function Ao(n, e = 0) {
  return n[n.length - (1 + e)];
}
function ri(n, e, t = ((i, s) => i === s)) {
  if (n === e) return !0;
  if (!n || !e || n.length !== e.length) return !1;
  for (let i = 0, s = n.length; i < s; i++) if (!t(n[i], e[i])) return !1;
  return !0;
}
function H0(n, e, t) {
  return (function(i, s) {
    let o = 0, r = i - 1;
    for (; o <= r; ) {
      const a = (o + r) / 2 | 0, l = s(a);
      if (l < 0) o = a + 1;
      else {
        if (!(l > 0)) return a;
        r = a - 1;
      }
    }
    return -(o + 1);
  })(n.length, ((i) => t(n[i], e)));
}
function CN(n, e, t) {
  if ((n |= 0) >= e.length) throw new TypeError("invalid index");
  const i = e[Math.floor(e.length * Math.random())], s = [], o = [], r = [];
  for (const a of e) {
    const l = t(a, i);
    l < 0 ? s.push(a) : l > 0 ? o.push(a) : r.push(a);
  }
  return n < s.length ? CN(n, s, t) : n < s.length + r.length ? r[0] : CN(n - (s.length + r.length), o, t);
}
function $P(n, e) {
  const t = [];
  let i;
  for (const s of n.slice(0).sort(e)) i && e(i[0], s) === 0 ? i.push(s) : (i = [s], t.push(i));
  return t;
}
function* HT(n, e) {
  let t, i;
  for (const s of n) i !== void 0 && e(i, s) ? t.push(s) : (t && (yield t), t = [s]), i = s;
  t && (yield t);
}
function g7(n, e) {
  for (let t = 0; t <= n.length; t++) e(t === 0 ? void 0 : n[t - 1], t === n.length ? void 0 : n[t]);
}
function ha(n) {
  return n.filter(((e) => !!e));
}
function GP(n) {
  let e = 0;
  for (let t = 0; t < n.length; t++) n[t] && (n[e] = n[t], e += 1);
  n.length = e;
}
function p7(n) {
  return !Array.isArray(n) || n.length === 0;
}
function zn(n) {
  return Array.isArray(n) && n.length > 0;
}
function Ad(n, e = ((t) => t)) {
  const t = /* @__PURE__ */ new Set();
  return n.filter(((i) => {
    const s = e(i);
    return !t.has(s) && (t.add(s), !0);
  }));
}
function zT(n, e) {
  return n.length > 0 ? n[0] : e;
}
function Ds(n, e) {
  let t = typeof e == "number" ? n : 0;
  typeof e == "number" ? t = n : (t = 0, e = n);
  const i = [];
  if (t <= e) for (let s = t; s < e; s++) i.push(s);
  else for (let s = t; s > e; s--) i.push(s);
  return i;
}
function TS(n, e, t) {
  const i = n.slice(0, e), s = n.slice(e);
  return i.concat(t, s);
}
function xk(n, e) {
  const t = n.indexOf(e);
  t > -1 && (n.splice(t, 1), n.unshift(e));
}
function j1(n, e) {
  const t = n.indexOf(e);
  t > -1 && (n.splice(t, 1), n.push(e));
}
function wN(n, e) {
  for (const t of e) n.push(t);
}
function UT(n) {
  return Array.isArray(n) ? n : [n];
}
function ZP(n, e, t, i) {
  const s = YP(n, e);
  let o = n.splice(s, t);
  return o === void 0 && (o = []), (function(r, a, l) {
    const d = YP(r, a), h = r.length, c = l.length;
    r.length = h + c;
    for (let u = h - 1; u >= d; u--) r[u + c] = r[u];
    for (let u = 0; u < c; u++) r[u + d] = l[u];
  })(n, s, i), o;
}
function YP(n, e) {
  return e < 0 ? Math.max(e + n.length, 0) : Math.min(e, n.length);
}
var z0;
function jo(n, e) {
  return (t, i) => e(n(t), n(i));
}
(function(n) {
  n.isLessThan = function(e) {
    return e < 0;
  }, n.isLessThanOrEqual = function(e) {
    return e <= 0;
  }, n.isGreaterThan = function(e) {
    return e > 0;
  }, n.isNeitherLessOrGreaterThan = function(e) {
    return e === 0;
  }, n.greaterThan = 1, n.lessThan = -1, n.neitherLessOrGreaterThan = 0;
})(z0 || (z0 = {}));
const od = (n, e) => n - e, VU = (n, e) => od(n ? 1 : 0, e ? 1 : 0);
function m7(n) {
  return (e, t) => -n(e, t);
}
class Pd {
  constructor(e) {
    this.items = e, this.firstIdx = 0, this.lastIdx = this.items.length - 1;
  }
  get length() {
    return this.lastIdx - this.firstIdx + 1;
  }
  takeWhile(e) {
    let t = this.firstIdx;
    for (; t < this.items.length && e(this.items[t]); ) t++;
    const i = t === this.firstIdx ? null : this.items.slice(this.firstIdx, t);
    return this.firstIdx = t, i;
  }
  takeFromEndWhile(e) {
    let t = this.lastIdx;
    for (; t >= 0 && e(this.items[t]); ) t--;
    const i = t === this.lastIdx ? null : this.items.slice(t + 1, this.lastIdx + 1);
    return this.lastIdx = t, i;
  }
  peek() {
    if (this.length !== 0) return this.items[this.firstIdx];
  }
  dequeue() {
    const e = this.items[this.firstIdx];
    return this.firstIdx++, e;
  }
  takeCount(e) {
    const t = this.items.slice(this.firstIdx, this.firstIdx + e);
    return this.firstIdx += e, t;
  }
}
class dl {
  constructor(e) {
    this.iterate = e;
  }
  toArray() {
    const e = [];
    return this.iterate(((t) => (e.push(t), !0))), e;
  }
  filter(e) {
    return new dl(((t) => this.iterate(((i) => !e(i) || t(i)))));
  }
  map(e) {
    return new dl(((t) => this.iterate(((i) => t(e(i))))));
  }
  findLast(e) {
    let t;
    return this.iterate(((i) => (e(i) && (t = i), !0))), t;
  }
  findLastMaxBy(e) {
    let t, i = !0;
    return this.iterate(((s) => ((i || z0.isGreaterThan(e(s, t))) && (i = !1, t = s), !0))), t;
  }
}
dl.empty = new dl(((n) => {
}));
class kw {
  constructor(e) {
    this._indexMap = e;
  }
  static createSortPermutation(e, t) {
    const i = Array.from(e.keys()).sort(((s, o) => t(e[s], e[o])));
    return new kw(i);
  }
  apply(e) {
    return e.map(((t, i) => e[this._indexMap[i]]));
  }
  inverse() {
    const e = this._indexMap.slice();
    for (let t = 0; t < this._indexMap.length; t++) e[this._indexMap[t]] = t;
    return new kw(e);
  }
}
function ps(n) {
  return typeof n == "string";
}
function ms(n) {
  return !(typeof n != "object" || n === null || Array.isArray(n) || n instanceof RegExp || n instanceof Date);
}
function HU(n) {
  const e = Object.getPrototypeOf(Uint8Array);
  return typeof n == "object" && n instanceof e;
}
function uc(n) {
  return typeof n == "number" && !isNaN(n);
}
function XP(n) {
  return !!n && typeof n[Symbol.iterator] == "function";
}
function f7(n) {
  return n === !0 || n === !1;
}
function $s(n) {
  return n === void 0;
}
function hl(n) {
  return !mo(n);
}
function mo(n) {
  return $s(n) || n === null;
}
function vt(n, e) {
  if (!n) throw new Error(e ? `Unexpected type, expected '${e}'` : "Unexpected type");
}
function Dh(n) {
  if (mo(n)) throw new Error("Assertion Failed: argument is undefined or null");
  return n;
}
function U0(n) {
  return typeof n == "function";
}
function zU(n, e) {
  if (ps(e)) {
    if (typeof n !== e) throw new Error(`argument does not match constraint: typeof ${e}`);
  } else if (U0(e)) {
    try {
      if (n instanceof e) return;
    } catch {
    }
    if (!mo(n) && n.constructor === e || e.length === 1 && e.call(void 0, n) === !0) return;
    throw new Error("argument does not match one of these constraints: arg instanceof constraint, arg.constructor === constraint, nor constraint(arg) === true");
  }
}
function Ul(n) {
  if (!n || typeof n != "object" || n instanceof RegExp) return n;
  const e = Array.isArray(n) ? [] : {};
  return Object.entries(n).forEach((([t, i]) => {
    e[t] = i && typeof i == "object" ? Ul(i) : i;
  })), e;
}
const _7 = Object.prototype.hasOwnProperty;
function v7(n, e) {
  return yN(n, e, /* @__PURE__ */ new Set());
}
function yN(n, e, t) {
  if (mo(n)) return n;
  const i = e(n);
  if (i !== void 0) return i;
  if (Array.isArray(n)) {
    const s = [];
    for (const o of n) s.push(yN(o, e, t));
    return s;
  }
  if (ms(n)) {
    if (t.has(n)) throw new Error("Cannot clone recursive data-structure");
    t.add(n);
    const s = {};
    for (const o in n) _7.call(n, o) && (s[o] = yN(n[o], e, t));
    return t.delete(n), s;
  }
  return n;
}
function RS(n, e, t = !0) {
  return ms(n) ? (ms(e) && Object.keys(e).forEach(((i) => {
    i in n ? t && (ms(n[i]) && ms(e[i]) ? RS(n[i], e[i], t) : n[i] = e[i]) : n[i] = e[i];
  })), n) : e;
}
function So(n, e) {
  if (n === e) return !0;
  if (n == null || e == null || typeof n != typeof e || typeof n != "object" || Array.isArray(n) !== Array.isArray(e)) return !1;
  let t, i;
  if (Array.isArray(n)) {
    if (n.length !== e.length) return !1;
    for (t = 0; t < n.length; t++) if (!So(n[t], e[t])) return !1;
  } else {
    const s = [];
    for (i in n) s.push(i);
    s.sort();
    const o = [];
    for (i in e) o.push(i);
    if (o.sort(), !So(s, o)) return !1;
    for (t = 0; t < s.length; t++) if (!So(n[s[t]], e[s[t]])) return !1;
  }
  return !0;
}
function KT(n) {
  const e = [];
  for (const t of (function(i) {
    let s = [];
    for (; Object.prototype !== i; ) s = s.concat(Object.getOwnPropertyNames(i)), i = Object.getPrototypeOf(i);
    return s;
  })(n)) typeof n[t] == "function" && e.push(t);
  return e;
}
let UU = typeof document < "u" && document.location && document.location.hash.indexOf("pseudo=true") >= 0;
function b7(n, e) {
  let t;
  return t = e.length === 0 ? n : n.replace(/\{(\d+)\}/g, ((i, s) => {
    const o = s[0], r = e[o];
    let a = i;
    return typeof r == "string" ? a = r : typeof r != "number" && typeof r != "boolean" && r != null || (a = String(r)), a;
  })), UU && (t = "［" + t.replace(/[aouei]/g, "$&$&") + "］"), t;
}
function m(n, e, ...t) {
  return b7(e, t);
}
function ct(n, e, ...t) {
  const i = b7(e, t);
  return { value: i, original: i };
}
var Nk, Ek;
const wp = "en";
let q1, KU, Ea, Dw = !1, xw = !1, LC = !1, C7 = !1, jT = !1, qT = !1, w7 = !1, kC = wp, QP = wp;
const Sd = globalThis;
let js;
Sd.vscode !== void 0 && Sd.vscode.process !== void 0 ? js = Sd.vscode.process : typeof process < "u" && typeof ((Nk = process == null ? void 0 : process.versions) === null || Nk === void 0 ? void 0 : Nk.node) == "string" && (js = process);
const jU = typeof ((Ek = js?.versions) === null || Ek === void 0 ? void 0 : Ek.electron) == "string" && js?.type === "renderer";
if (typeof js == "object") {
  Dw = js.platform === "win32", xw = js.platform === "darwin", LC = js.platform === "linux", LC && js.env.SNAP && js.env.SNAP_REVISION, js.env.CI || js.env.BUILD_ARTIFACTSTAGINGDIRECTORY, q1 = wp, kC = wp;
  const n = js.env.VSCODE_NLS_CONFIG;
  if (n) try {
    const e = JSON.parse(n), t = e.availableLanguages["*"];
    q1 = e.locale, QP = e.osLocale, kC = t || wp, KU = e._translationsConfigFile;
  } catch {
  }
  C7 = !0;
} else typeof navigator != "object" || jU ? console.error("Unable to resolve platform.") : (Ea = navigator.userAgent, Dw = Ea.indexOf("Windows") >= 0, xw = Ea.indexOf("Macintosh") >= 0, qT = (Ea.indexOf("Macintosh") >= 0 || Ea.indexOf("iPad") >= 0 || Ea.indexOf("iPhone") >= 0) && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 0, LC = Ea.indexOf("Linux") >= 0, w7 = Ea?.indexOf("Mobi") >= 0, jT = !0, m(0, "_"), q1 = wp, kC = q1, QP = navigator.language);
const Tn = Dw, Je = xw, Cs = LC, ml = C7, gc = jT, qU = jT && typeof Sd.importScripts == "function" ? Sd.origin : void 0, ca = qT, y7 = w7, fl = Ea, $U = kC, GU = typeof Sd.postMessage == "function" && !Sd.importScripts, S7 = (() => {
  if (GU) {
    const n = [];
    Sd.addEventListener("message", ((t) => {
      if (t.data && t.data.vscodeScheduleAsyncWork) for (let i = 0, s = n.length; i < s; i++) {
        const o = n[i];
        if (o.id === t.data.vscodeScheduleAsyncWork) return n.splice(i, 1), void o.callback();
      }
    }));
    let e = 0;
    return (t) => {
      const i = ++e;
      n.push({ id: i, callback: t }), Sd.postMessage({ vscodeScheduleAsyncWork: i }, "*");
    };
  }
  return (n) => setTimeout(n);
})(), Gs = xw || qT ? 2 : Dw ? 1 : 3;
let JP = !0, eO = !1;
function L7() {
  if (!eO) {
    eO = !0;
    const n = new Uint8Array(2);
    n[0] = 1, n[1] = 2, JP = new Uint16Array(n.buffer)[0] === 513;
  }
  return JP;
}
const k7 = !!(fl && fl.indexOf("Chrome") >= 0), ZU = !!(fl && fl.indexOf("Firefox") >= 0), YU = !!(!k7 && fl && fl.indexOf("Safari") >= 0), XU = !!(fl && fl.indexOf("Edg/") >= 0), QU = !!(fl && fl.indexOf("Android") >= 0), Wn = { tabSize: 4, indentSize: 4, insertSpaces: !0, detectIndentation: !0, trimAutoWhitespace: !0, largeFileOptimizations: !0, bracketPairColorizationOptions: { enabled: !0, independentColorPoolPerBracketType: !1 } };
var at;
(function(n) {
  function e(s) {
    return s && typeof s == "object" && typeof s[Symbol.iterator] == "function";
  }
  n.is = e;
  const t = Object.freeze([]);
  function* i(s) {
    yield s;
  }
  n.empty = function() {
    return t;
  }, n.single = i, n.wrap = function(s) {
    return e(s) ? s : i(s);
  }, n.from = function(s) {
    return s || t;
  }, n.reverse = function* (s) {
    for (let o = s.length - 1; o >= 0; o--) yield s[o];
  }, n.isEmpty = function(s) {
    return !s || s[Symbol.iterator]().next().done === !0;
  }, n.first = function(s) {
    return s[Symbol.iterator]().next().value;
  }, n.some = function(s, o) {
    for (const r of s) if (o(r)) return !0;
    return !1;
  }, n.find = function(s, o) {
    for (const r of s) if (o(r)) return r;
  }, n.filter = function* (s, o) {
    for (const r of s) o(r) && (yield r);
  }, n.map = function* (s, o) {
    let r = 0;
    for (const a of s) yield o(a, r++);
  }, n.concat = function* (...s) {
    for (const o of s) yield* o;
  }, n.reduce = function(s, o, r) {
    let a = r;
    for (const l of s) a = o(a, l);
    return a;
  }, n.slice = function* (s, o, r = s.length) {
    for (o < 0 && (o += s.length), r < 0 ? r += s.length : r > s.length && (r = s.length); o < r; o++) yield s[o];
  }, n.consume = function(s, o = Number.POSITIVE_INFINITY) {
    const r = [];
    if (o === 0) return [r, s];
    const a = s[Symbol.iterator]();
    for (let l = 0; l < o; l++) {
      const d = a.next();
      if (d.done) return [r, n.empty()];
      r.push(d.value);
    }
    return [r, { [Symbol.iterator]: () => a }];
  }, n.asyncToArray = async function(s) {
    const o = [];
    for await (const r of s) o.push(r);
    return Promise.resolve(o);
  };
})(at || (at = {}));
let Wi = class SN {
  constructor(e) {
    this.element = e, this.next = SN.Undefined, this.prev = SN.Undefined;
  }
};
Wi.Undefined = new Wi(void 0);
class fs {
  constructor() {
    this._first = Wi.Undefined, this._last = Wi.Undefined, this._size = 0;
  }
  get size() {
    return this._size;
  }
  isEmpty() {
    return this._first === Wi.Undefined;
  }
  clear() {
    let e = this._first;
    for (; e !== Wi.Undefined; ) {
      const t = e.next;
      e.prev = Wi.Undefined, e.next = Wi.Undefined, e = t;
    }
    this._first = Wi.Undefined, this._last = Wi.Undefined, this._size = 0;
  }
  unshift(e) {
    return this._insert(e, !1);
  }
  push(e) {
    return this._insert(e, !0);
  }
  _insert(e, t) {
    const i = new Wi(e);
    if (this._first === Wi.Undefined) this._first = i, this._last = i;
    else if (t) {
      const o = this._last;
      this._last = i, i.prev = o, o.next = i;
    } else {
      const o = this._first;
      this._first = i, i.next = o, o.prev = i;
    }
    this._size += 1;
    let s = !1;
    return () => {
      s || (s = !0, this._remove(i));
    };
  }
  shift() {
    if (this._first !== Wi.Undefined) {
      const e = this._first.element;
      return this._remove(this._first), e;
    }
  }
  pop() {
    if (this._last !== Wi.Undefined) {
      const e = this._last.element;
      return this._remove(this._last), e;
    }
  }
  _remove(e) {
    if (e.prev !== Wi.Undefined && e.next !== Wi.Undefined) {
      const t = e.prev;
      t.next = e.next, e.next.prev = t;
    } else e.prev === Wi.Undefined && e.next === Wi.Undefined ? (this._first = Wi.Undefined, this._last = Wi.Undefined) : e.next === Wi.Undefined ? (this._last = this._last.prev, this._last.next = Wi.Undefined) : e.prev === Wi.Undefined && (this._first = this._first.next, this._first.prev = Wi.Undefined);
    this._size -= 1;
  }
  *[Symbol.iterator]() {
    let e = this._first;
    for (; e !== Wi.Undefined; ) yield e.element, e = e.next;
  }
}
const D7 = "`~!@#$%^&*()-=+[{]}\\|;:'\",.<>/?", $T = (function(n = "") {
  let e = "(-?\\d*\\.\\d\\w*)|([^";
  for (const t of D7) n.indexOf(t) >= 0 || (e += "\\" + t);
  return e += "\\s]+)", new RegExp(e, "g");
})();
function GT(n) {
  let e = $T;
  if (n && n instanceof RegExp) if (n.global) e = n;
  else {
    let t = "g";
    n.ignoreCase && (t += "i"), n.multiline && (t += "m"), n.unicode && (t += "u"), e = new RegExp(n.source, t);
  }
  return e.lastIndex = 0, e;
}
const x7 = new fs();
function K0(n, e, t, i, s) {
  if (e = GT(e), s || (s = at.first(x7)), t.length > s.maxLen) {
    let d = n - s.maxLen / 2;
    return d < 0 ? d = 0 : i += d, K0(n, e, t = t.substring(d, n + s.maxLen / 2), i, s);
  }
  const o = Date.now(), r = n - 1 - i;
  let a = -1, l = null;
  for (let d = 1; !(Date.now() - o >= s.timeBudget); d++) {
    const h = r - s.windowSize * d;
    e.lastIndex = Math.max(0, h);
    const c = JU(e, t, r, a);
    if (!c && l || (l = c, h <= 0)) break;
    a = h;
  }
  if (l) {
    const d = { word: l[0], startColumn: i + 1 + l.index, endColumn: i + 1 + l.index + l[0].length };
    return e.lastIndex = 0, d;
  }
  return null;
}
function JU(n, e, t, i) {
  let s;
  for (; s = n.exec(e); ) {
    const o = s.index || 0;
    if (o <= t && n.lastIndex >= t) return s;
    if (i > 0 && o > i) return null;
  }
  return null;
}
x7.unshift({ maxLen: 1e3, windowSize: 15, timeBudget: 150 });
class N7 {
  constructor(e) {
    this._values = e;
  }
  hasChanged(e) {
    return this._values[e];
  }
}
class E7 {
  constructor() {
    this.stableMinimapLayoutInput = null, this.stableFitMaxMinimapScale = 0, this.stableFitRemainingWidth = 0;
  }
}
class Qt {
  constructor(e, t, i, s) {
    this.id = e, this.name = t, this.defaultValue = i, this.schema = s;
  }
  applyUpdate(e, t) {
    return AS(e, t);
  }
  compute(e, t, i) {
    return i;
  }
}
class q_ {
  constructor(e, t) {
    this.newValue = e, this.didChange = t;
  }
}
function AS(n, e) {
  if (typeof n != "object" || typeof e != "object" || !n || !e) return new q_(e, n !== e);
  if (Array.isArray(n) || Array.isArray(e)) {
    const i = Array.isArray(n) && Array.isArray(e) && ri(n, e);
    return new q_(e, !i);
  }
  let t = !1;
  for (const i in e) if (e.hasOwnProperty(i)) {
    const s = AS(n[i], e[i]);
    s.didChange && (n[i] = s.newValue, t = !0);
  }
  return new q_(n, t);
}
class d_ {
  constructor(e) {
    this.schema = void 0, this.id = e, this.name = "_never_", this.defaultValue = void 0;
  }
  applyUpdate(e, t) {
    return AS(e, t);
  }
  validate(e) {
    return this.defaultValue;
  }
}
class df {
  constructor(e, t, i, s) {
    this.id = e, this.name = t, this.defaultValue = i, this.schema = s;
  }
  applyUpdate(e, t) {
    return AS(e, t);
  }
  validate(e) {
    return e === void 0 ? this.defaultValue : e;
  }
  compute(e, t, i) {
    return i;
  }
}
function ve(n, e) {
  return n === void 0 ? e : n !== "false" && !!n;
}
class gt extends df {
  constructor(e, t, i, s = void 0) {
    s !== void 0 && (s.type = "boolean", s.default = i), super(e, t, i, s);
  }
  validate(e) {
    return ve(e, this.defaultValue);
  }
}
function iu(n, e, t, i) {
  if (n === void 0) return e;
  let s = parseInt(n, 10);
  return isNaN(s) ? e : (s = Math.max(t, s), s = Math.min(i, s), 0 | s);
}
class Ot extends df {
  static clampedInt(e, t, i, s) {
    return iu(e, t, i, s);
  }
  constructor(e, t, i, s, o, r = void 0) {
    r !== void 0 && (r.type = "integer", r.default = i, r.minimum = s, r.maximum = o), super(e, t, i, r), this.minimum = s, this.maximum = o;
  }
  validate(e) {
    return Ot.clampedInt(e, this.defaultValue, this.minimum, this.maximum);
  }
}
function eK(n, e, t, i) {
  if (n === void 0) return e;
  const s = Fo.float(n, e);
  return Fo.clamp(s, t, i);
}
class Fo extends df {
  static clamp(e, t, i) {
    return e < t ? t : e > i ? i : e;
  }
  static float(e, t) {
    if (typeof e == "number") return e;
    if (e === void 0) return t;
    const i = parseFloat(e);
    return isNaN(i) ? t : i;
  }
  constructor(e, t, i, s, o) {
    o !== void 0 && (o.type = "number", o.default = i), super(e, t, i, o), this.validationFn = s;
  }
  validate(e) {
    return this.validationFn(Fo.float(e, this.defaultValue));
  }
}
class ss extends df {
  static string(e, t) {
    return typeof e != "string" ? t : e;
  }
  constructor(e, t, i, s = void 0) {
    s !== void 0 && (s.type = "string", s.default = i), super(e, t, i, s);
  }
  validate(e) {
    return ss.string(e, this.defaultValue);
  }
}
function _i(n, e, t, i) {
  return typeof n != "string" ? e : i && n in i ? i[n] : t.indexOf(n) === -1 ? e : n;
}
class hi extends df {
  constructor(e, t, i, s, o = void 0) {
    o !== void 0 && (o.type = "string", o.enum = s, o.default = i), super(e, t, i, o), this._allowedValues = s;
  }
  validate(e) {
    return _i(e, this.defaultValue, this._allowedValues);
  }
}
class $1 extends Qt {
  constructor(e, t, i, s, o, r, a = void 0) {
    a !== void 0 && (a.type = "string", a.enum = o, a.default = s), super(e, t, i, a), this._allowedValues = o, this._convert = r;
  }
  validate(e) {
    return typeof e != "string" || this._allowedValues.indexOf(e) === -1 ? this.defaultValue : this._convert(e);
  }
}
var vn, mr;
(function(n) {
  n[n.Line = 1] = "Line", n[n.Block = 2] = "Block", n[n.Underline = 3] = "Underline", n[n.LineThin = 4] = "LineThin", n[n.BlockOutline = 5] = "BlockOutline", n[n.UnderlineThin = 6] = "UnderlineThin";
})(vn || (vn = {}));
class fo extends Qt {
  constructor() {
    super(51, "fontLigatures", fo.OFF, { anyOf: [{ type: "boolean", description: m(0, "Enables/Disables font ligatures ('calt' and 'liga' font features). Change this to a string for fine-grained control of the 'font-feature-settings' CSS property.") }, { type: "string", description: m(0, "Explicit 'font-feature-settings' CSS property. A boolean can be passed instead if one only needs to turn on/off ligatures.") }], description: m(0, "Configures font ligatures or font features. Can be either a boolean to enable/disable ligatures or a string for the value of the CSS 'font-feature-settings' property."), default: !1 });
  }
  validate(e) {
    return e === void 0 ? this.defaultValue : typeof e == "string" ? e === "false" || e.length === 0 ? fo.OFF : e === "true" ? fo.ON : e : e ? fo.ON : fo.OFF;
  }
}
fo.OFF = '"liga" off, "calt" off', fo.ON = '"liga" on, "calt" on';
class Xr extends Qt {
  constructor() {
    super(54, "fontVariations", Xr.OFF, { anyOf: [{ type: "boolean", description: m(0, "Enables/Disables the translation from font-weight to font-variation-settings. Change this to a string for fine-grained control of the 'font-variation-settings' CSS property.") }, { type: "string", description: m(0, "Explicit 'font-variation-settings' CSS property. A boolean can be passed instead if one only needs to translate font-weight to font-variation-settings.") }], description: m(0, "Configures font variations. Can be either a boolean to enable/disable the translation from font-weight to font-variation-settings or a string for the value of the CSS 'font-variation-settings' property."), default: !1 });
  }
  validate(e) {
    return e === void 0 ? this.defaultValue : typeof e == "string" ? e === "false" ? Xr.OFF : e === "true" ? Xr.TRANSLATE : e : e ? Xr.TRANSLATE : Xr.OFF;
  }
  compute(e, t, i) {
    return e.fontInfo.fontVariationSettings;
  }
}
Xr.OFF = "normal", Xr.TRANSLATE = "translate";
class Ka extends Qt {
  constructor() {
    super(53, "fontWeight", Is.fontWeight, { anyOf: [{ type: "number", minimum: Ka.MINIMUM_VALUE, maximum: Ka.MAXIMUM_VALUE, errorMessage: m(0, 'Only "normal" and "bold" keywords or numbers between 1 and 1000 are allowed.') }, { type: "string", pattern: "^(normal|bold|1000|[1-9][0-9]{0,2})$" }, { enum: Ka.SUGGESTION_VALUES }], default: Is.fontWeight, description: m(0, 'Controls the font weight. Accepts "normal" and "bold" keywords or numbers between 1 and 1000.') });
  }
  validate(e) {
    return e === "normal" || e === "bold" ? e : String(Ot.clampedInt(e, Is.fontWeight, Ka.MINIMUM_VALUE, Ka.MAXIMUM_VALUE));
  }
}
Ka.SUGGESTION_VALUES = ["normal", "bold", "100", "200", "300", "400", "500", "600", "700", "800", "900"], Ka.MINIMUM_VALUE = 1, Ka.MAXIMUM_VALUE = 1e3;
class Zp extends d_ {
  constructor() {
    super(145);
  }
  compute(e, t, i) {
    return Zp.computeLayout(t, { memory: e.memory, outerWidth: e.outerWidth, outerHeight: e.outerHeight, isDominatedByLongLines: e.isDominatedByLongLines, lineHeight: e.fontInfo.lineHeight, viewLineCount: e.viewLineCount, lineNumbersDigitCount: e.lineNumbersDigitCount, typicalHalfwidthCharacterWidth: e.fontInfo.typicalHalfwidthCharacterWidth, maxDigitWidth: e.fontInfo.maxDigitWidth, pixelRatio: e.pixelRatio, glyphMarginDecorationLaneCount: e.glyphMarginDecorationLaneCount });
  }
  static computeContainedMinimapLineCount(e) {
    const t = e.height / e.lineHeight, i = Math.floor(e.paddingTop / e.lineHeight);
    let s = Math.floor(e.paddingBottom / e.lineHeight);
    e.scrollBeyondLastLine && (s = Math.max(s, t - 1));
    const o = (i + e.viewLineCount + s) / (e.pixelRatio * e.height);
    return { typicalViewportLineCount: t, extraLinesBeforeFirstLine: i, extraLinesBeyondLastLine: s, desiredRatio: o, minimapLineCount: Math.floor(e.viewLineCount / o) };
  }
  static _computeMinimapLayout(e, t) {
    const i = e.outerWidth, s = e.outerHeight, o = e.pixelRatio;
    if (!e.minimap.enabled) return { renderMinimap: 0, minimapLeft: 0, minimapWidth: 0, minimapHeightIsEditorHeight: !1, minimapIsSampling: !1, minimapScale: 1, minimapLineHeight: 1, minimapCanvasInnerWidth: 0, minimapCanvasInnerHeight: Math.floor(o * s), minimapCanvasOuterWidth: 0, minimapCanvasOuterHeight: s };
    const r = t.stableMinimapLayoutInput, a = r && e.outerHeight === r.outerHeight && e.lineHeight === r.lineHeight && e.typicalHalfwidthCharacterWidth === r.typicalHalfwidthCharacterWidth && e.pixelRatio === r.pixelRatio && e.scrollBeyondLastLine === r.scrollBeyondLastLine && e.paddingTop === r.paddingTop && e.paddingBottom === r.paddingBottom && e.minimap.enabled === r.minimap.enabled && e.minimap.side === r.minimap.side && e.minimap.size === r.minimap.size && e.minimap.showSlider === r.minimap.showSlider && e.minimap.renderCharacters === r.minimap.renderCharacters && e.minimap.maxColumn === r.minimap.maxColumn && e.minimap.scale === r.minimap.scale && e.verticalScrollbarWidth === r.verticalScrollbarWidth && e.isViewportWrapping === r.isViewportWrapping, l = e.lineHeight, d = e.typicalHalfwidthCharacterWidth, h = e.scrollBeyondLastLine, c = e.minimap.renderCharacters;
    let u = o >= 2 ? Math.round(2 * e.minimap.scale) : e.minimap.scale;
    const g = e.minimap.maxColumn, p = e.minimap.size, f = e.minimap.side, _ = e.verticalScrollbarWidth, v = e.viewLineCount, b = e.remainingWidth, C = e.isViewportWrapping, w = c ? 2 : 3;
    let y = Math.floor(o * s);
    const L = y / o;
    let k = !1, N = !1, A = w * u, B = u / o, T = 1;
    if (p === "fill" || p === "fit") {
      const { typicalViewportLineCount: me, extraLinesBeforeFirstLine: ue, extraLinesBeyondLastLine: ee, desiredRatio: te, minimapLineCount: be } = Zp.computeContainedMinimapLineCount({ viewLineCount: v, scrollBeyondLastLine: h, paddingTop: e.paddingTop, paddingBottom: e.paddingBottom, height: s, lineHeight: l, pixelRatio: o });
      if (v / be > 1) k = !0, N = !0, u = 1, A = 1, B = u / o;
      else {
        let we = !1, Re = u + 1;
        if (p === "fit") {
          const it = Math.ceil((ue + v + ee) * A);
          C && a && b <= t.stableFitRemainingWidth ? (we = !0, Re = t.stableFitMaxMinimapScale) : we = it > y;
        }
        if (p === "fill" || we) {
          k = !0;
          const it = u;
          A = Math.min(l * o, Math.max(1, Math.floor(1 / te))), C && a && b <= t.stableFitRemainingWidth && (Re = t.stableFitMaxMinimapScale), u = Math.min(Re, Math.max(1, Math.floor(A / w))), u > it && (T = Math.min(2, u / it)), B = u / o / T, y = Math.ceil(Math.max(me, ue + v + ee) * A), C ? (t.stableMinimapLayoutInput = e, t.stableFitRemainingWidth = b, t.stableFitMaxMinimapScale = u) : (t.stableMinimapLayoutInput = null, t.stableFitRemainingWidth = 0);
        }
      }
    }
    const O = Math.floor(g * B), H = Math.min(O, Math.max(0, Math.floor((b - _ - 2) * B / (d + B))) + 8);
    let $ = Math.floor(o * H);
    const pe = $ / o;
    return $ = Math.floor($ * T), { renderMinimap: c ? 1 : 2, minimapLeft: f === "left" ? 0 : i - H - _, minimapWidth: H, minimapHeightIsEditorHeight: k, minimapIsSampling: N, minimapScale: u, minimapLineHeight: A, minimapCanvasInnerWidth: $, minimapCanvasInnerHeight: y, minimapCanvasOuterWidth: pe, minimapCanvasOuterHeight: L };
  }
  static computeLayout(e, t) {
    const i = 0 | t.outerWidth, s = 0 | t.outerHeight, o = 0 | t.lineHeight, r = 0 | t.lineNumbersDigitCount, a = t.typicalHalfwidthCharacterWidth, l = t.maxDigitWidth, d = t.pixelRatio, h = t.viewLineCount, c = e.get(137), u = c === "inherit" ? e.get(136) : c, g = u === "inherit" ? e.get(132) : u, p = e.get(135), f = t.isDominatedByLongLines, _ = e.get(57), v = e.get(68).renderType !== 0, b = e.get(69), C = e.get(105), w = e.get(84), y = e.get(73), L = e.get(103), k = L.verticalScrollbarSize, N = L.verticalHasArrows, A = L.arrowSize, B = L.horizontalScrollbarSize, T = e.get(43), O = e.get(110) !== "never";
    let H = e.get(66);
    T && O && (H += 16);
    let $ = 0;
    if (v) {
      const an = Math.max(r, b);
      $ = Math.round(an * l);
    }
    let pe = 0;
    _ && (pe = o * t.glyphMarginDecorationLaneCount);
    let me = 0, ue = me + pe, ee = ue + $, te = ee + H;
    const be = i - pe - $ - H;
    let we = !1, Re = !1, it = -1;
    u === "inherit" && f ? (we = !0, Re = !0) : g === "on" || g === "bounded" ? Re = !0 : g === "wordWrapColumn" && (it = p);
    const ut = Zp._computeMinimapLayout({ outerWidth: i, outerHeight: s, lineHeight: o, typicalHalfwidthCharacterWidth: a, pixelRatio: d, scrollBeyondLastLine: C, paddingTop: w.top, paddingBottom: w.bottom, minimap: y, verticalScrollbarWidth: k, viewLineCount: h, remainingWidth: be, isViewportWrapping: Re }, t.memory || new E7());
    ut.renderMinimap !== 0 && ut.minimapLeft === 0 && (me += ut.minimapWidth, ue += ut.minimapWidth, ee += ut.minimapWidth, te += ut.minimapWidth);
    const Xi = be - ut.minimapWidth, nt = Math.max(1, Math.floor((Xi - k - 2) / a)), De = N ? A : 0;
    return Re && (it = Math.max(1, nt), g === "bounded" && (it = Math.min(it, p))), { width: i, height: s, glyphMarginLeft: me, glyphMarginWidth: pe, glyphMarginDecorationLaneCount: t.glyphMarginDecorationLaneCount, lineNumbersLeft: ue, lineNumbersWidth: $, decorationsLeft: ee, decorationsWidth: H, contentLeft: te, contentWidth: Xi, minimap: ut, viewportColumn: nt, isWordWrapMinified: we, isViewportWrapping: Re, wrappingColumn: it, verticalScrollbarWidth: k, horizontalScrollbarHeight: B, overviewRuler: { top: De, width: k, height: s - 2 * De, right: 0 } };
  }
}
(function(n) {
  n.Off = "off", n.OnCode = "onCode", n.On = "on";
})(mr || (mr = {}));
function Nw(n) {
  const e = n.get(98);
  return e === "editable" ? n.get(91) : e !== "on";
}
function tO(n, e) {
  if (typeof n != "string") return e;
  switch (n) {
    case "hidden":
      return 2;
    case "visible":
      return 3;
    default:
      return 1;
  }
}
const ro = "inUntrustedWorkspace", LN = "editor.unicodeHighlight.allowedCharacters", I7 = "editor.unicodeHighlight.invisibleCharacters", M7 = "editor.unicodeHighlight.nonBasicASCII", T7 = "editor.unicodeHighlight.ambiguousCharacters", R7 = "editor.unicodeHighlight.includeComments", A7 = "editor.unicodeHighlight.includeStrings", kN = "editor.unicodeHighlight.allowedLocales";
function Bg(n, e, t) {
  const i = t.indexOf(n);
  return i === -1 ? e : t[i];
}
const Is = { fontFamily: Je ? "Menlo, Monaco, 'Courier New', monospace" : Cs ? "'Droid Sans Mono', 'monospace', monospace" : "Consolas, 'Courier New', monospace", fontWeight: "normal", fontSize: Je ? 12 : 14, lineHeight: 0, letterSpacing: 0 }, yp = [];
function J(n) {
  return yp[n.id] = n, n;
}
const ta = { acceptSuggestionOnCommitCharacter: J(new gt(0, "acceptSuggestionOnCommitCharacter", !0, { markdownDescription: m(0, "Controls whether suggestions should be accepted on commit characters. For example, in JavaScript, the semi-colon (`;`) can be a commit character that accepts a suggestion and types that character.") })), acceptSuggestionOnEnter: J(new hi(1, "acceptSuggestionOnEnter", "on", ["on", "smart", "off"], { markdownEnumDescriptions: ["", m(0, "Only accept a suggestion with `Enter` when it makes a textual change."), ""], markdownDescription: m(0, "Controls whether suggestions should be accepted on `Enter`, in addition to `Tab`. Helps to avoid ambiguity between inserting new lines or accepting suggestions.") })), accessibilitySupport: J(new class extends Qt {
  constructor() {
    super(2, "accessibilitySupport", 0, { type: "string", enum: ["auto", "on", "off"], enumDescriptions: [m(0, "Use platform APIs to detect when a Screen Reader is attached."), m(0, "Optimize for usage with a Screen Reader."), m(0, "Assume a screen reader is not attached.")], default: "auto", tags: ["accessibility"], description: m(0, "Controls if the UI should run in a mode where it is optimized for screen readers.") });
  }
  validate(n) {
    switch (n) {
      case "auto":
        return 0;
      case "off":
        return 1;
      case "on":
        return 2;
    }
    return this.defaultValue;
  }
  compute(n, e, t) {
    return t === 0 ? n.accessibilitySupport : t;
  }
}()), accessibilityPageSize: J(new Ot(3, "accessibilityPageSize", 10, 1, 1073741824, { description: m(0, "Controls the number of lines in the editor that can be read out by a screen reader at once. When we detect a screen reader we automatically set the default to be 500. Warning: this has a performance implication for numbers larger than the default."), tags: ["accessibility"] })), ariaLabel: J(new ss(4, "ariaLabel", m(0, "Editor content"))), ariaRequired: J(new gt(5, "ariaRequired", !1, void 0)), screenReaderAnnounceInlineSuggestion: J(new gt(8, "screenReaderAnnounceInlineSuggestion", !0, { description: m(0, "Control whether inline suggestions are announced by a screen reader."), tags: ["accessibility"] })), autoClosingBrackets: J(new hi(6, "autoClosingBrackets", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], { enumDescriptions: ["", m(0, "Use language configurations to determine when to autoclose brackets."), m(0, "Autoclose brackets only when the cursor is to the left of whitespace."), ""], description: m(0, "Controls whether the editor should automatically close brackets after the user adds an opening bracket.") })), autoClosingComments: J(new hi(7, "autoClosingComments", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], { enumDescriptions: ["", m(0, "Use language configurations to determine when to autoclose comments."), m(0, "Autoclose comments only when the cursor is to the left of whitespace."), ""], description: m(0, "Controls whether the editor should automatically close comments after the user adds an opening comment.") })), autoClosingDelete: J(new hi(9, "autoClosingDelete", "auto", ["always", "auto", "never"], { enumDescriptions: ["", m(0, "Remove adjacent closing quotes or brackets only if they were automatically inserted."), ""], description: m(0, "Controls whether the editor should remove adjacent closing quotes or brackets when deleting.") })), autoClosingOvertype: J(new hi(10, "autoClosingOvertype", "auto", ["always", "auto", "never"], { enumDescriptions: ["", m(0, "Type over closing quotes or brackets only if they were automatically inserted."), ""], description: m(0, "Controls whether the editor should type over closing quotes or brackets.") })), autoClosingQuotes: J(new hi(11, "autoClosingQuotes", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], { enumDescriptions: ["", m(0, "Use language configurations to determine when to autoclose quotes."), m(0, "Autoclose quotes only when the cursor is to the left of whitespace."), ""], description: m(0, "Controls whether the editor should automatically close quotes after the user adds an opening quote.") })), autoIndent: J(new $1(12, "autoIndent", 4, "full", ["none", "keep", "brackets", "advanced", "full"], (function(n) {
  switch (n) {
    case "none":
      return 0;
    case "keep":
      return 1;
    case "brackets":
      return 2;
    case "advanced":
      return 3;
    case "full":
      return 4;
  }
}), { enumDescriptions: [m(0, "The editor will not insert indentation automatically."), m(0, "The editor will keep the current line's indentation."), m(0, "The editor will keep the current line's indentation and honor language defined brackets."), m(0, "The editor will keep the current line's indentation, honor language defined brackets and invoke special onEnterRules defined by languages."), m(0, "The editor will keep the current line's indentation, honor language defined brackets, invoke special onEnterRules defined by languages, and honor indentationRules defined by languages.")], description: m(0, "Controls whether the editor should automatically adjust the indentation when users type, paste, move or indent lines.") })), automaticLayout: J(new gt(13, "automaticLayout", !1)), autoSurround: J(new hi(14, "autoSurround", "languageDefined", ["languageDefined", "quotes", "brackets", "never"], { enumDescriptions: [m(0, "Use language configurations to determine when to automatically surround selections."), m(0, "Surround with quotes but not brackets."), m(0, "Surround with brackets but not quotes."), ""], description: m(0, "Controls whether the editor should automatically surround selections when typing quotes or brackets.") })), bracketPairColorization: J(new class extends Qt {
  constructor() {
    const n = { enabled: Wn.bracketPairColorizationOptions.enabled, independentColorPoolPerBracketType: Wn.bracketPairColorizationOptions.independentColorPoolPerBracketType };
    super(15, "bracketPairColorization", n, { "editor.bracketPairColorization.enabled": { type: "boolean", default: n.enabled, markdownDescription: m(0, "Controls whether bracket pair colorization is enabled or not. Use {0} to override the bracket highlight colors.", "`#workbench.colorCustomizations#`") }, "editor.bracketPairColorization.independentColorPoolPerBracketType": { type: "boolean", default: n.independentColorPoolPerBracketType, description: m(0, "Controls whether each bracket type has its own independent color pool.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), independentColorPoolPerBracketType: ve(e.independentColorPoolPerBracketType, this.defaultValue.independentColorPoolPerBracketType) };
  }
}()), bracketPairGuides: J(new class extends Qt {
  constructor() {
    const n = { bracketPairs: !1, bracketPairsHorizontal: "active", highlightActiveBracketPair: !0, indentation: !0, highlightActiveIndentation: !0 };
    super(16, "guides", n, { "editor.guides.bracketPairs": { type: ["boolean", "string"], enum: [!0, "active", !1], enumDescriptions: [m(0, "Enables bracket pair guides."), m(0, "Enables bracket pair guides only for the active bracket pair."), m(0, "Disables bracket pair guides.")], default: n.bracketPairs, description: m(0, "Controls whether bracket pair guides are enabled or not.") }, "editor.guides.bracketPairsHorizontal": { type: ["boolean", "string"], enum: [!0, "active", !1], enumDescriptions: [m(0, "Enables horizontal guides as addition to vertical bracket pair guides."), m(0, "Enables horizontal guides only for the active bracket pair."), m(0, "Disables horizontal bracket pair guides.")], default: n.bracketPairsHorizontal, description: m(0, "Controls whether horizontal bracket pair guides are enabled or not.") }, "editor.guides.highlightActiveBracketPair": { type: "boolean", default: n.highlightActiveBracketPair, description: m(0, "Controls whether the editor should highlight the active bracket pair.") }, "editor.guides.indentation": { type: "boolean", default: n.indentation, description: m(0, "Controls whether the editor should render indent guides.") }, "editor.guides.highlightActiveIndentation": { type: ["boolean", "string"], enum: [!0, "always", !1], enumDescriptions: [m(0, "Highlights the active indent guide."), m(0, "Highlights the active indent guide even if bracket guides are highlighted."), m(0, "Do not highlight the active indent guide.")], default: n.highlightActiveIndentation, description: m(0, "Controls whether the editor should highlight the active indent guide.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { bracketPairs: Bg(e.bracketPairs, this.defaultValue.bracketPairs, [!0, !1, "active"]), bracketPairsHorizontal: Bg(e.bracketPairsHorizontal, this.defaultValue.bracketPairsHorizontal, [!0, !1, "active"]), highlightActiveBracketPair: ve(e.highlightActiveBracketPair, this.defaultValue.highlightActiveBracketPair), indentation: ve(e.indentation, this.defaultValue.indentation), highlightActiveIndentation: Bg(e.highlightActiveIndentation, this.defaultValue.highlightActiveIndentation, [!0, !1, "always"]) };
  }
}()), stickyTabStops: J(new gt(116, "stickyTabStops", !1, { description: m(0, "Emulate selection behavior of tab characters when using spaces for indentation. Selection will stick to tab stops.") })), codeLens: J(new gt(17, "codeLens", !0, { description: m(0, "Controls whether the editor shows CodeLens.") })), codeLensFontFamily: J(new ss(18, "codeLensFontFamily", "", { description: m(0, "Controls the font family for CodeLens.") })), codeLensFontSize: J(new Ot(19, "codeLensFontSize", 0, 0, 100, { type: "number", default: 0, minimum: 0, maximum: 100, markdownDescription: m(0, "Controls the font size in pixels for CodeLens. When set to 0, 90% of `#editor.fontSize#` is used.") })), colorDecorators: J(new gt(20, "colorDecorators", !0, { description: m(0, "Controls whether the editor should render the inline color decorators and color picker.") })), colorDecoratorActivatedOn: J(new hi(148, "colorDecoratorsActivatedOn", "clickAndHover", ["clickAndHover", "hover", "click"], { enumDescriptions: [m(0, "Make the color picker appear both on click and hover of the color decorator"), m(0, "Make the color picker appear on hover of the color decorator"), m(0, "Make the color picker appear on click of the color decorator")], description: m(0, "Controls the condition to make a color picker appear from a color decorator") })), colorDecoratorsLimit: J(new Ot(21, "colorDecoratorsLimit", 500, 1, 1e6, { markdownDescription: m(0, "Controls the max number of color decorators that can be rendered in an editor at once.") })), columnSelection: J(new gt(22, "columnSelection", !1, { description: m(0, "Enable that the selection with the mouse and keys is doing column selection.") })), comments: J(new class extends Qt {
  constructor() {
    const n = { insertSpace: !0, ignoreEmptyLines: !0 };
    super(23, "comments", n, { "editor.comments.insertSpace": { type: "boolean", default: n.insertSpace, description: m(0, "Controls whether a space character is inserted when commenting.") }, "editor.comments.ignoreEmptyLines": { type: "boolean", default: n.ignoreEmptyLines, description: m(0, "Controls if empty lines should be ignored with toggle, add or remove actions for line comments.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { insertSpace: ve(e.insertSpace, this.defaultValue.insertSpace), ignoreEmptyLines: ve(e.ignoreEmptyLines, this.defaultValue.ignoreEmptyLines) };
  }
}()), contextmenu: J(new gt(24, "contextmenu", !0)), copyWithSyntaxHighlighting: J(new gt(25, "copyWithSyntaxHighlighting", !0, { description: m(0, "Controls whether syntax highlighting should be copied into the clipboard.") })), cursorBlinking: J(new $1(26, "cursorBlinking", 1, "blink", ["blink", "smooth", "phase", "expand", "solid"], (function(n) {
  switch (n) {
    case "blink":
      return 1;
    case "smooth":
      return 2;
    case "phase":
      return 3;
    case "expand":
      return 4;
    case "solid":
      return 5;
  }
}), { description: m(0, "Control the cursor animation style.") })), cursorSmoothCaretAnimation: J(new hi(27, "cursorSmoothCaretAnimation", "off", ["off", "explicit", "on"], { enumDescriptions: [m(0, "Smooth caret animation is disabled."), m(0, "Smooth caret animation is enabled only when the user moves the cursor with an explicit gesture."), m(0, "Smooth caret animation is always enabled.")], description: m(0, "Controls whether the smooth caret animation should be enabled.") })), cursorStyle: J(new $1(28, "cursorStyle", vn.Line, "line", ["line", "block", "underline", "line-thin", "block-outline", "underline-thin"], (function(n) {
  switch (n) {
    case "line":
      return vn.Line;
    case "block":
      return vn.Block;
    case "underline":
      return vn.Underline;
    case "line-thin":
      return vn.LineThin;
    case "block-outline":
      return vn.BlockOutline;
    case "underline-thin":
      return vn.UnderlineThin;
  }
}), { description: m(0, "Controls the cursor style.") })), cursorSurroundingLines: J(new Ot(29, "cursorSurroundingLines", 0, 0, 1073741824, { description: m(0, "Controls the minimal number of visible leading lines (minimum 0) and trailing lines (minimum 1) surrounding the cursor. Known as 'scrollOff' or 'scrollOffset' in some other editors.") })), cursorSurroundingLinesStyle: J(new hi(30, "cursorSurroundingLinesStyle", "default", ["default", "all"], { enumDescriptions: [m(0, "`cursorSurroundingLines` is enforced only when triggered via the keyboard or API."), m(0, "`cursorSurroundingLines` is enforced always.")], markdownDescription: m(0, "Controls when `#editor.cursorSurroundingLines#` should be enforced.") })), cursorWidth: J(new Ot(31, "cursorWidth", 0, 0, 1073741824, { markdownDescription: m(0, "Controls the width of the cursor when `#editor.cursorStyle#` is set to `line`.") })), disableLayerHinting: J(new gt(32, "disableLayerHinting", !1)), disableMonospaceOptimizations: J(new gt(33, "disableMonospaceOptimizations", !1)), domReadOnly: J(new gt(34, "domReadOnly", !1)), dragAndDrop: J(new gt(35, "dragAndDrop", !0, { description: m(0, "Controls whether the editor should allow moving selections via drag and drop.") })), emptySelectionClipboard: J(new class extends gt {
  constructor() {
    super(37, "emptySelectionClipboard", !0, { description: m(0, "Controls whether copying without a selection copies the current line.") });
  }
  compute(n, e, t) {
    return t && n.emptySelectionClipboard;
  }
}()), dropIntoEditor: J(new class extends Qt {
  constructor() {
    const n = { enabled: !0, showDropSelector: "afterDrop" };
    super(36, "dropIntoEditor", n, { "editor.dropIntoEditor.enabled": { type: "boolean", default: n.enabled, markdownDescription: m(0, "Controls whether you can drag and drop a file into a text editor by holding down the `Shift` key (instead of opening the file in an editor).") }, "editor.dropIntoEditor.showDropSelector": { type: "string", markdownDescription: m(0, "Controls if a widget is shown when dropping files into the editor. This widget lets you control how the file is dropped."), enum: ["afterDrop", "never"], enumDescriptions: [m(0, "Show the drop selector widget after a file is dropped into the editor."), m(0, "Never show the drop selector widget. Instead the default drop provider is always used.")], default: "afterDrop" } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), showDropSelector: _i(e.showDropSelector, this.defaultValue.showDropSelector, ["afterDrop", "never"]) };
  }
}()), stickyScroll: J(new class extends Qt {
  constructor() {
    const n = { enabled: !0, maxLineCount: 5, defaultModel: "outlineModel", scrollWithEditor: !0 };
    super(115, "stickyScroll", n, { "editor.stickyScroll.enabled": { type: "boolean", default: n.enabled, description: m(0, "Shows the nested current scopes during the scroll at the top of the editor."), tags: ["experimental"] }, "editor.stickyScroll.maxLineCount": { type: "number", default: n.maxLineCount, minimum: 1, maximum: 20, description: m(0, "Defines the maximum number of sticky lines to show.") }, "editor.stickyScroll.defaultModel": { type: "string", enum: ["outlineModel", "foldingProviderModel", "indentationModel"], default: n.defaultModel, description: m(0, "Defines the model to use for determining which lines to stick. If the outline model does not exist, it will fall back on the folding provider model which falls back on the indentation model. This order is respected in all three cases.") }, "editor.stickyScroll.scrollWithEditor": { type: "boolean", default: n.scrollWithEditor, description: m(0, "Enable scrolling of Sticky Scroll with the editor's horizontal scrollbar.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), maxLineCount: Ot.clampedInt(e.maxLineCount, this.defaultValue.maxLineCount, 1, 20), defaultModel: _i(e.defaultModel, this.defaultValue.defaultModel, ["outlineModel", "foldingProviderModel", "indentationModel"]), scrollWithEditor: ve(e.scrollWithEditor, this.defaultValue.scrollWithEditor) };
  }
}()), experimentalWhitespaceRendering: J(new hi(38, "experimentalWhitespaceRendering", "svg", ["svg", "font", "off"], { enumDescriptions: [m(0, "Use a new rendering method with svgs."), m(0, "Use a new rendering method with font characters."), m(0, "Use the stable rendering method.")], description: m(0, "Controls whether whitespace is rendered with a new, experimental method.") })), extraEditorClassName: J(new ss(39, "extraEditorClassName", "")), fastScrollSensitivity: J(new Fo(40, "fastScrollSensitivity", 5, ((n) => n <= 0 ? 5 : n), { markdownDescription: m(0, "Scrolling speed multiplier when pressing `Alt`.") })), find: J(new class extends Qt {
  constructor() {
    const n = { cursorMoveOnType: !0, seedSearchStringFromSelection: "always", autoFindInSelection: "never", globalFindClipboard: !1, addExtraSpaceOnTop: !0, loop: !0 };
    super(41, "find", n, { "editor.find.cursorMoveOnType": { type: "boolean", default: n.cursorMoveOnType, description: m(0, "Controls whether the cursor should jump to find matches while typing.") }, "editor.find.seedSearchStringFromSelection": { type: "string", enum: ["never", "always", "selection"], default: n.seedSearchStringFromSelection, enumDescriptions: [m(0, "Never seed search string from the editor selection."), m(0, "Always seed search string from the editor selection, including word at cursor position."), m(0, "Only seed search string from the editor selection.")], description: m(0, "Controls whether the search string in the Find Widget is seeded from the editor selection.") }, "editor.find.autoFindInSelection": { type: "string", enum: ["never", "always", "multiline"], default: n.autoFindInSelection, enumDescriptions: [m(0, "Never turn on Find in Selection automatically (default)."), m(0, "Always turn on Find in Selection automatically."), m(0, "Turn on Find in Selection automatically when multiple lines of content are selected.")], description: m(0, "Controls the condition for turning on Find in Selection automatically.") }, "editor.find.globalFindClipboard": { type: "boolean", default: n.globalFindClipboard, description: m(0, "Controls whether the Find Widget should read or modify the shared find clipboard on macOS."), included: Je }, "editor.find.addExtraSpaceOnTop": { type: "boolean", default: n.addExtraSpaceOnTop, description: m(0, "Controls whether the Find Widget should add extra lines on top of the editor. When true, you can scroll beyond the first line when the Find Widget is visible.") }, "editor.find.loop": { type: "boolean", default: n.loop, description: m(0, "Controls whether the search automatically restarts from the beginning (or the end) when no further matches can be found.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { cursorMoveOnType: ve(e.cursorMoveOnType, this.defaultValue.cursorMoveOnType), seedSearchStringFromSelection: typeof n.seedSearchStringFromSelection == "boolean" ? n.seedSearchStringFromSelection ? "always" : "never" : _i(e.seedSearchStringFromSelection, this.defaultValue.seedSearchStringFromSelection, ["never", "always", "selection"]), autoFindInSelection: typeof n.autoFindInSelection == "boolean" ? n.autoFindInSelection ? "always" : "never" : _i(e.autoFindInSelection, this.defaultValue.autoFindInSelection, ["never", "always", "multiline"]), globalFindClipboard: ve(e.globalFindClipboard, this.defaultValue.globalFindClipboard), addExtraSpaceOnTop: ve(e.addExtraSpaceOnTop, this.defaultValue.addExtraSpaceOnTop), loop: ve(e.loop, this.defaultValue.loop) };
  }
}()), fixedOverflowWidgets: J(new gt(42, "fixedOverflowWidgets", !1)), folding: J(new gt(43, "folding", !0, { description: m(0, "Controls whether the editor has code folding enabled.") })), foldingStrategy: J(new hi(44, "foldingStrategy", "auto", ["auto", "indentation"], { enumDescriptions: [m(0, "Use a language-specific folding strategy if available, else the indentation-based one."), m(0, "Use the indentation-based folding strategy.")], description: m(0, "Controls the strategy for computing folding ranges.") })), foldingHighlight: J(new gt(45, "foldingHighlight", !0, { description: m(0, "Controls whether the editor should highlight folded ranges.") })), foldingImportsByDefault: J(new gt(46, "foldingImportsByDefault", !1, { description: m(0, "Controls whether the editor automatically collapses import ranges.") })), foldingMaximumRegions: J(new Ot(47, "foldingMaximumRegions", 5e3, 10, 65e3, { description: m(0, "The maximum number of foldable regions. Increasing this value may result in the editor becoming less responsive when the current source has a large number of foldable regions.") })), unfoldOnClickAfterEndOfLine: J(new gt(48, "unfoldOnClickAfterEndOfLine", !1, { description: m(0, "Controls whether clicking on the empty content after a folded line will unfold the line.") })), fontFamily: J(new ss(49, "fontFamily", Is.fontFamily, { description: m(0, "Controls the font family.") })), fontInfo: J(new class extends d_ {
  constructor() {
    super(50);
  }
  compute(n, e, t) {
    return n.fontInfo;
  }
}()), fontLigatures2: J(new fo()), fontSize: J(new class extends df {
  constructor() {
    super(52, "fontSize", Is.fontSize, { type: "number", minimum: 6, maximum: 100, default: Is.fontSize, description: m(0, "Controls the font size in pixels.") });
  }
  validate(n) {
    const e = Fo.float(n, this.defaultValue);
    return e === 0 ? Is.fontSize : Fo.clamp(e, 6, 100);
  }
  compute(n, e, t) {
    return n.fontInfo.fontSize;
  }
}()), fontWeight: J(new Ka()), fontVariations: J(new Xr()), formatOnPaste: J(new gt(55, "formatOnPaste", !1, { description: m(0, "Controls whether the editor should automatically format the pasted content. A formatter must be available and the formatter should be able to format a range in a document.") })), formatOnType: J(new gt(56, "formatOnType", !1, { description: m(0, "Controls whether the editor should automatically format the line after typing.") })), glyphMargin: J(new gt(57, "glyphMargin", !0, { description: m(0, "Controls whether the editor should render the vertical glyph margin. Glyph margin is mostly used for debugging.") })), gotoLocation: J(new class extends Qt {
  constructor() {
    const n = { multiple: "peek", multipleDefinitions: "peek", multipleTypeDefinitions: "peek", multipleDeclarations: "peek", multipleImplementations: "peek", multipleReferences: "peek", alternativeDefinitionCommand: "editor.action.goToReferences", alternativeTypeDefinitionCommand: "editor.action.goToReferences", alternativeDeclarationCommand: "editor.action.goToReferences", alternativeImplementationCommand: "", alternativeReferenceCommand: "" }, e = { type: "string", enum: ["peek", "gotoAndPeek", "goto"], default: n.multiple, enumDescriptions: [m(0, "Show Peek view of the results (default)"), m(0, "Go to the primary result and show a Peek view"), m(0, "Go to the primary result and enable Peek-less navigation to others")] }, t = ["", "editor.action.referenceSearch.trigger", "editor.action.goToReferences", "editor.action.peekImplementation", "editor.action.goToImplementation", "editor.action.peekTypeDefinition", "editor.action.goToTypeDefinition", "editor.action.peekDeclaration", "editor.action.revealDeclaration", "editor.action.peekDefinition", "editor.action.revealDefinitionAside", "editor.action.revealDefinition"];
    super(58, "gotoLocation", n, { "editor.gotoLocation.multiple": { deprecationMessage: m(0, "This setting is deprecated, please use separate settings like 'editor.editor.gotoLocation.multipleDefinitions' or 'editor.editor.gotoLocation.multipleImplementations' instead.") }, "editor.gotoLocation.multipleDefinitions": { description: m(0, "Controls the behavior the 'Go to Definition'-command when multiple target locations exist."), ...e }, "editor.gotoLocation.multipleTypeDefinitions": { description: m(0, "Controls the behavior the 'Go to Type Definition'-command when multiple target locations exist."), ...e }, "editor.gotoLocation.multipleDeclarations": { description: m(0, "Controls the behavior the 'Go to Declaration'-command when multiple target locations exist."), ...e }, "editor.gotoLocation.multipleImplementations": { description: m(0, "Controls the behavior the 'Go to Implementations'-command when multiple target locations exist."), ...e }, "editor.gotoLocation.multipleReferences": { description: m(0, "Controls the behavior the 'Go to References'-command when multiple target locations exist."), ...e }, "editor.gotoLocation.alternativeDefinitionCommand": { type: "string", default: n.alternativeDefinitionCommand, enum: t, description: m(0, "Alternative command id that is being executed when the result of 'Go to Definition' is the current location.") }, "editor.gotoLocation.alternativeTypeDefinitionCommand": { type: "string", default: n.alternativeTypeDefinitionCommand, enum: t, description: m(0, "Alternative command id that is being executed when the result of 'Go to Type Definition' is the current location.") }, "editor.gotoLocation.alternativeDeclarationCommand": { type: "string", default: n.alternativeDeclarationCommand, enum: t, description: m(0, "Alternative command id that is being executed when the result of 'Go to Declaration' is the current location.") }, "editor.gotoLocation.alternativeImplementationCommand": { type: "string", default: n.alternativeImplementationCommand, enum: t, description: m(0, "Alternative command id that is being executed when the result of 'Go to Implementation' is the current location.") }, "editor.gotoLocation.alternativeReferenceCommand": { type: "string", default: n.alternativeReferenceCommand, enum: t, description: m(0, "Alternative command id that is being executed when the result of 'Go to Reference' is the current location.") } });
  }
  validate(n) {
    var e, t, i, s, o;
    if (!n || typeof n != "object") return this.defaultValue;
    const r = n;
    return { multiple: _i(r.multiple, this.defaultValue.multiple, ["peek", "gotoAndPeek", "goto"]), multipleDefinitions: (e = r.multipleDefinitions) !== null && e !== void 0 ? e : _i(r.multipleDefinitions, "peek", ["peek", "gotoAndPeek", "goto"]), multipleTypeDefinitions: (t = r.multipleTypeDefinitions) !== null && t !== void 0 ? t : _i(r.multipleTypeDefinitions, "peek", ["peek", "gotoAndPeek", "goto"]), multipleDeclarations: (i = r.multipleDeclarations) !== null && i !== void 0 ? i : _i(r.multipleDeclarations, "peek", ["peek", "gotoAndPeek", "goto"]), multipleImplementations: (s = r.multipleImplementations) !== null && s !== void 0 ? s : _i(r.multipleImplementations, "peek", ["peek", "gotoAndPeek", "goto"]), multipleReferences: (o = r.multipleReferences) !== null && o !== void 0 ? o : _i(r.multipleReferences, "peek", ["peek", "gotoAndPeek", "goto"]), alternativeDefinitionCommand: ss.string(r.alternativeDefinitionCommand, this.defaultValue.alternativeDefinitionCommand), alternativeTypeDefinitionCommand: ss.string(r.alternativeTypeDefinitionCommand, this.defaultValue.alternativeTypeDefinitionCommand), alternativeDeclarationCommand: ss.string(r.alternativeDeclarationCommand, this.defaultValue.alternativeDeclarationCommand), alternativeImplementationCommand: ss.string(r.alternativeImplementationCommand, this.defaultValue.alternativeImplementationCommand), alternativeReferenceCommand: ss.string(r.alternativeReferenceCommand, this.defaultValue.alternativeReferenceCommand) };
  }
}()), hideCursorInOverviewRuler: J(new gt(59, "hideCursorInOverviewRuler", !1, { description: m(0, "Controls whether the cursor should be hidden in the overview ruler.") })), hover: J(new class extends Qt {
  constructor() {
    const n = { enabled: !0, delay: 300, hidingDelay: 300, sticky: !0, above: !0 };
    super(60, "hover", n, { "editor.hover.enabled": { type: "boolean", default: n.enabled, description: m(0, "Controls whether the hover is shown.") }, "editor.hover.delay": { type: "number", default: n.delay, minimum: 0, maximum: 1e4, description: m(0, "Controls the delay in milliseconds after which the hover is shown.") }, "editor.hover.sticky": { type: "boolean", default: n.sticky, description: m(0, "Controls whether the hover should remain visible when mouse is moved over it.") }, "editor.hover.hidingDelay": { type: "integer", minimum: 0, default: n.hidingDelay, description: m(0, "Controls the delay in milliseconds after which the hover is hidden. Requires `editor.hover.sticky` to be enabled.") }, "editor.hover.above": { type: "boolean", default: n.above, description: m(0, "Prefer showing hovers above the line, if there's space.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), delay: Ot.clampedInt(e.delay, this.defaultValue.delay, 0, 1e4), sticky: ve(e.sticky, this.defaultValue.sticky), hidingDelay: Ot.clampedInt(e.hidingDelay, this.defaultValue.hidingDelay, 0, 6e5), above: ve(e.above, this.defaultValue.above) };
  }
}()), inDiffEditor: J(new gt(61, "inDiffEditor", !1)), letterSpacing: J(new Fo(64, "letterSpacing", Is.letterSpacing, ((n) => Fo.clamp(n, -5, 20)), { description: m(0, "Controls the letter spacing in pixels.") })), lightbulb: J(new class extends Qt {
  constructor() {
    const n = { enabled: mr.On };
    super(65, "lightbulb", n, { "editor.lightbulb.enabled": { type: "string", tags: ["experimental"], enum: [mr.Off, mr.OnCode, mr.On], default: n.enabled, enumDescriptions: [m(0, "Disable the code action menu."), m(0, "Show the code action menu when the cursor is on lines with code."), m(0, "Show the code action menu when the cursor is on lines with code or on empty lines.")], description: m(0, "Enables the Code Action lightbulb in the editor.") } });
  }
  validate(n) {
    return !n || typeof n != "object" ? this.defaultValue : { enabled: _i(n.enabled, this.defaultValue.enabled, [mr.Off, mr.OnCode, mr.On]) };
  }
}()), lineDecorationsWidth: J(new class extends Qt {
  constructor() {
    super(66, "lineDecorationsWidth", 10);
  }
  validate(n) {
    return typeof n == "string" && /^\d+(\.\d+)?ch$/.test(n) ? -parseFloat(n.substring(0, n.length - 2)) : Ot.clampedInt(n, this.defaultValue, 0, 1e3);
  }
  compute(n, e, t) {
    return t < 0 ? Ot.clampedInt(-t * n.fontInfo.typicalHalfwidthCharacterWidth, this.defaultValue, 0, 1e3) : t;
  }
}()), lineHeight: J(new class extends Fo {
  constructor() {
    super(67, "lineHeight", Is.lineHeight, ((n) => Fo.clamp(n, 0, 150)), { markdownDescription: m(0, `Controls the line height. 
 - Use 0 to automatically compute the line height from the font size.
 - Values between 0 and 8 will be used as a multiplier with the font size.
 - Values greater than or equal to 8 will be used as effective values.`) });
  }
  compute(n, e, t) {
    return n.fontInfo.lineHeight;
  }
}()), lineNumbers: J(new class extends Qt {
  constructor() {
    super(68, "lineNumbers", { renderType: 1, renderFn: null }, { type: "string", enum: ["off", "on", "relative", "interval"], enumDescriptions: [m(0, "Line numbers are not rendered."), m(0, "Line numbers are rendered as absolute number."), m(0, "Line numbers are rendered as distance in lines to cursor position."), m(0, "Line numbers are rendered every 10 lines.")], default: "on", description: m(0, "Controls the display of line numbers.") });
  }
  validate(n) {
    let e = this.defaultValue.renderType, t = this.defaultValue.renderFn;
    return n !== void 0 && (typeof n == "function" ? (e = 4, t = n) : e = n === "interval" ? 3 : n === "relative" ? 2 : n === "on" ? 1 : 0), { renderType: e, renderFn: t };
  }
}()), lineNumbersMinChars: J(new Ot(69, "lineNumbersMinChars", 5, 1, 300)), linkedEditing: J(new gt(70, "linkedEditing", !1, { description: m(0, "Controls whether the editor has linked editing enabled. Depending on the language, related symbols such as HTML tags, are updated while editing.") })), links: J(new gt(71, "links", !0, { description: m(0, "Controls whether the editor should detect links and make them clickable.") })), matchBrackets: J(new hi(72, "matchBrackets", "always", ["always", "near", "never"], { description: m(0, "Highlight matching brackets.") })), minimap: J(new class extends Qt {
  constructor() {
    const n = { enabled: !0, size: "proportional", side: "right", showSlider: "mouseover", autohide: !1, renderCharacters: !0, maxColumn: 120, scale: 1, showRegionSectionHeaders: !0, showMarkSectionHeaders: !0, sectionHeaderFontSize: 9 };
    super(73, "minimap", n, { "editor.minimap.enabled": { type: "boolean", default: n.enabled, description: m(0, "Controls whether the minimap is shown.") }, "editor.minimap.autohide": { type: "boolean", default: n.autohide, description: m(0, "Controls whether the minimap is hidden automatically.") }, "editor.minimap.size": { type: "string", enum: ["proportional", "fill", "fit"], enumDescriptions: [m(0, "The minimap has the same size as the editor contents (and might scroll)."), m(0, "The minimap will stretch or shrink as necessary to fill the height of the editor (no scrolling)."), m(0, "The minimap will shrink as necessary to never be larger than the editor (no scrolling).")], default: n.size, description: m(0, "Controls the size of the minimap.") }, "editor.minimap.side": { type: "string", enum: ["left", "right"], default: n.side, description: m(0, "Controls the side where to render the minimap.") }, "editor.minimap.showSlider": { type: "string", enum: ["always", "mouseover"], default: n.showSlider, description: m(0, "Controls when the minimap slider is shown.") }, "editor.minimap.scale": { type: "number", default: n.scale, minimum: 1, maximum: 3, enum: [1, 2, 3], description: m(0, "Scale of content drawn in the minimap: 1, 2 or 3.") }, "editor.minimap.renderCharacters": { type: "boolean", default: n.renderCharacters, description: m(0, "Render the actual characters on a line as opposed to color blocks.") }, "editor.minimap.maxColumn": { type: "number", default: n.maxColumn, description: m(0, "Limit the width of the minimap to render at most a certain number of columns.") }, "editor.minimap.showRegionSectionHeaders": { type: "boolean", default: n.showRegionSectionHeaders, description: m(0, "Controls whether named regions are shown as section headers in the minimap.") }, "editor.minimap.showMarkSectionHeaders": { type: "boolean", default: n.showMarkSectionHeaders, description: m(0, "Controls whether MARK: comments are shown as section headers in the minimap.") }, "editor.minimap.sectionHeaderFontSize": { type: "number", default: n.sectionHeaderFontSize, description: m(0, "Controls the font size of section headers in the minimap.") } });
  }
  validate(n) {
    var e;
    if (!n || typeof n != "object") return this.defaultValue;
    const t = n;
    return { enabled: ve(t.enabled, this.defaultValue.enabled), autohide: ve(t.autohide, this.defaultValue.autohide), size: _i(t.size, this.defaultValue.size, ["proportional", "fill", "fit"]), side: _i(t.side, this.defaultValue.side, ["right", "left"]), showSlider: _i(t.showSlider, this.defaultValue.showSlider, ["always", "mouseover"]), renderCharacters: ve(t.renderCharacters, this.defaultValue.renderCharacters), scale: Ot.clampedInt(t.scale, 1, 1, 3), maxColumn: Ot.clampedInt(t.maxColumn, this.defaultValue.maxColumn, 1, 1e4), showRegionSectionHeaders: ve(t.showRegionSectionHeaders, this.defaultValue.showRegionSectionHeaders), showMarkSectionHeaders: ve(t.showMarkSectionHeaders, this.defaultValue.showMarkSectionHeaders), sectionHeaderFontSize: Fo.clamp((e = t.sectionHeaderFontSize) !== null && e !== void 0 ? e : this.defaultValue.sectionHeaderFontSize, 4, 32) };
  }
}()), mouseStyle: J(new hi(74, "mouseStyle", "text", ["text", "default", "copy"])), mouseWheelScrollSensitivity: J(new Fo(75, "mouseWheelScrollSensitivity", 1, ((n) => n === 0 ? 1 : n), { markdownDescription: m(0, "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.") })), mouseWheelZoom: J(new gt(76, "mouseWheelZoom", !1, { markdownDescription: m(0, Je ? "Zoom the font of the editor when using mouse wheel and holding `Cmd`." : "Zoom the font of the editor when using mouse wheel and holding `Ctrl`.") })), multiCursorMergeOverlapping: J(new gt(77, "multiCursorMergeOverlapping", !0, { description: m(0, "Merge multiple cursors when they are overlapping.") })), multiCursorModifier: J(new $1(78, "multiCursorModifier", "altKey", "alt", ["ctrlCmd", "alt"], (function(n) {
  return n === "ctrlCmd" ? Je ? "metaKey" : "ctrlKey" : "altKey";
}), { markdownEnumDescriptions: [m(0, "Maps to `Control` on Windows and Linux and to `Command` on macOS."), m(0, "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")], markdownDescription: m(0, "The modifier to be used to add multiple cursors with the mouse. The Go to Definition and Open Link mouse gestures will adapt such that they do not conflict with the [multicursor modifier](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-modifier).") })), multiCursorPaste: J(new hi(79, "multiCursorPaste", "spread", ["spread", "full"], { markdownEnumDescriptions: [m(0, "Each cursor pastes a single line of the text."), m(0, "Each cursor pastes the full text.")], markdownDescription: m(0, "Controls pasting when the line count of the pasted text matches the cursor count.") })), multiCursorLimit: J(new Ot(80, "multiCursorLimit", 1e4, 1, 1e5, { markdownDescription: m(0, "Controls the max number of cursors that can be in an active editor at once.") })), occurrencesHighlight: J(new hi(81, "occurrencesHighlight", "singleFile", ["off", "singleFile", "multiFile"], { markdownEnumDescriptions: [m(0, "Does not highlight occurrences."), m(0, "Highlights occurrences only in the current file."), m(0, "Experimental: Highlights occurrences across all valid open files.")], markdownDescription: m(0, "Controls whether occurrences should be highlighted across open files.") })), overviewRulerBorder: J(new gt(82, "overviewRulerBorder", !0, { description: m(0, "Controls whether a border should be drawn around the overview ruler.") })), overviewRulerLanes: J(new Ot(83, "overviewRulerLanes", 3, 0, 3)), padding: J(new class extends Qt {
  constructor() {
    super(84, "padding", { top: 0, bottom: 0 }, { "editor.padding.top": { type: "number", default: 0, minimum: 0, maximum: 1e3, description: m(0, "Controls the amount of space between the top edge of the editor and the first line.") }, "editor.padding.bottom": { type: "number", default: 0, minimum: 0, maximum: 1e3, description: m(0, "Controls the amount of space between the bottom edge of the editor and the last line.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { top: Ot.clampedInt(e.top, 0, 0, 1e3), bottom: Ot.clampedInt(e.bottom, 0, 0, 1e3) };
  }
}()), pasteAs: J(new class extends Qt {
  constructor() {
    const n = { enabled: !0, showPasteSelector: "afterPaste" };
    super(85, "pasteAs", n, { "editor.pasteAs.enabled": { type: "boolean", default: n.enabled, markdownDescription: m(0, "Controls whether you can paste content in different ways.") }, "editor.pasteAs.showPasteSelector": { type: "string", markdownDescription: m(0, "Controls if a widget is shown when pasting content in to the editor. This widget lets you control how the file is pasted."), enum: ["afterPaste", "never"], enumDescriptions: [m(0, "Show the paste selector widget after content is pasted into the editor."), m(0, "Never show the paste selector widget. Instead the default pasting behavior is always used.")], default: "afterPaste" } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), showPasteSelector: _i(e.showPasteSelector, this.defaultValue.showPasteSelector, ["afterPaste", "never"]) };
  }
}()), parameterHints: J(new class extends Qt {
  constructor() {
    const n = { enabled: !0, cycle: !0 };
    super(86, "parameterHints", n, { "editor.parameterHints.enabled": { type: "boolean", default: n.enabled, description: m(0, "Enables a pop-up that shows parameter documentation and type information as you type.") }, "editor.parameterHints.cycle": { type: "boolean", default: n.cycle, description: m(0, "Controls whether the parameter hints menu cycles or closes when reaching the end of the list.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), cycle: ve(e.cycle, this.defaultValue.cycle) };
  }
}()), peekWidgetDefaultFocus: J(new hi(87, "peekWidgetDefaultFocus", "tree", ["tree", "editor"], { enumDescriptions: [m(0, "Focus the tree when opening peek"), m(0, "Focus the editor when opening peek")], description: m(0, "Controls whether to focus the inline editor or the tree in the peek widget.") })), definitionLinkOpensInPeek: J(new gt(88, "definitionLinkOpensInPeek", !1, { description: m(0, "Controls whether the Go to Definition mouse gesture always opens the peek widget.") })), quickSuggestions: J(new class extends Qt {
  constructor() {
    const n = { other: "on", comments: "off", strings: "off" }, e = [{ type: "boolean" }, { type: "string", enum: ["on", "inline", "off"], enumDescriptions: [m(0, "Quick suggestions show inside the suggest widget"), m(0, "Quick suggestions show as ghost text"), m(0, "Quick suggestions are disabled")] }];
    super(89, "quickSuggestions", n, { type: "object", additionalProperties: !1, properties: { strings: { anyOf: e, default: n.strings, description: m(0, "Enable quick suggestions inside strings.") }, comments: { anyOf: e, default: n.comments, description: m(0, "Enable quick suggestions inside comments.") }, other: { anyOf: e, default: n.other, description: m(0, "Enable quick suggestions outside of strings and comments.") } }, default: n, markdownDescription: m(0, "Controls whether suggestions should automatically show up while typing. This can be controlled for typing in comments, strings, and other code. Quick suggestion can be configured to show as ghost text or with the suggest widget. Also be aware of the '{0}'-setting which controls if suggestions are triggered by special characters.", "#editor.suggestOnTriggerCharacters#") }), this.defaultValue = n;
  }
  validate(n) {
    if (typeof n == "boolean") {
      const l = n ? "on" : "off";
      return { comments: l, strings: l, other: l };
    }
    if (!n || typeof n != "object") return this.defaultValue;
    const { other: e, comments: t, strings: i } = n, s = ["on", "inline", "off"];
    let o, r, a;
    return o = typeof e == "boolean" ? e ? "on" : "off" : _i(e, this.defaultValue.other, s), r = typeof t == "boolean" ? t ? "on" : "off" : _i(t, this.defaultValue.comments, s), a = typeof i == "boolean" ? i ? "on" : "off" : _i(i, this.defaultValue.strings, s), { other: o, comments: r, strings: a };
  }
}()), quickSuggestionsDelay: J(new Ot(90, "quickSuggestionsDelay", 10, 0, 1073741824, { description: m(0, "Controls the delay in milliseconds after which quick suggestions will show up.") })), readOnly: J(new gt(91, "readOnly", !1)), readOnlyMessage: J(new class extends Qt {
  constructor() {
    super(92, "readOnlyMessage", void 0);
  }
  validate(n) {
    return n && typeof n == "object" ? n : this.defaultValue;
  }
}()), renameOnType: J(new gt(93, "renameOnType", !1, { description: m(0, "Controls whether the editor auto renames on type."), markdownDeprecationMessage: m(0, "Deprecated, use `editor.linkedEditing` instead.") })), renderControlCharacters: J(new gt(94, "renderControlCharacters", !0, { description: m(0, "Controls whether the editor should render control characters."), restricted: !0 })), renderFinalNewline: J(new hi(95, "renderFinalNewline", Cs ? "dimmed" : "on", ["off", "on", "dimmed"], { description: m(0, "Render last line number when the file ends with a newline.") })), renderLineHighlight: J(new hi(96, "renderLineHighlight", "line", ["none", "gutter", "line", "all"], { enumDescriptions: ["", "", "", m(0, "Highlights both the gutter and the current line.")], description: m(0, "Controls how the editor should render the current line highlight.") })), renderLineHighlightOnlyWhenFocus: J(new gt(97, "renderLineHighlightOnlyWhenFocus", !1, { description: m(0, "Controls if the editor should render the current line highlight only when the editor is focused.") })), renderValidationDecorations: J(new hi(98, "renderValidationDecorations", "editable", ["editable", "on", "off"])), renderWhitespace: J(new hi(99, "renderWhitespace", "selection", ["none", "boundary", "selection", "trailing", "all"], { enumDescriptions: ["", m(0, "Render whitespace characters except for single spaces between words."), m(0, "Render whitespace characters only on selected text."), m(0, "Render only trailing whitespace characters."), ""], description: m(0, "Controls how the editor should render whitespace characters.") })), revealHorizontalRightPadding: J(new Ot(100, "revealHorizontalRightPadding", 15, 0, 1e3)), roundedSelection: J(new gt(101, "roundedSelection", !0, { description: m(0, "Controls whether selections should have rounded corners.") })), rulers: J(new class extends Qt {
  constructor() {
    const n = [], e = { type: "number", description: m(0, "Number of monospace characters at which this editor ruler will render.") };
    super(102, "rulers", n, { type: "array", items: { anyOf: [e, { type: ["object"], properties: { column: e, color: { type: "string", description: m(0, "Color of this editor ruler."), format: "color-hex" } } }] }, default: n, description: m(0, "Render vertical rulers after a certain number of monospace characters. Use multiple values for multiple rulers. No rulers are drawn if array is empty.") });
  }
  validate(n) {
    if (Array.isArray(n)) {
      const e = [];
      for (const t of n) if (typeof t == "number") e.push({ column: Ot.clampedInt(t, 0, 0, 1e4), color: null });
      else if (t && typeof t == "object") {
        const i = t;
        e.push({ column: Ot.clampedInt(i.column, 0, 0, 1e4), color: i.color });
      }
      return e.sort(((t, i) => t.column - i.column)), e;
    }
    return this.defaultValue;
  }
}()), scrollbar: J(new class extends Qt {
  constructor() {
    const n = { vertical: 1, horizontal: 1, arrowSize: 11, useShadows: !0, verticalHasArrows: !1, horizontalHasArrows: !1, horizontalScrollbarSize: 12, horizontalSliderSize: 12, verticalScrollbarSize: 14, verticalSliderSize: 14, handleMouseWheel: !0, alwaysConsumeMouseWheel: !0, scrollByPage: !1, ignoreHorizontalScrollbarInContentHeight: !1 };
    super(103, "scrollbar", n, { "editor.scrollbar.vertical": { type: "string", enum: ["auto", "visible", "hidden"], enumDescriptions: [m(0, "The vertical scrollbar will be visible only when necessary."), m(0, "The vertical scrollbar will always be visible."), m(0, "The vertical scrollbar will always be hidden.")], default: "auto", description: m(0, "Controls the visibility of the vertical scrollbar.") }, "editor.scrollbar.horizontal": { type: "string", enum: ["auto", "visible", "hidden"], enumDescriptions: [m(0, "The horizontal scrollbar will be visible only when necessary."), m(0, "The horizontal scrollbar will always be visible."), m(0, "The horizontal scrollbar will always be hidden.")], default: "auto", description: m(0, "Controls the visibility of the horizontal scrollbar.") }, "editor.scrollbar.verticalScrollbarSize": { type: "number", default: n.verticalScrollbarSize, description: m(0, "The width of the vertical scrollbar.") }, "editor.scrollbar.horizontalScrollbarSize": { type: "number", default: n.horizontalScrollbarSize, description: m(0, "The height of the horizontal scrollbar.") }, "editor.scrollbar.scrollByPage": { type: "boolean", default: n.scrollByPage, description: m(0, "Controls whether clicks scroll by page or jump to click position.") }, "editor.scrollbar.ignoreHorizontalScrollbarInContentHeight": { type: "boolean", default: n.ignoreHorizontalScrollbarInContentHeight, description: m(0, "When set, the horizontal scrollbar will not increase the size of the editor's content.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n, t = Ot.clampedInt(e.horizontalScrollbarSize, this.defaultValue.horizontalScrollbarSize, 0, 1e3), i = Ot.clampedInt(e.verticalScrollbarSize, this.defaultValue.verticalScrollbarSize, 0, 1e3);
    return { arrowSize: Ot.clampedInt(e.arrowSize, this.defaultValue.arrowSize, 0, 1e3), vertical: tO(e.vertical, this.defaultValue.vertical), horizontal: tO(e.horizontal, this.defaultValue.horizontal), useShadows: ve(e.useShadows, this.defaultValue.useShadows), verticalHasArrows: ve(e.verticalHasArrows, this.defaultValue.verticalHasArrows), horizontalHasArrows: ve(e.horizontalHasArrows, this.defaultValue.horizontalHasArrows), handleMouseWheel: ve(e.handleMouseWheel, this.defaultValue.handleMouseWheel), alwaysConsumeMouseWheel: ve(e.alwaysConsumeMouseWheel, this.defaultValue.alwaysConsumeMouseWheel), horizontalScrollbarSize: t, horizontalSliderSize: Ot.clampedInt(e.horizontalSliderSize, t, 0, 1e3), verticalScrollbarSize: i, verticalSliderSize: Ot.clampedInt(e.verticalSliderSize, i, 0, 1e3), scrollByPage: ve(e.scrollByPage, this.defaultValue.scrollByPage), ignoreHorizontalScrollbarInContentHeight: ve(e.ignoreHorizontalScrollbarInContentHeight, this.defaultValue.ignoreHorizontalScrollbarInContentHeight) };
  }
}()), scrollBeyondLastColumn: J(new Ot(104, "scrollBeyondLastColumn", 4, 0, 1073741824, { description: m(0, "Controls the number of extra characters beyond which the editor will scroll horizontally.") })), scrollBeyondLastLine: J(new gt(105, "scrollBeyondLastLine", !0, { description: m(0, "Controls whether the editor will scroll beyond the last line.") })), scrollPredominantAxis: J(new gt(106, "scrollPredominantAxis", !0, { description: m(0, "Scroll only along the predominant axis when scrolling both vertically and horizontally at the same time. Prevents horizontal drift when scrolling vertically on a trackpad.") })), selectionClipboard: J(new gt(107, "selectionClipboard", !0, { description: m(0, "Controls whether the Linux primary clipboard should be supported."), included: Cs })), selectionHighlight: J(new gt(108, "selectionHighlight", !0, { description: m(0, "Controls whether the editor should highlight matches similar to the selection.") })), selectOnLineNumbers: J(new gt(109, "selectOnLineNumbers", !0)), showFoldingControls: J(new hi(110, "showFoldingControls", "mouseover", ["always", "never", "mouseover"], { enumDescriptions: [m(0, "Always show the folding controls."), m(0, "Never show the folding controls and reduce the gutter size."), m(0, "Only show the folding controls when the mouse is over the gutter.")], description: m(0, "Controls when the folding controls on the gutter are shown.") })), showUnused: J(new gt(111, "showUnused", !0, { description: m(0, "Controls fading out of unused code.") })), showDeprecated: J(new gt(140, "showDeprecated", !0, { description: m(0, "Controls strikethrough deprecated variables.") })), inlayHints: J(new class extends Qt {
  constructor() {
    const n = { enabled: "on", fontSize: 0, fontFamily: "", padding: !1 };
    super(141, "inlayHints", n, { "editor.inlayHints.enabled": { type: "string", default: n.enabled, description: m(0, "Enables the inlay hints in the editor."), enum: ["on", "onUnlessPressed", "offUnlessPressed", "off"], markdownEnumDescriptions: [m(0, "Inlay hints are enabled"), m(0, "Inlay hints are showing by default and hide when holding {0}", Je ? "Ctrl+Option" : "Ctrl+Alt"), m(0, "Inlay hints are hidden by default and show when holding {0}", Je ? "Ctrl+Option" : "Ctrl+Alt"), m(0, "Inlay hints are disabled")] }, "editor.inlayHints.fontSize": { type: "number", default: n.fontSize, markdownDescription: m(0, "Controls font size of inlay hints in the editor. As default the {0} is used when the configured value is less than {1} or greater than the editor font size.", "`#editor.fontSize#`", "`5`") }, "editor.inlayHints.fontFamily": { type: "string", default: n.fontFamily, markdownDescription: m(0, "Controls font family of inlay hints in the editor. When set to empty, the {0} is used.", "`#editor.fontFamily#`") }, "editor.inlayHints.padding": { type: "boolean", default: n.padding, description: m(0, "Enables the padding around the inlay hints in the editor.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return typeof e.enabled == "boolean" && (e.enabled = e.enabled ? "on" : "off"), { enabled: _i(e.enabled, this.defaultValue.enabled, ["on", "off", "offUnlessPressed", "onUnlessPressed"]), fontSize: Ot.clampedInt(e.fontSize, this.defaultValue.fontSize, 0, 100), fontFamily: ss.string(e.fontFamily, this.defaultValue.fontFamily), padding: ve(e.padding, this.defaultValue.padding) };
  }
}()), snippetSuggestions: J(new hi(112, "snippetSuggestions", "inline", ["top", "bottom", "inline", "none"], { enumDescriptions: [m(0, "Show snippet suggestions on top of other suggestions."), m(0, "Show snippet suggestions below other suggestions."), m(0, "Show snippets suggestions with other suggestions."), m(0, "Do not show snippet suggestions.")], description: m(0, "Controls whether snippets are shown with other suggestions and how they are sorted.") })), smartSelect: J(new class extends Qt {
  constructor() {
    super(113, "smartSelect", { selectLeadingAndTrailingWhitespace: !0, selectSubwords: !0 }, { "editor.smartSelect.selectLeadingAndTrailingWhitespace": { description: m(0, "Whether leading and trailing whitespace should always be selected."), default: !0, type: "boolean" }, "editor.smartSelect.selectSubwords": { description: m(0, "Whether subwords (like 'foo' in 'fooBar' or 'foo_bar') should be selected."), default: !0, type: "boolean" } });
  }
  validate(n) {
    return n && typeof n == "object" ? { selectLeadingAndTrailingWhitespace: ve(n.selectLeadingAndTrailingWhitespace, this.defaultValue.selectLeadingAndTrailingWhitespace), selectSubwords: ve(n.selectSubwords, this.defaultValue.selectSubwords) } : this.defaultValue;
  }
}()), smoothScrolling: J(new gt(114, "smoothScrolling", !1, { description: m(0, "Controls whether the editor will scroll using an animation.") })), stopRenderingLineAfter: J(new Ot(117, "stopRenderingLineAfter", 1e4, -1, 1073741824)), suggest: J(new class extends Qt {
  constructor() {
    const n = { insertMode: "insert", filterGraceful: !0, snippetsPreventQuickSuggestions: !1, localityBonus: !1, shareSuggestSelections: !1, selectionMode: "always", showIcons: !0, showStatusBar: !1, preview: !1, previewMode: "subwordSmart", showInlineDetails: !0, showMethods: !0, showFunctions: !0, showConstructors: !0, showDeprecated: !0, matchOnWordStartOnly: !0, showFields: !0, showVariables: !0, showClasses: !0, showStructs: !0, showInterfaces: !0, showModules: !0, showProperties: !0, showEvents: !0, showOperators: !0, showUnits: !0, showValues: !0, showConstants: !0, showEnums: !0, showEnumMembers: !0, showKeywords: !0, showWords: !0, showColors: !0, showFiles: !0, showReferences: !0, showFolders: !0, showTypeParameters: !0, showSnippets: !0, showUsers: !0, showIssues: !0 };
    super(118, "suggest", n, { "editor.suggest.insertMode": { type: "string", enum: ["insert", "replace"], enumDescriptions: [m(0, "Insert suggestion without overwriting text right of the cursor."), m(0, "Insert suggestion and overwrite text right of the cursor.")], default: n.insertMode, description: m(0, "Controls whether words are overwritten when accepting completions. Note that this depends on extensions opting into this feature.") }, "editor.suggest.filterGraceful": { type: "boolean", default: n.filterGraceful, description: m(0, "Controls whether filtering and sorting suggestions accounts for small typos.") }, "editor.suggest.localityBonus": { type: "boolean", default: n.localityBonus, description: m(0, "Controls whether sorting favors words that appear close to the cursor.") }, "editor.suggest.shareSuggestSelections": { type: "boolean", default: n.shareSuggestSelections, markdownDescription: m(0, "Controls whether remembered suggestion selections are shared between multiple workspaces and windows (needs `#editor.suggestSelection#`).") }, "editor.suggest.selectionMode": { type: "string", enum: ["always", "never", "whenTriggerCharacter", "whenQuickSuggestion"], enumDescriptions: [m(0, "Always select a suggestion when automatically triggering IntelliSense."), m(0, "Never select a suggestion when automatically triggering IntelliSense."), m(0, "Select a suggestion only when triggering IntelliSense from a trigger character."), m(0, "Select a suggestion only when triggering IntelliSense as you type.")], default: n.selectionMode, markdownDescription: m(0, "Controls whether a suggestion is selected when the widget shows. Note that this only applies to automatically triggered suggestions (`#editor.quickSuggestions#` and `#editor.suggestOnTriggerCharacters#`) and that a suggestion is always selected when explicitly invoked, e.g via `Ctrl+Space`.") }, "editor.suggest.snippetsPreventQuickSuggestions": { type: "boolean", default: n.snippetsPreventQuickSuggestions, description: m(0, "Controls whether an active snippet prevents quick suggestions.") }, "editor.suggest.showIcons": { type: "boolean", default: n.showIcons, description: m(0, "Controls whether to show or hide icons in suggestions.") }, "editor.suggest.showStatusBar": { type: "boolean", default: n.showStatusBar, description: m(0, "Controls the visibility of the status bar at the bottom of the suggest widget.") }, "editor.suggest.preview": { type: "boolean", default: n.preview, description: m(0, "Controls whether to preview the suggestion outcome in the editor.") }, "editor.suggest.showInlineDetails": { type: "boolean", default: n.showInlineDetails, description: m(0, "Controls whether suggest details show inline with the label or only in the details widget.") }, "editor.suggest.maxVisibleSuggestions": { type: "number", deprecationMessage: m(0, "This setting is deprecated. The suggest widget can now be resized.") }, "editor.suggest.filteredTypes": { type: "object", deprecationMessage: m(0, "This setting is deprecated, please use separate settings like 'editor.suggest.showKeywords' or 'editor.suggest.showSnippets' instead.") }, "editor.suggest.showMethods": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `method`-suggestions.") }, "editor.suggest.showFunctions": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `function`-suggestions.") }, "editor.suggest.showConstructors": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `constructor`-suggestions.") }, "editor.suggest.showDeprecated": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `deprecated`-suggestions.") }, "editor.suggest.matchOnWordStartOnly": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense filtering requires that the first character matches on a word start. For example, `c` on `Console` or `WebContext` but _not_ on `description`. When disabled IntelliSense will show more results but still sorts them by match quality.") }, "editor.suggest.showFields": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `field`-suggestions.") }, "editor.suggest.showVariables": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `variable`-suggestions.") }, "editor.suggest.showClasses": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `class`-suggestions.") }, "editor.suggest.showStructs": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `struct`-suggestions.") }, "editor.suggest.showInterfaces": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `interface`-suggestions.") }, "editor.suggest.showModules": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `module`-suggestions.") }, "editor.suggest.showProperties": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `property`-suggestions.") }, "editor.suggest.showEvents": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `event`-suggestions.") }, "editor.suggest.showOperators": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `operator`-suggestions.") }, "editor.suggest.showUnits": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `unit`-suggestions.") }, "editor.suggest.showValues": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `value`-suggestions.") }, "editor.suggest.showConstants": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `constant`-suggestions.") }, "editor.suggest.showEnums": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `enum`-suggestions.") }, "editor.suggest.showEnumMembers": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `enumMember`-suggestions.") }, "editor.suggest.showKeywords": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `keyword`-suggestions.") }, "editor.suggest.showWords": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `text`-suggestions.") }, "editor.suggest.showColors": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `color`-suggestions.") }, "editor.suggest.showFiles": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `file`-suggestions.") }, "editor.suggest.showReferences": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `reference`-suggestions.") }, "editor.suggest.showCustomcolors": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `customcolor`-suggestions.") }, "editor.suggest.showFolders": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `folder`-suggestions.") }, "editor.suggest.showTypeParameters": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `typeParameter`-suggestions.") }, "editor.suggest.showSnippets": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `snippet`-suggestions.") }, "editor.suggest.showUsers": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `user`-suggestions.") }, "editor.suggest.showIssues": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `issues`-suggestions.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { insertMode: _i(e.insertMode, this.defaultValue.insertMode, ["insert", "replace"]), filterGraceful: ve(e.filterGraceful, this.defaultValue.filterGraceful), snippetsPreventQuickSuggestions: ve(e.snippetsPreventQuickSuggestions, this.defaultValue.filterGraceful), localityBonus: ve(e.localityBonus, this.defaultValue.localityBonus), shareSuggestSelections: ve(e.shareSuggestSelections, this.defaultValue.shareSuggestSelections), selectionMode: _i(e.selectionMode, this.defaultValue.selectionMode, ["always", "never", "whenQuickSuggestion", "whenTriggerCharacter"]), showIcons: ve(e.showIcons, this.defaultValue.showIcons), showStatusBar: ve(e.showStatusBar, this.defaultValue.showStatusBar), preview: ve(e.preview, this.defaultValue.preview), previewMode: _i(e.previewMode, this.defaultValue.previewMode, ["prefix", "subword", "subwordSmart"]), showInlineDetails: ve(e.showInlineDetails, this.defaultValue.showInlineDetails), showMethods: ve(e.showMethods, this.defaultValue.showMethods), showFunctions: ve(e.showFunctions, this.defaultValue.showFunctions), showConstructors: ve(e.showConstructors, this.defaultValue.showConstructors), showDeprecated: ve(e.showDeprecated, this.defaultValue.showDeprecated), matchOnWordStartOnly: ve(e.matchOnWordStartOnly, this.defaultValue.matchOnWordStartOnly), showFields: ve(e.showFields, this.defaultValue.showFields), showVariables: ve(e.showVariables, this.defaultValue.showVariables), showClasses: ve(e.showClasses, this.defaultValue.showClasses), showStructs: ve(e.showStructs, this.defaultValue.showStructs), showInterfaces: ve(e.showInterfaces, this.defaultValue.showInterfaces), showModules: ve(e.showModules, this.defaultValue.showModules), showProperties: ve(e.showProperties, this.defaultValue.showProperties), showEvents: ve(e.showEvents, this.defaultValue.showEvents), showOperators: ve(e.showOperators, this.defaultValue.showOperators), showUnits: ve(e.showUnits, this.defaultValue.showUnits), showValues: ve(e.showValues, this.defaultValue.showValues), showConstants: ve(e.showConstants, this.defaultValue.showConstants), showEnums: ve(e.showEnums, this.defaultValue.showEnums), showEnumMembers: ve(e.showEnumMembers, this.defaultValue.showEnumMembers), showKeywords: ve(e.showKeywords, this.defaultValue.showKeywords), showWords: ve(e.showWords, this.defaultValue.showWords), showColors: ve(e.showColors, this.defaultValue.showColors), showFiles: ve(e.showFiles, this.defaultValue.showFiles), showReferences: ve(e.showReferences, this.defaultValue.showReferences), showFolders: ve(e.showFolders, this.defaultValue.showFolders), showTypeParameters: ve(e.showTypeParameters, this.defaultValue.showTypeParameters), showSnippets: ve(e.showSnippets, this.defaultValue.showSnippets), showUsers: ve(e.showUsers, this.defaultValue.showUsers), showIssues: ve(e.showIssues, this.defaultValue.showIssues) };
  }
}()), inlineSuggest: J(new class extends Qt {
  constructor() {
    const n = { enabled: !0, mode: "subwordSmart", showToolbar: "onHover", suppressSuggestions: !1, keepOnBlur: !1, fontFamily: "default" };
    super(62, "inlineSuggest", n, { "editor.inlineSuggest.enabled": { type: "boolean", default: n.enabled, description: m(0, "Controls whether to automatically show inline suggestions in the editor.") }, "editor.inlineSuggest.showToolbar": { type: "string", default: n.showToolbar, enum: ["always", "onHover", "never"], enumDescriptions: [m(0, "Show the inline suggestion toolbar whenever an inline suggestion is shown."), m(0, "Show the inline suggestion toolbar when hovering over an inline suggestion."), m(0, "Never show the inline suggestion toolbar.")], description: m(0, "Controls when to show the inline suggestion toolbar.") }, "editor.inlineSuggest.suppressSuggestions": { type: "boolean", default: n.suppressSuggestions, description: m(0, "Controls how inline suggestions interact with the suggest widget. If enabled, the suggest widget is not shown automatically when inline suggestions are available.") }, "editor.inlineSuggest.fontFamily": { type: "string", default: n.fontFamily, description: m(0, "Controls the font family of the inline suggestions.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), mode: _i(e.mode, this.defaultValue.mode, ["prefix", "subword", "subwordSmart"]), showToolbar: _i(e.showToolbar, this.defaultValue.showToolbar, ["always", "onHover", "never"]), suppressSuggestions: ve(e.suppressSuggestions, this.defaultValue.suppressSuggestions), keepOnBlur: ve(e.keepOnBlur, this.defaultValue.keepOnBlur), fontFamily: ss.string(e.fontFamily, this.defaultValue.fontFamily) };
  }
}()), inlineEdit: J(new class extends Qt {
  constructor() {
    const n = { enabled: !1, showToolbar: "onHover", fontFamily: "default", keepOnBlur: !1, backgroundColoring: !1 };
    super(63, "experimentalInlineEdit", n, { "editor.experimentalInlineEdit.enabled": { type: "boolean", default: n.enabled, description: m(0, "Controls whether to show inline edits in the editor.") }, "editor.experimentalInlineEdit.showToolbar": { type: "string", default: n.showToolbar, enum: ["always", "onHover", "never"], enumDescriptions: [m(0, "Show the inline edit toolbar whenever an inline suggestion is shown."), m(0, "Show the inline edit toolbar when hovering over an inline suggestion."), m(0, "Never show the inline edit toolbar.")], description: m(0, "Controls when to show the inline edit toolbar.") }, "editor.experimentalInlineEdit.fontFamily": { type: "string", default: n.fontFamily, description: m(0, "Controls the font family of the inline edit.") }, "editor.experimentalInlineEdit.backgroundColoring": { type: "boolean", default: n.backgroundColoring, description: m(0, "Controls whether to color the background of inline edits.") } });
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), showToolbar: _i(e.showToolbar, this.defaultValue.showToolbar, ["always", "onHover", "never"]), fontFamily: ss.string(e.fontFamily, this.defaultValue.fontFamily), keepOnBlur: ve(e.keepOnBlur, this.defaultValue.keepOnBlur), backgroundColoring: ve(e.backgroundColoring, this.defaultValue.backgroundColoring) };
  }
}()), inlineCompletionsAccessibilityVerbose: J(new gt(149, "inlineCompletionsAccessibilityVerbose", !1, { description: m(0, "Controls whether the accessibility hint should be provided to screen reader users when an inline completion is shown.") })), suggestFontSize: J(new Ot(119, "suggestFontSize", 0, 0, 1e3, { markdownDescription: m(0, "Font size for the suggest widget. When set to {0}, the value of {1} is used.", "`0`", "`#editor.fontSize#`") })), suggestLineHeight: J(new Ot(120, "suggestLineHeight", 0, 0, 1e3, { markdownDescription: m(0, "Line height for the suggest widget. When set to {0}, the value of {1} is used. The minimum value is 8.", "`0`", "`#editor.lineHeight#`") })), suggestOnTriggerCharacters: J(new gt(121, "suggestOnTriggerCharacters", !0, { description: m(0, "Controls whether suggestions should automatically show up when typing trigger characters.") })), suggestSelection: J(new hi(122, "suggestSelection", "first", ["first", "recentlyUsed", "recentlyUsedByPrefix"], { markdownEnumDescriptions: [m(0, "Always select the first suggestion."), m(0, "Select recent suggestions unless further typing selects one, e.g. `console.| -> console.log` because `log` has been completed recently."), m(0, "Select suggestions based on previous prefixes that have completed those suggestions, e.g. `co -> console` and `con -> const`.")], description: m(0, "Controls how suggestions are pre-selected when showing the suggest list.") })), tabCompletion: J(new hi(123, "tabCompletion", "off", ["on", "off", "onlySnippets"], { enumDescriptions: [m(0, "Tab complete will insert the best matching suggestion when pressing tab."), m(0, "Disable tab completions."), m(0, "Tab complete snippets when their prefix match. Works best when 'quickSuggestions' aren't enabled.")], description: m(0, "Enables tab completions.") })), tabIndex: J(new Ot(124, "tabIndex", 0, -1, 1073741824)), unicodeHighlight: J(new class extends Qt {
  constructor() {
    const n = { nonBasicASCII: ro, invisibleCharacters: !0, ambiguousCharacters: !0, includeComments: ro, includeStrings: !0, allowedCharacters: {}, allowedLocales: { _os: !0, _vscode: !0 } };
    super(125, "unicodeHighlight", n, { [M7]: { restricted: !0, type: ["boolean", "string"], enum: [!0, !1, ro], default: n.nonBasicASCII, description: m(0, "Controls whether all non-basic ASCII characters are highlighted. Only characters between U+0020 and U+007E, tab, line-feed and carriage-return are considered basic ASCII.") }, [I7]: { restricted: !0, type: "boolean", default: n.invisibleCharacters, description: m(0, "Controls whether characters that just reserve space or have no width at all are highlighted.") }, [T7]: { restricted: !0, type: "boolean", default: n.ambiguousCharacters, description: m(0, "Controls whether characters are highlighted that can be confused with basic ASCII characters, except those that are common in the current user locale.") }, [R7]: { restricted: !0, type: ["boolean", "string"], enum: [!0, !1, ro], default: n.includeComments, description: m(0, "Controls whether characters in comments should also be subject to Unicode highlighting.") }, [A7]: { restricted: !0, type: ["boolean", "string"], enum: [!0, !1, ro], default: n.includeStrings, description: m(0, "Controls whether characters in strings should also be subject to Unicode highlighting.") }, [LN]: { restricted: !0, type: "object", default: n.allowedCharacters, description: m(0, "Defines allowed characters that are not being highlighted."), additionalProperties: { type: "boolean" } }, [kN]: { restricted: !0, type: "object", additionalProperties: { type: "boolean" }, default: n.allowedLocales, description: m(0, "Unicode characters that are common in allowed locales are not being highlighted.") } });
  }
  applyUpdate(n, e) {
    let t = !1;
    e.allowedCharacters && n && (So(n.allowedCharacters, e.allowedCharacters) || (n = { ...n, allowedCharacters: e.allowedCharacters }, t = !0)), e.allowedLocales && n && (So(n.allowedLocales, e.allowedLocales) || (n = { ...n, allowedLocales: e.allowedLocales }, t = !0));
    const i = super.applyUpdate(n, e);
    return t ? new q_(i.newValue, !0) : i;
  }
  validate(n) {
    if (!n || typeof n != "object") return this.defaultValue;
    const e = n;
    return { nonBasicASCII: Bg(e.nonBasicASCII, ro, [!0, !1, ro]), invisibleCharacters: ve(e.invisibleCharacters, this.defaultValue.invisibleCharacters), ambiguousCharacters: ve(e.ambiguousCharacters, this.defaultValue.ambiguousCharacters), includeComments: Bg(e.includeComments, ro, [!0, !1, ro]), includeStrings: Bg(e.includeStrings, ro, [!0, !1, ro]), allowedCharacters: this.validateBooleanMap(n.allowedCharacters, this.defaultValue.allowedCharacters), allowedLocales: this.validateBooleanMap(n.allowedLocales, this.defaultValue.allowedLocales) };
  }
  validateBooleanMap(n, e) {
    if (typeof n != "object" || !n) return e;
    const t = {};
    for (const [i, s] of Object.entries(n)) s === !0 && (t[i] = !0);
    return t;
  }
}()), unusualLineTerminators: J(new hi(126, "unusualLineTerminators", "prompt", ["auto", "off", "prompt"], { enumDescriptions: [m(0, "Unusual line terminators are automatically removed."), m(0, "Unusual line terminators are ignored."), m(0, "Unusual line terminators prompt to be removed.")], description: m(0, "Remove unusual line terminators that might cause problems.") })), useShadowDOM: J(new gt(127, "useShadowDOM", !0)), useTabStops: J(new gt(128, "useTabStops", !0, { description: m(0, "Spaces and tabs are inserted and deleted in alignment with tab stops.") })), wordBreak: J(new hi(129, "wordBreak", "normal", ["normal", "keepAll"], { markdownEnumDescriptions: [m(0, "Use the default line break rule."), m(0, "Word breaks should not be used for Chinese/Japanese/Korean (CJK) text. Non-CJK text behavior is the same as for normal.")], description: m(0, "Controls the word break rules used for Chinese/Japanese/Korean (CJK) text.") })), wordSegmenterLocales: J(new class extends Qt {
  constructor() {
    super(130, "wordSegmenterLocales", [], { anyOf: [{ description: m(0, "Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.)."), type: "string" }, { description: m(0, "Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.)."), type: "array", items: { type: "string" } }] });
  }
  validate(n) {
    if (typeof n == "string" && (n = [n]), Array.isArray(n)) {
      const e = [];
      for (const t of n) if (typeof t == "string") try {
        Intl.Segmenter.supportedLocalesOf(t).length > 0 && e.push(t);
      } catch {
      }
      return e;
    }
    return this.defaultValue;
  }
}()), wordSeparators: J(new ss(131, "wordSeparators", D7, { description: m(0, "Characters that will be used as word separators when doing word related navigations or operations.") })), wordWrap: J(new hi(132, "wordWrap", "off", ["off", "on", "wordWrapColumn", "bounded"], { markdownEnumDescriptions: [m(0, "Lines will never wrap."), m(0, "Lines will wrap at the viewport width."), m(0, "Lines will wrap at `#editor.wordWrapColumn#`."), m(0, "Lines will wrap at the minimum of viewport and `#editor.wordWrapColumn#`.")], description: m(0, "Controls how lines should wrap.") })), wordWrapBreakAfterCharacters: J(new ss(133, "wordWrapBreakAfterCharacters", " 	})]?|/&.,;¢°′″‰℃、。｡､￠，．：；？！％・･ゝゞヽヾーァィゥェォッャュョヮヵヶぁぃぅぇぉっゃゅょゎゕゖㇰㇱㇲㇳㇴㇵㇶㇷㇸㇹㇺㇻㇼㇽㇾㇿ々〻ｧｨｩｪｫｬｭｮｯｰ”〉》」』】〕）］｝｣")), wordWrapBreakBeforeCharacters: J(new ss(134, "wordWrapBreakBeforeCharacters", "([{‘“〈《「『【〔（［｛｢£¥＄￡￥+＋")), wordWrapColumn: J(new Ot(135, "wordWrapColumn", 80, 1, 1073741824, { markdownDescription: m(0, "Controls the wrapping column of the editor when `#editor.wordWrap#` is `wordWrapColumn` or `bounded`.") })), wordWrapOverride1: J(new hi(136, "wordWrapOverride1", "inherit", ["off", "on", "inherit"])), wordWrapOverride2: J(new hi(137, "wordWrapOverride2", "inherit", ["off", "on", "inherit"])), editorClassName: J(new class extends d_ {
  constructor() {
    super(142);
  }
  compute(n, e, t) {
    const i = ["monaco-editor"];
    return e.get(39) && i.push(e.get(39)), n.extraEditorClassName && i.push(n.extraEditorClassName), e.get(74) === "default" ? i.push("mouse-default") : e.get(74) === "copy" && i.push("mouse-copy"), e.get(111) && i.push("showUnused"), e.get(140) && i.push("showDeprecated"), i.join(" ");
  }
}()), defaultColorDecorators: J(new gt(147, "defaultColorDecorators", !1, { markdownDescription: m(0, "Controls whether inline color decorations should be shown using the default document color provider") })), pixelRatio: J(new class extends d_ {
  constructor() {
    super(143);
  }
  compute(n, e, t) {
    return n.pixelRatio;
  }
}()), tabFocusMode: J(new gt(144, "tabFocusMode", !1, { markdownDescription: m(0, "Controls whether the editor receives tabs or defers them to the workbench for navigation.") })), layoutInfo: J(new Zp()), wrappingInfo: J(new class extends d_ {
  constructor() {
    super(146);
  }
  compute(n, e, t) {
    const i = e.get(145);
    return { isDominatedByLongLines: n.isDominatedByLongLines, isWordWrapMinified: i.isWordWrapMinified, isViewportWrapping: i.isViewportWrapping, wrappingColumn: i.wrappingColumn };
  }
}()), wrappingIndent: J(new class extends Qt {
  constructor() {
    super(138, "wrappingIndent", 1, { "editor.wrappingIndent": { type: "string", enum: ["none", "same", "indent", "deepIndent"], enumDescriptions: [m(0, "No indentation. Wrapped lines begin at column 1."), m(0, "Wrapped lines get the same indentation as the parent."), m(0, "Wrapped lines get +1 indentation toward the parent."), m(0, "Wrapped lines get +2 indentation toward the parent.")], description: m(0, "Controls the indentation of wrapped lines."), default: "same" } });
  }
  validate(n) {
    switch (n) {
      case "none":
        return 0;
      case "same":
        return 1;
      case "indent":
        return 2;
      case "deepIndent":
        return 3;
    }
    return 1;
  }
  compute(n, e, t) {
    return e.get(2) === 2 ? 0 : t;
  }
}()), wrappingStrategy: J(new class extends Qt {
  constructor() {
    super(139, "wrappingStrategy", "simple", { "editor.wrappingStrategy": { enumDescriptions: [m(0, "Assumes that all characters are of the same width. This is a fast algorithm that works correctly for monospace fonts and certain scripts (like Latin characters) where glyphs are of equal width."), m(0, "Delegates wrapping points computation to the browser. This is a slow algorithm, that might cause freezes for large files, but it works correctly in all cases.")], type: "string", enum: ["simple", "advanced"], default: "simple", description: m(0, "Controls the algorithm that computes wrapping points. Note that when in accessibility mode, advanced will be used for the best experience.") } });
  }
  validate(n) {
    return _i(n, "simple", ["simple", "advanced"]);
  }
  compute(n, e, t) {
    return e.get(2) === 2 ? "advanced" : t;
  }
}()) }, P7 = new class {
  constructor() {
    this.listeners = [], this.unexpectedErrorHandler = function(n) {
      setTimeout((() => {
        throw n.stack ? Rm.isErrorNoTelemetry(n) ? new Rm(n.message + `

` + n.stack) : new Error(n.message + `

` + n.stack) : n;
      }), 0);
    };
  }
  emit(n) {
    this.listeners.forEach(((e) => {
      e(n);
    }));
  }
  onUnexpectedError(n) {
    this.unexpectedErrorHandler(n), this.emit(n);
  }
  onUnexpectedExternalError(n) {
    this.unexpectedErrorHandler(n);
  }
}();
function We(n) {
  ya(n) || P7.onUnexpectedError(n);
}
function Ni(n) {
  ya(n) || P7.onUnexpectedExternalError(n);
}
function iO(n) {
  if (n instanceof Error) {
    const { name: e, message: t } = n;
    return { $isError: !0, name: e, message: t, stack: n.stacktrace || n.stack, noTelemetry: Rm.isErrorNoTelemetry(n) };
  }
  return n;
}
const Ew = "Canceled";
function ya(n) {
  return n instanceof Vd || n instanceof Error && n.name === Ew && n.message === Ew;
}
class Vd extends Error {
  constructor() {
    super(Ew), this.name = this.message;
  }
}
function Yo(n) {
  return n ? new Error(`Illegal argument: ${n}`) : new Error("Illegal argument");
}
function ZT(n) {
  return n ? new Error(`Illegal state: ${n}`) : new Error("Illegal state");
}
class tK extends Error {
  constructor(e) {
    super("NotSupported"), e && (this.message = e);
  }
}
class Rm extends Error {
  constructor(e) {
    super(e), this.name = "CodeExpectedError";
  }
  static fromError(e) {
    if (e instanceof Rm) return e;
    const t = new Rm();
    return t.message = e.message, t.stack = e.stack, t;
  }
  static isErrorNoTelemetry(e) {
    return e.name === "CodeExpectedError";
  }
}
class Kt extends Error {
  constructor(e) {
    super(e || "An unexpected bug occurred."), Object.setPrototypeOf(this, Kt.prototype);
  }
}
function pc(n, e) {
  const t = this;
  let i, s = !1;
  return function() {
    return s || (s = !0, i = n.apply(t, arguments)), i;
  };
}
function YT(n) {
  return typeof n.dispose == "function" && n.dispose.length === 0;
}
function Ht(n) {
  if (at.is(n)) {
    const e = [];
    for (const t of n) if (t) try {
      t.dispose();
    } catch (i) {
      e.push(i);
    }
    if (e.length === 1) throw e[0];
    if (e.length > 1) throw new AggregateError(e, "Encountered errors while disposing of store");
    return Array.isArray(n) ? [] : n;
  }
  if (n) return n.dispose(), n;
}
function yr(...n) {
  return ye((() => Ht(n)));
}
function ye(n) {
  return { dispose: pc((() => {
    n();
  })) };
}
class G {
  constructor() {
    this._toDispose = /* @__PURE__ */ new Set(), this._isDisposed = !1;
  }
  dispose() {
    this._isDisposed || (this._isDisposed = !0, this.clear());
  }
  get isDisposed() {
    return this._isDisposed;
  }
  clear() {
    if (this._toDispose.size !== 0) try {
      Ht(this._toDispose);
    } finally {
      this._toDispose.clear();
    }
  }
  add(e) {
    if (!e) return e;
    if (e === this) throw new Error("Cannot register a disposable on itself!");
    return this._isDisposed ? G.DISABLE_DISPOSED_WARNING || console.warn(new Error("Trying to add a disposable to a DisposableStore that has already been disposed of. The added object will be leaked!").stack) : this._toDispose.add(e), e;
  }
  deleteAndLeak(e) {
    e && this._toDispose.has(e) && this._toDispose.delete(e);
  }
}
G.DISABLE_DISPOSED_WARNING = !1;
class V {
  constructor() {
    this._store = new G(), this._store;
  }
  dispose() {
    this._store.dispose();
  }
  _register(e) {
    if (e === this) throw new Error("Cannot register a disposable on itself!");
    return this._store.add(e);
  }
}
V.None = Object.freeze({ dispose() {
} });
class rn {
  constructor() {
    this._isDisposed = !1;
  }
  get value() {
    return this._isDisposed ? void 0 : this._value;
  }
  set value(e) {
    var t;
    this._isDisposed || e === this._value || ((t = this._value) === null || t === void 0 || t.dispose(), this._value = e);
  }
  clear() {
    this.value = void 0;
  }
  dispose() {
    var e;
    this._isDisposed = !0, (e = this._value) === null || e === void 0 || e.dispose(), this._value = void 0;
  }
}
class iK {
  constructor(e) {
    this._disposable = e, this._counter = 1;
  }
  acquire() {
    return this._counter++, this;
  }
  release() {
    return --this._counter == 0 && this._disposable.dispose(), this;
  }
}
class nK {
  constructor(e) {
    this.object = e;
  }
  dispose() {
  }
}
class XT {
  constructor() {
    this._store = /* @__PURE__ */ new Map(), this._isDisposed = !1;
  }
  dispose() {
    this._isDisposed = !0, this.clearAndDisposeAll();
  }
  clearAndDisposeAll() {
    if (this._store.size) try {
      Ht(this._store.values());
    } finally {
      this._store.clear();
    }
  }
  get(e) {
    return this._store.get(e);
  }
  set(e, t, i = !1) {
    var s;
    this._isDisposed && console.warn(new Error("Trying to add a disposable to a DisposableMap that has already been disposed of. The added object will be leaked!").stack), i || (s = this._store.get(e)) === null || s === void 0 || s.dispose(), this._store.set(e, t);
  }
  deleteAndDispose(e) {
    var t;
    (t = this._store.get(e)) === null || t === void 0 || t.dispose(), this._store.delete(e);
  }
  [Symbol.iterator]() {
    return this._store[Symbol.iterator]();
  }
}
const sK = globalThis.performance && typeof globalThis.performance.now == "function";
class Rn {
  static create(e) {
    return new Rn(e);
  }
  constructor(e) {
    this._now = sK && e === !1 ? Date.now : globalThis.performance.now.bind(globalThis.performance), this._startTime = this._now(), this._stopTime = -1;
  }
  stop() {
    this._stopTime = this._now();
  }
  reset() {
    this._startTime = this._now(), this._stopTime = -1;
  }
  elapsed() {
    return this._stopTime !== -1 ? this._stopTime - this._startTime : this._now() - this._startTime;
  }
}
var se;
(function(n) {
  function e(d) {
    return (h, c = null, u) => {
      let g, p = !1;
      return g = d(((f) => {
        if (!p) return g ? g.dispose() : p = !0, h.call(c, f);
      }), null, u), p && g.dispose(), g;
    };
  }
  function t(d, h, c) {
    return s(((u, g = null, p) => d(((f) => u.call(g, h(f))), null, p)), c);
  }
  function i(d, h, c) {
    return s(((u, g = null, p) => d(((f) => h(f) && u.call(g, f)), null, p)), c);
  }
  function s(d, h) {
    let c;
    const u = new F({ onWillAddFirstListener() {
      c = d(u.fire, u);
    }, onDidRemoveLastListener() {
      c?.dispose();
    } });
    return h?.add(u), u.event;
  }
  function o(d, h, c = 100, u = !1, g = !1, p, f) {
    let _, v, b, C, w = 0;
    const y = new F({ leakWarningThreshold: p, onWillAddFirstListener() {
      _ = d(((L) => {
        w++, v = h(v, L), u && !b && (y.fire(v), v = void 0), C = () => {
          const k = v;
          v = void 0, b = void 0, (!u || w > 1) && y.fire(k), w = 0;
        }, typeof c == "number" ? (clearTimeout(b), b = setTimeout(C, c)) : b === void 0 && (b = 0, queueMicrotask(C));
      }));
    }, onWillRemoveListener() {
      g && w > 0 && C?.();
    }, onDidRemoveLastListener() {
      C = void 0, _.dispose();
    } });
    return f?.add(y), y.event;
  }
  n.None = () => V.None, n.defer = function(d, h) {
    return o(d, (() => {
    }), 0, void 0, !0, void 0, h);
  }, n.once = e, n.map = t, n.forEach = function(d, h, c) {
    return s(((u, g = null, p) => d(((f) => {
      h(f), u.call(g, f);
    }), null, p)), c);
  }, n.filter = i, n.signal = function(d) {
    return d;
  }, n.any = function(...d) {
    return (h, c = null, u) => (function(g, p) {
      return p instanceof Array ? p.push(g) : p && p.add(g), g;
    })(yr(...d.map(((g) => g(((p) => h.call(c, p)))))), u);
  }, n.reduce = function(d, h, c, u) {
    let g = c;
    return t(d, ((p) => (g = h(g, p), g)), u);
  }, n.debounce = o, n.accumulate = function(d, h = 0, c) {
    return n.debounce(d, ((u, g) => u ? (u.push(g), u) : [g]), h, void 0, !0, void 0, c);
  }, n.latch = function(d, h = ((u, g) => u === g), c) {
    let u, g = !0;
    return i(d, ((p) => {
      const f = g || !h(p, u);
      return g = !1, u = p, f;
    }), c);
  }, n.split = function(d, h, c) {
    return [n.filter(d, h, c), n.filter(d, ((u) => !h(u)), c)];
  }, n.buffer = function(d, h = !1, c = [], u) {
    let g = c.slice(), p = d(((v) => {
      g ? g.push(v) : _.fire(v);
    }));
    u && u.add(p);
    const f = () => {
      g?.forEach(((v) => _.fire(v))), g = null;
    }, _ = new F({ onWillAddFirstListener() {
      p || (p = d(((v) => _.fire(v))), u && u.add(p));
    }, onDidAddFirstListener() {
      g && (h ? setTimeout(f) : f());
    }, onDidRemoveLastListener() {
      p && p.dispose(), p = null;
    } });
    return u && u.add(_), _.event;
  }, n.chain = function(d, h) {
    return (c, u, g) => {
      const p = h(new a());
      return d((function(f) {
        const _ = p.evaluate(f);
        _ !== r && c.call(u, _);
      }), void 0, g);
    };
  };
  const r = Symbol("HaltChainable");
  class a {
    constructor() {
      this.steps = [];
    }
    map(h) {
      return this.steps.push(h), this;
    }
    forEach(h) {
      return this.steps.push(((c) => (h(c), c))), this;
    }
    filter(h) {
      return this.steps.push(((c) => h(c) ? c : r)), this;
    }
    reduce(h, c) {
      let u = c;
      return this.steps.push(((g) => (u = h(u, g), u))), this;
    }
    latch(h = ((c, u) => c === u)) {
      let c, u = !0;
      return this.steps.push(((g) => {
        const p = u || !h(g, c);
        return u = !1, c = g, p ? g : r;
      })), this;
    }
    evaluate(h) {
      for (const c of this.steps) if ((h = c(h)) === r) break;
      return h;
    }
  }
  n.fromNodeEventEmitter = function(d, h, c = ((u) => u)) {
    const u = (...p) => g.fire(c(...p)), g = new F({ onWillAddFirstListener: () => d.on(h, u), onDidRemoveLastListener: () => d.removeListener(h, u) });
    return g.event;
  }, n.fromDOMEventEmitter = function(d, h, c = ((u) => u)) {
    const u = (...p) => g.fire(c(...p)), g = new F({ onWillAddFirstListener: () => d.addEventListener(h, u), onDidRemoveLastListener: () => d.removeEventListener(h, u) });
    return g.event;
  }, n.toPromise = function(d) {
    return new Promise(((h) => e(d)(h)));
  }, n.fromPromise = function(d) {
    const h = new F();
    return d.then(((c) => {
      h.fire(c);
    }), (() => {
      h.fire(void 0);
    })).finally((() => {
      h.dispose();
    })), h.event;
  }, n.runAndSubscribe = function(d, h, c) {
    return h(c), d(((u) => h(u)));
  };
  class l {
    constructor(h, c) {
      this._observable = h, this._counter = 0, this._hasChanged = !1;
      const u = { onWillAddFirstListener: () => {
        h.addObserver(this);
      }, onDidRemoveLastListener: () => {
        h.removeObserver(this);
      } };
      this.emitter = new F(u), c && c.add(this.emitter);
    }
    beginUpdate(h) {
      this._counter++;
    }
    handlePossibleChange(h) {
    }
    handleChange(h, c) {
      this._hasChanged = !0;
    }
    endUpdate(h) {
      this._counter--, this._counter === 0 && (this._observable.reportChanges(), this._hasChanged && (this._hasChanged = !1, this.emitter.fire(this._observable.get())));
    }
  }
  n.fromObservable = function(d, h) {
    return new l(d, h).emitter.event;
  }, n.fromObservableLight = function(d) {
    return (h, c, u) => {
      let g = 0, p = !1;
      const f = { beginUpdate() {
        g++;
      }, endUpdate() {
        g--, g === 0 && (d.reportChanges(), p && (p = !1, h.call(c)));
      }, handlePossibleChange() {
      }, handleChange() {
        p = !0;
      } };
      d.addObserver(f), d.reportChanges();
      const _ = { dispose() {
        d.removeObserver(f);
      } };
      return u instanceof G ? u.add(_) : Array.isArray(u) && u.push(_), _;
    };
  };
})(se || (se = {}));
class Am {
  constructor(e) {
    this.listenerCount = 0, this.invocationCount = 0, this.elapsedOverall = 0, this.durations = [], this.name = `${e}_${Am._idPool++}`, Am.all.add(this);
  }
  start(e) {
    this._stopWatch = new Rn(), this.listenerCount = e;
  }
  stop() {
    if (this._stopWatch) {
      const e = this._stopWatch.elapsed();
      this.durations.push(e), this.elapsedOverall += e, this.invocationCount += 1, this._stopWatch = void 0;
    }
  }
}
Am.all = /* @__PURE__ */ new Set(), Am._idPool = 0;
class oK {
  constructor(e, t = Math.random().toString(18).slice(2, 5)) {
    this.threshold = e, this.name = t, this._warnCountdown = 0;
  }
  dispose() {
    var e;
    (e = this._stacks) === null || e === void 0 || e.clear();
  }
  check(e, t) {
    const i = this.threshold;
    if (i <= 0 || t < i) return;
    this._stacks || (this._stacks = /* @__PURE__ */ new Map());
    const s = this._stacks.get(e.value) || 0;
    if (this._stacks.set(e.value, s + 1), this._warnCountdown -= 1, this._warnCountdown <= 0) {
      let o;
      this._warnCountdown = 0.5 * i;
      let r = 0;
      for (const [a, l] of this._stacks) (!o || r < l) && (o = a, r = l);
      console.warn(`[${this.name}] potential listener LEAK detected, having ${t} listeners already. MOST frequent listener (${r}):`), console.warn(o);
    }
    return () => {
      const o = this._stacks.get(e.value) || 0;
      this._stacks.set(e.value, o - 1);
    };
  }
}
class QT {
  static create() {
    var e;
    return new QT((e = new Error().stack) !== null && e !== void 0 ? e : "");
  }
  constructor(e) {
    this.value = e;
  }
  print() {
    console.warn(this.value.split(`
`).slice(2).join(`
`));
  }
}
class Ik {
  constructor(e) {
    this.value = e;
  }
}
let F = class {
  constructor(n) {
    var e, t, i, s, o;
    this._size = 0, this._options = n, this._leakageMon = !((e = this._options) === null || e === void 0) && e.leakWarningThreshold ? new oK((i = (t = this._options) === null || t === void 0 ? void 0 : t.leakWarningThreshold) !== null && i !== void 0 ? i : -1) : void 0, this._perfMon = !((s = this._options) === null || s === void 0) && s._profName ? new Am(this._options._profName) : void 0, this._deliveryQueue = (o = this._options) === null || o === void 0 ? void 0 : o.deliveryQueue;
  }
  dispose() {
    var n, e, t, i;
    this._disposed || (this._disposed = !0, ((n = this._deliveryQueue) === null || n === void 0 ? void 0 : n.current) === this && this._deliveryQueue.reset(), this._listeners && (this._listeners = void 0, this._size = 0), (t = (e = this._options) === null || e === void 0 ? void 0 : e.onDidRemoveLastListener) === null || t === void 0 || t.call(e), (i = this._leakageMon) === null || i === void 0 || i.dispose());
  }
  get event() {
    var n;
    return (n = this._event) !== null && n !== void 0 || (this._event = (e, t, i) => {
      var s, o, r, a, l;
      if (this._leakageMon && this._size > 3 * this._leakageMon.threshold) return console.warn(`[${this._leakageMon.name}] REFUSES to accept new listeners because it exceeded its threshold by far`), V.None;
      if (this._disposed) return V.None;
      t && (e = e.bind(t));
      const d = new Ik(e);
      let h;
      this._leakageMon && this._size >= Math.ceil(0.2 * this._leakageMon.threshold) && (d.stack = QT.create(), h = this._leakageMon.check(d.stack, this._size + 1)), this._listeners ? this._listeners instanceof Ik ? ((l = this._deliveryQueue) !== null && l !== void 0 || (this._deliveryQueue = new O7()), this._listeners = [this._listeners, d]) : this._listeners.push(d) : ((o = (s = this._options) === null || s === void 0 ? void 0 : s.onWillAddFirstListener) === null || o === void 0 || o.call(s, this), this._listeners = d, (a = (r = this._options) === null || r === void 0 ? void 0 : r.onDidAddFirstListener) === null || a === void 0 || a.call(r, this)), this._size++;
      const c = ye((() => {
        h?.(), this._removeListener(d);
      }));
      return i instanceof G ? i.add(c) : Array.isArray(i) && i.push(c), c;
    }), this._event;
  }
  _removeListener(n) {
    var e, t, i, s;
    if ((t = (e = this._options) === null || e === void 0 ? void 0 : e.onWillRemoveListener) === null || t === void 0 || t.call(e, this), !this._listeners) return;
    if (this._size === 1) return this._listeners = void 0, (s = (i = this._options) === null || i === void 0 ? void 0 : i.onDidRemoveLastListener) === null || s === void 0 || s.call(i, this), void (this._size = 0);
    const o = this._listeners, r = o.indexOf(n);
    if (r === -1) throw console.log("disposed?", this._disposed), console.log("size?", this._size), console.log("arr?", JSON.stringify(this._listeners)), new Error("Attempted to dispose unknown listener");
    this._size--, o[r] = void 0;
    const a = this._deliveryQueue.current === this;
    if (2 * this._size <= o.length) {
      let l = 0;
      for (let d = 0; d < o.length; d++) o[d] ? o[l++] = o[d] : a && (this._deliveryQueue.end--, l < this._deliveryQueue.i && this._deliveryQueue.i--);
      o.length = l;
    }
  }
  _deliver(n, e) {
    var t;
    if (!n) return;
    const i = ((t = this._options) === null || t === void 0 ? void 0 : t.onListenerError) || We;
    if (i) try {
      n.value(e);
    } catch (s) {
      i(s);
    }
    else n.value(e);
  }
  _deliverQueue(n) {
    const e = n.current._listeners;
    for (; n.i < n.end; ) this._deliver(e[n.i++], n.value);
    n.reset();
  }
  fire(n) {
    var e, t, i, s;
    if (!((e = this._deliveryQueue) === null || e === void 0) && e.current && (this._deliverQueue(this._deliveryQueue), (t = this._perfMon) === null || t === void 0 || t.stop()), (i = this._perfMon) === null || i === void 0 || i.start(this._size), this._listeners) if (this._listeners instanceof Ik) this._deliver(this._listeners, n);
    else {
      const o = this._deliveryQueue;
      o.enqueue(this, n, this._listeners.length), this._deliverQueue(o);
    }
    (s = this._perfMon) === null || s === void 0 || s.stop();
  }
  hasListeners() {
    return this._size > 0;
  }
};
class O7 {
  constructor() {
    this.i = -1, this.end = 0;
  }
  enqueue(e, t, i) {
    this.i = 0, this.end = i, this.current = e, this.value = t;
  }
  reset() {
    this.i = this.end, this.current = void 0, this.value = void 0;
  }
}
class ng extends F {
  constructor(e) {
    super(e), this._isPaused = 0, this._eventQueue = new fs(), this._mergeFn = e?.merge;
  }
  pause() {
    this._isPaused++;
  }
  resume() {
    if (this._isPaused !== 0 && --this._isPaused == 0) if (this._mergeFn) {
      if (this._eventQueue.size > 0) {
        const e = Array.from(this._eventQueue);
        this._eventQueue.clear(), super.fire(this._mergeFn(e));
      }
    } else for (; !this._isPaused && this._eventQueue.size !== 0; ) super.fire(this._eventQueue.shift());
  }
  fire(e) {
    this._size && (this._isPaused !== 0 ? this._eventQueue.push(e) : super.fire(e));
  }
}
class F7 extends ng {
  constructor(e) {
    var t;
    super(e), this._delay = (t = e.delay) !== null && t !== void 0 ? t : 100;
  }
  fire(e) {
    this._handle || (this.pause(), this._handle = setTimeout((() => {
      this._handle = void 0, this.resume();
    }), this._delay)), super.fire(e);
  }
}
class rK extends F {
  constructor(e) {
    super(e), this._queuedEvents = [], this._mergeFn = e?.merge;
  }
  fire(e) {
    this.hasListeners() && (this._queuedEvents.push(e), this._queuedEvents.length === 1 && queueMicrotask((() => {
      this._mergeFn ? super.fire(this._mergeFn(this._queuedEvents)) : this._queuedEvents.forEach(((t) => super.fire(t))), this._queuedEvents = [];
    })));
  }
}
class aK {
  constructor() {
    this.hasListeners = !1, this.events = [], this.emitter = new F({ onWillAddFirstListener: () => this.onFirstListenerAdd(), onDidRemoveLastListener: () => this.onLastListenerRemove() });
  }
  get event() {
    return this.emitter.event;
  }
  add(e) {
    const t = { event: e, listener: null };
    return this.events.push(t), this.hasListeners && this.hook(t), ye(pc((() => {
      this.hasListeners && this.unhook(t);
      const i = this.events.indexOf(t);
      this.events.splice(i, 1);
    })));
  }
  onFirstListenerAdd() {
    this.hasListeners = !0, this.events.forEach(((e) => this.hook(e)));
  }
  onLastListenerRemove() {
    this.hasListeners = !1, this.events.forEach(((e) => this.unhook(e)));
  }
  hook(e) {
    e.listener = e.event(((t) => this.emitter.fire(t)));
  }
  unhook(e) {
    var t;
    (t = e.listener) === null || t === void 0 || t.dispose(), e.listener = null;
  }
  dispose() {
    var e;
    this.emitter.dispose();
    for (const t of this.events) (e = t.listener) === null || e === void 0 || e.dispose();
    this.events = [];
  }
}
class JT {
  constructor() {
    this.buffers = [];
  }
  wrapEvent(e) {
    return (t, i, s) => e(((o) => {
      const r = this.buffers[this.buffers.length - 1];
      r ? r.push((() => t.call(i, o))) : t.call(i, o);
    }), void 0, s);
  }
  bufferEvents(e) {
    const t = [];
    this.buffers.push(t);
    const i = e();
    return this.buffers.pop(), t.forEach(((s) => s())), i;
  }
}
class nO {
  constructor() {
    this.listening = !1, this.inputEvent = se.None, this.inputEventListener = V.None, this.emitter = new F({ onDidAddFirstListener: () => {
      this.listening = !0, this.inputEventListener = this.inputEvent(this.emitter.fire, this.emitter);
    }, onDidRemoveLastListener: () => {
      this.listening = !1, this.inputEventListener.dispose();
    } }), this.event = this.emitter.event;
  }
  set input(e) {
    this.inputEvent = e, this.listening && (this.inputEventListener.dispose(), this.inputEventListener = e(this.emitter.fire, this.emitter));
  }
  dispose() {
    this.inputEventListener.dispose(), this.emitter.dispose();
  }
}
const B7 = Object.freeze((function(n, e) {
  const t = setTimeout(n.bind(e), 0);
  return { dispose() {
    clearTimeout(t);
  } };
}));
var et;
(function(n) {
  n.isCancellationToken = function(e) {
    return e === n.None || e === n.Cancelled || e instanceof DC || !(!e || typeof e != "object") && typeof e.isCancellationRequested == "boolean" && typeof e.onCancellationRequested == "function";
  }, n.None = Object.freeze({ isCancellationRequested: !1, onCancellationRequested: se.None }), n.Cancelled = Object.freeze({ isCancellationRequested: !0, onCancellationRequested: B7 });
})(et || (et = {}));
class DC {
  constructor() {
    this._isCancelled = !1, this._emitter = null;
  }
  cancel() {
    this._isCancelled || (this._isCancelled = !0, this._emitter && (this._emitter.fire(void 0), this.dispose()));
  }
  get isCancellationRequested() {
    return this._isCancelled;
  }
  get onCancellationRequested() {
    return this._isCancelled ? B7 : (this._emitter || (this._emitter = new F()), this._emitter.event);
  }
  dispose() {
    this._emitter && (this._emitter.dispose(), this._emitter = null);
  }
}
let Ci = class {
  constructor(n) {
    this._token = void 0, this._parentListener = void 0, this._parentListener = n && n.onCancellationRequested(this.cancel, this);
  }
  get token() {
    return this._token || (this._token = new DC()), this._token;
  }
  cancel() {
    this._token ? this._token instanceof DC && this._token.cancel() : this._token = et.Cancelled;
  }
  dispose(n = !1) {
    var e;
    n && this.cancel(), (e = this._parentListener) === null || e === void 0 || e.dispose(), this._token ? this._token instanceof DC && this._token.dispose() : this._token = et.None;
  }
};
class eR {
  constructor() {
    this._keyCodeToStr = [], this._strToKeyCode = /* @__PURE__ */ Object.create(null);
  }
  define(e, t) {
    this._keyCodeToStr[e] = t, this._strToKeyCode[t.toLowerCase()] = e;
  }
  keyCodeToStr(e) {
    return this._keyCodeToStr[e];
  }
  strToKeyCode(e) {
    return this._strToKeyCode[e.toLowerCase()] || 0;
  }
}
const G1 = new eR(), Mk = new eR(), Tk = new eR(), W7 = new Array(230), lK = /* @__PURE__ */ Object.create(null), dK = /* @__PURE__ */ Object.create(null), tR = [];
for (let n = 0; n <= 193; n++) tR[n] = -1;
var Yl;
function Vi(n, e) {
  return (n | (65535 & e) << 16 >>> 0) >>> 0;
}
let j0;
(function() {
  const e = [[1, 0, "None", 0, "unknown", 0, "VK_UNKNOWN", "", ""], [1, 1, "Hyper", 0, "", 0, "", "", ""], [1, 2, "Super", 0, "", 0, "", "", ""], [1, 3, "Fn", 0, "", 0, "", "", ""], [1, 4, "FnLock", 0, "", 0, "", "", ""], [1, 5, "Suspend", 0, "", 0, "", "", ""], [1, 6, "Resume", 0, "", 0, "", "", ""], [1, 7, "Turbo", 0, "", 0, "", "", ""], [1, 8, "Sleep", 0, "", 0, "VK_SLEEP", "", ""], [1, 9, "WakeUp", 0, "", 0, "", "", ""], [0, 10, "KeyA", 31, "A", 65, "VK_A", "", ""], [0, 11, "KeyB", 32, "B", 66, "VK_B", "", ""], [0, 12, "KeyC", 33, "C", 67, "VK_C", "", ""], [0, 13, "KeyD", 34, "D", 68, "VK_D", "", ""], [0, 14, "KeyE", 35, "E", 69, "VK_E", "", ""], [0, 15, "KeyF", 36, "F", 70, "VK_F", "", ""], [0, 16, "KeyG", 37, "G", 71, "VK_G", "", ""], [0, 17, "KeyH", 38, "H", 72, "VK_H", "", ""], [0, 18, "KeyI", 39, "I", 73, "VK_I", "", ""], [0, 19, "KeyJ", 40, "J", 74, "VK_J", "", ""], [0, 20, "KeyK", 41, "K", 75, "VK_K", "", ""], [0, 21, "KeyL", 42, "L", 76, "VK_L", "", ""], [0, 22, "KeyM", 43, "M", 77, "VK_M", "", ""], [0, 23, "KeyN", 44, "N", 78, "VK_N", "", ""], [0, 24, "KeyO", 45, "O", 79, "VK_O", "", ""], [0, 25, "KeyP", 46, "P", 80, "VK_P", "", ""], [0, 26, "KeyQ", 47, "Q", 81, "VK_Q", "", ""], [0, 27, "KeyR", 48, "R", 82, "VK_R", "", ""], [0, 28, "KeyS", 49, "S", 83, "VK_S", "", ""], [0, 29, "KeyT", 50, "T", 84, "VK_T", "", ""], [0, 30, "KeyU", 51, "U", 85, "VK_U", "", ""], [0, 31, "KeyV", 52, "V", 86, "VK_V", "", ""], [0, 32, "KeyW", 53, "W", 87, "VK_W", "", ""], [0, 33, "KeyX", 54, "X", 88, "VK_X", "", ""], [0, 34, "KeyY", 55, "Y", 89, "VK_Y", "", ""], [0, 35, "KeyZ", 56, "Z", 90, "VK_Z", "", ""], [0, 36, "Digit1", 22, "1", 49, "VK_1", "", ""], [0, 37, "Digit2", 23, "2", 50, "VK_2", "", ""], [0, 38, "Digit3", 24, "3", 51, "VK_3", "", ""], [0, 39, "Digit4", 25, "4", 52, "VK_4", "", ""], [0, 40, "Digit5", 26, "5", 53, "VK_5", "", ""], [0, 41, "Digit6", 27, "6", 54, "VK_6", "", ""], [0, 42, "Digit7", 28, "7", 55, "VK_7", "", ""], [0, 43, "Digit8", 29, "8", 56, "VK_8", "", ""], [0, 44, "Digit9", 30, "9", 57, "VK_9", "", ""], [0, 45, "Digit0", 21, "0", 48, "VK_0", "", ""], [1, 46, "Enter", 3, "Enter", 13, "VK_RETURN", "", ""], [1, 47, "Escape", 9, "Escape", 27, "VK_ESCAPE", "", ""], [1, 48, "Backspace", 1, "Backspace", 8, "VK_BACK", "", ""], [1, 49, "Tab", 2, "Tab", 9, "VK_TAB", "", ""], [1, 50, "Space", 10, "Space", 32, "VK_SPACE", "", ""], [0, 51, "Minus", 88, "-", 189, "VK_OEM_MINUS", "-", "OEM_MINUS"], [0, 52, "Equal", 86, "=", 187, "VK_OEM_PLUS", "=", "OEM_PLUS"], [0, 53, "BracketLeft", 92, "[", 219, "VK_OEM_4", "[", "OEM_4"], [0, 54, "BracketRight", 94, "]", 221, "VK_OEM_6", "]", "OEM_6"], [0, 55, "Backslash", 93, "\\", 220, "VK_OEM_5", "\\", "OEM_5"], [0, 56, "IntlHash", 0, "", 0, "", "", ""], [0, 57, "Semicolon", 85, ";", 186, "VK_OEM_1", ";", "OEM_1"], [0, 58, "Quote", 95, "'", 222, "VK_OEM_7", "'", "OEM_7"], [0, 59, "Backquote", 91, "`", 192, "VK_OEM_3", "`", "OEM_3"], [0, 60, "Comma", 87, ",", 188, "VK_OEM_COMMA", ",", "OEM_COMMA"], [0, 61, "Period", 89, ".", 190, "VK_OEM_PERIOD", ".", "OEM_PERIOD"], [0, 62, "Slash", 90, "/", 191, "VK_OEM_2", "/", "OEM_2"], [1, 63, "CapsLock", 8, "CapsLock", 20, "VK_CAPITAL", "", ""], [1, 64, "F1", 59, "F1", 112, "VK_F1", "", ""], [1, 65, "F2", 60, "F2", 113, "VK_F2", "", ""], [1, 66, "F3", 61, "F3", 114, "VK_F3", "", ""], [1, 67, "F4", 62, "F4", 115, "VK_F4", "", ""], [1, 68, "F5", 63, "F5", 116, "VK_F5", "", ""], [1, 69, "F6", 64, "F6", 117, "VK_F6", "", ""], [1, 70, "F7", 65, "F7", 118, "VK_F7", "", ""], [1, 71, "F8", 66, "F8", 119, "VK_F8", "", ""], [1, 72, "F9", 67, "F9", 120, "VK_F9", "", ""], [1, 73, "F10", 68, "F10", 121, "VK_F10", "", ""], [1, 74, "F11", 69, "F11", 122, "VK_F11", "", ""], [1, 75, "F12", 70, "F12", 123, "VK_F12", "", ""], [1, 76, "PrintScreen", 0, "", 0, "", "", ""], [1, 77, "ScrollLock", 84, "ScrollLock", 145, "VK_SCROLL", "", ""], [1, 78, "Pause", 7, "PauseBreak", 19, "VK_PAUSE", "", ""], [1, 79, "Insert", 19, "Insert", 45, "VK_INSERT", "", ""], [1, 80, "Home", 14, "Home", 36, "VK_HOME", "", ""], [1, 81, "PageUp", 11, "PageUp", 33, "VK_PRIOR", "", ""], [1, 82, "Delete", 20, "Delete", 46, "VK_DELETE", "", ""], [1, 83, "End", 13, "End", 35, "VK_END", "", ""], [1, 84, "PageDown", 12, "PageDown", 34, "VK_NEXT", "", ""], [1, 85, "ArrowRight", 17, "RightArrow", 39, "VK_RIGHT", "Right", ""], [1, 86, "ArrowLeft", 15, "LeftArrow", 37, "VK_LEFT", "Left", ""], [1, 87, "ArrowDown", 18, "DownArrow", 40, "VK_DOWN", "Down", ""], [1, 88, "ArrowUp", 16, "UpArrow", 38, "VK_UP", "Up", ""], [1, 89, "NumLock", 83, "NumLock", 144, "VK_NUMLOCK", "", ""], [1, 90, "NumpadDivide", 113, "NumPad_Divide", 111, "VK_DIVIDE", "", ""], [1, 91, "NumpadMultiply", 108, "NumPad_Multiply", 106, "VK_MULTIPLY", "", ""], [1, 92, "NumpadSubtract", 111, "NumPad_Subtract", 109, "VK_SUBTRACT", "", ""], [1, 93, "NumpadAdd", 109, "NumPad_Add", 107, "VK_ADD", "", ""], [1, 94, "NumpadEnter", 3, "", 0, "", "", ""], [1, 95, "Numpad1", 99, "NumPad1", 97, "VK_NUMPAD1", "", ""], [1, 96, "Numpad2", 100, "NumPad2", 98, "VK_NUMPAD2", "", ""], [1, 97, "Numpad3", 101, "NumPad3", 99, "VK_NUMPAD3", "", ""], [1, 98, "Numpad4", 102, "NumPad4", 100, "VK_NUMPAD4", "", ""], [1, 99, "Numpad5", 103, "NumPad5", 101, "VK_NUMPAD5", "", ""], [1, 100, "Numpad6", 104, "NumPad6", 102, "VK_NUMPAD6", "", ""], [1, 101, "Numpad7", 105, "NumPad7", 103, "VK_NUMPAD7", "", ""], [1, 102, "Numpad8", 106, "NumPad8", 104, "VK_NUMPAD8", "", ""], [1, 103, "Numpad9", 107, "NumPad9", 105, "VK_NUMPAD9", "", ""], [1, 104, "Numpad0", 98, "NumPad0", 96, "VK_NUMPAD0", "", ""], [1, 105, "NumpadDecimal", 112, "NumPad_Decimal", 110, "VK_DECIMAL", "", ""], [0, 106, "IntlBackslash", 97, "OEM_102", 226, "VK_OEM_102", "", ""], [1, 107, "ContextMenu", 58, "ContextMenu", 93, "", "", ""], [1, 108, "Power", 0, "", 0, "", "", ""], [1, 109, "NumpadEqual", 0, "", 0, "", "", ""], [1, 110, "F13", 71, "F13", 124, "VK_F13", "", ""], [1, 111, "F14", 72, "F14", 125, "VK_F14", "", ""], [1, 112, "F15", 73, "F15", 126, "VK_F15", "", ""], [1, 113, "F16", 74, "F16", 127, "VK_F16", "", ""], [1, 114, "F17", 75, "F17", 128, "VK_F17", "", ""], [1, 115, "F18", 76, "F18", 129, "VK_F18", "", ""], [1, 116, "F19", 77, "F19", 130, "VK_F19", "", ""], [1, 117, "F20", 78, "F20", 131, "VK_F20", "", ""], [1, 118, "F21", 79, "F21", 132, "VK_F21", "", ""], [1, 119, "F22", 80, "F22", 133, "VK_F22", "", ""], [1, 120, "F23", 81, "F23", 134, "VK_F23", "", ""], [1, 121, "F24", 82, "F24", 135, "VK_F24", "", ""], [1, 122, "Open", 0, "", 0, "", "", ""], [1, 123, "Help", 0, "", 0, "", "", ""], [1, 124, "Select", 0, "", 0, "", "", ""], [1, 125, "Again", 0, "", 0, "", "", ""], [1, 126, "Undo", 0, "", 0, "", "", ""], [1, 127, "Cut", 0, "", 0, "", "", ""], [1, 128, "Copy", 0, "", 0, "", "", ""], [1, 129, "Paste", 0, "", 0, "", "", ""], [1, 130, "Find", 0, "", 0, "", "", ""], [1, 131, "AudioVolumeMute", 117, "AudioVolumeMute", 173, "VK_VOLUME_MUTE", "", ""], [1, 132, "AudioVolumeUp", 118, "AudioVolumeUp", 175, "VK_VOLUME_UP", "", ""], [1, 133, "AudioVolumeDown", 119, "AudioVolumeDown", 174, "VK_VOLUME_DOWN", "", ""], [1, 134, "NumpadComma", 110, "NumPad_Separator", 108, "VK_SEPARATOR", "", ""], [0, 135, "IntlRo", 115, "ABNT_C1", 193, "VK_ABNT_C1", "", ""], [1, 136, "KanaMode", 0, "", 0, "", "", ""], [0, 137, "IntlYen", 0, "", 0, "", "", ""], [1, 138, "Convert", 0, "", 0, "", "", ""], [1, 139, "NonConvert", 0, "", 0, "", "", ""], [1, 140, "Lang1", 0, "", 0, "", "", ""], [1, 141, "Lang2", 0, "", 0, "", "", ""], [1, 142, "Lang3", 0, "", 0, "", "", ""], [1, 143, "Lang4", 0, "", 0, "", "", ""], [1, 144, "Lang5", 0, "", 0, "", "", ""], [1, 145, "Abort", 0, "", 0, "", "", ""], [1, 146, "Props", 0, "", 0, "", "", ""], [1, 147, "NumpadParenLeft", 0, "", 0, "", "", ""], [1, 148, "NumpadParenRight", 0, "", 0, "", "", ""], [1, 149, "NumpadBackspace", 0, "", 0, "", "", ""], [1, 150, "NumpadMemoryStore", 0, "", 0, "", "", ""], [1, 151, "NumpadMemoryRecall", 0, "", 0, "", "", ""], [1, 152, "NumpadMemoryClear", 0, "", 0, "", "", ""], [1, 153, "NumpadMemoryAdd", 0, "", 0, "", "", ""], [1, 154, "NumpadMemorySubtract", 0, "", 0, "", "", ""], [1, 155, "NumpadClear", 131, "Clear", 12, "VK_CLEAR", "", ""], [1, 156, "NumpadClearEntry", 0, "", 0, "", "", ""], [1, 0, "", 5, "Ctrl", 17, "VK_CONTROL", "", ""], [1, 0, "", 4, "Shift", 16, "VK_SHIFT", "", ""], [1, 0, "", 6, "Alt", 18, "VK_MENU", "", ""], [1, 0, "", 57, "Meta", 91, "VK_COMMAND", "", ""], [1, 157, "ControlLeft", 5, "", 0, "VK_LCONTROL", "", ""], [1, 158, "ShiftLeft", 4, "", 0, "VK_LSHIFT", "", ""], [1, 159, "AltLeft", 6, "", 0, "VK_LMENU", "", ""], [1, 160, "MetaLeft", 57, "", 0, "VK_LWIN", "", ""], [1, 161, "ControlRight", 5, "", 0, "VK_RCONTROL", "", ""], [1, 162, "ShiftRight", 4, "", 0, "VK_RSHIFT", "", ""], [1, 163, "AltRight", 6, "", 0, "VK_RMENU", "", ""], [1, 164, "MetaRight", 57, "", 0, "VK_RWIN", "", ""], [1, 165, "BrightnessUp", 0, "", 0, "", "", ""], [1, 166, "BrightnessDown", 0, "", 0, "", "", ""], [1, 167, "MediaPlay", 0, "", 0, "", "", ""], [1, 168, "MediaRecord", 0, "", 0, "", "", ""], [1, 169, "MediaFastForward", 0, "", 0, "", "", ""], [1, 170, "MediaRewind", 0, "", 0, "", "", ""], [1, 171, "MediaTrackNext", 124, "MediaTrackNext", 176, "VK_MEDIA_NEXT_TRACK", "", ""], [1, 172, "MediaTrackPrevious", 125, "MediaTrackPrevious", 177, "VK_MEDIA_PREV_TRACK", "", ""], [1, 173, "MediaStop", 126, "MediaStop", 178, "VK_MEDIA_STOP", "", ""], [1, 174, "Eject", 0, "", 0, "", "", ""], [1, 175, "MediaPlayPause", 127, "MediaPlayPause", 179, "VK_MEDIA_PLAY_PAUSE", "", ""], [1, 176, "MediaSelect", 128, "LaunchMediaPlayer", 181, "VK_MEDIA_LAUNCH_MEDIA_SELECT", "", ""], [1, 177, "LaunchMail", 129, "LaunchMail", 180, "VK_MEDIA_LAUNCH_MAIL", "", ""], [1, 178, "LaunchApp2", 130, "LaunchApp2", 183, "VK_MEDIA_LAUNCH_APP2", "", ""], [1, 179, "LaunchApp1", 0, "", 0, "VK_MEDIA_LAUNCH_APP1", "", ""], [1, 180, "SelectTask", 0, "", 0, "", "", ""], [1, 181, "LaunchScreenSaver", 0, "", 0, "", "", ""], [1, 182, "BrowserSearch", 120, "BrowserSearch", 170, "VK_BROWSER_SEARCH", "", ""], [1, 183, "BrowserHome", 121, "BrowserHome", 172, "VK_BROWSER_HOME", "", ""], [1, 184, "BrowserBack", 122, "BrowserBack", 166, "VK_BROWSER_BACK", "", ""], [1, 185, "BrowserForward", 123, "BrowserForward", 167, "VK_BROWSER_FORWARD", "", ""], [1, 186, "BrowserStop", 0, "", 0, "VK_BROWSER_STOP", "", ""], [1, 187, "BrowserRefresh", 0, "", 0, "VK_BROWSER_REFRESH", "", ""], [1, 188, "BrowserFavorites", 0, "", 0, "VK_BROWSER_FAVORITES", "", ""], [1, 189, "ZoomToggle", 0, "", 0, "", "", ""], [1, 190, "MailReply", 0, "", 0, "", "", ""], [1, 191, "MailForward", 0, "", 0, "", "", ""], [1, 192, "MailSend", 0, "", 0, "", "", ""], [1, 0, "", 114, "KeyInComposition", 229, "", "", ""], [1, 0, "", 116, "ABNT_C2", 194, "VK_ABNT_C2", "", ""], [1, 0, "", 96, "OEM_8", 223, "VK_OEM_8", "", ""], [1, 0, "", 0, "", 0, "VK_KANA", "", ""], [1, 0, "", 0, "", 0, "VK_HANGUL", "", ""], [1, 0, "", 0, "", 0, "VK_JUNJA", "", ""], [1, 0, "", 0, "", 0, "VK_FINAL", "", ""], [1, 0, "", 0, "", 0, "VK_HANJA", "", ""], [1, 0, "", 0, "", 0, "VK_KANJI", "", ""], [1, 0, "", 0, "", 0, "VK_CONVERT", "", ""], [1, 0, "", 0, "", 0, "VK_NONCONVERT", "", ""], [1, 0, "", 0, "", 0, "VK_ACCEPT", "", ""], [1, 0, "", 0, "", 0, "VK_MODECHANGE", "", ""], [1, 0, "", 0, "", 0, "VK_SELECT", "", ""], [1, 0, "", 0, "", 0, "VK_PRINT", "", ""], [1, 0, "", 0, "", 0, "VK_EXECUTE", "", ""], [1, 0, "", 0, "", 0, "VK_SNAPSHOT", "", ""], [1, 0, "", 0, "", 0, "VK_HELP", "", ""], [1, 0, "", 0, "", 0, "VK_APPS", "", ""], [1, 0, "", 0, "", 0, "VK_PROCESSKEY", "", ""], [1, 0, "", 0, "", 0, "VK_PACKET", "", ""], [1, 0, "", 0, "", 0, "VK_DBE_SBCSCHAR", "", ""], [1, 0, "", 0, "", 0, "VK_DBE_DBCSCHAR", "", ""], [1, 0, "", 0, "", 0, "VK_ATTN", "", ""], [1, 0, "", 0, "", 0, "VK_CRSEL", "", ""], [1, 0, "", 0, "", 0, "VK_EXSEL", "", ""], [1, 0, "", 0, "", 0, "VK_EREOF", "", ""], [1, 0, "", 0, "", 0, "VK_PLAY", "", ""], [1, 0, "", 0, "", 0, "VK_ZOOM", "", ""], [1, 0, "", 0, "", 0, "VK_NONAME", "", ""], [1, 0, "", 0, "", 0, "VK_PA1", "", ""], [1, 0, "", 0, "", 0, "VK_OEM_CLEAR", "", ""]], t = [], i = [];
  for (const s of e) {
    const [o, r, a, l, d, h, c, u, g] = s;
    if (i[r] || (i[r] = !0, lK[a] = r, dK[a.toLowerCase()] = r, o && (tR[r] = l)), !t[l]) {
      if (t[l] = !0, !d) throw new Error(`String representation missing for key code ${l} around scan code ${a}`);
      G1.define(l, d), Mk.define(l, u || d), Tk.define(l, g || u || d);
    }
    h && (W7[h] = l);
  }
})(), (function(n) {
  n.toString = function(e) {
    return G1.keyCodeToStr(e);
  }, n.fromString = function(e) {
    return G1.strToKeyCode(e);
  }, n.toUserSettingsUS = function(e) {
    return Mk.keyCodeToStr(e);
  }, n.toUserSettingsGeneral = function(e) {
    return Tk.keyCodeToStr(e);
  }, n.fromUserSettings = function(e) {
    return Mk.strToKeyCode(e) || Tk.strToKeyCode(e);
  }, n.toElectronAccelerator = function(e) {
    if (e >= 98 && e <= 113) return null;
    switch (e) {
      case 16:
        return "Up";
      case 18:
        return "Down";
      case 15:
        return "Left";
      case 17:
        return "Right";
    }
    return G1.keyCodeToStr(e);
  };
})(Yl || (Yl = {}));
const Rk = globalThis.vscode;
if (Rk !== void 0 && Rk.process !== void 0) {
  const n = Rk.process;
  j0 = { get platform() {
    return n.platform;
  }, get arch() {
    return n.arch;
  }, get env() {
    return n.env;
  }, cwd: () => n.cwd() };
} else j0 = typeof process < "u" ? { get platform() {
  return process.platform;
}, get arch() {
  return process.arch;
}, get env() {
  return process.env;
}, cwd: () => process.env.VSCODE_CWD || process.cwd() } : { get platform() {
  return Tn ? "win32" : Je ? "darwin" : "linux";
}, get arch() {
}, get env() {
  return {};
}, cwd: () => "/" };
const Iw = j0.cwd, DN = j0.env, hK = j0.platform, Xh = 46, $n = 47, oo = 92, $d = 58;
class V7 extends Error {
  constructor(e, t, i) {
    let s;
    typeof t == "string" && t.indexOf("not ") === 0 ? (s = "must not be", t = t.replace(/^not /, "")) : s = "must be";
    const o = e.indexOf(".") !== -1 ? "property" : "argument";
    let r = `The "${e}" ${o} ${s} of type ${t}`;
    r += ". Received type " + typeof i, super(r), this.code = "ERR_INVALID_ARG_TYPE";
  }
}
function cn(n, e) {
  if (typeof n != "string") throw new V7(e, "string", n);
}
const Rc = hK === "win32";
function kt(n) {
  return n === $n || n === oo;
}
function xN(n) {
  return n === $n;
}
function Gd(n) {
  return n >= 65 && n <= 90 || n >= 97 && n <= 122;
}
function Mw(n, e, t, i) {
  let s = "", o = 0, r = -1, a = 0, l = 0;
  for (let d = 0; d <= n.length; ++d) {
    if (d < n.length) l = n.charCodeAt(d);
    else {
      if (i(l)) break;
      l = $n;
    }
    if (i(l)) {
      if (!(r === d - 1 || a === 1)) if (a === 2) {
        if (s.length < 2 || o !== 2 || s.charCodeAt(s.length - 1) !== Xh || s.charCodeAt(s.length - 2) !== Xh) {
          if (s.length > 2) {
            const h = s.lastIndexOf(t);
            h === -1 ? (s = "", o = 0) : (s = s.slice(0, h), o = s.length - 1 - s.lastIndexOf(t)), r = d, a = 0;
            continue;
          }
          if (s.length !== 0) {
            s = "", o = 0, r = d, a = 0;
            continue;
          }
        }
        e && (s += s.length > 0 ? `${t}..` : "..", o = 2);
      } else s.length > 0 ? s += `${t}${n.slice(r + 1, d)}` : s = n.slice(r + 1, d), o = d - r - 1;
      r = d, a = 0;
    } else l === Xh && a !== -1 ? ++a : a = -1;
  }
  return s;
}
function H7(n, e) {
  (function(s, o) {
    if (s === null || typeof s != "object") throw new V7(o, "Object", s);
  })(e, "pathObject");
  const t = e.dir || e.root, i = e.base || `${e.name || ""}${e.ext || ""}`;
  return t ? t === e.root ? `${t}${i}` : `${t}${n}${i}` : i;
}
const Zs = { resolve(...n) {
  let e = "", t = "", i = !1;
  for (let s = n.length - 1; s >= -1; s--) {
    let o;
    if (s >= 0) {
      if (o = n[s], cn(o, "path"), o.length === 0) continue;
    } else e.length === 0 ? o = Iw() : (o = DN[`=${e}`] || Iw(), (o === void 0 || o.slice(0, 2).toLowerCase() !== e.toLowerCase() && o.charCodeAt(2) === oo) && (o = `${e}\\`));
    const r = o.length;
    let a = 0, l = "", d = !1;
    const h = o.charCodeAt(0);
    if (r === 1) kt(h) && (a = 1, d = !0);
    else if (kt(h)) if (d = !0, kt(o.charCodeAt(1))) {
      let c = 2, u = c;
      for (; c < r && !kt(o.charCodeAt(c)); ) c++;
      if (c < r && c !== u) {
        const g = o.slice(u, c);
        for (u = c; c < r && kt(o.charCodeAt(c)); ) c++;
        if (c < r && c !== u) {
          for (u = c; c < r && !kt(o.charCodeAt(c)); ) c++;
          c !== r && c === u || (l = `\\\\${g}\\${o.slice(u, c)}`, a = c);
        }
      }
    } else a = 1;
    else Gd(h) && o.charCodeAt(1) === $d && (l = o.slice(0, 2), a = 2, r > 2 && kt(o.charCodeAt(2)) && (d = !0, a = 3));
    if (l.length > 0) if (e.length > 0) {
      if (l.toLowerCase() !== e.toLowerCase()) continue;
    } else e = l;
    if (i) {
      if (e.length > 0) break;
    } else if (t = `${o.slice(a)}\\${t}`, i = d, d && e.length > 0) break;
  }
  return t = Mw(t, !i, "\\", kt), i ? `${e}\\${t}` : `${e}${t}` || ".";
}, normalize(n) {
  cn(n, "path");
  const e = n.length;
  if (e === 0) return ".";
  let t, i = 0, s = !1;
  const o = n.charCodeAt(0);
  if (e === 1) return xN(o) ? "\\" : n;
  if (kt(o)) if (s = !0, kt(n.charCodeAt(1))) {
    let a = 2, l = a;
    for (; a < e && !kt(n.charCodeAt(a)); ) a++;
    if (a < e && a !== l) {
      const d = n.slice(l, a);
      for (l = a; a < e && kt(n.charCodeAt(a)); ) a++;
      if (a < e && a !== l) {
        for (l = a; a < e && !kt(n.charCodeAt(a)); ) a++;
        if (a === e) return `\\\\${d}\\${n.slice(l)}\\`;
        a !== l && (t = `\\\\${d}\\${n.slice(l, a)}`, i = a);
      }
    }
  } else i = 1;
  else Gd(o) && n.charCodeAt(1) === $d && (t = n.slice(0, 2), i = 2, e > 2 && kt(n.charCodeAt(2)) && (s = !0, i = 3));
  let r = i < e ? Mw(n.slice(i), !s, "\\", kt) : "";
  return r.length !== 0 || s || (r = "."), r.length > 0 && kt(n.charCodeAt(e - 1)) && (r += "\\"), t === void 0 ? s ? `\\${r}` : r : s ? `${t}\\${r}` : `${t}${r}`;
}, isAbsolute(n) {
  cn(n, "path");
  const e = n.length;
  if (e === 0) return !1;
  const t = n.charCodeAt(0);
  return kt(t) || e > 2 && Gd(t) && n.charCodeAt(1) === $d && kt(n.charCodeAt(2));
}, join(...n) {
  if (n.length === 0) return ".";
  let e, t;
  for (let o = 0; o < n.length; ++o) {
    const r = n[o];
    cn(r, "path"), r.length > 0 && (e === void 0 ? e = t = r : e += `\\${r}`);
  }
  if (e === void 0) return ".";
  let i = !0, s = 0;
  if (typeof t == "string" && kt(t.charCodeAt(0))) {
    ++s;
    const o = t.length;
    o > 1 && kt(t.charCodeAt(1)) && (++s, o > 2 && (kt(t.charCodeAt(2)) ? ++s : i = !1));
  }
  if (i) {
    for (; s < e.length && kt(e.charCodeAt(s)); ) s++;
    s >= 2 && (e = `\\${e.slice(s)}`);
  }
  return Zs.normalize(e);
}, relative(n, e) {
  if (cn(n, "from"), cn(e, "to"), n === e) return "";
  const t = Zs.resolve(n), i = Zs.resolve(e);
  if (t === i || (n = t.toLowerCase()) === (e = i.toLowerCase())) return "";
  let s = 0;
  for (; s < n.length && n.charCodeAt(s) === oo; ) s++;
  let o = n.length;
  for (; o - 1 > s && n.charCodeAt(o - 1) === oo; ) o--;
  const r = o - s;
  let a = 0;
  for (; a < e.length && e.charCodeAt(a) === oo; ) a++;
  let l = e.length;
  for (; l - 1 > a && e.charCodeAt(l - 1) === oo; ) l--;
  const d = l - a, h = r < d ? r : d;
  let c = -1, u = 0;
  for (; u < h; u++) {
    const p = n.charCodeAt(s + u);
    if (p !== e.charCodeAt(a + u)) break;
    p === oo && (c = u);
  }
  if (u !== h) {
    if (c === -1) return i;
  } else {
    if (d > h) {
      if (e.charCodeAt(a + u) === oo) return i.slice(a + u + 1);
      if (u === 2) return i.slice(a + u);
    }
    r > h && (n.charCodeAt(s + u) === oo ? c = u : u === 2 && (c = 3)), c === -1 && (c = 0);
  }
  let g = "";
  for (u = s + c + 1; u <= o; ++u) u !== o && n.charCodeAt(u) !== oo || (g += g.length === 0 ? ".." : "\\..");
  return a += c, g.length > 0 ? `${g}${i.slice(a, l)}` : (i.charCodeAt(a) === oo && ++a, i.slice(a, l));
}, toNamespacedPath(n) {
  if (typeof n != "string" || n.length === 0) return n;
  const e = Zs.resolve(n);
  if (e.length <= 2) return n;
  if (e.charCodeAt(0) === oo) {
    if (e.charCodeAt(1) === oo) {
      const t = e.charCodeAt(2);
      if (t !== 63 && t !== Xh) return `\\\\?\\UNC\\${e.slice(2)}`;
    }
  } else if (Gd(e.charCodeAt(0)) && e.charCodeAt(1) === $d && e.charCodeAt(2) === oo) return `\\\\?\\${e}`;
  return n;
}, dirname(n) {
  cn(n, "path");
  const e = n.length;
  if (e === 0) return ".";
  let t = -1, i = 0;
  const s = n.charCodeAt(0);
  if (e === 1) return kt(s) ? n : ".";
  if (kt(s)) {
    if (t = i = 1, kt(n.charCodeAt(1))) {
      let a = 2, l = a;
      for (; a < e && !kt(n.charCodeAt(a)); ) a++;
      if (a < e && a !== l) {
        for (l = a; a < e && kt(n.charCodeAt(a)); ) a++;
        if (a < e && a !== l) {
          for (l = a; a < e && !kt(n.charCodeAt(a)); ) a++;
          if (a === e) return n;
          a !== l && (t = i = a + 1);
        }
      }
    }
  } else Gd(s) && n.charCodeAt(1) === $d && (t = e > 2 && kt(n.charCodeAt(2)) ? 3 : 2, i = t);
  let o = -1, r = !0;
  for (let a = e - 1; a >= i; --a) if (kt(n.charCodeAt(a))) {
    if (!r) {
      o = a;
      break;
    }
  } else r = !1;
  if (o === -1) {
    if (t === -1) return ".";
    o = t;
  }
  return n.slice(0, o);
}, basename(n, e) {
  e !== void 0 && cn(e, "ext"), cn(n, "path");
  let t, i = 0, s = -1, o = !0;
  if (n.length >= 2 && Gd(n.charCodeAt(0)) && n.charCodeAt(1) === $d && (i = 2), e !== void 0 && e.length > 0 && e.length <= n.length) {
    if (e === n) return "";
    let r = e.length - 1, a = -1;
    for (t = n.length - 1; t >= i; --t) {
      const l = n.charCodeAt(t);
      if (kt(l)) {
        if (!o) {
          i = t + 1;
          break;
        }
      } else a === -1 && (o = !1, a = t + 1), r >= 0 && (l === e.charCodeAt(r) ? --r == -1 && (s = t) : (r = -1, s = a));
    }
    return i === s ? s = a : s === -1 && (s = n.length), n.slice(i, s);
  }
  for (t = n.length - 1; t >= i; --t) if (kt(n.charCodeAt(t))) {
    if (!o) {
      i = t + 1;
      break;
    }
  } else s === -1 && (o = !1, s = t + 1);
  return s === -1 ? "" : n.slice(i, s);
}, extname(n) {
  cn(n, "path");
  let e = 0, t = -1, i = 0, s = -1, o = !0, r = 0;
  n.length >= 2 && n.charCodeAt(1) === $d && Gd(n.charCodeAt(0)) && (e = i = 2);
  for (let a = n.length - 1; a >= e; --a) {
    const l = n.charCodeAt(a);
    if (kt(l)) {
      if (!o) {
        i = a + 1;
        break;
      }
    } else s === -1 && (o = !1, s = a + 1), l === Xh ? t === -1 ? t = a : r !== 1 && (r = 1) : t !== -1 && (r = -1);
  }
  return t === -1 || s === -1 || r === 0 || r === 1 && t === s - 1 && t === i + 1 ? "" : n.slice(t, s);
}, format: H7.bind(null, "\\"), parse(n) {
  cn(n, "path");
  const e = { root: "", dir: "", base: "", ext: "", name: "" };
  if (n.length === 0) return e;
  const t = n.length;
  let i = 0, s = n.charCodeAt(0);
  if (t === 1) return kt(s) ? (e.root = e.dir = n, e) : (e.base = e.name = n, e);
  if (kt(s)) {
    if (i = 1, kt(n.charCodeAt(1))) {
      let c = 2, u = c;
      for (; c < t && !kt(n.charCodeAt(c)); ) c++;
      if (c < t && c !== u) {
        for (u = c; c < t && kt(n.charCodeAt(c)); ) c++;
        if (c < t && c !== u) {
          for (u = c; c < t && !kt(n.charCodeAt(c)); ) c++;
          c === t ? i = c : c !== u && (i = c + 1);
        }
      }
    }
  } else if (Gd(s) && n.charCodeAt(1) === $d) {
    if (t <= 2) return e.root = e.dir = n, e;
    if (i = 2, kt(n.charCodeAt(2))) {
      if (t === 3) return e.root = e.dir = n, e;
      i = 3;
    }
  }
  i > 0 && (e.root = n.slice(0, i));
  let o = -1, r = i, a = -1, l = !0, d = n.length - 1, h = 0;
  for (; d >= i; --d) if (s = n.charCodeAt(d), kt(s)) {
    if (!l) {
      r = d + 1;
      break;
    }
  } else a === -1 && (l = !1, a = d + 1), s === Xh ? o === -1 ? o = d : h !== 1 && (h = 1) : o !== -1 && (h = -1);
  return a !== -1 && (o === -1 || h === 0 || h === 1 && o === a - 1 && o === r + 1 ? e.base = e.name = n.slice(r, a) : (e.name = n.slice(r, o), e.base = n.slice(r, a), e.ext = n.slice(o, a))), e.dir = r > 0 && r !== i ? n.slice(0, r - 1) : e.root, e;
}, sep: "\\", delimiter: ";", win32: null, posix: null }, cK = (() => {
  if (Rc) {
    const n = /\\/g;
    return () => {
      const e = Iw().replace(n, "/");
      return e.slice(e.indexOf("/"));
    };
  }
  return () => Iw();
})(), Fi = { resolve(...n) {
  let e = "", t = !1;
  for (let i = n.length - 1; i >= -1 && !t; i--) {
    const s = i >= 0 ? n[i] : cK();
    cn(s, "path"), s.length !== 0 && (e = `${s}/${e}`, t = s.charCodeAt(0) === $n);
  }
  return e = Mw(e, !t, "/", xN), t ? `/${e}` : e.length > 0 ? e : ".";
}, normalize(n) {
  if (cn(n, "path"), n.length === 0) return ".";
  const e = n.charCodeAt(0) === $n, t = n.charCodeAt(n.length - 1) === $n;
  return (n = Mw(n, !e, "/", xN)).length === 0 ? e ? "/" : t ? "./" : "." : (t && (n += "/"), e ? `/${n}` : n);
}, isAbsolute: (n) => (cn(n, "path"), n.length > 0 && n.charCodeAt(0) === $n), join(...n) {
  if (n.length === 0) return ".";
  let e;
  for (let t = 0; t < n.length; ++t) {
    const i = n[t];
    cn(i, "path"), i.length > 0 && (e === void 0 ? e = i : e += `/${i}`);
  }
  return e === void 0 ? "." : Fi.normalize(e);
}, relative(n, e) {
  if (cn(n, "from"), cn(e, "to"), n === e || (n = Fi.resolve(n)) === (e = Fi.resolve(e))) return "";
  const t = n.length, i = t - 1, s = e.length - 1, o = i < s ? i : s;
  let r = -1, a = 0;
  for (; a < o; a++) {
    const d = n.charCodeAt(1 + a);
    if (d !== e.charCodeAt(1 + a)) break;
    d === $n && (r = a);
  }
  if (a === o) if (s > o) {
    if (e.charCodeAt(1 + a) === $n) return e.slice(1 + a + 1);
    if (a === 0) return e.slice(1 + a);
  } else i > o && (n.charCodeAt(1 + a) === $n ? r = a : a === 0 && (r = 0));
  let l = "";
  for (a = 1 + r + 1; a <= t; ++a) a !== t && n.charCodeAt(a) !== $n || (l += l.length === 0 ? ".." : "/..");
  return `${l}${e.slice(1 + r)}`;
}, toNamespacedPath: (n) => n, dirname(n) {
  if (cn(n, "path"), n.length === 0) return ".";
  const e = n.charCodeAt(0) === $n;
  let t = -1, i = !0;
  for (let s = n.length - 1; s >= 1; --s) if (n.charCodeAt(s) === $n) {
    if (!i) {
      t = s;
      break;
    }
  } else i = !1;
  return t === -1 ? e ? "/" : "." : e && t === 1 ? "//" : n.slice(0, t);
}, basename(n, e) {
  e !== void 0 && cn(e, "ext"), cn(n, "path");
  let t, i = 0, s = -1, o = !0;
  if (e !== void 0 && e.length > 0 && e.length <= n.length) {
    if (e === n) return "";
    let r = e.length - 1, a = -1;
    for (t = n.length - 1; t >= 0; --t) {
      const l = n.charCodeAt(t);
      if (l === $n) {
        if (!o) {
          i = t + 1;
          break;
        }
      } else a === -1 && (o = !1, a = t + 1), r >= 0 && (l === e.charCodeAt(r) ? --r == -1 && (s = t) : (r = -1, s = a));
    }
    return i === s ? s = a : s === -1 && (s = n.length), n.slice(i, s);
  }
  for (t = n.length - 1; t >= 0; --t) if (n.charCodeAt(t) === $n) {
    if (!o) {
      i = t + 1;
      break;
    }
  } else s === -1 && (o = !1, s = t + 1);
  return s === -1 ? "" : n.slice(i, s);
}, extname(n) {
  cn(n, "path");
  let e = -1, t = 0, i = -1, s = !0, o = 0;
  for (let r = n.length - 1; r >= 0; --r) {
    const a = n.charCodeAt(r);
    if (a !== $n) i === -1 && (s = !1, i = r + 1), a === Xh ? e === -1 ? e = r : o !== 1 && (o = 1) : e !== -1 && (o = -1);
    else if (!s) {
      t = r + 1;
      break;
    }
  }
  return e === -1 || i === -1 || o === 0 || o === 1 && e === i - 1 && e === t + 1 ? "" : n.slice(e, i);
}, format: H7.bind(null, "/"), parse(n) {
  cn(n, "path");
  const e = { root: "", dir: "", base: "", ext: "", name: "" };
  if (n.length === 0) return e;
  const t = n.charCodeAt(0) === $n;
  let i;
  t ? (e.root = "/", i = 1) : i = 0;
  let s = -1, o = 0, r = -1, a = !0, l = n.length - 1, d = 0;
  for (; l >= i; --l) {
    const h = n.charCodeAt(l);
    if (h !== $n) r === -1 && (a = !1, r = l + 1), h === Xh ? s === -1 ? s = l : d !== 1 && (d = 1) : s !== -1 && (d = -1);
    else if (!a) {
      o = l + 1;
      break;
    }
  }
  if (r !== -1) {
    const h = o === 0 && t ? 1 : o;
    s === -1 || d === 0 || d === 1 && s === r - 1 && s === o + 1 ? e.base = e.name = n.slice(h, r) : (e.name = n.slice(h, s), e.base = n.slice(h, r), e.ext = n.slice(s, r));
  }
  return o > 0 ? e.dir = n.slice(0, o - 1) : t && (e.dir = "/"), e;
}, sep: "/", delimiter: ":", win32: null, posix: null };
Fi.win32 = Zs.win32 = Zs, Fi.posix = Zs.posix = Fi;
const z7 = Rc ? Zs.normalize : Fi.normalize, uK = Rc ? Zs.resolve : Fi.resolve, gK = Rc ? Zs.relative : Fi.relative, U7 = Rc ? Zs.dirname : Fi.dirname, xh = Rc ? Zs.basename : Fi.basename, pK = Rc ? Zs.extname : Fi.extname, sa = Rc ? Zs.sep : Fi.sep, mK = /^\w[\w\d+.-]*$/, fK = /^\//, _K = /^\/\//, Ii = "", Br = "/", vK = /^(([^:/?#]+?):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
let Ie = class xC {
  static isUri(e) {
    return e instanceof xC || !!e && typeof e.authority == "string" && typeof e.fragment == "string" && typeof e.path == "string" && typeof e.query == "string" && typeof e.scheme == "string" && typeof e.fsPath == "string" && typeof e.with == "function" && typeof e.toString == "function";
  }
  constructor(e, t, i, s, o, r = !1) {
    typeof e == "object" ? (this.scheme = e.scheme || Ii, this.authority = e.authority || Ii, this.path = e.path || Ii, this.query = e.query || Ii, this.fragment = e.fragment || Ii) : (this.scheme = /* @__PURE__ */ (function(a, l) {
      return a || l ? a : "file";
    })(e, r), this.authority = t || Ii, this.path = (function(a, l) {
      switch (a) {
        case "https":
        case "http":
        case "file":
          l ? l[0] !== Br && (l = Br + l) : l = Br;
      }
      return l;
    })(this.scheme, i || Ii), this.query = s || Ii, this.fragment = o || Ii, (function(a, l) {
      if (!a.scheme && l) throw new Error(`[UriError]: Scheme is missing: {scheme: "", authority: "${a.authority}", path: "${a.path}", query: "${a.query}", fragment: "${a.fragment}"}`);
      if (a.scheme && !mK.test(a.scheme)) throw new Error("[UriError]: Scheme contains illegal characters.");
      if (a.path) {
        if (a.authority) {
          if (!fK.test(a.path)) throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
        } else if (_K.test(a.path)) throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
      }
    })(this, r));
  }
  get fsPath() {
    return Tw(this, !1);
  }
  with(e) {
    if (!e) return this;
    let { scheme: t, authority: i, path: s, query: o, fragment: r } = e;
    return t === void 0 ? t = this.scheme : t === null && (t = Ii), i === void 0 ? i = this.authority : i === null && (i = Ii), s === void 0 ? s = this.path : s === null && (s = Ii), o === void 0 ? o = this.query : o === null && (o = Ii), r === void 0 ? r = this.fragment : r === null && (r = Ii), t === this.scheme && i === this.authority && s === this.path && o === this.query && r === this.fragment ? this : new Wg(t, i, s, o, r);
  }
  static parse(e, t = !1) {
    const i = vK.exec(e);
    return i ? new Wg(i[2] || Ii, Z1(i[4] || Ii), Z1(i[5] || Ii), Z1(i[7] || Ii), Z1(i[9] || Ii), t) : new Wg(Ii, Ii, Ii, Ii, Ii);
  }
  static file(e) {
    let t = Ii;
    if (Tn && (e = e.replace(/\\/g, Br)), e[0] === Br && e[1] === Br) {
      const i = e.indexOf(Br, 2);
      i === -1 ? (t = e.substring(2), e = Br) : (t = e.substring(2, i), e = e.substring(i) || Br);
    }
    return new Wg("file", t, e, Ii, Ii);
  }
  static from(e, t) {
    return new Wg(e.scheme, e.authority, e.path, e.query, e.fragment, t);
  }
  static joinPath(e, ...t) {
    if (!e.path) throw new Error("[UriError]: cannot call joinPath on URI without path");
    let i;
    return i = Tn && e.scheme === "file" ? xC.file(Zs.join(Tw(e, !0), ...t)).path : Fi.join(e.path, ...t), e.with({ path: i });
  }
  toString(e = !1) {
    return NN(this, e);
  }
  toJSON() {
    return this;
  }
  static revive(e) {
    var t, i;
    if (e) {
      if (e instanceof xC) return e;
      {
        const s = new Wg(e);
        return s._formatted = (t = e.external) !== null && t !== void 0 ? t : null, s._fsPath = e._sep === K7 && (i = e.fsPath) !== null && i !== void 0 ? i : null, s;
      }
    }
    return e;
  }
};
const K7 = Tn ? 1 : void 0;
let Wg = class extends Ie {
  constructor() {
    super(...arguments), this._formatted = null, this._fsPath = null;
  }
  get fsPath() {
    return this._fsPath || (this._fsPath = Tw(this, !1)), this._fsPath;
  }
  toString(n = !1) {
    return n ? NN(this, !0) : (this._formatted || (this._formatted = NN(this, !1)), this._formatted);
  }
  toJSON() {
    const n = { $mid: 1 };
    return this._fsPath && (n.fsPath = this._fsPath, n._sep = K7), this._formatted && (n.external = this._formatted), this.path && (n.path = this.path), this.scheme && (n.scheme = this.scheme), this.authority && (n.authority = this.authority), this.query && (n.query = this.query), this.fragment && (n.fragment = this.fragment), n;
  }
};
const j7 = { 58: "%3A", 47: "%2F", 63: "%3F", 35: "%23", 91: "%5B", 93: "%5D", 64: "%40", 33: "%21", 36: "%24", 38: "%26", 39: "%27", 40: "%28", 41: "%29", 42: "%2A", 43: "%2B", 44: "%2C", 59: "%3B", 61: "%3D", 32: "%20" };
function sO(n, e, t) {
  let i, s = -1;
  for (let o = 0; o < n.length; o++) {
    const r = n.charCodeAt(o);
    if (r >= 97 && r <= 122 || r >= 65 && r <= 90 || r >= 48 && r <= 57 || r === 45 || r === 46 || r === 95 || r === 126 || e && r === 47 || t && r === 91 || t && r === 93 || t && r === 58) s !== -1 && (i += encodeURIComponent(n.substring(s, o)), s = -1), i !== void 0 && (i += n.charAt(o));
    else {
      i === void 0 && (i = n.substr(0, o));
      const a = j7[r];
      a !== void 0 ? (s !== -1 && (i += encodeURIComponent(n.substring(s, o)), s = -1), i += a) : s === -1 && (s = o);
    }
  }
  return s !== -1 && (i += encodeURIComponent(n.substring(s))), i !== void 0 ? i : n;
}
function bK(n) {
  let e;
  for (let t = 0; t < n.length; t++) {
    const i = n.charCodeAt(t);
    i === 35 || i === 63 ? (e === void 0 && (e = n.substr(0, t)), e += j7[i]) : e !== void 0 && (e += n[t]);
  }
  return e !== void 0 ? e : n;
}
function Tw(n, e) {
  let t;
  return t = n.authority && n.path.length > 1 && n.scheme === "file" ? `//${n.authority}${n.path}` : n.path.charCodeAt(0) === 47 && (n.path.charCodeAt(1) >= 65 && n.path.charCodeAt(1) <= 90 || n.path.charCodeAt(1) >= 97 && n.path.charCodeAt(1) <= 122) && n.path.charCodeAt(2) === 58 ? e ? n.path.substr(1) : n.path[1].toLowerCase() + n.path.substr(2) : n.path, Tn && (t = t.replace(/\//g, "\\")), t;
}
function NN(n, e) {
  const t = e ? bK : sO;
  let i = "", { scheme: s, authority: o, path: r, query: a, fragment: l } = n;
  if (s && (i += s, i += ":"), (o || s === "file") && (i += Br, i += Br), o) {
    let d = o.indexOf("@");
    if (d !== -1) {
      const h = o.substr(0, d);
      o = o.substr(d + 1), d = h.lastIndexOf(":"), d === -1 ? i += t(h, !1, !1) : (i += t(h.substr(0, d), !1, !1), i += ":", i += t(h.substr(d + 1), !1, !0)), i += "@";
    }
    o = o.toLowerCase(), d = o.lastIndexOf(":"), d === -1 ? i += t(o, !1, !0) : (i += t(o.substr(0, d), !1, !0), i += o.substr(d));
  }
  if (r) {
    if (r.length >= 3 && r.charCodeAt(0) === 47 && r.charCodeAt(2) === 58) {
      const d = r.charCodeAt(1);
      d >= 65 && d <= 90 && (r = `/${String.fromCharCode(d + 32)}:${r.substr(3)}`);
    } else if (r.length >= 2 && r.charCodeAt(1) === 58) {
      const d = r.charCodeAt(0);
      d >= 65 && d <= 90 && (r = `${String.fromCharCode(d + 32)}:${r.substr(2)}`);
    }
    i += t(r, !0, !1);
  }
  return a && (i += "?", i += t(a, !1, !1)), l && (i += "#", i += e ? l : sO(l, !1, !1)), i;
}
function q7(n) {
  try {
    return decodeURIComponent(n);
  } catch {
    return n.length > 3 ? n.substr(0, 3) + q7(n.substr(3)) : n;
  }
}
const oO = /(%[0-9A-Za-z][0-9A-Za-z])+/g;
function Z1(n) {
  return n.match(oO) ? n.replace(oO, ((e) => q7(e))) : n;
}
let W = class nu {
  constructor(e, t) {
    this.lineNumber = e, this.column = t;
  }
  with(e = this.lineNumber, t = this.column) {
    return e === this.lineNumber && t === this.column ? this : new nu(e, t);
  }
  delta(e = 0, t = 0) {
    return this.with(this.lineNumber + e, this.column + t);
  }
  equals(e) {
    return nu.equals(this, e);
  }
  static equals(e, t) {
    return !e && !t || !!e && !!t && e.lineNumber === t.lineNumber && e.column === t.column;
  }
  isBefore(e) {
    return nu.isBefore(this, e);
  }
  static isBefore(e, t) {
    return e.lineNumber < t.lineNumber || !(t.lineNumber < e.lineNumber) && e.column < t.column;
  }
  isBeforeOrEqual(e) {
    return nu.isBeforeOrEqual(this, e);
  }
  static isBeforeOrEqual(e, t) {
    return e.lineNumber < t.lineNumber || !(t.lineNumber < e.lineNumber) && e.column <= t.column;
  }
  static compare(e, t) {
    const i = 0 | e.lineNumber, s = 0 | t.lineNumber;
    return i === s ? (0 | e.column) - (0 | t.column) : i - s;
  }
  clone() {
    return new nu(this.lineNumber, this.column);
  }
  toString() {
    return "(" + this.lineNumber + "," + this.column + ")";
  }
  static lift(e) {
    return new nu(e.lineNumber, e.column);
  }
  static isIPosition(e) {
    return e && typeof e.lineNumber == "number" && typeof e.column == "number";
  }
  toJSON() {
    return { lineNumber: this.lineNumber, column: this.column };
  }
}, D = class pn {
  constructor(e, t, i, s) {
    e > i || e === i && t > s ? (this.startLineNumber = i, this.startColumn = s, this.endLineNumber = e, this.endColumn = t) : (this.startLineNumber = e, this.startColumn = t, this.endLineNumber = i, this.endColumn = s);
  }
  isEmpty() {
    return pn.isEmpty(this);
  }
  static isEmpty(e) {
    return e.startLineNumber === e.endLineNumber && e.startColumn === e.endColumn;
  }
  containsPosition(e) {
    return pn.containsPosition(this, e);
  }
  static containsPosition(e, t) {
    return !(t.lineNumber < e.startLineNumber || t.lineNumber > e.endLineNumber) && !(t.lineNumber === e.startLineNumber && t.column < e.startColumn) && !(t.lineNumber === e.endLineNumber && t.column > e.endColumn);
  }
  static strictContainsPosition(e, t) {
    return !(t.lineNumber < e.startLineNumber || t.lineNumber > e.endLineNumber) && !(t.lineNumber === e.startLineNumber && t.column <= e.startColumn) && !(t.lineNumber === e.endLineNumber && t.column >= e.endColumn);
  }
  containsRange(e) {
    return pn.containsRange(this, e);
  }
  static containsRange(e, t) {
    return !(t.startLineNumber < e.startLineNumber || t.endLineNumber < e.startLineNumber) && !(t.startLineNumber > e.endLineNumber || t.endLineNumber > e.endLineNumber) && !(t.startLineNumber === e.startLineNumber && t.startColumn < e.startColumn) && !(t.endLineNumber === e.endLineNumber && t.endColumn > e.endColumn);
  }
  strictContainsRange(e) {
    return pn.strictContainsRange(this, e);
  }
  static strictContainsRange(e, t) {
    return !(t.startLineNumber < e.startLineNumber || t.endLineNumber < e.startLineNumber) && !(t.startLineNumber > e.endLineNumber || t.endLineNumber > e.endLineNumber) && !(t.startLineNumber === e.startLineNumber && t.startColumn <= e.startColumn) && !(t.endLineNumber === e.endLineNumber && t.endColumn >= e.endColumn);
  }
  plusRange(e) {
    return pn.plusRange(this, e);
  }
  static plusRange(e, t) {
    let i, s, o, r;
    return t.startLineNumber < e.startLineNumber ? (i = t.startLineNumber, s = t.startColumn) : t.startLineNumber === e.startLineNumber ? (i = t.startLineNumber, s = Math.min(t.startColumn, e.startColumn)) : (i = e.startLineNumber, s = e.startColumn), t.endLineNumber > e.endLineNumber ? (o = t.endLineNumber, r = t.endColumn) : t.endLineNumber === e.endLineNumber ? (o = t.endLineNumber, r = Math.max(t.endColumn, e.endColumn)) : (o = e.endLineNumber, r = e.endColumn), new pn(i, s, o, r);
  }
  intersectRanges(e) {
    return pn.intersectRanges(this, e);
  }
  static intersectRanges(e, t) {
    let i = e.startLineNumber, s = e.startColumn, o = e.endLineNumber, r = e.endColumn;
    const a = t.startLineNumber, l = t.startColumn, d = t.endLineNumber, h = t.endColumn;
    return i < a ? (i = a, s = l) : i === a && (s = Math.max(s, l)), o > d ? (o = d, r = h) : o === d && (r = Math.min(r, h)), i > o || i === o && s > r ? null : new pn(i, s, o, r);
  }
  equalsRange(e) {
    return pn.equalsRange(this, e);
  }
  static equalsRange(e, t) {
    return !e && !t || !!e && !!t && e.startLineNumber === t.startLineNumber && e.startColumn === t.startColumn && e.endLineNumber === t.endLineNumber && e.endColumn === t.endColumn;
  }
  getEndPosition() {
    return pn.getEndPosition(this);
  }
  static getEndPosition(e) {
    return new W(e.endLineNumber, e.endColumn);
  }
  getStartPosition() {
    return pn.getStartPosition(this);
  }
  static getStartPosition(e) {
    return new W(e.startLineNumber, e.startColumn);
  }
  toString() {
    return "[" + this.startLineNumber + "," + this.startColumn + " -> " + this.endLineNumber + "," + this.endColumn + "]";
  }
  setEndPosition(e, t) {
    return new pn(this.startLineNumber, this.startColumn, e, t);
  }
  setStartPosition(e, t) {
    return new pn(e, t, this.endLineNumber, this.endColumn);
  }
  collapseToStart() {
    return pn.collapseToStart(this);
  }
  static collapseToStart(e) {
    return new pn(e.startLineNumber, e.startColumn, e.startLineNumber, e.startColumn);
  }
  collapseToEnd() {
    return pn.collapseToEnd(this);
  }
  static collapseToEnd(e) {
    return new pn(e.endLineNumber, e.endColumn, e.endLineNumber, e.endColumn);
  }
  delta(e) {
    return new pn(this.startLineNumber + e, this.startColumn, this.endLineNumber + e, this.endColumn);
  }
  static fromPositions(e, t = e) {
    return new pn(e.lineNumber, e.column, t.lineNumber, t.column);
  }
  static lift(e) {
    return e ? new pn(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn) : null;
  }
  static isIRange(e) {
    return e && typeof e.startLineNumber == "number" && typeof e.startColumn == "number" && typeof e.endLineNumber == "number" && typeof e.endColumn == "number";
  }
  static areIntersectingOrTouching(e, t) {
    return !(e.endLineNumber < t.startLineNumber || e.endLineNumber === t.startLineNumber && e.endColumn < t.startColumn) && !(t.endLineNumber < e.startLineNumber || t.endLineNumber === e.startLineNumber && t.endColumn < e.startColumn);
  }
  static areIntersecting(e, t) {
    return !(e.endLineNumber < t.startLineNumber || e.endLineNumber === t.startLineNumber && e.endColumn <= t.startColumn) && !(t.endLineNumber < e.startLineNumber || t.endLineNumber === e.startLineNumber && t.endColumn <= e.startColumn);
  }
  static compareRangesUsingStarts(e, t) {
    if (e && t) {
      const i = 0 | e.startLineNumber, s = 0 | t.startLineNumber;
      if (i === s) {
        const o = 0 | e.startColumn, r = 0 | t.startColumn;
        if (o === r) {
          const a = 0 | e.endLineNumber, l = 0 | t.endLineNumber;
          return a === l ? (0 | e.endColumn) - (0 | t.endColumn) : a - l;
        }
        return o - r;
      }
      return i - s;
    }
    return (e ? 1 : 0) - (t ? 1 : 0);
  }
  static compareRangesUsingEnds(e, t) {
    return e.endLineNumber === t.endLineNumber ? e.endColumn === t.endColumn ? e.startLineNumber === t.startLineNumber ? e.startColumn - t.startColumn : e.startLineNumber - t.startLineNumber : e.endColumn - t.endColumn : e.endLineNumber - t.endLineNumber;
  }
  static spansMultipleLines(e) {
    return e.endLineNumber > e.startLineNumber;
  }
  toJSON() {
    return this;
  }
}, _e = class dr extends D {
  constructor(e, t, i, s) {
    super(e, t, i, s), this.selectionStartLineNumber = e, this.selectionStartColumn = t, this.positionLineNumber = i, this.positionColumn = s;
  }
  toString() {
    return "[" + this.selectionStartLineNumber + "," + this.selectionStartColumn + " -> " + this.positionLineNumber + "," + this.positionColumn + "]";
  }
  equalsSelection(e) {
    return dr.selectionsEqual(this, e);
  }
  static selectionsEqual(e, t) {
    return e.selectionStartLineNumber === t.selectionStartLineNumber && e.selectionStartColumn === t.selectionStartColumn && e.positionLineNumber === t.positionLineNumber && e.positionColumn === t.positionColumn;
  }
  getDirection() {
    return this.selectionStartLineNumber === this.startLineNumber && this.selectionStartColumn === this.startColumn ? 0 : 1;
  }
  setEndPosition(e, t) {
    return this.getDirection() === 0 ? new dr(this.startLineNumber, this.startColumn, e, t) : new dr(e, t, this.startLineNumber, this.startColumn);
  }
  getPosition() {
    return new W(this.positionLineNumber, this.positionColumn);
  }
  getSelectionStart() {
    return new W(this.selectionStartLineNumber, this.selectionStartColumn);
  }
  setStartPosition(e, t) {
    return this.getDirection() === 0 ? new dr(e, t, this.endLineNumber, this.endColumn) : new dr(this.endLineNumber, this.endColumn, e, t);
  }
  static fromPositions(e, t = e) {
    return new dr(e.lineNumber, e.column, t.lineNumber, t.column);
  }
  static fromRange(e, t) {
    return t === 0 ? new dr(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn) : new dr(e.endLineNumber, e.endColumn, e.startLineNumber, e.startColumn);
  }
  static liftSelection(e) {
    return new dr(e.selectionStartLineNumber, e.selectionStartColumn, e.positionLineNumber, e.positionColumn);
  }
  static selectionsArrEqual(e, t) {
    if (e && !t || !e && t) return !1;
    if (!e && !t) return !0;
    if (e.length !== t.length) return !1;
    for (let i = 0, s = e.length; i < s; i++) if (!this.selectionsEqual(e[i], t[i])) return !1;
    return !0;
  }
  static isISelection(e) {
    return e && typeof e.selectionStartLineNumber == "number" && typeof e.selectionStartColumn == "number" && typeof e.positionLineNumber == "number" && typeof e.positionColumn == "number";
  }
  static createWithDirection(e, t, i, s, o) {
    return o === 0 ? new dr(e, t, i, s) : new dr(i, s, e, t);
  }
};
const EN = /* @__PURE__ */ Object.create(null);
function S(n, e) {
  if (ps(e)) {
    const t = EN[e];
    if (t === void 0) throw new Error(`${n} references an unknown codicon: ${e}`);
    e = t;
  }
  return EN[n] = e, { id: n };
}
function $7() {
  return EN;
}
const ne = { add: S("add", 6e4), plus: S("plus", 6e4), gistNew: S("gist-new", 6e4), repoCreate: S("repo-create", 6e4), lightbulb: S("lightbulb", 60001), lightBulb: S("light-bulb", 60001), repo: S("repo", 60002), repoDelete: S("repo-delete", 60002), gistFork: S("gist-fork", 60003), repoForked: S("repo-forked", 60003), gitPullRequest: S("git-pull-request", 60004), gitPullRequestAbandoned: S("git-pull-request-abandoned", 60004), recordKeys: S("record-keys", 60005), keyboard: S("keyboard", 60005), tag: S("tag", 60006), gitPullRequestLabel: S("git-pull-request-label", 60006), tagAdd: S("tag-add", 60006), tagRemove: S("tag-remove", 60006), person: S("person", 60007), personFollow: S("person-follow", 60007), personOutline: S("person-outline", 60007), personFilled: S("person-filled", 60007), gitBranch: S("git-branch", 60008), gitBranchCreate: S("git-branch-create", 60008), gitBranchDelete: S("git-branch-delete", 60008), sourceControl: S("source-control", 60008), mirror: S("mirror", 60009), mirrorPublic: S("mirror-public", 60009), star: S("star", 60010), starAdd: S("star-add", 60010), starDelete: S("star-delete", 60010), starEmpty: S("star-empty", 60010), comment: S("comment", 60011), commentAdd: S("comment-add", 60011), alert: S("alert", 60012), warning: S("warning", 60012), search: S("search", 60013), searchSave: S("search-save", 60013), logOut: S("log-out", 60014), signOut: S("sign-out", 60014), logIn: S("log-in", 60015), signIn: S("sign-in", 60015), eye: S("eye", 60016), eyeUnwatch: S("eye-unwatch", 60016), eyeWatch: S("eye-watch", 60016), circleFilled: S("circle-filled", 60017), primitiveDot: S("primitive-dot", 60017), closeDirty: S("close-dirty", 60017), debugBreakpoint: S("debug-breakpoint", 60017), debugBreakpointDisabled: S("debug-breakpoint-disabled", 60017), debugHint: S("debug-hint", 60017), terminalDecorationSuccess: S("terminal-decoration-success", 60017), primitiveSquare: S("primitive-square", 60018), edit: S("edit", 60019), pencil: S("pencil", 60019), info: S("info", 60020), issueOpened: S("issue-opened", 60020), gistPrivate: S("gist-private", 60021), gitForkPrivate: S("git-fork-private", 60021), lock: S("lock", 60021), mirrorPrivate: S("mirror-private", 60021), close: S("close", 60022), removeClose: S("remove-close", 60022), x: S("x", 60022), repoSync: S("repo-sync", 60023), sync: S("sync", 60023), clone: S("clone", 60024), desktopDownload: S("desktop-download", 60024), beaker: S("beaker", 60025), microscope: S("microscope", 60025), vm: S("vm", 60026), deviceDesktop: S("device-desktop", 60026), file: S("file", 60027), fileText: S("file-text", 60027), more: S("more", 60028), ellipsis: S("ellipsis", 60028), kebabHorizontal: S("kebab-horizontal", 60028), mailReply: S("mail-reply", 60029), reply: S("reply", 60029), organization: S("organization", 60030), organizationFilled: S("organization-filled", 60030), organizationOutline: S("organization-outline", 60030), newFile: S("new-file", 60031), fileAdd: S("file-add", 60031), newFolder: S("new-folder", 60032), fileDirectoryCreate: S("file-directory-create", 60032), trash: S("trash", 60033), trashcan: S("trashcan", 60033), history: S("history", 60034), clock: S("clock", 60034), folder: S("folder", 60035), fileDirectory: S("file-directory", 60035), symbolFolder: S("symbol-folder", 60035), logoGithub: S("logo-github", 60036), markGithub: S("mark-github", 60036), github: S("github", 60036), terminal: S("terminal", 60037), console: S("console", 60037), repl: S("repl", 60037), zap: S("zap", 60038), symbolEvent: S("symbol-event", 60038), error: S("error", 60039), stop: S("stop", 60039), variable: S("variable", 60040), symbolVariable: S("symbol-variable", 60040), array: S("array", 60042), symbolArray: S("symbol-array", 60042), symbolModule: S("symbol-module", 60043), symbolPackage: S("symbol-package", 60043), symbolNamespace: S("symbol-namespace", 60043), symbolObject: S("symbol-object", 60043), symbolMethod: S("symbol-method", 60044), symbolFunction: S("symbol-function", 60044), symbolConstructor: S("symbol-constructor", 60044), symbolBoolean: S("symbol-boolean", 60047), symbolNull: S("symbol-null", 60047), symbolNumeric: S("symbol-numeric", 60048), symbolNumber: S("symbol-number", 60048), symbolStructure: S("symbol-structure", 60049), symbolStruct: S("symbol-struct", 60049), symbolParameter: S("symbol-parameter", 60050), symbolTypeParameter: S("symbol-type-parameter", 60050), symbolKey: S("symbol-key", 60051), symbolText: S("symbol-text", 60051), symbolReference: S("symbol-reference", 60052), goToFile: S("go-to-file", 60052), symbolEnum: S("symbol-enum", 60053), symbolValue: S("symbol-value", 60053), symbolRuler: S("symbol-ruler", 60054), symbolUnit: S("symbol-unit", 60054), activateBreakpoints: S("activate-breakpoints", 60055), archive: S("archive", 60056), arrowBoth: S("arrow-both", 60057), arrowDown: S("arrow-down", 60058), arrowLeft: S("arrow-left", 60059), arrowRight: S("arrow-right", 60060), arrowSmallDown: S("arrow-small-down", 60061), arrowSmallLeft: S("arrow-small-left", 60062), arrowSmallRight: S("arrow-small-right", 60063), arrowSmallUp: S("arrow-small-up", 60064), arrowUp: S("arrow-up", 60065), bell: S("bell", 60066), bold: S("bold", 60067), book: S("book", 60068), bookmark: S("bookmark", 60069), debugBreakpointConditionalUnverified: S("debug-breakpoint-conditional-unverified", 60070), debugBreakpointConditional: S("debug-breakpoint-conditional", 60071), debugBreakpointConditionalDisabled: S("debug-breakpoint-conditional-disabled", 60071), debugBreakpointDataUnverified: S("debug-breakpoint-data-unverified", 60072), debugBreakpointData: S("debug-breakpoint-data", 60073), debugBreakpointDataDisabled: S("debug-breakpoint-data-disabled", 60073), debugBreakpointLogUnverified: S("debug-breakpoint-log-unverified", 60074), debugBreakpointLog: S("debug-breakpoint-log", 60075), debugBreakpointLogDisabled: S("debug-breakpoint-log-disabled", 60075), briefcase: S("briefcase", 60076), broadcast: S("broadcast", 60077), browser: S("browser", 60078), bug: S("bug", 60079), calendar: S("calendar", 60080), caseSensitive: S("case-sensitive", 60081), check: S("check", 60082), checklist: S("checklist", 60083), chevronDown: S("chevron-down", 60084), chevronLeft: S("chevron-left", 60085), chevronRight: S("chevron-right", 60086), chevronUp: S("chevron-up", 60087), chromeClose: S("chrome-close", 60088), chromeMaximize: S("chrome-maximize", 60089), chromeMinimize: S("chrome-minimize", 60090), chromeRestore: S("chrome-restore", 60091), circleOutline: S("circle-outline", 60092), circle: S("circle", 60092), debugBreakpointUnverified: S("debug-breakpoint-unverified", 60092), terminalDecorationIncomplete: S("terminal-decoration-incomplete", 60092), circleSlash: S("circle-slash", 60093), circuitBoard: S("circuit-board", 60094), clearAll: S("clear-all", 60095), clippy: S("clippy", 60096), closeAll: S("close-all", 60097), cloudDownload: S("cloud-download", 60098), cloudUpload: S("cloud-upload", 60099), code: S("code", 60100), collapseAll: S("collapse-all", 60101), colorMode: S("color-mode", 60102), commentDiscussion: S("comment-discussion", 60103), creditCard: S("credit-card", 60105), dash: S("dash", 60108), dashboard: S("dashboard", 60109), database: S("database", 60110), debugContinue: S("debug-continue", 60111), debugDisconnect: S("debug-disconnect", 60112), debugPause: S("debug-pause", 60113), debugRestart: S("debug-restart", 60114), debugStart: S("debug-start", 60115), debugStepInto: S("debug-step-into", 60116), debugStepOut: S("debug-step-out", 60117), debugStepOver: S("debug-step-over", 60118), debugStop: S("debug-stop", 60119), debug: S("debug", 60120), deviceCameraVideo: S("device-camera-video", 60121), deviceCamera: S("device-camera", 60122), deviceMobile: S("device-mobile", 60123), diffAdded: S("diff-added", 60124), diffIgnored: S("diff-ignored", 60125), diffModified: S("diff-modified", 60126), diffRemoved: S("diff-removed", 60127), diffRenamed: S("diff-renamed", 60128), diff: S("diff", 60129), diffSidebyside: S("diff-sidebyside", 60129), discard: S("discard", 60130), editorLayout: S("editor-layout", 60131), emptyWindow: S("empty-window", 60132), exclude: S("exclude", 60133), extensions: S("extensions", 60134), eyeClosed: S("eye-closed", 60135), fileBinary: S("file-binary", 60136), fileCode: S("file-code", 60137), fileMedia: S("file-media", 60138), filePdf: S("file-pdf", 60139), fileSubmodule: S("file-submodule", 60140), fileSymlinkDirectory: S("file-symlink-directory", 60141), fileSymlinkFile: S("file-symlink-file", 60142), fileZip: S("file-zip", 60143), files: S("files", 60144), filter: S("filter", 60145), flame: S("flame", 60146), foldDown: S("fold-down", 60147), foldUp: S("fold-up", 60148), fold: S("fold", 60149), folderActive: S("folder-active", 60150), folderOpened: S("folder-opened", 60151), gear: S("gear", 60152), gift: S("gift", 60153), gistSecret: S("gist-secret", 60154), gist: S("gist", 60155), gitCommit: S("git-commit", 60156), gitCompare: S("git-compare", 60157), compareChanges: S("compare-changes", 60157), gitMerge: S("git-merge", 60158), githubAction: S("github-action", 60159), githubAlt: S("github-alt", 60160), globe: S("globe", 60161), grabber: S("grabber", 60162), graph: S("graph", 60163), gripper: S("gripper", 60164), heart: S("heart", 60165), home: S("home", 60166), horizontalRule: S("horizontal-rule", 60167), hubot: S("hubot", 60168), inbox: S("inbox", 60169), issueReopened: S("issue-reopened", 60171), issues: S("issues", 60172), italic: S("italic", 60173), jersey: S("jersey", 60174), json: S("json", 60175), kebabVertical: S("kebab-vertical", 60176), key: S("key", 60177), law: S("law", 60178), lightbulbAutofix: S("lightbulb-autofix", 60179), linkExternal: S("link-external", 60180), link: S("link", 60181), listOrdered: S("list-ordered", 60182), listUnordered: S("list-unordered", 60183), liveShare: S("live-share", 60184), loading: S("loading", 60185), location: S("location", 60186), mailRead: S("mail-read", 60187), mail: S("mail", 60188), markdown: S("markdown", 60189), megaphone: S("megaphone", 60190), mention: S("mention", 60191), milestone: S("milestone", 60192), gitPullRequestMilestone: S("git-pull-request-milestone", 60192), mortarBoard: S("mortar-board", 60193), move: S("move", 60194), multipleWindows: S("multiple-windows", 60195), mute: S("mute", 60196), noNewline: S("no-newline", 60197), note: S("note", 60198), octoface: S("octoface", 60199), openPreview: S("open-preview", 60200), package: S("package", 60201), paintcan: S("paintcan", 60202), pin: S("pin", 60203), play: S("play", 60204), run: S("run", 60204), plug: S("plug", 60205), preserveCase: S("preserve-case", 60206), preview: S("preview", 60207), project: S("project", 60208), pulse: S("pulse", 60209), question: S("question", 60210), quote: S("quote", 60211), radioTower: S("radio-tower", 60212), reactions: S("reactions", 60213), references: S("references", 60214), refresh: S("refresh", 60215), regex: S("regex", 60216), remoteExplorer: S("remote-explorer", 60217), remote: S("remote", 60218), remove: S("remove", 60219), replaceAll: S("replace-all", 60220), replace: S("replace", 60221), repoClone: S("repo-clone", 60222), repoForcePush: S("repo-force-push", 60223), repoPull: S("repo-pull", 60224), repoPush: S("repo-push", 60225), report: S("report", 60226), requestChanges: S("request-changes", 60227), rocket: S("rocket", 60228), rootFolderOpened: S("root-folder-opened", 60229), rootFolder: S("root-folder", 60230), rss: S("rss", 60231), ruby: S("ruby", 60232), saveAll: S("save-all", 60233), saveAs: S("save-as", 60234), save: S("save", 60235), screenFull: S("screen-full", 60236), screenNormal: S("screen-normal", 60237), searchStop: S("search-stop", 60238), server: S("server", 60240), settingsGear: S("settings-gear", 60241), settings: S("settings", 60242), shield: S("shield", 60243), smiley: S("smiley", 60244), sortPrecedence: S("sort-precedence", 60245), splitHorizontal: S("split-horizontal", 60246), splitVertical: S("split-vertical", 60247), squirrel: S("squirrel", 60248), starFull: S("star-full", 60249), starHalf: S("star-half", 60250), symbolClass: S("symbol-class", 60251), symbolColor: S("symbol-color", 60252), symbolConstant: S("symbol-constant", 60253), symbolEnumMember: S("symbol-enum-member", 60254), symbolField: S("symbol-field", 60255), symbolFile: S("symbol-file", 60256), symbolInterface: S("symbol-interface", 60257), symbolKeyword: S("symbol-keyword", 60258), symbolMisc: S("symbol-misc", 60259), symbolOperator: S("symbol-operator", 60260), symbolProperty: S("symbol-property", 60261), wrench: S("wrench", 60261), wrenchSubaction: S("wrench-subaction", 60261), symbolSnippet: S("symbol-snippet", 60262), tasklist: S("tasklist", 60263), telescope: S("telescope", 60264), textSize: S("text-size", 60265), threeBars: S("three-bars", 60266), thumbsdown: S("thumbsdown", 60267), thumbsup: S("thumbsup", 60268), tools: S("tools", 60269), triangleDown: S("triangle-down", 60270), triangleLeft: S("triangle-left", 60271), triangleRight: S("triangle-right", 60272), triangleUp: S("triangle-up", 60273), twitter: S("twitter", 60274), unfold: S("unfold", 60275), unlock: S("unlock", 60276), unmute: S("unmute", 60277), unverified: S("unverified", 60278), verified: S("verified", 60279), versions: S("versions", 60280), vmActive: S("vm-active", 60281), vmOutline: S("vm-outline", 60282), vmRunning: S("vm-running", 60283), watch: S("watch", 60284), whitespace: S("whitespace", 60285), wholeWord: S("whole-word", 60286), window: S("window", 60287), wordWrap: S("word-wrap", 60288), zoomIn: S("zoom-in", 60289), zoomOut: S("zoom-out", 60290), listFilter: S("list-filter", 60291), listFlat: S("list-flat", 60292), listSelection: S("list-selection", 60293), selection: S("selection", 60293), listTree: S("list-tree", 60294), debugBreakpointFunctionUnverified: S("debug-breakpoint-function-unverified", 60295), debugBreakpointFunction: S("debug-breakpoint-function", 60296), debugBreakpointFunctionDisabled: S("debug-breakpoint-function-disabled", 60296), debugStackframeActive: S("debug-stackframe-active", 60297), circleSmallFilled: S("circle-small-filled", 60298), debugStackframeDot: S("debug-stackframe-dot", 60298), terminalDecorationMark: S("terminal-decoration-mark", 60298), debugStackframe: S("debug-stackframe", 60299), debugStackframeFocused: S("debug-stackframe-focused", 60299), debugBreakpointUnsupported: S("debug-breakpoint-unsupported", 60300), symbolString: S("symbol-string", 60301), debugReverseContinue: S("debug-reverse-continue", 60302), debugStepBack: S("debug-step-back", 60303), debugRestartFrame: S("debug-restart-frame", 60304), debugAlt: S("debug-alt", 60305), callIncoming: S("call-incoming", 60306), callOutgoing: S("call-outgoing", 60307), menu: S("menu", 60308), expandAll: S("expand-all", 60309), feedback: S("feedback", 60310), gitPullRequestReviewer: S("git-pull-request-reviewer", 60310), groupByRefType: S("group-by-ref-type", 60311), ungroupByRefType: S("ungroup-by-ref-type", 60312), account: S("account", 60313), gitPullRequestAssignee: S("git-pull-request-assignee", 60313), bellDot: S("bell-dot", 60314), debugConsole: S("debug-console", 60315), library: S("library", 60316), output: S("output", 60317), runAll: S("run-all", 60318), syncIgnored: S("sync-ignored", 60319), pinned: S("pinned", 60320), githubInverted: S("github-inverted", 60321), serverProcess: S("server-process", 60322), serverEnvironment: S("server-environment", 60323), pass: S("pass", 60324), issueClosed: S("issue-closed", 60324), stopCircle: S("stop-circle", 60325), playCircle: S("play-circle", 60326), record: S("record", 60327), debugAltSmall: S("debug-alt-small", 60328), vmConnect: S("vm-connect", 60329), cloud: S("cloud", 60330), merge: S("merge", 60331), export: S("export", 60332), graphLeft: S("graph-left", 60333), magnet: S("magnet", 60334), notebook: S("notebook", 60335), redo: S("redo", 60336), checkAll: S("check-all", 60337), pinnedDirty: S("pinned-dirty", 60338), passFilled: S("pass-filled", 60339), circleLargeFilled: S("circle-large-filled", 60340), circleLarge: S("circle-large", 60341), circleLargeOutline: S("circle-large-outline", 60341), combine: S("combine", 60342), gather: S("gather", 60342), table: S("table", 60343), variableGroup: S("variable-group", 60344), typeHierarchy: S("type-hierarchy", 60345), typeHierarchySub: S("type-hierarchy-sub", 60346), typeHierarchySuper: S("type-hierarchy-super", 60347), gitPullRequestCreate: S("git-pull-request-create", 60348), runAbove: S("run-above", 60349), runBelow: S("run-below", 60350), notebookTemplate: S("notebook-template", 60351), debugRerun: S("debug-rerun", 60352), workspaceTrusted: S("workspace-trusted", 60353), workspaceUntrusted: S("workspace-untrusted", 60354), workspaceUnknown: S("workspace-unknown", 60355), terminalCmd: S("terminal-cmd", 60356), terminalDebian: S("terminal-debian", 60357), terminalLinux: S("terminal-linux", 60358), terminalPowershell: S("terminal-powershell", 60359), terminalTmux: S("terminal-tmux", 60360), terminalUbuntu: S("terminal-ubuntu", 60361), terminalBash: S("terminal-bash", 60362), arrowSwap: S("arrow-swap", 60363), copy: S("copy", 60364), personAdd: S("person-add", 60365), filterFilled: S("filter-filled", 60366), wand: S("wand", 60367), debugLineByLine: S("debug-line-by-line", 60368), inspect: S("inspect", 60369), layers: S("layers", 60370), layersDot: S("layers-dot", 60371), layersActive: S("layers-active", 60372), compass: S("compass", 60373), compassDot: S("compass-dot", 60374), compassActive: S("compass-active", 60375), azure: S("azure", 60376), issueDraft: S("issue-draft", 60377), gitPullRequestClosed: S("git-pull-request-closed", 60378), gitPullRequestDraft: S("git-pull-request-draft", 60379), debugAll: S("debug-all", 60380), debugCoverage: S("debug-coverage", 60381), runErrors: S("run-errors", 60382), folderLibrary: S("folder-library", 60383), debugContinueSmall: S("debug-continue-small", 60384), beakerStop: S("beaker-stop", 60385), graphLine: S("graph-line", 60386), graphScatter: S("graph-scatter", 60387), pieChart: S("pie-chart", 60388), bracket: S("bracket", 60175), bracketDot: S("bracket-dot", 60389), bracketError: S("bracket-error", 60390), lockSmall: S("lock-small", 60391), azureDevops: S("azure-devops", 60392), verifiedFilled: S("verified-filled", 60393), newline: S("newline", 60394), layout: S("layout", 60395), layoutActivitybarLeft: S("layout-activitybar-left", 60396), layoutActivitybarRight: S("layout-activitybar-right", 60397), layoutPanelLeft: S("layout-panel-left", 60398), layoutPanelCenter: S("layout-panel-center", 60399), layoutPanelJustify: S("layout-panel-justify", 60400), layoutPanelRight: S("layout-panel-right", 60401), layoutPanel: S("layout-panel", 60402), layoutSidebarLeft: S("layout-sidebar-left", 60403), layoutSidebarRight: S("layout-sidebar-right", 60404), layoutStatusbar: S("layout-statusbar", 60405), layoutMenubar: S("layout-menubar", 60406), layoutCentered: S("layout-centered", 60407), target: S("target", 60408), indent: S("indent", 60409), recordSmall: S("record-small", 60410), errorSmall: S("error-small", 60411), terminalDecorationError: S("terminal-decoration-error", 60411), arrowCircleDown: S("arrow-circle-down", 60412), arrowCircleLeft: S("arrow-circle-left", 60413), arrowCircleRight: S("arrow-circle-right", 60414), arrowCircleUp: S("arrow-circle-up", 60415), layoutSidebarRightOff: S("layout-sidebar-right-off", 60416), layoutPanelOff: S("layout-panel-off", 60417), layoutSidebarLeftOff: S("layout-sidebar-left-off", 60418), blank: S("blank", 60419), heartFilled: S("heart-filled", 60420), map: S("map", 60421), mapHorizontal: S("map-horizontal", 60421), foldHorizontal: S("fold-horizontal", 60421), mapFilled: S("map-filled", 60422), mapHorizontalFilled: S("map-horizontal-filled", 60422), foldHorizontalFilled: S("fold-horizontal-filled", 60422), circleSmall: S("circle-small", 60423), bellSlash: S("bell-slash", 60424), bellSlashDot: S("bell-slash-dot", 60425), commentUnresolved: S("comment-unresolved", 60426), gitPullRequestGoToChanges: S("git-pull-request-go-to-changes", 60427), gitPullRequestNewChanges: S("git-pull-request-new-changes", 60428), searchFuzzy: S("search-fuzzy", 60429), commentDraft: S("comment-draft", 60430), send: S("send", 60431), sparkle: S("sparkle", 60432), insert: S("insert", 60433), mic: S("mic", 60434), thumbsdownFilled: S("thumbsdown-filled", 60435), thumbsupFilled: S("thumbsup-filled", 60436), coffee: S("coffee", 60437), snake: S("snake", 60438), game: S("game", 60439), vr: S("vr", 60440), chip: S("chip", 60441), piano: S("piano", 60442), music: S("music", 60443), micFilled: S("mic-filled", 60444), repoFetch: S("repo-fetch", 60445), copilot: S("copilot", 60446), lightbulbSparkle: S("lightbulb-sparkle", 60447), robot: S("robot", 60448), sparkleFilled: S("sparkle-filled", 60449), diffSingle: S("diff-single", 60450), diffMultiple: S("diff-multiple", 60451), surroundWith: S("surround-with", 60452), share: S("share", 60453), gitStash: S("git-stash", 60454), gitStashApply: S("git-stash-apply", 60455), gitStashPop: S("git-stash-pop", 60456), vscode: S("vscode", 60457), vscodeInsiders: S("vscode-insiders", 60458), codeOss: S("code-oss", 60459), runCoverage: S("run-coverage", 60460), runAllCoverage: S("run-all-coverage", 60461), coverage: S("coverage", 60462), githubProject: S("github-project", 60463), mapVertical: S("map-vertical", 60464), foldVertical: S("fold-vertical", 60464), mapVerticalFilled: S("map-vertical-filled", 60465), foldVerticalFilled: S("fold-vertical-filled", 60465), dialogError: S("dialog-error", "error"), dialogWarning: S("dialog-warning", "warning"), dialogInfo: S("dialog-info", "info"), dialogClose: S("dialog-close", "close"), treeItemExpanded: S("tree-item-expanded", "chevron-down"), treeFilterOnTypeOn: S("tree-filter-on-type-on", "list-filter"), treeFilterOnTypeOff: S("tree-filter-on-type-off", "list-selection"), treeFilterClear: S("tree-filter-clear", "close"), treeItemLoading: S("tree-item-loading", "loading"), menuSelection: S("menu-selection", "check"), menuSubmenu: S("menu-submenu", "chevron-right"), menuBarMore: S("menubar-more", "more"), scrollbarButtonLeft: S("scrollbar-button-left", "triangle-left"), scrollbarButtonRight: S("scrollbar-button-right", "triangle-right"), scrollbarButtonUp: S("scrollbar-button-up", "triangle-up"), scrollbarButtonDown: S("scrollbar-button-down", "triangle-down"), toolBarMore: S("toolbar-more", "more"), quickInputBack: S("quick-input-back", "arrow-left"), dropDownButton: S("drop-down-button", 60084), symbolCustomColor: S("symbol-customcolor", 60252), exportIcon: S("export", 60332), workspaceUnspecified: S("workspace-unspecified", 60355), newLine: S("newline", 60394), thumbsDownFilled: S("thumbsdown-filled", 60435), thumbsUpFilled: S("thumbsup-filled", 60436), gitFetch: S("git-fetch", 60445), lightbulbSparkleAutofix: S("lightbulb-sparkle-autofix", 60447), debugBreakpointPending: S("debug-breakpoint-pending", 60377) };
class CK extends V {
  get isResolved() {
    return this._isResolved;
  }
  constructor(e, t, i) {
    super(), this._registry = e, this._languageId = t, this._factory = i, this._isDisposed = !1, this._resolvePromise = null, this._isResolved = !1;
  }
  dispose() {
    this._isDisposed = !0, super.dispose();
  }
  async resolve() {
    return this._resolvePromise || (this._resolvePromise = this._create()), this._resolvePromise;
  }
  async _create() {
    const e = await this._factory.tokenizationSupport;
    this._isResolved = !0, e && !this._isDisposed && this._register(this._registry.register(this._languageId, e));
  }
}
let q0 = class {
  constructor(n, e, t) {
    this.offset = n, this.type = e, this.language = t, this._tokenBrand = void 0;
  }
  toString() {
    return "(" + this.offset + ", " + this.type + ")";
  }
};
class iR {
  constructor(e, t) {
    this.tokens = e, this.endState = t, this._tokenizationResultBrand = void 0;
  }
}
class PS {
  constructor(e, t) {
    this.tokens = e, this.endState = t, this._encodedTokenizationResultBrand = void 0;
  }
}
var $0, Ld, G0, cl, Z0;
(function(n) {
  const e = /* @__PURE__ */ new Map();
  e.set(0, ne.symbolMethod), e.set(1, ne.symbolFunction), e.set(2, ne.symbolConstructor), e.set(3, ne.symbolField), e.set(4, ne.symbolVariable), e.set(5, ne.symbolClass), e.set(6, ne.symbolStruct), e.set(7, ne.symbolInterface), e.set(8, ne.symbolModule), e.set(9, ne.symbolProperty), e.set(10, ne.symbolEvent), e.set(11, ne.symbolOperator), e.set(12, ne.symbolUnit), e.set(13, ne.symbolValue), e.set(15, ne.symbolEnum), e.set(14, ne.symbolConstant), e.set(15, ne.symbolEnum), e.set(16, ne.symbolEnumMember), e.set(17, ne.symbolKeyword), e.set(27, ne.symbolSnippet), e.set(18, ne.symbolText), e.set(19, ne.symbolColor), e.set(20, ne.symbolFile), e.set(21, ne.symbolReference), e.set(22, ne.symbolCustomColor), e.set(23, ne.symbolFolder), e.set(24, ne.symbolTypeParameter), e.set(25, ne.account), e.set(26, ne.issues), n.toIcon = function(i) {
    let s = e.get(i);
    return s || (console.info("No codicon found for CompletionItemKind " + i), s = ne.symbolProperty), s;
  };
  const t = /* @__PURE__ */ new Map();
  t.set("method", 0), t.set("function", 1), t.set("constructor", 2), t.set("field", 3), t.set("variable", 4), t.set("class", 5), t.set("struct", 6), t.set("interface", 7), t.set("module", 8), t.set("property", 9), t.set("event", 10), t.set("operator", 11), t.set("unit", 12), t.set("value", 13), t.set("constant", 14), t.set("enum", 15), t.set("enum-member", 16), t.set("enumMember", 16), t.set("keyword", 17), t.set("snippet", 27), t.set("text", 18), t.set("color", 19), t.set("file", 20), t.set("reference", 21), t.set("customcolor", 22), t.set("folder", 23), t.set("type-parameter", 24), t.set("typeParameter", 24), t.set("account", 25), t.set("issue", 26), n.fromString = function(i, s) {
    let o = t.get(i);
    return o !== void 0 || s || (o = 9), o;
  };
})($0 || ($0 = {})), (function(n) {
  n[n.Automatic = 0] = "Automatic", n[n.Explicit = 1] = "Explicit";
})(Ld || (Ld = {}));
class G7 {
  constructor(e, t, i, s) {
    this.range = e, this.text = t, this.completionKind = i, this.isSnippetText = s;
  }
  equals(e) {
    return D.lift(this.range).equalsRange(e.range) && this.text === e.text && this.completionKind === e.completionKind && this.isSnippetText === e.isSnippetText;
  }
}
(function(n) {
  n[n.Automatic = 0] = "Automatic", n[n.PasteAs = 1] = "PasteAs";
})(G0 || (G0 = {})), (function(n) {
  n[n.Invoke = 1] = "Invoke", n[n.TriggerCharacter = 2] = "TriggerCharacter", n[n.ContentChange = 3] = "ContentChange";
})(cl || (cl = {})), (function(n) {
  n[n.Text = 0] = "Text", n[n.Read = 1] = "Read", n[n.Write = 2] = "Write";
})(Z0 || (Z0 = {}));
const wK = { 17: m(0, "array"), 16: m(0, "boolean"), 4: m(0, "class"), 13: m(0, "constant"), 8: m(0, "constructor"), 9: m(0, "enumeration"), 21: m(0, "enumeration member"), 23: m(0, "event"), 7: m(0, "field"), 0: m(0, "file"), 11: m(0, "function"), 10: m(0, "interface"), 19: m(0, "key"), 5: m(0, "method"), 1: m(0, "module"), 2: m(0, "namespace"), 20: m(0, "null"), 15: m(0, "number"), 18: m(0, "object"), 24: m(0, "operator"), 3: m(0, "package"), 6: m(0, "property"), 14: m(0, "string"), 22: m(0, "struct"), 25: m(0, "type parameter"), 12: m(0, "variable") };
var Rw, IN, MN, Aw;
(function(n) {
  const e = /* @__PURE__ */ new Map();
  e.set(0, ne.symbolFile), e.set(1, ne.symbolModule), e.set(2, ne.symbolNamespace), e.set(3, ne.symbolPackage), e.set(4, ne.symbolClass), e.set(5, ne.symbolMethod), e.set(6, ne.symbolProperty), e.set(7, ne.symbolField), e.set(8, ne.symbolConstructor), e.set(9, ne.symbolEnum), e.set(10, ne.symbolInterface), e.set(11, ne.symbolFunction), e.set(12, ne.symbolVariable), e.set(13, ne.symbolConstant), e.set(14, ne.symbolString), e.set(15, ne.symbolNumber), e.set(16, ne.symbolBoolean), e.set(17, ne.symbolArray), e.set(18, ne.symbolObject), e.set(19, ne.symbolKey), e.set(20, ne.symbolNull), e.set(21, ne.symbolEnumMember), e.set(22, ne.symbolStruct), e.set(23, ne.symbolEvent), e.set(24, ne.symbolOperator), e.set(25, ne.symbolTypeParameter), n.toIcon = function(t) {
    let i = e.get(t);
    return i || (console.info("No codicon found for SymbolKind " + t), i = ne.symbolProperty), i;
  };
})(Rw || (Rw = {}));
class ls {
  static fromValue(e) {
    switch (e) {
      case "comment":
        return ls.Comment;
      case "imports":
        return ls.Imports;
      case "region":
        return ls.Region;
    }
    return new ls(e);
  }
  constructor(e) {
    this.value = e;
  }
}
ls.Comment = new ls("comment"), ls.Imports = new ls("imports"), ls.Region = new ls("region"), (function(n) {
  n[n.AIGenerated = 1] = "AIGenerated";
})(IN || (IN = {})), (MN || (MN = {})).is = function(n) {
  return !(!n || typeof n != "object") && typeof n.id == "string" && typeof n.title == "string";
}, (function(n) {
  n[n.Type = 1] = "Type", n[n.Parameter = 2] = "Parameter";
})(Aw || (Aw = {}));
class yK {
  constructor(e) {
    this.createSupport = e, this._tokenizationSupport = null;
  }
  dispose() {
    this._tokenizationSupport && this._tokenizationSupport.then(((e) => {
      e && e.dispose();
    }));
  }
  get tokenizationSupport() {
    return this._tokenizationSupport || (this._tokenizationSupport = this.createSupport()), this._tokenizationSupport;
  }
}
const ci = new class {
  constructor() {
    this._tokenizationSupports = /* @__PURE__ */ new Map(), this._factories = /* @__PURE__ */ new Map(), this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._colorMap = null;
  }
  handleChange(n) {
    this._onDidChange.fire({ changedLanguages: n, changedColorMap: !1 });
  }
  register(n, e) {
    return this._tokenizationSupports.set(n, e), this.handleChange([n]), ye((() => {
      this._tokenizationSupports.get(n) === e && (this._tokenizationSupports.delete(n), this.handleChange([n]));
    }));
  }
  get(n) {
    return this._tokenizationSupports.get(n) || null;
  }
  registerFactory(n, e) {
    var t;
    (t = this._factories.get(n)) === null || t === void 0 || t.dispose();
    const i = new CK(this, n, e);
    return this._factories.set(n, i), ye((() => {
      const s = this._factories.get(n);
      s && s === i && (this._factories.delete(n), s.dispose());
    }));
  }
  async getOrCreate(n) {
    const e = this.get(n);
    if (e) return e;
    const t = this._factories.get(n);
    return !t || t.isResolved ? null : (await t.resolve(), this.get(n));
  }
  isResolved(n) {
    if (this.get(n)) return !0;
    const e = this._factories.get(n);
    return !(e && !e.isResolved);
  }
  setColorMap(n) {
    this._colorMap = n, this._onDidChange.fire({ changedLanguages: Array.from(this._tokenizationSupports.keys()), changedColorMap: !0 });
  }
  getColorMap() {
    return this._colorMap;
  }
  getDefaultBackground() {
    return this._colorMap && this._colorMap.length > 2 ? this._colorMap[2] : null;
  }
}();
var Pw, TN, RN, AN, PN, ON, FN, BN, WN, VN, HN, zN, UN, KN, jN, qN, $N, GN, ZN, YN, XN, QN, JN, eE, tE, iE, nE, sE, oE, rE, aE, lE, dE, hE, cE, uE, gE, pE, mE, fE, _E, vE, bE, CE, wE;
(function(n) {
  n[n.Invoke = 0] = "Invoke", n[n.Automatic = 1] = "Automatic";
})(Pw || (Pw = {})), (function(n) {
  n[n.Unknown = 0] = "Unknown", n[n.Disabled = 1] = "Disabled", n[n.Enabled = 2] = "Enabled";
})(TN || (TN = {})), (function(n) {
  n[n.Invoke = 1] = "Invoke", n[n.Auto = 2] = "Auto";
})(RN || (RN = {})), (function(n) {
  n[n.None = 0] = "None", n[n.KeepWhitespace = 1] = "KeepWhitespace", n[n.InsertAsSnippet = 4] = "InsertAsSnippet";
})(AN || (AN = {})), (function(n) {
  n[n.Method = 0] = "Method", n[n.Function = 1] = "Function", n[n.Constructor = 2] = "Constructor", n[n.Field = 3] = "Field", n[n.Variable = 4] = "Variable", n[n.Class = 5] = "Class", n[n.Struct = 6] = "Struct", n[n.Interface = 7] = "Interface", n[n.Module = 8] = "Module", n[n.Property = 9] = "Property", n[n.Event = 10] = "Event", n[n.Operator = 11] = "Operator", n[n.Unit = 12] = "Unit", n[n.Value = 13] = "Value", n[n.Constant = 14] = "Constant", n[n.Enum = 15] = "Enum", n[n.EnumMember = 16] = "EnumMember", n[n.Keyword = 17] = "Keyword", n[n.Text = 18] = "Text", n[n.Color = 19] = "Color", n[n.File = 20] = "File", n[n.Reference = 21] = "Reference", n[n.Customcolor = 22] = "Customcolor", n[n.Folder = 23] = "Folder", n[n.TypeParameter = 24] = "TypeParameter", n[n.User = 25] = "User", n[n.Issue = 26] = "Issue", n[n.Snippet = 27] = "Snippet";
})(PN || (PN = {})), (function(n) {
  n[n.Deprecated = 1] = "Deprecated";
})(ON || (ON = {})), (function(n) {
  n[n.Invoke = 0] = "Invoke", n[n.TriggerCharacter = 1] = "TriggerCharacter", n[n.TriggerForIncompleteCompletions = 2] = "TriggerForIncompleteCompletions";
})(FN || (FN = {})), (function(n) {
  n[n.EXACT = 0] = "EXACT", n[n.ABOVE = 1] = "ABOVE", n[n.BELOW = 2] = "BELOW";
})(BN || (BN = {})), (function(n) {
  n[n.NotSet = 0] = "NotSet", n[n.ContentFlush = 1] = "ContentFlush", n[n.RecoverFromMarkers = 2] = "RecoverFromMarkers", n[n.Explicit = 3] = "Explicit", n[n.Paste = 4] = "Paste", n[n.Undo = 5] = "Undo", n[n.Redo = 6] = "Redo";
})(WN || (WN = {})), (function(n) {
  n[n.LF = 1] = "LF", n[n.CRLF = 2] = "CRLF";
})(VN || (VN = {})), (function(n) {
  n[n.Text = 0] = "Text", n[n.Read = 1] = "Read", n[n.Write = 2] = "Write";
})(HN || (HN = {})), (function(n) {
  n[n.None = 0] = "None", n[n.Keep = 1] = "Keep", n[n.Brackets = 2] = "Brackets", n[n.Advanced = 3] = "Advanced", n[n.Full = 4] = "Full";
})(zN || (zN = {})), (function(n) {
  n[n.acceptSuggestionOnCommitCharacter = 0] = "acceptSuggestionOnCommitCharacter", n[n.acceptSuggestionOnEnter = 1] = "acceptSuggestionOnEnter", n[n.accessibilitySupport = 2] = "accessibilitySupport", n[n.accessibilityPageSize = 3] = "accessibilityPageSize", n[n.ariaLabel = 4] = "ariaLabel", n[n.ariaRequired = 5] = "ariaRequired", n[n.autoClosingBrackets = 6] = "autoClosingBrackets", n[n.autoClosingComments = 7] = "autoClosingComments", n[n.screenReaderAnnounceInlineSuggestion = 8] = "screenReaderAnnounceInlineSuggestion", n[n.autoClosingDelete = 9] = "autoClosingDelete", n[n.autoClosingOvertype = 10] = "autoClosingOvertype", n[n.autoClosingQuotes = 11] = "autoClosingQuotes", n[n.autoIndent = 12] = "autoIndent", n[n.automaticLayout = 13] = "automaticLayout", n[n.autoSurround = 14] = "autoSurround", n[n.bracketPairColorization = 15] = "bracketPairColorization", n[n.guides = 16] = "guides", n[n.codeLens = 17] = "codeLens", n[n.codeLensFontFamily = 18] = "codeLensFontFamily", n[n.codeLensFontSize = 19] = "codeLensFontSize", n[n.colorDecorators = 20] = "colorDecorators", n[n.colorDecoratorsLimit = 21] = "colorDecoratorsLimit", n[n.columnSelection = 22] = "columnSelection", n[n.comments = 23] = "comments", n[n.contextmenu = 24] = "contextmenu", n[n.copyWithSyntaxHighlighting = 25] = "copyWithSyntaxHighlighting", n[n.cursorBlinking = 26] = "cursorBlinking", n[n.cursorSmoothCaretAnimation = 27] = "cursorSmoothCaretAnimation", n[n.cursorStyle = 28] = "cursorStyle", n[n.cursorSurroundingLines = 29] = "cursorSurroundingLines", n[n.cursorSurroundingLinesStyle = 30] = "cursorSurroundingLinesStyle", n[n.cursorWidth = 31] = "cursorWidth", n[n.disableLayerHinting = 32] = "disableLayerHinting", n[n.disableMonospaceOptimizations = 33] = "disableMonospaceOptimizations", n[n.domReadOnly = 34] = "domReadOnly", n[n.dragAndDrop = 35] = "dragAndDrop", n[n.dropIntoEditor = 36] = "dropIntoEditor", n[n.emptySelectionClipboard = 37] = "emptySelectionClipboard", n[n.experimentalWhitespaceRendering = 38] = "experimentalWhitespaceRendering", n[n.extraEditorClassName = 39] = "extraEditorClassName", n[n.fastScrollSensitivity = 40] = "fastScrollSensitivity", n[n.find = 41] = "find", n[n.fixedOverflowWidgets = 42] = "fixedOverflowWidgets", n[n.folding = 43] = "folding", n[n.foldingStrategy = 44] = "foldingStrategy", n[n.foldingHighlight = 45] = "foldingHighlight", n[n.foldingImportsByDefault = 46] = "foldingImportsByDefault", n[n.foldingMaximumRegions = 47] = "foldingMaximumRegions", n[n.unfoldOnClickAfterEndOfLine = 48] = "unfoldOnClickAfterEndOfLine", n[n.fontFamily = 49] = "fontFamily", n[n.fontInfo = 50] = "fontInfo", n[n.fontLigatures = 51] = "fontLigatures", n[n.fontSize = 52] = "fontSize", n[n.fontWeight = 53] = "fontWeight", n[n.fontVariations = 54] = "fontVariations", n[n.formatOnPaste = 55] = "formatOnPaste", n[n.formatOnType = 56] = "formatOnType", n[n.glyphMargin = 57] = "glyphMargin", n[n.gotoLocation = 58] = "gotoLocation", n[n.hideCursorInOverviewRuler = 59] = "hideCursorInOverviewRuler", n[n.hover = 60] = "hover", n[n.inDiffEditor = 61] = "inDiffEditor", n[n.inlineSuggest = 62] = "inlineSuggest", n[n.inlineEdit = 63] = "inlineEdit", n[n.letterSpacing = 64] = "letterSpacing", n[n.lightbulb = 65] = "lightbulb", n[n.lineDecorationsWidth = 66] = "lineDecorationsWidth", n[n.lineHeight = 67] = "lineHeight", n[n.lineNumbers = 68] = "lineNumbers", n[n.lineNumbersMinChars = 69] = "lineNumbersMinChars", n[n.linkedEditing = 70] = "linkedEditing", n[n.links = 71] = "links", n[n.matchBrackets = 72] = "matchBrackets", n[n.minimap = 73] = "minimap", n[n.mouseStyle = 74] = "mouseStyle", n[n.mouseWheelScrollSensitivity = 75] = "mouseWheelScrollSensitivity", n[n.mouseWheelZoom = 76] = "mouseWheelZoom", n[n.multiCursorMergeOverlapping = 77] = "multiCursorMergeOverlapping", n[n.multiCursorModifier = 78] = "multiCursorModifier", n[n.multiCursorPaste = 79] = "multiCursorPaste", n[n.multiCursorLimit = 80] = "multiCursorLimit", n[n.occurrencesHighlight = 81] = "occurrencesHighlight", n[n.overviewRulerBorder = 82] = "overviewRulerBorder", n[n.overviewRulerLanes = 83] = "overviewRulerLanes", n[n.padding = 84] = "padding", n[n.pasteAs = 85] = "pasteAs", n[n.parameterHints = 86] = "parameterHints", n[n.peekWidgetDefaultFocus = 87] = "peekWidgetDefaultFocus", n[n.definitionLinkOpensInPeek = 88] = "definitionLinkOpensInPeek", n[n.quickSuggestions = 89] = "quickSuggestions", n[n.quickSuggestionsDelay = 90] = "quickSuggestionsDelay", n[n.readOnly = 91] = "readOnly", n[n.readOnlyMessage = 92] = "readOnlyMessage", n[n.renameOnType = 93] = "renameOnType", n[n.renderControlCharacters = 94] = "renderControlCharacters", n[n.renderFinalNewline = 95] = "renderFinalNewline", n[n.renderLineHighlight = 96] = "renderLineHighlight", n[n.renderLineHighlightOnlyWhenFocus = 97] = "renderLineHighlightOnlyWhenFocus", n[n.renderValidationDecorations = 98] = "renderValidationDecorations", n[n.renderWhitespace = 99] = "renderWhitespace", n[n.revealHorizontalRightPadding = 100] = "revealHorizontalRightPadding", n[n.roundedSelection = 101] = "roundedSelection", n[n.rulers = 102] = "rulers", n[n.scrollbar = 103] = "scrollbar", n[n.scrollBeyondLastColumn = 104] = "scrollBeyondLastColumn", n[n.scrollBeyondLastLine = 105] = "scrollBeyondLastLine", n[n.scrollPredominantAxis = 106] = "scrollPredominantAxis", n[n.selectionClipboard = 107] = "selectionClipboard", n[n.selectionHighlight = 108] = "selectionHighlight", n[n.selectOnLineNumbers = 109] = "selectOnLineNumbers", n[n.showFoldingControls = 110] = "showFoldingControls", n[n.showUnused = 111] = "showUnused", n[n.snippetSuggestions = 112] = "snippetSuggestions", n[n.smartSelect = 113] = "smartSelect", n[n.smoothScrolling = 114] = "smoothScrolling", n[n.stickyScroll = 115] = "stickyScroll", n[n.stickyTabStops = 116] = "stickyTabStops", n[n.stopRenderingLineAfter = 117] = "stopRenderingLineAfter", n[n.suggest = 118] = "suggest", n[n.suggestFontSize = 119] = "suggestFontSize", n[n.suggestLineHeight = 120] = "suggestLineHeight", n[n.suggestOnTriggerCharacters = 121] = "suggestOnTriggerCharacters", n[n.suggestSelection = 122] = "suggestSelection", n[n.tabCompletion = 123] = "tabCompletion", n[n.tabIndex = 124] = "tabIndex", n[n.unicodeHighlighting = 125] = "unicodeHighlighting", n[n.unusualLineTerminators = 126] = "unusualLineTerminators", n[n.useShadowDOM = 127] = "useShadowDOM", n[n.useTabStops = 128] = "useTabStops", n[n.wordBreak = 129] = "wordBreak", n[n.wordSegmenterLocales = 130] = "wordSegmenterLocales", n[n.wordSeparators = 131] = "wordSeparators", n[n.wordWrap = 132] = "wordWrap", n[n.wordWrapBreakAfterCharacters = 133] = "wordWrapBreakAfterCharacters", n[n.wordWrapBreakBeforeCharacters = 134] = "wordWrapBreakBeforeCharacters", n[n.wordWrapColumn = 135] = "wordWrapColumn", n[n.wordWrapOverride1 = 136] = "wordWrapOverride1", n[n.wordWrapOverride2 = 137] = "wordWrapOverride2", n[n.wrappingIndent = 138] = "wrappingIndent", n[n.wrappingStrategy = 139] = "wrappingStrategy", n[n.showDeprecated = 140] = "showDeprecated", n[n.inlayHints = 141] = "inlayHints", n[n.editorClassName = 142] = "editorClassName", n[n.pixelRatio = 143] = "pixelRatio", n[n.tabFocusMode = 144] = "tabFocusMode", n[n.layoutInfo = 145] = "layoutInfo", n[n.wrappingInfo = 146] = "wrappingInfo", n[n.defaultColorDecorators = 147] = "defaultColorDecorators", n[n.colorDecoratorsActivatedOn = 148] = "colorDecoratorsActivatedOn", n[n.inlineCompletionsAccessibilityVerbose = 149] = "inlineCompletionsAccessibilityVerbose";
})(UN || (UN = {})), (function(n) {
  n[n.TextDefined = 0] = "TextDefined", n[n.LF = 1] = "LF", n[n.CRLF = 2] = "CRLF";
})(KN || (KN = {})), (function(n) {
  n[n.LF = 0] = "LF", n[n.CRLF = 1] = "CRLF";
})(jN || (jN = {})), (function(n) {
  n[n.Left = 1] = "Left", n[n.Center = 2] = "Center", n[n.Right = 3] = "Right";
})(qN || (qN = {})), (function(n) {
  n[n.None = 0] = "None", n[n.Indent = 1] = "Indent", n[n.IndentOutdent = 2] = "IndentOutdent", n[n.Outdent = 3] = "Outdent";
})($N || ($N = {})), (function(n) {
  n[n.Both = 0] = "Both", n[n.Right = 1] = "Right", n[n.Left = 2] = "Left", n[n.None = 3] = "None";
})(GN || (GN = {})), (function(n) {
  n[n.Type = 1] = "Type", n[n.Parameter = 2] = "Parameter";
})(ZN || (ZN = {})), (function(n) {
  n[n.Automatic = 0] = "Automatic", n[n.Explicit = 1] = "Explicit";
})(YN || (YN = {})), (function(n) {
  n[n.Invoke = 0] = "Invoke", n[n.Automatic = 1] = "Automatic";
})(XN || (XN = {})), (function(n) {
  n[n.DependsOnKbLayout = -1] = "DependsOnKbLayout", n[n.Unknown = 0] = "Unknown", n[n.Backspace = 1] = "Backspace", n[n.Tab = 2] = "Tab", n[n.Enter = 3] = "Enter", n[n.Shift = 4] = "Shift", n[n.Ctrl = 5] = "Ctrl", n[n.Alt = 6] = "Alt", n[n.PauseBreak = 7] = "PauseBreak", n[n.CapsLock = 8] = "CapsLock", n[n.Escape = 9] = "Escape", n[n.Space = 10] = "Space", n[n.PageUp = 11] = "PageUp", n[n.PageDown = 12] = "PageDown", n[n.End = 13] = "End", n[n.Home = 14] = "Home", n[n.LeftArrow = 15] = "LeftArrow", n[n.UpArrow = 16] = "UpArrow", n[n.RightArrow = 17] = "RightArrow", n[n.DownArrow = 18] = "DownArrow", n[n.Insert = 19] = "Insert", n[n.Delete = 20] = "Delete", n[n.Digit0 = 21] = "Digit0", n[n.Digit1 = 22] = "Digit1", n[n.Digit2 = 23] = "Digit2", n[n.Digit3 = 24] = "Digit3", n[n.Digit4 = 25] = "Digit4", n[n.Digit5 = 26] = "Digit5", n[n.Digit6 = 27] = "Digit6", n[n.Digit7 = 28] = "Digit7", n[n.Digit8 = 29] = "Digit8", n[n.Digit9 = 30] = "Digit9", n[n.KeyA = 31] = "KeyA", n[n.KeyB = 32] = "KeyB", n[n.KeyC = 33] = "KeyC", n[n.KeyD = 34] = "KeyD", n[n.KeyE = 35] = "KeyE", n[n.KeyF = 36] = "KeyF", n[n.KeyG = 37] = "KeyG", n[n.KeyH = 38] = "KeyH", n[n.KeyI = 39] = "KeyI", n[n.KeyJ = 40] = "KeyJ", n[n.KeyK = 41] = "KeyK", n[n.KeyL = 42] = "KeyL", n[n.KeyM = 43] = "KeyM", n[n.KeyN = 44] = "KeyN", n[n.KeyO = 45] = "KeyO", n[n.KeyP = 46] = "KeyP", n[n.KeyQ = 47] = "KeyQ", n[n.KeyR = 48] = "KeyR", n[n.KeyS = 49] = "KeyS", n[n.KeyT = 50] = "KeyT", n[n.KeyU = 51] = "KeyU", n[n.KeyV = 52] = "KeyV", n[n.KeyW = 53] = "KeyW", n[n.KeyX = 54] = "KeyX", n[n.KeyY = 55] = "KeyY", n[n.KeyZ = 56] = "KeyZ", n[n.Meta = 57] = "Meta", n[n.ContextMenu = 58] = "ContextMenu", n[n.F1 = 59] = "F1", n[n.F2 = 60] = "F2", n[n.F3 = 61] = "F3", n[n.F4 = 62] = "F4", n[n.F5 = 63] = "F5", n[n.F6 = 64] = "F6", n[n.F7 = 65] = "F7", n[n.F8 = 66] = "F8", n[n.F9 = 67] = "F9", n[n.F10 = 68] = "F10", n[n.F11 = 69] = "F11", n[n.F12 = 70] = "F12", n[n.F13 = 71] = "F13", n[n.F14 = 72] = "F14", n[n.F15 = 73] = "F15", n[n.F16 = 74] = "F16", n[n.F17 = 75] = "F17", n[n.F18 = 76] = "F18", n[n.F19 = 77] = "F19", n[n.F20 = 78] = "F20", n[n.F21 = 79] = "F21", n[n.F22 = 80] = "F22", n[n.F23 = 81] = "F23", n[n.F24 = 82] = "F24", n[n.NumLock = 83] = "NumLock", n[n.ScrollLock = 84] = "ScrollLock", n[n.Semicolon = 85] = "Semicolon", n[n.Equal = 86] = "Equal", n[n.Comma = 87] = "Comma", n[n.Minus = 88] = "Minus", n[n.Period = 89] = "Period", n[n.Slash = 90] = "Slash", n[n.Backquote = 91] = "Backquote", n[n.BracketLeft = 92] = "BracketLeft", n[n.Backslash = 93] = "Backslash", n[n.BracketRight = 94] = "BracketRight", n[n.Quote = 95] = "Quote", n[n.OEM_8 = 96] = "OEM_8", n[n.IntlBackslash = 97] = "IntlBackslash", n[n.Numpad0 = 98] = "Numpad0", n[n.Numpad1 = 99] = "Numpad1", n[n.Numpad2 = 100] = "Numpad2", n[n.Numpad3 = 101] = "Numpad3", n[n.Numpad4 = 102] = "Numpad4", n[n.Numpad5 = 103] = "Numpad5", n[n.Numpad6 = 104] = "Numpad6", n[n.Numpad7 = 105] = "Numpad7", n[n.Numpad8 = 106] = "Numpad8", n[n.Numpad9 = 107] = "Numpad9", n[n.NumpadMultiply = 108] = "NumpadMultiply", n[n.NumpadAdd = 109] = "NumpadAdd", n[n.NUMPAD_SEPARATOR = 110] = "NUMPAD_SEPARATOR", n[n.NumpadSubtract = 111] = "NumpadSubtract", n[n.NumpadDecimal = 112] = "NumpadDecimal", n[n.NumpadDivide = 113] = "NumpadDivide", n[n.KEY_IN_COMPOSITION = 114] = "KEY_IN_COMPOSITION", n[n.ABNT_C1 = 115] = "ABNT_C1", n[n.ABNT_C2 = 116] = "ABNT_C2", n[n.AudioVolumeMute = 117] = "AudioVolumeMute", n[n.AudioVolumeUp = 118] = "AudioVolumeUp", n[n.AudioVolumeDown = 119] = "AudioVolumeDown", n[n.BrowserSearch = 120] = "BrowserSearch", n[n.BrowserHome = 121] = "BrowserHome", n[n.BrowserBack = 122] = "BrowserBack", n[n.BrowserForward = 123] = "BrowserForward", n[n.MediaTrackNext = 124] = "MediaTrackNext", n[n.MediaTrackPrevious = 125] = "MediaTrackPrevious", n[n.MediaStop = 126] = "MediaStop", n[n.MediaPlayPause = 127] = "MediaPlayPause", n[n.LaunchMediaPlayer = 128] = "LaunchMediaPlayer", n[n.LaunchMail = 129] = "LaunchMail", n[n.LaunchApp2 = 130] = "LaunchApp2", n[n.Clear = 131] = "Clear", n[n.MAX_VALUE = 132] = "MAX_VALUE";
})(QN || (QN = {})), (function(n) {
  n[n.Hint = 1] = "Hint", n[n.Info = 2] = "Info", n[n.Warning = 4] = "Warning", n[n.Error = 8] = "Error";
})(JN || (JN = {})), (function(n) {
  n[n.Unnecessary = 1] = "Unnecessary", n[n.Deprecated = 2] = "Deprecated";
})(eE || (eE = {})), (function(n) {
  n[n.Inline = 1] = "Inline", n[n.Gutter = 2] = "Gutter";
})(tE || (tE = {})), (function(n) {
  n[n.Normal = 1] = "Normal", n[n.Underlined = 2] = "Underlined";
})(iE || (iE = {})), (function(n) {
  n[n.UNKNOWN = 0] = "UNKNOWN", n[n.TEXTAREA = 1] = "TEXTAREA", n[n.GUTTER_GLYPH_MARGIN = 2] = "GUTTER_GLYPH_MARGIN", n[n.GUTTER_LINE_NUMBERS = 3] = "GUTTER_LINE_NUMBERS", n[n.GUTTER_LINE_DECORATIONS = 4] = "GUTTER_LINE_DECORATIONS", n[n.GUTTER_VIEW_ZONE = 5] = "GUTTER_VIEW_ZONE", n[n.CONTENT_TEXT = 6] = "CONTENT_TEXT", n[n.CONTENT_EMPTY = 7] = "CONTENT_EMPTY", n[n.CONTENT_VIEW_ZONE = 8] = "CONTENT_VIEW_ZONE", n[n.CONTENT_WIDGET = 9] = "CONTENT_WIDGET", n[n.OVERVIEW_RULER = 10] = "OVERVIEW_RULER", n[n.SCROLLBAR = 11] = "SCROLLBAR", n[n.OVERLAY_WIDGET = 12] = "OVERLAY_WIDGET", n[n.OUTSIDE_EDITOR = 13] = "OUTSIDE_EDITOR";
})(nE || (nE = {})), (function(n) {
  n[n.AIGenerated = 1] = "AIGenerated";
})(sE || (sE = {})), (function(n) {
  n[n.TOP_RIGHT_CORNER = 0] = "TOP_RIGHT_CORNER", n[n.BOTTOM_RIGHT_CORNER = 1] = "BOTTOM_RIGHT_CORNER", n[n.TOP_CENTER = 2] = "TOP_CENTER";
})(oE || (oE = {})), (function(n) {
  n[n.Left = 1] = "Left", n[n.Center = 2] = "Center", n[n.Right = 4] = "Right", n[n.Full = 7] = "Full";
})(rE || (rE = {})), (function(n) {
  n[n.Word = 0] = "Word", n[n.Line = 1] = "Line", n[n.Suggest = 2] = "Suggest";
})(aE || (aE = {})), (function(n) {
  n[n.Left = 0] = "Left", n[n.Right = 1] = "Right", n[n.None = 2] = "None", n[n.LeftOfInjectedText = 3] = "LeftOfInjectedText", n[n.RightOfInjectedText = 4] = "RightOfInjectedText";
})(lE || (lE = {})), (function(n) {
  n[n.Off = 0] = "Off", n[n.On = 1] = "On", n[n.Relative = 2] = "Relative", n[n.Interval = 3] = "Interval", n[n.Custom = 4] = "Custom";
})(dE || (dE = {})), (function(n) {
  n[n.None = 0] = "None", n[n.Text = 1] = "Text", n[n.Blocks = 2] = "Blocks";
})(hE || (hE = {})), (function(n) {
  n[n.Smooth = 0] = "Smooth", n[n.Immediate = 1] = "Immediate";
})(cE || (cE = {})), (function(n) {
  n[n.Auto = 1] = "Auto", n[n.Hidden = 2] = "Hidden", n[n.Visible = 3] = "Visible";
})(uE || (uE = {})), (function(n) {
  n[n.LTR = 0] = "LTR", n[n.RTL = 1] = "RTL";
})(gE || (gE = {})), (function(n) {
  n.Off = "off", n.OnCode = "onCode", n.On = "on";
})(pE || (pE = {})), (function(n) {
  n[n.Invoke = 1] = "Invoke", n[n.TriggerCharacter = 2] = "TriggerCharacter", n[n.ContentChange = 3] = "ContentChange";
})(mE || (mE = {})), (function(n) {
  n[n.File = 0] = "File", n[n.Module = 1] = "Module", n[n.Namespace = 2] = "Namespace", n[n.Package = 3] = "Package", n[n.Class = 4] = "Class", n[n.Method = 5] = "Method", n[n.Property = 6] = "Property", n[n.Field = 7] = "Field", n[n.Constructor = 8] = "Constructor", n[n.Enum = 9] = "Enum", n[n.Interface = 10] = "Interface", n[n.Function = 11] = "Function", n[n.Variable = 12] = "Variable", n[n.Constant = 13] = "Constant", n[n.String = 14] = "String", n[n.Number = 15] = "Number", n[n.Boolean = 16] = "Boolean", n[n.Array = 17] = "Array", n[n.Object = 18] = "Object", n[n.Key = 19] = "Key", n[n.Null = 20] = "Null", n[n.EnumMember = 21] = "EnumMember", n[n.Struct = 22] = "Struct", n[n.Event = 23] = "Event", n[n.Operator = 24] = "Operator", n[n.TypeParameter = 25] = "TypeParameter";
})(fE || (fE = {})), (function(n) {
  n[n.Deprecated = 1] = "Deprecated";
})(_E || (_E = {})), (function(n) {
  n[n.Hidden = 0] = "Hidden", n[n.Blink = 1] = "Blink", n[n.Smooth = 2] = "Smooth", n[n.Phase = 3] = "Phase", n[n.Expand = 4] = "Expand", n[n.Solid = 5] = "Solid";
})(vE || (vE = {})), (function(n) {
  n[n.Line = 1] = "Line", n[n.Block = 2] = "Block", n[n.Underline = 3] = "Underline", n[n.LineThin = 4] = "LineThin", n[n.BlockOutline = 5] = "BlockOutline", n[n.UnderlineThin = 6] = "UnderlineThin";
})(bE || (bE = {})), (function(n) {
  n[n.AlwaysGrowsWhenTypingAtEdges = 0] = "AlwaysGrowsWhenTypingAtEdges", n[n.NeverGrowsWhenTypingAtEdges = 1] = "NeverGrowsWhenTypingAtEdges", n[n.GrowsOnlyWhenTypingBefore = 2] = "GrowsOnlyWhenTypingBefore", n[n.GrowsOnlyWhenTypingAfter = 3] = "GrowsOnlyWhenTypingAfter";
})(CE || (CE = {})), (function(n) {
  n[n.None = 0] = "None", n[n.Same = 1] = "Same", n[n.Indent = 2] = "Indent", n[n.DeepIndent = 3] = "DeepIndent";
})(wE || (wE = {}));
let h_ = class {
  static chord(n, e) {
    return Vi(n, e);
  }
};
function Z7() {
  return { editor: void 0, languages: void 0, CancellationTokenSource: Ci, Emitter: F, KeyCode: QN, KeyMod: h_, Position: W, Range: D, Selection: _e, SelectionDirection: gE, MarkerSeverity: JN, MarkerTag: eE, Uri: Ie, Token: q0 };
}
h_.CtrlCmd = 2048, h_.Shift = 1024, h_.Alt = 512, h_.WinCtrl = 256;
const It = window;
class rO {
  get cachedValues() {
    return this._map;
  }
  constructor(e) {
    this.fn = e, this._map = /* @__PURE__ */ new Map();
  }
  get(e) {
    if (this._map.has(e)) return this._map.get(e);
    const t = this.fn(e);
    return this._map.set(e, t), t;
  }
}
class ua {
  constructor(e) {
    this.executor = e, this._didRun = !1;
  }
  get value() {
    if (!this._didRun) try {
      this._value = this.executor();
    } catch (e) {
      this._error = e;
    } finally {
      this._didRun = !0;
    }
    if (this._error) throw this._error;
    return this._value;
  }
  get rawValue() {
    return this._value;
  }
}
var Sp;
function Y7(n) {
  return !n || typeof n != "string" || n.trim().length === 0;
}
const SK = /{(\d+)}/g;
function sg(n, ...e) {
  return e.length === 0 ? n : n.replace(SK, (function(t, i) {
    const s = parseInt(i, 10);
    return isNaN(s) || s < 0 || s >= e.length ? t : e[s];
  }));
}
function Ow(n) {
  return n.replace(/[<>&]/g, (function(e) {
    switch (e) {
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case "&":
        return "&amp;";
      default:
        return e;
    }
  }));
}
function No(n) {
  return n.replace(/[\\\{\}\*\+\?\|\^\$\.\[\]\(\)]/g, "\\$&");
}
function LK(n, e = " ") {
  return X7(u1(n, e), e);
}
function u1(n, e) {
  if (!n || !e) return n;
  const t = e.length;
  if (t === 0 || n.length === 0) return n;
  let i = 0;
  for (; n.indexOf(e, i) === i; ) i += t;
  return n.substring(i);
}
function X7(n, e) {
  if (!n || !e) return n;
  const t = e.length, i = n.length;
  if (t === 0 || i === 0) return n;
  let s = i, o = -1;
  for (; o = n.lastIndexOf(e, s - 1), o !== -1 && o + t === s; ) {
    if (o === 0) return "";
    s = o;
  }
  return n.substring(0, s);
}
function Q7(n, e, t = {}) {
  if (!n) throw new Error("Cannot create regex from empty string");
  e || (n = No(n)), t.wholeWord && (/\B/.test(n.charAt(0)) || (n = "\\b" + n), /\B/.test(n.charAt(n.length - 1)) || (n += "\\b"));
  let i = "";
  return t.global && (i += "g"), t.matchCase || (i += "i"), t.multiline && (i += "m"), t.unicode && (i += "u"), new RegExp(n, i);
}
function Sl(n) {
  return n.split(/\r\n|\r|\n/);
}
function Jn(n) {
  for (let e = 0, t = n.length; e < t; e++) {
    const i = n.charCodeAt(e);
    if (i !== 32 && i !== 9) return e;
  }
  return -1;
}
function Wt(n, e = 0, t = n.length) {
  for (let i = e; i < t; i++) {
    const s = n.charCodeAt(i);
    if (s !== 32 && s !== 9) return n.substring(e, i);
  }
  return n.substring(e, t);
}
function oa(n, e = n.length - 1) {
  for (let t = e; t >= 0; t--) {
    const i = n.charCodeAt(t);
    if (i !== 32 && i !== 9) return t;
  }
  return -1;
}
function Y0(n, e) {
  return n < e ? -1 : n > e ? 1 : 0;
}
function nR(n, e, t = 0, i = n.length, s = 0, o = e.length) {
  for (; t < i && s < o; t++, s++) {
    const l = n.charCodeAt(t), d = e.charCodeAt(s);
    if (l < d) return -1;
    if (l > d) return 1;
  }
  const r = i - t, a = o - s;
  return r < a ? -1 : r > a ? 1 : 0;
}
function yE(n, e) {
  return g1(n, e, 0, n.length, 0, e.length);
}
function g1(n, e, t = 0, i = n.length, s = 0, o = e.length) {
  for (; t < i && s < o; t++, s++) {
    let l = n.charCodeAt(t), d = e.charCodeAt(s);
    if (l === d) continue;
    if (l >= 128 || d >= 128) return nR(n.toLowerCase(), e.toLowerCase(), t, i, s, o);
    Nh(l) && (l -= 32), Nh(d) && (d -= 32);
    const h = l - d;
    if (h !== 0) return h;
  }
  const r = i - t, a = o - s;
  return r < a ? -1 : r > a ? 1 : 0;
}
function Y1(n) {
  return n >= 48 && n <= 57;
}
function Nh(n) {
  return n >= 97 && n <= 122;
}
function Ba(n) {
  return n >= 65 && n <= 90;
}
function Lp(n, e) {
  return n.length === e.length && g1(n, e) === 0;
}
function sR(n, e) {
  const t = e.length;
  return !(e.length > n.length) && g1(n, e, 0, t) === 0;
}
function mc(n, e) {
  const t = Math.min(n.length, e.length);
  let i;
  for (i = 0; i < t; i++) if (n.charCodeAt(i) !== e.charCodeAt(i)) return i;
  return t;
}
function Fw(n, e) {
  const t = Math.min(n.length, e.length);
  let i;
  const s = n.length - 1, o = e.length - 1;
  for (i = 0; i < t; i++) if (n.charCodeAt(s - i) !== e.charCodeAt(o - i)) return i;
  return t;
}
function en(n) {
  return 55296 <= n && n <= 56319;
}
function og(n) {
  return 56320 <= n && n <= 57343;
}
function oR(n, e) {
  return e - 56320 + (n - 55296 << 10) + 65536;
}
function Bw(n, e, t) {
  const i = n.charCodeAt(t);
  if (en(i) && t + 1 < e) {
    const s = n.charCodeAt(t + 1);
    if (og(s)) return oR(i, s);
  }
  return i;
}
class SE {
  get offset() {
    return this._offset;
  }
  constructor(e, t = 0) {
    this._str = e, this._len = e.length, this._offset = t;
  }
  setOffset(e) {
    this._offset = e;
  }
  prevCodePoint() {
    const e = (function(t, i) {
      const s = t.charCodeAt(i - 1);
      if (og(s) && i > 1) {
        const o = t.charCodeAt(i - 2);
        if (en(o)) return oR(o, s);
      }
      return s;
    })(this._str, this._offset);
    return this._offset -= e >= 65536 ? 2 : 1, e;
  }
  nextCodePoint() {
    const e = Bw(this._str, this._len, this._offset);
    return this._offset += e >= 65536 ? 2 : 1, e;
  }
  eol() {
    return this._offset >= this._len;
  }
}
class Ww {
  get offset() {
    return this._iterator.offset;
  }
  constructor(e, t = 0) {
    this._iterator = new SE(e, t);
  }
  nextGraphemeLength() {
    const e = Eh.getInstance(), t = this._iterator, i = t.offset;
    let s = e.getGraphemeBreakType(t.nextCodePoint());
    for (; !t.eol(); ) {
      const o = t.offset, r = e.getGraphemeBreakType(t.nextCodePoint());
      if (aO(s, r)) {
        t.setOffset(o);
        break;
      }
      s = r;
    }
    return t.offset - i;
  }
  prevGraphemeLength() {
    const e = Eh.getInstance(), t = this._iterator, i = t.offset;
    let s = e.getGraphemeBreakType(t.prevCodePoint());
    for (; t.offset > 0; ) {
      const o = t.offset, r = e.getGraphemeBreakType(t.prevCodePoint());
      if (aO(r, s)) {
        t.setOffset(o);
        break;
      }
      s = r;
    }
    return i - t.offset;
  }
  eol() {
    return this._iterator.eol();
  }
}
function rR(n, e) {
  return new Ww(n, e).nextGraphemeLength();
}
function J7(n, e) {
  return new Ww(n, e).prevGraphemeLength();
}
let Ak;
function Pm(n) {
  return Ak || (Ak = /(?:[\u05BE\u05C0\u05C3\u05C6\u05D0-\u05F4\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u0710\u0712-\u072F\u074D-\u07A5\u07B1-\u07EA\u07F4\u07F5\u07FA\u07FE-\u0815\u081A\u0824\u0828\u0830-\u0858\u085E-\u088E\u08A0-\u08C9\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFD3D\uFD50-\uFDC7\uFDF0-\uFDFC\uFE70-\uFEFC]|\uD802[\uDC00-\uDD1B\uDD20-\uDE00\uDE10-\uDE35\uDE40-\uDEE4\uDEEB-\uDF35\uDF40-\uDFFF]|\uD803[\uDC00-\uDD23\uDE80-\uDEA9\uDEAD-\uDF45\uDF51-\uDF81\uDF86-\uDFF6]|\uD83A[\uDC00-\uDCCF\uDD00-\uDD43\uDD4B-\uDFFF]|\uD83B[\uDC00-\uDEBB])/), Ak.test(n);
}
const kK = /^[\t\n\r\x20-\x7E]*$/;
function p1(n) {
  return kK.test(n);
}
const e8 = /[\u2028\u2029]/;
function t8(n) {
  return e8.test(n);
}
function fc(n) {
  return n >= 11904 && n <= 55215 || n >= 63744 && n <= 64255 || n >= 65281 && n <= 65374;
}
function aR(n) {
  return n >= 127462 && n <= 127487 || n === 8986 || n === 8987 || n === 9200 || n === 9203 || n >= 9728 && n <= 10175 || n === 11088 || n === 11093 || n >= 127744 && n <= 128591 || n >= 128640 && n <= 128764 || n >= 128992 && n <= 129008 || n >= 129280 && n <= 129535 || n >= 129648 && n <= 129782;
}
const DK = "\uFEFF";
function lR(n) {
  return !!(n && n.length > 0 && n.charCodeAt(0) === 65279);
}
function i8(n) {
  return (n %= 52) < 26 ? String.fromCharCode(97 + n) : String.fromCharCode(65 + n - 26);
}
function aO(n, e) {
  return n === 0 ? e !== 5 && e !== 7 : (n !== 2 || e !== 3) && (n === 4 || n === 2 || n === 3 || e === 4 || e === 2 || e === 3 || (n !== 8 || e !== 8 && e !== 9 && e !== 11 && e !== 12) && (n !== 11 && n !== 9 || e !== 9 && e !== 10) && (n !== 12 && n !== 10 || e !== 10) && e !== 5 && e !== 13 && e !== 7 && n !== 1 && (n !== 13 || e !== 14) && (n !== 6 || e !== 6));
}
class Eh {
  static getInstance() {
    return Eh._INSTANCE || (Eh._INSTANCE = new Eh()), Eh._INSTANCE;
  }
  constructor() {
    this._data = JSON.parse("[0,0,0,51229,51255,12,44061,44087,12,127462,127487,6,7083,7085,5,47645,47671,12,54813,54839,12,128678,128678,14,3270,3270,5,9919,9923,14,45853,45879,12,49437,49463,12,53021,53047,12,71216,71218,7,128398,128399,14,129360,129374,14,2519,2519,5,4448,4519,9,9742,9742,14,12336,12336,14,44957,44983,12,46749,46775,12,48541,48567,12,50333,50359,12,52125,52151,12,53917,53943,12,69888,69890,5,73018,73018,5,127990,127990,14,128558,128559,14,128759,128760,14,129653,129655,14,2027,2035,5,2891,2892,7,3761,3761,5,6683,6683,5,8293,8293,4,9825,9826,14,9999,9999,14,43452,43453,5,44509,44535,12,45405,45431,12,46301,46327,12,47197,47223,12,48093,48119,12,48989,49015,12,49885,49911,12,50781,50807,12,51677,51703,12,52573,52599,12,53469,53495,12,54365,54391,12,65279,65279,4,70471,70472,7,72145,72147,7,119173,119179,5,127799,127818,14,128240,128244,14,128512,128512,14,128652,128652,14,128721,128722,14,129292,129292,14,129445,129450,14,129734,129743,14,1476,1477,5,2366,2368,7,2750,2752,7,3076,3076,5,3415,3415,5,4141,4144,5,6109,6109,5,6964,6964,5,7394,7400,5,9197,9198,14,9770,9770,14,9877,9877,14,9968,9969,14,10084,10084,14,43052,43052,5,43713,43713,5,44285,44311,12,44733,44759,12,45181,45207,12,45629,45655,12,46077,46103,12,46525,46551,12,46973,46999,12,47421,47447,12,47869,47895,12,48317,48343,12,48765,48791,12,49213,49239,12,49661,49687,12,50109,50135,12,50557,50583,12,51005,51031,12,51453,51479,12,51901,51927,12,52349,52375,12,52797,52823,12,53245,53271,12,53693,53719,12,54141,54167,12,54589,54615,12,55037,55063,12,69506,69509,5,70191,70193,5,70841,70841,7,71463,71467,5,72330,72342,5,94031,94031,5,123628,123631,5,127763,127765,14,127941,127941,14,128043,128062,14,128302,128317,14,128465,128467,14,128539,128539,14,128640,128640,14,128662,128662,14,128703,128703,14,128745,128745,14,129004,129007,14,129329,129330,14,129402,129402,14,129483,129483,14,129686,129704,14,130048,131069,14,173,173,4,1757,1757,1,2200,2207,5,2434,2435,7,2631,2632,5,2817,2817,5,3008,3008,5,3201,3201,5,3387,3388,5,3542,3542,5,3902,3903,7,4190,4192,5,6002,6003,5,6439,6440,5,6765,6770,7,7019,7027,5,7154,7155,7,8205,8205,13,8505,8505,14,9654,9654,14,9757,9757,14,9792,9792,14,9852,9853,14,9890,9894,14,9937,9937,14,9981,9981,14,10035,10036,14,11035,11036,14,42654,42655,5,43346,43347,7,43587,43587,5,44006,44007,7,44173,44199,12,44397,44423,12,44621,44647,12,44845,44871,12,45069,45095,12,45293,45319,12,45517,45543,12,45741,45767,12,45965,45991,12,46189,46215,12,46413,46439,12,46637,46663,12,46861,46887,12,47085,47111,12,47309,47335,12,47533,47559,12,47757,47783,12,47981,48007,12,48205,48231,12,48429,48455,12,48653,48679,12,48877,48903,12,49101,49127,12,49325,49351,12,49549,49575,12,49773,49799,12,49997,50023,12,50221,50247,12,50445,50471,12,50669,50695,12,50893,50919,12,51117,51143,12,51341,51367,12,51565,51591,12,51789,51815,12,52013,52039,12,52237,52263,12,52461,52487,12,52685,52711,12,52909,52935,12,53133,53159,12,53357,53383,12,53581,53607,12,53805,53831,12,54029,54055,12,54253,54279,12,54477,54503,12,54701,54727,12,54925,54951,12,55149,55175,12,68101,68102,5,69762,69762,7,70067,70069,7,70371,70378,5,70720,70721,7,71087,71087,5,71341,71341,5,71995,71996,5,72249,72249,7,72850,72871,5,73109,73109,5,118576,118598,5,121505,121519,5,127245,127247,14,127568,127569,14,127777,127777,14,127872,127891,14,127956,127967,14,128015,128016,14,128110,128172,14,128259,128259,14,128367,128368,14,128424,128424,14,128488,128488,14,128530,128532,14,128550,128551,14,128566,128566,14,128647,128647,14,128656,128656,14,128667,128673,14,128691,128693,14,128715,128715,14,128728,128732,14,128752,128752,14,128765,128767,14,129096,129103,14,129311,129311,14,129344,129349,14,129394,129394,14,129413,129425,14,129466,129471,14,129511,129535,14,129664,129666,14,129719,129722,14,129760,129767,14,917536,917631,5,13,13,2,1160,1161,5,1564,1564,4,1807,1807,1,2085,2087,5,2307,2307,7,2382,2383,7,2497,2500,5,2563,2563,7,2677,2677,5,2763,2764,7,2879,2879,5,2914,2915,5,3021,3021,5,3142,3144,5,3263,3263,5,3285,3286,5,3398,3400,7,3530,3530,5,3633,3633,5,3864,3865,5,3974,3975,5,4155,4156,7,4229,4230,5,5909,5909,7,6078,6085,7,6277,6278,5,6451,6456,7,6744,6750,5,6846,6846,5,6972,6972,5,7074,7077,5,7146,7148,7,7222,7223,5,7416,7417,5,8234,8238,4,8417,8417,5,9000,9000,14,9203,9203,14,9730,9731,14,9748,9749,14,9762,9763,14,9776,9783,14,9800,9811,14,9831,9831,14,9872,9873,14,9882,9882,14,9900,9903,14,9929,9933,14,9941,9960,14,9974,9974,14,9989,9989,14,10006,10006,14,10062,10062,14,10160,10160,14,11647,11647,5,12953,12953,14,43019,43019,5,43232,43249,5,43443,43443,5,43567,43568,7,43696,43696,5,43765,43765,7,44013,44013,5,44117,44143,12,44229,44255,12,44341,44367,12,44453,44479,12,44565,44591,12,44677,44703,12,44789,44815,12,44901,44927,12,45013,45039,12,45125,45151,12,45237,45263,12,45349,45375,12,45461,45487,12,45573,45599,12,45685,45711,12,45797,45823,12,45909,45935,12,46021,46047,12,46133,46159,12,46245,46271,12,46357,46383,12,46469,46495,12,46581,46607,12,46693,46719,12,46805,46831,12,46917,46943,12,47029,47055,12,47141,47167,12,47253,47279,12,47365,47391,12,47477,47503,12,47589,47615,12,47701,47727,12,47813,47839,12,47925,47951,12,48037,48063,12,48149,48175,12,48261,48287,12,48373,48399,12,48485,48511,12,48597,48623,12,48709,48735,12,48821,48847,12,48933,48959,12,49045,49071,12,49157,49183,12,49269,49295,12,49381,49407,12,49493,49519,12,49605,49631,12,49717,49743,12,49829,49855,12,49941,49967,12,50053,50079,12,50165,50191,12,50277,50303,12,50389,50415,12,50501,50527,12,50613,50639,12,50725,50751,12,50837,50863,12,50949,50975,12,51061,51087,12,51173,51199,12,51285,51311,12,51397,51423,12,51509,51535,12,51621,51647,12,51733,51759,12,51845,51871,12,51957,51983,12,52069,52095,12,52181,52207,12,52293,52319,12,52405,52431,12,52517,52543,12,52629,52655,12,52741,52767,12,52853,52879,12,52965,52991,12,53077,53103,12,53189,53215,12,53301,53327,12,53413,53439,12,53525,53551,12,53637,53663,12,53749,53775,12,53861,53887,12,53973,53999,12,54085,54111,12,54197,54223,12,54309,54335,12,54421,54447,12,54533,54559,12,54645,54671,12,54757,54783,12,54869,54895,12,54981,55007,12,55093,55119,12,55243,55291,10,66045,66045,5,68325,68326,5,69688,69702,5,69817,69818,5,69957,69958,7,70089,70092,5,70198,70199,5,70462,70462,5,70502,70508,5,70750,70750,5,70846,70846,7,71100,71101,5,71230,71230,7,71351,71351,5,71737,71738,5,72000,72000,7,72160,72160,5,72273,72278,5,72752,72758,5,72882,72883,5,73031,73031,5,73461,73462,7,94192,94193,7,119149,119149,7,121403,121452,5,122915,122916,5,126980,126980,14,127358,127359,14,127535,127535,14,127759,127759,14,127771,127771,14,127792,127793,14,127825,127867,14,127897,127899,14,127945,127945,14,127985,127986,14,128000,128007,14,128021,128021,14,128066,128100,14,128184,128235,14,128249,128252,14,128266,128276,14,128335,128335,14,128379,128390,14,128407,128419,14,128444,128444,14,128481,128481,14,128499,128499,14,128526,128526,14,128536,128536,14,128543,128543,14,128556,128556,14,128564,128564,14,128577,128580,14,128643,128645,14,128649,128649,14,128654,128654,14,128660,128660,14,128664,128664,14,128675,128675,14,128686,128689,14,128695,128696,14,128705,128709,14,128717,128719,14,128725,128725,14,128736,128741,14,128747,128748,14,128755,128755,14,128762,128762,14,128981,128991,14,129009,129023,14,129160,129167,14,129296,129304,14,129320,129327,14,129340,129342,14,129356,129356,14,129388,129392,14,129399,129400,14,129404,129407,14,129432,129442,14,129454,129455,14,129473,129474,14,129485,129487,14,129648,129651,14,129659,129660,14,129671,129679,14,129709,129711,14,129728,129730,14,129751,129753,14,129776,129782,14,917505,917505,4,917760,917999,5,10,10,3,127,159,4,768,879,5,1471,1471,5,1536,1541,1,1648,1648,5,1767,1768,5,1840,1866,5,2070,2073,5,2137,2139,5,2274,2274,1,2363,2363,7,2377,2380,7,2402,2403,5,2494,2494,5,2507,2508,7,2558,2558,5,2622,2624,7,2641,2641,5,2691,2691,7,2759,2760,5,2786,2787,5,2876,2876,5,2881,2884,5,2901,2902,5,3006,3006,5,3014,3016,7,3072,3072,5,3134,3136,5,3157,3158,5,3260,3260,5,3266,3266,5,3274,3275,7,3328,3329,5,3391,3392,7,3405,3405,5,3457,3457,5,3536,3537,7,3551,3551,5,3636,3642,5,3764,3772,5,3895,3895,5,3967,3967,7,3993,4028,5,4146,4151,5,4182,4183,7,4226,4226,5,4253,4253,5,4957,4959,5,5940,5940,7,6070,6070,7,6087,6088,7,6158,6158,4,6432,6434,5,6448,6449,7,6679,6680,5,6742,6742,5,6754,6754,5,6783,6783,5,6912,6915,5,6966,6970,5,6978,6978,5,7042,7042,7,7080,7081,5,7143,7143,7,7150,7150,7,7212,7219,5,7380,7392,5,7412,7412,5,8203,8203,4,8232,8232,4,8265,8265,14,8400,8412,5,8421,8432,5,8617,8618,14,9167,9167,14,9200,9200,14,9410,9410,14,9723,9726,14,9733,9733,14,9745,9745,14,9752,9752,14,9760,9760,14,9766,9766,14,9774,9774,14,9786,9786,14,9794,9794,14,9823,9823,14,9828,9828,14,9833,9850,14,9855,9855,14,9875,9875,14,9880,9880,14,9885,9887,14,9896,9897,14,9906,9916,14,9926,9927,14,9935,9935,14,9939,9939,14,9962,9962,14,9972,9972,14,9978,9978,14,9986,9986,14,9997,9997,14,10002,10002,14,10017,10017,14,10055,10055,14,10071,10071,14,10133,10135,14,10548,10549,14,11093,11093,14,12330,12333,5,12441,12442,5,42608,42610,5,43010,43010,5,43045,43046,5,43188,43203,7,43302,43309,5,43392,43394,5,43446,43449,5,43493,43493,5,43571,43572,7,43597,43597,7,43703,43704,5,43756,43757,5,44003,44004,7,44009,44010,7,44033,44059,12,44089,44115,12,44145,44171,12,44201,44227,12,44257,44283,12,44313,44339,12,44369,44395,12,44425,44451,12,44481,44507,12,44537,44563,12,44593,44619,12,44649,44675,12,44705,44731,12,44761,44787,12,44817,44843,12,44873,44899,12,44929,44955,12,44985,45011,12,45041,45067,12,45097,45123,12,45153,45179,12,45209,45235,12,45265,45291,12,45321,45347,12,45377,45403,12,45433,45459,12,45489,45515,12,45545,45571,12,45601,45627,12,45657,45683,12,45713,45739,12,45769,45795,12,45825,45851,12,45881,45907,12,45937,45963,12,45993,46019,12,46049,46075,12,46105,46131,12,46161,46187,12,46217,46243,12,46273,46299,12,46329,46355,12,46385,46411,12,46441,46467,12,46497,46523,12,46553,46579,12,46609,46635,12,46665,46691,12,46721,46747,12,46777,46803,12,46833,46859,12,46889,46915,12,46945,46971,12,47001,47027,12,47057,47083,12,47113,47139,12,47169,47195,12,47225,47251,12,47281,47307,12,47337,47363,12,47393,47419,12,47449,47475,12,47505,47531,12,47561,47587,12,47617,47643,12,47673,47699,12,47729,47755,12,47785,47811,12,47841,47867,12,47897,47923,12,47953,47979,12,48009,48035,12,48065,48091,12,48121,48147,12,48177,48203,12,48233,48259,12,48289,48315,12,48345,48371,12,48401,48427,12,48457,48483,12,48513,48539,12,48569,48595,12,48625,48651,12,48681,48707,12,48737,48763,12,48793,48819,12,48849,48875,12,48905,48931,12,48961,48987,12,49017,49043,12,49073,49099,12,49129,49155,12,49185,49211,12,49241,49267,12,49297,49323,12,49353,49379,12,49409,49435,12,49465,49491,12,49521,49547,12,49577,49603,12,49633,49659,12,49689,49715,12,49745,49771,12,49801,49827,12,49857,49883,12,49913,49939,12,49969,49995,12,50025,50051,12,50081,50107,12,50137,50163,12,50193,50219,12,50249,50275,12,50305,50331,12,50361,50387,12,50417,50443,12,50473,50499,12,50529,50555,12,50585,50611,12,50641,50667,12,50697,50723,12,50753,50779,12,50809,50835,12,50865,50891,12,50921,50947,12,50977,51003,12,51033,51059,12,51089,51115,12,51145,51171,12,51201,51227,12,51257,51283,12,51313,51339,12,51369,51395,12,51425,51451,12,51481,51507,12,51537,51563,12,51593,51619,12,51649,51675,12,51705,51731,12,51761,51787,12,51817,51843,12,51873,51899,12,51929,51955,12,51985,52011,12,52041,52067,12,52097,52123,12,52153,52179,12,52209,52235,12,52265,52291,12,52321,52347,12,52377,52403,12,52433,52459,12,52489,52515,12,52545,52571,12,52601,52627,12,52657,52683,12,52713,52739,12,52769,52795,12,52825,52851,12,52881,52907,12,52937,52963,12,52993,53019,12,53049,53075,12,53105,53131,12,53161,53187,12,53217,53243,12,53273,53299,12,53329,53355,12,53385,53411,12,53441,53467,12,53497,53523,12,53553,53579,12,53609,53635,12,53665,53691,12,53721,53747,12,53777,53803,12,53833,53859,12,53889,53915,12,53945,53971,12,54001,54027,12,54057,54083,12,54113,54139,12,54169,54195,12,54225,54251,12,54281,54307,12,54337,54363,12,54393,54419,12,54449,54475,12,54505,54531,12,54561,54587,12,54617,54643,12,54673,54699,12,54729,54755,12,54785,54811,12,54841,54867,12,54897,54923,12,54953,54979,12,55009,55035,12,55065,55091,12,55121,55147,12,55177,55203,12,65024,65039,5,65520,65528,4,66422,66426,5,68152,68154,5,69291,69292,5,69633,69633,5,69747,69748,5,69811,69814,5,69826,69826,5,69932,69932,7,70016,70017,5,70079,70080,7,70095,70095,5,70196,70196,5,70367,70367,5,70402,70403,7,70464,70464,5,70487,70487,5,70709,70711,7,70725,70725,7,70833,70834,7,70843,70844,7,70849,70849,7,71090,71093,5,71103,71104,5,71227,71228,7,71339,71339,5,71344,71349,5,71458,71461,5,71727,71735,5,71985,71989,7,71998,71998,5,72002,72002,7,72154,72155,5,72193,72202,5,72251,72254,5,72281,72283,5,72344,72345,5,72766,72766,7,72874,72880,5,72885,72886,5,73023,73029,5,73104,73105,5,73111,73111,5,92912,92916,5,94095,94098,5,113824,113827,4,119142,119142,7,119155,119162,4,119362,119364,5,121476,121476,5,122888,122904,5,123184,123190,5,125252,125258,5,127183,127183,14,127340,127343,14,127377,127386,14,127491,127503,14,127548,127551,14,127744,127756,14,127761,127761,14,127769,127769,14,127773,127774,14,127780,127788,14,127796,127797,14,127820,127823,14,127869,127869,14,127894,127895,14,127902,127903,14,127943,127943,14,127947,127950,14,127972,127972,14,127988,127988,14,127992,127994,14,128009,128011,14,128019,128019,14,128023,128041,14,128064,128064,14,128102,128107,14,128174,128181,14,128238,128238,14,128246,128247,14,128254,128254,14,128264,128264,14,128278,128299,14,128329,128330,14,128348,128359,14,128371,128377,14,128392,128393,14,128401,128404,14,128421,128421,14,128433,128434,14,128450,128452,14,128476,128478,14,128483,128483,14,128495,128495,14,128506,128506,14,128519,128520,14,128528,128528,14,128534,128534,14,128538,128538,14,128540,128542,14,128544,128549,14,128552,128555,14,128557,128557,14,128560,128563,14,128565,128565,14,128567,128576,14,128581,128591,14,128641,128642,14,128646,128646,14,128648,128648,14,128650,128651,14,128653,128653,14,128655,128655,14,128657,128659,14,128661,128661,14,128663,128663,14,128665,128666,14,128674,128674,14,128676,128677,14,128679,128685,14,128690,128690,14,128694,128694,14,128697,128702,14,128704,128704,14,128710,128714,14,128716,128716,14,128720,128720,14,128723,128724,14,128726,128727,14,128733,128735,14,128742,128744,14,128746,128746,14,128749,128751,14,128753,128754,14,128756,128758,14,128761,128761,14,128763,128764,14,128884,128895,14,128992,129003,14,129008,129008,14,129036,129039,14,129114,129119,14,129198,129279,14,129293,129295,14,129305,129310,14,129312,129319,14,129328,129328,14,129331,129338,14,129343,129343,14,129351,129355,14,129357,129359,14,129375,129387,14,129393,129393,14,129395,129398,14,129401,129401,14,129403,129403,14,129408,129412,14,129426,129431,14,129443,129444,14,129451,129453,14,129456,129465,14,129472,129472,14,129475,129482,14,129484,129484,14,129488,129510,14,129536,129647,14,129652,129652,14,129656,129658,14,129661,129663,14,129667,129670,14,129680,129685,14,129705,129708,14,129712,129718,14,129723,129727,14,129731,129733,14,129744,129750,14,129754,129759,14,129768,129775,14,129783,129791,14,917504,917504,4,917506,917535,4,917632,917759,4,918000,921599,4,0,9,4,11,12,4,14,31,4,169,169,14,174,174,14,1155,1159,5,1425,1469,5,1473,1474,5,1479,1479,5,1552,1562,5,1611,1631,5,1750,1756,5,1759,1764,5,1770,1773,5,1809,1809,5,1958,1968,5,2045,2045,5,2075,2083,5,2089,2093,5,2192,2193,1,2250,2273,5,2275,2306,5,2362,2362,5,2364,2364,5,2369,2376,5,2381,2381,5,2385,2391,5,2433,2433,5,2492,2492,5,2495,2496,7,2503,2504,7,2509,2509,5,2530,2531,5,2561,2562,5,2620,2620,5,2625,2626,5,2635,2637,5,2672,2673,5,2689,2690,5,2748,2748,5,2753,2757,5,2761,2761,7,2765,2765,5,2810,2815,5,2818,2819,7,2878,2878,5,2880,2880,7,2887,2888,7,2893,2893,5,2903,2903,5,2946,2946,5,3007,3007,7,3009,3010,7,3018,3020,7,3031,3031,5,3073,3075,7,3132,3132,5,3137,3140,7,3146,3149,5,3170,3171,5,3202,3203,7,3262,3262,7,3264,3265,7,3267,3268,7,3271,3272,7,3276,3277,5,3298,3299,5,3330,3331,7,3390,3390,5,3393,3396,5,3402,3404,7,3406,3406,1,3426,3427,5,3458,3459,7,3535,3535,5,3538,3540,5,3544,3550,7,3570,3571,7,3635,3635,7,3655,3662,5,3763,3763,7,3784,3789,5,3893,3893,5,3897,3897,5,3953,3966,5,3968,3972,5,3981,3991,5,4038,4038,5,4145,4145,7,4153,4154,5,4157,4158,5,4184,4185,5,4209,4212,5,4228,4228,7,4237,4237,5,4352,4447,8,4520,4607,10,5906,5908,5,5938,5939,5,5970,5971,5,6068,6069,5,6071,6077,5,6086,6086,5,6089,6099,5,6155,6157,5,6159,6159,5,6313,6313,5,6435,6438,7,6441,6443,7,6450,6450,5,6457,6459,5,6681,6682,7,6741,6741,7,6743,6743,7,6752,6752,5,6757,6764,5,6771,6780,5,6832,6845,5,6847,6862,5,6916,6916,7,6965,6965,5,6971,6971,7,6973,6977,7,6979,6980,7,7040,7041,5,7073,7073,7,7078,7079,7,7082,7082,7,7142,7142,5,7144,7145,5,7149,7149,5,7151,7153,5,7204,7211,7,7220,7221,7,7376,7378,5,7393,7393,7,7405,7405,5,7415,7415,7,7616,7679,5,8204,8204,5,8206,8207,4,8233,8233,4,8252,8252,14,8288,8292,4,8294,8303,4,8413,8416,5,8418,8420,5,8482,8482,14,8596,8601,14,8986,8987,14,9096,9096,14,9193,9196,14,9199,9199,14,9201,9202,14,9208,9210,14,9642,9643,14,9664,9664,14,9728,9729,14,9732,9732,14,9735,9741,14,9743,9744,14,9746,9746,14,9750,9751,14,9753,9756,14,9758,9759,14,9761,9761,14,9764,9765,14,9767,9769,14,9771,9773,14,9775,9775,14,9784,9785,14,9787,9791,14,9793,9793,14,9795,9799,14,9812,9822,14,9824,9824,14,9827,9827,14,9829,9830,14,9832,9832,14,9851,9851,14,9854,9854,14,9856,9861,14,9874,9874,14,9876,9876,14,9878,9879,14,9881,9881,14,9883,9884,14,9888,9889,14,9895,9895,14,9898,9899,14,9904,9905,14,9917,9918,14,9924,9925,14,9928,9928,14,9934,9934,14,9936,9936,14,9938,9938,14,9940,9940,14,9961,9961,14,9963,9967,14,9970,9971,14,9973,9973,14,9975,9977,14,9979,9980,14,9982,9985,14,9987,9988,14,9992,9996,14,9998,9998,14,10000,10001,14,10004,10004,14,10013,10013,14,10024,10024,14,10052,10052,14,10060,10060,14,10067,10069,14,10083,10083,14,10085,10087,14,10145,10145,14,10175,10175,14,11013,11015,14,11088,11088,14,11503,11505,5,11744,11775,5,12334,12335,5,12349,12349,14,12951,12951,14,42607,42607,5,42612,42621,5,42736,42737,5,43014,43014,5,43043,43044,7,43047,43047,7,43136,43137,7,43204,43205,5,43263,43263,5,43335,43345,5,43360,43388,8,43395,43395,7,43444,43445,7,43450,43451,7,43454,43456,7,43561,43566,5,43569,43570,5,43573,43574,5,43596,43596,5,43644,43644,5,43698,43700,5,43710,43711,5,43755,43755,7,43758,43759,7,43766,43766,5,44005,44005,5,44008,44008,5,44012,44012,7,44032,44032,11,44060,44060,11,44088,44088,11,44116,44116,11,44144,44144,11,44172,44172,11,44200,44200,11,44228,44228,11,44256,44256,11,44284,44284,11,44312,44312,11,44340,44340,11,44368,44368,11,44396,44396,11,44424,44424,11,44452,44452,11,44480,44480,11,44508,44508,11,44536,44536,11,44564,44564,11,44592,44592,11,44620,44620,11,44648,44648,11,44676,44676,11,44704,44704,11,44732,44732,11,44760,44760,11,44788,44788,11,44816,44816,11,44844,44844,11,44872,44872,11,44900,44900,11,44928,44928,11,44956,44956,11,44984,44984,11,45012,45012,11,45040,45040,11,45068,45068,11,45096,45096,11,45124,45124,11,45152,45152,11,45180,45180,11,45208,45208,11,45236,45236,11,45264,45264,11,45292,45292,11,45320,45320,11,45348,45348,11,45376,45376,11,45404,45404,11,45432,45432,11,45460,45460,11,45488,45488,11,45516,45516,11,45544,45544,11,45572,45572,11,45600,45600,11,45628,45628,11,45656,45656,11,45684,45684,11,45712,45712,11,45740,45740,11,45768,45768,11,45796,45796,11,45824,45824,11,45852,45852,11,45880,45880,11,45908,45908,11,45936,45936,11,45964,45964,11,45992,45992,11,46020,46020,11,46048,46048,11,46076,46076,11,46104,46104,11,46132,46132,11,46160,46160,11,46188,46188,11,46216,46216,11,46244,46244,11,46272,46272,11,46300,46300,11,46328,46328,11,46356,46356,11,46384,46384,11,46412,46412,11,46440,46440,11,46468,46468,11,46496,46496,11,46524,46524,11,46552,46552,11,46580,46580,11,46608,46608,11,46636,46636,11,46664,46664,11,46692,46692,11,46720,46720,11,46748,46748,11,46776,46776,11,46804,46804,11,46832,46832,11,46860,46860,11,46888,46888,11,46916,46916,11,46944,46944,11,46972,46972,11,47000,47000,11,47028,47028,11,47056,47056,11,47084,47084,11,47112,47112,11,47140,47140,11,47168,47168,11,47196,47196,11,47224,47224,11,47252,47252,11,47280,47280,11,47308,47308,11,47336,47336,11,47364,47364,11,47392,47392,11,47420,47420,11,47448,47448,11,47476,47476,11,47504,47504,11,47532,47532,11,47560,47560,11,47588,47588,11,47616,47616,11,47644,47644,11,47672,47672,11,47700,47700,11,47728,47728,11,47756,47756,11,47784,47784,11,47812,47812,11,47840,47840,11,47868,47868,11,47896,47896,11,47924,47924,11,47952,47952,11,47980,47980,11,48008,48008,11,48036,48036,11,48064,48064,11,48092,48092,11,48120,48120,11,48148,48148,11,48176,48176,11,48204,48204,11,48232,48232,11,48260,48260,11,48288,48288,11,48316,48316,11,48344,48344,11,48372,48372,11,48400,48400,11,48428,48428,11,48456,48456,11,48484,48484,11,48512,48512,11,48540,48540,11,48568,48568,11,48596,48596,11,48624,48624,11,48652,48652,11,48680,48680,11,48708,48708,11,48736,48736,11,48764,48764,11,48792,48792,11,48820,48820,11,48848,48848,11,48876,48876,11,48904,48904,11,48932,48932,11,48960,48960,11,48988,48988,11,49016,49016,11,49044,49044,11,49072,49072,11,49100,49100,11,49128,49128,11,49156,49156,11,49184,49184,11,49212,49212,11,49240,49240,11,49268,49268,11,49296,49296,11,49324,49324,11,49352,49352,11,49380,49380,11,49408,49408,11,49436,49436,11,49464,49464,11,49492,49492,11,49520,49520,11,49548,49548,11,49576,49576,11,49604,49604,11,49632,49632,11,49660,49660,11,49688,49688,11,49716,49716,11,49744,49744,11,49772,49772,11,49800,49800,11,49828,49828,11,49856,49856,11,49884,49884,11,49912,49912,11,49940,49940,11,49968,49968,11,49996,49996,11,50024,50024,11,50052,50052,11,50080,50080,11,50108,50108,11,50136,50136,11,50164,50164,11,50192,50192,11,50220,50220,11,50248,50248,11,50276,50276,11,50304,50304,11,50332,50332,11,50360,50360,11,50388,50388,11,50416,50416,11,50444,50444,11,50472,50472,11,50500,50500,11,50528,50528,11,50556,50556,11,50584,50584,11,50612,50612,11,50640,50640,11,50668,50668,11,50696,50696,11,50724,50724,11,50752,50752,11,50780,50780,11,50808,50808,11,50836,50836,11,50864,50864,11,50892,50892,11,50920,50920,11,50948,50948,11,50976,50976,11,51004,51004,11,51032,51032,11,51060,51060,11,51088,51088,11,51116,51116,11,51144,51144,11,51172,51172,11,51200,51200,11,51228,51228,11,51256,51256,11,51284,51284,11,51312,51312,11,51340,51340,11,51368,51368,11,51396,51396,11,51424,51424,11,51452,51452,11,51480,51480,11,51508,51508,11,51536,51536,11,51564,51564,11,51592,51592,11,51620,51620,11,51648,51648,11,51676,51676,11,51704,51704,11,51732,51732,11,51760,51760,11,51788,51788,11,51816,51816,11,51844,51844,11,51872,51872,11,51900,51900,11,51928,51928,11,51956,51956,11,51984,51984,11,52012,52012,11,52040,52040,11,52068,52068,11,52096,52096,11,52124,52124,11,52152,52152,11,52180,52180,11,52208,52208,11,52236,52236,11,52264,52264,11,52292,52292,11,52320,52320,11,52348,52348,11,52376,52376,11,52404,52404,11,52432,52432,11,52460,52460,11,52488,52488,11,52516,52516,11,52544,52544,11,52572,52572,11,52600,52600,11,52628,52628,11,52656,52656,11,52684,52684,11,52712,52712,11,52740,52740,11,52768,52768,11,52796,52796,11,52824,52824,11,52852,52852,11,52880,52880,11,52908,52908,11,52936,52936,11,52964,52964,11,52992,52992,11,53020,53020,11,53048,53048,11,53076,53076,11,53104,53104,11,53132,53132,11,53160,53160,11,53188,53188,11,53216,53216,11,53244,53244,11,53272,53272,11,53300,53300,11,53328,53328,11,53356,53356,11,53384,53384,11,53412,53412,11,53440,53440,11,53468,53468,11,53496,53496,11,53524,53524,11,53552,53552,11,53580,53580,11,53608,53608,11,53636,53636,11,53664,53664,11,53692,53692,11,53720,53720,11,53748,53748,11,53776,53776,11,53804,53804,11,53832,53832,11,53860,53860,11,53888,53888,11,53916,53916,11,53944,53944,11,53972,53972,11,54000,54000,11,54028,54028,11,54056,54056,11,54084,54084,11,54112,54112,11,54140,54140,11,54168,54168,11,54196,54196,11,54224,54224,11,54252,54252,11,54280,54280,11,54308,54308,11,54336,54336,11,54364,54364,11,54392,54392,11,54420,54420,11,54448,54448,11,54476,54476,11,54504,54504,11,54532,54532,11,54560,54560,11,54588,54588,11,54616,54616,11,54644,54644,11,54672,54672,11,54700,54700,11,54728,54728,11,54756,54756,11,54784,54784,11,54812,54812,11,54840,54840,11,54868,54868,11,54896,54896,11,54924,54924,11,54952,54952,11,54980,54980,11,55008,55008,11,55036,55036,11,55064,55064,11,55092,55092,11,55120,55120,11,55148,55148,11,55176,55176,11,55216,55238,9,64286,64286,5,65056,65071,5,65438,65439,5,65529,65531,4,66272,66272,5,68097,68099,5,68108,68111,5,68159,68159,5,68900,68903,5,69446,69456,5,69632,69632,7,69634,69634,7,69744,69744,5,69759,69761,5,69808,69810,7,69815,69816,7,69821,69821,1,69837,69837,1,69927,69931,5,69933,69940,5,70003,70003,5,70018,70018,7,70070,70078,5,70082,70083,1,70094,70094,7,70188,70190,7,70194,70195,7,70197,70197,7,70206,70206,5,70368,70370,7,70400,70401,5,70459,70460,5,70463,70463,7,70465,70468,7,70475,70477,7,70498,70499,7,70512,70516,5,70712,70719,5,70722,70724,5,70726,70726,5,70832,70832,5,70835,70840,5,70842,70842,5,70845,70845,5,70847,70848,5,70850,70851,5,71088,71089,7,71096,71099,7,71102,71102,7,71132,71133,5,71219,71226,5,71229,71229,5,71231,71232,5,71340,71340,7,71342,71343,7,71350,71350,7,71453,71455,5,71462,71462,7,71724,71726,7,71736,71736,7,71984,71984,5,71991,71992,7,71997,71997,7,71999,71999,1,72001,72001,1,72003,72003,5,72148,72151,5,72156,72159,7,72164,72164,7,72243,72248,5,72250,72250,1,72263,72263,5,72279,72280,7,72324,72329,1,72343,72343,7,72751,72751,7,72760,72765,5,72767,72767,5,72873,72873,7,72881,72881,7,72884,72884,7,73009,73014,5,73020,73021,5,73030,73030,1,73098,73102,7,73107,73108,7,73110,73110,7,73459,73460,5,78896,78904,4,92976,92982,5,94033,94087,7,94180,94180,5,113821,113822,5,118528,118573,5,119141,119141,5,119143,119145,5,119150,119154,5,119163,119170,5,119210,119213,5,121344,121398,5,121461,121461,5,121499,121503,5,122880,122886,5,122907,122913,5,122918,122922,5,123566,123566,5,125136,125142,5,126976,126979,14,126981,127182,14,127184,127231,14,127279,127279,14,127344,127345,14,127374,127374,14,127405,127461,14,127489,127490,14,127514,127514,14,127538,127546,14,127561,127567,14,127570,127743,14,127757,127758,14,127760,127760,14,127762,127762,14,127766,127768,14,127770,127770,14,127772,127772,14,127775,127776,14,127778,127779,14,127789,127791,14,127794,127795,14,127798,127798,14,127819,127819,14,127824,127824,14,127868,127868,14,127870,127871,14,127892,127893,14,127896,127896,14,127900,127901,14,127904,127940,14,127942,127942,14,127944,127944,14,127946,127946,14,127951,127955,14,127968,127971,14,127973,127984,14,127987,127987,14,127989,127989,14,127991,127991,14,127995,127999,5,128008,128008,14,128012,128014,14,128017,128018,14,128020,128020,14,128022,128022,14,128042,128042,14,128063,128063,14,128065,128065,14,128101,128101,14,128108,128109,14,128173,128173,14,128182,128183,14,128236,128237,14,128239,128239,14,128245,128245,14,128248,128248,14,128253,128253,14,128255,128258,14,128260,128263,14,128265,128265,14,128277,128277,14,128300,128301,14,128326,128328,14,128331,128334,14,128336,128347,14,128360,128366,14,128369,128370,14,128378,128378,14,128391,128391,14,128394,128397,14,128400,128400,14,128405,128406,14,128420,128420,14,128422,128423,14,128425,128432,14,128435,128443,14,128445,128449,14,128453,128464,14,128468,128475,14,128479,128480,14,128482,128482,14,128484,128487,14,128489,128494,14,128496,128498,14,128500,128505,14,128507,128511,14,128513,128518,14,128521,128525,14,128527,128527,14,128529,128529,14,128533,128533,14,128535,128535,14,128537,128537,14]");
  }
  getGraphemeBreakType(e) {
    if (e < 32) return e === 10 ? 3 : e === 13 ? 2 : 4;
    if (e < 127) return 0;
    const t = this._data, i = t.length / 3;
    let s = 1;
    for (; s <= i; ) if (e < t[3 * s]) s *= 2;
    else {
      if (!(e > t[3 * s + 1])) return t[3 * s + 2];
      s = 2 * s + 1;
    }
    return 0;
  }
}
function xK(n, e) {
  if (n === 0) return 0;
  const t = (function(s, o) {
    const r = new SE(o, s);
    let a = r.prevCodePoint();
    for (; NK(a) || a === 65039 || a === 8419; ) {
      if (r.offset === 0) return;
      a = r.prevCodePoint();
    }
    if (!aR(a)) return;
    let l = r.offset;
    return l > 0 && r.prevCodePoint() === 8205 && (l = r.offset), l;
  })(n, e);
  if (t !== void 0) return t;
  const i = new SE(e, n);
  return i.prevCodePoint(), i.offset;
}
function NK(n) {
  return 127995 <= n && n <= 127999;
}
Eh._INSTANCE = null;
class xu {
  static getInstance(e) {
    return Sp.cache.get(Array.from(e));
  }
  static getLocales() {
    return Sp._locales.value;
  }
  constructor(e) {
    this.confusableDictionary = e;
  }
  isAmbiguous(e) {
    return this.confusableDictionary.has(e);
  }
  getPrimaryConfusable(e) {
    return this.confusableDictionary.get(e);
  }
  getConfusableCodePoints() {
    return new Set(this.confusableDictionary.keys());
  }
}
Sp = xu, xu.ambiguousCharacterData = new ua((() => JSON.parse('{"_common":[8232,32,8233,32,5760,32,8192,32,8193,32,8194,32,8195,32,8196,32,8197,32,8198,32,8200,32,8201,32,8202,32,8287,32,8199,32,8239,32,2042,95,65101,95,65102,95,65103,95,8208,45,8209,45,8210,45,65112,45,1748,45,8259,45,727,45,8722,45,10134,45,11450,45,1549,44,1643,44,8218,44,184,44,42233,44,894,59,2307,58,2691,58,1417,58,1795,58,1796,58,5868,58,65072,58,6147,58,6153,58,8282,58,1475,58,760,58,42889,58,8758,58,720,58,42237,58,451,33,11601,33,660,63,577,63,2429,63,5038,63,42731,63,119149,46,8228,46,1793,46,1794,46,42510,46,68176,46,1632,46,1776,46,42232,46,1373,96,65287,96,8219,96,8242,96,1370,96,1523,96,8175,96,65344,96,900,96,8189,96,8125,96,8127,96,8190,96,697,96,884,96,712,96,714,96,715,96,756,96,699,96,701,96,700,96,702,96,42892,96,1497,96,2036,96,2037,96,5194,96,5836,96,94033,96,94034,96,65339,91,10088,40,10098,40,12308,40,64830,40,65341,93,10089,41,10099,41,12309,41,64831,41,10100,123,119060,123,10101,125,65342,94,8270,42,1645,42,8727,42,66335,42,5941,47,8257,47,8725,47,8260,47,9585,47,10187,47,10744,47,119354,47,12755,47,12339,47,11462,47,20031,47,12035,47,65340,92,65128,92,8726,92,10189,92,10741,92,10745,92,119311,92,119355,92,12756,92,20022,92,12034,92,42872,38,708,94,710,94,5869,43,10133,43,66203,43,8249,60,10094,60,706,60,119350,60,5176,60,5810,60,5120,61,11840,61,12448,61,42239,61,8250,62,10095,62,707,62,119351,62,5171,62,94015,62,8275,126,732,126,8128,126,8764,126,65372,124,65293,45,120784,50,120794,50,120804,50,120814,50,120824,50,130034,50,42842,50,423,50,1000,50,42564,50,5311,50,42735,50,119302,51,120785,51,120795,51,120805,51,120815,51,120825,51,130035,51,42923,51,540,51,439,51,42858,51,11468,51,1248,51,94011,51,71882,51,120786,52,120796,52,120806,52,120816,52,120826,52,130036,52,5070,52,71855,52,120787,53,120797,53,120807,53,120817,53,120827,53,130037,53,444,53,71867,53,120788,54,120798,54,120808,54,120818,54,120828,54,130038,54,11474,54,5102,54,71893,54,119314,55,120789,55,120799,55,120809,55,120819,55,120829,55,130039,55,66770,55,71878,55,2819,56,2538,56,2666,56,125131,56,120790,56,120800,56,120810,56,120820,56,120830,56,130040,56,547,56,546,56,66330,56,2663,57,2920,57,2541,57,3437,57,120791,57,120801,57,120811,57,120821,57,120831,57,130041,57,42862,57,11466,57,71884,57,71852,57,71894,57,9082,97,65345,97,119834,97,119886,97,119938,97,119990,97,120042,97,120094,97,120146,97,120198,97,120250,97,120302,97,120354,97,120406,97,120458,97,593,97,945,97,120514,97,120572,97,120630,97,120688,97,120746,97,65313,65,119808,65,119860,65,119912,65,119964,65,120016,65,120068,65,120120,65,120172,65,120224,65,120276,65,120328,65,120380,65,120432,65,913,65,120488,65,120546,65,120604,65,120662,65,120720,65,5034,65,5573,65,42222,65,94016,65,66208,65,119835,98,119887,98,119939,98,119991,98,120043,98,120095,98,120147,98,120199,98,120251,98,120303,98,120355,98,120407,98,120459,98,388,98,5071,98,5234,98,5551,98,65314,66,8492,66,119809,66,119861,66,119913,66,120017,66,120069,66,120121,66,120173,66,120225,66,120277,66,120329,66,120381,66,120433,66,42932,66,914,66,120489,66,120547,66,120605,66,120663,66,120721,66,5108,66,5623,66,42192,66,66178,66,66209,66,66305,66,65347,99,8573,99,119836,99,119888,99,119940,99,119992,99,120044,99,120096,99,120148,99,120200,99,120252,99,120304,99,120356,99,120408,99,120460,99,7428,99,1010,99,11429,99,43951,99,66621,99,128844,67,71922,67,71913,67,65315,67,8557,67,8450,67,8493,67,119810,67,119862,67,119914,67,119966,67,120018,67,120174,67,120226,67,120278,67,120330,67,120382,67,120434,67,1017,67,11428,67,5087,67,42202,67,66210,67,66306,67,66581,67,66844,67,8574,100,8518,100,119837,100,119889,100,119941,100,119993,100,120045,100,120097,100,120149,100,120201,100,120253,100,120305,100,120357,100,120409,100,120461,100,1281,100,5095,100,5231,100,42194,100,8558,68,8517,68,119811,68,119863,68,119915,68,119967,68,120019,68,120071,68,120123,68,120175,68,120227,68,120279,68,120331,68,120383,68,120435,68,5024,68,5598,68,5610,68,42195,68,8494,101,65349,101,8495,101,8519,101,119838,101,119890,101,119942,101,120046,101,120098,101,120150,101,120202,101,120254,101,120306,101,120358,101,120410,101,120462,101,43826,101,1213,101,8959,69,65317,69,8496,69,119812,69,119864,69,119916,69,120020,69,120072,69,120124,69,120176,69,120228,69,120280,69,120332,69,120384,69,120436,69,917,69,120492,69,120550,69,120608,69,120666,69,120724,69,11577,69,5036,69,42224,69,71846,69,71854,69,66182,69,119839,102,119891,102,119943,102,119995,102,120047,102,120099,102,120151,102,120203,102,120255,102,120307,102,120359,102,120411,102,120463,102,43829,102,42905,102,383,102,7837,102,1412,102,119315,70,8497,70,119813,70,119865,70,119917,70,120021,70,120073,70,120125,70,120177,70,120229,70,120281,70,120333,70,120385,70,120437,70,42904,70,988,70,120778,70,5556,70,42205,70,71874,70,71842,70,66183,70,66213,70,66853,70,65351,103,8458,103,119840,103,119892,103,119944,103,120048,103,120100,103,120152,103,120204,103,120256,103,120308,103,120360,103,120412,103,120464,103,609,103,7555,103,397,103,1409,103,119814,71,119866,71,119918,71,119970,71,120022,71,120074,71,120126,71,120178,71,120230,71,120282,71,120334,71,120386,71,120438,71,1292,71,5056,71,5107,71,42198,71,65352,104,8462,104,119841,104,119945,104,119997,104,120049,104,120101,104,120153,104,120205,104,120257,104,120309,104,120361,104,120413,104,120465,104,1211,104,1392,104,5058,104,65320,72,8459,72,8460,72,8461,72,119815,72,119867,72,119919,72,120023,72,120179,72,120231,72,120283,72,120335,72,120387,72,120439,72,919,72,120494,72,120552,72,120610,72,120668,72,120726,72,11406,72,5051,72,5500,72,42215,72,66255,72,731,105,9075,105,65353,105,8560,105,8505,105,8520,105,119842,105,119894,105,119946,105,119998,105,120050,105,120102,105,120154,105,120206,105,120258,105,120310,105,120362,105,120414,105,120466,105,120484,105,618,105,617,105,953,105,8126,105,890,105,120522,105,120580,105,120638,105,120696,105,120754,105,1110,105,42567,105,1231,105,43893,105,5029,105,71875,105,65354,106,8521,106,119843,106,119895,106,119947,106,119999,106,120051,106,120103,106,120155,106,120207,106,120259,106,120311,106,120363,106,120415,106,120467,106,1011,106,1112,106,65322,74,119817,74,119869,74,119921,74,119973,74,120025,74,120077,74,120129,74,120181,74,120233,74,120285,74,120337,74,120389,74,120441,74,42930,74,895,74,1032,74,5035,74,5261,74,42201,74,119844,107,119896,107,119948,107,120000,107,120052,107,120104,107,120156,107,120208,107,120260,107,120312,107,120364,107,120416,107,120468,107,8490,75,65323,75,119818,75,119870,75,119922,75,119974,75,120026,75,120078,75,120130,75,120182,75,120234,75,120286,75,120338,75,120390,75,120442,75,922,75,120497,75,120555,75,120613,75,120671,75,120729,75,11412,75,5094,75,5845,75,42199,75,66840,75,1472,108,8739,73,9213,73,65512,73,1633,108,1777,73,66336,108,125127,108,120783,73,120793,73,120803,73,120813,73,120823,73,130033,73,65321,73,8544,73,8464,73,8465,73,119816,73,119868,73,119920,73,120024,73,120128,73,120180,73,120232,73,120284,73,120336,73,120388,73,120440,73,65356,108,8572,73,8467,108,119845,108,119897,108,119949,108,120001,108,120053,108,120105,73,120157,73,120209,73,120261,73,120313,73,120365,73,120417,73,120469,73,448,73,120496,73,120554,73,120612,73,120670,73,120728,73,11410,73,1030,73,1216,73,1493,108,1503,108,1575,108,126464,108,126592,108,65166,108,65165,108,1994,108,11599,73,5825,73,42226,73,93992,73,66186,124,66313,124,119338,76,8556,76,8466,76,119819,76,119871,76,119923,76,120027,76,120079,76,120131,76,120183,76,120235,76,120287,76,120339,76,120391,76,120443,76,11472,76,5086,76,5290,76,42209,76,93974,76,71843,76,71858,76,66587,76,66854,76,65325,77,8559,77,8499,77,119820,77,119872,77,119924,77,120028,77,120080,77,120132,77,120184,77,120236,77,120288,77,120340,77,120392,77,120444,77,924,77,120499,77,120557,77,120615,77,120673,77,120731,77,1018,77,11416,77,5047,77,5616,77,5846,77,42207,77,66224,77,66321,77,119847,110,119899,110,119951,110,120003,110,120055,110,120107,110,120159,110,120211,110,120263,110,120315,110,120367,110,120419,110,120471,110,1400,110,1404,110,65326,78,8469,78,119821,78,119873,78,119925,78,119977,78,120029,78,120081,78,120185,78,120237,78,120289,78,120341,78,120393,78,120445,78,925,78,120500,78,120558,78,120616,78,120674,78,120732,78,11418,78,42208,78,66835,78,3074,111,3202,111,3330,111,3458,111,2406,111,2662,111,2790,111,3046,111,3174,111,3302,111,3430,111,3664,111,3792,111,4160,111,1637,111,1781,111,65359,111,8500,111,119848,111,119900,111,119952,111,120056,111,120108,111,120160,111,120212,111,120264,111,120316,111,120368,111,120420,111,120472,111,7439,111,7441,111,43837,111,959,111,120528,111,120586,111,120644,111,120702,111,120760,111,963,111,120532,111,120590,111,120648,111,120706,111,120764,111,11423,111,4351,111,1413,111,1505,111,1607,111,126500,111,126564,111,126596,111,65259,111,65260,111,65258,111,65257,111,1726,111,64428,111,64429,111,64427,111,64426,111,1729,111,64424,111,64425,111,64423,111,64422,111,1749,111,3360,111,4125,111,66794,111,71880,111,71895,111,66604,111,1984,79,2534,79,2918,79,12295,79,70864,79,71904,79,120782,79,120792,79,120802,79,120812,79,120822,79,130032,79,65327,79,119822,79,119874,79,119926,79,119978,79,120030,79,120082,79,120134,79,120186,79,120238,79,120290,79,120342,79,120394,79,120446,79,927,79,120502,79,120560,79,120618,79,120676,79,120734,79,11422,79,1365,79,11604,79,4816,79,2848,79,66754,79,42227,79,71861,79,66194,79,66219,79,66564,79,66838,79,9076,112,65360,112,119849,112,119901,112,119953,112,120005,112,120057,112,120109,112,120161,112,120213,112,120265,112,120317,112,120369,112,120421,112,120473,112,961,112,120530,112,120544,112,120588,112,120602,112,120646,112,120660,112,120704,112,120718,112,120762,112,120776,112,11427,112,65328,80,8473,80,119823,80,119875,80,119927,80,119979,80,120031,80,120083,80,120187,80,120239,80,120291,80,120343,80,120395,80,120447,80,929,80,120504,80,120562,80,120620,80,120678,80,120736,80,11426,80,5090,80,5229,80,42193,80,66197,80,119850,113,119902,113,119954,113,120006,113,120058,113,120110,113,120162,113,120214,113,120266,113,120318,113,120370,113,120422,113,120474,113,1307,113,1379,113,1382,113,8474,81,119824,81,119876,81,119928,81,119980,81,120032,81,120084,81,120188,81,120240,81,120292,81,120344,81,120396,81,120448,81,11605,81,119851,114,119903,114,119955,114,120007,114,120059,114,120111,114,120163,114,120215,114,120267,114,120319,114,120371,114,120423,114,120475,114,43847,114,43848,114,7462,114,11397,114,43905,114,119318,82,8475,82,8476,82,8477,82,119825,82,119877,82,119929,82,120033,82,120189,82,120241,82,120293,82,120345,82,120397,82,120449,82,422,82,5025,82,5074,82,66740,82,5511,82,42211,82,94005,82,65363,115,119852,115,119904,115,119956,115,120008,115,120060,115,120112,115,120164,115,120216,115,120268,115,120320,115,120372,115,120424,115,120476,115,42801,115,445,115,1109,115,43946,115,71873,115,66632,115,65331,83,119826,83,119878,83,119930,83,119982,83,120034,83,120086,83,120138,83,120190,83,120242,83,120294,83,120346,83,120398,83,120450,83,1029,83,1359,83,5077,83,5082,83,42210,83,94010,83,66198,83,66592,83,119853,116,119905,116,119957,116,120009,116,120061,116,120113,116,120165,116,120217,116,120269,116,120321,116,120373,116,120425,116,120477,116,8868,84,10201,84,128872,84,65332,84,119827,84,119879,84,119931,84,119983,84,120035,84,120087,84,120139,84,120191,84,120243,84,120295,84,120347,84,120399,84,120451,84,932,84,120507,84,120565,84,120623,84,120681,84,120739,84,11430,84,5026,84,42196,84,93962,84,71868,84,66199,84,66225,84,66325,84,119854,117,119906,117,119958,117,120010,117,120062,117,120114,117,120166,117,120218,117,120270,117,120322,117,120374,117,120426,117,120478,117,42911,117,7452,117,43854,117,43858,117,651,117,965,117,120534,117,120592,117,120650,117,120708,117,120766,117,1405,117,66806,117,71896,117,8746,85,8899,85,119828,85,119880,85,119932,85,119984,85,120036,85,120088,85,120140,85,120192,85,120244,85,120296,85,120348,85,120400,85,120452,85,1357,85,4608,85,66766,85,5196,85,42228,85,94018,85,71864,85,8744,118,8897,118,65366,118,8564,118,119855,118,119907,118,119959,118,120011,118,120063,118,120115,118,120167,118,120219,118,120271,118,120323,118,120375,118,120427,118,120479,118,7456,118,957,118,120526,118,120584,118,120642,118,120700,118,120758,118,1141,118,1496,118,71430,118,43945,118,71872,118,119309,86,1639,86,1783,86,8548,86,119829,86,119881,86,119933,86,119985,86,120037,86,120089,86,120141,86,120193,86,120245,86,120297,86,120349,86,120401,86,120453,86,1140,86,11576,86,5081,86,5167,86,42719,86,42214,86,93960,86,71840,86,66845,86,623,119,119856,119,119908,119,119960,119,120012,119,120064,119,120116,119,120168,119,120220,119,120272,119,120324,119,120376,119,120428,119,120480,119,7457,119,1121,119,1309,119,1377,119,71434,119,71438,119,71439,119,43907,119,71919,87,71910,87,119830,87,119882,87,119934,87,119986,87,120038,87,120090,87,120142,87,120194,87,120246,87,120298,87,120350,87,120402,87,120454,87,1308,87,5043,87,5076,87,42218,87,5742,120,10539,120,10540,120,10799,120,65368,120,8569,120,119857,120,119909,120,119961,120,120013,120,120065,120,120117,120,120169,120,120221,120,120273,120,120325,120,120377,120,120429,120,120481,120,5441,120,5501,120,5741,88,9587,88,66338,88,71916,88,65336,88,8553,88,119831,88,119883,88,119935,88,119987,88,120039,88,120091,88,120143,88,120195,88,120247,88,120299,88,120351,88,120403,88,120455,88,42931,88,935,88,120510,88,120568,88,120626,88,120684,88,120742,88,11436,88,11613,88,5815,88,42219,88,66192,88,66228,88,66327,88,66855,88,611,121,7564,121,65369,121,119858,121,119910,121,119962,121,120014,121,120066,121,120118,121,120170,121,120222,121,120274,121,120326,121,120378,121,120430,121,120482,121,655,121,7935,121,43866,121,947,121,8509,121,120516,121,120574,121,120632,121,120690,121,120748,121,1199,121,4327,121,71900,121,65337,89,119832,89,119884,89,119936,89,119988,89,120040,89,120092,89,120144,89,120196,89,120248,89,120300,89,120352,89,120404,89,120456,89,933,89,978,89,120508,89,120566,89,120624,89,120682,89,120740,89,11432,89,1198,89,5033,89,5053,89,42220,89,94019,89,71844,89,66226,89,119859,122,119911,122,119963,122,120015,122,120067,122,120119,122,120171,122,120223,122,120275,122,120327,122,120379,122,120431,122,120483,122,7458,122,43923,122,71876,122,66293,90,71909,90,65338,90,8484,90,8488,90,119833,90,119885,90,119937,90,119989,90,120041,90,120197,90,120249,90,120301,90,120353,90,120405,90,120457,90,918,90,120493,90,120551,90,120609,90,120667,90,120725,90,5059,90,42204,90,71849,90,65282,34,65284,36,65285,37,65286,38,65290,42,65291,43,65294,46,65295,47,65296,48,65297,49,65298,50,65299,51,65300,52,65301,53,65302,54,65303,55,65304,56,65305,57,65308,60,65309,61,65310,62,65312,64,65316,68,65318,70,65319,71,65324,76,65329,81,65330,82,65333,85,65334,86,65335,87,65343,95,65346,98,65348,100,65350,102,65355,107,65357,109,65358,110,65361,113,65362,114,65364,116,65365,117,65367,119,65370,122,65371,123,65373,125,119846,109],"_default":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"cs":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"de":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"es":[8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"fr":[65374,126,65306,58,65281,33,8216,96,8245,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"it":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"ja":[8211,45,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65292,44,65307,59],"ko":[8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"pl":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"pt-BR":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"qps-ploc":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"ru":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,305,105,921,73,1009,112,215,120,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"tr":[160,32,8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"zh-hans":[65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65288,40,65289,41],"zh-hant":[8211,45,65374,126,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65307,59]}'))), xu.cache = new class {
  constructor(n, e = JSON.stringify) {
    this.fn = n, this._computeKey = e, this.lastCache = void 0, this.lastArgKey = void 0;
  }
  get(n) {
    const e = this._computeKey(n);
    return this.lastArgKey !== e && (this.lastArgKey = e, this.lastCache = this.fn(n)), this.lastCache;
  }
}(((n) => {
  function e(a) {
    const l = /* @__PURE__ */ new Map();
    for (let d = 0; d < a.length; d += 2) l.set(a[d], a[d + 1]);
    return l;
  }
  function t(a, l) {
    if (!a) return l;
    const d = /* @__PURE__ */ new Map();
    for (const [h, c] of a) l.has(h) && d.set(h, c);
    return d;
  }
  const i = Sp.ambiguousCharacterData.value;
  let s, o = n.filter(((a) => !a.startsWith("_") && a in i));
  o.length === 0 && (o = ["_default"]);
  for (const a of o)
    s = t(s, e(i[a]));
  const r = (function(a, l) {
    const d = new Map(a);
    for (const [h, c] of l) d.set(h, c);
    return d;
  })(e(i._common), s);
  return new Sp(r);
})), xu._locales = new ua((() => Object.keys(Sp.ambiguousCharacterData.value).filter(((n) => !n.startsWith("_")))));
class ul {
  static getRawData() {
    return JSON.parse("[9,10,11,12,13,32,127,160,173,847,1564,4447,4448,6068,6069,6155,6156,6157,6158,7355,7356,8192,8193,8194,8195,8196,8197,8198,8199,8200,8201,8202,8203,8204,8205,8206,8207,8234,8235,8236,8237,8238,8239,8287,8288,8289,8290,8291,8292,8293,8294,8295,8296,8297,8298,8299,8300,8301,8302,8303,10240,12288,12644,65024,65025,65026,65027,65028,65029,65030,65031,65032,65033,65034,65035,65036,65037,65038,65039,65279,65440,65520,65521,65522,65523,65524,65525,65526,65527,65528,65532,78844,119155,119156,119157,119158,119159,119160,119161,119162,917504,917505,917506,917507,917508,917509,917510,917511,917512,917513,917514,917515,917516,917517,917518,917519,917520,917521,917522,917523,917524,917525,917526,917527,917528,917529,917530,917531,917532,917533,917534,917535,917536,917537,917538,917539,917540,917541,917542,917543,917544,917545,917546,917547,917548,917549,917550,917551,917552,917553,917554,917555,917556,917557,917558,917559,917560,917561,917562,917563,917564,917565,917566,917567,917568,917569,917570,917571,917572,917573,917574,917575,917576,917577,917578,917579,917580,917581,917582,917583,917584,917585,917586,917587,917588,917589,917590,917591,917592,917593,917594,917595,917596,917597,917598,917599,917600,917601,917602,917603,917604,917605,917606,917607,917608,917609,917610,917611,917612,917613,917614,917615,917616,917617,917618,917619,917620,917621,917622,917623,917624,917625,917626,917627,917628,917629,917630,917631,917760,917761,917762,917763,917764,917765,917766,917767,917768,917769,917770,917771,917772,917773,917774,917775,917776,917777,917778,917779,917780,917781,917782,917783,917784,917785,917786,917787,917788,917789,917790,917791,917792,917793,917794,917795,917796,917797,917798,917799,917800,917801,917802,917803,917804,917805,917806,917807,917808,917809,917810,917811,917812,917813,917814,917815,917816,917817,917818,917819,917820,917821,917822,917823,917824,917825,917826,917827,917828,917829,917830,917831,917832,917833,917834,917835,917836,917837,917838,917839,917840,917841,917842,917843,917844,917845,917846,917847,917848,917849,917850,917851,917852,917853,917854,917855,917856,917857,917858,917859,917860,917861,917862,917863,917864,917865,917866,917867,917868,917869,917870,917871,917872,917873,917874,917875,917876,917877,917878,917879,917880,917881,917882,917883,917884,917885,917886,917887,917888,917889,917890,917891,917892,917893,917894,917895,917896,917897,917898,917899,917900,917901,917902,917903,917904,917905,917906,917907,917908,917909,917910,917911,917912,917913,917914,917915,917916,917917,917918,917919,917920,917921,917922,917923,917924,917925,917926,917927,917928,917929,917930,917931,917932,917933,917934,917935,917936,917937,917938,917939,917940,917941,917942,917943,917944,917945,917946,917947,917948,917949,917950,917951,917952,917953,917954,917955,917956,917957,917958,917959,917960,917961,917962,917963,917964,917965,917966,917967,917968,917969,917970,917971,917972,917973,917974,917975,917976,917977,917978,917979,917980,917981,917982,917983,917984,917985,917986,917987,917988,917989,917990,917991,917992,917993,917994,917995,917996,917997,917998,917999]");
  }
  static getData() {
    return this._data || (this._data = new Set(ul.getRawData())), this._data;
  }
  static isInvisibleCharacter(e) {
    return ul.getData().has(e);
  }
  static get codePoints() {
    return ul.getData();
  }
}
ul._data = void 0;
class LE {
  constructor() {
    this.mapWindowIdToZoomFactor = /* @__PURE__ */ new Map();
  }
  getZoomFactor(e) {
    var t;
    return (t = this.mapWindowIdToZoomFactor.get(this.getWindowId(e))) !== null && t !== void 0 ? t : 1;
  }
  getWindowId(e) {
    return e.vscodeWindowId;
  }
}
function n8(n, e, t) {
  typeof e == "string" && (e = n.matchMedia(e)), e.addEventListener("change", t);
}
LE.INSTANCE = new LE();
const hf = navigator.userAgent, tr = hf.indexOf("Firefox") >= 0, OS = hf.indexOf("AppleWebKit") >= 0, m1 = hf.indexOf("Chrome") >= 0, _c = !m1 && hf.indexOf("Safari") >= 0, s8 = !m1 && !_c && OS;
hf.indexOf("Electron/");
const lO = hf.indexOf("Android") >= 0;
let Pk = !1;
if (typeof It.matchMedia == "function") {
  const n = It.matchMedia("(display-mode: standalone) or (display-mode: window-controls-overlay)"), e = It.matchMedia("(display-mode: fullscreen)");
  Pk = n.matches, n8(It, n, (({ matches: t }) => {
    Pk && e.matches || (Pk = t);
  }));
}
ml || document.queryCommandSupported && document.queryCommandSupported("copy") || navigator && navigator.clipboard && navigator.clipboard.writeText, ml || navigator && navigator.clipboard && navigator.clipboard.readText;
const dR = It.PointerEvent && ("ontouchstart" in It || navigator.maxTouchPoints > 0);
function kE(n, e) {
  if (typeof n == "number") {
    if (n === 0) return null;
    const t = (65535 & n) >>> 0, i = (4294901760 & n) >>> 16;
    return new dO(i !== 0 ? [X1(t, e), X1(i, e)] : [X1(t, e)]);
  }
  {
    const t = [];
    for (let i = 0; i < n.length; i++) t.push(X1(n[i], e));
    return new dO(t);
  }
}
function X1(n, e) {
  const t = !!(2048 & n), i = !!(256 & n);
  return new Od(e === 2 ? i : t, !!(1024 & n), !!(512 & n), e === 2 ? t : i, 255 & n);
}
class Od {
  constructor(e, t, i, s, o) {
    this.ctrlKey = e, this.shiftKey = t, this.altKey = i, this.metaKey = s, this.keyCode = o;
  }
  equals(e) {
    return e instanceof Od && this.ctrlKey === e.ctrlKey && this.shiftKey === e.shiftKey && this.altKey === e.altKey && this.metaKey === e.metaKey && this.keyCode === e.keyCode;
  }
  isModifierKey() {
    return this.keyCode === 0 || this.keyCode === 5 || this.keyCode === 57 || this.keyCode === 6 || this.keyCode === 4;
  }
  isDuplicateModifierCase() {
    return this.ctrlKey && this.keyCode === 5 || this.shiftKey && this.keyCode === 4 || this.altKey && this.keyCode === 6 || this.metaKey && this.keyCode === 57;
  }
}
class dO {
  constructor(e) {
    if (e.length === 0) throw Yo("chords");
    this.chords = e;
  }
}
class EK {
  constructor(e, t, i, s, o, r) {
    this.ctrlKey = e, this.shiftKey = t, this.altKey = i, this.metaKey = s, this.keyLabel = o, this.keyAriaLabel = r;
  }
}
class IK {
}
const MK = Je ? 256 : 2048, TK = Je ? 2048 : 256;
class jt {
  constructor(e) {
    var t;
    this._standardKeyboardEventBrand = !0;
    const i = e;
    this.browserEvent = i, this.target = i.target, this.ctrlKey = i.ctrlKey, this.shiftKey = i.shiftKey, this.altKey = i.altKey, this.metaKey = i.metaKey, this.altGraphKey = (t = i.getModifierState) === null || t === void 0 ? void 0 : t.call(i, "AltGraph"), this.keyCode = (function(s) {
      if (s.charCode) {
        const r = String.fromCharCode(s.charCode).toUpperCase();
        return Yl.fromString(r);
      }
      const o = s.keyCode;
      if (o === 3) return 7;
      if (tr) switch (o) {
        case 59:
          return 85;
        case 60:
          if (Cs) return 97;
          break;
        case 61:
          return 86;
        case 107:
          return 109;
        case 109:
          return 111;
        case 173:
          return 88;
        case 224:
          if (Je) return 57;
      }
      else if (OS && (Je && o === 93 || !Je && o === 92))
        return 57;
      return W7[o] || 0;
    })(i), this.code = i.code, this.ctrlKey = this.ctrlKey || this.keyCode === 5, this.altKey = this.altKey || this.keyCode === 6, this.shiftKey = this.shiftKey || this.keyCode === 4, this.metaKey = this.metaKey || this.keyCode === 57, this._asKeybinding = this._computeKeybinding(), this._asKeyCodeChord = this._computeKeyCodeChord();
  }
  preventDefault() {
    this.browserEvent && this.browserEvent.preventDefault && this.browserEvent.preventDefault();
  }
  stopPropagation() {
    this.browserEvent && this.browserEvent.stopPropagation && this.browserEvent.stopPropagation();
  }
  toKeyCodeChord() {
    return this._asKeyCodeChord;
  }
  equals(e) {
    return this._asKeybinding === e;
  }
  _computeKeybinding() {
    let e = 0;
    this.keyCode !== 5 && this.keyCode !== 4 && this.keyCode !== 6 && this.keyCode !== 57 && (e = this.keyCode);
    let t = 0;
    return this.ctrlKey && (t |= MK), this.altKey && (t |= 512), this.shiftKey && (t |= 1024), this.metaKey && (t |= TK), t |= e, t;
  }
  _computeKeyCodeChord() {
    let e = 0;
    return this.keyCode !== 5 && this.keyCode !== 4 && this.keyCode !== 6 && this.keyCode !== 57 && (e = this.keyCode), new Od(this.ctrlKey, this.shiftKey, this.altKey, this.metaKey, e);
  }
}
const hO = /* @__PURE__ */ new WeakMap();
function RK(n) {
  if (!n.parent || n.parent === n) return null;
  try {
    const e = n.location, t = n.parent.location;
    if (e.origin !== "null" && t.origin !== "null" && e.origin !== t.origin) return null;
  } catch {
    return null;
  }
  return n.parent;
}
class AK {
  static getSameOriginWindowChain(e) {
    let t = hO.get(e);
    if (!t) {
      t = [], hO.set(e, t);
      let i, s = e;
      do
        i = RK(s), i ? t.push({ window: new WeakRef(s), iframeElement: s.frameElement || null }) : t.push({ window: new WeakRef(s), iframeElement: null }), s = i;
      while (s);
    }
    return t.slice(0);
  }
  static getPositionOfChildWindowRelativeToAncestorWindow(e, t) {
    var i, s;
    if (!t || e === t) return { top: 0, left: 0 };
    let o = 0, r = 0;
    const a = this.getSameOriginWindowChain(e);
    for (const l of a) {
      const d = l.window.deref();
      if (o += (i = d?.scrollY) !== null && i !== void 0 ? i : 0, r += (s = d?.scrollX) !== null && s !== void 0 ? s : 0, d === t || !l.iframeElement) break;
      const h = l.iframeElement.getBoundingClientRect();
      o += h.top, r += h.left;
    }
    return { top: o, left: r };
  }
}
class _r {
  constructor(e, t) {
    this.timestamp = Date.now(), this.browserEvent = t, this.leftButton = t.button === 0, this.middleButton = t.button === 1, this.rightButton = t.button === 2, this.buttons = t.buttons, this.target = t.target, this.detail = t.detail || 1, t.type === "dblclick" && (this.detail = 2), this.ctrlKey = t.ctrlKey, this.shiftKey = t.shiftKey, this.altKey = t.altKey, this.metaKey = t.metaKey, typeof t.pageX == "number" ? (this.posx = t.pageX, this.posy = t.pageY) : (this.posx = t.clientX + this.target.ownerDocument.body.scrollLeft + this.target.ownerDocument.documentElement.scrollLeft, this.posy = t.clientY + this.target.ownerDocument.body.scrollTop + this.target.ownerDocument.documentElement.scrollTop);
    const i = AK.getPositionOfChildWindowRelativeToAncestorWindow(e, t.view);
    this.posx -= i.left, this.posy -= i.top;
  }
  preventDefault() {
    this.browserEvent.preventDefault();
  }
  stopPropagation() {
    this.browserEvent.stopPropagation();
  }
}
class rg {
  constructor(e, t = 0, i = 0) {
    var s;
    this.browserEvent = e || null, this.target = e ? e.target || e.targetNode || e.srcElement : null, this.deltaY = i, this.deltaX = t;
    let o = !1;
    if (m1) {
      const r = navigator.userAgent.match(/Chrome\/(\d+)/);
      o = (r ? parseInt(r[1]) : 123) <= 122;
    }
    if (e) {
      const r = e, a = e, l = ((s = e.view) === null || s === void 0 ? void 0 : s.devicePixelRatio) || 1;
      if (r.wheelDeltaY !== void 0) this.deltaY = o ? r.wheelDeltaY / (120 * l) : r.wheelDeltaY / 120;
      else if (a.VERTICAL_AXIS !== void 0 && a.axis === a.VERTICAL_AXIS) this.deltaY = -a.detail / 3;
      else if (e.type === "wheel") {
        const d = e;
        d.deltaMode === d.DOM_DELTA_LINE ? this.deltaY = tr && !Je ? -e.deltaY / 3 : -e.deltaY : this.deltaY = -e.deltaY / 40;
      }
      if (r.wheelDeltaX !== void 0) this.deltaX = _c && Tn ? -r.wheelDeltaX / 120 : o ? r.wheelDeltaX / (120 * l) : r.wheelDeltaX / 120;
      else if (a.HORIZONTAL_AXIS !== void 0 && a.axis === a.HORIZONTAL_AXIS) this.deltaX = -e.detail / 3;
      else if (e.type === "wheel") {
        const d = e;
        d.deltaMode === d.DOM_DELTA_LINE ? this.deltaX = tr && !Je ? -e.deltaX / 3 : -e.deltaX : this.deltaX = -e.deltaX / 40;
      }
      this.deltaY === 0 && this.deltaX === 0 && e.wheelDelta && (this.deltaY = o ? e.wheelDelta / (120 * l) : e.wheelDelta / 120);
    }
  }
  preventDefault() {
    var e;
    (e = this.browserEvent) === null || e === void 0 || e.preventDefault();
  }
  stopPropagation() {
    var e;
    (e = this.browserEvent) === null || e === void 0 || e.stopPropagation();
  }
}
const o8 = Symbol("MicrotaskDelay");
function Ok(n) {
  return !!n && typeof n.then == "function";
}
function on(n) {
  const e = new Ci(), t = n(e.token), i = new Promise(((s, o) => {
    const r = e.token.onCancellationRequested((() => {
      r.dispose(), o(new Vd());
    }));
    Promise.resolve(t).then(((a) => {
      r.dispose(), e.dispose(), s(a);
    }), ((a) => {
      r.dispose(), e.dispose(), o(a);
    }));
  }));
  return new class {
    cancel() {
      e.cancel(), e.dispose();
    }
    then(s, o) {
      return i.then(s, o);
    }
    catch(s) {
      return this.then(void 0, s);
    }
    finally(s) {
      return i.finally(s);
    }
  }();
}
function f1(n, e, t) {
  return new Promise(((i, s) => {
    const o = e.onCancellationRequested((() => {
      o.dispose(), i(t);
    }));
    n.then(i, s).finally((() => o.dispose()));
  }));
}
class PK {
  constructor() {
    this.isDisposed = !1, this.activePromise = null, this.queuedPromise = null, this.queuedPromiseFactory = null;
  }
  queue(e) {
    if (this.isDisposed) return Promise.reject(new Error("Throttler is disposed"));
    if (this.activePromise) {
      if (this.queuedPromiseFactory = e, !this.queuedPromise) {
        const t = () => {
          if (this.queuedPromise = null, this.isDisposed) return;
          const i = this.queue(this.queuedPromiseFactory);
          return this.queuedPromiseFactory = null, i;
        };
        this.queuedPromise = new Promise(((i) => {
          this.activePromise.then(t, t).then(i);
        }));
      }
      return new Promise(((t, i) => {
        this.queuedPromise.then(t, i);
      }));
    }
    return this.activePromise = e(), new Promise(((t, i) => {
      this.activePromise.then(((s) => {
        this.activePromise = null, t(s);
      }), ((s) => {
        this.activePromise = null, i(s);
      }));
    }));
  }
  dispose() {
    this.isDisposed = !0;
  }
}
class Sr {
  constructor(e) {
    this.defaultDelay = e, this.deferred = null, this.completionPromise = null, this.doResolve = null, this.doReject = null, this.task = null;
  }
  trigger(e, t = this.defaultDelay) {
    this.task = e, this.cancelTimeout(), this.completionPromise || (this.completionPromise = new Promise(((s, o) => {
      this.doResolve = s, this.doReject = o;
    })).then((() => {
      if (this.completionPromise = null, this.doResolve = null, this.task) {
        const s = this.task;
        return this.task = null, s();
      }
    })));
    const i = () => {
      var s;
      this.deferred = null, (s = this.doResolve) === null || s === void 0 || s.call(this, null);
    };
    return this.deferred = t === o8 ? ((s) => {
      let o = !0;
      return queueMicrotask((() => {
        o && (o = !1, s());
      })), { isTriggered: () => o, dispose: () => {
        o = !1;
      } };
    })(i) : ((s, o) => {
      let r = !0;
      const a = setTimeout((() => {
        r = !1, o();
      }), s);
      return { isTriggered: () => r, dispose: () => {
        clearTimeout(a), r = !1;
      } };
    })(t, i), this.completionPromise;
  }
  isTriggered() {
    var e;
    return !!(!((e = this.deferred) === null || e === void 0) && e.isTriggered());
  }
  cancel() {
    var e;
    this.cancelTimeout(), this.completionPromise && ((e = this.doReject) === null || e === void 0 || e.call(this, new Vd()), this.completionPromise = null);
  }
  cancelTimeout() {
    var e;
    (e = this.deferred) === null || e === void 0 || e.dispose(), this.deferred = null;
  }
  dispose() {
    this.cancel();
  }
}
class r8 {
  constructor(e) {
    this.delayer = new Sr(e), this.throttler = new PK();
  }
  trigger(e, t) {
    return this.delayer.trigger((() => this.throttler.queue(e)), t);
  }
  cancel() {
    this.delayer.cancel();
  }
  dispose() {
    this.delayer.dispose(), this.throttler.dispose();
  }
}
function vc(n, e) {
  return e ? new Promise(((t, i) => {
    const s = setTimeout((() => {
      o.dispose(), t();
    }), n), o = e.onCancellationRequested((() => {
      clearTimeout(s), o.dispose(), i(new Vd());
    }));
  })) : on(((t) => vc(n, t)));
}
function bc(n, e = 0, t) {
  const i = setTimeout((() => {
    n(), t && s.dispose();
  }), e), s = ye((() => {
    clearTimeout(i), t?.deleteAndLeak(s);
  }));
  return t?.add(s), s;
}
function hR(n, e = ((i) => !!i), t = null) {
  let i = 0;
  const s = n.length, o = () => {
    if (i >= s) return Promise.resolve(t);
    const r = n[i++];
    return Promise.resolve(r()).then(((a) => e(a) ? Promise.resolve(a) : o()));
  };
  return o();
}
class Dr {
  constructor(e, t) {
    this._token = -1, typeof e == "function" && typeof t == "number" && this.setIfNotSet(e, t);
  }
  dispose() {
    this.cancel();
  }
  cancel() {
    this._token !== -1 && (clearTimeout(this._token), this._token = -1);
  }
  cancelAndSet(e, t) {
    this.cancel(), this._token = setTimeout((() => {
      this._token = -1, e();
    }), t);
  }
  setIfNotSet(e, t) {
    this._token === -1 && (this._token = setTimeout((() => {
      this._token = -1, e();
    }), t));
  }
}
class cR {
  constructor() {
    this.disposable = void 0;
  }
  cancel() {
    var e;
    (e = this.disposable) === null || e === void 0 || e.dispose(), this.disposable = void 0;
  }
  cancelAndSet(e, t, i = globalThis) {
    this.cancel();
    const s = i.setInterval((() => {
      e();
    }), t);
    this.disposable = ye((() => {
      i.clearInterval(s), this.disposable = void 0;
    }));
  }
  dispose() {
    this.cancel();
  }
}
class Et {
  constructor(e, t) {
    this.timeoutToken = -1, this.runner = e, this.timeout = t, this.timeoutHandler = this.onTimeout.bind(this);
  }
  dispose() {
    this.cancel(), this.runner = null;
  }
  cancel() {
    this.isScheduled() && (clearTimeout(this.timeoutToken), this.timeoutToken = -1);
  }
  schedule(e = this.timeout) {
    this.cancel(), this.timeoutToken = setTimeout(this.timeoutHandler, e);
  }
  get delay() {
    return this.timeout;
  }
  set delay(e) {
    this.timeout = e;
  }
  isScheduled() {
    return this.timeoutToken !== -1;
  }
  onTimeout() {
    this.timeoutToken = -1, this.runner && this.doRun();
  }
  doRun() {
    var e;
    (e = this.runner) === null || e === void 0 || e.call(this);
  }
}
let a8, Vw;
Vw = typeof globalThis.requestIdleCallback != "function" || typeof globalThis.cancelIdleCallback != "function" ? (n, e) => {
  S7((() => {
    if (t) return;
    const i = Date.now() + 15;
    e(Object.freeze({ didTimeout: !0, timeRemaining: () => Math.max(0, i - Date.now()) }));
  }));
  let t = !1;
  return { dispose() {
    t || (t = !0);
  } };
} : (n, e, t) => {
  const i = n.requestIdleCallback(e, typeof t == "number" ? { timeout: t } : void 0);
  let s = !1;
  return { dispose() {
    s || (s = !0, n.cancelIdleCallback(i));
  } };
}, a8 = (n) => Vw(globalThis, n);
class l8 {
  constructor(e, t) {
    this._didRun = !1, this._executor = () => {
      try {
        this._value = t();
      } catch (i) {
        this._error = i;
      } finally {
        this._didRun = !0;
      }
    }, this._handle = Vw(e, (() => this._executor()));
  }
  dispose() {
    this._handle.dispose();
  }
  get value() {
    if (this._didRun || (this._handle.dispose(), this._executor()), this._error) throw this._error;
    return this._value;
  }
  get isInitialized() {
    return this._didRun;
  }
}
class OK extends l8 {
  constructor(e) {
    super(globalThis, e);
  }
}
class _1 {
  get isRejected() {
    var e;
    return ((e = this.outcome) === null || e === void 0 ? void 0 : e.outcome) === 1;
  }
  get isSettled() {
    return !!this.outcome;
  }
  constructor() {
    this.p = new Promise(((e, t) => {
      this.completeCallback = e, this.errorCallback = t;
    }));
  }
  complete(e) {
    return new Promise(((t) => {
      this.completeCallback(e), this.outcome = { outcome: 0, value: e }, t();
    }));
  }
  error(e) {
    return new Promise(((t) => {
      this.errorCallback(e), this.outcome = { outcome: 1, value: e }, t();
    }));
  }
  cancel() {
    return this.error(new Vd());
  }
}
var DE;
(function(n) {
  n.settled = async function(e) {
    let t;
    const i = await Promise.all(e.map(((s) => s.then(((o) => o), ((o) => {
      t || (t = o);
    })))));
    if (t !== void 0) throw t;
    return i;
  }, n.withAsyncBody = function(e) {
    return new Promise((async (t, i) => {
      try {
        await e(t, i);
      } catch (s) {
        i(s);
      }
    }));
  };
})(DE || (DE = {}));
class Pi {
  static fromArray(e) {
    return new Pi(((t) => {
      t.emitMany(e);
    }));
  }
  static fromPromise(e) {
    return new Pi((async (t) => {
      t.emitMany(await e);
    }));
  }
  static fromPromises(e) {
    return new Pi((async (t) => {
      await Promise.all(e.map((async (i) => t.emitOne(await i))));
    }));
  }
  static merge(e) {
    return new Pi((async (t) => {
      await Promise.all(e.map((async (i) => {
        for await (const s of i) t.emitOne(s);
      })));
    }));
  }
  constructor(e) {
    this._state = 0, this._results = [], this._error = null, this._onStateChanged = new F(), queueMicrotask((async () => {
      const t = { emitOne: (i) => this.emitOne(i), emitMany: (i) => this.emitMany(i), reject: (i) => this.reject(i) };
      try {
        await Promise.resolve(e(t)), this.resolve();
      } catch (i) {
        this.reject(i);
      } finally {
        t.emitOne = void 0, t.emitMany = void 0, t.reject = void 0;
      }
    }));
  }
  [Symbol.asyncIterator]() {
    let e = 0;
    return { next: async () => {
      for (; ; ) {
        if (this._state === 2) throw this._error;
        if (e < this._results.length) return { done: !1, value: this._results[e++] };
        if (this._state === 1) return { done: !0, value: void 0 };
        await se.toPromise(this._onStateChanged.event);
      }
    } };
  }
  static map(e, t) {
    return new Pi((async (i) => {
      for await (const s of e) i.emitOne(t(s));
    }));
  }
  map(e) {
    return Pi.map(this, e);
  }
  static filter(e, t) {
    return new Pi((async (i) => {
      for await (const s of e) t(s) && i.emitOne(s);
    }));
  }
  filter(e) {
    return Pi.filter(this, e);
  }
  static coalesce(e) {
    return Pi.filter(e, ((t) => !!t));
  }
  coalesce() {
    return Pi.coalesce(this);
  }
  static async toPromise(e) {
    const t = [];
    for await (const i of e) t.push(i);
    return t;
  }
  toPromise() {
    return Pi.toPromise(this);
  }
  emitOne(e) {
    this._state === 0 && (this._results.push(e), this._onStateChanged.fire());
  }
  emitMany(e) {
    this._state === 0 && (this._results = this._results.concat(e), this._onStateChanged.fire());
  }
  resolve() {
    this._state === 0 && (this._state = 1, this._onStateChanged.fire());
  }
  reject(e) {
    this._state === 0 && (this._state = 2, this._error = e, this._onStateChanged.fire());
  }
}
Pi.EMPTY = Pi.fromArray([]);
class FK extends Pi {
  constructor(e, t) {
    super(t), this._source = e;
  }
  cancel() {
    this._source.cancel();
  }
}
const { entries: d8, setPrototypeOf: cO, isFrozen: BK, getPrototypeOf: WK, getOwnPropertyDescriptor: VK } = Object;
let { freeze: eo, seal: ga, create: HK } = Object, { apply: xE, construct: NE } = typeof Reflect < "u" && Reflect;
xE || (xE = function(n, e, t) {
  return n.apply(e, t);
}), eo || (eo = function(n) {
  return n;
}), ga || (ga = function(n) {
  return n;
}), NE || (NE = function(n, e) {
  return new n(...e);
});
const zK = Lr(Array.prototype.forEach), uO = Lr(Array.prototype.pop), xf = Lr(Array.prototype.push), NC = Lr(String.prototype.toLowerCase), Fk = Lr(String.prototype.toString), UK = Lr(String.prototype.match), Tr = Lr(String.prototype.replace), KK = Lr(String.prototype.indexOf), jK = Lr(String.prototype.trim), Po = Lr(RegExp.prototype.test), Nf = (gO = TypeError, function() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++) e[t] = arguments[t];
  return NE(gO, e);
});
var gO;
function Lr(n) {
  return function(e) {
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) i[s - 1] = arguments[s];
    return xE(n, e, i);
  };
}
function xt(n, e, t) {
  var i;
  t = (i = t) !== null && i !== void 0 ? i : NC, cO && cO(n, null);
  let s = e.length;
  for (; s--; ) {
    let o = e[s];
    if (typeof o == "string") {
      const r = t(o);
      r !== o && (BK(e) || (e[s] = r), o = r);
    }
    n[o] = !0;
  }
  return n;
}
function Vg(n) {
  const e = HK(null);
  for (const [t, i] of d8(n)) e[t] = i;
  return e;
}
function Q1(n, e) {
  for (; n !== null; ) {
    const t = VK(n, e);
    if (t) {
      if (t.get) return Lr(t.get);
      if (typeof t.value == "function") return Lr(t.value);
    }
    n = WK(n);
  }
  return function(t) {
    return console.warn("fallback value for", t), null;
  };
}
const pO = eo(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Bk = eo(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Wk = eo(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), qK = eo(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Vk = eo(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), $K = eo(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), mO = eo(["#text"]), fO = eo(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), Hk = eo(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), _O = eo(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), J1 = eo(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), GK = ga(/\{\{[\w\W]*|[\w\W]*\}\}/gm), ZK = ga(/<%[\w\W]*|[\w\W]*%>/gm), YK = ga(/\${[\w\W]*}/gm), XK = ga(/^data-[\-\w.\u00B7-\uFFFF]/), QK = ga(/^aria-[\-\w]+$/), h8 = ga(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), JK = ga(/^(?:\w+script|data):/i), ej = ga(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), c8 = ga(/^html$/i);
var vO = Object.freeze({ __proto__: null, MUSTACHE_EXPR: GK, ERB_EXPR: ZK, TMPLIT_EXPR: YK, DATA_ATTR: XK, ARIA_ATTR: QK, IS_ALLOWED_URI: h8, IS_SCRIPT_OR_DATA: JK, ATTR_WHITESPACE: ej, DOCTYPE_NAME: c8 });
const tj = () => typeof window > "u" ? null : window;
var gl = (function n() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : tj();
  const t = (j) => n(j);
  if (t.version = "3.0.5", t.removed = [], !e || !e.document || e.document.nodeType !== 9) return t.isSupported = !1, t;
  const i = e.document, s = i.currentScript;
  let { document: o } = e;
  const { DocumentFragment: r, HTMLTemplateElement: a, Node: l, Element: d, NodeFilter: h, NamedNodeMap: c = e.NamedNodeMap || e.MozNamedAttrMap, HTMLFormElement: u, DOMParser: g, trustedTypes: p } = e, f = d.prototype, _ = Q1(f, "cloneNode"), v = Q1(f, "nextSibling"), b = Q1(f, "childNodes"), C = Q1(f, "parentNode");
  if (typeof a == "function") {
    const j = o.createElement("template");
    j.content && j.content.ownerDocument && (o = j.content.ownerDocument);
  }
  let w, y = "";
  const { implementation: L, createNodeIterator: k, createDocumentFragment: N, getElementsByTagName: A } = o, { importNode: B } = i;
  let T = {};
  t.isSupported = typeof d8 == "function" && typeof C == "function" && L && L.createHTMLDocument !== void 0;
  const { MUSTACHE_EXPR: O, ERB_EXPR: H, TMPLIT_EXPR: $, DATA_ATTR: pe, ARIA_ATTR: me, IS_SCRIPT_OR_DATA: ue, ATTR_WHITESPACE: ee } = vO;
  let { IS_ALLOWED_URI: te } = vO, be = null;
  const we = xt({}, [...pO, ...Bk, ...Wk, ...Vk, ...mO]);
  let Re = null;
  const it = xt({}, [...fO, ...Hk, ..._O, ...J1]);
  let ut = Object.seal(Object.create(null, { tagNameCheck: { writable: !0, configurable: !1, enumerable: !0, value: null }, attributeNameCheck: { writable: !0, configurable: !1, enumerable: !0, value: null }, allowCustomizedBuiltInElements: { writable: !0, configurable: !1, enumerable: !0, value: !1 } })), Xi = null, nt = null, De = !0, an = !0, La = !1, Er = !0, Ws = !1, Ss = !1, Ir = !1, jd = !1, Ki = !1, le = !1, Y = !1, M = !0, R = !1, P = !0, U = !1, ce = {}, Ae = null;
  const ge = xt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Ne = null;
  const Xe = xt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Oe = null;
  const _t = xt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Ke = "http://www.w3.org/1998/Math/MathML", Lt = "http://www.w3.org/2000/svg", Mt = "http://www.w3.org/1999/xhtml";
  let si = Mt, Vs = !1, At = null;
  const Wc = xt({}, [Ke, Lt, Mt], Fk);
  let Mr;
  const Dl = ["application/xhtml+xml", "text/html"];
  let Qi, Sn = null;
  const Ag = o.createElement("form"), qd = function(j) {
    return j instanceof RegExp || j instanceof Function;
  }, kf = function(j) {
    if (!Sn || Sn !== j) {
      if (j && typeof j == "object" || (j = {}), j = Vg(j), Mr = Mr = Dl.indexOf(j.PARSER_MEDIA_TYPE) === -1 ? "text/html" : j.PARSER_MEDIA_TYPE, Qi = Mr === "application/xhtml+xml" ? Fk : NC, be = "ALLOWED_TAGS" in j ? xt({}, j.ALLOWED_TAGS, Qi) : we, Re = "ALLOWED_ATTR" in j ? xt({}, j.ALLOWED_ATTR, Qi) : it, At = "ALLOWED_NAMESPACES" in j ? xt({}, j.ALLOWED_NAMESPACES, Fk) : Wc, Oe = "ADD_URI_SAFE_ATTR" in j ? xt(Vg(_t), j.ADD_URI_SAFE_ATTR, Qi) : _t, Ne = "ADD_DATA_URI_TAGS" in j ? xt(Vg(Xe), j.ADD_DATA_URI_TAGS, Qi) : Xe, Ae = "FORBID_CONTENTS" in j ? xt({}, j.FORBID_CONTENTS, Qi) : ge, Xi = "FORBID_TAGS" in j ? xt({}, j.FORBID_TAGS, Qi) : {}, nt = "FORBID_ATTR" in j ? xt({}, j.FORBID_ATTR, Qi) : {}, ce = "USE_PROFILES" in j && j.USE_PROFILES, De = j.ALLOW_ARIA_ATTR !== !1, an = j.ALLOW_DATA_ATTR !== !1, La = j.ALLOW_UNKNOWN_PROTOCOLS || !1, Er = j.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ws = j.SAFE_FOR_TEMPLATES || !1, Ss = j.WHOLE_DOCUMENT || !1, Ki = j.RETURN_DOM || !1, le = j.RETURN_DOM_FRAGMENT || !1, Y = j.RETURN_TRUSTED_TYPE || !1, jd = j.FORCE_BODY || !1, M = j.SANITIZE_DOM !== !1, R = j.SANITIZE_NAMED_PROPS || !1, P = j.KEEP_CONTENT !== !1, U = j.IN_PLACE || !1, te = j.ALLOWED_URI_REGEXP || h8, si = j.NAMESPACE || Mt, ut = j.CUSTOM_ELEMENT_HANDLING || {}, j.CUSTOM_ELEMENT_HANDLING && qd(j.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (ut.tagNameCheck = j.CUSTOM_ELEMENT_HANDLING.tagNameCheck), j.CUSTOM_ELEMENT_HANDLING && qd(j.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (ut.attributeNameCheck = j.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), j.CUSTOM_ELEMENT_HANDLING && typeof j.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (ut.allowCustomizedBuiltInElements = j.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ws && (an = !1), le && (Ki = !0), ce && (be = xt({}, [...mO]), Re = [], ce.html === !0 && (xt(be, pO), xt(Re, fO)), ce.svg === !0 && (xt(be, Bk), xt(Re, Hk), xt(Re, J1)), ce.svgFilters === !0 && (xt(be, Wk), xt(Re, Hk), xt(Re, J1)), ce.mathMl === !0 && (xt(be, Vk), xt(Re, _O), xt(Re, J1))), j.ADD_TAGS && (be === we && (be = Vg(be)), xt(be, j.ADD_TAGS, Qi)), j.ADD_ATTR && (Re === it && (Re = Vg(Re)), xt(Re, j.ADD_ATTR, Qi)), j.ADD_URI_SAFE_ATTR && xt(Oe, j.ADD_URI_SAFE_ATTR, Qi), j.FORBID_CONTENTS && (Ae === ge && (Ae = Vg(Ae)), xt(Ae, j.FORBID_CONTENTS, Qi)), P && (be["#text"] = !0), Ss && xt(be, ["html", "head", "body"]), be.table && (xt(be, ["tbody"]), delete Xi.tbody), j.TRUSTED_TYPES_POLICY) {
        if (typeof j.TRUSTED_TYPES_POLICY.createHTML != "function") throw Nf('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof j.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw Nf('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        w = j.TRUSTED_TYPES_POLICY, y = w.createHTML("");
      } else w === void 0 && (w = (function(xe, Be) {
        if (typeof xe != "object" || typeof xe.createPolicy != "function") return null;
        let Pt = null;
        const di = "data-tt-policy-suffix";
        Be && Be.hasAttribute(di) && (Pt = Be.getAttribute(di));
        const wi = "dompurify" + (Pt ? "#" + Pt : "");
        try {
          return xe.createPolicy(wi, { createHTML: (mi) => mi, createScriptURL: (mi) => mi });
        } catch {
          return console.warn("TrustedTypes policy " + wi + " could not be created."), null;
        }
      })(p, s)), w !== null && typeof y == "string" && (y = w.createHTML(""));
      eo && eo(j), Sn = j;
    }
  }, Pg = xt({}, ["mi", "mo", "mn", "ms", "mtext"]), Df = xt({}, ["foreignobject", "desc", "title", "annotation-xml"]), U1 = xt({}, ["title", "style", "font", "a", "script"]), Og = xt({}, Bk);
  xt(Og, Wk), xt(Og, qK);
  const kk = xt({}, Vk);
  xt(kk, $K);
  const Vc = function(j) {
    xf(t.removed, { element: j });
    try {
      j.parentNode.removeChild(j);
    } catch {
      j.remove();
    }
  }, Dk = function(j, xe) {
    try {
      xf(t.removed, { attribute: xe.getAttributeNode(j), from: xe });
    } catch {
      xf(t.removed, { attribute: null, from: xe });
    }
    if (xe.removeAttribute(j), j === "is" && !Re[j]) if (Ki || le) try {
      Vc(xe);
    } catch {
    }
    else try {
      xe.setAttribute(j, "");
    } catch {
    }
  }, VP = function(j) {
    let xe, Be;
    if (jd) j = "<remove></remove>" + j;
    else {
      const wi = UK(j, /^[\r\n\t ]+/);
      Be = wi && wi[0];
    }
    Mr === "application/xhtml+xml" && si === Mt && (j = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + j + "</body></html>");
    const Pt = w ? w.createHTML(j) : j;
    if (si === Mt) try {
      xe = new g().parseFromString(Pt, Mr);
    } catch {
    }
    if (!xe || !xe.documentElement) {
      xe = L.createDocument(si, "template", null);
      try {
        xe.documentElement.innerHTML = Vs ? y : Pt;
      } catch {
      }
    }
    const di = xe.body || xe.documentElement;
    return j && Be && di.insertBefore(o.createTextNode(Be), di.childNodes[0] || null), si === Mt ? A.call(xe, Ss ? "html" : "body")[0] : Ss ? xe.documentElement : di;
  }, HP = function(j) {
    return k.call(j.ownerDocument || j, j, h.SHOW_ELEMENT | h.SHOW_COMMENT | h.SHOW_TEXT, null, !1);
  }, K1 = function(j) {
    return typeof l == "object" ? j instanceof l : j && typeof j == "object" && typeof j.nodeType == "number" && typeof j.nodeName == "string";
  }, xl = function(j, xe, Be) {
    T[j] && zK(T[j], ((Pt) => {
      Pt.call(t, xe, Be, Sn);
    }));
  }, zP = function(j) {
    let xe;
    if (xl("beforeSanitizeElements", j, null), (Be = j) instanceof u && (typeof Be.nodeName != "string" || typeof Be.textContent != "string" || typeof Be.removeChild != "function" || !(Be.attributes instanceof c) || typeof Be.removeAttribute != "function" || typeof Be.setAttribute != "function" || typeof Be.namespaceURI != "string" || typeof Be.insertBefore != "function" || typeof Be.hasChildNodes != "function")) return Vc(j), !0;
    var Be;
    const Pt = Qi(j.nodeName);
    if (xl("uponSanitizeElement", j, { tagName: Pt, allowedTags: be }), j.hasChildNodes() && !K1(j.firstElementChild) && (!K1(j.content) || !K1(j.content.firstElementChild)) && Po(/<[/\w]/g, j.innerHTML) && Po(/<[/\w]/g, j.textContent)) return Vc(j), !0;
    if (!be[Pt] || Xi[Pt]) {
      if (!Xi[Pt] && KP(Pt) && (ut.tagNameCheck instanceof RegExp && Po(ut.tagNameCheck, Pt) || ut.tagNameCheck instanceof Function && ut.tagNameCheck(Pt)))
        return !1;
      if (P && !Ae[Pt]) {
        const di = C(j) || j.parentNode, wi = b(j) || j.childNodes;
        if (wi && di)
          for (let mi = wi.length - 1; mi >= 0; --mi) di.insertBefore(_(wi[mi], !0), v(j));
      }
      return Vc(j), !0;
    }
    return j instanceof d && !(function(di) {
      let wi = C(di);
      wi && wi.tagName || (wi = { namespaceURI: si, tagName: "template" });
      const mi = NC(di.tagName), ji = NC(wi.tagName);
      return !!At[di.namespaceURI] && (di.namespaceURI === Lt ? wi.namespaceURI === Mt ? mi === "svg" : wi.namespaceURI === Ke ? mi === "svg" && (ji === "annotation-xml" || Pg[ji]) : !!Og[mi] : di.namespaceURI === Ke ? wi.namespaceURI === Mt ? mi === "math" : wi.namespaceURI === Lt ? mi === "math" && Df[ji] : !!kk[mi] : di.namespaceURI === Mt ? !(wi.namespaceURI === Lt && !Df[ji]) && !(wi.namespaceURI === Ke && !Pg[ji]) && !kk[mi] && (U1[mi] || !Og[mi]) : !(Mr !== "application/xhtml+xml" || !At[di.namespaceURI]));
    })(j) ? (Vc(j), !0) : Pt !== "noscript" && Pt !== "noembed" && Pt !== "noframes" || !Po(/<\/no(script|embed|frames)/i, j.innerHTML) ? (Ws && j.nodeType === 3 && (xe = j.textContent, xe = Tr(xe, O, " "), xe = Tr(xe, H, " "), xe = Tr(xe, $, " "), j.textContent !== xe && (xf(t.removed, { element: j.cloneNode() }), j.textContent = xe)), xl("afterSanitizeElements", j, null), !1) : (Vc(j), !0);
  }, UP = function(j, xe, Be) {
    if (M && (xe === "id" || xe === "name") && (Be in o || Be in Ag)) return !1;
    if (!(an && !nt[xe] && Po(pe, xe))) {
      if (!(De && Po(me, xe))) {
        if (!Re[xe] || nt[xe]) {
          if (!(KP(j) && (ut.tagNameCheck instanceof RegExp && Po(ut.tagNameCheck, j) || ut.tagNameCheck instanceof Function && ut.tagNameCheck(j)) && (ut.attributeNameCheck instanceof RegExp && Po(ut.attributeNameCheck, xe) || ut.attributeNameCheck instanceof Function && ut.attributeNameCheck(xe)) || xe === "is" && ut.allowCustomizedBuiltInElements && (ut.tagNameCheck instanceof RegExp && Po(ut.tagNameCheck, Be) || ut.tagNameCheck instanceof Function && ut.tagNameCheck(Be)))) return !1;
        } else if (!Oe[xe]) {
          if (!Po(te, Tr(Be, ee, ""))) {
            if ((xe !== "src" && xe !== "xlink:href" && xe !== "href" || j === "script" || KK(Be, "data:") !== 0 || !Ne[j]) && !(La && !Po(ue, Tr(Be, ee, "")))) {
              if (Be) return !1;
            }
          }
        }
      }
    }
    return !0;
  }, KP = function(j) {
    return j.indexOf("-") > 0;
  }, jP = function(j) {
    let xe, Be, Pt, di;
    xl("beforeSanitizeAttributes", j, null);
    const { attributes: wi } = j;
    if (!wi) return;
    const mi = { attrName: "", attrValue: "", keepAttr: !0, allowedAttributes: Re };
    for (di = wi.length; di--; ) {
      xe = wi[di];
      const { name: ji, namespaceURI: Fg } = xe;
      if (Be = ji === "value" ? xe.value : jK(xe.value), Pt = Qi(ji), mi.attrName = Pt, mi.attrValue = Be, mi.keepAttr = !0, mi.forceKeepAttr = void 0, xl("uponSanitizeAttribute", j, mi), Be = mi.attrValue, mi.forceKeepAttr || (Dk(ji, j), !mi.keepAttr)) continue;
      if (!Er && Po(/\/>/i, Be)) {
        Dk(ji, j);
        continue;
      }
      Ws && (Be = Tr(Be, O, " "), Be = Tr(Be, H, " "), Be = Tr(Be, $, " "));
      const qP = Qi(j.nodeName);
      if (UP(qP, Pt, Be)) {
        if (!R || Pt !== "id" && Pt !== "name" || (Dk(ji, j), Be = "user-content-" + Be), w && typeof p == "object" && typeof p.getAttributeType == "function" && !Fg) switch (p.getAttributeType(qP, Pt)) {
          case "TrustedHTML":
            Be = w.createHTML(Be);
            break;
          case "TrustedScriptURL":
            Be = w.createScriptURL(Be);
        }
        try {
          Fg ? j.setAttributeNS(Fg, ji, Be) : j.setAttribute(ji, Be), uO(t.removed);
        } catch {
        }
      }
    }
    xl("afterSanitizeAttributes", j, null);
  }, WU = function j(xe) {
    let Be;
    const Pt = HP(xe);
    for (xl("beforeSanitizeShadowDOM", xe, null); Be = Pt.nextNode(); ) xl("uponSanitizeShadowNode", Be, null), zP(Be) || (Be.content instanceof r && j(Be.content), jP(Be));
    xl("afterSanitizeShadowDOM", xe, null);
  };
  return t.sanitize = function(j) {
    let xe, Be, Pt, di, wi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Vs = !j, Vs && (j = "<!-->"), typeof j != "string" && !K1(j)) {
      if (typeof j.toString != "function") throw Nf("toString is not a function");
      if (typeof (j = j.toString()) != "string") throw Nf("dirty is not a string, aborting");
    }
    if (!t.isSupported) return j;
    if (Ir || kf(wi), t.removed = [], typeof j == "string" && (U = !1), U) {
      if (j.nodeName) {
        const Fg = Qi(j.nodeName);
        if (!be[Fg] || Xi[Fg]) throw Nf("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (j instanceof l) xe = VP("<!---->"), Be = xe.ownerDocument.importNode(j, !0), Be.nodeType === 1 && Be.nodeName === "BODY" || Be.nodeName === "HTML" ? xe = Be : xe.appendChild(Be);
    else {
      if (!Ki && !Ws && !Ss && j.indexOf("<") === -1) return w && Y ? w.createHTML(j) : j;
      if (xe = VP(j), !xe) return Ki ? null : Y ? y : "";
    }
    xe && jd && Vc(xe.firstChild);
    const mi = HP(U ? j : xe);
    for (; Pt = mi.nextNode(); ) zP(Pt) || (Pt.content instanceof r && WU(Pt.content), jP(Pt));
    if (U) return j;
    if (Ki) {
      if (le) for (di = N.call(xe.ownerDocument); xe.firstChild; ) di.appendChild(xe.firstChild);
      else di = xe;
      return (Re.shadowroot || Re.shadowrootmode) && (di = B.call(i, di, !0)), di;
    }
    let ji = Ss ? xe.outerHTML : xe.innerHTML;
    return Ss && be["!doctype"] && xe.ownerDocument && xe.ownerDocument.doctype && xe.ownerDocument.doctype.name && Po(c8, xe.ownerDocument.doctype.name) && (ji = "<!DOCTYPE " + xe.ownerDocument.doctype.name + `>
` + ji), Ws && (ji = Tr(ji, O, " "), ji = Tr(ji, H, " "), ji = Tr(ji, $, " ")), w && Y ? w.createHTML(ji) : ji;
  }, t.setConfig = function(j) {
    kf(j), Ir = !0;
  }, t.clearConfig = function() {
    Sn = null, Ir = !1;
  }, t.isValidAttribute = function(j, xe, Be) {
    Sn || kf({});
    const Pt = Qi(j), di = Qi(xe);
    return UP(Pt, di, Be);
  }, t.addHook = function(j, xe) {
    typeof xe == "function" && (T[j] = T[j] || [], xf(T[j], xe));
  }, t.removeHook = function(j) {
    if (T[j]) return uO(T[j]);
  }, t.removeHooks = function(j) {
    T[j] && (T[j] = []);
  }, t.removeAllHooks = function() {
    T = {};
  }, t;
})();
gl.version, gl.isSupported;
const u8 = gl.sanitize;
gl.setConfig, gl.clearConfig, gl.isValidAttribute;
const zk = gl.addHook, bO = gl.removeHook;
var Ue;
function uR(n, e) {
  return Ie.isUri(n) ? Lp(n.scheme, e) : sR(n, e + ":");
}
function CO(n, ...e) {
  return e.some(((t) => uR(n, t)));
}
gl.removeHooks, gl.removeAllHooks, (function(n) {
  n.inMemory = "inmemory", n.vscode = "vscode", n.internal = "private", n.walkThrough = "walkThrough", n.walkThroughSnippet = "walkThroughSnippet", n.http = "http", n.https = "https", n.file = "file", n.mailto = "mailto", n.untitled = "untitled", n.data = "data", n.command = "command", n.vscodeRemote = "vscode-remote", n.vscodeRemoteResource = "vscode-remote-resource", n.vscodeManagedRemoteResource = "vscode-managed-remote-resource", n.vscodeUserData = "vscode-userdata", n.vscodeCustomEditor = "vscode-custom-editor", n.vscodeNotebookCell = "vscode-notebook-cell", n.vscodeNotebookCellMetadata = "vscode-notebook-cell-metadata", n.vscodeNotebookCellOutput = "vscode-notebook-cell-output", n.vscodeInteractiveInput = "vscode-interactive-input", n.vscodeSettings = "vscode-settings", n.vscodeWorkspaceTrust = "vscode-workspace-trust", n.vscodeTerminal = "vscode-terminal", n.vscodeChatCodeBlock = "vscode-chat-code-block", n.vscodeChatSesssion = "vscode-chat-editor", n.webviewPanel = "webview-panel", n.vscodeWebview = "vscode-webview", n.extension = "extension", n.vscodeFileResource = "vscode-file", n.tmp = "tmp", n.vsls = "vsls", n.vscodeSourceControl = "vscode-scm", n.codeSetting = "code-setting";
})(Ue || (Ue = {}));
const g8 = new class {
  constructor() {
    this._hosts = /* @__PURE__ */ Object.create(null), this._ports = /* @__PURE__ */ Object.create(null), this._connectionTokens = /* @__PURE__ */ Object.create(null), this._preferredWebSchema = "http", this._delegate = null, this._serverRootPath = "/";
  }
  setPreferredWebSchema(n) {
    this._preferredWebSchema = n;
  }
  get _remoteResourcesPath() {
    return Fi.join(this._serverRootPath, Ue.vscodeRemoteResource);
  }
  rewrite(n) {
    if (this._delegate) try {
      return this._delegate(n);
    } catch (r) {
      return We(r), n;
    }
    const e = n.authority;
    let t = this._hosts[e];
    t && t.indexOf(":") !== -1 && t.indexOf("[") === -1 && (t = `[${t}]`);
    const i = this._ports[e], s = this._connectionTokens[e];
    let o = `path=${encodeURIComponent(n.path)}`;
    return typeof s == "string" && (o += `&tkn=${encodeURIComponent(s)}`), Ie.from({ scheme: gc ? this._preferredWebSchema : Ue.vscodeRemoteResource, authority: `${t}:${i}`, path: this._remoteResourcesPath, query: o });
  }
}();
class X0 {
  uriToBrowserUri(e) {
    return e.scheme === Ue.vscodeRemote ? g8.rewrite(e) : e.scheme !== Ue.file || !ml && qU !== `${Ue.vscodeFileResource}://${X0.FALLBACK_AUTHORITY}` ? e : e.with({ scheme: Ue.vscodeFileResource, authority: e.authority || X0.FALLBACK_AUTHORITY, query: null, fragment: null });
  }
}
X0.FALLBACK_AUTHORITY = "vscode-app";
const p8 = new X0();
var wO;
function FS(n) {
  return Hw(n, 0);
}
function Hw(n, e) {
  switch (typeof n) {
    case "object":
      return n === null ? Bl(349, e) : Array.isArray(n) ? (t = n, i = Bl(104579, i = e), t.reduce(((s, o) => Hw(o, s)), i)) : (function(s, o) {
        return o = Bl(181387, o), Object.keys(s).sort().reduce(((r, a) => (r = EE(a, r), Hw(s[a], r))), o);
      })(n, e);
    case "string":
      return EE(n, e);
    case "boolean":
      return (function(s, o) {
        return Bl(s ? 433 : 863, o);
      })(n, e);
    case "number":
      return Bl(n, e);
    case "undefined":
      return Bl(937, e);
    default:
      return Bl(617, e);
  }
  var t, i;
}
function Bl(n, e) {
  return (e << 5) - e + n | 0;
}
function EE(n, e) {
  e = Bl(149417, e);
  for (let t = 0, i = n.length; t < i; t++) e = Bl(n.charCodeAt(t), e);
  return e;
}
function Uk(n, e, t = 32) {
  const i = t - e;
  return (n << e | (~((1 << i) - 1) & n) >>> i) >>> 0;
}
function yO(n, e = 0, t = n.byteLength, i = 0) {
  for (let s = 0; s < t; s++) n[e + s] = i;
}
function Ef(n, e = 32) {
  return n instanceof ArrayBuffer ? Array.from(new Uint8Array(n)).map(((t) => t.toString(16).padStart(2, "0"))).join("") : (function(t, i, s = "0") {
    for (; t.length < i; ) t = s + t;
    return t;
  })((n >>> 0).toString(16), e / 4);
}
(function(n) {
  const e = /* @__PURE__ */ new Map([["1", { "Cross-Origin-Opener-Policy": "same-origin" }], ["2", { "Cross-Origin-Embedder-Policy": "require-corp" }], ["3", { "Cross-Origin-Opener-Policy": "same-origin", "Cross-Origin-Embedder-Policy": "require-corp" }]]);
  n.CoopAndCoep = Object.freeze(e.get("3"));
  const t = "vscode-coi";
  n.getHeadersFromQuery = function(i) {
    let s;
    typeof i == "string" ? s = new URL(i).searchParams : i instanceof URL ? s = i.searchParams : Ie.isUri(i) && (s = new URL(i.toString(!0)).searchParams);
    const o = s?.get(t);
    if (o) return e.get(o);
  }, n.addSearchParam = function(i, s, o) {
    if (!globalThis.crossOriginIsolated) return;
    const r = s && o ? "3" : o ? "2" : "1";
    i instanceof URLSearchParams ? i.set(t, r) : i[t] = r;
  };
})(wO || (wO = {}));
class BS {
  constructor() {
    this._h0 = 1732584193, this._h1 = 4023233417, this._h2 = 2562383102, this._h3 = 271733878, this._h4 = 3285377520, this._buff = new Uint8Array(67), this._buffDV = new DataView(this._buff.buffer), this._buffLen = 0, this._totalLen = 0, this._leftoverHighSurrogate = 0, this._finished = !1;
  }
  update(e) {
    const t = e.length;
    if (t === 0) return;
    const i = this._buff;
    let s, o, r = this._buffLen, a = this._leftoverHighSurrogate;
    for (a !== 0 ? (s = a, o = -1, a = 0) : (s = e.charCodeAt(0), o = 0); ; ) {
      let l = s;
      if (en(s)) {
        if (!(o + 1 < t)) {
          a = s;
          break;
        }
        {
          const d = e.charCodeAt(o + 1);
          og(d) ? (o++, l = oR(s, d)) : l = 65533;
        }
      } else og(s) && (l = 65533);
      if (r = this._push(i, r, l), o++, !(o < t)) break;
      s = e.charCodeAt(o);
    }
    this._buffLen = r, this._leftoverHighSurrogate = a;
  }
  _push(e, t, i) {
    return i < 128 ? e[t++] = i : i < 2048 ? (e[t++] = 192 | (1984 & i) >>> 6, e[t++] = 128 | (63 & i) >>> 0) : i < 65536 ? (e[t++] = 224 | (61440 & i) >>> 12, e[t++] = 128 | (4032 & i) >>> 6, e[t++] = 128 | (63 & i) >>> 0) : (e[t++] = 240 | (1835008 & i) >>> 18, e[t++] = 128 | (258048 & i) >>> 12, e[t++] = 128 | (4032 & i) >>> 6, e[t++] = 128 | (63 & i) >>> 0), t >= 64 && (this._step(), t -= 64, this._totalLen += 64, e[0] = e[64], e[1] = e[65], e[2] = e[66]), t;
  }
  digest() {
    return this._finished || (this._finished = !0, this._leftoverHighSurrogate && (this._leftoverHighSurrogate = 0, this._buffLen = this._push(this._buff, this._buffLen, 65533)), this._totalLen += this._buffLen, this._wrapUp()), Ef(this._h0) + Ef(this._h1) + Ef(this._h2) + Ef(this._h3) + Ef(this._h4);
  }
  _wrapUp() {
    this._buff[this._buffLen++] = 128, yO(this._buff, this._buffLen), this._buffLen > 56 && (this._step(), yO(this._buff));
    const e = 8 * this._totalLen;
    this._buffDV.setUint32(56, Math.floor(e / 4294967296), !1), this._buffDV.setUint32(60, e % 4294967296, !1), this._step();
  }
  _step() {
    const e = BS._bigBlock32, t = this._buffDV;
    for (let c = 0; c < 64; c += 4) e.setUint32(c, t.getUint32(c, !1), !1);
    for (let c = 64; c < 320; c += 4) e.setUint32(c, Uk(e.getUint32(c - 12, !1) ^ e.getUint32(c - 32, !1) ^ e.getUint32(c - 56, !1) ^ e.getUint32(c - 64, !1), 1), !1);
    let i, s, o, r = this._h0, a = this._h1, l = this._h2, d = this._h3, h = this._h4;
    for (let c = 0; c < 80; c++) c < 20 ? (i = a & l | ~a & d, s = 1518500249) : c < 40 ? (i = a ^ l ^ d, s = 1859775393) : c < 60 ? (i = a & l | a & d | l & d, s = 2400959708) : (i = a ^ l ^ d, s = 3395469782), o = Uk(r, 5) + i + h + s + e.getUint32(4 * c, !1) & 4294967295, h = d, d = l, l = Uk(a, 30), a = r, r = o;
    this._h0 = this._h0 + r & 4294967295, this._h1 = this._h1 + a & 4294967295, this._h2 = this._h2 + l & 4294967295, this._h3 = this._h3 + d & 4294967295, this._h4 = this._h4 + h & 4294967295;
  }
}
BS._bigBlock32 = new DataView(new ArrayBuffer(320));
const { getWindow: ke, getWindows: m8, getWindowsCount: ij, getWindowId: zw, getWindowById: SO, onDidRegisterWindow: WS, onWillUnregisterWindow: nj, onDidUnregisterWindow: sj } = (function() {
  const n = /* @__PURE__ */ new Map();
  (function(o, r) {
    const a = o;
    typeof a.vscodeWindowId != "number" && Object.defineProperty(a, "vscodeWindowId", { get: () => r });
  })(It, 1);
  const e = { window: It, disposables: new G() };
  n.set(It.vscodeWindowId, e);
  const t = new F(), i = new F(), s = new F();
  return { onDidRegisterWindow: t.event, onWillUnregisterWindow: s.event, onDidUnregisterWindow: i.event, registerWindow(o) {
    if (n.has(o.vscodeWindowId)) return V.None;
    const r = new G(), a = { window: o, disposables: r.add(new G()) };
    return n.set(o.vscodeWindowId, a), r.add(ye((() => {
      n.delete(o.vscodeWindowId), i.fire(o);
    }))), r.add(K(o, ie.BEFORE_UNLOAD, (() => {
      s.fire(o);
    }))), t.fire(a), r;
  }, getWindows: () => n.values(), getWindowsCount: () => n.size, getWindowId: (o) => o.vscodeWindowId, hasWindow: (o) => n.has(o), getWindowById: function(o, r) {
    const a = typeof o == "number" ? n.get(o) : void 0;
    return a ?? (r ? e : void 0);
  }, getWindow(o) {
    var r;
    const a = o;
    if (!((r = a?.ownerDocument) === null || r === void 0) && r.defaultView) return a.ownerDocument.defaultView.window;
    const l = o;
    return l?.view ? l.view.window : It;
  }, getDocument: (o) => ke(o).document };
})();
function Un(n) {
  for (; n.firstChild; ) n.firstChild.remove();
}
class oj {
  constructor(e, t, i, s) {
    this._node = e, this._type = t, this._handler = i, this._options = s || !1, this._node.addEventListener(this._type, this._handler, this._options);
  }
  dispose() {
    this._handler && (this._node.removeEventListener(this._type, this._handler, this._options), this._node = null, this._handler = null);
  }
}
function K(n, e, t, i) {
  return new oj(n, e, t, i);
}
function f8(n, e) {
  return function(t) {
    return e(new _r(n, t));
  };
}
const bi = function(n, e, t, i) {
  let s = t;
  return e === "click" || e === "mousedown" ? s = f8(ke(n), t) : e !== "keydown" && e !== "keypress" && e !== "keyup" || (s = /* @__PURE__ */ (function(o) {
    return function(r) {
      return o(new jt(r));
    };
  })(t)), K(n, e, s, i);
}, rj = function(n, e, t) {
  return (function(i, s, o) {
    return K(i, ca && dR ? ie.POINTER_DOWN : ie.MOUSE_DOWN, s, o);
  })(n, f8(ke(n), e), t);
};
function c_(n, e, t) {
  return Vw(n, e, t);
}
class Kk extends l8 {
  constructor(e, t) {
    super(e, t);
  }
}
let Uw, Ys;
class gR extends cR {
  constructor(e) {
    super(), this.defaultTarget = e && ke(e);
  }
  cancelAndSet(e, t, i) {
    return super.cancelAndSet(e, t, i ?? this.defaultTarget);
  }
}
class jk {
  constructor(e, t = 0) {
    this._runner = e, this.priority = t, this._canceled = !1;
  }
  dispose() {
    this._canceled = !0;
  }
  execute() {
    if (!this._canceled) try {
      this._runner();
    } catch (e) {
      We(e);
    }
  }
  static sort(e, t) {
    return t.priority - e.priority;
  }
}
function VS(n) {
  return ke(n).getComputedStyle(n, null);
}
function Cc(n, e) {
  const t = ke(n), i = t.document;
  if (n !== i.body) return new bt(n.clientWidth, n.clientHeight);
  if (ca && t?.visualViewport) return new bt(t.visualViewport.width, t.visualViewport.height);
  if (t?.innerWidth && t.innerHeight) return new bt(t.innerWidth, t.innerHeight);
  if (i.body && i.body.clientWidth && i.body.clientHeight) return new bt(i.body.clientWidth, i.body.clientHeight);
  if (i.documentElement && i.documentElement.clientWidth && i.documentElement.clientHeight) return new bt(i.documentElement.clientWidth, i.documentElement.clientHeight);
  throw new Error("Unable to figure out browser width and height");
}
(function() {
  const n = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  Ys = (s, o, r = 0) => {
    const a = zw(s), l = new jk(o, r);
    let d = n.get(a);
    return d || (d = [], n.set(a, d)), d.push(l), t.get(a) || (t.set(a, !0), s.requestAnimationFrame((() => ((h) => {
      var c;
      t.set(h, !1);
      const u = (c = n.get(h)) !== null && c !== void 0 ? c : [];
      for (e.set(h, u), n.set(h, []), i.set(h, !0); u.length > 0; ) u.sort(jk.sort), u.shift().execute();
      i.set(h, !1);
    })(a)))), l;
  }, Uw = (s, o, r) => {
    const a = zw(s);
    if (i.get(a)) {
      const l = new jk(o, r);
      let d = e.get(a);
      return d || (d = [], e.set(a, d)), d.push(l), l;
    }
    return Ys(s, o, r);
  };
})();
class Si {
  static convertToPixels(e, t) {
    return parseFloat(t) || 0;
  }
  static getDimension(e, t, i) {
    const s = VS(e), o = s ? s.getPropertyValue(t) : "0";
    return Si.convertToPixels(e, o);
  }
  static getBorderLeftWidth(e) {
    return Si.getDimension(e, "border-left-width", "borderLeftWidth");
  }
  static getBorderRightWidth(e) {
    return Si.getDimension(e, "border-right-width", "borderRightWidth");
  }
  static getBorderTopWidth(e) {
    return Si.getDimension(e, "border-top-width", "borderTopWidth");
  }
  static getBorderBottomWidth(e) {
    return Si.getDimension(e, "border-bottom-width", "borderBottomWidth");
  }
  static getPaddingLeft(e) {
    return Si.getDimension(e, "padding-left", "paddingLeft");
  }
  static getPaddingRight(e) {
    return Si.getDimension(e, "padding-right", "paddingRight");
  }
  static getPaddingTop(e) {
    return Si.getDimension(e, "padding-top", "paddingTop");
  }
  static getPaddingBottom(e) {
    return Si.getDimension(e, "padding-bottom", "paddingBottom");
  }
  static getMarginLeft(e) {
    return Si.getDimension(e, "margin-left", "marginLeft");
  }
  static getMarginTop(e) {
    return Si.getDimension(e, "margin-top", "marginTop");
  }
  static getMarginRight(e) {
    return Si.getDimension(e, "margin-right", "marginRight");
  }
  static getMarginBottom(e) {
    return Si.getDimension(e, "margin-bottom", "marginBottom");
  }
}
class bt {
  constructor(e, t) {
    this.width = e, this.height = t;
  }
  with(e = this.width, t = this.height) {
    return e !== this.width || t !== this.height ? new bt(e, t) : this;
  }
  static is(e) {
    return typeof e == "object" && typeof e.height == "number" && typeof e.width == "number";
  }
  static lift(e) {
    return e instanceof bt ? e : new bt(e.width, e.height);
  }
  static equals(e, t) {
    return e === t || !(!e || !t) && e.width === t.width && e.height === t.height;
  }
}
function _8(n) {
  let e = n.offsetParent, t = n.offsetTop, i = n.offsetLeft;
  for (; (n = n.parentNode) !== null && n !== n.ownerDocument.body && n !== n.ownerDocument.documentElement; ) {
    t -= n.scrollTop;
    const s = b8(n) ? null : VS(n);
    s && (i -= s.direction !== "rtl" ? n.scrollLeft : -n.scrollLeft), n === e && (i += Si.getBorderLeftWidth(n), t += Si.getBorderTopWidth(n), t += n.offsetTop, i += n.offsetLeft, e = n.offsetParent);
  }
  return { left: i, top: t };
}
function Ti(n) {
  const e = n.getBoundingClientRect(), t = ke(n);
  return { left: e.left + t.scrollX, top: e.top + t.scrollY, width: e.width, height: e.height };
}
function v8(n) {
  let e = n, t = 1;
  do {
    const i = VS(e).zoom;
    i != null && i !== "1" && (t *= i), e = e.parentElement;
  } while (e !== null && e !== e.ownerDocument.documentElement);
  return t;
}
function os(n) {
  const e = Si.getMarginLeft(n) + Si.getMarginRight(n);
  return n.offsetWidth + e;
}
function qk(n) {
  const e = Si.getBorderLeftWidth(n) + Si.getBorderRightWidth(n), t = Si.getPaddingLeft(n) + Si.getPaddingRight(n);
  return n.offsetWidth - e - t;
}
function aj(n) {
  const e = Si.getBorderTopWidth(n) + Si.getBorderBottomWidth(n), t = Si.getPaddingTop(n) + Si.getPaddingBottom(n);
  return n.offsetHeight - e - t;
}
function rd(n) {
  const e = Si.getMarginTop(n) + Si.getMarginBottom(n);
  return n.offsetHeight + e;
}
function gn(n, e) {
  return !!e?.contains(n);
}
function $k(n, e, t) {
  return !!(function(i, s, o) {
    for (; i && i.nodeType === i.ELEMENT_NODE; ) {
      if (i.classList.contains(s)) return i;
      if (o) {
        if (typeof o == "string") {
          if (i.classList.contains(o)) return null;
        } else if (i === o) return null;
      }
      i = i.parentNode;
    }
    return null;
  })(n, e, t);
}
function b8(n) {
  return n && !!n.host && !!n.mode;
}
function Kw(n) {
  return !!ag(n);
}
function ag(n) {
  for (var e; n.parentNode; ) {
    if (n === ((e = n.ownerDocument) === null || e === void 0 ? void 0 : e.body)) return null;
    n = n.parentNode;
  }
  return b8(n) ? n : null;
}
function Mn() {
  let n = cf().activeElement;
  for (; n?.shadowRoot; ) n = n.shadowRoot.activeElement;
  return n;
}
function HS(n) {
  return Mn() === n;
}
function C8(n) {
  return gn(Mn(), n);
}
function cf() {
  var n;
  return ij() <= 1 ? It.document : (n = Array.from(m8()).map((({ window: e }) => e.document)).find(((e) => e.hasFocus()))) !== null && n !== void 0 ? n : It.document;
}
bt.None = new bt(0, 0);
const pR = /* @__PURE__ */ new Map();
function w8() {
  return new lj();
}
class lj {
  constructor() {
    this._currentCssStyle = "", this._styleSheet = void 0;
  }
  setStyle(e) {
    e !== this._currentCssStyle && (this._currentCssStyle = e, this._styleSheet ? this._styleSheet.innerText = e : this._styleSheet = Lo(It.document.head, ((t) => t.innerText = e)));
  }
  dispose() {
    this._styleSheet && (this._styleSheet.remove(), this._styleSheet = void 0);
  }
}
function Lo(n = It.document.head, e, t) {
  const i = document.createElement("style");
  if (i.type = "text/css", i.media = "screen", e?.(i), n.appendChild(i), t && t.add(ye((() => n.removeChild(i)))), n === It.document.head) {
    const s = /* @__PURE__ */ new Set();
    pR.set(i, s);
    for (const { window: o, disposables: r } of m8()) {
      if (o === It) continue;
      const a = r.add(dj(i, s, o));
      t?.add(a);
    }
  }
  return i;
}
function dj(n, e, t) {
  var i, s;
  const o = new G(), r = n.cloneNode(!0);
  t.document.head.appendChild(r), o.add(ye((() => t.document.head.removeChild(r))));
  for (const a of S8(n)) (i = r.sheet) === null || i === void 0 || i.insertRule(a.cssText, (s = r.sheet) === null || s === void 0 ? void 0 : s.cssRules.length);
  return o.add(hj.observe(n, o, { childList: !0 })((() => {
    r.textContent = n.textContent;
  }))), e.add(r), o.add(ye((() => e.delete(r)))), o;
}
const hj = new class {
  constructor() {
    this.mutationObservers = /* @__PURE__ */ new Map();
  }
  observe(n, e, t) {
    let i = this.mutationObservers.get(n);
    i || (i = /* @__PURE__ */ new Map(), this.mutationObservers.set(n, i));
    const s = FS(t);
    let o = i.get(s);
    if (o) o.users += 1;
    else {
      const r = new F(), a = new MutationObserver(((d) => r.fire(d)));
      a.observe(n, t);
      const l = o = { users: 1, observer: a, onDidMutate: r.event };
      e.add(ye((() => {
        l.users -= 1, l.users === 0 && (r.dispose(), a.disconnect(), i?.delete(s), i?.size === 0 && this.mutationObservers.delete(n));
      }))), i.set(s, o);
    }
    return o.onDidMutate;
  }
}();
let Gk = null;
function y8() {
  return Gk || (Gk = Lo()), Gk;
}
function S8(n) {
  var e, t;
  return !((e = n?.sheet) === null || e === void 0) && e.rules ? n.sheet.rules : !((t = n?.sheet) === null || t === void 0) && t.cssRules ? n.sheet.cssRules : [];
}
function jw(n, e, t = y8()) {
  var i, s;
  if (t && e) {
    (i = t.sheet) === null || i === void 0 || i.insertRule(`${n} {${e}}`, 0);
    for (const o of (s = pR.get(t)) !== null && s !== void 0 ? s : []) jw(n, e, o);
  }
}
function IE(n, e = y8()) {
  var t, i;
  if (!e) return;
  const s = S8(e), o = [];
  for (let r = 0; r < s.length; r++) {
    const a = s[r];
    cj(a) && a.selectorText.indexOf(n) !== -1 && o.push(r);
  }
  for (let r = o.length - 1; r >= 0; r--) (t = e.sheet) === null || t === void 0 || t.deleteRule(o[r]);
  for (const r of (i = pR.get(e)) !== null && i !== void 0 ? i : []) IE(n, r);
}
function cj(n) {
  return typeof n.selectorText == "string";
}
function mR(n) {
  return n instanceof MouseEvent || n instanceof ke(n).MouseEvent;
}
function fh(n) {
  return n instanceof KeyboardEvent || n instanceof ke(n).KeyboardEvent;
}
const ie = { CLICK: "click", AUXCLICK: "auxclick", DBLCLICK: "dblclick", MOUSE_UP: "mouseup", MOUSE_DOWN: "mousedown", MOUSE_OVER: "mouseover", MOUSE_MOVE: "mousemove", MOUSE_OUT: "mouseout", MOUSE_ENTER: "mouseenter", MOUSE_LEAVE: "mouseleave", MOUSE_WHEEL: "wheel", POINTER_UP: "pointerup", POINTER_DOWN: "pointerdown", POINTER_MOVE: "pointermove", POINTER_LEAVE: "pointerleave", CONTEXT_MENU: "contextmenu", KEY_DOWN: "keydown", KEY_UP: "keyup", BEFORE_UNLOAD: "beforeunload", CHANGE: "change", FOCUS: "focus", FOCUS_IN: "focusin", FOCUS_OUT: "focusout", BLUR: "blur", INPUT: "input", DRAG_START: "dragstart", DRAG: "drag", DRAG_ENTER: "dragenter", DRAG_LEAVE: "dragleave", DRAG_OVER: "dragover", DROP: "drop", DRAG_END: "dragend" };
function uj(n) {
  const e = n;
  return !(!e || typeof e.preventDefault != "function" || typeof e.stopPropagation != "function");
}
const Ze = (n, e) => (n.preventDefault(), e && n.stopPropagation(), n);
class qw extends V {
  static hasFocusWithin(e) {
    if (e instanceof HTMLElement) {
      const t = ag(e);
      return gn(t ? t.activeElement : e.ownerDocument.activeElement, e);
    }
    {
      const t = e;
      return gn(t.document.activeElement, t.document);
    }
  }
  constructor(e) {
    super(), this._onDidFocus = this._register(new F()), this.onDidFocus = this._onDidFocus.event, this._onDidBlur = this._register(new F()), this.onDidBlur = this._onDidBlur.event;
    let t = qw.hasFocusWithin(e), i = !1;
    const s = () => {
      i = !1, t || (t = !0, this._onDidFocus.fire());
    }, o = () => {
      t && (i = !0, (e instanceof HTMLElement ? ke(e) : e).setTimeout((() => {
        i && (i = !1, t = !1, this._onDidBlur.fire());
      }), 0));
    };
    this._refreshStateHandler = () => {
      qw.hasFocusWithin(e) !== t && (t ? o() : s());
    }, this._register(K(e, ie.FOCUS, s, !0)), this._register(K(e, ie.BLUR, o, !0)), e instanceof HTMLElement && (this._register(K(e, ie.FOCUS_IN, (() => this._refreshStateHandler()))), this._register(K(e, ie.FOCUS_OUT, (() => this._refreshStateHandler()))));
  }
}
function pa(n) {
  return new qw(n);
}
function Z(n, ...e) {
  if (n.append(...e), e.length === 1 && typeof e[0] != "string") return e[0];
}
function fR(n, e) {
  return n.insertBefore(e, n.firstChild), e;
}
function wn(n, ...e) {
  n.innerText = "", Z(n, ...e);
}
const gj = /([\w\-]+)?(#([\w\-]+))?((\.([\w\-]+))*)/;
var $_;
function L8(n, e, t, ...i) {
  const s = gj.exec(e);
  if (!s) throw new Error("Bad use of emmet");
  const o = s[1] || "div";
  let r;
  return r = n !== $_.HTML ? document.createElementNS(n, o) : document.createElement(o), s[3] && (r.id = s[3]), s[4] && (r.className = s[4].replace(/\./g, " ").trim()), t && Object.entries(t).forEach((([a, l]) => {
    l !== void 0 && (/^on\w+$/.test(a) ? r[a] = l : a === "selected" ? l && r.setAttribute(a, "true") : r.setAttribute(a, l));
  })), r.append(...i), r;
}
function Q(n, e, ...t) {
  return L8($_.HTML, n, e, ...t);
}
function bo(...n) {
  for (const e of n) e.style.display = "", e.removeAttribute("aria-hidden");
}
function Ts(...n) {
  for (const e of n) e.style.display = "none", e.setAttribute("aria-hidden", "true");
}
function LO(n, e) {
  const t = n.devicePixelRatio * e;
  return Math.max(1, Math.floor(t)) / n.devicePixelRatio;
}
function k8(n) {
  It.open(n, "_blank", "noopener");
}
function wc(n) {
  return n ? `url('${p8.uriToBrowserUri(n).toString(!0).replace(/'/g, "%27")}')` : "url('')";
}
function kO(n) {
  return `'${n.replace(/'/g, "%27")}'`;
}
function kd(n, e) {
  if (n !== void 0) {
    const t = n.match(/^\s*var\((.+)\)$/);
    if (t) {
      const i = t[1].split(",", 2);
      return i.length === 2 && (e = kd(i[1].trim(), e)), `var(${i[0]}, ${e})`;
    }
    return n;
  }
  return e;
}
(function(n) {
  n.HTML = "http://www.w3.org/1999/xhtml", n.SVG = "http://www.w3.org/2000/svg";
})($_ || ($_ = {})), Q.SVG = function(n, e, ...t) {
  return L8($_.SVG, n, e, ...t);
}, g8.setPreferredWebSchema(/^https:/.test(It.location.href) ? "https" : "http");
const pj = Object.freeze(["a", "abbr", "b", "bdo", "blockquote", "br", "caption", "cite", "code", "col", "colgroup", "dd", "del", "details", "dfn", "div", "dl", "dt", "em", "figcaption", "figure", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "input", "ins", "kbd", "label", "li", "mark", "ol", "p", "pre", "q", "rp", "rt", "ruby", "samp", "small", "small", "source", "span", "strike", "strong", "sub", "summary", "sup", "table", "tbody", "td", "tfoot", "th", "thead", "time", "tr", "tt", "u", "ul", "var", "video", "wbr"]);
class ad extends F {
  constructor() {
    super(), this._subscriptions = new G(), this._keyStatus = { altKey: !1, shiftKey: !1, ctrlKey: !1, metaKey: !1 }, this._subscriptions.add(se.runAndSubscribe(WS, (({ window: e, disposables: t }) => this.registerListeners(e, t)), { window: It, disposables: this._subscriptions }));
  }
  registerListeners(e, t) {
    t.add(K(e, "keydown", ((i) => {
      if (i.defaultPrevented) return;
      const s = new jt(i);
      if (s.keyCode !== 6 || !i.repeat) {
        if (i.altKey && !this._keyStatus.altKey) this._keyStatus.lastKeyPressed = "alt";
        else if (i.ctrlKey && !this._keyStatus.ctrlKey) this._keyStatus.lastKeyPressed = "ctrl";
        else if (i.metaKey && !this._keyStatus.metaKey) this._keyStatus.lastKeyPressed = "meta";
        else if (i.shiftKey && !this._keyStatus.shiftKey) this._keyStatus.lastKeyPressed = "shift";
        else {
          if (s.keyCode === 6) return;
          this._keyStatus.lastKeyPressed = void 0;
        }
        this._keyStatus.altKey = i.altKey, this._keyStatus.ctrlKey = i.ctrlKey, this._keyStatus.metaKey = i.metaKey, this._keyStatus.shiftKey = i.shiftKey, this._keyStatus.lastKeyPressed && (this._keyStatus.event = i, this.fire(this._keyStatus));
      }
    }), !0)), t.add(K(e, "keyup", ((i) => {
      i.defaultPrevented || (!i.altKey && this._keyStatus.altKey ? this._keyStatus.lastKeyReleased = "alt" : !i.ctrlKey && this._keyStatus.ctrlKey ? this._keyStatus.lastKeyReleased = "ctrl" : !i.metaKey && this._keyStatus.metaKey ? this._keyStatus.lastKeyReleased = "meta" : !i.shiftKey && this._keyStatus.shiftKey ? this._keyStatus.lastKeyReleased = "shift" : this._keyStatus.lastKeyReleased = void 0, this._keyStatus.lastKeyPressed !== this._keyStatus.lastKeyReleased && (this._keyStatus.lastKeyPressed = void 0), this._keyStatus.altKey = i.altKey, this._keyStatus.ctrlKey = i.ctrlKey, this._keyStatus.metaKey = i.metaKey, this._keyStatus.shiftKey = i.shiftKey, this._keyStatus.lastKeyReleased && (this._keyStatus.event = i, this.fire(this._keyStatus)));
    }), !0)), t.add(K(e.document.body, "mousedown", (() => {
      this._keyStatus.lastKeyPressed = void 0;
    }), !0)), t.add(K(e.document.body, "mouseup", (() => {
      this._keyStatus.lastKeyPressed = void 0;
    }), !0)), t.add(K(e.document.body, "mousemove", ((i) => {
      i.buttons && (this._keyStatus.lastKeyPressed = void 0);
    }), !0)), t.add(K(e, "blur", (() => {
      this.resetKeyStatus();
    })));
  }
  get keyStatus() {
    return this._keyStatus;
  }
  resetKeyStatus() {
    this.doResetKeyStatus(), this.fire(this._keyStatus);
  }
  doResetKeyStatus() {
    this._keyStatus = { altKey: !1, shiftKey: !1, ctrlKey: !1, metaKey: !1 };
  }
  static getInstance() {
    return ad.instance || (ad.instance = new ad()), ad.instance;
  }
  dispose() {
    super.dispose(), this._subscriptions.dispose();
  }
}
class mj extends V {
  constructor(e, t) {
    super(), this.element = e, this.callbacks = t, this.counter = 0, this.dragStartTime = 0, this.registerListeners();
  }
  registerListeners() {
    this.callbacks.onDragStart && this._register(K(this.element, ie.DRAG_START, ((e) => {
      var t, i;
      (i = (t = this.callbacks).onDragStart) === null || i === void 0 || i.call(t, e);
    }))), this.callbacks.onDrag && this._register(K(this.element, ie.DRAG, ((e) => {
      var t, i;
      (i = (t = this.callbacks).onDrag) === null || i === void 0 || i.call(t, e);
    }))), this._register(K(this.element, ie.DRAG_ENTER, ((e) => {
      var t, i;
      this.counter++, this.dragStartTime = e.timeStamp, (i = (t = this.callbacks).onDragEnter) === null || i === void 0 || i.call(t, e);
    }))), this._register(K(this.element, ie.DRAG_OVER, ((e) => {
      var t, i;
      e.preventDefault(), (i = (t = this.callbacks).onDragOver) === null || i === void 0 || i.call(t, e, e.timeStamp - this.dragStartTime);
    }))), this._register(K(this.element, ie.DRAG_LEAVE, ((e) => {
      var t, i;
      this.counter--, this.counter === 0 && (this.dragStartTime = 0, (i = (t = this.callbacks).onDragLeave) === null || i === void 0 || i.call(t, e));
    }))), this._register(K(this.element, ie.DRAG_END, ((e) => {
      var t, i;
      this.counter = 0, this.dragStartTime = 0, (i = (t = this.callbacks).onDragEnd) === null || i === void 0 || i.call(t, e);
    }))), this._register(K(this.element, ie.DROP, ((e) => {
      var t, i;
      this.counter = 0, this.dragStartTime = 0, (i = (t = this.callbacks).onDrop) === null || i === void 0 || i.call(t, e);
    })));
  }
}
const fj = /(?<tag>[\w\-]+)?(?:#(?<id>[\w\-]+))?(?<class>(?:\.(?:[\w\-]+))*)(?:@(?<name>(?:[\w\_])+))?/;
function yt(n, ...e) {
  let t, i;
  Array.isArray(e[0]) ? (t = {}, i = e[0]) : (t = e[0] || {}, i = e[1]);
  const s = fj.exec(n);
  if (!s || !s.groups) throw new Error("Bad use of h");
  const o = s.groups.tag || "div", r = document.createElement(o);
  s.groups.id && (r.id = s.groups.id);
  const a = [];
  if (s.groups.class) for (const d of s.groups.class.split(".")) d !== "" && a.push(d);
  if (t.className !== void 0) for (const d of t.className.split(".")) d !== "" && a.push(d);
  a.length > 0 && (r.className = a.join(" "));
  const l = {};
  if (s.groups.name && (l[s.groups.name] = r), i) for (const d of i) d instanceof HTMLElement ? r.appendChild(d) : typeof d == "string" ? r.append(d) : "root" in d && (Object.assign(l, d), r.appendChild(d.root));
  for (const [d, h] of Object.entries(t)) if (d !== "className") if (d === "style") for (const [c, u] of Object.entries(h)) r.style.setProperty(DO(c), typeof u == "number" ? u + "px" : "" + u);
  else d === "tabIndex" ? r.tabIndex = h : r.setAttribute(DO(d), h.toString());
  return l.root = r, l;
}
function DO(n) {
  return n.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
class _j extends V {
  constructor(e) {
    super(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._listener = () => this._handleChange(e, !0), this._mediaQueryList = null, this._handleChange(e, !1);
  }
  _handleChange(e, t) {
    var i;
    (i = this._mediaQueryList) === null || i === void 0 || i.removeEventListener("change", this._listener), this._mediaQueryList = e.matchMedia(`(resolution: ${e.devicePixelRatio}dppx)`), this._mediaQueryList.addEventListener("change", this._listener), t && this._onDidChange.fire();
  }
}
class vj extends V {
  get value() {
    return this._value;
  }
  constructor(e) {
    super(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._value = this._getPixelRatio(e);
    const t = this._register(new _j(e));
    this._register(t.onDidChange((() => {
      this._value = this._getPixelRatio(e), this._onDidChange.fire(this._value);
    })));
  }
  _getPixelRatio(e) {
    const t = document.createElement("canvas").getContext("2d");
    return (e.devicePixelRatio || 1) / (t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1);
  }
}
const Q0 = new class {
  constructor() {
    this.mapWindowIdToPixelRatioMonitor = /* @__PURE__ */ new Map();
  }
  _getOrCreatePixelRatioMonitor(n) {
    const e = zw(n);
    let t = this.mapWindowIdToPixelRatioMonitor.get(e);
    return t || (t = new vj(n), this.mapWindowIdToPixelRatioMonitor.set(e, t), se.once(sj)((({ vscodeWindowId: i }) => {
      i === e && (t?.dispose(), this.mapWindowIdToPixelRatioMonitor.delete(e));
    }))), t;
  }
  getInstance(n) {
    return this._getOrCreatePixelRatioMonitor(n);
  }
}();
class D8 {
  constructor(e) {
    this.domNode = e, this._maxWidth = "", this._width = "", this._height = "", this._top = "", this._left = "", this._bottom = "", this._right = "", this._paddingLeft = "", this._fontFamily = "", this._fontWeight = "", this._fontSize = "", this._fontStyle = "", this._fontFeatureSettings = "", this._fontVariationSettings = "", this._textDecoration = "", this._lineHeight = "", this._letterSpacing = "", this._className = "", this._display = "", this._position = "", this._visibility = "", this._color = "", this._backgroundColor = "", this._layerHint = !1, this._contain = "none", this._boxShadow = "";
  }
  setMaxWidth(e) {
    const t = Rr(e);
    this._maxWidth !== t && (this._maxWidth = t, this.domNode.style.maxWidth = this._maxWidth);
  }
  setWidth(e) {
    const t = Rr(e);
    this._width !== t && (this._width = t, this.domNode.style.width = this._width);
  }
  setHeight(e) {
    const t = Rr(e);
    this._height !== t && (this._height = t, this.domNode.style.height = this._height);
  }
  setTop(e) {
    const t = Rr(e);
    this._top !== t && (this._top = t, this.domNode.style.top = this._top);
  }
  setLeft(e) {
    const t = Rr(e);
    this._left !== t && (this._left = t, this.domNode.style.left = this._left);
  }
  setBottom(e) {
    const t = Rr(e);
    this._bottom !== t && (this._bottom = t, this.domNode.style.bottom = this._bottom);
  }
  setRight(e) {
    const t = Rr(e);
    this._right !== t && (this._right = t, this.domNode.style.right = this._right);
  }
  setPaddingLeft(e) {
    const t = Rr(e);
    this._paddingLeft !== t && (this._paddingLeft = t, this.domNode.style.paddingLeft = this._paddingLeft);
  }
  setFontFamily(e) {
    this._fontFamily !== e && (this._fontFamily = e, this.domNode.style.fontFamily = this._fontFamily);
  }
  setFontWeight(e) {
    this._fontWeight !== e && (this._fontWeight = e, this.domNode.style.fontWeight = this._fontWeight);
  }
  setFontSize(e) {
    const t = Rr(e);
    this._fontSize !== t && (this._fontSize = t, this.domNode.style.fontSize = this._fontSize);
  }
  setFontStyle(e) {
    this._fontStyle !== e && (this._fontStyle = e, this.domNode.style.fontStyle = this._fontStyle);
  }
  setFontFeatureSettings(e) {
    this._fontFeatureSettings !== e && (this._fontFeatureSettings = e, this.domNode.style.fontFeatureSettings = this._fontFeatureSettings);
  }
  setFontVariationSettings(e) {
    this._fontVariationSettings !== e && (this._fontVariationSettings = e, this.domNode.style.fontVariationSettings = this._fontVariationSettings);
  }
  setTextDecoration(e) {
    this._textDecoration !== e && (this._textDecoration = e, this.domNode.style.textDecoration = this._textDecoration);
  }
  setLineHeight(e) {
    const t = Rr(e);
    this._lineHeight !== t && (this._lineHeight = t, this.domNode.style.lineHeight = this._lineHeight);
  }
  setLetterSpacing(e) {
    const t = Rr(e);
    this._letterSpacing !== t && (this._letterSpacing = t, this.domNode.style.letterSpacing = this._letterSpacing);
  }
  setClassName(e) {
    this._className !== e && (this._className = e, this.domNode.className = this._className);
  }
  toggleClassName(e, t) {
    this.domNode.classList.toggle(e, t), this._className = this.domNode.className;
  }
  setDisplay(e) {
    this._display !== e && (this._display = e, this.domNode.style.display = this._display);
  }
  setPosition(e) {
    this._position !== e && (this._position = e, this.domNode.style.position = this._position);
  }
  setVisibility(e) {
    this._visibility !== e && (this._visibility = e, this.domNode.style.visibility = this._visibility);
  }
  setColor(e) {
    this._color !== e && (this._color = e, this.domNode.style.color = this._color);
  }
  setBackgroundColor(e) {
    this._backgroundColor !== e && (this._backgroundColor = e, this.domNode.style.backgroundColor = this._backgroundColor);
  }
  setLayerHinting(e) {
    this._layerHint !== e && (this._layerHint = e, this.domNode.style.transform = this._layerHint ? "translate3d(0px, 0px, 0px)" : "");
  }
  setBoxShadow(e) {
    this._boxShadow !== e && (this._boxShadow = e, this.domNode.style.boxShadow = e);
  }
  setContain(e) {
    this._contain !== e && (this._contain = e, this.domNode.style.contain = this._contain);
  }
  setAttribute(e, t) {
    this.domNode.setAttribute(e, t);
  }
  removeAttribute(e) {
    this.domNode.removeAttribute(e);
  }
  appendChild(e) {
    this.domNode.appendChild(e.domNode);
  }
  removeChild(e) {
    this.domNode.removeChild(e.domNode);
  }
}
function Rr(n) {
  return typeof n == "number" ? `${n}px` : n;
}
function wt(n) {
  return new D8(n);
}
function yn(n, e) {
  n instanceof D8 ? (n.setFontFamily(e.getMassagedFontFamily()), n.setFontWeight(e.fontWeight), n.setFontSize(e.fontSize), n.setFontFeatureSettings(e.fontFeatureSettings), n.setFontVariationSettings(e.fontVariationSettings), n.setLineHeight(e.lineHeight), n.setLetterSpacing(e.letterSpacing)) : (n.style.fontFamily = e.getMassagedFontFamily(), n.style.fontWeight = e.fontWeight, n.style.fontSize = e.fontSize + "px", n.style.fontFeatureSettings = e.fontFeatureSettings, n.style.fontVariationSettings = e.fontVariationSettings, n.style.lineHeight = e.lineHeight + "px", n.style.letterSpacing = e.letterSpacing + "px");
}
class bj {
  constructor(e, t) {
    this.chr = e, this.type = t, this.width = 0;
  }
  fulfill(e) {
    this.width = e;
  }
}
class _R {
  constructor(e, t) {
    this._bareFontInfo = e, this._requests = t, this._container = null, this._testElements = null;
  }
  read(e) {
    this._createDomElements(), e.document.body.appendChild(this._container), this._readFromDomElements(), e.document.body.removeChild(this._container), this._container = null, this._testElements = null;
  }
  _createDomElements() {
    const e = document.createElement("div");
    e.style.position = "absolute", e.style.top = "-50000px", e.style.width = "50000px";
    const t = document.createElement("div");
    yn(t, this._bareFontInfo), e.appendChild(t);
    const i = document.createElement("div");
    yn(i, this._bareFontInfo), i.style.fontWeight = "bold", e.appendChild(i);
    const s = document.createElement("div");
    yn(s, this._bareFontInfo), s.style.fontStyle = "italic", e.appendChild(s);
    const o = [];
    for (const r of this._requests) {
      let a;
      r.type === 0 && (a = t), r.type === 2 && (a = i), r.type === 1 && (a = s), a.appendChild(document.createElement("br"));
      const l = document.createElement("span");
      _R._render(l, r), a.appendChild(l), o.push(l);
    }
    this._container = e, this._testElements = o;
  }
  static _render(e, t) {
    if (t.chr === " ") {
      let i = " ";
      for (let s = 0; s < 8; s++) i += i;
      e.innerText = i;
    } else {
      let i = t.chr;
      for (let s = 0; s < 8; s++) i += i;
      e.textContent = i;
    }
  }
  _readFromDomElements() {
    for (let e = 0, t = this._requests.length; e < t; e++) {
      const i = this._requests[e], s = this._testElements[e];
      i.fulfill(s.offsetWidth / 256);
    }
  }
}
const Vo = new class {
  constructor() {
    this._zoomLevel = 0, this._onDidChangeZoomLevel = new F(), this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event;
  }
  getZoomLevel() {
    return this._zoomLevel;
  }
  setZoomLevel(n) {
    n = Math.min(Math.max(-5, n), 20), this._zoomLevel !== n && (this._zoomLevel = n, this._onDidChangeZoomLevel.fire(this._zoomLevel));
  }
}(), Cj = Je ? 1.5 : 1.35;
class zu {
  static createFromValidatedSettings(e, t, i) {
    const s = e.get(49), o = e.get(53), r = e.get(52), a = e.get(51), l = e.get(54), d = e.get(67), h = e.get(64);
    return zu._create(s, o, r, a, l, d, h, t, i);
  }
  static _create(e, t, i, s, o, r, a, l, d) {
    r === 0 ? r = Cj * i : r < 8 && (r *= i), (r = Math.round(r)) < 8 && (r = 8);
    const h = 1 + (d ? 0 : 0.1 * Vo.getZoomLevel());
    return i *= h, r *= h, o === Xr.TRANSLATE && (t === "normal" || t === "bold" ? o = Xr.OFF : (o = `'wght' ${parseInt(t, 10)}`, t = "normal")), new zu({ pixelRatio: l, fontFamily: e, fontWeight: t, fontSize: i, fontFeatureSettings: s, fontVariationSettings: o, lineHeight: r, letterSpacing: a });
  }
  constructor(e) {
    this._bareFontInfoBrand = void 0, this.pixelRatio = e.pixelRatio, this.fontFamily = String(e.fontFamily), this.fontWeight = String(e.fontWeight), this.fontSize = e.fontSize, this.fontFeatureSettings = e.fontFeatureSettings, this.fontVariationSettings = e.fontVariationSettings, this.lineHeight = 0 | e.lineHeight, this.letterSpacing = e.letterSpacing;
  }
  getId() {
    return `${this.pixelRatio}-${this.fontFamily}-${this.fontWeight}-${this.fontSize}-${this.fontFeatureSettings}-${this.fontVariationSettings}-${this.lineHeight}-${this.letterSpacing}`;
  }
  getMassagedFontFamily() {
    const e = Is.fontFamily, t = zu._wrapInQuotes(this.fontFamily);
    return this.fontFamily !== e ? `${t}, ${e}` : t;
  }
  static _wrapInQuotes(e) {
    return /[,"']/.test(e) ? e : /[+ ]/.test(e) ? `"${e}"` : e;
  }
}
class ME extends zu {
  constructor(e, t) {
    super(e), this._editorStylingBrand = void 0, this.version = 2, this.isTrusted = t, this.isMonospace = e.isMonospace, this.typicalHalfwidthCharacterWidth = e.typicalHalfwidthCharacterWidth, this.typicalFullwidthCharacterWidth = e.typicalFullwidthCharacterWidth, this.canUseHalfwidthRightwardsArrow = e.canUseHalfwidthRightwardsArrow, this.spaceWidth = e.spaceWidth, this.middotWidth = e.middotWidth, this.wsmiddotWidth = e.wsmiddotWidth, this.maxDigitWidth = e.maxDigitWidth;
  }
  equals(e) {
    return this.fontFamily === e.fontFamily && this.fontWeight === e.fontWeight && this.fontSize === e.fontSize && this.fontFeatureSettings === e.fontFeatureSettings && this.fontVariationSettings === e.fontVariationSettings && this.lineHeight === e.lineHeight && this.letterSpacing === e.letterSpacing && this.typicalHalfwidthCharacterWidth === e.typicalHalfwidthCharacterWidth && this.typicalFullwidthCharacterWidth === e.typicalFullwidthCharacterWidth && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.maxDigitWidth === e.maxDigitWidth;
  }
}
class wj {
  constructor() {
    this._keys = /* @__PURE__ */ Object.create(null), this._values = /* @__PURE__ */ Object.create(null);
  }
  has(e) {
    const t = e.getId();
    return !!this._values[t];
  }
  get(e) {
    const t = e.getId();
    return this._values[t];
  }
  put(e, t) {
    const i = e.getId();
    this._keys[i] = e, this._values[i] = t;
  }
  remove(e) {
    const t = e.getId();
    delete this._keys[t], delete this._values[t];
  }
  getValues() {
    return Object.keys(this._keys).map(((e) => this._values[e]));
  }
}
const TE = new class extends V {
  constructor() {
    super(...arguments), this._cache = /* @__PURE__ */ new Map(), this._evictUntrustedReadingsTimeout = -1, this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event;
  }
  dispose() {
    this._evictUntrustedReadingsTimeout !== -1 && (clearTimeout(this._evictUntrustedReadingsTimeout), this._evictUntrustedReadingsTimeout = -1), super.dispose();
  }
  clearAllFontInfos() {
    this._cache.clear(), this._onDidChange.fire();
  }
  _ensureCache(n) {
    const e = zw(n);
    let t = this._cache.get(e);
    return t || (t = new wj(), this._cache.set(e, t)), t;
  }
  _writeToCache(n, e, t) {
    this._ensureCache(n).put(e, t), t.isTrusted || this._evictUntrustedReadingsTimeout !== -1 || (this._evictUntrustedReadingsTimeout = n.setTimeout((() => {
      this._evictUntrustedReadingsTimeout = -1, this._evictUntrustedReadings(n);
    }), 5e3));
  }
  _evictUntrustedReadings(n) {
    const e = this._ensureCache(n), t = e.getValues();
    let i = !1;
    for (const s of t) s.isTrusted || (i = !0, e.remove(s));
    i && this._onDidChange.fire();
  }
  readFontInfo(n, e) {
    const t = this._ensureCache(n);
    if (!t.has(e)) {
      let i = this._actualReadFontInfo(n, e);
      (i.typicalHalfwidthCharacterWidth <= 2 || i.typicalFullwidthCharacterWidth <= 2 || i.spaceWidth <= 2 || i.maxDigitWidth <= 2) && (i = new ME({ pixelRatio: Q0.getInstance(n).value, fontFamily: i.fontFamily, fontWeight: i.fontWeight, fontSize: i.fontSize, fontFeatureSettings: i.fontFeatureSettings, fontVariationSettings: i.fontVariationSettings, lineHeight: i.lineHeight, letterSpacing: i.letterSpacing, isMonospace: i.isMonospace, typicalHalfwidthCharacterWidth: Math.max(i.typicalHalfwidthCharacterWidth, 5), typicalFullwidthCharacterWidth: Math.max(i.typicalFullwidthCharacterWidth, 5), canUseHalfwidthRightwardsArrow: i.canUseHalfwidthRightwardsArrow, spaceWidth: Math.max(i.spaceWidth, 5), middotWidth: Math.max(i.middotWidth, 5), wsmiddotWidth: Math.max(i.wsmiddotWidth, 5), maxDigitWidth: Math.max(i.maxDigitWidth, 5) }, !1)), this._writeToCache(n, e, i);
    }
    return t.get(e);
  }
  _createRequest(n, e, t, i) {
    const s = new bj(n, e);
    return t.push(s), i?.push(s), s;
  }
  _actualReadFontInfo(n, e) {
    const t = [], i = [], s = this._createRequest("n", 0, t, i), o = this._createRequest("ｍ", 0, t, null), r = this._createRequest(" ", 0, t, i), a = this._createRequest("0", 0, t, i), l = this._createRequest("1", 0, t, i), d = this._createRequest("2", 0, t, i), h = this._createRequest("3", 0, t, i), c = this._createRequest("4", 0, t, i), u = this._createRequest("5", 0, t, i), g = this._createRequest("6", 0, t, i), p = this._createRequest("7", 0, t, i), f = this._createRequest("8", 0, t, i), _ = this._createRequest("9", 0, t, i), v = this._createRequest("→", 0, t, i), b = this._createRequest("￫", 0, t, null), C = this._createRequest("·", 0, t, i), w = this._createRequest("⸱", 0, t, null), y = "|/-_ilm%";
    for (let B = 0, T = 8; B < T; B++) this._createRequest(y.charAt(B), 0, t, i), this._createRequest(y.charAt(B), 1, t, i), this._createRequest(y.charAt(B), 2, t, i);
    (function(B, T, O) {
      new _R(T, O).read(B);
    })(n, e, t);
    const L = Math.max(a.width, l.width, d.width, h.width, c.width, u.width, g.width, p.width, f.width, _.width);
    let k = e.fontFeatureSettings === fo.OFF;
    const N = i[0].width;
    for (let B = 1, T = i.length; k && B < T; B++) {
      const O = N - i[B].width;
      if (O < -1e-3 || O > 1e-3) {
        k = !1;
        break;
      }
    }
    let A = !0;
    return k && b.width !== N && (A = !1), b.width > v.width && (A = !1), new ME({ pixelRatio: Q0.getInstance(n).value, fontFamily: e.fontFamily, fontWeight: e.fontWeight, fontSize: e.fontSize, fontFeatureSettings: e.fontFeatureSettings, fontVariationSettings: e.fontVariationSettings, lineHeight: e.lineHeight, letterSpacing: e.letterSpacing, isMonospace: k, typicalHalfwidthCharacterWidth: s.width, typicalFullwidthCharacterWidth: o.width, canUseHalfwidthRightwardsArrow: A, spaceWidth: r.width, middotWidth: C.width, wsmiddotWidth: w.width, maxDigitWidth: L }, !0);
  }
}();
var zr;
(function(n) {
  n.serviceIds = /* @__PURE__ */ new Map(), n.DI_TARGET = "$di$target", n.DI_DEPENDENCIES = "$di$dependencies", n.getServiceDependencies = function(e) {
    return e[n.DI_DEPENDENCIES] || [];
  };
})(zr || (zr = {}));
const Se = tt("instantiationService");
function tt(n) {
  if (zr.serviceIds.has(n)) return zr.serviceIds.get(n);
  const e = function(t, i, s) {
    if (arguments.length !== 3) throw new Error("@IServiceName-decorator can only be used to decorate a parameter");
    (function(o, r, a) {
      r[zr.DI_TARGET] === r ? r[zr.DI_DEPENDENCIES].push({ id: o, index: a }) : (r[zr.DI_DEPENDENCIES] = [{ id: o, index: a }], r[zr.DI_TARGET] = r);
    })(e, t, s);
  };
  return e.toString = () => n, zr.serviceIds.set(n, e), e;
}
const mt = tt("codeEditorService"), ni = tt("modelService"), Ps = tt("textModelService");
class Qs extends V {
  constructor(e, t = "", i = "", s = !0, o) {
    super(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._enabled = !0, this._id = e, this._label = t, this._cssClass = i, this._enabled = s, this._actionCallback = o;
  }
  get id() {
    return this._id;
  }
  get label() {
    return this._label;
  }
  set label(e) {
    this._setLabel(e);
  }
  _setLabel(e) {
    this._label !== e && (this._label = e, this._onDidChange.fire({ label: e }));
  }
  get tooltip() {
    return this._tooltip || "";
  }
  set tooltip(e) {
    this._setTooltip(e);
  }
  _setTooltip(e) {
    this._tooltip !== e && (this._tooltip = e, this._onDidChange.fire({ tooltip: e }));
  }
  get class() {
    return this._cssClass;
  }
  set class(e) {
    this._setClass(e);
  }
  _setClass(e) {
    this._cssClass !== e && (this._cssClass = e, this._onDidChange.fire({ class: e }));
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(e) {
    this._setEnabled(e);
  }
  _setEnabled(e) {
    this._enabled !== e && (this._enabled = e, this._onDidChange.fire({ enabled: e }));
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    this._setChecked(e);
  }
  _setChecked(e) {
    this._checked !== e && (this._checked = e, this._onDidChange.fire({ checked: e }));
  }
  async run(e, t) {
    this._actionCallback && await this._actionCallback(e);
  }
}
class lg extends V {
  constructor() {
    super(...arguments), this._onWillRun = this._register(new F()), this.onWillRun = this._onWillRun.event, this._onDidRun = this._register(new F()), this.onDidRun = this._onDidRun.event;
  }
  async run(e, t) {
    if (!e.enabled) return;
    let i;
    this._onWillRun.fire({ action: e });
    try {
      await this.runAction(e, t);
    } catch (s) {
      i = s;
    }
    this._onDidRun.fire({ action: e, error: i });
  }
  async runAction(e, t) {
    await e.run(t);
  }
}
class Ui {
  constructor() {
    this.id = Ui.ID, this.label = "", this.tooltip = "", this.class = "separator", this.enabled = !1, this.checked = !1;
  }
  static join(...e) {
    let t = [];
    for (const i of e) i.length && (t = t.length ? [...t, new Ui(), ...i] : i);
    return t;
  }
  async run() {
  }
}
Ui.ID = "vs.actions.separator";
class Om {
  get actions() {
    return this._actions;
  }
  constructor(e, t, i, s) {
    this.tooltip = "", this.enabled = !0, this.checked = void 0, this.id = e, this.label = t, this.class = s, this._actions = i;
  }
  async run() {
  }
}
class zS extends Qs {
  constructor() {
    super(zS.ID, m(0, "(empty)"), void 0, !1);
  }
}
function Yp(n) {
  var e;
  return { id: n.id, label: n.label, class: n.class, enabled: (e = n.enabled) === null || e === void 0 || e, checked: n.checked, run: async (...t) => n.run(...t), tooltip: n.label };
}
var Zk, Ee;
zS.ID = "vs.actions.empty", (function(n) {
  n.isThemeColor = function(e) {
    return e && typeof e == "object" && typeof e.id == "string";
  };
})(Zk || (Zk = {})), (function(n) {
  n.iconNameSegment = "[A-Za-z0-9]+", n.iconNameExpression = "[A-Za-z0-9-]+", n.iconModifierExpression = "~[A-Za-z]+", n.iconNameCharacter = "[A-Za-z0-9~-]";
  const e = new RegExp(`^(${n.iconNameExpression})(${n.iconModifierExpression})?$`);
  function t(s) {
    const o = e.exec(s.id);
    if (!o) return t(ne.error);
    const [, r, a] = o, l = ["codicon", "codicon-" + r];
    return a && l.push("codicon-modifier-" + a.substring(1)), l;
  }
  n.asClassNameArray = t, n.asClassName = function(s) {
    return t(s).join(" ");
  }, n.asCSSSelector = function(s) {
    return "." + t(s).join(".");
  }, n.isThemeIcon = function(s) {
    return s && typeof s == "object" && typeof s.id == "string" && (s.color === void 0 || Zk.isThemeColor(s.color));
  };
  const i = new RegExp(`^\\$\\((${n.iconNameExpression}(?:${n.iconModifierExpression})?)\\)$`);
  n.fromString = function(s) {
    const o = i.exec(s);
    if (!o) return;
    const [, r] = o;
    return { id: r };
  }, n.fromId = function(s) {
    return { id: s };
  }, n.modify = function(s, o) {
    let r = s.id;
    const a = r.lastIndexOf("~");
    return a !== -1 && (r = r.substring(0, a)), o && (r = `${r}~${o}`), { id: r };
  }, n.getModifier = function(s) {
    const o = s.id.lastIndexOf("~");
    if (o !== -1) return s.id.substring(o + 1);
  }, n.isEqual = function(s, o) {
    var r, a;
    return s.id === o.id && ((r = s.color) === null || r === void 0 ? void 0 : r.id) === ((a = o.color) === null || a === void 0 ? void 0 : a.id);
  };
})(Ee || (Ee = {}));
const ai = tt("commandService"), dt = new class {
  constructor() {
    this._commands = /* @__PURE__ */ new Map(), this._onDidRegisterCommand = new F(), this.onDidRegisterCommand = this._onDidRegisterCommand.event;
  }
  registerCommand(n, e) {
    if (!n) throw new Error("invalid command");
    if (typeof n == "string") {
      if (!e) throw new Error("invalid command");
      return this.registerCommand({ id: n, handler: e });
    }
    if (n.metadata && Array.isArray(n.metadata.args)) {
      const r = [];
      for (const l of n.metadata.args) r.push(l.constraint);
      const a = n.handler;
      n.handler = function(l, ...d) {
        return (function(h, c) {
          const u = Math.min(h.length, c.length);
          for (let g = 0; g < u; g++) zU(h[g], c[g]);
        })(d, r), a(l, ...d);
      };
    }
    const { id: t } = n;
    let i = this._commands.get(t);
    i || (i = new fs(), this._commands.set(t, i));
    const s = i.unshift(n), o = ye((() => {
      s();
      const r = this._commands.get(t);
      r?.isEmpty() && this._commands.delete(t);
    }));
    return this._onDidRegisterCommand.fire(t), o;
  }
  registerCommandAlias(n, e) {
    return dt.registerCommand(n, ((t, ...i) => t.get(ai).executeCommand(e, ...i)));
  }
  getCommand(n) {
    const e = this._commands.get(n);
    if (e && !e.isEmpty()) return at.first(e);
  }
  getCommands() {
    const n = /* @__PURE__ */ new Map();
    for (const e of this._commands.keys()) {
      const t = this.getCommand(e);
      t && n.set(e, t);
    }
    return n;
  }
}();
function Yk(...n) {
  switch (n.length) {
    case 1:
      return m(0, "Did you mean {0}?", n[0]);
    case 2:
      return m(0, "Did you mean {0} or {1}?", n[0], n[1]);
    case 3:
      return m(0, "Did you mean {0}, {1} or {2}?", n[0], n[1], n[2]);
    default:
      return;
  }
}
dt.registerCommand("noop", (() => {
}));
const yj = m(0, "Did you forget to open or close the quote?"), Sj = m(0, "Did you forget to escape the '/' (slash) character? Put two backslashes before it to escape, e.g., '\\\\/'.");
let gu = class RE {
  constructor() {
    this._input = "", this._start = 0, this._current = 0, this._tokens = [], this._errors = [], this.stringRe = /[a-zA-Z0-9_<>\-\./\\:\*\?\+\[\]\^,#@;"%\$\p{L}-]+/uy;
  }
  static getLexeme(e) {
    switch (e.type) {
      case 0:
        return "(";
      case 1:
        return ")";
      case 2:
        return "!";
      case 3:
        return e.isTripleEq ? "===" : "==";
      case 4:
        return e.isTripleEq ? "!==" : "!=";
      case 5:
        return "<";
      case 6:
        return "<=";
      case 7:
      case 8:
        return ">=";
      case 9:
        return "=~";
      case 10:
      case 17:
      case 18:
      case 19:
        return e.lexeme;
      case 11:
        return "true";
      case 12:
        return "false";
      case 13:
        return "in";
      case 14:
        return "not";
      case 15:
        return "&&";
      case 16:
        return "||";
      case 20:
        return "EOF";
      default:
        throw ZT(`unhandled token type: ${JSON.stringify(e)}; have you forgotten to add a case?`);
    }
  }
  reset(e) {
    return this._input = e, this._start = 0, this._current = 0, this._tokens = [], this._errors = [], this;
  }
  scan() {
    for (; !this._isAtEnd(); )
      switch (this._start = this._current, this._advance()) {
        case 40:
          this._addToken(0);
          break;
        case 41:
          this._addToken(1);
          break;
        case 33:
          if (this._match(61)) {
            const e = this._match(61);
            this._tokens.push({ type: 4, offset: this._start, isTripleEq: e });
          } else this._addToken(2);
          break;
        case 39:
          this._quotedString();
          break;
        case 47:
          this._regex();
          break;
        case 61:
          if (this._match(61)) {
            const e = this._match(61);
            this._tokens.push({ type: 3, offset: this._start, isTripleEq: e });
          } else this._match(126) ? this._addToken(9) : this._error(Yk("==", "=~"));
          break;
        case 60:
          this._addToken(this._match(61) ? 6 : 5);
          break;
        case 62:
          this._addToken(this._match(61) ? 8 : 7);
          break;
        case 38:
          this._match(38) ? this._addToken(15) : this._error(Yk("&&"));
          break;
        case 124:
          this._match(124) ? this._addToken(16) : this._error(Yk("||"));
          break;
        case 32:
        case 13:
        case 9:
        case 10:
        case 160:
          break;
        default:
          this._string();
      }
    return this._start = this._current, this._addToken(20), Array.from(this._tokens);
  }
  _match(e) {
    return !this._isAtEnd() && this._input.charCodeAt(this._current) === e && (this._current++, !0);
  }
  _advance() {
    return this._input.charCodeAt(this._current++);
  }
  _peek() {
    return this._isAtEnd() ? 0 : this._input.charCodeAt(this._current);
  }
  _addToken(e) {
    this._tokens.push({ type: e, offset: this._start });
  }
  _error(e) {
    const t = this._start, i = this._input.substring(this._start, this._current), s = { type: 19, offset: this._start, lexeme: i };
    this._errors.push({ offset: t, lexeme: i, additionalInfo: e }), this._tokens.push(s);
  }
  _string() {
    this.stringRe.lastIndex = this._start;
    const e = this.stringRe.exec(this._input);
    if (e) {
      this._current = this._start + e[0].length;
      const t = this._input.substring(this._start, this._current), i = RE._keywords.get(t);
      i ? this._addToken(i) : this._tokens.push({ type: 17, lexeme: t, offset: this._start });
    }
  }
  _quotedString() {
    for (; this._peek() !== 39 && !this._isAtEnd(); ) this._advance();
    this._isAtEnd() ? this._error(yj) : (this._advance(), this._tokens.push({ type: 18, lexeme: this._input.substring(this._start + 1, this._current - 1), offset: this._start + 1 }));
  }
  _regex() {
    let e = this._current, t = !1, i = !1;
    for (; ; ) {
      if (e >= this._input.length) return this._current = e, void this._error(Sj);
      const o = this._input.charCodeAt(e);
      if (t) t = !1;
      else {
        if (o === 47 && !i) {
          e++;
          break;
        }
        o === 91 ? i = !0 : o === 92 ? t = !0 : o === 93 && (i = !1);
      }
      e++;
    }
    for (; e < this._input.length && RE._regexFlags.has(this._input.charCodeAt(e)); ) e++;
    this._current = e;
    const s = this._input.substring(this._start, this._current);
    this._tokens.push({ type: 10, lexeme: s, offset: this._start });
  }
  _isAtEnd() {
    return this._current >= this._input.length;
  }
};
gu._regexFlags = new Set(["i", "g", "s", "m", "y", "u"].map(((n) => n.charCodeAt(0)))), gu._keywords = /* @__PURE__ */ new Map([["not", 14], ["in", 13], ["false", 12], ["true", 11]]);
const On = /* @__PURE__ */ new Map();
On.set("false", !1), On.set("true", !0), On.set("isMac", Je), On.set("isLinux", Cs), On.set("isWindows", Tn), On.set("isWeb", gc), On.set("isMacNative", Je && !gc), On.set("isEdge", XU), On.set("isFirefox", ZU), On.set("isChrome", k7), On.set("isSafari", YU);
const Lj = Object.prototype.hasOwnProperty, kj = { regexParsingWithErrorRecovery: !0 }, Dj = m(0, "Empty context key expression"), xj = m(0, "Did you forget to write an expression? You can also put 'false' or 'true' to always evaluate to false or true, respectively."), Nj = m(0, "'in' after 'not'."), xO = m(0, "closing parenthesis ')'"), Ej = m(0, "Unexpected token"), Ij = m(0, "Did you forget to put && or || before the token?"), Mj = m(0, "Unexpected end of expression"), Tj = m(0, "Did you forget to put a context key?");
let x8 = class u_ {
  constructor(e = kj) {
    this._config = e, this._scanner = new gu(), this._tokens = [], this._current = 0, this._parsingErrors = [], this._flagsGYRe = /g|y/g;
  }
  parse(e) {
    if (e !== "") {
      this._tokens = this._scanner.reset(e).scan(), this._current = 0, this._parsingErrors = [];
      try {
        const t = this._expr();
        if (!this._isAtEnd()) {
          const i = this._peek(), s = i.type === 17 ? Ij : void 0;
          throw this._parsingErrors.push({ message: Ej, offset: i.offset, lexeme: gu.getLexeme(i), additionalInfo: s }), u_._parseError;
        }
        return t;
      } catch (t) {
        if (t !== u_._parseError) throw t;
        return;
      }
    } else this._parsingErrors.push({ message: Dj, offset: 0, lexeme: "", additionalInfo: xj });
  }
  _expr() {
    return this._or();
  }
  _or() {
    const e = [this._and()];
    for (; this._matchOne(16); ) {
      const t = this._and();
      e.push(t);
    }
    return e.length === 1 ? e[0] : q.or(...e);
  }
  _and() {
    const e = [this._term()];
    for (; this._matchOne(15); ) {
      const t = this._term();
      e.push(t);
    }
    return e.length === 1 ? e[0] : q.and(...e);
  }
  _term() {
    if (this._matchOne(2)) {
      const e = this._peek();
      switch (e.type) {
        case 11:
          return this._advance(), ws.INSTANCE;
        case 12:
          return this._advance(), Os.INSTANCE;
        case 0: {
          this._advance();
          const t = this._expr();
          return this._consume(1, xO), t?.negate();
        }
        case 17:
          return this._advance(), Dg.create(e.lexeme);
        default:
          throw this._errExpectedButGot("KEY | true | false | '(' expression ')'", e);
      }
    }
    return this._primary();
  }
  _primary() {
    const e = this._peek();
    switch (e.type) {
      case 11:
        return this._advance(), q.true();
      case 12:
        return this._advance(), q.false();
      case 0: {
        this._advance();
        const t = this._expr();
        return this._consume(1, xO), t;
      }
      case 17: {
        const t = e.lexeme;
        if (this._advance(), this._matchOne(9)) {
          const i = this._peek();
          if (!this._config.regexParsingWithErrorRecovery) {
            if (this._advance(), i.type !== 10) throw this._errExpectedButGot("REGEX", i);
            const s = i.lexeme, o = s.lastIndexOf("/"), r = o === s.length - 1 ? void 0 : this._removeFlagsGY(s.substring(o + 1));
            let a;
            try {
              a = new RegExp(s.substring(1, o), r);
            } catch {
              throw this._errExpectedButGot("REGEX", i);
            }
            return J0.create(t, a);
          }
          switch (i.type) {
            case 10:
            case 19: {
              const s = [i.lexeme];
              this._advance();
              let o = this._peek(), r = 0;
              for (let c = 0; c < i.lexeme.length; c++) i.lexeme.charCodeAt(c) === 40 ? r++ : i.lexeme.charCodeAt(c) === 41 && r--;
              for (; !this._isAtEnd() && o.type !== 15 && o.type !== 16; ) {
                switch (o.type) {
                  case 0:
                    r++;
                    break;
                  case 1:
                    r--;
                    break;
                  case 10:
                  case 18:
                    for (let c = 0; c < o.lexeme.length; c++) o.lexeme.charCodeAt(c) === 40 ? r++ : i.lexeme.charCodeAt(c) === 41 && r--;
                }
                if (r < 0) break;
                s.push(gu.getLexeme(o)), this._advance(), o = this._peek();
              }
              const a = s.join(""), l = a.lastIndexOf("/"), d = l === a.length - 1 ? void 0 : this._removeFlagsGY(a.substring(l + 1));
              let h;
              try {
                h = new RegExp(a.substring(1, l), d);
              } catch {
                throw this._errExpectedButGot("REGEX", i);
              }
              return q.regex(t, h);
            }
            case 18: {
              const s = i.lexeme;
              this._advance();
              let o = null;
              if (!Y7(s)) {
                const r = s.indexOf("/"), a = s.lastIndexOf("/");
                if (r !== a && r >= 0) {
                  const l = s.slice(r + 1, a), d = s[a + 1] === "i" ? "i" : "";
                  try {
                    o = new RegExp(l, d);
                  } catch {
                    throw this._errExpectedButGot("REGEX", i);
                  }
                }
              }
              if (o === null) throw this._errExpectedButGot("REGEX", i);
              return J0.create(t, o);
            }
            default:
              throw this._errExpectedButGot("REGEX", this._peek());
          }
        }
        if (this._matchOne(14)) {
          this._consume(13, Nj);
          const i = this._value();
          return q.notIn(t, i);
        }
        switch (this._peek().type) {
          case 3: {
            this._advance();
            const i = this._value();
            if (this._previous().type === 18) return q.equals(t, i);
            switch (i) {
              case "true":
                return q.has(t);
              case "false":
                return q.not(t);
              default:
                return q.equals(t, i);
            }
          }
          case 4: {
            this._advance();
            const i = this._value();
            if (this._previous().type === 18) return q.notEquals(t, i);
            switch (i) {
              case "true":
                return q.not(t);
              case "false":
                return q.has(t);
              default:
                return q.notEquals(t, i);
            }
          }
          case 5:
            return this._advance(), ZS.create(t, this._value());
          case 6:
            return this._advance(), YS.create(t, this._value());
          case 7:
            return this._advance(), $S.create(t, this._value());
          case 8:
            return this._advance(), GS.create(t, this._value());
          case 13:
            return this._advance(), q.in(t, this._value());
          default:
            return q.has(t);
        }
      }
      case 20:
        throw this._parsingErrors.push({ message: Mj, offset: e.offset, lexeme: "", additionalInfo: Tj }), u_._parseError;
      default:
        throw this._errExpectedButGot(`true | false | KEY 
	| KEY '=~' REGEX 
	| KEY ('==' | '!=' | '<' | '<=' | '>' | '>=' | 'in' | 'not' 'in') value`, this._peek());
    }
  }
  _value() {
    const e = this._peek();
    switch (e.type) {
      case 17:
      case 18:
        return this._advance(), e.lexeme;
      case 11:
        return this._advance(), "true";
      case 12:
        return this._advance(), "false";
      case 13:
        return this._advance(), "in";
      default:
        return "";
    }
  }
  _removeFlagsGY(e) {
    return e.replaceAll(this._flagsGYRe, "");
  }
  _previous() {
    return this._tokens[this._current - 1];
  }
  _matchOne(e) {
    return !!this._check(e) && (this._advance(), !0);
  }
  _advance() {
    return this._isAtEnd() || this._current++, this._previous();
  }
  _consume(e, t) {
    if (this._check(e)) return this._advance();
    throw this._errExpectedButGot(t, this._peek());
  }
  _errExpectedButGot(e, t, i) {
    const s = m(0, `Expected: {0}
Received: '{1}'.`, e, gu.getLexeme(t)), o = t.offset, r = gu.getLexeme(t);
    return this._parsingErrors.push({ message: s, offset: o, lexeme: r, additionalInfo: i }), u_._parseError;
  }
  _check(e) {
    return this._peek().type === e;
  }
  _peek() {
    return this._tokens[this._current];
  }
  _isAtEnd() {
    return this._peek().type === 20;
  }
};
x8._parseError = new Error();
class q {
  static false() {
    return ws.INSTANCE;
  }
  static true() {
    return Os.INSTANCE;
  }
  static has(e) {
    return kg.create(e);
  }
  static equals(e, t) {
    return uf.create(e, t);
  }
  static notEquals(e, t) {
    return jS.create(e, t);
  }
  static regex(e, t) {
    return J0.create(e, t);
  }
  static in(e, t) {
    return US.create(e, t);
  }
  static notIn(e, t) {
    return KS.create(e, t);
  }
  static not(e) {
    return Dg.create(e);
  }
  static and(...e) {
    return Nu.create(e, null, !0);
  }
  static or(...e) {
    return Xl.create(e, null, !0);
  }
  static deserialize(e) {
    if (e != null)
      return this._parser.parse(e);
  }
}
function G_(n, e) {
  return n.cmp(e);
}
q._parser = new x8({ regexParsingWithErrorRecovery: !1 });
class ws {
  constructor() {
    this.type = 0;
  }
  cmp(e) {
    return this.type - e.type;
  }
  equals(e) {
    return e.type === this.type;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !1;
  }
  serialize() {
    return "false";
  }
  keys() {
    return [];
  }
  negate() {
    return Os.INSTANCE;
  }
}
ws.INSTANCE = new ws();
class Os {
  constructor() {
    this.type = 1;
  }
  cmp(e) {
    return this.type - e.type;
  }
  equals(e) {
    return e.type === this.type;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !0;
  }
  serialize() {
    return "true";
  }
  keys() {
    return [];
  }
  negate() {
    return ws.INSTANCE;
  }
}
Os.INSTANCE = new Os();
class kg {
  static create(e, t = null) {
    const i = On.get(e);
    return typeof i == "boolean" ? i ? Os.INSTANCE : ws.INSTANCE : new kg(e, t);
  }
  constructor(e, t) {
    this.key = e, this.negated = t, this.type = 2;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : E8(this.key, e.key);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key;
  }
  substituteConstants() {
    const e = On.get(this.key);
    return typeof e == "boolean" ? e ? Os.INSTANCE : ws.INSTANCE : this;
  }
  evaluate(e) {
    return !!e.getValue(this.key);
  }
  serialize() {
    return this.key;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = Dg.create(this.key, this)), this.negated;
  }
}
class uf {
  static create(e, t, i = null) {
    if (typeof t == "boolean") return t ? kg.create(e, i) : Dg.create(e, i);
    const s = On.get(e);
    return typeof s == "boolean" ? t === (s ? "true" : "false") ? Os.INSTANCE : ws.INSTANCE : new uf(e, t, i);
  }
  constructor(e, t, i) {
    this.key = e, this.value = t, this.negated = i, this.type = 4;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : xg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    const e = On.get(this.key);
    if (typeof e == "boolean") {
      const t = e ? "true" : "false";
      return this.value === t ? Os.INSTANCE : ws.INSTANCE;
    }
    return this;
  }
  evaluate(e) {
    return e.getValue(this.key) == this.value;
  }
  serialize() {
    return `${this.key} == '${this.value}'`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = jS.create(this.key, this.value, this)), this.negated;
  }
}
class US {
  static create(e, t) {
    return new US(e, t);
  }
  constructor(e, t) {
    this.key = e, this.valueKey = t, this.type = 10, this.negated = null;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : xg(this.key, this.valueKey, e.key, e.valueKey);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.valueKey === e.valueKey;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    const t = e.getValue(this.valueKey), i = e.getValue(this.key);
    return Array.isArray(t) ? t.includes(i) : typeof i == "string" && typeof t == "object" && t !== null && Lj.call(t, i);
  }
  serialize() {
    return `${this.key} in '${this.valueKey}'`;
  }
  keys() {
    return [this.key, this.valueKey];
  }
  negate() {
    return this.negated || (this.negated = KS.create(this.key, this.valueKey)), this.negated;
  }
}
class KS {
  static create(e, t) {
    return new KS(e, t);
  }
  constructor(e, t) {
    this.key = e, this.valueKey = t, this.type = 11, this._negated = US.create(e, t);
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : this._negated.cmp(e._negated);
  }
  equals(e) {
    return e.type === this.type && this._negated.equals(e._negated);
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !this._negated.evaluate(e);
  }
  serialize() {
    return `${this.key} not in '${this.valueKey}'`;
  }
  keys() {
    return this._negated.keys();
  }
  negate() {
    return this._negated;
  }
}
class jS {
  static create(e, t, i = null) {
    if (typeof t == "boolean") return t ? Dg.create(e, i) : kg.create(e, i);
    const s = On.get(e);
    return typeof s == "boolean" ? t === (s ? "true" : "false") ? ws.INSTANCE : Os.INSTANCE : new jS(e, t, i);
  }
  constructor(e, t, i) {
    this.key = e, this.value = t, this.negated = i, this.type = 5;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : xg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    const e = On.get(this.key);
    if (typeof e == "boolean") {
      const t = e ? "true" : "false";
      return this.value === t ? ws.INSTANCE : Os.INSTANCE;
    }
    return this;
  }
  evaluate(e) {
    return e.getValue(this.key) != this.value;
  }
  serialize() {
    return `${this.key} != '${this.value}'`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = uf.create(this.key, this.value, this)), this.negated;
  }
}
class Dg {
  static create(e, t = null) {
    const i = On.get(e);
    return typeof i == "boolean" ? i ? ws.INSTANCE : Os.INSTANCE : new Dg(e, t);
  }
  constructor(e, t) {
    this.key = e, this.negated = t, this.type = 3;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : E8(this.key, e.key);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key;
  }
  substituteConstants() {
    const e = On.get(this.key);
    return typeof e == "boolean" ? e ? ws.INSTANCE : Os.INSTANCE : this;
  }
  evaluate(e) {
    return !e.getValue(this.key);
  }
  serialize() {
    return `!${this.key}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = kg.create(this.key, this)), this.negated;
  }
}
function qS(n, e) {
  if (typeof n == "string") {
    const t = parseFloat(n);
    isNaN(t) || (n = t);
  }
  return typeof n == "string" || typeof n == "number" ? e(n) : ws.INSTANCE;
}
class $S {
  static create(e, t, i = null) {
    return qS(t, ((s) => new $S(e, s, i)));
  }
  constructor(e, t, i) {
    this.key = e, this.value = t, this.negated = i, this.type = 12;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : xg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value != "string" && parseFloat(e.getValue(this.key)) > this.value;
  }
  serialize() {
    return `${this.key} > ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = YS.create(this.key, this.value, this)), this.negated;
  }
}
class GS {
  static create(e, t, i = null) {
    return qS(t, ((s) => new GS(e, s, i)));
  }
  constructor(e, t, i) {
    this.key = e, this.value = t, this.negated = i, this.type = 13;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : xg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value != "string" && parseFloat(e.getValue(this.key)) >= this.value;
  }
  serialize() {
    return `${this.key} >= ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = ZS.create(this.key, this.value, this)), this.negated;
  }
}
class ZS {
  static create(e, t, i = null) {
    return qS(t, ((s) => new ZS(e, s, i)));
  }
  constructor(e, t, i) {
    this.key = e, this.value = t, this.negated = i, this.type = 14;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : xg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value != "string" && parseFloat(e.getValue(this.key)) < this.value;
  }
  serialize() {
    return `${this.key} < ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = GS.create(this.key, this.value, this)), this.negated;
  }
}
class YS {
  static create(e, t, i = null) {
    return qS(t, ((s) => new YS(e, s, i)));
  }
  constructor(e, t, i) {
    this.key = e, this.value = t, this.negated = i, this.type = 15;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : xg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value != "string" && parseFloat(e.getValue(this.key)) <= this.value;
  }
  serialize() {
    return `${this.key} <= ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = $S.create(this.key, this.value, this)), this.negated;
  }
}
class J0 {
  static create(e, t) {
    return new J0(e, t);
  }
  constructor(e, t) {
    this.key = e, this.regexp = t, this.type = 7, this.negated = null;
  }
  cmp(e) {
    if (e.type !== this.type) return this.type - e.type;
    if (this.key < e.key) return -1;
    if (this.key > e.key) return 1;
    const t = this.regexp ? this.regexp.source : "", i = e.regexp ? e.regexp.source : "";
    return t < i ? -1 : t > i ? 1 : 0;
  }
  equals(e) {
    if (e.type === this.type) {
      const t = this.regexp ? this.regexp.source : "", i = e.regexp ? e.regexp.source : "";
      return this.key === e.key && t === i;
    }
    return !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    const t = e.getValue(this.key);
    return !!this.regexp && this.regexp.test(t);
  }
  serialize() {
    const e = this.regexp ? `/${this.regexp.source}/${this.regexp.flags}` : "/invalid/";
    return `${this.key} =~ ${e}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = vR.create(this)), this.negated;
  }
}
class vR {
  static create(e) {
    return new vR(e);
  }
  constructor(e) {
    this._actual = e, this.type = 8;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : this._actual.cmp(e._actual);
  }
  equals(e) {
    return e.type === this.type && this._actual.equals(e._actual);
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !this._actual.evaluate(e);
  }
  serialize() {
    return `!(${this._actual.serialize()})`;
  }
  keys() {
    return this._actual.keys();
  }
  negate() {
    return this._actual;
  }
}
function N8(n) {
  let e = null;
  for (let t = 0, i = n.length; t < i; t++) {
    const s = n[t].substituteConstants();
    if (n[t] !== s && e === null) {
      e = [];
      for (let o = 0; o < t; o++) e[o] = n[o];
    }
    e !== null && (e[t] = s);
  }
  return e === null ? n : e;
}
class Nu {
  static create(e, t, i) {
    return Nu._normalizeArr(e, t, i);
  }
  constructor(e, t) {
    this.expr = e, this.negated = t, this.type = 6;
  }
  cmp(e) {
    if (e.type !== this.type) return this.type - e.type;
    if (this.expr.length < e.expr.length) return -1;
    if (this.expr.length > e.expr.length) return 1;
    for (let t = 0, i = this.expr.length; t < i; t++) {
      const s = G_(this.expr[t], e.expr[t]);
      if (s !== 0) return s;
    }
    return 0;
  }
  equals(e) {
    if (e.type === this.type) {
      if (this.expr.length !== e.expr.length) return !1;
      for (let t = 0, i = this.expr.length; t < i; t++) if (!this.expr[t].equals(e.expr[t])) return !1;
      return !0;
    }
    return !1;
  }
  substituteConstants() {
    const e = N8(this.expr);
    return e === this.expr ? this : Nu.create(e, this.negated, !1);
  }
  evaluate(e) {
    for (let t = 0, i = this.expr.length; t < i; t++) if (!this.expr[t].evaluate(e)) return !1;
    return !0;
  }
  static _normalizeArr(e, t, i) {
    const s = [];
    let o = !1;
    for (const r of e) if (r) if (r.type !== 1) {
      if (r.type === 0) return ws.INSTANCE;
      r.type !== 6 ? s.push(r) : s.push(...r.expr);
    } else o = !0;
    if (s.length === 0 && o) return Os.INSTANCE;
    if (s.length !== 0) {
      if (s.length === 1) return s[0];
      s.sort(G_);
      for (let r = 1; r < s.length; r++) s[r - 1].equals(s[r]) && (s.splice(r, 1), r--);
      if (s.length === 1) return s[0];
      for (; s.length > 1; ) {
        const r = s[s.length - 1];
        if (r.type !== 9) break;
        s.pop();
        const a = s.pop(), l = s.length === 0, d = Xl.create(r.expr.map(((h) => Nu.create([h, a], null, i))), null, l);
        d && (s.push(d), s.sort(G_));
      }
      if (s.length === 1) return s[0];
      if (i) {
        for (let r = 0; r < s.length; r++) for (let a = r + 1; a < s.length; a++) if (s[r].negate().equals(s[a])) return ws.INSTANCE;
        if (s.length === 1) return s[0];
      }
      return new Nu(s, t);
    }
  }
  serialize() {
    return this.expr.map(((e) => e.serialize())).join(" && ");
  }
  keys() {
    const e = [];
    for (const t of this.expr) e.push(...t.keys());
    return e;
  }
  negate() {
    if (!this.negated) {
      const e = [];
      for (const t of this.expr) e.push(t.negate());
      this.negated = Xl.create(e, this, !0);
    }
    return this.negated;
  }
}
class Xl {
  static create(e, t, i) {
    return Xl._normalizeArr(e, t, i);
  }
  constructor(e, t) {
    this.expr = e, this.negated = t, this.type = 9;
  }
  cmp(e) {
    if (e.type !== this.type) return this.type - e.type;
    if (this.expr.length < e.expr.length) return -1;
    if (this.expr.length > e.expr.length) return 1;
    for (let t = 0, i = this.expr.length; t < i; t++) {
      const s = G_(this.expr[t], e.expr[t]);
      if (s !== 0) return s;
    }
    return 0;
  }
  equals(e) {
    if (e.type === this.type) {
      if (this.expr.length !== e.expr.length) return !1;
      for (let t = 0, i = this.expr.length; t < i; t++) if (!this.expr[t].equals(e.expr[t])) return !1;
      return !0;
    }
    return !1;
  }
  substituteConstants() {
    const e = N8(this.expr);
    return e === this.expr ? this : Xl.create(e, this.negated, !1);
  }
  evaluate(e) {
    for (let t = 0, i = this.expr.length; t < i; t++) if (this.expr[t].evaluate(e)) return !0;
    return !1;
  }
  static _normalizeArr(e, t, i) {
    let s = [], o = !1;
    if (e) {
      for (let r = 0, a = e.length; r < a; r++) {
        const l = e[r];
        if (l) if (l.type !== 0) {
          if (l.type === 1) return Os.INSTANCE;
          l.type !== 9 ? s.push(l) : s = s.concat(l.expr);
        } else o = !0;
      }
      if (s.length === 0 && o) return ws.INSTANCE;
      s.sort(G_);
    }
    if (s.length !== 0) {
      if (s.length === 1) return s[0];
      for (let r = 1; r < s.length; r++) s[r - 1].equals(s[r]) && (s.splice(r, 1), r--);
      if (s.length === 1) return s[0];
      if (i) {
        for (let r = 0; r < s.length; r++) for (let a = r + 1; a < s.length; a++) if (s[r].negate().equals(s[a])) return Os.INSTANCE;
        if (s.length === 1) return s[0];
      }
      return new Xl(s, t);
    }
  }
  serialize() {
    return this.expr.map(((e) => e.serialize())).join(" || ");
  }
  keys() {
    const e = [];
    for (const t of this.expr) e.push(...t.keys());
    return e;
  }
  negate() {
    if (!this.negated) {
      const e = [];
      for (const t of this.expr) e.push(t.negate());
      for (; e.length > 1; ) {
        const t = e.shift(), i = e.shift(), s = [];
        for (const o of EO(t)) for (const r of EO(i)) s.push(Nu.create([o, r], null, !1));
        e.unshift(Xl.create(s, null, !1));
      }
      this.negated = Xl.create(e, this, !0);
    }
    return this.negated;
  }
}
class ae extends kg {
  static all() {
    return ae._info.values();
  }
  constructor(e, t, i) {
    super(e, null), this._defaultValue = t, typeof i == "object" ? ae._info.push({ ...i, key: e }) : i !== !0 && ae._info.push({ key: e, description: i, type: t != null ? typeof t : void 0 });
  }
  bindTo(e) {
    return e.createKey(this.key, this._defaultValue);
  }
  getValue(e) {
    return e.getContextKeyValue(this.key);
  }
  toNegated() {
    return this.negate();
  }
  isEqualTo(e) {
    return uf.create(this.key, e);
  }
}
ae._info = [];
const Te = tt("contextKeyService");
function E8(n, e) {
  return n < e ? -1 : n > e ? 1 : 0;
}
function xg(n, e, t, i) {
  return n < t ? -1 : n > t ? 1 : e < i ? -1 : e > i ? 1 : 0;
}
function AE(n, e) {
  if (n.type === 0 || e.type === 1) return !0;
  if (n.type === 9) return e.type === 9 && NO(n.expr, e.expr);
  if (e.type === 9) {
    for (const t of e.expr) if (AE(n, t)) return !0;
    return !1;
  }
  if (n.type === 6) {
    if (e.type === 6) return NO(e.expr, n.expr);
    for (const t of n.expr) if (AE(t, e)) return !0;
    return !1;
  }
  return n.equals(e);
}
function NO(n, e) {
  let t = 0, i = 0;
  for (; t < n.length && i < e.length; ) {
    const s = n[t].cmp(e[i]);
    if (s < 0) return !1;
    s === 0 && t++, i++;
  }
  return t === n.length;
}
function EO(n) {
  return n.type === 9 ? n.expr : [n];
}
function Xk(n, e) {
  if (!n) throw new Error(e ? `Assertion failed (${e})` : "Assertion Failed");
}
function XS(n, e = "Unreachable") {
  throw new Error(e);
}
function IO(n) {
  n || We(new Kt("Soft Assertion Failed"));
}
function dg(n) {
  n() || (n(), We(new Kt("Assertion Failed")));
}
function bR(n, e) {
  let t = 0;
  for (; t < n.length - 1; ) {
    if (!e(n[t], n[t + 1])) return !1;
    t++;
  }
  return !0;
}
const li = new class {
  constructor() {
    this.data = /* @__PURE__ */ new Map();
  }
  add(n, e) {
    Xk(ps(n)), Xk(ms(e)), Xk(!this.data.has(n), "There is already an extension with this id"), this.data.set(n, e);
  }
  as(n) {
    return this.data.get(n) || null;
  }
}();
class CR {
  constructor() {
    this._coreKeybindings = new fs(), this._extensionKeybindings = [], this._cachedMergedKeybindings = null;
  }
  static bindToCurrentPlatform(e) {
    if (Gs === 1) {
      if (e && e.win) return e.win;
    } else if (Gs === 2) {
      if (e && e.mac) return e.mac;
    } else if (e && e.linux) return e.linux;
    return e;
  }
  registerKeybindingRule(e) {
    const t = CR.bindToCurrentPlatform(e), i = new G();
    if (t && t.primary) {
      const s = kE(t.primary, Gs);
      s && i.add(this._registerDefaultKeybinding(s, e.id, e.args, e.weight, 0, e.when));
    }
    if (t && Array.isArray(t.secondary)) for (let s = 0, o = t.secondary.length; s < o; s++) {
      const r = kE(t.secondary[s], Gs);
      r && i.add(this._registerDefaultKeybinding(r, e.id, e.args, e.weight, -s - 1, e.when));
    }
    return i;
  }
  registerCommandAndKeybindingRule(e) {
    return yr(this.registerKeybindingRule(e), dt.registerCommand(e));
  }
  _registerDefaultKeybinding(e, t, i, s, o, r) {
    const a = this._coreKeybindings.push({ keybinding: e, command: t, commandArgs: i, when: r, weight1: s, weight2: o, extensionId: null, isBuiltinExtension: !1 });
    return this._cachedMergedKeybindings = null, ye((() => {
      a(), this._cachedMergedKeybindings = null;
    }));
  }
  getDefaultKeybindings() {
    return this._cachedMergedKeybindings || (this._cachedMergedKeybindings = Array.from(this._coreKeybindings).concat(this._extensionKeybindings), this._cachedMergedKeybindings.sort(Rj)), this._cachedMergedKeybindings.slice(0);
  }
}
const Es = new CR();
function Rj(n, e) {
  if (n.weight1 !== e.weight1) return n.weight1 - e.weight1;
  if (n.command && e.command) {
    if (n.command < e.command) return -1;
    if (n.command > e.command) return 1;
  }
  return n.weight2 - e.weight2;
}
li.add("platform.keybindingsRegistry", Es);
var EC, Aj = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, MO = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
function kp(n) {
  return n.command !== void 0;
}
class x {
  constructor(e) {
    if (x._instances.has(e)) throw new TypeError(`MenuId with identifier '${e}' already exists. Use MenuId.for(ident) or a unique identifier`);
    x._instances.set(e, this), this.id = e;
  }
}
x._instances = /* @__PURE__ */ new Map(), x.CommandPalette = new x("CommandPalette"), x.DebugBreakpointsContext = new x("DebugBreakpointsContext"), x.DebugCallStackContext = new x("DebugCallStackContext"), x.DebugConsoleContext = new x("DebugConsoleContext"), x.DebugVariablesContext = new x("DebugVariablesContext"), x.NotebookVariablesContext = new x("NotebookVariablesContext"), x.DebugHoverContext = new x("DebugHoverContext"), x.DebugWatchContext = new x("DebugWatchContext"), x.DebugToolBar = new x("DebugToolBar"), x.DebugToolBarStop = new x("DebugToolBarStop"), x.EditorContext = new x("EditorContext"), x.SimpleEditorContext = new x("SimpleEditorContext"), x.EditorContent = new x("EditorContent"), x.EditorLineNumberContext = new x("EditorLineNumberContext"), x.EditorContextCopy = new x("EditorContextCopy"), x.EditorContextPeek = new x("EditorContextPeek"), x.EditorContextShare = new x("EditorContextShare"), x.EditorTitle = new x("EditorTitle"), x.EditorTitleRun = new x("EditorTitleRun"), x.EditorTitleContext = new x("EditorTitleContext"), x.EditorTitleContextShare = new x("EditorTitleContextShare"), x.EmptyEditorGroup = new x("EmptyEditorGroup"), x.EmptyEditorGroupContext = new x("EmptyEditorGroupContext"), x.EditorTabsBarContext = new x("EditorTabsBarContext"), x.EditorTabsBarShowTabsSubmenu = new x("EditorTabsBarShowTabsSubmenu"), x.EditorTabsBarShowTabsZenModeSubmenu = new x("EditorTabsBarShowTabsZenModeSubmenu"), x.EditorActionsPositionSubmenu = new x("EditorActionsPositionSubmenu"), x.ExplorerContext = new x("ExplorerContext"), x.ExplorerContextShare = new x("ExplorerContextShare"), x.ExtensionContext = new x("ExtensionContext"), x.GlobalActivity = new x("GlobalActivity"), x.CommandCenter = new x("CommandCenter"), x.CommandCenterCenter = new x("CommandCenterCenter"), x.LayoutControlMenuSubmenu = new x("LayoutControlMenuSubmenu"), x.LayoutControlMenu = new x("LayoutControlMenu"), x.MenubarMainMenu = new x("MenubarMainMenu"), x.MenubarAppearanceMenu = new x("MenubarAppearanceMenu"), x.MenubarDebugMenu = new x("MenubarDebugMenu"), x.MenubarEditMenu = new x("MenubarEditMenu"), x.MenubarCopy = new x("MenubarCopy"), x.MenubarFileMenu = new x("MenubarFileMenu"), x.MenubarGoMenu = new x("MenubarGoMenu"), x.MenubarHelpMenu = new x("MenubarHelpMenu"), x.MenubarLayoutMenu = new x("MenubarLayoutMenu"), x.MenubarNewBreakpointMenu = new x("MenubarNewBreakpointMenu"), x.PanelAlignmentMenu = new x("PanelAlignmentMenu"), x.PanelPositionMenu = new x("PanelPositionMenu"), x.ActivityBarPositionMenu = new x("ActivityBarPositionMenu"), x.MenubarPreferencesMenu = new x("MenubarPreferencesMenu"), x.MenubarRecentMenu = new x("MenubarRecentMenu"), x.MenubarSelectionMenu = new x("MenubarSelectionMenu"), x.MenubarShare = new x("MenubarShare"), x.MenubarSwitchEditorMenu = new x("MenubarSwitchEditorMenu"), x.MenubarSwitchGroupMenu = new x("MenubarSwitchGroupMenu"), x.MenubarTerminalMenu = new x("MenubarTerminalMenu"), x.MenubarViewMenu = new x("MenubarViewMenu"), x.MenubarHomeMenu = new x("MenubarHomeMenu"), x.OpenEditorsContext = new x("OpenEditorsContext"), x.OpenEditorsContextShare = new x("OpenEditorsContextShare"), x.ProblemsPanelContext = new x("ProblemsPanelContext"), x.SCMInputBox = new x("SCMInputBox"), x.SCMChangesSeparator = new x("SCMChangesSeparator"), x.SCMIncomingChanges = new x("SCMIncomingChanges"), x.SCMIncomingChangesContext = new x("SCMIncomingChangesContext"), x.SCMIncomingChangesSetting = new x("SCMIncomingChangesSetting"), x.SCMOutgoingChanges = new x("SCMOutgoingChanges"), x.SCMOutgoingChangesContext = new x("SCMOutgoingChangesContext"), x.SCMOutgoingChangesSetting = new x("SCMOutgoingChangesSetting"), x.SCMIncomingChangesAllChangesContext = new x("SCMIncomingChangesAllChangesContext"), x.SCMIncomingChangesHistoryItemContext = new x("SCMIncomingChangesHistoryItemContext"), x.SCMOutgoingChangesAllChangesContext = new x("SCMOutgoingChangesAllChangesContext"), x.SCMOutgoingChangesHistoryItemContext = new x("SCMOutgoingChangesHistoryItemContext"), x.SCMChangeContext = new x("SCMChangeContext"), x.SCMResourceContext = new x("SCMResourceContext"), x.SCMResourceContextShare = new x("SCMResourceContextShare"), x.SCMResourceFolderContext = new x("SCMResourceFolderContext"), x.SCMResourceGroupContext = new x("SCMResourceGroupContext"), x.SCMSourceControl = new x("SCMSourceControl"), x.SCMSourceControlInline = new x("SCMSourceControlInline"), x.SCMSourceControlTitle = new x("SCMSourceControlTitle"), x.SCMTitle = new x("SCMTitle"), x.SearchContext = new x("SearchContext"), x.SearchActionMenu = new x("SearchActionContext"), x.StatusBarWindowIndicatorMenu = new x("StatusBarWindowIndicatorMenu"), x.StatusBarRemoteIndicatorMenu = new x("StatusBarRemoteIndicatorMenu"), x.StickyScrollContext = new x("StickyScrollContext"), x.TestItem = new x("TestItem"), x.TestItemGutter = new x("TestItemGutter"), x.TestMessageContext = new x("TestMessageContext"), x.TestMessageContent = new x("TestMessageContent"), x.TestPeekElement = new x("TestPeekElement"), x.TestPeekTitle = new x("TestPeekTitle"), x.TouchBarContext = new x("TouchBarContext"), x.TitleBarContext = new x("TitleBarContext"), x.TitleBarTitleContext = new x("TitleBarTitleContext"), x.TunnelContext = new x("TunnelContext"), x.TunnelPrivacy = new x("TunnelPrivacy"), x.TunnelProtocol = new x("TunnelProtocol"), x.TunnelPortInline = new x("TunnelInline"), x.TunnelTitle = new x("TunnelTitle"), x.TunnelLocalAddressInline = new x("TunnelLocalAddressInline"), x.TunnelOriginInline = new x("TunnelOriginInline"), x.ViewItemContext = new x("ViewItemContext"), x.ViewContainerTitle = new x("ViewContainerTitle"), x.ViewContainerTitleContext = new x("ViewContainerTitleContext"), x.ViewTitle = new x("ViewTitle"), x.ViewTitleContext = new x("ViewTitleContext"), x.CommentEditorActions = new x("CommentEditorActions"), x.CommentThreadTitle = new x("CommentThreadTitle"), x.CommentThreadActions = new x("CommentThreadActions"), x.CommentThreadAdditionalActions = new x("CommentThreadAdditionalActions"), x.CommentThreadTitleContext = new x("CommentThreadTitleContext"), x.CommentThreadCommentContext = new x("CommentThreadCommentContext"), x.CommentTitle = new x("CommentTitle"), x.CommentActions = new x("CommentActions"), x.CommentsViewThreadActions = new x("CommentsViewThreadActions"), x.InteractiveToolbar = new x("InteractiveToolbar"), x.InteractiveCellTitle = new x("InteractiveCellTitle"), x.InteractiveCellDelete = new x("InteractiveCellDelete"), x.InteractiveCellExecute = new x("InteractiveCellExecute"), x.InteractiveInputExecute = new x("InteractiveInputExecute"), x.IssueReporter = new x("IssueReporter"), x.NotebookToolbar = new x("NotebookToolbar"), x.NotebookStickyScrollContext = new x("NotebookStickyScrollContext"), x.NotebookCellTitle = new x("NotebookCellTitle"), x.NotebookCellDelete = new x("NotebookCellDelete"), x.NotebookCellInsert = new x("NotebookCellInsert"), x.NotebookCellBetween = new x("NotebookCellBetween"), x.NotebookCellListTop = new x("NotebookCellTop"), x.NotebookCellExecute = new x("NotebookCellExecute"), x.NotebookCellExecuteGoTo = new x("NotebookCellExecuteGoTo"), x.NotebookCellExecutePrimary = new x("NotebookCellExecutePrimary"), x.NotebookDiffCellInputTitle = new x("NotebookDiffCellInputTitle"), x.NotebookDiffCellMetadataTitle = new x("NotebookDiffCellMetadataTitle"), x.NotebookDiffCellOutputsTitle = new x("NotebookDiffCellOutputsTitle"), x.NotebookOutputToolbar = new x("NotebookOutputToolbar"), x.NotebookOutlineFilter = new x("NotebookOutlineFilter"), x.NotebookOutlineActionMenu = new x("NotebookOutlineActionMenu"), x.NotebookEditorLayoutConfigure = new x("NotebookEditorLayoutConfigure"), x.NotebookKernelSource = new x("NotebookKernelSource"), x.BulkEditTitle = new x("BulkEditTitle"), x.BulkEditContext = new x("BulkEditContext"), x.TimelineItemContext = new x("TimelineItemContext"), x.TimelineTitle = new x("TimelineTitle"), x.TimelineTitleContext = new x("TimelineTitleContext"), x.TimelineFilterSubMenu = new x("TimelineFilterSubMenu"), x.AccountsContext = new x("AccountsContext"), x.SidebarTitle = new x("SidebarTitle"), x.PanelTitle = new x("PanelTitle"), x.AuxiliaryBarTitle = new x("AuxiliaryBarTitle"), x.AuxiliaryBarHeader = new x("AuxiliaryBarHeader"), x.TerminalInstanceContext = new x("TerminalInstanceContext"), x.TerminalEditorInstanceContext = new x("TerminalEditorInstanceContext"), x.TerminalNewDropdownContext = new x("TerminalNewDropdownContext"), x.TerminalTabContext = new x("TerminalTabContext"), x.TerminalTabEmptyAreaContext = new x("TerminalTabEmptyAreaContext"), x.TerminalStickyScrollContext = new x("TerminalStickyScrollContext"), x.WebviewContext = new x("WebviewContext"), x.InlineCompletionsActions = new x("InlineCompletionsActions"), x.InlineEditActions = new x("InlineEditActions"), x.NewFile = new x("NewFile"), x.MergeInput1Toolbar = new x("MergeToolbar1Toolbar"), x.MergeInput2Toolbar = new x("MergeToolbar2Toolbar"), x.MergeBaseToolbar = new x("MergeBaseToolbar"), x.MergeInputResultToolbar = new x("MergeToolbarResultToolbar"), x.InlineSuggestionToolbar = new x("InlineSuggestionToolbar"), x.InlineEditToolbar = new x("InlineEditToolbar"), x.ChatContext = new x("ChatContext"), x.ChatCodeBlock = new x("ChatCodeblock"), x.ChatMessageTitle = new x("ChatMessageTitle"), x.ChatExecute = new x("ChatExecute"), x.ChatExecuteSecondary = new x("ChatExecuteSecondary"), x.ChatInputSide = new x("ChatInputSide"), x.AccessibleView = new x("AccessibleView"), x.MultiDiffEditorFileToolbar = new x("MultiDiffEditorFileToolbar"), x.DiffEditorHunkToolbar = new x("DiffEditorHunkToolbar"), x.DiffEditorSelectionToolbar = new x("DiffEditorSelectionToolbar");
const Mo = tt("menuService");
class Ql {
  static for(e) {
    let t = this._all.get(e);
    return t || (t = new Ql(e), this._all.set(e, t)), t;
  }
  static merge(e) {
    const t = /* @__PURE__ */ new Set();
    for (const i of e) i instanceof Ql && t.add(i.id);
    return t;
  }
  constructor(e) {
    this.id = e, this.has = (t) => t === e;
  }
}
Ql._all = /* @__PURE__ */ new Map();
const tn = new class {
  constructor() {
    this._commands = /* @__PURE__ */ new Map(), this._menuItems = /* @__PURE__ */ new Map(), this._onDidChangeMenu = new rK({ merge: Ql.merge }), this.onDidChangeMenu = this._onDidChangeMenu.event;
  }
  addCommand(n) {
    return this._commands.set(n.id, n), this._onDidChangeMenu.fire(Ql.for(x.CommandPalette)), ye((() => {
      this._commands.delete(n.id) && this._onDidChangeMenu.fire(Ql.for(x.CommandPalette));
    }));
  }
  getCommand(n) {
    return this._commands.get(n);
  }
  getCommands() {
    const n = /* @__PURE__ */ new Map();
    return this._commands.forEach(((e, t) => n.set(t, e))), n;
  }
  appendMenuItem(n, e) {
    let t = this._menuItems.get(n);
    t || (t = new fs(), this._menuItems.set(n, t));
    const i = t.push(e);
    return this._onDidChangeMenu.fire(Ql.for(n)), ye((() => {
      i(), this._onDidChangeMenu.fire(Ql.for(n));
    }));
  }
  appendMenuItems(n) {
    const e = new G();
    for (const { id: t, item: i } of n) e.add(this.appendMenuItem(t, i));
    return e;
  }
  getMenuItems(n) {
    let e;
    return e = this._menuItems.has(n) ? [...this._menuItems.get(n)] : [], n === x.CommandPalette && this._appendImplicitItems(e), e;
  }
  _appendImplicitItems(n) {
    const e = /* @__PURE__ */ new Set();
    for (const t of n) kp(t) && (e.add(t.command.id), t.alt && e.add(t.alt.id));
    this._commands.forEach(((t, i) => {
      e.has(i) || n.push({ command: t });
    }));
  }
}();
class ev extends Om {
  constructor(e, t, i) {
    super(`submenuitem.${e.submenu.id}`, typeof e.title == "string" ? e.title : e.title.value, i, "submenu"), this.item = e, this.hideActions = t;
  }
}
let Eo = EC = class {
  static label(n, e) {
    return e?.renderShortTitle && n.shortTitle ? typeof n.shortTitle == "string" ? n.shortTitle : n.shortTitle.value : typeof n.title == "string" ? n.title : n.title.value;
  }
  constructor(n, e, t, i, s, o) {
    var r, a;
    let l;
    if (this.hideActions = i, this._commandService = o, this.id = n.id, this.label = EC.label(n, t), this.tooltip = (a = typeof n.tooltip == "string" ? n.tooltip : (r = n.tooltip) === null || r === void 0 ? void 0 : r.value) !== null && a !== void 0 ? a : "", this.enabled = !n.precondition || s.contextMatchesRules(n.precondition), this.checked = void 0, n.toggled) {
      const d = n.toggled.condition ? n.toggled : { condition: n.toggled };
      this.checked = s.contextMatchesRules(d.condition), this.checked && d.tooltip && (this.tooltip = typeof d.tooltip == "string" ? d.tooltip : d.tooltip.value), this.checked && Ee.isThemeIcon(d.icon) && (l = d.icon), this.checked && d.title && (this.label = typeof d.title == "string" ? d.title : d.title.value);
    }
    l || (l = Ee.isThemeIcon(n.icon) ? n.icon : void 0), this.item = n, this.alt = e ? new EC(e, void 0, t, i, s, o) : void 0, this._options = t, this.class = l && Ee.asClassName(l);
  }
  run(...n) {
    var e, t;
    let i = [];
    return !((e = this._options) === null || e === void 0) && e.arg && (i = [...i, this._options.arg]), !((t = this._options) === null || t === void 0) && t.shouldForwardArgs && (i = [...i, ...n]), this._commandService.executeCommand(this.id, ...i);
  }
};
Eo = EC = Aj([MO(4, Te), MO(5, ai)], Eo);
class cs {
  constructor(e) {
    this.desc = e;
  }
}
function Ft(n) {
  const e = new G(), t = new n(), { f1: i, menu: s, keybinding: o, ...r } = t.desc;
  if (dt.getCommand(r.id)) throw new Error(`Cannot register two commands with the same id: ${r.id}`);
  if (e.add(dt.registerCommand({ id: r.id, handler: (a, ...l) => t.run(a, ...l), metadata: r.metadata })), Array.isArray(s)) for (const a of s) e.add(tn.appendMenuItem(a.id, { command: { ...r, precondition: a.precondition === null ? void 0 : r.precondition }, ...a }));
  else s && e.add(tn.appendMenuItem(s.id, { command: { ...r, precondition: s.precondition === null ? void 0 : r.precondition }, ...s }));
  if (i && (e.add(tn.appendMenuItem(x.CommandPalette, { command: r, when: r.precondition })), e.add(tn.addCommand(r))), Array.isArray(o)) for (const a of o) e.add(Es.registerKeybindingRule({ ...a, id: r.id, when: r.precondition ? q.and(r.precondition, a.when) : a.when }));
  else o && e.add(Es.registerKeybindingRule({ ...o, id: r.id, when: r.precondition ? q.and(r.precondition, o.when) : o.when }));
  return e;
}
const es = tt("telemetryService"), ts = tt("logService");
var Nn;
(function(n) {
  n[n.Off = 0] = "Off", n[n.Trace = 1] = "Trace", n[n.Debug = 2] = "Debug", n[n.Info = 3] = "Info", n[n.Warning = 4] = "Warning", n[n.Error = 5] = "Error";
})(Nn || (Nn = {}));
const I8 = Nn.Info;
class M8 extends V {
  constructor() {
    super(...arguments), this.level = I8, this._onDidChangeLogLevel = this._register(new F()), this.onDidChangeLogLevel = this._onDidChangeLogLevel.event;
  }
  setLevel(e) {
    this.level !== e && (this.level = e, this._onDidChangeLogLevel.fire(this.level));
  }
  getLevel() {
    return this.level;
  }
  checkLogLevel(e) {
    return this.level !== Nn.Off && this.level <= e;
  }
}
class Pj extends M8 {
  constructor(e = I8, t = !0) {
    super(), this.useColors = t, this.setLevel(e);
  }
  trace(e, ...t) {
    this.checkLogLevel(Nn.Trace) && (this.useColors ? console.log("%cTRACE", "color: #888", e, ...t) : console.log(e, ...t));
  }
  debug(e, ...t) {
    this.checkLogLevel(Nn.Debug) && (this.useColors ? console.log("%cDEBUG", "background: #eee; color: #888", e, ...t) : console.log(e, ...t));
  }
  info(e, ...t) {
    this.checkLogLevel(Nn.Info) && (this.useColors ? console.log("%c INFO", "color: #33f", e, ...t) : console.log(e, ...t));
  }
  warn(e, ...t) {
    this.checkLogLevel(Nn.Warning) && (this.useColors ? console.log("%c WARN", "color: #993", e, ...t) : console.log(e, ...t));
  }
  error(e, ...t) {
    this.checkLogLevel(Nn.Error) && (this.useColors ? console.log("%c  ERR", "color: #f33", e, ...t) : console.error(e, ...t));
  }
}
class Oj extends M8 {
  constructor(e) {
    super(), this.loggers = e, e.length && this.setLevel(e[0].getLevel());
  }
  setLevel(e) {
    for (const t of this.loggers) t.setLevel(e);
    super.setLevel(e);
  }
  trace(e, ...t) {
    for (const i of this.loggers) i.trace(e, ...t);
  }
  debug(e, ...t) {
    for (const i of this.loggers) i.debug(e, ...t);
  }
  info(e, ...t) {
    for (const i of this.loggers) i.info(e, ...t);
  }
  warn(e, ...t) {
    for (const i of this.loggers) i.warn(e, ...t);
  }
  error(e, ...t) {
    for (const i of this.loggers) i.error(e, ...t);
  }
  dispose() {
    for (const e of this.loggers) e.dispose();
    super.dispose();
  }
}
new ae("logLevel", (function(n) {
  switch (n) {
    case Nn.Trace:
      return "trace";
    case Nn.Debug:
      return "debug";
    case Nn.Info:
      return "info";
    case Nn.Warning:
      return "warn";
    case Nn.Error:
      return "error";
    case Nn.Off:
      return "off";
  }
})(Nn.Info));
class QS {
  constructor(e) {
    this.id = e.id, this.precondition = e.precondition, this._kbOpts = e.kbOpts, this._menuOpts = e.menuOpts, this.metadata = e.metadata;
  }
  register() {
    if (Array.isArray(this._menuOpts) ? this._menuOpts.forEach(this._registerMenuItem, this) : this._menuOpts && this._registerMenuItem(this._menuOpts), this._kbOpts) {
      const e = Array.isArray(this._kbOpts) ? this._kbOpts : [this._kbOpts];
      for (const t of e) {
        let i = t.kbExpr;
        this.precondition && (i = i ? q.and(i, this.precondition) : this.precondition);
        const s = { id: this.id, weight: t.weight, args: t.args, when: i, primary: t.primary, secondary: t.secondary, win: t.win, linux: t.linux, mac: t.mac };
        Es.registerKeybindingRule(s);
      }
    }
    dt.registerCommand({ id: this.id, handler: (e, t) => this.runCommand(e, t), metadata: this.metadata });
  }
  _registerMenuItem(e) {
    tn.appendMenuItem(e.menuId, { group: e.group, command: { id: this.id, title: e.title, icon: e.icon, precondition: this.precondition }, when: e.when, order: e.order });
  }
}
class gf extends QS {
  constructor() {
    super(...arguments), this._implementations = [];
  }
  addImplementation(e, t, i, s) {
    return this._implementations.push({ priority: e, name: t, implementation: i, when: s }), this._implementations.sort(((o, r) => r.priority - o.priority)), { dispose: () => {
      for (let o = 0; o < this._implementations.length; o++) if (this._implementations[o].implementation === i) return void this._implementations.splice(o, 1);
    } };
  }
  runCommand(e, t) {
    const i = e.get(ts), s = e.get(Te);
    i.trace(`Executing Command '${this.id}' which has ${this._implementations.length} bound.`);
    for (const o of this._implementations) {
      if (o.when) {
        const a = s.getContext(Mn());
        if (!o.when.evaluate(a)) continue;
      }
      const r = o.implementation(e, t);
      if (r)
        return i.trace(`Command '${this.id}' was handled by '${o.name}'.`), typeof r == "boolean" ? void 0 : r;
    }
    i.trace(`The Command '${this.id}' was not handled by any implementation.`);
  }
}
class T8 extends QS {
  constructor(e, t) {
    super(t), this.command = e;
  }
  runCommand(e, t) {
    return this.command.runCommand(e, t);
  }
}
class Zi extends QS {
  static bindToContribution(e) {
    return class extends Zi {
      constructor(t) {
        super(t), this._callback = t.handler;
      }
      runEditorCommand(t, i, s) {
        const o = e(i);
        o && this._callback(o, s);
      }
    };
  }
  static runEditorCommand(e, t, i, s) {
    const o = e.get(mt), r = o.getFocusedCodeEditor() || o.getActiveCodeEditor();
    if (r) return r.invokeWithinContext(((a) => {
      if (a.get(Te).contextMatchesRules(i ?? void 0)) return s(a, r, t);
    }));
  }
  runCommand(e, t) {
    return Zi.runEditorCommand(e, t, this.precondition, ((i, s, o) => this.runEditorCommand(i, s, o)));
  }
}
class he extends Zi {
  static convertOptions(e) {
    let t;
    function i(s) {
      return s.menuId || (s.menuId = x.EditorContext), s.title || (s.title = e.label), s.when = q.and(e.precondition, s.when), s;
    }
    return t = Array.isArray(e.menuOpts) ? e.menuOpts : e.menuOpts ? [e.menuOpts] : [], Array.isArray(e.contextMenuOpts) ? t.push(...e.contextMenuOpts.map(i)) : e.contextMenuOpts && t.push(i(e.contextMenuOpts)), e.menuOpts = t, e;
  }
  constructor(e) {
    super(he.convertOptions(e)), this.label = e.label, this.alias = e.alias;
  }
  runEditorCommand(e, t, i) {
    return this.reportTelemetry(e, t), this.run(e, t, i || {});
  }
  reportTelemetry(e, t) {
    e.get(es).publicLog2("editorActionInvoked", { name: this.label, id: this.id });
  }
}
class R8 extends he {
  constructor() {
    super(...arguments), this._implementations = [];
  }
  addImplementation(e, t) {
    return this._implementations.push([e, t]), this._implementations.sort(((i, s) => s[0] - i[0])), { dispose: () => {
      for (let i = 0; i < this._implementations.length; i++) if (this._implementations[i][1] === t) return void this._implementations.splice(i, 1);
    } };
  }
  run(e, t, i) {
    for (const s of this._implementations) {
      const o = s[1](e, t, i);
      if (o)
        return typeof o == "boolean" ? void 0 : o;
    }
  }
}
class Qr extends cs {
  run(e, ...t) {
    const i = e.get(mt), s = i.getFocusedCodeEditor() || i.getActiveCodeEditor();
    if (s) return s.invokeWithinContext(((o) => {
      var r, a;
      const l = o.get(Te), d = o.get(ts);
      if (l.contextMatchesRules((r = this.desc.precondition) !== null && r !== void 0 ? r : void 0)) return this.runEditorCommand(o, s, ...t);
      d.debug("[EditorAction2] NOT running command because its precondition is FALSE", this.desc.id, (a = this.desc.precondition) === null || a === void 0 ? void 0 : a.serialize());
    }));
  }
}
function ja(n, e) {
  dt.registerCommand(n, (function(t, ...i) {
    const s = t.get(Se), [o, r] = i;
    vt(Ie.isUri(o)), vt(W.isIPosition(r));
    const a = t.get(ni).getModel(o);
    if (a) {
      const l = W.lift(r);
      return s.invokeFunction(e, a, l, ...i.slice(2));
    }
    return t.get(Ps).createModelReference(o).then(((l) => new Promise(((d, h) => {
      try {
        d(s.invokeFunction(e, l.object.textEditorModel, W.lift(r), i.slice(2)));
      } catch (c) {
        h(c);
      }
    })).finally((() => {
      l.dispose();
    }))));
  }));
}
function re(n) {
  return Ho.INSTANCE.registerEditorCommand(n), n;
}
function X(n) {
  const e = new n();
  return Ho.INSTANCE.registerEditorAction(e), e;
}
function A8(n) {
  return Ho.INSTANCE.registerEditorAction(n), n;
}
function ft(n, e, t) {
  Ho.INSTANCE.registerEditorContribution(n, e, t);
}
var Xp;
(function(n) {
  n.getEditorCommand = function(e) {
    return Ho.INSTANCE.getEditorCommand(e);
  }, n.getEditorActions = function() {
    return Ho.INSTANCE.getEditorActions();
  }, n.getEditorContributions = function() {
    return Ho.INSTANCE.getEditorContributions();
  }, n.getSomeEditorContributions = function(e) {
    return Ho.INSTANCE.getEditorContributions().filter(((t) => e.indexOf(t.id) >= 0));
  }, n.getDiffEditorContributions = function() {
    return Ho.INSTANCE.getDiffEditorContributions();
  };
})(Xp || (Xp = {}));
class Ho {
  constructor() {
    this.editorContributions = [], this.diffEditorContributions = [], this.editorActions = [], this.editorCommands = /* @__PURE__ */ Object.create(null);
  }
  registerEditorContribution(e, t, i) {
    this.editorContributions.push({ id: e, ctor: t, instantiation: i });
  }
  getEditorContributions() {
    return this.editorContributions.slice(0);
  }
  getDiffEditorContributions() {
    return this.diffEditorContributions.slice(0);
  }
  registerEditorAction(e) {
    e.register(), this.editorActions.push(e);
  }
  getEditorActions() {
    return this.editorActions;
  }
  registerEditorCommand(e) {
    e.register(), this.editorCommands[e.id] = e;
  }
  getEditorCommand(e) {
    return this.editorCommands[e] || null;
  }
}
function v1(n) {
  return n.register(), n;
}
Ho.INSTANCE = new Ho(), li.add("editor.contributions", Ho.INSTANCE);
const P8 = v1(new gf({ id: "undo", precondition: void 0, kbOpts: { weight: 0, primary: 2104 }, menuOpts: [{ menuId: x.MenubarEditMenu, group: "1_do", title: m(0, "&&Undo"), order: 1 }, { menuId: x.CommandPalette, group: "", title: m(0, "Undo"), order: 1 }] }));
v1(new T8(P8, { id: "default:undo", precondition: void 0 }));
const O8 = v1(new gf({ id: "redo", precondition: void 0, kbOpts: { weight: 0, primary: 2103, secondary: [3128], mac: { primary: 3128 } }, menuOpts: [{ menuId: x.MenubarEditMenu, group: "1_do", title: m(0, "&&Redo"), order: 2 }, { menuId: x.CommandPalette, group: "", title: m(0, "Redo"), order: 1 }] }));
v1(new T8(O8, { id: "default:redo", precondition: void 0 }));
const Fj = v1(new gf({ id: "editor.action.selectAll", precondition: void 0, kbOpts: { weight: 0, kbExpr: null, primary: 2079 }, menuOpts: [{ menuId: x.MenubarSelectionMenu, group: "1_basic", title: m(0, "&&Select All"), order: 1 }, { menuId: x.CommandPalette, group: "", title: m(0, "Select All"), order: 1 }] }));
let TO = !1;
function PE(n) {
  gc && (TO || (TO = !0, console.warn("Could not create web worker(s). Falling back to loading web worker code in main thread, which might cause UI freezes. Please see https://github.com/microsoft/monaco-editor#faq")), console.warn(n.message));
}
class Bj {
  constructor(e, t, i, s) {
    this.vsWorker = e, this.req = t, this.method = i, this.args = s, this.type = 0;
  }
}
class RO {
  constructor(e, t, i, s) {
    this.vsWorker = e, this.seq = t, this.res = i, this.err = s, this.type = 1;
  }
}
class Wj {
  constructor(e, t, i, s) {
    this.vsWorker = e, this.req = t, this.eventName = i, this.arg = s, this.type = 2;
  }
}
class Vj {
  constructor(e, t, i) {
    this.vsWorker = e, this.req = t, this.event = i, this.type = 3;
  }
}
class Hj {
  constructor(e, t) {
    this.vsWorker = e, this.req = t, this.type = 4;
  }
}
class zj {
  constructor(e) {
    this._workerId = -1, this._handler = e, this._lastSentReq = 0, this._pendingReplies = /* @__PURE__ */ Object.create(null), this._pendingEmitters = /* @__PURE__ */ new Map(), this._pendingEvents = /* @__PURE__ */ new Map();
  }
  setWorkerId(e) {
    this._workerId = e;
  }
  sendMessage(e, t) {
    const i = String(++this._lastSentReq);
    return new Promise(((s, o) => {
      this._pendingReplies[i] = { resolve: s, reject: o }, this._send(new Bj(this._workerId, i, e, t));
    }));
  }
  listen(e, t) {
    let i = null;
    const s = new F({ onWillAddFirstListener: () => {
      i = String(++this._lastSentReq), this._pendingEmitters.set(i, s), this._send(new Wj(this._workerId, i, e, t));
    }, onDidRemoveLastListener: () => {
      this._pendingEmitters.delete(i), this._send(new Hj(this._workerId, i)), i = null;
    } });
    return s.event;
  }
  handleMessage(e) {
    e && e.vsWorker && (this._workerId !== -1 && e.vsWorker !== this._workerId || this._handleMessage(e));
  }
  _handleMessage(e) {
    switch (e.type) {
      case 1:
        return this._handleReplyMessage(e);
      case 0:
        return this._handleRequestMessage(e);
      case 2:
        return this._handleSubscribeEventMessage(e);
      case 3:
        return this._handleEventMessage(e);
      case 4:
        return this._handleUnsubscribeEventMessage(e);
    }
  }
  _handleReplyMessage(e) {
    if (!this._pendingReplies[e.seq]) return void console.warn("Got reply to unknown seq");
    const t = this._pendingReplies[e.seq];
    if (delete this._pendingReplies[e.seq], e.err) {
      let i = e.err;
      return e.err.$isError && (i = new Error(), i.name = e.err.name, i.message = e.err.message, i.stack = e.err.stack), void t.reject(i);
    }
    t.resolve(e.res);
  }
  _handleRequestMessage(e) {
    const t = e.req;
    this._handler.handleMessage(e.method, e.args).then(((i) => {
      this._send(new RO(this._workerId, t, i, void 0));
    }), ((i) => {
      i.detail instanceof Error && (i.detail = iO(i.detail)), this._send(new RO(this._workerId, t, void 0, iO(i)));
    }));
  }
  _handleSubscribeEventMessage(e) {
    const t = e.req, i = this._handler.handleEvent(e.eventName, e.arg)(((s) => {
      this._send(new Vj(this._workerId, t, s));
    }));
    this._pendingEvents.set(t, i);
  }
  _handleEventMessage(e) {
    this._pendingEmitters.has(e.req) ? this._pendingEmitters.get(e.req).fire(e.event) : console.warn("Got event for unknown req");
  }
  _handleUnsubscribeEventMessage(e) {
    this._pendingEvents.has(e.req) ? (this._pendingEvents.get(e.req).dispose(), this._pendingEvents.delete(e.req)) : console.warn("Got unsubscribe for unknown req");
  }
  _send(e) {
    const t = [];
    if (e.type === 0) for (let i = 0; i < e.args.length; i++) e.args[i] instanceof ArrayBuffer && t.push(e.args[i]);
    else e.type === 1 && e.res instanceof ArrayBuffer && t.push(e.res);
    this._handler.sendMessage(e, t);
  }
}
class Uj extends V {
  constructor(e, t, i) {
    super();
    let s = null;
    this._worker = this._register(e.create("vs/base/common/worker/simpleWorker", ((h) => {
      this._protocol.handleMessage(h);
    }), ((h) => {
      s?.(h);
    }))), this._protocol = new zj({ sendMessage: (h, c) => {
      this._worker.postMessage(h, c);
    }, handleMessage: (h, c) => {
      if (typeof i[h] != "function") return Promise.reject(new Error("Missing method " + h + " on main thread host."));
      try {
        return Promise.resolve(i[h].apply(i, c));
      } catch (u) {
        return Promise.reject(u);
      }
    }, handleEvent: (h, c) => {
      if (PO(h)) {
        const u = i[h].call(i, c);
        if (typeof u != "function") throw new Error(`Missing dynamic event ${h} on main thread host.`);
        return u;
      }
      if (AO(h)) {
        const u = i[h];
        if (typeof u != "function") throw new Error(`Missing event ${h} on main thread host.`);
        return u;
      }
      throw new Error(`Malformed event name ${h}`);
    } }), this._protocol.setWorkerId(this._worker.getId());
    let o = null;
    const r = globalThis.require;
    r !== void 0 && typeof r.getConfig == "function" ? o = r.getConfig() : globalThis.requirejs !== void 0 && (o = globalThis.requirejs.s.contexts._.config);
    const a = KT(i);
    this._onModuleLoaded = this._protocol.sendMessage("$initialize", [this._worker.getId(), JSON.parse(JSON.stringify(o)), t, a]);
    const l = (h, c) => this._request(h, c), d = (h, c) => this._protocol.listen(h, c);
    this._lazyProxy = new Promise(((h, c) => {
      s = c, this._onModuleLoaded.then(((u) => {
        h((function(g, p, f) {
          const _ = (C) => function() {
            const w = Array.prototype.slice.call(arguments, 0);
            return p(C, w);
          }, v = (C) => function(w) {
            return f(C, w);
          }, b = {};
          for (const C of g) PO(C) ? b[C] = v(C) : AO(C) ? b[C] = f(C, void 0) : b[C] = _(C);
          return b;
        })(u, l, d));
      }), ((u) => {
        c(u), this._onError("Worker failed to load " + t, u);
      }));
    }));
  }
  getProxyObject() {
    return this._lazyProxy;
  }
  _request(e, t) {
    return new Promise(((i, s) => {
      this._onModuleLoaded.then((() => {
        this._protocol.sendMessage(e, t).then(i, s);
      }), s);
    }));
  }
  _onError(e, t) {
    console.error(e), console.info(t);
  }
}
function AO(n) {
  return n[0] === "o" && n[1] === "n" && Ba(n.charCodeAt(2));
}
function PO(n) {
  return /^onDynamic/.test(n) && Ba(n.charCodeAt(9));
}
function Hd(n, e) {
  var t;
  const i = globalThis.MonacoEnvironment;
  if (i?.createTrustedTypesPolicy) try {
    return i.createTrustedTypesPolicy(n, e);
  } catch (s) {
    return void We(s);
  }
  try {
    return (t = It.trustedTypes) === null || t === void 0 ? void 0 : t.createPolicy(n, e);
  } catch (s) {
    return void We(s);
  }
}
const OO = Hd("defaultWorkerFactory", { createScriptURL: (n) => n });
class Kj extends V {
  constructor(e, t, i, s, o) {
    super(), this.id = t, this.label = i;
    const r = (function(a) {
      const l = globalThis.MonacoEnvironment;
      if (l) {
        if (typeof l.getWorker == "function") return l.getWorker("workerMain.js", a);
        if (typeof l.getWorkerUrl == "function") {
          const d = l.getWorkerUrl("workerMain.js", a);
          return new Worker(OO ? OO.createScriptURL(d) : d, { name: a });
        }
      }
      throw new Error("You must define a function MonacoEnvironment.getWorkerUrl or MonacoEnvironment.getWorker");
    })(i);
    typeof r.then == "function" ? this.worker = r : this.worker = Promise.resolve(r), this.postMessage(e, []), this.worker.then(((a) => {
      a.onmessage = function(l) {
        s(l.data);
      }, a.onmessageerror = o, typeof a.addEventListener == "function" && a.addEventListener("error", o);
    })), this._register(ye((() => {
      var a;
      (a = this.worker) === null || a === void 0 || a.then(((l) => {
        l.onmessage = null, l.onmessageerror = null, l.removeEventListener("error", o), l.terminate();
      })), this.worker = null;
    })));
  }
  getId() {
    return this.id;
  }
  postMessage(e, t) {
    var i;
    (i = this.worker) === null || i === void 0 || i.then(((s) => {
      try {
        s.postMessage(e, t);
      } catch (o) {
        We(o), We(new Error(`FAILED to post message to '${this.label}'-worker`, { cause: o }));
      }
    }));
  }
}
class JS {
  constructor(e) {
    this._label = e, this._webWorkerFailedBeforeError = !1;
  }
  create(e, t, i) {
    const s = ++JS.LAST_WORKER_ID;
    if (this._webWorkerFailedBeforeError) throw this._webWorkerFailedBeforeError;
    return new Kj(e, s, this._label || "anonymous" + s, t, ((o) => {
      PE(o), this._webWorkerFailedBeforeError = o, i(o);
    }));
  }
}
var Oi;
JS.LAST_WORKER_ID = 0, (function(n) {
  n[n.None = 0] = "None", n[n.Indent = 1] = "Indent", n[n.IndentOutdent = 2] = "IndentOutdent", n[n.Outdent = 3] = "Outdent";
})(Oi || (Oi = {}));
class Qk {
  constructor(e) {
    if (this._neutralCharacter = null, this._neutralCharacterSearched = !1, this.open = e.open, this.close = e.close, this._inString = !0, this._inComment = !0, this._inRegEx = !0, Array.isArray(e.notIn)) for (let t = 0, i = e.notIn.length; t < i; t++)
      switch (e.notIn[t]) {
        case "string":
          this._inString = !1;
          break;
        case "comment":
          this._inComment = !1;
          break;
        case "regex":
          this._inRegEx = !1;
      }
  }
  isOK(e) {
    switch (e) {
      case 0:
        return !0;
      case 1:
        return this._inComment;
      case 2:
        return this._inString;
      case 3:
        return this._inRegEx;
    }
  }
  shouldAutoClose(e, t) {
    if (e.getTokenCount() === 0) return !0;
    const i = e.findTokenIndexAtOffset(t - 2), s = e.getStandardTokenType(i);
    return this.isOK(s);
  }
  _findNeutralCharacterInRange(e, t) {
    for (let i = e; i <= t; i++) {
      const s = String.fromCharCode(i);
      if (!this.open.includes(s) && !this.close.includes(s)) return s;
    }
    return null;
  }
  findNeutralCharacter() {
    return this._neutralCharacterSearched || (this._neutralCharacterSearched = !0, this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(48, 57)), this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(97, 122)), this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(65, 90))), this._neutralCharacter;
  }
}
class jj {
  constructor(e) {
    this.autoClosingPairsOpenByStart = /* @__PURE__ */ new Map(), this.autoClosingPairsOpenByEnd = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseByStart = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseByEnd = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseSingleChar = /* @__PURE__ */ new Map();
    for (const t of e) If(this.autoClosingPairsOpenByStart, t.open.charAt(0), t), If(this.autoClosingPairsOpenByEnd, t.open.charAt(t.open.length - 1), t), If(this.autoClosingPairsCloseByStart, t.close.charAt(0), t), If(this.autoClosingPairsCloseByEnd, t.close.charAt(t.close.length - 1), t), t.close.length === 1 && t.open.length === 1 && If(this.autoClosingPairsCloseSingleChar, t.close, t);
  }
}
function If(n, e, t) {
  n.has(e) ? n.get(e).push(t) : n.set(e, [t]);
}
function $w(n, e) {
  const t = n.getCount(), i = n.findTokenIndexAtOffset(e), s = n.getLanguageId(i);
  let o = i;
  for (; o + 1 < t && n.getLanguageId(o + 1) === s; ) o++;
  let r = i;
  for (; r > 0 && n.getLanguageId(r - 1) === s; ) r--;
  return new qj(n, s, r, o + 1, n.getStartOffset(r), n.getEndOffset(o));
}
class qj {
  constructor(e, t, i, s, o, r) {
    this._scopedLineTokensBrand = void 0, this._actual = e, this.languageId = t, this._firstTokenIndex = i, this._lastTokenIndex = s, this.firstCharOffset = o, this._lastCharOffset = r;
  }
  getLineContent() {
    return this._actual.getLineContent().substring(this.firstCharOffset, this._lastCharOffset);
  }
  getActualLineContentBefore(e) {
    return this._actual.getLineContent().substring(0, this.firstCharOffset + e);
  }
  getTokenCount() {
    return this._lastTokenIndex - this._firstTokenIndex;
  }
  findTokenIndexAtOffset(e) {
    return this._actual.findTokenIndexAtOffset(e + this.firstCharOffset) - this._firstTokenIndex;
  }
  getStandardTokenType(e) {
    return this._actual.getStandardTokenType(e + this._firstTokenIndex);
  }
}
function Ia(n) {
  return !!(3 & n);
}
class Fm {
  constructor(e) {
    if (e.autoClosingPairs ? this._autoClosingPairs = e.autoClosingPairs.map(((t) => new Qk(t))) : e.brackets ? this._autoClosingPairs = e.brackets.map(((t) => new Qk({ open: t[0], close: t[1] }))) : this._autoClosingPairs = [], e.__electricCharacterSupport && e.__electricCharacterSupport.docComment) {
      const t = e.__electricCharacterSupport.docComment;
      this._autoClosingPairs.push(new Qk({ open: t.open, close: t.close || "" }));
    }
    this._autoCloseBeforeForQuotes = typeof e.autoCloseBefore == "string" ? e.autoCloseBefore : Fm.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES, this._autoCloseBeforeForBrackets = typeof e.autoCloseBefore == "string" ? e.autoCloseBefore : Fm.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS, this._surroundingPairs = e.surroundingPairs || this._autoClosingPairs;
  }
  getAutoClosingPairs() {
    return this._autoClosingPairs;
  }
  getAutoCloseBeforeSet(e) {
    return e ? this._autoCloseBeforeForQuotes : this._autoCloseBeforeForBrackets;
  }
  getSurroundingPairs() {
    return this._surroundingPairs;
  }
}
Fm.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES = `;:.,=}])> 
	`, Fm.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS = `'"\`;:.,=}])> 
	`;
const FO = typeof Buffer < "u";
let Jk, eD, tD, iD;
class eL {
  static wrap(e) {
    return FO && !Buffer.isBuffer(e) && (e = Buffer.from(e.buffer, e.byteOffset, e.byteLength)), new eL(e);
  }
  constructor(e) {
    this.buffer = e, this.byteLength = this.buffer.byteLength;
  }
  toString() {
    return FO ? this.buffer.toString() : (Jk || (Jk = new TextDecoder()), Jk.decode(this.buffer));
  }
}
function $j(n, e) {
  return (n[e + 0] | 0) >>> 0 | n[e + 1] << 8 >>> 0;
}
function Gj(n, e, t) {
  n[t + 0] = 255 & e, e >>>= 8, n[t + 1] = 255 & e;
}
function Vr(n, e) {
  return n[e] * 2 ** 24 + 65536 * n[e + 1] + 256 * n[e + 2] + n[e + 3];
}
function Hr(n, e, t) {
  n[t + 3] = e, e >>>= 8, n[t + 2] = e, e >>>= 8, n[t + 1] = e, e >>>= 8, n[t] = e;
}
function BO(n, e) {
  return n[e];
}
function WO(n, e, t) {
  n[t] = e;
}
function F8() {
  return eD || (eD = new TextDecoder("UTF-16LE")), eD;
}
function B8() {
  return iD || (iD = L7() ? F8() : (tD || (tD = new TextDecoder("UTF-16BE")), tD)), iD;
}
function Zj(n, e, t) {
  const i = new Uint16Array(n.buffer, e, t);
  return t > 0 && (i[0] === 65279 || i[0] === 65534) ? (function(s, o, r) {
    const a = [];
    let l = 0;
    for (let d = 0; d < r; d++) {
      const h = $j(s, o);
      o += 2, a[l++] = String.fromCharCode(h);
    }
    return a.join("");
  })(n, e, t) : F8().decode(i);
}
class pf {
  constructor(e) {
    this._capacity = 0 | e, this._buffer = new Uint16Array(this._capacity), this._completedStrings = null, this._bufferLength = 0;
  }
  reset() {
    this._completedStrings = null, this._bufferLength = 0;
  }
  build() {
    return this._completedStrings !== null ? (this._flushBuffer(), this._completedStrings.join("")) : this._buildBuffer();
  }
  _buildBuffer() {
    if (this._bufferLength === 0) return "";
    const e = new Uint16Array(this._buffer.buffer, 0, this._bufferLength);
    return B8().decode(e);
  }
  _flushBuffer() {
    const e = this._buildBuffer();
    this._bufferLength = 0, this._completedStrings === null ? this._completedStrings = [e] : this._completedStrings[this._completedStrings.length] = e;
  }
  appendCharCode(e) {
    const t = this._capacity - this._bufferLength;
    t <= 1 && (t === 0 || en(e)) && this._flushBuffer(), this._buffer[this._bufferLength++] = e;
  }
  appendASCIICharCode(e) {
    this._bufferLength === this._capacity && this._flushBuffer(), this._buffer[this._bufferLength++] = e;
  }
  appendString(e) {
    const t = e.length;
    if (this._bufferLength + t >= this._capacity) return this._flushBuffer(), void (this._completedStrings[this._completedStrings.length] = e);
    for (let i = 0; i < t; i++) this._buffer[this._bufferLength++] = e.charCodeAt(i);
  }
}
class Gw {
  constructor(e, t, i, s, o, r) {
    this._richEditBracketBrand = void 0, this.languageId = e, this.index = t, this.open = i, this.close = s, this.forwardRegex = o, this.reversedRegex = r, this._openSet = Gw._toSet(this.open), this._closeSet = Gw._toSet(this.close);
  }
  isOpen(e) {
    return this._openSet.has(e);
  }
  isClose(e) {
    return this._closeSet.has(e);
  }
  static _toSet(e) {
    const t = /* @__PURE__ */ new Set();
    for (const i of e) t.add(i);
    return t;
  }
}
class Yj {
  constructor(e, t) {
    this._richEditBracketsBrand = void 0;
    const i = (function(s) {
      const o = s.length;
      s = s.map(((h) => [h[0].toLowerCase(), h[1].toLowerCase()]));
      const r = [];
      for (let h = 0; h < o; h++) r[h] = h;
      const a = (h, c) => {
        const [u, g] = h, [p, f] = c;
        return u === p || u === f || g === p || g === f;
      }, l = (h, c) => {
        const u = Math.min(h, c), g = Math.max(h, c);
        for (let p = 0; p < o; p++) r[p] === g && (r[p] = u);
      };
      for (let h = 0; h < o; h++) {
        const c = s[h];
        for (let u = h + 1; u < o; u++) a(c, s[u]) && l(r[h], r[u]);
      }
      const d = [];
      for (let h = 0; h < o; h++) {
        const c = [], u = [];
        for (let g = 0; g < o; g++) if (r[g] === h) {
          const [p, f] = s[g];
          c.push(p), u.push(f);
        }
        c.length > 0 && d.push({ open: c, close: u });
      }
      return d;
    })(t);
    this.brackets = i.map(((s, o) => new Gw(e, o, s.open, s.close, (function(r, a, l, d) {
      let h = [];
      h = h.concat(r), h = h.concat(a);
      for (let c = 0, u = h.length; c < u; c++) VO(h[c], l, d, h);
      return h = eb(h), h.sort(HO), h.reverse(), tb(h);
    })(s.open, s.close, i, o), (function(r, a, l, d) {
      let h = [];
      h = h.concat(r), h = h.concat(a);
      for (let c = 0, u = h.length; c < u; c++) VO(h[c], l, d, h);
      return h = eb(h), h.sort(HO), h.reverse(), tb(h.map(OE));
    })(s.open, s.close, i, o)))), this.forwardRegex = (function(s) {
      let o = [];
      for (const r of s) {
        for (const a of r.open) o.push(a);
        for (const a of r.close) o.push(a);
      }
      return o = eb(o), tb(o);
    })(this.brackets), this.reversedRegex = (function(s) {
      let o = [];
      for (const r of s) {
        for (const a of r.open) o.push(a);
        for (const a of r.close) o.push(a);
      }
      return o = eb(o), tb(o.map(OE));
    })(this.brackets), this.textIsBracket = {}, this.textIsOpenBracket = {}, this.maxBracketLength = 0;
    for (const s of this.brackets) {
      for (const o of s.open) this.textIsBracket[o] = s, this.textIsOpenBracket[o] = !0, this.maxBracketLength = Math.max(this.maxBracketLength, o.length);
      for (const o of s.close) this.textIsBracket[o] = s, this.textIsOpenBracket[o] = !1, this.maxBracketLength = Math.max(this.maxBracketLength, o.length);
    }
  }
}
function VO(n, e, t, i) {
  for (let s = 0, o = e.length; s < o; s++) {
    if (s === t) continue;
    const r = e[s];
    for (const a of r.open) a.indexOf(n) >= 0 && i.push(a);
    for (const a of r.close) a.indexOf(n) >= 0 && i.push(a);
  }
}
function HO(n, e) {
  return n.length - e.length;
}
function eb(n) {
  if (n.length <= 1) return n;
  const e = [], t = /* @__PURE__ */ new Set();
  for (const i of n) t.has(i) || (e.push(i), t.add(i));
  return e;
}
function Xj(n) {
  const e = /^[\w ]+$/.test(n);
  return n = No(n), e ? `\\b${n}\\b` : n;
}
function tb(n) {
  return Q7(`(${n.map(Xj).join(")|(")})`, !0);
}
const OE = /* @__PURE__ */ (function() {
  let n = null, e = null;
  return function(t) {
    return n !== t && (n = t, e = (function(i) {
      const s = new Uint16Array(i.length);
      let o = 0;
      for (let r = i.length - 1; r >= 0; r--) s[o++] = i.charCodeAt(r);
      return B8().decode(s);
    })(n)), e;
  };
})();
class hr {
  static _findPrevBracketInText(e, t, i, s) {
    const o = i.match(e);
    if (!o) return null;
    const r = i.length - (o.index || 0), a = o[0].length, l = s + r;
    return new D(t, l - a + 1, t, l + 1);
  }
  static findPrevBracketInRange(e, t, i, s, o) {
    const r = OE(i).substring(i.length - o, i.length - s);
    return this._findPrevBracketInText(e, t, r, s);
  }
  static findNextBracketInText(e, t, i, s) {
    const o = i.match(e);
    if (!o) return null;
    const r = o.index || 0, a = o[0].length;
    if (a === 0) return null;
    const l = s + r;
    return new D(t, l + 1, t, l + 1 + a);
  }
  static findNextBracketInRange(e, t, i, s, o) {
    const r = i.substring(s, o);
    return this.findNextBracketInText(e, t, r, s);
  }
}
class Qj {
  constructor(e) {
    this._richEditBrackets = e;
  }
  getElectricCharacters() {
    const e = [];
    if (this._richEditBrackets) for (const t of this._richEditBrackets.brackets) for (const i of t.close) {
      const s = i.charAt(i.length - 1);
      e.push(s);
    }
    return Ad(e);
  }
  onElectricCharacter(e, t, i) {
    if (!this._richEditBrackets || this._richEditBrackets.brackets.length === 0) return null;
    const s = t.findTokenIndexAtOffset(i - 1);
    if (Ia(t.getStandardTokenType(s))) return null;
    const o = this._richEditBrackets.reversedRegex, r = t.getLineContent().substring(0, i - 1) + e, a = hr.findPrevBracketInRange(o, 1, r, 0, r.length);
    if (!a) return null;
    const l = r.substring(a.startColumn - 1, a.endColumn - 1).toLowerCase();
    if (this._richEditBrackets.textIsOpenBracket[l]) return null;
    const d = t.getActualLineContentBefore(a.startColumn - 1);
    return /^\s*$/.test(d) ? { matchOpenBracket: l } : null;
  }
}
function ib(n) {
  return n.global && (n.lastIndex = 0), !0;
}
class Jj {
  constructor(e) {
    this._indentationRules = e;
  }
  shouldIncrease(e) {
    return !!(this._indentationRules && this._indentationRules.increaseIndentPattern && ib(this._indentationRules.increaseIndentPattern) && this._indentationRules.increaseIndentPattern.test(e));
  }
  shouldDecrease(e) {
    return !!(this._indentationRules && this._indentationRules.decreaseIndentPattern && ib(this._indentationRules.decreaseIndentPattern) && this._indentationRules.decreaseIndentPattern.test(e));
  }
  shouldIndentNextLine(e) {
    return !!(this._indentationRules && this._indentationRules.indentNextLinePattern && ib(this._indentationRules.indentNextLinePattern) && this._indentationRules.indentNextLinePattern.test(e));
  }
  shouldIgnore(e) {
    return !!(this._indentationRules && this._indentationRules.unIndentedLinePattern && ib(this._indentationRules.unIndentedLinePattern) && this._indentationRules.unIndentedLinePattern.test(e));
  }
  getIndentMetadata(e) {
    let t = 0;
    return this.shouldIncrease(e) && (t += 1), this.shouldDecrease(e) && (t += 2), this.shouldIndentNextLine(e) && (t += 4), this.shouldIgnore(e) && (t += 8), t;
  }
}
class Dp {
  constructor(e) {
    (e = e || {}).brackets = e.brackets || [["(", ")"], ["{", "}"], ["[", "]"]], this._brackets = [], e.brackets.forEach(((t) => {
      const i = Dp._createOpenBracketRegExp(t[0]), s = Dp._createCloseBracketRegExp(t[1]);
      i && s && this._brackets.push({ open: t[0], openRegExp: i, close: t[1], closeRegExp: s });
    })), this._regExpRules = e.onEnterRules || [];
  }
  onEnter(e, t, i, s) {
    if (e >= 3) for (let o = 0, r = this._regExpRules.length; o < r; o++) {
      const a = this._regExpRules[o];
      if ([{ reg: a.beforeText, text: i }, { reg: a.afterText, text: s }, { reg: a.previousLineText, text: t }].every(((l) => !l.reg || (l.reg.lastIndex = 0, l.reg.test(l.text))))) return a.action;
    }
    if (e >= 2 && i.length > 0 && s.length > 0) for (let o = 0, r = this._brackets.length; o < r; o++) {
      const a = this._brackets[o];
      if (a.openRegExp.test(i) && a.closeRegExp.test(s)) return { indentAction: Oi.IndentOutdent };
    }
    if (e >= 2 && i.length > 0) {
      for (let o = 0, r = this._brackets.length; o < r; o++)
        if (this._brackets[o].openRegExp.test(i)) return { indentAction: Oi.Indent };
    }
    return null;
  }
  static _createOpenBracketRegExp(e) {
    let t = No(e);
    return /\B/.test(t.charAt(0)) || (t = "\\b" + t), t += "\\s*$", Dp._safeRegExp(t);
  }
  static _createCloseBracketRegExp(e) {
    let t = No(e);
    return /\B/.test(t.charAt(t.length - 1)) || (t += "\\b"), t = "^\\s*" + t, Dp._safeRegExp(t);
  }
  static _safeRegExp(e) {
    try {
      return new RegExp(e);
    } catch (t) {
      return We(t), null;
    }
  }
}
const Ye = tt("configurationService");
function FE(n, e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const i in n) W8(t, i, n[i], e);
  return t;
}
function W8(n, e, t, i) {
  const s = e.split("."), o = s.pop();
  let r = n;
  for (let a = 0; a < s.length; a++) {
    const l = s[a];
    let d = r[l];
    switch (typeof d) {
      case "undefined":
        d = r[l] = /* @__PURE__ */ Object.create(null);
        break;
      case "object":
        break;
      default:
        return void i(`Ignoring ${e} as ${s.slice(0, a + 1).join(".")} is ${JSON.stringify(d)}`);
    }
    r = d;
  }
  if (typeof r == "object" && r !== null) try {
    r[o] = t;
  } catch {
    i(`Ignoring ${e} as ${s.join(".")} is ${JSON.stringify(r)}`);
  }
  else i(`Ignoring ${e} as ${s.join(".")} is ${JSON.stringify(r)}`);
}
function eq(n, e) {
  V8(n, e.split("."));
}
function V8(n, e) {
  const t = e.shift();
  if (e.length !== 0) {
    if (Object.keys(n).indexOf(t) !== -1) {
      const i = n[t];
      typeof i != "object" || Array.isArray(i) || (V8(i, e), Object.keys(i).length === 0 && delete n[t]);
    }
  } else delete n[t];
}
function zO(n, e, t) {
  const i = (function(s, o) {
    let r = s;
    for (const a of o) {
      if (typeof r != "object" || r === null) return;
      r = r[a];
    }
    return r;
  })(n, e.split("."));
  return i === void 0 ? t : i;
}
const Xt = tt("languageService");
class Wa {
  constructor(e, t = [], i = !1) {
    this.ctor = e, this.staticArguments = t, this.supportsDelayedInstantiation = i;
  }
}
const H8 = [];
function rt(n, e, t) {
  e instanceof Wa || (e = new Wa(e, [], !!t)), H8.push([n, e]);
}
function UO() {
  return H8;
}
const vi = Object.freeze({ text: "text/plain", binary: "application/octet-stream", unknown: "application/unknown", markdown: "text/markdown", latex: "text/latex", uriList: "text/uri-list" }), tL = "base.contributions.json", tq = new class {
  constructor() {
    this._onDidChangeSchema = new F(), this.schemasById = {};
  }
  registerSchema(n, e) {
    var t;
    this.schemasById[t = n, t.length > 0 && t.charAt(t.length - 1) === "#" ? t.substring(0, t.length - 1) : t] = e, this._onDidChangeSchema.fire(n);
  }
  notifySchemaChanged(n) {
    this._onDidChangeSchema.fire(n);
  }
}();
li.add(tL, tq);
const ma = "base.contributions.configuration", nb = "vscode://schemas/settings/resourceLanguage", KO = li.as(tL), z8 = "\\[([^\\]]+)\\]", jO = new RegExp(z8, "g"), yc = new RegExp(`^(${z8})+$`);
function Zw(n) {
  const e = [];
  if (yc.test(n)) {
    let t = jO.exec(n);
    for (; t?.length; ) {
      const i = t[1].trim();
      i && e.push(i), t = jO.exec(n);
    }
  }
  return Ad(e);
}
const IC = new class {
  constructor() {
    this.overrideIdentifiers = /* @__PURE__ */ new Set(), this._onDidSchemaChange = new F(), this._onDidUpdateConfiguration = new F(), this.configurationDefaultsOverrides = /* @__PURE__ */ new Map(), this.defaultLanguageConfigurationOverridesNode = { id: "defaultOverrides", title: m(0, "Default Language Configuration Overrides"), properties: {} }, this.configurationContributors = [this.defaultLanguageConfigurationOverridesNode], this.resourceLanguageSettingsSchema = { properties: {}, patternProperties: {}, additionalProperties: !0, allowTrailingCommas: !0, allowComments: !0 }, this.configurationProperties = {}, this.policyConfigurations = /* @__PURE__ */ new Map(), this.excludedConfigurationProperties = {}, KO.registerSchema(nb, this.resourceLanguageSettingsSchema), this.registerOverridePropertyPatternKey();
  }
  registerConfiguration(n, e = !0) {
    this.registerConfigurations([n], e);
  }
  registerConfigurations(n, e = !0) {
    const t = /* @__PURE__ */ new Set();
    this.doRegisterConfigurations(n, e, t), KO.registerSchema(nb, this.resourceLanguageSettingsSchema), this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire({ properties: t });
  }
  registerDefaultConfigurations(n) {
    const e = /* @__PURE__ */ new Set();
    this.doRegisterDefaultConfigurations(n, e), this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire({ properties: e, defaultsOverrides: !0 });
  }
  doRegisterDefaultConfigurations(n, e) {
    var t;
    const i = [];
    for (const { overrides: s, source: o } of n) for (const r in s) if (e.add(r), yc.test(r)) {
      const a = this.configurationDefaultsOverrides.get(r), l = (t = a?.valuesSources) !== null && t !== void 0 ? t : /* @__PURE__ */ new Map();
      if (o) for (const c of Object.keys(s[r])) l.set(c, o);
      const d = { ...a?.value || {}, ...s[r] };
      this.configurationDefaultsOverrides.set(r, { source: o, value: d, valuesSources: l });
      const h = { type: "object", default: d, description: m(0, "Configure settings to be overridden for the {0} language.", r.replace(/[\[\]]/g, "")), $ref: nb, defaultDefaultValue: d, source: ps(o) ? void 0 : o, defaultValueSource: o };
      i.push(...Zw(r)), this.configurationProperties[r] = h, this.defaultLanguageConfigurationOverridesNode.properties[r] = h;
    } else {
      this.configurationDefaultsOverrides.set(r, { value: s[r], source: o });
      const a = this.configurationProperties[r];
      a && (this.updatePropertyDefaultValue(r, a), this.updateSchema(r, a));
    }
    this.doRegisterOverrideIdentifiers(i);
  }
  registerOverrideIdentifiers(n) {
    this.doRegisterOverrideIdentifiers(n), this._onDidSchemaChange.fire();
  }
  doRegisterOverrideIdentifiers(n) {
    for (const e of n) this.overrideIdentifiers.add(e);
    this.updateOverridePropertyPatternKey();
  }
  doRegisterConfigurations(n, e, t) {
    n.forEach(((i) => {
      this.validateAndRegisterProperties(i, e, i.extensionInfo, i.restrictedProperties, void 0, t), this.configurationContributors.push(i), this.registerJSONConfiguration(i);
    }));
  }
  validateAndRegisterProperties(n, e = !0, t, i, s = 3, o) {
    var r;
    s = mo(n.scope) ? s : n.scope;
    const a = n.properties;
    if (a) for (const d in a) {
      const h = a[d];
      e && iq(d, h) ? delete a[d] : (h.source = t, h.defaultDefaultValue = a[d].default, this.updatePropertyDefaultValue(d, h), yc.test(d) ? h.scope = void 0 : (h.scope = mo(h.scope) ? s : h.scope, h.restricted = mo(h.restricted) ? !!i?.includes(d) : h.restricted), !a[d].hasOwnProperty("included") || a[d].included ? (this.configurationProperties[d] = a[d], !((r = a[d].policy) === null || r === void 0) && r.name && this.policyConfigurations.set(a[d].policy.name, d), !a[d].deprecationMessage && a[d].markdownDeprecationMessage && (a[d].deprecationMessage = a[d].markdownDeprecationMessage), o.add(d)) : (this.excludedConfigurationProperties[d] = a[d], delete a[d]));
    }
    const l = n.allOf;
    if (l) for (const d of l) this.validateAndRegisterProperties(d, e, t, i, s, o);
  }
  getConfigurationProperties() {
    return this.configurationProperties;
  }
  getPolicyConfigurations() {
    return this.policyConfigurations;
  }
  registerJSONConfiguration(n) {
    const e = (t) => {
      const i = t.properties;
      if (i) for (const o in i) this.updateSchema(o, i[o]);
      const s = t.allOf;
      s?.forEach(e);
    };
    e(n);
  }
  updateSchema(n, e) {
    switch (e.scope) {
      case 1:
      case 2:
      case 6:
      case 3:
      case 4:
        break;
      case 5:
        this.resourceLanguageSettingsSchema.properties[n] = e;
    }
  }
  updateOverridePropertyPatternKey() {
    for (const n of this.overrideIdentifiers.values()) {
      const e = `[${n}]`, t = { type: "object", description: m(0, "Configure editor settings to be overridden for a language."), errorMessage: m(0, "This setting does not support per-language configuration."), $ref: nb };
      this.updatePropertyDefaultValue(e, t);
    }
  }
  registerOverridePropertyPatternKey() {
    m(0, "Configure editor settings to be overridden for a language."), m(0, "This setting does not support per-language configuration."), this._onDidSchemaChange.fire();
  }
  updatePropertyDefaultValue(n, e) {
    const t = this.configurationDefaultsOverrides.get(n);
    let i = t?.value, s = t?.source;
    $s(i) && (i = e.defaultDefaultValue, s = void 0), $s(i) && (i = (function(o) {
      switch (Array.isArray(o) ? o[0] : o) {
        case "boolean":
          return !1;
        case "integer":
        case "number":
          return 0;
        case "string":
          return "";
        case "array":
          return [];
        case "object":
          return {};
        default:
          return null;
      }
    })(e.type)), e.default = i, e.defaultValueSource = s;
  }
}();
function iq(n, e) {
  var t, i, s, o;
  return n.trim() ? yc.test(n) ? m(0, "Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.", n) : IC.getConfigurationProperties()[n] !== void 0 ? m(0, "Cannot register '{0}'. This property is already registered.", n) : !((t = e.policy) === null || t === void 0) && t.name && IC.getPolicyConfigurations().get((i = e.policy) === null || i === void 0 ? void 0 : i.name) !== void 0 ? m(0, "Cannot register '{0}'. The associated policy {1} is already registered with {2}.", n, (s = e.policy) === null || s === void 0 ? void 0 : s.name, IC.getPolicyConfigurations().get((o = e.policy) === null || o === void 0 ? void 0 : o.name)) : null : m(0, "Cannot register an empty property");
}
li.add(ma, IC);
const Bm = new class {
  constructor() {
    this._onDidChangeLanguages = new F(), this.onDidChangeLanguages = this._onDidChangeLanguages.event, this._languages = [];
  }
  registerLanguage(n) {
    return this._languages.push(n), this._onDidChangeLanguages.fire(void 0), { dispose: () => {
      for (let e = 0, t = this._languages.length; e < t; e++) if (this._languages[e] === n) return void this._languages.splice(e, 1);
    } };
  }
  getLanguages() {
    return this._languages;
  }
}();
li.add("editor.modesRegistry", Bm);
const ko = "plaintext";
Bm.registerLanguage({ id: ko, extensions: [".txt"], aliases: [m(0, "Plain Text"), "text"], mimetypes: [vi.text] }), li.as(ma).registerDefaultConfigurations([{ overrides: { "[plaintext]": { "editor.unicodeHighlight.ambiguousCharacters": !1, "editor.unicodeHighlight.invisibleCharacters": !1 } } }]);
class nq {
  constructor(e, t) {
    this.languageId = e;
    const i = t.brackets ? qO(t.brackets) : [], s = new rO(((a) => {
      const l = /* @__PURE__ */ new Set();
      return { info: new sq(this, a, l), closing: l };
    })), o = new rO(((a) => {
      const l = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set();
      return { info: new oq(this, a, l, d), opening: l, openingColorized: d };
    }));
    for (const [a, l] of i) {
      const d = s.get(a), h = o.get(l);
      d.closing.add(h.info), h.opening.add(d.info);
    }
    const r = t.colorizedBracketPairs ? qO(t.colorizedBracketPairs) : i.filter(((a) => !(a[0] === "<" && a[1] === ">")));
    for (const [a, l] of r) {
      const d = s.get(a), h = o.get(l);
      d.closing.add(h.info), h.openingColorized.add(d.info), h.opening.add(d.info);
    }
    this._openingBrackets = new Map([...s.cachedValues].map((([a, l]) => [a, l.info]))), this._closingBrackets = new Map([...o.cachedValues].map((([a, l]) => [a, l.info])));
  }
  get openingBrackets() {
    return [...this._openingBrackets.values()];
  }
  get closingBrackets() {
    return [...this._closingBrackets.values()];
  }
  getOpeningBracketInfo(e) {
    return this._openingBrackets.get(e);
  }
  getClosingBracketInfo(e) {
    return this._closingBrackets.get(e);
  }
  getBracketInfo(e) {
    return this.getOpeningBracketInfo(e) || this.getClosingBracketInfo(e);
  }
}
function qO(n) {
  return n.filter((([e, t]) => e !== "" && t !== ""));
}
class U8 {
  constructor(e, t) {
    this.config = e, this.bracketText = t;
  }
  get languageId() {
    return this.config.languageId;
  }
}
class sq extends U8 {
  constructor(e, t, i) {
    super(e, t), this.openedBrackets = i, this.isOpeningBracket = !0;
  }
}
class oq extends U8 {
  constructor(e, t, i, s) {
    super(e, t), this.openingBrackets = i, this.openingColorizedBrackets = s, this.isOpeningBracket = !1;
  }
  closes(e) {
    return e.config === this.config && this.openingBrackets.has(e);
  }
  closesColorized(e) {
    return e.config === this.config && this.openingColorizedBrackets.has(e);
  }
  getOpeningBrackets() {
    return [...this.openingBrackets];
  }
}
var rq = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, $O = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class nD {
  constructor(e) {
    this.languageId = e;
  }
  affects(e) {
    return !this.languageId || this.languageId === e;
  }
}
const zt = tt("languageConfigurationService");
let BE = class extends V {
  constructor(n, e) {
    super(), this.configurationService = n, this.languageService = e, this._registry = this._register(new lq()), this.onDidChangeEmitter = this._register(new F()), this.onDidChange = this.onDidChangeEmitter.event, this.configurations = /* @__PURE__ */ new Map();
    const t = new Set(Object.values(sD));
    this._register(this.configurationService.onDidChangeConfiguration(((i) => {
      const s = i.change.keys.some(((r) => t.has(r))), o = i.change.overrides.filter((([r, a]) => a.some(((l) => t.has(l))))).map((([r]) => r));
      if (s) this.configurations.clear(), this.onDidChangeEmitter.fire(new nD(void 0));
      else for (const r of o) this.languageService.isRegisteredLanguageId(r) && (this.configurations.delete(r), this.onDidChangeEmitter.fire(new nD(r)));
    }))), this._register(this._registry.onDidChange(((i) => {
      this.configurations.delete(i.languageId), this.onDidChangeEmitter.fire(new nD(i.languageId));
    })));
  }
  register(n, e, t) {
    return this._registry.register(n, e, t);
  }
  getLanguageConfiguration(n) {
    let e = this.configurations.get(n);
    return e || (e = (function(t, i, s, o) {
      let r = i.getLanguageConfiguration(t);
      if (!r) {
        if (!o.isRegisteredLanguageId(t)) return new Jp(t, {});
        r = new Jp(t, {});
      }
      const a = (function(d, h) {
        const c = h.getValue(sD.brackets, { overrideIdentifier: d }), u = h.getValue(sD.colorizedBracketPairs, { overrideIdentifier: d });
        return { brackets: GO(c), colorizedBracketPairs: GO(u) };
      })(r.languageId, s), l = j8([r.underlyingConfig, a]);
      return new Jp(r.languageId, l);
    })(n, this._registry, this.configurationService, this.languageService), this.configurations.set(n, e)), e;
  }
};
BE = rq([$O(0, Ye), $O(1, Xt)], BE);
const sD = { brackets: "editor.language.brackets", colorizedBracketPairs: "editor.language.colorizedBracketPairs" };
function GO(n) {
  if (Array.isArray(n)) return n.map(((e) => {
    if (Array.isArray(e) && e.length === 2) return [e[0], e[1]];
  })).filter(((e) => !!e));
}
function K8(n, e, t) {
  let i = Wt(n.getLineContent(e));
  return i.length > t - 1 && (i = i.substring(0, t - 1)), i;
}
function Qp(n, e, t) {
  return n.tokenization.forceTokenization(e), $w(n.tokenization.getLineTokens(e), t === void 0 ? n.getLineMaxColumn(e) - 1 : t - 1);
}
class aq {
  constructor(e) {
    this.languageId = e, this._resolved = null, this._entries = [], this._order = 0, this._resolved = null;
  }
  register(e, t) {
    const i = new ZO(e, t, ++this._order);
    return this._entries.push(i), this._resolved = null, ye((() => {
      for (let s = 0; s < this._entries.length; s++) if (this._entries[s] === i) {
        this._entries.splice(s, 1), this._resolved = null;
        break;
      }
    }));
  }
  getResolvedConfiguration() {
    if (!this._resolved) {
      const e = this._resolve();
      e && (this._resolved = new Jp(this.languageId, e));
    }
    return this._resolved;
  }
  _resolve() {
    return this._entries.length === 0 ? null : (this._entries.sort(ZO.cmp), j8(this._entries.map(((e) => e.configuration))));
  }
}
function j8(n) {
  let e = { comments: void 0, brackets: void 0, wordPattern: void 0, indentationRules: void 0, onEnterRules: void 0, autoClosingPairs: void 0, surroundingPairs: void 0, autoCloseBefore: void 0, folding: void 0, colorizedBracketPairs: void 0, __electricCharacterSupport: void 0 };
  for (const t of n) e = { comments: t.comments || e.comments, brackets: t.brackets || e.brackets, wordPattern: t.wordPattern || e.wordPattern, indentationRules: t.indentationRules || e.indentationRules, onEnterRules: t.onEnterRules || e.onEnterRules, autoClosingPairs: t.autoClosingPairs || e.autoClosingPairs, surroundingPairs: t.surroundingPairs || e.surroundingPairs, autoCloseBefore: t.autoCloseBefore || e.autoCloseBefore, folding: t.folding || e.folding, colorizedBracketPairs: t.colorizedBracketPairs || e.colorizedBracketPairs, __electricCharacterSupport: t.__electricCharacterSupport || e.__electricCharacterSupport };
  return e;
}
class ZO {
  constructor(e, t, i) {
    this.configuration = e, this.priority = t, this.order = i;
  }
  static cmp(e, t) {
    return e.priority === t.priority ? e.order - t.order : e.priority - t.priority;
  }
}
class YO {
  constructor(e) {
    this.languageId = e;
  }
}
class lq extends V {
  constructor() {
    super(), this._entries = /* @__PURE__ */ new Map(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._register(this.register(ko, { brackets: [["(", ")"], ["[", "]"], ["{", "}"]], surroundingPairs: [{ open: "{", close: "}" }, { open: "[", close: "]" }, { open: "(", close: ")" }, { open: "<", close: ">" }, { open: '"', close: '"' }, { open: "'", close: "'" }, { open: "`", close: "`" }], colorizedBracketPairs: [], folding: { offSide: !0 } }, 0));
  }
  register(e, t, i = 0) {
    let s = this._entries.get(e);
    s || (s = new aq(e), this._entries.set(e, s));
    const o = s.register(t, i);
    return this._onDidChange.fire(new YO(e)), ye((() => {
      o.dispose(), this._onDidChange.fire(new YO(e));
    }));
  }
  getLanguageConfiguration(e) {
    const t = this._entries.get(e);
    return t?.getResolvedConfiguration() || null;
  }
}
class Jp {
  constructor(e, t) {
    this.languageId = e, this.underlyingConfig = t, this._brackets = null, this._electricCharacter = null, this._onEnterSupport = this.underlyingConfig.brackets || this.underlyingConfig.indentationRules || this.underlyingConfig.onEnterRules ? new Dp(this.underlyingConfig) : null, this.comments = Jp._handleComments(this.underlyingConfig), this.characterPair = new Fm(this.underlyingConfig), this.wordDefinition = this.underlyingConfig.wordPattern || $T, this.indentationRules = this.underlyingConfig.indentationRules, this.underlyingConfig.indentationRules ? this.indentRulesSupport = new Jj(this.underlyingConfig.indentationRules) : this.indentRulesSupport = null, this.foldingRules = this.underlyingConfig.folding || {}, this.bracketsNew = new nq(e, this.underlyingConfig);
  }
  getWordDefinition() {
    return GT(this.wordDefinition);
  }
  get brackets() {
    return !this._brackets && this.underlyingConfig.brackets && (this._brackets = new Yj(this.languageId, this.underlyingConfig.brackets)), this._brackets;
  }
  get electricCharacter() {
    return this._electricCharacter || (this._electricCharacter = new Qj(this.brackets)), this._electricCharacter;
  }
  onEnter(e, t, i, s) {
    return this._onEnterSupport ? this._onEnterSupport.onEnter(e, t, i, s) : null;
  }
  getAutoClosingPairs() {
    return new jj(this.characterPair.getAutoClosingPairs());
  }
  getAutoCloseBeforeSet(e) {
    return this.characterPair.getAutoCloseBeforeSet(e);
  }
  getSurroundingPairs() {
    return this.characterPair.getSurroundingPairs();
  }
  static _handleComments(e) {
    const t = e.comments;
    if (!t) return null;
    const i = {};
    if (t.lineComment && (i.lineCommentToken = t.lineComment), t.blockComment) {
      const [s, o] = t.blockComment;
      i.blockCommentStartToken = s, i.blockCommentEndToken = o;
    }
    return i;
  }
}
rt(zt, BE, 1);
class nh {
  constructor(e, t, i, s) {
    this.originalStart = e, this.originalLength = t, this.modifiedStart = i, this.modifiedLength = s;
  }
  getOriginalEnd() {
    return this.originalStart + this.originalLength;
  }
  getModifiedEnd() {
    return this.modifiedStart + this.modifiedLength;
  }
}
class XO {
  constructor(e) {
    this.source = e;
  }
  getElements() {
    const e = this.source, t = new Int32Array(e.length);
    for (let i = 0, s = e.length; i < s; i++) t[i] = e.charCodeAt(i);
    return t;
  }
}
function dq(n, e, t) {
  return new qa(new XO(n), new XO(e)).ComputeDiff(t).changes;
}
class Hg {
  static Assert(e, t) {
    if (!e) throw new Error(t);
  }
}
class zg {
  static Copy(e, t, i, s, o) {
    for (let r = 0; r < o; r++) i[s + r] = e[t + r];
  }
  static Copy2(e, t, i, s, o) {
    for (let r = 0; r < o; r++) i[s + r] = e[t + r];
  }
}
class QO {
  constructor() {
    this.m_changes = [], this.m_originalStart = 1073741824, this.m_modifiedStart = 1073741824, this.m_originalCount = 0, this.m_modifiedCount = 0;
  }
  MarkNextChange() {
    (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.m_changes.push(new nh(this.m_originalStart, this.m_originalCount, this.m_modifiedStart, this.m_modifiedCount)), this.m_originalCount = 0, this.m_modifiedCount = 0, this.m_originalStart = 1073741824, this.m_modifiedStart = 1073741824;
  }
  AddOriginalElement(e, t) {
    this.m_originalStart = Math.min(this.m_originalStart, e), this.m_modifiedStart = Math.min(this.m_modifiedStart, t), this.m_originalCount++;
  }
  AddModifiedElement(e, t) {
    this.m_originalStart = Math.min(this.m_originalStart, e), this.m_modifiedStart = Math.min(this.m_modifiedStart, t), this.m_modifiedCount++;
  }
  getChanges() {
    return (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.MarkNextChange(), this.m_changes;
  }
  getReverseChanges() {
    return (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.MarkNextChange(), this.m_changes.reverse(), this.m_changes;
  }
}
class qa {
  constructor(e, t, i = null) {
    this.ContinueProcessingPredicate = i, this._originalSequence = e, this._modifiedSequence = t;
    const [s, o, r] = qa._getElements(e), [a, l, d] = qa._getElements(t);
    this._hasStrings = r && d, this._originalStringElements = s, this._originalElementsOrHash = o, this._modifiedStringElements = a, this._modifiedElementsOrHash = l, this.m_forwardHistory = [], this.m_reverseHistory = [];
  }
  static _isStringArray(e) {
    return e.length > 0 && typeof e[0] == "string";
  }
  static _getElements(e) {
    const t = e.getElements();
    if (qa._isStringArray(t)) {
      const i = new Int32Array(t.length);
      for (let s = 0, o = t.length; s < o; s++) i[s] = EE(t[s], 0);
      return [t, i, !0];
    }
    return t instanceof Int32Array ? [[], t, !1] : [[], new Int32Array(t), !1];
  }
  ElementsAreEqual(e, t) {
    return this._originalElementsOrHash[e] === this._modifiedElementsOrHash[t] && (!this._hasStrings || this._originalStringElements[e] === this._modifiedStringElements[t]);
  }
  ElementsAreStrictEqual(e, t) {
    return this.ElementsAreEqual(e, t) ? qa._getStrictElement(this._originalSequence, e) === qa._getStrictElement(this._modifiedSequence, t) : !1;
  }
  static _getStrictElement(e, t) {
    return typeof e.getStrictElement == "function" ? e.getStrictElement(t) : null;
  }
  OriginalElementsAreEqual(e, t) {
    return this._originalElementsOrHash[e] === this._originalElementsOrHash[t] && (!this._hasStrings || this._originalStringElements[e] === this._originalStringElements[t]);
  }
  ModifiedElementsAreEqual(e, t) {
    return this._modifiedElementsOrHash[e] === this._modifiedElementsOrHash[t] && (!this._hasStrings || this._modifiedStringElements[e] === this._modifiedStringElements[t]);
  }
  ComputeDiff(e) {
    return this._ComputeDiff(0, this._originalElementsOrHash.length - 1, 0, this._modifiedElementsOrHash.length - 1, e);
  }
  _ComputeDiff(e, t, i, s, o) {
    const r = [!1];
    let a = this.ComputeDiffRecursive(e, t, i, s, r);
    return o && (a = this.PrettifyChanges(a)), { quitEarly: r[0], changes: a };
  }
  ComputeDiffRecursive(e, t, i, s, o) {
    for (o[0] = !1; e <= t && i <= s && this.ElementsAreEqual(e, i); ) e++, i++;
    for (; t >= e && s >= i && this.ElementsAreEqual(t, s); ) t--, s--;
    if (e > t || i > s) {
      let c;
      return i <= s ? (Hg.Assert(e === t + 1, "originalStart should only be one more than originalEnd"), c = [new nh(e, 0, i, s - i + 1)]) : e <= t ? (Hg.Assert(i === s + 1, "modifiedStart should only be one more than modifiedEnd"), c = [new nh(e, t - e + 1, i, 0)]) : (Hg.Assert(e === t + 1, "originalStart should only be one more than originalEnd"), Hg.Assert(i === s + 1, "modifiedStart should only be one more than modifiedEnd"), c = []), c;
    }
    const r = [0], a = [0], l = this.ComputeRecursionPoint(e, t, i, s, r, a, o), d = r[0], h = a[0];
    if (l !== null) return l;
    if (!o[0]) {
      const c = this.ComputeDiffRecursive(e, d, i, h, o);
      let u = [];
      return u = o[0] ? [new nh(d + 1, t - (d + 1) + 1, h + 1, s - (h + 1) + 1)] : this.ComputeDiffRecursive(d + 1, t, h + 1, s, o), this.ConcatenateChanges(c, u);
    }
    return [new nh(e, t - e + 1, i, s - i + 1)];
  }
  WALKTRACE(e, t, i, s, o, r, a, l, d, h, c, u, g, p, f, _, v, b) {
    let C = null, w = null, y = new QO(), L = t, k = i, N = g[0] - _[0] - s, A = -1073741824, B = this.m_forwardHistory.length - 1;
    do {
      const T = N + e;
      T === L || T < k && d[T - 1] < d[T + 1] ? (p = (c = d[T + 1]) - N - s, c < A && y.MarkNextChange(), A = c, y.AddModifiedElement(c + 1, p), N = T + 1 - e) : (p = (c = d[T - 1] + 1) - N - s, c < A && y.MarkNextChange(), A = c - 1, y.AddOriginalElement(c, p + 1), N = T - 1 - e), B >= 0 && (e = (d = this.m_forwardHistory[B])[0], L = 1, k = d.length - 1);
    } while (--B >= -1);
    if (C = y.getReverseChanges(), b[0]) {
      let T = g[0] + 1, O = _[0] + 1;
      if (C !== null && C.length > 0) {
        const H = C[C.length - 1];
        T = Math.max(T, H.getOriginalEnd()), O = Math.max(O, H.getModifiedEnd());
      }
      w = [new nh(T, u - T + 1, O, f - O + 1)];
    } else {
      y = new QO(), L = r, k = a, N = g[0] - _[0] - l, A = 1073741824, B = v ? this.m_reverseHistory.length - 1 : this.m_reverseHistory.length - 2;
      do {
        const T = N + o;
        T === L || T < k && h[T - 1] >= h[T + 1] ? (p = (c = h[T + 1] - 1) - N - l, c > A && y.MarkNextChange(), A = c + 1, y.AddOriginalElement(c + 1, p + 1), N = T + 1 - o) : (p = (c = h[T - 1]) - N - l, c > A && y.MarkNextChange(), A = c, y.AddModifiedElement(c + 1, p + 1), N = T - 1 - o), B >= 0 && (o = (h = this.m_reverseHistory[B])[0], L = 1, k = h.length - 1);
      } while (--B >= -1);
      w = y.getChanges();
    }
    return this.ConcatenateChanges(C, w);
  }
  ComputeRecursionPoint(e, t, i, s, o, r, a) {
    let l = 0, d = 0, h = 0, c = 0, u = 0, g = 0;
    e--, i--, o[0] = 0, r[0] = 0, this.m_forwardHistory = [], this.m_reverseHistory = [];
    const p = t - e + (s - i), f = p + 1, _ = new Int32Array(f), v = new Int32Array(f), b = s - i, C = t - e, w = e - i, y = t - s, L = (C - b) % 2 == 0;
    _[b] = e, v[C] = t, a[0] = !1;
    for (let k = 1; k <= p / 2 + 1; k++) {
      let N = 0, A = 0;
      h = this.ClipDiagonalBound(b - k, k, b, f), c = this.ClipDiagonalBound(b + k, k, b, f);
      for (let T = h; T <= c; T += 2) {
        l = T === h || T < c && _[T - 1] < _[T + 1] ? _[T + 1] : _[T - 1] + 1, d = l - (T - b) - w;
        const O = l;
        for (; l < t && d < s && this.ElementsAreEqual(l + 1, d + 1); ) l++, d++;
        if (_[T] = l, l + d > N + A && (N = l, A = d), !L && Math.abs(T - C) <= k - 1 && l >= v[T]) return o[0] = l, r[0] = d, O <= v[T] && k <= 1448 ? this.WALKTRACE(b, h, c, w, C, u, g, y, _, v, l, t, o, d, s, r, L, a) : null;
      }
      const B = (N - e + (A - i) - k) / 2;
      if (this.ContinueProcessingPredicate !== null && !this.ContinueProcessingPredicate(N, B)) return a[0] = !0, o[0] = N, r[0] = A, B > 0 && k <= 1448 ? this.WALKTRACE(b, h, c, w, C, u, g, y, _, v, l, t, o, d, s, r, L, a) : (e++, i++, [new nh(e, t - e + 1, i, s - i + 1)]);
      u = this.ClipDiagonalBound(C - k, k, C, f), g = this.ClipDiagonalBound(C + k, k, C, f);
      for (let T = u; T <= g; T += 2) {
        l = T === u || T < g && v[T - 1] >= v[T + 1] ? v[T + 1] - 1 : v[T - 1], d = l - (T - C) - y;
        const O = l;
        for (; l > e && d > i && this.ElementsAreEqual(l, d); ) l--, d--;
        if (v[T] = l, L && Math.abs(T - b) <= k && l <= _[T]) return o[0] = l, r[0] = d, O >= _[T] && k <= 1448 ? this.WALKTRACE(b, h, c, w, C, u, g, y, _, v, l, t, o, d, s, r, L, a) : null;
      }
      if (k <= 1447) {
        let T = new Int32Array(c - h + 2);
        T[0] = b - h + 1, zg.Copy2(_, h, T, 1, c - h + 1), this.m_forwardHistory.push(T), T = new Int32Array(g - u + 2), T[0] = C - u + 1, zg.Copy2(v, u, T, 1, g - u + 1), this.m_reverseHistory.push(T);
      }
    }
    return this.WALKTRACE(b, h, c, w, C, u, g, y, _, v, l, t, o, d, s, r, L, a);
  }
  PrettifyChanges(e) {
    for (let t = 0; t < e.length; t++) {
      const i = e[t], s = t < e.length - 1 ? e[t + 1].originalStart : this._originalElementsOrHash.length, o = t < e.length - 1 ? e[t + 1].modifiedStart : this._modifiedElementsOrHash.length, r = i.originalLength > 0, a = i.modifiedLength > 0;
      for (; i.originalStart + i.originalLength < s && i.modifiedStart + i.modifiedLength < o && (!r || this.OriginalElementsAreEqual(i.originalStart, i.originalStart + i.originalLength)) && (!a || this.ModifiedElementsAreEqual(i.modifiedStart, i.modifiedStart + i.modifiedLength)); ) {
        const d = this.ElementsAreStrictEqual(i.originalStart, i.modifiedStart);
        if (this.ElementsAreStrictEqual(i.originalStart + i.originalLength, i.modifiedStart + i.modifiedLength) && !d) break;
        i.originalStart++, i.modifiedStart++;
      }
      const l = [null];
      t < e.length - 1 && this.ChangesOverlap(e[t], e[t + 1], l) && (e[t] = l[0], e.splice(t + 1, 1), t--);
    }
    for (let t = e.length - 1; t >= 0; t--) {
      const i = e[t];
      let s = 0, o = 0;
      if (t > 0) {
        const c = e[t - 1];
        s = c.originalStart + c.originalLength, o = c.modifiedStart + c.modifiedLength;
      }
      const r = i.originalLength > 0, a = i.modifiedLength > 0;
      let l = 0, d = this._boundaryScore(i.originalStart, i.originalLength, i.modifiedStart, i.modifiedLength);
      for (let c = 1; ; c++) {
        const u = i.originalStart - c, g = i.modifiedStart - c;
        if (u < s || g < o || r && !this.OriginalElementsAreEqual(u, u + i.originalLength) || a && !this.ModifiedElementsAreEqual(g, g + i.modifiedLength)) break;
        const p = (u === s && g === o ? 5 : 0) + this._boundaryScore(u, i.originalLength, g, i.modifiedLength);
        p > d && (d = p, l = c);
      }
      i.originalStart -= l, i.modifiedStart -= l;
      const h = [null];
      t > 0 && this.ChangesOverlap(e[t - 1], e[t], h) && (e[t - 1] = h[0], e.splice(t, 1), t++);
    }
    if (this._hasStrings) for (let t = 1, i = e.length; t < i; t++) {
      const s = e[t - 1], o = e[t], r = o.originalStart - s.originalStart - s.originalLength, a = s.originalStart, l = o.originalStart + o.originalLength, d = l - a, h = s.modifiedStart, c = o.modifiedStart + o.modifiedLength, u = c - h;
      if (r < 5 && d < 20 && u < 20) {
        const g = this._findBetterContiguousSequence(a, d, h, u, r);
        if (g) {
          const [p, f] = g;
          p === s.originalStart + s.originalLength && f === s.modifiedStart + s.modifiedLength || (s.originalLength = p - s.originalStart, s.modifiedLength = f - s.modifiedStart, o.originalStart = p + r, o.modifiedStart = f + r, o.originalLength = l - o.originalStart, o.modifiedLength = c - o.modifiedStart);
        }
      }
    }
    return e;
  }
  _findBetterContiguousSequence(e, t, i, s, o) {
    if (t < o || s < o) return null;
    const r = e + t - o + 1, a = i + s - o + 1;
    let l = 0, d = 0, h = 0;
    for (let c = e; c < r; c++) for (let u = i; u < a; u++) {
      const g = this._contiguousSequenceScore(c, u, o);
      g > 0 && g > l && (l = g, d = c, h = u);
    }
    return l > 0 ? [d, h] : null;
  }
  _contiguousSequenceScore(e, t, i) {
    let s = 0;
    for (let o = 0; o < i; o++) {
      if (!this.ElementsAreEqual(e + o, t + o)) return 0;
      s += this._originalStringElements[e + o].length;
    }
    return s;
  }
  _OriginalIsBoundary(e) {
    return e <= 0 || e >= this._originalElementsOrHash.length - 1 || this._hasStrings && /^\s*$/.test(this._originalStringElements[e]);
  }
  _OriginalRegionIsBoundary(e, t) {
    if (this._OriginalIsBoundary(e) || this._OriginalIsBoundary(e - 1)) return !0;
    if (t > 0) {
      const i = e + t;
      if (this._OriginalIsBoundary(i - 1) || this._OriginalIsBoundary(i)) return !0;
    }
    return !1;
  }
  _ModifiedIsBoundary(e) {
    return e <= 0 || e >= this._modifiedElementsOrHash.length - 1 || this._hasStrings && /^\s*$/.test(this._modifiedStringElements[e]);
  }
  _ModifiedRegionIsBoundary(e, t) {
    if (this._ModifiedIsBoundary(e) || this._ModifiedIsBoundary(e - 1)) return !0;
    if (t > 0) {
      const i = e + t;
      if (this._ModifiedIsBoundary(i - 1) || this._ModifiedIsBoundary(i)) return !0;
    }
    return !1;
  }
  _boundaryScore(e, t, i, s) {
    return (this._OriginalRegionIsBoundary(e, t) ? 1 : 0) + (this._ModifiedRegionIsBoundary(i, s) ? 1 : 0);
  }
  ConcatenateChanges(e, t) {
    const i = [];
    if (e.length === 0 || t.length === 0) return t.length > 0 ? t : e;
    if (this.ChangesOverlap(e[e.length - 1], t[0], i)) {
      const s = new Array(e.length + t.length - 1);
      return zg.Copy(e, 0, s, 0, e.length - 1), s[e.length - 1] = i[0], zg.Copy(t, 1, s, e.length, t.length - 1), s;
    }
    {
      const s = new Array(e.length + t.length);
      return zg.Copy(e, 0, s, 0, e.length), zg.Copy(t, 0, s, e.length, t.length), s;
    }
  }
  ChangesOverlap(e, t, i) {
    if (Hg.Assert(e.originalStart <= t.originalStart, "Left change is not less than or equal to right change"), Hg.Assert(e.modifiedStart <= t.modifiedStart, "Left change is not less than or equal to right change"), e.originalStart + e.originalLength >= t.originalStart || e.modifiedStart + e.modifiedLength >= t.modifiedStart) {
      const s = e.originalStart;
      let o = e.originalLength;
      const r = e.modifiedStart;
      let a = e.modifiedLength;
      return e.originalStart + e.originalLength >= t.originalStart && (o = t.originalStart + t.originalLength - e.originalStart), e.modifiedStart + e.modifiedLength >= t.modifiedStart && (a = t.modifiedStart + t.modifiedLength - e.modifiedStart), i[0] = new nh(s, o, r, a), !0;
    }
    return i[0] = null, !1;
  }
  ClipDiagonalBound(e, t, i, s) {
    if (e >= 0 && e < s) return e;
    const o = t % 2 == 0;
    return e < 0 ? o === (i % 2 == 0) ? 0 : 1 : o === ((s - i - 1) % 2 == 0) ? s - 1 : s - 2;
  }
}
function Yw(n) {
  return n < 0 ? 0 : n > 255 ? 255 : 0 | n;
}
function Ug(n) {
  return n < 0 ? 0 : n > 4294967295 ? 4294967295 : 0 | n;
}
class hq {
  constructor(e) {
    this.values = e, this.prefixSum = new Uint32Array(e.length), this.prefixSumValidIndex = new Int32Array(1), this.prefixSumValidIndex[0] = -1;
  }
  insertValues(e, t) {
    e = Ug(e);
    const i = this.values, s = this.prefixSum, o = t.length;
    return o !== 0 && (this.values = new Uint32Array(i.length + o), this.values.set(i.subarray(0, e), 0), this.values.set(i.subarray(e), e + o), this.values.set(t, e), e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), this.prefixSum = new Uint32Array(this.values.length), this.prefixSumValidIndex[0] >= 0 && this.prefixSum.set(s.subarray(0, this.prefixSumValidIndex[0] + 1)), !0);
  }
  setValue(e, t) {
    return e = Ug(e), t = Ug(t), this.values[e] !== t && (this.values[e] = t, e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), !0);
  }
  removeValues(e, t) {
    e = Ug(e), t = Ug(t);
    const i = this.values, s = this.prefixSum;
    if (e >= i.length) return !1;
    const o = i.length - e;
    return t >= o && (t = o), t !== 0 && (this.values = new Uint32Array(i.length - t), this.values.set(i.subarray(0, e), 0), this.values.set(i.subarray(e + t), e), this.prefixSum = new Uint32Array(this.values.length), e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), this.prefixSumValidIndex[0] >= 0 && this.prefixSum.set(s.subarray(0, this.prefixSumValidIndex[0] + 1)), !0);
  }
  getTotalSum() {
    return this.values.length === 0 ? 0 : this._getPrefixSum(this.values.length - 1);
  }
  getPrefixSum(e) {
    return e < 0 ? 0 : (e = Ug(e), this._getPrefixSum(e));
  }
  _getPrefixSum(e) {
    if (e <= this.prefixSumValidIndex[0]) return this.prefixSum[e];
    let t = this.prefixSumValidIndex[0] + 1;
    t === 0 && (this.prefixSum[0] = this.values[0], t++), e >= this.values.length && (e = this.values.length - 1);
    for (let i = t; i <= e; i++) this.prefixSum[i] = this.prefixSum[i - 1] + this.values[i];
    return this.prefixSumValidIndex[0] = Math.max(this.prefixSumValidIndex[0], e), this.prefixSum[e];
  }
  getIndexOf(e) {
    e = Math.floor(e), this.getTotalSum();
    let t = 0, i = this.values.length - 1, s = 0, o = 0, r = 0;
    for (; t <= i; ) if (s = t + (i - t) / 2 | 0, o = this.prefixSum[s], r = o - this.values[s], e < r) i = s - 1;
    else {
      if (!(e >= o)) break;
      t = s + 1;
    }
    return new q8(s, e - r);
  }
}
class cq {
  constructor(e) {
    this._values = e, this._isValid = !1, this._validEndIndex = -1, this._prefixSum = [], this._indexBySum = [];
  }
  getTotalSum() {
    return this._ensureValid(), this._indexBySum.length;
  }
  getPrefixSum(e) {
    return this._ensureValid(), e === 0 ? 0 : this._prefixSum[e - 1];
  }
  getIndexOf(e) {
    this._ensureValid();
    const t = this._indexBySum[e], i = t > 0 ? this._prefixSum[t - 1] : 0;
    return new q8(t, e - i);
  }
  removeValues(e, t) {
    this._values.splice(e, t), this._invalidate(e);
  }
  insertValues(e, t) {
    this._values = TS(this._values, e, t), this._invalidate(e);
  }
  _invalidate(e) {
    this._isValid = !1, this._validEndIndex = Math.min(this._validEndIndex, e - 1);
  }
  _ensureValid() {
    if (!this._isValid) {
      for (let e = this._validEndIndex + 1, t = this._values.length; e < t; e++) {
        const i = this._values[e], s = e > 0 ? this._prefixSum[e - 1] : 0;
        this._prefixSum[e] = s + i;
        for (let o = 0; o < i; o++) this._indexBySum[s + o] = e;
      }
      this._prefixSum.length = this._values.length, this._indexBySum.length = this._prefixSum[this._prefixSum.length - 1], this._isValid = !0, this._validEndIndex = this._values.length - 1;
    }
  }
  setValue(e, t) {
    this._values[e] !== t && (this._values[e] = t, this._invalidate(e));
  }
}
class q8 {
  constructor(e, t) {
    this.index = e, this.remainder = t, this._prefixSumIndexOfResultBrand = void 0, this.index = e, this.remainder = t;
  }
}
class uq {
  constructor(e, t, i, s) {
    this._uri = e, this._lines = t, this._eol = i, this._versionId = s, this._lineStarts = null, this._cachedTextValue = null;
  }
  dispose() {
    this._lines.length = 0;
  }
  get version() {
    return this._versionId;
  }
  getText() {
    return this._cachedTextValue === null && (this._cachedTextValue = this._lines.join(this._eol)), this._cachedTextValue;
  }
  onEvents(e) {
    e.eol && e.eol !== this._eol && (this._eol = e.eol, this._lineStarts = null);
    const t = e.changes;
    for (const i of t) this._acceptDeleteRange(i.range), this._acceptInsertText(new W(i.range.startLineNumber, i.range.startColumn), i.text);
    this._versionId = e.versionId, this._cachedTextValue = null;
  }
  _ensureLineStarts() {
    if (!this._lineStarts) {
      const e = this._eol.length, t = this._lines.length, i = new Uint32Array(t);
      for (let s = 0; s < t; s++) i[s] = this._lines[s].length + e;
      this._lineStarts = new hq(i);
    }
  }
  _setLineText(e, t) {
    this._lines[e] = t, this._lineStarts && this._lineStarts.setValue(e, this._lines[e].length + this._eol.length);
  }
  _acceptDeleteRange(e) {
    if (e.startLineNumber !== e.endLineNumber) this._setLineText(e.startLineNumber - 1, this._lines[e.startLineNumber - 1].substring(0, e.startColumn - 1) + this._lines[e.endLineNumber - 1].substring(e.endColumn - 1)), this._lines.splice(e.startLineNumber, e.endLineNumber - e.startLineNumber), this._lineStarts && this._lineStarts.removeValues(e.startLineNumber, e.endLineNumber - e.startLineNumber);
    else {
      if (e.startColumn === e.endColumn) return;
      this._setLineText(e.startLineNumber - 1, this._lines[e.startLineNumber - 1].substring(0, e.startColumn - 1) + this._lines[e.startLineNumber - 1].substring(e.endColumn - 1));
    }
  }
  _acceptInsertText(e, t) {
    if (t.length === 0) return;
    const i = Sl(t);
    if (i.length === 1) return void this._setLineText(e.lineNumber - 1, this._lines[e.lineNumber - 1].substring(0, e.column - 1) + i[0] + this._lines[e.lineNumber - 1].substring(e.column - 1));
    i[i.length - 1] += this._lines[e.lineNumber - 1].substring(e.column - 1), this._setLineText(e.lineNumber - 1, this._lines[e.lineNumber - 1].substring(0, e.column - 1) + i[0]);
    const s = new Uint32Array(i.length - 1);
    for (let o = 1; o < i.length; o++) this._lines.splice(e.lineNumber + o - 1, 0, i[o]), s[o - 1] = i[o].length + this._eol.length;
    this._lineStarts && this._lineStarts.insertValues(e.lineNumber, s);
  }
}
class mf {
  constructor(e) {
    const t = Yw(e);
    this._defaultValue = t, this._asciiMap = mf._createAsciiMap(t), this._map = /* @__PURE__ */ new Map();
  }
  static _createAsciiMap(e) {
    const t = new Uint8Array(256);
    return t.fill(e), t;
  }
  set(e, t) {
    const i = Yw(t);
    e >= 0 && e < 256 ? this._asciiMap[e] = i : this._map.set(e, i);
  }
  get(e) {
    return e >= 0 && e < 256 ? this._asciiMap[e] : this._map.get(e) || this._defaultValue;
  }
  clear() {
    this._asciiMap.fill(this._defaultValue), this._map.clear();
  }
}
class Xw {
  constructor() {
    this._actual = new mf(0);
  }
  add(e) {
    this._actual.set(e, 1);
  }
  has(e) {
    return this._actual.get(e) === 1;
  }
  clear() {
    return this._actual.clear();
  }
}
class gq {
  constructor(e, t, i) {
    const s = new Uint8Array(e * t);
    for (let o = 0, r = e * t; o < r; o++) s[o] = i;
    this._data = s, this.rows = e, this.cols = t;
  }
  get(e, t) {
    return this._data[e * this.cols + t];
  }
  set(e, t, i) {
    this._data[e * this.cols + t] = i;
  }
}
class pq {
  constructor(e) {
    let t = 0, i = 0;
    for (let o = 0, r = e.length; o < r; o++) {
      const [a, l, d] = e[o];
      l > t && (t = l), a > i && (i = a), d > i && (i = d);
    }
    t++, i++;
    const s = new gq(i, t, 0);
    for (let o = 0, r = e.length; o < r; o++) {
      const [a, l, d] = e[o];
      s.set(a, l, d);
    }
    this._states = s, this._maxCharCode = t;
  }
  nextState(e, t) {
    return t < 0 || t >= this._maxCharCode ? 0 : this._states.get(e, t);
  }
}
let oD = null, Mf = null;
class Qw {
  static _createLink(e, t, i, s, o) {
    let r = o - 1;
    do {
      const a = t.charCodeAt(r);
      if (e.get(a) !== 2) break;
      r--;
    } while (r > s);
    if (s > 0) {
      const a = t.charCodeAt(s - 1), l = t.charCodeAt(r);
      (a === 40 && l === 41 || a === 91 && l === 93 || a === 123 && l === 125) && r--;
    }
    return { range: { startLineNumber: i, startColumn: s + 1, endLineNumber: i, endColumn: r + 2 }, url: t.substring(s, r + 1) };
  }
  static computeLinks(e, t = (function() {
    return oD === null && (oD = new pq([[1, 104, 2], [1, 72, 2], [1, 102, 6], [1, 70, 6], [2, 116, 3], [2, 84, 3], [3, 116, 4], [3, 84, 4], [4, 112, 5], [4, 80, 5], [5, 115, 9], [5, 83, 9], [5, 58, 10], [6, 105, 7], [6, 73, 7], [7, 108, 8], [7, 76, 8], [8, 101, 9], [8, 69, 9], [9, 58, 10], [10, 47, 11], [11, 47, 12]])), oD;
  })()) {
    const i = (function() {
      if (Mf === null) {
        Mf = new mf(0);
        const o = ` 	<>'"、。｡､，．：；‘〈「『〔（［｛｢｣｝］）〕』」〉’｀～…`;
        for (let a = 0; a < o.length; a++) Mf.set(o.charCodeAt(a), 1);
        const r = ".,;:";
        for (let a = 0; a < r.length; a++) Mf.set(r.charCodeAt(a), 2);
      }
      return Mf;
    })(), s = [];
    for (let o = 1, r = e.getLineCount(); o <= r; o++) {
      const a = e.getLineContent(o), l = a.length;
      let d = 0, h = 0, c = 0, u = 1, g = !1, p = !1, f = !1, _ = !1;
      for (; d < l; ) {
        let v = !1;
        const b = a.charCodeAt(d);
        if (u === 13) {
          let C;
          switch (b) {
            case 40:
              g = !0, C = 0;
              break;
            case 41:
              C = g ? 0 : 1;
              break;
            case 91:
              f = !0, p = !0, C = 0;
              break;
            case 93:
              f = !1, C = p ? 0 : 1;
              break;
            case 123:
              _ = !0, C = 0;
              break;
            case 125:
              C = _ ? 0 : 1;
              break;
            case 39:
            case 34:
            case 96:
              C = c === b ? 1 : c === 39 || c === 34 || c === 96 ? 0 : 1;
              break;
            case 42:
              C = c === 42 ? 1 : 0;
              break;
            case 124:
              C = c === 124 ? 1 : 0;
              break;
            case 32:
              C = f ? 0 : 1;
              break;
            default:
              C = i.get(b);
          }
          C === 1 && (s.push(Qw._createLink(i, a, o, h, d)), v = !0);
        } else if (u === 12) {
          let C;
          b === 91 ? (p = !0, C = 0) : C = i.get(b), C === 1 ? v = !0 : u = 13;
        } else u = t.nextState(u, b), u === 0 && (v = !0);
        v && (u = 1, g = !1, p = !1, _ = !1, h = d + 1, c = b), d++;
      }
      u === 13 && s.push(Qw._createLink(i, a, o, h, l));
    }
    return s;
  }
}
class WE {
  constructor() {
    this._defaultValueSet = [["true", "false"], ["True", "False"], ["Private", "Public", "Friend", "ReadOnly", "Partial", "Protected", "WriteOnly"], ["public", "protected", "private"]];
  }
  navigateValueSet(e, t, i, s, o) {
    if (e && t) {
      const r = this.doNavigateValueSet(t, o);
      if (r) return { range: e, value: r };
    }
    if (i && s) {
      const r = this.doNavigateValueSet(s, o);
      if (r) return { range: i, value: r };
    }
    return null;
  }
  doNavigateValueSet(e, t) {
    const i = this.numberReplace(e, t);
    return i !== null ? i : this.textReplace(e, t);
  }
  numberReplace(e, t) {
    const i = Math.pow(10, e.length - (e.lastIndexOf(".") + 1));
    let s = Number(e);
    const o = parseFloat(e);
    return isNaN(s) || isNaN(o) || s !== o ? null : s !== 0 || t ? (s = Math.floor(s * i), s += t ? i : -i, String(s / i)) : null;
  }
  textReplace(e, t) {
    return this.valueSetsReplace(this._defaultValueSet, e, t);
  }
  valueSetsReplace(e, t, i) {
    let s = null;
    for (let o = 0, r = e.length; s === null && o < r; o++) s = this.valueSetReplace(e[o], t, i);
    return s;
  }
  valueSetReplace(e, t, i) {
    let s = e.indexOf(t);
    return s >= 0 ? (s += i ? 1 : -1, s < 0 ? s = e.length - 1 : s %= e.length, e[s]) : null;
  }
}
var JO, e4;
WE.INSTANCE = new WE();
class mq {
  constructor(e, t) {
    this.uri = e, this.value = t;
  }
}
class Di {
  constructor(e, t) {
    if (this[JO] = "ResourceMap", e instanceof Di) this.map = new Map(e.map), this.toKey = t ?? Di.defaultToKey;
    else if ((function(i) {
      return Array.isArray(i);
    })(e)) {
      this.map = /* @__PURE__ */ new Map(), this.toKey = t ?? Di.defaultToKey;
      for (const [i, s] of e) this.set(i, s);
    } else this.map = /* @__PURE__ */ new Map(), this.toKey = e ?? Di.defaultToKey;
  }
  set(e, t) {
    return this.map.set(this.toKey(e), new mq(e, t)), this;
  }
  get(e) {
    var t;
    return (t = this.map.get(this.toKey(e))) === null || t === void 0 ? void 0 : t.value;
  }
  has(e) {
    return this.map.has(this.toKey(e));
  }
  get size() {
    return this.map.size;
  }
  clear() {
    this.map.clear();
  }
  delete(e) {
    return this.map.delete(this.toKey(e));
  }
  forEach(e, t) {
    t !== void 0 && (e = e.bind(t));
    for (const [i, s] of this.map) e(s.value, s.uri, this);
  }
  *values() {
    for (const e of this.map.values()) yield e.value;
  }
  *keys() {
    for (const e of this.map.values()) yield e.uri;
  }
  *entries() {
    for (const e of this.map.values()) yield [e.uri, e.value];
  }
  *[(JO = Symbol.toStringTag, Symbol.iterator)]() {
    for (const [, e] of this.map) yield [e.uri, e.value];
  }
}
Di.defaultToKey = (n) => n.toString();
class fq {
  constructor() {
    this[e4] = "LinkedMap", this._map = /* @__PURE__ */ new Map(), this._head = void 0, this._tail = void 0, this._size = 0, this._state = 0;
  }
  clear() {
    this._map.clear(), this._head = void 0, this._tail = void 0, this._size = 0, this._state++;
  }
  isEmpty() {
    return !this._head && !this._tail;
  }
  get size() {
    return this._size;
  }
  get first() {
    var e;
    return (e = this._head) === null || e === void 0 ? void 0 : e.value;
  }
  get last() {
    var e;
    return (e = this._tail) === null || e === void 0 ? void 0 : e.value;
  }
  has(e) {
    return this._map.has(e);
  }
  get(e, t = 0) {
    const i = this._map.get(e);
    if (i) return t !== 0 && this.touch(i, t), i.value;
  }
  set(e, t, i = 0) {
    let s = this._map.get(e);
    if (s) s.value = t, i !== 0 && this.touch(s, i);
    else {
      switch (s = { key: e, value: t, next: void 0, previous: void 0 }, i) {
        case 0:
        case 2:
        default:
          this.addItemLast(s);
          break;
        case 1:
          this.addItemFirst(s);
      }
      this._map.set(e, s), this._size++;
    }
    return this;
  }
  delete(e) {
    return !!this.remove(e);
  }
  remove(e) {
    const t = this._map.get(e);
    if (t) return this._map.delete(e), this.removeItem(t), this._size--, t.value;
  }
  shift() {
    if (!this._head && !this._tail) return;
    if (!this._head || !this._tail) throw new Error("Invalid list");
    const e = this._head;
    return this._map.delete(e.key), this.removeItem(e), this._size--, e.value;
  }
  forEach(e, t) {
    const i = this._state;
    let s = this._head;
    for (; s; ) {
      if (t ? e.bind(t)(s.value, s.key, this) : e(s.value, s.key, this), this._state !== i) throw new Error("LinkedMap got modified during iteration.");
      s = s.next;
    }
  }
  keys() {
    const e = this, t = this._state;
    let i = this._head;
    const s = { [Symbol.iterator]: () => s, next() {
      if (e._state !== t) throw new Error("LinkedMap got modified during iteration.");
      if (i) {
        const o = { value: i.key, done: !1 };
        return i = i.next, o;
      }
      return { value: void 0, done: !0 };
    } };
    return s;
  }
  values() {
    const e = this, t = this._state;
    let i = this._head;
    const s = { [Symbol.iterator]: () => s, next() {
      if (e._state !== t) throw new Error("LinkedMap got modified during iteration.");
      if (i) {
        const o = { value: i.value, done: !1 };
        return i = i.next, o;
      }
      return { value: void 0, done: !0 };
    } };
    return s;
  }
  entries() {
    const e = this, t = this._state;
    let i = this._head;
    const s = { [Symbol.iterator]: () => s, next() {
      if (e._state !== t) throw new Error("LinkedMap got modified during iteration.");
      if (i) {
        const o = { value: [i.key, i.value], done: !1 };
        return i = i.next, o;
      }
      return { value: void 0, done: !0 };
    } };
    return s;
  }
  [(e4 = Symbol.toStringTag, Symbol.iterator)]() {
    return this.entries();
  }
  trimOld(e) {
    if (e >= this.size) return;
    if (e === 0) return void this.clear();
    let t = this._head, i = this.size;
    for (; t && i > e; ) this._map.delete(t.key), t = t.next, i--;
    this._head = t, this._size = i, t && (t.previous = void 0), this._state++;
  }
  addItemFirst(e) {
    if (this._head || this._tail) {
      if (!this._head) throw new Error("Invalid list");
      e.next = this._head, this._head.previous = e;
    } else this._tail = e;
    this._head = e, this._state++;
  }
  addItemLast(e) {
    if (this._head || this._tail) {
      if (!this._tail) throw new Error("Invalid list");
      e.previous = this._tail, this._tail.next = e;
    } else this._head = e;
    this._tail = e, this._state++;
  }
  removeItem(e) {
    if (e === this._head && e === this._tail) this._head = void 0, this._tail = void 0;
    else if (e === this._head) {
      if (!e.next) throw new Error("Invalid list");
      e.next.previous = void 0, this._head = e.next;
    } else if (e === this._tail) {
      if (!e.previous) throw new Error("Invalid list");
      e.previous.next = void 0, this._tail = e.previous;
    } else {
      const t = e.next, i = e.previous;
      if (!t || !i) throw new Error("Invalid list");
      t.previous = i, i.next = t;
    }
    e.next = void 0, e.previous = void 0, this._state++;
  }
  touch(e, t) {
    if (!this._head || !this._tail) throw new Error("Invalid list");
    if (t === 1 || t === 2) {
      if (t === 1) {
        if (e === this._head) return;
        const i = e.next, s = e.previous;
        e === this._tail ? (s.next = void 0, this._tail = s) : (i.previous = s, s.next = i), e.previous = void 0, e.next = this._head, this._head.previous = e, this._head = e, this._state++;
      } else if (t === 2) {
        if (e === this._tail) return;
        const i = e.next, s = e.previous;
        e === this._head ? (i.previous = void 0, this._head = i) : (i.previous = s, s.next = i), e.next = void 0, e.previous = this._tail, this._tail.next = e, this._tail = e, this._state++;
      }
    }
  }
  toJSON() {
    const e = [];
    return this.forEach(((t, i) => {
      e.push([i, t]);
    })), e;
  }
  fromJSON(e) {
    this.clear();
    for (const [t, i] of e) this.set(t, i);
  }
}
class Ll extends fq {
  constructor(e, t = 1) {
    super(), this._limit = e, this._ratio = Math.min(Math.max(0, t), 1);
  }
  get limit() {
    return this._limit;
  }
  set limit(e) {
    this._limit = e, this.checkTrim();
  }
  get(e, t = 2) {
    return super.get(e, t);
  }
  peek(e) {
    return super.get(e, 0);
  }
  set(e, t) {
    return super.set(e, t, 2), this.checkTrim(), this;
  }
  checkTrim() {
    this.size > this._limit && this.trimOld(Math.round(this._limit * this._ratio));
  }
}
class _q {
  constructor(e) {
    if (this._m1 = /* @__PURE__ */ new Map(), this._m2 = /* @__PURE__ */ new Map(), e) for (const [t, i] of e) this.set(t, i);
  }
  clear() {
    this._m1.clear(), this._m2.clear();
  }
  set(e, t) {
    this._m1.set(e, t), this._m2.set(t, e);
  }
  get(e) {
    return this._m1.get(e);
  }
  getKey(e) {
    return this._m2.get(e);
  }
  delete(e) {
    const t = this._m1.get(e);
    return t !== void 0 && (this._m1.delete(e), this._m2.delete(t), !0);
  }
  keys() {
    return this._m1.keys();
  }
  values() {
    return this._m1.values();
  }
}
class wR {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  add(e, t) {
    let i = this.map.get(e);
    i || (i = /* @__PURE__ */ new Set(), this.map.set(e, i)), i.add(t);
  }
  delete(e, t) {
    const i = this.map.get(e);
    i && (i.delete(t), i.size === 0 && this.map.delete(e));
  }
  forEach(e, t) {
    const i = this.map.get(e);
    i && i.forEach(t);
  }
  get(e) {
    return this.map.get(e) || /* @__PURE__ */ new Set();
  }
}
class vq extends mf {
  constructor(e, t) {
    super(0), this._segmenter = null, this._cachedLine = null, this._cachedSegments = [], this.intlSegmenterLocales = t, this.intlSegmenterLocales.length > 0 ? this._segmenter = new Intl.Segmenter(this.intlSegmenterLocales, { granularity: "word" }) : this._segmenter = null;
    for (let i = 0, s = e.length; i < s; i++) this.set(e.charCodeAt(i), 2);
    this.set(32, 1), this.set(9, 1);
  }
  findPrevIntlWordBeforeOrAtOffset(e, t) {
    let i = null;
    for (const s of this._getIntlSegmenterWordsOnLine(e)) {
      if (s.index > t) break;
      i = s;
    }
    return i;
  }
  findNextIntlWordAtOrAfterOffset(e, t) {
    for (const i of this._getIntlSegmenterWordsOnLine(e)) if (!(i.index < t)) return i;
    return null;
  }
  _getIntlSegmenterWordsOnLine(e) {
    return this._segmenter ? (this._cachedLine === e || (this._cachedLine = e, this._cachedSegments = this._filterWordSegments(this._segmenter.segment(e))), this._cachedSegments) : [];
  }
  _filterWordSegments(e) {
    const t = [];
    for (const i of e) this._isWordLike(i) && t.push(i);
    return t;
  }
  _isWordLike(e) {
    return !!e.isWordLike;
  }
}
const t4 = new Ll(10);
function zo(n, e) {
  const t = `${n}/${e.join(",")}`;
  let i = t4.get(t);
  return i || (i = new vq(n, e), t4.set(t, i)), i;
}
var Do, _l, vr;
(function(n) {
  n[n.Left = 1] = "Left", n[n.Center = 2] = "Center", n[n.Right = 4] = "Right", n[n.Full = 7] = "Full";
})(Do || (Do = {})), (function(n) {
  n[n.Left = 1] = "Left", n[n.Center = 2] = "Center", n[n.Right = 3] = "Right";
})(_l || (_l = {})), (function(n) {
  n[n.Both = 0] = "Both", n[n.Right = 1] = "Right", n[n.Left = 2] = "Left", n[n.None = 3] = "None";
})(vr || (vr = {}));
class MC {
  get originalIndentSize() {
    return this._indentSizeIsTabSize ? "tabSize" : this.indentSize;
  }
  constructor(e) {
    this._textModelResolvedOptionsBrand = void 0, this.tabSize = Math.max(1, 0 | e.tabSize), e.indentSize === "tabSize" ? (this.indentSize = this.tabSize, this._indentSizeIsTabSize = !0) : (this.indentSize = Math.max(1, 0 | e.indentSize), this._indentSizeIsTabSize = !1), this.insertSpaces = !!e.insertSpaces, this.defaultEOL = 0 | e.defaultEOL, this.trimAutoWhitespace = !!e.trimAutoWhitespace, this.bracketPairColorizationOptions = e.bracketPairColorizationOptions;
  }
  equals(e) {
    return this.tabSize === e.tabSize && this._indentSizeIsTabSize === e._indentSizeIsTabSize && this.indentSize === e.indentSize && this.insertSpaces === e.insertSpaces && this.defaultEOL === e.defaultEOL && this.trimAutoWhitespace === e.trimAutoWhitespace && So(this.bracketPairColorizationOptions, e.bracketPairColorizationOptions);
  }
  createChangeEvent(e) {
    return { tabSize: this.tabSize !== e.tabSize, indentSize: this.indentSize !== e.indentSize, insertSpaces: this.insertSpaces !== e.insertSpaces, trimAutoWhitespace: this.trimAutoWhitespace !== e.trimAutoWhitespace };
  }
}
class tv {
  constructor(e, t) {
    this._findMatchBrand = void 0, this.range = e, this.matches = t;
  }
}
class rD {
  constructor(e, t, i, s, o, r) {
    this.identifier = e, this.range = t, this.text = i, this.forceMoveMarkers = s, this.isAutoWhitespaceEdit = o, this._isTracked = r;
  }
}
class bq {
  constructor(e, t, i) {
    this.regex = e, this.wordSeparators = t, this.simpleSearch = i;
  }
}
class Cq {
  constructor(e, t, i) {
    this.reverseEdits = e, this.changes = t, this.trimAutoWhitespaceLineNumbers = i;
  }
}
function $8(n) {
  return !n.isTooLargeForSyncing() && !n.isForSimpleWidget;
}
class su {
  constructor(e, t, i, s) {
    this.searchString = e, this.isRegex = t, this.matchCase = i, this.wordSeparators = s;
  }
  parseSearchRequest() {
    if (this.searchString === "") return null;
    let e;
    e = this.isRegex ? (function(s) {
      if (!s || s.length === 0) return !1;
      for (let o = 0, r = s.length; o < r; o++) {
        const a = s.charCodeAt(o);
        if (a === 10) return !0;
        if (a === 92) {
          if (o++, o >= r) break;
          const l = s.charCodeAt(o);
          if (l === 110 || l === 114 || l === 87) return !0;
        }
      }
      return !1;
    })(this.searchString) : this.searchString.indexOf(`
`) >= 0;
    let t = null;
    try {
      t = Q7(this.searchString, this.isRegex, { matchCase: this.matchCase, wholeWord: !1, multiline: e, global: !0, unicode: !0 });
    } catch {
      return null;
    }
    if (!t) return null;
    let i = !this.isRegex && !e;
    return i && this.searchString.toLowerCase() !== this.searchString.toUpperCase() && (i = this.matchCase), new bq(t, this.wordSeparators ? zo(this.wordSeparators, []) : null, i ? this.searchString : null);
  }
}
function pu(n, e, t) {
  if (!t) return new tv(n, null);
  const i = [];
  for (let s = 0, o = e.length; s < o; s++) i[s] = e[s];
  return new tv(n, i);
}
class i4 {
  constructor(e) {
    const t = [];
    let i = 0;
    for (let s = 0, o = e.length; s < o; s++) e.charCodeAt(s) === 10 && (t[i++] = s);
    this._lineFeedsOffsets = t;
  }
  findLineFeedCountBeforeOffset(e) {
    const t = this._lineFeedsOffsets;
    let i = 0, s = t.length - 1;
    if (s === -1 || e <= t[0]) return 0;
    for (; i < s; ) {
      const o = i + ((s - i) / 2 | 0);
      t[o] >= e ? s = o - 1 : t[o + 1] >= e ? (i = o, s = o) : i = o + 1;
    }
    return i + 1;
  }
}
class sb {
  static findMatches(e, t, i, s, o) {
    const r = t.parseSearchRequest();
    return r ? r.regex.multiline ? this._doFindMatchesMultiline(e, i, new xp(r.wordSeparators, r.regex), s, o) : this._doFindMatchesLineByLine(e, i, r, s, o) : [];
  }
  static _getMultilineMatchRange(e, t, i, s, o, r) {
    let a, l, d = 0;
    if (s ? (d = s.findLineFeedCountBeforeOffset(o), a = t + o + d) : a = t + o, s) {
      const u = s.findLineFeedCountBeforeOffset(o + r.length) - d;
      l = a + r.length + u;
    } else l = a + r.length;
    const h = e.getPositionAt(a), c = e.getPositionAt(l);
    return new D(h.lineNumber, h.column, c.lineNumber, c.column);
  }
  static _doFindMatchesMultiline(e, t, i, s, o) {
    const r = e.getOffsetAt(t.getStartPosition()), a = e.getValueInRange(t, 1), l = e.getEOL() === `\r
` ? new i4(a) : null, d = [];
    let h, c = 0;
    for (i.reset(0); h = i.next(a); ) if (d[c++] = pu(this._getMultilineMatchRange(e, r, a, l, h.index, h[0]), h, s), c >= o) return d;
    return d;
  }
  static _doFindMatchesLineByLine(e, t, i, s, o) {
    const r = [];
    let a = 0;
    if (t.startLineNumber === t.endLineNumber) {
      const d = e.getLineContent(t.startLineNumber).substring(t.startColumn - 1, t.endColumn - 1);
      return a = this._findMatchesInLine(i, d, t.startLineNumber, t.startColumn - 1, a, r, s, o), r;
    }
    const l = e.getLineContent(t.startLineNumber).substring(t.startColumn - 1);
    a = this._findMatchesInLine(i, l, t.startLineNumber, t.startColumn - 1, a, r, s, o);
    for (let d = t.startLineNumber + 1; d < t.endLineNumber && a < o; d++) a = this._findMatchesInLine(i, e.getLineContent(d), d, 0, a, r, s, o);
    if (a < o) {
      const d = e.getLineContent(t.endLineNumber).substring(0, t.endColumn - 1);
      a = this._findMatchesInLine(i, d, t.endLineNumber, 0, a, r, s, o);
    }
    return r;
  }
  static _findMatchesInLine(e, t, i, s, o, r, a, l) {
    const d = e.wordSeparators;
    if (!a && e.simpleSearch) {
      const u = e.simpleSearch, g = u.length, p = t.length;
      let f = -g;
      for (; (f = t.indexOf(u, f + g)) !== -1; ) if ((!d || yR(d, t, p, f, g)) && (r[o++] = new tv(new D(i, f + 1 + s, i, f + 1 + g + s), null), o >= l)) return o;
      return o;
    }
    const h = new xp(e.wordSeparators, e.regex);
    let c;
    h.reset(0);
    do
      if (c = h.next(t), c && (r[o++] = pu(new D(i, c.index + 1 + s, i, c.index + 1 + c[0].length + s), c, a), o >= l)) return o;
    while (c);
    return o;
  }
  static findNextMatch(e, t, i, s) {
    const o = t.parseSearchRequest();
    if (!o) return null;
    const r = new xp(o.wordSeparators, o.regex);
    return o.regex.multiline ? this._doFindNextMatchMultiline(e, i, r, s) : this._doFindNextMatchLineByLine(e, i, r, s);
  }
  static _doFindNextMatchMultiline(e, t, i, s) {
    const o = new W(t.lineNumber, 1), r = e.getOffsetAt(o), a = e.getLineCount(), l = e.getValueInRange(new D(o.lineNumber, o.column, a, e.getLineMaxColumn(a)), 1), d = e.getEOL() === `\r
` ? new i4(l) : null;
    i.reset(t.column - 1);
    const h = i.next(l);
    return h ? pu(this._getMultilineMatchRange(e, r, l, d, h.index, h[0]), h, s) : t.lineNumber !== 1 || t.column !== 1 ? this._doFindNextMatchMultiline(e, new W(1, 1), i, s) : null;
  }
  static _doFindNextMatchLineByLine(e, t, i, s) {
    const o = e.getLineCount(), r = t.lineNumber, a = e.getLineContent(r), l = this._findFirstMatchInLine(i, a, r, t.column, s);
    if (l) return l;
    for (let d = 1; d <= o; d++) {
      const h = (r + d - 1) % o, c = e.getLineContent(h + 1), u = this._findFirstMatchInLine(i, c, h + 1, 1, s);
      if (u) return u;
    }
    return null;
  }
  static _findFirstMatchInLine(e, t, i, s, o) {
    e.reset(s - 1);
    const r = e.next(t);
    return r ? pu(new D(i, r.index + 1, i, r.index + 1 + r[0].length), r, o) : null;
  }
  static findPreviousMatch(e, t, i, s) {
    const o = t.parseSearchRequest();
    if (!o) return null;
    const r = new xp(o.wordSeparators, o.regex);
    return o.regex.multiline ? this._doFindPreviousMatchMultiline(e, i, r, s) : this._doFindPreviousMatchLineByLine(e, i, r, s);
  }
  static _doFindPreviousMatchMultiline(e, t, i, s) {
    const o = this._doFindMatchesMultiline(e, new D(1, 1, t.lineNumber, t.column), i, s, 9990);
    if (o.length > 0) return o[o.length - 1];
    const r = e.getLineCount();
    return t.lineNumber !== r || t.column !== e.getLineMaxColumn(r) ? this._doFindPreviousMatchMultiline(e, new W(r, e.getLineMaxColumn(r)), i, s) : null;
  }
  static _doFindPreviousMatchLineByLine(e, t, i, s) {
    const o = e.getLineCount(), r = t.lineNumber, a = e.getLineContent(r).substring(0, t.column - 1), l = this._findLastMatchInLine(i, a, r, s);
    if (l) return l;
    for (let d = 1; d <= o; d++) {
      const h = (o + r - d - 1) % o, c = e.getLineContent(h + 1), u = this._findLastMatchInLine(i, c, h + 1, s);
      if (u) return u;
    }
    return null;
  }
  static _findLastMatchInLine(e, t, i, s) {
    let o, r = null;
    for (e.reset(0); o = e.next(t); ) r = pu(new D(i, o.index + 1, i, o.index + 1 + o[0].length), o, s);
    return r;
  }
}
function yR(n, e, t, i, s) {
  return (function(o, r, a, l, d) {
    if (l === 0) return !0;
    const h = r.charCodeAt(l - 1);
    if (o.get(h) !== 0 || h === 13 || h === 10) return !0;
    if (d > 0) {
      const c = r.charCodeAt(l);
      if (o.get(c) !== 0) return !0;
    }
    return !1;
  })(n, e, 0, i, s) && (function(o, r, a, l, d) {
    if (l + d === a) return !0;
    const h = r.charCodeAt(l + d);
    if (o.get(h) !== 0 || h === 13 || h === 10) return !0;
    if (d > 0) {
      const c = r.charCodeAt(l + d - 1);
      if (o.get(c) !== 0) return !0;
    }
    return !1;
  })(n, e, t, i, s);
}
class xp {
  constructor(e, t) {
    this._wordSeparators = e, this._searchRegex = t, this._prevMatchStartIndex = -1, this._prevMatchLength = 0;
  }
  reset(e) {
    this._searchRegex.lastIndex = e, this._prevMatchStartIndex = -1, this._prevMatchLength = 0;
  }
  next(e) {
    const t = e.length;
    let i;
    do {
      if (this._prevMatchStartIndex + this._prevMatchLength === t || (i = this._searchRegex.exec(e), !i)) return null;
      const s = i.index, o = i[0].length;
      if (s === this._prevMatchStartIndex && o === this._prevMatchLength) {
        if (o === 0) {
          Bw(e, t, this._searchRegex.lastIndex) > 65535 ? this._searchRegex.lastIndex += 2 : this._searchRegex.lastIndex += 1;
          continue;
        }
        return null;
      }
      if (this._prevMatchStartIndex = s, this._prevMatchLength = o, !this._wordSeparators || yR(this._wordSeparators, e, t, s, o)) return i;
    } while (i);
    return null;
  }
}
class SR {
  static computeUnicodeHighlights(e, t, i) {
    const s = i ? i.startLineNumber : 1, o = i ? i.endLineNumber : e.getLineCount(), r = new n4(t), a = r.getCandidateCodePoints();
    let l;
    l = a === "allNonBasicAscii" ? new RegExp("[^\\t\\n\\r\\x20-\\x7E]", "g") : new RegExp(`[${No(Array.from(a).map(((_) => String.fromCodePoint(_))).join(""))}]`, "g");
    const d = new xp(null, l), h = [];
    let c, u = !1, g = 0, p = 0, f = 0;
    e: for (let _ = s, v = o; _ <= v; _++) {
      const b = e.getLineContent(_), C = b.length;
      d.reset(0);
      do
        if (c = d.next(b), c) {
          let w = c.index, y = c.index + c[0].length;
          w > 0 && en(b.charCodeAt(w - 1)) && w--, y + 1 < C && en(b.charCodeAt(y - 1)) && y++;
          const L = b.substring(w, y);
          let k = K0(w + 1, $T, b, 0);
          k && k.endColumn <= w + 1 && (k = null);
          const N = r.shouldHighlightNonBasicASCII(L, k ? k.word : null);
          if (N !== 0) {
            if (N === 3 ? g++ : N === 2 ? p++ : N === 1 ? f++ : XS(), h.length >= 1e3) {
              u = !0;
              break e;
            }
            h.push(new D(_, w + 1, _, y + 1));
          }
        }
      while (c);
    }
    return { ranges: h, hasMore: u, ambiguousCharacterCount: g, invisibleCharacterCount: p, nonBasicAsciiCharacterCount: f };
  }
  static computeUnicodeHighlightReason(e, t) {
    const i = new n4(t);
    switch (i.shouldHighlightNonBasicASCII(e, null)) {
      case 0:
        return null;
      case 2:
        return { kind: 1 };
      case 3: {
        const s = e.codePointAt(0), o = i.ambiguousCharacters.getPrimaryConfusable(s), r = xu.getLocales().filter(((a) => !xu.getInstance(/* @__PURE__ */ new Set([...t.allowedLocales, a])).isAmbiguous(s)));
        return { kind: 0, confusableWith: String.fromCodePoint(o), notAmbiguousInLocales: r };
      }
      case 1:
        return { kind: 2 };
    }
  }
}
class n4 {
  constructor(e) {
    this.options = e, this.allowedCodePoints = new Set(e.allowedCodePoints), this.ambiguousCharacters = xu.getInstance(new Set(e.allowedLocales));
  }
  getCandidateCodePoints() {
    if (this.options.nonBasicASCII) return "allNonBasicAscii";
    const e = /* @__PURE__ */ new Set();
    if (this.options.invisibleCharacters) for (const t of ul.codePoints) s4(String.fromCodePoint(t)) || e.add(t);
    if (this.options.ambiguousCharacters) for (const t of this.ambiguousCharacters.getConfusableCodePoints()) e.add(t);
    for (const t of this.allowedCodePoints) e.delete(t);
    return e;
  }
  shouldHighlightNonBasicASCII(e, t) {
    const i = e.codePointAt(0);
    if (this.allowedCodePoints.has(i)) return 0;
    if (this.options.nonBasicASCII) return 1;
    let s = !1, o = !1;
    if (t) for (const r of t) {
      const a = r.codePointAt(0), l = p1(r);
      s = s || l, l || this.ambiguousCharacters.isAmbiguous(a) || ul.isInvisibleCharacter(a) || (o = !0);
    }
    return !s && o ? 0 : this.options.invisibleCharacters && !s4(e) && ul.isInvisibleCharacter(i) ? 2 : this.options.ambiguousCharacters && this.ambiguousCharacters.isAmbiguous(i) ? 3 : 0;
  }
}
function s4(n) {
  return n === " " || n === `
` || n === "	";
}
class TC {
  constructor(e, t, i) {
    this.changes = e, this.moves = t, this.hitTimeout = i;
  }
}
class G8 {
  constructor(e, t) {
    this.lineRangeMapping = e, this.changes = t;
  }
}
class qe {
  static addRange(e, t) {
    let i = 0;
    for (; i < t.length && t[i].endExclusive < e.start; ) i++;
    let s = i;
    for (; s < t.length && t[s].start <= e.endExclusive; ) s++;
    if (i === s) t.splice(i, 0, e);
    else {
      const o = Math.min(e.start, t[i].start), r = Math.max(e.endExclusive, t[s - 1].endExclusive);
      t.splice(i, s - i, new qe(o, r));
    }
  }
  static tryCreate(e, t) {
    if (!(e > t)) return new qe(e, t);
  }
  static ofLength(e) {
    return new qe(0, e);
  }
  static ofStartAndLength(e, t) {
    return new qe(e, e + t);
  }
  constructor(e, t) {
    if (this.start = e, this.endExclusive = t, e > t) throw new Kt(`Invalid range: ${this.toString()}`);
  }
  get isEmpty() {
    return this.start === this.endExclusive;
  }
  delta(e) {
    return new qe(this.start + e, this.endExclusive + e);
  }
  deltaStart(e) {
    return new qe(this.start + e, this.endExclusive);
  }
  deltaEnd(e) {
    return new qe(this.start, this.endExclusive + e);
  }
  get length() {
    return this.endExclusive - this.start;
  }
  toString() {
    return `[${this.start}, ${this.endExclusive})`;
  }
  contains(e) {
    return this.start <= e && e < this.endExclusive;
  }
  join(e) {
    return new qe(Math.min(this.start, e.start), Math.max(this.endExclusive, e.endExclusive));
  }
  intersect(e) {
    const t = Math.max(this.start, e.start), i = Math.min(this.endExclusive, e.endExclusive);
    if (t <= i) return new qe(t, i);
  }
  intersects(e) {
    return Math.max(this.start, e.start) < Math.min(this.endExclusive, e.endExclusive);
  }
  isBefore(e) {
    return this.endExclusive <= e.start;
  }
  isAfter(e) {
    return this.start >= e.endExclusive;
  }
  slice(e) {
    return e.slice(this.start, this.endExclusive);
  }
  substring(e) {
    return e.substring(this.start, this.endExclusive);
  }
  clip(e) {
    if (this.isEmpty) throw new Kt(`Invalid clipping range: ${this.toString()}`);
    return Math.max(this.start, Math.min(this.endExclusive - 1, e));
  }
  clipCyclic(e) {
    if (this.isEmpty) throw new Kt(`Invalid clipping range: ${this.toString()}`);
    return e < this.start ? this.endExclusive - (this.start - e) % this.length : e >= this.endExclusive ? this.start + (e - this.start) % this.length : e;
  }
  forEach(e) {
    for (let t = this.start; t < this.endExclusive; t++) e(t);
  }
}
class LR {
  constructor() {
    this._sortedRanges = [];
  }
  addRange(e) {
    let t = 0;
    for (; t < this._sortedRanges.length && this._sortedRanges[t].endExclusive < e.start; ) t++;
    let i = t;
    for (; i < this._sortedRanges.length && this._sortedRanges[i].start <= e.endExclusive; ) i++;
    if (t === i) this._sortedRanges.splice(t, 0, e);
    else {
      const s = Math.min(e.start, this._sortedRanges[t].start), o = Math.max(e.endExclusive, this._sortedRanges[i - 1].endExclusive);
      this._sortedRanges.splice(t, i - t, new qe(s, o));
    }
  }
  toString() {
    return this._sortedRanges.map(((e) => e.toString())).join(", ");
  }
  intersectsStrict(e) {
    let t = 0;
    for (; t < this._sortedRanges.length && this._sortedRanges[t].endExclusive <= e.start; ) t++;
    return t < this._sortedRanges.length && this._sortedRanges[t].start < e.endExclusive;
  }
  intersectWithRange(e) {
    const t = new LR();
    for (const i of this._sortedRanges) {
      const s = i.intersect(e);
      s && t.addRange(s);
    }
    return t;
  }
  intersectWithRangeLength(e) {
    return this.intersectWithRange(e).length;
  }
  get length() {
    return this._sortedRanges.reduce(((e, t) => e + t.length), 0);
  }
}
function iv(n, e, t) {
  const i = (function(s, o, r = s.length - 1) {
    for (let a = r; a >= 0; a--)
      if (o(s[a])) return a;
    return -1;
  })(n, e);
  if (i !== -1) return n[i];
}
function em(n, e) {
  const t = nv(n, e);
  return t === -1 ? void 0 : n[t];
}
function nv(n, e, t = 0, i = n.length) {
  let s = t, o = i;
  for (; s < o; ) {
    const r = Math.floor((s + o) / 2);
    e(n[r]) ? s = r + 1 : o = r;
  }
  return s - 1;
}
function sv(n, e, t = 0, i = n.length) {
  let s = t, o = i;
  for (; s < o; ) {
    const r = Math.floor((s + o) / 2);
    e(n[r]) ? o = r : s = r + 1;
  }
  return s;
}
class ov {
  constructor(e) {
    this._array = e, this._findLastMonotonousLastIdx = 0;
  }
  findLastMonotonous(e) {
    if (ov.assertInvariants) {
      if (this._prevFindLastPredicate) {
        for (const i of this._array) if (this._prevFindLastPredicate(i) && !e(i)) throw new Error("MonotonousArray: current predicate must be weaker than (or equal to) the previous predicate.");
      }
      this._prevFindLastPredicate = e;
    }
    const t = nv(this._array, e, this._findLastMonotonousLastIdx);
    return this._findLastMonotonousLastIdx = t + 1, t === -1 ? void 0 : this._array[t];
  }
}
function kR(n, e) {
  if (n.length === 0) return;
  let t = n[0];
  for (let i = 1; i < n.length; i++) {
    const s = n[i];
    e(s, t) > 0 && (t = s);
  }
  return t;
}
function wq(n, e) {
  if (n.length === 0) return -1;
  let t = 0;
  for (let i = 1; i < n.length; i++)
    e(n[i], n[t]) > 0 && (t = i);
  return t;
}
ov.assertInvariants = !1;
let je = class Pl {
  static fromRangeInclusive(e) {
    return new Pl(e.startLineNumber, e.endLineNumber + 1);
  }
  static joinMany(e) {
    if (e.length === 0) return [];
    let t = new Uo(e[0].slice());
    for (let i = 1; i < e.length; i++) t = t.getUnion(new Uo(e[i].slice()));
    return t.ranges;
  }
  static join(e) {
    if (e.length === 0) throw new Kt("lineRanges cannot be empty");
    let t = e[0].startLineNumber, i = e[0].endLineNumberExclusive;
    for (let s = 1; s < e.length; s++) t = Math.min(t, e[s].startLineNumber), i = Math.max(i, e[s].endLineNumberExclusive);
    return new Pl(t, i);
  }
  static ofLength(e, t) {
    return new Pl(e, e + t);
  }
  static deserialize(e) {
    return new Pl(e[0], e[1]);
  }
  constructor(e, t) {
    if (e > t) throw new Kt(`startLineNumber ${e} cannot be after endLineNumberExclusive ${t}`);
    this.startLineNumber = e, this.endLineNumberExclusive = t;
  }
  contains(e) {
    return this.startLineNumber <= e && e < this.endLineNumberExclusive;
  }
  get isEmpty() {
    return this.startLineNumber === this.endLineNumberExclusive;
  }
  delta(e) {
    return new Pl(this.startLineNumber + e, this.endLineNumberExclusive + e);
  }
  deltaLength(e) {
    return new Pl(this.startLineNumber, this.endLineNumberExclusive + e);
  }
  get length() {
    return this.endLineNumberExclusive - this.startLineNumber;
  }
  join(e) {
    return new Pl(Math.min(this.startLineNumber, e.startLineNumber), Math.max(this.endLineNumberExclusive, e.endLineNumberExclusive));
  }
  toString() {
    return `[${this.startLineNumber},${this.endLineNumberExclusive})`;
  }
  intersect(e) {
    const t = Math.max(this.startLineNumber, e.startLineNumber), i = Math.min(this.endLineNumberExclusive, e.endLineNumberExclusive);
    if (t <= i) return new Pl(t, i);
  }
  intersectsStrict(e) {
    return this.startLineNumber < e.endLineNumberExclusive && e.startLineNumber < this.endLineNumberExclusive;
  }
  overlapOrTouch(e) {
    return this.startLineNumber <= e.endLineNumberExclusive && e.startLineNumber <= this.endLineNumberExclusive;
  }
  equals(e) {
    return this.startLineNumber === e.startLineNumber && this.endLineNumberExclusive === e.endLineNumberExclusive;
  }
  toInclusiveRange() {
    return this.isEmpty ? null : new D(this.startLineNumber, 1, this.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER);
  }
  toExclusiveRange() {
    return new D(this.startLineNumber, 1, this.endLineNumberExclusive, 1);
  }
  mapToLineArray(e) {
    const t = [];
    for (let i = this.startLineNumber; i < this.endLineNumberExclusive; i++) t.push(e(i));
    return t;
  }
  forEach(e) {
    for (let t = this.startLineNumber; t < this.endLineNumberExclusive; t++) e(t);
  }
  serialize() {
    return [this.startLineNumber, this.endLineNumberExclusive];
  }
  includes(e) {
    return this.startLineNumber <= e && e < this.endLineNumberExclusive;
  }
  toOffsetRange() {
    return new qe(this.startLineNumber - 1, this.endLineNumberExclusive - 1);
  }
};
class Uo {
  constructor(e = []) {
    this._normalizedRanges = e;
  }
  get ranges() {
    return this._normalizedRanges;
  }
  addRange(e) {
    if (e.length === 0) return;
    const t = sv(this._normalizedRanges, ((s) => s.endLineNumberExclusive >= e.startLineNumber)), i = nv(this._normalizedRanges, ((s) => s.startLineNumber <= e.endLineNumberExclusive)) + 1;
    if (t === i) this._normalizedRanges.splice(t, 0, e);
    else if (t === i - 1) {
      const s = this._normalizedRanges[t];
      this._normalizedRanges[t] = s.join(e);
    } else {
      const s = this._normalizedRanges[t].join(this._normalizedRanges[i - 1]).join(e);
      this._normalizedRanges.splice(t, i - t, s);
    }
  }
  contains(e) {
    const t = em(this._normalizedRanges, ((i) => i.startLineNumber <= e));
    return !!t && t.endLineNumberExclusive > e;
  }
  intersects(e) {
    const t = em(this._normalizedRanges, ((i) => i.startLineNumber < e.endLineNumberExclusive));
    return !!t && t.endLineNumberExclusive > e.startLineNumber;
  }
  getUnion(e) {
    if (this._normalizedRanges.length === 0) return e;
    if (e._normalizedRanges.length === 0) return this;
    const t = [];
    let i = 0, s = 0, o = null;
    for (; i < this._normalizedRanges.length || s < e._normalizedRanges.length; ) {
      let r = null;
      if (i < this._normalizedRanges.length && s < e._normalizedRanges.length) {
        const a = this._normalizedRanges[i], l = e._normalizedRanges[s];
        a.startLineNumber < l.startLineNumber ? (r = a, i++) : (r = l, s++);
      } else i < this._normalizedRanges.length ? (r = this._normalizedRanges[i], i++) : (r = e._normalizedRanges[s], s++);
      o === null ? o = r : o.endLineNumberExclusive >= r.startLineNumber ? o = new je(o.startLineNumber, Math.max(o.endLineNumberExclusive, r.endLineNumberExclusive)) : (t.push(o), o = r);
    }
    return o !== null && t.push(o), new Uo(t);
  }
  subtractFrom(e) {
    const t = sv(this._normalizedRanges, ((r) => r.endLineNumberExclusive >= e.startLineNumber)), i = nv(this._normalizedRanges, ((r) => r.startLineNumber <= e.endLineNumberExclusive)) + 1;
    if (t === i) return new Uo([e]);
    const s = [];
    let o = e.startLineNumber;
    for (let r = t; r < i; r++) {
      const a = this._normalizedRanges[r];
      a.startLineNumber > o && s.push(new je(o, a.startLineNumber)), o = a.endLineNumberExclusive;
    }
    return o < e.endLineNumberExclusive && s.push(new je(o, e.endLineNumberExclusive)), new Uo(s);
  }
  toString() {
    return this._normalizedRanges.map(((e) => e.toString())).join(", ");
  }
  getIntersection(e) {
    const t = [];
    let i = 0, s = 0;
    for (; i < this._normalizedRanges.length && s < e._normalizedRanges.length; ) {
      const o = this._normalizedRanges[i], r = e._normalizedRanges[s], a = o.intersect(r);
      a && !a.isEmpty && t.push(a), o.endLineNumberExclusive < r.endLineNumberExclusive ? i++ : s++;
    }
    return new Uo(t);
  }
  getWithDelta(e) {
    return new Uo(this._normalizedRanges.map(((t) => t.delta(e))));
  }
}
class us {
  static inverse(e, t, i) {
    const s = [];
    let o = 1, r = 1;
    for (const l of e) {
      const d = new us(new je(o, l.original.startLineNumber), new je(r, l.modified.startLineNumber));
      d.modified.isEmpty || s.push(d), o = l.original.endLineNumberExclusive, r = l.modified.endLineNumberExclusive;
    }
    const a = new us(new je(o, t + 1), new je(r, i + 1));
    return a.modified.isEmpty || s.push(a), s;
  }
  static clip(e, t, i) {
    const s = [];
    for (const o of e) {
      const r = o.original.intersect(t), a = o.modified.intersect(i);
      r && !r.isEmpty && a && !a.isEmpty && s.push(new us(r, a));
    }
    return s;
  }
  constructor(e, t) {
    this.original = e, this.modified = t;
  }
  toString() {
    return `{${this.original.toString()}->${this.modified.toString()}}`;
  }
  flip() {
    return new us(this.modified, this.original);
  }
  join(e) {
    return new us(this.original.join(e.original), this.modified.join(e.modified));
  }
}
class xo extends us {
  static fromRangeMappings(e) {
    const t = je.join(e.map(((s) => je.fromRangeInclusive(s.originalRange)))), i = je.join(e.map(((s) => je.fromRangeInclusive(s.modifiedRange))));
    return new xo(t, i, e);
  }
  constructor(e, t, i) {
    super(e, t), this.innerChanges = i;
  }
  flip() {
    var e;
    return new xo(this.modified, this.original, (e = this.innerChanges) === null || e === void 0 ? void 0 : e.map(((t) => t.flip())));
  }
  withInnerChangesFromLineRanges() {
    return new xo(this.original, this.modified, [new Fd(this.original.toExclusiveRange(), this.modified.toExclusiveRange())]);
  }
}
class Fd {
  constructor(e, t) {
    this.originalRange = e, this.modifiedRange = t;
  }
  toString() {
    return `{${this.originalRange.toString()}->${this.modifiedRange.toString()}}`;
  }
  flip() {
    return new Fd(this.modifiedRange, this.originalRange);
  }
}
class yq {
  computeDiff(e, t, i) {
    var s;
    const o = new Lq(e, t, { maxComputationTime: i.maxComputationTimeMs, shouldIgnoreTrimWhitespace: i.ignoreTrimWhitespace, shouldComputeCharChanges: !0, shouldMakePrettyDiff: !0, shouldPostProcessCharChanges: !0 }).computeDiff(), r = [];
    let a = null;
    for (const l of o.changes) {
      let d, h;
      d = l.originalEndLineNumber === 0 ? new je(l.originalStartLineNumber + 1, l.originalStartLineNumber + 1) : new je(l.originalStartLineNumber, l.originalEndLineNumber + 1), h = l.modifiedEndLineNumber === 0 ? new je(l.modifiedStartLineNumber + 1, l.modifiedStartLineNumber + 1) : new je(l.modifiedStartLineNumber, l.modifiedEndLineNumber + 1);
      let c = new xo(d, h, (s = l.charChanges) === null || s === void 0 ? void 0 : s.map(((u) => new Fd(new D(u.originalStartLineNumber, u.originalStartColumn, u.originalEndLineNumber, u.originalEndColumn), new D(u.modifiedStartLineNumber, u.modifiedStartColumn, u.modifiedEndLineNumber, u.modifiedEndColumn)))));
      a && (a.modified.endLineNumberExclusive !== c.modified.startLineNumber && a.original.endLineNumberExclusive !== c.original.startLineNumber || (c = new xo(a.original.join(c.original), a.modified.join(c.modified), a.innerChanges && c.innerChanges ? a.innerChanges.concat(c.innerChanges) : void 0), r.pop())), r.push(c), a = c;
    }
    return dg((() => bR(r, ((l, d) => d.original.startLineNumber - l.original.endLineNumberExclusive == d.modified.startLineNumber - l.modified.endLineNumberExclusive && l.original.endLineNumberExclusive < d.original.startLineNumber && l.modified.endLineNumberExclusive < d.modified.startLineNumber)))), new TC(r, [], o.quitEarly);
  }
}
function Z8(n, e, t, i) {
  return new qa(n, e, t).ComputeDiff(i);
}
let o4 = class {
  constructor(n) {
    const e = [], t = [];
    for (let i = 0, s = n.length; i < s; i++) e[i] = VE(n[i], 1), t[i] = HE(n[i], 1);
    this.lines = n, this._startColumns = e, this._endColumns = t;
  }
  getElements() {
    const n = [];
    for (let e = 0, t = this.lines.length; e < t; e++) n[e] = this.lines[e].substring(this._startColumns[e] - 1, this._endColumns[e] - 1);
    return n;
  }
  getStrictElement(n) {
    return this.lines[n];
  }
  getStartLineNumber(n) {
    return n + 1;
  }
  getEndLineNumber(n) {
    return n + 1;
  }
  createCharSequence(n, e, t) {
    const i = [], s = [], o = [];
    let r = 0;
    for (let a = e; a <= t; a++) {
      const l = this.lines[a], d = n ? this._startColumns[a] : 1, h = n ? this._endColumns[a] : l.length + 1;
      for (let c = d; c < h; c++) i[r] = l.charCodeAt(c - 1), s[r] = a + 1, o[r] = c, r++;
      !n && a < t && (i[r] = 10, s[r] = a + 1, o[r] = l.length + 1, r++);
    }
    return new Sq(i, s, o);
  }
};
class Sq {
  constructor(e, t, i) {
    this._charCodes = e, this._lineNumbers = t, this._columns = i;
  }
  toString() {
    return "[" + this._charCodes.map(((e, t) => (e === 10 ? "\\n" : String.fromCharCode(e)) + `-(${this._lineNumbers[t]},${this._columns[t]})`)).join(", ") + "]";
  }
  _assertIndex(e, t) {
    if (e < 0 || e >= t.length) throw new Error("Illegal index");
  }
  getElements() {
    return this._charCodes;
  }
  getStartLineNumber(e) {
    return e > 0 && e === this._lineNumbers.length ? this.getEndLineNumber(e - 1) : (this._assertIndex(e, this._lineNumbers), this._lineNumbers[e]);
  }
  getEndLineNumber(e) {
    return e === -1 ? this.getStartLineNumber(e + 1) : (this._assertIndex(e, this._lineNumbers), this._charCodes[e] === 10 ? this._lineNumbers[e] + 1 : this._lineNumbers[e]);
  }
  getStartColumn(e) {
    return e > 0 && e === this._columns.length ? this.getEndColumn(e - 1) : (this._assertIndex(e, this._columns), this._columns[e]);
  }
  getEndColumn(e) {
    return e === -1 ? this.getStartColumn(e + 1) : (this._assertIndex(e, this._columns), this._charCodes[e] === 10 ? 1 : this._columns[e] + 1);
  }
}
class tm {
  constructor(e, t, i, s, o, r, a, l) {
    this.originalStartLineNumber = e, this.originalStartColumn = t, this.originalEndLineNumber = i, this.originalEndColumn = s, this.modifiedStartLineNumber = o, this.modifiedStartColumn = r, this.modifiedEndLineNumber = a, this.modifiedEndColumn = l;
  }
  static createFromDiffChange(e, t, i) {
    const s = t.getStartLineNumber(e.originalStart), o = t.getStartColumn(e.originalStart), r = t.getEndLineNumber(e.originalStart + e.originalLength - 1), a = t.getEndColumn(e.originalStart + e.originalLength - 1), l = i.getStartLineNumber(e.modifiedStart), d = i.getStartColumn(e.modifiedStart), h = i.getEndLineNumber(e.modifiedStart + e.modifiedLength - 1), c = i.getEndColumn(e.modifiedStart + e.modifiedLength - 1);
    return new tm(s, o, r, a, l, d, h, c);
  }
}
class Z_ {
  constructor(e, t, i, s, o) {
    this.originalStartLineNumber = e, this.originalEndLineNumber = t, this.modifiedStartLineNumber = i, this.modifiedEndLineNumber = s, this.charChanges = o;
  }
  static createFromDiffResult(e, t, i, s, o, r, a) {
    let l, d, h, c, u;
    if (t.originalLength === 0 ? (l = i.getStartLineNumber(t.originalStart) - 1, d = 0) : (l = i.getStartLineNumber(t.originalStart), d = i.getEndLineNumber(t.originalStart + t.originalLength - 1)), t.modifiedLength === 0 ? (h = s.getStartLineNumber(t.modifiedStart) - 1, c = 0) : (h = s.getStartLineNumber(t.modifiedStart), c = s.getEndLineNumber(t.modifiedStart + t.modifiedLength - 1)), r && t.originalLength > 0 && t.originalLength < 20 && t.modifiedLength > 0 && t.modifiedLength < 20 && o()) {
      const g = i.createCharSequence(e, t.originalStart, t.originalStart + t.originalLength - 1), p = s.createCharSequence(e, t.modifiedStart, t.modifiedStart + t.modifiedLength - 1);
      if (g.getElements().length > 0 && p.getElements().length > 0) {
        let f = Z8(g, p, o, !0).changes;
        a && (f = (function(_) {
          if (_.length <= 1) return _;
          const v = [_[0]];
          let b = v[0];
          for (let C = 1, w = _.length; C < w; C++) {
            const y = _[C], L = y.originalStart - (b.originalStart + b.originalLength), k = y.modifiedStart - (b.modifiedStart + b.modifiedLength);
            Math.min(L, k) < 3 ? (b.originalLength = y.originalStart + y.originalLength - b.originalStart, b.modifiedLength = y.modifiedStart + y.modifiedLength - b.modifiedStart) : (v.push(y), b = y);
          }
          return v;
        })(f)), u = [];
        for (let _ = 0, v = f.length; _ < v; _++) u.push(tm.createFromDiffChange(f[_], g, p));
      }
    }
    return new Z_(l, d, h, c, u);
  }
}
class Lq {
  constructor(e, t, i) {
    this.shouldComputeCharChanges = i.shouldComputeCharChanges, this.shouldPostProcessCharChanges = i.shouldPostProcessCharChanges, this.shouldIgnoreTrimWhitespace = i.shouldIgnoreTrimWhitespace, this.shouldMakePrettyDiff = i.shouldMakePrettyDiff, this.originalLines = e, this.modifiedLines = t, this.original = new o4(e), this.modified = new o4(t), this.continueLineDiff = r4(i.maxComputationTime), this.continueCharDiff = r4(i.maxComputationTime === 0 ? 0 : Math.min(i.maxComputationTime, 5e3));
  }
  computeDiff() {
    if (this.original.lines.length === 1 && this.original.lines[0].length === 0) return this.modified.lines.length === 1 && this.modified.lines[0].length === 0 ? { quitEarly: !1, changes: [] } : { quitEarly: !1, changes: [{ originalStartLineNumber: 1, originalEndLineNumber: 1, modifiedStartLineNumber: 1, modifiedEndLineNumber: this.modified.lines.length, charChanges: void 0 }] };
    if (this.modified.lines.length === 1 && this.modified.lines[0].length === 0) return { quitEarly: !1, changes: [{ originalStartLineNumber: 1, originalEndLineNumber: this.original.lines.length, modifiedStartLineNumber: 1, modifiedEndLineNumber: 1, charChanges: void 0 }] };
    const e = Z8(this.original, this.modified, this.continueLineDiff, this.shouldMakePrettyDiff), t = e.changes, i = e.quitEarly;
    if (this.shouldIgnoreTrimWhitespace) {
      const a = [];
      for (let l = 0, d = t.length; l < d; l++) a.push(Z_.createFromDiffResult(this.shouldIgnoreTrimWhitespace, t[l], this.original, this.modified, this.continueCharDiff, this.shouldComputeCharChanges, this.shouldPostProcessCharChanges));
      return { quitEarly: i, changes: a };
    }
    const s = [];
    let o = 0, r = 0;
    for (let a = -1, l = t.length; a < l; a++) {
      const d = a + 1 < l ? t[a + 1] : null, h = d ? d.originalStart : this.originalLines.length, c = d ? d.modifiedStart : this.modifiedLines.length;
      for (; o < h && r < c; ) {
        const u = this.originalLines[o], g = this.modifiedLines[r];
        if (u !== g) {
          {
            let p = VE(u, 1), f = VE(g, 1);
            for (; p > 1 && f > 1 && u.charCodeAt(p - 2) === g.charCodeAt(f - 2); )
              p--, f--;
            (p > 1 || f > 1) && this._pushTrimWhitespaceCharChange(s, o + 1, 1, p, r + 1, 1, f);
          }
          {
            let p = HE(u, 1), f = HE(g, 1);
            const _ = u.length + 1, v = g.length + 1;
            for (; p < _ && f < v && u.charCodeAt(p - 1) === u.charCodeAt(f - 1); )
              p++, f++;
            (p < _ || f < v) && this._pushTrimWhitespaceCharChange(s, o + 1, p, _, r + 1, f, v);
          }
        }
        o++, r++;
      }
      d && (s.push(Z_.createFromDiffResult(this.shouldIgnoreTrimWhitespace, d, this.original, this.modified, this.continueCharDiff, this.shouldComputeCharChanges, this.shouldPostProcessCharChanges)), o += d.originalLength, r += d.modifiedLength);
    }
    return { quitEarly: i, changes: s };
  }
  _pushTrimWhitespaceCharChange(e, t, i, s, o, r, a) {
    if (this._mergeTrimWhitespaceCharChange(e, t, i, s, o, r, a)) return;
    let l;
    this.shouldComputeCharChanges && (l = [new tm(t, i, t, s, o, r, o, a)]), e.push(new Z_(t, t, o, o, l));
  }
  _mergeTrimWhitespaceCharChange(e, t, i, s, o, r, a) {
    const l = e.length;
    if (l === 0) return !1;
    const d = e[l - 1];
    return d.originalEndLineNumber !== 0 && d.modifiedEndLineNumber !== 0 && (d.originalEndLineNumber === t && d.modifiedEndLineNumber === o ? (this.shouldComputeCharChanges && d.charChanges && d.charChanges.push(new tm(t, i, t, s, o, r, o, a)), !0) : d.originalEndLineNumber + 1 === t && d.modifiedEndLineNumber + 1 === o && (d.originalEndLineNumber = t, d.modifiedEndLineNumber = o, this.shouldComputeCharChanges && d.charChanges && d.charChanges.push(new tm(t, i, t, s, o, r, o, a)), !0));
  }
}
function VE(n, e) {
  const t = Jn(n);
  return t === -1 ? e : t + 1;
}
function HE(n, e) {
  const t = oa(n);
  return t === -1 ? e : t + 2;
}
function r4(n) {
  if (n === 0) return () => !0;
  const e = Date.now();
  return () => Date.now() - e < n;
}
class Dd {
  static trivial(e, t) {
    return new Dd([new Ji(qe.ofLength(e.length), qe.ofLength(t.length))], !1);
  }
  static trivialTimedOut(e, t) {
    return new Dd([new Ji(qe.ofLength(e.length), qe.ofLength(t.length))], !0);
  }
  constructor(e, t) {
    this.diffs = e, this.hitTimeout = t;
  }
}
class Ji {
  static invert(e, t) {
    const i = [];
    return g7(e, ((s, o) => {
      i.push(Ji.fromOffsetPairs(s ? s.getEndExclusives() : qo.zero, o ? o.getStarts() : new qo(t, (s ? s.seq2Range.endExclusive - s.seq1Range.endExclusive : 0) + t)));
    })), i;
  }
  static fromOffsetPairs(e, t) {
    return new Ji(new qe(e.offset1, t.offset1), new qe(e.offset2, t.offset2));
  }
  constructor(e, t) {
    this.seq1Range = e, this.seq2Range = t;
  }
  swap() {
    return new Ji(this.seq2Range, this.seq1Range);
  }
  toString() {
    return `${this.seq1Range} <-> ${this.seq2Range}`;
  }
  join(e) {
    return new Ji(this.seq1Range.join(e.seq1Range), this.seq2Range.join(e.seq2Range));
  }
  delta(e) {
    return e === 0 ? this : new Ji(this.seq1Range.delta(e), this.seq2Range.delta(e));
  }
  deltaStart(e) {
    return e === 0 ? this : new Ji(this.seq1Range.deltaStart(e), this.seq2Range.deltaStart(e));
  }
  deltaEnd(e) {
    return e === 0 ? this : new Ji(this.seq1Range.deltaEnd(e), this.seq2Range.deltaEnd(e));
  }
  intersect(e) {
    const t = this.seq1Range.intersect(e.seq1Range), i = this.seq2Range.intersect(e.seq2Range);
    if (t && i) return new Ji(t, i);
  }
  getStarts() {
    return new qo(this.seq1Range.start, this.seq2Range.start);
  }
  getEndExclusives() {
    return new qo(this.seq1Range.endExclusive, this.seq2Range.endExclusive);
  }
}
class qo {
  constructor(e, t) {
    this.offset1 = e, this.offset2 = t;
  }
  toString() {
    return `${this.offset1} <-> ${this.offset2}`;
  }
  delta(e) {
    return e === 0 ? this : new qo(this.offset1 + e, this.offset2 + e);
  }
  equals(e) {
    return this.offset1 === e.offset1 && this.offset2 === e.offset2;
  }
}
qo.zero = new qo(0, 0), qo.max = new qo(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
class rv {
  isValid() {
    return !0;
  }
}
rv.instance = new rv();
class kq {
  constructor(e) {
    if (this.timeout = e, this.startTime = Date.now(), this.valid = !0, e <= 0) throw new Kt("timeout must be positive");
  }
  isValid() {
    return !(Date.now() - this.startTime < this.timeout) && this.valid && (this.valid = !1), this.valid;
  }
}
class aD {
  constructor(e, t) {
    this.width = e, this.height = t, this.array = [], this.array = new Array(e * t);
  }
  get(e, t) {
    return this.array[e + t * this.width];
  }
  set(e, t, i) {
    this.array[e + t * this.width] = i;
  }
}
function zE(n) {
  return n === 32 || n === 9;
}
class Wm {
  static getKey(e) {
    let t = this.chrKeys.get(e);
    return t === void 0 && (t = this.chrKeys.size, this.chrKeys.set(e, t)), t;
  }
  constructor(e, t, i) {
    this.range = e, this.lines = t, this.source = i, this.histogram = [];
    let s = 0;
    for (let o = e.startLineNumber - 1; o < e.endLineNumberExclusive - 1; o++) {
      const r = t[o];
      for (let l = 0; l < r.length; l++) {
        s++;
        const d = r[l], h = Wm.getKey(d);
        this.histogram[h] = (this.histogram[h] || 0) + 1;
      }
      s++;
      const a = Wm.getKey(`
`);
      this.histogram[a] = (this.histogram[a] || 0) + 1;
    }
    this.totalCount = s;
  }
  computeSimilarity(e) {
    var t, i;
    let s = 0;
    const o = Math.max(this.histogram.length, e.histogram.length);
    for (let r = 0; r < o; r++) s += Math.abs(((t = this.histogram[r]) !== null && t !== void 0 ? t : 0) - ((i = e.histogram[r]) !== null && i !== void 0 ? i : 0));
    return 1 - s / (this.totalCount + e.totalCount);
  }
}
Wm.chrKeys = /* @__PURE__ */ new Map();
class Dq {
  compute(e, t, i = rv.instance, s) {
    if (e.length === 0 || t.length === 0) return Dd.trivial(e, t);
    const o = new aD(e.length, t.length), r = new aD(e.length, t.length), a = new aD(e.length, t.length);
    for (let p = 0; p < e.length; p++) for (let f = 0; f < t.length; f++) {
      if (!i.isValid()) return Dd.trivialTimedOut(e, t);
      const _ = p === 0 ? 0 : o.get(p - 1, f), v = f === 0 ? 0 : o.get(p, f - 1);
      let b;
      e.getElement(p) === t.getElement(f) ? (b = p === 0 || f === 0 ? 0 : o.get(p - 1, f - 1), p > 0 && f > 0 && r.get(p - 1, f - 1) === 3 && (b += a.get(p - 1, f - 1)), b += s ? s(p, f) : 1) : b = -1;
      const C = Math.max(_, v, b);
      if (C === b) {
        const w = p > 0 && f > 0 ? a.get(p - 1, f - 1) : 0;
        a.set(p, f, w + 1), r.set(p, f, 3);
      } else C === _ ? (a.set(p, f, 0), r.set(p, f, 1)) : C === v && (a.set(p, f, 0), r.set(p, f, 2));
      o.set(p, f, C);
    }
    const l = [];
    let d = e.length, h = t.length;
    function c(p, f) {
      p + 1 === d && f + 1 === h || l.push(new Ji(new qe(p + 1, d), new qe(f + 1, h))), d = p, h = f;
    }
    let u = e.length - 1, g = t.length - 1;
    for (; u >= 0 && g >= 0; ) r.get(u, g) === 3 ? (c(u, g), u--, g--) : r.get(u, g) === 1 ? u-- : g--;
    return c(-1, -1), l.reverse(), new Dd(l, !1);
  }
}
class Y8 {
  compute(e, t, i = rv.instance) {
    if (e.length === 0 || t.length === 0) return Dd.trivial(e, t);
    const s = e, o = t;
    function r(f, _) {
      for (; f < s.length && _ < o.length && s.getElement(f) === o.getElement(_); ) f++, _++;
      return f;
    }
    let a = 0;
    const l = new xq();
    l.set(0, r(0, 0));
    const d = new Nq();
    d.set(0, l.get(0) === 0 ? null : new a4(null, 0, 0, l.get(0)));
    let h = 0;
    e: for (; ; ) {
      if (a++, !i.isValid()) return Dd.trivialTimedOut(s, o);
      const f = -Math.min(a, o.length + a % 2), _ = Math.min(a, s.length + a % 2);
      for (h = f; h <= _; h += 2) {
        const v = h === _ ? -1 : l.get(h + 1), b = h === f ? -1 : l.get(h - 1) + 1, C = Math.min(Math.max(v, b), s.length), w = C - h;
        if (C > s.length || w > o.length) continue;
        const y = r(C, w);
        l.set(h, y);
        const L = C === v ? d.get(h + 1) : d.get(h - 1);
        if (d.set(h, y !== C ? new a4(L, C, w, y - C) : L), l.get(h) === s.length && l.get(h) - h === o.length) break e;
      }
    }
    let c = d.get(h);
    const u = [];
    let g = s.length, p = o.length;
    for (; ; ) {
      const f = c ? c.x + c.length : 0, _ = c ? c.y + c.length : 0;
      if (f === g && _ === p || u.push(new Ji(new qe(f, g), new qe(_, p))), !c) break;
      g = c.x, p = c.y, c = c.prev;
    }
    return u.reverse(), new Dd(u, !1);
  }
}
class a4 {
  constructor(e, t, i, s) {
    this.prev = e, this.x = t, this.y = i, this.length = s;
  }
}
class xq {
  constructor() {
    this.positiveArr = new Int32Array(10), this.negativeArr = new Int32Array(10);
  }
  get(e) {
    return e < 0 ? (e = -e - 1, this.negativeArr[e]) : this.positiveArr[e];
  }
  set(e, t) {
    if (e < 0) {
      if ((e = -e - 1) >= this.negativeArr.length) {
        const i = this.negativeArr;
        this.negativeArr = new Int32Array(2 * i.length), this.negativeArr.set(i);
      }
      this.negativeArr[e] = t;
    } else {
      if (e >= this.positiveArr.length) {
        const i = this.positiveArr;
        this.positiveArr = new Int32Array(2 * i.length), this.positiveArr.set(i);
      }
      this.positiveArr[e] = t;
    }
  }
}
class Nq {
  constructor() {
    this.positiveArr = [], this.negativeArr = [];
  }
  get(e) {
    return e < 0 ? (e = -e - 1, this.negativeArr[e]) : this.positiveArr[e];
  }
  set(e, t) {
    e < 0 ? (e = -e - 1, this.negativeArr[e] = t) : this.positiveArr[e] = t;
  }
}
class Jw {
  constructor(e, t, i) {
    this.lines = e, this.considerWhitespaceChanges = i, this.elements = [], this.firstCharOffsetByLine = [], this.additionalOffsetByLine = [];
    let s = !1;
    t.start > 0 && t.endExclusive >= e.length && (t = new qe(t.start - 1, t.endExclusive), s = !0), this.lineRange = t, this.firstCharOffsetByLine[0] = 0;
    for (let o = this.lineRange.start; o < this.lineRange.endExclusive; o++) {
      let r = e[o], a = 0;
      if (s) a = r.length, r = "", s = !1;
      else if (!i) {
        const l = r.trimStart();
        a = r.length - l.length, r = l.trimEnd();
      }
      this.additionalOffsetByLine.push(a);
      for (let l = 0; l < r.length; l++) this.elements.push(r.charCodeAt(l));
      o < e.length - 1 && (this.elements.push(10), this.firstCharOffsetByLine[o - this.lineRange.start + 1] = this.elements.length);
    }
    this.additionalOffsetByLine.push(0);
  }
  toString() {
    return `Slice: "${this.text}"`;
  }
  get text() {
    return this.getText(new qe(0, this.length));
  }
  getText(e) {
    return this.elements.slice(e.start, e.endExclusive).map(((t) => String.fromCharCode(t))).join("");
  }
  getElement(e) {
    return this.elements[e];
  }
  get length() {
    return this.elements.length;
  }
  getBoundaryScore(e) {
    const t = d4(e > 0 ? this.elements[e - 1] : -1), i = d4(e < this.elements.length ? this.elements[e] : -1);
    if (t === 7 && i === 8) return 0;
    if (t === 8) return 150;
    let s = 0;
    return t !== i && (s += 10, t === 0 && i === 1 && (s += 1)), s += l4(t), s += l4(i), s;
  }
  translateOffset(e) {
    if (this.lineRange.isEmpty) return new W(this.lineRange.start + 1, 1);
    const t = nv(this.firstCharOffsetByLine, ((i) => i <= e));
    return new W(this.lineRange.start + t + 1, e - this.firstCharOffsetByLine[t] + this.additionalOffsetByLine[t] + 1);
  }
  translateRange(e) {
    return D.fromPositions(this.translateOffset(e.start), this.translateOffset(e.endExclusive));
  }
  findWordContaining(e) {
    if (e < 0 || e >= this.elements.length || !lD(this.elements[e])) return;
    let t = e;
    for (; t > 0 && lD(this.elements[t - 1]); ) t--;
    let i = e;
    for (; i < this.elements.length && lD(this.elements[i]); ) i++;
    return new qe(t, i);
  }
  countLinesIn(e) {
    return this.translateOffset(e.endExclusive).lineNumber - this.translateOffset(e.start).lineNumber;
  }
  isStronglyEqual(e, t) {
    return this.elements[e] === this.elements[t];
  }
  extendToFullLines(e) {
    var t, i;
    const s = (t = em(this.firstCharOffsetByLine, ((r) => r <= e.start))) !== null && t !== void 0 ? t : 0, o = (i = (function(r, a) {
      const l = sv(r, a);
      return l === r.length ? void 0 : r[l];
    })(this.firstCharOffsetByLine, ((r) => e.endExclusive <= r))) !== null && i !== void 0 ? i : this.elements.length;
    return new qe(s, o);
  }
}
function lD(n) {
  return n >= 97 && n <= 122 || n >= 65 && n <= 90 || n >= 48 && n <= 57;
}
const Eq = { 0: 0, 1: 0, 2: 0, 3: 10, 4: 2, 5: 30, 6: 3, 7: 10, 8: 10 };
function l4(n) {
  return Eq[n];
}
function d4(n) {
  return n === 10 ? 8 : n === 13 ? 7 : zE(n) ? 6 : n >= 97 && n <= 122 ? 0 : n >= 65 && n <= 90 ? 1 : n >= 48 && n <= 57 ? 2 : n === -1 ? 3 : n === 44 || n === 59 ? 5 : 4;
}
function Iq(n, e, t, i, s, o) {
  let { moves: r, excludedChanges: a } = (function(d, h, c, u) {
    const g = [], p = d.filter(((v) => v.modified.isEmpty && v.original.length >= 3)).map(((v) => new Wm(v.original, h, v))), f = new Set(d.filter(((v) => v.original.isEmpty && v.modified.length >= 3)).map(((v) => new Wm(v.modified, c, v)))), _ = /* @__PURE__ */ new Set();
    for (const v of p) {
      let b, C = -1;
      for (const w of f) {
        const y = v.computeSimilarity(w);
        y > C && (C = y, b = w);
      }
      if (C > 0.9 && b && (f.delete(b), g.push(new us(v.range, b.range)), _.add(v.source), _.add(b.source)), !u.isValid()) return { moves: g, excludedChanges: _ };
    }
    return { moves: g, excludedChanges: _ };
  })(n, e, t, o);
  if (!o.isValid()) return [];
  const l = (function(d, h, c, u, g, p) {
    const f = [], _ = new wR();
    for (const y of d) for (let L = y.original.startLineNumber; L < y.original.endLineNumberExclusive - 2; L++) {
      const k = `${h[L - 1]}:${h[L + 1 - 1]}:${h[L + 2 - 1]}`;
      _.add(k, { range: new je(L, L + 3) });
    }
    const v = [];
    d.sort(jo(((y) => y.modified.startLineNumber), od));
    for (const y of d) {
      let L = [];
      for (let k = y.modified.startLineNumber; k < y.modified.endLineNumberExclusive - 2; k++) {
        const N = `${c[k - 1]}:${c[k + 1 - 1]}:${c[k + 2 - 1]}`, A = new je(k, k + 3), B = [];
        _.forEach(N, (({ range: T }) => {
          for (const H of L) if (H.originalLineRange.endLineNumberExclusive + 1 === T.endLineNumberExclusive && H.modifiedLineRange.endLineNumberExclusive + 1 === A.endLineNumberExclusive) return H.originalLineRange = new je(H.originalLineRange.startLineNumber, T.endLineNumberExclusive), H.modifiedLineRange = new je(H.modifiedLineRange.startLineNumber, A.endLineNumberExclusive), void B.push(H);
          const O = { modifiedLineRange: A, originalLineRange: T };
          v.push(O), B.push(O);
        })), L = B;
      }
      if (!p.isValid()) return [];
    }
    v.sort(m7(jo(((y) => y.modifiedLineRange.length), od)));
    const b = new Uo(), C = new Uo();
    for (const y of v) {
      const L = y.modifiedLineRange.startLineNumber - y.originalLineRange.startLineNumber, k = b.subtractFrom(y.modifiedLineRange), N = C.subtractFrom(y.originalLineRange).getWithDelta(L), A = k.getIntersection(N);
      for (const B of A.ranges) {
        if (B.length < 3) continue;
        const T = B, O = B.delta(-L);
        f.push(new us(O, T)), b.addRange(T), C.addRange(O);
      }
    }
    f.sort(jo(((y) => y.original.startLineNumber), od));
    const w = new ov(d);
    for (let y = 0; y < f.length; y++) {
      const L = f[y], k = w.findLastMonotonous(((pe) => pe.original.startLineNumber <= L.original.startLineNumber)), N = em(d, ((pe) => pe.modified.startLineNumber <= L.modified.startLineNumber)), A = Math.max(L.original.startLineNumber - k.original.startLineNumber, L.modified.startLineNumber - N.modified.startLineNumber), B = w.findLastMonotonous(((pe) => pe.original.startLineNumber < L.original.endLineNumberExclusive)), T = em(d, ((pe) => pe.modified.startLineNumber < L.modified.endLineNumberExclusive)), O = Math.max(B.original.endLineNumberExclusive - L.original.endLineNumberExclusive, T.modified.endLineNumberExclusive - L.modified.endLineNumberExclusive);
      let H, $;
      for (H = 0; H < A; H++) {
        const pe = L.original.startLineNumber - H - 1, me = L.modified.startLineNumber - H - 1;
        if (pe > u.length || me > g.length || b.contains(me) || C.contains(pe) || !h4(u[pe - 1], g[me - 1], p)) break;
      }
      for (H > 0 && (C.addRange(new je(L.original.startLineNumber - H, L.original.startLineNumber)), b.addRange(new je(L.modified.startLineNumber - H, L.modified.startLineNumber))), $ = 0; $ < O; $++) {
        const pe = L.original.endLineNumberExclusive + $, me = L.modified.endLineNumberExclusive + $;
        if (pe > u.length || me > g.length || b.contains(me) || C.contains(pe) || !h4(u[pe - 1], g[me - 1], p)) break;
      }
      $ > 0 && (C.addRange(new je(L.original.endLineNumberExclusive, L.original.endLineNumberExclusive + $)), b.addRange(new je(L.modified.endLineNumberExclusive, L.modified.endLineNumberExclusive + $))), (H > 0 || $ > 0) && (f[y] = new us(new je(L.original.startLineNumber - H, L.original.endLineNumberExclusive + $), new je(L.modified.startLineNumber - H, L.modified.endLineNumberExclusive + $)));
    }
    return f;
  })(n.filter(((d) => !a.has(d))), i, s, e, t, o);
  return wN(r, l), r = (function(d) {
    if (d.length === 0) return d;
    d.sort(jo(((c) => c.original.startLineNumber), od));
    const h = [d[0]];
    for (let c = 1; c < d.length; c++) {
      const u = h[h.length - 1], g = d[c], p = g.original.startLineNumber - u.original.endLineNumberExclusive, f = g.modified.startLineNumber - u.modified.endLineNumberExclusive;
      p >= 0 && f >= 0 && p + f <= 2 ? h[h.length - 1] = u.join(g) : h.push(g);
    }
    return h;
  })(r), r = r.filter(((d) => {
    const h = d.original.toOffsetRange().slice(e).map(((c) => c.trim()));
    return h.join(`
`).length >= 15 && (function(c, u) {
      let g = 0;
      for (const p of c) u(p) && g++;
      return g;
    })(h, ((c) => c.length >= 2)) >= 2;
  })), r = (function(d, h) {
    const c = new ov(d);
    return h = h.filter(((u) => (c.findLastMonotonous(((g) => g.original.startLineNumber < u.original.endLineNumberExclusive)) || new us(new je(1, 1), new je(1, 1))) !== em(d, ((g) => g.modified.startLineNumber < u.modified.endLineNumberExclusive)))), h;
  })(n, r), r;
}
function h4(n, e, t) {
  if (n.trim() === e.trim()) return !0;
  if (n.length > 300 && e.length > 300) return !1;
  const i = new Y8().compute(new Jw([n], new qe(0, 1), !1), new Jw([e], new qe(0, 1), !1), t);
  let s = 0;
  const o = Ji.invert(i.diffs, n.length);
  for (const a of o) a.seq1Range.forEach(((l) => {
    zE(n.charCodeAt(l)) || s++;
  }));
  const r = (function(a) {
    let l = 0;
    for (let d = 0; d < n.length; d++) zE(a.charCodeAt(d)) || l++;
    return l;
  })(n.length > e.length ? n : e);
  return s / r > 0.6 && r > 10;
}
function UE(n, e, t) {
  let i = t;
  return i = c4(n, e, i), i = c4(n, e, i), i = (function(s, o, r) {
    if (!s.getBoundaryScore || !o.getBoundaryScore) return r;
    for (let a = 0; a < r.length; a++) {
      const l = a > 0 ? r[a - 1] : void 0, d = r[a], h = a + 1 < r.length ? r[a + 1] : void 0, c = new qe(l ? l.seq1Range.endExclusive + 1 : 0, h ? h.seq1Range.start - 1 : s.length), u = new qe(l ? l.seq2Range.endExclusive + 1 : 0, h ? h.seq2Range.start - 1 : o.length);
      d.seq1Range.isEmpty ? r[a] = u4(d, s, o, c, u) : d.seq2Range.isEmpty && (r[a] = u4(d.swap(), o, s, u, c).swap());
    }
    return r;
  })(n, e, i), i;
}
function c4(n, e, t) {
  if (t.length === 0) return t;
  const i = [];
  i.push(t[0]);
  for (let o = 1; o < t.length; o++) {
    const r = i[i.length - 1];
    let a = t[o];
    if (a.seq1Range.isEmpty || a.seq2Range.isEmpty) {
      const l = a.seq1Range.start - r.seq1Range.endExclusive;
      let d;
      for (d = 1; d <= l && n.getElement(a.seq1Range.start - d) === n.getElement(a.seq1Range.endExclusive - d) && e.getElement(a.seq2Range.start - d) === e.getElement(a.seq2Range.endExclusive - d); d++) ;
      if (d--, d === l) {
        i[i.length - 1] = new Ji(new qe(r.seq1Range.start, a.seq1Range.endExclusive - l), new qe(r.seq2Range.start, a.seq2Range.endExclusive - l));
        continue;
      }
      a = a.delta(-d);
    }
    i.push(a);
  }
  const s = [];
  for (let o = 0; o < i.length - 1; o++) {
    const r = i[o + 1];
    let a = i[o];
    if (a.seq1Range.isEmpty || a.seq2Range.isEmpty) {
      const l = r.seq1Range.start - a.seq1Range.endExclusive;
      let d;
      for (d = 0; d < l && n.isStronglyEqual(a.seq1Range.start + d, a.seq1Range.endExclusive + d) && e.isStronglyEqual(a.seq2Range.start + d, a.seq2Range.endExclusive + d); d++) ;
      if (d === l) {
        i[o + 1] = new Ji(new qe(a.seq1Range.start + l, r.seq1Range.endExclusive), new qe(a.seq2Range.start + l, r.seq2Range.endExclusive));
        continue;
      }
      d > 0 && (a = a.delta(d));
    }
    s.push(a);
  }
  return i.length > 0 && s.push(i[i.length - 1]), s;
}
function u4(n, e, t, i, s) {
  let o = 1;
  for (; n.seq1Range.start - o >= i.start && n.seq2Range.start - o >= s.start && t.isStronglyEqual(n.seq2Range.start - o, n.seq2Range.endExclusive - o) && o < 100; ) o++;
  o--;
  let r = 0;
  for (; n.seq1Range.start + r < i.endExclusive && n.seq2Range.endExclusive + r < s.endExclusive && t.isStronglyEqual(n.seq2Range.start + r, n.seq2Range.endExclusive + r) && r < 100; ) r++;
  if (o === 0 && r === 0) return n;
  let a = 0, l = -1;
  for (let d = -o; d <= r; d++) {
    const h = n.seq2Range.start + d, c = n.seq2Range.endExclusive + d, u = n.seq1Range.start + d, g = e.getBoundaryScore(u) + t.getBoundaryScore(h) + t.getBoundaryScore(c);
    g > l && (l = g, a = d);
  }
  return n.delta(a);
}
class g4 {
  constructor(e, t) {
    this.trimmedHash = e, this.lines = t;
  }
  getElement(e) {
    return this.trimmedHash[e];
  }
  get length() {
    return this.trimmedHash.length;
  }
  getBoundaryScore(e) {
    return 1e3 - ((e === 0 ? 0 : p4(this.lines[e - 1])) + (e === this.lines.length ? 0 : p4(this.lines[e])));
  }
  getText(e) {
    return this.lines.slice(e.start, e.endExclusive).join(`
`);
  }
  isStronglyEqual(e, t) {
    return this.lines[e] === this.lines[t];
  }
}
function p4(n) {
  let e = 0;
  for (; e < n.length && (n.charCodeAt(e) === 32 || n.charCodeAt(e) === 9); ) e++;
  return e;
}
class X8 {
  constructor() {
    this.dynamicProgrammingDiffing = new Dq(), this.myersDiffingAlgorithm = new Y8();
  }
  computeDiff(e, t, i) {
    if (e.length <= 1 && ri(e, t, ((y, L) => y === L))) return new TC([], [], !1);
    if (e.length === 1 && e[0].length === 0 || t.length === 1 && t[0].length === 0) return new TC([new xo(new je(1, e.length + 1), new je(1, t.length + 1), [new Fd(new D(1, 1, e.length, e[0].length + 1), new D(1, 1, t.length, t[0].length + 1))])], [], !1);
    const s = i.maxComputationTimeMs === 0 ? rv.instance : new kq(i.maxComputationTimeMs), o = !i.ignoreTrimWhitespace, r = /* @__PURE__ */ new Map();
    function a(y) {
      let L = r.get(y);
      return L === void 0 && (L = r.size, r.set(y, L)), L;
    }
    const l = e.map(((y) => a(y.trim()))), d = t.map(((y) => a(y.trim()))), h = new g4(l, e), c = new g4(d, t), u = h.length + c.length < 1700 ? this.dynamicProgrammingDiffing.compute(h, c, s, ((y, L) => e[y] === t[L] ? t[L].length === 0 ? 0.1 : 1 + Math.log(1 + t[L].length) : 0.99)) : this.myersDiffingAlgorithm.compute(h, c);
    let g = u.diffs, p = u.hitTimeout;
    g = UE(h, c, g), g = (function(y, L, k) {
      let N = k;
      if (N.length === 0) return N;
      let A, B = 0;
      do {
        A = !1;
        const T = [N[0]];
        for (let O = 1; O < N.length; O++) {
          let pe = function(me, ue) {
            const ee = new qe($.seq1Range.endExclusive, H.seq1Range.start);
            return y.getText(ee).replace(/\s/g, "").length <= 4 && (me.seq1Range.length + me.seq2Range.length > 5 || ue.seq1Range.length + ue.seq2Range.length > 5);
          };
          const H = N[O], $ = T[T.length - 1];
          pe($, H) ? (A = !0, T[T.length - 1] = T[T.length - 1].join(H)) : T.push(H);
        }
        N = T;
      } while (B++ < 10 && A);
      return N;
    })(h, 0, g);
    const f = [], _ = (y) => {
      if (o) for (let L = 0; L < y; L++) {
        const k = v + L, N = b + L;
        if (e[k] !== t[N]) {
          const A = this.refineDiff(e, t, new Ji(new qe(k, k + 1), new qe(N, N + 1)), s, o);
          for (const B of A.mappings) f.push(B);
          A.hitTimeout && (p = !0);
        }
      }
    };
    let v = 0, b = 0;
    for (const y of g) {
      dg((() => y.seq1Range.start - v == y.seq2Range.start - b)), _(y.seq1Range.start - v), v = y.seq1Range.endExclusive, b = y.seq2Range.endExclusive;
      const L = this.refineDiff(e, t, y, s, o);
      L.hitTimeout && (p = !0);
      for (const k of L.mappings) f.push(k);
    }
    _(e.length - v);
    const C = m4(f, e, t);
    let w = [];
    return i.computeMoves && (w = this.computeMoves(C, e, t, l, d, s, o)), dg((() => {
      function y(k, N) {
        if (k.lineNumber < 1 || k.lineNumber > N.length) return !1;
        const A = N[k.lineNumber - 1];
        return !(k.column < 1 || k.column > A.length + 1);
      }
      function L(k, N) {
        return !(k.startLineNumber < 1 || k.startLineNumber > N.length + 1) && !(k.endLineNumberExclusive < 1 || k.endLineNumberExclusive > N.length + 1);
      }
      for (const k of C) {
        if (!k.innerChanges) return !1;
        for (const N of k.innerChanges)
          if (!(y(N.modifiedRange.getStartPosition(), t) && y(N.modifiedRange.getEndPosition(), t) && y(N.originalRange.getStartPosition(), e) && y(N.originalRange.getEndPosition(), e))) return !1;
        if (!L(k.modified, t) || !L(k.original, e)) return !1;
      }
      return !0;
    })), new TC(C, w, p);
  }
  computeMoves(e, t, i, s, o, r, a) {
    return Iq(e, t, i, s, o, r).map(((l) => {
      const d = m4(this.refineDiff(t, i, new Ji(l.original.toOffsetRange(), l.modified.toOffsetRange()), r, a).mappings, t, i, !0);
      return new G8(l, d);
    }));
  }
  refineDiff(e, t, i, s, o) {
    const r = new Jw(e, i.seq1Range, o), a = new Jw(t, i.seq2Range, o), l = r.length + a.length < 500 ? this.dynamicProgrammingDiffing.compute(r, a, s) : this.myersDiffingAlgorithm.compute(r, a, s);
    let d = l.diffs;
    return d = UE(r, a, d), d = (function(h, c, u) {
      const g = Ji.invert(u, h.length), p = [];
      let f = new qo(0, 0);
      function _(v, b) {
        if (v.offset1 < f.offset1 || v.offset2 < f.offset2) return;
        const C = h.findWordContaining(v.offset1), w = c.findWordContaining(v.offset2);
        if (!C || !w) return;
        let y = new Ji(C, w);
        const L = y.intersect(b);
        let k = L.seq1Range.length, N = L.seq2Range.length;
        for (; g.length > 0; ) {
          const A = g[0];
          if (!A.seq1Range.intersects(y.seq1Range) && !A.seq2Range.intersects(y.seq2Range)) break;
          const B = h.findWordContaining(A.seq1Range.start), T = c.findWordContaining(A.seq2Range.start), O = new Ji(B, T), H = O.intersect(A);
          if (k += H.seq1Range.length, N += H.seq2Range.length, y = y.join(O), !(y.seq1Range.endExclusive >= A.seq1Range.endExclusive)) break;
          g.shift();
        }
        k + N < 2 * (y.seq1Range.length + y.seq2Range.length) / 3 && p.push(y), f = y.getEndExclusives();
      }
      for (; g.length > 0; ) {
        const v = g.shift();
        v.seq1Range.isEmpty || (_(v.getStarts(), v), _(v.getEndExclusives().delta(-1), v));
      }
      return (function(v, b) {
        const C = [];
        for (; v.length > 0 || b.length > 0; ) {
          const w = v[0], y = b[0];
          let L;
          L = w && (!y || w.seq1Range.start < y.seq1Range.start) ? v.shift() : b.shift(), C.length > 0 && C[C.length - 1].seq1Range.endExclusive >= L.seq1Range.start ? C[C.length - 1] = C[C.length - 1].join(L) : C.push(L);
        }
        return C;
      })(u, p);
    })(r, a, d), d = (function(h, c, u) {
      const g = [];
      for (const p of u) {
        const f = g[g.length - 1];
        f && (p.seq1Range.start - f.seq1Range.endExclusive <= 2 || p.seq2Range.start - f.seq2Range.endExclusive <= 2) ? g[g.length - 1] = new Ji(f.seq1Range.join(p.seq1Range), f.seq2Range.join(p.seq2Range)) : g.push(p);
      }
      return g;
    })(0, 0, d), d = (function(h, c, u) {
      let g = u;
      if (g.length === 0) return g;
      let p, f = 0;
      do {
        p = !1;
        const v = [g[0]];
        for (let b = 1; b < g.length; b++) {
          let y = function(L, k) {
            const N = new qe(w.seq1Range.endExclusive, C.seq1Range.start);
            if (h.countLinesIn(N) > 5 || N.length > 500) return !1;
            const A = h.getText(N).trim();
            if (A.length > 20 || A.split(/\r\n|\r|\n/).length > 1) return !1;
            const B = h.countLinesIn(L.seq1Range), T = L.seq1Range.length, O = c.countLinesIn(L.seq2Range), H = L.seq2Range.length, $ = h.countLinesIn(k.seq1Range), pe = k.seq1Range.length, me = c.countLinesIn(k.seq2Range), ue = k.seq2Range.length;
            function ee(te) {
              return Math.min(te, 130);
            }
            return Math.pow(Math.pow(ee(40 * B + T), 1.5) + Math.pow(ee(40 * O + H), 1.5), 1.5) + Math.pow(Math.pow(ee(40 * $ + pe), 1.5) + Math.pow(ee(40 * me + ue), 1.5), 1.5) > 74184.96480721243;
          };
          const C = g[b], w = v[v.length - 1];
          y(w, C) ? (p = !0, v[v.length - 1] = v[v.length - 1].join(C)) : v.push(C);
        }
        g = v;
      } while (f++ < 10 && p);
      const _ = [];
      return (function(v, b) {
        for (let C = 0; C < v.length; C++) b(C === 0 ? void 0 : v[C - 1], v[C], C + 1 === v.length ? void 0 : v[C + 1]);
      })(g, ((v, b, C) => {
        let w = b;
        function y(T) {
          return T.length > 0 && T.trim().length <= 3 && b.seq1Range.length + b.seq2Range.length > 100;
        }
        const L = h.extendToFullLines(b.seq1Range), k = h.getText(new qe(L.start, b.seq1Range.start));
        y(k) && (w = w.deltaStart(-k.length));
        const N = h.getText(new qe(b.seq1Range.endExclusive, L.endExclusive));
        y(N) && (w = w.deltaEnd(N.length));
        const A = Ji.fromOffsetPairs(v ? v.getEndExclusives() : qo.zero, C ? C.getStarts() : qo.max), B = w.intersect(A);
        _.length > 0 && B.getStarts().equals(_[_.length - 1].getEndExclusives()) ? _[_.length - 1] = _[_.length - 1].join(B) : _.push(B);
      })), _;
    })(r, a, d), { mappings: d.map(((h) => new Fd(r.translateRange(h.seq1Range), a.translateRange(h.seq2Range)))), hitTimeout: l.hitTimeout };
  }
}
function m4(n, e, t, i = !1) {
  const s = [];
  for (const o of HT(n.map(((r) => (function(a, l, d) {
    let h = 0, c = 0;
    a.modifiedRange.endColumn === 1 && a.originalRange.endColumn === 1 && a.originalRange.startLineNumber + h <= a.originalRange.endLineNumber && a.modifiedRange.startLineNumber + h <= a.modifiedRange.endLineNumber && (c = -1), a.modifiedRange.startColumn - 1 >= d[a.modifiedRange.startLineNumber - 1].length && a.originalRange.startColumn - 1 >= l[a.originalRange.startLineNumber - 1].length && a.originalRange.startLineNumber <= a.originalRange.endLineNumber + c && a.modifiedRange.startLineNumber <= a.modifiedRange.endLineNumber + c && (h = 1);
    const u = new je(a.originalRange.startLineNumber + h, a.originalRange.endLineNumber + 1 + c), g = new je(a.modifiedRange.startLineNumber + h, a.modifiedRange.endLineNumber + 1 + c);
    return new xo(u, g, [a]);
  })(r, e, t))), ((r, a) => r.original.overlapOrTouch(a.original) || r.modified.overlapOrTouch(a.modified)))) {
    const r = o[0], a = o[o.length - 1];
    s.push(new xo(r.original.join(a.original), r.modified.join(a.modified), o.map(((l) => l.innerChanges[0]))));
  }
  return dg((() => !i && s.length > 0 && (s[0].modified.startLineNumber !== s[0].original.startLineNumber || t.length - s[s.length - 1].modified.endLineNumberExclusive != e.length - s[s.length - 1].original.endLineNumberExclusive) ? !1 : bR(s, ((o, r) => r.original.startLineNumber - o.original.endLineNumberExclusive == r.modified.startLineNumber - o.modified.endLineNumberExclusive && o.original.endLineNumberExclusive < r.original.startLineNumber && o.modified.endLineNumberExclusive < r.modified.startLineNumber)))), s;
}
const Mq = () => new yq(), Tq = () => new X8();
function Qh(n, e) {
  const t = Math.pow(10, e);
  return Math.round(n * t) / t;
}
class ht {
  constructor(e, t, i, s = 1) {
    this._rgbaBrand = void 0, this.r = 0 | Math.min(255, Math.max(0, e)), this.g = 0 | Math.min(255, Math.max(0, t)), this.b = 0 | Math.min(255, Math.max(0, i)), this.a = Qh(Math.max(Math.min(1, s), 0), 3);
  }
  static equals(e, t) {
    return e.r === t.r && e.g === t.g && e.b === t.b && e.a === t.a;
  }
}
class fr {
  constructor(e, t, i, s) {
    this._hslaBrand = void 0, this.h = 0 | Math.max(Math.min(360, e), 0), this.s = Qh(Math.max(Math.min(1, t), 0), 3), this.l = Qh(Math.max(Math.min(1, i), 0), 3), this.a = Qh(Math.max(Math.min(1, s), 0), 3);
  }
  static equals(e, t) {
    return e.h === t.h && e.s === t.s && e.l === t.l && e.a === t.a;
  }
  static fromRGBA(e) {
    const t = e.r / 255, i = e.g / 255, s = e.b / 255, o = e.a, r = Math.max(t, i, s), a = Math.min(t, i, s);
    let l = 0, d = 0;
    const h = (a + r) / 2, c = r - a;
    if (c > 0) {
      switch (d = Math.min(h <= 0.5 ? c / (2 * h) : c / (2 - 2 * h), 1), r) {
        case t:
          l = (i - s) / c + (i < s ? 6 : 0);
          break;
        case i:
          l = (s - t) / c + 2;
          break;
        case s:
          l = (t - i) / c + 4;
      }
      l *= 60, l = Math.round(l);
    }
    return new fr(l, d, h, o);
  }
  static _hue2rgb(e, t, i) {
    return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? e + 6 * (t - e) * i : i < 0.5 ? t : i < 2 / 3 ? e + (t - e) * (2 / 3 - i) * 6 : e;
  }
  static toRGBA(e) {
    const t = e.h / 360, { s: i, l: s, a: o } = e;
    let r, a, l;
    if (i === 0) r = a = l = s;
    else {
      const d = s < 0.5 ? s * (1 + i) : s + i - s * i, h = 2 * s - d;
      r = fr._hue2rgb(h, d, t + 1 / 3), a = fr._hue2rgb(h, d, t), l = fr._hue2rgb(h, d, t - 1 / 3);
    }
    return new ht(Math.round(255 * r), Math.round(255 * a), Math.round(255 * l), o);
  }
}
class il {
  constructor(e, t, i, s) {
    this._hsvaBrand = void 0, this.h = 0 | Math.max(Math.min(360, e), 0), this.s = Qh(Math.max(Math.min(1, t), 0), 3), this.v = Qh(Math.max(Math.min(1, i), 0), 3), this.a = Qh(Math.max(Math.min(1, s), 0), 3);
  }
  static equals(e, t) {
    return e.h === t.h && e.s === t.s && e.v === t.v && e.a === t.a;
  }
  static fromRGBA(e) {
    const t = e.r / 255, i = e.g / 255, s = e.b / 255, o = Math.max(t, i, s), r = o - Math.min(t, i, s), a = o === 0 ? 0 : r / o;
    let l;
    return l = r === 0 ? 0 : o === t ? ((i - s) / r % 6 + 6) % 6 : o === i ? (s - t) / r + 2 : (t - i) / r + 4, new il(Math.round(60 * l), a, o, e.a);
  }
  static toRGBA(e) {
    const { h: t, s: i, v: s, a: o } = e, r = s * i, a = r * (1 - Math.abs(t / 60 % 2 - 1)), l = s - r;
    let [d, h, c] = [0, 0, 0];
    return t < 60 ? (d = r, h = a) : t < 120 ? (d = a, h = r) : t < 180 ? (h = r, c = a) : t < 240 ? (h = a, c = r) : t < 300 ? (d = a, c = r) : t <= 360 && (d = r, c = a), d = Math.round(255 * (d + l)), h = Math.round(255 * (h + l)), c = Math.round(255 * (c + l)), new ht(d, h, c, o);
  }
}
class z {
  static fromHex(e) {
    return z.Format.CSS.parseHex(e) || z.red;
  }
  static equals(e, t) {
    return !e && !t || !(!e || !t) && e.equals(t);
  }
  get hsla() {
    return this._hsla ? this._hsla : fr.fromRGBA(this.rgba);
  }
  get hsva() {
    return this._hsva ? this._hsva : il.fromRGBA(this.rgba);
  }
  constructor(e) {
    if (!e) throw new Error("Color needs a value");
    if (e instanceof ht) this.rgba = e;
    else if (e instanceof fr) this._hsla = e, this.rgba = fr.toRGBA(e);
    else {
      if (!(e instanceof il)) throw new Error("Invalid color ctor argument");
      this._hsva = e, this.rgba = il.toRGBA(e);
    }
  }
  equals(e) {
    return !!e && ht.equals(this.rgba, e.rgba) && fr.equals(this.hsla, e.hsla) && il.equals(this.hsva, e.hsva);
  }
  getRelativeLuminance() {
    return Qh(0.2126 * z._relativeLuminanceForComponent(this.rgba.r) + 0.7152 * z._relativeLuminanceForComponent(this.rgba.g) + 0.0722 * z._relativeLuminanceForComponent(this.rgba.b), 4);
  }
  static _relativeLuminanceForComponent(e) {
    const t = e / 255;
    return t <= 0.03928 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
  }
  isLighter() {
    return (299 * this.rgba.r + 587 * this.rgba.g + 114 * this.rgba.b) / 1e3 >= 128;
  }
  isLighterThan(e) {
    return this.getRelativeLuminance() > e.getRelativeLuminance();
  }
  isDarkerThan(e) {
    return this.getRelativeLuminance() < e.getRelativeLuminance();
  }
  lighten(e) {
    return new z(new fr(this.hsla.h, this.hsla.s, this.hsla.l + this.hsla.l * e, this.hsla.a));
  }
  darken(e) {
    return new z(new fr(this.hsla.h, this.hsla.s, this.hsla.l - this.hsla.l * e, this.hsla.a));
  }
  transparent(e) {
    const { r: t, g: i, b: s, a: o } = this.rgba;
    return new z(new ht(t, i, s, o * e));
  }
  isTransparent() {
    return this.rgba.a === 0;
  }
  isOpaque() {
    return this.rgba.a === 1;
  }
  opposite() {
    return new z(new ht(255 - this.rgba.r, 255 - this.rgba.g, 255 - this.rgba.b, this.rgba.a));
  }
  makeOpaque(e) {
    if (this.isOpaque() || e.rgba.a !== 1) return this;
    const { r: t, g: i, b: s, a: o } = this.rgba;
    return new z(new ht(e.rgba.r - o * (e.rgba.r - t), e.rgba.g - o * (e.rgba.g - i), e.rgba.b - o * (e.rgba.b - s), 1));
  }
  toString() {
    return this._toString || (this._toString = z.Format.CSS.format(this)), this._toString;
  }
  static getLighterColor(e, t, i) {
    if (e.isLighterThan(t)) return e;
    i = i || 0.5;
    const s = e.getRelativeLuminance(), o = t.getRelativeLuminance();
    return i = i * (o - s) / o, e.lighten(i);
  }
  static getDarkerColor(e, t, i) {
    if (e.isDarkerThan(t)) return e;
    i = i || 0.5;
    const s = e.getRelativeLuminance();
    return i = i * (s - t.getRelativeLuminance()) / s, e.darken(i);
  }
}
function Q8(n) {
  const e = [];
  for (const t of n) {
    const i = Number(t);
    (i || i === 0 && t.replace(/\s/g, "") !== "") && e.push(i);
  }
  return e;
}
function DR(n, e, t, i) {
  return { red: n / 255, blue: t / 255, green: e / 255, alpha: i };
}
function Tf(n, e) {
  const t = e.index, i = e[0].length;
  if (!t) return;
  const s = n.positionAt(t);
  return { startLineNumber: s.lineNumber, startColumn: s.column, endLineNumber: s.lineNumber, endColumn: s.column + i };
}
function Rq(n, e) {
  if (!n) return;
  const t = z.Format.CSS.parseHex(e);
  return t ? { range: n, color: DR(t.rgba.r, t.rgba.g, t.rgba.b, t.rgba.a) } : void 0;
}
function f4(n, e, t) {
  if (!n || e.length !== 1) return;
  const i = Q8(e[0].values());
  return { range: n, color: DR(i[0], i[1], i[2], t ? i[3] : 1) };
}
function _4(n, e, t) {
  if (!n || e.length !== 1) return;
  const i = Q8(e[0].values()), s = new z(new fr(i[0], i[1] / 100, i[2] / 100, t ? i[3] : 1));
  return { range: n, color: DR(s.rgba.r, s.rgba.g, s.rgba.b, s.rgba.a) };
}
function Rf(n, e) {
  return typeof n == "string" ? [...n.matchAll(e)] : n.findMatches(e);
}
function Aq(n) {
  return n && typeof n.getValue == "function" && typeof n.positionAt == "function" ? (function(e) {
    const t = [], i = Rf(e, /\b(rgb|rgba|hsl|hsla)(\([0-9\s,.\%]*\))|(#)([A-Fa-f0-9]{3})\b|(#)([A-Fa-f0-9]{4})\b|(#)([A-Fa-f0-9]{6})\b|(#)([A-Fa-f0-9]{8})\b/gm);
    if (i.length > 0) for (const s of i) {
      const o = s.filter(((d) => d !== void 0)), r = o[1], a = o[2];
      if (!a) continue;
      let l;
      if (r === "rgb") {
        const d = /^\(\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*\)$/gm;
        l = f4(Tf(e, s), Rf(a, d), !1);
      } else if (r === "rgba") {
        const d = /^\(\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(0[.][0-9]+|[.][0-9]+|[01][.]|[01])\s*\)$/gm;
        l = f4(Tf(e, s), Rf(a, d), !0);
      } else if (r === "hsl") {
        const d = /^\(\s*(36[0]|3[0-5][0-9]|[12][0-9][0-9]|[1-9]?[0-9])\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*\)$/gm;
        l = _4(Tf(e, s), Rf(a, d), !1);
      } else if (r === "hsla") {
        const d = /^\(\s*(36[0]|3[0-5][0-9]|[12][0-9][0-9]|[1-9]?[0-9])\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(0[.][0-9]+|[.][0-9]+|[01][.]|[01])\s*\)$/gm;
        l = _4(Tf(e, s), Rf(a, d), !0);
      } else r === "#" && (l = Rq(Tf(e, s), r + a));
      l && t.push(l);
    }
    return t;
  })(n) : [];
}
z.white = new z(new ht(255, 255, 255, 1)), z.black = new z(new ht(0, 0, 0, 1)), z.red = new z(new ht(255, 0, 0, 1)), z.blue = new z(new ht(0, 0, 255, 1)), z.green = new z(new ht(0, 255, 0, 1)), z.cyan = new z(new ht(0, 255, 255, 1)), z.lightgrey = new z(new ht(211, 211, 211, 1)), z.transparent = new z(new ht(0, 0, 0, 0)), (function(n) {
  var e;
  (function(t) {
    function i(o) {
      const r = o.toString(16);
      return r.length !== 2 ? "0" + r : r;
    }
    function s(o) {
      switch (o) {
        case 48:
          return 0;
        case 49:
          return 1;
        case 50:
          return 2;
        case 51:
          return 3;
        case 52:
          return 4;
        case 53:
          return 5;
        case 54:
          return 6;
        case 55:
          return 7;
        case 56:
          return 8;
        case 57:
          return 9;
        case 97:
        case 65:
          return 10;
        case 98:
        case 66:
          return 11;
        case 99:
        case 67:
          return 12;
        case 100:
        case 68:
          return 13;
        case 101:
        case 69:
          return 14;
        case 102:
        case 70:
          return 15;
      }
      return 0;
    }
    t.formatRGB = function(o) {
      return o.rgba.a === 1 ? `rgb(${o.rgba.r}, ${o.rgba.g}, ${o.rgba.b})` : n.Format.CSS.formatRGBA(o);
    }, t.formatRGBA = function(o) {
      return `rgba(${o.rgba.r}, ${o.rgba.g}, ${o.rgba.b}, ${+o.rgba.a.toFixed(2)})`;
    }, t.formatHSL = function(o) {
      return o.hsla.a === 1 ? `hsl(${o.hsla.h}, ${(100 * o.hsla.s).toFixed(2)}%, ${(100 * o.hsla.l).toFixed(2)}%)` : n.Format.CSS.formatHSLA(o);
    }, t.formatHSLA = function(o) {
      return `hsla(${o.hsla.h}, ${(100 * o.hsla.s).toFixed(2)}%, ${(100 * o.hsla.l).toFixed(2)}%, ${o.hsla.a.toFixed(2)})`;
    }, t.formatHex = function(o) {
      return `#${i(o.rgba.r)}${i(o.rgba.g)}${i(o.rgba.b)}`;
    }, t.formatHexA = function(o, r = !1) {
      return r && o.rgba.a === 1 ? n.Format.CSS.formatHex(o) : `#${i(o.rgba.r)}${i(o.rgba.g)}${i(o.rgba.b)}${i(Math.round(255 * o.rgba.a))}`;
    }, t.format = function(o) {
      return o.isOpaque() ? n.Format.CSS.formatHex(o) : n.Format.CSS.formatRGBA(o);
    }, t.parseHex = function(o) {
      const r = o.length;
      if (r === 0 || o.charCodeAt(0) !== 35) return null;
      if (r === 7) {
        const a = 16 * s(o.charCodeAt(1)) + s(o.charCodeAt(2)), l = 16 * s(o.charCodeAt(3)) + s(o.charCodeAt(4)), d = 16 * s(o.charCodeAt(5)) + s(o.charCodeAt(6));
        return new n(new ht(a, l, d, 1));
      }
      if (r === 9) {
        const a = 16 * s(o.charCodeAt(1)) + s(o.charCodeAt(2)), l = 16 * s(o.charCodeAt(3)) + s(o.charCodeAt(4)), d = 16 * s(o.charCodeAt(5)) + s(o.charCodeAt(6)), h = 16 * s(o.charCodeAt(7)) + s(o.charCodeAt(8));
        return new n(new ht(a, l, d, h / 255));
      }
      if (r === 4) {
        const a = s(o.charCodeAt(1)), l = s(o.charCodeAt(2)), d = s(o.charCodeAt(3));
        return new n(new ht(16 * a + a, 16 * l + l, 16 * d + d));
      }
      if (r === 5) {
        const a = s(o.charCodeAt(1)), l = s(o.charCodeAt(2)), d = s(o.charCodeAt(3)), h = s(o.charCodeAt(4));
        return new n(new ht(16 * a + a, 16 * l + l, 16 * d + d, (16 * h + h) / 255));
      }
      return null;
    };
  })((e = n.Format || (n.Format = {})).CSS || (e.CSS = {}));
})(z || (z = {}));
const v4 = /\bMARK:\s*(.*)$/d, Pq = /^-+|-+$/g;
function Oq(n, e) {
  var t;
  let i = [];
  if (e.findRegionSectionHeaders && (!((t = e.foldingRules) === null || t === void 0) && t.markers)) {
    const s = (function(o, r) {
      const a = [], l = o.getLineCount();
      for (let d = 1; d <= l; d++) {
        const h = o.getLineContent(d), c = h.match(r.foldingRules.markers.start);
        if (c) {
          const u = { startLineNumber: d, startColumn: c[0].length + 1, endLineNumber: d, endColumn: h.length + 1 };
          if (u.endColumn > u.startColumn) {
            const g = { range: u, ...J8(h.substring(c[0].length)), shouldBeInComments: !1 };
            (g.text || g.hasSeparatorLine) && a.push(g);
          }
        }
      }
      return a;
    })(n, e);
    i = i.concat(s);
  }
  if (e.findMarkSectionHeaders) {
    const s = (function(o) {
      const r = [], a = o.getLineCount();
      for (let l = 1; l <= a; l++)
        Fq(o.getLineContent(l), l, r);
      return r;
    })(n);
    i = i.concat(s);
  }
  return i;
}
function Fq(n, e, t) {
  v4.lastIndex = 0;
  const i = v4.exec(n);
  if (i) {
    const s = { startLineNumber: e, startColumn: i.indices[1][0] + 1, endLineNumber: e, endColumn: i.indices[1][1] + 1 };
    if (s.endColumn > s.startColumn) {
      const o = { range: s, ...J8(i[1]), shouldBeInComments: !0 };
      (o.text || o.hasSeparatorLine) && t.push(o);
    }
  }
}
function J8(n) {
  const e = (n = n.trim()).startsWith("-");
  return { text: n = n.replace(Pq, ""), hasSeparatorLine: e };
}
class Bq extends uq {
  get uri() {
    return this._uri;
  }
  get eol() {
    return this._eol;
  }
  getValue() {
    return this.getText();
  }
  findMatches(e) {
    const t = [];
    for (let i = 0; i < this._lines.length; i++) {
      const s = this._lines[i], o = this.offsetAt(new W(i + 1, 1)), r = s.matchAll(e);
      for (const a of r) (a.index || a.index === 0) && (a.index = a.index + o), t.push(a);
    }
    return t;
  }
  getLinesContent() {
    return this._lines.slice(0);
  }
  getLineCount() {
    return this._lines.length;
  }
  getLineContent(e) {
    return this._lines[e - 1];
  }
  getWordAtPosition(e, t) {
    const i = K0(e.column, GT(t), this._lines[e.lineNumber - 1], 0);
    return i ? new D(e.lineNumber, i.startColumn, e.lineNumber, i.endColumn) : null;
  }
  words(e) {
    const t = this._lines, i = this._wordenize.bind(this);
    let s = 0, o = "", r = 0, a = [];
    return { *[Symbol.iterator]() {
      for (; ; ) if (r < a.length) {
        const l = o.substring(a[r].start, a[r].end);
        r += 1, yield l;
      } else {
        if (!(s < t.length)) break;
        o = t[s], a = i(o, e), r = 0, s += 1;
      }
    } };
  }
  getLineWords(e, t) {
    const i = this._lines[e - 1], s = this._wordenize(i, t), o = [];
    for (const r of s) o.push({ word: i.substring(r.start, r.end), startColumn: r.start + 1, endColumn: r.end + 1 });
    return o;
  }
  _wordenize(e, t) {
    const i = [];
    let s;
    for (t.lastIndex = 0; (s = t.exec(e)) && s[0].length !== 0; ) i.push({ start: s.index, end: s.index + s[0].length });
    return i;
  }
  getValueInRange(e) {
    if ((e = this._validateRange(e)).startLineNumber === e.endLineNumber) return this._lines[e.startLineNumber - 1].substring(e.startColumn - 1, e.endColumn - 1);
    const t = this._eol, i = e.startLineNumber - 1, s = e.endLineNumber - 1, o = [];
    o.push(this._lines[i].substring(e.startColumn - 1));
    for (let r = i + 1; r < s; r++) o.push(this._lines[r]);
    return o.push(this._lines[s].substring(0, e.endColumn - 1)), o.join(t);
  }
  offsetAt(e) {
    return e = this._validatePosition(e), this._ensureLineStarts(), this._lineStarts.getPrefixSum(e.lineNumber - 2) + (e.column - 1);
  }
  positionAt(e) {
    e = Math.floor(e), e = Math.max(0, e), this._ensureLineStarts();
    const t = this._lineStarts.getIndexOf(e), i = this._lines[t.index].length;
    return { lineNumber: 1 + t.index, column: 1 + Math.min(t.remainder, i) };
  }
  _validateRange(e) {
    const t = this._validatePosition({ lineNumber: e.startLineNumber, column: e.startColumn }), i = this._validatePosition({ lineNumber: e.endLineNumber, column: e.endColumn });
    return t.lineNumber !== e.startLineNumber || t.column !== e.startColumn || i.lineNumber !== e.endLineNumber || i.column !== e.endColumn ? { startLineNumber: t.lineNumber, startColumn: t.column, endLineNumber: i.lineNumber, endColumn: i.column } : e;
  }
  _validatePosition(e) {
    if (!W.isIPosition(e)) throw new Error("bad position");
    let { lineNumber: t, column: i } = e, s = !1;
    if (t < 1) t = 1, i = 1, s = !0;
    else if (t > this._lines.length) t = this._lines.length, i = this._lines[t - 1].length + 1, s = !0;
    else {
      const o = this._lines[t - 1].length + 1;
      i < 1 ? (i = 1, s = !0) : i > o && (i = o, s = !0);
    }
    return s ? { lineNumber: t, column: i } : e;
  }
}
class Jh {
  constructor(e, t) {
    this._host = e, this._models = /* @__PURE__ */ Object.create(null), this._foreignModuleFactory = t, this._foreignModule = null;
  }
  dispose() {
    this._models = /* @__PURE__ */ Object.create(null);
  }
  _getModel(e) {
    return this._models[e];
  }
  _getModels() {
    const e = [];
    return Object.keys(this._models).forEach(((t) => e.push(this._models[t]))), e;
  }
  acceptNewModel(e) {
    this._models[e.url] = new Bq(Ie.parse(e.url), e.lines, e.EOL, e.versionId);
  }
  acceptModelChanged(e, t) {
    this._models[e] && this._models[e].onEvents(t);
  }
  acceptRemovedModel(e) {
    this._models[e] && delete this._models[e];
  }
  async computeUnicodeHighlights(e, t, i) {
    const s = this._getModel(e);
    return s ? SR.computeUnicodeHighlights(s, t, i) : { ranges: [], hasMore: !1, ambiguousCharacterCount: 0, invisibleCharacterCount: 0, nonBasicAsciiCharacterCount: 0 };
  }
  async findSectionHeaders(e, t) {
    const i = this._getModel(e);
    return i ? Oq(i, t) : [];
  }
  async computeDiff(e, t, i, s) {
    const o = this._getModel(e), r = this._getModel(t);
    return !o || !r ? null : Jh.computeDiff(o, r, i, s);
  }
  static computeDiff(e, t, i, s) {
    const o = s === "advanced" ? Tq() : Mq(), r = e.getLinesContent(), a = t.getLinesContent(), l = o.computeDiff(r, a, i);
    function d(h) {
      return h.map(((c) => {
        var u;
        return [c.original.startLineNumber, c.original.endLineNumberExclusive, c.modified.startLineNumber, c.modified.endLineNumberExclusive, (u = c.innerChanges) === null || u === void 0 ? void 0 : u.map(((g) => [g.originalRange.startLineNumber, g.originalRange.startColumn, g.originalRange.endLineNumber, g.originalRange.endColumn, g.modifiedRange.startLineNumber, g.modifiedRange.startColumn, g.modifiedRange.endLineNumber, g.modifiedRange.endColumn]))];
      }));
    }
    return { identical: !(l.changes.length > 0) && this._modelsAreIdentical(e, t), quitEarly: l.hitTimeout, changes: d(l.changes), moves: l.moves.map(((h) => [h.lineRangeMapping.original.startLineNumber, h.lineRangeMapping.original.endLineNumberExclusive, h.lineRangeMapping.modified.startLineNumber, h.lineRangeMapping.modified.endLineNumberExclusive, d(h.changes)])) };
  }
  static _modelsAreIdentical(e, t) {
    const i = e.getLineCount();
    if (i !== t.getLineCount()) return !1;
    for (let s = 1; s <= i; s++)
      if (e.getLineContent(s) !== t.getLineContent(s)) return !1;
    return !0;
  }
  async computeMoreMinimalEdits(e, t, i) {
    const s = this._getModel(e);
    if (!s) return t;
    const o = [];
    let r;
    t = t.slice(0).sort(((l, d) => l.range && d.range ? D.compareRangesUsingStarts(l.range, d.range) : (l.range ? 0 : 1) - (d.range ? 0 : 1)));
    let a = 0;
    for (let l = 1; l < t.length; l++) D.getEndPosition(t[a].range).equals(D.getStartPosition(t[l].range)) ? (t[a].range = D.fromPositions(D.getStartPosition(t[a].range), D.getEndPosition(t[l].range)), t[a].text += t[l].text) : (a++, t[a] = t[l]);
    t.length = a + 1;
    for (let { range: l, text: d, eol: h } of t) {
      if (typeof h == "number" && (r = h), D.isEmpty(l) && !d) continue;
      const c = s.getValueInRange(l);
      if (d = d.replace(/\r\n|\n|\r/g, s.eol), c === d) continue;
      if (Math.max(d.length, c.length) > Jh._diffLimit) {
        o.push({ range: l, text: d });
        continue;
      }
      const u = dq(c, d, i), g = s.offsetAt(D.lift(l).getStartPosition());
      for (const p of u) {
        const f = s.positionAt(g + p.originalStart), _ = s.positionAt(g + p.originalStart + p.originalLength), v = { text: d.substr(p.modifiedStart, p.modifiedLength), range: { startLineNumber: f.lineNumber, startColumn: f.column, endLineNumber: _.lineNumber, endColumn: _.column } };
        s.getValueInRange(v.range) !== v.text && o.push(v);
      }
    }
    return typeof r == "number" && o.push({ eol: r, text: "", range: { startLineNumber: 0, startColumn: 0, endLineNumber: 0, endColumn: 0 } }), o;
  }
  async computeLinks(e) {
    const t = this._getModel(e);
    return t ? (function(i) {
      return i && typeof i.getLineCount == "function" && typeof i.getLineContent == "function" ? Qw.computeLinks(i) : [];
    })(t) : null;
  }
  async computeDefaultDocumentColors(e) {
    const t = this._getModel(e);
    return t ? Aq(t) : null;
  }
  async textualSuggest(e, t, i, s) {
    const o = new Rn(), r = new RegExp(i, s), a = /* @__PURE__ */ new Set();
    e: for (const l of e) {
      const d = this._getModel(l);
      if (d) {
        for (const h of d.words(r)) if (h !== t && isNaN(Number(h)) && (a.add(h), a.size > Jh._suggestionsLimit)) break e;
      }
    }
    return { words: Array.from(a), duration: o.elapsed() };
  }
  async computeWordRanges(e, t, i, s) {
    const o = this._getModel(e);
    if (!o) return /* @__PURE__ */ Object.create(null);
    const r = new RegExp(i, s), a = /* @__PURE__ */ Object.create(null);
    for (let l = t.startLineNumber; l < t.endLineNumber; l++) {
      const d = o.getLineWords(l, r);
      for (const h of d) {
        if (!isNaN(Number(h.word))) continue;
        let c = a[h.word];
        c || (c = [], a[h.word] = c), c.push({ startLineNumber: l, startColumn: h.startColumn, endLineNumber: l, endColumn: h.endColumn });
      }
    }
    return a;
  }
  async navigateValueSet(e, t, i, s, o) {
    const r = this._getModel(e);
    if (!r) return null;
    const a = new RegExp(s, o);
    t.startColumn === t.endColumn && (t = { startLineNumber: t.startLineNumber, startColumn: t.startColumn, endLineNumber: t.endLineNumber, endColumn: t.endColumn + 1 });
    const l = r.getValueInRange(t), d = r.getWordAtPosition({ lineNumber: t.startLineNumber, column: t.startColumn }, a);
    if (!d) return null;
    const h = r.getValueInRange(d);
    return WE.INSTANCE.navigateValueSet(t, l, d, h, i);
  }
  loadForeignModule(e, t, i) {
    const s = (function(r, a) {
      const l = (h) => function() {
        const c = Array.prototype.slice.call(arguments, 0);
        return a(h, c);
      }, d = {};
      for (const h of r) d[h] = l(h);
      return d;
    })(i, ((r, a) => this._host.fhr(r, a))), o = { host: s, getMirrorModels: () => this._getModels() };
    return this._foreignModuleFactory ? (this._foreignModule = this._foreignModuleFactory(o, t), Promise.resolve(KT(this._foreignModule))) : Promise.reject(new Error("Unexpected usage"));
  }
  fmr(e, t) {
    if (!this._foreignModule || typeof this._foreignModule[e] != "function") return Promise.reject(new Error("Missing requestHandler or method: " + e));
    try {
      return Promise.resolve(this._foreignModule[e].apply(this._foreignModule, t));
    } catch (i) {
      return Promise.reject(i);
    }
  }
}
Jh._diffLimit = 1e5, Jh._suggestionsLimit = 1e4, typeof importScripts == "function" && (globalThis.monaco = Z7());
const xR = tt("textResourceConfigurationService"), eB = tt("textResourcePropertiesService"), fe = tt("ILanguageFeaturesService");
var Wq = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Af = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const Vq = 3e5;
function mu(n, e) {
  const t = n.getModel(e);
  return !!t && !t.isTooLargeForSyncing();
}
let KE = class extends V {
  constructor(n, e, t, i, s) {
    super(), this._modelService = n, this._workerManager = this._register(new zq(this._modelService, i)), this._logService = t, this._register(s.linkProvider.register({ language: "*", hasAccessToAllModels: !0 }, { provideLinks: (o, r) => mu(this._modelService, o.uri) ? this._workerManager.withWorker().then(((a) => a.computeLinks(o.uri))).then(((a) => a && { links: a })) : Promise.resolve({ links: [] }) })), this._register(s.completionProvider.register("*", new Hq(this._workerManager, e, this._modelService, i)));
  }
  dispose() {
    super.dispose();
  }
  canComputeUnicodeHighlights(n) {
    return mu(this._modelService, n);
  }
  computedUnicodeHighlights(n, e, t) {
    return this._workerManager.withWorker().then(((i) => i.computedUnicodeHighlights(n, e, t)));
  }
  async computeDiff(n, e, t, i) {
    const s = await this._workerManager.withWorker().then(((r) => r.computeDiff(n, e, t, i)));
    if (!s) return null;
    return { identical: s.identical, quitEarly: s.quitEarly, changes: o(s.changes), moves: s.moves.map(((r) => new G8(new us(new je(r[0], r[1]), new je(r[2], r[3])), o(r[4])))) };
    function o(r) {
      return r.map(((a) => {
        var l;
        return new xo(new je(a[0], a[1]), new je(a[2], a[3]), (l = a[4]) === null || l === void 0 ? void 0 : l.map(((d) => new Fd(new D(d[0], d[1], d[2], d[3]), new D(d[4], d[5], d[6], d[7])))));
      }));
    }
  }
  computeMoreMinimalEdits(n, e, t = !1) {
    if (zn(e)) {
      if (!mu(this._modelService, n)) return Promise.resolve(e);
      const i = Rn.create(), s = this._workerManager.withWorker().then(((o) => o.computeMoreMinimalEdits(n, e, t)));
      return s.finally((() => this._logService.trace("FORMAT#computeMoreMinimalEdits", n.toString(!0), i.elapsed()))), Promise.race([s, vc(1e3).then((() => e))]);
    }
    return Promise.resolve(void 0);
  }
  canNavigateValueSet(n) {
    return mu(this._modelService, n);
  }
  navigateValueSet(n, e, t) {
    return this._workerManager.withWorker().then(((i) => i.navigateValueSet(n, e, t)));
  }
  canComputeWordRanges(n) {
    return mu(this._modelService, n);
  }
  computeWordRanges(n, e) {
    return this._workerManager.withWorker().then(((t) => t.computeWordRanges(n, e)));
  }
  findSectionHeaders(n, e) {
    return this._workerManager.withWorker().then(((t) => t.findSectionHeaders(n, e)));
  }
};
KE = Wq([Af(0, ni), Af(1, xR), Af(2, ts), Af(3, zt), Af(4, fe)], KE);
class Hq {
  constructor(e, t, i, s) {
    this.languageConfigurationService = s, this._debugDisplayName = "wordbasedCompletions", this._workerManager = e, this._configurationService = t, this._modelService = i;
  }
  async provideCompletionItems(e, t) {
    const i = this._configurationService.getValue(e.uri, t, "editor");
    if (i.wordBasedSuggestions === "off") return;
    const s = [];
    if (i.wordBasedSuggestions === "currentDocument") mu(this._modelService, e.uri) && s.push(e.uri);
    else for (const c of this._modelService.getModels()) mu(this._modelService, c.uri) && (c === e ? s.unshift(c.uri) : i.wordBasedSuggestions !== "allDocuments" && c.getLanguageId() !== e.getLanguageId() || s.push(c.uri));
    if (s.length === 0) return;
    const o = this.languageConfigurationService.getLanguageConfiguration(e.getLanguageId()).getWordDefinition(), r = e.getWordAtPosition(t), a = r ? new D(t.lineNumber, r.startColumn, t.lineNumber, r.endColumn) : D.fromPositions(t), l = a.setEndPosition(t.lineNumber, t.column), d = await this._workerManager.withWorker(), h = await d.textualSuggest(s, r?.word, o);
    return h ? { duration: h.duration, suggestions: h.words.map(((c) => ({ kind: 18, label: c, insertText: c, range: { insert: l, replace: a } }))) } : void 0;
  }
}
class zq extends V {
  constructor(e, t) {
    super(), this.languageConfigurationService = t, this._modelService = e, this._editorWorkerClient = null, this._lastWorkerUsedTime = (/* @__PURE__ */ new Date()).getTime(), this._register(new gR()).cancelAndSet((() => this._checkStopIdleWorker()), Math.round(15e4), It), this._register(this._modelService.onModelRemoved(((i) => this._checkStopEmptyWorker())));
  }
  dispose() {
    this._editorWorkerClient && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null), super.dispose();
  }
  _checkStopEmptyWorker() {
    this._editorWorkerClient && this._modelService.getModels().length === 0 && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null);
  }
  _checkStopIdleWorker() {
    this._editorWorkerClient && (/* @__PURE__ */ new Date()).getTime() - this._lastWorkerUsedTime > Vq && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null);
  }
  withWorker() {
    return this._lastWorkerUsedTime = (/* @__PURE__ */ new Date()).getTime(), this._editorWorkerClient || (this._editorWorkerClient = new NR(this._modelService, !1, "editorWorkerService", this.languageConfigurationService)), Promise.resolve(this._editorWorkerClient);
  }
}
class Uq extends V {
  constructor(e, t, i) {
    if (super(), this._syncedModels = /* @__PURE__ */ Object.create(null), this._syncedModelsLastUsedTime = /* @__PURE__ */ Object.create(null), this._proxy = e, this._modelService = t, !i) {
      const s = new cR();
      s.cancelAndSet((() => this._checkStopModelSync()), Math.round(3e4)), this._register(s);
    }
  }
  dispose() {
    for (const e in this._syncedModels) Ht(this._syncedModels[e]);
    this._syncedModels = /* @__PURE__ */ Object.create(null), this._syncedModelsLastUsedTime = /* @__PURE__ */ Object.create(null), super.dispose();
  }
  ensureSyncedResources(e, t) {
    for (const i of e) {
      const s = i.toString();
      this._syncedModels[s] || this._beginModelSync(i, t), this._syncedModels[s] && (this._syncedModelsLastUsedTime[s] = (/* @__PURE__ */ new Date()).getTime());
    }
  }
  _checkStopModelSync() {
    const e = (/* @__PURE__ */ new Date()).getTime(), t = [];
    for (const i in this._syncedModelsLastUsedTime)
      e - this._syncedModelsLastUsedTime[i] > 6e4 && t.push(i);
    for (const i of t) this._stopModelSync(i);
  }
  _beginModelSync(e, t) {
    const i = this._modelService.getModel(e);
    if (!i || !t && i.isTooLargeForSyncing()) return;
    const s = e.toString();
    this._proxy.acceptNewModel({ url: i.uri.toString(), lines: i.getLinesContent(), EOL: i.getEOL(), versionId: i.getVersionId() });
    const o = new G();
    o.add(i.onDidChangeContent(((r) => {
      this._proxy.acceptModelChanged(s.toString(), r);
    }))), o.add(i.onWillDispose((() => {
      this._stopModelSync(s);
    }))), o.add(ye((() => {
      this._proxy.acceptRemovedModel(s);
    }))), this._syncedModels[s] = o;
  }
  _stopModelSync(e) {
    const t = this._syncedModels[e];
    delete this._syncedModels[e], delete this._syncedModelsLastUsedTime[e], Ht(t);
  }
}
class b4 {
  constructor(e) {
    this._instance = e, this._proxyObj = Promise.resolve(this._instance);
  }
  dispose() {
    this._instance.dispose();
  }
  getProxyObject() {
    return this._proxyObj;
  }
}
class dD {
  constructor(e) {
    this._workerClient = e;
  }
  fhr(e, t) {
    return this._workerClient.fhr(e, t);
  }
}
class NR extends V {
  constructor(e, t, i, s) {
    super(), this.languageConfigurationService = s, this._disposed = !1, this._modelService = e, this._keepIdleModels = t, this._workerFactory = new JS(i), this._worker = null, this._modelManager = null;
  }
  fhr(e, t) {
    throw new Error("Not implemented!");
  }
  _getOrCreateWorker() {
    if (!this._worker) try {
      this._worker = this._register(new Uj(this._workerFactory, "vs/editor/common/services/editorSimpleWorker", new dD(this)));
    } catch (e) {
      PE(e), this._worker = new b4(new Jh(new dD(this), null));
    }
    return this._worker;
  }
  _getProxy() {
    return this._getOrCreateWorker().getProxyObject().then(void 0, ((e) => (PE(e), this._worker = new b4(new Jh(new dD(this), null)), this._getOrCreateWorker().getProxyObject())));
  }
  _getOrCreateModelManager(e) {
    return this._modelManager || (this._modelManager = this._register(new Uq(e, this._modelService, this._keepIdleModels))), this._modelManager;
  }
  async _withSyncedResources(e, t = !1) {
    return this._disposed ? Promise.reject((function() {
      const i = new Error(Ew);
      return i.name = i.message, i;
    })()) : this._getProxy().then(((i) => (this._getOrCreateModelManager(i).ensureSyncedResources(e, t), i)));
  }
  computedUnicodeHighlights(e, t, i) {
    return this._withSyncedResources([e]).then(((s) => s.computeUnicodeHighlights(e.toString(), t, i)));
  }
  computeDiff(e, t, i, s) {
    return this._withSyncedResources([e, t], !0).then(((o) => o.computeDiff(e.toString(), t.toString(), i, s)));
  }
  computeMoreMinimalEdits(e, t, i) {
    return this._withSyncedResources([e]).then(((s) => s.computeMoreMinimalEdits(e.toString(), t, i)));
  }
  computeLinks(e) {
    return this._withSyncedResources([e]).then(((t) => t.computeLinks(e.toString())));
  }
  computeDefaultDocumentColors(e) {
    return this._withSyncedResources([e]).then(((t) => t.computeDefaultDocumentColors(e.toString())));
  }
  async textualSuggest(e, t, i) {
    const s = await this._withSyncedResources(e), o = i.source, r = i.flags;
    return s.textualSuggest(e.map(((a) => a.toString())), t, o, r);
  }
  computeWordRanges(e, t) {
    return this._withSyncedResources([e]).then(((i) => {
      const s = this._modelService.getModel(e);
      if (!s) return Promise.resolve(null);
      const o = this.languageConfigurationService.getLanguageConfiguration(s.getLanguageId()).getWordDefinition(), r = o.source, a = o.flags;
      return i.computeWordRanges(e.toString(), t, r, a);
    }));
  }
  navigateValueSet(e, t, i) {
    return this._withSyncedResources([e]).then(((s) => {
      const o = this._modelService.getModel(e);
      if (!o) return null;
      const r = this.languageConfigurationService.getLanguageConfiguration(o.getLanguageId()).getWordDefinition(), a = r.source, l = r.flags;
      return s.navigateValueSet(e.toString(), t, i, a, l);
    }));
  }
  findSectionHeaders(e, t) {
    return this._withSyncedResources([e]).then(((i) => i.findSectionHeaders(e.toString(), t)));
  }
  dispose() {
    super.dispose(), this._disposed = !0;
  }
}
class Kq extends NR {
  constructor(e, t, i) {
    super(e, i.keepIdleModels || !1, i.label, t), this._foreignModuleId = i.moduleId, this._foreignModuleCreateData = i.createData || null, this._foreignModuleHost = i.host || null, this._foreignProxy = null;
  }
  fhr(e, t) {
    if (!this._foreignModuleHost || typeof this._foreignModuleHost[e] != "function") return Promise.reject(new Error("Missing method " + e + " or missing main thread foreign host."));
    try {
      return Promise.resolve(this._foreignModuleHost[e].apply(this._foreignModuleHost, t));
    } catch (i) {
      return Promise.reject(i);
    }
  }
  _getForeignProxy() {
    return this._foreignProxy || (this._foreignProxy = this._getProxy().then(((e) => {
      const t = this._foreignModuleHost ? KT(this._foreignModuleHost) : [];
      return e.loadForeignModule(this._foreignModuleId, this._foreignModuleCreateData, t).then(((i) => {
        this._foreignModuleCreateData = null;
        const s = (a, l) => e.fmr(a, l), o = (a, l) => function() {
          const d = Array.prototype.slice.call(arguments, 0);
          return l(a, d);
        }, r = {};
        for (const a of i) r[a] = o(a, s);
        return r;
      }));
    }))), this._foreignProxy;
  }
  getProxy() {
    return this._getForeignProxy();
  }
  withSyncedResources(e) {
    return this._withSyncedResources(e).then(((t) => this.getProxy()));
  }
}
const b1 = { ICodeEditor: "vs.editor.ICodeEditor", IDiffEditor: "vs.editor.IDiffEditor" }, Vm = new class {
  clone() {
    return this;
  }
  equals(n) {
    return this === n;
  }
}();
function ER(n, e) {
  return new iR([new q0(0, "", n)], e);
}
function iL(n, e) {
  const t = new Uint32Array(2);
  return t[0] = 0, t[1] = (32768 | n | 2 << 24) >>> 0, new PS(t, e === null ? Vm : e);
}
class In {
  static getLanguageId(e) {
    return (255 & e) >>> 0;
  }
  static getTokenType(e) {
    return (768 & e) >>> 8;
  }
  static containsBalancedBrackets(e) {
    return !!(1024 & e);
  }
  static getFontStyle(e) {
    return (30720 & e) >>> 11;
  }
  static getForeground(e) {
    return (16744448 & e) >>> 15;
  }
  static getBackground(e) {
    return (4278190080 & e) >>> 24;
  }
  static getClassNameFromMetadata(e) {
    let t = "mtk" + this.getForeground(e);
    const i = this.getFontStyle(e);
    return 1 & i && (t += " mtki"), 2 & i && (t += " mtkb"), 4 & i && (t += " mtku"), 8 & i && (t += " mtks"), t;
  }
  static getInlineStyleFromMetadata(e, t) {
    const i = this.getForeground(e), s = this.getFontStyle(e);
    let o = `color: ${t[i]};`;
    1 & s && (o += "font-style: italic;"), 2 & s && (o += "font-weight: bold;");
    let r = "";
    return 4 & s && (r += " underline"), 8 & s && (r += " line-through"), r && (o += `text-decoration:${r};`), o;
  }
  static getPresentationFromMetadata(e) {
    const t = this.getForeground(e), i = this.getFontStyle(e);
    return { foreground: t, italic: !!(1 & i), bold: !!(2 & i), underline: !!(4 & i), strikethrough: !!(8 & i) };
  }
}
class nn {
  static createEmpty(e, t) {
    const i = nn.defaultTokenMetadata, s = new Uint32Array(2);
    return s[0] = e.length, s[1] = i, new nn(s, e, t);
  }
  constructor(e, t, i) {
    this._lineTokensBrand = void 0, this._tokens = e, this._tokensCount = this._tokens.length >>> 1, this._text = t, this._languageIdCodec = i;
  }
  equals(e) {
    return e instanceof nn && this.slicedEquals(e, 0, this._tokensCount);
  }
  slicedEquals(e, t, i) {
    if (this._text !== e._text || this._tokensCount !== e._tokensCount) return !1;
    const s = t << 1, o = s + (i << 1);
    for (let r = s; r < o; r++) if (this._tokens[r] !== e._tokens[r]) return !1;
    return !0;
  }
  getLineContent() {
    return this._text;
  }
  getCount() {
    return this._tokensCount;
  }
  getStartOffset(e) {
    return e > 0 ? this._tokens[e - 1 << 1] : 0;
  }
  getMetadata(e) {
    return this._tokens[1 + (e << 1)];
  }
  getLanguageId(e) {
    const t = this._tokens[1 + (e << 1)], i = In.getLanguageId(t);
    return this._languageIdCodec.decodeLanguageId(i);
  }
  getStandardTokenType(e) {
    const t = this._tokens[1 + (e << 1)];
    return In.getTokenType(t);
  }
  getForeground(e) {
    const t = this._tokens[1 + (e << 1)];
    return In.getForeground(t);
  }
  getClassName(e) {
    const t = this._tokens[1 + (e << 1)];
    return In.getClassNameFromMetadata(t);
  }
  getInlineStyle(e, t) {
    const i = this._tokens[1 + (e << 1)];
    return In.getInlineStyleFromMetadata(i, t);
  }
  getPresentation(e) {
    const t = this._tokens[1 + (e << 1)];
    return In.getPresentationFromMetadata(t);
  }
  getEndOffset(e) {
    return this._tokens[e << 1];
  }
  findTokenIndexAtOffset(e) {
    return nn.findIndexInTokensArray(this._tokens, e);
  }
  inflate() {
    return this;
  }
  sliceAndInflate(e, t, i) {
    return new IR(this, e, t, i);
  }
  static convertToEndOffset(e, t) {
    const i = (e.length >>> 1) - 1;
    for (let s = 0; s < i; s++) e[s << 1] = e[s + 1 << 1];
    e[i << 1] = t;
  }
  static findIndexInTokensArray(e, t) {
    if (e.length <= 2) return 0;
    let i = 0, s = (e.length >>> 1) - 1;
    for (; i < s; ) {
      const o = i + Math.floor((s - i) / 2), r = e[o << 1];
      if (r === t) return o + 1;
      r < t ? i = o + 1 : r > t && (s = o);
    }
    return i;
  }
  withInserted(e) {
    if (e.length === 0) return this;
    let t = 0, i = 0, s = "";
    const o = new Array();
    let r = 0;
    for (; ; ) {
      const a = t < this._tokensCount ? this._tokens[t << 1] : -1, l = i < e.length ? e[i] : null;
      if (a !== -1 && (l === null || a <= l.offset)) {
        s += this._text.substring(r, a);
        const d = this._tokens[1 + (t << 1)];
        o.push(s.length, d), t++, r = a;
      } else {
        if (!l) break;
        if (l.offset > r) {
          s += this._text.substring(r, l.offset);
          const d = this._tokens[1 + (t << 1)];
          o.push(s.length, d), r = l.offset;
        }
        s += l.text, o.push(s.length, l.tokenMetadata), i++;
      }
    }
    return new nn(new Uint32Array(o), s, this._languageIdCodec);
  }
}
nn.defaultTokenMetadata = 33587200;
class IR {
  constructor(e, t, i, s) {
    this._source = e, this._startOffset = t, this._endOffset = i, this._deltaOffset = s, this._firstTokenIndex = e.findTokenIndexAtOffset(t), this._tokensCount = 0;
    for (let o = this._firstTokenIndex, r = e.getCount(); o < r && !(e.getStartOffset(o) >= i); o++)
      this._tokensCount++;
  }
  getMetadata(e) {
    return this._source.getMetadata(this._firstTokenIndex + e);
  }
  getLanguageId(e) {
    return this._source.getLanguageId(this._firstTokenIndex + e);
  }
  getLineContent() {
    return this._source.getLineContent().substring(this._startOffset, this._endOffset);
  }
  equals(e) {
    return e instanceof IR && this._startOffset === e._startOffset && this._endOffset === e._endOffset && this._deltaOffset === e._deltaOffset && this._source.slicedEquals(e._source, this._firstTokenIndex, this._tokensCount);
  }
  getCount() {
    return this._tokensCount;
  }
  getForeground(e) {
    return this._source.getForeground(this._firstTokenIndex + e);
  }
  getEndOffset(e) {
    const t = this._source.getEndOffset(this._firstTokenIndex + e);
    return Math.min(this._endOffset, t) - this._startOffset + this._deltaOffset;
  }
  getClassName(e) {
    return this._source.getClassName(this._firstTokenIndex + e);
  }
  getInlineStyle(e, t) {
    return this._source.getInlineStyle(this._firstTokenIndex + e, t);
  }
  getPresentation(e) {
    return this._source.getPresentation(this._firstTokenIndex + e);
  }
  findTokenIndexAtOffset(e) {
    return this._source.findTokenIndexAtOffset(e + this._startOffset - this._deltaOffset) - this._firstTokenIndex;
  }
}
class _s {
  constructor(e, t, i, s) {
    this.startColumn = e, this.endColumn = t, this.className = i, this.type = s, this._lineDecorationBrand = void 0;
  }
  static _equals(e, t) {
    return e.startColumn === t.startColumn && e.endColumn === t.endColumn && e.className === t.className && e.type === t.type;
  }
  static equalsArr(e, t) {
    const i = e.length;
    if (i !== t.length) return !1;
    for (let s = 0; s < i; s++) if (!_s._equals(e[s], t[s])) return !1;
    return !0;
  }
  static extractWrapped(e, t, i) {
    if (e.length === 0) return e;
    const s = t + 1, o = i + 1, r = i - t, a = [];
    let l = 0;
    for (const d of e) d.endColumn <= s || d.startColumn >= o || (a[l++] = new _s(Math.max(1, d.startColumn - s + 1), Math.min(r + 1, d.endColumn - s + 1), d.className, d.type));
    return a;
  }
  static filter(e, t, i, s) {
    if (e.length === 0) return [];
    const o = [];
    let r = 0;
    for (let a = 0, l = e.length; a < l; a++) {
      const d = e[a], h = d.range;
      if (h.endLineNumber < t || h.startLineNumber > t || h.isEmpty() && (d.type === 0 || d.type === 3)) continue;
      const c = h.startLineNumber === t ? h.startColumn : i, u = h.endLineNumber === t ? h.endColumn : s;
      o[r++] = new _s(c, u, d.inlineClassName, d.type);
    }
    return o;
  }
  static _typeCompare(e, t) {
    const i = [2, 0, 1, 3];
    return i[e] - i[t];
  }
  static compare(e, t) {
    if (e.startColumn !== t.startColumn) return e.startColumn - t.startColumn;
    if (e.endColumn !== t.endColumn) return e.endColumn - t.endColumn;
    const i = _s._typeCompare(e.type, t.type);
    return i !== 0 ? i : e.className !== t.className ? e.className < t.className ? -1 : 1 : 0;
  }
}
class C4 {
  constructor(e, t, i, s) {
    this.startOffset = e, this.endOffset = t, this.className = i, this.metadata = s;
  }
}
class ey {
  constructor() {
    this.stopOffsets = [], this.classNames = [], this.metadata = [], this.count = 0;
  }
  static _metadata(e) {
    let t = 0;
    for (let i = 0, s = e.length; i < s; i++) t |= e[i];
    return t;
  }
  consumeLowerThan(e, t, i) {
    for (; this.count > 0 && this.stopOffsets[0] < e; ) {
      let s = 0;
      for (; s + 1 < this.count && this.stopOffsets[s] === this.stopOffsets[s + 1]; ) s++;
      i.push(new C4(t, this.stopOffsets[s], this.classNames.join(" "), ey._metadata(this.metadata))), t = this.stopOffsets[s] + 1, this.stopOffsets.splice(0, s + 1), this.classNames.splice(0, s + 1), this.metadata.splice(0, s + 1), this.count -= s + 1;
    }
    return this.count > 0 && t < e && (i.push(new C4(t, e - 1, this.classNames.join(" "), ey._metadata(this.metadata))), t = e), t;
  }
  insert(e, t, i) {
    if (this.count === 0 || this.stopOffsets[this.count - 1] <= e) this.stopOffsets.push(e), this.classNames.push(t), this.metadata.push(i);
    else for (let s = 0; s < this.count; s++) if (this.stopOffsets[s] >= e) {
      this.stopOffsets.splice(s, 0, e), this.classNames.splice(s, 0, t), this.metadata.splice(s, 0, i);
      break;
    }
    this.count++;
  }
}
class jq {
  static normalize(e, t) {
    if (t.length === 0) return [];
    const i = [], s = new ey();
    let o = 0;
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      let d = l.startColumn, h = l.endColumn;
      const c = l.className, u = l.type === 1 ? 2 : l.type === 2 ? 4 : 0;
      d > 1 && en(e.charCodeAt(d - 2)) && d--, h > 1 && en(e.charCodeAt(h - 2)) && h--;
      const g = d - 1, p = h - 2;
      o = s.consumeLowerThan(g, o, i), s.count === 0 && (o = g), s.insert(p, c, u);
    }
    return s.consumeLowerThan(1073741824, o, i), i;
  }
}
class ln {
  constructor(e, t, i, s) {
    this.endIndex = e, this.type = t, this.metadata = i, this.containsRTL = s, this._linePartBrand = void 0;
  }
  isWhitespace() {
    return !!(1 & this.metadata);
  }
  isPseudoAfter() {
    return !!(4 & this.metadata);
  }
}
class tB {
  constructor(e, t) {
    this.startOffset = e, this.endOffset = t;
  }
  equals(e) {
    return this.startOffset === e.startOffset && this.endOffset === e.endOffset;
  }
}
class Sc {
  constructor(e, t, i, s, o, r, a, l, d, h, c, u, g, p, f, _, v, b, C) {
    this.useMonospaceOptimizations = e, this.canUseHalfwidthRightwardsArrow = t, this.lineContent = i, this.continuesWithWrappedLine = s, this.isBasicASCII = o, this.containsRTL = r, this.fauxIndentLength = a, this.lineTokens = l, this.lineDecorations = d.sort(_s.compare), this.tabSize = h, this.startVisibleColumn = c, this.spaceWidth = u, this.stopRenderingLineAfter = f, this.renderWhitespace = _ === "all" ? 4 : _ === "boundary" ? 1 : _ === "selection" ? 2 : _ === "trailing" ? 3 : 0, this.renderControlCharacters = v, this.fontLigatures = b, this.selectionsOnLine = C && C.sort(((w, y) => w.startOffset < y.startOffset ? -1 : 1)), Math.abs(p - u) < Math.abs(g - u) ? (this.renderSpaceWidth = p, this.renderSpaceCharCode = 11825) : (this.renderSpaceWidth = g, this.renderSpaceCharCode = 183);
  }
  sameSelection(e) {
    if (this.selectionsOnLine === null) return e === null;
    if (e === null || e.length !== this.selectionsOnLine.length) return !1;
    for (let t = 0; t < this.selectionsOnLine.length; t++) if (!this.selectionsOnLine[t].equals(e[t])) return !1;
    return !0;
  }
  equals(e) {
    return this.useMonospaceOptimizations === e.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineContent === e.lineContent && this.continuesWithWrappedLine === e.continuesWithWrappedLine && this.isBasicASCII === e.isBasicASCII && this.containsRTL === e.containsRTL && this.fauxIndentLength === e.fauxIndentLength && this.tabSize === e.tabSize && this.startVisibleColumn === e.startVisibleColumn && this.spaceWidth === e.spaceWidth && this.renderSpaceWidth === e.renderSpaceWidth && this.renderSpaceCharCode === e.renderSpaceCharCode && this.stopRenderingLineAfter === e.stopRenderingLineAfter && this.renderWhitespace === e.renderWhitespace && this.renderControlCharacters === e.renderControlCharacters && this.fontLigatures === e.fontLigatures && _s.equalsArr(this.lineDecorations, e.lineDecorations) && this.lineTokens.equals(e.lineTokens) && this.sameSelection(e.selectionsOnLine);
  }
}
class iB {
  constructor(e, t) {
    this.partIndex = e, this.charIndex = t;
  }
}
class Va {
  static getPartIndex(e) {
    return (4294901760 & e) >>> 16;
  }
  static getCharIndex(e) {
    return (65535 & e) >>> 0;
  }
  constructor(e, t) {
    this.length = e, this._data = new Uint32Array(this.length), this._horizontalOffset = new Uint32Array(this.length);
  }
  setColumnInfo(e, t, i, s) {
    const o = (t << 16 | i) >>> 0;
    this._data[e - 1] = o, this._horizontalOffset[e - 1] = s;
  }
  getHorizontalOffset(e) {
    return this._horizontalOffset.length === 0 ? 0 : this._horizontalOffset[e - 1];
  }
  charOffsetToPartData(e) {
    return this.length === 0 ? 0 : e < 0 ? this._data[0] : e >= this.length ? this._data[this.length - 1] : this._data[e];
  }
  getDomPosition(e) {
    const t = this.charOffsetToPartData(e - 1), i = Va.getPartIndex(t), s = Va.getCharIndex(t);
    return new iB(i, s);
  }
  getColumn(e, t) {
    return this.partDataToCharOffset(e.partIndex, t, e.charIndex) + 1;
  }
  partDataToCharOffset(e, t, i) {
    if (this.length === 0) return 0;
    const s = (e << 16 | i) >>> 0;
    let o = 0, r = this.length - 1;
    for (; o + 1 < r; ) {
      const u = o + r >>> 1, g = this._data[u];
      if (g === s) return u;
      g > s ? r = u : o = u;
    }
    if (o === r) return o;
    const a = this._data[o], l = this._data[r];
    if (a === s) return o;
    if (l === s) return r;
    const d = Va.getPartIndex(a), h = Va.getCharIndex(a);
    let c;
    return c = d !== Va.getPartIndex(l) ? t : Va.getCharIndex(l), i - h <= c - i ? o : r;
  }
}
class hD {
  constructor(e, t, i) {
    this._renderLineOutputBrand = void 0, this.characterMapping = e, this.containsRTL = t, this.containsForeignElements = i;
  }
}
function C1(n, e) {
  if (n.lineContent.length === 0) {
    if (n.lineDecorations.length > 0) {
      e.appendString("<span>");
      let t = 0, i = 0, s = 0;
      for (const r of n.lineDecorations) r.type !== 1 && r.type !== 2 || (e.appendString('<span class="'), e.appendString(r.className), e.appendString('"></span>'), r.type === 1 && (s |= 1, t++), r.type === 2 && (s |= 2, i++));
      e.appendString("</span>");
      const o = new Va(1, t + i);
      return o.setColumnInfo(1, t, 0, 0), new hD(o, !1, s);
    }
    return e.appendString("<span><span></span></span>"), new hD(new Va(0, 0), !1, 0);
  }
  return (function(t, i) {
    const s = t.fontIsMonospace, o = t.canUseHalfwidthRightwardsArrow, r = t.containsForeignElements, a = t.lineContent, l = t.len, d = t.isOverflowing, h = t.overflowingCharCount, c = t.parts, u = t.fauxIndentLength, g = t.tabSize, p = t.startVisibleColumn, f = t.containsRTL, _ = t.spaceWidth, v = t.renderSpaceCharCode, b = t.renderWhitespace, C = t.renderControlCharacters, w = new Va(l + 1, c.length);
    let y = !1, L = 0, k = p, N = 0, A = 0, B = 0;
    f ? i.appendString('<span dir="ltr">') : i.appendString("<span>");
    for (let T = 0, O = c.length; T < O; T++) {
      const H = c[T], $ = H.endIndex, pe = H.type, me = H.containsRTL, ue = b !== 0 && H.isWhitespace(), ee = ue && !s && (pe === "mtkw" || !r), te = L === $ && H.isPseudoAfter();
      if (N = 0, i.appendString("<span "), me && i.appendString('style="unicode-bidi:isolate" '), i.appendString('class="'), i.appendString(ee ? "mtkz" : pe), i.appendASCIICharCode(34), ue) {
        let be = 0;
        {
          let we = L, Re = k;
          for (; we < $; we++) {
            const it = 0 | (a.charCodeAt(we) === 9 ? g - Re % g : 1);
            be += it, we >= u && (Re += it);
          }
        }
        for (ee && (i.appendString(' style="width:'), i.appendString(String(_ * be)), i.appendString('px"')), i.appendASCIICharCode(62); L < $; L++) {
          w.setColumnInfo(L + 1, T - B, N, A), B = 0;
          let we, Re;
          if (a.charCodeAt(L) === 9) {
            we = g - k % g | 0, Re = we, !o || Re > 1 ? i.appendCharCode(8594) : i.appendCharCode(65515);
            for (let it = 2; it <= Re; it++) i.appendCharCode(160);
          } else we = 2, Re = 1, i.appendCharCode(v), i.appendCharCode(8204);
          N += we, A += Re, L >= u && (k += Re);
        }
      } else for (i.appendASCIICharCode(62); L < $; L++) {
        w.setColumnInfo(L + 1, T - B, N, A), B = 0;
        const be = a.charCodeAt(L);
        let we = 1, Re = 1;
        switch (be) {
          case 9:
            we = g - k % g, Re = we;
            for (let it = 1; it <= we; it++) i.appendCharCode(160);
            break;
          case 32:
            i.appendCharCode(160);
            break;
          case 60:
            i.appendString("&lt;");
            break;
          case 62:
            i.appendString("&gt;");
            break;
          case 38:
            i.appendString("&amp;");
            break;
          case 0:
            C ? i.appendCharCode(9216) : i.appendString("&#00;");
            break;
          case 65279:
          case 8232:
          case 8233:
          case 133:
            i.appendCharCode(65533);
            break;
          default:
            fc(be) && Re++, C && be < 32 ? i.appendCharCode(9216 + be) : C && be === 127 ? i.appendCharCode(9249) : C && w4(be) ? (i.appendString("[U+"), i.appendString(Gq(be)), i.appendString("]"), we = 8, Re = we) : i.appendCharCode(be);
        }
        N += we, A += Re, L >= u && (k += Re);
      }
      te ? B++ : B = 0, L >= l && !y && H.isPseudoAfter() && (y = !0, w.setColumnInfo(L + 1, T, N, A)), i.appendString("</span>");
    }
    return y || w.setColumnInfo(l + 1, c.length - 1, N, A), d && (i.appendString('<span class="mtkoverflow">'), i.appendString(m(0, "Show more ({0})", (function(T) {
      return T < 1024 ? m(0, "{0} chars", T) : T < 1048576 ? `${(T / 1024).toFixed(1)} KB` : `${(T / 1024 / 1024).toFixed(1)} MB`;
    })(h))), i.appendString("</span>")), i.appendString("</span>"), new hD(w, f, r);
  })((function(t) {
    const i = t.lineContent;
    let s, o, r;
    t.stopRenderingLineAfter !== -1 && t.stopRenderingLineAfter < i.length ? (s = !0, o = i.length - t.stopRenderingLineAfter, r = t.stopRenderingLineAfter) : (s = !1, o = 0, r = i.length);
    let a = (function(d, h, c, u, g) {
      const p = [];
      let f = 0;
      u > 0 && (p[f++] = new ln(u, "", 0, !1));
      let _ = u;
      for (let v = 0, b = c.getCount(); v < b; v++) {
        const C = c.getEndOffset(v);
        if (C <= u) continue;
        const w = c.getClassName(v);
        if (C >= g) {
          const L = !!h && Pm(d.substring(_, g));
          p[f++] = new ln(g, w, 0, L);
          break;
        }
        const y = !!h && Pm(d.substring(_, C));
        p[f++] = new ln(C, w, 0, y), _ = C;
      }
      return p;
    })(i, t.containsRTL, t.lineTokens, t.fauxIndentLength, r);
    t.renderControlCharacters && !t.isBasicASCII && (a = (function(d, h) {
      const c = [];
      let u = new ln(0, "", 0, !1), g = 0;
      for (const p of h) {
        const f = p.endIndex;
        for (; g < f; g++)
          w4(d.charCodeAt(g)) && (g > u.endIndex && (u = new ln(g, p.type, p.metadata, p.containsRTL), c.push(u)), u = new ln(g + 1, "mtkcontrol", p.metadata, !1), c.push(u));
        g > u.endIndex && (u = new ln(f, p.type, p.metadata, p.containsRTL), c.push(u));
      }
      return c;
    })(i, a)), (t.renderWhitespace === 4 || t.renderWhitespace === 1 || t.renderWhitespace === 2 && t.selectionsOnLine || t.renderWhitespace === 3 && !t.continuesWithWrappedLine) && (a = (function(d, h, c, u) {
      const g = d.continuesWithWrappedLine, p = d.fauxIndentLength, f = d.tabSize, _ = d.startVisibleColumn, v = d.useMonospaceOptimizations, b = d.selectionsOnLine, C = d.renderWhitespace === 1, w = d.renderWhitespace === 3, y = d.renderSpaceWidth !== d.spaceWidth, L = [];
      let k = 0, N = 0, A = u[N].type, B = u[N].containsRTL, T = u[N].endIndex;
      const O = u.length;
      let H, $ = !1, pe = Jn(h);
      pe === -1 ? ($ = !0, pe = c, H = c) : H = oa(h);
      let me = !1, ue = 0, ee = b && b[ue], te = _ % f;
      for (let we = p; we < c; we++) {
        const Re = h.charCodeAt(we);
        let it;
        if (ee && we >= ee.endOffset && (ue++, ee = b && b[ue]), we < pe || we > H) it = !0;
        else if (Re === 9) it = !0;
        else if (Re === 32) if (C) if (me) it = !0;
        else {
          const ut = we + 1 < c ? h.charCodeAt(we + 1) : 0;
          it = ut === 32 || ut === 9;
        }
        else it = !0;
        else it = !1;
        if (it && b && (it = !!ee && ee.startOffset <= we && ee.endOffset > we), it && w && (it = $ || we > H), it && B && we >= pe && we <= H && (it = !1), me) {
          if (!it || !v && te >= f) {
            if (y)
              for (let ut = (k > 0 ? L[k - 1].endIndex : p) + 1; ut <= we; ut++) L[k++] = new ln(ut, "mtkw", 1, !1);
            else L[k++] = new ln(we, "mtkw", 1, !1);
            te %= f;
          }
        } else (we === T || it && we > p) && (L[k++] = new ln(we, A, 0, B), te %= f);
        for (Re === 9 ? te = f : fc(Re) ? te += 2 : te++, me = it; we === T && (N++, N < O); ) A = u[N].type, B = u[N].containsRTL, T = u[N].endIndex;
      }
      let be = !1;
      if (me) if (g && C) {
        const we = c > 0 ? h.charCodeAt(c - 1) : 0, Re = c > 1 ? h.charCodeAt(c - 2) : 0;
        we === 32 && Re !== 32 && Re !== 9 || (be = !0);
      } else be = !0;
      if (be) if (y)
        for (let we = (k > 0 ? L[k - 1].endIndex : p) + 1; we <= c; we++) L[k++] = new ln(we, "mtkw", 1, !1);
      else L[k++] = new ln(c, "mtkw", 1, !1);
      else L[k++] = new ln(c, A, 0, B);
      return L;
    })(t, i, r, a));
    let l = 0;
    if (t.lineDecorations.length > 0) {
      for (let d = 0, h = t.lineDecorations.length; d < h; d++) {
        const c = t.lineDecorations[d];
        c.type === 3 || c.type === 1 ? l |= 1 : c.type === 2 && (l |= 2);
      }
      a = (function(d, h, c, u) {
        u.sort(_s.compare);
        const g = jq.normalize(d, u), p = g.length;
        let f = 0;
        const _ = [];
        let v = 0, b = 0;
        for (let w = 0, y = c.length; w < y; w++) {
          const L = c[w], k = L.endIndex, N = L.type, A = L.metadata, B = L.containsRTL;
          for (; f < p && g[f].startOffset < k; ) {
            const T = g[f];
            if (T.startOffset > b && (b = T.startOffset, _[v++] = new ln(b, N, A, B)), !(T.endOffset + 1 <= k)) {
              b = k, _[v++] = new ln(b, N + " " + T.className, A | T.metadata, B);
              break;
            }
            b = T.endOffset + 1, _[v++] = new ln(b, N + " " + T.className, A | T.metadata, B), f++;
          }
          k > b && (b = k, _[v++] = new ln(b, N, A, B));
        }
        const C = c[c.length - 1].endIndex;
        if (f < p && g[f].startOffset === C) for (; f < p && g[f].startOffset === C; ) {
          const w = g[f];
          _[v++] = new ln(b, w.className, w.metadata, !1), f++;
        }
        return _;
      })(i, 0, a, t.lineDecorations);
    }
    return t.containsRTL || (a = (function(d, h, c) {
      let u = 0;
      const g = [];
      let p = 0;
      if (c) for (let f = 0, _ = h.length; f < _; f++) {
        const v = h[f], b = v.endIndex;
        if (u + 50 < b) {
          const C = v.type, w = v.metadata, y = v.containsRTL;
          let L = -1, k = u;
          for (let N = u; N < b; N++) d.charCodeAt(N) === 32 && (L = N), L !== -1 && N - k >= 50 && (g[p++] = new ln(L + 1, C, w, y), k = L + 1, L = -1);
          k !== b && (g[p++] = new ln(b, C, w, y));
        } else g[p++] = v;
        u = b;
      }
      else for (let f = 0, _ = h.length; f < _; f++) {
        const v = h[f], b = v.endIndex, C = b - u;
        if (C > 50) {
          const w = v.type, y = v.metadata, L = v.containsRTL, k = Math.ceil(C / 50);
          for (let N = 1; N < k; N++) {
            const A = u + 50 * N;
            g[p++] = new ln(A, w, y, L);
          }
          g[p++] = new ln(b, w, y, L);
        } else g[p++] = v;
        u = b;
      }
      return g;
    })(i, a, !t.isBasicASCII || t.fontLigatures)), new $q(t.useMonospaceOptimizations, t.canUseHalfwidthRightwardsArrow, i, r, s, o, a, l, t.fauxIndentLength, t.tabSize, t.startVisibleColumn, t.containsRTL, t.spaceWidth, t.renderSpaceCharCode, t.renderWhitespace, t.renderControlCharacters);
  })(n), e);
}
class qq {
  constructor(e, t, i, s) {
    this.characterMapping = e, this.html = t, this.containsRTL = i, this.containsForeignElements = s;
  }
}
function ty(n) {
  const e = new pf(1e4), t = C1(n, e);
  return new qq(t.characterMapping, e.build(), t.containsRTL, t.containsForeignElements);
}
class $q {
  constructor(e, t, i, s, o, r, a, l, d, h, c, u, g, p, f, _) {
    this.fontIsMonospace = e, this.canUseHalfwidthRightwardsArrow = t, this.lineContent = i, this.len = s, this.isOverflowing = o, this.overflowingCharCount = r, this.parts = a, this.containsForeignElements = l, this.fauxIndentLength = d, this.tabSize = h, this.startVisibleColumn = c, this.containsRTL = u, this.spaceWidth = g, this.renderSpaceCharCode = p, this.renderWhitespace = f, this.renderControlCharacters = _;
  }
}
function w4(n) {
  return n < 32 ? n !== 9 : n === 127 || n >= 8234 && n <= 8238 || n >= 8294 && n <= 8297 || n >= 8206 && n <= 8207 || n === 1564;
}
function Gq(n) {
  return n.toString(16).toUpperCase().padStart(4, "0");
}
class y4 {
  constructor(e, t, i, s) {
    this._viewportBrand = void 0, this.top = 0 | e, this.left = 0 | t, this.width = 0 | i, this.height = 0 | s;
  }
}
class Zq {
  constructor(e, t) {
    this.tabSize = e, this.data = t;
  }
}
class MR {
  constructor(e, t, i, s, o, r, a) {
    this._viewLineDataBrand = void 0, this.content = e, this.continuesWithWrappedLine = t, this.minColumn = i, this.maxColumn = s, this.startVisibleColumn = o, this.tokens = r, this.inlineDecorations = a;
  }
}
class Co {
  constructor(e, t, i, s, o, r, a, l, d, h) {
    this.minColumn = e, this.maxColumn = t, this.content = i, this.continuesWithWrappedLine = s, this.isBasicASCII = Co.isBasicASCII(i, r), this.containsRTL = Co.containsRTL(i, this.isBasicASCII, o), this.tokens = a, this.inlineDecorations = l, this.tabSize = d, this.startVisibleColumn = h;
  }
  static isBasicASCII(e, t) {
    return !t || p1(e);
  }
  static containsRTL(e, t, i) {
    return !(t || !i) && Pm(e);
  }
}
class Y_ {
  constructor(e, t, i) {
    this.range = e, this.inlineClassName = t, this.type = i;
  }
}
class Yq {
  constructor(e, t, i, s) {
    this.startOffset = e, this.endOffset = t, this.inlineClassName = i, this.inlineClassNameAffectsLetterSpacing = s;
  }
  toInlineDecoration(e) {
    return new Y_(new D(e, this.startOffset + 1, e, this.endOffset + 1), this.inlineClassName, this.inlineClassNameAffectsLetterSpacing ? 3 : 0);
  }
}
class nB {
  constructor(e, t) {
    this._viewModelDecorationBrand = void 0, this.range = e, this.options = t;
  }
}
class av {
  constructor(e, t, i) {
    this.color = e, this.zIndex = t, this.data = i;
  }
  static compareByRenderingProps(e, t) {
    return e.zIndex === t.zIndex ? e.color < t.color ? -1 : e.color > t.color ? 1 : 0 : e.zIndex - t.zIndex;
  }
  static equals(e, t) {
    return e.color === t.color && e.zIndex === t.zIndex && ri(e.data, t.data);
  }
  static equalsArr(e, t) {
    return ri(e, t, av.equals);
  }
}
function Xq(n) {
  return !(function(e) {
    return Array.isArray(e);
  })(n);
}
function sB(n) {
  return typeof n == "string";
}
function S4(n) {
  return !sB(n);
}
function fu(n) {
  return !n;
}
function xd(n, e) {
  return n.ignoreCase && e ? e.toLowerCase() : e;
}
function L4(n) {
  return n.replace(/[&<>'"_]/g, "-");
}
function Gt(n, e) {
  return new Error(`${n.languageId}: ${e}`);
}
function _h(n, e, t, i, s) {
  let o = null;
  return e.replace(/\$((\$)|(#)|(\d\d?)|[sS](\d\d?)|@(\w+))/g, (function(r, a, l, d, h, c, u, g, p) {
    return fu(l) ? fu(d) ? !fu(h) && h < i.length ? xd(n, i[h]) : !fu(u) && n && typeof n[u] == "string" ? n[u] : (o === null && (o = s.split("."), o.unshift(s)), !fu(c) && c < o.length ? xd(n, o[c]) : "") : xd(n, t) : "$";
  }));
}
function ob(n, e) {
  let t = e;
  for (; t && t.length > 0; ) {
    const i = n.tokenizer[t];
    if (i) return i;
    const s = t.lastIndexOf(".");
    t = s < 0 ? null : t.substr(0, s);
  }
  return null;
}
var jE, Qq = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Jq = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class lv {
  static create(e, t) {
    return this._INSTANCE.create(e, t);
  }
  constructor(e) {
    this._maxCacheDepth = e, this._entries = /* @__PURE__ */ Object.create(null);
  }
  create(e, t) {
    if (e !== null && e.depth >= this._maxCacheDepth) return new im(e, t);
    let i = im.getStackElementId(e);
    i.length > 0 && (i += "|"), i += t;
    let s = this._entries[i];
    return s || (s = new im(e, t), this._entries[i] = s, s);
  }
}
lv._INSTANCE = new lv(5);
class im {
  constructor(e, t) {
    this.parent = e, this.state = t, this.depth = (this.parent ? this.parent.depth : 0) + 1;
  }
  static getStackElementId(e) {
    let t = "";
    for (; e !== null; ) t.length > 0 && (t += "|"), t += e.state, e = e.parent;
    return t;
  }
  static _equals(e, t) {
    for (; e !== null && t !== null; ) {
      if (e === t) return !0;
      if (e.state !== t.state) return !1;
      e = e.parent, t = t.parent;
    }
    return e === null && t === null;
  }
  equals(e) {
    return im._equals(this, e);
  }
  push(e) {
    return lv.create(this, e);
  }
  pop() {
    return this.parent;
  }
  popall() {
    let e = this;
    for (; e.parent; ) e = e.parent;
    return e;
  }
  switchTo(e) {
    return lv.create(this.parent, e);
  }
}
class X_ {
  constructor(e, t) {
    this.languageId = e, this.state = t;
  }
  equals(e) {
    return this.languageId === e.languageId && this.state.equals(e.state);
  }
  clone() {
    return this.state.clone() === this.state ? this : new X_(this.languageId, this.state);
  }
}
class vh {
  static create(e, t) {
    return this._INSTANCE.create(e, t);
  }
  constructor(e) {
    this._maxCacheDepth = e, this._entries = /* @__PURE__ */ Object.create(null);
  }
  create(e, t) {
    if (t !== null) return new Q_(e, t);
    if (e !== null && e.depth >= this._maxCacheDepth) return new Q_(e, t);
    const i = im.getStackElementId(e);
    let s = this._entries[i];
    return s || (s = new Q_(e, null), this._entries[i] = s, s);
  }
}
vh._INSTANCE = new vh(5);
class Q_ {
  constructor(e, t) {
    this.stack = e, this.embeddedLanguageData = t;
  }
  clone() {
    return (this.embeddedLanguageData ? this.embeddedLanguageData.clone() : null) === this.embeddedLanguageData ? this : vh.create(this.stack, this.embeddedLanguageData);
  }
  equals(e) {
    return e instanceof Q_ && !!this.stack.equals(e.stack) && (this.embeddedLanguageData === null && e.embeddedLanguageData === null || this.embeddedLanguageData !== null && e.embeddedLanguageData !== null && this.embeddedLanguageData.equals(e.embeddedLanguageData));
  }
}
class e$ {
  constructor() {
    this._tokens = [], this._languageId = null, this._lastTokenType = null, this._lastTokenLanguage = null;
  }
  enterLanguage(e) {
    this._languageId = e;
  }
  emit(e, t) {
    this._lastTokenType === t && this._lastTokenLanguage === this._languageId || (this._lastTokenType = t, this._lastTokenLanguage = this._languageId, this._tokens.push(new q0(e, t, this._languageId)));
  }
  nestedLanguageTokenize(e, t, i, s) {
    const o = i.languageId, r = i.state, a = ci.get(o);
    if (!a) return this.enterLanguage(o), this.emit(s, ""), r;
    const l = a.tokenize(e, t, r);
    if (s !== 0) for (const d of l.tokens) this._tokens.push(new q0(d.offset + s, d.type, d.language));
    else this._tokens = this._tokens.concat(l.tokens);
    return this._lastTokenType = null, this._lastTokenLanguage = null, this._languageId = null, l.endState;
  }
  finalize(e) {
    return new iR(this._tokens, e);
  }
}
class iy {
  constructor(e, t) {
    this._languageService = e, this._theme = t, this._prependTokens = null, this._tokens = [], this._currentLanguageId = 0, this._lastTokenMetadata = 0;
  }
  enterLanguage(e) {
    this._currentLanguageId = this._languageService.languageIdCodec.encodeLanguageId(e);
  }
  emit(e, t) {
    const i = 1024 | this._theme.match(this._currentLanguageId, t);
    this._lastTokenMetadata !== i && (this._lastTokenMetadata = i, this._tokens.push(e), this._tokens.push(i));
  }
  static _merge(e, t, i) {
    const s = e !== null ? e.length : 0, o = t.length, r = i !== null ? i.length : 0;
    if (s === 0 && o === 0 && r === 0) return new Uint32Array(0);
    if (s === 0 && o === 0) return i;
    if (o === 0 && r === 0) return e;
    const a = new Uint32Array(s + o + r);
    e !== null && a.set(e);
    for (let l = 0; l < o; l++) a[s + l] = t[l];
    return i !== null && a.set(i, s + o), a;
  }
  nestedLanguageTokenize(e, t, i, s) {
    const o = i.languageId, r = i.state, a = ci.get(o);
    if (!a) return this.enterLanguage(o), this.emit(s, ""), r;
    const l = a.tokenizeEncoded(e, t, r);
    if (s !== 0) for (let d = 0, h = l.tokens.length; d < h; d += 2) l.tokens[d] += s;
    return this._prependTokens = iy._merge(this._prependTokens, this._tokens, l.tokens), this._tokens = [], this._currentLanguageId = 0, this._lastTokenMetadata = 0, l.endState;
  }
  finalize(e) {
    return new PS(iy._merge(this._prependTokens, this._tokens, null), e);
  }
}
let dv = jE = class extends V {
  constructor(n, e, t, i, s) {
    super(), this._configurationService = s, this._languageService = n, this._standaloneThemeService = e, this._languageId = t, this._lexer = i, this._embeddedLanguages = /* @__PURE__ */ Object.create(null), this.embeddedLoaded = Promise.resolve(void 0);
    let o = !1;
    this._register(ci.onDidChange(((r) => {
      if (o) return;
      let a = !1;
      for (let l = 0, d = r.changedLanguages.length; l < d; l++) {
        const h = r.changedLanguages[l];
        if (this._embeddedLanguages[h]) {
          a = !0;
          break;
        }
      }
      a && (o = !0, ci.handleChange([this._languageId]), o = !1);
    }))), this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", { overrideIdentifier: this._languageId }), this._register(this._configurationService.onDidChangeConfiguration(((r) => {
      r.affectsConfiguration("editor.maxTokenizationLineLength") && (this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", { overrideIdentifier: this._languageId }));
    })));
  }
  getLoadStatus() {
    const n = [];
    for (const e in this._embeddedLanguages) {
      const t = ci.get(e);
      if (t) {
        if (t instanceof jE) {
          const i = t.getLoadStatus();
          i.loaded === !1 && n.push(i.promise);
        }
      } else ci.isResolved(e) || n.push(ci.getOrCreate(e));
    }
    return n.length === 0 ? { loaded: !0 } : { loaded: !1, promise: Promise.all(n).then(((e) => {
    })) };
  }
  getInitialState() {
    const n = lv.create(null, this._lexer.start);
    return vh.create(n, null);
  }
  tokenize(n, e, t) {
    if (n.length >= this._maxTokenizationLineLength) return ER(this._languageId, t);
    const i = new e$(), s = this._tokenize(n, e, t, i);
    return i.finalize(s);
  }
  tokenizeEncoded(n, e, t) {
    if (n.length >= this._maxTokenizationLineLength) return iL(this._languageService.languageIdCodec.encodeLanguageId(this._languageId), t);
    const i = new iy(this._languageService, this._standaloneThemeService.getColorTheme().tokenTheme), s = this._tokenize(n, e, t, i);
    return i.finalize(s);
  }
  _tokenize(n, e, t, i) {
    return t.embeddedLanguageData ? this._nestedTokenize(n, e, t, 0, i) : this._myTokenize(n, e, t, 0, i);
  }
  _findLeavingNestedLanguageOffset(n, e) {
    let t = this._lexer.tokenizer[e.stack.state];
    if (!t && (t = ob(this._lexer, e.stack.state), !t)) throw Gt(this._lexer, "tokenizer state is not defined: " + e.stack.state);
    let i = -1, s = !1;
    for (const o of t) {
      if (!S4(o.action) || o.action.nextEmbedded !== "@pop") continue;
      s = !0;
      let r = o.resolveRegex(e.stack.state);
      const a = r.source;
      if (a.substr(0, 4) === "^(?:" && a.substr(a.length - 1, 1) === ")") {
        const d = (r.ignoreCase ? "i" : "") + (r.unicode ? "u" : "");
        r = new RegExp(a.substr(4, a.length - 5), d);
      }
      const l = n.search(r);
      l === -1 || l !== 0 && o.matchOnlyAtLineStart || (i === -1 || l < i) && (i = l);
    }
    if (!s) throw Gt(this._lexer, 'no rule containing nextEmbedded: "@pop" in tokenizer embedded state: ' + e.stack.state);
    return i;
  }
  _nestedTokenize(n, e, t, i, s) {
    const o = this._findLeavingNestedLanguageOffset(n, t);
    if (o === -1) {
      const l = s.nestedLanguageTokenize(n, e, t.embeddedLanguageData, i);
      return vh.create(t.stack, new X_(t.embeddedLanguageData.languageId, l));
    }
    const r = n.substring(0, o);
    r.length > 0 && s.nestedLanguageTokenize(r, !1, t.embeddedLanguageData, i);
    const a = n.substring(o);
    return this._myTokenize(a, e, t, i + o, s);
  }
  _safeRuleName(n) {
    return n ? n.name : "(unknown)";
  }
  _myTokenize(n, e, t, i, s) {
    s.enterLanguage(this._languageId);
    const o = n.length, r = e && this._lexer.includeLF ? n + `
` : n, a = r.length;
    let l = t.embeddedLanguageData, d = t.stack, h = 0, c = null, u = !0;
    for (; u || h < a; ) {
      const f = h, _ = d.depth, v = c ? c.groups.length : 0, b = d.state;
      let C = null, w = null, y = null, L = null, k = null;
      if (c) {
        C = c.matches;
        const B = c.groups.shift();
        w = B.matched, y = B.action, L = c.rule, c.groups.length === 0 && (c = null);
      } else {
        if (!u && h >= a) break;
        u = !1;
        let B = this._lexer.tokenizer[b];
        if (!B && (B = ob(this._lexer, b), !B)) throw Gt(this._lexer, "tokenizer state is not defined: " + b);
        const T = r.substr(h);
        for (const O of B) if ((h === 0 || !O.matchOnlyAtLineStart) && (C = T.match(O.resolveRegex(b)), C)) {
          w = C[0], y = O.action;
          break;
        }
      }
      if (C || (C = [""], w = ""), y || (h < a && (C = [r.charAt(h)], w = C[0]), y = this._lexer.defaultToken), w === null) break;
      for (h += w.length; Xq(y) && S4(y) && y.test; ) y = y.test(w, C, b, h === a);
      let N = null;
      if (typeof y == "string" || Array.isArray(y)) N = y;
      else if (y.group) N = y.group;
      else if (y.token !== null && y.token !== void 0) {
        if (N = y.tokenSubst ? _h(this._lexer, y.token, w, C, b) : y.token, y.nextEmbedded) if (y.nextEmbedded === "@pop") {
          if (!l) throw Gt(this._lexer, "cannot pop embedded language if not inside one");
          l = null;
        } else {
          if (l) throw Gt(this._lexer, "cannot enter embedded language from within an embedded language");
          k = _h(this._lexer, y.nextEmbedded, w, C, b);
        }
        if (y.goBack && (h = Math.max(0, h - y.goBack)), y.switchTo && typeof y.switchTo == "string") {
          let B = _h(this._lexer, y.switchTo, w, C, b);
          if (B[0] === "@" && (B = B.substr(1)), !ob(this._lexer, B)) throw Gt(this._lexer, "trying to switch to a state '" + B + "' that is undefined in rule: " + this._safeRuleName(L));
          d = d.switchTo(B);
        } else {
          if (y.transform && typeof y.transform == "function") throw Gt(this._lexer, "action.transform not supported");
          if (y.next) if (y.next === "@push") {
            if (d.depth >= this._lexer.maxStack) throw Gt(this._lexer, "maximum tokenizer stack size reached: [" + d.state + "," + d.parent.state + ",...]");
            d = d.push(b);
          } else if (y.next === "@pop") {
            if (d.depth <= 1) throw Gt(this._lexer, "trying to pop an empty stack in rule: " + this._safeRuleName(L));
            d = d.pop();
          } else if (y.next === "@popall") d = d.popall();
          else {
            let B = _h(this._lexer, y.next, w, C, b);
            if (B[0] === "@" && (B = B.substr(1)), !ob(this._lexer, B)) throw Gt(this._lexer, "trying to set a next state '" + B + "' that is undefined in rule: " + this._safeRuleName(L));
            d = d.push(B);
          }
        }
        y.log && typeof y.log == "string" && (g = this._lexer, p = this._lexer.languageId + ": " + _h(this._lexer, y.log, w, C, b), console.log(`${g.languageId}: ${p}`));
      }
      if (N === null) throw Gt(this._lexer, "lexer rule has no well-defined action in rule: " + this._safeRuleName(L));
      const A = (B) => {
        const T = this._languageService.getLanguageIdByLanguageName(B) || this._languageService.getLanguageIdByMimeType(B) || B, O = this._getNestedEmbeddedLanguageData(T);
        if (h < a) {
          const H = n.substr(h);
          return this._nestedTokenize(H, e, vh.create(d, O), i + h, s);
        }
        return vh.create(d, O);
      };
      if (Array.isArray(N)) {
        if (c && c.groups.length > 0) throw Gt(this._lexer, "groups cannot be nested: " + this._safeRuleName(L));
        if (C.length !== N.length + 1) throw Gt(this._lexer, "matched number of groups does not match the number of actions in rule: " + this._safeRuleName(L));
        let B = 0;
        for (let T = 1; T < C.length; T++) B += C[T].length;
        if (B !== w.length) throw Gt(this._lexer, "with groups, all characters should be matched in consecutive groups in rule: " + this._safeRuleName(L));
        c = { rule: L, matches: C, groups: [] };
        for (let T = 0; T < N.length; T++) c.groups[T] = { action: N[T], matched: C[T + 1] };
        h -= w.length;
      } else {
        {
          if (N === "@rematch" && (h -= w.length, w = "", C = null, N = "", k !== null)) return A(k);
          if (w.length === 0) {
            if (a === 0 || _ !== d.depth || b !== d.state || (c ? c.groups.length : 0) !== v) continue;
            throw Gt(this._lexer, "no progress in tokenizer in rule: " + this._safeRuleName(L));
          }
          let B = null;
          if (sB(N) && N.indexOf("@brackets") === 0) {
            const T = N.substr(9), O = t$(this._lexer, w);
            if (!O) throw Gt(this._lexer, "@brackets token returned but no bracket defined as: " + w);
            B = L4(O.token + T);
          } else
            B = L4(N === "" ? "" : N + this._lexer.tokenPostfix);
          f < o && s.emit(f + i, B);
        }
        if (k !== null) return A(k);
      }
    }
    var g, p;
    return vh.create(d, l);
  }
  _getNestedEmbeddedLanguageData(n) {
    if (!this._languageService.isRegisteredLanguageId(n)) return new X_(n, Vm);
    n !== this._languageId && (this._languageService.requestBasicLanguageFeatures(n), ci.getOrCreate(n), this._embeddedLanguages[n] = !0);
    const e = ci.get(n);
    return new X_(n, e ? e.getInitialState() : Vm);
  }
};
function t$(n, e) {
  if (!e) return null;
  e = xd(n, e);
  const t = n.brackets;
  for (const i of t) {
    if (i.open === e) return { token: i.token, bracketType: 1 };
    if (i.close === e) return { token: i.token, bracketType: -1 };
  }
  return null;
}
dv = jE = Qq([Jq(4, Ye)], dv);
const k4 = Hd("standaloneColorizer", { createHTML: (n) => n });
class TR {
  static colorizeElement(e, t, i, s) {
    const o = (s = s || {}).theme || "vs", r = s.mimeType || i.getAttribute("lang") || i.getAttribute("data-lang");
    if (!r) return console.error("Mode not detected"), Promise.resolve();
    const a = t.getLanguageIdByMimeType(r) || r;
    e.setTheme(o);
    const l = i.firstChild ? i.firstChild.nodeValue : "";
    return i.className += " " + o, this.colorize(t, l || "", a, s).then(((d) => {
      var h;
      const c = (h = k4?.createHTML(d)) !== null && h !== void 0 ? h : d;
      i.innerHTML = c;
    }), ((d) => console.error(d)));
  }
  static async colorize(e, t, i, s) {
    const o = e.languageIdCodec;
    let r = 4;
    s && typeof s.tabSize == "number" && (r = s.tabSize), lR(t) && (t = t.substr(1));
    const a = Sl(t);
    if (!e.isRegisteredLanguageId(i)) return D4(a, r, o);
    const l = await ci.getOrCreate(i);
    return l ? (function(d, h, c, u) {
      return new Promise(((g, p) => {
        const f = () => {
          const _ = (function(v, b, C, w) {
            let y = [], L = C.getInitialState();
            for (let k = 0, N = v.length; k < N; k++) {
              const A = v[k], B = C.tokenizeEncoded(A, !0, L);
              nn.convertToEndOffset(B.tokens, A.length);
              const T = new nn(B.tokens, A, w), O = Co.isBasicASCII(A, !0), H = Co.containsRTL(A, O, !0), $ = ty(new Sc(!1, !0, A, !1, O, H, 0, T.inflate(), [], b, 0, 0, 0, 0, -1, "none", !1, !1, null));
              y = y.concat($.html), y.push("<br/>"), L = B.endState;
            }
            return y.join("");
          })(d, h, c, u);
          if (c instanceof dv) {
            const v = c.getLoadStatus();
            if (v.loaded === !1) return void v.promise.then(f, p);
          }
          g(_);
        };
        f();
      }));
    })(a, r, l, o) : D4(a, r, o);
  }
  static colorizeLine(e, t, i, s, o = 4) {
    const r = Co.isBasicASCII(e, t), a = Co.containsRTL(e, r, i);
    return ty(new Sc(!1, !0, e, !1, r, a, 0, s, [], o, 0, 0, 0, 0, -1, "none", !1, !1, null)).html;
  }
  static colorizeModelLine(e, t, i = 4) {
    const s = e.getLineContent(t);
    e.tokenization.forceTokenization(t);
    const o = e.tokenization.getLineTokens(t).inflate();
    return this.colorizeLine(s, e.mightContainNonBasicASCII(), e.mightContainRTL(), o, i);
  }
}
function D4(n, e, t) {
  let i = [];
  const s = new Uint32Array(2);
  s[0] = 0, s[1] = 33587200;
  for (let o = 0, r = n.length; o < r; o++) {
    const a = n[o];
    s[0] = a.length;
    const l = new nn(s, a, t), d = Co.isBasicASCII(a, !0), h = Co.containsRTL(a, d, !0), c = ty(new Sc(!1, !0, a, !1, d, h, 0, l, [], e, 0, 0, 0, 0, -1, "none", !1, !1, null));
    i = i.concat(c.html), i.push("<br/>");
  }
  return i.join("");
}
const x4 = 2e4;
let _u, RC, qE, AC, $E;
function Io(n) {
  _u && (RC.textContent !== n ? (Un(qE), ny(RC, n)) : (Un(RC), ny(qE, n)));
}
function vl(n) {
  _u && (AC.textContent !== n ? (Un($E), ny(AC, n)) : (Un(AC), ny($E, n)));
}
function ny(n, e) {
  Un(n), e.length > x4 && (e = e.substr(0, x4)), n.textContent = e, n.style.visibility = "hidden", n.style.visibility = "visible";
}
const RR = tt("markerDecorationsService");
var i$ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, n$ = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Pf = class {
  constructor(n, e) {
  }
  dispose() {
  }
};
Pf.ID = "editor.contrib.markerDecorations", Pf = i$([n$(1, RR)], Pf), ft(Pf.ID, Pf, 0);
class oB extends V {
  constructor(e, t) {
    super(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._referenceDomElement = e, this._width = -1, this._height = -1, this._resizeObserver = null, this.measureReferenceDomElement(!1, t);
  }
  dispose() {
    this.stopObserving(), super.dispose();
  }
  getWidth() {
    return this._width;
  }
  getHeight() {
    return this._height;
  }
  startObserving() {
    if (!this._resizeObserver && this._referenceDomElement) {
      let e = null;
      const t = () => {
        e ? this.observe({ width: e.width, height: e.height }) : this.observe();
      };
      let i = !1, s = !1;
      const o = () => {
        if (i && !s) try {
          i = !1, s = !0, t();
        } finally {
          Ys(ke(this._referenceDomElement), (() => {
            s = !1, o();
          }));
        }
      };
      this._resizeObserver = new ResizeObserver(((r) => {
        e = r && r[0] && r[0].contentRect ? { width: r[0].contentRect.width, height: r[0].contentRect.height } : null, i = !0, o();
      })), this._resizeObserver.observe(this._referenceDomElement);
    }
  }
  stopObserving() {
    this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = null);
  }
  observe(e) {
    this.measureReferenceDomElement(!0, e);
  }
  measureReferenceDomElement(e, t) {
    let i = 0, s = 0;
    t ? (i = t.width, s = t.height) : this._referenceDomElement && (i = this._referenceDomElement.clientWidth, s = this._referenceDomElement.clientHeight), i = Math.max(5, i), s = Math.max(5, s), this._width === i && this._height === s || (this._width = i, this._height = s, e && this._onDidChange.fire());
  }
}
class ec {
  constructor(e, t) {
    this.key = e, this.migrate = t;
  }
  apply(e) {
    const t = ec._read(e, this.key);
    this.migrate(t, ((i) => ec._read(e, i)), ((i, s) => ec._write(e, i, s)));
  }
  static _read(e, t) {
    if (e === void 0) return;
    const i = t.indexOf(".");
    if (i >= 0) {
      const s = t.substring(0, i);
      return this._read(e[s], t.substring(i + 1));
    }
    return e[t];
  }
  static _write(e, t, i) {
    const s = t.indexOf(".");
    if (s >= 0) {
      const o = t.substring(0, s);
      return e[o] = e[o] || {}, void this._write(e[o], t.substring(s + 1), i);
    }
    e[t] = i;
  }
}
function Ur(n, e) {
  ec.items.push(new ec(n, e));
}
function Hs(n, e) {
  Ur(n, ((t, i, s) => {
    if (t !== void 0) {
      for (const [o, r] of e) if (t === o) return void s(n, r);
    }
  }));
}
ec.items = [], Hs("wordWrap", [[!0, "on"], [!1, "off"]]), Hs("lineNumbers", [[!0, "on"], [!1, "off"]]), Hs("cursorBlinking", [["visible", "solid"]]), Hs("renderWhitespace", [[!0, "boundary"], [!1, "none"]]), Hs("renderLineHighlight", [[!0, "line"], [!1, "none"]]), Hs("acceptSuggestionOnEnter", [[!0, "on"], [!1, "off"]]), Hs("tabCompletion", [[!1, "off"], [!0, "onlySnippets"]]), Hs("hover", [[!0, { enabled: !0 }], [!1, { enabled: !1 }]]), Hs("parameterHints", [[!0, { enabled: !0 }], [!1, { enabled: !1 }]]), Hs("autoIndent", [[!1, "advanced"], [!0, "full"]]), Hs("matchBrackets", [[!0, "always"], [!1, "never"]]), Hs("renderFinalNewline", [[!0, "on"], [!1, "off"]]), Hs("cursorSmoothCaretAnimation", [[!0, "on"], [!1, "off"]]), Hs("occurrencesHighlight", [[!0, "singleFile"], [!1, "off"]]), Hs("wordBasedSuggestions", [[!0, "matchingDocuments"], [!1, "off"]]), Ur("autoClosingBrackets", ((n, e, t) => {
  n === !1 && (t("autoClosingBrackets", "never"), e("autoClosingQuotes") === void 0 && t("autoClosingQuotes", "never"), e("autoSurround") === void 0 && t("autoSurround", "never"));
})), Ur("renderIndentGuides", ((n, e, t) => {
  n !== void 0 && (t("renderIndentGuides", void 0), e("guides.indentation") === void 0 && t("guides.indentation", !!n));
})), Ur("highlightActiveIndentGuide", ((n, e, t) => {
  n !== void 0 && (t("highlightActiveIndentGuide", void 0), e("guides.highlightActiveIndentation") === void 0 && t("guides.highlightActiveIndentation", !!n));
}));
const s$ = { method: "showMethods", function: "showFunctions", constructor: "showConstructors", deprecated: "showDeprecated", field: "showFields", variable: "showVariables", class: "showClasses", struct: "showStructs", interface: "showInterfaces", module: "showModules", property: "showProperties", event: "showEvents", operator: "showOperators", unit: "showUnits", value: "showValues", constant: "showConstants", enum: "showEnums", enumMember: "showEnumMembers", keyword: "showKeywords", text: "showWords", color: "showColors", file: "showFiles", reference: "showReferences", folder: "showFolders", typeParameter: "showTypeParameters", snippet: "showSnippets" };
Ur("suggest.filteredTypes", ((n, e, t) => {
  if (n && typeof n == "object") {
    for (const i of Object.entries(s$))
      n[i[0]] === !1 && e(`suggest.${i[1]}`) === void 0 && t(`suggest.${i[1]}`, !1);
    t("suggest.filteredTypes", void 0);
  }
})), Ur("quickSuggestions", ((n, e, t) => {
  if (typeof n == "boolean") {
    const i = n ? "on" : "off";
    t("quickSuggestions", { comments: i, strings: i, other: i });
  }
})), Ur("experimental.stickyScroll.enabled", ((n, e, t) => {
  typeof n == "boolean" && (t("experimental.stickyScroll.enabled", void 0), e("stickyScroll.enabled") === void 0 && t("stickyScroll.enabled", n));
})), Ur("experimental.stickyScroll.maxLineCount", ((n, e, t) => {
  typeof n == "number" && (t("experimental.stickyScroll.maxLineCount", void 0), e("stickyScroll.maxLineCount") === void 0 && t("stickyScroll.maxLineCount", n));
})), Ur("codeActionsOnSave", ((n, e, t) => {
  if (n && typeof n == "object") {
    let i = !1;
    const s = {};
    for (const o of Object.entries(n)) typeof o[1] == "boolean" ? (i = !0, s[o[0]] = o[1] ? "explicit" : "never") : s[o[0]] = o[1];
    i && t("codeActionsOnSave", s);
  }
})), Ur("codeActionWidget.includeNearbyQuickfixes", ((n, e, t) => {
  typeof n == "boolean" && (t("codeActionWidget.includeNearbyQuickfixes", void 0), e("codeActionWidget.includeNearbyQuickFixes") === void 0 && t("codeActionWidget.includeNearbyQuickFixes", n));
})), Ur("lightbulb.enabled", ((n, e, t) => {
  typeof n == "boolean" && t("lightbulb.enabled", n ? void 0 : "off");
}));
const Hm = new class {
  constructor() {
    this._tabFocus = !1, this._onDidChangeTabFocus = new F(), this.onDidChangeTabFocus = this._onDidChangeTabFocus.event;
  }
  getTabFocusMode() {
    return this._tabFocus;
  }
  setTabFocusMode(n) {
    this._tabFocus = n, this._onDidChangeTabFocus.fire(this._tabFocus);
  }
}(), or = tt("accessibilityService"), g_ = new ae("accessibilityModeEnabled", !1);
var o$ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, r$ = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let GE = class extends V {
  constructor(n, e, t, i) {
    super(), this._accessibilityService = i, this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._onDidChangeFast = this._register(new F()), this.onDidChangeFast = this._onDidChangeFast.event, this._isDominatedByLongLines = !1, this._viewLineCount = 1, this._lineNumbersDigitCount = 1, this._reservedHeight = 0, this._glyphMarginDecorationLaneCount = 1, this._computeOptionsMemory = new E7(), this.isSimpleWidget = n, this._containerObserver = this._register(new oB(t, e.dimension)), this._targetWindowId = ke(t).vscodeWindowId, this._rawOptions = N4(e), this._validatedOptions = bh.validateOptions(this._rawOptions), this.options = this._computeOptions(), this.options.get(13) && this._containerObserver.startObserving(), this._register(Vo.onDidChangeZoomLevel((() => this._recomputeOptions()))), this._register(Hm.onDidChangeTabFocus((() => this._recomputeOptions()))), this._register(this._containerObserver.onDidChange((() => this._recomputeOptions()))), this._register(TE.onDidChange((() => this._recomputeOptions()))), this._register(Q0.getInstance(ke(t)).onDidChange((() => this._recomputeOptions()))), this._register(this._accessibilityService.onDidChangeScreenReaderOptimized((() => this._recomputeOptions())));
  }
  _recomputeOptions() {
    const n = this._computeOptions(), e = bh.checkEquals(this.options, n);
    e !== null && (this.options = n, this._onDidChangeFast.fire(e), this._onDidChange.fire(e));
  }
  _computeOptions() {
    const n = this._readEnvConfiguration(), e = zu.createFromValidatedSettings(this._validatedOptions, n.pixelRatio, this.isSimpleWidget), t = this._readFontInfo(e), i = { memory: this._computeOptionsMemory, outerWidth: n.outerWidth, outerHeight: n.outerHeight - this._reservedHeight, fontInfo: t, extraEditorClassName: n.extraEditorClassName, isDominatedByLongLines: this._isDominatedByLongLines, viewLineCount: this._viewLineCount, lineNumbersDigitCount: this._lineNumbersDigitCount, emptySelectionClipboard: n.emptySelectionClipboard, pixelRatio: n.pixelRatio, tabFocusMode: Hm.getTabFocusMode(), accessibilitySupport: n.accessibilitySupport, glyphMarginDecorationLaneCount: this._glyphMarginDecorationLaneCount };
    return bh.computeOptions(this._validatedOptions, i);
  }
  _readEnvConfiguration() {
    return { extraEditorClassName: a$(), outerWidth: this._containerObserver.getWidth(), outerHeight: this._containerObserver.getHeight(), emptySelectionClipboard: OS || tr, pixelRatio: Q0.getInstance(SO(this._targetWindowId, !0).window).value, accessibilitySupport: this._accessibilityService.isScreenReaderOptimized() ? 2 : this._accessibilityService.getAccessibilitySupport() };
  }
  _readFontInfo(n) {
    return TE.readFontInfo(SO(this._targetWindowId, !0).window, n);
  }
  getRawOptions() {
    return this._rawOptions;
  }
  updateOptions(n) {
    const e = N4(n);
    bh.applyUpdate(this._rawOptions, e) && (this._validatedOptions = bh.validateOptions(this._rawOptions), this._recomputeOptions());
  }
  observeContainer(n) {
    this._containerObserver.observe(n);
  }
  setIsDominatedByLongLines(n) {
    this._isDominatedByLongLines !== n && (this._isDominatedByLongLines = n, this._recomputeOptions());
  }
  setModelLineCount(n) {
    const e = (function(t) {
      let i = 0;
      for (; t; ) t = Math.floor(t / 10), i++;
      return i || 1;
    })(n);
    this._lineNumbersDigitCount !== e && (this._lineNumbersDigitCount = e, this._recomputeOptions());
  }
  setViewLineCount(n) {
    this._viewLineCount !== n && (this._viewLineCount = n, this._recomputeOptions());
  }
  setReservedHeight(n) {
    this._reservedHeight !== n && (this._reservedHeight = n, this._recomputeOptions());
  }
  setGlyphMarginDecorationLaneCount(n) {
    this._glyphMarginDecorationLaneCount !== n && (this._glyphMarginDecorationLaneCount = n, this._recomputeOptions());
  }
};
function a$() {
  let n = "";
  return _c || s8 || (n += "no-user-select "), _c && (n += "no-minimap-shadow ", n += "enable-user-select "), Je && (n += "mac "), n;
}
GE = o$([r$(3, or)], GE);
class l$ {
  constructor() {
    this._values = [];
  }
  _read(e) {
    return this._values[e];
  }
  get(e) {
    return this._values[e];
  }
  _write(e, t) {
    this._values[e] = t;
  }
}
class d$ {
  constructor() {
    this._values = [];
  }
  _read(e) {
    if (e >= this._values.length) throw new Error("Cannot read uninitialized value");
    return this._values[e];
  }
  get(e) {
    return this._read(e);
  }
  _write(e, t) {
    this._values[e] = t;
  }
}
class bh {
  static validateOptions(e) {
    const t = new l$();
    for (const i of yp) {
      const s = i.name === "_never_" ? void 0 : e[i.name];
      t._write(i.id, i.validate(s));
    }
    return t;
  }
  static computeOptions(e, t) {
    const i = new d$();
    for (const s of yp) i._write(s.id, s.compute(t, i, e._read(s.id)));
    return i;
  }
  static _deepEquals(e, t) {
    if (typeof e != "object" || typeof t != "object" || !e || !t) return e === t;
    if (Array.isArray(e) || Array.isArray(t)) return !(!Array.isArray(e) || !Array.isArray(t)) && ri(e, t);
    if (Object.keys(e).length !== Object.keys(t).length) return !1;
    for (const i in e) if (!bh._deepEquals(e[i], t[i])) return !1;
    return !0;
  }
  static checkEquals(e, t) {
    const i = [];
    let s = !1;
    for (const o of yp) {
      const r = !bh._deepEquals(e._read(o.id), t._read(o.id));
      i[o.id] = r, r && (s = !0);
    }
    return s ? new N7(i) : null;
  }
  static applyUpdate(e, t) {
    let i = !1;
    for (const s of yp) if (t.hasOwnProperty(s.name)) {
      const o = s.applyUpdate(e[s.name], t[s.name]);
      e[s.name] = o.newValue, i = i || o.didChange;
    }
    return i;
  }
}
function N4(n) {
  const e = Ul(n);
  return (function(t) {
    ec.items.forEach(((i) => i.apply(t)));
  })(e), e;
}
var Ih;
(function(n) {
  const e = { total: 0, min: Number.MAX_VALUE, max: 0 }, t = { ...e }, i = { ...e }, s = { ...e };
  let o = 0;
  const r = { keydown: 0, input: 0, render: 0 };
  function a() {
    r.keydown === 1 && (performance.mark("keydown/end"), r.keydown = 2);
  }
  function l() {
    performance.mark("input/start"), r.input = 1, c();
  }
  function d() {
    r.input === 1 && (performance.mark("input/end"), r.input = 2);
  }
  function h() {
    r.render === 1 && (performance.mark("render/end"), r.render = 2);
  }
  function c() {
    setTimeout(u);
  }
  function u() {
    r.keydown === 2 && r.input === 2 && r.render === 2 && (performance.mark("inputlatency/end"), performance.measure("keydown", "keydown/start", "keydown/end"), performance.measure("input", "input/start", "input/end"), performance.measure("render", "render/start", "render/end"), performance.measure("inputlatency", "inputlatency/start", "inputlatency/end"), g("keydown", e), g("input", t), g("render", i), g("inputlatency", s), o++, performance.clearMarks("keydown/start"), performance.clearMarks("keydown/end"), performance.clearMarks("input/start"), performance.clearMarks("input/end"), performance.clearMarks("render/start"), performance.clearMarks("render/end"), performance.clearMarks("inputlatency/start"), performance.clearMarks("inputlatency/end"), performance.clearMeasures("keydown"), performance.clearMeasures("input"), performance.clearMeasures("render"), performance.clearMeasures("inputlatency"), r.keydown = 0, r.input = 0, r.render = 0);
  }
  function g(_, v) {
    const b = performance.getEntriesByName(_)[0].duration;
    v.total += b, v.min = Math.min(v.min, b), v.max = Math.max(v.max, b);
  }
  function p(_) {
    return { average: _.total / o, max: _.max, min: _.min };
  }
  function f(_) {
    _.total = 0, _.min = Number.MAX_VALUE, _.max = 0;
  }
  n.onKeyDown = function() {
    u(), performance.mark("inputlatency/start"), performance.mark("keydown/start"), r.keydown = 1, queueMicrotask(a);
  }, n.onBeforeInput = l, n.onInput = function() {
    r.input === 0 && l(), queueMicrotask(d);
  }, n.onKeyUp = function() {
    u();
  }, n.onSelectionChange = function() {
    u();
  }, n.onRenderStart = function() {
    r.keydown === 2 && r.input === 2 && r.render === 0 && (performance.mark("render/start"), r.render = 1, queueMicrotask(h), c());
  }, n.getAndClearMeasurements = function() {
    if (o === 0) return;
    const _ = { keydown: p(e), input: p(t), render: p(i), total: p(s), sampleCount: o };
    return f(e), f(t), f(i), f(s), o = 0, _;
  };
})(Ih || (Ih = {}));
class ff {
  constructor() {
    this._hooks = new G(), this._pointerMoveCallback = null, this._onStopCallback = null;
  }
  dispose() {
    this.stopMonitoring(!1), this._hooks.dispose();
  }
  stopMonitoring(e, t) {
    if (!this.isMonitoring()) return;
    this._hooks.clear(), this._pointerMoveCallback = null;
    const i = this._onStopCallback;
    this._onStopCallback = null, e && i && i(t);
  }
  isMonitoring() {
    return !!this._pointerMoveCallback;
  }
  startMonitoring(e, t, i, s, o) {
    this.isMonitoring() && this.stopMonitoring(!1), this._pointerMoveCallback = s, this._onStopCallback = o;
    let r = e;
    try {
      e.setPointerCapture(t), this._hooks.add(ye((() => {
        try {
          e.releasePointerCapture(t);
        } catch {
        }
      })));
    } catch {
      r = ke(e);
    }
    this._hooks.add(K(r, ie.POINTER_MOVE, ((a) => {
      a.buttons === i ? (a.preventDefault(), this._pointerMoveCallback(a)) : this.stopMonitoring(!0);
    }))), this._hooks.add(K(r, ie.POINTER_UP, ((a) => this.stopMonitoring(!0))));
  }
}
function AR(n) {
  return `--vscode-${n.replace(/\./g, "-")}`;
}
function de(n) {
  return `var(${AR(n)})`;
}
const rB = "base.contributions.colors", nL = new class {
  constructor() {
    this._onDidChangeSchema = new F(), this.onDidChangeSchema = this._onDidChangeSchema.event, this.colorSchema = { type: "object", properties: {} }, this.colorReferenceSchema = { type: "string", enum: [], enumDescriptions: [] }, this.colorsById = {};
  }
  registerColor(n, e, t, i = !1, s) {
    const o = { id: n, description: t, defaults: e, needsTransparency: i, deprecationMessage: s };
    this.colorsById[n] = o;
    const r = { type: "string", description: t, format: "color-hex", defaultSnippets: [{ body: "${1:#ff0000}" }] };
    return s && (r.deprecationMessage = s), i && (r.pattern = "^#(?:(?<rgba>[0-9a-fA-f]{3}[0-9a-eA-E])|(?:[0-9a-fA-F]{6}(?:(?![fF]{2})(?:[0-9a-fA-F]{2}))))?$", r.patternErrorMessage = "This color must be transparent or it will obscure content"), this.colorSchema.properties[n] = r, this.colorReferenceSchema.enum.push(n), this.colorReferenceSchema.enumDescriptions.push(t), this._onDidChangeSchema.fire(), n;
  }
  getColors() {
    return Object.keys(this.colorsById).map(((n) => this.colorsById[n]));
  }
  resolveDefaultColor(n, e) {
    const t = this.colorsById[n];
    if (t && t.defaults)
      return Pr(t.defaults[e.type], e);
  }
  getColorSchema() {
    return this.colorSchema;
  }
  toString() {
    return Object.keys(this.colorsById).sort(((n, e) => {
      const t = n.indexOf(".") === -1 ? 0 : 1, i = e.indexOf(".") === -1 ? 0 : 1;
      return t !== i ? t - i : n.localeCompare(e);
    })).map(((n) => `- \`${n}\`: ${this.colorsById[n].description}`)).join(`
`);
  }
}();
function I(n, e, t, i, s) {
  return nL.registerColor(n, e, t, i, s);
}
function Ng(n, e) {
  return { op: 0, value: n, factor: e };
}
function ra(n, e) {
  return { op: 1, value: n, factor: e };
}
function Ce(n, e) {
  return { op: 2, value: n, factor: e };
}
function hv(...n) {
  return { op: 4, values: n };
}
function E4(n, e, t, i) {
  return { op: 5, value: n, background: e, factor: t, transparency: i };
}
function Pr(n, e) {
  if (n !== null) return typeof n == "string" ? n[0] === "#" ? z.fromHex(n) : e.getColor(n) : n instanceof z ? n : typeof n == "object" ? (function(t, i) {
    var s, o, r, a;
    switch (t.op) {
      case 0:
        return (s = Pr(t.value, i)) === null || s === void 0 ? void 0 : s.darken(t.factor);
      case 1:
        return (o = Pr(t.value, i)) === null || o === void 0 ? void 0 : o.lighten(t.factor);
      case 2:
        return (r = Pr(t.value, i)) === null || r === void 0 ? void 0 : r.transparent(t.factor);
      case 3: {
        const l = Pr(t.background, i);
        return l ? (a = Pr(t.value, i)) === null || a === void 0 ? void 0 : a.makeOpaque(l) : Pr(t.value, i);
      }
      case 4:
        for (const l of t.values) {
          const d = Pr(l, i);
          if (d) return d;
        }
        return;
      case 6:
        return Pr(i.defines(t.if) ? t.then : t.else, i);
      case 5: {
        const l = Pr(t.value, i);
        if (!l) return;
        const d = Pr(t.background, i);
        return d ? l.isDarkerThan(d) ? z.getLighterColor(l, d, t.factor).transparent(t.transparency) : z.getDarkerColor(l, d, t.factor).transparent(t.transparency) : l.transparent(t.factor * t.transparency);
      }
      default:
        throw XS();
    }
  })(n, e) : void 0;
}
li.add(rB, nL);
const aB = "vscode://schemas/workbench-colors", lB = li.as(tL);
lB.registerSchema(aB, nL.getColorSchema());
const I4 = new Et((() => lB.notifySchemaChanged(aB)), 200);
nL.onDidChangeSchema((() => {
  I4.isScheduled() || I4.schedule();
}));
const oe = I("foreground", { dark: "#CCCCCC", light: "#616161", hcDark: "#FFFFFF", hcLight: "#292929" }, m(0, "Overall foreground color. This color is only used if not overridden by a component."));
I("disabledForeground", { dark: "#CCCCCC80", light: "#61616180", hcDark: "#A5A5A5", hcLight: "#7F7F7F" }, m(0, "Overall foreground for disabled elements. This color is only used if not overridden by a component.")), I("errorForeground", { dark: "#F48771", light: "#A1260D", hcDark: "#F48771", hcLight: "#B5200D" }, m(0, "Overall foreground color for error messages. This color is only used if not overridden by a component.")), I("descriptionForeground", { light: "#717171", dark: Ce(oe, 0.7), hcDark: Ce(oe, 0.7), hcLight: Ce(oe, 0.7) }, m(0, "Foreground color for description text providing additional information, for example for a label."));
const nl = I("icon.foreground", { dark: "#C5C5C5", light: "#424242", hcDark: "#FFFFFF", hcLight: "#292929" }, m(0, "The default color for icons in the workbench.")), $o = I("focusBorder", { dark: "#007FD4", light: "#0090F1", hcDark: "#F38518", hcLight: "#006BBD" }, m(0, "Overall border color for focused elements. This color is only used if not overridden by a component.")), ot = I("contrastBorder", { light: null, dark: null, hcDark: "#6FC3DF", hcLight: "#0F4A85" }, m(0, "An extra border around elements to separate them from others for greater contrast.")), Zt = I("contrastActiveBorder", { light: null, dark: null, hcDark: $o, hcLight: $o }, m(0, "An extra border around active elements to separate them from others for greater contrast."));
I("selection.background", { light: null, dark: null, hcDark: null, hcLight: null }, m(0, "The background color of text selections in the workbench (e.g. for input fields or text areas). Note that this does not apply to selections within the editor."));
const h$ = I("textLink.foreground", { light: "#006AB1", dark: "#3794FF", hcDark: "#21A6FF", hcLight: "#0F4A85" }, m(0, "Foreground color for links in text."));
I("textLink.activeForeground", { light: "#006AB1", dark: "#3794FF", hcDark: "#21A6FF", hcLight: "#0F4A85" }, m(0, "Foreground color for links in text when clicked on and on mouse hover.")), I("textSeparator.foreground", { light: "#0000002e", dark: "#ffffff2e", hcDark: z.black, hcLight: "#292929" }, m(0, "Color for text separators.")), I("textPreformat.foreground", { light: "#A31515", dark: "#D7BA7D", hcDark: "#000000", hcLight: "#FFFFFF" }, m(0, "Foreground color for preformatted text segments.")), I("textPreformat.background", { light: "#0000001A", dark: "#FFFFFF1A", hcDark: "#FFFFFF", hcLight: "#09345f" }, m(0, "Background color for preformatted text segments.")), I("textBlockQuote.background", { light: "#f2f2f2", dark: "#222222", hcDark: null, hcLight: "#F2F2F2" }, m(0, "Background color for block quotes in text.")), I("textBlockQuote.border", { light: "#007acc80", dark: "#007acc80", hcDark: z.white, hcLight: "#292929" }, m(0, "Border color for block quotes in text.")), I("textCodeBlock.background", { light: "#dcdcdc66", dark: "#0a0a0a66", hcDark: z.black, hcLight: "#F2F2F2" }, m(0, "Background color for code blocks in text.")), I("sash.hoverBorder", { dark: $o, light: $o, hcDark: $o, hcLight: $o }, m(0, "Border color of active sashes."));
const PC = I("badge.background", { dark: "#4D4D4D", light: "#C4C4C4", hcDark: z.black, hcLight: "#0F4A85" }, m(0, "Badge background color. Badges are small information labels, e.g. for search results count.")), c$ = I("badge.foreground", { dark: z.white, light: "#333", hcDark: z.white, hcLight: z.white }, m(0, "Badge foreground color. Badges are small information labels, e.g. for search results count.")), p_ = I("scrollbar.shadow", { dark: "#000000", light: "#DDDDDD", hcDark: null, hcLight: null }, m(0, "Scrollbar shadow to indicate that the view is scrolled.")), m_ = I("scrollbarSlider.background", { dark: z.fromHex("#797979").transparent(0.4), light: z.fromHex("#646464").transparent(0.4), hcDark: Ce(ot, 0.6), hcLight: Ce(ot, 0.4) }, m(0, "Scrollbar slider background color.")), f_ = I("scrollbarSlider.hoverBackground", { dark: z.fromHex("#646464").transparent(0.7), light: z.fromHex("#646464").transparent(0.7), hcDark: Ce(ot, 0.8), hcLight: Ce(ot, 0.8) }, m(0, "Scrollbar slider background color when hovering.")), __ = I("scrollbarSlider.activeBackground", { dark: z.fromHex("#BFBFBF").transparent(0.4), light: z.fromHex("#000000").transparent(0.6), hcDark: ot, hcLight: ot }, m(0, "Scrollbar slider background color when clicked on.")), u$ = I("progressBar.background", { dark: z.fromHex("#0E70C0"), light: z.fromHex("#0E70C0"), hcDark: ot, hcLight: ot }, m(0, "Background color of the progress bar that can show for long running operations.")), sn = I("editor.background", { light: "#ffffff", dark: "#1E1E1E", hcDark: z.black, hcLight: z.white }, m(0, "Editor background color.")), Go = I("editor.foreground", { light: "#333333", dark: "#BBBBBB", hcDark: z.white, hcLight: oe }, m(0, "Editor default foreground color."));
I("editorStickyScroll.background", { light: sn, dark: sn, hcDark: sn, hcLight: sn }, m(0, "Background color of sticky scroll in the editor")), I("editorStickyScrollHover.background", { dark: "#2A2D2E", light: "#F0F0F0", hcDark: null, hcLight: z.fromHex("#0F4A85").transparent(0.1) }, m(0, "Background color of sticky scroll on hover in the editor")), I("editorStickyScroll.border", { dark: null, light: null, hcDark: ot, hcLight: ot }, m(0, "Border color of sticky scroll in the editor")), I("editorStickyScroll.shadow", { dark: p_, light: p_, hcDark: p_, hcLight: p_ }, m(0, " Shadow color of sticky scroll in the editor"));
const xi = I("editorWidget.background", { dark: "#252526", light: "#F3F3F3", hcDark: "#0C141F", hcLight: z.white }, m(0, "Background color of editor widgets, such as find/replace.")), ld = I("editorWidget.foreground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "Foreground color of editor widgets, such as find/replace.")), dd = I("editorWidget.border", { dark: "#454545", light: "#C8C8C8", hcDark: ot, hcLight: ot }, m(0, "Border color of editor widgets. The color is only used if the widget chooses to have a border and if the color is not overridden by a widget."));
I("editorWidget.resizeBorder", { light: null, dark: null, hcDark: null, hcLight: null }, m(0, "Border color of the resize bar of editor widgets. The color is only used if the widget chooses to have a resize border and if the color is not overridden by a widget.")), I("editorError.background", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color of error text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0);
const sl = I("editorError.foreground", { dark: "#F14C4C", light: "#E51400", hcDark: "#F48771", hcLight: "#B5200D" }, m(0, "Foreground color of error squigglies in the editor.")), g$ = I("editorError.border", { dark: null, light: null, hcDark: z.fromHex("#E47777").transparent(0.8), hcLight: "#B5200D" }, m(0, "If set, color of double underlines for errors in the editor.")), rb = I("editorWarning.background", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color of warning text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0), Qn = I("editorWarning.foreground", { dark: "#CCA700", light: "#BF8803", hcDark: "#FFD370", hcLight: "#895503" }, m(0, "Foreground color of warning squigglies in the editor.")), cv = I("editorWarning.border", { dark: null, light: null, hcDark: z.fromHex("#FFCC00").transparent(0.8), hcLight: z.fromHex("#FFCC00").transparent(0.8) }, m(0, "If set, color of double underlines for warnings in the editor."));
I("editorInfo.background", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color of info text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0);
const Rs = I("editorInfo.foreground", { dark: "#3794FF", light: "#1a85ff", hcDark: "#3794FF", hcLight: "#1a85ff" }, m(0, "Foreground color of info squigglies in the editor.")), uv = I("editorInfo.border", { dark: null, light: null, hcDark: z.fromHex("#3794FF").transparent(0.8), hcLight: "#292929" }, m(0, "If set, color of double underlines for infos in the editor.")), p$ = I("editorHint.foreground", { dark: z.fromHex("#eeeeee").transparent(0.7), light: "#6c6c6c", hcDark: null, hcLight: null }, m(0, "Foreground color of hint squigglies in the editor."));
I("editorHint.border", { dark: null, light: null, hcDark: z.fromHex("#eeeeee").transparent(0.8), hcLight: "#292929" }, m(0, "If set, color of double underlines for hints in the editor."));
const m$ = I("editorLink.activeForeground", { dark: "#4E94CE", light: z.blue, hcDark: z.cyan, hcLight: "#292929" }, m(0, "Color of active links.")), Mh = I("editor.selectionBackground", { light: "#ADD6FF", dark: "#264F78", hcDark: "#f3f518", hcLight: "#0F4A85" }, m(0, "Color of the editor selection.")), f$ = I("editor.selectionForeground", { light: null, dark: null, hcDark: "#000000", hcLight: z.white }, m(0, "Color of the selected text for high contrast.")), dB = I("editor.inactiveSelectionBackground", { light: Ce(Mh, 0.5), dark: Ce(Mh, 0.5), hcDark: Ce(Mh, 0.7), hcLight: Ce(Mh, 0.5) }, m(0, "Color of the selection in an inactive editor. The color must not be opaque so as not to hide underlying decorations."), !0), PR = I("editor.selectionHighlightBackground", { light: E4(Mh, sn, 0.3, 0.6), dark: E4(Mh, sn, 0.3, 0.6), hcDark: null, hcLight: null }, m(0, "Color for regions with the same content as the selection. The color must not be opaque so as not to hide underlying decorations."), !0);
I("editor.selectionHighlightBorder", { light: null, dark: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color for regions with the same content as the selection.")), I("editor.findMatchBackground", { light: "#A8AC94", dark: "#515C6A", hcDark: null, hcLight: null }, m(0, "Color of the current search match."));
const hd = I("editor.findMatchHighlightBackground", { light: "#EA5C0055", dark: "#EA5C0055", hcDark: null, hcLight: null }, m(0, "Color of the other search matches. The color must not be opaque so as not to hide underlying decorations."), !0);
I("editor.findRangeHighlightBackground", { dark: "#3a3d4166", light: "#b4b4b44d", hcDark: null, hcLight: null }, m(0, "Color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), !0), I("editor.findMatchBorder", { light: null, dark: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color of the current search match."));
const Th = I("editor.findMatchHighlightBorder", { light: null, dark: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color of the other search matches.")), _$ = I("editor.findRangeHighlightBorder", { dark: null, light: null, hcDark: Ce(Zt, 0.4), hcLight: Ce(Zt, 0.4) }, m(0, "Border color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), !0);
I("editor.hoverHighlightBackground", { light: "#ADD6FF26", dark: "#264f7840", hcDark: "#ADD6FF26", hcLight: null }, m(0, "Highlight below the word for which a hover is shown. The color must not be opaque so as not to hide underlying decorations."), !0);
const sy = I("editorHoverWidget.background", { light: xi, dark: xi, hcDark: xi, hcLight: xi }, m(0, "Background color of the editor hover."));
I("editorHoverWidget.foreground", { light: ld, dark: ld, hcDark: ld, hcLight: ld }, m(0, "Foreground color of the editor hover."));
const hB = I("editorHoverWidget.border", { light: dd, dark: dd, hcDark: dd, hcLight: dd }, m(0, "Border color of the editor hover."));
I("editorHoverWidget.statusBarBackground", { dark: ra(sy, 0.2), light: Ng(sy, 0.05), hcDark: xi, hcLight: xi }, m(0, "Background color of the editor hover status bar."));
const cd = I("editorInlayHint.foreground", { dark: "#969696", light: "#969696", hcDark: z.white, hcLight: z.black }, m(0, "Foreground color of inline hints")), ud = I("editorInlayHint.background", { dark: Ce(PC, 0.1), light: Ce(PC, 0.1), hcDark: Ce(z.white, 0.1), hcLight: Ce(PC, 0.1) }, m(0, "Background color of inline hints")), v$ = I("editorInlayHint.typeForeground", { dark: cd, light: cd, hcDark: cd, hcLight: cd }, m(0, "Foreground color of inline hints for types")), b$ = I("editorInlayHint.typeBackground", { dark: ud, light: ud, hcDark: ud, hcLight: ud }, m(0, "Background color of inline hints for types")), C$ = I("editorInlayHint.parameterForeground", { dark: cd, light: cd, hcDark: cd, hcLight: cd }, m(0, "Foreground color of inline hints for parameters")), w$ = I("editorInlayHint.parameterBackground", { dark: ud, light: ud, hcDark: ud, hcLight: ud }, m(0, "Background color of inline hints for parameters")), ab = I("editorLightBulb.foreground", { dark: "#FFCC00", light: "#DDB100", hcDark: "#FFCC00", hcLight: "#007ACC" }, m(0, "The color used for the lightbulb actions icon."));
I("editorLightBulbAutoFix.foreground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, m(0, "The color used for the lightbulb auto fix actions icon.")), I("editorLightBulbAi.foreground", { dark: ab, light: ab, hcDark: ab, hcLight: ab }, m(0, "The color used for the lightbulb AI icon.")), I("editor.snippetTabstopHighlightBackground", { dark: new z(new ht(124, 124, 124, 0.3)), light: new z(new ht(10, 50, 100, 0.2)), hcDark: new z(new ht(124, 124, 124, 0.3)), hcLight: new z(new ht(10, 50, 100, 0.2)) }, m(0, "Highlight background color of a snippet tabstop.")), I("editor.snippetTabstopHighlightBorder", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Highlight border color of a snippet tabstop.")), I("editor.snippetFinalTabstopHighlightBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Highlight background color of the final tabstop of a snippet.")), I("editor.snippetFinalTabstopHighlightBorder", { dark: "#525252", light: new z(new ht(10, 50, 100, 0.5)), hcDark: "#525252", hcLight: "#292929" }, m(0, "Highlight border color of the final tabstop of a snippet."));
const ZE = new z(new ht(155, 185, 85, 0.2)), YE = new z(new ht(255, 0, 0, 0.2)), y$ = I("diffEditor.insertedTextBackground", { dark: "#9ccc2c33", light: "#9ccc2c40", hcDark: null, hcLight: null }, m(0, "Background color for text that got inserted. The color must not be opaque so as not to hide underlying decorations."), !0), S$ = I("diffEditor.removedTextBackground", { dark: "#ff000033", light: "#ff000033", hcDark: null, hcLight: null }, m(0, "Background color for text that got removed. The color must not be opaque so as not to hide underlying decorations."), !0);
I("diffEditor.insertedLineBackground", { dark: ZE, light: ZE, hcDark: null, hcLight: null }, m(0, "Background color for lines that got inserted. The color must not be opaque so as not to hide underlying decorations."), !0), I("diffEditor.removedLineBackground", { dark: YE, light: YE, hcDark: null, hcLight: null }, m(0, "Background color for lines that got removed. The color must not be opaque so as not to hide underlying decorations."), !0), I("diffEditorGutter.insertedLineBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color for the margin where lines got inserted.")), I("diffEditorGutter.removedLineBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color for the margin where lines got removed."));
const L$ = I("diffEditorOverview.insertedForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Diff overview ruler foreground for inserted content.")), k$ = I("diffEditorOverview.removedForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Diff overview ruler foreground for removed content."));
I("diffEditor.insertedTextBorder", { dark: null, light: null, hcDark: "#33ff2eff", hcLight: "#374E06" }, m(0, "Outline color for the text that got inserted.")), I("diffEditor.removedTextBorder", { dark: null, light: null, hcDark: "#FF008F", hcLight: "#AD0707" }, m(0, "Outline color for text that got removed.")), I("diffEditor.border", { dark: null, light: null, hcDark: ot, hcLight: ot }, m(0, "Border color between the two text editors.")), I("diffEditor.diagonalFill", { dark: "#cccccc33", light: "#22222233", hcDark: null, hcLight: null }, m(0, "Color of the diff editor's diagonal fill. The diagonal fill is used in side-by-side diff views.")), I("diffEditor.unchangedRegionBackground", { dark: "sideBar.background", light: "sideBar.background", hcDark: "sideBar.background", hcLight: "sideBar.background" }, m(0, "The background color of unchanged blocks in the diff editor.")), I("diffEditor.unchangedRegionForeground", { dark: "foreground", light: "foreground", hcDark: "foreground", hcLight: "foreground" }, m(0, "The foreground color of unchanged blocks in the diff editor.")), I("diffEditor.unchangedCodeBackground", { dark: "#74747429", light: "#b8b8b829", hcDark: null, hcLight: null }, m(0, "The background color of unchanged code in the diff editor."));
const gd = I("widget.shadow", { dark: Ce(z.black, 0.36), light: Ce(z.black, 0.16), hcDark: null, hcLight: null }, m(0, "Shadow color of widgets such as find/replace inside the editor.")), cB = I("widget.border", { dark: null, light: null, hcDark: ot, hcLight: ot }, m(0, "Border color of widgets such as find/replace inside the editor.")), M4 = I("toolbar.hoverBackground", { dark: "#5a5d5e50", light: "#b8b8b850", hcDark: null, hcLight: null }, m(0, "Toolbar background when hovering over actions using the mouse"));
I("toolbar.hoverOutline", { dark: null, light: null, hcDark: Zt, hcLight: Zt }, m(0, "Toolbar outline when hovering over actions using the mouse")), I("toolbar.activeBackground", { dark: ra(M4, 0.1), light: Ng(M4, 0.1), hcDark: null, hcLight: null }, m(0, "Toolbar background when holding the mouse over actions"));
const D$ = I("breadcrumb.foreground", { light: Ce(oe, 0.8), dark: Ce(oe, 0.8), hcDark: Ce(oe, 0.8), hcLight: Ce(oe, 0.8) }, m(0, "Color of focused breadcrumb items.")), x$ = I("breadcrumb.background", { light: sn, dark: sn, hcDark: sn, hcLight: sn }, m(0, "Background color of breadcrumb items.")), T4 = I("breadcrumb.focusForeground", { light: Ng(oe, 0.2), dark: ra(oe, 0.1), hcDark: ra(oe, 0.1), hcLight: ra(oe, 0.1) }, m(0, "Color of focused breadcrumb items.")), N$ = I("breadcrumb.activeSelectionForeground", { light: Ng(oe, 0.2), dark: ra(oe, 0.1), hcDark: ra(oe, 0.1), hcLight: ra(oe, 0.1) }, m(0, "Color of selected breadcrumb items."));
I("breadcrumbPicker.background", { light: xi, dark: xi, hcDark: xi, hcLight: xi }, m(0, "Background color of breadcrumb item picker."));
const R4 = z.fromHex("#40C8AE").transparent(0.5), A4 = z.fromHex("#40A6FF").transparent(0.5), P4 = z.fromHex("#606060").transparent(0.4), br = 0.4, Np = I("merge.currentHeaderBackground", { dark: R4, light: R4, hcDark: null, hcLight: null }, m(0, "Current header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
I("merge.currentContentBackground", { dark: Ce(Np, br), light: Ce(Np, br), hcDark: Ce(Np, br), hcLight: Ce(Np, br) }, m(0, "Current content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const Ep = I("merge.incomingHeaderBackground", { dark: A4, light: A4, hcDark: null, hcLight: null }, m(0, "Incoming header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
I("merge.incomingContentBackground", { dark: Ce(Ep, br), light: Ce(Ep, br), hcDark: Ce(Ep, br), hcLight: Ce(Ep, br) }, m(0, "Incoming content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const Ip = I("merge.commonHeaderBackground", { dark: P4, light: P4, hcDark: null, hcLight: null }, m(0, "Common ancestor header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
I("merge.commonContentBackground", { dark: Ce(Ip, br), light: Ce(Ip, br), hcDark: Ce(Ip, br), hcLight: Ce(Ip, br) }, m(0, "Common ancestor content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const Kg = I("merge.border", { dark: null, light: null, hcDark: "#C3DF6F", hcLight: "#007ACC" }, m(0, "Border color on headers and the splitter in inline merge-conflicts."));
I("editorOverviewRuler.currentContentForeground", { dark: Ce(Np, 1), light: Ce(Np, 1), hcDark: Kg, hcLight: Kg }, m(0, "Current overview ruler foreground for inline merge-conflicts.")), I("editorOverviewRuler.incomingContentForeground", { dark: Ce(Ep, 1), light: Ce(Ep, 1), hcDark: Kg, hcLight: Kg }, m(0, "Incoming overview ruler foreground for inline merge-conflicts.")), I("editorOverviewRuler.commonContentForeground", { dark: Ce(Ip, 1), light: Ce(Ip, 1), hcDark: Kg, hcLight: Kg }, m(0, "Common ancestor overview ruler foreground for inline merge-conflicts."));
const cD = I("editorOverviewRuler.findMatchForeground", { dark: "#d186167e", light: "#d186167e", hcDark: "#AB5A00", hcLight: "" }, m(0, "Overview ruler marker color for find matches. The color must not be opaque so as not to hide underlying decorations."), !0), v_ = I("editorOverviewRuler.selectionHighlightForeground", { dark: "#A0A0A0CC", light: "#A0A0A0CC", hcDark: "#A0A0A0CC", hcLight: "#A0A0A0CC" }, m(0, "Overview ruler marker color for selection highlights. The color must not be opaque so as not to hide underlying decorations."), !0), E$ = I("problemsErrorIcon.foreground", { dark: sl, light: sl, hcDark: sl, hcLight: sl }, m(0, "The color used for the problems error icon.")), I$ = I("problemsWarningIcon.foreground", { dark: Qn, light: Qn, hcDark: Qn, hcLight: Qn }, m(0, "The color used for the problems warning icon.")), M$ = I("problemsInfoIcon.foreground", { dark: Rs, light: Rs, hcDark: Rs, hcLight: Rs }, m(0, "The color used for the problems info icon.")), Mp = I("minimap.findMatchHighlight", { light: "#d18616", dark: "#d18616", hcDark: "#AB5A00", hcLight: "#0F4A85" }, m(0, "Minimap marker color for find matches."), !0), sL = I("minimap.selectionOccurrenceHighlight", { light: "#c9c9c9", dark: "#676767", hcDark: "#ffffff", hcLight: "#0F4A85" }, m(0, "Minimap marker color for repeating editor selections."), !0), O4 = I("minimap.selectionHighlight", { light: "#ADD6FF", dark: "#264F78", hcDark: "#ffffff", hcLight: "#0F4A85" }, m(0, "Minimap marker color for the editor selection."), !0), T$ = I("minimap.infoHighlight", { dark: Rs, light: Rs, hcDark: uv, hcLight: uv }, m(0, "Minimap marker color for infos.")), R$ = I("minimap.warningHighlight", { dark: Qn, light: Qn, hcDark: cv, hcLight: cv }, m(0, "Minimap marker color for warnings.")), A$ = I("minimap.errorHighlight", { dark: new z(new ht(255, 18, 18, 0.7)), light: new z(new ht(255, 18, 18, 0.7)), hcDark: new z(new ht(255, 50, 50, 1)), hcLight: "#B5200D" }, m(0, "Minimap marker color for errors.")), P$ = I("minimap.background", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Minimap background color.")), O$ = I("minimap.foregroundOpacity", { dark: z.fromHex("#000f"), light: z.fromHex("#000f"), hcDark: z.fromHex("#000f"), hcLight: z.fromHex("#000f") }, m(0, 'Opacity of foreground elements rendered in the minimap. For example, "#000000c0" will render the elements with 75% opacity.'));
I("minimapSlider.background", { light: Ce(m_, 0.5), dark: Ce(m_, 0.5), hcDark: Ce(m_, 0.5), hcLight: Ce(m_, 0.5) }, m(0, "Minimap slider background color.")), I("minimapSlider.hoverBackground", { light: Ce(f_, 0.5), dark: Ce(f_, 0.5), hcDark: Ce(f_, 0.5), hcLight: Ce(f_, 0.5) }, m(0, "Minimap slider background color when hovering.")), I("minimapSlider.activeBackground", { light: Ce(__, 0.5), dark: Ce(__, 0.5), hcDark: Ce(__, 0.5), hcLight: Ce(__, 0.5) }, m(0, "Minimap slider background color when clicked on.")), I("charts.foreground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color used in charts.")), I("charts.lines", { dark: Ce(oe, 0.5), light: Ce(oe, 0.5), hcDark: Ce(oe, 0.5), hcLight: Ce(oe, 0.5) }, m(0, "The color used for horizontal lines in charts.")), I("charts.red", { dark: sl, light: sl, hcDark: sl, hcLight: sl }, m(0, "The red color used in chart visualizations.")), I("charts.blue", { dark: Rs, light: Rs, hcDark: Rs, hcLight: Rs }, m(0, "The blue color used in chart visualizations.")), I("charts.yellow", { dark: Qn, light: Qn, hcDark: Qn, hcLight: Qn }, m(0, "The yellow color used in chart visualizations.")), I("charts.orange", { dark: Mp, light: Mp, hcDark: Mp, hcLight: Mp }, m(0, "The orange color used in chart visualizations.")), I("charts.green", { dark: "#89D185", light: "#388A34", hcDark: "#89D185", hcLight: "#374e06" }, m(0, "The green color used in chart visualizations.")), I("charts.purple", { dark: "#B180D7", light: "#652D90", hcDark: "#B180D7", hcLight: "#652D90" }, m(0, "The purple color used in chart visualizations."));
const uB = I("input.background", { dark: "#3C3C3C", light: z.white, hcDark: z.black, hcLight: z.white }, m(0, "Input box background.")), gB = I("input.foreground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "Input box foreground.")), pB = I("input.border", { dark: null, light: null, hcDark: ot, hcLight: ot }, m(0, "Input box border.")), OR = I("inputOption.activeBorder", { dark: "#007ACC", light: "#007ACC", hcDark: ot, hcLight: ot }, m(0, "Border color of activated options in input fields."));
I("inputOption.hoverBackground", { dark: "#5a5d5e80", light: "#b8b8b850", hcDark: null, hcLight: null }, m(0, "Background color of activated options in input fields."));
const Eu = I("inputOption.activeBackground", { dark: Ce($o, 0.4), light: Ce($o, 0.2), hcDark: z.transparent, hcLight: z.transparent }, m(0, "Background hover color of options in input fields.")), FR = I("inputOption.activeForeground", { dark: z.white, light: z.black, hcDark: oe, hcLight: oe }, m(0, "Foreground color of activated options in input fields."));
I("input.placeholderForeground", { light: Ce(oe, 0.5), dark: Ce(oe, 0.5), hcDark: Ce(oe, 0.7), hcLight: Ce(oe, 0.7) }, m(0, "Input box foreground color for placeholder text."));
const F$ = I("inputValidation.infoBackground", { dark: "#063B49", light: "#D6ECF2", hcDark: z.black, hcLight: z.white }, m(0, "Input validation background color for information severity.")), B$ = I("inputValidation.infoForeground", { dark: null, light: null, hcDark: null, hcLight: oe }, m(0, "Input validation foreground color for information severity.")), W$ = I("inputValidation.infoBorder", { dark: "#007acc", light: "#007acc", hcDark: ot, hcLight: ot }, m(0, "Input validation border color for information severity.")), V$ = I("inputValidation.warningBackground", { dark: "#352A05", light: "#F6F5D2", hcDark: z.black, hcLight: z.white }, m(0, "Input validation background color for warning severity.")), H$ = I("inputValidation.warningForeground", { dark: null, light: null, hcDark: null, hcLight: oe }, m(0, "Input validation foreground color for warning severity.")), z$ = I("inputValidation.warningBorder", { dark: "#B89500", light: "#B89500", hcDark: ot, hcLight: ot }, m(0, "Input validation border color for warning severity.")), U$ = I("inputValidation.errorBackground", { dark: "#5A1D1D", light: "#F2DEDE", hcDark: z.black, hcLight: z.white }, m(0, "Input validation background color for error severity.")), K$ = I("inputValidation.errorForeground", { dark: null, light: null, hcDark: null, hcLight: oe }, m(0, "Input validation foreground color for error severity.")), j$ = I("inputValidation.errorBorder", { dark: "#BE1100", light: "#BE1100", hcDark: ot, hcLight: ot }, m(0, "Input validation border color for error severity.")), ol = I("dropdown.background", { dark: "#3C3C3C", light: z.white, hcDark: z.black, hcLight: z.white }, m(0, "Dropdown background.")), q$ = I("dropdown.listBackground", { dark: null, light: null, hcDark: z.black, hcLight: z.white }, m(0, "Dropdown list background.")), pd = I("dropdown.foreground", { dark: "#F0F0F0", light: oe, hcDark: z.white, hcLight: oe }, m(0, "Dropdown foreground.")), Tp = I("dropdown.border", { dark: ol, light: "#CECECE", hcDark: ot, hcLight: ot }, m(0, "Dropdown border.")), b_ = I("button.foreground", { dark: z.white, light: z.white, hcDark: z.white, hcLight: z.white }, m(0, "Button foreground color.")), $$ = I("button.separator", { dark: Ce(b_, 0.4), light: Ce(b_, 0.4), hcDark: Ce(b_, 0.4), hcLight: Ce(b_, 0.4) }, m(0, "Button separator color.")), C_ = I("button.background", { dark: "#0E639C", light: "#007ACC", hcDark: null, hcLight: "#0F4A85" }, m(0, "Button background color.")), G$ = I("button.hoverBackground", { dark: ra(C_, 0.2), light: Ng(C_, 0.2), hcDark: C_, hcLight: C_ }, m(0, "Button background color when hovering.")), Z$ = I("button.border", { dark: ot, light: ot, hcDark: ot, hcLight: ot }, m(0, "Button border color.")), Y$ = I("button.secondaryForeground", { dark: z.white, light: z.white, hcDark: z.white, hcLight: oe }, m(0, "Secondary button foreground color.")), XE = I("button.secondaryBackground", { dark: "#3A3D41", light: "#5F6A79", hcDark: null, hcLight: z.white }, m(0, "Secondary button background color.")), X$ = I("button.secondaryHoverBackground", { dark: ra(XE, 0.2), light: Ng(XE, 0.2), hcDark: null, hcLight: null }, m(0, "Secondary button background color when hovering.")), Q$ = I("checkbox.background", { dark: ol, light: ol, hcDark: ol, hcLight: ol }, m(0, "Background color of checkbox widget."));
I("checkbox.selectBackground", { dark: xi, light: xi, hcDark: xi, hcLight: xi }, m(0, "Background color of checkbox widget when the element it's in is selected."));
const J$ = I("checkbox.foreground", { dark: pd, light: pd, hcDark: pd, hcLight: pd }, m(0, "Foreground color of checkbox widget.")), eG = I("checkbox.border", { dark: Tp, light: Tp, hcDark: Tp, hcLight: Tp }, m(0, "Border color of checkbox widget."));
I("checkbox.selectBorder", { dark: nl, light: nl, hcDark: nl, hcLight: nl }, m(0, "Border color of checkbox widget when the element it's in is selected."));
const tG = I("keybindingLabel.background", { dark: new z(new ht(128, 128, 128, 0.17)), light: new z(new ht(221, 221, 221, 0.4)), hcDark: z.transparent, hcLight: z.transparent }, m(0, "Keybinding label background color. The keybinding label is used to represent a keyboard shortcut.")), iG = I("keybindingLabel.foreground", { dark: z.fromHex("#CCCCCC"), light: z.fromHex("#555555"), hcDark: z.white, hcLight: oe }, m(0, "Keybinding label foreground color. The keybinding label is used to represent a keyboard shortcut.")), nG = I("keybindingLabel.border", { dark: new z(new ht(51, 51, 51, 0.6)), light: new z(new ht(204, 204, 204, 0.4)), hcDark: new z(new ht(111, 195, 223)), hcLight: ot }, m(0, "Keybinding label border color. The keybinding label is used to represent a keyboard shortcut.")), sG = I("keybindingLabel.bottomBorder", { dark: new z(new ht(68, 68, 68, 0.6)), light: new z(new ht(187, 187, 187, 0.4)), hcDark: new z(new ht(111, 195, 223)), hcLight: oe }, m(0, "Keybinding label border bottom color. The keybinding label is used to represent a keyboard shortcut.")), oG = I("list.focusBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree background color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), rG = I("list.focusForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree foreground color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), aG = I("list.focusOutline", { dark: $o, light: $o, hcDark: Zt, hcLight: Zt }, m(0, "List/Tree outline color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), lG = I("list.focusAndSelectionOutline", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree outline color for the focused item when the list/tree is active and selected. An active list/tree has keyboard focus, an inactive does not.")), md = I("list.activeSelectionBackground", { dark: "#04395E", light: "#0060C0", hcDark: null, hcLight: z.fromHex("#0F4A85").transparent(0.1) }, m(0, "List/Tree background color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), rl = I("list.activeSelectionForeground", { dark: z.white, light: z.white, hcDark: null, hcLight: null }, m(0, "List/Tree foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), w_ = I("list.activeSelectionIconForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree icon foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), dG = I("list.inactiveSelectionBackground", { dark: "#37373D", light: "#E4E6F1", hcDark: null, hcLight: z.fromHex("#0F4A85").transparent(0.1) }, m(0, "List/Tree background color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), hG = I("list.inactiveSelectionForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), cG = I("list.inactiveSelectionIconForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree icon foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), uG = I("list.inactiveFocusBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree background color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), gG = I("list.inactiveFocusOutline", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree outline color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), mB = I("list.hoverBackground", { dark: "#2A2D2E", light: "#F0F0F0", hcDark: z.white.transparent(0.1), hcLight: z.fromHex("#0F4A85").transparent(0.1) }, m(0, "List/Tree background when hovering over items using the mouse.")), fB = I("list.hoverForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree foreground when hovering over items using the mouse.")), pG = I("list.dropBackground", { dark: "#062F4A", light: "#D6EBFF", hcDark: null, hcLight: null }, m(0, "List/Tree drag and drop background when moving items over other items when using the mouse.")), mG = I("list.dropBetweenBackground", { dark: nl, light: nl, hcDark: null, hcLight: null }, m(0, "List/Tree drag and drop border color when moving items between items when using the mouse.")), Cr = I("list.highlightForeground", { dark: "#2AAAFF", light: "#0066BF", hcDark: $o, hcLight: $o }, m(0, "List/Tree foreground color of the match highlights when searching inside the list/tree.")), lb = I("list.focusHighlightForeground", { dark: Cr, light: (F4 = md, B4 = Cr, W4 = "#BBE7FF", { op: 6, if: F4, then: B4, else: W4 }), hcDark: Cr, hcLight: Cr }, m(0, "List/Tree foreground color of the match highlights on actively focused items when searching inside the list/tree."));
var F4, B4, W4;
I("list.invalidItemForeground", { dark: "#B89500", light: "#B89500", hcDark: "#B89500", hcLight: "#B5200D" }, m(0, "List/Tree foreground color for invalid items, for example an unresolved root in explorer.")), I("list.errorForeground", { dark: "#F88070", light: "#B01011", hcDark: null, hcLight: null }, m(0, "Foreground color of list items containing errors.")), I("list.warningForeground", { dark: "#CCA700", light: "#855F00", hcDark: null, hcLight: null }, m(0, "Foreground color of list items containing warnings."));
const fG = I("listFilterWidget.background", { light: Ng(xi, 0), dark: ra(xi, 0), hcDark: xi, hcLight: xi }, m(0, "Background color of the type filter widget in lists and trees.")), _G = I("listFilterWidget.outline", { dark: z.transparent, light: z.transparent, hcDark: "#f38518", hcLight: "#007ACC" }, m(0, "Outline color of the type filter widget in lists and trees.")), vG = I("listFilterWidget.noMatchesOutline", { dark: "#BE1100", light: "#BE1100", hcDark: ot, hcLight: ot }, m(0, "Outline color of the type filter widget in lists and trees, when there are no matches.")), bG = I("listFilterWidget.shadow", { dark: gd, light: gd, hcDark: gd, hcLight: gd }, m(0, "Shadow color of the type filter widget in lists and trees."));
I("list.filterMatchBackground", { dark: hd, light: hd, hcDark: null, hcLight: null }, m(0, "Background color of the filtered match.")), I("list.filterMatchBorder", { dark: Th, light: Th, hcDark: ot, hcLight: Zt }, m(0, "Border color of the filtered match.")), I("list.deemphasizedForeground", { dark: "#8C8C8C", light: "#8E8E90", hcDark: "#A7A8A9", hcLight: "#666666" }, m(0, "List/Tree foreground color for items that are deemphasized."));
const y_ = I("tree.indentGuidesStroke", { dark: "#585858", light: "#a9a9a9", hcDark: "#a9a9a9", hcLight: "#a5a5a5" }, m(0, "Tree stroke color for the indentation guides.")), CG = I("tree.inactiveIndentGuidesStroke", { dark: Ce(y_, 0.4), light: Ce(y_, 0.4), hcDark: Ce(y_, 0.4), hcLight: Ce(y_, 0.4) }, m(0, "Tree stroke color for the indentation guides that are not active.")), wG = I("tree.tableColumnsBorder", { dark: "#CCCCCC20", light: "#61616120", hcDark: null, hcLight: null }, m(0, "Table border color between columns.")), yG = I("tree.tableOddRowsBackground", { dark: Ce(oe, 0.04), light: Ce(oe, 0.04), hcDark: null, hcLight: null }, m(0, "Background color for odd table rows.")), SG = I("menu.border", { dark: null, light: null, hcDark: ot, hcLight: ot }, m(0, "Border color of menus.")), LG = I("menu.foreground", { dark: pd, light: pd, hcDark: pd, hcLight: pd }, m(0, "Foreground color of menu items.")), kG = I("menu.background", { dark: ol, light: ol, hcDark: ol, hcLight: ol }, m(0, "Background color of menu items.")), DG = I("menu.selectionForeground", { dark: rl, light: rl, hcDark: rl, hcLight: rl }, m(0, "Foreground color of the selected menu item in menus.")), xG = I("menu.selectionBackground", { dark: md, light: md, hcDark: md, hcLight: md }, m(0, "Background color of the selected menu item in menus.")), NG = I("menu.selectionBorder", { dark: null, light: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color of the selected menu item in menus.")), EG = I("menu.separatorBackground", { dark: "#606060", light: "#D4D4D4", hcDark: ot, hcLight: ot }, m(0, "Color of a separator menu item in menus.")), V4 = I("quickInput.background", { dark: xi, light: xi, hcDark: xi, hcLight: xi }, m(0, "Quick picker background color. The quick picker widget is the container for pickers like the command palette.")), IG = I("quickInput.foreground", { dark: ld, light: ld, hcDark: ld, hcLight: ld }, m(0, "Quick picker foreground color. The quick picker widget is the container for pickers like the command palette.")), MG = I("quickInputTitle.background", { dark: new z(new ht(255, 255, 255, 0.105)), light: new z(new ht(0, 0, 0, 0.06)), hcDark: "#000000", hcLight: z.white }, m(0, "Quick picker title background color. The quick picker widget is the container for pickers like the command palette.")), _B = I("pickerGroup.foreground", { dark: "#3794FF", light: "#0066BF", hcDark: z.white, hcLight: "#0F4A85" }, m(0, "Quick picker color for grouping labels.")), TG = I("pickerGroup.border", { dark: "#3F3F46", light: "#CCCEDB", hcDark: z.white, hcLight: "#0F4A85" }, m(0, "Quick picker color for grouping borders.")), H4 = I("quickInput.list.focusBackground", { dark: null, light: null, hcDark: null, hcLight: null }, "", void 0, m(0, "Please use quickInputList.focusBackground instead")), Rh = I("quickInputList.focusForeground", { dark: rl, light: rl, hcDark: rl, hcLight: rl }, m(0, "Quick picker foreground color for the focused item.")), Rp = I("quickInputList.focusIconForeground", { dark: w_, light: w_, hcDark: w_, hcLight: w_ }, m(0, "Quick picker icon foreground color for the focused item.")), Ah = I("quickInputList.focusBackground", { dark: hv(H4, md), light: hv(H4, md), hcDark: null, hcLight: null }, m(0, "Quick picker background color for the focused item."));
I("search.resultsInfoForeground", { light: oe, dark: Ce(oe, 0.65), hcDark: oe, hcLight: oe }, m(0, "Color of the text in the search viewlet's completion message.")), I("searchEditor.findMatchBackground", { light: Ce(hd, 0.66), dark: Ce(hd, 0.66), hcDark: hd, hcLight: hd }, m(0, "Color of the Search Editor query matches.")), I("searchEditor.findMatchBorder", { light: Ce(Th, 0.66), dark: Ce(Th, 0.66), hcDark: Th, hcLight: Th }, m(0, "Border color of the Search Editor query matches."));
class oL {
  constructor(e, t) {
    this.x = e, this.y = t, this._pageCoordinatesBrand = void 0;
  }
  toClientCoordinates(e) {
    return new vB(this.x - e.scrollX, this.y - e.scrollY);
  }
}
class vB {
  constructor(e, t) {
    this.clientX = e, this.clientY = t, this._clientCoordinatesBrand = void 0;
  }
  toPageCoordinates(e) {
    return new oL(this.clientX + e.scrollX, this.clientY + e.scrollY);
  }
}
class RG {
  constructor(e, t, i, s) {
    this.x = e, this.y = t, this.width = i, this.height = s, this._editorPagePositionBrand = void 0;
  }
}
class AG {
  constructor(e, t) {
    this.x = e, this.y = t, this._positionRelativeToEditorBrand = void 0;
  }
}
function BR(n) {
  const e = Ti(n);
  return new RG(e.left, e.top, e.width, e.height);
}
function WR(n, e, t) {
  const i = e.width / n.offsetWidth, s = e.height / n.offsetHeight, o = (t.x - e.x) / i, r = (t.y - e.y) / s;
  return new AG(o, r);
}
class Lc extends _r {
  constructor(e, t, i) {
    super(ke(i), e), this._editorMouseEventBrand = void 0, this.isFromPointerCapture = t, this.pos = new oL(this.posx, this.posy), this.editorPos = BR(i), this.relativePos = WR(i, this.editorPos, this.pos);
  }
}
class PG {
  constructor(e) {
    this._editorViewDomNode = e;
  }
  _create(e) {
    return new Lc(e, !1, this._editorViewDomNode);
  }
  onContextMenu(e, t) {
    return K(e, "contextmenu", ((i) => {
      t(this._create(i));
    }));
  }
  onMouseUp(e, t) {
    return K(e, "mouseup", ((i) => {
      t(this._create(i));
    }));
  }
  onMouseDown(e, t) {
    return K(e, ie.MOUSE_DOWN, ((i) => {
      t(this._create(i));
    }));
  }
  onPointerDown(e, t) {
    return K(e, ie.POINTER_DOWN, ((i) => {
      t(this._create(i), i.pointerId);
    }));
  }
  onMouseLeave(e, t) {
    return K(e, ie.MOUSE_LEAVE, ((i) => {
      t(this._create(i));
    }));
  }
  onMouseMove(e, t) {
    return K(e, "mousemove", ((i) => t(this._create(i))));
  }
}
class OG {
  constructor(e) {
    this._editorViewDomNode = e;
  }
  _create(e) {
    return new Lc(e, !1, this._editorViewDomNode);
  }
  onPointerUp(e, t) {
    return K(e, "pointerup", ((i) => {
      t(this._create(i));
    }));
  }
  onPointerDown(e, t) {
    return K(e, ie.POINTER_DOWN, ((i) => {
      t(this._create(i), i.pointerId);
    }));
  }
  onPointerLeave(e, t) {
    return K(e, ie.POINTER_LEAVE, ((i) => {
      t(this._create(i));
    }));
  }
  onPointerMove(e, t) {
    return K(e, "pointermove", ((i) => t(this._create(i))));
  }
}
class FG extends V {
  constructor(e) {
    super(), this._editorViewDomNode = e, this._globalPointerMoveMonitor = this._register(new ff()), this._keydownListener = null;
  }
  startMonitoring(e, t, i, s, o) {
    this._keydownListener = bi(e.ownerDocument, "keydown", ((r) => {
      r.toKeyCodeChord().isModifierKey() || this._globalPointerMoveMonitor.stopMonitoring(!0, r.browserEvent);
    }), !0), this._globalPointerMoveMonitor.startMonitoring(e, t, i, ((r) => {
      s(new Lc(r, !0, this._editorViewDomNode));
    }), ((r) => {
      this._keydownListener.dispose(), o(r);
    }));
  }
  stopMonitoring() {
    this._globalPointerMoveMonitor.stopMonitoring(!0);
  }
}
class w1 {
  constructor(e) {
    this._editor = e, this._instanceId = ++w1._idPool, this._counter = 0, this._rules = /* @__PURE__ */ new Map(), this._garbageCollectionScheduler = new Et((() => this.garbageCollect()), 1e3);
  }
  createClassNameRef(e) {
    const t = this.getOrCreateRule(e);
    return t.increaseRefCount(), { className: t.className, dispose: () => {
      t.decreaseRefCount(), this._garbageCollectionScheduler.schedule();
    } };
  }
  getOrCreateRule(e) {
    const t = this.computeUniqueKey(e);
    let i = this._rules.get(t);
    if (!i) {
      const s = this._counter++;
      i = new BG(t, `dyn-rule-${this._instanceId}-${s}`, Kw(this._editor.getContainerDomNode()) ? this._editor.getContainerDomNode() : void 0, e), this._rules.set(t, i);
    }
    return i;
  }
  computeUniqueKey(e) {
    return JSON.stringify(e);
  }
  garbageCollect() {
    for (const e of this._rules.values()) e.hasReferences() || (this._rules.delete(e.key), e.dispose());
  }
}
w1._idPool = 0;
class BG {
  constructor(e, t, i, s) {
    this.key = e, this.className = t, this.properties = s, this._referenceCount = 0, this._styleElementDisposables = new G(), this._styleElement = Lo(i, void 0, this._styleElementDisposables), this._styleElement.textContent = this.getCssText(this.className, this.properties);
  }
  getCssText(e, t) {
    let i = `.${e} {`;
    for (const s in t) {
      const o = t[s];
      let r;
      r = typeof o == "object" ? de(o.id) : o, i += `
	${WG(s)}: ${r};`;
    }
    return i += `
}`, i;
  }
  dispose() {
    this._styleElementDisposables.dispose(), this._styleElement = void 0;
  }
  increaseRefCount() {
    this._referenceCount++;
  }
  decreaseRefCount() {
    this._referenceCount--;
  }
  hasReferences() {
    return this._referenceCount > 0;
  }
}
function WG(n) {
  return n.replace(/(^[A-Z])/, (([e]) => e.toLowerCase())).replace(/([A-Z])/g, (([e]) => `-${e.toLowerCase()}`));
}
class y1 extends V {
  constructor() {
    super(), this._shouldRender = !0;
  }
  shouldRender() {
    return this._shouldRender;
  }
  forceShouldRender() {
    this._shouldRender = !0;
  }
  setShouldRender() {
    this._shouldRender = !0;
  }
  onDidRender() {
    this._shouldRender = !1;
  }
  onCompositionStart(e) {
    return !1;
  }
  onCompositionEnd(e) {
    return !1;
  }
  onConfigurationChanged(e) {
    return !1;
  }
  onCursorStateChanged(e) {
    return !1;
  }
  onDecorationsChanged(e) {
    return !1;
  }
  onFlushed(e) {
    return !1;
  }
  onFocusChanged(e) {
    return !1;
  }
  onLanguageConfigurationChanged(e) {
    return !1;
  }
  onLineMappingChanged(e) {
    return !1;
  }
  onLinesChanged(e) {
    return !1;
  }
  onLinesDeleted(e) {
    return !1;
  }
  onLinesInserted(e) {
    return !1;
  }
  onRevealRangeRequest(e) {
    return !1;
  }
  onScrollChanged(e) {
    return !1;
  }
  onThemeChanged(e) {
    return !1;
  }
  onTokensChanged(e) {
    return !1;
  }
  onTokensColorsChanged(e) {
    return !1;
  }
  onZonesChanged(e) {
    return !1;
  }
  handleEvents(e) {
    let t = !1;
    for (let i = 0, s = e.length; i < s; i++) {
      const o = e[i];
      switch (o.type) {
        case 0:
          this.onCompositionStart(o) && (t = !0);
          break;
        case 1:
          this.onCompositionEnd(o) && (t = !0);
          break;
        case 2:
          this.onConfigurationChanged(o) && (t = !0);
          break;
        case 3:
          this.onCursorStateChanged(o) && (t = !0);
          break;
        case 4:
          this.onDecorationsChanged(o) && (t = !0);
          break;
        case 5:
          this.onFlushed(o) && (t = !0);
          break;
        case 6:
          this.onFocusChanged(o) && (t = !0);
          break;
        case 7:
          this.onLanguageConfigurationChanged(o) && (t = !0);
          break;
        case 8:
          this.onLineMappingChanged(o) && (t = !0);
          break;
        case 9:
          this.onLinesChanged(o) && (t = !0);
          break;
        case 10:
          this.onLinesDeleted(o) && (t = !0);
          break;
        case 11:
          this.onLinesInserted(o) && (t = !0);
          break;
        case 12:
          this.onRevealRangeRequest(o) && (t = !0);
          break;
        case 13:
          this.onScrollChanged(o) && (t = !0);
          break;
        case 15:
          this.onTokensChanged(o) && (t = !0);
          break;
        case 14:
          this.onThemeChanged(o) && (t = !0);
          break;
        case 16:
          this.onTokensColorsChanged(o) && (t = !0);
          break;
        case 17:
          this.onZonesChanged(o) && (t = !0);
          break;
        default:
          console.info("View received unknown event: "), console.info(o);
      }
    }
    t && (this._shouldRender = !0);
  }
}
class to extends y1 {
  constructor(e) {
    super(), this._context = e, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
}
class fa {
  static write(e, t) {
    e.setAttribute("data-mprt", String(t));
  }
  static read(e) {
    const t = e.getAttribute("data-mprt");
    return t === null ? 0 : parseInt(t, 10);
  }
  static collect(e, t) {
    const i = [];
    let s = 0;
    for (; e && e !== e.ownerDocument.body && e !== t; ) e.nodeType === e.ELEMENT_NODE && (i[s++] = this.read(e)), e = e.parentElement;
    const o = new Uint8Array(s);
    for (let r = 0; r < s; r++) o[r] = i[s - r - 1];
    return o;
  }
}
class VG {
  constructor(e, t) {
    this._restrictedRenderingContextBrand = void 0, this._viewLayout = e, this.viewportData = t, this.scrollWidth = this._viewLayout.getScrollWidth(), this.scrollHeight = this._viewLayout.getScrollHeight(), this.visibleRange = this.viewportData.visibleRange, this.bigNumbersDelta = this.viewportData.bigNumbersDelta;
    const i = this._viewLayout.getCurrentViewport();
    this.scrollTop = i.top, this.scrollLeft = i.left, this.viewportWidth = i.width, this.viewportHeight = i.height;
  }
  getScrolledTopFromAbsoluteTop(e) {
    return e - this.scrollTop;
  }
  getVerticalOffsetForLineNumber(e, t) {
    return this._viewLayout.getVerticalOffsetForLineNumber(e, t);
  }
  getVerticalOffsetAfterLineNumber(e, t) {
    return this._viewLayout.getVerticalOffsetAfterLineNumber(e, t);
  }
  getDecorationsInViewport() {
    return this.viewportData.getDecorationsInViewport();
  }
}
class HG extends VG {
  constructor(e, t, i) {
    super(e, t), this._renderingContextBrand = void 0, this._viewLines = i;
  }
  linesVisibleRangesForRange(e, t) {
    return this._viewLines.linesVisibleRangesForRange(e, t);
  }
  visibleRangeForPosition(e) {
    return this._viewLines.visibleRangeForPosition(e);
  }
}
class zG {
  constructor(e, t, i, s) {
    this.outsideRenderedLine = e, this.lineNumber = t, this.ranges = i, this.continuesOnNextLine = s;
  }
}
class rL {
  static from(e) {
    const t = new Array(e.length);
    for (let i = 0, s = e.length; i < s; i++) {
      const o = e[i];
      t[i] = new rL(o.left, o.width);
    }
    return t;
  }
  constructor(e, t) {
    this._horizontalRangeBrand = void 0, this.left = Math.round(e), this.width = Math.round(t);
  }
  toString() {
    return `[${this.left},${this.width}]`;
  }
}
class Uu {
  constructor(e, t) {
    this._floatHorizontalRangeBrand = void 0, this.left = e, this.width = t;
  }
  toString() {
    return `[${this.left},${this.width}]`;
  }
  static compare(e, t) {
    return e.left - t.left;
  }
}
class UG {
  constructor(e, t) {
    this.outsideRenderedLine = e, this.originalLeft = t, this.left = Math.round(this.originalLeft);
  }
}
class z4 {
  constructor(e, t) {
    this.outsideRenderedLine = e, this.ranges = t;
  }
}
class OC {
  static _createRange() {
    return this._handyReadyRange || (this._handyReadyRange = document.createRange()), this._handyReadyRange;
  }
  static _detachRange(e, t) {
    e.selectNodeContents(t);
  }
  static _readClientRects(e, t, i, s, o) {
    const r = this._createRange();
    try {
      return r.setStart(e, t), r.setEnd(i, s), r.getClientRects();
    } catch {
      return null;
    } finally {
      this._detachRange(r, o);
    }
  }
  static _mergeAdjacentRanges(e) {
    if (e.length === 1) return e;
    e.sort(Uu.compare);
    const t = [];
    let i = 0, s = e[0];
    for (let o = 1, r = e.length; o < r; o++) {
      const a = e[o];
      s.left + s.width + 0.9 >= a.left ? s.width = Math.max(s.width, a.left + a.width - s.left) : (t[i++] = s, s = a);
    }
    return t[i++] = s, t;
  }
  static _createHorizontalRangesFromClientRects(e, t, i) {
    if (!e || e.length === 0) return null;
    const s = [];
    for (let o = 0, r = e.length; o < r; o++) {
      const a = e[o];
      s[o] = new Uu(Math.max(0, (a.left - t) / i), a.width / i);
    }
    return this._mergeAdjacentRanges(s);
  }
  static readHorizontalRanges(e, t, i, s, o, r) {
    const a = e.children.length - 1;
    if (0 > a) return null;
    if ((t = Math.min(a, Math.max(0, t))) === (s = Math.min(a, Math.max(0, s))) && i === o && i === 0 && !e.children[t].firstChild) {
      const c = e.children[t].getClientRects();
      return r.markDidDomLayout(), this._createHorizontalRangesFromClientRects(c, r.clientRectDeltaLeft, r.clientRectScale);
    }
    t !== s && s > 0 && o === 0 && (s--, o = 1073741824);
    let l = e.children[t].firstChild, d = e.children[s].firstChild;
    if (l && d || (!l && i === 0 && t > 0 && (l = e.children[t - 1].firstChild, i = 1073741824), !d && o === 0 && s > 0 && (d = e.children[s - 1].firstChild, o = 1073741824)), !l || !d) return null;
    i = Math.min(l.textContent.length, Math.max(0, i)), o = Math.min(d.textContent.length, Math.max(0, o));
    const h = this._readClientRects(l, i, d, o, r.endNode);
    return r.markDidDomLayout(), this._createHorizontalRangesFromClientRects(h, r.clientRectDeltaLeft, r.clientRectScale);
  }
}
var Zo;
function aa(n) {
  return n === Zo.HIGH_CONTRAST_DARK || n === Zo.HIGH_CONTRAST_LIGHT;
}
function zm(n) {
  return n === Zo.DARK || n === Zo.HIGH_CONTRAST_DARK;
}
(function(n) {
  n.DARK = "dark", n.LIGHT = "light", n.HIGH_CONTRAST_DARK = "hcDark", n.HIGH_CONTRAST_LIGHT = "hcLight";
})(Zo || (Zo = {}));
const KG = !!ml || !(Cs || tr || _c);
let J_ = !0;
class U4 {
  constructor(e, t) {
    this.themeType = t;
    const i = e.options, s = i.get(50), o = i.get(38);
    this.renderWhitespace = o === "off" ? i.get(99) : "none", this.renderControlCharacters = i.get(94), this.spaceWidth = s.spaceWidth, this.middotWidth = s.middotWidth, this.wsmiddotWidth = s.wsmiddotWidth, this.useMonospaceOptimizations = s.isMonospace && !i.get(33), this.canUseHalfwidthRightwardsArrow = s.canUseHalfwidthRightwardsArrow, this.lineHeight = i.get(67), this.stopRenderingLineAfter = i.get(117), this.fontLigatures = i.get(51);
  }
  equals(e) {
    return this.themeType === e.themeType && this.renderWhitespace === e.renderWhitespace && this.renderControlCharacters === e.renderControlCharacters && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.useMonospaceOptimizations === e.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineHeight === e.lineHeight && this.stopRenderingLineAfter === e.stopRenderingLineAfter && this.fontLigatures === e.fontLigatures;
  }
}
class $a {
  constructor(e) {
    this._options = e, this._isMaybeInvalid = !0, this._renderedViewLine = null;
  }
  getDomNode() {
    return this._renderedViewLine && this._renderedViewLine.domNode ? this._renderedViewLine.domNode.domNode : null;
  }
  setDomNode(e) {
    if (!this._renderedViewLine) throw new Error("I have no rendered view line to set the dom node to...");
    this._renderedViewLine.domNode = wt(e);
  }
  onContentChanged() {
    this._isMaybeInvalid = !0;
  }
  onTokensChanged() {
    this._isMaybeInvalid = !0;
  }
  onDecorationsChanged() {
    this._isMaybeInvalid = !0;
  }
  onOptionsChanged(e) {
    this._isMaybeInvalid = !0, this._options = e;
  }
  onSelectionChanged() {
    return !(!aa(this._options.themeType) && this._options.renderWhitespace !== "selection") && (this._isMaybeInvalid = !0, !0);
  }
  renderLine(e, t, i, s, o) {
    if (this._isMaybeInvalid === !1) return !1;
    this._isMaybeInvalid = !1;
    const r = s.getViewLineRenderingData(e), a = this._options, l = _s.filter(r.inlineDecorations, e, r.minColumn, r.maxColumn);
    let d = null;
    if (aa(a.themeType) || this._options.renderWhitespace === "selection") {
      const g = s.selections;
      for (const p of g) {
        if (p.endLineNumber < e || p.startLineNumber > e) continue;
        const f = p.startLineNumber === e ? p.startColumn : r.minColumn, _ = p.endLineNumber === e ? p.endColumn : r.maxColumn;
        f < _ && (aa(a.themeType) && l.push(new _s(f, _, "inline-selected-text", 0)), this._options.renderWhitespace === "selection" && (d || (d = []), d.push(new tB(f - 1, _ - 1))));
      }
    }
    const h = new Sc(a.useMonospaceOptimizations, a.canUseHalfwidthRightwardsArrow, r.content, r.continuesWithWrappedLine, r.isBasicASCII, r.containsRTL, r.minColumn - 1, r.tokens, l, r.tabSize, r.startVisibleColumn, a.spaceWidth, a.middotWidth, a.wsmiddotWidth, a.stopRenderingLineAfter, a.renderWhitespace, a.renderControlCharacters, a.fontLigatures !== fo.OFF, d);
    if (this._renderedViewLine && this._renderedViewLine.input.equals(h)) return !1;
    o.appendString('<div style="top:'), o.appendString(String(t)), o.appendString("px;height:"), o.appendString(String(i)), o.appendString('px;" class="'), o.appendString($a.CLASS_NAME), o.appendString('">');
    const c = C1(h, o);
    o.appendString("</div>");
    let u = null;
    return J_ && KG && r.isBasicASCII && a.useMonospaceOptimizations && c.containsForeignElements === 0 && (u = new db(this._renderedViewLine ? this._renderedViewLine.domNode : null, h, c.characterMapping)), u || (u = CB(this._renderedViewLine ? this._renderedViewLine.domNode : null, h, c.characterMapping, c.containsRTL, c.containsForeignElements)), this._renderedViewLine = u, !0;
  }
  layoutLine(e, t, i) {
    this._renderedViewLine && this._renderedViewLine.domNode && (this._renderedViewLine.domNode.setTop(t), this._renderedViewLine.domNode.setHeight(i));
  }
  getWidth(e) {
    return this._renderedViewLine ? this._renderedViewLine.getWidth(e) : 0;
  }
  getWidthIsFast() {
    return !this._renderedViewLine || this._renderedViewLine.getWidthIsFast();
  }
  needsMonospaceFontCheck() {
    return !!this._renderedViewLine && this._renderedViewLine instanceof db;
  }
  monospaceAssumptionsAreValid() {
    return this._renderedViewLine && this._renderedViewLine instanceof db ? this._renderedViewLine.monospaceAssumptionsAreValid() : J_;
  }
  onMonospaceAssumptionsInvalidated() {
    this._renderedViewLine && this._renderedViewLine instanceof db && (this._renderedViewLine = this._renderedViewLine.toSlowRenderedLine());
  }
  getVisibleRangesForRange(e, t, i, s) {
    if (!this._renderedViewLine) return null;
    t = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, t)), i = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, i));
    const o = this._renderedViewLine.input.stopRenderingLineAfter;
    if (o !== -1 && t > o + 1 && i > o + 1) return new z4(!0, [new Uu(this.getWidth(s), 0)]);
    o !== -1 && t > o + 1 && (t = o + 1), o !== -1 && i > o + 1 && (i = o + 1);
    const r = this._renderedViewLine.getVisibleRangesForRange(e, t, i, s);
    return r && r.length > 0 ? new z4(!1, r) : null;
  }
  getColumnOfNodeOffset(e, t) {
    return this._renderedViewLine ? this._renderedViewLine.getColumnOfNodeOffset(e, t) : 1;
  }
}
$a.CLASS_NAME = "view-line";
class db {
  constructor(e, t, i) {
    this._cachedWidth = -1, this.domNode = e, this.input = t;
    const s = Math.floor(t.lineContent.length / 300);
    if (s > 0) {
      this._keyColumnPixelOffsetCache = new Float32Array(s);
      for (let o = 0; o < s; o++) this._keyColumnPixelOffsetCache[o] = -1;
    } else this._keyColumnPixelOffsetCache = null;
    this._characterMapping = i, this._charWidth = t.spaceWidth;
  }
  getWidth(e) {
    if (!this.domNode || this.input.lineContent.length < 300) {
      const t = this._characterMapping.getHorizontalOffset(this._characterMapping.length);
      return Math.round(this._charWidth * t);
    }
    return this._cachedWidth === -1 && (this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth, e?.markDidDomLayout()), this._cachedWidth;
  }
  getWidthIsFast() {
    return this.input.lineContent.length < 300 || this._cachedWidth !== -1;
  }
  monospaceAssumptionsAreValid() {
    if (!this.domNode) return J_;
    if (this.input.lineContent.length < 300) {
      const e = this.getWidth(null), t = this.domNode.domNode.firstChild.offsetWidth;
      Math.abs(e - t) >= 2 && (console.warn("monospace assumptions have been violated, therefore disabling monospace optimizations!"), J_ = !1);
    }
    return J_;
  }
  toSlowRenderedLine() {
    return CB(this.domNode, this.input, this._characterMapping, !1, 0);
  }
  getVisibleRangesForRange(e, t, i, s) {
    const o = this._getColumnPixelOffset(e, t, s), r = this._getColumnPixelOffset(e, i, s);
    return [new Uu(o, r - o)];
  }
  _getColumnPixelOffset(e, t, i) {
    if (t <= 300) {
      const d = this._characterMapping.getHorizontalOffset(t);
      return this._charWidth * d;
    }
    const s = Math.floor((t - 1) / 300) - 1, o = 300 * (s + 1) + 1;
    let r = -1;
    if (this._keyColumnPixelOffsetCache && (r = this._keyColumnPixelOffsetCache[s], r === -1 && (r = this._actualReadPixelOffset(e, o, i), this._keyColumnPixelOffsetCache[s] = r)), r === -1) {
      const d = this._characterMapping.getHorizontalOffset(t);
      return this._charWidth * d;
    }
    const a = this._characterMapping.getHorizontalOffset(o), l = this._characterMapping.getHorizontalOffset(t);
    return r + this._charWidth * (l - a);
  }
  _getReadingTarget(e) {
    return e.domNode.firstChild;
  }
  _actualReadPixelOffset(e, t, i) {
    if (!this.domNode) return -1;
    const s = this._characterMapping.getDomPosition(t), o = OC.readHorizontalRanges(this._getReadingTarget(this.domNode), s.partIndex, s.charIndex, s.partIndex, s.charIndex, i);
    return o && o.length !== 0 ? o[0].left : -1;
  }
  getColumnOfNodeOffset(e, t) {
    return VR(this._characterMapping, e, t);
  }
}
class bB {
  constructor(e, t, i, s, o) {
    if (this.domNode = e, this.input = t, this._characterMapping = i, this._isWhitespaceOnly = /^\s*$/.test(t.lineContent), this._containsForeignElements = o, this._cachedWidth = -1, this._pixelOffsetCache = null, !s || this._characterMapping.length === 0) {
      this._pixelOffsetCache = new Float32Array(Math.max(2, this._characterMapping.length + 1));
      for (let r = 0, a = this._characterMapping.length; r <= a; r++) this._pixelOffsetCache[r] = -1;
    }
  }
  _getReadingTarget(e) {
    return e.domNode.firstChild;
  }
  getWidth(e) {
    return this.domNode ? (this._cachedWidth === -1 && (this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth, e?.markDidDomLayout()), this._cachedWidth) : 0;
  }
  getWidthIsFast() {
    return this._cachedWidth !== -1;
  }
  getVisibleRangesForRange(e, t, i, s) {
    if (!this.domNode) return null;
    if (this._pixelOffsetCache !== null) {
      const o = this._readPixelOffset(this.domNode, e, t, s);
      if (o === -1) return null;
      const r = this._readPixelOffset(this.domNode, e, i, s);
      return r === -1 ? null : [new Uu(o, r - o)];
    }
    return this._readVisibleRangesForRange(this.domNode, e, t, i, s);
  }
  _readVisibleRangesForRange(e, t, i, s, o) {
    if (i === s) {
      const r = this._readPixelOffset(e, t, i, o);
      return r === -1 ? null : [new Uu(r, 0)];
    }
    return this._readRawVisibleRangesForRange(e, i, s, o);
  }
  _readPixelOffset(e, t, i, s) {
    if (this._characterMapping.length === 0) {
      if (this._containsForeignElements === 0 || this._containsForeignElements === 2) return 0;
      if (this._containsForeignElements === 1) return this.getWidth(s);
      const o = this._getReadingTarget(e);
      return o.firstChild ? (s.markDidDomLayout(), o.firstChild.offsetWidth) : 0;
    }
    if (this._pixelOffsetCache !== null) {
      const o = this._pixelOffsetCache[i];
      if (o !== -1) return o;
      const r = this._actualReadPixelOffset(e, t, i, s);
      return this._pixelOffsetCache[i] = r, r;
    }
    return this._actualReadPixelOffset(e, t, i, s);
  }
  _actualReadPixelOffset(e, t, i, s) {
    if (this._characterMapping.length === 0) {
      const l = OC.readHorizontalRanges(this._getReadingTarget(e), 0, 0, 0, 0, s);
      return l && l.length !== 0 ? l[0].left : -1;
    }
    if (i === this._characterMapping.length && this._isWhitespaceOnly && this._containsForeignElements === 0) return this.getWidth(s);
    const o = this._characterMapping.getDomPosition(i), r = OC.readHorizontalRanges(this._getReadingTarget(e), o.partIndex, o.charIndex, o.partIndex, o.charIndex, s);
    if (!r || r.length === 0) return -1;
    const a = r[0].left;
    if (this.input.isBasicASCII) {
      const l = this._characterMapping.getHorizontalOffset(i), d = Math.round(this.input.spaceWidth * l);
      if (Math.abs(d - a) <= 1) return d;
    }
    return a;
  }
  _readRawVisibleRangesForRange(e, t, i, s) {
    if (t === 1 && i === this._characterMapping.length) return [new Uu(0, this.getWidth(s))];
    const o = this._characterMapping.getDomPosition(t), r = this._characterMapping.getDomPosition(i);
    return OC.readHorizontalRanges(this._getReadingTarget(e), o.partIndex, o.charIndex, r.partIndex, r.charIndex, s);
  }
  getColumnOfNodeOffset(e, t) {
    return VR(this._characterMapping, e, t);
  }
}
class jG extends bB {
  _readVisibleRangesForRange(e, t, i, s, o) {
    const r = super._readVisibleRangesForRange(e, t, i, s, o);
    if (!r || r.length === 0 || i === s || i === 1 && s === this._characterMapping.length) return r;
    if (!this.input.containsRTL) {
      const a = this._readPixelOffset(e, t, s, o);
      if (a !== -1) {
        const l = r[r.length - 1];
        l.left < a && (l.width = a - l.left);
      }
    }
    return r;
  }
}
const CB = OS ? qG : $G;
function qG(n, e, t, i, s) {
  return new jG(n, e, t, i, s);
}
function $G(n, e, t, i, s) {
  return new bB(n, e, t, i, s);
}
function VR(n, e, t) {
  const i = e.textContent.length;
  let s = -1;
  for (; e; ) e = e.previousSibling, s++;
  return n.getColumn(new iB(s, t), i);
}
class Gi {
  static _nextVisibleColumn(e, t, i) {
    return e === 9 ? Gi.nextRenderTabStop(t, i) : fc(e) || aR(e) ? t + 2 : t + 1;
  }
  static visibleColumnFromColumn(e, t, i) {
    const s = Math.min(t - 1, e.length), o = e.substring(0, s), r = new Ww(o);
    let a = 0;
    for (; !r.eol(); ) {
      const l = Bw(o, s, r.offset);
      r.nextGraphemeLength(), a = this._nextVisibleColumn(l, a, i);
    }
    return a;
  }
  static columnFromVisibleColumn(e, t, i) {
    if (t <= 0) return 1;
    const s = e.length, o = new Ww(e);
    let r = 0, a = 1;
    for (; !o.eol(); ) {
      const l = Bw(e, s, o.offset);
      o.nextGraphemeLength();
      const d = this._nextVisibleColumn(l, r, i), h = o.offset + 1;
      if (d >= t)
        return d - t < t - r ? h : a;
      r = d, a = h;
    }
    return s + 1;
  }
  static nextRenderTabStop(e, t) {
    return e + t - e % t;
  }
  static nextIndentTabStop(e, t) {
    return e + t - e % t;
  }
  static prevRenderTabStop(e, t) {
    return Math.max(0, e - 1 - (e - 1) % t);
  }
  static prevIndentTabStop(e, t) {
    return Math.max(0, e - 1 - (e - 1) % t);
  }
}
class gv {
  static whitespaceVisibleColumn(e, t, i) {
    const s = e.length;
    let o = 0, r = -1, a = -1;
    for (let l = 0; l < s; l++) {
      if (l === t) return [r, a, o];
      switch (o % i == 0 && (r = l, a = o), e.charCodeAt(l)) {
        case 32:
          o += 1;
          break;
        case 9:
          o = Gi.nextRenderTabStop(o, i);
          break;
        default:
          return [-1, -1, -1];
      }
    }
    return t === s ? [r, a, o] : [-1, -1, -1];
  }
  static atomicPosition(e, t, i, s) {
    const o = e.length, [r, a, l] = gv.whitespaceVisibleColumn(e, t, i);
    if (l === -1) return -1;
    let d;
    switch (s) {
      case 0:
        d = !0;
        break;
      case 1:
        d = !1;
        break;
      case 2:
        if (l % i == 0) return t;
        d = l % i <= i / 2;
    }
    if (d) {
      if (r === -1) return -1;
      let u = a;
      for (let g = r; g < o; ++g) {
        if (u === a + i) return r;
        switch (e.charCodeAt(g)) {
          case 32:
            u += 1;
            break;
          case 9:
            u = Gi.nextRenderTabStop(u, i);
            break;
          default:
            return -1;
        }
      }
      return u === a + i ? r : -1;
    }
    const h = Gi.nextRenderTabStop(l, i);
    let c = l;
    for (let u = t; u < o; u++) {
      if (c === h) return u;
      switch (e.charCodeAt(u)) {
        case 32:
          c += 1;
          break;
        case 9:
          c = Gi.nextRenderTabStop(c, i);
          break;
        default:
          return -1;
      }
    }
    return c === h ? o : -1;
  }
}
class sh {
  constructor(e = null) {
    this.hitTarget = e, this.type = 0;
  }
}
class wB {
  get hitTarget() {
    return this.spanNode;
  }
  constructor(e, t, i) {
    this.position = e, this.spanNode = t, this.injectedText = i, this.type = 1;
  }
}
var vu;
(function(n) {
  n.createFromDOMInfo = function(e, t, i) {
    const s = e.getPositionFromDOMInfo(t, i);
    return s ? new wB(s, t, null) : new sh(t);
  };
})(vu || (vu = {}));
class GG {
  constructor(e, t) {
    this.lastViewCursorsRenderData = e, this.lastTextareaPosition = t;
  }
}
class Yn {
  static _deduceRage(e, t = null) {
    return !t && e ? new D(e.lineNumber, e.column, e.lineNumber, e.column) : t ?? null;
  }
  static createUnknown(e, t, i) {
    return { type: 0, element: e, mouseColumn: t, position: i, range: this._deduceRage(i) };
  }
  static createTextarea(e, t) {
    return { type: 1, element: e, mouseColumn: t, position: null, range: null };
  }
  static createMargin(e, t, i, s, o, r) {
    return { type: e, element: t, mouseColumn: i, position: s, range: o, detail: r };
  }
  static createViewZone(e, t, i, s, o) {
    return { type: e, element: t, mouseColumn: i, position: s, range: this._deduceRage(s), detail: o };
  }
  static createContentText(e, t, i, s, o) {
    return { type: 6, element: e, mouseColumn: t, position: i, range: this._deduceRage(i, s), detail: o };
  }
  static createContentEmpty(e, t, i, s) {
    return { type: 7, element: e, mouseColumn: t, position: i, range: this._deduceRage(i), detail: s };
  }
  static createContentWidget(e, t, i) {
    return { type: 9, element: e, mouseColumn: t, position: null, range: null, detail: i };
  }
  static createScrollbar(e, t, i) {
    return { type: 11, element: e, mouseColumn: t, position: i, range: this._deduceRage(i) };
  }
  static createOverlayWidget(e, t, i) {
    return { type: 12, element: e, mouseColumn: t, position: null, range: null, detail: i };
  }
  static createOutsideEditor(e, t, i, s) {
    return { type: 13, element: null, mouseColumn: e, position: t, range: this._deduceRage(t), outsidePosition: i, outsideDistance: s };
  }
  static _typeToString(e) {
    return e === 1 ? "TEXTAREA" : e === 2 ? "GUTTER_GLYPH_MARGIN" : e === 3 ? "GUTTER_LINE_NUMBERS" : e === 4 ? "GUTTER_LINE_DECORATIONS" : e === 5 ? "GUTTER_VIEW_ZONE" : e === 6 ? "CONTENT_TEXT" : e === 7 ? "CONTENT_EMPTY" : e === 8 ? "CONTENT_VIEW_ZONE" : e === 9 ? "CONTENT_WIDGET" : e === 10 ? "OVERVIEW_RULER" : e === 11 ? "SCROLLBAR" : e === 12 ? "OVERLAY_WIDGET" : "UNKNOWN";
  }
  static toString(e) {
    return this._typeToString(e.type) + ": " + e.position + " - " + e.range + " - " + JSON.stringify(e.detail);
  }
}
class is {
  static isTextArea(e) {
    return e.length === 2 && e[0] === 3 && e[1] === 7;
  }
  static isChildOfViewLines(e) {
    return e.length >= 4 && e[0] === 3 && e[3] === 8;
  }
  static isStrictChildOfViewLines(e) {
    return e.length > 4 && e[0] === 3 && e[3] === 8;
  }
  static isChildOfScrollableElement(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 6;
  }
  static isChildOfMinimap(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 9;
  }
  static isChildOfContentWidgets(e) {
    return e.length >= 4 && e[0] === 3 && e[3] === 1;
  }
  static isChildOfOverflowGuard(e) {
    return e.length >= 1 && e[0] === 3;
  }
  static isChildOfOverflowingContentWidgets(e) {
    return e.length >= 1 && e[0] === 2;
  }
  static isChildOfOverlayWidgets(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 4;
  }
  static isChildOfOverflowingOverlayWidgets(e) {
    return e.length >= 1 && e[0] === 5;
  }
}
class Um {
  constructor(e, t, i) {
    this.viewModel = e.viewModel;
    const s = e.configuration.options;
    this.layoutInfo = s.get(145), this.viewDomNode = t.viewDomNode, this.lineHeight = s.get(67), this.stickyTabStops = s.get(116), this.typicalHalfwidthCharacterWidth = s.get(50).typicalHalfwidthCharacterWidth, this.lastRenderData = i, this._context = e, this._viewHelper = t;
  }
  getZoneAtCoord(e) {
    return Um.getZoneAtCoord(this._context, e);
  }
  static getZoneAtCoord(e, t) {
    const i = e.viewLayout.getWhitespaceAtVerticalOffset(t);
    if (i) {
      const s = i.verticalOffset + i.height / 2, o = e.viewModel.getLineCount();
      let r, a = null, l = null;
      return i.afterLineNumber !== o && (l = new W(i.afterLineNumber + 1, 1)), i.afterLineNumber > 0 && (a = new W(i.afterLineNumber, e.viewModel.getLineMaxColumn(i.afterLineNumber))), r = l === null ? a : a === null ? l : t < s ? a : l, { viewZoneId: i.id, afterLineNumber: i.afterLineNumber, positionBefore: a, positionAfter: l, position: r };
    }
    return null;
  }
  getFullLineRangeAtCoord(e) {
    if (this._context.viewLayout.isAfterLines(e)) {
      const s = this._context.viewModel.getLineCount(), o = this._context.viewModel.getLineMaxColumn(s);
      return { range: new D(s, o, s, o), isAfterLines: !0 };
    }
    const t = this._context.viewLayout.getLineNumberAtVerticalOffset(e), i = this._context.viewModel.getLineMaxColumn(t);
    return { range: new D(t, 1, t, i), isAfterLines: !1 };
  }
  getLineNumberAtVerticalOffset(e) {
    return this._context.viewLayout.getLineNumberAtVerticalOffset(e);
  }
  isAfterLines(e) {
    return this._context.viewLayout.isAfterLines(e);
  }
  isInTopPadding(e) {
    return this._context.viewLayout.isInTopPadding(e);
  }
  isInBottomPadding(e) {
    return this._context.viewLayout.isInBottomPadding(e);
  }
  getVerticalOffsetForLineNumber(e) {
    return this._context.viewLayout.getVerticalOffsetForLineNumber(e);
  }
  findAttribute(e, t) {
    return Um._findAttribute(e, t, this._viewHelper.viewDomNode);
  }
  static _findAttribute(e, t, i) {
    for (; e && e !== e.ownerDocument.body; ) {
      if (e.hasAttribute && e.hasAttribute(t)) return e.getAttribute(t);
      if (e === i) return null;
      e = e.parentNode;
    }
    return null;
  }
  getLineWidth(e) {
    return this._viewHelper.getLineWidth(e);
  }
  visibleRangeForPosition(e, t) {
    return this._viewHelper.visibleRangeForPosition(e, t);
  }
  getPositionFromDOMInfo(e, t) {
    return this._viewHelper.getPositionFromDOMInfo(e, t);
  }
  getCurrentScrollTop() {
    return this._context.viewLayout.getCurrentScrollTop();
  }
  getCurrentScrollLeft() {
    return this._context.viewLayout.getCurrentScrollLeft();
  }
}
class ZG {
  constructor(e, t, i, s) {
    this.editorPos = t, this.pos = i, this.relativePos = s, this.mouseVerticalOffset = Math.max(0, e.getCurrentScrollTop() + this.relativePos.y), this.mouseContentHorizontalOffset = e.getCurrentScrollLeft() + this.relativePos.x - e.layoutInfo.contentLeft, this.isInMarginArea = this.relativePos.x < e.layoutInfo.contentLeft && this.relativePos.x >= e.layoutInfo.glyphMarginLeft, this.isInContentArea = !this.isInMarginArea, this.mouseColumn = Math.max(0, Gn._getMouseColumn(this.mouseContentHorizontalOffset, e.typicalHalfwidthCharacterWidth));
  }
}
class YG extends ZG {
  get target() {
    return this._useHitTestTarget ? this.hitTestResult.value.hitTarget : this._eventTarget;
  }
  get targetPath() {
    return this._targetPathCacheElement !== this.target && (this._targetPathCacheElement = this.target, this._targetPathCacheValue = fa.collect(this.target, this._ctx.viewDomNode)), this._targetPathCacheValue;
  }
  constructor(e, t, i, s, o) {
    super(e, t, i, s), this.hitTestResult = new ua((() => Gn.doHitTest(this._ctx, this))), this._targetPathCacheElement = null, this._targetPathCacheValue = new Uint8Array(0), this._ctx = e, this._eventTarget = o;
    const r = !!this._eventTarget;
    this._useHitTestTarget = !r;
  }
  toString() {
    return `pos(${this.pos.x},${this.pos.y}), editorPos(${this.editorPos.x},${this.editorPos.y}), relativePos(${this.relativePos.x},${this.relativePos.y}), mouseVerticalOffset: ${this.mouseVerticalOffset}, mouseContentHorizontalOffset: ${this.mouseContentHorizontalOffset}
	target: ${this.target ? this.target.outerHTML : null}`;
  }
  get wouldBenefitFromHitTestTargetSwitch() {
    return !this._useHitTestTarget && this.hitTestResult.value.hitTarget !== null && this.target !== this.hitTestResult.value.hitTarget;
  }
  switchToHitTestTarget() {
    this._useHitTestTarget = !0;
  }
  _getMouseColumn(e = null) {
    return e && e.column < this._ctx.viewModel.getLineMaxColumn(e.lineNumber) ? Gi.visibleColumnFromColumn(this._ctx.viewModel.getLineContent(e.lineNumber), e.column, this._ctx.viewModel.model.getOptions().tabSize) + 1 : this.mouseColumn;
  }
  fulfillUnknown(e = null) {
    return Yn.createUnknown(this.target, this._getMouseColumn(e), e);
  }
  fulfillTextarea() {
    return Yn.createTextarea(this.target, this._getMouseColumn());
  }
  fulfillMargin(e, t, i, s) {
    return Yn.createMargin(e, this.target, this._getMouseColumn(t), t, i, s);
  }
  fulfillViewZone(e, t, i) {
    return Yn.createViewZone(e, this.target, this._getMouseColumn(t), t, i);
  }
  fulfillContentText(e, t, i) {
    return Yn.createContentText(this.target, this._getMouseColumn(e), e, t, i);
  }
  fulfillContentEmpty(e, t) {
    return Yn.createContentEmpty(this.target, this._getMouseColumn(e), e, t);
  }
  fulfillContentWidget(e) {
    return Yn.createContentWidget(this.target, this._getMouseColumn(), e);
  }
  fulfillScrollbar(e) {
    return Yn.createScrollbar(this.target, this._getMouseColumn(e), e);
  }
  fulfillOverlayWidget(e) {
    return Yn.createOverlayWidget(this.target, this._getMouseColumn(), e);
  }
}
const K4 = { isAfterLines: !0 };
function uD(n) {
  return { isAfterLines: !1, horizontalDistanceToText: n };
}
class Gn {
  constructor(e, t) {
    this._context = e, this._viewHelper = t;
  }
  mouseTargetIsWidget(e) {
    const t = e.target, i = fa.collect(t, this._viewHelper.viewDomNode);
    return !(!is.isChildOfContentWidgets(i) && !is.isChildOfOverflowingContentWidgets(i)) || !(!is.isChildOfOverlayWidgets(i) && !is.isChildOfOverflowingOverlayWidgets(i));
  }
  createMouseTarget(e, t, i, s, o) {
    const r = new Um(this._context, this._viewHelper, e), a = new YG(r, t, i, s, o);
    try {
      const l = Gn._createMouseTarget(r, a);
      if (l.type === 6 && r.stickyTabStops && l.position !== null) {
        const d = Gn._snapToSoftTabBoundary(l.position, r.viewModel), h = D.fromPositions(d, d).plusRange(l.range);
        return a.fulfillContentText(d, h, l.detail);
      }
      return l;
    } catch {
      return a.fulfillUnknown();
    }
  }
  static _createMouseTarget(e, t) {
    if (t.target === null) return t.fulfillUnknown();
    const i = t;
    let s = null;
    return is.isChildOfOverflowGuard(t.targetPath) || is.isChildOfOverflowingContentWidgets(t.targetPath) || is.isChildOfOverflowingOverlayWidgets(t.targetPath) || (s = s || t.fulfillUnknown()), s = s || Gn._hitTestContentWidget(e, i), s = s || Gn._hitTestOverlayWidget(e, i), s = s || Gn._hitTestMinimap(e, i), s = s || Gn._hitTestScrollbarSlider(e, i), s = s || Gn._hitTestViewZone(e, i), s = s || Gn._hitTestMargin(e, i), s = s || Gn._hitTestViewCursor(e, i), s = s || Gn._hitTestTextArea(e, i), s = s || Gn._hitTestViewLines(e, i), s = s || Gn._hitTestScrollbar(e, i), s || t.fulfillUnknown();
  }
  static _hitTestContentWidget(e, t) {
    if (is.isChildOfContentWidgets(t.targetPath) || is.isChildOfOverflowingContentWidgets(t.targetPath)) {
      const i = e.findAttribute(t.target, "widgetId");
      return i ? t.fulfillContentWidget(i) : t.fulfillUnknown();
    }
    return null;
  }
  static _hitTestOverlayWidget(e, t) {
    if (is.isChildOfOverlayWidgets(t.targetPath) || is.isChildOfOverflowingOverlayWidgets(t.targetPath)) {
      const i = e.findAttribute(t.target, "widgetId");
      return i ? t.fulfillOverlayWidget(i) : t.fulfillUnknown();
    }
    return null;
  }
  static _hitTestViewCursor(e, t) {
    if (t.target) {
      const i = e.lastRenderData.lastViewCursorsRenderData;
      for (const s of i) if (t.target === s.domNode) return t.fulfillContentText(s.position, null, { mightBeForeignElement: !1, injectedText: null });
    }
    if (t.isInContentArea) {
      const i = e.lastRenderData.lastViewCursorsRenderData, s = t.mouseContentHorizontalOffset, o = t.mouseVerticalOffset;
      for (const r of i) {
        if (s < r.contentLeft || s > r.contentLeft + r.width) continue;
        const a = e.getVerticalOffsetForLineNumber(r.position.lineNumber);
        if (a <= o && o <= a + r.height) return t.fulfillContentText(r.position, null, { mightBeForeignElement: !1, injectedText: null });
      }
    }
    return null;
  }
  static _hitTestViewZone(e, t) {
    const i = e.getZoneAtCoord(t.mouseVerticalOffset);
    if (i) {
      const s = t.isInContentArea ? 8 : 5;
      return t.fulfillViewZone(s, i.position, i);
    }
    return null;
  }
  static _hitTestTextArea(e, t) {
    return is.isTextArea(t.targetPath) ? e.lastRenderData.lastTextareaPosition ? t.fulfillContentText(e.lastRenderData.lastTextareaPosition, null, { mightBeForeignElement: !1, injectedText: null }) : t.fulfillTextarea() : null;
  }
  static _hitTestMargin(e, t) {
    if (t.isInMarginArea) {
      const i = e.getFullLineRangeAtCoord(t.mouseVerticalOffset), s = i.range.getStartPosition();
      let o = Math.abs(t.relativePos.x);
      const r = { isAfterLines: i.isAfterLines, glyphMarginLeft: e.layoutInfo.glyphMarginLeft, glyphMarginWidth: e.layoutInfo.glyphMarginWidth, lineNumbersWidth: e.layoutInfo.lineNumbersWidth, offsetX: o };
      if (o -= e.layoutInfo.glyphMarginLeft, o <= e.layoutInfo.glyphMarginWidth) {
        const a = e.viewModel.coordinatesConverter.convertViewPositionToModelPosition(i.range.getStartPosition()), l = e.viewModel.glyphLanes.getLanesAtLine(a.lineNumber);
        return r.glyphMarginLane = l[Math.floor(o / e.lineHeight)], t.fulfillMargin(2, s, i.range, r);
      }
      return o -= e.layoutInfo.glyphMarginWidth, o <= e.layoutInfo.lineNumbersWidth ? t.fulfillMargin(3, s, i.range, r) : (o -= e.layoutInfo.lineNumbersWidth, t.fulfillMargin(4, s, i.range, r));
    }
    return null;
  }
  static _hitTestViewLines(e, t) {
    if (!is.isChildOfViewLines(t.targetPath)) return null;
    if (e.isInTopPadding(t.mouseVerticalOffset)) return t.fulfillContentEmpty(new W(1, 1), K4);
    if (e.isAfterLines(t.mouseVerticalOffset) || e.isInBottomPadding(t.mouseVerticalOffset)) {
      const s = e.viewModel.getLineCount(), o = e.viewModel.getLineMaxColumn(s);
      return t.fulfillContentEmpty(new W(s, o), K4);
    }
    if (is.isStrictChildOfViewLines(t.targetPath)) {
      const s = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset);
      if (e.viewModel.getLineLength(s) === 0) {
        const r = e.getLineWidth(s), a = uD(t.mouseContentHorizontalOffset - r);
        return t.fulfillContentEmpty(new W(s, 1), a);
      }
      const o = e.getLineWidth(s);
      if (t.mouseContentHorizontalOffset >= o) {
        const r = uD(t.mouseContentHorizontalOffset - o), a = new W(s, e.viewModel.getLineMaxColumn(s));
        return t.fulfillContentEmpty(a, r);
      }
    }
    const i = t.hitTestResult.value;
    return i.type === 1 ? Gn.createMouseTargetFromHitTestPosition(e, t, i.spanNode, i.position, i.injectedText) : t.wouldBenefitFromHitTestTargetSwitch ? (t.switchToHitTestTarget(), this._createMouseTarget(e, t)) : t.fulfillUnknown();
  }
  static _hitTestMinimap(e, t) {
    if (is.isChildOfMinimap(t.targetPath)) {
      const i = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), s = e.viewModel.getLineMaxColumn(i);
      return t.fulfillScrollbar(new W(i, s));
    }
    return null;
  }
  static _hitTestScrollbarSlider(e, t) {
    if (is.isChildOfScrollableElement(t.targetPath) && t.target && t.target.nodeType === 1) {
      const i = t.target.className;
      if (i && /\b(slider|scrollbar)\b/.test(i)) {
        const s = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), o = e.viewModel.getLineMaxColumn(s);
        return t.fulfillScrollbar(new W(s, o));
      }
    }
    return null;
  }
  static _hitTestScrollbar(e, t) {
    if (is.isChildOfScrollableElement(t.targetPath)) {
      const i = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), s = e.viewModel.getLineMaxColumn(i);
      return t.fulfillScrollbar(new W(i, s));
    }
    return null;
  }
  getMouseColumn(e) {
    const t = this._context.configuration.options, i = t.get(145), s = this._context.viewLayout.getCurrentScrollLeft() + e.x - i.contentLeft;
    return Gn._getMouseColumn(s, t.get(50).typicalHalfwidthCharacterWidth);
  }
  static _getMouseColumn(e, t) {
    return e < 0 ? 1 : Math.round(e / t) + 1;
  }
  static createMouseTargetFromHitTestPosition(e, t, i, s, o) {
    const r = s.lineNumber, a = s.column, l = e.getLineWidth(r);
    if (t.mouseContentHorizontalOffset > l) {
      const _ = uD(t.mouseContentHorizontalOffset - l);
      return t.fulfillContentEmpty(s, _);
    }
    const d = e.visibleRangeForPosition(r, a);
    if (!d) return t.fulfillUnknown(s);
    const h = d.left;
    if (Math.abs(t.mouseContentHorizontalOffset - h) < 1) return t.fulfillContentText(s, null, { mightBeForeignElement: !!o, injectedText: o });
    const c = [];
    if (c.push({ offset: d.left, column: a }), a > 1) {
      const _ = e.visibleRangeForPosition(r, a - 1);
      _ && c.push({ offset: _.left, column: a - 1 });
    }
    if (a < e.viewModel.getLineMaxColumn(r)) {
      const _ = e.visibleRangeForPosition(r, a + 1);
      _ && c.push({ offset: _.left, column: a + 1 });
    }
    c.sort(((_, v) => _.offset - v.offset));
    const u = t.pos.toClientCoordinates(ke(e.viewDomNode)), g = i.getBoundingClientRect(), p = g.left <= u.clientX && u.clientX <= g.right;
    let f = null;
    for (let _ = 1; _ < c.length; _++) {
      const v = c[_ - 1], b = c[_];
      if (v.offset <= t.mouseContentHorizontalOffset && t.mouseContentHorizontalOffset <= b.offset) {
        f = new D(r, v.column, r, b.column);
        const C = Math.abs(v.offset - t.mouseContentHorizontalOffset), w = Math.abs(b.offset - t.mouseContentHorizontalOffset);
        s = new W(r, C < w ? v.column : b.column);
        break;
      }
    }
    return t.fulfillContentText(s, f, { mightBeForeignElement: !p || !!o, injectedText: o });
  }
  static _doHitTestWithCaretRangeFromPoint(e, t) {
    const i = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), s = e.getVerticalOffsetForLineNumber(i), o = s + e.lineHeight;
    if (!(i === e.viewModel.getLineCount() && t.mouseVerticalOffset > o)) {
      const r = Math.floor((s + o) / 2);
      let a = t.pos.y + (r - t.mouseVerticalOffset);
      a <= t.editorPos.y && (a = t.editorPos.y + 1), a >= t.editorPos.y + t.editorPos.height && (a = t.editorPos.y + t.editorPos.height - 1);
      const l = new oL(t.pos.x, a), d = this._actualDoHitTestWithCaretRangeFromPoint(e, l.toClientCoordinates(ke(e.viewDomNode)));
      if (d.type === 1) return d;
    }
    return this._actualDoHitTestWithCaretRangeFromPoint(e, t.pos.toClientCoordinates(ke(e.viewDomNode)));
  }
  static _actualDoHitTestWithCaretRangeFromPoint(e, t) {
    const i = ag(e.viewDomNode);
    let s;
    if (s = i ? i.caretRangeFromPoint === void 0 ? (function(r, a, l) {
      const d = document.createRange();
      let h = r.elementFromPoint(a, l);
      if (h !== null) {
        for (; h && h.firstChild && h.firstChild.nodeType !== h.firstChild.TEXT_NODE && h.lastChild && h.lastChild.firstChild; ) h = h.lastChild;
        const c = h.getBoundingClientRect(), u = ke(h), g = `${u.getComputedStyle(h, null).getPropertyValue("font-style")} ${u.getComputedStyle(h, null).getPropertyValue("font-variant")} ${u.getComputedStyle(h, null).getPropertyValue("font-weight")} ${u.getComputedStyle(h, null).getPropertyValue("font-size")}/${u.getComputedStyle(h, null).getPropertyValue("line-height")} ${u.getComputedStyle(h, null).getPropertyValue("font-family")}`, p = h.innerText;
        let f, _ = c.left, v = 0;
        if (a > c.left + c.width) v = p.length;
        else {
          const b = Iu.getInstance();
          for (let C = 0; C < p.length + 1; C++) {
            if (f = b.getCharWidth(p.charAt(C), g) / 2, _ += f, a < _) {
              v = C;
              break;
            }
            _ += f;
          }
        }
        d.setStart(h.firstChild, v), d.setEnd(h.firstChild, v);
      }
      return d;
    })(i, t.clientX, t.clientY) : i.caretRangeFromPoint(t.clientX, t.clientY) : e.viewDomNode.ownerDocument.caretRangeFromPoint(t.clientX, t.clientY), !s || !s.startContainer) return new sh();
    const o = s.startContainer;
    if (o.nodeType === o.TEXT_NODE) {
      const r = o.parentNode, a = r ? r.parentNode : null, l = a ? a.parentNode : null;
      return (l && l.nodeType === l.ELEMENT_NODE ? l.className : null) === $a.CLASS_NAME ? vu.createFromDOMInfo(e, r, s.startOffset) : new sh(o.parentNode);
    }
    if (o.nodeType === o.ELEMENT_NODE) {
      const r = o.parentNode, a = r ? r.parentNode : null;
      return (a && a.nodeType === a.ELEMENT_NODE ? a.className : null) === $a.CLASS_NAME ? vu.createFromDOMInfo(e, o, o.textContent.length) : new sh(o);
    }
    return new sh();
  }
  static _doHitTestWithCaretPositionFromPoint(e, t) {
    const i = e.viewDomNode.ownerDocument.caretPositionFromPoint(t.clientX, t.clientY);
    if (i.offsetNode.nodeType === i.offsetNode.TEXT_NODE) {
      const s = i.offsetNode.parentNode, o = s ? s.parentNode : null, r = o ? o.parentNode : null;
      return (r && r.nodeType === r.ELEMENT_NODE ? r.className : null) === $a.CLASS_NAME ? vu.createFromDOMInfo(e, i.offsetNode.parentNode, i.offset) : new sh(i.offsetNode.parentNode);
    }
    if (i.offsetNode.nodeType === i.offsetNode.ELEMENT_NODE) {
      const s = i.offsetNode.parentNode, o = s && s.nodeType === s.ELEMENT_NODE ? s.className : null, r = s ? s.parentNode : null, a = r && r.nodeType === r.ELEMENT_NODE ? r.className : null;
      if (o === $a.CLASS_NAME) {
        const l = i.offsetNode.childNodes[Math.min(i.offset, i.offsetNode.childNodes.length - 1)];
        if (l) return vu.createFromDOMInfo(e, l, 0);
      } else if (a === $a.CLASS_NAME) return vu.createFromDOMInfo(e, i.offsetNode, 0);
    }
    return new sh(i.offsetNode);
  }
  static _snapToSoftTabBoundary(e, t) {
    const i = t.getLineContent(e.lineNumber), { tabSize: s } = t.model.getOptions(), o = gv.atomicPosition(i, e.column - 1, s, 2);
    return o !== -1 ? new W(e.lineNumber, o + 1) : e;
  }
  static doHitTest(e, t) {
    let i = new sh();
    if (typeof e.viewDomNode.ownerDocument.caretRangeFromPoint == "function" ? i = this._doHitTestWithCaretRangeFromPoint(e, t) : e.viewDomNode.ownerDocument.caretPositionFromPoint && (i = this._doHitTestWithCaretPositionFromPoint(e, t.pos.toClientCoordinates(ke(e.viewDomNode)))), i.type === 1) {
      const s = e.viewModel.getInjectedTextAt(i.position), o = e.viewModel.normalizePosition(i.position, 2);
      !s && o.equals(i.position) || (i = new wB(o, i.spanNode, s));
    }
    return i;
  }
}
class Iu {
  static getInstance() {
    return Iu._INSTANCE || (Iu._INSTANCE = new Iu()), Iu._INSTANCE;
  }
  constructor() {
    this._cache = {}, this._canvas = document.createElement("canvas");
  }
  getCharWidth(e, t) {
    const i = e + t;
    if (this._cache[i]) return this._cache[i];
    const s = this._canvas.getContext("2d");
    s.font = t;
    const o = s.measureText(e).width;
    return this._cache[i] = o, o;
  }
}
function Li(n, e, t) {
  let i = null, s = null;
  if (typeof t.value == "function" ? (i = "value", s = t.value, s.length !== 0 && console.warn("Memoize should only be used in functions with zero parameters")) : typeof t.get == "function" && (i = "get", s = t.get), !s) throw new Error("not supported");
  const o = `$memoize$${e}`;
  t[i] = function(...r) {
    return this.hasOwnProperty(o) || Object.defineProperty(this, o, { configurable: !1, enumerable: !1, writable: !1, value: s.apply(this, r) }), this[o];
  };
}
Iu._INSTANCE = null;
var Vt, XG = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
};
(function(n) {
  n.Tap = "-monaco-gesturetap", n.Change = "-monaco-gesturechange", n.Start = "-monaco-gesturestart", n.End = "-monaco-gesturesend", n.Contextmenu = "-monaco-gesturecontextmenu";
})(Vt || (Vt = {}));
class Bt extends V {
  constructor() {
    super(), this.dispatched = !1, this.targets = new fs(), this.ignoreTargets = new fs(), this.activeTouches = {}, this.handle = null, this._lastSetTapCountTime = 0, this._register(se.runAndSubscribe(WS, (({ window: e, disposables: t }) => {
      t.add(K(e.document, "touchstart", ((i) => this.onTouchStart(i)), { passive: !1 })), t.add(K(e.document, "touchend", ((i) => this.onTouchEnd(e, i)))), t.add(K(e.document, "touchmove", ((i) => this.onTouchMove(i)), { passive: !1 }));
    }), { window: It, disposables: this._store }));
  }
  static addTarget(e) {
    return Bt.isTouchDevice() ? (Bt.INSTANCE || (Bt.INSTANCE = new Bt()), ye(Bt.INSTANCE.targets.push(e))) : V.None;
  }
  static ignoreTarget(e) {
    return Bt.isTouchDevice() ? (Bt.INSTANCE || (Bt.INSTANCE = new Bt()), ye(Bt.INSTANCE.ignoreTargets.push(e))) : V.None;
  }
  static isTouchDevice() {
    return "ontouchstart" in It || navigator.maxTouchPoints > 0;
  }
  dispose() {
    this.handle && (this.handle.dispose(), this.handle = null), super.dispose();
  }
  onTouchStart(e) {
    const t = Date.now();
    this.handle && (this.handle.dispose(), this.handle = null);
    for (let i = 0, s = e.targetTouches.length; i < s; i++) {
      const o = e.targetTouches.item(i);
      this.activeTouches[o.identifier] = { id: o.identifier, initialTarget: o.target, initialTimeStamp: t, initialPageX: o.pageX, initialPageY: o.pageY, rollingTimestamps: [t], rollingPageX: [o.pageX], rollingPageY: [o.pageY] };
      const r = this.newGestureEvent(Vt.Start, o.target);
      r.pageX = o.pageX, r.pageY = o.pageY, this.dispatchEvent(r);
    }
    this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
  }
  onTouchEnd(e, t) {
    const i = Date.now(), s = Object.keys(this.activeTouches).length;
    for (let o = 0, r = t.changedTouches.length; o < r; o++) {
      const a = t.changedTouches.item(o);
      if (!this.activeTouches.hasOwnProperty(String(a.identifier))) {
        console.warn("move of an UNKNOWN touch", a);
        continue;
      }
      const l = this.activeTouches[a.identifier], d = Date.now() - l.initialTimeStamp;
      if (d < Bt.HOLD_DELAY && Math.abs(l.initialPageX - Ao(l.rollingPageX)) < 30 && Math.abs(l.initialPageY - Ao(l.rollingPageY)) < 30) {
        const h = this.newGestureEvent(Vt.Tap, l.initialTarget);
        h.pageX = Ao(l.rollingPageX), h.pageY = Ao(l.rollingPageY), this.dispatchEvent(h);
      } else if (d >= Bt.HOLD_DELAY && Math.abs(l.initialPageX - Ao(l.rollingPageX)) < 30 && Math.abs(l.initialPageY - Ao(l.rollingPageY)) < 30) {
        const h = this.newGestureEvent(Vt.Contextmenu, l.initialTarget);
        h.pageX = Ao(l.rollingPageX), h.pageY = Ao(l.rollingPageY), this.dispatchEvent(h);
      } else if (s === 1) {
        const h = Ao(l.rollingPageX), c = Ao(l.rollingPageY), u = Ao(l.rollingTimestamps) - l.rollingTimestamps[0], g = h - l.rollingPageX[0], p = c - l.rollingPageY[0], f = [...this.targets].filter(((_) => l.initialTarget instanceof Node && _.contains(l.initialTarget)));
        this.inertia(e, f, i, Math.abs(g) / u, g > 0 ? 1 : -1, h, Math.abs(p) / u, p > 0 ? 1 : -1, c);
      }
      this.dispatchEvent(this.newGestureEvent(Vt.End, l.initialTarget)), delete this.activeTouches[a.identifier];
    }
    this.dispatched && (t.preventDefault(), t.stopPropagation(), this.dispatched = !1);
  }
  newGestureEvent(e, t) {
    const i = document.createEvent("CustomEvent");
    return i.initEvent(e, !1, !0), i.initialTarget = t, i.tapCount = 0, i;
  }
  dispatchEvent(e) {
    if (e.type === Vt.Tap) {
      const t = (/* @__PURE__ */ new Date()).getTime();
      let i = 0;
      i = t - this._lastSetTapCountTime > Bt.CLEAR_TAP_COUNT_TIME ? 1 : 2, this._lastSetTapCountTime = t, e.tapCount = i;
    } else e.type !== Vt.Change && e.type !== Vt.Contextmenu || (this._lastSetTapCountTime = 0);
    if (e.initialTarget instanceof Node) {
      for (const i of this.ignoreTargets) if (i.contains(e.initialTarget)) return;
      const t = [];
      for (const i of this.targets) if (i.contains(e.initialTarget)) {
        let s = 0, o = e.initialTarget;
        for (; o && o !== i; ) s++, o = o.parentElement;
        t.push([s, i]);
      }
      t.sort(((i, s) => i[0] - s[0]));
      for (const [i, s] of t) s.dispatchEvent(e), this.dispatched = !0;
    }
  }
  inertia(e, t, i, s, o, r, a, l, d) {
    this.handle = Ys(e, (() => {
      const h = Date.now(), c = h - i;
      let u = 0, g = 0, p = !0;
      s += Bt.SCROLL_FRICTION * c, a += Bt.SCROLL_FRICTION * c, s > 0 && (p = !1, u = o * s * c), a > 0 && (p = !1, g = l * a * c);
      const f = this.newGestureEvent(Vt.Change);
      f.translationX = u, f.translationY = g, t.forEach(((_) => _.dispatchEvent(f))), p || this.inertia(e, t, h, s, o, r + u, a, l, d + g);
    }));
  }
  onTouchMove(e) {
    const t = Date.now();
    for (let i = 0, s = e.changedTouches.length; i < s; i++) {
      const o = e.changedTouches.item(i);
      if (!this.activeTouches.hasOwnProperty(String(o.identifier))) {
        console.warn("end of an UNKNOWN touch", o);
        continue;
      }
      const r = this.activeTouches[o.identifier], a = this.newGestureEvent(Vt.Change, r.initialTarget);
      a.translationX = o.pageX - Ao(r.rollingPageX), a.translationY = o.pageY - Ao(r.rollingPageY), a.pageX = o.pageX, a.pageY = o.pageY, this.dispatchEvent(a), r.rollingPageX.length > 3 && (r.rollingPageX.shift(), r.rollingPageY.shift(), r.rollingTimestamps.shift()), r.rollingPageX.push(o.pageX), r.rollingPageY.push(o.pageY), r.rollingTimestamps.push(t);
    }
    this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
  }
}
Bt.SCROLL_FRICTION = -5e-3, Bt.HOLD_DELAY = 700, Bt.CLEAR_TAP_COUNT_TIME = 400, XG([Li], Bt, "isTouchDevice", null);
let To = class extends V {
  onclick(n, e) {
    this._register(K(n, ie.CLICK, ((t) => e(new _r(ke(n), t)))));
  }
  onmousedown(n, e) {
    this._register(K(n, ie.MOUSE_DOWN, ((t) => e(new _r(ke(n), t)))));
  }
  onmouseover(n, e) {
    this._register(K(n, ie.MOUSE_OVER, ((t) => e(new _r(ke(n), t)))));
  }
  onmouseleave(n, e) {
    this._register(K(n, ie.MOUSE_LEAVE, ((t) => e(new _r(ke(n), t)))));
  }
  onkeydown(n, e) {
    this._register(K(n, ie.KEY_DOWN, ((t) => e(new jt(t)))));
  }
  onkeyup(n, e) {
    this._register(K(n, ie.KEY_UP, ((t) => e(new jt(t)))));
  }
  oninput(n, e) {
    this._register(K(n, ie.INPUT, e));
  }
  onblur(n, e) {
    this._register(K(n, ie.BLUR, e));
  }
  onfocus(n, e) {
    this._register(K(n, ie.FOCUS, e));
  }
  ignoreGesture(n) {
    return Bt.ignoreTarget(n);
  }
};
const oy = 11;
class QG extends To {
  constructor(e) {
    super(), this._onActivate = e.onActivate, this.bgDomNode = document.createElement("div"), this.bgDomNode.className = "arrow-background", this.bgDomNode.style.position = "absolute", this.bgDomNode.style.width = e.bgWidth + "px", this.bgDomNode.style.height = e.bgHeight + "px", e.top !== void 0 && (this.bgDomNode.style.top = "0px"), e.left !== void 0 && (this.bgDomNode.style.left = "0px"), e.bottom !== void 0 && (this.bgDomNode.style.bottom = "0px"), e.right !== void 0 && (this.bgDomNode.style.right = "0px"), this.domNode = document.createElement("div"), this.domNode.className = e.className, this.domNode.classList.add(...Ee.asClassNameArray(e.icon)), this.domNode.style.position = "absolute", this.domNode.style.width = "11px", this.domNode.style.height = "11px", e.top !== void 0 && (this.domNode.style.top = e.top + "px"), e.left !== void 0 && (this.domNode.style.left = e.left + "px"), e.bottom !== void 0 && (this.domNode.style.bottom = e.bottom + "px"), e.right !== void 0 && (this.domNode.style.right = e.right + "px"), this._pointerMoveMonitor = this._register(new ff()), this._register(bi(this.bgDomNode, ie.POINTER_DOWN, ((t) => this._arrowPointerDown(t)))), this._register(bi(this.domNode, ie.POINTER_DOWN, ((t) => this._arrowPointerDown(t)))), this._pointerdownRepeatTimer = this._register(new gR()), this._pointerdownScheduleRepeatTimer = this._register(new Dr());
  }
  _arrowPointerDown(e) {
    e.target && e.target instanceof Element && (this._onActivate(), this._pointerdownRepeatTimer.cancel(), this._pointerdownScheduleRepeatTimer.cancelAndSet((() => {
      this._pointerdownRepeatTimer.cancelAndSet((() => this._onActivate()), 1e3 / 24, ke(e));
    }), 200), this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, ((t) => {
    }), (() => {
      this._pointerdownRepeatTimer.cancel(), this._pointerdownScheduleRepeatTimer.cancel();
    })), e.preventDefault());
  }
}
class JG extends V {
  constructor(e, t, i) {
    super(), this._visibility = e, this._visibleClassName = t, this._invisibleClassName = i, this._domNode = null, this._isVisible = !1, this._isNeeded = !1, this._rawShouldBeVisible = !1, this._shouldBeVisible = !1, this._revealTimer = this._register(new Dr());
  }
  setVisibility(e) {
    this._visibility !== e && (this._visibility = e, this._updateShouldBeVisible());
  }
  setShouldBeVisible(e) {
    this._rawShouldBeVisible = e, this._updateShouldBeVisible();
  }
  _applyVisibilitySetting() {
    return this._visibility !== 2 && (this._visibility === 3 || this._rawShouldBeVisible);
  }
  _updateShouldBeVisible() {
    const e = this._applyVisibilitySetting();
    this._shouldBeVisible !== e && (this._shouldBeVisible = e, this.ensureVisibility());
  }
  setIsNeeded(e) {
    this._isNeeded !== e && (this._isNeeded = e, this.ensureVisibility());
  }
  setDomNode(e) {
    this._domNode = e, this._domNode.setClassName(this._invisibleClassName), this.setShouldBeVisible(!1);
  }
  ensureVisibility() {
    this._isNeeded ? this._shouldBeVisible ? this._reveal() : this._hide(!0) : this._hide(!1);
  }
  _reveal() {
    this._isVisible || (this._isVisible = !0, this._revealTimer.setIfNotSet((() => {
      var e;
      (e = this._domNode) === null || e === void 0 || e.setClassName(this._visibleClassName);
    }), 0));
  }
  _hide(e) {
    var t;
    this._revealTimer.cancel(), this._isVisible && (this._isVisible = !1, (t = this._domNode) === null || t === void 0 || t.setClassName(this._invisibleClassName + (e ? " fade" : "")));
  }
}
class yB extends To {
  constructor(e) {
    super(), this._lazyRender = e.lazyRender, this._host = e.host, this._scrollable = e.scrollable, this._scrollByPage = e.scrollByPage, this._scrollbarState = e.scrollbarState, this._visibilityController = this._register(new JG(e.visibility, "visible scrollbar " + e.extraScrollbarClassName, "invisible scrollbar " + e.extraScrollbarClassName)), this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._pointerMoveMonitor = this._register(new ff()), this._shouldRender = !0, this.domNode = wt(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this._visibilityController.setDomNode(this.domNode), this.domNode.setPosition("absolute"), this._register(K(this.domNode.domNode, ie.POINTER_DOWN, ((t) => this._domNodePointerDown(t))));
  }
  _createArrow(e) {
    const t = this._register(new QG(e));
    this.domNode.domNode.appendChild(t.bgDomNode), this.domNode.domNode.appendChild(t.domNode);
  }
  _createSlider(e, t, i, s) {
    this.slider = wt(document.createElement("div")), this.slider.setClassName("slider"), this.slider.setPosition("absolute"), this.slider.setTop(e), this.slider.setLeft(t), typeof i == "number" && this.slider.setWidth(i), typeof s == "number" && this.slider.setHeight(s), this.slider.setLayerHinting(!0), this.slider.setContain("strict"), this.domNode.domNode.appendChild(this.slider.domNode), this._register(K(this.slider.domNode, ie.POINTER_DOWN, ((o) => {
      o.button === 0 && (o.preventDefault(), this._sliderPointerDown(o));
    }))), this.onclick(this.slider.domNode, ((o) => {
      o.leftButton && o.stopPropagation();
    }));
  }
  _onElementSize(e) {
    return this._scrollbarState.setVisibleSize(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  _onElementScrollSize(e) {
    return this._scrollbarState.setScrollSize(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  _onElementScrollPosition(e) {
    return this._scrollbarState.setScrollPosition(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  beginReveal() {
    this._visibilityController.setShouldBeVisible(!0);
  }
  beginHide() {
    this._visibilityController.setShouldBeVisible(!1);
  }
  render() {
    this._shouldRender && (this._shouldRender = !1, this._renderDomNode(this._scrollbarState.getRectangleLargeSize(), this._scrollbarState.getRectangleSmallSize()), this._updateSlider(this._scrollbarState.getSliderSize(), this._scrollbarState.getArrowSize() + this._scrollbarState.getSliderPosition()));
  }
  _domNodePointerDown(e) {
    e.target === this.domNode.domNode && this._onPointerDown(e);
  }
  delegatePointerDown(e) {
    const t = this.domNode.domNode.getClientRects()[0].top, i = t + this._scrollbarState.getSliderPosition(), s = t + this._scrollbarState.getSliderPosition() + this._scrollbarState.getSliderSize(), o = this._sliderPointerPosition(e);
    i <= o && o <= s ? e.button === 0 && (e.preventDefault(), this._sliderPointerDown(e)) : this._onPointerDown(e);
  }
  _onPointerDown(e) {
    let t, i;
    if (e.target === this.domNode.domNode && typeof e.offsetX == "number" && typeof e.offsetY == "number") t = e.offsetX, i = e.offsetY;
    else {
      const o = Ti(this.domNode.domNode);
      t = e.pageX - o.left, i = e.pageY - o.top;
    }
    const s = this._pointerDownRelativePosition(t, i);
    this._setDesiredScrollPositionNow(this._scrollByPage ? this._scrollbarState.getDesiredScrollPositionFromOffsetPaged(s) : this._scrollbarState.getDesiredScrollPositionFromOffset(s)), e.button === 0 && (e.preventDefault(), this._sliderPointerDown(e));
  }
  _sliderPointerDown(e) {
    if (!(e.target && e.target instanceof Element)) return;
    const t = this._sliderPointerPosition(e), i = this._sliderOrthogonalPointerPosition(e), s = this._scrollbarState.clone();
    this.slider.toggleClassName("active", !0), this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, ((o) => {
      const r = this._sliderOrthogonalPointerPosition(o), a = Math.abs(r - i);
      if (Tn && a > 140) return void this._setDesiredScrollPositionNow(s.getScrollPosition());
      const l = this._sliderPointerPosition(o) - t;
      this._setDesiredScrollPositionNow(s.getDesiredScrollPositionFromDelta(l));
    }), (() => {
      this.slider.toggleClassName("active", !1), this._host.onDragEnd();
    })), this._host.onDragStart();
  }
  _setDesiredScrollPositionNow(e) {
    const t = {};
    this.writeScrollPosition(t, e), this._scrollable.setScrollPositionNow(t);
  }
  updateScrollbarSize(e) {
    this._updateScrollbarSize(e), this._scrollbarState.setScrollbarSize(e), this._shouldRender = !0, this._lazyRender || this.render();
  }
  isNeeded() {
    return this._scrollbarState.isNeeded();
  }
}
class Km {
  constructor(e, t, i, s, o, r) {
    this._scrollbarSize = Math.round(t), this._oppositeScrollbarSize = Math.round(i), this._arrowSize = Math.round(e), this._visibleSize = s, this._scrollSize = o, this._scrollPosition = r, this._computedAvailableSize = 0, this._computedIsNeeded = !1, this._computedSliderSize = 0, this._computedSliderRatio = 0, this._computedSliderPosition = 0, this._refreshComputedValues();
  }
  clone() {
    return new Km(this._arrowSize, this._scrollbarSize, this._oppositeScrollbarSize, this._visibleSize, this._scrollSize, this._scrollPosition);
  }
  setVisibleSize(e) {
    const t = Math.round(e);
    return this._visibleSize !== t && (this._visibleSize = t, this._refreshComputedValues(), !0);
  }
  setScrollSize(e) {
    const t = Math.round(e);
    return this._scrollSize !== t && (this._scrollSize = t, this._refreshComputedValues(), !0);
  }
  setScrollPosition(e) {
    const t = Math.round(e);
    return this._scrollPosition !== t && (this._scrollPosition = t, this._refreshComputedValues(), !0);
  }
  setScrollbarSize(e) {
    this._scrollbarSize = Math.round(e);
  }
  setOppositeScrollbarSize(e) {
    this._oppositeScrollbarSize = Math.round(e);
  }
  static _computeValues(e, t, i, s, o) {
    const r = Math.max(0, i - e), a = Math.max(0, r - 2 * t), l = s > 0 && s > i;
    if (!l) return { computedAvailableSize: Math.round(r), computedIsNeeded: l, computedSliderSize: Math.round(a), computedSliderRatio: 0, computedSliderPosition: 0 };
    const d = Math.round(Math.max(20, Math.floor(i * a / s))), h = (a - d) / (s - i), c = o * h;
    return { computedAvailableSize: Math.round(r), computedIsNeeded: l, computedSliderSize: Math.round(d), computedSliderRatio: h, computedSliderPosition: Math.round(c) };
  }
  _refreshComputedValues() {
    const e = Km._computeValues(this._oppositeScrollbarSize, this._arrowSize, this._visibleSize, this._scrollSize, this._scrollPosition);
    this._computedAvailableSize = e.computedAvailableSize, this._computedIsNeeded = e.computedIsNeeded, this._computedSliderSize = e.computedSliderSize, this._computedSliderRatio = e.computedSliderRatio, this._computedSliderPosition = e.computedSliderPosition;
  }
  getArrowSize() {
    return this._arrowSize;
  }
  getScrollPosition() {
    return this._scrollPosition;
  }
  getRectangleLargeSize() {
    return this._computedAvailableSize;
  }
  getRectangleSmallSize() {
    return this._scrollbarSize;
  }
  isNeeded() {
    return this._computedIsNeeded;
  }
  getSliderSize() {
    return this._computedSliderSize;
  }
  getSliderPosition() {
    return this._computedSliderPosition;
  }
  getDesiredScrollPositionFromOffset(e) {
    if (!this._computedIsNeeded) return 0;
    const t = e - this._arrowSize - this._computedSliderSize / 2;
    return Math.round(t / this._computedSliderRatio);
  }
  getDesiredScrollPositionFromOffsetPaged(e) {
    if (!this._computedIsNeeded) return 0;
    const t = e - this._arrowSize;
    let i = this._scrollPosition;
    return t < this._computedSliderPosition ? i -= this._visibleSize : i += this._visibleSize, i;
  }
  getDesiredScrollPositionFromDelta(e) {
    if (!this._computedIsNeeded) return 0;
    const t = this._computedSliderPosition + e;
    return Math.round(t / this._computedSliderRatio);
  }
}
class eZ extends yB {
  constructor(e, t, i) {
    const s = e.getScrollDimensions(), o = e.getCurrentScrollPosition();
    if (super({ lazyRender: t.lazyRender, host: i, scrollbarState: new Km(t.horizontalHasArrows ? t.arrowSize : 0, t.horizontal === 2 ? 0 : t.horizontalScrollbarSize, t.vertical === 2 ? 0 : t.verticalScrollbarSize, s.width, s.scrollWidth, o.scrollLeft), visibility: t.horizontal, extraScrollbarClassName: "horizontal", scrollable: e, scrollByPage: t.scrollByPage }), t.horizontalHasArrows) {
      const r = (t.arrowSize - oy) / 2, a = (t.horizontalScrollbarSize - oy) / 2;
      this._createArrow({ className: "scra", icon: ne.scrollbarButtonLeft, top: a, left: r, bottom: void 0, right: void 0, bgWidth: t.arrowSize, bgHeight: t.horizontalScrollbarSize, onActivate: () => this._host.onMouseWheel(new rg(null, 1, 0)) }), this._createArrow({ className: "scra", icon: ne.scrollbarButtonRight, top: a, left: void 0, bottom: void 0, right: r, bgWidth: t.arrowSize, bgHeight: t.horizontalScrollbarSize, onActivate: () => this._host.onMouseWheel(new rg(null, -1, 0)) });
    }
    this._createSlider(Math.floor((t.horizontalScrollbarSize - t.horizontalSliderSize) / 2), 0, void 0, t.horizontalSliderSize);
  }
  _updateSlider(e, t) {
    this.slider.setWidth(e), this.slider.setLeft(t);
  }
  _renderDomNode(e, t) {
    this.domNode.setWidth(e), this.domNode.setHeight(t), this.domNode.setLeft(0), this.domNode.setBottom(0);
  }
  onDidScroll(e) {
    return this._shouldRender = this._onElementScrollSize(e.scrollWidth) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(e.scrollLeft) || this._shouldRender, this._shouldRender = this._onElementSize(e.width) || this._shouldRender, this._shouldRender;
  }
  _pointerDownRelativePosition(e, t) {
    return e;
  }
  _sliderPointerPosition(e) {
    return e.pageX;
  }
  _sliderOrthogonalPointerPosition(e) {
    return e.pageY;
  }
  _updateScrollbarSize(e) {
    this.slider.setHeight(e);
  }
  writeScrollPosition(e, t) {
    e.scrollLeft = t;
  }
  updateOptions(e) {
    this.updateScrollbarSize(e.horizontal === 2 ? 0 : e.horizontalScrollbarSize), this._scrollbarState.setOppositeScrollbarSize(e.vertical === 2 ? 0 : e.verticalScrollbarSize), this._visibilityController.setVisibility(e.horizontal), this._scrollByPage = e.scrollByPage;
  }
}
class tZ extends yB {
  constructor(e, t, i) {
    const s = e.getScrollDimensions(), o = e.getCurrentScrollPosition();
    if (super({ lazyRender: t.lazyRender, host: i, scrollbarState: new Km(t.verticalHasArrows ? t.arrowSize : 0, t.vertical === 2 ? 0 : t.verticalScrollbarSize, 0, s.height, s.scrollHeight, o.scrollTop), visibility: t.vertical, extraScrollbarClassName: "vertical", scrollable: e, scrollByPage: t.scrollByPage }), t.verticalHasArrows) {
      const r = (t.arrowSize - oy) / 2, a = (t.verticalScrollbarSize - oy) / 2;
      this._createArrow({ className: "scra", icon: ne.scrollbarButtonUp, top: r, left: a, bottom: void 0, right: void 0, bgWidth: t.verticalScrollbarSize, bgHeight: t.arrowSize, onActivate: () => this._host.onMouseWheel(new rg(null, 0, 1)) }), this._createArrow({ className: "scra", icon: ne.scrollbarButtonDown, top: void 0, left: a, bottom: r, right: void 0, bgWidth: t.verticalScrollbarSize, bgHeight: t.arrowSize, onActivate: () => this._host.onMouseWheel(new rg(null, 0, -1)) });
    }
    this._createSlider(0, Math.floor((t.verticalScrollbarSize - t.verticalSliderSize) / 2), t.verticalSliderSize, void 0);
  }
  _updateSlider(e, t) {
    this.slider.setHeight(e), this.slider.setTop(t);
  }
  _renderDomNode(e, t) {
    this.domNode.setWidth(t), this.domNode.setHeight(e), this.domNode.setRight(0), this.domNode.setTop(0);
  }
  onDidScroll(e) {
    return this._shouldRender = this._onElementScrollSize(e.scrollHeight) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(e.scrollTop) || this._shouldRender, this._shouldRender = this._onElementSize(e.height) || this._shouldRender, this._shouldRender;
  }
  _pointerDownRelativePosition(e, t) {
    return t;
  }
  _sliderPointerPosition(e) {
    return e.pageY;
  }
  _sliderOrthogonalPointerPosition(e) {
    return e.pageX;
  }
  _updateScrollbarSize(e) {
    this.slider.setWidth(e);
  }
  writeScrollPosition(e, t) {
    e.scrollTop = t;
  }
  updateOptions(e) {
    this.updateScrollbarSize(e.vertical === 2 ? 0 : e.verticalScrollbarSize), this._scrollbarState.setOppositeScrollbarSize(0), this._visibilityController.setVisibility(e.vertical), this._scrollByPage = e.scrollByPage;
  }
}
class ry {
  constructor(e, t, i, s, o, r, a) {
    this._forceIntegerValues = e, this._scrollStateBrand = void 0, this._forceIntegerValues && (t |= 0, i |= 0, s |= 0, o |= 0, r |= 0, a |= 0), this.rawScrollLeft = s, this.rawScrollTop = a, t < 0 && (t = 0), s + t > i && (s = i - t), s < 0 && (s = 0), o < 0 && (o = 0), a + o > r && (a = r - o), a < 0 && (a = 0), this.width = t, this.scrollWidth = i, this.scrollLeft = s, this.height = o, this.scrollHeight = r, this.scrollTop = a;
  }
  equals(e) {
    return this.rawScrollLeft === e.rawScrollLeft && this.rawScrollTop === e.rawScrollTop && this.width === e.width && this.scrollWidth === e.scrollWidth && this.scrollLeft === e.scrollLeft && this.height === e.height && this.scrollHeight === e.scrollHeight && this.scrollTop === e.scrollTop;
  }
  withScrollDimensions(e, t) {
    return new ry(this._forceIntegerValues, e.width !== void 0 ? e.width : this.width, e.scrollWidth !== void 0 ? e.scrollWidth : this.scrollWidth, t ? this.rawScrollLeft : this.scrollLeft, e.height !== void 0 ? e.height : this.height, e.scrollHeight !== void 0 ? e.scrollHeight : this.scrollHeight, t ? this.rawScrollTop : this.scrollTop);
  }
  withScrollPosition(e) {
    return new ry(this._forceIntegerValues, this.width, this.scrollWidth, e.scrollLeft !== void 0 ? e.scrollLeft : this.rawScrollLeft, this.height, this.scrollHeight, e.scrollTop !== void 0 ? e.scrollTop : this.rawScrollTop);
  }
  createScrollEvent(e, t) {
    const i = this.width !== e.width, s = this.scrollWidth !== e.scrollWidth, o = this.scrollLeft !== e.scrollLeft, r = this.height !== e.height, a = this.scrollHeight !== e.scrollHeight, l = this.scrollTop !== e.scrollTop;
    return { inSmoothScrolling: t, oldWidth: e.width, oldScrollWidth: e.scrollWidth, oldScrollLeft: e.scrollLeft, width: this.width, scrollWidth: this.scrollWidth, scrollLeft: this.scrollLeft, oldHeight: e.height, oldScrollHeight: e.scrollHeight, oldScrollTop: e.scrollTop, height: this.height, scrollHeight: this.scrollHeight, scrollTop: this.scrollTop, widthChanged: i, scrollWidthChanged: s, scrollLeftChanged: o, heightChanged: r, scrollHeightChanged: a, scrollTopChanged: l };
  }
}
class _f extends V {
  constructor(e) {
    super(), this._scrollableBrand = void 0, this._onScroll = this._register(new F()), this.onScroll = this._onScroll.event, this._smoothScrollDuration = e.smoothScrollDuration, this._scheduleAtNextAnimationFrame = e.scheduleAtNextAnimationFrame, this._state = new ry(e.forceIntegerValues, 0, 0, 0, 0, 0, 0), this._smoothScrolling = null;
  }
  dispose() {
    this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), super.dispose();
  }
  setSmoothScrollDuration(e) {
    this._smoothScrollDuration = e;
  }
  validateScrollPosition(e) {
    return this._state.withScrollPosition(e);
  }
  getScrollDimensions() {
    return this._state;
  }
  setScrollDimensions(e, t) {
    var i;
    const s = this._state.withScrollDimensions(e, t);
    this._setState(s, !!this._smoothScrolling), (i = this._smoothScrolling) === null || i === void 0 || i.acceptScrollDimensions(this._state);
  }
  getFutureScrollPosition() {
    return this._smoothScrolling ? this._smoothScrolling.to : this._state;
  }
  getCurrentScrollPosition() {
    return this._state;
  }
  setScrollPositionNow(e) {
    const t = this._state.withScrollPosition(e);
    this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), this._setState(t, !1);
  }
  setScrollPositionSmooth(e, t) {
    if (this._smoothScrollDuration === 0) return this.setScrollPositionNow(e);
    if (this._smoothScrolling) {
      e = { scrollLeft: e.scrollLeft === void 0 ? this._smoothScrolling.to.scrollLeft : e.scrollLeft, scrollTop: e.scrollTop === void 0 ? this._smoothScrolling.to.scrollTop : e.scrollTop };
      const i = this._state.withScrollPosition(e);
      if (this._smoothScrolling.to.scrollLeft === i.scrollLeft && this._smoothScrolling.to.scrollTop === i.scrollTop) return;
      let s;
      s = t ? new pv(this._smoothScrolling.from, i, this._smoothScrolling.startTime, this._smoothScrolling.duration) : this._smoothScrolling.combine(this._state, i, this._smoothScrollDuration), this._smoothScrolling.dispose(), this._smoothScrolling = s;
    } else {
      const i = this._state.withScrollPosition(e);
      this._smoothScrolling = pv.start(this._state, i, this._smoothScrollDuration);
    }
    this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame((() => {
      this._smoothScrolling && (this._smoothScrolling.animationFrameDisposable = null, this._performSmoothScrolling());
    }));
  }
  hasPendingScrollAnimation() {
    return !!this._smoothScrolling;
  }
  _performSmoothScrolling() {
    if (!this._smoothScrolling) return;
    const e = this._smoothScrolling.tick(), t = this._state.withScrollPosition(e);
    return this._setState(t, !0), this._smoothScrolling ? e.isDone ? (this._smoothScrolling.dispose(), void (this._smoothScrolling = null)) : void (this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame((() => {
      this._smoothScrolling && (this._smoothScrolling.animationFrameDisposable = null, this._performSmoothScrolling());
    }))) : void 0;
  }
  _setState(e, t) {
    const i = this._state;
    i.equals(e) || (this._state = e, this._onScroll.fire(this._state.createScrollEvent(i, t)));
  }
}
class j4 {
  constructor(e, t, i) {
    this.scrollLeft = e, this.scrollTop = t, this.isDone = i;
  }
}
function gD(n, e) {
  const t = e - n;
  return function(i) {
    return n + t * (1 - (function(s) {
      return Math.pow(s, 3);
    })(1 - i));
  };
}
class pv {
  constructor(e, t, i, s) {
    this.from = e, this.to = t, this.duration = s, this.startTime = i, this.animationFrameDisposable = null, this._initAnimations();
  }
  _initAnimations() {
    this.scrollLeft = this._initAnimation(this.from.scrollLeft, this.to.scrollLeft, this.to.width), this.scrollTop = this._initAnimation(this.from.scrollTop, this.to.scrollTop, this.to.height);
  }
  _initAnimation(e, t, i) {
    if (Math.abs(e - t) > 2.5 * i) {
      let a, l;
      return e < t ? (a = e + 0.75 * i, l = t - 0.75 * i) : (a = e - 0.75 * i, l = t + 0.75 * i), s = gD(e, a), o = gD(l, t), r = 0.33, function(d) {
        return d < r ? s(d / r) : o((d - r) / (1 - r));
      };
    }
    var s, o, r;
    return gD(e, t);
  }
  dispose() {
    this.animationFrameDisposable !== null && (this.animationFrameDisposable.dispose(), this.animationFrameDisposable = null);
  }
  acceptScrollDimensions(e) {
    this.to = e.withScrollPosition(this.to), this._initAnimations();
  }
  tick() {
    return this._tick(Date.now());
  }
  _tick(e) {
    const t = (e - this.startTime) / this.duration;
    if (t < 1) {
      const i = this.scrollLeft(t), s = this.scrollTop(t);
      return new j4(i, s, !1);
    }
    return new j4(this.to.scrollLeft, this.to.scrollTop, !0);
  }
  combine(e, t, i) {
    return pv.start(e, t, i);
  }
  static start(e, t, i) {
    i += 10;
    const s = Date.now() - 10;
    return new pv(e, t, s, i);
  }
}
class iZ {
  constructor(e, t, i) {
    this.timestamp = e, this.deltaX = t, this.deltaY = i, this.score = 0;
  }
}
class ay {
  constructor() {
    this._capacity = 5, this._memory = [], this._front = -1, this._rear = -1;
  }
  isPhysicalMouseWheel() {
    if (this._front === -1 && this._rear === -1) return !1;
    let e = 1, t = 0, i = 1, s = this._rear;
    for (; ; ) {
      const o = s === this._front ? e : Math.pow(2, -i);
      if (e -= o, t += this._memory[s].score * o, s === this._front) break;
      s = (this._capacity + s - 1) % this._capacity, i++;
    }
    return t <= 0.5;
  }
  acceptStandardWheelEvent(e) {
    if (m1) {
      const t = (function(i) {
        return LE.INSTANCE.getZoomFactor(i);
      })(ke(e.browserEvent));
      this.accept(Date.now(), e.deltaX * t, e.deltaY * t);
    } else this.accept(Date.now(), e.deltaX, e.deltaY);
  }
  accept(e, t, i) {
    let s = null;
    const o = new iZ(e, t, i);
    this._front === -1 && this._rear === -1 ? (this._memory[0] = o, this._front = 0, this._rear = 0) : (s = this._memory[this._rear], this._rear = (this._rear + 1) % this._capacity, this._rear === this._front && (this._front = (this._front + 1) % this._capacity), this._memory[this._rear] = o), o.score = this._computeScore(o, s);
  }
  _computeScore(e, t) {
    if (Math.abs(e.deltaX) > 0 && Math.abs(e.deltaY) > 0) return 1;
    let i = 0.5;
    if (this._isAlmostInt(e.deltaX) && this._isAlmostInt(e.deltaY) || (i += 0.25), t) {
      const s = Math.abs(e.deltaX), o = Math.abs(e.deltaY), r = Math.abs(t.deltaX), a = Math.abs(t.deltaY), l = Math.max(Math.min(s, r), 1), d = Math.max(Math.min(o, a), 1), h = Math.max(s, r), c = Math.max(o, a);
      h % l == 0 && c % d == 0 && (i -= 0.5);
    }
    return Math.min(Math.max(i, 0), 1);
  }
  _isAlmostInt(e) {
    return Math.abs(Math.round(e) - e) < 0.01;
  }
}
ay.INSTANCE = new ay();
class HR extends To {
  get options() {
    return this._options;
  }
  constructor(e, t, i) {
    super(), this._onScroll = this._register(new F()), this.onScroll = this._onScroll.event, this._onWillScroll = this._register(new F()), e.style.overflow = "hidden", this._options = (function(o) {
      const r = { lazyRender: o.lazyRender !== void 0 && o.lazyRender, className: o.className !== void 0 ? o.className : "", useShadows: o.useShadows === void 0 || o.useShadows, handleMouseWheel: o.handleMouseWheel === void 0 || o.handleMouseWheel, flipAxes: o.flipAxes !== void 0 && o.flipAxes, consumeMouseWheelIfScrollbarIsNeeded: o.consumeMouseWheelIfScrollbarIsNeeded !== void 0 && o.consumeMouseWheelIfScrollbarIsNeeded, alwaysConsumeMouseWheel: o.alwaysConsumeMouseWheel !== void 0 && o.alwaysConsumeMouseWheel, scrollYToX: o.scrollYToX !== void 0 && o.scrollYToX, mouseWheelScrollSensitivity: o.mouseWheelScrollSensitivity !== void 0 ? o.mouseWheelScrollSensitivity : 1, fastScrollSensitivity: o.fastScrollSensitivity !== void 0 ? o.fastScrollSensitivity : 5, scrollPredominantAxis: o.scrollPredominantAxis === void 0 || o.scrollPredominantAxis, mouseWheelSmoothScroll: o.mouseWheelSmoothScroll === void 0 || o.mouseWheelSmoothScroll, arrowSize: o.arrowSize !== void 0 ? o.arrowSize : 11, listenOnDomNode: o.listenOnDomNode !== void 0 ? o.listenOnDomNode : null, horizontal: o.horizontal !== void 0 ? o.horizontal : 1, horizontalScrollbarSize: o.horizontalScrollbarSize !== void 0 ? o.horizontalScrollbarSize : 10, horizontalSliderSize: o.horizontalSliderSize !== void 0 ? o.horizontalSliderSize : 0, horizontalHasArrows: o.horizontalHasArrows !== void 0 && o.horizontalHasArrows, vertical: o.vertical !== void 0 ? o.vertical : 1, verticalScrollbarSize: o.verticalScrollbarSize !== void 0 ? o.verticalScrollbarSize : 10, verticalHasArrows: o.verticalHasArrows !== void 0 && o.verticalHasArrows, verticalSliderSize: o.verticalSliderSize !== void 0 ? o.verticalSliderSize : 0, scrollByPage: o.scrollByPage !== void 0 && o.scrollByPage };
      return r.horizontalSliderSize = o.horizontalSliderSize !== void 0 ? o.horizontalSliderSize : r.horizontalScrollbarSize, r.verticalSliderSize = o.verticalSliderSize !== void 0 ? o.verticalSliderSize : r.verticalScrollbarSize, Je && (r.className += " mac"), r;
    })(t), this._scrollable = i, this._register(this._scrollable.onScroll(((o) => {
      this._onWillScroll.fire(o), this._onDidScroll(o), this._onScroll.fire(o);
    })));
    const s = { onMouseWheel: (o) => this._onMouseWheel(o), onDragStart: () => this._onDragStart(), onDragEnd: () => this._onDragEnd() };
    this._verticalScrollbar = this._register(new tZ(this._scrollable, this._options, s)), this._horizontalScrollbar = this._register(new eZ(this._scrollable, this._options, s)), this._domNode = document.createElement("div"), this._domNode.className = "monaco-scrollable-element " + this._options.className, this._domNode.setAttribute("role", "presentation"), this._domNode.style.position = "relative", this._domNode.style.overflow = "hidden", this._domNode.appendChild(e), this._domNode.appendChild(this._horizontalScrollbar.domNode.domNode), this._domNode.appendChild(this._verticalScrollbar.domNode.domNode), this._options.useShadows ? (this._leftShadowDomNode = wt(document.createElement("div")), this._leftShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._leftShadowDomNode.domNode), this._topShadowDomNode = wt(document.createElement("div")), this._topShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._topShadowDomNode.domNode), this._topLeftShadowDomNode = wt(document.createElement("div")), this._topLeftShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._topLeftShadowDomNode.domNode)) : (this._leftShadowDomNode = null, this._topShadowDomNode = null, this._topLeftShadowDomNode = null), this._listenOnDomNode = this._options.listenOnDomNode || this._domNode, this._mouseWheelToDispose = [], this._setListeningToMouseWheel(this._options.handleMouseWheel), this.onmouseover(this._listenOnDomNode, ((o) => this._onMouseOver(o))), this.onmouseleave(this._listenOnDomNode, ((o) => this._onMouseLeave(o))), this._hideTimeout = this._register(new Dr()), this._isDragging = !1, this._mouseIsOver = !1, this._shouldRender = !0, this._revealOnScroll = !0;
  }
  dispose() {
    this._mouseWheelToDispose = Ht(this._mouseWheelToDispose), super.dispose();
  }
  getDomNode() {
    return this._domNode;
  }
  getOverviewRulerLayoutInfo() {
    return { parent: this._domNode, insertBefore: this._verticalScrollbar.domNode.domNode };
  }
  delegateVerticalScrollbarPointerDown(e) {
    this._verticalScrollbar.delegatePointerDown(e);
  }
  getScrollDimensions() {
    return this._scrollable.getScrollDimensions();
  }
  setScrollDimensions(e) {
    this._scrollable.setScrollDimensions(e, !1);
  }
  updateClassName(e) {
    this._options.className = e, Je && (this._options.className += " mac"), this._domNode.className = "monaco-scrollable-element " + this._options.className;
  }
  updateOptions(e) {
    e.handleMouseWheel !== void 0 && (this._options.handleMouseWheel = e.handleMouseWheel, this._setListeningToMouseWheel(this._options.handleMouseWheel)), e.mouseWheelScrollSensitivity !== void 0 && (this._options.mouseWheelScrollSensitivity = e.mouseWheelScrollSensitivity), e.fastScrollSensitivity !== void 0 && (this._options.fastScrollSensitivity = e.fastScrollSensitivity), e.scrollPredominantAxis !== void 0 && (this._options.scrollPredominantAxis = e.scrollPredominantAxis), e.horizontal !== void 0 && (this._options.horizontal = e.horizontal), e.vertical !== void 0 && (this._options.vertical = e.vertical), e.horizontalScrollbarSize !== void 0 && (this._options.horizontalScrollbarSize = e.horizontalScrollbarSize), e.verticalScrollbarSize !== void 0 && (this._options.verticalScrollbarSize = e.verticalScrollbarSize), e.scrollByPage !== void 0 && (this._options.scrollByPage = e.scrollByPage), this._horizontalScrollbar.updateOptions(this._options), this._verticalScrollbar.updateOptions(this._options), this._options.lazyRender || this._render();
  }
  delegateScrollFromMouseWheelEvent(e) {
    this._onMouseWheel(new rg(e));
  }
  _setListeningToMouseWheel(e) {
    if (this._mouseWheelToDispose.length > 0 !== e && (this._mouseWheelToDispose = Ht(this._mouseWheelToDispose), e)) {
      const t = (i) => {
        this._onMouseWheel(new rg(i));
      };
      this._mouseWheelToDispose.push(K(this._listenOnDomNode, ie.MOUSE_WHEEL, t, { passive: !1 }));
    }
  }
  _onMouseWheel(e) {
    var t;
    if (!((t = e.browserEvent) === null || t === void 0) && t.defaultPrevented) return;
    const i = ay.INSTANCE;
    i.acceptStandardWheelEvent(e);
    let s = !1;
    if (e.deltaY || e.deltaX) {
      let r = e.deltaY * this._options.mouseWheelScrollSensitivity, a = e.deltaX * this._options.mouseWheelScrollSensitivity;
      this._options.scrollPredominantAxis && (this._options.scrollYToX && a + r === 0 ? a = r = 0 : Math.abs(r) >= Math.abs(a) ? a = 0 : r = 0), this._options.flipAxes && ([r, a] = [a, r]);
      const l = !Je && e.browserEvent && e.browserEvent.shiftKey;
      !this._options.scrollYToX && !l || a || (a = r, r = 0), e.browserEvent && e.browserEvent.altKey && (a *= this._options.fastScrollSensitivity, r *= this._options.fastScrollSensitivity);
      const d = this._scrollable.getFutureScrollPosition();
      let h = {};
      if (r) {
        const c = 50 * r, u = d.scrollTop - (c < 0 ? Math.floor(c) : Math.ceil(c));
        this._verticalScrollbar.writeScrollPosition(h, u);
      }
      if (a) {
        const c = 50 * a, u = d.scrollLeft - (c < 0 ? Math.floor(c) : Math.ceil(c));
        this._horizontalScrollbar.writeScrollPosition(h, u);
      }
      h = this._scrollable.validateScrollPosition(h), (d.scrollLeft !== h.scrollLeft || d.scrollTop !== h.scrollTop) && (this._options.mouseWheelSmoothScroll && i.isPhysicalMouseWheel() ? this._scrollable.setScrollPositionSmooth(h) : this._scrollable.setScrollPositionNow(h), s = !0);
    }
    let o = s;
    !o && this._options.alwaysConsumeMouseWheel && (o = !0), !o && this._options.consumeMouseWheelIfScrollbarIsNeeded && (this._verticalScrollbar.isNeeded() || this._horizontalScrollbar.isNeeded()) && (o = !0), o && (e.preventDefault(), e.stopPropagation());
  }
  _onDidScroll(e) {
    this._shouldRender = this._horizontalScrollbar.onDidScroll(e) || this._shouldRender, this._shouldRender = this._verticalScrollbar.onDidScroll(e) || this._shouldRender, this._options.useShadows && (this._shouldRender = !0), this._revealOnScroll && this._reveal(), this._options.lazyRender || this._render();
  }
  renderNow() {
    if (!this._options.lazyRender) throw new Error("Please use `lazyRender` together with `renderNow`!");
    this._render();
  }
  _render() {
    if (this._shouldRender && (this._shouldRender = !1, this._horizontalScrollbar.render(), this._verticalScrollbar.render(), this._options.useShadows)) {
      const e = this._scrollable.getCurrentScrollPosition(), t = e.scrollTop > 0, i = e.scrollLeft > 0, s = i ? " left" : "", o = t ? " top" : "", r = i || t ? " top-left-corner" : "";
      this._leftShadowDomNode.setClassName(`shadow${s}`), this._topShadowDomNode.setClassName(`shadow${o}`), this._topLeftShadowDomNode.setClassName(`shadow${r}${o}${s}`);
    }
  }
  _onDragStart() {
    this._isDragging = !0, this._reveal();
  }
  _onDragEnd() {
    this._isDragging = !1, this._hide();
  }
  _onMouseLeave(e) {
    this._mouseIsOver = !1, this._hide();
  }
  _onMouseOver(e) {
    this._mouseIsOver = !0, this._reveal();
  }
  _reveal() {
    this._verticalScrollbar.beginReveal(), this._horizontalScrollbar.beginReveal(), this._scheduleHide();
  }
  _hide() {
    this._mouseIsOver || this._isDragging || (this._verticalScrollbar.beginHide(), this._horizontalScrollbar.beginHide());
  }
  _scheduleHide() {
    this._mouseIsOver || this._isDragging || this._hideTimeout.cancelAndSet((() => this._hide()), 500);
  }
}
class SB extends HR {
  constructor(e, t) {
    (t = t || {}).mouseWheelSmoothScroll = !1;
    const i = new _f({ forceIntegerValues: !0, smoothScrollDuration: 0, scheduleAtNextAnimationFrame: (s) => Ys(ke(e), s) });
    super(e, t, i), this._register(i);
  }
  setScrollPosition(e) {
    this._scrollable.setScrollPositionNow(e);
  }
}
class aL extends HR {
  constructor(e, t, i) {
    super(e, t, i);
  }
  setScrollPosition(e) {
    e.reuseAnimation ? this._scrollable.setScrollPositionSmooth(e, e.reuseAnimation) : this._scrollable.setScrollPositionNow(e);
  }
  getScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
}
class S1 extends HR {
  constructor(e, t) {
    (t = t || {}).mouseWheelSmoothScroll = !1;
    const i = new _f({ forceIntegerValues: !1, smoothScrollDuration: 0, scheduleAtNextAnimationFrame: (s) => Ys(ke(e), s) });
    super(e, t, i), this._register(i), this._element = e, this._register(this.onScroll(((s) => {
      s.scrollTopChanged && (this._element.scrollTop = s.scrollTop), s.scrollLeftChanged && (this._element.scrollLeft = s.scrollLeft);
    }))), this.scanDomNode();
  }
  setScrollPosition(e) {
    this._scrollable.setScrollPositionNow(e);
  }
  getScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
  scanDomNode() {
    this.setScrollDimensions({ width: this._element.clientWidth, scrollWidth: this._element.scrollWidth, height: this._element.clientHeight, scrollHeight: this._element.scrollHeight }), this.setScrollPosition({ scrollLeft: this._element.scrollLeft, scrollTop: this._element.scrollTop });
  }
}
class zR extends y1 {
  constructor(e, t, i) {
    super(), this._mouseLeaveMonitor = null, this._context = e, this.viewController = t, this.viewHelper = i, this.mouseTargetFactory = new Gn(this._context, i), this._mouseDownOperation = this._register(new nZ(this._context, this.viewController, this.viewHelper, this.mouseTargetFactory, ((r, a) => this._createMouseTarget(r, a)), ((r) => this._getMouseColumn(r)))), this.lastMouseLeaveTime = -1, this._height = this._context.configuration.options.get(145).height;
    const s = new PG(this.viewHelper.viewDomNode);
    this._register(s.onContextMenu(this.viewHelper.viewDomNode, ((r) => this._onContextMenu(r, !0)))), this._register(s.onMouseMove(this.viewHelper.viewDomNode, ((r) => {
      this._onMouseMove(r), this._mouseLeaveMonitor || (this._mouseLeaveMonitor = K(this.viewHelper.viewDomNode.ownerDocument, "mousemove", ((a) => {
        this.viewHelper.viewDomNode.contains(a.target) || this._onMouseLeave(new Lc(a, !1, this.viewHelper.viewDomNode));
      })));
    }))), this._register(s.onMouseUp(this.viewHelper.viewDomNode, ((r) => this._onMouseUp(r)))), this._register(s.onMouseLeave(this.viewHelper.viewDomNode, ((r) => this._onMouseLeave(r))));
    let o = 0;
    this._register(s.onPointerDown(this.viewHelper.viewDomNode, ((r, a) => {
      o = a;
    }))), this._register(K(this.viewHelper.viewDomNode, ie.POINTER_UP, ((r) => {
      this._mouseDownOperation.onPointerUp();
    }))), this._register(s.onMouseDown(this.viewHelper.viewDomNode, ((r) => this._onMouseDown(r, o)))), this._setupMouseWheelZoomListener(), this._context.addEventHandler(this);
  }
  _setupMouseWheelZoomListener() {
    const e = ay.INSTANCE;
    let t = 0, i = Vo.getZoomLevel(), s = !1, o = 0;
    function r(a) {
      return Je ? (a.metaKey || a.ctrlKey) && !a.shiftKey && !a.altKey : a.ctrlKey && !a.metaKey && !a.shiftKey && !a.altKey;
    }
    this._register(K(this.viewHelper.viewDomNode, ie.MOUSE_WHEEL, ((a) => {
      if (this.viewController.emitMouseWheel(a), !this._context.configuration.options.get(76)) return;
      const l = new rg(a);
      if (e.acceptStandardWheelEvent(l), e.isPhysicalMouseWheel()) {
        if (r(a)) {
          const d = Vo.getZoomLevel(), h = l.deltaY > 0 ? 1 : -1;
          Vo.setZoomLevel(d + h), l.preventDefault(), l.stopPropagation();
        }
      } else Date.now() - t > 50 && (i = Vo.getZoomLevel(), s = r(a), o = 0), t = Date.now(), o += l.deltaY, s && (Vo.setZoomLevel(i + o / 5), l.preventDefault(), l.stopPropagation());
    }), { capture: !0, passive: !1 }));
  }
  dispose() {
    this._context.removeEventHandler(this), this._mouseLeaveMonitor && (this._mouseLeaveMonitor.dispose(), this._mouseLeaveMonitor = null), super.dispose();
  }
  onConfigurationChanged(e) {
    if (e.hasChanged(145)) {
      const t = this._context.configuration.options.get(145).height;
      this._height !== t && (this._height = t, this._mouseDownOperation.onHeightChanged());
    }
    return !1;
  }
  onCursorStateChanged(e) {
    return this._mouseDownOperation.onCursorStateChanged(e), !1;
  }
  onFocusChanged(e) {
    return !1;
  }
  getTargetAtClientPoint(e, t) {
    const i = new vB(e, t).toPageCoordinates(ke(this.viewHelper.viewDomNode)), s = BR(this.viewHelper.viewDomNode);
    if (i.y < s.y || i.y > s.y + s.height || i.x < s.x || i.x > s.x + s.width) return null;
    const o = WR(this.viewHelper.viewDomNode, s, i);
    return this.mouseTargetFactory.createMouseTarget(this.viewHelper.getLastRenderData(), s, i, o, null);
  }
  _createMouseTarget(e, t) {
    let i = e.target;
    if (!this.viewHelper.viewDomNode.contains(i)) {
      const s = ag(this.viewHelper.viewDomNode);
      s && (i = s.elementsFromPoint(e.posx, e.posy).find(((o) => this.viewHelper.viewDomNode.contains(o))));
    }
    return this.mouseTargetFactory.createMouseTarget(this.viewHelper.getLastRenderData(), e.editorPos, e.pos, e.relativePos, t ? i : null);
  }
  _getMouseColumn(e) {
    return this.mouseTargetFactory.getMouseColumn(e.relativePos);
  }
  _onContextMenu(e, t) {
    this.viewController.emitContextMenu({ event: e, target: this._createMouseTarget(e, t) });
  }
  _onMouseMove(e) {
    this.mouseTargetFactory.mouseTargetIsWidget(e) || e.preventDefault(), !this._mouseDownOperation.isActive() && (e.timestamp < this.lastMouseLeaveTime || this.viewController.emitMouseMove({ event: e, target: this._createMouseTarget(e, !0) }));
  }
  _onMouseLeave(e) {
    this._mouseLeaveMonitor && (this._mouseLeaveMonitor.dispose(), this._mouseLeaveMonitor = null), this.lastMouseLeaveTime = (/* @__PURE__ */ new Date()).getTime(), this.viewController.emitMouseLeave({ event: e, target: null });
  }
  _onMouseUp(e) {
    this.viewController.emitMouseUp({ event: e, target: this._createMouseTarget(e, !0) });
  }
  _onMouseDown(e, t) {
    const i = this._createMouseTarget(e, !0), s = i.type === 6 || i.type === 7, o = i.type === 2 || i.type === 3 || i.type === 4, r = i.type === 3, a = this._context.configuration.options.get(109), l = i.type === 8 || i.type === 5, d = i.type === 9;
    let h = e.leftButton || e.middleButton;
    Je && e.leftButton && e.ctrlKey && (h = !1);
    const c = () => {
      e.preventDefault(), this.viewHelper.focusTextArea();
    };
    if (h && (s || r && a)) c(), this._mouseDownOperation.start(i.type, e, t);
    else if (o) e.preventDefault();
    else if (l) {
      const u = i.detail;
      h && this.viewHelper.shouldSuppressMouseDownOnViewZone(u.viewZoneId) && (c(), this._mouseDownOperation.start(i.type, e, t), e.preventDefault());
    } else d && this.viewHelper.shouldSuppressMouseDownOnWidget(i.detail) && (c(), e.preventDefault());
    this.viewController.emitMouseDown({ event: e, target: i });
  }
}
class nZ extends V {
  constructor(e, t, i, s, o, r) {
    super(), this._context = e, this._viewController = t, this._viewHelper = i, this._mouseTargetFactory = s, this._createMouseTarget = o, this._getMouseColumn = r, this._mouseMoveMonitor = this._register(new FG(this._viewHelper.viewDomNode)), this._topBottomDragScrolling = this._register(new sZ(this._context, this._viewHelper, this._mouseTargetFactory, ((a, l, d) => this._dispatchMouse(a, l, d)))), this._mouseState = new lL(), this._currentSelection = new _e(1, 1, 1, 1), this._isActive = !1, this._lastMouseEvent = null;
  }
  dispose() {
    super.dispose();
  }
  isActive() {
    return this._isActive;
  }
  _onMouseDownThenMove(e) {
    this._lastMouseEvent = e, this._mouseState.setModifiers(e);
    const t = this._findMousePosition(e, !1);
    t && (this._mouseState.isDragAndDrop ? this._viewController.emitMouseDrag({ event: e, target: t }) : t.type !== 13 || t.outsidePosition !== "above" && t.outsidePosition !== "below" ? (this._topBottomDragScrolling.stop(), this._dispatchMouse(t, !0, 1)) : this._topBottomDragScrolling.start(t, e));
  }
  start(e, t, i) {
    this._lastMouseEvent = t, this._mouseState.setStartedOnLineNumbers(e === 3), this._mouseState.setStartButtons(t), this._mouseState.setModifiers(t);
    const s = this._findMousePosition(t, !0);
    if (!s || !s.position) return;
    this._mouseState.trySetCount(t.detail, s.position), t.detail = this._mouseState.count;
    const o = this._context.configuration.options;
    if (!o.get(91) && o.get(35) && !o.get(22) && !this._mouseState.altKey && t.detail < 2 && !this._isActive && !this._currentSelection.isEmpty() && s.type === 6 && s.position && this._currentSelection.containsPosition(s.position)) return this._mouseState.isDragAndDrop = !0, this._isActive = !0, void this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, i, t.buttons, ((r) => this._onMouseDownThenMove(r)), ((r) => {
      const a = this._findMousePosition(this._lastMouseEvent, !1);
      fh(r) ? this._viewController.emitMouseDropCanceled() : this._viewController.emitMouseDrop({ event: this._lastMouseEvent, target: a ? this._createMouseTarget(this._lastMouseEvent, !0) : null }), this._stop();
    }));
    this._mouseState.isDragAndDrop = !1, this._dispatchMouse(s, t.shiftKey, 1), this._isActive || (this._isActive = !0, this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, i, t.buttons, ((r) => this._onMouseDownThenMove(r)), (() => this._stop())));
  }
  _stop() {
    this._isActive = !1, this._topBottomDragScrolling.stop();
  }
  onHeightChanged() {
    this._mouseMoveMonitor.stopMonitoring();
  }
  onPointerUp() {
    this._mouseMoveMonitor.stopMonitoring();
  }
  onCursorStateChanged(e) {
    this._currentSelection = e.selections[0];
  }
  _getPositionOutsideEditor(e) {
    const t = e.editorPos, i = this._context.viewModel, s = this._context.viewLayout, o = this._getMouseColumn(e);
    if (e.posy < t.y) {
      const a = t.y - e.posy, l = Math.max(s.getCurrentScrollTop() - a, 0), d = Um.getZoneAtCoord(this._context, l);
      if (d) {
        const c = this._helpPositionJumpOverViewZone(d);
        if (c) return Yn.createOutsideEditor(o, c, "above", a);
      }
      const h = s.getLineNumberAtVerticalOffset(l);
      return Yn.createOutsideEditor(o, new W(h, 1), "above", a);
    }
    if (e.posy > t.y + t.height) {
      const a = e.posy - t.y - t.height, l = s.getCurrentScrollTop() + e.relativePos.y, d = Um.getZoneAtCoord(this._context, l);
      if (d) {
        const c = this._helpPositionJumpOverViewZone(d);
        if (c) return Yn.createOutsideEditor(o, c, "below", a);
      }
      const h = s.getLineNumberAtVerticalOffset(l);
      return Yn.createOutsideEditor(o, new W(h, i.getLineMaxColumn(h)), "below", a);
    }
    const r = s.getLineNumberAtVerticalOffset(s.getCurrentScrollTop() + e.relativePos.y);
    if (e.posx < t.x) {
      const a = t.x - e.posx;
      return Yn.createOutsideEditor(o, new W(r, 1), "left", a);
    }
    if (e.posx > t.x + t.width) {
      const a = e.posx - t.x - t.width;
      return Yn.createOutsideEditor(o, new W(r, i.getLineMaxColumn(r)), "right", a);
    }
    return null;
  }
  _findMousePosition(e, t) {
    const i = this._getPositionOutsideEditor(e);
    if (i) return i;
    const s = this._createMouseTarget(e, t);
    if (!s.position) return null;
    if (s.type === 8 || s.type === 5) {
      const o = this._helpPositionJumpOverViewZone(s.detail);
      if (o) return Yn.createViewZone(s.type, s.element, s.mouseColumn, o, s.detail);
    }
    return s;
  }
  _helpPositionJumpOverViewZone(e) {
    const t = new W(this._currentSelection.selectionStartLineNumber, this._currentSelection.selectionStartColumn), i = e.positionBefore, s = e.positionAfter;
    return i && s ? i.isBefore(t) ? i : s : null;
  }
  _dispatchMouse(e, t, i) {
    e.position && this._viewController.dispatchMouse({ position: e.position, mouseColumn: e.mouseColumn, startedOnLineNumbers: this._mouseState.startedOnLineNumbers, revealType: i, inSelectionMode: t, mouseDownCount: this._mouseState.count, altKey: this._mouseState.altKey, ctrlKey: this._mouseState.ctrlKey, metaKey: this._mouseState.metaKey, shiftKey: this._mouseState.shiftKey, leftButton: this._mouseState.leftButton, middleButton: this._mouseState.middleButton, onInjectedText: e.type === 6 && e.detail.injectedText !== null });
  }
}
class sZ extends V {
  constructor(e, t, i, s) {
    super(), this._context = e, this._viewHelper = t, this._mouseTargetFactory = i, this._dispatchMouse = s, this._operation = null;
  }
  dispose() {
    super.dispose(), this.stop();
  }
  start(e, t) {
    this._operation ? this._operation.setPosition(e, t) : this._operation = new oZ(this._context, this._viewHelper, this._mouseTargetFactory, this._dispatchMouse, e, t);
  }
  stop() {
    this._operation && (this._operation.dispose(), this._operation = null);
  }
}
class oZ extends V {
  constructor(e, t, i, s, o, r) {
    super(), this._context = e, this._viewHelper = t, this._mouseTargetFactory = i, this._dispatchMouse = s, this._position = o, this._mouseEvent = r, this._lastTime = Date.now(), this._animationFrameDisposable = Ys(ke(r.browserEvent), (() => this._execute()));
  }
  dispose() {
    this._animationFrameDisposable.dispose(), super.dispose();
  }
  setPosition(e, t) {
    this._position = e, this._mouseEvent = t;
  }
  _tick() {
    const e = Date.now(), t = e - this._lastTime;
    return this._lastTime = e, t;
  }
  _getScrollSpeed() {
    const e = this._context.configuration.options.get(67), t = this._context.configuration.options.get(145).height / e, i = this._position.outsideDistance / e;
    return i <= 1.5 ? Math.max(30, t * (1 + i)) : i <= 3 ? Math.max(60, t * (2 + i)) : Math.max(200, t * (7 + i));
  }
  _execute() {
    const e = this._context.configuration.options.get(67), t = this._getScrollSpeed() * (this._tick() / 1e3) * e, i = this._position.outsidePosition === "above" ? -t : t;
    this._context.viewModel.viewLayout.deltaScrollNow(0, i), this._viewHelper.renderNow();
    const s = this._context.viewLayout.getLinesViewportData(), o = this._position.outsidePosition === "above" ? s.startLineNumber : s.endLineNumber;
    let r;
    {
      const a = BR(this._viewHelper.viewDomNode), l = this._context.configuration.options.get(145).horizontalScrollbarHeight, d = new oL(this._mouseEvent.pos.x, a.y + a.height - l - 0.1), h = WR(this._viewHelper.viewDomNode, a, d);
      r = this._mouseTargetFactory.createMouseTarget(this._viewHelper.getLastRenderData(), a, d, h, null);
    }
    r.position && r.position.lineNumber === o || (r = this._position.outsidePosition === "above" ? Yn.createOutsideEditor(this._position.mouseColumn, new W(o, 1), "above", this._position.outsideDistance) : Yn.createOutsideEditor(this._position.mouseColumn, new W(o, this._context.viewModel.getLineMaxColumn(o)), "below", this._position.outsideDistance)), this._dispatchMouse(r, !0, 2), this._animationFrameDisposable = Ys(ke(r.element), (() => this._execute()));
  }
}
class lL {
  get altKey() {
    return this._altKey;
  }
  get ctrlKey() {
    return this._ctrlKey;
  }
  get metaKey() {
    return this._metaKey;
  }
  get shiftKey() {
    return this._shiftKey;
  }
  get leftButton() {
    return this._leftButton;
  }
  get middleButton() {
    return this._middleButton;
  }
  get startedOnLineNumbers() {
    return this._startedOnLineNumbers;
  }
  constructor() {
    this._altKey = !1, this._ctrlKey = !1, this._metaKey = !1, this._shiftKey = !1, this._leftButton = !1, this._middleButton = !1, this._startedOnLineNumbers = !1, this._lastMouseDownPosition = null, this._lastMouseDownPositionEqualCount = 0, this._lastMouseDownCount = 0, this._lastSetMouseDownCountTime = 0, this.isDragAndDrop = !1;
  }
  get count() {
    return this._lastMouseDownCount;
  }
  setModifiers(e) {
    this._altKey = e.altKey, this._ctrlKey = e.ctrlKey, this._metaKey = e.metaKey, this._shiftKey = e.shiftKey;
  }
  setStartButtons(e) {
    this._leftButton = e.leftButton, this._middleButton = e.middleButton;
  }
  setStartedOnLineNumbers(e) {
    this._startedOnLineNumbers = e;
  }
  trySetCount(e, t) {
    const i = (/* @__PURE__ */ new Date()).getTime();
    i - this._lastSetMouseDownCountTime > lL.CLEAR_MOUSE_DOWN_COUNT_TIME && (e = 1), this._lastSetMouseDownCountTime = i, e > this._lastMouseDownCount + 1 && (e = this._lastMouseDownCount + 1), this._lastMouseDownPosition && this._lastMouseDownPosition.equals(t) ? this._lastMouseDownPositionEqualCount++ : this._lastMouseDownPositionEqualCount = 1, this._lastMouseDownPosition = t, this._lastMouseDownCount = Math.min(e, this._lastMouseDownPositionEqualCount);
  }
}
lL.CLEAR_MOUSE_DOWN_COUNT_TIME = 400;
class st {
  get event() {
    return this.emitter.event;
  }
  constructor(e, t, i) {
    const s = (o) => this.emitter.fire(o);
    this.emitter = new F({ onWillAddFirstListener: () => e.addEventListener(t, s, i), onDidRemoveLastListener: () => e.removeEventListener(t, s, i) });
  }
  dispose() {
    this.emitter.dispose();
  }
}
class fn {
  constructor(e, t, i, s, o) {
    this.value = e, this.selectionStart = t, this.selectionEnd = i, this.selection = s, this.newlineCountBeforeSelection = o;
  }
  toString() {
    return `[ <${this.value}>, selectionStart: ${this.selectionStart}, selectionEnd: ${this.selectionEnd}]`;
  }
  static readFromTextArea(e, t) {
    const i = e.getValue(), s = e.getSelectionStart(), o = e.getSelectionEnd();
    let r;
    return t && i.substring(0, s) === t.value.substring(0, t.selectionStart) && (r = t.newlineCountBeforeSelection), new fn(i, s, o, null, r);
  }
  collapseSelection() {
    return this.selectionStart === this.value.length ? this : new fn(this.value, this.value.length, this.value.length, null, void 0);
  }
  writeToTextArea(e, t, i) {
    t.setValue(e, this.value), i && t.setSelectionRange(e, this.selectionStart, this.selectionEnd);
  }
  deduceEditorPosition(e) {
    var t, i, s, o, r, a, l, d;
    if (e <= this.selectionStart) {
      const u = this.value.substring(e, this.selectionStart);
      return this._finishDeduceEditorPosition((i = (t = this.selection) === null || t === void 0 ? void 0 : t.getStartPosition()) !== null && i !== void 0 ? i : null, u, -1);
    }
    if (e >= this.selectionEnd) {
      const u = this.value.substring(this.selectionEnd, e);
      return this._finishDeduceEditorPosition((o = (s = this.selection) === null || s === void 0 ? void 0 : s.getEndPosition()) !== null && o !== void 0 ? o : null, u, 1);
    }
    const h = this.value.substring(this.selectionStart, e);
    if (h.indexOf("…") === -1) return this._finishDeduceEditorPosition((a = (r = this.selection) === null || r === void 0 ? void 0 : r.getStartPosition()) !== null && a !== void 0 ? a : null, h, 1);
    const c = this.value.substring(e, this.selectionEnd);
    return this._finishDeduceEditorPosition((d = (l = this.selection) === null || l === void 0 ? void 0 : l.getEndPosition()) !== null && d !== void 0 ? d : null, c, -1);
  }
  _finishDeduceEditorPosition(e, t, i) {
    let s = 0, o = -1;
    for (; (o = t.indexOf(`
`, o + 1)) !== -1; ) s++;
    return [e, i * t.length, s];
  }
  static deduceInput(e, t, i) {
    if (!e) return { text: "", replacePrevCharCnt: 0, replaceNextCharCnt: 0, positionDelta: 0 };
    const s = Math.min(mc(e.value, t.value), e.selectionStart, t.selectionStart), o = Math.min(Fw(e.value, t.value), e.value.length - e.selectionEnd, t.value.length - t.selectionEnd);
    e.value.substring(s, e.value.length - o);
    const r = t.value.substring(s, t.value.length - o), a = e.selectionStart - s, l = e.selectionEnd - s;
    return t.selectionStart - s === t.selectionEnd - s ? { text: r, replacePrevCharCnt: e.selectionStart - s, replaceNextCharCnt: 0, positionDelta: 0 } : { text: r, replacePrevCharCnt: l - a, replaceNextCharCnt: 0, positionDelta: 0 };
  }
  static deduceAndroidCompositionInput(e, t) {
    if (!e) return { text: "", replacePrevCharCnt: 0, replaceNextCharCnt: 0, positionDelta: 0 };
    if (e.value === t.value) return { text: "", replacePrevCharCnt: 0, replaceNextCharCnt: 0, positionDelta: t.selectionEnd - e.selectionEnd };
    const i = Math.min(mc(e.value, t.value), e.selectionEnd), s = Math.min(Fw(e.value, t.value), e.value.length - e.selectionEnd), o = e.value.substring(i, e.value.length - s), r = t.value.substring(i, t.value.length - s);
    e.selectionStart;
    const a = e.selectionEnd - i;
    t.selectionStart;
    const l = t.selectionEnd - i;
    return { text: r, replacePrevCharCnt: a, replaceNextCharCnt: o.length - a, positionDelta: l - r.length };
  }
}
fn.EMPTY = new fn("", 0, 0, null, void 0);
class Ap {
  static _getPageOfLine(e, t) {
    return Math.floor((e - 1) / t);
  }
  static _getRangeForPage(e, t) {
    const i = e * t;
    return new D(i + 1, 1, i + t + 1, 1);
  }
  static fromEditorSelection(e, t, i, s) {
    const r = Ap._getPageOfLine(t.startLineNumber, i), a = Ap._getRangeForPage(r, i), l = Ap._getPageOfLine(t.endLineNumber, i), d = Ap._getRangeForPage(l, i);
    let h = a.intersectRanges(new D(1, 1, t.startLineNumber, t.startColumn));
    if (s && e.getValueLengthInRange(h, 1) > 500) {
      const v = e.modifyPosition(h.getEndPosition(), -500);
      h = D.fromPositions(v, h.getEndPosition());
    }
    const c = e.getValueInRange(h, 1), u = e.getLineCount(), g = e.getLineMaxColumn(u);
    let p = d.intersectRanges(new D(t.endLineNumber, t.endColumn, u, g));
    if (s && e.getValueLengthInRange(p, 1) > 500) {
      const v = e.modifyPosition(p.getStartPosition(), 500);
      p = D.fromPositions(p.getStartPosition(), v);
    }
    const f = e.getValueInRange(p, 1);
    let _;
    if (r === l || r + 1 === l) _ = e.getValueInRange(t, 1);
    else {
      const v = a.intersectRanges(t), b = d.intersectRanges(t);
      _ = e.getValueInRange(v, 1) + "…" + e.getValueInRange(b, 1);
    }
    return s && _.length > 1e3 && (_ = _.substring(0, 500) + "…" + _.substring(_.length - 500, _.length)), new fn(c + _ + f, c.length, c.length + _.length, t, h.endLineNumber - h.startLineNumber);
  }
}
var ly, rZ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, q4 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
(function(n) {
  n.Tap = "-monaco-textarea-synthetic-tap";
})(ly || (ly = {}));
const QE = { forceCopyWithSyntaxHighlighting: !1 };
class mv {
  constructor() {
    this._lastState = null;
  }
  set(e, t) {
    this._lastState = { lastCopiedValue: e, data: t };
  }
  get(e) {
    return this._lastState && this._lastState.lastCopiedValue === e ? this._lastState.data : (this._lastState = null, null);
  }
}
mv.INSTANCE = new mv();
class aZ {
  constructor() {
    this._lastTypeTextLength = 0;
  }
  handleCompositionUpdate(e) {
    const t = { text: e = e || "", replacePrevCharCnt: this._lastTypeTextLength, replaceNextCharCnt: 0, positionDelta: 0 };
    return this._lastTypeTextLength = e.length, t;
  }
}
let JE = class extends V {
  get textAreaState() {
    return this._textAreaState;
  }
  constructor(n, e, t, i, s, o) {
    super(), this._host = n, this._textArea = e, this._OS = t, this._browser = i, this._accessibilityService = s, this._logService = o, this._onFocus = this._register(new F()), this.onFocus = this._onFocus.event, this._onBlur = this._register(new F()), this.onBlur = this._onBlur.event, this._onKeyDown = this._register(new F()), this.onKeyDown = this._onKeyDown.event, this._onKeyUp = this._register(new F()), this.onKeyUp = this._onKeyUp.event, this._onCut = this._register(new F()), this.onCut = this._onCut.event, this._onPaste = this._register(new F()), this.onPaste = this._onPaste.event, this._onType = this._register(new F()), this.onType = this._onType.event, this._onCompositionStart = this._register(new F()), this.onCompositionStart = this._onCompositionStart.event, this._onCompositionUpdate = this._register(new F()), this.onCompositionUpdate = this._onCompositionUpdate.event, this._onCompositionEnd = this._register(new F()), this.onCompositionEnd = this._onCompositionEnd.event, this._onSelectionChangeRequest = this._register(new F()), this.onSelectionChangeRequest = this._onSelectionChangeRequest.event, this._asyncFocusGainWriteScreenReaderContent = this._register(new rn()), this._asyncTriggerCut = this._register(new Et((() => this._onCut.fire()), 0)), this._textAreaState = fn.EMPTY, this._selectionChangeListener = null, this._accessibilityService.isScreenReaderOptimized() && this.writeNativeTextAreaContent("ctor"), this._register(se.runAndSubscribe(this._accessibilityService.onDidChangeScreenReaderOptimized, (() => {
      this._accessibilityService.isScreenReaderOptimized() && !this._asyncFocusGainWriteScreenReaderContent.value ? this._asyncFocusGainWriteScreenReaderContent.value = this._register(new Et((() => this.writeNativeTextAreaContent("asyncFocusGain")), 0)) : this._asyncFocusGainWriteScreenReaderContent.clear();
    }))), this._hasFocus = !1, this._currentComposition = null;
    let r = null;
    this._register(this._textArea.onKeyDown(((a) => {
      const l = new jt(a);
      (l.keyCode === 114 || this._currentComposition && l.keyCode === 1) && l.stopPropagation(), l.equals(9) && l.preventDefault(), r = l, this._onKeyDown.fire(l);
    }))), this._register(this._textArea.onKeyUp(((a) => {
      const l = new jt(a);
      this._onKeyUp.fire(l);
    }))), this._register(this._textArea.onCompositionStart(((a) => {
      const l = new aZ();
      if (this._currentComposition) this._currentComposition = l;
      else {
        if (this._currentComposition = l, this._OS === 2 && r && r.equals(114) && this._textAreaState.selectionStart === this._textAreaState.selectionEnd && this._textAreaState.selectionStart > 0 && this._textAreaState.value.substr(this._textAreaState.selectionStart - 1, 1) === a.data && (r.code === "ArrowRight" || r.code === "ArrowLeft")) return l.handleCompositionUpdate("x"), void this._onCompositionStart.fire({ data: a.data });
        this._browser.isAndroid, this._onCompositionStart.fire({ data: a.data });
      }
    }))), this._register(this._textArea.onCompositionUpdate(((a) => {
      const l = this._currentComposition;
      if (!l) return;
      if (this._browser.isAndroid) {
        const h = fn.readFromTextArea(this._textArea, this._textAreaState), c = fn.deduceAndroidCompositionInput(this._textAreaState, h);
        return this._textAreaState = h, this._onType.fire(c), void this._onCompositionUpdate.fire(a);
      }
      const d = l.handleCompositionUpdate(a.data);
      this._textAreaState = fn.readFromTextArea(this._textArea, this._textAreaState), this._onType.fire(d), this._onCompositionUpdate.fire(a);
    }))), this._register(this._textArea.onCompositionEnd(((a) => {
      const l = this._currentComposition;
      if (!l) return;
      if (this._currentComposition = null, this._browser.isAndroid) {
        const h = fn.readFromTextArea(this._textArea, this._textAreaState), c = fn.deduceAndroidCompositionInput(this._textAreaState, h);
        return this._textAreaState = h, this._onType.fire(c), void this._onCompositionEnd.fire();
      }
      const d = l.handleCompositionUpdate(a.data);
      this._textAreaState = fn.readFromTextArea(this._textArea, this._textAreaState), this._onType.fire(d), this._onCompositionEnd.fire();
    }))), this._register(this._textArea.onInput(((a) => {
      if (this._textArea.setIgnoreSelectionChangeTime("received input event"), this._currentComposition) return;
      const l = fn.readFromTextArea(this._textArea, this._textAreaState), d = fn.deduceInput(this._textAreaState, l, this._OS === 2);
      (d.replacePrevCharCnt !== 0 || d.text.length !== 1 || !en(d.text.charCodeAt(0)) && d.text.charCodeAt(0) !== 127) && (this._textAreaState = l, d.text === "" && d.replacePrevCharCnt === 0 && d.replaceNextCharCnt === 0 && d.positionDelta === 0 || this._onType.fire(d));
    }))), this._register(this._textArea.onCut(((a) => {
      this._textArea.setIgnoreSelectionChangeTime("received cut event"), this._ensureClipboardGetsEditorSelection(a), this._asyncTriggerCut.schedule();
    }))), this._register(this._textArea.onCopy(((a) => {
      this._ensureClipboardGetsEditorSelection(a);
    }))), this._register(this._textArea.onPaste(((a) => {
      if (this._textArea.setIgnoreSelectionChangeTime("received paste event"), a.preventDefault(), !a.clipboardData) return;
      let [l, d] = eI.getTextData(a.clipboardData);
      l && (d = d || mv.INSTANCE.get(l), this._onPaste.fire({ text: l, metadata: d }));
    }))), this._register(this._textArea.onFocus((() => {
      const a = this._hasFocus;
      this._setHasFocus(!0), this._accessibilityService.isScreenReaderOptimized() && this._browser.isSafari && !a && this._hasFocus && (this._asyncFocusGainWriteScreenReaderContent.value || (this._asyncFocusGainWriteScreenReaderContent.value = new Et((() => this.writeNativeTextAreaContent("asyncFocusGain")), 0)), this._asyncFocusGainWriteScreenReaderContent.value.schedule());
    }))), this._register(this._textArea.onBlur((() => {
      this._currentComposition && (this._currentComposition = null, this.writeNativeTextAreaContent("blurWithoutCompositionEnd"), this._onCompositionEnd.fire()), this._setHasFocus(!1);
    }))), this._register(this._textArea.onSyntheticTap((() => {
      this._browser.isAndroid && this._currentComposition && (this._currentComposition = null, this.writeNativeTextAreaContent("tapWithoutCompositionEnd"), this._onCompositionEnd.fire());
    })));
  }
  _installSelectionChangeListener() {
    let n = 0;
    return K(this._textArea.ownerDocument, "selectionchange", ((e) => {
      if (Ih.onSelectionChange(), !this._hasFocus || this._currentComposition || !this._browser.isChrome) return;
      const t = Date.now(), i = t - n;
      if (n = t, i < 5) return;
      const s = t - this._textArea.getIgnoreSelectionChangeTime();
      if (this._textArea.resetSelectionChangeTime(), s < 100 || !this._textAreaState.selection) return;
      const o = this._textArea.getValue();
      if (this._textAreaState.value !== o) return;
      const r = this._textArea.getSelectionStart(), a = this._textArea.getSelectionEnd();
      if (this._textAreaState.selectionStart === r && this._textAreaState.selectionEnd === a) return;
      const l = this._textAreaState.deduceEditorPosition(r), d = this._host.deduceModelPosition(l[0], l[1], l[2]), h = this._textAreaState.deduceEditorPosition(a), c = this._host.deduceModelPosition(h[0], h[1], h[2]), u = new _e(d.lineNumber, d.column, c.lineNumber, c.column);
      this._onSelectionChangeRequest.fire(u);
    }));
  }
  dispose() {
    super.dispose(), this._selectionChangeListener && (this._selectionChangeListener.dispose(), this._selectionChangeListener = null);
  }
  focusTextArea() {
    this._setHasFocus(!0), this.refreshFocusState();
  }
  isFocused() {
    return this._hasFocus;
  }
  refreshFocusState() {
    this._setHasFocus(this._textArea.hasFocus());
  }
  _setHasFocus(n) {
    this._hasFocus !== n && (this._hasFocus = n, this._selectionChangeListener && (this._selectionChangeListener.dispose(), this._selectionChangeListener = null), this._hasFocus && (this._selectionChangeListener = this._installSelectionChangeListener()), this._hasFocus && this.writeNativeTextAreaContent("focusgain"), this._hasFocus ? this._onFocus.fire() : this._onBlur.fire());
  }
  _setAndWriteTextAreaState(n, e) {
    this._hasFocus || (e = e.collapseSelection()), e.writeToTextArea(n, this._textArea, this._hasFocus), this._textAreaState = e;
  }
  writeNativeTextAreaContent(n) {
    !this._accessibilityService.isScreenReaderOptimized() && n === "render" || this._currentComposition || (this._logService.trace(`writeTextAreaState(reason: ${n})`), this._setAndWriteTextAreaState(n, this._host.getScreenReaderContent()));
  }
  _ensureClipboardGetsEditorSelection(n) {
    const e = this._host.getDataToCopy(), t = { version: 1, isFromEmptySelection: e.isFromEmptySelection, multicursorText: e.multicursorText, mode: e.mode };
    mv.INSTANCE.set(this._browser.isFirefox ? e.text.replace(/\r\n/g, `
`) : e.text, t), n.preventDefault(), n.clipboardData && eI.setTextData(n.clipboardData, e.text, e.html, t);
  }
};
JE = rZ([q4(4, or), q4(5, ts)], JE);
const eI = { getTextData(n) {
  const e = n.getData(vi.text);
  let t = null;
  const i = n.getData("vscode-editor-data");
  if (typeof i == "string") try {
    t = JSON.parse(i), t.version !== 1 && (t = null);
  } catch {
  }
  return e.length === 0 && t === null && n.files.length > 0 ? [Array.prototype.slice.call(n.files, 0).map(((s) => s.name)).join(`
`), null] : [e, t];
}, setTextData(n, e, t, i) {
  n.setData(vi.text, e), typeof t == "string" && n.setData("text/html", t), n.setData("vscode-editor-data", JSON.stringify(i));
} };
class lZ extends V {
  get ownerDocument() {
    return this._actual.ownerDocument;
  }
  constructor(e) {
    super(), this._actual = e, this.onKeyDown = this._register(new st(this._actual, "keydown")).event, this.onKeyUp = this._register(new st(this._actual, "keyup")).event, this.onCompositionStart = this._register(new st(this._actual, "compositionstart")).event, this.onCompositionUpdate = this._register(new st(this._actual, "compositionupdate")).event, this.onCompositionEnd = this._register(new st(this._actual, "compositionend")).event, this.onBeforeInput = this._register(new st(this._actual, "beforeinput")).event, this.onInput = this._register(new st(this._actual, "input")).event, this.onCut = this._register(new st(this._actual, "cut")).event, this.onCopy = this._register(new st(this._actual, "copy")).event, this.onPaste = this._register(new st(this._actual, "paste")).event, this.onFocus = this._register(new st(this._actual, "focus")).event, this.onBlur = this._register(new st(this._actual, "blur")).event, this._onSyntheticTap = this._register(new F()), this.onSyntheticTap = this._onSyntheticTap.event, this._ignoreSelectionChangeTime = 0, this._register(this.onKeyDown((() => Ih.onKeyDown()))), this._register(this.onBeforeInput((() => Ih.onBeforeInput()))), this._register(this.onInput((() => Ih.onInput()))), this._register(this.onKeyUp((() => Ih.onKeyUp()))), this._register(K(this._actual, ly.Tap, (() => this._onSyntheticTap.fire())));
  }
  hasFocus() {
    const e = ag(this._actual);
    return e ? e.activeElement === this._actual : !!this._actual.isConnected && Mn() === this._actual;
  }
  setIgnoreSelectionChangeTime(e) {
    this._ignoreSelectionChangeTime = Date.now();
  }
  getIgnoreSelectionChangeTime() {
    return this._ignoreSelectionChangeTime;
  }
  resetSelectionChangeTime() {
    this._ignoreSelectionChangeTime = 0;
  }
  getValue() {
    return this._actual.value;
  }
  setValue(e, t) {
    const i = this._actual;
    i.value !== t && (this.setIgnoreSelectionChangeTime("setValue"), i.value = t);
  }
  getSelectionStart() {
    return this._actual.selectionDirection === "backward" ? this._actual.selectionEnd : this._actual.selectionStart;
  }
  getSelectionEnd() {
    return this._actual.selectionDirection === "backward" ? this._actual.selectionStart : this._actual.selectionEnd;
  }
  setSelectionRange(e, t, i) {
    const s = this._actual;
    let o = null;
    const r = ag(s);
    o = r ? r.activeElement : Mn();
    const a = ke(o), l = o === s, d = s.selectionStart, h = s.selectionEnd;
    if (l && d === t && h === i) tr && a.parent !== a && s.focus();
    else {
      if (l) return this.setIgnoreSelectionChangeTime("setSelectionRange"), s.setSelectionRange(t, i), void (tr && a.parent !== a && s.focus());
      try {
        const c = (function(u) {
          const g = [];
          for (let p = 0; u && u.nodeType === u.ELEMENT_NODE; p++) g[p] = u.scrollTop, u = u.parentNode;
          return g;
        })(s);
        this.setIgnoreSelectionChangeTime("setSelectionRange"), s.focus(), s.setSelectionRange(t, i), (function(u, g) {
          for (let p = 0; u && u.nodeType === u.ELEMENT_NODE; p++) u.scrollTop !== g[p] && (u.scrollTop = g[p]), u = u.parentNode;
        })(s, c);
      } catch {
      }
    }
  }
}
class dZ extends zR {
  constructor(e, t, i) {
    super(e, t, i), this._register(Bt.addTarget(this.viewHelper.linesContentDomNode)), this._register(K(this.viewHelper.linesContentDomNode, Vt.Tap, ((o) => this.onTap(o)))), this._register(K(this.viewHelper.linesContentDomNode, Vt.Change, ((o) => this.onChange(o)))), this._register(K(this.viewHelper.linesContentDomNode, Vt.Contextmenu, ((o) => this._onContextMenu(new Lc(o, !1, this.viewHelper.viewDomNode), !1)))), this._lastPointerType = "mouse", this._register(K(this.viewHelper.linesContentDomNode, "pointerdown", ((o) => {
      const r = o.pointerType;
      this._lastPointerType = r !== "mouse" ? r === "touch" ? "touch" : "pen" : "mouse";
    })));
    const s = new OG(this.viewHelper.viewDomNode);
    this._register(s.onPointerMove(this.viewHelper.viewDomNode, ((o) => this._onMouseMove(o)))), this._register(s.onPointerUp(this.viewHelper.viewDomNode, ((o) => this._onMouseUp(o)))), this._register(s.onPointerLeave(this.viewHelper.viewDomNode, ((o) => this._onMouseLeave(o)))), this._register(s.onPointerDown(this.viewHelper.viewDomNode, ((o, r) => this._onMouseDown(o, r))));
  }
  onTap(e) {
    e.initialTarget && this.viewHelper.linesContentDomNode.contains(e.initialTarget) && (e.preventDefault(), this.viewHelper.focusTextArea(), this._dispatchGesture(e, !1));
  }
  onChange(e) {
    this._lastPointerType === "touch" && this._context.viewModel.viewLayout.deltaScrollNow(-e.translationX, -e.translationY), this._lastPointerType === "pen" && this._dispatchGesture(e, !0);
  }
  _dispatchGesture(e, t) {
    const i = this._createMouseTarget(new Lc(e, !1, this.viewHelper.viewDomNode), !1);
    i.position && this.viewController.dispatchMouse({ position: i.position, mouseColumn: i.position.column, startedOnLineNumbers: !1, revealType: 1, mouseDownCount: e.tapCount, inSelectionMode: t, altKey: !1, ctrlKey: !1, metaKey: !1, shiftKey: !1, leftButton: !1, middleButton: !1, onInjectedText: i.type === 6 && i.detail.injectedText !== null });
  }
  _onMouseDown(e, t) {
    e.browserEvent.pointerType !== "touch" && super._onMouseDown(e, t);
  }
}
class hZ extends zR {
  constructor(e, t, i) {
    super(e, t, i), this._register(Bt.addTarget(this.viewHelper.linesContentDomNode)), this._register(K(this.viewHelper.linesContentDomNode, Vt.Tap, ((s) => this.onTap(s)))), this._register(K(this.viewHelper.linesContentDomNode, Vt.Change, ((s) => this.onChange(s)))), this._register(K(this.viewHelper.linesContentDomNode, Vt.Contextmenu, ((s) => this._onContextMenu(new Lc(s, !1, this.viewHelper.viewDomNode), !1))));
  }
  onTap(e) {
    e.preventDefault(), this.viewHelper.focusTextArea();
    const t = this._createMouseTarget(new Lc(e, !1, this.viewHelper.viewDomNode), !1);
    if (t.position) {
      const i = document.createEvent("CustomEvent");
      i.initEvent(ly.Tap, !1, !0), this.viewHelper.dispatchTextAreaEvent(i), this.viewController.moveTo(t.position, 1);
    }
  }
  onChange(e) {
    this._context.viewModel.viewLayout.deltaScrollNow(-e.translationX, -e.translationY);
  }
}
class cZ extends V {
  constructor(e, t, i) {
    super(), (ca || QU && y7) && dR ? this.handler = this._register(new dZ(e, t, i)) : It.TouchEvent ? this.handler = this._register(new hZ(e, t, i)) : this.handler = this._register(new zR(e, t, i));
  }
  getTargetAtClientPoint(e, t) {
    return this.handler.getTargetAtClientPoint(e, t);
  }
}
class Eg extends y1 {
}
const Yi = tt("themeService");
function ui(n) {
  return { id: n };
}
function tI(n) {
  switch (n) {
    case Zo.DARK:
      return "vs-dark";
    case Zo.HIGH_CONTRAST_DARK:
      return "hc-black";
    case Zo.HIGH_CONTRAST_LIGHT:
      return "hc-light";
    default:
      return "vs";
  }
}
const LB = "base.contributions.theming", kB = new class {
  constructor() {
    this.themingParticipants = [], this.themingParticipants = [], this.onThemingParticipantAddedEmitter = new F();
  }
  onColorThemeChange(n) {
    return this.themingParticipants.push(n), this.onThemingParticipantAddedEmitter.fire(n), ye((() => {
      const e = this.themingParticipants.indexOf(n);
      this.themingParticipants.splice(e, 1);
    }));
  }
  getThemingParticipants() {
    return this.themingParticipants;
  }
}();
function rr(n) {
  return kB.onColorThemeChange(n);
}
li.add(LB, kB);
class uZ extends V {
  constructor(e) {
    super(), this.themeService = e, this.theme = e.getColorTheme(), this._register(this.themeService.onDidColorThemeChange(((t) => this.onThemeChange(t))));
  }
  onThemeChange(e) {
    this.theme = e, this.updateStyles();
  }
  updateStyles() {
  }
}
const DB = I("editor.lineHighlightBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color for the highlight of line at the cursor position.")), $4 = I("editor.lineHighlightBorder", { dark: "#282828", light: "#eeeeee", hcDark: "#f38518", hcLight: ot }, m(0, "Background color for the border around the line at the cursor position."));
I("editor.rangeHighlightBackground", { dark: "#ffffff0b", light: "#fdff0033", hcDark: null, hcLight: null }, m(0, "Background color of highlighted ranges, like by quick open and find features. The color must not be opaque so as not to hide underlying decorations."), !0), I("editor.rangeHighlightBorder", { dark: null, light: null, hcDark: Zt, hcLight: Zt }, m(0, "Background color of the border around highlighted ranges."), !0), I("editor.symbolHighlightBackground", { dark: hd, light: hd, hcDark: null, hcLight: null }, m(0, "Background color of highlighted symbol, like for go to definition or go next/previous symbol. The color must not be opaque so as not to hide underlying decorations."), !0), I("editor.symbolHighlightBorder", { dark: null, light: null, hcDark: Zt, hcLight: Zt }, m(0, "Background color of the border around highlighted symbols."), !0);
const al = I("editorCursor.foreground", { dark: "#AEAFAD", light: z.black, hcDark: z.white, hcLight: "#0F4A85" }, m(0, "Color of the editor cursor.")), fd = I("editorCursor.background", null, m(0, "The background color of the editor cursor. Allows customizing the color of a character overlapped by a block cursor.")), xB = I("editorMultiCursor.primary.foreground", { dark: al, light: al, hcDark: al, hcLight: al }, m(0, "Color of the primary editor cursor when multiple cursors are present.")), gZ = I("editorMultiCursor.primary.background", { dark: fd, light: fd, hcDark: fd, hcLight: fd }, m(0, "The background color of the primary editor cursor when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor.")), NB = I("editorMultiCursor.secondary.foreground", { dark: al, light: al, hcDark: al, hcLight: al }, m(0, "Color of secondary editor cursors when multiple cursors are present.")), pZ = I("editorMultiCursor.secondary.background", { dark: fd, light: fd, hcDark: fd, hcLight: fd }, m(0, "The background color of secondary editor cursors when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor.")), _d = I("editorWhitespace.foreground", { dark: "#e3e4e229", light: "#33333333", hcDark: "#e3e4e229", hcLight: "#CCCCCC" }, m(0, "Color of whitespace characters in the editor.")), mZ = I("editorLineNumber.foreground", { dark: "#858585", light: "#237893", hcDark: z.white, hcLight: "#292929" }, m(0, "Color of editor line numbers.")), hb = I("editorIndentGuide.background", { dark: _d, light: _d, hcDark: _d, hcLight: _d }, m(0, "Color of the editor indentation guides."), !1, m(0, "'editorIndentGuide.background' is deprecated. Use 'editorIndentGuide.background1' instead.")), cb = I("editorIndentGuide.activeBackground", { dark: _d, light: _d, hcDark: _d, hcLight: _d }, m(0, "Color of the active editor indentation guides."), !1, m(0, "'editorIndentGuide.activeBackground' is deprecated. Use 'editorIndentGuide.activeBackground1' instead.")), L1 = I("editorIndentGuide.background1", { dark: hb, light: hb, hcDark: hb, hcLight: hb }, m(0, "Color of the editor indentation guides (1).")), fZ = I("editorIndentGuide.background2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the editor indentation guides (2).")), _Z = I("editorIndentGuide.background3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the editor indentation guides (3).")), vZ = I("editorIndentGuide.background4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the editor indentation guides (4).")), bZ = I("editorIndentGuide.background5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the editor indentation guides (5).")), CZ = I("editorIndentGuide.background6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the editor indentation guides (6).")), k1 = I("editorIndentGuide.activeBackground1", { dark: cb, light: cb, hcDark: cb, hcLight: cb }, m(0, "Color of the active editor indentation guides (1).")), wZ = I("editorIndentGuide.activeBackground2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the active editor indentation guides (2).")), yZ = I("editorIndentGuide.activeBackground3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the active editor indentation guides (3).")), SZ = I("editorIndentGuide.activeBackground4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the active editor indentation guides (4).")), LZ = I("editorIndentGuide.activeBackground5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the active editor indentation guides (5).")), kZ = I("editorIndentGuide.activeBackground6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the active editor indentation guides (6).")), ub = I("editorActiveLineNumber.foreground", { dark: "#c6c6c6", light: "#0B216F", hcDark: Zt, hcLight: Zt }, m(0, "Color of editor active line number"), !1, m(0, "Id is deprecated. Use 'editorLineNumber.activeForeground' instead."));
I("editorLineNumber.activeForeground", { dark: ub, light: ub, hcDark: ub, hcLight: ub }, m(0, "Color of editor active line number"));
const DZ = I("editorLineNumber.dimmedForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Color of the final editor line when editor.renderFinalNewline is set to dimmed."));
I("editorRuler.foreground", { dark: "#5A5A5A", light: z.lightgrey, hcDark: z.white, hcLight: "#292929" }, m(0, "Color of the editor rulers.")), I("editorCodeLens.foreground", { dark: "#999999", light: "#919191", hcDark: "#999999", hcLight: "#292929" }, m(0, "Foreground color of editor CodeLens")), I("editorBracketMatch.background", { dark: "#0064001a", light: "#0064001a", hcDark: "#0064001a", hcLight: "#0000" }, m(0, "Background color behind matching brackets")), I("editorBracketMatch.border", { dark: "#888", light: "#B9B9B9", hcDark: ot, hcLight: ot }, m(0, "Color for matching brackets boxes"));
const xZ = I("editorOverviewRuler.border", { dark: "#7f7f7f4d", light: "#7f7f7f4d", hcDark: "#7f7f7f4d", hcLight: "#666666" }, m(0, "Color of the overview ruler border.")), NZ = I("editorOverviewRuler.background", null, m(0, "Background color of the editor overview ruler."));
I("editorGutter.background", { dark: sn, light: sn, hcDark: sn, hcLight: sn }, m(0, "Background color of the editor gutter. The gutter contains the glyph margins and the line numbers.")), I("editorUnnecessaryCode.border", { dark: null, light: null, hcDark: z.fromHex("#fff").transparent(0.8), hcLight: ot }, m(0, "Border color of unnecessary (unused) source code in the editor."));
const EZ = I("editorUnnecessaryCode.opacity", { dark: z.fromHex("#000a"), light: z.fromHex("#0007"), hcDark: null, hcLight: null }, m(0, `Opacity of unnecessary (unused) source code in the editor. For example, "#000000c0" will render the code with 75% opacity. For high contrast themes, use the  'editorUnnecessaryCode.border' theme color to underline unnecessary code instead of fading it out.`));
I("editorGhostText.border", { dark: null, light: null, hcDark: z.fromHex("#fff").transparent(0.8), hcLight: z.fromHex("#292929").transparent(0.8) }, m(0, "Border color of ghost text in the editor.")), I("editorGhostText.foreground", { dark: z.fromHex("#ffffff56"), light: z.fromHex("#0007"), hcDark: null, hcLight: null }, m(0, "Foreground color of the ghost text in the editor.")), I("editorGhostText.background", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color of the ghost text in the editor."));
const gb = new z(new ht(0, 122, 204, 0.6)), EB = I("editorOverviewRuler.rangeHighlightForeground", { dark: gb, light: gb, hcDark: gb, hcLight: gb }, m(0, "Overview ruler marker color for range highlights. The color must not be opaque so as not to hide underlying decorations."), !0), IZ = I("editorOverviewRuler.errorForeground", { dark: new z(new ht(255, 18, 18, 0.7)), light: new z(new ht(255, 18, 18, 0.7)), hcDark: new z(new ht(255, 50, 50, 1)), hcLight: "#B5200D" }, m(0, "Overview ruler marker color for errors.")), MZ = I("editorOverviewRuler.warningForeground", { dark: Qn, light: Qn, hcDark: cv, hcLight: cv }, m(0, "Overview ruler marker color for warnings.")), TZ = I("editorOverviewRuler.infoForeground", { dark: Rs, light: Rs, hcDark: uv, hcLight: uv }, m(0, "Overview ruler marker color for infos.")), IB = I("editorBracketHighlight.foreground1", { dark: "#FFD700", light: "#0431FAFF", hcDark: "#FFD700", hcLight: "#0431FAFF" }, m(0, "Foreground color of brackets (1). Requires enabling bracket pair colorization.")), MB = I("editorBracketHighlight.foreground2", { dark: "#DA70D6", light: "#319331FF", hcDark: "#DA70D6", hcLight: "#319331FF" }, m(0, "Foreground color of brackets (2). Requires enabling bracket pair colorization.")), TB = I("editorBracketHighlight.foreground3", { dark: "#179FFF", light: "#7B3814FF", hcDark: "#87CEFA", hcLight: "#7B3814FF" }, m(0, "Foreground color of brackets (3). Requires enabling bracket pair colorization.")), RB = I("editorBracketHighlight.foreground4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Foreground color of brackets (4). Requires enabling bracket pair colorization.")), AB = I("editorBracketHighlight.foreground5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Foreground color of brackets (5). Requires enabling bracket pair colorization.")), PB = I("editorBracketHighlight.foreground6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Foreground color of brackets (6). Requires enabling bracket pair colorization.")), RZ = I("editorBracketHighlight.unexpectedBracket.foreground", { dark: new z(new ht(255, 18, 18, 0.8)), light: new z(new ht(255, 18, 18, 0.8)), hcDark: new z(new ht(255, 50, 50, 1)), hcLight: "" }, m(0, "Foreground color of unexpected brackets.")), AZ = I("editorBracketPairGuide.background1", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (1). Requires enabling bracket pair guides.")), PZ = I("editorBracketPairGuide.background2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (2). Requires enabling bracket pair guides.")), OZ = I("editorBracketPairGuide.background3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (3). Requires enabling bracket pair guides.")), FZ = I("editorBracketPairGuide.background4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (4). Requires enabling bracket pair guides.")), BZ = I("editorBracketPairGuide.background5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (5). Requires enabling bracket pair guides.")), WZ = I("editorBracketPairGuide.background6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (6). Requires enabling bracket pair guides.")), VZ = I("editorBracketPairGuide.activeBackground1", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (1). Requires enabling bracket pair guides.")), HZ = I("editorBracketPairGuide.activeBackground2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (2). Requires enabling bracket pair guides.")), zZ = I("editorBracketPairGuide.activeBackground3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (3). Requires enabling bracket pair guides.")), UZ = I("editorBracketPairGuide.activeBackground4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (4). Requires enabling bracket pair guides.")), KZ = I("editorBracketPairGuide.activeBackground5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (5). Requires enabling bracket pair guides.")), jZ = I("editorBracketPairGuide.activeBackground6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (6). Requires enabling bracket pair guides."));
I("editorUnicodeHighlight.border", { dark: Qn, light: Qn, hcDark: Qn, hcLight: Qn }, m(0, "Border color used to highlight unicode characters.")), I("editorUnicodeHighlight.background", { dark: rb, light: rb, hcDark: rb, hcLight: rb }, m(0, "Background color used to highlight unicode characters.")), rr(((n, e) => {
  const t = n.getColor(sn), i = n.getColor(DB), s = i && !i.isTransparent() ? i : t;
  s && e.addRule(`.monaco-editor .inputarea.ime-input { background-color: ${s}; }`);
}));
class D1 extends Eg {
  constructor(e) {
    super(), this._context = e, this._readConfig(), this._lastCursorModelPosition = new W(1, 1), this._renderResult = null, this._activeLineNumber = 1, this._context.addEventHandler(this);
  }
  _readConfig() {
    const e = this._context.configuration.options;
    this._lineHeight = e.get(67);
    const t = e.get(68);
    this._renderLineNumbers = t.renderType, this._renderCustomLineNumbers = t.renderFn, this._renderFinalNewline = e.get(95);
    const i = e.get(145);
    this._lineNumbersLeft = i.lineNumbersLeft, this._lineNumbersWidth = i.lineNumbersWidth;
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    return this._readConfig(), !0;
  }
  onCursorStateChanged(e) {
    const t = e.selections[0].getPosition();
    this._lastCursorModelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(t);
    let i = !1;
    return this._activeLineNumber !== t.lineNumber && (this._activeLineNumber = t.lineNumber, i = !0), this._renderLineNumbers !== 2 && this._renderLineNumbers !== 3 || (i = !0), i;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onDecorationsChanged(e) {
    return e.affectsLineNumber;
  }
  _getLineRenderLineNumber(e) {
    const t = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new W(e, 1));
    if (t.column !== 1) return "";
    const i = t.lineNumber;
    if (this._renderCustomLineNumbers) return this._renderCustomLineNumbers(i);
    if (this._renderLineNumbers === 2) {
      const s = Math.abs(this._lastCursorModelPosition.lineNumber - i);
      return s === 0 ? '<span class="relative-current-line-number">' + i + "</span>" : String(s);
    }
    return this._renderLineNumbers === 3 ? this._lastCursorModelPosition.lineNumber === i || i % 10 == 0 || i === this._context.viewModel.getLineCount() ? String(i) : "" : String(i);
  }
  prepareRender(e) {
    if (this._renderLineNumbers === 0) return void (this._renderResult = null);
    const t = Cs ? this._lineHeight % 2 == 0 ? " lh-even" : " lh-odd" : "", i = e.visibleRange.startLineNumber, s = e.visibleRange.endLineNumber, o = this._context.viewModel.getDecorationsInViewport(e.visibleRange).filter(((d) => !!d.options.lineNumberClassName));
    o.sort(((d, h) => D.compareRangesUsingEnds(d.range, h.range)));
    let r = 0;
    const a = this._context.viewModel.getLineCount(), l = [];
    for (let d = i; d <= s; d++) {
      const h = d - i;
      let c = this._getLineRenderLineNumber(d), u = "";
      for (; r < o.length && o[r].range.endLineNumber < d; ) r++;
      for (let g = r; g < o.length; g++) {
        const { range: p, options: f } = o[g];
        p.startLineNumber <= d && (u += " " + f.lineNumberClassName);
      }
      c || u ? (d === a && this._context.viewModel.getLineLength(d) === 0 && (this._renderFinalNewline === "off" && (c = ""), this._renderFinalNewline === "dimmed" && (u += " dimmed-line-number")), d === this._activeLineNumber && (u += " active-line-number"), l[h] = `<div class="${D1.CLASS_NAME}${t}${u}" style="left:${this._lineNumbersLeft}px;width:${this._lineNumbersWidth}px;">${c}</div>`) : l[h] = "";
    }
    this._renderResult = l;
  }
  render(e, t) {
    if (!this._renderResult) return "";
    const i = t - e;
    return i < 0 || i >= this._renderResult.length ? "" : this._renderResult[i];
  }
}
D1.CLASS_NAME = "line-numbers", rr(((n, e) => {
  const t = n.getColor(mZ), i = n.getColor(DZ);
  i ? e.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${i}; }`) : t && e.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${t.transparent(0.4)}; }`);
}));
class hg extends to {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, i = t.get(145);
    this._canUseLayerHinting = !t.get(32), this._contentLeft = i.contentLeft, this._glyphMarginLeft = i.glyphMarginLeft, this._glyphMarginWidth = i.glyphMarginWidth, this._domNode = wt(document.createElement("div")), this._domNode.setClassName(hg.OUTER_CLASS_NAME), this._domNode.setPosition("absolute"), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._glyphMarginBackgroundDomNode = wt(document.createElement("div")), this._glyphMarginBackgroundDomNode.setClassName(hg.CLASS_NAME), this._domNode.appendChild(this._glyphMarginBackgroundDomNode);
  }
  dispose() {
    super.dispose();
  }
  getDomNode() {
    return this._domNode;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, i = t.get(145);
    return this._canUseLayerHinting = !t.get(32), this._contentLeft = i.contentLeft, this._glyphMarginLeft = i.glyphMarginLeft, this._glyphMarginWidth = i.glyphMarginWidth, !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollTopChanged;
  }
  prepareRender(e) {
  }
  render(e) {
    this._domNode.setLayerHinting(this._canUseLayerHinting), this._domNode.setContain("strict");
    const t = e.scrollTop - e.bigNumbersDelta;
    this._domNode.setTop(-t);
    const i = Math.min(e.scrollHeight, 1e6);
    this._domNode.setHeight(i), this._domNode.setWidth(this._contentLeft), this._glyphMarginBackgroundDomNode.setLeft(this._glyphMarginLeft), this._glyphMarginBackgroundDomNode.setWidth(this._glyphMarginWidth), this._glyphMarginBackgroundDomNode.setHeight(i);
  }
}
hg.CLASS_NAME = "glyph-margin", hg.OUTER_CLASS_NAME = "margin";
const nm = "monaco-mouse-cursor-text", e0 = new class {
  constructor() {
    this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._enabled = !0;
  }
  get enabled() {
    return this._enabled;
  }
  enable() {
    this._enabled = !0, this._onDidChange.fire();
  }
  disable() {
    this._enabled = !1, this._onDidChange.fire();
  }
}(), Dt = tt("keybindingService");
var qZ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, G4 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class $Z {
  constructor(e, t, i, s, o) {
    this._context = e, this.modelLineNumber = t, this.distanceToModelLineStart = i, this.widthOfHiddenLineTextBefore = s, this.distanceToModelLineEnd = o, this._visibleTextAreaBrand = void 0, this.startPosition = null, this.endPosition = null, this.visibleTextareaStart = null, this.visibleTextareaEnd = null, this._previousPresentation = null;
  }
  prepareRender(e) {
    const t = new W(this.modelLineNumber, this.distanceToModelLineStart + 1), i = new W(this.modelLineNumber, this._context.viewModel.model.getLineMaxColumn(this.modelLineNumber) - this.distanceToModelLineEnd);
    this.startPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(t), this.endPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(i), this.startPosition.lineNumber === this.endPosition.lineNumber ? (this.visibleTextareaStart = e.visibleRangeForPosition(this.startPosition), this.visibleTextareaEnd = e.visibleRangeForPosition(this.endPosition)) : (this.visibleTextareaStart = null, this.visibleTextareaEnd = null);
  }
  definePresentation(e) {
    return this._previousPresentation || (this._previousPresentation = e || { foreground: 1, italic: !1, bold: !1, underline: !1, strikethrough: !1 }), this._previousPresentation;
  }
}
const pD = tr;
let iI = class extends to {
  constructor(n, e, t, i, s) {
    super(n), this._keybindingService = i, this._instantiationService = s, this._primaryCursorPosition = new W(1, 1), this._primaryCursorVisibleRange = null, this._viewController = e, this._visibleRangeProvider = t, this._scrollLeft = 0, this._scrollTop = 0;
    const o = this._context.configuration.options, r = o.get(145);
    this._setAccessibilityOptions(o), this._contentLeft = r.contentLeft, this._contentWidth = r.contentWidth, this._contentHeight = r.height, this._fontInfo = o.get(50), this._lineHeight = o.get(67), this._emptySelectionClipboard = o.get(37), this._copyWithSyntaxHighlighting = o.get(25), this._visibleTextArea = null, this._selections = [new _e(1, 1, 1, 1)], this._modelSelections = [new _e(1, 1, 1, 1)], this._lastRenderPosition = null, this.textArea = wt(document.createElement("textarea")), fa.write(this.textArea, 7), this.textArea.setClassName(`inputarea ${nm}`), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
    const { tabSize: a } = this._context.viewModel.model.getOptions();
    this.textArea.domNode.style.tabSize = a * this._fontInfo.spaceWidth + "px", this.textArea.setAttribute("autocorrect", "off"), this.textArea.setAttribute("autocapitalize", "off"), this.textArea.setAttribute("autocomplete", "off"), this.textArea.setAttribute("spellcheck", "false"), this.textArea.setAttribute("aria-label", this._getAriaLabel(o)), this.textArea.setAttribute("aria-required", o.get(5) ? "true" : "false"), this.textArea.setAttribute("tabindex", String(o.get(124))), this.textArea.setAttribute("role", "textbox"), this.textArea.setAttribute("aria-roledescription", m(0, "editor")), this.textArea.setAttribute("aria-multiline", "true"), this.textArea.setAttribute("aria-autocomplete", o.get(91) ? "none" : "both"), this._ensureReadOnlyAttribute(), this.textAreaCover = wt(document.createElement("div")), this.textAreaCover.setPosition("absolute");
    const l = { getLineCount: () => this._context.viewModel.getLineCount(), getLineMaxColumn: (c) => this._context.viewModel.getLineMaxColumn(c), getValueInRange: (c, u) => this._context.viewModel.getValueInRange(c, u), getValueLengthInRange: (c, u) => this._context.viewModel.getValueLengthInRange(c, u), modifyPosition: (c, u) => this._context.viewModel.modifyPosition(c, u) }, d = { getDataToCopy: () => {
      const c = this._context.viewModel.getPlainTextToCopy(this._modelSelections, this._emptySelectionClipboard, Tn), u = this._context.viewModel.model.getEOL(), g = this._emptySelectionClipboard && this._modelSelections.length === 1 && this._modelSelections[0].isEmpty(), p = Array.isArray(c) ? c : null, f = Array.isArray(c) ? c.join(u) : c;
      let _, v = null;
      if (QE.forceCopyWithSyntaxHighlighting || this._copyWithSyntaxHighlighting && f.length < 65536) {
        const b = this._context.viewModel.getRichTextToCopy(this._modelSelections, this._emptySelectionClipboard);
        b && (_ = b.html, v = b.mode);
      }
      return { isFromEmptySelection: g, multicursorText: p, text: f, html: _, mode: v };
    }, getScreenReaderContent: () => {
      if (this._accessibilitySupport === 1) {
        const c = this._selections[0];
        if (Je && c.isEmpty()) {
          const g = c.getStartPosition();
          let p = this._getWordBeforePosition(g);
          if (p.length === 0 && (p = this._getCharacterBeforePosition(g)), p.length > 0) return new fn(p, p.length, p.length, D.fromPositions(g), 0);
        }
        if (Je && !c.isEmpty() && l.getValueLengthInRange(c, 0) < 500) {
          const g = l.getValueInRange(c, 0);
          return new fn(g, 0, g.length, c, 0);
        }
        if (_c && !c.isEmpty()) {
          const g = "vscode-placeholder";
          return new fn(g, 0, g.length, null, void 0);
        }
        return fn.EMPTY;
      }
      if (lO) {
        const c = this._selections[0];
        if (c.isEmpty()) {
          const u = c.getStartPosition(), [g, p] = this._getAndroidWordAtPosition(u);
          if (g.length > 0) return new fn(g, p, p, D.fromPositions(u), 0);
        }
        return fn.EMPTY;
      }
      return Ap.fromEditorSelection(l, this._selections[0], this._accessibilityPageSize, this._accessibilitySupport === 0);
    }, deduceModelPosition: (c, u, g) => this._context.viewModel.deduceModelPositionRelativeToViewPosition(c, u, g) }, h = this._register(new lZ(this.textArea.domNode));
    this._textAreaInput = this._register(this._instantiationService.createInstance(JE, d, h, Gs, { isAndroid: lO, isChrome: m1, isFirefox: tr, isSafari: _c })), this._register(this._textAreaInput.onKeyDown(((c) => {
      this._viewController.emitKeyDown(c);
    }))), this._register(this._textAreaInput.onKeyUp(((c) => {
      this._viewController.emitKeyUp(c);
    }))), this._register(this._textAreaInput.onPaste(((c) => {
      let u = !1, g = null, p = null;
      c.metadata && (u = this._emptySelectionClipboard && !!c.metadata.isFromEmptySelection, g = c.metadata.multicursorText !== void 0 ? c.metadata.multicursorText : null, p = c.metadata.mode), this._viewController.paste(c.text, u, g, p);
    }))), this._register(this._textAreaInput.onCut((() => {
      this._viewController.cut();
    }))), this._register(this._textAreaInput.onType(((c) => {
      c.replacePrevCharCnt || c.replaceNextCharCnt || c.positionDelta ? this._viewController.compositionType(c.text, c.replacePrevCharCnt, c.replaceNextCharCnt, c.positionDelta) : this._viewController.type(c.text);
    }))), this._register(this._textAreaInput.onSelectionChangeRequest(((c) => {
      this._viewController.setSelection(c);
    }))), this._register(this._textAreaInput.onCompositionStart(((c) => {
      const u = this.textArea.domNode, g = this._modelSelections[0], { distanceToModelLineStart: p, widthOfHiddenTextBefore: f } = (() => {
        const v = u.value.substring(0, Math.min(u.selectionStart, u.selectionEnd)), b = v.lastIndexOf(`
`), C = v.substring(b + 1), w = C.lastIndexOf("	"), y = C.length - w - 1, L = g.getStartPosition(), k = Math.min(L.column - 1, y), N = L.column - 1 - k, A = C.substring(0, C.length - k), { tabSize: B } = this._context.viewModel.model.getOptions(), T = (function(O, H, $, pe) {
          if (H.length === 0) return 0;
          const me = O.createElement("div");
          me.style.position = "absolute", me.style.top = "-50000px", me.style.width = "50000px";
          const ue = O.createElement("span");
          yn(ue, $), ue.style.whiteSpace = "pre", ue.style.tabSize = pe * $.spaceWidth + "px", ue.append(H), me.appendChild(ue), O.body.appendChild(me);
          const ee = ue.offsetWidth;
          return O.body.removeChild(me), ee;
        })(this.textArea.domNode.ownerDocument, A, this._fontInfo, B);
        return { distanceToModelLineStart: N, widthOfHiddenTextBefore: T };
      })(), { distanceToModelLineEnd: _ } = (() => {
        const v = u.value.substring(Math.max(u.selectionStart, u.selectionEnd)), b = v.indexOf(`
`), C = b === -1 ? v : v.substring(0, b), w = C.indexOf("	"), y = w === -1 ? C.length : C.length - w - 1, L = g.getEndPosition(), k = Math.min(this._context.viewModel.model.getLineMaxColumn(L.lineNumber) - L.column, y);
        return { distanceToModelLineEnd: this._context.viewModel.model.getLineMaxColumn(L.lineNumber) - L.column - k };
      })();
      this._context.viewModel.revealRange("keyboard", !0, D.fromPositions(this._selections[0].getStartPosition()), 0, 1), this._visibleTextArea = new $Z(this._context, g.startLineNumber, p, f, _), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off"), this._visibleTextArea.prepareRender(this._visibleRangeProvider), this._render(), this.textArea.setClassName(`inputarea ${nm} ime-input`), this._viewController.compositionStart(), this._context.viewModel.onCompositionStart();
    }))), this._register(this._textAreaInput.onCompositionUpdate(((c) => {
      this._visibleTextArea && (this._visibleTextArea.prepareRender(this._visibleRangeProvider), this._render());
    }))), this._register(this._textAreaInput.onCompositionEnd((() => {
      this._visibleTextArea = null, this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off"), this._render(), this.textArea.setClassName(`inputarea ${nm}`), this._viewController.compositionEnd(), this._context.viewModel.onCompositionEnd();
    }))), this._register(this._textAreaInput.onFocus((() => {
      this._context.viewModel.setHasFocus(!0);
    }))), this._register(this._textAreaInput.onBlur((() => {
      this._context.viewModel.setHasFocus(!1);
    }))), this._register(e0.onDidChange((() => {
      this._ensureReadOnlyAttribute();
    })));
  }
  writeScreenReaderContent(n) {
    this._textAreaInput.writeNativeTextAreaContent(n);
  }
  dispose() {
    super.dispose();
  }
  _getAndroidWordAtPosition(n) {
    const e = this._context.viewModel.getLineContent(n.lineNumber), t = zo('`~!@#$%^&*()-=+[{]}\\|;:",.<>/?', []);
    let i = !0, s = n.column, o = !0, r = n.column, a = 0;
    for (; a < 50 && (i || o); ) {
      if (i && s <= 1 && (i = !1), i) {
        const l = e.charCodeAt(s - 2);
        t.get(l) !== 0 ? i = !1 : s--;
      }
      if (o && r > e.length && (o = !1), o) {
        const l = e.charCodeAt(r - 1);
        t.get(l) !== 0 ? o = !1 : r++;
      }
      a++;
    }
    return [e.substring(s - 1, r - 1), n.column - s];
  }
  _getWordBeforePosition(n) {
    const e = this._context.viewModel.getLineContent(n.lineNumber), t = zo(this._context.configuration.options.get(131), []);
    let i = n.column, s = 0;
    for (; i > 1; ) {
      const o = e.charCodeAt(i - 2);
      if (t.get(o) !== 0 || s > 50) return e.substring(i - 1, n.column - 1);
      s++, i--;
    }
    return e.substring(0, n.column - 1);
  }
  _getCharacterBeforePosition(n) {
    if (n.column > 1) {
      const e = this._context.viewModel.getLineContent(n.lineNumber).charAt(n.column - 2);
      if (!en(e.charCodeAt(0))) return e;
    }
    return "";
  }
  _getAriaLabel(n) {
    var e, t, i;
    if (n.get(2) === 1) {
      const s = (e = this._keybindingService.lookupKeybinding("editor.action.toggleScreenReaderAccessibilityMode")) === null || e === void 0 ? void 0 : e.getAriaLabel(), o = (t = this._keybindingService.lookupKeybinding("workbench.action.showCommands")) === null || t === void 0 ? void 0 : t.getAriaLabel(), r = (i = this._keybindingService.lookupKeybinding("workbench.action.openGlobalKeybindings")) === null || i === void 0 ? void 0 : i.getAriaLabel(), a = m(0, "The editor is not accessible at this time.");
      return s ? m(0, "{0} To enable screen reader optimized mode, use {1}", a, s) : o ? m(0, "{0} To enable screen reader optimized mode, open the quick pick with {1} and run the command Toggle Screen Reader Accessibility Mode, which is currently not triggerable via keyboard.", a, o) : r ? m(0, "{0} Please assign a keybinding for the command Toggle Screen Reader Accessibility Mode by accessing the keybindings editor with {1} and run it.", a, r) : a;
    }
    return n.get(4);
  }
  _setAccessibilityOptions(n) {
    this._accessibilitySupport = n.get(2);
    const e = n.get(3);
    this._accessibilitySupport === 2 && e === ta.accessibilityPageSize.defaultValue ? this._accessibilityPageSize = 500 : this._accessibilityPageSize = e;
    const t = n.get(145).wrappingColumn;
    if (t !== -1 && this._accessibilitySupport !== 1) {
      const i = n.get(50);
      this._textAreaWrapping = !0, this._textAreaWidth = Math.round(t * i.typicalHalfwidthCharacterWidth);
    } else this._textAreaWrapping = !1, this._textAreaWidth = pD ? 0 : 1;
  }
  onConfigurationChanged(n) {
    const e = this._context.configuration.options, t = e.get(145);
    this._setAccessibilityOptions(e), this._contentLeft = t.contentLeft, this._contentWidth = t.contentWidth, this._contentHeight = t.height, this._fontInfo = e.get(50), this._lineHeight = e.get(67), this._emptySelectionClipboard = e.get(37), this._copyWithSyntaxHighlighting = e.get(25), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
    const { tabSize: i } = this._context.viewModel.model.getOptions();
    return this.textArea.domNode.style.tabSize = i * this._fontInfo.spaceWidth + "px", this.textArea.setAttribute("aria-label", this._getAriaLabel(e)), this.textArea.setAttribute("aria-required", e.get(5) ? "true" : "false"), this.textArea.setAttribute("tabindex", String(e.get(124))), (n.hasChanged(34) || n.hasChanged(91)) && this._ensureReadOnlyAttribute(), n.hasChanged(2) && this._textAreaInput.writeNativeTextAreaContent("strategy changed"), !0;
  }
  onCursorStateChanged(n) {
    return this._selections = n.selections.slice(0), this._modelSelections = n.modelSelections.slice(0), this._textAreaInput.writeNativeTextAreaContent("selection changed"), !0;
  }
  onDecorationsChanged(n) {
    return !0;
  }
  onFlushed(n) {
    return !0;
  }
  onLinesChanged(n) {
    return !0;
  }
  onLinesDeleted(n) {
    return !0;
  }
  onLinesInserted(n) {
    return !0;
  }
  onScrollChanged(n) {
    return this._scrollLeft = n.scrollLeft, this._scrollTop = n.scrollTop, !0;
  }
  onZonesChanged(n) {
    return !0;
  }
  isFocused() {
    return this._textAreaInput.isFocused();
  }
  focusTextArea() {
    this._textAreaInput.focusTextArea();
  }
  getLastRenderData() {
    return this._lastRenderPosition;
  }
  setAriaOptions(n) {
    n.activeDescendant ? (this.textArea.setAttribute("aria-haspopup", "true"), this.textArea.setAttribute("aria-autocomplete", "list"), this.textArea.setAttribute("aria-activedescendant", n.activeDescendant)) : (this.textArea.setAttribute("aria-haspopup", "false"), this.textArea.setAttribute("aria-autocomplete", "both"), this.textArea.removeAttribute("aria-activedescendant")), n.role && this.textArea.setAttribute("role", n.role);
  }
  _ensureReadOnlyAttribute() {
    const n = this._context.configuration.options;
    !e0.enabled || n.get(34) && n.get(91) ? this.textArea.setAttribute("readonly", "true") : this.textArea.removeAttribute("readonly");
  }
  prepareRender(n) {
    var e;
    this._primaryCursorPosition = new W(this._selections[0].positionLineNumber, this._selections[0].positionColumn), this._primaryCursorVisibleRange = n.visibleRangeForPosition(this._primaryCursorPosition), (e = this._visibleTextArea) === null || e === void 0 || e.prepareRender(n);
  }
  render(n) {
    this._textAreaInput.writeNativeTextAreaContent("render"), this._render();
  }
  _render() {
    var n;
    if (this._visibleTextArea) {
      const i = this._visibleTextArea.visibleTextareaStart, s = this._visibleTextArea.visibleTextareaEnd, o = this._visibleTextArea.startPosition, r = this._visibleTextArea.endPosition;
      if (o && r && i && s && s.left >= this._scrollLeft && i.left <= this._scrollLeft + this._contentWidth) {
        const a = this._context.viewLayout.getVerticalOffsetForLineNumber(this._primaryCursorPosition.lineNumber) - this._scrollTop, l = this._newlinecount(this.textArea.domNode.value.substr(0, this.textArea.domNode.selectionStart));
        let d = this._visibleTextArea.widthOfHiddenLineTextBefore, h = this._contentLeft + i.left - this._scrollLeft, c = s.left - i.left + 1;
        if (h < this._contentLeft) {
          const _ = this._contentLeft - h;
          h += _, d += _, c -= _;
        }
        c > this._contentWidth && (c = this._contentWidth);
        const u = this._context.viewModel.getViewLineData(o.lineNumber), g = u.tokens.findTokenIndexAtOffset(o.column - 1), p = g === u.tokens.findTokenIndexAtOffset(r.column - 1), f = this._visibleTextArea.definePresentation(p ? u.tokens.getPresentation(g) : null);
        this.textArea.domNode.scrollTop = l * this._lineHeight, this.textArea.domNode.scrollLeft = d, this._doRender({ lastRenderPosition: null, top: a, left: h, width: c, height: this._lineHeight, useCover: !1, color: (ci.getColorMap() || [])[f.foreground], italic: f.italic, bold: f.bold, underline: f.underline, strikethrough: f.strikethrough });
      }
      return;
    }
    if (!this._primaryCursorVisibleRange) return void this._renderAtTopLeft();
    const e = this._contentLeft + this._primaryCursorVisibleRange.left - this._scrollLeft;
    if (e < this._contentLeft || e > this._contentLeft + this._contentWidth) return void this._renderAtTopLeft();
    const t = this._context.viewLayout.getVerticalOffsetForLineNumber(this._selections[0].positionLineNumber) - this._scrollTop;
    if (t < 0 || t > this._contentHeight) this._renderAtTopLeft();
    else if (Je || this._accessibilitySupport === 2) {
      this._doRender({ lastRenderPosition: this._primaryCursorPosition, top: t, left: this._textAreaWrapping ? this._contentLeft : e, width: this._textAreaWidth, height: this._lineHeight, useCover: !1 }), this.textArea.domNode.scrollLeft = this._primaryCursorVisibleRange.left;
      const i = (n = this._textAreaInput.textAreaState.newlineCountBeforeSelection) !== null && n !== void 0 ? n : this._newlinecount(this.textArea.domNode.value.substr(0, this.textArea.domNode.selectionStart));
      this.textArea.domNode.scrollTop = i * this._lineHeight;
    } else this._doRender({ lastRenderPosition: this._primaryCursorPosition, top: t, left: this._textAreaWrapping ? this._contentLeft : e, width: this._textAreaWidth, height: pD ? 0 : 1, useCover: !1 });
  }
  _newlinecount(n) {
    let e = 0, t = -1;
    for (; t = n.indexOf(`
`, t + 1), t !== -1; )
      e++;
    return e;
  }
  _renderAtTopLeft() {
    this._doRender({ lastRenderPosition: null, top: 0, left: 0, width: this._textAreaWidth, height: pD ? 0 : 1, useCover: !0 });
  }
  _doRender(n) {
    this._lastRenderPosition = n.lastRenderPosition;
    const e = this.textArea, t = this.textAreaCover;
    yn(e, this._fontInfo), e.setTop(n.top), e.setLeft(n.left), e.setWidth(n.width), e.setHeight(n.height), e.setColor(n.color ? z.Format.CSS.formatHex(n.color) : ""), e.setFontStyle(n.italic ? "italic" : ""), n.bold && e.setFontWeight("bold"), e.setTextDecoration(`${n.underline ? " underline" : ""}${n.strikethrough ? " line-through" : ""}`), t.setTop(n.useCover ? n.top : 0), t.setLeft(n.useCover ? n.left : 0), t.setWidth(n.useCover ? n.width : 0), t.setHeight(n.useCover ? n.height : 0);
    const i = this._context.configuration.options;
    i.get(57) ? t.setClassName("monaco-editor-background textAreaCover " + hg.OUTER_CLASS_NAME) : i.get(68).renderType !== 0 ? t.setClassName("monaco-editor-background textAreaCover " + D1.CLASS_NAME) : t.setClassName("monaco-editor-background textAreaCover");
  }
};
function UR(n, e, t) {
  let i = Jn(n);
  return i === -1 && (i = n.length), (function(s, o, r) {
    let a = 0;
    for (let d = 0; d < s.length; d++) s.charAt(d) === "	" ? a = Gi.nextIndentTabStop(a, o) : a++;
    let l = "";
    if (!r) {
      const d = Math.floor(a / o);
      a %= o;
      for (let h = 0; h < d; h++) l += "	";
    }
    for (let d = 0; d < a; d++) l += " ";
    return l;
  })(n.substring(0, i), e, t) + n.substring(i);
}
iI = qZ([G4(3, Dt), G4(4, Se)], iI);
const GZ = () => !0, ZZ = () => !1, YZ = (n) => n === " " || n === "	";
class jg {
  static shouldRecreate(e) {
    return e.hasChanged(145) || e.hasChanged(131) || e.hasChanged(37) || e.hasChanged(77) || e.hasChanged(79) || e.hasChanged(80) || e.hasChanged(6) || e.hasChanged(7) || e.hasChanged(11) || e.hasChanged(9) || e.hasChanged(10) || e.hasChanged(14) || e.hasChanged(128) || e.hasChanged(50) || e.hasChanged(91) || e.hasChanged(130);
  }
  constructor(e, t, i, s) {
    var o;
    this.languageConfigurationService = s, this._cursorMoveConfigurationBrand = void 0, this._languageId = e;
    const r = i.options, a = r.get(145), l = r.get(50);
    this.readOnly = r.get(91), this.tabSize = t.tabSize, this.indentSize = t.indentSize, this.insertSpaces = t.insertSpaces, this.stickyTabStops = r.get(116), this.lineHeight = l.lineHeight, this.typicalHalfwidthCharacterWidth = l.typicalHalfwidthCharacterWidth, this.pageSize = Math.max(1, Math.floor(a.height / this.lineHeight) - 2), this.useTabStops = r.get(128), this.wordSeparators = r.get(131), this.emptySelectionClipboard = r.get(37), this.copyWithSyntaxHighlighting = r.get(25), this.multiCursorMergeOverlapping = r.get(77), this.multiCursorPaste = r.get(79), this.multiCursorLimit = r.get(80), this.autoClosingBrackets = r.get(6), this.autoClosingComments = r.get(7), this.autoClosingQuotes = r.get(11), this.autoClosingDelete = r.get(9), this.autoClosingOvertype = r.get(10), this.autoSurround = r.get(14), this.autoIndent = r.get(12), this.wordSegmenterLocales = r.get(130), this.surroundingPairs = {}, this._electricChars = null, this.shouldAutoCloseBefore = { quote: this._getShouldAutoClose(e, this.autoClosingQuotes, !0), comment: this._getShouldAutoClose(e, this.autoClosingComments, !1), bracket: this._getShouldAutoClose(e, this.autoClosingBrackets, !1) }, this.autoClosingPairs = this.languageConfigurationService.getLanguageConfiguration(e).getAutoClosingPairs();
    const d = this.languageConfigurationService.getLanguageConfiguration(e).getSurroundingPairs();
    if (d) for (const c of d) this.surroundingPairs[c.open] = c.close;
    const h = this.languageConfigurationService.getLanguageConfiguration(e).comments;
    this.blockCommentStartToken = (o = h?.blockCommentStartToken) !== null && o !== void 0 ? o : null;
  }
  get electricChars() {
    var e;
    if (!this._electricChars) {
      this._electricChars = {};
      const t = (e = this.languageConfigurationService.getLanguageConfiguration(this._languageId).electricCharacter) === null || e === void 0 ? void 0 : e.getElectricCharacters();
      if (t) for (const i of t) this._electricChars[i] = !0;
    }
    return this._electricChars;
  }
  onElectricCharacter(e, t, i) {
    const s = $w(t, i - 1), o = this.languageConfigurationService.getLanguageConfiguration(s.languageId).electricCharacter;
    return o ? o.onElectricCharacter(e, s, i - s.firstCharOffset) : null;
  }
  normalizeIndentation(e) {
    return UR(e, this.indentSize, this.insertSpaces);
  }
  _getShouldAutoClose(e, t, i) {
    switch (t) {
      case "beforeWhitespace":
        return YZ;
      case "languageDefined":
        return this._getLanguageDefinedShouldAutoClose(e, i);
      case "always":
        return GZ;
      case "never":
        return ZZ;
    }
  }
  _getLanguageDefinedShouldAutoClose(e, t) {
    const i = this.languageConfigurationService.getLanguageConfiguration(e).getAutoCloseBeforeSet(t);
    return (s) => i.indexOf(s) !== -1;
  }
  visibleColumnFromColumn(e, t) {
    return Gi.visibleColumnFromColumn(e.getLineContent(t.lineNumber), t.column, this.tabSize);
  }
  columnFromVisibleColumn(e, t, i) {
    const s = Gi.columnFromVisibleColumn(e.getLineContent(t), i, this.tabSize), o = e.getLineMinColumn(t);
    if (s < o) return o;
    const r = e.getLineMaxColumn(t);
    return s > r ? r : s;
  }
}
let pt = class OB {
  static fromModelState(e) {
    return new XZ(e);
  }
  static fromViewState(e) {
    return new QZ(e);
  }
  static fromModelSelection(e) {
    const t = _e.liftSelection(e), i = new bn(D.fromPositions(t.getSelectionStart()), 0, 0, t.getPosition(), 0);
    return OB.fromModelState(i);
  }
  static fromModelSelections(e) {
    const t = [];
    for (let i = 0, s = e.length; i < s; i++) t[i] = this.fromModelSelection(e[i]);
    return t;
  }
  constructor(e, t) {
    this._cursorStateBrand = void 0, this.modelState = e, this.viewState = t;
  }
  equals(e) {
    return this.viewState.equals(e.viewState) && this.modelState.equals(e.modelState);
  }
};
class XZ {
  constructor(e) {
    this.modelState = e, this.viewState = null;
  }
}
class QZ {
  constructor(e) {
    this.modelState = null, this.viewState = e;
  }
}
class bn {
  constructor(e, t, i, s, o) {
    this.selectionStart = e, this.selectionStartKind = t, this.selectionStartLeftoverVisibleColumns = i, this.position = s, this.leftoverVisibleColumns = o, this._singleCursorStateBrand = void 0, this.selection = bn._computeSelection(this.selectionStart, this.position);
  }
  equals(e) {
    return this.selectionStartLeftoverVisibleColumns === e.selectionStartLeftoverVisibleColumns && this.leftoverVisibleColumns === e.leftoverVisibleColumns && this.selectionStartKind === e.selectionStartKind && this.position.equals(e.position) && this.selectionStart.equalsRange(e.selectionStart);
  }
  hasSelection() {
    return !this.selection.isEmpty() || !this.selectionStart.isEmpty();
  }
  move(e, t, i, s) {
    return e ? new bn(this.selectionStart, this.selectionStartKind, this.selectionStartLeftoverVisibleColumns, new W(t, i), s) : new bn(new D(t, i, t, i), 0, s, new W(t, i), s);
  }
  static _computeSelection(e, t) {
    return e.isEmpty() || !t.isBeforeOrEqual(e.getStartPosition()) ? _e.fromPositions(e.getStartPosition(), t) : _e.fromPositions(e.getEndPosition(), t);
  }
}
class Ls {
  constructor(e, t, i) {
    this._editOperationResultBrand = void 0, this.type = e, this.commands = t, this.shouldPushStackElementBefore = i.shouldPushStackElementBefore, this.shouldPushStackElementAfter = i.shouldPushStackElementAfter;
  }
}
function oh(n) {
  return n === "'" || n === '"' || n === "`";
}
class bu {
  static columnSelect(e, t, i, s, o, r) {
    const a = Math.abs(o - i) + 1, l = i > o, d = s > r, h = s < r, c = [];
    for (let u = 0; u < a; u++) {
      const g = i + (l ? -u : u), p = e.columnFromVisibleColumn(t, g, s), f = e.columnFromVisibleColumn(t, g, r), _ = e.visibleColumnFromColumn(t, new W(g, p)), v = e.visibleColumnFromColumn(t, new W(g, f));
      h && (_ > r || v < s) || d && (v > s || _ < r) || c.push(new bn(new D(g, p, g, p), 0, 0, new W(g, f), 0));
    }
    if (c.length === 0) for (let u = 0; u < a; u++) {
      const g = i + (l ? -u : u), p = t.getLineMaxColumn(g);
      c.push(new bn(new D(g, p, g, p), 0, 0, new W(g, p), 0));
    }
    return { viewStates: c, reversed: l, fromLineNumber: i, fromVisualColumn: s, toLineNumber: o, toVisualColumn: r };
  }
  static columnSelectLeft(e, t, i) {
    let s = i.toViewVisualColumn;
    return s > 0 && s--, bu.columnSelect(e, t, i.fromViewLineNumber, i.fromViewVisualColumn, i.toViewLineNumber, s);
  }
  static columnSelectRight(e, t, i) {
    let s = 0;
    const o = Math.min(i.fromViewLineNumber, i.toViewLineNumber), r = Math.max(i.fromViewLineNumber, i.toViewLineNumber);
    for (let l = o; l <= r; l++) {
      const d = t.getLineMaxColumn(l), h = e.visibleColumnFromColumn(t, new W(l, d));
      s = Math.max(s, h);
    }
    let a = i.toViewVisualColumn;
    return a < s && a++, this.columnSelect(e, t, i.fromViewLineNumber, i.fromViewVisualColumn, i.toViewLineNumber, a);
  }
  static columnSelectUp(e, t, i, s) {
    const o = s ? e.pageSize : 1, r = Math.max(1, i.toViewLineNumber - o);
    return this.columnSelect(e, t, i.fromViewLineNumber, i.fromViewVisualColumn, r, i.toViewVisualColumn);
  }
  static columnSelectDown(e, t, i, s) {
    const o = s ? e.pageSize : 1, r = Math.min(t.getLineCount(), i.toViewLineNumber + o);
    return this.columnSelect(e, t, i.fromViewLineNumber, i.fromViewVisualColumn, r, i.toViewVisualColumn);
  }
}
class Dn {
  constructor(e, t, i = !1) {
    this._range = e, this._text = t, this.insertsAutoWhitespace = i;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return _e.fromPositions(i.getEndPosition());
  }
}
class JZ {
  constructor(e, t) {
    this._range = e, this._text = t;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return _e.fromRange(i, 0);
  }
}
class pb {
  constructor(e, t, i = !1) {
    this._range = e, this._text = t, this.insertsAutoWhitespace = i;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return _e.fromPositions(i.getStartPosition());
  }
}
class FC {
  constructor(e, t, i, s, o = !1) {
    this._range = e, this._text = t, this._columnDeltaOffset = s, this._lineNumberDeltaOffset = i, this.insertsAutoWhitespace = o;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return _e.fromPositions(i.getEndPosition().delta(this._lineNumberDeltaOffset, this._columnDeltaOffset));
  }
}
class KR {
  constructor(e, t, i, s = !1) {
    this._range = e, this._text = t, this._initialSelection = i, this._forceMoveMarkers = s, this._selectionId = null;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text, this._forceMoveMarkers), this._selectionId = t.trackSelection(this._initialSelection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._selectionId);
  }
}
class mD {
  constructor(e, t, i) {
    this._cursorPositionBrand = void 0, this.lineNumber = e, this.column = t, this.leftoverVisibleColumns = i;
  }
}
class St {
  static leftPosition(e, t) {
    if (t.column > e.getLineMinColumn(t.lineNumber)) return t.delta(void 0, -J7(e.getLineContent(t.lineNumber), t.column - 1));
    if (t.lineNumber > 1) {
      const i = t.lineNumber - 1;
      return new W(i, e.getLineMaxColumn(i));
    }
    return t;
  }
  static leftPositionAtomicSoftTabs(e, t, i) {
    if (t.column <= e.getLineIndentColumn(t.lineNumber)) {
      const s = e.getLineMinColumn(t.lineNumber), o = e.getLineContent(t.lineNumber), r = gv.atomicPosition(o, t.column - 1, i, 0);
      if (r !== -1 && r + 1 >= s) return new W(t.lineNumber, r + 1);
    }
    return this.leftPosition(e, t);
  }
  static left(e, t, i) {
    const s = e.stickyTabStops ? St.leftPositionAtomicSoftTabs(t, i, e.tabSize) : St.leftPosition(t, i);
    return new mD(s.lineNumber, s.column, 0);
  }
  static moveLeft(e, t, i, s, o) {
    let r, a;
    if (i.hasSelection() && !s) r = i.selection.startLineNumber, a = i.selection.startColumn;
    else {
      const l = i.position.delta(void 0, -(o - 1)), d = t.normalizePosition(St.clipPositionColumn(l, t), 0), h = St.left(e, t, d);
      r = h.lineNumber, a = h.column;
    }
    return i.move(s, r, a, 0);
  }
  static clipPositionColumn(e, t) {
    return new W(e.lineNumber, St.clipRange(e.column, t.getLineMinColumn(e.lineNumber), t.getLineMaxColumn(e.lineNumber)));
  }
  static clipRange(e, t, i) {
    return e < t ? t : e > i ? i : e;
  }
  static rightPosition(e, t, i) {
    return i < e.getLineMaxColumn(t) ? i += rR(e.getLineContent(t), i - 1) : t < e.getLineCount() && (t += 1, i = e.getLineMinColumn(t)), new W(t, i);
  }
  static rightPositionAtomicSoftTabs(e, t, i, s, o) {
    if (i < e.getLineIndentColumn(t)) {
      const r = e.getLineContent(t), a = gv.atomicPosition(r, i - 1, s, 1);
      if (a !== -1) return new W(t, a + 1);
    }
    return this.rightPosition(e, t, i);
  }
  static right(e, t, i) {
    const s = e.stickyTabStops ? St.rightPositionAtomicSoftTabs(t, i.lineNumber, i.column, e.tabSize, e.indentSize) : St.rightPosition(t, i.lineNumber, i.column);
    return new mD(s.lineNumber, s.column, 0);
  }
  static moveRight(e, t, i, s, o) {
    let r, a;
    if (i.hasSelection() && !s) r = i.selection.endLineNumber, a = i.selection.endColumn;
    else {
      const l = i.position.delta(void 0, o - 1), d = t.normalizePosition(St.clipPositionColumn(l, t), 1), h = St.right(e, t, d);
      r = h.lineNumber, a = h.column;
    }
    return i.move(s, r, a, 0);
  }
  static vertical(e, t, i, s, o, r, a, l) {
    const d = Gi.visibleColumnFromColumn(t.getLineContent(i), s, e.tabSize) + o, h = t.getLineCount(), c = i === 1 && s === 1, u = i === h && s === t.getLineMaxColumn(i), g = r < i ? c : u;
    if ((i = r) < 1 ? (i = 1, s = a ? t.getLineMinColumn(i) : Math.min(t.getLineMaxColumn(i), s)) : i > h ? (i = h, s = a ? t.getLineMaxColumn(i) : Math.min(t.getLineMaxColumn(i), s)) : s = e.columnFromVisibleColumn(t, i, d), o = g ? 0 : d - Gi.visibleColumnFromColumn(t.getLineContent(i), s, e.tabSize), l !== void 0) {
      const p = new W(i, s), f = t.normalizePosition(p, l);
      o += s - f.column, i = f.lineNumber, s = f.column;
    }
    return new mD(i, s, o);
  }
  static down(e, t, i, s, o, r, a) {
    return this.vertical(e, t, i, s, o, i + r, a, 4);
  }
  static moveDown(e, t, i, s, o) {
    let r, a;
    i.hasSelection() && !s ? (r = i.selection.endLineNumber, a = i.selection.endColumn) : (r = i.position.lineNumber, a = i.position.column);
    let l, d = 0;
    do
      if (l = St.down(e, t, r + d, a, i.leftoverVisibleColumns, o, !0), t.normalizePosition(new W(l.lineNumber, l.column), 2).lineNumber > r) break;
    while (d++ < 10 && r + d < t.getLineCount());
    return i.move(s, l.lineNumber, l.column, l.leftoverVisibleColumns);
  }
  static translateDown(e, t, i) {
    const s = i.selection, o = St.down(e, t, s.selectionStartLineNumber, s.selectionStartColumn, i.selectionStartLeftoverVisibleColumns, 1, !1), r = St.down(e, t, s.positionLineNumber, s.positionColumn, i.leftoverVisibleColumns, 1, !1);
    return new bn(new D(o.lineNumber, o.column, o.lineNumber, o.column), 0, o.leftoverVisibleColumns, new W(r.lineNumber, r.column), r.leftoverVisibleColumns);
  }
  static up(e, t, i, s, o, r, a) {
    return this.vertical(e, t, i, s, o, i - r, a, 3);
  }
  static moveUp(e, t, i, s, o) {
    let r, a;
    i.hasSelection() && !s ? (r = i.selection.startLineNumber, a = i.selection.startColumn) : (r = i.position.lineNumber, a = i.position.column);
    const l = St.up(e, t, r, a, i.leftoverVisibleColumns, o, !0);
    return i.move(s, l.lineNumber, l.column, l.leftoverVisibleColumns);
  }
  static translateUp(e, t, i) {
    const s = i.selection, o = St.up(e, t, s.selectionStartLineNumber, s.selectionStartColumn, i.selectionStartLeftoverVisibleColumns, 1, !1), r = St.up(e, t, s.positionLineNumber, s.positionColumn, i.leftoverVisibleColumns, 1, !1);
    return new bn(new D(o.lineNumber, o.column, o.lineNumber, o.column), 0, o.leftoverVisibleColumns, new W(r.lineNumber, r.column), r.leftoverVisibleColumns);
  }
  static _isBlankLine(e, t) {
    return e.getLineFirstNonWhitespaceColumn(t) === 0;
  }
  static moveToPrevBlankLine(e, t, i, s) {
    let o = i.position.lineNumber;
    for (; o > 1 && this._isBlankLine(t, o); ) o--;
    for (; o > 1 && !this._isBlankLine(t, o); ) o--;
    return i.move(s, o, t.getLineMinColumn(o), 0);
  }
  static moveToNextBlankLine(e, t, i, s) {
    const o = t.getLineCount();
    let r = i.position.lineNumber;
    for (; r < o && this._isBlankLine(t, r); ) r++;
    for (; r < o && !this._isBlankLine(t, r); ) r++;
    return i.move(s, r, t.getLineMinColumn(r), 0);
  }
  static moveToBeginningOfLine(e, t, i, s) {
    const o = i.position.lineNumber, r = t.getLineMinColumn(o), a = t.getLineFirstNonWhitespaceColumn(o) || r;
    let l;
    return l = i.position.column === a ? r : a, i.move(s, o, l, 0);
  }
  static moveToEndOfLine(e, t, i, s, o) {
    const r = i.position.lineNumber, a = t.getLineMaxColumn(r);
    return i.move(s, r, a, o ? 1073741824 - a : 0);
  }
  static moveToBeginningOfBuffer(e, t, i, s) {
    return i.move(s, 1, 1, 0);
  }
  static moveToEndOfBuffer(e, t, i, s) {
    const o = t.getLineCount(), r = t.getLineMaxColumn(o);
    return i.move(s, o, r, 0);
  }
}
class cg {
  static deleteRight(e, t, i, s) {
    const o = [];
    let r = e !== 3;
    for (let a = 0, l = s.length; a < l; a++) {
      const d = s[a];
      let h = d;
      if (h.isEmpty()) {
        const c = d.getPosition(), u = St.right(t, i, c);
        h = new D(u.lineNumber, u.column, c.lineNumber, c.column);
      }
      h.isEmpty() ? o[a] = null : (h.startLineNumber !== h.endLineNumber && (r = !0), o[a] = new Dn(h, ""));
    }
    return [r, o];
  }
  static isAutoClosingPairDelete(e, t, i, s, o, r, a) {
    if (t === "never" && i === "never" || e === "never") return !1;
    for (let l = 0, d = r.length; l < d; l++) {
      const h = r[l], c = h.getPosition();
      if (!h.isEmpty()) return !1;
      const u = o.getLineContent(c.lineNumber);
      if (c.column < 2 || c.column >= u.length + 1) return !1;
      const g = u.charAt(c.column - 2), p = s.get(g);
      if (!p) return !1;
      if (oh(g)) {
        if (i === "never") return !1;
      } else if (t === "never") return !1;
      const f = u.charAt(c.column - 1);
      let _ = !1;
      for (const v of p) v.open === g && v.close === f && (_ = !0);
      if (!_) return !1;
      if (e === "auto") {
        let v = !1;
        for (let b = 0, C = a.length; b < C; b++) {
          const w = a[b];
          if (c.lineNumber === w.startLineNumber && c.column === w.startColumn) {
            v = !0;
            break;
          }
        }
        if (!v) return !1;
      }
    }
    return !0;
  }
  static _runAutoClosingPairDelete(e, t, i) {
    const s = [];
    for (let o = 0, r = i.length; o < r; o++) {
      const a = i[o].getPosition(), l = new D(a.lineNumber, a.column - 1, a.lineNumber, a.column + 1);
      s[o] = new Dn(l, "");
    }
    return [!0, s];
  }
  static deleteLeft(e, t, i, s, o) {
    if (this.isAutoClosingPairDelete(t.autoClosingDelete, t.autoClosingBrackets, t.autoClosingQuotes, t.autoClosingPairs.autoClosingPairsOpenByEnd, i, s, o)) return this._runAutoClosingPairDelete(t, i, s);
    const r = [];
    let a = e !== 2;
    for (let l = 0, d = s.length; l < d; l++) {
      const h = cg.getDeleteRange(s[l], i, t);
      h.isEmpty() ? r[l] = null : (h.startLineNumber !== h.endLineNumber && (a = !0), r[l] = new Dn(h, ""));
    }
    return [a, r];
  }
  static getDeleteRange(e, t, i) {
    if (!e.isEmpty()) return e;
    const s = e.getPosition();
    if (i.useTabStops && s.column > 1) {
      const o = t.getLineContent(s.lineNumber), r = Jn(o), a = r === -1 ? o.length + 1 : r + 1;
      if (s.column <= a) {
        const l = i.visibleColumnFromColumn(t, s), d = Gi.prevIndentTabStop(l, i.indentSize), h = i.columnFromVisibleColumn(t, s.lineNumber, d);
        return new D(s.lineNumber, h, s.lineNumber, s.column);
      }
    }
    return D.fromPositions(cg.getPositionAfterDeleteLeft(s, t), s);
  }
  static getPositionAfterDeleteLeft(e, t) {
    if (e.column > 1) {
      const i = xK(e.column - 1, t.getLineContent(e.lineNumber));
      return e.with(void 0, i + 1);
    }
    if (e.lineNumber > 1) {
      const i = e.lineNumber - 1;
      return new W(i, t.getLineMaxColumn(i));
    }
    return e;
  }
  static cut(e, t, i) {
    const s = [];
    let o = null;
    i.sort(((r, a) => W.compare(r.getStartPosition(), a.getEndPosition())));
    for (let r = 0, a = i.length; r < a; r++) {
      const l = i[r];
      if (l.isEmpty()) if (e.emptySelectionClipboard) {
        const d = l.getPosition();
        let h, c, u, g;
        d.lineNumber < t.getLineCount() ? (h = d.lineNumber, c = 1, u = d.lineNumber + 1, g = 1) : d.lineNumber > 1 && o?.endLineNumber !== d.lineNumber ? (h = d.lineNumber - 1, c = t.getLineMaxColumn(d.lineNumber - 1), u = d.lineNumber, g = t.getLineMaxColumn(d.lineNumber)) : (h = d.lineNumber, c = 1, u = d.lineNumber, g = t.getLineMaxColumn(d.lineNumber));
        const p = new D(h, c, u, g);
        o = p, p.isEmpty() ? s[r] = null : s[r] = new Dn(p, "");
      } else s[r] = null;
      else s[r] = new Dn(l, "");
    }
    return new Ls(0, s, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !0 });
  }
}
class Ct {
  static _createWord(e, t, i, s, o) {
    return { start: s, end: o, wordType: t, nextCharClass: i };
  }
  static _createIntlWord(e, t) {
    return { start: e.index, end: e.index + e.segment.length, wordType: 1, nextCharClass: t };
  }
  static _findPreviousWordOnLine(e, t, i) {
    const s = t.getLineContent(i.lineNumber);
    return this._doFindPreviousWordOnLine(s, e, i);
  }
  static _doFindPreviousWordOnLine(e, t, i) {
    let s = 0;
    const o = t.findPrevIntlWordBeforeOrAtOffset(e, i.column - 2);
    for (let r = i.column - 2; r >= 0; r--) {
      const a = e.charCodeAt(r), l = t.get(a);
      if (o && r === o.index) return this._createIntlWord(o, l);
      if (l === 0) {
        if (s === 2) return this._createWord(e, s, l, r + 1, this._findEndOfWord(e, t, s, r + 1));
        s = 1;
      } else if (l === 2) {
        if (s === 1) return this._createWord(e, s, l, r + 1, this._findEndOfWord(e, t, s, r + 1));
        s = 2;
      } else if (l === 1 && s !== 0) return this._createWord(e, s, l, r + 1, this._findEndOfWord(e, t, s, r + 1));
    }
    return s !== 0 ? this._createWord(e, s, 1, 0, this._findEndOfWord(e, t, s, 0)) : null;
  }
  static _findEndOfWord(e, t, i, s) {
    const o = t.findNextIntlWordAtOrAfterOffset(e, s), r = e.length;
    for (let a = s; a < r; a++) {
      const l = e.charCodeAt(a), d = t.get(l);
      if (o && a === o.index + o.segment.length || d === 1 || i === 1 && d === 2 || i === 2 && d === 0) return a;
    }
    return r;
  }
  static _findNextWordOnLine(e, t, i) {
    const s = t.getLineContent(i.lineNumber);
    return this._doFindNextWordOnLine(s, e, i);
  }
  static _doFindNextWordOnLine(e, t, i) {
    let s = 0;
    const o = e.length, r = t.findNextIntlWordAtOrAfterOffset(e, i.column - 1);
    for (let a = i.column - 1; a < o; a++) {
      const l = e.charCodeAt(a), d = t.get(l);
      if (r && a === r.index) return this._createIntlWord(r, d);
      if (d === 0) {
        if (s === 2) return this._createWord(e, s, d, this._findStartOfWord(e, t, s, a - 1), a);
        s = 1;
      } else if (d === 2) {
        if (s === 1) return this._createWord(e, s, d, this._findStartOfWord(e, t, s, a - 1), a);
        s = 2;
      } else if (d === 1 && s !== 0) return this._createWord(e, s, d, this._findStartOfWord(e, t, s, a - 1), a);
    }
    return s !== 0 ? this._createWord(e, s, 1, this._findStartOfWord(e, t, s, o - 1), o) : null;
  }
  static _findStartOfWord(e, t, i, s) {
    const o = t.findPrevIntlWordBeforeOrAtOffset(e, s);
    for (let r = s; r >= 0; r--) {
      const a = e.charCodeAt(r), l = t.get(a);
      if (o && r === o.index) return r;
      if (l === 1 || i === 1 && l === 2 || i === 2 && l === 0) return r + 1;
    }
    return 0;
  }
  static moveWordLeft(e, t, i, s) {
    let o = i.lineNumber, r = i.column;
    r === 1 && o > 1 && (o -= 1, r = t.getLineMaxColumn(o));
    let a = Ct._findPreviousWordOnLine(e, t, new W(o, r));
    if (s === 0) return new W(o, a ? a.start + 1 : 1);
    if (s === 1) return a && a.wordType === 2 && a.end - a.start == 1 && a.nextCharClass === 0 && (a = Ct._findPreviousWordOnLine(e, t, new W(o, a.start + 1))), new W(o, a ? a.start + 1 : 1);
    if (s === 3) {
      for (; a && a.wordType === 2; ) a = Ct._findPreviousWordOnLine(e, t, new W(o, a.start + 1));
      return new W(o, a ? a.start + 1 : 1);
    }
    return a && r <= a.end + 1 && (a = Ct._findPreviousWordOnLine(e, t, new W(o, a.start + 1))), new W(o, a ? a.end + 1 : 1);
  }
  static _moveWordPartLeft(e, t) {
    const i = t.lineNumber, s = e.getLineMaxColumn(i);
    if (t.column === 1) return i > 1 ? new W(i - 1, e.getLineMaxColumn(i - 1)) : t;
    const o = e.getLineContent(i);
    for (let r = t.column - 1; r > 1; r--) {
      const a = o.charCodeAt(r - 2), l = o.charCodeAt(r - 1);
      if (a === 95 && l !== 95) return new W(i, r);
      if (a === 45 && l !== 45) return new W(i, r);
      if ((Nh(a) || Y1(a)) && Ba(l)) return new W(i, r);
      if (Ba(a) && Ba(l) && r + 1 < s) {
        const d = o.charCodeAt(r);
        if (Nh(d) || Y1(d)) return new W(i, r);
      }
    }
    return new W(i, 1);
  }
  static moveWordRight(e, t, i, s) {
    let o = i.lineNumber, r = i.column, a = !1;
    r === t.getLineMaxColumn(o) && o < t.getLineCount() && (a = !0, o += 1, r = 1);
    let l = Ct._findNextWordOnLine(e, t, new W(o, r));
    if (s === 2) l && l.wordType === 2 && l.end - l.start == 1 && l.nextCharClass === 0 && (l = Ct._findNextWordOnLine(e, t, new W(o, l.end + 1))), r = l ? l.end + 1 : t.getLineMaxColumn(o);
    else if (s === 3) {
      for (a && (r = 0); l && (l.wordType === 2 || l.start + 1 <= r); ) l = Ct._findNextWordOnLine(e, t, new W(o, l.end + 1));
      r = l ? l.start + 1 : t.getLineMaxColumn(o);
    } else l && !a && r >= l.start + 1 && (l = Ct._findNextWordOnLine(e, t, new W(o, l.end + 1))), r = l ? l.start + 1 : t.getLineMaxColumn(o);
    return new W(o, r);
  }
  static _moveWordPartRight(e, t) {
    const i = t.lineNumber, s = e.getLineMaxColumn(i);
    if (t.column === s) return i < e.getLineCount() ? new W(i + 1, 1) : t;
    const o = e.getLineContent(i);
    for (let r = t.column + 1; r < s; r++) {
      const a = o.charCodeAt(r - 2), l = o.charCodeAt(r - 1);
      if (a !== 95 && l === 95) return new W(i, r);
      if (a !== 45 && l === 45) return new W(i, r);
      if ((Nh(a) || Y1(a)) && Ba(l)) return new W(i, r);
      if (Ba(a) && Ba(l) && r + 1 < s) {
        const d = o.charCodeAt(r);
        if (Nh(d) || Y1(d)) return new W(i, r);
      }
    }
    return new W(i, s);
  }
  static _deleteWordLeftWhitespace(e, t) {
    const i = e.getLineContent(t.lineNumber), s = t.column - 2, o = oa(i, s);
    return o + 1 < s ? new D(t.lineNumber, o + 2, t.lineNumber, t.column) : null;
  }
  static deleteWordLeft(e, t) {
    const i = e.wordSeparators, s = e.model, o = e.selection, r = e.whitespaceHeuristics;
    if (!o.isEmpty()) return o;
    if (cg.isAutoClosingPairDelete(e.autoClosingDelete, e.autoClosingBrackets, e.autoClosingQuotes, e.autoClosingPairs.autoClosingPairsOpenByEnd, e.model, [e.selection], e.autoClosedCharacters)) {
      const c = e.selection.getPosition();
      return new D(c.lineNumber, c.column - 1, c.lineNumber, c.column + 1);
    }
    const a = new W(o.positionLineNumber, o.positionColumn);
    let l = a.lineNumber, d = a.column;
    if (l === 1 && d === 1) return null;
    if (r) {
      const c = this._deleteWordLeftWhitespace(s, a);
      if (c) return c;
    }
    let h = Ct._findPreviousWordOnLine(i, s, a);
    return t === 0 ? h ? d = h.start + 1 : d > 1 ? d = 1 : (l--, d = s.getLineMaxColumn(l)) : (h && d <= h.end + 1 && (h = Ct._findPreviousWordOnLine(i, s, new W(l, h.start + 1))), h ? d = h.end + 1 : d > 1 ? d = 1 : (l--, d = s.getLineMaxColumn(l))), new D(l, d, a.lineNumber, a.column);
  }
  static deleteInsideWord(e, t, i) {
    if (!i.isEmpty()) return i;
    const s = new W(i.positionLineNumber, i.positionColumn);
    return this._deleteInsideWordWhitespace(t, s) || this._deleteInsideWordDetermineDeleteRange(e, t, s);
  }
  static _charAtIsWhitespace(e, t) {
    const i = e.charCodeAt(t);
    return i === 32 || i === 9;
  }
  static _deleteInsideWordWhitespace(e, t) {
    const i = e.getLineContent(t.lineNumber), s = i.length;
    if (s === 0) return null;
    let o = Math.max(t.column - 2, 0);
    if (!this._charAtIsWhitespace(i, o)) return null;
    let r = Math.min(t.column - 1, s - 1);
    if (!this._charAtIsWhitespace(i, r)) return null;
    for (; o > 0 && this._charAtIsWhitespace(i, o - 1); ) o--;
    for (; r + 1 < s && this._charAtIsWhitespace(i, r + 1); ) r++;
    return new D(t.lineNumber, o + 1, t.lineNumber, r + 2);
  }
  static _deleteInsideWordDetermineDeleteRange(e, t, i) {
    const s = t.getLineContent(i.lineNumber), o = s.length;
    if (o === 0) return i.lineNumber > 1 ? new D(i.lineNumber - 1, t.getLineMaxColumn(i.lineNumber - 1), i.lineNumber, 1) : i.lineNumber < t.getLineCount() ? new D(i.lineNumber, 1, i.lineNumber + 1, 1) : new D(i.lineNumber, 1, i.lineNumber, 1);
    const r = (c) => c.start + 1 <= i.column && i.column <= c.end + 1, a = (c, u) => (c = Math.min(c, i.column), u = Math.max(u, i.column), new D(i.lineNumber, c, i.lineNumber, u)), l = (c) => {
      let u = c.start + 1, g = c.end + 1, p = !1;
      for (; g - 1 < o && this._charAtIsWhitespace(s, g - 1); ) p = !0, g++;
      if (!p) for (; u > 1 && this._charAtIsWhitespace(s, u - 2); ) u--;
      return a(u, g);
    }, d = Ct._findPreviousWordOnLine(e, t, i);
    if (d && r(d)) return l(d);
    const h = Ct._findNextWordOnLine(e, t, i);
    return h && r(h) ? l(h) : d && h ? a(d.end + 1, h.start + 1) : d ? a(d.start + 1, d.end + 1) : h ? a(h.start + 1, h.end + 1) : a(1, o + 1);
  }
  static _deleteWordPartLeft(e, t) {
    if (!t.isEmpty()) return t;
    const i = t.getPosition(), s = Ct._moveWordPartLeft(e, i);
    return new D(i.lineNumber, i.column, s.lineNumber, s.column);
  }
  static _findFirstNonWhitespaceChar(e, t) {
    const i = e.length;
    for (let s = t; s < i; s++) {
      const o = e.charAt(s);
      if (o !== " " && o !== "	") return s;
    }
    return i;
  }
  static _deleteWordRightWhitespace(e, t) {
    const i = e.getLineContent(t.lineNumber), s = t.column - 1, o = this._findFirstNonWhitespaceChar(i, s);
    return s + 1 < o ? new D(t.lineNumber, t.column, t.lineNumber, o + 1) : null;
  }
  static deleteWordRight(e, t) {
    const i = e.wordSeparators, s = e.model, o = e.selection, r = e.whitespaceHeuristics;
    if (!o.isEmpty()) return o;
    const a = new W(o.positionLineNumber, o.positionColumn);
    let l = a.lineNumber, d = a.column;
    const h = s.getLineCount(), c = s.getLineMaxColumn(l);
    if (l === h && d === c) return null;
    if (r) {
      const g = this._deleteWordRightWhitespace(s, a);
      if (g) return g;
    }
    let u = Ct._findNextWordOnLine(i, s, a);
    return t === 2 ? u ? d = u.end + 1 : d < c || l === h ? d = c : (l++, u = Ct._findNextWordOnLine(i, s, new W(l, 1)), d = u ? u.start + 1 : s.getLineMaxColumn(l)) : (u && d >= u.start + 1 && (u = Ct._findNextWordOnLine(i, s, new W(l, u.end + 1))), u ? d = u.start + 1 : d < c || l === h ? d = c : (l++, u = Ct._findNextWordOnLine(i, s, new W(l, 1)), d = u ? u.start + 1 : s.getLineMaxColumn(l))), new D(l, d, a.lineNumber, a.column);
  }
  static _deleteWordPartRight(e, t) {
    if (!t.isEmpty()) return t;
    const i = t.getPosition(), s = Ct._moveWordPartRight(e, i);
    return new D(i.lineNumber, i.column, s.lineNumber, s.column);
  }
  static _createWordAtPosition(e, t, i) {
    const s = new D(t, i.start + 1, t, i.end + 1);
    return { word: e.getValueInRange(s), startColumn: s.startColumn, endColumn: s.endColumn };
  }
  static getWordAtPosition(e, t, i, s) {
    const o = zo(t, i), r = Ct._findPreviousWordOnLine(o, e, s);
    if (r && r.wordType === 1 && r.start <= s.column - 1 && s.column - 1 <= r.end) return Ct._createWordAtPosition(e, s.lineNumber, r);
    const a = Ct._findNextWordOnLine(o, e, s);
    return a && a.wordType === 1 && a.start <= s.column - 1 && s.column - 1 <= a.end ? Ct._createWordAtPosition(e, s.lineNumber, a) : null;
  }
  static word(e, t, i, s, o) {
    const r = zo(e.wordSeparators, e.wordSegmenterLocales), a = Ct._findPreviousWordOnLine(r, t, o), l = Ct._findNextWordOnLine(r, t, o);
    if (!s) {
      let g, p;
      return a && a.wordType === 1 && a.start <= o.column - 1 && o.column - 1 <= a.end ? (g = a.start + 1, p = a.end + 1) : l && l.wordType === 1 && l.start <= o.column - 1 && o.column - 1 <= l.end ? (g = l.start + 1, p = l.end + 1) : (g = a ? a.end + 1 : 1, p = l ? l.start + 1 : t.getLineMaxColumn(o.lineNumber)), new bn(new D(o.lineNumber, g, o.lineNumber, p), 1, 0, new W(o.lineNumber, p), 0);
    }
    let d, h;
    a && a.wordType === 1 && a.start < o.column - 1 && o.column - 1 < a.end ? (d = a.start + 1, h = a.end + 1) : l && l.wordType === 1 && l.start < o.column - 1 && o.column - 1 < l.end ? (d = l.start + 1, h = l.end + 1) : (d = o.column, h = o.column);
    const c = o.lineNumber;
    let u;
    if (i.selectionStart.containsPosition(o)) u = i.selectionStart.endColumn;
    else if (o.isBeforeOrEqual(i.selectionStart.getStartPosition())) {
      u = d;
      const g = new W(c, u);
      i.selectionStart.containsPosition(g) && (u = i.selectionStart.endColumn);
    } else {
      u = h;
      const g = new W(c, u);
      i.selectionStart.containsPosition(g) && (u = i.selectionStart.startColumn);
    }
    return i.move(!0, c, u, 0);
  }
}
class dy extends Ct {
  static deleteWordPartLeft(e) {
    const t = mb([Ct.deleteWordLeft(e, 0), Ct.deleteWordLeft(e, 2), Ct._deleteWordPartLeft(e.model, e.selection)]);
    return t.sort(D.compareRangesUsingEnds), t[2];
  }
  static deleteWordPartRight(e) {
    const t = mb([Ct.deleteWordRight(e, 0), Ct.deleteWordRight(e, 2), Ct._deleteWordPartRight(e.model, e.selection)]);
    return t.sort(D.compareRangesUsingStarts), t[0];
  }
  static moveWordPartLeft(e, t, i) {
    const s = mb([Ct.moveWordLeft(e, t, i, 0), Ct.moveWordLeft(e, t, i, 2), Ct._moveWordPartLeft(t, i)]);
    return s.sort(W.compare), s[2];
  }
  static moveWordPartRight(e, t, i) {
    const s = mb([Ct.moveWordRight(e, t, i, 0), Ct.moveWordRight(e, t, i, 2), Ct._moveWordPartRight(t, i)]);
    return s.sort(W.compare), s[0];
  }
}
function mb(n) {
  return n.filter(((e) => !!e));
}
class mn {
  static addCursorDown(e, t, i) {
    const s = [];
    let o = 0;
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      s[o++] = new pt(l.modelState, l.viewState), s[o++] = i ? pt.fromModelState(St.translateDown(e.cursorConfig, e.model, l.modelState)) : pt.fromViewState(St.translateDown(e.cursorConfig, e, l.viewState));
    }
    return s;
  }
  static addCursorUp(e, t, i) {
    const s = [];
    let o = 0;
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      s[o++] = new pt(l.modelState, l.viewState), s[o++] = i ? pt.fromModelState(St.translateUp(e.cursorConfig, e.model, l.modelState)) : pt.fromViewState(St.translateUp(e.cursorConfig, e, l.viewState));
    }
    return s;
  }
  static moveToBeginningOfLine(e, t, i) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o];
      s[o] = this._moveToLineStart(e, a, i);
    }
    return s;
  }
  static _moveToLineStart(e, t, i) {
    const s = t.viewState.position.column, o = s === t.modelState.position.column, r = t.viewState.position.lineNumber, a = e.getLineFirstNonWhitespaceColumn(r);
    return o || s === a ? this._moveToLineStartByModel(e, t, i) : this._moveToLineStartByView(e, t, i);
  }
  static _moveToLineStartByView(e, t, i) {
    return pt.fromViewState(St.moveToBeginningOfLine(e.cursorConfig, e, t.viewState, i));
  }
  static _moveToLineStartByModel(e, t, i) {
    return pt.fromModelState(St.moveToBeginningOfLine(e.cursorConfig, e.model, t.modelState, i));
  }
  static moveToEndOfLine(e, t, i, s) {
    const o = [];
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      o[r] = this._moveToLineEnd(e, l, i, s);
    }
    return o;
  }
  static _moveToLineEnd(e, t, i, s) {
    const o = t.viewState.position, r = e.getLineMaxColumn(o.lineNumber), a = o.column === r, l = t.modelState.position, d = e.model.getLineMaxColumn(l.lineNumber), h = r - o.column == d - l.column;
    return a || h ? this._moveToLineEndByModel(e, t, i, s) : this._moveToLineEndByView(e, t, i, s);
  }
  static _moveToLineEndByView(e, t, i, s) {
    return pt.fromViewState(St.moveToEndOfLine(e.cursorConfig, e, t.viewState, i, s));
  }
  static _moveToLineEndByModel(e, t, i, s) {
    return pt.fromModelState(St.moveToEndOfLine(e.cursorConfig, e.model, t.modelState, i, s));
  }
  static expandLineSelection(e, t) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const r = t[s], a = r.modelState.selection.startLineNumber, l = e.model.getLineCount();
      let d, h = r.modelState.selection.endLineNumber;
      h === l ? d = e.model.getLineMaxColumn(l) : (h++, d = 1), i[s] = pt.fromModelState(new bn(new D(a, 1, a, 1), 0, 0, new W(h, d), 0));
    }
    return i;
  }
  static moveToBeginningOfBuffer(e, t, i) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o];
      s[o] = pt.fromModelState(St.moveToBeginningOfBuffer(e.cursorConfig, e.model, a.modelState, i));
    }
    return s;
  }
  static moveToEndOfBuffer(e, t, i) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o];
      s[o] = pt.fromModelState(St.moveToEndOfBuffer(e.cursorConfig, e.model, a.modelState, i));
    }
    return s;
  }
  static selectAll(e, t) {
    const i = e.model.getLineCount(), s = e.model.getLineMaxColumn(i);
    return pt.fromModelState(new bn(new D(1, 1, 1, 1), 0, 0, new W(i, s), 0));
  }
  static line(e, t, i, s, o) {
    const r = e.model.validatePosition(s), a = o ? e.coordinatesConverter.validateViewPosition(new W(o.lineNumber, o.column), r) : e.coordinatesConverter.convertModelPositionToViewPosition(r);
    if (!i) {
      const d = e.model.getLineCount();
      let h = r.lineNumber + 1, c = 1;
      return h > d && (h = d, c = e.model.getLineMaxColumn(h)), pt.fromModelState(new bn(new D(r.lineNumber, 1, h, c), 2, 0, new W(h, c), 0));
    }
    const l = t.modelState.selectionStart.getStartPosition().lineNumber;
    if (r.lineNumber < l) return pt.fromViewState(t.viewState.move(!0, a.lineNumber, 1, 0));
    if (r.lineNumber > l) {
      const d = e.getLineCount();
      let h = a.lineNumber + 1, c = 1;
      return h > d && (h = d, c = e.getLineMaxColumn(h)), pt.fromViewState(t.viewState.move(!0, h, c, 0));
    }
    {
      const d = t.modelState.selectionStart.getEndPosition();
      return pt.fromModelState(t.modelState.move(!0, d.lineNumber, d.column, 0));
    }
  }
  static word(e, t, i, s) {
    const o = e.model.validatePosition(s);
    return pt.fromModelState(Ct.word(e.cursorConfig, e.model, t.modelState, i, o));
  }
  static cancelSelection(e, t) {
    if (!t.modelState.hasSelection()) return new pt(t.modelState, t.viewState);
    const i = t.viewState.position.lineNumber, s = t.viewState.position.column;
    return pt.fromViewState(new bn(new D(i, s, i, s), 0, 0, new W(i, s), 0));
  }
  static moveTo(e, t, i, s, o) {
    if (i) {
      if (t.modelState.selectionStartKind === 1) return this.word(e, t, i, s);
      if (t.modelState.selectionStartKind === 2) return this.line(e, t, i, s, o);
    }
    const r = e.model.validatePosition(s), a = o ? e.coordinatesConverter.validateViewPosition(new W(o.lineNumber, o.column), r) : e.coordinatesConverter.convertModelPositionToViewPosition(r);
    return pt.fromViewState(t.viewState.move(i, a.lineNumber, a.column, 0));
  }
  static simpleMove(e, t, i, s, o, r) {
    switch (i) {
      case 0:
        return r === 4 ? this._moveHalfLineLeft(e, t, s) : this._moveLeft(e, t, s, o);
      case 1:
        return r === 4 ? this._moveHalfLineRight(e, t, s) : this._moveRight(e, t, s, o);
      case 2:
        return r === 2 ? this._moveUpByViewLines(e, t, s, o) : this._moveUpByModelLines(e, t, s, o);
      case 3:
        return r === 2 ? this._moveDownByViewLines(e, t, s, o) : this._moveDownByModelLines(e, t, s, o);
      case 4:
        return r === 2 ? t.map(((a) => pt.fromViewState(St.moveToPrevBlankLine(e.cursorConfig, e, a.viewState, s)))) : t.map(((a) => pt.fromModelState(St.moveToPrevBlankLine(e.cursorConfig, e.model, a.modelState, s))));
      case 5:
        return r === 2 ? t.map(((a) => pt.fromViewState(St.moveToNextBlankLine(e.cursorConfig, e, a.viewState, s)))) : t.map(((a) => pt.fromModelState(St.moveToNextBlankLine(e.cursorConfig, e.model, a.modelState, s))));
      case 6:
        return this._moveToViewMinColumn(e, t, s);
      case 7:
        return this._moveToViewFirstNonWhitespaceColumn(e, t, s);
      case 8:
        return this._moveToViewCenterColumn(e, t, s);
      case 9:
        return this._moveToViewMaxColumn(e, t, s);
      case 10:
        return this._moveToViewLastNonWhitespaceColumn(e, t, s);
      default:
        return null;
    }
  }
  static viewportMove(e, t, i, s, o) {
    const r = e.getCompletelyVisibleViewRange(), a = e.coordinatesConverter.convertViewRangeToModelRange(r);
    switch (i) {
      case 11: {
        const l = this._firstLineNumberInRange(e.model, a, o), d = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], s, l, d)];
      }
      case 13: {
        const l = this._lastLineNumberInRange(e.model, a, o), d = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], s, l, d)];
      }
      case 12: {
        const l = Math.round((a.startLineNumber + a.endLineNumber) / 2), d = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], s, l, d)];
      }
      case 14: {
        const l = [];
        for (let d = 0, h = t.length; d < h; d++) {
          const c = t[d];
          l[d] = this.findPositionInViewportIfOutside(e, c, r, s);
        }
        return l;
      }
      default:
        return null;
    }
  }
  static findPositionInViewportIfOutside(e, t, i, s) {
    const o = t.viewState.position.lineNumber;
    if (i.startLineNumber <= o && o <= i.endLineNumber - 1) return new pt(t.modelState, t.viewState);
    {
      let r;
      r = o > i.endLineNumber - 1 ? i.endLineNumber - 1 : o < i.startLineNumber ? i.startLineNumber : o;
      const a = St.vertical(e.cursorConfig, e, o, t.viewState.position.column, t.viewState.leftoverVisibleColumns, r, !1);
      return pt.fromViewState(t.viewState.move(s, a.lineNumber, a.column, a.leftoverVisibleColumns));
    }
  }
  static _firstLineNumberInRange(e, t, i) {
    let s = t.startLineNumber;
    return t.startColumn !== e.getLineMinColumn(s) && s++, Math.min(t.endLineNumber, s + i - 1);
  }
  static _lastLineNumberInRange(e, t, i) {
    let s = t.startLineNumber;
    return t.startColumn !== e.getLineMinColumn(s) && s++, Math.max(s, t.endLineNumber - i + 1);
  }
  static _moveLeft(e, t, i, s) {
    return t.map(((o) => pt.fromViewState(St.moveLeft(e.cursorConfig, e, o.viewState, i, s))));
  }
  static _moveHalfLineLeft(e, t, i) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = Math.round(e.getLineLength(l) / 2);
      s[o] = pt.fromViewState(St.moveLeft(e.cursorConfig, e, a.viewState, i, d));
    }
    return s;
  }
  static _moveRight(e, t, i, s) {
    return t.map(((o) => pt.fromViewState(St.moveRight(e.cursorConfig, e, o.viewState, i, s))));
  }
  static _moveHalfLineRight(e, t, i) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = Math.round(e.getLineLength(l) / 2);
      s[o] = pt.fromViewState(St.moveRight(e.cursorConfig, e, a.viewState, i, d));
    }
    return s;
  }
  static _moveDownByViewLines(e, t, i, s) {
    const o = [];
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      o[r] = pt.fromViewState(St.moveDown(e.cursorConfig, e, l.viewState, i, s));
    }
    return o;
  }
  static _moveDownByModelLines(e, t, i, s) {
    const o = [];
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      o[r] = pt.fromModelState(St.moveDown(e.cursorConfig, e.model, l.modelState, i, s));
    }
    return o;
  }
  static _moveUpByViewLines(e, t, i, s) {
    const o = [];
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      o[r] = pt.fromViewState(St.moveUp(e.cursorConfig, e, l.viewState, i, s));
    }
    return o;
  }
  static _moveUpByModelLines(e, t, i, s) {
    const o = [];
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      o[r] = pt.fromModelState(St.moveUp(e.cursorConfig, e.model, l.modelState, i, s));
    }
    return o;
  }
  static _moveToViewPosition(e, t, i, s, o) {
    return pt.fromViewState(t.viewState.move(i, s, o, 0));
  }
  static _moveToModelPosition(e, t, i, s, o) {
    return pt.fromModelState(t.modelState.move(i, s, o, 0));
  }
  static _moveToViewMinColumn(e, t, i) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = e.getLineMinColumn(l);
      s[o] = this._moveToViewPosition(e, a, i, l, d);
    }
    return s;
  }
  static _moveToViewFirstNonWhitespaceColumn(e, t, i) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = e.getLineFirstNonWhitespaceColumn(l);
      s[o] = this._moveToViewPosition(e, a, i, l, d);
    }
    return s;
  }
  static _moveToViewCenterColumn(e, t, i) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = Math.round((e.getLineMaxColumn(l) + e.getLineMinColumn(l)) / 2);
      s[o] = this._moveToViewPosition(e, a, i, l, d);
    }
    return s;
  }
  static _moveToViewMaxColumn(e, t, i) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = e.getLineMaxColumn(l);
      s[o] = this._moveToViewPosition(e, a, i, l, d);
    }
    return s;
  }
  static _moveToViewLastNonWhitespaceColumn(e, t, i) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = e.getLineLastNonWhitespaceColumn(l);
      s[o] = this._moveToViewPosition(e, a, i, l, d);
    }
    return s;
  }
}
var hy;
function sm(n, e, t, i) {
  const s = Qp(e, t.startLineNumber, t.startColumn), o = i.getLanguageConfiguration(s.languageId);
  if (!o) return null;
  const r = s.getLineContent(), a = r.substr(0, t.startColumn - 1 - s.firstCharOffset);
  let l;
  t.isEmpty() ? l = r.substr(t.startColumn - 1 - s.firstCharOffset) : l = Qp(e, t.endLineNumber, t.endColumn).getLineContent().substr(t.endColumn - 1 - s.firstCharOffset);
  let d = "";
  if (t.startLineNumber > 1 && s.firstCharOffset === 0) {
    const f = Qp(e, t.startLineNumber - 1);
    f.languageId === s.languageId && (d = f.getLineContent());
  }
  const h = o.onEnter(n, d, a, l);
  if (!h) return null;
  const c = h.indentAction;
  let u = h.appendText;
  const g = h.removeText || 0;
  u ? c === Oi.Indent && (u = "	" + u) : u = c === Oi.Indent || c === Oi.IndentOutdent ? "	" : "";
  let p = K8(e, t.startLineNumber, t.startColumn);
  return g && (p = p.substring(0, p.length - g)), { indentAction: c, appendText: u, removeText: g, indentation: p };
}
(function(n) {
  n.metadata = { description: "Move cursor to a logical position in the view", args: [{ name: "Cursor move argument object", description: `Property-value pairs that can be passed through this argument:
					* 'to': A mandatory logical position value providing where to move the cursor.
						\`\`\`
						'left', 'right', 'up', 'down', 'prevBlankLine', 'nextBlankLine',
						'wrappedLineStart', 'wrappedLineEnd', 'wrappedLineColumnCenter'
						'wrappedLineFirstNonWhitespaceCharacter', 'wrappedLineLastNonWhitespaceCharacter'
						'viewPortTop', 'viewPortCenter', 'viewPortBottom', 'viewPortIfOutside'
						\`\`\`
					* 'by': Unit to move. Default is computed based on 'to' value.
						\`\`\`
						'line', 'wrappedLine', 'character', 'halfLine'
						\`\`\`
					* 'value': Number of units to move. Default is '1'.
					* 'select': If 'true' makes the selection. Default is 'false'.
				`, constraint: function(e) {
    if (!ms(e)) return !1;
    const t = e;
    return !!ps(t.to) && !(!$s(t.select) && !f7(t.select)) && !(!$s(t.by) && !ps(t.by)) && !(!$s(t.value) && !uc(t.value));
  }, schema: { type: "object", required: ["to"], properties: { to: { type: "string", enum: ["left", "right", "up", "down", "prevBlankLine", "nextBlankLine", "wrappedLineStart", "wrappedLineEnd", "wrappedLineColumnCenter", "wrappedLineFirstNonWhitespaceCharacter", "wrappedLineLastNonWhitespaceCharacter", "viewPortTop", "viewPortCenter", "viewPortBottom", "viewPortIfOutside"] }, by: { type: "string", enum: ["line", "wrappedLine", "character", "halfLine"] }, value: { type: "number", default: 1 }, select: { type: "boolean", default: !1 } } } }] }, n.RawDirection = { Left: "left", Right: "right", Up: "up", Down: "down", PrevBlankLine: "prevBlankLine", NextBlankLine: "nextBlankLine", WrappedLineStart: "wrappedLineStart", WrappedLineFirstNonWhitespaceCharacter: "wrappedLineFirstNonWhitespaceCharacter", WrappedLineColumnCenter: "wrappedLineColumnCenter", WrappedLineEnd: "wrappedLineEnd", WrappedLineLastNonWhitespaceCharacter: "wrappedLineLastNonWhitespaceCharacter", ViewPortTop: "viewPortTop", ViewPortCenter: "viewPortCenter", ViewPortBottom: "viewPortBottom", ViewPortIfOutside: "viewPortIfOutside" }, n.RawUnit = { Line: "line", WrappedLine: "wrappedLine", Character: "character", HalfLine: "halfLine" }, n.parse = function(e) {
    if (!e.to) return null;
    let t;
    switch (e.to) {
      case n.RawDirection.Left:
        t = 0;
        break;
      case n.RawDirection.Right:
        t = 1;
        break;
      case n.RawDirection.Up:
        t = 2;
        break;
      case n.RawDirection.Down:
        t = 3;
        break;
      case n.RawDirection.PrevBlankLine:
        t = 4;
        break;
      case n.RawDirection.NextBlankLine:
        t = 5;
        break;
      case n.RawDirection.WrappedLineStart:
        t = 6;
        break;
      case n.RawDirection.WrappedLineFirstNonWhitespaceCharacter:
        t = 7;
        break;
      case n.RawDirection.WrappedLineColumnCenter:
        t = 8;
        break;
      case n.RawDirection.WrappedLineEnd:
        t = 9;
        break;
      case n.RawDirection.WrappedLineLastNonWhitespaceCharacter:
        t = 10;
        break;
      case n.RawDirection.ViewPortTop:
        t = 11;
        break;
      case n.RawDirection.ViewPortBottom:
        t = 13;
        break;
      case n.RawDirection.ViewPortCenter:
        t = 12;
        break;
      case n.RawDirection.ViewPortIfOutside:
        t = 14;
        break;
      default:
        return null;
    }
    let i = 0;
    switch (e.by) {
      case n.RawUnit.Line:
        i = 1;
        break;
      case n.RawUnit.WrappedLine:
        i = 2;
        break;
      case n.RawUnit.Character:
        i = 3;
        break;
      case n.RawUnit.HalfLine:
        i = 4;
    }
    return { direction: t, unit: i, select: !!e.select, value: e.value || 1 };
  };
})(hy || (hy = {}));
var BC, eY = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, tY = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const fD = /* @__PURE__ */ Object.create(null);
function Hc(n, e) {
  if (e <= 0) return "";
  fD[n] || (fD[n] = ["", n]);
  const t = fD[n];
  for (let i = t.length; i <= e; i++) t[i] = t[i - 1] + n;
  return t[e];
}
let Ko = BC = class {
  static unshiftIndent(n, e, t, i, s) {
    const o = Gi.visibleColumnFromColumn(n, e, t);
    if (s) {
      const r = Hc(" ", i);
      return Hc(r, Gi.prevIndentTabStop(o, i) / i);
    }
    return Hc("	", Gi.prevRenderTabStop(o, t) / t);
  }
  static shiftIndent(n, e, t, i, s) {
    const o = Gi.visibleColumnFromColumn(n, e, t);
    if (s) {
      const r = Hc(" ", i);
      return Hc(r, Gi.nextIndentTabStop(o, i) / i);
    }
    return Hc("	", Gi.nextRenderTabStop(o, t) / t);
  }
  constructor(n, e, t) {
    this._languageConfigurationService = t, this._opts = e, this._selection = n, this._selectionId = null, this._useLastEditRangeForCursorEndPosition = !1, this._selectionStartColumnStaysPut = !1;
  }
  _addEditOperation(n, e, t) {
    this._useLastEditRangeForCursorEndPosition ? n.addTrackedEditOperation(e, t) : n.addEditOperation(e, t);
  }
  getEditOperations(n, e) {
    const t = this._selection.startLineNumber;
    let i = this._selection.endLineNumber;
    this._selection.endColumn === 1 && t !== i && (i -= 1);
    const { tabSize: s, indentSize: o, insertSpaces: r } = this._opts, a = t === i;
    if (this._opts.useTabStops) {
      this._selection.isEmpty() && /^\s*$/.test(n.getLineContent(t)) && (this._useLastEditRangeForCursorEndPosition = !0);
      let l = 0, d = 0;
      for (let h = t; h <= i; h++, l = d) {
        d = 0;
        const c = n.getLineContent(h);
        let u, g = Jn(c);
        if ((!this._opts.isUnshift || c.length !== 0 && g !== 0) && (a || this._opts.isUnshift || c.length !== 0)) {
          if (g === -1 && (g = c.length), h > 1 && Gi.visibleColumnFromColumn(c, g + 1, s) % o != 0 && n.tokenization.isCheapToTokenize(h - 1)) {
            const p = sm(this._opts.autoIndent, n, new D(h - 1, n.getLineMaxColumn(h - 1), h - 1, n.getLineMaxColumn(h - 1)), this._languageConfigurationService);
            if (p) {
              if (d = l, p.appendText) for (let f = 0, _ = p.appendText.length; f < _ && d < o && p.appendText.charCodeAt(f) === 32; f++) d++;
              p.removeText && (d = Math.max(0, d - p.removeText));
              for (let f = 0; f < d && g !== 0 && c.charCodeAt(g - 1) === 32; f++) g--;
            }
          }
          this._opts.isUnshift && g === 0 || (u = this._opts.isUnshift ? BC.unshiftIndent(c, g + 1, s, o, r) : BC.shiftIndent(c, g + 1, s, o, r), this._addEditOperation(e, new D(h, 1, h, g + 1), u), h !== t || this._selection.isEmpty() || (this._selectionStartColumnStaysPut = this._selection.startColumn <= g + 1));
        }
      }
    } else {
      !this._opts.isUnshift && this._selection.isEmpty() && n.getLineLength(t) === 0 && (this._useLastEditRangeForCursorEndPosition = !0);
      const l = r ? Hc(" ", o) : "	";
      for (let d = t; d <= i; d++) {
        const h = n.getLineContent(d);
        let c = Jn(h);
        if ((!this._opts.isUnshift || h.length !== 0 && c !== 0) && (a || this._opts.isUnshift || h.length !== 0) && (c === -1 && (c = h.length), !this._opts.isUnshift || c !== 0)) if (this._opts.isUnshift) {
          c = Math.min(c, o);
          for (let u = 0; u < c; u++)
            if (h.charCodeAt(u) === 9) {
              c = u + 1;
              break;
            }
          this._addEditOperation(e, new D(d, 1, d, c + 1), "");
        } else this._addEditOperation(e, new D(d, 1, d, 1), l), d !== t || this._selection.isEmpty() || (this._selectionStartColumnStaysPut = this._selection.startColumn === 1);
      }
    }
    this._selectionId = e.trackSelection(this._selection);
  }
  computeCursorState(n, e) {
    if (this._useLastEditRangeForCursorEndPosition) {
      const i = e.getInverseEditOperations()[0];
      return new _e(i.range.endLineNumber, i.range.endColumn, i.range.endLineNumber, i.range.endColumn);
    }
    const t = e.getTrackedSelection(this._selectionId);
    if (this._selectionStartColumnStaysPut) {
      const i = this._selection.startColumn;
      return t.startColumn <= i ? t : t.getDirection() === 0 ? new _e(t.startLineNumber, i, t.endLineNumber, t.endColumn) : new _e(t.endLineNumber, t.endColumn, t.startLineNumber, i);
    }
    return t;
  }
};
Ko = BC = eY([tY(2, zt)], Ko);
class iY {
  constructor(e, t, i) {
    this._range = e, this._charBeforeSelection = t, this._charAfterSelection = i;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(new D(this._range.startLineNumber, this._range.startColumn, this._range.startLineNumber, this._range.startColumn), this._charBeforeSelection), t.addTrackedEditOperation(new D(this._range.endLineNumber, this._range.endColumn, this._range.endLineNumber, this._range.endColumn), this._charAfterSelection);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations(), s = i[0].range, o = i[1].range;
    return new _e(s.endLineNumber, s.endColumn, o.endLineNumber, o.endColumn - this._charAfterSelection.length);
  }
}
class nY {
  constructor(e, t, i) {
    this._position = e, this._text = t, this._charAfter = i;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(new D(this._position.lineNumber, this._position.column, this._position.lineNumber, this._position.column), this._text + this._charAfter);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return new _e(i.endLineNumber, i.startColumn, i.endLineNumber, i.endColumn - this._charAfter.length);
  }
}
function WC(n, e, t, i = !0, s) {
  if (n < 4) return null;
  const o = s.getLanguageConfiguration(e.tokenization.getLanguageId()).indentRulesSupport;
  if (!o) return null;
  if (t <= 1) return { indentation: "", action: null };
  for (let l = t - 1; l > 0 && e.getLineContent(l) === ""; l--) if (l === 1) return { indentation: "", action: null };
  const r = (function(l, d, h) {
    const c = l.tokenization.getLanguageIdAtPosition(d, 0);
    if (d > 1) {
      let u, g = -1;
      for (u = d - 1; u >= 1; u--) {
        if (l.tokenization.getLanguageIdAtPosition(u, 0) !== c) return g;
        const p = l.getLineContent(u);
        if (!h.shouldIgnore(p) && !/^\s+$/.test(p) && p !== "") return u;
        g = u;
      }
    }
    return -1;
  })(e, t, o);
  if (r < 0) return null;
  if (r < 1) return { indentation: "", action: null };
  const a = e.getLineContent(r);
  if (o.shouldIncrease(a) || o.shouldIndentNextLine(a)) return { indentation: Wt(a), action: Oi.Indent, line: r };
  if (o.shouldDecrease(a)) return { indentation: Wt(a), action: null, line: r };
  {
    if (r === 1) return { indentation: Wt(e.getLineContent(r)), action: null, line: r };
    const l = r - 1, d = o.getIndentMetadata(e.getLineContent(l));
    if (!(3 & d) && 4 & d) {
      let h = 0;
      for (let c = l - 1; c > 0; c--) if (!o.shouldIndentNextLine(e.getLineContent(c))) {
        h = c;
        break;
      }
      return { indentation: Wt(e.getLineContent(h + 1)), action: null, line: h + 1 };
    }
    if (i) return { indentation: Wt(e.getLineContent(r)), action: null, line: r };
    for (let h = r; h > 0; h--) {
      const c = e.getLineContent(h);
      if (o.shouldIncrease(c)) return { indentation: Wt(c), action: Oi.Indent, line: h };
      if (o.shouldIndentNextLine(c)) {
        let u = 0;
        for (let g = h - 1; g > 0; g--) if (!o.shouldIndentNextLine(e.getLineContent(h))) {
          u = g;
          break;
        }
        return { indentation: Wt(e.getLineContent(u + 1)), action: null, line: u + 1 };
      }
      if (o.shouldDecrease(c)) return { indentation: Wt(c), action: null, line: h };
    }
    return { indentation: Wt(e.getLineContent(1)), action: null, line: 1 };
  }
}
function t0(n, e, t, i, s, o) {
  if (n < 4) return null;
  const r = o.getLanguageConfiguration(t);
  if (!r) return null;
  const a = o.getLanguageConfiguration(t).indentRulesSupport;
  if (!a) return null;
  const l = WC(n, e, i, void 0, o), d = e.getLineContent(i);
  if (l) {
    const h = l.line;
    if (h !== void 0) {
      let c = !0;
      for (let u = h; u < i - 1; u++) if (!/^\s*$/.test(e.getLineContent(u))) {
        c = !1;
        break;
      }
      if (c) {
        const u = r.onEnter(n, "", e.getLineContent(h), "");
        if (u) {
          let g = Wt(e.getLineContent(h));
          return u.removeText && (g = g.substring(0, g.length - u.removeText)), u.indentAction === Oi.Indent || u.indentAction === Oi.IndentOutdent ? g = s.shiftIndent(g) : u.indentAction === Oi.Outdent && (g = s.unshiftIndent(g)), a.shouldDecrease(d) && (g = s.unshiftIndent(g)), u.appendText && (g += u.appendText), Wt(g);
        }
      }
    }
    return a.shouldDecrease(d) ? l.action === Oi.Indent ? l.indentation : s.unshiftIndent(l.indentation) : l.action === Oi.Indent ? s.shiftIndent(l.indentation) : l.indentation;
  }
  return null;
}
function FB(n, e, t) {
  const i = t.getLanguageConfiguration(n.getLanguageId()).indentRulesSupport;
  return i ? e < 1 || e > n.getLineCount() ? null : i.getIndentMetadata(n.getLineContent(e)) : null;
}
class oi {
  static indent(e, t, i) {
    if (t === null || i === null) return [];
    const s = [];
    for (let o = 0, r = i.length; o < r; o++) s[o] = new Ko(i[o], { isUnshift: !1, tabSize: e.tabSize, indentSize: e.indentSize, insertSpaces: e.insertSpaces, useTabStops: e.useTabStops, autoIndent: e.autoIndent }, e.languageConfigurationService);
    return s;
  }
  static outdent(e, t, i) {
    const s = [];
    for (let o = 0, r = i.length; o < r; o++) s[o] = new Ko(i[o], { isUnshift: !0, tabSize: e.tabSize, indentSize: e.indentSize, insertSpaces: e.insertSpaces, useTabStops: e.useTabStops, autoIndent: e.autoIndent }, e.languageConfigurationService);
    return s;
  }
  static shiftIndent(e, t, i) {
    return i = i || 1, Ko.shiftIndent(t, t.length + i, e.tabSize, e.indentSize, e.insertSpaces);
  }
  static unshiftIndent(e, t, i) {
    return i = i || 1, Ko.unshiftIndent(t, t.length + i, e.tabSize, e.indentSize, e.insertSpaces);
  }
  static _distributedPaste(e, t, i, s) {
    const o = [];
    for (let r = 0, a = i.length; r < a; r++) o[r] = new Dn(i[r], s[r]);
    return new Ls(0, o, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !0 });
  }
  static _simplePaste(e, t, i, s, o) {
    const r = [];
    for (let a = 0, l = i.length; a < l; a++) {
      const d = i[a], h = d.getPosition();
      if (o && !d.isEmpty() && (o = !1), o && s.indexOf(`
`) !== s.length - 1 && (o = !1), o) {
        const c = new D(h.lineNumber, 1, h.lineNumber, 1);
        r[a] = new KR(c, s, d, !0);
      } else r[a] = new Dn(d, s);
    }
    return new Ls(0, r, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !0 });
  }
  static _distributePasteToCursors(e, t, i, s, o) {
    if (s || t.length === 1) return null;
    if (o && o.length === t.length) return o;
    if (e.multiCursorPaste === "spread") {
      i.charCodeAt(i.length - 1) === 10 && (i = i.substr(0, i.length - 1)), i.charCodeAt(i.length - 1) === 13 && (i = i.substr(0, i.length - 1));
      const r = Sl(i);
      if (r.length === t.length) return r;
    }
    return null;
  }
  static paste(e, t, i, s, o, r) {
    const a = this._distributePasteToCursors(e, i, s, o, r);
    return a ? (i = i.sort(D.compareRangesUsingStarts), this._distributedPaste(e, t, i, a)) : this._simplePaste(e, t, i, s, o);
  }
  static _goodIndentForLine(e, t, i) {
    let s = null, o = "";
    const r = WC(e.autoIndent, t, i, !1, e.languageConfigurationService);
    if (r) s = r.action, o = r.indentation;
    else if (i > 1) {
      let a;
      for (a = i - 1; a >= 1 && !(oa(t.getLineContent(a)) >= 0); a--)
        ;
      if (a < 1) return null;
      const l = t.getLineMaxColumn(a), d = sm(e.autoIndent, t, new D(a, l, a, l), e.languageConfigurationService);
      d && (o = d.indentation + d.appendText);
    }
    return s && (s === Oi.Indent && (o = oi.shiftIndent(e, o)), s === Oi.Outdent && (o = oi.unshiftIndent(e, o)), o = e.normalizeIndentation(o)), o || null;
  }
  static _replaceJumpToNextIndent(e, t, i, s) {
    let o = "";
    const r = i.getStartPosition();
    if (e.insertSpaces) {
      const a = e.visibleColumnFromColumn(t, r), l = e.indentSize, d = l - a % l;
      for (let h = 0; h < d; h++) o += " ";
    } else o = "	";
    return new Dn(i, o, s);
  }
  static tab(e, t, i) {
    const s = [];
    for (let o = 0, r = i.length; o < r; o++) {
      const a = i[o];
      if (a.isEmpty()) {
        const l = t.getLineContent(a.startLineNumber);
        if (/^\s*$/.test(l) && t.tokenization.isCheapToTokenize(a.startLineNumber)) {
          let d = this._goodIndentForLine(e, t, a.startLineNumber);
          d = d || "	";
          const h = e.normalizeIndentation(d);
          if (!l.startsWith(h)) {
            s[o] = new Dn(new D(a.startLineNumber, 1, a.startLineNumber, l.length + 1), h, !0);
            continue;
          }
        }
        s[o] = this._replaceJumpToNextIndent(e, t, a, !0);
      } else {
        if (a.startLineNumber === a.endLineNumber) {
          const l = t.getLineMaxColumn(a.startLineNumber);
          if (a.startColumn !== 1 || a.endColumn !== l) {
            s[o] = this._replaceJumpToNextIndent(e, t, a, !1);
            continue;
          }
        }
        s[o] = new Ko(a, { isUnshift: !1, tabSize: e.tabSize, indentSize: e.indentSize, insertSpaces: e.insertSpaces, useTabStops: e.useTabStops, autoIndent: e.autoIndent }, e.languageConfigurationService);
      }
    }
    return s;
  }
  static compositionType(e, t, i, s, o, r, a, l) {
    const d = s.map(((h) => this._compositionType(i, h, o, r, a, l)));
    return new Ls(4, d, { shouldPushStackElementBefore: fb(e, 4), shouldPushStackElementAfter: !1 });
  }
  static _compositionType(e, t, i, s, o, r) {
    if (!t.isEmpty()) return null;
    const a = t.getPosition(), l = Math.max(1, a.column - s), d = Math.min(e.getLineMaxColumn(a.lineNumber), a.column + o), h = new D(a.lineNumber, l, a.lineNumber, d);
    return e.getValueInRange(h) === i && r === 0 ? null : new FC(h, i, 0, r);
  }
  static _typeCommand(e, t, i) {
    return i ? new pb(e, t, !0) : new Dn(e, t, !0);
  }
  static _enter(e, t, i, s) {
    if (e.autoIndent === 0) return oi._typeCommand(s, `
`, i);
    if (!t.tokenization.isCheapToTokenize(s.getStartPosition().lineNumber) || e.autoIndent === 1) {
      const a = Wt(t.getLineContent(s.startLineNumber)).substring(0, s.startColumn - 1);
      return oi._typeCommand(s, `
` + e.normalizeIndentation(a), i);
    }
    const o = sm(e.autoIndent, t, s, e.languageConfigurationService);
    if (o) {
      if (o.indentAction === Oi.None || o.indentAction === Oi.Indent) return oi._typeCommand(s, `
` + e.normalizeIndentation(o.indentation + o.appendText), i);
      if (o.indentAction === Oi.IndentOutdent) {
        const a = e.normalizeIndentation(o.indentation), l = e.normalizeIndentation(o.indentation + o.appendText), d = `
` + l + `
` + a;
        return i ? new pb(s, d, !0) : new FC(s, d, -1, l.length - a.length, !0);
      }
      if (o.indentAction === Oi.Outdent) {
        const a = oi.unshiftIndent(e, o.indentation);
        return oi._typeCommand(s, `
` + e.normalizeIndentation(a + o.appendText), i);
      }
    }
    const r = Wt(t.getLineContent(s.startLineNumber)).substring(0, s.startColumn - 1);
    if (e.autoIndent >= 4) {
      const a = (function(l, d, h, c, u) {
        if (l < 4) return null;
        d.tokenization.forceTokenization(h.startLineNumber);
        const g = d.tokenization.getLineTokens(h.startLineNumber), p = $w(g, h.startColumn - 1), f = p.getLineContent();
        let _, v, b = !1;
        p.firstCharOffset > 0 && g.getLanguageId(0) !== p.languageId ? (b = !0, _ = f.substr(0, h.startColumn - 1 - p.firstCharOffset)) : _ = g.getLineContent().substring(0, h.startColumn - 1), v = h.isEmpty() ? f.substr(h.startColumn - 1 - p.firstCharOffset) : Qp(d, h.endLineNumber, h.endColumn).getLineContent().substr(h.endColumn - 1 - p.firstCharOffset);
        const C = u.getLanguageConfiguration(p.languageId).indentRulesSupport;
        if (!C) return null;
        const w = _, y = Wt(_), L = { tokenization: { getLineTokens: (B) => d.tokenization.getLineTokens(B), getLanguageId: () => d.getLanguageId(), getLanguageIdAtPosition: (B, T) => d.getLanguageIdAtPosition(B, T) }, getLineContent: (B) => B === h.startLineNumber ? w : d.getLineContent(B) }, k = Wt(g.getLineContent()), N = WC(l, L, h.startLineNumber + 1, void 0, u);
        if (!N) {
          const B = b ? k : y;
          return { beforeEnter: B, afterEnter: B };
        }
        let A = b ? k : N.indentation;
        return N.action === Oi.Indent && (A = c.shiftIndent(A)), C.shouldDecrease(v) && (A = c.unshiftIndent(A)), { beforeEnter: b ? k : y, afterEnter: A };
      })(e.autoIndent, t, s, { unshiftIndent: (l) => oi.unshiftIndent(e, l), shiftIndent: (l) => oi.shiftIndent(e, l), normalizeIndentation: (l) => e.normalizeIndentation(l) }, e.languageConfigurationService);
      if (a) {
        let l = e.visibleColumnFromColumn(t, s.getEndPosition());
        const d = s.endColumn, h = Jn(t.getLineContent(s.endLineNumber));
        if (s = h >= 0 ? s.setEndPosition(s.endLineNumber, Math.max(s.endColumn, h + 1)) : s.setEndPosition(s.endLineNumber, t.getLineMaxColumn(s.endLineNumber)), i) return new pb(s, `
` + e.normalizeIndentation(a.afterEnter), !0);
        {
          let c = 0;
          return d <= h + 1 && (e.insertSpaces || (l = Math.ceil(l / e.indentSize)), c = Math.min(l + 1 - e.normalizeIndentation(a.afterEnter).length - 1, 0)), new FC(s, `
` + e.normalizeIndentation(a.afterEnter), 0, c, !0);
        }
      }
    }
    return oi._typeCommand(s, `
` + e.normalizeIndentation(r), i);
  }
  static _isAutoIndentType(e, t, i) {
    if (e.autoIndent < 4) return !1;
    for (let s = 0, o = i.length; s < o; s++) if (!t.tokenization.isCheapToTokenize(i[s].getEndPosition().lineNumber)) return !1;
    return !0;
  }
  static _runAutoIndentType(e, t, i, s) {
    const o = K8(t, i.startLineNumber, i.startColumn), r = (function(a, l, d, h, c, u) {
      if (a < 4) return null;
      const g = Qp(l, d.startLineNumber, d.startColumn);
      if (g.firstCharOffset) return null;
      const p = u.getLanguageConfiguration(g.languageId).indentRulesSupport;
      if (!p) return null;
      const f = g.getLineContent(), _ = f.substr(0, d.startColumn - 1 - g.firstCharOffset);
      let v;
      if (v = d.isEmpty() ? f.substr(d.startColumn - 1 - g.firstCharOffset) : Qp(l, d.endLineNumber, d.endColumn).getLineContent().substr(d.endColumn - 1 - g.firstCharOffset), !p.shouldDecrease(_ + v) && p.shouldDecrease(_ + h + v)) {
        const b = WC(a, l, d.startLineNumber, !1, u);
        if (!b) return null;
        let C = b.indentation;
        return b.action !== Oi.Indent && (C = c.unshiftIndent(C)), C;
      }
      return null;
    })(e.autoIndent, t, i, s, { shiftIndent: (a) => oi.shiftIndent(e, a), unshiftIndent: (a) => oi.unshiftIndent(e, a) }, e.languageConfigurationService);
    if (r === null) return null;
    if (r !== e.normalizeIndentation(o)) {
      const a = t.getLineFirstNonWhitespaceColumn(i.startLineNumber);
      return a === 0 ? oi._typeCommand(new D(i.startLineNumber, 1, i.endLineNumber, i.endColumn), e.normalizeIndentation(r) + s, !1) : oi._typeCommand(new D(i.startLineNumber, 1, i.endLineNumber, i.endColumn), e.normalizeIndentation(r) + t.getLineContent(i.startLineNumber).substring(a - 1, i.startColumn - 1) + s, !1);
    }
    return null;
  }
  static _isAutoClosingOvertype(e, t, i, s, o) {
    if (e.autoClosingOvertype === "never" || !e.autoClosingPairs.autoClosingPairsCloseSingleChar.has(o)) return !1;
    for (let r = 0, a = i.length; r < a; r++) {
      const l = i[r];
      if (!l.isEmpty()) return !1;
      const d = l.getPosition(), h = t.getLineContent(d.lineNumber);
      if (h.charAt(d.column - 1) !== o) return !1;
      const c = oh(o);
      if ((d.column > 2 ? h.charCodeAt(d.column - 2) : 0) === 92 && c) return !1;
      if (e.autoClosingOvertype === "auto") {
        let u = !1;
        for (let g = 0, p = s.length; g < p; g++) {
          const f = s[g];
          if (d.lineNumber === f.startLineNumber && d.column === f.startColumn) {
            u = !0;
            break;
          }
        }
        if (!u) return !1;
      }
    }
    return !0;
  }
  static _runAutoClosingOvertype(e, t, i, s, o) {
    const r = [];
    for (let a = 0, l = s.length; a < l; a++) {
      const d = s[a].getPosition(), h = new D(d.lineNumber, d.column, d.lineNumber, d.column + 1);
      r[a] = new Dn(h, o);
    }
    return new Ls(4, r, { shouldPushStackElementBefore: fb(e, 4), shouldPushStackElementAfter: !1 });
  }
  static _isBeforeClosingBrace(e, t) {
    const i = t.charAt(0), s = e.autoClosingPairs.autoClosingPairsOpenByStart.get(i) || [], o = e.autoClosingPairs.autoClosingPairsCloseByStart.get(i) || [], r = s.some(((l) => t.startsWith(l.open))), a = o.some(((l) => t.startsWith(l.close)));
    return !r && a;
  }
  static _findAutoClosingPairOpen(e, t, i, s) {
    const o = e.autoClosingPairs.autoClosingPairsOpenByEnd.get(s);
    if (!o) return null;
    let r = null;
    for (const a of o) if (r === null || a.open.length > r.open.length) {
      let l = !0;
      for (const d of i)
        if (t.getValueInRange(new D(d.lineNumber, d.column - a.open.length + 1, d.lineNumber, d.column)) + s !== a.open) {
          l = !1;
          break;
        }
      l && (r = a);
    }
    return r;
  }
  static _findContainedAutoClosingPair(e, t) {
    if (t.open.length <= 1) return null;
    const i = t.close.charAt(t.close.length - 1), s = e.autoClosingPairs.autoClosingPairsCloseByEnd.get(i) || [];
    let o = null;
    for (const r of s) r.open !== t.open && t.open.includes(r.open) && t.close.endsWith(r.close) && (!o || r.open.length > o.open.length) && (o = r);
    return o;
  }
  static _getAutoClosingPairClose(e, t, i, s, o) {
    for (const g of i) if (!g.isEmpty()) return null;
    const r = i.map(((g) => {
      const p = g.getPosition();
      return o ? { lineNumber: p.lineNumber, beforeColumn: p.column - s.length, afterColumn: p.column } : { lineNumber: p.lineNumber, beforeColumn: p.column, afterColumn: p.column };
    })), a = this._findAutoClosingPairOpen(e, t, r.map(((g) => new W(g.lineNumber, g.beforeColumn))), s);
    if (!a) return null;
    let l, d;
    if (oh(s) ? (l = e.autoClosingQuotes, d = e.shouldAutoCloseBefore.quote) : e.blockCommentStartToken && a.open.includes(e.blockCommentStartToken) ? (l = e.autoClosingComments, d = e.shouldAutoCloseBefore.comment) : (l = e.autoClosingBrackets, d = e.shouldAutoCloseBefore.bracket), l === "never") return null;
    const h = this._findContainedAutoClosingPair(e, a), c = h ? h.close : "";
    let u = !0;
    for (const g of r) {
      const { lineNumber: p, beforeColumn: f, afterColumn: _ } = g, v = t.getLineContent(p), b = v.substring(0, f - 1), C = v.substring(_ - 1);
      if (C.startsWith(c) || (u = !1), C.length > 0) {
        const L = C.charAt(0);
        if (!oi._isBeforeClosingBrace(e, C) && !d(L)) return null;
      }
      if (a.open.length === 1 && (s === "'" || s === '"') && l !== "always") {
        const L = zo(e.wordSeparators, []);
        if (b.length > 0) {
          const k = b.charCodeAt(b.length - 1);
          if (L.get(k) === 0) return null;
        }
      }
      if (!t.tokenization.isCheapToTokenize(p)) return null;
      t.tokenization.forceTokenization(p);
      const w = $w(t.tokenization.getLineTokens(p), f - 1);
      if (!a.shouldAutoClose(w, f - w.firstCharOffset)) return null;
      const y = a.findNeutralCharacter();
      if (y) {
        const L = t.tokenization.getTokenTypeIfInsertingCharacter(p, f, y);
        if (!a.isOK(L)) return null;
      }
    }
    return u ? a.close.substring(0, a.close.length - c.length) : a.close;
  }
  static _runAutoClosingOpenCharType(e, t, i, s, o, r, a) {
    const l = [];
    for (let d = 0, h = s.length; d < h; d++) {
      const c = s[d];
      l[d] = new BB(c, o, !r, a);
    }
    return new Ls(4, l, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !1 });
  }
  static _shouldSurroundChar(e, t) {
    return oh(t) ? e.autoSurround === "quotes" || e.autoSurround === "languageDefined" : e.autoSurround === "brackets" || e.autoSurround === "languageDefined";
  }
  static _isSurroundSelectionType(e, t, i, s) {
    if (!oi._shouldSurroundChar(e, s) || !e.surroundingPairs.hasOwnProperty(s)) return !1;
    const o = oh(s);
    for (const r of i) {
      if (r.isEmpty()) return !1;
      let a = !0;
      for (let l = r.startLineNumber; l <= r.endLineNumber; l++) {
        const d = t.getLineContent(l), h = l === r.startLineNumber ? r.startColumn - 1 : 0, c = l === r.endLineNumber ? r.endColumn - 1 : d.length, u = d.substring(h, c);
        if (/[^ \t]/.test(u)) {
          a = !1;
          break;
        }
      }
      if (a || o && r.startLineNumber === r.endLineNumber && r.startColumn + 1 === r.endColumn && oh(t.getValueInRange(r)))
        return !1;
    }
    return !0;
  }
  static _runSurroundSelectionType(e, t, i, s, o) {
    const r = [];
    for (let a = 0, l = s.length; a < l; a++) {
      const d = s[a], h = t.surroundingPairs[o];
      r[a] = new iY(d, o, h);
    }
    return new Ls(0, r, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !0 });
  }
  static _isTypeInterceptorElectricChar(e, t, i) {
    return !(i.length !== 1 || !t.tokenization.isCheapToTokenize(i[0].getEndPosition().lineNumber));
  }
  static _typeInterceptorElectricChar(e, t, i, s, o) {
    if (!t.electricChars.hasOwnProperty(o) || !s.isEmpty()) return null;
    const r = s.getPosition();
    i.tokenization.forceTokenization(r.lineNumber);
    const a = i.tokenization.getLineTokens(r.lineNumber);
    let l;
    try {
      l = t.onElectricCharacter(o, a, r.column);
    } catch (d) {
      return We(d), null;
    }
    if (!l) return null;
    if (l.matchOpenBracket) {
      const d = (a.getLineContent() + o).lastIndexOf(l.matchOpenBracket) + 1, h = i.bracketPairs.findMatchingBracketUp(l.matchOpenBracket, { lineNumber: r.lineNumber, column: d }, 500);
      if (h) {
        if (h.startLineNumber === r.lineNumber) return null;
        const c = Wt(i.getLineContent(h.startLineNumber)), u = t.normalizeIndentation(c), g = i.getLineContent(r.lineNumber), p = i.getLineFirstNonWhitespaceColumn(r.lineNumber) || r.column, f = u + g.substring(p - 1, r.column - 1) + o, _ = new D(r.lineNumber, 1, r.lineNumber, r.column), v = new Dn(_, f);
        return new Ls(_D(f, e), [v], { shouldPushStackElementBefore: !1, shouldPushStackElementAfter: !0 });
      }
    }
    return null;
  }
  static compositionEndWithInterceptors(e, t, i, s, o, r) {
    if (!s) return null;
    let a = null;
    for (const c of s) if (a === null) a = c.insertedText;
    else if (a !== c.insertedText) return null;
    if (!a || a.length !== 1) return null;
    const l = a;
    let d = !1;
    for (const c of s) if (c.deletedText.length !== 0) {
      d = !0;
      break;
    }
    if (d) {
      if (!oi._shouldSurroundChar(t, l) || !t.surroundingPairs.hasOwnProperty(l)) return null;
      const c = oh(l);
      for (const p of s)
        if (p.deletedSelectionStart !== 0 || p.deletedSelectionEnd !== p.deletedText.length || /^[ \t]+$/.test(p.deletedText) || c && oh(p.deletedText)) return null;
      const u = [];
      for (const p of o) {
        if (!p.isEmpty()) return null;
        u.push(p.getPosition());
      }
      if (u.length !== s.length) return null;
      const g = [];
      for (let p = 0, f = u.length; p < f; p++) g.push(new nY(u[p], s[p].deletedText, t.surroundingPairs[l]));
      return new Ls(4, g, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !1 });
    }
    if (this._isAutoClosingOvertype(t, i, o, r, l)) {
      const c = o.map(((u) => new Dn(new D(u.positionLineNumber, u.positionColumn, u.positionLineNumber, u.positionColumn + 1), "", !1)));
      return new Ls(4, c, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !1 });
    }
    const h = this._getAutoClosingPairClose(t, i, o, l, !0);
    return h !== null ? this._runAutoClosingOpenCharType(e, t, i, o, l, !0, h) : null;
  }
  static typeWithInterceptors(e, t, i, s, o, r, a) {
    if (!e && a === `
`) {
      const h = [];
      for (let c = 0, u = o.length; c < u; c++) h[c] = oi._enter(i, s, !1, o[c]);
      return new Ls(4, h, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !1 });
    }
    if (!e && this._isAutoIndentType(i, s, o)) {
      const h = [];
      let c = !1;
      for (let u = 0, g = o.length; u < g; u++) if (h[u] = this._runAutoIndentType(i, s, o[u], a), !h[u]) {
        c = !0;
        break;
      }
      if (!c) return new Ls(4, h, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !1 });
    }
    if (this._isAutoClosingOvertype(i, s, o, r, a)) return this._runAutoClosingOvertype(t, i, s, o, a);
    if (!e) {
      const h = this._getAutoClosingPairClose(i, s, o, a, !1);
      if (h) return this._runAutoClosingOpenCharType(t, i, s, o, a, !1, h);
    }
    if (!e && this._isSurroundSelectionType(i, s, o, a)) return this._runSurroundSelectionType(t, i, s, o, a);
    if (!e && this._isTypeInterceptorElectricChar(i, s, o)) {
      const h = this._typeInterceptorElectricChar(t, i, s, o[0], a);
      if (h) return h;
    }
    const l = [];
    for (let h = 0, c = o.length; h < c; h++) l[h] = new Dn(o[h], a);
    const d = _D(a, t);
    return new Ls(d, l, { shouldPushStackElementBefore: fb(t, d), shouldPushStackElementAfter: !1 });
  }
  static typeWithoutInterceptors(e, t, i, s, o) {
    const r = [];
    for (let l = 0, d = s.length; l < d; l++) r[l] = new Dn(s[l], o);
    const a = _D(o, e);
    return new Ls(a, r, { shouldPushStackElementBefore: fb(e, a), shouldPushStackElementAfter: !1 });
  }
  static lineInsertBefore(e, t, i) {
    if (t === null || i === null) return [];
    const s = [];
    for (let o = 0, r = i.length; o < r; o++) {
      let a = i[o].positionLineNumber;
      if (a === 1) s[o] = new pb(new D(1, 1, 1, 1), `
`);
      else {
        a--;
        const l = t.getLineMaxColumn(a);
        s[o] = this._enter(e, t, !1, new D(a, l, a, l));
      }
    }
    return s;
  }
  static lineInsertAfter(e, t, i) {
    if (t === null || i === null) return [];
    const s = [];
    for (let o = 0, r = i.length; o < r; o++) {
      const a = i[o].positionLineNumber, l = t.getLineMaxColumn(a);
      s[o] = this._enter(e, t, !1, new D(a, l, a, l));
    }
    return s;
  }
  static lineBreakInsert(e, t, i) {
    const s = [];
    for (let o = 0, r = i.length; o < r; o++) s[o] = this._enter(e, t, !0, i[o]);
    return s;
  }
}
class BB extends FC {
  constructor(e, t, i, s) {
    super(e, (i ? t : "") + s, 0, -s.length), this._openCharacter = t, this._closeCharacter = s, this.closeCharacterRange = null, this.enclosingRange = null;
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return this.closeCharacterRange = new D(i.startLineNumber, i.endColumn - this._closeCharacter.length, i.endLineNumber, i.endColumn), this.enclosingRange = new D(i.startLineNumber, i.endColumn - this._openCharacter.length - this._closeCharacter.length, i.endLineNumber, i.endColumn), super.computeCursorState(e, t);
  }
}
class sY {
  constructor(e, t, i, s, o, r) {
    this.deletedText = e, this.deletedSelectionStart = t, this.deletedSelectionEnd = i, this.insertedText = s, this.insertedSelectionStart = o, this.insertedSelectionEnd = r;
  }
}
function _D(n, e) {
  return n === " " ? e === 5 || e === 6 ? 6 : 5 : 4;
}
function fb(n, e) {
  return !(!Y4(n) || Y4(e)) || n !== 5 && Z4(n) !== Z4(e);
}
function Z4(n) {
  return n === 6 || n === 5 ? "space" : n;
}
function Y4(n) {
  return n === 4 || n === 5 || n === 6;
}
var E;
(function(n) {
  n.editorSimpleInput = new ae("editorSimpleInput", !1, !0), n.editorTextFocus = new ae("editorTextFocus", !1, m(0, "Whether the editor text has focus (cursor is blinking)")), n.focus = new ae("editorFocus", !1, m(0, "Whether the editor or an editor widget has focus (e.g. focus is in the find widget)")), n.textInputFocus = new ae("textInputFocus", !1, m(0, "Whether an editor or a rich text input has focus (cursor is blinking)")), n.readOnly = new ae("editorReadonly", !1, m(0, "Whether the editor is read-only")), n.inDiffEditor = new ae("inDiffEditor", !1, m(0, "Whether the context is a diff editor")), n.isEmbeddedDiffEditor = new ae("isEmbeddedDiffEditor", !1, m(0, "Whether the context is an embedded diff editor")), n.inMultiDiffEditor = new ae("inMultiDiffEditor", !1, m(0, "Whether the context is a multi diff editor")), n.multiDiffEditorAllCollapsed = new ae("multiDiffEditorAllCollapsed", void 0, m(0, "Whether all files in multi diff editor are collapsed")), n.hasChanges = new ae("diffEditorHasChanges", !1, m(0, "Whether the diff editor has changes")), n.comparingMovedCode = new ae("comparingMovedCode", !1, m(0, "Whether a moved code block is selected for comparison")), n.accessibleDiffViewerVisible = new ae("accessibleDiffViewerVisible", !1, m(0, "Whether the accessible diff viewer is visible")), n.diffEditorRenderSideBySideInlineBreakpointReached = new ae("diffEditorRenderSideBySideInlineBreakpointReached", !1, m(0, "Whether the diff editor render side by side inline breakpoint is reached")), n.diffEditorInlineMode = new ae("diffEditorInlineMode", !1, m(0, "Whether inline mode is active")), n.diffEditorOriginalWritable = new ae("diffEditorOriginalWritable", !1, m(0, "Whether modified is writable in the diff editor")), n.diffEditorModifiedWritable = new ae("diffEditorModifiedWritable", !1, m(0, "Whether modified is writable in the diff editor")), n.diffEditorOriginalUri = new ae("diffEditorOriginalUri", "", m(0, "The uri of the original document")), n.diffEditorModifiedUri = new ae("diffEditorModifiedUri", "", m(0, "The uri of the modified document")), n.columnSelection = new ae("editorColumnSelection", !1, m(0, "Whether `editor.columnSelection` is enabled")), n.writable = n.readOnly.toNegated(), n.hasNonEmptySelection = new ae("editorHasSelection", !1, m(0, "Whether the editor has text selected")), n.hasOnlyEmptySelection = n.hasNonEmptySelection.toNegated(), n.hasMultipleSelections = new ae("editorHasMultipleSelections", !1, m(0, "Whether the editor has multiple selections")), n.hasSingleSelection = n.hasMultipleSelections.toNegated(), n.tabMovesFocus = new ae("editorTabMovesFocus", !1, m(0, "Whether `Tab` will move focus out of the editor")), n.tabDoesNotMoveFocus = n.tabMovesFocus.toNegated(), n.isInEmbeddedEditor = new ae("isInEmbeddedEditor", !1, !0), n.canUndo = new ae("canUndo", !1, !0), n.canRedo = new ae("canRedo", !1, !0), n.hoverVisible = new ae("editorHoverVisible", !1, m(0, "Whether the editor hover is visible")), n.hoverFocused = new ae("editorHoverFocused", !1, m(0, "Whether the editor hover is focused")), n.stickyScrollFocused = new ae("stickyScrollFocused", !1, m(0, "Whether the sticky scroll is focused")), n.stickyScrollVisible = new ae("stickyScrollVisible", !1, m(0, "Whether the sticky scroll is visible")), n.standaloneColorPickerVisible = new ae("standaloneColorPickerVisible", !1, m(0, "Whether the standalone color picker is visible")), n.standaloneColorPickerFocused = new ae("standaloneColorPickerFocused", !1, m(0, "Whether the standalone color picker is focused")), n.inCompositeEditor = new ae("inCompositeEditor", void 0, m(0, "Whether the editor is part of a larger editor (e.g. notebooks)")), n.notInCompositeEditor = n.inCompositeEditor.toNegated(), n.languageId = new ae("editorLangId", "", m(0, "The language identifier of the editor")), n.hasCompletionItemProvider = new ae("editorHasCompletionItemProvider", !1, m(0, "Whether the editor has a completion item provider")), n.hasCodeActionsProvider = new ae("editorHasCodeActionsProvider", !1, m(0, "Whether the editor has a code actions provider")), n.hasCodeLensProvider = new ae("editorHasCodeLensProvider", !1, m(0, "Whether the editor has a code lens provider")), n.hasDefinitionProvider = new ae("editorHasDefinitionProvider", !1, m(0, "Whether the editor has a definition provider")), n.hasDeclarationProvider = new ae("editorHasDeclarationProvider", !1, m(0, "Whether the editor has a declaration provider")), n.hasImplementationProvider = new ae("editorHasImplementationProvider", !1, m(0, "Whether the editor has an implementation provider")), n.hasTypeDefinitionProvider = new ae("editorHasTypeDefinitionProvider", !1, m(0, "Whether the editor has a type definition provider")), n.hasHoverProvider = new ae("editorHasHoverProvider", !1, m(0, "Whether the editor has a hover provider")), n.hasDocumentHighlightProvider = new ae("editorHasDocumentHighlightProvider", !1, m(0, "Whether the editor has a document highlight provider")), n.hasDocumentSymbolProvider = new ae("editorHasDocumentSymbolProvider", !1, m(0, "Whether the editor has a document symbol provider")), n.hasReferenceProvider = new ae("editorHasReferenceProvider", !1, m(0, "Whether the editor has a reference provider")), n.hasRenameProvider = new ae("editorHasRenameProvider", !1, m(0, "Whether the editor has a rename provider")), n.hasSignatureHelpProvider = new ae("editorHasSignatureHelpProvider", !1, m(0, "Whether the editor has a signature help provider")), n.hasInlayHintsProvider = new ae("editorHasInlayHintsProvider", !1, m(0, "Whether the editor has an inline hints provider")), n.hasDocumentFormattingProvider = new ae("editorHasDocumentFormattingProvider", !1, m(0, "Whether the editor has a document formatting provider")), n.hasDocumentSelectionFormattingProvider = new ae("editorHasDocumentSelectionFormattingProvider", !1, m(0, "Whether the editor has a document selection formatting provider")), n.hasMultipleDocumentFormattingProvider = new ae("editorHasMultipleDocumentFormattingProvider", !1, m(0, "Whether the editor has multiple document formatting providers")), n.hasMultipleDocumentSelectionFormattingProvider = new ae("editorHasMultipleDocumentSelectionFormattingProvider", !1, m(0, "Whether the editor has multiple document selection formatting providers"));
})(E || (E = {}));
class fi extends Zi {
  runEditorCommand(e, t, i) {
    const s = t._getViewModel();
    s && this.runCoreEditorCommand(s, i || {});
  }
}
var kn, Pp, dn;
(function(n) {
  n.metadata = { description: "Scroll editor in the given direction", args: [{ name: "Editor scroll argument object", description: "Property-value pairs that can be passed through this argument:\n					* 'to': A mandatory direction value.\n						```\n						'up', 'down'\n						```\n					* 'by': Unit to move. Default is computed based on 'to' value.\n						```\n						'line', 'wrappedLine', 'page', 'halfPage', 'editor'\n						```\n					* 'value': Number of units to move. Default is '1'.\n					* 'revealCursor': If 'true' reveals the cursor if it is outside view port.\n				", constraint: function(e) {
    if (!ms(e)) return !1;
    const t = e;
    return !!ps(t.to) && !(!$s(t.by) && !ps(t.by)) && !(!$s(t.value) && !uc(t.value)) && !(!$s(t.revealCursor) && !f7(t.revealCursor));
  }, schema: { type: "object", required: ["to"], properties: { to: { type: "string", enum: ["up", "down"] }, by: { type: "string", enum: ["line", "wrappedLine", "page", "halfPage", "editor"] }, value: { type: "number", default: 1 }, revealCursor: { type: "boolean" } } } }] }, n.RawDirection = { Up: "up", Right: "right", Down: "down", Left: "left" }, n.RawUnit = { Line: "line", WrappedLine: "wrappedLine", Page: "page", HalfPage: "halfPage", Editor: "editor", Column: "column" }, n.parse = function(e) {
    let t, i;
    switch (e.to) {
      case n.RawDirection.Up:
        t = 1;
        break;
      case n.RawDirection.Right:
        t = 2;
        break;
      case n.RawDirection.Down:
        t = 3;
        break;
      case n.RawDirection.Left:
        t = 4;
        break;
      default:
        return null;
    }
    switch (e.by) {
      case n.RawUnit.Line:
        i = 1;
        break;
      case n.RawUnit.WrappedLine:
        i = 2;
        break;
      case n.RawUnit.Page:
        i = 3;
        break;
      case n.RawUnit.HalfPage:
        i = 4;
        break;
      case n.RawUnit.Editor:
        i = 5;
        break;
      case n.RawUnit.Column:
        i = 6;
        break;
      default:
        i = 2;
    }
    return { direction: t, unit: i, value: Math.floor(e.value || 1), revealCursor: !!e.revealCursor, select: !!e.select };
  };
})(kn || (kn = {})), (function(n) {
  n.metadata = { description: "Reveal the given line at the given logical position", args: [{ name: "Reveal line argument object", description: "Property-value pairs that can be passed through this argument:\n					* 'lineNumber': A mandatory line number value.\n					* 'at': Logical position at which line has to be revealed.\n						```\n						'top', 'center', 'bottom'\n						```\n				", constraint: function(e) {
    if (!ms(e)) return !1;
    const t = e;
    return !(!uc(t.lineNumber) && !ps(t.lineNumber)) && !(!$s(t.at) && !ps(t.at));
  }, schema: { type: "object", required: ["lineNumber"], properties: { lineNumber: { type: ["number", "string"] }, at: { type: "string", enum: ["top", "center", "bottom"] } } } }] }, n.RawAtArgument = { Top: "top", Center: "center", Bottom: "bottom" };
})(Pp || (Pp = {}));
class nI {
  constructor(e) {
    e.addImplementation(1e4, "code-editor", ((t, i) => {
      const s = t.get(mt).getFocusedCodeEditor();
      return !(!s || !s.hasTextFocus()) && this._runEditorCommand(t, s, i);
    })), e.addImplementation(1e3, "generic-dom-input-textarea", ((t, i) => {
      const s = Mn();
      return !!(s && ["input", "textarea"].indexOf(s.tagName.toLowerCase()) >= 0) && (this.runDOMCommand(s), !0);
    })), e.addImplementation(0, "generic-dom", ((t, i) => {
      const s = t.get(mt).getActiveCodeEditor();
      return !!s && (s.focus(), this._runEditorCommand(t, s, i));
    }));
  }
  _runEditorCommand(e, t, i) {
    return this.runEditorCommand(e, t, i) || !0;
  }
}
(function(n) {
  class e extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      C.position && (b.model.pushStackElement(), b.setCursorStates(C.source, 3, [mn.moveTo(b, b.getPrimaryCursorState(), this._inSelectionMode, C.position, C.viewPosition)]) && C.revealType !== 2 && b.revealAllCursors(C.source, !0, !0));
    }
  }
  n.MoveTo = re(new e({ id: "_moveTo", inSelectionMode: !1, precondition: void 0 })), n.MoveToSelect = re(new e({ id: "_moveToSelect", inSelectionMode: !0, precondition: void 0 }));
  class t extends fi {
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement();
      const w = this._getColumnSelectResult(b, b.getPrimaryCursorState(), b.getCursorColumnSelectData(), C);
      w !== null && (b.setCursorStates(C.source, 3, w.viewStates.map(((y) => pt.fromViewState(y)))), b.setCursorColumnSelectData({ isReal: !0, fromViewLineNumber: w.fromLineNumber, fromViewVisualColumn: w.fromVisualColumn, toViewLineNumber: w.toLineNumber, toViewVisualColumn: w.toVisualColumn }), w.reversed ? b.revealTopMostCursor(C.source) : b.revealBottomMostCursor(C.source));
    }
  }
  n.ColumnSelect = re(new class extends t {
    constructor() {
      super({ id: "columnSelect", precondition: void 0 });
    }
    _getColumnSelectResult(v, b, C, w) {
      if (w.position === void 0 || w.viewPosition === void 0 || w.mouseColumn === void 0) return null;
      const y = v.model.validatePosition(w.position), L = v.coordinatesConverter.validateViewPosition(new W(w.viewPosition.lineNumber, w.viewPosition.column), y), k = w.doColumnSelect ? C.fromViewLineNumber : L.lineNumber, N = w.doColumnSelect ? C.fromViewVisualColumn : w.mouseColumn - 1;
      return bu.columnSelect(v.cursorConfig, v, k, N, L.lineNumber, w.mouseColumn - 1);
    }
  }()), n.CursorColumnSelectLeft = re(new class extends t {
    constructor() {
      super({ id: "cursorColumnSelectLeft", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3599, linux: { primary: 0 } } });
    }
    _getColumnSelectResult(v, b, C, w) {
      return bu.columnSelectLeft(v.cursorConfig, v, C);
    }
  }()), n.CursorColumnSelectRight = re(new class extends t {
    constructor() {
      super({ id: "cursorColumnSelectRight", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3601, linux: { primary: 0 } } });
    }
    _getColumnSelectResult(v, b, C, w) {
      return bu.columnSelectRight(v.cursorConfig, v, C);
    }
  }());
  class i extends t {
    constructor(b) {
      super(b), this._isPaged = b.isPaged;
    }
    _getColumnSelectResult(b, C, w, y) {
      return bu.columnSelectUp(b.cursorConfig, b, w, this._isPaged);
    }
  }
  n.CursorColumnSelectUp = re(new i({ isPaged: !1, id: "cursorColumnSelectUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3600, linux: { primary: 0 } } })), n.CursorColumnSelectPageUp = re(new i({ isPaged: !0, id: "cursorColumnSelectPageUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3595, linux: { primary: 0 } } }));
  class s extends t {
    constructor(b) {
      super(b), this._isPaged = b.isPaged;
    }
    _getColumnSelectResult(b, C, w, y) {
      return bu.columnSelectDown(b.cursorConfig, b, w, this._isPaged);
    }
  }
  n.CursorColumnSelectDown = re(new s({ isPaged: !1, id: "cursorColumnSelectDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3602, linux: { primary: 0 } } })), n.CursorColumnSelectPageDown = re(new s({ isPaged: !0, id: "cursorColumnSelectPageDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3596, linux: { primary: 0 } } }));
  class o extends fi {
    constructor() {
      super({ id: "cursorMove", precondition: void 0, metadata: hy.metadata });
    }
    runCoreEditorCommand(b, C) {
      const w = hy.parse(C);
      w && this._runCursorMove(b, C.source, w);
    }
    _runCursorMove(b, C, w) {
      b.model.pushStackElement(), b.setCursorStates(C, 3, o._move(b, b.getCursorStates(), w)), b.revealAllCursors(C, !0);
    }
    static _move(b, C, w) {
      const y = w.select, L = w.value;
      switch (w.direction) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
          return mn.simpleMove(b, C, w.direction, y, L, w.unit);
        case 11:
        case 13:
        case 12:
        case 14:
          return mn.viewportMove(b, C, w.direction, y, L);
        default:
          return null;
      }
    }
  }
  n.CursorMoveImpl = o, n.CursorMove = re(new o());
  class r extends fi {
    constructor(b) {
      super(b), this._staticArgs = b.args;
    }
    runCoreEditorCommand(b, C) {
      let w = this._staticArgs;
      this._staticArgs.value === -1 && (w = { direction: this._staticArgs.direction, unit: this._staticArgs.unit, select: this._staticArgs.select, value: C.pageSize || b.cursorConfig.pageSize }), b.model.pushStackElement(), b.setCursorStates(C.source, 3, mn.simpleMove(b, b.getCursorStates(), w.direction, w.select, w.value, w.unit)), b.revealAllCursors(C.source, !0);
    }
  }
  n.CursorLeft = re(new r({ args: { direction: 0, unit: 0, select: !1, value: 1 }, id: "cursorLeft", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 15, mac: { primary: 15, secondary: [288] } } })), n.CursorLeftSelect = re(new r({ args: { direction: 0, unit: 0, select: !0, value: 1 }, id: "cursorLeftSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1039 } })), n.CursorRight = re(new r({ args: { direction: 1, unit: 0, select: !1, value: 1 }, id: "cursorRight", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 17, mac: { primary: 17, secondary: [292] } } })), n.CursorRightSelect = re(new r({ args: { direction: 1, unit: 0, select: !0, value: 1 }, id: "cursorRightSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1041 } })), n.CursorUp = re(new r({ args: { direction: 2, unit: 2, select: !1, value: 1 }, id: "cursorUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 16, mac: { primary: 16, secondary: [302] } } })), n.CursorUpSelect = re(new r({ args: { direction: 2, unit: 2, select: !0, value: 1 }, id: "cursorUpSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1040, secondary: [3088], mac: { primary: 1040 }, linux: { primary: 1040 } } })), n.CursorPageUp = re(new r({ args: { direction: 2, unit: 2, select: !1, value: -1 }, id: "cursorPageUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 11 } })), n.CursorPageUpSelect = re(new r({ args: { direction: 2, unit: 2, select: !0, value: -1 }, id: "cursorPageUpSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1035 } })), n.CursorDown = re(new r({ args: { direction: 3, unit: 2, select: !1, value: 1 }, id: "cursorDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 18, mac: { primary: 18, secondary: [300] } } })), n.CursorDownSelect = re(new r({ args: { direction: 3, unit: 2, select: !0, value: 1 }, id: "cursorDownSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1042, secondary: [3090], mac: { primary: 1042 }, linux: { primary: 1042 } } })), n.CursorPageDown = re(new r({ args: { direction: 3, unit: 2, select: !1, value: -1 }, id: "cursorPageDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 12 } })), n.CursorPageDownSelect = re(new r({ args: { direction: 3, unit: 2, select: !0, value: -1 }, id: "cursorPageDownSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1036 } })), n.CreateCursor = re(new class extends fi {
    constructor() {
      super({ id: "createCursor", precondition: void 0 });
    }
    runCoreEditorCommand(v, b) {
      if (!b.position) return;
      let C;
      C = b.wholeLine ? mn.line(v, v.getPrimaryCursorState(), !1, b.position, b.viewPosition) : mn.moveTo(v, v.getPrimaryCursorState(), !1, b.position, b.viewPosition);
      const w = v.getCursorStates();
      if (w.length > 1) {
        const y = C.modelState ? C.modelState.position : null, L = C.viewState ? C.viewState.position : null;
        for (let k = 0, N = w.length; k < N; k++) {
          const A = w[k];
          if ((!y || A.modelState.selection.containsPosition(y)) && (!L || A.viewState.selection.containsPosition(L))) return w.splice(k, 1), v.model.pushStackElement(), void v.setCursorStates(b.source, 3, w);
        }
      }
      w.push(C), v.model.pushStackElement(), v.setCursorStates(b.source, 3, w);
    }
  }()), n.LastCursorMoveToSelect = re(new class extends fi {
    constructor() {
      super({ id: "_lastCursorMoveToSelect", precondition: void 0 });
    }
    runCoreEditorCommand(v, b) {
      if (!b.position) return;
      const C = v.getLastAddedCursorIndex(), w = v.getCursorStates(), y = w.slice(0);
      y[C] = mn.moveTo(v, w[C], !0, b.position, b.viewPosition), v.model.pushStackElement(), v.setCursorStates(b.source, 3, y);
    }
  }());
  class a extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, mn.moveToBeginningOfLine(b, b.getCursorStates(), this._inSelectionMode)), b.revealAllCursors(C.source, !0);
    }
  }
  n.CursorHome = re(new a({ inSelectionMode: !1, id: "cursorHome", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 14, mac: { primary: 14, secondary: [2063] } } })), n.CursorHomeSelect = re(new a({ inSelectionMode: !0, id: "cursorHomeSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1038, mac: { primary: 1038, secondary: [3087] } } }));
  class l extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, this._exec(b.getCursorStates())), b.revealAllCursors(C.source, !0);
    }
    _exec(b) {
      const C = [];
      for (let w = 0, y = b.length; w < y; w++) {
        const L = b[w], k = L.modelState.position.lineNumber;
        C[w] = pt.fromModelState(L.modelState.move(this._inSelectionMode, k, 1, 0));
      }
      return C;
    }
  }
  n.CursorLineStart = re(new l({ inSelectionMode: !1, id: "cursorLineStart", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 0, mac: { primary: 287 } } })), n.CursorLineStartSelect = re(new l({ inSelectionMode: !0, id: "cursorLineStartSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 0, mac: { primary: 1311 } } }));
  class d extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, mn.moveToEndOfLine(b, b.getCursorStates(), this._inSelectionMode, C.sticky || !1)), b.revealAllCursors(C.source, !0);
    }
  }
  n.CursorEnd = re(new d({ inSelectionMode: !1, id: "cursorEnd", precondition: void 0, kbOpts: { args: { sticky: !1 }, weight: 0, kbExpr: E.textInputFocus, primary: 13, mac: { primary: 13, secondary: [2065] } }, metadata: { description: "Go to End", args: [{ name: "args", schema: { type: "object", properties: { sticky: { description: m(0, "Stick to the end even when going to longer lines"), type: "boolean", default: !1 } } } }] } })), n.CursorEndSelect = re(new d({ inSelectionMode: !0, id: "cursorEndSelect", precondition: void 0, kbOpts: { args: { sticky: !1 }, weight: 0, kbExpr: E.textInputFocus, primary: 1037, mac: { primary: 1037, secondary: [3089] } }, metadata: { description: "Select to End", args: [{ name: "args", schema: { type: "object", properties: { sticky: { description: m(0, "Stick to the end even when going to longer lines"), type: "boolean", default: !1 } } } }] } }));
  class h extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, this._exec(b, b.getCursorStates())), b.revealAllCursors(C.source, !0);
    }
    _exec(b, C) {
      const w = [];
      for (let y = 0, L = C.length; y < L; y++) {
        const k = C[y], N = k.modelState.position.lineNumber, A = b.model.getLineMaxColumn(N);
        w[y] = pt.fromModelState(k.modelState.move(this._inSelectionMode, N, A, 0));
      }
      return w;
    }
  }
  n.CursorLineEnd = re(new h({ inSelectionMode: !1, id: "cursorLineEnd", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 0, mac: { primary: 291 } } })), n.CursorLineEndSelect = re(new h({ inSelectionMode: !0, id: "cursorLineEndSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 0, mac: { primary: 1315 } } }));
  class c extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, mn.moveToBeginningOfBuffer(b, b.getCursorStates(), this._inSelectionMode)), b.revealAllCursors(C.source, !0);
    }
  }
  n.CursorTop = re(new c({ inSelectionMode: !1, id: "cursorTop", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2062, mac: { primary: 2064 } } })), n.CursorTopSelect = re(new c({ inSelectionMode: !0, id: "cursorTopSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3086, mac: { primary: 3088 } } }));
  class u extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, mn.moveToEndOfBuffer(b, b.getCursorStates(), this._inSelectionMode)), b.revealAllCursors(C.source, !0);
    }
  }
  n.CursorBottom = re(new u({ inSelectionMode: !1, id: "cursorBottom", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2061, mac: { primary: 2066 } } })), n.CursorBottomSelect = re(new u({ inSelectionMode: !0, id: "cursorBottomSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3085, mac: { primary: 3090 } } }));
  class g extends fi {
    constructor() {
      super({ id: "editorScroll", precondition: void 0, metadata: kn.metadata });
    }
    determineScrollMethod(b) {
      return [6].includes(b.unit) && [4, 2].includes(b.direction) ? this._runHorizontalEditorScroll.bind(this) : [1, 2, 3, 4, 5, 6].includes(b.unit) && [1, 3].includes(b.direction) ? this._runVerticalEditorScroll.bind(this) : null;
    }
    runCoreEditorCommand(b, C) {
      const w = kn.parse(C);
      if (!w) return;
      const y = this.determineScrollMethod(w);
      y && y(b, C.source, w);
    }
    _runVerticalEditorScroll(b, C, w) {
      const y = this._computeDesiredScrollTop(b, w);
      if (w.revealCursor) {
        const L = b.getCompletelyVisibleViewRangeAtScrollTop(y);
        b.setCursorStates(C, 3, [mn.findPositionInViewportIfOutside(b, b.getPrimaryCursorState(), L, w.select)]);
      }
      b.viewLayout.setScrollPosition({ scrollTop: y }, 0);
    }
    _computeDesiredScrollTop(b, C) {
      if (C.unit === 1) {
        const L = b.viewLayout.getFutureViewport(), k = b.getCompletelyVisibleViewRangeAtScrollTop(L.top), N = b.coordinatesConverter.convertViewRangeToModelRange(k);
        let A;
        A = C.direction === 1 ? Math.max(1, N.startLineNumber - C.value) : Math.min(b.model.getLineCount(), N.startLineNumber + C.value);
        const B = b.coordinatesConverter.convertModelPositionToViewPosition(new W(A, 1));
        return b.viewLayout.getVerticalOffsetForLineNumber(B.lineNumber);
      }
      if (C.unit === 5) {
        let L = 0;
        return C.direction === 3 && (L = b.model.getLineCount() - b.cursorConfig.pageSize), b.viewLayout.getVerticalOffsetForLineNumber(L);
      }
      let w;
      w = C.unit === 3 ? b.cursorConfig.pageSize * C.value : C.unit === 4 ? Math.round(b.cursorConfig.pageSize / 2) * C.value : C.value;
      const y = (C.direction === 1 ? -1 : 1) * w;
      return b.viewLayout.getCurrentScrollTop() + y * b.cursorConfig.lineHeight;
    }
    _runHorizontalEditorScroll(b, C, w) {
      const y = this._computeDesiredScrollLeft(b, w);
      b.viewLayout.setScrollPosition({ scrollLeft: y }, 0);
    }
    _computeDesiredScrollLeft(b, C) {
      const w = (C.direction === 4 ? -1 : 1) * C.value;
      return b.viewLayout.getCurrentScrollLeft() + w * b.cursorConfig.typicalHalfwidthCharacterWidth;
    }
  }
  n.EditorScrollImpl = g, n.EditorScroll = re(new g()), n.ScrollLineUp = re(new class extends fi {
    constructor() {
      super({ id: "scrollLineUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2064, mac: { primary: 267 } } });
    }
    runCoreEditorCommand(v, b) {
      n.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Up, by: kn.RawUnit.WrappedLine, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), n.ScrollPageUp = re(new class extends fi {
    constructor() {
      super({ id: "scrollPageUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2059, win: { primary: 523 }, linux: { primary: 523 } } });
    }
    runCoreEditorCommand(v, b) {
      n.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Up, by: kn.RawUnit.Page, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), n.ScrollEditorTop = re(new class extends fi {
    constructor() {
      super({ id: "scrollEditorTop", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus } });
    }
    runCoreEditorCommand(v, b) {
      n.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Up, by: kn.RawUnit.Editor, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), n.ScrollLineDown = re(new class extends fi {
    constructor() {
      super({ id: "scrollLineDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2066, mac: { primary: 268 } } });
    }
    runCoreEditorCommand(v, b) {
      n.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Down, by: kn.RawUnit.WrappedLine, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), n.ScrollPageDown = re(new class extends fi {
    constructor() {
      super({ id: "scrollPageDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2060, win: { primary: 524 }, linux: { primary: 524 } } });
    }
    runCoreEditorCommand(v, b) {
      n.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Down, by: kn.RawUnit.Page, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), n.ScrollEditorBottom = re(new class extends fi {
    constructor() {
      super({ id: "scrollEditorBottom", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus } });
    }
    runCoreEditorCommand(v, b) {
      n.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Down, by: kn.RawUnit.Editor, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), n.ScrollLeft = re(new class extends fi {
    constructor() {
      super({ id: "scrollLeft", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus } });
    }
    runCoreEditorCommand(v, b) {
      n.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Left, by: kn.RawUnit.Column, value: 2, revealCursor: !1, select: !1, source: b.source });
    }
  }()), n.ScrollRight = re(new class extends fi {
    constructor() {
      super({ id: "scrollRight", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus } });
    }
    runCoreEditorCommand(v, b) {
      n.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Right, by: kn.RawUnit.Column, value: 2, revealCursor: !1, select: !1, source: b.source });
    }
  }());
  class p extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      C.position && (b.model.pushStackElement(), b.setCursorStates(C.source, 3, [mn.word(b, b.getPrimaryCursorState(), this._inSelectionMode, C.position)]), C.revealType !== 2 && b.revealAllCursors(C.source, !0, !0));
    }
  }
  n.WordSelect = re(new p({ inSelectionMode: !1, id: "_wordSelect", precondition: void 0 })), n.WordSelectDrag = re(new p({ inSelectionMode: !0, id: "_wordSelectDrag", precondition: void 0 })), n.LastCursorWordSelect = re(new class extends fi {
    constructor() {
      super({ id: "lastCursorWordSelect", precondition: void 0 });
    }
    runCoreEditorCommand(v, b) {
      if (!b.position) return;
      const C = v.getLastAddedCursorIndex(), w = v.getCursorStates(), y = w.slice(0), L = w[C];
      y[C] = mn.word(v, L, L.modelState.hasSelection(), b.position), v.model.pushStackElement(), v.setCursorStates(b.source, 3, y);
    }
  }());
  class f extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      C.position && (b.model.pushStackElement(), b.setCursorStates(C.source, 3, [mn.line(b, b.getPrimaryCursorState(), this._inSelectionMode, C.position, C.viewPosition)]), C.revealType !== 2 && b.revealAllCursors(C.source, !1, !0));
    }
  }
  n.LineSelect = re(new f({ inSelectionMode: !1, id: "_lineSelect", precondition: void 0 })), n.LineSelectDrag = re(new f({ inSelectionMode: !0, id: "_lineSelectDrag", precondition: void 0 }));
  class _ extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      if (!C.position) return;
      const w = b.getLastAddedCursorIndex(), y = b.getCursorStates(), L = y.slice(0);
      L[w] = mn.line(b, y[w], this._inSelectionMode, C.position, C.viewPosition), b.model.pushStackElement(), b.setCursorStates(C.source, 3, L);
    }
  }
  n.LastCursorLineSelect = re(new _({ inSelectionMode: !1, id: "lastCursorLineSelect", precondition: void 0 })), n.LastCursorLineSelectDrag = re(new _({ inSelectionMode: !0, id: "lastCursorLineSelectDrag", precondition: void 0 })), n.CancelSelection = re(new class extends fi {
    constructor() {
      super({ id: "cancelSelection", precondition: E.hasNonEmptySelection, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 9, secondary: [1033] } });
    }
    runCoreEditorCommand(v, b) {
      v.model.pushStackElement(), v.setCursorStates(b.source, 3, [mn.cancelSelection(v, v.getPrimaryCursorState())]), v.revealAllCursors(b.source, !0);
    }
  }()), n.RemoveSecondaryCursors = re(new class extends fi {
    constructor() {
      super({ id: "removeSecondaryCursors", precondition: E.hasMultipleSelections, kbOpts: { weight: 1, kbExpr: E.textInputFocus, primary: 9, secondary: [1033] } });
    }
    runCoreEditorCommand(v, b) {
      v.model.pushStackElement(), v.setCursorStates(b.source, 3, [v.getPrimaryCursorState()]), v.revealAllCursors(b.source, !0), vl(m(0, "Removed secondary cursors"));
    }
  }()), n.RevealLine = re(new class extends fi {
    constructor() {
      super({ id: "revealLine", precondition: void 0, metadata: Pp.metadata });
    }
    runCoreEditorCommand(v, b) {
      const C = b, w = C.lineNumber || 0;
      let y = typeof w == "number" ? w + 1 : parseInt(w) + 1;
      y < 1 && (y = 1);
      const L = v.model.getLineCount();
      y > L && (y = L);
      const k = new D(y, 1, y, v.model.getLineMaxColumn(y));
      let N = 0;
      if (C.at) switch (C.at) {
        case Pp.RawAtArgument.Top:
          N = 3;
          break;
        case Pp.RawAtArgument.Center:
          N = 1;
          break;
        case Pp.RawAtArgument.Bottom:
          N = 4;
      }
      const A = v.coordinatesConverter.convertModelRangeToViewRange(k);
      v.revealRange(b.source, !1, A, N, 0);
    }
  }()), n.SelectAll = new class extends nI {
    constructor() {
      super(Fj);
    }
    runDOMCommand(v) {
      tr && (v.focus(), v.select()), v.ownerDocument.execCommand("selectAll");
    }
    runEditorCommand(v, b, C) {
      const w = b._getViewModel();
      w && this.runCoreEditorCommand(w, C);
    }
    runCoreEditorCommand(v, b) {
      v.model.pushStackElement(), v.setCursorStates("keyboard", 3, [mn.selectAll(v, v.getPrimaryCursorState())]);
    }
  }(), n.SetSelection = re(new class extends fi {
    constructor() {
      super({ id: "setSelection", precondition: void 0 });
    }
    runCoreEditorCommand(v, b) {
      b.selection && (v.model.pushStackElement(), v.setCursorStates(b.source, 3, [pt.fromModelSelection(b.selection)]));
    }
  }());
})(dn || (dn = {}));
const oY = q.and(E.textInputFocus, E.columnSelection);
function qg(n, e) {
  Es.registerKeybindingRule({ id: n, primary: e, when: oY, weight: 1 });
}
function X4(n) {
  return n.register(), n;
}
var om, Ku;
qg(dn.CursorColumnSelectLeft.id, 1039), qg(dn.CursorColumnSelectRight.id, 1041), qg(dn.CursorColumnSelectUp.id, 1040), qg(dn.CursorColumnSelectPageUp.id, 1035), qg(dn.CursorColumnSelectDown.id, 1042), qg(dn.CursorColumnSelectPageDown.id, 1036), (function(n) {
  class e extends Zi {
    runEditorCommand(i, s, o) {
      const r = s._getViewModel();
      r && this.runCoreEditingCommand(s, r, o || {});
    }
  }
  n.CoreEditingCommand = e, n.LineBreakInsert = re(new class extends e {
    constructor() {
      super({ id: "lineBreakInsert", precondition: E.writable, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 0, mac: { primary: 301 } } });
    }
    runCoreEditingCommand(t, i, s) {
      t.pushUndoStop(), t.executeCommands(this.id, oi.lineBreakInsert(i.cursorConfig, i.model, i.getCursorStates().map(((o) => o.modelState.selection))));
    }
  }()), n.Outdent = re(new class extends e {
    constructor() {
      super({ id: "outdent", precondition: E.writable, kbOpts: { weight: 0, kbExpr: q.and(E.editorTextFocus, E.tabDoesNotMoveFocus), primary: 1026 } });
    }
    runCoreEditingCommand(t, i, s) {
      t.pushUndoStop(), t.executeCommands(this.id, oi.outdent(i.cursorConfig, i.model, i.getCursorStates().map(((o) => o.modelState.selection)))), t.pushUndoStop();
    }
  }()), n.Tab = re(new class extends e {
    constructor() {
      super({ id: "tab", precondition: E.writable, kbOpts: { weight: 0, kbExpr: q.and(E.editorTextFocus, E.tabDoesNotMoveFocus), primary: 2 } });
    }
    runCoreEditingCommand(t, i, s) {
      t.pushUndoStop(), t.executeCommands(this.id, oi.tab(i.cursorConfig, i.model, i.getCursorStates().map(((o) => o.modelState.selection)))), t.pushUndoStop();
    }
  }()), n.DeleteLeft = re(new class extends e {
    constructor() {
      super({ id: "deleteLeft", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1, secondary: [1025], mac: { primary: 1, secondary: [1025, 294, 257] } } });
    }
    runCoreEditingCommand(t, i, s) {
      const [o, r] = cg.deleteLeft(i.getPrevEditOperationType(), i.cursorConfig, i.model, i.getCursorStates().map(((a) => a.modelState.selection)), i.getCursorAutoClosedCharacters());
      o && t.pushUndoStop(), t.executeCommands(this.id, r), i.setPrevEditOperationType(2);
    }
  }()), n.DeleteRight = re(new class extends e {
    constructor() {
      super({ id: "deleteRight", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 20, mac: { primary: 20, secondary: [290, 276] } } });
    }
    runCoreEditingCommand(t, i, s) {
      const [o, r] = cg.deleteRight(i.getPrevEditOperationType(), i.cursorConfig, i.model, i.getCursorStates().map(((a) => a.modelState.selection)));
      o && t.pushUndoStop(), t.executeCommands(this.id, r), i.setPrevEditOperationType(3);
    }
  }()), n.Undo = new class extends nI {
    constructor() {
      super(P8);
    }
    runDOMCommand(t) {
      t.ownerDocument.execCommand("undo");
    }
    runEditorCommand(t, i, s) {
      if (i.hasModel() && i.getOption(91) !== !0) return i.getModel().undo();
    }
  }(), n.Redo = new class extends nI {
    constructor() {
      super(O8);
    }
    runDOMCommand(t) {
      t.ownerDocument.execCommand("redo");
    }
    runEditorCommand(t, i, s) {
      if (i.hasModel() && i.getOption(91) !== !0) return i.getModel().redo();
    }
  }();
})(om || (om = {}));
class Q4 extends QS {
  constructor(e, t, i) {
    super({ id: e, precondition: void 0, metadata: i }), this._handlerId = t;
  }
  runCommand(e, t) {
    const i = e.get(mt).getFocusedCodeEditor();
    i && i.trigger("keyboard", this._handlerId, t);
  }
}
function zc(n, e) {
  X4(new Q4("default:" + n, n)), X4(new Q4(n, n, e));
}
zc("type", { description: "Type", args: [{ name: "args", schema: { type: "object", required: ["text"], properties: { text: { type: "string" } } } }] }), zc("replacePreviousChar"), zc("compositionType"), zc("compositionStart"), zc("compositionEnd"), zc("paste"), zc("cut");
class rY {
  constructor(e, t, i, s) {
    this.configuration = e, this.viewModel = t, this.userInputEvents = i, this.commandDelegate = s;
  }
  paste(e, t, i, s) {
    this.commandDelegate.paste(e, t, i, s);
  }
  type(e) {
    this.commandDelegate.type(e);
  }
  compositionType(e, t, i, s) {
    this.commandDelegate.compositionType(e, t, i, s);
  }
  compositionStart() {
    this.commandDelegate.startComposition();
  }
  compositionEnd() {
    this.commandDelegate.endComposition();
  }
  cut() {
    this.commandDelegate.cut();
  }
  setSelection(e) {
    dn.SetSelection.runCoreEditorCommand(this.viewModel, { source: "keyboard", selection: e });
  }
  _validateViewColumn(e) {
    const t = this.viewModel.getLineMinColumn(e.lineNumber);
    return e.column < t ? new W(e.lineNumber, t) : e;
  }
  _hasMulticursorModifier(e) {
    switch (this.configuration.options.get(78)) {
      case "altKey":
        return e.altKey;
      case "ctrlKey":
        return e.ctrlKey;
      case "metaKey":
        return e.metaKey;
      default:
        return !1;
    }
  }
  _hasNonMulticursorModifier(e) {
    switch (this.configuration.options.get(78)) {
      case "altKey":
        return e.ctrlKey || e.metaKey;
      case "ctrlKey":
        return e.altKey || e.metaKey;
      case "metaKey":
        return e.ctrlKey || e.altKey;
      default:
        return !1;
    }
  }
  dispatchMouse(e) {
    const t = this.configuration.options, i = Cs && t.get(107), s = t.get(22);
    e.middleButton && !i ? this._columnSelect(e.position, e.mouseColumn, e.inSelectionMode) : e.startedOnLineNumbers ? this._hasMulticursorModifier(e) ? e.inSelectionMode ? this._lastCursorLineSelect(e.position, e.revealType) : this._createCursor(e.position, !0) : e.inSelectionMode ? this._lineSelectDrag(e.position, e.revealType) : this._lineSelect(e.position, e.revealType) : e.mouseDownCount >= 4 ? this._selectAll() : e.mouseDownCount === 3 ? this._hasMulticursorModifier(e) ? e.inSelectionMode ? this._lastCursorLineSelectDrag(e.position, e.revealType) : this._lastCursorLineSelect(e.position, e.revealType) : e.inSelectionMode ? this._lineSelectDrag(e.position, e.revealType) : this._lineSelect(e.position, e.revealType) : e.mouseDownCount === 2 ? e.onInjectedText || (this._hasMulticursorModifier(e) ? this._lastCursorWordSelect(e.position, e.revealType) : e.inSelectionMode ? this._wordSelectDrag(e.position, e.revealType) : this._wordSelect(e.position, e.revealType)) : this._hasMulticursorModifier(e) ? this._hasNonMulticursorModifier(e) || (e.shiftKey ? this._columnSelect(e.position, e.mouseColumn, !0) : e.inSelectionMode ? this._lastCursorMoveToSelect(e.position, e.revealType) : this._createCursor(e.position, !1)) : e.inSelectionMode ? e.altKey || s ? this._columnSelect(e.position, e.mouseColumn, !0) : this._moveToSelect(e.position, e.revealType) : this.moveTo(e.position, e.revealType);
  }
  _usualArgs(e, t) {
    return e = this._validateViewColumn(e), { source: "mouse", position: this._convertViewToModelPosition(e), viewPosition: e, revealType: t };
  }
  moveTo(e, t) {
    dn.MoveTo.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _moveToSelect(e, t) {
    dn.MoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _columnSelect(e, t, i) {
    e = this._validateViewColumn(e), dn.ColumnSelect.runCoreEditorCommand(this.viewModel, { source: "mouse", position: this._convertViewToModelPosition(e), viewPosition: e, mouseColumn: t, doColumnSelect: i });
  }
  _createCursor(e, t) {
    e = this._validateViewColumn(e), dn.CreateCursor.runCoreEditorCommand(this.viewModel, { source: "mouse", position: this._convertViewToModelPosition(e), viewPosition: e, wholeLine: t });
  }
  _lastCursorMoveToSelect(e, t) {
    dn.LastCursorMoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _wordSelect(e, t) {
    dn.WordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _wordSelectDrag(e, t) {
    dn.WordSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorWordSelect(e, t) {
    dn.LastCursorWordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lineSelect(e, t) {
    dn.LineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lineSelectDrag(e, t) {
    dn.LineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorLineSelect(e, t) {
    dn.LastCursorLineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorLineSelectDrag(e, t) {
    dn.LastCursorLineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _selectAll() {
    dn.SelectAll.runCoreEditorCommand(this.viewModel, { source: "mouse" });
  }
  _convertViewToModelPosition(e) {
    return this.viewModel.coordinatesConverter.convertViewPositionToModelPosition(e);
  }
  emitKeyDown(e) {
    this.userInputEvents.emitKeyDown(e);
  }
  emitKeyUp(e) {
    this.userInputEvents.emitKeyUp(e);
  }
  emitContextMenu(e) {
    this.userInputEvents.emitContextMenu(e);
  }
  emitMouseMove(e) {
    this.userInputEvents.emitMouseMove(e);
  }
  emitMouseLeave(e) {
    this.userInputEvents.emitMouseLeave(e);
  }
  emitMouseUp(e) {
    this.userInputEvents.emitMouseUp(e);
  }
  emitMouseDown(e) {
    this.userInputEvents.emitMouseDown(e);
  }
  emitMouseDrag(e) {
    this.userInputEvents.emitMouseDrag(e);
  }
  emitMouseDrop(e) {
    this.userInputEvents.emitMouseDrop(e);
  }
  emitMouseDropCanceled() {
    this.userInputEvents.emitMouseDropCanceled();
  }
  emitMouseWheel(e) {
    this.userInputEvents.emitMouseWheel(e);
  }
}
class WB {
  constructor(e) {
    this._createLine = e, this._set(1, []);
  }
  flush() {
    this._set(1, []);
  }
  _set(e, t) {
    this._lines = t, this._rendLineNumberStart = e;
  }
  _get() {
    return { rendLineNumberStart: this._rendLineNumberStart, lines: this._lines };
  }
  getStartLineNumber() {
    return this._rendLineNumberStart;
  }
  getEndLineNumber() {
    return this._rendLineNumberStart + this._lines.length - 1;
  }
  getCount() {
    return this._lines.length;
  }
  getLine(e) {
    const t = e - this._rendLineNumberStart;
    if (t < 0 || t >= this._lines.length) throw new Kt("Illegal value for lineNumber");
    return this._lines[t];
  }
  onLinesDeleted(e, t) {
    if (this.getCount() === 0) return null;
    const i = this.getStartLineNumber(), s = this.getEndLineNumber();
    if (t < i) {
      const a = t - e + 1;
      return this._rendLineNumberStart -= a, null;
    }
    if (e > s) return null;
    let o = 0, r = 0;
    for (let a = i; a <= s; a++) {
      const l = a - this._rendLineNumberStart;
      e <= a && a <= t && (r === 0 ? (o = l, r = 1) : r++);
    }
    if (e < i) {
      let a = 0;
      a = t < i ? t - e + 1 : i - e, this._rendLineNumberStart -= a;
    }
    return this._lines.splice(o, r);
  }
  onLinesChanged(e, t) {
    const i = e + t - 1;
    if (this.getCount() === 0) return !1;
    const s = this.getStartLineNumber(), o = this.getEndLineNumber();
    let r = !1;
    for (let a = e; a <= i; a++) a >= s && a <= o && (this._lines[a - this._rendLineNumberStart].onContentChanged(), r = !0);
    return r;
  }
  onLinesInserted(e, t) {
    if (this.getCount() === 0) return null;
    const i = t - e + 1, s = this.getStartLineNumber(), o = this.getEndLineNumber();
    if (e <= s) return this._rendLineNumberStart += i, null;
    if (e > o) return null;
    if (i + e > o)
      return this._lines.splice(e - this._rendLineNumberStart, o - e + 1);
    const r = [];
    for (let c = 0; c < i; c++) r[c] = this._createLine();
    const a = e - this._rendLineNumberStart, l = this._lines.slice(0, a), d = this._lines.slice(a, this._lines.length - i), h = this._lines.slice(this._lines.length - i, this._lines.length);
    return this._lines = l.concat(r).concat(d), h;
  }
  onTokensChanged(e) {
    if (this.getCount() === 0) return !1;
    const t = this.getStartLineNumber(), i = this.getEndLineNumber();
    let s = !1;
    for (let o = 0, r = e.length; o < r; o++) {
      const a = e[o];
      if (a.toLineNumber < t || a.fromLineNumber > i) continue;
      const l = Math.max(t, a.fromLineNumber), d = Math.min(i, a.toLineNumber);
      for (let h = l; h <= d; h++) {
        const c = h - this._rendLineNumberStart;
        this._lines[c].onTokensChanged(), s = !0;
      }
    }
    return s;
  }
}
class VB {
  constructor(e) {
    this._host = e, this.domNode = this._createDomNode(), this._linesCollection = new WB((() => this._host.createVisibleLine()));
  }
  _createDomNode() {
    const e = wt(document.createElement("div"));
    return e.setClassName("view-layer"), e.setPosition("absolute"), e.domNode.setAttribute("role", "presentation"), e.domNode.setAttribute("aria-hidden", "true"), e;
  }
  onConfigurationChanged(e) {
    return !!e.hasChanged(145);
  }
  onFlushed(e) {
    return this._linesCollection.flush(), !0;
  }
  onLinesChanged(e) {
    return this._linesCollection.onLinesChanged(e.fromLineNumber, e.count);
  }
  onLinesDeleted(e) {
    const t = this._linesCollection.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
    if (t) for (let i = 0, s = t.length; i < s; i++) {
      const o = t[i].getDomNode();
      o && this.domNode.domNode.removeChild(o);
    }
    return !0;
  }
  onLinesInserted(e) {
    const t = this._linesCollection.onLinesInserted(e.fromLineNumber, e.toLineNumber);
    if (t) for (let i = 0, s = t.length; i < s; i++) {
      const o = t[i].getDomNode();
      o && this.domNode.domNode.removeChild(o);
    }
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onTokensChanged(e) {
    return this._linesCollection.onTokensChanged(e.ranges);
  }
  onZonesChanged(e) {
    return !0;
  }
  getStartLineNumber() {
    return this._linesCollection.getStartLineNumber();
  }
  getEndLineNumber() {
    return this._linesCollection.getEndLineNumber();
  }
  getVisibleLine(e) {
    return this._linesCollection.getLine(e);
  }
  renderLines(e) {
    const t = this._linesCollection._get(), i = new Jl(this.domNode.domNode, this._host, e), s = { rendLineNumberStart: t.rendLineNumberStart, lines: t.lines, linesLength: t.lines.length }, o = i.render(s, e.startLineNumber, e.endLineNumber, e.relativeVerticalOffset);
    this._linesCollection._set(o.rendLineNumberStart, o.lines);
  }
}
class Jl {
  constructor(e, t, i) {
    this.domNode = e, this.host = t, this.viewportData = i;
  }
  render(e, t, i, s) {
    const o = { rendLineNumberStart: e.rendLineNumberStart, lines: e.lines.slice(0), linesLength: e.linesLength };
    if (o.rendLineNumberStart + o.linesLength - 1 < t || i < o.rendLineNumberStart) {
      o.rendLineNumberStart = t, o.linesLength = i - t + 1, o.lines = [];
      for (let r = t; r <= i; r++) o.lines[r - t] = this.host.createVisibleLine();
      return this._finishRendering(o, !0, s), o;
    }
    if (this._renderUntouchedLines(o, Math.max(t - o.rendLineNumberStart, 0), Math.min(i - o.rendLineNumberStart, o.linesLength - 1), s, t), o.rendLineNumberStart > t) {
      const r = t, a = Math.min(i, o.rendLineNumberStart - 1);
      r <= a && (this._insertLinesBefore(o, r, a, s, t), o.linesLength += a - r + 1);
    } else if (o.rendLineNumberStart < t) {
      const r = Math.min(o.linesLength, t - o.rendLineNumberStart);
      r > 0 && (this._removeLinesBefore(o, r), o.linesLength -= r);
    }
    if (o.rendLineNumberStart = t, o.rendLineNumberStart + o.linesLength - 1 < i) {
      const r = o.rendLineNumberStart + o.linesLength, a = i;
      r <= a && (this._insertLinesAfter(o, r, a, s, t), o.linesLength += a - r + 1);
    } else if (o.rendLineNumberStart + o.linesLength - 1 > i) {
      const r = Math.max(0, i - o.rendLineNumberStart + 1), a = o.linesLength - 1 - r + 1;
      a > 0 && (this._removeLinesAfter(o, a), o.linesLength -= a);
    }
    return this._finishRendering(o, !1, s), o;
  }
  _renderUntouchedLines(e, t, i, s, o) {
    const r = e.rendLineNumberStart, a = e.lines;
    for (let l = t; l <= i; l++) {
      const d = r + l;
      a[l].layoutLine(d, s[d - o], this.viewportData.lineHeight);
    }
  }
  _insertLinesBefore(e, t, i, s, o) {
    const r = [];
    let a = 0;
    for (let l = t; l <= i; l++) r[a++] = this.host.createVisibleLine();
    e.lines = r.concat(e.lines);
  }
  _removeLinesBefore(e, t) {
    for (let i = 0; i < t; i++) {
      const s = e.lines[i].getDomNode();
      s && this.domNode.removeChild(s);
    }
    e.lines.splice(0, t);
  }
  _insertLinesAfter(e, t, i, s, o) {
    const r = [];
    let a = 0;
    for (let l = t; l <= i; l++) r[a++] = this.host.createVisibleLine();
    e.lines = e.lines.concat(r);
  }
  _removeLinesAfter(e, t) {
    const i = e.linesLength - t;
    for (let s = 0; s < t; s++) {
      const o = e.lines[i + s].getDomNode();
      o && this.domNode.removeChild(o);
    }
    e.lines.splice(i, t);
  }
  _finishRenderingNewLines(e, t, i, s) {
    Jl._ttPolicy && (i = Jl._ttPolicy.createHTML(i));
    const o = this.domNode.lastChild;
    t || !o ? this.domNode.innerHTML = i : o.insertAdjacentHTML("afterend", i);
    let r = this.domNode.lastChild;
    for (let a = e.linesLength - 1; a >= 0; a--) {
      const l = e.lines[a];
      s[a] && (l.setDomNode(r), r = r.previousSibling);
    }
  }
  _finishRenderingInvalidLines(e, t, i) {
    const s = document.createElement("div");
    Jl._ttPolicy && (t = Jl._ttPolicy.createHTML(t)), s.innerHTML = t;
    for (let o = 0; o < e.linesLength; o++) {
      const r = e.lines[o];
      if (i[o]) {
        const a = s.firstChild, l = r.getDomNode();
        l.parentNode.replaceChild(a, l), r.setDomNode(a);
      }
    }
  }
  _finishRendering(e, t, i) {
    const s = Jl._sb, o = e.linesLength, r = e.lines, a = e.rendLineNumberStart, l = [];
    {
      s.reset();
      let d = !1;
      for (let h = 0; h < o; h++) {
        const c = r[h];
        l[h] = !1, !c.getDomNode() && c.renderLine(h + a, i[h], this.viewportData.lineHeight, this.viewportData, s) && (l[h] = !0, d = !0);
      }
      d && this._finishRenderingNewLines(e, t, s.build(), l);
    }
    {
      s.reset();
      let d = !1;
      const h = [];
      for (let c = 0; c < o; c++) {
        const u = r[c];
        h[c] = !1, !l[c] && u.renderLine(c + a, i[c], this.viewportData.lineHeight, this.viewportData, s) && (h[c] = !0, d = !0);
      }
      d && this._finishRenderingInvalidLines(e, s.build(), h);
    }
  }
}
Jl._ttPolicy = Hd("editorViewLayer", { createHTML: (n) => n }), Jl._sb = new pf(1e5);
class HB extends to {
  constructor(e) {
    super(e), this._visibleLines = new VB(this), this.domNode = this._visibleLines.domNode;
    const t = this._context.configuration.options.get(50);
    yn(this.domNode, t), this._dynamicOverlays = [], this._isFocused = !1, this.domNode.setClassName("view-overlays");
  }
  shouldRender() {
    if (super.shouldRender()) return !0;
    for (let e = 0, t = this._dynamicOverlays.length; e < t; e++)
      if (this._dynamicOverlays[e].shouldRender()) return !0;
    return !1;
  }
  dispose() {
    super.dispose();
    for (let e = 0, t = this._dynamicOverlays.length; e < t; e++)
      this._dynamicOverlays[e].dispose();
    this._dynamicOverlays = [];
  }
  getDomNode() {
    return this.domNode;
  }
  createVisibleLine() {
    return new aY(this._dynamicOverlays);
  }
  addDynamicOverlay(e) {
    this._dynamicOverlays.push(e);
  }
  onConfigurationChanged(e) {
    this._visibleLines.onConfigurationChanged(e);
    const t = this._context.configuration.options.get(50);
    return yn(this.domNode, t), !0;
  }
  onFlushed(e) {
    return this._visibleLines.onFlushed(e);
  }
  onFocusChanged(e) {
    return this._isFocused = e.isFocused, !0;
  }
  onLinesChanged(e) {
    return this._visibleLines.onLinesChanged(e);
  }
  onLinesDeleted(e) {
    return this._visibleLines.onLinesDeleted(e);
  }
  onLinesInserted(e) {
    return this._visibleLines.onLinesInserted(e);
  }
  onScrollChanged(e) {
    return this._visibleLines.onScrollChanged(e) || !0;
  }
  onTokensChanged(e) {
    return this._visibleLines.onTokensChanged(e);
  }
  onZonesChanged(e) {
    return this._visibleLines.onZonesChanged(e);
  }
  prepareRender(e) {
    const t = this._dynamicOverlays.filter(((i) => i.shouldRender()));
    for (let i = 0, s = t.length; i < s; i++) {
      const o = t[i];
      o.prepareRender(e), o.onDidRender();
    }
  }
  render(e) {
    this._viewOverlaysRender(e), this.domNode.toggleClassName("focused", this._isFocused);
  }
  _viewOverlaysRender(e) {
    this._visibleLines.renderLines(e.viewportData);
  }
}
class aY {
  constructor(e) {
    this._dynamicOverlays = e, this._domNode = null, this._renderedContent = null;
  }
  getDomNode() {
    return this._domNode ? this._domNode.domNode : null;
  }
  setDomNode(e) {
    this._domNode = wt(e);
  }
  onContentChanged() {
  }
  onTokensChanged() {
  }
  renderLine(e, t, i, s, o) {
    let r = "";
    for (let a = 0, l = this._dynamicOverlays.length; a < l; a++)
      r += this._dynamicOverlays[a].render(s.startLineNumber, e);
    return this._renderedContent !== r && (this._renderedContent = r, o.appendString('<div style="top:'), o.appendString(String(t)), o.appendString("px;height:"), o.appendString(String(i)), o.appendString('px;">'), o.appendString(r), o.appendString("</div>"), !0);
  }
  layoutLine(e, t, i) {
    this._domNode && (this._domNode.setTop(t), this._domNode.setHeight(i));
  }
}
class lY extends HB {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options.get(145);
    this._contentWidth = t.contentWidth, this.domNode.setHeight(0);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options.get(145);
    return this._contentWidth = t.contentWidth, super.onConfigurationChanged(e) || !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollWidthChanged;
  }
  _viewOverlaysRender(e) {
    super._viewOverlaysRender(e), this.domNode.setWidth(Math.max(e.scrollWidth, this._contentWidth));
  }
}
class dY extends HB {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, i = t.get(145);
    this._contentLeft = i.contentLeft, this.domNode.setClassName("margin-view-overlays"), this.domNode.setWidth(1), yn(this.domNode, t.get(50));
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    yn(this.domNode, t.get(50));
    const i = t.get(145);
    return this._contentLeft = i.contentLeft, super.onConfigurationChanged(e) || !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollHeightChanged;
  }
  _viewOverlaysRender(e) {
    super._viewOverlaysRender(e);
    const t = Math.min(e.scrollHeight, 1e6);
    this.domNode.setHeight(t), this.domNode.setWidth(this._contentLeft);
  }
}
class dL {
  constructor(e) {
    this.onKeyDown = null, this.onKeyUp = null, this.onContextMenu = null, this.onMouseMove = null, this.onMouseLeave = null, this.onMouseDown = null, this.onMouseUp = null, this.onMouseDrag = null, this.onMouseDrop = null, this.onMouseDropCanceled = null, this.onMouseWheel = null, this._coordinatesConverter = e;
  }
  emitKeyDown(e) {
    var t;
    (t = this.onKeyDown) === null || t === void 0 || t.call(this, e);
  }
  emitKeyUp(e) {
    var t;
    (t = this.onKeyUp) === null || t === void 0 || t.call(this, e);
  }
  emitContextMenu(e) {
    var t;
    (t = this.onContextMenu) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseMove(e) {
    var t;
    (t = this.onMouseMove) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseLeave(e) {
    var t;
    (t = this.onMouseLeave) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDown(e) {
    var t;
    (t = this.onMouseDown) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseUp(e) {
    var t;
    (t = this.onMouseUp) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDrag(e) {
    var t;
    (t = this.onMouseDrag) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDrop(e) {
    var t;
    (t = this.onMouseDrop) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDropCanceled() {
    var e;
    (e = this.onMouseDropCanceled) === null || e === void 0 || e.call(this);
  }
  emitMouseWheel(e) {
    var t;
    (t = this.onMouseWheel) === null || t === void 0 || t.call(this, e);
  }
  _convertViewToModelMouseEvent(e) {
    return e.target ? { event: e.event, target: this._convertViewToModelMouseTarget(e.target) } : e;
  }
  _convertViewToModelMouseTarget(e) {
    return dL.convertViewToModelMouseTarget(e, this._coordinatesConverter);
  }
  static convertViewToModelMouseTarget(e, t) {
    const i = { ...e };
    return i.position && (i.position = t.convertViewPositionToModelPosition(i.position)), i.range && (i.range = t.convertViewRangeToModelRange(i.range)), i.type !== 5 && i.type !== 8 || (i.detail = this.convertViewToModelViewZoneData(i.detail, t)), i;
  }
  static convertViewToModelViewZoneData(e, t) {
    return { viewZoneId: e.viewZoneId, positionBefore: e.positionBefore ? t.convertViewPositionToModelPosition(e.positionBefore) : e.positionBefore, positionAfter: e.positionAfter ? t.convertViewPositionToModelPosition(e.positionAfter) : e.positionAfter, position: t.convertViewPositionToModelPosition(e.position), afterLineNumber: t.convertViewPositionToModelPosition(new W(e.afterLineNumber, 1)).lineNumber };
  }
}
class hY extends to {
  constructor(e) {
    super(e), this.blocks = [], this.contentWidth = -1, this.contentLeft = 0, this.domNode = wt(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.domNode.setClassName("blockDecorations-container"), this.update();
  }
  update() {
    let e = !1;
    const t = this._context.configuration.options.get(145), i = t.contentWidth - t.verticalScrollbarWidth;
    this.contentWidth !== i && (this.contentWidth = i, e = !0);
    const s = t.contentLeft;
    return this.contentLeft !== s && (this.contentLeft = s, e = !0), e;
  }
  dispose() {
    super.dispose();
  }
  onConfigurationChanged(e) {
    return this.update();
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollLeftChanged;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onZonesChanged(e) {
    return !0;
  }
  prepareRender(e) {
  }
  render(e) {
    var t;
    let i = 0;
    const s = e.getDecorationsInViewport();
    for (const o of s) {
      if (!o.options.blockClassName) continue;
      let r, a, l = this.blocks[i];
      l || (l = this.blocks[i] = wt(document.createElement("div")), this.domNode.appendChild(l)), o.options.blockIsAfterEnd ? (r = e.getVerticalOffsetAfterLineNumber(o.range.endLineNumber, !1), a = e.getVerticalOffsetAfterLineNumber(o.range.endLineNumber, !0)) : (r = e.getVerticalOffsetForLineNumber(o.range.startLineNumber, !0), a = o.range.isEmpty() && !o.options.blockDoesNotCollapse ? e.getVerticalOffsetForLineNumber(o.range.startLineNumber, !1) : e.getVerticalOffsetAfterLineNumber(o.range.endLineNumber, !0));
      const [d, h, c, u] = (t = o.options.blockPadding) !== null && t !== void 0 ? t : [0, 0, 0, 0];
      l.setClassName("blockDecorations-block " + o.options.blockClassName), l.setLeft(this.contentLeft - u), l.setWidth(this.contentWidth + u + h), l.setTop(r - e.scrollTop - d), l.setHeight(a - r + d + c), i++;
    }
    for (let o = i; o < this.blocks.length; o++) this.blocks[o].domNode.remove();
    this.blocks.length = i;
  }
}
class cY extends to {
  constructor(e, t) {
    super(e), this._viewDomNode = t, this._widgets = {}, this.domNode = wt(document.createElement("div")), fa.write(this.domNode, 1), this.domNode.setClassName("contentWidgets"), this.domNode.setPosition("absolute"), this.domNode.setTop(0), this.overflowingContentWidgetsDomNode = wt(document.createElement("div")), fa.write(this.overflowingContentWidgetsDomNode, 2), this.overflowingContentWidgetsDomNode.setClassName("overflowingContentWidgets");
  }
  dispose() {
    super.dispose(), this._widgets = {};
  }
  onConfigurationChanged(e) {
    const t = Object.keys(this._widgets);
    for (const i of t) this._widgets[i].onConfigurationChanged(e);
    return !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLineMappingChanged(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesChanged(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesDeleted(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesInserted(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onZonesChanged(e) {
    return !0;
  }
  _updateAnchorsViewPositions() {
    const e = Object.keys(this._widgets);
    for (const t of e) this._widgets[t].updateAnchorViewPosition();
  }
  addWidget(e) {
    const t = new uY(this._context, this._viewDomNode, e);
    this._widgets[t.id] = t, t.allowEditorOverflow ? this.overflowingContentWidgetsDomNode.appendChild(t.domNode) : this.domNode.appendChild(t.domNode), this.setShouldRender();
  }
  setWidgetPosition(e, t, i, s, o) {
    this._widgets[e.getId()].setPosition(t, i, s, o), this.setShouldRender();
  }
  removeWidget(e) {
    const t = e.getId();
    if (this._widgets.hasOwnProperty(t)) {
      const i = this._widgets[t];
      delete this._widgets[t];
      const s = i.domNode.domNode;
      s.parentNode.removeChild(s), s.removeAttribute("monaco-visible-content-widget"), this.setShouldRender();
    }
  }
  shouldSuppressMouseDownOnWidget(e) {
    return !!this._widgets.hasOwnProperty(e) && this._widgets[e].suppressMouseDown;
  }
  onBeforeRender(e) {
    const t = Object.keys(this._widgets);
    for (const i of t) this._widgets[i].onBeforeRender(e);
  }
  prepareRender(e) {
    const t = Object.keys(this._widgets);
    for (const i of t) this._widgets[i].prepareRender(e);
  }
  render(e) {
    const t = Object.keys(this._widgets);
    for (const i of t) this._widgets[i].render(e);
  }
}
class uY {
  constructor(e, t, i) {
    this._primaryAnchor = new Of(null, null), this._secondaryAnchor = new Of(null, null), this._context = e, this._viewDomNode = t, this._actual = i, this.domNode = wt(this._actual.getDomNode()), this.id = this._actual.getId(), this.allowEditorOverflow = this._actual.allowEditorOverflow || !1, this.suppressMouseDown = this._actual.suppressMouseDown || !1;
    const s = this._context.configuration.options, o = s.get(145);
    this._fixedOverflowWidgets = s.get(42), this._contentWidth = o.contentWidth, this._contentLeft = o.contentLeft, this._lineHeight = s.get(67), this._affinity = null, this._preference = [], this._cachedDomNodeOffsetWidth = -1, this._cachedDomNodeOffsetHeight = -1, this._maxWidth = this._getMaxWidth(), this._isVisible = !1, this._renderData = null, this.domNode.setPosition(this._fixedOverflowWidgets && this.allowEditorOverflow ? "fixed" : "absolute"), this.domNode.setDisplay("none"), this.domNode.setVisibility("hidden"), this.domNode.setAttribute("widgetId", this.id), this.domNode.setMaxWidth(this._maxWidth);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    if (this._lineHeight = t.get(67), e.hasChanged(145)) {
      const i = t.get(145);
      this._contentLeft = i.contentLeft, this._contentWidth = i.contentWidth, this._maxWidth = this._getMaxWidth();
    }
  }
  updateAnchorViewPosition() {
    this._setPosition(this._affinity, this._primaryAnchor.modelPosition, this._secondaryAnchor.modelPosition);
  }
  _setPosition(e, t, i) {
    function s(o, r, a) {
      if (!o) return new Of(null, null);
      const l = r.model.validatePosition(o);
      if (r.coordinatesConverter.modelPositionIsVisible(l)) {
        const d = r.coordinatesConverter.convertModelPositionToViewPosition(l, a ?? void 0);
        return new Of(o, d);
      }
      return new Of(o, null);
    }
    this._affinity = e, this._primaryAnchor = s(t, this._context.viewModel, this._affinity), this._secondaryAnchor = s(i, this._context.viewModel, this._affinity);
  }
  _getMaxWidth() {
    const e = this.domNode.domNode.ownerDocument, t = e.defaultView;
    return this.allowEditorOverflow ? t?.innerWidth || e.documentElement.offsetWidth || e.body.offsetWidth : this._contentWidth;
  }
  setPosition(e, t, i, s) {
    this._setPosition(s, e, t), this._preference = i, this._primaryAnchor.viewPosition && this._preference && this._preference.length > 0 ? this.domNode.setDisplay("block") : this.domNode.setDisplay("none"), this._cachedDomNodeOffsetWidth = -1, this._cachedDomNodeOffsetHeight = -1;
  }
  _layoutBoxInViewport(e, t, i, s) {
    const o = e.top, r = o, a = e.top + e.height, l = o - i, d = r >= i, h = a, c = s.viewportHeight - a >= i;
    let u = e.left;
    return u + t > s.scrollLeft + s.viewportWidth && (u = s.scrollLeft + s.viewportWidth - t), u < s.scrollLeft && (u = s.scrollLeft), { fitsAbove: d, aboveTop: l, fitsBelow: c, belowTop: h, left: u };
  }
  _layoutHorizontalSegmentInPage(e, t, i, s) {
    var o;
    const r = Math.max(15, t.left - s), a = Math.min(t.left + t.width + s, e.width - 15), l = this._viewDomNode.domNode.ownerDocument.defaultView;
    let d = t.left + i - ((o = l?.scrollX) !== null && o !== void 0 ? o : 0);
    if (d + s > a) {
      const h = d - (a - s);
      d -= h, i -= h;
    }
    if (d < r) {
      const h = d - r;
      d -= h, i -= h;
    }
    return [i, d];
  }
  _layoutBoxInPage(e, t, i, s) {
    var o, r;
    const a = e.top - i, l = e.top + e.height, d = Ti(this._viewDomNode.domNode), h = this._viewDomNode.domNode.ownerDocument, c = h.defaultView, u = d.top + a - ((o = c?.scrollY) !== null && o !== void 0 ? o : 0), g = d.top + l - ((r = c?.scrollY) !== null && r !== void 0 ? r : 0), p = Cc(h.body), [f, _] = this._layoutHorizontalSegmentInPage(p, d, e.left - s.scrollLeft + this._contentLeft, t), v = u >= 22, b = g + i <= p.height - 22;
    return this._fixedOverflowWidgets ? { fitsAbove: v, aboveTop: Math.max(u, 22), fitsBelow: b, belowTop: g, left: _ } : { fitsAbove: v, aboveTop: a, fitsBelow: b, belowTop: l, left: f };
  }
  _prepareRenderWidgetAtExactPositionOverflowing(e) {
    return new Ff(e.top, e.left + this._contentLeft);
  }
  _getAnchorsCoordinates(e) {
    var t, i;
    return { primary: s(this._primaryAnchor.viewPosition, this._affinity, this._lineHeight), secondary: s(((t = this._secondaryAnchor.viewPosition) === null || t === void 0 ? void 0 : t.lineNumber) === ((i = this._primaryAnchor.viewPosition) === null || i === void 0 ? void 0 : i.lineNumber) ? this._secondaryAnchor.viewPosition : null, this._affinity, this._lineHeight) };
    function s(o, r, a) {
      if (!o) return null;
      const l = e.visibleRangeForPosition(o);
      if (!l) return null;
      const d = o.column === 1 && r === 3 ? 0 : l.left, h = e.getVerticalOffsetForLineNumber(o.lineNumber) - e.scrollTop;
      return new J4(h, d, a);
    }
  }
  _reduceAnchorCoordinates(e, t, i) {
    if (!t) return e;
    const s = this._context.configuration.options.get(50);
    let o = t.left;
    return o = o < e.left ? Math.max(o, e.left - i + s.typicalFullwidthCharacterWidth) : Math.min(o, e.left + i - s.typicalFullwidthCharacterWidth), new J4(e.top, o, e.height);
  }
  _prepareRenderWidget(e) {
    if (!this._preference || this._preference.length === 0) return null;
    const { primary: t, secondary: i } = this._getAnchorsCoordinates(e);
    if (!t) return null;
    if (this._cachedDomNodeOffsetWidth === -1 || this._cachedDomNodeOffsetHeight === -1) {
      let r = null;
      if (typeof this._actual.beforeRender == "function" && (r = vD(this._actual.beforeRender, this._actual)), r) this._cachedDomNodeOffsetWidth = r.width, this._cachedDomNodeOffsetHeight = r.height;
      else {
        const a = this.domNode.domNode.getBoundingClientRect();
        this._cachedDomNodeOffsetWidth = Math.round(a.width), this._cachedDomNodeOffsetHeight = Math.round(a.height);
      }
    }
    const s = this._reduceAnchorCoordinates(t, i, this._cachedDomNodeOffsetWidth);
    let o;
    o = this.allowEditorOverflow ? this._layoutBoxInPage(s, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, e) : this._layoutBoxInViewport(s, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, e);
    for (let r = 1; r <= 2; r++) for (const a of this._preference) if (a === 1) {
      if (!o) return null;
      if (r === 2 || o.fitsAbove) return { coordinate: new Ff(o.aboveTop, o.left), position: 1 };
    } else {
      if (a !== 2) return this.allowEditorOverflow ? { coordinate: this._prepareRenderWidgetAtExactPositionOverflowing(new Ff(s.top, s.left)), position: 0 } : { coordinate: new Ff(s.top, s.left), position: 0 };
      if (!o) return null;
      if (r === 2 || o.fitsBelow) return { coordinate: new Ff(o.belowTop, o.left), position: 2 };
    }
    return null;
  }
  onBeforeRender(e) {
    this._primaryAnchor.viewPosition && this._preference && (this._primaryAnchor.viewPosition.lineNumber < e.startLineNumber || this._primaryAnchor.viewPosition.lineNumber > e.endLineNumber || this.domNode.setMaxWidth(this._maxWidth));
  }
  prepareRender(e) {
    this._renderData = this._prepareRenderWidget(e);
  }
  render(e) {
    if (!this._renderData) return this._isVisible && (this.domNode.removeAttribute("monaco-visible-content-widget"), this._isVisible = !1, this.domNode.setVisibility("hidden")), void (typeof this._actual.afterRender == "function" && vD(this._actual.afterRender, this._actual, null));
    this.allowEditorOverflow ? (this.domNode.setTop(this._renderData.coordinate.top), this.domNode.setLeft(this._renderData.coordinate.left)) : (this.domNode.setTop(this._renderData.coordinate.top + e.scrollTop - e.bigNumbersDelta), this.domNode.setLeft(this._renderData.coordinate.left)), this._isVisible || (this.domNode.setVisibility("inherit"), this.domNode.setAttribute("monaco-visible-content-widget", "true"), this._isVisible = !0), typeof this._actual.afterRender == "function" && vD(this._actual.afterRender, this._actual, this._renderData.position);
  }
}
class Of {
  constructor(e, t) {
    this.modelPosition = e, this.viewPosition = t;
  }
}
class Ff {
  constructor(e, t) {
    this.top = e, this.left = t, this._coordinateBrand = void 0;
  }
}
class J4 {
  constructor(e, t, i) {
    this.top = e, this.left = t, this.height = i, this._anchorCoordinateBrand = void 0;
  }
}
function vD(n, e, ...t) {
  try {
    return n.call(e, ...t);
  } catch {
    return null;
  }
}
class zB extends Eg {
  constructor(e) {
    super(), this._context = e;
    const t = this._context.configuration.options, i = t.get(145);
    this._renderLineHighlight = t.get(96), this._renderLineHighlightOnlyWhenFocus = t.get(97), this._wordWrap = i.isViewportWrapping, this._contentLeft = i.contentLeft, this._contentWidth = i.contentWidth, this._selectionIsEmpty = !0, this._focused = !1, this._cursorLineNumbers = [1], this._selections = [new _e(1, 1, 1, 1)], this._renderData = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
  _readFromSelections() {
    let e = !1;
    const t = /* @__PURE__ */ new Set();
    for (const o of this._selections) t.add(o.positionLineNumber);
    const i = Array.from(t);
    i.sort(((o, r) => o - r)), ri(this._cursorLineNumbers, i) || (this._cursorLineNumbers = i, e = !0);
    const s = this._selections.every(((o) => o.isEmpty()));
    return this._selectionIsEmpty !== s && (this._selectionIsEmpty = s, e = !0), e;
  }
  onThemeChanged(e) {
    return this._readFromSelections();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, i = t.get(145);
    return this._renderLineHighlight = t.get(96), this._renderLineHighlightOnlyWhenFocus = t.get(97), this._wordWrap = i.isViewportWrapping, this._contentLeft = i.contentLeft, this._contentWidth = i.contentWidth, !0;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections, this._readFromSelections();
  }
  onFlushed(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollWidthChanged || e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onFocusChanged(e) {
    return !!this._renderLineHighlightOnlyWhenFocus && (this._focused = e.isFocused, !0);
  }
  prepareRender(e) {
    if (!this._shouldRenderThis()) return void (this._renderData = null);
    const t = e.visibleRange.startLineNumber, i = e.visibleRange.endLineNumber, s = [];
    for (let r = t; r <= i; r++)
      s[r - t] = "";
    if (this._wordWrap) {
      const r = this._renderOne(e, !1);
      for (const a of this._cursorLineNumbers) {
        const l = this._context.viewModel.coordinatesConverter, d = l.convertViewPositionToModelPosition(new W(a, 1)).lineNumber, h = l.convertModelPositionToViewPosition(new W(d, 1)).lineNumber, c = l.convertModelPositionToViewPosition(new W(d, this._context.viewModel.model.getLineMaxColumn(d))).lineNumber, u = Math.max(h, t), g = Math.min(c, i);
        for (let p = u; p <= g; p++)
          s[p - t] = r;
      }
    }
    const o = this._renderOne(e, !0);
    for (const r of this._cursorLineNumbers)
      r < t || r > i || (s[r - t] = o);
    this._renderData = s;
  }
  render(e, t) {
    if (!this._renderData) return "";
    const i = t - e;
    return i >= this._renderData.length ? "" : this._renderData[i];
  }
  _shouldRenderInMargin() {
    return (this._renderLineHighlight === "gutter" || this._renderLineHighlight === "all") && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
  }
  _shouldRenderInContent() {
    return (this._renderLineHighlight === "line" || this._renderLineHighlight === "all") && this._selectionIsEmpty && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
  }
}
class gY extends zB {
  _renderOne(e, t) {
    return `<div class="${"current-line" + (this._shouldRenderInMargin() ? " current-line-both" : "") + (t ? " current-line-exact" : "")}" style="width:${Math.max(e.scrollWidth, this._contentWidth)}px;"></div>`;
  }
  _shouldRenderThis() {
    return this._shouldRenderInContent();
  }
  _shouldRenderOther() {
    return this._shouldRenderInMargin();
  }
}
class pY extends zB {
  _renderOne(e, t) {
    return `<div class="${"current-line" + (this._shouldRenderInMargin() ? " current-line-margin" : "") + (this._shouldRenderOther() ? " current-line-margin-both" : "") + (this._shouldRenderInMargin() && t ? " current-line-exact-margin" : "")}" style="width:${this._contentLeft}px"></div>`;
  }
  _shouldRenderThis() {
    return !0;
  }
  _shouldRenderOther() {
    return this._shouldRenderInContent();
  }
}
rr(((n, e) => {
  const t = n.getColor(DB);
  if (t && (e.addRule(`.monaco-editor .view-overlays .current-line { background-color: ${t}; }`), e.addRule(`.monaco-editor .margin-view-overlays .current-line-margin { background-color: ${t}; border: none; }`)), !t || t.isTransparent() || n.defines($4)) {
    const i = n.getColor($4);
    i && (e.addRule(`.monaco-editor .view-overlays .current-line-exact { border: 2px solid ${i}; }`), e.addRule(`.monaco-editor .margin-view-overlays .current-line-exact-margin { border: 2px solid ${i}; }`), aa(n.type) && (e.addRule(".monaco-editor .view-overlays .current-line-exact { border-width: 1px; }"), e.addRule(".monaco-editor .margin-view-overlays .current-line-exact-margin { border-width: 1px; }")));
  }
}));
class mY extends Eg {
  constructor(e) {
    super(), this._context = e;
    const t = this._context.configuration.options;
    this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollWidthChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  prepareRender(e) {
    const t = e.getDecorationsInViewport();
    let i = [], s = 0;
    for (let l = 0, d = t.length; l < d; l++) {
      const h = t[l];
      h.options.className && (i[s++] = h);
    }
    i = i.sort(((l, d) => {
      if (l.options.zIndex < d.options.zIndex) return -1;
      if (l.options.zIndex > d.options.zIndex) return 1;
      const h = l.options.className, c = d.options.className;
      return h < c ? -1 : h > c ? 1 : D.compareRangesUsingStarts(l.range, d.range);
    }));
    const o = e.visibleRange.startLineNumber, r = e.visibleRange.endLineNumber, a = [];
    for (let l = o; l <= r; l++)
      a[l - o] = "";
    this._renderWholeLineDecorations(e, i, a), this._renderNormalDecorations(e, i, a), this._renderResult = a;
  }
  _renderWholeLineDecorations(e, t, i) {
    const s = e.visibleRange.startLineNumber, o = e.visibleRange.endLineNumber;
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      if (!l.options.isWholeLine) continue;
      const d = '<div class="cdr ' + l.options.className + '" style="left:0;width:100%;"></div>', h = Math.max(l.range.startLineNumber, s), c = Math.min(l.range.endLineNumber, o);
      for (let u = h; u <= c; u++)
        i[u - s] += d;
    }
  }
  _renderNormalDecorations(e, t, i) {
    var s;
    const o = e.visibleRange.startLineNumber;
    let r = null, a = !1, l = null, d = !1;
    for (let h = 0, c = t.length; h < c; h++) {
      const u = t[h];
      if (u.options.isWholeLine) continue;
      const g = u.options.className, p = !!u.options.showIfCollapsed;
      let f = u.range;
      p && f.endColumn === 1 && f.endLineNumber !== f.startLineNumber && (f = new D(f.startLineNumber, f.startColumn, f.endLineNumber - 1, this._context.viewModel.getLineMaxColumn(f.endLineNumber - 1))), r === g && a === p && D.areIntersectingOrTouching(l, f) ? l = D.plusRange(l, f) : (r !== null && this._renderNormalDecoration(e, l, r, d, a, o, i), r = g, a = p, l = f, d = (s = u.options.shouldFillLineOnLineBreak) !== null && s !== void 0 && s);
    }
    r !== null && this._renderNormalDecoration(e, l, r, d, a, o, i);
  }
  _renderNormalDecoration(e, t, i, s, o, r, a) {
    const l = e.linesVisibleRangesForRange(t, i === "findMatch");
    if (l) for (let d = 0, h = l.length; d < h; d++) {
      const c = l[d];
      if (c.outsideRenderedLine) continue;
      const u = c.lineNumber - r;
      if (o && c.ranges.length === 1) {
        const g = c.ranges[0];
        if (g.width < this._typicalHalfwidthCharacterWidth) {
          const p = Math.round(g.left + g.width / 2), f = Math.max(0, Math.round(p - this._typicalHalfwidthCharacterWidth / 2));
          c.ranges[0] = new rL(f, this._typicalHalfwidthCharacterWidth);
        }
      }
      for (let g = 0, p = c.ranges.length; g < p; g++) {
        const f = s && c.continuesOnNextLine && p === 1, _ = c.ranges[g], v = '<div class="cdr ' + i + '" style="left:' + String(_.left) + "px;width:" + (f ? "100%;" : String(_.width) + "px;") + '"></div>';
        a[u] += v;
      }
    }
  }
  render(e, t) {
    if (!this._renderResult) return "";
    const i = t - e;
    return i < 0 || i >= this._renderResult.length ? "" : this._renderResult[i];
  }
}
class fY extends to {
  constructor(e, t, i, s) {
    super(e);
    const o = this._context.configuration.options, r = o.get(103), a = o.get(75), l = o.get(40), d = o.get(106), h = { listenOnDomNode: i.domNode, className: "editor-scrollable " + tI(e.theme.type), useShadows: !1, lazyRender: !0, vertical: r.vertical, horizontal: r.horizontal, verticalHasArrows: r.verticalHasArrows, horizontalHasArrows: r.horizontalHasArrows, verticalScrollbarSize: r.verticalScrollbarSize, verticalSliderSize: r.verticalSliderSize, horizontalScrollbarSize: r.horizontalScrollbarSize, horizontalSliderSize: r.horizontalSliderSize, handleMouseWheel: r.handleMouseWheel, alwaysConsumeMouseWheel: r.alwaysConsumeMouseWheel, arrowSize: r.arrowSize, mouseWheelScrollSensitivity: a, fastScrollSensitivity: l, scrollPredominantAxis: d, scrollByPage: r.scrollByPage };
    this.scrollbar = this._register(new aL(t.domNode, h, this._context.viewLayout.getScrollable())), fa.write(this.scrollbar.getDomNode(), 6), this.scrollbarDomNode = wt(this.scrollbar.getDomNode()), this.scrollbarDomNode.setPosition("absolute"), this._setLayout();
    const c = (u, g, p) => {
      const f = {};
      {
        const _ = u.scrollTop;
        _ && (f.scrollTop = this._context.viewLayout.getCurrentScrollTop() + _, u.scrollTop = 0);
      }
      if (p) {
        const _ = u.scrollLeft;
        _ && (f.scrollLeft = this._context.viewLayout.getCurrentScrollLeft() + _, u.scrollLeft = 0);
      }
      this._context.viewModel.viewLayout.setScrollPosition(f, 1);
    };
    this._register(K(i.domNode, "scroll", ((u) => c(i.domNode, 0, !0)))), this._register(K(t.domNode, "scroll", ((u) => c(t.domNode, 0, !1)))), this._register(K(s.domNode, "scroll", ((u) => c(s.domNode, 0, !1)))), this._register(K(this.scrollbarDomNode.domNode, "scroll", ((u) => c(this.scrollbarDomNode.domNode, 0, !1))));
  }
  dispose() {
    super.dispose();
  }
  _setLayout() {
    const e = this._context.configuration.options, t = e.get(145);
    this.scrollbarDomNode.setLeft(t.contentLeft), e.get(73).side === "right" ? this.scrollbarDomNode.setWidth(t.contentWidth + t.minimap.minimapWidth) : this.scrollbarDomNode.setWidth(t.contentWidth), this.scrollbarDomNode.setHeight(t.height);
  }
  getOverviewRulerLayoutInfo() {
    return this.scrollbar.getOverviewRulerLayoutInfo();
  }
  getDomNode() {
    return this.scrollbarDomNode;
  }
  delegateVerticalScrollbarPointerDown(e) {
    this.scrollbar.delegateVerticalScrollbarPointerDown(e);
  }
  delegateScrollFromMouseWheelEvent(e) {
    this.scrollbar.delegateScrollFromMouseWheelEvent(e);
  }
  onConfigurationChanged(e) {
    if (e.hasChanged(103) || e.hasChanged(75) || e.hasChanged(40)) {
      const t = this._context.configuration.options, i = t.get(103), s = t.get(75), o = t.get(40), r = t.get(106), a = { vertical: i.vertical, horizontal: i.horizontal, verticalScrollbarSize: i.verticalScrollbarSize, horizontalScrollbarSize: i.horizontalScrollbarSize, scrollByPage: i.scrollByPage, handleMouseWheel: i.handleMouseWheel, mouseWheelScrollSensitivity: s, fastScrollSensitivity: o, scrollPredominantAxis: r };
      this.scrollbar.updateOptions(a);
    }
    return e.hasChanged(145) && this._setLayout(), !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onThemeChanged(e) {
    return this.scrollbar.updateClassName("editor-scrollable " + tI(this._context.theme.type)), !0;
  }
  prepareRender(e) {
  }
  render(e) {
    this.scrollbar.renderNow();
  }
}
class sI {
  constructor(e, t, i, s, o) {
    this.startLineNumber = e, this.endLineNumber = t, this.className = i, this.tooltip = s, this._decorationToRenderBrand = void 0, this.zIndex = o ?? 0;
  }
}
class _Y {
  constructor(e, t, i) {
    this.className = e, this.zIndex = t, this.tooltip = i;
  }
}
class vY {
  constructor() {
    this.decorations = [];
  }
  add(e) {
    this.decorations.push(e);
  }
  getDecorations() {
    return this.decorations;
  }
}
class UB extends Eg {
  _render(e, t, i) {
    const s = [];
    for (let a = e; a <= t; a++)
      s[a - e] = new vY();
    if (i.length === 0) return s;
    i.sort(((a, l) => a.className === l.className ? a.startLineNumber === l.startLineNumber ? a.endLineNumber - l.endLineNumber : a.startLineNumber - l.startLineNumber : a.className < l.className ? -1 : 1));
    let o = null, r = 0;
    for (let a = 0, l = i.length; a < l; a++) {
      const d = i[a], h = d.className, c = d.zIndex;
      let u = Math.max(d.startLineNumber, e) - e;
      const g = Math.min(d.endLineNumber, t) - e;
      o === h ? (u = Math.max(r + 1, u), r = Math.max(r, g)) : (o = h, r = g);
      for (let p = u; p <= r; p++) s[p].add(new _Y(h, c, d.tooltip));
    }
    return s;
  }
}
class bY extends to {
  constructor(e) {
    super(e), this._widgets = {}, this._context = e;
    const t = this._context.configuration.options, i = t.get(145);
    this.domNode = wt(document.createElement("div")), this.domNode.setClassName("glyph-margin-widgets"), this.domNode.setPosition("absolute"), this.domNode.setTop(0), this._lineHeight = t.get(67), this._glyphMargin = t.get(57), this._glyphMarginLeft = i.glyphMarginLeft, this._glyphMarginWidth = i.glyphMarginWidth, this._glyphMarginDecorationLaneCount = i.glyphMarginDecorationLaneCount, this._managedDomNodes = [], this._decorationGlyphsToRender = [];
  }
  dispose() {
    this._managedDomNodes = [], this._decorationGlyphsToRender = [], this._widgets = {}, super.dispose();
  }
  getWidgets() {
    return Object.values(this._widgets);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, i = t.get(145);
    return this._lineHeight = t.get(67), this._glyphMargin = t.get(57), this._glyphMarginLeft = i.glyphMarginLeft, this._glyphMarginWidth = i.glyphMarginWidth, this._glyphMarginDecorationLaneCount = i.glyphMarginDecorationLaneCount, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  addWidget(e) {
    const t = wt(e.getDomNode());
    this._widgets[e.getId()] = { widget: e, preference: e.getPosition(), domNode: t, renderInfo: null }, t.setPosition("absolute"), t.setDisplay("none"), t.setAttribute("widgetId", e.getId()), this.domNode.appendChild(t), this.setShouldRender();
  }
  setWidgetPosition(e, t) {
    const i = this._widgets[e.getId()];
    return (i.preference.lane !== t.lane || i.preference.zIndex !== t.zIndex || !D.equalsRange(i.preference.range, t.range)) && (i.preference = t, this.setShouldRender(), !0);
  }
  removeWidget(e) {
    var t;
    const i = e.getId();
    if (this._widgets[i]) {
      const s = this._widgets[i].domNode.domNode;
      delete this._widgets[i], (t = s.parentNode) === null || t === void 0 || t.removeChild(s), this.setShouldRender();
    }
  }
  _collectDecorationBasedGlyphRenderRequest(e, t) {
    var i, s, o;
    const r = e.visibleRange.startLineNumber, a = e.visibleRange.endLineNumber, l = e.getDecorationsInViewport();
    for (const d of l) {
      const h = d.options.glyphMarginClassName;
      if (!h) continue;
      const c = Math.max(d.range.startLineNumber, r), u = Math.min(d.range.endLineNumber, a), g = (s = (i = d.options.glyphMargin) === null || i === void 0 ? void 0 : i.position) !== null && s !== void 0 ? s : _l.Center, p = (o = d.options.zIndex) !== null && o !== void 0 ? o : 0;
      for (let f = c; f <= u; f++) {
        const _ = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new W(f, 0)), v = this._context.viewModel.glyphLanes.getLanesAtLine(_.lineNumber).indexOf(g);
        t.push(new CY(f, v, p, h));
      }
    }
  }
  _collectWidgetBasedGlyphRenderRequest(e, t) {
    const i = e.visibleRange.startLineNumber, s = e.visibleRange.endLineNumber;
    for (const o of Object.values(this._widgets)) {
      const r = o.preference.range, { startLineNumber: a, endLineNumber: l } = this._context.viewModel.coordinatesConverter.convertModelRangeToViewRange(D.lift(r));
      if (!a || !l || l < i || a > s) continue;
      const d = Math.max(a, i), h = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new W(d, 0)), c = this._context.viewModel.glyphLanes.getLanesAtLine(h.lineNumber).indexOf(o.preference.lane);
      t.push(new wY(d, c, o.preference.zIndex, o));
    }
  }
  _collectSortedGlyphRenderRequests(e) {
    const t = [];
    return this._collectDecorationBasedGlyphRenderRequest(e, t), this._collectWidgetBasedGlyphRenderRequest(e, t), t.sort(((i, s) => i.lineNumber === s.lineNumber ? i.laneIndex === s.laneIndex ? i.zIndex === s.zIndex ? s.type === i.type ? i.type === 0 && s.type === 0 ? i.className < s.className ? -1 : 1 : 0 : s.type - i.type : s.zIndex - i.zIndex : i.laneIndex - s.laneIndex : i.lineNumber - s.lineNumber)), t;
  }
  prepareRender(e) {
    if (!this._glyphMargin) return void (this._decorationGlyphsToRender = []);
    for (const s of Object.values(this._widgets)) s.renderInfo = null;
    const t = new Pd(this._collectSortedGlyphRenderRequests(e)), i = [];
    for (; t.length > 0; ) {
      const s = t.peek();
      if (!s) break;
      const o = t.takeWhile(((a) => a.lineNumber === s.lineNumber && a.laneIndex === s.laneIndex));
      if (!o || o.length === 0) break;
      const r = o[0];
      if (r.type === 0) {
        const a = [];
        for (const l of o) {
          if (l.zIndex !== r.zIndex || l.type !== r.type) break;
          a.length !== 0 && a[a.length - 1] === l.className || a.push(l.className);
        }
        i.push(r.accept(a.join(" ")));
      } else r.widget.renderInfo = { lineNumber: r.lineNumber, laneIndex: r.laneIndex };
    }
    this._decorationGlyphsToRender = i;
  }
  render(e) {
    if (!this._glyphMargin) {
      for (const i of Object.values(this._widgets)) i.domNode.setDisplay("none");
      for (; this._managedDomNodes.length > 0; ) {
        const i = this._managedDomNodes.pop();
        i?.domNode.remove();
      }
      return;
    }
    const t = Math.round(this._glyphMarginWidth / this._glyphMarginDecorationLaneCount);
    for (const i of Object.values(this._widgets)) if (i.renderInfo) {
      const s = e.viewportData.relativeVerticalOffset[i.renderInfo.lineNumber - e.viewportData.startLineNumber], o = this._glyphMarginLeft + i.renderInfo.laneIndex * this._lineHeight;
      i.domNode.setDisplay("block"), i.domNode.setTop(s), i.domNode.setLeft(o), i.domNode.setWidth(t), i.domNode.setHeight(this._lineHeight);
    } else i.domNode.setDisplay("none");
    for (let i = 0; i < this._decorationGlyphsToRender.length; i++) {
      const s = this._decorationGlyphsToRender[i], o = e.viewportData.relativeVerticalOffset[s.lineNumber - e.viewportData.startLineNumber], r = this._glyphMarginLeft + s.laneIndex * this._lineHeight;
      let a;
      i < this._managedDomNodes.length ? a = this._managedDomNodes[i] : (a = wt(document.createElement("div")), this._managedDomNodes.push(a), this.domNode.appendChild(a)), a.setClassName("cgmr codicon " + s.combinedClassName), a.setPosition("absolute"), a.setTop(o), a.setLeft(r), a.setWidth(t), a.setHeight(this._lineHeight);
    }
    for (; this._managedDomNodes.length > this._decorationGlyphsToRender.length; ) {
      const i = this._managedDomNodes.pop();
      i?.domNode.remove();
    }
  }
}
class CY {
  constructor(e, t, i, s) {
    this.lineNumber = e, this.laneIndex = t, this.zIndex = i, this.className = s, this.type = 0;
  }
  accept(e) {
    return new yY(this.lineNumber, this.laneIndex, e);
  }
}
class wY {
  constructor(e, t, i, s) {
    this.lineNumber = e, this.laneIndex = t, this.zIndex = i, this.widget = s, this.type = 1;
  }
}
class yY {
  constructor(e, t, i) {
    this.lineNumber = e, this.laneIndex = t, this.combinedClassName = i;
  }
}
class KB extends V {
  constructor() {
    super(...arguments), this._isDisposed = !1;
  }
  dispose() {
    super.dispose(), this._isDisposed = !0;
  }
  assertNotDisposed() {
    if (this._isDisposed) throw new Error("TextModelPart is disposed!");
  }
}
function hL(n, e) {
  let t = 0, i = 0;
  const s = n.length;
  for (; i < s; ) {
    const o = n.charCodeAt(i);
    if (o === 32) t++;
    else {
      if (o !== 9) break;
      t = t - t % e + e;
    }
    i++;
  }
  return i === s ? -1 : t;
}
(function(n) {
  n[n.Disabled = 0] = "Disabled", n[n.EnabledForActive = 1] = "EnabledForActive", n[n.Enabled = 2] = "Enabled";
})(Ku || (Ku = {}));
class Mu {
  constructor(e, t, i, s, o, r) {
    if (this.visibleColumn = e, this.column = t, this.className = i, this.horizontalLine = s, this.forWrappedLinesAfterColumn = o, this.forWrappedLinesBeforeOrAtColumn = r, e !== -1 == (t !== -1)) throw new Error();
  }
}
class i0 {
  constructor(e, t) {
    this.top = e, this.endColumn = t;
  }
}
class SY extends KB {
  constructor(e, t) {
    super(), this.textModel = e, this.languageConfigurationService = t;
  }
  getLanguageConfiguration(e) {
    return this.languageConfigurationService.getLanguageConfiguration(e);
  }
  _computeIndentLevel(e) {
    return hL(this.textModel.getLineContent(e + 1), this.textModel.getOptions().tabSize);
  }
  getActiveIndentGuide(e, t, i) {
    this.assertNotDisposed();
    const s = this.textModel.getLineCount();
    if (e < 1 || e > s) throw new Kt("Illegal value for lineNumber");
    const o = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules, r = !!(o && o.offSide);
    let a = -2, l = -1, d = -2, h = -1;
    const c = (k) => {
      if (a !== -1 && (a === -2 || a > k - 1)) {
        a = -1, l = -1;
        for (let N = k - 2; N >= 0; N--) {
          const A = this._computeIndentLevel(N);
          if (A >= 0) {
            a = N, l = A;
            break;
          }
        }
      }
      if (d === -2) {
        d = -1, h = -1;
        for (let N = k; N < s; N++) {
          const A = this._computeIndentLevel(N);
          if (A >= 0) {
            d = N, h = A;
            break;
          }
        }
      }
    };
    let u = -2, g = -1, p = -2, f = -1;
    const _ = (k) => {
      if (u === -2) {
        u = -1, g = -1;
        for (let N = k - 2; N >= 0; N--) {
          const A = this._computeIndentLevel(N);
          if (A >= 0) {
            u = N, g = A;
            break;
          }
        }
      }
      if (p !== -1 && (p === -2 || p < k - 1)) {
        p = -1, f = -1;
        for (let N = k; N < s; N++) {
          const A = this._computeIndentLevel(N);
          if (A >= 0) {
            p = N, f = A;
            break;
          }
        }
      }
    };
    let v = 0, b = !0, C = 0, w = !0, y = 0, L = 0;
    for (let k = 0; b || w; k++) {
      const N = e - k, A = e + k;
      k > 1 && (N < 1 || N < t) && (b = !1), k > 1 && (A > s || A > i) && (w = !1), k > 5e4 && (b = !1, w = !1);
      let B = -1;
      if (b && N >= 1) {
        const O = this._computeIndentLevel(N - 1);
        O >= 0 ? (d = N - 1, h = O, B = Math.ceil(O / this.textModel.getOptions().indentSize)) : (c(N), B = this._getIndentLevelForWhitespaceLine(r, l, h));
      }
      let T = -1;
      if (w && A <= s) {
        const O = this._computeIndentLevel(A - 1);
        O >= 0 ? (u = A - 1, g = O, T = Math.ceil(O / this.textModel.getOptions().indentSize)) : (_(A), T = this._getIndentLevelForWhitespaceLine(r, g, f));
      }
      if (k !== 0) {
        if (k === 1) {
          if (A <= s && T >= 0 && L + 1 === T) {
            b = !1, v = A, C = A, y = T;
            continue;
          }
          if (N >= 1 && B >= 0 && B - 1 === L) {
            w = !1, v = N, C = N, y = B;
            continue;
          }
          if (v = e, C = e, y = L, y === 0) return { startLineNumber: v, endLineNumber: C, indent: y };
        }
        b && (B >= y ? v = N : b = !1), w && (T >= y ? C = A : w = !1);
      } else L = B;
    }
    return { startLineNumber: v, endLineNumber: C, indent: y };
  }
  getLinesBracketGuides(e, t, i, s) {
    var o;
    const r = [];
    for (let c = e; c <= t; c++) r.push([]);
    const a = this.textModel.bracketPairs.getBracketPairsInRangeWithMinIndentation(new D(e, 1, t, this.textModel.getLineMaxColumn(t))).toArray();
    let l;
    i && a.length > 0 && (l = (o = iv((e <= i.lineNumber && i.lineNumber <= t ? a : this.textModel.bracketPairs.getBracketPairsInRange(D.fromPositions(i)).toArray()).filter(((c) => D.strictContainsPosition(c.range, i))), ((c) => !0))) === null || o === void 0 ? void 0 : o.range);
    const d = this.textModel.getOptions().bracketPairColorizationOptions.independentColorPoolPerBracketType, h = new jB();
    for (const c of a) {
      if (!c.closingBracketRange) continue;
      const u = l && c.range.equalsRange(l);
      if (!u && !s.includeInactive) continue;
      const g = h.getInlineClassName(c.nestingLevel, c.nestingLevelOfEqualBracketType, d) + (s.highlightActive && u ? " " + h.activeClassName : ""), p = c.openingBracketRange.getStartPosition(), f = c.closingBracketRange.getStartPosition(), _ = s.horizontalGuides === Ku.Enabled || s.horizontalGuides === Ku.EnabledForActive && u;
      if (c.range.startLineNumber === c.range.endLineNumber) {
        _ && r[c.range.startLineNumber - e].push(new Mu(-1, c.openingBracketRange.getEndPosition().column, g, new i0(!1, f.column), -1, -1));
        continue;
      }
      const v = this.getVisibleColumnFromPosition(f), b = this.getVisibleColumnFromPosition(c.openingBracketRange.getStartPosition()), C = Math.min(b, v, c.minVisibleColumnIndentation + 1);
      let w = !1;
      Jn(this.textModel.getLineContent(c.closingBracketRange.startLineNumber)) < c.closingBracketRange.startColumn - 1 && (w = !0);
      const y = Math.max(p.lineNumber, e), L = Math.min(f.lineNumber, t), k = w ? 1 : 0;
      for (let N = y; N < L + k; N++) r[N - e].push(new Mu(C, -1, g, null, N === p.lineNumber ? p.column : -1, N === f.lineNumber ? f.column : -1));
      _ && (p.lineNumber >= e && b > C && r[p.lineNumber - e].push(new Mu(C, -1, g, new i0(!1, p.column), -1, -1)), f.lineNumber <= t && v > C && r[f.lineNumber - e].push(new Mu(C, -1, g, new i0(!w, f.column), -1, -1)));
    }
    for (const c of r) c.sort(((u, g) => u.visibleColumn - g.visibleColumn));
    return r;
  }
  getVisibleColumnFromPosition(e) {
    return Gi.visibleColumnFromColumn(this.textModel.getLineContent(e.lineNumber), e.column, this.textModel.getOptions().tabSize) + 1;
  }
  getLinesIndentGuides(e, t) {
    this.assertNotDisposed();
    const i = this.textModel.getLineCount();
    if (e < 1 || e > i) throw new Error("Illegal value for startLineNumber");
    if (t < 1 || t > i) throw new Error("Illegal value for endLineNumber");
    const s = this.textModel.getOptions(), o = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules, r = !!(o && o.offSide), a = new Array(t - e + 1);
    let l = -2, d = -1, h = -2, c = -1;
    for (let u = e; u <= t; u++) {
      const g = u - e, p = this._computeIndentLevel(u - 1);
      if (p >= 0) l = u - 1, d = p, a[g] = Math.ceil(p / s.indentSize);
      else {
        if (l === -2) {
          l = -1, d = -1;
          for (let f = u - 2; f >= 0; f--) {
            const _ = this._computeIndentLevel(f);
            if (_ >= 0) {
              l = f, d = _;
              break;
            }
          }
        }
        if (h !== -1 && (h === -2 || h < u - 1)) {
          h = -1, c = -1;
          for (let f = u; f < i; f++) {
            const _ = this._computeIndentLevel(f);
            if (_ >= 0) {
              h = f, c = _;
              break;
            }
          }
        }
        a[g] = this._getIndentLevelForWhitespaceLine(r, d, c);
      }
    }
    return a;
  }
  _getIndentLevelForWhitespaceLine(e, t, i) {
    const s = this.textModel.getOptions();
    return t === -1 || i === -1 ? 0 : t < i ? 1 + Math.floor(t / s.indentSize) : t === i || e ? Math.ceil(i / s.indentSize) : 1 + Math.floor(i / s.indentSize);
  }
}
class jB {
  constructor() {
    this.activeClassName = "indent-active";
  }
  getInlineClassName(e, t, i) {
    return this.getInlineClassNameOfLevel(i ? t : e);
  }
  getInlineClassNameOfLevel(e) {
    return "bracket-indent-guide lvl-" + e % 30;
  }
}
class LY extends Eg {
  constructor(e) {
    super(), this._context = e, this._primaryPosition = null;
    const t = this._context.configuration.options, i = t.get(146), s = t.get(50);
    this._spaceWidth = s.spaceWidth, this._maxIndentLeft = i.wrappingColumn === -1 ? -1 : i.wrappingColumn * s.typicalHalfwidthCharacterWidth, this._bracketPairGuideOptions = t.get(16), this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, i = t.get(146), s = t.get(50);
    return this._spaceWidth = s.spaceWidth, this._maxIndentLeft = i.wrappingColumn === -1 ? -1 : i.wrappingColumn * s.typicalHalfwidthCharacterWidth, this._bracketPairGuideOptions = t.get(16), !0;
  }
  onCursorStateChanged(e) {
    var t;
    const i = e.selections[0].getPosition();
    return !(!((t = this._primaryPosition) === null || t === void 0) && t.equals(i)) && (this._primaryPosition = i, !0);
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onLanguageConfigurationChanged(e) {
    return !0;
  }
  prepareRender(e) {
    var t, i, s, o;
    if (!this._bracketPairGuideOptions.indentation && this._bracketPairGuideOptions.bracketPairs === !1) return void (this._renderResult = null);
    const r = e.visibleRange.startLineNumber, a = e.visibleRange.endLineNumber, l = e.scrollWidth, d = this._primaryPosition, h = this.getGuidesByLine(r, Math.min(a + 1, this._context.viewModel.getLineCount()), d), c = [];
    for (let u = r; u <= a; u++) {
      const g = u - r, p = h[g];
      let f = "";
      const _ = (i = (t = e.visibleRangeForPosition(new W(u, 1))) === null || t === void 0 ? void 0 : t.left) !== null && i !== void 0 ? i : 0;
      for (const v of p) {
        const b = v.column === -1 ? _ + (v.visibleColumn - 1) * this._spaceWidth : e.visibleRangeForPosition(new W(u, v.column)).left;
        if (b > l || this._maxIndentLeft > 0 && b > this._maxIndentLeft) break;
        const C = v.horizontalLine ? v.horizontalLine.top ? "horizontal-top" : "horizontal-bottom" : "vertical", w = v.horizontalLine ? ((o = (s = e.visibleRangeForPosition(new W(u, v.horizontalLine.endColumn))) === null || s === void 0 ? void 0 : s.left) !== null && o !== void 0 ? o : b + this._spaceWidth) - b : this._spaceWidth;
        f += `<div class="core-guide ${v.className} ${C}" style="left:${b}px;width:${w}px"></div>`;
      }
      c[g] = f;
    }
    this._renderResult = c;
  }
  getGuidesByLine(e, t, i) {
    const s = this._bracketPairGuideOptions.bracketPairs !== !1 ? this._context.viewModel.getBracketGuidesInRangeByLine(e, t, i, { highlightActive: this._bracketPairGuideOptions.highlightActiveBracketPair, horizontalGuides: this._bracketPairGuideOptions.bracketPairsHorizontal === !0 ? Ku.Enabled : this._bracketPairGuideOptions.bracketPairsHorizontal === "active" ? Ku.EnabledForActive : Ku.Disabled, includeInactive: this._bracketPairGuideOptions.bracketPairs === !0 }) : null, o = this._bracketPairGuideOptions.indentation ? this._context.viewModel.getLinesIndentGuides(e, t) : null;
    let r = 0, a = 0, l = 0;
    if (this._bracketPairGuideOptions.highlightActiveIndentation !== !1 && i) {
      const c = this._context.viewModel.getActiveIndentGuide(i.lineNumber, e, t);
      r = c.startLineNumber, a = c.endLineNumber, l = c.indent;
    }
    const { indentSize: d } = this._context.viewModel.model.getOptions(), h = [];
    for (let c = e; c <= t; c++) {
      const u = new Array();
      h.push(u);
      const g = s ? s[c - e] : [], p = new Pd(g), f = o ? o[c - e] : 0;
      for (let _ = 1; _ <= f; _++) {
        const v = (_ - 1) * d + 1, b = (this._bracketPairGuideOptions.highlightActiveIndentation === "always" || g.length === 0) && r <= c && c <= a && _ === l;
        u.push(...p.takeWhile(((w) => w.visibleColumn < v)) || []);
        const C = p.peek();
        C && C.visibleColumn === v && !C.horizontalLine || u.push(new Mu(v, -1, "core-guide-indent lvl-" + (_ - 1) % 30 + (b ? " indent-active" : ""), null, -1, -1));
      }
      u.push(...p.takeWhile(((_) => !0)) || []);
    }
    return h;
  }
  render(e, t) {
    if (!this._renderResult) return "";
    const i = t - e;
    return i < 0 || i >= this._renderResult.length ? "" : this._renderResult[i];
  }
}
function $g(n) {
  if (!n || !n.isTransparent()) return n;
}
rr(((n, e) => {
  const t = [{ bracketColor: IB, guideColor: AZ, guideColorActive: VZ }, { bracketColor: MB, guideColor: PZ, guideColorActive: HZ }, { bracketColor: TB, guideColor: OZ, guideColorActive: zZ }, { bracketColor: RB, guideColor: FZ, guideColorActive: UZ }, { bracketColor: AB, guideColor: BZ, guideColorActive: KZ }, { bracketColor: PB, guideColor: WZ, guideColorActive: jZ }], i = new jB(), s = [{ indentColor: L1, indentColorActive: k1 }, { indentColor: fZ, indentColorActive: wZ }, { indentColor: _Z, indentColorActive: yZ }, { indentColor: vZ, indentColorActive: SZ }, { indentColor: bZ, indentColorActive: LZ }, { indentColor: CZ, indentColorActive: kZ }], o = t.map(((a) => {
    var l, d;
    const h = n.getColor(a.bracketColor), c = n.getColor(a.guideColor), u = n.getColor(a.guideColorActive), g = $g((l = $g(c)) !== null && l !== void 0 ? l : h?.transparent(0.3)), p = $g((d = $g(u)) !== null && d !== void 0 ? d : h);
    if (g && p) return { guideColor: g, guideColorActive: p };
  })).filter(hl), r = s.map(((a) => {
    const l = n.getColor(a.indentColor), d = n.getColor(a.indentColorActive), h = $g(l), c = $g(d);
    if (h && c) return { indentColor: h, indentColorActive: c };
  })).filter(hl);
  if (o.length > 0) {
    for (let a = 0; a < 30; a++) {
      const l = o[a % o.length];
      e.addRule(`.monaco-editor .${i.getInlineClassNameOfLevel(a).replace(/ /g, ".")} { --guide-color: ${l.guideColor}; --guide-color-active: ${l.guideColorActive}; }`);
    }
    e.addRule(".monaco-editor .vertical { box-shadow: 1px 0 0 0 var(--guide-color) inset; }"), e.addRule(".monaco-editor .horizontal-top { border-top: 1px solid var(--guide-color); }"), e.addRule(".monaco-editor .horizontal-bottom { border-bottom: 1px solid var(--guide-color); }"), e.addRule(`.monaco-editor .vertical.${i.activeClassName} { box-shadow: 1px 0 0 0 var(--guide-color-active) inset; }`), e.addRule(`.monaco-editor .horizontal-top.${i.activeClassName} { border-top: 1px solid var(--guide-color-active); }`), e.addRule(`.monaco-editor .horizontal-bottom.${i.activeClassName} { border-bottom: 1px solid var(--guide-color-active); }`);
  }
  if (r.length > 0) {
    for (let a = 0; a < 30; a++) {
      const l = r[a % r.length];
      e.addRule(`.monaco-editor .lines-content .core-guide-indent.lvl-${a} { --indent-color: ${l.indentColor}; --indent-color-active: ${l.indentColorActive}; }`);
    }
    e.addRule(".monaco-editor .lines-content .core-guide-indent { box-shadow: 1px 0 0 0 var(--indent-color) inset; }"), e.addRule(".monaco-editor .lines-content .core-guide-indent.indent-active { box-shadow: 1px 0 0 0 var(--indent-color-active) inset; }");
  }
}));
class bD {
  get didDomLayout() {
    return this._didDomLayout;
  }
  readClientRect() {
    if (!this._clientRectRead) {
      this._clientRectRead = !0;
      const e = this._domNode.getBoundingClientRect();
      this.markDidDomLayout(), this._clientRectDeltaLeft = e.left, this._clientRectScale = e.width / this._domNode.offsetWidth;
    }
  }
  get clientRectDeltaLeft() {
    return this._clientRectRead || this.readClientRect(), this._clientRectDeltaLeft;
  }
  get clientRectScale() {
    return this._clientRectRead || this.readClientRect(), this._clientRectScale;
  }
  constructor(e, t) {
    this._domNode = e, this.endNode = t, this._didDomLayout = !1, this._clientRectDeltaLeft = 0, this._clientRectScale = 1, this._clientRectRead = !1;
  }
  markDidDomLayout() {
    this._didDomLayout = !0;
  }
}
class kY {
  constructor() {
    this._currentVisibleRange = new D(1, 1, 1, 1);
  }
  getCurrentVisibleRange() {
    return this._currentVisibleRange;
  }
  setCurrentVisibleRange(e) {
    this._currentVisibleRange = e;
  }
}
class DY {
  constructor(e, t, i, s, o, r, a) {
    this.minimalReveal = e, this.lineNumber = t, this.startColumn = i, this.endColumn = s, this.startScrollTop = o, this.stopScrollTop = r, this.scrollType = a, this.type = "range", this.minLineNumber = t, this.maxLineNumber = t;
  }
}
class xY {
  constructor(e, t, i, s, o) {
    this.minimalReveal = e, this.selections = t, this.startScrollTop = i, this.stopScrollTop = s, this.scrollType = o, this.type = "selections";
    let r = t[0].startLineNumber, a = t[0].endLineNumber;
    for (let l = 1, d = t.length; l < d; l++) {
      const h = t[l];
      r = Math.min(r, h.startLineNumber), a = Math.max(a, h.endLineNumber);
    }
    this.minLineNumber = r, this.maxLineNumber = a;
  }
}
class cL extends to {
  constructor(e, t) {
    super(e), this._linesContent = t, this._textRangeRestingSpot = document.createElement("div"), this._visibleLines = new VB(this), this.domNode = this._visibleLines.domNode;
    const i = this._context.configuration, s = this._context.configuration.options, o = s.get(50), r = s.get(146);
    this._lineHeight = s.get(67), this._typicalHalfwidthCharacterWidth = o.typicalHalfwidthCharacterWidth, this._isViewportWrapping = r.isViewportWrapping, this._revealHorizontalRightPadding = s.get(100), this._cursorSurroundingLines = s.get(29), this._cursorSurroundingLinesStyle = s.get(30), this._canUseLayerHinting = !s.get(32), this._viewLineOptions = new U4(i, this._context.theme.type), fa.write(this.domNode, 8), this.domNode.setClassName(`view-lines ${nm}`), yn(this.domNode, o), this._maxLineWidth = 0, this._asyncUpdateLineWidths = new Et((() => {
      this._updateLineWidthsSlow();
    }), 200), this._asyncCheckMonospaceFontAssumptions = new Et((() => {
      this._checkMonospaceFontAssumptions();
    }), 2e3), this._lastRenderedData = new kY(), this._horizontalRevealRequest = null, this._stickyScrollEnabled = s.get(115).enabled, this._maxNumberStickyLines = s.get(115).maxLineCount;
  }
  dispose() {
    this._asyncUpdateLineWidths.dispose(), this._asyncCheckMonospaceFontAssumptions.dispose(), super.dispose();
  }
  getDomNode() {
    return this.domNode;
  }
  createVisibleLine() {
    return new $a(this._viewLineOptions);
  }
  onConfigurationChanged(e) {
    this._visibleLines.onConfigurationChanged(e), e.hasChanged(146) && (this._maxLineWidth = 0);
    const t = this._context.configuration.options, i = t.get(50), s = t.get(146);
    return this._lineHeight = t.get(67), this._typicalHalfwidthCharacterWidth = i.typicalHalfwidthCharacterWidth, this._isViewportWrapping = s.isViewportWrapping, this._revealHorizontalRightPadding = t.get(100), this._cursorSurroundingLines = t.get(29), this._cursorSurroundingLinesStyle = t.get(30), this._canUseLayerHinting = !t.get(32), this._stickyScrollEnabled = t.get(115).enabled, this._maxNumberStickyLines = t.get(115).maxLineCount, yn(this.domNode, i), this._onOptionsMaybeChanged(), e.hasChanged(145) && (this._maxLineWidth = 0), !0;
  }
  _onOptionsMaybeChanged() {
    const e = this._context.configuration, t = new U4(e, this._context.theme.type);
    if (!this._viewLineOptions.equals(t)) {
      this._viewLineOptions = t;
      const i = this._visibleLines.getStartLineNumber(), s = this._visibleLines.getEndLineNumber();
      for (let o = i; o <= s; o++)
        this._visibleLines.getVisibleLine(o).onOptionsChanged(this._viewLineOptions);
      return !0;
    }
    return !1;
  }
  onCursorStateChanged(e) {
    const t = this._visibleLines.getStartLineNumber(), i = this._visibleLines.getEndLineNumber();
    let s = !1;
    for (let o = t; o <= i; o++) s = this._visibleLines.getVisibleLine(o).onSelectionChanged() || s;
    return s;
  }
  onDecorationsChanged(e) {
    {
      const t = this._visibleLines.getStartLineNumber(), i = this._visibleLines.getEndLineNumber();
      for (let s = t; s <= i; s++) this._visibleLines.getVisibleLine(s).onDecorationsChanged();
    }
    return !0;
  }
  onFlushed(e) {
    const t = this._visibleLines.onFlushed(e);
    return this._maxLineWidth = 0, t;
  }
  onLinesChanged(e) {
    return this._visibleLines.onLinesChanged(e);
  }
  onLinesDeleted(e) {
    return this._visibleLines.onLinesDeleted(e);
  }
  onLinesInserted(e) {
    return this._visibleLines.onLinesInserted(e);
  }
  onRevealRangeRequest(e) {
    const t = this._computeScrollTopToRevealRange(this._context.viewLayout.getFutureViewport(), e.source, e.minimalReveal, e.range, e.selections, e.verticalType);
    if (t === -1) return !1;
    let i = this._context.viewLayout.validateScrollPosition({ scrollTop: t });
    e.revealHorizontal ? e.range && e.range.startLineNumber !== e.range.endLineNumber ? i = { scrollTop: i.scrollTop, scrollLeft: 0 } : e.range ? this._horizontalRevealRequest = new DY(e.minimalReveal, e.range.startLineNumber, e.range.startColumn, e.range.endColumn, this._context.viewLayout.getCurrentScrollTop(), i.scrollTop, e.scrollType) : e.selections && e.selections.length > 0 && (this._horizontalRevealRequest = new xY(e.minimalReveal, e.selections, this._context.viewLayout.getCurrentScrollTop(), i.scrollTop, e.scrollType)) : this._horizontalRevealRequest = null;
    const s = Math.abs(this._context.viewLayout.getCurrentScrollTop() - i.scrollTop) <= this._lineHeight ? 1 : e.scrollType;
    return this._context.viewModel.viewLayout.setScrollPosition(i, s), !0;
  }
  onScrollChanged(e) {
    if (this._horizontalRevealRequest && e.scrollLeftChanged && (this._horizontalRevealRequest = null), this._horizontalRevealRequest && e.scrollTopChanged) {
      const t = Math.min(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop), i = Math.max(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop);
      (e.scrollTop < t || e.scrollTop > i) && (this._horizontalRevealRequest = null);
    }
    return this.domNode.setWidth(e.scrollWidth), this._visibleLines.onScrollChanged(e) || !0;
  }
  onTokensChanged(e) {
    return this._visibleLines.onTokensChanged(e);
  }
  onZonesChanged(e) {
    return this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth), this._visibleLines.onZonesChanged(e);
  }
  onThemeChanged(e) {
    return this._onOptionsMaybeChanged();
  }
  getPositionFromDOMInfo(e, t) {
    const i = this._getViewLineDomNode(e);
    if (i === null) return null;
    const s = this._getLineNumberFor(i);
    if (s === -1 || s < 1 || s > this._context.viewModel.getLineCount()) return null;
    if (this._context.viewModel.getLineMaxColumn(s) === 1) return new W(s, 1);
    const o = this._visibleLines.getStartLineNumber(), r = this._visibleLines.getEndLineNumber();
    if (s < o || s > r) return null;
    let a = this._visibleLines.getVisibleLine(s).getColumnOfNodeOffset(e, t);
    const l = this._context.viewModel.getLineMinColumn(s);
    return a < l && (a = l), new W(s, a);
  }
  _getViewLineDomNode(e) {
    for (; e && e.nodeType === 1; ) {
      if (e.className === $a.CLASS_NAME) return e;
      e = e.parentElement;
    }
    return null;
  }
  _getLineNumberFor(e) {
    const t = this._visibleLines.getStartLineNumber(), i = this._visibleLines.getEndLineNumber();
    for (let s = t; s <= i; s++)
      if (e === this._visibleLines.getVisibleLine(s).getDomNode()) return s;
    return -1;
  }
  getLineWidth(e) {
    const t = this._visibleLines.getStartLineNumber(), i = this._visibleLines.getEndLineNumber();
    if (e < t || e > i) return -1;
    const s = new bD(this.domNode.domNode, this._textRangeRestingSpot), o = this._visibleLines.getVisibleLine(e).getWidth(s);
    return this._updateLineWidthsSlowIfDomDidLayout(s), o;
  }
  linesVisibleRangesForRange(e, t) {
    if (this.shouldRender()) return null;
    const i = e.endLineNumber, s = D.intersectRanges(e, this._lastRenderedData.getCurrentVisibleRange());
    if (!s) return null;
    const o = [];
    let r = 0;
    const a = new bD(this.domNode.domNode, this._textRangeRestingSpot);
    let l = 0;
    t && (l = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new W(s.startLineNumber, 1)).lineNumber);
    const d = this._visibleLines.getStartLineNumber(), h = this._visibleLines.getEndLineNumber();
    for (let c = s.startLineNumber; c <= s.endLineNumber; c++) {
      if (c < d || c > h) continue;
      const u = c === s.startLineNumber ? s.startColumn : 1, g = c !== s.endLineNumber, p = g ? this._context.viewModel.getLineMaxColumn(c) : s.endColumn, f = this._visibleLines.getVisibleLine(c).getVisibleRangesForRange(c, u, p, a);
      if (f) {
        if (t && c < i) {
          const _ = l;
          l = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new W(c + 1, 1)).lineNumber, _ !== l && (f.ranges[f.ranges.length - 1].width += this._typicalHalfwidthCharacterWidth);
        }
        o[r++] = new zG(f.outsideRenderedLine, c, rL.from(f.ranges), g);
      }
    }
    return this._updateLineWidthsSlowIfDomDidLayout(a), r === 0 ? null : o;
  }
  _visibleRangesForLineRange(e, t, i) {
    if (this.shouldRender() || e < this._visibleLines.getStartLineNumber() || e > this._visibleLines.getEndLineNumber()) return null;
    const s = new bD(this.domNode.domNode, this._textRangeRestingSpot), o = this._visibleLines.getVisibleLine(e).getVisibleRangesForRange(e, t, i, s);
    return this._updateLineWidthsSlowIfDomDidLayout(s), o;
  }
  visibleRangeForPosition(e) {
    const t = this._visibleRangesForLineRange(e.lineNumber, e.column, e.column);
    return t ? new UG(t.outsideRenderedLine, t.ranges[0].left) : null;
  }
  _updateLineWidthsFast() {
    return this._updateLineWidths(!0);
  }
  _updateLineWidthsSlow() {
    this._updateLineWidths(!1);
  }
  _updateLineWidthsSlowIfDomDidLayout(e) {
    e.didDomLayout && (this._asyncUpdateLineWidths.isScheduled() || (this._asyncUpdateLineWidths.cancel(), this._updateLineWidthsSlow()));
  }
  _updateLineWidths(e) {
    const t = this._visibleLines.getStartLineNumber(), i = this._visibleLines.getEndLineNumber();
    let s = 1, o = !0;
    for (let r = t; r <= i; r++) {
      const a = this._visibleLines.getVisibleLine(r);
      !e || a.getWidthIsFast() ? s = Math.max(s, a.getWidth(null)) : o = !1;
    }
    return o && t === 1 && i === this._context.viewModel.getLineCount() && (this._maxLineWidth = 0), this._ensureMaxLineWidth(s), o;
  }
  _checkMonospaceFontAssumptions() {
    let e = -1, t = -1;
    const i = this._visibleLines.getStartLineNumber(), s = this._visibleLines.getEndLineNumber();
    for (let o = i; o <= s; o++) {
      const r = this._visibleLines.getVisibleLine(o);
      if (r.needsMonospaceFontCheck()) {
        const a = r.getWidth(null);
        a > t && (t = a, e = o);
      }
    }
    if (e !== -1 && !this._visibleLines.getVisibleLine(e).monospaceAssumptionsAreValid()) for (let o = i; o <= s; o++)
      this._visibleLines.getVisibleLine(o).onMonospaceAssumptionsInvalidated();
  }
  prepareRender() {
    throw new Error("Not supported");
  }
  render() {
    throw new Error("Not supported");
  }
  renderText(e) {
    if (this._visibleLines.renderLines(e), this._lastRenderedData.setCurrentVisibleRange(e.visibleRange), this.domNode.setWidth(this._context.viewLayout.getScrollWidth()), this.domNode.setHeight(Math.min(this._context.viewLayout.getScrollHeight(), 1e6)), this._horizontalRevealRequest) {
      const i = this._horizontalRevealRequest;
      if (e.startLineNumber <= i.minLineNumber && i.maxLineNumber <= e.endLineNumber) {
        this._horizontalRevealRequest = null, this.onDidRender();
        const s = this._computeScrollLeftToReveal(i);
        s && (this._isViewportWrapping || this._ensureMaxLineWidth(s.maxHorizontalOffset), this._context.viewModel.viewLayout.setScrollPosition({ scrollLeft: s.scrollLeft }, i.scrollType));
      }
    }
    if (this._updateLineWidthsFast() ? this._asyncUpdateLineWidths.cancel() : this._asyncUpdateLineWidths.schedule(), Cs && !this._asyncCheckMonospaceFontAssumptions.isScheduled()) {
      const i = this._visibleLines.getStartLineNumber(), s = this._visibleLines.getEndLineNumber();
      for (let o = i; o <= s; o++)
        if (this._visibleLines.getVisibleLine(o).needsMonospaceFontCheck()) {
          this._asyncCheckMonospaceFontAssumptions.schedule();
          break;
        }
    }
    this._linesContent.setLayerHinting(this._canUseLayerHinting), this._linesContent.setContain("strict");
    const t = this._context.viewLayout.getCurrentScrollTop() - e.bigNumbersDelta;
    this._linesContent.setTop(-t), this._linesContent.setLeft(-this._context.viewLayout.getCurrentScrollLeft());
  }
  _ensureMaxLineWidth(e) {
    const t = Math.ceil(e);
    this._maxLineWidth < t && (this._maxLineWidth = t, this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth));
  }
  _computeScrollTopToRevealRange(e, t, i, s, o, r) {
    const a = e.top, l = e.height, d = a + l;
    let h, c, u;
    if (o && o.length > 0) {
      let _ = o[0].startLineNumber, v = o[0].endLineNumber;
      for (let b = 1, C = o.length; b < C; b++) {
        const w = o[b];
        _ = Math.min(_, w.startLineNumber), v = Math.max(v, w.endLineNumber);
      }
      h = !1, c = this._context.viewLayout.getVerticalOffsetForLineNumber(_), u = this._context.viewLayout.getVerticalOffsetForLineNumber(v) + this._lineHeight;
    } else {
      if (!s) return -1;
      h = !0, c = this._context.viewLayout.getVerticalOffsetForLineNumber(s.startLineNumber), u = this._context.viewLayout.getVerticalOffsetForLineNumber(s.endLineNumber) + this._lineHeight;
    }
    let g, p = 0, f = 0;
    if ((t === "mouse" || i) && this._cursorSurroundingLinesStyle === "default") i || (p = this._lineHeight);
    else {
      const _ = Math.min(l / this._lineHeight / 2, this._cursorSurroundingLines);
      p = this._stickyScrollEnabled ? Math.max(_, this._maxNumberStickyLines) * this._lineHeight : _ * this._lineHeight, f = Math.max(0, _ - 1) * this._lineHeight;
    }
    if (i || r !== 0 && r !== 4 || (f += this._lineHeight), c -= p, u += f, u - c > l) {
      if (!h) return -1;
      g = c;
    } else if (r === 5 || r === 6) if (r === 6 && a <= c && u <= d) g = a;
    else {
      const _ = c - Math.max(5 * this._lineHeight, 0.2 * l), v = u - l;
      g = Math.max(v, _);
    }
    else if (r === 1 || r === 2) if (r === 2 && a <= c && u <= d) g = a;
    else {
      const _ = (c + u) / 2;
      g = Math.max(0, _ - l / 2);
    }
    else g = this._computeMinimumScrolling(a, d, c, u, r === 3, r === 4);
    return g;
  }
  _computeScrollLeftToReveal(e) {
    const t = this._context.viewLayout.getCurrentViewport(), i = this._context.configuration.options.get(145), s = t.left, o = s + t.width - i.verticalScrollbarWidth;
    let r = 1073741824, a = 0;
    if (e.type === "range") {
      const l = this._visibleRangesForLineRange(e.lineNumber, e.startColumn, e.endColumn);
      if (!l) return null;
      for (const d of l.ranges) r = Math.min(r, Math.round(d.left)), a = Math.max(a, Math.round(d.left + d.width));
    } else for (const l of e.selections) {
      if (l.startLineNumber !== l.endLineNumber) return null;
      const d = this._visibleRangesForLineRange(l.startLineNumber, l.startColumn, l.endColumn);
      if (!d) return null;
      for (const h of d.ranges) r = Math.min(r, Math.round(h.left)), a = Math.max(a, Math.round(h.left + h.width));
    }
    return e.minimalReveal || (r = Math.max(0, r - cL.HORIZONTAL_EXTRA_PX), a += this._revealHorizontalRightPadding), e.type === "selections" && a - r > t.width ? null : { scrollLeft: this._computeMinimumScrolling(s, o, r, a), maxHorizontalOffset: a };
  }
  _computeMinimumScrolling(e, t, i, s, o, r) {
    o = !!o, r = !!r;
    const a = (t |= 0) - (e |= 0);
    return (s |= 0) - (i |= 0) < a ? o ? i : r ? Math.max(0, s - a) : i < e ? i : s > t ? Math.max(0, s - a) : e : i;
  }
}
cL.HORIZONTAL_EXTRA_PX = 30;
class NY extends UB {
  constructor(e) {
    super(), this._context = e;
    const t = this._context.configuration.options.get(145);
    this._decorationsLeft = t.decorationsLeft, this._decorationsWidth = t.decorationsWidth, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options.get(145);
    return this._decorationsLeft = t.decorationsLeft, this._decorationsWidth = t.decorationsWidth, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  _getDecorations(e) {
    var t, i;
    const s = e.getDecorationsInViewport(), o = [];
    let r = 0;
    for (let a = 0, l = s.length; a < l; a++) {
      const d = s[a], h = d.options.linesDecorationsClassName, c = d.options.zIndex;
      h && (o[r++] = new sI(d.range.startLineNumber, d.range.endLineNumber, h, (t = d.options.linesDecorationsTooltip) !== null && t !== void 0 ? t : null, c));
      const u = d.options.firstLineDecorationClassName;
      u && (o[r++] = new sI(d.range.startLineNumber, d.range.startLineNumber, u, (i = d.options.linesDecorationsTooltip) !== null && i !== void 0 ? i : null, c));
    }
    return o;
  }
  prepareRender(e) {
    const t = e.visibleRange.startLineNumber, i = e.visibleRange.endLineNumber, s = this._render(t, i, this._getDecorations(e)), o = '" style="left:' + this._decorationsLeft.toString() + "px;width:" + this._decorationsWidth.toString() + 'px;"></div>', r = [];
    for (let a = t; a <= i; a++) {
      const l = a - t, d = s[l].getDecorations();
      let h = "";
      for (const c of d) {
        let u = '<div class="cldr ' + c.className;
        c.tooltip !== null && (u += '" title="' + c.tooltip), u += o, h += u;
      }
      r[l] = h;
    }
    this._renderResult = r;
  }
  render(e, t) {
    return this._renderResult ? this._renderResult[t - e] : "";
  }
}
class EY extends UB {
  constructor(e) {
    super(), this._context = e, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    return !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  _getDecorations(e) {
    const t = e.getDecorationsInViewport(), i = [];
    let s = 0;
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.options.marginClassName, d = a.options.zIndex;
      l && (i[s++] = new sI(a.range.startLineNumber, a.range.endLineNumber, l, null, d));
    }
    return i;
  }
  prepareRender(e) {
    const t = e.visibleRange.startLineNumber, i = e.visibleRange.endLineNumber, s = this._render(t, i, this._getDecorations(e)), o = [];
    for (let r = t; r <= i; r++) {
      const a = r - t, l = s[a].getDecorations();
      let d = "";
      for (const h of l) d += '<div class="cmdr ' + h.className + '" style=""></div>';
      o[a] = d;
    }
    this._renderResult = o;
  }
  render(e, t) {
    return this._renderResult ? this._renderResult[t - e] : "";
  }
}
class wo {
  constructor(e, t, i, s) {
    this._rgba8Brand = void 0, this.r = wo._clamp(e), this.g = wo._clamp(t), this.b = wo._clamp(i), this.a = wo._clamp(s);
  }
  equals(e) {
    return this.r === e.r && this.g === e.g && this.b === e.b && this.a === e.a;
  }
  static _clamp(e) {
    return e < 0 ? 0 : e > 255 ? 255 : 0 | e;
  }
}
wo.Empty = new wo(0, 0, 0, 0);
class x1 extends V {
  static getInstance() {
    return this._INSTANCE || (this._INSTANCE = new x1()), this._INSTANCE;
  }
  constructor() {
    super(), this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._updateColorMap(), this._register(ci.onDidChange(((e) => {
      e.changedColorMap && this._updateColorMap();
    })));
  }
  _updateColorMap() {
    const e = ci.getColorMap();
    if (!e) return this._colors = [wo.Empty], void (this._backgroundIsLight = !0);
    this._colors = [wo.Empty];
    for (let i = 1; i < e.length; i++) {
      const s = e[i].rgba;
      this._colors[i] = new wo(s.r, s.g, s.b, Math.round(255 * s.a));
    }
    const t = e[2].getRelativeLuminance();
    this._backgroundIsLight = t >= 0.5, this._onDidChange.fire(void 0);
  }
  getColor(e) {
    return (e < 1 || e >= this._colors.length) && (e = 2), this._colors[e];
  }
  backgroundIsLight() {
    return this._backgroundIsLight;
  }
}
x1._INSTANCE = null;
const IY = (() => {
  const n = [];
  for (let e = 32; e <= 126; e++) n.push(e);
  return n.push(65533), n;
})();
class fv {
  constructor(e, t) {
    this.scale = t, this._minimapCharRendererBrand = void 0, this.charDataNormal = fv.soften(e, 0.8), this.charDataLight = fv.soften(e, 50 / 60);
  }
  static soften(e, t) {
    const i = new Uint8ClampedArray(e.length);
    for (let s = 0, o = e.length; s < o; s++) i[s] = Yw(e[s] * t);
    return i;
  }
  renderChar(e, t, i, s, o, r, a, l, d, h, c) {
    const u = 1 * this.scale, g = 2 * this.scale, p = c ? 1 : g;
    if (t + u > e.width || i + p > e.height) return void console.warn("bad render request outside image data");
    const f = h ? this.charDataLight : this.charDataNormal, _ = ((O, H) => (O -= 32) < 0 || O > 96 ? H <= 2 ? (O + 96) % 96 : 95 : O)(s, d), v = 4 * e.width, b = a.r, C = a.g, w = a.b, y = o.r - b, L = o.g - C, k = o.b - w, N = Math.max(r, l), A = e.data;
    let B = _ * u * g, T = i * v + 4 * t;
    for (let O = 0; O < p; O++) {
      let H = T;
      for (let $ = 0; $ < u; $++) {
        const pe = f[B++] / 255 * (r / 255);
        A[H++] = b + y * pe, A[H++] = C + L * pe, A[H++] = w + k * pe, A[H++] = N;
      }
      T += v;
    }
  }
  blockRenderChar(e, t, i, s, o, r, a, l) {
    const d = 1 * this.scale, h = 2 * this.scale, c = l ? 1 : h;
    if (t + d > e.width || i + c > e.height) return void console.warn("bad render request outside image data");
    const u = 4 * e.width, g = o / 255 * 0.5, p = r.r, f = r.g, _ = r.b, v = p + (s.r - p) * g, b = f + (s.g - f) * g, C = _ + (s.b - _) * g, w = Math.max(o, a), y = e.data;
    let L = i * u + 4 * t;
    for (let k = 0; k < c; k++) {
      let N = L;
      for (let A = 0; A < d; A++) y[N++] = v, y[N++] = b, y[N++] = C, y[N++] = w;
      L += u;
    }
  }
}
const e5 = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15 }, t5 = (n) => {
  const e = new Uint8ClampedArray(n.length / 2);
  for (let t = 0; t < n.length; t += 2) e[t >> 1] = e5[n[t]] << 4 | 15 & e5[n[t + 1]];
  return e;
}, i5 = { 1: pc((() => t5("0000511D6300CF609C709645A78432005642574171487021003C451900274D35D762755E8B629C5BA856AF57BA649530C167D1512A272A3F6038604460398526BCA2A968DB6F8957C768BE5FBE2FB467CF5D8D5B795DC7625B5DFF50DE64C466DB2FC47CD860A65E9A2EB96CB54CE06DA763AB2EA26860524D3763536601005116008177A8705E53AB738E6A982F88BAA35B5F5B626D9C636B449B737E5B7B678598869A662F6B5B8542706C704C80736A607578685B70594A49715A4522E792"))), 2: pc((() => t5("000000000000000055394F383D2800008B8B1F210002000081B1CBCBCC820000847AAF6B9AAF2119BE08B8881AD60000A44FD07DCCF107015338130C00000000385972265F390B406E2437634B4B48031B12B8A0847000001E15B29A402F0000000000004B33460B00007A752C2A0000000000004D3900000084394B82013400ABA5CFC7AD9C0302A45A3E5A98AB000089A43382D97900008BA54AA087A70A0248A6A7AE6DBE0000BF6F94987EA40A01A06DCFA7A7A9030496C32F77891D0000A99FB1A0AFA80603B29AB9CA75930D010C0948354D3900000C0948354F37460D0028BE673D8400000000AF9D7B6E00002B007AA8933400007AA642675C2700007984CFB9C3985B768772A8A6B7B20000CAAECAAFC4B700009F94A6009F840009D09F9BA4CA9C0000CC8FC76DC87F0000C991C472A2000000A894A48CA7B501079BA2C9C69BA20000B19A5D3FA89000005CA6009DA2960901B0A7F0669FB200009D009E00B7890000DAD0F5D092820000D294D4C48BD10000B5A7A4A3B1A50402CAB6CBA6A2000000B5A7A4A3B1A8044FCDADD19D9CB00000B7778F7B8AAE0803C9AB5D3F5D3F00009EA09EA0BAB006039EA0989A8C7900009B9EF4D6B7C00000A9A7816CACA80000ABAC84705D3F000096DA635CDC8C00006F486F266F263D4784006124097B00374F6D2D6D2D6D4A3A95872322000000030000000000008D8939130000000000002E22A5C9CBC70600AB25C0B5C9B400061A2DB04CA67001082AA6BEBEBFC606002321DACBC19E03087AA08B6768380000282FBAC0B8CA7A88AD25BBA5A29900004C396C5894A6000040485A6E356E9442A32CD17EADA70000B4237923628600003E2DE9C1D7B500002F25BBA5A2990000231DB6AFB4A804023025C0B5CAB588062B2CBDBEC0C706882435A75CA20000002326BD6A82A908048B4B9A5A668000002423A09CB4BB060025259C9D8A7900001C1FCAB2C7C700002A2A9387ABA200002626A4A47D6E9D14333163A0C87500004B6F9C2D643A257049364936493647358A34438355497F1A0000A24C1D590000D38DFFBDD4CD3126"))) };
class n0 {
  static create(e, t) {
    if (this.lastCreated && e === this.lastCreated.scale && t === this.lastFontFamily) return this.lastCreated;
    let i;
    return i = i5[e] ? new fv(i5[e](), e) : n0.createFromSampleData(n0.createSampleData(t).data, e), this.lastFontFamily = t, this.lastCreated = i, i;
  }
  static createSampleData(e) {
    const t = document.createElement("canvas"), i = t.getContext("2d");
    t.style.height = "16px", t.height = 16, t.width = 960, t.style.width = "960px", i.fillStyle = "#ffffff", i.font = `bold 16px ${e}`, i.textBaseline = "middle";
    let s = 0;
    for (const o of IY) i.fillText(String.fromCharCode(o), s, 8), s += 10;
    return i.getImageData(0, 0, 960, 16);
  }
  static createFromSampleData(e, t) {
    if (e.length !== 61440) throw new Error("Unexpected source in MinimapCharRenderer");
    const i = n0._downsample(e, t);
    return new fv(i, t);
  }
  static _downsampleChar(e, t, i, s, o) {
    const r = 1 * o, a = 2 * o;
    let l = s, d = 0;
    for (let h = 0; h < a; h++) {
      const c = h / a * 16, u = (h + 1) / a * 16;
      for (let g = 0; g < r; g++) {
        const p = g / r * 10, f = (g + 1) / r * 10;
        let _ = 0, v = 0;
        for (let C = c; C < u; C++) {
          const w = t + 3840 * Math.floor(C), y = 1 - (C - Math.floor(C));
          for (let L = p; L < f; L++) {
            const k = 1 - (L - Math.floor(L)), N = w + 4 * Math.floor(L), A = k * y;
            v += A, _ += e[N] * e[N + 3] / 255 * A;
          }
        }
        const b = _ / v;
        d = Math.max(d, b), i[l++] = Yw(b);
      }
    }
    return d;
  }
  static _downsample(e, t) {
    const i = 2 * t * 1 * t, s = 96 * i, o = new Uint8ClampedArray(s);
    let r = 0, a = 0, l = 0;
    for (let d = 0; d < 96; d++) l = Math.max(l, this._downsampleChar(e, a, o, r, t)), r += i, a += 40;
    if (l > 0) {
      const d = 255 / l;
      for (let h = 0; h < s; h++) o[h] *= d;
    }
    return o;
  }
}
const MY = Tn ? '"Segoe WPC", "Segoe UI", sans-serif' : Je ? "-apple-system, BlinkMacSystemFont, sans-serif" : 'system-ui, "Ubuntu", "Droid Sans", sans-serif';
class rm {
  constructor(e, t, i) {
    const s = e.options, o = s.get(143), r = s.get(145), a = r.minimap, l = s.get(50), d = s.get(73);
    this.renderMinimap = a.renderMinimap, this.size = d.size, this.minimapHeightIsEditorHeight = a.minimapHeightIsEditorHeight, this.scrollBeyondLastLine = s.get(105), this.paddingTop = s.get(84).top, this.paddingBottom = s.get(84).bottom, this.showSlider = d.showSlider, this.autohide = d.autohide, this.pixelRatio = o, this.typicalHalfwidthCharacterWidth = l.typicalHalfwidthCharacterWidth, this.lineHeight = s.get(67), this.minimapLeft = a.minimapLeft, this.minimapWidth = a.minimapWidth, this.minimapHeight = r.height, this.canvasInnerWidth = a.minimapCanvasInnerWidth, this.canvasInnerHeight = a.minimapCanvasInnerHeight, this.canvasOuterWidth = a.minimapCanvasOuterWidth, this.canvasOuterHeight = a.minimapCanvasOuterHeight, this.isSampling = a.minimapIsSampling, this.editorHeight = r.height, this.fontScale = a.minimapScale, this.minimapLineHeight = a.minimapLineHeight, this.minimapCharWidth = 1 * this.fontScale, this.sectionHeaderFontFamily = MY, this.sectionHeaderFontSize = d.sectionHeaderFontSize * o, this.sectionHeaderFontColor = rm._getSectionHeaderColor(t, i.getColor(1)), this.charRenderer = pc((() => n0.create(this.fontScale, l.fontFamily))), this.defaultBackgroundColor = i.getColor(2), this.backgroundColor = rm._getMinimapBackground(t, this.defaultBackgroundColor), this.foregroundAlpha = rm._getMinimapForegroundOpacity(t);
  }
  static _getMinimapBackground(e, t) {
    const i = e.getColor(P$);
    return i ? new wo(i.rgba.r, i.rgba.g, i.rgba.b, Math.round(255 * i.rgba.a)) : t;
  }
  static _getMinimapForegroundOpacity(e) {
    const t = e.getColor(O$);
    return t ? wo._clamp(Math.round(255 * t.rgba.a)) : 255;
  }
  static _getSectionHeaderColor(e, t) {
    const i = e.getColor(Go);
    return i ? new wo(i.rgba.r, i.rgba.g, i.rgba.b, Math.round(255 * i.rgba.a)) : t;
  }
  equals(e) {
    return this.renderMinimap === e.renderMinimap && this.size === e.size && this.minimapHeightIsEditorHeight === e.minimapHeightIsEditorHeight && this.scrollBeyondLastLine === e.scrollBeyondLastLine && this.paddingTop === e.paddingTop && this.paddingBottom === e.paddingBottom && this.showSlider === e.showSlider && this.autohide === e.autohide && this.pixelRatio === e.pixelRatio && this.typicalHalfwidthCharacterWidth === e.typicalHalfwidthCharacterWidth && this.lineHeight === e.lineHeight && this.minimapLeft === e.minimapLeft && this.minimapWidth === e.minimapWidth && this.minimapHeight === e.minimapHeight && this.canvasInnerWidth === e.canvasInnerWidth && this.canvasInnerHeight === e.canvasInnerHeight && this.canvasOuterWidth === e.canvasOuterWidth && this.canvasOuterHeight === e.canvasOuterHeight && this.isSampling === e.isSampling && this.editorHeight === e.editorHeight && this.fontScale === e.fontScale && this.minimapLineHeight === e.minimapLineHeight && this.minimapCharWidth === e.minimapCharWidth && this.sectionHeaderFontSize === e.sectionHeaderFontSize && this.defaultBackgroundColor && this.defaultBackgroundColor.equals(e.defaultBackgroundColor) && this.backgroundColor && this.backgroundColor.equals(e.backgroundColor) && this.foregroundAlpha === e.foregroundAlpha;
  }
}
class s0 {
  constructor(e, t, i, s, o, r, a, l, d) {
    this.scrollTop = e, this.scrollHeight = t, this.sliderNeeded = i, this._computedSliderRatio = s, this.sliderTop = o, this.sliderHeight = r, this.topPaddingLineCount = a, this.startLineNumber = l, this.endLineNumber = d;
  }
  getDesiredScrollTopFromDelta(e) {
    return Math.round(this.scrollTop + e / this._computedSliderRatio);
  }
  getDesiredScrollTopFromTouchLocation(e) {
    return Math.round((e - this.sliderHeight / 2) / this._computedSliderRatio);
  }
  intersectWithViewport(e) {
    const t = Math.max(this.startLineNumber, e.startLineNumber), i = Math.min(this.endLineNumber, e.endLineNumber);
    return t > i ? null : [t, i];
  }
  getYForLineNumber(e, t) {
    return +(e - this.startLineNumber + this.topPaddingLineCount) * t;
  }
  static create(e, t, i, s, o, r, a, l, d, h, c) {
    const u = e.pixelRatio, g = e.minimapLineHeight, p = Math.floor(e.canvasInnerHeight / g), f = e.lineHeight;
    if (e.minimapHeightIsEditorHeight) {
      let L = l * e.lineHeight + e.paddingTop + e.paddingBottom;
      e.scrollBeyondLastLine && (L += Math.max(0, o - e.lineHeight - e.paddingBottom));
      const k = Math.max(1, Math.floor(o * o / L)), N = Math.max(0, e.minimapHeight - k), A = N / (h - o), B = d * A, T = N > 0, O = Math.floor(e.canvasInnerHeight / e.minimapLineHeight), H = Math.floor(e.paddingTop / e.lineHeight);
      return new s0(d, h, T, A, B, k, H, 1, Math.min(a, O));
    }
    let _;
    if (r && i !== a) {
      const L = i - t + 1;
      _ = Math.floor(L * g / u);
    } else {
      const L = o / f;
      _ = Math.floor(L * g / u);
    }
    const v = Math.floor(e.paddingTop / f);
    let b, C = Math.floor(e.paddingBottom / f);
    if (e.scrollBeyondLastLine) {
      const L = o / f;
      C = Math.max(C, L - 1);
    }
    C > 0 ? b = (v + a + C - o / f - 1) * g / u : b = Math.max(0, (v + a) * g / u - _), b = Math.min(e.minimapHeight - _, b);
    const w = b / (h - o), y = d * w;
    if (p >= v + a + C)
      return new s0(d, h, b > 0, w, y, _, v, 1, a);
    {
      let L, k;
      L = t > 1 ? t + v : Math.max(1, d / f);
      let N = Math.max(1, Math.floor(L - y * u / g));
      N < v ? (k = v - N + 1, N = 1) : (k = 0, N = Math.max(1, N - v)), c && c.scrollHeight === h && (c.scrollTop > d && (N = Math.min(N, c.startLineNumber), k = Math.max(k, c.topPaddingLineCount)), c.scrollTop < d && (N = Math.max(N, c.startLineNumber), k = Math.min(k, c.topPaddingLineCount)));
      const A = Math.min(a, N - k + p - 1), B = (d - s) / f;
      let T;
      return T = d >= e.paddingTop ? (t - N + k + B) * g / u : d / e.paddingTop * (k + B) * g / u, new s0(d, h, !0, w, T, _, k, N, A);
    }
  }
}
class cy {
  constructor(e) {
    this.dy = e;
  }
  onContentChanged() {
    this.dy = -1;
  }
  onTokensChanged() {
    this.dy = -1;
  }
}
cy.INVALID = new cy(-1);
class n5 {
  constructor(e, t, i) {
    this.renderedLayout = e, this._imageData = t, this._renderedLines = new WB((() => cy.INVALID)), this._renderedLines._set(e.startLineNumber, i);
  }
  linesEquals(e) {
    if (!this.scrollEquals(e)) return !1;
    const t = this._renderedLines._get().lines;
    for (let i = 0, s = t.length; i < s; i++) if (t[i].dy === -1) return !1;
    return !0;
  }
  scrollEquals(e) {
    return this.renderedLayout.startLineNumber === e.startLineNumber && this.renderedLayout.endLineNumber === e.endLineNumber;
  }
  _get() {
    const e = this._renderedLines._get();
    return { imageData: this._imageData, rendLineNumberStart: e.rendLineNumberStart, lines: e.lines };
  }
  onLinesChanged(e, t) {
    return this._renderedLines.onLinesChanged(e, t);
  }
  onLinesDeleted(e, t) {
    this._renderedLines.onLinesDeleted(e, t);
  }
  onLinesInserted(e, t) {
    this._renderedLines.onLinesInserted(e, t);
  }
  onTokensChanged(e) {
    return this._renderedLines.onTokensChanged(e);
  }
}
class jR {
  constructor(e, t, i, s) {
    this._backgroundFillData = jR._createBackgroundFillData(t, i, s), this._buffers = [e.createImageData(t, i), e.createImageData(t, i)], this._lastUsedBuffer = 0;
  }
  getBuffer() {
    this._lastUsedBuffer = 1 - this._lastUsedBuffer;
    const e = this._buffers[this._lastUsedBuffer];
    return e.data.set(this._backgroundFillData), e;
  }
  static _createBackgroundFillData(e, t, i) {
    const s = i.r, o = i.g, r = i.b, a = i.a, l = new Uint8ClampedArray(e * t * 4);
    let d = 0;
    for (let h = 0; h < t; h++) for (let c = 0; c < e; c++) l[d] = s, l[d + 1] = o, l[d + 2] = r, l[d + 3] = a, d += 4;
    return l;
  }
}
class _v {
  static compute(e, t, i) {
    if (e.renderMinimap === 0 || !e.isSampling) return [null, []];
    const { minimapLineCount: s } = Zp.computeContainedMinimapLineCount({ viewLineCount: t, scrollBeyondLastLine: e.scrollBeyondLastLine, paddingTop: e.paddingTop, paddingBottom: e.paddingBottom, height: e.editorHeight, lineHeight: e.lineHeight, pixelRatio: e.pixelRatio }), o = t / s, r = o / 2;
    if (!i || i.minimapLines.length === 0) {
      const f = [];
      if (f[0] = 1, s > 1) {
        for (let _ = 0, v = s - 1; _ < v; _++) f[_] = Math.round(_ * o + r);
        f[s - 1] = t;
      }
      return [new _v(o, f), []];
    }
    const a = i.minimapLines, l = a.length, d = [];
    let h = 0, c = 0, u = 1, g = [], p = null;
    for (let f = 0; f < s; f++) {
      const _ = Math.max(u, Math.round(f * o)), v = Math.max(_, Math.round((f + 1) * o));
      for (; h < l && a[h] < _; ) {
        if (g.length < 10) {
          const C = h + 1 + c;
          p && p.type === "deleted" && p._oldIndex === h - 1 ? p.deleteToLineNumber++ : (p = { type: "deleted", _oldIndex: h, deleteFromLineNumber: C, deleteToLineNumber: C }, g.push(p)), c--;
        }
        h++;
      }
      let b;
      if (h < l && a[h] <= v) b = a[h], h++;
      else if (b = f === 0 ? 1 : f + 1 === s ? t : Math.round(f * o + r), g.length < 10) {
        const C = h + 1 + c;
        p && p.type === "inserted" && p._i === f - 1 ? p.insertToLineNumber++ : (p = { type: "inserted", _i: f, insertFromLineNumber: C, insertToLineNumber: C }, g.push(p)), c++;
      }
      d[f] = b, u = b;
    }
    if (g.length < 10) for (; h < l; ) {
      const f = h + 1 + c;
      p && p.type === "deleted" && p._oldIndex === h - 1 ? p.deleteToLineNumber++ : (p = { type: "deleted", _oldIndex: h, deleteFromLineNumber: f, deleteToLineNumber: f }, g.push(p)), c--, h++;
    }
    else g = [{ type: "flush" }];
    return [new _v(o, d), g];
  }
  constructor(e, t) {
    this.samplingRatio = e, this.minimapLines = t;
  }
  modelLineToMinimapLine(e) {
    return Math.min(this.minimapLines.length, Math.max(1, Math.round(e / this.samplingRatio)));
  }
  modelLineRangeToMinimapLineRange(e, t) {
    let i = this.modelLineToMinimapLine(e) - 1;
    for (; i > 0 && this.minimapLines[i - 1] >= e; ) i--;
    let s = this.modelLineToMinimapLine(t) - 1;
    for (; s + 1 < this.minimapLines.length && this.minimapLines[s + 1] <= t; ) s++;
    if (i === s) {
      const o = this.minimapLines[i];
      if (o < e || o > t) return null;
    }
    return [i + 1, s + 1];
  }
  decorationLineRangeToMinimapLineRange(e, t) {
    let i = this.modelLineToMinimapLine(e), s = this.modelLineToMinimapLine(t);
    return e !== t && s === i && (s === this.minimapLines.length ? i > 1 && i-- : s++), [i, s];
  }
  onLinesDeleted(e) {
    const t = e.toLineNumber - e.fromLineNumber + 1;
    let i = this.minimapLines.length, s = 0;
    for (let o = this.minimapLines.length - 1; o >= 0 && !(this.minimapLines[o] < e.fromLineNumber); o--) this.minimapLines[o] <= e.toLineNumber ? (this.minimapLines[o] = Math.max(1, e.fromLineNumber - 1), i = Math.min(i, o), s = Math.max(s, o)) : this.minimapLines[o] -= t;
    return [i, s];
  }
  onLinesInserted(e) {
    const t = e.toLineNumber - e.fromLineNumber + 1;
    for (let i = this.minimapLines.length - 1; i >= 0 && !(this.minimapLines[i] < e.fromLineNumber); i--) this.minimapLines[i] += t;
  }
}
class TY extends to {
  constructor(e) {
    super(e), this._sectionHeaderCache = new Ll(10, 1.5), this.tokensColorTracker = x1.getInstance(), this._selections = [], this._minimapSelections = null, this.options = new rm(this._context.configuration, this._context.theme, this.tokensColorTracker);
    const [t] = _v.compute(this.options, this._context.viewModel.getLineCount(), null);
    this._samplingState = t, this._shouldCheckSampling = !1, this._actual = new Op(e.theme, this);
  }
  dispose() {
    this._actual.dispose(), super.dispose();
  }
  getDomNode() {
    return this._actual.getDomNode();
  }
  _onOptionsMaybeChanged() {
    const e = new rm(this._context.configuration, this._context.theme, this.tokensColorTracker);
    return !this.options.equals(e) && (this.options = e, this._recreateLineSampling(), this._actual.onDidChangeOptions(), !0);
  }
  onConfigurationChanged(e) {
    return this._onOptionsMaybeChanged();
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections, this._minimapSelections = null, this._actual.onSelectionChanged();
  }
  onDecorationsChanged(e) {
    return !!e.affectsMinimap && this._actual.onDecorationsChanged();
  }
  onFlushed(e) {
    return this._samplingState && (this._shouldCheckSampling = !0), this._actual.onFlushed();
  }
  onLinesChanged(e) {
    if (this._samplingState) {
      const t = this._samplingState.modelLineRangeToMinimapLineRange(e.fromLineNumber, e.fromLineNumber + e.count - 1);
      return !!t && this._actual.onLinesChanged(t[0], t[1] - t[0] + 1);
    }
    return this._actual.onLinesChanged(e.fromLineNumber, e.count);
  }
  onLinesDeleted(e) {
    if (this._samplingState) {
      const [t, i] = this._samplingState.onLinesDeleted(e);
      return t <= i && this._actual.onLinesChanged(t + 1, i - t + 1), this._shouldCheckSampling = !0, !0;
    }
    return this._actual.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
  }
  onLinesInserted(e) {
    return this._samplingState ? (this._samplingState.onLinesInserted(e), this._shouldCheckSampling = !0, !0) : this._actual.onLinesInserted(e.fromLineNumber, e.toLineNumber);
  }
  onScrollChanged(e) {
    return this._actual.onScrollChanged();
  }
  onThemeChanged(e) {
    return this._actual.onThemeChanged(), this._onOptionsMaybeChanged(), !0;
  }
  onTokensChanged(e) {
    if (this._samplingState) {
      const t = [];
      for (const i of e.ranges) {
        const s = this._samplingState.modelLineRangeToMinimapLineRange(i.fromLineNumber, i.toLineNumber);
        s && t.push({ fromLineNumber: s[0], toLineNumber: s[1] });
      }
      return !!t.length && this._actual.onTokensChanged(t);
    }
    return this._actual.onTokensChanged(e.ranges);
  }
  onTokensColorsChanged(e) {
    return this._onOptionsMaybeChanged(), this._actual.onTokensColorsChanged();
  }
  onZonesChanged(e) {
    return this._actual.onZonesChanged();
  }
  prepareRender(e) {
    this._shouldCheckSampling && (this._shouldCheckSampling = !1, this._recreateLineSampling());
  }
  render(e) {
    let t = e.visibleRange.startLineNumber, i = e.visibleRange.endLineNumber;
    this._samplingState && (t = this._samplingState.modelLineToMinimapLine(t), i = this._samplingState.modelLineToMinimapLine(i));
    const s = { viewportContainsWhitespaceGaps: e.viewportData.whitespaceViewportData.length > 0, scrollWidth: e.scrollWidth, scrollHeight: e.scrollHeight, viewportStartLineNumber: t, viewportEndLineNumber: i, viewportStartLineNumberVerticalOffset: e.getVerticalOffsetForLineNumber(t), scrollTop: e.scrollTop, scrollLeft: e.scrollLeft, viewportWidth: e.viewportWidth, viewportHeight: e.viewportHeight };
    this._actual.render(s);
  }
  _recreateLineSampling() {
    this._minimapSelections = null;
    const e = !!this._samplingState, [t, i] = _v.compute(this.options, this._context.viewModel.getLineCount(), this._samplingState);
    if (this._samplingState = t, e && this._samplingState) for (const s of i) switch (s.type) {
      case "deleted":
        this._actual.onLinesDeleted(s.deleteFromLineNumber, s.deleteToLineNumber);
        break;
      case "inserted":
        this._actual.onLinesInserted(s.insertFromLineNumber, s.insertToLineNumber);
        break;
      case "flush":
        this._actual.onFlushed();
    }
  }
  getLineCount() {
    return this._samplingState ? this._samplingState.minimapLines.length : this._context.viewModel.getLineCount();
  }
  getRealLineCount() {
    return this._context.viewModel.getLineCount();
  }
  getLineContent(e) {
    return this._samplingState ? this._context.viewModel.getLineContent(this._samplingState.minimapLines[e - 1]) : this._context.viewModel.getLineContent(e);
  }
  getLineMaxColumn(e) {
    return this._samplingState ? this._context.viewModel.getLineMaxColumn(this._samplingState.minimapLines[e - 1]) : this._context.viewModel.getLineMaxColumn(e);
  }
  getMinimapLinesRenderingData(e, t, i) {
    if (this._samplingState) {
      const s = [];
      for (let o = 0, r = t - e + 1; o < r; o++) i[o] ? s[o] = this._context.viewModel.getViewLineData(this._samplingState.minimapLines[e + o - 1]) : s[o] = null;
      return s;
    }
    return this._context.viewModel.getMinimapLinesRenderingData(e, t, i).data;
  }
  getSelections() {
    if (this._minimapSelections === null) if (this._samplingState) {
      this._minimapSelections = [];
      for (const e of this._selections) {
        const [t, i] = this._samplingState.decorationLineRangeToMinimapLineRange(e.startLineNumber, e.endLineNumber);
        this._minimapSelections.push(new _e(t, e.startColumn, i, e.endColumn));
      }
    } else this._minimapSelections = this._selections;
    return this._minimapSelections;
  }
  getMinimapDecorationsInViewport(e, t) {
    const i = this._getMinimapDecorationsInViewport(e, t).filter(((s) => {
      var o;
      return !(!((o = s.options.minimap) === null || o === void 0) && o.sectionHeaderStyle);
    }));
    if (this._samplingState) {
      const s = [];
      for (const o of i) {
        if (!o.options.minimap) continue;
        const r = o.range, a = this._samplingState.modelLineToMinimapLine(r.startLineNumber), l = this._samplingState.modelLineToMinimapLine(r.endLineNumber);
        s.push(new nB(new D(a, r.startColumn, l, r.endColumn), o.options));
      }
      return s;
    }
    return i;
  }
  getSectionHeaderDecorationsInViewport(e, t) {
    const i = this.options.minimapLineHeight, s = this.options.sectionHeaderFontSize / i;
    return e = Math.floor(Math.max(1, e - s)), this._getMinimapDecorationsInViewport(e, t).filter(((o) => {
      var r;
      return !!(!((r = o.options.minimap) === null || r === void 0) && r.sectionHeaderStyle);
    }));
  }
  _getMinimapDecorationsInViewport(e, t) {
    let i;
    if (this._samplingState) {
      const s = this._samplingState.minimapLines[e - 1], o = this._samplingState.minimapLines[t - 1];
      i = new D(s, 1, o, this._context.viewModel.getLineMaxColumn(o));
    } else i = new D(e, 1, t, this._context.viewModel.getLineMaxColumn(t));
    return this._context.viewModel.getMinimapDecorationsInRange(i);
  }
  getSectionHeaderText(e, t) {
    var i;
    const s = (i = e.options.minimap) === null || i === void 0 ? void 0 : i.sectionHeaderText;
    if (!s) return null;
    const o = this._sectionHeaderCache.get(s);
    if (o) return o;
    const r = t(s);
    return this._sectionHeaderCache.set(s, r), r;
  }
  getOptions() {
    return this._context.viewModel.model.getOptions();
  }
  revealLineNumber(e) {
    this._samplingState && (e = this._samplingState.minimapLines[e - 1]), this._context.viewModel.revealRange("mouse", !1, new D(e, 1, e, 1), 1, 0);
  }
  setScrollTop(e) {
    this._context.viewModel.viewLayout.setScrollPosition({ scrollTop: e }, 1);
  }
}
class Op extends V {
  constructor(e, t) {
    super(), this._renderDecorations = !1, this._gestureInProgress = !1, this._theme = e, this._model = t, this._lastRenderData = null, this._buffers = null, this._selectionColor = this._theme.getColor(O4), this._domNode = wt(document.createElement("div")), fa.write(this._domNode, 9), this._domNode.setClassName(this._getMinimapDomNodeClassName()), this._domNode.setPosition("absolute"), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._shadow = wt(document.createElement("div")), this._shadow.setClassName("minimap-shadow-hidden"), this._domNode.appendChild(this._shadow), this._canvas = wt(document.createElement("canvas")), this._canvas.setPosition("absolute"), this._canvas.setLeft(0), this._domNode.appendChild(this._canvas), this._decorationsCanvas = wt(document.createElement("canvas")), this._decorationsCanvas.setPosition("absolute"), this._decorationsCanvas.setClassName("minimap-decorations-layer"), this._decorationsCanvas.setLeft(0), this._domNode.appendChild(this._decorationsCanvas), this._slider = wt(document.createElement("div")), this._slider.setPosition("absolute"), this._slider.setClassName("minimap-slider"), this._slider.setLayerHinting(!0), this._slider.setContain("strict"), this._domNode.appendChild(this._slider), this._sliderHorizontal = wt(document.createElement("div")), this._sliderHorizontal.setPosition("absolute"), this._sliderHorizontal.setClassName("minimap-slider-horizontal"), this._slider.appendChild(this._sliderHorizontal), this._applyLayout(), this._pointerDownListener = bi(this._domNode.domNode, ie.POINTER_DOWN, ((i) => {
      if (i.preventDefault(), this._model.options.renderMinimap === 0 || !this._lastRenderData) return;
      if (this._model.options.size !== "proportional") {
        if (i.button === 0 && this._lastRenderData) {
          const a = Ti(this._slider.domNode), l = a.top + a.height / 2;
          this._startSliderDragging(i, l, this._lastRenderData.renderedLayout);
        }
        return;
      }
      const s = this._model.options.minimapLineHeight, o = this._model.options.canvasInnerHeight / this._model.options.canvasOuterHeight * i.offsetY;
      let r = Math.floor(o / s) + this._lastRenderData.renderedLayout.startLineNumber - this._lastRenderData.renderedLayout.topPaddingLineCount;
      r = Math.min(r, this._model.getLineCount()), this._model.revealLineNumber(r);
    })), this._sliderPointerMoveMonitor = new ff(), this._sliderPointerDownListener = bi(this._slider.domNode, ie.POINTER_DOWN, ((i) => {
      i.preventDefault(), i.stopPropagation(), i.button === 0 && this._lastRenderData && this._startSliderDragging(i, i.pageY, this._lastRenderData.renderedLayout);
    })), this._gestureDisposable = Bt.addTarget(this._domNode.domNode), this._sliderTouchStartListener = K(this._domNode.domNode, Vt.Start, ((i) => {
      i.preventDefault(), i.stopPropagation(), this._lastRenderData && (this._slider.toggleClassName("active", !0), this._gestureInProgress = !0, this.scrollDueToTouchEvent(i));
    }), { passive: !1 }), this._sliderTouchMoveListener = K(this._domNode.domNode, Vt.Change, ((i) => {
      i.preventDefault(), i.stopPropagation(), this._lastRenderData && this._gestureInProgress && this.scrollDueToTouchEvent(i);
    }), { passive: !1 }), this._sliderTouchEndListener = bi(this._domNode.domNode, Vt.End, ((i) => {
      i.preventDefault(), i.stopPropagation(), this._gestureInProgress = !1, this._slider.toggleClassName("active", !1);
    }));
  }
  _startSliderDragging(e, t, i) {
    if (!(e.target && e.target instanceof Element)) return;
    const s = e.pageX;
    this._slider.toggleClassName("active", !0);
    const o = (r, a) => {
      const l = Ti(this._domNode.domNode), d = Math.min(Math.abs(a - s), Math.abs(a - l.left), Math.abs(a - l.left - l.width));
      if (Tn && d > 140) return void this._model.setScrollTop(i.scrollTop);
      const h = r - t;
      this._model.setScrollTop(i.getDesiredScrollTopFromDelta(h));
    };
    e.pageY !== t && o(e.pageY, s), this._sliderPointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, ((r) => o(r.pageY, r.pageX)), (() => {
      this._slider.toggleClassName("active", !1);
    }));
  }
  scrollDueToTouchEvent(e) {
    const t = this._domNode.domNode.getBoundingClientRect().top, i = this._lastRenderData.renderedLayout.getDesiredScrollTopFromTouchLocation(e.pageY - t);
    this._model.setScrollTop(i);
  }
  dispose() {
    this._pointerDownListener.dispose(), this._sliderPointerMoveMonitor.dispose(), this._sliderPointerDownListener.dispose(), this._gestureDisposable.dispose(), this._sliderTouchStartListener.dispose(), this._sliderTouchMoveListener.dispose(), this._sliderTouchEndListener.dispose(), super.dispose();
  }
  _getMinimapDomNodeClassName() {
    const e = ["minimap"];
    return this._model.options.showSlider === "always" ? e.push("slider-always") : e.push("slider-mouseover"), this._model.options.autohide && e.push("autohide"), e.join(" ");
  }
  getDomNode() {
    return this._domNode;
  }
  _applyLayout() {
    this._domNode.setLeft(this._model.options.minimapLeft), this._domNode.setWidth(this._model.options.minimapWidth), this._domNode.setHeight(this._model.options.minimapHeight), this._shadow.setHeight(this._model.options.minimapHeight), this._canvas.setWidth(this._model.options.canvasOuterWidth), this._canvas.setHeight(this._model.options.canvasOuterHeight), this._canvas.domNode.width = this._model.options.canvasInnerWidth, this._canvas.domNode.height = this._model.options.canvasInnerHeight, this._decorationsCanvas.setWidth(this._model.options.canvasOuterWidth), this._decorationsCanvas.setHeight(this._model.options.canvasOuterHeight), this._decorationsCanvas.domNode.width = this._model.options.canvasInnerWidth, this._decorationsCanvas.domNode.height = this._model.options.canvasInnerHeight, this._slider.setWidth(this._model.options.minimapWidth);
  }
  _getBuffer() {
    return this._buffers || this._model.options.canvasInnerWidth > 0 && this._model.options.canvasInnerHeight > 0 && (this._buffers = new jR(this._canvas.domNode.getContext("2d"), this._model.options.canvasInnerWidth, this._model.options.canvasInnerHeight, this._model.options.backgroundColor)), this._buffers ? this._buffers.getBuffer() : null;
  }
  onDidChangeOptions() {
    this._lastRenderData = null, this._buffers = null, this._applyLayout(), this._domNode.setClassName(this._getMinimapDomNodeClassName());
  }
  onSelectionChanged() {
    return this._renderDecorations = !0, !0;
  }
  onDecorationsChanged() {
    return this._renderDecorations = !0, !0;
  }
  onFlushed() {
    return this._lastRenderData = null, !0;
  }
  onLinesChanged(e, t) {
    return !!this._lastRenderData && this._lastRenderData.onLinesChanged(e, t);
  }
  onLinesDeleted(e, t) {
    var i;
    return (i = this._lastRenderData) === null || i === void 0 || i.onLinesDeleted(e, t), !0;
  }
  onLinesInserted(e, t) {
    var i;
    return (i = this._lastRenderData) === null || i === void 0 || i.onLinesInserted(e, t), !0;
  }
  onScrollChanged() {
    return this._renderDecorations = !0, !0;
  }
  onThemeChanged() {
    return this._selectionColor = this._theme.getColor(O4), this._renderDecorations = !0, !0;
  }
  onTokensChanged(e) {
    return !!this._lastRenderData && this._lastRenderData.onTokensChanged(e);
  }
  onTokensColorsChanged() {
    return this._lastRenderData = null, this._buffers = null, !0;
  }
  onZonesChanged() {
    return this._lastRenderData = null, !0;
  }
  render(e) {
    if (this._model.options.renderMinimap === 0) return this._shadow.setClassName("minimap-shadow-hidden"), this._sliderHorizontal.setWidth(0), void this._sliderHorizontal.setHeight(0);
    e.scrollLeft + e.viewportWidth >= e.scrollWidth ? this._shadow.setClassName("minimap-shadow-hidden") : this._shadow.setClassName("minimap-shadow-visible");
    const t = s0.create(this._model.options, e.viewportStartLineNumber, e.viewportEndLineNumber, e.viewportStartLineNumberVerticalOffset, e.viewportHeight, e.viewportContainsWhitespaceGaps, this._model.getLineCount(), this._model.getRealLineCount(), e.scrollTop, e.scrollHeight, this._lastRenderData ? this._lastRenderData.renderedLayout : null);
    this._slider.setDisplay(t.sliderNeeded ? "block" : "none"), this._slider.setTop(t.sliderTop), this._slider.setHeight(t.sliderHeight), this._sliderHorizontal.setLeft(0), this._sliderHorizontal.setWidth(this._model.options.minimapWidth), this._sliderHorizontal.setTop(0), this._sliderHorizontal.setHeight(t.sliderHeight), this.renderDecorations(t), this._lastRenderData = this.renderLines(t);
  }
  renderDecorations(e) {
    if (this._renderDecorations) {
      this._renderDecorations = !1;
      const t = this._model.getSelections();
      t.sort(D.compareRangesUsingStarts);
      const i = this._model.getMinimapDecorationsInViewport(e.startLineNumber, e.endLineNumber);
      i.sort(((u, g) => (u.options.zIndex || 0) - (g.options.zIndex || 0)));
      const { canvasInnerWidth: s, canvasInnerHeight: o } = this._model.options, r = this._model.options.minimapLineHeight, a = this._model.options.minimapCharWidth, l = this._model.getOptions().tabSize, d = this._decorationsCanvas.domNode.getContext("2d");
      d.clearRect(0, 0, s, o);
      const h = new s5(e.startLineNumber, e.endLineNumber, !1);
      this._renderSelectionLineHighlights(d, t, h, e, r), this._renderDecorationsLineHighlights(d, i, h, e, r);
      const c = new s5(e.startLineNumber, e.endLineNumber, null);
      this._renderSelectionsHighlights(d, t, c, e, r, l, a, s), this._renderDecorationsHighlights(d, i, c, e, r, l, a, s), this._renderSectionHeaders(e);
    }
  }
  _renderSelectionLineHighlights(e, t, i, s, o) {
    if (!this._selectionColor || this._selectionColor.isTransparent()) return;
    e.fillStyle = this._selectionColor.transparent(0.5).toString();
    let r = 0, a = 0;
    for (const l of t) {
      const d = s.intersectWithViewport(l);
      if (!d) continue;
      const [h, c] = d;
      for (let p = h; p <= c; p++) i.set(p, !0);
      const u = s.getYForLineNumber(h, o), g = s.getYForLineNumber(c, o);
      a >= u || (a > r && e.fillRect(8, r, e.canvas.width, a - r), r = u), a = g;
    }
    a > r && e.fillRect(8, r, e.canvas.width, a - r);
  }
  _renderDecorationsLineHighlights(e, t, i, s, o) {
    const r = /* @__PURE__ */ new Map();
    for (let a = t.length - 1; a >= 0; a--) {
      const l = t[a], d = l.options.minimap;
      if (!d || d.position !== 1) continue;
      const h = s.intersectWithViewport(l.range);
      if (!h) continue;
      const [c, u] = h, g = d.getColor(this._theme.value);
      if (!g || g.isTransparent()) continue;
      let p = r.get(g.toString());
      p || (p = g.transparent(0.5).toString(), r.set(g.toString(), p)), e.fillStyle = p;
      for (let f = c; f <= u; f++) {
        if (i.has(f)) continue;
        i.set(f, !0);
        const _ = s.getYForLineNumber(c, o);
        e.fillRect(8, _, e.canvas.width, o);
      }
    }
  }
  _renderSelectionsHighlights(e, t, i, s, o, r, a, l) {
    if (this._selectionColor && !this._selectionColor.isTransparent()) for (const d of t) {
      const h = s.intersectWithViewport(d);
      if (!h) continue;
      const [c, u] = h;
      for (let g = c; g <= u; g++) this.renderDecorationOnLine(e, i, d, this._selectionColor, s, g, o, o, r, a, l);
    }
  }
  _renderDecorationsHighlights(e, t, i, s, o, r, a, l) {
    for (const d of t) {
      const h = d.options.minimap;
      if (!h) continue;
      const c = s.intersectWithViewport(d.range);
      if (!c) continue;
      const [u, g] = c, p = h.getColor(this._theme.value);
      if (p && !p.isTransparent()) for (let f = u; f <= g; f++) switch (h.position) {
        case 1:
          this.renderDecorationOnLine(e, i, d.range, p, s, f, o, o, r, a, l);
          continue;
        case 2: {
          const _ = s.getYForLineNumber(f, o);
          this.renderDecoration(e, p, 2, _, 2, o);
          continue;
        }
      }
    }
  }
  renderDecorationOnLine(e, t, i, s, o, r, a, l, d, h, c) {
    const u = o.getYForLineNumber(r, l);
    if (u + a < 0 || u > this._model.options.canvasInnerHeight) return;
    const { startLineNumber: g, endLineNumber: p } = i, f = g === r ? i.startColumn : 1, _ = p === r ? i.endColumn : this._model.getLineMaxColumn(r), v = this.getXOffsetForPosition(t, r, f, d, h, c), b = this.getXOffsetForPosition(t, r, _, d, h, c);
    this.renderDecoration(e, s, v, u, b - v, a);
  }
  getXOffsetForPosition(e, t, i, s, o, r) {
    if (i === 1) return 8;
    if ((i - 1) * o >= r) return r;
    let a = e.get(t);
    if (!a) {
      const l = this._model.getLineContent(t);
      a = [8];
      let d = 8;
      for (let h = 1; h < l.length + 1; h++) {
        const c = l.charCodeAt(h - 1), u = d + (c === 9 ? s * o : fc(c) ? 2 * o : o);
        if (u >= r) {
          a[h] = r;
          break;
        }
        a[h] = u, d = u;
      }
      e.set(t, a);
    }
    return i - 1 < a.length ? a[i - 1] : r;
  }
  renderDecoration(e, t, i, s, o, r) {
    e.fillStyle = t && t.toString() || "", e.fillRect(i, s, o, r);
  }
  _renderSectionHeaders(e) {
    var t;
    const i = this._model.options.minimapLineHeight, s = this._model.options.sectionHeaderFontSize, o = 1.5 * s, { canvasInnerWidth: r } = this._model.options, a = this._model.options.backgroundColor, l = `rgb(${a.r} ${a.g} ${a.b} / .7)`, d = this._model.options.sectionHeaderFontColor, h = `rgb(${d.r} ${d.g} ${d.b})`, c = h, u = this._decorationsCanvas.domNode.getContext("2d");
    u.font = s + "px " + this._model.options.sectionHeaderFontFamily, u.strokeStyle = c, u.lineWidth = 0.2;
    const g = this._model.getSectionHeaderDecorationsInViewport(e.startLineNumber, e.endLineNumber);
    g.sort(((f, _) => f.range.startLineNumber - _.range.startLineNumber));
    const p = Op._fitSectionHeader.bind(null, u, r - 8);
    for (const f of g) {
      const _ = e.getYForLineNumber(f.range.startLineNumber, i) + s, v = _ - s, b = v + 2, C = this._model.getSectionHeaderText(f, p);
      Op._renderSectionLabel(u, C, ((t = f.options.minimap) === null || t === void 0 ? void 0 : t.sectionHeaderStyle) === 2, l, h, r, v, o, _, b);
    }
  }
  static _fitSectionHeader(e, t, i) {
    if (!i) return i;
    const s = e.measureText(i).width, o = e.measureText("…").width;
    if (s <= t || s <= o) return i;
    const r = i.length, a = s / i.length, l = Math.floor((t - o) / a) - 1;
    let d = Math.ceil(l / 2);
    for (; d > 0 && /\s/.test(i[d - 1]); ) --d;
    return i.substring(0, d) + "…" + i.substring(r - (l - d));
  }
  static _renderSectionLabel(e, t, i, s, o, r, a, l, d, h) {
    t && (e.fillStyle = s, e.fillRect(0, a, r, l), e.fillStyle = o, e.fillText(t, 8, d)), i && (e.beginPath(), e.moveTo(0, h), e.lineTo(r, h), e.closePath(), e.stroke());
  }
  renderLines(e) {
    const t = e.startLineNumber, i = e.endLineNumber, s = this._model.options.minimapLineHeight;
    if (this._lastRenderData && this._lastRenderData.linesEquals(e)) {
      const O = this._lastRenderData._get();
      return new n5(e, O.imageData, O.lines);
    }
    const o = this._getBuffer();
    if (!o) return null;
    const [r, a, l] = Op._renderUntouchedLines(o, e.topPaddingLineCount, t, i, s, this._lastRenderData), d = this._model.getMinimapLinesRenderingData(t, i, l), h = this._model.getOptions().tabSize, c = this._model.options.defaultBackgroundColor, u = this._model.options.backgroundColor, g = this._model.options.foregroundAlpha, p = this._model.tokensColorTracker, f = p.backgroundIsLight(), _ = this._model.options.renderMinimap, v = this._model.options.charRenderer(), b = this._model.options.fontScale, C = this._model.options.minimapCharWidth, w = (_ === 1 ? 2 : 3) * b, y = s > w ? Math.floor((s - w) / 2) : 0, L = u.a / 255, k = new wo(Math.round((u.r - c.r) * L + c.r), Math.round((u.g - c.g) * L + c.g), Math.round((u.b - c.b) * L + c.b), 255);
    let N = e.topPaddingLineCount * s;
    const A = [];
    for (let O = 0, H = i - t + 1; O < H; O++) l[O] && Op._renderLine(o, k, u.a, f, _, C, p, g, v, N, y, h, d[O], b, s), A[O] = new cy(N), N += s;
    const B = r === -1 ? 0 : r, T = (a === -1 ? o.height : a) - B;
    return this._canvas.domNode.getContext("2d").putImageData(o, 0, 0, 0, B, o.width, T), new n5(e, o, A);
  }
  static _renderUntouchedLines(e, t, i, s, o, r) {
    const a = [];
    if (!r) {
      for (let k = 0, N = s - i + 1; k < N; k++) a[k] = !0;
      return [-1, -1, a];
    }
    const l = r._get(), d = l.imageData.data, h = l.rendLineNumberStart, c = l.lines, u = c.length, g = e.width, p = e.data, f = (s - i + 1) * o * g * 4;
    let _ = -1, v = -1, b = -1, C = -1, w = -1, y = -1, L = t * o;
    for (let k = i; k <= s; k++) {
      const N = k - i, A = k - h, B = A >= 0 && A < u ? c[A].dy : -1;
      if (B === -1) {
        a[N] = !0, L += o;
        continue;
      }
      const T = B * g * 4, O = (B + o) * g * 4, H = L * g * 4, $ = (L + o) * g * 4;
      C === T && y === H ? (C = O, y = $) : (b !== -1 && (p.set(d.subarray(b, C), w), _ === -1 && b === 0 && b === w && (_ = C), v === -1 && C === f && b === w && (v = b)), b = T, C = O, w = H, y = $), a[N] = !1, L += o;
    }
    return b !== -1 && (p.set(d.subarray(b, C), w), _ === -1 && b === 0 && b === w && (_ = C), v === -1 && C === f && b === w && (v = b)), [_ === -1 ? -1 : _ / (4 * g), v === -1 ? -1 : v / (4 * g), a];
  }
  static _renderLine(e, t, i, s, o, r, a, l, d, h, c, u, g, p, f) {
    const _ = g.content, v = g.tokens, b = e.width - r, C = f === 1;
    let w = 8, y = 0, L = 0;
    for (let k = 0, N = v.getCount(); k < N; k++) {
      const A = v.getEndOffset(k), B = v.getForeground(k), T = a.getColor(B);
      for (; y < A; y++) {
        if (w > b) return;
        const O = _.charCodeAt(y);
        if (O === 9) {
          const H = u - (y + L) % u;
          L += H - 1, w += H * r;
        } else if (O === 32) w += r;
        else {
          const H = fc(O) ? 2 : 1;
          for (let $ = 0; $ < H; $++) if (o === 2 ? d.blockRenderChar(e, w, h + c, T, l, t, i, C) : d.renderChar(e, w, h + c, O, T, l, t, i, p, s, C), w += r, w > b) return;
        }
      }
    }
  }
}
class s5 {
  constructor(e, t, i) {
    this._startLineNumber = e, this._endLineNumber = t, this._defaultValue = i, this._values = [];
    for (let s = 0, o = this._endLineNumber - this._startLineNumber + 1; s < o; s++) this._values[s] = i;
  }
  has(e) {
    return this.get(e) !== this._defaultValue;
  }
  set(e, t) {
    e < this._startLineNumber || e > this._endLineNumber || (this._values[e - this._startLineNumber] = t);
  }
  get(e) {
    return e < this._startLineNumber || e > this._endLineNumber ? this._defaultValue : this._values[e - this._startLineNumber];
  }
}
class RY extends to {
  constructor(e, t) {
    super(e), this._viewDomNode = t;
    const i = this._context.configuration.options.get(145);
    this._widgets = {}, this._verticalScrollbarWidth = i.verticalScrollbarWidth, this._minimapWidth = i.minimap.minimapWidth, this._horizontalScrollbarHeight = i.horizontalScrollbarHeight, this._editorHeight = i.height, this._editorWidth = i.width, this._viewDomNodeRect = { top: 0, left: 0, width: 0, height: 0 }, this._domNode = wt(document.createElement("div")), fa.write(this._domNode, 4), this._domNode.setClassName("overlayWidgets"), this.overflowingOverlayWidgetsDomNode = wt(document.createElement("div")), fa.write(this.overflowingOverlayWidgetsDomNode, 5), this.overflowingOverlayWidgetsDomNode.setClassName("overflowingOverlayWidgets");
  }
  dispose() {
    super.dispose(), this._widgets = {};
  }
  getDomNode() {
    return this._domNode;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options.get(145);
    return this._verticalScrollbarWidth = t.verticalScrollbarWidth, this._minimapWidth = t.minimap.minimapWidth, this._horizontalScrollbarHeight = t.horizontalScrollbarHeight, this._editorHeight = t.height, this._editorWidth = t.width, !0;
  }
  addWidget(e) {
    const t = wt(e.getDomNode());
    this._widgets[e.getId()] = { widget: e, preference: null, domNode: t }, t.setPosition("absolute"), t.setAttribute("widgetId", e.getId()), e.allowEditorOverflow ? this.overflowingOverlayWidgetsDomNode.appendChild(t) : this._domNode.appendChild(t), this.setShouldRender(), this._updateMaxMinWidth();
  }
  setWidgetPosition(e, t) {
    const i = this._widgets[e.getId()];
    return i.preference === t ? (this._updateMaxMinWidth(), !1) : (i.preference = t, this.setShouldRender(), this._updateMaxMinWidth(), !0);
  }
  removeWidget(e) {
    const t = e.getId();
    if (this._widgets.hasOwnProperty(t)) {
      const i = this._widgets[t].domNode.domNode;
      delete this._widgets[t], i.remove(), this.setShouldRender(), this._updateMaxMinWidth();
    }
  }
  _updateMaxMinWidth() {
    var e, t;
    let i = 0;
    const s = Object.keys(this._widgets);
    for (let o = 0, r = s.length; o < r; o++) {
      const a = s[o], l = (t = (e = this._widgets[a].widget).getMinContentWidthInPx) === null || t === void 0 ? void 0 : t.call(e);
      l !== void 0 && (i = Math.max(i, l));
    }
    this._context.viewLayout.setOverlayWidgetsMinWidth(i);
  }
  _renderWidget(e) {
    const t = e.domNode;
    if (e.preference !== null) if (e.preference === 0) t.setTop(0), t.setRight(2 * this._verticalScrollbarWidth + this._minimapWidth);
    else if (e.preference === 1) {
      const i = t.domNode.clientHeight;
      t.setTop(this._editorHeight - i - 2 * this._horizontalScrollbarHeight), t.setRight(2 * this._verticalScrollbarWidth + this._minimapWidth);
    } else if (e.preference === 2) t.setTop(0), t.domNode.style.right = "50%";
    else {
      const { top: i, left: s } = e.preference;
      if (this._context.configuration.options.get(42) && e.widget.allowEditorOverflow) {
        const o = this._viewDomNodeRect;
        t.setTop(i + o.top), t.setLeft(s + o.left), t.setPosition("fixed");
      } else t.setTop(i), t.setLeft(s), t.setPosition("absolute");
    }
    else t.setTop("");
  }
  prepareRender(e) {
    this._viewDomNodeRect = Ti(this._viewDomNode.domNode);
  }
  render(e) {
    this._domNode.setWidth(this._editorWidth);
    const t = Object.keys(this._widgets);
    for (let i = 0, s = t.length; i < s; i++) {
      const o = t[i];
      this._renderWidget(this._widgets[o]);
    }
  }
}
class AY {
  constructor(e, t) {
    const i = e.options;
    this.lineHeight = i.get(67), this.pixelRatio = i.get(143), this.overviewRulerLanes = i.get(83), this.renderBorder = i.get(82);
    const s = t.getColor(xZ);
    this.borderColor = s ? s.toString() : null, this.hideCursor = i.get(59);
    const o = t.getColor(al);
    this.cursorColorSingle = o ? o.transparent(0.7).toString() : null;
    const r = t.getColor(xB);
    this.cursorColorPrimary = r ? r.transparent(0.7).toString() : null;
    const a = t.getColor(NB);
    this.cursorColorSecondary = a ? a.transparent(0.7).toString() : null, this.themeType = t.type;
    const l = i.get(73), d = l.enabled, h = l.side, c = t.getColor(NZ), u = ci.getDefaultBackground();
    this.backgroundColor = c || (d && h === "right" ? u : null);
    const g = i.get(145).overviewRuler;
    this.top = g.top, this.right = g.right, this.domWidth = g.width, this.domHeight = g.height, this.overviewRulerLanes === 0 ? (this.canvasWidth = 0, this.canvasHeight = 0) : (this.canvasWidth = this.domWidth * this.pixelRatio | 0, this.canvasHeight = this.domHeight * this.pixelRatio | 0);
    const [p, f] = this._initLanes(1, this.canvasWidth, this.overviewRulerLanes);
    this.x = p, this.w = f;
  }
  _initLanes(e, t, i) {
    const s = t - e;
    if (i >= 3) {
      const o = Math.floor(s / 3), r = Math.floor(s / 3), a = s - o - r, l = e + o;
      return [[0, e, l, e, e + o + a, e, l, e], [0, o, a, o + a, r, o + a + r, a + r, o + a + r]];
    }
    if (i === 2) {
      const o = Math.floor(s / 2), r = s - o;
      return [[0, e, e, e, e + o, e, e, e], [0, o, o, o, r, o + r, o + r, o + r]];
    }
    return [[0, e, e, e, e, e, e, e], [0, s, s, s, s, s, s, s]];
  }
  equals(e) {
    return this.lineHeight === e.lineHeight && this.pixelRatio === e.pixelRatio && this.overviewRulerLanes === e.overviewRulerLanes && this.renderBorder === e.renderBorder && this.borderColor === e.borderColor && this.hideCursor === e.hideCursor && this.cursorColorSingle === e.cursorColorSingle && this.cursorColorPrimary === e.cursorColorPrimary && this.cursorColorSecondary === e.cursorColorSecondary && this.themeType === e.themeType && z.equals(this.backgroundColor, e.backgroundColor) && this.top === e.top && this.right === e.right && this.domWidth === e.domWidth && this.domHeight === e.domHeight && this.canvasWidth === e.canvasWidth && this.canvasHeight === e.canvasHeight;
  }
}
class PY extends to {
  constructor(e) {
    super(e), this._actualShouldRender = 0, this._renderedDecorations = [], this._renderedCursorPositions = [], this._domNode = wt(document.createElement("canvas")), this._domNode.setClassName("decorationsOverviewRuler"), this._domNode.setPosition("absolute"), this._domNode.setLayerHinting(!0), this._domNode.setContain("strict"), this._domNode.setAttribute("aria-hidden", "true"), this._updateSettings(!1), this._tokensColorTrackerListener = ci.onDidChange(((t) => {
      t.changedColorMap && this._updateSettings(!0);
    })), this._cursorPositions = [{ position: new W(1, 1), color: this._settings.cursorColorSingle }];
  }
  dispose() {
    super.dispose(), this._tokensColorTrackerListener.dispose();
  }
  _updateSettings(e) {
    const t = new AY(this._context.configuration, this._context.theme);
    return (!this._settings || !this._settings.equals(t)) && (this._settings = t, this._domNode.setTop(this._settings.top), this._domNode.setRight(this._settings.right), this._domNode.setWidth(this._settings.domWidth), this._domNode.setHeight(this._settings.domHeight), this._domNode.domNode.width = this._settings.canvasWidth, this._domNode.domNode.height = this._settings.canvasHeight, e && this._render(), !0);
  }
  _markRenderingIsNeeded() {
    return this._actualShouldRender = 2, !0;
  }
  _markRenderingIsMaybeNeeded() {
    return this._actualShouldRender = 1, !0;
  }
  onConfigurationChanged(e) {
    return !!this._updateSettings(!1) && this._markRenderingIsNeeded();
  }
  onCursorStateChanged(e) {
    this._cursorPositions = [];
    for (let t = 0, i = e.selections.length; t < i; t++) {
      let s = this._settings.cursorColorSingle;
      i > 1 && (s = t === 0 ? this._settings.cursorColorPrimary : this._settings.cursorColorSecondary), this._cursorPositions.push({ position: e.selections[t].getPosition(), color: s });
    }
    return this._cursorPositions.sort(((t, i) => W.compare(t.position, i.position))), this._markRenderingIsMaybeNeeded();
  }
  onDecorationsChanged(e) {
    return !!e.affectsOverviewRuler && this._markRenderingIsMaybeNeeded();
  }
  onFlushed(e) {
    return this._markRenderingIsNeeded();
  }
  onScrollChanged(e) {
    return !!e.scrollHeightChanged && this._markRenderingIsNeeded();
  }
  onZonesChanged(e) {
    return this._markRenderingIsNeeded();
  }
  onThemeChanged(e) {
    return !!this._updateSettings(!1) && this._markRenderingIsNeeded();
  }
  getDomNode() {
    return this._domNode.domNode;
  }
  prepareRender(e) {
  }
  render(e) {
    this._render(), this._actualShouldRender = 0;
  }
  _render() {
    const e = this._settings.backgroundColor;
    if (this._settings.overviewRulerLanes === 0) return this._domNode.setBackgroundColor(e ? z.Format.CSS.formatHexA(e) : ""), void this._domNode.setDisplay("none");
    const t = this._context.viewModel.getAllOverviewRulerDecorations(this._context.theme);
    if (t.sort(av.compareByRenderingProps), this._actualShouldRender !== 1 || av.equalsArr(this._renderedDecorations, t) || (this._actualShouldRender = 2), this._actualShouldRender !== 1 || ri(this._renderedCursorPositions, this._cursorPositions, ((g, p) => g.position.lineNumber === p.position.lineNumber && g.color === p.color)) || (this._actualShouldRender = 2), this._actualShouldRender === 1) return;
    this._renderedDecorations = t, this._renderedCursorPositions = this._cursorPositions, this._domNode.setDisplay("block");
    const i = this._settings.canvasWidth, s = this._settings.canvasHeight, o = this._settings.lineHeight, r = this._context.viewLayout, a = s / this._context.viewLayout.getScrollHeight(), l = 6 * this._settings.pixelRatio | 0, d = l / 2 | 0, h = this._domNode.domNode.getContext("2d");
    e ? e.isOpaque() ? (h.fillStyle = z.Format.CSS.formatHexA(e), h.fillRect(0, 0, i, s)) : (h.clearRect(0, 0, i, s), h.fillStyle = z.Format.CSS.formatHexA(e), h.fillRect(0, 0, i, s)) : h.clearRect(0, 0, i, s);
    const c = this._settings.x, u = this._settings.w;
    for (const g of t) {
      const p = g.color, f = g.data;
      h.fillStyle = p;
      let _ = 0, v = 0, b = 0;
      for (let C = 0, w = f.length / 3; C < w; C++) {
        const y = f[3 * C], L = f[3 * C + 1], k = f[3 * C + 2];
        let N = r.getVerticalOffsetForLineNumber(L) * a | 0, A = (r.getVerticalOffsetForLineNumber(k) + o) * a | 0;
        if (A - N < l) {
          let B = (N + A) / 2 | 0;
          B < d ? B = d : B + d > s && (B = s - d), N = B - d, A = B + d;
        }
        N > b + 1 || y !== _ ? (C !== 0 && h.fillRect(c[_], v, u[_], b - v), _ = y, v = N, b = A) : A > b && (b = A);
      }
      h.fillRect(c[_], v, u[_], b - v);
    }
    if (!this._settings.hideCursor) {
      const g = 2 * this._settings.pixelRatio | 0, p = g / 2 | 0, f = this._settings.x[7], _ = this._settings.w[7];
      let v = -100, b = -100, C = null;
      for (let w = 0, y = this._cursorPositions.length; w < y; w++) {
        const L = this._cursorPositions[w].color;
        if (!L) continue;
        const k = this._cursorPositions[w].position;
        let N = r.getVerticalOffsetForLineNumber(k.lineNumber) * a | 0;
        N < p ? N = p : N + p > s && (N = s - p);
        const A = N - p, B = A + g;
        A > b + 1 || L !== C ? (w !== 0 && C && h.fillRect(f, v, _, b - v), v = A, b = B) : B > b && (b = B), C = L, h.fillStyle = L;
      }
      C && h.fillRect(f, v, _, b - v);
    }
    this._settings.renderBorder && this._settings.borderColor && this._settings.overviewRulerLanes > 0 && (h.beginPath(), h.lineWidth = 1, h.strokeStyle = this._settings.borderColor, h.moveTo(0, 0), h.lineTo(0, s), h.stroke(), h.moveTo(0, 0), h.lineTo(i, 0), h.stroke());
  }
}
class o5 {
  constructor(e, t, i) {
    this._colorZoneBrand = void 0, this.from = 0 | e, this.to = 0 | t, this.colorId = 0 | i;
  }
  static compare(e, t) {
    return e.colorId === t.colorId ? e.from === t.from ? e.to - t.to : e.from - t.from : e.colorId - t.colorId;
  }
}
class qB {
  constructor(e, t, i, s) {
    this._overviewRulerZoneBrand = void 0, this.startLineNumber = e, this.endLineNumber = t, this.heightInLines = i, this.color = s, this._colorZone = null;
  }
  static compare(e, t) {
    return e.color === t.color ? e.startLineNumber === t.startLineNumber ? e.heightInLines === t.heightInLines ? e.endLineNumber - t.endLineNumber : e.heightInLines - t.heightInLines : e.startLineNumber - t.startLineNumber : e.color < t.color ? -1 : 1;
  }
  setColorZone(e) {
    this._colorZone = e;
  }
  getColorZones() {
    return this._colorZone;
  }
}
class OY {
  constructor(e) {
    this._getVerticalOffsetForLine = e, this._zones = [], this._colorZonesInvalid = !1, this._lineHeight = 0, this._domWidth = 0, this._domHeight = 0, this._outerHeight = 0, this._pixelRatio = 1, this._lastAssignedId = 0, this._color2Id = /* @__PURE__ */ Object.create(null), this._id2Color = [];
  }
  getId2Color() {
    return this._id2Color;
  }
  setZones(e) {
    this._zones = e, this._zones.sort(qB.compare);
  }
  setLineHeight(e) {
    return this._lineHeight !== e && (this._lineHeight = e, this._colorZonesInvalid = !0, !0);
  }
  setPixelRatio(e) {
    this._pixelRatio = e, this._colorZonesInvalid = !0;
  }
  getDOMWidth() {
    return this._domWidth;
  }
  getCanvasWidth() {
    return this._domWidth * this._pixelRatio;
  }
  setDOMWidth(e) {
    return this._domWidth !== e && (this._domWidth = e, this._colorZonesInvalid = !0, !0);
  }
  getDOMHeight() {
    return this._domHeight;
  }
  getCanvasHeight() {
    return this._domHeight * this._pixelRatio;
  }
  setDOMHeight(e) {
    return this._domHeight !== e && (this._domHeight = e, this._colorZonesInvalid = !0, !0);
  }
  getOuterHeight() {
    return this._outerHeight;
  }
  setOuterHeight(e) {
    return this._outerHeight !== e && (this._outerHeight = e, this._colorZonesInvalid = !0, !0);
  }
  resolveColorZones() {
    const e = this._colorZonesInvalid, t = Math.floor(this._lineHeight), i = Math.floor(this.getCanvasHeight()), s = i / Math.floor(this._outerHeight), o = Math.floor(4 * this._pixelRatio / 2), r = [];
    for (let a = 0, l = this._zones.length; a < l; a++) {
      const d = this._zones[a];
      if (!e) {
        const C = d.getColorZones();
        if (C) {
          r.push(C);
          continue;
        }
      }
      const h = this._getVerticalOffsetForLine(d.startLineNumber), c = d.heightInLines === 0 ? this._getVerticalOffsetForLine(d.endLineNumber) + t : h + d.heightInLines * t, u = Math.floor(s * h), g = Math.floor(s * c);
      let p = Math.floor((u + g) / 2), f = g - p;
      f < o && (f = o), p - f < 0 && (p = f), p + f > i && (p = i - f);
      const _ = d.color;
      let v = this._color2Id[_];
      v || (v = ++this._lastAssignedId, this._color2Id[_] = v, this._id2Color[v] = _);
      const b = new o5(p - f, p + f, v);
      d.setColorZone(b), r.push(b);
    }
    return this._colorZonesInvalid = !1, r.sort(o5.compare), r;
  }
}
class FY extends y1 {
  constructor(e, t) {
    super(), this._context = e;
    const i = this._context.configuration.options;
    this._domNode = wt(document.createElement("canvas")), this._domNode.setClassName(t), this._domNode.setPosition("absolute"), this._domNode.setLayerHinting(!0), this._domNode.setContain("strict"), this._zoneManager = new OY(((s) => this._context.viewLayout.getVerticalOffsetForLineNumber(s))), this._zoneManager.setDOMWidth(0), this._zoneManager.setDOMHeight(0), this._zoneManager.setOuterHeight(this._context.viewLayout.getScrollHeight()), this._zoneManager.setLineHeight(i.get(67)), this._zoneManager.setPixelRatio(i.get(143)), this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return e.hasChanged(67) && (this._zoneManager.setLineHeight(t.get(67)), this._render()), e.hasChanged(143) && (this._zoneManager.setPixelRatio(t.get(143)), this._domNode.setWidth(this._zoneManager.getDOMWidth()), this._domNode.setHeight(this._zoneManager.getDOMHeight()), this._domNode.domNode.width = this._zoneManager.getCanvasWidth(), this._domNode.domNode.height = this._zoneManager.getCanvasHeight(), this._render()), !0;
  }
  onFlushed(e) {
    return this._render(), !0;
  }
  onScrollChanged(e) {
    return e.scrollHeightChanged && (this._zoneManager.setOuterHeight(e.scrollHeight), this._render()), !0;
  }
  onZonesChanged(e) {
    return this._render(), !0;
  }
  getDomNode() {
    return this._domNode.domNode;
  }
  setLayout(e) {
    this._domNode.setTop(e.top), this._domNode.setRight(e.right);
    let t = !1;
    t = this._zoneManager.setDOMWidth(e.width) || t, t = this._zoneManager.setDOMHeight(e.height) || t, t && (this._domNode.setWidth(this._zoneManager.getDOMWidth()), this._domNode.setHeight(this._zoneManager.getDOMHeight()), this._domNode.domNode.width = this._zoneManager.getCanvasWidth(), this._domNode.domNode.height = this._zoneManager.getCanvasHeight(), this._render());
  }
  setZones(e) {
    this._zoneManager.setZones(e), this._render();
  }
  _render() {
    if (this._zoneManager.getOuterHeight() === 0) return !1;
    const e = this._zoneManager.getCanvasWidth(), t = this._zoneManager.getCanvasHeight(), i = this._zoneManager.resolveColorZones(), s = this._zoneManager.getId2Color(), o = this._domNode.domNode.getContext("2d");
    return o.clearRect(0, 0, e, t), i.length > 0 && this._renderOneLane(o, i, s, e), !0;
  }
  _renderOneLane(e, t, i, s) {
    let o = 0, r = 0, a = 0;
    for (const l of t) {
      const d = l.colorId, h = l.from, c = l.to;
      d !== o ? (e.fillRect(0, r, s, a - r), o = d, e.fillStyle = i[o], r = h, a = c) : a >= h ? a = Math.max(a, c) : (e.fillRect(0, r, s, a - r), r = h, a = c);
    }
    e.fillRect(0, r, s, a - r);
  }
}
class BY extends to {
  constructor(e) {
    super(e), this.domNode = wt(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.domNode.setClassName("view-rulers"), this._renderedRulers = [];
    const t = this._context.configuration.options;
    this._rulers = t.get(102), this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth;
  }
  dispose() {
    super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._rulers = t.get(102), this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth, !0;
  }
  onScrollChanged(e) {
    return e.scrollHeightChanged;
  }
  prepareRender(e) {
  }
  _ensureRulersCount() {
    const e = this._renderedRulers.length, t = this._rulers.length;
    if (e === t) return;
    if (e < t) {
      const { tabSize: s } = this._context.viewModel.model.getOptions(), o = s;
      let r = t - e;
      for (; r > 0; ) {
        const a = wt(document.createElement("div"));
        a.setClassName("view-ruler"), a.setWidth(o), this.domNode.appendChild(a), this._renderedRulers.push(a), r--;
      }
      return;
    }
    let i = e - t;
    for (; i > 0; ) {
      const s = this._renderedRulers.pop();
      this.domNode.removeChild(s), i--;
    }
  }
  render(e) {
    this._ensureRulersCount();
    for (let t = 0, i = this._rulers.length; t < i; t++) {
      const s = this._renderedRulers[t], o = this._rulers[t];
      s.setBoxShadow(o.color ? `1px 0 0 0 ${o.color} inset` : ""), s.setHeight(Math.min(e.scrollHeight, 1e6)), s.setLeft(o.column * this._typicalHalfwidthCharacterWidth);
    }
  }
}
class WY extends to {
  constructor(e) {
    super(e), this._scrollTop = 0, this._width = 0, this._updateWidth(), this._shouldShow = !1;
    const t = this._context.configuration.options.get(103);
    this._useShadows = t.useShadows, this._domNode = wt(document.createElement("div")), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true");
  }
  dispose() {
    super.dispose();
  }
  _updateShouldShow() {
    const e = this._useShadows && this._scrollTop > 0;
    return this._shouldShow !== e && (this._shouldShow = e, !0);
  }
  getDomNode() {
    return this._domNode;
  }
  _updateWidth() {
    const e = this._context.configuration.options.get(145);
    e.minimap.renderMinimap === 0 || e.minimap.minimapWidth > 0 && e.minimap.minimapLeft === 0 ? this._width = e.width : this._width = e.width - e.verticalScrollbarWidth;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options.get(103);
    return this._useShadows = t.useShadows, this._updateWidth(), this._updateShouldShow(), !0;
  }
  onScrollChanged(e) {
    return this._scrollTop = e.scrollTop, this._updateShouldShow();
  }
  prepareRender(e) {
  }
  render(e) {
    this._domNode.setWidth(this._width), this._domNode.setClassName(this._shouldShow ? "scroll-decoration" : "");
  }
}
class VY {
  constructor(e) {
    this.left = e.left, this.width = e.width, this.startStyle = null, this.endStyle = null;
  }
}
class HY {
  constructor(e, t) {
    this.lineNumber = e, this.ranges = t;
  }
}
function zY(n) {
  return new VY(n);
}
function UY(n) {
  return new HY(n.lineNumber, n.ranges.map(zY));
}
class yi extends Eg {
  constructor(e) {
    super(), this._previousFrameVisibleRangesWithStyle = [], this._context = e;
    const t = this._context.configuration.options;
    this._roundedSelection = t.get(101), this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth, this._selections = [], this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._roundedSelection = t.get(101), this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth, !0;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections.slice(0), !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  _visibleRangesHaveGaps(e) {
    for (let t = 0, i = e.length; t < i; t++)
      if (e[t].ranges.length > 1) return !0;
    return !1;
  }
  _enrichVisibleRangesWithStyle(e, t, i) {
    const s = this._typicalHalfwidthCharacterWidth / 4;
    let o = null, r = null;
    if (i && i.length > 0 && t.length > 0) {
      const a = t[0].lineNumber;
      if (a === e.startLineNumber) for (let d = 0; !o && d < i.length; d++) i[d].lineNumber === a && (o = i[d].ranges[0]);
      const l = t[t.length - 1].lineNumber;
      if (l === e.endLineNumber) for (let d = i.length - 1; !r && d >= 0; d--) i[d].lineNumber === l && (r = i[d].ranges[0]);
      o && !o.startStyle && (o = null), r && !r.startStyle && (r = null);
    }
    for (let a = 0, l = t.length; a < l; a++) {
      const d = t[a].ranges[0], h = d.left, c = d.left + d.width, u = { top: 0, bottom: 0 }, g = { top: 0, bottom: 0 };
      if (a > 0) {
        const p = t[a - 1].ranges[0].left, f = t[a - 1].ranges[0].left + t[a - 1].ranges[0].width;
        _b(h - p) < s ? u.top = 2 : h > p && (u.top = 1), _b(c - f) < s ? g.top = 2 : p < c && c < f && (g.top = 1);
      } else o && (u.top = o.startStyle.top, g.top = o.endStyle.top);
      if (a + 1 < l) {
        const p = t[a + 1].ranges[0].left, f = t[a + 1].ranges[0].left + t[a + 1].ranges[0].width;
        _b(h - p) < s ? u.bottom = 2 : p < h && h < f && (u.bottom = 1), _b(c - f) < s ? g.bottom = 2 : c < f && (g.bottom = 1);
      } else r && (u.bottom = r.startStyle.bottom, g.bottom = r.endStyle.bottom);
      d.startStyle = u, d.endStyle = g;
    }
  }
  _getVisibleRangesWithStyle(e, t, i) {
    const s = (t.linesVisibleRangesForRange(e, !0) || []).map(UY);
    return !this._visibleRangesHaveGaps(s) && this._roundedSelection && this._enrichVisibleRangesWithStyle(t.visibleRange, s, i), s;
  }
  _createSelectionPiece(e, t, i, s, o) {
    return '<div class="cslr ' + i + '" style="top:' + e.toString() + "px;bottom:" + t.toString() + "px;left:" + s.toString() + "px;width:" + o.toString() + 'px;"></div>';
  }
  _actualRenderOneSelection(e, t, i, s) {
    if (s.length === 0) return;
    const o = !!s[0].ranges[0].startStyle, r = s[0].lineNumber, a = s[s.length - 1].lineNumber;
    for (let l = 0, d = s.length; l < d; l++) {
      const h = s[l], c = h.lineNumber, u = c - t, g = i && c === r ? 1 : 0, p = i && c !== r && c === a ? 1 : 0;
      let f = "", _ = "";
      for (let v = 0, b = h.ranges.length; v < b; v++) {
        const C = h.ranges[v];
        if (o) {
          const y = C.startStyle, L = C.endStyle;
          if (y.top === 1 || y.bottom === 1) {
            f += this._createSelectionPiece(g, p, yi.SELECTION_CLASS_NAME, C.left - yi.ROUNDED_PIECE_WIDTH, yi.ROUNDED_PIECE_WIDTH);
            let k = yi.EDITOR_BACKGROUND_CLASS_NAME;
            y.top === 1 && (k += " " + yi.SELECTION_TOP_RIGHT), y.bottom === 1 && (k += " " + yi.SELECTION_BOTTOM_RIGHT), f += this._createSelectionPiece(g, p, k, C.left - yi.ROUNDED_PIECE_WIDTH, yi.ROUNDED_PIECE_WIDTH);
          }
          if (L.top === 1 || L.bottom === 1) {
            f += this._createSelectionPiece(g, p, yi.SELECTION_CLASS_NAME, C.left + C.width, yi.ROUNDED_PIECE_WIDTH);
            let k = yi.EDITOR_BACKGROUND_CLASS_NAME;
            L.top === 1 && (k += " " + yi.SELECTION_TOP_LEFT), L.bottom === 1 && (k += " " + yi.SELECTION_BOTTOM_LEFT), f += this._createSelectionPiece(g, p, k, C.left + C.width, yi.ROUNDED_PIECE_WIDTH);
          }
        }
        let w = yi.SELECTION_CLASS_NAME;
        if (o) {
          const y = C.startStyle, L = C.endStyle;
          y.top === 0 && (w += " " + yi.SELECTION_TOP_LEFT), y.bottom === 0 && (w += " " + yi.SELECTION_BOTTOM_LEFT), L.top === 0 && (w += " " + yi.SELECTION_TOP_RIGHT), L.bottom === 0 && (w += " " + yi.SELECTION_BOTTOM_RIGHT);
        }
        _ += this._createSelectionPiece(g, p, w, C.left, C.width);
      }
      e[u][0] += f, e[u][1] += _;
    }
  }
  prepareRender(e) {
    const t = [], i = e.visibleRange.startLineNumber, s = e.visibleRange.endLineNumber;
    for (let r = i; r <= s; r++)
      t[r - i] = ["", ""];
    const o = [];
    for (let r = 0, a = this._selections.length; r < a; r++) {
      const l = this._selections[r];
      if (l.isEmpty()) {
        o[r] = null;
        continue;
      }
      const d = this._getVisibleRangesWithStyle(l, e, this._previousFrameVisibleRangesWithStyle[r]);
      o[r] = d, this._actualRenderOneSelection(t, i, this._selections.length > 1, d);
    }
    this._previousFrameVisibleRangesWithStyle = o, this._renderResult = t.map((([r, a]) => r + a));
  }
  render(e, t) {
    if (!this._renderResult) return "";
    const i = t - e;
    return i < 0 || i >= this._renderResult.length ? "" : this._renderResult[i];
  }
}
function _b(n) {
  return n < 0 ? -n : n;
}
yi.SELECTION_CLASS_NAME = "selected-text", yi.SELECTION_TOP_LEFT = "top-left-radius", yi.SELECTION_BOTTOM_LEFT = "bottom-left-radius", yi.SELECTION_TOP_RIGHT = "top-right-radius", yi.SELECTION_BOTTOM_RIGHT = "bottom-right-radius", yi.EDITOR_BACKGROUND_CLASS_NAME = "monaco-editor-background", yi.ROUNDED_PIECE_WIDTH = 10, rr(((n, e) => {
  const t = n.getColor(f$);
  t && !t.isTransparent() && e.addRule(`.monaco-editor .view-line span.inline-selected-text { color: ${t}; }`);
}));
class r5 {
  constructor(e, t, i, s, o, r, a) {
    this.top = e, this.left = t, this.paddingLeft = i, this.width = s, this.height = o, this.textContent = r, this.textContentClassName = a;
  }
}
var vd;
(function(n) {
  n[n.Single = 0] = "Single", n[n.MultiPrimary = 1] = "MultiPrimary", n[n.MultiSecondary = 2] = "MultiSecondary";
})(vd || (vd = {}));
class a5 {
  constructor(e, t) {
    this._context = e;
    const i = this._context.configuration.options, s = i.get(50);
    this._cursorStyle = i.get(28), this._lineHeight = i.get(67), this._typicalHalfwidthCharacterWidth = s.typicalHalfwidthCharacterWidth, this._lineCursorWidth = Math.min(i.get(31), this._typicalHalfwidthCharacterWidth), this._isVisible = !0, this._domNode = wt(document.createElement("div")), this._domNode.setClassName(`cursor ${nm}`), this._domNode.setHeight(this._lineHeight), this._domNode.setTop(0), this._domNode.setLeft(0), yn(this._domNode, s), this._domNode.setDisplay("none"), this._position = new W(1, 1), this._pluralityClass = "", this.setPlurality(t), this._lastRenderedContent = "", this._renderData = null;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return this._position;
  }
  setPlurality(e) {
    switch (e) {
      default:
      case vd.Single:
        this._pluralityClass = "";
        break;
      case vd.MultiPrimary:
        this._pluralityClass = "cursor-primary";
        break;
      case vd.MultiSecondary:
        this._pluralityClass = "cursor-secondary";
    }
  }
  show() {
    this._isVisible || (this._domNode.setVisibility("inherit"), this._isVisible = !0);
  }
  hide() {
    this._isVisible && (this._domNode.setVisibility("hidden"), this._isVisible = !1);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, i = t.get(50);
    return this._cursorStyle = t.get(28), this._lineHeight = t.get(67), this._typicalHalfwidthCharacterWidth = i.typicalHalfwidthCharacterWidth, this._lineCursorWidth = Math.min(t.get(31), this._typicalHalfwidthCharacterWidth), yn(this._domNode, i), !0;
  }
  onCursorPositionChanged(e, t) {
    return this._domNode.domNode.style.transitionProperty = t ? "none" : "", this._position = e, !0;
  }
  _getGraphemeAwarePosition() {
    const { lineNumber: e, column: t } = this._position, i = this._context.viewModel.getLineContent(e), [s, o] = (function(r, a) {
      a > 0 && og(r.charCodeAt(a)) && a--;
      const l = a + rR(r, a);
      return [l - J7(r, l), l];
    })(i, t - 1);
    return [new W(e, s + 1), i.substring(s, o)];
  }
  _prepareRender(e) {
    let t = "", i = "";
    const [s, o] = this._getGraphemeAwarePosition();
    if (this._cursorStyle === vn.Line || this._cursorStyle === vn.LineThin) {
      const u = e.visibleRangeForPosition(s);
      if (!u || u.outsideRenderedLine) return null;
      const g = ke(this._domNode.domNode);
      let p;
      this._cursorStyle === vn.Line ? (p = LO(g, this._lineCursorWidth > 0 ? this._lineCursorWidth : 2), p > 2 && (t = o, i = this._getTokenClassName(s))) : p = LO(g, 1);
      let f = u.left, _ = 0;
      p >= 2 && f >= 1 && (_ = 1, f -= _);
      const v = e.getVerticalOffsetForLineNumber(s.lineNumber) - e.bigNumbersDelta;
      return new r5(v, f, _, p, this._lineHeight, t, i);
    }
    const r = e.linesVisibleRangesForRange(new D(s.lineNumber, s.column, s.lineNumber, s.column + o.length), !1);
    if (!r || r.length === 0) return null;
    const a = r[0];
    if (a.outsideRenderedLine || a.ranges.length === 0) return null;
    const l = a.ranges[0], d = o === "	" || l.width < 1 ? this._typicalHalfwidthCharacterWidth : l.width;
    this._cursorStyle === vn.Block && (t = o, i = this._getTokenClassName(s));
    let h = e.getVerticalOffsetForLineNumber(s.lineNumber) - e.bigNumbersDelta, c = this._lineHeight;
    return this._cursorStyle !== vn.Underline && this._cursorStyle !== vn.UnderlineThin || (h += this._lineHeight - 2, c = 2), new r5(h, l.left, 0, d, c, t, i);
  }
  _getTokenClassName(e) {
    const t = this._context.viewModel.getViewLineData(e.lineNumber), i = t.tokens.findTokenIndexAtOffset(e.column - 1);
    return t.tokens.getClassName(i);
  }
  prepareRender(e) {
    this._renderData = this._prepareRender(e);
  }
  render(e) {
    return this._renderData ? (this._lastRenderedContent !== this._renderData.textContent && (this._lastRenderedContent = this._renderData.textContent, this._domNode.domNode.textContent = this._lastRenderedContent), this._domNode.setClassName(`cursor ${this._pluralityClass} ${nm} ${this._renderData.textContentClassName}`), this._domNode.setDisplay("block"), this._domNode.setTop(this._renderData.top), this._domNode.setLeft(this._renderData.left), this._domNode.setPaddingLeft(this._renderData.paddingLeft), this._domNode.setWidth(this._renderData.width), this._domNode.setLineHeight(this._renderData.height), this._domNode.setHeight(this._renderData.height), { domNode: this._domNode.domNode, position: this._position, contentLeft: this._renderData.left, height: this._renderData.height, width: 2 }) : (this._domNode.setDisplay("none"), null);
  }
}
class vv extends to {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options;
    this._readOnly = t.get(91), this._cursorBlinking = t.get(26), this._cursorStyle = t.get(28), this._cursorSmoothCaretAnimation = t.get(27), this._selectionIsEmpty = !0, this._isComposingInput = !1, this._isVisible = !1, this._primaryCursor = new a5(this._context, vd.Single), this._secondaryCursors = [], this._renderData = [], this._domNode = wt(document.createElement("div")), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._updateDomClassName(), this._domNode.appendChild(this._primaryCursor.getDomNode()), this._startCursorBlinkAnimation = new Dr(), this._cursorFlatBlinkInterval = new gR(), this._blinkingEnabled = !1, this._editorHasFocus = !1, this._updateBlinking();
  }
  dispose() {
    super.dispose(), this._startCursorBlinkAnimation.dispose(), this._cursorFlatBlinkInterval.dispose();
  }
  getDomNode() {
    return this._domNode;
  }
  onCompositionStart(e) {
    return this._isComposingInput = !0, this._updateBlinking(), !0;
  }
  onCompositionEnd(e) {
    return this._isComposingInput = !1, this._updateBlinking(), !0;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    this._readOnly = t.get(91), this._cursorBlinking = t.get(26), this._cursorStyle = t.get(28), this._cursorSmoothCaretAnimation = t.get(27), this._updateBlinking(), this._updateDomClassName(), this._primaryCursor.onConfigurationChanged(e);
    for (let i = 0, s = this._secondaryCursors.length; i < s; i++) this._secondaryCursors[i].onConfigurationChanged(e);
    return !0;
  }
  _onCursorPositionChanged(e, t, i) {
    const s = this._secondaryCursors.length !== t.length || this._cursorSmoothCaretAnimation === "explicit" && i !== 3;
    if (this._primaryCursor.setPlurality(t.length ? vd.MultiPrimary : vd.Single), this._primaryCursor.onCursorPositionChanged(e, s), this._updateBlinking(), this._secondaryCursors.length < t.length) {
      const o = t.length - this._secondaryCursors.length;
      for (let r = 0; r < o; r++) {
        const a = new a5(this._context, vd.MultiSecondary);
        this._domNode.domNode.insertBefore(a.getDomNode().domNode, this._primaryCursor.getDomNode().domNode.nextSibling), this._secondaryCursors.push(a);
      }
    } else if (this._secondaryCursors.length > t.length) {
      const o = this._secondaryCursors.length - t.length;
      for (let r = 0; r < o; r++) this._domNode.removeChild(this._secondaryCursors[0].getDomNode()), this._secondaryCursors.splice(0, 1);
    }
    for (let o = 0; o < t.length; o++) this._secondaryCursors[o].onCursorPositionChanged(t[o], s);
  }
  onCursorStateChanged(e) {
    const t = [];
    for (let s = 0, o = e.selections.length; s < o; s++) t[s] = e.selections[s].getPosition();
    this._onCursorPositionChanged(t[0], t.slice(1), e.reason);
    const i = e.selections[0].isEmpty();
    return this._selectionIsEmpty !== i && (this._selectionIsEmpty = i, this._updateDomClassName()), !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onFocusChanged(e) {
    return this._editorHasFocus = e.isFocused, this._updateBlinking(), !1;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onTokensChanged(e) {
    const t = (i) => {
      for (let s = 0, o = e.ranges.length; s < o; s++) if (e.ranges[s].fromLineNumber <= i.lineNumber && i.lineNumber <= e.ranges[s].toLineNumber) return !0;
      return !1;
    };
    if (t(this._primaryCursor.getPosition())) return !0;
    for (const i of this._secondaryCursors) if (t(i.getPosition())) return !0;
    return !1;
  }
  onZonesChanged(e) {
    return !0;
  }
  _getCursorBlinking() {
    return this._isComposingInput ? 0 : this._editorHasFocus ? this._readOnly ? 5 : this._cursorBlinking : 0;
  }
  _updateBlinking() {
    this._startCursorBlinkAnimation.cancel(), this._cursorFlatBlinkInterval.cancel();
    const e = this._getCursorBlinking(), t = e === 0, i = e === 5;
    t ? this._hide() : this._show(), this._blinkingEnabled = !1, this._updateDomClassName(), t || i || (e === 1 ? this._cursorFlatBlinkInterval.cancelAndSet((() => {
      this._isVisible ? this._hide() : this._show();
    }), vv.BLINK_INTERVAL, ke(this._domNode.domNode)) : this._startCursorBlinkAnimation.setIfNotSet((() => {
      this._blinkingEnabled = !0, this._updateDomClassName();
    }), vv.BLINK_INTERVAL));
  }
  _updateDomClassName() {
    this._domNode.setClassName(this._getClassName());
  }
  _getClassName() {
    let e = "cursors-layer";
    switch (this._selectionIsEmpty || (e += " has-selection"), this._cursorStyle) {
      case vn.Line:
        e += " cursor-line-style";
        break;
      case vn.Block:
        e += " cursor-block-style";
        break;
      case vn.Underline:
        e += " cursor-underline-style";
        break;
      case vn.LineThin:
        e += " cursor-line-thin-style";
        break;
      case vn.BlockOutline:
        e += " cursor-block-outline-style";
        break;
      case vn.UnderlineThin:
        e += " cursor-underline-thin-style";
        break;
      default:
        e += " cursor-line-style";
    }
    if (this._blinkingEnabled) switch (this._getCursorBlinking()) {
      case 1:
        e += " cursor-blink";
        break;
      case 2:
        e += " cursor-smooth";
        break;
      case 3:
        e += " cursor-phase";
        break;
      case 4:
        e += " cursor-expand";
        break;
      default:
        e += " cursor-solid";
    }
    else e += " cursor-solid";
    return this._cursorSmoothCaretAnimation !== "on" && this._cursorSmoothCaretAnimation !== "explicit" || (e += " cursor-smooth-caret-animation"), e;
  }
  _show() {
    this._primaryCursor.show();
    for (let e = 0, t = this._secondaryCursors.length; e < t; e++) this._secondaryCursors[e].show();
    this._isVisible = !0;
  }
  _hide() {
    this._primaryCursor.hide();
    for (let e = 0, t = this._secondaryCursors.length; e < t; e++) this._secondaryCursors[e].hide();
    this._isVisible = !1;
  }
  prepareRender(e) {
    this._primaryCursor.prepareRender(e);
    for (let t = 0, i = this._secondaryCursors.length; t < i; t++) this._secondaryCursors[t].prepareRender(e);
  }
  render(e) {
    const t = [];
    let i = 0;
    const s = this._primaryCursor.render(e);
    s && (t[i++] = s);
    for (let o = 0, r = this._secondaryCursors.length; o < r; o++) {
      const a = this._secondaryCursors[o].render(e);
      a && (t[i++] = a);
    }
    this._renderData = t;
  }
  getLastRenderData() {
    return this._renderData;
  }
}
vv.BLINK_INTERVAL = 500, rr(((n, e) => {
  const t = [{ class: ".cursor", foreground: al, background: fd }, { class: ".cursor-primary", foreground: xB, background: gZ }, { class: ".cursor-secondary", foreground: NB, background: pZ }];
  for (const i of t) {
    const s = n.getColor(i.foreground);
    if (s) {
      let o = n.getColor(i.background);
      o || (o = s.opposite()), e.addRule(`.monaco-editor .cursors-layer ${i.class} { background-color: ${s}; border-color: ${s}; color: ${o}; }`), aa(n.type) && e.addRule(`.monaco-editor .cursors-layer.has-selection ${i.class} { border-left: 1px solid ${o}; border-right: 1px solid ${o}; }`);
    }
  }
}));
const CD = () => {
  throw new Error("Invalid change accessor");
};
class KY extends to {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, i = t.get(145);
    this._lineHeight = t.get(67), this._contentWidth = i.contentWidth, this._contentLeft = i.contentLeft, this.domNode = wt(document.createElement("div")), this.domNode.setClassName("view-zones"), this.domNode.setPosition("absolute"), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.marginDomNode = wt(document.createElement("div")), this.marginDomNode.setClassName("margin-view-zones"), this.marginDomNode.setPosition("absolute"), this.marginDomNode.setAttribute("role", "presentation"), this.marginDomNode.setAttribute("aria-hidden", "true"), this._zones = {};
  }
  dispose() {
    super.dispose(), this._zones = {};
  }
  _recomputeWhitespacesProps() {
    const e = this._context.viewLayout.getWhitespaces(), t = /* @__PURE__ */ new Map();
    for (const s of e) t.set(s.id, s);
    let i = !1;
    return this._context.viewModel.changeWhitespace(((s) => {
      const o = Object.keys(this._zones);
      for (let r = 0, a = o.length; r < a; r++) {
        const l = o[r], d = this._zones[l], h = this._computeWhitespaceProps(d.delegate);
        d.isInHiddenArea = h.isInHiddenArea;
        const c = t.get(l);
        !c || c.afterLineNumber === h.afterViewLineNumber && c.height === h.heightInPx || (s.changeOneWhitespace(l, h.afterViewLineNumber, h.heightInPx), this._safeCallOnComputedHeight(d.delegate, h.heightInPx), i = !0);
      }
    })), i;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, i = t.get(145);
    return this._lineHeight = t.get(67), this._contentWidth = i.contentWidth, this._contentLeft = i.contentLeft, e.hasChanged(67) && this._recomputeWhitespacesProps(), !0;
  }
  onLineMappingChanged(e) {
    return this._recomputeWhitespacesProps();
  }
  onLinesDeleted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollWidthChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  _getZoneOrdinal(e) {
    var t, i;
    return (i = (t = e.ordinal) !== null && t !== void 0 ? t : e.afterColumn) !== null && i !== void 0 ? i : 1e4;
  }
  _computeWhitespaceProps(e) {
    if (e.afterLineNumber === 0) return { isInHiddenArea: !1, afterViewLineNumber: 0, heightInPx: this._heightInPixels(e), minWidthInPx: this._minWidthInPixels(e) };
    let t, i;
    if (e.afterColumn !== void 0) t = this._context.viewModel.model.validatePosition({ lineNumber: e.afterLineNumber, column: e.afterColumn });
    else {
      const r = this._context.viewModel.model.validatePosition({ lineNumber: e.afterLineNumber, column: 1 }).lineNumber;
      t = new W(r, this._context.viewModel.model.getLineMaxColumn(r));
    }
    i = t.column === this._context.viewModel.model.getLineMaxColumn(t.lineNumber) ? this._context.viewModel.model.validatePosition({ lineNumber: t.lineNumber + 1, column: 1 }) : this._context.viewModel.model.validatePosition({ lineNumber: t.lineNumber, column: t.column + 1 });
    const s = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(t, e.afterColumnAffinity, !0), o = e.showInHiddenAreas || this._context.viewModel.coordinatesConverter.modelPositionIsVisible(i);
    return { isInHiddenArea: !o, afterViewLineNumber: s.lineNumber, heightInPx: o ? this._heightInPixels(e) : 0, minWidthInPx: this._minWidthInPixels(e) };
  }
  changeViewZones(e) {
    let t = !1;
    return this._context.viewModel.changeWhitespace(((i) => {
      const s = { addZone: (o) => (t = !0, this._addZone(i, o)), removeZone: (o) => {
        o && (t = this._removeZone(i, o) || t);
      }, layoutZone: (o) => {
        o && (t = this._layoutZone(i, o) || t);
      } };
      (function(o, r) {
        try {
          return o(r);
        } catch (a) {
          We(a);
        }
      })(e, s), s.addZone = CD, s.removeZone = CD, s.layoutZone = CD;
    })), t;
  }
  _addZone(e, t) {
    const i = this._computeWhitespaceProps(t), s = { whitespaceId: e.insertWhitespace(i.afterViewLineNumber, this._getZoneOrdinal(t), i.heightInPx, i.minWidthInPx), delegate: t, isInHiddenArea: i.isInHiddenArea, isVisible: !1, domNode: wt(t.domNode), marginDomNode: t.marginDomNode ? wt(t.marginDomNode) : null };
    return this._safeCallOnComputedHeight(s.delegate, i.heightInPx), s.domNode.setPosition("absolute"), s.domNode.domNode.style.width = "100%", s.domNode.setDisplay("none"), s.domNode.setAttribute("monaco-view-zone", s.whitespaceId), this.domNode.appendChild(s.domNode), s.marginDomNode && (s.marginDomNode.setPosition("absolute"), s.marginDomNode.domNode.style.width = "100%", s.marginDomNode.setDisplay("none"), s.marginDomNode.setAttribute("monaco-view-zone", s.whitespaceId), this.marginDomNode.appendChild(s.marginDomNode)), this._zones[s.whitespaceId] = s, this.setShouldRender(), s.whitespaceId;
  }
  _removeZone(e, t) {
    if (this._zones.hasOwnProperty(t)) {
      const i = this._zones[t];
      return delete this._zones[t], e.removeWhitespace(i.whitespaceId), i.domNode.removeAttribute("monaco-visible-view-zone"), i.domNode.removeAttribute("monaco-view-zone"), i.domNode.domNode.parentNode.removeChild(i.domNode.domNode), i.marginDomNode && (i.marginDomNode.removeAttribute("monaco-visible-view-zone"), i.marginDomNode.removeAttribute("monaco-view-zone"), i.marginDomNode.domNode.parentNode.removeChild(i.marginDomNode.domNode)), this.setShouldRender(), !0;
    }
    return !1;
  }
  _layoutZone(e, t) {
    if (this._zones.hasOwnProperty(t)) {
      const i = this._zones[t], s = this._computeWhitespaceProps(i.delegate);
      return i.isInHiddenArea = s.isInHiddenArea, e.changeOneWhitespace(i.whitespaceId, s.afterViewLineNumber, s.heightInPx), this._safeCallOnComputedHeight(i.delegate, s.heightInPx), this.setShouldRender(), !0;
    }
    return !1;
  }
  shouldSuppressMouseDownOnViewZone(e) {
    return this._zones.hasOwnProperty(e) ? !!this._zones[e].delegate.suppressMouseDown : !1;
  }
  _heightInPixels(e) {
    return typeof e.heightInPx == "number" ? e.heightInPx : typeof e.heightInLines == "number" ? this._lineHeight * e.heightInLines : this._lineHeight;
  }
  _minWidthInPixels(e) {
    return typeof e.minWidthInPx == "number" ? e.minWidthInPx : 0;
  }
  _safeCallOnComputedHeight(e, t) {
    if (typeof e.onComputedHeight == "function") try {
      e.onComputedHeight(t);
    } catch (i) {
      We(i);
    }
  }
  _safeCallOnDomNodeTop(e, t) {
    if (typeof e.onDomNodeTop == "function") try {
      e.onDomNodeTop(t);
    } catch (i) {
      We(i);
    }
  }
  prepareRender(e) {
  }
  render(e) {
    const t = e.viewportData.whitespaceViewportData, i = {};
    let s = !1;
    for (const r of t) this._zones[r.id].isInHiddenArea || (i[r.id] = r, s = !0);
    const o = Object.keys(this._zones);
    for (let r = 0, a = o.length; r < a; r++) {
      const l = o[r], d = this._zones[l];
      let h = 0, c = 0, u = "none";
      i.hasOwnProperty(l) ? (h = i[l].verticalOffset - e.bigNumbersDelta, c = i[l].height, u = "block", d.isVisible || (d.domNode.setAttribute("monaco-visible-view-zone", "true"), d.isVisible = !0), this._safeCallOnDomNodeTop(d.delegate, e.getScrolledTopFromAbsoluteTop(i[l].verticalOffset))) : (d.isVisible && (d.domNode.removeAttribute("monaco-visible-view-zone"), d.isVisible = !1), this._safeCallOnDomNodeTop(d.delegate, e.getScrolledTopFromAbsoluteTop(-1e6))), d.domNode.setTop(h), d.domNode.setHeight(c), d.domNode.setDisplay(u), d.marginDomNode && (d.marginDomNode.setTop(h), d.marginDomNode.setHeight(c), d.marginDomNode.setDisplay(u));
    }
    s && (this.domNode.setWidth(Math.max(e.scrollWidth, this._contentWidth)), this.marginDomNode.setWidth(this._contentLeft));
  }
}
class jY extends Eg {
  constructor(e) {
    super(), this._context = e, this._options = new l5(this._context.configuration), this._selection = [], this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    const t = new l5(this._context.configuration);
    return this._options.equals(t) ? e.hasChanged(145) : (this._options = t, !0);
  }
  onCursorStateChanged(e) {
    return this._selection = e.selections, this._options.renderWhitespace === "selection";
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  prepareRender(e) {
    if (this._options.renderWhitespace === "none") return void (this._renderResult = null);
    const t = e.visibleRange.startLineNumber, i = e.visibleRange.endLineNumber - t + 1, s = new Array(i);
    for (let r = 0; r < i; r++) s[r] = !0;
    const o = this._context.viewModel.getMinimapLinesRenderingData(e.viewportData.startLineNumber, e.viewportData.endLineNumber, s);
    this._renderResult = [];
    for (let r = e.viewportData.startLineNumber; r <= e.viewportData.endLineNumber; r++) {
      const a = r - e.viewportData.startLineNumber, l = o.data[a];
      let d = null;
      if (this._options.renderWhitespace === "selection") {
        const h = this._selection;
        for (const c of h) {
          if (c.endLineNumber < r || c.startLineNumber > r) continue;
          const u = c.startLineNumber === r ? c.startColumn : l.minColumn, g = c.endLineNumber === r ? c.endColumn : l.maxColumn;
          u < g && (d || (d = []), d.push(new tB(u - 1, g - 1)));
        }
      }
      this._renderResult[a] = this._applyRenderWhitespace(e, r, d, l);
    }
  }
  _applyRenderWhitespace(e, t, i, s) {
    if (this._options.renderWhitespace === "selection" && !i || this._options.renderWhitespace === "trailing" && s.continuesWithWrappedLine) return "";
    const o = this._context.theme.getColor(_d), r = this._options.renderWithSVG, a = s.content, l = this._options.stopRenderingLineAfter === -1 ? a.length : Math.min(this._options.stopRenderingLineAfter, a.length), d = s.continuesWithWrappedLine, h = s.minColumn - 1, c = this._options.renderWhitespace === "boundary", u = this._options.renderWhitespace === "trailing", g = this._options.lineHeight, p = this._options.middotWidth, f = this._options.wsmiddotWidth, _ = this._options.spaceWidth, v = Math.abs(f - _) < Math.abs(p - _) ? 11825 : 183, b = this._options.canUseHalfwidthRightwardsArrow;
    let C, w = "", y = !1, L = Jn(a);
    L === -1 ? (y = !0, L = l, C = l) : C = oa(a);
    let k = 0, N = i && i[k], A = 0;
    for (let B = h; B < l; B++) {
      const T = a.charCodeAt(B);
      if (N && B >= N.endOffset && (k++, N = i && i[k]), T !== 9 && T !== 32 || u && !y && B <= C) continue;
      if (c && B >= L && B <= C && T === 32) {
        const H = B - 1 >= 0 ? a.charCodeAt(B - 1) : 0, $ = B + 1 < l ? a.charCodeAt(B + 1) : 0;
        if (H !== 32 && $ !== 32) continue;
      }
      if (c && d && B === l - 1) {
        const H = B - 1 >= 0 ? a.charCodeAt(B - 1) : 0;
        if (T === 32 && H !== 32 && H !== 9) continue;
      }
      if (i && (!N || N.startOffset > B || N.endOffset <= B)) continue;
      const O = e.visibleRangeForPosition(new W(t, B + 1));
      O && (r ? (A = Math.max(A, O.left), w += T === 9 ? this._renderArrow(g, _, O.left) : `<circle cx="${(O.left + _ / 2).toFixed(2)}" cy="${(g / 2).toFixed(2)}" r="${(_ / 7).toFixed(2)}" />`) : w += T === 9 ? `<div class="mwh" style="left:${O.left}px;height:${g}px;">${b ? "￫" : "→"}</div>` : `<div class="mwh" style="left:${O.left}px;height:${g}px;">${String.fromCharCode(v)}</div>`);
    }
    return r ? (A = Math.round(A + _), `<svg style="bottom:0;position:absolute;width:${A}px;height:${g}px" viewBox="0 0 ${A} ${g}" xmlns="http://www.w3.org/2000/svg" fill="${o}">` + w + "</svg>") : w;
  }
  _renderArrow(e, t, i) {
    const s = e / 2, o = i, r = { x: 0, y: t / 7 / 2 }, a = { x: 0.8 * t, y: r.y }, l = { x: a.x - 0.2 * a.x, y: a.y + 0.2 * a.x }, d = { x: l.x + 0.1 * a.x, y: l.y + 0.1 * a.x }, h = { x: d.x + 0.35 * a.x, y: d.y - 0.35 * a.x };
    return `<path d="M ${[r, a, l, d, h, { x: h.x, y: -h.y }, { x: d.x, y: -d.y }, { x: l.x, y: -l.y }, { x: a.x, y: -a.y }, { x: r.x, y: -r.y }].map(((c) => `${(o + c.x).toFixed(2)} ${(s + c.y).toFixed(2)}`)).join(" L ")}" />`;
  }
  render(e, t) {
    if (!this._renderResult) return "";
    const i = t - e;
    return i < 0 || i >= this._renderResult.length ? "" : this._renderResult[i];
  }
}
class l5 {
  constructor(e) {
    const t = e.options, i = t.get(50), s = t.get(38);
    s === "off" ? (this.renderWhitespace = "none", this.renderWithSVG = !1) : s === "svg" ? (this.renderWhitespace = t.get(99), this.renderWithSVG = !0) : (this.renderWhitespace = t.get(99), this.renderWithSVG = !1), this.spaceWidth = i.spaceWidth, this.middotWidth = i.middotWidth, this.wsmiddotWidth = i.wsmiddotWidth, this.canUseHalfwidthRightwardsArrow = i.canUseHalfwidthRightwardsArrow, this.lineHeight = t.get(67), this.stopRenderingLineAfter = t.get(117);
  }
  equals(e) {
    return this.renderWhitespace === e.renderWhitespace && this.renderWithSVG === e.renderWithSVG && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineHeight === e.lineHeight && this.stopRenderingLineAfter === e.stopRenderingLineAfter;
  }
}
class qY {
  constructor(e, t, i, s) {
    this.selections = e, this.startLineNumber = 0 | t.startLineNumber, this.endLineNumber = 0 | t.endLineNumber, this.relativeVerticalOffset = t.relativeVerticalOffset, this.bigNumbersDelta = 0 | t.bigNumbersDelta, this.lineHeight = 0 | t.lineHeight, this.whitespaceViewportData = i, this._model = s, this.visibleRange = new D(t.startLineNumber, this._model.getLineMinColumn(t.startLineNumber), t.endLineNumber, this._model.getLineMaxColumn(t.endLineNumber));
  }
  getViewLineRenderingData(e) {
    return this._model.getViewportViewLineRenderingData(this.visibleRange, e);
  }
  getDecorationsInViewport() {
    return this._model.getDecorationsInViewport(this.visibleRange);
  }
}
class $Y {
  get type() {
    return this._theme.type;
  }
  get value() {
    return this._theme;
  }
  constructor(e) {
    this._theme = e;
  }
  update(e) {
    this._theme = e;
  }
  getColor(e) {
    return this._theme.getColor(e);
  }
}
class GY {
  constructor(e, t, i) {
    this.configuration = e, this.theme = new $Y(t), this.viewModel = i, this.viewLayout = i.viewLayout;
  }
  addEventHandler(e) {
    this.viewModel.addViewEventHandler(e);
  }
  removeEventHandler(e) {
    this.viewModel.removeViewEventHandler(e);
  }
}
var ZY = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, YY = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let oI = class extends y1 {
  constructor(n, e, t, i, s, o, r) {
    super(), this._instantiationService = r, this._shouldRecomputeGlyphMarginLanes = !1, this._selections = [new _e(1, 1, 1, 1)], this._renderAnimationFrame = null;
    const a = new rY(e, i, s, n);
    this._context = new GY(e, t, i), this._context.addEventHandler(this), this._viewParts = [], this._textAreaHandler = this._instantiationService.createInstance(iI, this._context, a, this._createTextAreaHandlerHelper()), this._viewParts.push(this._textAreaHandler), this._linesContent = wt(document.createElement("div")), this._linesContent.setClassName("lines-content monaco-editor-background"), this._linesContent.setPosition("absolute"), this.domNode = wt(document.createElement("div")), this.domNode.setClassName(this._getEditorClassName()), this.domNode.setAttribute("role", "code"), this._overflowGuardContainer = wt(document.createElement("div")), fa.write(this._overflowGuardContainer, 3), this._overflowGuardContainer.setClassName("overflow-guard"), this._scrollbar = new fY(this._context, this._linesContent, this.domNode, this._overflowGuardContainer), this._viewParts.push(this._scrollbar), this._viewLines = new cL(this._context, this._linesContent), this._viewZones = new KY(this._context), this._viewParts.push(this._viewZones);
    const l = new PY(this._context);
    this._viewParts.push(l);
    const d = new WY(this._context);
    this._viewParts.push(d);
    const h = new lY(this._context);
    this._viewParts.push(h), h.addDynamicOverlay(new gY(this._context)), h.addDynamicOverlay(new yi(this._context)), h.addDynamicOverlay(new LY(this._context)), h.addDynamicOverlay(new mY(this._context)), h.addDynamicOverlay(new jY(this._context));
    const c = new dY(this._context);
    this._viewParts.push(c), c.addDynamicOverlay(new pY(this._context)), c.addDynamicOverlay(new EY(this._context)), c.addDynamicOverlay(new NY(this._context)), c.addDynamicOverlay(new D1(this._context)), this._glyphMarginWidgets = new bY(this._context), this._viewParts.push(this._glyphMarginWidgets);
    const u = new hg(this._context);
    u.getDomNode().appendChild(this._viewZones.marginDomNode), u.getDomNode().appendChild(c.getDomNode()), u.getDomNode().appendChild(this._glyphMarginWidgets.domNode), this._viewParts.push(u), this._contentWidgets = new cY(this._context, this.domNode), this._viewParts.push(this._contentWidgets), this._viewCursors = new vv(this._context), this._viewParts.push(this._viewCursors), this._overlayWidgets = new RY(this._context, this.domNode), this._viewParts.push(this._overlayWidgets);
    const g = new BY(this._context);
    this._viewParts.push(g);
    const p = new hY(this._context);
    this._viewParts.push(p);
    const f = new TY(this._context);
    if (this._viewParts.push(f), l) {
      const _ = this._scrollbar.getOverviewRulerLayoutInfo();
      _.parent.insertBefore(l.getDomNode(), _.insertBefore);
    }
    this._linesContent.appendChild(h.getDomNode()), this._linesContent.appendChild(g.domNode), this._linesContent.appendChild(this._viewZones.domNode), this._linesContent.appendChild(this._viewLines.getDomNode()), this._linesContent.appendChild(this._contentWidgets.domNode), this._linesContent.appendChild(this._viewCursors.getDomNode()), this._overflowGuardContainer.appendChild(u.getDomNode()), this._overflowGuardContainer.appendChild(this._scrollbar.getDomNode()), this._overflowGuardContainer.appendChild(d.getDomNode()), this._overflowGuardContainer.appendChild(this._textAreaHandler.textArea), this._overflowGuardContainer.appendChild(this._textAreaHandler.textAreaCover), this._overflowGuardContainer.appendChild(this._overlayWidgets.getDomNode()), this._overflowGuardContainer.appendChild(f.getDomNode()), this._overflowGuardContainer.appendChild(p.domNode), this.domNode.appendChild(this._overflowGuardContainer), o ? (o.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode.domNode), o.appendChild(this._overlayWidgets.overflowingOverlayWidgetsDomNode.domNode)) : (this.domNode.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode), this.domNode.appendChild(this._overlayWidgets.overflowingOverlayWidgetsDomNode)), this._applyLayout(), this._pointerHandler = this._register(new cZ(this._context, a, this._createPointerHandlerHelper()));
  }
  _computeGlyphMarginLanes() {
    const n = this._context.viewModel.model, e = this._context.viewModel.glyphLanes;
    let t = [], i = 0;
    t = t.concat(n.getAllMarginDecorations().map(((s) => {
      var o, r, a;
      const l = (r = (o = s.options.glyphMargin) === null || o === void 0 ? void 0 : o.position) !== null && r !== void 0 ? r : _l.Center;
      return i = Math.max(i, s.range.endLineNumber), { range: s.range, lane: l, persist: (a = s.options.glyphMargin) === null || a === void 0 ? void 0 : a.persistLane };
    }))), t = t.concat(this._glyphMarginWidgets.getWidgets().map(((s) => {
      const o = n.validateRange(s.preference.range);
      return i = Math.max(i, o.endLineNumber), { range: o, lane: s.preference.lane };
    }))), t.sort(((s, o) => D.compareRangesUsingStarts(s.range, o.range))), e.reset(i);
    for (const s of t) e.push(s.lane, s.range, s.persist);
    return e;
  }
  _createPointerHandlerHelper() {
    return { viewDomNode: this.domNode.domNode, linesContentDomNode: this._linesContent.domNode, viewLinesDomNode: this._viewLines.getDomNode().domNode, focusTextArea: () => {
      this.focus();
    }, dispatchTextAreaEvent: (n) => {
      this._textAreaHandler.textArea.domNode.dispatchEvent(n);
    }, getLastRenderData: () => {
      const n = this._viewCursors.getLastRenderData() || [], e = this._textAreaHandler.getLastRenderData();
      return new GG(n, e);
    }, renderNow: () => {
      this.render(!0, !1);
    }, shouldSuppressMouseDownOnViewZone: (n) => this._viewZones.shouldSuppressMouseDownOnViewZone(n), shouldSuppressMouseDownOnWidget: (n) => this._contentWidgets.shouldSuppressMouseDownOnWidget(n), getPositionFromDOMInfo: (n, e) => (this._flushAccumulatedAndRenderNow(), this._viewLines.getPositionFromDOMInfo(n, e)), visibleRangeForPosition: (n, e) => (this._flushAccumulatedAndRenderNow(), this._viewLines.visibleRangeForPosition(new W(n, e))), getLineWidth: (n) => (this._flushAccumulatedAndRenderNow(), this._viewLines.getLineWidth(n)) };
  }
  _createTextAreaHandlerHelper() {
    return { visibleRangeForPosition: (n) => (this._flushAccumulatedAndRenderNow(), this._viewLines.visibleRangeForPosition(n)) };
  }
  _applyLayout() {
    const n = this._context.configuration.options.get(145);
    this.domNode.setWidth(n.width), this.domNode.setHeight(n.height), this._overflowGuardContainer.setWidth(n.width), this._overflowGuardContainer.setHeight(n.height), this._linesContent.setWidth(16777216), this._linesContent.setHeight(16777216);
  }
  _getEditorClassName() {
    const n = this._textAreaHandler.isFocused() ? " focused" : "";
    return this._context.configuration.options.get(142) + " " + tI(this._context.theme.type) + n;
  }
  handleEvents(n) {
    super.handleEvents(n), this._scheduleRender();
  }
  onConfigurationChanged(n) {
    return this.domNode.setClassName(this._getEditorClassName()), this._applyLayout(), !1;
  }
  onCursorStateChanged(n) {
    return this._selections = n.selections, !1;
  }
  onDecorationsChanged(n) {
    return n.affectsGlyphMargin && (this._shouldRecomputeGlyphMarginLanes = !0), !1;
  }
  onFocusChanged(n) {
    return this.domNode.setClassName(this._getEditorClassName()), !1;
  }
  onThemeChanged(n) {
    return this._context.theme.update(n.theme), this.domNode.setClassName(this._getEditorClassName()), !1;
  }
  dispose() {
    this._renderAnimationFrame !== null && (this._renderAnimationFrame.dispose(), this._renderAnimationFrame = null), this._contentWidgets.overflowingContentWidgetsDomNode.domNode.remove(), this._context.removeEventHandler(this), this._viewLines.dispose();
    for (const n of this._viewParts) n.dispose();
    super.dispose();
  }
  _scheduleRender() {
    if (this._store.isDisposed) throw new Kt();
    if (this._renderAnimationFrame === null) {
      const n = this._createCoordinatedRendering();
      this._renderAnimationFrame = rI.INSTANCE.scheduleCoordinatedRendering({ window: ke(this.domNode.domNode), prepareRenderText: () => {
        if (this._store.isDisposed) throw new Kt();
        try {
          return n.prepareRenderText();
        } finally {
          this._renderAnimationFrame = null;
        }
      }, renderText: () => {
        if (this._store.isDisposed) throw new Kt();
        return n.renderText();
      }, prepareRender: (e, t) => {
        if (this._store.isDisposed) throw new Kt();
        return n.prepareRender(e, t);
      }, render: (e, t) => {
        if (this._store.isDisposed) throw new Kt();
        return n.render(e, t);
      } });
    }
  }
  _flushAccumulatedAndRenderNow() {
    const n = this._createCoordinatedRendering();
    Ph((() => n.prepareRenderText()));
    const e = Ph((() => n.renderText()));
    if (e) {
      const [t, i] = e;
      Ph((() => n.prepareRender(t, i))), Ph((() => n.render(t, i)));
    }
  }
  _getViewPartsToRender() {
    const n = [];
    let e = 0;
    for (const t of this._viewParts) t.shouldRender() && (n[e++] = t);
    return n;
  }
  _createCoordinatedRendering() {
    return { prepareRenderText: () => {
      if (this._shouldRecomputeGlyphMarginLanes) {
        this._shouldRecomputeGlyphMarginLanes = !1;
        const n = this._computeGlyphMarginLanes();
        this._context.configuration.setGlyphMarginDecorationLaneCount(n.requiredLanes);
      }
      Ih.onRenderStart();
    }, renderText: () => {
      if (!this.domNode.domNode.isConnected) return null;
      let n = this._getViewPartsToRender();
      if (!this._viewLines.shouldRender() && n.length === 0) return null;
      const e = this._context.viewLayout.getLinesViewportData();
      this._context.viewModel.setViewport(e.startLineNumber, e.endLineNumber, e.centeredLineNumber);
      const t = new qY(this._selections, e, this._context.viewLayout.getWhitespaceViewportData(), this._context.viewModel);
      return this._contentWidgets.shouldRender() && this._contentWidgets.onBeforeRender(t), this._viewLines.shouldRender() && (this._viewLines.renderText(t), this._viewLines.onDidRender(), n = this._getViewPartsToRender()), [n, new HG(this._context.viewLayout, t, this._viewLines)];
    }, prepareRender: (n, e) => {
      for (const t of n) t.prepareRender(e);
    }, render: (n, e) => {
      for (const t of n) t.render(e), t.onDidRender();
    } };
  }
  delegateVerticalScrollbarPointerDown(n) {
    this._scrollbar.delegateVerticalScrollbarPointerDown(n);
  }
  delegateScrollFromMouseWheelEvent(n) {
    this._scrollbar.delegateScrollFromMouseWheelEvent(n);
  }
  restoreState(n) {
    this._context.viewModel.viewLayout.setScrollPosition({ scrollTop: n.scrollTop, scrollLeft: n.scrollLeft }, 1), this._context.viewModel.visibleLinesStabilized();
  }
  getOffsetForColumn(n, e) {
    const t = this._context.viewModel.model.validatePosition({ lineNumber: n, column: e }), i = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(t);
    this._flushAccumulatedAndRenderNow();
    const s = this._viewLines.visibleRangeForPosition(new W(i.lineNumber, i.column));
    return s ? s.left : -1;
  }
  getTargetAtClientPoint(n, e) {
    const t = this._pointerHandler.getTargetAtClientPoint(n, e);
    return t ? dL.convertViewToModelMouseTarget(t, this._context.viewModel.coordinatesConverter) : null;
  }
  createOverviewRuler(n) {
    return new FY(this._context, n);
  }
  change(n) {
    this._viewZones.changeViewZones(n), this._scheduleRender();
  }
  render(n, e) {
    if (e) {
      this._viewLines.forceShouldRender();
      for (const t of this._viewParts) t.forceShouldRender();
    }
    n ? this._flushAccumulatedAndRenderNow() : this._scheduleRender();
  }
  writeScreenReaderContent(n) {
    this._textAreaHandler.writeScreenReaderContent(n);
  }
  focus() {
    this._textAreaHandler.focusTextArea();
  }
  isFocused() {
    return this._textAreaHandler.isFocused();
  }
  setAriaOptions(n) {
    this._textAreaHandler.setAriaOptions(n);
  }
  addContentWidget(n) {
    this._contentWidgets.addWidget(n.widget), this.layoutContentWidget(n), this._scheduleRender();
  }
  layoutContentWidget(n) {
    var e, t, i, s, o, r, a, l;
    this._contentWidgets.setWidgetPosition(n.widget, (t = (e = n.position) === null || e === void 0 ? void 0 : e.position) !== null && t !== void 0 ? t : null, (s = (i = n.position) === null || i === void 0 ? void 0 : i.secondaryPosition) !== null && s !== void 0 ? s : null, (r = (o = n.position) === null || o === void 0 ? void 0 : o.preference) !== null && r !== void 0 ? r : null, (l = (a = n.position) === null || a === void 0 ? void 0 : a.positionAffinity) !== null && l !== void 0 ? l : null), this._scheduleRender();
  }
  removeContentWidget(n) {
    this._contentWidgets.removeWidget(n.widget), this._scheduleRender();
  }
  addOverlayWidget(n) {
    this._overlayWidgets.addWidget(n.widget), this.layoutOverlayWidget(n), this._scheduleRender();
  }
  layoutOverlayWidget(n) {
    const e = n.position ? n.position.preference : null;
    this._overlayWidgets.setWidgetPosition(n.widget, e) && this._scheduleRender();
  }
  removeOverlayWidget(n) {
    this._overlayWidgets.removeWidget(n.widget), this._scheduleRender();
  }
  addGlyphMarginWidget(n) {
    this._glyphMarginWidgets.addWidget(n.widget), this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender();
  }
  layoutGlyphMarginWidget(n) {
    const e = n.position;
    this._glyphMarginWidgets.setWidgetPosition(n.widget, e) && (this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender());
  }
  removeGlyphMarginWidget(n) {
    this._glyphMarginWidgets.removeWidget(n.widget), this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender();
  }
};
function Ph(n) {
  try {
    return n();
  } catch (e) {
    return We(e), null;
  }
}
oI = ZY([YY(6, Se)], oI);
class rI {
  constructor() {
    this._coordinatedRenderings = [], this._animationFrameRunners = /* @__PURE__ */ new Map();
  }
  scheduleCoordinatedRendering(e) {
    return this._coordinatedRenderings.push(e), this._scheduleRender(e.window), { dispose: () => {
      const t = this._coordinatedRenderings.indexOf(e);
      if (t !== -1 && (this._coordinatedRenderings.splice(t, 1), this._coordinatedRenderings.length === 0)) {
        for (const [i, s] of this._animationFrameRunners) s.dispose();
        this._animationFrameRunners.clear();
      }
    } };
  }
  _scheduleRender(e) {
    if (!this._animationFrameRunners.has(e)) {
      const t = () => {
        this._animationFrameRunners.delete(e), this._onRenderScheduled();
      };
      this._animationFrameRunners.set(e, Uw(e, t, 100));
    }
  }
  _onRenderScheduled() {
    const e = this._coordinatedRenderings.slice(0);
    this._coordinatedRenderings = [];
    for (const i of e) Ph((() => i.prepareRenderText()));
    const t = [];
    for (let i = 0, s = e.length; i < s; i++) {
      const o = e[i];
      t[i] = Ph((() => o.renderText()));
    }
    for (let i = 0, s = e.length; i < s; i++) {
      const o = e[i], r = t[i];
      if (!r) continue;
      const [a, l] = r;
      Ph((() => o.prepareRender(a, l)));
    }
    for (let i = 0, s = e.length; i < s; i++) {
      const o = e[i], r = t[i];
      if (!r) continue;
      const [a, l] = r;
      Ph((() => o.render(a, l)));
    }
  }
}
rI.INSTANCE = new rI();
class o0 {
  constructor(e, t, i, s, o) {
    this.injectionOffsets = e, this.injectionOptions = t, this.breakOffsets = i, this.breakOffsetsVisibleColumn = s, this.wrappedTextIndentLength = o;
  }
  getOutputLineCount() {
    return this.breakOffsets.length;
  }
  getMinOutputOffset(e) {
    return e > 0 ? this.wrappedTextIndentLength : 0;
  }
  getLineLength(e) {
    const t = e > 0 ? this.breakOffsets[e - 1] : 0;
    let i = this.breakOffsets[e] - t;
    return e > 0 && (i += this.wrappedTextIndentLength), i;
  }
  getMaxOutputOffset(e) {
    return this.getLineLength(e);
  }
  translateToInputOffset(e, t) {
    e > 0 && (t = Math.max(0, t - this.wrappedTextIndentLength));
    let i = e === 0 ? t : this.breakOffsets[e - 1] + t;
    if (this.injectionOffsets !== null) for (let s = 0; s < this.injectionOffsets.length && i > this.injectionOffsets[s]; s++) i < this.injectionOffsets[s] + this.injectionOptions[s].content.length ? i = this.injectionOffsets[s] : i -= this.injectionOptions[s].content.length;
    return i;
  }
  translateToOutputPosition(e, t = 2) {
    let i = e;
    if (this.injectionOffsets !== null) for (let s = 0; s < this.injectionOffsets.length && !(e < this.injectionOffsets[s]) && (t === 1 || e !== this.injectionOffsets[s]); s++) i += this.injectionOptions[s].content.length;
    return this.offsetInInputWithInjectionsToOutputPosition(i, t);
  }
  offsetInInputWithInjectionsToOutputPosition(e, t = 2) {
    let i = 0, s = this.breakOffsets.length - 1, o = 0, r = 0;
    for (; i <= s; ) {
      o = i + (s - i) / 2 | 0;
      const l = this.breakOffsets[o];
      if (r = o > 0 ? this.breakOffsets[o - 1] : 0, t === 0) if (e <= r) s = o - 1;
      else {
        if (!(e > l)) break;
        i = o + 1;
      }
      else if (e < r) s = o - 1;
      else {
        if (!(e >= l)) break;
        i = o + 1;
      }
    }
    let a = e - r;
    return o > 0 && (a += this.wrappedTextIndentLength), new vb(o, a);
  }
  normalizeOutputPosition(e, t, i) {
    if (this.injectionOffsets !== null) {
      const s = this.outputPositionToOffsetInInputWithInjections(e, t), o = this.normalizeOffsetInInputWithInjectionsAroundInjections(s, i);
      if (o !== s) return this.offsetInInputWithInjectionsToOutputPosition(o, i);
    }
    if (i === 0) {
      if (e > 0 && t === this.getMinOutputOffset(e)) return new vb(e - 1, this.getMaxOutputOffset(e - 1));
    } else if (i === 1 && e < this.getOutputLineCount() - 1 && t === this.getMaxOutputOffset(e))
      return new vb(e + 1, this.getMinOutputOffset(e + 1));
    return new vb(e, t);
  }
  outputPositionToOffsetInInputWithInjections(e, t) {
    return e > 0 && (t = Math.max(0, t - this.wrappedTextIndentLength)), (e > 0 ? this.breakOffsets[e - 1] : 0) + t;
  }
  normalizeOffsetInInputWithInjectionsAroundInjections(e, t) {
    const i = this.getInjectedTextAtOffset(e);
    if (!i) return e;
    if (t === 2) {
      if (e === i.offsetInInputWithInjections + i.length && d5(this.injectionOptions[i.injectedTextIndex].cursorStops)) return i.offsetInInputWithInjections + i.length;
      {
        let s = i.offsetInInputWithInjections;
        if (h5(this.injectionOptions[i.injectedTextIndex].cursorStops)) return s;
        let o = i.injectedTextIndex - 1;
        for (; o >= 0 && this.injectionOffsets[o] === this.injectionOffsets[i.injectedTextIndex] && !d5(this.injectionOptions[o].cursorStops) && (s -= this.injectionOptions[o].content.length, !h5(this.injectionOptions[o].cursorStops)); ) o--;
        return s;
      }
    }
    if (t === 1 || t === 4) {
      let s = i.offsetInInputWithInjections + i.length, o = i.injectedTextIndex;
      for (; o + 1 < this.injectionOffsets.length && this.injectionOffsets[o + 1] === this.injectionOffsets[o]; ) s += this.injectionOptions[o + 1].content.length, o++;
      return s;
    }
    if (t === 0 || t === 3) {
      let s = i.offsetInInputWithInjections, o = i.injectedTextIndex;
      for (; o - 1 >= 0 && this.injectionOffsets[o - 1] === this.injectionOffsets[o]; ) s -= this.injectionOptions[o - 1].content.length, o--;
      return s;
    }
    XS();
  }
  getInjectedText(e, t) {
    const i = this.outputPositionToOffsetInInputWithInjections(e, t), s = this.getInjectedTextAtOffset(i);
    return s ? { options: this.injectionOptions[s.injectedTextIndex] } : null;
  }
  getInjectedTextAtOffset(e) {
    const t = this.injectionOffsets, i = this.injectionOptions;
    if (t !== null) {
      let s = 0;
      for (let o = 0; o < t.length; o++) {
        const r = i[o].content.length, a = t[o] + s, l = t[o] + s + r;
        if (a > e) break;
        if (e <= l) return { injectedTextIndex: o, offsetInInputWithInjections: a, length: r };
        s += r;
      }
    }
  }
}
function d5(n) {
  return n == null || n === vr.Right || n === vr.Both;
}
function h5(n) {
  return n == null || n === vr.Left || n === vr.Both;
}
class vb {
  constructor(e, t) {
    this.outputLineIndex = e, this.outputOffset = t;
  }
  toString() {
    return `${this.outputLineIndex}:${this.outputOffset}`;
  }
  toPosition(e) {
    return new W(e + this.outputLineIndex, this.outputOffset + 1);
  }
}
class XY {
  constructor() {
    this.changeType = 1;
  }
}
class _a {
  static applyInjectedText(e, t) {
    if (!t || t.length === 0) return e;
    let i = "", s = 0;
    for (const o of t) i += e.substring(s, o.column - 1), s = o.column - 1, i += o.options.content;
    return i += e.substring(s), i;
  }
  static fromDecorations(e) {
    const t = [];
    for (const i of e) i.options.before && i.options.before.content.length > 0 && t.push(new _a(i.ownerId, i.range.startLineNumber, i.range.startColumn, i.options.before, 0)), i.options.after && i.options.after.content.length > 0 && t.push(new _a(i.ownerId, i.range.endLineNumber, i.range.endColumn, i.options.after, 1));
    return t.sort(((i, s) => i.lineNumber === s.lineNumber ? i.column === s.column ? i.order - s.order : i.column - s.column : i.lineNumber - s.lineNumber)), t;
  }
  constructor(e, t, i, s, o) {
    this.ownerId = e, this.lineNumber = t, this.column = i, this.options = s, this.order = o;
  }
}
class c5 {
  constructor(e, t, i) {
    this.changeType = 2, this.lineNumber = e, this.detail = t, this.injectedText = i;
  }
}
class QY {
  constructor(e, t) {
    this.changeType = 3, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class JY {
  constructor(e, t, i, s) {
    this.changeType = 4, this.injectedTexts = s, this.fromLineNumber = e, this.toLineNumber = t, this.detail = i;
  }
}
class eX {
  constructor() {
    this.changeType = 5;
  }
}
class am {
  constructor(e, t, i, s) {
    this.changes = e, this.versionId = t, this.isUndoing = i, this.isRedoing = s, this.resultingSelection = null;
  }
  containsEvent(e) {
    for (let t = 0, i = this.changes.length; t < i; t++)
      if (this.changes[t].changeType === e) return !0;
    return !1;
  }
  static merge(e, t) {
    const i = [].concat(e.changes).concat(t.changes), s = t.versionId, o = e.isUndoing || t.isUndoing, r = e.isRedoing || t.isRedoing;
    return new am(i, s, o, r);
  }
}
class $B {
  constructor(e) {
    this.changes = e;
  }
}
class ju {
  constructor(e, t) {
    this.rawContentChangedEvent = e, this.contentChangedEvent = t;
  }
  merge(e) {
    const t = am.merge(this.rawContentChangedEvent, e.rawContentChangedEvent), i = ju._mergeChangeEvents(this.contentChangedEvent, e.contentChangedEvent);
    return new ju(t, i);
  }
  static _mergeChangeEvents(e, t) {
    const i = [].concat(e.changes).concat(t.changes), s = t.eol, o = t.versionId, r = e.isUndoing || t.isUndoing, a = e.isRedoing || t.isRedoing, l = e.isFlush || t.isFlush;
    return { changes: i, eol: s, isEolChange: e.isEolChange && t.isEolChange, versionId: o, isUndoing: r, isRedoing: a, isFlush: l };
  }
}
const u5 = Hd("domLineBreaksComputer", { createHTML: (n) => n });
class qR {
  static create(e) {
    return new qR(new WeakRef(e));
  }
  constructor(e) {
    this.targetWindow = e;
  }
  createLineBreaksComputer(e, t, i, s, o) {
    const r = [], a = [];
    return { addRequest: (l, d, h) => {
      r.push(l), a.push(d);
    }, finalize: () => (function(l, d, h, c, u, g, p, f) {
      var _;
      function v(ee) {
        const te = f[ee];
        if (te) {
          const be = _a.applyInjectedText(d[ee], te), we = te.map(((it) => it.options)), Re = te.map(((it) => it.column - 1));
          return new o0(Re, we, [be.length], [], 0);
        }
        return null;
      }
      if (u === -1) {
        const ee = [];
        for (let te = 0, be = d.length; te < be; te++) ee[te] = v(te);
        return ee;
      }
      const b = Math.round(u * h.typicalHalfwidthCharacterWidth), C = g === 3 ? 2 : g === 2 ? 1 : 0, w = Math.round(c * C), y = Math.ceil(h.spaceWidth * w), L = document.createElement("div");
      yn(L, h);
      const k = new pf(1e4), N = [], A = [], B = [], T = [], O = [];
      for (let ee = 0; ee < d.length; ee++) {
        const te = _a.applyInjectedText(d[ee], f[ee]);
        let be = 0, we = 0, Re = b;
        if (g !== 0) if (be = Jn(te), be === -1) be = 0;
        else {
          for (let nt = 0; nt < be; nt++)
            we += te.charCodeAt(nt) === 9 ? c - we % c : 1;
          const Xi = Math.ceil(h.spaceWidth * we);
          Xi + h.typicalFullwidthCharacterWidth > b ? (be = 0, we = 0) : Re = b - Xi;
        }
        const it = te.substr(be), ut = tX(it, we, c, Re, k, y);
        N[ee] = be, A[ee] = we, B[ee] = it, T[ee] = ut[0], O[ee] = ut[1];
      }
      const H = k.build(), $ = (_ = u5?.createHTML(H)) !== null && _ !== void 0 ? _ : H;
      L.innerHTML = $, L.style.position = "absolute", L.style.top = "10000", p === "keepAll" ? (L.style.wordBreak = "keep-all", L.style.overflowWrap = "anywhere") : (L.style.wordBreak = "inherit", L.style.overflowWrap = "break-word"), l.document.body.appendChild(L);
      const pe = document.createRange(), me = Array.prototype.slice.call(L.children, 0), ue = [];
      for (let ee = 0; ee < d.length; ee++) {
        const te = iX(pe, me[ee], B[ee], T[ee]);
        if (te === null) {
          ue[ee] = v(ee);
          continue;
        }
        const be = N[ee], we = A[ee] + w, Re = O[ee], it = [];
        for (let De = 0, an = te.length; De < an; De++) it[De] = Re[te[De]];
        if (be !== 0) for (let De = 0, an = te.length; De < an; De++) te[De] += be;
        let ut, Xi;
        const nt = f[ee];
        nt ? (ut = nt.map(((De) => De.options)), Xi = nt.map(((De) => De.column - 1))) : (ut = null, Xi = null), ue[ee] = new o0(Xi, ut, te, it, we);
      }
      return l.document.body.removeChild(L), ue;
    })(Dh(this.targetWindow.deref()), r, e, t, i, s, o, a) };
  }
}
function tX(n, e, t, i, s, o) {
  if (o !== 0) {
    const u = String(o);
    s.appendString('<div style="text-indent: -'), s.appendString(u), s.appendString("px; padding-left: "), s.appendString(u), s.appendString("px; box-sizing: border-box; width:");
  } else s.appendString('<div style="width:');
  s.appendString(String(i)), s.appendString('px;">');
  const r = n.length;
  let a = e, l = 0;
  const d = [], h = [];
  let c = 0 < r ? n.charCodeAt(0) : 0;
  s.appendString("<span>");
  for (let u = 0; u < r; u++) {
    u !== 0 && u % 16384 == 0 && s.appendString("</span><span>"), d[u] = l, h[u] = a;
    const g = c;
    c = u + 1 < r ? n.charCodeAt(u + 1) : 0;
    let p = 1, f = 1;
    switch (g) {
      case 9:
        p = t - a % t, f = p;
        for (let _ = 1; _ <= p; _++) _ < p ? s.appendCharCode(160) : s.appendASCIICharCode(32);
        break;
      case 32:
        c === 32 ? s.appendCharCode(160) : s.appendASCIICharCode(32);
        break;
      case 60:
        s.appendString("&lt;");
        break;
      case 62:
        s.appendString("&gt;");
        break;
      case 38:
        s.appendString("&amp;");
        break;
      case 0:
        s.appendString("&#00;");
        break;
      case 65279:
      case 8232:
      case 8233:
      case 133:
        s.appendCharCode(65533);
        break;
      default:
        fc(g) && f++, g < 32 ? s.appendCharCode(9216 + g) : s.appendCharCode(g);
    }
    l += p, a += f;
  }
  return s.appendString("</span>"), d[n.length] = l, h[n.length] = a, s.appendString("</div>"), [d, h];
}
function iX(n, e, t, i) {
  if (t.length <= 1) return null;
  const s = Array.prototype.slice.call(e.children, 0), o = [];
  try {
    aI(n, s, i, 0, null, t.length - 1, null, o);
  } catch (r) {
    return console.log(r), null;
  }
  return o.length === 0 ? null : (o.push(t.length), o);
}
function aI(n, e, t, i, s, o, r, a) {
  if (i === o || (s = s || wD(n, e, t[i], t[i + 1]), r = r || wD(n, e, t[o], t[o + 1]), Math.abs(s[0].top - r[0].top) <= 0.1)) return;
  if (i + 1 === o) return void a.push(o);
  const l = i + (o - i) / 2 | 0, d = wD(n, e, t[l], t[l + 1]);
  aI(n, e, t, i, s, l, d, a), aI(n, e, t, l, d, o, r, a);
}
function wD(n, e, t, i) {
  return n.setStart(e[t / 16384 | 0].firstChild, t % 16384), n.setEnd(e[i / 16384 | 0].firstChild, i % 16384), n.getClientRects();
}
class nX extends V {
  constructor() {
    super(), this._editor = null, this._instantiationService = null, this._instances = this._register(new XT()), this._pending = /* @__PURE__ */ new Map(), this._finishedInstantiation = [], this._finishedInstantiation[0] = !1, this._finishedInstantiation[1] = !1, this._finishedInstantiation[2] = !1, this._finishedInstantiation[3] = !1;
  }
  initialize(e, t, i) {
    this._editor = e, this._instantiationService = i;
    for (const s of t) this._pending.has(s.id) ? We(new Error(`Cannot have two contributions with the same id ${s.id}`)) : this._pending.set(s.id, s);
    this._instantiateSome(0), this._register(c_(ke(this._editor.getDomNode()), (() => {
      this._instantiateSome(1);
    }))), this._register(c_(ke(this._editor.getDomNode()), (() => {
      this._instantiateSome(2);
    }))), this._register(c_(ke(this._editor.getDomNode()), (() => {
      this._instantiateSome(3);
    }), 5e3));
  }
  saveViewState() {
    const e = {};
    for (const [t, i] of this._instances) typeof i.saveViewState == "function" && (e[t] = i.saveViewState());
    return e;
  }
  restoreViewState(e) {
    for (const [t, i] of this._instances) typeof i.restoreViewState == "function" && i.restoreViewState(e[t]);
  }
  get(e) {
    return this._instantiateById(e), this._instances.get(e) || null;
  }
  onBeforeInteractionEvent() {
    this._instantiateSome(2);
  }
  onAfterModelAttached() {
    var e;
    return c_(ke((e = this._editor) === null || e === void 0 ? void 0 : e.getDomNode()), (() => {
      this._instantiateSome(1);
    }), 50);
  }
  _instantiateSome(e) {
    if (this._finishedInstantiation[e]) return;
    this._finishedInstantiation[e] = !0;
    const t = this._findPendingContributionsByInstantiation(e);
    for (const i of t) this._instantiateById(i.id);
  }
  _findPendingContributionsByInstantiation(e) {
    const t = [];
    for (const [, i] of this._pending) i.instantiation === e && t.push(i);
    return t;
  }
  _instantiateById(e) {
    const t = this._pending.get(e);
    if (t) {
      if (this._pending.delete(e), !this._instantiationService || !this._editor) throw new Error("Cannot instantiate contributions before being initialized!");
      try {
        const i = this._instantiationService.createInstance(t.ctor, this._editor);
        this._instances.set(t.id, i), typeof i.restoreViewState == "function" && t.instantiation !== 0 && console.warn(`Editor contribution '${t.id}' should be eager instantiated because it uses saveViewState / restoreViewState.`);
      } catch (i) {
        We(i);
      }
    }
  }
}
class GB {
  constructor(e, t, i, s, o, r, a) {
    this.id = e, this.label = t, this.alias = i, this.metadata = s, this._precondition = o, this._run = r, this._contextKeyService = a;
  }
  isSupported() {
    return this._contextKeyService.contextMatchesRules(this._precondition);
  }
  run(e) {
    return this.isSupported() ? this._run(e) : Promise.resolve(void 0);
  }
}
function kc(n) {
  let e = 0, t = 0, i = 0, s = 0;
  for (let o = 0, r = n.length; o < r; o++) {
    const a = n.charCodeAt(o);
    a === 13 ? (e === 0 && (t = o), e++, o + 1 < r && n.charCodeAt(o + 1) === 10 ? (s |= 2, o++) : s |= 3, i = o + 1) : a === 10 && (s |= 1, e === 0 && (t = o), e++, i = o + 1);
  }
  return e === 0 && (t = n.length), [e, t, n.length - i, s];
}
class g5 {
  constructor(e, t, i, s) {
    this.range = e, this.nestingLevel = t, this.nestingLevelOfEqualBracketType = i, this.isInvalid = s;
  }
}
class sX {
  constructor(e, t, i, s, o, r) {
    this.range = e, this.openingBracketRange = t, this.closingBracketRange = i, this.nestingLevel = s, this.nestingLevelOfEqualBracketType = o, this.bracketPairNode = r;
  }
  get openingBracketInfo() {
    return this.bracketPairNode.openingBracket.bracketInfo;
  }
}
class oX extends sX {
  constructor(e, t, i, s, o, r, a) {
    super(e, t, i, s, o, r), this.minVisibleColumnIndentation = a;
  }
}
class kr {
  static ofText(e) {
    let t = 0, i = 0;
    for (const s of e) s === `
` ? (t++, i = 0) : i++;
    return new kr(t, i);
  }
  constructor(e, t) {
    this.lineCount = e, this.columnCount = t;
  }
  createRange(e) {
    return this.lineCount === 0 ? new D(e.lineNumber, e.column, e.lineNumber, e.column + this.columnCount) : new D(e.lineNumber, e.column, e.lineNumber + this.lineCount, this.columnCount + 1);
  }
  addToPosition(e) {
    return this.lineCount === 0 ? new W(e.lineNumber, e.column + this.columnCount) : new W(e.lineNumber + this.lineCount, this.columnCount + 1);
  }
  toString() {
    return `${this.lineCount},${this.columnCount}`;
  }
}
kr.zero = new kr(0, 0);
const vs = 0;
function uy(n) {
  return n === 0;
}
const yo = 2 ** 26;
function Mi(n, e) {
  return n * yo + e;
}
function Xo(n) {
  const e = n, t = Math.floor(e / yo);
  return new kr(t, e - t * yo);
}
function gi(n, e) {
  let t = n + e;
  return e >= yo && (t -= n % yo), t;
}
function rX(n, e) {
  return n.reduce(((t, i) => gi(t, e(i))), vs);
}
function ZB(n, e) {
  return n === e;
}
function bv(n, e) {
  const t = n, i = e;
  if (i - t <= 0) return vs;
  const s = Math.floor(t / yo), o = Math.floor(i / yo), r = i - o * yo;
  return s === o ? Mi(0, r - (t - s * yo)) : Mi(o - s, r);
}
function lm(n, e) {
  return n < e;
}
function dm(n, e) {
  return n <= e;
}
function S_(n, e) {
  return n >= e;
}
function Fp(n) {
  return Mi(n.lineNumber - 1, n.column - 1);
}
function qu(n, e) {
  const t = n, i = Math.floor(t / yo), s = t - i * yo, o = e, r = Math.floor(o / yo);
  return new D(i + 1, s + 1, r + 1, o - r * yo + 1);
}
class bd {
  static fromModelContentChanges(e) {
    return e.map(((i) => {
      const s = D.lift(i.range);
      return new bd(Fp(s.getStartPosition()), Fp(s.getEndPosition()), (function(o) {
        const r = Sl(o);
        return Mi(r.length - 1, r[r.length - 1].length);
      })(i.text));
    })).reverse();
  }
  constructor(e, t, i) {
    this.startOffset = e, this.endOffset = t, this.newLength = i;
  }
  toString() {
    return `[${Xo(this.startOffset)}...${Xo(this.endOffset)}) -> ${Xo(this.newLength)}`;
  }
}
class aX {
  constructor(e) {
    this.nextEditIdx = 0, this.deltaOldToNewLineCount = 0, this.deltaOldToNewColumnCount = 0, this.deltaLineIdxInOld = -1, this.edits = e.map(((t) => $R.from(t)));
  }
  getOffsetBeforeChange(e) {
    return this.adjustNextEdit(e), this.translateCurToOld(e);
  }
  getDistanceToNextChange(e) {
    this.adjustNextEdit(e);
    const t = this.edits[this.nextEditIdx], i = t ? this.translateOldToCur(t.offsetObj) : null;
    return i === null ? null : bv(e, i);
  }
  translateOldToCur(e) {
    return e.lineCount === this.deltaLineIdxInOld ? Mi(e.lineCount + this.deltaOldToNewLineCount, e.columnCount + this.deltaOldToNewColumnCount) : Mi(e.lineCount + this.deltaOldToNewLineCount, e.columnCount);
  }
  translateCurToOld(e) {
    const t = Xo(e);
    return t.lineCount - this.deltaOldToNewLineCount === this.deltaLineIdxInOld ? Mi(t.lineCount - this.deltaOldToNewLineCount, t.columnCount - this.deltaOldToNewColumnCount) : Mi(t.lineCount - this.deltaOldToNewLineCount, t.columnCount);
  }
  adjustNextEdit(e) {
    for (; this.nextEditIdx < this.edits.length; ) {
      const t = this.edits[this.nextEditIdx], i = this.translateOldToCur(t.endOffsetAfterObj);
      if (!dm(i, e)) break;
      {
        this.nextEditIdx++;
        const s = Xo(i), o = Xo(this.translateOldToCur(t.endOffsetBeforeObj)), r = s.lineCount - o.lineCount;
        this.deltaOldToNewLineCount += r;
        const a = this.deltaLineIdxInOld === t.endOffsetBeforeObj.lineCount ? this.deltaOldToNewColumnCount : 0, l = s.columnCount - o.columnCount;
        this.deltaOldToNewColumnCount = a + l, this.deltaLineIdxInOld = t.endOffsetBeforeObj.lineCount;
      }
    }
  }
}
class $R {
  static from(e) {
    return new $R(e.startOffset, e.endOffset, e.newLength);
  }
  constructor(e, t, i) {
    this.endOffsetBeforeObj = Xo(t), this.endOffsetAfterObj = Xo(gi(e, i)), this.offsetObj = Xo(e);
  }
}
const VC = [];
class zi {
  static create(e, t) {
    if (e <= 128 && t.length === 0) {
      let i = zi.cache[e];
      return i || (i = new zi(e, t), zi.cache[e] = i), i;
    }
    return new zi(e, t);
  }
  static getEmpty() {
    return this.empty;
  }
  constructor(e, t) {
    this.items = e, this.additionalItems = t;
  }
  add(e, t) {
    const i = t.getKey(e);
    let s = i >> 5;
    if (s === 0) {
      const r = 1 << i | this.items;
      return r === this.items ? this : zi.create(r, this.additionalItems);
    }
    s--;
    const o = this.additionalItems.slice(0);
    for (; o.length < s; ) o.push(0);
    return o[s] |= 1 << (31 & i), zi.create(this.items, o);
  }
  merge(e) {
    const t = this.items | e.items;
    if (this.additionalItems === VC && e.additionalItems === VC) return t === this.items ? this : t === e.items ? e : zi.create(t, VC);
    const i = [];
    for (let s = 0; s < Math.max(this.additionalItems.length, e.additionalItems.length); s++) {
      const o = this.additionalItems[s] || 0, r = e.additionalItems[s] || 0;
      i.push(o | r);
    }
    return zi.create(t, i);
  }
  intersects(e) {
    if (this.items & e.items) return !0;
    for (let t = 0; t < Math.min(this.additionalItems.length, e.additionalItems.length); t++) if (this.additionalItems[t] & e.additionalItems[t]) return !0;
    return !1;
  }
}
zi.cache = new Array(129), zi.empty = zi.create(0, VC);
const p5 = { getKey: (n) => n };
class YB {
  constructor() {
    this.items = /* @__PURE__ */ new Map();
  }
  getKey(e) {
    let t = this.items.get(e);
    return t === void 0 && (t = this.items.size, this.items.set(e, t)), t;
  }
}
class GR {
  get length() {
    return this._length;
  }
  constructor(e) {
    this._length = e;
  }
}
class Cv extends GR {
  static create(e, t, i) {
    let s = e.length;
    return t && (s = gi(s, t.length)), i && (s = gi(s, i.length)), new Cv(s, e, t, i, t ? t.missingOpeningBracketIds : zi.getEmpty());
  }
  get kind() {
    return 2;
  }
  get listHeight() {
    return 0;
  }
  get childrenLength() {
    return 3;
  }
  getChild(e) {
    switch (e) {
      case 0:
        return this.openingBracket;
      case 1:
        return this.child;
      case 2:
        return this.closingBracket;
    }
    throw new Error("Invalid child index");
  }
  get children() {
    const e = [];
    return e.push(this.openingBracket), this.child && e.push(this.child), this.closingBracket && e.push(this.closingBracket), e;
  }
  constructor(e, t, i, s, o) {
    super(e), this.openingBracket = t, this.child = i, this.closingBracket = s, this.missingOpeningBracketIds = o;
  }
  canBeReused(e) {
    return this.closingBracket !== null && !e.intersects(this.missingOpeningBracketIds);
  }
  deepClone() {
    return new Cv(this.length, this.openingBracket.deepClone(), this.child && this.child.deepClone(), this.closingBracket && this.closingBracket.deepClone(), this.missingOpeningBracketIds);
  }
  computeMinIndentation(e, t) {
    return this.child ? this.child.computeMinIndentation(gi(e, this.openingBracket.length), t) : Number.MAX_SAFE_INTEGER;
  }
}
class Ga extends GR {
  static create23(e, t, i, s = !1) {
    let o = e.length, r = e.missingOpeningBracketIds;
    if (e.listHeight !== t.listHeight) throw new Error("Invalid list heights");
    if (o = gi(o, t.length), r = r.merge(t.missingOpeningBracketIds), i) {
      if (e.listHeight !== i.listHeight) throw new Error("Invalid list heights");
      o = gi(o, i.length), r = r.merge(i.missingOpeningBracketIds);
    }
    return s ? new lX(o, e.listHeight + 1, e, t, i, r) : new wv(o, e.listHeight + 1, e, t, i, r);
  }
  static getEmpty() {
    return new dX(vs, 0, [], zi.getEmpty());
  }
  get kind() {
    return 4;
  }
  get missingOpeningBracketIds() {
    return this._missingOpeningBracketIds;
  }
  constructor(e, t, i) {
    super(e), this.listHeight = t, this._missingOpeningBracketIds = i, this.cachedMinIndentation = -1;
  }
  throwIfImmutable() {
  }
  makeLastElementMutable() {
    this.throwIfImmutable();
    const e = this.childrenLength;
    if (e === 0) return;
    const t = this.getChild(e - 1), i = t.kind === 4 ? t.toMutable() : t;
    return t !== i && this.setChild(e - 1, i), i;
  }
  makeFirstElementMutable() {
    if (this.throwIfImmutable(), this.childrenLength === 0) return;
    const e = this.getChild(0), t = e.kind === 4 ? e.toMutable() : e;
    return e !== t && this.setChild(0, t), t;
  }
  canBeReused(e) {
    if (e.intersects(this.missingOpeningBracketIds) || this.childrenLength === 0) return !1;
    let t = this;
    for (; t.kind === 4; ) {
      const i = t.childrenLength;
      if (i === 0) throw new Kt();
      t = t.getChild(i - 1);
    }
    return t.canBeReused(e);
  }
  handleChildrenChanged() {
    this.throwIfImmutable();
    const e = this.childrenLength;
    let t = this.getChild(0).length, i = this.getChild(0).missingOpeningBracketIds;
    for (let s = 1; s < e; s++) {
      const o = this.getChild(s);
      t = gi(t, o.length), i = i.merge(o.missingOpeningBracketIds);
    }
    this._length = t, this._missingOpeningBracketIds = i, this.cachedMinIndentation = -1;
  }
  computeMinIndentation(e, t) {
    if (this.cachedMinIndentation !== -1) return this.cachedMinIndentation;
    let i = Number.MAX_SAFE_INTEGER, s = e;
    for (let o = 0; o < this.childrenLength; o++) {
      const r = this.getChild(o);
      r && (i = Math.min(i, r.computeMinIndentation(s, t)), s = gi(s, r.length));
    }
    return this.cachedMinIndentation = i, i;
  }
}
class wv extends Ga {
  get childrenLength() {
    return this._item3 !== null ? 3 : 2;
  }
  getChild(e) {
    switch (e) {
      case 0:
        return this._item1;
      case 1:
        return this._item2;
      case 2:
        return this._item3;
    }
    throw new Error("Invalid child index");
  }
  setChild(e, t) {
    switch (e) {
      case 0:
        return void (this._item1 = t);
      case 1:
        return void (this._item2 = t);
      case 2:
        return void (this._item3 = t);
    }
    throw new Error("Invalid child index");
  }
  get children() {
    return this._item3 ? [this._item1, this._item2, this._item3] : [this._item1, this._item2];
  }
  get item1() {
    return this._item1;
  }
  get item2() {
    return this._item2;
  }
  get item3() {
    return this._item3;
  }
  constructor(e, t, i, s, o, r) {
    super(e, t, r), this._item1 = i, this._item2 = s, this._item3 = o;
  }
  deepClone() {
    return new wv(this.length, this.listHeight, this._item1.deepClone(), this._item2.deepClone(), this._item3 ? this._item3.deepClone() : null, this.missingOpeningBracketIds);
  }
  appendChildOfSameHeight(e) {
    if (this._item3) throw new Error("Cannot append to a full (2,3) tree node");
    this.throwIfImmutable(), this._item3 = e, this.handleChildrenChanged();
  }
  unappendChild() {
    if (!this._item3) throw new Error("Cannot remove from a non-full (2,3) tree node");
    this.throwIfImmutable();
    const e = this._item3;
    return this._item3 = null, this.handleChildrenChanged(), e;
  }
  prependChildOfSameHeight(e) {
    if (this._item3) throw new Error("Cannot prepend to a full (2,3) tree node");
    this.throwIfImmutable(), this._item3 = this._item2, this._item2 = this._item1, this._item1 = e, this.handleChildrenChanged();
  }
  unprependChild() {
    if (!this._item3) throw new Error("Cannot remove from a non-full (2,3) tree node");
    this.throwIfImmutable();
    const e = this._item1;
    return this._item1 = this._item2, this._item2 = this._item3, this._item3 = null, this.handleChildrenChanged(), e;
  }
  toMutable() {
    return this;
  }
}
class lX extends wv {
  toMutable() {
    return new wv(this.length, this.listHeight, this.item1, this.item2, this.item3, this.missingOpeningBracketIds);
  }
  throwIfImmutable() {
    throw new Error("this instance is immutable");
  }
}
class gy extends Ga {
  get childrenLength() {
    return this._children.length;
  }
  getChild(e) {
    return this._children[e];
  }
  setChild(e, t) {
    this._children[e] = t;
  }
  get children() {
    return this._children;
  }
  constructor(e, t, i, s) {
    super(e, t, s), this._children = i;
  }
  deepClone() {
    const e = new Array(this._children.length);
    for (let t = 0; t < this._children.length; t++) e[t] = this._children[t].deepClone();
    return new gy(this.length, this.listHeight, e, this.missingOpeningBracketIds);
  }
  appendChildOfSameHeight(e) {
    this.throwIfImmutable(), this._children.push(e), this.handleChildrenChanged();
  }
  unappendChild() {
    this.throwIfImmutable();
    const e = this._children.pop();
    return this.handleChildrenChanged(), e;
  }
  prependChildOfSameHeight(e) {
    this.throwIfImmutable(), this._children.unshift(e), this.handleChildrenChanged();
  }
  unprependChild() {
    this.throwIfImmutable();
    const e = this._children.shift();
    return this.handleChildrenChanged(), e;
  }
  toMutable() {
    return this;
  }
}
class dX extends gy {
  toMutable() {
    return new gy(this.length, this.listHeight, [...this.children], this.missingOpeningBracketIds);
  }
  throwIfImmutable() {
    throw new Error("this instance is immutable");
  }
}
const hX = [];
class ZR extends GR {
  get listHeight() {
    return 0;
  }
  get childrenLength() {
    return 0;
  }
  getChild(e) {
    return null;
  }
  get children() {
    return hX;
  }
  deepClone() {
    return this;
  }
}
class Cu extends ZR {
  get kind() {
    return 0;
  }
  get missingOpeningBracketIds() {
    return zi.getEmpty();
  }
  canBeReused(e) {
    return !0;
  }
  computeMinIndentation(e, t) {
    const i = Xo(e), s = (i.columnCount === 0 ? i.lineCount : i.lineCount + 1) + 1, o = (function(a) {
      return Math.floor(a / yo);
    })(gi(e, this.length)) + 1;
    let r = Number.MAX_SAFE_INTEGER;
    for (let a = s; a <= o; a++) {
      const l = t.getLineFirstNonWhitespaceColumn(a), d = t.getLineContent(a);
      if (l === 0) continue;
      const h = Gi.visibleColumnFromColumn(d, l, t.getOptions().tabSize);
      r = Math.min(r, h);
    }
    return r;
  }
}
class py extends ZR {
  static create(e, t, i) {
    return new py(e, t, i);
  }
  get kind() {
    return 1;
  }
  get missingOpeningBracketIds() {
    return zi.getEmpty();
  }
  constructor(e, t, i) {
    super(e), this.bracketInfo = t, this.bracketIds = i;
  }
  get text() {
    return this.bracketInfo.bracketText;
  }
  get languageId() {
    return this.bracketInfo.languageId;
  }
  canBeReused(e) {
    return !1;
  }
  computeMinIndentation(e, t) {
    return Number.MAX_SAFE_INTEGER;
  }
}
class cX extends ZR {
  get kind() {
    return 3;
  }
  constructor(e, t) {
    super(t), this.missingOpeningBracketIds = e;
  }
  canBeReused(e) {
    return !e.intersects(this.missingOpeningBracketIds);
  }
  computeMinIndentation(e, t) {
    return Number.MAX_SAFE_INTEGER;
  }
}
let Ch = class {
  constructor(n, e, t, i, s) {
    this.length = n, this.kind = e, this.bracketId = t, this.bracketIds = i, this.astNode = s;
  }
};
class XB {
  constructor(e, t) {
    this.textModel = e, this.bracketTokens = t, this.reader = new uX(this.textModel, this.bracketTokens), this._offset = vs, this.didPeek = !1, this.peeked = null, this.textBufferLineCount = e.getLineCount(), this.textBufferLastLineLength = e.getLineLength(this.textBufferLineCount);
  }
  get offset() {
    return this._offset;
  }
  get length() {
    return Mi(this.textBufferLineCount - 1, this.textBufferLastLineLength);
  }
  skip(e) {
    this.didPeek = !1, this._offset = gi(this._offset, e);
    const t = Xo(this._offset);
    this.reader.setPosition(t.lineCount, t.columnCount);
  }
  read() {
    let e;
    return this.peeked ? (this.didPeek = !1, e = this.peeked) : e = this.reader.read(), e && (this._offset = gi(this._offset, e.length)), e;
  }
  peek() {
    return this.didPeek || (this.peeked = this.reader.read(), this.didPeek = !0), this.peeked;
  }
}
class uX {
  constructor(e, t) {
    this.textModel = e, this.bracketTokens = t, this.lineIdx = 0, this.line = null, this.lineCharOffset = 0, this.lineTokens = null, this.lineTokenOffset = 0, this.peekedToken = null, this.textBufferLineCount = e.getLineCount(), this.textBufferLastLineLength = e.getLineLength(this.textBufferLineCount);
  }
  setPosition(e, t) {
    e === this.lineIdx ? (this.lineCharOffset = t, this.line !== null && (this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset))) : (this.lineIdx = e, this.lineCharOffset = t, this.line = null), this.peekedToken = null;
  }
  read() {
    if (this.peekedToken) {
      const d = this.peekedToken;
      return this.peekedToken = null, this.lineCharOffset += d.length, d;
    }
    if (this.lineIdx > this.textBufferLineCount - 1 || this.lineIdx === this.textBufferLineCount - 1 && this.lineCharOffset >= this.textBufferLastLineLength) return null;
    this.line === null && (this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1), this.line = this.lineTokens.getLineContent(), this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset));
    const e = this.lineIdx, t = this.lineCharOffset;
    let i = 0;
    for (; ; ) {
      const d = this.lineTokens, h = d.getCount();
      let c = null;
      if (this.lineTokenOffset < h) {
        const u = d.getMetadata(this.lineTokenOffset);
        for (; this.lineTokenOffset + 1 < h && u === d.getMetadata(this.lineTokenOffset + 1); ) this.lineTokenOffset++;
        const g = In.getTokenType(u) === 0, p = In.containsBalancedBrackets(u), f = d.getEndOffset(this.lineTokenOffset);
        if (p && g && this.lineCharOffset < f) {
          const _ = d.getLanguageId(this.lineTokenOffset), v = this.line.substring(this.lineCharOffset, f), b = this.bracketTokens.getSingleLanguageBracketTokens(_), C = b.regExpGlobal;
          if (C) {
            C.lastIndex = 0;
            const w = C.exec(v);
            w && (c = b.getToken(w[0]), c && (this.lineCharOffset += w.index));
          }
        }
        if (i += f - this.lineCharOffset, c) {
          if (e !== this.lineIdx || t !== this.lineCharOffset) {
            this.peekedToken = c;
            break;
          }
          return this.lineCharOffset += c.length, c;
        }
        this.lineTokenOffset++, this.lineCharOffset = f;
      } else if (this.lineIdx === this.textBufferLineCount - 1 || (this.lineIdx++, this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1), this.lineTokenOffset = 0, this.line = this.lineTokens.getLineContent(), this.lineCharOffset = 0, i += 33, i > 1e3)) break;
      if (i > 1500) break;
    }
    const s = (o = e, r = t, a = this.lineIdx, l = this.lineCharOffset, o !== a ? Mi(a - o, l) : Mi(0, l - r));
    var o, r, a, l;
    return new Ch(s, 0, -1, zi.getEmpty(), new Cu(s));
  }
}
class gX {
  constructor(e, t) {
    this.text = e, this._offset = vs, this.idx = 0;
    const i = t.getRegExpStr(), s = i ? new RegExp(i + `|
`, "gi") : null, o = [];
    let r, a = 0, l = 0, d = 0, h = 0;
    const c = [];
    for (let p = 0; p < 60; p++) c.push(new Ch(Mi(0, p), 0, -1, zi.getEmpty(), new Cu(Mi(0, p))));
    const u = [];
    for (let p = 0; p < 60; p++) u.push(new Ch(Mi(1, p), 0, -1, zi.getEmpty(), new Cu(Mi(1, p))));
    if (s) for (s.lastIndex = 0; (r = s.exec(e)) !== null; ) {
      const p = r.index, f = r[0];
      if (f === `
`) a++, l = p + 1;
      else {
        if (d !== p) {
          let _;
          if (h === a) {
            const v = p - d;
            if (v < c.length) _ = c[v];
            else {
              const b = Mi(0, v);
              _ = new Ch(b, 0, -1, zi.getEmpty(), new Cu(b));
            }
          } else {
            const v = a - h, b = p - l;
            if (v === 1 && b < u.length) _ = u[b];
            else {
              const C = Mi(v, b);
              _ = new Ch(C, 0, -1, zi.getEmpty(), new Cu(C));
            }
          }
          o.push(_);
        }
        o.push(t.getToken(f)), d = p + f.length, h = a;
      }
    }
    const g = e.length;
    if (d !== g) {
      const p = h === a ? Mi(0, g - d) : Mi(a - h, g - l);
      o.push(new Ch(p, 0, -1, zi.getEmpty(), new Cu(p)));
    }
    this.length = Mi(a, g - l), this.tokens = o;
  }
  get offset() {
    return this._offset;
  }
  read() {
    return this.tokens[this.idx++] || null;
  }
  peek() {
    return this.tokens[this.idx] || null;
  }
  skip(e) {
    throw new tK();
  }
}
class YR {
  static createFromLanguage(e, t) {
    function i(o) {
      return t.getKey(`${o.languageId}:::${o.bracketText}`);
    }
    const s = /* @__PURE__ */ new Map();
    for (const o of e.bracketsNew.openingBrackets) {
      const r = Mi(0, o.bracketText.length), a = i(o), l = zi.getEmpty().add(a, p5);
      s.set(o.bracketText, new Ch(r, 1, a, l, py.create(r, o, l)));
    }
    for (const o of e.bracketsNew.closingBrackets) {
      const r = Mi(0, o.bracketText.length);
      let a = zi.getEmpty();
      const l = o.getOpeningBrackets();
      for (const d of l) a = a.add(i(d), p5);
      s.set(o.bracketText, new Ch(r, 2, i(l[0]), a, py.create(r, o, a)));
    }
    return new YR(s);
  }
  constructor(e) {
    this.map = e, this.hasRegExp = !1, this._regExpGlobal = null;
  }
  getRegExpStr() {
    if (this.isEmpty) return null;
    {
      const e = [...this.map.keys()];
      return e.sort(), e.reverse(), e.map(((t) => (function(i) {
        let s = No(i);
        return /^[\w ]+/.test(i) && (s = `\\b${s}`), /[\w ]+$/.test(i) && (s = `${s}\\b`), s;
      })(t))).join("|");
    }
  }
  get regExpGlobal() {
    if (!this.hasRegExp) {
      const e = this.getRegExpStr();
      this._regExpGlobal = e ? new RegExp(e, "gi") : null, this.hasRegExp = !0;
    }
    return this._regExpGlobal;
  }
  getToken(e) {
    return this.map.get(e.toLowerCase());
  }
  findClosingTokenText(e) {
    for (const [t, i] of this.map) if (i.kind === 2 && i.bracketIds.intersects(e)) return t;
  }
  get isEmpty() {
    return this.map.size === 0;
  }
}
class QB {
  constructor(e, t) {
    this.denseKeyProvider = e, this.getLanguageConfiguration = t, this.languageIdToBracketTokens = /* @__PURE__ */ new Map();
  }
  didLanguageChange(e) {
    return this.languageIdToBracketTokens.has(e);
  }
  getSingleLanguageBracketTokens(e) {
    let t = this.languageIdToBracketTokens.get(e);
    return t || (t = YR.createFromLanguage(this.getLanguageConfiguration(e), this.denseKeyProvider), this.languageIdToBracketTokens.set(e, t)), t;
  }
}
function m5(n, e = !1) {
  if (n.length === 0) return null;
  if (n.length === 1) return n[0];
  let t = n.length;
  for (; t > 3; ) {
    const i = t >> 1;
    for (let s = 0; s < i; s++) {
      const o = s << 1;
      n[s] = Ga.create23(n[o], n[o + 1], o + 3 === t ? n[o + 2] : null, e);
    }
    t = i;
  }
  return Ga.create23(n[0], n[1], t >= 3 ? n[2] : null, e);
}
function f5(n, e) {
  return Math.abs(n.listHeight - e.listHeight);
}
function yD(n, e) {
  return n.listHeight === e.listHeight ? Ga.create23(n, e, null, !1) : n.listHeight > e.listHeight ? (function(t, i) {
    let s = t = t.toMutable();
    const o = [];
    let r;
    for (; ; ) {
      if (i.listHeight === s.listHeight) {
        r = i;
        break;
      }
      if (s.kind !== 4) throw new Error("unexpected");
      o.push(s), s = s.makeLastElementMutable();
    }
    for (let a = o.length - 1; a >= 0; a--) {
      const l = o[a];
      r ? l.childrenLength >= 3 ? r = Ga.create23(l.unappendChild(), r, null, !1) : (l.appendChildOfSameHeight(r), r = void 0) : l.handleChildrenChanged();
    }
    return r ? Ga.create23(t, r, null, !1) : t;
  })(n, e) : (function(t, i) {
    let s = t = t.toMutable();
    const o = [];
    for (; i.listHeight !== s.listHeight; ) {
      if (s.kind !== 4) throw new Error("unexpected");
      o.push(s), s = s.makeFirstElementMutable();
    }
    let r = i;
    for (let a = o.length - 1; a >= 0; a--) {
      const l = o[a];
      r ? l.childrenLength >= 3 ? r = Ga.create23(r, l.unprependChild(), null, !1) : (l.prependChildOfSameHeight(r), r = void 0) : l.handleChildrenChanged();
    }
    return r ? Ga.create23(r, t, null, !1) : t;
  })(e, n);
}
class pX {
  constructor(e) {
    this.lastOffset = vs, this.nextNodes = [e], this.offsets = [vs], this.idxs = [];
  }
  readLongestNodeAt(e, t) {
    if (lm(e, this.lastOffset)) throw new Error("Invalid offset");
    for (this.lastOffset = e; ; ) {
      const i = Bf(this.nextNodes);
      if (!i) return;
      const s = Bf(this.offsets);
      if (lm(e, s)) return;
      if (lm(s, e)) if (gi(s, i.length) <= e) this.nextNodeAfterCurrent();
      else {
        const o = SD(i);
        o !== -1 ? (this.nextNodes.push(i.getChild(o)), this.offsets.push(s), this.idxs.push(o)) : this.nextNodeAfterCurrent();
      }
      else {
        if (t(i)) return this.nextNodeAfterCurrent(), i;
        {
          const o = SD(i);
          if (o === -1) return void this.nextNodeAfterCurrent();
          this.nextNodes.push(i.getChild(o)), this.offsets.push(s), this.idxs.push(o);
        }
      }
    }
  }
  nextNodeAfterCurrent() {
    for (; ; ) {
      const e = Bf(this.offsets), t = Bf(this.nextNodes);
      if (this.nextNodes.pop(), this.offsets.pop(), this.idxs.length === 0) break;
      const i = Bf(this.nextNodes), s = SD(i, this.idxs[this.idxs.length - 1]);
      if (s !== -1) {
        this.nextNodes.push(i.getChild(s)), this.offsets.push(gi(e, t.length)), this.idxs[this.idxs.length - 1] = s;
        break;
      }
      this.idxs.pop();
    }
  }
}
function SD(n, e = -1) {
  for (; ; ) {
    if (++e >= n.childrenLength) return -1;
    if (n.getChild(e)) return e;
  }
}
function Bf(n) {
  return n.length > 0 ? n[n.length - 1] : void 0;
}
function lI(n, e, t, i) {
  return new mX(n, e, t, i).parseDocument();
}
class mX {
  constructor(e, t, i, s) {
    if (this.tokenizer = e, this.createImmutableLists = s, this._itemsConstructed = 0, this._itemsFromCache = 0, i && s) throw new Error("Not supported");
    this.oldNodeReader = i ? new pX(i) : void 0, this.positionMapper = new aX(t);
  }
  parseDocument() {
    this._itemsConstructed = 0, this._itemsFromCache = 0;
    let e = this.parseList(zi.getEmpty(), 0);
    return e || (e = Ga.getEmpty()), e;
  }
  parseList(e, t) {
    const i = [];
    for (; ; ) {
      let o = this.tryReadChildFromCache(e);
      if (!o) {
        const r = this.tokenizer.peek();
        if (!r || r.kind === 2 && r.bracketIds.intersects(e)) break;
        o = this.parseChild(e, t + 1);
      }
      o.kind === 4 && o.childrenLength === 0 || i.push(o);
    }
    return this.oldNodeReader ? (function(o) {
      if (o.length === 0) return null;
      if (o.length === 1) return o[0];
      let r = 0;
      function a() {
        if (r >= o.length) return null;
        const h = r, c = o[h].listHeight;
        for (r++; r < o.length && o[r].listHeight === c; ) r++;
        return r - h >= 2 ? m5(h === 0 && r === o.length ? o : o.slice(h, r), !1) : o[h];
      }
      let l = a(), d = a();
      if (!d) return l;
      for (let h = a(); h; h = a()) f5(l, d) <= f5(d, h) ? (l = yD(l, d), d = h) : d = yD(d, h);
      return yD(l, d);
    })(i) : m5(i, this.createImmutableLists);
  }
  tryReadChildFromCache(e) {
    if (this.oldNodeReader) {
      const t = this.positionMapper.getDistanceToNextChange(this.tokenizer.offset);
      if (t === null || !uy(t)) {
        const i = this.oldNodeReader.readLongestNodeAt(this.positionMapper.getOffsetBeforeChange(this.tokenizer.offset), ((s) => t !== null && !lm(s.length, t) ? !1 : s.canBeReused(e)));
        if (i) return this._itemsFromCache++, this.tokenizer.skip(i.length), i;
      }
    }
  }
  parseChild(e, t) {
    this._itemsConstructed++;
    const i = this.tokenizer.read();
    switch (i.kind) {
      case 2:
        return new cX(i.bracketIds, i.length);
      case 0:
        return i.astNode;
      case 1: {
        if (t > 300) return new Cu(i.length);
        const s = e.merge(i.bracketIds), o = this.parseList(s, t + 1), r = this.tokenizer.peek();
        return r && r.kind === 2 && (r.bracketId === i.bracketId || r.bracketIds.intersects(i.bracketIds)) ? (this.tokenizer.read(), Cv.create(i.astNode, o, r.astNode)) : Cv.create(i.astNode, o, null);
      }
      default:
        throw new Error("unexpected");
    }
  }
}
function my(n, e) {
  if (n.length === 0) return e;
  if (e.length === 0) return n;
  const t = new Pd(_5(n)), i = _5(e);
  i.push({ modified: !1, lengthBefore: void 0, lengthAfter: void 0 });
  let s = t.dequeue();
  function o(d) {
    if (d === void 0) {
      const c = t.takeWhile(((u) => !0)) || [];
      return s && c.unshift(s), c;
    }
    const h = [];
    for (; s && !uy(d); ) {
      const [c, u] = s.splitAt(d);
      h.push(c), d = bv(c.lengthAfter, d), s = u ?? t.dequeue();
    }
    return uy(d) || h.push(new Oh(!1, d, d)), h;
  }
  const r = [];
  function a(d, h, c) {
    if (r.length > 0 && ZB(r[r.length - 1].endOffset, d)) {
      const u = r[r.length - 1];
      r[r.length - 1] = new bd(u.startOffset, h, gi(u.newLength, c));
    } else r.push({ startOffset: d, endOffset: h, newLength: c });
  }
  let l = vs;
  for (const d of i) {
    const h = o(d.lengthBefore);
    if (d.modified) {
      const c = gi(l, rX(h, ((u) => u.lengthBefore)));
      a(l, c, d.lengthAfter), l = c;
    } else for (const c of h) {
      const u = l;
      l = gi(l, c.lengthBefore), c.modified && a(u, l, c.lengthAfter);
    }
  }
  return r;
}
class Oh {
  constructor(e, t, i) {
    this.modified = e, this.lengthBefore = t, this.lengthAfter = i;
  }
  splitAt(e) {
    const t = bv(e, this.lengthAfter);
    return ZB(t, vs) ? [this, void 0] : this.modified ? [new Oh(this.modified, this.lengthBefore, e), new Oh(this.modified, vs, t)] : [new Oh(this.modified, e, e), new Oh(this.modified, t, t)];
  }
  toString() {
    return `${this.modified ? "M" : "U"}:${Xo(this.lengthBefore)} -> ${Xo(this.lengthAfter)}`;
  }
}
function _5(n) {
  const e = [];
  let t = vs;
  for (const i of n) {
    const s = bv(t, i.startOffset);
    uy(s) || e.push(new Oh(!1, s, s));
    const o = bv(i.startOffset, i.endOffset);
    e.push(new Oh(!0, o, i.newLength)), t = i.endOffset;
  }
  return e;
}
class fX extends V {
  didLanguageChange(e) {
    return this.brackets.didLanguageChange(e);
  }
  constructor(e, t) {
    if (super(), this.textModel = e, this.getLanguageConfiguration = t, this.didChangeEmitter = new F(), this.denseKeyProvider = new YB(), this.brackets = new QB(this.denseKeyProvider, this.getLanguageConfiguration), this.onDidChange = this.didChangeEmitter.event, this.queuedTextEditsForInitialAstWithoutTokens = [], this.queuedTextEdits = [], e.tokenization.hasTokens) e.tokenization.backgroundTokenizationState === 2 ? (this.initialAstWithoutTokens = void 0, this.astWithTokens = this.parseDocumentFromTextBuffer([], void 0, !1)) : (this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer([], void 0, !0), this.astWithTokens = this.initialAstWithoutTokens);
    else {
      const i = this.brackets.getSingleLanguageBracketTokens(this.textModel.getLanguageId()), s = new gX(this.textModel.getValue(), i);
      this.initialAstWithoutTokens = lI(s, [], void 0, !0), this.astWithTokens = this.initialAstWithoutTokens;
    }
  }
  handleDidChangeBackgroundTokenizationState() {
    if (this.textModel.tokenization.backgroundTokenizationState === 2) {
      const e = this.initialAstWithoutTokens === void 0;
      this.initialAstWithoutTokens = void 0, e || this.didChangeEmitter.fire();
    }
  }
  handleDidChangeTokens({ ranges: e }) {
    const t = e.map(((i) => new bd(Mi(i.fromLineNumber - 1, 0), Mi(i.toLineNumber, 0), Mi(i.toLineNumber - i.fromLineNumber + 1, 0))));
    this.handleEdits(t, !0), this.initialAstWithoutTokens || this.didChangeEmitter.fire();
  }
  handleContentChanged(e) {
    const t = bd.fromModelContentChanges(e.changes);
    this.handleEdits(t, !1);
  }
  handleEdits(e, t) {
    const i = my(this.queuedTextEdits, e);
    this.queuedTextEdits = i, this.initialAstWithoutTokens && !t && (this.queuedTextEditsForInitialAstWithoutTokens = my(this.queuedTextEditsForInitialAstWithoutTokens, e));
  }
  flushQueue() {
    this.queuedTextEdits.length > 0 && (this.astWithTokens = this.parseDocumentFromTextBuffer(this.queuedTextEdits, this.astWithTokens, !1), this.queuedTextEdits = []), this.queuedTextEditsForInitialAstWithoutTokens.length > 0 && (this.initialAstWithoutTokens && (this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer(this.queuedTextEditsForInitialAstWithoutTokens, this.initialAstWithoutTokens, !1)), this.queuedTextEditsForInitialAstWithoutTokens = []);
  }
  parseDocumentFromTextBuffer(e, t, i) {
    const s = t;
    return lI(new XB(this.textModel, this.brackets), e, s, i);
  }
  getBracketsInRange(e, t) {
    this.flushQueue();
    const i = Mi(e.startLineNumber - 1, e.startColumn - 1), s = Mi(e.endLineNumber - 1, e.endColumn - 1);
    return new dl(((o) => {
      const r = this.initialAstWithoutTokens || this.astWithTokens;
      dI(r, vs, r.length, i, s, o, 0, 0, /* @__PURE__ */ new Map(), t);
    }));
  }
  getBracketPairsInRange(e, t) {
    this.flushQueue();
    const i = Fp(e.getStartPosition()), s = Fp(e.getEndPosition());
    return new dl(((o) => {
      const r = this.initialAstWithoutTokens || this.astWithTokens, a = new _X(o, t, this.textModel);
      hI(r, vs, r.length, i, s, a, 0, /* @__PURE__ */ new Map());
    }));
  }
  getFirstBracketAfter(e) {
    this.flushQueue();
    const t = this.initialAstWithoutTokens || this.astWithTokens;
    return eW(t, vs, t.length, Fp(e));
  }
  getFirstBracketBefore(e) {
    this.flushQueue();
    const t = this.initialAstWithoutTokens || this.astWithTokens;
    return JB(t, vs, t.length, Fp(e));
  }
}
function JB(n, e, t, i) {
  if (n.kind === 4 || n.kind === 2) {
    const s = [];
    for (const o of n.children) t = gi(e, o.length), s.push({ nodeOffsetStart: e, nodeOffsetEnd: t }), e = t;
    for (let o = s.length - 1; o >= 0; o--) {
      const { nodeOffsetStart: r, nodeOffsetEnd: a } = s[o];
      if (lm(r, i)) {
        const l = JB(n.children[o], r, a, i);
        if (l) return l;
      }
    }
    return null;
  }
  if (n.kind === 3) return null;
  if (n.kind === 1) {
    const s = qu(e, t);
    return { bracketInfo: n.bracketInfo, range: s };
  }
  return null;
}
function eW(n, e, t, i) {
  if (n.kind === 4 || n.kind === 2) {
    for (const s of n.children) {
      if (lm(i, t = gi(e, s.length))) {
        const o = eW(s, e, t, i);
        if (o) return o;
      }
      e = t;
    }
    return null;
  }
  if (n.kind === 3) return null;
  if (n.kind === 1) {
    const s = qu(e, t);
    return { bracketInfo: n.bracketInfo, range: s };
  }
  return null;
}
function dI(n, e, t, i, s, o, r, a, l, d, h = !1) {
  if (r > 200) return !0;
  e: for (; ; ) switch (n.kind) {
    case 4: {
      const c = n.childrenLength;
      for (let u = 0; u < c; u++) {
        const g = n.getChild(u);
        if (g) {
          if (t = gi(e, g.length), dm(e, s) && S_(t, i)) {
            if (S_(t, s)) {
              n = g;
              continue e;
            }
            if (!dI(g, e, t, i, s, o, r, 0, l, d)) return !1;
          }
          e = t;
        }
      }
      return !0;
    }
    case 2: {
      const c = !d || !n.closingBracket || n.closingBracket.bracketInfo.closesColorized(n.openingBracket.bracketInfo);
      let u = 0;
      if (l) {
        let p = l.get(n.openingBracket.text);
        p === void 0 && (p = 0), u = p, c && (p++, l.set(n.openingBracket.text, p));
      }
      const g = n.childrenLength;
      for (let p = 0; p < g; p++) {
        const f = n.getChild(p);
        if (f) {
          if (t = gi(e, f.length), dm(e, s) && S_(t, i)) {
            if (S_(t, s) && f.kind !== 1) {
              n = f, c ? (r++, a = u + 1) : a = u;
              continue e;
            }
            if ((c || f.kind !== 1 || !n.closingBracket) && !dI(f, e, t, i, s, o, c ? r + 1 : r, c ? u + 1 : u, l, d, !n.closingBracket))
              return !1;
          }
          e = t;
        }
      }
      return l?.set(n.openingBracket.text, u), !0;
    }
    case 3: {
      const c = qu(e, t);
      return o(new g5(c, r - 1, 0, !0));
    }
    case 1: {
      const c = qu(e, t);
      return o(new g5(c, r - 1, a - 1, h));
    }
    case 0:
      return !0;
  }
}
class _X {
  constructor(e, t, i) {
    this.push = e, this.includeMinIndentation = t, this.textModel = i;
  }
}
function hI(n, e, t, i, s, o, r, a) {
  var l;
  if (r > 200) return !0;
  let d = !0;
  if (n.kind === 2) {
    let h = 0;
    if (a) {
      let g = a.get(n.openingBracket.text);
      g === void 0 && (g = 0), h = g, g++, a.set(n.openingBracket.text, g);
    }
    const c = gi(e, n.openingBracket.length);
    let u = -1;
    if (o.includeMinIndentation && (u = n.computeMinIndentation(e, o.textModel)), d = o.push(new oX(qu(e, t), qu(e, c), n.closingBracket ? qu(gi(c, ((l = n.child) === null || l === void 0 ? void 0 : l.length) || vs), t) : void 0, r, h, n, u)), e = c, d && n.child) {
      const g = n.child;
      if (t = gi(e, g.length), dm(e, s) && S_(t, i) && (d = hI(g, e, t, i, s, o, r + 1, a), !d)) return !1;
    }
    a?.set(n.openingBracket.text, h);
  } else {
    let h = e;
    for (const c of n.children) {
      const u = h;
      if (h = gi(h, c.length), dm(u, s) && dm(i, h) && (d = hI(c, u, h, i, s, o, r, a), !d)) return !1;
    }
  }
  return d;
}
class vX extends V {
  get canBuildAST() {
    return this.textModel.getValueLength() <= 5e6;
  }
  constructor(e, t) {
    super(), this.textModel = e, this.languageConfigurationService = t, this.bracketPairsTree = this._register(new rn()), this.onDidChangeEmitter = new F(), this.onDidChange = this.onDidChangeEmitter.event, this.bracketsRequested = !1, this._register(this.languageConfigurationService.onDidChange(((i) => {
      var s;
      i.languageId && !(!((s = this.bracketPairsTree.value) === null || s === void 0) && s.object.didLanguageChange(i.languageId)) || (this.bracketPairsTree.clear(), this.updateBracketPairsTree());
    })));
  }
  handleDidChangeOptions(e) {
    this.bracketPairsTree.clear(), this.updateBracketPairsTree();
  }
  handleDidChangeLanguage(e) {
    this.bracketPairsTree.clear(), this.updateBracketPairsTree();
  }
  handleDidChangeContent(e) {
    var t;
    (t = this.bracketPairsTree.value) === null || t === void 0 || t.object.handleContentChanged(e);
  }
  handleDidChangeBackgroundTokenizationState() {
    var e;
    (e = this.bracketPairsTree.value) === null || e === void 0 || e.object.handleDidChangeBackgroundTokenizationState();
  }
  handleDidChangeTokens(e) {
    var t;
    (t = this.bracketPairsTree.value) === null || t === void 0 || t.object.handleDidChangeTokens(e);
  }
  updateBracketPairsTree() {
    if (this.bracketsRequested && this.canBuildAST) {
      if (!this.bracketPairsTree.value) {
        const i = new G();
        this.bracketPairsTree.value = (e = i.add(new fX(this.textModel, ((s) => this.languageConfigurationService.getLanguageConfiguration(s)))), t = i, { object: e, dispose: () => t?.dispose() }), i.add(this.bracketPairsTree.value.object.onDidChange(((s) => this.onDidChangeEmitter.fire(s)))), this.onDidChangeEmitter.fire();
      }
    } else this.bracketPairsTree.value && (this.bracketPairsTree.clear(), this.onDidChangeEmitter.fire());
    var e, t;
  }
  getBracketPairsInRange(e) {
    var t;
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getBracketPairsInRange(e, !1)) || dl.empty;
  }
  getBracketPairsInRangeWithMinIndentation(e) {
    var t;
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getBracketPairsInRange(e, !0)) || dl.empty;
  }
  getBracketsInRange(e, t = !1) {
    var i;
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((i = this.bracketPairsTree.value) === null || i === void 0 ? void 0 : i.object.getBracketsInRange(e, t)) || dl.empty;
  }
  findMatchingBracketUp(e, t, i) {
    const s = this.textModel.validatePosition(t), o = this.textModel.getLanguageIdAtPosition(s.lineNumber, s.column);
    if (this.canBuildAST) {
      const r = this.languageConfigurationService.getLanguageConfiguration(o).bracketsNew.getClosingBracketInfo(e);
      if (!r) return null;
      const a = this.getBracketPairsInRange(D.fromPositions(t, t)).findLast(((l) => r.closes(l.openingBracketInfo)));
      return a ? a.openingBracketRange : null;
    }
    {
      const r = e.toLowerCase(), a = this.languageConfigurationService.getLanguageConfiguration(o).brackets;
      if (!a) return null;
      const l = a.textIsBracket[r];
      return l ? bb(this._findMatchingBracketUp(l, s, LD(i))) : null;
    }
  }
  matchBracket(e, t) {
    if (this.canBuildAST) {
      const i = this.getBracketPairsInRange(D.fromPositions(e, e)).filter(((s) => s.closingBracketRange !== void 0 && (s.openingBracketRange.containsPosition(e) || s.closingBracketRange.containsPosition(e)))).findLastMaxBy(jo(((s) => s.openingBracketRange.containsPosition(e) ? s.openingBracketRange : s.closingBracketRange), D.compareRangesUsingStarts));
      return i ? [i.openingBracketRange, i.closingBracketRange] : null;
    }
    {
      const i = LD(t);
      return this._matchBracket(this.textModel.validatePosition(e), i);
    }
  }
  _establishBracketSearchOffsets(e, t, i, s) {
    const o = t.getCount(), r = t.getLanguageId(s);
    let a = Math.max(0, e.column - 1 - i.maxBracketLength);
    for (let d = s - 1; d >= 0; d--) {
      const h = t.getEndOffset(d);
      if (h <= a) break;
      if (Ia(t.getStandardTokenType(d)) || t.getLanguageId(d) !== r) {
        a = h;
        break;
      }
    }
    let l = Math.min(t.getLineContent().length, e.column - 1 + i.maxBracketLength);
    for (let d = s + 1; d < o; d++) {
      const h = t.getStartOffset(d);
      if (h >= l) break;
      if (Ia(t.getStandardTokenType(d)) || t.getLanguageId(d) !== r) {
        l = h;
        break;
      }
    }
    return { searchStartOffset: a, searchEndOffset: l };
  }
  _matchBracket(e, t) {
    const i = e.lineNumber, s = this.textModel.tokenization.getLineTokens(i), o = this.textModel.getLineContent(i), r = s.findTokenIndexAtOffset(e.column - 1);
    if (r < 0) return null;
    const a = this.languageConfigurationService.getLanguageConfiguration(s.getLanguageId(r)).brackets;
    if (a && !Ia(s.getStandardTokenType(r))) {
      let { searchStartOffset: l, searchEndOffset: d } = this._establishBracketSearchOffsets(e, s, a, r), h = null;
      for (; ; ) {
        const c = hr.findNextBracketInRange(a.forwardRegex, i, o, l, d);
        if (!c) break;
        if (c.startColumn <= e.column && e.column <= c.endColumn) {
          const u = o.substring(c.startColumn - 1, c.endColumn - 1).toLowerCase(), g = this._matchFoundBracket(c, a.textIsBracket[u], a.textIsOpenBracket[u], t);
          if (g) {
            if (g instanceof Kl) return null;
            h = g;
          }
        }
        l = c.endColumn - 1;
      }
      if (h) return h;
    }
    if (r > 0 && s.getStartOffset(r) === e.column - 1) {
      const l = r - 1, d = this.languageConfigurationService.getLanguageConfiguration(s.getLanguageId(l)).brackets;
      if (d && !Ia(s.getStandardTokenType(l))) {
        const { searchStartOffset: h, searchEndOffset: c } = this._establishBracketSearchOffsets(e, s, d, l), u = hr.findPrevBracketInRange(d.reversedRegex, i, o, h, c);
        if (u && u.startColumn <= e.column && e.column <= u.endColumn) {
          const g = o.substring(u.startColumn - 1, u.endColumn - 1).toLowerCase(), p = this._matchFoundBracket(u, d.textIsBracket[g], d.textIsOpenBracket[g], t);
          if (p) return p instanceof Kl ? null : p;
        }
      }
    }
    return null;
  }
  _matchFoundBracket(e, t, i, s) {
    if (!t) return null;
    const o = i ? this._findMatchingBracketDown(t, e.getEndPosition(), s) : this._findMatchingBracketUp(t, e.getStartPosition(), s);
    return o ? o instanceof Kl ? o : [e, o] : null;
  }
  _findMatchingBracketUp(e, t, i) {
    const s = e.languageId, o = e.reversedRegex;
    let r = -1, a = 0;
    const l = (d, h, c, u) => {
      for (; ; ) {
        if (i && ++a % 100 == 0 && !i()) return Kl.INSTANCE;
        const g = hr.findPrevBracketInRange(o, d, h, c, u);
        if (!g) break;
        const p = h.substring(g.startColumn - 1, g.endColumn - 1).toLowerCase();
        if (e.isOpen(p) ? r++ : e.isClose(p) && r--, r === 0) return g;
        u = g.startColumn - 1;
      }
      return null;
    };
    for (let d = t.lineNumber; d >= 1; d--) {
      const h = this.textModel.tokenization.getLineTokens(d), c = h.getCount(), u = this.textModel.getLineContent(d);
      let g = c - 1, p = u.length, f = u.length;
      d === t.lineNumber && (g = h.findTokenIndexAtOffset(t.column - 1), p = t.column - 1, f = t.column - 1);
      let _ = !0;
      for (; g >= 0; g--) {
        const v = h.getLanguageId(g) === s && !Ia(h.getStandardTokenType(g));
        if (v) _ ? p = h.getStartOffset(g) : (p = h.getStartOffset(g), f = h.getEndOffset(g));
        else if (_ && p !== f) {
          const b = l(d, u, p, f);
          if (b) return b;
        }
        _ = v;
      }
      if (_ && p !== f) {
        const v = l(d, u, p, f);
        if (v) return v;
      }
    }
    return null;
  }
  _findMatchingBracketDown(e, t, i) {
    const s = e.languageId, o = e.forwardRegex;
    let r = 1, a = 0;
    const l = (h, c, u, g) => {
      for (; ; ) {
        if (i && ++a % 100 == 0 && !i()) return Kl.INSTANCE;
        const p = hr.findNextBracketInRange(o, h, c, u, g);
        if (!p) break;
        const f = c.substring(p.startColumn - 1, p.endColumn - 1).toLowerCase();
        if (e.isOpen(f) ? r++ : e.isClose(f) && r--, r === 0) return p;
        u = p.endColumn - 1;
      }
      return null;
    }, d = this.textModel.getLineCount();
    for (let h = t.lineNumber; h <= d; h++) {
      const c = this.textModel.tokenization.getLineTokens(h), u = c.getCount(), g = this.textModel.getLineContent(h);
      let p = 0, f = 0, _ = 0;
      h === t.lineNumber && (p = c.findTokenIndexAtOffset(t.column - 1), f = t.column - 1, _ = t.column - 1);
      let v = !0;
      for (; p < u; p++) {
        const b = c.getLanguageId(p) === s && !Ia(c.getStandardTokenType(p));
        if (b) v || (f = c.getStartOffset(p)), _ = c.getEndOffset(p);
        else if (v && f !== _) {
          const C = l(h, g, f, _);
          if (C) return C;
        }
        v = b;
      }
      if (v && f !== _) {
        const b = l(h, g, f, _);
        if (b) return b;
      }
    }
    return null;
  }
  findPrevBracket(e) {
    var t;
    const i = this.textModel.validatePosition(e);
    if (this.canBuildAST) return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getFirstBracketBefore(i)) || null;
    let s = null, o = null, r = null;
    for (let a = i.lineNumber; a >= 1; a--) {
      const l = this.textModel.tokenization.getLineTokens(a), d = l.getCount(), h = this.textModel.getLineContent(a);
      let c = d - 1, u = h.length, g = h.length;
      if (a === i.lineNumber) {
        c = l.findTokenIndexAtOffset(i.column - 1), u = i.column - 1, g = i.column - 1;
        const f = l.getLanguageId(c);
        s !== f && (s = f, o = this.languageConfigurationService.getLanguageConfiguration(s).brackets, r = this.languageConfigurationService.getLanguageConfiguration(s).bracketsNew);
      }
      let p = !0;
      for (; c >= 0; c--) {
        const f = l.getLanguageId(c);
        if (s !== f) {
          if (o && r && p && u !== g) {
            const v = hr.findPrevBracketInRange(o.reversedRegex, a, h, u, g);
            if (v) return this._toFoundBracket(r, v);
            p = !1;
          }
          s = f, o = this.languageConfigurationService.getLanguageConfiguration(s).brackets, r = this.languageConfigurationService.getLanguageConfiguration(s).bracketsNew;
        }
        const _ = !!o && !Ia(l.getStandardTokenType(c));
        if (_) p ? u = l.getStartOffset(c) : (u = l.getStartOffset(c), g = l.getEndOffset(c));
        else if (r && o && p && u !== g) {
          const v = hr.findPrevBracketInRange(o.reversedRegex, a, h, u, g);
          if (v) return this._toFoundBracket(r, v);
        }
        p = _;
      }
      if (r && o && p && u !== g) {
        const f = hr.findPrevBracketInRange(o.reversedRegex, a, h, u, g);
        if (f) return this._toFoundBracket(r, f);
      }
    }
    return null;
  }
  findNextBracket(e) {
    var t;
    const i = this.textModel.validatePosition(e);
    if (this.canBuildAST) return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getFirstBracketAfter(i)) || null;
    const s = this.textModel.getLineCount();
    let o = null, r = null, a = null;
    for (let l = i.lineNumber; l <= s; l++) {
      const d = this.textModel.tokenization.getLineTokens(l), h = d.getCount(), c = this.textModel.getLineContent(l);
      let u = 0, g = 0, p = 0;
      if (l === i.lineNumber) {
        u = d.findTokenIndexAtOffset(i.column - 1), g = i.column - 1, p = i.column - 1;
        const _ = d.getLanguageId(u);
        o !== _ && (o = _, r = this.languageConfigurationService.getLanguageConfiguration(o).brackets, a = this.languageConfigurationService.getLanguageConfiguration(o).bracketsNew);
      }
      let f = !0;
      for (; u < h; u++) {
        const _ = d.getLanguageId(u);
        if (o !== _) {
          if (a && r && f && g !== p) {
            const b = hr.findNextBracketInRange(r.forwardRegex, l, c, g, p);
            if (b) return this._toFoundBracket(a, b);
            f = !1;
          }
          o = _, r = this.languageConfigurationService.getLanguageConfiguration(o).brackets, a = this.languageConfigurationService.getLanguageConfiguration(o).bracketsNew;
        }
        const v = !!r && !Ia(d.getStandardTokenType(u));
        if (v) f || (g = d.getStartOffset(u)), p = d.getEndOffset(u);
        else if (a && r && f && g !== p) {
          const b = hr.findNextBracketInRange(r.forwardRegex, l, c, g, p);
          if (b) return this._toFoundBracket(a, b);
        }
        f = v;
      }
      if (a && r && f && g !== p) {
        const _ = hr.findNextBracketInRange(r.forwardRegex, l, c, g, p);
        if (_) return this._toFoundBracket(a, _);
      }
    }
    return null;
  }
  findEnclosingBrackets(e, t) {
    const i = this.textModel.validatePosition(e);
    if (this.canBuildAST) {
      const g = D.fromPositions(i), p = this.getBracketPairsInRange(D.fromPositions(i, i)).findLast(((f) => f.closingBracketRange !== void 0 && f.range.strictContainsRange(g)));
      return p ? [p.openingBracketRange, p.closingBracketRange] : null;
    }
    const s = LD(t), o = this.textModel.getLineCount(), r = /* @__PURE__ */ new Map();
    let a = [];
    const l = (g, p) => {
      if (!r.has(g)) {
        const f = [];
        for (let _ = 0, v = p ? p.brackets.length : 0; _ < v; _++) f[_] = 0;
        r.set(g, f);
      }
      a = r.get(g);
    };
    let d = 0;
    const h = (g, p, f, _, v) => {
      for (; ; ) {
        if (s && ++d % 100 == 0 && !s()) return Kl.INSTANCE;
        const b = hr.findNextBracketInRange(g.forwardRegex, p, f, _, v);
        if (!b) break;
        const C = f.substring(b.startColumn - 1, b.endColumn - 1).toLowerCase(), w = g.textIsBracket[C];
        if (w && (w.isOpen(C) ? a[w.index]++ : w.isClose(C) && a[w.index]--, a[w.index] === -1)) return this._matchFoundBracket(b, w, !1, s);
        _ = b.endColumn - 1;
      }
      return null;
    };
    let c = null, u = null;
    for (let g = i.lineNumber; g <= o; g++) {
      const p = this.textModel.tokenization.getLineTokens(g), f = p.getCount(), _ = this.textModel.getLineContent(g);
      let v = 0, b = 0, C = 0;
      if (g === i.lineNumber) {
        v = p.findTokenIndexAtOffset(i.column - 1), b = i.column - 1, C = i.column - 1;
        const y = p.getLanguageId(v);
        c !== y && (c = y, u = this.languageConfigurationService.getLanguageConfiguration(c).brackets, l(c, u));
      }
      let w = !0;
      for (; v < f; v++) {
        const y = p.getLanguageId(v);
        if (c !== y) {
          if (u && w && b !== C) {
            const k = h(u, g, _, b, C);
            if (k) return bb(k);
            w = !1;
          }
          c = y, u = this.languageConfigurationService.getLanguageConfiguration(c).brackets, l(c, u);
        }
        const L = !!u && !Ia(p.getStandardTokenType(v));
        if (L) w || (b = p.getStartOffset(v)), C = p.getEndOffset(v);
        else if (u && w && b !== C) {
          const k = h(u, g, _, b, C);
          if (k) return bb(k);
        }
        w = L;
      }
      if (u && w && b !== C) {
        const y = h(u, g, _, b, C);
        if (y) return bb(y);
      }
    }
    return null;
  }
  _toFoundBracket(e, t) {
    if (!t) return null;
    let i = this.textModel.getValueInRange(t);
    i = i.toLowerCase();
    const s = e.getBracketInfo(i);
    return s ? { range: t, bracketInfo: s } : null;
  }
}
function LD(n) {
  if (n === void 0) return () => !0;
  {
    const e = Date.now();
    return () => Date.now() - e <= n;
  }
}
class Kl {
  constructor() {
    this._searchCanceledBrand = void 0;
  }
}
function bb(n) {
  return n instanceof Kl ? null : n;
}
Kl.INSTANCE = new Kl();
class bX extends V {
  constructor(e) {
    super(), this.textModel = e, this.colorProvider = new tW(), this.onDidChangeEmitter = new F(), this.onDidChange = this.onDidChangeEmitter.event, this.colorizationOptions = e.getOptions().bracketPairColorizationOptions, this._register(e.bracketPairs.onDidChange(((t) => {
      this.onDidChangeEmitter.fire();
    })));
  }
  handleDidChangeOptions(e) {
    this.colorizationOptions = this.textModel.getOptions().bracketPairColorizationOptions;
  }
  getDecorationsInRange(e, t, i, s) {
    return s ? [] : t === void 0 ? [] : this.colorizationOptions.enabled ? this.textModel.bracketPairs.getBracketsInRange(e, !0).map(((o) => ({ id: `bracket${o.range.toString()}-${o.nestingLevel}`, options: { description: "BracketPairColorization", inlineClassName: this.colorProvider.getInlineClassName(o, this.colorizationOptions.independentColorPoolPerBracketType) }, ownerId: 0, range: o.range }))).toArray() : [];
  }
  getAllDecorations(e, t) {
    return e === void 0 ? [] : this.colorizationOptions.enabled ? this.getDecorationsInRange(new D(1, 1, this.textModel.getLineCount(), 1), e, t) : [];
  }
}
class tW {
  constructor() {
    this.unexpectedClosingBracketClassName = "unexpected-closing-bracket";
  }
  getInlineClassName(e, t) {
    return e.isInvalid ? this.unexpectedClosingBracketClassName : this.getInlineClassNameOfLevel(t ? e.nestingLevelOfEqualBracketType : e.nestingLevel);
  }
  getInlineClassNameOfLevel(e) {
    return "bracket-highlighting-" + e % 30;
  }
}
function Cb(n) {
  return n.replace(/\n/g, "\\n").replace(/\r/g, "\\r");
}
rr(((n, e) => {
  const t = [IB, MB, TB, RB, AB, PB], i = new tW();
  e.addRule(`.monaco-editor .${i.unexpectedClosingBracketClassName} { color: ${n.getColor(RZ)}; }`);
  const s = t.map(((o) => n.getColor(o))).filter(((o) => !!o)).filter(((o) => !o.isTransparent()));
  for (let o = 0; o < 30; o++) {
    const r = s[o % s.length];
    e.addRule(`.monaco-editor .${i.getInlineClassNameOfLevel(o)} { color: ${r}; }`);
  }
}));
class xn {
  get oldLength() {
    return this.oldText.length;
  }
  get oldEnd() {
    return this.oldPosition + this.oldText.length;
  }
  get newLength() {
    return this.newText.length;
  }
  get newEnd() {
    return this.newPosition + this.newText.length;
  }
  constructor(e, t, i, s) {
    this.oldPosition = e, this.oldText = t, this.newPosition = i, this.newText = s;
  }
  toString() {
    return this.oldText.length === 0 ? `(insert@${this.oldPosition} "${Cb(this.newText)}")` : this.newText.length === 0 ? `(delete@${this.oldPosition} "${Cb(this.oldText)}")` : `(replace@${this.oldPosition} "${Cb(this.oldText)}" with "${Cb(this.newText)}")`;
  }
  static _writeStringSize(e) {
    return 4 + 2 * e.length;
  }
  static _writeString(e, t, i) {
    const s = t.length;
    Hr(e, s, i), i += 4;
    for (let o = 0; o < s; o++) Gj(e, t.charCodeAt(o), i), i += 2;
    return i;
  }
  static _readString(e, t) {
    const i = Vr(e, t);
    return Zj(e, t += 4, i);
  }
  writeSize() {
    return 8 + xn._writeStringSize(this.oldText) + xn._writeStringSize(this.newText);
  }
  write(e, t) {
    return Hr(e, this.oldPosition, t), t += 4, Hr(e, this.newPosition, t), t += 4, t = xn._writeString(e, this.oldText, t), t = xn._writeString(e, this.newText, t);
  }
  static read(e, t, i) {
    const s = Vr(e, t), o = Vr(e, t += 4);
    t += 4;
    const r = xn._readString(e, t);
    t += xn._writeStringSize(r);
    const a = xn._readString(e, t);
    return t += xn._writeStringSize(a), i.push(new xn(s, r, o, a)), t;
  }
}
class Ra {
  constructor(e, t) {
    this._prevEdits = e, this._currEdits = t, this._result = [], this._resultLen = 0, this._prevLen = this._prevEdits.length, this._prevDeltaOffset = 0, this._currLen = this._currEdits.length, this._currDeltaOffset = 0;
  }
  compress() {
    let e = 0, t = 0, i = this._getPrev(e), s = this._getCurr(t);
    for (; e < this._prevLen || t < this._currLen; ) {
      if (i === null) {
        this._acceptCurr(s), s = this._getCurr(++t);
        continue;
      }
      if (s === null) {
        this._acceptPrev(i), i = this._getPrev(++e);
        continue;
      }
      if (s.oldEnd <= i.newPosition) {
        this._acceptCurr(s), s = this._getCurr(++t);
        continue;
      }
      if (i.newEnd <= s.oldPosition) {
        this._acceptPrev(i), i = this._getPrev(++e);
        continue;
      }
      if (s.oldPosition < i.newPosition) {
        const [l, d] = Ra._splitCurr(s, i.newPosition - s.oldPosition);
        this._acceptCurr(l), s = d;
        continue;
      }
      if (i.newPosition < s.oldPosition) {
        const [l, d] = Ra._splitPrev(i, s.oldPosition - i.newPosition);
        this._acceptPrev(l), i = d;
        continue;
      }
      let r, a;
      if (s.oldEnd === i.newEnd) r = i, a = s, i = this._getPrev(++e), s = this._getCurr(++t);
      else if (s.oldEnd < i.newEnd) {
        const [l, d] = Ra._splitPrev(i, s.oldLength);
        r = l, a = s, i = d, s = this._getCurr(++t);
      } else {
        const [l, d] = Ra._splitCurr(s, i.newLength);
        r = i, a = l, i = this._getPrev(++e), s = d;
      }
      this._result[this._resultLen++] = new xn(r.oldPosition, r.oldText, a.newPosition, a.newText), this._prevDeltaOffset += r.newLength - r.oldLength, this._currDeltaOffset += a.newLength - a.oldLength;
    }
    const o = Ra._merge(this._result);
    return Ra._removeNoOps(o);
  }
  _acceptCurr(e) {
    this._result[this._resultLen++] = Ra._rebaseCurr(this._prevDeltaOffset, e), this._currDeltaOffset += e.newLength - e.oldLength;
  }
  _getCurr(e) {
    return e < this._currLen ? this._currEdits[e] : null;
  }
  _acceptPrev(e) {
    this._result[this._resultLen++] = Ra._rebasePrev(this._currDeltaOffset, e), this._prevDeltaOffset += e.newLength - e.oldLength;
  }
  _getPrev(e) {
    return e < this._prevLen ? this._prevEdits[e] : null;
  }
  static _rebaseCurr(e, t) {
    return new xn(t.oldPosition - e, t.oldText, t.newPosition, t.newText);
  }
  static _rebasePrev(e, t) {
    return new xn(t.oldPosition, t.oldText, t.newPosition + e, t.newText);
  }
  static _splitPrev(e, t) {
    const i = e.newText.substr(0, t), s = e.newText.substr(t);
    return [new xn(e.oldPosition, e.oldText, e.newPosition, i), new xn(e.oldEnd, "", e.newPosition + t, s)];
  }
  static _splitCurr(e, t) {
    const i = e.oldText.substr(0, t), s = e.oldText.substr(t);
    return [new xn(e.oldPosition, i, e.newPosition, e.newText), new xn(e.oldPosition + t, s, e.newEnd, "")];
  }
  static _merge(e) {
    if (e.length === 0) return e;
    const t = [];
    let i = 0, s = e[0];
    for (let o = 1; o < e.length; o++) {
      const r = e[o];
      s.oldEnd === r.oldPosition ? s = new xn(s.oldPosition, s.oldText + r.oldText, s.newPosition, s.newText + r.newText) : (t[i++] = s, s = r);
    }
    return t[i++] = s, t;
  }
  static _removeNoOps(e) {
    if (e.length === 0) return e;
    const t = [];
    let i = 0;
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      o.oldText !== o.newText && (t[i++] = o);
    }
    return t;
  }
}
function Zd(n) {
  return n === 47 || n === 92;
}
function v5(n) {
  return n.replace(/[\\/]/g, Fi.sep);
}
function b5(n, e = Fi.sep) {
  if (!n) return "";
  const t = n.length, i = n.charCodeAt(0);
  if (Zd(i)) {
    if (Zd(n.charCodeAt(1)) && !Zd(n.charCodeAt(2))) {
      let o = 3;
      const r = o;
      for (; o < t && !Zd(n.charCodeAt(o)); o++) ;
      if (r !== o && !Zd(n.charCodeAt(o + 1))) {
        for (o += 1; o < t; o++) if (Zd(n.charCodeAt(o))) return n.slice(0, o + 1).replace(/[\\/]/g, e);
      }
    }
    return e;
  }
  if (iW(i) && n.charCodeAt(1) === 58) return Zd(n.charCodeAt(2)) ? n.slice(0, 2) + e : n.slice(0, 2);
  let s = n.indexOf("://");
  if (s !== -1) {
    for (s += 3; s < t; s++) if (Zd(n.charCodeAt(s))) return n.slice(0, s + 1);
  }
  return "";
}
function cI(n, e, t, i = sa) {
  if (n === e) return !0;
  if (!n || !e || e.length > n.length) return !1;
  if (t) {
    if (!sR(n, e)) return !1;
    if (e.length === n.length) return !0;
    let s = e.length;
    return e.charAt(e.length - 1) === i && s--, n.charAt(s) === i;
  }
  return e.charAt(e.length - 1) !== i && (e += i), n.indexOf(e) === 0;
}
function iW(n) {
  return n >= 65 && n <= 90 || n >= 97 && n <= 122;
}
function Ma(n) {
  return Tw(n, !0);
}
const Yt = new class {
  constructor(n) {
    this._ignorePathCasing = n;
  }
  compare(n, e, t = !1) {
    return n === e ? 0 : Y0(this.getComparisonKey(n, t), this.getComparisonKey(e, t));
  }
  isEqual(n, e, t = !1) {
    return n === e || !(!n || !e) && this.getComparisonKey(n, t) === this.getComparisonKey(e, t);
  }
  getComparisonKey(n, e = !1) {
    return n.with({ path: this._ignorePathCasing(n) ? n.path.toLowerCase() : void 0, fragment: e ? null : void 0 }).toString();
  }
  isEqualOrParent(n, e, t = !1) {
    if (n.scheme === e.scheme) {
      if (n.scheme === Ue.file) return cI(Ma(n), Ma(e), this._ignorePathCasing(n)) && n.query === e.query && (t || n.fragment === e.fragment);
      if (w5(n.authority, e.authority)) return cI(n.path, e.path, this._ignorePathCasing(n), "/") && n.query === e.query && (t || n.fragment === e.fragment);
    }
    return !1;
  }
  joinPath(n, ...e) {
    return Ie.joinPath(n, ...e);
  }
  basenameOrAuthority(n) {
    return ir(n) || n.authority;
  }
  basename(n) {
    return Fi.basename(n.path);
  }
  extname(n) {
    return Fi.extname(n.path);
  }
  dirname(n) {
    if (n.path.length === 0) return n;
    let e;
    return n.scheme === Ue.file ? e = Ie.file(U7(Ma(n))).path : (e = Fi.dirname(n.path), n.authority && e.length && e.charCodeAt(0) !== 47 && (console.error(`dirname("${n.toString})) resulted in a relative path`), e = "/")), n.with({ path: e });
  }
  normalizePath(n) {
    if (!n.path.length) return n;
    let e;
    return e = n.scheme === Ue.file ? Ie.file(z7(Ma(n))).path : Fi.normalize(n.path), n.with({ path: e });
  }
  relativePath(n, e) {
    if (n.scheme !== e.scheme || !w5(n.authority, e.authority)) return;
    if (n.scheme === Ue.file) {
      const s = gK(Ma(n), Ma(e));
      return Tn ? v5(s) : s;
    }
    let t = n.path || "/";
    const i = e.path || "/";
    if (this._ignorePathCasing(n)) {
      let s = 0;
      for (const o = Math.min(t.length, i.length); s < o && (t.charCodeAt(s) === i.charCodeAt(s) || t.charAt(s).toLowerCase() === i.charAt(s).toLowerCase()); s++) ;
      t = i.substr(0, s) + t.substr(s);
    }
    return Fi.relative(t, i);
  }
  resolvePath(n, e) {
    if (n.scheme === Ue.file) {
      const i = Ie.file(uK(Ma(n), e));
      return n.with({ authority: i.authority, path: i.path });
    }
    var t;
    return (t = e).indexOf("/") === -1 && (t = v5(t)), /^[a-zA-Z]:(\/|$)/.test(t) && (t = "/" + t), e = t, n.with({ path: Fi.resolve(n.path, e) });
  }
  isAbsolutePath(n) {
    return !!n.path && n.path[0] === "/";
  }
  isEqualAuthority(n, e) {
    return n === e || n !== void 0 && e !== void 0 && Lp(n, e);
  }
  hasTrailingPathSeparator(n, e = sa) {
    if (n.scheme === Ue.file) {
      const t = Ma(n);
      return t.length > b5(t).length && t[t.length - 1] === e;
    }
    {
      const t = n.path;
      return t.length > 1 && t.charCodeAt(t.length - 1) === 47 && !/^[a-zA-Z]:(\/$|\\$)/.test(n.fsPath);
    }
  }
  removeTrailingPathSeparator(n, e = sa) {
    return y5(n, e) ? n.with({ path: n.path.substr(0, n.path.length - 1) }) : n;
  }
  addTrailingPathSeparator(n, e = sa) {
    let t = !1;
    if (n.scheme === Ue.file) {
      const i = Ma(n);
      t = i !== void 0 && i.length === b5(i).length && i[i.length - 1] === e;
    } else {
      e = "/";
      const i = n.path;
      t = i.length === 1 && i.charCodeAt(i.length - 1) === 47;
    }
    return t || y5(n, e) ? n : n.with({ path: n.path + "/" });
  }
}((() => !1)), XR = Yt.isEqual.bind(Yt);
Yt.isEqualOrParent.bind(Yt), Yt.getComparisonKey.bind(Yt);
const CX = Yt.basenameOrAuthority.bind(Yt), ir = Yt.basename.bind(Yt), wX = Yt.extname.bind(Yt), uL = Yt.dirname.bind(Yt), yX = Yt.joinPath.bind(Yt), SX = Yt.normalizePath.bind(Yt), LX = Yt.relativePath.bind(Yt), C5 = Yt.resolvePath.bind(Yt);
Yt.isAbsolutePath.bind(Yt);
const w5 = Yt.isEqualAuthority.bind(Yt), y5 = Yt.hasTrailingPathSeparator.bind(Yt);
var Fh;
function Gg(n) {
  return n.toString();
}
Yt.removeTrailingPathSeparator.bind(Yt), Yt.addTrailingPathSeparator.bind(Yt), (function(n) {
  n.META_DATA_LABEL = "label", n.META_DATA_DESCRIPTION = "description", n.META_DATA_SIZE = "size", n.META_DATA_MIME = "mime", n.parseMetaData = function(e) {
    const t = /* @__PURE__ */ new Map();
    e.path.substring(e.path.indexOf(";") + 1, e.path.lastIndexOf(";")).split(";").forEach(((s) => {
      const [o, r] = s.split(":");
      o && r && t.set(o, r);
    }));
    const i = e.path.substring(0, e.path.indexOf(";"));
    return i && t.set(n.META_DATA_MIME, i), t;
  };
})(Fh || (Fh = {}));
class hn {
  static create(e, t) {
    const i = e.getAlternativeVersionId(), s = uI(e);
    return new hn(i, i, s, s, t, t, []);
  }
  constructor(e, t, i, s, o, r, a) {
    this.beforeVersionId = e, this.afterVersionId = t, this.beforeEOL = i, this.afterEOL = s, this.beforeCursorState = o, this.afterCursorState = r, this.changes = a;
  }
  append(e, t, i, s, o) {
    var r, a;
    t.length > 0 && (this.changes = (r = this.changes, a = t, r === null || r.length === 0 ? a : new Ra(r, a).compress())), this.afterEOL = i, this.afterVersionId = s, this.afterCursorState = o;
  }
  static _writeSelectionsSize(e) {
    return 4 + 16 * (e ? e.length : 0);
  }
  static _writeSelections(e, t, i) {
    if (Hr(e, t ? t.length : 0, i), i += 4, t) for (const s of t) Hr(e, s.selectionStartLineNumber, i), i += 4, Hr(e, s.selectionStartColumn, i), i += 4, Hr(e, s.positionLineNumber, i), i += 4, Hr(e, s.positionColumn, i), i += 4;
    return i;
  }
  static _readSelections(e, t, i) {
    const s = Vr(e, t);
    t += 4;
    for (let o = 0; o < s; o++) {
      const r = Vr(e, t), a = Vr(e, t += 4), l = Vr(e, t += 4), d = Vr(e, t += 4);
      t += 4, i.push(new _e(r, a, l, d));
    }
    return t;
  }
  serialize() {
    let e = 10 + hn._writeSelectionsSize(this.beforeCursorState) + hn._writeSelectionsSize(this.afterCursorState) + 4;
    for (const s of this.changes) e += s.writeSize();
    const t = new Uint8Array(e);
    let i = 0;
    Hr(t, this.beforeVersionId, i), i += 4, Hr(t, this.afterVersionId, i), i += 4, WO(t, this.beforeEOL, i), i += 1, WO(t, this.afterEOL, i), i += 1, i = hn._writeSelections(t, this.beforeCursorState, i), i = hn._writeSelections(t, this.afterCursorState, i), Hr(t, this.changes.length, i), i += 4;
    for (const s of this.changes) i = s.write(t, i);
    return t.buffer;
  }
  static deserialize(e) {
    const t = new Uint8Array(e);
    let i = 0;
    const s = Vr(t, i);
    i += 4;
    const o = Vr(t, i);
    i += 4;
    const r = BO(t, i);
    i += 1;
    const a = BO(t, i);
    i += 1;
    const l = [];
    i = hn._readSelections(t, i, l);
    const d = [];
    i = hn._readSelections(t, i, d);
    const h = Vr(t, i);
    i += 4;
    const c = [];
    for (let u = 0; u < h; u++) i = xn.read(t, i, c);
    return new hn(s, o, r, a, l, d, c);
  }
}
class nW {
  get type() {
    return 0;
  }
  get resource() {
    return Ie.isUri(this.model) ? this.model : this.model.uri;
  }
  constructor(e, t, i, s) {
    this.label = e, this.code = t, this.model = i, this._data = hn.create(i, s);
  }
  toString() {
    return (this._data instanceof hn ? this._data : hn.deserialize(this._data)).changes.map(((e) => e.toString())).join(", ");
  }
  matchesResource(e) {
    return (Ie.isUri(this.model) ? this.model : this.model.uri).toString() === e.toString();
  }
  setModel(e) {
    this.model = e;
  }
  canAppend(e) {
    return this.model === e && this._data instanceof hn;
  }
  append(e, t, i, s, o) {
    this._data instanceof hn && this._data.append(e, t, i, s, o);
  }
  close() {
    this._data instanceof hn && (this._data = this._data.serialize());
  }
  open() {
    this._data instanceof hn || (this._data = hn.deserialize(this._data));
  }
  undo() {
    if (Ie.isUri(this.model)) throw new Error("Invalid SingleModelEditStackElement");
    this._data instanceof hn && (this._data = this._data.serialize());
    const e = hn.deserialize(this._data);
    this.model._applyUndo(e.changes, e.beforeEOL, e.beforeVersionId, e.beforeCursorState);
  }
  redo() {
    if (Ie.isUri(this.model)) throw new Error("Invalid SingleModelEditStackElement");
    this._data instanceof hn && (this._data = this._data.serialize());
    const e = hn.deserialize(this._data);
    this.model._applyRedo(e.changes, e.afterEOL, e.afterVersionId, e.afterCursorState);
  }
  heapSize() {
    return this._data instanceof hn && (this._data = this._data.serialize()), this._data.byteLength + 168;
  }
}
class kX {
  get resources() {
    return this._editStackElementsArr.map(((e) => e.resource));
  }
  constructor(e, t, i) {
    this.label = e, this.code = t, this.type = 1, this._isOpen = !0, this._editStackElementsArr = i.slice(0), this._editStackElementsMap = /* @__PURE__ */ new Map();
    for (const s of this._editStackElementsArr) {
      const o = Gg(s.resource);
      this._editStackElementsMap.set(o, s);
    }
    this._delegate = null;
  }
  prepareUndoRedo() {
    if (this._delegate) return this._delegate.prepareUndoRedo(this);
  }
  matchesResource(e) {
    const t = Gg(e);
    return this._editStackElementsMap.has(t);
  }
  setModel(e) {
    const t = Gg(Ie.isUri(e) ? e : e.uri);
    this._editStackElementsMap.has(t) && this._editStackElementsMap.get(t).setModel(e);
  }
  canAppend(e) {
    if (!this._isOpen) return !1;
    const t = Gg(e.uri);
    return this._editStackElementsMap.has(t) ? this._editStackElementsMap.get(t).canAppend(e) : !1;
  }
  append(e, t, i, s, o) {
    const r = Gg(e.uri);
    this._editStackElementsMap.get(r).append(e, t, i, s, o);
  }
  close() {
    this._isOpen = !1;
  }
  open() {
  }
  undo() {
    this._isOpen = !1;
    for (const e of this._editStackElementsArr) e.undo();
  }
  redo() {
    for (const e of this._editStackElementsArr) e.redo();
  }
  heapSize(e) {
    const t = Gg(e);
    return this._editStackElementsMap.has(t) ? this._editStackElementsMap.get(t).heapSize() : 0;
  }
  split() {
    return this._editStackElementsArr;
  }
  toString() {
    const e = [];
    for (const t of this._editStackElementsArr) e.push(`${ir(t.resource)}: ${t}`);
    return `{${e.join(", ")}}`;
  }
}
function uI(n) {
  return n.getEOL() === `
` ? 0 : 1;
}
function jl(n) {
  return !!n && (n instanceof nW || n instanceof kX);
}
class QR {
  constructor(e, t) {
    this._model = e, this._undoRedoService = t;
  }
  pushStackElement() {
    const e = this._undoRedoService.getLastElement(this._model.uri);
    jl(e) && e.close();
  }
  popStackElement() {
    const e = this._undoRedoService.getLastElement(this._model.uri);
    jl(e) && e.open();
  }
  clear() {
    this._undoRedoService.removeElements(this._model.uri);
  }
  _getOrCreateEditStackElement(e, t) {
    const i = this._undoRedoService.getLastElement(this._model.uri);
    if (jl(i) && i.canAppend(this._model)) return i;
    const s = new nW(m(0, "Typing"), "undoredo.textBufferEdit", this._model, e);
    return this._undoRedoService.pushElement(s, t), s;
  }
  pushEOL(e) {
    const t = this._getOrCreateEditStackElement(null, void 0);
    this._model.setEOL(e), t.append(this._model, [], uI(this._model), this._model.getAlternativeVersionId(), null);
  }
  pushEditOperation(e, t, i, s) {
    const o = this._getOrCreateEditStackElement(e, s), r = this._model.applyEdits(t, !0), a = QR._computeCursorState(i, r), l = r.map(((d, h) => ({ index: h, textChange: d.textChange })));
    return l.sort(((d, h) => d.textChange.oldPosition === h.textChange.oldPosition ? d.index - h.index : d.textChange.oldPosition - h.textChange.oldPosition)), o.append(this._model, l.map(((d) => d.textChange)), uI(this._model), this._model.getAlternativeVersionId(), a), a;
  }
  static _computeCursorState(e, t) {
    try {
      return e ? e(t) : null;
    } catch (i) {
      return We(i), null;
    }
  }
}
class DX {
  constructor() {
    this.spacesDiff = 0, this.looksLikeAlignment = !1;
  }
}
function xX(n, e, t, i, s) {
  let o;
  for (s.spacesDiff = 0, s.looksLikeAlignment = !1, o = 0; o < e && o < i && n.charCodeAt(o) === t.charCodeAt(o); o++)
    ;
  let r = 0, a = 0;
  for (let u = o; u < e; u++)
    n.charCodeAt(u) === 32 ? r++ : a++;
  let l = 0, d = 0;
  for (let u = o; u < i; u++)
    t.charCodeAt(u) === 32 ? l++ : d++;
  if (r > 0 && a > 0 || l > 0 && d > 0) return;
  const h = Math.abs(a - d), c = Math.abs(r - l);
  if (h === 0) return s.spacesDiff = c, void (c > 0 && 0 <= l - 1 && l - 1 < n.length && l < t.length && t.charCodeAt(l) !== 32 && n.charCodeAt(l - 1) === 32 && n.charCodeAt(n.length - 1) === 44 && (s.looksLikeAlignment = !0));
  c % h != 0 || (s.spacesDiff = c / h);
}
function S5(n, e, t) {
  const i = Math.min(n.getLineCount(), 1e4);
  let s = 0, o = 0, r = "", a = 0;
  const l = [2, 4, 6, 8, 3, 5, 7], d = [0, 0, 0, 0, 0, 0, 0, 0, 0], h = new DX();
  for (let g = 1; g <= i; g++) {
    const p = n.getLineLength(g), f = n.getLineContent(g), _ = p <= 65536;
    let v = !1, b = 0, C = 0, w = 0;
    for (let L = 0, k = p; L < k; L++) {
      const N = _ ? f.charCodeAt(L) : n.getLineCharCode(g, L);
      if (N === 9) w++;
      else {
        if (N !== 32) {
          v = !0, b = L;
          break;
        }
        C++;
      }
    }
    if (!v || (w > 0 ? s++ : C > 1 && o++, xX(r, a, f, b, h), h.looksLikeAlignment && (!t || e !== h.spacesDiff))) continue;
    const y = h.spacesDiff;
    y <= 8 && d[y]++, r = f, a = b;
  }
  let c = t;
  s !== o && (c = s < o);
  let u = e;
  if (c) {
    let g = c ? 0 : 0.1 * i;
    l.forEach(((p) => {
      const f = d[p];
      f > g && (g = f, u = p);
    })), u === 4 && d[4] > 0 && d[2] > 0 && d[2] >= d[4] / 2 && (u = 2);
  }
  return { insertSpaces: c, tabSize: u };
}
function ks(n) {
  return (1 & n.metadata) >>> 0;
}
function $t(n, e) {
  n.metadata = 254 & n.metadata | e;
}
function Ln(n) {
  return (2 & n.metadata) >>> 1 == 1;
}
function Ut(n, e) {
  n.metadata = 253 & n.metadata | (e ? 1 : 0) << 1;
}
function L5(n) {
  return (4 & n.metadata) >>> 2 == 1;
}
function k5(n, e) {
  n.metadata = 251 & n.metadata | (e ? 1 : 0) << 2;
}
function D5(n) {
  return (64 & n.metadata) >>> 6 == 1;
}
function x5(n, e) {
  n.metadata = 191 & n.metadata | (e ? 1 : 0) << 6;
}
function N5(n, e) {
  n.metadata = 231 & n.metadata | e << 3;
}
function E5(n, e) {
  n.metadata = 223 & n.metadata | (e ? 1 : 0) << 5;
}
class sW {
  constructor(e, t, i) {
    this.metadata = 0, this.parent = this, this.left = this, this.right = this, $t(this, 1), this.start = t, this.end = i, this.delta = 0, this.maxEnd = i, this.id = e, this.ownerId = 0, this.options = null, k5(this, !1), x5(this, !1), N5(this, 1), E5(this, !1), this.cachedVersionId = 0, this.cachedAbsoluteStart = t, this.cachedAbsoluteEnd = i, this.range = null, Ut(this, !1);
  }
  reset(e, t, i, s) {
    this.start = t, this.end = i, this.maxEnd = i, this.cachedVersionId = e, this.cachedAbsoluteStart = t, this.cachedAbsoluteEnd = i, this.range = s;
  }
  setOptions(e) {
    this.options = e;
    const t = this.options.className;
    k5(this, t === "squiggly-error" || t === "squiggly-warning" || t === "squiggly-info"), x5(this, this.options.glyphMarginClassName !== null), N5(this, this.options.stickiness), E5(this, this.options.collapseOnReplaceEdit);
  }
  setCachedOffsets(e, t, i) {
    this.cachedVersionId !== i && (this.range = null), this.cachedVersionId = i, this.cachedAbsoluteStart = e, this.cachedAbsoluteEnd = t;
  }
  detach() {
    this.parent = null, this.left = null, this.right = null;
  }
}
const Qe = new sW(null, 0, 0);
Qe.parent = Qe, Qe.left = Qe, Qe.right = Qe, $t(Qe, 0);
class kD {
  constructor() {
    this.root = Qe, this.requestNormalizeDelta = !1;
  }
  intervalSearch(e, t, i, s, o, r) {
    return this.root === Qe ? [] : (function(a, l, d, h, c, u, g) {
      let p = a.root, f = 0, _ = 0, v = 0, b = 0;
      const C = [];
      let w = 0;
      for (; p !== Qe; ) if (Ln(p)) Ut(p.left, !1), Ut(p.right, !1), p === p.parent.right && (f -= p.parent.delta), p = p.parent;
      else {
        if (!Ln(p.left)) {
          if (_ = f + p.maxEnd, _ < l) {
            Ut(p, !0);
            continue;
          }
          if (p.left !== Qe) {
            p = p.left;
            continue;
          }
        }
        if (v = f + p.start, v > d) Ut(p, !0);
        else {
          if (b = f + p.end, b >= l) {
            p.setCachedOffsets(v, b, u);
            let y = !0;
            h && p.ownerId && p.ownerId !== h && (y = !1), c && L5(p) && (y = !1), g && !D5(p) && (y = !1), y && (C[w++] = p);
          }
          Ut(p, !0), p.right === Qe || Ln(p.right) || (f += p.delta, p = p.right);
        }
      }
      return Ut(a.root, !1), C;
    })(this, e, t, i, s, o, r);
  }
  search(e, t, i, s) {
    return this.root === Qe ? [] : (function(o, r, a, l, d) {
      let h = o.root, c = 0, u = 0, g = 0;
      const p = [];
      let f = 0;
      for (; h !== Qe; ) {
        if (Ln(h)) {
          Ut(h.left, !1), Ut(h.right, !1), h === h.parent.right && (c -= h.parent.delta), h = h.parent;
          continue;
        }
        if (h.left !== Qe && !Ln(h.left)) {
          h = h.left;
          continue;
        }
        u = c + h.start, g = c + h.end, h.setCachedOffsets(u, g, l);
        let _ = !0;
        r && h.ownerId && h.ownerId !== r && (_ = !1), a && L5(h) && (_ = !1), d && !D5(h) && (_ = !1), _ && (p[f++] = h), Ut(h, !0), h.right === Qe || Ln(h.right) || (c += h.delta, h = h.right);
      }
      return Ut(o.root, !1), p;
    })(this, e, t, i, s);
  }
  collectNodesFromOwner(e) {
    return (function(t, i) {
      let s = t.root;
      const o = [];
      let r = 0;
      for (; s !== Qe; ) Ln(s) ? (Ut(s.left, !1), Ut(s.right, !1), s = s.parent) : s.left === Qe || Ln(s.left) ? (s.ownerId === i && (o[r++] = s), Ut(s, !0), s.right === Qe || Ln(s.right) || (s = s.right)) : s = s.left;
      return Ut(t.root, !1), o;
    })(this, e);
  }
  collectNodesPostOrder() {
    return (function(e) {
      let t = e.root;
      const i = [];
      let s = 0;
      for (; t !== Qe; ) Ln(t) ? (Ut(t.left, !1), Ut(t.right, !1), t = t.parent) : t.left === Qe || Ln(t.left) ? t.right === Qe || Ln(t.right) ? (i[s++] = t, Ut(t, !0)) : t = t.right : t = t.left;
      return Ut(e.root, !1), i;
    })(this);
  }
  insert(e) {
    I5(this, e), this._normalizeDeltaIfNecessary();
  }
  delete(e) {
    M5(this, e), this._normalizeDeltaIfNecessary();
  }
  resolveNode(e, t) {
    const i = e;
    let s = 0;
    for (; e !== this.root; ) e === e.parent.right && (s += e.parent.delta), e = e.parent;
    const o = i.start + s, r = i.end + s;
    i.setCachedOffsets(o, r, t);
  }
  acceptReplace(e, t, i, s) {
    const o = (function(r, a, l) {
      let d = r.root, h = 0, c = 0, u = 0, g = 0;
      const p = [];
      let f = 0;
      for (; d !== Qe; ) if (Ln(d)) Ut(d.left, !1), Ut(d.right, !1), d === d.parent.right && (h -= d.parent.delta), d = d.parent;
      else {
        if (!Ln(d.left)) {
          if (c = h + d.maxEnd, c < a) {
            Ut(d, !0);
            continue;
          }
          if (d.left !== Qe) {
            d = d.left;
            continue;
          }
        }
        u = h + d.start, u > l ? Ut(d, !0) : (g = h + d.end, g >= a && (d.setCachedOffsets(u, g, 0), p[f++] = d), Ut(d, !0), d.right === Qe || Ln(d.right) || (h += d.delta, d = d.right));
      }
      return Ut(r.root, !1), p;
    })(this, e, e + t);
    for (let r = 0, a = o.length; r < a; r++)
      M5(this, o[r]);
    this._normalizeDeltaIfNecessary(), (function(r, a, l, d) {
      let h = r.root, c = 0, u = 0, g = 0;
      const p = d - (l - a);
      for (; h !== Qe; ) if (Ln(h)) Ut(h.left, !1), Ut(h.right, !1), h === h.parent.right && (c -= h.parent.delta), Dc(h), h = h.parent;
      else {
        if (!Ln(h.left)) {
          if (u = c + h.maxEnd, u < a) {
            Ut(h, !0);
            continue;
          }
          if (h.left !== Qe) {
            h = h.left;
            continue;
          }
        }
        g = c + h.start, g > l ? (h.start += p, h.end += p, h.delta += p, (h.delta < -1073741824 || h.delta > 1073741824) && (r.requestNormalizeDelta = !0), Ut(h, !0)) : (Ut(h, !0), h.right === Qe || Ln(h.right) || (c += h.delta, h = h.right));
      }
      Ut(r.root, !1);
    })(this, e, e + t, i), this._normalizeDeltaIfNecessary();
    for (let r = 0, a = o.length; r < a; r++) {
      const l = o[r];
      l.start = l.cachedAbsoluteStart, l.end = l.cachedAbsoluteEnd, NX(l, e, e + t, i, s), l.maxEnd = l.end, I5(this, l);
    }
    this._normalizeDeltaIfNecessary();
  }
  _normalizeDeltaIfNecessary() {
    this.requestNormalizeDelta && (this.requestNormalizeDelta = !1, (function(e) {
      let t = e.root, i = 0;
      for (; t !== Qe; ) t.left === Qe || Ln(t.left) ? t.right === Qe || Ln(t.right) ? (t.start = i + t.start, t.end = i + t.end, t.delta = 0, Dc(t), Ut(t, !0), Ut(t.left, !1), Ut(t.right, !1), t === t.parent.right && (i -= t.parent.delta), t = t.parent) : (i += t.delta, t = t.right) : t = t.left;
      Ut(e.root, !1);
    })(this));
  }
}
function Zg(n, e, t, i) {
  return n < t || !(n > t) && i !== 1 && (i === 2 || e);
}
function NX(n, e, t, i, s) {
  const o = (function(_) {
    return (24 & _.metadata) >>> 3;
  })(n), r = o === 0 || o === 2, a = o === 1 || o === 2, l = t - e, d = i, h = Math.min(l, d), c = n.start;
  let u = !1;
  const g = n.end;
  let p = !1;
  e <= c && g <= t && (function(_) {
    return (32 & _.metadata) >>> 5 == 1;
  })(n) && (n.start = e, u = !0, n.end = e, p = !0);
  {
    const _ = s ? 1 : l > 0 ? 2 : 0;
    !u && Zg(c, r, e, _) && (u = !0), !p && Zg(g, a, e, _) && (p = !0);
  }
  if (h > 0 && !s) {
    const _ = l > d ? 2 : 0;
    !u && Zg(c, r, e + h, _) && (u = !0), !p && Zg(g, a, e + h, _) && (p = !0);
  }
  {
    const _ = s ? 1 : 0;
    !u && Zg(c, r, t, _) && (n.start = e + d, u = !0), !p && Zg(g, a, t, _) && (n.end = e + d, p = !0);
  }
  const f = d - l;
  u || (n.start = Math.max(0, c + f)), p || (n.end = Math.max(0, g + f)), n.start > n.end && (n.end = n.start);
}
function I5(n, e) {
  if (n.root === Qe) return e.parent = Qe, e.left = Qe, e.right = Qe, $t(e, 0), n.root = e, n.root;
  (function(i, s) {
    let o = 0, r = i.root;
    const a = s.start, l = s.end;
    for (; ; )
      if (EX(a, l, r.start + o, r.end + o) < 0) {
        if (r.left === Qe) {
          s.start -= o, s.end -= o, s.maxEnd -= o, r.left = s;
          break;
        }
        r = r.left;
      } else {
        if (r.right === Qe) {
          s.start -= o + r.delta, s.end -= o + r.delta, s.maxEnd -= o + r.delta, r.right = s;
          break;
        }
        o += r.delta, r = r.right;
      }
    s.parent = r, s.left = Qe, s.right = Qe, $t(s, 1);
  })(n, e), rh(e.parent);
  let t = e;
  for (; t !== n.root && ks(t.parent) === 1; ) if (t.parent === t.parent.parent.left) {
    const i = t.parent.parent.right;
    ks(i) === 1 ? ($t(t.parent, 0), $t(i, 0), $t(t.parent.parent, 1), t = t.parent.parent) : (t === t.parent.right && (t = t.parent, r0(n, t)), $t(t.parent, 0), $t(t.parent.parent, 1), a0(n, t.parent.parent));
  } else {
    const i = t.parent.parent.left;
    ks(i) === 1 ? ($t(t.parent, 0), $t(i, 0), $t(t.parent.parent, 1), t = t.parent.parent) : (t === t.parent.left && (t = t.parent, a0(n, t)), $t(t.parent, 0), $t(t.parent.parent, 1), r0(n, t.parent.parent));
  }
  return $t(n.root, 0), e;
}
function M5(n, e) {
  let t, i;
  if (e.left === Qe ? (t = e.right, i = e, t.delta += e.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (n.requestNormalizeDelta = !0), t.start += e.delta, t.end += e.delta) : e.right === Qe ? (t = e.left, i = e) : (i = (function(r) {
    for (; r.left !== Qe; ) r = r.left;
    return r;
  })(e.right), t = i.right, t.start += i.delta, t.end += i.delta, t.delta += i.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (n.requestNormalizeDelta = !0), i.start += e.delta, i.end += e.delta, i.delta = e.delta, (i.delta < -1073741824 || i.delta > 1073741824) && (n.requestNormalizeDelta = !0)), i === n.root) return n.root = t, $t(t, 0), e.detach(), DD(), Dc(t), void (n.root.parent = Qe);
  const s = ks(i) === 1;
  if (i === i.parent.left ? i.parent.left = t : i.parent.right = t, i === e ? t.parent = i.parent : (i.parent === e ? t.parent = i : t.parent = i.parent, i.left = e.left, i.right = e.right, i.parent = e.parent, $t(i, ks(e)), e === n.root ? n.root = i : e === e.parent.left ? e.parent.left = i : e.parent.right = i, i.left !== Qe && (i.left.parent = i), i.right !== Qe && (i.right.parent = i)), e.detach(), s) return rh(t.parent), i !== e && (rh(i), rh(i.parent)), void DD();
  let o;
  for (rh(t), rh(t.parent), i !== e && (rh(i), rh(i.parent)); t !== n.root && ks(t) === 0; ) t === t.parent.left ? (o = t.parent.right, ks(o) === 1 && ($t(o, 0), $t(t.parent, 1), r0(n, t.parent), o = t.parent.right), ks(o.left) === 0 && ks(o.right) === 0 ? ($t(o, 1), t = t.parent) : (ks(o.right) === 0 && ($t(o.left, 0), $t(o, 1), a0(n, o), o = t.parent.right), $t(o, ks(t.parent)), $t(t.parent, 0), $t(o.right, 0), r0(n, t.parent), t = n.root)) : (o = t.parent.left, ks(o) === 1 && ($t(o, 0), $t(t.parent, 1), a0(n, t.parent), o = t.parent.left), ks(o.left) === 0 && ks(o.right) === 0 ? ($t(o, 1), t = t.parent) : (ks(o.left) === 0 && ($t(o.right, 0), $t(o, 1), r0(n, o), o = t.parent.left), $t(o, ks(t.parent)), $t(t.parent, 0), $t(o.left, 0), a0(n, t.parent), t = n.root));
  $t(t, 0), DD();
}
function DD() {
  Qe.parent = Qe, Qe.delta = 0, Qe.start = 0, Qe.end = 0;
}
function r0(n, e) {
  const t = e.right;
  t.delta += e.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (n.requestNormalizeDelta = !0), t.start += e.delta, t.end += e.delta, e.right = t.left, t.left !== Qe && (t.left.parent = e), t.parent = e.parent, e.parent === Qe ? n.root = t : e === e.parent.left ? e.parent.left = t : e.parent.right = t, t.left = e, e.parent = t, Dc(e), Dc(t);
}
function a0(n, e) {
  const t = e.left;
  e.delta -= t.delta, (e.delta < -1073741824 || e.delta > 1073741824) && (n.requestNormalizeDelta = !0), e.start -= t.delta, e.end -= t.delta, e.left = t.right, t.right !== Qe && (t.right.parent = e), t.parent = e.parent, e.parent === Qe ? n.root = t : e === e.parent.right ? e.parent.right = t : e.parent.left = t, t.right = e, e.parent = t, Dc(e), Dc(t);
}
function oW(n) {
  let e = n.end;
  if (n.left !== Qe) {
    const t = n.left.maxEnd;
    t > e && (e = t);
  }
  if (n.right !== Qe) {
    const t = n.right.maxEnd + n.delta;
    t > e && (e = t);
  }
  return e;
}
function Dc(n) {
  n.maxEnd = oW(n);
}
function rh(n) {
  for (; n !== Qe; ) {
    const e = oW(n);
    if (n.maxEnd === e) return;
    n.maxEnd = e, n = n.parent;
  }
}
function EX(n, e, t, i) {
  return n === t ? e - i : n - t;
}
class gI {
  constructor(e, t) {
    this.piece = e, this.color = t, this.size_left = 0, this.lf_left = 0, this.parent = this, this.left = this, this.right = this;
  }
  next() {
    if (this.right !== ze) return JR(this.right);
    let e = this;
    for (; e.parent !== ze && e.parent.left !== e; ) e = e.parent;
    return e.parent === ze ? ze : e.parent;
  }
  prev() {
    if (this.left !== ze) return rW(this.left);
    let e = this;
    for (; e.parent !== ze && e.parent.right !== e; ) e = e.parent;
    return e.parent === ze ? ze : e.parent;
  }
  detach() {
    this.parent = null, this.left = null, this.right = null;
  }
}
const ze = new gI(null, 0);
function JR(n) {
  for (; n.left !== ze; ) n = n.left;
  return n;
}
function rW(n) {
  for (; n.right !== ze; ) n = n.right;
  return n;
}
function eA(n) {
  return n === ze ? 0 : n.size_left + n.piece.length + eA(n.right);
}
function tA(n) {
  return n === ze ? 0 : n.lf_left + n.piece.lineFeedCnt + tA(n.right);
}
function xD() {
  ze.parent = ze;
}
function l0(n, e) {
  const t = e.right;
  t.size_left += e.size_left + (e.piece ? e.piece.length : 0), t.lf_left += e.lf_left + (e.piece ? e.piece.lineFeedCnt : 0), e.right = t.left, t.left !== ze && (t.left.parent = e), t.parent = e.parent, e.parent === ze ? n.root = t : e.parent.left === e ? e.parent.left = t : e.parent.right = t, t.left = e, e.parent = t;
}
function d0(n, e) {
  const t = e.left;
  e.left = t.right, t.right !== ze && (t.right.parent = e), t.parent = e.parent, e.size_left -= t.size_left + (t.piece ? t.piece.length : 0), e.lf_left -= t.lf_left + (t.piece ? t.piece.lineFeedCnt : 0), e.parent === ze ? n.root = t : e === e.parent.right ? e.parent.right = t : e.parent.left = t, t.right = e, e.parent = t;
}
function wb(n, e) {
  let t, i;
  if (e.left === ze ? (i = e, t = i.right) : e.right === ze ? (i = e, t = i.left) : (i = JR(e.right), t = i.right), i === n.root) return n.root = t, t.color = 0, e.detach(), xD(), void (n.root.parent = ze);
  const s = i.color === 1;
  if (i === i.parent.left ? i.parent.left = t : i.parent.right = t, i === e ? (t.parent = i.parent, L_(n, t)) : (i.parent === e ? t.parent = i : t.parent = i.parent, L_(n, t), i.left = e.left, i.right = e.right, i.parent = e.parent, i.color = e.color, e === n.root ? n.root = i : e === e.parent.left ? e.parent.left = i : e.parent.right = i, i.left !== ze && (i.left.parent = i), i.right !== ze && (i.right.parent = i), i.size_left = e.size_left, i.lf_left = e.lf_left, L_(n, i)), e.detach(), t.parent.left === t) {
    const r = eA(t), a = tA(t);
    if (r !== t.parent.size_left || a !== t.parent.lf_left) {
      const l = r - t.parent.size_left, d = a - t.parent.lf_left;
      t.parent.size_left = r, t.parent.lf_left = a, Ol(n, t.parent, l, d);
    }
  }
  if (L_(n, t.parent), s) return void xD();
  let o;
  for (; t !== n.root && t.color === 0; ) t === t.parent.left ? (o = t.parent.right, o.color === 1 && (o.color = 0, t.parent.color = 1, l0(n, t.parent), o = t.parent.right), o.left.color === 0 && o.right.color === 0 ? (o.color = 1, t = t.parent) : (o.right.color === 0 && (o.left.color = 0, o.color = 1, d0(n, o), o = t.parent.right), o.color = t.parent.color, t.parent.color = 0, o.right.color = 0, l0(n, t.parent), t = n.root)) : (o = t.parent.left, o.color === 1 && (o.color = 0, t.parent.color = 1, d0(n, t.parent), o = t.parent.left), o.left.color === 0 && o.right.color === 0 ? (o.color = 1, t = t.parent) : (o.left.color === 0 && (o.right.color = 0, o.color = 1, l0(n, o), o = t.parent.left), o.color = t.parent.color, t.parent.color = 0, o.left.color = 0, d0(n, t.parent), t = n.root));
  t.color = 0, xD();
}
function T5(n, e) {
  for (L_(n, e); e !== n.root && e.parent.color === 1; ) if (e.parent === e.parent.parent.left) {
    const t = e.parent.parent.right;
    t.color === 1 ? (e.parent.color = 0, t.color = 0, e.parent.parent.color = 1, e = e.parent.parent) : (e === e.parent.right && l0(n, e = e.parent), e.parent.color = 0, e.parent.parent.color = 1, d0(n, e.parent.parent));
  } else {
    const t = e.parent.parent.left;
    t.color === 1 ? (e.parent.color = 0, t.color = 0, e.parent.parent.color = 1, e = e.parent.parent) : (e === e.parent.left && d0(n, e = e.parent), e.parent.color = 0, e.parent.parent.color = 1, l0(n, e.parent.parent));
  }
  n.root.color = 0;
}
function Ol(n, e, t, i) {
  for (; e !== n.root && e !== ze; ) e.parent.left === e && (e.parent.size_left += t, e.parent.lf_left += i), e = e.parent;
}
function L_(n, e) {
  let t = 0, i = 0;
  if (e !== n.root) {
    for (; e !== n.root && e === e.parent.right; ) e = e.parent;
    if (e !== n.root) for (t = eA((e = e.parent).left) - e.size_left, i = tA(e.left) - e.lf_left, e.size_left += t, e.lf_left += i; e !== n.root && (t !== 0 || i !== 0); ) e.parent.left === e && (e.parent.size_left += t, e.parent.lf_left += i), e = e.parent;
  }
}
ze.parent = ze, ze.left = ze, ze.right = ze, ze.color = 0;
const Yg = 65535;
function aW(n) {
  let e;
  return e = n[n.length - 1] < 65536 ? new Uint16Array(n.length) : new Uint32Array(n.length), e.set(n, 0), e;
}
class IX {
  constructor(e, t, i, s, o) {
    this.lineStarts = e, this.cr = t, this.lf = i, this.crlf = s, this.isBasicASCII = o;
  }
}
function Wl(n, e = !0) {
  const t = [0];
  let i = 1;
  for (let s = 0, o = n.length; s < o; s++) {
    const r = n.charCodeAt(s);
    r === 13 ? s + 1 < o && n.charCodeAt(s + 1) === 10 ? (t[i++] = s + 2, s++) : t[i++] = s + 1 : r === 10 && (t[i++] = s + 1);
  }
  return e ? aW(t) : t;
}
class zs {
  constructor(e, t, i, s, o) {
    this.bufferIndex = e, this.start = t, this.end = i, this.lineFeedCnt = s, this.length = o;
  }
}
class wu {
  constructor(e, t) {
    this.buffer = e, this.lineStarts = t;
  }
}
class MX {
  constructor(e, t) {
    this._pieces = [], this._tree = e, this._BOM = t, this._index = 0, e.root !== ze && e.iterate(e.root, ((i) => (i !== ze && this._pieces.push(i.piece), !0)));
  }
  read() {
    return this._pieces.length === 0 ? this._index === 0 ? (this._index++, this._BOM) : null : this._index > this._pieces.length - 1 ? null : this._index === 0 ? this._BOM + this._tree.getPieceContent(this._pieces[this._index++]) : this._tree.getPieceContent(this._pieces[this._index++]);
  }
}
class TX {
  constructor(e) {
    this._limit = e, this._cache = [];
  }
  get(e) {
    for (let t = this._cache.length - 1; t >= 0; t--) {
      const i = this._cache[t];
      if (i.nodeStartOffset <= e && i.nodeStartOffset + i.node.piece.length >= e) return i;
    }
    return null;
  }
  get2(e) {
    for (let t = this._cache.length - 1; t >= 0; t--) {
      const i = this._cache[t];
      if (i.nodeStartLineNumber && i.nodeStartLineNumber < e && i.nodeStartLineNumber + i.node.piece.lineFeedCnt >= e) return i;
    }
    return null;
  }
  set(e) {
    this._cache.length >= this._limit && this._cache.shift(), this._cache.push(e);
  }
  validate(e) {
    let t = !1;
    const i = this._cache;
    for (let s = 0; s < i.length; s++) {
      const o = i[s];
      (o.node.parent === null || o.nodeStartOffset >= e) && (i[s] = null, t = !0);
    }
    if (t) {
      const s = [];
      for (const o of i) o !== null && s.push(o);
      this._cache = s;
    }
  }
}
class RX {
  constructor(e, t, i) {
    this.create(e, t, i);
  }
  create(e, t, i) {
    this._buffers = [new wu("", [0])], this._lastChangeBufferPos = { line: 0, column: 0 }, this.root = ze, this._lineCnt = 1, this._length = 0, this._EOL = t, this._EOLLength = t.length, this._EOLNormalized = i;
    let s = null;
    for (let o = 0, r = e.length; o < r; o++) if (e[o].buffer.length > 0) {
      e[o].lineStarts || (e[o].lineStarts = Wl(e[o].buffer));
      const a = new zs(o + 1, { line: 0, column: 0 }, { line: e[o].lineStarts.length - 1, column: e[o].buffer.length - e[o].lineStarts[e[o].lineStarts.length - 1] }, e[o].lineStarts.length - 1, e[o].buffer.length);
      this._buffers.push(e[o]), s = this.rbInsertRight(s, a);
    }
    this._searchCache = new TX(1), this._lastVisitedLine = { lineNumber: 0, value: "" }, this.computeBufferMetadata();
  }
  normalizeEOL(e) {
    const t = Yg, i = t - Math.floor(21845), s = 2 * i;
    let o = "", r = 0;
    const a = [];
    if (this.iterate(this.root, ((l) => {
      const d = this.getNodeContent(l), h = d.length;
      if (r <= i || r + h < s) return o += d, r += h, !0;
      const c = o.replace(/\r\n|\r|\n/g, e);
      return a.push(new wu(c, Wl(c))), o = d, r = h, !0;
    })), r > 0) {
      const l = o.replace(/\r\n|\r|\n/g, e);
      a.push(new wu(l, Wl(l)));
    }
    this.create(a, e, !0);
  }
  getEOL() {
    return this._EOL;
  }
  setEOL(e) {
    this._EOL = e, this._EOLLength = this._EOL.length, this.normalizeEOL(e);
  }
  createSnapshot(e) {
    return new MX(this, e);
  }
  getOffsetAt(e, t) {
    let i = 0, s = this.root;
    for (; s !== ze; ) if (s.left !== ze && s.lf_left + 1 >= e) s = s.left;
    else {
      if (s.lf_left + s.piece.lineFeedCnt + 1 >= e)
        return i += s.size_left, i + (this.getAccumulatedValue(s, e - s.lf_left - 2) + t - 1);
      e -= s.lf_left + s.piece.lineFeedCnt, i += s.size_left + s.piece.length, s = s.right;
    }
    return i;
  }
  getPositionAt(e) {
    e = Math.floor(e), e = Math.max(0, e);
    let t = this.root, i = 0;
    const s = e;
    for (; t !== ze; ) if (t.size_left !== 0 && t.size_left >= e) t = t.left;
    else {
      if (t.size_left + t.piece.length >= e) {
        const o = this.getIndexOf(t, e - t.size_left);
        if (i += t.lf_left + o.index, o.index === 0) {
          const r = this.getOffsetAt(i + 1, 1);
          return new W(i + 1, s - r + 1);
        }
        return new W(i + 1, o.remainder + 1);
      }
      if (e -= t.size_left + t.piece.length, i += t.lf_left + t.piece.lineFeedCnt, t.right === ze) {
        const o = this.getOffsetAt(i + 1, 1);
        return new W(i + 1, s - e - o + 1);
      }
      t = t.right;
    }
    return new W(1, 1);
  }
  getValueInRange(e, t) {
    if (e.startLineNumber === e.endLineNumber && e.startColumn === e.endColumn) return "";
    const i = this.nodeAt2(e.startLineNumber, e.startColumn), s = this.nodeAt2(e.endLineNumber, e.endColumn), o = this.getValueInRange2(i, s);
    return t ? t === this._EOL && this._EOLNormalized && t === this.getEOL() && this._EOLNormalized ? o : o.replace(/\r\n|\r|\n/g, t) : o;
  }
  getValueInRange2(e, t) {
    if (e.node === t.node) {
      const a = e.node, l = this._buffers[a.piece.bufferIndex].buffer, d = this.offsetInBuffer(a.piece.bufferIndex, a.piece.start);
      return l.substring(d + e.remainder, d + t.remainder);
    }
    let i = e.node;
    const s = this._buffers[i.piece.bufferIndex].buffer, o = this.offsetInBuffer(i.piece.bufferIndex, i.piece.start);
    let r = s.substring(o + e.remainder, o + i.piece.length);
    for (i = i.next(); i !== ze; ) {
      const a = this._buffers[i.piece.bufferIndex].buffer, l = this.offsetInBuffer(i.piece.bufferIndex, i.piece.start);
      if (i === t.node) {
        r += a.substring(l, l + t.remainder);
        break;
      }
      r += a.substr(l, i.piece.length), i = i.next();
    }
    return r;
  }
  getLinesContent() {
    const e = [];
    let t = 0, i = "", s = !1;
    return this.iterate(this.root, ((o) => {
      if (o === ze) return !0;
      const r = o.piece;
      let a = r.length;
      if (a === 0) return !0;
      const l = this._buffers[r.bufferIndex].buffer, d = this._buffers[r.bufferIndex].lineStarts, h = r.start.line, c = r.end.line;
      let u = d[h] + r.start.column;
      if (s && (l.charCodeAt(u) === 10 && (u++, a--), e[t++] = i, i = "", s = !1, a === 0)) return !0;
      if (h === c) return this._EOLNormalized || l.charCodeAt(u + a - 1) !== 13 ? i += l.substr(u, a) : (s = !0, i += l.substr(u, a - 1)), !0;
      i += this._EOLNormalized ? l.substring(u, Math.max(u, d[h + 1] - this._EOLLength)) : l.substring(u, d[h + 1]).replace(/(\r\n|\r|\n)$/, ""), e[t++] = i;
      for (let g = h + 1; g < c; g++) i = this._EOLNormalized ? l.substring(d[g], d[g + 1] - this._EOLLength) : l.substring(d[g], d[g + 1]).replace(/(\r\n|\r|\n)$/, ""), e[t++] = i;
      return this._EOLNormalized || l.charCodeAt(d[c] + r.end.column - 1) !== 13 ? i = l.substr(d[c], r.end.column) : (s = !0, r.end.column === 0 ? t-- : i = l.substr(d[c], r.end.column - 1)), !0;
    })), s && (e[t++] = i, i = ""), e[t++] = i, e;
  }
  getLength() {
    return this._length;
  }
  getLineCount() {
    return this._lineCnt;
  }
  getLineContent(e) {
    return this._lastVisitedLine.lineNumber === e || (this._lastVisitedLine.lineNumber = e, e === this._lineCnt ? this._lastVisitedLine.value = this.getLineRawContent(e) : this._EOLNormalized ? this._lastVisitedLine.value = this.getLineRawContent(e, this._EOLLength) : this._lastVisitedLine.value = this.getLineRawContent(e).replace(/(\r\n|\r|\n)$/, "")), this._lastVisitedLine.value;
  }
  _getCharCode(e) {
    if (e.remainder === e.node.piece.length) {
      const t = e.node.next();
      if (!t) return 0;
      const i = this._buffers[t.piece.bufferIndex], s = this.offsetInBuffer(t.piece.bufferIndex, t.piece.start);
      return i.buffer.charCodeAt(s);
    }
    {
      const t = this._buffers[e.node.piece.bufferIndex], i = this.offsetInBuffer(e.node.piece.bufferIndex, e.node.piece.start) + e.remainder;
      return t.buffer.charCodeAt(i);
    }
  }
  getLineCharCode(e, t) {
    const i = this.nodeAt2(e, t + 1);
    return this._getCharCode(i);
  }
  getLineLength(e) {
    if (e === this.getLineCount()) {
      const t = this.getOffsetAt(e, 1);
      return this.getLength() - t;
    }
    return this.getOffsetAt(e + 1, 1) - this.getOffsetAt(e, 1) - this._EOLLength;
  }
  findMatchesInNode(e, t, i, s, o, r, a, l, d, h, c) {
    const u = this._buffers[e.piece.bufferIndex], g = this.offsetInBuffer(e.piece.bufferIndex, e.piece.start), p = this.offsetInBuffer(e.piece.bufferIndex, o), f = this.offsetInBuffer(e.piece.bufferIndex, r);
    let _;
    const v = { line: 0, column: 0 };
    let b, C;
    t._wordSeparators ? (b = u.buffer.substring(p, f), C = (w) => w + p, t.reset(0)) : (b = u.buffer, C = (w) => w, t.reset(p));
    do
      if (_ = t.next(b), _) {
        if (C(_.index) >= f) return h;
        this.positionInBuffer(e, C(_.index) - g, v);
        const w = this.getLineFeedCnt(e.piece.bufferIndex, o, v), y = v.line === o.line ? v.column - o.column + s : v.column + 1, L = y + _[0].length;
        if (c[h++] = pu(new D(i + w, y, i + w, L), _, l), C(_.index) + _[0].length >= f || h >= d) return h;
      }
    while (_);
    return h;
  }
  findMatchesLineByLine(e, t, i, s) {
    const o = [];
    let r = 0;
    const a = new xp(t.wordSeparators, t.regex);
    let l = this.nodeAt2(e.startLineNumber, e.startColumn);
    if (l === null) return [];
    const d = this.nodeAt2(e.endLineNumber, e.endColumn);
    if (d === null) return [];
    let h = this.positionInBuffer(l.node, l.remainder);
    const c = this.positionInBuffer(d.node, d.remainder);
    if (l.node === d.node) return this.findMatchesInNode(l.node, a, e.startLineNumber, e.startColumn, h, c, t, i, s, r, o), o;
    let u = e.startLineNumber, g = l.node;
    for (; g !== d.node; ) {
      const f = this.getLineFeedCnt(g.piece.bufferIndex, h, g.piece.end);
      if (f >= 1) {
        const v = this._buffers[g.piece.bufferIndex].lineStarts, b = this.offsetInBuffer(g.piece.bufferIndex, g.piece.start), C = v[h.line + f], w = u === e.startLineNumber ? e.startColumn : 1;
        if (r = this.findMatchesInNode(g, a, u, w, h, this.positionInBuffer(g, C - b), t, i, s, r, o), r >= s) return o;
        u += f;
      }
      const _ = u === e.startLineNumber ? e.startColumn - 1 : 0;
      if (u === e.endLineNumber) {
        const v = this.getLineContent(u).substring(_, e.endColumn - 1);
        return r = this._findMatchesInLine(t, a, v, e.endLineNumber, _, r, o, i, s), o;
      }
      if (r = this._findMatchesInLine(t, a, this.getLineContent(u).substr(_), u, _, r, o, i, s), r >= s) return o;
      u++, l = this.nodeAt2(u, 1), g = l.node, h = this.positionInBuffer(l.node, l.remainder);
    }
    if (u === e.endLineNumber) {
      const f = u === e.startLineNumber ? e.startColumn - 1 : 0, _ = this.getLineContent(u).substring(f, e.endColumn - 1);
      return r = this._findMatchesInLine(t, a, _, e.endLineNumber, f, r, o, i, s), o;
    }
    const p = u === e.startLineNumber ? e.startColumn : 1;
    return r = this.findMatchesInNode(d.node, a, u, p, h, c, t, i, s, r, o), o;
  }
  _findMatchesInLine(e, t, i, s, o, r, a, l, d) {
    const h = e.wordSeparators;
    if (!l && e.simpleSearch) {
      const u = e.simpleSearch, g = u.length, p = i.length;
      let f = -g;
      for (; (f = i.indexOf(u, f + g)) !== -1; ) if ((!h || yR(h, i, p, f, g)) && (a[r++] = new tv(new D(s, f + 1 + o, s, f + 1 + g + o), null), r >= d)) return r;
      return r;
    }
    let c;
    t.reset(0);
    do
      if (c = t.next(i), c && (a[r++] = pu(new D(s, c.index + 1 + o, s, c.index + 1 + c[0].length + o), c, l), r >= d)) return r;
    while (c);
    return r;
  }
  insert(e, t, i = !1) {
    if (this._EOLNormalized = this._EOLNormalized && i, this._lastVisitedLine.lineNumber = 0, this._lastVisitedLine.value = "", this.root !== ze) {
      const { node: s, remainder: o, nodeStartOffset: r } = this.nodeAt(e), a = s.piece, l = a.bufferIndex, d = this.positionInBuffer(s, o);
      if (s.piece.bufferIndex === 0 && a.end.line === this._lastChangeBufferPos.line && a.end.column === this._lastChangeBufferPos.column && r + a.length === e && t.length < Yg) return this.appendToNode(s, t), void this.computeBufferMetadata();
      if (r === e) this.insertContentToNodeLeft(t, s), this._searchCache.validate(e);
      else if (r + s.piece.length > e) {
        const h = [];
        let c = new zs(a.bufferIndex, d, a.end, this.getLineFeedCnt(a.bufferIndex, d, a.end), this.offsetInBuffer(l, a.end) - this.offsetInBuffer(l, d));
        if (this.shouldCheckCRLF() && this.endWithCR(t) && this.nodeCharCodeAt(s, o) === 10) {
          const p = { line: c.start.line + 1, column: 0 };
          c = new zs(c.bufferIndex, p, c.end, this.getLineFeedCnt(c.bufferIndex, p, c.end), c.length - 1), t += `
`;
        }
        if (this.shouldCheckCRLF() && this.startWithLF(t))
          if (this.nodeCharCodeAt(s, o - 1) === 13) {
            const p = this.positionInBuffer(s, o - 1);
            this.deleteNodeTail(s, p), t = "\r" + t, s.piece.length === 0 && h.push(s);
          } else this.deleteNodeTail(s, d);
        else this.deleteNodeTail(s, d);
        const u = this.createNewPieces(t);
        c.length > 0 && this.rbInsertRight(s, c);
        let g = s;
        for (let p = 0; p < u.length; p++) g = this.rbInsertRight(g, u[p]);
        this.deleteNodes(h);
      } else this.insertContentToNodeRight(t, s);
    } else {
      const s = this.createNewPieces(t);
      let o = this.rbInsertLeft(null, s[0]);
      for (let r = 1; r < s.length; r++) o = this.rbInsertRight(o, s[r]);
    }
    this.computeBufferMetadata();
  }
  delete(e, t) {
    if (this._lastVisitedLine.lineNumber = 0, this._lastVisitedLine.value = "", t <= 0 || this.root === ze) return;
    const i = this.nodeAt(e), s = this.nodeAt(e + t), o = i.node, r = s.node;
    if (o === r) {
      const c = this.positionInBuffer(o, i.remainder), u = this.positionInBuffer(o, s.remainder);
      if (i.nodeStartOffset === e) {
        if (t === o.piece.length) {
          const g = o.next();
          return wb(this, o), this.validateCRLFWithPrevNode(g), void this.computeBufferMetadata();
        }
        return this.deleteNodeHead(o, u), this._searchCache.validate(e), this.validateCRLFWithPrevNode(o), void this.computeBufferMetadata();
      }
      return i.nodeStartOffset + o.piece.length === e + t ? (this.deleteNodeTail(o, c), this.validateCRLFWithNextNode(o), void this.computeBufferMetadata()) : (this.shrinkNode(o, c, u), void this.computeBufferMetadata());
    }
    const a = [], l = this.positionInBuffer(o, i.remainder);
    this.deleteNodeTail(o, l), this._searchCache.validate(e), o.piece.length === 0 && a.push(o);
    const d = this.positionInBuffer(r, s.remainder);
    this.deleteNodeHead(r, d), r.piece.length === 0 && a.push(r);
    for (let c = o.next(); c !== ze && c !== r; c = c.next()) a.push(c);
    const h = o.piece.length === 0 ? o.prev() : o;
    this.deleteNodes(a), this.validateCRLFWithNextNode(h), this.computeBufferMetadata();
  }
  insertContentToNodeLeft(e, t) {
    const i = [];
    if (this.shouldCheckCRLF() && this.endWithCR(e) && this.startWithLF(t)) {
      const r = t.piece, a = { line: r.start.line + 1, column: 0 }, l = new zs(r.bufferIndex, a, r.end, this.getLineFeedCnt(r.bufferIndex, a, r.end), r.length - 1);
      t.piece = l, e += `
`, Ol(this, t, -1, -1), t.piece.length === 0 && i.push(t);
    }
    const s = this.createNewPieces(e);
    let o = this.rbInsertLeft(t, s[s.length - 1]);
    for (let r = s.length - 2; r >= 0; r--) o = this.rbInsertLeft(o, s[r]);
    this.validateCRLFWithPrevNode(o), this.deleteNodes(i);
  }
  insertContentToNodeRight(e, t) {
    this.adjustCarriageReturnFromNext(e, t) && (e += `
`);
    const i = this.createNewPieces(e), s = this.rbInsertRight(t, i[0]);
    let o = s;
    for (let r = 1; r < i.length; r++) o = this.rbInsertRight(o, i[r]);
    this.validateCRLFWithPrevNode(s);
  }
  positionInBuffer(e, t, i) {
    const s = e.piece, o = e.piece.bufferIndex, r = this._buffers[o].lineStarts, a = r[s.start.line] + s.start.column + t;
    let l = s.start.line, d = s.end.line, h = 0, c = 0, u = 0;
    for (; l <= d && (h = l + (d - l) / 2 | 0, u = r[h], h !== d); ) if (c = r[h + 1], a < u) d = h - 1;
    else {
      if (!(a >= c)) break;
      l = h + 1;
    }
    return i ? (i.line = h, i.column = a - u, null) : { line: h, column: a - u };
  }
  getLineFeedCnt(e, t, i) {
    if (i.column === 0) return i.line - t.line;
    const s = this._buffers[e].lineStarts;
    if (i.line === s.length - 1) return i.line - t.line;
    const o = s[i.line + 1], r = s[i.line] + i.column;
    if (o > r + 1) return i.line - t.line;
    const a = r - 1;
    return this._buffers[e].buffer.charCodeAt(a) === 13 ? i.line - t.line + 1 : i.line - t.line;
  }
  offsetInBuffer(e, t) {
    return this._buffers[e].lineStarts[t.line] + t.column;
  }
  deleteNodes(e) {
    for (let t = 0; t < e.length; t++) wb(this, e[t]);
  }
  createNewPieces(e) {
    if (e.length > Yg) {
      const d = [];
      for (; e.length > Yg; ) {
        const c = e.charCodeAt(65534);
        let u;
        c === 13 || c >= 55296 && c <= 56319 ? (u = e.substring(0, 65534), e = e.substring(65534)) : (u = e.substring(0, Yg), e = e.substring(Yg));
        const g = Wl(u);
        d.push(new zs(this._buffers.length, { line: 0, column: 0 }, { line: g.length - 1, column: u.length - g[g.length - 1] }, g.length - 1, u.length)), this._buffers.push(new wu(u, g));
      }
      const h = Wl(e);
      return d.push(new zs(this._buffers.length, { line: 0, column: 0 }, { line: h.length - 1, column: e.length - h[h.length - 1] }, h.length - 1, e.length)), this._buffers.push(new wu(e, h)), d;
    }
    let t = this._buffers[0].buffer.length;
    const i = Wl(e, !1);
    let s = this._lastChangeBufferPos;
    if (this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 1] === t && t !== 0 && this.startWithLF(e) && this.endWithCR(this._buffers[0].buffer)) {
      this._lastChangeBufferPos = { line: this._lastChangeBufferPos.line, column: this._lastChangeBufferPos.column + 1 }, s = this._lastChangeBufferPos;
      for (let d = 0; d < i.length; d++) i[d] += t + 1;
      this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(i.slice(1)), this._buffers[0].buffer += "_" + e, t += 1;
    } else {
      if (t !== 0) for (let d = 0; d < i.length; d++) i[d] += t;
      this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(i.slice(1)), this._buffers[0].buffer += e;
    }
    const o = this._buffers[0].buffer.length, r = this._buffers[0].lineStarts.length - 1, a = { line: r, column: o - this._buffers[0].lineStarts[r] }, l = new zs(0, s, a, this.getLineFeedCnt(0, s, a), o - t);
    return this._lastChangeBufferPos = a, [l];
  }
  getLineRawContent(e, t = 0) {
    let i = this.root, s = "";
    const o = this._searchCache.get2(e);
    if (o) {
      i = o.node;
      const r = this.getAccumulatedValue(i, e - o.nodeStartLineNumber - 1), a = this._buffers[i.piece.bufferIndex].buffer, l = this.offsetInBuffer(i.piece.bufferIndex, i.piece.start);
      if (o.nodeStartLineNumber + i.piece.lineFeedCnt !== e) {
        const d = this.getAccumulatedValue(i, e - o.nodeStartLineNumber);
        return a.substring(l + r, l + d - t);
      }
      s = a.substring(l + r, l + i.piece.length);
    } else {
      let r = 0;
      const a = e;
      for (; i !== ze; ) if (i.left !== ze && i.lf_left >= e - 1) i = i.left;
      else {
        if (i.lf_left + i.piece.lineFeedCnt > e - 1) {
          const l = this.getAccumulatedValue(i, e - i.lf_left - 2), d = this.getAccumulatedValue(i, e - i.lf_left - 1), h = this._buffers[i.piece.bufferIndex].buffer, c = this.offsetInBuffer(i.piece.bufferIndex, i.piece.start);
          return r += i.size_left, this._searchCache.set({ node: i, nodeStartOffset: r, nodeStartLineNumber: a - (e - 1 - i.lf_left) }), h.substring(c + l, c + d - t);
        }
        if (i.lf_left + i.piece.lineFeedCnt === e - 1) {
          const l = this.getAccumulatedValue(i, e - i.lf_left - 2), d = this._buffers[i.piece.bufferIndex].buffer, h = this.offsetInBuffer(i.piece.bufferIndex, i.piece.start);
          s = d.substring(h + l, h + i.piece.length);
          break;
        }
        e -= i.lf_left + i.piece.lineFeedCnt, r += i.size_left + i.piece.length, i = i.right;
      }
    }
    for (i = i.next(); i !== ze; ) {
      const r = this._buffers[i.piece.bufferIndex].buffer;
      if (i.piece.lineFeedCnt > 0) {
        const a = this.getAccumulatedValue(i, 0), l = this.offsetInBuffer(i.piece.bufferIndex, i.piece.start);
        return s += r.substring(l, l + a - t), s;
      }
      {
        const a = this.offsetInBuffer(i.piece.bufferIndex, i.piece.start);
        s += r.substr(a, i.piece.length);
      }
      i = i.next();
    }
    return s;
  }
  computeBufferMetadata() {
    let e = this.root, t = 1, i = 0;
    for (; e !== ze; ) t += e.lf_left + e.piece.lineFeedCnt, i += e.size_left + e.piece.length, e = e.right;
    this._lineCnt = t, this._length = i, this._searchCache.validate(this._length);
  }
  getIndexOf(e, t) {
    const i = e.piece, s = this.positionInBuffer(e, t), o = s.line - i.start.line;
    if (this.offsetInBuffer(i.bufferIndex, i.end) - this.offsetInBuffer(i.bufferIndex, i.start) === t) {
      const r = this.getLineFeedCnt(e.piece.bufferIndex, i.start, s);
      if (r !== o) return { index: r, remainder: 0 };
    }
    return { index: o, remainder: s.column };
  }
  getAccumulatedValue(e, t) {
    if (t < 0) return 0;
    const i = e.piece, s = this._buffers[i.bufferIndex].lineStarts, o = i.start.line + t + 1;
    return o > i.end.line ? s[i.end.line] + i.end.column - s[i.start.line] - i.start.column : s[o] - s[i.start.line] - i.start.column;
  }
  deleteNodeTail(e, t) {
    const i = e.piece, s = i.lineFeedCnt, o = this.offsetInBuffer(i.bufferIndex, i.end), r = t, a = this.offsetInBuffer(i.bufferIndex, r), l = this.getLineFeedCnt(i.bufferIndex, i.start, r), d = l - s, h = a - o, c = i.length + h;
    e.piece = new zs(i.bufferIndex, i.start, r, l, c), Ol(this, e, h, d);
  }
  deleteNodeHead(e, t) {
    const i = e.piece, s = i.lineFeedCnt, o = this.offsetInBuffer(i.bufferIndex, i.start), r = t, a = this.getLineFeedCnt(i.bufferIndex, r, i.end), l = a - s, d = o - this.offsetInBuffer(i.bufferIndex, r), h = i.length + d;
    e.piece = new zs(i.bufferIndex, r, i.end, a, h), Ol(this, e, d, l);
  }
  shrinkNode(e, t, i) {
    const s = e.piece, o = s.start, r = s.end, a = s.length, l = s.lineFeedCnt, d = t, h = this.getLineFeedCnt(s.bufferIndex, s.start, d), c = this.offsetInBuffer(s.bufferIndex, t) - this.offsetInBuffer(s.bufferIndex, o);
    e.piece = new zs(s.bufferIndex, s.start, d, h, c), Ol(this, e, c - a, h - l);
    const u = new zs(s.bufferIndex, i, r, this.getLineFeedCnt(s.bufferIndex, i, r), this.offsetInBuffer(s.bufferIndex, r) - this.offsetInBuffer(s.bufferIndex, i)), g = this.rbInsertRight(e, u);
    this.validateCRLFWithPrevNode(g);
  }
  appendToNode(e, t) {
    this.adjustCarriageReturnFromNext(t, e) && (t += `
`);
    const i = this.shouldCheckCRLF() && this.startWithLF(t) && this.endWithCR(e), s = this._buffers[0].buffer.length;
    this._buffers[0].buffer += t;
    const o = Wl(t, !1);
    for (let u = 0; u < o.length; u++) o[u] += s;
    if (i) {
      const u = this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 2];
      this._buffers[0].lineStarts.pop(), this._lastChangeBufferPos = { line: this._lastChangeBufferPos.line - 1, column: s - u };
    }
    this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(o.slice(1));
    const r = this._buffers[0].lineStarts.length - 1, a = { line: r, column: this._buffers[0].buffer.length - this._buffers[0].lineStarts[r] }, l = e.piece.length + t.length, d = e.piece.lineFeedCnt, h = this.getLineFeedCnt(0, e.piece.start, a), c = h - d;
    e.piece = new zs(e.piece.bufferIndex, e.piece.start, a, h, l), this._lastChangeBufferPos = a, Ol(this, e, t.length, c);
  }
  nodeAt(e) {
    let t = this.root;
    const i = this._searchCache.get(e);
    if (i) return { node: i.node, nodeStartOffset: i.nodeStartOffset, remainder: e - i.nodeStartOffset };
    let s = 0;
    for (; t !== ze; ) if (t.size_left > e) t = t.left;
    else {
      if (t.size_left + t.piece.length >= e) {
        s += t.size_left;
        const o = { node: t, remainder: e - t.size_left, nodeStartOffset: s };
        return this._searchCache.set(o), o;
      }
      e -= t.size_left + t.piece.length, s += t.size_left + t.piece.length, t = t.right;
    }
    return null;
  }
  nodeAt2(e, t) {
    let i = this.root, s = 0;
    for (; i !== ze; ) if (i.left !== ze && i.lf_left >= e - 1) i = i.left;
    else {
      if (i.lf_left + i.piece.lineFeedCnt > e - 1) {
        const o = this.getAccumulatedValue(i, e - i.lf_left - 2), r = this.getAccumulatedValue(i, e - i.lf_left - 1);
        return s += i.size_left, { node: i, remainder: Math.min(o + t - 1, r), nodeStartOffset: s };
      }
      if (i.lf_left + i.piece.lineFeedCnt === e - 1) {
        const o = this.getAccumulatedValue(i, e - i.lf_left - 2);
        if (o + t - 1 <= i.piece.length) return { node: i, remainder: o + t - 1, nodeStartOffset: s };
        t -= i.piece.length - o;
        break;
      }
      e -= i.lf_left + i.piece.lineFeedCnt, s += i.size_left + i.piece.length, i = i.right;
    }
    for (i = i.next(); i !== ze; ) {
      if (i.piece.lineFeedCnt > 0) {
        const o = this.getAccumulatedValue(i, 0), r = this.offsetOfNode(i);
        return { node: i, remainder: Math.min(t - 1, o), nodeStartOffset: r };
      }
      if (i.piece.length >= t - 1)
        return { node: i, remainder: t - 1, nodeStartOffset: this.offsetOfNode(i) };
      t -= i.piece.length, i = i.next();
    }
    return null;
  }
  nodeCharCodeAt(e, t) {
    if (e.piece.lineFeedCnt < 1) return -1;
    const i = this._buffers[e.piece.bufferIndex], s = this.offsetInBuffer(e.piece.bufferIndex, e.piece.start) + t;
    return i.buffer.charCodeAt(s);
  }
  offsetOfNode(e) {
    if (!e) return 0;
    let t = e.size_left;
    for (; e !== this.root; ) e.parent.right === e && (t += e.parent.size_left + e.parent.piece.length), e = e.parent;
    return t;
  }
  shouldCheckCRLF() {
    return !(this._EOLNormalized && this._EOL === `
`);
  }
  startWithLF(e) {
    if (typeof e == "string") return e.charCodeAt(0) === 10;
    if (e === ze || e.piece.lineFeedCnt === 0) return !1;
    const t = e.piece, i = this._buffers[t.bufferIndex].lineStarts, s = t.start.line, o = i[s] + t.start.column;
    return s === i.length - 1 ? !1 : !(i[s + 1] > o + 1) && this._buffers[t.bufferIndex].buffer.charCodeAt(o) === 10;
  }
  endWithCR(e) {
    return typeof e == "string" ? e.charCodeAt(e.length - 1) === 13 : e !== ze && e.piece.lineFeedCnt !== 0 && this.nodeCharCodeAt(e, e.piece.length - 1) === 13;
  }
  validateCRLFWithPrevNode(e) {
    if (this.shouldCheckCRLF() && this.startWithLF(e)) {
      const t = e.prev();
      this.endWithCR(t) && this.fixCRLF(t, e);
    }
  }
  validateCRLFWithNextNode(e) {
    if (this.shouldCheckCRLF() && this.endWithCR(e)) {
      const t = e.next();
      this.startWithLF(t) && this.fixCRLF(e, t);
    }
  }
  fixCRLF(e, t) {
    const i = [], s = this._buffers[e.piece.bufferIndex].lineStarts;
    let o;
    o = e.piece.end.column === 0 ? { line: e.piece.end.line - 1, column: s[e.piece.end.line] - s[e.piece.end.line - 1] - 1 } : { line: e.piece.end.line, column: e.piece.end.column - 1 };
    const r = e.piece.length - 1, a = e.piece.lineFeedCnt - 1;
    e.piece = new zs(e.piece.bufferIndex, e.piece.start, o, a, r), Ol(this, e, -1, -1), e.piece.length === 0 && i.push(e);
    const l = { line: t.piece.start.line + 1, column: 0 }, d = t.piece.length - 1, h = this.getLineFeedCnt(t.piece.bufferIndex, l, t.piece.end);
    t.piece = new zs(t.piece.bufferIndex, l, t.piece.end, h, d), Ol(this, t, -1, -1), t.piece.length === 0 && i.push(t);
    const c = this.createNewPieces(`\r
`);
    this.rbInsertRight(e, c[0]);
    for (let u = 0; u < i.length; u++) wb(this, i[u]);
  }
  adjustCarriageReturnFromNext(e, t) {
    if (this.shouldCheckCRLF() && this.endWithCR(e)) {
      const i = t.next();
      if (this.startWithLF(i)) {
        if (e += `
`, i.piece.length === 1) wb(this, i);
        else {
          const s = i.piece, o = { line: s.start.line + 1, column: 0 }, r = s.length - 1, a = this.getLineFeedCnt(s.bufferIndex, o, s.end);
          i.piece = new zs(s.bufferIndex, o, s.end, a, r), Ol(this, i, -1, -1);
        }
        return !0;
      }
    }
    return !1;
  }
  iterate(e, t) {
    if (e === ze) return t(ze);
    const i = this.iterate(e.left, t);
    return i && t(e) && this.iterate(e.right, t);
  }
  getNodeContent(e) {
    if (e === ze) return "";
    const t = this._buffers[e.piece.bufferIndex], i = e.piece, s = this.offsetInBuffer(i.bufferIndex, i.start), o = this.offsetInBuffer(i.bufferIndex, i.end);
    return t.buffer.substring(s, o);
  }
  getPieceContent(e) {
    const t = this._buffers[e.bufferIndex], i = this.offsetInBuffer(e.bufferIndex, e.start), s = this.offsetInBuffer(e.bufferIndex, e.end);
    return t.buffer.substring(i, s);
  }
  rbInsertRight(e, t) {
    const i = new gI(t, 1);
    if (i.left = ze, i.right = ze, i.parent = ze, i.size_left = 0, i.lf_left = 0, this.root === ze) this.root = i, i.color = 0;
    else if (e.right === ze) e.right = i, i.parent = e;
    else {
      const s = JR(e.right);
      s.left = i, i.parent = s;
    }
    return T5(this, i), i;
  }
  rbInsertLeft(e, t) {
    const i = new gI(t, 1);
    if (i.left = ze, i.right = ze, i.parent = ze, i.size_left = 0, i.lf_left = 0, this.root === ze) this.root = i, i.color = 0;
    else if (e.left === ze) e.left = i, i.parent = e;
    else {
      const s = rW(e.left);
      s.right = i, i.parent = s;
    }
    return T5(this, i), i;
  }
}
class hm extends V {
  constructor(e, t, i, s, o, r, a) {
    super(), this._onDidChangeContent = this._register(new F()), this._BOM = t, this._mightContainNonBasicASCII = !r, this._mightContainRTL = s, this._mightContainUnusualLineTerminators = o, this._pieceTree = new RX(e, i, a);
  }
  mightContainRTL() {
    return this._mightContainRTL;
  }
  mightContainUnusualLineTerminators() {
    return this._mightContainUnusualLineTerminators;
  }
  resetMightContainUnusualLineTerminators() {
    this._mightContainUnusualLineTerminators = !1;
  }
  mightContainNonBasicASCII() {
    return this._mightContainNonBasicASCII;
  }
  getBOM() {
    return this._BOM;
  }
  getEOL() {
    return this._pieceTree.getEOL();
  }
  createSnapshot(e) {
    return this._pieceTree.createSnapshot(e ? this._BOM : "");
  }
  getOffsetAt(e, t) {
    return this._pieceTree.getOffsetAt(e, t);
  }
  getPositionAt(e) {
    return this._pieceTree.getPositionAt(e);
  }
  getRangeAt(e, t) {
    const i = e + t, s = this.getPositionAt(e), o = this.getPositionAt(i);
    return new D(s.lineNumber, s.column, o.lineNumber, o.column);
  }
  getValueInRange(e, t = 0) {
    if (e.isEmpty()) return "";
    const i = this._getEndOfLine(t);
    return this._pieceTree.getValueInRange(e, i);
  }
  getValueLengthInRange(e, t = 0) {
    if (e.isEmpty()) return 0;
    if (e.startLineNumber === e.endLineNumber) return e.endColumn - e.startColumn;
    const i = this.getOffsetAt(e.startLineNumber, e.startColumn), s = this.getOffsetAt(e.endLineNumber, e.endColumn);
    let o = 0;
    const r = this._getEndOfLine(t), a = this.getEOL();
    return r.length !== a.length && (o = (r.length - a.length) * (e.endLineNumber - e.startLineNumber)), s - i + o;
  }
  getCharacterCountInRange(e, t = 0) {
    if (this._mightContainNonBasicASCII) {
      let i = 0;
      const s = e.startLineNumber, o = e.endLineNumber;
      for (let r = s; r <= o; r++) {
        const a = this.getLineContent(r), l = r === s ? e.startColumn - 1 : 0, d = r === o ? e.endColumn - 1 : a.length;
        for (let h = l; h < d; h++) en(a.charCodeAt(h)) ? (i += 1, h += 1) : i += 1;
      }
      return i += this._getEndOfLine(t).length * (o - s), i;
    }
    return this.getValueLengthInRange(e, t);
  }
  getLength() {
    return this._pieceTree.getLength();
  }
  getLineCount() {
    return this._pieceTree.getLineCount();
  }
  getLinesContent() {
    return this._pieceTree.getLinesContent();
  }
  getLineContent(e) {
    return this._pieceTree.getLineContent(e);
  }
  getLineCharCode(e, t) {
    return this._pieceTree.getLineCharCode(e, t);
  }
  getLineLength(e) {
    return this._pieceTree.getLineLength(e);
  }
  getLineFirstNonWhitespaceColumn(e) {
    const t = Jn(this.getLineContent(e));
    return t === -1 ? 0 : t + 1;
  }
  getLineLastNonWhitespaceColumn(e) {
    const t = oa(this.getLineContent(e));
    return t === -1 ? 0 : t + 2;
  }
  _getEndOfLine(e) {
    switch (e) {
      case 1:
        return `
`;
      case 2:
        return `\r
`;
      case 0:
        return this.getEOL();
      default:
        throw new Error("Unknown EOL preference");
    }
  }
  setEOL(e) {
    this._pieceTree.setEOL(e);
  }
  applyEdits(e, t, i) {
    let s = this._mightContainRTL, o = this._mightContainUnusualLineTerminators, r = this._mightContainNonBasicASCII, a = !0, l = [];
    for (let f = 0; f < e.length; f++) {
      const _ = e[f];
      a && _._isTracked && (a = !1);
      const v = _.range;
      if (_.text) {
        let L = !0;
        r || (L = !p1(_.text), r = L), !s && L && (s = Pm(_.text)), !o && L && (o = t8(_.text));
      }
      let b = "", C = 0, w = 0, y = 0;
      if (_.text) {
        let L;
        [C, w, y, L] = kc(_.text);
        const k = this.getEOL();
        b = L === 0 || L === (k === `\r
` ? 2 : 1) ? _.text : _.text.replace(/\r\n|\r|\n/g, k);
      }
      l[f] = { sortIndex: f, identifier: _.identifier || null, range: v, rangeOffset: this.getOffsetAt(v.startLineNumber, v.startColumn), rangeLength: this.getValueLengthInRange(v), text: b, eolCount: C, firstLineLength: w, lastLineLength: y, forceMoveMarkers: !!_.forceMoveMarkers, isAutoWhitespaceEdit: _.isAutoWhitespaceEdit || !1 };
    }
    l.sort(hm._sortOpsAscending);
    let d = !1;
    for (let f = 0, _ = l.length - 1; f < _; f++) {
      const v = l[f].range.getEndPosition(), b = l[f + 1].range.getStartPosition();
      if (b.isBeforeOrEqual(v)) {
        if (b.isBefore(v)) throw new Error("Overlapping ranges are not allowed!");
        d = !0;
      }
    }
    a && (l = this._reduceOperations(l));
    const h = i || t ? hm._getInverseEditRanges(l) : [], c = [];
    if (t) for (let f = 0; f < l.length; f++) {
      const _ = l[f], v = h[f];
      if (_.isAutoWhitespaceEdit && _.range.isEmpty()) for (let b = v.startLineNumber; b <= v.endLineNumber; b++) {
        let C = "";
        b === v.startLineNumber && (C = this.getLineContent(_.range.startLineNumber), Jn(C) !== -1) || c.push({ lineNumber: b, oldContent: C });
      }
    }
    let u = null;
    if (i) {
      let f = 0;
      u = [];
      for (let _ = 0; _ < l.length; _++) {
        const v = l[_], b = h[_], C = this.getValueInRange(v.range), w = v.rangeOffset + f;
        f += v.text.length - C.length, u[_] = { sortIndex: v.sortIndex, identifier: v.identifier, range: b, text: C, textChange: new xn(v.rangeOffset, C, w, v.text) };
      }
      d || u.sort(((_, v) => _.sortIndex - v.sortIndex));
    }
    this._mightContainRTL = s, this._mightContainUnusualLineTerminators = o, this._mightContainNonBasicASCII = r;
    const g = this._doApplyEdits(l);
    let p = null;
    if (t && c.length > 0) {
      c.sort(((f, _) => _.lineNumber - f.lineNumber)), p = [];
      for (let f = 0, _ = c.length; f < _; f++) {
        const v = c[f].lineNumber;
        if (f > 0 && c[f - 1].lineNumber === v) continue;
        const b = c[f].oldContent, C = this.getLineContent(v);
        C.length !== 0 && C !== b && Jn(C) === -1 && p.push(v);
      }
    }
    return this._onDidChangeContent.fire(), new Cq(u, g, p);
  }
  _reduceOperations(e) {
    return e.length < 1e3 ? e : [this._toSingleEditOperation(e)];
  }
  _toSingleEditOperation(e) {
    let t = !1;
    const i = e[0].range, s = e[e.length - 1].range, o = new D(i.startLineNumber, i.startColumn, s.endLineNumber, s.endColumn);
    let r = i.startLineNumber, a = i.startColumn;
    const l = [];
    for (let g = 0, p = e.length; g < p; g++) {
      const f = e[g], _ = f.range;
      t = t || f.forceMoveMarkers, l.push(this.getValueInRange(new D(r, a, _.startLineNumber, _.startColumn))), f.text.length > 0 && l.push(f.text), r = _.endLineNumber, a = _.endColumn;
    }
    const d = l.join(""), [h, c, u] = kc(d);
    return { sortIndex: 0, identifier: e[0].identifier, range: o, rangeOffset: this.getOffsetAt(o.startLineNumber, o.startColumn), rangeLength: this.getValueLengthInRange(o, 0), text: d, eolCount: h, firstLineLength: c, lastLineLength: u, forceMoveMarkers: t, isAutoWhitespaceEdit: !1 };
  }
  _doApplyEdits(e) {
    e.sort(hm._sortOpsDescending);
    const t = [];
    for (let i = 0; i < e.length; i++) {
      const s = e[i], o = s.range.startLineNumber, r = s.range.startColumn, a = s.range.endLineNumber, l = s.range.endColumn;
      if (o === a && r === l && s.text.length === 0) continue;
      s.text ? (this._pieceTree.delete(s.rangeOffset, s.rangeLength), this._pieceTree.insert(s.rangeOffset, s.text, !0)) : this._pieceTree.delete(s.rangeOffset, s.rangeLength);
      const d = new D(o, r, a, l);
      t.push({ range: d, rangeLength: s.rangeLength, text: s.text, rangeOffset: s.rangeOffset, forceMoveMarkers: s.forceMoveMarkers });
    }
    return t;
  }
  findMatchesLineByLine(e, t, i, s) {
    return this._pieceTree.findMatchesLineByLine(e, t, i, s);
  }
  static _getInverseEditRanges(e) {
    const t = [];
    let i = 0, s = 0, o = null;
    for (let r = 0, a = e.length; r < a; r++) {
      const l = e[r];
      let d, h, c;
      if (o ? o.range.endLineNumber === l.range.startLineNumber ? (d = i, h = s + (l.range.startColumn - o.range.endColumn)) : (d = i + (l.range.startLineNumber - o.range.endLineNumber), h = l.range.startColumn) : (d = l.range.startLineNumber, h = l.range.startColumn), l.text.length > 0) {
        const u = l.eolCount + 1;
        c = u === 1 ? new D(d, h, d, h + l.firstLineLength) : new D(d, h, d + u - 1, l.lastLineLength + 1);
      } else c = new D(d, h, d, h);
      i = c.endLineNumber, s = c.endColumn, t.push(c), o = l;
    }
    return t;
  }
  static _sortOpsAscending(e, t) {
    const i = D.compareRangesUsingEnds(e.range, t.range);
    return i === 0 ? e.sortIndex - t.sortIndex : i;
  }
  static _sortOpsDescending(e, t) {
    const i = D.compareRangesUsingEnds(e.range, t.range);
    return i === 0 ? t.sortIndex - e.sortIndex : -i;
  }
}
class AX {
  constructor(e, t, i, s, o, r, a, l, d) {
    this._chunks = e, this._bom = t, this._cr = i, this._lf = s, this._crlf = o, this._containsRTL = r, this._containsUnusualLineTerminators = a, this._isBasicASCII = l, this._normalizeEOL = d;
  }
  _getEOL(e) {
    const t = this._cr + this._lf + this._crlf, i = this._cr + this._crlf;
    return t === 0 ? e === 1 ? `
` : `\r
` : i > t / 2 ? `\r
` : `
`;
  }
  create(e) {
    const t = this._getEOL(e), i = this._chunks;
    if (this._normalizeEOL && (t === `\r
` && (this._cr > 0 || this._lf > 0) || t === `
` && (this._cr > 0 || this._crlf > 0))) for (let o = 0, r = i.length; o < r; o++) {
      const a = i[o].buffer.replace(/\r\n|\r|\n/g, t), l = Wl(a);
      i[o] = new wu(a, l);
    }
    const s = new hm(i, this._bom, t, this._containsRTL, this._containsUnusualLineTerminators, this._isBasicASCII, this._normalizeEOL);
    return { textBuffer: s, disposable: s };
  }
}
class R5 {
  constructor() {
    this.chunks = [], this.BOM = "", this._hasPreviousChar = !1, this._previousChar = 0, this._tmpLineStarts = [], this.cr = 0, this.lf = 0, this.crlf = 0, this.containsRTL = !1, this.containsUnusualLineTerminators = !1, this.isBasicASCII = !0;
  }
  acceptChunk(e) {
    if (e.length === 0) return;
    this.chunks.length === 0 && lR(e) && (this.BOM = DK, e = e.substr(1));
    const t = e.charCodeAt(e.length - 1);
    t === 13 || t >= 55296 && t <= 56319 ? (this._acceptChunk1(e.substr(0, e.length - 1), !1), this._hasPreviousChar = !0, this._previousChar = t) : (this._acceptChunk1(e, !1), this._hasPreviousChar = !1, this._previousChar = t);
  }
  _acceptChunk1(e, t) {
    (t || e.length !== 0) && (this._hasPreviousChar ? this._acceptChunk2(String.fromCharCode(this._previousChar) + e) : this._acceptChunk2(e));
  }
  _acceptChunk2(e) {
    const t = (function(i, s) {
      i.length = 0, i[0] = 0;
      let o = 1, r = 0, a = 0, l = 0, d = !0;
      for (let c = 0, u = s.length; c < u; c++) {
        const g = s.charCodeAt(c);
        g === 13 ? c + 1 < u && s.charCodeAt(c + 1) === 10 ? (l++, i[o++] = c + 2, c++) : (r++, i[o++] = c + 1) : g === 10 ? (a++, i[o++] = c + 1) : d && g !== 9 && (g < 32 || g > 126) && (d = !1);
      }
      const h = new IX(aW(i), r, a, l, d);
      return i.length = 0, h;
    })(this._tmpLineStarts, e);
    this.chunks.push(new wu(e, t.lineStarts)), this.cr += t.cr, this.lf += t.lf, this.crlf += t.crlf, t.isBasicASCII || (this.isBasicASCII = !1, this.containsRTL || (this.containsRTL = Pm(e)), this.containsUnusualLineTerminators || (this.containsUnusualLineTerminators = t8(e)));
  }
  finish(e = !0) {
    return this._finish(), new AX(this.chunks, this.BOM, this.cr, this.lf, this.crlf, this.containsRTL, this.containsUnusualLineTerminators, this.isBasicASCII, e);
  }
  _finish() {
    if (this.chunks.length === 0 && this._acceptChunk1("", !0), this._hasPreviousChar) {
      this._hasPreviousChar = !1;
      const e = this.chunks[this.chunks.length - 1];
      e.buffer += String.fromCharCode(this._previousChar);
      const t = Wl(e.buffer);
      e.lineStarts = t, this._previousChar === 13 && this.cr++;
    }
  }
}
class PX {
  constructor(e) {
    this._default = e, this._store = [];
  }
  get(e) {
    return e < this._store.length ? this._store[e] : this._default;
  }
  set(e, t) {
    for (; e >= this._store.length; ) this._store[this._store.length] = this._default;
    this._store[e] = t;
  }
  replace(e, t, i) {
    if (e >= this._store.length) return;
    if (t === 0) return void this.insert(e, i);
    if (i === 0) return void this.delete(e, t);
    const s = this._store.slice(0, e), o = this._store.slice(e + t), r = (function(a, l) {
      const d = [];
      for (let h = 0; h < a; h++) d[h] = l;
      return d;
    })(i, this._default);
    this._store = s.concat(r, o);
  }
  delete(e, t) {
    t === 0 || e >= this._store.length || this._store.splice(e, t);
  }
  insert(e, t) {
    if (t === 0 || e >= this._store.length) return;
    const i = [];
    for (let s = 0; s < t; s++) i[s] = this._default;
    this._store = TS(this._store, e, i);
  }
}
class OX {
  get startLineNumber() {
    return this._startLineNumber;
  }
  get endLineNumber() {
    return this._startLineNumber + this._tokens.length - 1;
  }
  constructor(e, t) {
    this._startLineNumber = e, this._tokens = t;
  }
  getLineTokens(e) {
    return this._tokens[e - this._startLineNumber];
  }
  appendLineTokens(e) {
    this._tokens.push(e);
  }
}
class pI {
  constructor() {
    this._tokens = [];
  }
  add(e, t) {
    if (this._tokens.length > 0) {
      const i = this._tokens[this._tokens.length - 1];
      if (i.endLineNumber + 1 === e) return void i.appendLineTokens(t);
    }
    this._tokens.push(new OX(e, [t]));
  }
  finalize() {
    return this._tokens;
  }
}
class FX {
  constructor(e, t) {
    this.tokenizationSupport = t, this.initialState = this.tokenizationSupport.getInitialState(), this.store = new mI(e);
  }
  getStartState(e) {
    return this.store.getStartState(e, this.initialState);
  }
  getFirstInvalidLine() {
    return this.store.getFirstInvalidLine(this.initialState);
  }
}
class BX extends FX {
  constructor(e, t, i, s) {
    super(e, t), this._textModel = i, this._languageIdCodec = s;
  }
  updateTokensUntilLine(e, t) {
    const i = this._textModel.getLanguageId();
    for (; ; ) {
      const s = this.getFirstInvalidLine();
      if (!s || s.lineNumber > t) break;
      const o = this._textModel.getLineContent(s.lineNumber), r = Wf(this._languageIdCodec, i, this.tokenizationSupport, o, !0, s.startState);
      e.add(s.lineNumber, r.tokens), this.store.setEndState(s.lineNumber, r.endState);
    }
  }
  getTokenTypeIfInsertingCharacter(e, t) {
    const i = this.getStartState(e.lineNumber);
    if (!i) return 0;
    const s = this._textModel.getLanguageId(), o = this._textModel.getLineContent(e.lineNumber), r = o.substring(0, e.column - 1) + t + o.substring(e.column - 1), a = Wf(this._languageIdCodec, s, this.tokenizationSupport, r, !0, i), l = new nn(a.tokens, r, this._languageIdCodec);
    if (l.getCount() === 0) return 0;
    const d = l.findTokenIndexAtOffset(e.column - 1);
    return l.getStandardTokenType(d);
  }
  tokenizeLineWithEdit(e, t, i) {
    const s = e.lineNumber, o = e.column, r = this.getStartState(s);
    if (!r) return null;
    const a = this._textModel.getLineContent(s), l = a.substring(0, o - 1) + i + a.substring(o - 1 + t), d = this._textModel.getLanguageIdAtPosition(s, 0), h = Wf(this._languageIdCodec, d, this.tokenizationSupport, l, !0, r);
    return new nn(h.tokens, l, this._languageIdCodec);
  }
  hasAccurateTokensForLine(e) {
    return e < this.store.getFirstInvalidEndStateLineNumberOrMax();
  }
  isCheapToTokenize(e) {
    const t = this.store.getFirstInvalidEndStateLineNumberOrMax();
    return e < t || e === t && this._textModel.getLineLength(e) < 2048;
  }
  tokenizeHeuristically(e, t, i) {
    if (i <= this.store.getFirstInvalidEndStateLineNumberOrMax()) return { heuristicTokens: !1 };
    if (t <= this.store.getFirstInvalidEndStateLineNumberOrMax()) return this.updateTokensUntilLine(e, i), { heuristicTokens: !1 };
    let s = this.guessStartState(t);
    const o = this._textModel.getLanguageId();
    for (let r = t; r <= i; r++) {
      const a = this._textModel.getLineContent(r), l = Wf(this._languageIdCodec, o, this.tokenizationSupport, a, !0, s);
      e.add(r, l.tokens), s = l.endState;
    }
    return { heuristicTokens: !0 };
  }
  guessStartState(e) {
    let t = this._textModel.getLineFirstNonWhitespaceColumn(e);
    const i = [];
    let s = null;
    for (let a = e - 1; t > 1 && a >= 1; a--) {
      const l = this._textModel.getLineFirstNonWhitespaceColumn(a);
      if (l !== 0 && l < t && (i.push(this._textModel.getLineContent(a)), t = l, s = this.getStartState(a), s)) break;
    }
    s || (s = this.tokenizationSupport.getInitialState()), i.reverse();
    const o = this._textModel.getLanguageId();
    let r = s;
    for (const a of i)
      r = Wf(this._languageIdCodec, o, this.tokenizationSupport, a, !1, r).endState;
    return r;
  }
}
class mI {
  constructor(e) {
    this.lineCount = e, this._tokenizationStateStore = new WX(), this._invalidEndStatesLineNumbers = new VX(), this._invalidEndStatesLineNumbers.addRange(new qe(1, e + 1));
  }
  getEndState(e) {
    return this._tokenizationStateStore.getEndState(e);
  }
  setEndState(e, t) {
    if (!t) throw new Kt("Cannot set null/undefined state");
    this._invalidEndStatesLineNumbers.delete(e);
    const i = this._tokenizationStateStore.setEndState(e, t);
    return i && e < this.lineCount && this._invalidEndStatesLineNumbers.addRange(new qe(e + 1, e + 2)), i;
  }
  acceptChange(e, t) {
    this.lineCount += t - e.length, this._tokenizationStateStore.acceptChange(e, t), this._invalidEndStatesLineNumbers.addRangeAndResize(new qe(e.startLineNumber, e.endLineNumberExclusive), t);
  }
  acceptChanges(e) {
    for (const t of e) {
      const [i] = kc(t.text);
      this.acceptChange(new je(t.range.startLineNumber, t.range.endLineNumber + 1), i + 1);
    }
  }
  invalidateEndStateRange(e) {
    this._invalidEndStatesLineNumbers.addRange(new qe(e.startLineNumber, e.endLineNumberExclusive));
  }
  getFirstInvalidEndStateLineNumber() {
    return this._invalidEndStatesLineNumbers.min;
  }
  getFirstInvalidEndStateLineNumberOrMax() {
    return this.getFirstInvalidEndStateLineNumber() || Number.MAX_SAFE_INTEGER;
  }
  allStatesValid() {
    return this._invalidEndStatesLineNumbers.min === null;
  }
  getStartState(e, t) {
    return e === 1 ? t : this.getEndState(e - 1);
  }
  getFirstInvalidLine(e) {
    const t = this.getFirstInvalidEndStateLineNumber();
    if (t === null) return null;
    const i = this.getStartState(t, e);
    if (!i) throw new Kt("Start state must be defined");
    return { lineNumber: t, startState: i };
  }
}
class WX {
  constructor() {
    this._lineEndStates = new PX(null);
  }
  getEndState(e) {
    return this._lineEndStates.get(e);
  }
  setEndState(e, t) {
    const i = this._lineEndStates.get(e);
    return (!i || !i.equals(t)) && (this._lineEndStates.set(e, t), !0);
  }
  acceptChange(e, t) {
    let i = e.length;
    t > 0 && i > 0 && (i--, t--), this._lineEndStates.replace(e.startLineNumber, i, t);
  }
}
class VX {
  constructor() {
    this._ranges = [];
  }
  get min() {
    return this._ranges.length === 0 ? null : this._ranges[0].start;
  }
  delete(e) {
    const t = this._ranges.findIndex(((i) => i.contains(e)));
    if (t !== -1) {
      const i = this._ranges[t];
      i.start === e ? i.endExclusive === e + 1 ? this._ranges.splice(t, 1) : this._ranges[t] = new qe(e + 1, i.endExclusive) : i.endExclusive === e + 1 ? this._ranges[t] = new qe(i.start, e) : this._ranges.splice(t, 1, new qe(i.start, e), new qe(e + 1, i.endExclusive));
    }
  }
  addRange(e) {
    qe.addRange(e, this._ranges);
  }
  addRangeAndResize(e, t) {
    let i = 0;
    for (; !(i >= this._ranges.length || e.start <= this._ranges[i].endExclusive); ) i++;
    let s = i;
    for (; !(s >= this._ranges.length || e.endExclusive < this._ranges[s].start); ) s++;
    const o = t - e.length;
    for (let r = s; r < this._ranges.length; r++) this._ranges[r] = this._ranges[r].delta(o);
    if (i === s) {
      const r = new qe(e.start, e.start + t);
      r.isEmpty || this._ranges.splice(i, 0, r);
    } else {
      const r = Math.min(e.start, this._ranges[i].start), a = Math.max(e.endExclusive, this._ranges[s - 1].endExclusive), l = new qe(r, a + o);
      l.isEmpty ? this._ranges.splice(i, s - i) : this._ranges.splice(i, s - i, l);
    }
  }
  toString() {
    return this._ranges.map(((e) => e.toString())).join(" + ");
  }
}
function Wf(n, e, t, i, s, o) {
  let r = null;
  if (t) try {
    r = t.tokenizeEncoded(i, s, o.clone());
  } catch (a) {
    We(a);
  }
  return r || (r = iL(n.encodeLanguageId(e), o)), nn.convertToEndOffset(r.tokens, i.length), r;
}
class HX {
  constructor(e, t) {
    this._tokenizerWithStateStore = e, this._backgroundTokenStore = t, this._isDisposed = !1, this._isScheduled = !1;
  }
  dispose() {
    this._isDisposed = !0;
  }
  handleChanges() {
    this._beginBackgroundTokenization();
  }
  _beginBackgroundTokenization() {
    !this._isScheduled && this._tokenizerWithStateStore._textModel.isAttachedToEditor() && this._hasLinesToTokenize() && (this._isScheduled = !0, a8(((e) => {
      this._isScheduled = !1, this._backgroundTokenizeWithDeadline(e);
    })));
  }
  _backgroundTokenizeWithDeadline(e) {
    const t = Date.now() + e.timeRemaining(), i = () => {
      !this._isDisposed && this._tokenizerWithStateStore._textModel.isAttachedToEditor() && this._hasLinesToTokenize() && (this._backgroundTokenizeForAtLeast1ms(), Date.now() < t ? S7(i) : this._beginBackgroundTokenization());
    };
    i();
  }
  _backgroundTokenizeForAtLeast1ms() {
    const e = this._tokenizerWithStateStore._textModel.getLineCount(), t = new pI(), i = Rn.create(!1);
    do
      if (i.elapsed() > 1 || this._tokenizeOneInvalidLine(t) >= e) break;
    while (this._hasLinesToTokenize());
    this._backgroundTokenStore.setTokens(t.finalize()), this.checkFinished();
  }
  _hasLinesToTokenize() {
    return !!this._tokenizerWithStateStore && !this._tokenizerWithStateStore.store.allStatesValid();
  }
  _tokenizeOneInvalidLine(e) {
    var t;
    const i = (t = this._tokenizerWithStateStore) === null || t === void 0 ? void 0 : t.getFirstInvalidLine();
    return i ? (this._tokenizerWithStateStore.updateTokensUntilLine(e, i.lineNumber), i.lineNumber) : this._tokenizerWithStateStore._textModel.getLineCount() + 1;
  }
  checkFinished() {
    this._isDisposed || this._tokenizerWithStateStore.store.allStatesValid() && this._backgroundTokenStore.backgroundTokenizationFinished();
  }
  requestTokens(e, t) {
    this._tokenizerWithStateStore.store.invalidateEndStateRange(new je(e, t));
  }
}
const Vl = new Uint32Array(0).buffer;
class Aa {
  static deleteBeginning(e, t) {
    return e === null || e === Vl ? e : Aa.delete(e, 0, t);
  }
  static deleteEnding(e, t) {
    if (e === null || e === Vl) return e;
    const i = ed(e), s = i[i.length - 2];
    return Aa.delete(e, t, s);
  }
  static delete(e, t, i) {
    if (e === null || e === Vl || t === i) return e;
    const s = ed(e), o = s.length >>> 1;
    if (t === 0 && s[s.length - 2] === i) return Vl;
    const r = nn.findIndexInTokensArray(s, t), a = r > 0 ? s[r - 1 << 1] : 0;
    if (i < s[r << 1]) {
      const u = i - t;
      for (let g = r; g < o; g++) s[g << 1] -= u;
      return e;
    }
    let l, d;
    a !== t ? (s[r << 1] = t, l = r + 1 << 1, d = t) : (l = r << 1, d = a);
    const h = i - t;
    for (let u = r + 1; u < o; u++) {
      const g = s[u << 1] - h;
      g > d && (s[l++] = g, s[l++] = s[1 + (u << 1)], d = g);
    }
    if (l === s.length) return e;
    const c = new Uint32Array(l);
    return c.set(s.subarray(0, l), 0), c.buffer;
  }
  static append(e, t) {
    if (t === Vl) return e;
    if (e === Vl) return t;
    if (e === null) return e;
    if (t === null) return null;
    const i = ed(e), s = ed(t), o = s.length >>> 1, r = new Uint32Array(i.length + s.length);
    r.set(i, 0);
    let a = i.length;
    const l = i[i.length - 2];
    for (let d = 0; d < o; d++) r[a++] = s[d << 1] + l, r[a++] = s[1 + (d << 1)];
    return r.buffer;
  }
  static insert(e, t, i) {
    if (e === null || e === Vl) return e;
    const s = ed(e), o = s.length >>> 1;
    let r = nn.findIndexInTokensArray(s, t);
    r > 0 && s[r - 1 << 1] === t && r--;
    for (let a = r; a < o; a++) s[a << 1] += i;
    return e;
  }
}
function ed(n) {
  return n instanceof Uint32Array ? n : new Uint32Array(n);
}
class yv {
  constructor(e) {
    this._lineTokens = [], this._len = 0, this._languageIdCodec = e;
  }
  flush() {
    this._lineTokens = [], this._len = 0;
  }
  get hasTokens() {
    return this._lineTokens.length > 0;
  }
  getTokens(e, t, i) {
    let s = null;
    if (t < this._len && (s = this._lineTokens[t]), s !== null && s !== Vl) return new nn(ed(s), i, this._languageIdCodec);
    const o = new Uint32Array(2);
    return o[0] = i.length, o[1] = A5(this._languageIdCodec.encodeLanguageId(e)), new nn(o, i, this._languageIdCodec);
  }
  static _massageTokens(e, t, i) {
    const s = i ? ed(i) : null;
    if (t === 0) {
      let o = !1;
      if (s && s.length > 1 && (o = In.getLanguageId(s[1]) !== e), !o) return Vl;
    }
    if (!s || s.length === 0) {
      const o = new Uint32Array(2);
      return o[0] = t, o[1] = A5(e), o.buffer;
    }
    return s[s.length - 2] = t, s.byteOffset === 0 && s.byteLength === s.buffer.byteLength ? s.buffer : s;
  }
  _ensureLine(e) {
    for (; e >= this._len; ) this._lineTokens[this._len] = null, this._len++;
  }
  _deleteLines(e, t) {
    t !== 0 && (e + t > this._len && (t = this._len - e), this._lineTokens.splice(e, t), this._len -= t);
  }
  _insertLines(e, t) {
    if (t === 0) return;
    const i = [];
    for (let s = 0; s < t; s++) i[s] = null;
    this._lineTokens = TS(this._lineTokens, e, i), this._len += t;
  }
  setTokens(e, t, i, s, o) {
    const r = yv._massageTokens(this._languageIdCodec.encodeLanguageId(e), i, s);
    this._ensureLine(t);
    const a = this._lineTokens[t];
    return this._lineTokens[t] = r, !!o && !yv._equals(a, r);
  }
  static _equals(e, t) {
    if (!e || !t) return !e && !t;
    const i = ed(e), s = ed(t);
    if (i.length !== s.length) return !1;
    for (let o = 0, r = i.length; o < r; o++) if (i[o] !== s[o]) return !1;
    return !0;
  }
  acceptEdit(e, t, i) {
    this._acceptDeleteRange(e), this._acceptInsertText(new W(e.startLineNumber, e.startColumn), t, i);
  }
  _acceptDeleteRange(e) {
    const t = e.startLineNumber - 1;
    if (t >= this._len) return;
    if (e.startLineNumber === e.endLineNumber)
      return e.startColumn === e.endColumn ? void 0 : void (this._lineTokens[t] = Aa.delete(this._lineTokens[t], e.startColumn - 1, e.endColumn - 1));
    this._lineTokens[t] = Aa.deleteEnding(this._lineTokens[t], e.startColumn - 1);
    const i = e.endLineNumber - 1;
    let s = null;
    i < this._len && (s = Aa.deleteBeginning(this._lineTokens[i], e.endColumn - 1)), this._lineTokens[t] = Aa.append(this._lineTokens[t], s), this._deleteLines(e.startLineNumber, e.endLineNumber - e.startLineNumber);
  }
  _acceptInsertText(e, t, i) {
    if (t === 0 && i === 0) return;
    const s = e.lineNumber - 1;
    s >= this._len || (t !== 0 ? (this._lineTokens[s] = Aa.deleteEnding(this._lineTokens[s], e.column - 1), this._lineTokens[s] = Aa.insert(this._lineTokens[s], e.column - 1, i), this._insertLines(e.lineNumber, t)) : this._lineTokens[s] = Aa.insert(this._lineTokens[s], e.column - 1, i));
  }
  setMultilineTokens(e, t) {
    if (e.length === 0) return { changes: [] };
    const i = [];
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e[s];
      let a = 0, l = 0, d = !1;
      for (let h = r.startLineNumber; h <= r.endLineNumber; h++) d ? (this.setTokens(t.getLanguageId(), h - 1, t.getLineLength(h), r.getLineTokens(h), !1), l = h) : this.setTokens(t.getLanguageId(), h - 1, t.getLineLength(h), r.getLineTokens(h), !0) && (d = !0, a = h, l = h);
      d && i.push({ fromLineNumber: a, toLineNumber: l });
    }
    return { changes: i };
  }
}
function A5(n) {
  return (32768 | n | 2 << 24 | 1024) >>> 0;
}
class iA {
  constructor(e) {
    this._pieces = [], this._isComplete = !1, this._languageIdCodec = e;
  }
  flush() {
    this._pieces = [], this._isComplete = !1;
  }
  isEmpty() {
    return this._pieces.length === 0;
  }
  set(e, t) {
    this._pieces = e || [], this._isComplete = t;
  }
  setPartial(e, t) {
    let i = e;
    if (t.length > 0) {
      const o = t[0].getRange(), r = t[t.length - 1].getRange();
      if (!o || !r) return e;
      i = e.plusRange(o).plusRange(r);
    }
    let s = null;
    for (let o = 0, r = this._pieces.length; o < r; o++) {
      const a = this._pieces[o];
      if (a.endLineNumber < i.startLineNumber) continue;
      if (a.startLineNumber > i.endLineNumber) {
        s = s || { index: o };
        break;
      }
      if (a.removeTokens(i), a.isEmpty()) {
        this._pieces.splice(o, 1), o--, r--;
        continue;
      }
      if (a.endLineNumber < i.startLineNumber) continue;
      if (a.startLineNumber > i.endLineNumber) {
        s = s || { index: o };
        continue;
      }
      const [l, d] = a.split(i);
      l.isEmpty() ? s = s || { index: o } : d.isEmpty() || (this._pieces.splice(o, 1, l, d), o++, r++, s = s || { index: o });
    }
    return s = s || { index: this._pieces.length }, t.length > 0 && (this._pieces = TS(this._pieces, s.index, t)), i;
  }
  isComplete() {
    return this._isComplete;
  }
  addSparseTokens(e, t) {
    if (t.getLineContent().length === 0) return t;
    const i = this._pieces;
    if (i.length === 0) return t;
    const s = i[iA._findFirstPieceWithLine(i, e)].getLineTokens(e);
    if (!s) return t;
    const o = t.getCount(), r = s.getCount();
    let a = 0;
    const l = [];
    let d = 0, h = 0;
    const c = (u, g) => {
      u !== h && (h = u, l[d++] = u, l[d++] = g);
    };
    for (let u = 0; u < r; u++) {
      const g = s.getStartCharacter(u), p = s.getEndCharacter(u), f = s.getMetadata(u), _ = ((1 & f ? 2048 : 0) | (2 & f ? 4096 : 0) | (4 & f ? 8192 : 0) | (8 & f ? 16384 : 0) | (16 & f ? 16744448 : 0) | (32 & f ? 4278190080 : 0)) >>> 0, v = ~_ >>> 0;
      for (; a < o && t.getEndOffset(a) <= g; ) c(t.getEndOffset(a), t.getMetadata(a)), a++;
      for (a < o && t.getStartOffset(a) < g && c(g, t.getMetadata(a)); a < o && t.getEndOffset(a) < p; ) c(t.getEndOffset(a), t.getMetadata(a) & v | f & _), a++;
      if (a < o) c(p, t.getMetadata(a) & v | f & _), t.getEndOffset(a) === p && a++;
      else {
        const b = Math.min(Math.max(0, a - 1), o - 1);
        c(p, t.getMetadata(b) & v | f & _);
      }
    }
    for (; a < o; ) c(t.getEndOffset(a), t.getMetadata(a)), a++;
    return new nn(new Uint32Array(l), t.getLineContent(), this._languageIdCodec);
  }
  static _findFirstPieceWithLine(e, t) {
    let i = 0, s = e.length - 1;
    for (; i < s; ) {
      let o = i + Math.floor((s - i) / 2);
      if (e[o].endLineNumber < t) i = o + 1;
      else {
        if (!(e[o].startLineNumber > t)) {
          for (; o > i && e[o - 1].startLineNumber <= t && t <= e[o - 1].endLineNumber; ) o--;
          return o;
        }
        s = o - 1;
      }
    }
    return i;
  }
  acceptEdit(e, t, i, s, o) {
    for (const r of this._pieces) r.acceptEdit(e, t, i, s, o);
  }
}
class fy extends KB {
  constructor(e, t, i, s, o, r) {
    super(), this._languageService = e, this._languageConfigurationService = t, this._textModel = i, this._bracketPairsTextModelPart = s, this._languageId = o, this._attachedViews = r, this._semanticTokens = new iA(this._languageService.languageIdCodec), this._onDidChangeLanguage = this._register(new F()), this.onDidChangeLanguage = this._onDidChangeLanguage.event, this._onDidChangeLanguageConfiguration = this._register(new F()), this.onDidChangeLanguageConfiguration = this._onDidChangeLanguageConfiguration.event, this._onDidChangeTokens = this._register(new F()), this.onDidChangeTokens = this._onDidChangeTokens.event, this.grammarTokens = this._register(new zX(this._languageService.languageIdCodec, this._textModel, (() => this._languageId), this._attachedViews)), this._register(this._languageConfigurationService.onDidChange(((a) => {
      a.affects(this._languageId) && this._onDidChangeLanguageConfiguration.fire({});
    }))), this._register(this.grammarTokens.onDidChangeTokens(((a) => {
      this._emitModelTokensChangedEvent(a);
    }))), this._register(this.grammarTokens.onDidChangeBackgroundTokenizationState(((a) => {
      this._bracketPairsTextModelPart.handleDidChangeBackgroundTokenizationState();
    })));
  }
  handleDidChangeContent(e) {
    if (e.isFlush) this._semanticTokens.flush();
    else if (!e.isEolChange) for (const t of e.changes) {
      const [i, s, o] = kc(t.text);
      this._semanticTokens.acceptEdit(t.range, i, s, o, t.text.length > 0 ? t.text.charCodeAt(0) : 0);
    }
    this.grammarTokens.handleDidChangeContent(e);
  }
  handleDidChangeAttached() {
    this.grammarTokens.handleDidChangeAttached();
  }
  getLineTokens(e) {
    this.validateLineNumber(e);
    const t = this.grammarTokens.getLineTokens(e);
    return this._semanticTokens.addSparseTokens(e, t);
  }
  _emitModelTokensChangedEvent(e) {
    this._textModel._isDisposing() || (this._bracketPairsTextModelPart.handleDidChangeTokens(e), this._onDidChangeTokens.fire(e));
  }
  validateLineNumber(e) {
    if (e < 1 || e > this._textModel.getLineCount()) throw new Kt("Illegal value for lineNumber");
  }
  get hasTokens() {
    return this.grammarTokens.hasTokens;
  }
  resetTokenization() {
    this.grammarTokens.resetTokenization();
  }
  get backgroundTokenizationState() {
    return this.grammarTokens.backgroundTokenizationState;
  }
  forceTokenization(e) {
    this.validateLineNumber(e), this.grammarTokens.forceTokenization(e);
  }
  hasAccurateTokensForLine(e) {
    return this.validateLineNumber(e), this.grammarTokens.hasAccurateTokensForLine(e);
  }
  isCheapToTokenize(e) {
    return this.validateLineNumber(e), this.grammarTokens.isCheapToTokenize(e);
  }
  tokenizeIfCheap(e) {
    this.validateLineNumber(e), this.grammarTokens.tokenizeIfCheap(e);
  }
  getTokenTypeIfInsertingCharacter(e, t, i) {
    return this.grammarTokens.getTokenTypeIfInsertingCharacter(e, t, i);
  }
  tokenizeLineWithEdit(e, t, i) {
    return this.grammarTokens.tokenizeLineWithEdit(e, t, i);
  }
  setSemanticTokens(e, t) {
    this._semanticTokens.set(e, t), this._emitModelTokensChangedEvent({ semanticTokensApplied: e !== null, ranges: [{ fromLineNumber: 1, toLineNumber: this._textModel.getLineCount() }] });
  }
  hasCompleteSemanticTokens() {
    return this._semanticTokens.isComplete();
  }
  hasSomeSemanticTokens() {
    return !this._semanticTokens.isEmpty();
  }
  setPartialSemanticTokens(e, t) {
    if (this.hasCompleteSemanticTokens()) return;
    const i = this._textModel.validateRange(this._semanticTokens.setPartial(e, t));
    this._emitModelTokensChangedEvent({ semanticTokensApplied: !0, ranges: [{ fromLineNumber: i.startLineNumber, toLineNumber: i.endLineNumber }] });
  }
  getWordAtPosition(e) {
    this.assertNotDisposed();
    const t = this._textModel.validatePosition(e), i = this._textModel.getLineContent(t.lineNumber), s = this.getLineTokens(t.lineNumber), o = s.findTokenIndexAtOffset(t.column - 1), [r, a] = fy._findLanguageBoundaries(s, o), l = K0(t.column, this.getLanguageConfiguration(s.getLanguageId(o)).getWordDefinition(), i.substring(r, a), r);
    if (l && l.startColumn <= e.column && e.column <= l.endColumn) return l;
    if (o > 0 && r === t.column - 1) {
      const [d, h] = fy._findLanguageBoundaries(s, o - 1), c = K0(t.column, this.getLanguageConfiguration(s.getLanguageId(o - 1)).getWordDefinition(), i.substring(d, h), d);
      if (c && c.startColumn <= e.column && e.column <= c.endColumn) return c;
    }
    return null;
  }
  getLanguageConfiguration(e) {
    return this._languageConfigurationService.getLanguageConfiguration(e);
  }
  static _findLanguageBoundaries(e, t) {
    const i = e.getLanguageId(t);
    let s = 0;
    for (let r = t; r >= 0 && e.getLanguageId(r) === i; r--) s = e.getStartOffset(r);
    let o = e.getLineContent().length;
    for (let r = t, a = e.getCount(); r < a && e.getLanguageId(r) === i; r++) o = e.getEndOffset(r);
    return [s, o];
  }
  getWordUntilPosition(e) {
    const t = this.getWordAtPosition(e);
    return t ? { word: t.word.substr(0, e.column - t.startColumn), startColumn: t.startColumn, endColumn: e.column } : { word: "", startColumn: e.column, endColumn: e.column };
  }
  getLanguageId() {
    return this._languageId;
  }
  getLanguageIdAtPosition(e, t) {
    const i = this._textModel.validatePosition(new W(e, t)), s = this.getLineTokens(i.lineNumber);
    return s.getLanguageId(s.findTokenIndexAtOffset(i.column - 1));
  }
  setLanguageId(e, t = "api") {
    if (this._languageId === e) return;
    const i = { oldLanguage: this._languageId, newLanguage: e, source: t };
    this._languageId = e, this._bracketPairsTextModelPart.handleDidChangeLanguage(i), this.grammarTokens.resetTokenization(), this._onDidChangeLanguage.fire(i), this._onDidChangeLanguageConfiguration.fire({});
  }
}
class zX extends V {
  get backgroundTokenizationState() {
    return this._backgroundTokenizationState;
  }
  constructor(e, t, i, s) {
    super(), this._languageIdCodec = e, this._textModel = t, this.getLanguageId = i, this._tokenizer = null, this._defaultBackgroundTokenizer = null, this._backgroundTokenizer = this._register(new rn()), this._tokens = new yv(this._languageIdCodec), this._debugBackgroundTokenizer = this._register(new rn()), this._backgroundTokenizationState = 1, this._onDidChangeBackgroundTokenizationState = this._register(new F()), this.onDidChangeBackgroundTokenizationState = this._onDidChangeBackgroundTokenizationState.event, this._onDidChangeTokens = this._register(new F()), this.onDidChangeTokens = this._onDidChangeTokens.event, this._attachedViewStates = this._register(new XT()), this._register(ci.onDidChange(((o) => {
      const r = this.getLanguageId();
      o.changedLanguages.indexOf(r) !== -1 && this.resetTokenization();
    }))), this.resetTokenization(), this._register(s.onDidChangeVisibleRanges((({ view: o, state: r }) => {
      if (r) {
        let a = this._attachedViewStates.get(o);
        a || (a = new UX((() => this.refreshRanges(a.lineRanges))), this._attachedViewStates.set(o, a)), a.handleStateChange(r);
      } else this._attachedViewStates.deleteAndDispose(o);
    })));
  }
  resetTokenization(e = !0) {
    var t;
    this._tokens.flush(), (t = this._debugBackgroundTokens) === null || t === void 0 || t.flush(), this._debugBackgroundStates && (this._debugBackgroundStates = new mI(this._textModel.getLineCount())), e && this._onDidChangeTokens.fire({ semanticTokensApplied: !1, ranges: [{ fromLineNumber: 1, toLineNumber: this._textModel.getLineCount() }] });
    const [i, s] = (() => {
      if (this._textModel.isTooLargeForTokenization()) return [null, null];
      const o = ci.get(this.getLanguageId());
      if (!o) return [null, null];
      let r;
      try {
        r = o.getInitialState();
      } catch (a) {
        return We(a), [null, null];
      }
      return [o, r];
    })();
    if (this._tokenizer = i && s ? new BX(this._textModel.getLineCount(), i, this._textModel, this._languageIdCodec) : null, this._backgroundTokenizer.clear(), this._defaultBackgroundTokenizer = null, this._tokenizer) {
      const o = { setTokens: (r) => {
        this.setTokens(r);
      }, backgroundTokenizationFinished: () => {
        this._backgroundTokenizationState !== 2 && (this._backgroundTokenizationState = 2, this._onDidChangeBackgroundTokenizationState.fire());
      }, setEndState: (r, a) => {
        var l;
        if (!this._tokenizer) return;
        const d = this._tokenizer.store.getFirstInvalidEndStateLineNumber();
        d !== null && r >= d && ((l = this._tokenizer) === null || l === void 0 || l.store.setEndState(r, a));
      } };
      i && i.createBackgroundTokenizer && !i.backgroundTokenizerShouldOnlyVerifyTokens && (this._backgroundTokenizer.value = i.createBackgroundTokenizer(this._textModel, o)), this._backgroundTokenizer.value || this._textModel.isTooLargeForTokenization() || (this._backgroundTokenizer.value = this._defaultBackgroundTokenizer = new HX(this._tokenizer, o), this._defaultBackgroundTokenizer.handleChanges()), i?.backgroundTokenizerShouldOnlyVerifyTokens && i.createBackgroundTokenizer ? (this._debugBackgroundTokens = new yv(this._languageIdCodec), this._debugBackgroundStates = new mI(this._textModel.getLineCount()), this._debugBackgroundTokenizer.clear(), this._debugBackgroundTokenizer.value = i.createBackgroundTokenizer(this._textModel, { setTokens: (r) => {
        var a;
        (a = this._debugBackgroundTokens) === null || a === void 0 || a.setMultilineTokens(r, this._textModel);
      }, backgroundTokenizationFinished() {
      }, setEndState: (r, a) => {
        var l;
        (l = this._debugBackgroundStates) === null || l === void 0 || l.setEndState(r, a);
      } })) : (this._debugBackgroundTokens = void 0, this._debugBackgroundStates = void 0, this._debugBackgroundTokenizer.value = void 0);
    }
    this.refreshAllVisibleLineTokens();
  }
  handleDidChangeAttached() {
    var e;
    (e = this._defaultBackgroundTokenizer) === null || e === void 0 || e.handleChanges();
  }
  handleDidChangeContent(e) {
    var t, i, s;
    if (e.isFlush) this.resetTokenization(!1);
    else if (!e.isEolChange) {
      for (const o of e.changes) {
        const [r, a] = kc(o.text);
        this._tokens.acceptEdit(o.range, r, a), (t = this._debugBackgroundTokens) === null || t === void 0 || t.acceptEdit(o.range, r, a);
      }
      (i = this._debugBackgroundStates) === null || i === void 0 || i.acceptChanges(e.changes), this._tokenizer && this._tokenizer.store.acceptChanges(e.changes), (s = this._defaultBackgroundTokenizer) === null || s === void 0 || s.handleChanges();
    }
  }
  setTokens(e) {
    const { changes: t } = this._tokens.setMultilineTokens(e, this._textModel);
    return t.length > 0 && this._onDidChangeTokens.fire({ semanticTokensApplied: !1, ranges: t }), { changes: t };
  }
  refreshAllVisibleLineTokens() {
    const e = je.joinMany([...this._attachedViewStates].map((([t, i]) => i.lineRanges)));
    this.refreshRanges(e);
  }
  refreshRanges(e) {
    for (const t of e) this.refreshRange(t.startLineNumber, t.endLineNumberExclusive - 1);
  }
  refreshRange(e, t) {
    var i, s;
    if (!this._tokenizer) return;
    e = Math.max(1, Math.min(this._textModel.getLineCount(), e)), t = Math.min(this._textModel.getLineCount(), t);
    const o = new pI(), { heuristicTokens: r } = this._tokenizer.tokenizeHeuristically(o, e, t), a = this.setTokens(o.finalize());
    if (r) for (const l of a.changes) (i = this._backgroundTokenizer.value) === null || i === void 0 || i.requestTokens(l.fromLineNumber, l.toLineNumber + 1);
    (s = this._defaultBackgroundTokenizer) === null || s === void 0 || s.checkFinished();
  }
  forceTokenization(e) {
    var t, i;
    const s = new pI();
    (t = this._tokenizer) === null || t === void 0 || t.updateTokensUntilLine(s, e), this.setTokens(s.finalize()), (i = this._defaultBackgroundTokenizer) === null || i === void 0 || i.checkFinished();
  }
  hasAccurateTokensForLine(e) {
    return !this._tokenizer || this._tokenizer.hasAccurateTokensForLine(e);
  }
  isCheapToTokenize(e) {
    return !this._tokenizer || this._tokenizer.isCheapToTokenize(e);
  }
  tokenizeIfCheap(e) {
    this.isCheapToTokenize(e) && this.forceTokenization(e);
  }
  getLineTokens(e) {
    var t;
    const i = this._textModel.getLineContent(e), s = this._tokens.getTokens(this._textModel.getLanguageId(), e - 1, i);
    if (this._debugBackgroundTokens && this._debugBackgroundStates && this._tokenizer && this._debugBackgroundStates.getFirstInvalidEndStateLineNumberOrMax() > e && this._tokenizer.store.getFirstInvalidEndStateLineNumberOrMax() > e) {
      const o = this._debugBackgroundTokens.getTokens(this._textModel.getLanguageId(), e - 1, i);
      !s.equals(o) && (!((t = this._debugBackgroundTokenizer.value) === null || t === void 0) && t.reportMismatchingTokens) && this._debugBackgroundTokenizer.value.reportMismatchingTokens(e);
    }
    return s;
  }
  getTokenTypeIfInsertingCharacter(e, t, i) {
    if (!this._tokenizer) return 0;
    const s = this._textModel.validatePosition(new W(e, t));
    return this.forceTokenization(s.lineNumber), this._tokenizer.getTokenTypeIfInsertingCharacter(s, i);
  }
  tokenizeLineWithEdit(e, t, i) {
    if (!this._tokenizer) return null;
    const s = this._textModel.validatePosition(e);
    return this.forceTokenization(s.lineNumber), this._tokenizer.tokenizeLineWithEdit(s, t, i);
  }
  get hasTokens() {
    return this._tokens.hasTokens;
  }
}
class UX extends V {
  get lineRanges() {
    return this._lineRanges;
  }
  constructor(e) {
    super(), this._refreshTokens = e, this.runner = this._register(new Et((() => this.update()), 50)), this._computedLineRanges = [], this._lineRanges = [];
  }
  update() {
    ri(this._computedLineRanges, this._lineRanges, ((e, t) => e.equals(t))) || (this._computedLineRanges = this._lineRanges, this._refreshTokens());
  }
  handleStateChange(e) {
    this._lineRanges = e.visibleLineRanges, e.stabilized ? (this.runner.cancel(), this.update()) : this.runner.schedule();
  }
}
const gL = tt("undoRedoService");
class lW {
  constructor(e, t) {
    this.resource = e, this.elements = t;
  }
}
class cm {
  constructor() {
    this.id = cm._ID++, this.order = 1;
  }
  nextOrder() {
    return this.id === 0 ? 0 : this.order++;
  }
}
cm._ID = 0, cm.None = new cm();
class Za {
  constructor() {
    this.id = Za._ID++, this.order = 1;
  }
  nextOrder() {
    return this.id === 0 ? 0 : this.order++;
  }
}
Za._ID = 0, Za.None = new Za();
var ou, KX = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, ND = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
function P5(n, e) {
  let t;
  var i;
  return typeof n == "string" ? t = (function(s) {
    const o = new R5();
    return o.acceptChunk(s), o.finish();
  })(n) : t = (i = n) && typeof i.read == "function" ? (function(s) {
    const o = new R5();
    let r;
    for (; typeof (r = s.read()) == "string"; ) o.acceptChunk(r);
    return o.finish();
  })(n) : n, t.create(e);
}
let yb = 0;
class jX {
  constructor(e) {
    this._source = e, this._eos = !1;
  }
  read() {
    if (this._eos) return null;
    const e = [];
    let t = 0, i = 0;
    for (; ; ) {
      const s = this._source.read();
      if (s === null) return this._eos = !0, t === 0 ? null : e.join("");
      if (s.length > 0 && (e[t++] = s, i += s.length), i >= 65536) return e.join("");
    }
  }
}
const Vf = () => {
  throw new Error("Invalid change accessor");
};
let Pa = ou = class extends V {
  static resolveOptions(n, e) {
    if (e.detectIndentation) {
      const t = S5(n, e.tabSize, e.insertSpaces);
      return new MC({ tabSize: t.tabSize, indentSize: "tabSize", insertSpaces: t.insertSpaces, trimAutoWhitespace: e.trimAutoWhitespace, defaultEOL: e.defaultEOL, bracketPairColorizationOptions: e.bracketPairColorizationOptions });
    }
    return new MC(e);
  }
  get onDidChangeLanguage() {
    return this._tokenizationTextModelPart.onDidChangeLanguage;
  }
  get onDidChangeLanguageConfiguration() {
    return this._tokenizationTextModelPart.onDidChangeLanguageConfiguration;
  }
  get onDidChangeTokens() {
    return this._tokenizationTextModelPart.onDidChangeTokens;
  }
  onDidChangeContent(n) {
    return this._eventEmitter.slowEvent(((e) => n(e.contentChangedEvent)));
  }
  onDidChangeContentOrInjectedText(n) {
    return yr(this._eventEmitter.fastEvent(((e) => n(e))), this._onDidChangeInjectedText.event(((e) => n(e))));
  }
  _isDisposing() {
    return this.__isDisposing;
  }
  get tokenization() {
    return this._tokenizationTextModelPart;
  }
  get bracketPairs() {
    return this._bracketPairs;
  }
  get guides() {
    return this._guidesTextModelPart;
  }
  constructor(n, e, t, i = null, s, o, r) {
    super(), this._undoRedoService = s, this._languageService = o, this._languageConfigurationService = r, this._onWillDispose = this._register(new F()), this.onWillDispose = this._onWillDispose.event, this._onDidChangeDecorations = this._register(new ZX(((u) => this.handleBeforeFireDecorationsChangedEvent(u)))), this.onDidChangeDecorations = this._onDidChangeDecorations.event, this._onDidChangeOptions = this._register(new F()), this.onDidChangeOptions = this._onDidChangeOptions.event, this._onDidChangeAttached = this._register(new F()), this.onDidChangeAttached = this._onDidChangeAttached.event, this._onDidChangeInjectedText = this._register(new F()), this._eventEmitter = this._register(new YX()), this._languageSelectionListener = this._register(new rn()), this._deltaDecorationCallCnt = 0, this._attachedViews = new XX(), yb++, this.id = "$model" + yb, this.isForSimpleWidget = t.isForSimpleWidget, this._associatedResource = i ?? Ie.parse("inmemory://model/" + yb), this._attachedEditorCount = 0;
    const { textBuffer: a, disposable: l } = P5(n, t.defaultEOL);
    this._buffer = a, this._bufferDisposable = l, this._options = ou.resolveOptions(this._buffer, t);
    const d = typeof e == "string" ? e : e.languageId;
    typeof e != "string" && (this._languageSelectionListener.value = e.onDidChange((() => this._setLanguage(e.languageId)))), this._bracketPairs = this._register(new vX(this, this._languageConfigurationService)), this._guidesTextModelPart = this._register(new SY(this, this._languageConfigurationService)), this._decorationProvider = this._register(new bX(this)), this._tokenizationTextModelPart = new fy(this._languageService, this._languageConfigurationService, this, this._bracketPairs, d, this._attachedViews);
    const h = this._buffer.getLineCount(), c = this._buffer.getValueLengthInRange(new D(1, 1, h, this._buffer.getLineLength(h) + 1), 0);
    t.largeFileOptimizations ? (this._isTooLargeForTokenization = c > ou.LARGE_FILE_SIZE_THRESHOLD || h > ou.LARGE_FILE_LINE_COUNT_THRESHOLD, this._isTooLargeForHeapOperation = c > ou.LARGE_FILE_HEAP_OPERATION_THRESHOLD) : (this._isTooLargeForTokenization = !1, this._isTooLargeForHeapOperation = !1), this._isTooLargeForSyncing = c > ou._MODEL_SYNC_LIMIT, this._versionId = 1, this._alternativeVersionId = 1, this._initialUndoRedoSnapshot = null, this._isDisposed = !1, this.__isDisposing = !1, this._instanceId = i8(yb), this._lastDecorationId = 0, this._decorations = /* @__PURE__ */ Object.create(null), this._decorationsTree = new O5(), this._commandManager = new QR(this, this._undoRedoService), this._isUndoing = !1, this._isRedoing = !1, this._trimAutoWhitespaceLines = null, this._register(this._decorationProvider.onDidChange((() => {
      this._onDidChangeDecorations.beginDeferredEmit(), this._onDidChangeDecorations.fire(), this._onDidChangeDecorations.endDeferredEmit();
    }))), this._languageService.requestRichLanguageFeatures(d);
  }
  dispose() {
    this.__isDisposing = !0, this._onWillDispose.fire(), this._tokenizationTextModelPart.dispose(), this._isDisposed = !0, super.dispose(), this._bufferDisposable.dispose(), this.__isDisposing = !1;
    const n = new hm([], "", `
`, !1, !1, !0, !0);
    n.dispose(), this._buffer = n, this._bufferDisposable = V.None;
  }
  _assertNotDisposed() {
    if (this._isDisposed) throw new Error("Model is disposed!");
  }
  _emitContentChangedEvent(n, e) {
    this.__isDisposing || (this._tokenizationTextModelPart.handleDidChangeContent(e), this._bracketPairs.handleDidChangeContent(e), this._eventEmitter.fire(new ju(n, e)));
  }
  setValue(n) {
    if (this._assertNotDisposed(), n == null) throw Yo();
    const { textBuffer: e, disposable: t } = P5(n, this._options.defaultEOL);
    this._setValueFromTextBuffer(e, t);
  }
  _createContentChanged2(n, e, t, i, s, o, r, a) {
    return { changes: [{ range: n, rangeOffset: e, rangeLength: t, text: i }], eol: this._buffer.getEOL(), isEolChange: a, versionId: this.getVersionId(), isUndoing: s, isRedoing: o, isFlush: r };
  }
  _setValueFromTextBuffer(n, e) {
    this._assertNotDisposed();
    const t = this.getFullModelRange(), i = this.getValueLengthInRange(t), s = this.getLineCount(), o = this.getLineMaxColumn(s);
    this._buffer = n, this._bufferDisposable.dispose(), this._bufferDisposable = e, this._increaseVersionId(), this._decorations = /* @__PURE__ */ Object.create(null), this._decorationsTree = new O5(), this._commandManager.clear(), this._trimAutoWhitespaceLines = null, this._emitContentChangedEvent(new am([new XY()], this._versionId, !1, !1), this._createContentChanged2(new D(1, 1, s, o), 0, i, this.getValue(), !1, !1, !0, !1));
  }
  setEOL(n) {
    this._assertNotDisposed();
    const e = n === 1 ? `\r
` : `
`;
    if (this._buffer.getEOL() === e) return;
    const t = this.getFullModelRange(), i = this.getValueLengthInRange(t), s = this.getLineCount(), o = this.getLineMaxColumn(s);
    this._onBeforeEOLChange(), this._buffer.setEOL(e), this._increaseVersionId(), this._onAfterEOLChange(), this._emitContentChangedEvent(new am([new eX()], this._versionId, !1, !1), this._createContentChanged2(new D(1, 1, s, o), 0, i, this.getValue(), !1, !1, !1, !0));
  }
  _onBeforeEOLChange() {
    this._decorationsTree.ensureAllNodesHaveRanges(this);
  }
  _onAfterEOLChange() {
    const n = this.getVersionId(), e = this._decorationsTree.collectNodesPostOrder();
    for (let t = 0, i = e.length; t < i; t++) {
      const s = e[t], o = s.range, r = s.cachedAbsoluteStart - s.start, a = this._buffer.getOffsetAt(o.startLineNumber, o.startColumn), l = this._buffer.getOffsetAt(o.endLineNumber, o.endColumn);
      s.cachedAbsoluteStart = a, s.cachedAbsoluteEnd = l, s.cachedVersionId = n, s.start = a - r, s.end = l - r, Dc(s);
    }
  }
  onBeforeAttached() {
    return this._attachedEditorCount++, this._attachedEditorCount === 1 && (this._tokenizationTextModelPart.handleDidChangeAttached(), this._onDidChangeAttached.fire(void 0)), this._attachedViews.attachView();
  }
  onBeforeDetached(n) {
    this._attachedEditorCount--, this._attachedEditorCount === 0 && (this._tokenizationTextModelPart.handleDidChangeAttached(), this._onDidChangeAttached.fire(void 0)), this._attachedViews.detachView(n);
  }
  isAttachedToEditor() {
    return this._attachedEditorCount > 0;
  }
  getAttachedEditorCount() {
    return this._attachedEditorCount;
  }
  isTooLargeForSyncing() {
    return this._isTooLargeForSyncing;
  }
  isTooLargeForTokenization() {
    return this._isTooLargeForTokenization;
  }
  isTooLargeForHeapOperation() {
    return this._isTooLargeForHeapOperation;
  }
  isDisposed() {
    return this._isDisposed;
  }
  isDominatedByLongLines() {
    if (this._assertNotDisposed(), this.isTooLargeForTokenization()) return !1;
    let n = 0, e = 0;
    const t = this._buffer.getLineCount();
    for (let i = 1; i <= t; i++) {
      const s = this._buffer.getLineLength(i);
      s >= 1e4 ? e += s : n += s;
    }
    return e > n;
  }
  get uri() {
    return this._associatedResource;
  }
  getOptions() {
    return this._assertNotDisposed(), this._options;
  }
  getFormattingOptions() {
    return { tabSize: this._options.indentSize, insertSpaces: this._options.insertSpaces };
  }
  updateOptions(n) {
    this._assertNotDisposed();
    const e = n.tabSize !== void 0 ? n.tabSize : this._options.tabSize, t = n.indentSize !== void 0 ? n.indentSize : this._options.originalIndentSize, i = n.insertSpaces !== void 0 ? n.insertSpaces : this._options.insertSpaces, s = n.trimAutoWhitespace !== void 0 ? n.trimAutoWhitespace : this._options.trimAutoWhitespace, o = n.bracketColorizationOptions !== void 0 ? n.bracketColorizationOptions : this._options.bracketPairColorizationOptions, r = new MC({ tabSize: e, indentSize: t, insertSpaces: i, defaultEOL: this._options.defaultEOL, trimAutoWhitespace: s, bracketPairColorizationOptions: o });
    if (this._options.equals(r)) return;
    const a = this._options.createChangeEvent(r);
    this._options = r, this._bracketPairs.handleDidChangeOptions(a), this._decorationProvider.handleDidChangeOptions(a), this._onDidChangeOptions.fire(a);
  }
  detectIndentation(n, e) {
    this._assertNotDisposed();
    const t = S5(this._buffer, e, n);
    this.updateOptions({ insertSpaces: t.insertSpaces, tabSize: t.tabSize, indentSize: t.tabSize });
  }
  normalizeIndentation(n) {
    return this._assertNotDisposed(), UR(n, this._options.indentSize, this._options.insertSpaces);
  }
  getVersionId() {
    return this._assertNotDisposed(), this._versionId;
  }
  mightContainRTL() {
    return this._buffer.mightContainRTL();
  }
  mightContainUnusualLineTerminators() {
    return this._buffer.mightContainUnusualLineTerminators();
  }
  removeUnusualLineTerminators(n = null) {
    const e = this.findMatches(e8.source, !1, !0, !1, null, !1, 1073741824);
    this._buffer.resetMightContainUnusualLineTerminators(), this.pushEditOperations(n, e.map(((t) => ({ range: t.range, text: null }))), (() => null));
  }
  mightContainNonBasicASCII() {
    return this._buffer.mightContainNonBasicASCII();
  }
  getAlternativeVersionId() {
    return this._assertNotDisposed(), this._alternativeVersionId;
  }
  getInitialUndoRedoSnapshot() {
    return this._assertNotDisposed(), this._initialUndoRedoSnapshot;
  }
  getOffsetAt(n) {
    this._assertNotDisposed();
    const e = this._validatePosition(n.lineNumber, n.column, 0);
    return this._buffer.getOffsetAt(e.lineNumber, e.column);
  }
  getPositionAt(n) {
    this._assertNotDisposed();
    const e = Math.min(this._buffer.getLength(), Math.max(0, n));
    return this._buffer.getPositionAt(e);
  }
  _increaseVersionId() {
    this._versionId = this._versionId + 1, this._alternativeVersionId = this._versionId;
  }
  _overwriteVersionId(n) {
    this._versionId = n;
  }
  _overwriteAlternativeVersionId(n) {
    this._alternativeVersionId = n;
  }
  _overwriteInitialUndoRedoSnapshot(n) {
    this._initialUndoRedoSnapshot = n;
  }
  getValue(n, e = !1) {
    if (this._assertNotDisposed(), this.isTooLargeForHeapOperation()) throw new Kt("Operation would exceed heap memory limits");
    const t = this.getFullModelRange(), i = this.getValueInRange(t, n);
    return e ? this._buffer.getBOM() + i : i;
  }
  createSnapshot(n = !1) {
    return new jX(this._buffer.createSnapshot(n));
  }
  getValueLength(n, e = !1) {
    this._assertNotDisposed();
    const t = this.getFullModelRange(), i = this.getValueLengthInRange(t, n);
    return e ? this._buffer.getBOM().length + i : i;
  }
  getValueInRange(n, e = 0) {
    return this._assertNotDisposed(), this._buffer.getValueInRange(this.validateRange(n), e);
  }
  getValueLengthInRange(n, e = 0) {
    return this._assertNotDisposed(), this._buffer.getValueLengthInRange(this.validateRange(n), e);
  }
  getCharacterCountInRange(n, e = 0) {
    return this._assertNotDisposed(), this._buffer.getCharacterCountInRange(this.validateRange(n), e);
  }
  getLineCount() {
    return this._assertNotDisposed(), this._buffer.getLineCount();
  }
  getLineContent(n) {
    if (this._assertNotDisposed(), n < 1 || n > this.getLineCount()) throw new Kt("Illegal value for lineNumber");
    return this._buffer.getLineContent(n);
  }
  getLineLength(n) {
    if (this._assertNotDisposed(), n < 1 || n > this.getLineCount()) throw new Kt("Illegal value for lineNumber");
    return this._buffer.getLineLength(n);
  }
  getLinesContent() {
    if (this._assertNotDisposed(), this.isTooLargeForHeapOperation()) throw new Kt("Operation would exceed heap memory limits");
    return this._buffer.getLinesContent();
  }
  getEOL() {
    return this._assertNotDisposed(), this._buffer.getEOL();
  }
  getEndOfLineSequence() {
    return this._assertNotDisposed(), this._buffer.getEOL() === `
` ? 0 : 1;
  }
  getLineMinColumn(n) {
    return this._assertNotDisposed(), 1;
  }
  getLineMaxColumn(n) {
    if (this._assertNotDisposed(), n < 1 || n > this.getLineCount()) throw new Kt("Illegal value for lineNumber");
    return this._buffer.getLineLength(n) + 1;
  }
  getLineFirstNonWhitespaceColumn(n) {
    if (this._assertNotDisposed(), n < 1 || n > this.getLineCount()) throw new Kt("Illegal value for lineNumber");
    return this._buffer.getLineFirstNonWhitespaceColumn(n);
  }
  getLineLastNonWhitespaceColumn(n) {
    if (this._assertNotDisposed(), n < 1 || n > this.getLineCount()) throw new Kt("Illegal value for lineNumber");
    return this._buffer.getLineLastNonWhitespaceColumn(n);
  }
  _validateRangeRelaxedNoAllocations(n) {
    const e = this._buffer.getLineCount(), t = n.startLineNumber, i = n.startColumn;
    let s = Math.floor(typeof t != "number" || isNaN(t) ? 1 : t), o = Math.floor(typeof i != "number" || isNaN(i) ? 1 : i);
    if (s < 1) s = 1, o = 1;
    else if (s > e) s = e, o = this.getLineMaxColumn(s);
    else if (o <= 1) o = 1;
    else {
      const h = this.getLineMaxColumn(s);
      o >= h && (o = h);
    }
    const r = n.endLineNumber, a = n.endColumn;
    let l = Math.floor(typeof r != "number" || isNaN(r) ? 1 : r), d = Math.floor(typeof a != "number" || isNaN(a) ? 1 : a);
    if (l < 1) l = 1, d = 1;
    else if (l > e) l = e, d = this.getLineMaxColumn(l);
    else if (d <= 1) d = 1;
    else {
      const h = this.getLineMaxColumn(l);
      d >= h && (d = h);
    }
    return t === s && i === o && r === l && a === d && n instanceof D && !(n instanceof _e) ? n : new D(s, o, l, d);
  }
  _isValidPosition(n, e, t) {
    return typeof n != "number" || typeof e != "number" || isNaN(n) || isNaN(e) || n < 1 || e < 1 || (0 | n) !== n || (0 | e) !== e || n > this._buffer.getLineCount() ? !1 : e === 1 ? !0 : !(e > this.getLineMaxColumn(n) || t === 1 && en(this._buffer.getLineCharCode(n, e - 2)));
  }
  _validatePosition(n, e, t) {
    const i = Math.floor(typeof n != "number" || isNaN(n) ? 1 : n), s = Math.floor(typeof e != "number" || isNaN(e) ? 1 : e), o = this._buffer.getLineCount();
    if (i < 1) return new W(1, 1);
    if (i > o) return new W(o, this.getLineMaxColumn(o));
    if (s <= 1) return new W(i, 1);
    const r = this.getLineMaxColumn(i);
    return s >= r ? new W(i, r) : t === 1 && en(this._buffer.getLineCharCode(i, s - 2)) ? new W(i, s - 1) : new W(i, s);
  }
  validatePosition(n) {
    return this._assertNotDisposed(), n instanceof W && this._isValidPosition(n.lineNumber, n.column, 1) ? n : this._validatePosition(n.lineNumber, n.column, 1);
  }
  _isValidRange(n, e) {
    const t = n.startLineNumber, i = n.startColumn, s = n.endLineNumber, o = n.endColumn;
    if (!this._isValidPosition(t, i, 0) || !this._isValidPosition(s, o, 0)) return !1;
    if (e === 1) {
      const r = i > 1 ? this._buffer.getLineCharCode(t, i - 2) : 0, a = o > 1 && o <= this._buffer.getLineLength(s) ? this._buffer.getLineCharCode(s, o - 2) : 0, l = en(r), d = en(a);
      return !l && !d;
    }
    return !0;
  }
  validateRange(n) {
    if (this._assertNotDisposed(), n instanceof D && !(n instanceof _e) && this._isValidRange(n, 1)) return n;
    const e = this._validatePosition(n.startLineNumber, n.startColumn, 0), t = this._validatePosition(n.endLineNumber, n.endColumn, 0), i = e.lineNumber, s = e.column, o = t.lineNumber, r = t.column;
    {
      const a = s > 1 ? this._buffer.getLineCharCode(i, s - 2) : 0, l = r > 1 && r <= this._buffer.getLineLength(o) ? this._buffer.getLineCharCode(o, r - 2) : 0, d = en(a), h = en(l);
      return d || h ? i === o && s === r ? new D(i, s - 1, o, r - 1) : d && h ? new D(i, s - 1, o, r + 1) : d ? new D(i, s - 1, o, r) : new D(i, s, o, r + 1) : new D(i, s, o, r);
    }
  }
  modifyPosition(n, e) {
    this._assertNotDisposed();
    const t = this.getOffsetAt(n) + e;
    return this.getPositionAt(Math.min(this._buffer.getLength(), Math.max(0, t)));
  }
  getFullModelRange() {
    this._assertNotDisposed();
    const n = this.getLineCount();
    return new D(1, 1, n, this.getLineMaxColumn(n));
  }
  findMatchesLineByLine(n, e, t, i) {
    return this._buffer.findMatchesLineByLine(n, e, t, i);
  }
  findMatches(n, e, t, i, s, o, r = 999) {
    this._assertNotDisposed();
    let a = null;
    e !== null && (Array.isArray(e) || (e = [e]), e.every(((h) => D.isIRange(h))) && (a = e.map(((h) => this.validateRange(h))))), a === null && (a = [this.getFullModelRange()]), a = a.sort(((h, c) => h.startLineNumber - c.startLineNumber || h.startColumn - c.startColumn));
    const l = [];
    let d;
    if (l.push(a.reduce(((h, c) => D.areIntersecting(h, c) ? h.plusRange(c) : (l.push(h), c)))), !t && n.indexOf(`
`) < 0) {
      const h = new su(n, t, i, s).parseSearchRequest();
      if (!h) return [];
      d = (c) => this.findMatchesLineByLine(c, h, o, r);
    } else d = (h) => sb.findMatches(this, new su(n, t, i, s), h, o, r);
    return l.map(d).reduce(((h, c) => h.concat(c)), []);
  }
  findNextMatch(n, e, t, i, s, o) {
    this._assertNotDisposed();
    const r = this.validatePosition(e);
    if (!t && n.indexOf(`
`) < 0) {
      const a = new su(n, t, i, s).parseSearchRequest();
      if (!a) return null;
      const l = this.getLineCount();
      let d = new D(r.lineNumber, r.column, l, this.getLineMaxColumn(l)), h = this.findMatchesLineByLine(d, a, o, 1);
      return sb.findNextMatch(this, new su(n, t, i, s), r, o), h.length > 0 ? h[0] : (d = new D(1, 1, r.lineNumber, this.getLineMaxColumn(r.lineNumber)), h = this.findMatchesLineByLine(d, a, o, 1), h.length > 0 ? h[0] : null);
    }
    return sb.findNextMatch(this, new su(n, t, i, s), r, o);
  }
  findPreviousMatch(n, e, t, i, s, o) {
    this._assertNotDisposed();
    const r = this.validatePosition(e);
    return sb.findPreviousMatch(this, new su(n, t, i, s), r, o);
  }
  pushStackElement() {
    this._commandManager.pushStackElement();
  }
  popStackElement() {
    this._commandManager.popStackElement();
  }
  pushEOL(n) {
    if ((this.getEOL() === `
` ? 0 : 1) !== n) try {
      this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._initialUndoRedoSnapshot === null && (this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri)), this._commandManager.pushEOL(n);
    } finally {
      this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _validateEditOperation(n) {
    return n instanceof rD ? n : new rD(n.identifier || null, this.validateRange(n.range), n.text, n.forceMoveMarkers || !1, n.isAutoWhitespaceEdit || !1, n._isTracked || !1);
  }
  _validateEditOperations(n) {
    const e = [];
    for (let t = 0, i = n.length; t < i; t++) e[t] = this._validateEditOperation(n[t]);
    return e;
  }
  pushEditOperations(n, e, t, i) {
    try {
      return this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._pushEditOperations(n, this._validateEditOperations(e), t, i);
    } finally {
      this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _pushEditOperations(n, e, t, i) {
    if (this._options.trimAutoWhitespace && this._trimAutoWhitespaceLines) {
      const s = e.map(((r) => ({ range: this.validateRange(r.range), text: r.text })));
      let o = !0;
      if (n) for (let r = 0, a = n.length; r < a; r++) {
        const l = n[r];
        let d = !1;
        for (let h = 0, c = s.length; h < c; h++) {
          const u = s[h].range, g = u.startLineNumber > l.endLineNumber, p = l.startLineNumber > u.endLineNumber;
          if (!g && !p) {
            d = !0;
            break;
          }
        }
        if (!d) {
          o = !1;
          break;
        }
      }
      if (o) for (let r = 0, a = this._trimAutoWhitespaceLines.length; r < a; r++) {
        const l = this._trimAutoWhitespaceLines[r], d = this.getLineMaxColumn(l);
        let h = !0;
        for (let c = 0, u = s.length; c < u; c++) {
          const g = s[c].range, p = s[c].text;
          if (!(l < g.startLineNumber || l > g.endLineNumber) && !(l === g.startLineNumber && g.startColumn === d && g.isEmpty() && p && p.length > 0 && p.charAt(0) === `
` || l === g.startLineNumber && g.startColumn === 1 && g.isEmpty() && p && p.length > 0 && p.charAt(p.length - 1) === `
`)) {
            h = !1;
            break;
          }
        }
        if (h) {
          const c = new D(l, 1, l, d);
          e.push(new rD(null, c, null, !1, !1, !1));
        }
      }
      this._trimAutoWhitespaceLines = null;
    }
    return this._initialUndoRedoSnapshot === null && (this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri)), this._commandManager.pushEditOperation(n, e, t, i);
  }
  _applyUndo(n, e, t, i) {
    const s = n.map(((o) => {
      const r = this.getPositionAt(o.newPosition), a = this.getPositionAt(o.newEnd);
      return { range: new D(r.lineNumber, r.column, a.lineNumber, a.column), text: o.oldText };
    }));
    this._applyUndoRedoEdits(s, e, !0, !1, t, i);
  }
  _applyRedo(n, e, t, i) {
    const s = n.map(((o) => {
      const r = this.getPositionAt(o.oldPosition), a = this.getPositionAt(o.oldEnd);
      return { range: new D(r.lineNumber, r.column, a.lineNumber, a.column), text: o.newText };
    }));
    this._applyUndoRedoEdits(s, e, !1, !0, t, i);
  }
  _applyUndoRedoEdits(n, e, t, i, s, o) {
    try {
      this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._isUndoing = t, this._isRedoing = i, this.applyEdits(n, !1), this.setEOL(e), this._overwriteAlternativeVersionId(s);
    } finally {
      this._isUndoing = !1, this._isRedoing = !1, this._eventEmitter.endDeferredEmit(o), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  applyEdits(n, e = !1) {
    try {
      this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit();
      const t = this._validateEditOperations(n);
      return this._doApplyEdits(t, e);
    } finally {
      this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _doApplyEdits(n, e) {
    const t = this._buffer.getLineCount(), i = this._buffer.applyEdits(n, this._options.trimAutoWhitespace, e), s = this._buffer.getLineCount(), o = i.changes;
    if (this._trimAutoWhitespaceLines = i.trimAutoWhitespaceLineNumbers, o.length !== 0) {
      for (let l = 0, d = o.length; l < d; l++) {
        const h = o[l];
        this._decorationsTree.acceptReplace(h.rangeOffset, h.rangeLength, h.text.length, h.forceMoveMarkers);
      }
      const r = [];
      this._increaseVersionId();
      let a = t;
      for (let l = 0, d = o.length; l < d; l++) {
        const h = o[l], [c] = kc(h.text);
        this._onDidChangeDecorations.fire();
        const u = h.range.startLineNumber, g = h.range.endLineNumber, p = g - u, f = c, _ = Math.min(p, f), v = f - p, b = s - a - v + u, C = b, w = b + f, y = this._decorationsTree.getInjectedTextInInterval(this, this.getOffsetAt(new W(C, 1)), this.getOffsetAt(new W(w, this.getLineMaxColumn(w))), 0), L = _a.fromDecorations(y), k = new Pd(L);
        for (let N = _; N >= 0; N--) {
          const A = u + N, B = b + N;
          k.takeFromEndWhile(((O) => O.lineNumber > B));
          const T = k.takeFromEndWhile(((O) => O.lineNumber === B));
          r.push(new c5(A, this.getLineContent(B), T));
        }
        if (_ < p) {
          const N = u + _;
          r.push(new QY(N + 1, g));
        }
        if (_ < f) {
          const N = new Pd(L), A = u + _, B = f - _, T = s - a - B + A + 1, O = [], H = [];
          for (let $ = 0; $ < B; $++) {
            const pe = T + $;
            H[$] = this.getLineContent(pe), N.takeWhile(((me) => me.lineNumber < pe)), O[$] = N.takeWhile(((me) => me.lineNumber === pe));
          }
          r.push(new JY(A + 1, u + f, H, O));
        }
        a += v;
      }
      this._emitContentChangedEvent(new am(r, this.getVersionId(), this._isUndoing, this._isRedoing), { changes: o, eol: this._buffer.getEOL(), isEolChange: !1, versionId: this.getVersionId(), isUndoing: this._isUndoing, isRedoing: this._isRedoing, isFlush: !1 });
    }
    return i.reverseEdits === null ? void 0 : i.reverseEdits;
  }
  undo() {
    return this._undoRedoService.undo(this.uri);
  }
  canUndo() {
    return this._undoRedoService.canUndo(this.uri);
  }
  redo() {
    return this._undoRedoService.redo(this.uri);
  }
  canRedo() {
    return this._undoRedoService.canRedo(this.uri);
  }
  handleBeforeFireDecorationsChangedEvent(n) {
    if (n === null || n.size === 0) return;
    const e = Array.from(n).map(((t) => new c5(t, this.getLineContent(t), this._getInjectedTextInLine(t))));
    this._onDidChangeInjectedText.fire(new $B(e));
  }
  changeDecorations(n, e = 0) {
    this._assertNotDisposed();
    try {
      return this._onDidChangeDecorations.beginDeferredEmit(), this._changeDecorations(e, n);
    } finally {
      this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _changeDecorations(n, e) {
    const t = { addDecoration: (s, o) => this._deltaDecorationsImpl(n, [], [{ range: s, options: o }])[0], changeDecoration: (s, o) => {
      this._changeDecorationImpl(s, o);
    }, changeDecorationOptions: (s, o) => {
      this._changeDecorationOptionsImpl(s, B5(o));
    }, removeDecoration: (s) => {
      this._deltaDecorationsImpl(n, [s], []);
    }, deltaDecorations: (s, o) => s.length === 0 && o.length === 0 ? [] : this._deltaDecorationsImpl(n, s, o) };
    let i = null;
    try {
      i = e(t);
    } catch (s) {
      We(s);
    }
    return t.addDecoration = Vf, t.changeDecoration = Vf, t.changeDecorationOptions = Vf, t.removeDecoration = Vf, t.deltaDecorations = Vf, i;
  }
  deltaDecorations(n, e, t = 0) {
    if (this._assertNotDisposed(), n || (n = []), n.length === 0 && e.length === 0) return [];
    try {
      return this._deltaDecorationCallCnt++, this._deltaDecorationCallCnt > 1 && (console.warn("Invoking deltaDecorations recursively could lead to leaking decorations."), We(new Error("Invoking deltaDecorations recursively could lead to leaking decorations."))), this._onDidChangeDecorations.beginDeferredEmit(), this._deltaDecorationsImpl(t, n, e);
    } finally {
      this._onDidChangeDecorations.endDeferredEmit(), this._deltaDecorationCallCnt--;
    }
  }
  _getTrackedRange(n) {
    return this.getDecorationRange(n);
  }
  _setTrackedRange(n, e, t) {
    const i = n ? this._decorations[n] : null;
    if (!i) return e ? this._deltaDecorationsImpl(0, [], [{ range: e, options: F5[t] }], !0)[0] : null;
    if (!e) return this._decorationsTree.delete(i), delete this._decorations[i.id], null;
    const s = this._validateRangeRelaxedNoAllocations(e), o = this._buffer.getOffsetAt(s.startLineNumber, s.startColumn), r = this._buffer.getOffsetAt(s.endLineNumber, s.endColumn);
    return this._decorationsTree.delete(i), i.reset(this.getVersionId(), o, r, s), i.setOptions(F5[t]), this._decorationsTree.insert(i), i.id;
  }
  removeAllDecorationsWithOwnerId(n) {
    if (this._isDisposed) return;
    const e = this._decorationsTree.collectNodesFromOwner(n);
    for (let t = 0, i = e.length; t < i; t++) {
      const s = e[t];
      this._decorationsTree.delete(s), delete this._decorations[s.id];
    }
  }
  getDecorationOptions(n) {
    const e = this._decorations[n];
    return e ? e.options : null;
  }
  getDecorationRange(n) {
    const e = this._decorations[n];
    return e ? this._decorationsTree.getNodeRange(this, e) : null;
  }
  getLineDecorations(n, e = 0, t = !1) {
    return n < 1 || n > this.getLineCount() ? [] : this.getLinesDecorations(n, n, e, t);
  }
  getLinesDecorations(n, e, t = 0, i = !1, s = !1) {
    const o = this.getLineCount(), r = Math.min(o, Math.max(1, n)), a = Math.min(o, Math.max(1, e)), l = this.getLineMaxColumn(a), d = new D(r, 1, a, l), h = this._getDecorationsInRange(d, t, i, s);
    return wN(h, this._decorationProvider.getDecorationsInRange(d, t, i)), h;
  }
  getDecorationsInRange(n, e = 0, t = !1, i = !1, s = !1) {
    const o = this.validateRange(n), r = this._getDecorationsInRange(o, e, t, s);
    return wN(r, this._decorationProvider.getDecorationsInRange(o, e, t, i)), r;
  }
  getOverviewRulerDecorations(n = 0, e = !1) {
    return this._decorationsTree.getAll(this, n, e, !0, !1);
  }
  getInjectedTextDecorations(n = 0) {
    return this._decorationsTree.getAllInjectedText(this, n);
  }
  _getInjectedTextInLine(n) {
    const e = this._buffer.getOffsetAt(n, 1), t = e + this._buffer.getLineLength(n), i = this._decorationsTree.getInjectedTextInInterval(this, e, t, 0);
    return _a.fromDecorations(i).filter(((s) => s.lineNumber === n));
  }
  getAllDecorations(n = 0, e = !1) {
    let t = this._decorationsTree.getAll(this, n, e, !1, !1);
    return t = t.concat(this._decorationProvider.getAllDecorations(n, e)), t;
  }
  getAllMarginDecorations(n = 0) {
    return this._decorationsTree.getAll(this, n, !1, !1, !0);
  }
  _getDecorationsInRange(n, e, t, i) {
    const s = this._buffer.getOffsetAt(n.startLineNumber, n.startColumn), o = this._buffer.getOffsetAt(n.endLineNumber, n.endColumn);
    return this._decorationsTree.getAllInInterval(this, s, o, e, t, i);
  }
  getRangeAt(n, e) {
    return this._buffer.getRangeAt(n, e - n);
  }
  _changeDecorationImpl(n, e) {
    const t = this._decorations[n];
    if (!t) return;
    if (t.options.after) {
      const r = this.getDecorationRange(n);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(r.endLineNumber);
    }
    if (t.options.before) {
      const r = this.getDecorationRange(n);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(r.startLineNumber);
    }
    const i = this._validateRangeRelaxedNoAllocations(e), s = this._buffer.getOffsetAt(i.startLineNumber, i.startColumn), o = this._buffer.getOffsetAt(i.endLineNumber, i.endColumn);
    this._decorationsTree.delete(t), t.reset(this.getVersionId(), s, o, i), this._decorationsTree.insert(t), this._onDidChangeDecorations.checkAffectedAndFire(t.options), t.options.after && this._onDidChangeDecorations.recordLineAffectedByInjectedText(i.endLineNumber), t.options.before && this._onDidChangeDecorations.recordLineAffectedByInjectedText(i.startLineNumber);
  }
  _changeDecorationOptionsImpl(n, e) {
    const t = this._decorations[n];
    if (!t) return;
    const i = !(!t.options.overviewRuler || !t.options.overviewRuler.color), s = !(!e.overviewRuler || !e.overviewRuler.color);
    if (this._onDidChangeDecorations.checkAffectedAndFire(t.options), this._onDidChangeDecorations.checkAffectedAndFire(e), t.options.after || e.after) {
      const a = this._decorationsTree.getNodeRange(this, t);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(a.endLineNumber);
    }
    if (t.options.before || e.before) {
      const a = this._decorationsTree.getNodeRange(this, t);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(a.startLineNumber);
    }
    const o = i !== s, r = (function(a) {
      return !!a.after || !!a.before;
    })(e) !== HC(t);
    o || r ? (this._decorationsTree.delete(t), t.setOptions(e), this._decorationsTree.insert(t)) : t.setOptions(e);
  }
  _deltaDecorationsImpl(n, e, t, i = !1) {
    const s = this.getVersionId(), o = e.length;
    let r = 0;
    const a = t.length;
    let l = 0;
    this._onDidChangeDecorations.beginDeferredEmit();
    try {
      const d = new Array(a);
      for (; r < o || l < a; ) {
        let h = null;
        if (r < o) {
          do
            h = this._decorations[e[r++]];
          while (!h && r < o);
          if (h) {
            if (h.options.after) {
              const c = this._decorationsTree.getNodeRange(this, h);
              this._onDidChangeDecorations.recordLineAffectedByInjectedText(c.endLineNumber);
            }
            if (h.options.before) {
              const c = this._decorationsTree.getNodeRange(this, h);
              this._onDidChangeDecorations.recordLineAffectedByInjectedText(c.startLineNumber);
            }
            this._decorationsTree.delete(h), i || this._onDidChangeDecorations.checkAffectedAndFire(h.options);
          }
        }
        if (l < a) {
          if (!h) {
            const _ = ++this._lastDecorationId, v = `${this._instanceId};${_}`;
            h = new sW(v, 0, 0), this._decorations[v] = h;
          }
          const c = t[l], u = this._validateRangeRelaxedNoAllocations(c.range), g = B5(c.options), p = this._buffer.getOffsetAt(u.startLineNumber, u.startColumn), f = this._buffer.getOffsetAt(u.endLineNumber, u.endColumn);
          h.ownerId = n, h.reset(s, p, f, u), h.setOptions(g), h.options.after && this._onDidChangeDecorations.recordLineAffectedByInjectedText(u.endLineNumber), h.options.before && this._onDidChangeDecorations.recordLineAffectedByInjectedText(u.startLineNumber), i || this._onDidChangeDecorations.checkAffectedAndFire(g), this._decorationsTree.insert(h), d[l] = h.id, l++;
        } else h && delete this._decorations[h.id];
      }
      return d;
    } finally {
      this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  getLanguageId() {
    return this.tokenization.getLanguageId();
  }
  setLanguage(n, e) {
    typeof n == "string" ? (this._languageSelectionListener.clear(), this._setLanguage(n, e)) : (this._languageSelectionListener.value = n.onDidChange((() => this._setLanguage(n.languageId, e))), this._setLanguage(n.languageId, e));
  }
  _setLanguage(n, e) {
    this.tokenization.setLanguageId(n, e), this._languageService.requestRichLanguageFeatures(n);
  }
  getLanguageIdAtPosition(n, e) {
    return this.tokenization.getLanguageIdAtPosition(n, e);
  }
  getWordAtPosition(n) {
    return this._tokenizationTextModelPart.getWordAtPosition(n);
  }
  getWordUntilPosition(n) {
    return this._tokenizationTextModelPart.getWordUntilPosition(n);
  }
  normalizePosition(n, e) {
    return n;
  }
  getLineIndentColumn(n) {
    return (function(e) {
      let t = 0;
      for (const i of e) {
        if (i !== " " && i !== "	") break;
        t++;
      }
      return t;
    })(this.getLineContent(n)) + 1;
  }
};
function ED(n) {
  return !(!n.options.overviewRuler || !n.options.overviewRuler.color);
}
function HC(n) {
  return !!n.options.after || !!n.options.before;
}
Pa._MODEL_SYNC_LIMIT = 52428800, Pa.LARGE_FILE_SIZE_THRESHOLD = 20971520, Pa.LARGE_FILE_LINE_COUNT_THRESHOLD = 3e5, Pa.LARGE_FILE_HEAP_OPERATION_THRESHOLD = 268435456, Pa.DEFAULT_CREATION_OPTIONS = { isForSimpleWidget: !1, tabSize: Wn.tabSize, indentSize: Wn.indentSize, insertSpaces: Wn.insertSpaces, detectIndentation: !1, defaultEOL: 1, trimAutoWhitespace: Wn.trimAutoWhitespace, largeFileOptimizations: Wn.largeFileOptimizations, bracketPairColorizationOptions: Wn.bracketPairColorizationOptions }, Pa = ou = KX([ND(4, gL), ND(5, Xt), ND(6, zt)], Pa);
class O5 {
  constructor() {
    this._decorationsTree0 = new kD(), this._decorationsTree1 = new kD(), this._injectedTextDecorationsTree = new kD();
  }
  ensureAllNodesHaveRanges(e) {
    this.getAll(e, 0, !1, !1, !1);
  }
  _ensureNodesHaveRanges(e, t) {
    for (const i of t) i.range === null && (i.range = e.getRangeAt(i.cachedAbsoluteStart, i.cachedAbsoluteEnd));
    return t;
  }
  getAllInInterval(e, t, i, s, o, r) {
    const a = e.getVersionId(), l = this._intervalSearch(t, i, s, o, a, r);
    return this._ensureNodesHaveRanges(e, l);
  }
  _intervalSearch(e, t, i, s, o, r) {
    const a = this._decorationsTree0.intervalSearch(e, t, i, s, o, r), l = this._decorationsTree1.intervalSearch(e, t, i, s, o, r), d = this._injectedTextDecorationsTree.intervalSearch(e, t, i, s, o, r);
    return a.concat(l).concat(d);
  }
  getInjectedTextInInterval(e, t, i, s) {
    const o = e.getVersionId(), r = this._injectedTextDecorationsTree.intervalSearch(t, i, s, !1, o, !1);
    return this._ensureNodesHaveRanges(e, r).filter(((a) => a.options.showIfCollapsed || !a.range.isEmpty()));
  }
  getAllInjectedText(e, t) {
    const i = e.getVersionId(), s = this._injectedTextDecorationsTree.search(t, !1, i, !1);
    return this._ensureNodesHaveRanges(e, s).filter(((o) => o.options.showIfCollapsed || !o.range.isEmpty()));
  }
  getAll(e, t, i, s, o) {
    const r = e.getVersionId(), a = this._search(t, i, s, r, o);
    return this._ensureNodesHaveRanges(e, a);
  }
  _search(e, t, i, s, o) {
    if (i) return this._decorationsTree1.search(e, t, s, o);
    {
      const r = this._decorationsTree0.search(e, t, s, o), a = this._decorationsTree1.search(e, t, s, o), l = this._injectedTextDecorationsTree.search(e, t, s, o);
      return r.concat(a).concat(l);
    }
  }
  collectNodesFromOwner(e) {
    const t = this._decorationsTree0.collectNodesFromOwner(e), i = this._decorationsTree1.collectNodesFromOwner(e), s = this._injectedTextDecorationsTree.collectNodesFromOwner(e);
    return t.concat(i).concat(s);
  }
  collectNodesPostOrder() {
    const e = this._decorationsTree0.collectNodesPostOrder(), t = this._decorationsTree1.collectNodesPostOrder(), i = this._injectedTextDecorationsTree.collectNodesPostOrder();
    return e.concat(t).concat(i);
  }
  insert(e) {
    HC(e) ? this._injectedTextDecorationsTree.insert(e) : ED(e) ? this._decorationsTree1.insert(e) : this._decorationsTree0.insert(e);
  }
  delete(e) {
    HC(e) ? this._injectedTextDecorationsTree.delete(e) : ED(e) ? this._decorationsTree1.delete(e) : this._decorationsTree0.delete(e);
  }
  getNodeRange(e, t) {
    const i = e.getVersionId();
    return t.cachedVersionId !== i && this._resolveNode(t, i), t.range === null && (t.range = e.getRangeAt(t.cachedAbsoluteStart, t.cachedAbsoluteEnd)), t.range;
  }
  _resolveNode(e, t) {
    HC(e) ? this._injectedTextDecorationsTree.resolveNode(e, t) : ED(e) ? this._decorationsTree1.resolveNode(e, t) : this._decorationsTree0.resolveNode(e, t);
  }
  acceptReplace(e, t, i, s) {
    this._decorationsTree0.acceptReplace(e, t, i, s), this._decorationsTree1.acceptReplace(e, t, i, s), this._injectedTextDecorationsTree.acceptReplace(e, t, i, s);
  }
}
function ka(n) {
  return n.replace(/[^a-z0-9\-_]/gi, " ");
}
class dW {
  constructor(e) {
    this.color = e.color || "", this.darkColor = e.darkColor || "";
  }
}
class qX extends dW {
  constructor(e) {
    super(e), this._resolvedColor = null, this.position = typeof e.position == "number" ? e.position : Do.Center;
  }
  getColor(e) {
    return this._resolvedColor || (e.type !== "light" && this.darkColor ? this._resolvedColor = this._resolveColor(this.darkColor, e) : this._resolvedColor = this._resolveColor(this.color, e)), this._resolvedColor;
  }
  invalidateCachedColor() {
    this._resolvedColor = null;
  }
  _resolveColor(e, t) {
    if (typeof e == "string") return e;
    const i = e ? t.getColor(e.id) : null;
    return i ? i.toString() : "";
  }
}
class $X {
  constructor(e) {
    var t;
    this.position = (t = e?.position) !== null && t !== void 0 ? t : _l.Center, this.persistLane = e?.persistLane;
  }
}
class GX extends dW {
  constructor(e) {
    var t, i;
    super(e), this.position = e.position, this.sectionHeaderStyle = (t = e.sectionHeaderStyle) !== null && t !== void 0 ? t : null, this.sectionHeaderText = (i = e.sectionHeaderText) !== null && i !== void 0 ? i : null;
  }
  getColor(e) {
    return this._resolvedColor || (e.type !== "light" && this.darkColor ? this._resolvedColor = this._resolveColor(this.darkColor, e) : this._resolvedColor = this._resolveColor(this.color, e)), this._resolvedColor;
  }
  invalidateCachedColor() {
    this._resolvedColor = void 0;
  }
  _resolveColor(e, t) {
    return typeof e == "string" ? z.fromHex(e) : t.getColor(e.id);
  }
}
class xc {
  static from(e) {
    return e instanceof xc ? e : new xc(e);
  }
  constructor(e) {
    this.content = e.content || "", this.inlineClassName = e.inlineClassName || null, this.inlineClassNameAffectsLetterSpacing = e.inlineClassNameAffectsLetterSpacing || !1, this.attachedData = e.attachedData || null, this.cursorStops = e.cursorStops || null;
  }
}
class Ve {
  static register(e) {
    return new Ve(e);
  }
  static createDynamic(e) {
    return new Ve(e);
  }
  constructor(e) {
    var t, i, s, o, r, a;
    this.description = e.description, this.blockClassName = e.blockClassName ? ka(e.blockClassName) : null, this.blockDoesNotCollapse = (t = e.blockDoesNotCollapse) !== null && t !== void 0 ? t : null, this.blockIsAfterEnd = (i = e.blockIsAfterEnd) !== null && i !== void 0 ? i : null, this.blockPadding = (s = e.blockPadding) !== null && s !== void 0 ? s : null, this.stickiness = e.stickiness || 0, this.zIndex = e.zIndex || 0, this.className = e.className ? ka(e.className) : null, this.shouldFillLineOnLineBreak = (o = e.shouldFillLineOnLineBreak) !== null && o !== void 0 ? o : null, this.hoverMessage = e.hoverMessage || null, this.glyphMarginHoverMessage = e.glyphMarginHoverMessage || null, this.lineNumberHoverMessage = e.lineNumberHoverMessage || null, this.isWholeLine = e.isWholeLine || !1, this.showIfCollapsed = e.showIfCollapsed || !1, this.collapseOnReplaceEdit = e.collapseOnReplaceEdit || !1, this.overviewRuler = e.overviewRuler ? new qX(e.overviewRuler) : null, this.minimap = e.minimap ? new GX(e.minimap) : null, this.glyphMargin = e.glyphMarginClassName ? new $X(e.glyphMargin) : null, this.glyphMarginClassName = e.glyphMarginClassName ? ka(e.glyphMarginClassName) : null, this.linesDecorationsClassName = e.linesDecorationsClassName ? ka(e.linesDecorationsClassName) : null, this.lineNumberClassName = e.lineNumberClassName ? ka(e.lineNumberClassName) : null, this.linesDecorationsTooltip = e.linesDecorationsTooltip ? e.linesDecorationsTooltip.replace(/[<>"'&]/g, ((l) => {
      switch (l) {
        case "<":
          return "&lt;";
        case ">":
          return "&gt;";
        case '"':
          return "&quot;";
        case "'":
          return "&apos;";
        case "&":
          return "&amp;";
      }
      return l;
    })) : null, this.firstLineDecorationClassName = e.firstLineDecorationClassName ? ka(e.firstLineDecorationClassName) : null, this.marginClassName = e.marginClassName ? ka(e.marginClassName) : null, this.inlineClassName = e.inlineClassName ? ka(e.inlineClassName) : null, this.inlineClassNameAffectsLetterSpacing = e.inlineClassNameAffectsLetterSpacing || !1, this.beforeContentClassName = e.beforeContentClassName ? ka(e.beforeContentClassName) : null, this.afterContentClassName = e.afterContentClassName ? ka(e.afterContentClassName) : null, this.after = e.after ? xc.from(e.after) : null, this.before = e.before ? xc.from(e.before) : null, this.hideInCommentTokens = (r = e.hideInCommentTokens) !== null && r !== void 0 && r, this.hideInStringTokens = (a = e.hideInStringTokens) !== null && a !== void 0 && a;
  }
}
Ve.EMPTY = Ve.register({ description: "empty" });
const F5 = [Ve.register({ description: "tracked-range-always-grows-when-typing-at-edges", stickiness: 0 }), Ve.register({ description: "tracked-range-never-grows-when-typing-at-edges", stickiness: 1 }), Ve.register({ description: "tracked-range-grows-only-when-typing-before", stickiness: 2 }), Ve.register({ description: "tracked-range-grows-only-when-typing-after", stickiness: 3 })];
function B5(n) {
  return n instanceof Ve ? n : Ve.createDynamic(n);
}
class ZX extends V {
  constructor(e) {
    super(), this.handleBeforeFire = e, this._actual = this._register(new F()), this.event = this._actual.event, this._affectedInjectedTextLines = null, this._deferredCnt = 0, this._shouldFireDeferred = !1, this._affectsMinimap = !1, this._affectsOverviewRuler = !1, this._affectsGlyphMargin = !1, this._affectsLineNumber = !1;
  }
  beginDeferredEmit() {
    this._deferredCnt++;
  }
  endDeferredEmit() {
    var e;
    this._deferredCnt--, this._deferredCnt === 0 && (this._shouldFireDeferred && this.doFire(), (e = this._affectedInjectedTextLines) === null || e === void 0 || e.clear(), this._affectedInjectedTextLines = null);
  }
  recordLineAffectedByInjectedText(e) {
    this._affectedInjectedTextLines || (this._affectedInjectedTextLines = /* @__PURE__ */ new Set()), this._affectedInjectedTextLines.add(e);
  }
  checkAffectedAndFire(e) {
    var t, i;
    this._affectsMinimap || (this._affectsMinimap = !!(!((t = e.minimap) === null || t === void 0) && t.position)), this._affectsOverviewRuler || (this._affectsOverviewRuler = !!(!((i = e.overviewRuler) === null || i === void 0) && i.color)), this._affectsGlyphMargin || (this._affectsGlyphMargin = !!e.glyphMarginClassName), this._affectsLineNumber || (this._affectsLineNumber = !!e.lineNumberClassName), this.tryFire();
  }
  fire() {
    this._affectsMinimap = !0, this._affectsOverviewRuler = !0, this._affectsGlyphMargin = !0, this.tryFire();
  }
  tryFire() {
    this._deferredCnt === 0 ? this.doFire() : this._shouldFireDeferred = !0;
  }
  doFire() {
    this.handleBeforeFire(this._affectedInjectedTextLines);
    const e = { affectsMinimap: this._affectsMinimap, affectsOverviewRuler: this._affectsOverviewRuler, affectsGlyphMargin: this._affectsGlyphMargin, affectsLineNumber: this._affectsLineNumber };
    this._shouldFireDeferred = !1, this._affectsMinimap = !1, this._affectsOverviewRuler = !1, this._affectsGlyphMargin = !1, this._actual.fire(e);
  }
}
class YX extends V {
  constructor() {
    super(), this._fastEmitter = this._register(new F()), this.fastEvent = this._fastEmitter.event, this._slowEmitter = this._register(new F()), this.slowEvent = this._slowEmitter.event, this._deferredCnt = 0, this._deferredEvent = null;
  }
  beginDeferredEmit() {
    this._deferredCnt++;
  }
  endDeferredEmit(e = null) {
    if (this._deferredCnt--, this._deferredCnt === 0 && this._deferredEvent !== null) {
      this._deferredEvent.rawContentChangedEvent.resultingSelection = e;
      const t = this._deferredEvent;
      this._deferredEvent = null, this._fastEmitter.fire(t), this._slowEmitter.fire(t);
    }
  }
  fire(e) {
    this._deferredCnt > 0 ? this._deferredEvent ? this._deferredEvent = this._deferredEvent.merge(e) : this._deferredEvent = e : (this._fastEmitter.fire(e), this._slowEmitter.fire(e));
  }
}
class XX {
  constructor() {
    this._onDidChangeVisibleRanges = new F(), this.onDidChangeVisibleRanges = this._onDidChangeVisibleRanges.event, this._views = /* @__PURE__ */ new Set();
  }
  attachView() {
    const e = new QX(((t) => {
      this._onDidChangeVisibleRanges.fire({ view: e, state: t });
    }));
    return this._views.add(e), e;
  }
  detachView(e) {
    this._views.delete(e), this._onDidChangeVisibleRanges.fire({ view: e, state: void 0 });
  }
}
class QX {
  constructor(e) {
    this.handleStateChange = e;
  }
  setVisibleLines(e, t) {
    const i = e.map(((s) => new je(s.startLineNumber, s.endLineNumber + 1)));
    this.handleStateChange({ visibleLineRanges: i, stabilized: t });
  }
}
class nA {
  static create(e) {
    return new nA(e.get(134), e.get(133));
  }
  constructor(e, t) {
    this.classifier = new JX(e, t);
  }
  createLineBreaksComputer(e, t, i, s, o) {
    const r = [], a = [], l = [];
    return { addRequest: (d, h, c) => {
      r.push(d), a.push(h), l.push(c);
    }, finalize: () => {
      const d = e.typicalFullwidthCharacterWidth / e.typicalHalfwidthCharacterWidth, h = [];
      for (let c = 0, u = r.length; c < u; c++) {
        const g = a[c], p = l[c];
        !p || p.injectionOptions || g ? h[c] = tQ(this.classifier, r[c], g, t, i, d, s, o) : h[c] = eQ(this.classifier, p, r[c], t, i, d, s, o);
      }
      return fI.length = 0, _I.length = 0, h;
    } };
  }
}
class JX extends mf {
  constructor(e, t) {
    super(0);
    for (let i = 0; i < e.length; i++) this.set(e.charCodeAt(i), 1);
    for (let i = 0; i < t.length; i++) this.set(t.charCodeAt(i), 2);
  }
  get(e) {
    return e >= 0 && e < 256 ? this._asciiMap[e] : e >= 12352 && e <= 12543 || e >= 13312 && e <= 19903 || e >= 19968 && e <= 40959 ? 3 : this._map.get(e) || this._defaultValue;
  }
}
let fI = [], _I = [];
function eQ(n, e, t, i, s, o, r, a) {
  if (s === -1) return null;
  const l = t.length;
  if (l <= 1) return null;
  const d = a === "keepAll", h = e.breakOffsets, c = e.breakOffsetsVisibleColumn, u = hW(t, i, s, o, r), g = s - u, p = fI, f = _I;
  let _ = 0, v = 0, b = 0, C = s;
  const w = h.length;
  let y = 0;
  if (y >= 0) {
    let L = Math.abs(c[y] - C);
    for (; y + 1 < w; ) {
      const k = Math.abs(c[y + 1] - C);
      if (k >= L) break;
      L = k, y++;
    }
  }
  for (; y < w; ) {
    let L = y < 0 ? 0 : h[y], k = y < 0 ? 0 : c[y];
    v > L && (L = v, k = b);
    let N = 0, A = 0, B = 0, T = 0;
    if (k <= C) {
      let H = k, $ = L === 0 ? 0 : t.charCodeAt(L - 1), pe = L === 0 ? 0 : n.get($), me = !0;
      for (let ue = L; ue < l; ue++) {
        const ee = ue, te = t.charCodeAt(ue);
        let be, we;
        if (en(te) ? (ue++, be = 0, we = 2) : (be = n.get(te), we = h0(te, H, i, o)), ee > v && vI($, pe, te, be, d) && (N = ee, A = H), H += we, H > C) {
          ee > v ? (B = ee, T = H - we) : (B = ue + 1, T = H), H - A > g && (N = 0), me = !1;
          break;
        }
        $ = te, pe = be;
      }
      if (me) {
        _ > 0 && (p[_] = h[h.length - 1], f[_] = c[h.length - 1], _++);
        break;
      }
    }
    if (N === 0) {
      let H = k, $ = t.charCodeAt(L), pe = n.get($), me = !1;
      for (let ue = L - 1; ue >= v; ue--) {
        const ee = ue + 1, te = t.charCodeAt(ue);
        if (te === 9) {
          me = !0;
          break;
        }
        let be, we;
        if (og(te) ? (ue--, be = 0, we = 2) : (be = n.get(te), we = fc(te) ? o : 1), H <= C) {
          if (B === 0 && (B = ee, T = H), H <= C - g) break;
          if (vI(te, be, $, pe, d)) {
            N = ee, A = H;
            break;
          }
        }
        H -= we, $ = te, pe = be;
      }
      if (N !== 0) {
        const ue = g - (T - A);
        if (ue <= i) {
          const ee = t.charCodeAt(B);
          let te;
          te = en(ee) ? 2 : h0(ee, T, i, o), ue - te < 0 && (N = 0);
        }
      }
      if (me) {
        y--;
        continue;
      }
    }
    if (N === 0 && (N = B, A = T), N <= v) {
      const H = t.charCodeAt(v);
      en(H) ? (N = v + 2, A = b + 2) : (N = v + 1, A = b + h0(H, b, i, o));
    }
    for (v = N, p[_] = N, b = A, f[_] = A, _++, C = A + g; y < 0 || y < w && c[y] < A; ) y++;
    let O = Math.abs(c[y] - C);
    for (; y + 1 < w; ) {
      const H = Math.abs(c[y + 1] - C);
      if (H >= O) break;
      O = H, y++;
    }
  }
  return _ === 0 ? null : (p.length = _, f.length = _, fI = e.breakOffsets, _I = e.breakOffsetsVisibleColumn, e.breakOffsets = p, e.breakOffsetsVisibleColumn = f, e.wrappedTextIndentLength = u, e);
}
function tQ(n, e, t, i, s, o, r, a) {
  const l = _a.applyInjectedText(e, t);
  let d, h;
  if (t && t.length > 0 ? (d = t.map(((A) => A.options)), h = t.map(((A) => A.column - 1))) : (d = null, h = null), s === -1) return d ? new o0(h, d, [l.length], [], 0) : null;
  const c = l.length;
  if (c <= 1) return d ? new o0(h, d, [l.length], [], 0) : null;
  const u = a === "keepAll", g = hW(l, i, s, o, r), p = s - g, f = [], _ = [];
  let v = 0, b = 0, C = 0, w = s, y = l.charCodeAt(0), L = n.get(y), k = h0(y, 0, i, o), N = 1;
  en(y) && (k += 1, y = l.charCodeAt(1), L = n.get(y), N++);
  for (let A = N; A < c; A++) {
    const B = A, T = l.charCodeAt(A);
    let O, H;
    en(T) ? (A++, O = 0, H = 2) : (O = n.get(T), H = h0(T, k, i, o)), vI(y, L, T, O, u) && (b = B, C = k), k += H, k > w && ((b === 0 || k - C > p) && (b = B, C = k - H), f[v] = b, _[v] = C, v++, w = C + p, b = 0), y = T, L = O;
  }
  return v !== 0 || t && t.length !== 0 ? (f[v] = c, _[v] = k, new o0(h, d, f, _, g)) : null;
}
function h0(n, e, t, i) {
  return n === 9 ? t - e % t : fc(n) || n < 32 ? i : 1;
}
function W5(n, e) {
  return e - n % e;
}
function vI(n, e, t, i, s) {
  return t !== 32 && (e === 2 && i !== 2 || e !== 1 && i === 1 || !s && e === 3 && i !== 2 || !s && i === 3 && e !== 1);
}
function hW(n, e, t, i, s) {
  let o = 0;
  if (s !== 0) {
    const r = Jn(n);
    if (r !== -1) {
      for (let l = 0; l < r; l++)
        o += n.charCodeAt(l) === 9 ? W5(o, e) : 1;
      const a = s === 3 ? 2 : s === 2 ? 1 : 0;
      for (let l = 0; l < a; l++)
        o += W5(o, e);
      o + i > t && (o = 0);
    }
  }
  return o;
}
class _y {
  constructor(e) {
    this._selTrackedRange = null, this._trackSelection = !0, this._setState(e, new bn(new D(1, 1, 1, 1), 0, 0, new W(1, 1), 0), new bn(new D(1, 1, 1, 1), 0, 0, new W(1, 1), 0));
  }
  dispose(e) {
    this._removeTrackedRange(e);
  }
  startTrackingSelection(e) {
    this._trackSelection = !0, this._updateTrackedRange(e);
  }
  stopTrackingSelection(e) {
    this._trackSelection = !1, this._removeTrackedRange(e);
  }
  _updateTrackedRange(e) {
    this._trackSelection && (this._selTrackedRange = e.model._setTrackedRange(this._selTrackedRange, this.modelState.selection, 0));
  }
  _removeTrackedRange(e) {
    this._selTrackedRange = e.model._setTrackedRange(this._selTrackedRange, null, 0);
  }
  asCursorState() {
    return new pt(this.modelState, this.viewState);
  }
  readSelectionFromMarkers(e) {
    const t = e.model._getTrackedRange(this._selTrackedRange);
    return this.modelState.selection.isEmpty() && !t.isEmpty() ? _e.fromRange(t.collapseToEnd(), this.modelState.selection.getDirection()) : _e.fromRange(t, this.modelState.selection.getDirection());
  }
  ensureValidState(e) {
    this._setState(e, this.modelState, this.viewState);
  }
  setState(e, t, i) {
    this._setState(e, t, i);
  }
  static _validatePositionWithCache(e, t, i, s) {
    return t.equals(i) ? s : e.normalizePosition(t, 2);
  }
  static _validateViewState(e, t) {
    const i = t.position, s = t.selectionStart.getStartPosition(), o = t.selectionStart.getEndPosition(), r = e.normalizePosition(i, 2), a = this._validatePositionWithCache(e, s, i, r), l = this._validatePositionWithCache(e, o, s, a);
    return i.equals(r) && s.equals(a) && o.equals(l) ? t : new bn(D.fromPositions(a, l), t.selectionStartKind, t.selectionStartLeftoverVisibleColumns + s.column - a.column, r, t.leftoverVisibleColumns + i.column - r.column);
  }
  _setState(e, t, i) {
    if (i && (i = _y._validateViewState(e.viewModel, i)), t) {
      const s = e.model.validateRange(t.selectionStart), o = t.selectionStart.equalsRange(s) ? t.selectionStartLeftoverVisibleColumns : 0, r = e.model.validatePosition(t.position), a = t.position.equals(r) ? t.leftoverVisibleColumns : 0;
      t = new bn(s, t.selectionStartKind, o, r, a);
    } else {
      if (!i) return;
      const s = e.model.validateRange(e.coordinatesConverter.convertViewRangeToModelRange(i.selectionStart)), o = e.model.validatePosition(e.coordinatesConverter.convertViewPositionToModelPosition(i.position));
      t = new bn(s, i.selectionStartKind, i.selectionStartLeftoverVisibleColumns, o, i.leftoverVisibleColumns);
    }
    if (i) {
      const s = e.coordinatesConverter.validateViewRange(i.selectionStart, t.selectionStart), o = e.coordinatesConverter.validateViewPosition(i.position, t.position);
      i = new bn(s, t.selectionStartKind, t.selectionStartLeftoverVisibleColumns, o, t.leftoverVisibleColumns);
    } else {
      const s = e.coordinatesConverter.convertModelPositionToViewPosition(new W(t.selectionStart.startLineNumber, t.selectionStart.startColumn)), o = e.coordinatesConverter.convertModelPositionToViewPosition(new W(t.selectionStart.endLineNumber, t.selectionStart.endColumn)), r = new D(s.lineNumber, s.column, o.lineNumber, o.column), a = e.coordinatesConverter.convertModelPositionToViewPosition(t.position);
      i = new bn(r, t.selectionStartKind, t.selectionStartLeftoverVisibleColumns, a, t.leftoverVisibleColumns);
    }
    this.modelState = t, this.viewState = i, this._updateTrackedRange(e);
  }
}
class V5 {
  constructor(e) {
    this.context = e, this.cursors = [new _y(e)], this.lastAddedCursorIndex = 0;
  }
  dispose() {
    for (const e of this.cursors) e.dispose(this.context);
  }
  startTrackingSelections() {
    for (const e of this.cursors) e.startTrackingSelection(this.context);
  }
  stopTrackingSelections() {
    for (const e of this.cursors) e.stopTrackingSelection(this.context);
  }
  updateContext(e) {
    this.context = e;
  }
  ensureValidState() {
    for (const e of this.cursors) e.ensureValidState(this.context);
  }
  readSelectionFromMarkers() {
    return this.cursors.map(((e) => e.readSelectionFromMarkers(this.context)));
  }
  getAll() {
    return this.cursors.map(((e) => e.asCursorState()));
  }
  getViewPositions() {
    return this.cursors.map(((e) => e.viewState.position));
  }
  getTopMostViewPosition() {
    return (function(e, t) {
      return kR(e, ((i, s) => -t(i, s)));
    })(this.cursors, jo(((e) => e.viewState.position), W.compare)).viewState.position;
  }
  getBottomMostViewPosition() {
    return (function(e, t) {
      if (e.length === 0) return;
      let i = e[0];
      for (let s = 1; s < e.length; s++) {
        const o = e[s];
        t(o, i) >= 0 && (i = o);
      }
      return i;
    })(this.cursors, jo(((e) => e.viewState.position), W.compare)).viewState.position;
  }
  getSelections() {
    return this.cursors.map(((e) => e.modelState.selection));
  }
  getViewSelections() {
    return this.cursors.map(((e) => e.viewState.selection));
  }
  setSelections(e) {
    this.setStates(pt.fromModelSelections(e));
  }
  getPrimaryCursor() {
    return this.cursors[0].asCursorState();
  }
  setStates(e) {
    e !== null && (this.cursors[0].setState(this.context, e[0].modelState, e[0].viewState), this._setSecondaryStates(e.slice(1)));
  }
  _setSecondaryStates(e) {
    const t = this.cursors.length - 1, i = e.length;
    if (t < i) {
      const s = i - t;
      for (let o = 0; o < s; o++) this._addSecondaryCursor();
    } else if (t > i) {
      const s = t - i;
      for (let o = 0; o < s; o++) this._removeSecondaryCursor(this.cursors.length - 2);
    }
    for (let s = 0; s < i; s++) this.cursors[s + 1].setState(this.context, e[s].modelState, e[s].viewState);
  }
  killSecondaryCursors() {
    this._setSecondaryStates([]);
  }
  _addSecondaryCursor() {
    this.cursors.push(new _y(this.context)), this.lastAddedCursorIndex = this.cursors.length - 1;
  }
  getLastAddedCursorIndex() {
    return this.cursors.length === 1 || this.lastAddedCursorIndex === 0 ? 0 : this.lastAddedCursorIndex;
  }
  _removeSecondaryCursor(e) {
    this.lastAddedCursorIndex >= e + 1 && this.lastAddedCursorIndex--, this.cursors[e + 1].dispose(this.context), this.cursors.splice(e + 1, 1);
  }
  normalize() {
    if (this.cursors.length === 1) return;
    const e = this.cursors.slice(0), t = [];
    for (let i = 0, s = e.length; i < s; i++) t.push({ index: i, selection: e[i].modelState.selection });
    t.sort(jo(((i) => i.selection), D.compareRangesUsingStarts));
    for (let i = 0; i < t.length - 1; i++) {
      const s = t[i], o = t[i + 1], r = s.selection, a = o.selection;
      if (!this.context.cursorConfig.multiCursorMergeOverlapping) continue;
      let l;
      if (l = a.isEmpty() || r.isEmpty() ? a.getStartPosition().isBeforeOrEqual(r.getEndPosition()) : a.getStartPosition().isBefore(r.getEndPosition()), l) {
        const d = s.index < o.index ? i : i + 1, h = s.index < o.index ? i + 1 : i, c = t[h].index, u = t[d].index, g = t[h].selection, p = t[d].selection;
        if (!g.equalsSelection(p)) {
          const f = g.plusRange(p), _ = g.selectionStartLineNumber === g.startLineNumber && g.selectionStartColumn === g.startColumn, v = p.selectionStartLineNumber === p.startLineNumber && p.selectionStartColumn === p.startColumn;
          let b, C;
          c === this.lastAddedCursorIndex ? (b = _, this.lastAddedCursorIndex = u) : b = v, C = b ? new _e(f.startLineNumber, f.startColumn, f.endLineNumber, f.endColumn) : new _e(f.endLineNumber, f.endColumn, f.startLineNumber, f.startColumn), t[d].selection = C;
          const w = pt.fromModelSelection(C);
          e[u].setState(this.context, w.modelState, w.viewState);
        }
        for (const f of t) f.index > c && f.index--;
        e.splice(c, 1), t.splice(h, 1), this._removeSecondaryCursor(c - 1), i--;
      }
    }
  }
}
class H5 {
  constructor(e, t, i, s) {
    this._cursorContextBrand = void 0, this.model = e, this.viewModel = t, this.coordinatesConverter = i, this.cursorConfig = s;
  }
}
class iQ {
  constructor() {
    this.type = 0;
  }
}
class nQ {
  constructor() {
    this.type = 1;
  }
}
class sQ {
  constructor(e) {
    this.type = 2, this._source = e;
  }
  hasChanged(e) {
    return this._source.hasChanged(e);
  }
}
class oQ {
  constructor(e, t, i) {
    this.selections = e, this.modelSelections = t, this.reason = i, this.type = 3;
  }
}
class Uc {
  constructor(e) {
    this.type = 4, e ? (this.affectsMinimap = e.affectsMinimap, this.affectsOverviewRuler = e.affectsOverviewRuler, this.affectsGlyphMargin = e.affectsGlyphMargin, this.affectsLineNumber = e.affectsLineNumber) : (this.affectsMinimap = !0, this.affectsOverviewRuler = !0, this.affectsGlyphMargin = !0, this.affectsLineNumber = !0);
  }
}
class Sb {
  constructor() {
    this.type = 5;
  }
}
class rQ {
  constructor(e) {
    this.type = 6, this.isFocused = e;
  }
}
class aQ {
  constructor() {
    this.type = 7;
  }
}
class Lb {
  constructor() {
    this.type = 8;
  }
}
class cW {
  constructor(e, t) {
    this.fromLineNumber = e, this.count = t, this.type = 9;
  }
}
class bI {
  constructor(e, t) {
    this.type = 10, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class CI {
  constructor(e, t) {
    this.type = 11, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class c0 {
  constructor(e, t, i, s, o, r, a) {
    this.source = e, this.minimalReveal = t, this.range = i, this.selections = s, this.verticalType = o, this.revealHorizontal = r, this.scrollType = a, this.type = 12;
  }
}
class lQ {
  constructor(e) {
    this.type = 13, this.scrollWidth = e.scrollWidth, this.scrollLeft = e.scrollLeft, this.scrollHeight = e.scrollHeight, this.scrollTop = e.scrollTop, this.scrollWidthChanged = e.scrollWidthChanged, this.scrollLeftChanged = e.scrollLeftChanged, this.scrollHeightChanged = e.scrollHeightChanged, this.scrollTopChanged = e.scrollTopChanged;
  }
}
class dQ {
  constructor(e) {
    this.theme = e, this.type = 14;
  }
}
class hQ {
  constructor(e) {
    this.type = 15, this.ranges = e;
  }
}
class cQ {
  constructor() {
    this.type = 16;
  }
}
let uQ = class {
  constructor() {
    this.type = 17;
  }
};
class gQ extends V {
  constructor() {
    super(), this._onEvent = this._register(new F()), this.onEvent = this._onEvent.event, this._eventHandlers = [], this._viewEventQueue = null, this._isConsumingViewEventQueue = !1, this._collector = null, this._collectorCnt = 0, this._outgoingEvents = [];
  }
  emitOutgoingEvent(e) {
    this._addOutgoingEvent(e), this._emitOutgoingEvents();
  }
  _addOutgoingEvent(e) {
    for (let t = 0, i = this._outgoingEvents.length; t < i; t++) {
      const s = this._outgoingEvents[t].kind === e.kind ? this._outgoingEvents[t].attemptToMerge(e) : null;
      if (s) return void (this._outgoingEvents[t] = s);
    }
    this._outgoingEvents.push(e);
  }
  _emitOutgoingEvents() {
    for (; this._outgoingEvents.length > 0; ) {
      if (this._collector || this._isConsumingViewEventQueue) return;
      const e = this._outgoingEvents.shift();
      e.isNoOp() || this._onEvent.fire(e);
    }
  }
  addViewEventHandler(e) {
    for (let t = 0, i = this._eventHandlers.length; t < i; t++) this._eventHandlers[t] === e && console.warn("Detected duplicate listener in ViewEventDispatcher", e);
    this._eventHandlers.push(e);
  }
  removeViewEventHandler(e) {
    for (let t = 0; t < this._eventHandlers.length; t++) if (this._eventHandlers[t] === e) {
      this._eventHandlers.splice(t, 1);
      break;
    }
  }
  beginEmitViewEvents() {
    return this._collectorCnt++, this._collectorCnt === 1 && (this._collector = new pQ()), this._collector;
  }
  endEmitViewEvents() {
    if (this._collectorCnt--, this._collectorCnt === 0) {
      const e = this._collector.outgoingEvents, t = this._collector.viewEvents;
      this._collector = null;
      for (const i of e) this._addOutgoingEvent(i);
      t.length > 0 && this._emitMany(t);
    }
    this._emitOutgoingEvents();
  }
  emitSingleViewEvent(e) {
    try {
      this.beginEmitViewEvents().emitViewEvent(e);
    } finally {
      this.endEmitViewEvents();
    }
  }
  _emitMany(e) {
    this._viewEventQueue ? this._viewEventQueue = this._viewEventQueue.concat(e) : this._viewEventQueue = e, this._isConsumingViewEventQueue || this._consumeViewEventQueue();
  }
  _consumeViewEventQueue() {
    try {
      this._isConsumingViewEventQueue = !0, this._doConsumeQueue();
    } finally {
      this._isConsumingViewEventQueue = !1;
    }
  }
  _doConsumeQueue() {
    for (; this._viewEventQueue; ) {
      const e = this._viewEventQueue;
      this._viewEventQueue = null;
      const t = this._eventHandlers.slice(0);
      for (const i of t) i.handleEvents(e);
    }
  }
}
class pQ {
  constructor() {
    this.viewEvents = [], this.outgoingEvents = [];
  }
  emitViewEvent(e) {
    this.viewEvents.push(e);
  }
  emitOutgoingEvent(e) {
    this.outgoingEvents.push(e);
  }
}
class sA {
  constructor(e, t, i, s) {
    this.kind = 0, this._oldContentWidth = e, this._oldContentHeight = t, this.contentWidth = i, this.contentHeight = s, this.contentWidthChanged = this._oldContentWidth !== this.contentWidth, this.contentHeightChanged = this._oldContentHeight !== this.contentHeight;
  }
  isNoOp() {
    return !this.contentWidthChanged && !this.contentHeightChanged;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new sA(this._oldContentWidth, this._oldContentHeight, e.contentWidth, e.contentHeight);
  }
}
class oA {
  constructor(e, t) {
    this.kind = 1, this.oldHasFocus = e, this.hasFocus = t;
  }
  isNoOp() {
    return this.oldHasFocus === this.hasFocus;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new oA(this.oldHasFocus, e.hasFocus);
  }
}
class rA {
  constructor(e, t, i, s, o, r, a, l) {
    this.kind = 2, this._oldScrollWidth = e, this._oldScrollLeft = t, this._oldScrollHeight = i, this._oldScrollTop = s, this.scrollWidth = o, this.scrollLeft = r, this.scrollHeight = a, this.scrollTop = l, this.scrollWidthChanged = this._oldScrollWidth !== this.scrollWidth, this.scrollLeftChanged = this._oldScrollLeft !== this.scrollLeft, this.scrollHeightChanged = this._oldScrollHeight !== this.scrollHeight, this.scrollTopChanged = this._oldScrollTop !== this.scrollTop;
  }
  isNoOp() {
    return !(this.scrollWidthChanged || this.scrollLeftChanged || this.scrollHeightChanged || this.scrollTopChanged);
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new rA(this._oldScrollWidth, this._oldScrollLeft, this._oldScrollHeight, this._oldScrollTop, e.scrollWidth, e.scrollLeft, e.scrollHeight, e.scrollTop);
  }
}
class mQ {
  constructor() {
    this.kind = 3;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class fQ {
  constructor() {
    this.kind = 4;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class vy {
  constructor(e, t, i, s, o, r, a) {
    this.kind = 6, this.oldSelections = e, this.selections = t, this.oldModelVersionId = i, this.modelVersionId = s, this.source = o, this.reason = r, this.reachedMaxCursorCount = a;
  }
  static _selectionsAreEqual(e, t) {
    if (!e && !t) return !0;
    if (!e || !t) return !1;
    const i = e.length;
    if (i !== t.length) return !1;
    for (let s = 0; s < i; s++) if (!e[s].equalsSelection(t[s])) return !1;
    return !0;
  }
  isNoOp() {
    return vy._selectionsAreEqual(this.oldSelections, this.selections) && this.oldModelVersionId === this.modelVersionId;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new vy(this.oldSelections, e.selections, this.oldModelVersionId, e.modelVersionId, e.source, e.reason, this.reachedMaxCursorCount || e.reachedMaxCursorCount);
  }
}
class _Q {
  constructor() {
    this.kind = 5;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class vQ {
  constructor(e) {
    this.event = e, this.kind = 7;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class bQ {
  constructor(e) {
    this.event = e, this.kind = 8;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class CQ {
  constructor(e) {
    this.event = e, this.kind = 9;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class wQ {
  constructor(e) {
    this.event = e, this.kind = 10;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class yQ {
  constructor(e) {
    this.event = e, this.kind = 11;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class SQ {
  constructor(e) {
    this.event = e, this.kind = 12;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class LQ extends V {
  constructor(e, t, i, s) {
    super(), this._model = e, this._knownModelVersionId = this._model.getVersionId(), this._viewModel = t, this._coordinatesConverter = i, this.context = new H5(this._model, this._viewModel, this._coordinatesConverter, s), this._cursors = new V5(this.context), this._hasFocus = !1, this._isHandling = !1, this._compositionState = null, this._columnSelectData = null, this._autoClosedActions = [], this._prevEditOperationType = 0;
  }
  dispose() {
    this._cursors.dispose(), this._autoClosedActions = Ht(this._autoClosedActions), super.dispose();
  }
  updateConfiguration(e) {
    this.context = new H5(this._model, this._viewModel, this._coordinatesConverter, e), this._cursors.updateContext(this.context);
  }
  onLineMappingChanged(e) {
    this._knownModelVersionId === this._model.getVersionId() && this.setStates(e, "viewModel", 0, this.getCursorStates());
  }
  setHasFocus(e) {
    this._hasFocus = e;
  }
  _validateAutoClosedActions() {
    if (this._autoClosedActions.length > 0) {
      const e = this._cursors.getSelections();
      for (let t = 0; t < this._autoClosedActions.length; t++) {
        const i = this._autoClosedActions[t];
        i.isValid(e) || (i.dispose(), this._autoClosedActions.splice(t, 1), t--);
      }
    }
  }
  getPrimaryCursorState() {
    return this._cursors.getPrimaryCursor();
  }
  getLastAddedCursorIndex() {
    return this._cursors.getLastAddedCursorIndex();
  }
  getCursorStates() {
    return this._cursors.getAll();
  }
  setStates(e, t, i, s) {
    let o = !1;
    const r = this.context.cursorConfig.multiCursorLimit;
    s !== null && s.length > r && (s = s.slice(0, r), o = !0);
    const a = u0.from(this._model, this);
    return this._cursors.setStates(s), this._cursors.normalize(), this._columnSelectData = null, this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(e, t, i, a, o);
  }
  setCursorColumnSelectData(e) {
    this._columnSelectData = e;
  }
  revealAll(e, t, i, s, o, r) {
    const a = this._cursors.getViewPositions();
    let l = null, d = null;
    a.length > 1 ? d = this._cursors.getViewSelections() : l = D.fromPositions(a[0], a[0]), e.emitViewEvent(new c0(t, i, l, d, s, o, r));
  }
  revealPrimary(e, t, i, s, o, r) {
    const a = [this._cursors.getPrimaryCursor().viewState.selection];
    e.emitViewEvent(new c0(t, i, null, a, s, o, r));
  }
  saveState() {
    const e = [], t = this._cursors.getSelections();
    for (let i = 0, s = t.length; i < s; i++) {
      const o = t[i];
      e.push({ inSelectionMode: !o.isEmpty(), selectionStart: { lineNumber: o.selectionStartLineNumber, column: o.selectionStartColumn }, position: { lineNumber: o.positionLineNumber, column: o.positionColumn } });
    }
    return e;
  }
  restoreState(e, t) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const r = t[s];
      let a = 1, l = 1;
      r.position && r.position.lineNumber && (a = r.position.lineNumber), r.position && r.position.column && (l = r.position.column);
      let d = a, h = l;
      r.selectionStart && r.selectionStart.lineNumber && (d = r.selectionStart.lineNumber), r.selectionStart && r.selectionStart.column && (h = r.selectionStart.column), i.push({ selectionStartLineNumber: d, selectionStartColumn: h, positionLineNumber: a, positionColumn: l });
    }
    this.setStates(e, "restoreState", 0, pt.fromModelSelections(i)), this.revealAll(e, "restoreState", !1, 0, !0, 1);
  }
  onModelContentChanged(e, t) {
    if (t instanceof $B) {
      if (this._isHandling) return;
      this._isHandling = !0;
      try {
        this.setStates(e, "modelChange", 0, this.getCursorStates());
      } finally {
        this._isHandling = !1;
      }
    } else {
      const i = t.rawContentChangedEvent;
      if (this._knownModelVersionId = i.versionId, this._isHandling) return;
      const s = i.containsEvent(1);
      if (this._prevEditOperationType = 0, s) this._cursors.dispose(), this._cursors = new V5(this.context), this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(e, "model", 1, null, !1);
      else if (this._hasFocus && i.resultingSelection && i.resultingSelection.length > 0) {
        const o = pt.fromModelSelections(i.resultingSelection);
        this.setStates(e, "modelChange", i.isUndoing ? 5 : i.isRedoing ? 6 : 2, o) && this.revealAll(e, "modelChange", !1, 0, !0, 0);
      } else {
        const o = this._cursors.readSelectionFromMarkers();
        this.setStates(e, "modelChange", 2, pt.fromModelSelections(o));
      }
    }
  }
  getSelection() {
    return this._cursors.getPrimaryCursor().modelState.selection;
  }
  getTopMostViewPosition() {
    return this._cursors.getTopMostViewPosition();
  }
  getBottomMostViewPosition() {
    return this._cursors.getBottomMostViewPosition();
  }
  getCursorColumnSelectData() {
    if (this._columnSelectData) return this._columnSelectData;
    const e = this._cursors.getPrimaryCursor(), t = e.viewState.selectionStart.getStartPosition(), i = e.viewState.position;
    return { isReal: !1, fromViewLineNumber: t.lineNumber, fromViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, t), toViewLineNumber: i.lineNumber, toViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, i) };
  }
  getSelections() {
    return this._cursors.getSelections();
  }
  setSelections(e, t, i, s) {
    this.setStates(e, t, s, pt.fromModelSelections(i));
  }
  getPrevEditOperationType() {
    return this._prevEditOperationType;
  }
  setPrevEditOperationType(e) {
    this._prevEditOperationType = e;
  }
  _pushAutoClosedAction(e, t) {
    const i = [], s = [];
    for (let a = 0, l = e.length; a < l; a++) i.push({ range: e[a], options: { description: "auto-closed-character", inlineClassName: "auto-closed-character", stickiness: 1 } }), s.push({ range: t[a], options: { description: "auto-closed-enclosing", stickiness: 1 } });
    const o = this._model.deltaDecorations([], i), r = this._model.deltaDecorations([], s);
    this._autoClosedActions.push(new z5(this._model, o, r));
  }
  _executeEditOperation(e) {
    if (!e) return;
    e.shouldPushStackElementBefore && this._model.pushStackElement();
    const t = kQ.executeCommands(this._model, this._cursors.getSelections(), e.commands);
    if (t) {
      this._interpretCommandResult(t);
      const i = [], s = [];
      for (let o = 0; o < e.commands.length; o++) {
        const r = e.commands[o];
        r instanceof BB && r.enclosingRange && r.closeCharacterRange && (i.push(r.closeCharacterRange), s.push(r.enclosingRange));
      }
      i.length > 0 && this._pushAutoClosedAction(i, s), this._prevEditOperationType = e.type;
    }
    e.shouldPushStackElementAfter && this._model.pushStackElement();
  }
  _interpretCommandResult(e) {
    e && e.length !== 0 || (e = this._cursors.readSelectionFromMarkers()), this._columnSelectData = null, this._cursors.setSelections(e), this._cursors.normalize();
  }
  _emitStateChangedIfNecessary(e, t, i, s, o) {
    const r = u0.from(this._model, this);
    if (r.equals(s)) return !1;
    const a = this._cursors.getSelections(), l = this._cursors.getViewSelections();
    if (e.emitViewEvent(new oQ(l, a, i)), !s || s.cursorState.length !== r.cursorState.length || r.cursorState.some(((d, h) => !d.modelState.equals(s.cursorState[h].modelState)))) {
      const d = s ? s.cursorState.map(((c) => c.modelState.selection)) : null, h = s ? s.modelVersionId : 0;
      e.emitOutgoingEvent(new vy(d, a, h, r.modelVersionId, t || "keyboard", i, o));
    }
    return !0;
  }
  _findAutoClosingPairs(e) {
    if (!e.length) return null;
    const t = [];
    for (let i = 0, s = e.length; i < s; i++) {
      const o = e[i];
      if (!o.text || o.text.indexOf(`
`) >= 0) return null;
      const r = o.text.match(/([)\]}>'"`])([^)\]}>'"`]*)$/);
      if (!r) return null;
      const a = r[1], l = this.context.cursorConfig.autoClosingPairs.autoClosingPairsCloseSingleChar.get(a);
      if (!l || l.length !== 1) return null;
      const d = l[0].open, h = o.text.length - r[2].length - 1, c = o.text.lastIndexOf(d, h - 1);
      if (c === -1) return null;
      t.push([c, h]);
    }
    return t;
  }
  executeEdits(e, t, i, s) {
    let o = null;
    t === "snippet" && (o = this._findAutoClosingPairs(i)), o && (i[0]._isTracked = !0);
    const r = [], a = [], l = this._model.pushEditOperations(this.getSelections(), i, ((d) => {
      if (o) for (let c = 0, u = o.length; c < u; c++) {
        const [g, p] = o[c], f = d[c], _ = f.range.startLineNumber, v = f.range.startColumn - 1 + g, b = f.range.startColumn - 1 + p;
        r.push(new D(_, b + 1, _, b + 2)), a.push(new D(_, v + 1, _, b + 2));
      }
      const h = s(d);
      return h && (this._isHandling = !0), h;
    }));
    l && (this._isHandling = !1, this.setSelections(e, t, l, 0)), r.length > 0 && this._pushAutoClosedAction(r, a);
  }
  _executeEdit(e, t, i, s = 0) {
    if (this.context.cursorConfig.readOnly) return;
    const o = u0.from(this._model, this);
    this._cursors.stopTrackingSelections(), this._isHandling = !0;
    try {
      this._cursors.ensureValidState(), e();
    } catch (r) {
      We(r);
    }
    this._isHandling = !1, this._cursors.startTrackingSelections(), this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(t, i, s, o, !1) && this.revealAll(t, i, !1, 0, !0, 0);
  }
  getAutoClosedCharacters() {
    return z5.getAllAutoClosedCharacters(this._autoClosedActions);
  }
  startComposition(e) {
    this._compositionState = new g0(this._model, this.getSelections());
  }
  endComposition(e, t) {
    const i = this._compositionState ? this._compositionState.deduceOutcome(this._model, this.getSelections()) : null;
    this._compositionState = null, this._executeEdit((() => {
      t === "keyboard" && this._executeEditOperation(oi.compositionEndWithInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, i, this.getSelections(), this.getAutoClosedCharacters()));
    }), e, t);
  }
  type(e, t, i) {
    this._executeEdit((() => {
      if (i === "keyboard") {
        const s = t.length;
        let o = 0;
        for (; o < s; ) {
          const r = rR(t, o), a = t.substr(o, r);
          this._executeEditOperation(oi.typeWithInterceptors(!!this._compositionState, this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), this.getAutoClosedCharacters(), a)), o += r;
        }
      } else this._executeEditOperation(oi.typeWithoutInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), t));
    }), e, i);
  }
  compositionType(e, t, i, s, o, r) {
    if (t.length !== 0 || i !== 0 || s !== 0) this._executeEdit((() => {
      this._executeEditOperation(oi.compositionType(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), t, i, s, o));
    }), e, r);
    else if (o !== 0) {
      const a = this.getSelections().map(((l) => {
        const d = l.getPosition();
        return new _e(d.lineNumber, d.column + o, d.lineNumber, d.column + o);
      }));
      this.setSelections(e, r, a, 0);
    }
  }
  paste(e, t, i, s, o) {
    this._executeEdit((() => {
      this._executeEditOperation(oi.paste(this.context.cursorConfig, this._model, this.getSelections(), t, i, s || []));
    }), e, o, 4);
  }
  cut(e, t) {
    this._executeEdit((() => {
      this._executeEditOperation(cg.cut(this.context.cursorConfig, this._model, this.getSelections()));
    }), e, t);
  }
  executeCommand(e, t, i) {
    this._executeEdit((() => {
      this._cursors.killSecondaryCursors(), this._executeEditOperation(new Ls(0, [t], { shouldPushStackElementBefore: !1, shouldPushStackElementAfter: !1 }));
    }), e, i);
  }
  executeCommands(e, t, i) {
    this._executeEdit((() => {
      this._executeEditOperation(new Ls(0, t, { shouldPushStackElementBefore: !1, shouldPushStackElementAfter: !1 }));
    }), e, i);
  }
}
class u0 {
  static from(e, t) {
    return new u0(e.getVersionId(), t.getCursorStates());
  }
  constructor(e, t) {
    this.modelVersionId = e, this.cursorState = t;
  }
  equals(e) {
    if (!e || this.modelVersionId !== e.modelVersionId || this.cursorState.length !== e.cursorState.length) return !1;
    for (let t = 0, i = this.cursorState.length; t < i; t++) if (!this.cursorState[t].equals(e.cursorState[t])) return !1;
    return !0;
  }
}
class z5 {
  static getAllAutoClosedCharacters(e) {
    let t = [];
    for (const i of e) t = t.concat(i.getAutoClosedCharactersRanges());
    return t;
  }
  constructor(e, t, i) {
    this._model = e, this._autoClosedCharactersDecorations = t, this._autoClosedEnclosingDecorations = i;
  }
  dispose() {
    this._autoClosedCharactersDecorations = this._model.deltaDecorations(this._autoClosedCharactersDecorations, []), this._autoClosedEnclosingDecorations = this._model.deltaDecorations(this._autoClosedEnclosingDecorations, []);
  }
  getAutoClosedCharactersRanges() {
    const e = [];
    for (let t = 0; t < this._autoClosedCharactersDecorations.length; t++) {
      const i = this._model.getDecorationRange(this._autoClosedCharactersDecorations[t]);
      i && e.push(i);
    }
    return e;
  }
  isValid(e) {
    const t = [];
    for (let i = 0; i < this._autoClosedEnclosingDecorations.length; i++) {
      const s = this._model.getDecorationRange(this._autoClosedEnclosingDecorations[i]);
      if (s && (t.push(s), s.startLineNumber !== s.endLineNumber)) return !1;
    }
    t.sort(D.compareRangesUsingStarts), e.sort(D.compareRangesUsingStarts);
    for (let i = 0; i < e.length; i++)
      if (i >= t.length || !t[i].strictContainsRange(e[i])) return !1;
    return !0;
  }
}
class kQ {
  static executeCommands(e, t, i) {
    const s = { model: e, selectionsBefore: t, trackedRanges: [], trackedRangesDirection: [] }, o = this._innerExecuteCommands(s, i);
    for (let r = 0, a = s.trackedRanges.length; r < a; r++) s.model._setTrackedRange(s.trackedRanges[r], null, 0);
    return o;
  }
  static _innerExecuteCommands(e, t) {
    if (this._arrayIsEmpty(t)) return null;
    const i = this._getEditOperations(e, t);
    if (i.operations.length === 0) return null;
    const s = i.operations, o = this._getLoserCursorMap(s);
    if (o.hasOwnProperty("0")) return console.warn("Ignoring commands"), null;
    const r = [];
    for (let d = 0, h = s.length; d < h; d++) o.hasOwnProperty(s[d].identifier.major.toString()) || r.push(s[d]);
    i.hadTrackedEditOperation && r.length > 0 && (r[0]._isTracked = !0);
    let a = e.model.pushEditOperations(e.selectionsBefore, r, ((d) => {
      const h = [];
      for (let g = 0; g < e.selectionsBefore.length; g++) h[g] = [];
      for (const g of d) g.identifier && h[g.identifier.major].push(g);
      const c = (g, p) => g.identifier.minor - p.identifier.minor, u = [];
      for (let g = 0; g < e.selectionsBefore.length; g++) h[g].length > 0 ? (h[g].sort(c), u[g] = t[g].computeCursorState(e.model, { getInverseEditOperations: () => h[g], getTrackedSelection: (p) => {
        const f = parseInt(p, 10), _ = e.model._getTrackedRange(e.trackedRanges[f]);
        return e.trackedRangesDirection[f] === 0 ? new _e(_.startLineNumber, _.startColumn, _.endLineNumber, _.endColumn) : new _e(_.endLineNumber, _.endColumn, _.startLineNumber, _.startColumn);
      } })) : u[g] = e.selectionsBefore[g];
      return u;
    }));
    a || (a = e.selectionsBefore);
    const l = [];
    for (const d in o) o.hasOwnProperty(d) && l.push(parseInt(d, 10));
    l.sort(((d, h) => h - d));
    for (const d of l) a.splice(d, 1);
    return a;
  }
  static _arrayIsEmpty(e) {
    for (let t = 0, i = e.length; t < i; t++) if (e[t]) return !1;
    return !0;
  }
  static _getEditOperations(e, t) {
    let i = [], s = !1;
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o];
      if (a) {
        const l = this._getEditOperationsFromCommand(e, o, a);
        i = i.concat(l.operations), s = s || l.hadTrackedEditOperation;
      }
    }
    return { operations: i, hadTrackedEditOperation: s };
  }
  static _getEditOperationsFromCommand(e, t, i) {
    const s = [];
    let o = 0;
    const r = (d, h, c = !1) => {
      D.isEmpty(d) && h === "" || s.push({ identifier: { major: t, minor: o++ }, range: d, text: h, forceMoveMarkers: c, isAutoWhitespaceEdit: i.insertsAutoWhitespace });
    };
    let a = !1;
    const l = { addEditOperation: r, addTrackedEditOperation: (d, h, c) => {
      a = !0, r(d, h, c);
    }, trackSelection: (d, h) => {
      const c = _e.liftSelection(d);
      let u;
      if (c.isEmpty()) if (typeof h == "boolean") u = h ? 2 : 3;
      else {
        const f = e.model.getLineMaxColumn(c.startLineNumber);
        u = c.startColumn === f ? 2 : 3;
      }
      else u = 1;
      const g = e.trackedRanges.length, p = e.model._setTrackedRange(null, c, u);
      return e.trackedRanges[g] = p, e.trackedRangesDirection[g] = c.getDirection(), g.toString();
    } };
    try {
      i.getEditOperations(e.model, l);
    } catch (d) {
      return We(d), { operations: [], hadTrackedEditOperation: !1 };
    }
    return { operations: s, hadTrackedEditOperation: a };
  }
  static _getLoserCursorMap(e) {
    (e = e.slice(0)).sort(((i, s) => -D.compareRangesUsingEnds(i.range, s.range)));
    const t = {};
    for (let i = 1; i < e.length; i++) {
      const s = e[i - 1], o = e[i];
      if (D.getStartPosition(s.range).isBefore(D.getEndPosition(o.range))) {
        let r;
        r = s.identifier.major > o.identifier.major ? s.identifier.major : o.identifier.major, t[r.toString()] = !0;
        for (let a = 0; a < e.length; a++) e[a].identifier.major === r && (e.splice(a, 1), a < i && i--, a--);
        i > 0 && i--;
      }
    }
    return t;
  }
}
class DQ {
  constructor(e, t, i) {
    this.text = e, this.startSelection = t, this.endSelection = i;
  }
}
class g0 {
  static _capture(e, t) {
    const i = [];
    for (const s of t) {
      if (s.startLineNumber !== s.endLineNumber) return null;
      i.push(new DQ(e.getLineContent(s.startLineNumber), s.startColumn - 1, s.endColumn - 1));
    }
    return i;
  }
  constructor(e, t) {
    this._original = g0._capture(e, t);
  }
  deduceOutcome(e, t) {
    if (!this._original) return null;
    const i = g0._capture(e, t);
    if (!i || this._original.length !== i.length) return null;
    const s = [];
    for (let o = 0, r = this._original.length; o < r; o++) s.push(g0._deduceOutcome(this._original[o], i[o]));
    return s;
  }
  static _deduceOutcome(e, t) {
    const i = Math.min(e.startSelection, t.startSelection, mc(e.text, t.text)), s = Math.min(e.text.length - e.endSelection, t.text.length - t.endSelection, Fw(e.text, t.text)), o = e.text.substring(i, e.text.length - s), r = t.text.substring(i, t.text.length - s);
    return new sY(o, e.startSelection - i, e.endSelection - i, r, t.startSelection - i, t.endSelection - i);
  }
}
const U5 = { getInitialState: () => Vm, tokenizeEncoded: (n, e, t) => iL(0, t) };
function xQ(n, e, t, i, s, o, r) {
  let a = "<div>", l = i, d = 0, h = !0;
  for (let c = 0, u = e.getCount(); c < u; c++) {
    const g = e.getEndOffset(c);
    if (g <= i) continue;
    let p = "";
    for (; l < g && l < s; l++) {
      const f = n.charCodeAt(l);
      switch (f) {
        case 9: {
          let _ = o - (l + d) % o;
          for (d += _ - 1; _ > 0; ) r && h ? (p += "&#160;", h = !1) : (p += " ", h = !0), _--;
          break;
        }
        case 60:
          p += "&lt;", h = !1;
          break;
        case 62:
          p += "&gt;", h = !1;
          break;
        case 38:
          p += "&amp;", h = !1;
          break;
        case 0:
          p += "&#00;", h = !1;
          break;
        case 65279:
        case 8232:
        case 8233:
        case 133:
          p += "�", h = !1;
          break;
        case 13:
          p += "&#8203", h = !1;
          break;
        case 32:
          r && h ? (p += "&#160;", h = !1) : (p += " ", h = !0);
          break;
        default:
          p += String.fromCharCode(f), h = !1;
      }
    }
    if (a += `<span style="${e.getInlineStyle(c, t)}">${p}</span>`, g > s || l >= s) break;
  }
  return a += "</div>", a;
}
function K5(n, e, t) {
  let i = '<div class="monaco-tokenized-source">';
  const s = Sl(n);
  let o = t.getInitialState();
  for (let r = 0, a = s.length; r < a; r++) {
    const l = s[r];
    r > 0 && (i += "<br/>");
    const d = t.tokenizeEncoded(l, !0, o);
    nn.convertToEndOffset(d.tokens, l.length);
    const h = new nn(d.tokens, l, e).inflate();
    let c = 0;
    for (let u = 0, g = h.getCount(); u < g; u++) {
      const p = h.getClassName(u), f = h.getEndOffset(u);
      i += `<span class="${p}">${Ow(l.substring(c, f))}</span>`, c = f;
    }
    o = d.endState;
  }
  return i += "</div>", i;
}
class NQ {
  constructor() {
    this._hasPending = !1, this._inserts = [], this._changes = [], this._removes = [];
  }
  insert(e) {
    this._hasPending = !0, this._inserts.push(e);
  }
  change(e) {
    this._hasPending = !0, this._changes.push(e);
  }
  remove(e) {
    this._hasPending = !0, this._removes.push(e);
  }
  mustCommit() {
    return this._hasPending;
  }
  commit(e) {
    if (!this._hasPending) return;
    const t = this._inserts, i = this._changes, s = this._removes;
    this._hasPending = !1, this._inserts = [], this._changes = [], this._removes = [], e._commitPendingChanges(t, i, s);
  }
}
class EQ {
  constructor(e, t, i, s, o) {
    this.id = e, this.afterLineNumber = t, this.ordinal = i, this.height = s, this.minWidth = o, this.prefixSum = 0;
  }
}
let uW = class wI {
  constructor(e, t, i, s) {
    this._instanceId = i8(++wI.INSTANCE_COUNT), this._pendingChanges = new NQ(), this._lastWhitespaceId = 0, this._arr = [], this._prefixSumValidIndex = -1, this._minWidth = -1, this._lineCount = e, this._lineHeight = t, this._paddingTop = i, this._paddingBottom = s;
  }
  static findInsertionIndex(e, t, i) {
    let s = 0, o = e.length;
    for (; s < o; ) {
      const r = s + o >>> 1;
      t === e[r].afterLineNumber ? i < e[r].ordinal ? o = r : s = r + 1 : t < e[r].afterLineNumber ? o = r : s = r + 1;
    }
    return s;
  }
  setLineHeight(e) {
    this._checkPendingChanges(), this._lineHeight = e;
  }
  setPadding(e, t) {
    this._paddingTop = e, this._paddingBottom = t;
  }
  onFlushed(e) {
    this._checkPendingChanges(), this._lineCount = e;
  }
  changeWhitespace(e) {
    let t = !1;
    try {
      e({ insertWhitespace: (i, s, o, r) => {
        t = !0, i |= 0, s |= 0, o |= 0, r |= 0;
        const a = this._instanceId + ++this._lastWhitespaceId;
        return this._pendingChanges.insert(new EQ(a, i, s, o, r)), a;
      }, changeOneWhitespace: (i, s, o) => {
        t = !0, s |= 0, o |= 0, this._pendingChanges.change({ id: i, newAfterLineNumber: s, newHeight: o });
      }, removeWhitespace: (i) => {
        t = !0, this._pendingChanges.remove({ id: i });
      } });
    } finally {
      this._pendingChanges.commit(this);
    }
    return t;
  }
  _commitPendingChanges(e, t, i) {
    if ((e.length > 0 || i.length > 0) && (this._minWidth = -1), e.length + t.length + i.length <= 1) {
      for (const l of e) this._insertWhitespace(l);
      for (const l of t) this._changeOneWhitespace(l.id, l.newAfterLineNumber, l.newHeight);
      for (const l of i) {
        const d = this._findWhitespaceIndex(l.id);
        d !== -1 && this._removeWhitespace(d);
      }
      return;
    }
    const s = /* @__PURE__ */ new Set();
    for (const l of i) s.add(l.id);
    const o = /* @__PURE__ */ new Map();
    for (const l of t) o.set(l.id, l);
    const r = (l) => {
      const d = [];
      for (const h of l) if (!s.has(h.id)) {
        if (o.has(h.id)) {
          const c = o.get(h.id);
          h.afterLineNumber = c.newAfterLineNumber, h.height = c.newHeight;
        }
        d.push(h);
      }
      return d;
    }, a = r(this._arr).concat(r(e));
    a.sort(((l, d) => l.afterLineNumber === d.afterLineNumber ? l.ordinal - d.ordinal : l.afterLineNumber - d.afterLineNumber)), this._arr = a, this._prefixSumValidIndex = -1;
  }
  _checkPendingChanges() {
    this._pendingChanges.mustCommit() && this._pendingChanges.commit(this);
  }
  _insertWhitespace(e) {
    const t = wI.findInsertionIndex(this._arr, e.afterLineNumber, e.ordinal);
    this._arr.splice(t, 0, e), this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, t - 1);
  }
  _findWhitespaceIndex(e) {
    const t = this._arr;
    for (let i = 0, s = t.length; i < s; i++) if (t[i].id === e) return i;
    return -1;
  }
  _changeOneWhitespace(e, t, i) {
    const s = this._findWhitespaceIndex(e);
    if (s !== -1 && (this._arr[s].height !== i && (this._arr[s].height = i, this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, s - 1)), this._arr[s].afterLineNumber !== t)) {
      const o = this._arr[s];
      this._removeWhitespace(s), o.afterLineNumber = t, this._insertWhitespace(o);
    }
  }
  _removeWhitespace(e) {
    this._arr.splice(e, 1), this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, e - 1);
  }
  onLinesDeleted(e, t) {
    this._checkPendingChanges(), e |= 0, t |= 0, this._lineCount -= t - e + 1;
    for (let i = 0, s = this._arr.length; i < s; i++) {
      const o = this._arr[i].afterLineNumber;
      e <= o && o <= t ? this._arr[i].afterLineNumber = e - 1 : o > t && (this._arr[i].afterLineNumber -= t - e + 1);
    }
  }
  onLinesInserted(e, t) {
    this._checkPendingChanges(), e |= 0, t |= 0, this._lineCount += t - e + 1;
    for (let i = 0, s = this._arr.length; i < s; i++)
      e <= this._arr[i].afterLineNumber && (this._arr[i].afterLineNumber += t - e + 1);
  }
  getWhitespacesTotalHeight() {
    return this._checkPendingChanges(), this._arr.length === 0 ? 0 : this.getWhitespacesAccumulatedHeight(this._arr.length - 1);
  }
  getWhitespacesAccumulatedHeight(e) {
    this._checkPendingChanges(), e |= 0;
    let t = Math.max(0, this._prefixSumValidIndex + 1);
    t === 0 && (this._arr[0].prefixSum = this._arr[0].height, t++);
    for (let i = t; i <= e; i++) this._arr[i].prefixSum = this._arr[i - 1].prefixSum + this._arr[i].height;
    return this._prefixSumValidIndex = Math.max(this._prefixSumValidIndex, e), this._arr[e].prefixSum;
  }
  getLinesTotalHeight() {
    return this._checkPendingChanges(), this._lineHeight * this._lineCount + this.getWhitespacesTotalHeight() + this._paddingTop + this._paddingBottom;
  }
  getWhitespaceAccumulatedHeightBeforeLineNumber(e) {
    this._checkPendingChanges(), e |= 0;
    const t = this._findLastWhitespaceBeforeLineNumber(e);
    return t === -1 ? 0 : this.getWhitespacesAccumulatedHeight(t);
  }
  _findLastWhitespaceBeforeLineNumber(e) {
    e |= 0;
    const t = this._arr;
    let i = 0, s = t.length - 1;
    for (; i <= s; ) {
      const o = i + ((s - i | 0) / 2 | 0) | 0;
      if (t[o].afterLineNumber < e) {
        if (o + 1 >= t.length || t[o + 1].afterLineNumber >= e) return o;
        i = o + 1 | 0;
      } else s = o - 1 | 0;
    }
    return -1;
  }
  _findFirstWhitespaceAfterLineNumber(e) {
    e |= 0;
    const t = this._findLastWhitespaceBeforeLineNumber(e) + 1;
    return t < this._arr.length ? t : -1;
  }
  getFirstWhitespaceIndexAfterLineNumber(e) {
    return this._checkPendingChanges(), e |= 0, this._findFirstWhitespaceAfterLineNumber(e);
  }
  getVerticalOffsetForLineNumber(e, t = !1) {
    let i;
    return this._checkPendingChanges(), i = (e |= 0) > 1 ? this._lineHeight * (e - 1) : 0, i + this.getWhitespaceAccumulatedHeightBeforeLineNumber(e - (t ? 1 : 0)) + this._paddingTop;
  }
  getVerticalOffsetAfterLineNumber(e, t = !1) {
    return this._checkPendingChanges(), e |= 0, this._lineHeight * e + this.getWhitespaceAccumulatedHeightBeforeLineNumber(e + (t ? 1 : 0)) + this._paddingTop;
  }
  getWhitespaceMinWidth() {
    if (this._checkPendingChanges(), this._minWidth === -1) {
      let e = 0;
      for (let t = 0, i = this._arr.length; t < i; t++) e = Math.max(e, this._arr[t].minWidth);
      this._minWidth = e;
    }
    return this._minWidth;
  }
  isAfterLines(e) {
    return this._checkPendingChanges(), e > this.getLinesTotalHeight();
  }
  isInTopPadding(e) {
    return this._paddingTop !== 0 && (this._checkPendingChanges(), e < this._paddingTop);
  }
  isInBottomPadding(e) {
    return this._paddingBottom === 0 ? !1 : (this._checkPendingChanges(), e >= this.getLinesTotalHeight() - this._paddingBottom);
  }
  getLineNumberAtOrAfterVerticalOffset(e) {
    if (this._checkPendingChanges(), (e |= 0) < 0) return 1;
    const t = 0 | this._lineCount, i = this._lineHeight;
    let s = 1, o = t;
    for (; s < o; ) {
      const r = (s + o) / 2 | 0, a = 0 | this.getVerticalOffsetForLineNumber(r);
      if (e >= a + i) s = r + 1;
      else {
        if (e >= a) return r;
        o = r;
      }
    }
    return s > t ? t : s;
  }
  getLinesViewportData(e, t) {
    this._checkPendingChanges(), e |= 0, t |= 0;
    const i = this._lineHeight, s = 0 | this.getLineNumberAtOrAfterVerticalOffset(e), o = 0 | this.getVerticalOffsetForLineNumber(s);
    let r = 0 | this._lineCount, a = 0 | this.getFirstWhitespaceIndexAfterLineNumber(s);
    const l = 0 | this.getWhitespacesCount();
    let d, h;
    a === -1 ? (a = l, h = r + 1, d = 0) : (h = 0 | this.getAfterLineNumberForWhitespaceIndex(a), d = 0 | this.getHeightForWhitespaceIndex(a));
    let c = o, u = c;
    const g = 5e5;
    let p = 0;
    o >= g && (p = Math.floor(o / g) * g, p = Math.floor(p / i) * i, u -= p);
    const f = [], _ = e + (t - e) / 2;
    let v = -1;
    for (let y = s; y <= r; y++) {
      for (v === -1 && (c <= _ && _ < c + i || c > _) && (v = y), c += i, f[y - s] = u, u += i; h === y; ) u += d, c += d, a++, a >= l ? h = r + 1 : (h = 0 | this.getAfterLineNumberForWhitespaceIndex(a), d = 0 | this.getHeightForWhitespaceIndex(a));
      if (c >= t) {
        r = y;
        break;
      }
    }
    v === -1 && (v = r);
    const b = 0 | this.getVerticalOffsetForLineNumber(r);
    let C = s, w = r;
    return C < w && o < e && C++, C < w && b + i > t && w--, { bigNumbersDelta: p, startLineNumber: s, endLineNumber: r, relativeVerticalOffset: f, centeredLineNumber: v, completelyVisibleStartLineNumber: C, completelyVisibleEndLineNumber: w, lineHeight: this._lineHeight };
  }
  getVerticalOffsetForWhitespaceIndex(e) {
    this._checkPendingChanges(), e |= 0;
    const t = this.getAfterLineNumberForWhitespaceIndex(e);
    let i, s;
    return i = t >= 1 ? this._lineHeight * t : 0, s = e > 0 ? this.getWhitespacesAccumulatedHeight(e - 1) : 0, i + s + this._paddingTop;
  }
  getWhitespaceIndexAtOrAfterVerticallOffset(e) {
    this._checkPendingChanges(), e |= 0;
    let t = 0, i = this.getWhitespacesCount() - 1;
    if (i < 0 || e >= this.getVerticalOffsetForWhitespaceIndex(i) + this.getHeightForWhitespaceIndex(i)) return -1;
    for (; t < i; ) {
      const s = Math.floor((t + i) / 2), o = this.getVerticalOffsetForWhitespaceIndex(s);
      if (e >= o + this.getHeightForWhitespaceIndex(s)) t = s + 1;
      else {
        if (e >= o) return s;
        i = s;
      }
    }
    return t;
  }
  getWhitespaceAtVerticalOffset(e) {
    this._checkPendingChanges(), e |= 0;
    const t = this.getWhitespaceIndexAtOrAfterVerticallOffset(e);
    if (t < 0 || t >= this.getWhitespacesCount()) return null;
    const i = this.getVerticalOffsetForWhitespaceIndex(t);
    if (i > e) return null;
    const s = this.getHeightForWhitespaceIndex(t);
    return { id: this.getIdForWhitespaceIndex(t), afterLineNumber: this.getAfterLineNumberForWhitespaceIndex(t), verticalOffset: i, height: s };
  }
  getWhitespaceViewportData(e, t) {
    this._checkPendingChanges(), e |= 0, t |= 0;
    const i = this.getWhitespaceIndexAtOrAfterVerticallOffset(e), s = this.getWhitespacesCount() - 1;
    if (i < 0) return [];
    const o = [];
    for (let r = i; r <= s; r++) {
      const a = this.getVerticalOffsetForWhitespaceIndex(r), l = this.getHeightForWhitespaceIndex(r);
      if (a >= t) break;
      o.push({ id: this.getIdForWhitespaceIndex(r), afterLineNumber: this.getAfterLineNumberForWhitespaceIndex(r), verticalOffset: a, height: l });
    }
    return o;
  }
  getWhitespaces() {
    return this._checkPendingChanges(), this._arr.slice(0);
  }
  getWhitespacesCount() {
    return this._checkPendingChanges(), this._arr.length;
  }
  getIdForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e |= 0, this._arr[e].id;
  }
  getAfterLineNumberForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e |= 0, this._arr[e].afterLineNumber;
  }
  getHeightForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e |= 0, this._arr[e].height;
  }
};
uW.INSTANCE_COUNT = 0;
class k_ {
  constructor(e, t, i, s) {
    (e |= 0) < 0 && (e = 0), (t |= 0) < 0 && (t = 0), (i |= 0) < 0 && (i = 0), (s |= 0) < 0 && (s = 0), this.width = e, this.contentWidth = t, this.scrollWidth = Math.max(e, t), this.height = i, this.contentHeight = s, this.scrollHeight = Math.max(i, s);
  }
  equals(e) {
    return this.width === e.width && this.contentWidth === e.contentWidth && this.height === e.height && this.contentHeight === e.contentHeight;
  }
}
class IQ extends V {
  constructor(e, t) {
    super(), this._onDidContentSizeChange = this._register(new F()), this.onDidContentSizeChange = this._onDidContentSizeChange.event, this._dimensions = new k_(0, 0, 0, 0), this._scrollable = this._register(new _f({ forceIntegerValues: !0, smoothScrollDuration: e, scheduleAtNextAnimationFrame: t })), this.onDidScroll = this._scrollable.onScroll;
  }
  getScrollable() {
    return this._scrollable;
  }
  setSmoothScrollDuration(e) {
    this._scrollable.setSmoothScrollDuration(e);
  }
  validateScrollPosition(e) {
    return this._scrollable.validateScrollPosition(e);
  }
  getScrollDimensions() {
    return this._dimensions;
  }
  setScrollDimensions(e) {
    if (this._dimensions.equals(e)) return;
    const t = this._dimensions;
    this._dimensions = e, this._scrollable.setScrollDimensions({ width: e.width, scrollWidth: e.scrollWidth, height: e.height, scrollHeight: e.scrollHeight }, !0);
    const i = t.contentWidth !== e.contentWidth, s = t.contentHeight !== e.contentHeight;
    (i || s) && this._onDidContentSizeChange.fire(new sA(t.contentWidth, t.contentHeight, e.contentWidth, e.contentHeight));
  }
  getFutureScrollPosition() {
    return this._scrollable.getFutureScrollPosition();
  }
  getCurrentScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
  setScrollPositionNow(e) {
    this._scrollable.setScrollPositionNow(e);
  }
  setScrollPositionSmooth(e) {
    this._scrollable.setScrollPositionSmooth(e);
  }
  hasPendingScrollAnimation() {
    return this._scrollable.hasPendingScrollAnimation();
  }
}
class MQ extends V {
  constructor(e, t, i) {
    super(), this._configuration = e;
    const s = this._configuration.options, o = s.get(145), r = s.get(84);
    this._linesLayout = new uW(t, s.get(67), r.top, r.bottom), this._maxLineWidth = 0, this._overlayWidgetsMinWidth = 0, this._scrollable = this._register(new IQ(0, i)), this._configureSmoothScrollDuration(), this._scrollable.setScrollDimensions(new k_(o.contentWidth, 0, o.height, 0)), this.onDidScroll = this._scrollable.onDidScroll, this.onDidContentSizeChange = this._scrollable.onDidContentSizeChange, this._updateHeight();
  }
  dispose() {
    super.dispose();
  }
  getScrollable() {
    return this._scrollable.getScrollable();
  }
  onHeightMaybeChanged() {
    this._updateHeight();
  }
  _configureSmoothScrollDuration() {
    this._scrollable.setSmoothScrollDuration(this._configuration.options.get(114) ? 125 : 0);
  }
  onConfigurationChanged(e) {
    const t = this._configuration.options;
    if (e.hasChanged(67) && this._linesLayout.setLineHeight(t.get(67)), e.hasChanged(84)) {
      const i = t.get(84);
      this._linesLayout.setPadding(i.top, i.bottom);
    }
    if (e.hasChanged(145)) {
      const i = t.get(145), s = i.contentWidth, o = i.height, r = this._scrollable.getScrollDimensions(), a = r.contentWidth;
      this._scrollable.setScrollDimensions(new k_(s, r.contentWidth, o, this._getContentHeight(s, o, a)));
    } else this._updateHeight();
    e.hasChanged(114) && this._configureSmoothScrollDuration();
  }
  onFlushed(e) {
    this._linesLayout.onFlushed(e);
  }
  onLinesDeleted(e, t) {
    this._linesLayout.onLinesDeleted(e, t);
  }
  onLinesInserted(e, t) {
    this._linesLayout.onLinesInserted(e, t);
  }
  _getHorizontalScrollbarHeight(e, t) {
    const i = this._configuration.options.get(103);
    return i.horizontal === 2 || e >= t ? 0 : i.horizontalScrollbarSize;
  }
  _getContentHeight(e, t, i) {
    const s = this._configuration.options;
    let o = this._linesLayout.getLinesTotalHeight();
    return s.get(105) ? o += Math.max(0, t - s.get(67) - s.get(84).bottom) : s.get(103).ignoreHorizontalScrollbarInContentHeight || (o += this._getHorizontalScrollbarHeight(e, i)), o;
  }
  _updateHeight() {
    const e = this._scrollable.getScrollDimensions(), t = e.width, i = e.height, s = e.contentWidth;
    this._scrollable.setScrollDimensions(new k_(t, e.contentWidth, i, this._getContentHeight(t, i, s)));
  }
  getCurrentViewport() {
    const e = this._scrollable.getScrollDimensions(), t = this._scrollable.getCurrentScrollPosition();
    return new y4(t.scrollTop, t.scrollLeft, e.width, e.height);
  }
  getFutureViewport() {
    const e = this._scrollable.getScrollDimensions(), t = this._scrollable.getFutureScrollPosition();
    return new y4(t.scrollTop, t.scrollLeft, e.width, e.height);
  }
  _computeContentWidth() {
    const e = this._configuration.options, t = this._maxLineWidth, i = e.get(146), s = e.get(50), o = e.get(145);
    if (i.isViewportWrapping) {
      const r = e.get(73);
      return t > o.contentWidth + s.typicalHalfwidthCharacterWidth && r.enabled && r.side === "right" ? t + o.verticalScrollbarWidth : t;
    }
    {
      const r = e.get(104) * s.typicalHalfwidthCharacterWidth, a = this._linesLayout.getWhitespaceMinWidth();
      return Math.max(t + r + o.verticalScrollbarWidth, a, this._overlayWidgetsMinWidth);
    }
  }
  setMaxLineWidth(e) {
    this._maxLineWidth = e, this._updateContentWidth();
  }
  setOverlayWidgetsMinWidth(e) {
    this._overlayWidgetsMinWidth = e, this._updateContentWidth();
  }
  _updateContentWidth() {
    const e = this._scrollable.getScrollDimensions();
    this._scrollable.setScrollDimensions(new k_(e.width, this._computeContentWidth(), e.height, e.contentHeight)), this._updateHeight();
  }
  saveState() {
    const e = this._scrollable.getFutureScrollPosition(), t = e.scrollTop, i = this._linesLayout.getLineNumberAtOrAfterVerticalOffset(t);
    return { scrollTop: t, scrollTopWithoutViewZones: t - this._linesLayout.getWhitespaceAccumulatedHeightBeforeLineNumber(i), scrollLeft: e.scrollLeft };
  }
  changeWhitespace(e) {
    const t = this._linesLayout.changeWhitespace(e);
    return t && this.onHeightMaybeChanged(), t;
  }
  getVerticalOffsetForLineNumber(e, t = !1) {
    return this._linesLayout.getVerticalOffsetForLineNumber(e, t);
  }
  getVerticalOffsetAfterLineNumber(e, t = !1) {
    return this._linesLayout.getVerticalOffsetAfterLineNumber(e, t);
  }
  isAfterLines(e) {
    return this._linesLayout.isAfterLines(e);
  }
  isInTopPadding(e) {
    return this._linesLayout.isInTopPadding(e);
  }
  isInBottomPadding(e) {
    return this._linesLayout.isInBottomPadding(e);
  }
  getLineNumberAtVerticalOffset(e) {
    return this._linesLayout.getLineNumberAtOrAfterVerticalOffset(e);
  }
  getWhitespaceAtVerticalOffset(e) {
    return this._linesLayout.getWhitespaceAtVerticalOffset(e);
  }
  getLinesViewportData() {
    const e = this.getCurrentViewport();
    return this._linesLayout.getLinesViewportData(e.top, e.top + e.height);
  }
  getLinesViewportDataAtScrollTop(e) {
    const t = this._scrollable.getScrollDimensions();
    return e + t.height > t.scrollHeight && (e = t.scrollHeight - t.height), e < 0 && (e = 0), this._linesLayout.getLinesViewportData(e, e + t.height);
  }
  getWhitespaceViewportData() {
    const e = this.getCurrentViewport();
    return this._linesLayout.getWhitespaceViewportData(e.top, e.top + e.height);
  }
  getWhitespaces() {
    return this._linesLayout.getWhitespaces();
  }
  getContentWidth() {
    return this._scrollable.getScrollDimensions().contentWidth;
  }
  getScrollWidth() {
    return this._scrollable.getScrollDimensions().scrollWidth;
  }
  getContentHeight() {
    return this._scrollable.getScrollDimensions().contentHeight;
  }
  getScrollHeight() {
    return this._scrollable.getScrollDimensions().scrollHeight;
  }
  getCurrentScrollLeft() {
    return this._scrollable.getCurrentScrollPosition().scrollLeft;
  }
  getCurrentScrollTop() {
    return this._scrollable.getCurrentScrollPosition().scrollTop;
  }
  validateScrollPosition(e) {
    return this._scrollable.validateScrollPosition(e);
  }
  setScrollPosition(e, t) {
    t === 1 ? this._scrollable.setScrollPositionNow(e) : this._scrollable.setScrollPositionSmooth(e);
  }
  hasPendingScrollAnimation() {
    return this._scrollable.hasPendingScrollAnimation();
  }
  deltaScrollNow(e, t) {
    const i = this._scrollable.getCurrentScrollPosition();
    this._scrollable.setScrollPositionNow({ scrollLeft: i.scrollLeft + e, scrollTop: i.scrollTop + t });
  }
}
class TQ {
  constructor(e, t, i, s, o) {
    this.editorId = e, this.model = t, this.configuration = i, this._linesCollection = s, this._coordinatesConverter = o, this._decorationsCache = /* @__PURE__ */ Object.create(null), this._cachedModelDecorationsResolver = null, this._cachedModelDecorationsResolverViewRange = null;
  }
  _clearCachedModelDecorationsResolver() {
    this._cachedModelDecorationsResolver = null, this._cachedModelDecorationsResolverViewRange = null;
  }
  dispose() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  reset() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  onModelDecorationsChanged() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  onLineMappingChanged() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  _getOrCreateViewModelDecoration(e) {
    const t = e.id;
    let i = this._decorationsCache[t];
    if (!i) {
      const s = e.range, o = e.options;
      let r;
      if (o.isWholeLine) {
        const a = this._coordinatesConverter.convertModelPositionToViewPosition(new W(s.startLineNumber, 1), 0, !1, !0), l = this._coordinatesConverter.convertModelPositionToViewPosition(new W(s.endLineNumber, this.model.getLineMaxColumn(s.endLineNumber)), 1);
        r = new D(a.lineNumber, a.column, l.lineNumber, l.column);
      } else r = this._coordinatesConverter.convertModelRangeToViewRange(s, 1);
      i = new nB(r, o), this._decorationsCache[t] = i;
    }
    return i;
  }
  getMinimapDecorationsInRange(e) {
    return this._getDecorationsInRange(e, !0, !1).decorations;
  }
  getDecorationsViewportData(e) {
    let t = this._cachedModelDecorationsResolver !== null;
    return t = t && e.equalsRange(this._cachedModelDecorationsResolverViewRange), t || (this._cachedModelDecorationsResolver = this._getDecorationsInRange(e, !1, !1), this._cachedModelDecorationsResolverViewRange = e), this._cachedModelDecorationsResolver;
  }
  getInlineDecorationsOnLine(e, t = !1, i = !1) {
    const s = new D(e, this._linesCollection.getViewLineMinColumn(e), e, this._linesCollection.getViewLineMaxColumn(e));
    return this._getDecorationsInRange(s, t, i).inlineDecorations[0];
  }
  _getDecorationsInRange(e, t, i) {
    const s = this._linesCollection.getDecorationsInRange(e, this.editorId, Nw(this.configuration.options), t, i), o = e.startLineNumber, r = e.endLineNumber, a = [];
    let l = 0;
    const d = [];
    for (let h = o; h <= r; h++) d[h - o] = [];
    for (let h = 0, c = s.length; h < c; h++) {
      const u = s[h], g = u.options;
      if (!aA(this.model, u)) continue;
      const p = this._getOrCreateViewModelDecoration(u), f = p.range;
      if (a[l++] = p, g.inlineClassName) {
        const _ = new Y_(f, g.inlineClassName, g.inlineClassNameAffectsLetterSpacing ? 3 : 0), v = Math.max(o, f.startLineNumber), b = Math.min(r, f.endLineNumber);
        for (let C = v; C <= b; C++) d[C - o].push(_);
      }
      if (g.beforeContentClassName && o <= f.startLineNumber && f.startLineNumber <= r) {
        const _ = new Y_(new D(f.startLineNumber, f.startColumn, f.startLineNumber, f.startColumn), g.beforeContentClassName, 1);
        d[f.startLineNumber - o].push(_);
      }
      if (g.afterContentClassName && o <= f.endLineNumber && f.endLineNumber <= r) {
        const _ = new Y_(new D(f.endLineNumber, f.endColumn, f.endLineNumber, f.endColumn), g.afterContentClassName, 2);
        d[f.endLineNumber - o].push(_);
      }
    }
    return { decorations: a, inlineDecorations: d };
  }
}
function aA(n, e) {
  return (!e.options.hideInCommentTokens || !lA(n, e)) && (!e.options.hideInStringTokens || !dA(n, e));
}
function lA(n, e) {
  return gW(n, e.range, ((t) => t === 1));
}
function dA(n, e) {
  return gW(n, e.range, ((t) => t === 2));
}
function gW(n, e, t) {
  for (let i = e.startLineNumber; i <= e.endLineNumber; i++) {
    const s = n.tokenization.getLineTokens(i), o = i === e.startLineNumber, r = i === e.endLineNumber;
    let a = o ? s.findTokenIndexAtOffset(e.startColumn - 1) : 0;
    for (; a < s.getCount() && !(r && s.getStartOffset(a) > e.endColumn - 1); ) {
      if (!t(s.getStandardTokenType(a))) return !1;
      a++;
    }
  }
  return !0;
}
function ID(n, e) {
  return n === null ? e ? by.INSTANCE : Cy.INSTANCE : new RQ(n, e);
}
class RQ {
  constructor(e, t) {
    this._projectionData = e, this._isVisible = t;
  }
  isVisible() {
    return this._isVisible;
  }
  setVisible(e) {
    return this._isVisible = e, this;
  }
  getProjectionData() {
    return this._projectionData;
  }
  getViewLineCount() {
    return this._isVisible ? this._projectionData.getOutputLineCount() : 0;
  }
  getViewLineContent(e, t, i) {
    this._assertVisible();
    const s = i > 0 ? this._projectionData.breakOffsets[i - 1] : 0, o = this._projectionData.breakOffsets[i];
    let r;
    if (this._projectionData.injectionOffsets !== null) {
      const a = this._projectionData.injectionOffsets.map(((l, d) => new _a(0, 0, l + 1, this._projectionData.injectionOptions[d], 0)));
      r = _a.applyInjectedText(e.getLineContent(t), a).substring(s, o);
    } else r = e.getValueInRange({ startLineNumber: t, startColumn: s + 1, endLineNumber: t, endColumn: o + 1 });
    return i > 0 && (r = j5(this._projectionData.wrappedTextIndentLength) + r), r;
  }
  getViewLineLength(e, t, i) {
    return this._assertVisible(), this._projectionData.getLineLength(i);
  }
  getViewLineMinColumn(e, t, i) {
    return this._assertVisible(), this._projectionData.getMinOutputOffset(i) + 1;
  }
  getViewLineMaxColumn(e, t, i) {
    return this._assertVisible(), this._projectionData.getMaxOutputOffset(i) + 1;
  }
  getViewLineData(e, t, i) {
    const s = new Array();
    return this.getViewLinesData(e, t, i, 1, 0, [!0], s), s[0];
  }
  getViewLinesData(e, t, i, s, o, r, a) {
    this._assertVisible();
    const l = this._projectionData, d = l.injectionOffsets, h = l.injectionOptions;
    let c, u = null;
    if (d) {
      u = [];
      let g = 0, p = 0;
      for (let f = 0; f < l.getOutputLineCount(); f++) {
        const _ = new Array();
        u[f] = _;
        const v = f > 0 ? l.breakOffsets[f - 1] : 0, b = l.breakOffsets[f];
        for (; p < d.length; ) {
          const C = h[p].content.length, w = d[p] + g, y = w + C;
          if (w > b) break;
          if (v < y) {
            const L = h[p];
            if (L.inlineClassName) {
              const k = f > 0 ? l.wrappedTextIndentLength : 0, N = k + Math.max(w - v, 0), A = k + Math.min(y - v, b - v);
              N !== A && _.push(new Yq(N, A, L.inlineClassName, L.inlineClassNameAffectsLetterSpacing));
            }
          }
          if (!(y <= b)) break;
          g += C, p++;
        }
      }
    }
    c = d ? e.tokenization.getLineTokens(t).withInserted(d.map(((g, p) => ({ offset: g, text: h[p].content, tokenMetadata: nn.defaultTokenMetadata })))) : e.tokenization.getLineTokens(t);
    for (let g = i; g < i + s; g++) {
      const p = o + g - i;
      r[p] ? a[p] = this._getViewLineData(c, u ? u[g] : null, g) : a[p] = null;
    }
  }
  _getViewLineData(e, t, i) {
    this._assertVisible();
    const s = this._projectionData, o = i > 0 ? s.wrappedTextIndentLength : 0, r = i > 0 ? s.breakOffsets[i - 1] : 0, a = s.breakOffsets[i], l = e.sliceAndInflate(r, a, o);
    let d = l.getLineContent();
    i > 0 && (d = j5(s.wrappedTextIndentLength) + d);
    const h = this._projectionData.getMinOutputOffset(i) + 1, c = d.length + 1, u = i + 1 < this.getViewLineCount(), g = i === 0 ? 0 : s.breakOffsetsVisibleColumn[i - 1];
    return new MR(d, u, h, c, g, l, t);
  }
  getModelColumnOfViewPosition(e, t) {
    return this._assertVisible(), this._projectionData.translateToInputOffset(e, t - 1) + 1;
  }
  getViewPositionOfModelPosition(e, t, i = 2) {
    return this._assertVisible(), this._projectionData.translateToOutputPosition(t - 1, i).toPosition(e);
  }
  getViewLineNumberOfModelPosition(e, t) {
    return this._assertVisible(), e + this._projectionData.translateToOutputPosition(t - 1).outputLineIndex;
  }
  normalizePosition(e, t, i) {
    const s = t.lineNumber - e;
    return this._projectionData.normalizeOutputPosition(e, t.column - 1, i).toPosition(s);
  }
  getInjectedTextAt(e, t) {
    return this._projectionData.getInjectedText(e, t - 1);
  }
  _assertVisible() {
    if (!this._isVisible) throw new Error("Not supported");
  }
}
class by {
  constructor() {
  }
  isVisible() {
    return !0;
  }
  setVisible(e) {
    return e ? this : Cy.INSTANCE;
  }
  getProjectionData() {
    return null;
  }
  getViewLineCount() {
    return 1;
  }
  getViewLineContent(e, t, i) {
    return e.getLineContent(t);
  }
  getViewLineLength(e, t, i) {
    return e.getLineLength(t);
  }
  getViewLineMinColumn(e, t, i) {
    return e.getLineMinColumn(t);
  }
  getViewLineMaxColumn(e, t, i) {
    return e.getLineMaxColumn(t);
  }
  getViewLineData(e, t, i) {
    const s = e.tokenization.getLineTokens(t), o = s.getLineContent();
    return new MR(o, !1, 1, o.length + 1, 0, s.inflate(), null);
  }
  getViewLinesData(e, t, i, s, o, r, a) {
    r[o] ? a[o] = this.getViewLineData(e, t, 0) : a[o] = null;
  }
  getModelColumnOfViewPosition(e, t) {
    return t;
  }
  getViewPositionOfModelPosition(e, t) {
    return new W(e, t);
  }
  getViewLineNumberOfModelPosition(e, t) {
    return e;
  }
  normalizePosition(e, t, i) {
    return t;
  }
  getInjectedTextAt(e, t) {
    return null;
  }
}
by.INSTANCE = new by();
class Cy {
  constructor() {
  }
  isVisible() {
    return !1;
  }
  setVisible(e) {
    return e ? by.INSTANCE : this;
  }
  getProjectionData() {
    return null;
  }
  getViewLineCount() {
    return 0;
  }
  getViewLineContent(e, t, i) {
    throw new Error("Not supported");
  }
  getViewLineLength(e, t, i) {
    throw new Error("Not supported");
  }
  getViewLineMinColumn(e, t, i) {
    throw new Error("Not supported");
  }
  getViewLineMaxColumn(e, t, i) {
    throw new Error("Not supported");
  }
  getViewLineData(e, t, i) {
    throw new Error("Not supported");
  }
  getViewLinesData(e, t, i, s, o, r, a) {
    throw new Error("Not supported");
  }
  getModelColumnOfViewPosition(e, t) {
    throw new Error("Not supported");
  }
  getViewPositionOfModelPosition(e, t) {
    throw new Error("Not supported");
  }
  getViewLineNumberOfModelPosition(e, t) {
    throw new Error("Not supported");
  }
  normalizePosition(e, t, i) {
    throw new Error("Not supported");
  }
  getInjectedTextAt(e, t) {
    throw new Error("Not supported");
  }
}
Cy.INSTANCE = new Cy();
const MD = [""];
function j5(n) {
  if (n >= MD.length) for (let e = 1; e <= n; e++) MD[e] = AQ(e);
  return MD[n];
}
function AQ(n) {
  return new Array(n + 1).join(" ");
}
class PQ {
  constructor(e, t, i, s, o, r, a, l, d, h) {
    this._editorId = e, this.model = t, this._validModelVersionId = -1, this._domLineBreaksComputerFactory = i, this._monospaceLineBreaksComputerFactory = s, this.fontInfo = o, this.tabSize = r, this.wrappingStrategy = a, this.wrappingColumn = l, this.wrappingIndent = d, this.wordBreak = h, this._constructLines(!0, null);
  }
  dispose() {
    this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []);
  }
  createCoordinatesConverter() {
    return new OQ(this);
  }
  _constructLines(e, t) {
    this.modelLineProjections = [], e && (this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []));
    const i = this.model.getLinesContent(), s = this.model.getInjectedTextDecorations(this._editorId), o = i.length, r = this.createLineBreaksComputer(), a = new Pd(_a.fromDecorations(s));
    for (let f = 0; f < o; f++) {
      const _ = a.takeWhile(((v) => v.lineNumber === f + 1));
      r.addRequest(i[f], _, t ? t[f] : null);
    }
    const l = r.finalize(), d = [], h = this.hiddenAreasDecorationIds.map(((f) => this.model.getDecorationRange(f))).sort(D.compareRangesUsingStarts);
    let c = 1, u = 0, g = -1, p = g + 1 < h.length ? u + 1 : o + 2;
    for (let f = 0; f < o; f++) {
      const _ = f + 1;
      _ === p && (g++, c = h[g].startLineNumber, u = h[g].endLineNumber, p = g + 1 < h.length ? u + 1 : o + 2);
      const v = _ >= c && _ <= u, b = ID(l[f], !v);
      d[f] = b.getViewLineCount(), this.modelLineProjections[f] = b;
    }
    this._validModelVersionId = this.model.getVersionId(), this.projectedModelLineLineCounts = new cq(d);
  }
  getHiddenAreas() {
    return this.hiddenAreasDecorationIds.map(((e) => this.model.getDecorationRange(e)));
  }
  setHiddenAreas(e) {
    const t = (function(c) {
      if (c.length === 0) return [];
      const u = c.slice();
      u.sort(D.compareRangesUsingStarts);
      const g = [];
      let p = u[0].startLineNumber, f = u[0].endLineNumber;
      for (let _ = 1, v = u.length; _ < v; _++) {
        const b = u[_];
        b.startLineNumber > f + 1 ? (g.push(new D(p, 1, f, 1)), p = b.startLineNumber, f = b.endLineNumber) : b.endLineNumber > f && (f = b.endLineNumber);
      }
      return g.push(new D(p, 1, f, 1)), g;
    })(e.map(((c) => this.model.validateRange(c)))), i = this.hiddenAreasDecorationIds.map(((c) => this.model.getDecorationRange(c))).sort(D.compareRangesUsingStarts);
    if (t.length === i.length) {
      let c = !1;
      for (let u = 0; u < t.length; u++) if (!t[u].equalsRange(i[u])) {
        c = !0;
        break;
      }
      if (!c) return !1;
    }
    const s = t.map(((c) => ({ range: c, options: Ve.EMPTY })));
    this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, s);
    const o = t;
    let r = 1, a = 0, l = -1, d = l + 1 < o.length ? a + 1 : this.modelLineProjections.length + 2, h = !1;
    for (let c = 0; c < this.modelLineProjections.length; c++) {
      const u = c + 1;
      u === d && (l++, r = o[l].startLineNumber, a = o[l].endLineNumber, d = l + 1 < o.length ? a + 1 : this.modelLineProjections.length + 2);
      let g = !1;
      if (u >= r && u <= a ? this.modelLineProjections[c].isVisible() && (this.modelLineProjections[c] = this.modelLineProjections[c].setVisible(!1), g = !0) : (h = !0, this.modelLineProjections[c].isVisible() || (this.modelLineProjections[c] = this.modelLineProjections[c].setVisible(!0), g = !0)), g) {
        const p = this.modelLineProjections[c].getViewLineCount();
        this.projectedModelLineLineCounts.setValue(c, p);
      }
    }
    return h || this.setHiddenAreas([]), !0;
  }
  modelPositionIsVisible(e, t) {
    return !(e < 1 || e > this.modelLineProjections.length) && this.modelLineProjections[e - 1].isVisible();
  }
  getModelLineViewLineCount(e) {
    return e < 1 || e > this.modelLineProjections.length ? 1 : this.modelLineProjections[e - 1].getViewLineCount();
  }
  setTabSize(e) {
    return this.tabSize !== e && (this.tabSize = e, this._constructLines(!1, null), !0);
  }
  setWrappingSettings(e, t, i, s, o) {
    const r = this.fontInfo.equals(e), a = this.wrappingStrategy === t, l = this.wrappingColumn === i, d = this.wrappingIndent === s, h = this.wordBreak === o;
    if (r && a && l && d && h) return !1;
    const c = r && a && !l && d && h;
    this.fontInfo = e, this.wrappingStrategy = t, this.wrappingColumn = i, this.wrappingIndent = s, this.wordBreak = o;
    let u = null;
    if (c) {
      u = [];
      for (let g = 0, p = this.modelLineProjections.length; g < p; g++) u[g] = this.modelLineProjections[g].getProjectionData();
    }
    return this._constructLines(!1, u), !0;
  }
  createLineBreaksComputer() {
    return (this.wrappingStrategy === "advanced" ? this._domLineBreaksComputerFactory : this._monospaceLineBreaksComputerFactory).createLineBreaksComputer(this.fontInfo, this.tabSize, this.wrappingColumn, this.wrappingIndent, this.wordBreak);
  }
  onModelFlushed() {
    this._constructLines(!0, null);
  }
  onModelLinesDeleted(e, t, i) {
    if (!e || e <= this._validModelVersionId) return null;
    const s = t === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, o = this.projectedModelLineLineCounts.getPrefixSum(i);
    return this.modelLineProjections.splice(t - 1, i - t + 1), this.projectedModelLineLineCounts.removeValues(t - 1, i - t + 1), new bI(s, o);
  }
  onModelLinesInserted(e, t, i, s) {
    if (!e || e <= this._validModelVersionId) return null;
    const o = t > 2 && !this.modelLineProjections[t - 2].isVisible(), r = t === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1;
    let a = 0;
    const l = [], d = [];
    for (let h = 0, c = s.length; h < c; h++) {
      const u = ID(s[h], !o);
      l.push(u);
      const g = u.getViewLineCount();
      a += g, d[h] = g;
    }
    return this.modelLineProjections = this.modelLineProjections.slice(0, t - 1).concat(l).concat(this.modelLineProjections.slice(t - 1)), this.projectedModelLineLineCounts.insertValues(t - 1, d), new CI(r, r + a - 1);
  }
  onModelLineChanged(e, t, i) {
    if (e !== null && e <= this._validModelVersionId) return [!1, null, null, null];
    const s = t - 1, o = this.modelLineProjections[s].getViewLineCount(), r = ID(i, this.modelLineProjections[s].isVisible());
    this.modelLineProjections[s] = r;
    const a = this.modelLineProjections[s].getViewLineCount();
    let l = !1, d = 0, h = -1, c = 0, u = -1, g = 0, p = -1;
    return o > a ? (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, h = d + a - 1, g = h + 1, p = g + (o - a) - 1, l = !0) : o < a ? (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, h = d + o - 1, c = h + 1, u = c + (a - o) - 1, l = !0) : (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, h = d + a - 1), this.projectedModelLineLineCounts.setValue(s, a), [l, d <= h ? new cW(d, h - d + 1) : null, c <= u ? new CI(c, u) : null, g <= p ? new bI(g, p) : null];
  }
  acceptVersionId(e) {
    this._validModelVersionId = e, this.modelLineProjections.length !== 1 || this.modelLineProjections[0].isVisible() || this.setHiddenAreas([]);
  }
  getViewLineCount() {
    return this.projectedModelLineLineCounts.getTotalSum();
  }
  _toValidViewLineNumber(e) {
    if (e < 1) return 1;
    const t = this.getViewLineCount();
    return e > t ? t : 0 | e;
  }
  getActiveIndentGuide(e, t, i) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t), i = this._toValidViewLineNumber(i);
    const s = this.convertViewPositionToModelPosition(e, this.getViewLineMinColumn(e)), o = this.convertViewPositionToModelPosition(t, this.getViewLineMinColumn(t)), r = this.convertViewPositionToModelPosition(i, this.getViewLineMinColumn(i)), a = this.model.guides.getActiveIndentGuide(s.lineNumber, o.lineNumber, r.lineNumber), l = this.convertModelPositionToViewPosition(a.startLineNumber, 1), d = this.convertModelPositionToViewPosition(a.endLineNumber, this.model.getLineMaxColumn(a.endLineNumber));
    return { startLineNumber: l.lineNumber, endLineNumber: d.lineNumber, indent: a.indent };
  }
  getViewLineInfo(e) {
    e = this._toValidViewLineNumber(e);
    const t = this.projectedModelLineLineCounts.getIndexOf(e - 1), i = t.index, s = t.remainder;
    return new q5(i + 1, s);
  }
  getMinColumnOfViewLine(e) {
    return this.modelLineProjections[e.modelLineNumber - 1].getViewLineMinColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx);
  }
  getMaxColumnOfViewLine(e) {
    return this.modelLineProjections[e.modelLineNumber - 1].getViewLineMaxColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx);
  }
  getModelStartPositionOfViewLine(e) {
    const t = this.modelLineProjections[e.modelLineNumber - 1], i = t.getViewLineMinColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx), s = t.getModelColumnOfViewPosition(e.modelLineWrappedLineIdx, i);
    return new W(e.modelLineNumber, s);
  }
  getModelEndPositionOfViewLine(e) {
    const t = this.modelLineProjections[e.modelLineNumber - 1], i = t.getViewLineMaxColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx), s = t.getModelColumnOfViewPosition(e.modelLineWrappedLineIdx, i);
    return new W(e.modelLineNumber, s);
  }
  getViewLineInfosGroupedByModelRanges(e, t) {
    const i = this.getViewLineInfo(e), s = this.getViewLineInfo(t), o = new Array();
    let r = this.getModelStartPositionOfViewLine(i), a = new Array();
    for (let l = i.modelLineNumber; l <= s.modelLineNumber; l++) {
      const d = this.modelLineProjections[l - 1];
      if (d.isVisible()) {
        const h = l === i.modelLineNumber ? i.modelLineWrappedLineIdx : 0, c = l === s.modelLineNumber ? s.modelLineWrappedLineIdx + 1 : d.getViewLineCount();
        for (let u = h; u < c; u++) a.push(new q5(l, u));
      }
      if (!d.isVisible() && r) {
        const h = new W(l - 1, this.model.getLineMaxColumn(l - 1) + 1), c = D.fromPositions(r, h);
        o.push(new $5(c, a)), a = [], r = null;
      } else d.isVisible() && !r && (r = new W(l, 1));
    }
    if (r) {
      const l = D.fromPositions(r, this.getModelEndPositionOfViewLine(s));
      o.push(new $5(l, a));
    }
    return o;
  }
  getViewLinesBracketGuides(e, t, i, s) {
    const o = i ? this.convertViewPositionToModelPosition(i.lineNumber, i.column) : null, r = [];
    for (const a of this.getViewLineInfosGroupedByModelRanges(e, t)) {
      const l = a.modelRange.startLineNumber, d = this.model.guides.getLinesBracketGuides(l, a.modelRange.endLineNumber, o, s);
      for (const h of a.viewLines) {
        const c = d[h.modelLineNumber - l].map(((u) => {
          if (u.forWrappedLinesAfterColumn !== -1 && this.modelLineProjections[h.modelLineNumber - 1].getViewPositionOfModelPosition(0, u.forWrappedLinesAfterColumn).lineNumber >= h.modelLineWrappedLineIdx || u.forWrappedLinesBeforeOrAtColumn !== -1 && this.modelLineProjections[h.modelLineNumber - 1].getViewPositionOfModelPosition(0, u.forWrappedLinesBeforeOrAtColumn).lineNumber < h.modelLineWrappedLineIdx)
            return;
          if (!u.horizontalLine) return u;
          let g = -1;
          if (u.column !== -1) {
            const _ = this.modelLineProjections[h.modelLineNumber - 1].getViewPositionOfModelPosition(0, u.column);
            if (_.lineNumber === h.modelLineWrappedLineIdx) g = _.column;
            else if (_.lineNumber < h.modelLineWrappedLineIdx) g = this.getMinColumnOfViewLine(h);
            else if (_.lineNumber > h.modelLineWrappedLineIdx) return;
          }
          const p = this.convertModelPositionToViewPosition(h.modelLineNumber, u.horizontalLine.endColumn), f = this.modelLineProjections[h.modelLineNumber - 1].getViewPositionOfModelPosition(0, u.horizontalLine.endColumn);
          return f.lineNumber === h.modelLineWrappedLineIdx ? new Mu(u.visibleColumn, g, u.className, new i0(u.horizontalLine.top, p.column), -1, -1) : f.lineNumber < h.modelLineWrappedLineIdx || u.visibleColumn !== -1 ? void 0 : new Mu(u.visibleColumn, g, u.className, new i0(u.horizontalLine.top, this.getMaxColumnOfViewLine(h)), -1, -1);
        }));
        r.push(c.filter(((u) => !!u)));
      }
    }
    return r;
  }
  getViewLinesIndentGuides(e, t) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t);
    const i = this.convertViewPositionToModelPosition(e, this.getViewLineMinColumn(e)), s = this.convertViewPositionToModelPosition(t, this.getViewLineMaxColumn(t));
    let o = [];
    const r = [], a = [], l = i.lineNumber - 1, d = s.lineNumber - 1;
    let h = null;
    for (let p = l; p <= d; p++) {
      const f = this.modelLineProjections[p];
      if (f.isVisible()) {
        const _ = f.getViewLineNumberOfModelPosition(0, p === l ? i.column : 1), v = f.getViewLineNumberOfModelPosition(0, this.model.getLineMaxColumn(p + 1)), b = v - _ + 1;
        let C = 0;
        b > 1 && f.getViewLineMinColumn(this.model, p + 1, v) === 1 && (C = _ === 0 ? 1 : 2), r.push(b), a.push(C), h === null && (h = new W(p + 1, 0));
      } else h !== null && (o = o.concat(this.model.guides.getLinesIndentGuides(h.lineNumber, p)), h = null);
    }
    h !== null && (o = o.concat(this.model.guides.getLinesIndentGuides(h.lineNumber, s.lineNumber)), h = null);
    const c = t - e + 1, u = new Array(c);
    let g = 0;
    for (let p = 0, f = o.length; p < f; p++) {
      let _ = o[p];
      const v = Math.min(c - g, r[p]), b = a[p];
      let C;
      C = b === 2 ? 0 : b === 1 ? 1 : v;
      for (let w = 0; w < v; w++) w === C && (_ = 0), u[g++] = _;
    }
    return u;
  }
  getViewLineContent(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineContent(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineLength(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineLength(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineMinColumn(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineMinColumn(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineMaxColumn(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineMaxColumn(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineData(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineData(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLinesData(e, t, i) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t);
    const s = this.projectedModelLineLineCounts.getIndexOf(e - 1);
    let o = e;
    const r = s.index, a = s.remainder, l = [];
    for (let d = r, h = this.model.getLineCount(); d < h; d++) {
      const c = this.modelLineProjections[d];
      if (!c.isVisible()) continue;
      const u = d === r ? a : 0;
      let g = c.getViewLineCount() - u, p = !1;
      if (o + g > t && (p = !0, g = t - o + 1), c.getViewLinesData(this.model, d + 1, u, g, o - e, i, l), o += g, p) break;
    }
    return l;
  }
  validateViewPosition(e, t, i) {
    e = this._toValidViewLineNumber(e);
    const s = this.projectedModelLineLineCounts.getIndexOf(e - 1), o = s.index, r = s.remainder, a = this.modelLineProjections[o], l = a.getViewLineMinColumn(this.model, o + 1, r), d = a.getViewLineMaxColumn(this.model, o + 1, r);
    t < l && (t = l), t > d && (t = d);
    const h = a.getModelColumnOfViewPosition(r, t);
    return this.model.validatePosition(new W(o + 1, h)).equals(i) ? new W(e, t) : this.convertModelPositionToViewPosition(i.lineNumber, i.column);
  }
  validateViewRange(e, t) {
    const i = this.validateViewPosition(e.startLineNumber, e.startColumn, t.getStartPosition()), s = this.validateViewPosition(e.endLineNumber, e.endColumn, t.getEndPosition());
    return new D(i.lineNumber, i.column, s.lineNumber, s.column);
  }
  convertViewPositionToModelPosition(e, t) {
    const i = this.getViewLineInfo(e), s = this.modelLineProjections[i.modelLineNumber - 1].getModelColumnOfViewPosition(i.modelLineWrappedLineIdx, t);
    return this.model.validatePosition(new W(i.modelLineNumber, s));
  }
  convertViewRangeToModelRange(e) {
    const t = this.convertViewPositionToModelPosition(e.startLineNumber, e.startColumn), i = this.convertViewPositionToModelPosition(e.endLineNumber, e.endColumn);
    return new D(t.lineNumber, t.column, i.lineNumber, i.column);
  }
  convertModelPositionToViewPosition(e, t, i = 2, s = !1, o = !1) {
    const r = this.model.validatePosition(new W(e, t)), a = r.lineNumber, l = r.column;
    let d = a - 1, h = !1;
    if (o) for (; d < this.modelLineProjections.length && !this.modelLineProjections[d].isVisible(); ) d++, h = !0;
    else for (; d > 0 && !this.modelLineProjections[d].isVisible(); ) d--, h = !0;
    if (d === 0 && !this.modelLineProjections[d].isVisible()) return new W(s ? 0 : 1, 1);
    const c = 1 + this.projectedModelLineLineCounts.getPrefixSum(d);
    let u;
    return u = h ? o ? this.modelLineProjections[d].getViewPositionOfModelPosition(c, 1, i) : this.modelLineProjections[d].getViewPositionOfModelPosition(c, this.model.getLineMaxColumn(d + 1), i) : this.modelLineProjections[a - 1].getViewPositionOfModelPosition(c, l, i), u;
  }
  convertModelRangeToViewRange(e, t = 0) {
    if (e.isEmpty()) {
      const i = this.convertModelPositionToViewPosition(e.startLineNumber, e.startColumn, t);
      return D.fromPositions(i);
    }
    {
      const i = this.convertModelPositionToViewPosition(e.startLineNumber, e.startColumn, 1), s = this.convertModelPositionToViewPosition(e.endLineNumber, e.endColumn, 0);
      return new D(i.lineNumber, i.column, s.lineNumber, s.column);
    }
  }
  getViewLineNumberOfModelPosition(e, t) {
    let i = e - 1;
    if (this.modelLineProjections[i].isVisible()) {
      const o = 1 + this.projectedModelLineLineCounts.getPrefixSum(i);
      return this.modelLineProjections[i].getViewLineNumberOfModelPosition(o, t);
    }
    for (; i > 0 && !this.modelLineProjections[i].isVisible(); ) i--;
    if (i === 0 && !this.modelLineProjections[i].isVisible()) return 1;
    const s = 1 + this.projectedModelLineLineCounts.getPrefixSum(i);
    return this.modelLineProjections[i].getViewLineNumberOfModelPosition(s, this.model.getLineMaxColumn(i + 1));
  }
  getDecorationsInRange(e, t, i, s, o) {
    const r = this.convertViewPositionToModelPosition(e.startLineNumber, e.startColumn), a = this.convertViewPositionToModelPosition(e.endLineNumber, e.endColumn);
    if (a.lineNumber - r.lineNumber <= e.endLineNumber - e.startLineNumber) return this.model.getDecorationsInRange(new D(r.lineNumber, 1, a.lineNumber, a.column), t, i, s, o);
    let l = [];
    const d = r.lineNumber - 1, h = a.lineNumber - 1;
    let c = null;
    for (let f = d; f <= h; f++)
      if (this.modelLineProjections[f].isVisible()) c === null && (c = new W(f + 1, f === d ? r.column : 1));
      else if (c !== null) {
        const _ = this.model.getLineMaxColumn(f);
        l = l.concat(this.model.getDecorationsInRange(new D(c.lineNumber, c.column, f, _), t, i, s)), c = null;
      }
    c !== null && (l = l.concat(this.model.getDecorationsInRange(new D(c.lineNumber, c.column, a.lineNumber, a.column), t, i, s)), c = null), l.sort(((f, _) => {
      const v = D.compareRangesUsingStarts(f.range, _.range);
      return v === 0 ? f.id < _.id ? -1 : f.id > _.id ? 1 : 0 : v;
    }));
    const u = [];
    let g = 0, p = null;
    for (const f of l) {
      const _ = f.id;
      p !== _ && (p = _, u[g++] = f);
    }
    return u;
  }
  getInjectedTextAt(e) {
    const t = this.getViewLineInfo(e.lineNumber);
    return this.modelLineProjections[t.modelLineNumber - 1].getInjectedTextAt(t.modelLineWrappedLineIdx, e.column);
  }
  normalizePosition(e, t) {
    const i = this.getViewLineInfo(e.lineNumber);
    return this.modelLineProjections[i.modelLineNumber - 1].normalizePosition(i.modelLineWrappedLineIdx, e, t);
  }
  getLineIndentColumn(e) {
    const t = this.getViewLineInfo(e);
    return t.modelLineWrappedLineIdx === 0 ? this.model.getLineIndentColumn(t.modelLineNumber) : 0;
  }
}
class q5 {
  constructor(e, t) {
    this.modelLineNumber = e, this.modelLineWrappedLineIdx = t;
  }
}
class $5 {
  constructor(e, t) {
    this.modelRange = e, this.viewLines = t;
  }
}
class OQ {
  constructor(e) {
    this._lines = e;
  }
  convertViewPositionToModelPosition(e) {
    return this._lines.convertViewPositionToModelPosition(e.lineNumber, e.column);
  }
  convertViewRangeToModelRange(e) {
    return this._lines.convertViewRangeToModelRange(e);
  }
  validateViewPosition(e, t) {
    return this._lines.validateViewPosition(e.lineNumber, e.column, t);
  }
  validateViewRange(e, t) {
    return this._lines.validateViewRange(e, t);
  }
  convertModelPositionToViewPosition(e, t, i, s) {
    return this._lines.convertModelPositionToViewPosition(e.lineNumber, e.column, t, i, s);
  }
  convertModelRangeToViewRange(e, t) {
    return this._lines.convertModelRangeToViewRange(e, t);
  }
  modelPositionIsVisible(e) {
    return this._lines.modelPositionIsVisible(e.lineNumber, e.column);
  }
  getModelLineViewLineCount(e) {
    return this._lines.getModelLineViewLineCount(e);
  }
  getViewLineNumberOfModelPosition(e, t) {
    return this._lines.getViewLineNumberOfModelPosition(e, t);
  }
}
class FQ {
  constructor(e) {
    this.model = e;
  }
  dispose() {
  }
  createCoordinatesConverter() {
    return new BQ(this);
  }
  getHiddenAreas() {
    return [];
  }
  setHiddenAreas(e) {
    return !1;
  }
  setTabSize(e) {
    return !1;
  }
  setWrappingSettings(e, t, i, s) {
    return !1;
  }
  createLineBreaksComputer() {
    const e = [];
    return { addRequest: (t, i, s) => {
      e.push(null);
    }, finalize: () => e };
  }
  onModelFlushed() {
  }
  onModelLinesDeleted(e, t, i) {
    return new bI(t, i);
  }
  onModelLinesInserted(e, t, i, s) {
    return new CI(t, i);
  }
  onModelLineChanged(e, t, i) {
    return [!1, new cW(t, 1), null, null];
  }
  acceptVersionId(e) {
  }
  getViewLineCount() {
    return this.model.getLineCount();
  }
  getActiveIndentGuide(e, t, i) {
    return { startLineNumber: e, endLineNumber: e, indent: 0 };
  }
  getViewLinesBracketGuides(e, t, i) {
    return new Array(t - e + 1).fill([]);
  }
  getViewLinesIndentGuides(e, t) {
    const i = t - e + 1, s = new Array(i);
    for (let o = 0; o < i; o++) s[o] = 0;
    return s;
  }
  getViewLineContent(e) {
    return this.model.getLineContent(e);
  }
  getViewLineLength(e) {
    return this.model.getLineLength(e);
  }
  getViewLineMinColumn(e) {
    return this.model.getLineMinColumn(e);
  }
  getViewLineMaxColumn(e) {
    return this.model.getLineMaxColumn(e);
  }
  getViewLineData(e) {
    const t = this.model.tokenization.getLineTokens(e), i = t.getLineContent();
    return new MR(i, !1, 1, i.length + 1, 0, t.inflate(), null);
  }
  getViewLinesData(e, t, i) {
    const s = this.model.getLineCount();
    e = Math.min(Math.max(1, e), s), t = Math.min(Math.max(1, t), s);
    const o = [];
    for (let r = e; r <= t; r++) {
      const a = r - e;
      o[a] = i[a] ? this.getViewLineData(r) : null;
    }
    return o;
  }
  getDecorationsInRange(e, t, i, s, o) {
    return this.model.getDecorationsInRange(e, t, i, s, o);
  }
  normalizePosition(e, t) {
    return this.model.normalizePosition(e, t);
  }
  getLineIndentColumn(e) {
    return this.model.getLineIndentColumn(e);
  }
  getInjectedTextAt(e) {
    return null;
  }
}
class BQ {
  constructor(e) {
    this._lines = e;
  }
  _validPosition(e) {
    return this._lines.model.validatePosition(e);
  }
  _validRange(e) {
    return this._lines.model.validateRange(e);
  }
  convertViewPositionToModelPosition(e) {
    return this._validPosition(e);
  }
  convertViewRangeToModelRange(e) {
    return this._validRange(e);
  }
  validateViewPosition(e, t) {
    return this._validPosition(t);
  }
  validateViewRange(e, t) {
    return this._validRange(t);
  }
  convertModelPositionToViewPosition(e) {
    return this._validPosition(e);
  }
  convertModelRangeToViewRange(e) {
    return this._validRange(e);
  }
  modelPositionIsVisible(e) {
    const t = this._lines.model.getLineCount();
    return !(e.lineNumber < 1 || e.lineNumber > t);
  }
  getModelLineViewLineCount(e) {
    return 1;
  }
  getViewLineNumberOfModelPosition(e, t) {
    return e;
  }
}
const Kc = _l.Right;
class WQ {
  constructor(e) {
    this.persist = 0, this._requiredLanes = 1, this.lanes = new Uint8Array(Math.ceil((e + 1) * Kc / 8));
  }
  reset(e) {
    const t = Math.ceil((e + 1) * Kc / 8);
    this.lanes.length < t ? this.lanes = new Uint8Array(t) : this.lanes.fill(0), this._requiredLanes = 1;
  }
  get requiredLanes() {
    return this._requiredLanes;
  }
  push(e, t, i) {
    i && (this.persist |= 1 << e - 1);
    for (let s = t.startLineNumber; s <= t.endLineNumber; s++) {
      const o = Kc * s + (e - 1);
      this.lanes[o >>> 3] |= 1 << o % 8, this._requiredLanes = Math.max(this._requiredLanes, this.countAtLine(s));
    }
  }
  getLanesAtLine(e) {
    const t = [];
    let i = Kc * e;
    for (let s = 0; s < Kc; s++) (this.persist & 1 << s || this.lanes[i >>> 3] & 1 << i % 8) && t.push(s + 1), i++;
    return t.length ? t : [_l.Center];
  }
  countAtLine(e) {
    let t = Kc * e, i = 0;
    for (let s = 0; s < Kc; s++) (this.persist & 1 << s || this.lanes[t >>> 3] & 1 << t % 8) && i++, t++;
    return i;
  }
}
let VQ = class extends V {
  constructor(n, e, t, i, s, o, r, a, l) {
    if (super(), this.languageConfigurationService = r, this._themeService = a, this._attachedView = l, this.hiddenAreasModel = new zQ(), this.previousHiddenAreas = [], this._editorId = n, this._configuration = e, this.model = t, this._eventDispatcher = new gQ(), this.onEvent = this._eventDispatcher.onEvent, this.cursorConfig = new jg(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._updateConfigurationViewLineCount = this._register(new Et((() => this._updateConfigurationViewLineCountNow()), 0)), this._hasFocus = !1, this._viewportStart = hA.create(this.model), this.glyphLanes = new WQ(0), this.model.isTooLargeForTokenization()) this._lines = new FQ(this.model);
    else {
      const d = this._configuration.options, h = d.get(50), c = d.get(139), u = d.get(146), g = d.get(138), p = d.get(129);
      this._lines = new PQ(this._editorId, this.model, i, s, h, this.model.getOptions().tabSize, c, u.wrappingColumn, g, p);
    }
    this.coordinatesConverter = this._lines.createCoordinatesConverter(), this._cursor = this._register(new LQ(t, this, this.coordinatesConverter, this.cursorConfig)), this.viewLayout = this._register(new MQ(this._configuration, this.getLineCount(), o)), this._register(this.viewLayout.onDidScroll(((d) => {
      d.scrollTopChanged && this._handleVisibleLinesChanged(), d.scrollTopChanged && this._viewportStart.invalidate(), this._eventDispatcher.emitSingleViewEvent(new lQ(d)), this._eventDispatcher.emitOutgoingEvent(new rA(d.oldScrollWidth, d.oldScrollLeft, d.oldScrollHeight, d.oldScrollTop, d.scrollWidth, d.scrollLeft, d.scrollHeight, d.scrollTop));
    }))), this._register(this.viewLayout.onDidContentSizeChange(((d) => {
      this._eventDispatcher.emitOutgoingEvent(d);
    }))), this._decorations = new TQ(this._editorId, this.model, this._configuration, this._lines, this.coordinatesConverter), this._registerModelEvents(), this._register(this._configuration.onDidChangeFast(((d) => {
      try {
        const h = this._eventDispatcher.beginEmitViewEvents();
        this._onConfigurationChanged(h, d);
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
    }))), this._register(x1.getInstance().onDidChange((() => {
      this._eventDispatcher.emitSingleViewEvent(new cQ());
    }))), this._register(this._themeService.onDidColorThemeChange(((d) => {
      this._invalidateDecorationsColorCache(), this._eventDispatcher.emitSingleViewEvent(new dQ(d));
    }))), this._updateConfigurationViewLineCountNow();
  }
  dispose() {
    super.dispose(), this._decorations.dispose(), this._lines.dispose(), this._viewportStart.dispose(), this._eventDispatcher.dispose();
  }
  createLineBreaksComputer() {
    return this._lines.createLineBreaksComputer();
  }
  addViewEventHandler(n) {
    this._eventDispatcher.addViewEventHandler(n);
  }
  removeViewEventHandler(n) {
    this._eventDispatcher.removeViewEventHandler(n);
  }
  _updateConfigurationViewLineCountNow() {
    this._configuration.setViewLineCount(this._lines.getViewLineCount());
  }
  getModelVisibleRanges() {
    const n = this.viewLayout.getLinesViewportData(), e = new D(n.startLineNumber, this.getLineMinColumn(n.startLineNumber), n.endLineNumber, this.getLineMaxColumn(n.endLineNumber));
    return this._toModelVisibleRanges(e);
  }
  visibleLinesStabilized() {
    const n = this.getModelVisibleRanges();
    this._attachedView.setVisibleLines(n, !0);
  }
  _handleVisibleLinesChanged() {
    const n = this.getModelVisibleRanges();
    this._attachedView.setVisibleLines(n, !1);
  }
  setHasFocus(n) {
    this._hasFocus = n, this._cursor.setHasFocus(n), this._eventDispatcher.emitSingleViewEvent(new rQ(n)), this._eventDispatcher.emitOutgoingEvent(new oA(!n, n));
  }
  onCompositionStart() {
    this._eventDispatcher.emitSingleViewEvent(new iQ());
  }
  onCompositionEnd() {
    this._eventDispatcher.emitSingleViewEvent(new nQ());
  }
  _captureStableViewport() {
    if (this._viewportStart.isValid && this.viewLayout.getCurrentScrollTop() > 0) {
      const n = new W(this._viewportStart.viewLineNumber, this.getLineMinColumn(this._viewportStart.viewLineNumber)), e = this.coordinatesConverter.convertViewPositionToModelPosition(n);
      return new Z5(e, this._viewportStart.startLineDelta);
    }
    return new Z5(null, 0);
  }
  _onConfigurationChanged(n, e) {
    const t = this._captureStableViewport(), i = this._configuration.options, s = i.get(50), o = i.get(139), r = i.get(146), a = i.get(138), l = i.get(129);
    this._lines.setWrappingSettings(s, o, r.wrappingColumn, a, l) && (n.emitViewEvent(new Sb()), n.emitViewEvent(new Lb()), n.emitViewEvent(new Uc(null)), this._cursor.onLineMappingChanged(n), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount()), this._updateConfigurationViewLineCount.schedule()), e.hasChanged(91) && (this._decorations.reset(), n.emitViewEvent(new Uc(null))), e.hasChanged(98) && (this._decorations.reset(), n.emitViewEvent(new Uc(null))), n.emitViewEvent(new sQ(e)), this.viewLayout.onConfigurationChanged(e), t.recoverViewportStart(this.coordinatesConverter, this.viewLayout), jg.shouldRecreate(e) && (this.cursorConfig = new jg(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig));
  }
  _registerModelEvents() {
    this._register(this.model.onDidChangeContentOrInjectedText(((n) => {
      try {
        const t = this._eventDispatcher.beginEmitViewEvents();
        let i = !1, s = !1;
        const o = n instanceof ju ? n.rawContentChangedEvent.changes : n.changes, r = n instanceof ju ? n.rawContentChangedEvent.versionId : null, a = this._lines.createLineBreaksComputer();
        for (const h of o) switch (h.changeType) {
          case 4:
            for (let c = 0; c < h.detail.length; c++) {
              const u = h.detail[c];
              let g = h.injectedTexts[c];
              g && (g = g.filter(((p) => !p.ownerId || p.ownerId === this._editorId))), a.addRequest(u, g, null);
            }
            break;
          case 2: {
            let c = null;
            h.injectedText && (c = h.injectedText.filter(((u) => !u.ownerId || u.ownerId === this._editorId))), a.addRequest(h.detail, c, null);
            break;
          }
        }
        const l = a.finalize(), d = new Pd(l);
        for (const h of o) switch (h.changeType) {
          case 1:
            this._lines.onModelFlushed(), t.emitViewEvent(new Sb()), this._decorations.reset(), this.viewLayout.onFlushed(this.getLineCount()), i = !0;
            break;
          case 3: {
            const c = this._lines.onModelLinesDeleted(r, h.fromLineNumber, h.toLineNumber);
            c !== null && (t.emitViewEvent(c), this.viewLayout.onLinesDeleted(c.fromLineNumber, c.toLineNumber)), i = !0;
            break;
          }
          case 4: {
            const c = d.takeCount(h.detail.length), u = this._lines.onModelLinesInserted(r, h.fromLineNumber, h.toLineNumber, c);
            u !== null && (t.emitViewEvent(u), this.viewLayout.onLinesInserted(u.fromLineNumber, u.toLineNumber)), i = !0;
            break;
          }
          case 2: {
            const c = d.dequeue(), [u, g, p, f] = this._lines.onModelLineChanged(r, h.lineNumber, c);
            s = u, g && t.emitViewEvent(g), p && (t.emitViewEvent(p), this.viewLayout.onLinesInserted(p.fromLineNumber, p.toLineNumber)), f && (t.emitViewEvent(f), this.viewLayout.onLinesDeleted(f.fromLineNumber, f.toLineNumber));
            break;
          }
        }
        r !== null && this._lines.acceptVersionId(r), this.viewLayout.onHeightMaybeChanged(), !i && s && (t.emitViewEvent(new Lb()), t.emitViewEvent(new Uc(null)), this._cursor.onLineMappingChanged(t), this._decorations.onLineMappingChanged());
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
      const e = this._viewportStart.isValid;
      if (this._viewportStart.invalidate(), this._configuration.setModelLineCount(this.model.getLineCount()), this._updateConfigurationViewLineCountNow(), !this._hasFocus && this.model.getAttachedEditorCount() >= 2 && e) {
        const t = this.model._getTrackedRange(this._viewportStart.modelTrackedRange);
        if (t) {
          const i = this.coordinatesConverter.convertModelPositionToViewPosition(t.getStartPosition()), s = this.viewLayout.getVerticalOffsetForLineNumber(i.lineNumber);
          this.viewLayout.setScrollPosition({ scrollTop: s + this._viewportStart.startLineDelta }, 1);
        }
      }
      try {
        const t = this._eventDispatcher.beginEmitViewEvents();
        n instanceof ju && t.emitOutgoingEvent(new wQ(n.contentChangedEvent)), this._cursor.onModelContentChanged(t, n);
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
      this._handleVisibleLinesChanged();
    }))), this._register(this.model.onDidChangeTokens(((n) => {
      const e = [];
      for (let t = 0, i = n.ranges.length; t < i; t++) {
        const s = n.ranges[t], o = this.coordinatesConverter.convertModelPositionToViewPosition(new W(s.fromLineNumber, 1)).lineNumber, r = this.coordinatesConverter.convertModelPositionToViewPosition(new W(s.toLineNumber, this.model.getLineMaxColumn(s.toLineNumber))).lineNumber;
        e[t] = { fromLineNumber: o, toLineNumber: r };
      }
      this._eventDispatcher.emitSingleViewEvent(new hQ(e)), this._eventDispatcher.emitOutgoingEvent(new SQ(n));
    }))), this._register(this.model.onDidChangeLanguageConfiguration(((n) => {
      this._eventDispatcher.emitSingleViewEvent(new aQ()), this.cursorConfig = new jg(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new CQ(n));
    }))), this._register(this.model.onDidChangeLanguage(((n) => {
      this.cursorConfig = new jg(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new bQ(n));
    }))), this._register(this.model.onDidChangeOptions(((n) => {
      if (this._lines.setTabSize(this.model.getOptions().tabSize)) {
        try {
          const e = this._eventDispatcher.beginEmitViewEvents();
          e.emitViewEvent(new Sb()), e.emitViewEvent(new Lb()), e.emitViewEvent(new Uc(null)), this._cursor.onLineMappingChanged(e), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount());
        } finally {
          this._eventDispatcher.endEmitViewEvents();
        }
        this._updateConfigurationViewLineCount.schedule();
      }
      this.cursorConfig = new jg(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new yQ(n));
    }))), this._register(this.model.onDidChangeDecorations(((n) => {
      this._decorations.onModelDecorationsChanged(), this._eventDispatcher.emitSingleViewEvent(new Uc(n)), this._eventDispatcher.emitOutgoingEvent(new vQ(n));
    })));
  }
  setHiddenAreas(n, e) {
    var t;
    this.hiddenAreasModel.setHiddenAreas(e, n);
    const i = this.hiddenAreasModel.getMergedRanges();
    if (i === this.previousHiddenAreas) return;
    this.previousHiddenAreas = i;
    const s = this._captureStableViewport();
    let o = !1;
    try {
      const r = this._eventDispatcher.beginEmitViewEvents();
      o = this._lines.setHiddenAreas(i), o && (r.emitViewEvent(new Sb()), r.emitViewEvent(new Lb()), r.emitViewEvent(new Uc(null)), this._cursor.onLineMappingChanged(r), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount()), this.viewLayout.onHeightMaybeChanged());
      const a = (t = s.viewportStartModelPosition) === null || t === void 0 ? void 0 : t.lineNumber;
      a && i.some(((d) => d.startLineNumber <= a && a <= d.endLineNumber)) || s.recoverViewportStart(this.coordinatesConverter, this.viewLayout);
    } finally {
      this._eventDispatcher.endEmitViewEvents();
    }
    this._updateConfigurationViewLineCount.schedule(), o && this._eventDispatcher.emitOutgoingEvent(new fQ());
  }
  getVisibleRangesPlusViewportAboveBelow() {
    const n = this._configuration.options.get(145), e = this._configuration.options.get(67), t = Math.max(20, Math.round(n.height / e)), i = this.viewLayout.getLinesViewportData(), s = Math.max(1, i.completelyVisibleStartLineNumber - t), o = Math.min(this.getLineCount(), i.completelyVisibleEndLineNumber + t);
    return this._toModelVisibleRanges(new D(s, this.getLineMinColumn(s), o, this.getLineMaxColumn(o)));
  }
  getVisibleRanges() {
    const n = this.getCompletelyVisibleViewRange();
    return this._toModelVisibleRanges(n);
  }
  getHiddenAreas() {
    return this._lines.getHiddenAreas();
  }
  _toModelVisibleRanges(n) {
    const e = this.coordinatesConverter.convertViewRangeToModelRange(n), t = this._lines.getHiddenAreas();
    if (t.length === 0) return [e];
    const i = [];
    let s = 0, o = e.startLineNumber, r = e.startColumn;
    const a = e.endLineNumber, l = e.endColumn;
    for (let d = 0, h = t.length; d < h; d++) {
      const c = t[d].startLineNumber, u = t[d].endLineNumber;
      u < o || c > a || (o < c && (i[s++] = new D(o, r, c - 1, this.model.getLineMaxColumn(c - 1))), o = u + 1, r = 1);
    }
    return (o < a || o === a && r < l) && (i[s++] = new D(o, r, a, l)), i;
  }
  getCompletelyVisibleViewRange() {
    const n = this.viewLayout.getLinesViewportData(), e = n.completelyVisibleStartLineNumber, t = n.completelyVisibleEndLineNumber;
    return new D(e, this.getLineMinColumn(e), t, this.getLineMaxColumn(t));
  }
  getCompletelyVisibleViewRangeAtScrollTop(n) {
    const e = this.viewLayout.getLinesViewportDataAtScrollTop(n), t = e.completelyVisibleStartLineNumber, i = e.completelyVisibleEndLineNumber;
    return new D(t, this.getLineMinColumn(t), i, this.getLineMaxColumn(i));
  }
  saveState() {
    const n = this.viewLayout.saveState(), e = n.scrollTop, t = this.viewLayout.getLineNumberAtVerticalOffset(e), i = this.coordinatesConverter.convertViewPositionToModelPosition(new W(t, this.getLineMinColumn(t))), s = this.viewLayout.getVerticalOffsetForLineNumber(t) - e;
    return { scrollLeft: n.scrollLeft, firstPosition: i, firstPositionDeltaTop: s };
  }
  reduceRestoreState(n) {
    if (n.firstPosition === void 0) return this._reduceRestoreStateCompatibility(n);
    const e = this.model.validatePosition(n.firstPosition), t = this.coordinatesConverter.convertModelPositionToViewPosition(e), i = this.viewLayout.getVerticalOffsetForLineNumber(t.lineNumber) - n.firstPositionDeltaTop;
    return { scrollLeft: n.scrollLeft, scrollTop: i };
  }
  _reduceRestoreStateCompatibility(n) {
    return { scrollLeft: n.scrollLeft, scrollTop: n.scrollTopWithoutViewZones };
  }
  getTabSize() {
    return this.model.getOptions().tabSize;
  }
  getLineCount() {
    return this._lines.getViewLineCount();
  }
  setViewport(n, e, t) {
    this._viewportStart.update(this, n);
  }
  getActiveIndentGuide(n, e, t) {
    return this._lines.getActiveIndentGuide(n, e, t);
  }
  getLinesIndentGuides(n, e) {
    return this._lines.getViewLinesIndentGuides(n, e);
  }
  getBracketGuidesInRangeByLine(n, e, t, i) {
    return this._lines.getViewLinesBracketGuides(n, e, t, i);
  }
  getLineContent(n) {
    return this._lines.getViewLineContent(n);
  }
  getLineLength(n) {
    return this._lines.getViewLineLength(n);
  }
  getLineMinColumn(n) {
    return this._lines.getViewLineMinColumn(n);
  }
  getLineMaxColumn(n) {
    return this._lines.getViewLineMaxColumn(n);
  }
  getLineFirstNonWhitespaceColumn(n) {
    const e = Jn(this.getLineContent(n));
    return e === -1 ? 0 : e + 1;
  }
  getLineLastNonWhitespaceColumn(n) {
    const e = oa(this.getLineContent(n));
    return e === -1 ? 0 : e + 2;
  }
  getMinimapDecorationsInRange(n) {
    return this._decorations.getMinimapDecorationsInRange(n);
  }
  getDecorationsInViewport(n) {
    return this._decorations.getDecorationsViewportData(n).decorations;
  }
  getInjectedTextAt(n) {
    return this._lines.getInjectedTextAt(n);
  }
  getViewportViewLineRenderingData(n, e) {
    const t = this._decorations.getDecorationsViewportData(n).inlineDecorations[e - n.startLineNumber];
    return this._getViewLineRenderingData(e, t);
  }
  getViewLineRenderingData(n) {
    const e = this._decorations.getInlineDecorationsOnLine(n);
    return this._getViewLineRenderingData(n, e);
  }
  _getViewLineRenderingData(n, e) {
    const t = this.model.mightContainRTL(), i = this.model.mightContainNonBasicASCII(), s = this.getTabSize(), o = this._lines.getViewLineData(n);
    return o.inlineDecorations && (e = [...e, ...o.inlineDecorations.map(((r) => r.toInlineDecoration(n)))]), new Co(o.minColumn, o.maxColumn, o.content, o.continuesWithWrappedLine, t, i, o.tokens, e, s, o.startVisibleColumn);
  }
  getViewLineData(n) {
    return this._lines.getViewLineData(n);
  }
  getMinimapLinesRenderingData(n, e, t) {
    const i = this._lines.getViewLinesData(n, e, t);
    return new Zq(this.getTabSize(), i);
  }
  getAllOverviewRulerDecorations(n) {
    const e = this.model.getOverviewRulerDecorations(this._editorId, Nw(this._configuration.options)), t = new HQ();
    for (const i of e) {
      const s = i.options, o = s.overviewRuler;
      if (!o) continue;
      const r = o.position;
      if (r === 0) continue;
      const a = o.getColor(n.value), l = this.coordinatesConverter.getViewLineNumberOfModelPosition(i.range.startLineNumber, i.range.startColumn), d = this.coordinatesConverter.getViewLineNumberOfModelPosition(i.range.endLineNumber, i.range.endColumn);
      t.accept(a, s.zIndex, l, d, r);
    }
    return t.asArray;
  }
  _invalidateDecorationsColorCache() {
    const n = this.model.getOverviewRulerDecorations();
    for (const e of n) {
      const t = e.options.overviewRuler;
      t?.invalidateCachedColor();
      const i = e.options.minimap;
      i?.invalidateCachedColor();
    }
  }
  getValueInRange(n, e) {
    const t = this.coordinatesConverter.convertViewRangeToModelRange(n);
    return this.model.getValueInRange(t, e);
  }
  getValueLengthInRange(n, e) {
    const t = this.coordinatesConverter.convertViewRangeToModelRange(n);
    return this.model.getValueLengthInRange(t, e);
  }
  modifyPosition(n, e) {
    const t = this.coordinatesConverter.convertViewPositionToModelPosition(n), i = this.model.modifyPosition(t, e);
    return this.coordinatesConverter.convertModelPositionToViewPosition(i);
  }
  deduceModelPositionRelativeToViewPosition(n, e, t) {
    const i = this.coordinatesConverter.convertViewPositionToModelPosition(n);
    this.model.getEOL().length === 2 && (e < 0 ? e -= t : e += t);
    const s = this.model.getOffsetAt(i) + e;
    return this.model.getPositionAt(s);
  }
  getPlainTextToCopy(n, e, t) {
    const i = t ? `\r
` : this.model.getEOL();
    (n = n.slice(0)).sort(D.compareRangesUsingStarts);
    let s = !1, o = !1;
    for (const a of n) a.isEmpty() ? s = !0 : o = !0;
    if (!o) {
      if (!e) return "";
      const a = n.map(((d) => d.startLineNumber));
      let l = "";
      for (let d = 0; d < a.length; d++) d > 0 && a[d - 1] === a[d] || (l += this.model.getLineContent(a[d]) + i);
      return l;
    }
    if (s && e) {
      const a = [];
      let l = 0;
      for (const d of n) {
        const h = d.startLineNumber;
        d.isEmpty() ? h !== l && a.push(this.model.getLineContent(h)) : a.push(this.model.getValueInRange(d, t ? 2 : 0)), l = h;
      }
      return a.length === 1 ? a[0] : a;
    }
    const r = [];
    for (const a of n) a.isEmpty() || r.push(this.model.getValueInRange(a, t ? 2 : 0));
    return r.length === 1 ? r[0] : r;
  }
  getRichTextToCopy(n, e) {
    const t = this.model.getLanguageId();
    if (t === ko || n.length !== 1) return null;
    let i = n[0];
    if (i.isEmpty()) {
      if (!e) return null;
      const a = i.startLineNumber;
      i = new D(a, this.model.getLineMinColumn(a), a, this.model.getLineMaxColumn(a));
    }
    const s = this._configuration.options.get(50), o = this._getColorMap();
    let r;
    return /[:;\\\/<>]/.test(s.fontFamily) || s.fontFamily === Is.fontFamily ? r = Is.fontFamily : (r = s.fontFamily, r = r.replace(/"/g, "'"), /[,']/.test(r) || /[+ ]/.test(r) && (r = `'${r}'`), r = `${r}, ${Is.fontFamily}`), { mode: t, html: `<div style="color: ${o[1]};background-color: ${o[2]};font-family: ${r};font-weight: ${s.fontWeight};font-size: ${s.fontSize}px;line-height: ${s.lineHeight}px;white-space: pre;">` + this._getHTMLToCopy(i, o) + "</div>" };
  }
  _getHTMLToCopy(n, e) {
    const t = n.startLineNumber, i = n.startColumn, s = n.endLineNumber, o = n.endColumn, r = this.getTabSize();
    let a = "";
    for (let l = t; l <= s; l++) {
      const d = this.model.tokenization.getLineTokens(l), h = d.getLineContent(), c = l === t ? i - 1 : 0, u = l === s ? o - 1 : h.length;
      a += h === "" ? "<br>" : xQ(h, d.inflate(), e, c, u, r, Tn);
    }
    return a;
  }
  _getColorMap() {
    const n = ci.getColorMap(), e = ["#000000"];
    if (n) for (let t = 1, i = n.length; t < i; t++) e[t] = z.Format.CSS.formatHex(n[t]);
    return e;
  }
  getPrimaryCursorState() {
    return this._cursor.getPrimaryCursorState();
  }
  getLastAddedCursorIndex() {
    return this._cursor.getLastAddedCursorIndex();
  }
  getCursorStates() {
    return this._cursor.getCursorStates();
  }
  setCursorStates(n, e, t) {
    return this._withViewEventsCollector(((i) => this._cursor.setStates(i, n, e, t)));
  }
  getCursorColumnSelectData() {
    return this._cursor.getCursorColumnSelectData();
  }
  getCursorAutoClosedCharacters() {
    return this._cursor.getAutoClosedCharacters();
  }
  setCursorColumnSelectData(n) {
    this._cursor.setCursorColumnSelectData(n);
  }
  getPrevEditOperationType() {
    return this._cursor.getPrevEditOperationType();
  }
  setPrevEditOperationType(n) {
    this._cursor.setPrevEditOperationType(n);
  }
  getSelection() {
    return this._cursor.getSelection();
  }
  getSelections() {
    return this._cursor.getSelections();
  }
  getPosition() {
    return this._cursor.getPrimaryCursorState().modelState.position;
  }
  setSelections(n, e, t = 0) {
    this._withViewEventsCollector(((i) => this._cursor.setSelections(i, n, e, t)));
  }
  saveCursorState() {
    return this._cursor.saveState();
  }
  restoreCursorState(n) {
    this._withViewEventsCollector(((e) => this._cursor.restoreState(e, n)));
  }
  _executeCursorEdit(n) {
    this._cursor.context.cursorConfig.readOnly ? this._eventDispatcher.emitOutgoingEvent(new _Q()) : this._withViewEventsCollector(n);
  }
  executeEdits(n, e, t) {
    this._executeCursorEdit(((i) => this._cursor.executeEdits(i, n, e, t)));
  }
  startComposition() {
    this._executeCursorEdit(((n) => this._cursor.startComposition(n)));
  }
  endComposition(n) {
    this._executeCursorEdit(((e) => this._cursor.endComposition(e, n)));
  }
  type(n, e) {
    this._executeCursorEdit(((t) => this._cursor.type(t, n, e)));
  }
  compositionType(n, e, t, i, s) {
    this._executeCursorEdit(((o) => this._cursor.compositionType(o, n, e, t, i, s)));
  }
  paste(n, e, t, i) {
    this._executeCursorEdit(((s) => this._cursor.paste(s, n, e, t, i)));
  }
  cut(n) {
    this._executeCursorEdit(((e) => this._cursor.cut(e, n)));
  }
  executeCommand(n, e) {
    this._executeCursorEdit(((t) => this._cursor.executeCommand(t, n, e)));
  }
  executeCommands(n, e) {
    this._executeCursorEdit(((t) => this._cursor.executeCommands(t, n, e)));
  }
  revealAllCursors(n, e, t = !1) {
    this._withViewEventsCollector(((i) => this._cursor.revealAll(i, n, t, 0, e, 0)));
  }
  revealPrimaryCursor(n, e, t = !1) {
    this._withViewEventsCollector(((i) => this._cursor.revealPrimary(i, n, t, 0, e, 0)));
  }
  revealTopMostCursor(n) {
    const e = this._cursor.getTopMostViewPosition(), t = new D(e.lineNumber, e.column, e.lineNumber, e.column);
    this._withViewEventsCollector(((i) => i.emitViewEvent(new c0(n, !1, t, null, 0, !0, 0))));
  }
  revealBottomMostCursor(n) {
    const e = this._cursor.getBottomMostViewPosition(), t = new D(e.lineNumber, e.column, e.lineNumber, e.column);
    this._withViewEventsCollector(((i) => i.emitViewEvent(new c0(n, !1, t, null, 0, !0, 0))));
  }
  revealRange(n, e, t, i, s) {
    this._withViewEventsCollector(((o) => o.emitViewEvent(new c0(n, !1, t, null, i, e, s))));
  }
  changeWhitespace(n) {
    this.viewLayout.changeWhitespace(n) && (this._eventDispatcher.emitSingleViewEvent(new uQ()), this._eventDispatcher.emitOutgoingEvent(new mQ()));
  }
  _withViewEventsCollector(n) {
    try {
      return n(this._eventDispatcher.beginEmitViewEvents());
    } finally {
      this._eventDispatcher.endEmitViewEvents();
    }
  }
  normalizePosition(n, e) {
    return this._lines.normalizePosition(n, e);
  }
  getLineIndentColumn(n) {
    return this._lines.getLineIndentColumn(n);
  }
};
class hA {
  static create(e) {
    const t = e._setTrackedRange(null, new D(1, 1, 1, 1), 1);
    return new hA(e, 1, !1, t, 0);
  }
  get viewLineNumber() {
    return this._viewLineNumber;
  }
  get isValid() {
    return this._isValid;
  }
  get modelTrackedRange() {
    return this._modelTrackedRange;
  }
  get startLineDelta() {
    return this._startLineDelta;
  }
  constructor(e, t, i, s, o) {
    this._model = e, this._viewLineNumber = t, this._isValid = i, this._modelTrackedRange = s, this._startLineDelta = o;
  }
  dispose() {
    this._model._setTrackedRange(this._modelTrackedRange, null, 1);
  }
  update(e, t) {
    const i = e.coordinatesConverter.convertViewPositionToModelPosition(new W(t, e.getLineMinColumn(t))), s = e.model._setTrackedRange(this._modelTrackedRange, new D(i.lineNumber, i.column, i.lineNumber, i.column), 1), o = e.viewLayout.getVerticalOffsetForLineNumber(t), r = e.viewLayout.getCurrentScrollTop();
    this._viewLineNumber = t, this._isValid = !0, this._modelTrackedRange = s, this._startLineDelta = r - o;
  }
  invalidate() {
    this._isValid = !1;
  }
}
class HQ {
  constructor() {
    this._asMap = /* @__PURE__ */ Object.create(null), this.asArray = [];
  }
  accept(e, t, i, s, o) {
    const r = this._asMap[e];
    if (r) {
      const a = r.data, l = a[a.length - 3], d = a[a.length - 1];
      if (l === o && d + 1 >= i) return void (s > d && (a[a.length - 1] = s));
      a.push(o, i, s);
    } else {
      const a = new av(e, t, [o, i, s]);
      this._asMap[e] = a, this.asArray.push(a);
    }
  }
}
class zQ {
  constructor() {
    this.hiddenAreas = /* @__PURE__ */ new Map(), this.shouldRecompute = !1, this.ranges = [];
  }
  setHiddenAreas(e, t) {
    const i = this.hiddenAreas.get(e);
    i && G5(i, t) || (this.hiddenAreas.set(e, t), this.shouldRecompute = !0);
  }
  getMergedRanges() {
    if (!this.shouldRecompute) return this.ranges;
    this.shouldRecompute = !1;
    const e = Array.from(this.hiddenAreas.values()).reduce(((t, i) => (function(s, o) {
      const r = [];
      let a = 0, l = 0;
      for (; a < s.length && l < o.length; ) {
        const d = s[a], h = o[l];
        if (d.endLineNumber < h.startLineNumber - 1) r.push(s[a++]);
        else if (h.endLineNumber < d.startLineNumber - 1) r.push(o[l++]);
        else {
          const c = Math.min(d.startLineNumber, h.startLineNumber), u = Math.max(d.endLineNumber, h.endLineNumber);
          r.push(new D(c, 1, u, 1)), a++, l++;
        }
      }
      for (; a < s.length; ) r.push(s[a++]);
      for (; l < o.length; ) r.push(o[l++]);
      return r;
    })(t, i)), []);
    return G5(this.ranges, e) || (this.ranges = e), this.ranges;
  }
}
function G5(n, e) {
  if (n.length !== e.length) return !1;
  for (let t = 0; t < n.length; t++) if (!n[t].equalsRange(e[t])) return !1;
  return !0;
}
class Z5 {
  constructor(e, t) {
    this.viewportStartModelPosition = e, this.startLineDelta = t;
  }
  recoverViewportStart(e, t) {
    if (!this.viewportStartModelPosition) return;
    const i = e.convertModelPositionToViewPosition(this.viewportStartModelPosition), s = t.getVerticalOffsetForLineNumber(i.lineNumber);
    t.setScrollPosition({ scrollTop: s + this.startLineDelta }, 1);
  }
}
class N1 {
  constructor(...e) {
    this._entries = /* @__PURE__ */ new Map();
    for (const [t, i] of e) this.set(t, i);
  }
  set(e, t) {
    const i = this._entries.get(e);
    return this._entries.set(e, t), i;
  }
  get(e) {
    return this._entries.get(e);
  }
}
var D_;
(function(n) {
  n[n.Ignore = 0] = "Ignore", n[n.Info = 1] = "Info", n[n.Warning = 2] = "Warning", n[n.Error = 3] = "Error";
})(D_ || (D_ = {})), (function(n) {
  const e = "error", t = "warning", i = "info";
  n.fromValue = function(s) {
    return s ? Lp(e, s) ? n.Error : Lp(t, s) || Lp("warn", s) ? n.Warning : Lp(i, s) ? n.Info : n.Ignore : n.Ignore;
  }, n.toString = function(s) {
    switch (s) {
      case n.Error:
        return e;
      case n.Warning:
        return t;
      case n.Info:
        return i;
      default:
        return "ignore";
    }
  };
})(D_ || (D_ = {}));
const ki = D_;
var pL = ki;
const Ri = tt("notificationService");
var ru, UQ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Nl = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let um = ru = class extends V {
  get isSimpleWidget() {
    return this._configuration.isSimpleWidget;
  }
  constructor(n, e, t, i, s, o, r, a, l, d, h, c) {
    var u;
    super(), this.languageConfigurationService = h, this._deliveryQueue = new O7(), this._contributions = this._register(new nX()), this._onDidDispose = this._register(new F()), this.onDidDispose = this._onDidDispose.event, this._onDidChangeModelContent = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelContent = this._onDidChangeModelContent.event, this._onDidChangeModelLanguage = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelLanguage = this._onDidChangeModelLanguage.event, this._onDidChangeModelLanguageConfiguration = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelLanguageConfiguration = this._onDidChangeModelLanguageConfiguration.event, this._onDidChangeModelOptions = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelOptions = this._onDidChangeModelOptions.event, this._onDidChangeModelDecorations = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelDecorations = this._onDidChangeModelDecorations.event, this._onDidChangeModelTokens = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelTokens = this._onDidChangeModelTokens.event, this._onDidChangeConfiguration = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeConfiguration = this._onDidChangeConfiguration.event, this._onWillChangeModel = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onWillChangeModel = this._onWillChangeModel.event, this._onDidChangeModel = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModel = this._onDidChangeModel.event, this._onDidChangeCursorPosition = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeCursorPosition = this._onDidChangeCursorPosition.event, this._onDidChangeCursorSelection = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeCursorSelection = this._onDidChangeCursorSelection.event, this._onDidAttemptReadOnlyEdit = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDidAttemptReadOnlyEdit = this._onDidAttemptReadOnlyEdit.event, this._onDidLayoutChange = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidLayoutChange = this._onDidLayoutChange.event, this._editorTextFocus = this._register(new Y5({ deliveryQueue: this._deliveryQueue })), this.onDidFocusEditorText = this._editorTextFocus.onDidChangeToTrue, this.onDidBlurEditorText = this._editorTextFocus.onDidChangeToFalse, this._editorWidgetFocus = this._register(new Y5({ deliveryQueue: this._deliveryQueue })), this.onDidFocusEditorWidget = this._editorWidgetFocus.onDidChangeToTrue, this.onDidBlurEditorWidget = this._editorWidgetFocus.onDidChangeToFalse, this._onWillType = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onWillType = this._onWillType.event, this._onDidType = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDidType = this._onDidType.event, this._onDidCompositionStart = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDidCompositionStart = this._onDidCompositionStart.event, this._onDidCompositionEnd = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDidCompositionEnd = this._onDidCompositionEnd.event, this._onDidPaste = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDidPaste = this._onDidPaste.event, this._onMouseUp = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseUp = this._onMouseUp.event, this._onMouseDown = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseDown = this._onMouseDown.event, this._onMouseDrag = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseDrag = this._onMouseDrag.event, this._onMouseDrop = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseDrop = this._onMouseDrop.event, this._onMouseDropCanceled = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseDropCanceled = this._onMouseDropCanceled.event, this._onDropIntoEditor = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDropIntoEditor = this._onDropIntoEditor.event, this._onContextMenu = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onContextMenu = this._onContextMenu.event, this._onMouseMove = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseMove = this._onMouseMove.event, this._onMouseLeave = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseLeave = this._onMouseLeave.event, this._onMouseWheel = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseWheel = this._onMouseWheel.event, this._onKeyUp = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onKeyUp = this._onKeyUp.event, this._onKeyDown = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onKeyDown = this._onKeyDown.event, this._onDidContentSizeChange = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidContentSizeChange = this._onDidContentSizeChange.event, this._onDidScrollChange = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidScrollChange = this._onDidScrollChange.event, this._onDidChangeViewZones = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeViewZones = this._onDidChangeViewZones.event, this._onDidChangeHiddenAreas = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeHiddenAreas = this._onDidChangeHiddenAreas.event, this._actions = /* @__PURE__ */ new Map(), this._bannerDomNode = null, this._dropIntoEditorDecorations = this.createDecorationsCollection(), s.willCreateCodeEditor();
    const g = { ...e };
    let p;
    this._domElement = n, this._overflowWidgetsDomNode = g.overflowWidgetsDomNode, delete g.overflowWidgetsDomNode, this._id = ++KQ, this._decorationTypeKeysToIds = {}, this._decorationTypeSubtypes = {}, this._telemetryData = t.telemetryData, this._configuration = this._register(this._createConfiguration(t.isSimpleWidget || !1, g, d)), this._register(this._configuration.onDidChange(((_) => {
      this._onDidChangeConfiguration.fire(_);
      const v = this._configuration.options;
      if (_.hasChanged(145)) {
        const b = v.get(145);
        this._onDidLayoutChange.fire(b);
      }
    }))), this._contextKeyService = this._register(r.createScoped(this._domElement)), this._notificationService = l, this._codeEditorService = s, this._commandService = o, this._themeService = a, this._register(new qQ(this, this._contextKeyService)), this._register(new $Q(this, this._contextKeyService, c)), this._instantiationService = i.createChild(new N1([Te, this._contextKeyService])), this._modelData = null, this._focusTracker = new GQ(n, this._overflowWidgetsDomNode), this._register(this._focusTracker.onChange((() => {
      this._editorWidgetFocus.setValue(this._focusTracker.hasFocus());
    }))), this._contentWidgets = {}, this._overlayWidgets = {}, this._glyphMarginWidgets = {}, p = Array.isArray(t.contributions) ? t.contributions : Xp.getEditorContributions(), this._contributions.initialize(this, p, this._instantiationService);
    for (const _ of Xp.getEditorActions()) {
      if (this._actions.has(_.id)) {
        We(new Error(`Cannot have two actions with the same id ${_.id}`));
        continue;
      }
      const v = new GB(_.id, _.label, _.alias, _.metadata, (u = _.precondition) !== null && u !== void 0 ? u : void 0, ((b) => this._instantiationService.invokeFunction(((C) => Promise.resolve(_.runEditorCommand(C, this, b))))), this._contextKeyService);
      this._actions.set(v.id, v);
    }
    const f = () => !this._configuration.options.get(91) && this._configuration.options.get(36).enabled;
    this._register(new mj(this._domElement, { onDragOver: (_) => {
      if (!f()) return;
      const v = this.getTargetAtClientPoint(_.clientX, _.clientY);
      v?.position && this.showDropIndicatorAt(v.position);
    }, onDrop: async (_) => {
      if (!f() || (this.removeDropIndicator(), !_.dataTransfer)) return;
      const v = this.getTargetAtClientPoint(_.clientX, _.clientY);
      v?.position && this._onDropIntoEditor.fire({ position: v.position, event: _ });
    }, onDragLeave: () => {
      this.removeDropIndicator();
    }, onDragEnd: () => {
      this.removeDropIndicator();
    } })), this._codeEditorService.addCodeEditor(this);
  }
  writeScreenReaderContent(n) {
    var e;
    (e = this._modelData) === null || e === void 0 || e.view.writeScreenReaderContent(n);
  }
  _createConfiguration(n, e, t) {
    return new GE(n, e, this._domElement, t);
  }
  getId() {
    return this.getEditorType() + ":" + this._id;
  }
  getEditorType() {
    return b1.ICodeEditor;
  }
  dispose() {
    this._codeEditorService.removeCodeEditor(this), this._focusTracker.dispose(), this._actions.clear(), this._contentWidgets = {}, this._overlayWidgets = {}, this._removeDecorationTypes(), this._postDetachModelCleanup(this._detachModel()), this._onDidDispose.fire(), super.dispose();
  }
  invokeWithinContext(n) {
    return this._instantiationService.invokeFunction(n);
  }
  updateOptions(n) {
    this._configuration.updateOptions(n || {});
  }
  getOptions() {
    return this._configuration.options;
  }
  getOption(n) {
    return this._configuration.options.get(n);
  }
  getRawOptions() {
    return this._configuration.getRawOptions();
  }
  getOverflowWidgetsDomNode() {
    return this._overflowWidgetsDomNode;
  }
  getConfiguredWordAtPosition(n) {
    return this._modelData ? Ct.getWordAtPosition(this._modelData.model, this._configuration.options.get(131), this._configuration.options.get(130), n) : null;
  }
  getValue(n = null) {
    if (!this._modelData) return "";
    const e = !(!n || !n.preserveBOM);
    let t = 0;
    return n && n.lineEnding && n.lineEnding === `
` ? t = 1 : n && n.lineEnding && n.lineEnding === `\r
` && (t = 2), this._modelData.model.getValue(t, e);
  }
  setValue(n) {
    this._modelData && this._modelData.model.setValue(n);
  }
  getModel() {
    return this._modelData ? this._modelData.model : null;
  }
  setModel(n = null) {
    var e;
    const t = n;
    if (this._modelData === null && t === null || this._modelData && this._modelData.model === t) return;
    const i = { oldModelUrl: ((e = this._modelData) === null || e === void 0 ? void 0 : e.model.uri) || null, newModelUrl: t?.uri || null };
    this._onWillChangeModel.fire(i);
    const s = this.hasTextFocus(), o = this._detachModel();
    this._attachModel(t), s && this.hasModel() && this.focus(), this._removeDecorationTypes(), this._onDidChangeModel.fire(i), this._postDetachModelCleanup(o), this._contributionsDisposable = this._contributions.onAfterModelAttached();
  }
  _removeDecorationTypes() {
    if (this._decorationTypeKeysToIds = {}, this._decorationTypeSubtypes) {
      for (const n in this._decorationTypeSubtypes) {
        const e = this._decorationTypeSubtypes[n];
        for (const t in e) this._removeDecorationType(n + "-" + t);
      }
      this._decorationTypeSubtypes = {};
    }
  }
  getVisibleRanges() {
    return this._modelData ? this._modelData.viewModel.getVisibleRanges() : [];
  }
  getVisibleRangesPlusViewportAboveBelow() {
    return this._modelData ? this._modelData.viewModel.getVisibleRangesPlusViewportAboveBelow() : [];
  }
  getWhitespaces() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getWhitespaces() : [];
  }
  static _getVerticalOffsetAfterPosition(n, e, t, i) {
    const s = n.model.validatePosition({ lineNumber: e, column: t }), o = n.viewModel.coordinatesConverter.convertModelPositionToViewPosition(s);
    return n.viewModel.viewLayout.getVerticalOffsetAfterLineNumber(o.lineNumber, i);
  }
  getTopForLineNumber(n, e = !1) {
    return this._modelData ? ru._getVerticalOffsetForPosition(this._modelData, n, 1, e) : -1;
  }
  getTopForPosition(n, e) {
    return this._modelData ? ru._getVerticalOffsetForPosition(this._modelData, n, e, !1) : -1;
  }
  static _getVerticalOffsetForPosition(n, e, t, i = !1) {
    const s = n.model.validatePosition({ lineNumber: e, column: t }), o = n.viewModel.coordinatesConverter.convertModelPositionToViewPosition(s);
    return n.viewModel.viewLayout.getVerticalOffsetForLineNumber(o.lineNumber, i);
  }
  getBottomForLineNumber(n, e = !1) {
    return this._modelData ? ru._getVerticalOffsetAfterPosition(this._modelData, n, 1, e) : -1;
  }
  setHiddenAreas(n, e) {
    var t;
    (t = this._modelData) === null || t === void 0 || t.viewModel.setHiddenAreas(n.map(((i) => D.lift(i))), e);
  }
  getVisibleColumnFromPosition(n) {
    if (!this._modelData) return n.column;
    const e = this._modelData.model.validatePosition(n), t = this._modelData.model.getOptions().tabSize;
    return Gi.visibleColumnFromColumn(this._modelData.model.getLineContent(e.lineNumber), e.column, t) + 1;
  }
  getPosition() {
    return this._modelData ? this._modelData.viewModel.getPosition() : null;
  }
  setPosition(n, e = "api") {
    if (this._modelData) {
      if (!W.isIPosition(n)) throw new Error("Invalid arguments");
      this._modelData.viewModel.setSelections(e, [{ selectionStartLineNumber: n.lineNumber, selectionStartColumn: n.column, positionLineNumber: n.lineNumber, positionColumn: n.column }]);
    }
  }
  _sendRevealRange(n, e, t, i) {
    if (!this._modelData) return;
    if (!D.isIRange(n)) throw new Error("Invalid arguments");
    const s = this._modelData.model.validateRange(n), o = this._modelData.viewModel.coordinatesConverter.convertModelRangeToViewRange(s);
    this._modelData.viewModel.revealRange("api", t, o, e, i);
  }
  revealLine(n, e = 0) {
    this._revealLine(n, 0, e);
  }
  revealLineInCenter(n, e = 0) {
    this._revealLine(n, 1, e);
  }
  revealLineInCenterIfOutsideViewport(n, e = 0) {
    this._revealLine(n, 2, e);
  }
  revealLineNearTop(n, e = 0) {
    this._revealLine(n, 5, e);
  }
  _revealLine(n, e, t) {
    if (typeof n != "number") throw new Error("Invalid arguments");
    this._sendRevealRange(new D(n, 1, n, 1), e, !1, t);
  }
  revealPosition(n, e = 0) {
    this._revealPosition(n, 0, !0, e);
  }
  revealPositionInCenter(n, e = 0) {
    this._revealPosition(n, 1, !0, e);
  }
  revealPositionInCenterIfOutsideViewport(n, e = 0) {
    this._revealPosition(n, 2, !0, e);
  }
  revealPositionNearTop(n, e = 0) {
    this._revealPosition(n, 5, !0, e);
  }
  _revealPosition(n, e, t, i) {
    if (!W.isIPosition(n)) throw new Error("Invalid arguments");
    this._sendRevealRange(new D(n.lineNumber, n.column, n.lineNumber, n.column), e, t, i);
  }
  getSelection() {
    return this._modelData ? this._modelData.viewModel.getSelection() : null;
  }
  getSelections() {
    return this._modelData ? this._modelData.viewModel.getSelections() : null;
  }
  setSelection(n, e = "api") {
    const t = _e.isISelection(n), i = D.isIRange(n);
    if (!t && !i) throw new Error("Invalid arguments");
    if (t) this._setSelectionImpl(n, e);
    else if (i) {
      const s = { selectionStartLineNumber: n.startLineNumber, selectionStartColumn: n.startColumn, positionLineNumber: n.endLineNumber, positionColumn: n.endColumn };
      this._setSelectionImpl(s, e);
    }
  }
  _setSelectionImpl(n, e) {
    if (!this._modelData) return;
    const t = new _e(n.selectionStartLineNumber, n.selectionStartColumn, n.positionLineNumber, n.positionColumn);
    this._modelData.viewModel.setSelections(e, [t]);
  }
  revealLines(n, e, t = 0) {
    this._revealLines(n, e, 0, t);
  }
  revealLinesInCenter(n, e, t = 0) {
    this._revealLines(n, e, 1, t);
  }
  revealLinesInCenterIfOutsideViewport(n, e, t = 0) {
    this._revealLines(n, e, 2, t);
  }
  revealLinesNearTop(n, e, t = 0) {
    this._revealLines(n, e, 5, t);
  }
  _revealLines(n, e, t, i) {
    if (typeof n != "number" || typeof e != "number") throw new Error("Invalid arguments");
    this._sendRevealRange(new D(n, 1, e, 1), t, !1, i);
  }
  revealRange(n, e = 0, t = !1, i = !0) {
    this._revealRange(n, t ? 1 : 0, i, e);
  }
  revealRangeInCenter(n, e = 0) {
    this._revealRange(n, 1, !0, e);
  }
  revealRangeInCenterIfOutsideViewport(n, e = 0) {
    this._revealRange(n, 2, !0, e);
  }
  revealRangeNearTop(n, e = 0) {
    this._revealRange(n, 5, !0, e);
  }
  revealRangeNearTopIfOutsideViewport(n, e = 0) {
    this._revealRange(n, 6, !0, e);
  }
  revealRangeAtTop(n, e = 0) {
    this._revealRange(n, 3, !0, e);
  }
  _revealRange(n, e, t, i) {
    if (!D.isIRange(n)) throw new Error("Invalid arguments");
    this._sendRevealRange(D.lift(n), e, t, i);
  }
  setSelections(n, e = "api", t = 0) {
    if (this._modelData) {
      if (!n || n.length === 0) throw new Error("Invalid arguments");
      for (let i = 0, s = n.length; i < s; i++) if (!_e.isISelection(n[i])) throw new Error("Invalid arguments");
      this._modelData.viewModel.setSelections(e, n, t);
    }
  }
  getContentWidth() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getContentWidth() : -1;
  }
  getScrollWidth() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getScrollWidth() : -1;
  }
  getScrollLeft() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getCurrentScrollLeft() : -1;
  }
  getContentHeight() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getContentHeight() : -1;
  }
  getScrollHeight() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getScrollHeight() : -1;
  }
  getScrollTop() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getCurrentScrollTop() : -1;
  }
  setScrollLeft(n, e = 1) {
    if (this._modelData) {
      if (typeof n != "number") throw new Error("Invalid arguments");
      this._modelData.viewModel.viewLayout.setScrollPosition({ scrollLeft: n }, e);
    }
  }
  setScrollTop(n, e = 1) {
    if (this._modelData) {
      if (typeof n != "number") throw new Error("Invalid arguments");
      this._modelData.viewModel.viewLayout.setScrollPosition({ scrollTop: n }, e);
    }
  }
  setScrollPosition(n, e = 1) {
    this._modelData && this._modelData.viewModel.viewLayout.setScrollPosition(n, e);
  }
  hasPendingScrollAnimation() {
    return !!this._modelData && this._modelData.viewModel.viewLayout.hasPendingScrollAnimation();
  }
  saveViewState() {
    if (!this._modelData) return null;
    const n = this._contributions.saveViewState();
    return { cursorState: this._modelData.viewModel.saveCursorState(), viewState: this._modelData.viewModel.saveState(), contributionsState: n };
  }
  restoreViewState(n) {
    if (!this._modelData || !this._modelData.hasRealView) return;
    const e = n;
    if (e && e.cursorState && e.viewState) {
      const t = e.cursorState;
      Array.isArray(t) ? t.length > 0 && this._modelData.viewModel.restoreCursorState(t) : this._modelData.viewModel.restoreCursorState([t]), this._contributions.restoreViewState(e.contributionsState || {});
      const i = this._modelData.viewModel.reduceRestoreState(e.viewState);
      this._modelData.view.restoreState(i);
    }
  }
  handleInitialized() {
    var n;
    (n = this._getViewModel()) === null || n === void 0 || n.visibleLinesStabilized();
  }
  getContribution(n) {
    return this._contributions.get(n);
  }
  getActions() {
    return Array.from(this._actions.values());
  }
  getSupportedActions() {
    let n = this.getActions();
    return n = n.filter(((e) => e.isSupported())), n;
  }
  getAction(n) {
    return this._actions.get(n) || null;
  }
  trigger(n, e, t) {
    switch (t = t || {}, e) {
      case "compositionStart":
        return void this._startComposition();
      case "compositionEnd":
        return void this._endComposition(n);
      case "type": {
        const s = t;
        return void this._type(n, s.text || "");
      }
      case "replacePreviousChar": {
        const s = t;
        return void this._compositionType(n, s.text || "", s.replaceCharCnt || 0, 0, 0);
      }
      case "compositionType": {
        const s = t;
        return void this._compositionType(n, s.text || "", s.replacePrevCharCnt || 0, s.replaceNextCharCnt || 0, s.positionDelta || 0);
      }
      case "paste": {
        const s = t;
        return void this._paste(n, s.text || "", s.pasteOnNewLine || !1, s.multicursorText || null, s.mode || null, s.clipboardEvent);
      }
      case "cut":
        return void this._cut(n);
    }
    const i = this.getAction(e);
    i ? Promise.resolve(i.run(t)).then(void 0, We) : this._modelData && (this._triggerEditorCommand(n, e, t) || this._triggerCommand(e, t));
  }
  _triggerCommand(n, e) {
    this._commandService.executeCommand(n, e);
  }
  _startComposition() {
    this._modelData && (this._modelData.viewModel.startComposition(), this._onDidCompositionStart.fire());
  }
  _endComposition(n) {
    this._modelData && (this._modelData.viewModel.endComposition(n), this._onDidCompositionEnd.fire());
  }
  _type(n, e) {
    this._modelData && e.length !== 0 && (n === "keyboard" && this._onWillType.fire(e), this._modelData.viewModel.type(e, n), n === "keyboard" && this._onDidType.fire(e));
  }
  _compositionType(n, e, t, i, s) {
    this._modelData && this._modelData.viewModel.compositionType(e, t, i, s, n);
  }
  _paste(n, e, t, i, s, o) {
    if (!this._modelData) return;
    const r = this._modelData.viewModel, a = r.getSelection().getStartPosition();
    r.paste(e, t, i, n);
    const l = r.getSelection().getStartPosition();
    n === "keyboard" && this._onDidPaste.fire({ clipboardEvent: o, range: new D(a.lineNumber, a.column, l.lineNumber, l.column), languageId: s });
  }
  _cut(n) {
    this._modelData && this._modelData.viewModel.cut(n);
  }
  _triggerEditorCommand(n, e, t) {
    const i = Xp.getEditorCommand(e);
    return !!i && ((t = t || {}).source = n, this._instantiationService.invokeFunction(((s) => {
      Promise.resolve(i.runEditorCommand(s, this, t)).then(void 0, We);
    })), !0);
  }
  _getViewModel() {
    return this._modelData ? this._modelData.viewModel : null;
  }
  pushUndoStop() {
    return !!this._modelData && !this._configuration.options.get(91) && (this._modelData.model.pushStackElement(), !0);
  }
  popUndoStop() {
    return !!this._modelData && !this._configuration.options.get(91) && (this._modelData.model.popStackElement(), !0);
  }
  executeEdits(n, e, t) {
    if (!this._modelData || this._configuration.options.get(91)) return !1;
    let i;
    return i = t ? Array.isArray(t) ? () => t : t : () => null, this._modelData.viewModel.executeEdits(n, e, i), !0;
  }
  executeCommand(n, e) {
    this._modelData && this._modelData.viewModel.executeCommand(e, n);
  }
  executeCommands(n, e) {
    this._modelData && this._modelData.viewModel.executeCommands(e, n);
  }
  createDecorationsCollection(n) {
    return new ZQ(this, n);
  }
  changeDecorations(n) {
    return this._modelData ? this._modelData.model.changeDecorations(n, this._id) : null;
  }
  getLineDecorations(n) {
    return this._modelData ? this._modelData.model.getLineDecorations(n, this._id, Nw(this._configuration.options)) : null;
  }
  getDecorationsInRange(n) {
    return this._modelData ? this._modelData.model.getDecorationsInRange(n, this._id, Nw(this._configuration.options)) : null;
  }
  deltaDecorations(n, e) {
    return this._modelData ? n.length === 0 && e.length === 0 ? n : this._modelData.model.deltaDecorations(n, e, this._id) : [];
  }
  removeDecorations(n) {
    this._modelData && n.length !== 0 && this._modelData.model.changeDecorations(((e) => {
      e.deltaDecorations(n, []);
    }));
  }
  removeDecorationsByType(n) {
    const e = this._decorationTypeKeysToIds[n];
    e && this.changeDecorations(((t) => t.deltaDecorations(e, []))), this._decorationTypeKeysToIds.hasOwnProperty(n) && delete this._decorationTypeKeysToIds[n], this._decorationTypeSubtypes.hasOwnProperty(n) && delete this._decorationTypeSubtypes[n];
  }
  getLayoutInfo() {
    return this._configuration.options.get(145);
  }
  createOverviewRuler(n) {
    return this._modelData && this._modelData.hasRealView ? this._modelData.view.createOverviewRuler(n) : null;
  }
  getContainerDomNode() {
    return this._domElement;
  }
  getDomNode() {
    return this._modelData && this._modelData.hasRealView ? this._modelData.view.domNode.domNode : null;
  }
  delegateVerticalScrollbarPointerDown(n) {
    this._modelData && this._modelData.hasRealView && this._modelData.view.delegateVerticalScrollbarPointerDown(n);
  }
  delegateScrollFromMouseWheelEvent(n) {
    this._modelData && this._modelData.hasRealView && this._modelData.view.delegateScrollFromMouseWheelEvent(n);
  }
  layout(n, e = !1) {
    this._configuration.observeContainer(n), e || this.render();
  }
  focus() {
    this._modelData && this._modelData.hasRealView && this._modelData.view.focus();
  }
  hasTextFocus() {
    return !(!this._modelData || !this._modelData.hasRealView) && this._modelData.view.isFocused();
  }
  hasWidgetFocus() {
    return this._focusTracker && this._focusTracker.hasFocus();
  }
  addContentWidget(n) {
    const e = { widget: n, position: n.getPosition() };
    this._contentWidgets.hasOwnProperty(n.getId()) && console.warn("Overwriting a content widget with the same id:" + n.getId()), this._contentWidgets[n.getId()] = e, this._modelData && this._modelData.hasRealView && this._modelData.view.addContentWidget(e);
  }
  layoutContentWidget(n) {
    const e = n.getId();
    if (this._contentWidgets.hasOwnProperty(e)) {
      const t = this._contentWidgets[e];
      t.position = n.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutContentWidget(t);
    }
  }
  removeContentWidget(n) {
    const e = n.getId();
    if (this._contentWidgets.hasOwnProperty(e)) {
      const t = this._contentWidgets[e];
      delete this._contentWidgets[e], this._modelData && this._modelData.hasRealView && this._modelData.view.removeContentWidget(t);
    }
  }
  addOverlayWidget(n) {
    const e = { widget: n, position: n.getPosition() };
    this._overlayWidgets.hasOwnProperty(n.getId()) && console.warn("Overwriting an overlay widget with the same id."), this._overlayWidgets[n.getId()] = e, this._modelData && this._modelData.hasRealView && this._modelData.view.addOverlayWidget(e);
  }
  layoutOverlayWidget(n) {
    const e = n.getId();
    if (this._overlayWidgets.hasOwnProperty(e)) {
      const t = this._overlayWidgets[e];
      t.position = n.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutOverlayWidget(t);
    }
  }
  removeOverlayWidget(n) {
    const e = n.getId();
    if (this._overlayWidgets.hasOwnProperty(e)) {
      const t = this._overlayWidgets[e];
      delete this._overlayWidgets[e], this._modelData && this._modelData.hasRealView && this._modelData.view.removeOverlayWidget(t);
    }
  }
  addGlyphMarginWidget(n) {
    const e = { widget: n, position: n.getPosition() };
    this._glyphMarginWidgets.hasOwnProperty(n.getId()) && console.warn("Overwriting a glyph margin widget with the same id."), this._glyphMarginWidgets[n.getId()] = e, this._modelData && this._modelData.hasRealView && this._modelData.view.addGlyphMarginWidget(e);
  }
  layoutGlyphMarginWidget(n) {
    const e = n.getId();
    if (this._glyphMarginWidgets.hasOwnProperty(e)) {
      const t = this._glyphMarginWidgets[e];
      t.position = n.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutGlyphMarginWidget(t);
    }
  }
  removeGlyphMarginWidget(n) {
    const e = n.getId();
    if (this._glyphMarginWidgets.hasOwnProperty(e)) {
      const t = this._glyphMarginWidgets[e];
      delete this._glyphMarginWidgets[e], this._modelData && this._modelData.hasRealView && this._modelData.view.removeGlyphMarginWidget(t);
    }
  }
  changeViewZones(n) {
    this._modelData && this._modelData.hasRealView && this._modelData.view.change(n);
  }
  getTargetAtClientPoint(n, e) {
    return this._modelData && this._modelData.hasRealView ? this._modelData.view.getTargetAtClientPoint(n, e) : null;
  }
  getScrolledVisiblePosition(n) {
    if (!this._modelData || !this._modelData.hasRealView) return null;
    const e = this._modelData.model.validatePosition(n), t = this._configuration.options, i = t.get(145);
    return { top: ru._getVerticalOffsetForPosition(this._modelData, e.lineNumber, e.column) - this.getScrollTop(), left: this._modelData.view.getOffsetForColumn(e.lineNumber, e.column) + i.glyphMarginWidth + i.lineNumbersWidth + i.decorationsWidth - this.getScrollLeft(), height: t.get(67) };
  }
  getOffsetForColumn(n, e) {
    return this._modelData && this._modelData.hasRealView ? this._modelData.view.getOffsetForColumn(n, e) : -1;
  }
  render(n = !1) {
    this._modelData && this._modelData.hasRealView && this._modelData.view.render(!0, n);
  }
  setAriaOptions(n) {
    this._modelData && this._modelData.hasRealView && this._modelData.view.setAriaOptions(n);
  }
  applyFontInfo(n) {
    yn(n, this._configuration.options.get(50));
  }
  setBanner(n, e) {
    this._bannerDomNode && this._domElement.contains(this._bannerDomNode) && this._domElement.removeChild(this._bannerDomNode), this._bannerDomNode = n, this._configuration.setReservedHeight(n ? e : 0), this._bannerDomNode && this._domElement.prepend(this._bannerDomNode);
  }
  _attachModel(n) {
    if (!n) return void (this._modelData = null);
    const e = [];
    this._domElement.setAttribute("data-mode-id", n.getLanguageId()), this._configuration.setIsDominatedByLongLines(n.isDominatedByLongLines()), this._configuration.setModelLineCount(n.getLineCount());
    const t = n.onBeforeAttached(), i = new VQ(this._id, this._configuration, n, qR.create(ke(this._domElement)), nA.create(this._configuration.options), ((r) => Ys(ke(this._domElement), r)), this.languageConfigurationService, this._themeService, t);
    e.push(n.onWillDispose((() => this.setModel(null)))), e.push(i.onEvent(((r) => {
      switch (r.kind) {
        case 0:
          this._onDidContentSizeChange.fire(r);
          break;
        case 1:
          this._editorTextFocus.setValue(r.hasFocus);
          break;
        case 2:
          this._onDidScrollChange.fire(r);
          break;
        case 3:
          this._onDidChangeViewZones.fire();
          break;
        case 4:
          this._onDidChangeHiddenAreas.fire();
          break;
        case 5:
          this._onDidAttemptReadOnlyEdit.fire();
          break;
        case 6: {
          if (r.reachedMaxCursorCount) {
            const h = m(0, "The number of cursors has been limited to {0}. Consider using [find and replace](https://code.visualstudio.com/docs/editor/codebasics#_find-and-replace) for larger changes or increase the editor multi cursor limit setting.", this.getOption(80));
            this._notificationService.prompt(pL.Warning, h, [{ label: "Find and Replace", run: () => {
              this._commandService.executeCommand("editor.action.startFindReplaceAction");
            } }, { label: m(0, "Increase Multi Cursor Limit"), run: () => {
              this._commandService.executeCommand("workbench.action.openSettings2", { query: "editor.multiCursorLimit" });
            } }]);
          }
          const a = [];
          for (let h = 0, c = r.selections.length; h < c; h++) a[h] = r.selections[h].getPosition();
          const l = { position: a[0], secondaryPositions: a.slice(1), reason: r.reason, source: r.source };
          this._onDidChangeCursorPosition.fire(l);
          const d = { selection: r.selections[0], secondarySelections: r.selections.slice(1), modelVersionId: r.modelVersionId, oldSelections: r.oldSelections, oldModelVersionId: r.oldModelVersionId, source: r.source, reason: r.reason };
          this._onDidChangeCursorSelection.fire(d);
          break;
        }
        case 7:
          this._onDidChangeModelDecorations.fire(r.event);
          break;
        case 8:
          this._domElement.setAttribute("data-mode-id", n.getLanguageId()), this._onDidChangeModelLanguage.fire(r.event);
          break;
        case 9:
          this._onDidChangeModelLanguageConfiguration.fire(r.event);
          break;
        case 10:
          this._onDidChangeModelContent.fire(r.event);
          break;
        case 11:
          this._onDidChangeModelOptions.fire(r.event);
          break;
        case 12:
          this._onDidChangeModelTokens.fire(r.event);
      }
    })));
    const [s, o] = this._createView(i);
    if (o) {
      this._domElement.appendChild(s.domNode.domNode);
      let r = Object.keys(this._contentWidgets);
      for (let a = 0, l = r.length; a < l; a++) {
        const d = r[a];
        s.addContentWidget(this._contentWidgets[d]);
      }
      r = Object.keys(this._overlayWidgets);
      for (let a = 0, l = r.length; a < l; a++) {
        const d = r[a];
        s.addOverlayWidget(this._overlayWidgets[d]);
      }
      r = Object.keys(this._glyphMarginWidgets);
      for (let a = 0, l = r.length; a < l; a++) {
        const d = r[a];
        s.addGlyphMarginWidget(this._glyphMarginWidgets[d]);
      }
      s.render(!1, !0), s.domNode.domNode.setAttribute("data-uri", n.uri.toString());
    }
    this._modelData = new jQ(n, i, s, o, e, t);
  }
  _createView(n) {
    let e;
    e = this.isSimpleWidget ? { paste: (i, s, o, r) => {
      this._paste("keyboard", i, s, o, r);
    }, type: (i) => {
      this._type("keyboard", i);
    }, compositionType: (i, s, o, r) => {
      this._compositionType("keyboard", i, s, o, r);
    }, startComposition: () => {
      this._startComposition();
    }, endComposition: () => {
      this._endComposition("keyboard");
    }, cut: () => {
      this._cut("keyboard");
    } } : { paste: (i, s, o, r) => {
      const a = { text: i, pasteOnNewLine: s, multicursorText: o, mode: r };
      this._commandService.executeCommand("paste", a);
    }, type: (i) => {
      const s = { text: i };
      this._commandService.executeCommand("type", s);
    }, compositionType: (i, s, o, r) => {
      if (o || r) {
        const a = { text: i, replacePrevCharCnt: s, replaceNextCharCnt: o, positionDelta: r };
        this._commandService.executeCommand("compositionType", a);
      } else {
        const a = { text: i, replaceCharCnt: s };
        this._commandService.executeCommand("replacePreviousChar", a);
      }
    }, startComposition: () => {
      this._commandService.executeCommand("compositionStart", {});
    }, endComposition: () => {
      this._commandService.executeCommand("compositionEnd", {});
    }, cut: () => {
      this._commandService.executeCommand("cut", {});
    } };
    const t = new dL(n.coordinatesConverter);
    return t.onKeyDown = (i) => this._onKeyDown.fire(i), t.onKeyUp = (i) => this._onKeyUp.fire(i), t.onContextMenu = (i) => this._onContextMenu.fire(i), t.onMouseMove = (i) => this._onMouseMove.fire(i), t.onMouseLeave = (i) => this._onMouseLeave.fire(i), t.onMouseDown = (i) => this._onMouseDown.fire(i), t.onMouseUp = (i) => this._onMouseUp.fire(i), t.onMouseDrag = (i) => this._onMouseDrag.fire(i), t.onMouseDrop = (i) => this._onMouseDrop.fire(i), t.onMouseDropCanceled = (i) => this._onMouseDropCanceled.fire(i), t.onMouseWheel = (i) => this._onMouseWheel.fire(i), [new oI(e, this._configuration, this._themeService.getColorTheme(), n, t, this._overflowWidgetsDomNode, this._instantiationService), !0];
  }
  _postDetachModelCleanup(n) {
    n?.removeAllDecorationsWithOwnerId(this._id);
  }
  _detachModel() {
    var n;
    if ((n = this._contributionsDisposable) === null || n === void 0 || n.dispose(), this._contributionsDisposable = void 0, !this._modelData) return null;
    const e = this._modelData.model, t = this._modelData.hasRealView ? this._modelData.view.domNode.domNode : null;
    return this._modelData.dispose(), this._modelData = null, this._domElement.removeAttribute("data-mode-id"), t && this._domElement.contains(t) && this._domElement.removeChild(t), this._bannerDomNode && this._domElement.contains(this._bannerDomNode) && this._domElement.removeChild(this._bannerDomNode), e;
  }
  _removeDecorationType(n) {
    this._codeEditorService.removeDecorationType(n);
  }
  hasModel() {
    return this._modelData !== null;
  }
  showDropIndicatorAt(n) {
    const e = [{ range: new D(n.lineNumber, n.column, n.lineNumber, n.column), options: ru.dropIntoEditorDecorationOptions }];
    this._dropIntoEditorDecorations.set(e), this.revealPosition(n, 1);
  }
  removeDropIndicator() {
    this._dropIntoEditorDecorations.clear();
  }
  setContextValue(n, e) {
    this._contextKeyService.createKey(n, e);
  }
};
um.dropIntoEditorDecorationOptions = Ve.register({ description: "workbench-dnd-target", className: "dnd-target" }), um = ru = UQ([Nl(3, Se), Nl(4, mt), Nl(5, ai), Nl(6, Te), Nl(7, Yi), Nl(8, Ri), Nl(9, or), Nl(10, zt), Nl(11, fe)], um);
let KQ = 0, jQ = class {
  constructor(n, e, t, i, s, o) {
    this.model = n, this.viewModel = e, this.view = t, this.hasRealView = i, this.listenersToRemove = s, this.attachedView = o;
  }
  dispose() {
    Ht(this.listenersToRemove), this.model.onBeforeDetached(this.attachedView), this.hasRealView && this.view.dispose(), this.viewModel.dispose();
  }
};
class Y5 extends V {
  constructor(e) {
    super(), this._emitterOptions = e, this._onDidChangeToTrue = this._register(new F(this._emitterOptions)), this.onDidChangeToTrue = this._onDidChangeToTrue.event, this._onDidChangeToFalse = this._register(new F(this._emitterOptions)), this.onDidChangeToFalse = this._onDidChangeToFalse.event, this._value = 0;
  }
  setValue(e) {
    const t = e ? 2 : 1;
    this._value !== t && (this._value = t, this._value === 2 ? this._onDidChangeToTrue.fire() : this._value === 1 && this._onDidChangeToFalse.fire());
  }
}
class Kn extends F {
  constructor(e, t) {
    super({ deliveryQueue: t }), this._contributions = e;
  }
  fire(e) {
    this._contributions.onBeforeInteractionEvent(), super.fire(e);
  }
}
class qQ extends V {
  constructor(e, t) {
    super(), this._editor = e, t.createKey("editorId", e.getId()), this._editorSimpleInput = E.editorSimpleInput.bindTo(t), this._editorFocus = E.focus.bindTo(t), this._textInputFocus = E.textInputFocus.bindTo(t), this._editorTextFocus = E.editorTextFocus.bindTo(t), this._tabMovesFocus = E.tabMovesFocus.bindTo(t), this._editorReadonly = E.readOnly.bindTo(t), this._inDiffEditor = E.inDiffEditor.bindTo(t), this._editorColumnSelection = E.columnSelection.bindTo(t), this._hasMultipleSelections = E.hasMultipleSelections.bindTo(t), this._hasNonEmptySelection = E.hasNonEmptySelection.bindTo(t), this._canUndo = E.canUndo.bindTo(t), this._canRedo = E.canRedo.bindTo(t), this._register(this._editor.onDidChangeConfiguration((() => this._updateFromConfig()))), this._register(this._editor.onDidChangeCursorSelection((() => this._updateFromSelection()))), this._register(this._editor.onDidFocusEditorWidget((() => this._updateFromFocus()))), this._register(this._editor.onDidBlurEditorWidget((() => this._updateFromFocus()))), this._register(this._editor.onDidFocusEditorText((() => this._updateFromFocus()))), this._register(this._editor.onDidBlurEditorText((() => this._updateFromFocus()))), this._register(this._editor.onDidChangeModel((() => this._updateFromModel()))), this._register(this._editor.onDidChangeConfiguration((() => this._updateFromModel()))), this._register(Hm.onDidChangeTabFocus(((i) => this._tabMovesFocus.set(i)))), this._updateFromConfig(), this._updateFromSelection(), this._updateFromFocus(), this._updateFromModel(), this._editorSimpleInput.set(this._editor.isSimpleWidget);
  }
  _updateFromConfig() {
    const e = this._editor.getOptions();
    this._tabMovesFocus.set(Hm.getTabFocusMode()), this._editorReadonly.set(e.get(91)), this._inDiffEditor.set(e.get(61)), this._editorColumnSelection.set(e.get(22));
  }
  _updateFromSelection() {
    const e = this._editor.getSelections();
    e ? (this._hasMultipleSelections.set(e.length > 1), this._hasNonEmptySelection.set(e.some(((t) => !t.isEmpty())))) : (this._hasMultipleSelections.reset(), this._hasNonEmptySelection.reset());
  }
  _updateFromFocus() {
    this._editorFocus.set(this._editor.hasWidgetFocus() && !this._editor.isSimpleWidget), this._editorTextFocus.set(this._editor.hasTextFocus() && !this._editor.isSimpleWidget), this._textInputFocus.set(this._editor.hasTextFocus());
  }
  _updateFromModel() {
    const e = this._editor.getModel();
    this._canUndo.set(!!(e && e.canUndo())), this._canRedo.set(!!(e && e.canRedo()));
  }
}
class $Q extends V {
  constructor(e, t, i) {
    super(), this._editor = e, this._contextKeyService = t, this._languageFeaturesService = i, this._langId = E.languageId.bindTo(t), this._hasCompletionItemProvider = E.hasCompletionItemProvider.bindTo(t), this._hasCodeActionsProvider = E.hasCodeActionsProvider.bindTo(t), this._hasCodeLensProvider = E.hasCodeLensProvider.bindTo(t), this._hasDefinitionProvider = E.hasDefinitionProvider.bindTo(t), this._hasDeclarationProvider = E.hasDeclarationProvider.bindTo(t), this._hasImplementationProvider = E.hasImplementationProvider.bindTo(t), this._hasTypeDefinitionProvider = E.hasTypeDefinitionProvider.bindTo(t), this._hasHoverProvider = E.hasHoverProvider.bindTo(t), this._hasDocumentHighlightProvider = E.hasDocumentHighlightProvider.bindTo(t), this._hasDocumentSymbolProvider = E.hasDocumentSymbolProvider.bindTo(t), this._hasReferenceProvider = E.hasReferenceProvider.bindTo(t), this._hasRenameProvider = E.hasRenameProvider.bindTo(t), this._hasSignatureHelpProvider = E.hasSignatureHelpProvider.bindTo(t), this._hasInlayHintsProvider = E.hasInlayHintsProvider.bindTo(t), this._hasDocumentFormattingProvider = E.hasDocumentFormattingProvider.bindTo(t), this._hasDocumentSelectionFormattingProvider = E.hasDocumentSelectionFormattingProvider.bindTo(t), this._hasMultipleDocumentFormattingProvider = E.hasMultipleDocumentFormattingProvider.bindTo(t), this._hasMultipleDocumentSelectionFormattingProvider = E.hasMultipleDocumentSelectionFormattingProvider.bindTo(t), this._isInEmbeddedEditor = E.isInEmbeddedEditor.bindTo(t);
    const s = () => this._update();
    this._register(e.onDidChangeModel(s)), this._register(e.onDidChangeModelLanguage(s)), this._register(i.completionProvider.onDidChange(s)), this._register(i.codeActionProvider.onDidChange(s)), this._register(i.codeLensProvider.onDidChange(s)), this._register(i.definitionProvider.onDidChange(s)), this._register(i.declarationProvider.onDidChange(s)), this._register(i.implementationProvider.onDidChange(s)), this._register(i.typeDefinitionProvider.onDidChange(s)), this._register(i.hoverProvider.onDidChange(s)), this._register(i.documentHighlightProvider.onDidChange(s)), this._register(i.documentSymbolProvider.onDidChange(s)), this._register(i.referenceProvider.onDidChange(s)), this._register(i.renameProvider.onDidChange(s)), this._register(i.documentFormattingEditProvider.onDidChange(s)), this._register(i.documentRangeFormattingEditProvider.onDidChange(s)), this._register(i.signatureHelpProvider.onDidChange(s)), this._register(i.inlayHintsProvider.onDidChange(s)), s();
  }
  dispose() {
    super.dispose();
  }
  reset() {
    this._contextKeyService.bufferChangeEvents((() => {
      this._langId.reset(), this._hasCompletionItemProvider.reset(), this._hasCodeActionsProvider.reset(), this._hasCodeLensProvider.reset(), this._hasDefinitionProvider.reset(), this._hasDeclarationProvider.reset(), this._hasImplementationProvider.reset(), this._hasTypeDefinitionProvider.reset(), this._hasHoverProvider.reset(), this._hasDocumentHighlightProvider.reset(), this._hasDocumentSymbolProvider.reset(), this._hasReferenceProvider.reset(), this._hasRenameProvider.reset(), this._hasDocumentFormattingProvider.reset(), this._hasDocumentSelectionFormattingProvider.reset(), this._hasSignatureHelpProvider.reset(), this._isInEmbeddedEditor.reset();
    }));
  }
  _update() {
    const e = this._editor.getModel();
    e ? this._contextKeyService.bufferChangeEvents((() => {
      this._langId.set(e.getLanguageId()), this._hasCompletionItemProvider.set(this._languageFeaturesService.completionProvider.has(e)), this._hasCodeActionsProvider.set(this._languageFeaturesService.codeActionProvider.has(e)), this._hasCodeLensProvider.set(this._languageFeaturesService.codeLensProvider.has(e)), this._hasDefinitionProvider.set(this._languageFeaturesService.definitionProvider.has(e)), this._hasDeclarationProvider.set(this._languageFeaturesService.declarationProvider.has(e)), this._hasImplementationProvider.set(this._languageFeaturesService.implementationProvider.has(e)), this._hasTypeDefinitionProvider.set(this._languageFeaturesService.typeDefinitionProvider.has(e)), this._hasHoverProvider.set(this._languageFeaturesService.hoverProvider.has(e)), this._hasDocumentHighlightProvider.set(this._languageFeaturesService.documentHighlightProvider.has(e)), this._hasDocumentSymbolProvider.set(this._languageFeaturesService.documentSymbolProvider.has(e)), this._hasReferenceProvider.set(this._languageFeaturesService.referenceProvider.has(e)), this._hasRenameProvider.set(this._languageFeaturesService.renameProvider.has(e)), this._hasSignatureHelpProvider.set(this._languageFeaturesService.signatureHelpProvider.has(e)), this._hasInlayHintsProvider.set(this._languageFeaturesService.inlayHintsProvider.has(e)), this._hasDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.has(e) || this._languageFeaturesService.documentRangeFormattingEditProvider.has(e)), this._hasDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.has(e)), this._hasMultipleDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.all(e).length + this._languageFeaturesService.documentRangeFormattingEditProvider.all(e).length > 1), this._hasMultipleDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.all(e).length > 1), this._isInEmbeddedEditor.set(e.uri.scheme === Ue.walkThroughSnippet || e.uri.scheme === Ue.vscodeChatCodeBlock);
    })) : this.reset();
  }
}
class GQ extends V {
  constructor(e, t) {
    super(), this._onChange = this._register(new F()), this.onChange = this._onChange.event, this._hadFocus = void 0, this._hasDomElementFocus = !1, this._domFocusTracker = this._register(pa(e)), this._overflowWidgetsDomNodeHasFocus = !1, this._register(this._domFocusTracker.onDidFocus((() => {
      this._hasDomElementFocus = !0, this._update();
    }))), this._register(this._domFocusTracker.onDidBlur((() => {
      this._hasDomElementFocus = !1, this._update();
    }))), t && (this._overflowWidgetsDomNode = this._register(pa(t)), this._register(this._overflowWidgetsDomNode.onDidFocus((() => {
      this._overflowWidgetsDomNodeHasFocus = !0, this._update();
    }))), this._register(this._overflowWidgetsDomNode.onDidBlur((() => {
      this._overflowWidgetsDomNodeHasFocus = !1, this._update();
    }))));
  }
  _update() {
    const e = this._hasDomElementFocus || this._overflowWidgetsDomNodeHasFocus;
    this._hadFocus !== e && (this._hadFocus = e, this._onChange.fire(void 0));
  }
  hasFocus() {
    var e;
    return (e = this._hadFocus) !== null && e !== void 0 && e;
  }
}
class ZQ {
  get length() {
    return this._decorationIds.length;
  }
  constructor(e, t) {
    this._editor = e, this._decorationIds = [], this._isChangingDecorations = !1, Array.isArray(t) && t.length > 0 && this.set(t);
  }
  onDidChange(e, t, i) {
    return this._editor.onDidChangeModelDecorations(((s) => {
      this._isChangingDecorations || e.call(t, s);
    }), i);
  }
  getRange(e) {
    return this._editor.hasModel() ? e >= this._decorationIds.length ? null : this._editor.getModel().getDecorationRange(this._decorationIds[e]) : null;
  }
  getRanges() {
    if (!this._editor.hasModel()) return [];
    const e = this._editor.getModel(), t = [];
    for (const i of this._decorationIds) {
      const s = e.getDecorationRange(i);
      s && t.push(s);
    }
    return t;
  }
  has(e) {
    return this._decorationIds.includes(e.id);
  }
  clear() {
    this._decorationIds.length !== 0 && this.set([]);
  }
  set(e) {
    try {
      this._isChangingDecorations = !0, this._editor.changeDecorations(((t) => {
        this._decorationIds = t.deltaDecorations(this._decorationIds, e);
      }));
    } finally {
      this._isChangingDecorations = !1;
    }
    return this._decorationIds;
  }
  append(e) {
    let t = [];
    try {
      this._isChangingDecorations = !0, this._editor.changeDecorations(((i) => {
        t = i.deltaDecorations([], e), this._decorationIds = this._decorationIds.concat(t);
      }));
    } finally {
      this._isChangingDecorations = !1;
    }
    return t;
  }
}
const YQ = encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3' enable-background='new 0 0 6 3' height='3' width='6'><g fill='"), XQ = encodeURIComponent("'><polygon points='5.5,0 2.5,3 1.1,3 4.1,0'/><polygon points='4,0 6,2 6,0.6 5.4,0'/><polygon points='0,2 1,3 2.4,3 0,0.6'/></g></svg>");
function TD(n) {
  return YQ + encodeURIComponent(n.toString()) + XQ;
}
const QQ = encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" height="3" width="12"><g fill="'), JQ = encodeURIComponent('"><circle cx="1" cy="1" r="1"/><circle cx="5" cy="1" r="1"/><circle cx="9" cy="1" r="1"/></g></svg>');
rr(((n, e) => {
  const t = n.getColor(sl);
  t && e.addRule(`.monaco-editor .squiggly-error { background: url("data:image/svg+xml,${TD(t)}") repeat-x bottom left; }`);
  const i = n.getColor(Qn);
  i && e.addRule(`.monaco-editor .squiggly-warning { background: url("data:image/svg+xml,${TD(i)}") repeat-x bottom left; }`);
  const s = n.getColor(Rs);
  s && e.addRule(`.monaco-editor .squiggly-info { background: url("data:image/svg+xml,${TD(s)}") repeat-x bottom left; }`);
  const o = n.getColor(p$);
  var r;
  o && e.addRule(`.monaco-editor .squiggly-hint { background: url("data:image/svg+xml,${r = o, QQ + encodeURIComponent(r.toString()) + JQ}") no-repeat bottom left; }`);
  const a = n.getColor(EZ);
  a && e.addRule(`.monaco-editor.showUnused .squiggly-inline-unnecessary { opacity: ${a.rgba.a}; }`);
}));
var eJ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, tJ = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let yI = class extends V {
  constructor(n) {
    super(), this._themeService = n, this._onWillCreateCodeEditor = this._register(new F()), this._onCodeEditorAdd = this._register(new F()), this.onCodeEditorAdd = this._onCodeEditorAdd.event, this._onCodeEditorRemove = this._register(new F()), this.onCodeEditorRemove = this._onCodeEditorRemove.event, this._onWillCreateDiffEditor = this._register(new F()), this._onDiffEditorAdd = this._register(new F()), this.onDiffEditorAdd = this._onDiffEditorAdd.event, this._onDiffEditorRemove = this._register(new F()), this.onDiffEditorRemove = this._onDiffEditorRemove.event, this._decorationOptionProviders = /* @__PURE__ */ new Map(), this._codeEditorOpenHandlers = new fs(), this._modelProperties = /* @__PURE__ */ new Map(), this._codeEditors = /* @__PURE__ */ Object.create(null), this._diffEditors = /* @__PURE__ */ Object.create(null), this._globalStyleSheet = null;
  }
  willCreateCodeEditor() {
    this._onWillCreateCodeEditor.fire();
  }
  addCodeEditor(n) {
    this._codeEditors[n.getId()] = n, this._onCodeEditorAdd.fire(n);
  }
  removeCodeEditor(n) {
    delete this._codeEditors[n.getId()] && this._onCodeEditorRemove.fire(n);
  }
  listCodeEditors() {
    return Object.keys(this._codeEditors).map(((n) => this._codeEditors[n]));
  }
  willCreateDiffEditor() {
    this._onWillCreateDiffEditor.fire();
  }
  addDiffEditor(n) {
    this._diffEditors[n.getId()] = n, this._onDiffEditorAdd.fire(n);
  }
  listDiffEditors() {
    return Object.keys(this._diffEditors).map(((n) => this._diffEditors[n]));
  }
  getFocusedCodeEditor() {
    let n = null;
    const e = this.listCodeEditors();
    for (const t of e) {
      if (t.hasTextFocus()) return t;
      t.hasWidgetFocus() && (n = t);
    }
    return n;
  }
  removeDecorationType(n) {
    const e = this._decorationOptionProviders.get(n);
    e && (e.refCount--, e.refCount <= 0 && (this._decorationOptionProviders.delete(n), e.dispose(), this.listCodeEditors().forEach(((t) => t.removeDecorationsByType(n)))));
  }
  setModelProperty(n, e, t) {
    const i = n.toString();
    let s;
    this._modelProperties.has(i) ? s = this._modelProperties.get(i) : (s = /* @__PURE__ */ new Map(), this._modelProperties.set(i, s)), s.set(e, t);
  }
  getModelProperty(n, e) {
    const t = n.toString();
    if (this._modelProperties.has(t))
      return this._modelProperties.get(t).get(e);
  }
  async openCodeEditor(n, e, t) {
    for (const i of this._codeEditorOpenHandlers) {
      const s = await i(n, e, t);
      if (s !== null) return s;
    }
    return null;
  }
  registerCodeEditorOpenHandler(n) {
    return ye(this._codeEditorOpenHandlers.unshift(n));
  }
};
yI = eJ([tJ(0, Yi)], yI);
var iJ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, X5 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let zC = class extends yI {
  constructor(n, e) {
    super(e), this._register(this.onCodeEditorAdd((() => this._checkContextKey()))), this._register(this.onCodeEditorRemove((() => this._checkContextKey()))), this._editorIsOpen = n.createKey("editorIsOpen", !1), this._activeCodeEditor = null, this._register(this.registerCodeEditorOpenHandler((async (t, i, s) => i ? this.doOpenEditor(i, t) : null)));
  }
  _checkContextKey() {
    let n = !1;
    for (const e of this.listCodeEditors()) if (!e.isSimpleWidget) {
      n = !0;
      break;
    }
    this._editorIsOpen.set(n);
  }
  setActiveCodeEditor(n) {
    this._activeCodeEditor = n;
  }
  getActiveCodeEditor() {
    return this._activeCodeEditor;
  }
  doOpenEditor(n, e) {
    if (!this.findModel(n, e.resource)) {
      if (e.resource) {
        const i = e.resource.scheme;
        if (i === Ue.http || i === Ue.https) return k8(e.resource.toString()), n;
      }
      return null;
    }
    const t = e.options ? e.options.selection : null;
    if (t) if (typeof t.endLineNumber == "number" && typeof t.endColumn == "number") n.setSelection(t), n.revealRangeInCenter(t, 1);
    else {
      const i = { lineNumber: t.startLineNumber, column: t.startColumn };
      n.setPosition(i), n.revealPositionInCenter(i, 1);
    }
    return n;
  }
  findModel(n, e) {
    const t = n.getModel();
    return t && t.uri.toString() !== e.toString() ? null : t;
  }
};
zC = iJ([X5(0, Te), X5(1, Yi)], zC), rt(mt, zC, 0);
const Ac = tt("layoutService");
var pW = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, mW = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let wy = class {
  get mainContainer() {
    var n, e;
    return (e = (n = zT(this._codeEditorService.listCodeEditors())) === null || n === void 0 ? void 0 : n.getContainerDomNode()) !== null && e !== void 0 ? e : It.document.body;
  }
  get activeContainer() {
    var n, e;
    const t = (n = this._codeEditorService.getFocusedCodeEditor()) !== null && n !== void 0 ? n : this._codeEditorService.getActiveCodeEditor();
    return (e = t?.getContainerDomNode()) !== null && e !== void 0 ? e : this.mainContainer;
  }
  get mainContainerDimension() {
    return Cc(this.mainContainer);
  }
  get activeContainerDimension() {
    return Cc(this.activeContainer);
  }
  get containers() {
    return ha(this._codeEditorService.listCodeEditors().map(((n) => n.getContainerDomNode())));
  }
  getContainer() {
    return this.activeContainer;
  }
  whenContainerStylesLoaded() {
  }
  focus() {
    var n;
    (n = this._codeEditorService.getFocusedCodeEditor()) === null || n === void 0 || n.focus();
  }
  constructor(n) {
    this._codeEditorService = n, this.onDidLayoutMainContainer = se.None, this.onDidLayoutActiveContainer = se.None, this.onDidLayoutContainer = se.None, this.onDidChangeActiveContainer = se.None, this.onDidAddContainer = se.None, this.mainContainerOffset = { top: 0, quickPickTop: 0 }, this.activeContainerOffset = { top: 0, quickPickTop: 0 };
  }
};
wy = pW([mW(0, mt)], wy);
let SI = class extends wy {
  get mainContainer() {
    return this._container;
  }
  constructor(n, e) {
    super(e), this._container = n;
  }
};
SI = pW([mW(1, mt)], SI), rt(Ac, wy, 1);
const E1 = tt("dialogService");
var nJ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Q5 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
function kb(n) {
  return n.scheme === Ue.file ? n.fsPath : n.path;
}
let fW = 0;
class Db {
  constructor(e, t, i, s, o, r, a) {
    this.id = ++fW, this.type = 0, this.actual = e, this.label = e.label, this.confirmBeforeUndo = e.confirmBeforeUndo || !1, this.resourceLabel = t, this.strResource = i, this.resourceLabels = [this.resourceLabel], this.strResources = [this.strResource], this.groupId = s, this.groupOrder = o, this.sourceId = r, this.sourceOrder = a, this.isValid = !0;
  }
  setValid(e) {
    this.isValid = e;
  }
  toString() {
    return `[id:${this.id}] [group:${this.groupId}] [${this.isValid ? "  VALID" : "INVALID"}] ${this.actual.constructor.name} - ${this.actual}`;
  }
}
class J5 {
  constructor(e, t) {
    this.resourceLabel = e, this.reason = t;
  }
}
class e3 {
  constructor() {
    this.elements = /* @__PURE__ */ new Map();
  }
  createMessage() {
    const e = [], t = [];
    for (const [, s] of this.elements)
      (s.reason === 0 ? e : t).push(s.resourceLabel);
    const i = [];
    return e.length > 0 && i.push(m(0, "The following files have been closed and modified on disk: {0}.", e.join(", "))), t.length > 0 && i.push(m(0, "The following files have been modified in an incompatible way: {0}.", t.join(", "))), i.join(`
`);
  }
  get size() {
    return this.elements.size;
  }
  has(e) {
    return this.elements.has(e);
  }
  set(e, t) {
    this.elements.set(e, t);
  }
  delete(e) {
    return this.elements.delete(e);
  }
}
class sJ {
  constructor(e, t, i, s, o, r, a) {
    this.id = ++fW, this.type = 1, this.actual = e, this.label = e.label, this.confirmBeforeUndo = e.confirmBeforeUndo || !1, this.resourceLabels = t, this.strResources = i, this.groupId = s, this.groupOrder = o, this.sourceId = r, this.sourceOrder = a, this.removedResources = null, this.invalidatedResources = null;
  }
  canSplit() {
    return typeof this.actual.split == "function";
  }
  removeResource(e, t, i) {
    this.removedResources || (this.removedResources = new e3()), this.removedResources.has(t) || this.removedResources.set(t, new J5(e, i));
  }
  setValid(e, t, i) {
    i ? this.invalidatedResources && (this.invalidatedResources.delete(t), this.invalidatedResources.size === 0 && (this.invalidatedResources = null)) : (this.invalidatedResources || (this.invalidatedResources = new e3()), this.invalidatedResources.has(t) || this.invalidatedResources.set(t, new J5(e, 0)));
  }
  toString() {
    return `[id:${this.id}] [group:${this.groupId}] [${this.invalidatedResources ? "INVALID" : "  VALID"}] ${this.actual.constructor.name} - ${this.actual}`;
  }
}
class _W {
  constructor(e, t) {
    this.resourceLabel = e, this.strResource = t, this._past = [], this._future = [], this.locked = !1, this.versionId = 1;
  }
  dispose() {
    for (const e of this._past) e.type === 1 && e.removeResource(this.resourceLabel, this.strResource, 0);
    for (const e of this._future) e.type === 1 && e.removeResource(this.resourceLabel, this.strResource, 0);
    this.versionId++;
  }
  toString() {
    const e = [];
    e.push(`* ${this.strResource}:`);
    for (let t = 0; t < this._past.length; t++) e.push(`   * [UNDO] ${this._past[t]}`);
    for (let t = this._future.length - 1; t >= 0; t--) e.push(`   * [REDO] ${this._future[t]}`);
    return e.join(`
`);
  }
  flushAllElements() {
    this._past = [], this._future = [], this.versionId++;
  }
  _setElementValidFlag(e, t) {
    e.type === 1 ? e.setValid(this.resourceLabel, this.strResource, t) : e.setValid(t);
  }
  setElementsValidFlag(e, t) {
    for (const i of this._past) t(i.actual) && this._setElementValidFlag(i, e);
    for (const i of this._future) t(i.actual) && this._setElementValidFlag(i, e);
  }
  pushElement(e) {
    for (const t of this._future) t.type === 1 && t.removeResource(this.resourceLabel, this.strResource, 1);
    this._future = [], this._past.push(e), this.versionId++;
  }
  createSnapshot(e) {
    const t = [];
    for (let i = 0, s = this._past.length; i < s; i++) t.push(this._past[i].id);
    for (let i = this._future.length - 1; i >= 0; i--) t.push(this._future[i].id);
    return new lW(e, t);
  }
  restoreSnapshot(e) {
    const t = e.elements.length;
    let i = !0, s = 0, o = -1;
    for (let a = 0, l = this._past.length; a < l; a++, s++) {
      const d = this._past[a];
      i && (s >= t || d.id !== e.elements[s]) && (i = !1, o = 0), i || d.type !== 1 || d.removeResource(this.resourceLabel, this.strResource, 0);
    }
    let r = -1;
    for (let a = this._future.length - 1; a >= 0; a--, s++) {
      const l = this._future[a];
      i && (s >= t || l.id !== e.elements[s]) && (i = !1, r = a), i || l.type !== 1 || l.removeResource(this.resourceLabel, this.strResource, 0);
    }
    o !== -1 && (this._past = this._past.slice(0, o)), r !== -1 && (this._future = this._future.slice(r + 1)), this.versionId++;
  }
  getElements() {
    const e = [], t = [];
    for (const i of this._past) e.push(i.actual);
    for (const i of this._future) t.push(i.actual);
    return { past: e, future: t };
  }
  getClosestPastElement() {
    return this._past.length === 0 ? null : this._past[this._past.length - 1];
  }
  getSecondClosestPastElement() {
    return this._past.length < 2 ? null : this._past[this._past.length - 2];
  }
  getClosestFutureElement() {
    return this._future.length === 0 ? null : this._future[this._future.length - 1];
  }
  hasPastElements() {
    return this._past.length > 0;
  }
  hasFutureElements() {
    return this._future.length > 0;
  }
  splitPastWorkspaceElement(e, t) {
    for (let i = this._past.length - 1; i >= 0; i--) if (this._past[i] === e) {
      t.has(this.strResource) ? this._past[i] = t.get(this.strResource) : this._past.splice(i, 1);
      break;
    }
    this.versionId++;
  }
  splitFutureWorkspaceElement(e, t) {
    for (let i = this._future.length - 1; i >= 0; i--) if (this._future[i] === e) {
      t.has(this.strResource) ? this._future[i] = t.get(this.strResource) : this._future.splice(i, 1);
      break;
    }
    this.versionId++;
  }
  moveBackward(e) {
    this._past.pop(), this._future.push(e), this.versionId++;
  }
  moveForward(e) {
    this._future.pop(), this._past.push(e), this.versionId++;
  }
}
class RD {
  constructor(e) {
    this.editStacks = e, this._versionIds = [];
    for (let t = 0, i = this.editStacks.length; t < i; t++) this._versionIds[t] = this.editStacks[t].versionId;
  }
  isValid() {
    for (let e = 0, t = this.editStacks.length; e < t; e++) if (this._versionIds[e] !== this.editStacks[e].versionId) return !1;
    return !0;
  }
}
const vW = new _W("", "");
vW.locked = !0;
let LI = class {
  constructor(n, e) {
    this._dialogService = n, this._notificationService = e, this._editStacks = /* @__PURE__ */ new Map(), this._uriComparisonKeyComputers = [];
  }
  getUriComparisonKey(n) {
    for (const e of this._uriComparisonKeyComputers) if (e[0] === n.scheme) return e[1].getComparisonKey(n);
    return n.toString();
  }
  _print(n) {
    console.log("------------------------------------"), console.log(`AFTER ${n}: `);
    const e = [];
    for (const t of this._editStacks) e.push(t[1].toString());
    console.log(e.join(`
`));
  }
  pushElement(n, e = cm.None, t = Za.None) {
    if (n.type === 0) {
      const i = kb(n.resource), s = this.getUriComparisonKey(n.resource);
      this._pushElement(new Db(n, i, s, e.id, e.nextOrder(), t.id, t.nextOrder()));
    } else {
      const i = /* @__PURE__ */ new Set(), s = [], o = [];
      for (const r of n.resources) {
        const a = kb(r), l = this.getUriComparisonKey(r);
        i.has(l) || (i.add(l), s.push(a), o.push(l));
      }
      s.length === 1 ? this._pushElement(new Db(n, s[0], o[0], e.id, e.nextOrder(), t.id, t.nextOrder())) : this._pushElement(new sJ(n, s, o, e.id, e.nextOrder(), t.id, t.nextOrder()));
    }
  }
  _pushElement(n) {
    for (let e = 0, t = n.strResources.length; e < t; e++) {
      const i = n.resourceLabels[e], s = n.strResources[e];
      let o;
      this._editStacks.has(s) ? o = this._editStacks.get(s) : (o = new _W(i, s), this._editStacks.set(s, o)), o.pushElement(n);
    }
  }
  getLastElement(n) {
    const e = this.getUriComparisonKey(n);
    if (this._editStacks.has(e)) {
      const t = this._editStacks.get(e);
      if (t.hasFutureElements()) return null;
      const i = t.getClosestPastElement();
      return i ? i.actual : null;
    }
    return null;
  }
  _splitPastWorkspaceElement(n, e) {
    const t = n.actual.split(), i = /* @__PURE__ */ new Map();
    for (const s of t) {
      const o = kb(s.resource), r = this.getUriComparisonKey(s.resource), a = new Db(s, o, r, 0, 0, 0, 0);
      i.set(a.strResource, a);
    }
    for (const s of n.strResources)
      e && e.has(s) || this._editStacks.get(s).splitPastWorkspaceElement(n, i);
  }
  _splitFutureWorkspaceElement(n, e) {
    const t = n.actual.split(), i = /* @__PURE__ */ new Map();
    for (const s of t) {
      const o = kb(s.resource), r = this.getUriComparisonKey(s.resource), a = new Db(s, o, r, 0, 0, 0, 0);
      i.set(a.strResource, a);
    }
    for (const s of n.strResources)
      e && e.has(s) || this._editStacks.get(s).splitFutureWorkspaceElement(n, i);
  }
  removeElements(n) {
    const e = typeof n == "string" ? n : this.getUriComparisonKey(n);
    this._editStacks.has(e) && (this._editStacks.get(e).dispose(), this._editStacks.delete(e));
  }
  setElementsValidFlag(n, e, t) {
    const i = this.getUriComparisonKey(n);
    this._editStacks.has(i) && this._editStacks.get(i).setElementsValidFlag(e, t);
  }
  createSnapshot(n) {
    const e = this.getUriComparisonKey(n);
    return this._editStacks.has(e) ? this._editStacks.get(e).createSnapshot(n) : new lW(n, []);
  }
  restoreSnapshot(n) {
    const e = this.getUriComparisonKey(n.resource);
    if (this._editStacks.has(e)) {
      const t = this._editStacks.get(e);
      t.restoreSnapshot(n), t.hasPastElements() || t.hasFutureElements() || (t.dispose(), this._editStacks.delete(e));
    }
  }
  getElements(n) {
    const e = this.getUriComparisonKey(n);
    return this._editStacks.has(e) ? this._editStacks.get(e).getElements() : { past: [], future: [] };
  }
  _findClosestUndoElementWithSource(n) {
    if (!n) return [null, null];
    let e = null, t = null;
    for (const [i, s] of this._editStacks) {
      const o = s.getClosestPastElement();
      o && o.sourceId === n && (!e || o.sourceOrder > e.sourceOrder) && (e = o, t = i);
    }
    return [e, t];
  }
  canUndo(n) {
    if (n instanceof Za) {
      const [, t] = this._findClosestUndoElementWithSource(n.id);
      return !!t;
    }
    const e = this.getUriComparisonKey(n);
    return this._editStacks.has(e) ? this._editStacks.get(e).hasPastElements() : !1;
  }
  _onError(n, e) {
    We(n);
    for (const t of e.strResources) this.removeElements(t);
    this._notificationService.error(n);
  }
  _acquireLocks(n) {
    for (const e of n.editStacks) if (e.locked) throw new Error("Cannot acquire edit stack lock");
    for (const e of n.editStacks) e.locked = !0;
    return () => {
      for (const e of n.editStacks) e.locked = !1;
    };
  }
  _safeInvokeWithLocks(n, e, t, i, s) {
    const o = this._acquireLocks(t);
    let r;
    try {
      r = e();
    } catch (a) {
      return o(), i.dispose(), this._onError(a, n);
    }
    return r ? r.then((() => (o(), i.dispose(), s())), ((a) => (o(), i.dispose(), this._onError(a, n)))) : (o(), i.dispose(), s());
  }
  async _invokeWorkspacePrepare(n) {
    if (n.actual.prepareUndoRedo === void 0) return V.None;
    const e = n.actual.prepareUndoRedo();
    return e === void 0 ? V.None : e;
  }
  _invokeResourcePrepare(n, e) {
    if (n.actual.type !== 1 || n.actual.prepareUndoRedo === void 0) return e(V.None);
    const t = n.actual.prepareUndoRedo();
    return t ? YT(t) ? e(t) : t.then(((i) => e(i))) : e(V.None);
  }
  _getAffectedEditStacks(n) {
    const e = [];
    for (const t of n.strResources) e.push(this._editStacks.get(t) || vW);
    return new RD(e);
  }
  _tryToSplitAndUndo(n, e, t, i) {
    if (e.canSplit()) return this._splitPastWorkspaceElement(e, t), this._notificationService.warn(i), new xb(this._undo(n, 0, !0));
    for (const s of e.strResources) this.removeElements(s);
    return this._notificationService.warn(i), new xb();
  }
  _checkWorkspaceUndo(n, e, t, i) {
    if (e.removedResources) return this._tryToSplitAndUndo(n, e, e.removedResources, m(0, "Could not undo '{0}' across all files. {1}", e.label, e.removedResources.createMessage()));
    if (i && e.invalidatedResources) return this._tryToSplitAndUndo(n, e, e.invalidatedResources, m(0, "Could not undo '{0}' across all files. {1}", e.label, e.invalidatedResources.createMessage()));
    const s = [];
    for (const r of t.editStacks) r.getClosestPastElement() !== e && s.push(r.resourceLabel);
    if (s.length > 0) return this._tryToSplitAndUndo(n, e, null, m(0, "Could not undo '{0}' across all files because changes were made to {1}", e.label, s.join(", ")));
    const o = [];
    for (const r of t.editStacks) r.locked && o.push(r.resourceLabel);
    return o.length > 0 ? this._tryToSplitAndUndo(n, e, null, m(0, "Could not undo '{0}' across all files because there is already an undo or redo operation running on {1}", e.label, o.join(", "))) : t.isValid() ? null : this._tryToSplitAndUndo(n, e, null, m(0, "Could not undo '{0}' across all files because an undo or redo operation occurred in the meantime", e.label));
  }
  _workspaceUndo(n, e, t) {
    const i = this._getAffectedEditStacks(e), s = this._checkWorkspaceUndo(n, e, i, !1);
    return s ? s.returnValue : this._confirmAndExecuteWorkspaceUndo(n, e, i, t);
  }
  _isPartOfUndoGroup(n) {
    if (!n.groupId) return !1;
    for (const [, e] of this._editStacks) {
      const t = e.getClosestPastElement();
      if (t) {
        if (t === n) {
          const i = e.getSecondClosestPastElement();
          if (i && i.groupId === n.groupId) return !0;
        }
        if (t.groupId === n.groupId) return !0;
      }
    }
    return !1;
  }
  async _confirmAndExecuteWorkspaceUndo(n, e, t, i) {
    if (e.canSplit() && !this._isPartOfUndoGroup(e)) {
      let r;
      (function(d) {
        d[d.All = 0] = "All", d[d.This = 1] = "This", d[d.Cancel = 2] = "Cancel";
      })(r || (r = {}));
      const { result: a } = await this._dialogService.prompt({ type: ki.Info, message: m(0, "Would you like to undo '{0}' across all files?", e.label), buttons: [{ label: m(0, "&&Undo in {0} Files", t.editStacks.length), run: () => r.All }, { label: m(0, "Undo this &&File"), run: () => r.This }], cancelButton: { run: () => r.Cancel } });
      if (a === r.Cancel) return;
      if (a === r.This) return this._splitPastWorkspaceElement(e, null), this._undo(n, 0, !0);
      const l = this._checkWorkspaceUndo(n, e, t, !1);
      if (l) return l.returnValue;
      i = !0;
    }
    let s;
    try {
      s = await this._invokeWorkspacePrepare(e);
    } catch (r) {
      return this._onError(r, e);
    }
    const o = this._checkWorkspaceUndo(n, e, t, !0);
    if (o) return s.dispose(), o.returnValue;
    for (const r of t.editStacks) r.moveBackward(e);
    return this._safeInvokeWithLocks(e, (() => e.actual.undo()), t, s, (() => this._continueUndoInGroup(e.groupId, i)));
  }
  _resourceUndo(n, e, t) {
    if (e.isValid) {
      if (!n.locked) return this._invokeResourcePrepare(e, ((i) => (n.moveBackward(e), this._safeInvokeWithLocks(e, (() => e.actual.undo()), new RD([n]), i, (() => this._continueUndoInGroup(e.groupId, t))))));
      {
        const i = m(0, "Could not undo '{0}' because there is already an undo or redo operation running.", e.label);
        this._notificationService.warn(i);
      }
    } else n.flushAllElements();
  }
  _findClosestUndoElementInGroup(n) {
    if (!n) return [null, null];
    let e = null, t = null;
    for (const [i, s] of this._editStacks) {
      const o = s.getClosestPastElement();
      o && o.groupId === n && (!e || o.groupOrder > e.groupOrder) && (e = o, t = i);
    }
    return [e, t];
  }
  _continueUndoInGroup(n, e) {
    if (!n) return;
    const [, t] = this._findClosestUndoElementInGroup(n);
    return t ? this._undo(t, 0, e) : void 0;
  }
  undo(n) {
    if (n instanceof Za) {
      const [, e] = this._findClosestUndoElementWithSource(n.id);
      return e ? this._undo(e, n.id, !1) : void 0;
    }
    return typeof n == "string" ? this._undo(n, 0, !1) : this._undo(this.getUriComparisonKey(n), 0, !1);
  }
  _undo(n, e = 0, t) {
    if (!this._editStacks.has(n)) return;
    const i = this._editStacks.get(n), s = i.getClosestPastElement();
    if (s) {
      if (s.groupId) {
        const [o, r] = this._findClosestUndoElementInGroup(s.groupId);
        if (s !== o && r) return this._undo(r, e, t);
      }
      if ((s.sourceId !== e || s.confirmBeforeUndo) && !t) return this._confirmAndContinueUndo(n, e, s);
      try {
        return s.type === 1 ? this._workspaceUndo(n, s, t) : this._resourceUndo(i, s, t);
      } finally {
      }
    }
  }
  async _confirmAndContinueUndo(n, e, t) {
    if ((await this._dialogService.confirm({ message: m(0, "Would you like to undo '{0}'?", t.label), primaryButton: m(0, "&&Yes"), cancelButton: m(0, "No") })).confirmed) return this._undo(n, e, !0);
  }
  _findClosestRedoElementWithSource(n) {
    if (!n) return [null, null];
    let e = null, t = null;
    for (const [i, s] of this._editStacks) {
      const o = s.getClosestFutureElement();
      o && o.sourceId === n && (!e || o.sourceOrder < e.sourceOrder) && (e = o, t = i);
    }
    return [e, t];
  }
  canRedo(n) {
    if (n instanceof Za) {
      const [, t] = this._findClosestRedoElementWithSource(n.id);
      return !!t;
    }
    const e = this.getUriComparisonKey(n);
    return this._editStacks.has(e) ? this._editStacks.get(e).hasFutureElements() : !1;
  }
  _tryToSplitAndRedo(n, e, t, i) {
    if (e.canSplit()) return this._splitFutureWorkspaceElement(e, t), this._notificationService.warn(i), new xb(this._redo(n));
    for (const s of e.strResources) this.removeElements(s);
    return this._notificationService.warn(i), new xb();
  }
  _checkWorkspaceRedo(n, e, t, i) {
    if (e.removedResources) return this._tryToSplitAndRedo(n, e, e.removedResources, m(0, "Could not redo '{0}' across all files. {1}", e.label, e.removedResources.createMessage()));
    if (i && e.invalidatedResources) return this._tryToSplitAndRedo(n, e, e.invalidatedResources, m(0, "Could not redo '{0}' across all files. {1}", e.label, e.invalidatedResources.createMessage()));
    const s = [];
    for (const r of t.editStacks) r.getClosestFutureElement() !== e && s.push(r.resourceLabel);
    if (s.length > 0) return this._tryToSplitAndRedo(n, e, null, m(0, "Could not redo '{0}' across all files because changes were made to {1}", e.label, s.join(", ")));
    const o = [];
    for (const r of t.editStacks) r.locked && o.push(r.resourceLabel);
    return o.length > 0 ? this._tryToSplitAndRedo(n, e, null, m(0, "Could not redo '{0}' across all files because there is already an undo or redo operation running on {1}", e.label, o.join(", "))) : t.isValid() ? null : this._tryToSplitAndRedo(n, e, null, m(0, "Could not redo '{0}' across all files because an undo or redo operation occurred in the meantime", e.label));
  }
  _workspaceRedo(n, e) {
    const t = this._getAffectedEditStacks(e), i = this._checkWorkspaceRedo(n, e, t, !1);
    return i ? i.returnValue : this._executeWorkspaceRedo(n, e, t);
  }
  async _executeWorkspaceRedo(n, e, t) {
    let i;
    try {
      i = await this._invokeWorkspacePrepare(e);
    } catch (o) {
      return this._onError(o, e);
    }
    const s = this._checkWorkspaceRedo(n, e, t, !0);
    if (s) return i.dispose(), s.returnValue;
    for (const o of t.editStacks) o.moveForward(e);
    return this._safeInvokeWithLocks(e, (() => e.actual.redo()), t, i, (() => this._continueRedoInGroup(e.groupId)));
  }
  _resourceRedo(n, e) {
    if (e.isValid) {
      if (!n.locked) return this._invokeResourcePrepare(e, ((t) => (n.moveForward(e), this._safeInvokeWithLocks(e, (() => e.actual.redo()), new RD([n]), t, (() => this._continueRedoInGroup(e.groupId))))));
      {
        const t = m(0, "Could not redo '{0}' because there is already an undo or redo operation running.", e.label);
        this._notificationService.warn(t);
      }
    } else n.flushAllElements();
  }
  _findClosestRedoElementInGroup(n) {
    if (!n) return [null, null];
    let e = null, t = null;
    for (const [i, s] of this._editStacks) {
      const o = s.getClosestFutureElement();
      o && o.groupId === n && (!e || o.groupOrder < e.groupOrder) && (e = o, t = i);
    }
    return [e, t];
  }
  _continueRedoInGroup(n) {
    if (!n) return;
    const [, e] = this._findClosestRedoElementInGroup(n);
    return e ? this._redo(e) : void 0;
  }
  redo(n) {
    if (n instanceof Za) {
      const [, e] = this._findClosestRedoElementWithSource(n.id);
      return e ? this._redo(e) : void 0;
    }
    return typeof n == "string" ? this._redo(n) : this._redo(this.getUriComparisonKey(n));
  }
  _redo(n) {
    if (!this._editStacks.has(n)) return;
    const e = this._editStacks.get(n), t = e.getClosestFutureElement();
    if (t) {
      if (t.groupId) {
        const [i, s] = this._findClosestRedoElementInGroup(t.groupId);
        if (t !== i && s) return this._redo(s);
      }
      try {
        return t.type === 1 ? this._workspaceRedo(n, t) : this._resourceRedo(e, t);
      } finally {
      }
    }
  }
};
LI = nJ([Q5(0, E1), Q5(1, Ri)], LI);
class xb {
  constructor(e) {
    this.returnValue = e;
  }
}
function as(n, e, t) {
  return Math.min(Math.max(n, e), t);
}
rt(gL, LI, 1);
class bW {
  constructor() {
    this._n = 1, this._val = 0;
  }
  update(e) {
    return this._val = this._val + (e - this._val) / this._n, this._n += 1, this._val;
  }
  get value() {
    return this._val;
  }
}
class oJ {
  constructor(e) {
    this._n = 0, this._val = 0, this._values = [], this._index = 0, this._sum = 0, this._values = new Array(e), this._values.fill(0, 0, e);
  }
  update(e) {
    const t = this._values[this._index];
    return this._values[this._index] = e, this._index = (this._index + 1) % this._values.length, this._sum -= t, this._sum += e, this._n < this._values.length && (this._n += 1), this._val = this._sum / this._n, this._val;
  }
  get value() {
    return this._val;
  }
}
const cA = tt("environmentService");
var rJ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, t3 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const ar = tt("ILanguageFeatureDebounceService");
var yy;
(function(n) {
  const e = /* @__PURE__ */ new WeakMap();
  let t = 0;
  n.of = function(i) {
    let s = e.get(i);
    return s === void 0 && (s = ++t, e.set(i, s)), s;
  };
})(yy || (yy = {}));
class aJ {
  constructor(e) {
    this._default = e;
  }
  get(e) {
    return this._default;
  }
  update(e, t) {
    return this._default;
  }
  default() {
    return this._default;
  }
}
class lJ {
  constructor(e, t, i, s, o, r) {
    this._logService = e, this._name = t, this._registry = i, this._default = s, this._min = o, this._max = r, this._cache = new Ll(50, 0.7);
  }
  _key(e) {
    return e.id + this._registry.all(e).reduce(((t, i) => Hw(yy.of(i), t)), 0);
  }
  get(e) {
    const t = this._key(e), i = this._cache.get(t);
    return i ? as(i.value, this._min, this._max) : this.default();
  }
  update(e, t) {
    const i = this._key(e);
    let s = this._cache.get(i);
    s || (s = new oJ(6), this._cache.set(i, s));
    const o = as(s.update(t), this._min, this._max);
    return uR(e.uri, "output") || this._logService.trace(`[DEBOUNCE: ${this._name}] for ${e.uri.toString()} is ${o}ms`), o;
  }
  _overall() {
    const e = new bW();
    for (const [, t] of this._cache) e.update(t.value);
    return e.value;
  }
  default() {
    return as(0 | this._overall() || this._default, this._min, this._max);
  }
}
let AD = class {
  constructor(n, e) {
    this._logService = n, this._data = /* @__PURE__ */ new Map(), this._isDev = e.isExtensionDevelopment || !e.isBuilt;
  }
  for(n, e, t) {
    var i, s, o;
    const r = (i = t?.min) !== null && i !== void 0 ? i : 50, a = (s = t?.max) !== null && s !== void 0 ? s : r ** 2, l = (o = t?.key) !== null && o !== void 0 ? o : void 0, d = `${yy.of(n)},${r}${l ? "," + l : ""}`;
    let h = this._data.get(d);
    return h || (this._isDev ? h = new lJ(this._logService, e, n, 0 | this._overallAverage() || 1.5 * r, r, a) : (this._logService.debug(`[DEBOUNCE: ${e}] is disabled in developed mode`), h = new aJ(1.5 * r)), this._data.set(d, h)), h;
  }
  _overallAverage() {
    const n = new bW();
    for (const e of this._data.values()) n.update(e.default());
    return n.value;
  }
};
AD = rJ([t3(0, ts), t3(1, cA)], AD), rt(ar, AD, 1);
class p0 {
  static create(e, t) {
    return new p0(e, new Sy(t));
  }
  get startLineNumber() {
    return this._startLineNumber;
  }
  get endLineNumber() {
    return this._endLineNumber;
  }
  constructor(e, t) {
    this._startLineNumber = e, this._tokens = t, this._endLineNumber = this._startLineNumber + this._tokens.getMaxDeltaLine();
  }
  toString() {
    return this._tokens.toString(this._startLineNumber);
  }
  _updateEndLineNumber() {
    this._endLineNumber = this._startLineNumber + this._tokens.getMaxDeltaLine();
  }
  isEmpty() {
    return this._tokens.isEmpty();
  }
  getLineTokens(e) {
    return this._startLineNumber <= e && e <= this._endLineNumber ? this._tokens.getLineTokens(e - this._startLineNumber) : null;
  }
  getRange() {
    const e = this._tokens.getRange();
    return e && new D(this._startLineNumber + e.startLineNumber, e.startColumn, this._startLineNumber + e.endLineNumber, e.endColumn);
  }
  removeTokens(e) {
    const t = e.startLineNumber - this._startLineNumber, i = e.endLineNumber - this._startLineNumber;
    this._startLineNumber += this._tokens.removeTokens(t, e.startColumn - 1, i, e.endColumn - 1), this._updateEndLineNumber();
  }
  split(e) {
    const t = e.startLineNumber - this._startLineNumber, i = e.endLineNumber - this._startLineNumber, [s, o, r] = this._tokens.split(t, e.startColumn - 1, i, e.endColumn - 1);
    return [new p0(this._startLineNumber, s), new p0(this._startLineNumber + r, o)];
  }
  applyEdit(e, t) {
    const [i, s, o] = kc(t);
    this.acceptEdit(e, i, s, o, t.length > 0 ? t.charCodeAt(0) : 0);
  }
  acceptEdit(e, t, i, s, o) {
    this._acceptDeleteRange(e), this._acceptInsertText(new W(e.startLineNumber, e.startColumn), t, i, s, o), this._updateEndLineNumber();
  }
  _acceptDeleteRange(e) {
    if (e.startLineNumber === e.endLineNumber && e.startColumn === e.endColumn) return;
    const t = e.startLineNumber - this._startLineNumber, i = e.endLineNumber - this._startLineNumber;
    if (i < 0) {
      const o = i - t;
      return void (this._startLineNumber -= o);
    }
    const s = this._tokens.getMaxDeltaLine();
    if (!(t >= s + 1)) {
      if (t < 0 && i >= s + 1) return this._startLineNumber = 0, void this._tokens.clear();
      if (t < 0) {
        const o = -t;
        this._startLineNumber -= o, this._tokens.acceptDeleteRange(e.startColumn - 1, 0, 0, i, e.endColumn - 1);
      } else this._tokens.acceptDeleteRange(0, t, e.startColumn - 1, i, e.endColumn - 1);
    }
  }
  _acceptInsertText(e, t, i, s, o) {
    if (t === 0 && i === 0) return;
    const r = e.lineNumber - this._startLineNumber;
    if (r < 0) return void (this._startLineNumber += t);
    r >= this._tokens.getMaxDeltaLine() + 1 || this._tokens.acceptInsertText(r, e.column - 1, t, i, s, o);
  }
}
class Sy {
  constructor(e) {
    this._tokens = e, this._tokenCount = e.length / 4;
  }
  toString(e) {
    const t = [];
    for (let i = 0; i < this._tokenCount; i++) t.push(`(${this._getDeltaLine(i) + e},${this._getStartCharacter(i)}-${this._getEndCharacter(i)})`);
    return `[${t.join(",")}]`;
  }
  getMaxDeltaLine() {
    const e = this._getTokenCount();
    return e === 0 ? -1 : this._getDeltaLine(e - 1);
  }
  getRange() {
    const e = this._getTokenCount();
    if (e === 0) return null;
    const t = this._getStartCharacter(0), i = this._getDeltaLine(e - 1), s = this._getEndCharacter(e - 1);
    return new D(0, t + 1, i, s + 1);
  }
  _getTokenCount() {
    return this._tokenCount;
  }
  _getDeltaLine(e) {
    return this._tokens[4 * e];
  }
  _getStartCharacter(e) {
    return this._tokens[4 * e + 1];
  }
  _getEndCharacter(e) {
    return this._tokens[4 * e + 2];
  }
  isEmpty() {
    return this._getTokenCount() === 0;
  }
  getLineTokens(e) {
    let t = 0, i = this._getTokenCount() - 1;
    for (; t < i; ) {
      const s = t + Math.floor((i - t) / 2), o = this._getDeltaLine(s);
      if (o < e) t = s + 1;
      else {
        if (!(o > e)) {
          let r = s;
          for (; r > t && this._getDeltaLine(r - 1) === e; ) r--;
          let a = s;
          for (; a < i && this._getDeltaLine(a + 1) === e; ) a++;
          return new i3(this._tokens.subarray(4 * r, 4 * a + 4));
        }
        i = s - 1;
      }
    }
    return this._getDeltaLine(t) === e ? new i3(this._tokens.subarray(4 * t, 4 * t + 4)) : null;
  }
  clear() {
    this._tokenCount = 0;
  }
  removeTokens(e, t, i, s) {
    const o = this._tokens, r = this._tokenCount;
    let a = 0, l = !1, d = 0;
    for (let h = 0; h < r; h++) {
      const c = 4 * h, u = o[c], g = o[c + 1], p = o[c + 2], f = o[c + 3];
      if ((u > e || u === e && p >= t) && (u < i || u === i && g <= s)) l = !0;
      else {
        if (a === 0 && (d = u), l) {
          const _ = 4 * a;
          o[_] = u - d, o[_ + 1] = g, o[_ + 2] = p, o[_ + 3] = f;
        }
        a++;
      }
    }
    return this._tokenCount = a, d;
  }
  split(e, t, i, s) {
    const o = this._tokens, r = this._tokenCount, a = [], l = [];
    let d = a, h = 0, c = 0;
    for (let u = 0; u < r; u++) {
      const g = 4 * u, p = o[g], f = o[g + 1], _ = o[g + 2], v = o[g + 3];
      if (p > e || p === e && _ >= t) {
        if (p < i || p === i && f <= s) continue;
        d !== l && (d = l, h = 0, c = p);
      }
      d[h++] = p - c, d[h++] = f, d[h++] = _, d[h++] = v;
    }
    return [new Sy(new Uint32Array(a)), new Sy(new Uint32Array(l)), c];
  }
  acceptDeleteRange(e, t, i, s, o) {
    const r = this._tokens, a = this._tokenCount, l = s - t;
    let d = 0, h = !1;
    for (let c = 0; c < a; c++) {
      const u = 4 * c;
      let g = r[u], p = r[u + 1], f = r[u + 2];
      const _ = r[u + 3];
      if (g < t || g === t && f <= i) {
        d++;
        continue;
      }
      if (g === t && p < i) g === s && f > o ? f -= o - i : f = i;
      else if (g === t && p === i) {
        if (!(g === s && f > o)) {
          h = !0;
          continue;
        }
        f -= o - i;
      } else if (g < s || g === s && p < o) {
        if (!(g === s && f > o)) {
          h = !0;
          continue;
        }
        g = t, p = i, f = p + (f - o);
      } else if (g > s) {
        if (l === 0 && !h) {
          d = a;
          break;
        }
        g -= l;
      } else {
        if (!(g === s && p >= o)) throw new Error("Not possible!");
        e && g === 0 && (p += e, f += e), g -= l, p -= o - i, f -= o - i;
      }
      const v = 4 * d;
      r[v] = g, r[v + 1] = p, r[v + 2] = f, r[v + 3] = _, d++;
    }
    this._tokenCount = d;
  }
  acceptInsertText(e, t, i, s, o, r) {
    const a = i === 0 && s === 1 && (r >= 48 && r <= 57 || r >= 65 && r <= 90 || r >= 97 && r <= 122), l = this._tokens, d = this._tokenCount;
    for (let h = 0; h < d; h++) {
      const c = 4 * h;
      let u = l[c], g = l[c + 1], p = l[c + 2];
      if (!(u < e || u === e && p < t)) {
        if (u === e && p === t) {
          if (!a) continue;
          p += 1;
        } else if (u === e && g < t && t < p) i === 0 ? p += s : p = t;
        else {
          if (u === e && g === t && a) continue;
          if (u === e) if (u += i, i === 0) g += s, p += s;
          else {
            const f = p - g;
            g = o + (g - t), p = g + f;
          }
          else u += i;
        }
        l[c] = u, l[c + 1] = g, l[c + 2] = p;
      }
    }
  }
}
class i3 {
  constructor(e) {
    this._tokens = e;
  }
  getCount() {
    return this._tokens.length / 4;
  }
  getStartCharacter(e) {
    return this._tokens[4 * e + 1];
  }
  getEndCharacter(e) {
    return this._tokens[4 * e + 2];
  }
  getMetadata(e) {
    return this._tokens[4 * e + 3];
  }
}
var dJ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, PD = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let kI = class {
  constructor(n, e, t, i) {
    this._legend = n, this._themeService = e, this._languageService = t, this._logService = i, this._hasWarnedOverlappingTokens = !1, this._hasWarnedInvalidLengthTokens = !1, this._hasWarnedInvalidEditStart = !1, this._hashTable = new ql();
  }
  getMetadata(n, e, t) {
    const i = this._languageService.languageIdCodec.encodeLanguageId(t), s = this._hashTable.get(n, e, i);
    let o;
    if (s) o = s.metadata, this._logService.getLevel() === Nn.Trace && this._logService.trace(`SemanticTokensProviderStyling [CACHED] ${n} / ${e}: foreground ${In.getForeground(o)}, fontStyle ${In.getFontStyle(o).toString(2)}`);
    else {
      let r = this._legend.tokenTypes[n];
      const a = [];
      if (r) {
        let l = e;
        for (let h = 0; l > 0 && h < this._legend.tokenModifiers.length; h++) 1 & l && a.push(this._legend.tokenModifiers[h]), l >>= 1;
        l > 0 && this._logService.getLevel() === Nn.Trace && (this._logService.trace(`SemanticTokensProviderStyling: unknown token modifier index: ${e.toString(2)} for legend: ${JSON.stringify(this._legend.tokenModifiers)}`), a.push("not-in-legend"));
        const d = this._themeService.getColorTheme().getTokenStyleMetadata(r, a, t);
        d === void 0 ? o = 2147483647 : (o = 0, d.italic !== void 0 && (o |= 1 | (d.italic ? 1 : 0) << 11), d.bold !== void 0 && (o |= 2 | (d.bold ? 2 : 0) << 11), d.underline !== void 0 && (o |= 4 | (d.underline ? 4 : 0) << 11), d.strikethrough !== void 0 && (o |= 8 | (d.strikethrough ? 8 : 0) << 11), d.foreground && (o |= 16 | d.foreground << 15), o === 0 && (o = 2147483647));
      } else this._logService.getLevel() === Nn.Trace && this._logService.trace(`SemanticTokensProviderStyling: unknown token type index: ${n} for legend: ${JSON.stringify(this._legend.tokenTypes)}`), o = 2147483647, r = "not-in-legend";
      this._hashTable.add(n, e, i, o), this._logService.getLevel() === Nn.Trace && this._logService.trace(`SemanticTokensProviderStyling ${n} (${r}) / ${e} (${a.join(" ")}): foreground ${In.getForeground(o)}, fontStyle ${In.getFontStyle(o).toString(2)}`);
    }
    return o;
  }
  warnOverlappingSemanticTokens(n, e) {
    this._hasWarnedOverlappingTokens || (this._hasWarnedOverlappingTokens = !0, this._logService.warn(`Overlapping semantic tokens detected at lineNumber ${n}, column ${e}`));
  }
  warnInvalidLengthSemanticTokens(n, e) {
    this._hasWarnedInvalidLengthTokens || (this._hasWarnedInvalidLengthTokens = !0, this._logService.warn(`Semantic token with invalid length detected at lineNumber ${n}, column ${e}`));
  }
  warnInvalidEditStart(n, e, t, i, s) {
    this._hasWarnedInvalidEditStart || (this._hasWarnedInvalidEditStart = !0, this._logService.warn(`Invalid semantic tokens edit detected (previousResultId: ${n}, resultId: ${e}) at edit #${t}: The provided start offset ${i} is outside the previous data (length ${s}).`));
  }
};
function CW(n, e, t) {
  const i = n.data, s = n.data.length / 5 | 0, o = Math.max(Math.ceil(s / 1024), 400), r = [];
  let a = 0, l = 1, d = 0;
  for (; a < s; ) {
    const h = a;
    let c = Math.min(h + o, s);
    if (c < s) {
      let b = c;
      for (; b - 1 > h && i[5 * b] === 0; ) b--;
      if (b - 1 === h) {
        let C = c;
        for (; C + 1 < s && i[5 * C] === 0; ) C++;
        c = C;
      } else c = b;
    }
    let u = new Uint32Array(4 * (c - h)), g = 0, p = 0, f = 0, _ = 0;
    for (; a < c; ) {
      const b = 5 * a, C = i[b], w = i[b + 1], y = l + C | 0, L = C === 0 ? d + w | 0 : w, k = L + i[b + 2] | 0, N = i[b + 3], A = i[b + 4];
      if (k <= L) e.warnInvalidLengthSemanticTokens(y, L + 1);
      else if (f === y && _ > L) e.warnOverlappingSemanticTokens(y, L + 1);
      else {
        const B = e.getMetadata(N, A, t);
        B !== 2147483647 && (p === 0 && (p = y), u[g] = y - p, u[g + 1] = L, u[g + 2] = k, u[g + 3] = B, g += 4, f = y, _ = k);
      }
      l = y, d = L, a++;
    }
    g !== u.length && (u = u.subarray(0, g));
    const v = p0.create(p, u);
    r.push(v);
  }
  return r;
}
kI = dJ([PD(1, Yi), PD(2, Xt), PD(3, ts)], kI);
class hJ {
  constructor(e, t, i, s) {
    this.tokenTypeIndex = e, this.tokenModifierSet = t, this.languageId = i, this.metadata = s, this.next = null;
  }
}
class ql {
  constructor() {
    this._elementsCount = 0, this._currentLengthIndex = 0, this._currentLength = ql._SIZES[this._currentLengthIndex], this._growCount = Math.round(this._currentLengthIndex + 1 < ql._SIZES.length ? 2 / 3 * this._currentLength : 0), this._elements = [], ql._nullOutEntries(this._elements, this._currentLength);
  }
  static _nullOutEntries(e, t) {
    for (let i = 0; i < t; i++) e[i] = null;
  }
  _hash2(e, t) {
    return (e << 5) - e + t | 0;
  }
  _hashFunc(e, t, i) {
    return this._hash2(this._hash2(e, t), i) % this._currentLength;
  }
  get(e, t, i) {
    const s = this._hashFunc(e, t, i);
    let o = this._elements[s];
    for (; o; ) {
      if (o.tokenTypeIndex === e && o.tokenModifierSet === t && o.languageId === i) return o;
      o = o.next;
    }
    return null;
  }
  add(e, t, i, s) {
    if (this._elementsCount++, this._growCount !== 0 && this._elementsCount >= this._growCount) {
      const o = this._elements;
      this._currentLengthIndex++, this._currentLength = ql._SIZES[this._currentLengthIndex], this._growCount = Math.round(this._currentLengthIndex + 1 < ql._SIZES.length ? 2 / 3 * this._currentLength : 0), this._elements = [], ql._nullOutEntries(this._elements, this._currentLength);
      for (const r of o) {
        let a = r;
        for (; a; ) {
          const l = a.next;
          a.next = null, this._add(a), a = l;
        }
      }
    }
    this._add(new hJ(e, t, i, s));
  }
  _add(e) {
    const t = this._hashFunc(e.tokenTypeIndex, e.tokenModifierSet, e.languageId);
    e.next = this._elements[t], this._elements[t] = e;
  }
}
ql._SIZES = [3, 7, 13, 31, 61, 127, 251, 509, 1021, 2039, 4093, 8191, 16381, 32749, 65521, 131071, 262139, 524287, 1048573, 2097143];
const mL = tt("semanticTokensStylingService");
var cJ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, OD = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let FD = class extends V {
  constructor(n, e, t) {
    super(), this._themeService = n, this._logService = e, this._languageService = t, this._caches = /* @__PURE__ */ new WeakMap(), this._register(this._themeService.onDidColorThemeChange((() => {
      this._caches = /* @__PURE__ */ new WeakMap();
    })));
  }
  getStyling(n) {
    return this._caches.has(n) || this._caches.set(n, new kI(n.getLegend(), this._themeService, this._languageService, this._logService)), this._caches.get(n);
  }
};
FD = cJ([OD(0, Yi), OD(1, ts), OD(2, Xt)], FD), rt(mL, FD, 1);
const Nb = "**", n3 = "/", UC = "[/\\\\]", KC = "[^/\\\\]", uJ = /\//g;
function s3(n, e) {
  switch (n) {
    case 0:
      return "";
    case 1:
      return `${KC}*?`;
    default:
      return `(?:${UC}|${KC}+${UC}${e ? `|${UC}${KC}+` : ""})*?`;
  }
}
function o3(n, e) {
  if (!n) return [];
  const t = [];
  let i = !1, s = !1, o = "";
  for (const r of n) {
    switch (r) {
      case e:
        if (!i && !s) {
          t.push(o), o = "";
          continue;
        }
        break;
      case "{":
        i = !0;
        break;
      case "}":
        i = !1;
        break;
      case "[":
        s = !0;
        break;
      case "]":
        s = !1;
    }
    o += r;
  }
  return o && t.push(o), t;
}
function wW(n) {
  if (!n) return "";
  let e = "";
  const t = o3(n, n3);
  if (t.every(((i) => i === Nb))) e = ".*";
  else {
    let i = !1;
    t.forEach(((s, o) => {
      if (s === Nb) {
        if (i) return;
        e += s3(2, o === t.length - 1);
      } else {
        let r = !1, a = "", l = !1, d = "";
        for (const h of s) if (h !== "}" && r) a += h;
        else if (!l || h === "]" && d) switch (h) {
          case "{":
            r = !0;
            continue;
          case "[":
            l = !0;
            continue;
          case "}": {
            const c = `(?:${o3(a, ",").map(((u) => wW(u))).join("|")})`;
            e += c, r = !1, a = "";
            break;
          }
          case "]":
            e += "[" + d + "]", l = !1, d = "";
            break;
          case "?":
            e += KC;
            continue;
          case "*":
            e += s3(1);
            continue;
          default:
            e += No(h);
        }
        else {
          let c;
          c = h === "-" ? h : h !== "^" && h !== "!" || d ? h === n3 ? "" : No(h) : "^", d += c;
        }
        o < t.length - 1 && (t[o + 1] !== Nb || o + 2 < t.length) && (e += UC);
      }
      i = s === Nb;
    }));
  }
  return e;
}
const gJ = /^\*\*\/\*\.[\w\.-]+$/, pJ = /^\*\*\/([\w\.-]+)\/?$/, mJ = /^{\*\*\/\*?[\w\.-]+\/?(,\*\*\/\*?[\w\.-]+\/?)*}$/, fJ = /^{\*\*\/\*?[\w\.-]+(\/(\*\*)?)?(,\*\*\/\*?[\w\.-]+(\/(\*\*)?)?)*}$/, _J = /^\*\*((\/[\w\.-]+)+)\/?$/, vJ = /^([\w\.-]+(\/[\w\.-]+)*)\/?$/, r3 = new Ll(1e4), a3 = function() {
  return !1;
}, Ha = function() {
  return null;
};
function DI(n, e) {
  if (!n) return Ha;
  let t;
  t = typeof n != "string" ? n.pattern : n, t = t.trim();
  const i = `${t}_${!!e.trimForExclusions}`;
  let s, o = r3.get(i);
  return o || (o = gJ.test(t) ? /* @__PURE__ */ (function(r, a) {
    return function(l, d) {
      return typeof l == "string" && l.endsWith(r) ? a : null;
    };
  })(t.substr(4), t) : (s = pJ.exec(BD(t, e))) ? (function(r, a) {
    const l = `/${r}`, d = `\\${r}`, h = function(u, g) {
      return typeof u != "string" ? null : g ? g === r ? a : null : u === r || u.endsWith(l) || u.endsWith(d) ? a : null;
    }, c = [r];
    return h.basenames = c, h.patterns = [a], h.allBasenames = c, h;
  })(s[1], t) : (e.trimForExclusions ? fJ : mJ).test(t) ? (function(r, a) {
    const l = SW(r.slice(1, -1).split(",").map(((g) => DI(g, a))).filter(((g) => g !== Ha)), r), d = l.length;
    if (!d) return Ha;
    if (d === 1) return l[0];
    const h = function(g, p) {
      for (let f = 0, _ = l.length; f < _; f++) if (l[f](g, p)) return r;
      return null;
    }, c = l.find(((g) => !!g.allBasenames));
    c && (h.allBasenames = c.allBasenames);
    const u = l.reduce(((g, p) => p.allPaths ? g.concat(p.allPaths) : g), []);
    return u.length && (h.allPaths = u), h;
  })(t, e) : (s = _J.exec(BD(t, e))) ? l3(s[1].substr(1), t, !0) : (s = vJ.exec(BD(t, e))) ? l3(s[1], t, !1) : (function(r) {
    try {
      const a = new RegExp(`^${wW(r)}$`);
      return function(l) {
        return a.lastIndex = 0, typeof l == "string" && a.test(l) ? r : null;
      };
    } catch {
      return Ha;
    }
  })(t), r3.set(i, o)), bJ(o, n);
}
function bJ(n, e) {
  if (typeof e == "string") return n;
  const t = function(i, s) {
    return cI(i, e.base, !Cs) ? n(u1(i.substr(e.base.length), sa), s) : null;
  };
  return t.allBasenames = n.allBasenames, t.allPaths = n.allPaths, t.basenames = n.basenames, t.patterns = n.patterns, t;
}
function BD(n, e) {
  return e.trimForExclusions && n.endsWith("/**") ? n.substr(0, n.length - 2) : n;
}
function l3(n, e, t) {
  const i = sa === Fi.sep, s = i ? n : n.replace(uJ, sa), o = sa + s, r = Fi.sep + n;
  let a;
  return a = t ? function(l, d) {
    return typeof l != "string" || l !== s && !l.endsWith(o) && (i || l !== n && !l.endsWith(r)) ? null : e;
  } : function(l, d) {
    return typeof l != "string" || l !== s && (i || l !== n) ? null : e;
  }, a.allPaths = [(t ? "*/" : "./") + n], a;
}
function yW(n, e = {}) {
  if (!n) return a3;
  if (typeof n == "string" || (function(t) {
    const i = t;
    return i ? typeof i.base == "string" && typeof i.pattern == "string" : !1;
  })(n)) {
    const t = DI(n, e);
    if (t === Ha) return a3;
    const i = function(s, o) {
      return !!t(s, o);
    };
    return t.allBasenames && (i.allBasenames = t.allBasenames), t.allPaths && (i.allPaths = t.allPaths), i;
  }
  return (function(t, i) {
    const s = SW(Object.getOwnPropertyNames(t).map(((d) => (function(h, c, u) {
      if (c === !1) return Ha;
      const g = DI(h, u);
      if (g === Ha) return Ha;
      if (typeof c == "boolean") return g;
      if (c) {
        const p = c.when;
        if (typeof p == "string") {
          const f = (_, v, b, C) => {
            if (!C || !g(_, v)) return null;
            const w = C(p.replace("$(basename)", (() => b)));
            return Ok(w) ? w.then(((y) => y ? h : null)) : w ? h : null;
          };
          return f.requiresSiblings = !0, f;
        }
      }
      return g;
    })(d, t[d], i))).filter(((d) => d !== Ha))), o = s.length;
    if (!o) return Ha;
    if (!s.some(((d) => !!d.requiresSiblings))) {
      if (o === 1) return s[0];
      const d = function(u, g) {
        let p;
        for (let f = 0, _ = s.length; f < _; f++) {
          const v = s[f](u, g);
          if (typeof v == "string") return v;
          Ok(v) && (p || (p = []), p.push(v));
        }
        return p ? (async () => {
          for (const f of p) {
            const _ = await f;
            if (typeof _ == "string") return _;
          }
          return null;
        })() : null;
      }, h = s.find(((u) => !!u.allBasenames));
      h && (d.allBasenames = h.allBasenames);
      const c = s.reduce(((u, g) => g.allPaths ? u.concat(g.allPaths) : u), []);
      return c.length && (d.allPaths = c), d;
    }
    const r = function(d, h, c) {
      let u, g;
      for (let p = 0, f = s.length; p < f; p++) {
        const _ = s[p];
        _.requiresSiblings && c && (h || (h = xh(d)), u || (u = h.substr(0, h.length - pK(d).length)));
        const v = _(d, h, u, c);
        if (typeof v == "string") return v;
        Ok(v) && (g || (g = []), g.push(v));
      }
      return g ? (async () => {
        for (const p of g) {
          const f = await p;
          if (typeof f == "string") return f;
        }
        return null;
      })() : null;
    }, a = s.find(((d) => !!d.allBasenames));
    a && (r.allBasenames = a.allBasenames);
    const l = s.reduce(((d, h) => h.allPaths ? d.concat(h.allPaths) : d), []);
    return l.length && (r.allPaths = l), r;
  })(n, e);
}
function SW(n, e) {
  const t = n.filter(((a) => !!a.basenames));
  if (t.length < 2) return n;
  const i = t.reduce(((a, l) => {
    const d = l.basenames;
    return d ? a.concat(d) : a;
  }), []);
  let s;
  if (e) {
    s = [];
    for (let a = 0, l = i.length; a < l; a++) s.push(e);
  } else s = t.reduce(((a, l) => {
    const d = l.patterns;
    return d ? a.concat(d) : a;
  }), []);
  const o = function(a, l) {
    if (typeof a != "string") return null;
    if (!l) {
      let h;
      for (h = a.length; h > 0; h--) {
        const c = a.charCodeAt(h - 1);
        if (c === 47 || c === 92) break;
      }
      l = a.substr(h);
    }
    const d = i.indexOf(l);
    return d !== -1 ? s[d] : null;
  };
  o.basenames = i, o.patterns = s, o.allBasenames = i;
  const r = n.filter(((a) => !a.basenames));
  return r.push(o), r;
}
function uA(n, e, t, i, s, o) {
  if (Array.isArray(n)) {
    let d = 0;
    for (const h of n) {
      const c = uA(h, e, t, i, s, o);
      if (c === 10) return c;
      c > d && (d = c);
    }
    return d;
  }
  if (typeof n == "string") return i ? n === "*" ? 5 : n === t ? 10 : 0 : 0;
  if (n) {
    const { language: d, pattern: h, scheme: c, hasAccessToAllModels: u, notebookType: g } = n;
    if (!i && !u) return 0;
    g && s && (e = s);
    let p = 0;
    if (c) if (c === e.scheme) p = 10;
    else {
      if (c !== "*") return 0;
      p = 5;
    }
    if (d) if (d === t) p = 10;
    else {
      if (d !== "*") return 0;
      p = Math.max(p, 5);
    }
    if (g) if (g === o) p = 10;
    else {
      if (g !== "*" || o === void 0) return 0;
      p = Math.max(p, 5);
    }
    if (h) {
      let f;
      if (f = typeof h == "string" ? h : { ...h, base: z7(h.base) }, f !== e.fsPath && (r = f, a = e.fsPath, !r || typeof a != "string" || !yW(r)(a, void 0, l))) return 0;
      p = 10;
    }
    return p;
  }
  return 0;
  var r, a, l;
}
function LW(n) {
  return typeof n != "string" && (Array.isArray(n) ? n.every(LW) : !!n.exclusive);
}
class d3 {
  constructor(e, t, i, s) {
    this.uri = e, this.languageId = t, this.notebookUri = i, this.notebookType = s;
  }
  equals(e) {
    var t, i;
    return this.notebookType === e.notebookType && this.languageId === e.languageId && this.uri.toString() === e.uri.toString() && ((t = this.notebookUri) === null || t === void 0 ? void 0 : t.toString()) === ((i = e.notebookUri) === null || i === void 0 ? void 0 : i.toString());
  }
}
class ei {
  constructor(e) {
    this._notebookInfoResolver = e, this._clock = 0, this._entries = [], this._onDidChange = new F(), this.onDidChange = this._onDidChange.event;
  }
  register(e, t) {
    let i = { selector: e, provider: t, _score: -1, _time: this._clock++ };
    return this._entries.push(i), this._lastCandidate = void 0, this._onDidChange.fire(this._entries.length), ye((() => {
      if (i) {
        const s = this._entries.indexOf(i);
        s >= 0 && (this._entries.splice(s, 1), this._lastCandidate = void 0, this._onDidChange.fire(this._entries.length), i = void 0);
      }
    }));
  }
  has(e) {
    return this.all(e).length > 0;
  }
  all(e) {
    if (!e) return [];
    this._updateScores(e);
    const t = [];
    for (const i of this._entries) i._score > 0 && t.push(i.provider);
    return t;
  }
  ordered(e) {
    const t = [];
    return this._orderedForEach(e, ((i) => t.push(i.provider))), t;
  }
  orderedGroups(e) {
    const t = [];
    let i, s;
    return this._orderedForEach(e, ((o) => {
      i && s === o._score ? i.push(o.provider) : (s = o._score, i = [o.provider], t.push(i));
    })), t;
  }
  _orderedForEach(e, t) {
    this._updateScores(e);
    for (const i of this._entries) i._score > 0 && t(i);
  }
  _updateScores(e) {
    var t, i;
    const s = (t = this._notebookInfoResolver) === null || t === void 0 ? void 0 : t.call(this, e.uri), o = s ? new d3(e.uri, e.getLanguageId(), s.uri, s.type) : new d3(e.uri, e.getLanguageId(), void 0, void 0);
    if (!(!((i = this._lastCandidate) === null || i === void 0) && i.equals(o))) {
      this._lastCandidate = o;
      for (const r of this._entries) if (r._score = uA(r.selector, o.uri, o.languageId, $8(e), o.notebookUri, o.notebookType), LW(r.selector) && r._score > 0) {
        for (const a of this._entries) a._score = 0;
        r._score = 1e3;
        break;
      }
      this._entries.sort(ei._compareByScoreAndTime);
    }
  }
  static _compareByScoreAndTime(e, t) {
    return e._score < t._score ? 1 : e._score > t._score ? -1 : x_(e.selector) && !x_(t.selector) ? 1 : !x_(e.selector) && x_(t.selector) ? -1 : e._time < t._time ? 1 : e._time > t._time ? -1 : 0;
  }
}
function x_(n) {
  return typeof n != "string" && (Array.isArray(n) ? n.some(x_) : !!n.isBuiltin);
}
rt(fe, class {
  constructor() {
    this.referenceProvider = new ei(this._score.bind(this)), this.renameProvider = new ei(this._score.bind(this)), this.newSymbolNamesProvider = new ei(this._score.bind(this)), this.codeActionProvider = new ei(this._score.bind(this)), this.definitionProvider = new ei(this._score.bind(this)), this.typeDefinitionProvider = new ei(this._score.bind(this)), this.declarationProvider = new ei(this._score.bind(this)), this.implementationProvider = new ei(this._score.bind(this)), this.documentSymbolProvider = new ei(this._score.bind(this)), this.inlayHintsProvider = new ei(this._score.bind(this)), this.colorProvider = new ei(this._score.bind(this)), this.codeLensProvider = new ei(this._score.bind(this)), this.documentFormattingEditProvider = new ei(this._score.bind(this)), this.documentRangeFormattingEditProvider = new ei(this._score.bind(this)), this.onTypeFormattingEditProvider = new ei(this._score.bind(this)), this.signatureHelpProvider = new ei(this._score.bind(this)), this.hoverProvider = new ei(this._score.bind(this)), this.documentHighlightProvider = new ei(this._score.bind(this)), this.multiDocumentHighlightProvider = new ei(this._score.bind(this)), this.selectionRangeProvider = new ei(this._score.bind(this)), this.foldingRangeProvider = new ei(this._score.bind(this)), this.linkProvider = new ei(this._score.bind(this)), this.inlineCompletionsProvider = new ei(this._score.bind(this)), this.inlineEditProvider = new ei(this._score.bind(this)), this.completionProvider = new ei(this._score.bind(this)), this.linkedEditingRangeProvider = new ei(this._score.bind(this)), this.documentRangeSemanticTokensProvider = new ei(this._score.bind(this)), this.documentSemanticTokensProvider = new ei(this._score.bind(this)), this.documentOnDropEditProvider = new ei(this._score.bind(this)), this.documentPasteEditProvider = new ei(this._score.bind(this));
  }
  _score(n) {
    var e;
    return (e = this._notebookTypeResolver) === null || e === void 0 ? void 0 : e.call(this, n);
  }
}, 1);
var CJ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, h3 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const gA = tt("hoverService");
let Sv = class extends V {
  get delay() {
    return this.isInstantlyHovering() ? 0 : this._delay;
  }
  constructor(n, e, t = {}, i, s) {
    super(), this.placement = n, this.instantHover = e, this.overrideOptions = t, this.configurationService = i, this.hoverService = s, this.lastHoverHideTime = 0, this.timeLimit = 200, this.hoverDisposables = this._register(new G()), this._delay = this.configurationService.getValue("workbench.hover.delay"), this._register(this.configurationService.onDidChangeConfiguration(((o) => {
      o.affectsConfiguration("workbench.hover.delay") && (this._delay = this.configurationService.getValue("workbench.hover.delay"));
    })));
  }
  showHover(n, e) {
    const t = typeof this.overrideOptions == "function" ? this.overrideOptions(n, e) : this.overrideOptions;
    this.hoverDisposables.clear();
    const i = n.target instanceof HTMLElement ? [n.target] : n.target.targetElements;
    for (const o of i) this.hoverDisposables.add(bi(o, "keydown", ((r) => {
      r.equals(9) && this.hoverService.hideHover();
    })));
    const s = n.content instanceof HTMLElement ? void 0 : n.content.toString();
    return this.hoverService.showHover({ ...n, ...t, persistence: { hideOnKeyDown: !0, ...t.persistence }, id: s, appearance: { ...n.appearance, compact: !0, skipFadeInAnimation: this.isInstantlyHovering(), ...t.appearance } }, e);
  }
  isInstantlyHovering() {
    return this.instantHover && Date.now() - this.lastHoverHideTime < this.timeLimit;
  }
  onDidHideHover() {
    this.hoverDisposables.clear(), this.instantHover && (this.lastHoverHideTime = Date.now());
  }
};
Sv = CJ([h3(3, Ye), h3(4, gA)], Sv);
const zd = tt("contextViewService"), io = tt("contextMenuService"), Eb = Q;
let pA = class extends V {
  constructor() {
    super(), this.containerDomNode = document.createElement("div"), this.containerDomNode.className = "monaco-hover", this.containerDomNode.tabIndex = 0, this.containerDomNode.setAttribute("role", "tooltip"), this.contentsDomNode = document.createElement("div"), this.contentsDomNode.className = "monaco-hover-content", this.scrollbar = this._register(new S1(this.contentsDomNode, { consumeMouseWheelIfScrollbarIsNeeded: !0 })), this.containerDomNode.appendChild(this.scrollbar.getDomNode());
  }
  onContentsChanged() {
    this.scrollbar.scanDomNode();
  }
};
class fL extends V {
  static render(e, t, i) {
    return new fL(e, t, i);
  }
  constructor(e, t, i) {
    super(), this.actionContainer = Z(e, Eb("div.action-container")), this.actionContainer.setAttribute("tabindex", "0"), this.action = Z(this.actionContainer, Eb("a.action")), this.action.setAttribute("role", "button"), t.iconClass && Z(this.action, Eb(`span.icon.${t.iconClass}`)), Z(this.action, Eb("span")).textContent = i ? `${t.label} (${i})` : t.label, this._register(K(this.actionContainer, ie.CLICK, ((s) => {
      s.stopPropagation(), s.preventDefault(), t.run(this.actionContainer);
    }))), this._register(K(this.actionContainer, ie.KEY_DOWN, ((s) => {
      const o = new jt(s);
      (o.equals(3) || o.equals(10)) && (s.stopPropagation(), s.preventDefault(), t.run(this.actionContainer));
    }))), this.setEnabled(!0);
  }
  setEnabled(e) {
    e ? (this.actionContainer.classList.remove("disabled"), this.actionContainer.removeAttribute("aria-disabled")) : (this.actionContainer.classList.add("disabled"), this.actionContainer.setAttribute("aria-disabled", "true"));
  }
}
function kW(n, e) {
  return n && e ? m(0, "Inspect this in the accessible view with {0}.", e) : n ? m(0, "Inspect this in the accessible view via the command Open Accessible View which is currently not triggerable via keybinding.") : "";
}
const Fs = tt("openerService");
function wJ(n, e = {}) {
  const t = mA(e);
  return DW(t, (function(i, s) {
    const o = { type: 1, children: [] };
    let r = 0, a = o;
    const l = [], d = new yJ(i);
    for (; !d.eos(); ) {
      let h = d.next();
      const c = h === "\\" && xI(d.peek(), s) !== 0;
      if (c && (h = d.next()), !c && SJ(h, s) && h === d.peek()) {
        d.advance(), a.type === 2 && (a = l.pop());
        const u = xI(h, s);
        if (a.type === u || a.type === 5 && u === 6) a = l.pop();
        else {
          const g = { type: u, children: [] };
          u === 5 && (g.index = r, r++), a.children.push(g), l.push(a), a = g;
        }
      } else if (h === `
`) a.type === 2 && (a = l.pop()), a.children.push({ type: 8 });
      else if (a.type !== 2) {
        const u = { type: 2, content: h };
        a.children.push(u), l.push(a), a = u;
      } else a.content += h;
    }
    return a.type === 2 && (a = l.pop()), o;
  })(n, !!e.renderCodeSegments), e.actionHandler, e.renderCodeSegments), t;
}
function mA(n) {
  const e = n.inline ? "span" : "div", t = document.createElement(e);
  return n.className && (t.className = n.className), t;
}
class yJ {
  constructor(e) {
    this.source = e, this.index = 0;
  }
  eos() {
    return this.index >= this.source.length;
  }
  next() {
    const e = this.peek();
    return this.advance(), e;
  }
  peek() {
    return this.source[this.index];
  }
  advance() {
    this.index++;
  }
}
function DW(n, e, t, i) {
  let s;
  if (e.type === 2) s = document.createTextNode(e.content || "");
  else if (e.type === 3) s = document.createElement("b");
  else if (e.type === 4) s = document.createElement("i");
  else if (e.type === 7 && i) s = document.createElement("code");
  else if (e.type === 5 && t) {
    const o = document.createElement("a");
    t.disposables.add(bi(o, "click", ((r) => {
      t.callback(String(e.index), r);
    }))), s = o;
  } else e.type === 8 ? s = document.createElement("br") : e.type === 1 && (s = n);
  s && n !== s && n.appendChild(s), s && Array.isArray(e.children) && e.children.forEach(((o) => {
    DW(s, o, t, i);
  }));
}
function SJ(n, e) {
  return xI(n, e) !== 0;
}
function xI(n, e) {
  switch (n) {
    case "*":
      return 3;
    case "_":
      return 4;
    case "[":
      return 5;
    case "]":
      return 6;
    case "`":
      return e ? 7 : 0;
    default:
      return 0;
  }
}
const LJ = new RegExp(`(\\\\)?\\$\\((${Ee.iconNameExpression}(?:${Ee.iconModifierExpression})?)\\)`, "g");
function tc(n) {
  const e = new Array();
  let t, i = 0, s = 0;
  for (; (t = LJ.exec(n)) !== null; ) {
    s = t.index || 0, i < s && e.push(n.substring(i, s)), i = (t.index || 0) + t[0].length;
    const [, o, r] = t;
    e.push(o ? `$(${r})` : Lv({ id: r }));
  }
  return i < n.length && e.push(n.substring(i)), e;
}
function Lv(n) {
  const e = Q("span");
  return e.classList.add(...Ee.asClassNameArray(n)), e;
}
function kJ(n) {
  const e = (function(t) {
    if (ao = 0, Da(t, WD, 4352), ao > 0 || (Da(t, VD, 4449), ao > 0) || (Da(t, HD, 4520), ao > 0) || (Da(t, jc, 12593), ao)) return wh.subarray(0, ao);
    if (t >= 44032 && t <= 55203) {
      const i = t - 44032, s = i % 588, o = Math.floor(i / 588), r = Math.floor(s / 28), a = s % 28 - 1;
      if (o < WD.length ? Da(o, WD, 0) : 4352 + o - 12593 < jc.length && Da(4352 + o, jc, 12593), r < VD.length ? Da(r, VD, 0) : 4449 + r - 12593 < jc.length && Da(4449 + r - 12593, jc, 12593), a >= 0 && (a < HD.length ? Da(a, HD, 0) : 4520 + a - 12593 < jc.length && Da(4520 + a - 12593, jc, 12593)), ao > 0) return wh.subarray(0, ao);
    }
  })(n);
  if (e && e.length > 0) return new Uint32Array(e);
}
let ao = 0;
const wh = new Uint32Array(10);
function Da(n, e, t) {
  n >= t && n < t + e.length && (function(i) {
    i !== 0 && (wh[ao++] = 255 & i, i >> 8 && (wh[ao++] = i >> 8 & 255), i >> 16 && (wh[ao++] = i >> 16 & 255));
  })(e[n - t]);
}
const WD = new Uint8Array([114, 82, 115, 101, 69, 102, 97, 113, 81, 116, 84, 100, 119, 87, 99, 122, 120, 118, 103]), VD = new Uint16Array([107, 111, 105, 79, 106, 112, 117, 80, 104, 27496, 28520, 27752, 121, 110, 27246, 28782, 27758, 98, 109, 27757, 108]), HD = new Uint16Array([114, 82, 29810, 115, 30579, 26483, 101, 102, 29286, 24934, 29030, 29798, 30822, 30310, 26470, 97, 113, 29809, 116, 84, 100, 119, 99, 122, 120, 118, 103]), jc = new Uint16Array([114, 82, 29810, 115, 30579, 26483, 101, 69, 102, 29286, 24934, 29030, 29798, 30822, 30310, 26470, 97, 113, 81, 29809, 116, 84, 100, 119, 87, 99, 122, 120, 118, 103, 107, 111, 105, 79, 106, 112, 117, 80, 104, 27496, 28520, 27752, 121, 110, 27246, 28782, 27758, 98, 109, 27757, 108]);
function fA(...n) {
  return function(e, t) {
    for (let i = 0, s = n.length; i < s; i++) {
      const o = n[i](e, t);
      if (o) return o;
    }
    return null;
  };
}
xW.bind(void 0, !1);
const kv = xW.bind(void 0, !0);
function xW(n, e, t) {
  if (!t || t.length < e.length) return null;
  let i;
  return i = n ? sR(t, e) : t.indexOf(e) === 0, i ? e.length > 0 ? [{ start: 0, end: e.length }] : [] : null;
}
function NW(n, e) {
  const t = e.toLowerCase().indexOf(n.toLowerCase());
  return t === -1 ? null : [{ start: t, end: t + n.length }];
}
function EW(n, e) {
  return NI(n.toLowerCase(), e.toLowerCase(), 0, 0);
}
function NI(n, e, t, i) {
  if (t === n.length) return [];
  if (i === e.length) return null;
  if (n[t] === e[i]) {
    let s = null;
    return (s = NI(n, e, t + 1, i + 1)) ? vA({ start: i, end: i + 1 }, s) : null;
  }
  return NI(n, e, t, i + 1);
}
function EI(n) {
  return 97 <= n && n <= 122;
}
function Ly(n) {
  return 65 <= n && n <= 90;
}
function _A(n) {
  return 48 <= n && n <= 57;
}
function IW(n) {
  return n === 32 || n === 9 || n === 10 || n === 13;
}
const MW = /* @__PURE__ */ new Set();
function ky(n) {
  return IW(n) || MW.has(n);
}
function c3(n, e) {
  return n === e || ky(n) && ky(e);
}
"()[]{}<>`'\"-/;:,.?!".split("").forEach(((n) => MW.add(n.charCodeAt(0))));
const zD = /* @__PURE__ */ new Map();
function u3(n) {
  if (zD.has(n)) return zD.get(n);
  let e;
  const t = kJ(n);
  return t && (e = t), zD.set(n, e), e;
}
function TW(n) {
  return EI(n) || Ly(n) || _A(n);
}
function vA(n, e) {
  return e.length === 0 ? e = [n] : n.end === e[0].start ? e[0].start = n.start : e.unshift(n), e;
}
function RW(n, e) {
  for (let t = e; t < n.length; t++) {
    const i = n.charCodeAt(t);
    if (Ly(i) || _A(i) || t > 0 && !TW(n.charCodeAt(t - 1))) return t;
  }
  return n.length;
}
function II(n, e, t, i) {
  if (t === n.length) return [];
  if (i === e.length || n[t] !== e[i].toLowerCase()) return null;
  {
    let s = null, o = i + 1;
    for (s = II(n, e, t + 1, i + 1); !s && (o = RW(e, o)) < e.length; ) s = II(n, e, t + 1, o), o++;
    return s === null ? null : vA({ start: i, end: i + 1 }, s);
  }
}
function AW(n, e) {
  if (!e || (e = e.trim()).length === 0 || !(function(o) {
    let r = 0, a = 0, l = 0, d = 0;
    for (let h = 0; h < o.length; h++) l = o.charCodeAt(h), Ly(l) && r++, EI(l) && a++, IW(l) && d++;
    return r !== 0 && a !== 0 || d !== 0 ? r <= 5 : o.length <= 30;
  })(n)) return null;
  e.length > 60 && (e = e.substring(0, 60));
  const t = (function(o) {
    let r = 0, a = 0, l = 0, d = 0, h = 0;
    for (let c = 0; c < o.length; c++) h = o.charCodeAt(c), Ly(h) && r++, EI(h) && a++, TW(h) && l++, _A(h) && d++;
    return { upperPercent: r / o.length, lowerPercent: a / o.length, alphaPercent: l / o.length, numericPercent: d / o.length };
  })(e);
  if (!(function(o) {
    const { upperPercent: r, lowerPercent: a, alphaPercent: l, numericPercent: d } = o;
    return a > 0.2 && r < 0.8 && l > 0.6 && d < 0.2;
  })(t)) {
    if (!(function(o) {
      const { upperPercent: r, lowerPercent: a } = o;
      return a === 0 && r > 0.6;
    })(t)) return null;
    e = e.toLowerCase();
  }
  let i = null, s = 0;
  for (n = n.toLowerCase(); s < e.length && (i = II(n, e, 0, s)) === null; ) s = RW(e, s + 1);
  return i;
}
function MI(n, e, t, i, s) {
  let o = 0;
  if (t === n.length) return [];
  if (i === e.length) return null;
  if (!c3(n.charCodeAt(t), e.charCodeAt(i))) {
    const l = u3(n.charCodeAt(t));
    if (!l) return null;
    for (let d = 0; d < l.length; d++) if (!c3(l[d], e.charCodeAt(i + d))) return null;
    o += l.length - 1;
  }
  let r = null, a = i + o + 1;
  if (r = MI(n, e, t + 1, a, s), !s) for (; !r && (a = PW(e, a)) < e.length; ) r = MI(n, e, t + 1, a, s), a++;
  if (!r) return null;
  if (n.charCodeAt(t) !== e.charCodeAt(i)) {
    const l = u3(n.charCodeAt(t));
    if (!l) return r;
    for (let d = 0; d < l.length; d++) if (l[d] !== e.charCodeAt(i + d)) return r;
  }
  return vA({ start: i, end: i + o + 1 }, r);
}
function PW(n, e) {
  for (let t = e; t < n.length; t++) if (ky(n.charCodeAt(t)) || t > 0 && ky(n.charCodeAt(t - 1))) return t;
  return n.length;
}
const DJ = fA(kv, AW, NW), xJ = fA(kv, AW, EW), g3 = new Ll(1e4);
function p3(n, e, t = !1) {
  if (typeof n != "string" || typeof e != "string") return null;
  let i = g3.get(n);
  i || (i = new RegExp(n.replace(/[\-\\\{\}\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&").replace(/[\*]/g, ".*"), "i"), g3.set(n, i));
  const s = i.exec(e);
  return s ? [{ start: s.index, end: s.index + s[0].length }] : t ? xJ(n, e) : DJ(n, e);
}
function NJ(n, e) {
  const t = ug(n, n.toLowerCase(), 0, e, e.toLowerCase(), 0, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
  return t ? I1(t) : null;
}
function EJ(n, e, t, i, s, o) {
  const r = Math.min(13, n.length);
  for (; t < r; t++) {
    const a = ug(n, e, t, i, s, o, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
    if (a) return a;
  }
  return [0, o];
}
function I1(n) {
  if (n === void 0) return [];
  const e = [], t = n[1];
  for (let i = n.length - 1; i > 1; i--) {
    const s = n[i] + t, o = e[e.length - 1];
    o && o.end === s ? o.end = s + 1 : e.push({ start: s, end: s + 1 });
  }
  return e;
}
const Bh = 128;
function bA() {
  const n = [], e = [];
  for (let t = 0; t <= Bh; t++) e[t] = 0;
  for (let t = 0; t <= Bh; t++) n.push(e.slice(0));
  return n;
}
function OW(n) {
  const e = [];
  for (let t = 0; t <= n; t++) e[t] = 0;
  return e;
}
const m3 = OW(2 * Bh), UD = OW(2 * Bh), El = bA(), qc = bA(), Ib = bA();
function Mb(n, e) {
  if (e < 0 || e >= n.length) return !1;
  const t = n.codePointAt(e);
  switch (t) {
    case 95:
    case 45:
    case 46:
    case 32:
    case 47:
    case 92:
    case 39:
    case 34:
    case 58:
    case 36:
    case 60:
    case 62:
    case 40:
    case 41:
    case 91:
    case 93:
    case 123:
    case 125:
      return !0;
    case void 0:
      return !1;
    default:
      return !!aR(t);
  }
}
function f3(n, e) {
  if (e < 0 || e >= n.length) return !1;
  switch (n.charCodeAt(e)) {
    case 32:
    case 9:
      return !0;
    default:
      return !1;
  }
}
function jC(n, e, t) {
  return e[n] !== t[n];
}
var la;
(function(n) {
  n.Default = [-100, 0], n.isDefault = function(e) {
    return !e || e.length === 2 && e[0] === -100 && e[1] === 0;
  };
})(la || (la = {}));
class _L {
  constructor(e, t) {
    this.firstMatchCanBeWeak = e, this.boostFullMatch = t;
  }
}
function ug(n, e, t, i, s, o, r = _L.default) {
  const a = n.length > Bh ? Bh : n.length, l = i.length > Bh ? Bh : i.length;
  if (t >= a || o >= l || a - t > l - o || !(function(b, C, w, y, L, k, N = !1) {
    for (; C < w && L < k; ) b[C] === y[L] && (N && (m3[C] = L), C += 1), L += 1;
    return C === w;
  })(e, t, a, s, o, l, !0)) return;
  (function(b, C, w, y, L, k) {
    let N = b - 1, A = C - 1;
    for (; N >= w && A >= y; ) L[N] === k[A] && (UD[N] = A, N--), A--;
  })(a, l, t, o, e, s);
  let d = 1, h = 1, c = t, u = o;
  const g = [!1];
  for (d = 1, c = t; c < a; d++, c++) {
    const b = m3[c], C = UD[c], w = c + 1 < a ? UD[c + 1] : l;
    for (h = b - o + 1, u = b; u < w; h++, u++) {
      let y = Number.MIN_SAFE_INTEGER, L = !1;
      u <= C && (y = IJ(n, e, c, t, i, s, u, l, o, El[d - 1][h - 1] === 0, g));
      let k = 0;
      y !== Number.MAX_SAFE_INTEGER && (L = !0, k = y + qc[d - 1][h - 1]);
      const N = u > b, A = N ? qc[d][h - 1] + (El[d][h - 1] > 0 ? -5 : 0) : 0, B = u > b + 1 && El[d][h - 1] > 0, T = B ? qc[d][h - 2] + (El[d][h - 2] > 0 ? -5 : 0) : 0;
      if (B && (!N || T >= A) && (!L || T >= k)) qc[d][h] = T, Ib[d][h] = 3, El[d][h] = 0;
      else if (N && (!L || A >= k)) qc[d][h] = A, Ib[d][h] = 2, El[d][h] = 0;
      else {
        if (!L) throw new Error("not possible");
        qc[d][h] = k, Ib[d][h] = 1, El[d][h] = El[d - 1][h - 1] + 1;
      }
    }
  }
  if (!g[0] && !r.firstMatchCanBeWeak) return;
  d--, h--;
  const p = [qc[d][h], o];
  let f = 0, _ = 0;
  for (; d >= 1; ) {
    let b = h;
    do {
      const C = Ib[d][b];
      if (C === 3) b -= 2;
      else {
        if (C !== 2) break;
        b -= 1;
      }
    } while (b >= 1);
    f > 1 && e[t + d - 1] === s[o + h - 1] && !jC(b + o - 1, i, s) && f + 1 > El[d][b] && (b = h), b === h ? f++ : f = 1, _ || (_ = b), d--, h = b - 1, p.push(h);
  }
  l === a && r.boostFullMatch && (p[0] += 2);
  const v = _ - a;
  return p[0] -= v, p;
}
function IJ(n, e, t, i, s, o, r, a, l, d, h) {
  if (e[t] !== o[r]) return Number.MIN_SAFE_INTEGER;
  let c = 1, u = !1;
  return r === t - i ? c = n[t] === s[r] ? 7 : 5 : !jC(r, s, o) || r !== 0 && jC(r - 1, s, o) ? !Mb(o, r) || r !== 0 && Mb(o, r - 1) ? (Mb(o, r - 1) || f3(o, r - 1)) && (c = 5, u = !0) : c = 5 : (c = n[t] === s[r] ? 7 : 5, u = !0), c > 1 && t === i && (h[0] = !0), u || (u = jC(r, s, o) || Mb(o, r - 1) || f3(o, r - 1)), t === i ? r > l && (c -= u ? 3 : 5) : c += d ? u ? 2 : 0 : u ? 0 : 1, r + 1 === a && (c -= u ? 3 : 5), c;
}
function MJ(n, e, t, i, s, o, r) {
  return (function(a, l, d, h, c, u, g, p) {
    let f = ug(a, l, d, h, c, u, p);
    if (a.length >= 3) {
      const _ = Math.min(7, a.length - 1);
      for (let v = d + 1; v < _; v++) {
        const b = TJ(a, v);
        if (b) {
          const C = ug(b, b.toLowerCase(), d, h, c, u, p);
          C && (C[0] -= 3, (!f || C[0] > f[0]) && (f = C));
        }
      }
    }
    return f;
  })(n, e, t, i, s, o, 0, r);
}
function TJ(n, e) {
  if (e + 1 >= n.length) return;
  const t = n[e], i = n[e + 1];
  return t !== i ? n.slice(0, e) + i + t + n.slice(e + 2) : void 0;
}
_L.default = { boostFullMatch: !0, firstMatchCanBeWeak: !1 };
const RJ = "$(", CA = new RegExp(`\\$\\(${Ee.iconNameExpression}(?:${Ee.iconModifierExpression})?\\)`, "g"), AJ = new RegExp(`(\\\\)?${CA.source}`, "g"), PJ = new RegExp(`\\\\${CA.source}`, "g"), OJ = new RegExp(`(\\s)?(\\\\)?${CA.source}(\\s)?`, "g");
function wA(n) {
  return n.indexOf(RJ) === -1 ? n : n.replace(OJ, ((e, t, i, s) => i ? e : t || s || ""));
}
const KD = new RegExp(`\\$\\(${Ee.iconNameCharacter}+\\)`, "g");
function N_(n) {
  KD.lastIndex = 0;
  let e = "";
  const t = [];
  let i = 0;
  for (; ; ) {
    const s = KD.lastIndex, o = KD.exec(n), r = n.substring(s, o?.index);
    if (r.length > 0) {
      e += r;
      for (let a = 0; a < r.length; a++) t.push(i);
    }
    if (!o) break;
    i += o[0].length;
  }
  return { text: e, iconOffsets: t };
}
function jD(n, e, t = !1) {
  const { text: i, iconOffsets: s } = e;
  if (!s || s.length === 0) return p3(n, i, t);
  const o = u1(i, " "), r = i.length - o.length, a = p3(n, o, t);
  if (a) for (const l of a) {
    const d = s[l.start + r] + r;
    l.start += d, l.end += d;
  }
  return a;
}
class Vn {
  constructor(e = "", t = !1) {
    var i, s, o;
    if (this.value = e, typeof this.value != "string") throw Yo("value");
    typeof t == "boolean" ? (this.isTrusted = t, this.supportThemeIcons = !1, this.supportHtml = !1) : (this.isTrusted = (i = t.isTrusted) !== null && i !== void 0 ? i : void 0, this.supportThemeIcons = (s = t.supportThemeIcons) !== null && s !== void 0 && s, this.supportHtml = (o = t.supportHtml) !== null && o !== void 0 && o);
  }
  appendText(e, t = 0) {
    return this.value += (function(i) {
      return i.replace(/[\\`*_{}[\]()#+\-!~]/g, "\\$&");
    })(this.supportThemeIcons ? (function(i) {
      return i.replace(AJ, ((s, o) => o ? s : `\\${s}`));
    })(e) : e).replace(/([ \t]+)/g, ((i, s) => "&nbsp;".repeat(s.length))).replace(/\>/gm, "\\>").replace(/\n/g, t === 1 ? `\\
` : `

`), this;
  }
  appendMarkdown(e) {
    return this.value += e, this;
  }
  appendCodeblock(e, t) {
    return this.value += `
${(function(i, s) {
      var o, r;
      const a = (r = (o = i.match(/^`+/gm)) === null || o === void 0 ? void 0 : o.reduce(((d, h) => d.length > h.length ? d : h)).length) !== null && r !== void 0 ? r : 0, l = a >= 3 ? a + 1 : 3;
      return [`${"`".repeat(l)}${s}`, i, `${"`".repeat(l)}`].join(`
`);
    })(t, e)}
`, this;
  }
  appendLink(e, t, i) {
    return this.value += "[", this.value += this._escape(t, "]"), this.value += "](", this.value += this._escape(String(e), ")"), i && (this.value += ` "${this._escape(this._escape(i, '"'), ")")}"`), this.value += ")", this;
  }
  _escape(e, t) {
    const i = new RegExp(No(t), "g");
    return e.replace(i, ((s, o) => e.charAt(o - 1) !== "\\" ? `\\${s}` : s));
  }
}
function jm(n) {
  return da(n) ? !n.value : !Array.isArray(n) || n.every(jm);
}
function da(n) {
  return n instanceof Vn || !(!n || typeof n != "object") && !(typeof n.value != "string" || typeof n.isTrusted != "boolean" && typeof n.isTrusted != "object" && n.isTrusted !== void 0 || typeof n.supportThemeIcons != "boolean" && n.supportThemeIcons !== void 0);
}
function Tb(n) {
  return n.replace(/"/g, "&quot;");
}
function qD(n) {
  return n && n.replace(/\\([\\`*_{}[\]()#+\-.!~])/g, "$1");
}
class yA {
  constructor(e) {
    this._prefix = e, this._lastId = 0;
  }
  nextId() {
    return this._prefix + ++this._lastId;
  }
}
const TI = new yA("id#");
let rs = {};
(function() {
  function n(i, s) {
    s(rs);
  }
  var e, t;
  n.amd = !0, e = this, t = function(i) {
    function s(le, Y, M) {
      return M && (function(R, P) {
        for (var U = 0; U < P.length; U++) {
          var ce = P[U];
          ce.enumerable = ce.enumerable || !1, ce.configurable = !0, "value" in ce && (ce.writable = !0), Object.defineProperty(R, ce.key, ce);
        }
      })(le, M), Object.defineProperty(le, "prototype", { writable: !1 }), le;
    }
    function o(le, Y) {
      (Y == null || Y > le.length) && (Y = le.length);
      for (var M = 0, R = new Array(Y); M < Y; M++) R[M] = le[M];
      return R;
    }
    function r(le, Y) {
      var M = typeof Symbol < "u" && le[Symbol.iterator] || le["@@iterator"];
      if (M) return (M = M.call(le)).next.bind(M);
      if (Array.isArray(le) || (M = (function(P, U) {
        if (P) {
          if (typeof P == "string") return o(P, U);
          var ce = Object.prototype.toString.call(P).slice(8, -1);
          return ce === "Object" && P.constructor && (ce = P.constructor.name), ce === "Map" || ce === "Set" ? Array.from(P) : ce === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ce) ? o(P, U) : void 0;
        }
      })(le)) || Y) {
        M && (le = M);
        var R = 0;
        return function() {
          return R >= le.length ? { done: !0 } : { done: !1, value: le[R++] };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function a() {
      return { async: !1, baseUrl: null, breaks: !1, extensions: null, gfm: !0, headerIds: !0, headerPrefix: "", highlight: null, langPrefix: "language-", mangle: !0, pedantic: !1, renderer: null, sanitize: !1, sanitizer: null, silent: !1, smartLists: !1, smartypants: !1, tokenizer: null, walkTokens: null, xhtml: !1 };
    }
    i.defaults = { async: !1, baseUrl: null, breaks: !1, extensions: null, gfm: !0, headerIds: !0, headerPrefix: "", highlight: null, langPrefix: "language-", mangle: !0, pedantic: !1, renderer: null, sanitize: !1, sanitizer: null, silent: !1, smartLists: !1, smartypants: !1, tokenizer: null, walkTokens: null, xhtml: !1 };
    var l = /[&<>"']/, d = /[&<>"']/g, h = /[<>"']|&(?!#?\w+;)/, c = /[<>"']|&(?!#?\w+;)/g, u = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, g = function(le) {
      return u[le];
    };
    function p(le, Y) {
      if (Y) {
        if (l.test(le)) return le.replace(d, g);
      } else if (h.test(le)) return le.replace(c, g);
      return le;
    }
    var f = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi;
    function _(le) {
      return le.replace(f, (function(Y, M) {
        return (M = M.toLowerCase()) === "colon" ? ":" : M.charAt(0) === "#" ? M.charAt(1) === "x" ? String.fromCharCode(parseInt(M.substring(2), 16)) : String.fromCharCode(+M.substring(1)) : "";
      }));
    }
    var v = /(^|[^\[])\^/g;
    function b(le, Y) {
      le = typeof le == "string" ? le : le.source, Y = Y || "";
      var M = { replace: function(R, P) {
        return P = (P = P.source || P).replace(v, "$1"), le = le.replace(R, P), M;
      }, getRegex: function() {
        return new RegExp(le, Y);
      } };
      return M;
    }
    var C = /[^\w:]/g, w = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    function y(le, Y, M) {
      if (le) {
        var R;
        try {
          R = decodeURIComponent(_(M)).replace(C, "").toLowerCase();
        } catch {
          return null;
        }
        if (R.indexOf("javascript:") === 0 || R.indexOf("vbscript:") === 0 || R.indexOf("data:") === 0) return null;
      }
      Y && !w.test(M) && (M = (function(P, U) {
        L[" " + P] || (k.test(P) ? L[" " + P] = P + "/" : L[" " + P] = H(P, "/", !0));
        var ce = (P = L[" " + P]).indexOf(":") === -1;
        return U.substring(0, 2) === "//" ? ce ? U : P.replace(N, "$1") + U : U.charAt(0) === "/" ? ce ? U : P.replace(A, "$1") + U : P + U;
      })(Y, M));
      try {
        M = encodeURI(M).replace(/%25/g, "%");
      } catch {
        return null;
      }
      return M;
    }
    var L = {}, k = /^[^:]+:\/*[^/]*$/, N = /^([^:]+:)[\s\S]*$/, A = /^([^:]+:\/*[^/]*)[\s\S]*$/, B = { exec: function() {
    } };
    function T(le) {
      for (var Y, M, R = 1; R < arguments.length; R++) for (M in Y = arguments[R]) Object.prototype.hasOwnProperty.call(Y, M) && (le[M] = Y[M]);
      return le;
    }
    function O(le, Y) {
      var M = le.replace(/\|/g, (function(P, U, ce) {
        for (var Ae = !1, ge = U; --ge >= 0 && ce[ge] === "\\"; ) Ae = !Ae;
        return Ae ? "|" : " |";
      })).split(/ \|/), R = 0;
      if (M[0].trim() || M.shift(), M.length > 0 && !M[M.length - 1].trim() && M.pop(), M.length > Y) M.splice(Y);
      else for (; M.length < Y; ) M.push("");
      for (; R < M.length; R++) M[R] = M[R].trim().replace(/\\\|/g, "|");
      return M;
    }
    function H(le, Y, M) {
      var R = le.length;
      if (R === 0) return "";
      for (var P = 0; P < R; ) {
        var U = le.charAt(R - P - 1);
        if (U !== Y || M) {
          if (U === Y || !M) break;
          P++;
        } else P++;
      }
      return le.slice(0, R - P);
    }
    function $(le) {
      le && le.sanitize && !le.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
    }
    function pe(le, Y) {
      if (Y < 1) return "";
      for (var M = ""; Y > 1; ) 1 & Y && (M += le), Y >>= 1, le += le;
      return M + le;
    }
    function me(le, Y, M, R) {
      var P = Y.href, U = Y.title ? p(Y.title) : null, ce = le[1].replace(/\\([\[\]])/g, "$1");
      if (le[0].charAt(0) !== "!") {
        R.state.inLink = !0;
        var Ae = { type: "link", raw: M, href: P, title: U, text: ce, tokens: R.inlineTokens(ce) };
        return R.state.inLink = !1, Ae;
      }
      return { type: "image", raw: M, href: P, title: U, text: p(ce) };
    }
    var ue = (function() {
      function le(M) {
        this.options = M || i.defaults;
      }
      var Y = le.prototype;
      return Y.space = function(M) {
        var R = this.rules.block.newline.exec(M);
        if (R && R[0].length > 0) return { type: "space", raw: R[0] };
      }, Y.code = function(M) {
        var R = this.rules.block.code.exec(M);
        if (R) {
          var P = R[0].replace(/^ {1,4}/gm, "");
          return { type: "code", raw: R[0], codeBlockStyle: "indented", text: this.options.pedantic ? P : H(P, `
`) };
        }
      }, Y.fences = function(M) {
        var R = this.rules.block.fences.exec(M);
        if (R) {
          var P = R[0], U = (function(ce, Ae) {
            var ge = ce.match(/^(\s+)(?:```)/);
            if (ge === null) return Ae;
            var Ne = ge[1];
            return Ae.split(`
`).map((function(Xe) {
              var Oe = Xe.match(/^\s+/);
              return Oe === null ? Xe : Oe[0].length >= Ne.length ? Xe.slice(Ne.length) : Xe;
            })).join(`
`);
          })(P, R[3] || "");
          return { type: "code", raw: P, lang: R[2] ? R[2].trim() : R[2], text: U };
        }
      }, Y.heading = function(M) {
        var R = this.rules.block.heading.exec(M);
        if (R) {
          var P = R[2].trim();
          if (/#$/.test(P)) {
            var U = H(P, "#");
            this.options.pedantic ? P = U.trim() : U && !/ $/.test(U) || (P = U.trim());
          }
          return { type: "heading", raw: R[0], depth: R[1].length, text: P, tokens: this.lexer.inline(P) };
        }
      }, Y.hr = function(M) {
        var R = this.rules.block.hr.exec(M);
        if (R) return { type: "hr", raw: R[0] };
      }, Y.blockquote = function(M) {
        var R = this.rules.block.blockquote.exec(M);
        if (R) {
          var P = R[0].replace(/^ *>[ \t]?/gm, "");
          return { type: "blockquote", raw: R[0], tokens: this.lexer.blockTokens(P, []), text: P };
        }
      }, Y.list = function(M) {
        var R = this.rules.block.list.exec(M);
        if (R) {
          var P, U, ce, Ae, ge, Ne, Xe, Oe, _t, Ke, Lt, Mt, si = R[1].trim(), Vs = si.length > 1, At = { type: "list", raw: "", ordered: Vs, start: Vs ? +si.slice(0, -1) : "", loose: !1, items: [] };
          si = Vs ? "\\d{1,9}\\" + si.slice(-1) : "\\" + si, this.options.pedantic && (si = Vs ? si : "[*+-]");
          for (var Wc = new RegExp("^( {0,3}" + si + ")((?:[	 ][^\\n]*)?(?:\\n|$))"); M && (Mt = !1, R = Wc.exec(M)) && !this.rules.block.hr.test(M); ) {
            if (P = R[0], M = M.substring(P.length), Oe = R[2].split(`
`, 1)[0], _t = M.split(`
`, 1)[0], this.options.pedantic ? (Ae = 2, Lt = Oe.trimLeft()) : (Ae = (Ae = R[2].search(/[^ ]/)) > 4 ? 1 : Ae, Lt = Oe.slice(Ae), Ae += R[1].length), Ne = !1, !Oe && /^ *$/.test(_t) && (P += _t + `
`, M = M.substring(_t.length + 1), Mt = !0), !Mt) for (var Mr = new RegExp("^ {0," + Math.min(3, Ae - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?: [^\\n]*)?(?:\\n|$))"), Dl = new RegExp("^ {0," + Math.min(3, Ae - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)"), Qi = new RegExp("^ {0," + Math.min(3, Ae - 1) + "}(?:```|~~~)"), Sn = new RegExp("^ {0," + Math.min(3, Ae - 1) + "}#"); M && (Oe = Ke = M.split(`
`, 1)[0], this.options.pedantic && (Oe = Oe.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !Qi.test(Oe)) && !Sn.test(Oe) && !Mr.test(Oe) && !Dl.test(M); ) {
              if (Oe.search(/[^ ]/) >= Ae || !Oe.trim()) Lt += `
` + Oe.slice(Ae);
              else {
                if (Ne) break;
                Lt += `
` + Oe;
              }
              Ne || Oe.trim() || (Ne = !0), P += Ke + `
`, M = M.substring(Ke.length + 1);
            }
            At.loose || (Xe ? At.loose = !0 : /\n *\n *$/.test(P) && (Xe = !0)), this.options.gfm && (U = /^\[[ xX]\] /.exec(Lt)) && (ce = U[0] !== "[ ] ", Lt = Lt.replace(/^\[[ xX]\] +/, "")), At.items.push({ type: "list_item", raw: P, task: !!U, checked: ce, loose: !1, text: Lt }), At.raw += P;
          }
          At.items[At.items.length - 1].raw = P.trimRight(), At.items[At.items.length - 1].text = Lt.trimRight(), At.raw = At.raw.trimRight();
          var Ag = At.items.length;
          for (ge = 0; ge < Ag; ge++) {
            this.lexer.state.top = !1, At.items[ge].tokens = this.lexer.blockTokens(At.items[ge].text, []);
            var qd = At.items[ge].tokens.filter((function(Pg) {
              return Pg.type === "space";
            })), kf = qd.every((function(Pg) {
              for (var Df, U1 = 0, Og = r(Pg.raw.split("")); !(Df = Og()).done; ) if (Df.value === `
` && (U1 += 1), U1 > 1) return !0;
              return !1;
            }));
            !At.loose && qd.length && kf && (At.loose = !0, At.items[ge].loose = !0);
          }
          return At;
        }
      }, Y.html = function(M) {
        var R = this.rules.block.html.exec(M);
        if (R) {
          var P = { type: "html", raw: R[0], pre: !this.options.sanitizer && (R[1] === "pre" || R[1] === "script" || R[1] === "style"), text: R[0] };
          if (this.options.sanitize) {
            var U = this.options.sanitizer ? this.options.sanitizer(R[0]) : p(R[0]);
            P.type = "paragraph", P.text = U, P.tokens = this.lexer.inline(U);
          }
          return P;
        }
      }, Y.def = function(M) {
        var R = this.rules.block.def.exec(M);
        if (R) return R[3] && (R[3] = R[3].substring(1, R[3].length - 1)), { type: "def", tag: R[1].toLowerCase().replace(/\s+/g, " "), raw: R[0], href: R[2], title: R[3] };
      }, Y.table = function(M) {
        var R = this.rules.block.table.exec(M);
        if (R) {
          var P = { type: "table", header: O(R[1]).map((function(Xe) {
            return { text: Xe };
          })), align: R[2].replace(/^ *|\| *$/g, "").split(/ *\| */), rows: R[3] && R[3].trim() ? R[3].replace(/\n[ \t]*$/, "").split(`
`) : [] };
          if (P.header.length === P.align.length) {
            P.raw = R[0];
            var U, ce, Ae, ge, Ne = P.align.length;
            for (U = 0; U < Ne; U++) /^ *-+: *$/.test(P.align[U]) ? P.align[U] = "right" : /^ *:-+: *$/.test(P.align[U]) ? P.align[U] = "center" : /^ *:-+ *$/.test(P.align[U]) ? P.align[U] = "left" : P.align[U] = null;
            for (Ne = P.rows.length, U = 0; U < Ne; U++) P.rows[U] = O(P.rows[U], P.header.length).map((function(Xe) {
              return { text: Xe };
            }));
            for (Ne = P.header.length, ce = 0; ce < Ne; ce++) P.header[ce].tokens = this.lexer.inline(P.header[ce].text);
            for (Ne = P.rows.length, ce = 0; ce < Ne; ce++) for (ge = P.rows[ce], Ae = 0; Ae < ge.length; Ae++) ge[Ae].tokens = this.lexer.inline(ge[Ae].text);
            return P;
          }
        }
      }, Y.lheading = function(M) {
        var R = this.rules.block.lheading.exec(M);
        if (R) return { type: "heading", raw: R[0], depth: R[2].charAt(0) === "=" ? 1 : 2, text: R[1], tokens: this.lexer.inline(R[1]) };
      }, Y.paragraph = function(M) {
        var R = this.rules.block.paragraph.exec(M);
        if (R) {
          var P = R[1].charAt(R[1].length - 1) === `
` ? R[1].slice(0, -1) : R[1];
          return { type: "paragraph", raw: R[0], text: P, tokens: this.lexer.inline(P) };
        }
      }, Y.text = function(M) {
        var R = this.rules.block.text.exec(M);
        if (R) return { type: "text", raw: R[0], text: R[0], tokens: this.lexer.inline(R[0]) };
      }, Y.escape = function(M) {
        var R = this.rules.inline.escape.exec(M);
        if (R) return { type: "escape", raw: R[0], text: p(R[1]) };
      }, Y.tag = function(M) {
        var R = this.rules.inline.tag.exec(M);
        if (R) return !this.lexer.state.inLink && /^<a /i.test(R[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(R[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(R[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(R[0]) && (this.lexer.state.inRawBlock = !1), { type: this.options.sanitize ? "text" : "html", raw: R[0], inLink: this.lexer.state.inLink, inRawBlock: this.lexer.state.inRawBlock, text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(R[0]) : p(R[0]) : R[0] };
      }, Y.link = function(M) {
        var R = this.rules.inline.link.exec(M);
        if (R) {
          var P = R[2].trim();
          if (!this.options.pedantic && /^</.test(P)) {
            if (!/>$/.test(P)) return;
            var U = H(P.slice(0, -1), "\\");
            if ((P.length - U.length) % 2 == 0) return;
          } else {
            var ce = (function(Oe, _t) {
              if (Oe.indexOf(_t[1]) === -1) return -1;
              for (var Ke = Oe.length, Lt = 0, Mt = 0; Mt < Ke; Mt++) if (Oe[Mt] === "\\") Mt++;
              else if (Oe[Mt] === _t[0]) Lt++;
              else if (Oe[Mt] === _t[1] && --Lt < 0) return Mt;
              return -1;
            })(R[2], "()");
            if (ce > -1) {
              var Ae = (R[0].indexOf("!") === 0 ? 5 : 4) + R[1].length + ce;
              R[2] = R[2].substring(0, ce), R[0] = R[0].substring(0, Ae).trim(), R[3] = "";
            }
          }
          var ge = R[2], Ne = "";
          if (this.options.pedantic) {
            var Xe = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(ge);
            Xe && (ge = Xe[1], Ne = Xe[3]);
          } else Ne = R[3] ? R[3].slice(1, -1) : "";
          return ge = ge.trim(), /^</.test(ge) && (ge = this.options.pedantic && !/>$/.test(P) ? ge.slice(1) : ge.slice(1, -1)), me(R, { href: ge && ge.replace(this.rules.inline._escapes, "$1"), title: Ne && Ne.replace(this.rules.inline._escapes, "$1") }, R[0], this.lexer);
        }
      }, Y.reflink = function(M, R) {
        var P;
        if ((P = this.rules.inline.reflink.exec(M)) || (P = this.rules.inline.nolink.exec(M))) {
          var U = (P[2] || P[1]).replace(/\s+/g, " ");
          if (!(U = R[U.toLowerCase()]) || !U.href) {
            var ce = P[0].charAt(0);
            return { type: "text", raw: ce, text: ce };
          }
          return me(P, U, P[0], this.lexer);
        }
      }, Y.emStrong = function(M, R, P) {
        P === void 0 && (P = "");
        var U = this.rules.inline.emStrong.lDelim.exec(M);
        if (U && (!U[3] || !P.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/))) {
          var ce = U[1] || U[2] || "";
          if (!ce || ce && (P === "" || this.rules.inline.punctuation.exec(P))) {
            var Ae, ge, Ne = U[0].length - 1, Xe = Ne, Oe = 0, _t = U[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
            for (_t.lastIndex = 0, R = R.slice(-1 * M.length + Ne); (U = _t.exec(R)) != null; ) if (Ae = U[1] || U[2] || U[3] || U[4] || U[5] || U[6]) if (ge = Ae.length, U[3] || U[4]) Xe += ge;
            else if (!((U[5] || U[6]) && Ne % 3) || (Ne + ge) % 3) {
              if (!((Xe -= ge) > 0)) {
                if (ge = Math.min(ge, ge + Xe + Oe), Math.min(Ne, ge) % 2) {
                  var Ke = M.slice(1, Ne + U.index + ge);
                  return { type: "em", raw: M.slice(0, Ne + U.index + ge + 1), text: Ke, tokens: this.lexer.inlineTokens(Ke) };
                }
                var Lt = M.slice(2, Ne + U.index + ge - 1);
                return { type: "strong", raw: M.slice(0, Ne + U.index + ge + 1), text: Lt, tokens: this.lexer.inlineTokens(Lt) };
              }
            } else Oe += ge;
          }
        }
      }, Y.codespan = function(M) {
        var R = this.rules.inline.code.exec(M);
        if (R) {
          var P = R[2].replace(/\n/g, " "), U = /[^ ]/.test(P), ce = /^ /.test(P) && / $/.test(P);
          return U && ce && (P = P.substring(1, P.length - 1)), P = p(P, !0), { type: "codespan", raw: R[0], text: P };
        }
      }, Y.br = function(M) {
        var R = this.rules.inline.br.exec(M);
        if (R) return { type: "br", raw: R[0] };
      }, Y.del = function(M) {
        var R = this.rules.inline.del.exec(M);
        if (R) return { type: "del", raw: R[0], text: R[2], tokens: this.lexer.inlineTokens(R[2]) };
      }, Y.autolink = function(M, R) {
        var P, U, ce = this.rules.inline.autolink.exec(M);
        if (ce) return U = ce[2] === "@" ? "mailto:" + (P = p(this.options.mangle ? R(ce[1]) : ce[1])) : P = p(ce[1]), { type: "link", raw: ce[0], text: P, href: U, tokens: [{ type: "text", raw: P, text: P }] };
      }, Y.url = function(M, R) {
        var P;
        if (P = this.rules.inline.url.exec(M)) {
          var U, ce;
          if (P[2] === "@") ce = "mailto:" + (U = p(this.options.mangle ? R(P[0]) : P[0]));
          else {
            var Ae;
            do
              Ae = P[0], P[0] = this.rules.inline._backpedal.exec(P[0])[0];
            while (Ae !== P[0]);
            U = p(P[0]), ce = P[1] === "www." ? "http://" + U : U;
          }
          return { type: "link", raw: P[0], text: U, href: ce, tokens: [{ type: "text", raw: U, text: U }] };
        }
      }, Y.inlineText = function(M, R) {
        var P, U = this.rules.inline.text.exec(M);
        if (U) return P = this.lexer.state.inRawBlock ? this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(U[0]) : p(U[0]) : U[0] : p(this.options.smartypants ? R(U[0]) : U[0]), { type: "text", raw: U[0], text: P };
      }, le;
    })(), ee = { newline: /^(?: *(?:\n|$))+/, code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/, fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/, hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/, list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/, html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/, table: B, lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/, _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, text: /^[^\n]+/, _label: /(?!\s*\])(?:\\.|[^\[\]\\])+/, _title: /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/ };
    ee.def = b(ee.def).replace("label", ee._label).replace("title", ee._title).getRegex(), ee.bullet = /(?:[*+-]|\d{1,9}[.)])/, ee.listItemStart = b(/^( *)(bull) */).replace("bull", ee.bullet).getRegex(), ee.list = b(ee.list).replace(/bull/g, ee.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + ee.def.source + ")").getRegex(), ee._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", ee._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/, ee.html = b(ee.html, "i").replace("comment", ee._comment).replace("tag", ee._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), ee.paragraph = b(ee._paragraph).replace("hr", ee.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", ee._tag).getRegex(), ee.blockquote = b(ee.blockquote).replace("paragraph", ee.paragraph).getRegex(), ee.normal = T({}, ee), ee.gfm = T({}, ee.normal, { table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" }), ee.gfm.table = b(ee.gfm.table).replace("hr", ee.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", ee._tag).getRegex(), ee.gfm.paragraph = b(ee._paragraph).replace("hr", ee.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", ee.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", ee._tag).getRegex(), ee.pedantic = T({}, ee.normal, { html: b(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", ee._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(), def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/, heading: /^(#{1,6})(.*)(?:\n+|$)/, fences: B, paragraph: b(ee.normal._paragraph).replace("hr", ee.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", ee.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex() });
    var te = { escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/, url: B, tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/, reflink: /^!?\[(label)\]\[(ref)\]/, nolink: /^!?\[(ref)\](?:\[\])?/, reflinkSearch: "reflink|nolink(?!\\()", emStrong: { lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/, rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[^*]+(?=[^*])|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/, rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ }, code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, br: /^( {2,}|\\)\n(?!\s*$)/, del: B, text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, punctuation: /^([\spunctuation])/ };
    function be(le) {
      return le.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
    }
    function we(le) {
      var Y, M, R = "", P = le.length;
      for (Y = 0; Y < P; Y++) M = le.charCodeAt(Y), Math.random() > 0.5 && (M = "x" + M.toString(16)), R += "&#" + M + ";";
      return R;
    }
    te._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~", te.punctuation = b(te.punctuation).replace(/punctuation/g, te._punctuation).getRegex(), te.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g, te.escapedEmSt = /\\\*|\\_/g, te._comment = b(ee._comment).replace("(?:-->|$)", "-->").getRegex(), te.emStrong.lDelim = b(te.emStrong.lDelim).replace(/punct/g, te._punctuation).getRegex(), te.emStrong.rDelimAst = b(te.emStrong.rDelimAst, "g").replace(/punct/g, te._punctuation).getRegex(), te.emStrong.rDelimUnd = b(te.emStrong.rDelimUnd, "g").replace(/punct/g, te._punctuation).getRegex(), te._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g, te._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/, te._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/, te.autolink = b(te.autolink).replace("scheme", te._scheme).replace("email", te._email).getRegex(), te._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/, te.tag = b(te.tag).replace("comment", te._comment).replace("attribute", te._attribute).getRegex(), te._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, te._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/, te._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/, te.link = b(te.link).replace("label", te._label).replace("href", te._href).replace("title", te._title).getRegex(), te.reflink = b(te.reflink).replace("label", te._label).replace("ref", ee._label).getRegex(), te.nolink = b(te.nolink).replace("ref", ee._label).getRegex(), te.reflinkSearch = b(te.reflinkSearch, "g").replace("reflink", te.reflink).replace("nolink", te.nolink).getRegex(), te.normal = T({}, te), te.pedantic = T({}, te.normal, { strong: { start: /^__|\*\*/, middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/, endAst: /\*\*(?!\*)/g, endUnd: /__(?!_)/g }, em: { start: /^_|\*/, middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/, endAst: /\*(?!\*)/g, endUnd: /_(?!_)/g }, link: b(/^!?\[(label)\]\((.*?)\)/).replace("label", te._label).getRegex(), reflink: b(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", te._label).getRegex() }), te.gfm = T({}, te.normal, { escape: b(te.escape).replace("])", "~|])").getRegex(), _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/, url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/, del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/, text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/ }), te.gfm.url = b(te.gfm.url, "i").replace("email", te.gfm._extended_email).getRegex(), te.breaks = T({}, te.gfm, { br: b(te.br).replace("{2,}", "*").getRegex(), text: b(te.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex() });
    var Re = (function() {
      function le(M) {
        this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = M || i.defaults, this.options.tokenizer = this.options.tokenizer || new ue(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = { inLink: !1, inRawBlock: !1, top: !0 };
        var R = { block: ee.normal, inline: te.normal };
        this.options.pedantic ? (R.block = ee.pedantic, R.inline = te.pedantic) : this.options.gfm && (R.block = ee.gfm, this.options.breaks ? R.inline = te.breaks : R.inline = te.gfm), this.tokenizer.rules = R;
      }
      le.lex = function(M, R) {
        return new le(R).lex(M);
      }, le.lexInline = function(M, R) {
        return new le(R).inlineTokens(M);
      };
      var Y = le.prototype;
      return Y.lex = function(M) {
        var R;
        for (M = M.replace(/\r\n|\r/g, `
`), this.blockTokens(M, this.tokens); R = this.inlineQueue.shift(); ) this.inlineTokens(R.src, R.tokens);
        return this.tokens;
      }, Y.blockTokens = function(M, R) {
        var P, U, ce, Ae, ge = this;
        for (R === void 0 && (R = []), M = this.options.pedantic ? M.replace(/\t/g, "    ").replace(/^ +$/gm, "") : M.replace(/^( *)(\t+)/gm, (function(Xe, Oe, _t) {
          return Oe + "    ".repeat(_t.length);
        })); M; ) if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((function(Xe) {
          return !!(P = Xe.call({ lexer: ge }, M, R)) && (M = M.substring(P.raw.length), R.push(P), !0);
        })))) {
          if (P = this.tokenizer.space(M)) M = M.substring(P.raw.length), P.raw.length === 1 && R.length > 0 ? R[R.length - 1].raw += `
` : R.push(P);
          else if (P = this.tokenizer.code(M)) M = M.substring(P.raw.length), !(U = R[R.length - 1]) || U.type !== "paragraph" && U.type !== "text" ? R.push(P) : (U.raw += `
` + P.raw, U.text += `
` + P.text, this.inlineQueue[this.inlineQueue.length - 1].src = U.text);
          else if (P = this.tokenizer.fences(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.heading(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.hr(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.blockquote(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.list(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.html(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.def(M)) M = M.substring(P.raw.length), !(U = R[R.length - 1]) || U.type !== "paragraph" && U.type !== "text" ? this.tokens.links[P.tag] || (this.tokens.links[P.tag] = { href: P.href, title: P.title }) : (U.raw += `
` + P.raw, U.text += `
` + P.raw, this.inlineQueue[this.inlineQueue.length - 1].src = U.text);
          else if (P = this.tokenizer.table(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.lheading(M)) M = M.substring(P.raw.length), R.push(P);
          else if (ce = M, this.options.extensions && this.options.extensions.startBlock && (function() {
            var Xe = 1 / 0, Oe = M.slice(1), _t = void 0;
            ge.options.extensions.startBlock.forEach((function(Ke) {
              typeof (_t = Ke.call({ lexer: this }, Oe)) == "number" && _t >= 0 && (Xe = Math.min(Xe, _t));
            })), Xe < 1 / 0 && Xe >= 0 && (ce = M.substring(0, Xe + 1));
          })(), this.state.top && (P = this.tokenizer.paragraph(ce))) U = R[R.length - 1], Ae && U.type === "paragraph" ? (U.raw += `
` + P.raw, U.text += `
` + P.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = U.text) : R.push(P), Ae = ce.length !== M.length, M = M.substring(P.raw.length);
          else if (P = this.tokenizer.text(M)) M = M.substring(P.raw.length), (U = R[R.length - 1]) && U.type === "text" ? (U.raw += `
` + P.raw, U.text += `
` + P.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = U.text) : R.push(P);
          else if (M) {
            var Ne = "Infinite loop on byte: " + M.charCodeAt(0);
            if (this.options.silent) {
              console.error(Ne);
              break;
            }
            throw new Error(Ne);
          }
        }
        return this.state.top = !0, R;
      }, Y.inline = function(M, R) {
        return R === void 0 && (R = []), this.inlineQueue.push({ src: M, tokens: R }), R;
      }, Y.inlineTokens = function(M, R) {
        var P, U, ce, Ae = this;
        R === void 0 && (R = []);
        var ge, Ne, Xe, Oe = M;
        if (this.tokens.links) {
          var _t = Object.keys(this.tokens.links);
          if (_t.length > 0) for (; (ge = this.tokenizer.rules.inline.reflinkSearch.exec(Oe)) != null; ) _t.includes(ge[0].slice(ge[0].lastIndexOf("[") + 1, -1)) && (Oe = Oe.slice(0, ge.index) + "[" + pe("a", ge[0].length - 2) + "]" + Oe.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
        }
        for (; (ge = this.tokenizer.rules.inline.blockSkip.exec(Oe)) != null; ) Oe = Oe.slice(0, ge.index) + "[" + pe("a", ge[0].length - 2) + "]" + Oe.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        for (; (ge = this.tokenizer.rules.inline.escapedEmSt.exec(Oe)) != null; ) Oe = Oe.slice(0, ge.index) + "++" + Oe.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
        for (; M; ) if (Ne || (Xe = ""), Ne = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((function(Lt) {
          return !!(P = Lt.call({ lexer: Ae }, M, R)) && (M = M.substring(P.raw.length), R.push(P), !0);
        })))) if (P = this.tokenizer.escape(M)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.tag(M)) M = M.substring(P.raw.length), (U = R[R.length - 1]) && P.type === "text" && U.type === "text" ? (U.raw += P.raw, U.text += P.text) : R.push(P);
        else if (P = this.tokenizer.link(M)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.reflink(M, this.tokens.links)) M = M.substring(P.raw.length), (U = R[R.length - 1]) && P.type === "text" && U.type === "text" ? (U.raw += P.raw, U.text += P.text) : R.push(P);
        else if (P = this.tokenizer.emStrong(M, Oe, Xe)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.codespan(M)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.br(M)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.del(M)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.autolink(M, we)) M = M.substring(P.raw.length), R.push(P);
        else if (this.state.inLink || !(P = this.tokenizer.url(M, we))) {
          if (ce = M, this.options.extensions && this.options.extensions.startInline && (function() {
            var Lt = 1 / 0, Mt = M.slice(1), si = void 0;
            Ae.options.extensions.startInline.forEach((function(Vs) {
              typeof (si = Vs.call({ lexer: this }, Mt)) == "number" && si >= 0 && (Lt = Math.min(Lt, si));
            })), Lt < 1 / 0 && Lt >= 0 && (ce = M.substring(0, Lt + 1));
          })(), P = this.tokenizer.inlineText(ce, be)) M = M.substring(P.raw.length), P.raw.slice(-1) !== "_" && (Xe = P.raw.slice(-1)), Ne = !0, (U = R[R.length - 1]) && U.type === "text" ? (U.raw += P.raw, U.text += P.text) : R.push(P);
          else if (M) {
            var Ke = "Infinite loop on byte: " + M.charCodeAt(0);
            if (this.options.silent) {
              console.error(Ke);
              break;
            }
            throw new Error(Ke);
          }
        } else M = M.substring(P.raw.length), R.push(P);
        return R;
      }, s(le, 0, [{ key: "rules", get: function() {
        return { block: ee, inline: te };
      } }]), le;
    })(), it = (function() {
      function le(M) {
        this.options = M || i.defaults;
      }
      var Y = le.prototype;
      return Y.code = function(M, R, P) {
        var U = (R || "").match(/\S*/)[0];
        if (this.options.highlight) {
          var ce = this.options.highlight(M, U);
          ce != null && ce !== M && (P = !0, M = ce);
        }
        return M = M.replace(/\n$/, "") + `
`, U ? '<pre><code class="' + this.options.langPrefix + p(U, !0) + '">' + (P ? M : p(M, !0)) + `</code></pre>
` : "<pre><code>" + (P ? M : p(M, !0)) + `</code></pre>
`;
      }, Y.blockquote = function(M) {
        return `<blockquote>
` + M + `</blockquote>
`;
      }, Y.html = function(M) {
        return M;
      }, Y.heading = function(M, R, P, U) {
        return this.options.headerIds ? "<h" + R + ' id="' + (this.options.headerPrefix + U.slug(P)) + '">' + M + "</h" + R + `>
` : "<h" + R + ">" + M + "</h" + R + `>
`;
      }, Y.hr = function() {
        return this.options.xhtml ? `<hr/>
` : `<hr>
`;
      }, Y.list = function(M, R, P) {
        var U = R ? "ol" : "ul";
        return "<" + U + (R && P !== 1 ? ' start="' + P + '"' : "") + `>
` + M + "</" + U + `>
`;
      }, Y.listitem = function(M) {
        return "<li>" + M + `</li>
`;
      }, Y.checkbox = function(M) {
        return "<input " + (M ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
      }, Y.paragraph = function(M) {
        return "<p>" + M + `</p>
`;
      }, Y.table = function(M, R) {
        return R && (R = "<tbody>" + R + "</tbody>"), `<table>
<thead>
` + M + `</thead>
` + R + `</table>
`;
      }, Y.tablerow = function(M) {
        return `<tr>
` + M + `</tr>
`;
      }, Y.tablecell = function(M, R) {
        var P = R.header ? "th" : "td";
        return (R.align ? "<" + P + ' align="' + R.align + '">' : "<" + P + ">") + M + "</" + P + `>
`;
      }, Y.strong = function(M) {
        return "<strong>" + M + "</strong>";
      }, Y.em = function(M) {
        return "<em>" + M + "</em>";
      }, Y.codespan = function(M) {
        return "<code>" + M + "</code>";
      }, Y.br = function() {
        return this.options.xhtml ? "<br/>" : "<br>";
      }, Y.del = function(M) {
        return "<del>" + M + "</del>";
      }, Y.link = function(M, R, P) {
        if ((M = y(this.options.sanitize, this.options.baseUrl, M)) === null) return P;
        var U = '<a href="' + p(M) + '"';
        return R && (U += ' title="' + R + '"'), U += ">" + P + "</a>";
      }, Y.image = function(M, R, P) {
        if ((M = y(this.options.sanitize, this.options.baseUrl, M)) === null) return P;
        var U = '<img src="' + M + '" alt="' + P + '"';
        return R && (U += ' title="' + R + '"'), U += this.options.xhtml ? "/>" : ">";
      }, Y.text = function(M) {
        return M;
      }, le;
    })(), ut = (function() {
      function le() {
      }
      var Y = le.prototype;
      return Y.strong = function(M) {
        return M;
      }, Y.em = function(M) {
        return M;
      }, Y.codespan = function(M) {
        return M;
      }, Y.del = function(M) {
        return M;
      }, Y.html = function(M) {
        return M;
      }, Y.text = function(M) {
        return M;
      }, Y.link = function(M, R, P) {
        return "" + P;
      }, Y.image = function(M, R, P) {
        return "" + P;
      }, Y.br = function() {
        return "";
      }, le;
    })(), Xi = (function() {
      function le() {
        this.seen = {};
      }
      var Y = le.prototype;
      return Y.serialize = function(M) {
        return M.toLowerCase().trim().replace(/<[!\/a-z].*?>/gi, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
      }, Y.getNextSafeSlug = function(M, R) {
        var P = M, U = 0;
        if (this.seen.hasOwnProperty(P)) {
          U = this.seen[M];
          do
            P = M + "-" + ++U;
          while (this.seen.hasOwnProperty(P));
        }
        return R || (this.seen[M] = U, this.seen[P] = 0), P;
      }, Y.slug = function(M, R) {
        R === void 0 && (R = {});
        var P = this.serialize(M);
        return this.getNextSafeSlug(P, R.dryrun);
      }, le;
    })(), nt = (function() {
      function le(M) {
        this.options = M || i.defaults, this.options.renderer = this.options.renderer || new it(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new ut(), this.slugger = new Xi();
      }
      le.parse = function(M, R) {
        return new le(R).parse(M);
      }, le.parseInline = function(M, R) {
        return new le(R).parseInline(M);
      };
      var Y = le.prototype;
      return Y.parse = function(M, R) {
        R === void 0 && (R = !0);
        var P, U, ce, Ae, ge, Ne, Xe, Oe, _t, Ke, Lt, Mt, si, Vs, At, Wc, Mr, Dl, Qi, Sn = "", Ag = M.length;
        for (P = 0; P < Ag; P++) if (Ke = M[P], !(this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[Ke.type]) || (Qi = this.options.extensions.renderers[Ke.type].call({ parser: this }, Ke)) === !1 && ["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(Ke.type)) switch (Ke.type) {
          case "space":
            continue;
          case "hr":
            Sn += this.renderer.hr();
            continue;
          case "heading":
            Sn += this.renderer.heading(this.parseInline(Ke.tokens), Ke.depth, _(this.parseInline(Ke.tokens, this.textRenderer)), this.slugger);
            continue;
          case "code":
            Sn += this.renderer.code(Ke.text, Ke.lang, Ke.escaped);
            continue;
          case "table":
            for (Oe = "", Xe = "", Ae = Ke.header.length, U = 0; U < Ae; U++) Xe += this.renderer.tablecell(this.parseInline(Ke.header[U].tokens), { header: !0, align: Ke.align[U] });
            for (Oe += this.renderer.tablerow(Xe), _t = "", Ae = Ke.rows.length, U = 0; U < Ae; U++) {
              for (Xe = "", ge = (Ne = Ke.rows[U]).length, ce = 0; ce < ge; ce++) Xe += this.renderer.tablecell(this.parseInline(Ne[ce].tokens), { header: !1, align: Ke.align[ce] });
              _t += this.renderer.tablerow(Xe);
            }
            Sn += this.renderer.table(Oe, _t);
            continue;
          case "blockquote":
            _t = this.parse(Ke.tokens), Sn += this.renderer.blockquote(_t);
            continue;
          case "list":
            for (Lt = Ke.ordered, Mt = Ke.start, si = Ke.loose, Ae = Ke.items.length, _t = "", U = 0; U < Ae; U++) Wc = (At = Ke.items[U]).checked, Mr = At.task, Vs = "", At.task && (Dl = this.renderer.checkbox(Wc), si ? At.tokens.length > 0 && At.tokens[0].type === "paragraph" ? (At.tokens[0].text = Dl + " " + At.tokens[0].text, At.tokens[0].tokens && At.tokens[0].tokens.length > 0 && At.tokens[0].tokens[0].type === "text" && (At.tokens[0].tokens[0].text = Dl + " " + At.tokens[0].tokens[0].text)) : At.tokens.unshift({ type: "text", text: Dl }) : Vs += Dl), Vs += this.parse(At.tokens, si), _t += this.renderer.listitem(Vs, Mr, Wc);
            Sn += this.renderer.list(_t, Lt, Mt);
            continue;
          case "html":
            Sn += this.renderer.html(Ke.text);
            continue;
          case "paragraph":
            Sn += this.renderer.paragraph(this.parseInline(Ke.tokens));
            continue;
          case "text":
            for (_t = Ke.tokens ? this.parseInline(Ke.tokens) : Ke.text; P + 1 < Ag && M[P + 1].type === "text"; ) _t += `
` + ((Ke = M[++P]).tokens ? this.parseInline(Ke.tokens) : Ke.text);
            Sn += R ? this.renderer.paragraph(_t) : _t;
            continue;
          default:
            var qd = 'Token with "' + Ke.type + '" type was not found.';
            if (this.options.silent) return void console.error(qd);
            throw new Error(qd);
        }
        else Sn += Qi || "";
        return Sn;
      }, Y.parseInline = function(M, R) {
        R = R || this.renderer;
        var P, U, ce, Ae = "", ge = M.length;
        for (P = 0; P < ge; P++) if (U = M[P], !(this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[U.type]) || (ce = this.options.extensions.renderers[U.type].call({ parser: this }, U)) === !1 && ["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(U.type)) switch (U.type) {
          case "escape":
          case "text":
            Ae += R.text(U.text);
            break;
          case "html":
            Ae += R.html(U.text);
            break;
          case "link":
            Ae += R.link(U.href, U.title, this.parseInline(U.tokens, R));
            break;
          case "image":
            Ae += R.image(U.href, U.title, U.text);
            break;
          case "strong":
            Ae += R.strong(this.parseInline(U.tokens, R));
            break;
          case "em":
            Ae += R.em(this.parseInline(U.tokens, R));
            break;
          case "codespan":
            Ae += R.codespan(U.text);
            break;
          case "br":
            Ae += R.br();
            break;
          case "del":
            Ae += R.del(this.parseInline(U.tokens, R));
            break;
          default:
            var Ne = 'Token with "' + U.type + '" type was not found.';
            if (this.options.silent) return void console.error(Ne);
            throw new Error(Ne);
        }
        else Ae += ce || "";
        return Ae;
      }, le;
    })();
    function De(le, Y, M) {
      if (le == null) throw new Error("marked(): input parameter is undefined or null");
      if (typeof le != "string") throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(le) + ", string expected");
      if (typeof Y == "function" && (M = Y, Y = null), $(Y = T({}, De.defaults, Y || {})), M) {
        var R, P = Y.highlight;
        try {
          R = Re.lex(le, Y);
        } catch (Ne) {
          return M(Ne);
        }
        var U = function(Ne) {
          var Xe;
          if (!Ne) try {
            Y.walkTokens && De.walkTokens(R, Y.walkTokens), Xe = nt.parse(R, Y);
          } catch (Oe) {
            Ne = Oe;
          }
          return Y.highlight = P, Ne ? M(Ne) : M(null, Xe);
        };
        if (!P || P.length < 3 || (delete Y.highlight, !R.length)) return U();
        var ce = 0;
        return De.walkTokens(R, (function(Ne) {
          Ne.type === "code" && (ce++, setTimeout((function() {
            P(Ne.text, Ne.lang, (function(Xe, Oe) {
              if (Xe) return U(Xe);
              Oe != null && Oe !== Ne.text && (Ne.text = Oe, Ne.escaped = !0), --ce == 0 && U();
            }));
          }), 0));
        })), void (ce === 0 && U());
      }
      function Ae(Ne) {
        if (Ne.message += `
Please report this to https://github.com/markedjs/marked.`, Y.silent) return "<p>An error occurred:</p><pre>" + p(Ne.message + "", !0) + "</pre>";
        throw Ne;
      }
      try {
        var ge = Re.lex(le, Y);
        if (Y.walkTokens) {
          if (Y.async) return Promise.all(De.walkTokens(ge, Y.walkTokens)).then((function() {
            return nt.parse(ge, Y);
          })).catch(Ae);
          De.walkTokens(ge, Y.walkTokens);
        }
        return nt.parse(ge, Y);
      } catch (Ne) {
        Ae(Ne);
      }
    }
    De.options = De.setOptions = function(le) {
      var Y;
      return T(De.defaults, le), Y = De.defaults, i.defaults = Y, De;
    }, De.getDefaults = a, De.defaults = i.defaults, De.use = function() {
      for (var le = arguments.length, Y = new Array(le), M = 0; M < le; M++) Y[M] = arguments[M];
      var R, P = T.apply(void 0, [{}].concat(Y)), U = De.defaults.extensions || { renderers: {}, childTokens: {} };
      Y.forEach((function(ce) {
        if (ce.extensions && (R = !0, ce.extensions.forEach((function(ge) {
          if (!ge.name) throw new Error("extension name required");
          if (ge.renderer) {
            var Ne = U.renderers ? U.renderers[ge.name] : null;
            U.renderers[ge.name] = Ne ? function() {
              for (var Xe = arguments.length, Oe = new Array(Xe), _t = 0; _t < Xe; _t++) Oe[_t] = arguments[_t];
              var Ke = ge.renderer.apply(this, Oe);
              return Ke === !1 && (Ke = Ne.apply(this, Oe)), Ke;
            } : ge.renderer;
          }
          if (ge.tokenizer) {
            if (!ge.level || ge.level !== "block" && ge.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
            U[ge.level] ? U[ge.level].unshift(ge.tokenizer) : U[ge.level] = [ge.tokenizer], ge.start && (ge.level === "block" ? U.startBlock ? U.startBlock.push(ge.start) : U.startBlock = [ge.start] : ge.level === "inline" && (U.startInline ? U.startInline.push(ge.start) : U.startInline = [ge.start]));
          }
          ge.childTokens && (U.childTokens[ge.name] = ge.childTokens);
        }))), ce.renderer && (function() {
          var ge = De.defaults.renderer || new it(), Ne = function(Oe) {
            var _t = ge[Oe];
            ge[Oe] = function() {
              for (var Ke = arguments.length, Lt = new Array(Ke), Mt = 0; Mt < Ke; Mt++) Lt[Mt] = arguments[Mt];
              var si = ce.renderer[Oe].apply(ge, Lt);
              return si === !1 && (si = _t.apply(ge, Lt)), si;
            };
          };
          for (var Xe in ce.renderer) Ne(Xe);
          P.renderer = ge;
        })(), ce.tokenizer && (function() {
          var ge = De.defaults.tokenizer || new ue(), Ne = function(Oe) {
            var _t = ge[Oe];
            ge[Oe] = function() {
              for (var Ke = arguments.length, Lt = new Array(Ke), Mt = 0; Mt < Ke; Mt++) Lt[Mt] = arguments[Mt];
              var si = ce.tokenizer[Oe].apply(ge, Lt);
              return si === !1 && (si = _t.apply(ge, Lt)), si;
            };
          };
          for (var Xe in ce.tokenizer) Ne(Xe);
          P.tokenizer = ge;
        })(), ce.walkTokens) {
          var Ae = De.defaults.walkTokens;
          P.walkTokens = function(ge) {
            var Ne = [];
            return Ne.push(ce.walkTokens.call(this, ge)), Ae && (Ne = Ne.concat(Ae.call(this, ge))), Ne;
          };
        }
        R && (P.extensions = U), De.setOptions(P);
      }));
    }, De.walkTokens = function(le, Y) {
      for (var M, R = [], P = function() {
        var ce = M.value;
        switch (R = R.concat(Y.call(De, ce)), ce.type) {
          case "table":
            for (var Ae, ge = r(ce.header); !(Ae = ge()).done; ) {
              var Ne = Ae.value;
              R = R.concat(De.walkTokens(Ne.tokens, Y));
            }
            for (var Xe, Oe = r(ce.rows); !(Xe = Oe()).done; ) for (var _t, Ke = r(Xe.value); !(_t = Ke()).done; ) {
              var Lt = _t.value;
              R = R.concat(De.walkTokens(Lt.tokens, Y));
            }
            break;
          case "list":
            R = R.concat(De.walkTokens(ce.items, Y));
            break;
          default:
            De.defaults.extensions && De.defaults.extensions.childTokens && De.defaults.extensions.childTokens[ce.type] ? De.defaults.extensions.childTokens[ce.type].forEach((function(Mt) {
              R = R.concat(De.walkTokens(ce[Mt], Y));
            })) : ce.tokens && (R = R.concat(De.walkTokens(ce.tokens, Y)));
        }
      }, U = r(le); !(M = U()).done; ) P();
      return R;
    }, De.parseInline = function(le, Y) {
      if (le == null) throw new Error("marked.parseInline(): input parameter is undefined or null");
      if (typeof le != "string") throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(le) + ", string expected");
      $(Y = T({}, De.defaults, Y || {}));
      try {
        var M = Re.lexInline(le, Y);
        return Y.walkTokens && De.walkTokens(M, Y.walkTokens), nt.parseInline(M, Y);
      } catch (R) {
        if (R.message += `
Please report this to https://github.com/markedjs/marked.`, Y.silent) return "<p>An error occurred:</p><pre>" + p(R.message + "", !0) + "</pre>";
        throw R;
      }
    }, De.Parser = nt, De.parser = nt.parse, De.Renderer = it, De.TextRenderer = ut, De.Lexer = Re, De.lexer = Re.lex, De.Tokenizer = ue, De.Slugger = Xi, De.parse = De;
    var an = De.options, La = De.setOptions, Er = De.use, Ws = De.walkTokens, Ss = De.parseInline, Ir = De, jd = nt.parse, Ki = Re.lex;
    i.Lexer = Re, i.Parser = nt, i.Renderer = it, i.Slugger = Xi, i.TextRenderer = ut, i.Tokenizer = ue, i.getDefaults = a, i.lexer = Ki, i.marked = De, i.options = an, i.parse = Ir, i.parseInline = Ss, i.parser = jd, i.setOptions = La, i.use = Er, i.walkTokens = Ws, Object.defineProperty(i, "__esModule", { value: !0 });
  }, n.amd ? n(0, t) : t(typeof exports == "object" && typeof module < "u" ? exports : (e = typeof globalThis < "u" ? globalThis : e || self).marked = {});
})(), rs.Lexer || exports.Lexer, rs.Parser || exports.Parser, rs.Renderer || exports.Renderer, rs.Slugger || exports.Slugger, rs.TextRenderer || exports.TextRenderer, rs.Tokenizer || exports.Tokenizer, rs.getDefaults || exports.getDefaults, rs.lexer || exports.lexer;
var Ya = rs.marked || exports.marked;
function RI(n) {
  let e = JSON.parse(n);
  return e = AI(e), e;
}
function FJ(n, e) {
  return e instanceof RegExp ? { $mid: 2, source: e.source, flags: e.flags } : e;
}
function AI(n, e = 0) {
  if (!n || e > 200) return n;
  if (typeof n == "object") {
    switch (n.$mid) {
      case 1:
        return Ie.revive(n);
      case 2:
        return new RegExp(n.source, n.flags);
      case 17:
        return new Date(n.source);
    }
    if (n instanceof eL || n instanceof Uint8Array) return n;
    if (Array.isArray(n)) for (let t = 0; t < n.length; ++t) n[t] = AI(n[t], e + 1);
    else for (const t in n) Object.hasOwnProperty.call(n, t) && (n[t] = AI(n[t], e + 1));
  }
  return n;
}
rs.options || exports.options, rs.parse || exports.parse, rs.parseInline || exports.parseInline, rs.parser || exports.parser, rs.setOptions || exports.setOptions, rs.use || exports.use, rs.walkTokens || exports.walkTokens;
const $D = Object.freeze({ image: (n, e, t) => {
  let i = [], s = [];
  return n && ({ href: n, dimensions: i } = (function(o) {
    const r = [], a = o.split("|").map(((d) => d.trim()));
    o = a[0];
    const l = a[1];
    if (l) {
      const d = /height=(\d+)/.exec(l), h = /width=(\d+)/.exec(l), c = d ? d[1] : "", u = h ? h[1] : "", g = isFinite(parseInt(u)), p = isFinite(parseInt(c));
      g && r.push(`width="${u}"`), p && r.push(`height="${c}"`);
    }
    return { href: o, dimensions: r };
  })(n), s.push(`src="${Tb(n)}"`)), t && s.push(`alt="${Tb(t)}"`), e && s.push(`title="${Tb(e)}"`), i.length && (s = s.concat(i)), "<img " + s.join(" ") + ">";
}, paragraph: (n) => `<p>${n}</p>`, link: (n, e, t) => typeof n != "string" ? "" : (n === t && (t = qD(t)), e = typeof e == "string" ? Tb(qD(e)) : "", `<a href="${n = (n = qD(n)).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;")}" title="${e || n}" draggable="false">${t}</a>`) });
function vL(n, e = {}, t = {}) {
  var i, s;
  const o = new G();
  let r = !1;
  const a = mA(e), l = function(_) {
    let v;
    try {
      v = RI(decodeURIComponent(_));
    } catch {
    }
    return v ? (v = v7(v, ((b) => n.uris && n.uris[b] ? Ie.revive(n.uris[b]) : void 0)), encodeURIComponent(JSON.stringify(v))) : _;
  }, d = function(_, v) {
    const b = n.uris && n.uris[_];
    let C = Ie.revive(b);
    return v ? _.startsWith(Ue.data + ":") ? _ : (C || (C = Ie.parse(_)), p8.uriToBrowserUri(C).toString(!0)) : C ? Ie.parse(_).toString() === C.toString() ? _ : (C.query && (C = C.with({ query: l(C.query) })), C.toString()) : _;
  }, h = new Ya.Renderer();
  h.image = $D.image, h.link = $D.link, h.paragraph = $D.paragraph;
  const c = [], u = [];
  if (e.codeBlockRendererSync ? h.code = (_, v) => {
    const b = TI.nextId(), C = e.codeBlockRendererSync(_3(v), _);
    return u.push([b, C]), `<div class="code" data-code="${b}">${Ow(_)}</div>`;
  } : e.codeBlockRenderer && (h.code = (_, v) => {
    const b = TI.nextId(), C = e.codeBlockRenderer(_3(v), _);
    return c.push(C.then(((w) => [b, w]))), `<div class="code" data-code="${b}">${Ow(_)}</div>`;
  }), e.actionHandler) {
    const _ = function(C) {
      let w = C.target;
      if (w.tagName === "A" || (w = w.parentElement, w && w.tagName === "A")) try {
        let y = w.dataset.href;
        y && (n.baseUri && (y = GD(Ie.from(n.baseUri), y)), e.actionHandler.callback(y, C));
      } catch (y) {
        We(y);
      } finally {
        C.preventDefault();
      }
    }, v = e.actionHandler.disposables.add(new st(a, "click")), b = e.actionHandler.disposables.add(new st(a, "auxclick"));
    e.actionHandler.disposables.add(se.any(v.event, b.event)(((C) => {
      const w = new _r(ke(a), C);
      (w.leftButton || w.middleButton) && _(w);
    }))), e.actionHandler.disposables.add(K(a, "keydown", ((C) => {
      const w = new jt(C);
      (w.equals(10) || w.equals(3)) && _(w);
    })));
  }
  n.supportHtml || (t.sanitizer = (_) => n.isTrusted && _.match(/^(<span[^>]+>)|(<\/\s*span>)$/) ? _ : "", t.sanitize = !0, t.silent = !0), t.renderer = h;
  let g, p = (i = n.value) !== null && i !== void 0 ? i : "";
  if (p.length > 1e5 && (p = `${p.substr(0, 1e5)}…`), n.supportThemeIcons && (p = (function(_) {
    return _.replace(PJ, ((v) => `\\${v}`));
  })(p)), e.fillInIncompleteTokens) {
    const _ = { ...Ya.defaults, ...t }, v = (function(b) {
      let C, w;
      for (C = 0; C < b.length; C++) {
        const y = b[C];
        let L;
        if (y.type === "paragraph" && (L = y.raw.match(/(\n|^)(````*)/))) {
          const k = L[2];
          w = UJ(b.slice(C), k);
          break;
        }
        if (y.type === "paragraph" && y.raw.match(/(\n|^)\|/)) {
          w = YJ(b.slice(C));
          break;
        }
        if (C === b.length - 1 && y.type === "paragraph") {
          const k = zJ(y);
          if (k) {
            w = [k];
            break;
          }
        }
      }
      if (w) {
        const y = [...b.slice(0, C), ...w];
        return y.links = b.links, y;
      }
      return b;
    })(Ya.lexer(p, _));
    g = Ya.parser(v, _);
  } else g = Ya.parse(p, t);
  n.supportThemeIcons && (g = tc(g).map(((_) => typeof _ == "string" ? _ : _.outerHTML)).join(""));
  const f = new DOMParser().parseFromString(PI(n, g), "text/html");
  if (f.body.querySelectorAll("img").forEach(((_) => {
    const v = _.getAttribute("src");
    if (v) {
      let b = v;
      try {
        n.baseUri && (b = GD(Ie.from(n.baseUri), b));
      } catch {
      }
      _.src = d(b, !0);
    }
  })), f.body.querySelectorAll("a").forEach(((_) => {
    const v = _.getAttribute("href");
    if (_.setAttribute("href", ""), !v || /^data:|javascript:/i.test(v) || /^command:/i.test(v) && !n.isTrusted || /^command:(\/\/\/)?_workbench\.downloadResource/i.test(v)) _.replaceWith(..._.childNodes);
    else {
      let b = d(v, !1);
      n.baseUri && (b = GD(Ie.from(n.baseUri), v)), _.dataset.href = b;
    }
  })), a.innerHTML = PI(n, f.body.innerHTML), c.length > 0) Promise.all(c).then(((_) => {
    var v, b;
    if (r) return;
    const C = new Map(_), w = a.querySelectorAll("div[data-code]");
    for (const y of w) {
      const L = C.get((v = y.dataset.code) !== null && v !== void 0 ? v : "");
      L && wn(y, L);
    }
    (b = e.asyncRenderCallback) === null || b === void 0 || b.call(e);
  }));
  else if (u.length > 0) {
    const _ = new Map(u), v = a.querySelectorAll("div[data-code]");
    for (const b of v) {
      const C = _.get((s = b.dataset.code) !== null && s !== void 0 ? s : "");
      C && wn(b, C);
    }
  }
  if (e.asyncRenderCallback) for (const _ of a.getElementsByTagName("img")) {
    const v = o.add(K(_, "load", (() => {
      v.dispose(), e.asyncRenderCallback();
    })));
  }
  return { element: a, dispose: () => {
    r = !0, o.dispose();
  } };
}
function _3(n) {
  if (!n) return "";
  const e = n.split(/[\s+|:|,|\{|\?]/, 1);
  return e.length ? e[0] : n;
}
function GD(n, e) {
  return /^\w[\w\d+.-]*:/.test(e) ? e : n.path.endsWith("/") ? C5(n, e).toString() : C5(uL(n), e).toString();
}
function PI(n, e) {
  const { config: t, allowedSchemes: i } = (function(o) {
    const r = [Ue.http, Ue.https, Ue.mailto, Ue.data, Ue.file, Ue.vscodeFileResource, Ue.vscodeRemote, Ue.vscodeRemoteResource];
    return o.isTrusted && r.push(Ue.command), { config: { ALLOWED_TAGS: [...pj], ALLOWED_ATTR: BJ, ALLOW_UNKNOWN_PROTOCOLS: !0 }, allowedSchemes: r };
  })(n);
  zk("uponSanitizeAttribute", ((o, r) => {
    var a;
    if (r.attrName !== "style" && r.attrName !== "class") {
      if (o.tagName === "INPUT" && ((a = o.attributes.getNamedItem("type")) === null || a === void 0 ? void 0 : a.value) === "checkbox") {
        if (r.attrName === "type" && r.attrValue === "checkbox" || r.attrName === "disabled" || r.attrName === "checked") return void (r.keepAttr = !0);
        r.keepAttr = !1;
      }
    } else {
      if (o.tagName === "SPAN") {
        if (r.attrName === "style") return void (r.keepAttr = /^(color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z]+)+\));)?(background-color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z]+)+\));)?$/.test(r.attrValue));
        if (r.attrName === "class") return void (r.keepAttr = /^codicon codicon-[a-z\-]+( codicon-modifier-[a-z\-]+)?$/.test(r.attrValue));
      }
      r.keepAttr = !1;
    }
  })), zk("uponSanitizeElement", ((o, r) => {
    var a, l;
    r.tagName === "input" && (((a = o.attributes.getNamedItem("type")) === null || a === void 0 ? void 0 : a.value) === "checkbox" ? o.setAttribute("disabled", "") : (l = o.parentElement) === null || l === void 0 || l.removeChild(o));
  }));
  const s = (function(o, r = !1) {
    const a = document.createElement("a");
    return zk("afterSanitizeAttributes", ((l) => {
      for (const d of ["href", "src"]) if (l.hasAttribute(d)) {
        const h = l.getAttribute(d);
        if (d === "href" && h.startsWith("#")) continue;
        if (a.href = h, !o.includes(a.protocol.replace(/:$/, ""))) {
          if (r && d === "src" && a.href.startsWith("data:")) continue;
          l.removeAttribute(d);
        }
      }
    })), ye((() => {
      bO("afterSanitizeAttributes");
    }));
  })(i);
  try {
    return u8(e, { ...t, RETURN_TRUSTED_TYPE: !0 });
  } finally {
    bO("uponSanitizeAttribute"), s.dispose();
  }
}
const BJ = ["align", "autoplay", "alt", "checked", "class", "controls", "data-code", "data-href", "disabled", "draggable", "height", "href", "loop", "muted", "playsinline", "poster", "src", "style", "target", "title", "type", "width", "start"];
function WJ(n) {
  return typeof n == "string" ? n : (function(e) {
    var t;
    let i = (t = e.value) !== null && t !== void 0 ? t : "";
    i.length > 1e5 && (i = `${i.substr(0, 1e5)}…`);
    const s = Ya.parse(i, { renderer: HJ.value }).replace(/&(#\d+|[a-zA-Z]+);/g, ((o) => {
      var r;
      return (r = VJ.get(o)) !== null && r !== void 0 ? r : o;
    }));
    return PI({ isTrusted: !1 }, s).toString();
  })(n);
}
const VJ = /* @__PURE__ */ new Map([["&quot;", '"'], ["&nbsp;", " "], ["&amp;", "&"], ["&#39;", "'"], ["&lt;", "<"], ["&gt;", ">"]]), HJ = new ua((() => {
  const n = new Ya.Renderer();
  return n.code = (e) => e, n.blockquote = (e) => e, n.html = (e) => "", n.heading = (e, t, i) => e + `
`, n.hr = () => "", n.list = (e, t) => e, n.listitem = (e) => e + `
`, n.paragraph = (e) => e + `
`, n.table = (e, t) => e + t + `
`, n.tablerow = (e) => e, n.tablecell = (e, t) => e + " ", n.strong = (e) => e, n.em = (e) => e, n.codespan = (e) => e, n.br = () => `
`, n.del = (e) => e, n.image = (e, t, i) => "", n.text = (e) => e, n.link = (e, t, i) => i, n;
}));
function SA(n) {
  let e = "";
  return n.forEach(((t) => {
    e += t.raw;
  })), e;
}
function zJ(n) {
  var e, t;
  for (let i = 0; i < n.tokens.length; i++) {
    const s = n.tokens[i];
    if (s.type === "text") {
      const o = s.raw.split(`
`), r = o[o.length - 1];
      if (r.includes("`")) return KJ(n);
      if (r.includes("**")) return Pc(n, "**");
      if (r.match(/\*\w/)) return jJ(n);
      if (r.match(/(^|\s)__\w/)) return ZJ(n);
      if (r.match(/(^|\s)_\w/)) return qJ(n);
      if (r.match(/(^|\s)\[.*\]\(\w*/)) {
        const a = n.tokens.slice(i + 1);
        return ((e = a[0]) === null || e === void 0 ? void 0 : e.type) === "link" && ((t = a[1]) === null || t === void 0 ? void 0 : t.type) === "text" && a[1].raw.match(/^ *"[^"]*$/) ? $J(n) : b3(n);
      }
      if (v3(r)) return b3(n);
      if (r.match(/(^|\s)\[\w/) && !n.tokens.slice(i + 1).some(((a) => v3(a.raw)))) return GJ(n);
    }
  }
}
function v3(n) {
  return !!n.match(/^[^\[]*\]\([^\)]*$/);
}
function UJ(n, e) {
  const t = SA(n);
  return Ya.lexer(t + `
${e}`);
}
function KJ(n) {
  return Pc(n, "`");
}
function jJ(n) {
  return Pc(n, "*");
}
function qJ(n) {
  return Pc(n, "_");
}
function b3(n) {
  return Pc(n, ")");
}
function $J(n) {
  return Pc(n, '")');
}
function GJ(n) {
  return Pc(n, "](about:blank)");
}
function ZJ(n) {
  return Pc(n, "__");
}
function Pc(n, e) {
  const t = SA(Array.isArray(n) ? n : [n]);
  return Ya.lexer(t + e)[0];
}
function YJ(n) {
  const e = SA(n), t = e.split(`
`);
  let i, s = !1;
  for (let o = 0; o < t.length; o++) {
    const r = t[o].trim();
    if (i === void 0 && r.match(/^\s*\|/)) {
      const a = r.match(/(\|[^\|]+)(?=\||$)/g);
      a && (i = a.length);
    } else if (typeof i == "number") {
      if (!r.match(/^\s*\|/) || o !== t.length - 1) return;
      s = !0;
    }
  }
  if (typeof i == "number" && i > 0) {
    const o = s ? t.slice(0, -1).join(`
`) : e, r = !!o.match(/\|\s*$/), a = o + (r ? "" : "|") + `
|${" --- |".repeat(i)}`;
    return Ya.lexer(a);
  }
}
var OI, XJ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, C3 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let pl = OI = class {
  constructor(n, e, t) {
    this._options = n, this._languageService = e, this._openerService = t, this._onDidRenderAsync = new F(), this.onDidRenderAsync = this._onDidRenderAsync.event;
  }
  dispose() {
    this._onDidRenderAsync.dispose();
  }
  render(n, e, t) {
    if (!n)
      return { element: document.createElement("span"), dispose: () => {
      } };
    const i = new G(), s = i.add(vL(n, { ...this._getRenderOptions(n, i), ...e }, t));
    return s.element.classList.add("rendered-markdown"), { element: s.element, dispose: () => i.dispose() };
  }
  _getRenderOptions(n, e) {
    return { codeBlockRenderer: async (t, i) => {
      var s, o, r;
      let a;
      t ? a = this._languageService.getLanguageIdByLanguageName(t) : this._options.editor && (a = (s = this._options.editor.getModel()) === null || s === void 0 ? void 0 : s.getLanguageId()), a || (a = ko);
      const l = await (async function(h, c, u) {
        if (!u) return K5(c, h.languageIdCodec, U5);
        const g = await ci.getOrCreate(u);
        return K5(c, h.languageIdCodec, g || U5);
      })(this._languageService, i, a), d = document.createElement("span");
      return d.innerHTML = (r = (o = OI._ttpTokenizer) === null || o === void 0 ? void 0 : o.createHTML(l)) !== null && r !== void 0 ? r : l, this._options.editor ? yn(d, this._options.editor.getOption(50)) : this._options.codeBlockFontFamily && (d.style.fontFamily = this._options.codeBlockFontFamily), this._options.codeBlockFontSize !== void 0 && (d.style.fontSize = this._options.codeBlockFontSize), d;
    }, asyncRenderCallback: () => this._onDidRenderAsync.fire(), actionHandler: { callback: (t) => LA(this._openerService, t, n.isTrusted), disposables: e } };
  }
};
async function LA(n, e, t) {
  try {
    return await n.open(e, { fromUserGesture: !0, allowContributedOpeners: !0, allowCommands: QJ(t) });
  } catch (i) {
    return We(i), !1;
  }
}
function QJ(n) {
  return n === !0 || !(!n || !Array.isArray(n.enabledCommands)) && n.enabledCommands;
}
pl._ttpTokenizer = Hd("tokenizeToString", { createHTML: (n) => n }), pl = OI = XJ([C3(1, Xt), C3(2, Fs)], pl);
var JJ = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Hf = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const xa = Q;
let FI = class extends To {
  get _targetWindow() {
    return ke(this._target.targetElements[0]);
  }
  get _targetDocumentElement() {
    return ke(this._target.targetElements[0]).document.documentElement;
  }
  get isDisposed() {
    return this._isDisposed;
  }
  get isMouseIn() {
    return this._lockMouseTracker.isMouseIn;
  }
  get domNode() {
    return this._hover.containerDomNode;
  }
  get onDispose() {
    return this._onDispose.event;
  }
  get onRequestLayout() {
    return this._onRequestLayout.event;
  }
  get anchor() {
    return this._hoverPosition === 2 ? 0 : 1;
  }
  get x() {
    return this._x;
  }
  get y() {
    return this._y;
  }
  get isLocked() {
    return this._isLocked;
  }
  set isLocked(n) {
    this._isLocked !== n && (this._isLocked = n, this._hoverContainer.classList.toggle("locked", this._isLocked));
  }
  constructor(n, e, t, i, s, o) {
    var r, a, l, d, h, c, u, g;
    super(), this._keybindingService = e, this._configurationService = t, this._openerService = i, this._instantiationService = s, this._accessibilityService = o, this._messageListeners = new G(), this._isDisposed = !1, this._forcePosition = !1, this._x = 0, this._y = 0, this._isLocked = !1, this._enableFocusTraps = !1, this._addedFocusTrap = !1, this._onDispose = this._register(new F()), this._onRequestLayout = this._register(new F()), this._linkHandler = n.linkHandler || ((C) => LA(this._openerService, C, da(n.content) ? n.content.isTrusted : void 0)), this._target = "targetElements" in n.target ? n.target : new eee(n.target), this._hoverPointer = !((r = n.appearance) === null || r === void 0) && r.showPointer ? xa("div.workbench-hover-pointer") : void 0, this._hover = this._register(new pA()), this._hover.containerDomNode.classList.add("workbench-hover", "fadeIn"), !((a = n.appearance) === null || a === void 0) && a.compact && this._hover.containerDomNode.classList.add("workbench-hover", "compact"), !((l = n.appearance) === null || l === void 0) && l.skipFadeInAnimation && this._hover.containerDomNode.classList.add("skip-fade-in"), n.additionalClasses && this._hover.containerDomNode.classList.add(...n.additionalClasses), !((d = n.position) === null || d === void 0) && d.forcePosition && (this._forcePosition = !0), n.trapFocus && (this._enableFocusTraps = !0), this._hoverPosition = (c = (h = n.position) === null || h === void 0 ? void 0 : h.hoverPosition) !== null && c !== void 0 ? c : 3, this.onmousedown(this._hover.containerDomNode, ((C) => C.stopPropagation())), this.onkeydown(this._hover.containerDomNode, ((C) => {
      C.equals(9) && this.dispose();
    })), this._register(K(this._targetWindow, "blur", (() => this.dispose())));
    const p = xa("div.hover-row.markdown-hover"), f = xa("div.hover-contents");
    if (typeof n.content == "string") f.textContent = n.content, f.style.whiteSpace = "pre-wrap";
    else if (n.content instanceof HTMLElement) f.appendChild(n.content), f.classList.add("html-hover-contents");
    else {
      const C = n.content, w = this._instantiationService.createInstance(pl, { codeBlockFontFamily: this._configurationService.getValue("editor").fontFamily || Is.fontFamily }), { element: y } = w.render(C, { actionHandler: { callback: (L) => this._linkHandler(L), disposables: this._messageListeners }, asyncRenderCallback: () => {
        f.classList.add("code-hover-contents"), this.layout(), this._onRequestLayout.fire();
      } });
      f.appendChild(y);
    }
    if (p.appendChild(f), this._hover.contentsDomNode.appendChild(p), n.actions && n.actions.length > 0) {
      const C = xa("div.hover-row.status-bar"), w = xa("div.actions");
      n.actions.forEach(((y) => {
        const L = this._keybindingService.lookupKeybinding(y.commandId), k = L ? L.getLabel() : null;
        fL.render(w, { label: y.label, commandId: y.commandId, run: (N) => {
          y.run(N), this.dispose();
        }, iconClass: y.iconClass }, k);
      })), C.appendChild(w), this._hover.containerDomNode.appendChild(C);
    }
    let _;
    if (this._hoverContainer = xa("div.workbench-hover-container"), this._hoverPointer && this._hoverContainer.appendChild(this._hoverPointer), this._hoverContainer.appendChild(this._hover.containerDomNode), _ = !(n.actions && n.actions.length > 0) && (((u = n.persistence) === null || u === void 0 ? void 0 : u.hideOnHover) === void 0 ? typeof n.content == "string" || da(n.content) && !n.content.value.includes("](") && !n.content.value.includes("</a>") : n.persistence.hideOnHover), _ && ((g = n.appearance) === null || g === void 0 ? void 0 : g.showHoverHint)) {
      const C = xa("div.hover-row.status-bar"), w = xa("div.info");
      w.textContent = m(0, "Hold {0} key to mouse over", Je ? "Option" : "Alt"), C.appendChild(w), this._hover.containerDomNode.appendChild(C);
    }
    const v = [...this._target.targetElements];
    _ || v.push(this._hoverContainer);
    const b = this._register(new w3(v));
    if (this._register(b.onMouseOut((() => {
      this._isLocked || this.dispose();
    }))), _) {
      const C = [...this._target.targetElements, this._hoverContainer];
      this._lockMouseTracker = this._register(new w3(C)), this._register(this._lockMouseTracker.onMouseOut((() => {
        this._isLocked || this.dispose();
      })));
    } else this._lockMouseTracker = b;
  }
  addFocusTrap() {
    if (!this._enableFocusTraps || this._addedFocusTrap) return;
    this._addedFocusTrap = !0;
    const n = this._hover.containerDomNode, e = this.findLastFocusableChild(this._hover.containerDomNode);
    if (e) {
      const t = fR(this._hoverContainer, xa("div")), i = Z(this._hoverContainer, xa("div"));
      t.tabIndex = 0, i.tabIndex = 0, this._register(K(i, "focus", ((s) => {
        n.focus(), s.preventDefault();
      }))), this._register(K(t, "focus", ((s) => {
        e.focus(), s.preventDefault();
      })));
    }
  }
  findLastFocusableChild(n) {
    if (n.hasChildNodes()) for (let e = 0; e < n.childNodes.length; e++) {
      const t = n.childNodes.item(n.childNodes.length - e - 1);
      if (t.nodeType === t.ELEMENT_NODE) {
        const s = t;
        if (typeof s.tabIndex == "number" && s.tabIndex >= 0) return s;
      }
      const i = this.findLastFocusableChild(t);
      if (i) return i;
    }
  }
  render(n) {
    var e;
    n.appendChild(this._hoverContainer);
    const t = this._hoverContainer.contains(this._hoverContainer.ownerDocument.activeElement) && kW(this._configurationService.getValue("accessibility.verbosity.hover") === !0 && this._accessibilityService.isScreenReaderOptimized(), (e = this._keybindingService.lookupKeybinding("editor.action.accessibleView")) === null || e === void 0 ? void 0 : e.getAriaLabel());
    t && vl(t), this.layout(), this.addFocusTrap();
  }
  layout() {
    this._hover.containerDomNode.classList.remove("right-aligned"), this._hover.contentsDomNode.style.maxHeight = "";
    const n = this._target.targetElements.map(((l) => ((d) => {
      const h = v8(d), c = d.getBoundingClientRect();
      return { top: c.top * h, bottom: c.bottom * h, right: c.right * h, left: c.left * h };
    })(l))), { top: e, right: t, bottom: i, left: s } = n[0], o = t - s, r = i - e, a = { top: e, right: t, bottom: i, left: s, width: o, height: r, center: { x: s + o / 2, y: e + r / 2 } };
    if (this.adjustHorizontalHoverPosition(a), this.adjustVerticalHoverPosition(a), this.adjustHoverMaxHeight(a), this._hoverContainer.style.padding = "", this._hoverContainer.style.margin = "", this._hoverPointer) {
      switch (this._hoverPosition) {
        case 1:
          a.left += 3, a.right += 3, this._hoverContainer.style.paddingLeft = "3px", this._hoverContainer.style.marginLeft = "-3px";
          break;
        case 0:
          a.left -= 3, a.right -= 3, this._hoverContainer.style.paddingRight = "3px", this._hoverContainer.style.marginRight = "-3px";
          break;
        case 2:
          a.top += 3, a.bottom += 3, this._hoverContainer.style.paddingTop = "3px", this._hoverContainer.style.marginTop = "-3px";
          break;
        case 3:
          a.top -= 3, a.bottom -= 3, this._hoverContainer.style.paddingBottom = "3px", this._hoverContainer.style.marginBottom = "-3px";
      }
      a.center.x = a.left + o / 2, a.center.y = a.top + r / 2;
    }
    this.computeXCordinate(a), this.computeYCordinate(a), this._hoverPointer && (this._hoverPointer.classList.remove("top"), this._hoverPointer.classList.remove("left"), this._hoverPointer.classList.remove("right"), this._hoverPointer.classList.remove("bottom"), this.setHoverPointerPosition(a)), this._hover.onContentsChanged();
  }
  computeXCordinate(n) {
    const e = this._hover.containerDomNode.clientWidth + 2;
    this._target.x !== void 0 ? this._x = this._target.x : this._hoverPosition === 1 ? this._x = n.right : this._hoverPosition === 0 ? this._x = n.left - e : (this._hoverPointer ? this._x = n.center.x - this._hover.containerDomNode.clientWidth / 2 : this._x = n.left, this._x + e >= this._targetDocumentElement.clientWidth && (this._hover.containerDomNode.classList.add("right-aligned"), this._x = Math.max(this._targetDocumentElement.clientWidth - e - 2, this._targetDocumentElement.clientLeft))), this._x < this._targetDocumentElement.clientLeft && (this._x = n.left + 2);
  }
  computeYCordinate(n) {
    this._target.y !== void 0 ? this._y = this._target.y : this._hoverPosition === 3 ? this._y = n.top : this._hoverPosition === 2 ? this._y = n.bottom - 2 : this._hoverPointer ? this._y = n.center.y + this._hover.containerDomNode.clientHeight / 2 : this._y = n.bottom, this._y > this._targetWindow.innerHeight && (this._y = n.bottom);
  }
  adjustHorizontalHoverPosition(n) {
    if (this._target.x !== void 0) return;
    const e = this._hoverPointer ? 3 : 0;
    if (this._forcePosition) {
      const t = e + 2;
      this._hoverPosition === 1 ? this._hover.containerDomNode.style.maxWidth = this._targetDocumentElement.clientWidth - n.right - t + "px" : this._hoverPosition === 0 && (this._hover.containerDomNode.style.maxWidth = n.left - t + "px");
    } else this._hoverPosition === 1 ? this._targetDocumentElement.clientWidth - n.right < this._hover.containerDomNode.clientWidth + e && (n.left >= this._hover.containerDomNode.clientWidth + e ? this._hoverPosition = 0 : this._hoverPosition = 2) : this._hoverPosition === 0 && (n.left < this._hover.containerDomNode.clientWidth + e && (this._targetDocumentElement.clientWidth - n.right >= this._hover.containerDomNode.clientWidth + e ? this._hoverPosition = 1 : this._hoverPosition = 2), n.left - this._hover.containerDomNode.clientWidth - e <= this._targetDocumentElement.clientLeft && (this._hoverPosition = 1));
  }
  adjustVerticalHoverPosition(n) {
    if (this._target.y !== void 0 || this._forcePosition) return;
    const e = this._hoverPointer ? 3 : 0;
    this._hoverPosition === 3 ? n.top - this._hover.containerDomNode.clientHeight - e < 0 && (this._hoverPosition = 2) : this._hoverPosition === 2 && n.bottom + this._hover.containerDomNode.clientHeight + e > this._targetWindow.innerHeight && (this._hoverPosition = 3);
  }
  adjustHoverMaxHeight(n) {
    let e = this._targetWindow.innerHeight / 2;
    if (this._forcePosition) {
      const t = 2 + (this._hoverPointer ? 3 : 0);
      this._hoverPosition === 3 ? e = Math.min(e, n.top - t) : this._hoverPosition === 2 && (e = Math.min(e, this._targetWindow.innerHeight - n.bottom - t));
    }
    if (this._hover.containerDomNode.style.maxHeight = `${e}px`, this._hover.contentsDomNode.clientHeight < this._hover.contentsDomNode.scrollHeight) {
      const t = `${this._hover.scrollbar.options.verticalScrollbarSize}px`;
      this._hover.contentsDomNode.style.paddingRight !== t && (this._hover.contentsDomNode.style.paddingRight = t);
    }
  }
  setHoverPointerPosition(n) {
    if (this._hoverPointer) switch (this._hoverPosition) {
      case 0:
      case 1: {
        this._hoverPointer.classList.add(this._hoverPosition === 0 ? "right" : "left");
        const e = this._hover.containerDomNode.clientHeight;
        e > n.height ? this._hoverPointer.style.top = n.center.y - (this._y - e) - 3 + "px" : this._hoverPointer.style.top = Math.round(e / 2) - 3 + "px";
        break;
      }
      case 3:
      case 2: {
        this._hoverPointer.classList.add(this._hoverPosition === 3 ? "bottom" : "top");
        const e = this._hover.containerDomNode.clientWidth;
        let t = Math.round(e / 2) - 3;
        const i = this._x + t;
        (i < n.left || i > n.right) && (t = n.center.x - this._x - 3), this._hoverPointer.style.left = `${t}px`;
        break;
      }
    }
  }
  focus() {
    this._hover.containerDomNode.focus();
  }
  dispose() {
    this._isDisposed || (this._onDispose.fire(), this._hoverContainer.remove(), this._messageListeners.dispose(), this._target.dispose(), super.dispose()), this._isDisposed = !0;
  }
};
FI = JJ([Hf(1, Dt), Hf(2, Ye), Hf(3, Fs), Hf(4, Se), Hf(5, or)], FI);
class w3 extends To {
  get onMouseOut() {
    return this._onMouseOut.event;
  }
  get isMouseIn() {
    return this._isMouseIn;
  }
  constructor(e) {
    super(), this._elements = e, this._isMouseIn = !0, this._onMouseOut = this._register(new F()), this._elements.forEach(((t) => this.onmouseover(t, (() => this._onTargetMouseOver(t))))), this._elements.forEach(((t) => this.onmouseleave(t, (() => this._onTargetMouseLeave(t)))));
  }
  _onTargetMouseOver(e) {
    this._isMouseIn = !0, this._clearEvaluateMouseStateTimeout(e);
  }
  _onTargetMouseLeave(e) {
    this._isMouseIn = !1, this._evaluateMouseState(e);
  }
  _evaluateMouseState(e) {
    this._clearEvaluateMouseStateTimeout(e), this._mouseTimeout = ke(e).setTimeout((() => this._fireIfMouseOutside()), 0);
  }
  _clearEvaluateMouseStateTimeout(e) {
    this._mouseTimeout && (ke(e).clearTimeout(this._mouseTimeout), this._mouseTimeout = void 0);
  }
  _fireIfMouseOutside() {
    this._isMouseIn || this._onMouseOut.fire();
  }
}
class eee {
  constructor(e) {
    this._element = e, this.targetElements = [this._element];
  }
  dispose() {
  }
}
var Fn, Wh;
function Bp(n, e, t) {
  const i = t.mode === Wh.ALIGN ? t.offset : t.offset + t.size, s = t.mode === Wh.ALIGN ? t.offset + t.size : t.offset;
  return t.position === 0 ? e <= n - i ? i : e <= s ? s - e : Math.max(n - e, 0) : e <= s ? s - e : e <= n - i ? i : 0;
}
(function(n) {
  function e(i, s) {
    if (i.start >= s.end || s.start >= i.end) return { start: 0, end: 0 };
    const o = Math.max(i.start, s.start), r = Math.min(i.end, s.end);
    return r - o <= 0 ? { start: 0, end: 0 } : { start: o, end: r };
  }
  function t(i) {
    return i.end - i.start <= 0;
  }
  n.intersect = e, n.isEmpty = t, n.intersects = function(i, s) {
    return !t(e(i, s));
  }, n.relativeComplement = function(i, s) {
    const o = [], r = { start: i.start, end: Math.min(s.start, i.end) }, a = { start: Math.max(s.end, i.start), end: i.end };
    return t(r) || o.push(r), t(a) || o.push(a), o;
  };
})(Fn || (Fn = {})), (function(n) {
  n[n.AVOID = 0] = "AVOID", n[n.ALIGN = 1] = "ALIGN";
})(Wh || (Wh = {}));
class qm extends V {
  constructor(e, t) {
    super(), this.container = null, this.useFixedPosition = !1, this.useShadowDOM = !1, this.delegate = null, this.toDisposeOnClean = V.None, this.toDisposeOnSetContainer = V.None, this.shadowRoot = null, this.shadowRootHostElement = null, this.view = Q(".context-view"), Ts(this.view), this.setContainer(e, t), this._register(ye((() => this.setContainer(null, 1))));
  }
  setContainer(e, t) {
    var i;
    this.useFixedPosition = t !== 1;
    const s = this.useShadowDOM;
    if (this.useShadowDOM = t === 3, (e !== this.container || s !== this.useShadowDOM) && (this.container && (this.toDisposeOnSetContainer.dispose(), this.shadowRoot ? (this.shadowRoot.removeChild(this.view), this.shadowRoot = null, (i = this.shadowRootHostElement) === null || i === void 0 || i.remove(), this.shadowRootHostElement = null) : this.container.removeChild(this.view), this.container = null), e)) {
      if (this.container = e, this.useShadowDOM) {
        this.shadowRootHostElement = Q(".shadow-root-host"), this.container.appendChild(this.shadowRootHostElement), this.shadowRoot = this.shadowRootHostElement.attachShadow({ mode: "open" });
        const r = document.createElement("style");
        r.textContent = tee, this.shadowRoot.appendChild(r), this.shadowRoot.appendChild(this.view), this.shadowRoot.appendChild(Q("slot"));
      } else this.container.appendChild(this.view);
      const o = new G();
      qm.BUBBLE_UP_EVENTS.forEach(((r) => {
        o.add(bi(this.container, r, ((a) => {
          this.onDOMEvent(a, !1);
        })));
      })), qm.BUBBLE_DOWN_EVENTS.forEach(((r) => {
        o.add(bi(this.container, r, ((a) => {
          this.onDOMEvent(a, !0);
        }), !0));
      })), this.toDisposeOnSetContainer = o;
    }
  }
  show(e) {
    var t, i, s;
    this.isVisible() && this.hide(), Un(this.view), this.view.className = "context-view", this.view.style.top = "0px", this.view.style.left = "0px", this.view.style.zIndex = `${2575 + ((t = e.layer) !== null && t !== void 0 ? t : 0)}`, this.view.style.position = this.useFixedPosition ? "fixed" : "absolute", bo(this.view), this.toDisposeOnClean = e.render(this.view) || V.None, this.delegate = e, this.doLayout(), (s = (i = this.delegate).focus) === null || s === void 0 || s.call(i);
  }
  getViewElement() {
    return this.view;
  }
  layout() {
    var e, t;
    this.isVisible() && (this.delegate.canRelayout !== !1 || ca && dR ? ((t = (e = this.delegate) === null || e === void 0 ? void 0 : e.layout) === null || t === void 0 || t.call(e), this.doLayout()) : this.hide());
  }
  doLayout() {
    if (!this.isVisible()) return;
    const e = this.delegate.getAnchor();
    let t;
    if (e instanceof HTMLElement) {
      const u = Ti(e), g = v8(e);
      t = { top: u.top * g, left: u.left * g, width: u.width * g, height: u.height * g };
    } else t = (function(u) {
      const g = u;
      return !!g && typeof g.x == "number" && typeof g.y == "number";
    })(e) ? { top: e.y, left: e.x, width: e.width || 1, height: e.height || 2 } : { top: e.posy, left: e.posx, width: 2, height: 2 };
    const i = os(this.view), s = rd(this.view), o = this.delegate.anchorPosition || 0, r = this.delegate.anchorAlignment || 0, a = this.delegate.anchorAxisAlignment || 0;
    let l, d;
    const h = (function() {
      var u, g;
      return (g = (u = cf().defaultView) === null || u === void 0 ? void 0 : u.window) !== null && g !== void 0 ? g : It;
    })();
    if (a === 0) {
      const u = { offset: t.top - h.pageYOffset, size: t.height, position: o === 0 ? 0 : 1 }, g = { offset: t.left, size: t.width, position: r === 0 ? 0 : 1, mode: Wh.ALIGN };
      l = Bp(h.innerHeight, s, u) + h.pageYOffset, Fn.intersects({ start: l, end: l + s }, { start: u.offset, end: u.offset + u.size }) && (g.mode = Wh.AVOID), d = Bp(h.innerWidth, i, g);
    } else {
      const u = { offset: t.left, size: t.width, position: r === 0 ? 0 : 1 }, g = { offset: t.top, size: t.height, position: o === 0 ? 0 : 1, mode: Wh.ALIGN };
      d = Bp(h.innerWidth, i, u), Fn.intersects({ start: d, end: d + i }, { start: u.offset, end: u.offset + u.size }) && (g.mode = Wh.AVOID), l = Bp(h.innerHeight, s, g) + h.pageYOffset;
    }
    this.view.classList.remove("top", "bottom", "left", "right"), this.view.classList.add(o === 0 ? "bottom" : "top"), this.view.classList.add(r === 0 ? "left" : "right"), this.view.classList.toggle("fixed", this.useFixedPosition);
    const c = Ti(this.container);
    this.view.style.top = l - (this.useFixedPosition ? Ti(this.view).top : c.top) + "px", this.view.style.left = d - (this.useFixedPosition ? Ti(this.view).left : c.left) + "px", this.view.style.width = "initial";
  }
  hide(e) {
    const t = this.delegate;
    this.delegate = null, t?.onHide && t.onHide(e), this.toDisposeOnClean.dispose(), Ts(this.view);
  }
  isVisible() {
    return !!this.delegate;
  }
  onDOMEvent(e, t) {
    this.delegate && (this.delegate.onDOMEvent ? this.delegate.onDOMEvent(e, ke(e).document.activeElement) : t && !gn(e.target, this.container) && this.hide());
  }
  dispose() {
    this.hide(), super.dispose();
  }
}
qm.BUBBLE_UP_EVENTS = ["click", "keydown", "focus", "blur"], qm.BUBBLE_DOWN_EVENTS = ["click"];
const tee = `
	:host {
		all: initial; /* 1st rule so subsequent properties are reset. */
	}

	.codicon[class*='codicon-'] {
		font: normal normal normal 16px/1 codicon;
		display: inline-block;
		text-decoration: none;
		text-rendering: auto;
		text-align: center;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}

	:host {
		font-family: -apple-system, BlinkMacSystemFont, "Segoe WPC", "Segoe UI", "HelveticaNeue-Light", system-ui, "Ubuntu", "Droid Sans", sans-serif;
	}

	:host-context(.mac) { font-family: -apple-system, BlinkMacSystemFont, sans-serif; }
	:host-context(.mac:lang(zh-Hans)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", sans-serif; }
	:host-context(.mac:lang(zh-Hant)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang TC", sans-serif; }
	:host-context(.mac:lang(ja)) { font-family: -apple-system, BlinkMacSystemFont, "Hiragino Kaku Gothic Pro", sans-serif; }
	:host-context(.mac:lang(ko)) { font-family: -apple-system, BlinkMacSystemFont, "Nanum Gothic", "Apple SD Gothic Neo", "AppleGothic", sans-serif; }

	:host-context(.windows) { font-family: "Segoe WPC", "Segoe UI", sans-serif; }
	:host-context(.windows:lang(zh-Hans)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft YaHei", sans-serif; }
	:host-context(.windows:lang(zh-Hant)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft Jhenghei", sans-serif; }
	:host-context(.windows:lang(ja)) { font-family: "Segoe WPC", "Segoe UI", "Yu Gothic UI", "Meiryo UI", sans-serif; }
	:host-context(.windows:lang(ko)) { font-family: "Segoe WPC", "Segoe UI", "Malgun Gothic", "Dotom", sans-serif; }

	:host-context(.linux) { font-family: system-ui, "Ubuntu", "Droid Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hans)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans SC", "Source Han Sans CN", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hant)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans TC", "Source Han Sans TW", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ja)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans J", "Source Han Sans JP", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ko)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans K", "Source Han Sans JR", "Source Han Sans", "UnDotum", "FBaekmuk Gulim", sans-serif; }
`;
var iee = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, nee = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Dy = class extends V {
  constructor(n) {
    super(), this.layoutService = n, this.currentViewDisposable = this._register(new rn()), this.contextView = this._register(new qm(this.layoutService.mainContainer, 1)), this.layout(), this._register(n.onDidLayoutContainer((() => this.layout())));
  }
  showContextView(n, e, t) {
    let i;
    i = e ? e === this.layoutService.getContainer(ke(e)) ? 1 : t ? 3 : 2 : 1, this.contextView.setContainer(e ?? this.layoutService.activeContainer, i), this.contextView.show(n);
    const s = ye((() => {
      this.currentViewDisposable === s && this.hideContextView();
    }));
    return this.currentViewDisposable.value = s, s;
  }
  layout() {
    this.contextView.layout();
  }
  hideContextView(n) {
    this.contextView.hide(n);
  }
};
Dy = iee([nee(0, Ac)], Dy);
class see extends Dy {
  getContextViewElement() {
    return this.contextView.getViewElement();
  }
}
var oee = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, zf = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let BI = class extends V {
  constructor(n, e, t, i, s) {
    super(), this._instantiationService = n, this._keybindingService = t, this._layoutService = i, this._accessibilityService = s, e.onDidShowContextMenu((() => this.hideHover())), this._contextViewHandler = this._register(new Dy(this._layoutService));
  }
  showHover(n, e, t) {
    var i, s, o, r;
    if (y3(this._currentHoverOptions) === y3(n) || this._currentHover && (!((s = (i = this._currentHoverOptions) === null || i === void 0 ? void 0 : i.persistence) === null || s === void 0) && s.sticky)) return;
    this._currentHoverOptions = n, this._lastHoverOptions = n;
    const a = n.trapFocus || this._accessibilityService.isScreenReaderOptimized(), l = Mn();
    t || (this._lastFocusedElementBeforeOpen = a && l ? l : void 0);
    const d = new G(), h = this._instantiationService.createInstance(FI, n);
    if (!((o = n.persistence) === null || o === void 0) && o.sticky && (h.isLocked = !0), h.onDispose((() => {
      var c, u;
      !((c = this._currentHover) === null || c === void 0) && c.domNode && C8(this._currentHover.domNode) && ((u = this._lastFocusedElementBeforeOpen) === null || u === void 0 || u.focus()), this._currentHoverOptions === n && (this._currentHoverOptions = void 0), d.dispose();
    })), !n.container) {
      const c = n.target instanceof HTMLElement ? n.target : n.target.targetElements[0];
      n.container = this._layoutService.getContainer(ke(c));
    }
    if (this._contextViewHandler.showContextView(new ree(h, e), n.container), h.onRequestLayout((() => this._contextViewHandler.layout())), (r = n.persistence) === null || r === void 0 ? void 0 : r.sticky) d.add(K(ke(n.container).document, ie.MOUSE_DOWN, ((c) => {
      gn(c.target, h.domNode) || this.doHideHover();
    })));
    else {
      if ("targetElements" in n.target) for (const u of n.target.targetElements) d.add(K(u, ie.CLICK, (() => this.hideHover())));
      else d.add(K(n.target, ie.CLICK, (() => this.hideHover())));
      const c = Mn();
      if (c) {
        const u = ke(c).document;
        d.add(K(c, ie.KEY_DOWN, ((g) => {
          var p;
          return this._keyDown(g, h, !!(!((p = n.persistence) === null || p === void 0) && p.hideOnKeyDown));
        }))), d.add(K(u, ie.KEY_DOWN, ((g) => {
          var p;
          return this._keyDown(g, h, !!(!((p = n.persistence) === null || p === void 0) && p.hideOnKeyDown));
        }))), d.add(K(c, ie.KEY_UP, ((g) => this._keyUp(g, h)))), d.add(K(u, ie.KEY_UP, ((g) => this._keyUp(g, h))));
      }
    }
    if ("IntersectionObserver" in It) {
      const c = new IntersectionObserver(((g) => this._intersectionChange(g, h)), { threshold: 0 }), u = "targetElements" in n.target ? n.target.targetElements[0] : n.target;
      c.observe(u), d.add(ye((() => c.disconnect())));
    }
    return this._currentHover = h, h;
  }
  hideHover() {
    var n;
    !(!((n = this._currentHover) === null || n === void 0) && n.isLocked) && this._currentHoverOptions && this.doHideHover();
  }
  doHideHover() {
    this._currentHover = void 0, this._currentHoverOptions = void 0, this._contextViewHandler.hideContextView();
  }
  _intersectionChange(n, e) {
    n[n.length - 1].isIntersecting || e.dispose();
  }
  _keyDown(n, e, t) {
    var i, s;
    if (n.key === "Alt") return void (e.isLocked = !0);
    const o = new jt(n);
    this._keybindingService.resolveKeyboardEvent(o).getSingleModifierDispatchChords().some(((r) => !!r)) || this._keybindingService.softDispatch(o, o.target).kind !== 0 || !t || !((i = this._currentHoverOptions) === null || i === void 0) && i.trapFocus && n.key === "Tab" || (this.hideHover(), (s = this._lastFocusedElementBeforeOpen) === null || s === void 0 || s.focus());
  }
  _keyUp(n, e) {
    var t;
    n.key === "Alt" && (e.isLocked = !1, e.isMouseIn || (this.hideHover(), (t = this._lastFocusedElementBeforeOpen) === null || t === void 0 || t.focus()));
  }
};
function y3(n) {
  var e;
  if (n !== void 0) return (e = n?.id) !== null && e !== void 0 ? e : n;
}
BI = oee([zf(0, Se), zf(1, io), zf(2, Dt), zf(3, Ac), zf(4, or)], BI);
class ree {
  get anchorPosition() {
    return this._hover.anchor;
  }
  constructor(e, t = !1) {
    this._hover = e, this._focus = t, this.layer = 1;
  }
  render(e) {
    return this._hover.render(e), this._focus && this._hover.focus(), this._hover;
  }
  getAnchor() {
    return { x: this._hover.x, y: this._hover.y };
  }
  layout() {
    this._hover.layout();
  }
}
rt(gA, BI, 1), rr(((n, e) => {
  const t = n.getColor(hB);
  t && (e.addRule(`.monaco-workbench .workbench-hover .hover-row:not(:first-child):not(:empty) { border-top: 1px solid ${t.transparent(0.5)}; }`), e.addRule(`.monaco-workbench .workbench-hover hr { border-top: 1px solid ${t.transparent(0.5)}; }`));
}));
const M1 = tt("IWorkspaceEditService");
class kA {
  constructor(e) {
    this.metadata = e;
  }
  static convert(e) {
    return e.edits.map(((t) => {
      if (ic.is(t)) return ic.lift(t);
      if (gm.is(t)) return gm.lift(t);
      throw new Error("Unsupported edit");
    }));
  }
}
class ic extends kA {
  static is(e) {
    return e instanceof ic || ms(e) && Ie.isUri(e.resource) && ms(e.textEdit);
  }
  static lift(e) {
    return e instanceof ic ? e : new ic(e.resource, e.textEdit, e.versionId, e.metadata);
  }
  constructor(e, t, i = void 0, s) {
    super(s), this.resource = e, this.textEdit = t, this.versionId = i;
  }
}
class gm extends kA {
  static is(e) {
    return e instanceof gm || ms(e) && (!!e.newResource || !!e.oldResource);
  }
  static lift(e) {
    return e instanceof gm ? e : new gm(e.oldResource, e.newResource, e.options, e.metadata);
  }
  constructor(e, t, i = {}, s) {
    super(s), this.oldResource = e, this.newResource = t, this.options = i;
  }
}
const An = { enableSplitViewResizing: !0, renderSideBySide: !0, renderMarginRevertIcon: !0, renderGutterMenu: !0, maxComputationTime: 5e3, maxFileSize: 50, ignoreTrimWhitespace: !0, renderIndicators: !0, originalEditable: !1, diffCodeLens: !1, renderOverviewRuler: !0, diffWordWrap: "inherit", diffAlgorithm: "advanced", accessibilityVerbose: !1, experimental: { showMoves: !1, showEmptyDecorations: !0 }, hideUnchangedRegions: { enabled: !1, contextLineCount: 3, minimumLineCount: 3, revealLineCount: 20 }, isInEmbeddedEditor: !1, onlyShowAccessibleDiffViewer: !1, renderSideBySideInlineBreakpoint: 900, useInlineViewWhenSpaceIsLimited: !0 }, xy = Object.freeze({ id: "editor", order: 5, type: "object", title: m(0, "Editor"), scope: 5 }), Ny = { ...xy, properties: { "editor.tabSize": { type: "number", default: Wn.tabSize, minimum: 1, markdownDescription: m(0, "The number of spaces a tab is equal to. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`") }, "editor.indentSize": { anyOf: [{ type: "string", enum: ["tabSize"] }, { type: "number", minimum: 1 }], default: "tabSize", markdownDescription: m(0, 'The number of spaces used for indentation or `"tabSize"` to use the value from `#editor.tabSize#`. This setting is overridden based on the file contents when `#editor.detectIndentation#` is on.') }, "editor.insertSpaces": { type: "boolean", default: Wn.insertSpaces, markdownDescription: m(0, "Insert spaces when pressing `Tab`. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`") }, "editor.detectIndentation": { type: "boolean", default: Wn.detectIndentation, markdownDescription: m(0, "Controls whether {0} and {1} will be automatically detected when a file is opened based on the file contents.", "`#editor.tabSize#`", "`#editor.insertSpaces#`") }, "editor.trimAutoWhitespace": { type: "boolean", default: Wn.trimAutoWhitespace, description: m(0, "Remove trailing auto inserted whitespace.") }, "editor.largeFileOptimizations": { type: "boolean", default: Wn.largeFileOptimizations, description: m(0, "Special handling for large files to disable certain memory intensive features.") }, "editor.wordBasedSuggestions": { enum: ["off", "currentDocument", "matchingDocuments", "allDocuments"], default: "matchingDocuments", enumDescriptions: [m(0, "Turn off Word Based Suggestions."), m(0, "Only suggest words from the active document."), m(0, "Suggest words from all open documents of the same language."), m(0, "Suggest words from all open documents.")], description: m(0, "Controls whether completions should be computed based on words in the document and from which documents they are computed.") }, "editor.semanticHighlighting.enabled": { enum: [!0, !1, "configuredByTheme"], enumDescriptions: [m(0, "Semantic highlighting enabled for all color themes."), m(0, "Semantic highlighting disabled for all color themes."), m(0, "Semantic highlighting is configured by the current color theme's `semanticHighlighting` setting.")], default: "configuredByTheme", description: m(0, "Controls whether the semanticHighlighting is shown for the languages that support it.") }, "editor.stablePeek": { type: "boolean", default: !1, markdownDescription: m(0, "Keep peek editors open even when double-clicking their content or when hitting `Escape`.") }, "editor.maxTokenizationLineLength": { type: "integer", default: 2e4, description: m(0, "Lines above this length will not be tokenized for performance reasons") }, "editor.experimental.asyncTokenization": { type: "boolean", default: !1, description: m(0, "Controls whether the tokenization should happen asynchronously on a web worker."), tags: ["experimental"] }, "editor.experimental.asyncTokenizationLogging": { type: "boolean", default: !1, description: m(0, "Controls whether async tokenization should be logged. For debugging only.") }, "editor.experimental.asyncTokenizationVerification": { type: "boolean", default: !1, description: m(0, "Controls whether async tokenization should be verified against legacy background tokenization. Might slow down tokenization. For debugging only."), tags: ["experimental"] }, "editor.language.brackets": { type: ["array", "null"], default: null, description: m(0, "Defines the bracket symbols that increase or decrease the indentation."), items: { type: "array", items: [{ type: "string", description: m(0, "The opening bracket character or string sequence.") }, { type: "string", description: m(0, "The closing bracket character or string sequence.") }] } }, "editor.language.colorizedBracketPairs": { type: ["array", "null"], default: null, description: m(0, "Defines the bracket pairs that are colorized by their nesting level if bracket pair colorization is enabled."), items: { type: "array", items: [{ type: "string", description: m(0, "The opening bracket character or string sequence.") }, { type: "string", description: m(0, "The closing bracket character or string sequence.") }] } }, "diffEditor.maxComputationTime": { type: "number", default: An.maxComputationTime, description: m(0, "Timeout in milliseconds after which diff computation is cancelled. Use 0 for no timeout.") }, "diffEditor.maxFileSize": { type: "number", default: An.maxFileSize, description: m(0, "Maximum file size in MB for which to compute diffs. Use 0 for no limit.") }, "diffEditor.renderSideBySide": { type: "boolean", default: An.renderSideBySide, description: m(0, "Controls whether the diff editor shows the diff side by side or inline.") }, "diffEditor.renderSideBySideInlineBreakpoint": { type: "number", default: An.renderSideBySideInlineBreakpoint, description: m(0, "If the diff editor width is smaller than this value, the inline view is used.") }, "diffEditor.useInlineViewWhenSpaceIsLimited": { type: "boolean", default: An.useInlineViewWhenSpaceIsLimited, description: m(0, "If enabled and the editor width is too small, the inline view is used.") }, "diffEditor.renderMarginRevertIcon": { type: "boolean", default: An.renderMarginRevertIcon, description: m(0, "When enabled, the diff editor shows arrows in its glyph margin to revert changes.") }, "diffEditor.renderGutterMenu": { type: "boolean", default: An.renderGutterMenu, description: m(0, "When enabled, the diff editor shows a special gutter for revert and stage actions.") }, "diffEditor.ignoreTrimWhitespace": { type: "boolean", default: An.ignoreTrimWhitespace, description: m(0, "When enabled, the diff editor ignores changes in leading or trailing whitespace.") }, "diffEditor.renderIndicators": { type: "boolean", default: An.renderIndicators, description: m(0, "Controls whether the diff editor shows +/- indicators for added/removed changes.") }, "diffEditor.codeLens": { type: "boolean", default: An.diffCodeLens, description: m(0, "Controls whether the editor shows CodeLens.") }, "diffEditor.wordWrap": { type: "string", enum: ["off", "on", "inherit"], default: An.diffWordWrap, markdownEnumDescriptions: [m(0, "Lines will never wrap."), m(0, "Lines will wrap at the viewport width."), m(0, "Lines will wrap according to the {0} setting.", "`#editor.wordWrap#`")] }, "diffEditor.diffAlgorithm": { type: "string", enum: ["legacy", "advanced"], default: An.diffAlgorithm, markdownEnumDescriptions: [m(0, "Uses the legacy diffing algorithm."), m(0, "Uses the advanced diffing algorithm.")], tags: ["experimental"] }, "diffEditor.hideUnchangedRegions.enabled": { type: "boolean", default: An.hideUnchangedRegions.enabled, markdownDescription: m(0, "Controls whether the diff editor shows unchanged regions.") }, "diffEditor.hideUnchangedRegions.revealLineCount": { type: "integer", default: An.hideUnchangedRegions.revealLineCount, markdownDescription: m(0, "Controls how many lines are used for unchanged regions."), minimum: 1 }, "diffEditor.hideUnchangedRegions.minimumLineCount": { type: "integer", default: An.hideUnchangedRegions.minimumLineCount, markdownDescription: m(0, "Controls how many lines are used as a minimum for unchanged regions."), minimum: 1 }, "diffEditor.hideUnchangedRegions.contextLineCount": { type: "integer", default: An.hideUnchangedRegions.contextLineCount, markdownDescription: m(0, "Controls how many lines are used as context when comparing unchanged regions."), minimum: 1 }, "diffEditor.experimental.showMoves": { type: "boolean", default: An.experimental.showMoves, markdownDescription: m(0, "Controls whether the diff editor should show detected code moves.") }, "diffEditor.experimental.showEmptyDecorations": { type: "boolean", default: An.experimental.showEmptyDecorations, description: m(0, "Controls whether the diff editor shows empty decorations to see where characters got inserted or deleted.") } } };
for (const n of yp) {
  const e = n.schema;
  if (e !== void 0) if ((S3 = e).type !== void 0 || S3.anyOf !== void 0) Ny.properties[`editor.${n.name}`] = e;
  else for (const t in e) Object.hasOwnProperty.call(e, t) && (Ny.properties[t] = e[t]);
}
var S3;
let Rb = null;
function L3() {
  return Rb === null && (Rb = /* @__PURE__ */ Object.create(null), Object.keys(Ny.properties).forEach(((n) => {
    Rb[n] = !0;
  }))), Rb;
}
li.as(ma).registerConfiguration(Ny);
class ii {
  static insert(e, t) {
    return { range: new D(e.lineNumber, e.column, e.lineNumber, e.column), text: t, forceMoveMarkers: !0 };
  }
  static delete(e) {
    return { range: e, text: null };
  }
  static replace(e, t) {
    return { range: e, text: t };
  }
  static replaceMove(e, t) {
    return { range: e, text: t, forceMoveMarkers: !0 };
  }
}
function Ab(n) {
  return Object.isFrozen(n) ? n : (function(e) {
    if (!e || typeof e != "object") return e;
    const t = [e];
    for (; t.length > 0; ) {
      const i = t.shift();
      Object.freeze(i);
      for (const s in i) if (_7.call(i, s)) {
        const o = i[s];
        typeof o != "object" || Object.isFrozen(o) || HU(o) || t.push(o);
      }
    }
    return e;
  })(n);
}
class En {
  constructor(e = {}, t = [], i = [], s) {
    this._contents = e, this._keys = t, this._overrides = i, this.raw = s, this.overrideConfigurations = /* @__PURE__ */ new Map();
  }
  get rawConfiguration() {
    var e;
    if (!this._rawConfiguration) if (!((e = this.raw) === null || e === void 0) && e.length) {
      const t = this.raw.map(((i) => {
        if (i instanceof En) return i;
        const s = new aee("");
        return s.parseRaw(i), s.configurationModel;
      }));
      this._rawConfiguration = t.reduce(((i, s) => s === i ? s : i.merge(s)), t[0]);
    } else this._rawConfiguration = this;
    return this._rawConfiguration;
  }
  get contents() {
    return this._contents;
  }
  get overrides() {
    return this._overrides;
  }
  get keys() {
    return this._keys;
  }
  isEmpty() {
    return this._keys.length === 0 && Object.keys(this._contents).length === 0 && this._overrides.length === 0;
  }
  getValue(e) {
    return e ? zO(this.contents, e) : this.contents;
  }
  inspect(e, t) {
    const i = this;
    return { get value() {
      return Ab(i.rawConfiguration.getValue(e));
    }, get override() {
      return t ? Ab(i.rawConfiguration.getOverrideValue(e, t)) : void 0;
    }, get merged() {
      return Ab(t ? i.rawConfiguration.override(t).getValue(e) : i.rawConfiguration.getValue(e));
    }, get overrides() {
      const s = [];
      for (const { contents: o, identifiers: r, keys: a } of i.rawConfiguration.overrides) {
        const l = new En(o, a).getValue(e);
        l !== void 0 && s.push({ identifiers: r, value: l });
      }
      return s.length ? Ab(s) : void 0;
    } };
  }
  getOverrideValue(e, t) {
    const i = this.getContentsForOverrideIdentifer(t);
    return i ? e ? zO(i, e) : i : void 0;
  }
  override(e) {
    let t = this.overrideConfigurations.get(e);
    return t || (t = this.createOverrideConfigurationModel(e), this.overrideConfigurations.set(e, t)), t;
  }
  merge(...e) {
    var t, i;
    const s = Ul(this.contents), o = Ul(this.overrides), r = [...this.keys], a = !((t = this.raw) === null || t === void 0) && t.length ? [...this.raw] : [this];
    for (const l of e) if (a.push(...!((i = l.raw) === null || i === void 0) && i.length ? l.raw : [l]), !l.isEmpty()) {
      this.mergeContents(s, l.contents);
      for (const d of l.overrides) {
        const [h] = o.filter(((c) => ri(c.identifiers, d.identifiers)));
        h ? (this.mergeContents(h.contents, d.contents), h.keys.push(...d.keys), h.keys = Ad(h.keys)) : o.push(Ul(d));
      }
      for (const d of l.keys) r.indexOf(d) === -1 && r.push(d);
    }
    return new En(s, r, o, a.every(((l) => l instanceof En)) ? void 0 : a);
  }
  createOverrideConfigurationModel(e) {
    const t = this.getContentsForOverrideIdentifer(e);
    if (!t || typeof t != "object" || !Object.keys(t).length) return this;
    const i = {};
    for (const s of Ad([...Object.keys(this.contents), ...Object.keys(t)])) {
      let o = this.contents[s];
      const r = t[s];
      r && (typeof o == "object" && typeof r == "object" ? (o = Ul(o), this.mergeContents(o, r)) : o = r), i[s] = o;
    }
    return new En(i, this.keys, this.overrides);
  }
  mergeContents(e, t) {
    for (const i of Object.keys(t)) i in e && ms(e[i]) && ms(t[i]) ? this.mergeContents(e[i], t[i]) : e[i] = Ul(t[i]);
  }
  getContentsForOverrideIdentifer(e) {
    let t = null, i = null;
    const s = (o) => {
      o && (i ? this.mergeContents(i, o) : i = Ul(o));
    };
    for (const o of this.overrides) o.identifiers.length === 1 && o.identifiers[0] === e ? t = o.contents : o.identifiers.includes(e) && s(o.contents);
    return s(t), i;
  }
  toJSON() {
    return { contents: this.contents, overrides: this.overrides, keys: this.keys };
  }
  addValue(e, t) {
    this.updateValue(e, t, !0);
  }
  setValue(e, t) {
    this.updateValue(e, t, !1);
  }
  removeValue(e) {
    const t = this.keys.indexOf(e);
    t !== -1 && (this.keys.splice(t, 1), eq(this.contents, e), yc.test(e) && this.overrides.splice(this.overrides.findIndex(((i) => ri(i.identifiers, Zw(e)))), 1));
  }
  updateValue(e, t, i) {
    W8(this.contents, e, t, ((s) => console.error(s))), (i = i || this.keys.indexOf(e) === -1) && this.keys.push(e), yc.test(e) && this.overrides.push({ identifiers: Zw(e), keys: Object.keys(this.contents[e]), contents: FE(this.contents[e], ((s) => console.error(s))) });
  }
}
class aee {
  constructor(e) {
    this._name = e, this._raw = null, this._configurationModel = null, this._restrictedConfigurations = [];
  }
  get configurationModel() {
    return this._configurationModel || new En();
  }
  parseRaw(e, t) {
    this._raw = e;
    const { contents: i, keys: s, overrides: o, restricted: r, hasExcludedProperties: a } = this.doParseRaw(e, t);
    this._configurationModel = new En(i, s, o, a ? [e] : void 0), this._restrictedConfigurations = r || [];
  }
  doParseRaw(e, t) {
    const i = li.as(ma).getConfigurationProperties(), s = this.filter(e, i, !0, t);
    return { contents: FE(e = s.raw, ((o) => console.error(`Conflict in settings file ${this._name}: ${o}`))), keys: Object.keys(e), overrides: this.toOverrides(e, ((o) => console.error(`Conflict in settings file ${this._name}: ${o}`))), restricted: s.restricted, hasExcludedProperties: s.hasExcludedProperties };
  }
  filter(e, t, i, s) {
    var o, r, a;
    let l = !1;
    if (!s?.scopes && !s?.skipRestricted && !(!((o = s?.exclude) === null || o === void 0) && o.length)) return { raw: e, restricted: [], hasExcludedProperties: l };
    const d = {}, h = [];
    for (const c in e) if (yc.test(c) && i) {
      const u = this.filter(e[c], t, !1, s);
      d[c] = u.raw, l = l || u.hasExcludedProperties, h.push(...u.restricted);
    } else {
      const u = t[c], g = u ? u.scope !== void 0 ? u.scope : 3 : void 0;
      u?.restricted && h.push(c), !((r = s.exclude) === null || r === void 0) && r.includes(c) || !(!((a = s.include) === null || a === void 0) && a.includes(c)) && (g !== void 0 && s.scopes !== void 0 && !s.scopes.includes(g) || s.skipRestricted && u?.restricted) ? l = !0 : d[c] = e[c];
    }
    return { raw: d, restricted: h, hasExcludedProperties: l };
  }
  toOverrides(e, t) {
    const i = [];
    for (const s of Object.keys(e)) if (yc.test(s)) {
      const o = {};
      for (const r in e[s]) o[r] = e[s][r];
      i.push({ identifiers: Zw(s), keys: Object.keys(o), contents: FE(o, t) });
    }
    return i;
  }
}
class lee {
  constructor(e, t, i, s, o, r, a, l, d, h, c, u, g) {
    this.key = e, this.overrides = t, this._value = i, this.overrideIdentifiers = s, this.defaultConfiguration = o, this.policyConfiguration = r, this.applicationConfiguration = a, this.userConfiguration = l, this.localUserConfiguration = d, this.remoteUserConfiguration = h, this.workspaceConfiguration = c, this.folderConfigurationModel = u, this.memoryConfigurationModel = g;
  }
  toInspectValue(e) {
    return e?.value !== void 0 || e?.override !== void 0 || e?.overrides !== void 0 ? e : void 0;
  }
  get userInspectValue() {
    return this._userInspectValue || (this._userInspectValue = this.userConfiguration.inspect(this.key, this.overrides.overrideIdentifier)), this._userInspectValue;
  }
  get user() {
    return this.toInspectValue(this.userInspectValue);
  }
}
class bL {
  constructor(e, t, i, s, o = new En(), r = new En(), a = new Di(), l = new En(), d = new Di()) {
    this._defaultConfiguration = e, this._policyConfiguration = t, this._applicationConfiguration = i, this._localUserConfiguration = s, this._remoteUserConfiguration = o, this._workspaceConfiguration = r, this._folderConfigurations = a, this._memoryConfiguration = l, this._memoryConfigurationByResource = d, this._workspaceConsolidatedConfiguration = null, this._foldersConsolidatedConfigurations = new Di(), this._userConfiguration = null;
  }
  getValue(e, t, i) {
    return this.getConsolidatedConfigurationModel(e, t, i).getValue(e);
  }
  updateValue(e, t, i = {}) {
    let s;
    i.resource ? (s = this._memoryConfigurationByResource.get(i.resource), s || (s = new En(), this._memoryConfigurationByResource.set(i.resource, s))) : s = this._memoryConfiguration, t === void 0 ? s.removeValue(e) : s.setValue(e, t), i.resource || (this._workspaceConsolidatedConfiguration = null);
  }
  inspect(e, t, i) {
    const s = this.getConsolidatedConfigurationModel(e, t, i), o = this.getFolderConfigurationModelForResource(t.resource, i), r = t.resource && this._memoryConfigurationByResource.get(t.resource) || this._memoryConfiguration, a = /* @__PURE__ */ new Set();
    for (const l of s.overrides) for (const d of l.identifiers) s.getOverrideValue(e, d) !== void 0 && a.add(d);
    return new lee(e, t, s.getValue(e), a.size ? [...a] : void 0, this._defaultConfiguration, this._policyConfiguration.isEmpty() ? void 0 : this._policyConfiguration, this.applicationConfiguration.isEmpty() ? void 0 : this.applicationConfiguration, this.userConfiguration, this.localUserConfiguration, this.remoteUserConfiguration, i ? this._workspaceConfiguration : void 0, o || void 0, r);
  }
  get applicationConfiguration() {
    return this._applicationConfiguration;
  }
  get userConfiguration() {
    return this._userConfiguration || (this._userConfiguration = this._remoteUserConfiguration.isEmpty() ? this._localUserConfiguration : this._localUserConfiguration.merge(this._remoteUserConfiguration)), this._userConfiguration;
  }
  get localUserConfiguration() {
    return this._localUserConfiguration;
  }
  get remoteUserConfiguration() {
    return this._remoteUserConfiguration;
  }
  getConsolidatedConfigurationModel(e, t, i) {
    let s = this.getConsolidatedConfigurationModelForResource(t, i);
    return t.overrideIdentifier && (s = s.override(t.overrideIdentifier)), this._policyConfiguration.isEmpty() || this._policyConfiguration.getValue(e) === void 0 || (s = s.merge(this._policyConfiguration)), s;
  }
  getConsolidatedConfigurationModelForResource({ resource: e }, t) {
    let i = this.getWorkspaceConsolidatedConfiguration();
    if (t && e) {
      const s = t.getFolder(e);
      s && (i = this.getFolderConsolidatedConfiguration(s.uri) || i);
      const o = this._memoryConfigurationByResource.get(e);
      o && (i = i.merge(o));
    }
    return i;
  }
  getWorkspaceConsolidatedConfiguration() {
    return this._workspaceConsolidatedConfiguration || (this._workspaceConsolidatedConfiguration = this._defaultConfiguration.merge(this.applicationConfiguration, this.userConfiguration, this._workspaceConfiguration, this._memoryConfiguration)), this._workspaceConsolidatedConfiguration;
  }
  getFolderConsolidatedConfiguration(e) {
    let t = this._foldersConsolidatedConfigurations.get(e);
    if (!t) {
      const i = this.getWorkspaceConsolidatedConfiguration(), s = this._folderConfigurations.get(e);
      s ? (t = i.merge(s), this._foldersConsolidatedConfigurations.set(e, t)) : t = i;
    }
    return t;
  }
  getFolderConfigurationModelForResource(e, t) {
    if (t && e) {
      const i = t.getFolder(e);
      if (i) return this._folderConfigurations.get(i.uri);
    }
  }
  toData() {
    return { defaults: { contents: this._defaultConfiguration.contents, overrides: this._defaultConfiguration.overrides, keys: this._defaultConfiguration.keys }, policy: { contents: this._policyConfiguration.contents, overrides: this._policyConfiguration.overrides, keys: this._policyConfiguration.keys }, application: { contents: this.applicationConfiguration.contents, overrides: this.applicationConfiguration.overrides, keys: this.applicationConfiguration.keys }, user: { contents: this.userConfiguration.contents, overrides: this.userConfiguration.overrides, keys: this.userConfiguration.keys }, workspace: { contents: this._workspaceConfiguration.contents, overrides: this._workspaceConfiguration.overrides, keys: this._workspaceConfiguration.keys }, folders: [...this._folderConfigurations.keys()].reduce(((e, t) => {
      const { contents: i, overrides: s, keys: o } = this._folderConfigurations.get(t);
      return e.push([t, { contents: i, overrides: s, keys: o }]), e;
    }), []) };
  }
  static parse(e) {
    const t = this.parseConfigurationModel(e.defaults), i = this.parseConfigurationModel(e.policy), s = this.parseConfigurationModel(e.application), o = this.parseConfigurationModel(e.user), r = this.parseConfigurationModel(e.workspace), a = e.folders.reduce(((l, d) => (l.set(Ie.revive(d[0]), this.parseConfigurationModel(d[1])), l)), new Di());
    return new bL(t, i, s, o, new En(), r, a, new En(), new Di());
  }
  static parseConfigurationModel(e) {
    return new En(e.contents, e.keys, e.overrides);
  }
}
class dee {
  constructor(e, t, i, s) {
    this.change = e, this.previous = t, this.currentConfiguraiton = i, this.currentWorkspace = s, this._marker = `
`, this._markerCode1 = this._marker.charCodeAt(0), this._markerCode2 = 46, this.affectedKeys = /* @__PURE__ */ new Set(), this._previousConfiguration = void 0;
    for (const o of e.keys) this.affectedKeys.add(o);
    for (const [, o] of e.overrides) for (const r of o) this.affectedKeys.add(r);
    this._affectsConfigStr = this._marker;
    for (const o of this.affectedKeys) this._affectsConfigStr += o + this._marker;
  }
  get previousConfiguration() {
    return !this._previousConfiguration && this.previous && (this._previousConfiguration = bL.parse(this.previous.data)), this._previousConfiguration;
  }
  affectsConfiguration(e, t) {
    var i;
    const s = this._marker + e, o = this._affectsConfigStr.indexOf(s);
    if (o < 0) return !1;
    const r = o + s.length;
    if (r >= this._affectsConfigStr.length) return !1;
    const a = this._affectsConfigStr.charCodeAt(r);
    return a !== this._markerCode1 && a !== this._markerCode2 ? !1 : t ? !So(this.previousConfiguration ? this.previousConfiguration.getValue(e, t, (i = this.previous) === null || i === void 0 ? void 0 : i.workspace) : void 0, this.currentConfiguraiton.getValue(e, t, this.currentWorkspace)) : !0;
  }
}
const Ey = { kind: 0 }, hee = { kind: 1 };
class m0 {
  constructor(e, t, i) {
    var s;
    this._log = i, this._defaultKeybindings = e, this._defaultBoundCommands = /* @__PURE__ */ new Map();
    for (const o of e) {
      const r = o.command;
      r && r.charAt(0) !== "-" && this._defaultBoundCommands.set(r, !0);
    }
    this._map = /* @__PURE__ */ new Map(), this._lookupMap = /* @__PURE__ */ new Map(), this._keybindings = m0.handleRemovals([].concat(e).concat(t));
    for (let o = 0, r = this._keybindings.length; o < r; o++) {
      const a = this._keybindings[o];
      if (a.chords.length === 0) continue;
      const l = (s = a.when) === null || s === void 0 ? void 0 : s.substituteConstants();
      l && l.type === 0 || this._addKeyPress(a.chords[0], a);
    }
  }
  static _isTargetedForRemoval(e, t, i) {
    if (t) {
      for (let s = 0; s < t.length; s++) if (t[s] !== e.chords[s]) return !1;
    }
    return !(i && i.type !== 1 && (!e.when || !(function(s, o) {
      const r = s ? s.substituteConstants() : void 0, a = o ? o.substituteConstants() : void 0;
      return !r && !a || !(!r || !a) && r.equals(a);
    })(i, e.when)));
  }
  static handleRemovals(e) {
    const t = /* @__PURE__ */ new Map();
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e[s];
      if (r.command && r.command.charAt(0) === "-") {
        const a = r.command.substring(1);
        t.has(a) ? t.get(a).push(r) : t.set(a, [r]);
      }
    }
    if (t.size === 0) return e;
    const i = [];
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e[s];
      if (!r.command || r.command.length === 0) {
        i.push(r);
        continue;
      }
      if (r.command.charAt(0) === "-") continue;
      const a = t.get(r.command);
      if (!a || !r.isDefault) {
        i.push(r);
        continue;
      }
      let l = !1;
      for (const d of a) {
        const h = d.when;
        if (this._isTargetedForRemoval(r, d.chords, h)) {
          l = !0;
          break;
        }
      }
      l || i.push(r);
    }
    return i;
  }
  _addKeyPress(e, t) {
    const i = this._map.get(e);
    if (i === void 0) return this._map.set(e, [t]), void this._addToLookupMap(t);
    for (let s = i.length - 1; s >= 0; s--) {
      const o = i[s];
      if (o.command === t.command) continue;
      let r = !0;
      for (let a = 1; a < o.chords.length && a < t.chords.length; a++) if (o.chords[a] !== t.chords[a]) {
        r = !1;
        break;
      }
      r && m0.whenIsEntirelyIncluded(o.when, t.when) && this._removeFromLookupMap(o);
    }
    i.push(t), this._addToLookupMap(t);
  }
  _addToLookupMap(e) {
    if (!e.command) return;
    let t = this._lookupMap.get(e.command);
    t === void 0 ? (t = [e], this._lookupMap.set(e.command, t)) : t.push(e);
  }
  _removeFromLookupMap(e) {
    if (!e.command) return;
    const t = this._lookupMap.get(e.command);
    if (t !== void 0) {
      for (let i = 0, s = t.length; i < s; i++) if (t[i] === e) return void t.splice(i, 1);
    }
  }
  static whenIsEntirelyIncluded(e, t) {
    return !t || t.type === 1 || !(!e || e.type === 1) && AE(e, t);
  }
  getKeybindings() {
    return this._keybindings;
  }
  lookupPrimaryKeybinding(e, t) {
    const i = this._lookupMap.get(e);
    if (i === void 0 || i.length === 0) return null;
    if (i.length === 1) return i[0];
    for (let s = i.length - 1; s >= 0; s--) {
      const o = i[s];
      if (t.contextMatchesRules(o.when)) return o;
    }
    return i[i.length - 1];
  }
  resolve(e, t, i) {
    const s = [...t, i];
    this._log(`| Resolving ${s}`);
    const o = this._map.get(s[0]);
    if (o === void 0) return this._log("\\ No keybinding entries."), Ey;
    let r = null;
    if (s.length < 2) r = o;
    else {
      r = [];
      for (let c = 0, u = o.length; c < u; c++) {
        const g = o[c];
        if (s.length > g.chords.length) continue;
        let p = !0;
        for (let f = 1; f < s.length; f++) if (g.chords[f] !== s[f]) {
          p = !1;
          break;
        }
        p && r.push(g);
      }
    }
    const a = this._findCommand(e, r);
    return a ? s.length < a.chords.length ? (this._log(`\\ From ${r.length} keybinding entries, awaiting ${a.chords.length - s.length} more chord(s), when: ${k3(a.when)}, source: ${D3(a)}.`), hee) : (this._log(`\\ From ${r.length} keybinding entries, matched ${a.command}, when: ${k3(a.when)}, source: ${D3(a)}.`), l = a.command, d = a.commandArgs, h = a.bubble, { kind: 2, commandId: l, commandArgs: d, isBubble: h }) : (this._log(`\\ From ${r.length} keybinding entries, no when clauses matched the context.`), Ey);
    var l, d, h;
  }
  _findCommand(e, t) {
    for (let i = t.length - 1; i >= 0; i--) {
      const s = t[i];
      if (m0._contextMatchesRules(e, s.when)) return s;
    }
    return null;
  }
  static _contextMatchesRules(e, t) {
    return !t || t.evaluate(e);
  }
}
function k3(n) {
  return n ? `${n.serialize()}` : "no when condition";
}
function D3(n) {
  return n.extensionId ? n.isBuiltinExtension ? `built-in extension ${n.extensionId}` : `user extension ${n.extensionId}` : n.isDefault ? "built-in" : "user";
}
const cee = /^(cursor|delete|undo|redo|tab|editor\.action\.clipboard)/;
class uee extends V {
  get onDidUpdateKeybindings() {
    return this._onDidUpdateKeybindings ? this._onDidUpdateKeybindings.event : se.None;
  }
  get inChordMode() {
    return this._currentChords.length > 0;
  }
  constructor(e, t, i, s, o) {
    super(), this._contextKeyService = e, this._commandService = t, this._telemetryService = i, this._notificationService = s, this._logService = o, this._onDidUpdateKeybindings = this._register(new F()), this._currentChords = [], this._currentChordChecker = new cR(), this._currentChordStatusMessage = null, this._ignoreSingleModifiers = Wp.EMPTY, this._currentSingleModifier = null, this._currentSingleModifierClearTimeout = new Dr(), this._currentlyDispatchingCommandId = null, this._logging = !1;
  }
  dispose() {
    super.dispose();
  }
  _log(e) {
    this._logging && this._logService.info(`[KeybindingService]: ${e}`);
  }
  getKeybindings() {
    return this._getResolver().getKeybindings();
  }
  lookupKeybinding(e, t) {
    const i = this._getResolver().lookupPrimaryKeybinding(e, t || this._contextKeyService);
    if (i) return i.resolvedKeybinding;
  }
  dispatchEvent(e, t) {
    return this._dispatch(e, t);
  }
  softDispatch(e, t) {
    this._log("/ Soft dispatching keyboard event");
    const i = this.resolveKeyboardEvent(e);
    if (i.hasMultipleChords()) return console.warn("keyboard event should not be mapped to multiple chords"), Ey;
    const [s] = i.getDispatchChords();
    if (s === null) return this._log("\\ Keyboard event cannot be dispatched"), Ey;
    const o = this._contextKeyService.getContext(t), r = this._currentChords.map((({ keypress: a }) => a));
    return this._getResolver().resolve(o, r, s);
  }
  _scheduleLeaveChordMode() {
    const e = Date.now();
    this._currentChordChecker.cancelAndSet((() => {
      this._documentHasFocus() ? Date.now() - e > 5e3 && this._leaveChordMode() : this._leaveChordMode();
    }), 500);
  }
  _expectAnotherChord(e, t) {
    switch (this._currentChords.push({ keypress: e, label: t }), this._currentChords.length) {
      case 0:
        throw ZT("impossible");
      case 1:
        this._currentChordStatusMessage = this._notificationService.status(m(0, "({0}) was pressed. Waiting for second key of chord...", t));
        break;
      default: {
        const i = this._currentChords.map((({ label: s }) => s)).join(", ");
        this._currentChordStatusMessage = this._notificationService.status(m(0, "({0}) was pressed. Waiting for next key of chord...", i));
      }
    }
    this._scheduleLeaveChordMode(), e0.enabled && e0.disable();
  }
  _leaveChordMode() {
    this._currentChordStatusMessage && (this._currentChordStatusMessage.dispose(), this._currentChordStatusMessage = null), this._currentChordChecker.cancel(), this._currentChords = [], e0.enable();
  }
  _dispatch(e, t) {
    return this._doDispatch(this.resolveKeyboardEvent(e), t, !1);
  }
  _singleModifierDispatch(e, t) {
    const i = this.resolveKeyboardEvent(e), [s] = i.getSingleModifierDispatchChords();
    if (s) return this._ignoreSingleModifiers.has(s) ? (this._log(`+ Ignoring single modifier ${s} due to it being pressed together with other keys.`), this._ignoreSingleModifiers = Wp.EMPTY, this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1) : (this._ignoreSingleModifiers = Wp.EMPTY, this._currentSingleModifier === null ? (this._log(`+ Storing single modifier for possible chord ${s}.`), this._currentSingleModifier = s, this._currentSingleModifierClearTimeout.cancelAndSet((() => {
      this._log("+ Clearing single modifier due to 300ms elapsed."), this._currentSingleModifier = null;
    }), 300), !1) : s === this._currentSingleModifier ? (this._log(`/ Dispatching single modifier chord ${s} ${s}`), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, this._doDispatch(i, t, !0)) : (this._log(`+ Clearing single modifier due to modifier mismatch: ${this._currentSingleModifier} ${s}`), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1));
    const [o] = i.getChords();
    return this._ignoreSingleModifiers = new Wp(o), this._currentSingleModifier !== null && this._log("+ Clearing single modifier due to other key up."), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1;
  }
  _doDispatch(e, t, i = !1) {
    var s;
    let o = !1;
    if (e.hasMultipleChords()) return console.warn("Unexpected keyboard event mapped to multiple chords"), !1;
    let r = null, a = null;
    if (i) {
      const [c] = e.getSingleModifierDispatchChords();
      r = c, a = c ? [c] : [];
    } else [r] = e.getDispatchChords(), a = this._currentChords.map((({ keypress: c }) => c));
    if (r === null) return this._log("\\ Keyboard event cannot be dispatched in keydown phase."), o;
    const l = this._contextKeyService.getContext(t), d = e.getLabel(), h = this._getResolver().resolve(l, a, r);
    switch (h.kind) {
      case 0:
        if (this._logService.trace("KeybindingService#dispatch", d, "[ No matching keybinding ]"), this.inChordMode) {
          const c = this._currentChords.map((({ label: u }) => u)).join(", ");
          this._log(`+ Leaving multi-chord mode: Nothing bound to "${c}, ${d}".`), this._notificationService.status(m(0, "The key combination ({0}, {1}) is not a command.", c, d), { hideAfter: 1e4 }), this._leaveChordMode(), o = !0;
        }
        return o;
      case 1:
        return this._logService.trace("KeybindingService#dispatch", d, "[ Several keybindings match - more chords needed ]"), o = !0, this._expectAnotherChord(r, d), this._log(this._currentChords.length === 1 ? "+ Entering multi-chord mode..." : "+ Continuing multi-chord mode..."), o;
      case 2:
        if (this._logService.trace("KeybindingService#dispatch", d, `[ Will dispatch command ${h.commandId} ]`), h.commandId === null || h.commandId === "") {
          if (this.inChordMode) {
            const c = this._currentChords.map((({ label: u }) => u)).join(", ");
            this._log(`+ Leaving chord mode: Nothing bound to "${c}, ${d}".`), this._notificationService.status(m(0, "The key combination ({0}, {1}) is not a command.", c, d), { hideAfter: 1e4 }), this._leaveChordMode(), o = !0;
          }
        } else {
          this.inChordMode && this._leaveChordMode(), h.isBubble || (o = !0), this._log(`+ Invoking command ${h.commandId}.`), this._currentlyDispatchingCommandId = h.commandId;
          try {
            h.commandArgs === void 0 ? this._commandService.executeCommand(h.commandId).then(void 0, ((c) => this._notificationService.warn(c))) : this._commandService.executeCommand(h.commandId, h.commandArgs).then(void 0, ((c) => this._notificationService.warn(c)));
          } finally {
            this._currentlyDispatchingCommandId = null;
          }
          cee.test(h.commandId) || this._telemetryService.publicLog2("workbenchActionExecuted", { id: h.commandId, from: "keybinding", detail: (s = e.getUserSettingsLabel()) !== null && s !== void 0 ? s : void 0 });
        }
        return o;
    }
  }
  mightProducePrintableCharacter(e) {
    return !e.ctrlKey && !e.metaKey && (e.keyCode >= 31 && e.keyCode <= 56 || e.keyCode >= 21 && e.keyCode <= 30);
  }
}
class Wp {
  constructor(e) {
    this._ctrlKey = !!e && e.ctrlKey, this._shiftKey = !!e && e.shiftKey, this._altKey = !!e && e.altKey, this._metaKey = !!e && e.metaKey;
  }
  has(e) {
    switch (e) {
      case "ctrl":
        return this._ctrlKey;
      case "shift":
        return this._shiftKey;
      case "alt":
        return this._altKey;
      case "meta":
        return this._metaKey;
    }
  }
}
Wp.EMPTY = new Wp(null);
class x3 {
  constructor(e, t, i, s, o, r, a) {
    this._resolvedKeybindingItemBrand = void 0, this.resolvedKeybinding = e, this.chords = e ? WI(e.getDispatchChords()) : [], e && this.chords.length === 0 && (this.chords = WI(e.getSingleModifierDispatchChords())), this.bubble = !!t && t.charCodeAt(0) === 94, this.command = this.bubble ? t.substr(1) : t, this.commandArgs = i, this.when = s, this.isDefault = o, this.extensionId = r, this.isBuiltinExtension = a;
  }
}
function WI(n) {
  const e = [];
  for (let t = 0, i = n.length; t < i; t++) {
    const s = n[t];
    if (!s) return [];
    e.push(s);
  }
  return e;
}
class CL {
  constructor(e, t, i = t) {
    this.modifierLabels = [null], this.modifierLabels[2] = e, this.modifierLabels[1] = t, this.modifierLabels[3] = i;
  }
  toLabel(e, t, i) {
    if (t.length === 0) return null;
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = i(a);
      if (l === null) return null;
      s[o] = fee(a, l, this.modifierLabels[e]);
    }
    return s.join(" ");
  }
}
const DA = new CL({ ctrlKey: "⌃", shiftKey: "⇧", altKey: "⌥", metaKey: "⌘", separator: "" }, { ctrlKey: m(0, "Ctrl"), shiftKey: m(0, "Shift"), altKey: m(0, "Alt"), metaKey: m(0, "Windows"), separator: "+" }, { ctrlKey: m(0, "Ctrl"), shiftKey: m(0, "Shift"), altKey: m(0, "Alt"), metaKey: m(0, "Super"), separator: "+" }), gee = new CL({ ctrlKey: m(0, "Control"), shiftKey: m(0, "Shift"), altKey: m(0, "Option"), metaKey: m(0, "Command"), separator: "+" }, { ctrlKey: m(0, "Control"), shiftKey: m(0, "Shift"), altKey: m(0, "Alt"), metaKey: m(0, "Windows"), separator: "+" }, { ctrlKey: m(0, "Control"), shiftKey: m(0, "Shift"), altKey: m(0, "Alt"), metaKey: m(0, "Super"), separator: "+" }), pee = new CL({ ctrlKey: "Ctrl", shiftKey: "Shift", altKey: "Alt", metaKey: "Cmd", separator: "+" }, { ctrlKey: "Ctrl", shiftKey: "Shift", altKey: "Alt", metaKey: "Super", separator: "+" }), mee = new CL({ ctrlKey: "ctrl", shiftKey: "shift", altKey: "alt", metaKey: "cmd", separator: "+" }, { ctrlKey: "ctrl", shiftKey: "shift", altKey: "alt", metaKey: "win", separator: "+" }, { ctrlKey: "ctrl", shiftKey: "shift", altKey: "alt", metaKey: "meta", separator: "+" });
function fee(n, e, t) {
  if (e === null) return "";
  const i = [];
  return n.ctrlKey && i.push(t.ctrlKey), n.shiftKey && i.push(t.shiftKey), n.altKey && i.push(t.altKey), n.metaKey && i.push(t.metaKey), e !== "" && i.push(e), i.join(t.separator);
}
class _ee extends IK {
  constructor(e, t) {
    if (super(), t.length === 0) throw Yo("chords");
    this._os = e, this._chords = t;
  }
  getLabel() {
    return DA.toLabel(this._os, this._chords, ((e) => this._getLabel(e)));
  }
  getAriaLabel() {
    return gee.toLabel(this._os, this._chords, ((e) => this._getAriaLabel(e)));
  }
  getElectronAccelerator() {
    return this._chords.length > 1 || this._chords[0].isDuplicateModifierCase() ? null : pee.toLabel(this._os, this._chords, ((e) => this._getElectronAccelerator(e)));
  }
  getUserSettingsLabel() {
    return mee.toLabel(this._os, this._chords, ((e) => this._getUserSettingsLabel(e)));
  }
  hasMultipleChords() {
    return this._chords.length > 1;
  }
  getChords() {
    return this._chords.map(((e) => this._getChord(e)));
  }
  _getChord(e) {
    return new EK(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, this._getLabel(e), this._getAriaLabel(e));
  }
  getDispatchChords() {
    return this._chords.map(((e) => this._getChordDispatch(e)));
  }
  getSingleModifierDispatchChords() {
    return this._chords.map(((e) => this._getSingleModifierChordDispatch(e)));
  }
}
class Dv extends _ee {
  constructor(e, t) {
    super(t, e);
  }
  _keyCodeToUILabel(e) {
    if (this._os === 2) switch (e) {
      case 15:
        return "←";
      case 16:
        return "↑";
      case 17:
        return "→";
      case 18:
        return "↓";
    }
    return Yl.toString(e);
  }
  _getLabel(e) {
    return e.isDuplicateModifierCase() ? "" : this._keyCodeToUILabel(e.keyCode);
  }
  _getAriaLabel(e) {
    return e.isDuplicateModifierCase() ? "" : Yl.toString(e.keyCode);
  }
  _getElectronAccelerator(e) {
    return Yl.toElectronAccelerator(e.keyCode);
  }
  _getUserSettingsLabel(e) {
    if (e.isDuplicateModifierCase()) return "";
    const t = Yl.toUserSettingsUS(e.keyCode);
    return t && t.toLowerCase();
  }
  _getChordDispatch(e) {
    return Dv.getDispatchStr(e);
  }
  static getDispatchStr(e) {
    if (e.isModifierKey()) return null;
    let t = "";
    return e.ctrlKey && (t += "ctrl+"), e.shiftKey && (t += "shift+"), e.altKey && (t += "alt+"), e.metaKey && (t += "meta+"), t += Yl.toString(e.keyCode), t;
  }
  _getSingleModifierChordDispatch(e) {
    return e.keyCode !== 5 || e.shiftKey || e.altKey || e.metaKey ? e.keyCode !== 4 || e.ctrlKey || e.altKey || e.metaKey ? e.keyCode !== 6 || e.ctrlKey || e.shiftKey || e.metaKey ? e.keyCode !== 57 || e.ctrlKey || e.shiftKey || e.altKey ? null : "meta" : "alt" : "shift" : "ctrl";
  }
  static _scanCodeToKeyCode(e) {
    const t = tR[e];
    if (t !== -1) return t;
    switch (e) {
      case 10:
        return 31;
      case 11:
        return 32;
      case 12:
        return 33;
      case 13:
        return 34;
      case 14:
        return 35;
      case 15:
        return 36;
      case 16:
        return 37;
      case 17:
        return 38;
      case 18:
        return 39;
      case 19:
        return 40;
      case 20:
        return 41;
      case 21:
        return 42;
      case 22:
        return 43;
      case 23:
        return 44;
      case 24:
        return 45;
      case 25:
        return 46;
      case 26:
        return 47;
      case 27:
        return 48;
      case 28:
        return 49;
      case 29:
        return 50;
      case 30:
        return 51;
      case 31:
        return 52;
      case 32:
        return 53;
      case 33:
        return 54;
      case 34:
        return 55;
      case 35:
        return 56;
      case 36:
        return 22;
      case 37:
        return 23;
      case 38:
        return 24;
      case 39:
        return 25;
      case 40:
        return 26;
      case 41:
        return 27;
      case 42:
        return 28;
      case 43:
        return 29;
      case 44:
        return 30;
      case 45:
        return 21;
      case 51:
        return 88;
      case 52:
        return 86;
      case 53:
        return 92;
      case 54:
        return 94;
      case 55:
        return 93;
      case 56:
        return 0;
      case 57:
        return 85;
      case 58:
        return 95;
      case 59:
        return 91;
      case 60:
        return 87;
      case 61:
        return 89;
      case 62:
        return 90;
      case 106:
        return 97;
    }
    return 0;
  }
  static _toKeyCodeChord(e) {
    if (!e) return null;
    if (e instanceof Od) return e;
    const t = this._scanCodeToKeyCode(e.scanCode);
    return t === 0 ? null : new Od(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, t);
  }
  static resolveKeybinding(e, t) {
    const i = WI(e.chords.map(((s) => this._toKeyCodeChord(s))));
    return i.length > 0 ? [new Dv(i, t)] : [];
  }
}
const $m = tt("labelService"), FW = tt("progressService");
class Nd {
  constructor(e) {
    this.callback = e;
  }
  report(e) {
    this._value = e, this.callback(this._value);
  }
}
Nd.None = Object.freeze({ report() {
} });
const Nc = tt("editorProgressService");
class vee {
  constructor() {
    this._value = "", this._pos = 0;
  }
  reset(e) {
    return this._value = e, this._pos = 0, this;
  }
  next() {
    return this._pos += 1, this;
  }
  hasNext() {
    return this._pos < this._value.length - 1;
  }
  cmp(e) {
    return e.charCodeAt(0) - this._value.charCodeAt(this._pos);
  }
  value() {
    return this._value[this._pos];
  }
}
class bee {
  constructor(e = !0) {
    this._caseSensitive = e;
  }
  reset(e) {
    return this._value = e, this._from = 0, this._to = 0, this.next();
  }
  hasNext() {
    return this._to < this._value.length;
  }
  next() {
    this._from = this._to;
    let e = !0;
    for (; this._to < this._value.length; this._to++)
      if (this._value.charCodeAt(this._to) === 46) {
        if (!e) break;
        this._from++;
      } else e = !1;
    return this;
  }
  cmp(e) {
    return this._caseSensitive ? nR(e, this._value, 0, e.length, this._from, this._to) : g1(e, this._value, 0, e.length, this._from, this._to);
  }
  value() {
    return this._value.substring(this._from, this._to);
  }
}
class Cee {
  constructor(e = !0, t = !0) {
    this._splitOnBackslash = e, this._caseSensitive = t;
  }
  reset(e) {
    this._from = 0, this._to = 0, this._value = e, this._valueLen = e.length;
    for (let t = e.length - 1; t >= 0; t--, this._valueLen--) {
      const i = this._value.charCodeAt(t);
      if (!(i === 47 || this._splitOnBackslash && i === 92)) break;
    }
    return this.next();
  }
  hasNext() {
    return this._to < this._valueLen;
  }
  next() {
    this._from = this._to;
    let e = !0;
    for (; this._to < this._valueLen; this._to++) {
      const t = this._value.charCodeAt(this._to);
      if (t === 47 || this._splitOnBackslash && t === 92) {
        if (!e) break;
        this._from++;
      } else e = !1;
    }
    return this;
  }
  cmp(e) {
    return this._caseSensitive ? nR(e, this._value, 0, e.length, this._from, this._to) : g1(e, this._value, 0, e.length, this._from, this._to);
  }
  value() {
    return this._value.substring(this._from, this._to);
  }
}
class wee {
  constructor(e, t) {
    this._ignorePathCasing = e, this._ignoreQueryAndFragment = t, this._states = [], this._stateIdx = 0;
  }
  reset(e) {
    return this._value = e, this._states = [], this._value.scheme && this._states.push(1), this._value.authority && this._states.push(2), this._value.path && (this._pathIterator = new Cee(!1, !this._ignorePathCasing(e)), this._pathIterator.reset(e.path), this._pathIterator.value() && this._states.push(3)), this._ignoreQueryAndFragment(e) || (this._value.query && this._states.push(4), this._value.fragment && this._states.push(5)), this._stateIdx = 0, this;
  }
  next() {
    return this._states[this._stateIdx] === 3 && this._pathIterator.hasNext() ? this._pathIterator.next() : this._stateIdx += 1, this;
  }
  hasNext() {
    return this._states[this._stateIdx] === 3 && this._pathIterator.hasNext() || this._stateIdx < this._states.length - 1;
  }
  cmp(e) {
    if (this._states[this._stateIdx] === 1) return yE(e, this._value.scheme);
    if (this._states[this._stateIdx] === 2) return yE(e, this._value.authority);
    if (this._states[this._stateIdx] === 3) return this._pathIterator.cmp(e);
    if (this._states[this._stateIdx] === 4) return Y0(e, this._value.query);
    if (this._states[this._stateIdx] === 5) return Y0(e, this._value.fragment);
    throw new Error();
  }
  value() {
    if (this._states[this._stateIdx] === 1) return this._value.scheme;
    if (this._states[this._stateIdx] === 2) return this._value.authority;
    if (this._states[this._stateIdx] === 3) return this._pathIterator.value();
    if (this._states[this._stateIdx] === 4) return this._value.query;
    if (this._states[this._stateIdx] === 5) return this._value.fragment;
    throw new Error();
  }
}
class Pb {
  constructor() {
    this.height = 1;
  }
  rotateLeft() {
    const e = this.right;
    return this.right = e.left, e.left = this, this.updateHeight(), e.updateHeight(), e;
  }
  rotateRight() {
    const e = this.left;
    return this.left = e.right, e.right = this, this.updateHeight(), e.updateHeight(), e;
  }
  updateHeight() {
    this.height = 1 + Math.max(this.heightLeft, this.heightRight);
  }
  balanceFactor() {
    return this.heightRight - this.heightLeft;
  }
  get heightLeft() {
    var e, t;
    return (t = (e = this.left) === null || e === void 0 ? void 0 : e.height) !== null && t !== void 0 ? t : 0;
  }
  get heightRight() {
    var e, t;
    return (t = (e = this.right) === null || e === void 0 ? void 0 : e.height) !== null && t !== void 0 ? t : 0;
  }
}
class pm {
  static forUris(e = (() => !1), t = (() => !1)) {
    return new pm(new wee(e, t));
  }
  static forStrings() {
    return new pm(new vee());
  }
  static forConfigKeys() {
    return new pm(new bee());
  }
  constructor(e) {
    this._iter = e;
  }
  clear() {
    this._root = void 0;
  }
  set(e, t) {
    const i = this._iter.reset(e);
    let s;
    this._root || (this._root = new Pb(), this._root.segment = i.value());
    const o = [];
    for (s = this._root; ; ) {
      const a = i.cmp(s.segment);
      if (a > 0) s.left || (s.left = new Pb(), s.left.segment = i.value()), o.push([-1, s]), s = s.left;
      else if (a < 0) s.right || (s.right = new Pb(), s.right.segment = i.value()), o.push([1, s]), s = s.right;
      else {
        if (!i.hasNext()) break;
        i.next(), s.mid || (s.mid = new Pb(), s.mid.segment = i.value()), o.push([0, s]), s = s.mid;
      }
    }
    const r = s.value;
    s.value = t, s.key = e;
    for (let a = o.length - 1; a >= 0; a--) {
      const l = o[a][1];
      l.updateHeight();
      const d = l.balanceFactor();
      if (d < -1 || d > 1) {
        const h = o[a][0], c = o[a + 1][0];
        if (h === 1 && c === 1) o[a][1] = l.rotateLeft();
        else if (h === -1 && c === -1) o[a][1] = l.rotateRight();
        else if (h === 1 && c === -1) l.right = o[a + 1][1] = o[a + 1][1].rotateRight(), o[a][1] = l.rotateLeft();
        else {
          if (h !== -1 || c !== 1) throw new Error();
          l.left = o[a + 1][1] = o[a + 1][1].rotateLeft(), o[a][1] = l.rotateRight();
        }
        if (a > 0) switch (o[a - 1][0]) {
          case -1:
            o[a - 1][1].left = o[a][1];
            break;
          case 1:
            o[a - 1][1].right = o[a][1];
            break;
          case 0:
            o[a - 1][1].mid = o[a][1];
        }
        else this._root = o[0][1];
      }
    }
    return r;
  }
  get(e) {
    var t;
    return (t = this._getNode(e)) === null || t === void 0 ? void 0 : t.value;
  }
  _getNode(e) {
    const t = this._iter.reset(e);
    let i = this._root;
    for (; i; ) {
      const s = t.cmp(i.segment);
      if (s > 0) i = i.left;
      else if (s < 0) i = i.right;
      else {
        if (!t.hasNext()) break;
        t.next(), i = i.mid;
      }
    }
    return i;
  }
  has(e) {
    const t = this._getNode(e);
    return !(t?.value === void 0 && t?.mid === void 0);
  }
  delete(e) {
    return this._delete(e, !1);
  }
  deleteSuperstr(e) {
    return this._delete(e, !0);
  }
  _delete(e, t) {
    var i;
    const s = this._iter.reset(e), o = [];
    let r = this._root;
    for (; r; ) {
      const a = s.cmp(r.segment);
      if (a > 0) o.push([-1, r]), r = r.left;
      else if (a < 0) o.push([1, r]), r = r.right;
      else {
        if (!s.hasNext()) break;
        s.next(), o.push([0, r]), r = r.mid;
      }
    }
    if (r) {
      if (t ? (r.left = void 0, r.mid = void 0, r.right = void 0, r.height = 1) : (r.key = void 0, r.value = void 0), !r.mid && !r.value) if (r.left && r.right) {
        const a = this._min(r.right);
        if (a.key) {
          const { key: l, value: d, segment: h } = a;
          this._delete(a.key, !1), r.key = l, r.value = d, r.segment = h;
        }
      } else {
        const a = (i = r.left) !== null && i !== void 0 ? i : r.right;
        if (o.length > 0) {
          const [l, d] = o[o.length - 1];
          switch (l) {
            case -1:
              d.left = a;
              break;
            case 0:
              d.mid = a;
              break;
            case 1:
              d.right = a;
          }
        } else this._root = a;
      }
      for (let a = o.length - 1; a >= 0; a--) {
        const l = o[a][1];
        l.updateHeight();
        const d = l.balanceFactor();
        if (d > 1 ? (l.right.balanceFactor() >= 0 || (l.right = l.right.rotateRight()), o[a][1] = l.rotateLeft()) : d < -1 && (l.left.balanceFactor() <= 0 || (l.left = l.left.rotateLeft()), o[a][1] = l.rotateRight()), a > 0) switch (o[a - 1][0]) {
          case -1:
            o[a - 1][1].left = o[a][1];
            break;
          case 1:
            o[a - 1][1].right = o[a][1];
            break;
          case 0:
            o[a - 1][1].mid = o[a][1];
        }
        else this._root = o[0][1];
      }
    }
  }
  _min(e) {
    for (; e.left; ) e = e.left;
    return e;
  }
  findSubstr(e) {
    const t = this._iter.reset(e);
    let i, s = this._root;
    for (; s; ) {
      const o = t.cmp(s.segment);
      if (o > 0) s = s.left;
      else if (o < 0) s = s.right;
      else {
        if (!t.hasNext()) break;
        t.next(), i = s.value || i, s = s.mid;
      }
    }
    return s && s.value || i;
  }
  findSuperstr(e) {
    return this._findSuperstrOrElement(e, !1);
  }
  _findSuperstrOrElement(e, t) {
    const i = this._iter.reset(e);
    let s = this._root;
    for (; s; ) {
      const o = i.cmp(s.segment);
      if (o > 0) s = s.left;
      else if (o < 0) s = s.right;
      else {
        if (!i.hasNext()) return s.mid ? this._entries(s.mid) : t ? s.value : void 0;
        i.next(), s = s.mid;
      }
    }
  }
  forEach(e) {
    for (const [t, i] of this) e(i, t);
  }
  *[Symbol.iterator]() {
    yield* this._entries(this._root);
  }
  _entries(e) {
    const t = [];
    return this._dfsEntries(e, t), t[Symbol.iterator]();
  }
  _dfsEntries(e, t) {
    e && (e.left && this._dfsEntries(e.left, t), e.value && t.push([e.key, e.value]), e.mid && this._dfsEntries(e.mid, t), e.right && this._dfsEntries(e.right, t));
  }
}
const gg = tt("contextService");
function VI(n) {
  const e = n;
  return typeof e?.id == "string" && Ie.isUri(e.uri);
}
function yee(n) {
  const e = n;
  return typeof e?.id == "string" && !VI(n) && !(function(t) {
    const i = t;
    return typeof i?.id == "string" && Ie.isUri(i.configPath);
  })(n);
}
const See = { id: "empty-window" };
class Lee {
  constructor(e, t) {
    this.raw = t, this.uri = e.uri, this.index = e.index, this.name = e.name;
  }
  toJSON() {
    return { uri: this.uri, name: this.name, index: this.index };
  }
}
const kee = "code-workspace";
m(0, "Code Workspace");
const BW = "4064f6ec-cb38-4ad0-af64-ee6467e63c82";
var HI, Iy, zI, My, xv, Ty, UI, KI;
(function(n) {
  n.inspectTokensAction = m(0, "Developer: Inspect Tokens");
})(HI || (HI = {})), (function(n) {
  n.gotoLineActionLabel = m(0, "Go to Line/Column...");
})(Iy || (Iy = {})), (function(n) {
  n.helpQuickAccessActionLabel = m(0, "Show all Quick Access Providers");
})(zI || (zI = {})), (function(n) {
  n.quickCommandActionLabel = m(0, "Command Palette"), n.quickCommandHelp = m(0, "Show And Run Commands");
})(My || (My = {})), (function(n) {
  n.quickOutlineActionLabel = m(0, "Go to Symbol..."), n.quickOutlineByCategoryActionLabel = m(0, "Go to Symbol by Category...");
})(xv || (xv = {})), (function(n) {
  n.editorViewAccessibleLabel = m(0, "Editor content"), n.accessibilityHelpMessage = m(0, "Press Alt+F1 for Accessibility Options.");
})(Ty || (Ty = {})), (function(n) {
  n.toggleHighContrast = m(0, "Toggle High Contrast Theme");
})(UI || (UI = {})), (function(n) {
  n.bulkEditServiceSummary = m(0, "Made {0} edits in {1} files");
})(KI || (KI = {}));
const WW = tt("workspaceTrustManagementService");
let Gm = [], xA = [], VW = [];
function Ob(n, e = !1) {
  (function(t, i, s) {
    const o = (function(r, a) {
      return { id: r.id, mime: r.mime, filename: r.filename, extension: r.extension, filepattern: r.filepattern, firstline: r.firstline, userConfigured: a, filenameLowercase: r.filename ? r.filename.toLowerCase() : void 0, extensionLowercase: r.extension ? r.extension.toLowerCase() : void 0, filepatternLowercase: r.filepattern ? yW(r.filepattern.toLowerCase()) : void 0, filepatternOnPath: !!r.filepattern && r.filepattern.indexOf(Fi.sep) >= 0 };
    })(t, i);
    Gm.push(o), o.userConfigured ? VW.push(o) : xA.push(o), s && !o.userConfigured && Gm.forEach(((r) => {
      r.mime === o.mime || r.userConfigured || (o.extension && r.extension === o.extension && console.warn(`Overwriting extension <<${o.extension}>> to now point to mime <<${o.mime}>>`), o.filename && r.filename === o.filename && console.warn(`Overwriting filename <<${o.filename}>> to now point to mime <<${o.mime}>>`), o.filepattern && r.filepattern === o.filepattern && console.warn(`Overwriting filepattern <<${o.filepattern}>> to now point to mime <<${o.mime}>>`), o.firstline && r.firstline === o.firstline && console.warn(`Overwriting firstline <<${o.firstline}>> to now point to mime <<${o.mime}>>`));
    }));
  })(n, !1, e);
}
function Dee(n, e) {
  return (function(t, i) {
    let s;
    if (t) switch (t.scheme) {
      case Ue.file:
        s = t.fsPath;
        break;
      case Ue.data:
        s = Fh.parseMetaData(t).get(Fh.META_DATA_LABEL);
        break;
      case Ue.vscodeNotebookCell:
        s = void 0;
        break;
      default:
        s = t.path;
    }
    if (!s) return [{ id: "unknown", mime: vi.unknown }];
    s = s.toLowerCase();
    const o = xh(s), r = N3(s, o, VW);
    if (r) return [r, { id: ko, mime: vi.text }];
    const a = N3(s, o, xA);
    if (a) return [a, { id: ko, mime: vi.text }];
    if (i) {
      const l = (function(d) {
        if (lR(d) && (d = d.substr(1)), d.length > 0) for (let h = Gm.length - 1; h >= 0; h--) {
          const c = Gm[h];
          if (!c.firstline) continue;
          const u = d.match(c.firstline);
          if (u && u.length > 0) return c;
        }
      })(i);
      if (l) return [l, { id: ko, mime: vi.text }];
    }
    return [{ id: "unknown", mime: vi.unknown }];
  })(n, e).map(((t) => t.id));
}
function N3(n, e, t) {
  var i;
  let s, o, r;
  for (let a = t.length - 1; a >= 0; a--) {
    const l = t[a];
    if (e === l.filenameLowercase) {
      s = l;
      break;
    }
    if (l.filepattern && (!o || l.filepattern.length > o.filepattern.length)) {
      const d = l.filepatternOnPath ? n : e;
      !((i = l.filepatternLowercase) === null || i === void 0) && i.call(l, d) && (o = l);
    }
    l.extension && (!r || l.extension.length > r.extension.length) && e.endsWith(l.extensionLowercase) && (r = l);
  }
  return s || o || r || void 0;
}
const Fb = Object.prototype.hasOwnProperty, E3 = "vs.editor.nullLanguage";
class xee {
  constructor() {
    this._languageIdToLanguage = [], this._languageToLanguageId = /* @__PURE__ */ new Map(), this._register(E3, 0), this._register(ko, 1), this._nextLanguageId = 2;
  }
  _register(e, t) {
    this._languageIdToLanguage[t] = e, this._languageToLanguageId.set(e, t);
  }
  register(e) {
    if (this._languageToLanguageId.has(e)) return;
    const t = this._nextLanguageId++;
    this._register(e, t);
  }
  encodeLanguageId(e) {
    return this._languageToLanguageId.get(e) || 0;
  }
  decodeLanguageId(e) {
    return this._languageIdToLanguage[e] || E3;
  }
}
class Nv extends V {
  constructor(e = !0, t = !1) {
    super(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, Nv.instanceCount++, this._warnOnOverwrite = t, this.languageIdCodec = new xee(), this._dynamicLanguages = [], this._languages = {}, this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, e && (this._initializeFromRegistry(), this._register(Bm.onDidChangeLanguages(((i) => {
      this._initializeFromRegistry();
    }))));
  }
  dispose() {
    Nv.instanceCount--, super.dispose();
  }
  _initializeFromRegistry() {
    this._languages = {}, this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, Gm = Gm.filter(((t) => t.userConfigured)), xA = [];
    const e = [].concat(Bm.getLanguages()).concat(this._dynamicLanguages);
    this._registerLanguages(e);
  }
  _registerLanguages(e) {
    for (const t of e) this._registerLanguage(t);
    this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, Object.keys(this._languages).forEach(((t) => {
      const i = this._languages[t];
      i.name && (this._nameMap[i.name] = i.identifier), i.aliases.forEach(((s) => {
        this._lowercaseNameMap[s.toLowerCase()] = i.identifier;
      })), i.mimetypes.forEach(((s) => {
        this._mimeTypesMap[s] = i.identifier;
      }));
    })), li.as(ma).registerOverrideIdentifiers(this.getRegisteredLanguageIds()), this._onDidChange.fire();
  }
  _registerLanguage(e) {
    const t = e.id;
    let i;
    Fb.call(this._languages, t) ? i = this._languages[t] : (this.languageIdCodec.register(t), i = { identifier: t, name: null, mimetypes: [], aliases: [], extensions: [], filenames: [], configurationFiles: [], icons: [] }, this._languages[t] = i), this._mergeLanguage(i, e);
  }
  _mergeLanguage(e, t) {
    const i = t.id;
    let s = null;
    if (Array.isArray(t.mimetypes) && t.mimetypes.length > 0 && (e.mimetypes.push(...t.mimetypes), s = t.mimetypes[0]), s || (s = `text/x-${i}`, e.mimetypes.push(s)), Array.isArray(t.extensions)) {
      t.configuration ? e.extensions = t.extensions.concat(e.extensions) : e.extensions = e.extensions.concat(t.extensions);
      for (const l of t.extensions) Ob({ id: i, mime: s, extension: l }, this._warnOnOverwrite);
    }
    if (Array.isArray(t.filenames)) for (const l of t.filenames) Ob({ id: i, mime: s, filename: l }, this._warnOnOverwrite), e.filenames.push(l);
    if (Array.isArray(t.filenamePatterns)) for (const l of t.filenamePatterns) Ob({ id: i, mime: s, filepattern: l }, this._warnOnOverwrite);
    if (typeof t.firstLine == "string" && t.firstLine.length > 0) {
      let l = t.firstLine;
      l.charAt(0) !== "^" && (l = "^" + l);
      try {
        const d = new RegExp(l);
        (o = d).source !== "^" && o.source !== "^$" && o.source !== "$" && o.source !== "^\\s*$" && o.exec("") && o.lastIndex === 0 || Ob({ id: i, mime: s, firstline: d }, this._warnOnOverwrite);
      } catch (d) {
        console.warn(`[${t.id}]: Invalid regular expression \`${l}\`: `, d);
      }
    }
    var o;
    e.aliases.push(i);
    let r = null;
    if (t.aliases !== void 0 && Array.isArray(t.aliases) && (r = t.aliases.length === 0 ? [null] : t.aliases), r !== null) for (const l of r) l && l.length !== 0 && e.aliases.push(l);
    const a = r !== null && r.length > 0;
    if (!(a && r[0] === null)) {
      const l = (a ? r[0] : null) || i;
      !a && e.name || (e.name = l);
    }
    t.configuration && e.configurationFiles.push(t.configuration), t.icon && e.icons.push(t.icon);
  }
  isRegisteredLanguageId(e) {
    return !!e && Fb.call(this._languages, e);
  }
  getRegisteredLanguageIds() {
    return Object.keys(this._languages);
  }
  getLanguageIdByLanguageName(e) {
    const t = e.toLowerCase();
    return Fb.call(this._lowercaseNameMap, t) ? this._lowercaseNameMap[t] : null;
  }
  getLanguageIdByMimeType(e) {
    return e && Fb.call(this._mimeTypesMap, e) ? this._mimeTypesMap[e] : null;
  }
  guessLanguageIdByFilepathOrFirstLine(e, t) {
    return e || t ? Dee(e, t) : [];
  }
}
Nv.instanceCount = 0;
class Ev extends V {
  constructor(e = !1) {
    super(), this._onDidRequestBasicLanguageFeatures = this._register(new F()), this.onDidRequestBasicLanguageFeatures = this._onDidRequestBasicLanguageFeatures.event, this._onDidRequestRichLanguageFeatures = this._register(new F()), this.onDidRequestRichLanguageFeatures = this._onDidRequestRichLanguageFeatures.event, this._onDidChange = this._register(new F({ leakWarningThreshold: 200 })), this.onDidChange = this._onDidChange.event, this._requestedBasicLanguages = /* @__PURE__ */ new Set(), this._requestedRichLanguages = /* @__PURE__ */ new Set(), Ev.instanceCount++, this._registry = this._register(new Nv(!0, e)), this.languageIdCodec = this._registry.languageIdCodec, this._register(this._registry.onDidChange((() => this._onDidChange.fire())));
  }
  dispose() {
    Ev.instanceCount--, super.dispose();
  }
  isRegisteredLanguageId(e) {
    return this._registry.isRegisteredLanguageId(e);
  }
  getLanguageIdByLanguageName(e) {
    return this._registry.getLanguageIdByLanguageName(e);
  }
  getLanguageIdByMimeType(e) {
    return this._registry.getLanguageIdByMimeType(e);
  }
  guessLanguageIdByFilepathOrFirstLine(e, t) {
    return zT(this._registry.guessLanguageIdByFilepathOrFirstLine(e, t), null);
  }
  createById(e) {
    return new I3(this.onDidChange, (() => this._createAndGetLanguageIdentifier(e)));
  }
  createByFilepathOrFirstLine(e, t) {
    return new I3(this.onDidChange, (() => {
      const i = this.guessLanguageIdByFilepathOrFirstLine(e, t);
      return this._createAndGetLanguageIdentifier(i);
    }));
  }
  _createAndGetLanguageIdentifier(e) {
    return e && this.isRegisteredLanguageId(e) || (e = ko), e;
  }
  requestBasicLanguageFeatures(e) {
    this._requestedBasicLanguages.has(e) || (this._requestedBasicLanguages.add(e), this._onDidRequestBasicLanguageFeatures.fire(e));
  }
  requestRichLanguageFeatures(e) {
    this._requestedRichLanguages.has(e) || (this._requestedRichLanguages.add(e), this.requestBasicLanguageFeatures(e), ci.getOrCreate(e), this._onDidRequestRichLanguageFeatures.fire(e));
  }
}
Ev.instanceCount = 0;
class I3 {
  constructor(e, t) {
    this._onDidChangeLanguages = e, this._selector = t, this._listener = null, this._emitter = null, this.languageId = this._selector();
  }
  _dispose() {
    this._listener && (this._listener.dispose(), this._listener = null), this._emitter && (this._emitter.dispose(), this._emitter = null);
  }
  get onDidChange() {
    return this._listener || (this._listener = this._onDidChangeLanguages((() => this._evaluate()))), this._emitter || (this._emitter = new F({ onDidRemoveLastListener: () => {
      this._dispose();
    } })), this._emitter.event;
  }
  _evaluate() {
    var e;
    const t = this._selector();
    t !== this.languageId && (this.languageId = t, (e = this._emitter) === null || e === void 0 || e.fire(this.languageId));
  }
}
const Iv = { RESOURCES: "ResourceURLs", TEXT: vi.text, INTERNAL_URI_LIST: "application/vnd.code.uri-list" };
let wL = () => ({ get delay() {
  return -1;
}, dispose: () => {
}, showHover: () => {
} });
const Nee = new ua((() => wL("mouse", !1))), Eee = new ua((() => wL("element", !1)));
function Bs(n) {
  return n === "element" ? Eee.value : Nee.value;
}
function Zm() {
  return wL("element", !0);
}
class Iee {
  constructor(e, t, i) {
    this.hoverDelegate = e, this.target = t, this.fadeInAnimation = i;
  }
  async update(e, t, i) {
    var s;
    if (this._cancellationTokenSource && (this._cancellationTokenSource.dispose(!0), this._cancellationTokenSource = void 0), this.isDisposed) return;
    let o;
    if (e === void 0 || ps(e) || e instanceof HTMLElement) o = e;
    else if (U0(e.markdown)) {
      this._hoverWidget || this.show(m(0, "Loading..."), t), this._cancellationTokenSource = new Ci();
      const r = this._cancellationTokenSource.token;
      if (o = await e.markdown(r), o === void 0 && (o = e.markdownNotSupportedFallback), this.isDisposed || r.isCancellationRequested) return;
    } else o = (s = e.markdown) !== null && s !== void 0 ? s : e.markdownNotSupportedFallback;
    this.show(o, t, i);
  }
  show(e, t, i) {
    const s = this._hoverWidget;
    if (this.hasContent(e)) {
      const o = { content: e, target: this.target, appearance: { showPointer: this.hoverDelegate.placement === "element", skipFadeInAnimation: !this.fadeInAnimation || !!s }, position: { hoverPosition: 2 }, ...i };
      this._hoverWidget = this.hoverDelegate.showHover(o, t);
    }
    s?.dispose();
  }
  hasContent(e) {
    return !!e && (!da(e) || !!e.value);
  }
  get isDisposed() {
    var e;
    return (e = this._hoverWidget) === null || e === void 0 ? void 0 : e.isDisposed;
  }
  dispose() {
    var e, t;
    (e = this._hoverWidget) === null || e === void 0 || e.dispose(), (t = this._cancellationTokenSource) === null || t === void 0 || t.dispose(!0), this._cancellationTokenSource = void 0;
  }
}
function M3(n, e) {
  for (e = e ?? ke(n).document.body; !n.hasAttribute("custom-hover") && n !== e; ) n = n.parentElement;
  return n;
}
function xr(n, e, t, i) {
  let s, o;
  e.setAttribute("custom-hover", "true"), e.title !== "" && (console.warn("HTML element already has a title attribute, which will conflict with the custom hover. Please remove the title attribute."), console.trace("Stack trace:", e.title), e.title = "");
  const r = (_, v) => {
    var b;
    const C = o !== void 0;
    _ && (o?.dispose(), o = void 0), v && (s?.dispose(), s = void 0), C && ((b = n.onDidHideHover) === null || b === void 0 || b.call(n), o = void 0);
  }, a = (_, v, b) => new Dr((async () => {
    o && !o.isDisposed || (o = new Iee(n, b || e, _ > 0), await o.update(typeof t == "function" ? t() : t, v, i));
  }), _);
  let l = !1;
  const d = K(e, ie.MOUSE_DOWN, (() => {
    l = !0, r(!0, !0);
  }), !0), h = K(e, ie.MOUSE_UP, (() => {
    l = !1;
  }), !0), c = K(e, ie.MOUSE_LEAVE, ((_) => {
    l = !1, r(!1, _.fromElement === e);
  }), !0), u = K(e, ie.MOUSE_OVER, ((_) => {
    if (s) return;
    const v = new G(), b = { targetElements: [e], dispose: () => {
    } };
    if (n.placement === void 0 || n.placement === "mouse") {
      const C = (w) => {
        b.x = w.x + 10, w.target instanceof HTMLElement && M3(w.target, e) !== e && r(!0, !0);
      };
      v.add(K(e, ie.MOUSE_MOVE, C, !0));
    }
    s = v, _.target instanceof HTMLElement && M3(_.target, e) !== e || v.add(a(n.delay, !1, b));
  }), !0), g = () => {
    if (l || s) return;
    const _ = { targetElements: [e], dispose: () => {
    } }, v = new G();
    v.add(K(e, ie.BLUR, (() => r(!0, !0)), !0)), v.add(a(n.delay, !1, _)), s = v;
  };
  let p;
  const f = e.tagName.toLowerCase();
  return f !== "input" && f !== "textarea" && (p = K(e, ie.FOCUS, g, !0)), { show: (_) => {
    r(!1, !0), a(0, _);
  }, hide: () => {
    r(!0, !0);
  }, update: async (_, v) => {
    t = _, await o?.update(t, void 0, v);
  }, dispose: () => {
    u.dispose(), c.dispose(), d.dispose(), h.dispose(), p?.dispose(), r(!0, !0);
  } };
}
class Mee {
  constructor(e) {
    this.spliceables = e;
  }
  splice(e, t, i) {
    this.spliceables.forEach(((s) => s.splice(e, t, i)));
  }
}
class $c extends Error {
  constructor(e, t) {
    super(`ListError [${e}] ${t}`);
  }
}
function T3(n, e) {
  const t = [];
  for (const i of e) {
    if (n.start >= i.range.end) continue;
    if (n.end < i.range.start) break;
    const s = Fn.intersect(n, i.range);
    Fn.isEmpty(s) || t.push({ range: s, size: i.size });
  }
  return t;
}
function jI({ start: n, end: e }, t) {
  return { start: n + t, end: e + t };
}
class Tee {
  get paddingTop() {
    return this._paddingTop;
  }
  set paddingTop(e) {
    this._size = this._size + e - this._paddingTop, this._paddingTop = e;
  }
  constructor(e) {
    this.groups = [], this._size = 0, this._paddingTop = 0, this._paddingTop = e ?? 0, this._size = this._paddingTop;
  }
  splice(e, t, i = []) {
    const s = i.length - t, o = T3({ start: 0, end: e }, this.groups), r = T3({ start: e + t, end: Number.POSITIVE_INFINITY }, this.groups).map(((l) => ({ range: jI(l.range, s), size: l.size }))), a = i.map(((l, d) => ({ range: { start: e + d, end: e + d + 1 }, size: l.size })));
    this.groups = (function(...l) {
      return (function(d) {
        const h = [];
        let c = null;
        for (const u of d) {
          const g = u.range.start, p = u.range.end, f = u.size;
          c && f === c.size ? c.range.end = p : (c = { range: { start: g, end: p }, size: f }, h.push(c));
        }
        return h;
      })(l.reduce(((d, h) => d.concat(h)), []));
    })(o, a, r), this._size = this._paddingTop + this.groups.reduce(((l, d) => l + d.size * (d.range.end - d.range.start)), 0);
  }
  get count() {
    const e = this.groups.length;
    return e ? this.groups[e - 1].range.end : 0;
  }
  get size() {
    return this._size;
  }
  indexAt(e) {
    if (e < 0) return -1;
    if (e < this._paddingTop) return 0;
    let t = 0, i = this._paddingTop;
    for (const s of this.groups) {
      const o = s.range.end - s.range.start, r = i + o * s.size;
      if (e < r) return t + Math.floor((e - i) / s.size);
      t += o, i = r;
    }
    return t;
  }
  indexAfter(e) {
    return Math.min(this.indexAt(e) + 1, this.count);
  }
  positionAt(e) {
    if (e < 0) return -1;
    let t = 0, i = 0;
    for (const s of this.groups) {
      const o = s.range.end - s.range.start, r = i + o;
      if (e < r) return this._paddingTop + t + (e - i) * s.size;
      t += o * s.size, i = r;
    }
    return -1;
  }
}
class Ree {
  constructor(e) {
    this.renderers = e, this.cache = /* @__PURE__ */ new Map(), this.transactionNodesPendingRemoval = /* @__PURE__ */ new Set(), this.inTransaction = !1;
  }
  alloc(e) {
    let t = this.getTemplateCache(e).pop(), i = !1;
    if (t) i = this.transactionNodesPendingRemoval.has(t.domNode), i && this.transactionNodesPendingRemoval.delete(t.domNode);
    else {
      const s = Q(".monaco-list-row");
      t = { domNode: s, templateId: e, templateData: this.getRenderer(e).renderTemplate(s) };
    }
    return { row: t, isReusingConnectedDomNode: i };
  }
  release(e) {
    e && this.releaseRow(e);
  }
  transact(e) {
    if (this.inTransaction) throw new Error("Already in transaction");
    this.inTransaction = !0;
    try {
      e();
    } finally {
      for (const t of this.transactionNodesPendingRemoval) this.doRemoveNode(t);
      this.transactionNodesPendingRemoval.clear(), this.inTransaction = !1;
    }
  }
  releaseRow(e) {
    const { domNode: t, templateId: i } = e;
    t && (this.inTransaction ? this.transactionNodesPendingRemoval.add(t) : this.doRemoveNode(t)), this.getTemplateCache(i).push(e);
  }
  doRemoveNode(e) {
    e.classList.remove("scrolling"), (function(t) {
      var i;
      try {
        (i = t.parentElement) === null || i === void 0 || i.removeChild(t);
      } catch {
      }
    })(e);
  }
  getTemplateCache(e) {
    let t = this.cache.get(e);
    return t || (t = [], this.cache.set(e, t)), t;
  }
  dispose() {
    this.cache.forEach(((e, t) => {
      for (const i of e)
        this.getRenderer(t).disposeTemplate(i.templateData), i.templateData = null;
    })), this.cache.clear(), this.transactionNodesPendingRemoval.clear();
  }
  getRenderer(e) {
    const t = this.renderers.get(e);
    if (!t) throw new Error(`No renderer found for ${e}`);
    return t;
  }
}
var Il = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
};
const Gc = { CurrentDragAndDropData: void 0 }, Na = { useShadows: !0, verticalScrollMode: 1, setRowLineHeight: !0, setRowHeight: !0, supportDynamicHeights: !1, dnd: { getDragElements: (n) => [n], getDragURI: () => null, onDragStart() {
}, onDragOver: () => !1, drop() {
}, dispose() {
} }, horizontalScrolling: !1, transformOptimization: !0, alwaysConsumeMouseWheel: !0 };
class T1 {
  constructor(e) {
    this.elements = e;
  }
  update() {
  }
  getData() {
    return this.elements;
  }
}
class Aee {
  constructor(e) {
    this.elements = e;
  }
  update() {
  }
  getData() {
    return this.elements;
  }
}
class Pee {
  constructor() {
    this.types = [], this.files = [];
  }
  update(e) {
    if (e.types && this.types.splice(0, this.types.length, ...e.types), e.files) {
      this.files.splice(0, this.files.length);
      for (let t = 0; t < e.files.length; t++) {
        const i = e.files.item(t);
        i && (i.size || i.type) && this.files.push(i);
      }
    }
  }
  getData() {
    return { types: this.types, files: this.files };
  }
}
class Oee {
  constructor(e) {
    e?.getSetSize ? this.getSetSize = e.getSetSize.bind(e) : this.getSetSize = (t, i, s) => s, e?.getPosInSet ? this.getPosInSet = e.getPosInSet.bind(e) : this.getPosInSet = (t, i) => i + 1, e?.getRole ? this.getRole = e.getRole.bind(e) : this.getRole = (t) => "listitem", e?.isChecked ? this.isChecked = e.isChecked.bind(e) : this.isChecked = (t) => {
    };
  }
}
class Oo {
  get contentHeight() {
    return this.rangeMap.size;
  }
  get onDidScroll() {
    return this.scrollableElement.onScroll;
  }
  get scrollableElementDomNode() {
    return this.scrollableElement.getDomNode();
  }
  get horizontalScrolling() {
    return this._horizontalScrolling;
  }
  set horizontalScrolling(e) {
    if (e !== this._horizontalScrolling) {
      if (e && this.supportDynamicHeights) throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
      if (this._horizontalScrolling = e, this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling), this._horizontalScrolling) {
        for (const t of this.items) this.measureItemWidth(t);
        this.updateScrollWidth(), this.scrollableElement.setScrollDimensions({ width: qk(this.domNode) }), this.rowsContainer.style.width = `${Math.max(this.scrollWidth || 0, this.renderWidth)}px`;
      } else this.scrollableElementWidthDelayer.cancel(), this.scrollableElement.setScrollDimensions({ width: this.renderWidth, scrollWidth: this.renderWidth }), this.rowsContainer.style.width = "";
    }
  }
  constructor(e, t, i, s = Na) {
    var o, r, a, l, d, h, c, u, g, p, f, _, v;
    if (this.virtualDelegate = t, this.domId = "list_id_" + ++Oo.InstanceCount, this.renderers = /* @__PURE__ */ new Map(), this.renderWidth = 0, this._scrollHeight = 0, this.scrollableElementUpdateDisposable = null, this.scrollableElementWidthDelayer = new Sr(50), this.splicing = !1, this.dragOverAnimationStopDisposable = V.None, this.dragOverMouseY = 0, this.canDrop = !1, this.currentDragFeedbackDisposable = V.None, this.onDragLeaveTimeout = V.None, this.disposables = new G(), this._onDidChangeContentHeight = new F(), this._onDidChangeContentWidth = new F(), this.onDidChangeContentHeight = se.latch(this._onDidChangeContentHeight.event, void 0, this.disposables), this._horizontalScrolling = !1, s.horizontalScrolling && s.supportDynamicHeights) throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
    this.items = [], this.itemId = 0, this.rangeMap = this.createRangeMap((o = s.paddingTop) !== null && o !== void 0 ? o : 0);
    for (const b of i) this.renderers.set(b.templateId, b);
    this.cache = this.disposables.add(new Ree(this.renderers)), this.lastRenderTop = 0, this.lastRenderHeight = 0, this.domNode = document.createElement("div"), this.domNode.className = "monaco-list", this.domNode.classList.add(this.domId), this.domNode.tabIndex = 0, this.domNode.classList.toggle("mouse-support", typeof s.mouseSupport != "boolean" || s.mouseSupport), this._horizontalScrolling = (r = s.horizontalScrolling) !== null && r !== void 0 ? r : Na.horizontalScrolling, this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling), this.paddingBottom = s.paddingBottom === void 0 ? 0 : s.paddingBottom, this.accessibilityProvider = new Oee(s.accessibilityProvider), this.rowsContainer = document.createElement("div"), this.rowsContainer.className = "monaco-list-rows", ((a = s.transformOptimization) !== null && a !== void 0 ? a : Na.transformOptimization) && (this.rowsContainer.style.transform = "translate3d(0px, 0px, 0px)", this.rowsContainer.style.overflow = "hidden", this.rowsContainer.style.contain = "strict"), this.disposables.add(Bt.addTarget(this.rowsContainer)), this.scrollable = this.disposables.add(new _f({ forceIntegerValues: !0, smoothScrollDuration: (l = s.smoothScrolling) !== null && l !== void 0 && l ? 125 : 0, scheduleAtNextAnimationFrame: (b) => Ys(ke(this.domNode), b) })), this.scrollableElement = this.disposables.add(new aL(this.rowsContainer, { alwaysConsumeMouseWheel: (d = s.alwaysConsumeMouseWheel) !== null && d !== void 0 ? d : Na.alwaysConsumeMouseWheel, horizontal: 1, vertical: (h = s.verticalScrollMode) !== null && h !== void 0 ? h : Na.verticalScrollMode, useShadows: (c = s.useShadows) !== null && c !== void 0 ? c : Na.useShadows, mouseWheelScrollSensitivity: s.mouseWheelScrollSensitivity, fastScrollSensitivity: s.fastScrollSensitivity, scrollByPage: s.scrollByPage }, this.scrollable)), this.domNode.appendChild(this.scrollableElement.getDomNode()), e.appendChild(this.domNode), this.scrollableElement.onScroll(this.onScroll, this, this.disposables), this.disposables.add(K(this.rowsContainer, Vt.Change, ((b) => this.onTouchChange(b)))), this.disposables.add(K(this.scrollableElement.getDomNode(), "scroll", ((b) => b.target.scrollTop = 0))), this.disposables.add(K(this.domNode, "dragover", ((b) => this.onDragOver(this.toDragEvent(b))))), this.disposables.add(K(this.domNode, "drop", ((b) => this.onDrop(this.toDragEvent(b))))), this.disposables.add(K(this.domNode, "dragleave", ((b) => this.onDragLeave(this.toDragEvent(b))))), this.disposables.add(K(this.domNode, "dragend", ((b) => this.onDragEnd(b)))), this.setRowLineHeight = (u = s.setRowLineHeight) !== null && u !== void 0 ? u : Na.setRowLineHeight, this.setRowHeight = (g = s.setRowHeight) !== null && g !== void 0 ? g : Na.setRowHeight, this.supportDynamicHeights = (p = s.supportDynamicHeights) !== null && p !== void 0 ? p : Na.supportDynamicHeights, this.dnd = (f = s.dnd) !== null && f !== void 0 ? f : this.disposables.add(Na.dnd), this.layout((_ = s.initialSize) === null || _ === void 0 ? void 0 : _.height, (v = s.initialSize) === null || v === void 0 ? void 0 : v.width);
  }
  updateOptions(e) {
    let t;
    if (e.paddingBottom !== void 0 && (this.paddingBottom = e.paddingBottom, this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight })), e.smoothScrolling !== void 0 && this.scrollable.setSmoothScrollDuration(e.smoothScrolling ? 125 : 0), e.horizontalScrolling !== void 0 && (this.horizontalScrolling = e.horizontalScrolling), e.scrollByPage !== void 0 && (t = { ...t ?? {}, scrollByPage: e.scrollByPage }), e.mouseWheelScrollSensitivity !== void 0 && (t = { ...t ?? {}, mouseWheelScrollSensitivity: e.mouseWheelScrollSensitivity }), e.fastScrollSensitivity !== void 0 && (t = { ...t ?? {}, fastScrollSensitivity: e.fastScrollSensitivity }), t && this.scrollableElement.updateOptions(t), e.paddingTop !== void 0 && e.paddingTop !== this.rangeMap.paddingTop) {
      const i = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), s = e.paddingTop - this.rangeMap.paddingTop;
      this.rangeMap.paddingTop = e.paddingTop, this.render(i, Math.max(0, this.lastRenderTop + s), this.lastRenderHeight, void 0, void 0, !0), this.setScrollTop(this.lastRenderTop), this.eventuallyUpdateScrollDimensions(), this.supportDynamicHeights && this._rerender(this.lastRenderTop, this.lastRenderHeight);
    }
  }
  createRangeMap(e) {
    return new Tee(e);
  }
  splice(e, t, i = []) {
    if (this.splicing) throw new Error("Can't run recursive splices.");
    this.splicing = !0;
    try {
      return this._splice(e, t, i);
    } finally {
      this.splicing = !1, this._onDidChangeContentHeight.fire(this.contentHeight);
    }
  }
  _splice(e, t, i = []) {
    const s = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), o = { start: e, end: e + t }, r = Fn.intersect(s, o), a = /* @__PURE__ */ new Map();
    for (let w = r.end - 1; w >= r.start; w--) {
      const y = this.items[w];
      if (y.dragStartDisposable.dispose(), y.checkedDisposable.dispose(), y.row) {
        let L = a.get(y.templateId);
        L || (L = [], a.set(y.templateId, L));
        const k = this.renderers.get(y.templateId);
        k && k.disposeElement && k.disposeElement(y.element, w, y.row.templateData, y.size), L.push(y.row);
      }
      y.row = null, y.stale = !0;
    }
    const l = { start: e + t, end: this.items.length }, d = Fn.intersect(l, s), h = Fn.relativeComplement(l, s), c = i.map(((w) => ({ id: String(this.itemId++), element: w, templateId: this.virtualDelegate.getTemplateId(w), size: this.virtualDelegate.getHeight(w), width: void 0, hasDynamicHeight: !!this.virtualDelegate.hasDynamicHeight && this.virtualDelegate.hasDynamicHeight(w), lastDynamicHeightWidth: void 0, row: null, uri: void 0, dropTarget: !1, dragStartDisposable: V.None, checkedDisposable: V.None, stale: !1 })));
    let u;
    e === 0 && t >= this.items.length ? (this.rangeMap = this.createRangeMap(this.rangeMap.paddingTop), this.rangeMap.splice(0, 0, c), u = this.items, this.items = c) : (this.rangeMap.splice(e, t, c), u = this.items.splice(e, t, ...c));
    const g = i.length - t, p = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), f = jI(d, g), _ = Fn.intersect(p, f);
    for (let w = _.start; w < _.end; w++) this.updateItemInDOM(this.items[w], w);
    const v = Fn.relativeComplement(f, p);
    for (const w of v) for (let y = w.start; y < w.end; y++) this.removeItemFromDOM(y);
    const b = h.map(((w) => jI(w, g))), C = [{ start: e, end: e + i.length }, ...b].map(((w) => Fn.intersect(p, w))).reverse();
    for (const w of C) for (let y = w.end - 1; y >= w.start; y--) {
      const L = this.items[y], k = a.get(L.templateId), N = k?.pop();
      this.insertItemInDOM(y, N);
    }
    for (const w of a.values()) for (const y of w) this.cache.release(y);
    return this.eventuallyUpdateScrollDimensions(), this.supportDynamicHeights && this._rerender(this.scrollTop, this.renderHeight), u.map(((w) => w.element));
  }
  eventuallyUpdateScrollDimensions() {
    this._scrollHeight = this.contentHeight, this.rowsContainer.style.height = `${this._scrollHeight}px`, this.scrollableElementUpdateDisposable || (this.scrollableElementUpdateDisposable = Ys(ke(this.domNode), (() => {
      this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight }), this.updateScrollWidth(), this.scrollableElementUpdateDisposable = null;
    })));
  }
  eventuallyUpdateScrollWidth() {
    this.horizontalScrolling ? this.scrollableElementWidthDelayer.trigger((() => this.updateScrollWidth())) : this.scrollableElementWidthDelayer.cancel();
  }
  updateScrollWidth() {
    if (!this.horizontalScrolling) return;
    let e = 0;
    for (const t of this.items) t.width !== void 0 && (e = Math.max(e, t.width));
    this.scrollWidth = e, this.scrollableElement.setScrollDimensions({ scrollWidth: e === 0 ? 0 : e + 10 }), this._onDidChangeContentWidth.fire(this.scrollWidth);
  }
  rerender() {
    if (this.supportDynamicHeights) {
      for (const e of this.items) e.lastDynamicHeightWidth = void 0;
      this._rerender(this.lastRenderTop, this.lastRenderHeight);
    }
  }
  get length() {
    return this.items.length;
  }
  get renderHeight() {
    return this.scrollableElement.getScrollDimensions().height;
  }
  get firstVisibleIndex() {
    return this.getRenderRange(this.lastRenderTop, this.lastRenderHeight).start;
  }
  element(e) {
    return this.items[e].element;
  }
  indexOf(e) {
    return this.items.findIndex(((t) => t.element === e));
  }
  domElement(e) {
    const t = this.items[e].row;
    return t && t.domNode;
  }
  elementHeight(e) {
    return this.items[e].size;
  }
  elementTop(e) {
    return this.rangeMap.positionAt(e);
  }
  indexAt(e) {
    return this.rangeMap.indexAt(e);
  }
  indexAfter(e) {
    return this.rangeMap.indexAfter(e);
  }
  layout(e, t) {
    const i = { height: typeof e == "number" ? e : aj(this.domNode) };
    this.scrollableElementUpdateDisposable && (this.scrollableElementUpdateDisposable.dispose(), this.scrollableElementUpdateDisposable = null, i.scrollHeight = this.scrollHeight), this.scrollableElement.setScrollDimensions(i), t !== void 0 && (this.renderWidth = t, this.supportDynamicHeights && this._rerender(this.scrollTop, this.renderHeight)), this.horizontalScrolling && this.scrollableElement.setScrollDimensions({ width: typeof t == "number" ? t : qk(this.domNode) });
  }
  render(e, t, i, s, o, r = !1) {
    const a = this.getRenderRange(t, i), l = Fn.relativeComplement(a, e).reverse(), d = Fn.relativeComplement(e, a);
    if (r) {
      const h = Fn.intersect(e, a);
      for (let c = h.start; c < h.end; c++) this.updateItemInDOM(this.items[c], c);
    }
    this.cache.transact((() => {
      for (const h of d) for (let c = h.start; c < h.end; c++) this.removeItemFromDOM(c);
      for (const h of l) for (let c = h.end - 1; c >= h.start; c--) this.insertItemInDOM(c);
    })), s !== void 0 && (this.rowsContainer.style.left = `-${s}px`), this.rowsContainer.style.top = `-${t}px`, this.horizontalScrolling && o !== void 0 && (this.rowsContainer.style.width = `${Math.max(o, this.renderWidth)}px`), this.lastRenderTop = t, this.lastRenderHeight = i;
  }
  insertItemInDOM(e, t) {
    var i, s, o;
    const r = this.items[e];
    if (!r.row) if (t) r.row = t, r.stale = !0;
    else {
      const c = this.cache.alloc(r.templateId);
      r.row = c.row, r.stale || (r.stale = c.isReusingConnectedDomNode);
    }
    const a = this.accessibilityProvider.getRole(r.element) || "listitem";
    r.row.domNode.setAttribute("role", a);
    const l = this.accessibilityProvider.isChecked(r.element);
    if (typeof l == "boolean") r.row.domNode.setAttribute("aria-checked", String(!!l));
    else if (l) {
      const c = (u) => r.row.domNode.setAttribute("aria-checked", String(!!u));
      c(l.value), r.checkedDisposable = l.onDidChange(c);
    }
    if (r.stale || !r.row.domNode.parentElement) {
      const c = (o = (s = (i = this.items.at(e + 1)) === null || i === void 0 ? void 0 : i.row) === null || s === void 0 ? void 0 : s.domNode) !== null && o !== void 0 ? o : null;
      this.rowsContainer.insertBefore(r.row.domNode, c), r.stale = !1;
    }
    this.updateItemInDOM(r, e);
    const d = this.renderers.get(r.templateId);
    if (!d) throw new Error(`No renderer found for template id ${r.templateId}`);
    d?.renderElement(r.element, e, r.row.templateData, r.size);
    const h = this.dnd.getDragURI(r.element);
    r.dragStartDisposable.dispose(), r.row.domNode.draggable = !!h, h && (r.dragStartDisposable = K(r.row.domNode, "dragstart", ((c) => this.onDragStart(r.element, h, c)))), this.horizontalScrolling && (this.measureItemWidth(r), this.eventuallyUpdateScrollWidth());
  }
  measureItemWidth(e) {
    if (!e.row || !e.row.domNode) return;
    e.row.domNode.style.width = "fit-content", e.width = qk(e.row.domNode);
    const t = ke(e.row.domNode).getComputedStyle(e.row.domNode);
    t.paddingLeft && (e.width += parseFloat(t.paddingLeft)), t.paddingRight && (e.width += parseFloat(t.paddingRight)), e.row.domNode.style.width = "";
  }
  updateItemInDOM(e, t) {
    e.row.domNode.style.top = `${this.elementTop(t)}px`, this.setRowHeight && (e.row.domNode.style.height = `${e.size}px`), this.setRowLineHeight && (e.row.domNode.style.lineHeight = `${e.size}px`), e.row.domNode.setAttribute("data-index", `${t}`), e.row.domNode.setAttribute("data-last-element", t === this.length - 1 ? "true" : "false"), e.row.domNode.setAttribute("data-parity", t % 2 == 0 ? "even" : "odd"), e.row.domNode.setAttribute("aria-setsize", String(this.accessibilityProvider.getSetSize(e.element, t, this.length))), e.row.domNode.setAttribute("aria-posinset", String(this.accessibilityProvider.getPosInSet(e.element, t))), e.row.domNode.setAttribute("id", this.getElementDomId(t)), e.row.domNode.classList.toggle("drop-target", e.dropTarget);
  }
  removeItemFromDOM(e) {
    const t = this.items[e];
    if (t.dragStartDisposable.dispose(), t.checkedDisposable.dispose(), t.row) {
      const i = this.renderers.get(t.templateId);
      i && i.disposeElement && i.disposeElement(t.element, e, t.row.templateData, t.size), this.cache.release(t.row), t.row = null;
    }
    this.horizontalScrolling && this.eventuallyUpdateScrollWidth();
  }
  getScrollTop() {
    return this.scrollableElement.getScrollPosition().scrollTop;
  }
  setScrollTop(e, t) {
    this.scrollableElementUpdateDisposable && (this.scrollableElementUpdateDisposable.dispose(), this.scrollableElementUpdateDisposable = null, this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight })), this.scrollableElement.setScrollPosition({ scrollTop: e, reuseAnimation: t });
  }
  get scrollTop() {
    return this.getScrollTop();
  }
  set scrollTop(e) {
    this.setScrollTop(e);
  }
  get scrollHeight() {
    return this._scrollHeight + (this.horizontalScrolling ? 10 : 0) + this.paddingBottom;
  }
  get onMouseClick() {
    return se.map(this.disposables.add(new st(this.domNode, "click")).event, ((e) => this.toMouseEvent(e)), this.disposables);
  }
  get onMouseDblClick() {
    return se.map(this.disposables.add(new st(this.domNode, "dblclick")).event, ((e) => this.toMouseEvent(e)), this.disposables);
  }
  get onMouseMiddleClick() {
    return se.filter(se.map(this.disposables.add(new st(this.domNode, "auxclick")).event, ((e) => this.toMouseEvent(e)), this.disposables), ((e) => e.browserEvent.button === 1), this.disposables);
  }
  get onMouseDown() {
    return se.map(this.disposables.add(new st(this.domNode, "mousedown")).event, ((e) => this.toMouseEvent(e)), this.disposables);
  }
  get onMouseOver() {
    return se.map(this.disposables.add(new st(this.domNode, "mouseover")).event, ((e) => this.toMouseEvent(e)), this.disposables);
  }
  get onMouseOut() {
    return se.map(this.disposables.add(new st(this.domNode, "mouseout")).event, ((e) => this.toMouseEvent(e)), this.disposables);
  }
  get onContextMenu() {
    return se.any(se.map(this.disposables.add(new st(this.domNode, "contextmenu")).event, ((e) => this.toMouseEvent(e)), this.disposables), se.map(this.disposables.add(new st(this.domNode, Vt.Contextmenu)).event, ((e) => this.toGestureEvent(e)), this.disposables));
  }
  get onTouchStart() {
    return se.map(this.disposables.add(new st(this.domNode, "touchstart")).event, ((e) => this.toTouchEvent(e)), this.disposables);
  }
  get onTap() {
    return se.map(this.disposables.add(new st(this.rowsContainer, Vt.Tap)).event, ((e) => this.toGestureEvent(e)), this.disposables);
  }
  toMouseEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), i = t === void 0 ? void 0 : this.items[t];
    return { browserEvent: e, index: t, element: i && i.element };
  }
  toTouchEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), i = t === void 0 ? void 0 : this.items[t];
    return { browserEvent: e, index: t, element: i && i.element };
  }
  toGestureEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.initialTarget || null), i = t === void 0 ? void 0 : this.items[t];
    return { browserEvent: e, index: t, element: i && i.element };
  }
  toDragEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), i = t === void 0 ? void 0 : this.items[t];
    return { browserEvent: e, index: t, element: i && i.element, sector: this.getTargetSector(e, t) };
  }
  onScroll(e) {
    try {
      const t = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
      this.render(t, e.scrollTop, e.height, e.scrollLeft, e.scrollWidth), this.supportDynamicHeights && this._rerender(e.scrollTop, e.height, e.inSmoothScrolling);
    } catch (t) {
      throw console.error("Got bad scroll event:", e), t;
    }
  }
  onTouchChange(e) {
    e.preventDefault(), e.stopPropagation(), this.scrollTop -= e.translationY;
  }
  onDragStart(e, t, i) {
    var s, o;
    if (!i.dataTransfer) return;
    const r = this.dnd.getDragElements(e);
    if (i.dataTransfer.effectAllowed = "copyMove", i.dataTransfer.setData(Iv.TEXT, t), i.dataTransfer.setDragImage) {
      let a;
      this.dnd.getDragLabel && (a = this.dnd.getDragLabel(r, i)), a === void 0 && (a = String(r.length));
      const l = Q(".monaco-drag-image");
      l.textContent = a;
      const d = ((h) => {
        for (; h && !h.classList.contains("monaco-workbench"); ) h = h.parentElement;
        return h || this.domNode.ownerDocument;
      })(this.domNode);
      d.appendChild(l), i.dataTransfer.setDragImage(l, -10, -10), setTimeout((() => d.removeChild(l)), 0);
    }
    this.domNode.classList.add("dragging"), this.currentDragData = new T1(r), Gc.CurrentDragAndDropData = new Aee(r), (o = (s = this.dnd).onDragStart) === null || o === void 0 || o.call(s, this.currentDragData, i);
  }
  onDragOver(e) {
    var t, i;
    if (e.browserEvent.preventDefault(), this.onDragLeaveTimeout.dispose(), Gc.CurrentDragAndDropData && Gc.CurrentDragAndDropData.getData() === "vscode-ui" || (this.setupDragAndDropScrollTopAnimation(e.browserEvent), !e.browserEvent.dataTransfer)) return !1;
    if (!this.currentDragData) if (Gc.CurrentDragAndDropData) this.currentDragData = Gc.CurrentDragAndDropData;
    else {
      if (!e.browserEvent.dataTransfer.types) return !1;
      this.currentDragData = new Pee();
    }
    const s = this.dnd.onDragOver(this.currentDragData, e.element, e.index, e.sector, e.browserEvent);
    if (this.canDrop = typeof s == "boolean" ? s : s.accept, !this.canDrop) return this.currentDragFeedback = void 0, this.currentDragFeedbackDisposable.dispose(), !1;
    let o;
    e.browserEvent.dataTransfer.dropEffect = typeof s != "boolean" && ((t = s.effect) === null || t === void 0 ? void 0 : t.type) === 0 ? "copy" : "move", o = typeof s != "boolean" && s.feedback ? s.feedback : e.index === void 0 ? [-1] : [e.index], o = Ad(o).filter(((d) => d >= -1 && d < this.length)).sort(((d, h) => d - h)), o = o[0] === -1 ? [-1] : o;
    let r = typeof s != "boolean" && s.effect && s.effect.position ? s.effect.position : "drop-target";
    if (a = this.currentDragFeedback, l = o, (Array.isArray(a) && Array.isArray(l) ? ri(a, l) : a === l) && this.currentDragFeedbackPosition === r) return !0;
    var a, l;
    if (this.currentDragFeedback = o, this.currentDragFeedbackPosition = r, this.currentDragFeedbackDisposable.dispose(), o[0] === -1) this.domNode.classList.add(r), this.rowsContainer.classList.add(r), this.currentDragFeedbackDisposable = ye((() => {
      this.domNode.classList.remove(r), this.rowsContainer.classList.remove(r);
    }));
    else {
      if (o.length > 1 && r !== "drop-target") throw new Error("Can't use multiple feedbacks with position different than 'over'");
      r === "drop-target-after" && o[0] < this.length - 1 && (o[0] += 1, r = "drop-target-before");
      for (const d of o) {
        const h = this.items[d];
        h.dropTarget = !0, (i = h.row) === null || i === void 0 || i.domNode.classList.add(r);
      }
      this.currentDragFeedbackDisposable = ye((() => {
        var d;
        for (const h of o) {
          const c = this.items[h];
          c.dropTarget = !1, (d = c.row) === null || d === void 0 || d.domNode.classList.remove(r);
        }
      }));
    }
    return !0;
  }
  onDragLeave(e) {
    var t, i;
    this.onDragLeaveTimeout.dispose(), this.onDragLeaveTimeout = bc((() => this.clearDragOverFeedback()), 100, this.disposables), this.currentDragData && ((i = (t = this.dnd).onDragLeave) === null || i === void 0 || i.call(t, this.currentDragData, e.element, e.index, e.browserEvent));
  }
  onDrop(e) {
    if (!this.canDrop) return;
    const t = this.currentDragData;
    this.teardownDragAndDropScrollTopAnimation(), this.clearDragOverFeedback(), this.domNode.classList.remove("dragging"), this.currentDragData = void 0, Gc.CurrentDragAndDropData = void 0, t && e.browserEvent.dataTransfer && (e.browserEvent.preventDefault(), t.update(e.browserEvent.dataTransfer), this.dnd.drop(t, e.element, e.index, e.sector, e.browserEvent));
  }
  onDragEnd(e) {
    var t, i;
    this.canDrop = !1, this.teardownDragAndDropScrollTopAnimation(), this.clearDragOverFeedback(), this.domNode.classList.remove("dragging"), this.currentDragData = void 0, Gc.CurrentDragAndDropData = void 0, (i = (t = this.dnd).onDragEnd) === null || i === void 0 || i.call(t, e);
  }
  clearDragOverFeedback() {
    this.currentDragFeedback = void 0, this.currentDragFeedbackPosition = void 0, this.currentDragFeedbackDisposable.dispose(), this.currentDragFeedbackDisposable = V.None;
  }
  setupDragAndDropScrollTopAnimation(e) {
    if (!this.dragOverAnimationDisposable) {
      const t = _8(this.domNode).top;
      this.dragOverAnimationDisposable = (function(i, s) {
        const o = () => {
          s(), r = Ys(i, o);
        };
        let r = Ys(i, o);
        return ye((() => r.dispose()));
      })(ke(this.domNode), this.animateDragAndDropScrollTop.bind(this, t));
    }
    this.dragOverAnimationStopDisposable.dispose(), this.dragOverAnimationStopDisposable = bc((() => {
      this.dragOverAnimationDisposable && (this.dragOverAnimationDisposable.dispose(), this.dragOverAnimationDisposable = void 0);
    }), 1e3, this.disposables), this.dragOverMouseY = e.pageY;
  }
  animateDragAndDropScrollTop(e) {
    if (this.dragOverMouseY === void 0) return;
    const t = this.dragOverMouseY - e, i = this.renderHeight - 35;
    t < 35 ? this.scrollTop += Math.max(-14, Math.floor(0.3 * (t - 35))) : t > i && (this.scrollTop += Math.min(14, Math.floor(0.3 * (t - i))));
  }
  teardownDragAndDropScrollTopAnimation() {
    this.dragOverAnimationStopDisposable.dispose(), this.dragOverAnimationDisposable && (this.dragOverAnimationDisposable.dispose(), this.dragOverAnimationDisposable = void 0);
  }
  getTargetSector(e, t) {
    if (t === void 0) return;
    const i = e.offsetY / this.items[t].size;
    return as(Math.floor(i / 0.25), 0, 3);
  }
  getItemIndexFromEventTarget(e) {
    const t = this.scrollableElement.getDomNode();
    let i = e;
    for (; i instanceof HTMLElement && i !== this.rowsContainer && t.contains(i); ) {
      const s = i.getAttribute("data-index");
      if (s) {
        const o = Number(s);
        if (!isNaN(o)) return o;
      }
      i = i.parentElement;
    }
  }
  getRenderRange(e, t) {
    return { start: this.rangeMap.indexAt(e), end: this.rangeMap.indexAfter(e + t - 1) };
  }
  _rerender(e, t, i) {
    const s = this.getRenderRange(e, t);
    let o, r;
    e === this.elementTop(s.start) ? (o = s.start, r = 0) : s.end - s.start > 1 && (o = s.start + 1, r = this.elementTop(o) - e);
    let a = 0;
    for (; ; ) {
      const l = this.getRenderRange(e, t);
      let d = !1;
      for (let h = l.start; h < l.end; h++) {
        const c = this.probeDynamicHeight(h);
        c !== 0 && this.rangeMap.splice(h, 1, [this.items[h]]), a += c, d = d || c !== 0;
      }
      if (!d) {
        a !== 0 && this.eventuallyUpdateScrollDimensions();
        const h = Fn.relativeComplement(s, l);
        for (const u of h) for (let g = u.start; g < u.end; g++) this.items[g].row && this.removeItemFromDOM(g);
        const c = Fn.relativeComplement(l, s).reverse();
        for (const u of c) for (let g = u.end - 1; g >= u.start; g--) this.insertItemInDOM(g);
        for (let u = l.start; u < l.end; u++) this.items[u].row && this.updateItemInDOM(this.items[u], u);
        if (typeof o == "number") {
          const u = this.scrollable.getFutureScrollPosition().scrollTop - e, g = this.elementTop(o) - r + u;
          this.setScrollTop(g, i);
        }
        return void this._onDidChangeContentHeight.fire(this.contentHeight);
      }
    }
  }
  probeDynamicHeight(e) {
    var t, i, s;
    const o = this.items[e];
    if (this.virtualDelegate.getDynamicHeight) {
      const d = this.virtualDelegate.getDynamicHeight(o.element);
      if (d !== null) {
        const h = o.size;
        return o.size = d, o.lastDynamicHeightWidth = this.renderWidth, d - h;
      }
    }
    if (!o.hasDynamicHeight || o.lastDynamicHeightWidth === this.renderWidth || this.virtualDelegate.hasDynamicHeight && !this.virtualDelegate.hasDynamicHeight(o.element)) return 0;
    const r = o.size;
    if (o.row) return o.row.domNode.style.height = "", o.size = o.row.domNode.offsetHeight, o.size !== 0 || gn(o.row.domNode, ke(o.row.domNode).document.body) || console.warn("Measuring item node that is not in DOM! Add ListView to the DOM before measuring row height!"), o.lastDynamicHeightWidth = this.renderWidth, o.size - r;
    const { row: a } = this.cache.alloc(o.templateId);
    a.domNode.style.height = "", this.rowsContainer.appendChild(a.domNode);
    const l = this.renderers.get(o.templateId);
    if (!l) throw new Kt("Missing renderer for templateId: " + o.templateId);
    return l.renderElement(o.element, e, a.templateData, void 0), o.size = a.domNode.offsetHeight, (t = l.disposeElement) === null || t === void 0 || t.call(l, o.element, e, a.templateData, void 0), (s = (i = this.virtualDelegate).setDynamicHeight) === null || s === void 0 || s.call(i, o.element, o.size), o.lastDynamicHeightWidth = this.renderWidth, this.rowsContainer.removeChild(a.domNode), this.cache.release(a), o.size - r;
  }
  getElementDomId(e) {
    return `${this.domId}_${e}`;
  }
  dispose() {
    var e, t;
    for (const i of this.items) if (i.dragStartDisposable.dispose(), i.checkedDisposable.dispose(), i.row) {
      const s = this.renderers.get(i.row.templateId);
      s && ((e = s.disposeElement) === null || e === void 0 || e.call(s, i.element, -1, i.row.templateData, void 0), s.disposeTemplate(i.row.templateData));
    }
    this.items = [], this.domNode && this.domNode.parentNode && this.domNode.parentNode.removeChild(this.domNode), (t = this.dragOverAnimationDisposable) === null || t === void 0 || t.dispose(), this.disposables.dispose();
  }
}
Oo.InstanceCount = 0, Il([Li], Oo.prototype, "onMouseClick", null), Il([Li], Oo.prototype, "onMouseDblClick", null), Il([Li], Oo.prototype, "onMouseMiddleClick", null), Il([Li], Oo.prototype, "onMouseDown", null), Il([Li], Oo.prototype, "onMouseOver", null), Il([Li], Oo.prototype, "onMouseOut", null), Il([Li], Oo.prototype, "onContextMenu", null), Il([Li], Oo.prototype, "onTouchStart", null), Il([Li], Oo.prototype, "onTap", null);
class va {
  constructor(e, t, i) {
    this.owner = e, this.debugNameSource = t, this.referenceFn = i;
  }
  getDebugName(e) {
    return (function(t, i) {
      var s;
      const o = ZD.get(t);
      if (o) return o;
      const r = (function(a, l) {
        const d = ZD.get(a);
        if (d) return d;
        const h = l.owner ? (function(p) {
          var f;
          const _ = P3.get(p);
          if (_) return _;
          const v = (function(w) {
            const y = w.constructor;
            return y ? y.name : "Object";
          })(p);
          let b = (f = A3.get(v)) !== null && f !== void 0 ? f : 0;
          b++, A3.set(v, b);
          const C = b === 1 ? v : `${v}#${b}`;
          return P3.set(p, C), C;
        })(l.owner) + "." : "";
        let c;
        const u = l.debugNameSource;
        if (u !== void 0) {
          if (typeof u != "function") return h + u;
          if (c = u(), c !== void 0) return h + c;
        }
        const g = l.referenceFn;
        if (g !== void 0 && (c = yL(g), c !== void 0)) return h + c;
        if (l.owner !== void 0) {
          const p = (function(f, _) {
            for (const v in f) if (f[v] === _) return v;
          })(l.owner, a);
          if (p !== void 0) return h + p;
        }
      })(t, i);
      if (r) {
        let a = (s = R3.get(r)) !== null && s !== void 0 ? s : 0;
        a++, R3.set(r, a);
        const l = a === 1 ? r : `${r}#${a}`;
        return ZD.set(t, l), l;
      }
    })(e, this);
  }
}
const R3 = /* @__PURE__ */ new Map(), ZD = /* @__PURE__ */ new WeakMap(), A3 = /* @__PURE__ */ new Map(), P3 = /* @__PURE__ */ new WeakMap();
function yL(n) {
  const e = n.toString(), t = /\/\*\*\s*@description\s*([^*]*)\*\//.exec(e), i = t ? t[1] : void 0;
  return i?.trim();
}
let HW, zW, Bb;
class UW {
  get TChange() {
    return null;
  }
  reportChanges() {
    this.get();
  }
  read(e) {
    return e ? e.readObservable(this) : this.get();
  }
  map(e, t) {
    const i = t === void 0 ? void 0 : e, s = t === void 0 ? e : t;
    return zW({ owner: i, debugName: () => {
      const o = yL(s);
      if (o !== void 0) return o;
      const r = /^\s*\(?\s*([a-zA-Z_$][a-zA-Z_$0-9]*)\s*\)?\s*=>\s*\1(?:\??)\.([a-zA-Z_$][a-zA-Z_$0-9]*)\s*$/.exec(s.toString());
      return r ? `${this.debugName}.${r[2]}` : i ? void 0 : `${this.debugName} (mapped)`;
    } }, ((o) => s(this.read(o), o)));
  }
  recomputeInitiallyAndOnChange(e, t) {
    return e.add(HW(this, t)), this;
  }
}
class R1 extends UW {
  constructor() {
    super(...arguments), this.observers = /* @__PURE__ */ new Set();
  }
  addObserver(e) {
    const t = this.observers.size;
    this.observers.add(e), t === 0 && this.onFirstObserverAdded();
  }
  removeObserver(e) {
    this.observers.delete(e) && this.observers.size === 0 && this.onLastObserverRemoved();
  }
  onFirstObserverAdded() {
  }
  onLastObserverRemoved() {
  }
}
function Tt(n, e) {
  const t = new SL(n, e);
  try {
    n(t);
  } finally {
    t.finish();
  }
}
function qC(n) {
  if (Bb) n(Bb);
  else {
    const e = new SL(n, void 0);
    Bb = e;
    try {
      n(e);
    } finally {
      e.finish(), Bb = void 0;
    }
  }
}
function Mv(n, e, t) {
  n ? e(n) : Tt(e, t);
}
class SL {
  constructor(e, t) {
    var i;
    this._fn = e, this._getDebugName = t, this.updatingObservers = [], (i = void 0) === null || i === void 0 || i.handleBeginTransaction(this);
  }
  getDebugName() {
    return this._getDebugName ? this._getDebugName() : yL(this._fn);
  }
  updateObserver(e, t) {
    this.updatingObservers.push({ observer: e, observable: t }), e.beginUpdate(t);
  }
  finish() {
    var e;
    const t = this.updatingObservers;
    for (let i = 0; i < t.length; i++) {
      const { observer: s, observable: o } = t[i];
      s.endUpdate(o);
    }
    this.updatingObservers = null, (e = void 0) === null || e === void 0 || e.handleEndTransaction();
  }
}
function lt(n, e) {
  return typeof n == "string" ? new qI(void 0, n, e) : new qI(n, void 0, e);
}
class qI extends R1 {
  get debugName() {
    var e;
    return (e = new va(this._owner, this._debugName, void 0).getDebugName(this)) !== null && e !== void 0 ? e : "ObservableValue";
  }
  constructor(e, t, i) {
    super(), this._owner = e, this._debugName = t, this._value = i;
  }
  get() {
    return this._value;
  }
  set(e, t, i) {
    var s;
    if (this._value === e) return;
    let o;
    t || (t = o = new SL((() => {
    }), (() => `Setting ${this.debugName}`)));
    try {
      const r = this._value;
      this._setValue(e), (s = void 0) === null || s === void 0 || s.handleObservableChanged(this, { oldValue: r, newValue: e, change: i, didChange: !0, hadValue: !0 });
      for (const a of this.observers) t.updateObserver(a, this), a.handleChange(this, i);
    } finally {
      o && o.finish();
    }
  }
  toString() {
    return `${this.debugName}: ${this._value}`;
  }
  _setValue(e) {
    this._value = e;
  }
}
function Tv(n, e) {
  return typeof n == "string" ? new O3(void 0, n, e) : new O3(n, void 0, e);
}
class O3 extends qI {
  _setValue(e) {
    this._value !== e && (this._value && this._value.dispose(), this._value = e);
  }
  dispose() {
    var e;
    (e = this._value) === null || e === void 0 || e.dispose();
  }
}
const Ym = (n, e) => n === e;
function Fe(n, e) {
  return e !== void 0 ? new Xm(new va(n, void 0, e), e, void 0, void 0, void 0, Ym) : new Xm(new va(void 0, void 0, n), n, void 0, void 0, void 0, Ym);
}
function mm(n, e) {
  var t;
  return new Xm(new va(n.owner, n.debugName, n.debugReferenceFn), e, void 0, void 0, n.onLastObserverRemoved, (t = n.equalityComparer) !== null && t !== void 0 ? t : Ym);
}
function vf(n, e) {
  let t, i;
  e === void 0 ? (t = n, i = void 0) : (i = n, t = e);
  const s = new G();
  return new Xm(new va(i, void 0, t), ((o) => (s.clear(), t(o, s))), void 0, void 0, (() => s.dispose()), Ym);
}
function Fl(n, e) {
  let t, i;
  e === void 0 ? (t = n, i = void 0) : (i = n, t = e);
  const s = new G();
  return new Xm(new va(i, void 0, t), ((o) => {
    s.clear();
    const r = t(o);
    return r && s.add(r), r;
  }), void 0, void 0, (() => s.dispose()), Ym);
}
(function(n) {
  zW = n;
})(mm);
class Xm extends R1 {
  get debugName() {
    var e;
    return (e = this._debugNameData.getDebugName(this)) !== null && e !== void 0 ? e : "(anonymous)";
  }
  constructor(e, t, i, s, o = void 0, r) {
    var a, l;
    super(), this._debugNameData = e, this._computeFn = t, this.createChangeSummary = i, this._handleChange = s, this._handleLastObserverRemoved = o, this._equalityComparator = r, this.state = 0, this.value = void 0, this.updateCount = 0, this.dependencies = /* @__PURE__ */ new Set(), this.dependenciesToBeRemoved = /* @__PURE__ */ new Set(), this.changeSummary = void 0, this.changeSummary = (a = this.createChangeSummary) === null || a === void 0 ? void 0 : a.call(this), (l = void 0) === null || l === void 0 || l.handleDerivedCreated(this);
  }
  onLastObserverRemoved() {
    var e;
    this.state = 0, this.value = void 0;
    for (const t of this.dependencies) t.removeObserver(this);
    this.dependencies.clear(), (e = this._handleLastObserverRemoved) === null || e === void 0 || e.call(this);
  }
  get() {
    var e;
    if (this.observers.size === 0) {
      const t = this._computeFn(this, (e = this.createChangeSummary) === null || e === void 0 ? void 0 : e.call(this));
      return this.onLastObserverRemoved(), t;
    }
    do {
      if (this.state === 1) {
        for (const t of this.dependencies) if (t.reportChanges(), this.state === 2) break;
      }
      this.state === 1 && (this.state = 3), this._recomputeIfNeeded();
    } while (this.state !== 3);
    return this.value;
  }
  _recomputeIfNeeded() {
    var e, t;
    if (this.state === 3) return;
    const i = this.dependenciesToBeRemoved;
    this.dependenciesToBeRemoved = this.dependencies, this.dependencies = i;
    const s = this.state !== 0, o = this.value;
    this.state = 3;
    const r = this.changeSummary;
    this.changeSummary = (e = this.createChangeSummary) === null || e === void 0 ? void 0 : e.call(this);
    try {
      this.value = this._computeFn(this, r);
    } finally {
      for (const l of this.dependenciesToBeRemoved) l.removeObserver(this);
      this.dependenciesToBeRemoved.clear();
    }
    const a = s && !this._equalityComparator(o, this.value);
    if ((t = void 0) === null || t === void 0 || t.handleDerivedRecomputed(this, { oldValue: o, newValue: this.value, change: void 0, didChange: a, hadValue: s }), a) for (const l of this.observers) l.handleChange(this, void 0);
  }
  toString() {
    return `LazyDerived<${this.debugName}>`;
  }
  beginUpdate(e) {
    this.updateCount++;
    const t = this.updateCount === 1;
    if (this.state === 3 && (this.state = 1, !t)) for (const i of this.observers) i.handlePossibleChange(this);
    if (t) for (const i of this.observers) i.beginUpdate(this);
  }
  endUpdate(e) {
    if (this.updateCount--, this.updateCount === 0) {
      const t = [...this.observers];
      for (const i of t) i.endUpdate(this);
    }
    dg((() => this.updateCount >= 0));
  }
  handlePossibleChange(e) {
    if (this.state === 3 && this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e)) {
      this.state = 1;
      for (const t of this.observers) t.handlePossibleChange(this);
    }
  }
  handleChange(e, t) {
    if (this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e)) {
      const i = !this._handleChange || this._handleChange({ changedObservable: e, change: t, didChange: (o) => o === e }, this.changeSummary), s = this.state === 3;
      if (i && (this.state === 1 || s) && (this.state = 2, s)) for (const o of this.observers) o.handlePossibleChange(this);
    }
  }
  readObservable(e) {
    e.addObserver(this);
    const t = e.get();
    return this.dependencies.add(e), this.dependenciesToBeRemoved.delete(e), t;
  }
  addObserver(e) {
    const t = !this.observers.has(e) && this.updateCount > 0;
    super.addObserver(e), t && e.beginUpdate(this);
  }
  removeObserver(e) {
    const t = this.observers.has(e) && this.updateCount > 0;
    super.removeObserver(e), t && e.endUpdate(this);
  }
}
function Ge(n) {
  return new kL(new va(void 0, void 0, n), n, void 0, void 0);
}
function LL(n, e) {
  var t;
  return new kL(new va(n.owner, n.debugName, (t = n.debugReferenceFn) !== null && t !== void 0 ? t : e), e, void 0, void 0);
}
function A1(n, e) {
  var t;
  return new kL(new va(n.owner, n.debugName, (t = n.debugReferenceFn) !== null && t !== void 0 ? t : e), e, n.createEmptyChangeSummary, n.handleChange);
}
function nr(n) {
  const e = new G(), t = LL({ owner: void 0, debugName: void 0, debugReferenceFn: n }, ((i) => {
    e.clear(), n(i, e);
  }));
  return ye((() => {
    t.dispose(), e.dispose();
  }));
}
class kL {
  get debugName() {
    var e;
    return (e = this._debugNameData.getDebugName(this)) !== null && e !== void 0 ? e : "(anonymous)";
  }
  constructor(e, t, i, s) {
    var o, r;
    this._debugNameData = e, this._runFn = t, this.createChangeSummary = i, this._handleChange = s, this.state = 2, this.updateCount = 0, this.disposed = !1, this.dependencies = /* @__PURE__ */ new Set(), this.dependenciesToBeRemoved = /* @__PURE__ */ new Set(), this.changeSummary = (o = this.createChangeSummary) === null || o === void 0 ? void 0 : o.call(this), (r = void 0) === null || r === void 0 || r.handleAutorunCreated(this), this._runIfNeeded();
  }
  dispose() {
    this.disposed = !0;
    for (const e of this.dependencies) e.removeObserver(this);
    this.dependencies.clear();
  }
  _runIfNeeded() {
    var e, t, i;
    if (this.state === 3) return;
    const s = this.dependenciesToBeRemoved;
    this.dependenciesToBeRemoved = this.dependencies, this.dependencies = s, this.state = 3;
    const o = this.disposed;
    try {
      if (!o) {
        (e = void 0) === null || e === void 0 || e.handleAutorunTriggered(this);
        const r = this.changeSummary;
        this.changeSummary = (t = this.createChangeSummary) === null || t === void 0 ? void 0 : t.call(this), this._runFn(this, r);
      }
    } finally {
      o || (i = void 0) === null || i === void 0 || i.handleAutorunFinished(this);
      for (const r of this.dependenciesToBeRemoved) r.removeObserver(this);
      this.dependenciesToBeRemoved.clear();
    }
  }
  toString() {
    return `Autorun<${this.debugName}>`;
  }
  beginUpdate() {
    this.state === 3 && (this.state = 1), this.updateCount++;
  }
  endUpdate() {
    if (this.updateCount === 1) do {
      if (this.state === 1) {
        this.state = 3;
        for (const e of this.dependencies) if (e.reportChanges(), this.state === 2) break;
      }
      this._runIfNeeded();
    } while (this.state !== 3);
    this.updateCount--, dg((() => this.updateCount >= 0));
  }
  handlePossibleChange(e) {
    this.state === 3 && this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e) && (this.state = 1);
  }
  handleChange(e, t) {
    this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e) && (!this._handleChange || this._handleChange({ changedObservable: e, change: t, didChange: (i) => i === e }, this.changeSummary)) && (this.state = 2);
  }
  readObservable(e) {
    if (this.disposed) return e.get();
    e.addObserver(this);
    const t = e.get();
    return this.dependencies.add(e), this.dependenciesToBeRemoved.delete(e), t;
  }
}
function ia(n) {
  return new Fee(n);
}
(function(n) {
  n.Observer = kL;
})(Ge || (Ge = {}));
class Fee extends UW {
  constructor(e) {
    super(), this.value = e;
  }
  get debugName() {
    return this.toString();
  }
  get() {
    return this.value;
  }
  addObserver(e) {
  }
  removeObserver(e) {
  }
  toString() {
    return `Const: ${this.value}`;
  }
}
function Rt(n, e) {
  return new Tu(n, e);
}
class Tu extends R1 {
  constructor(e, t) {
    super(), this.event = e, this._getValue = t, this.hasValue = !1, this.handleEvent = (i) => {
      var s;
      const o = this._getValue(i), r = this.value, a = !this.hasValue || r !== o;
      let l = !1;
      a && (this.value = o, this.hasValue && (l = !0, Mv(Tu.globalTransaction, ((d) => {
        var h;
        (h = void 0) === null || h === void 0 || h.handleFromEventObservableTriggered(this, { oldValue: r, newValue: o, change: void 0, didChange: a, hadValue: this.hasValue });
        for (const c of this.observers) d.updateObserver(c, this), c.handleChange(this, void 0);
      }), (() => {
        const d = this.getDebugName();
        return "Event fired" + (d ? `: ${d}` : "");
      }))), this.hasValue = !0), l || (s = void 0) === null || s === void 0 || s.handleFromEventObservableTriggered(this, { oldValue: r, newValue: o, change: void 0, didChange: a, hadValue: this.hasValue });
    };
  }
  getDebugName() {
    return yL(this._getValue);
  }
  get debugName() {
    const e = this.getDebugName();
    return "From Event" + (e ? `: ${e}` : "");
  }
  onFirstObserverAdded() {
    this.subscription = this.event(this.handleEvent);
  }
  onLastObserverRemoved() {
    this.subscription.dispose(), this.subscription = void 0, this.hasValue = !1, this.value = void 0;
  }
  get() {
    return this.subscription ? (this.hasValue || this.handleEvent(void 0), this.value) : this._getValue(void 0);
  }
}
function Hn(n, e) {
  return new Bee(n, e);
}
(function(n) {
  n.Observer = Tu, n.batchEventsGlobally = function(e, t) {
    let i = !1;
    Tu.globalTransaction === void 0 && (Tu.globalTransaction = e, i = !0);
    try {
      t();
    } finally {
      i && (Tu.globalTransaction = void 0);
    }
  };
})(Rt || (Rt = {}));
class Bee extends R1 {
  constructor(e, t) {
    super(), this.debugName = e, this.event = t, this.handleEvent = () => {
      Tt(((i) => {
        for (const s of this.observers) i.updateObserver(s, this), s.handleChange(this, void 0);
      }), (() => this.debugName));
    };
  }
  onFirstObserverAdded() {
    this.subscription = this.event(this.handleEvent);
  }
  onLastObserverRemoved() {
    this.subscription.dispose(), this.subscription = void 0;
  }
  get() {
  }
}
function DL(n) {
  return typeof n == "string" ? new F3(n) : new F3(void 0, n);
}
class F3 extends R1 {
  get debugName() {
    var e;
    return (e = new va(this._owner, this._debugName, void 0).getDebugName(this)) !== null && e !== void 0 ? e : "Observable Signal";
  }
  constructor(e, t) {
    super(), this._debugName = e, this._owner = t;
  }
  trigger(e, t) {
    if (e) for (const i of this.observers) e.updateObserver(i, this), i.handleChange(this, t);
    else Tt(((i) => {
      this.trigger(i, t);
    }), (() => `Trigger signal ${this.debugName}`));
  }
  get() {
  }
}
function P1(n, e) {
  const t = new Wee(!0, e);
  return n.addObserver(t), e ? e(n.get()) : n.reportChanges(), ye((() => {
    n.removeObserver(t);
  }));
}
(function(n) {
  HW = n;
})(P1);
class Wee {
  constructor(e, t) {
    this._forceRecompute = e, this._handleValue = t, this._counter = 0;
  }
  beginUpdate(e) {
    this._counter++;
  }
  endUpdate(e) {
    this._counter--, this._counter === 0 && this._forceRecompute && (this._handleValue ? this._handleValue(e.get()) : e.reportChanges());
  }
  handlePossibleChange(e) {
  }
  handleChange(e, t) {
  }
}
class B3 {
  constructor(e, t) {
    this._map = e, this._keySelector = t, this._cache = /* @__PURE__ */ new Map(), this._items = [];
  }
  dispose() {
    this._cache.forEach(((e) => e.store.dispose())), this._cache.clear();
  }
  setItems(e) {
    const t = [], i = new Set(this._cache.keys());
    for (const s of e) {
      const o = this._keySelector ? this._keySelector(s) : s;
      let r = this._cache.get(o);
      if (r) i.delete(o);
      else {
        const a = new G();
        r = { out: this._map(s, a), store: a }, this._cache.set(o, r);
      }
      t.push(r.out);
    }
    for (const s of i)
      this._cache.get(s).store.dispose(), this._cache.delete(s);
    this._items = t;
  }
  getItems() {
    return this._items;
  }
}
var gh = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
};
class Vee {
  constructor(e) {
    this.trait = e, this.renderedElements = [];
  }
  get templateId() {
    return `template:${this.trait.name}`;
  }
  renderTemplate(e) {
    return e;
  }
  renderElement(e, t, i) {
    const s = this.renderedElements.findIndex(((o) => o.templateData === i));
    if (s >= 0) {
      const o = this.renderedElements[s];
      this.trait.unrender(i), o.index = t;
    } else {
      const o = { index: t, templateData: i };
      this.renderedElements.push(o);
    }
    this.trait.renderIndex(t, i);
  }
  splice(e, t, i) {
    const s = [];
    for (const o of this.renderedElements) o.index < e ? s.push(o) : o.index >= e + t && s.push({ index: o.index + i - t, templateData: o.templateData });
    this.renderedElements = s;
  }
  renderIndexes(e) {
    for (const { index: t, templateData: i } of this.renderedElements) e.indexOf(t) > -1 && this.trait.renderIndex(t, i);
  }
  disposeTemplate(e) {
    const t = this.renderedElements.findIndex(((i) => i.templateData === e));
    t < 0 || this.renderedElements.splice(t, 1);
  }
}
let Ry = class {
  get name() {
    return this._trait;
  }
  get renderer() {
    return new Vee(this);
  }
  constructor(n) {
    this._trait = n, this.indexes = [], this.sortedIndexes = [], this._onChange = new F(), this.onChange = this._onChange.event;
  }
  splice(n, e, t) {
    const i = t.length - e, s = n + e, o = [];
    let r = 0;
    for (; r < this.sortedIndexes.length && this.sortedIndexes[r] < n; ) o.push(this.sortedIndexes[r++]);
    for (let a = 0; a < t.length; a++) t[a] && o.push(a + n);
    for (; r < this.sortedIndexes.length && this.sortedIndexes[r] >= s; ) o.push(this.sortedIndexes[r++] + i);
    this.renderer.splice(n, e, t.length), this._set(o, o);
  }
  renderIndex(n, e) {
    e.classList.toggle(this._trait, this.contains(n));
  }
  unrender(n) {
    n.classList.remove(this._trait);
  }
  set(n, e) {
    return this._set(n, [...n].sort(V3), e);
  }
  _set(n, e, t) {
    const i = this.indexes, s = this.sortedIndexes;
    this.indexes = n, this.sortedIndexes = e;
    const o = $I(s, n);
    return this.renderer.renderIndexes(o), this._onChange.fire({ indexes: n, browserEvent: t }), i;
  }
  get() {
    return this.indexes;
  }
  contains(n) {
    return H0(this.sortedIndexes, n, V3) >= 0;
  }
  dispose() {
    Ht(this._onChange);
  }
};
gh([Li], Ry.prototype, "renderer", null);
class Hee extends Ry {
  constructor(e) {
    super("selected"), this.setAriaSelected = e;
  }
  renderIndex(e, t) {
    super.renderIndex(e, t), this.setAriaSelected && (this.contains(e) ? t.setAttribute("aria-selected", "true") : t.setAttribute("aria-selected", "false"));
  }
}
class YD {
  constructor(e, t, i) {
    this.trait = e, this.view = t, this.identityProvider = i;
  }
  splice(e, t, i) {
    if (!this.identityProvider) return this.trait.splice(e, t, new Array(i.length).fill(!1));
    const s = this.trait.get().map(((a) => this.identityProvider.getId(this.view.element(a)).toString()));
    if (s.length === 0) return this.trait.splice(e, t, new Array(i.length).fill(!1));
    const o = new Set(s), r = i.map(((a) => o.has(this.identityProvider.getId(a).toString())));
    this.trait.splice(e, t, r);
  }
}
function nc(n) {
  return n.tagName === "INPUT" || n.tagName === "TEXTAREA";
}
function Rv(n, e) {
  return !!n.classList.contains(e) || !n.classList.contains("monaco-list") && !!n.parentElement && Rv(n.parentElement, e);
}
function E_(n) {
  return Rv(n, "monaco-editor");
}
function f0(n) {
  return Rv(n, "monaco-tree-sticky-row");
}
function Av(n) {
  return n.classList.contains("monaco-tree-sticky-container");
}
function KW(n) {
  return !!(n.tagName === "A" && n.classList.contains("monaco-button") || n.tagName === "DIV" && n.classList.contains("monaco-button-dropdown")) || !n.classList.contains("monaco-list") && !!n.parentElement && KW(n.parentElement);
}
class jW {
  get onKeyDown() {
    return se.chain(this.disposables.add(new st(this.view.domNode, "keydown")).event, ((e) => e.filter(((t) => !nc(t.target))).map(((t) => new jt(t)))));
  }
  constructor(e, t, i) {
    this.list = e, this.view = t, this.disposables = new G(), this.multipleSelectionDisposables = new G(), this.multipleSelectionSupport = i.multipleSelectionSupport, this.disposables.add(this.onKeyDown(((s) => {
      switch (s.keyCode) {
        case 3:
          return this.onEnter(s);
        case 16:
          return this.onUpArrow(s);
        case 18:
          return this.onDownArrow(s);
        case 11:
          return this.onPageUpArrow(s);
        case 12:
          return this.onPageDownArrow(s);
        case 9:
          return this.onEscape(s);
        case 31:
          this.multipleSelectionSupport && (Je ? s.metaKey : s.ctrlKey) && this.onCtrlA(s);
      }
    })));
  }
  updateOptions(e) {
    e.multipleSelectionSupport !== void 0 && (this.multipleSelectionSupport = e.multipleSelectionSupport);
  }
  onEnter(e) {
    e.preventDefault(), e.stopPropagation(), this.list.setSelection(this.list.getFocus(), e.browserEvent);
  }
  onUpArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusPrevious(1, !1, e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onDownArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusNext(1, !1, e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onPageUpArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusPreviousPage(e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onPageDownArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusNextPage(e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onCtrlA(e) {
    e.preventDefault(), e.stopPropagation(), this.list.setSelection(Ds(this.list.length), e.browserEvent), this.list.setAnchor(void 0), this.view.domNode.focus();
  }
  onEscape(e) {
    this.list.getSelection().length && (e.preventDefault(), e.stopPropagation(), this.list.setSelection([], e.browserEvent), this.list.setAnchor(void 0), this.view.domNode.focus());
  }
  dispose() {
    this.disposables.dispose(), this.multipleSelectionDisposables.dispose();
  }
}
var Xa, Vp;
gh([Li], jW.prototype, "onKeyDown", null), (function(n) {
  n[n.Automatic = 0] = "Automatic", n[n.Trigger = 1] = "Trigger";
})(Xa || (Xa = {})), (function(n) {
  n[n.Idle = 0] = "Idle", n[n.Typing = 1] = "Typing";
})(Vp || (Vp = {}));
const zee = new class {
  mightProducePrintableCharacter(n) {
    return !(n.ctrlKey || n.metaKey || n.altKey) && (n.keyCode >= 31 && n.keyCode <= 56 || n.keyCode >= 21 && n.keyCode <= 30 || n.keyCode >= 98 && n.keyCode <= 107 || n.keyCode >= 85 && n.keyCode <= 95);
  }
}();
class Uee {
  constructor(e, t, i, s, o) {
    this.list = e, this.view = t, this.keyboardNavigationLabelProvider = i, this.keyboardNavigationEventFilter = s, this.delegate = o, this.enabled = !1, this.state = Vp.Idle, this.mode = Xa.Automatic, this.triggered = !1, this.previouslyFocused = -1, this.enabledDisposables = new G(), this.disposables = new G(), this.updateOptions(e.options);
  }
  updateOptions(e) {
    var t, i;
    (t = e.typeNavigationEnabled) === null || t === void 0 || t ? this.enable() : this.disable(), this.mode = (i = e.typeNavigationMode) !== null && i !== void 0 ? i : Xa.Automatic;
  }
  enable() {
    if (this.enabled) return;
    let e = !1;
    const t = se.chain(this.enabledDisposables.add(new st(this.view.domNode, "keydown")).event, ((s) => s.filter(((o) => !nc(o.target))).filter((() => this.mode === Xa.Automatic || this.triggered)).map(((o) => new jt(o))).filter(((o) => e || this.keyboardNavigationEventFilter(o))).filter(((o) => this.delegate.mightProducePrintableCharacter(o))).forEach(((o) => Ze(o, !0))).map(((o) => o.browserEvent.key)))), i = se.debounce(t, (() => null), 800, void 0, void 0, void 0, this.enabledDisposables);
    se.reduce(se.any(t, i), ((s, o) => o === null ? null : (s || "") + o), void 0, this.enabledDisposables)(this.onInput, this, this.enabledDisposables), i(this.onClear, this, this.enabledDisposables), t((() => e = !0), void 0, this.enabledDisposables), i((() => e = !1), void 0, this.enabledDisposables), this.enabled = !0, this.triggered = !1;
  }
  disable() {
    this.enabled && (this.enabledDisposables.clear(), this.enabled = !1, this.triggered = !1);
  }
  onClear() {
    var e;
    const t = this.list.getFocus();
    if (t.length > 0 && t[0] === this.previouslyFocused) {
      const i = (e = this.list.options.accessibilityProvider) === null || e === void 0 ? void 0 : e.getAriaLabel(this.list.element(t[0]));
      typeof i == "string" ? Io(i) : i && Io(i.get());
    }
    this.previouslyFocused = -1;
  }
  onInput(e) {
    if (!e) return this.state = Vp.Idle, void (this.triggered = !1);
    const t = this.list.getFocus(), i = t.length > 0 ? t[0] : 0, s = this.state === Vp.Idle ? 1 : 0;
    this.state = Vp.Typing;
    for (let o = 0; o < this.list.length; o++) {
      const r = (i + o + s) % this.list.length, a = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(this.view.element(r)), l = a && a.toString();
      if (this.list.options.typeNavigationEnabled) {
        if (l !== void 0) {
          if (kv(e, l)) return this.previouslyFocused = i, this.list.setFocus([r]), void this.list.reveal(r);
          const d = NJ(e, l);
          if (d && d[0].end - d[0].start > 1 && d.length === 1)
            return this.previouslyFocused = i, this.list.setFocus([r]), void this.list.reveal(r);
        }
      } else if (l === void 0 || kv(e, l)) return this.previouslyFocused = i, this.list.setFocus([r]), void this.list.reveal(r);
    }
  }
  dispose() {
    this.disable(), this.enabledDisposables.dispose(), this.disposables.dispose();
  }
}
class Kee {
  constructor(e, t) {
    this.list = e, this.view = t, this.disposables = new G();
    const i = se.chain(this.disposables.add(new st(t.domNode, "keydown")).event, ((o) => o.filter(((r) => !nc(r.target))).map(((r) => new jt(r)))));
    se.chain(i, ((o) => o.filter(((r) => !(r.keyCode !== 2 || r.ctrlKey || r.metaKey || r.shiftKey || r.altKey)))))(this.onTab, this, this.disposables);
  }
  onTab(e) {
    if (e.target !== this.view.domNode) return;
    const t = this.list.getFocus();
    if (t.length === 0) return;
    const i = this.view.domElement(t[0]);
    if (!i) return;
    const s = i.querySelector("[tabIndex]");
    if (!(s && s instanceof HTMLElement && s.tabIndex !== -1)) return;
    const o = ke(s).getComputedStyle(s);
    o.visibility !== "hidden" && o.display !== "none" && (e.preventDefault(), e.stopPropagation(), s.focus());
  }
  dispose() {
    this.disposables.dispose();
  }
}
function qW(n) {
  return Je ? n.browserEvent.metaKey : n.browserEvent.ctrlKey;
}
function $W(n) {
  return n.browserEvent.shiftKey;
}
const W3 = { isSelectionSingleChangeEvent: qW, isSelectionRangeChangeEvent: $W };
class GW {
  constructor(e) {
    this.list = e, this.disposables = new G(), this._onPointer = new F(), this.onPointer = this._onPointer.event, e.options.multipleSelectionSupport !== !1 && (this.multipleSelectionController = this.list.options.multipleSelectionController || W3), this.mouseSupport = e.options.mouseSupport === void 0 || !!e.options.mouseSupport, this.mouseSupport && (e.onMouseDown(this.onMouseDown, this, this.disposables), e.onContextMenu(this.onContextMenu, this, this.disposables), e.onMouseDblClick(this.onDoubleClick, this, this.disposables), e.onTouchStart(this.onMouseDown, this, this.disposables), this.disposables.add(Bt.addTarget(e.getHTMLElement()))), se.any(e.onMouseClick, e.onMouseMiddleClick, e.onTap)(this.onViewPointer, this, this.disposables);
  }
  updateOptions(e) {
    e.multipleSelectionSupport !== void 0 && (this.multipleSelectionController = void 0, e.multipleSelectionSupport && (this.multipleSelectionController = this.list.options.multipleSelectionController || W3));
  }
  isSelectionSingleChangeEvent(e) {
    return !!this.multipleSelectionController && this.multipleSelectionController.isSelectionSingleChangeEvent(e);
  }
  isSelectionRangeChangeEvent(e) {
    return !!this.multipleSelectionController && this.multipleSelectionController.isSelectionRangeChangeEvent(e);
  }
  isSelectionChangeEvent(e) {
    return this.isSelectionSingleChangeEvent(e) || this.isSelectionRangeChangeEvent(e);
  }
  onMouseDown(e) {
    E_(e.browserEvent.target) || Mn() !== e.browserEvent.target && this.list.domFocus();
  }
  onContextMenu(e) {
    if (nc(e.browserEvent.target) || E_(e.browserEvent.target)) return;
    const t = e.index === void 0 ? [] : [e.index];
    this.list.setFocus(t, e.browserEvent);
  }
  onViewPointer(e) {
    if (!this.mouseSupport || nc(e.browserEvent.target) || E_(e.browserEvent.target) || e.browserEvent.isHandledByList) return;
    e.browserEvent.isHandledByList = !0;
    const t = e.index;
    return t === void 0 ? (this.list.setFocus([], e.browserEvent), this.list.setSelection([], e.browserEvent), void this.list.setAnchor(void 0)) : this.isSelectionChangeEvent(e) ? this.changeSelection(e) : (this.list.setFocus([t], e.browserEvent), this.list.setAnchor(t), mR(i = e.browserEvent) && i.button === 2 || this.list.setSelection([t], e.browserEvent), void this._onPointer.fire(e));
    var i;
  }
  onDoubleClick(e) {
    if (nc(e.browserEvent.target) || E_(e.browserEvent.target) || this.isSelectionChangeEvent(e) || e.browserEvent.isHandledByList) return;
    e.browserEvent.isHandledByList = !0;
    const t = this.list.getFocus();
    this.list.setSelection(t, e.browserEvent);
  }
  changeSelection(e) {
    const t = e.index;
    let i = this.list.getAnchor();
    if (this.isSelectionRangeChangeEvent(e)) {
      if (i === void 0) {
        const l = this.list.getFocus()[0];
        i = l ?? t, this.list.setAnchor(i);
      }
      const s = Ds(Math.min(i, t), Math.max(i, t) + 1), o = this.list.getSelection(), r = (function(l, d) {
        const h = l.indexOf(d);
        if (h === -1) return [];
        const c = [];
        let u = h - 1;
        for (; u >= 0 && l[u] === d - (h - u); ) c.push(l[u--]);
        for (c.reverse(), u = h; u < l.length && l[u] === d + (u - h); ) c.push(l[u++]);
        return c;
      })($I(o, [i]), i);
      if (r.length === 0) return;
      const a = $I(s, (function(l, d) {
        const h = [];
        let c = 0, u = 0;
        for (; c < l.length || u < d.length; ) if (c >= l.length) h.push(d[u++]);
        else if (u >= d.length) h.push(l[c++]);
        else {
          if (l[c] === d[u]) {
            c++, u++;
            continue;
          }
          l[c] < d[u] ? h.push(l[c++]) : u++;
        }
        return h;
      })(o, r));
      this.list.setSelection(a, e.browserEvent), this.list.setFocus([t], e.browserEvent);
    } else if (this.isSelectionSingleChangeEvent(e)) {
      const s = this.list.getSelection(), o = s.filter(((r) => r !== t));
      this.list.setFocus([t]), this.list.setAnchor(t), s.length === o.length ? this.list.setSelection([...o, t], e.browserEvent) : this.list.setSelection(o, e.browserEvent);
    }
  }
  dispose() {
    this.disposables.dispose();
  }
}
class ZW {
  constructor(e, t) {
    this.styleElement = e, this.selectorSuffix = t;
  }
  style(e) {
    var t, i;
    const s = this.selectorSuffix && `.${this.selectorSuffix}`, o = [];
    e.listBackground && o.push(`.monaco-list${s} .monaco-list-rows { background: ${e.listBackground}; }`), e.listFocusBackground && (o.push(`.monaco-list${s}:focus .monaco-list-row.focused { background-color: ${e.listFocusBackground}; }`), o.push(`.monaco-list${s}:focus .monaco-list-row.focused:hover { background-color: ${e.listFocusBackground}; }`)), e.listFocusForeground && o.push(`.monaco-list${s}:focus .monaco-list-row.focused { color: ${e.listFocusForeground}; }`), e.listActiveSelectionBackground && (o.push(`.monaco-list${s}:focus .monaco-list-row.selected { background-color: ${e.listActiveSelectionBackground}; }`), o.push(`.monaco-list${s}:focus .monaco-list-row.selected:hover { background-color: ${e.listActiveSelectionBackground}; }`)), e.listActiveSelectionForeground && o.push(`.monaco-list${s}:focus .monaco-list-row.selected { color: ${e.listActiveSelectionForeground}; }`), e.listActiveSelectionIconForeground && o.push(`.monaco-list${s}:focus .monaco-list-row.selected .codicon { color: ${e.listActiveSelectionIconForeground}; }`), e.listFocusAndSelectionBackground && o.push(`
				.monaco-drag-image,
				.monaco-list${s}:focus .monaco-list-row.selected.focused { background-color: ${e.listFocusAndSelectionBackground}; }
			`), e.listFocusAndSelectionForeground && o.push(`
				.monaco-drag-image,
				.monaco-list${s}:focus .monaco-list-row.selected.focused { color: ${e.listFocusAndSelectionForeground}; }
			`), e.listInactiveFocusForeground && (o.push(`.monaco-list${s} .monaco-list-row.focused { color:  ${e.listInactiveFocusForeground}; }`), o.push(`.monaco-list${s} .monaco-list-row.focused:hover { color:  ${e.listInactiveFocusForeground}; }`)), e.listInactiveSelectionIconForeground && o.push(`.monaco-list${s} .monaco-list-row.focused .codicon { color:  ${e.listInactiveSelectionIconForeground}; }`), e.listInactiveFocusBackground && (o.push(`.monaco-list${s} .monaco-list-row.focused { background-color:  ${e.listInactiveFocusBackground}; }`), o.push(`.monaco-list${s} .monaco-list-row.focused:hover { background-color:  ${e.listInactiveFocusBackground}; }`)), e.listInactiveSelectionBackground && (o.push(`.monaco-list${s} .monaco-list-row.selected { background-color:  ${e.listInactiveSelectionBackground}; }`), o.push(`.monaco-list${s} .monaco-list-row.selected:hover { background-color:  ${e.listInactiveSelectionBackground}; }`)), e.listInactiveSelectionForeground && o.push(`.monaco-list${s} .monaco-list-row.selected { color: ${e.listInactiveSelectionForeground}; }`), e.listHoverBackground && o.push(`.monaco-list${s}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { background-color: ${e.listHoverBackground}; }`), e.listHoverForeground && o.push(`.monaco-list${s}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { color:  ${e.listHoverForeground}; }`);
    const r = kd(e.listFocusAndSelectionOutline, kd(e.listSelectionOutline, (t = e.listFocusOutline) !== null && t !== void 0 ? t : ""));
    r && o.push(`.monaco-list${s}:focus .monaco-list-row.focused.selected { outline: 1px solid ${r}; outline-offset: -1px;}`), e.listFocusOutline && o.push(`
				.monaco-drag-image,
				.monaco-list${s}:focus .monaco-list-row.focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }
				.monaco-workbench.context-menu-visible .monaco-list${s}.last-focused .monaco-list-row.focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }
			`);
    const a = kd(e.listSelectionOutline, (i = e.listInactiveFocusOutline) !== null && i !== void 0 ? i : "");
    a && o.push(`.monaco-list${s} .monaco-list-row.focused.selected { outline: 1px dotted ${a}; outline-offset: -1px; }`), e.listSelectionOutline && o.push(`.monaco-list${s} .monaco-list-row.selected { outline: 1px dotted ${e.listSelectionOutline}; outline-offset: -1px; }`), e.listInactiveFocusOutline && o.push(`.monaco-list${s} .monaco-list-row.focused { outline: 1px dotted ${e.listInactiveFocusOutline}; outline-offset: -1px; }`), e.listHoverOutline && o.push(`.monaco-list${s} .monaco-list-row:hover { outline: 1px dashed ${e.listHoverOutline}; outline-offset: -1px; }`), e.listDropOverBackground && o.push(`
				.monaco-list${s}.drop-target,
				.monaco-list${s} .monaco-list-rows.drop-target,
				.monaco-list${s} .monaco-list-row.drop-target { background-color: ${e.listDropOverBackground} !important; color: inherit !important; }
			`), e.listDropBetweenBackground && (o.push(`
			.monaco-list${s} .monaco-list-rows.drop-target-before .monaco-list-row:first-child::before,
			.monaco-list${s} .monaco-list-row.drop-target-before::before {
				content: ""; position: absolute; top: 0px; left: 0px; width: 100%; height: 1px;
				background-color: ${e.listDropBetweenBackground};
			}`), o.push(`
			.monaco-list${s} .monaco-list-rows.drop-target-after .monaco-list-row:last-child::after,
			.monaco-list${s} .monaco-list-row.drop-target-after::after {
				content: ""; position: absolute; bottom: 0px; left: 0px; width: 100%; height: 1px;
				background-color: ${e.listDropBetweenBackground};
			}`)), e.tableColumnsBorder && o.push(`
				.monaco-table > .monaco-split-view2,
				.monaco-table > .monaco-split-view2 .monaco-sash.vertical::before,
				.monaco-workbench:not(.reduce-motion) .monaco-table:hover > .monaco-split-view2,
				.monaco-workbench:not(.reduce-motion) .monaco-table:hover > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: ${e.tableColumnsBorder};
				}

				.monaco-workbench:not(.reduce-motion) .monaco-table > .monaco-split-view2,
				.monaco-workbench:not(.reduce-motion) .monaco-table > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: transparent;
				}
			`), e.tableOddRowsBackgroundColor && o.push(`
				.monaco-table .monaco-list-row[data-parity=odd]:not(.focused):not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(:focus) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(.focused) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr {
					background-color: ${e.tableOddRowsBackgroundColor};
				}
			`), this.styleElement.textContent = o.join(`
`);
  }
}
const jee = { listFocusBackground: "#7FB0D0", listActiveSelectionBackground: "#0E639C", listActiveSelectionForeground: "#FFFFFF", listActiveSelectionIconForeground: "#FFFFFF", listFocusAndSelectionOutline: "#90C2F9", listFocusAndSelectionBackground: "#094771", listFocusAndSelectionForeground: "#FFFFFF", listInactiveSelectionBackground: "#3F3F46", listInactiveSelectionIconForeground: "#FFFFFF", listHoverBackground: "#2A2D2E", listDropOverBackground: "#383B3D", listDropBetweenBackground: "#EEEEEE", treeIndentGuidesStroke: "#a9a9a9", treeInactiveIndentGuidesStroke: z.fromHex("#a9a9a9").transparent(0.4).toString(), tableColumnsBorder: z.fromHex("#cccccc").transparent(0.2).toString(), tableOddRowsBackgroundColor: z.fromHex("#cccccc").transparent(0.04).toString(), listBackground: void 0, listFocusForeground: void 0, listInactiveSelectionForeground: void 0, listInactiveFocusForeground: void 0, listInactiveFocusBackground: void 0, listHoverForeground: void 0, listFocusOutline: void 0, listInactiveFocusOutline: void 0, listSelectionOutline: void 0, listHoverOutline: void 0 }, qee = { keyboardSupport: !0, mouseSupport: !0, multipleSelectionSupport: !0, dnd: { getDragURI: () => null, onDragStart() {
}, onDragOver: () => !1, drop() {
}, dispose() {
} } };
function $I(n, e) {
  const t = [];
  let i = 0, s = 0;
  for (; i < n.length || s < e.length; ) if (i >= n.length) t.push(e[s++]);
  else if (s >= e.length) t.push(n[i++]);
  else {
    if (n[i] === e[s]) {
      t.push(n[i]), i++, s++;
      continue;
    }
    n[i] < e[s] ? t.push(n[i++]) : t.push(e[s++]);
  }
  return t;
}
const V3 = (n, e) => n - e;
class $ee {
  constructor(e, t) {
    this._templateId = e, this.renderers = t;
  }
  get templateId() {
    return this._templateId;
  }
  renderTemplate(e) {
    return this.renderers.map(((t) => t.renderTemplate(e)));
  }
  renderElement(e, t, i, s) {
    let o = 0;
    for (const r of this.renderers) r.renderElement(e, t, i[o++], s);
  }
  disposeElement(e, t, i, s) {
    var o;
    let r = 0;
    for (const a of this.renderers) (o = a.disposeElement) === null || o === void 0 || o.call(a, e, t, i[r], s), r += 1;
  }
  disposeTemplate(e) {
    let t = 0;
    for (const i of this.renderers) i.disposeTemplate(e[t++]);
  }
}
class Gee {
  constructor(e) {
    this.accessibilityProvider = e, this.templateId = "a18n";
  }
  renderTemplate(e) {
    return { container: e, disposables: new G() };
  }
  renderElement(e, t, i) {
    const s = this.accessibilityProvider.getAriaLabel(e), o = s && typeof s != "string" ? s : ia(s);
    i.disposables.add(Ge(((a) => {
      this.setAriaLabel(a.readObservable(o), i.container);
    })));
    const r = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(e);
    typeof r == "number" ? i.container.setAttribute("aria-level", `${r}`) : i.container.removeAttribute("aria-level");
  }
  setAriaLabel(e, t) {
    e ? t.setAttribute("aria-label", e) : t.removeAttribute("aria-label");
  }
  disposeElement(e, t, i, s) {
    i.disposables.clear();
  }
  disposeTemplate(e) {
    e.disposables.dispose();
  }
}
class Zee {
  constructor(e, t) {
    this.list = e, this.dnd = t;
  }
  getDragElements(e) {
    const t = this.list.getSelectedElements();
    return t.indexOf(e) > -1 ? t : [e];
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel) return this.dnd.getDragLabel(e, t);
  }
  onDragStart(e, t) {
    var i, s;
    (s = (i = this.dnd).onDragStart) === null || s === void 0 || s.call(i, e, t);
  }
  onDragOver(e, t, i, s, o) {
    return this.dnd.onDragOver(e, t, i, s, o);
  }
  onDragLeave(e, t, i, s) {
    var o, r;
    (r = (o = this.dnd).onDragLeave) === null || r === void 0 || r.call(o, e, t, i, s);
  }
  onDragEnd(e) {
    var t, i;
    (i = (t = this.dnd).onDragEnd) === null || i === void 0 || i.call(t, e);
  }
  drop(e, t, i, s, o) {
    this.dnd.drop(e, t, i, s, o);
  }
  dispose() {
    this.dnd.dispose();
  }
}
class uo {
  get onDidChangeFocus() {
    return se.map(this.eventBufferer.wrapEvent(this.focus.onChange), ((e) => this.toListEvent(e)), this.disposables);
  }
  get onDidChangeSelection() {
    return se.map(this.eventBufferer.wrapEvent(this.selection.onChange), ((e) => this.toListEvent(e)), this.disposables);
  }
  get domId() {
    return this.view.domId;
  }
  get onDidScroll() {
    return this.view.onDidScroll;
  }
  get onMouseClick() {
    return this.view.onMouseClick;
  }
  get onMouseDblClick() {
    return this.view.onMouseDblClick;
  }
  get onMouseMiddleClick() {
    return this.view.onMouseMiddleClick;
  }
  get onPointer() {
    return this.mouseController.onPointer;
  }
  get onMouseDown() {
    return this.view.onMouseDown;
  }
  get onMouseOver() {
    return this.view.onMouseOver;
  }
  get onMouseOut() {
    return this.view.onMouseOut;
  }
  get onTouchStart() {
    return this.view.onTouchStart;
  }
  get onTap() {
    return this.view.onTap;
  }
  get onContextMenu() {
    let e = !1;
    const t = se.chain(this.disposables.add(new st(this.view.domNode, "keydown")).event, ((o) => o.map(((r) => new jt(r))).filter(((r) => e = r.keyCode === 58 || r.shiftKey && r.keyCode === 68)).map(((r) => Ze(r, !0))).filter((() => !1)))), i = se.chain(this.disposables.add(new st(this.view.domNode, "keyup")).event, ((o) => o.forEach((() => e = !1)).map(((r) => new jt(r))).filter(((r) => r.keyCode === 58 || r.shiftKey && r.keyCode === 68)).map(((r) => Ze(r, !0))).map((({ browserEvent: r }) => {
      const a = this.getFocus(), l = a.length ? a[0] : void 0;
      return { index: l, element: l !== void 0 ? this.view.element(l) : void 0, anchor: l !== void 0 ? this.view.domElement(l) : this.view.domNode, browserEvent: r };
    })))), s = se.chain(this.view.onContextMenu, ((o) => o.filter(((r) => !e)).map((({ element: r, index: a, browserEvent: l }) => ({ element: r, index: a, anchor: new _r(ke(this.view.domNode), l), browserEvent: l })))));
    return se.any(t, i, s);
  }
  get onKeyDown() {
    return this.disposables.add(new st(this.view.domNode, "keydown")).event;
  }
  get onDidFocus() {
    return se.signal(this.disposables.add(new st(this.view.domNode, "focus", !0)).event);
  }
  get onDidBlur() {
    return se.signal(this.disposables.add(new st(this.view.domNode, "blur", !0)).event);
  }
  constructor(e, t, i, s, o = qee) {
    var r, a, l, d;
    this.user = e, this._options = o, this.focus = new Ry("focused"), this.anchor = new Ry("anchor"), this.eventBufferer = new JT(), this._ariaLabel = "", this.disposables = new G(), this._onDidDispose = new F(), this.onDidDispose = this._onDidDispose.event;
    const h = this._options.accessibilityProvider && this._options.accessibilityProvider.getWidgetRole ? (r = this._options.accessibilityProvider) === null || r === void 0 ? void 0 : r.getWidgetRole() : "list";
    this.selection = new Hee(h !== "listbox");
    const c = [this.focus.renderer, this.selection.renderer];
    this.accessibilityProvider = o.accessibilityProvider, this.accessibilityProvider && (c.push(new Gee(this.accessibilityProvider)), (l = (a = this.accessibilityProvider).onDidChangeActiveDescendant) === null || l === void 0 || l.call(a, this.onDidChangeActiveDescendant, this, this.disposables)), s = s.map(((g) => new $ee(g.templateId, [...c, g])));
    const u = { ...o, dnd: o.dnd && new Zee(this, o.dnd) };
    if (this.view = this.createListView(t, i, s, u), this.view.domNode.setAttribute("role", h), o.styleController) this.styleController = o.styleController(this.view.domId);
    else {
      const g = Lo(this.view.domNode);
      this.styleController = new ZW(g, this.view.domId);
    }
    if (this.spliceable = new Mee([new YD(this.focus, this.view, o.identityProvider), new YD(this.selection, this.view, o.identityProvider), new YD(this.anchor, this.view, o.identityProvider), this.view]), this.disposables.add(this.focus), this.disposables.add(this.selection), this.disposables.add(this.anchor), this.disposables.add(this.view), this.disposables.add(this._onDidDispose), this.disposables.add(new Kee(this, this.view)), (typeof o.keyboardSupport != "boolean" || o.keyboardSupport) && (this.keyboardController = new jW(this, this.view, o), this.disposables.add(this.keyboardController)), o.keyboardNavigationLabelProvider) {
      const g = o.keyboardNavigationDelegate || zee;
      this.typeNavigationController = new Uee(this, this.view, o.keyboardNavigationLabelProvider, (d = o.keyboardNavigationEventFilter) !== null && d !== void 0 ? d : () => !0, g), this.disposables.add(this.typeNavigationController);
    }
    this.mouseController = this.createMouseController(o), this.disposables.add(this.mouseController), this.onDidChangeFocus(this._onFocusChange, this, this.disposables), this.onDidChangeSelection(this._onSelectionChange, this, this.disposables), this.accessibilityProvider && (this.ariaLabel = this.accessibilityProvider.getWidgetAriaLabel()), this._options.multipleSelectionSupport !== !1 && this.view.domNode.setAttribute("aria-multiselectable", "true");
  }
  createListView(e, t, i, s) {
    return new Oo(e, t, i, s);
  }
  createMouseController(e) {
    return new GW(this);
  }
  updateOptions(e = {}) {
    var t, i;
    this._options = { ...this._options, ...e }, (t = this.typeNavigationController) === null || t === void 0 || t.updateOptions(this._options), this._options.multipleSelectionController !== void 0 && (this._options.multipleSelectionSupport ? this.view.domNode.setAttribute("aria-multiselectable", "true") : this.view.domNode.removeAttribute("aria-multiselectable")), this.mouseController.updateOptions(e), (i = this.keyboardController) === null || i === void 0 || i.updateOptions(e), this.view.updateOptions(e);
  }
  get options() {
    return this._options;
  }
  splice(e, t, i = []) {
    if (e < 0 || e > this.view.length) throw new $c(this.user, `Invalid start index: ${e}`);
    if (t < 0) throw new $c(this.user, `Invalid delete count: ${t}`);
    t === 0 && i.length === 0 || this.eventBufferer.bufferEvents((() => this.spliceable.splice(e, t, i)));
  }
  rerender() {
    this.view.rerender();
  }
  element(e) {
    return this.view.element(e);
  }
  indexOf(e) {
    return this.view.indexOf(e);
  }
  indexAt(e) {
    return this.view.indexAt(e);
  }
  get length() {
    return this.view.length;
  }
  get contentHeight() {
    return this.view.contentHeight;
  }
  get onDidChangeContentHeight() {
    return this.view.onDidChangeContentHeight;
  }
  get scrollTop() {
    return this.view.getScrollTop();
  }
  set scrollTop(e) {
    this.view.setScrollTop(e);
  }
  get scrollHeight() {
    return this.view.scrollHeight;
  }
  get renderHeight() {
    return this.view.renderHeight;
  }
  get firstVisibleIndex() {
    return this.view.firstVisibleIndex;
  }
  get ariaLabel() {
    return this._ariaLabel;
  }
  set ariaLabel(e) {
    this._ariaLabel = e, this.view.domNode.setAttribute("aria-label", e);
  }
  domFocus() {
    this.view.domNode.focus({ preventScroll: !0 });
  }
  layout(e, t) {
    this.view.layout(e, t);
  }
  setSelection(e, t) {
    for (const i of e) if (i < 0 || i >= this.length) throw new $c(this.user, `Invalid index ${i}`);
    this.selection.set(e, t);
  }
  getSelection() {
    return this.selection.get();
  }
  getSelectedElements() {
    return this.getSelection().map(((e) => this.view.element(e)));
  }
  setAnchor(e) {
    if (e !== void 0) {
      if (e < 0 || e >= this.length) throw new $c(this.user, `Invalid index ${e}`);
      this.anchor.set([e]);
    } else this.anchor.set([]);
  }
  getAnchor() {
    return zT(this.anchor.get(), void 0);
  }
  getAnchorElement() {
    const e = this.getAnchor();
    return e === void 0 ? void 0 : this.element(e);
  }
  setFocus(e, t) {
    for (const i of e) if (i < 0 || i >= this.length) throw new $c(this.user, `Invalid index ${i}`);
    this.focus.set(e, t);
  }
  focusNext(e = 1, t = !1, i, s) {
    if (this.length === 0) return;
    const o = this.focus.get(), r = this.findNextIndex(o.length > 0 ? o[0] + e : 0, t, s);
    r > -1 && this.setFocus([r], i);
  }
  focusPrevious(e = 1, t = !1, i, s) {
    if (this.length === 0) return;
    const o = this.focus.get(), r = this.findPreviousIndex(o.length > 0 ? o[0] - e : 0, t, s);
    r > -1 && this.setFocus([r], i);
  }
  async focusNextPage(e, t) {
    let i = this.view.indexAt(this.view.getScrollTop() + this.view.renderHeight);
    i = i === 0 ? 0 : i - 1;
    const s = this.getFocus()[0];
    if (s !== i && (s === void 0 || i > s)) {
      const o = this.findPreviousIndex(i, !1, t);
      o > -1 && s !== o ? this.setFocus([o], e) : this.setFocus([i], e);
    } else {
      const o = this.view.getScrollTop();
      let r = o + this.view.renderHeight;
      i > s && (r -= this.view.elementHeight(i)), this.view.setScrollTop(r), this.view.getScrollTop() !== o && (this.setFocus([]), await vc(0), await this.focusNextPage(e, t));
    }
  }
  async focusPreviousPage(e, t, i = (() => 0)) {
    let s;
    const o = i(), r = this.view.getScrollTop() + o;
    s = r === 0 ? this.view.indexAt(r) : this.view.indexAfter(r - 1);
    const a = this.getFocus()[0];
    if (a !== s && (a === void 0 || a >= s)) {
      const l = this.findNextIndex(s, !1, t);
      l > -1 && a !== l ? this.setFocus([l], e) : this.setFocus([s], e);
    } else {
      const l = r;
      this.view.setScrollTop(r - this.view.renderHeight - o), this.view.getScrollTop() + i() !== l && (this.setFocus([]), await vc(0), await this.focusPreviousPage(e, t, i));
    }
  }
  focusLast(e, t) {
    if (this.length === 0) return;
    const i = this.findPreviousIndex(this.length - 1, !1, t);
    i > -1 && this.setFocus([i], e);
  }
  focusFirst(e, t) {
    this.focusNth(0, e, t);
  }
  focusNth(e, t, i) {
    if (this.length === 0) return;
    const s = this.findNextIndex(e, !1, i);
    s > -1 && this.setFocus([s], t);
  }
  findNextIndex(e, t = !1, i) {
    for (let s = 0; s < this.length; s++) {
      if (e >= this.length && !t) return -1;
      if (e %= this.length, !i || i(this.element(e))) return e;
      e++;
    }
    return -1;
  }
  findPreviousIndex(e, t = !1, i) {
    for (let s = 0; s < this.length; s++) {
      if (e < 0 && !t) return -1;
      if (e = (this.length + e % this.length) % this.length, !i || i(this.element(e))) return e;
      e--;
    }
    return -1;
  }
  getFocus() {
    return this.focus.get();
  }
  getFocusedElements() {
    return this.getFocus().map(((e) => this.view.element(e)));
  }
  reveal(e, t, i = 0) {
    if (e < 0 || e >= this.length) throw new $c(this.user, `Invalid index ${e}`);
    const s = this.view.getScrollTop(), o = this.view.elementTop(e), r = this.view.elementHeight(e);
    if (uc(t)) {
      const a = r - this.view.renderHeight + i;
      this.view.setScrollTop(a * as(t, 0, 1) + o - i);
    } else {
      const a = o + r, l = s + this.view.renderHeight;
      o < s + i && a >= l || (o < s + i || a >= l && r >= this.view.renderHeight ? this.view.setScrollTop(o - i) : a >= l && this.view.setScrollTop(a - this.view.renderHeight));
    }
  }
  getRelativeTop(e, t = 0) {
    if (e < 0 || e >= this.length) throw new $c(this.user, `Invalid index ${e}`);
    const i = this.view.getScrollTop(), s = this.view.elementTop(e), o = this.view.elementHeight(e);
    if (s < i + t || s + o > i + this.view.renderHeight) return null;
    const r = o - this.view.renderHeight + t;
    return Math.abs((i + t - s) / r);
  }
  getHTMLElement() {
    return this.view.domNode;
  }
  getScrollableElement() {
    return this.view.scrollableElementDomNode;
  }
  getElementID(e) {
    return this.view.getElementDomId(e);
  }
  getElementTop(e) {
    return this.view.elementTop(e);
  }
  style(e) {
    this.styleController.style(e);
  }
  toListEvent({ indexes: e, browserEvent: t }) {
    return { indexes: e, elements: e.map(((i) => this.view.element(i))), browserEvent: t };
  }
  _onFocusChange() {
    const e = this.focus.get();
    this.view.domNode.classList.toggle("element-focused", e.length > 0), this.onDidChangeActiveDescendant();
  }
  onDidChangeActiveDescendant() {
    var e;
    const t = this.focus.get();
    if (t.length > 0) {
      let i;
      !((e = this.accessibilityProvider) === null || e === void 0) && e.getActiveDescendantId && (i = this.accessibilityProvider.getActiveDescendantId(this.view.element(t[0]))), this.view.domNode.setAttribute("aria-activedescendant", i || this.view.getElementDomId(t[0]));
    } else this.view.domNode.removeAttribute("aria-activedescendant");
  }
  _onSelectionChange() {
    const e = this.selection.get();
    this.view.domNode.classList.toggle("selection-none", e.length === 0), this.view.domNode.classList.toggle("selection-single", e.length === 1), this.view.domNode.classList.toggle("selection-multiple", e.length > 1);
  }
  dispose() {
    this._onDidDispose.fire(), this.disposables.dispose(), this._onDidDispose.dispose();
  }
}
gh([Li], uo.prototype, "onDidChangeFocus", null), gh([Li], uo.prototype, "onDidChangeSelection", null), gh([Li], uo.prototype, "onContextMenu", null), gh([Li], uo.prototype, "onKeyDown", null), gh([Li], uo.prototype, "onDidFocus", null), gh([Li], uo.prototype, "onDidBlur", null);
const Ru = Q, YW = "selectOption.entry.template";
class Yee {
  get templateId() {
    return YW;
  }
  renderTemplate(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return t.root = e, t.text = Z(e, Ru(".option-text")), t.detail = Z(e, Ru(".option-detail")), t.decoratorRight = Z(e, Ru(".option-decorator-right")), t;
  }
  renderElement(e, t, i) {
    const s = i, o = e.text, r = e.detail, a = e.decoratorRight, l = e.isDisabled;
    s.text.textContent = o, s.detail.textContent = r || "", s.decoratorRight.innerText = a || "", l ? s.root.classList.add("option-disabled") : s.root.classList.remove("option-disabled");
  }
  disposeTemplate(e) {
  }
}
class Qa extends V {
  constructor(e, t, i, s, o) {
    super(), this.options = [], this._currentSelection = 0, this._hasDetails = !1, this._skipLayout = !1, this._sticky = !1, this._isVisible = !1, this.styles = s, this.selectBoxOptions = o || /* @__PURE__ */ Object.create(null), typeof this.selectBoxOptions.minBottomMargin != "number" ? this.selectBoxOptions.minBottomMargin = Qa.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN : this.selectBoxOptions.minBottomMargin < 0 && (this.selectBoxOptions.minBottomMargin = 0), this.selectElement = document.createElement("select"), this.selectElement.className = "monaco-select-box monaco-select-box-dropdown-padding", typeof this.selectBoxOptions.ariaLabel == "string" && this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel), typeof this.selectBoxOptions.ariaDescription == "string" && this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription), this._onDidSelect = new F(), this._register(this._onDidSelect), this.registerListeners(), this.constructSelectDropDown(i), this.selected = t || 0, e && this.setOptions(e, t), this.initStyleSheet();
  }
  setTitle(e) {
    !this._hover && e ? this._hover = this._register(xr(Bs("mouse"), this.selectElement, e)) : this._hover && this._hover.update(e);
  }
  getHeight() {
    return 22;
  }
  getTemplateId() {
    return YW;
  }
  constructSelectDropDown(e) {
    this.contextViewProvider = e, this.selectDropDownContainer = Q(".monaco-select-box-dropdown-container"), this.selectDropDownContainer.classList.add("monaco-select-box-dropdown-padding"), this.selectionDetailsPane = Z(this.selectDropDownContainer, Ru(".select-box-details-pane"));
    const t = Z(this.selectDropDownContainer, Ru(".select-box-dropdown-container-width-control")), i = Z(t, Ru(".width-control-div"));
    this.widthControlElement = document.createElement("span"), this.widthControlElement.className = "option-text-width-control", Z(i, this.widthControlElement), this._dropDownPosition = 0, this.styleElement = Lo(this.selectDropDownContainer), this.selectDropDownContainer.setAttribute("draggable", "true"), this._register(K(this.selectDropDownContainer, ie.DRAG_START, ((s) => {
      Ze(s, !0);
    })));
  }
  registerListeners() {
    let e;
    this._register(bi(this.selectElement, "change", ((t) => {
      this.selected = t.target.selectedIndex, this._onDidSelect.fire({ index: t.target.selectedIndex, selected: t.target.value }), this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text);
    }))), this._register(K(this.selectElement, ie.CLICK, ((t) => {
      Ze(t), this._isVisible ? this.hideSelectDropDown(!0) : this.showSelectDropDown();
    }))), this._register(K(this.selectElement, ie.MOUSE_DOWN, ((t) => {
      Ze(t);
    }))), this._register(K(this.selectElement, "touchstart", ((t) => {
      e = this._isVisible;
    }))), this._register(K(this.selectElement, "touchend", ((t) => {
      Ze(t), e ? this.hideSelectDropDown(!0) : this.showSelectDropDown();
    }))), this._register(K(this.selectElement, ie.KEY_DOWN, ((t) => {
      const i = new jt(t);
      let s = !1;
      Je ? i.keyCode !== 18 && i.keyCode !== 16 && i.keyCode !== 10 && i.keyCode !== 3 || (s = !0) : (i.keyCode === 18 && i.altKey || i.keyCode === 16 && i.altKey || i.keyCode === 10 || i.keyCode === 3) && (s = !0), s && (this.showSelectDropDown(), Ze(t, !0));
    })));
  }
  get onDidSelect() {
    return this._onDidSelect.event;
  }
  setOptions(e, t) {
    ri(this.options, e) || (this.options = e, this.selectElement.options.length = 0, this._hasDetails = !1, this._cachedMaxDetailsHeight = void 0, this.options.forEach(((i, s) => {
      this.selectElement.add(this.createOption(i.text, s, i.isDisabled)), typeof i.description == "string" && (this._hasDetails = !0);
    }))), t !== void 0 && (this.select(t), this._currentSelection = this.selected);
  }
  setOptionsList() {
    var e;
    (e = this.selectList) === null || e === void 0 || e.splice(0, this.selectList.length, this.options);
  }
  select(e) {
    e >= 0 && e < this.options.length ? this.selected = e : e > this.options.length - 1 ? this.select(this.options.length - 1) : this.selected < 0 && (this.selected = 0), this.selectElement.selectedIndex = this.selected, this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text);
  }
  focus() {
    this.selectElement && (this.selectElement.tabIndex = 0, this.selectElement.focus());
  }
  blur() {
    this.selectElement && (this.selectElement.tabIndex = -1, this.selectElement.blur());
  }
  setFocusable(e) {
    this.selectElement.tabIndex = e ? 0 : -1;
  }
  render(e) {
    this.container = e, e.classList.add("select-container"), e.appendChild(this.selectElement), this.styleSelectElement();
  }
  initStyleSheet() {
    const e = [];
    this.styles.listFocusBackground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { background-color: ${this.styles.listFocusBackground} !important; }`), this.styles.listFocusForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { color: ${this.styles.listFocusForeground} !important; }`), this.styles.decoratorRightForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.focused) .option-decorator-right { color: ${this.styles.decoratorRightForeground}; }`), this.styles.selectBackground && this.styles.selectBorder && this.styles.selectBorder !== this.styles.selectBackground ? (e.push(`.monaco-select-box-dropdown-container { border: 1px solid ${this.styles.selectBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectBorder} } `)) : this.styles.selectListBorder && (e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectListBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectListBorder} } `)), this.styles.listHoverForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { color: ${this.styles.listHoverForeground} !important; }`), this.styles.listHoverBackground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { background-color: ${this.styles.listHoverBackground} !important; }`), this.styles.listFocusOutline && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { outline: 1.6px dotted ${this.styles.listFocusOutline} !important; outline-offset: -1.6px !important; }`), this.styles.listHoverOutline && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { outline: 1.6px dashed ${this.styles.listHoverOutline} !important; outline-offset: -1.6px !important; }`), e.push(".monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled.focused { background-color: transparent !important; color: inherit !important; outline: none !important; }"), e.push(".monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled:hover { background-color: transparent !important; color: inherit !important; outline: none !important; }"), this.styleElement.textContent = e.join(`
`);
  }
  styleSelectElement() {
    var e, t, i;
    const s = (e = this.styles.selectBackground) !== null && e !== void 0 ? e : "", o = (t = this.styles.selectForeground) !== null && t !== void 0 ? t : "", r = (i = this.styles.selectBorder) !== null && i !== void 0 ? i : "";
    this.selectElement.style.backgroundColor = s, this.selectElement.style.color = o, this.selectElement.style.borderColor = r;
  }
  styleList() {
    var e, t;
    const i = (e = this.styles.selectBackground) !== null && e !== void 0 ? e : "", s = kd(this.styles.selectListBackground, i);
    this.selectDropDownListContainer.style.backgroundColor = s, this.selectionDetailsPane.style.backgroundColor = s;
    const o = (t = this.styles.focusBorder) !== null && t !== void 0 ? t : "";
    this.selectDropDownContainer.style.outlineColor = o, this.selectDropDownContainer.style.outlineOffset = "-1px", this.selectList.style(this.styles);
  }
  createOption(e, t, i) {
    const s = document.createElement("option");
    return s.value = e, s.text = e, s.disabled = !!i, s;
  }
  showSelectDropDown() {
    this.selectionDetailsPane.innerText = "", this.contextViewProvider && !this._isVisible && (this.createSelectList(this.selectDropDownContainer), this.setOptionsList(), this.contextViewProvider.showContextView({ getAnchor: () => this.selectElement, render: (e) => this.renderSelectDropDown(e, !0), layout: () => {
      this.layoutSelectDropDown();
    }, onHide: () => {
      this.selectDropDownContainer.classList.remove("visible"), this.selectElement.classList.remove("synthetic-focus");
    }, anchorPosition: this._dropDownPosition }, this.selectBoxOptions.optionsAsChildren ? this.container : void 0), this._isVisible = !0, this.hideSelectDropDown(!1), this.contextViewProvider.showContextView({ getAnchor: () => this.selectElement, render: (e) => this.renderSelectDropDown(e), layout: () => this.layoutSelectDropDown(), onHide: () => {
      this.selectDropDownContainer.classList.remove("visible"), this.selectElement.classList.remove("synthetic-focus");
    }, anchorPosition: this._dropDownPosition }, this.selectBoxOptions.optionsAsChildren ? this.container : void 0), this._currentSelection = this.selected, this._isVisible = !0, this.selectElement.setAttribute("aria-expanded", "true"));
  }
  hideSelectDropDown(e) {
    this.contextViewProvider && this._isVisible && (this._isVisible = !1, this.selectElement.setAttribute("aria-expanded", "false"), e && this.selectElement.focus(), this.contextViewProvider.hideContextView());
  }
  renderSelectDropDown(e, t) {
    return e.appendChild(this.selectDropDownContainer), this.layoutSelectDropDown(t), { dispose: () => {
      try {
        e.removeChild(this.selectDropDownContainer);
      } catch {
      }
    } };
  }
  measureMaxDetailsHeight() {
    let e = 0;
    return this.options.forEach(((t, i) => {
      this.updateDetail(i), this.selectionDetailsPane.offsetHeight > e && (e = this.selectionDetailsPane.offsetHeight);
    })), e;
  }
  layoutSelectDropDown(e) {
    if (this._skipLayout) return !1;
    if (this.selectList) {
      this.selectDropDownContainer.classList.add("visible");
      const t = ke(this.selectElement), i = Ti(this.selectElement), s = ke(this.selectElement).getComputedStyle(this.selectElement), o = parseFloat(s.getPropertyValue("--dropdown-padding-top")) + parseFloat(s.getPropertyValue("--dropdown-padding-bottom")), r = t.innerHeight - i.top - i.height - (this.selectBoxOptions.minBottomMargin || 0), a = i.top - Qa.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN, l = this.selectElement.offsetWidth, d = this.setWidthControlElement(this.widthControlElement), h = Math.max(d, Math.round(l)).toString() + "px";
      this.selectDropDownContainer.style.width = h, this.selectList.getHTMLElement().style.height = "", this.selectList.layout();
      let c = this.selectList.contentHeight;
      this._hasDetails && this._cachedMaxDetailsHeight === void 0 && (this._cachedMaxDetailsHeight = this.measureMaxDetailsHeight());
      const u = this._hasDetails ? this._cachedMaxDetailsHeight : 0, g = c + o + u, p = Math.floor((r - o - u) / this.getHeight()), f = Math.floor((a - o - u) / this.getHeight());
      if (e) return !(i.top + i.height > t.innerHeight - 22 || i.top < Qa.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || p < 1 && f < 1) && (p < Qa.DEFAULT_MINIMUM_VISIBLE_OPTIONS && f > p && this.options.length > p ? (this._dropDownPosition = 1, this.selectDropDownContainer.removeChild(this.selectDropDownListContainer), this.selectDropDownContainer.removeChild(this.selectionDetailsPane), this.selectDropDownContainer.appendChild(this.selectionDetailsPane), this.selectDropDownContainer.appendChild(this.selectDropDownListContainer), this.selectionDetailsPane.classList.remove("border-top"), this.selectionDetailsPane.classList.add("border-bottom")) : (this._dropDownPosition = 0, this.selectDropDownContainer.removeChild(this.selectDropDownListContainer), this.selectDropDownContainer.removeChild(this.selectionDetailsPane), this.selectDropDownContainer.appendChild(this.selectDropDownListContainer), this.selectDropDownContainer.appendChild(this.selectionDetailsPane), this.selectionDetailsPane.classList.remove("border-bottom"), this.selectionDetailsPane.classList.add("border-top")), !0);
      if (i.top + i.height > t.innerHeight - 22 || i.top < Qa.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || this._dropDownPosition === 0 && p < 1 || this._dropDownPosition === 1 && f < 1) return this.hideSelectDropDown(!0), !1;
      if (this._dropDownPosition === 0) {
        if (this._isVisible && p + f < 1) return this.hideSelectDropDown(!0), !1;
        g > r && (c = p * this.getHeight());
      } else g > a && (c = f * this.getHeight());
      return this.selectList.layout(c), this.selectList.domFocus(), this.selectList.length > 0 && (this.selectList.setFocus([this.selected || 0]), this.selectList.reveal(this.selectList.getFocus()[0] || 0)), this._hasDetails ? (this.selectList.getHTMLElement().style.height = c + o + "px", this.selectDropDownContainer.style.height = "") : this.selectDropDownContainer.style.height = c + o + "px", this.updateDetail(this.selected), this.selectDropDownContainer.style.width = h, this.selectDropDownListContainer.setAttribute("tabindex", "0"), this.selectElement.classList.add("synthetic-focus"), this.selectDropDownContainer.classList.add("synthetic-focus"), !0;
    }
    return !1;
  }
  setWidthControlElement(e) {
    let t = 0;
    if (e) {
      let i = 0, s = 0;
      this.options.forEach(((o, r) => {
        const a = o.detail ? o.detail.length : 0, l = o.decoratorRight ? o.decoratorRight.length : 0, d = o.text.length + a + l;
        d > s && (i = r, s = d);
      })), e.textContent = this.options[i].text + (this.options[i].decoratorRight ? this.options[i].decoratorRight + " " : ""), t = os(e);
    }
    return t;
  }
  createSelectList(e) {
    if (this.selectList) return;
    this.selectDropDownListContainer = Z(e, Ru(".select-box-dropdown-list-container")), this.listRenderer = new Yee(), this.selectList = new uo("SelectBoxCustom", this.selectDropDownListContainer, this, [this.listRenderer], { useShadows: !1, verticalScrollMode: 3, keyboardSupport: !1, mouseSupport: !1, accessibilityProvider: { getAriaLabel: (s) => {
      let o = s.text;
      return s.detail && (o += `. ${s.detail}`), s.decoratorRight && (o += `. ${s.decoratorRight}`), s.description && (o += `. ${s.description}`), o;
    }, getWidgetAriaLabel: () => m(0, "Select Box"), getRole: () => Je ? "" : "option", getWidgetRole: () => "listbox" } }), this.selectBoxOptions.ariaLabel && (this.selectList.ariaLabel = this.selectBoxOptions.ariaLabel);
    const t = this._register(new st(this.selectDropDownListContainer, "keydown")), i = se.chain(t.event, ((s) => s.filter((() => this.selectList.length > 0)).map(((o) => new jt(o)))));
    this._register(se.chain(i, ((s) => s.filter(((o) => o.keyCode === 3))))(this.onEnter, this)), this._register(se.chain(i, ((s) => s.filter(((o) => o.keyCode === 2))))(this.onEnter, this)), this._register(se.chain(i, ((s) => s.filter(((o) => o.keyCode === 9))))(this.onEscape, this)), this._register(se.chain(i, ((s) => s.filter(((o) => o.keyCode === 16))))(this.onUpArrow, this)), this._register(se.chain(i, ((s) => s.filter(((o) => o.keyCode === 18))))(this.onDownArrow, this)), this._register(se.chain(i, ((s) => s.filter(((o) => o.keyCode === 12))))(this.onPageDown, this)), this._register(se.chain(i, ((s) => s.filter(((o) => o.keyCode === 11))))(this.onPageUp, this)), this._register(se.chain(i, ((s) => s.filter(((o) => o.keyCode === 14))))(this.onHome, this)), this._register(se.chain(i, ((s) => s.filter(((o) => o.keyCode === 13))))(this.onEnd, this)), this._register(se.chain(i, ((s) => s.filter(((o) => o.keyCode >= 21 && o.keyCode <= 56 || o.keyCode >= 85 && o.keyCode <= 113))))(this.onCharacter, this)), this._register(K(this.selectList.getHTMLElement(), ie.POINTER_UP, ((s) => this.onPointerUp(s)))), this._register(this.selectList.onMouseOver(((s) => s.index !== void 0 && this.selectList.setFocus([s.index])))), this._register(this.selectList.onDidChangeFocus(((s) => this.onListFocus(s)))), this._register(K(this.selectDropDownContainer, ie.FOCUS_OUT, ((s) => {
      this._isVisible && !gn(s.relatedTarget, this.selectDropDownContainer) && this.onListBlur();
    }))), this.selectList.getHTMLElement().setAttribute("aria-label", this.selectBoxOptions.ariaLabel || ""), this.selectList.getHTMLElement().setAttribute("aria-expanded", "true"), this.styleList();
  }
  onPointerUp(e) {
    if (!this.selectList.length) return;
    Ze(e);
    const t = e.target;
    if (!t || t.classList.contains("slider")) return;
    const i = t.closest(".monaco-list-row");
    if (!i) return;
    const s = Number(i.getAttribute("data-index")), o = i.classList.contains("option-disabled");
    s >= 0 && s < this.options.length && !o && (this.selected = s, this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]), this.selected !== this._currentSelection && (this._currentSelection = this.selected, this._onDidSelect.fire({ index: this.selectElement.selectedIndex, selected: this.options[this.selected].text }), this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text)), this.hideSelectDropDown(!0));
  }
  onListBlur() {
    this._sticky || (this.selected !== this._currentSelection && this.select(this._currentSelection), this.hideSelectDropDown(!1));
  }
  renderDescriptionMarkdown(e, t) {
    const i = (o) => {
      for (let r = 0; r < o.childNodes.length; r++) {
        const a = o.childNodes.item(r);
        (a.tagName && a.tagName.toLowerCase()) === "img" ? o.removeChild(a) : i(a);
      }
    }, s = vL({ value: e, supportThemeIcons: !0 }, { actionHandler: t });
    return s.element.classList.add("select-box-description-markdown"), i(s.element), s.element;
  }
  onListFocus(e) {
    this._isVisible && this._hasDetails && this.updateDetail(e.indexes[0]);
  }
  updateDetail(e) {
    var t, i;
    this.selectionDetailsPane.innerText = "";
    const s = this.options[e], o = (t = s?.description) !== null && t !== void 0 ? t : "", r = (i = s?.descriptionIsMarkdown) !== null && i !== void 0 && i;
    if (o) {
      if (r) {
        const a = s.descriptionMarkdownActionHandler;
        this.selectionDetailsPane.appendChild(this.renderDescriptionMarkdown(o, a));
      } else this.selectionDetailsPane.innerText = o;
      this.selectionDetailsPane.style.display = "block";
    } else this.selectionDetailsPane.style.display = "none";
    this._skipLayout = !0, this.contextViewProvider.layout(), this._skipLayout = !1;
  }
  onEscape(e) {
    Ze(e), this.select(this._currentSelection), this.hideSelectDropDown(!0);
  }
  onEnter(e) {
    Ze(e), this.selected !== this._currentSelection && (this._currentSelection = this.selected, this._onDidSelect.fire({ index: this.selectElement.selectedIndex, selected: this.options[this.selected].text }), this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text)), this.hideSelectDropDown(!0);
  }
  onDownArrow(e) {
    if (this.selected < this.options.length - 1) {
      Ze(e, !0);
      const t = this.options[this.selected + 1].isDisabled;
      if (t && this.options.length > this.selected + 2) this.selected += 2;
      else {
        if (t) return;
        this.selected++;
      }
      this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]);
    }
  }
  onUpArrow(e) {
    this.selected > 0 && (Ze(e, !0), this.options[this.selected - 1].isDisabled && this.selected > 1 ? this.selected -= 2 : this.selected--, this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]));
  }
  onPageUp(e) {
    Ze(e), this.selectList.focusPreviousPage(), setTimeout((() => {
      this.selected = this.selectList.getFocus()[0], this.options[this.selected].isDisabled && this.selected < this.options.length - 1 && (this.selected++, this.selectList.setFocus([this.selected])), this.selectList.reveal(this.selected), this.select(this.selected);
    }), 1);
  }
  onPageDown(e) {
    Ze(e), this.selectList.focusNextPage(), setTimeout((() => {
      this.selected = this.selectList.getFocus()[0], this.options[this.selected].isDisabled && this.selected > 0 && (this.selected--, this.selectList.setFocus([this.selected])), this.selectList.reveal(this.selected), this.select(this.selected);
    }), 1);
  }
  onHome(e) {
    Ze(e), this.options.length < 2 || (this.selected = 0, this.options[this.selected].isDisabled && this.selected > 1 && this.selected++, this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selected), this.select(this.selected));
  }
  onEnd(e) {
    Ze(e), this.options.length < 2 || (this.selected = this.options.length - 1, this.options[this.selected].isDisabled && this.selected > 1 && this.selected--, this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selected), this.select(this.selected));
  }
  onCharacter(e) {
    const t = Yl.toString(e.keyCode);
    let i = -1;
    for (let s = 0; s < this.options.length - 1; s++) if (i = (s + this.selected + 1) % this.options.length, this.options[i].text.charAt(0).toUpperCase() === t && !this.options[i].isDisabled) {
      this.select(i), this.selectList.setFocus([i]), this.selectList.reveal(this.selectList.getFocus()[0]), Ze(e);
      break;
    }
  }
  dispose() {
    this.hideSelectDropDown(!1), super.dispose();
  }
}
Qa.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN = 32, Qa.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN = 2, Qa.DEFAULT_MINIMUM_VISIBLE_OPTIONS = 3;
class Xee extends V {
  constructor(e, t, i, s) {
    super(), this.selected = 0, this.selectBoxOptions = s || /* @__PURE__ */ Object.create(null), this.options = [], this.selectElement = document.createElement("select"), this.selectElement.className = "monaco-select-box", typeof this.selectBoxOptions.ariaLabel == "string" && this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel), typeof this.selectBoxOptions.ariaDescription == "string" && this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription), this._onDidSelect = this._register(new F()), this.styles = i, this.registerListeners(), this.setOptions(e, t);
  }
  registerListeners() {
    this._register(Bt.addTarget(this.selectElement)), [Vt.Tap].forEach(((e) => {
      this._register(K(this.selectElement, e, ((t) => {
        this.selectElement.focus();
      })));
    })), this._register(bi(this.selectElement, "click", ((e) => {
      Ze(e, !0);
    }))), this._register(bi(this.selectElement, "change", ((e) => {
      this.selectElement.title = e.target.value, this._onDidSelect.fire({ index: e.target.selectedIndex, selected: e.target.value });
    }))), this._register(bi(this.selectElement, "keydown", ((e) => {
      let t = !1;
      Je ? e.keyCode !== 18 && e.keyCode !== 16 && e.keyCode !== 10 || (t = !0) : (e.keyCode === 18 && e.altKey || e.keyCode === 10 || e.keyCode === 3) && (t = !0), t && e.stopPropagation();
    })));
  }
  get onDidSelect() {
    return this._onDidSelect.event;
  }
  setOptions(e, t) {
    this.options && ri(this.options, e) || (this.options = e, this.selectElement.options.length = 0, this.options.forEach(((i, s) => {
      this.selectElement.add(this.createOption(i.text, s, i.isDisabled));
    }))), t !== void 0 && this.select(t);
  }
  select(e) {
    this.options.length === 0 ? this.selected = 0 : e >= 0 && e < this.options.length ? this.selected = e : e > this.options.length - 1 ? this.select(this.options.length - 1) : this.selected < 0 && (this.selected = 0), this.selectElement.selectedIndex = this.selected, this.selected < this.options.length && typeof this.options[this.selected].text == "string" ? this.selectElement.title = this.options[this.selected].text : this.selectElement.title = "";
  }
  focus() {
    this.selectElement && (this.selectElement.tabIndex = 0, this.selectElement.focus());
  }
  blur() {
    this.selectElement && (this.selectElement.tabIndex = -1, this.selectElement.blur());
  }
  setFocusable(e) {
    this.selectElement.tabIndex = e ? 0 : -1;
  }
  render(e) {
    e.classList.add("select-container"), e.appendChild(this.selectElement), this.setOptions(this.options, this.selected), this.applyStyles();
  }
  applyStyles() {
    var e, t, i;
    this.selectElement && (this.selectElement.style.backgroundColor = (e = this.styles.selectBackground) !== null && e !== void 0 ? e : "", this.selectElement.style.color = (t = this.styles.selectForeground) !== null && t !== void 0 ? t : "", this.selectElement.style.borderColor = (i = this.styles.selectBorder) !== null && i !== void 0 ? i : "");
  }
  createOption(e, t, i) {
    const s = document.createElement("option");
    return s.value = e, s.text = e, s.disabled = !!i, s;
  }
}
class Qee extends To {
  constructor(e, t, i, s, o) {
    super(), Je && !o?.useCustomDrawn ? this.selectBoxDelegate = new Xee(e, t, s, o) : this.selectBoxDelegate = new Qa(e, t, i, s, o), this._register(this.selectBoxDelegate);
  }
  get onDidSelect() {
    return this.selectBoxDelegate.onDidSelect;
  }
  setOptions(e, t) {
    this.selectBoxDelegate.setOptions(e, t);
  }
  select(e) {
    this.selectBoxDelegate.select(e);
  }
  focus() {
    this.selectBoxDelegate.focus();
  }
  blur() {
    this.selectBoxDelegate.blur();
  }
  setFocusable(e) {
    this.selectBoxDelegate.setFocusable(e);
  }
  render(e) {
    this.selectBoxDelegate.render(e);
  }
}
class Gr extends V {
  get action() {
    return this._action;
  }
  constructor(e, t, i = {}) {
    super(), this.options = i, this._context = e || this, this._action = t, t instanceof Qs && this._register(t.onDidChange(((s) => {
      this.element && this.handleActionChangeEvent(s);
    })));
  }
  handleActionChangeEvent(e) {
    e.enabled !== void 0 && this.updateEnabled(), e.checked !== void 0 && this.updateChecked(), e.class !== void 0 && this.updateClass(), e.label !== void 0 && (this.updateLabel(), this.updateTooltip()), e.tooltip !== void 0 && this.updateTooltip();
  }
  get actionRunner() {
    return this._actionRunner || (this._actionRunner = this._register(new lg())), this._actionRunner;
  }
  set actionRunner(e) {
    this._actionRunner = e;
  }
  isEnabled() {
    return this._action.enabled;
  }
  setActionContext(e) {
    this._context = e;
  }
  render(e) {
    const t = this.element = e;
    this._register(Bt.addTarget(e));
    const i = this.options && this.options.draggable;
    i && (e.draggable = !0, tr && this._register(K(e, ie.DRAG_START, ((s) => {
      var o;
      return (o = s.dataTransfer) === null || o === void 0 ? void 0 : o.setData(Iv.TEXT, this._action.label);
    })))), this._register(K(t, Vt.Tap, ((s) => this.onClick(s, !0)))), this._register(K(t, ie.MOUSE_DOWN, ((s) => {
      i || Ze(s, !0), this._action.enabled && s.button === 0 && t.classList.add("active");
    }))), Je && this._register(K(t, ie.CONTEXT_MENU, ((s) => {
      s.button === 0 && s.ctrlKey === !0 && this.onClick(s);
    }))), this._register(K(t, ie.CLICK, ((s) => {
      Ze(s, !0), this.options && this.options.isMenu || this.onClick(s);
    }))), this._register(K(t, ie.DBLCLICK, ((s) => {
      Ze(s, !0);
    }))), [ie.MOUSE_UP, ie.MOUSE_OUT].forEach(((s) => {
      this._register(K(t, s, ((o) => {
        Ze(o), t.classList.remove("active");
      })));
    }));
  }
  onClick(e, t = !1) {
    var i;
    Ze(e, !0);
    const s = mo(this._context) ? !((i = this.options) === null || i === void 0) && i.useEventAsContext ? e : { preserveFocus: t } : this._context;
    this.actionRunner.run(this._action, s);
  }
  focus() {
    this.element && (this.element.tabIndex = 0, this.element.focus(), this.element.classList.add("focused"));
  }
  blur() {
    this.element && (this.element.blur(), this.element.tabIndex = -1, this.element.classList.remove("focused"));
  }
  setFocusable(e) {
    this.element && (this.element.tabIndex = e ? 0 : -1);
  }
  get trapsArrowNavigation() {
    return !1;
  }
  updateEnabled() {
  }
  updateLabel() {
  }
  getClass() {
    return this.action.class;
  }
  getTooltip() {
    return this.action.tooltip;
  }
  updateTooltip() {
    var e, t, i;
    if (!this.element) return;
    const s = (e = this.getTooltip()) !== null && e !== void 0 ? e : "";
    if (this.updateAriaLabel(), (t = this.options.hoverDelegate) === null || t === void 0 ? void 0 : t.showNativeHover) this.element.title = s;
    else if (this.customHover || s === "") this.customHover && this.customHover.update(s);
    else {
      const o = (i = this.options.hoverDelegate) !== null && i !== void 0 ? i : Bs("element");
      this.customHover = this._store.add(xr(o, this.element, s));
    }
  }
  updateAriaLabel() {
    var e;
    if (this.element) {
      const t = (e = this.getTooltip()) !== null && e !== void 0 ? e : "";
      this.element.setAttribute("aria-label", t);
    }
  }
  updateClass() {
  }
  updateChecked() {
  }
  dispose() {
    this.element && (this.element.remove(), this.element = void 0), this._context = void 0, super.dispose();
  }
}
class Qm extends Gr {
  constructor(e, t, i) {
    super(e, t, i), this.options = i, this.options.icon = i.icon !== void 0 && i.icon, this.options.label = i.label === void 0 || i.label, this.cssClass = "";
  }
  render(e) {
    super.render(e), vt(this.element);
    const t = document.createElement("a");
    if (t.classList.add("action-label"), t.setAttribute("role", this.getDefaultAriaRole()), this.label = t, this.element.appendChild(t), this.options.label && this.options.keybinding) {
      const i = document.createElement("span");
      i.classList.add("keybinding"), i.textContent = this.options.keybinding, this.element.appendChild(i);
    }
    this.updateClass(), this.updateLabel(), this.updateTooltip(), this.updateEnabled(), this.updateChecked();
  }
  getDefaultAriaRole() {
    return this._action.id === Ui.ID ? "presentation" : this.options.isMenu ? "menuitem" : "button";
  }
  focus() {
    this.label && (this.label.tabIndex = 0, this.label.focus());
  }
  blur() {
    this.label && (this.label.tabIndex = -1);
  }
  setFocusable(e) {
    this.label && (this.label.tabIndex = e ? 0 : -1);
  }
  updateLabel() {
    this.options.label && this.label && (this.label.textContent = this.action.label);
  }
  getTooltip() {
    let e = null;
    return this.action.tooltip ? e = this.action.tooltip : !this.options.label && this.action.label && this.options.icon && (e = this.action.label, this.options.keybinding && (e = m(0, "{0} ({1})", e, this.options.keybinding))), e ?? void 0;
  }
  updateClass() {
    var e;
    this.cssClass && this.label && this.label.classList.remove(...this.cssClass.split(" ")), this.options.icon ? (this.cssClass = this.getClass(), this.label && (this.label.classList.add("codicon"), this.cssClass && this.label.classList.add(...this.cssClass.split(" "))), this.updateEnabled()) : (e = this.label) === null || e === void 0 || e.classList.remove("codicon");
  }
  updateEnabled() {
    var e, t;
    this.action.enabled ? (this.label && (this.label.removeAttribute("aria-disabled"), this.label.classList.remove("disabled")), (e = this.element) === null || e === void 0 || e.classList.remove("disabled")) : (this.label && (this.label.setAttribute("aria-disabled", "true"), this.label.classList.add("disabled")), (t = this.element) === null || t === void 0 || t.classList.add("disabled"));
  }
  updateAriaLabel() {
    var e;
    if (this.label) {
      const t = (e = this.getTooltip()) !== null && e !== void 0 ? e : "";
      this.label.setAttribute("aria-label", t);
    }
  }
  updateChecked() {
    this.label && (this.action.checked !== void 0 ? (this.label.classList.toggle("checked", this.action.checked), this.label.setAttribute("aria-checked", this.action.checked ? "true" : "false"), this.label.setAttribute("role", "checkbox")) : (this.label.classList.remove("checked"), this.label.removeAttribute("aria-checked"), this.label.setAttribute("role", this.getDefaultAriaRole())));
  }
}
class Jee extends Gr {
  constructor(e, t, i, s, o, r, a) {
    super(e, t), this.selectBox = new Qee(i, s, o, r, a), this.selectBox.setFocusable(!1), this._register(this.selectBox), this.registerListeners();
  }
  select(e) {
    this.selectBox.select(e);
  }
  registerListeners() {
    this._register(this.selectBox.onDidSelect(((e) => this.runAction(e.selected, e.index))));
  }
  runAction(e, t) {
    this.actionRunner.run(this._action, this.getActionContext(e, t));
  }
  getActionContext(e, t) {
    return e;
  }
  setFocusable(e) {
    this.selectBox.setFocusable(e);
  }
  focus() {
    var e;
    (e = this.selectBox) === null || e === void 0 || e.focus();
  }
  blur() {
    var e;
    (e = this.selectBox) === null || e === void 0 || e.blur();
  }
  render(e) {
    this.selectBox.render(e);
  }
}
class ete extends lg {
  constructor(e, t) {
    super(), this._onDidChangeVisibility = this._register(new F()), this.onDidChangeVisibility = this._onDidChangeVisibility.event, this._element = Z(e, Q(".monaco-dropdown")), this._label = Z(this._element, Q(".dropdown-label"));
    let i = t.labelRenderer;
    i || (i = (o) => (o.textContent = t.label || "", null));
    for (const o of [ie.CLICK, ie.MOUSE_DOWN, Vt.Tap]) this._register(K(this.element, o, ((r) => Ze(r, !0))));
    for (const o of [ie.MOUSE_DOWN, Vt.Tap]) this._register(K(this._label, o, ((r) => {
      mR(r) && (r.detail > 1 || r.button !== 0) || (this.visible ? this.hide() : this.show());
    })));
    this._register(K(this._label, ie.KEY_UP, ((o) => {
      const r = new jt(o);
      (r.equals(3) || r.equals(10)) && (Ze(o, !0), this.visible ? this.hide() : this.show());
    })));
    const s = i(this._label);
    s && this._register(s), this._register(Bt.addTarget(this._label));
  }
  get element() {
    return this._element;
  }
  show() {
    this.visible || (this.visible = !0, this._onDidChangeVisibility.fire(!0));
  }
  hide() {
    this.visible && (this.visible = !1, this._onDidChangeVisibility.fire(!1));
  }
  dispose() {
    super.dispose(), this.hide(), this.boxContainer && (this.boxContainer.remove(), this.boxContainer = void 0), this.contents && (this.contents.remove(), this.contents = void 0), this._label && (this._label.remove(), this._label = void 0);
  }
}
class tte extends ete {
  constructor(e, t) {
    super(e, t), this._options = t, this._actions = [], this.actions = t.actions || [];
  }
  set menuOptions(e) {
    this._menuOptions = e;
  }
  get menuOptions() {
    return this._menuOptions;
  }
  get actions() {
    return this._options.actionProvider ? this._options.actionProvider.getActions() : this._actions;
  }
  set actions(e) {
    this._actions = e;
  }
  show() {
    super.show(), this.element.classList.add("active"), this._options.contextMenuProvider.showContextMenu({ getAnchor: () => this.element, getActions: () => this.actions, getActionsContext: () => this.menuOptions ? this.menuOptions.context : null, getActionViewItem: (e, t) => this.menuOptions && this.menuOptions.actionViewItemProvider ? this.menuOptions.actionViewItemProvider(e, t) : void 0, getKeyBinding: (e) => this.menuOptions && this.menuOptions.getKeyBinding ? this.menuOptions.getKeyBinding(e) : void 0, getMenuClassName: () => this._options.menuClassName || "", onHide: () => this.onHide(), actionRunner: this.menuOptions ? this.menuOptions.actionRunner : void 0, anchorAlignment: this.menuOptions ? this.menuOptions.anchorAlignment : 0, domForShadowRoot: this._options.menuAsChild ? this.element : void 0, skipTelemetry: this._options.skipTelemetry });
  }
  hide() {
    super.hide();
  }
  onHide() {
    this.hide(), this.element.classList.remove("active");
  }
}
class Ay extends Gr {
  constructor(e, t, i, s = /* @__PURE__ */ Object.create(null)) {
    super(null, e, s), this.actionItem = null, this._onDidChangeVisibility = this._register(new F()), this.onDidChangeVisibility = this._onDidChangeVisibility.event, this.menuActionsOrProvider = t, this.contextMenuProvider = i, this.options = s, this.options.actionRunner && (this.actionRunner = this.options.actionRunner);
  }
  render(e) {
    this.actionItem = e;
    const t = Array.isArray(this.menuActionsOrProvider), i = { contextMenuProvider: this.contextMenuProvider, labelRenderer: (s) => {
      var o;
      this.element = Z(s, Q("a.action-label"));
      let r = [];
      return typeof this.options.classNames == "string" ? r = this.options.classNames.split(/\s+/g).filter(((a) => !!a)) : this.options.classNames && (r = this.options.classNames), r.find(((a) => a === "icon")) || r.push("codicon"), this.element.classList.add(...r), this.element.setAttribute("role", "button"), this.element.setAttribute("aria-haspopup", "true"), this.element.setAttribute("aria-expanded", "false"), this._action.label && this._register(xr((o = this.options.hoverDelegate) !== null && o !== void 0 ? o : Bs("mouse"), this.element, this._action.label)), this.element.ariaLabel = this._action.label || "", null;
    }, menuAsChild: this.options.menuAsChild, actions: t ? this.menuActionsOrProvider : void 0, actionProvider: t ? void 0 : this.menuActionsOrProvider, skipTelemetry: this.options.skipTelemetry };
    if (this.dropdownMenu = this._register(new tte(e, i)), this._register(this.dropdownMenu.onDidChangeVisibility(((s) => {
      var o;
      (o = this.element) === null || o === void 0 || o.setAttribute("aria-expanded", `${s}`), this._onDidChangeVisibility.fire(s);
    }))), this.dropdownMenu.menuOptions = { actionViewItemProvider: this.options.actionViewItemProvider, actionRunner: this.actionRunner, getKeyBinding: this.options.keybindingProvider, context: this._context }, this.options.anchorAlignmentProvider) {
      const s = this;
      this.dropdownMenu.menuOptions = { ...this.dropdownMenu.menuOptions, get anchorAlignment() {
        return s.options.anchorAlignmentProvider();
      } };
    }
    this.updateTooltip(), this.updateEnabled();
  }
  getTooltip() {
    let e = null;
    return this.action.tooltip ? e = this.action.tooltip : this.action.label && (e = this.action.label), e ?? void 0;
  }
  setActionContext(e) {
    super.setActionContext(e), this.dropdownMenu && (this.dropdownMenu.menuOptions ? this.dropdownMenu.menuOptions.context = e : this.dropdownMenu.menuOptions = { context: e });
  }
  show() {
    var e;
    (e = this.dropdownMenu) === null || e === void 0 || e.show();
  }
  updateEnabled() {
    var e, t;
    const i = !this.action.enabled;
    (e = this.actionItem) === null || e === void 0 || e.classList.toggle("disabled", i), (t = this.element) === null || t === void 0 || t.classList.toggle("disabled", i);
  }
}
var fm, Hp;
(function(n) {
  n[n.STORAGE_DOES_NOT_EXIST = 0] = "STORAGE_DOES_NOT_EXIST", n[n.STORAGE_IN_MEMORY = 1] = "STORAGE_IN_MEMORY";
})(fm || (fm = {})), (function(n) {
  n[n.None = 0] = "None", n[n.Initialized = 1] = "Initialized", n[n.Closed = 2] = "Closed";
})(Hp || (Hp = {}));
class _m extends V {
  constructor(e, t = /* @__PURE__ */ Object.create(null)) {
    super(), this.database = e, this.options = t, this._onDidChangeStorage = this._register(new ng()), this.onDidChangeStorage = this._onDidChangeStorage.event, this.state = Hp.None, this.cache = /* @__PURE__ */ new Map(), this.flushDelayer = this._register(new r8(_m.DEFAULT_FLUSH_DELAY)), this.pendingDeletes = /* @__PURE__ */ new Set(), this.pendingInserts = /* @__PURE__ */ new Map(), this.whenFlushedCallbacks = [], this.registerListeners();
  }
  registerListeners() {
    this._register(this.database.onDidChangeItemsExternal(((e) => this.onDidChangeItemsExternal(e))));
  }
  onDidChangeItemsExternal(e) {
    var t, i;
    this._onDidChangeStorage.pause();
    try {
      (t = e.changed) === null || t === void 0 || t.forEach(((s, o) => this.acceptExternal(o, s))), (i = e.deleted) === null || i === void 0 || i.forEach(((s) => this.acceptExternal(s, void 0)));
    } finally {
      this._onDidChangeStorage.resume();
    }
  }
  acceptExternal(e, t) {
    if (this.state === Hp.Closed) return;
    let i = !1;
    mo(t) ? i = this.cache.delete(e) : this.cache.get(e) !== t && (this.cache.set(e, t), i = !0), i && this._onDidChangeStorage.fire({ key: e, external: !0 });
  }
  get(e, t) {
    const i = this.cache.get(e);
    return mo(i) ? t : i;
  }
  getBoolean(e, t) {
    const i = this.get(e);
    return mo(i) ? t : i === "true";
  }
  getNumber(e, t) {
    const i = this.get(e);
    return mo(i) ? t : parseInt(i, 10);
  }
  async set(e, t, i = !1) {
    if (this.state === Hp.Closed) return;
    if (mo(t)) return this.delete(e, i);
    const s = ms(t) || Array.isArray(t) ? (o = t, JSON.stringify(o, FJ)) : String(t);
    var o;
    return this.cache.get(e) !== s ? (this.cache.set(e, s), this.pendingInserts.set(e, s), this.pendingDeletes.delete(e), this._onDidChangeStorage.fire({ key: e, external: i }), this.doFlush()) : void 0;
  }
  async delete(e, t = !1) {
    if (this.state !== Hp.Closed)
      return this.cache.delete(e) ? (this.pendingDeletes.has(e) || this.pendingDeletes.add(e), this.pendingInserts.delete(e), this._onDidChangeStorage.fire({ key: e, external: t }), this.doFlush()) : void 0;
  }
  get hasPending() {
    return this.pendingInserts.size > 0 || this.pendingDeletes.size > 0;
  }
  async flushPending() {
    if (!this.hasPending) return;
    const e = { insert: this.pendingInserts, delete: this.pendingDeletes };
    return this.pendingDeletes = /* @__PURE__ */ new Set(), this.pendingInserts = /* @__PURE__ */ new Map(), this.database.updateItems(e).finally((() => {
      var t;
      if (!this.hasPending) for (; this.whenFlushedCallbacks.length; ) (t = this.whenFlushedCallbacks.pop()) === null || t === void 0 || t();
    }));
  }
  async doFlush(e) {
    return this.options.hint === fm.STORAGE_IN_MEMORY ? this.flushPending() : this.flushDelayer.trigger((() => this.flushPending()), e);
  }
}
_m.DEFAULT_FLUSH_DELAY = 100;
class XD {
  constructor() {
    this.onDidChangeItemsExternal = se.None, this.items = /* @__PURE__ */ new Map();
  }
  async updateItems(e) {
    var t, i;
    (t = e.insert) === null || t === void 0 || t.forEach(((s, o) => this.items.set(o, s))), (i = e.delete) === null || i === void 0 || i.forEach(((s) => this.items.delete(s)));
  }
}
const Wb = "__$__targetStorageMarker", Nr = tt("storageService");
var Pv;
(function(n) {
  n[n.NONE = 0] = "NONE", n[n.SHUTDOWN = 1] = "SHUTDOWN";
})(Pv || (Pv = {}));
class xL extends V {
  constructor(e = { flushInterval: xL.DEFAULT_FLUSH_INTERVAL }) {
    super(), this.options = e, this._onDidChangeValue = this._register(new ng()), this._onDidChangeTarget = this._register(new ng()), this._onWillSaveState = this._register(new F()), this.onWillSaveState = this._onWillSaveState.event, this._workspaceKeyTargets = void 0, this._profileKeyTargets = void 0, this._applicationKeyTargets = void 0;
  }
  onDidChangeValue(e, t, i) {
    return se.filter(this._onDidChangeValue.event, ((s) => s.scope === e && (t === void 0 || s.key === t)), i);
  }
  emitDidChangeValue(e, t) {
    const { key: i, external: s } = t;
    if (i === Wb) {
      switch (e) {
        case -1:
          this._applicationKeyTargets = void 0;
          break;
        case 0:
          this._profileKeyTargets = void 0;
          break;
        case 1:
          this._workspaceKeyTargets = void 0;
      }
      this._onDidChangeTarget.fire({ scope: e });
    } else this._onDidChangeValue.fire({ scope: e, key: i, target: this.getKeyTargets(e)[i], external: s });
  }
  get(e, t, i) {
    var s;
    return (s = this.getStorage(t)) === null || s === void 0 ? void 0 : s.get(e, i);
  }
  getBoolean(e, t, i) {
    var s;
    return (s = this.getStorage(t)) === null || s === void 0 ? void 0 : s.getBoolean(e, i);
  }
  getNumber(e, t, i) {
    var s;
    return (s = this.getStorage(t)) === null || s === void 0 ? void 0 : s.getNumber(e, i);
  }
  store(e, t, i, s, o = !1) {
    mo(t) ? this.remove(e, i, o) : this.withPausedEmitters((() => {
      var r;
      this.updateKeyTarget(e, i, s), (r = this.getStorage(i)) === null || r === void 0 || r.set(e, t, o);
    }));
  }
  remove(e, t, i = !1) {
    this.withPausedEmitters((() => {
      var s;
      this.updateKeyTarget(e, t, void 0), (s = this.getStorage(t)) === null || s === void 0 || s.delete(e, i);
    }));
  }
  withPausedEmitters(e) {
    this._onDidChangeValue.pause(), this._onDidChangeTarget.pause();
    try {
      e();
    } finally {
      this._onDidChangeValue.resume(), this._onDidChangeTarget.resume();
    }
  }
  updateKeyTarget(e, t, i, s = !1) {
    var o, r;
    const a = this.getKeyTargets(t);
    typeof i == "number" ? a[e] !== i && (a[e] = i, (o = this.getStorage(t)) === null || o === void 0 || o.set(Wb, JSON.stringify(a), s)) : typeof a[e] == "number" && (delete a[e], (r = this.getStorage(t)) === null || r === void 0 || r.set(Wb, JSON.stringify(a), s));
  }
  get workspaceKeyTargets() {
    return this._workspaceKeyTargets || (this._workspaceKeyTargets = this.loadKeyTargets(1)), this._workspaceKeyTargets;
  }
  get profileKeyTargets() {
    return this._profileKeyTargets || (this._profileKeyTargets = this.loadKeyTargets(0)), this._profileKeyTargets;
  }
  get applicationKeyTargets() {
    return this._applicationKeyTargets || (this._applicationKeyTargets = this.loadKeyTargets(-1)), this._applicationKeyTargets;
  }
  getKeyTargets(e) {
    switch (e) {
      case -1:
        return this.applicationKeyTargets;
      case 0:
        return this.profileKeyTargets;
      default:
        return this.workspaceKeyTargets;
    }
  }
  loadKeyTargets(e) {
    const t = this.getStorage(e);
    return t ? (function(i) {
      const s = i.get(Wb);
      if (s) try {
        return JSON.parse(s);
      } catch {
      }
      return /* @__PURE__ */ Object.create(null);
    })(t) : /* @__PURE__ */ Object.create(null);
  }
}
xL.DEFAULT_FLUSH_INTERVAL = 6e4;
const ite = { keybindingLabelBackground: de(tG), keybindingLabelForeground: de(iG), keybindingLabelBorder: de(nG), keybindingLabelBottomBorder: de(sG), keybindingLabelShadow: de(gd) }, nte = { buttonForeground: de(b_), buttonSeparator: de($$), buttonBackground: de(C_), buttonHoverBackground: de(G$), buttonSecondaryForeground: de(Y$), buttonSecondaryBackground: de(XE), buttonSecondaryHoverBackground: de(X$), buttonBorder: de(Z$) }, ste = { progressBarBackground: de(u$) }, Py = { inputActiveOptionBorder: de(OR), inputActiveOptionForeground: de(FR), inputActiveOptionBackground: de(Eu) };
de(Q$), de(eG), de(J$), de(xi), de(ld), de(gd), de(ot), de(E$), de(I$), de(M$), de(h$);
const Oy = { inputBackground: de(uB), inputForeground: de(gB), inputBorder: de(pB), inputValidationInfoBorder: de(W$), inputValidationInfoBackground: de(F$), inputValidationInfoForeground: de(B$), inputValidationWarningBorder: de(z$), inputValidationWarningBackground: de(V$), inputValidationWarningForeground: de(H$), inputValidationErrorBorder: de(j$), inputValidationErrorBackground: de(U$), inputValidationErrorForeground: de(K$) }, ote = { listFilterWidgetBackground: de(fG), listFilterWidgetOutline: de(_G), listFilterWidgetNoMatchesOutline: de(vG), listFilterWidgetShadow: de(bG), inputBoxStyles: Oy, toggleStyles: Py }, XW = { badgeBackground: de(PC), badgeForeground: de(c$), badgeBorder: de(ot) };
de(x$), de(D$), de(T4), de(T4), de(N$);
const Ig = { listBackground: void 0, listInactiveFocusForeground: void 0, listFocusBackground: de(oG), listFocusForeground: de(rG), listFocusOutline: de(aG), listActiveSelectionBackground: de(md), listActiveSelectionForeground: de(rl), listActiveSelectionIconForeground: de(w_), listFocusAndSelectionOutline: de(lG), listFocusAndSelectionBackground: de(md), listFocusAndSelectionForeground: de(rl), listInactiveSelectionBackground: de(dG), listInactiveSelectionIconForeground: de(cG), listInactiveSelectionForeground: de(hG), listInactiveFocusBackground: de(uG), listInactiveFocusOutline: de(gG), listHoverBackground: de(mB), listHoverForeground: de(fB), listDropOverBackground: de(pG), listDropBetweenBackground: de(mG), listSelectionOutline: de(Zt), listHoverOutline: de(Zt), treeIndentGuidesStroke: de(y_), treeInactiveIndentGuidesStroke: de(CG), tableColumnsBorder: de(wG), tableOddRowsBackgroundColor: de(yG) };
function Mg(n) {
  return (function(e, t) {
    const i = { ...t };
    for (const s in e) {
      const o = e[s];
      i[s] = o !== void 0 ? de(o) : void 0;
    }
    return i;
  })(n, Ig);
}
const rte = { selectBackground: de(ol), selectListBackground: de(q$), selectForeground: de(pd), decoratorRightForeground: de(_B), selectBorder: de(Tp), focusBorder: de($o), listFocusBackground: de(Ah), listInactiveSelectionIconForeground: de(Rp), listFocusForeground: de(Rh), listFocusOutline: (H3 = Zt, z3 = z.transparent.toString(), `var(${AR(H3)}, ${z3})`), listHoverBackground: de(mB), listHoverForeground: de(fB), listHoverOutline: de(Zt), selectListBorder: de(dd), listBackground: void 0, listActiveSelectionBackground: void 0, listActiveSelectionForeground: void 0, listActiveSelectionIconForeground: void 0, listFocusAndSelectionBackground: void 0, listDropOverBackground: void 0, listDropBetweenBackground: void 0, listInactiveSelectionBackground: void 0, listInactiveSelectionForeground: void 0, listInactiveFocusBackground: void 0, listInactiveFocusOutline: void 0, listSelectionOutline: void 0, listFocusAndSelectionForeground: void 0, listFocusAndSelectionOutline: void 0, listInactiveFocusForeground: void 0, tableColumnsBorder: void 0, tableOddRowsBackgroundColor: void 0, treeIndentGuidesStroke: void 0, treeInactiveIndentGuidesStroke: void 0 };
var H3, z3;
const ate = { shadowColor: de(gd), borderColor: de(SG), foregroundColor: de(LG), backgroundColor: de(kG), selectionForegroundColor: de(DG), selectionBackgroundColor: de(xG), selectionBorderColor: de(NG), separatorColor: de(EG), scrollbarShadow: de(p_), scrollbarSliderBackground: de(m_), scrollbarSliderHoverBackground: de(f_), scrollbarSliderActiveBackground: de(__) };
var NL = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ms = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
function EL(n, e, t, i, s, o) {
  QW(n.getActions(e), t, !1, typeof i == "string" ? (r) => r === i : i, s, o);
}
function QW(n, e, t, i = ((r) => r === "navigation"), s = (() => !1), o = !1) {
  let r, a;
  Array.isArray(e) ? (r = e, a = e) : (r = e.primary, a = e.secondary);
  const l = /* @__PURE__ */ new Set();
  for (const [d, h] of n) {
    let c;
    i(d) ? (c = r, c.length > 0 && o && c.push(new Ui())) : (c = a, c.length > 0 && c.push(new Ui()));
    for (let u of h) {
      t && (u = u instanceof Eo && u.alt ? u.alt : u);
      const g = c.push(u);
      u instanceof Om && l.add({ group: d, action: u, index: g - 1 });
    }
  }
  for (const { group: d, action: h, index: c } of l) {
    const u = i(d) ? r : a, g = h.actions;
    s(h, d, u.length) && u.splice(c, 1, ...g);
  }
}
let Ec = class extends Qm {
  constructor(n, e, t, i, s, o, r, a) {
    super(void 0, n, { icon: !(!n.class && !n.item.icon), label: !n.class && !n.item.icon, draggable: e?.draggable, keybinding: e?.keybinding, hoverDelegate: e?.hoverDelegate }), this._keybindingService = t, this._notificationService = i, this._contextKeyService = s, this._themeService = o, this._contextMenuService = r, this._accessibilityService = a, this._wantsAltCommand = !1, this._itemClassDispose = this._register(new rn()), this._altKey = ad.getInstance();
  }
  get _menuItemAction() {
    return this._action;
  }
  get _commandAction() {
    return this._wantsAltCommand && this._menuItemAction.alt || this._menuItemAction;
  }
  async onClick(n) {
    n.preventDefault(), n.stopPropagation();
    try {
      await this.actionRunner.run(this._commandAction, this._context);
    } catch (e) {
      this._notificationService.error(e);
    }
  }
  render(n) {
    if (super.render(n), n.classList.add("menu-entry"), this.options.icon && this._updateItemClass(this._menuItemAction.item), this._menuItemAction.alt) {
      let e = !1;
      const t = () => {
        var i;
        const s = !!(!((i = this._menuItemAction.alt) === null || i === void 0) && i.enabled) && (!this._accessibilityService.isMotionReduced() || e) && (this._altKey.keyStatus.altKey || this._altKey.keyStatus.shiftKey && e);
        s !== this._wantsAltCommand && (this._wantsAltCommand = s, this.updateLabel(), this.updateTooltip(), this.updateClass());
      };
      this._register(this._altKey.event(t)), this._register(K(n, "mouseleave", ((i) => {
        e = !1, t();
      }))), this._register(K(n, "mouseenter", ((i) => {
        e = !0, t();
      }))), t();
    }
  }
  updateLabel() {
    this.options.label && this.label && (this.label.textContent = this._commandAction.label);
  }
  getTooltip() {
    var n;
    const e = this._keybindingService.lookupKeybinding(this._commandAction.id, this._contextKeyService), t = e && e.getLabel(), i = this._commandAction.tooltip || this._commandAction.label;
    let s = t ? m(0, "{0} ({1})", i, t) : i;
    if (!this._wantsAltCommand && (!((n = this._menuItemAction.alt) === null || n === void 0) && n.enabled)) {
      const o = this._menuItemAction.alt.tooltip || this._menuItemAction.alt.label, r = this._keybindingService.lookupKeybinding(this._menuItemAction.alt.id, this._contextKeyService), a = r && r.getLabel(), l = a ? m(0, "{0} ({1})", o, a) : o;
      s = m(0, `{0}
[{1}] {2}`, s, DA.modifierLabels[Gs].altKey, l);
    }
    return s;
  }
  updateClass() {
    this.options.icon && (this._commandAction !== this._menuItemAction ? this._menuItemAction.alt && this._updateItemClass(this._menuItemAction.alt.item) : this._updateItemClass(this._menuItemAction.item));
  }
  _updateItemClass(n) {
    this._itemClassDispose.value = void 0;
    const { element: e, label: t } = this;
    if (!e || !t) return;
    const i = this._commandAction.checked && (s = n.toggled) && s.condition !== void 0 && n.toggled.icon ? n.toggled.icon : n.icon;
    var s;
    if (i) if (Ee.isThemeIcon(i)) {
      const o = Ee.asClassNameArray(i);
      t.classList.add(...o), this._itemClassDispose.value = ye((() => {
        t.classList.remove(...o);
      }));
    } else t.style.backgroundImage = zm(this._themeService.getColorTheme().type) ? wc(i.dark) : wc(i.light), t.classList.add("icon"), this._itemClassDispose.value = yr(ye((() => {
      t.style.backgroundImage = "", t.classList.remove("icon");
    })), this._themeService.onDidColorThemeChange((() => {
      this.updateClass();
    })));
  }
};
Ec = NL([Ms(2, Dt), Ms(3, Ri), Ms(4, Te), Ms(5, Yi), Ms(6, io), Ms(7, or)], Ec);
let GI = class extends Ay {
  constructor(n, e, t, i, s) {
    var o, r, a;
    const l = { ...e, menuAsChild: (o = e?.menuAsChild) !== null && o !== void 0 && o, classNames: (r = e?.classNames) !== null && r !== void 0 ? r : Ee.isThemeIcon(n.item.icon) ? Ee.asClassName(n.item.icon) : void 0, keybindingProvider: (a = e?.keybindingProvider) !== null && a !== void 0 ? a : (d) => t.lookupKeybinding(d.id) };
    super(n, { getActions: () => n.actions }, i, l), this._keybindingService = t, this._contextMenuService = i, this._themeService = s;
  }
  render(n) {
    super.render(n), vt(this.element), n.classList.add("menu-entry");
    const e = this._action, { icon: t } = e.item;
    if (t && !Ee.isThemeIcon(t)) {
      this.element.classList.add("icon");
      const i = () => {
        this.element && (this.element.style.backgroundImage = zm(this._themeService.getColorTheme().type) ? wc(t.dark) : wc(t.light));
      };
      i(), this._register(this._themeService.onDidColorThemeChange((() => {
        i();
      })));
    }
  }
};
GI = NL([Ms(2, Dt), Ms(3, io), Ms(4, Yi)], GI);
let ZI = class extends Gr {
  constructor(n, e, t, i, s, o, r, a) {
    var l, d, h;
    let c;
    super(null, n), this._keybindingService = t, this._notificationService = i, this._contextMenuService = s, this._menuService = o, this._instaService = r, this._storageService = a, this._container = null, this._options = e, this._storageKey = `${n.item.submenu.id}_lastActionId`;
    const u = e?.persistLastActionId ? a.get(this._storageKey, 1) : void 0;
    u && (c = n.actions.find(((p) => u === p.id))), c || (c = n.actions[0]), this._defaultAction = this._instaService.createInstance(Ec, c, { keybinding: this._getDefaultActionKeybindingLabel(c) });
    const g = { keybindingProvider: (p) => this._keybindingService.lookupKeybinding(p.id), ...e, menuAsChild: (l = e?.menuAsChild) === null || l === void 0 || l, classNames: (d = e?.classNames) !== null && d !== void 0 ? d : ["codicon", "codicon-chevron-down"], actionRunner: (h = e?.actionRunner) !== null && h !== void 0 ? h : new lg() };
    this._dropdown = new Ay(n, n.actions, this._contextMenuService, g), this._register(this._dropdown.actionRunner.onDidRun(((p) => {
      p.action instanceof Eo && this.update(p.action);
    })));
  }
  update(n) {
    var e;
    !((e = this._options) === null || e === void 0) && e.persistLastActionId && this._storageService.store(this._storageKey, n.id, 1, 1), this._defaultAction.dispose(), this._defaultAction = this._instaService.createInstance(Ec, n, { keybinding: this._getDefaultActionKeybindingLabel(n) }), this._defaultAction.actionRunner = new class extends lg {
      async runAction(t, i) {
        await t.run(void 0);
      }
    }(), this._container && this._defaultAction.render(fR(this._container, Q(".action-container")));
  }
  _getDefaultActionKeybindingLabel(n) {
    var e;
    let t;
    if (!((e = this._options) === null || e === void 0) && e.renderKeybindingWithDefaultActionLabel) {
      const i = this._keybindingService.lookupKeybinding(n.id);
      i && (t = `(${i.getLabel()})`);
    }
    return t;
  }
  setActionContext(n) {
    super.setActionContext(n), this._defaultAction.setActionContext(n), this._dropdown.setActionContext(n);
  }
  render(n) {
    this._container = n, super.render(this._container), this._container.classList.add("monaco-dropdown-with-default");
    const e = Q(".action-container");
    this._defaultAction.render(Z(this._container, e)), this._register(K(e, ie.KEY_DOWN, ((i) => {
      const s = new jt(i);
      s.equals(17) && (this._defaultAction.element.tabIndex = -1, this._dropdown.focus(), s.stopPropagation());
    })));
    const t = Q(".dropdown-action-container");
    this._dropdown.render(Z(this._container, t)), this._register(K(t, ie.KEY_DOWN, ((i) => {
      var s;
      const o = new jt(i);
      o.equals(15) && (this._defaultAction.element.tabIndex = 0, this._dropdown.setFocusable(!1), (s = this._defaultAction.element) === null || s === void 0 || s.focus(), o.stopPropagation());
    })));
  }
  focus(n) {
    n ? this._dropdown.focus() : (this._defaultAction.element.tabIndex = 0, this._defaultAction.element.focus());
  }
  blur() {
    this._defaultAction.element.tabIndex = -1, this._dropdown.blur(), this._container.blur();
  }
  setFocusable(n) {
    n ? this._defaultAction.element.tabIndex = 0 : (this._defaultAction.element.tabIndex = -1, this._dropdown.setFocusable(!1));
  }
  dispose() {
    this._defaultAction.dispose(), this._dropdown.dispose(), super.dispose();
  }
};
ZI = NL([Ms(2, Dt), Ms(3, Ri), Ms(4, io), Ms(5, Mo), Ms(6, Se), Ms(7, Nr)], ZI);
let YI = class extends Jee {
  constructor(n, e) {
    super(null, n, n.actions.map(((t) => ({ text: t.id === Ui.ID ? "─────────" : t.label, isDisabled: !t.enabled }))), 0, e, rte, { ariaLabel: n.tooltip, optionsAsChildren: !0 }), this.select(Math.max(0, n.actions.findIndex(((t) => t.checked))));
  }
  render(n) {
    super.render(n), n.style.borderColor = de(Tp);
  }
  runAction(n, e) {
    const t = this.action.actions[e];
    t && this.actionRunner.run(t);
  }
};
function JW(n, e, t) {
  return e instanceof Eo ? n.createInstance(Ec, e, t) : e instanceof ev ? e.item.isSelection ? n.createInstance(YI, e) : e.item.rememberDefaultAction ? n.createInstance(ZI, e, { ...t, persistLastActionId: !0 }) : n.createInstance(GI, e, t) : void 0;
}
YI = NL([Ms(1, zd)], YI);
class sr extends V {
  constructor(e, t = {}) {
    var i, s, o, r, a, l, d;
    let h, c;
    switch (super(), this._actionRunnerDisposables = this._register(new G()), this.viewItemDisposables = this._register(new XT()), this.triggerKeyDown = !1, this.focusable = !0, this._onDidBlur = this._register(new F()), this.onDidBlur = this._onDidBlur.event, this._onDidCancel = this._register(new F({ onWillAddFirstListener: () => this.cancelHasListener = !0 })), this.onDidCancel = this._onDidCancel.event, this.cancelHasListener = !1, this._onDidRun = this._register(new F()), this.onDidRun = this._onDidRun.event, this._onWillRun = this._register(new F()), this.onWillRun = this._onWillRun.event, this.options = t, this._context = (i = t.context) !== null && i !== void 0 ? i : null, this._orientation = (s = this.options.orientation) !== null && s !== void 0 ? s : 0, this._triggerKeys = { keyDown: (r = (o = this.options.triggerKeys) === null || o === void 0 ? void 0 : o.keyDown) !== null && r !== void 0 && r, keys: (l = (a = this.options.triggerKeys) === null || a === void 0 ? void 0 : a.keys) !== null && l !== void 0 ? l : [3, 10] }, this._hoverDelegate = (d = t.hoverDelegate) !== null && d !== void 0 ? d : this._register(Zm()), this.options.actionRunner ? this._actionRunner = this.options.actionRunner : (this._actionRunner = new lg(), this._actionRunnerDisposables.add(this._actionRunner)), this._actionRunnerDisposables.add(this._actionRunner.onDidRun(((u) => this._onDidRun.fire(u)))), this._actionRunnerDisposables.add(this._actionRunner.onWillRun(((u) => this._onWillRun.fire(u)))), this.viewItems = [], this.focusedItem = void 0, this.domNode = document.createElement("div"), this.domNode.className = "monaco-action-bar", this._orientation) {
      case 0:
        h = [15], c = [17];
        break;
      case 1:
        h = [16], c = [18], this.domNode.className += " vertical";
    }
    this._register(K(this.domNode, ie.KEY_DOWN, ((u) => {
      const g = new jt(u);
      let p = !0;
      const f = typeof this.focusedItem == "number" ? this.viewItems[this.focusedItem] : void 0;
      h && (g.equals(h[0]) || g.equals(h[1])) ? p = this.focusPrevious() : c && (g.equals(c[0]) || g.equals(c[1])) ? p = this.focusNext() : g.equals(9) && this.cancelHasListener ? this._onDidCancel.fire() : g.equals(14) ? p = this.focusFirst() : g.equals(13) ? p = this.focusLast() : g.equals(2) && f instanceof Gr && f.trapsArrowNavigation ? p = this.focusNext() : this.isTriggerKeyEvent(g) ? this._triggerKeys.keyDown ? this.doTrigger(g) : this.triggerKeyDown = !0 : p = !1, p && (g.preventDefault(), g.stopPropagation());
    }))), this._register(K(this.domNode, ie.KEY_UP, ((u) => {
      const g = new jt(u);
      this.isTriggerKeyEvent(g) ? (!this._triggerKeys.keyDown && this.triggerKeyDown && (this.triggerKeyDown = !1, this.doTrigger(g)), g.preventDefault(), g.stopPropagation()) : (g.equals(2) || g.equals(1026) || g.equals(16) || g.equals(18) || g.equals(15) || g.equals(17)) && this.updateFocusedItem();
    }))), this.focusTracker = this._register(pa(this.domNode)), this._register(this.focusTracker.onDidBlur((() => {
      Mn() !== this.domNode && gn(Mn(), this.domNode) || (this._onDidBlur.fire(), this.previouslyFocusedItem = this.focusedItem, this.focusedItem = void 0, this.triggerKeyDown = !1);
    }))), this._register(this.focusTracker.onDidFocus((() => this.updateFocusedItem()))), this.actionsList = document.createElement("ul"), this.actionsList.className = "actions-container", this.options.highlightToggledItems && this.actionsList.classList.add("highlight-toggled"), this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar"), this.options.ariaLabel && this.actionsList.setAttribute("aria-label", this.options.ariaLabel), this.domNode.appendChild(this.actionsList), e.appendChild(this.domNode);
  }
  refreshRole() {
    this.length() >= 1 ? this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar") : this.actionsList.setAttribute("role", "presentation");
  }
  setFocusable(e) {
    if (this.focusable = e, this.focusable) {
      const t = this.viewItems.find(((i) => i instanceof Gr && i.isEnabled()));
      t instanceof Gr && t.setFocusable(!0);
    } else this.viewItems.forEach(((t) => {
      t instanceof Gr && t.setFocusable(!1);
    }));
  }
  isTriggerKeyEvent(e) {
    let t = !1;
    return this._triggerKeys.keys.forEach(((i) => {
      t = t || e.equals(i);
    })), t;
  }
  updateFocusedItem() {
    var e, t;
    for (let i = 0; i < this.actionsList.children.length; i++) {
      const s = this.actionsList.children[i];
      if (gn(Mn(), s)) {
        this.focusedItem = i, (t = (e = this.viewItems[this.focusedItem]) === null || e === void 0 ? void 0 : e.showHover) === null || t === void 0 || t.call(e);
        break;
      }
    }
  }
  get context() {
    return this._context;
  }
  set context(e) {
    this._context = e, this.viewItems.forEach(((t) => t.setActionContext(e)));
  }
  get actionRunner() {
    return this._actionRunner;
  }
  set actionRunner(e) {
    this._actionRunner = e, this._actionRunnerDisposables.clear(), this._actionRunnerDisposables.add(this._actionRunner.onDidRun(((t) => this._onDidRun.fire(t)))), this._actionRunnerDisposables.add(this._actionRunner.onWillRun(((t) => this._onWillRun.fire(t)))), this.viewItems.forEach(((t) => t.actionRunner = e));
  }
  getContainer() {
    return this.domNode;
  }
  getAction(e) {
    var t;
    if (typeof e == "number") return (t = this.viewItems[e]) === null || t === void 0 ? void 0 : t.action;
    if (e instanceof HTMLElement) {
      for (; e.parentElement !== this.actionsList; ) {
        if (!e.parentElement) return;
        e = e.parentElement;
      }
      for (let i = 0; i < this.actionsList.childNodes.length; i++) if (this.actionsList.childNodes[i] === e) return this.viewItems[i].action;
    }
  }
  push(e, t = {}) {
    const i = Array.isArray(e) ? e : [e];
    let s = uc(t.index) ? t.index : null;
    i.forEach(((o) => {
      const r = document.createElement("li");
      let a;
      r.className = "action-item", r.setAttribute("role", "presentation");
      const l = { hoverDelegate: this._hoverDelegate, ...t };
      this.options.actionViewItemProvider && (a = this.options.actionViewItemProvider(o, l)), a || (a = new Qm(this.context, o, l)), this.options.allowContextMenu || this.viewItemDisposables.set(a, K(r, ie.CONTEXT_MENU, ((d) => {
        Ze(d, !0);
      }))), a.actionRunner = this._actionRunner, a.setActionContext(this.context), a.render(r), this.focusable && a instanceof Gr && this.viewItems.length === 0 && a.setFocusable(!0), s === null || s < 0 || s >= this.actionsList.children.length ? (this.actionsList.appendChild(r), this.viewItems.push(a)) : (this.actionsList.insertBefore(r, this.actionsList.children[s]), this.viewItems.splice(s, 0, a), s++);
    })), typeof this.focusedItem == "number" && this.focus(this.focusedItem), this.refreshRole();
  }
  clear() {
    this.isEmpty() || (this.viewItems = Ht(this.viewItems), this.viewItemDisposables.clearAndDisposeAll(), Un(this.actionsList), this.refreshRole());
  }
  length() {
    return this.viewItems.length;
  }
  isEmpty() {
    return this.viewItems.length === 0;
  }
  focus(e) {
    let t, i = !1;
    if (e === void 0 ? i = !0 : typeof e == "number" ? t = e : typeof e == "boolean" && (i = e), i && this.focusedItem === void 0) {
      const s = this.viewItems.findIndex(((o) => o.isEnabled()));
      this.focusedItem = s === -1 ? void 0 : s, this.updateFocus(void 0, void 0, !0);
    } else t !== void 0 && (this.focusedItem = t), this.updateFocus(void 0, void 0, !0);
  }
  focusFirst() {
    return this.focusedItem = this.length() - 1, this.focusNext(!0);
  }
  focusLast() {
    return this.focusedItem = 0, this.focusPrevious(!0);
  }
  focusNext(e) {
    if (this.focusedItem === void 0) this.focusedItem = this.viewItems.length - 1;
    else if (this.viewItems.length <= 1) return !1;
    const t = this.focusedItem;
    let i;
    do {
      if (!e && this.options.preventLoopNavigation && this.focusedItem + 1 >= this.viewItems.length) return this.focusedItem = t, !1;
      this.focusedItem = (this.focusedItem + 1) % this.viewItems.length, i = this.viewItems[this.focusedItem];
    } while (this.focusedItem !== t && (this.options.focusOnlyEnabledItems && !i.isEnabled() || i.action.id === Ui.ID));
    return this.updateFocus(), !0;
  }
  focusPrevious(e) {
    if (this.focusedItem === void 0) this.focusedItem = 0;
    else if (this.viewItems.length <= 1) return !1;
    const t = this.focusedItem;
    let i;
    do {
      if (this.focusedItem = this.focusedItem - 1, this.focusedItem < 0) {
        if (!e && this.options.preventLoopNavigation) return this.focusedItem = t, !1;
        this.focusedItem = this.viewItems.length - 1;
      }
      i = this.viewItems[this.focusedItem];
    } while (this.focusedItem !== t && (this.options.focusOnlyEnabledItems && !i.isEnabled() || i.action.id === Ui.ID));
    return this.updateFocus(!0), !0;
  }
  updateFocus(e, t, i = !1) {
    var s, o;
    this.focusedItem === void 0 && this.actionsList.focus({ preventScroll: t }), this.previouslyFocusedItem !== void 0 && this.previouslyFocusedItem !== this.focusedItem && ((s = this.viewItems[this.previouslyFocusedItem]) === null || s === void 0 || s.blur());
    const r = this.focusedItem !== void 0 ? this.viewItems[this.focusedItem] : void 0;
    if (r) {
      let a = !0;
      U0(r.focus) || (a = !1), this.options.focusOnlyEnabledItems && U0(r.isEnabled) && !r.isEnabled() && (a = !1), r.action.id === Ui.ID && (a = !1), a ? (i || this.previouslyFocusedItem !== this.focusedItem) && (r.focus(e), this.previouslyFocusedItem = this.focusedItem) : (this.actionsList.focus({ preventScroll: t }), this.previouslyFocusedItem = void 0), a && ((o = r.showHover) === null || o === void 0 || o.call(r));
    }
  }
  doTrigger(e) {
    if (this.focusedItem === void 0) return;
    const t = this.viewItems[this.focusedItem];
    if (t instanceof Gr) {
      const i = t._context === null || t._context === void 0 ? e : t._context;
      this.run(t._action, i);
    }
  }
  async run(e, t) {
    await this._actionRunner.run(e, t);
  }
  dispose() {
    this._context = void 0, this.viewItems = Ht(this.viewItems), this.getContainer().remove(), super.dispose();
  }
}
const QD = /\(&([^\s&])\)|(^|[^&])&([^\s&])/, JD = /(&amp;)?(&amp;)([^\s&])/g;
var Fy, XI;
(function(n) {
  n[n.Right = 0] = "Right", n[n.Left = 1] = "Left";
})(Fy || (Fy = {})), (function(n) {
  n[n.Above = 0] = "Above", n[n.Below = 1] = "Below";
})(XI || (XI = {}));
class vm extends sr {
  constructor(e, t, i, s) {
    e.classList.add("monaco-menu-container"), e.setAttribute("role", "presentation");
    const o = document.createElement("div");
    o.classList.add("monaco-menu"), o.setAttribute("role", "presentation"), super(o, { orientation: 1, actionViewItemProvider: (d) => this.doGetActionViewItem(d, i, r), context: i.context, actionRunner: i.actionRunner, ariaLabel: i.ariaLabel, ariaRole: "menu", focusOnlyEnabledItems: !0, triggerKeys: { keys: [3, ...Je || Cs ? [10] : []], keyDown: !0 } }), this.menuStyles = s, this.menuElement = o, this.actionsList.tabIndex = 0, this.initializeOrUpdateStyleSheet(e, s), this._register(Bt.addTarget(o)), this._register(K(o, ie.KEY_DOWN, ((d) => {
      new jt(d).equals(2) && d.preventDefault();
    }))), i.enableMnemonics && this._register(K(o, ie.KEY_DOWN, ((d) => {
      const h = d.key.toLocaleLowerCase();
      if (this.mnemonics.has(h)) {
        Ze(d, !0);
        const c = this.mnemonics.get(h);
        if (c.length === 1 && (c[0] instanceof U3 && c[0].container && this.focusItemByElement(c[0].container), c[0].onClick(d)), c.length > 1) {
          const u = c.shift();
          u && u.container && (this.focusItemByElement(u.container), c.push(u)), this.mnemonics.set(h, c);
        }
      }
    }))), Cs && this._register(K(o, ie.KEY_DOWN, ((d) => {
      const h = new jt(d);
      h.equals(14) || h.equals(11) ? (this.focusedItem = this.viewItems.length - 1, this.focusNext(), Ze(d, !0)) : (h.equals(13) || h.equals(12)) && (this.focusedItem = 0, this.focusPrevious(), Ze(d, !0));
    }))), this._register(K(this.domNode, ie.MOUSE_OUT, ((d) => {
      gn(d.relatedTarget, this.domNode) || (this.focusedItem = void 0, this.updateFocus(), d.stopPropagation());
    }))), this._register(K(this.actionsList, ie.MOUSE_OVER, ((d) => {
      let h = d.target;
      if (h && gn(h, this.actionsList) && h !== this.actionsList) {
        for (; h.parentElement !== this.actionsList && h.parentElement !== null; ) h = h.parentElement;
        if (h.classList.contains("action-item")) {
          const c = this.focusedItem;
          this.setFocusedItem(h), c !== this.focusedItem && this.updateFocus();
        }
      }
    }))), this._register(Bt.addTarget(this.actionsList)), this._register(K(this.actionsList, Vt.Tap, ((d) => {
      let h = d.initialTarget;
      if (h && gn(h, this.actionsList) && h !== this.actionsList) {
        for (; h.parentElement !== this.actionsList && h.parentElement !== null; ) h = h.parentElement;
        if (h.classList.contains("action-item")) {
          const c = this.focusedItem;
          this.setFocusedItem(h), c !== this.focusedItem && this.updateFocus();
        }
      }
    })));
    const r = { parent: this };
    this.mnemonics = /* @__PURE__ */ new Map(), this.scrollableElement = this._register(new S1(o, { alwaysConsumeMouseWheel: !0, horizontal: 2, vertical: 3, verticalScrollbarSize: 7, handleMouseWheel: !0, useShadows: !0 }));
    const a = this.scrollableElement.getDomNode();
    a.style.position = "", this.styleScrollElement(a, s), this._register(K(o, Vt.Change, ((d) => {
      Ze(d, !0);
      const h = this.scrollableElement.getScrollPosition().scrollTop;
      this.scrollableElement.setScrollPosition({ scrollTop: h - d.translationY });
    }))), this._register(K(a, ie.MOUSE_UP, ((d) => {
      d.preventDefault();
    })));
    const l = ke(e);
    o.style.maxHeight = `${Math.max(10, l.innerHeight - e.getBoundingClientRect().top - 35)}px`, t = t.filter(((d, h) => {
      var c;
      return !((c = i.submenuIds) === null || c === void 0) && c.has(d.id) ? (console.warn(`Found submenu cycle: ${d.id}`), !1) : !(d instanceof Ui && (h === t.length - 1 || h === 0 || t[h - 1] instanceof Ui));
    })), this.push(t, { icon: !0, label: !0, isMenu: !0 }), e.appendChild(this.scrollableElement.getDomNode()), this.scrollableElement.scanDomNode(), this.viewItems.filter(((d) => !(d instanceof K3))).forEach(((d, h, c) => {
      d.updatePositionInSet(h + 1, c.length);
    }));
  }
  initializeOrUpdateStyleSheet(e, t) {
    this.styleSheet || (Kw(e) ? this.styleSheet = Lo(e) : (vm.globalStyleSheet || (vm.globalStyleSheet = Lo()), this.styleSheet = vm.globalStyleSheet)), this.styleSheet.textContent = (function(i, s) {
      let o = `
.monaco-menu {
	font-size: 13px;
	border-radius: 5px;
	min-width: 160px;
}

${j3(ne.menuSelection)}
${j3(ne.menuSubmenu)}

.monaco-menu .monaco-action-bar {
	text-align: right;
	overflow: hidden;
	white-space: nowrap;
}

.monaco-menu .monaco-action-bar .actions-container {
	display: flex;
	margin: 0 auto;
	padding: 0;
	width: 100%;
	justify-content: flex-end;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: inline-block;
}

.monaco-menu .monaco-action-bar.reverse .actions-container {
	flex-direction: row-reverse;
}

.monaco-menu .monaco-action-bar .action-item {
	cursor: pointer;
	display: inline-block;
	transition: transform 50ms ease;
	position: relative;  /* DO NOT REMOVE - this is the key to preventing the ghosting icon bug in Chrome 42 */
}

.monaco-menu .monaco-action-bar .action-item.disabled {
	cursor: default;
}

.monaco-menu .monaco-action-bar .action-item .icon,
.monaco-menu .monaco-action-bar .action-item .codicon {
	display: inline-block;
}

.monaco-menu .monaco-action-bar .action-item .codicon {
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar .action-label {
	font-size: 11px;
	margin-right: 4px;
}

.monaco-menu .monaco-action-bar .action-item.disabled .action-label,
.monaco-menu .monaco-action-bar .action-item.disabled .action-label:hover {
	color: var(--vscode-disabledForeground);
}

/* Vertical actions */

.monaco-menu .monaco-action-bar.vertical {
	text-align: left;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	display: block;
	border-bottom: 1px solid var(--vscode-menu-separatorBackground);
	padding-top: 1px;
	padding: 30px;
}

.monaco-menu .secondary-actions .monaco-action-bar .action-label {
	margin-left: 6px;
}

/* Action Items */
.monaco-menu .monaco-action-bar .action-item.select-container {
	overflow: hidden; /* somehow the dropdown overflows its container, we prevent it here to not push */
	flex: 1;
	max-width: 170px;
	min-width: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 10px;
}

.monaco-menu .monaco-action-bar.vertical {
	margin-left: 0;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	padding: 0;
	transform: none;
	display: flex;
}

.monaco-menu .monaco-action-bar.vertical .action-item.active {
	transform: none;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	flex: 1 1 auto;
	display: flex;
	height: 2em;
	align-items: center;
	position: relative;
	margin: 0 4px;
	border-radius: 4px;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item:hover .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-menu-item:focus .keybinding {
	opacity: unset;
}

.monaco-menu .monaco-action-bar.vertical .action-label {
	flex: 1 1 auto;
	text-decoration: none;
	padding: 0 1em;
	background: none;
	font-size: 12px;
	line-height: 1;
}

.monaco-menu .monaco-action-bar.vertical .keybinding,
.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	display: inline-block;
	flex: 2 1 auto;
	padding: 0 1em;
	text-align: right;
	font-size: 12px;
	line-height: 1;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon {
	font-size: 16px !important;
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon::before {
	margin-left: auto;
	margin-right: -20px;
}

.monaco-menu .monaco-action-bar.vertical .action-item.disabled .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-item.disabled .submenu-indicator {
	opacity: 0.4;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator) {
	display: inline-block;
	box-sizing: border-box;
	margin: 0;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	position: static;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .action-item .monaco-submenu {
	position: absolute;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	width: 100%;
	height: 0px !important;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator.text {
	padding: 0.7em 1em 0.1em 1em;
	font-weight: bold;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label:hover {
	color: inherit;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	position: absolute;
	visibility: hidden;
	width: 1em;
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item.checked .menu-item-check {
	visibility: visible;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Context Menu */

.context-view.monaco-menu-container {
	outline: 0;
	border: none;
	animation: fadeIn 0.083s linear;
	-webkit-app-region: no-drag;
}

.context-view.monaco-menu-container :focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical:focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical :focus {
	outline: 0;
}

.hc-black .context-view.monaco-menu-container,
.hc-light .context-view.monaco-menu-container,
:host-context(.hc-black) .context-view.monaco-menu-container,
:host-context(.hc-light) .context-view.monaco-menu-container {
	box-shadow: none;
}

.hc-black .monaco-menu .monaco-action-bar.vertical .action-item.focused,
.hc-light .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-black) .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-light) .monaco-menu .monaco-action-bar.vertical .action-item.focused {
	background: none;
}

/* Vertical Action Bar Styles */

.monaco-menu .monaco-action-bar.vertical {
	padding: 4px 0;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	height: 2em;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator),
.monaco-menu .monaco-action-bar.vertical .keybinding {
	font-size: inherit;
	padding: 0 2em;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	font-size: inherit;
	width: 2em;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	font-size: inherit;
	margin: 5px 0 !important;
	padding: 0;
	border-radius: 0;
}

.linux .monaco-menu .monaco-action-bar.vertical .action-label.separator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .action-label.separator {
	margin-left: 0;
	margin-right: 0;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	font-size: 60%;
	padding: 0 1.8em;
}

.linux .monaco-menu .monaco-action-bar.vertical .submenu-indicator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
	mask-size: 10px 10px;
	-webkit-mask-size: 10px 10px;
}

.monaco-menu .action-item {
	cursor: default;
}`;
      if (s) {
        o += `
			/* Arrows */
			.monaco-scrollable-element > .scrollbar > .scra {
				cursor: pointer;
				font-size: 11px !important;
			}

			.monaco-scrollable-element > .visible {
				opacity: 1;

				/* Background rule added for IE9 - to allow clicks on dom node */
				background:rgba(0,0,0,0);

				transition: opacity 100ms linear;
			}
			.monaco-scrollable-element > .invisible {
				opacity: 0;
				pointer-events: none;
			}
			.monaco-scrollable-element > .invisible.fade {
				transition: opacity 800ms linear;
			}

			/* Scrollable Content Inset Shadow */
			.monaco-scrollable-element > .shadow {
				position: absolute;
				display: none;
			}
			.monaco-scrollable-element > .shadow.top {
				display: block;
				top: 0;
				left: 3px;
				height: 3px;
				width: 100%;
			}
			.monaco-scrollable-element > .shadow.left {
				display: block;
				top: 3px;
				left: 0;
				height: 100%;
				width: 3px;
			}
			.monaco-scrollable-element > .shadow.top-left-corner {
				display: block;
				top: 0;
				left: 0;
				height: 3px;
				width: 3px;
			}
		`;
        const r = i.scrollbarShadow;
        r && (o += `
				.monaco-scrollable-element > .shadow.top {
					box-shadow: ${r} 0 6px 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.left {
					box-shadow: ${r} 6px 0 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.top.left {
					box-shadow: ${r} 6px 6px 6px -6px inset;
				}
			`);
        const a = i.scrollbarSliderBackground;
        a && (o += `
				.monaco-scrollable-element > .scrollbar > .slider {
					background: ${a};
				}
			`);
        const l = i.scrollbarSliderHoverBackground;
        l && (o += `
				.monaco-scrollable-element > .scrollbar > .slider:hover {
					background: ${l};
				}
			`);
        const d = i.scrollbarSliderActiveBackground;
        d && (o += `
				.monaco-scrollable-element > .scrollbar > .slider.active {
					background: ${d};
				}
			`);
      }
      return o;
    })(t, Kw(e));
  }
  styleScrollElement(e, t) {
    var i, s;
    const o = (i = t.foregroundColor) !== null && i !== void 0 ? i : "", r = (s = t.backgroundColor) !== null && s !== void 0 ? s : "", a = t.borderColor ? `1px solid ${t.borderColor}` : "", l = t.shadowColor ? `0 2px 8px ${t.shadowColor}` : "";
    e.style.outline = a, e.style.borderRadius = "5px", e.style.color = o, e.style.backgroundColor = r, e.style.boxShadow = l;
  }
  getContainer() {
    return this.scrollableElement.getDomNode();
  }
  get onScroll() {
    return this.scrollableElement.onScroll;
  }
  focusItemByElement(e) {
    const t = this.focusedItem;
    this.setFocusedItem(e), t !== this.focusedItem && this.updateFocus();
  }
  setFocusedItem(e) {
    for (let t = 0; t < this.actionsList.children.length; t++)
      if (e === this.actionsList.children[t]) {
        this.focusedItem = t;
        break;
      }
  }
  updateFocus(e) {
    super.updateFocus(e, !0, !0), this.focusedItem !== void 0 && this.scrollableElement.setScrollPosition({ scrollTop: Math.round(this.menuElement.scrollTop) });
  }
  doGetActionViewItem(e, t, i) {
    if (e instanceof Ui) return new K3(t.context, e, { icon: !0 }, this.menuStyles);
    if (e instanceof Om) {
      const s = new U3(e, e.actions, i, { ...t, submenuIds: /* @__PURE__ */ new Set([...t.submenuIds || [], e.id]) }, this.menuStyles);
      if (t.enableMnemonics) {
        const o = s.getMnemonic();
        if (o && s.isEnabled()) {
          let r = [];
          this.mnemonics.has(o) && (r = this.mnemonics.get(o)), r.push(s), this.mnemonics.set(o, r);
        }
      }
      return s;
    }
    {
      const s = { enableMnemonics: t.enableMnemonics, useEventAsContext: t.useEventAsContext };
      if (t.getKeyBinding) {
        const r = t.getKeyBinding(e);
        if (r) {
          const a = r.getLabel();
          a && (s.keybinding = a);
        }
      }
      const o = new eV(t.context, e, s, this.menuStyles);
      if (t.enableMnemonics) {
        const r = o.getMnemonic();
        if (r && o.isEnabled()) {
          let a = [];
          this.mnemonics.has(r) && (a = this.mnemonics.get(r)), a.push(o), this.mnemonics.set(r, a);
        }
      }
      return o;
    }
  }
}
class eV extends Gr {
  constructor(e, t, i, s) {
    if (i.isMenu = !0, super(t, t, i), this.menuStyle = s, this.options = i, this.options.icon = i.icon !== void 0 && i.icon, this.options.label = i.label === void 0 || i.label, this.cssClass = "", this.options.label && i.enableMnemonics) {
      const o = this.action.label;
      if (o) {
        const r = QD.exec(o);
        r && (this.mnemonic = (r[1] ? r[1] : r[3]).toLocaleLowerCase());
      }
    }
    this.runOnceToEnableMouseUp = new Et((() => {
      this.element && (this._register(K(this.element, ie.MOUSE_UP, ((o) => {
        if (Ze(o, !0), tr) {
          if (new _r(ke(this.element), o).rightButton) return;
          this.onClick(o);
        } else setTimeout((() => {
          this.onClick(o);
        }), 0);
      }))), this._register(K(this.element, ie.CONTEXT_MENU, ((o) => {
        Ze(o, !0);
      }))));
    }), 100), this._register(this.runOnceToEnableMouseUp);
  }
  render(e) {
    super.render(e), this.element && (this.container = e, this.item = Z(this.element, Q("a.action-menu-item")), this._action.id === Ui.ID ? this.item.setAttribute("role", "presentation") : (this.item.setAttribute("role", "menuitem"), this.mnemonic && this.item.setAttribute("aria-keyshortcuts", `${this.mnemonic}`)), this.check = Z(this.item, Q("span.menu-item-check" + Ee.asCSSSelector(ne.menuSelection))), this.check.setAttribute("role", "none"), this.label = Z(this.item, Q("span.action-label")), this.options.label && this.options.keybinding && (Z(this.item, Q("span.keybinding")).textContent = this.options.keybinding), this.runOnceToEnableMouseUp.schedule(), this.updateClass(), this.updateLabel(), this.updateTooltip(), this.updateEnabled(), this.updateChecked(), this.applyStyle());
  }
  blur() {
    super.blur(), this.applyStyle();
  }
  focus() {
    var e;
    super.focus(), (e = this.item) === null || e === void 0 || e.focus(), this.applyStyle();
  }
  updatePositionInSet(e, t) {
    this.item && (this.item.setAttribute("aria-posinset", `${e}`), this.item.setAttribute("aria-setsize", `${t}`));
  }
  updateLabel() {
    var e;
    if (this.label && this.options.label) {
      Un(this.label);
      let t = wA(this.action.label);
      if (t) {
        const i = (function(o) {
          const r = QD, a = r.exec(o);
          if (!a) return o;
          const l = !a[1];
          return o.replace(r, l ? "$2$3" : "").trim();
        })(t);
        this.options.enableMnemonics || (t = i), this.label.setAttribute("aria-label", i.replace(/&&/g, "&"));
        const s = QD.exec(t);
        if (s) {
          t = Ow(t), JD.lastIndex = 0;
          let o = JD.exec(t);
          for (; o && o[1]; ) o = JD.exec(t);
          const r = (a) => a.replace(/&amp;&amp;/g, "&amp;");
          o ? this.label.append(u1(r(t.substr(0, o.index)), " "), Q("u", { "aria-hidden": "true" }, o[3]), X7(r(t.substr(o.index + o[0].length)), " ")) : this.label.innerText = r(t).trim(), (e = this.item) === null || e === void 0 || e.setAttribute("aria-keyshortcuts", (s[1] ? s[1] : s[3]).toLocaleLowerCase());
        } else this.label.innerText = t.replace(/&&/g, "&").trim();
      }
    }
  }
  updateTooltip() {
  }
  updateClass() {
    this.cssClass && this.item && this.item.classList.remove(...this.cssClass.split(" ")), this.options.icon && this.label ? (this.cssClass = this.action.class || "", this.label.classList.add("icon"), this.cssClass && this.label.classList.add(...this.cssClass.split(" ")), this.updateEnabled()) : this.label && this.label.classList.remove("icon");
  }
  updateEnabled() {
    this.action.enabled ? (this.element && (this.element.classList.remove("disabled"), this.element.removeAttribute("aria-disabled")), this.item && (this.item.classList.remove("disabled"), this.item.removeAttribute("aria-disabled"), this.item.tabIndex = 0)) : (this.element && (this.element.classList.add("disabled"), this.element.setAttribute("aria-disabled", "true")), this.item && (this.item.classList.add("disabled"), this.item.setAttribute("aria-disabled", "true")));
  }
  updateChecked() {
    if (!this.item) return;
    const e = this.action.checked;
    this.item.classList.toggle("checked", !!e), e !== void 0 ? (this.item.setAttribute("role", "menuitemcheckbox"), this.item.setAttribute("aria-checked", e ? "true" : "false")) : (this.item.setAttribute("role", "menuitem"), this.item.setAttribute("aria-checked", ""));
  }
  getMnemonic() {
    return this.mnemonic;
  }
  applyStyle() {
    const e = this.element && this.element.classList.contains("focused"), t = e && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor, i = e && this.menuStyle.selectionBackgroundColor ? this.menuStyle.selectionBackgroundColor : void 0, s = e && this.menuStyle.selectionBorderColor ? `1px solid ${this.menuStyle.selectionBorderColor}` : "", o = e && this.menuStyle.selectionBorderColor ? "-1px" : "";
    this.item && (this.item.style.color = t ?? "", this.item.style.backgroundColor = i ?? "", this.item.style.outline = s, this.item.style.outlineOffset = o), this.check && (this.check.style.color = t ?? "");
  }
}
class U3 extends eV {
  constructor(e, t, i, s, o) {
    super(e, e, s, o), this.submenuActions = t, this.parentData = i, this.submenuOptions = s, this.mysubmenu = null, this.submenuDisposables = this._register(new G()), this.mouseOver = !1, this.expandDirection = s && s.expandDirection !== void 0 ? s.expandDirection : { horizontal: Fy.Right, vertical: XI.Below }, this.showScheduler = new Et((() => {
      this.mouseOver && (this.cleanupExistingSubmenu(!1), this.createSubmenu(!1));
    }), 250), this.hideScheduler = new Et((() => {
      this.element && !gn(Mn(), this.element) && this.parentData.submenu === this.mysubmenu && (this.parentData.parent.focus(!1), this.cleanupExistingSubmenu(!0));
    }), 750);
  }
  render(e) {
    super.render(e), this.element && (this.item && (this.item.classList.add("monaco-submenu-item"), this.item.tabIndex = 0, this.item.setAttribute("aria-haspopup", "true"), this.updateAriaExpanded("false"), this.submenuIndicator = Z(this.item, Q("span.submenu-indicator" + Ee.asCSSSelector(ne.menuSubmenu))), this.submenuIndicator.setAttribute("aria-hidden", "true")), this._register(K(this.element, ie.KEY_UP, ((t) => {
      const i = new jt(t);
      (i.equals(17) || i.equals(3)) && (Ze(t, !0), this.createSubmenu(!0));
    }))), this._register(K(this.element, ie.KEY_DOWN, ((t) => {
      const i = new jt(t);
      Mn() === this.item && (i.equals(17) || i.equals(3)) && Ze(t, !0);
    }))), this._register(K(this.element, ie.MOUSE_OVER, ((t) => {
      this.mouseOver || (this.mouseOver = !0, this.showScheduler.schedule());
    }))), this._register(K(this.element, ie.MOUSE_LEAVE, ((t) => {
      this.mouseOver = !1;
    }))), this._register(K(this.element, ie.FOCUS_OUT, ((t) => {
      this.element && !gn(Mn(), this.element) && this.hideScheduler.schedule();
    }))), this._register(this.parentData.parent.onScroll((() => {
      this.parentData.submenu === this.mysubmenu && (this.parentData.parent.focus(!1), this.cleanupExistingSubmenu(!0));
    }))));
  }
  updateEnabled() {
  }
  onClick(e) {
    Ze(e, !0), this.cleanupExistingSubmenu(!1), this.createSubmenu(!0);
  }
  cleanupExistingSubmenu(e) {
    if (this.parentData.submenu && (e || this.parentData.submenu !== this.mysubmenu)) {
      try {
        this.parentData.submenu.dispose();
      } catch {
      }
      this.parentData.submenu = void 0, this.updateAriaExpanded("false"), this.submenuContainer && (this.submenuDisposables.clear(), this.submenuContainer = void 0);
    }
  }
  calculateSubmenuMenuLayout(e, t, i, s) {
    const o = { top: 0, left: 0 };
    return o.left = Bp(e.width, t.width, { position: s.horizontal === Fy.Right ? 0 : 1, offset: i.left, size: i.width }), o.left >= i.left && o.left < i.left + i.width && (i.left + 10 + t.width <= e.width && (o.left = i.left + 10), i.top += 10, i.height = 0), o.top = Bp(e.height, t.height, { position: 0, offset: i.top, size: 0 }), o.top + t.height === i.top && o.top + i.height + t.height <= e.height && (o.top += i.height), o;
  }
  createSubmenu(e = !0) {
    if (this.element) if (this.parentData.submenu) this.parentData.submenu.focus(!1);
    else {
      this.updateAriaExpanded("true"), this.submenuContainer = Z(this.element, Q("div.monaco-submenu")), this.submenuContainer.classList.add("menubar-menu-items-holder", "context-view");
      const t = ke(this.parentData.parent.domNode).getComputedStyle(this.parentData.parent.domNode), i = parseFloat(t.paddingTop || "0") || 0;
      this.submenuContainer.style.zIndex = "1", this.submenuContainer.style.position = "fixed", this.submenuContainer.style.top = "0", this.submenuContainer.style.left = "0", this.parentData.submenu = new vm(this.submenuContainer, this.submenuActions.length ? this.submenuActions : [new zS()], this.submenuOptions, this.menuStyle);
      const s = this.element.getBoundingClientRect(), o = { top: s.top - i, left: s.left, height: s.height + 2 * i, width: s.width }, r = this.submenuContainer.getBoundingClientRect(), a = ke(this.element), { top: l, left: d } = this.calculateSubmenuMenuLayout(new bt(a.innerWidth, a.innerHeight), bt.lift(r), o, this.expandDirection);
      this.submenuContainer.style.left = d - r.left + "px", this.submenuContainer.style.top = l - r.top + "px", this.submenuDisposables.add(K(this.submenuContainer, ie.KEY_UP, ((h) => {
        new jt(h).equals(15) && (Ze(h, !0), this.parentData.parent.focus(), this.cleanupExistingSubmenu(!0));
      }))), this.submenuDisposables.add(K(this.submenuContainer, ie.KEY_DOWN, ((h) => {
        new jt(h).equals(15) && Ze(h, !0);
      }))), this.submenuDisposables.add(this.parentData.submenu.onDidCancel((() => {
        this.parentData.parent.focus(), this.cleanupExistingSubmenu(!0);
      }))), this.parentData.submenu.focus(e), this.mysubmenu = this.parentData.submenu;
    }
  }
  updateAriaExpanded(e) {
    var t;
    this.item && ((t = this.item) === null || t === void 0 || t.setAttribute("aria-expanded", e));
  }
  applyStyle() {
    super.applyStyle();
    const e = this.element && this.element.classList.contains("focused") && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor;
    this.submenuIndicator && (this.submenuIndicator.style.color = e ?? "");
  }
  dispose() {
    super.dispose(), this.hideScheduler.dispose(), this.mysubmenu && (this.mysubmenu.dispose(), this.mysubmenu = null), this.submenuContainer && (this.submenuContainer = void 0);
  }
}
class K3 extends Qm {
  constructor(e, t, i, s) {
    super(e, t, i), this.menuStyles = s;
  }
  render(e) {
    super.render(e), this.label && (this.label.style.borderBottomColor = this.menuStyles.separatorColor ? `${this.menuStyles.separatorColor}` : "");
  }
}
function j3(n) {
  const e = $7()[n.id];
  return `.codicon-${n.id}:before { content: '\\${e.toString(16)}'; }`;
}
class lte {
  constructor(e, t, i, s) {
    this.contextViewService = e, this.telemetryService = t, this.notificationService = i, this.keybindingService = s, this.focusToReturn = null, this.lastContainer = null, this.block = null, this.blockDisposable = null, this.options = { blockMouse: !0 };
  }
  configure(e) {
    this.options = e;
  }
  showContextMenu(e) {
    const t = e.getActions();
    if (!t.length) return;
    let i;
    this.focusToReturn = Mn();
    const s = e.domForShadowRoot instanceof HTMLElement ? e.domForShadowRoot : void 0;
    this.contextViewService.showContextView({ getAnchor: () => e.getAnchor(), canRelayout: !1, anchorAlignment: e.anchorAlignment, anchorAxisAlignment: e.anchorAxisAlignment, render: (o) => {
      var r;
      this.lastContainer = o;
      const a = e.getMenuClassName ? e.getMenuClassName() : "";
      a && (o.className += " " + a), this.options.blockMouse && (this.block = o.appendChild(Q(".context-view-block")), this.block.style.position = "fixed", this.block.style.cursor = "initial", this.block.style.left = "0", this.block.style.top = "0", this.block.style.width = "100%", this.block.style.height = "100%", this.block.style.zIndex = "-1", (r = this.blockDisposable) === null || r === void 0 || r.dispose(), this.blockDisposable = K(this.block, ie.MOUSE_DOWN, ((c) => c.stopPropagation())));
      const l = new G(), d = e.actionRunner || new lg();
      d.onWillRun(((c) => this.onActionRun(c, !e.skipTelemetry)), this, l), d.onDidRun(this.onDidActionRun, this, l), i = new vm(o, t, { actionViewItemProvider: e.getActionViewItem, context: e.getActionsContext ? e.getActionsContext() : null, actionRunner: d, getKeyBinding: e.getKeyBinding ? e.getKeyBinding : (c) => this.keybindingService.lookupKeybinding(c.id) }, ate), i.onDidCancel((() => this.contextViewService.hideContextView(!0)), null, l), i.onDidBlur((() => this.contextViewService.hideContextView(!0)), null, l);
      const h = ke(o);
      return l.add(K(h, ie.BLUR, (() => this.contextViewService.hideContextView(!0)))), l.add(K(h, ie.MOUSE_DOWN, ((c) => {
        if (c.defaultPrevented) return;
        const u = new _r(h, c);
        let g = u.target;
        if (!u.rightButton) {
          for (; g; ) {
            if (g === o) return;
            g = g.parentElement;
          }
          this.contextViewService.hideContextView(!0);
        }
      }))), yr(l, i);
    }, focus: () => {
      i?.focus(!!e.autoSelectFirstItem);
    }, onHide: (o) => {
      var r, a, l;
      (r = e.onHide) === null || r === void 0 || r.call(e, !!o), this.block && (this.block.remove(), this.block = null), (a = this.blockDisposable) === null || a === void 0 || a.dispose(), this.blockDisposable = null, this.lastContainer && (Mn() === this.lastContainer || gn(Mn(), this.lastContainer)) && ((l = this.focusToReturn) === null || l === void 0 || l.focus()), this.lastContainer = null;
    } }, s, !!s);
  }
  onActionRun(e, t) {
    t && this.telemetryService.publicLog2("workbenchActionExecuted", { id: e.action.id, from: "contextMenu" }), this.contextViewService.hideContextView(!1);
  }
  onDidActionRun(e) {
    e.error && !ya(e.error) && this.notificationService.error(e.error);
  }
}
var dte = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Xg = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let QI = class extends V {
  get contextMenuHandler() {
    return this._contextMenuHandler || (this._contextMenuHandler = new lte(this.contextViewService, this.telemetryService, this.notificationService, this.keybindingService)), this._contextMenuHandler;
  }
  constructor(n, e, t, i, s, o) {
    super(), this.telemetryService = n, this.notificationService = e, this.contextViewService = t, this.keybindingService = i, this.menuService = s, this.contextKeyService = o, this._contextMenuHandler = void 0, this._onDidShowContextMenu = this._store.add(new F()), this.onDidShowContextMenu = this._onDidShowContextMenu.event, this._onDidHideContextMenu = this._store.add(new F());
  }
  configure(n) {
    this.contextMenuHandler.configure(n);
  }
  showContextMenu(n) {
    n = JI.transform(n, this.menuService, this.contextKeyService), this.contextMenuHandler.showContextMenu({ ...n, onHide: (e) => {
      var t;
      (t = n.onHide) === null || t === void 0 || t.call(n, e), this._onDidHideContextMenu.fire();
    } }), ad.getInstance().resetKeyStatus(), this._onDidShowContextMenu.fire();
  }
};
var JI, By;
QI = dte([Xg(0, es), Xg(1, Ri), Xg(2, zd), Xg(3, Dt), Xg(4, Mo), Xg(5, Te)], QI), (function(n) {
  n.transform = function(e, t, i) {
    if (!((s = e) && s.menuId instanceof x)) return e;
    var s;
    const { menuId: o, menuActionOptions: r, contextKeyService: a } = e;
    return { ...e, getActions: () => {
      const l = [];
      if (o) {
        const d = t.createMenu(o, a ?? i);
        (function(h, c, u, g) {
          const p = h.getActions(c), f = ad.getInstance();
          QW(p, u, f.keyStatus.altKey || (Tn || Cs) && f.keyStatus.shiftKey, ((_) => _ === "navigation"));
        })(d, r, l), d.dispose();
      }
      return e.getActions ? Ui.join(e.getActions(), l) : l;
    } };
  };
})(JI || (JI = {})), (function(n) {
  n[n.API = 0] = "API", n[n.USER = 1] = "USER";
})(By || (By = {}));
var NA = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Wy = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let e2 = class {
  constructor(n) {
    this._commandService = n;
  }
  async open(n, e) {
    if (!uR(n, Ue.command)) return !1;
    if (!e?.allowCommands || (typeof n == "string" && (n = Ie.parse(n)), Array.isArray(e.allowCommands) && !e.allowCommands.includes(n.path))) return !0;
    let t = [];
    try {
      t = RI(decodeURIComponent(n.query));
    } catch {
      try {
        t = RI(n.query);
      } catch {
      }
    }
    return Array.isArray(t) || (t = [t]), await this._commandService.executeCommand(n.path, ...t), !0;
  }
};
e2 = NA([Wy(0, ai)], e2);
let t2 = class {
  constructor(n) {
    this._editorService = n;
  }
  async open(n, e) {
    typeof n == "string" && (n = Ie.parse(n));
    const { selection: t, uri: i } = (function(s) {
      let o;
      const r = /^L?(\d+)(?:,(\d+))?(-L?(\d+)(?:,(\d+))?)?/.exec(s.fragment);
      return r && (o = { startLineNumber: parseInt(r[1]), startColumn: r[2] ? parseInt(r[2]) : 1, endLineNumber: r[4] ? parseInt(r[4]) : void 0, endColumn: r[4] ? r[5] ? parseInt(r[5]) : 1 : void 0 }, s = s.with({ fragment: "" })), { selection: o, uri: s };
    })(n);
    return (n = i).scheme === Ue.file && (n = SX(n)), await this._editorService.openCodeEditor({ resource: n, options: { selection: t, source: e?.fromUserGesture ? By.USER : By.API, ...e?.editorOptions } }, this._editorService.getFocusedCodeEditor(), e?.openToSide), !0;
  }
};
t2 = NA([Wy(0, mt)], t2);
let i2 = class {
  constructor(n, e) {
    this._openers = new fs(), this._validators = new fs(), this._resolvers = new fs(), this._resolvedUriTargets = new Di(((t) => t.with({ path: null, fragment: null, query: null }).toString())), this._externalOpeners = new fs(), this._defaultExternalOpener = { openExternal: async (t) => (CO(t, Ue.http, Ue.https) ? k8(t) : It.location.href = t, !0) }, this._openers.push({ open: async (t, i) => !(!i?.openExternal && !CO(t, Ue.mailto, Ue.http, Ue.https, Ue.vsls)) && (await this._doOpenExternal(t, i), !0) }), this._openers.push(new e2(e)), this._openers.push(new t2(n));
  }
  registerOpener(n) {
    return { dispose: this._openers.unshift(n) };
  }
  async open(n, e) {
    var t;
    const i = typeof n == "string" ? Ie.parse(n) : n, s = (t = this._resolvedUriTargets.get(i)) !== null && t !== void 0 ? t : n;
    for (const o of this._validators) if (!await o.shouldOpen(s, e)) return !1;
    for (const o of this._openers)
      if (await o.open(n, e)) return !0;
    return !1;
  }
  async resolveExternalUri(n, e) {
    for (const t of this._resolvers) try {
      const i = await t.resolveExternalUri(n, e);
      if (i) return this._resolvedUriTargets.has(i.resolved) || this._resolvedUriTargets.set(i.resolved, n), i;
    } catch {
    }
    throw new Error("Could not resolve external URI: " + n.toString());
  }
  async _doOpenExternal(n, e) {
    const t = typeof n == "string" ? Ie.parse(n) : n;
    let i, s;
    try {
      i = (await this.resolveExternalUri(t, e)).resolved;
    } catch {
      i = t;
    }
    if (s = typeof n == "string" && t.toString() === i.toString() ? n : encodeURI(i.toString(!0)), e?.allowContributedOpeners) {
      const o = typeof e?.allowContributedOpeners == "string" ? e?.allowContributedOpeners : void 0;
      for (const r of this._externalOpeners)
        if (await r.openExternal(s, { sourceUri: t, preferredOpenerId: o }, et.None)) return !0;
    }
    return this._defaultExternalOpener.openExternal(s, { sourceUri: t }, et.None);
  }
  dispose() {
    this._validators.clear();
  }
};
i2 = NA([Wy(0, mt), Wy(1, ai)], i2);
const Qo = tt("editorWorkerService");
var pi, Vy;
(function(n) {
  n[n.Hint = 1] = "Hint", n[n.Info = 2] = "Info", n[n.Warning = 4] = "Warning", n[n.Error = 8] = "Error";
})(pi || (pi = {})), (function(n) {
  n.compare = function(t, i) {
    return i - t;
  };
  const e = /* @__PURE__ */ Object.create(null);
  e[n.Error] = m(0, "Error"), e[n.Warning] = m(0, "Warning"), e[n.Info] = m(0, "Info"), n.toString = function(t) {
    return e[t] || "";
  }, n.fromSeverity = function(t) {
    switch (t) {
      case ki.Error:
        return n.Error;
      case ki.Warning:
        return n.Warning;
      case ki.Info:
        return n.Info;
      case ki.Ignore:
        return n.Hint;
    }
  }, n.toSeverity = function(t) {
    switch (t) {
      case n.Error:
        return ki.Error;
      case n.Warning:
        return ki.Warning;
      case n.Info:
        return ki.Info;
      case n.Hint:
        return ki.Ignore;
    }
  };
})(pi || (pi = {})), (function(n) {
  function t(i, s) {
    const o = [""];
    return i.source ? o.push(i.source.replace("¦", "\\¦")) : o.push(""), i.code ? typeof i.code == "string" ? o.push(i.code.replace("¦", "\\¦")) : o.push(i.code.value.replace("¦", "\\¦")) : o.push(""), i.severity !== void 0 && i.severity !== null ? o.push(pi.toString(i.severity)) : o.push(""), i.message && s ? o.push(i.message.replace("¦", "\\¦")) : o.push(""), i.startLineNumber !== void 0 && i.startLineNumber !== null ? o.push(i.startLineNumber.toString()) : o.push(""), i.startColumn !== void 0 && i.startColumn !== null ? o.push(i.startColumn.toString()) : o.push(""), i.endLineNumber !== void 0 && i.endLineNumber !== null ? o.push(i.endLineNumber.toString()) : o.push(""), i.endColumn !== void 0 && i.endColumn !== null ? o.push(i.endColumn.toString()) : o.push(""), o.push(""), o.join("¦");
  }
  n.makeKey = function(i) {
    return t(i, !0);
  }, n.makeKeyOptionalMessage = t;
})(Vy || (Vy = {}));
const kl = tt("markerService");
var hte = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, q3 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let n2 = class extends V {
  constructor(n, e) {
    super(), this._markerService = e, this._onDidChangeMarker = this._register(new F()), this._markerDecorations = new Di(), n.getModels().forEach(((t) => this._onModelAdded(t))), this._register(n.onModelAdded(this._onModelAdded, this)), this._register(n.onModelRemoved(this._onModelRemoved, this)), this._register(this._markerService.onMarkerChanged(this._handleMarkerChange, this));
  }
  dispose() {
    super.dispose(), this._markerDecorations.forEach(((n) => n.dispose())), this._markerDecorations.clear();
  }
  getMarker(n, e) {
    const t = this._markerDecorations.get(n);
    return t && t.getMarker(e) || null;
  }
  _handleMarkerChange(n) {
    n.forEach(((e) => {
      const t = this._markerDecorations.get(e);
      t && this._updateDecorations(t);
    }));
  }
  _onModelAdded(n) {
    const e = new cte(n);
    this._markerDecorations.set(n.uri, e), this._updateDecorations(e);
  }
  _onModelRemoved(n) {
    var e;
    const t = this._markerDecorations.get(n.uri);
    t && (t.dispose(), this._markerDecorations.delete(n.uri)), n.uri.scheme !== Ue.inMemory && n.uri.scheme !== Ue.internal && n.uri.scheme !== Ue.vscode || (e = this._markerService) === null || e === void 0 || e.read({ resource: n.uri }).map(((i) => i.owner)).forEach(((i) => this._markerService.remove(i, [n.uri])));
  }
  _updateDecorations(n) {
    const e = this._markerService.read({ resource: n.model.uri, take: 500 });
    n.update(e) && this._onDidChangeMarker.fire(n.model);
  }
};
n2 = hte([q3(0, ni), q3(1, kl)], n2);
class cte extends V {
  constructor(e) {
    super(), this.model = e, this._map = new _q(), this._register(ye((() => {
      this.model.deltaDecorations([...this._map.values()], []), this._map.clear();
    })));
  }
  update(e) {
    const { added: t, removed: i } = (function(a, l) {
      const d = [], h = [];
      for (const c of a) l.has(c) || d.push(c);
      for (const c of l) a.has(c) || h.push(c);
      return { removed: d, added: h };
    })(new Set(this._map.keys()), new Set(e));
    if (t.length === 0 && i.length === 0) return !1;
    const s = i.map(((a) => this._map.get(a))), o = t.map(((a) => ({ range: this._createDecorationRange(this.model, a), options: this._createDecorationOption(a) }))), r = this.model.deltaDecorations(s, o);
    for (const a of i) this._map.delete(a);
    for (let a = 0; a < r.length; a++) this._map.set(t[a], r[a]);
    return !0;
  }
  getMarker(e) {
    return this._map.getKey(e.id);
  }
  _createDecorationRange(e, t) {
    let i = D.lift(t);
    if (t.severity !== pi.Hint || this._hasMarkerTag(t, 1) || this._hasMarkerTag(t, 2) || (i = i.setEndPosition(i.startLineNumber, i.startColumn + 2)), i = e.validateRange(i), i.isEmpty()) {
      const s = e.getLineLastNonWhitespaceColumn(i.startLineNumber) || e.getLineMaxColumn(i.startLineNumber);
      if (s === 1 || i.endColumn >= s) return i;
      const o = e.getWordAtPosition(i.getStartPosition());
      o && (i = new D(i.startLineNumber, o.startColumn, i.endLineNumber, o.endColumn));
    } else if (t.endColumn === Number.MAX_VALUE && t.startColumn === 1 && i.startLineNumber === i.endLineNumber) {
      const s = e.getLineFirstNonWhitespaceColumn(t.startLineNumber);
      s < i.endColumn && (i = new D(i.startLineNumber, s, i.endLineNumber, i.endColumn), t.startColumn = s);
    }
    return i;
  }
  _createDecorationOption(e) {
    let t, i, s, o, r;
    switch (e.severity) {
      case pi.Hint:
        t = this._hasMarkerTag(e, 2) ? void 0 : this._hasMarkerTag(e, 1) ? "squiggly-unnecessary" : "squiggly-hint", s = 0;
        break;
      case pi.Info:
        t = "squiggly-info", i = ui(TZ), s = 10, r = { color: ui(T$), position: 1 };
        break;
      case pi.Warning:
        t = "squiggly-warning", i = ui(MZ), s = 20, r = { color: ui(R$), position: 1 };
        break;
      case pi.Error:
      default:
        t = "squiggly-error", i = ui(IZ), s = 30, r = { color: ui(A$), position: 1 };
    }
    return e.tags && (e.tags.indexOf(1) !== -1 && (o = "squiggly-inline-unnecessary"), e.tags.indexOf(2) !== -1 && (o = "squiggly-inline-deprecated")), { description: "marker-decoration", stickiness: 1, className: t, showIfCollapsed: !0, overviewRuler: { color: i, position: Do.Right }, minimap: r, zIndex: s, inlineClassName: o };
  }
  _hasMarkerTag(e, t) {
    return !!e.tags && e.tags.indexOf(t) >= 0;
  }
}
var gp, ute = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Uf = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
function Zc(n) {
  return n.toString();
}
class gte {
  constructor(e, t, i) {
    this.model = e, this._modelEventListeners = new G(), this.model = e, this._modelEventListeners.add(e.onWillDispose((() => t(e)))), this._modelEventListeners.add(e.onDidChangeLanguage(((s) => i(e, s))));
  }
  dispose() {
    this._modelEventListeners.dispose();
  }
}
const pte = Cs || Je ? 1 : 2;
class mte {
  constructor(e, t, i, s, o, r, a, l) {
    this.uri = e, this.initialUndoRedoSnapshot = t, this.time = i, this.sharesUndoRedoStack = s, this.heapSize = o, this.sha1 = r, this.versionId = a, this.alternativeVersionId = l;
  }
}
let $C = gp = class extends V {
  constructor(n, e, t, i, s) {
    super(), this._configurationService = n, this._resourcePropertiesService = e, this._undoRedoService = t, this._languageService = i, this._languageConfigurationService = s, this._onModelAdded = this._register(new F()), this.onModelAdded = this._onModelAdded.event, this._onModelRemoved = this._register(new F()), this.onModelRemoved = this._onModelRemoved.event, this._onModelModeChanged = this._register(new F()), this.onModelLanguageChanged = this._onModelModeChanged.event, this._modelCreationOptionsByLanguageAndResource = /* @__PURE__ */ Object.create(null), this._models = {}, this._disposedModels = /* @__PURE__ */ new Map(), this._disposedModelsHeapSize = 0, this._register(this._configurationService.onDidChangeConfiguration(((o) => this._updateModelOptions(o)))), this._updateModelOptions(void 0);
  }
  static _readModelOptions(n, e) {
    var t;
    let i = Wn.tabSize;
    if (n.editor && n.editor.tabSize !== void 0) {
      const u = parseInt(n.editor.tabSize, 10);
      isNaN(u) || (i = u), i < 1 && (i = 1);
    }
    let s = "tabSize";
    if (n.editor && n.editor.indentSize !== void 0 && n.editor.indentSize !== "tabSize") {
      const u = parseInt(n.editor.indentSize, 10);
      isNaN(u) || (s = Math.max(u, 1));
    }
    let o = Wn.insertSpaces;
    n.editor && n.editor.insertSpaces !== void 0 && (o = n.editor.insertSpaces !== "false" && !!n.editor.insertSpaces);
    let r = pte;
    const a = n.eol;
    a === `\r
` ? r = 2 : a === `
` && (r = 1);
    let l = Wn.trimAutoWhitespace;
    n.editor && n.editor.trimAutoWhitespace !== void 0 && (l = n.editor.trimAutoWhitespace !== "false" && !!n.editor.trimAutoWhitespace);
    let d = Wn.detectIndentation;
    n.editor && n.editor.detectIndentation !== void 0 && (d = n.editor.detectIndentation !== "false" && !!n.editor.detectIndentation);
    let h = Wn.largeFileOptimizations;
    n.editor && n.editor.largeFileOptimizations !== void 0 && (h = n.editor.largeFileOptimizations !== "false" && !!n.editor.largeFileOptimizations);
    let c = Wn.bracketPairColorizationOptions;
    return !((t = n.editor) === null || t === void 0) && t.bracketPairColorization && typeof n.editor.bracketPairColorization == "object" && (c = { enabled: !!n.editor.bracketPairColorization.enabled, independentColorPoolPerBracketType: !!n.editor.bracketPairColorization.independentColorPoolPerBracketType }), { isForSimpleWidget: e, tabSize: i, indentSize: s, insertSpaces: o, detectIndentation: d, defaultEOL: r, trimAutoWhitespace: l, largeFileOptimizations: h, bracketPairColorizationOptions: c };
  }
  _getEOL(n, e) {
    if (n) return this._resourcePropertiesService.getEOL(n, e);
    const t = this._configurationService.getValue("files.eol", { overrideIdentifier: e });
    return t && typeof t == "string" && t !== "auto" ? t : Gs === 3 || Gs === 2 ? `
` : `\r
`;
  }
  _shouldRestoreUndoStack() {
    const n = this._configurationService.getValue("files.restoreUndoStack");
    return typeof n != "boolean" || n;
  }
  getCreationOptions(n, e, t) {
    const i = typeof n == "string" ? n : n.languageId;
    let s = this._modelCreationOptionsByLanguageAndResource[i + e];
    if (!s) {
      const o = this._configurationService.getValue("editor", { overrideIdentifier: i, resource: e }), r = this._getEOL(e, i);
      s = gp._readModelOptions({ editor: o, eol: r }, t), this._modelCreationOptionsByLanguageAndResource[i + e] = s;
    }
    return s;
  }
  _updateModelOptions(n) {
    const e = this._modelCreationOptionsByLanguageAndResource;
    this._modelCreationOptionsByLanguageAndResource = /* @__PURE__ */ Object.create(null);
    const t = Object.keys(this._models);
    for (let i = 0, s = t.length; i < s; i++) {
      const o = t[i], r = this._models[o], a = r.model.getLanguageId(), l = r.model.uri;
      if (n && !n.affectsConfiguration("editor", { overrideIdentifier: a, resource: l }) && !n.affectsConfiguration("files.eol", { overrideIdentifier: a, resource: l })) continue;
      const d = e[a + l], h = this.getCreationOptions(a, l, r.model.isForSimpleWidget);
      gp._setModelOptionsForModel(r.model, h, d);
    }
  }
  static _setModelOptionsForModel(n, e, t) {
    t && t.defaultEOL !== e.defaultEOL && n.getLineCount() === 1 && n.setEOL(e.defaultEOL === 1 ? 0 : 1), t && t.detectIndentation === e.detectIndentation && t.insertSpaces === e.insertSpaces && t.tabSize === e.tabSize && t.indentSize === e.indentSize && t.trimAutoWhitespace === e.trimAutoWhitespace && So(t.bracketPairColorizationOptions, e.bracketPairColorizationOptions) || (e.detectIndentation ? (n.detectIndentation(e.insertSpaces, e.tabSize), n.updateOptions({ trimAutoWhitespace: e.trimAutoWhitespace, bracketColorizationOptions: e.bracketPairColorizationOptions })) : n.updateOptions({ insertSpaces: e.insertSpaces, tabSize: e.tabSize, indentSize: e.indentSize, trimAutoWhitespace: e.trimAutoWhitespace, bracketColorizationOptions: e.bracketPairColorizationOptions }));
  }
  _insertDisposedModel(n) {
    this._disposedModels.set(Zc(n.uri), n), this._disposedModelsHeapSize += n.heapSize;
  }
  _removeDisposedModel(n) {
    const e = this._disposedModels.get(Zc(n));
    return e && (this._disposedModelsHeapSize -= e.heapSize), this._disposedModels.delete(Zc(n)), e;
  }
  _ensureDisposedModelsHeapSize(n) {
    if (this._disposedModelsHeapSize > n) {
      const e = [];
      for (this._disposedModels.forEach(((t) => {
        t.sharesUndoRedoStack || e.push(t);
      })), e.sort(((t, i) => t.time - i.time)); e.length > 0 && this._disposedModelsHeapSize > n; ) {
        const t = e.shift();
        this._removeDisposedModel(t.uri), t.initialUndoRedoSnapshot !== null && this._undoRedoService.restoreSnapshot(t.initialUndoRedoSnapshot);
      }
    }
  }
  _createModelData(n, e, t, i) {
    const s = this.getCreationOptions(e, t, i), o = new Pa(n, e, s, t, this._undoRedoService, this._languageService, this._languageConfigurationService);
    if (t && this._disposedModels.has(Zc(t))) {
      const l = this._removeDisposedModel(t), d = this._undoRedoService.getElements(t), h = this._getSHA1Computer(), c = !!h.canComputeSHA1(o) && h.computeSHA1(o) === l.sha1;
      if (c || l.sharesUndoRedoStack) {
        for (const u of d.past) jl(u) && u.matchesResource(t) && u.setModel(o);
        for (const u of d.future) jl(u) && u.matchesResource(t) && u.setModel(o);
        this._undoRedoService.setElementsValidFlag(t, !0, ((u) => jl(u) && u.matchesResource(t))), c && (o._overwriteVersionId(l.versionId), o._overwriteAlternativeVersionId(l.alternativeVersionId), o._overwriteInitialUndoRedoSnapshot(l.initialUndoRedoSnapshot));
      } else l.initialUndoRedoSnapshot !== null && this._undoRedoService.restoreSnapshot(l.initialUndoRedoSnapshot);
    }
    const r = Zc(o.uri);
    if (this._models[r]) throw new Error("ModelService: Cannot add model because it already exists!");
    const a = new gte(o, ((l) => this._onWillDispose(l)), ((l, d) => this._onDidChangeLanguage(l, d)));
    return this._models[r] = a, a;
  }
  createModel(n, e, t, i = !1) {
    let s;
    return s = e ? this._createModelData(n, e, t, i) : this._createModelData(n, ko, t, i), this._onModelAdded.fire(s.model), s.model;
  }
  getModels() {
    const n = [], e = Object.keys(this._models);
    for (let t = 0, i = e.length; t < i; t++) {
      const s = e[t];
      n.push(this._models[s].model);
    }
    return n;
  }
  getModel(n) {
    const e = Zc(n), t = this._models[e];
    return t ? t.model : null;
  }
  _schemaShouldMaintainUndoRedoElements(n) {
    return n.scheme === Ue.file || n.scheme === Ue.vscodeRemote || n.scheme === Ue.vscodeUserData || n.scheme === Ue.vscodeNotebookCell || n.scheme === "fake-fs";
  }
  _onWillDispose(n) {
    const e = Zc(n.uri), t = this._models[e], i = this._undoRedoService.getUriComparisonKey(n.uri) !== n.uri.toString();
    let s = !1, o = 0;
    if (i || this._shouldRestoreUndoStack() && this._schemaShouldMaintainUndoRedoElements(n.uri)) {
      const l = this._undoRedoService.getElements(n.uri);
      if (l.past.length > 0 || l.future.length > 0) {
        for (const d of l.past) jl(d) && d.matchesResource(n.uri) && (s = !0, o += d.heapSize(n.uri), d.setModel(n.uri));
        for (const d of l.future) jl(d) && d.matchesResource(n.uri) && (s = !0, o += d.heapSize(n.uri), d.setModel(n.uri));
      }
    }
    const r = gp.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK, a = this._getSHA1Computer();
    if (s) if (i || !(o > r) && a.canComputeSHA1(n)) this._ensureDisposedModelsHeapSize(r - o), this._undoRedoService.setElementsValidFlag(n.uri, !1, ((l) => jl(l) && l.matchesResource(n.uri))), this._insertDisposedModel(new mte(n.uri, t.model.getInitialUndoRedoSnapshot(), Date.now(), i, o, a.computeSHA1(n), n.getVersionId(), n.getAlternativeVersionId()));
    else {
      const l = t.model.getInitialUndoRedoSnapshot();
      l !== null && this._undoRedoService.restoreSnapshot(l);
    }
    else if (!i) {
      const l = t.model.getInitialUndoRedoSnapshot();
      l !== null && this._undoRedoService.restoreSnapshot(l);
    }
    delete this._models[e], t.dispose(), delete this._modelCreationOptionsByLanguageAndResource[n.getLanguageId() + n.uri], this._onModelRemoved.fire(n);
  }
  _onDidChangeLanguage(n, e) {
    const t = e.oldLanguage, i = n.getLanguageId(), s = this.getCreationOptions(t, n.uri, n.isForSimpleWidget), o = this.getCreationOptions(i, n.uri, n.isForSimpleWidget);
    gp._setModelOptionsForModel(n, o, s), this._onModelModeChanged.fire({ model: n, oldLanguageId: t });
  }
  _getSHA1Computer() {
    return new IL();
  }
};
$C.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK = 20971520, $C = gp = ute([Uf(0, Ye), Uf(1, eB), Uf(2, gL), Uf(3, Xt), Uf(4, zt)], $C);
class IL {
  canComputeSHA1(e) {
    return e.getValueLength() <= IL.MAX_MODEL_SIZE;
  }
  computeSHA1(e) {
    const t = new BS(), i = e.createSnapshot();
    let s;
    for (; s = i.read(); ) t.update(s);
    return t.digest();
  }
}
var s2;
IL.MAX_MODEL_SIZE = 10485760, (function(n) {
  n[n.PRESERVE = 0] = "PRESERVE", n[n.LAST = 1] = "LAST";
})(s2 || (s2 = {}));
const Tg = "workbench.contributions.quickaccess";
li.add(Tg, new class {
  constructor() {
    this.providers = [], this.defaultProvider = void 0;
  }
  registerQuickAccessProvider(n) {
    return n.prefix.length === 0 ? this.defaultProvider = n : this.providers.push(n), this.providers.sort(((e, t) => t.prefix.length - e.prefix.length)), ye((() => {
      this.providers.splice(this.providers.indexOf(n), 1), this.defaultProvider === n && (this.defaultProvider = void 0);
    }));
  }
  getQuickAccessProviders() {
    return ha([this.defaultProvider, ...this.providers]);
  }
  getQuickAccessProvider(n) {
    return n && this.providers.find(((e) => n.startsWith(e.prefix))) || void 0 || this.defaultProvider;
  }
}());
const fte = { ctrlCmd: !1, alt: !1 };
var Jm, Kr;
(function(n) {
  n[n.Blur = 1] = "Blur", n[n.Gesture = 2] = "Gesture", n[n.Other = 3] = "Other";
})(Jm || (Jm = {})), (function(n) {
  n[n.NONE = 0] = "NONE", n[n.FIRST = 1] = "FIRST", n[n.SECOND = 2] = "SECOND", n[n.LAST = 3] = "LAST";
})(Kr || (Kr = {}));
const Sa = tt("quickInputService");
var _te = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, $3 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let o2 = class extends V {
  constructor(n, e) {
    super(), this.quickInputService = n, this.instantiationService = e, this.registry = li.as(Tg), this.mapProviderToDescriptor = /* @__PURE__ */ new Map(), this.lastAcceptedPickerValues = /* @__PURE__ */ new Map(), this.visibleQuickAccess = void 0;
  }
  show(n = "", e) {
    this.doShowOrPick(n, !1, e);
  }
  doShowOrPick(n, e, t) {
    var i, s, o;
    const [r, a] = this.getOrInstantiateProvider(n), l = this.visibleQuickAccess, d = l?.descriptor;
    if (l && a && d === a) return n === a.prefix || t?.preserveValue || (l.picker.value = n), void this.adjustValueSelection(l.picker, a, t);
    if (a && !t?.preserveValue) {
      let _;
      if (l && d && d !== a) {
        const v = l.value.substr(d.prefix.length);
        v && (_ = `${a.prefix}${v}`);
      }
      if (!_) {
        const v = r?.defaultFilterValue;
        v === s2.LAST ? _ = this.lastAcceptedPickerValues.get(a) : typeof v == "string" && (_ = `${a.prefix}${v}`);
      }
      typeof _ == "string" && (n = _);
    }
    const h = (i = l?.picker) === null || i === void 0 ? void 0 : i.valueSelection, c = (s = l?.picker) === null || s === void 0 ? void 0 : s.value, u = new G(), g = u.add(this.quickInputService.createQuickPick());
    let p;
    g.value = n, this.adjustValueSelection(g, a, t), g.placeholder = a?.placeholder, g.quickNavigate = t?.quickNavigateConfiguration, g.hideInput = !!g.quickNavigate && !l, (typeof t?.itemActivation == "number" || t?.quickNavigateConfiguration) && (g.itemActivation = (o = t?.itemActivation) !== null && o !== void 0 ? o : Kr.SECOND), g.contextKey = a?.contextKey, g.filterValue = (_) => _.substring(a ? a.prefix.length : 0), e && (p = new _1(), u.add(se.once(g.onWillAccept)(((_) => {
      _.veto(), g.hide();
    })))), u.add(this.registerPickerListeners(g, r, a, n, t?.providerOptions));
    const f = u.add(new Ci());
    return r && u.add(r.provide(g, f.token, t?.providerOptions)), se.once(g.onDidHide)((() => {
      g.selectedItems.length === 0 && f.cancel(), u.dispose(), p?.complete(g.selectedItems.slice(0));
    })), g.show(), h && c === n && (g.valueSelection = h), e ? p?.p : void 0;
  }
  adjustValueSelection(n, e, t) {
    var i;
    let s;
    s = t?.preserveValue ? [n.value.length, n.value.length] : [(i = e?.prefix.length) !== null && i !== void 0 ? i : 0, n.value.length], n.valueSelection = s;
  }
  registerPickerListeners(n, e, t, i, s) {
    const o = new G(), r = this.visibleQuickAccess = { picker: n, descriptor: t, value: i };
    return o.add(ye((() => {
      r === this.visibleQuickAccess && (this.visibleQuickAccess = void 0);
    }))), o.add(n.onDidChangeValue(((a) => {
      const [l] = this.getOrInstantiateProvider(a);
      l !== e ? this.show(a, { preserveValue: !0, providerOptions: s }) : r.value = a;
    }))), t && o.add(n.onDidAccept((() => {
      this.lastAcceptedPickerValues.set(t, n.value);
    }))), o;
  }
  getOrInstantiateProvider(n) {
    const e = this.registry.getQuickAccessProvider(n);
    if (!e) return [void 0, void 0];
    let t = this.mapProviderToDescriptor.get(e);
    return t || (t = this.instantiationService.createInstance(e.ctor), this.mapProviderToDescriptor.set(e, t)), [t, e];
  }
};
o2 = _te([$3(0, Sa), $3(1, Se)], o2);
class bf extends To {
  constructor(e) {
    var t;
    super(), this._onChange = this._register(new F()), this.onChange = this._onChange.event, this._onKeyDown = this._register(new F()), this.onKeyDown = this._onKeyDown.event, this._opts = e, this._checked = this._opts.isChecked;
    const i = ["monaco-custom-toggle"];
    this._opts.icon && (this._icon = this._opts.icon, i.push(...Ee.asClassNameArray(this._icon))), this._opts.actionClassName && i.push(...this._opts.actionClassName.split(" ")), this._checked && i.push("checked"), this.domNode = document.createElement("div"), this._hover = this._register(xr((t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("mouse"), this.domNode, this._opts.title)), this.domNode.classList.add(...i), this._opts.notFocusable || (this.domNode.tabIndex = 0), this.domNode.setAttribute("role", "checkbox"), this.domNode.setAttribute("aria-checked", String(this._checked)), this.domNode.setAttribute("aria-label", this._opts.title), this.applyStyles(), this.onclick(this.domNode, ((s) => {
      this.enabled && (this.checked = !this._checked, this._onChange.fire(!1), s.preventDefault());
    })), this._register(this.ignoreGesture(this.domNode)), this.onkeydown(this.domNode, ((s) => {
      if (s.keyCode === 10 || s.keyCode === 3) return this.checked = !this._checked, this._onChange.fire(!0), s.preventDefault(), void s.stopPropagation();
      this._onKeyDown.fire(s);
    }));
  }
  get enabled() {
    return this.domNode.getAttribute("aria-disabled") !== "true";
  }
  focus() {
    this.domNode.focus();
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    this._checked = e, this.domNode.setAttribute("aria-checked", String(this._checked)), this.domNode.classList.toggle("checked", this._checked), this.applyStyles();
  }
  width() {
    return 22;
  }
  applyStyles() {
    this.domNode && (this.domNode.style.borderColor = this._checked && this._opts.inputActiveOptionBorder || "", this.domNode.style.color = this._checked && this._opts.inputActiveOptionForeground || "inherit", this.domNode.style.backgroundColor = this._checked && this._opts.inputActiveOptionBackground || "");
  }
  enable() {
    this.domNode.setAttribute("aria-disabled", String(!1));
  }
  disable() {
    this.domNode.setAttribute("aria-disabled", String(!0));
  }
}
var vte = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
};
class tV {
  constructor(e) {
    this.nodes = e;
  }
  toString() {
    return this.nodes.map(((e) => typeof e == "string" ? e : e.label)).join("");
  }
}
vte([Li], tV.prototype, "toString", null);
const bte = /\[([^\]]+)\]\(((?:https?:\/\/|command:|file:)[^\)\s]+)(?: (["'])(.+?)(\3))?\)/gi, ex = {}, Cte = new yA("quick-input-button-icon-");
function Hy(n, e, t) {
  let i = n.iconClass || (function(s) {
    if (!s) return;
    let o;
    const r = s.dark.toString();
    return ex[r] ? o = ex[r] : (o = Cte.nextId(), jw(`.${o}, .hc-light .${o}`, `background-image: ${wc(s.light || s.dark)}`), jw(`.vs-dark .${o}, .hc-black .${o}`, `background-image: ${wc(s.dark)}`), ex[r] = o), o;
  })(n.iconPath);
  return n.alwaysVisible && (i = i ? `${i} always-visible` : "always-visible"), { id: e, label: "", tooltip: n.tooltip || "", class: i, enabled: !0, run: t };
}
function wte(n, e, t) {
  wn(e);
  const i = (function(o) {
    const r = [];
    let a, l = 0;
    for (; a = bte.exec(o); ) {
      a.index - l > 0 && r.push(o.substring(l, a.index));
      const [, d, h, , c] = a;
      c ? r.push({ label: d, href: h, title: c }) : r.push({ label: d, href: h }), l = a.index + a[0].length;
    }
    return l < o.length && r.push(o.substring(l)), new tV(r);
  })(n);
  let s = 0;
  for (const o of i.nodes) if (typeof o == "string") e.append(...tc(o));
  else {
    let r = o.title;
    !r && o.href.startsWith("command:") ? r = m(0, "Click to execute command '{0}'", o.href.substring(8)) : r || (r = o.href);
    const a = Q("a", { href: o.href, title: r, tabIndex: s++ }, o.label);
    a.style.textDecoration = "underline";
    const l = (g) => {
      uj(g) && Ze(g, !0), t.callback(o.href);
    }, d = t.disposables.add(new st(a, ie.CLICK)).event, h = t.disposables.add(new st(a, ie.KEY_DOWN)).event, c = se.chain(h, ((g) => g.filter(((p) => {
      const f = new jt(p);
      return f.equals(10) || f.equals(3);
    }))));
    t.disposables.add(Bt.addTarget(a));
    const u = t.disposables.add(new st(a, Vt.Tap)).event;
    se.any(d, u, c)(l, null, t.disposables), e.appendChild(a);
  }
}
class yte {
  get templateId() {
    return this.renderer.templateId;
  }
  constructor(e, t) {
    this.renderer = e, this.modelProvider = t;
  }
  renderTemplate(e) {
    return { data: this.renderer.renderTemplate(e), disposable: V.None };
  }
  renderElement(e, t, i, s) {
    var o;
    if ((o = i.disposable) === null || o === void 0 || o.dispose(), !i.data) return;
    const r = this.modelProvider();
    if (r.isResolved(e)) return this.renderer.renderElement(r.get(e), e, i.data, s);
    const a = new Ci(), l = r.resolve(e, a.token);
    i.disposable = { dispose: () => a.cancel() }, this.renderer.renderPlaceholder(e, i.data), l.then(((d) => this.renderer.renderElement(d, e, i.data, s)));
  }
  disposeTemplate(e) {
    e.disposable && (e.disposable.dispose(), e.disposable = void 0), e.data && (this.renderer.disposeTemplate(e.data), e.data = void 0);
  }
}
class Ste {
  constructor(e, t) {
    this.modelProvider = e, this.accessibilityProvider = t;
  }
  getWidgetAriaLabel() {
    return this.accessibilityProvider.getWidgetAriaLabel();
  }
  getAriaLabel(e) {
    const t = this.modelProvider();
    return t.isResolved(e) ? this.accessibilityProvider.getAriaLabel(t.get(e)) : null;
  }
}
class Lte {
  constructor(e, t, i, s, o = {}) {
    const r = () => this.model, a = s.map(((l) => new yte(l, r)));
    this.list = new uo(e, t, i, a, (function(l, d) {
      return { ...d, accessibilityProvider: d.accessibilityProvider && new Ste(l, d.accessibilityProvider) };
    })(r, o));
  }
  updateOptions(e) {
    this.list.updateOptions(e);
  }
  getHTMLElement() {
    return this.list.getHTMLElement();
  }
  get onDidFocus() {
    return this.list.onDidFocus;
  }
  get widget() {
    return this.list;
  }
  get onDidDispose() {
    return this.list.onDidDispose;
  }
  get onMouseDblClick() {
    return se.map(this.list.onMouseDblClick, (({ element: e, index: t, browserEvent: i }) => ({ element: e === void 0 ? void 0 : this._model.get(e), index: t, browserEvent: i })));
  }
  get onPointer() {
    return se.map(this.list.onPointer, (({ element: e, index: t, browserEvent: i }) => ({ element: e === void 0 ? void 0 : this._model.get(e), index: t, browserEvent: i })));
  }
  get onDidChangeSelection() {
    return se.map(this.list.onDidChangeSelection, (({ elements: e, indexes: t, browserEvent: i }) => ({ elements: e.map(((s) => this._model.get(s))), indexes: t, browserEvent: i })));
  }
  get model() {
    return this._model;
  }
  set model(e) {
    this._model = e, this.list.splice(0, this.list.length, Ds(e.length));
  }
  getFocus() {
    return this.list.getFocus();
  }
  getSelection() {
    return this.list.getSelection();
  }
  getSelectedElements() {
    return this.getSelection().map(((e) => this.model.get(e)));
  }
  style(e) {
    this.list.style(e);
  }
  dispose() {
    this.list.dispose();
  }
}
var ef = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, zy;
(function(n) {
  n.North = "north", n.South = "south", n.East = "east", n.West = "west";
})(zy || (zy = {}));
const kte = new F(), Dte = new F();
class r2 {
  constructor(e) {
    this.el = e, this.disposables = new G();
  }
  get onPointerMove() {
    return this.disposables.add(new st(ke(this.el), "mousemove")).event;
  }
  get onPointerUp() {
    return this.disposables.add(new st(ke(this.el), "mouseup")).event;
  }
  dispose() {
    this.disposables.dispose();
  }
}
ef([Li], r2.prototype, "onPointerMove", null), ef([Li], r2.prototype, "onPointerUp", null);
class a2 {
  get onPointerMove() {
    return this.disposables.add(new st(this.el, Vt.Change)).event;
  }
  get onPointerUp() {
    return this.disposables.add(new st(this.el, Vt.End)).event;
  }
  constructor(e) {
    this.el = e, this.disposables = new G();
  }
  dispose() {
    this.disposables.dispose();
  }
}
ef([Li], a2.prototype, "onPointerMove", null), ef([Li], a2.prototype, "onPointerUp", null);
class Uy {
  get onPointerMove() {
    return this.factory.onPointerMove;
  }
  get onPointerUp() {
    return this.factory.onPointerUp;
  }
  constructor(e) {
    this.factory = e;
  }
  dispose() {
  }
}
ef([Li], Uy.prototype, "onPointerMove", null), ef([Li], Uy.prototype, "onPointerUp", null);
const G3 = "pointer-events-disabled";
class Bn extends V {
  get state() {
    return this._state;
  }
  get orthogonalStartSash() {
    return this._orthogonalStartSash;
  }
  get orthogonalEndSash() {
    return this._orthogonalEndSash;
  }
  set state(e) {
    this._state !== e && (this.el.classList.toggle("disabled", e === 0), this.el.classList.toggle("minimum", e === 1), this.el.classList.toggle("maximum", e === 2), this._state = e, this.onDidEnablementChange.fire(e));
  }
  set orthogonalStartSash(e) {
    if (this._orthogonalStartSash !== e) {
      if (this.orthogonalStartDragHandleDisposables.clear(), this.orthogonalStartSashDisposables.clear(), e) {
        const t = (i) => {
          this.orthogonalStartDragHandleDisposables.clear(), i !== 0 && (this._orthogonalStartDragHandle = Z(this.el, Q(".orthogonal-drag-handle.start")), this.orthogonalStartDragHandleDisposables.add(ye((() => this._orthogonalStartDragHandle.remove()))), this.orthogonalStartDragHandleDisposables.add(new st(this._orthogonalStartDragHandle, "mouseenter")).event((() => Bn.onMouseEnter(e)), void 0, this.orthogonalStartDragHandleDisposables), this.orthogonalStartDragHandleDisposables.add(new st(this._orthogonalStartDragHandle, "mouseleave")).event((() => Bn.onMouseLeave(e)), void 0, this.orthogonalStartDragHandleDisposables));
        };
        this.orthogonalStartSashDisposables.add(e.onDidEnablementChange.event(t, this)), t(e.state);
      }
      this._orthogonalStartSash = e;
    }
  }
  set orthogonalEndSash(e) {
    if (this._orthogonalEndSash !== e) {
      if (this.orthogonalEndDragHandleDisposables.clear(), this.orthogonalEndSashDisposables.clear(), e) {
        const t = (i) => {
          this.orthogonalEndDragHandleDisposables.clear(), i !== 0 && (this._orthogonalEndDragHandle = Z(this.el, Q(".orthogonal-drag-handle.end")), this.orthogonalEndDragHandleDisposables.add(ye((() => this._orthogonalEndDragHandle.remove()))), this.orthogonalEndDragHandleDisposables.add(new st(this._orthogonalEndDragHandle, "mouseenter")).event((() => Bn.onMouseEnter(e)), void 0, this.orthogonalEndDragHandleDisposables), this.orthogonalEndDragHandleDisposables.add(new st(this._orthogonalEndDragHandle, "mouseleave")).event((() => Bn.onMouseLeave(e)), void 0, this.orthogonalEndDragHandleDisposables));
        };
        this.orthogonalEndSashDisposables.add(e.onDidEnablementChange.event(t, this)), t(e.state);
      }
      this._orthogonalEndSash = e;
    }
  }
  constructor(e, t, i) {
    super(), this.hoverDelay = 300, this.hoverDelayer = this._register(new Sr(this.hoverDelay)), this._state = 3, this.onDidEnablementChange = this._register(new F()), this._onDidStart = this._register(new F()), this._onDidChange = this._register(new F()), this._onDidReset = this._register(new F()), this._onDidEnd = this._register(new F()), this.orthogonalStartSashDisposables = this._register(new G()), this.orthogonalStartDragHandleDisposables = this._register(new G()), this.orthogonalEndSashDisposables = this._register(new G()), this.orthogonalEndDragHandleDisposables = this._register(new G()), this.onDidStart = this._onDidStart.event, this.onDidChange = this._onDidChange.event, this.onDidReset = this._onDidReset.event, this.onDidEnd = this._onDidEnd.event, this.linkedSash = void 0, this.el = Z(e, Q(".monaco-sash")), i.orthogonalEdge && this.el.classList.add(`orthogonal-edge-${i.orthogonalEdge}`), Je && this.el.classList.add("mac");
    const s = this._register(new st(this.el, "mousedown")).event;
    this._register(s(((c) => this.onPointerStart(c, new r2(e))), this));
    const o = this._register(new st(this.el, "dblclick")).event;
    this._register(o(this.onPointerDoublePress, this));
    const r = this._register(new st(this.el, "mouseenter")).event;
    this._register(r((() => Bn.onMouseEnter(this))));
    const a = this._register(new st(this.el, "mouseleave")).event;
    this._register(a((() => Bn.onMouseLeave(this)))), this._register(Bt.addTarget(this.el));
    const l = this._register(new st(this.el, Vt.Start)).event;
    this._register(l(((c) => this.onPointerStart(c, new a2(this.el))), this));
    const d = this._register(new st(this.el, Vt.Tap)).event;
    let h;
    this._register(d(((c) => {
      if (h) return clearTimeout(h), h = void 0, void this.onPointerDoublePress(c);
      clearTimeout(h), h = setTimeout((() => h = void 0), 250);
    }), this)), typeof i.size == "number" ? (this.size = i.size, i.orientation === 0 ? this.el.style.width = `${this.size}px` : this.el.style.height = `${this.size}px`) : (this.size = 4, this._register(kte.event(((c) => {
      this.size = c, this.layout();
    })))), this._register(Dte.event(((c) => this.hoverDelay = c))), this.layoutProvider = t, this.orthogonalStartSash = i.orthogonalStartSash, this.orthogonalEndSash = i.orthogonalEndSash, this.orientation = i.orientation || 0, this.orientation === 1 ? (this.el.classList.add("horizontal"), this.el.classList.remove("vertical")) : (this.el.classList.remove("horizontal"), this.el.classList.add("vertical")), this.el.classList.toggle("debug", !1), this.layout();
  }
  onPointerStart(e, t) {
    Ze(e);
    let i = !1;
    if (!e.__orthogonalSashEvent) {
      const u = this.getOrthogonalSash(e);
      u && (i = !0, e.__orthogonalSashEvent = !0, u.onPointerStart(e, new Uy(t)));
    }
    if (this.linkedSash && !e.__linkedSashEvent && (e.__linkedSashEvent = !0, this.linkedSash.onPointerStart(e, new Uy(t))), !this.state) return;
    const s = this.el.ownerDocument.getElementsByTagName("iframe");
    for (const u of s) u.classList.add(G3);
    const o = e.pageX, r = e.pageY, a = e.altKey, l = { startX: o, currentX: o, startY: r, currentY: r, altKey: a };
    this.el.classList.add("active"), this._onDidStart.fire(l);
    const d = Lo(this.el), h = () => {
      let u = "";
      u = i ? "all-scroll" : this.orientation === 1 ? this.state === 1 ? "s-resize" : this.state === 2 ? "n-resize" : Je ? "row-resize" : "ns-resize" : this.state === 1 ? "e-resize" : this.state === 2 ? "w-resize" : Je ? "col-resize" : "ew-resize", d.textContent = `* { cursor: ${u} !important; }`;
    }, c = new G();
    h(), i || this.onDidEnablementChange.event(h, null, c), t.onPointerMove(((u) => {
      Ze(u, !1);
      const g = { startX: o, currentX: u.pageX, startY: r, currentY: u.pageY, altKey: a };
      this._onDidChange.fire(g);
    }), null, c), t.onPointerUp(((u) => {
      Ze(u, !1), this.el.removeChild(d), this.el.classList.remove("active"), this._onDidEnd.fire(), c.dispose();
      for (const g of s) g.classList.remove(G3);
    }), null, c), c.add(t);
  }
  onPointerDoublePress(e) {
    const t = this.getOrthogonalSash(e);
    t && t._onDidReset.fire(), this.linkedSash && this.linkedSash._onDidReset.fire(), this._onDidReset.fire();
  }
  static onMouseEnter(e, t = !1) {
    e.el.classList.contains("active") ? (e.hoverDelayer.cancel(), e.el.classList.add("hover")) : e.hoverDelayer.trigger((() => e.el.classList.add("hover")), e.hoverDelay).then(void 0, (() => {
    })), !t && e.linkedSash && Bn.onMouseEnter(e.linkedSash, !0);
  }
  static onMouseLeave(e, t = !1) {
    e.hoverDelayer.cancel(), e.el.classList.remove("hover"), !t && e.linkedSash && Bn.onMouseLeave(e.linkedSash, !0);
  }
  clearSashHoverState() {
    Bn.onMouseLeave(this);
  }
  layout() {
    if (this.orientation === 0) {
      const e = this.layoutProvider;
      this.el.style.left = e.getVerticalSashLeft(this) - this.size / 2 + "px", e.getVerticalSashTop && (this.el.style.top = e.getVerticalSashTop(this) + "px"), e.getVerticalSashHeight && (this.el.style.height = e.getVerticalSashHeight(this) + "px");
    } else {
      const e = this.layoutProvider;
      this.el.style.top = e.getHorizontalSashTop(this) - this.size / 2 + "px", e.getHorizontalSashLeft && (this.el.style.left = e.getHorizontalSashLeft(this) + "px"), e.getHorizontalSashWidth && (this.el.style.width = e.getHorizontalSashWidth(this) + "px");
    }
  }
  getOrthogonalSash(e) {
    var t;
    const i = (t = e.initialTarget) !== null && t !== void 0 ? t : e.target;
    if (i && i instanceof HTMLElement) return i.classList.contains("orthogonal-drag-handle") ? i.classList.contains("start") ? this.orthogonalStartSash : this.orthogonalEndSash : void 0;
  }
  dispose() {
    super.dispose(), this.el.remove();
  }
}
const xte = { separatorBorder: z.transparent };
class iV {
  set size(e) {
    this._size = e;
  }
  get size() {
    return this._size;
  }
  get visible() {
    return this._cachedVisibleSize === void 0;
  }
  setVisible(e, t) {
    var i, s;
    if (e !== this.visible) {
      e ? (this.size = as(this._cachedVisibleSize, this.viewMinimumSize, this.viewMaximumSize), this._cachedVisibleSize = void 0) : (this._cachedVisibleSize = typeof t == "number" ? t : this.size, this.size = 0), this.container.classList.toggle("visible", e);
      try {
        (s = (i = this.view).setVisible) === null || s === void 0 || s.call(i, e);
      } catch (o) {
        console.error("Splitview: Failed to set visible view"), console.error(o);
      }
    }
  }
  get minimumSize() {
    return this.visible ? this.view.minimumSize : 0;
  }
  get viewMinimumSize() {
    return this.view.minimumSize;
  }
  get maximumSize() {
    return this.visible ? this.view.maximumSize : 0;
  }
  get viewMaximumSize() {
    return this.view.maximumSize;
  }
  get priority() {
    return this.view.priority;
  }
  get proportionalLayout() {
    var e;
    return (e = this.view.proportionalLayout) === null || e === void 0 || e;
  }
  get snap() {
    return !!this.view.snap;
  }
  set enabled(e) {
    this.container.style.pointerEvents = e ? "" : "none";
  }
  constructor(e, t, i, s) {
    this.container = e, this.view = t, this.disposable = s, this._cachedVisibleSize = void 0, typeof i == "number" ? (this._size = i, this._cachedVisibleSize = void 0, e.classList.add("visible")) : (this._size = 0, this._cachedVisibleSize = i.cachedVisibleSize);
  }
  layout(e, t) {
    this.layoutContainer(e);
    try {
      this.view.layout(this.size, e, t);
    } catch (i) {
      console.error("Splitview: Failed to layout view"), console.error(i);
    }
  }
  dispose() {
    this.disposable.dispose();
  }
}
class Nte extends iV {
  layoutContainer(e) {
    this.container.style.top = `${e}px`, this.container.style.height = `${this.size}px`;
  }
}
class Ete extends iV {
  layoutContainer(e) {
    this.container.style.left = `${e}px`, this.container.style.width = `${this.size}px`;
  }
}
var Hl, Ky;
(function(n) {
  n[n.Idle = 0] = "Idle", n[n.Busy = 1] = "Busy";
})(Hl || (Hl = {})), (function(n) {
  n.Distribute = { type: "distribute" }, n.Split = function(e) {
    return { type: "split", index: e };
  }, n.Auto = function(e) {
    return { type: "auto", index: e };
  }, n.Invisible = function(e) {
    return { type: "invisible", cachedVisibleSize: e };
  };
})(Ky || (Ky = {}));
class nV extends V {
  get orthogonalStartSash() {
    return this._orthogonalStartSash;
  }
  get orthogonalEndSash() {
    return this._orthogonalEndSash;
  }
  get startSnappingEnabled() {
    return this._startSnappingEnabled;
  }
  get endSnappingEnabled() {
    return this._endSnappingEnabled;
  }
  set orthogonalStartSash(e) {
    for (const t of this.sashItems) t.sash.orthogonalStartSash = e;
    this._orthogonalStartSash = e;
  }
  set orthogonalEndSash(e) {
    for (const t of this.sashItems) t.sash.orthogonalEndSash = e;
    this._orthogonalEndSash = e;
  }
  set startSnappingEnabled(e) {
    this._startSnappingEnabled !== e && (this._startSnappingEnabled = e, this.updateSashEnablement());
  }
  set endSnappingEnabled(e) {
    this._endSnappingEnabled !== e && (this._endSnappingEnabled = e, this.updateSashEnablement());
  }
  constructor(e, t = {}) {
    var i, s, o, r, a;
    super(), this.size = 0, this._contentSize = 0, this.proportions = void 0, this.viewItems = [], this.sashItems = [], this.state = Hl.Idle, this._onDidSashChange = this._register(new F()), this._onDidSashReset = this._register(new F()), this._startSnappingEnabled = !0, this._endSnappingEnabled = !0, this.onDidSashChange = this._onDidSashChange.event, this.onDidSashReset = this._onDidSashReset.event, this.orientation = (i = t.orientation) !== null && i !== void 0 ? i : 0, this.inverseAltBehavior = (s = t.inverseAltBehavior) !== null && s !== void 0 && s, this.proportionalLayout = (o = t.proportionalLayout) === null || o === void 0 || o, this.getSashOrthogonalSize = t.getSashOrthogonalSize, this.el = document.createElement("div"), this.el.classList.add("monaco-split-view2"), this.el.classList.add(this.orientation === 0 ? "vertical" : "horizontal"), e.appendChild(this.el), this.sashContainer = Z(this.el, Q(".sash-container")), this.viewContainer = Q(".split-view-container"), this.scrollable = this._register(new _f({ forceIntegerValues: !0, smoothScrollDuration: 125, scheduleAtNextAnimationFrame: (d) => Ys(ke(this.el), d) })), this.scrollableElement = this._register(new aL(this.viewContainer, { vertical: this.orientation === 0 ? (r = t.scrollbarVisibility) !== null && r !== void 0 ? r : 1 : 2, horizontal: this.orientation === 1 ? (a = t.scrollbarVisibility) !== null && a !== void 0 ? a : 1 : 2 }, this.scrollable));
    const l = this._register(new st(this.viewContainer, "scroll")).event;
    this._register(l(((d) => {
      const h = this.scrollableElement.getScrollPosition(), c = Math.abs(this.viewContainer.scrollLeft - h.scrollLeft) <= 1 ? void 0 : this.viewContainer.scrollLeft, u = Math.abs(this.viewContainer.scrollTop - h.scrollTop) <= 1 ? void 0 : this.viewContainer.scrollTop;
      c === void 0 && u === void 0 || this.scrollableElement.setScrollPosition({ scrollLeft: c, scrollTop: u });
    }))), this.onDidScroll = this.scrollableElement.onScroll, this._register(this.onDidScroll(((d) => {
      d.scrollTopChanged && (this.viewContainer.scrollTop = d.scrollTop), d.scrollLeftChanged && (this.viewContainer.scrollLeft = d.scrollLeft);
    }))), Z(this.el, this.scrollableElement.getDomNode()), this.style(t.styles || xte), t.descriptor && (this.size = t.descriptor.size, t.descriptor.views.forEach(((d, h) => {
      const c = $s(d.visible) || d.visible ? d.size : { type: "invisible", cachedVisibleSize: d.size }, u = d.view;
      this.doAddView(u, c, h, !0);
    })), this._contentSize = this.viewItems.reduce(((d, h) => d + h.size), 0), this.saveProportions());
  }
  style(e) {
    e.separatorBorder.isTransparent() ? (this.el.classList.remove("separator-border"), this.el.style.removeProperty("--separator-border")) : (this.el.classList.add("separator-border"), this.el.style.setProperty("--separator-border", e.separatorBorder.toString()));
  }
  addView(e, t, i = this.viewItems.length, s) {
    this.doAddView(e, t, i, s);
  }
  layout(e, t) {
    const i = Math.max(this.size, this._contentSize);
    if (this.size = e, this.layoutContext = t, this.proportions) {
      let s = 0;
      for (let o = 0; o < this.viewItems.length; o++) {
        const r = this.viewItems[o], a = this.proportions[o];
        typeof a == "number" ? s += a : e -= r.size;
      }
      for (let o = 0; o < this.viewItems.length; o++) {
        const r = this.viewItems[o], a = this.proportions[o];
        typeof a == "number" && s > 0 && (r.size = as(Math.round(a * e / s), r.minimumSize, r.maximumSize));
      }
    } else {
      const s = Ds(this.viewItems.length), o = s.filter(((a) => this.viewItems[a].priority === 1)), r = s.filter(((a) => this.viewItems[a].priority === 2));
      this.resize(this.viewItems.length - 1, e - i, void 0, o, r);
    }
    this.distributeEmptySpace(), this.layoutViews();
  }
  saveProportions() {
    this.proportionalLayout && this._contentSize > 0 && (this.proportions = this.viewItems.map(((e) => e.proportionalLayout && e.visible ? e.size / this._contentSize : void 0)));
  }
  onSashStart({ sash: e, start: t, alt: i }) {
    for (const a of this.viewItems) a.enabled = !1;
    const s = this.sashItems.findIndex(((a) => a.sash === e)), o = yr(K(this.el.ownerDocument.body, "keydown", ((a) => r(this.sashDragState.current, a.altKey))), K(this.el.ownerDocument.body, "keyup", (() => r(this.sashDragState.current, !1)))), r = (a, l) => {
      const d = this.viewItems.map(((p) => p.size));
      let h, c, u = Number.NEGATIVE_INFINITY, g = Number.POSITIVE_INFINITY;
      if (this.inverseAltBehavior && (l = !l), l)
        if (s === this.sashItems.length - 1) {
          const p = this.viewItems[s];
          u = (p.minimumSize - p.size) / 2, g = (p.maximumSize - p.size) / 2;
        } else {
          const p = this.viewItems[s + 1];
          u = (p.size - p.maximumSize) / 2, g = (p.size - p.minimumSize) / 2;
        }
      if (!l) {
        const p = Ds(s, -1), f = Ds(s + 1, this.viewItems.length), _ = p.reduce(((N, A) => N + (this.viewItems[A].minimumSize - d[A])), 0), v = p.reduce(((N, A) => N + (this.viewItems[A].viewMaximumSize - d[A])), 0), b = f.length === 0 ? Number.POSITIVE_INFINITY : f.reduce(((N, A) => N + (d[A] - this.viewItems[A].minimumSize)), 0), C = f.length === 0 ? Number.NEGATIVE_INFINITY : f.reduce(((N, A) => N + (d[A] - this.viewItems[A].viewMaximumSize)), 0), w = Math.max(_, C), y = Math.min(b, v), L = this.findFirstSnapIndex(p), k = this.findFirstSnapIndex(f);
        if (typeof L == "number") {
          const N = this.viewItems[L], A = Math.floor(N.viewMinimumSize / 2);
          h = { index: L, limitDelta: N.visible ? w - A : w + A, size: N.size };
        }
        if (typeof k == "number") {
          const N = this.viewItems[k], A = Math.floor(N.viewMinimumSize / 2);
          c = { index: k, limitDelta: N.visible ? y + A : y - A, size: N.size };
        }
      }
      this.sashDragState = { start: a, current: a, index: s, sizes: d, minDelta: u, maxDelta: g, alt: l, snapBefore: h, snapAfter: c, disposable: o };
    };
    r(t, i);
  }
  onSashChange({ current: e }) {
    const { index: t, start: i, sizes: s, alt: o, minDelta: r, maxDelta: a, snapBefore: l, snapAfter: d } = this.sashDragState;
    this.sashDragState.current = e;
    const h = e - i, c = this.resize(t, h, s, void 0, void 0, r, a, l, d);
    if (o) {
      const u = t === this.sashItems.length - 1, g = this.viewItems.map(((C) => C.size)), p = u ? t : t + 1, f = this.viewItems[p], _ = f.size - f.maximumSize, v = f.size - f.minimumSize, b = u ? t - 1 : t + 1;
      this.resize(b, -c, g, void 0, void 0, _, v);
    }
    this.distributeEmptySpace(), this.layoutViews();
  }
  onSashEnd(e) {
    this._onDidSashChange.fire(e), this.sashDragState.disposable.dispose(), this.saveProportions();
    for (const t of this.viewItems) t.enabled = !0;
  }
  onViewChange(e, t) {
    const i = this.viewItems.indexOf(e);
    i < 0 || i >= this.viewItems.length || (t = as(t = typeof t == "number" ? t : e.size, e.minimumSize, e.maximumSize), this.inverseAltBehavior && i > 0 ? (this.resize(i - 1, Math.floor((e.size - t) / 2)), this.distributeEmptySpace(), this.layoutViews()) : (e.size = t, this.relayout([i], void 0)));
  }
  resizeView(e, t) {
    if (!(e < 0 || e >= this.viewItems.length)) {
      if (this.state !== Hl.Idle) throw new Error("Cant modify splitview");
      this.state = Hl.Busy;
      try {
        const i = Ds(this.viewItems.length).filter(((a) => a !== e)), s = [...i.filter(((a) => this.viewItems[a].priority === 1)), e], o = i.filter(((a) => this.viewItems[a].priority === 2)), r = this.viewItems[e];
        t = as(t = Math.round(t), r.minimumSize, Math.min(r.maximumSize, this.size)), r.size = t, this.relayout(s, o);
      } finally {
        this.state = Hl.Idle;
      }
    }
  }
  distributeViewSizes() {
    const e = [];
    let t = 0;
    for (const a of this.viewItems) a.maximumSize - a.minimumSize > 0 && (e.push(a), t += a.size);
    const i = Math.floor(t / e.length);
    for (const a of e) a.size = as(i, a.minimumSize, a.maximumSize);
    const s = Ds(this.viewItems.length), o = s.filter(((a) => this.viewItems[a].priority === 1)), r = s.filter(((a) => this.viewItems[a].priority === 2));
    this.relayout(o, r);
  }
  getViewSize(e) {
    return e < 0 || e >= this.viewItems.length ? -1 : this.viewItems[e].size;
  }
  doAddView(e, t, i = this.viewItems.length, s) {
    if (this.state !== Hl.Idle) throw new Error("Cant modify splitview");
    this.state = Hl.Busy;
    try {
      const o = Q(".split-view-view");
      i === this.viewItems.length ? this.viewContainer.appendChild(o) : this.viewContainer.insertBefore(o, this.viewContainer.children.item(i));
      const r = e.onDidChange(((c) => this.onViewChange(d, c))), a = yr(r, ye((() => this.viewContainer.removeChild(o))));
      let l;
      typeof t == "number" ? l = t : (t.type === "auto" && (t = this.areViewsDistributed() ? { type: "distribute" } : { type: "split", index: t.index }), l = t.type === "split" ? this.getViewSize(t.index) / 2 : t.type === "invisible" ? { cachedVisibleSize: t.cachedVisibleSize } : e.minimumSize);
      const d = this.orientation === 0 ? new Nte(o, e, l, a) : new Ete(o, e, l, a);
      if (this.viewItems.splice(i, 0, d), this.viewItems.length > 1) {
        const c = { orthogonalStartSash: this.orthogonalStartSash, orthogonalEndSash: this.orthogonalEndSash }, u = this.orientation === 0 ? new Bn(this.sashContainer, { getHorizontalSashTop: (y) => this.getSashPosition(y), getHorizontalSashWidth: this.getSashOrthogonalSize }, { ...c, orientation: 1 }) : new Bn(this.sashContainer, { getVerticalSashLeft: (y) => this.getSashPosition(y), getVerticalSashHeight: this.getSashOrthogonalSize }, { ...c, orientation: 0 }), g = this.orientation === 0 ? (y) => ({ sash: u, start: y.startY, current: y.currentY, alt: y.altKey }) : (y) => ({ sash: u, start: y.startX, current: y.currentX, alt: y.altKey }), p = se.map(u.onDidStart, g)(this.onSashStart, this), f = se.map(u.onDidChange, g)(this.onSashChange, this), _ = se.map(u.onDidEnd, (() => this.sashItems.findIndex(((y) => y.sash === u)))), v = _(this.onSashEnd, this), b = u.onDidReset((() => {
          const y = this.sashItems.findIndex(((B) => B.sash === u)), L = Ds(y, -1), k = Ds(y + 1, this.viewItems.length), N = this.findFirstSnapIndex(L), A = this.findFirstSnapIndex(k);
          (typeof N != "number" || this.viewItems[N].visible) && (typeof A != "number" || this.viewItems[A].visible) && this._onDidSashReset.fire(y);
        })), C = yr(p, f, v, b, u), w = { sash: u, disposable: C };
        this.sashItems.splice(i - 1, 0, w);
      }
      let h;
      o.appendChild(e.element), typeof t != "number" && t.type === "split" && (h = [t.index]), s || this.relayout([i], h), s || typeof t == "number" || t.type !== "distribute" || this.distributeViewSizes();
    } finally {
      this.state = Hl.Idle;
    }
  }
  relayout(e, t) {
    const i = this.viewItems.reduce(((s, o) => s + o.size), 0);
    this.resize(this.viewItems.length - 1, this.size - i, void 0, e, t), this.distributeEmptySpace(), this.layoutViews(), this.saveProportions();
  }
  resize(e, t, i = this.viewItems.map(((h) => h.size)), s, o, r = Number.NEGATIVE_INFINITY, a = Number.POSITIVE_INFINITY, l, d) {
    if (e < 0 || e >= this.viewItems.length) return 0;
    const h = Ds(e, -1), c = Ds(e + 1, this.viewItems.length);
    if (o) for (const k of o) xk(h, k), xk(c, k);
    if (s) for (const k of s) j1(h, k), j1(c, k);
    const u = h.map(((k) => this.viewItems[k])), g = h.map(((k) => i[k])), p = c.map(((k) => this.viewItems[k])), f = c.map(((k) => i[k])), _ = h.reduce(((k, N) => k + (this.viewItems[N].minimumSize - i[N])), 0), v = h.reduce(((k, N) => k + (this.viewItems[N].maximumSize - i[N])), 0), b = c.length === 0 ? Number.POSITIVE_INFINITY : c.reduce(((k, N) => k + (i[N] - this.viewItems[N].minimumSize)), 0), C = c.length === 0 ? Number.NEGATIVE_INFINITY : c.reduce(((k, N) => k + (i[N] - this.viewItems[N].maximumSize)), 0), w = Math.max(_, C, r), y = Math.min(b, v, a);
    let L = !1;
    if (l) {
      const k = this.viewItems[l.index], N = t >= l.limitDelta;
      L = N !== k.visible, k.setVisible(N, l.size);
    }
    if (!L && d) {
      const k = this.viewItems[d.index], N = t < d.limitDelta;
      L = N !== k.visible, k.setVisible(N, d.size);
    }
    if (L) return this.resize(e, t, i, s, o, r, a);
    for (let k = 0, N = t = as(t, w, y); k < u.length; k++) {
      const A = u[k], B = as(g[k] + N, A.minimumSize, A.maximumSize);
      N -= B - g[k], A.size = B;
    }
    for (let k = 0, N = t; k < p.length; k++) {
      const A = p[k], B = as(f[k] - N, A.minimumSize, A.maximumSize);
      N += B - f[k], A.size = B;
    }
    return t;
  }
  distributeEmptySpace(e) {
    const t = this.viewItems.reduce(((a, l) => a + l.size), 0);
    let i = this.size - t;
    const s = Ds(this.viewItems.length - 1, -1), o = s.filter(((a) => this.viewItems[a].priority === 1)), r = s.filter(((a) => this.viewItems[a].priority === 2));
    for (const a of r) xk(s, a);
    for (const a of o) j1(s, a);
    typeof e == "number" && j1(s, e);
    for (let a = 0; i !== 0 && a < s.length; a++) {
      const l = this.viewItems[s[a]], d = as(l.size + i, l.minimumSize, l.maximumSize);
      i -= d - l.size, l.size = d;
    }
  }
  layoutViews() {
    this._contentSize = this.viewItems.reduce(((t, i) => t + i.size), 0);
    let e = 0;
    for (const t of this.viewItems) t.layout(e, this.layoutContext), e += t.size;
    this.sashItems.forEach(((t) => t.sash.layout())), this.updateSashEnablement(), this.updateScrollableElement();
  }
  updateScrollableElement() {
    this.orientation === 0 ? this.scrollableElement.setScrollDimensions({ height: this.size, scrollHeight: this._contentSize }) : this.scrollableElement.setScrollDimensions({ width: this.size, scrollWidth: this._contentSize });
  }
  updateSashEnablement() {
    let e = !1;
    const t = this.viewItems.map(((l) => e = l.size - l.minimumSize > 0 || e));
    e = !1;
    const i = this.viewItems.map(((l) => e = l.maximumSize - l.size > 0 || e)), s = [...this.viewItems].reverse();
    e = !1;
    const o = s.map(((l) => e = l.size - l.minimumSize > 0 || e)).reverse();
    e = !1;
    const r = s.map(((l) => e = l.maximumSize - l.size > 0 || e)).reverse();
    let a = 0;
    for (let l = 0; l < this.sashItems.length; l++) {
      const { sash: d } = this.sashItems[l];
      a += this.viewItems[l].size;
      const h = !(t[l] && r[l + 1]), c = !(i[l] && o[l + 1]);
      if (h && c) {
        const u = Ds(l, -1), g = Ds(l + 1, this.viewItems.length), p = this.findFirstSnapIndex(u), f = this.findFirstSnapIndex(g), _ = typeof p == "number" && !this.viewItems[p].visible, v = typeof f == "number" && !this.viewItems[f].visible;
        _ && o[l] && (a > 0 || this.startSnappingEnabled) ? d.state = 1 : v && t[l] && (a < this._contentSize || this.endSnappingEnabled) ? d.state = 2 : d.state = 0;
      } else d.state = h && !c ? 1 : !h && c ? 2 : 3;
    }
  }
  getSashPosition(e) {
    let t = 0;
    for (let i = 0; i < this.sashItems.length; i++) if (t += this.viewItems[i].size, this.sashItems[i].sash === e) return t;
    return 0;
  }
  findFirstSnapIndex(e) {
    for (const t of e) {
      const i = this.viewItems[t];
      if (i.visible && i.snap) return t;
    }
    for (const t of e) {
      const i = this.viewItems[t];
      if (i.visible && i.maximumSize - i.minimumSize > 0) return;
      if (!i.visible && i.snap) return t;
    }
  }
  areViewsDistributed() {
    let e, t;
    for (const i of this.viewItems) if (e = e === void 0 ? i.size : Math.min(e, i.size), t = t === void 0 ? i.size : Math.max(t, i.size), t - e > 2) return !1;
    return !0;
  }
  dispose() {
    var e;
    (e = this.sashDragState) === null || e === void 0 || e.disposable.dispose(), Ht(this.viewItems), this.viewItems = [], this.sashItems.forEach(((t) => t.disposable.dispose())), this.sashItems = [], super.dispose();
  }
}
class Ov {
  constructor(e, t, i) {
    this.columns = e, this.getColumnSize = i, this.templateId = Ov.TemplateId, this.renderedTemplates = /* @__PURE__ */ new Set();
    const s = new Map(t.map(((o) => [o.templateId, o])));
    this.renderers = [];
    for (const o of e) {
      const r = s.get(o.templateId);
      if (!r) throw new Error(`Table cell renderer for template id ${o.templateId} not found.`);
      this.renderers.push(r);
    }
  }
  renderTemplate(e) {
    const t = Z(e, Q(".monaco-table-tr")), i = [], s = [];
    for (let r = 0; r < this.columns.length; r++) {
      const a = this.renderers[r], l = Z(t, Q(".monaco-table-td", { "data-col-index": r }));
      l.style.width = `${this.getColumnSize(r)}px`, i.push(l), s.push(a.renderTemplate(l));
    }
    const o = { container: e, cellContainers: i, cellTemplateData: s };
    return this.renderedTemplates.add(o), o;
  }
  renderElement(e, t, i, s) {
    for (let o = 0; o < this.columns.length; o++) {
      const r = this.columns[o].project(e);
      this.renderers[o].renderElement(r, t, i.cellTemplateData[o], s);
    }
  }
  disposeElement(e, t, i, s) {
    for (let o = 0; o < this.columns.length; o++) {
      const r = this.renderers[o];
      if (r.disposeElement) {
        const a = this.columns[o].project(e);
        r.disposeElement(a, t, i.cellTemplateData[o], s);
      }
    }
  }
  disposeTemplate(e) {
    for (let t = 0; t < this.columns.length; t++)
      this.renderers[t].disposeTemplate(e.cellTemplateData[t]);
    Un(e.container), this.renderedTemplates.delete(e);
  }
  layoutColumn(e, t) {
    for (const { cellContainers: i } of this.renderedTemplates) i[e].style.width = `${t}px`;
  }
}
Ov.TemplateId = "row";
class Ite extends V {
  get minimumSize() {
    var e;
    return (e = this.column.minimumWidth) !== null && e !== void 0 ? e : 120;
  }
  get maximumSize() {
    var e;
    return (e = this.column.maximumWidth) !== null && e !== void 0 ? e : Number.POSITIVE_INFINITY;
  }
  get onDidChange() {
    var e;
    return (e = this.column.onDidChangeWidthConstraints) !== null && e !== void 0 ? e : se.None;
  }
  constructor(e, t) {
    super(), this.column = e, this.index = t, this._onDidLayout = new F(), this.onDidLayout = this._onDidLayout.event, this.element = Q(".monaco-table-th", { "data-col-index": t }, e.label), e.tooltip && this._register(xr(Bs("mouse"), this.element, e.tooltip));
  }
  layout(e) {
    this._onDidLayout.fire([this.index, e]);
  }
}
class ML {
  get onDidChangeFocus() {
    return this.list.onDidChangeFocus;
  }
  get onDidChangeSelection() {
    return this.list.onDidChangeSelection;
  }
  get onDidScroll() {
    return this.list.onDidScroll;
  }
  get onMouseDblClick() {
    return this.list.onMouseDblClick;
  }
  get onPointer() {
    return this.list.onPointer;
  }
  get onDidFocus() {
    return this.list.onDidFocus;
  }
  get scrollTop() {
    return this.list.scrollTop;
  }
  set scrollTop(e) {
    this.list.scrollTop = e;
  }
  get scrollHeight() {
    return this.list.scrollHeight;
  }
  get renderHeight() {
    return this.list.renderHeight;
  }
  get onDidDispose() {
    return this.list.onDidDispose;
  }
  constructor(e, t, i, s, o, r) {
    this.virtualDelegate = i, this.domId = "table_id_" + ++ML.InstanceCount, this.disposables = new G(), this.cachedWidth = 0, this.cachedHeight = 0, this.domNode = Z(t, Q(`.monaco-table.${this.domId}`));
    const a = s.map(((c, u) => this.disposables.add(new Ite(c, u)))), l = { size: a.reduce(((c, u) => c + u.column.weight), 0), views: a.map(((c) => ({ size: c.column.weight, view: c }))) };
    this.splitview = this.disposables.add(new nV(this.domNode, { orientation: 1, scrollbarVisibility: 2, getSashOrthogonalSize: () => this.cachedHeight, descriptor: l })), this.splitview.el.style.height = `${i.headerRowHeight}px`, this.splitview.el.style.lineHeight = `${i.headerRowHeight}px`;
    const d = new Ov(s, o, ((c) => this.splitview.getViewSize(c)));
    var h;
    this.list = this.disposables.add(new uo(e, this.domNode, (h = i, { getHeight: (c) => h.getHeight(c), getTemplateId: () => Ov.TemplateId }), [d], r)), se.any(...a.map(((c) => c.onDidLayout)))((([c, u]) => d.layoutColumn(c, u)), null, this.disposables), this.splitview.onDidSashReset(((c) => {
      const u = s.reduce(((p, f) => p + f.weight), 0), g = s[c].weight / u * this.cachedWidth;
      this.splitview.resizeView(c, g);
    }), null, this.disposables), this.styleElement = Lo(this.domNode), this.style(jee);
  }
  updateOptions(e) {
    this.list.updateOptions(e);
  }
  splice(e, t, i = []) {
    this.list.splice(e, t, i);
  }
  getHTMLElement() {
    return this.domNode;
  }
  style(e) {
    const t = [];
    t.push(`.monaco-table.${this.domId} > .monaco-split-view2 .monaco-sash.vertical::before {
			top: ${this.virtualDelegate.headerRowHeight + 1}px;
			height: calc(100% - ${this.virtualDelegate.headerRowHeight}px);
		}`), this.styleElement.textContent = t.join(`
`), this.list.style(e);
  }
  getSelectedElements() {
    return this.list.getSelectedElements();
  }
  getSelection() {
    return this.list.getSelection();
  }
  getFocus() {
    return this.list.getFocus();
  }
  dispose() {
    this.disposables.dispose();
  }
}
ML.InstanceCount = 0;
const Mte = m(0, "Match Case"), Tte = m(0, "Match Whole Word"), Rte = m(0, "Use Regular Expression");
class sV extends bf {
  constructor(e) {
    var t;
    super({ icon: ne.caseSensitive, title: Mte + e.appendTitle, isChecked: e.isChecked, hoverDelegate: (t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("element"), inputActiveOptionBorder: e.inputActiveOptionBorder, inputActiveOptionForeground: e.inputActiveOptionForeground, inputActiveOptionBackground: e.inputActiveOptionBackground });
  }
}
class oV extends bf {
  constructor(e) {
    var t;
    super({ icon: ne.wholeWord, title: Tte + e.appendTitle, isChecked: e.isChecked, hoverDelegate: (t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("element"), inputActiveOptionBorder: e.inputActiveOptionBorder, inputActiveOptionForeground: e.inputActiveOptionForeground, inputActiveOptionBackground: e.inputActiveOptionBackground });
  }
}
class rV extends bf {
  constructor(e) {
    var t;
    super({ icon: ne.regex, title: Rte + e.appendTitle, isChecked: e.isChecked, hoverDelegate: (t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("element"), inputActiveOptionBorder: e.inputActiveOptionBorder, inputActiveOptionForeground: e.inputActiveOptionForeground, inputActiveOptionBackground: e.inputActiveOptionBackground });
  }
}
class Ate {
  constructor(e, t = 0, i = e.length, s = t - 1) {
    this.items = e, this.start = t, this.end = i, this.index = s;
  }
  current() {
    return this.index === this.start - 1 || this.index === this.end ? null : this.items[this.index];
  }
  next() {
    return this.index = Math.min(this.index + 1, this.end), this.current();
  }
  previous() {
    return this.index = Math.max(this.index - 1, this.start - 1), this.current();
  }
  first() {
    return this.index = this.start, this.current();
  }
  last() {
    return this.index = this.end - 1, this.current();
  }
}
class Pte {
  constructor(e = [], t = 10) {
    this._initialize(e), this._limit = t, this._onChange();
  }
  getHistory() {
    return this._elements;
  }
  add(e) {
    this._history.delete(e), this._history.add(e), this._onChange();
  }
  next() {
    return this._navigator.next();
  }
  previous() {
    return this._currentPosition() !== 0 ? this._navigator.previous() : null;
  }
  current() {
    return this._navigator.current();
  }
  first() {
    return this._navigator.first();
  }
  last() {
    return this._navigator.last();
  }
  isLast() {
    return this._currentPosition() >= this._elements.length - 1;
  }
  isNowhere() {
    return this._navigator.current() === null;
  }
  has(e) {
    return this._history.has(e);
  }
  _onChange() {
    this._reduceToLimit();
    const e = this._elements;
    this._navigator = new Ate(e, 0, e.length, e.length);
  }
  _reduceToLimit() {
    const e = this._elements;
    e.length > this._limit && this._initialize(e.slice(e.length - this._limit));
  }
  _currentPosition() {
    const e = this._navigator.current();
    return e ? this._elements.indexOf(e) : -1;
  }
  _initialize(e) {
    this._history = /* @__PURE__ */ new Set();
    for (const t of e) this._history.add(t);
  }
  get _elements() {
    const e = [];
    return this._history.forEach(((t) => e.push(t))), e;
  }
}
const Kf = Q;
let Ote = class extends To {
  constructor(n, e, t) {
    var i;
    super(), this.state = "idle", this.maxHeight = Number.POSITIVE_INFINITY, this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._onDidHeightChange = this._register(new F()), this.onDidHeightChange = this._onDidHeightChange.event, this.contextViewProvider = e, this.options = t, this.message = null, this.placeholder = this.options.placeholder || "", this.tooltip = (i = this.options.tooltip) !== null && i !== void 0 ? i : this.placeholder || "", this.ariaLabel = this.options.ariaLabel || "", this.options.validationOptions && (this.validation = this.options.validationOptions.validation), this.element = Z(n, Kf(".monaco-inputbox.idle"));
    const s = this.options.flexibleHeight ? "textarea" : "input", o = Z(this.element, Kf(".ibwrapper"));
    if (this.input = Z(o, Kf(s + ".input.empty")), this.input.setAttribute("autocorrect", "off"), this.input.setAttribute("autocapitalize", "off"), this.input.setAttribute("spellcheck", "false"), this.onfocus(this.input, (() => this.element.classList.add("synthetic-focus"))), this.onblur(this.input, (() => this.element.classList.remove("synthetic-focus"))), this.options.flexibleHeight) {
      this.maxHeight = typeof this.options.flexibleMaxHeight == "number" ? this.options.flexibleMaxHeight : Number.POSITIVE_INFINITY, this.mirror = Z(o, Kf("div.mirror")), this.mirror.innerText = " ", this.scrollableElement = new SB(this.element, { vertical: 1 }), this.options.flexibleWidth && (this.input.setAttribute("wrap", "off"), this.mirror.style.whiteSpace = "pre", this.mirror.style.wordWrap = "initial"), Z(n, this.scrollableElement.getDomNode()), this._register(this.scrollableElement), this._register(this.scrollableElement.onScroll(((l) => this.input.scrollTop = l.scrollTop)));
      const r = this._register(new st(n.ownerDocument, "selectionchange")), a = se.filter(r.event, (() => {
        const l = n.ownerDocument.getSelection();
        return l?.anchorNode === o;
      }));
      this._register(a(this.updateScrollDimensions, this)), this._register(this.onDidHeightChange(this.updateScrollDimensions, this));
    } else this.input.type = this.options.type || "text", this.input.setAttribute("wrap", "off");
    this.ariaLabel && this.input.setAttribute("aria-label", this.ariaLabel), this.placeholder && !this.options.showPlaceholderOnFocus && this.setPlaceHolder(this.placeholder), this.tooltip && this.setTooltip(this.tooltip), this.oninput(this.input, (() => this.onValueChange())), this.onblur(this.input, (() => this.onBlur())), this.onfocus(this.input, (() => this.onFocus())), this._register(this.ignoreGesture(this.input)), setTimeout((() => this.updateMirror()), 0), this.options.actions && (this.actionbar = this._register(new sr(this.element)), this.actionbar.push(this.options.actions, { icon: !0, label: !1 })), this.applyStyles();
  }
  onBlur() {
    this._hideMessage(), this.options.showPlaceholderOnFocus && this.input.setAttribute("placeholder", "");
  }
  onFocus() {
    this._showMessage(), this.options.showPlaceholderOnFocus && this.input.setAttribute("placeholder", this.placeholder || "");
  }
  setPlaceHolder(n) {
    this.placeholder = n, this.input.setAttribute("placeholder", n);
  }
  setTooltip(n) {
    this.tooltip = n, this.hover ? this.hover.update(n) : this.hover = this._register(xr(Bs("mouse"), this.input, n));
  }
  get inputElement() {
    return this.input;
  }
  get value() {
    return this.input.value;
  }
  set value(n) {
    this.input.value !== n && (this.input.value = n, this.onValueChange());
  }
  get height() {
    return typeof this.cachedHeight == "number" ? this.cachedHeight : rd(this.element);
  }
  focus() {
    this.input.focus();
  }
  blur() {
    this.input.blur();
  }
  hasFocus() {
    return HS(this.input);
  }
  select(n = null) {
    this.input.select(), n && (this.input.setSelectionRange(n.start, n.end), n.end === this.input.value.length && (this.input.scrollLeft = this.input.scrollWidth));
  }
  isSelectionAtEnd() {
    return this.input.selectionEnd === this.input.value.length && this.input.selectionStart === this.input.selectionEnd;
  }
  getSelection() {
    var n;
    const e = this.input.selectionStart;
    return e === null ? null : { start: e, end: (n = this.input.selectionEnd) !== null && n !== void 0 ? n : e };
  }
  enable() {
    this.input.removeAttribute("disabled");
  }
  disable() {
    this.blur(), this.input.disabled = !0, this._hideMessage();
  }
  set paddingRight(n) {
    this.input.style.width = `calc(100% - ${n}px)`, this.mirror && (this.mirror.style.paddingRight = n + "px");
  }
  updateScrollDimensions() {
    if (typeof this.cachedContentHeight != "number" || typeof this.cachedHeight != "number" || !this.scrollableElement) return;
    const n = this.cachedContentHeight, e = this.cachedHeight, t = this.input.scrollTop;
    this.scrollableElement.setScrollDimensions({ scrollHeight: n, height: e }), this.scrollableElement.setScrollPosition({ scrollTop: t });
  }
  showMessage(n, e) {
    if (this.state === "open" && So(this.message, n)) return;
    this.message = n, this.element.classList.remove("idle"), this.element.classList.remove("info"), this.element.classList.remove("warning"), this.element.classList.remove("error"), this.element.classList.add(this.classForType(n.type));
    const t = this.stylesForType(this.message.type);
    this.element.style.border = `1px solid ${kd(t.border, "transparent")}`, this.message.content && (this.hasFocus() || e) && this._showMessage();
  }
  hideMessage() {
    this.message = null, this.element.classList.remove("info"), this.element.classList.remove("warning"), this.element.classList.remove("error"), this.element.classList.add("idle"), this._hideMessage(), this.applyStyles();
  }
  validate() {
    let n = null;
    return this.validation && (n = this.validation(this.value), n ? (this.inputElement.setAttribute("aria-invalid", "true"), this.showMessage(n)) : this.inputElement.hasAttribute("aria-invalid") && (this.inputElement.removeAttribute("aria-invalid"), this.hideMessage())), n?.type;
  }
  stylesForType(n) {
    const e = this.options.inputBoxStyles;
    switch (n) {
      case 1:
        return { border: e.inputValidationInfoBorder, background: e.inputValidationInfoBackground, foreground: e.inputValidationInfoForeground };
      case 2:
        return { border: e.inputValidationWarningBorder, background: e.inputValidationWarningBackground, foreground: e.inputValidationWarningForeground };
      default:
        return { border: e.inputValidationErrorBorder, background: e.inputValidationErrorBackground, foreground: e.inputValidationErrorForeground };
    }
  }
  classForType(n) {
    switch (n) {
      case 1:
        return "info";
      case 2:
        return "warning";
      default:
        return "error";
    }
  }
  _showMessage() {
    if (!this.contextViewProvider || !this.message) return;
    let n;
    const e = () => n.style.width = os(this.element) + "px";
    let t;
    this.contextViewProvider.showContextView({ getAnchor: () => this.element, anchorAlignment: 1, render: (i) => {
      var s, o;
      if (!this.message) return null;
      n = Z(i, Kf(".monaco-inputbox-container")), e();
      const r = { inline: !0, className: "monaco-inputbox-message" }, a = this.message.formatContent ? wJ(this.message.content, r) : (function(d, h = {}) {
        const c = mA(h);
        return c.textContent = d, c;
      })(this.message.content, r);
      a.classList.add(this.classForType(this.message.type));
      const l = this.stylesForType(this.message.type);
      return a.style.backgroundColor = (s = l.background) !== null && s !== void 0 ? s : "", a.style.color = (o = l.foreground) !== null && o !== void 0 ? o : "", a.style.border = l.border ? `1px solid ${l.border}` : "", Z(n, a), null;
    }, onHide: () => {
      this.state = "closed";
    }, layout: e }), t = this.message.type === 3 ? m(0, "Error: {0}", this.message.content) : this.message.type === 2 ? m(0, "Warning: {0}", this.message.content) : m(0, "Info: {0}", this.message.content), Io(t), this.state = "open";
  }
  _hideMessage() {
    this.contextViewProvider && (this.state === "open" && this.contextViewProvider.hideContextView(), this.state = "idle");
  }
  onValueChange() {
    this._onDidChange.fire(this.value), this.validate(), this.updateMirror(), this.input.classList.toggle("empty", !this.value), this.state === "open" && this.contextViewProvider && this.contextViewProvider.layout();
  }
  updateMirror() {
    if (!this.mirror) return;
    const n = this.value, e = n.charCodeAt(n.length - 1) === 10 ? " " : "";
    (n + e).replace(/\u000c/g, "") ? this.mirror.textContent = n + e : this.mirror.innerText = " ", this.layout();
  }
  applyStyles() {
    var n, e, t;
    const i = this.options.inputBoxStyles, s = (n = i.inputBackground) !== null && n !== void 0 ? n : "", o = (e = i.inputForeground) !== null && e !== void 0 ? e : "", r = (t = i.inputBorder) !== null && t !== void 0 ? t : "";
    this.element.style.backgroundColor = s, this.element.style.color = o, this.input.style.backgroundColor = "inherit", this.input.style.color = o, this.element.style.border = `1px solid ${kd(r, "transparent")}`;
  }
  layout() {
    if (!this.mirror) return;
    const n = this.cachedContentHeight;
    this.cachedContentHeight = rd(this.mirror), n !== this.cachedContentHeight && (this.cachedHeight = Math.min(this.cachedContentHeight, this.maxHeight), this.input.style.height = this.cachedHeight + "px", this._onDidHeightChange.fire(this.cachedContentHeight));
  }
  insertAtCursor(n) {
    const e = this.inputElement, t = e.selectionStart, i = e.selectionEnd, s = e.value;
    t !== null && i !== null && (this.value = s.substr(0, t) + n + s.substr(i), e.setSelectionRange(t + 1, t + 1), this.layout());
  }
  dispose() {
    var n;
    this._hideMessage(), this.message = null, (n = this.actionbar) === null || n === void 0 || n.dispose(), super.dispose();
  }
};
class aV extends Ote {
  constructor(e, t, i) {
    const s = m(0, " or {0} for history", "⇅"), o = m(0, " ({0} for history)", "⇅");
    super(e, t, i), this._onDidFocus = this._register(new F()), this.onDidFocus = this._onDidFocus.event, this._onDidBlur = this._register(new F()), this.onDidBlur = this._onDidBlur.event, this.history = new Pte(i.history, 100);
    const r = () => {
      if (i.showHistoryHint && i.showHistoryHint() && !this.placeholder.endsWith(s) && !this.placeholder.endsWith(o) && this.history.getHistory().length) {
        const a = this.placeholder.endsWith(")") ? s : o, l = this.placeholder + a;
        i.showPlaceholderOnFocus && !HS(this.input) ? this.placeholder = l : this.setPlaceHolder(l);
      }
    };
    this.observer = new MutationObserver(((a, l) => {
      a.forEach(((d) => {
        d.target.textContent || r();
      }));
    })), this.observer.observe(this.input, { attributeFilter: ["class"] }), this.onfocus(this.input, (() => r())), this.onblur(this.input, (() => {
      const a = (l) => {
        if (this.placeholder.endsWith(l)) {
          const d = this.placeholder.slice(0, this.placeholder.length - l.length);
          return i.showPlaceholderOnFocus ? this.placeholder = d : this.setPlaceHolder(d), !0;
        }
        return !1;
      };
      a(o) || a(s);
    }));
  }
  dispose() {
    super.dispose(), this.observer && (this.observer.disconnect(), this.observer = void 0);
  }
  addToHistory(e) {
    this.value && (e || this.value !== this.getCurrentValue()) && this.history.add(this.value);
  }
  isAtLastInHistory() {
    return this.history.isLast();
  }
  isNowhereInHistory() {
    return this.history.isNowhere();
  }
  showNextValue() {
    this.history.has(this.value) || this.addToHistory();
    let e = this.getNextValue();
    e && (e = e === this.value ? this.getNextValue() : e), this.value = e ?? "", vl(this.value ? this.value : m(0, "Cleared Input"));
  }
  showPreviousValue() {
    this.history.has(this.value) || this.addToHistory();
    let e = this.getPreviousValue();
    e && (e = e === this.value ? this.getPreviousValue() : e), e && (this.value = e, vl(this.value));
  }
  setPlaceHolder(e) {
    super.setPlaceHolder(e), this.setTooltip(e);
  }
  onBlur() {
    super.onBlur(), this._onDidBlur.fire();
  }
  onFocus() {
    super.onFocus(), this._onDidFocus.fire();
  }
  getCurrentValue() {
    let e = this.history.current();
    return e || (e = this.history.last(), this.history.next()), e;
  }
  getPreviousValue() {
    return this.history.previous() || this.history.first();
  }
  getNextValue() {
    return this.history.next();
  }
}
const Fte = m(0, "input");
class lV extends To {
  constructor(e, t, i) {
    super(), this.fixFocusOnOptionClickEnabled = !0, this.imeSessionInProgress = !1, this.additionalTogglesDisposables = this._register(new rn()), this.additionalToggles = [], this._onDidOptionChange = this._register(new F()), this.onDidOptionChange = this._onDidOptionChange.event, this._onKeyDown = this._register(new F()), this.onKeyDown = this._onKeyDown.event, this._onMouseDown = this._register(new F()), this.onMouseDown = this._onMouseDown.event, this._onInput = this._register(new F()), this._onKeyUp = this._register(new F()), this._onCaseSensitiveKeyDown = this._register(new F()), this.onCaseSensitiveKeyDown = this._onCaseSensitiveKeyDown.event, this._onRegexKeyDown = this._register(new F()), this.onRegexKeyDown = this._onRegexKeyDown.event, this._lastHighlightFindOptions = 0, this.placeholder = i.placeholder || "", this.validation = i.validation, this.label = i.label || Fte, this.showCommonFindToggles = !!i.showCommonFindToggles;
    const s = i.appendCaseSensitiveLabel || "", o = i.appendWholeWordsLabel || "", r = i.appendRegexLabel || "", a = i.history || [], l = !!i.flexibleHeight, d = !!i.flexibleWidth, h = i.flexibleMaxHeight;
    this.domNode = document.createElement("div"), this.domNode.classList.add("monaco-findInput"), this.inputBox = this._register(new aV(this.domNode, t, { placeholder: this.placeholder || "", ariaLabel: this.label || "", validationOptions: { validation: this.validation }, history: a, showHistoryHint: i.showHistoryHint, flexibleHeight: l, flexibleWidth: d, flexibleMaxHeight: h, inputBoxStyles: i.inputBoxStyles }));
    const c = this._register(Zm());
    if (this.showCommonFindToggles) {
      this.regex = this._register(new rV({ appendTitle: r, isChecked: !1, hoverDelegate: c, ...i.toggleStyles })), this._register(this.regex.onChange(((g) => {
        this._onDidOptionChange.fire(g), !g && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      }))), this._register(this.regex.onKeyDown(((g) => {
        this._onRegexKeyDown.fire(g);
      }))), this.wholeWords = this._register(new oV({ appendTitle: o, isChecked: !1, hoverDelegate: c, ...i.toggleStyles })), this._register(this.wholeWords.onChange(((g) => {
        this._onDidOptionChange.fire(g), !g && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      }))), this.caseSensitive = this._register(new sV({ appendTitle: s, isChecked: !1, hoverDelegate: c, ...i.toggleStyles })), this._register(this.caseSensitive.onChange(((g) => {
        this._onDidOptionChange.fire(g), !g && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      }))), this._register(this.caseSensitive.onKeyDown(((g) => {
        this._onCaseSensitiveKeyDown.fire(g);
      })));
      const u = [this.caseSensitive.domNode, this.wholeWords.domNode, this.regex.domNode];
      this.onkeydown(this.domNode, ((g) => {
        if (g.equals(15) || g.equals(17) || g.equals(9)) {
          const p = u.indexOf(this.domNode.ownerDocument.activeElement);
          if (p >= 0) {
            let f = -1;
            g.equals(17) ? f = (p + 1) % u.length : g.equals(15) && (f = p === 0 ? u.length - 1 : p - 1), g.equals(9) ? (u[p].blur(), this.inputBox.focus()) : f >= 0 && u[f].focus(), Ze(g, !0);
          }
        }
      }));
    }
    this.controls = document.createElement("div"), this.controls.className = "controls", this.controls.style.display = this.showCommonFindToggles ? "" : "none", this.caseSensitive && this.controls.append(this.caseSensitive.domNode), this.wholeWords && this.controls.appendChild(this.wholeWords.domNode), this.regex && this.controls.appendChild(this.regex.domNode), this.setAdditionalToggles(i?.additionalToggles), this.controls && this.domNode.appendChild(this.controls), e?.appendChild(this.domNode), this._register(K(this.inputBox.inputElement, "compositionstart", ((u) => {
      this.imeSessionInProgress = !0;
    }))), this._register(K(this.inputBox.inputElement, "compositionend", ((u) => {
      this.imeSessionInProgress = !1, this._onInput.fire();
    }))), this.onkeydown(this.inputBox.inputElement, ((u) => this._onKeyDown.fire(u))), this.onkeyup(this.inputBox.inputElement, ((u) => this._onKeyUp.fire(u))), this.oninput(this.inputBox.inputElement, ((u) => this._onInput.fire())), this.onmousedown(this.inputBox.inputElement, ((u) => this._onMouseDown.fire(u)));
  }
  get onDidChange() {
    return this.inputBox.onDidChange;
  }
  layout(e) {
    this.inputBox.layout(), this.updateInputBoxPadding(e.collapsedFindWidget);
  }
  enable() {
    var e, t, i;
    this.domNode.classList.remove("disabled"), this.inputBox.enable(), (e = this.regex) === null || e === void 0 || e.enable(), (t = this.wholeWords) === null || t === void 0 || t.enable(), (i = this.caseSensitive) === null || i === void 0 || i.enable();
    for (const s of this.additionalToggles) s.enable();
  }
  disable() {
    var e, t, i;
    this.domNode.classList.add("disabled"), this.inputBox.disable(), (e = this.regex) === null || e === void 0 || e.disable(), (t = this.wholeWords) === null || t === void 0 || t.disable(), (i = this.caseSensitive) === null || i === void 0 || i.disable();
    for (const s of this.additionalToggles) s.disable();
  }
  setFocusInputOnOptionClick(e) {
    this.fixFocusOnOptionClickEnabled = e;
  }
  setEnabled(e) {
    e ? this.enable() : this.disable();
  }
  setAdditionalToggles(e) {
    for (const t of this.additionalToggles) t.domNode.remove();
    this.additionalToggles = [], this.additionalTogglesDisposables.value = new G();
    for (const t of e ?? []) this.additionalTogglesDisposables.value.add(t), this.controls.appendChild(t.domNode), this.additionalTogglesDisposables.value.add(t.onChange(((i) => {
      this._onDidOptionChange.fire(i), !i && this.fixFocusOnOptionClickEnabled && this.inputBox.focus();
    }))), this.additionalToggles.push(t);
    this.additionalToggles.length > 0 && (this.controls.style.display = ""), this.updateInputBoxPadding();
  }
  updateInputBoxPadding(e = !1) {
    var t, i, s, o, r, a;
    this.inputBox.paddingRight = e ? 0 : ((i = (t = this.caseSensitive) === null || t === void 0 ? void 0 : t.width()) !== null && i !== void 0 ? i : 0) + ((o = (s = this.wholeWords) === null || s === void 0 ? void 0 : s.width()) !== null && o !== void 0 ? o : 0) + ((a = (r = this.regex) === null || r === void 0 ? void 0 : r.width()) !== null && a !== void 0 ? a : 0) + this.additionalToggles.reduce(((l, d) => l + d.width()), 0);
  }
  getValue() {
    return this.inputBox.value;
  }
  setValue(e) {
    this.inputBox.value !== e && (this.inputBox.value = e);
  }
  select() {
    this.inputBox.select();
  }
  focus() {
    this.inputBox.focus();
  }
  getCaseSensitive() {
    var e, t;
    return (t = (e = this.caseSensitive) === null || e === void 0 ? void 0 : e.checked) !== null && t !== void 0 && t;
  }
  setCaseSensitive(e) {
    this.caseSensitive && (this.caseSensitive.checked = e);
  }
  getWholeWords() {
    var e, t;
    return (t = (e = this.wholeWords) === null || e === void 0 ? void 0 : e.checked) !== null && t !== void 0 && t;
  }
  setWholeWords(e) {
    this.wholeWords && (this.wholeWords.checked = e);
  }
  getRegex() {
    var e, t;
    return (t = (e = this.regex) === null || e === void 0 ? void 0 : e.checked) !== null && t !== void 0 && t;
  }
  setRegex(e) {
    this.regex && (this.regex.checked = e, this.validate());
  }
  focusOnCaseSensitive() {
    var e;
    (e = this.caseSensitive) === null || e === void 0 || e.focus();
  }
  highlightFindOptions() {
    this.domNode.classList.remove("highlight-" + this._lastHighlightFindOptions), this._lastHighlightFindOptions = 1 - this._lastHighlightFindOptions, this.domNode.classList.add("highlight-" + this._lastHighlightFindOptions);
  }
  validate() {
    this.inputBox.validate();
  }
  showMessage(e) {
    this.inputBox.showMessage(e);
  }
  clearMessage() {
    this.inputBox.hideMessage();
  }
}
var co, Au, tf, Cd, pg;
(function(n) {
  n[n.Expanded = 0] = "Expanded", n[n.Collapsed = 1] = "Collapsed", n[n.PreserveOrExpanded = 2] = "PreserveOrExpanded", n[n.PreserveOrCollapsed = 3] = "PreserveOrCollapsed";
})(co || (co = {})), (function(n) {
  n[n.Unknown = 0] = "Unknown", n[n.Twistie = 1] = "Twistie", n[n.Element = 2] = "Element", n[n.Filter = 3] = "Filter";
})(Au || (Au = {}));
class _o extends Error {
  constructor(e, t) {
    super(`TreeError [${e}] ${t}`);
  }
}
class EA {
  constructor(e) {
    this.fn = e, this._map = /* @__PURE__ */ new WeakMap();
  }
  map(e) {
    let t = this._map.get(e);
    return t || (t = this.fn(e), this._map.set(e, t)), t;
  }
}
function IA(n) {
  return typeof n == "object" && "visibility" in n && "data" in n;
}
function Fv(n) {
  switch (n) {
    case !0:
      return 1;
    case !1:
      return 0;
    default:
      return n;
  }
}
function tx(n) {
  return typeof n.collapsible == "boolean";
}
class Bte {
  constructor(e, t, i, s = {}) {
    var o;
    this.user = e, this.list = t, this.rootRef = [], this.eventBufferer = new JT(), this._onDidChangeCollapseState = new F(), this.onDidChangeCollapseState = this.eventBufferer.wrapEvent(this._onDidChangeCollapseState.event), this._onDidChangeRenderNodeCount = new F(), this.onDidChangeRenderNodeCount = this.eventBufferer.wrapEvent(this._onDidChangeRenderNodeCount.event), this._onDidSplice = new F(), this.onDidSplice = this._onDidSplice.event, this.refilterDelayer = new Sr(o8), this.collapseByDefault = s.collapseByDefault !== void 0 && s.collapseByDefault, this.allowNonCollapsibleParents = (o = s.allowNonCollapsibleParents) !== null && o !== void 0 && o, this.filter = s.filter, this.autoExpandSingleChildren = s.autoExpandSingleChildren !== void 0 && s.autoExpandSingleChildren, this.root = { parent: void 0, element: i, children: [], depth: 0, visibleChildrenCount: 0, visibleChildIndex: -1, collapsible: !1, collapsed: !1, renderNodeCount: 0, visibility: 1, visible: !0, filterData: void 0 };
  }
  splice(e, t, i = at.empty(), s = {}) {
    if (e.length === 0) throw new _o(this.user, "Invalid tree location");
    s.diffIdentityProvider ? this.spliceSmart(s.diffIdentityProvider, e, t, i, s) : this.spliceSimple(e, t, i, s);
  }
  spliceSmart(e, t, i, s, o, r) {
    var a;
    s === void 0 && (s = at.empty()), r === void 0 && (r = (a = o.diffDepth) !== null && a !== void 0 ? a : 0);
    const { parentNode: l } = this.getParentNodeWithListIndex(t);
    if (!l.lastDiffIds) return this.spliceSimple(t, i, s, o);
    const d = [...s], h = t[t.length - 1], c = new qa({ getElements: () => l.lastDiffIds }, { getElements: () => [...l.children.slice(0, h), ...d, ...l.children.slice(h + i)].map(((_) => e.getId(_.element).toString())) }).ComputeDiff(!1);
    if (c.quitEarly) return l.lastDiffIds = void 0, this.spliceSimple(t, i, d, o);
    const u = t.slice(0, -1), g = (_, v, b) => {
      if (r > 0) for (let C = 0; C < b; C++) _--, v--, this.spliceSmart(e, [...u, _, 0], Number.MAX_SAFE_INTEGER, d[v].children, o, r - 1);
    };
    let p = Math.min(l.children.length, h + i), f = d.length;
    for (const _ of c.changes.sort(((v, b) => b.originalStart - v.originalStart))) g(p, f, p - (_.originalStart + _.originalLength)), p = _.originalStart, f = _.modifiedStart - h, this.spliceSimple([...u, p], _.originalLength, at.slice(d, f, f + _.modifiedLength), o);
    g(p, f, p);
  }
  spliceSimple(e, t, i = at.empty(), { onDidCreateNode: s, onDidDeleteNode: o, diffIdentityProvider: r }) {
    const { parentNode: a, listIndex: l, revealed: d, visible: h } = this.getParentNodeWithListIndex(e), c = [], u = at.map(i, ((y) => this.createTreeNode(y, a, a.visible ? 1 : 0, d, c, s))), g = e[e.length - 1];
    let p = 0;
    for (let y = g; y >= 0 && y < a.children.length; y--) {
      const L = a.children[y];
      if (L.visible) {
        p = L.visibleChildIndex;
        break;
      }
    }
    const f = [];
    let _ = 0, v = 0;
    for (const y of u) f.push(y), v += y.renderNodeCount, y.visible && (y.visibleChildIndex = p + _++);
    const b = ZP(a.children, g, t, f);
    r ? a.lastDiffIds ? ZP(a.lastDiffIds, g, t, f.map(((y) => r.getId(y.element).toString()))) : a.lastDiffIds = a.children.map(((y) => r.getId(y.element).toString())) : a.lastDiffIds = void 0;
    let C = 0;
    for (const y of b) y.visible && C++;
    if (C !== 0) for (let y = g + f.length; y < a.children.length; y++) {
      const L = a.children[y];
      L.visible && (L.visibleChildIndex -= C);
    }
    if (a.visibleChildrenCount += _ - C, d && h) {
      const y = b.reduce(((L, k) => L + (k.visible ? k.renderNodeCount : 0)), 0);
      this._updateAncestorsRenderNodeCount(a, v - y), this.list.splice(l, y, c);
    }
    if (b.length > 0 && o) {
      const y = (L) => {
        o(L), L.children.forEach(y);
      };
      b.forEach(y);
    }
    this._onDidSplice.fire({ insertedNodes: f, deletedNodes: b });
    let w = a;
    for (; w; ) {
      if (w.visibility === 2) {
        this.refilterDelayer.trigger((() => this.refilter()));
        break;
      }
      w = w.parent;
    }
  }
  rerender(e) {
    if (e.length === 0) throw new _o(this.user, "Invalid tree location");
    const { node: t, listIndex: i, revealed: s } = this.getTreeNodeWithListIndex(e);
    t.visible && s && this.list.splice(i, 1, [t]);
  }
  has(e) {
    return this.hasTreeNode(e);
  }
  getListIndex(e) {
    const { listIndex: t, visible: i, revealed: s } = this.getTreeNodeWithListIndex(e);
    return i && s ? t : -1;
  }
  getListRenderCount(e) {
    return this.getTreeNode(e).renderNodeCount;
  }
  isCollapsible(e) {
    return this.getTreeNode(e).collapsible;
  }
  setCollapsible(e, t) {
    const i = this.getTreeNode(e);
    t === void 0 && (t = !i.collapsible);
    const s = { collapsible: t };
    return this.eventBufferer.bufferEvents((() => this._setCollapseState(e, s)));
  }
  isCollapsed(e) {
    return this.getTreeNode(e).collapsed;
  }
  setCollapsed(e, t, i) {
    const s = this.getTreeNode(e);
    t === void 0 && (t = !s.collapsed);
    const o = { collapsed: t, recursive: i || !1 };
    return this.eventBufferer.bufferEvents((() => this._setCollapseState(e, o)));
  }
  _setCollapseState(e, t) {
    const { node: i, listIndex: s, revealed: o } = this.getTreeNodeWithListIndex(e), r = this._setListNodeCollapseState(i, s, o, t);
    if (i !== this.root && this.autoExpandSingleChildren && r && !tx(t) && i.collapsible && !i.collapsed && !t.recursive) {
      let a = -1;
      for (let l = 0; l < i.children.length; l++)
        if (i.children[l].visible) {
          if (a > -1) {
            a = -1;
            break;
          }
          a = l;
        }
      a > -1 && this._setCollapseState([...e, a], t);
    }
    return r;
  }
  _setListNodeCollapseState(e, t, i, s) {
    const o = this._setNodeCollapseState(e, s, !1);
    if (!i || !e.visible || !o) return o;
    const r = e.renderNodeCount, a = this.updateNodeAfterCollapseChange(e), l = r - (t === -1 ? 0 : 1);
    return this.list.splice(t + 1, l, a.slice(1)), o;
  }
  _setNodeCollapseState(e, t, i) {
    let s;
    if (e === this.root ? s = !1 : (tx(t) ? (s = e.collapsible !== t.collapsible, e.collapsible = t.collapsible) : e.collapsible ? (s = e.collapsed !== t.collapsed, e.collapsed = t.collapsed) : s = !1, s && this._onDidChangeCollapseState.fire({ node: e, deep: i })), !tx(t) && t.recursive) for (const o of e.children) s = this._setNodeCollapseState(o, t, !0) || s;
    return s;
  }
  expandTo(e) {
    this.eventBufferer.bufferEvents((() => {
      let t = this.getTreeNode(e);
      for (; t.parent; ) t = t.parent, e = e.slice(0, e.length - 1), t.collapsed && this._setCollapseState(e, { collapsed: !1, recursive: !1 });
    }));
  }
  refilter() {
    const e = this.root.renderNodeCount, t = this.updateNodeAfterFilterChange(this.root);
    this.list.splice(0, e, t), this.refilterDelayer.cancel();
  }
  createTreeNode(e, t, i, s, o, r) {
    const a = { parent: t, element: e.element, children: [], depth: t.depth + 1, visibleChildrenCount: 0, visibleChildIndex: -1, collapsible: typeof e.collapsible == "boolean" ? e.collapsible : e.collapsed !== void 0, collapsed: e.collapsed === void 0 ? this.collapseByDefault : e.collapsed, renderNodeCount: 1, visibility: 1, visible: !0, filterData: void 0 }, l = this._filterNode(a, i);
    a.visibility = l, s && o.push(a);
    const d = e.children || at.empty(), h = s && l !== 0 && !a.collapsed;
    let c = 0, u = 1;
    for (const g of d) {
      const p = this.createTreeNode(g, a, l, h, o, r);
      a.children.push(p), u += p.renderNodeCount, p.visible && (p.visibleChildIndex = c++);
    }
    return this.allowNonCollapsibleParents || (a.collapsible = a.collapsible || a.children.length > 0), a.visibleChildrenCount = c, a.visible = l === 2 ? c > 0 : l === 1, a.visible ? a.collapsed || (a.renderNodeCount = u) : (a.renderNodeCount = 0, s && o.pop()), r?.(a), a;
  }
  updateNodeAfterCollapseChange(e) {
    const t = e.renderNodeCount, i = [];
    return this._updateNodeAfterCollapseChange(e, i), this._updateAncestorsRenderNodeCount(e.parent, i.length - t), i;
  }
  _updateNodeAfterCollapseChange(e, t) {
    if (e.visible === !1) return 0;
    if (t.push(e), e.renderNodeCount = 1, !e.collapsed) for (const i of e.children) e.renderNodeCount += this._updateNodeAfterCollapseChange(i, t);
    return this._onDidChangeRenderNodeCount.fire(e), e.renderNodeCount;
  }
  updateNodeAfterFilterChange(e) {
    const t = e.renderNodeCount, i = [];
    return this._updateNodeAfterFilterChange(e, e.visible ? 1 : 0, i), this._updateAncestorsRenderNodeCount(e.parent, i.length - t), i;
  }
  _updateNodeAfterFilterChange(e, t, i, s = !0) {
    let o;
    if (e !== this.root) {
      if (o = this._filterNode(e, t), o === 0) return e.visible = !1, e.renderNodeCount = 0, !1;
      s && i.push(e);
    }
    const r = i.length;
    e.renderNodeCount = e === this.root ? 0 : 1;
    let a = !1;
    if (e.collapsed && o === 0) e.visibleChildrenCount = 0;
    else {
      let l = 0;
      for (const d of e.children) a = this._updateNodeAfterFilterChange(d, o, i, s && !e.collapsed) || a, d.visible && (d.visibleChildIndex = l++);
      e.visibleChildrenCount = l;
    }
    return e !== this.root && (e.visible = o === 2 ? a : o === 1, e.visibility = o), e.visible ? e.collapsed || (e.renderNodeCount += i.length - r) : (e.renderNodeCount = 0, s && i.pop()), this._onDidChangeRenderNodeCount.fire(e), e.visible;
  }
  _updateAncestorsRenderNodeCount(e, t) {
    if (t !== 0) for (; e; ) e.renderNodeCount += t, this._onDidChangeRenderNodeCount.fire(e), e = e.parent;
  }
  _filterNode(e, t) {
    const i = this.filter ? this.filter.filter(e.element, t) : 1;
    return typeof i == "boolean" ? (e.filterData = void 0, i ? 1 : 0) : IA(i) ? (e.filterData = i.data, Fv(i.visibility)) : (e.filterData = void 0, Fv(i));
  }
  hasTreeNode(e, t = this.root) {
    if (!e || e.length === 0) return !0;
    const [i, ...s] = e;
    return !(i < 0 || i > t.children.length) && this.hasTreeNode(s, t.children[i]);
  }
  getTreeNode(e, t = this.root) {
    if (!e || e.length === 0) return t;
    const [i, ...s] = e;
    if (i < 0 || i > t.children.length) throw new _o(this.user, "Invalid tree location");
    return this.getTreeNode(s, t.children[i]);
  }
  getTreeNodeWithListIndex(e) {
    if (e.length === 0) return { node: this.root, listIndex: -1, revealed: !0, visible: !1 };
    const { parentNode: t, listIndex: i, revealed: s, visible: o } = this.getParentNodeWithListIndex(e), r = e[e.length - 1];
    if (r < 0 || r > t.children.length) throw new _o(this.user, "Invalid tree location");
    const a = t.children[r];
    return { node: a, listIndex: i, revealed: s, visible: o && a.visible };
  }
  getParentNodeWithListIndex(e, t = this.root, i = 0, s = !0, o = !0) {
    const [r, ...a] = e;
    if (r < 0 || r > t.children.length) throw new _o(this.user, "Invalid tree location");
    for (let l = 0; l < r; l++) i += t.children[l].renderNodeCount;
    return s = s && !t.collapsed, o = o && t.visible, a.length === 0 ? { parentNode: t, listIndex: i, revealed: s, visible: o } : this.getParentNodeWithListIndex(a, t.children[r], i + 1, s, o);
  }
  getNode(e = []) {
    return this.getTreeNode(e);
  }
  getNodeLocation(e) {
    const t = [];
    let i = e;
    for (; i.parent; ) t.push(i.parent.children.indexOf(i)), i = i.parent;
    return t.reverse();
  }
  getParentNodeLocation(e) {
    return e.length === 0 ? void 0 : e.length === 1 ? [] : (function(t) {
      if (t.length === 0) throw new Error("Invalid tail call");
      return [t.slice(0, t.length - 1), t[t.length - 1]];
    })(e)[0];
  }
  getFirstElementChild(e) {
    const t = this.getTreeNode(e);
    if (t.children.length !== 0) return t.children[0].element;
  }
}
class Wte extends T1 {
  constructor(e) {
    super(e.elements.map(((t) => t.element))), this.data = e;
  }
}
function ix(n) {
  return n instanceof T1 ? new Wte(n) : n;
}
class Vte {
  constructor(e, t) {
    this.modelProvider = e, this.dnd = t, this.autoExpandDisposable = V.None, this.disposables = new G();
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e.element);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel) return this.dnd.getDragLabel(e.map(((i) => i.element)), t);
  }
  onDragStart(e, t) {
    var i, s;
    (s = (i = this.dnd).onDragStart) === null || s === void 0 || s.call(i, ix(e), t);
  }
  onDragOver(e, t, i, s, o, r = !0) {
    const a = this.dnd.onDragOver(ix(e), t && t.element, i, s, o), l = this.autoExpandNode !== t;
    if (l && (this.autoExpandDisposable.dispose(), this.autoExpandNode = t), t === void 0) return a;
    if (l && typeof a != "boolean" && a.autoExpand && (this.autoExpandDisposable = bc((() => {
      const g = this.modelProvider(), p = g.getNodeLocation(t);
      g.isCollapsed(p) && g.setCollapsed(p, !1), this.autoExpandNode = void 0;
    }), 500, this.disposables)), typeof a == "boolean" || !a.accept || a.bubble === void 0 || a.feedback)
      return r ? a : { accept: typeof a == "boolean" ? a : a.accept, effect: typeof a == "boolean" ? void 0 : a.effect, feedback: [i] };
    if (a.bubble === 1) {
      const g = this.modelProvider(), p = g.getNodeLocation(t), f = g.getParentNodeLocation(p), _ = g.getNode(f), v = f && g.getListIndex(f);
      return this.onDragOver(e, _, v, s, o, !1);
    }
    const d = this.modelProvider(), h = d.getNodeLocation(t), c = d.getListIndex(h), u = d.getListRenderCount(h);
    return { ...a, feedback: Ds(c, c + u) };
  }
  drop(e, t, i, s, o) {
    this.autoExpandDisposable.dispose(), this.autoExpandNode = void 0, this.dnd.drop(ix(e), t && t.element, i, s, o);
  }
  onDragEnd(e) {
    var t, i;
    (i = (t = this.dnd).onDragEnd) === null || i === void 0 || i.call(t, e);
  }
  dispose() {
    this.disposables.dispose(), this.dnd.dispose();
  }
}
class MA {
  constructor(e) {
    this.delegate = e;
  }
  getHeight(e) {
    return this.delegate.getHeight(e.element);
  }
  getTemplateId(e) {
    return this.delegate.getTemplateId(e.element);
  }
  hasDynamicHeight(e) {
    return !!this.delegate.hasDynamicHeight && this.delegate.hasDynamicHeight(e.element);
  }
  setDynamicHeight(e, t) {
    var i, s;
    (s = (i = this.delegate).setDynamicHeight) === null || s === void 0 || s.call(i, e.element, t);
  }
}
(function(n) {
  n.None = "none", n.OnHover = "onHover", n.Always = "always";
})(tf || (tf = {}));
class Hte {
  get elements() {
    return this._elements;
  }
  constructor(e, t = []) {
    this._elements = t, this.disposables = new G(), this.onDidChange = se.forEach(e, ((i) => this._elements = i), this.disposables);
  }
  dispose() {
    this.disposables.dispose();
  }
}
class Bv {
  constructor(e, t, i, s, o, r = {}) {
    var a;
    this.renderer = e, this.modelProvider = t, this.activeNodes = s, this.renderedIndentGuides = o, this.renderedElements = /* @__PURE__ */ new Map(), this.renderedNodes = /* @__PURE__ */ new Map(), this.indent = Bv.DefaultIndent, this.hideTwistiesOfChildlessElements = !1, this.shouldRenderIndentGuides = !1, this.activeIndentNodes = /* @__PURE__ */ new Set(), this.indentGuidesDisposable = V.None, this.disposables = new G(), this.templateId = e.templateId, this.updateOptions(r), se.map(i, ((l) => l.node))(this.onDidChangeNodeTwistieState, this, this.disposables), (a = e.onDidChangeTwistieState) === null || a === void 0 || a.call(e, this.onDidChangeTwistieState, this, this.disposables);
  }
  updateOptions(e = {}) {
    if (e.indent !== void 0) {
      const t = as(e.indent, 0, 40);
      if (t !== this.indent) {
        this.indent = t;
        for (const [i, s] of this.renderedNodes) this.renderTreeElement(i, s);
      }
    }
    if (e.renderIndentGuides !== void 0) {
      const t = e.renderIndentGuides !== tf.None;
      if (t !== this.shouldRenderIndentGuides) {
        this.shouldRenderIndentGuides = t;
        for (const [i, s] of this.renderedNodes) this._renderIndentGuides(i, s);
        if (this.indentGuidesDisposable.dispose(), t) {
          const i = new G();
          this.activeNodes.onDidChange(this._onDidChangeActiveNodes, this, i), this.indentGuidesDisposable = i, this._onDidChangeActiveNodes(this.activeNodes.elements);
        }
      }
    }
    e.hideTwistiesOfChildlessElements !== void 0 && (this.hideTwistiesOfChildlessElements = e.hideTwistiesOfChildlessElements);
  }
  renderTemplate(e) {
    const t = Z(e, Q(".monaco-tl-row")), i = Z(t, Q(".monaco-tl-indent")), s = Z(t, Q(".monaco-tl-twistie")), o = Z(t, Q(".monaco-tl-contents")), r = this.renderer.renderTemplate(o);
    return { container: e, indent: i, twistie: s, indentGuidesDisposable: V.None, templateData: r };
  }
  renderElement(e, t, i, s) {
    this.renderedNodes.set(e, i), this.renderedElements.set(e.element, e), this.renderTreeElement(e, i), this.renderer.renderElement(e, t, i.templateData, s);
  }
  disposeElement(e, t, i, s) {
    var o, r;
    i.indentGuidesDisposable.dispose(), (r = (o = this.renderer).disposeElement) === null || r === void 0 || r.call(o, e, t, i.templateData, s), typeof s == "number" && (this.renderedNodes.delete(e), this.renderedElements.delete(e.element));
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  onDidChangeTwistieState(e) {
    const t = this.renderedElements.get(e);
    t && this.onDidChangeNodeTwistieState(t);
  }
  onDidChangeNodeTwistieState(e) {
    const t = this.renderedNodes.get(e);
    t && (this._onDidChangeActiveNodes(this.activeNodes.elements), this.renderTreeElement(e, t));
  }
  renderTreeElement(e, t) {
    const i = Bv.DefaultIndent + (e.depth - 1) * this.indent;
    t.twistie.style.paddingLeft = `${i}px`, t.indent.style.width = i + this.indent - 16 + "px", e.collapsible ? t.container.setAttribute("aria-expanded", String(!e.collapsed)) : t.container.removeAttribute("aria-expanded"), t.twistie.classList.remove(...Ee.asClassNameArray(ne.treeItemExpanded));
    let s = !1;
    this.renderer.renderTwistie && (s = this.renderer.renderTwistie(e.element, t.twistie)), e.collapsible && (!this.hideTwistiesOfChildlessElements || e.visibleChildrenCount > 0) ? (s || t.twistie.classList.add(...Ee.asClassNameArray(ne.treeItemExpanded)), t.twistie.classList.add("collapsible"), t.twistie.classList.toggle("collapsed", e.collapsed)) : t.twistie.classList.remove("collapsible", "collapsed"), this._renderIndentGuides(e, t);
  }
  _renderIndentGuides(e, t) {
    if (Un(t.indent), t.indentGuidesDisposable.dispose(), !this.shouldRenderIndentGuides) return;
    const i = new G(), s = this.modelProvider();
    for (; ; ) {
      const o = s.getNodeLocation(e), r = s.getParentNodeLocation(o);
      if (!r) break;
      const a = s.getNode(r), l = Q(".indent-guide", { style: `width: ${this.indent}px` });
      this.activeIndentNodes.has(a) && l.classList.add("active"), t.indent.childElementCount === 0 ? t.indent.appendChild(l) : t.indent.insertBefore(l, t.indent.firstElementChild), this.renderedIndentGuides.add(a, l), i.add(ye((() => this.renderedIndentGuides.delete(a, l)))), e = a;
    }
    t.indentGuidesDisposable = i;
  }
  _onDidChangeActiveNodes(e) {
    if (!this.shouldRenderIndentGuides) return;
    const t = /* @__PURE__ */ new Set(), i = this.modelProvider();
    e.forEach(((s) => {
      const o = i.getNodeLocation(s);
      try {
        const r = i.getParentNodeLocation(o);
        s.collapsible && s.children.length > 0 && !s.collapsed ? t.add(s) : r && t.add(i.getNode(r));
      } catch {
      }
    })), this.activeIndentNodes.forEach(((s) => {
      t.has(s) || this.renderedIndentGuides.forEach(s, ((o) => o.classList.remove("active")));
    })), t.forEach(((s) => {
      this.activeIndentNodes.has(s) || this.renderedIndentGuides.forEach(s, ((o) => o.classList.add("active")));
    })), this.activeIndentNodes = t;
  }
  dispose() {
    this.renderedNodes.clear(), this.renderedElements.clear(), this.indentGuidesDisposable.dispose(), Ht(this.disposables);
  }
}
Bv.DefaultIndent = 8;
class zte {
  get totalCount() {
    return this._totalCount;
  }
  get matchCount() {
    return this._matchCount;
  }
  constructor(e, t, i) {
    this.tree = e, this.keyboardNavigationLabelProvider = t, this._filter = i, this._totalCount = 0, this._matchCount = 0, this._pattern = "", this._lowercasePattern = "", this.disposables = new G(), e.onWillRefilter(this.reset, this, this.disposables);
  }
  filter(e, t) {
    let i = 1;
    if (this._filter) {
      const r = this._filter.filter(e, t);
      if (i = typeof r == "boolean" ? r ? 1 : 0 : IA(r) ? Fv(r.visibility) : r, i === 0) return !1;
    }
    if (this._totalCount++, !this._pattern) return this._matchCount++, { data: la.Default, visibility: i };
    const s = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e), o = Array.isArray(s) ? s : [s];
    for (const r of o) {
      const a = r && r.toString();
      if (a === void 0) return { data: la.Default, visibility: i };
      let l;
      if (this.tree.findMatchType === pg.Contiguous) {
        const d = a.toLowerCase().indexOf(this._lowercasePattern);
        if (d > -1) {
          l = [Number.MAX_SAFE_INTEGER, 0];
          for (let h = this._lowercasePattern.length; h > 0; h--) l.push(d + h - 1);
        }
      } else l = ug(this._pattern, this._lowercasePattern, 0, a, a.toLowerCase(), 0, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
      if (l) return this._matchCount++, o.length === 1 ? { data: l, visibility: i } : { data: { label: a, score: l }, visibility: i };
    }
    return this.tree.findMode === Cd.Filter ? typeof this.tree.options.defaultFindVisibility == "number" ? this.tree.options.defaultFindVisibility : this.tree.options.defaultFindVisibility ? this.tree.options.defaultFindVisibility(e) : 2 : { data: la.Default, visibility: i };
  }
  reset() {
    this._totalCount = 0, this._matchCount = 0;
  }
  dispose() {
    Ht(this.disposables);
  }
}
(function(n) {
  n[n.Highlight = 0] = "Highlight", n[n.Filter = 1] = "Filter";
})(Cd || (Cd = {})), (function(n) {
  n[n.Fuzzy = 0] = "Fuzzy", n[n.Contiguous = 1] = "Contiguous";
})(pg || (pg = {}));
let Ute = class {
  get pattern() {
    return this._pattern;
  }
  get mode() {
    return this._mode;
  }
  set mode(n) {
    n !== this._mode && (this._mode = n, this.widget && (this.widget.mode = this._mode), this.tree.refilter(), this.render(), this._onDidChangeMode.fire(n));
  }
  get matchType() {
    return this._matchType;
  }
  set matchType(n) {
    n !== this._matchType && (this._matchType = n, this.widget && (this.widget.matchType = this._matchType), this.tree.refilter(), this.render(), this._onDidChangeMatchType.fire(n));
  }
  constructor(n, e, t, i, s, o = {}) {
    var r, a;
    this.tree = n, this.view = t, this.filter = i, this.contextViewProvider = s, this.options = o, this._pattern = "", this.width = 0, this._onDidChangeMode = new F(), this.onDidChangeMode = this._onDidChangeMode.event, this._onDidChangeMatchType = new F(), this.onDidChangeMatchType = this._onDidChangeMatchType.event, this._onDidChangePattern = new F(), this._onDidChangeOpenState = new F(), this.onDidChangeOpenState = this._onDidChangeOpenState.event, this.enabledDisposables = new G(), this.disposables = new G(), this._mode = (r = n.options.defaultFindMode) !== null && r !== void 0 ? r : Cd.Highlight, this._matchType = (a = n.options.defaultFindMatchType) !== null && a !== void 0 ? a : pg.Fuzzy, e.onDidSplice(this.onDidSpliceModel, this, this.disposables);
  }
  updateOptions(n = {}) {
    n.defaultFindMode !== void 0 && (this.mode = n.defaultFindMode), n.defaultFindMatchType !== void 0 && (this.matchType = n.defaultFindMatchType);
  }
  onDidSpliceModel() {
    this.widget && this.pattern.length !== 0 && (this.tree.refilter(), this.render());
  }
  render() {
    var n, e, t, i;
    const s = this.filter.totalCount > 0 && this.filter.matchCount === 0;
    this.pattern && s ? (n = this.tree.options.showNotFoundMessage) === null || n === void 0 || n ? (e = this.widget) === null || e === void 0 || e.showMessage({ type: 2, content: m(0, "No elements found.") }) : (t = this.widget) === null || t === void 0 || t.showMessage({ type: 2 }) : (i = this.widget) === null || i === void 0 || i.clearMessage();
  }
  shouldAllowFocus(n) {
    return !this.widget || !this.pattern || this.filter.totalCount > 0 && this.filter.matchCount <= 1 || !la.isDefault(n.filterData);
  }
  layout(n) {
    var e;
    this.width = n, (e = this.widget) === null || e === void 0 || e.layout(n);
  }
  dispose() {
    this._history = void 0, this._onDidChangePattern.dispose(), this.enabledDisposables.dispose(), this.disposables.dispose();
  }
};
function Kte(n, e) {
  return n.position === e.position && dV(n, e);
}
function dV(n, e) {
  return n.node.element === e.node.element && n.startIndex === e.startIndex && n.height === e.height && n.endIndex === e.endIndex;
}
class jte {
  constructor(e = []) {
    this.stickyNodes = e;
  }
  get count() {
    return this.stickyNodes.length;
  }
  equal(e) {
    return ri(this.stickyNodes, e.stickyNodes, Kte);
  }
  lastNodePartiallyVisible() {
    if (this.count === 0) return !1;
    const e = this.stickyNodes[this.count - 1];
    if (this.count === 1) return e.position !== 0;
    const t = this.stickyNodes[this.count - 2];
    return t.position + t.height !== e.position;
  }
  animationStateChanged(e) {
    if (!ri(this.stickyNodes, e.stickyNodes, dV) || this.count === 0) return !1;
    const t = this.stickyNodes[this.count - 1], i = e.stickyNodes[e.count - 1];
    return t.position !== i.position;
  }
}
class qte {
  constrainStickyScrollNodes(e, t, i) {
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      if (o.position + o.height > i || s >= t) return e.slice(0, s);
    }
    return e;
  }
}
let Z3 = class extends V {
  constructor(n, e, t, i, s, o = {}) {
    var r;
    super(), this.tree = n, this.model = e, this.view = t, this.treeDelegate = s, this.maxWidgetViewRatio = 0.4;
    const a = this.validateStickySettings(o);
    this.stickyScrollMaxItemCount = a.stickyScrollMaxItemCount, this.stickyScrollDelegate = (r = o.stickyScrollDelegate) !== null && r !== void 0 ? r : new qte(), this._widget = this._register(new $te(t.getScrollableElement(), t, n, i, s, o.accessibilityProvider)), this.onDidChangeHasFocus = this._widget.onDidChangeHasFocus, this.onContextMenu = this._widget.onContextMenu, this._register(t.onDidScroll((() => this.update()))), this._register(t.onDidChangeContentHeight((() => this.update()))), this._register(n.onDidChangeCollapseState((() => this.update()))), this.update();
  }
  get height() {
    return this._widget.height;
  }
  getNodeAtHeight(n) {
    let e;
    if (e = n === 0 ? this.view.firstVisibleIndex : this.view.indexAt(n + this.view.scrollTop), !(e < 0 || e >= this.view.length)) return this.view.element(e);
  }
  update() {
    const n = this.getNodeAtHeight(0);
    if (!n || this.tree.scrollTop === 0) return void this._widget.setState(void 0);
    const e = this.findStickyState(n);
    this._widget.setState(e);
  }
  findStickyState(n) {
    const e = [];
    let t = n, i = 0, s = this.getNextStickyNode(t, void 0, i);
    for (; s && (e.push(s), i += s.height, !(e.length <= this.stickyScrollMaxItemCount) || (t = this.getNextVisibleNode(s), t)); ) s = this.getNextStickyNode(t, s.node, i);
    const o = this.constrainStickyNodes(e);
    return o.length ? new jte(o) : void 0;
  }
  getNextVisibleNode(n) {
    return this.getNodeAtHeight(n.position + n.height);
  }
  getNextStickyNode(n, e, t) {
    const i = this.getAncestorUnderPrevious(n, e);
    if (i)
      return i === n && (!this.nodeIsUncollapsedParent(n) || this.nodeTopAlignsWithStickyNodesBottom(n, t)) ? void 0 : this.createStickyScrollNode(i, t);
  }
  nodeTopAlignsWithStickyNodesBottom(n, e) {
    const t = this.getNodeIndex(n), i = this.view.getElementTop(t), s = e;
    return this.view.scrollTop === i - s;
  }
  createStickyScrollNode(n, e) {
    const t = this.treeDelegate.getHeight(n), { startIndex: i, endIndex: s } = this.getNodeRange(n);
    return { node: n, position: this.calculateStickyNodePosition(s, e, t), height: t, startIndex: i, endIndex: s };
  }
  getAncestorUnderPrevious(n, e = void 0) {
    let t = n, i = this.getParentNode(t);
    for (; i; ) {
      if (i === e) return t;
      t = i, i = this.getParentNode(t);
    }
    if (e === void 0) return t;
  }
  calculateStickyNodePosition(n, e, t) {
    let i = this.view.getRelativeTop(n);
    if (i === null && this.view.firstVisibleIndex === n && n + 1 < this.view.length) {
      const a = this.treeDelegate.getHeight(this.view.element(n)), l = this.view.getRelativeTop(n + 1);
      i = l ? l - a / this.view.renderHeight : null;
    }
    if (i === null) return e;
    const s = this.view.element(n), o = this.treeDelegate.getHeight(s), r = i * this.view.renderHeight + o;
    return e + t > r && e <= r ? r - t : e;
  }
  constrainStickyNodes(n) {
    if (n.length === 0) return [];
    const e = this.view.renderHeight * this.maxWidgetViewRatio, t = n[n.length - 1];
    if (n.length <= this.stickyScrollMaxItemCount && t.position + t.height <= e) return n;
    const i = this.stickyScrollDelegate.constrainStickyScrollNodes(n, this.stickyScrollMaxItemCount, e);
    if (!i.length) return [];
    const s = i[i.length - 1];
    if (i.length > this.stickyScrollMaxItemCount || s.position + s.height > e) throw new Error("stickyScrollDelegate violates constraints");
    return i;
  }
  getParentNode(n) {
    const e = this.model.getNodeLocation(n), t = this.model.getParentNodeLocation(e);
    return t ? this.model.getNode(t) : void 0;
  }
  nodeIsUncollapsedParent(n) {
    const e = this.model.getNodeLocation(n);
    return this.model.getListRenderCount(e) > 1;
  }
  getNodeIndex(n) {
    const e = this.model.getNodeLocation(n);
    return this.model.getListIndex(e);
  }
  getNodeRange(n) {
    const e = this.model.getNodeLocation(n), t = this.model.getListIndex(e);
    if (t < 0) throw new Error("Node not found in tree");
    return { startIndex: t, endIndex: t + this.model.getListRenderCount(e) - 1 };
  }
  nodePositionTopBelowWidget(n) {
    const e = [];
    let t = this.getParentNode(n);
    for (; t; ) e.push(t), t = this.getParentNode(t);
    let i = 0;
    for (let s = 0; s < e.length && s < this.stickyScrollMaxItemCount; s++) i += this.treeDelegate.getHeight(e[s]);
    return i;
  }
  domFocus() {
    this._widget.domFocus();
  }
  focusedLast() {
    return this._widget.focusedLast();
  }
  updateOptions(n = {}) {
    if (!n.stickyScrollMaxItemCount) return;
    const e = this.validateStickySettings(n);
    this.stickyScrollMaxItemCount !== e.stickyScrollMaxItemCount && (this.stickyScrollMaxItemCount = e.stickyScrollMaxItemCount, this.update());
  }
  validateStickySettings(n) {
    let e = 7;
    return typeof n.stickyScrollMaxItemCount == "number" && (e = Math.max(n.stickyScrollMaxItemCount, 1)), { stickyScrollMaxItemCount: e };
  }
}, $te = class {
  constructor(n, e, t, i, s, o) {
    this.view = e, this.tree = t, this.treeRenderers = i, this.treeDelegate = s, this.accessibilityProvider = o, this._previousElements = [], this._previousStateDisposables = new G(), this._rootDomNode = Q(".monaco-tree-sticky-container.empty"), n.appendChild(this._rootDomNode);
    const r = Q(".monaco-tree-sticky-container-shadow");
    this._rootDomNode.appendChild(r), this.stickyScrollFocus = new Gte(this._rootDomNode, e), this.onDidChangeHasFocus = this.stickyScrollFocus.onDidChangeHasFocus, this.onContextMenu = this.stickyScrollFocus.onContextMenu;
  }
  get height() {
    if (!this._previousState) return 0;
    const n = this._previousState.stickyNodes[this._previousState.count - 1];
    return n.position + n.height;
  }
  setState(n) {
    const e = !!this._previousState && this._previousState.count > 0, t = !!n && n.count > 0;
    if (!e && !t || e && t && this._previousState.equal(n)) return;
    if (e !== t && this.setVisible(t), !t) return this._previousState = void 0, this._previousElements = [], void this._previousStateDisposables.clear();
    const i = n.stickyNodes[n.count - 1];
    if (this._previousState && n.animationStateChanged(this._previousState)) this._previousElements[this._previousState.count - 1].style.top = `${i.position}px`;
    else {
      this._previousStateDisposables.clear();
      const s = Array(n.count);
      for (let o = n.count - 1; o >= 0; o--) {
        const r = n.stickyNodes[o], { element: a, disposable: l } = this.createElement(r, o, n.count);
        s[o] = a, this._rootDomNode.appendChild(a), this._previousStateDisposables.add(l);
      }
      this.stickyScrollFocus.updateElements(s, n), this._previousElements = s;
    }
    this._previousState = n, this._rootDomNode.style.height = `${i.position + i.height}px`;
  }
  createElement(n, e, t) {
    const i = n.startIndex, s = document.createElement("div");
    s.style.top = `${n.position}px`, this.tree.options.setRowHeight !== !1 && (s.style.height = `${n.height}px`), this.tree.options.setRowLineHeight !== !1 && (s.style.lineHeight = `${n.height}px`), s.classList.add("monaco-tree-sticky-row"), s.classList.add("monaco-list-row"), s.setAttribute("data-index", `${i}`), s.setAttribute("data-parity", i % 2 == 0 ? "even" : "odd"), s.setAttribute("id", this.view.getElementID(i));
    const o = this.setAccessibilityAttributes(s, n.node.element, e, t), r = this.treeDelegate.getTemplateId(n.node), a = this.treeRenderers.find(((c) => c.templateId === r));
    if (!a) throw new Error(`No renderer found for template id ${r}`);
    let l = n.node;
    l === this.tree.getNode(this.tree.getNodeLocation(n.node)) && (l = new Proxy(n.node, {}));
    const d = a.renderTemplate(s);
    a.renderElement(l, n.startIndex, d, n.height);
    const h = ye((() => {
      o.dispose(), a.disposeElement(l, n.startIndex, d, n.height), a.disposeTemplate(d), s.remove();
    }));
    return { element: s, disposable: h };
  }
  setAccessibilityAttributes(n, e, t, i) {
    var s;
    if (!this.accessibilityProvider) return V.None;
    this.accessibilityProvider.getSetSize && n.setAttribute("aria-setsize", String(this.accessibilityProvider.getSetSize(e, t, i))), this.accessibilityProvider.getPosInSet && n.setAttribute("aria-posinset", String(this.accessibilityProvider.getPosInSet(e, t))), this.accessibilityProvider.getRole && n.setAttribute("role", (s = this.accessibilityProvider.getRole(e)) !== null && s !== void 0 ? s : "treeitem");
    const o = this.accessibilityProvider.getAriaLabel(e), r = o && typeof o != "string" ? o : ia(o), a = Ge(((d) => {
      const h = d.readObservable(r);
      h ? n.setAttribute("aria-label", h) : n.removeAttribute("aria-label");
    }));
    typeof o == "string" || o && n.setAttribute("aria-label", o.get());
    const l = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(e);
    return typeof l == "number" && n.setAttribute("aria-level", `${l}`), n.setAttribute("aria-selected", String(!1)), a;
  }
  setVisible(n) {
    this._rootDomNode.classList.toggle("empty", !n), n || this.stickyScrollFocus.updateElements([], void 0);
  }
  domFocus() {
    this.stickyScrollFocus.domFocus();
  }
  focusedLast() {
    return this.stickyScrollFocus.focusedLast();
  }
  dispose() {
    this.stickyScrollFocus.dispose(), this._previousStateDisposables.dispose(), this._rootDomNode.remove();
  }
};
class Gte extends V {
  get domHasFocus() {
    return this._domHasFocus;
  }
  set domHasFocus(e) {
    e !== this._domHasFocus && (this._onDidChangeHasFocus.fire(e), this._domHasFocus = e);
  }
  constructor(e, t) {
    super(), this.container = e, this.view = t, this.focusedIndex = -1, this.elements = [], this._onDidChangeHasFocus = new F(), this.onDidChangeHasFocus = this._onDidChangeHasFocus.event, this._onContextMenu = new F(), this.onContextMenu = this._onContextMenu.event, this._domHasFocus = !1, this.container.addEventListener("focus", (() => this.onFocus())), this.container.addEventListener("blur", (() => this.onBlur())), this._register(this.view.onDidFocus((() => this.toggleStickyScrollFocused(!1)))), this._register(this.view.onKeyDown(((i) => this.onKeyDown(i)))), this._register(this.view.onMouseDown(((i) => this.onMouseDown(i)))), this._register(this.view.onContextMenu(((i) => this.handleContextMenu(i))));
  }
  handleContextMenu(e) {
    const t = e.browserEvent.target;
    if (!Av(t) && !f0(t)) return void (this.focusedLast() && this.view.domFocus());
    if (!fh(e.browserEvent)) {
      if (!this.state) throw new Error("Context menu should not be triggered when state is undefined");
      const o = this.state.stickyNodes.findIndex(((r) => {
        var a;
        return r.node.element === ((a = e.element) === null || a === void 0 ? void 0 : a.element);
      }));
      if (o === -1) throw new Error("Context menu should not be triggered when element is not in sticky scroll widget");
      return this.container.focus(), void this.setFocus(o);
    }
    if (!this.state || this.focusedIndex < 0) throw new Error("Context menu key should not be triggered when focus is not in sticky scroll widget");
    const i = this.state.stickyNodes[this.focusedIndex].node.element, s = this.elements[this.focusedIndex];
    this._onContextMenu.fire({ element: i, anchor: s, browserEvent: e.browserEvent, isStickyScroll: !0 });
  }
  onKeyDown(e) {
    if (this.domHasFocus && this.state) {
      if (e.key === "ArrowUp") this.setFocusedElement(Math.max(0, this.focusedIndex - 1)), e.preventDefault(), e.stopPropagation();
      else if (e.key === "ArrowDown" || e.key === "ArrowRight") {
        if (this.focusedIndex >= this.state.count - 1) {
          const t = this.state.stickyNodes[this.state.count - 1].startIndex + 1;
          this.view.domFocus(), this.view.setFocus([t]), this.scrollNodeUnderWidget(t, this.state);
        } else this.setFocusedElement(this.focusedIndex + 1);
        e.preventDefault(), e.stopPropagation();
      }
    }
  }
  onMouseDown(e) {
    const t = e.browserEvent.target;
    (Av(t) || f0(t)) && (e.browserEvent.preventDefault(), e.browserEvent.stopPropagation());
  }
  updateElements(e, t) {
    if (t && t.count === 0) throw new Error("Sticky scroll state must be undefined when there are no sticky nodes");
    if (t && t.count !== e.length) throw new Error("Sticky scroll focus received illigel state");
    const i = this.focusedIndex;
    if (this.removeFocus(), this.elements = e, this.state = t, t) {
      const s = as(i, 0, t.count - 1);
      this.setFocus(s);
    } else this.domHasFocus && this.view.domFocus();
    this.container.tabIndex = t ? 0 : -1;
  }
  setFocusedElement(e) {
    const t = this.state;
    if (!t) throw new Error("Cannot set focus when state is undefined");
    if (this.setFocus(e), !(e < t.count - 1) && t.lastNodePartiallyVisible()) {
      const i = t.stickyNodes[e];
      this.scrollNodeUnderWidget(i.endIndex + 1, t);
    }
  }
  scrollNodeUnderWidget(e, t) {
    const i = t.stickyNodes[t.count - 1], s = t.count > 1 ? t.stickyNodes[t.count - 2] : void 0, o = this.view.getElementTop(e), r = s ? s.position + s.height + i.height : i.height;
    this.view.scrollTop = o - r;
  }
  domFocus() {
    if (!this.state) throw new Error("Cannot focus when state is undefined");
    this.container.focus();
  }
  focusedLast() {
    return !!this.state && this.view.getHTMLElement().classList.contains("sticky-scroll-focused");
  }
  removeFocus() {
    this.focusedIndex !== -1 && (this.toggleElementFocus(this.elements[this.focusedIndex], !1), this.focusedIndex = -1);
  }
  setFocus(e) {
    if (0 > e) throw new Error("addFocus() can not remove focus");
    if (!this.state && e >= 0) throw new Error("Cannot set focus index when state is undefined");
    if (this.state && e >= this.state.count) throw new Error("Cannot set focus index to an index that does not exist");
    const t = this.focusedIndex;
    t >= 0 && this.toggleElementFocus(this.elements[t], !1), e >= 0 && this.toggleElementFocus(this.elements[e], !0), this.focusedIndex = e;
  }
  toggleElementFocus(e, t) {
    this.toggleElementActiveFocus(e, t && this.domHasFocus), this.toggleElementPassiveFocus(e, t);
  }
  toggleCurrentElementActiveFocus(e) {
    this.focusedIndex !== -1 && this.toggleElementActiveFocus(this.elements[this.focusedIndex], e);
  }
  toggleElementActiveFocus(e, t) {
    e.classList.toggle("focused", t);
  }
  toggleElementPassiveFocus(e, t) {
    e.classList.toggle("passive-focused", t);
  }
  toggleStickyScrollFocused(e) {
    this.view.getHTMLElement().classList.toggle("sticky-scroll-focused", e);
  }
  onFocus() {
    if (!this.state || this.elements.length === 0) throw new Error("Cannot focus when state is undefined or elements are empty");
    this.domHasFocus = !0, this.toggleStickyScrollFocused(!0), this.toggleCurrentElementActiveFocus(!0), this.focusedIndex === -1 && this.setFocus(0);
  }
  onBlur() {
    this.domHasFocus = !1, this.toggleCurrentElementActiveFocus(!1);
  }
  dispose() {
    this.toggleStickyScrollFocused(!1), this._onDidChangeHasFocus.fire(!1), super.dispose();
  }
}
function Vb(n) {
  let e = Au.Unknown;
  return $k(n.browserEvent.target, "monaco-tl-twistie", "monaco-tl-row") ? e = Au.Twistie : $k(n.browserEvent.target, "monaco-tl-contents", "monaco-tl-row") ? e = Au.Element : $k(n.browserEvent.target, "monaco-tree-type-filter", "monaco-list") && (e = Au.Filter), { browserEvent: n.browserEvent, element: n.element ? n.element.element : null, target: e };
}
function Zte(n) {
  const e = Av(n.browserEvent.target);
  return { element: n.element ? n.element.element : null, browserEvent: n.browserEvent, anchor: n.anchor, isStickyScroll: e };
}
function GC(n, e) {
  e(n), n.children.forEach(((t) => GC(t, e)));
}
class nx {
  get nodeSet() {
    return this._nodeSet || (this._nodeSet = this.createNodeSet()), this._nodeSet;
  }
  constructor(e, t) {
    this.getFirstViewElementWithTrait = e, this.identityProvider = t, this.nodes = [], this._onDidChange = new F(), this.onDidChange = this._onDidChange.event;
  }
  set(e, t) {
    !t?.__forceEvent && ri(this.nodes, e) || this._set(e, !1, t);
  }
  _set(e, t, i) {
    if (this.nodes = [...e], this.elements = void 0, this._nodeSet = void 0, !t) {
      const s = this;
      this._onDidChange.fire({ get elements() {
        return s.get();
      }, browserEvent: i });
    }
  }
  get() {
    return this.elements || (this.elements = this.nodes.map(((e) => e.element))), [...this.elements];
  }
  getNodes() {
    return this.nodes;
  }
  has(e) {
    return this.nodeSet.has(e);
  }
  onDidModelSplice({ insertedNodes: e, deletedNodes: t }) {
    if (!this.identityProvider) {
      const l = this.createNodeSet(), d = (h) => l.delete(h);
      return t.forEach(((h) => GC(h, d))), void this.set([...l.values()]);
    }
    const i = /* @__PURE__ */ new Set(), s = (l) => i.add(this.identityProvider.getId(l.element).toString());
    t.forEach(((l) => GC(l, s)));
    const o = /* @__PURE__ */ new Map(), r = (l) => o.set(this.identityProvider.getId(l.element).toString(), l);
    e.forEach(((l) => GC(l, r)));
    const a = [];
    for (const l of this.nodes) {
      const d = this.identityProvider.getId(l.element).toString();
      if (i.has(d)) {
        const h = o.get(d);
        h && h.visible && a.push(h);
      } else a.push(l);
    }
    if (this.nodes.length > 0 && a.length === 0) {
      const l = this.getFirstViewElementWithTrait();
      l && a.push(l);
    }
    this._set(a, !0);
  }
  createNodeSet() {
    const e = /* @__PURE__ */ new Set();
    for (const t of this.nodes) e.add(t);
    return e;
  }
}
class Yte extends GW {
  constructor(e, t, i) {
    super(e), this.tree = t, this.stickyScrollProvider = i;
  }
  onViewPointer(e) {
    if (KW(e.browserEvent.target) || nc(e.browserEvent.target) || E_(e.browserEvent.target) || e.browserEvent.isHandledByList) return;
    const t = e.element;
    if (!t) return super.onViewPointer(e);
    if (this.isSelectionRangeChangeEvent(e) || this.isSelectionSingleChangeEvent(e)) return super.onViewPointer(e);
    const i = e.browserEvent.target, s = i.classList.contains("monaco-tl-twistie") || i.classList.contains("monaco-icon-label") && i.classList.contains("folder-icon") && e.browserEvent.offsetX < 16, o = f0(e.browserEvent.target);
    let r = !1;
    if (r = !!o || (typeof this.tree.expandOnlyOnTwistieClick == "function" ? this.tree.expandOnlyOnTwistieClick(t.element) : !!this.tree.expandOnlyOnTwistieClick), o) this.handleStickyScrollMouseEvent(e, t);
    else {
      if (r && !s && e.browserEvent.detail !== 2) return super.onViewPointer(e);
      if (!this.tree.expandOnDoubleClick && e.browserEvent.detail === 2) return super.onViewPointer(e);
    }
    if (t.collapsible && (!o || s)) {
      const a = this.tree.getNodeLocation(t), l = e.browserEvent.altKey;
      if (this.tree.setFocus([a]), this.tree.toggleCollapsed(a, l), r && s) return void (e.browserEvent.isHandledByList = !0);
    }
    o || super.onViewPointer(e);
  }
  handleStickyScrollMouseEvent(e, t) {
    if ((function(a) {
      return Rv(a, "monaco-custom-toggle");
    })(e.browserEvent.target) || (function(a) {
      return Rv(a, "action-item");
    })(e.browserEvent.target)) return;
    const i = this.stickyScrollProvider();
    if (!i) throw new Error("Sticky scroll controller not found");
    const s = this.list.indexOf(t), o = this.list.getElementTop(s), r = i.nodePositionTopBelowWidget(t);
    this.tree.scrollTop = o - r, this.list.domFocus(), this.list.setFocus([s]), this.list.setSelection([s]);
  }
  onDoubleClick(e) {
    !e.browserEvent.target.classList.contains("monaco-tl-twistie") && this.tree.expandOnDoubleClick && (e.browserEvent.isHandledByList || super.onDoubleClick(e));
  }
  onMouseDown(e) {
    const t = e.browserEvent.target;
    Av(t) || f0(t) || super.onMouseDown(e);
  }
  onContextMenu(e) {
    const t = e.browserEvent.target;
    Av(t) || f0(t) || super.onContextMenu(e);
  }
}
class Xte extends uo {
  constructor(e, t, i, s, o, r, a, l) {
    super(e, t, i, s, l), this.focusTrait = o, this.selectionTrait = r, this.anchorTrait = a;
  }
  createMouseController(e) {
    return new Yte(this, e.tree, e.stickyScrollProvider);
  }
  splice(e, t, i = []) {
    if (super.splice(e, t, i), i.length === 0) return;
    const s = [], o = [];
    let r;
    i.forEach(((a, l) => {
      this.focusTrait.has(a) && s.push(e + l), this.selectionTrait.has(a) && o.push(e + l), this.anchorTrait.has(a) && (r = e + l);
    })), s.length > 0 && super.setFocus(Ad([...super.getFocus(), ...s])), o.length > 0 && super.setSelection(Ad([...super.getSelection(), ...o])), typeof r == "number" && super.setAnchor(r);
  }
  setFocus(e, t, i = !1) {
    super.setFocus(e, t), i || this.focusTrait.set(e.map(((s) => this.element(s))), t);
  }
  setSelection(e, t, i = !1) {
    super.setSelection(e, t), i || this.selectionTrait.set(e.map(((s) => this.element(s))), t);
  }
  setAnchor(e, t = !1) {
    super.setAnchor(e), t || (e === void 0 ? this.anchorTrait.set([]) : this.anchorTrait.set([this.element(e)]));
  }
}
class hV {
  get onDidScroll() {
    return this.view.onDidScroll;
  }
  get onDidChangeFocus() {
    return this.eventBufferer.wrapEvent(this.focus.onDidChange);
  }
  get onDidChangeSelection() {
    return this.eventBufferer.wrapEvent(this.selection.onDidChange);
  }
  get onMouseDblClick() {
    return se.filter(se.map(this.view.onMouseDblClick, Vb), ((e) => e.target !== Au.Filter));
  }
  get onMouseOver() {
    return se.map(this.view.onMouseOver, Vb);
  }
  get onMouseOut() {
    return se.map(this.view.onMouseOut, Vb);
  }
  get onContextMenu() {
    var e, t;
    return se.any(se.filter(se.map(this.view.onContextMenu, Zte), ((i) => !i.isStickyScroll)), (t = (e = this.stickyScrollController) === null || e === void 0 ? void 0 : e.onContextMenu) !== null && t !== void 0 ? t : se.None);
  }
  get onPointer() {
    return se.map(this.view.onPointer, Vb);
  }
  get onKeyDown() {
    return this.view.onKeyDown;
  }
  get onDidFocus() {
    return this.view.onDidFocus;
  }
  get onDidChangeModel() {
    return se.signal(this.model.onDidSplice);
  }
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  get findMode() {
    var e, t;
    return (t = (e = this.findController) === null || e === void 0 ? void 0 : e.mode) !== null && t !== void 0 ? t : Cd.Highlight;
  }
  set findMode(e) {
    this.findController && (this.findController.mode = e);
  }
  get findMatchType() {
    var e, t;
    return (t = (e = this.findController) === null || e === void 0 ? void 0 : e.matchType) !== null && t !== void 0 ? t : pg.Fuzzy;
  }
  set findMatchType(e) {
    this.findController && (this.findController.matchType = e);
  }
  get expandOnDoubleClick() {
    return this._options.expandOnDoubleClick === void 0 || this._options.expandOnDoubleClick;
  }
  get expandOnlyOnTwistieClick() {
    return this._options.expandOnlyOnTwistieClick === void 0 || this._options.expandOnlyOnTwistieClick;
  }
  get onDidDispose() {
    return this.view.onDidDispose;
  }
  constructor(e, t, i, s, o = {}) {
    var r;
    this._user = e, this._options = o, this.eventBufferer = new JT(), this.onDidChangeFindOpenState = se.None, this.onDidChangeStickyScrollFocused = se.None, this.disposables = new G(), this._onWillRefilter = new F(), this.onWillRefilter = this._onWillRefilter.event, this._onDidUpdateOptions = new F(), this.treeDelegate = new MA(i);
    const a = new nO(), l = new nO(), d = this.disposables.add(new Hte(l.event)), h = new wR();
    this.renderers = s.map(((v) => new Bv(v, (() => this.model), a.event, d, h, o)));
    for (const v of this.renderers) this.disposables.add(v);
    let c;
    var u, g;
    o.keyboardNavigationLabelProvider && (c = new zte(this, o.keyboardNavigationLabelProvider, o.filter), o = { ...o, filter: c }, this.disposables.add(c)), this.focus = new nx((() => this.view.getFocusedElements()[0]), o.identityProvider), this.selection = new nx((() => this.view.getSelectedElements()[0]), o.identityProvider), this.anchor = new nx((() => this.view.getAnchorElement()), o.identityProvider), this.view = new Xte(e, t, this.treeDelegate, this.renderers, this.focus, this.selection, this.anchor, { ...(u = () => this.model, g = o, g && { ...g, identityProvider: g.identityProvider && { getId: (v) => g.identityProvider.getId(v.element) }, dnd: g.dnd && new Vte(u, g.dnd), multipleSelectionController: g.multipleSelectionController && { isSelectionSingleChangeEvent: (v) => g.multipleSelectionController.isSelectionSingleChangeEvent({ ...v, element: v.element }), isSelectionRangeChangeEvent: (v) => g.multipleSelectionController.isSelectionRangeChangeEvent({ ...v, element: v.element }) }, accessibilityProvider: g.accessibilityProvider && { ...g.accessibilityProvider, getSetSize(v) {
      const b = u(), C = b.getNodeLocation(v), w = b.getParentNodeLocation(C);
      return b.getNode(w).visibleChildrenCount;
    }, getPosInSet: (v) => v.visibleChildIndex + 1, isChecked: g.accessibilityProvider && g.accessibilityProvider.isChecked ? (v) => g.accessibilityProvider.isChecked(v.element) : void 0, getRole: g.accessibilityProvider && g.accessibilityProvider.getRole ? (v) => g.accessibilityProvider.getRole(v.element) : () => "treeitem", getAriaLabel: (v) => g.accessibilityProvider.getAriaLabel(v.element), getWidgetAriaLabel: () => g.accessibilityProvider.getWidgetAriaLabel(), getWidgetRole: g.accessibilityProvider && g.accessibilityProvider.getWidgetRole ? () => g.accessibilityProvider.getWidgetRole() : () => "tree", getAriaLevel: g.accessibilityProvider && g.accessibilityProvider.getAriaLevel ? (v) => g.accessibilityProvider.getAriaLevel(v.element) : (v) => v.depth, getActiveDescendantId: g.accessibilityProvider.getActiveDescendantId && ((v) => g.accessibilityProvider.getActiveDescendantId(v.element)) }, keyboardNavigationLabelProvider: g.keyboardNavigationLabelProvider && { ...g.keyboardNavigationLabelProvider, getKeyboardNavigationLabel: (v) => g.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(v.element) } }), tree: this, stickyScrollProvider: () => this.stickyScrollController }), this.model = this.createModel(e, this.view, o), a.input = this.model.onDidChangeCollapseState;
    const p = se.forEach(this.model.onDidSplice, ((v) => {
      this.eventBufferer.bufferEvents((() => {
        this.focus.onDidModelSplice(v), this.selection.onDidModelSplice(v);
      }));
    }), this.disposables);
    p((() => null), null, this.disposables);
    const f = this.disposables.add(new F()), _ = this.disposables.add(new Sr(0));
    if (this.disposables.add(se.any(p, this.focus.onDidChange, this.selection.onDidChange)((() => {
      _.trigger((() => {
        const v = /* @__PURE__ */ new Set();
        for (const b of this.focus.getNodes()) v.add(b);
        for (const b of this.selection.getNodes()) v.add(b);
        f.fire([...v.values()]);
      }));
    }))), l.input = f.event, o.keyboardSupport !== !1) {
      const v = se.chain(this.view.onKeyDown, ((b) => b.filter(((C) => !nc(C.target))).map(((C) => new jt(C)))));
      se.chain(v, ((b) => b.filter(((C) => C.keyCode === 15))))(this.onLeftArrow, this, this.disposables), se.chain(v, ((b) => b.filter(((C) => C.keyCode === 17))))(this.onRightArrow, this, this.disposables), se.chain(v, ((b) => b.filter(((C) => C.keyCode === 10))))(this.onSpace, this, this.disposables);
    }
    if (((r = o.findWidgetEnabled) === null || r === void 0 || r) && o.keyboardNavigationLabelProvider && o.contextViewProvider) {
      const v = this.options.findWidgetStyles ? { styles: this.options.findWidgetStyles } : void 0;
      this.findController = new Ute(this, this.model, this.view, c, o.contextViewProvider, v), this.focusNavigationFilter = (b) => this.findController.shouldAllowFocus(b), this.onDidChangeFindOpenState = this.findController.onDidChangeOpenState, this.disposables.add(this.findController), this.onDidChangeFindMode = this.findController.onDidChangeMode, this.onDidChangeFindMatchType = this.findController.onDidChangeMatchType;
    } else this.onDidChangeFindMode = se.None, this.onDidChangeFindMatchType = se.None;
    o.enableStickyScroll && (this.stickyScrollController = new Z3(this, this.model, this.view, this.renderers, this.treeDelegate, o), this.onDidChangeStickyScrollFocused = this.stickyScrollController.onDidChangeHasFocus), this.styleElement = Lo(this.view.getHTMLElement()), this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === tf.Always);
  }
  updateOptions(e = {}) {
    var t;
    this._options = { ...this._options, ...e };
    for (const i of this.renderers) i.updateOptions(e);
    this.view.updateOptions(this._options), (t = this.findController) === null || t === void 0 || t.updateOptions(e), this.updateStickyScroll(e), this._onDidUpdateOptions.fire(this._options), this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === tf.Always);
  }
  get options() {
    return this._options;
  }
  updateStickyScroll(e) {
    var t;
    !this.stickyScrollController && this._options.enableStickyScroll ? (this.stickyScrollController = new Z3(this, this.model, this.view, this.renderers, this.treeDelegate, this._options), this.onDidChangeStickyScrollFocused = this.stickyScrollController.onDidChangeHasFocus) : this.stickyScrollController && !this._options.enableStickyScroll && (this.onDidChangeStickyScrollFocused = se.None, this.stickyScrollController.dispose(), this.stickyScrollController = void 0), (t = this.stickyScrollController) === null || t === void 0 || t.updateOptions(e);
  }
  getHTMLElement() {
    return this.view.getHTMLElement();
  }
  get scrollTop() {
    return this.view.scrollTop;
  }
  set scrollTop(e) {
    this.view.scrollTop = e;
  }
  get scrollHeight() {
    return this.view.scrollHeight;
  }
  get renderHeight() {
    return this.view.renderHeight;
  }
  get ariaLabel() {
    return this.view.ariaLabel;
  }
  set ariaLabel(e) {
    this.view.ariaLabel = e;
  }
  domFocus() {
    var e;
    !((e = this.stickyScrollController) === null || e === void 0) && e.focusedLast() ? this.stickyScrollController.domFocus() : this.view.domFocus();
  }
  layout(e, t) {
    var i;
    this.view.layout(e, t), uc(t) && ((i = this.findController) === null || i === void 0 || i.layout(t));
  }
  style(e) {
    var t;
    const i = `.${this.view.domId}`, s = [];
    e.treeIndentGuidesStroke && (s.push(`.monaco-list${i}:hover .monaco-tl-indent > .indent-guide, .monaco-list${i}.always .monaco-tl-indent > .indent-guide  { border-color: ${e.treeInactiveIndentGuidesStroke}; }`), s.push(`.monaco-list${i} .monaco-tl-indent > .indent-guide.active { border-color: ${e.treeIndentGuidesStroke}; }`)), e.listBackground && (s.push(`.monaco-list${i} .monaco-scrollable-element .monaco-tree-sticky-container { background-color: ${e.listBackground}; }`), s.push(`.monaco-list${i} .monaco-scrollable-element .monaco-tree-sticky-container .monaco-tree-sticky-row { background-color: ${e.listBackground}; }`)), e.listFocusForeground && (s.push(`.monaco-list${i}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused { color: ${e.listFocusForeground}; }`), s.push(`.monaco-list${i}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused { color: inherit; }`));
    const o = kd(e.listFocusAndSelectionOutline, kd(e.listSelectionOutline, (t = e.listFocusOutline) !== null && t !== void 0 ? t : ""));
    o && (s.push(`.monaco-list${i}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused.selected { outline: 1px solid ${o}; outline-offset: -1px;}`), s.push(`.monaco-list${i}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused.selected { outline: inherit;}`)), e.listFocusOutline && (s.push(`.monaco-list${i}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }`), s.push(`.monaco-list${i}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused { outline: inherit; }`), s.push(`.monaco-workbench.context-menu-visible .monaco-list${i}.last-focused.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.passive-focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }`), s.push(`.monaco-workbench.context-menu-visible .monaco-list${i}.last-focused.sticky-scroll-focused .monaco-list-rows .monaco-list-row.focused { outline: inherit; }`), s.push(`.monaco-workbench.context-menu-visible .monaco-list${i}.last-focused:not(.sticky-scroll-focused) .monaco-tree-sticky-container .monaco-list-rows .monaco-list-row.focused { outline: inherit; }`)), this.styleElement.textContent = s.join(`
`), this.view.style(e);
  }
  getParentElement(e) {
    const t = this.model.getParentNodeLocation(e);
    return this.model.getNode(t).element;
  }
  getFirstElementChild(e) {
    return this.model.getFirstElementChild(e);
  }
  getNode(e) {
    return this.model.getNode(e);
  }
  getNodeLocation(e) {
    return this.model.getNodeLocation(e);
  }
  collapse(e, t = !1) {
    return this.model.setCollapsed(e, !0, t);
  }
  expand(e, t = !1) {
    return this.model.setCollapsed(e, !1, t);
  }
  toggleCollapsed(e, t = !1) {
    return this.model.setCollapsed(e, void 0, t);
  }
  isCollapsible(e) {
    return this.model.isCollapsible(e);
  }
  setCollapsible(e, t) {
    return this.model.setCollapsible(e, t);
  }
  isCollapsed(e) {
    return this.model.isCollapsed(e);
  }
  refilter() {
    this._onWillRefilter.fire(void 0), this.model.refilter();
  }
  setSelection(e, t) {
    this.eventBufferer.bufferEvents((() => {
      const i = e.map(((o) => this.model.getNode(o)));
      this.selection.set(i, t);
      const s = e.map(((o) => this.model.getListIndex(o))).filter(((o) => o > -1));
      this.view.setSelection(s, t, !0);
    }));
  }
  getSelection() {
    return this.selection.get();
  }
  setFocus(e, t) {
    this.eventBufferer.bufferEvents((() => {
      const i = e.map(((o) => this.model.getNode(o)));
      this.focus.set(i, t);
      const s = e.map(((o) => this.model.getListIndex(o))).filter(((o) => o > -1));
      this.view.setFocus(s, t, !0);
    }));
  }
  focusNext(e = 1, t = !1, i, s = fh(i) && i.altKey ? void 0 : this.focusNavigationFilter) {
    this.view.focusNext(e, t, i, s);
  }
  focusPrevious(e = 1, t = !1, i, s = fh(i) && i.altKey ? void 0 : this.focusNavigationFilter) {
    this.view.focusPrevious(e, t, i, s);
  }
  focusNextPage(e, t = fh(e) && e.altKey ? void 0 : this.focusNavigationFilter) {
    return this.view.focusNextPage(e, t);
  }
  focusPreviousPage(e, t = fh(e) && e.altKey ? void 0 : this.focusNavigationFilter) {
    return this.view.focusPreviousPage(e, t, (() => {
      var i, s;
      return (s = (i = this.stickyScrollController) === null || i === void 0 ? void 0 : i.height) !== null && s !== void 0 ? s : 0;
    }));
  }
  focusFirst(e, t = fh(e) && e.altKey ? void 0 : this.focusNavigationFilter) {
    this.view.focusFirst(e, t);
  }
  getFocus() {
    return this.focus.get();
  }
  reveal(e, t) {
    this.model.expandTo(e);
    const i = this.model.getListIndex(e);
    if (i !== -1) if (this.stickyScrollController) {
      const s = this.stickyScrollController.nodePositionTopBelowWidget(this.getNode(e));
      this.view.reveal(i, t, s);
    } else this.view.reveal(i, t);
  }
  onLeftArrow(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0) return;
    const i = t[0], s = this.model.getNodeLocation(i);
    if (!this.model.setCollapsed(s, !0)) {
      const o = this.model.getParentNodeLocation(s);
      if (!o) return;
      const r = this.model.getListIndex(o);
      this.view.reveal(r), this.view.setFocus([r]);
    }
  }
  onRightArrow(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0) return;
    const i = t[0], s = this.model.getNodeLocation(i);
    if (!this.model.setCollapsed(s, !1)) {
      if (!i.children.some(((a) => a.visible))) return;
      const [o] = this.view.getFocus(), r = o + 1;
      this.view.reveal(r), this.view.setFocus([r]);
    }
  }
  onSpace(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0) return;
    const i = t[0], s = this.model.getNodeLocation(i), o = e.browserEvent.altKey;
    this.model.setCollapsed(s, void 0, o);
  }
  dispose() {
    var e;
    Ht(this.disposables), (e = this.stickyScrollController) === null || e === void 0 || e.dispose(), this.view.dispose();
  }
}
class TA {
  constructor(e, t, i = {}) {
    this.user = e, this.rootRef = null, this.nodes = /* @__PURE__ */ new Map(), this.nodesByIdentity = /* @__PURE__ */ new Map(), this.model = new Bte(e, t, null, i), this.onDidSplice = this.model.onDidSplice, this.onDidChangeCollapseState = this.model.onDidChangeCollapseState, this.onDidChangeRenderNodeCount = this.model.onDidChangeRenderNodeCount, i.sorter && (this.sorter = { compare: (s, o) => i.sorter.compare(s.element, o.element) }), this.identityProvider = i.identityProvider;
  }
  setChildren(e, t = at.empty(), i = {}) {
    const s = this.getElementLocation(e);
    this._setChildren(s, this.preserveCollapseState(t), i);
  }
  _setChildren(e, t = at.empty(), i) {
    const s = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set();
    this.model.splice([...e, 0], Number.MAX_VALUE, t, { ...i, onDidCreateNode: (r) => {
      var a;
      if (r.element === null) return;
      const l = r;
      if (s.add(l.element), this.nodes.set(l.element, l), this.identityProvider) {
        const d = this.identityProvider.getId(l.element).toString();
        o.add(d), this.nodesByIdentity.set(d, l);
      }
      (a = i.onDidCreateNode) === null || a === void 0 || a.call(i, l);
    }, onDidDeleteNode: (r) => {
      var a;
      if (r.element === null) return;
      const l = r;
      if (s.has(l.element) || this.nodes.delete(l.element), this.identityProvider) {
        const d = this.identityProvider.getId(l.element).toString();
        o.has(d) || this.nodesByIdentity.delete(d);
      }
      (a = i.onDidDeleteNode) === null || a === void 0 || a.call(i, l);
    } });
  }
  preserveCollapseState(e = at.empty()) {
    return this.sorter && (e = [...e].sort(this.sorter.compare.bind(this.sorter))), at.map(e, ((t) => {
      let i = this.nodes.get(t.element);
      if (!i && this.identityProvider) {
        const r = this.identityProvider.getId(t.element).toString();
        i = this.nodesByIdentity.get(r);
      }
      if (!i) {
        let r;
        return r = t.collapsed === void 0 ? void 0 : t.collapsed === co.Collapsed || t.collapsed === co.PreserveOrCollapsed || t.collapsed !== co.Expanded && t.collapsed !== co.PreserveOrExpanded && !!t.collapsed, { ...t, children: this.preserveCollapseState(t.children), collapsed: r };
      }
      const s = typeof t.collapsible == "boolean" ? t.collapsible : i.collapsible;
      let o;
      return o = t.collapsed === void 0 || t.collapsed === co.PreserveOrCollapsed || t.collapsed === co.PreserveOrExpanded ? i.collapsed : t.collapsed === co.Collapsed || t.collapsed !== co.Expanded && !!t.collapsed, { ...t, collapsible: s, collapsed: o, children: this.preserveCollapseState(t.children) };
    }));
  }
  rerender(e) {
    const t = this.getElementLocation(e);
    this.model.rerender(t);
  }
  getFirstElementChild(e = null) {
    const t = this.getElementLocation(e);
    return this.model.getFirstElementChild(t);
  }
  has(e) {
    return this.nodes.has(e);
  }
  getListIndex(e) {
    const t = this.getElementLocation(e);
    return this.model.getListIndex(t);
  }
  getListRenderCount(e) {
    const t = this.getElementLocation(e);
    return this.model.getListRenderCount(t);
  }
  isCollapsible(e) {
    const t = this.getElementLocation(e);
    return this.model.isCollapsible(t);
  }
  setCollapsible(e, t) {
    const i = this.getElementLocation(e);
    return this.model.setCollapsible(i, t);
  }
  isCollapsed(e) {
    const t = this.getElementLocation(e);
    return this.model.isCollapsed(t);
  }
  setCollapsed(e, t, i) {
    const s = this.getElementLocation(e);
    return this.model.setCollapsed(s, t, i);
  }
  expandTo(e) {
    const t = this.getElementLocation(e);
    this.model.expandTo(t);
  }
  refilter() {
    this.model.refilter();
  }
  getNode(e = null) {
    if (e === null) return this.model.getNode(this.model.rootRef);
    const t = this.nodes.get(e);
    if (!t) throw new _o(this.user, `Tree element not found: ${e}`);
    return t;
  }
  getNodeLocation(e) {
    return e.element;
  }
  getParentNodeLocation(e) {
    if (e === null) throw new _o(this.user, "Invalid getParentNodeLocation call");
    const t = this.nodes.get(e);
    if (!t) throw new _o(this.user, `Tree element not found: ${e}`);
    const i = this.model.getNodeLocation(t), s = this.model.getParentNodeLocation(i);
    return this.model.getNode(s).element;
  }
  getElementLocation(e) {
    if (e === null) return [];
    const t = this.nodes.get(e);
    if (!t) throw new _o(this.user, `Tree element not found: ${e}`);
    return this.model.getNodeLocation(t);
  }
}
function ZC(n) {
  return { element: { elements: [n.element], incompressible: n.incompressible || !1 }, children: at.map(at.from(n.children), ZC), collapsible: n.collapsible, collapsed: n.collapsed };
}
function YC(n) {
  const e = [n.element], t = n.incompressible || !1;
  let i, s;
  for (; [s, i] = at.consume(at.from(n.children), 2), s.length === 1 && !s[0].incompressible; ) n = s[0], e.push(n.element);
  return { element: { elements: e, incompressible: t }, children: at.map(at.concat(s, i), YC), collapsible: n.collapsible, collapsed: n.collapsed };
}
function l2(n, e = 0) {
  let t;
  return t = e < n.element.elements.length - 1 ? [l2(n, e + 1)] : at.map(at.from(n.children), ((i) => l2(i, 0))), e === 0 && n.element.incompressible ? { element: n.element.elements[e], children: t, incompressible: !0, collapsible: n.collapsible, collapsed: n.collapsed } : { element: n.element.elements[e], children: t, collapsible: n.collapsible, collapsed: n.collapsed };
}
function Y3(n) {
  return l2(n, 0);
}
function cV(n, e, t) {
  return n.element === e ? { ...n, children: t } : { ...n, children: at.map(at.from(n.children), ((i) => cV(i, e, t))) };
}
class Qte {
  get onDidSplice() {
    return this.model.onDidSplice;
  }
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  get onDidChangeRenderNodeCount() {
    return this.model.onDidChangeRenderNodeCount;
  }
  constructor(e, t, i = {}) {
    this.user = e, this.rootRef = null, this.nodes = /* @__PURE__ */ new Map(), this.model = new TA(e, t, i), this.enabled = i.compressionEnabled === void 0 || i.compressionEnabled, this.identityProvider = i.identityProvider;
  }
  setChildren(e, t = at.empty(), i) {
    const s = i.diffIdentityProvider && (o = i.diffIdentityProvider, { getId: (p) => p.elements.map(((f) => o.getId(f).toString())).join("\0") });
    var o;
    if (e === null) {
      const p = at.map(t, this.enabled ? YC : ZC);
      return void this._setChildren(null, p, { diffIdentityProvider: s, diffDepth: 1 / 0 });
    }
    const r = this.nodes.get(e);
    if (!r) throw new _o(this.user, "Unknown compressed tree node");
    const a = this.model.getNode(r), l = this.model.getParentNodeLocation(r), d = this.model.getNode(l), h = cV(Y3(a), e, t), c = (this.enabled ? YC : ZC)(h), u = i.diffIdentityProvider ? (p, f) => i.diffIdentityProvider.getId(p) === i.diffIdentityProvider.getId(f) : void 0;
    if (ri(c.element.elements, a.element.elements, u)) return void this._setChildren(r, c.children || at.empty(), { diffIdentityProvider: s, diffDepth: 1 });
    const g = d.children.map(((p) => p === a ? c : p));
    this._setChildren(d.element, g, { diffIdentityProvider: s, diffDepth: a.depth - d.depth });
  }
  isCompressionEnabled() {
    return this.enabled;
  }
  setCompressionEnabled(e) {
    if (e === this.enabled) return;
    this.enabled = e;
    const t = this.model.getNode().children, i = at.map(t, Y3), s = at.map(i, e ? YC : ZC);
    this._setChildren(null, s, { diffIdentityProvider: this.identityProvider, diffDepth: 1 / 0 });
  }
  _setChildren(e, t, i) {
    const s = /* @__PURE__ */ new Set();
    this.model.setChildren(e, t, { ...i, onDidCreateNode: (o) => {
      for (const r of o.element.elements) s.add(r), this.nodes.set(r, o.element);
    }, onDidDeleteNode: (o) => {
      for (const r of o.element.elements) s.has(r) || this.nodes.delete(r);
    } });
  }
  has(e) {
    return this.nodes.has(e);
  }
  getListIndex(e) {
    const t = this.getCompressedNode(e);
    return this.model.getListIndex(t);
  }
  getListRenderCount(e) {
    const t = this.getCompressedNode(e);
    return this.model.getListRenderCount(t);
  }
  getNode(e) {
    if (e === void 0) return this.model.getNode();
    const t = this.getCompressedNode(e);
    return this.model.getNode(t);
  }
  getNodeLocation(e) {
    const t = this.model.getNodeLocation(e);
    return t === null ? null : t.elements[t.elements.length - 1];
  }
  getParentNodeLocation(e) {
    const t = this.getCompressedNode(e), i = this.model.getParentNodeLocation(t);
    return i === null ? null : i.elements[i.elements.length - 1];
  }
  getFirstElementChild(e) {
    const t = this.getCompressedNode(e);
    return this.model.getFirstElementChild(t);
  }
  isCollapsible(e) {
    const t = this.getCompressedNode(e);
    return this.model.isCollapsible(t);
  }
  setCollapsible(e, t) {
    const i = this.getCompressedNode(e);
    return this.model.setCollapsible(i, t);
  }
  isCollapsed(e) {
    const t = this.getCompressedNode(e);
    return this.model.isCollapsed(t);
  }
  setCollapsed(e, t, i) {
    const s = this.getCompressedNode(e);
    return this.model.setCollapsed(s, t, i);
  }
  expandTo(e) {
    const t = this.getCompressedNode(e);
    this.model.expandTo(t);
  }
  rerender(e) {
    const t = this.getCompressedNode(e);
    this.model.rerender(t);
  }
  refilter() {
    this.model.refilter();
  }
  getCompressedNode(e) {
    if (e === null) return null;
    const t = this.nodes.get(e);
    if (!t) throw new _o(this.user, `Tree element not found: ${e}`);
    return t;
  }
}
const Jte = (n) => n[n.length - 1];
class RA {
  get element() {
    return this.node.element === null ? null : this.unwrapper(this.node.element);
  }
  get children() {
    return this.node.children.map(((e) => new RA(this.unwrapper, e)));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e, t) {
    this.unwrapper = e, this.node = t;
  }
}
class eie {
  get onDidSplice() {
    return se.map(this.model.onDidSplice, (({ insertedNodes: e, deletedNodes: t }) => ({ insertedNodes: e.map(((i) => this.nodeMapper.map(i))), deletedNodes: t.map(((i) => this.nodeMapper.map(i))) })));
  }
  get onDidChangeCollapseState() {
    return se.map(this.model.onDidChangeCollapseState, (({ node: e, deep: t }) => ({ node: this.nodeMapper.map(e), deep: t })));
  }
  get onDidChangeRenderNodeCount() {
    return se.map(this.model.onDidChangeRenderNodeCount, ((e) => this.nodeMapper.map(e)));
  }
  constructor(e, t, i = {}) {
    this.rootRef = null, this.elementMapper = i.elementMapper || Jte;
    const s = (o) => this.elementMapper(o.elements);
    this.nodeMapper = new EA(((o) => new RA(s, o))), this.model = new Qte(e, /* @__PURE__ */ (function(o, r) {
      return { splice(a, l, d) {
        r.splice(a, l, d.map(((h) => o.map(h))));
      }, updateElementHeight(a, l) {
        r.updateElementHeight(a, l);
      } };
    })(this.nodeMapper, t), (function(o, r) {
      return { ...r, identityProvider: r.identityProvider && { getId: (a) => r.identityProvider.getId(o(a)) }, sorter: r.sorter && { compare: (a, l) => r.sorter.compare(a.elements[0], l.elements[0]) }, filter: r.filter && { filter: (a, l) => r.filter.filter(o(a), l) } };
    })(s, i));
  }
  setChildren(e, t = at.empty(), i = {}) {
    this.model.setChildren(e, t, i);
  }
  isCompressionEnabled() {
    return this.model.isCompressionEnabled();
  }
  setCompressionEnabled(e) {
    this.model.setCompressionEnabled(e);
  }
  has(e) {
    return this.model.has(e);
  }
  getListIndex(e) {
    return this.model.getListIndex(e);
  }
  getListRenderCount(e) {
    return this.model.getListRenderCount(e);
  }
  getNode(e) {
    return this.nodeMapper.map(this.model.getNode(e));
  }
  getNodeLocation(e) {
    return e.element;
  }
  getParentNodeLocation(e) {
    return this.model.getParentNodeLocation(e);
  }
  getFirstElementChild(e) {
    const t = this.model.getFirstElementChild(e);
    return t == null ? t : this.elementMapper(t.elements);
  }
  isCollapsible(e) {
    return this.model.isCollapsible(e);
  }
  setCollapsible(e, t) {
    return this.model.setCollapsible(e, t);
  }
  isCollapsed(e) {
    return this.model.isCollapsed(e);
  }
  setCollapsed(e, t, i) {
    return this.model.setCollapsed(e, t, i);
  }
  expandTo(e) {
    return this.model.expandTo(e);
  }
  rerender(e) {
    return this.model.rerender(e);
  }
  refilter() {
    return this.model.refilter();
  }
  getCompressedTreeNode(e = null) {
    return this.model.getNode(e);
  }
}
var tie = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
};
class AA extends hV {
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  constructor(e, t, i, s, o = {}) {
    super(e, t, i, s, o), this.user = e;
  }
  setChildren(e, t = at.empty(), i) {
    this.model.setChildren(e, t, i);
  }
  rerender(e) {
    e !== void 0 ? this.model.rerender(e) : this.view.rerender();
  }
  hasElement(e) {
    return this.model.has(e);
  }
  createModel(e, t, i) {
    return new TA(e, t, i);
  }
}
class uV {
  get compressedTreeNodeProvider() {
    return this._compressedTreeNodeProvider();
  }
  constructor(e, t, i) {
    this._compressedTreeNodeProvider = e, this.stickyScrollDelegate = t, this.renderer = i, this.templateId = i.templateId, i.onDidChangeTwistieState && (this.onDidChangeTwistieState = i.onDidChangeTwistieState);
  }
  renderTemplate(e) {
    return { compressedTreeNode: void 0, data: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, i, s) {
    let o = this.stickyScrollDelegate.getCompressedNode(e);
    o || (o = this.compressedTreeNodeProvider.getCompressedTreeNode(e.element)), o.element.elements.length === 1 ? (i.compressedTreeNode = void 0, this.renderer.renderElement(e, t, i.data, s)) : (i.compressedTreeNode = o, this.renderer.renderCompressedElements(o, t, i.data, s));
  }
  disposeElement(e, t, i, s) {
    var o, r, a, l;
    i.compressedTreeNode ? (r = (o = this.renderer).disposeCompressedElements) === null || r === void 0 || r.call(o, i.compressedTreeNode, t, i.data, s) : (l = (a = this.renderer).disposeElement) === null || l === void 0 || l.call(a, e, t, i.data, s);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.data);
  }
  renderTwistie(e, t) {
    return !!this.renderer.renderTwistie && this.renderer.renderTwistie(e, t);
  }
}
tie([Li], uV.prototype, "compressedTreeNodeProvider", null);
class iie {
  constructor(e) {
    this.modelProvider = e, this.compressedStickyNodes = /* @__PURE__ */ new Map();
  }
  getCompressedNode(e) {
    return this.compressedStickyNodes.get(e);
  }
  constrainStickyScrollNodes(e, t, i) {
    if (this.compressedStickyNodes.clear(), e.length === 0) return [];
    for (let s = 0; s < e.length; s++) {
      const o = e[s], r = o.position + o.height;
      if (s + 1 < e.length && r + e[s + 1].height > i || s >= t - 1 && t < e.length) {
        const a = e.slice(0, s), l = e.slice(s);
        return [...a, this.compressStickyNodes(l)];
      }
    }
    return e;
  }
  compressStickyNodes(e) {
    if (e.length === 0) throw new Error("Can't compress empty sticky nodes");
    if (!this.modelProvider().isCompressionEnabled()) return e[0];
    const t = [];
    for (const l of e) {
      const d = this.modelProvider().getCompressedTreeNode(l.node.element);
      if (d.element) {
        if (d.element.incompressible) break;
        t.push(...d.element.elements);
      }
    }
    if (t.length < 2) return e[0];
    const i = e[e.length - 1], s = { elements: t, incompressible: !1 }, o = { ...i.node, children: [], element: s }, r = new Proxy(e[0].node, {}), a = { node: r, startIndex: e[0].startIndex, endIndex: i.endIndex, position: e[0].position, height: e[0].height };
    return this.compressedStickyNodes.set(r, o), a;
  }
}
function nie(n, e) {
  return e && { ...e, keyboardNavigationLabelProvider: e.keyboardNavigationLabelProvider && { getKeyboardNavigationLabel(t) {
    let i;
    try {
      i = n().getCompressedTreeNode(t);
    } catch {
      return e.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(t);
    }
    return i.element.elements.length === 1 ? e.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(t) : e.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(i.element.elements);
  } } };
}
class gV extends AA {
  constructor(e, t, i, s, o = {}) {
    const r = () => this, a = new iie((() => this.model));
    super(e, t, i, s.map(((l) => new uV(r, a, l))), { ...nie(r, o), stickyScrollDelegate: a });
  }
  setChildren(e, t = at.empty(), i) {
    this.model.setChildren(e, t, i);
  }
  createModel(e, t, i) {
    return new eie(e, t, i);
  }
  updateOptions(e = {}) {
    super.updateOptions(e), e.compressionEnabled !== void 0 && this.model.setCompressionEnabled(e.compressionEnabled);
  }
  getCompressedTreeNode(e = null) {
    return this.model.getCompressedTreeNode(e);
  }
}
function sx(n) {
  return { ...n, children: [], refreshPromise: void 0, stale: !0, slow: !1, forceExpanded: !1 };
}
function d2(n, e) {
  return !!e.parent && (e.parent === n || d2(n, e.parent));
}
class PA {
  get element() {
    return this.node.element.element;
  }
  get children() {
    return this.node.children.map(((e) => new PA(e)));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e) {
    this.node = e;
  }
}
class sie {
  constructor(e, t, i) {
    this.renderer = e, this.nodeMapper = t, this.onDidChangeTwistieState = i, this.renderedNodes = /* @__PURE__ */ new Map(), this.templateId = e.templateId;
  }
  renderTemplate(e) {
    return { templateData: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, i, s) {
    this.renderer.renderElement(this.nodeMapper.map(e), t, i.templateData, s);
  }
  renderTwistie(e, t) {
    return e.slow ? (t.classList.add(...Ee.asClassNameArray(ne.treeItemLoading)), !0) : (t.classList.remove(...Ee.asClassNameArray(ne.treeItemLoading)), !1);
  }
  disposeElement(e, t, i, s) {
    var o, r;
    (r = (o = this.renderer).disposeElement) === null || r === void 0 || r.call(o, this.nodeMapper.map(e), t, i.templateData, s);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  dispose() {
    this.renderedNodes.clear();
  }
}
function X3(n) {
  return { browserEvent: n.browserEvent, elements: n.elements.map(((e) => e.element)) };
}
function Q3(n) {
  return { browserEvent: n.browserEvent, element: n.element && n.element.element, target: n.target };
}
class oie extends T1 {
  constructor(e) {
    super(e.elements.map(((t) => t.element))), this.data = e;
  }
}
function ox(n) {
  return n instanceof T1 ? new oie(n) : n;
}
class rie {
  constructor(e) {
    this.dnd = e;
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e.element);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel) return this.dnd.getDragLabel(e.map(((i) => i.element)), t);
  }
  onDragStart(e, t) {
    var i, s;
    (s = (i = this.dnd).onDragStart) === null || s === void 0 || s.call(i, ox(e), t);
  }
  onDragOver(e, t, i, s, o, r = !0) {
    return this.dnd.onDragOver(ox(e), t && t.element, i, s, o);
  }
  drop(e, t, i, s, o) {
    this.dnd.drop(ox(e), t && t.element, i, s, o);
  }
  onDragEnd(e) {
    var t, i;
    (i = (t = this.dnd).onDragEnd) === null || i === void 0 || i.call(t, e);
  }
  dispose() {
    this.dnd.dispose();
  }
}
function pV(n) {
  return n && { ...n, collapseByDefault: !0, identityProvider: n.identityProvider && { getId: (e) => n.identityProvider.getId(e.element) }, dnd: n.dnd && new rie(n.dnd), multipleSelectionController: n.multipleSelectionController && { isSelectionSingleChangeEvent: (e) => n.multipleSelectionController.isSelectionSingleChangeEvent({ ...e, element: e.element }), isSelectionRangeChangeEvent: (e) => n.multipleSelectionController.isSelectionRangeChangeEvent({ ...e, element: e.element }) }, accessibilityProvider: n.accessibilityProvider && { ...n.accessibilityProvider, getPosInSet: void 0, getSetSize: void 0, getRole: n.accessibilityProvider.getRole ? (e) => n.accessibilityProvider.getRole(e.element) : () => "treeitem", isChecked: n.accessibilityProvider.isChecked ? (e) => {
    var t;
    return !!(!((t = n.accessibilityProvider) === null || t === void 0) && t.isChecked(e.element));
  } : void 0, getAriaLabel: (e) => n.accessibilityProvider.getAriaLabel(e.element), getWidgetAriaLabel: () => n.accessibilityProvider.getWidgetAriaLabel(), getWidgetRole: n.accessibilityProvider.getWidgetRole ? () => n.accessibilityProvider.getWidgetRole() : () => "tree", getAriaLevel: n.accessibilityProvider.getAriaLevel && ((e) => n.accessibilityProvider.getAriaLevel(e.element)), getActiveDescendantId: n.accessibilityProvider.getActiveDescendantId && ((e) => n.accessibilityProvider.getActiveDescendantId(e.element)) }, filter: n.filter && { filter: (e, t) => n.filter.filter(e.element, t) }, keyboardNavigationLabelProvider: n.keyboardNavigationLabelProvider && { ...n.keyboardNavigationLabelProvider, getKeyboardNavigationLabel: (e) => n.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e.element) }, sorter: void 0, expandOnlyOnTwistieClick: n.expandOnlyOnTwistieClick === void 0 ? void 0 : typeof n.expandOnlyOnTwistieClick != "function" ? n.expandOnlyOnTwistieClick : (e) => n.expandOnlyOnTwistieClick(e.element), defaultFindVisibility: (e) => e.hasChildren && e.stale ? 1 : typeof n.defaultFindVisibility == "number" ? n.defaultFindVisibility : n.defaultFindVisibility === void 0 ? 2 : n.defaultFindVisibility(e.element) };
}
function h2(n, e) {
  e(n), n.children.forEach(((t) => h2(t, e)));
}
class mV {
  get onDidScroll() {
    return this.tree.onDidScroll;
  }
  get onDidChangeFocus() {
    return se.map(this.tree.onDidChangeFocus, X3);
  }
  get onDidChangeSelection() {
    return se.map(this.tree.onDidChangeSelection, X3);
  }
  get onMouseDblClick() {
    return se.map(this.tree.onMouseDblClick, Q3);
  }
  get onPointer() {
    return se.map(this.tree.onPointer, Q3);
  }
  get onDidFocus() {
    return this.tree.onDidFocus;
  }
  get onDidChangeModel() {
    return this.tree.onDidChangeModel;
  }
  get onDidChangeCollapseState() {
    return this.tree.onDidChangeCollapseState;
  }
  get onDidChangeFindOpenState() {
    return this.tree.onDidChangeFindOpenState;
  }
  get onDidChangeStickyScrollFocused() {
    return this.tree.onDidChangeStickyScrollFocused;
  }
  get onDidDispose() {
    return this.tree.onDidDispose;
  }
  constructor(e, t, i, s, o, r = {}) {
    this.user = e, this.dataSource = o, this.nodes = /* @__PURE__ */ new Map(), this.subTreeRefreshPromises = /* @__PURE__ */ new Map(), this.refreshPromises = /* @__PURE__ */ new Map(), this._onDidRender = new F(), this._onDidChangeNodeSlowState = new F(), this.nodeMapper = new EA(((a) => new PA(a))), this.disposables = new G(), this.identityProvider = r.identityProvider, this.autoExpandSingleChildren = r.autoExpandSingleChildren !== void 0 && r.autoExpandSingleChildren, this.sorter = r.sorter, this.getDefaultCollapseState = (a) => r.collapseByDefault ? r.collapseByDefault(a) ? co.PreserveOrCollapsed : co.PreserveOrExpanded : void 0, this.tree = this.createTree(e, t, i, s, r), this.onDidChangeFindMode = this.tree.onDidChangeFindMode, this.onDidChangeFindMatchType = this.tree.onDidChangeFindMatchType, this.root = sx({ element: void 0, parent: null, hasChildren: !0, defaultCollapseState: void 0 }), this.identityProvider && (this.root = { ...this.root, id: null }), this.nodes.set(null, this.root), this.tree.onDidChangeCollapseState(this._onDidChangeCollapseState, this, this.disposables);
  }
  createTree(e, t, i, s, o) {
    const r = new MA(i), a = s.map(((d) => new sie(d, this.nodeMapper, this._onDidChangeNodeSlowState.event))), l = pV(o) || {};
    return new AA(e, t, r, a, l);
  }
  updateOptions(e = {}) {
    this.tree.updateOptions(e);
  }
  getHTMLElement() {
    return this.tree.getHTMLElement();
  }
  get scrollTop() {
    return this.tree.scrollTop;
  }
  set scrollTop(e) {
    this.tree.scrollTop = e;
  }
  get scrollHeight() {
    return this.tree.scrollHeight;
  }
  get renderHeight() {
    return this.tree.renderHeight;
  }
  domFocus() {
    this.tree.domFocus();
  }
  layout(e, t) {
    this.tree.layout(e, t);
  }
  style(e) {
    this.tree.style(e);
  }
  getInput() {
    return this.root.element;
  }
  async setInput(e, t) {
    this.refreshPromises.forEach(((s) => s.cancel())), this.refreshPromises.clear(), this.root.element = e;
    const i = t && { viewState: t, focus: [], selection: [] };
    await this._updateChildren(e, !0, !1, i), i && (this.tree.setFocus(i.focus), this.tree.setSelection(i.selection)), t && typeof t.scrollTop == "number" && (this.scrollTop = t.scrollTop);
  }
  async _updateChildren(e = this.root.element, t = !0, i = !1, s, o) {
    if (this.root.element === void 0) throw new _o(this.user, "Tree input not set");
    this.root.refreshPromise && (await this.root.refreshPromise, await se.toPromise(this._onDidRender.event));
    const r = this.getDataNode(e);
    if (await this.refreshAndRenderNode(r, t, s, o), i) try {
      this.tree.rerender(r);
    } catch {
    }
  }
  rerender(e) {
    if (e === void 0 || e === this.root.element) return void this.tree.rerender();
    const t = this.getDataNode(e);
    this.tree.rerender(t);
  }
  getNode(e = this.root.element) {
    const t = this.getDataNode(e), i = this.tree.getNode(t === this.root ? null : t);
    return this.nodeMapper.map(i);
  }
  collapse(e, t = !1) {
    const i = this.getDataNode(e);
    return this.tree.collapse(i === this.root ? null : i, t);
  }
  async expand(e, t = !1) {
    if (this.root.element === void 0) throw new _o(this.user, "Tree input not set");
    this.root.refreshPromise && (await this.root.refreshPromise, await se.toPromise(this._onDidRender.event));
    const i = this.getDataNode(e);
    if (this.tree.hasElement(i) && !this.tree.isCollapsible(i) || (i.refreshPromise && (await this.root.refreshPromise, await se.toPromise(this._onDidRender.event)), i !== this.root && !i.refreshPromise && !this.tree.isCollapsed(i))) return !1;
    const s = this.tree.expand(i === this.root ? null : i, t);
    return i.refreshPromise && (await this.root.refreshPromise, await se.toPromise(this._onDidRender.event)), s;
  }
  setSelection(e, t) {
    const i = e.map(((s) => this.getDataNode(s)));
    this.tree.setSelection(i, t);
  }
  getSelection() {
    return this.tree.getSelection().map(((e) => e.element));
  }
  setFocus(e, t) {
    const i = e.map(((s) => this.getDataNode(s)));
    this.tree.setFocus(i, t);
  }
  getFocus() {
    return this.tree.getFocus().map(((e) => e.element));
  }
  reveal(e, t) {
    this.tree.reveal(this.getDataNode(e), t);
  }
  getParentElement(e) {
    const t = this.tree.getParentElement(this.getDataNode(e));
    return t && t.element;
  }
  getFirstElementChild(e = this.root.element) {
    const t = this.getDataNode(e), i = this.tree.getFirstElementChild(t === this.root ? null : t);
    return i && i.element;
  }
  getDataNode(e) {
    const t = this.nodes.get(e === this.root.element ? null : e);
    if (!t) throw new _o(this.user, `Data tree node not found: ${e}`);
    return t;
  }
  async refreshAndRenderNode(e, t, i, s) {
    await this.refreshNode(e, t, i), this.disposables.isDisposed || this.render(e, i, s);
  }
  async refreshNode(e, t, i) {
    let s;
    return this.subTreeRefreshPromises.forEach(((o, r) => {
      !s && (function(a, l) {
        return a === l || d2(a, l) || d2(l, a);
      })(r, e) && (s = o.then((() => this.refreshNode(e, t, i))));
    })), s || (e !== this.root && this.tree.getNode(e).collapsed ? (e.hasChildren = !!this.dataSource.hasChildren(e.element), e.stale = !0, void this.setChildren(e, [], t, i)) : this.doRefreshSubTree(e, t, i));
  }
  async doRefreshSubTree(e, t, i) {
    let s;
    e.refreshPromise = new Promise(((o) => s = o)), this.subTreeRefreshPromises.set(e, e.refreshPromise), e.refreshPromise.finally((() => {
      e.refreshPromise = void 0, this.subTreeRefreshPromises.delete(e);
    }));
    try {
      const o = await this.doRefreshNode(e, t, i);
      e.stale = !1, await DE.settled(o.map(((r) => this.doRefreshSubTree(r, t, i))));
    } finally {
      s();
    }
  }
  async doRefreshNode(e, t, i) {
    let s;
    if (e.hasChildren = !!this.dataSource.hasChildren(e.element), e.hasChildren) {
      const o = this.doGetChildren(e);
      if (XP(o)) s = Promise.resolve(o);
      else {
        const r = vc(800);
        r.then((() => {
          e.slow = !0, this._onDidChangeNodeSlowState.fire(e);
        }), ((a) => null)), s = o.finally((() => r.cancel()));
      }
    } else s = Promise.resolve(at.empty());
    try {
      const o = await s;
      return this.setChildren(e, o, t, i);
    } catch (o) {
      if (e !== this.root && this.tree.hasElement(e) && this.tree.collapse(e), ya(o)) return [];
      throw o;
    } finally {
      e.slow && (e.slow = !1, this._onDidChangeNodeSlowState.fire(e));
    }
  }
  doGetChildren(e) {
    let t = this.refreshPromises.get(e);
    if (t) return t;
    const i = this.dataSource.getChildren(e.element);
    return XP(i) ? this.processChildren(i) : (t = on((async () => this.processChildren(await i))), this.refreshPromises.set(e, t), t.finally((() => {
      this.refreshPromises.delete(e);
    })));
  }
  _onDidChangeCollapseState({ node: e, deep: t }) {
    e.element !== null && !e.collapsed && e.element.stale && (t ? this.collapse(e.element.element) : this.refreshAndRenderNode(e.element, !1).catch(We));
  }
  setChildren(e, t, i, s) {
    const o = [...t];
    if (e.children.length === 0 && o.length === 0) return [];
    const r = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
    for (const h of e.children) r.set(h.element, h), this.identityProvider && a.set(h.id, { node: h, collapsed: this.tree.hasElement(h) && this.tree.isCollapsed(h) });
    const l = [], d = o.map(((h) => {
      const c = !!this.dataSource.hasChildren(h);
      if (!this.identityProvider) {
        const f = sx({ element: h, parent: e, hasChildren: c, defaultCollapseState: this.getDefaultCollapseState(h) });
        return c && f.defaultCollapseState === co.PreserveOrExpanded && l.push(f), f;
      }
      const u = this.identityProvider.getId(h).toString(), g = a.get(u);
      if (g) {
        const f = g.node;
        return r.delete(f.element), this.nodes.delete(f.element), this.nodes.set(h, f), f.element = h, f.hasChildren = c, i ? g.collapsed ? (f.children.forEach(((_) => h2(_, ((v) => this.nodes.delete(v.element))))), f.children.splice(0, f.children.length), f.stale = !0) : l.push(f) : c && !g.collapsed && l.push(f), f;
      }
      const p = sx({ element: h, parent: e, id: u, hasChildren: c, defaultCollapseState: this.getDefaultCollapseState(h) });
      return s && s.viewState.focus && s.viewState.focus.indexOf(u) > -1 && s.focus.push(p), s && s.viewState.selection && s.viewState.selection.indexOf(u) > -1 && s.selection.push(p), (s && s.viewState.expanded && s.viewState.expanded.indexOf(u) > -1 || c && p.defaultCollapseState === co.PreserveOrExpanded) && l.push(p), p;
    }));
    for (const h of r.values()) h2(h, ((c) => this.nodes.delete(c.element)));
    for (const h of d) this.nodes.set(h.element, h);
    return e.children.splice(0, e.children.length, ...d), e !== this.root && this.autoExpandSingleChildren && d.length === 1 && l.length === 0 && (d[0].forceExpanded = !0, l.push(d[0])), l;
  }
  render(e, t, i) {
    const s = e.children.map(((r) => this.asTreeElement(r, t))), o = i && { ...i, diffIdentityProvider: i.diffIdentityProvider && { getId: (r) => i.diffIdentityProvider.getId(r.element) } };
    this.tree.setChildren(e === this.root ? null : e, s, o), e !== this.root && this.tree.setCollapsible(e, e.hasChildren), this._onDidRender.fire();
  }
  asTreeElement(e, t) {
    if (e.stale) return { element: e, collapsible: e.hasChildren, collapsed: !0 };
    let i;
    return t && t.viewState.expanded && e.id && t.viewState.expanded.indexOf(e.id) > -1 ? i = !1 : e.forceExpanded ? (i = !1, e.forceExpanded = !1) : i = e.defaultCollapseState, { element: e, children: e.hasChildren ? at.map(e.children, ((s) => this.asTreeElement(s, t))) : [], collapsible: e.hasChildren, collapsed: i };
  }
  processChildren(e) {
    return this.sorter && (e = [...e].sort(this.sorter.compare.bind(this.sorter))), e;
  }
  dispose() {
    this.disposables.dispose(), this.tree.dispose();
  }
}
class OA {
  get element() {
    return { elements: this.node.element.elements.map(((e) => e.element)), incompressible: this.node.element.incompressible };
  }
  get children() {
    return this.node.children.map(((e) => new OA(e)));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e) {
    this.node = e;
  }
}
class aie {
  constructor(e, t, i, s) {
    this.renderer = e, this.nodeMapper = t, this.compressibleNodeMapperProvider = i, this.onDidChangeTwistieState = s, this.renderedNodes = /* @__PURE__ */ new Map(), this.disposables = [], this.templateId = e.templateId;
  }
  renderTemplate(e) {
    return { templateData: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, i, s) {
    this.renderer.renderElement(this.nodeMapper.map(e), t, i.templateData, s);
  }
  renderCompressedElements(e, t, i, s) {
    this.renderer.renderCompressedElements(this.compressibleNodeMapperProvider().map(e), t, i.templateData, s);
  }
  renderTwistie(e, t) {
    return e.slow ? (t.classList.add(...Ee.asClassNameArray(ne.treeItemLoading)), !0) : (t.classList.remove(...Ee.asClassNameArray(ne.treeItemLoading)), !1);
  }
  disposeElement(e, t, i, s) {
    var o, r;
    (r = (o = this.renderer).disposeElement) === null || r === void 0 || r.call(o, this.nodeMapper.map(e), t, i.templateData, s);
  }
  disposeCompressedElements(e, t, i, s) {
    var o, r;
    (r = (o = this.renderer).disposeCompressedElements) === null || r === void 0 || r.call(o, this.compressibleNodeMapperProvider().map(e), t, i.templateData, s);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  dispose() {
    this.renderedNodes.clear(), this.disposables = Ht(this.disposables);
  }
}
class lie extends mV {
  constructor(e, t, i, s, o, r, a = {}) {
    super(e, t, i, o, r, a), this.compressionDelegate = s, this.compressibleNodeMapper = new EA(((l) => new OA(l))), this.filter = a.filter;
  }
  createTree(e, t, i, s, o) {
    const r = new MA(i), a = s.map(((d) => new aie(d, this.nodeMapper, (() => this.compressibleNodeMapper), this._onDidChangeNodeSlowState.event))), l = (function(d) {
      const h = d && pV(d);
      return h && { ...h, keyboardNavigationLabelProvider: h.keyboardNavigationLabelProvider && { ...h.keyboardNavigationLabelProvider, getCompressedNodeKeyboardNavigationLabel: (c) => d.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(c.map(((u) => u.element))) } };
    })(o) || {};
    return new gV(e, t, r, a, l);
  }
  asTreeElement(e, t) {
    return { incompressible: this.compressionDelegate.isIncompressible(e.element), ...super.asTreeElement(e, t) };
  }
  updateOptions(e = {}) {
    this.tree.updateOptions(e);
  }
  render(e, t, i) {
    if (!this.identityProvider) return super.render(e, t);
    const s = (g) => this.identityProvider.getId(g).toString(), o = (g) => {
      const p = /* @__PURE__ */ new Set();
      for (const f of g) {
        const _ = this.tree.getCompressedTreeNode(f === this.root ? null : f);
        if (_.element) for (const v of _.element.elements) p.add(s(v.element));
      }
      return p;
    }, r = o(this.tree.getSelection()), a = o(this.tree.getFocus());
    super.render(e, t, i);
    const l = this.getSelection();
    let d = !1;
    const h = this.getFocus();
    let c = !1;
    const u = (g) => {
      const p = g.element;
      if (p) for (let f = 0; f < p.elements.length; f++) {
        const _ = s(p.elements[f].element), v = p.elements[p.elements.length - 1].element;
        r.has(_) && l.indexOf(v) === -1 && (l.push(v), d = !0), a.has(_) && h.indexOf(v) === -1 && (h.push(v), c = !0);
      }
      g.children.forEach(u);
    };
    u(this.tree.getCompressedTreeNode(e === this.root ? null : e)), d && this.setSelection(l), c && this.setFocus(h);
  }
  processChildren(e) {
    return this.filter && (e = at.filter(e, ((t) => {
      const i = this.filter.filter(t, 1), s = typeof (o = i) == "boolean" ? o ? 1 : 0 : IA(o) ? Fv(o.visibility) : Fv(o);
      var o;
      if (s === 2) throw new Error("Recursive tree visibility not supported in async data compressed trees");
      return s === 1;
    }))), super.processChildren(e);
  }
}
class die extends hV {
  constructor(e, t, i, s, o, r = {}) {
    super(e, t, i, s, r), this.user = e, this.dataSource = o, this.identityProvider = r.identityProvider;
  }
  createModel(e, t, i) {
    return new TA(e, t, i);
  }
}
new ae("isMac", Je, m(0, "Whether the operating system is macOS")), new ae("isLinux", Cs, m(0, "Whether the operating system is Linux"));
const Hb = new ae("isWindows", Tn, m(0, "Whether the operating system is Windows")), J3 = new ae("isWeb", gc, m(0, "Whether the platform is a web browser"));
new ae("isMacNative", Je && !gc, m(0, "Whether the operating system is macOS on a non-browser platform")), new ae("isIOS", ca, m(0, "Whether the operating system is iOS")), new ae("isMobile", y7, m(0, "Whether the platform is a mobile web browser")), new ae("isDevelopment", !1, !0), new ae("productQualityType", "", m(0, "Quality type of VS Code"));
const fV = "inputFocus", hie = new ae(fV, !1, m(0, "Whether keyboard focus is inside an input box"));
var Ud = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, qt = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const Jo = tt("listService"), I_ = new ae("listScrollAtBoundary", "none");
q.or(I_.isEqualTo("top"), I_.isEqualTo("both")), q.or(I_.isEqualTo("bottom"), I_.isEqualTo("both"));
const _V = new ae("listFocus", !0), vV = new ae("treestickyScrollFocused", !1), TL = new ae("listSupportsMultiselect", !0), eF = q.and(_V, q.not(fV), vV.negate()), FA = new ae("listHasSelectionOrFocus", !1), BA = new ae("listDoubleSelection", !1), WA = new ae("listMultiSelection", !1), RL = new ae("listSelectionNavigation", !1), cie = new ae("listSupportsFind", !0), c2 = new ae("treeElementCanCollapse", !1), uie = new ae("treeElementHasParent", !1), u2 = new ae("treeElementCanExpand", !1), gie = new ae("treeElementHasChild", !1), pie = new ae("treeFindOpen", !1), bV = "listTypeNavigationMode", CV = "listAutomaticKeyboardNavigation";
function AL(n, e) {
  const t = n.createScoped(e.getHTMLElement());
  return _V.bindTo(t), t;
}
function PL(n, e) {
  const t = I_.bindTo(n), i = () => {
    const s = e.scrollTop === 0, o = e.scrollHeight - e.renderHeight - e.scrollTop < 1;
    s && o ? t.set("both") : s ? t.set("top") : o ? t.set("bottom") : t.set("none");
  };
  return i(), e.onDidScroll(i);
}
const Rg = "workbench.list.multiSelectModifier", XC = "workbench.list.openMode", er = "workbench.list.horizontalScrolling", VA = "workbench.list.defaultFindMode", HA = "workbench.list.typeNavigationMode", jy = "workbench.list.keyboardNavigation", ba = "workbench.list.scrollByPage", zA = "workbench.list.defaultFindMatchType", Wv = "workbench.tree.indent", qy = "workbench.tree.renderIndentGuides", Ca = "workbench.list.smoothScrolling", bl = "workbench.list.mouseWheelScrollSensitivity", Cl = "workbench.list.fastScrollSensitivity", $y = "workbench.tree.expandMode", Gy = "workbench.tree.enableStickyScroll", Zy = "workbench.tree.stickyScrollMaxItemCount";
function wl(n) {
  return n.getValue(Rg) === "alt";
}
class mie extends V {
  constructor(e) {
    super(), this.configurationService = e, this.useAltAsMultipleSelectionModifier = wl(e), this.registerListeners();
  }
  registerListeners() {
    this._register(this.configurationService.onDidChangeConfiguration(((e) => {
      e.affectsConfiguration(Rg) && (this.useAltAsMultipleSelectionModifier = wl(this.configurationService));
    })));
  }
  isSelectionSingleChangeEvent(e) {
    return this.useAltAsMultipleSelectionModifier ? e.browserEvent.altKey : qW(e);
  }
  isSelectionRangeChangeEvent(e) {
    return $W(e);
  }
}
function OL(n, e) {
  var t;
  const i = n.get(Ye), s = n.get(Dt), o = new G();
  return [{ ...e, keyboardNavigationDelegate: { mightProducePrintableCharacter: (r) => s.mightProducePrintableCharacter(r) }, smoothScrolling: !!i.getValue(Ca), mouseWheelScrollSensitivity: i.getValue(bl), fastScrollSensitivity: i.getValue(Cl), multipleSelectionController: (t = e.multipleSelectionController) !== null && t !== void 0 ? t : o.add(new mie(i)), keyboardNavigationEventFilter: vie(s), scrollByPage: !!i.getValue(ba) }, o];
}
let tF = class extends uo {
  constructor(n, e, t, i, s, o, r, a, l) {
    const d = s.horizontalScrolling !== void 0 ? s.horizontalScrolling : !!a.getValue(er), [h, c] = l.invokeFunction(OL, s);
    super(n, e, t, i, { keyboardSupport: !1, ...h, horizontalScrolling: d }), this.disposables.add(c), this.contextKeyService = AL(o, this), this.disposables.add(PL(this.contextKeyService, this)), this.listSupportsMultiSelect = TL.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(s.multipleSelectionSupport !== !1), RL.bindTo(this.contextKeyService).set(!!s.selectionNavigation), this.listHasSelectionOrFocus = FA.bindTo(this.contextKeyService), this.listDoubleSelection = BA.bindTo(this.contextKeyService), this.listMultiSelection = WA.bindTo(this.contextKeyService), this.horizontalScrolling = s.horizontalScrolling, this._useAltAsMultipleSelectionModifier = wl(a), this.disposables.add(this.contextKeyService), this.disposables.add(r.register(this)), this.updateStyles(s.overrideStyles), this.disposables.add(this.onDidChangeSelection((() => {
      const u = this.getSelection(), g = this.getFocus();
      this.contextKeyService.bufferChangeEvents((() => {
        this.listHasSelectionOrFocus.set(u.length > 0 || g.length > 0), this.listMultiSelection.set(u.length > 1), this.listDoubleSelection.set(u.length === 2);
      }));
    }))), this.disposables.add(this.onDidChangeFocus((() => {
      const u = this.getSelection(), g = this.getFocus();
      this.listHasSelectionOrFocus.set(u.length > 0 || g.length > 0);
    }))), this.disposables.add(a.onDidChangeConfiguration(((u) => {
      u.affectsConfiguration(Rg) && (this._useAltAsMultipleSelectionModifier = wl(a));
      let g = {};
      if (u.affectsConfiguration(er) && this.horizontalScrolling === void 0) {
        const p = !!a.getValue(er);
        g = { ...g, horizontalScrolling: p };
      }
      if (u.affectsConfiguration(ba)) {
        const p = !!a.getValue(ba);
        g = { ...g, scrollByPage: p };
      }
      if (u.affectsConfiguration(Ca)) {
        const p = !!a.getValue(Ca);
        g = { ...g, smoothScrolling: p };
      }
      if (u.affectsConfiguration(bl)) {
        const p = a.getValue(bl);
        g = { ...g, mouseWheelScrollSensitivity: p };
      }
      if (u.affectsConfiguration(Cl)) {
        const p = a.getValue(Cl);
        g = { ...g, fastScrollSensitivity: p };
      }
      Object.keys(g).length > 0 && this.updateOptions(g);
    }))), this.navigator = new wV(this, { configurationService: a, ...s }), this.disposables.add(this.navigator);
  }
  updateOptions(n) {
    super.updateOptions(n), n.overrideStyles !== void 0 && this.updateStyles(n.overrideStyles), n.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!n.multipleSelectionSupport);
  }
  updateStyles(n) {
    this.style(n ? Mg(n) : Ig);
  }
};
tF = Ud([qt(5, Te), qt(6, Jo), qt(7, Ye), qt(8, Se)], tF);
let iF = class extends Lte {
  constructor(n, e, t, i, s, o, r, a, l) {
    const d = s.horizontalScrolling !== void 0 ? s.horizontalScrolling : !!a.getValue(er), [h, c] = l.invokeFunction(OL, s);
    super(n, e, t, i, { keyboardSupport: !1, ...h, horizontalScrolling: d }), this.disposables = new G(), this.disposables.add(c), this.contextKeyService = AL(o, this), this.disposables.add(PL(this.contextKeyService, this.widget)), this.horizontalScrolling = s.horizontalScrolling, this.listSupportsMultiSelect = TL.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(s.multipleSelectionSupport !== !1), RL.bindTo(this.contextKeyService).set(!!s.selectionNavigation), this._useAltAsMultipleSelectionModifier = wl(a), this.disposables.add(this.contextKeyService), this.disposables.add(r.register(this)), this.updateStyles(s.overrideStyles), this.disposables.add(a.onDidChangeConfiguration(((u) => {
      u.affectsConfiguration(Rg) && (this._useAltAsMultipleSelectionModifier = wl(a));
      let g = {};
      if (u.affectsConfiguration(er) && this.horizontalScrolling === void 0) {
        const p = !!a.getValue(er);
        g = { ...g, horizontalScrolling: p };
      }
      if (u.affectsConfiguration(ba)) {
        const p = !!a.getValue(ba);
        g = { ...g, scrollByPage: p };
      }
      if (u.affectsConfiguration(Ca)) {
        const p = !!a.getValue(Ca);
        g = { ...g, smoothScrolling: p };
      }
      if (u.affectsConfiguration(bl)) {
        const p = a.getValue(bl);
        g = { ...g, mouseWheelScrollSensitivity: p };
      }
      if (u.affectsConfiguration(Cl)) {
        const p = a.getValue(Cl);
        g = { ...g, fastScrollSensitivity: p };
      }
      Object.keys(g).length > 0 && this.updateOptions(g);
    }))), this.navigator = new wV(this, { configurationService: a, ...s }), this.disposables.add(this.navigator);
  }
  updateOptions(n) {
    super.updateOptions(n), n.overrideStyles !== void 0 && this.updateStyles(n.overrideStyles), n.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!n.multipleSelectionSupport);
  }
  updateStyles(n) {
    this.style(n ? Mg(n) : Ig);
  }
  dispose() {
    this.disposables.dispose(), super.dispose();
  }
};
iF = Ud([qt(5, Te), qt(6, Jo), qt(7, Ye), qt(8, Se)], iF);
let nF = class extends ML {
  constructor(n, e, t, i, s, o, r, a, l, d) {
    const h = o.horizontalScrolling !== void 0 ? o.horizontalScrolling : !!l.getValue(er), [c, u] = d.invokeFunction(OL, o);
    super(n, e, t, i, s, { keyboardSupport: !1, ...c, horizontalScrolling: h }), this.disposables.add(u), this.contextKeyService = AL(r, this), this.disposables.add(PL(this.contextKeyService, this)), this.listSupportsMultiSelect = TL.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(o.multipleSelectionSupport !== !1), RL.bindTo(this.contextKeyService).set(!!o.selectionNavigation), this.listHasSelectionOrFocus = FA.bindTo(this.contextKeyService), this.listDoubleSelection = BA.bindTo(this.contextKeyService), this.listMultiSelection = WA.bindTo(this.contextKeyService), this.horizontalScrolling = o.horizontalScrolling, this._useAltAsMultipleSelectionModifier = wl(l), this.disposables.add(this.contextKeyService), this.disposables.add(a.register(this)), this.updateStyles(o.overrideStyles), this.disposables.add(this.onDidChangeSelection((() => {
      const g = this.getSelection(), p = this.getFocus();
      this.contextKeyService.bufferChangeEvents((() => {
        this.listHasSelectionOrFocus.set(g.length > 0 || p.length > 0), this.listMultiSelection.set(g.length > 1), this.listDoubleSelection.set(g.length === 2);
      }));
    }))), this.disposables.add(this.onDidChangeFocus((() => {
      const g = this.getSelection(), p = this.getFocus();
      this.listHasSelectionOrFocus.set(g.length > 0 || p.length > 0);
    }))), this.disposables.add(l.onDidChangeConfiguration(((g) => {
      g.affectsConfiguration(Rg) && (this._useAltAsMultipleSelectionModifier = wl(l));
      let p = {};
      if (g.affectsConfiguration(er) && this.horizontalScrolling === void 0) {
        const f = !!l.getValue(er);
        p = { ...p, horizontalScrolling: f };
      }
      if (g.affectsConfiguration(ba)) {
        const f = !!l.getValue(ba);
        p = { ...p, scrollByPage: f };
      }
      if (g.affectsConfiguration(Ca)) {
        const f = !!l.getValue(Ca);
        p = { ...p, smoothScrolling: f };
      }
      if (g.affectsConfiguration(bl)) {
        const f = l.getValue(bl);
        p = { ...p, mouseWheelScrollSensitivity: f };
      }
      if (g.affectsConfiguration(Cl)) {
        const f = l.getValue(Cl);
        p = { ...p, fastScrollSensitivity: f };
      }
      Object.keys(p).length > 0 && this.updateOptions(p);
    }))), this.navigator = new fie(this, { configurationService: l, ...o }), this.disposables.add(this.navigator);
  }
  updateOptions(n) {
    super.updateOptions(n), n.overrideStyles !== void 0 && this.updateStyles(n.overrideStyles), n.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!n.multipleSelectionSupport);
  }
  updateStyles(n) {
    this.style(n ? Mg(n) : Ig);
  }
  dispose() {
    this.disposables.dispose(), super.dispose();
  }
};
nF = Ud([qt(6, Te), qt(7, Jo), qt(8, Ye), qt(9, Se)], nF);
class UA extends V {
  constructor(e, t) {
    var i;
    super(), this.widget = e, this._onDidOpen = this._register(new F()), this.onDidOpen = this._onDidOpen.event, this._register(se.filter(this.widget.onDidChangeSelection, ((s) => fh(s.browserEvent)))(((s) => this.onSelectionFromKeyboard(s)))), this._register(this.widget.onPointer(((s) => this.onPointer(s.element, s.browserEvent)))), this._register(this.widget.onMouseDblClick(((s) => this.onMouseDblClick(s.element, s.browserEvent)))), typeof t?.openOnSingleClick != "boolean" && t?.configurationService ? (this.openOnSingleClick = t?.configurationService.getValue(XC) !== "doubleClick", this._register(t?.configurationService.onDidChangeConfiguration(((s) => {
      s.affectsConfiguration(XC) && (this.openOnSingleClick = t?.configurationService.getValue(XC) !== "doubleClick");
    })))) : this.openOnSingleClick = (i = t?.openOnSingleClick) === null || i === void 0 || i;
  }
  onSelectionFromKeyboard(e) {
    if (e.elements.length !== 1) return;
    const t = e.browserEvent, i = typeof t.preserveFocus != "boolean" || t.preserveFocus, s = typeof t.pinned == "boolean" ? t.pinned : !i;
    this._open(this.getSelectedElement(), i, s, !1, e.browserEvent);
  }
  onPointer(e, t) {
    if (!this.openOnSingleClick || t.detail === 2) return;
    const i = t.button === 1, s = t.ctrlKey || t.metaKey || t.altKey;
    this._open(e, !0, i, s, t);
  }
  onMouseDblClick(e, t) {
    if (!t) return;
    const i = t.target;
    if (i.classList.contains("monaco-tl-twistie") || i.classList.contains("monaco-icon-label") && i.classList.contains("folder-icon") && t.offsetX < 16) return;
    const s = t.ctrlKey || t.metaKey || t.altKey;
    this._open(e, !1, !0, s, t);
  }
  _open(e, t, i, s, o) {
    e && this._onDidOpen.fire({ editorOptions: { preserveFocus: t, pinned: i, revealIfVisible: !0 }, sideBySide: s, element: e, browserEvent: o });
  }
}
class wV extends UA {
  constructor(e, t) {
    super(e, t), this.widget = e;
  }
  getSelectedElement() {
    return this.widget.getSelectedElements()[0];
  }
}
class fie extends UA {
  constructor(e, t) {
    super(e, t);
  }
  getSelectedElement() {
    return this.widget.getSelectedElements()[0];
  }
}
class _ie extends UA {
  constructor(e, t) {
    super(e, t);
  }
  getSelectedElement() {
    var e;
    return (e = this.widget.getSelection()[0]) !== null && e !== void 0 ? e : void 0;
  }
}
function vie(n) {
  let e = !1;
  return (t) => {
    if (t.toKeyCodeChord().isModifierKey()) return !1;
    if (e) return e = !1, !1;
    const i = n.softDispatch(t, t.target);
    return i.kind === 1 ? (e = !0, !1) : (e = !1, i.kind === 0);
  };
}
let g2 = class extends AA {
  constructor(n, e, t, i, s, o, r, a, l) {
    const { options: d, getTypeNavigationMode: h, disposable: c } = o.invokeFunction(O1, s);
    super(n, e, t, i, d), this.disposables.add(c), this.internals = new mg(this, s, h, s.overrideStyles, r, a, l), this.disposables.add(this.internals);
  }
  updateOptions(n) {
    super.updateOptions(n), this.internals.updateOptions(n);
  }
};
g2 = Ud([qt(5, Se), qt(6, Te), qt(7, Jo), qt(8, Ye)], g2);
let sF = class extends gV {
  constructor(n, e, t, i, s, o, r, a, l) {
    const { options: d, getTypeNavigationMode: h, disposable: c } = o.invokeFunction(O1, s);
    super(n, e, t, i, d), this.disposables.add(c), this.internals = new mg(this, s, h, s.overrideStyles, r, a, l), this.disposables.add(this.internals);
  }
  updateOptions(n = {}) {
    super.updateOptions(n), n.overrideStyles && this.internals.updateStyleOverrides(n.overrideStyles), this.internals.updateOptions(n);
  }
};
sF = Ud([qt(5, Se), qt(6, Te), qt(7, Jo), qt(8, Ye)], sF);
let oF = class extends die {
  constructor(n, e, t, i, s, o, r, a, l, d) {
    const { options: h, getTypeNavigationMode: c, disposable: u } = r.invokeFunction(O1, o);
    super(n, e, t, i, s, h), this.disposables.add(u), this.internals = new mg(this, o, c, o.overrideStyles, a, l, d), this.disposables.add(this.internals);
  }
  updateOptions(n = {}) {
    super.updateOptions(n), n.overrideStyles !== void 0 && this.internals.updateStyleOverrides(n.overrideStyles), this.internals.updateOptions(n);
  }
};
oF = Ud([qt(6, Se), qt(7, Te), qt(8, Jo), qt(9, Ye)], oF);
let p2 = class extends mV {
  get onDidOpen() {
    return this.internals.onDidOpen;
  }
  constructor(n, e, t, i, s, o, r, a, l, d) {
    const { options: h, getTypeNavigationMode: c, disposable: u } = r.invokeFunction(O1, o);
    super(n, e, t, i, s, h), this.disposables.add(u), this.internals = new mg(this, o, c, o.overrideStyles, a, l, d), this.disposables.add(this.internals);
  }
  updateOptions(n = {}) {
    super.updateOptions(n), n.overrideStyles && this.internals.updateStyleOverrides(n.overrideStyles), this.internals.updateOptions(n);
  }
};
p2 = Ud([qt(6, Se), qt(7, Te), qt(8, Jo), qt(9, Ye)], p2);
let rF = class extends lie {
  constructor(n, e, t, i, s, o, r, a, l, d, h) {
    const { options: c, getTypeNavigationMode: u, disposable: g } = a.invokeFunction(O1, r);
    super(n, e, t, i, s, o, c), this.disposables.add(g), this.internals = new mg(this, r, u, r.overrideStyles, l, d, h), this.disposables.add(this.internals);
  }
  updateOptions(n) {
    super.updateOptions(n), this.internals.updateOptions(n);
  }
};
function yV(n) {
  const e = n.getValue(VA);
  if (e === "highlight") return Cd.Highlight;
  if (e === "filter") return Cd.Filter;
  const t = n.getValue(jy);
  return t === "simple" || t === "highlight" ? Cd.Highlight : t === "filter" ? Cd.Filter : void 0;
}
function SV(n) {
  const e = n.getValue(zA);
  return e === "fuzzy" ? pg.Fuzzy : e === "contiguous" ? pg.Contiguous : void 0;
}
function O1(n, e) {
  var t;
  const i = n.get(Ye), s = n.get(zd), o = n.get(Te), r = n.get(Se), a = e.horizontalScrolling !== void 0 ? e.horizontalScrolling : !!i.getValue(er), [l, d] = r.invokeFunction(OL, e), h = e.paddingBottom, c = e.renderIndentGuides !== void 0 ? e.renderIndentGuides : i.getValue(qy);
  return { getTypeNavigationMode: () => {
    const u = o.getContextKeyValue(bV);
    if (u === "automatic") return Xa.Automatic;
    if (u === "trigger" || o.getContextKeyValue(CV) === !1) return Xa.Trigger;
    const g = i.getValue(HA);
    return g === "automatic" ? Xa.Automatic : g === "trigger" ? Xa.Trigger : void 0;
  }, disposable: d, options: { keyboardSupport: !1, ...l, indent: typeof i.getValue(Wv) == "number" ? i.getValue(Wv) : void 0, renderIndentGuides: c, smoothScrolling: !!i.getValue(Ca), defaultFindMode: yV(i), defaultFindMatchType: SV(i), horizontalScrolling: a, scrollByPage: !!i.getValue(ba), paddingBottom: h, hideTwistiesOfChildlessElements: e.hideTwistiesOfChildlessElements, expandOnlyOnTwistieClick: (t = e.expandOnlyOnTwistieClick) !== null && t !== void 0 ? t : i.getValue($y) === "doubleClick", contextViewProvider: s, findWidgetStyles: ote, enableStickyScroll: !!i.getValue(Gy), stickyScrollMaxItemCount: Number(i.getValue(Zy)) } };
}
rF = Ud([qt(7, Se), qt(8, Te), qt(9, Jo), qt(10, Ye)], rF);
let mg = class {
  get onDidOpen() {
    return this.navigator.onDidOpen;
  }
  constructor(n, e, t, i, s, o, r) {
    var a;
    this.tree = n, this.disposables = [], this.contextKeyService = AL(s, n), this.disposables.push(PL(this.contextKeyService, n)), this.listSupportsMultiSelect = TL.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(e.multipleSelectionSupport !== !1), RL.bindTo(this.contextKeyService).set(!!e.selectionNavigation), this.listSupportFindWidget = cie.bindTo(this.contextKeyService), this.listSupportFindWidget.set((a = e.findWidgetEnabled) === null || a === void 0 || a), this.hasSelectionOrFocus = FA.bindTo(this.contextKeyService), this.hasDoubleSelection = BA.bindTo(this.contextKeyService), this.hasMultiSelection = WA.bindTo(this.contextKeyService), this.treeElementCanCollapse = c2.bindTo(this.contextKeyService), this.treeElementHasParent = uie.bindTo(this.contextKeyService), this.treeElementCanExpand = u2.bindTo(this.contextKeyService), this.treeElementHasChild = gie.bindTo(this.contextKeyService), this.treeFindOpen = pie.bindTo(this.contextKeyService), this.treeStickyScrollFocused = vV.bindTo(this.contextKeyService), this._useAltAsMultipleSelectionModifier = wl(r), this.updateStyleOverrides(i);
    const l = () => {
      const h = n.getFocus()[0];
      if (!h) return;
      const c = n.getNode(h);
      this.treeElementCanCollapse.set(c.collapsible && !c.collapsed), this.treeElementHasParent.set(!!n.getParentElement(h)), this.treeElementCanExpand.set(c.collapsible && c.collapsed), this.treeElementHasChild.set(!!n.getFirstElementChild(h));
    }, d = /* @__PURE__ */ new Set();
    d.add(bV), d.add(CV), this.disposables.push(this.contextKeyService, o.register(n), n.onDidChangeSelection((() => {
      const h = n.getSelection(), c = n.getFocus();
      this.contextKeyService.bufferChangeEvents((() => {
        this.hasSelectionOrFocus.set(h.length > 0 || c.length > 0), this.hasMultiSelection.set(h.length > 1), this.hasDoubleSelection.set(h.length === 2);
      }));
    })), n.onDidChangeFocus((() => {
      const h = n.getSelection(), c = n.getFocus();
      this.hasSelectionOrFocus.set(h.length > 0 || c.length > 0), l();
    })), n.onDidChangeCollapseState(l), n.onDidChangeModel(l), n.onDidChangeFindOpenState(((h) => this.treeFindOpen.set(h))), n.onDidChangeStickyScrollFocused(((h) => this.treeStickyScrollFocused.set(h))), r.onDidChangeConfiguration(((h) => {
      let c = {};
      if (h.affectsConfiguration(Rg) && (this._useAltAsMultipleSelectionModifier = wl(r)), h.affectsConfiguration(Wv)) {
        const u = r.getValue(Wv);
        c = { ...c, indent: u };
      }
      if (h.affectsConfiguration(qy) && e.renderIndentGuides === void 0) {
        const u = r.getValue(qy);
        c = { ...c, renderIndentGuides: u };
      }
      if (h.affectsConfiguration(Ca)) {
        const u = !!r.getValue(Ca);
        c = { ...c, smoothScrolling: u };
      }
      if (h.affectsConfiguration(VA) || h.affectsConfiguration(jy)) {
        const u = yV(r);
        c = { ...c, defaultFindMode: u };
      }
      if (h.affectsConfiguration(HA) || h.affectsConfiguration(jy)) {
        const u = t();
        c = { ...c, typeNavigationMode: u };
      }
      if (h.affectsConfiguration(zA)) {
        const u = SV(r);
        c = { ...c, defaultFindMatchType: u };
      }
      if (h.affectsConfiguration(er) && e.horizontalScrolling === void 0) {
        const u = !!r.getValue(er);
        c = { ...c, horizontalScrolling: u };
      }
      if (h.affectsConfiguration(ba)) {
        const u = !!r.getValue(ba);
        c = { ...c, scrollByPage: u };
      }
      if (h.affectsConfiguration($y) && e.expandOnlyOnTwistieClick === void 0 && (c = { ...c, expandOnlyOnTwistieClick: r.getValue($y) === "doubleClick" }), h.affectsConfiguration(Gy)) {
        const u = r.getValue(Gy);
        c = { ...c, enableStickyScroll: u };
      }
      if (h.affectsConfiguration(Zy)) {
        const u = Math.max(1, r.getValue(Zy));
        c = { ...c, stickyScrollMaxItemCount: u };
      }
      if (h.affectsConfiguration(bl)) {
        const u = r.getValue(bl);
        c = { ...c, mouseWheelScrollSensitivity: u };
      }
      if (h.affectsConfiguration(Cl)) {
        const u = r.getValue(Cl);
        c = { ...c, fastScrollSensitivity: u };
      }
      Object.keys(c).length > 0 && n.updateOptions(c);
    })), this.contextKeyService.onDidChangeContext(((h) => {
      h.affectsSome(d) && n.updateOptions({ typeNavigationMode: t() });
    }))), this.navigator = new _ie(n, { configurationService: r, ...e }), this.disposables.push(this.navigator);
  }
  updateOptions(n) {
    n.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!n.multipleSelectionSupport);
  }
  updateStyleOverrides(n) {
    this.tree.style(n ? Mg(n) : Ig);
  }
  dispose() {
    this.disposables = Ht(this.disposables);
  }
};
mg = Ud([qt(4, Te), qt(5, Jo), qt(6, Ye)], mg);
li.as(ma).registerConfiguration({ id: "workbench", order: 7, title: m(0, "Workbench"), type: "object", properties: { [Rg]: { type: "string", enum: ["ctrlCmd", "alt"], markdownEnumDescriptions: [m(0, "Maps to `Control` on Windows and Linux and to `Command` on macOS."), m(0, "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")], default: "ctrlCmd", description: m(0, "The modifier to be used to add an item in trees and lists to a multi-selection with the mouse (for example in the explorer, open editors and scm view). The 'Open to Side' mouse gestures - if supported - will adapt such that they do not conflict with the multiselect modifier.") }, [XC]: { type: "string", enum: ["singleClick", "doubleClick"], default: "singleClick", description: m(0, "Controls how to open items in trees and lists using the mouse (if supported). Note that some trees and lists might choose to ignore this setting if it is not applicable.") }, [er]: { type: "boolean", default: !1, description: m(0, "Controls whether lists and trees support horizontal scrolling in the workbench. Warning: turning on this setting has a performance implication.") }, [ba]: { type: "boolean", default: !1, description: m(0, "Controls whether clicks in the scrollbar scroll page by page.") }, [Wv]: { type: "number", default: 8, minimum: 4, maximum: 40, description: m(0, "Controls tree indentation in pixels.") }, [qy]: { type: "string", enum: ["none", "onHover", "always"], default: "onHover", description: m(0, "Controls whether the tree should render indent guides.") }, [Ca]: { type: "boolean", default: !1, description: m(0, "Controls whether lists and trees have smooth scrolling.") }, [bl]: { type: "number", default: 1, markdownDescription: m(0, "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.") }, [Cl]: { type: "number", default: 5, markdownDescription: m(0, "Scrolling speed multiplier when pressing `Alt`.") }, [VA]: { type: "string", enum: ["highlight", "filter"], enumDescriptions: [m(0, "Highlight elements when searching. Further up and down navigation will traverse only the highlighted elements."), m(0, "Filter elements when searching.")], default: "highlight", description: m(0, "Controls the default find mode for lists and trees in the workbench.") }, [jy]: { type: "string", enum: ["simple", "highlight", "filter"], enumDescriptions: [m(0, "Simple keyboard navigation focuses elements which match the keyboard input. Matching is done only on prefixes."), m(0, "Highlight keyboard navigation highlights elements which match the keyboard input. Further up and down navigation will traverse only the highlighted elements."), m(0, "Filter keyboard navigation will filter out and hide all the elements which do not match the keyboard input.")], default: "highlight", description: m(0, "Controls the keyboard navigation style for lists and trees in the workbench. Can be simple, highlight and filter."), deprecated: !0, deprecationMessage: m(0, "Please use 'workbench.list.defaultFindMode' and	'workbench.list.typeNavigationMode' instead.") }, [zA]: { type: "string", enum: ["fuzzy", "contiguous"], enumDescriptions: [m(0, "Use fuzzy matching when searching."), m(0, "Use contiguous matching when searching.")], default: "fuzzy", description: m(0, "Controls the type of matching used when searching lists and trees in the workbench.") }, [$y]: { type: "string", enum: ["singleClick", "doubleClick"], default: "singleClick", description: m(0, "Controls how tree folders are expanded when clicking the folder names. Note that some trees and lists might choose to ignore this setting if it is not applicable.") }, [Gy]: { type: "boolean", default: !0, description: m(0, "Controls whether sticky scrolling is enabled in trees.") }, [Zy]: { type: "number", minimum: 1, default: 7, markdownDescription: m(0, "Controls the number of sticky elements displayed in the tree when `#workbench.tree.enableStickyScroll#` is enabled.") }, [HA]: { type: "string", enum: ["automatic", "trigger"], default: "automatic", markdownDescription: m(0, "Controls how type navigation works in lists and trees in the workbench. When set to `trigger`, type navigation begins once the `list.triggerTypeNavigation` command is run.") } } });
class sc extends V {
  constructor(e, t) {
    var i;
    super(), this.options = t, this.text = "", this.title = "", this.highlights = [], this.didEverRender = !1, this.supportIcons = (i = t?.supportIcons) !== null && i !== void 0 && i, this.domNode = Z(e, Q("span.monaco-highlighted-label"));
  }
  get element() {
    return this.domNode;
  }
  set(e, t = [], i = "", s) {
    e || (e = ""), s && (e = sc.escapeNewLines(e, t)), this.didEverRender && this.text === e && this.title === i && So(this.highlights, t) || (this.text = e, this.title = i, this.highlights = t, this.render());
  }
  render() {
    var e, t, i, s;
    const o = [];
    let r = 0;
    for (const a of this.highlights) {
      if (a.end === a.start) continue;
      if (r < a.start) {
        const h = this.text.substring(r, a.start);
        this.supportIcons ? o.push(...tc(h)) : o.push(h), r = a.start;
      }
      const l = this.text.substring(r, a.end), d = Q("span.highlight", void 0, ...this.supportIcons ? tc(l) : [l]);
      a.extraClasses && d.classList.add(...a.extraClasses), o.push(d), r = a.end;
    }
    if (r < this.text.length) {
      const a = this.text.substring(r);
      this.supportIcons ? o.push(...tc(a)) : o.push(a);
    }
    if (wn(this.domNode, ...o), (t = (e = this.options) === null || e === void 0 ? void 0 : e.hoverDelegate) === null || t === void 0 ? void 0 : t.showNativeHover) this.domNode.title = this.title;
    else if (this.customHover || this.title === "") this.customHover && this.customHover.update(this.title);
    else {
      const a = (s = (i = this.options) === null || i === void 0 ? void 0 : i.hoverDelegate) !== null && s !== void 0 ? s : Bs("mouse");
      this.customHover = this._register(xr(a, this.domNode, this.title));
    }
    this.didEverRender = !0;
  }
  static escapeNewLines(e, t) {
    let i = 0, s = 0;
    return e.replace(/\r\n|\r|\n/g, ((o, r) => {
      s = o === `\r
` ? -1 : 0, r += i;
      for (const a of t) a.end <= r || (a.start >= r && (a.start += s), a.end >= r && (a.end += s));
      return i += s, "⏎";
    }));
  }
}
class jf {
  constructor(e) {
    this._element = e;
  }
  get element() {
    return this._element;
  }
  set textContent(e) {
    this.disposed || e === this._textContent || (this._textContent = e, this._element.textContent = e);
  }
  set className(e) {
    this.disposed || e === this._className || (this._className = e, this._element.className = e);
  }
  set empty(e) {
    this.disposed || e === this._empty || (this._empty = e, this._element.style.marginLeft = e ? "0" : "");
  }
  dispose() {
    this.disposed = !0;
  }
}
class Yy extends V {
  constructor(e, t) {
    var i;
    super(), this.customHovers = /* @__PURE__ */ new Map(), this.creationOptions = t, this.domNode = this._register(new jf(Z(e, Q(".monaco-icon-label")))), this.labelContainer = Z(this.domNode.element, Q(".monaco-icon-label-container")), this.nameContainer = Z(this.labelContainer, Q("span.monaco-icon-name-container")), t?.supportHighlights || t?.supportIcons ? this.nameNode = this._register(new Cie(this.nameContainer, !!t.supportIcons)) : this.nameNode = new bie(this.nameContainer), this.hoverDelegate = (i = t?.hoverDelegate) !== null && i !== void 0 ? i : Bs("mouse");
  }
  get element() {
    return this.domNode.element;
  }
  setLabel(e, t, i) {
    var s;
    const o = ["monaco-icon-label"], r = ["monaco-icon-label-container"];
    let a = "";
    if (i && (i.extraClasses && o.push(...i.extraClasses), i.italic && o.push("italic"), i.strikethrough && o.push("strikethrough"), i.disabledCommand && r.push("disabled"), i.title && (typeof i.title == "string" ? a += i.title : a += e)), this.domNode.className = o.join(" "), this.domNode.element.setAttribute("aria-label", a), this.labelContainer.className = r.join(" "), this.setupHover(i?.descriptionTitle ? this.labelContainer : this.element, i?.title), this.nameNode.setLabel(e, i), t || this.descriptionNode) {
      const l = this.getOrCreateDescriptionNode();
      l instanceof sc ? (l.set(t || "", i ? i.descriptionMatches : void 0, void 0, i?.labelEscapeNewLines), this.setupHover(l.element, i?.descriptionTitle)) : (l.textContent = t && i?.labelEscapeNewLines ? sc.escapeNewLines(t, []) : t || "", this.setupHover(l.element, i?.descriptionTitle || ""), l.empty = !t);
    }
    (i?.suffix || this.suffixNode) && (this.getOrCreateSuffixNode().textContent = (s = i?.suffix) !== null && s !== void 0 ? s : "");
  }
  setupHover(e, t) {
    const i = this.customHovers.get(e);
    if (i && (i.dispose(), this.customHovers.delete(e)), t) if (this.hoverDelegate.showNativeHover) (function(s, o) {
      ps(o) ? s.title = wA(o) : o?.markdownNotSupportedFallback ? s.title = o.markdownNotSupportedFallback : s.removeAttribute("title");
    })(e, t);
    else {
      const s = xr(this.hoverDelegate, e, t);
      s && this.customHovers.set(e, s);
    }
    else e.removeAttribute("title");
  }
  dispose() {
    super.dispose();
    for (const e of this.customHovers.values()) e.dispose();
    this.customHovers.clear();
  }
  getOrCreateSuffixNode() {
    if (!this.suffixNode) {
      const i = this._register(new jf((e = this.nameContainer, t = Q("span.monaco-icon-suffix-container"), e.after(t), t)));
      this.suffixNode = this._register(new jf(Z(i.element, Q("span.label-suffix"))));
    }
    var e, t;
    return this.suffixNode;
  }
  getOrCreateDescriptionNode() {
    var e;
    if (!this.descriptionNode) {
      const t = this._register(new jf(Z(this.labelContainer, Q("span.monaco-icon-description-container"))));
      !((e = this.creationOptions) === null || e === void 0) && e.supportDescriptionHighlights ? this.descriptionNode = this._register(new sc(Z(t.element, Q("span.label-description")), { supportIcons: !!this.creationOptions.supportIcons })) : this.descriptionNode = this._register(new jf(Z(t.element, Q("span.label-description"))));
    }
    return this.descriptionNode;
  }
}
class bie {
  constructor(e) {
    this.container = e, this.label = void 0, this.singleLabel = void 0;
  }
  setLabel(e, t) {
    if (this.label !== e || !So(this.options, t)) if (this.label = e, this.options = t, typeof e == "string") this.singleLabel || (this.container.innerText = "", this.container.classList.remove("multiple"), this.singleLabel = Z(this.container, Q("a.label-name", { id: t?.domId }))), this.singleLabel.textContent = e;
    else {
      this.container.innerText = "", this.container.classList.add("multiple"), this.singleLabel = void 0;
      for (let i = 0; i < e.length; i++) {
        const s = e[i], o = t?.domId && `${t?.domId}_${i}`;
        Z(this.container, Q("a.label-name", { id: o, "data-icon-label-count": e.length, "data-icon-label-index": i, role: "treeitem" }, s)), i < e.length - 1 && Z(this.container, Q("span.label-separator", void 0, t?.separator || "/"));
      }
    }
  }
}
class Cie extends V {
  constructor(e, t) {
    super(), this.container = e, this.supportIcons = t, this.label = void 0, this.singleLabel = void 0;
  }
  setLabel(e, t) {
    if (this.label !== e || !So(this.options, t)) if (this.label = e, this.options = t, typeof e == "string") this.singleLabel || (this.container.innerText = "", this.container.classList.remove("multiple"), this.singleLabel = this._register(new sc(Z(this.container, Q("a.label-name", { id: t?.domId })), { supportIcons: this.supportIcons }))), this.singleLabel.set(e, t?.matches, void 0, t?.labelEscapeNewLines);
    else {
      this.container.innerText = "", this.container.classList.add("multiple"), this.singleLabel = void 0;
      const i = t?.separator || "/", s = (function(o, r, a) {
        if (!a) return;
        let l = 0;
        return o.map(((d) => {
          const h = { start: l, end: l + d.length }, c = a.map(((u) => Fn.intersect(h, u))).filter(((u) => !Fn.isEmpty(u))).map((({ start: u, end: g }) => ({ start: u - l, end: g - l })));
          return l = h.end + r.length, c;
        }));
      })(e, i, t?.matches);
      for (let o = 0; o < e.length; o++) {
        const r = e[o], a = s ? s[o] : void 0, l = Q("a.label-name", { id: t?.domId && `${t?.domId}_${o}`, "data-icon-label-count": e.length, "data-icon-label-index": o, role: "treeitem" });
        this._register(new sc(Z(this.container, l), { supportIcons: this.supportIcons })).set(r, a, void 0, t?.labelEscapeNewLines), o < e.length - 1 && Z(l, Q("span.label-separator", void 0, i));
      }
    }
  }
}
const zb = Q, LV = { keybindingLabelBackground: void 0, keybindingLabelForeground: void 0, keybindingLabelBorder: void 0, keybindingLabelBottomBorder: void 0, keybindingLabelShadow: void 0 };
class Cf extends V {
  constructor(e, t, i) {
    super(), this.os = t, this.keyElements = /* @__PURE__ */ new Set(), this.options = i || /* @__PURE__ */ Object.create(null);
    const s = this.options.keybindingLabelForeground;
    this.domNode = Z(e, zb(".monaco-keybinding")), s && (this.domNode.style.color = s), this.hover = this._register(xr(Bs("mouse"), this.domNode, "")), this.didEverRender = !1, e.appendChild(this.domNode);
  }
  get element() {
    return this.domNode;
  }
  set(e, t) {
    this.didEverRender && this.keybinding === e && Cf.areSame(this.matches, t) || (this.keybinding = e, this.matches = t, this.render());
  }
  render() {
    var e;
    if (this.clear(), this.keybinding) {
      const t = this.keybinding.getChords();
      t[0] && this.renderChord(this.domNode, t[0], this.matches ? this.matches.firstPart : null);
      for (let s = 1; s < t.length; s++) Z(this.domNode, zb("span.monaco-keybinding-key-chord-separator", void 0, " ")), this.renderChord(this.domNode, t[s], this.matches ? this.matches.chordPart : null);
      const i = (e = this.options.disableTitle) !== null && e !== void 0 && e ? void 0 : this.keybinding.getAriaLabel() || void 0;
      this.hover.update(i), this.domNode.setAttribute("aria-label", i || "");
    } else this.options && this.options.renderUnboundKeybindings && this.renderUnbound(this.domNode);
    this.didEverRender = !0;
  }
  clear() {
    Un(this.domNode), this.keyElements.clear();
  }
  renderChord(e, t, i) {
    const s = DA.modifierLabels[this.os];
    t.ctrlKey && this.renderKey(e, s.ctrlKey, !!i?.ctrlKey, s.separator), t.shiftKey && this.renderKey(e, s.shiftKey, !!i?.shiftKey, s.separator), t.altKey && this.renderKey(e, s.altKey, !!i?.altKey, s.separator), t.metaKey && this.renderKey(e, s.metaKey, !!i?.metaKey, s.separator);
    const o = t.keyLabel;
    o && this.renderKey(e, o, !!i?.keyCode, "");
  }
  renderKey(e, t, i, s) {
    Z(e, this.createKeyElement(t, i ? ".highlight" : "")), s && Z(e, zb("span.monaco-keybinding-key-separator", void 0, s));
  }
  renderUnbound(e) {
    Z(e, this.createKeyElement(m(0, "Unbound")));
  }
  createKeyElement(e, t = "") {
    const i = zb("span.monaco-keybinding-key" + t, void 0, e);
    return this.keyElements.add(i), this.options.keybindingLabelBackground && (i.style.backgroundColor = this.options.keybindingLabelBackground), this.options.keybindingLabelBorder && (i.style.borderColor = this.options.keybindingLabelBorder), this.options.keybindingLabelBottomBorder && (i.style.borderBottomColor = this.options.keybindingLabelBottomBorder), this.options.keybindingLabelShadow && (i.style.boxShadow = `inset 0 -1px 0 ${this.options.keybindingLabelShadow}`), i;
  }
  static areSame(e, t) {
    return e === t || !e && !t || !!e && !!t && So(e.firstPart, t.firstPart) && So(e.chordPart, t.chordPart);
  }
}
const aF = new ua((() => {
  const n = new Intl.Collator(void 0, { numeric: !0, sensitivity: "base" });
  return { collator: n, collatorIsNumeric: n.resolvedOptions().numeric };
}));
function wie(n, e, t) {
  const i = n.toLowerCase(), s = e.toLowerCase(), o = (function(l, d, h) {
    const c = l.toLowerCase(), u = d.toLowerCase(), g = c.startsWith(h), p = u.startsWith(h);
    if (g !== p) return g ? -1 : 1;
    if (g && p) {
      if (c.length < u.length) return -1;
      if (c.length > u.length) return 1;
    }
    return 0;
  })(n, e, t);
  if (o) return o;
  const r = i.endsWith(t);
  if (r !== s.endsWith(t)) return r ? -1 : 1;
  const a = (function(l, d, h = !1) {
    const c = l || "", u = d || "", g = aF.value.collator.compare(c, u);
    return aF.value.collatorIsNumeric && g === 0 && c !== u ? c < u ? -1 : 1 : g;
  })(i, s);
  return a !== 0 ? a : i.localeCompare(s);
}
var m2, QC = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, kV = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const Or = Q;
var Hi, Oa;
(function(n) {
  n[n.First = 1] = "First", n[n.Second = 2] = "Second", n[n.Last = 3] = "Last", n[n.Next = 4] = "Next", n[n.Previous = 5] = "Previous", n[n.NextPage = 6] = "NextPage", n[n.PreviousPage = 7] = "PreviousPage", n[n.NextSeparator = 8] = "NextSeparator", n[n.PreviousSeparator = 9] = "PreviousSeparator";
})(Hi || (Hi = {}));
class DV {
  constructor(e, t, i) {
    this.index = e, this.hasCheckbox = t, this._hidden = !1, this._init = new ua((() => {
      var s;
      const o = (s = i.label) !== null && s !== void 0 ? s : "", r = N_(o).text.trim(), a = i.ariaLabel || [o, this.saneDescription, this.saneDetail].map(((l) => (function(d) {
        return d ? d.replace(/\$\((.*?)\)/g, ((h, c) => ` ${c} `)).trim() : "";
      })(l))).filter(((l) => !!l)).join(", ");
      return { saneLabel: o, saneSortLabel: r, saneAriaLabel: a };
    })), this._saneDescription = i.description, this._saneTooltip = i.tooltip;
  }
  get saneLabel() {
    return this._init.value.saneLabel;
  }
  get saneSortLabel() {
    return this._init.value.saneSortLabel;
  }
  get saneAriaLabel() {
    return this._init.value.saneAriaLabel;
  }
  get element() {
    return this._element;
  }
  set element(e) {
    this._element = e;
  }
  get hidden() {
    return this._hidden;
  }
  set hidden(e) {
    this._hidden = e;
  }
  get saneDescription() {
    return this._saneDescription;
  }
  set saneDescription(e) {
    this._saneDescription = e;
  }
  get saneDetail() {
    return this._saneDetail;
  }
  set saneDetail(e) {
    this._saneDetail = e;
  }
  get saneTooltip() {
    return this._saneTooltip;
  }
  set saneTooltip(e) {
    this._saneTooltip = e;
  }
  get labelHighlights() {
    return this._labelHighlights;
  }
  set labelHighlights(e) {
    this._labelHighlights = e;
  }
  get descriptionHighlights() {
    return this._descriptionHighlights;
  }
  set descriptionHighlights(e) {
    this._descriptionHighlights = e;
  }
  get detailHighlights() {
    return this._detailHighlights;
  }
  set detailHighlights(e) {
    this._detailHighlights = e;
  }
}
class qn extends DV {
  constructor(e, t, i, s, o, r) {
    var a, l, d;
    super(e, t, o), this.fireButtonTriggered = i, this._onChecked = s, this.item = o, this._separator = r, this._checked = !1, this.onChecked = t ? se.map(se.filter(this._onChecked.event, ((h) => h.element === this)), ((h) => h.checked)) : se.None, this._saneDetail = o.detail, this._labelHighlights = (a = o.highlights) === null || a === void 0 ? void 0 : a.label, this._descriptionHighlights = (l = o.highlights) === null || l === void 0 ? void 0 : l.description, this._detailHighlights = (d = o.highlights) === null || d === void 0 ? void 0 : d.detail;
  }
  get separator() {
    return this._separator;
  }
  set separator(e) {
    this._separator = e;
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    e !== this._checked && (this._checked = e, this._onChecked.fire({ element: this, checked: e }));
  }
  get checkboxDisabled() {
    return !!this.item.disabled;
  }
}
(function(n) {
  n[n.NONE = 0] = "NONE", n[n.MOUSE_HOVER = 1] = "MOUSE_HOVER", n[n.ACTIVE_ITEM = 2] = "ACTIVE_ITEM";
})(Oa || (Oa = {}));
class ah extends DV {
  constructor(e, t, i) {
    super(e, !1, i), this.fireSeparatorButtonTriggered = t, this.separator = i, this.children = new Array(), this.focusInsideSeparator = Oa.NONE;
  }
}
class yie {
  getHeight(e) {
    return e instanceof ah ? 30 : e.saneDetail ? 44 : 22;
  }
  getTemplateId(e) {
    return e instanceof qn ? _0.ID : F1.ID;
  }
}
class Sie {
  getWidgetAriaLabel() {
    return m(0, "Quick Input");
  }
  getAriaLabel(e) {
    var t;
    return !((t = e.separator) === null || t === void 0) && t.label ? `${e.saneAriaLabel}, ${e.separator.label}` : e.saneAriaLabel;
  }
  getWidgetRole() {
    return "listbox";
  }
  getRole(e) {
    return e.hasCheckbox ? "checkbox" : "option";
  }
  isChecked(e) {
    if (e.hasCheckbox && e instanceof qn) return { value: e.checked, onDidChange: e.onChecked };
  }
}
class xV {
  constructor(e) {
    this.hoverDelegate = e;
  }
  renderTemplate(e) {
    const t = /* @__PURE__ */ Object.create(null);
    t.toDisposeElement = new G(), t.toDisposeTemplate = new G(), t.entry = Z(e, Or(".quick-input-list-entry"));
    const i = Z(t.entry, Or("label.quick-input-list-label"));
    t.toDisposeTemplate.add(bi(i, ie.CLICK, ((d) => {
      t.checkbox.offsetParent || d.preventDefault();
    }))), t.checkbox = Z(i, Or("input.quick-input-list-checkbox")), t.checkbox.type = "checkbox";
    const s = Z(i, Or(".quick-input-list-rows")), o = Z(s, Or(".quick-input-list-row")), r = Z(s, Or(".quick-input-list-row"));
    t.label = new Yy(o, { supportHighlights: !0, supportDescriptionHighlights: !0, supportIcons: !0, hoverDelegate: this.hoverDelegate }), t.toDisposeTemplate.add(t.label), t.icon = fR(t.label.element, Or(".quick-input-list-icon"));
    const a = Z(o, Or(".quick-input-list-entry-keybinding"));
    t.keybinding = new Cf(a, Gs), t.toDisposeTemplate.add(t.keybinding);
    const l = Z(r, Or(".quick-input-list-label-meta"));
    return t.detail = new Yy(l, { supportHighlights: !0, supportIcons: !0, hoverDelegate: this.hoverDelegate }), t.toDisposeTemplate.add(t.detail), t.separator = Z(t.entry, Or(".quick-input-list-separator")), t.actionBar = new sr(t.entry, this.hoverDelegate ? { hoverDelegate: this.hoverDelegate } : void 0), t.actionBar.domNode.classList.add("quick-input-list-entry-action-bar"), t.toDisposeTemplate.add(t.actionBar), t;
  }
  disposeTemplate(e) {
    e.toDisposeElement.dispose(), e.toDisposeTemplate.dispose();
  }
  disposeElement(e, t, i) {
    i.toDisposeElement.clear(), i.actionBar.clear();
  }
}
let _0 = m2 = class extends xV {
  constructor(n, e) {
    super(n), this.themeService = e, this._itemsWithSeparatorsFrequency = /* @__PURE__ */ new Map();
  }
  get templateId() {
    return m2.ID;
  }
  renderTemplate(n) {
    const e = super.renderTemplate(n);
    return e.toDisposeTemplate.add(bi(e.checkbox, ie.CHANGE, ((t) => {
      e.element.checked = e.checkbox.checked;
    }))), e;
  }
  renderElement(n, e, t) {
    var i, s, o;
    const r = n.element;
    t.element = r, r.element = (i = t.entry) !== null && i !== void 0 ? i : void 0;
    const a = r.item;
    t.checkbox.checked = r.checked, t.toDisposeElement.add(r.onChecked(((p) => t.checkbox.checked = p))), t.checkbox.disabled = r.checkboxDisabled;
    const { labelHighlights: l, descriptionHighlights: d, detailHighlights: h } = r;
    if (a.iconPath) {
      const p = zm(this.themeService.getColorTheme().type) ? a.iconPath.dark : (s = a.iconPath.light) !== null && s !== void 0 ? s : a.iconPath.dark, f = Ie.revive(p);
      t.icon.className = "quick-input-list-icon", t.icon.style.backgroundImage = wc(f);
    } else t.icon.style.backgroundImage = "", t.icon.className = a.iconClass ? `quick-input-list-icon ${a.iconClass}` : "";
    let c;
    !r.saneTooltip && r.saneDescription && (c = { markdown: { value: r.saneDescription, supportThemeIcons: !0 }, markdownNotSupportedFallback: r.saneDescription });
    const u = { matches: l || [], descriptionTitle: c, descriptionMatches: d || [], labelEscapeNewLines: !0 };
    if (u.extraClasses = a.iconClasses, u.italic = a.italic, u.strikethrough = a.strikethrough, t.entry.classList.remove("quick-input-list-separator-as-item"), t.label.setLabel(r.saneLabel, r.saneDescription, u), t.keybinding.set(a.keybinding), r.saneDetail) {
      let p;
      r.saneTooltip || (p = { markdown: { value: r.saneDetail, supportThemeIcons: !0 }, markdownNotSupportedFallback: r.saneDetail }), t.detail.element.style.display = "", t.detail.setLabel(r.saneDetail, void 0, { matches: h, title: p, labelEscapeNewLines: !0 });
    } else t.detail.element.style.display = "none";
    !((o = r.separator) === null || o === void 0) && o.label ? (t.separator.textContent = r.separator.label, t.separator.style.display = "", this.addItemWithSeparator(r)) : t.separator.style.display = "none", t.entry.classList.toggle("quick-input-list-separator-border", !!r.separator);
    const g = a.buttons;
    g && g.length ? (t.actionBar.push(g.map(((p, f) => Hy(p, `id-${f}`, (() => r.fireButtonTriggered({ button: p, item: r.item }))))), { icon: !0, label: !1 }), t.entry.classList.add("has-actions")) : t.entry.classList.remove("has-actions");
  }
  disposeElement(n, e, t) {
    this.removeItemWithSeparator(n.element), super.disposeElement(n, e, t);
  }
  isItemWithSeparatorVisible(n) {
    return this._itemsWithSeparatorsFrequency.has(n);
  }
  addItemWithSeparator(n) {
    this._itemsWithSeparatorsFrequency.set(n, (this._itemsWithSeparatorsFrequency.get(n) || 0) + 1);
  }
  removeItemWithSeparator(n) {
    const e = this._itemsWithSeparatorsFrequency.get(n) || 0;
    e > 1 ? this._itemsWithSeparatorsFrequency.set(n, e - 1) : this._itemsWithSeparatorsFrequency.delete(n);
  }
};
_0.ID = "quickpickitem", _0 = m2 = QC([kV(1, Yi)], _0);
class F1 extends xV {
  constructor() {
    super(...arguments), this._visibleSeparatorsFrequency = /* @__PURE__ */ new Map();
  }
  get templateId() {
    return F1.ID;
  }
  get visibleSeparators() {
    return [...this._visibleSeparatorsFrequency.keys()];
  }
  isSeparatorVisible(e) {
    return this._visibleSeparatorsFrequency.has(e);
  }
  renderElement(e, t, i) {
    var s;
    const o = e.element;
    i.element = o, o.element = (s = i.entry) !== null && s !== void 0 ? s : void 0, o.element.classList.toggle("focus-inside", !!o.focusInsideSeparator);
    const r = o.separator, { labelHighlights: a, descriptionHighlights: l, detailHighlights: d } = o;
    let h;
    i.icon.style.backgroundImage = "", i.icon.className = "", !o.saneTooltip && o.saneDescription && (h = { markdown: { value: o.saneDescription, supportThemeIcons: !0 }, markdownNotSupportedFallback: o.saneDescription });
    const c = { matches: a || [], descriptionTitle: h, descriptionMatches: l || [], labelEscapeNewLines: !0 };
    if (i.entry.classList.add("quick-input-list-separator-as-item"), i.label.setLabel(o.saneLabel, o.saneDescription, c), o.saneDetail) {
      let g;
      o.saneTooltip || (g = { markdown: { value: o.saneDetail, supportThemeIcons: !0 }, markdownNotSupportedFallback: o.saneDetail }), i.detail.element.style.display = "", i.detail.setLabel(o.saneDetail, void 0, { matches: d, title: g, labelEscapeNewLines: !0 });
    } else i.detail.element.style.display = "none";
    i.separator.style.display = "none", i.entry.classList.add("quick-input-list-separator-border");
    const u = r.buttons;
    u && u.length ? (i.actionBar.push(u.map(((g, p) => Hy(g, `id-${p}`, (() => o.fireSeparatorButtonTriggered({ button: g, separator: o.separator }))))), { icon: !0, label: !1 }), i.entry.classList.add("has-actions")) : i.entry.classList.remove("has-actions"), this.addSeparator(o);
  }
  disposeElement(e, t, i) {
    var s;
    this.removeSeparator(e.element), this.isSeparatorVisible(e.element) || (s = e.element.element) === null || s === void 0 || s.classList.remove("focus-inside"), super.disposeElement(e, t, i);
  }
  addSeparator(e) {
    this._visibleSeparatorsFrequency.set(e, (this._visibleSeparatorsFrequency.get(e) || 0) + 1);
  }
  removeSeparator(e) {
    const t = this._visibleSeparatorsFrequency.get(e) || 0;
    t > 1 ? this._visibleSeparatorsFrequency.set(e, t - 1) : this._visibleSeparatorsFrequency.delete(e);
  }
}
F1.ID = "quickpickseparator";
let M_ = class extends V {
  constructor(n, e, t, i, s) {
    super(), this.parent = n, this.hoverDelegate = e, this.linkOpenerDelegate = t, this._onKeyDown = new F(), this.onKeyDown = this._onKeyDown.event, this._onLeave = new F(), this.onLeave = this._onLeave.event, this._onChangedAllVisibleChecked = new F(), this.onChangedAllVisibleChecked = this._onChangedAllVisibleChecked.event, this._onChangedCheckedCount = new F(), this.onChangedCheckedCount = this._onChangedCheckedCount.event, this._onChangedVisibleCount = new F(), this.onChangedVisibleCount = this._onChangedVisibleCount.event, this._onChangedCheckedElements = new F(), this.onChangedCheckedElements = this._onChangedCheckedElements.event, this._onButtonTriggered = new F(), this.onButtonTriggered = this._onButtonTriggered.event, this._onSeparatorButtonTriggered = new F(), this.onSeparatorButtonTriggered = this._onSeparatorButtonTriggered.event, this._onTriggerEmptySelectionOrFocus = new F(), this._elementChecked = new F(), this._inputElements = new Array(), this._elementTree = new Array(), this._itemElements = new Array(), this._elementDisposable = this._register(new G()), this._shouldFireCheckedEvents = !0, this._matchOnDescription = !1, this._matchOnDetail = !1, this._matchOnLabel = !0, this._matchOnLabelMode = "fuzzy", this._sortByLabel = !0, this._container = Z(this.parent, Or(".quick-input-list")), this._separatorRenderer = new F1(e), this._itemRenderer = s.createInstance(_0, e), this._tree = this._register(s.createInstance(g2, "QuickInput", this._container, new yie(), [this._itemRenderer, this._separatorRenderer], { accessibilityProvider: new Sie(), setRowLineHeight: !1, multipleSelectionSupport: !1, hideTwistiesOfChildlessElements: !0, renderIndentGuides: tf.None, findWidgetEnabled: !1, indent: 0, horizontalScrolling: !1, allowNonCollapsibleParents: !0, identityProvider: { getId: (o) => {
      var r, a, l, d, h, c, u, g;
      return (g = (c = (d = (a = (r = o.item) === null || r === void 0 ? void 0 : r.id) !== null && a !== void 0 ? a : (l = o.item) === null || l === void 0 ? void 0 : l.label) !== null && d !== void 0 ? d : (h = o.separator) === null || h === void 0 ? void 0 : h.id) !== null && c !== void 0 ? c : (u = o.separator) === null || u === void 0 ? void 0 : u.label) !== null && g !== void 0 ? g : "";
    } }, alwaysConsumeMouseWheel: !0 })), this._tree.getHTMLElement().id = i, this._registerListeners();
  }
  get onDidChangeFocus() {
    return se.map(se.any(this._tree.onDidChangeFocus, this._onTriggerEmptySelectionOrFocus.event), ((n) => n.elements.filter(((e) => e instanceof qn)).map(((e) => e.item))));
  }
  get onDidChangeSelection() {
    return se.map(se.any(this._tree.onDidChangeSelection, this._onTriggerEmptySelectionOrFocus.event), ((n) => ({ items: n.elements.filter(((e) => e instanceof qn)).map(((e) => e.item)), event: n.browserEvent })));
  }
  get scrollTop() {
    return this._tree.scrollTop;
  }
  set scrollTop(n) {
    this._tree.scrollTop = n;
  }
  get ariaLabel() {
    return this._tree.ariaLabel;
  }
  set ariaLabel(n) {
    this._tree.ariaLabel = n ?? "";
  }
  set enabled(n) {
    this._tree.getHTMLElement().style.pointerEvents = n ? "" : "none";
  }
  get matchOnDescription() {
    return this._matchOnDescription;
  }
  set matchOnDescription(n) {
    this._matchOnDescription = n;
  }
  get matchOnDetail() {
    return this._matchOnDetail;
  }
  set matchOnDetail(n) {
    this._matchOnDetail = n;
  }
  get matchOnLabel() {
    return this._matchOnLabel;
  }
  set matchOnLabel(n) {
    this._matchOnLabel = n;
  }
  get matchOnLabelMode() {
    return this._matchOnLabelMode;
  }
  set matchOnLabelMode(n) {
    this._matchOnLabelMode = n;
  }
  get sortByLabel() {
    return this._sortByLabel;
  }
  set sortByLabel(n) {
    this._sortByLabel = n;
  }
  _registerListeners() {
    this._registerOnKeyDown(), this._registerOnContainerClick(), this._registerOnMouseMiddleClick(), this._registerOnElementChecked(), this._registerOnContextMenu(), this._registerHoverListeners(), this._registerSelectionChangeListener(), this._registerSeparatorActionShowingListeners();
  }
  _registerOnKeyDown() {
    this._register(this._tree.onKeyDown(((n) => {
      const e = new jt(n);
      switch (e.keyCode) {
        case 10:
          this.toggleCheckbox();
          break;
        case 31:
          (Je ? n.metaKey : n.ctrlKey) && this._tree.setFocus(this._itemElements);
          break;
        case 16: {
          const t = this._tree.getFocus();
          t.length === 1 && t[0] === this._itemElements[0] && this._onLeave.fire();
          break;
        }
        case 18: {
          const t = this._tree.getFocus();
          t.length === 1 && t[0] === this._itemElements[this._itemElements.length - 1] && this._onLeave.fire();
          break;
        }
      }
      this._onKeyDown.fire(e);
    })));
  }
  _registerOnContainerClick() {
    this._register(K(this._container, ie.CLICK, ((n) => {
      (n.x || n.y) && this._onLeave.fire();
    })));
  }
  _registerOnMouseMiddleClick() {
    this._register(K(this._container, ie.AUXCLICK, ((n) => {
      n.button === 1 && this._onLeave.fire();
    })));
  }
  _registerOnElementChecked() {
    this._register(this._elementChecked.event(((n) => this._fireCheckedEvents())));
  }
  _registerOnContextMenu() {
    this._register(this._tree.onContextMenu(((n) => {
      n.element && (n.browserEvent.preventDefault(), this._tree.setSelection([n.element]));
    })));
  }
  _registerHoverListeners() {
    const n = this._register(new r8(this.hoverDelegate.delay));
    this._register(this._tree.onMouseOver((async (e) => {
      var t;
      if (e.browserEvent.target instanceof HTMLAnchorElement) n.cancel();
      else if (e.browserEvent.relatedTarget instanceof HTMLAnchorElement || !gn(e.browserEvent.relatedTarget, (t = e.element) === null || t === void 0 ? void 0 : t.element)) try {
        await n.trigger((async () => {
          e.element instanceof qn && this.showHover(e.element);
        }));
      } catch (i) {
        if (!ya(i)) throw i;
      }
    }))), this._register(this._tree.onMouseOut(((e) => {
      var t;
      gn(e.browserEvent.relatedTarget, (t = e.element) === null || t === void 0 ? void 0 : t.element) || n.cancel();
    })));
  }
  _registerSeparatorActionShowingListeners() {
    this._register(this._tree.onDidChangeFocus(((n) => {
      const e = n.elements[0] ? this._tree.getParentElement(n.elements[0]) : null;
      for (const t of this._separatorRenderer.visibleSeparators) {
        const i = t === e;
        !!(t.focusInsideSeparator & Oa.ACTIVE_ITEM) !== i && (i ? t.focusInsideSeparator |= Oa.ACTIVE_ITEM : t.focusInsideSeparator &= ~Oa.ACTIVE_ITEM, this._tree.rerender(t));
      }
    }))), this._register(this._tree.onMouseOver(((n) => {
      const e = n.element ? this._tree.getParentElement(n.element) : null;
      for (const t of this._separatorRenderer.visibleSeparators)
        t === e && (t.focusInsideSeparator & Oa.MOUSE_HOVER || (t.focusInsideSeparator |= Oa.MOUSE_HOVER, this._tree.rerender(t)));
    }))), this._register(this._tree.onMouseOut(((n) => {
      const e = n.element ? this._tree.getParentElement(n.element) : null;
      for (const t of this._separatorRenderer.visibleSeparators)
        t === e && t.focusInsideSeparator & Oa.MOUSE_HOVER && (t.focusInsideSeparator &= ~Oa.MOUSE_HOVER, this._tree.rerender(t));
    })));
  }
  _registerSelectionChangeListener() {
    this._register(this._tree.onDidChangeSelection(((n) => {
      const e = n.elements.filter(((t) => t instanceof qn));
      e.length !== n.elements.length && (n.elements.length === 1 && n.elements[0] instanceof ah && (this._tree.setFocus([n.elements[0].children[0]]), this._tree.reveal(n.elements[0], 0)), this._tree.setSelection(e));
    })));
  }
  getAllVisibleChecked() {
    return this._allVisibleChecked(this._itemElements, !1);
  }
  getCheckedCount() {
    return this._itemElements.filter(((n) => n.checked)).length;
  }
  getVisibleCount() {
    return this._itemElements.filter(((n) => !n.hidden)).length;
  }
  setAllVisibleChecked(n) {
    try {
      this._shouldFireCheckedEvents = !1, this._itemElements.forEach(((e) => {
        e.hidden || e.checkboxDisabled || (e.checked = n);
      }));
    } finally {
      this._shouldFireCheckedEvents = !0, this._fireCheckedEvents();
    }
  }
  setElements(n) {
    this._elementDisposable.clear(), this._inputElements = n;
    const e = this.parent.classList.contains("show-checkboxes");
    let t;
    this._itemElements = new Array(), this._elementTree = n.reduce(((o, r, a) => {
      let l;
      if (r.type === "separator") {
        if (!r.buttons) return o;
        t = new ah(a, ((d) => this.fireSeparatorButtonTriggered(d)), r), l = t;
      } else {
        const d = a > 0 ? n[a - 1] : void 0;
        let h;
        d && d.type === "separator" && !d.buttons && (t = void 0, h = d);
        const c = new qn(a, e, ((u) => this.fireButtonTriggered(u)), this._elementChecked, r, h);
        if (this._itemElements.push(c), t) return t.children.push(c), o;
        l = c;
      }
      return o.push(l), o;
    }), new Array());
    const i = new Array();
    let s = 0;
    for (const o of this._elementTree) o instanceof ah ? (i.push({ element: o, collapsible: !1, collapsed: !1, children: o.children.map(((r) => ({ element: r, collapsible: !1, collapsed: !1 }))) }), s += o.children.length + 1) : (i.push({ element: o, collapsible: !1, collapsed: !1 }), s++);
    this._tree.setChildren(null, i), this._onChangedVisibleCount.fire(s);
  }
  setFocusedElements(n) {
    const e = n.map(((t) => this._itemElements.find(((i) => i.item === t)))).filter(((t) => !!t));
    if (this._tree.setFocus(e), n.length > 0) {
      const t = this._tree.getFocus()[0];
      t && this._tree.reveal(t);
    }
  }
  getActiveDescendant() {
    return this._tree.getHTMLElement().getAttribute("aria-activedescendant");
  }
  setSelectedElements(n) {
    const e = n.map(((t) => this._itemElements.find(((i) => i.item === t)))).filter(((t) => !!t));
    this._tree.setSelection(e);
  }
  getCheckedElements() {
    return this._itemElements.filter(((n) => n.checked)).map(((n) => n.item));
  }
  setCheckedElements(n) {
    try {
      this._shouldFireCheckedEvents = !1;
      const e = /* @__PURE__ */ new Set();
      for (const t of n) e.add(t);
      for (const t of this._itemElements) t.checked = e.has(t.item);
    } finally {
      this._shouldFireCheckedEvents = !0, this._fireCheckedEvents();
    }
  }
  focus(n) {
    var e;
    if (this._itemElements.length) switch (n === Hi.Second && this._itemElements.length < 2 && (n = Hi.First), n) {
      case Hi.First:
        this._tree.scrollTop = 0, this._tree.focusFirst(void 0, ((t) => t.element instanceof qn));
        break;
      case Hi.Second:
        this._tree.scrollTop = 0, this._tree.setFocus([this._itemElements[1]]);
        break;
      case Hi.Last:
        this._tree.scrollTop = this._tree.scrollHeight, this._tree.setFocus([this._itemElements[this._itemElements.length - 1]]);
        break;
      case Hi.Next:
        this._tree.focusNext(void 0, !0, void 0, ((t) => t.element instanceof qn && (this._tree.reveal(t.element), !0)));
        break;
      case Hi.Previous:
        this._tree.focusPrevious(void 0, !0, void 0, ((t) => {
          if (!(t.element instanceof qn)) return !1;
          const i = this._tree.getParentElement(t.element);
          return i === null || i.children[0] !== t.element ? this._tree.reveal(t.element) : this._tree.reveal(i), !0;
        }));
        break;
      case Hi.NextPage:
        this._tree.focusNextPage(void 0, ((t) => t.element instanceof qn && (this._tree.reveal(t.element), !0)));
        break;
      case Hi.PreviousPage:
        this._tree.focusPreviousPage(void 0, ((t) => {
          if (!(t.element instanceof qn)) return !1;
          const i = this._tree.getParentElement(t.element);
          return i === null || i.children[0] !== t.element ? this._tree.reveal(t.element) : this._tree.reveal(i), !0;
        }));
        break;
      case Hi.NextSeparator: {
        let t = !1;
        const i = this._tree.getFocus()[0];
        this._tree.focusNext(void 0, !0, void 0, ((s) => {
          if (t) return !0;
          if (s.element instanceof ah) t = !0, this._separatorRenderer.isSeparatorVisible(s.element) ? this._tree.reveal(s.element.children[0]) : this._tree.reveal(s.element, 0);
          else if (s.element instanceof qn) {
            if (s.element.separator) return this._itemRenderer.isItemWithSeparatorVisible(s.element) ? this._tree.reveal(s.element) : this._tree.reveal(s.element, 0), !0;
            if (s.element === this._elementTree[0]) return this._tree.reveal(s.element, 0), !0;
          }
          return !1;
        })), i === this._tree.getFocus()[0] && (this._tree.scrollTop = this._tree.scrollHeight, this._tree.setFocus([this._itemElements[this._itemElements.length - 1]]));
        break;
      }
      case Hi.PreviousSeparator: {
        let t, i = !!(!((e = this._tree.getFocus()[0]) === null || e === void 0) && e.separator);
        this._tree.focusPrevious(void 0, !0, void 0, ((s) => {
          if (s.element instanceof ah) i ? t || (this._separatorRenderer.isSeparatorVisible(s.element) ? this._tree.reveal(s.element) : this._tree.reveal(s.element, 0), t = s.element.children[0]) : i = !0;
          else if (s.element instanceof qn && !t) {
            if (s.element.separator) this._itemRenderer.isItemWithSeparatorVisible(s.element) ? this._tree.reveal(s.element) : this._tree.reveal(s.element, 0), t = s.element;
            else if (s.element === this._elementTree[0]) return this._tree.reveal(s.element, 0), !0;
          }
          return !1;
        })), t && this._tree.setFocus([t]);
        break;
      }
    }
  }
  clearFocus() {
    this._tree.setFocus([]);
  }
  domFocus() {
    this._tree.domFocus();
  }
  layout(n) {
    this._tree.getHTMLElement().style.maxHeight = n ? 44 * Math.floor(n / 44) + 6 + "px" : "", this._tree.layout();
  }
  filter(n) {
    if (!(this._sortByLabel || this._matchOnLabel || this._matchOnDescription || this._matchOnDetail)) return this._tree.layout(), !1;
    const e = n;
    if ((n = n.trim()) && (this.matchOnLabel || this.matchOnDescription || this.matchOnDetail)) {
      let a;
      this._elementTree.forEach(((l) => {
        var d, h, c, u;
        let g;
        g = this.matchOnLabelMode === "fuzzy" ? this.matchOnLabel && (d = jD(n, N_(l.saneLabel))) !== null && d !== void 0 ? d : void 0 : this.matchOnLabel && (h = (function(_, v) {
          const { text: b, iconOffsets: C } = v;
          if (!C || C.length === 0) return lF(_, b);
          const w = u1(b, " "), y = b.length - w.length, L = lF(_, w);
          if (L) for (const k of L) {
            const N = C[k.start + y] + y;
            k.start += N, k.end += N;
          }
          return L;
        })(e, N_(l.saneLabel))) !== null && h !== void 0 ? h : void 0;
        const p = this.matchOnDescription && (c = jD(n, N_(l.saneDescription || ""))) !== null && c !== void 0 ? c : void 0, f = this.matchOnDetail && (u = jD(n, N_(l.saneDetail || ""))) !== null && u !== void 0 ? u : void 0;
        if (g || p || f ? (l.labelHighlights = g, l.descriptionHighlights = p, l.detailHighlights = f, l.hidden = !1) : (l.labelHighlights = void 0, l.descriptionHighlights = void 0, l.detailHighlights = void 0, l.hidden = !l.item || !l.item.alwaysShow), l.item ? l.separator = void 0 : l.separator && (l.hidden = !0), !this.sortByLabel) {
          const _ = l.index && this._inputElements[l.index - 1];
          a = _ && _.type === "separator" ? _ : a, a && !l.hidden && (l.separator = a, a = void 0);
        }
      }));
    } else this._itemElements.forEach(((a) => {
      a.labelHighlights = void 0, a.descriptionHighlights = void 0, a.detailHighlights = void 0, a.hidden = !1;
      const l = a.index && this._inputElements[a.index - 1];
      a.item && (a.separator = l && l.type === "separator" && !l.buttons ? l : void 0);
    }));
    const t = this._elementTree.filter(((a) => !a.hidden));
    if (this.sortByLabel && n) {
      const a = n.toLowerCase();
      t.sort(((l, d) => (function(h, c, u) {
        const g = h.labelHighlights || [], p = c.labelHighlights || [];
        return g.length && !p.length ? -1 : !g.length && p.length ? 1 : g.length === 0 && p.length === 0 ? 0 : wie(h.saneSortLabel, c.saneSortLabel, u);
      })(l, d, a)));
    }
    let i;
    const s = t.reduce(((a, l, d) => (l instanceof qn ? i ? i.children.push(l) : a.push(l) : l instanceof ah && (l.children = [], i = l, a.push(l)), a)), new Array()), o = new Array();
    for (const a of s) a instanceof ah ? o.push({ element: a, collapsible: !1, collapsed: !1, children: a.children.map(((l) => ({ element: l, collapsible: !1, collapsed: !1 }))) }) : o.push({ element: a, collapsible: !1, collapsed: !1 });
    const r = this._tree.getFocus().length;
    return this._tree.setChildren(null, o), r > 0 && o.length === 0 && this._onTriggerEmptySelectionOrFocus.fire({ elements: [] }), this._tree.layout(), this._onChangedAllVisibleChecked.fire(this.getAllVisibleChecked()), this._onChangedVisibleCount.fire(t.length), !0;
  }
  toggleCheckbox() {
    try {
      this._shouldFireCheckedEvents = !1;
      const n = this._tree.getFocus().filter(((t) => t instanceof qn)), e = this._allVisibleChecked(n);
      for (const t of n) t.checkboxDisabled || (t.checked = !e);
    } finally {
      this._shouldFireCheckedEvents = !0, this._fireCheckedEvents();
    }
  }
  display(n) {
    this._container.style.display = n ? "" : "none";
  }
  isDisplayed() {
    return this._container.style.display !== "none";
  }
  style(n) {
    this._tree.style(n);
  }
  toggleHover() {
    const n = this._tree.getFocus()[0];
    if (!(n?.saneTooltip && n instanceof qn)) return;
    if (this._lastHover && !this._lastHover.isDisposed) return void this._lastHover.dispose();
    this.showHover(n);
    const e = new G();
    e.add(this._tree.onDidChangeFocus(((t) => {
      t.elements[0] instanceof qn && this.showHover(t.elements[0]);
    }))), this._lastHover && e.add(this._lastHover), this._elementDisposable.add(e);
  }
  _allVisibleChecked(n, e = !0) {
    for (let t = 0, i = n.length; t < i; t++) {
      const s = n[t];
      if (!s.hidden) {
        if (!s.checked) return !1;
        e = !0;
      }
    }
    return e;
  }
  _fireCheckedEvents() {
    this._shouldFireCheckedEvents && (this._onChangedAllVisibleChecked.fire(this.getAllVisibleChecked()), this._onChangedCheckedCount.fire(this.getCheckedCount()), this._onChangedCheckedElements.fire(this.getCheckedElements()));
  }
  fireButtonTriggered(n) {
    this._onButtonTriggered.fire(n);
  }
  fireSeparatorButtonTriggered(n) {
    this._onSeparatorButtonTriggered.fire(n);
  }
  showHover(n) {
    var e, t, i;
    this._lastHover && !this._lastHover.isDisposed && ((t = (e = this.hoverDelegate).onDidHideHover) === null || t === void 0 || t.call(e), (i = this._lastHover) === null || i === void 0 || i.dispose()), n.element && n.saneTooltip && (this._lastHover = this.hoverDelegate.showHover({ content: n.saneTooltip, target: n.element, linkHandler: (s) => {
      this.linkOpenerDelegate(s);
    }, appearance: { showPointer: !0 }, container: this._container, position: { hoverPosition: 1 } }, !1));
  }
};
function lF(n, e) {
  const t = e.toLowerCase().indexOf(n.toLowerCase());
  return t !== -1 ? [{ start: t, end: t + n.length }] : null;
}
QC([Li], M_.prototype, "onDidChangeFocus", null), QC([Li], M_.prototype, "onDidChangeSelection", null), M_ = QC([kV(4, Se)], M_);
var Lie = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, dF = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const f2 = { iconClass: Ee.asClassName(ne.quickInputBack), tooltip: m(0, "Back") };
class B1 extends V {
  constructor(e) {
    super(), this.ui = e, this._widgetUpdated = !1, this.visible = !1, this._enabled = !0, this._busy = !1, this._ignoreFocusOut = !1, this._buttons = [], this.buttonsUpdated = !1, this._toggles = [], this.togglesUpdated = !1, this.noValidationMessage = B1.noPromptMessage, this._severity = ki.Ignore, this.onDidTriggerButtonEmitter = this._register(new F()), this.onDidHideEmitter = this._register(new F()), this.onWillHideEmitter = this._register(new F()), this.onDisposeEmitter = this._register(new F()), this.visibleDisposables = this._register(new G()), this.onDidHide = this.onDidHideEmitter.event;
  }
  get title() {
    return this._title;
  }
  set title(e) {
    this._title = e, this.update();
  }
  get description() {
    return this._description;
  }
  set description(e) {
    this._description = e, this.update();
  }
  get step() {
    return this._steps;
  }
  set step(e) {
    this._steps = e, this.update();
  }
  get totalSteps() {
    return this._totalSteps;
  }
  set totalSteps(e) {
    this._totalSteps = e, this.update();
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(e) {
    this._enabled = e, this.update();
  }
  get contextKey() {
    return this._contextKey;
  }
  set contextKey(e) {
    this._contextKey = e, this.update();
  }
  get busy() {
    return this._busy;
  }
  set busy(e) {
    this._busy = e, this.update();
  }
  get ignoreFocusOut() {
    return this._ignoreFocusOut;
  }
  set ignoreFocusOut(e) {
    const t = this._ignoreFocusOut !== e && !ca;
    this._ignoreFocusOut = e && !ca, t && this.update();
  }
  get buttons() {
    return this._buttons;
  }
  set buttons(e) {
    this._buttons = e, this.buttonsUpdated = !0, this.update();
  }
  get toggles() {
    return this._toggles;
  }
  set toggles(e) {
    this._toggles = e ?? [], this.togglesUpdated = !0, this.update();
  }
  get validationMessage() {
    return this._validationMessage;
  }
  set validationMessage(e) {
    this._validationMessage = e, this.update();
  }
  get severity() {
    return this._severity;
  }
  set severity(e) {
    this._severity = e, this.update();
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.onDidTriggerButton(((e) => {
      this.buttons.indexOf(e) !== -1 && this.onDidTriggerButtonEmitter.fire(e);
    }))), this.ui.show(this), this.visible = !0, this._lastValidationMessage = void 0, this._lastSeverity = void 0, this.buttons.length && (this.buttonsUpdated = !0), this.toggles.length && (this.togglesUpdated = !0), this.update());
  }
  hide() {
    this.visible && this.ui.hide();
  }
  didHide(e = Jm.Other) {
    this.visible = !1, this.visibleDisposables.clear(), this.onDidHideEmitter.fire({ reason: e });
  }
  willHide(e = Jm.Other) {
    this.onWillHideEmitter.fire({ reason: e });
  }
  update() {
    var e, t;
    if (!this.visible) return;
    const i = this.getTitle();
    i && this.ui.title.textContent !== i ? this.ui.title.textContent = i : i || this.ui.title.innerHTML === "&nbsp;" || (this.ui.title.innerText = " ");
    const s = this.getDescription();
    if (this.ui.description1.textContent !== s && (this.ui.description1.textContent = s), this.ui.description2.textContent !== s && (this.ui.description2.textContent = s), this._widgetUpdated && (this._widgetUpdated = !1, this._widget ? wn(this.ui.widget, this._widget) : wn(this.ui.widget)), this.busy && !this.busyDelay && (this.busyDelay = new Dr(), this.busyDelay.setIfNotSet((() => {
      this.visible && this.ui.progressBar.infinite();
    }), 800)), !this.busy && this.busyDelay && (this.ui.progressBar.stop(), this.busyDelay.cancel(), this.busyDelay = void 0), this.buttonsUpdated) {
      this.buttonsUpdated = !1, this.ui.leftActionBar.clear();
      const r = this.buttons.filter(((l) => l === f2)).map(((l, d) => Hy(l, `id-${d}`, (async () => this.onDidTriggerButtonEmitter.fire(l)))));
      this.ui.leftActionBar.push(r, { icon: !0, label: !1 }), this.ui.rightActionBar.clear();
      const a = this.buttons.filter(((l) => l !== f2)).map(((l, d) => Hy(l, `id-${d}`, (async () => this.onDidTriggerButtonEmitter.fire(l)))));
      this.ui.rightActionBar.push(a, { icon: !0, label: !1 });
    }
    if (this.togglesUpdated) {
      this.togglesUpdated = !1;
      const r = (t = (e = this.toggles) === null || e === void 0 ? void 0 : e.filter(((a) => a instanceof bf))) !== null && t !== void 0 ? t : [];
      this.ui.inputBox.toggles = r;
    }
    this.ui.ignoreFocusOut = this.ignoreFocusOut, this.ui.setEnabled(this.enabled), this.ui.setContextKey(this.contextKey);
    const o = this.validationMessage || this.noValidationMessage;
    this._lastValidationMessage !== o && (this._lastValidationMessage = o, wn(this.ui.message), wte(o, this.ui.message, { callback: (r) => {
      this.ui.linkOpenerDelegate(r);
    }, disposables: this.visibleDisposables })), this._lastSeverity !== this.severity && (this._lastSeverity = this.severity, this.showMessageDecoration(this.severity));
  }
  getTitle() {
    return this.title && this.step ? `${this.title} (${this.getSteps()})` : this.title ? this.title : this.step ? this.getSteps() : "";
  }
  getDescription() {
    return this.description || "";
  }
  getSteps() {
    return this.step && this.totalSteps ? m(0, "{0}/{1}", this.step, this.totalSteps) : this.step ? String(this.step) : "";
  }
  showMessageDecoration(e) {
    if (this.ui.inputBox.showDecoration(e), e !== ki.Ignore) {
      const t = this.ui.inputBox.stylesForType(e);
      this.ui.message.style.color = t.foreground ? `${t.foreground}` : "", this.ui.message.style.backgroundColor = t.background ? `${t.background}` : "", this.ui.message.style.border = t.border ? `1px solid ${t.border}` : "", this.ui.message.style.marginBottom = "-2px";
    } else this.ui.message.style.color = "", this.ui.message.style.backgroundColor = "", this.ui.message.style.border = "", this.ui.message.style.marginBottom = "";
  }
  dispose() {
    this.hide(), this.onDisposeEmitter.fire(), super.dispose();
  }
}
B1.noPromptMessage = m(0, "Press 'Enter' to confirm your input or 'Escape' to cancel");
class Vv extends B1 {
  constructor() {
    super(...arguments), this._value = "", this.onDidChangeValueEmitter = this._register(new F()), this.onWillAcceptEmitter = this._register(new F()), this.onDidAcceptEmitter = this._register(new F()), this.onDidCustomEmitter = this._register(new F()), this._items = [], this.itemsUpdated = !1, this._canSelectMany = !1, this._canAcceptInBackground = !1, this._matchOnDescription = !1, this._matchOnDetail = !1, this._matchOnLabel = !0, this._matchOnLabelMode = "fuzzy", this._sortByLabel = !0, this._keepScrollPosition = !1, this._itemActivation = Kr.FIRST, this._activeItems = [], this.activeItemsUpdated = !1, this.activeItemsToConfirm = [], this.onDidChangeActiveEmitter = this._register(new F()), this._selectedItems = [], this.selectedItemsUpdated = !1, this.selectedItemsToConfirm = [], this.onDidChangeSelectionEmitter = this._register(new F()), this.onDidTriggerItemButtonEmitter = this._register(new F()), this.onDidTriggerSeparatorButtonEmitter = this._register(new F()), this.valueSelectionUpdated = !0, this._ok = "default", this._customButton = !1, this.filterValue = (e) => e, this.onDidChangeValue = this.onDidChangeValueEmitter.event, this.onWillAccept = this.onWillAcceptEmitter.event, this.onDidAccept = this.onDidAcceptEmitter.event, this.onDidChangeActive = this.onDidChangeActiveEmitter.event, this.onDidChangeSelection = this.onDidChangeSelectionEmitter.event, this.onDidTriggerItemButton = this.onDidTriggerItemButtonEmitter.event, this.onDidTriggerSeparatorButton = this.onDidTriggerSeparatorButtonEmitter.event;
  }
  get quickNavigate() {
    return this._quickNavigate;
  }
  set quickNavigate(e) {
    this._quickNavigate = e, this.update();
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.doSetValue(e);
  }
  doSetValue(e, t) {
    this._value !== e && (this._value = e, t || this.update(), this.visible && this.ui.list.filter(this.filterValue(this._value)) && this.trySelectFirst(), this.onDidChangeValueEmitter.fire(this._value));
  }
  set ariaLabel(e) {
    this._ariaLabel = e, this.update();
  }
  get ariaLabel() {
    return this._ariaLabel;
  }
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(e) {
    this._placeholder = e, this.update();
  }
  get items() {
    return this._items;
  }
  get scrollTop() {
    return this.ui.list.scrollTop;
  }
  set scrollTop(e) {
    this.ui.list.scrollTop = e;
  }
  set items(e) {
    this._items = e, this.itemsUpdated = !0, this.update();
  }
  get canSelectMany() {
    return this._canSelectMany;
  }
  set canSelectMany(e) {
    this._canSelectMany = e, this.update();
  }
  get canAcceptInBackground() {
    return this._canAcceptInBackground;
  }
  set canAcceptInBackground(e) {
    this._canAcceptInBackground = e;
  }
  get matchOnDescription() {
    return this._matchOnDescription;
  }
  set matchOnDescription(e) {
    this._matchOnDescription = e, this.update();
  }
  get matchOnDetail() {
    return this._matchOnDetail;
  }
  set matchOnDetail(e) {
    this._matchOnDetail = e, this.update();
  }
  get matchOnLabel() {
    return this._matchOnLabel;
  }
  set matchOnLabel(e) {
    this._matchOnLabel = e, this.update();
  }
  get matchOnLabelMode() {
    return this._matchOnLabelMode;
  }
  set matchOnLabelMode(e) {
    this._matchOnLabelMode = e, this.update();
  }
  get sortByLabel() {
    return this._sortByLabel;
  }
  set sortByLabel(e) {
    this._sortByLabel = e, this.update();
  }
  get keepScrollPosition() {
    return this._keepScrollPosition;
  }
  set keepScrollPosition(e) {
    this._keepScrollPosition = e;
  }
  get itemActivation() {
    return this._itemActivation;
  }
  set itemActivation(e) {
    this._itemActivation = e;
  }
  get activeItems() {
    return this._activeItems;
  }
  set activeItems(e) {
    this._activeItems = e, this.activeItemsUpdated = !0, this.update();
  }
  get selectedItems() {
    return this._selectedItems;
  }
  set selectedItems(e) {
    this._selectedItems = e, this.selectedItemsUpdated = !0, this.update();
  }
  get keyMods() {
    return this._quickNavigate ? fte : this.ui.keyMods;
  }
  get valueSelection() {
    const e = this.ui.inputBox.getSelection();
    if (e) return [e.start, e.end];
  }
  set valueSelection(e) {
    this._valueSelection = e, this.valueSelectionUpdated = !0, this.update();
  }
  get customButton() {
    return this._customButton;
  }
  set customButton(e) {
    this._customButton = e, this.update();
  }
  get customLabel() {
    return this._customButtonLabel;
  }
  set customLabel(e) {
    this._customButtonLabel = e, this.update();
  }
  get customHover() {
    return this._customButtonHover;
  }
  set customHover(e) {
    this._customButtonHover = e, this.update();
  }
  get ok() {
    return this._ok;
  }
  set ok(e) {
    this._ok = e, this.update();
  }
  get hideInput() {
    return !!this._hideInput;
  }
  set hideInput(e) {
    this._hideInput = e, this.update();
  }
  trySelectFirst() {
    this.canSelectMany || this.ui.list.focus(Hi.First);
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.inputBox.onDidChange(((e) => {
      this.doSetValue(e, !0);
    }))), this.visibleDisposables.add((this._hideInput ? this.ui.list : this.ui.inputBox).onKeyDown(((e) => {
      switch (e.keyCode) {
        case 18:
          (Je ? e.metaKey : e.altKey) ? this.ui.list.focus(Hi.NextSeparator) : this.ui.list.focus(Hi.Next), this.canSelectMany && this.ui.list.domFocus(), Ze(e, !0);
          break;
        case 16:
          (Je ? e.metaKey : e.altKey) ? this.ui.list.focus(Hi.PreviousSeparator) : this.ui.list.focus(Hi.Previous), this.canSelectMany && this.ui.list.domFocus(), Ze(e, !0);
          break;
        case 12:
          this.ui.list.focus(Hi.NextPage), this.canSelectMany && this.ui.list.domFocus(), Ze(e, !0);
          break;
        case 11:
          this.ui.list.focus(Hi.PreviousPage), this.canSelectMany && this.ui.list.domFocus(), Ze(e, !0);
          break;
        case 17:
          if (!this._canAcceptInBackground || !this.ui.inputBox.isSelectionAtEnd()) return;
          this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems), this.handleAccept(!0));
          break;
        case 14:
          !e.ctrlKey && !e.metaKey || e.shiftKey || e.altKey || (this.ui.list.focus(Hi.First), Ze(e, !0));
          break;
        case 13:
          !e.ctrlKey && !e.metaKey || e.shiftKey || e.altKey || (this.ui.list.focus(Hi.Last), Ze(e, !0));
      }
    }))), this.visibleDisposables.add(this.ui.onDidAccept((() => {
      this.canSelectMany ? this.ui.list.getCheckedElements().length || (this._selectedItems = [], this.onDidChangeSelectionEmitter.fire(this.selectedItems)) : this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems)), this.handleAccept(!1);
    }))), this.visibleDisposables.add(this.ui.onDidCustom((() => {
      this.onDidCustomEmitter.fire();
    }))), this.visibleDisposables.add(this.ui.list.onDidChangeFocus(((e) => {
      this.activeItemsUpdated || this.activeItemsToConfirm !== this._activeItems && ri(e, this._activeItems, ((t, i) => t === i)) || (this._activeItems = e, this.onDidChangeActiveEmitter.fire(e));
    }))), this.visibleDisposables.add(this.ui.list.onDidChangeSelection((({ items: e, event: t }) => {
      this.canSelectMany ? e.length && this.ui.list.setSelectedElements([]) : this.selectedItemsToConfirm !== this._selectedItems && ri(e, this._selectedItems, ((i, s) => i === s)) || (this._selectedItems = e, this.onDidChangeSelectionEmitter.fire(e), e.length && this.handleAccept(mR(t) && t.button === 1));
    }))), this.visibleDisposables.add(this.ui.list.onChangedCheckedElements(((e) => {
      this.canSelectMany && (this.selectedItemsToConfirm !== this._selectedItems && ri(e, this._selectedItems, ((t, i) => t === i)) || (this._selectedItems = e, this.onDidChangeSelectionEmitter.fire(e)));
    }))), this.visibleDisposables.add(this.ui.list.onButtonTriggered(((e) => this.onDidTriggerItemButtonEmitter.fire(e)))), this.visibleDisposables.add(this.ui.list.onSeparatorButtonTriggered(((e) => this.onDidTriggerSeparatorButtonEmitter.fire(e)))), this.visibleDisposables.add(this.registerQuickNavigation()), this.valueSelectionUpdated = !0), super.show();
  }
  handleAccept(e) {
    let t = !1;
    this.onWillAcceptEmitter.fire({ veto: () => t = !0 }), t || this.onDidAcceptEmitter.fire({ inBackground: e });
  }
  registerQuickNavigation() {
    return K(this.ui.container, ie.KEY_UP, ((e) => {
      if (this.canSelectMany || !this._quickNavigate) return;
      const t = new jt(e), i = t.keyCode;
      this._quickNavigate.keybindings.some(((s) => {
        const o = s.getChords();
        return !(o.length > 1) && (o[0].shiftKey && i === 4 ? !(t.ctrlKey || t.altKey || t.metaKey) : !(!o[0].altKey || i !== 6) || !(!o[0].ctrlKey || i !== 5) || !(!o[0].metaKey || i !== 57));
      })) && (this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems), this.handleAccept(!1)), this._quickNavigate = void 0);
    }));
  }
  update() {
    if (!this.visible) return;
    const e = this.keepScrollPosition ? this.scrollTop : 0, t = !!this.description, i = { title: !!this.title || !!this.step || !!this.buttons.length, description: t, checkAll: this.canSelectMany && !this._hideCheckAll, checkBox: this.canSelectMany, inputBox: !this._hideInput, progressBar: !this._hideInput || t, visibleCount: !0, count: this.canSelectMany && !this._hideCountBadge, ok: this.ok === "default" ? this.canSelectMany : this.ok, list: !0, message: !!this.validationMessage, customButton: this.customButton };
    this.ui.setVisibilities(i), super.update(), this.ui.inputBox.value !== this.value && (this.ui.inputBox.value = this.value), this.valueSelectionUpdated && (this.valueSelectionUpdated = !1, this.ui.inputBox.select(this._valueSelection && { start: this._valueSelection[0], end: this._valueSelection[1] })), this.ui.inputBox.placeholder !== (this.placeholder || "") && (this.ui.inputBox.placeholder = this.placeholder || "");
    let s = this.ariaLabel;
    if (!s && i.inputBox && (s = this.placeholder || Vv.DEFAULT_ARIA_LABEL, this.title && (s += ` - ${this.title}`)), this.ui.list.ariaLabel !== s && (this.ui.list.ariaLabel = s ?? null), this.ui.list.matchOnDescription = this.matchOnDescription, this.ui.list.matchOnDetail = this.matchOnDetail, this.ui.list.matchOnLabel = this.matchOnLabel, this.ui.list.matchOnLabelMode = this.matchOnLabelMode, this.ui.list.sortByLabel = this.sortByLabel, this.itemsUpdated) {
      this.itemsUpdated = !1;
      const o = this._activeItems;
      switch (this.ui.list.setElements(this.items), this.ui.list.filter(this.filterValue(this.ui.inputBox.value)), this.ui.checkAll.checked = this.ui.list.getAllVisibleChecked(), this.ui.visibleCount.setCount(this.ui.list.getVisibleCount()), this.ui.count.setCount(this.ui.list.getCheckedCount()), this._itemActivation) {
        case Kr.NONE:
          o.length > 0 && (this._activeItems = [], this.onDidChangeActiveEmitter.fire(this._activeItems)), this._itemActivation = Kr.FIRST;
          break;
        case Kr.SECOND:
          this.ui.list.focus(Hi.Second), this._itemActivation = Kr.FIRST;
          break;
        case Kr.LAST:
          this.ui.list.focus(Hi.Last), this._itemActivation = Kr.FIRST;
          break;
        default:
          this.trySelectFirst();
      }
    }
    this.ui.container.classList.contains("show-checkboxes") !== !!this.canSelectMany && (this.canSelectMany ? this.ui.list.clearFocus() : this.trySelectFirst()), this.activeItemsUpdated && (this.activeItemsUpdated = !1, this.activeItemsToConfirm = this._activeItems, this.ui.list.setFocusedElements(this.activeItems), this.activeItemsToConfirm === this._activeItems && (this.activeItemsToConfirm = null)), this.selectedItemsUpdated && (this.selectedItemsUpdated = !1, this.selectedItemsToConfirm = this._selectedItems, this.canSelectMany ? this.ui.list.setCheckedElements(this.selectedItems) : this.ui.list.setSelectedElements(this.selectedItems), this.selectedItemsToConfirm === this._selectedItems && (this.selectedItemsToConfirm = null)), this.ui.customButton.label = this.customLabel || "", this.ui.customButton.element.title = this.customHover || "", i.inputBox || (this.ui.list.domFocus(), this.canSelectMany && this.ui.list.focus(Hi.First)), this.keepScrollPosition && (this.scrollTop = e);
  }
}
Vv.DEFAULT_ARIA_LABEL = m(0, "Type to narrow down results.");
class kie extends B1 {
  constructor() {
    super(...arguments), this._value = "", this.valueSelectionUpdated = !0, this._password = !1, this.onDidValueChangeEmitter = this._register(new F()), this.onDidAcceptEmitter = this._register(new F()), this.onDidChangeValue = this.onDidValueChangeEmitter.event, this.onDidAccept = this.onDidAcceptEmitter.event;
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this._value = e || "", this.update();
  }
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(e) {
    this._placeholder = e, this.update();
  }
  get password() {
    return this._password;
  }
  set password(e) {
    this._password = e, this.update();
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.inputBox.onDidChange(((e) => {
      e !== this.value && (this._value = e, this.onDidValueChangeEmitter.fire(e));
    }))), this.visibleDisposables.add(this.ui.onDidAccept((() => this.onDidAcceptEmitter.fire()))), this.valueSelectionUpdated = !0), super.show();
  }
  update() {
    if (!this.visible) return;
    this.ui.container.classList.remove("hidden-input");
    const e = { title: !!this.title || !!this.step || !!this.buttons.length, description: !!this.description || !!this.step, inputBox: !0, message: !0, progressBar: !0 };
    this.ui.setVisibilities(e), super.update(), this.ui.inputBox.value !== this.value && (this.ui.inputBox.value = this.value), this.valueSelectionUpdated && (this.valueSelectionUpdated = !1, this.ui.inputBox.select(this._valueSelection && { start: this._valueSelection[0], end: this._valueSelection[1] })), this.ui.inputBox.placeholder !== (this.placeholder || "") && (this.ui.inputBox.placeholder = this.placeholder || ""), this.ui.inputBox.password !== this.password && (this.ui.inputBox.password = this.password);
  }
}
let _2 = class extends Sv {
  constructor(n, e) {
    super("element", !1, ((t) => this.getOverrideOptions(t)), n, e);
  }
  getOverrideOptions(n) {
    var e;
    return { persistence: { hideOnKeyDown: !1 }, appearance: { showHoverHint: (n.content instanceof HTMLElement ? (e = n.content.textContent) !== null && e !== void 0 ? e : "" : typeof n.content == "string" ? n.content : n.content.value).includes(`
`), skipFadeInAnimation: !0 } };
  }
};
_2 = Lie([dF(0, Ye), dF(1, gA)], _2), z.white.toString(), z.white.toString();
class Xy extends V {
  get onDidClick() {
    return this._onDidClick.event;
  }
  constructor(e, t) {
    super(), this._label = "", this._onDidClick = this._register(new F()), this._onDidEscape = this._register(new F()), this.options = t, this._element = document.createElement("a"), this._element.classList.add("monaco-button"), this._element.tabIndex = 0, this._element.setAttribute("role", "button"), this._element.classList.toggle("secondary", !!t.secondary);
    const i = t.secondary ? t.buttonSecondaryBackground : t.buttonBackground, s = t.secondary ? t.buttonSecondaryForeground : t.buttonForeground;
    this._element.style.color = s || "", this._element.style.backgroundColor = i || "", t.supportShortLabel && (this._labelShortElement = document.createElement("div"), this._labelShortElement.classList.add("monaco-button-label-short"), this._element.appendChild(this._labelShortElement), this._labelElement = document.createElement("div"), this._labelElement.classList.add("monaco-button-label"), this._element.appendChild(this._labelElement), this._element.classList.add("monaco-text-button-with-short-label")), typeof t.title == "string" && this.setTitle(t.title), typeof t.ariaLabel == "string" && this._element.setAttribute("aria-label", t.ariaLabel), e.appendChild(this._element), this._register(Bt.addTarget(this._element)), [ie.CLICK, Vt.Tap].forEach(((o) => {
      this._register(K(this._element, o, ((r) => {
        this.enabled ? this._onDidClick.fire(r) : Ze(r);
      })));
    })), this._register(K(this._element, ie.KEY_DOWN, ((o) => {
      const r = new jt(o);
      let a = !1;
      this.enabled && (r.equals(3) || r.equals(10)) ? (this._onDidClick.fire(o), a = !0) : r.equals(9) && (this._onDidEscape.fire(o), this._element.blur(), a = !0), a && Ze(r, !0);
    }))), this._register(K(this._element, ie.MOUSE_OVER, ((o) => {
      this._element.classList.contains("disabled") || this.updateBackground(!0);
    }))), this._register(K(this._element, ie.MOUSE_OUT, ((o) => {
      this.updateBackground(!1);
    }))), this.focusTracker = this._register(pa(this._element)), this._register(this.focusTracker.onDidFocus((() => {
      this.enabled && this.updateBackground(!0);
    }))), this._register(this.focusTracker.onDidBlur((() => {
      this.enabled && this.updateBackground(!1);
    })));
  }
  dispose() {
    super.dispose(), this._element.remove();
  }
  getContentElements(e) {
    const t = [];
    for (let i of tc(e)) if (typeof i == "string") {
      if (i = i.trim(), i === "") continue;
      const s = document.createElement("span");
      s.textContent = i, t.push(s);
    } else t.push(i);
    return t;
  }
  updateBackground(e) {
    let t;
    t = this.options.secondary ? e ? this.options.buttonSecondaryHoverBackground : this.options.buttonSecondaryBackground : e ? this.options.buttonHoverBackground : this.options.buttonBackground, t && (this._element.style.backgroundColor = t);
  }
  get element() {
    return this._element;
  }
  set label(e) {
    var t, i, s;
    if (this._label === e || da(this._label) && da(e) && ((i = this._label) === (s = e) || i && s && i.value === s.value && i.isTrusted === s.isTrusted && i.supportThemeIcons === s.supportThemeIcons && i.supportHtml === s.supportHtml && (i.baseUri === s.baseUri || i.baseUri && s.baseUri && XR(Ie.from(i.baseUri), Ie.from(s.baseUri))))) return;
    this._element.classList.add("monaco-text-button");
    const o = this.options.supportShortLabel ? this._labelElement : this._element;
    if (da(e)) {
      const a = vL(e, { inline: !0 });
      a.dispose();
      const l = (t = a.element.querySelector("p")) === null || t === void 0 ? void 0 : t.innerHTML;
      if (l) {
        const d = u8(l, { ADD_TAGS: ["b", "i", "u", "code", "span"], ALLOWED_ATTR: ["class"], RETURN_TRUSTED_TYPE: !0 });
        o.innerHTML = d;
      } else wn(o);
    } else this.options.supportIcons ? wn(o, ...this.getContentElements(e)) : o.textContent = e;
    let r = "";
    typeof this.options.title == "string" ? r = this.options.title : this.options.title && (r = WJ(e)), this.setTitle(r), typeof this.options.ariaLabel == "string" ? this._element.setAttribute("aria-label", this.options.ariaLabel) : this.options.ariaLabel && this._element.setAttribute("aria-label", r), this._label = e;
  }
  get label() {
    return this._label;
  }
  set icon(e) {
    this._element.classList.add(...Ee.asClassNameArray(e));
  }
  set enabled(e) {
    e ? (this._element.classList.remove("disabled"), this._element.setAttribute("aria-disabled", String(!1)), this._element.tabIndex = 0) : (this._element.classList.add("disabled"), this._element.setAttribute("aria-disabled", String(!0)));
  }
  get enabled() {
    return !this._element.classList.contains("disabled");
  }
  setTitle(e) {
    var t;
    this._hover || e === "" ? this._hover && this._hover.update(e) : this._hover = this._register(xr((t = this.options.hoverDelegate) !== null && t !== void 0 ? t : Bs("mouse"), this._element, e));
  }
}
class v2 {
  constructor(e, t, i) {
    this.options = t, this.styles = i, this.count = 0, this.element = Z(e, Q(".monaco-count-badge")), this.countFormat = this.options.countFormat || "{0}", this.titleFormat = this.options.titleFormat || "", this.setCount(this.options.count || 0);
  }
  setCount(e) {
    this.count = e, this.render();
  }
  setTitleFormat(e) {
    this.titleFormat = e, this.render();
  }
  render() {
    var e, t;
    this.element.textContent = sg(this.countFormat, this.count), this.element.title = sg(this.titleFormat, this.count), this.element.style.backgroundColor = (e = this.styles.badgeBackground) !== null && e !== void 0 ? e : "", this.element.style.color = (t = this.styles.badgeForeground) !== null && t !== void 0 ? t : "", this.styles.badgeBorder && (this.element.style.border = `1px solid ${this.styles.badgeBorder}`);
  }
}
const hF = "done", cF = "active", rx = "infinite", ax = "infinite-long-running", uF = "discrete";
class FL extends V {
  constructor(e, t) {
    super(), this.workedVal = 0, this.showDelayedScheduler = this._register(new Et((() => bo(this.element)), 0)), this.longRunningScheduler = this._register(new Et((() => this.infiniteLongRunning()), FL.LONG_RUNNING_INFINITE_THRESHOLD)), this.create(e, t);
  }
  create(e, t) {
    this.element = document.createElement("div"), this.element.classList.add("monaco-progress-container"), this.element.setAttribute("role", "progressbar"), this.element.setAttribute("aria-valuemin", "0"), e.appendChild(this.element), this.bit = document.createElement("div"), this.bit.classList.add("progress-bit"), this.bit.style.backgroundColor = t?.progressBarBackground || "#0E70C0", this.element.appendChild(this.bit);
  }
  off() {
    this.bit.style.width = "inherit", this.bit.style.opacity = "1", this.element.classList.remove(cF, rx, ax, uF), this.workedVal = 0, this.totalWork = void 0, this.longRunningScheduler.cancel();
  }
  stop() {
    return this.doDone(!1);
  }
  doDone(e) {
    return this.element.classList.add(hF), this.element.classList.contains(rx) ? (this.bit.style.opacity = "0", e ? setTimeout((() => this.off()), 200) : this.off()) : (this.bit.style.width = "inherit", e ? setTimeout((() => this.off()), 200) : this.off()), this;
  }
  infinite() {
    return this.bit.style.width = "2%", this.bit.style.opacity = "1", this.element.classList.remove(uF, hF, ax), this.element.classList.add(cF, rx), this.longRunningScheduler.schedule(), this;
  }
  infiniteLongRunning() {
    this.element.classList.add(ax);
  }
  getContainer() {
    return this.element;
  }
}
FL.LONG_RUNNING_INFINITE_THRESHOLD = 1e4;
const Die = Q;
class xie extends V {
  constructor(e, t, i) {
    super(), this.parent = e, this.onKeyDown = (o) => bi(this.findInput.inputBox.inputElement, ie.KEY_DOWN, o), this.onDidChange = (o) => this.findInput.onDidChange(o), this.container = Z(this.parent, Die(".quick-input-box")), this.findInput = this._register(new lV(this.container, void 0, { label: "", inputBoxStyles: t, toggleStyles: i }));
    const s = this.findInput.inputBox.inputElement;
    s.role = "combobox", s.ariaHasPopup = "menu", s.ariaAutoComplete = "list", s.ariaExpanded = "true";
  }
  get value() {
    return this.findInput.getValue();
  }
  set value(e) {
    this.findInput.setValue(e);
  }
  select(e = null) {
    this.findInput.inputBox.select(e);
  }
  getSelection() {
    return this.findInput.inputBox.getSelection();
  }
  isSelectionAtEnd() {
    return this.findInput.inputBox.isSelectionAtEnd();
  }
  get placeholder() {
    return this.findInput.inputBox.inputElement.getAttribute("placeholder") || "";
  }
  set placeholder(e) {
    this.findInput.inputBox.setPlaceHolder(e);
  }
  get password() {
    return this.findInput.inputBox.inputElement.type === "password";
  }
  set password(e) {
    this.findInput.inputBox.inputElement.type = e ? "password" : "text";
  }
  set enabled(e) {
    this.findInput.inputBox.inputElement.toggleAttribute("readonly", !e);
  }
  set toggles(e) {
    this.findInput.setAdditionalToggles(e);
  }
  setAttribute(e, t) {
    this.findInput.inputBox.inputElement.setAttribute(e, t);
  }
  showDecoration(e) {
    e === ki.Ignore ? this.findInput.clearMessage() : this.findInput.showMessage({ type: e === ki.Info ? 1 : e === ki.Warning ? 2 : 3, content: "" });
  }
  stylesForType(e) {
    return this.findInput.inputBox.stylesForType(e === ki.Info ? 1 : e === ki.Warning ? 2 : 3);
  }
  setFocus() {
    this.findInput.focus();
  }
  layout() {
    this.findInput.inputBox.layout();
  }
}
var b2, Nie = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, gF = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const Us = Q;
let JC = b2 = class extends V {
  get container() {
    return this._container;
  }
  constructor(n, e, t) {
    super(), this.options = n, this.layoutService = e, this.instantiationService = t, this.enabled = !0, this.onDidAcceptEmitter = this._register(new F()), this.onDidCustomEmitter = this._register(new F()), this.onDidTriggerButtonEmitter = this._register(new F()), this.keyMods = { ctrlCmd: !1, alt: !1 }, this.controller = null, this.onShowEmitter = this._register(new F()), this.onShow = this.onShowEmitter.event, this.onHideEmitter = this._register(new F()), this.onHide = this.onHideEmitter.event, this.idPrefix = n.idPrefix, this._container = n.container, this.styles = n.styles, this._register(se.runAndSubscribe(WS, (({ window: i, disposables: s }) => this.registerKeyModsListeners(i, s)), { window: It, disposables: this._store })), this._register(nj(((i) => {
      this.ui && ke(this.ui.container) === i && (this.reparentUI(this.layoutService.mainContainer), this.layout(this.layoutService.mainContainerDimension, this.layoutService.mainContainerOffset.quickPickTop));
    })));
  }
  registerKeyModsListeners(n, e) {
    const t = (i) => {
      this.keyMods.ctrlCmd = i.ctrlKey || i.metaKey, this.keyMods.alt = i.altKey;
    };
    for (const i of [ie.KEY_DOWN, ie.KEY_UP, ie.MOUSE_DOWN]) e.add(K(n, i, t, !0));
  }
  getUI(n) {
    if (this.ui) return n && ke(this._container) !== ke(this.layoutService.activeContainer) && (this.reparentUI(this.layoutService.activeContainer), this.layout(this.layoutService.activeContainerDimension, this.layoutService.activeContainerOffset.quickPickTop)), this.ui;
    const e = Z(this._container, Us(".quick-input-widget.show-file-icons"));
    e.tabIndex = -1, e.style.display = "none";
    const t = Lo(e), i = Z(e, Us(".quick-input-titlebar")), s = this._register(new sr(i, { hoverDelegate: this.options.hoverDelegate }));
    s.domNode.classList.add("quick-input-left-action-bar");
    const o = Z(i, Us(".quick-input-title")), r = this._register(new sr(i, { hoverDelegate: this.options.hoverDelegate }));
    r.domNode.classList.add("quick-input-right-action-bar");
    const a = Z(e, Us(".quick-input-header")), l = Z(a, Us("input.quick-input-check-all"));
    l.type = "checkbox", l.setAttribute("aria-label", m(0, "Toggle all checkboxes")), this._register(bi(l, ie.CHANGE, ((O) => {
      const H = l.checked;
      B.setAllVisibleChecked(H);
    }))), this._register(K(l, ie.CLICK, ((O) => {
      (O.x || O.y) && u.setFocus();
    })));
    const d = Z(a, Us(".quick-input-description")), h = Z(a, Us(".quick-input-and-message")), c = Z(h, Us(".quick-input-filter")), u = this._register(new xie(c, this.styles.inputBox, this.styles.toggle));
    u.setAttribute("aria-describedby", `${this.idPrefix}message`);
    const g = Z(c, Us(".quick-input-visible-count"));
    g.setAttribute("aria-live", "polite"), g.setAttribute("aria-atomic", "true");
    const p = new v2(g, { countFormat: m(0, "{0} Results") }, this.styles.countBadge), f = Z(c, Us(".quick-input-count"));
    f.setAttribute("aria-live", "polite");
    const _ = new v2(f, { countFormat: m(0, "{0} Selected") }, this.styles.countBadge), v = Z(a, Us(".quick-input-action")), b = this._register(new Xy(v, this.styles.button));
    b.label = m(0, "OK"), this._register(b.onDidClick(((O) => {
      this.onDidAcceptEmitter.fire();
    })));
    const C = Z(a, Us(".quick-input-action")), w = this._register(new Xy(C, { ...this.styles.button, supportIcons: !0 }));
    w.label = m(0, "Custom"), this._register(w.onDidClick(((O) => {
      this.onDidCustomEmitter.fire();
    })));
    const y = Z(h, Us(`#${this.idPrefix}message.quick-input-message`)), L = this._register(new FL(e, this.styles.progressBar));
    L.getContainer().classList.add("quick-input-progress");
    const k = Z(e, Us(".quick-input-html-widget"));
    k.tabIndex = -1;
    const N = Z(e, Us(".quick-input-description")), A = this.idPrefix + "list", B = this._register(this.instantiationService.createInstance(M_, e, this.options.hoverDelegate, this.options.linkOpenerDelegate, A));
    u.setAttribute("aria-controls", A), this._register(B.onDidChangeFocus((() => {
      var O;
      u.setAttribute("aria-activedescendant", (O = B.getActiveDescendant()) !== null && O !== void 0 ? O : "");
    }))), this._register(B.onChangedAllVisibleChecked(((O) => {
      l.checked = O;
    }))), this._register(B.onChangedVisibleCount(((O) => {
      p.setCount(O);
    }))), this._register(B.onChangedCheckedCount(((O) => {
      _.setCount(O);
    }))), this._register(B.onLeave((() => {
      setTimeout((() => {
        this.controller && (u.setFocus(), this.controller instanceof Vv && this.controller.canSelectMany && B.clearFocus());
      }), 0);
    })));
    const T = pa(e);
    return this._register(T), this._register(K(e, ie.FOCUS, ((O) => {
      gn(O.relatedTarget, e) || (this.previousFocusElement = O.relatedTarget instanceof HTMLElement ? O.relatedTarget : void 0);
    }), !0)), this._register(T.onDidBlur((() => {
      this.getUI().ignoreFocusOut || this.options.ignoreFocusOut() || this.hide(Jm.Blur), this.previousFocusElement = void 0;
    }))), this._register(K(e, ie.FOCUS, ((O) => {
      u.setFocus();
    }))), this._register(bi(e, ie.KEY_DOWN, ((O) => {
      if (!gn(O.target, k)) switch (O.keyCode) {
        case 3:
          Ze(O, !0), this.enabled && this.onDidAcceptEmitter.fire();
          break;
        case 9:
          Ze(O, !0), this.hide(Jm.Gesture);
          break;
        case 2:
          if (!O.altKey && !O.ctrlKey && !O.metaKey) {
            const H = [".quick-input-list .monaco-action-bar .always-visible", ".quick-input-list-entry:hover .monaco-action-bar", ".monaco-list-row.focused .monaco-action-bar"];
            if (e.classList.contains("show-checkboxes") ? H.push("input") : H.push("input[type=text]"), this.getUI().list.isDisplayed() && H.push(".monaco-list"), this.getUI().message && H.push(".quick-input-message a"), this.getUI().widget) {
              if (gn(O.target, this.getUI().widget)) break;
              H.push(".quick-input-html-widget");
            }
            const $ = e.querySelectorAll(H.join(", "));
            O.shiftKey && O.target === $[0] ? (Ze(O, !0), B.clearFocus()) : !O.shiftKey && gn(O.target, $[$.length - 1]) && (Ze(O, !0), $[0].focus());
          }
          break;
        case 10:
          O.ctrlKey && (Ze(O, !0), this.getUI().list.toggleHover());
      }
    }))), this.ui = { container: e, styleSheet: t, leftActionBar: s, titleBar: i, title: o, description1: N, description2: d, widget: k, rightActionBar: r, checkAll: l, inputContainer: h, filterContainer: c, inputBox: u, visibleCountContainer: g, visibleCount: p, countContainer: f, count: _, okContainer: v, ok: b, message: y, customButtonContainer: C, customButton: w, list: B, progressBar: L, onDidAccept: this.onDidAcceptEmitter.event, onDidCustom: this.onDidCustomEmitter.event, onDidTriggerButton: this.onDidTriggerButtonEmitter.event, ignoreFocusOut: !1, keyMods: this.keyMods, show: (O) => this.show(O), hide: () => this.hide(), setVisibilities: (O) => this.setVisibilities(O), setEnabled: (O) => this.setEnabled(O), setContextKey: (O) => this.options.setContextKey(O), linkOpenerDelegate: (O) => this.options.linkOpenerDelegate(O) }, this.updateStyles(), this.ui;
  }
  reparentUI(n) {
    this.ui && (this._container = n, Z(this._container, this.ui.container));
  }
  pick(n, e = {}, t = et.None) {
    return new Promise(((i, s) => {
      let o = (d) => {
        var h;
        o = i, (h = e.onKeyMods) === null || h === void 0 || h.call(e, r.keyMods), i(d);
      };
      if (t.isCancellationRequested) return void o(void 0);
      const r = this.createQuickPick();
      let a;
      const l = [r, r.onDidAccept((() => {
        if (r.canSelectMany) o(r.selectedItems.slice()), r.hide();
        else {
          const d = r.activeItems[0];
          d && (o(d), r.hide());
        }
      })), r.onDidChangeActive(((d) => {
        const h = d[0];
        h && e.onDidFocus && e.onDidFocus(h);
      })), r.onDidChangeSelection(((d) => {
        if (!r.canSelectMany) {
          const h = d[0];
          h && (o(h), r.hide());
        }
      })), r.onDidTriggerItemButton(((d) => e.onDidTriggerItemButton && e.onDidTriggerItemButton({ ...d, removeItem: () => {
        const h = r.items.indexOf(d.item);
        if (h !== -1) {
          const c = r.items.slice(), u = c.splice(h, 1), g = r.activeItems.filter(((f) => f !== u[0])), p = r.keepScrollPosition;
          r.keepScrollPosition = !0, r.items = c, g && (r.activeItems = g), r.keepScrollPosition = p;
        }
      } }))), r.onDidTriggerSeparatorButton(((d) => {
        var h;
        return (h = e.onDidTriggerSeparatorButton) === null || h === void 0 ? void 0 : h.call(e, d);
      })), r.onDidChangeValue(((d) => {
        !a || d || r.activeItems.length === 1 && r.activeItems[0] === a || (r.activeItems = [a]);
      })), t.onCancellationRequested((() => {
        r.hide();
      })), r.onDidHide((() => {
        Ht(l), o(void 0);
      }))];
      r.title = e.title, r.canSelectMany = !!e.canPickMany, r.placeholder = e.placeHolder, r.ignoreFocusOut = !!e.ignoreFocusLost, r.matchOnDescription = !!e.matchOnDescription, r.matchOnDetail = !!e.matchOnDetail, r.matchOnLabel = e.matchOnLabel === void 0 || e.matchOnLabel, r.quickNavigate = e.quickNavigate, r.hideInput = !!e.hideInput, r.contextKey = e.contextKey, r.busy = !0, Promise.all([n, e.activeItem]).then((([d, h]) => {
        a = h, r.busy = !1, r.items = d, r.canSelectMany && (r.selectedItems = d.filter(((c) => c.type !== "separator" && c.picked))), a && (r.activeItems = [a]);
      })), r.show(), Promise.resolve(n).then(void 0, ((d) => {
        s(d), r.hide();
      }));
    }));
  }
  createQuickPick() {
    const n = this.getUI(!0);
    return new Vv(n);
  }
  createInputBox() {
    const n = this.getUI(!0);
    return new kie(n);
  }
  show(n) {
    const e = this.getUI(!0);
    this.onShowEmitter.fire();
    const t = this.controller;
    this.controller = n, t?.didHide(), this.setEnabled(!0), e.leftActionBar.clear(), e.title.textContent = "", e.description1.textContent = "", e.description2.textContent = "", wn(e.widget), e.rightActionBar.clear(), e.checkAll.checked = !1, e.inputBox.placeholder = "", e.inputBox.password = !1, e.inputBox.showDecoration(ki.Ignore), e.visibleCount.setCount(0), e.count.setCount(0), wn(e.message), e.progressBar.stop(), e.list.setElements([]), e.list.matchOnDescription = !1, e.list.matchOnDetail = !1, e.list.matchOnLabel = !0, e.list.sortByLabel = !0, e.ignoreFocusOut = !1, e.inputBox.toggles = void 0;
    const i = this.options.backKeybindingLabel();
    f2.tooltip = i ? m(0, "Back ({0})", i) : m(0, "Back"), e.container.style.display = "", this.updateLayout(), e.inputBox.setFocus();
  }
  isVisible() {
    return !!this.ui && this.ui.container.style.display !== "none";
  }
  setVisibilities(n) {
    const e = this.getUI();
    e.title.style.display = n.title ? "" : "none", e.description1.style.display = n.description && (n.inputBox || n.checkAll) ? "" : "none", e.description2.style.display = !n.description || n.inputBox || n.checkAll ? "none" : "", e.checkAll.style.display = n.checkAll ? "" : "none", e.inputContainer.style.display = n.inputBox ? "" : "none", e.filterContainer.style.display = n.inputBox ? "" : "none", e.visibleCountContainer.style.display = n.visibleCount ? "" : "none", e.countContainer.style.display = n.count ? "" : "none", e.okContainer.style.display = n.ok ? "" : "none", e.customButtonContainer.style.display = n.customButton ? "" : "none", e.message.style.display = n.message ? "" : "none", e.progressBar.getContainer().style.display = n.progressBar ? "" : "none", e.list.display(!!n.list), e.container.classList.toggle("show-checkboxes", !!n.checkBox), e.container.classList.toggle("hidden-input", !n.inputBox && !n.description), this.updateLayout();
  }
  setEnabled(n) {
    if (n !== this.enabled) {
      this.enabled = n;
      for (const e of this.getUI().leftActionBar.viewItems) e.action.enabled = n;
      for (const e of this.getUI().rightActionBar.viewItems) e.action.enabled = n;
      this.getUI().checkAll.disabled = !n, this.getUI().inputBox.enabled = n, this.getUI().ok.enabled = n, this.getUI().list.enabled = n;
    }
  }
  hide(n) {
    var e, t;
    const i = this.controller;
    if (!i) return;
    i.willHide(n);
    const s = (e = this.ui) === null || e === void 0 ? void 0 : e.container, o = s && !C8(s);
    if (this.controller = null, this.onHideEmitter.fire(), s && (s.style.display = "none"), !o) {
      let r = this.previousFocusElement;
      for (; r && !r.offsetParent; ) r = (t = r.parentElement) !== null && t !== void 0 ? t : void 0;
      r?.offsetParent ? (r.focus(), this.previousFocusElement = void 0) : this.options.returnFocus();
    }
    i.didHide(n);
  }
  layout(n, e) {
    this.dimension = n, this.titleBarOffset = e, this.updateLayout();
  }
  updateLayout() {
    if (this.ui && this.isVisible()) {
      this.ui.container.style.top = `${this.titleBarOffset}px`;
      const n = this.ui.container.style, e = Math.min(0.62 * this.dimension.width, b2.MAX_WIDTH);
      n.width = e + "px", n.marginLeft = "-" + e / 2 + "px", this.ui.inputBox.layout(), this.ui.list.layout(this.dimension && 0.4 * this.dimension.height);
    }
  }
  applyStyles(n) {
    this.styles = n, this.updateStyles();
  }
  updateStyles() {
    if (this.ui) {
      const { quickInputTitleBackground: n, quickInputBackground: e, quickInputForeground: t, widgetBorder: i, widgetShadow: s } = this.styles.widget;
      this.ui.titleBar.style.backgroundColor = n ?? "", this.ui.container.style.backgroundColor = e ?? "", this.ui.container.style.color = t ?? "", this.ui.container.style.border = i ? `1px solid ${i}` : "", this.ui.container.style.boxShadow = s ? `0 0 8px 2px ${s}` : "", this.ui.list.style(this.styles.list);
      const o = [];
      this.styles.pickerGroup.pickerGroupBorder && o.push(`.quick-input-list .quick-input-list-entry { border-top-color:  ${this.styles.pickerGroup.pickerGroupBorder}; }`), this.styles.pickerGroup.pickerGroupForeground && o.push(`.quick-input-list .quick-input-list-separator { color:  ${this.styles.pickerGroup.pickerGroupForeground}; }`), this.styles.pickerGroup.pickerGroupForeground && o.push(".quick-input-list .quick-input-list-separator-as-item { color: var(--vscode-descriptionForeground); }"), (this.styles.keybindingLabel.keybindingLabelBackground || this.styles.keybindingLabel.keybindingLabelBorder || this.styles.keybindingLabel.keybindingLabelBottomBorder || this.styles.keybindingLabel.keybindingLabelShadow || this.styles.keybindingLabel.keybindingLabelForeground) && (o.push(".quick-input-list .monaco-keybinding > .monaco-keybinding-key {"), this.styles.keybindingLabel.keybindingLabelBackground && o.push(`background-color: ${this.styles.keybindingLabel.keybindingLabelBackground};`), this.styles.keybindingLabel.keybindingLabelBorder && o.push(`border-color: ${this.styles.keybindingLabel.keybindingLabelBorder};`), this.styles.keybindingLabel.keybindingLabelBottomBorder && o.push(`border-bottom-color: ${this.styles.keybindingLabel.keybindingLabelBottomBorder};`), this.styles.keybindingLabel.keybindingLabelShadow && o.push(`box-shadow: inset 0 -1px 0 ${this.styles.keybindingLabel.keybindingLabelShadow};`), this.styles.keybindingLabel.keybindingLabelForeground && o.push(`color: ${this.styles.keybindingLabel.keybindingLabelForeground};`), o.push("}"));
      const r = o.join(`
`);
      r !== this.ui.styleSheet.textContent && (this.ui.styleSheet.textContent = r);
    }
  }
};
JC.MAX_WIDTH = 600, JC = b2 = Nie([gF(1, Ac), gF(2, Se)], JC);
var Eie = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, qf = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let C2 = class extends uZ {
  get controller() {
    return this._controller || (this._controller = this._register(this.createController())), this._controller;
  }
  get hasController() {
    return !!this._controller;
  }
  get quickAccess() {
    return this._quickAccess || (this._quickAccess = this._register(this.instantiationService.createInstance(o2))), this._quickAccess;
  }
  constructor(n, e, t, i, s) {
    super(t), this.instantiationService = n, this.contextKeyService = e, this.layoutService = i, this.configurationService = s, this._onShow = this._register(new F()), this._onHide = this._register(new F()), this.contexts = /* @__PURE__ */ new Map();
  }
  createController(n = this.layoutService, e) {
    const t = { idPrefix: "quickInput_", container: n.activeContainer, ignoreFocusOut: () => !1, backKeybindingLabel: () => {
    }, setContextKey: (s) => this.setContextKey(s), linkOpenerDelegate: (s) => {
      this.instantiationService.invokeFunction(((o) => {
        o.get(Fs).open(s, { allowCommands: !0, fromUserGesture: !0 });
      }));
    }, returnFocus: () => n.focus(), styles: this.computeStyles(), hoverDelegate: this._register(this.instantiationService.createInstance(_2)) }, i = this._register(this.instantiationService.createInstance(JC, { ...t, ...e }));
    return i.layout(n.activeContainerDimension, n.activeContainerOffset.quickPickTop), this._register(n.onDidLayoutActiveContainer(((s) => {
      ke(n.activeContainer) === ke(i.container) && i.layout(s, n.activeContainerOffset.quickPickTop);
    }))), this._register(n.onDidChangeActiveContainer((() => {
      i.isVisible() || i.layout(n.activeContainerDimension, n.activeContainerOffset.quickPickTop);
    }))), this._register(i.onShow((() => {
      this.resetContextKeys(), this._onShow.fire();
    }))), this._register(i.onHide((() => {
      this.resetContextKeys(), this._onHide.fire();
    }))), i;
  }
  setContextKey(n) {
    let e;
    n && (e = this.contexts.get(n), e || (e = new ae(n, !1).bindTo(this.contextKeyService), this.contexts.set(n, e))), e && e.get() || (this.resetContextKeys(), e?.set(!0));
  }
  resetContextKeys() {
    this.contexts.forEach(((n) => {
      n.get() && n.reset();
    }));
  }
  pick(n, e = {}, t = et.None) {
    return this.controller.pick(n, e, t);
  }
  createQuickPick() {
    return this.controller.createQuickPick();
  }
  createInputBox() {
    return this.controller.createInputBox();
  }
  updateStyles() {
    this.hasController && this.controller.applyStyles(this.computeStyles());
  }
  computeStyles() {
    return { widget: { quickInputBackground: de(V4), quickInputForeground: de(IG), quickInputTitleBackground: de(MG), widgetBorder: de(cB), widgetShadow: de(gd) }, inputBox: Oy, toggle: Py, countBadge: XW, button: nte, progressBar: ste, keybindingLabel: ite, list: Mg({ listBackground: V4, listFocusBackground: Ah, listFocusForeground: Rh, listInactiveFocusForeground: Rh, listInactiveSelectionIconForeground: Rp, listInactiveFocusBackground: Ah, listFocusOutline: Zt, listInactiveFocusOutline: Zt }), pickerGroup: { pickerGroupBorder: de(TG), pickerGroupForeground: de(_B) } };
  }
};
C2 = Eie([qf(0, Se), qf(1, Te), qf(2, Yi), qf(3, Ac), qf(4, Ye)], C2);
var NV = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, yu = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let w2 = class extends C2 {
  constructor(n, e, t, i, s, o) {
    super(e, t, i, new SI(n.getContainerDomNode(), s), o), this.host = void 0;
    const r = nf.get(n);
    if (r) {
      const a = r.widget;
      this.host = { _serviceBrand: void 0, get mainContainer() {
        return a.getDomNode();
      }, getContainer: () => a.getDomNode(), whenContainerStylesLoaded() {
      }, get containers() {
        return [a.getDomNode()];
      }, get activeContainer() {
        return a.getDomNode();
      }, get mainContainerDimension() {
        return n.getLayoutInfo();
      }, get activeContainerDimension() {
        return n.getLayoutInfo();
      }, get onDidLayoutMainContainer() {
        return n.onDidLayoutChange;
      }, get onDidLayoutActiveContainer() {
        return n.onDidLayoutChange;
      }, get onDidLayoutContainer() {
        return se.map(n.onDidLayoutChange, ((l) => ({ container: a.getDomNode(), dimension: l })));
      }, get onDidChangeActiveContainer() {
        return se.None;
      }, get onDidAddContainer() {
        return se.None;
      }, get mainContainerOffset() {
        return { top: 0, quickPickTop: 0 };
      }, get activeContainerOffset() {
        return { top: 0, quickPickTop: 0 };
      }, focus: () => n.focus() };
    } else this.host = void 0;
  }
  createController() {
    return super.createController(this.host);
  }
};
w2 = NV([yu(1, Se), yu(2, Te), yu(3, Yi), yu(4, mt), yu(5, Ye)], w2);
let y2 = class {
  get activeService() {
    const n = this.codeEditorService.getFocusedCodeEditor();
    if (!n) throw new Error("Quick input service needs a focused editor to work.");
    let e = this.mapEditorToService.get(n);
    if (!e) {
      const t = e = this.instantiationService.createInstance(w2, n);
      this.mapEditorToService.set(n, e), pc(n.onDidDispose)((() => {
        t.dispose(), this.mapEditorToService.delete(n);
      }));
    }
    return e;
  }
  get quickAccess() {
    return this.activeService.quickAccess;
  }
  constructor(n, e) {
    this.instantiationService = n, this.codeEditorService = e, this.mapEditorToService = /* @__PURE__ */ new Map();
  }
  pick(n, e = {}, t = et.None) {
    return this.activeService.pick(n, e, t);
  }
  createQuickPick() {
    return this.activeService.createQuickPick();
  }
  createInputBox() {
    return this.activeService.createInputBox();
  }
};
y2 = NV([yu(0, Se), yu(1, mt)], y2);
class nf {
  static get(e) {
    return e.getContribution(nf.ID);
  }
  constructor(e) {
    this.editor = e, this.widget = new BL(this.editor);
  }
  dispose() {
    this.widget.dispose();
  }
}
nf.ID = "editor.controller.quickInput";
class BL {
  constructor(e) {
    this.codeEditor = e, this.domNode = document.createElement("div"), this.codeEditor.addOverlayWidget(this);
  }
  getId() {
    return BL.ID;
  }
  getDomNode() {
    return this.domNode;
  }
  getPosition() {
    return { preference: 2 };
  }
  dispose() {
    this.codeEditor.removeOverlayWidget(this);
  }
}
BL.ID = "editor.contrib.quickInputWidget", ft(nf.ID, nf, 4);
class Iie {
  constructor(e, t, i, s, o) {
    this._parsedThemeRuleBrand = void 0, this.token = e, this.index = t, this.fontStyle = i, this.foreground = s, this.background = o;
  }
}
const Mie = /^#?([0-9A-Fa-f]{6})([0-9A-Fa-f]{2})?$/;
class Tie {
  constructor() {
    this._lastColorId = 0, this._id2color = [], this._color2id = /* @__PURE__ */ new Map();
  }
  getId(e) {
    if (e === null) return 0;
    const t = e.match(Mie);
    if (!t) throw new Error("Illegal value for token color: " + e);
    e = t[1].toUpperCase();
    let i = this._color2id.get(e);
    return i || (i = ++this._lastColorId, this._color2id.set(e, i), this._id2color[i] = z.fromHex("#" + e), i);
  }
  getColorMap() {
    return this._id2color.slice(0);
  }
}
class KA {
  static createFromRawTokenTheme(e, t) {
    return this.createFromParsedTokenTheme((function(i) {
      if (!i || !Array.isArray(i)) return [];
      const s = [];
      let o = 0;
      for (let r = 0, a = i.length; r < a; r++) {
        const l = i[r];
        let d = -1;
        if (typeof l.fontStyle == "string") {
          d = 0;
          const u = l.fontStyle.split(" ");
          for (let g = 0, p = u.length; g < p; g++) switch (u[g]) {
            case "italic":
              d |= 1;
              break;
            case "bold":
              d |= 2;
              break;
            case "underline":
              d |= 4;
              break;
            case "strikethrough":
              d |= 8;
          }
        }
        let h = null;
        typeof l.foreground == "string" && (h = l.foreground);
        let c = null;
        typeof l.background == "string" && (c = l.background), s[o++] = new Iie(l.token || "", r, d, h, c);
      }
      return s;
    })(e), t);
  }
  static createFromParsedTokenTheme(e, t) {
    return (function(i, s) {
      i.sort(((g, p) => {
        const f = (function(_, v) {
          return _ < v ? -1 : _ > v ? 1 : 0;
        })(g.token, p.token);
        return f !== 0 ? f : g.index - p.index;
      }));
      let o = 0, r = "000000", a = "ffffff";
      for (; i.length >= 1 && i[0].token === ""; ) {
        const g = i.shift();
        g.fontStyle !== -1 && (o = g.fontStyle), g.foreground !== null && (r = g.foreground), g.background !== null && (a = g.background);
      }
      const l = new Tie();
      for (const g of s) l.getId(g);
      const d = l.getId(r), h = l.getId(a), c = new jA(o, d, h), u = new qA(c);
      for (let g = 0, p = i.length; g < p; g++) {
        const f = i[g];
        u.insert(f.token, f.fontStyle, l.getId(f.foreground), l.getId(f.background));
      }
      return new KA(l, u);
    })(e, t);
  }
  constructor(e, t) {
    this._colorMap = e, this._root = t, this._cache = /* @__PURE__ */ new Map();
  }
  getColorMap() {
    return this._colorMap.getColorMap();
  }
  _match(e) {
    return this._root.match(e);
  }
  match(e, t) {
    let i = this._cache.get(t);
    if (i === void 0) {
      const s = this._match(t), o = (function(r) {
        const a = r.match(Rie);
        if (!a) return 0;
        switch (a[1]) {
          case "comment":
            return 1;
          case "string":
            return 2;
          case "regex":
          case "regexp":
            return 3;
        }
        throw new Error("Unexpected match for standard token type!");
      })(t);
      i = (s.metadata | o << 8) >>> 0, this._cache.set(t, i);
    }
    return (i | e) >>> 0;
  }
}
const Rie = /\b(comment|string|regex|regexp)\b/;
class jA {
  constructor(e, t, i) {
    this._themeTrieElementRuleBrand = void 0, this._fontStyle = e, this._foreground = t, this._background = i, this.metadata = (this._fontStyle << 11 | this._foreground << 15 | this._background << 24) >>> 0;
  }
  clone() {
    return new jA(this._fontStyle, this._foreground, this._background);
  }
  acceptOverwrite(e, t, i) {
    e !== -1 && (this._fontStyle = e), t !== 0 && (this._foreground = t), i !== 0 && (this._background = i), this.metadata = (this._fontStyle << 11 | this._foreground << 15 | this._background << 24) >>> 0;
  }
}
class qA {
  constructor(e) {
    this._themeTrieElementBrand = void 0, this._mainRule = e, this._children = /* @__PURE__ */ new Map();
  }
  match(e) {
    if (e === "") return this._mainRule;
    const t = e.indexOf(".");
    let i, s;
    t === -1 ? (i = e, s = "") : (i = e.substring(0, t), s = e.substring(t + 1));
    const o = this._children.get(i);
    return o !== void 0 ? o.match(s) : this._mainRule;
  }
  insert(e, t, i, s) {
    if (e === "") return void this._mainRule.acceptOverwrite(t, i, s);
    const o = e.indexOf(".");
    let r, a;
    o === -1 ? (r = e, a = "") : (r = e.substring(0, o), a = e.substring(o + 1));
    let l = this._children.get(r);
    l === void 0 && (l = new qA(this._mainRule.clone()), this._children.set(r, l)), l.insert(a, t, i, s);
  }
}
const Aie = { base: "vs", inherit: !1, rules: [{ token: "", foreground: "000000", background: "fffffe" }, { token: "invalid", foreground: "cd3131" }, { token: "emphasis", fontStyle: "italic" }, { token: "strong", fontStyle: "bold" }, { token: "variable", foreground: "001188" }, { token: "variable.predefined", foreground: "4864AA" }, { token: "constant", foreground: "dd0000" }, { token: "comment", foreground: "008000" }, { token: "number", foreground: "098658" }, { token: "number.hex", foreground: "3030c0" }, { token: "regexp", foreground: "800000" }, { token: "annotation", foreground: "808080" }, { token: "type", foreground: "008080" }, { token: "delimiter", foreground: "000000" }, { token: "delimiter.html", foreground: "383838" }, { token: "delimiter.xml", foreground: "0000FF" }, { token: "tag", foreground: "800000" }, { token: "tag.id.pug", foreground: "4F76AC" }, { token: "tag.class.pug", foreground: "4F76AC" }, { token: "meta.scss", foreground: "800000" }, { token: "metatag", foreground: "e00000" }, { token: "metatag.content.html", foreground: "FF0000" }, { token: "metatag.html", foreground: "808080" }, { token: "metatag.xml", foreground: "808080" }, { token: "metatag.php", fontStyle: "bold" }, { token: "key", foreground: "863B00" }, { token: "string.key.json", foreground: "A31515" }, { token: "string.value.json", foreground: "0451A5" }, { token: "attribute.name", foreground: "FF0000" }, { token: "attribute.value", foreground: "0451A5" }, { token: "attribute.value.number", foreground: "098658" }, { token: "attribute.value.unit", foreground: "098658" }, { token: "attribute.value.html", foreground: "0000FF" }, { token: "attribute.value.xml", foreground: "0000FF" }, { token: "string", foreground: "A31515" }, { token: "string.html", foreground: "0000FF" }, { token: "string.sql", foreground: "FF0000" }, { token: "string.yaml", foreground: "0451A5" }, { token: "keyword", foreground: "0000FF" }, { token: "keyword.json", foreground: "0451A5" }, { token: "keyword.flow", foreground: "AF00DB" }, { token: "keyword.flow.scss", foreground: "0000FF" }, { token: "operator.scss", foreground: "666666" }, { token: "operator.sql", foreground: "778899" }, { token: "operator.swift", foreground: "666666" }, { token: "predefined.sql", foreground: "C700C7" }], colors: { [sn]: "#FFFFFE", [Go]: "#000000", [dB]: "#E5EBF1", [L1]: "#D3D3D3", [k1]: "#939393", [PR]: "#ADD6FF4D" } }, Pie = { base: "vs-dark", inherit: !1, rules: [{ token: "", foreground: "D4D4D4", background: "1E1E1E" }, { token: "invalid", foreground: "f44747" }, { token: "emphasis", fontStyle: "italic" }, { token: "strong", fontStyle: "bold" }, { token: "variable", foreground: "74B0DF" }, { token: "variable.predefined", foreground: "4864AA" }, { token: "variable.parameter", foreground: "9CDCFE" }, { token: "constant", foreground: "569CD6" }, { token: "comment", foreground: "608B4E" }, { token: "number", foreground: "B5CEA8" }, { token: "number.hex", foreground: "5BB498" }, { token: "regexp", foreground: "B46695" }, { token: "annotation", foreground: "cc6666" }, { token: "type", foreground: "3DC9B0" }, { token: "delimiter", foreground: "DCDCDC" }, { token: "delimiter.html", foreground: "808080" }, { token: "delimiter.xml", foreground: "808080" }, { token: "tag", foreground: "569CD6" }, { token: "tag.id.pug", foreground: "4F76AC" }, { token: "tag.class.pug", foreground: "4F76AC" }, { token: "meta.scss", foreground: "A79873" }, { token: "meta.tag", foreground: "CE9178" }, { token: "metatag", foreground: "DD6A6F" }, { token: "metatag.content.html", foreground: "9CDCFE" }, { token: "metatag.html", foreground: "569CD6" }, { token: "metatag.xml", foreground: "569CD6" }, { token: "metatag.php", fontStyle: "bold" }, { token: "key", foreground: "9CDCFE" }, { token: "string.key.json", foreground: "9CDCFE" }, { token: "string.value.json", foreground: "CE9178" }, { token: "attribute.name", foreground: "9CDCFE" }, { token: "attribute.value", foreground: "CE9178" }, { token: "attribute.value.number.css", foreground: "B5CEA8" }, { token: "attribute.value.unit.css", foreground: "B5CEA8" }, { token: "attribute.value.hex.css", foreground: "D4D4D4" }, { token: "string", foreground: "CE9178" }, { token: "string.sql", foreground: "FF0000" }, { token: "keyword", foreground: "569CD6" }, { token: "keyword.flow", foreground: "C586C0" }, { token: "keyword.json", foreground: "CE9178" }, { token: "keyword.flow.scss", foreground: "569CD6" }, { token: "operator.scss", foreground: "909090" }, { token: "operator.sql", foreground: "778899" }, { token: "operator.swift", foreground: "909090" }, { token: "predefined.sql", foreground: "FF00FF" }], colors: { [sn]: "#1E1E1E", [Go]: "#D4D4D4", [dB]: "#3A3D41", [L1]: "#404040", [k1]: "#707070", [PR]: "#ADD6FF26" } }, Oie = { base: "hc-black", inherit: !1, rules: [{ token: "", foreground: "FFFFFF", background: "000000" }, { token: "invalid", foreground: "f44747" }, { token: "emphasis", fontStyle: "italic" }, { token: "strong", fontStyle: "bold" }, { token: "variable", foreground: "1AEBFF" }, { token: "variable.parameter", foreground: "9CDCFE" }, { token: "constant", foreground: "569CD6" }, { token: "comment", foreground: "608B4E" }, { token: "number", foreground: "FFFFFF" }, { token: "regexp", foreground: "C0C0C0" }, { token: "annotation", foreground: "569CD6" }, { token: "type", foreground: "3DC9B0" }, { token: "delimiter", foreground: "FFFF00" }, { token: "delimiter.html", foreground: "FFFF00" }, { token: "tag", foreground: "569CD6" }, { token: "tag.id.pug", foreground: "4F76AC" }, { token: "tag.class.pug", foreground: "4F76AC" }, { token: "meta", foreground: "D4D4D4" }, { token: "meta.tag", foreground: "CE9178" }, { token: "metatag", foreground: "569CD6" }, { token: "metatag.content.html", foreground: "1AEBFF" }, { token: "metatag.html", foreground: "569CD6" }, { token: "metatag.xml", foreground: "569CD6" }, { token: "metatag.php", fontStyle: "bold" }, { token: "key", foreground: "9CDCFE" }, { token: "string.key", foreground: "9CDCFE" }, { token: "string.value", foreground: "CE9178" }, { token: "attribute.name", foreground: "569CD6" }, { token: "attribute.value", foreground: "3FF23F" }, { token: "string", foreground: "CE9178" }, { token: "string.sql", foreground: "FF0000" }, { token: "keyword", foreground: "569CD6" }, { token: "keyword.flow", foreground: "C586C0" }, { token: "operator.sql", foreground: "778899" }, { token: "operator.swift", foreground: "909090" }, { token: "predefined.sql", foreground: "FF00FF" }], colors: { [sn]: "#000000", [Go]: "#FFFFFF", [L1]: "#FFFFFF", [k1]: "#FFFFFF" } }, Fie = { base: "hc-light", inherit: !1, rules: [{ token: "", foreground: "292929", background: "FFFFFF" }, { token: "invalid", foreground: "B5200D" }, { token: "emphasis", fontStyle: "italic" }, { token: "strong", fontStyle: "bold" }, { token: "variable", foreground: "264F70" }, { token: "variable.predefined", foreground: "4864AA" }, { token: "constant", foreground: "dd0000" }, { token: "comment", foreground: "008000" }, { token: "number", foreground: "098658" }, { token: "number.hex", foreground: "3030c0" }, { token: "regexp", foreground: "800000" }, { token: "annotation", foreground: "808080" }, { token: "type", foreground: "008080" }, { token: "delimiter", foreground: "000000" }, { token: "delimiter.html", foreground: "383838" }, { token: "tag", foreground: "800000" }, { token: "tag.id.pug", foreground: "4F76AC" }, { token: "tag.class.pug", foreground: "4F76AC" }, { token: "meta.scss", foreground: "800000" }, { token: "metatag", foreground: "e00000" }, { token: "metatag.content.html", foreground: "B5200D" }, { token: "metatag.html", foreground: "808080" }, { token: "metatag.xml", foreground: "808080" }, { token: "metatag.php", fontStyle: "bold" }, { token: "key", foreground: "863B00" }, { token: "string.key.json", foreground: "A31515" }, { token: "string.value.json", foreground: "0451A5" }, { token: "attribute.name", foreground: "264F78" }, { token: "attribute.value", foreground: "0451A5" }, { token: "string", foreground: "A31515" }, { token: "string.sql", foreground: "B5200D" }, { token: "keyword", foreground: "0000FF" }, { token: "keyword.flow", foreground: "AF00DB" }, { token: "operator.sql", foreground: "778899" }, { token: "operator.swift", foreground: "666666" }, { token: "predefined.sql", foreground: "C700C7" }], colors: { [sn]: "#FFFFFF", [Go]: "#292929", [L1]: "#292929", [k1]: "#292929" } };
var pF, mF;
(function(n) {
  n.getDefinition = function(e, t) {
    let i = e.defaults;
    for (; Ee.isThemeIcon(i); ) {
      const s = fg.getIcon(i.id);
      if (!s) return;
      i = s.defaults;
    }
    return i;
  };
})(pF || (pF = {})), (function(n) {
  n.toJSONObject = function(e) {
    return { weight: e.weight, style: e.style, src: e.src.map(((t) => ({ format: t.format, location: t.location.toString() }))) };
  }, n.fromJSONObject = function(e) {
    const t = (i) => ps(i) ? i : void 0;
    if (e && Array.isArray(e.src) && e.src.every(((i) => ps(i.format) && ps(i.location)))) return { weight: t(e.weight), style: t(e.style), src: e.src.map(((i) => ({ format: i.format, location: Ie.parse(i.location) }))) };
  };
})(mF || (mF = {}));
const fg = new class {
  constructor() {
    this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this.iconSchema = { definitions: { icons: { type: "object", properties: { fontId: { type: "string", description: m(0, "The id of the font to use. If not set, the font that is defined first is used.") }, fontCharacter: { type: "string", description: m(0, "The font character associated with the icon definition.") } }, additionalProperties: !1, defaultSnippets: [{ body: { fontCharacter: "\\\\e030" } }] } }, type: "object", properties: {} }, this.iconReferenceSchema = { type: "string", pattern: `^${Ee.iconNameExpression}$`, enum: [], enumDescriptions: [] }, this.iconsById = {}, this.iconFontsById = {};
  }
  registerIcon(n, e, t, i) {
    const s = this.iconsById[n];
    if (s) {
      if (t && !s.description) {
        s.description = t, this.iconSchema.properties[n].markdownDescription = `${t} $(${n})`;
        const a = this.iconReferenceSchema.enum.indexOf(n);
        a !== -1 && (this.iconReferenceSchema.enumDescriptions[a] = t), this._onDidChange.fire();
      }
      return s;
    }
    const o = { id: n, description: t, defaults: e, deprecationMessage: i };
    this.iconsById[n] = o;
    const r = { $ref: "#/definitions/icons" };
    return i && (r.deprecationMessage = i), t && (r.markdownDescription = `${t}: $(${n})`), this.iconSchema.properties[n] = r, this.iconReferenceSchema.enum.push(n), this.iconReferenceSchema.enumDescriptions.push(t || ""), this._onDidChange.fire(), { id: n };
  }
  getIcons() {
    return Object.keys(this.iconsById).map(((n) => this.iconsById[n]));
  }
  getIcon(n) {
    return this.iconsById[n];
  }
  getIconSchema() {
    return this.iconSchema;
  }
  toString() {
    const n = (s, o) => s.id.localeCompare(o.id), e = (s) => {
      for (; Ee.isThemeIcon(s.defaults); ) s = this.iconsById[s.defaults.id];
      return `codicon codicon-${s ? s.id : ""}`;
    }, t = [];
    t.push("| preview     | identifier                        | default codicon ID                | description"), t.push("| ----------- | --------------------------------- | --------------------------------- | --------------------------------- |");
    const i = Object.keys(this.iconsById).map(((s) => this.iconsById[s]));
    for (const s of i.filter(((o) => !!o.description)).sort(n)) t.push(`|<i class="${e(s)}"></i>|${s.id}|${Ee.isThemeIcon(s.defaults) ? s.defaults.id : s.id}|${s.description || ""}|`);
    t.push("| preview     | identifier                        "), t.push("| ----------- | --------------------------------- |");
    for (const s of i.filter(((o) => !Ee.isThemeIcon(o.defaults))).sort(n)) t.push(`|<i class="${e(s)}"></i>|${s.id}|`);
    return t.join(`
`);
  }
}();
function Ei(n, e, t, i) {
  return fg.registerIcon(n, e, t, i);
}
function EV() {
  return fg;
}
li.add("base.contributions.icons", fg), (function() {
  const n = $7();
  for (const e in n) {
    const t = "\\" + n[e].toString(16);
    fg.registerIcon(e, { fontCharacter: t });
  }
})();
const IV = "vscode://schemas/icons", MV = li.as(tL);
MV.registerSchema(IV, fg.getIconSchema());
const fF = new Et((() => MV.notifySchemaChanged(IV)), 200);
fg.onDidChange((() => {
  fF.isScheduled() || fF.schedule();
}));
const TV = Ei("widget-close", ne.close, m(0, "Icon for the close action in widgets."));
Ei("goto-previous-location", ne.arrowUp, m(0, "Icon for goto previous editor location.")), Ei("goto-next-location", ne.arrowDown, m(0, "Icon for goto next editor location.")), Ee.modify(ne.sync, "spin"), Ee.modify(ne.loading, "spin");
class _F {
  getIcon(e) {
    const t = EV();
    let i = e.defaults;
    for (; Ee.isThemeIcon(i); ) {
      const s = t.getIcon(i.id);
      if (!s) return;
      i = s.defaults;
    }
    return i;
  }
}
const td = "vs", bm = "vs-dark", $u = "hc-black", Gu = "hc-light", RV = li.as(rB), Bie = li.as(LB);
class AV {
  constructor(e, t) {
    this.semanticHighlighting = !1, this.themeData = t;
    const i = t.base;
    e.length > 0 ? (ew(e) ? this.id = e : this.id = i + " " + e, this.themeName = e) : (this.id = i, this.themeName = i), this.colors = null, this.defaultColors = /* @__PURE__ */ Object.create(null), this._tokenTheme = null;
  }
  get base() {
    return this.themeData.base;
  }
  notifyBaseUpdated() {
    this.themeData.inherit && (this.colors = null, this._tokenTheme = null);
  }
  getColors() {
    if (!this.colors) {
      const e = /* @__PURE__ */ new Map();
      for (const t in this.themeData.colors) e.set(t, z.fromHex(this.themeData.colors[t]));
      if (this.themeData.inherit) {
        const t = S2(this.themeData.base);
        for (const i in t.colors) e.has(i) || e.set(i, z.fromHex(t.colors[i]));
      }
      this.colors = e;
    }
    return this.colors;
  }
  getColor(e, t) {
    return this.getColors().get(e) || (t !== !1 ? this.getDefault(e) : void 0);
  }
  getDefault(e) {
    let t = this.defaultColors[e];
    return t || (t = RV.resolveDefaultColor(e, this), this.defaultColors[e] = t, t);
  }
  defines(e) {
    return this.getColors().has(e);
  }
  get type() {
    switch (this.base) {
      case td:
        return Zo.LIGHT;
      case $u:
        return Zo.HIGH_CONTRAST_DARK;
      case Gu:
        return Zo.HIGH_CONTRAST_LIGHT;
      default:
        return Zo.DARK;
    }
  }
  get tokenTheme() {
    if (!this._tokenTheme) {
      let e = [], t = [];
      if (this.themeData.inherit) {
        const o = S2(this.themeData.base);
        e = o.rules, o.encodedTokensColors && (t = o.encodedTokensColors);
      }
      const i = this.themeData.colors["editor.foreground"], s = this.themeData.colors["editor.background"];
      if (i || s) {
        const o = { token: "" };
        i && (o.foreground = i), s && (o.background = s), e.push(o);
      }
      e = e.concat(this.themeData.rules), this.themeData.encodedTokensColors && (t = this.themeData.encodedTokensColors), this._tokenTheme = KA.createFromRawTokenTheme(e, t);
    }
    return this._tokenTheme;
  }
  getTokenStyleMetadata(e, t, i) {
    const s = this.tokenTheme._match([e].concat(t).join(".")).metadata, o = In.getForeground(s), r = In.getFontStyle(s);
    return { foreground: o, italic: !!(1 & r), bold: !!(2 & r), underline: !!(4 & r), strikethrough: !!(8 & r) };
  }
}
function ew(n) {
  return n === td || n === bm || n === $u || n === Gu;
}
function S2(n) {
  switch (n) {
    case td:
      return Aie;
    case bm:
      return Pie;
    case $u:
      return Oie;
    case Gu:
      return Fie;
  }
}
function Ub(n) {
  const e = S2(n);
  return new AV(n, e);
}
const Ro = tt("themeService");
var Wie = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, lx = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let L2 = class extends V {
  constructor(n, e, t) {
    super(), this._contextKeyService = n, this._layoutService = e, this._configurationService = t, this._accessibilitySupport = 0, this._onDidChangeScreenReaderOptimized = new F(), this._onDidChangeReducedMotion = new F(), this._accessibilityModeEnabledContext = g_.bindTo(this._contextKeyService);
    const i = () => this._accessibilityModeEnabledContext.set(this.isScreenReaderOptimized());
    this._register(this._configurationService.onDidChangeConfiguration(((o) => {
      o.affectsConfiguration("editor.accessibilitySupport") && (i(), this._onDidChangeScreenReaderOptimized.fire()), o.affectsConfiguration("workbench.reduceMotion") && (this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion"), this._onDidChangeReducedMotion.fire());
    }))), i(), this._register(this.onDidChangeScreenReaderOptimized((() => i())));
    const s = It.matchMedia("(prefers-reduced-motion: reduce)");
    this._systemMotionReduced = s.matches, this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion"), this.initReducedMotionListeners(s);
  }
  initReducedMotionListeners(n) {
    this._register(K(n, "change", (() => {
      this._systemMotionReduced = n.matches, this._configMotionReduced === "auto" && this._onDidChangeReducedMotion.fire();
    })));
    const e = () => {
      const t = this.isMotionReduced();
      this._layoutService.mainContainer.classList.toggle("reduce-motion", t), this._layoutService.mainContainer.classList.toggle("enable-motion", !t);
    };
    e(), this._register(this.onDidChangeReducedMotion((() => e())));
  }
  get onDidChangeScreenReaderOptimized() {
    return this._onDidChangeScreenReaderOptimized.event;
  }
  isScreenReaderOptimized() {
    const n = this._configurationService.getValue("editor.accessibilitySupport");
    return n === "on" || n === "auto" && this._accessibilitySupport === 2;
  }
  get onDidChangeReducedMotion() {
    return this._onDidChangeReducedMotion.event;
  }
  isMotionReduced() {
    const n = this._configMotionReduced;
    return n === "on" || n === "auto" && this._systemMotionReduced;
  }
  getAccessibilitySupport() {
    return this._accessibilitySupport;
  }
};
L2 = Wie([lx(0, Te), lx(1, Ac), lx(2, Ye)], L2);
var pp, lh, WL = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, _g = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let k2 = class {
  constructor(n, e) {
    this._commandService = n, this._hiddenStates = new tw(e);
  }
  createMenu(n, e, t) {
    return new x2(n, this._hiddenStates, { emitEventsForSubmenuChanges: !1, eventDebounceDelay: 50, ...t }, this._commandService, e);
  }
  resetHiddenStates(n) {
    this._hiddenStates.reset(n);
  }
};
k2 = WL([_g(0, ai), _g(1, Nr)], k2);
let tw = pp = class {
  constructor(n) {
    this._storageService = n, this._disposables = new G(), this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._ignoreChangeEvent = !1, this._hiddenByDefaultCache = /* @__PURE__ */ new Map();
    try {
      const e = n.get(pp._key, 0, "{}");
      this._data = JSON.parse(e);
    } catch {
      this._data = /* @__PURE__ */ Object.create(null);
    }
    this._disposables.add(n.onDidChangeValue(0, pp._key, this._disposables)((() => {
      if (!this._ignoreChangeEvent) try {
        const e = n.get(pp._key, 0, "{}");
        this._data = JSON.parse(e);
      } catch (e) {
        console.log("FAILED to read storage after UPDATE", e);
      }
      this._onDidChange.fire();
    })));
  }
  dispose() {
    this._onDidChange.dispose(), this._disposables.dispose();
  }
  _isHiddenByDefault(n, e) {
    var t;
    return (t = this._hiddenByDefaultCache.get(`${n.id}/${e}`)) !== null && t !== void 0 && t;
  }
  setDefaultState(n, e, t) {
    this._hiddenByDefaultCache.set(`${n.id}/${e}`, t);
  }
  isHidden(n, e) {
    var t, i;
    const s = this._isHiddenByDefault(n, e), o = (i = (t = this._data[n.id]) === null || t === void 0 ? void 0 : t.includes(e)) !== null && i !== void 0 && i;
    return s ? !o : o;
  }
  updateHidden(n, e, t) {
    this._isHiddenByDefault(n, e) && (t = !t);
    const i = this._data[n.id];
    if (t) i ? i.indexOf(e) < 0 && i.push(e) : this._data[n.id] = [e];
    else if (i) {
      const s = i.indexOf(e);
      s >= 0 && (function(o, r) {
        const a = o.length - 1;
        r < a && (o[r] = o[a]), o.pop();
      })(i, s), i.length === 0 && delete this._data[n.id];
    }
    this._persist();
  }
  reset(n) {
    if (n === void 0) this._data = /* @__PURE__ */ Object.create(null), this._persist();
    else {
      for (const { id: e } of n) this._data[e] && delete this._data[e];
      this._persist();
    }
  }
  _persist() {
    try {
      this._ignoreChangeEvent = !0;
      const n = JSON.stringify(this._data);
      this._storageService.store(pp._key, n, 0, 0);
    } finally {
      this._ignoreChangeEvent = !1;
    }
  }
};
tw._key = "menu.hiddenCommands", tw = pp = WL([_g(0, Nr)], tw);
let D2 = lh = class {
  constructor(n, e, t, i, s) {
    this._id = n, this._hiddenStates = e, this._collectContextKeysForSubmenus = t, this._commandService = i, this._contextKeyService = s, this._menuGroups = [], this._structureContextKeys = /* @__PURE__ */ new Set(), this._preconditionContextKeys = /* @__PURE__ */ new Set(), this._toggledContextKeys = /* @__PURE__ */ new Set(), this.refresh();
  }
  get structureContextKeys() {
    return this._structureContextKeys;
  }
  get preconditionContextKeys() {
    return this._preconditionContextKeys;
  }
  get toggledContextKeys() {
    return this._toggledContextKeys;
  }
  refresh() {
    this._menuGroups.length = 0, this._structureContextKeys.clear(), this._preconditionContextKeys.clear(), this._toggledContextKeys.clear();
    const n = tn.getMenuItems(this._id);
    let e;
    n.sort(lh._compareMenuItems);
    for (const t of n) {
      const i = t.group || "";
      e && e[0] === i || (e = [i, []], this._menuGroups.push(e)), e[1].push(t), this._collectContextKeys(t);
    }
  }
  _collectContextKeys(n) {
    if (lh._fillInKbExprKeys(n.when, this._structureContextKeys), kp(n)) {
      if (n.command.precondition && lh._fillInKbExprKeys(n.command.precondition, this._preconditionContextKeys), n.command.toggled) {
        const e = n.command.toggled.condition || n.command.toggled;
        lh._fillInKbExprKeys(e, this._toggledContextKeys);
      }
    } else this._collectContextKeysForSubmenus && tn.getMenuItems(n.submenu).forEach(this._collectContextKeys, this);
  }
  createActionGroups(n) {
    const e = [];
    for (const t of this._menuGroups) {
      const [i, s] = t, o = [];
      for (const r of s) if (this._contextKeyService.contextMatchesRules(r.when)) {
        const a = kp(r);
        a && this._hiddenStates.setDefaultState(this._id, r.command.id, !!r.isHiddenByDefault);
        const l = Vie(this._id, a ? r.command : r, this._hiddenStates);
        if (a) o.push(new Eo(r.command, r.alt, n, l, this._contextKeyService, this._commandService));
        else {
          const d = new lh(r.submenu, this._hiddenStates, this._collectContextKeysForSubmenus, this._commandService, this._contextKeyService).createActionGroups(n), h = Ui.join(...d.map(((c) => c[1])));
          h.length > 0 && o.push(new ev(r, l, h));
        }
      }
      o.length > 0 && e.push([i, o]);
    }
    return e;
  }
  static _fillInKbExprKeys(n, e) {
    if (n) for (const t of n.keys()) e.add(t);
  }
  static _compareMenuItems(n, e) {
    const t = n.group, i = e.group;
    if (t !== i) {
      if (!t) return 1;
      if (!i || t === "navigation") return -1;
      if (i === "navigation") return 1;
      const r = t.localeCompare(i);
      if (r !== 0) return r;
    }
    const s = n.order || 0, o = e.order || 0;
    return s < o ? -1 : s > o ? 1 : lh._compareTitles(kp(n) ? n.command.title : n.title, kp(e) ? e.command.title : e.title);
  }
  static _compareTitles(n, e) {
    const t = typeof n == "string" ? n : n.original, i = typeof e == "string" ? e : e.original;
    return t.localeCompare(i);
  }
};
D2 = lh = WL([_g(3, ai), _g(4, Te)], D2);
let x2 = class {
  constructor(n, e, t, i, s) {
    this._disposables = new G(), this._menuInfo = new D2(n, e, t.emitEventsForSubmenuChanges, i, s);
    const o = new Et((() => {
      this._menuInfo.refresh(), this._onDidChange.fire({ menu: this, isStructuralChange: !0, isEnablementChange: !0, isToggleChange: !0 });
    }), t.eventDebounceDelay);
    this._disposables.add(o), this._disposables.add(tn.onDidChangeMenu(((a) => {
      a.has(n) && o.schedule();
    })));
    const r = this._disposables.add(new G());
    this._onDidChange = new F7({ onWillAddFirstListener: () => {
      r.add(s.onDidChangeContext(((a) => {
        const l = a.affectsSome(this._menuInfo.structureContextKeys), d = a.affectsSome(this._menuInfo.preconditionContextKeys), h = a.affectsSome(this._menuInfo.toggledContextKeys);
        (l || d || h) && this._onDidChange.fire({ menu: this, isStructuralChange: l, isEnablementChange: d, isToggleChange: h });
      }))), r.add(e.onDidChange(((a) => {
        this._onDidChange.fire({ menu: this, isStructuralChange: !0, isEnablementChange: !1, isToggleChange: !1 });
      })));
    }, onDidRemoveLastListener: r.clear.bind(r), delay: t.eventDebounceDelay, merge: (a) => {
      let l = !1, d = !1, h = !1;
      for (const c of a) if (l = l || c.isStructuralChange, d = d || c.isEnablementChange, h = h || c.isToggleChange, l && d && h) break;
      return { menu: this, isStructuralChange: l, isEnablementChange: d, isToggleChange: h };
    } }), this.onDidChange = this._onDidChange.event;
  }
  getActions(n) {
    return this._menuInfo.createActionGroups(n);
  }
  dispose() {
    this._disposables.dispose(), this._onDidChange.dispose();
  }
};
function Vie(n, e, t) {
  const i = e.submenu !== void 0 ? e.submenu.id : e.id, s = typeof e.title == "string" ? e.title : e.title.value, o = Yp({ id: `hide/${n.id}/${i}`, label: m(0, "Hide '{0}'", s), run() {
    t.updateHidden(n, i, !0);
  } }), r = Yp({ id: `toggle/${n.id}/${i}`, label: s, get checked() {
    return !t.isHidden(n, i);
  }, run() {
    t.updateHidden(n, i, !!this.checked);
  } });
  return { hide: o, toggle: r, get isHidden() {
    return !r.checked;
  } };
}
x2 = WL([_g(3, ai), _g(4, Te)], x2);
var N2, Hie = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, vF = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let iw = N2 = class extends V {
  constructor(n, e) {
    super(), this.layoutService = n, this.logService = e, this.mapTextToType = /* @__PURE__ */ new Map(), this.findText = "", this.resources = [], this.resourcesStateHash = void 0, (_c || s8) && this.installWebKitWriteTextWorkaround(), this._register(se.runAndSubscribe(WS, (({ window: t, disposables: i }) => {
      i.add(K(t.document, "copy", (() => this.clearResources())));
    }), { window: It, disposables: this._store }));
  }
  installWebKitWriteTextWorkaround() {
    const n = () => {
      const e = new _1();
      this.webKitPendingClipboardWritePromise && !this.webKitPendingClipboardWritePromise.isSettled && this.webKitPendingClipboardWritePromise.cancel(), this.webKitPendingClipboardWritePromise = e, navigator.clipboard.write([new ClipboardItem({ "text/plain": e.p })]).catch((async (t) => {
        t instanceof Error && t.name === "NotAllowedError" && e.isRejected || this.logService.error(t);
      }));
    };
    this._register(se.runAndSubscribe(this.layoutService.onDidAddContainer, (({ container: e, disposables: t }) => {
      t.add(K(e, "click", n)), t.add(K(e, "keydown", n));
    }), { container: this.layoutService.mainContainer, disposables: this._store }));
  }
  async writeText(n, e) {
    if (this.writeResources([]), e) this.mapTextToType.set(e, n);
    else {
      if (this.webKitPendingClipboardWritePromise) return this.webKitPendingClipboardWritePromise.complete(n);
      try {
        return await navigator.clipboard.writeText(n);
      } catch (t) {
        console.error(t);
      }
      this.fallbackWriteText(n);
    }
  }
  fallbackWriteText(n) {
    const e = cf(), t = e.activeElement, i = e.body.appendChild(Q("textarea", { "aria-hidden": !0 }));
    i.style.height = "1px", i.style.width = "1px", i.style.position = "absolute", i.value = n, i.focus(), i.select(), e.execCommand("copy"), t instanceof HTMLElement && t.focus(), e.body.removeChild(i);
  }
  async readText(n) {
    if (n) return this.mapTextToType.get(n) || "";
    try {
      return await navigator.clipboard.readText();
    } catch (e) {
      console.error(e);
    }
    return "";
  }
  async readFindText() {
    return this.findText;
  }
  async writeFindText(n) {
    this.findText = n;
  }
  async writeResources(n) {
    n.length === 0 ? this.clearResources() : (this.resources = n, this.resourcesStateHash = await this.computeResourcesStateHash());
  }
  async readResources() {
    const n = await this.computeResourcesStateHash();
    return this.resourcesStateHash !== n && this.clearResources(), this.resources;
  }
  async computeResourcesStateHash() {
    if (this.resources.length !== 0)
      return FS((await this.readText()).substring(0, N2.MAX_RESOURCE_STATE_SOURCE_LENGTH));
  }
  clearResources() {
    this.resources = [], this.resourcesStateHash = void 0;
  }
};
iw.MAX_RESOURCE_STATE_SOURCE_LENGTH = 1e3, iw = N2 = Hie([vF(0, Ac), vF(1, ts)], iw);
const Kd = tt("clipboardService");
var zie = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Uie = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const v0 = "data-keybinding-context";
let $A = class {
  constructor(n, e) {
    this._id = n, this._parent = e, this._value = /* @__PURE__ */ Object.create(null), this._value._contextId = n;
  }
  get value() {
    return { ...this._value };
  }
  setValue(n, e) {
    return this._value[n] !== e && (this._value[n] = e, !0);
  }
  removeValue(n) {
    return n in this._value && (delete this._value[n], !0);
  }
  getValue(n) {
    const e = this._value[n];
    return e === void 0 && this._parent ? this._parent.getValue(n) : e;
  }
};
class sf extends $A {
  constructor() {
    super(-1, null);
  }
  setValue(e, t) {
    return !1;
  }
  removeValue(e) {
    return !1;
  }
  getValue(e) {
  }
}
sf.INSTANCE = new sf();
class Hv extends $A {
  constructor(e, t, i) {
    super(e, null), this._configurationService = t, this._values = pm.forConfigKeys(), this._listener = this._configurationService.onDidChangeConfiguration(((s) => {
      if (s.source === 7) {
        const o = Array.from(this._values, (([r]) => r));
        this._values.clear(), i.fire(new CF(o));
      } else {
        const o = [];
        for (const r of s.affectedKeys) {
          const a = `config.${r}`, l = this._values.findSuperstr(a);
          l !== void 0 && (o.push(...at.map(l, (([d]) => d))), this._values.deleteSuperstr(a)), this._values.has(a) && (o.push(a), this._values.delete(a));
        }
        i.fire(new CF(o));
      }
    }));
  }
  dispose() {
    this._listener.dispose();
  }
  getValue(e) {
    if (e.indexOf(Hv._keyPrefix) !== 0) return super.getValue(e);
    if (this._values.has(e)) return this._values.get(e);
    const t = e.substr(Hv._keyPrefix.length), i = this._configurationService.getValue(t);
    let s;
    switch (typeof i) {
      case "number":
      case "boolean":
      case "string":
        s = i;
        break;
      default:
        s = Array.isArray(i) ? JSON.stringify(i) : i;
    }
    return this._values.set(e, s), s;
  }
  setValue(e, t) {
    return super.setValue(e, t);
  }
  removeValue(e) {
    return super.removeValue(e);
  }
}
Hv._keyPrefix = "config.";
class Kie {
  constructor(e, t, i) {
    this._service = e, this._key = t, this._defaultValue = i, this.reset();
  }
  set(e) {
    this._service.setContext(this._key, e);
  }
  reset() {
    this._defaultValue === void 0 ? this._service.removeContext(this._key) : this._service.setContext(this._key, this._defaultValue);
  }
  get() {
    return this._service.getContextKeyValue(this._key);
  }
}
class bF {
  constructor(e) {
    this.key = e;
  }
  affectsSome(e) {
    return e.has(this.key);
  }
  allKeysContainedIn(e) {
    return this.affectsSome(e);
  }
}
class CF {
  constructor(e) {
    this.keys = e;
  }
  affectsSome(e) {
    for (const t of this.keys) if (e.has(t)) return !0;
    return !1;
  }
  allKeysContainedIn(e) {
    return this.keys.every(((t) => e.has(t)));
  }
}
class jie {
  constructor(e) {
    this.events = e;
  }
  affectsSome(e) {
    for (const t of this.events) if (t.affectsSome(e)) return !0;
    return !1;
  }
  allKeysContainedIn(e) {
    return this.events.every(((t) => t.allKeysContainedIn(e)));
  }
}
class PV extends V {
  constructor(e) {
    super(), this._onDidChangeContext = this._register(new ng({ merge: (t) => new jie(t) })), this.onDidChangeContext = this._onDidChangeContext.event, this._isDisposed = !1, this._myContextId = e;
  }
  createKey(e, t) {
    if (this._isDisposed) throw new Error("AbstractContextKeyService has been disposed");
    return new Kie(this, e, t);
  }
  bufferChangeEvents(e) {
    this._onDidChangeContext.pause();
    try {
      e();
    } finally {
      this._onDidChangeContext.resume();
    }
  }
  createScoped(e) {
    if (this._isDisposed) throw new Error("AbstractContextKeyService has been disposed");
    return new qie(this, e);
  }
  contextMatchesRules(e) {
    if (this._isDisposed) throw new Error("AbstractContextKeyService has been disposed");
    const t = this.getContextValuesContainer(this._myContextId);
    return !e || e.evaluate(t);
  }
  getContextKeyValue(e) {
    if (!this._isDisposed) return this.getContextValuesContainer(this._myContextId).getValue(e);
  }
  setContext(e, t) {
    if (this._isDisposed) return;
    const i = this.getContextValuesContainer(this._myContextId);
    i && i.setValue(e, t) && this._onDidChangeContext.fire(new bF(e));
  }
  removeContext(e) {
    this._isDisposed || this.getContextValuesContainer(this._myContextId).removeValue(e) && this._onDidChangeContext.fire(new bF(e));
  }
  getContext(e) {
    return this._isDisposed ? sf.INSTANCE : this.getContextValuesContainer((function(t) {
      for (; t; ) {
        if (t.hasAttribute(v0)) {
          const i = t.getAttribute(v0);
          return i ? parseInt(i, 10) : NaN;
        }
        t = t.parentElement;
      }
      return 0;
    })(e));
  }
  dispose() {
    super.dispose(), this._isDisposed = !0;
  }
}
let E2 = class extends PV {
  constructor(n) {
    super(0), this._contexts = /* @__PURE__ */ new Map(), this._lastContextId = 0;
    const e = this._register(new Hv(this._myContextId, n, this._onDidChangeContext));
    this._contexts.set(this._myContextId, e);
  }
  getContextValuesContainer(n) {
    return this._isDisposed ? sf.INSTANCE : this._contexts.get(n) || sf.INSTANCE;
  }
  createChildContext(n = this._myContextId) {
    if (this._isDisposed) throw new Error("ContextKeyService has been disposed");
    const e = ++this._lastContextId;
    return this._contexts.set(e, new $A(e, this.getContextValuesContainer(n))), e;
  }
  disposeContext(n) {
    this._isDisposed || this._contexts.delete(n);
  }
};
E2 = zie([Uie(0, Ye)], E2);
class qie extends PV {
  constructor(e, t) {
    if (super(e.createChildContext()), this._parentChangeListener = this._register(new rn()), this._parent = e, this._updateParentChangeListener(), this._domNode = t, this._domNode.hasAttribute(v0)) {
      let i = "";
      this._domNode.classList && (i = Array.from(this._domNode.classList.values()).join(", ")), console.error("Element already has context attribute" + (i ? ": " + i : ""));
    }
    this._domNode.setAttribute(v0, String(this._myContextId));
  }
  _updateParentChangeListener() {
    this._parentChangeListener.value = this._parent.onDidChangeContext(((e) => {
      const t = this._parent.getContextValuesContainer(this._myContextId).value;
      var i;
      i = t, e.allKeysContainedIn(new Set(Object.keys(i))) || this._onDidChangeContext.fire(e);
    }));
  }
  dispose() {
    this._isDisposed || (this._parent.disposeContext(this._myContextId), this._domNode.removeAttribute(v0), super.dispose());
  }
  getContextValuesContainer(e) {
    return this._isDisposed ? sf.INSTANCE : this._parent.getContextValuesContainer(e);
  }
  createChildContext(e = this._myContextId) {
    if (this._isDisposed) throw new Error("ScopedContextKeyService has been disposed");
    return this._parent.createChildContext(e);
  }
  disposeContext(e) {
    this._isDisposed || this._parent.disposeContext(e);
  }
}
dt.registerCommand("_setContext", (function(n, e, t) {
  n.get(Te).createKey(String(e), (function(i) {
    return v7(i, ((s) => typeof s == "object" && s.$mid === 1 ? Ie.revive(s).toString() : s instanceof Ie ? s.toString() : void 0));
  })(t));
})), dt.registerCommand({ id: "getContextKeyInfo", handler: () => [...ae.all()].sort(((n, e) => n.key.localeCompare(e.key))), metadata: { description: m(0, "A command that returns information about context keys"), args: [] } }), dt.registerCommand("_generateContextKeyInfo", (function() {
  const n = [], e = /* @__PURE__ */ new Set();
  for (const t of ae.all()) e.has(t.key) || (e.add(t.key), n.push(t));
  n.sort(((t, i) => t.key.localeCompare(i.key))), console.log(JSON.stringify(n, void 0, 2));
}));
let $ie = class {
  constructor(n, e) {
    this.key = n, this.data = e, this.incoming = /* @__PURE__ */ new Map(), this.outgoing = /* @__PURE__ */ new Map();
  }
};
class wF {
  constructor(e) {
    this._hashFn = e, this._nodes = /* @__PURE__ */ new Map();
  }
  roots() {
    const e = [];
    for (const t of this._nodes.values()) t.outgoing.size === 0 && e.push(t);
    return e;
  }
  insertEdge(e, t) {
    const i = this.lookupOrInsertNode(e), s = this.lookupOrInsertNode(t);
    i.outgoing.set(s.key, s), s.incoming.set(i.key, i);
  }
  removeNode(e) {
    const t = this._hashFn(e);
    this._nodes.delete(t);
    for (const i of this._nodes.values()) i.outgoing.delete(t), i.incoming.delete(t);
  }
  lookupOrInsertNode(e) {
    const t = this._hashFn(e);
    let i = this._nodes.get(t);
    return i || (i = new $ie(t, e), this._nodes.set(t, i)), i;
  }
  isEmpty() {
    return this._nodes.size === 0;
  }
  toString() {
    const e = [];
    for (const [t, i] of this._nodes) e.push(`${t}
	(-> incoming)[${[...i.incoming.keys()].join(", ")}]
	(outgoing ->)[${[...i.outgoing.keys()].join(",")}]
`);
    return e.join(`
`);
  }
  findCycleSlow() {
    for (const [e, t] of this._nodes) {
      const i = /* @__PURE__ */ new Set([e]), s = this._findCycle(t, i);
      if (s) return s;
    }
  }
  _findCycle(e, t) {
    for (const [i, s] of e.outgoing) {
      if (t.has(i)) return [...t, i].join(" -> ");
      t.add(i);
      const o = this._findCycle(s, t);
      if (o) return o;
      t.delete(i);
    }
  }
}
class yF extends Error {
  constructor(e) {
    var t;
    super("cyclic dependency between services"), this.message = (t = e.findCycleSlow()) !== null && t !== void 0 ? t : `UNABLE to detect cycle, dumping graph: 
${e.toString()}`;
  }
}
class Qy {
  constructor(e = new N1(), t = !1, i, s = !1) {
    var o;
    this._services = e, this._strict = t, this._parent = i, this._enableTracing = s, this._activeInstantiations = /* @__PURE__ */ new Set(), this._services.set(Se, this), this._globalGraph = s ? (o = i?._globalGraph) !== null && o !== void 0 ? o : new wF(((r) => r)) : void 0;
  }
  createChild(e) {
    return new Qy(e, this._strict, this, this._enableTracing);
  }
  invokeFunction(e, ...t) {
    const i = Ns.traceInvocation(this._enableTracing, e);
    let s = !1;
    try {
      return e({ get: (o) => {
        if (s) throw ZT("service accessor is only valid during the invocation of its target method");
        const r = this._getOrCreateServiceInstance(o, i);
        if (!r) throw new Error(`[invokeFunction] unknown service '${o}'`);
        return r;
      } }, ...t);
    } finally {
      s = !0, i.stop();
    }
  }
  createInstance(e, ...t) {
    let i, s;
    return e instanceof Wa ? (i = Ns.traceCreation(this._enableTracing, e.ctor), s = this._createInstance(e.ctor, e.staticArguments.concat(t), i)) : (i = Ns.traceCreation(this._enableTracing, e), s = this._createInstance(e, t, i)), i.stop(), s;
  }
  _createInstance(e, t = [], i) {
    const s = zr.getServiceDependencies(e).sort(((a, l) => a.index - l.index)), o = [];
    for (const a of s) {
      const l = this._getOrCreateServiceInstance(a.id, i);
      l || this._throwIfStrict(`[createInstance] ${e.name} depends on UNKNOWN service ${a.id}.`, !1), o.push(l);
    }
    const r = s.length > 0 ? s[0].index : t.length;
    if (t.length !== r) {
      console.trace(`[createInstance] First service dependency of ${e.name} at position ${r + 1} conflicts with ${t.length} static arguments`);
      const a = r - t.length;
      t = a > 0 ? t.concat(new Array(a)) : t.slice(0, r);
    }
    return Reflect.construct(e, t.concat(o));
  }
  _setServiceInstance(e, t) {
    if (this._services.get(e) instanceof Wa) this._services.set(e, t);
    else {
      if (!this._parent) throw new Error("illegalState - setting UNKNOWN service instance");
      this._parent._setServiceInstance(e, t);
    }
  }
  _getServiceInstanceOrDescriptor(e) {
    const t = this._services.get(e);
    return !t && this._parent ? this._parent._getServiceInstanceOrDescriptor(e) : t;
  }
  _getOrCreateServiceInstance(e, t) {
    this._globalGraph && this._globalGraphImplicitDependency && this._globalGraph.insertEdge(this._globalGraphImplicitDependency, String(e));
    const i = this._getServiceInstanceOrDescriptor(e);
    return i instanceof Wa ? this._safeCreateAndCacheServiceInstance(e, i, t.branch(e, !0)) : (t.branch(e, !1), i);
  }
  _safeCreateAndCacheServiceInstance(e, t, i) {
    if (this._activeInstantiations.has(e)) throw new Error(`illegal state - RECURSIVELY instantiating service '${e}'`);
    this._activeInstantiations.add(e);
    try {
      return this._createAndCacheServiceInstance(e, t, i);
    } finally {
      this._activeInstantiations.delete(e);
    }
  }
  _createAndCacheServiceInstance(e, t, i) {
    var s;
    const o = new wF(((l) => l.id.toString()));
    let r = 0;
    const a = [{ id: e, desc: t, _trace: i }];
    for (; a.length; ) {
      const l = a.pop();
      if (o.lookupOrInsertNode(l), r++ > 1e3) throw new yF(o);
      for (const d of zr.getServiceDependencies(l.desc.ctor)) {
        const h = this._getServiceInstanceOrDescriptor(d.id);
        if (h || this._throwIfStrict(`[createInstance] ${e} depends on ${d.id} which is NOT registered.`, !0), (s = this._globalGraph) === null || s === void 0 || s.insertEdge(String(l.id), String(d.id)), h instanceof Wa) {
          const c = { id: d.id, desc: h, _trace: l._trace.branch(d.id, !0) };
          o.insertEdge(l, c), a.push(c);
        }
      }
    }
    for (; ; ) {
      const l = o.roots();
      if (l.length === 0) {
        if (!o.isEmpty()) throw new yF(o);
        break;
      }
      for (const { data: d } of l) {
        if (this._getServiceInstanceOrDescriptor(d.id) instanceof Wa) {
          const h = this._createServiceInstanceWithOwner(d.id, d.desc.ctor, d.desc.staticArguments, d.desc.supportsDelayedInstantiation, d._trace);
          this._setServiceInstance(d.id, h);
        }
        o.removeNode(d);
      }
    }
    return this._getServiceInstanceOrDescriptor(e);
  }
  _createServiceInstanceWithOwner(e, t, i = [], s, o) {
    if (this._services.get(e) instanceof Wa) return this._createServiceInstance(e, t, i, s, o);
    if (this._parent) return this._parent._createServiceInstanceWithOwner(e, t, i, s, o);
    throw new Error(`illegalState - creating UNKNOWN service instance ${t.name}`);
  }
  _createServiceInstance(e, t, i = [], s, o) {
    if (s) {
      const r = new Qy(void 0, this._strict, this, this._enableTracing);
      r._globalGraphImplicitDependency = String(e);
      const a = /* @__PURE__ */ new Map(), l = new OK((() => {
        const d = r._createInstance(t, i, o);
        for (const [h, c] of a) {
          const u = d[h];
          if (typeof u == "function") for (const g of c) g.disposable = u.apply(d, g.listener);
        }
        return a.clear(), d;
      }));
      return new Proxy(/* @__PURE__ */ Object.create(null), { get(d, h) {
        if (!l.isInitialized && typeof h == "string" && (h.startsWith("onDid") || h.startsWith("onWill"))) {
          let g = a.get(h);
          return g || (g = new fs(), a.set(h, g)), (f, _, v) => {
            if (l.isInitialized) return l.value[h](f, _, v);
            {
              const b = { listener: [f, _, v], disposable: void 0 }, C = g.push(b);
              return ye((() => {
                var y;
                C(), (y = b.disposable) === null || y === void 0 || y.dispose();
              }));
            }
          };
        }
        if (h in d) return d[h];
        const c = l.value;
        let u = c[h];
        return typeof u != "function" || (u = u.bind(c), d[h] = u), u;
      }, set: (d, h, c) => (l.value[h] = c, !0), getPrototypeOf: (d) => t.prototype });
    }
    return this._createInstance(t, i, o);
  }
  _throwIfStrict(e, t) {
    if (t && console.warn(e), this._strict) throw new Error(e);
  }
}
class Ns {
  static traceInvocation(e, t) {
    return e ? new Ns(2, t.name || new Error().stack.split(`
`).slice(3, 4).join(`
`)) : Ns._None;
  }
  static traceCreation(e, t) {
    return e ? new Ns(1, t.name) : Ns._None;
  }
  constructor(e, t) {
    this.type = e, this.name = t, this._start = Date.now(), this._dep = [];
  }
  branch(e, t) {
    const i = new Ns(3, e.toString());
    return this._dep.push([e, t, i]), i;
  }
  stop() {
    const e = Date.now() - this._start;
    Ns._totals += e;
    let t = !1;
    const i = [`${this.type === 1 ? "CREATE" : "CALL"} ${this.name}`, `${(function s(o, r) {
      const a = [], l = new Array(o + 1).join("	");
      for (const [d, h, c] of r._dep) if (h && c) {
        t = !0, a.push(`${l}CREATES -> ${d}`);
        const u = s(o + 1, c);
        u && a.push(u);
      } else a.push(`${l}uses -> ${d}`);
      return a.join(`
`);
    })(1, this)}`, `DONE, took ${e.toFixed(2)}ms (grand total ${Ns._totals.toFixed(2)}ms)`];
    (e > 2 || t) && Ns.all.add(i.join(`
`));
  }
}
Ns.all = /* @__PURE__ */ new Set(), Ns._None = new class extends Ns {
  constructor() {
    super(0, null);
  }
  stop() {
  }
  branch() {
    return this;
  }
}(), Ns._totals = 0;
const Gie = /* @__PURE__ */ new Set([Ue.inMemory, Ue.vscodeSourceControl, Ue.walkThrough, Ue.walkThroughSnippet, Ue.vscodeChatCodeBlock]);
class Zie {
  constructor() {
    this._byResource = new Di(), this._byOwner = /* @__PURE__ */ new Map();
  }
  set(e, t, i) {
    let s = this._byResource.get(e);
    s || (s = /* @__PURE__ */ new Map(), this._byResource.set(e, s)), s.set(t, i);
    let o = this._byOwner.get(t);
    o || (o = new Di(), this._byOwner.set(t, o)), o.set(e, i);
  }
  get(e, t) {
    const i = this._byResource.get(e);
    return i?.get(t);
  }
  delete(e, t) {
    let i = !1, s = !1;
    const o = this._byResource.get(e);
    o && (i = o.delete(t));
    const r = this._byOwner.get(t);
    if (r && (s = r.delete(e)), i !== s) throw new Error("illegal state");
    return i && s;
  }
  values(e) {
    var t, i, s, o;
    return typeof e == "string" ? (i = (t = this._byOwner.get(e)) === null || t === void 0 ? void 0 : t.values()) !== null && i !== void 0 ? i : at.empty() : Ie.isUri(e) ? (o = (s = this._byResource.get(e)) === null || s === void 0 ? void 0 : s.values()) !== null && o !== void 0 ? o : at.empty() : at.map(at.concat(...this._byOwner.values()), ((r) => r[1]));
  }
}
class Yie {
  constructor(e) {
    this.errors = 0, this.infos = 0, this.warnings = 0, this.unknowns = 0, this._data = new Di(), this._service = e, this._subscription = e.onMarkerChanged(this._update, this);
  }
  dispose() {
    this._subscription.dispose();
  }
  _update(e) {
    for (const t of e) {
      const i = this._data.get(t);
      i && this._substract(i);
      const s = this._resourceStats(t);
      this._add(s), this._data.set(t, s);
    }
  }
  _resourceStats(e) {
    const t = { errors: 0, warnings: 0, infos: 0, unknowns: 0 };
    if (Gie.has(e.scheme)) return t;
    for (const { severity: i } of this._service.read({ resource: e })) i === pi.Error ? t.errors += 1 : i === pi.Warning ? t.warnings += 1 : i === pi.Info ? t.infos += 1 : t.unknowns += 1;
    return t;
  }
  _substract(e) {
    this.errors -= e.errors, this.warnings -= e.warnings, this.infos -= e.infos, this.unknowns -= e.unknowns;
  }
  _add(e) {
    this.errors += e.errors, this.warnings += e.warnings, this.infos += e.infos, this.unknowns += e.unknowns;
  }
}
class ph {
  constructor() {
    this._onMarkerChanged = new F7({ delay: 0, merge: ph._merge }), this.onMarkerChanged = this._onMarkerChanged.event, this._data = new Zie(), this._stats = new Yie(this);
  }
  dispose() {
    this._stats.dispose(), this._onMarkerChanged.dispose();
  }
  remove(e, t) {
    for (const i of t || []) this.changeOne(e, i, []);
  }
  changeOne(e, t, i) {
    if (p7(i))
      this._data.delete(t, e) && this._onMarkerChanged.fire([t]);
    else {
      const s = [];
      for (const o of i) {
        const r = ph._toMarker(e, t, o);
        r && s.push(r);
      }
      this._data.set(t, e, s), this._onMarkerChanged.fire([t]);
    }
  }
  static _toMarker(e, t, i) {
    let { code: s, severity: o, message: r, source: a, startLineNumber: l, startColumn: d, endLineNumber: h, endColumn: c, relatedInformation: u, tags: g } = i;
    if (r) return l = l > 0 ? l : 1, d = d > 0 ? d : 1, h = h >= l ? h : l, c = c > 0 ? c : d, { resource: t, owner: e, code: s, severity: o, message: r, source: a, startLineNumber: l, startColumn: d, endLineNumber: h, endColumn: c, relatedInformation: u, tags: g };
  }
  changeAll(e, t) {
    const i = [], s = this._data.values(e);
    if (s) for (const o of s) {
      const r = at.first(o);
      r && (i.push(r.resource), this._data.delete(r.resource, e));
    }
    if (zn(t)) {
      const o = new Di();
      for (const { resource: r, marker: a } of t) {
        const l = ph._toMarker(e, r, a);
        if (!l) continue;
        const d = o.get(r);
        d ? d.push(l) : (o.set(r, [l]), i.push(r));
      }
      for (const [r, a] of o) this._data.set(r, e, a);
    }
    i.length > 0 && this._onMarkerChanged.fire(i);
  }
  read(e = /* @__PURE__ */ Object.create(null)) {
    let { owner: t, resource: i, severities: s, take: o } = e;
    if ((!o || o < 0) && (o = -1), t && i) {
      const r = this._data.get(i, t);
      if (r) {
        const a = [];
        for (const l of r) if (ph._accept(l, s)) {
          const d = a.push(l);
          if (o > 0 && d === o) break;
        }
        return a;
      }
      return [];
    }
    if (t || i) {
      const r = this._data.values(i ?? t), a = [];
      for (const l of r) for (const d of l) if (ph._accept(d, s)) {
        const h = a.push(d);
        if (o > 0 && h === o) return a;
      }
      return a;
    }
    {
      const r = [];
      for (const a of this._data.values()) for (const l of a) if (ph._accept(l, s)) {
        const d = r.push(l);
        if (o > 0 && d === o) return r;
      }
      return r;
    }
  }
  static _accept(e, t) {
    return t === void 0 || (t & e.severity) === e.severity;
  }
  static _merge(e) {
    const t = new Di();
    for (const i of e) for (const s of i) t.set(s, !0);
    return Array.from(t.keys());
  }
}
class Xie extends V {
  constructor() {
    super(...arguments), this._configurationModel = new En();
  }
  get configurationModel() {
    return this._configurationModel;
  }
  reload() {
    return this.resetConfigurationModel(), this.configurationModel;
  }
  getConfigurationDefaultOverrides() {
    return {};
  }
  resetConfigurationModel() {
    this._configurationModel = new En();
    const e = li.as(ma).getConfigurationProperties();
    this.updateConfigurationModel(Object.keys(e), e);
  }
  updateConfigurationModel(e, t) {
    const i = this.getConfigurationDefaultOverrides();
    for (const s of e) {
      const o = i[s], r = t[s];
      o !== void 0 ? this._configurationModel.addValue(s, o) : r ? this._configurationModel.addValue(s, r.default) : this._configurationModel.removeValue(s);
    }
  }
}
const Oc = tt("accessibilitySignalService");
class Pe {
  static register(e) {
    return new Pe(e.fileName);
  }
  constructor(e) {
    this.fileName = e;
  }
}
Pe.error = Pe.register({ fileName: "error.mp3" }), Pe.warning = Pe.register({ fileName: "warning.mp3" }), Pe.foldedArea = Pe.register({ fileName: "foldedAreas.mp3" }), Pe.break = Pe.register({ fileName: "break.mp3" }), Pe.quickFixes = Pe.register({ fileName: "quickFixes.mp3" }), Pe.taskCompleted = Pe.register({ fileName: "taskCompleted.mp3" }), Pe.taskFailed = Pe.register({ fileName: "taskFailed.mp3" }), Pe.terminalBell = Pe.register({ fileName: "terminalBell.mp3" }), Pe.diffLineInserted = Pe.register({ fileName: "diffLineInserted.mp3" }), Pe.diffLineDeleted = Pe.register({ fileName: "diffLineDeleted.mp3" }), Pe.diffLineModified = Pe.register({ fileName: "diffLineModified.mp3" }), Pe.chatRequestSent = Pe.register({ fileName: "chatRequestSent.mp3" }), Pe.chatResponsePending = Pe.register({ fileName: "chatResponsePending.mp3" }), Pe.chatResponseReceived1 = Pe.register({ fileName: "chatResponseReceived1.mp3" }), Pe.chatResponseReceived2 = Pe.register({ fileName: "chatResponseReceived2.mp3" }), Pe.chatResponseReceived3 = Pe.register({ fileName: "chatResponseReceived3.mp3" }), Pe.chatResponseReceived4 = Pe.register({ fileName: "chatResponseReceived4.mp3" }), Pe.clear = Pe.register({ fileName: "clear.mp3" }), Pe.save = Pe.register({ fileName: "save.mp3" }), Pe.format = Pe.register({ fileName: "format.mp3" }), Pe.voiceRecordingStarted = Pe.register({ fileName: "voiceRecordingStarted.mp3" }), Pe.voiceRecordingStopped = Pe.register({ fileName: "voiceRecordingStopped.mp3" });
class Qie {
  constructor(e) {
    this.randomOneOf = e;
  }
}
class He {
  static register(e) {
    const t = new Qie("randomOneOf" in e.sound ? e.sound.randomOneOf : [e.sound]), i = new He(t, e.name, e.legacySoundSettingsKey, e.settingsKey, e.legacyAnnouncementSettingsKey, e.announcementMessage);
    return He._signals.add(i), i;
  }
  constructor(e, t, i, s, o, r) {
    this.sound = e, this.name = t, this.legacySoundSettingsKey = i, this.settingsKey = s, this.legacyAnnouncementSettingsKey = o, this.announcementMessage = r;
  }
}
He._signals = /* @__PURE__ */ new Set(), He.error = He.register({ name: m(0, "Error on Line"), sound: Pe.error, legacySoundSettingsKey: "audioCues.lineHasError", legacyAnnouncementSettingsKey: "accessibility.alert.error", announcementMessage: m(0, "Error"), settingsKey: "accessibility.signals.lineHasError" }), He.warning = He.register({ name: m(0, "Warning on Line"), sound: Pe.warning, legacySoundSettingsKey: "audioCues.lineHasWarning", legacyAnnouncementSettingsKey: "accessibility.alert.warning", announcementMessage: m(0, "Warning"), settingsKey: "accessibility.signals.lineHasWarning" }), He.foldedArea = He.register({ name: m(0, "Folded Area on Line"), sound: Pe.foldedArea, legacySoundSettingsKey: "audioCues.lineHasFoldedArea", legacyAnnouncementSettingsKey: "accessibility.alert.foldedArea", announcementMessage: m(0, "Folded"), settingsKey: "accessibility.signals.lineHasFoldedArea" }), He.break = He.register({ name: m(0, "Breakpoint on Line"), sound: Pe.break, legacySoundSettingsKey: "audioCues.lineHasBreakpoint", legacyAnnouncementSettingsKey: "accessibility.alert.breakpoint", announcementMessage: m(0, "Breakpoint"), settingsKey: "accessibility.signals.lineHasBreakpoint" }), He.inlineSuggestion = He.register({ name: m(0, "Inline Suggestion on Line"), sound: Pe.quickFixes, legacySoundSettingsKey: "audioCues.lineHasInlineSuggestion", settingsKey: "accessibility.signals.lineHasInlineSuggestion" }), He.terminalQuickFix = He.register({ name: m(0, "Terminal Quick Fix"), sound: Pe.quickFixes, legacySoundSettingsKey: "audioCues.terminalQuickFix", legacyAnnouncementSettingsKey: "accessibility.alert.terminalQuickFix", announcementMessage: m(0, "Quick Fix"), settingsKey: "accessibility.signals.terminalQuickFix" }), He.onDebugBreak = He.register({ name: m(0, "Debugger Stopped on Breakpoint"), sound: Pe.break, legacySoundSettingsKey: "audioCues.onDebugBreak", legacyAnnouncementSettingsKey: "accessibility.alert.onDebugBreak", announcementMessage: m(0, "Breakpoint"), settingsKey: "accessibility.signals.onDebugBreak" }), He.noInlayHints = He.register({ name: m(0, "No Inlay Hints on Line"), sound: Pe.error, legacySoundSettingsKey: "audioCues.noInlayHints", legacyAnnouncementSettingsKey: "accessibility.alert.noInlayHints", announcementMessage: m(0, "No Inlay Hints"), settingsKey: "accessibility.signals.noInlayHints" }), He.taskCompleted = He.register({ name: m(0, "Task Completed"), sound: Pe.taskCompleted, legacySoundSettingsKey: "audioCues.taskCompleted", legacyAnnouncementSettingsKey: "accessibility.alert.taskCompleted", announcementMessage: m(0, "Task Completed"), settingsKey: "accessibility.signals.taskCompleted" }), He.taskFailed = He.register({ name: m(0, "Task Failed"), sound: Pe.taskFailed, legacySoundSettingsKey: "audioCues.taskFailed", legacyAnnouncementSettingsKey: "accessibility.alert.taskFailed", announcementMessage: m(0, "Task Failed"), settingsKey: "accessibility.signals.taskFailed" }), He.terminalCommandFailed = He.register({ name: m(0, "Terminal Command Failed"), sound: Pe.error, legacySoundSettingsKey: "audioCues.terminalCommandFailed", legacyAnnouncementSettingsKey: "accessibility.alert.terminalCommandFailed", announcementMessage: m(0, "Command Failed"), settingsKey: "accessibility.signals.terminalCommandFailed" }), He.terminalBell = He.register({ name: m(0, "Terminal Bell"), sound: Pe.terminalBell, legacySoundSettingsKey: "audioCues.terminalBell", legacyAnnouncementSettingsKey: "accessibility.alert.terminalBell", announcementMessage: m(0, "Terminal Bell"), settingsKey: "accessibility.signals.terminalBell" }), He.notebookCellCompleted = He.register({ name: m(0, "Notebook Cell Completed"), sound: Pe.taskCompleted, legacySoundSettingsKey: "audioCues.notebookCellCompleted", legacyAnnouncementSettingsKey: "accessibility.alert.notebookCellCompleted", announcementMessage: m(0, "Notebook Cell Completed"), settingsKey: "accessibility.signals.notebookCellCompleted" }), He.notebookCellFailed = He.register({ name: m(0, "Notebook Cell Failed"), sound: Pe.taskFailed, legacySoundSettingsKey: "audioCues.notebookCellFailed", legacyAnnouncementSettingsKey: "accessibility.alert.notebookCellFailed", announcementMessage: m(0, "Notebook Cell Failed"), settingsKey: "accessibility.signals.notebookCellFailed" }), He.diffLineInserted = He.register({ name: m(0, "Diff Line Inserted"), sound: Pe.diffLineInserted, legacySoundSettingsKey: "audioCues.diffLineInserted", settingsKey: "accessibility.signals.diffLineInserted" }), He.diffLineDeleted = He.register({ name: m(0, "Diff Line Deleted"), sound: Pe.diffLineDeleted, legacySoundSettingsKey: "audioCues.diffLineDeleted", settingsKey: "accessibility.signals.diffLineDeleted" }), He.diffLineModified = He.register({ name: m(0, "Diff Line Modified"), sound: Pe.diffLineModified, legacySoundSettingsKey: "audioCues.diffLineModified", settingsKey: "accessibility.signals.diffLineModified" }), He.chatRequestSent = He.register({ name: m(0, "Chat Request Sent"), sound: Pe.chatRequestSent, legacySoundSettingsKey: "audioCues.chatRequestSent", legacyAnnouncementSettingsKey: "accessibility.alert.chatRequestSent", announcementMessage: m(0, "Chat Request Sent"), settingsKey: "accessibility.signals.chatRequestSent" }), He.chatResponseReceived = He.register({ name: m(0, "Chat Response Received"), legacySoundSettingsKey: "audioCues.chatResponseReceived", sound: { randomOneOf: [Pe.chatResponseReceived1, Pe.chatResponseReceived2, Pe.chatResponseReceived3, Pe.chatResponseReceived4] }, settingsKey: "accessibility.signals.chatResponseReceived" }), He.chatResponsePending = He.register({ name: m(0, "Chat Response Pending"), sound: Pe.chatResponsePending, legacySoundSettingsKey: "audioCues.chatResponsePending", legacyAnnouncementSettingsKey: "accessibility.alert.chatResponsePending", announcementMessage: m(0, "Chat Response Pending"), settingsKey: "accessibility.signals.chatResponsePending" }), He.clear = He.register({ name: m(0, "Clear"), sound: Pe.clear, legacySoundSettingsKey: "audioCues.clear", legacyAnnouncementSettingsKey: "accessibility.alert.clear", announcementMessage: m(0, "Clear"), settingsKey: "accessibility.signals.clear" }), He.save = He.register({ name: m(0, "Save"), sound: Pe.save, legacySoundSettingsKey: "audioCues.save", legacyAnnouncementSettingsKey: "accessibility.alert.save", announcementMessage: m(0, "Save"), settingsKey: "accessibility.signals.save" }), He.format = He.register({ name: m(0, "Format"), sound: Pe.format, legacySoundSettingsKey: "audioCues.format", legacyAnnouncementSettingsKey: "accessibility.alert.format", announcementMessage: m(0, "Format"), settingsKey: "accessibility.signals.format" }), He.voiceRecordingStarted = He.register({ name: m(0, "Voice Recording Started"), sound: Pe.voiceRecordingStarted, legacySoundSettingsKey: "audioCues.voiceRecordingStarted", settingsKey: "accessibility.signals.voiceRecordingStarted" }), He.voiceRecordingStopped = He.register({ name: m(0, "Voice Recording Stopped"), sound: Pe.voiceRecordingStopped, legacySoundSettingsKey: "audioCues.voiceRecordingStopped", settingsKey: "accessibility.signals.voiceRecordingStopped" });
class Jie extends V {
  constructor(e, t = []) {
    super(), this.logger = new Oj([e, ...t]), this._register(e.onDidChangeLogLevel(((i) => this.setLevel(i))));
  }
  get onDidChangeLogLevel() {
    return this.logger.onDidChangeLogLevel;
  }
  setLevel(e) {
    this.logger.setLevel(e);
  }
  getLevel() {
    return this.logger.getLevel();
  }
  trace(e, ...t) {
    this.logger.trace(e, ...t);
  }
  debug(e, ...t) {
    this.logger.debug(e, ...t);
  }
  info(e, ...t) {
    this.logger.info(e, ...t);
  }
  warn(e, ...t) {
    this.logger.warn(e, ...t);
  }
  error(e, ...t) {
    this.logger.error(e, ...t);
  }
}
const OV = [];
function W1(n) {
  OV.push(n);
}
function ene() {
  return OV.slice(0);
}
var Fc = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Cn = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class tne {
  constructor(e) {
    this.disposed = !1, this.model = e, this._onWillDispose = new F();
  }
  get textEditorModel() {
    return this.model;
  }
  dispose() {
    this.disposed = !0, this._onWillDispose.fire();
  }
}
let I2 = class {
  constructor(n) {
    this.modelService = n;
  }
  createModelReference(n) {
    const e = this.modelService.getModel(n);
    return e ? Promise.resolve(new nK(new tne(e))) : Promise.reject(new Error("Model not found"));
  }
};
I2 = Fc([Cn(0, ni)], I2);
class VL {
  show() {
    return VL.NULL_PROGRESS_RUNNER;
  }
  async showWhile(e, t) {
    await e;
  }
}
VL.NULL_PROGRESS_RUNNER = { done: () => {
}, total: () => {
}, worked: () => {
} };
class zv {
  info(e) {
    return this.notify({ severity: ki.Info, message: e });
  }
  warn(e) {
    return this.notify({ severity: ki.Warning, message: e });
  }
  error(e) {
    return this.notify({ severity: ki.Error, message: e });
  }
  notify(e) {
    switch (e.severity) {
      case ki.Error:
        console.error(e.message);
        break;
      case ki.Warning:
        console.warn(e.message);
        break;
      default:
        console.log(e.message);
    }
    return zv.NO_OP;
  }
  prompt(e, t, i, s) {
    return zv.NO_OP;
  }
  status(e, t) {
    return V.None;
  }
}
zv.NO_OP = new class {
}();
let M2 = class {
  constructor(n) {
    this._onWillExecuteCommand = new F(), this._onDidExecuteCommand = new F(), this.onDidExecuteCommand = this._onDidExecuteCommand.event, this._instantiationService = n;
  }
  executeCommand(n, ...e) {
    const t = dt.getCommand(n);
    if (!t) return Promise.reject(new Error(`command '${n}' not found`));
    try {
      this._onWillExecuteCommand.fire({ commandId: n, args: e });
      const i = this._instantiationService.invokeFunction.apply(this._instantiationService, [t.handler, ...e]);
      return this._onDidExecuteCommand.fire({ commandId: n, args: e }), Promise.resolve(i);
    } catch (i) {
      return Promise.reject(i);
    }
  }
};
M2 = Fc([Cn(0, Se)], M2);
let of = class extends uee {
  constructor(n, e, t, i, s, o) {
    super(n, e, t, i, s), this._cachedResolver = null, this._dynamicKeybindings = [], this._domNodeListeners = [];
    const r = (h) => {
      const c = new G();
      c.add(K(h, ie.KEY_DOWN, ((u) => {
        const g = new jt(u);
        this._dispatch(g, g.target) && (g.preventDefault(), g.stopPropagation());
      }))), c.add(K(h, ie.KEY_UP, ((u) => {
        const g = new jt(u);
        this._singleModifierDispatch(g, g.target) && g.preventDefault();
      }))), this._domNodeListeners.push(new ine(h, c));
    }, a = (h) => {
      for (let c = 0; c < this._domNodeListeners.length; c++) {
        const u = this._domNodeListeners[c];
        u.domNode === h && (this._domNodeListeners.splice(c, 1), u.dispose());
      }
    }, l = (h) => {
      h.getOption(61) || r(h.getContainerDomNode());
    };
    this._register(o.onCodeEditorAdd(l)), this._register(o.onCodeEditorRemove(((h) => {
      h.getOption(61) || a(h.getContainerDomNode());
    }))), o.listCodeEditors().forEach(l);
    const d = (h) => {
      r(h.getContainerDomNode());
    };
    this._register(o.onDiffEditorAdd(d)), this._register(o.onDiffEditorRemove(((h) => {
      a(h.getContainerDomNode());
    }))), o.listDiffEditors().forEach(d);
  }
  addDynamicKeybinding(n, e, t, i) {
    return yr(dt.registerCommand(n, t), this.addDynamicKeybindings([{ keybinding: e, command: n, when: i }]));
  }
  addDynamicKeybindings(n) {
    const e = n.map(((t) => {
      var i;
      return { keybinding: kE(t.keybinding, Gs), command: (i = t.command) !== null && i !== void 0 ? i : null, commandArgs: t.commandArgs, when: t.when, weight1: 1e3, weight2: 0, extensionId: null, isBuiltinExtension: !1 };
    }));
    return this._dynamicKeybindings = this._dynamicKeybindings.concat(e), this.updateResolver(), ye((() => {
      for (let t = 0; t < this._dynamicKeybindings.length; t++) if (this._dynamicKeybindings[t] === e[0]) return this._dynamicKeybindings.splice(t, e.length), void this.updateResolver();
    }));
  }
  updateResolver() {
    this._cachedResolver = null, this._onDidUpdateKeybindings.fire();
  }
  _getResolver() {
    if (!this._cachedResolver) {
      const n = this._toNormalizedKeybindingItems(Es.getDefaultKeybindings(), !0), e = this._toNormalizedKeybindingItems(this._dynamicKeybindings, !1);
      this._cachedResolver = new m0(n, e, ((t) => this._log(t)));
    }
    return this._cachedResolver;
  }
  _documentHasFocus() {
    return It.document.hasFocus();
  }
  _toNormalizedKeybindingItems(n, e) {
    const t = [];
    let i = 0;
    for (const s of n) {
      const o = s.when || void 0, r = s.keybinding;
      if (r) {
        const a = Dv.resolveKeybinding(r, Gs);
        for (const l of a) t[i++] = new x3(l, s.command, s.commandArgs, o, e, null, !1);
      } else t[i++] = new x3(void 0, s.command, s.commandArgs, o, e, null, !1);
    }
    return t;
  }
  resolveKeyboardEvent(n) {
    const e = new Od(n.ctrlKey, n.shiftKey, n.altKey, n.metaKey, n.keyCode);
    return new Dv([e], Gs);
  }
};
of = Fc([Cn(0, Te), Cn(1, ai), Cn(2, es), Cn(3, Ri), Cn(4, ts), Cn(5, mt)], of);
class ine extends V {
  constructor(e, t) {
    super(), this.domNode = e, this._register(t);
  }
}
function SF(n) {
  return n && typeof n == "object" && (!n.overrideIdentifier || typeof n.overrideIdentifier == "string") && (!n.resource || n.resource instanceof Ie);
}
class FV {
  constructor() {
    this._onDidChangeConfiguration = new F(), this.onDidChangeConfiguration = this._onDidChangeConfiguration.event;
    const e = new Xie();
    this._configuration = new bL(e.reload(), new En(), new En(), new En()), e.dispose();
  }
  getValue(e, t) {
    const i = typeof e == "string" ? e : void 0, s = SF(e) ? e : SF(t) ? t : {};
    return this._configuration.getValue(i, s, void 0);
  }
  updateValues(e) {
    const t = { data: this._configuration.toData() }, i = [];
    for (const s of e) {
      const [o, r] = s;
      this.getValue(o) !== r && (this._configuration.updateValue(o, r), i.push(o));
    }
    if (i.length > 0) {
      const s = new dee({ keys: i, overrides: [] }, t, this._configuration);
      s.source = 8, this._onDidChangeConfiguration.fire(s);
    }
    return Promise.resolve();
  }
  updateValue(e, t, i, s) {
    return this.updateValues([[e, t]]);
  }
  inspect(e, t = {}) {
    return this._configuration.inspect(e, t, void 0);
  }
}
let T2 = class {
  constructor(n, e, t) {
    this.configurationService = n, this.modelService = e, this.languageService = t, this._onDidChangeConfiguration = new F(), this.configurationService.onDidChangeConfiguration(((i) => {
      this._onDidChangeConfiguration.fire({ affectedKeys: i.affectedKeys, affectsConfiguration: (s, o) => i.affectsConfiguration(o) });
    }));
  }
  getValue(n, e, t) {
    const i = W.isIPosition(e) ? e : null, s = i ? typeof t == "string" ? t : void 0 : typeof e == "string" ? e : void 0, o = n ? this.getLanguage(n, i) : void 0;
    return s === void 0 ? this.configurationService.getValue({ resource: n, overrideIdentifier: o }) : this.configurationService.getValue(s, { resource: n, overrideIdentifier: o });
  }
  getLanguage(n, e) {
    const t = this.modelService.getModel(n);
    return t ? e ? t.getLanguageIdAtPosition(e.lineNumber, e.column) : t.getLanguageId() : this.languageService.guessLanguageIdByFilepathOrFirstLine(n);
  }
};
T2 = Fc([Cn(0, Ye), Cn(1, ni), Cn(2, Xt)], T2);
let R2 = class {
  constructor(n) {
    this.configurationService = n;
  }
  getEOL(n, e) {
    const t = this.configurationService.getValue("files.eol", { overrideIdentifier: e, resource: n });
    return t && typeof t == "string" && t !== "auto" ? t : Cs || Je ? `
` : `\r
`;
  }
};
R2 = Fc([Cn(0, Ye)], R2);
class Uv {
  constructor() {
    const e = Ie.from({ scheme: Uv.SCHEME, authority: "model", path: "/" });
    this.workspace = { id: BW, folders: [new Lee({ uri: e, name: "", index: 0 })] };
  }
  getWorkspace() {
    return this.workspace;
  }
  getWorkspaceFolder(e) {
    return e && e.scheme === Uv.SCHEME ? this.workspace.folders[0] : null;
  }
}
function Jy(n, e, t) {
  if (!e || !(n instanceof FV)) return;
  const i = [];
  Object.keys(e).forEach(((s) => {
    (function(o) {
      return L3()[`editor.${o}`] || !1;
    })(s) && i.push([`editor.${s}`, e[s]]), t && (function(o) {
      return L3()[`diffEditor.${o}`] || !1;
    })(s) && i.push([`diffEditor.${s}`, e[s]]);
  })), i.length > 0 && n.updateValues(i);
}
Uv.SCHEME = "inmemory";
let A2 = class {
  constructor(n) {
    this._modelService = n;
  }
  hasPreviewHandler() {
    return !1;
  }
  async apply(n, e) {
    const t = Array.isArray(n) ? n : kA.convert(n), i = /* @__PURE__ */ new Map();
    for (const r of t) {
      if (!(r instanceof ic)) throw new Error("bad edit - only text edits are supported");
      const a = this._modelService.getModel(r.resource);
      if (!a) throw new Error("bad edit - model not found");
      if (typeof r.versionId == "number" && a.getVersionId() !== r.versionId) throw new Error("bad state - model changed in the meantime");
      let l = i.get(a);
      l || (l = [], i.set(a, l)), l.push(ii.replaceMove(D.lift(r.textEdit.range), r.textEdit.text));
    }
    let s = 0, o = 0;
    for (const [r, a] of i) r.pushStackElement(), r.pushEditOperations([], a, (() => [])), r.pushStackElement(), o += 1, s += a.length;
    return { ariaSummary: sg(KI.bulkEditServiceSummary, s, o), isApplied: s > 0 };
  }
};
A2 = Fc([Cn(0, ni)], A2);
let P2 = class extends see {
  constructor(n, e) {
    super(n), this._codeEditorService = e;
  }
  showContextView(n, e, t) {
    if (!e) {
      const i = this._codeEditorService.getFocusedCodeEditor() || this._codeEditorService.getActiveCodeEditor();
      i && (e = i.getContainerDomNode());
    }
    return super.showContextView(n, e, t);
  }
};
P2 = Fc([Cn(0, Ac), Cn(1, mt)], P2);
let O2 = class extends QI {
  constructor(n, e, t, i, s, o) {
    super(n, e, t, i, s, o), this.configure({ blockMouse: !1 });
  }
};
O2 = Fc([Cn(0, es), Cn(1, Ri), Cn(2, zd), Cn(3, Dt), Cn(4, Mo), Cn(5, Te)], O2);
var Me;
rt(Ye, FV, 0), rt(xR, T2, 0), rt(eB, R2, 0), rt(gg, Uv, 0), rt($m, class {
  getUriLabel(n, e) {
    return n.scheme === "file" ? n.fsPath : n.path;
  }
  getUriBasenameLabel(n) {
    return ir(n);
  }
}, 0), rt(es, class {
  publicLog2() {
  }
}, 0), rt(E1, class {
  async confirm(n) {
    return { confirmed: this.doConfirm(n.message, n.detail), checkboxChecked: !1 };
  }
  doConfirm(n, e) {
    let t = n;
    return e && (t = t + `

` + e), It.confirm(t);
  }
  async prompt(n) {
    var e, t;
    let i;
    if (this.doConfirm(n.message, n.detail)) {
      const s = [...(e = n.buttons) !== null && e !== void 0 ? e : []];
      n.cancelButton && typeof n.cancelButton != "string" && typeof n.cancelButton != "boolean" && s.push(n.cancelButton), i = await ((t = s[0]) === null || t === void 0 ? void 0 : t.run({ checkboxChecked: !1 }));
    }
    return { result: i };
  }
  async error(n, e) {
    await this.prompt({ type: ki.Error, message: n, detail: e });
  }
}, 0), rt(cA, class {
  constructor() {
    this.isExtensionDevelopment = !1, this.isBuilt = !1;
  }
}, 0), rt(Ri, zv, 0), rt(kl, ph, 0), rt(Xt, class extends Ev {
  constructor() {
    super();
  }
}, 0), rt(Ro, class extends V {
  constructor() {
    super(), this._onColorThemeChange = this._register(new F()), this.onDidColorThemeChange = this._onColorThemeChange.event, this._onProductIconThemeChange = this._register(new F()), this.onDidProductIconThemeChange = this._onProductIconThemeChange.event, this._environment = /* @__PURE__ */ Object.create(null), this._builtInProductIconTheme = new _F(), this._autoDetectHighContrast = !0, this._knownThemes = /* @__PURE__ */ new Map(), this._knownThemes.set(td, Ub(td)), this._knownThemes.set(bm, Ub(bm)), this._knownThemes.set($u, Ub($u)), this._knownThemes.set(Gu, Ub(Gu));
    const n = this._register((function(e) {
      const t = new G(), i = t.add(new F()), s = EV();
      return t.add(s.onDidChange((() => i.fire()))), e && t.add(e.onDidProductIconThemeChange((() => i.fire()))), { dispose: () => t.dispose(), onDidChange: i.event, getCSS() {
        const o = e ? e.getProductIconTheme() : new _F(), r = {}, a = (d) => {
          const h = o.getIcon(d);
          if (!h) return;
          const c = h.font;
          return c ? (r[c.id] = c.definition, `.codicon-${d.id}:before { content: '${h.fontCharacter}'; font-family: ${kO(c.id)}; }`) : `.codicon-${d.id}:before { content: '${h.fontCharacter}'; }`;
        }, l = [];
        for (const d of s.getIcons()) {
          const h = a(d);
          h && l.push(h);
        }
        for (const d in r) {
          const h = r[d], c = h.weight ? `font-weight: ${h.weight};` : "", u = h.style ? `font-style: ${h.style};` : "", g = h.src.map(((p) => `${wc(p.location)} format('${p.format}')`)).join(", ");
          l.push(`@font-face { src: ${g}; font-family: ${kO(d)};${c}${u} font-display: block; }`);
        }
        return l.join(`
`);
      } };
    })(this));
    this._codiconCSS = n.getCSS(), this._themeCSS = "", this._allCSS = `${this._codiconCSS}
${this._themeCSS}`, this._globalStyleElement = null, this._styleElements = [], this._colorMapOverride = null, this.setTheme(td), this._onOSSchemeChanged(), this._register(n.onDidChange((() => {
      this._codiconCSS = n.getCSS(), this._updateCSS();
    }))), n8(It, "(forced-colors: active)", (() => {
      this._onOSSchemeChanged();
    }));
  }
  registerEditorContainer(n) {
    return Kw(n) ? this._registerShadowDomContainer(n) : this._registerRegularEditorContainer();
  }
  _registerRegularEditorContainer() {
    return this._globalStyleElement || (this._globalStyleElement = Lo(void 0, ((n) => {
      n.className = "monaco-colors", n.textContent = this._allCSS;
    })), this._styleElements.push(this._globalStyleElement)), V.None;
  }
  _registerShadowDomContainer(n) {
    const e = Lo(n, ((t) => {
      t.className = "monaco-colors", t.textContent = this._allCSS;
    }));
    return this._styleElements.push(e), { dispose: () => {
      for (let t = 0; t < this._styleElements.length; t++) if (this._styleElements[t] === e) return void this._styleElements.splice(t, 1);
    } };
  }
  defineTheme(n, e) {
    if (!/^[a-z0-9\-]+$/i.test(n)) throw new Error("Illegal theme name!");
    if (!ew(e.base) && !ew(n)) throw new Error("Illegal theme base!");
    this._knownThemes.set(n, new AV(n, e)), ew(n) && this._knownThemes.forEach(((t) => {
      t.base === n && t.notifyBaseUpdated();
    })), this._theme.themeName === n && this.setTheme(n);
  }
  getColorTheme() {
    return this._theme;
  }
  setColorMapOverride(n) {
    this._colorMapOverride = n, this._updateThemeOrColorMap();
  }
  setTheme(n) {
    let e;
    e = this._knownThemes.has(n) ? this._knownThemes.get(n) : this._knownThemes.get(td), this._updateActualTheme(e);
  }
  _updateActualTheme(n) {
    n && this._theme !== n && (this._theme = n, this._updateThemeOrColorMap());
  }
  _onOSSchemeChanged() {
    if (this._autoDetectHighContrast) {
      const n = It.matchMedia("(forced-colors: active)").matches;
      if (n !== aa(this._theme.type)) {
        let e;
        e = zm(this._theme.type) ? n ? $u : bm : n ? Gu : td, this._updateActualTheme(this._knownThemes.get(e));
      }
    }
  }
  setAutoDetectHighContrast(n) {
    this._autoDetectHighContrast = n, this._onOSSchemeChanged();
  }
  _updateThemeOrColorMap() {
    const n = [], e = {}, t = { addRule: (o) => {
      e[o] || (n.push(o), e[o] = !0);
    } };
    Bie.getThemingParticipants().forEach(((o) => o(this._theme, t, this._environment)));
    const i = [];
    for (const o of RV.getColors()) {
      const r = this._theme.getColor(o.id, !0);
      r && i.push(`${AR(o.id)}: ${r.toString()};`);
    }
    t.addRule(`.monaco-editor, .monaco-diff-editor, .monaco-component { ${i.join(`
`)} }`);
    const s = this._colorMapOverride || this._theme.tokenTheme.getColorMap();
    t.addRule((function(o) {
      const r = [];
      for (let a = 1, l = o.length; a < l; a++) {
        const d = o[a];
        r[a] = `.mtk${a} { color: ${d}; }`;
      }
      return r.push(".mtki { font-style: italic; }"), r.push(".mtkb { font-weight: bold; }"), r.push(".mtku { text-decoration: underline; text-underline-position: under; }"), r.push(".mtks { text-decoration: line-through; }"), r.push(".mtks.mtku { text-decoration: underline line-through; text-underline-position: under; }"), r.join(`
`);
    })(s)), this._themeCSS = n.join(`
`), this._updateCSS(), ci.setColorMap(s), this._onColorThemeChange.fire(this._theme);
  }
  _updateCSS() {
    this._allCSS = `${this._codiconCSS}
${this._themeCSS}`, this._styleElements.forEach(((n) => n.textContent = this._allCSS));
  }
  getFileIconTheme() {
    return { hasFileIcons: !1, hasFolderIcons: !1, hidesExplorerArrows: !1 };
  }
  getProductIconTheme() {
    return this._builtInProductIconTheme;
  }
}, 0), rt(ts, class extends Jie {
  constructor() {
    super(new Pj());
  }
}, 0), rt(ni, $C, 0), rt(RR, n2, 0), rt(Te, E2, 0), rt(FW, class {
  withProgress(n, e, t) {
    return e({ report: () => {
    } });
  }
}, 0), rt(Nc, VL, 0), rt(Nr, class extends xL {
  constructor() {
    super(), this.applicationStorage = this._register(new _m(new XD(), { hint: fm.STORAGE_IN_MEMORY })), this.profileStorage = this._register(new _m(new XD(), { hint: fm.STORAGE_IN_MEMORY })), this.workspaceStorage = this._register(new _m(new XD(), { hint: fm.STORAGE_IN_MEMORY })), this._register(this.workspaceStorage.onDidChangeStorage(((n) => this.emitDidChangeValue(1, n)))), this._register(this.profileStorage.onDidChangeStorage(((n) => this.emitDidChangeValue(0, n)))), this._register(this.applicationStorage.onDidChangeStorage(((n) => this.emitDidChangeValue(-1, n))));
  }
  getStorage(n) {
    switch (n) {
      case -1:
        return this.applicationStorage;
      case 0:
        return this.profileStorage;
      default:
        return this.workspaceStorage;
    }
  }
}, 0), rt(Qo, KE, 0), rt(M1, A2, 0), rt(WW, class {
  constructor() {
    this._neverEmitter = new F(), this.onDidChangeTrust = this._neverEmitter.event;
  }
  isWorkspaceTrusted() {
    return !0;
  }
}, 0), rt(Ps, I2, 0), rt(or, L2, 0), rt(Jo, class {
  get lastFocusedList() {
    return this._lastFocusedWidget;
  }
  constructor() {
    this.disposables = new G(), this.lists = [], this._lastFocusedWidget = void 0, this._hasCreatedStyleController = !1;
  }
  setLastFocusedList(n) {
    var e, t;
    n !== this._lastFocusedWidget && ((e = this._lastFocusedWidget) === null || e === void 0 || e.getHTMLElement().classList.remove("last-focused"), this._lastFocusedWidget = n, (t = this._lastFocusedWidget) === null || t === void 0 || t.getHTMLElement().classList.add("last-focused"));
  }
  register(n, e) {
    if (this._hasCreatedStyleController || (this._hasCreatedStyleController = !0, new ZW(Lo(), "").style(Ig)), this.lists.some(((i) => i.widget === n))) throw new Error("Cannot register the same widget multiple times");
    const t = { widget: n, extraContextKeys: e };
    return this.lists.push(t), HS(n.getHTMLElement()) && this.setLastFocusedList(n), yr(n.onDidFocus((() => this.setLastFocusedList(n))), ye((() => this.lists.splice(this.lists.indexOf(t), 1))), n.onDidDispose((() => {
      this.lists = this.lists.filter(((i) => i !== t)), this._lastFocusedWidget === n && this.setLastFocusedList(void 0);
    })));
  }
  dispose() {
    this.disposables.dispose();
  }
}, 0), rt(ai, M2, 0), rt(Dt, of, 0), rt(Sa, y2, 0), rt(zd, P2, 0), rt(Fs, i2, 0), rt(Kd, iw, 0), rt(io, O2, 0), rt(Mo, k2, 0), rt(Oc, class {
  async playSignal(n, e) {
  }
}, 0), (function(n) {
  const e = new N1();
  for (const [r, a] of UO()) e.set(r, a);
  const t = new Qy(e, !0);
  e.set(Se, t), n.get = function(r) {
    i || o({});
    const a = e.get(r);
    if (!a) throw new Error("Missing service " + r);
    return a instanceof Wa ? t.invokeFunction(((l) => l.get(r))) : a;
  };
  let i = !1;
  const s = new F();
  function o(r) {
    if (i) return t;
    i = !0;
    for (const [l, d] of UO()) e.get(l) || e.set(l, d);
    for (const l in r) if (r.hasOwnProperty(l)) {
      const d = tt(l);
      e.get(d) instanceof Wa && e.set(d, r[l]);
    }
    const a = ene();
    for (const l of a) try {
      t.createInstance(l);
    } catch (d) {
      We(d);
    }
    return s.fire(), t;
  }
  n.initialize = o, n.withServices = function(r) {
    if (i) return r();
    const a = new G(), l = a.add(s.event((() => {
      l.dispose(), a.add(r());
    })));
    return a;
  };
})(Me || (Me = {}));
class wa {
  static capture(e) {
    if (e.getScrollTop() === 0 || e.hasPendingScrollAnimation()) return new wa(e.getScrollTop(), e.getContentHeight(), null, 0, null);
    let t = null, i = 0;
    const s = e.getVisibleRanges();
    if (s.length > 0) {
      t = s[0].getStartPosition();
      const o = e.getTopForPosition(t.lineNumber, t.column);
      i = e.getScrollTop() - o;
    }
    return new wa(e.getScrollTop(), e.getContentHeight(), t, i, e.getPosition());
  }
  constructor(e, t, i, s, o) {
    this._initialScrollTop = e, this._initialContentHeight = t, this._visiblePosition = i, this._visiblePositionScrollDelta = s, this._cursorPosition = o;
  }
  restore(e) {
    if ((this._initialContentHeight !== e.getContentHeight() || this._initialScrollTop !== e.getScrollTop()) && this._visiblePosition) {
      const t = e.getTopForPosition(this._visiblePosition.lineNumber, this._visiblePosition.column);
      e.setScrollTop(t + this._visiblePositionScrollDelta);
    }
  }
  restoreRelativeVerticalPositionOfCursor(e) {
    if (this._initialContentHeight === e.getContentHeight() && this._initialScrollTop === e.getScrollTop()) return;
    const t = e.getPosition();
    if (!this._cursorPosition || !t) return;
    const i = e.getTopForLineNumber(t.lineNumber) - e.getTopForLineNumber(this._cursorPosition.lineNumber);
    e.setScrollTop(e.getScrollTop() + i);
  }
}
function GA() {
  return DN && !!DN.VSCODE_DEV;
}
function BV(n) {
  if (GA()) {
    const e = (function() {
      Kb || (Kb = /* @__PURE__ */ new Set());
      const t = globalThis;
      return t.$hotReload_applyNewExports || (t.$hotReload_applyNewExports = (i) => {
        const s = { config: { mode: void 0 }, ...i };
        for (const o of Kb) {
          const r = o(s);
          if (r) return r;
        }
      }), Kb;
    })();
    return e.add(n), { dispose() {
      e.delete(n);
    } };
  }
  return { dispose() {
  } };
}
let Kb;
function eS(n, e) {
  const t = new G(), i = n.createDecorationsCollection();
  return t.add(LL({ debugName: () => `Apply decorations from ${e.debugName}` }, ((s) => {
    const o = e.read(s);
    i.set(o);
  }))), t.add({ dispose: () => {
    i.clear();
  } }), t;
}
function T_(n, e) {
  return n.appendChild(e), ye((() => {
    n.removeChild(e);
  }));
}
GA() && BV((({ oldExports: n, newSrc: e, config: t }) => {
  if (t.mode === "patch-prototype") return (i) => {
    var s, o;
    for (const r in i) {
      const a = i[r];
      if (console.log(`[hot-reload] Patching prototype methods of '${r}'`, { exportedItem: a }), typeof a == "function" && a.prototype) {
        const l = n[r];
        if (l) {
          for (const d of Object.getOwnPropertyNames(a.prototype)) {
            const h = Object.getOwnPropertyDescriptor(a.prototype, d), c = Object.getOwnPropertyDescriptor(l.prototype, d);
            ((s = h?.value) === null || s === void 0 ? void 0 : s.toString()) !== ((o = c?.value) === null || o === void 0 ? void 0 : o.toString()) && console.log(`[hot-reload] Patching prototype method '${r}.${d}'`), Object.defineProperty(l.prototype, d, h);
          }
          i[r] = l;
        }
      }
    }
    return !0;
  };
}));
class WV extends V {
  get width() {
    return this._width;
  }
  get height() {
    return this._height;
  }
  constructor(e, t) {
    super(), this.elementSizeObserver = this._register(new oB(e, t)), this._width = lt(this, this.elementSizeObserver.getWidth()), this._height = lt(this, this.elementSizeObserver.getHeight()), this._register(this.elementSizeObserver.onDidChange(((i) => Tt(((s) => {
      this._width.set(this.elementSizeObserver.getWidth(), s), this._height.set(this.elementSizeObserver.getHeight(), s);
    })))));
  }
  observe(e) {
    this.elementSizeObserver.observe(e);
  }
  setAutomaticLayout(e) {
    e ? this.elementSizeObserver.startObserving() : this.elementSizeObserver.stopObserving();
  }
}
function LF(n, e, t) {
  let i = e.get(), s = i, o = i;
  const r = lt("animatedValue", i);
  let a = -1, l;
  function d() {
    const h = Date.now() - a;
    var c, u, g, p;
    o = Math.floor((u = s, g = i - s, (c = h) === (p = 300) ? u + g : g * (1 - Math.pow(2, -10 * c / p)) + u)), h < 300 ? l = n.requestAnimationFrame(d) : o = i, r.set(o, void 0);
  }
  return t.add(A1({ createEmptyChangeSummary: () => ({ animate: !1 }), handleChange: (h, c) => (h.didChange(e) && (c.animate = c.animate || h.change), !0) }, ((h, c) => {
    l !== void 0 && (n.cancelAnimationFrame(l), l = void 0), s = o, i = e.read(h), a = Date.now() - (c.animate ? 0 : 300), d();
  }))), r;
}
class VV extends V {
  constructor(e, t, i) {
    super(), this._register(new HL(e, i)), this._register(Ed(i, { height: t.actualHeight, top: t.actualTop }));
  }
}
class tS {
  get afterLineNumber() {
    return this._afterLineNumber.get();
  }
  constructor(e, t) {
    this._afterLineNumber = e, this.heightInPx = t, this.domNode = document.createElement("div"), this._actualTop = lt(this, void 0), this._actualHeight = lt(this, void 0), this.actualTop = this._actualTop, this.actualHeight = this._actualHeight, this.showInHiddenAreas = !0, this.onChange = this._afterLineNumber, this.onDomNodeTop = (i) => {
      this._actualTop.set(i, void 0);
    }, this.onComputedHeight = (i) => {
      this._actualHeight.set(i, void 0);
    };
  }
}
class HL {
  constructor(e, t) {
    this._editor = e, this._domElement = t, this._overlayWidgetId = "managedOverlayWidget-" + HL._counter++, this._overlayWidget = { getId: () => this._overlayWidgetId, getDomNode: () => this._domElement, getPosition: () => null }, this._editor.addOverlayWidget(this._overlayWidget);
  }
  dispose() {
    this._editor.removeOverlayWidget(this._overlayWidget);
  }
}
function Ed(n, e) {
  return Ge(((t) => {
    for (let [i, s] of Object.entries(e)) s && typeof s == "object" && "read" in s && (s = s.read(t)), typeof s == "number" && (s = `${s}px`), i = i.replace(/[A-Z]/g, ((o) => "-" + o.toLowerCase())), n.style[i] = s;
  }));
}
function gr(n, e) {
  return (function(t, i) {
    GA() && Hn("reload", ((s) => BV((({ oldExports: o }) => {
      if ([...Object.values(o)].some(((r) => t.includes(r)))) return (r) => (s(void 0), !0);
    })))).read(i);
  })([n], e), n;
}
function iS(n, e, t, i) {
  const s = new G(), o = [];
  return s.add(nr(((r, a) => {
    const l = e.read(r), d = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Map();
    t && t(!0), n.changeViewZones(((c) => {
      for (const u of o) c.removeZone(u), i?.delete(u);
      o.length = 0;
      for (const u of l) {
        const g = c.addZone(u);
        u.setZoneId && u.setZoneId(g), o.push(g), i?.add(g), d.set(u, g);
      }
    })), t && t(!1), a.add(A1({ createEmptyChangeSummary: () => ({ zoneIds: [] }), handleChange(c, u) {
      const g = h.get(c.changedObservable);
      return g !== void 0 && u.zoneIds.push(g), !0;
    } }, ((c, u) => {
      for (const g of l) g.onChange && (h.set(g.onChange, d.get(g)), g.onChange.read(c));
      t && t(!0), n.changeViewZones(((g) => {
        for (const p of u.zoneIds) g.layoutZone(p);
      })), t && t(!1);
    })));
  }))), s.add({ dispose() {
    t && t(!0), n.changeViewZones(((r) => {
      for (const a of o) r.removeZone(a);
    })), i?.clear(), t && t(!1);
  } }), s;
}
HL._counter = 0;
class nne extends Ci {
  dispose() {
    super.dispose(!0);
  }
}
function kF(n, e) {
  const t = iv(e, ((r) => r.original.startLineNumber <= n.lineNumber));
  if (!t) return D.fromPositions(n);
  if (t.original.endLineNumberExclusive <= n.lineNumber) {
    const r = n.lineNumber - t.original.endLineNumberExclusive + t.modified.endLineNumberExclusive;
    return D.fromPositions(new W(r, n.column));
  }
  if (!t.innerChanges) return D.fromPositions(new W(t.modified.startLineNumber, 1));
  const i = iv(t.innerChanges, ((r) => r.originalRange.getStartPosition().isBeforeOrEqual(n)));
  if (!i) {
    const r = n.lineNumber - t.original.startLineNumber + t.modified.startLineNumber;
    return D.fromPositions(new W(r, n.column));
  }
  if (i.originalRange.containsPosition(n)) return i.modifiedRange;
  {
    const r = (s = i.originalRange.getEndPosition(), o = n, s.lineNumber === o.lineNumber ? new kr(0, o.column - s.column) : new kr(o.lineNumber - s.lineNumber, o.column - 1));
    return D.fromPositions(r.addToPosition(i.modifiedRange.getEndPosition()));
  }
  var s, o;
}
function Ml(n, e, t) {
  const i = n.bindTo(e);
  return LL({ debugName: () => `Set Context Key "${n.key}"` }, ((s) => {
    i.set(t(s));
  }));
}
var ZA = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, YA = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const sne = Ei("diff-review-insert", ne.add, m(0, "Icon for 'Insert' in accessible diff viewer.")), one = Ei("diff-review-remove", ne.remove, m(0, "Icon for 'Remove' in accessible diff viewer.")), rne = Ei("diff-review-close", ne.close, m(0, "Icon for 'Close' in accessible diff viewer."));
let Vh = class extends V {
  constructor(n, e, t, i, s, o, r, a, l) {
    super(), this._parentNode = n, this._visible = e, this._setVisible = t, this._canClose = i, this._width = s, this._height = o, this._diffs = r, this._models = a, this._instantiationService = l, this._state = vf(this, ((d, h) => {
      const c = this._visible.read(d);
      if (this._parentNode.style.visibility = c ? "visible" : "hidden", !c) return null;
      const u = h.add(this._instantiationService.createInstance(F2, this._diffs, this._models, this._setVisible, this._canClose));
      return { model: u, view: h.add(this._instantiationService.createInstance(B2, this._parentNode, u, this._width, this._height, this._models)) };
    })).recomputeInitiallyAndOnChange(this._store);
  }
  next() {
    Tt(((n) => {
      const e = this._visible.get();
      this._setVisible(!0, n), e && this._state.get().model.nextGroup(n);
    }));
  }
  prev() {
    Tt(((n) => {
      this._setVisible(!0, n), this._state.get().model.previousGroup(n);
    }));
  }
  close() {
    Tt(((n) => {
      this._setVisible(!1, n);
    }));
  }
};
Vh._ttPolicy = Hd("diffReview", { createHTML: (n) => n }), Vh = ZA([YA(8, Se)], Vh);
let F2 = class extends V {
  constructor(n, e, t, i, s) {
    super(), this._diffs = n, this._models = e, this._setVisible = t, this.canClose = i, this._accessibilitySignalService = s, this._groups = lt(this, []), this._currentGroupIdx = lt(this, 0), this._currentElementIdx = lt(this, 0), this.groups = this._groups, this.currentGroup = this._currentGroupIdx.map(((o, r) => this._groups.read(r)[o])), this.currentGroupIndex = this._currentGroupIdx, this.currentElement = this._currentElementIdx.map(((o, r) => {
      var a;
      return (a = this.currentGroup.read(r)) === null || a === void 0 ? void 0 : a.lines[o];
    })), this._register(Ge(((o) => {
      const r = this._diffs.read(o);
      if (!r) return void this._groups.set([], void 0);
      const a = (function(l, d, h) {
        const c = [];
        for (const u of HT(l, ((g, p) => p.modified.startLineNumber - g.modified.endLineNumberExclusive < 2 * $f))) {
          const g = [];
          g.push(new lne());
          const p = new je(Math.max(1, u[0].original.startLineNumber - $f), Math.min(u[u.length - 1].original.endLineNumberExclusive + $f, d + 1)), f = new je(Math.max(1, u[0].modified.startLineNumber - $f), Math.min(u[u.length - 1].modified.endLineNumberExclusive + $f, h + 1));
          g7(u, ((b, C) => {
            const w = new je(b ? b.original.endLineNumberExclusive : p.startLineNumber, C ? C.original.startLineNumber : p.endLineNumberExclusive), y = new je(b ? b.modified.endLineNumberExclusive : f.startLineNumber, C ? C.modified.startLineNumber : f.endLineNumberExclusive);
            w.forEach(((L) => {
              g.push(new cne(L, y.startLineNumber + (L - w.startLineNumber)));
            })), C && (C.original.forEach(((L) => {
              g.push(new dne(C, L));
            })), C.modified.forEach(((L) => {
              g.push(new hne(C, L));
            })));
          }));
          const _ = u[0].modified.join(u[u.length - 1].modified), v = u[0].original.join(u[u.length - 1].original);
          c.push(new ane(new us(_, v), g));
        }
        return c;
      })(r, this._models.getOriginalModel().getLineCount(), this._models.getModifiedModel().getLineCount());
      Tt(((l) => {
        const d = this._models.getModifiedPosition();
        if (d) {
          const h = a.findIndex(((c) => d?.lineNumber < c.range.modified.endLineNumberExclusive));
          h !== -1 && this._currentGroupIdx.set(h, l);
        }
        this._groups.set(a, l);
      }));
    }))), this._register(Ge(((o) => {
      const r = this.currentElement.read(o);
      r?.type === ds.Deleted ? this._accessibilitySignalService.playSignal(He.diffLineDeleted, { source: "accessibleDiffViewer.currentElementChanged" }) : r?.type === ds.Added && this._accessibilitySignalService.playSignal(He.diffLineInserted, { source: "accessibleDiffViewer.currentElementChanged" });
    }))), this._register(Ge(((o) => {
      var r;
      const a = this.currentElement.read(o);
      if (a && a.type !== ds.Header) {
        const l = (r = a.modifiedLineNumber) !== null && r !== void 0 ? r : a.diff.modified.startLineNumber;
        this._models.modifiedSetSelection(D.fromPositions(new W(l, 1)));
      }
    })));
  }
  _goToGroupDelta(n, e) {
    const t = this.groups.get();
    !t || t.length <= 1 || Mv(e, ((i) => {
      this._currentGroupIdx.set(qe.ofLength(t.length).clipCyclic(this._currentGroupIdx.get() + n), i), this._currentElementIdx.set(0, i);
    }));
  }
  nextGroup(n) {
    this._goToGroupDelta(1, n);
  }
  previousGroup(n) {
    this._goToGroupDelta(-1, n);
  }
  _goToLineDelta(n) {
    const e = this.currentGroup.get();
    !e || e.lines.length <= 1 || Tt(((t) => {
      this._currentElementIdx.set(qe.ofLength(e.lines.length).clip(this._currentElementIdx.get() + n), t);
    }));
  }
  goToNextLine() {
    this._goToLineDelta(1);
  }
  goToPreviousLine() {
    this._goToLineDelta(-1);
  }
  goToLine(n) {
    const e = this.currentGroup.get();
    if (!e) return;
    const t = e.lines.indexOf(n);
    t !== -1 && Tt(((i) => {
      this._currentElementIdx.set(t, i);
    }));
  }
  revealCurrentElementInEditor() {
    if (!this.canClose.get()) return;
    this._setVisible(!1, void 0);
    const n = this.currentElement.get();
    n && (n.type === ds.Deleted ? this._models.originalReveal(D.fromPositions(new W(n.originalLineNumber, 1))) : this._models.modifiedReveal(n.type !== ds.Header ? D.fromPositions(new W(n.modifiedLineNumber, 1)) : void 0));
  }
  close() {
    this.canClose.get() && (this._setVisible(!1, void 0), this._models.modifiedFocus());
  }
};
F2 = ZA([YA(4, Oc)], F2);
const $f = 3;
var ds;
(function(n) {
  n[n.Header = 0] = "Header", n[n.Unchanged = 1] = "Unchanged", n[n.Deleted = 2] = "Deleted", n[n.Added = 3] = "Added";
})(ds || (ds = {}));
class ane {
  constructor(e, t) {
    this.range = e, this.lines = t;
  }
}
class lne {
  constructor() {
    this.type = ds.Header;
  }
}
class dne {
  constructor(e, t) {
    this.diff = e, this.originalLineNumber = t, this.type = ds.Deleted, this.modifiedLineNumber = void 0;
  }
}
class hne {
  constructor(e, t) {
    this.diff = e, this.modifiedLineNumber = t, this.type = ds.Added, this.originalLineNumber = void 0;
  }
}
class cne {
  constructor(e, t) {
    this.originalLineNumber = e, this.modifiedLineNumber = t, this.type = ds.Unchanged;
  }
}
let B2 = class extends V {
  constructor(n, e, t, i, s, o) {
    super(), this._element = n, this._model = e, this._width = t, this._height = i, this._models = s, this._languageService = o, this.domNode = this._element, this.domNode.className = "monaco-component diff-review monaco-editor-background";
    const r = document.createElement("div");
    r.className = "diff-review-actions", this._actionBar = this._register(new sr(r)), this._register(Ge(((a) => {
      this._actionBar.clear(), this._model.canClose.read(a) && this._actionBar.push(new Qs("diffreview.close", m(0, "Close"), "close-diff-review " + Ee.asClassName(rne), !0, (async () => e.close())), { label: !1, icon: !0 });
    }))), this._content = document.createElement("div"), this._content.className = "diff-review-content", this._content.setAttribute("role", "code"), this._scrollbar = this._register(new S1(this._content, {})), wn(this.domNode, this._scrollbar.getDomNode(), r), this._register(Ge(((a) => {
      this._height.read(a), this._width.read(a), this._scrollbar.scanDomNode();
    }))), this._register(ye((() => {
      wn(this.domNode);
    }))), this._register(Ed(this.domNode, { width: this._width, height: this._height })), this._register(Ed(this._content, { width: this._width, height: this._height })), this._register(nr(((a, l) => {
      this._model.currentGroup.read(a), this._render(l);
    }))), this._register(bi(this.domNode, "keydown", ((a) => {
      (a.equals(18) || a.equals(2066) || a.equals(530)) && (a.preventDefault(), this._model.goToNextLine()), (a.equals(16) || a.equals(2064) || a.equals(528)) && (a.preventDefault(), this._model.goToPreviousLine()), (a.equals(9) || a.equals(2057) || a.equals(521) || a.equals(1033)) && (a.preventDefault(), this._model.close()), (a.equals(10) || a.equals(3)) && (a.preventDefault(), this._model.revealCurrentElementInEditor());
    })));
  }
  _render(n) {
    const e = this._models.getOriginalOptions(), t = this._models.getModifiedOptions(), i = document.createElement("div");
    i.className = "diff-review-table", i.setAttribute("role", "list"), i.setAttribute("aria-label", m(0, "Accessible Diff Viewer. Use arrow up and down to navigate.")), yn(i, t.get(50)), wn(this._content, i);
    const s = this._models.getOriginalModel(), o = this._models.getModifiedModel();
    if (!s || !o) return;
    const r = s.getOptions(), a = o.getOptions(), l = t.get(67), d = this._model.currentGroup.get();
    for (const h of d?.lines || []) {
      if (!d) break;
      let c;
      if (h.type === ds.Header) {
        const g = document.createElement("div");
        g.className = "diff-review-row", g.setAttribute("role", "listitem");
        const p = d.range, f = this._model.currentGroupIndex.get(), _ = this._model.groups.get().length, v = (y) => y === 0 ? m(0, "no lines changed") : y === 1 ? m(0, "1 line changed") : m(0, "{0} lines changed", y), b = v(p.original.length), C = v(p.modified.length);
        g.setAttribute("aria-label", m(0, "Difference {0} of {1}: original line {2}, {3}, modified line {4}, {5}", f + 1, _, p.original.startLineNumber, b, p.modified.startLineNumber, C));
        const w = document.createElement("div");
        w.className = "diff-review-cell diff-review-summary", w.appendChild(document.createTextNode(`${f + 1}/${_}: @@ -${p.original.startLineNumber},${p.original.length} +${p.modified.startLineNumber},${p.modified.length} @@`)), g.appendChild(w), c = g;
      } else c = this._createRow(h, l, this._width.get(), e, s, r, t, o, a);
      i.appendChild(c);
      const u = Fe(((g) => this._model.currentElement.read(g) === h));
      n.add(Ge(((g) => {
        const p = u.read(g);
        c.tabIndex = p ? 0 : -1, p && c.focus();
      }))), n.add(K(c, "focus", (() => {
        this._model.goToLine(h);
      })));
    }
    this._scrollbar.scanDomNode();
  }
  _createRow(n, e, t, i, s, o, r, a, l) {
    const d = i.get(145), h = d.glyphMarginWidth + d.lineNumbersWidth, c = r.get(145), u = 10 + c.glyphMarginWidth + c.lineNumbersWidth;
    let g = "diff-review-row", p = "", f = null;
    switch (n.type) {
      case ds.Added:
        g = "diff-review-row line-insert", p = " char-insert", f = sne;
        break;
      case ds.Deleted:
        g = "diff-review-row line-delete", p = " char-delete", f = one;
    }
    const _ = document.createElement("div");
    _.style.minWidth = t + "px", _.className = g, _.setAttribute("role", "listitem"), _.ariaLevel = "";
    const v = document.createElement("div");
    v.className = "diff-review-cell", v.style.height = `${e}px`, _.appendChild(v);
    const b = document.createElement("span");
    b.style.width = h + "px", b.style.minWidth = h + "px", b.className = "diff-review-line-number" + p, n.originalLineNumber !== void 0 ? b.appendChild(document.createTextNode(String(n.originalLineNumber))) : b.innerText = " ", v.appendChild(b);
    const C = document.createElement("span");
    C.style.width = u + "px", C.style.minWidth = u + "px", C.style.paddingRight = "10px", C.className = "diff-review-line-number" + p, n.modifiedLineNumber !== void 0 ? C.appendChild(document.createTextNode(String(n.modifiedLineNumber))) : C.innerText = " ", v.appendChild(C);
    const w = document.createElement("span");
    if (w.className = "diff-review-spacer", f) {
      const k = document.createElement("span");
      k.className = Ee.asClassName(f), k.innerText = "  ", w.appendChild(k);
    } else w.innerText = "  ";
    let y;
    if (v.appendChild(w), n.modifiedLineNumber !== void 0) {
      let k = this._getLineHtml(a, r, l.tabSize, n.modifiedLineNumber, this._languageService.languageIdCodec);
      Vh._ttPolicy && (k = Vh._ttPolicy.createHTML(k)), v.insertAdjacentHTML("beforeend", k), y = a.getLineContent(n.modifiedLineNumber);
    } else {
      let k = this._getLineHtml(s, i, o.tabSize, n.originalLineNumber, this._languageService.languageIdCodec);
      Vh._ttPolicy && (k = Vh._ttPolicy.createHTML(k)), v.insertAdjacentHTML("beforeend", k), y = s.getLineContent(n.originalLineNumber);
    }
    y.length === 0 && (y = m(0, "blank"));
    let L = "";
    switch (n.type) {
      case ds.Unchanged:
        L = n.originalLineNumber === n.modifiedLineNumber ? m(0, "{0} unchanged line {1}", y, n.originalLineNumber) : m(0, "{0} original line {1} modified line {2}", y, n.originalLineNumber, n.modifiedLineNumber);
        break;
      case ds.Added:
        L = m(0, "+ {0} modified line {1}", y, n.modifiedLineNumber);
        break;
      case ds.Deleted:
        L = m(0, "- {0} original line {1}", y, n.originalLineNumber);
    }
    return _.setAttribute("aria-label", L), _;
  }
  _getLineHtml(n, e, t, i, s) {
    const o = n.getLineContent(i), r = e.get(50), a = nn.createEmpty(o, s), l = Co.isBasicASCII(o, n.mightContainNonBasicASCII()), d = Co.containsRTL(o, l, n.mightContainRTL());
    return ty(new Sc(r.isMonospace && !e.get(33), r.canUseHalfwidthRightwardsArrow, o, !1, l, d, 0, a, [], t, 0, r.spaceWidth, r.middotWidth, r.wsmiddotWidth, e.get(117), e.get(99), e.get(94), e.get(51) !== fo.OFF, null)).html;
  }
};
B2 = ZA([YA(5, Xt)], B2);
class une {
  constructor(e) {
    this.editors = e;
  }
  getOriginalModel() {
    return this.editors.original.getModel();
  }
  getOriginalOptions() {
    return this.editors.original.getOptions();
  }
  originalReveal(e) {
    this.editors.original.revealRange(e), this.editors.original.setSelection(e), this.editors.original.focus();
  }
  getModifiedModel() {
    return this.editors.modified.getModel();
  }
  getModifiedOptions() {
    return this.editors.modified.getOptions();
  }
  modifiedReveal(e) {
    e && (this.editors.modified.revealRange(e), this.editors.modified.setSelection(e)), this.editors.modified.focus();
  }
  modifiedSetSelection(e) {
    this.editors.modified.setSelection(e);
  }
  modifiedFocus() {
    this.editors.modified.focus();
  }
  getModifiedPosition() {
    var e;
    return (e = this.editors.modified.getPosition()) !== null && e !== void 0 ? e : void 0;
  }
}
class oc extends V {
  constructor(e, t, i, s, o) {
    super(), this._rootElement = e, this._diffModel = t, this._originalEditorLayoutInfo = i, this._modifiedEditorLayoutInfo = s, this._editors = o, this._originalScrollTop = Rt(this._editors.original.onDidScrollChange, (() => this._editors.original.getScrollTop())), this._modifiedScrollTop = Rt(this._editors.modified.onDidScrollChange, (() => this._editors.modified.getScrollTop())), this._viewZonesChanged = Hn("onDidChangeViewZones", this._editors.modified.onDidChangeViewZones), this.width = lt(this, 0), this._modifiedViewZonesChangedSignal = Hn("modified.onDidChangeViewZones", this._editors.modified.onDidChangeViewZones), this._originalViewZonesChangedSignal = Hn("original.onDidChangeViewZones", this._editors.original.onDidChangeViewZones), this._state = vf(this, ((h, c) => {
      var u;
      this._element.replaceChildren();
      const g = this._diffModel.read(h), p = (u = g?.diff.read(h)) === null || u === void 0 ? void 0 : u.movedTexts;
      if (!p || p.length === 0) return void this.width.set(0, void 0);
      this._viewZonesChanged.read(h);
      const f = this._originalEditorLayoutInfo.read(h), _ = this._modifiedEditorLayoutInfo.read(h);
      if (!f || !_) return void this.width.set(0, void 0);
      this._modifiedViewZonesChangedSignal.read(h), this._originalViewZonesChangedSignal.read(h);
      const v = p.map(((k) => {
        function N(me, ue) {
          return (ue.getTopForLineNumber(me.startLineNumber, !0) + ue.getTopForLineNumber(me.endLineNumberExclusive, !0)) / 2;
        }
        const A = N(k.lineRangeMapping.original, this._editors.original), B = this._originalScrollTop.read(h), T = N(k.lineRangeMapping.modified, this._editors.modified), O = A - B, H = T - this._modifiedScrollTop.read(h), $ = Math.min(A, T), pe = Math.max(A, T);
        return { range: new qe($, pe), from: O, to: H, fromWithoutScroll: A, toWithoutScroll: T, move: k };
      }));
      v.sort(/* @__PURE__ */ (function(...k) {
        return (N, A) => {
          for (const B of k) {
            const T = B(N, A);
            if (!z0.isNeitherLessOrGreaterThan(T)) return T;
          }
          return z0.neitherLessOrGreaterThan;
        };
      })(jo(((k) => k.fromWithoutScroll > k.toWithoutScroll), VU), jo(((k) => k.fromWithoutScroll > k.toWithoutScroll ? k.fromWithoutScroll : -k.toWithoutScroll), od)));
      const b = XA.compute(v.map(((k) => k.range))), C = f.verticalScrollbarWidth, w = 10 * (b.getTrackCount() - 1) + 20, y = C + w + (_.contentLeft - oc.movedCodeBlockPadding);
      let L = 0;
      for (const k of v) {
        const N = C + 10 + 10 * b.getTrack(L), A = 15, B = 15, T = y, O = _.glyphMarginWidth + _.lineNumbersWidth, H = 18, $ = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        $.classList.add("arrow-rectangle"), $.setAttribute("x", "" + (T - O)), $.setAttribute("y", "" + (k.to - H / 2)), $.setAttribute("width", `${O}`), $.setAttribute("height", `${H}`), this._element.appendChild($);
        const pe = document.createElementNS("http://www.w3.org/2000/svg", "g"), me = document.createElementNS("http://www.w3.org/2000/svg", "path");
        me.setAttribute("d", `M 0 ${k.from} L ${N} ${k.from} L ${N} ${k.to} L ${T - B} ${k.to}`), me.setAttribute("fill", "none"), pe.appendChild(me);
        const ue = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
        ue.classList.add("arrow"), c.add(Ge(((ee) => {
          me.classList.toggle("currentMove", k.move === g.activeMovedText.read(ee)), ue.classList.toggle("currentMove", k.move === g.activeMovedText.read(ee));
        }))), ue.setAttribute("points", `${T - B},${k.to - A / 2} ${T},${k.to} ${T - B},${k.to + A / 2}`), pe.appendChild(ue), this._element.appendChild(pe), L++;
      }
      this.width.set(w, void 0);
    })), this._element = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this._element.setAttribute("class", "moved-blocks-lines"), this._rootElement.appendChild(this._element), this._register(ye((() => this._element.remove()))), this._register(Ge(((h) => {
      const c = this._originalEditorLayoutInfo.read(h), u = this._modifiedEditorLayoutInfo.read(h);
      c && u && (this._element.style.left = c.width - c.verticalScrollbarWidth + "px", this._element.style.height = `${c.height}px`, this._element.style.width = `${c.verticalScrollbarWidth + c.contentLeft - oc.movedCodeBlockPadding + this.width.read(h)}px`);
    }))), this._register(P1(this._state));
    const r = Fe(((h) => {
      const c = this._diffModel.read(h), u = c?.diff.read(h);
      return u ? u.movedTexts.map(((g) => ({ move: g, original: new tS(ia(g.lineRangeMapping.original.startLineNumber - 1), 18), modified: new tS(ia(g.lineRangeMapping.modified.startLineNumber - 1), 18) }))) : [];
    }));
    this._register(iS(this._editors.original, r.map(((h) => h.map(((c) => c.original)))))), this._register(iS(this._editors.modified, r.map(((h) => h.map(((c) => c.modified)))))), this._register(nr(((h, c) => {
      const u = r.read(h);
      for (const g of u) c.add(new DF(this._editors.original, g.original, g.move, "original", this._diffModel.get())), c.add(new DF(this._editors.modified, g.modified, g.move, "modified", this._diffModel.get()));
    })));
    const a = Hn("original.onDidFocusEditorWidget", ((h) => this._editors.original.onDidFocusEditorWidget((() => setTimeout((() => h(void 0)), 0))))), l = Hn("modified.onDidFocusEditorWidget", ((h) => this._editors.modified.onDidFocusEditorWidget((() => setTimeout((() => h(void 0)), 0)))));
    let d = "modified";
    this._register(A1({ createEmptyChangeSummary: () => {
    }, handleChange: (h, c) => (h.didChange(a) && (d = "original"), h.didChange(l) && (d = "modified"), !0) }, ((h) => {
      a.read(h), l.read(h);
      const c = this._diffModel.read(h);
      if (!c) return;
      const u = c.diff.read(h);
      let g;
      if (u && d === "original") {
        const p = this._editors.originalCursor.read(h);
        p && (g = u.movedTexts.find(((f) => f.lineRangeMapping.original.contains(p.lineNumber))));
      }
      if (u && d === "modified") {
        const p = this._editors.modifiedCursor.read(h);
        p && (g = u.movedTexts.find(((f) => f.lineRangeMapping.modified.contains(p.lineNumber))));
      }
      g !== c.movedTextToCompare.get() && c.movedTextToCompare.set(void 0, void 0), c.setActiveMovedText(g);
    })));
  }
}
oc.movedCodeBlockPadding = 4;
class XA {
  static compute(e) {
    const t = [], i = [];
    for (const s of e) {
      let o = t.findIndex(((r) => !r.intersectsStrict(s)));
      o === -1 && (t.length >= 6 ? o = wq(t, jo(((a) => a.intersectWithRangeLength(s)), od)) : (o = t.length, t.push(new LR()))), t[o].addRange(s), i.push(o);
    }
    return new XA(t.length, i);
  }
  constructor(e, t) {
    this._trackCount = e, this.trackPerLineIdx = t;
  }
  getTrack(e) {
    return this.trackPerLineIdx[e];
  }
  getTrackCount() {
    return this._trackCount;
  }
}
class DF extends VV {
  constructor(e, t, i, s, o) {
    const r = yt("div.diff-hidden-lines-widget");
    super(e, t, r.root), this._editor = e, this._move = i, this._kind = s, this._diffModel = o, this._nodes = yt("div.diff-moved-code-block", { style: { marginRight: "4px" } }, [yt("div.text-content@textContent"), yt("div.action-bar@actionBar")]), r.root.appendChild(this._nodes.root);
    const a = Rt(this._editor.onDidLayoutChange, (() => this._editor.getLayoutInfo()));
    let l;
    this._register(Ed(this._nodes.root, { paddingRight: a.map(((u) => u.verticalScrollbarWidth)) })), l = i.changes.length > 0 ? this._kind === "original" ? m(0, "Code moved with changes to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : m(0, "Code moved with changes from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1) : this._kind === "original" ? m(0, "Code moved to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : m(0, "Code moved from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1);
    const d = this._register(new sr(this._nodes.actionBar, { highlightToggledItems: !0 })), h = new Qs("", l, "", !1);
    d.push(h, { icon: !1, label: !0 });
    const c = new Qs("", "Compare", Ee.asClassName(ne.compareChanges), !0, (() => {
      this._editor.focus(), this._diffModel.movedTextToCompare.set(this._diffModel.movedTextToCompare.get() === i ? void 0 : this._move, void 0);
    }));
    this._register(Ge(((u) => {
      const g = this._diffModel.movedTextToCompare.read(u) === i;
      c.checked = g;
    }))), d.push(c, { icon: !1, label: !0 });
  }
}
I("diffEditor.move.border", { dark: "#8b8b8b9c", light: "#8b8b8b9c", hcDark: "#8b8b8b9c", hcLight: "#8b8b8b9c" }, m(0, "The border color for text that got moved in the diff editor.")), I("diffEditor.moveActive.border", { dark: "#FFA500", light: "#FFA500", hcDark: "#FFA500", hcLight: "#FFA500" }, m(0, "The active border color for text that got moved in the diff editor.")), I("diffEditor.unchangedRegionShadow", { dark: "#000000", light: "#737373BF", hcDark: "#000000", hcLight: "#737373BF" }, m(0, "The color of the shadow around unchanged region widgets."));
const gne = Ei("diff-insert", ne.add, m(0, "Line decoration for inserts in the diff editor.")), HV = Ei("diff-remove", ne.remove, m(0, "Line decoration for removals in the diff editor.")), xF = Ve.register({ className: "line-insert", description: "line-insert", isWholeLine: !0, linesDecorationsClassName: "insert-sign " + Ee.asClassName(gne), marginClassName: "gutter-insert" }), NF = Ve.register({ className: "line-delete", description: "line-delete", isWholeLine: !0, linesDecorationsClassName: "delete-sign " + Ee.asClassName(HV), marginClassName: "gutter-delete" }), EF = Ve.register({ className: "line-insert", description: "line-insert", isWholeLine: !0, marginClassName: "gutter-insert" }), IF = Ve.register({ className: "line-delete", description: "line-delete", isWholeLine: !0, marginClassName: "gutter-delete" }), MF = Ve.register({ className: "char-insert", description: "char-insert", shouldFillLineOnLineBreak: !0 }), pne = Ve.register({ className: "char-insert", description: "char-insert", isWholeLine: !0 }), mne = Ve.register({ className: "char-insert diff-range-empty", description: "char-insert diff-range-empty" }), W2 = Ve.register({ className: "char-delete", description: "char-delete", shouldFillLineOnLineBreak: !0 }), fne = Ve.register({ className: "char-delete", description: "char-delete", isWholeLine: !0 }), _ne = Ve.register({ className: "char-delete diff-range-empty", description: "char-delete diff-range-empty" });
class vne extends V {
  constructor(e, t, i, s) {
    super(), this._editors = e, this._diffModel = t, this._options = i, this._decorations = Fe(this, ((o) => {
      var r;
      const a = (r = this._diffModel.read(o)) === null || r === void 0 ? void 0 : r.diff.read(o);
      if (!a) return null;
      const l = this._diffModel.read(o).movedTextToCompare.read(o), d = this._options.renderIndicators.read(o), h = this._options.showEmptyDecorations.read(o), c = [], u = [];
      if (!l) for (const p of a.mappings) if (p.lineRangeMapping.original.isEmpty || c.push({ range: p.lineRangeMapping.original.toInclusiveRange(), options: d ? NF : IF }), p.lineRangeMapping.modified.isEmpty || u.push({ range: p.lineRangeMapping.modified.toInclusiveRange(), options: d ? xF : EF }), p.lineRangeMapping.modified.isEmpty || p.lineRangeMapping.original.isEmpty) p.lineRangeMapping.original.isEmpty || c.push({ range: p.lineRangeMapping.original.toInclusiveRange(), options: fne }), p.lineRangeMapping.modified.isEmpty || u.push({ range: p.lineRangeMapping.modified.toInclusiveRange(), options: pne });
      else for (const f of p.lineRangeMapping.innerChanges || []) p.lineRangeMapping.original.contains(f.originalRange.startLineNumber) && c.push({ range: f.originalRange, options: f.originalRange.isEmpty() && h ? _ne : W2 }), p.lineRangeMapping.modified.contains(f.modifiedRange.startLineNumber) && u.push({ range: f.modifiedRange, options: f.modifiedRange.isEmpty() && h ? mne : MF });
      if (l) for (const p of l.changes) {
        const f = p.original.toInclusiveRange();
        f && c.push({ range: f, options: d ? NF : IF });
        const _ = p.modified.toInclusiveRange();
        _ && u.push({ range: _, options: d ? xF : EF });
        for (const v of p.innerChanges || []) c.push({ range: v.originalRange, options: W2 }), u.push({ range: v.modifiedRange, options: MF });
      }
      const g = this._diffModel.read(o).activeMovedText.read(o);
      for (const p of a.movedTexts) c.push({ range: p.lineRangeMapping.original.toInclusiveRange(), options: { description: "moved", blockClassName: "movedOriginal" + (p === g ? " currentMove" : ""), blockPadding: [oc.movedCodeBlockPadding, 0, oc.movedCodeBlockPadding, oc.movedCodeBlockPadding] } }), u.push({ range: p.lineRangeMapping.modified.toInclusiveRange(), options: { description: "moved", blockClassName: "movedModified" + (p === g ? " currentMove" : ""), blockPadding: [4, 0, 4, 4] } });
      return { originalDecorations: c, modifiedDecorations: u };
    })), this._register(eS(this._editors.original, this._decorations.map(((o) => o?.originalDecorations || [])))), this._register(eS(this._editors.modified, this._decorations.map(((o) => o?.modifiedDecorations || []))));
  }
}
class bne extends V {
  constructor(e, t, i, s) {
    super(), this._options = e, this._domNode = t, this._dimensions = i, this._sashes = s, this._sashRatio = lt(this, void 0), this.sashLeft = Fe(this, ((o) => {
      var r;
      const a = (r = this._sashRatio.read(o)) !== null && r !== void 0 ? r : this._options.splitViewDefaultRatio.read(o);
      return this._computeSashLeft(a, o);
    })), this._sash = this._register(new Bn(this._domNode, { getVerticalSashTop: (o) => 0, getVerticalSashLeft: (o) => this.sashLeft.get(), getVerticalSashHeight: (o) => this._dimensions.height.get() }, { orientation: 0 })), this._startSashPosition = void 0, this._register(this._sash.onDidStart((() => {
      this._startSashPosition = this.sashLeft.get();
    }))), this._register(this._sash.onDidChange(((o) => {
      const r = this._dimensions.width.get(), a = this._computeSashLeft((this._startSashPosition + (o.currentX - o.startX)) / r, void 0);
      this._sashRatio.set(a / r, void 0);
    }))), this._register(this._sash.onDidEnd((() => this._sash.layout()))), this._register(this._sash.onDidReset((() => this._sashRatio.set(void 0, void 0)))), this._register(Ge(((o) => {
      const r = this._sashes.read(o);
      r && (this._sash.orthogonalEndSash = r.bottom);
    }))), this._register(Ge(((o) => {
      const r = this._options.enableSplitViewResizing.read(o);
      this._sash.state = r ? 3 : 0, this.sashLeft.read(o), this._dimensions.height.read(o), this._sash.layout();
    })));
  }
  _computeSashLeft(e, t) {
    const i = this._dimensions.width.read(t), s = Math.floor(this._options.splitViewDefaultRatio.read(t) * i), o = this._options.enableSplitViewResizing.read(t) ? Math.floor(e * i) : s, r = 100;
    return i <= 200 ? s : o < r ? r : o > i - r ? i - r : o;
  }
}
var au, zV = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, V2 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const UV = tt("diffProviderFactoryService");
let dx = class {
  constructor(n) {
    this.instantiationService = n;
  }
  createDiffProvider(n) {
    return this.instantiationService.createInstance(nw, n);
  }
};
dx = zV([V2(0, Se)], dx), rt(UV, dx, 1);
let nw = au = class {
  constructor(n, e, t) {
    this.editorWorkerService = e, this.telemetryService = t, this.onDidChangeEventEmitter = new F(), this.onDidChange = this.onDidChangeEventEmitter.event, this.diffAlgorithm = "advanced", this.diffAlgorithmOnDidChangeSubscription = void 0, this.setOptions(n);
  }
  dispose() {
    var n;
    (n = this.diffAlgorithmOnDidChangeSubscription) === null || n === void 0 || n.dispose();
  }
  async computeDiff(n, e, t, i) {
    var s, o;
    if (typeof this.diffAlgorithm != "string") return this.diffAlgorithm.computeDiff(n, e, t, i);
    if (n.getLineCount() === 1 && n.getLineMaxColumn(1) === 1) return e.getLineCount() === 1 && e.getLineMaxColumn(1) === 1 ? { changes: [], identical: !0, quitEarly: !1, moves: [] } : { changes: [new xo(new je(1, 2), new je(1, e.getLineCount() + 1), [new Fd(n.getFullModelRange(), e.getFullModelRange())])], identical: !1, quitEarly: !1, moves: [] };
    const r = JSON.stringify([n.uri.toString(), e.uri.toString()]), a = JSON.stringify([n.id, e.id, n.getAlternativeVersionId(), e.getAlternativeVersionId(), JSON.stringify(t)]), l = au.diffCache.get(r);
    if (l && l.context === a) return l.result;
    const d = Rn.create(), h = await this.editorWorkerService.computeDiff(n.uri, e.uri, t, this.diffAlgorithm), c = d.elapsed();
    if (this.telemetryService.publicLog2("diffEditor.computeDiff", { timeMs: c, timedOut: (s = h?.quitEarly) === null || s === void 0 || s, detectedMoves: t.computeMoves ? (o = h?.moves.length) !== null && o !== void 0 ? o : 0 : -1 }), i.isCancellationRequested) return { changes: [], identical: !1, quitEarly: !0, moves: [] };
    if (!h) throw new Error("no diff result available");
    return au.diffCache.size > 10 && au.diffCache.delete(au.diffCache.keys().next().value), au.diffCache.set(r, { result: h, context: a }), h;
  }
  setOptions(n) {
    var e;
    let t = !1;
    n.diffAlgorithm && this.diffAlgorithm !== n.diffAlgorithm && ((e = this.diffAlgorithmOnDidChangeSubscription) === null || e === void 0 || e.dispose(), this.diffAlgorithmOnDidChangeSubscription = void 0, this.diffAlgorithm = n.diffAlgorithm, typeof n.diffAlgorithm != "string" && (this.diffAlgorithmOnDidChangeSubscription = n.diffAlgorithm.onDidChange((() => this.onDidChangeEventEmitter.fire()))), t = !0), t && this.onDidChangeEventEmitter.fire();
  }
};
nw.diffCache = /* @__PURE__ */ new Map(), nw = au = zV([V2(1, Qo), V2(2, es)], nw);
var Cne = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, wne = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let H2 = class extends V {
  setActiveMovedText(n) {
    this._activeMovedText.set(n, void 0);
  }
  constructor(n, e, t) {
    super(), this.model = n, this._options = e, this._diffProviderFactoryService = t, this._isDiffUpToDate = lt(this, !1), this.isDiffUpToDate = this._isDiffUpToDate, this._diff = lt(this, void 0), this.diff = this._diff, this._unchangedRegions = lt(this, void 0), this.unchangedRegions = Fe(this, ((r) => {
      var a, l;
      return this._options.hideUnchangedRegions.read(r) ? (l = (a = this._unchangedRegions.read(r)) === null || a === void 0 ? void 0 : a.regions) !== null && l !== void 0 ? l : [] : (Tt(((d) => {
        var h;
        for (const c of ((h = this._unchangedRegions.get()) === null || h === void 0 ? void 0 : h.regions) || []) c.collapseAll(d);
      })), []);
    })), this.movedTextToCompare = lt(this, void 0), this._activeMovedText = lt(this, void 0), this._hoveredMovedText = lt(this, void 0), this.activeMovedText = Fe(this, ((r) => {
      var a, l;
      return (l = (a = this.movedTextToCompare.read(r)) !== null && a !== void 0 ? a : this._hoveredMovedText.read(r)) !== null && l !== void 0 ? l : this._activeMovedText.read(r);
    })), this._cancellationTokenSource = new Ci(), this._diffProvider = Fe(this, ((r) => {
      const a = this._diffProviderFactoryService.createDiffProvider({ diffAlgorithm: this._options.diffAlgorithm.read(r) });
      return { diffProvider: a, onChangeSignal: Hn("onDidChange", a.onDidChange) };
    })), this._register(ye((() => this._cancellationTokenSource.cancel())));
    const i = DL("contentChangedSignal"), s = this._register(new Et((() => i.trigger(void 0)), 200));
    this._register(Ge(((r) => {
      const a = this._unchangedRegions.read(r);
      if (!a || a.regions.some(((g) => g.isDragged.read(r)))) return;
      const l = a.originalDecorationIds.map(((g) => n.original.getDecorationRange(g))).map(((g) => g ? je.fromRangeInclusive(g) : void 0)), d = a.modifiedDecorationIds.map(((g) => n.modified.getDecorationRange(g))).map(((g) => g ? je.fromRangeInclusive(g) : void 0)), h = a.regions.map(((g, p) => l[p] && d[p] ? new Hh(l[p].startLineNumber, d[p].startLineNumber, l[p].length, g.visibleLineCountTop.read(r), g.visibleLineCountBottom.read(r)) : void 0)).filter(hl), c = [];
      let u = !1;
      for (const g of HT(h, ((p, f) => p.getHiddenModifiedRange(r).endLineNumberExclusive === f.getHiddenModifiedRange(r).startLineNumber))) if (g.length > 1) {
        u = !0;
        const p = g.reduce(((_, v) => _ + v.lineCount), 0), f = new Hh(g[0].originalLineNumber, g[0].modifiedLineNumber, p, g[0].visibleLineCountTop.get(), g[g.length - 1].visibleLineCountBottom.get());
        c.push(f);
      } else c.push(g[0]);
      if (u) {
        const g = n.original.deltaDecorations(a.originalDecorationIds, c.map(((f) => ({ range: f.originalUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } })))), p = n.modified.deltaDecorations(a.modifiedDecorationIds, c.map(((f) => ({ range: f.modifiedUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } }))));
        Tt(((f) => {
          this._unchangedRegions.set({ regions: c, originalDecorationIds: g, modifiedDecorationIds: p }, f);
        }));
      }
    })));
    const o = (r, a, l) => {
      const d = Hh.fromDiffs(r.changes, n.original.getLineCount(), n.modified.getLineCount(), this._options.hideUnchangedRegionsMinimumLineCount.read(l), this._options.hideUnchangedRegionsContextLineCount.read(l));
      let h;
      const c = this._unchangedRegions.get();
      if (c) {
        const f = c.originalDecorationIds.map(((C) => n.original.getDecorationRange(C))).map(((C) => C ? je.fromRangeInclusive(C) : void 0)), _ = c.modifiedDecorationIds.map(((C) => n.modified.getDecorationRange(C))).map(((C) => C ? je.fromRangeInclusive(C) : void 0));
        let b = (function(C, w) {
          let y;
          return C.filter(((L) => {
            const k = w(L, y);
            return y = L, k;
          }));
        })(c.regions.map(((C, w) => {
          if (!f[w] || !_[w]) return;
          const y = f[w].length;
          return new Hh(f[w].startLineNumber, _[w].startLineNumber, y, Math.min(C.visibleLineCountTop.get(), y), Math.min(C.visibleLineCountBottom.get(), y - C.visibleLineCountTop.get()));
        })).filter(hl), ((C, w) => !w || C.modifiedLineNumber >= w.modifiedLineNumber + w.lineCount && C.originalLineNumber >= w.originalLineNumber + w.lineCount)).map(((C) => new us(C.getHiddenOriginalRange(l), C.getHiddenModifiedRange(l))));
        b = us.clip(b, je.ofLength(1, n.original.getLineCount()), je.ofLength(1, n.modified.getLineCount())), h = us.inverse(b, n.original.getLineCount(), n.modified.getLineCount());
      }
      const u = [];
      if (h) for (const f of d) {
        const _ = h.filter(((v) => v.original.intersectsStrict(f.originalUnchangedRange) && v.modified.intersectsStrict(f.modifiedUnchangedRange)));
        u.push(...f.setVisibleRanges(_, a));
      }
      else u.push(...d);
      const g = n.original.deltaDecorations(c?.originalDecorationIds || [], u.map(((f) => ({ range: f.originalUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } })))), p = n.modified.deltaDecorations(c?.modifiedDecorationIds || [], u.map(((f) => ({ range: f.modifiedUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } }))));
      this._unchangedRegions.set({ regions: u, originalDecorationIds: g, modifiedDecorationIds: p }, a);
    };
    this._register(n.modified.onDidChangeContent(((r) => {
      if (this._diff.get()) {
        const a = bd.fromModelContentChanges(r.changes);
        this._lastDiff, n.original, n.modified;
      }
      this._isDiffUpToDate.set(!1, void 0), s.schedule();
    }))), this._register(n.original.onDidChangeContent(((r) => {
      if (this._diff.get()) {
        const a = bd.fromModelContentChanges(r.changes);
        this._lastDiff, n.original, n.modified;
      }
      this._isDiffUpToDate.set(!1, void 0), s.schedule();
    }))), this._register(nr((async (r, a) => {
      var l, d;
      this._options.hideUnchangedRegionsMinimumLineCount.read(r), this._options.hideUnchangedRegionsContextLineCount.read(r), s.cancel(), i.read(r);
      const h = this._diffProvider.read(r);
      h.onChangeSignal.read(r), gr(X8, r), gr(UE, r), this._isDiffUpToDate.set(!1, void 0);
      let c = [];
      a.add(n.original.onDidChangeContent(((v) => {
        const b = bd.fromModelContentChanges(v.changes);
        c = my(c, b);
      })));
      let u = [];
      a.add(n.modified.onDidChangeContent(((v) => {
        const b = bd.fromModelContentChanges(v.changes);
        u = my(u, b);
      })));
      let g = await h.diffProvider.computeDiff(n.original, n.modified, { ignoreTrimWhitespace: this._options.ignoreTrimWhitespace.read(r), maxComputationTimeMs: this._options.maxComputationTimeMs.read(r), computeMoves: this._options.showMoves.read(r) }, this._cancellationTokenSource.token);
      var p, f, _;
      this._cancellationTokenSource.token.isCancellationRequested || (p = g, f = n.original, _ = n.modified, g = { changes: p.changes.map(((v) => new xo(v.original, v.modified, v.innerChanges ? v.innerChanges.map(((b) => (function(C, w, y) {
        let L = C.originalRange, k = C.modifiedRange;
        return (L.endColumn !== 1 || k.endColumn !== 1) && L.endColumn === w.getLineMaxColumn(L.endLineNumber) && k.endColumn === y.getLineMaxColumn(k.endLineNumber) && L.endLineNumber < w.getLineCount() && k.endLineNumber < y.getLineCount() && (L = L.setEndPosition(L.endLineNumber + 1, 1), k = k.setEndPosition(k.endLineNumber + 1, 1)), new Fd(L, k);
      })(b, f, _))) : void 0))), moves: p.moves, identical: p.identical, quitEarly: p.quitEarly }, g = (l = (n.original, n.modified, void 0)) !== null && l !== void 0 ? l : g, g = (d = (n.original, n.modified, void 0)) !== null && d !== void 0 ? d : g, Tt(((v) => {
        o(g, v), this._lastDiff = g;
        const b = QA.fromDiffResult(g);
        this._diff.set(b, v), this._isDiffUpToDate.set(!0, v);
        const C = this.movedTextToCompare.get();
        this.movedTextToCompare.set(C ? this._lastDiff.moves.find(((w) => w.lineRangeMapping.modified.intersect(C.lineRangeMapping.modified))) : void 0, v);
      })));
    })));
  }
  ensureModifiedLineIsVisible(n, e, t) {
    var i, s;
    if (((i = this.diff.get()) === null || i === void 0 ? void 0 : i.mappings.length) === 0) return;
    const o = ((s = this._unchangedRegions.get()) === null || s === void 0 ? void 0 : s.regions) || [];
    for (const r of o) if (r.getHiddenModifiedRange(void 0).contains(n)) return void r.showModifiedLine(n, e, t);
  }
  ensureOriginalLineIsVisible(n, e, t) {
    var i, s;
    if (((i = this.diff.get()) === null || i === void 0 ? void 0 : i.mappings.length) === 0) return;
    const o = ((s = this._unchangedRegions.get()) === null || s === void 0 ? void 0 : s.regions) || [];
    for (const r of o) if (r.getHiddenOriginalRange(void 0).contains(n)) return void r.showOriginalLine(n, e, t);
  }
  async waitForDiff() {
    var n, e;
    await (n = this.isDiffUpToDate, e = (t) => t, new Promise(((t, i) => {
      let s = !0, o = !1;
      const r = n.map(((l) => ({ isFinished: e(l), error: !1, state: l }))), a = Ge(((l) => {
        const { isFinished: d, error: h, state: c } = r.read(l);
        (d || h) && (s ? o = !0 : a.dispose(), h ? i(h === !0 ? c : h) : t(c));
      }));
      s = !1, o && a.dispose();
    })));
  }
  serializeState() {
    const n = this._unchangedRegions.get();
    return { collapsedRegions: n?.regions.map(((e) => ({ range: e.getHiddenModifiedRange(void 0).serialize() }))) };
  }
  restoreSerializedState(n) {
    var e;
    const t = (e = n.collapsedRegions) === null || e === void 0 ? void 0 : e.map(((s) => je.deserialize(s.range))), i = this._unchangedRegions.get();
    i && t && Tt(((s) => {
      for (const o of i.regions) for (const r of t) if (o.modifiedUnchangedRange.intersect(r)) {
        o.setHiddenModifiedRange(r, s);
        break;
      }
    }));
  }
};
H2 = Cne([wne(2, UV)], H2);
class QA {
  static fromDiffResult(e) {
    return new QA(e.changes.map(((t) => new KV(t))), e.moves || [], e.identical, e.quitEarly);
  }
  constructor(e, t, i, s) {
    this.mappings = e, this.movedTexts = t, this.identical = i, this.quitEarly = s;
  }
}
class KV {
  constructor(e) {
    this.lineRangeMapping = e;
  }
}
class Hh {
  static fromDiffs(e, t, i, s, o) {
    const r = xo.inverse(e, t, i), a = [];
    for (const l of r) {
      let d = l.original.startLineNumber, h = l.modified.startLineNumber, c = l.original.length;
      const u = d === 1 && h === 1, g = d + c === t + 1 && h + c === i + 1;
      (u || g) && c >= o + s ? (u && !g && (c -= o), g && !u && (d += o, h += o, c -= o), a.push(new Hh(d, h, c, 0, 0))) : c >= 2 * o + s && (d += o, h += o, c -= 2 * o, a.push(new Hh(d, h, c, 0, 0)));
    }
    return a;
  }
  get originalUnchangedRange() {
    return je.ofLength(this.originalLineNumber, this.lineCount);
  }
  get modifiedUnchangedRange() {
    return je.ofLength(this.modifiedLineNumber, this.lineCount);
  }
  constructor(e, t, i, s, o) {
    this.originalLineNumber = e, this.modifiedLineNumber = t, this.lineCount = i, this._visibleLineCountTop = lt(this, 0), this.visibleLineCountTop = this._visibleLineCountTop, this._visibleLineCountBottom = lt(this, 0), this.visibleLineCountBottom = this._visibleLineCountBottom, this._shouldHideControls = Fe(this, ((l) => this.visibleLineCountTop.read(l) + this.visibleLineCountBottom.read(l) === this.lineCount && !this.isDragged.read(l))), this.isDragged = lt(this, void 0);
    const r = Math.max(Math.min(s, this.lineCount), 0), a = Math.max(Math.min(o, this.lineCount - s), 0);
    IO(s === r), IO(o === a), this._visibleLineCountTop.set(r, void 0), this._visibleLineCountBottom.set(a, void 0);
  }
  setVisibleRanges(e, t) {
    const i = [], s = new Uo(e.map(((l) => l.modified))).subtractFrom(this.modifiedUnchangedRange);
    let o = this.originalLineNumber, r = this.modifiedLineNumber;
    const a = this.modifiedLineNumber + this.lineCount;
    if (s.ranges.length === 0) this.showAll(t), i.push(this);
    else {
      let l = 0;
      for (const d of s.ranges) {
        const h = l === s.ranges.length - 1;
        l++;
        const c = (h ? a : d.endLineNumberExclusive) - r, u = new Hh(o, r, c, 0, 0);
        u.setHiddenModifiedRange(d, t), i.push(u), o = u.originalUnchangedRange.endLineNumberExclusive, r = u.modifiedUnchangedRange.endLineNumberExclusive;
      }
    }
    return i;
  }
  shouldHideControls(e) {
    return this._shouldHideControls.read(e);
  }
  getHiddenOriginalRange(e) {
    return je.ofLength(this.originalLineNumber + this._visibleLineCountTop.read(e), this.lineCount - this._visibleLineCountTop.read(e) - this._visibleLineCountBottom.read(e));
  }
  getHiddenModifiedRange(e) {
    return je.ofLength(this.modifiedLineNumber + this._visibleLineCountTop.read(e), this.lineCount - this._visibleLineCountTop.read(e) - this._visibleLineCountBottom.read(e));
  }
  setHiddenModifiedRange(e, t) {
    const i = e.startLineNumber - this.modifiedLineNumber, s = this.modifiedLineNumber + this.lineCount - e.endLineNumberExclusive;
    this.setState(i, s, t);
  }
  getMaxVisibleLineCountTop() {
    return this.lineCount - this._visibleLineCountBottom.get();
  }
  getMaxVisibleLineCountBottom() {
    return this.lineCount - this._visibleLineCountTop.get();
  }
  showMoreAbove(e = 10, t) {
    const i = this.getMaxVisibleLineCountTop();
    this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + e, i), t);
  }
  showMoreBelow(e = 10, t) {
    const i = this.lineCount - this._visibleLineCountTop.get();
    this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + e, i), t);
  }
  showAll(e) {
    this._visibleLineCountBottom.set(this.lineCount - this._visibleLineCountTop.get(), e);
  }
  showModifiedLine(e, t, i) {
    const s = e + 1 - (this.modifiedLineNumber + this._visibleLineCountTop.get()), o = this.modifiedLineNumber - this._visibleLineCountBottom.get() + this.lineCount - e;
    t === 0 && s < o || t === 1 ? this._visibleLineCountTop.set(this._visibleLineCountTop.get() + s, i) : this._visibleLineCountBottom.set(this._visibleLineCountBottom.get() + o, i);
  }
  showOriginalLine(e, t, i) {
    const s = e - this.originalLineNumber, o = this.originalLineNumber + this.lineCount - e;
    t === 0 && s < o || t === 1 ? this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + o - s, this.getMaxVisibleLineCountTop()), i) : this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + s - o, this.getMaxVisibleLineCountBottom()), i);
  }
  collapseAll(e) {
    this._visibleLineCountTop.set(0, e), this._visibleLineCountBottom.set(0, e);
  }
  setState(e, t, i) {
    e = Math.max(Math.min(e, this.lineCount), 0), t = Math.max(Math.min(t, this.lineCount - e), 0), this._visibleLineCountTop.set(e, i), this._visibleLineCountBottom.set(t, i);
  }
}
class yne extends V {
  get visibility() {
    return this._visibility;
  }
  set visibility(e) {
    this._visibility !== e && (this._visibility = e, this._diffActions.style.visibility = e ? "visible" : "hidden");
  }
  constructor(e, t, i, s, o, r, a, l, d) {
    super(), this._getViewZoneId = e, this._marginDomNode = t, this._modifiedEditor = i, this._diff = s, this._editor = o, this._viewLineCounts = r, this._originalTextModel = a, this._contextMenuService = l, this._clipboardService = d, this._visibility = !1, this._marginDomNode.style.zIndex = "10", this._diffActions = document.createElement("div"), this._diffActions.className = Ee.asClassName(ne.lightBulb) + " lightbulb-glyph", this._diffActions.style.position = "absolute";
    const h = this._modifiedEditor.getOption(67);
    this._diffActions.style.right = "0px", this._diffActions.style.visibility = "hidden", this._diffActions.style.height = `${h}px`, this._diffActions.style.lineHeight = `${h}px`, this._marginDomNode.appendChild(this._diffActions);
    let c = 0;
    const u = i.getOption(127) && !ca, g = (p, f) => {
      var _;
      this._contextMenuService.showContextMenu({ domForShadowRoot: u && (_ = i.getDomNode()) !== null && _ !== void 0 ? _ : void 0, getAnchor: () => ({ x: p, y: f }), getActions: () => {
        const v = [], b = s.modified.isEmpty;
        return v.push(new Qs("diff.clipboard.copyDeletedContent", b ? s.original.length > 1 ? m(0, "Copy deleted lines") : m(0, "Copy deleted line") : s.original.length > 1 ? m(0, "Copy changed lines") : m(0, "Copy changed line"), void 0, !0, (async () => {
          const C = this._originalTextModel.getValueInRange(s.original.toExclusiveRange());
          await this._clipboardService.writeText(C);
        }))), s.original.length > 1 && v.push(new Qs("diff.clipboard.copyDeletedLineContent", m(0, b ? "Copy deleted line ({0})" : "Copy changed line ({0})", s.original.startLineNumber + c), void 0, !0, (async () => {
          let C = this._originalTextModel.getLineContent(s.original.startLineNumber + c);
          C === "" && (C = this._originalTextModel.getEndOfLineSequence() === 0 ? `
` : `\r
`), await this._clipboardService.writeText(C);
        }))), i.getOption(91) || v.push(new Qs("diff.inline.revertChange", m(0, "Revert this change"), void 0, !0, (async () => {
          this._editor.revert(this._diff);
        }))), v;
      }, autoSelectFirstItem: !0 });
    };
    this._register(bi(this._diffActions, "mousedown", ((p) => {
      if (!p.leftButton) return;
      const { top: f, height: _ } = Ti(this._diffActions), v = Math.floor(h / 3);
      p.preventDefault(), g(p.posx, f + _ + v);
    }))), this._register(i.onMouseMove(((p) => {
      p.target.type !== 8 && p.target.type !== 5 || p.target.detail.viewZoneId !== this._getViewZoneId() ? this.visibility = !1 : (c = this._updateLightBulbPosition(this._marginDomNode, p.event.browserEvent.y, h), this.visibility = !0);
    }))), this._register(i.onMouseDown(((p) => {
      p.event.leftButton && (p.target.type === 8 || p.target.type === 5) && p.target.detail.viewZoneId === this._getViewZoneId() && (p.event.preventDefault(), c = this._updateLightBulbPosition(this._marginDomNode, p.event.browserEvent.y, h), g(p.event.posx, p.event.posy + h));
    })));
  }
  _updateLightBulbPosition(e, t, i) {
    const { top: s } = Ti(e), o = t - s, r = Math.floor(o / i), a = r * i;
    if (this._diffActions.style.top = `${a}px`, this._viewLineCounts) {
      let l = 0;
      for (let d = 0; d < this._viewLineCounts.length; d++) if (l += this._viewLineCounts[d], r < l) return d;
    }
    return r;
  }
}
const TF = Hd("diffEditorWidget", { createHTML: (n) => n });
function Sne(n, e, t, i) {
  yn(i, e.fontInfo);
  const s = t.length > 0, o = new pf(1e4);
  let r = 0, a = 0;
  const l = [];
  for (let c = 0; c < n.lineTokens.length; c++) {
    const u = c + 1, g = n.lineTokens[c], p = n.lineBreakData[c], f = _s.filter(t, u, 1, Number.MAX_SAFE_INTEGER);
    if (p) {
      let _ = 0;
      for (const v of p.breakOffsets) {
        const b = g.sliceAndInflate(_, v, 0);
        r = Math.max(r, RF(a, b, _s.extractWrapped(f, _, v), s, n.mightContainNonBasicASCII, n.mightContainRTL, e, o)), a++, _ = v;
      }
      l.push(p.breakOffsets.length);
    } else l.push(1), r = Math.max(r, RF(a, g, f, s, n.mightContainNonBasicASCII, n.mightContainRTL, e, o)), a++;
  }
  r += e.scrollBeyondLastColumn;
  const d = o.build(), h = TF ? TF.createHTML(d) : d;
  return i.innerHTML = h, { heightInLines: a, minWidthInPx: r * e.typicalHalfwidthCharacterWidth, viewLineCounts: l };
}
class Lne {
  constructor(e, t, i, s) {
    this.lineTokens = e, this.lineBreakData = t, this.mightContainNonBasicASCII = i, this.mightContainRTL = s;
  }
}
class JA {
  static fromEditor(e) {
    var t;
    const i = e.getOptions(), s = i.get(50), o = i.get(145);
    return new JA(((t = e.getModel()) === null || t === void 0 ? void 0 : t.getOptions().tabSize) || 0, s, i.get(33), s.typicalHalfwidthCharacterWidth, i.get(104), i.get(67), o.decorationsWidth, i.get(117), i.get(99), i.get(94), i.get(51));
  }
  constructor(e, t, i, s, o, r, a, l, d, h, c) {
    this.tabSize = e, this.fontInfo = t, this.disableMonospaceOptimizations = i, this.typicalHalfwidthCharacterWidth = s, this.scrollBeyondLastColumn = o, this.lineHeight = r, this.lineDecorationsWidth = a, this.stopRenderingLineAfter = l, this.renderWhitespace = d, this.renderControlCharacters = h, this.fontLigatures = c;
  }
}
function RF(n, e, t, i, s, o, r, a) {
  a.appendString('<div class="view-line'), i || a.appendString(" char-delete"), a.appendString('" style="top:'), a.appendString(String(n * r.lineHeight)), a.appendString('px;width:1000000px;">');
  const l = e.getLineContent(), d = Co.isBasicASCII(l, s), h = Co.containsRTL(l, d, o), c = C1(new Sc(r.fontInfo.isMonospace && !r.disableMonospaceOptimizations, r.fontInfo.canUseHalfwidthRightwardsArrow, l, !1, d, h, 0, e, t, r.tabSize, 0, r.fontInfo.spaceWidth, r.fontInfo.middotWidth, r.fontInfo.wsmiddotWidth, r.stopRenderingLineAfter, r.renderWhitespace, r.renderControlCharacters, r.fontLigatures !== fo.OFF, null), a);
  return a.appendString("</div>"), c.characterMapping.getHorizontalOffset(c.characterMapping.length);
}
var kne = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, AF = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let z2 = class extends V {
  constructor(n, e, t, i, s, o, r, a, l, d) {
    super(), this._targetWindow = n, this._editors = e, this._diffModel = t, this._options = i, this._diffEditorWidget = s, this._canIgnoreViewZoneUpdateEvent = o, this._origViewZonesToIgnore = r, this._modViewZonesToIgnore = a, this._clipboardService = l, this._contextMenuService = d, this._originalTopPadding = lt(this, 0), this._originalScrollOffset = lt(this, 0), this._originalScrollOffsetAnimated = LF(this._targetWindow, this._originalScrollOffset, this._store), this._modifiedTopPadding = lt(this, 0), this._modifiedScrollOffset = lt(this, 0), this._modifiedScrollOffsetAnimated = LF(this._targetWindow, this._modifiedScrollOffset, this._store);
    const h = lt("invalidateAlignmentsState", 0), c = this._register(new Et((() => {
      h.set(h.get() + 1, void 0);
    }), 0));
    this._register(this._editors.original.onDidChangeViewZones(((b) => {
      this._canIgnoreViewZoneUpdateEvent() || c.schedule();
    }))), this._register(this._editors.modified.onDidChangeViewZones(((b) => {
      this._canIgnoreViewZoneUpdateEvent() || c.schedule();
    }))), this._register(this._editors.original.onDidChangeConfiguration(((b) => {
      (b.hasChanged(146) || b.hasChanged(67)) && c.schedule();
    }))), this._register(this._editors.modified.onDidChangeConfiguration(((b) => {
      (b.hasChanged(146) || b.hasChanged(67)) && c.schedule();
    })));
    const u = this._diffModel.map(((b) => b ? Rt(b.model.original.onDidChangeTokens, (() => b.model.original.tokenization.backgroundTokenizationState === 2)) : void 0)).map(((b, C) => b?.read(C))), g = Fe(((b) => {
      const C = this._diffModel.read(b), w = C?.diff.read(b);
      if (!C || !w) return null;
      h.read(b);
      const y = this._options.renderSideBySide.read(b);
      return PF(this._editors.original, this._editors.modified, w.mappings, this._origViewZonesToIgnore, this._modViewZonesToIgnore, y);
    })), p = Fe(((b) => {
      var C;
      const w = (C = this._diffModel.read(b)) === null || C === void 0 ? void 0 : C.movedTextToCompare.read(b);
      if (!w) return null;
      h.read(b);
      const y = w.changes.map(((L) => new KV(L)));
      return PF(this._editors.original, this._editors.modified, y, this._origViewZonesToIgnore, this._modViewZonesToIgnore, !0);
    }));
    function f() {
      const b = document.createElement("div");
      return b.className = "diagonal-fill", b;
    }
    const _ = this._register(new G());
    this.viewZones = vf(this, ((b, C) => {
      var w, y, L, k, N, A, B, T;
      _.clear();
      const O = g.read(b) || [], H = [], $ = [], pe = this._modifiedTopPadding.read(b);
      pe > 0 && $.push({ afterLineNumber: 0, domNode: document.createElement("div"), heightInPx: pe, showInHiddenAreas: !0, suppressMouseDown: !0 });
      const me = this._originalTopPadding.read(b);
      me > 0 && H.push({ afterLineNumber: 0, domNode: document.createElement("div"), heightInPx: me, showInHiddenAreas: !0, suppressMouseDown: !0 });
      const ue = this._options.renderSideBySide.read(b), ee = ue || (w = this._editors.modified._getViewModel()) === null || w === void 0 ? void 0 : w.createLineBreaksComputer();
      if (ee) {
        const nt = this._editors.original.getModel();
        for (const De of O) if (De.diff) for (let an = De.originalRange.startLineNumber; an < De.originalRange.endLineNumberExclusive; an++) {
          if (an > nt.getLineCount()) return { orig: H, mod: $ };
          ee?.addRequest(nt.getLineContent(an), null, null);
        }
      }
      const te = (y = ee?.finalize()) !== null && y !== void 0 ? y : [];
      let be = 0;
      const we = this._editors.modified.getOption(67), Re = (L = this._diffModel.read(b)) === null || L === void 0 ? void 0 : L.movedTextToCompare.read(b), it = (N = (k = this._editors.original.getModel()) === null || k === void 0 ? void 0 : k.mightContainNonBasicASCII()) !== null && N !== void 0 && N, ut = (B = (A = this._editors.original.getModel()) === null || A === void 0 ? void 0 : A.mightContainRTL()) !== null && B !== void 0 && B, Xi = JA.fromEditor(this._editors.modified);
      for (const nt of O) if (nt.diff && !ue) {
        if (!nt.originalRange.isEmpty) {
          u.read(b);
          const an = document.createElement("div");
          an.classList.add("view-lines", "line-delete", "monaco-mouse-cursor-text");
          const La = this._editors.original.getModel();
          if (nt.originalRange.endLineNumberExclusive - 1 > La.getLineCount()) return { orig: H, mod: $ };
          const Er = new Lne(nt.originalRange.mapToLineArray(((Ki) => La.tokenization.getLineTokens(Ki))), nt.originalRange.mapToLineArray(((Ki) => te[be++])), it, ut), Ws = [];
          for (const Ki of nt.diff.innerChanges || []) Ws.push(new Y_(Ki.originalRange.delta(-(nt.diff.original.startLineNumber - 1)), W2.className, 0));
          const Ss = Sne(Er, Xi, Ws, an), Ir = document.createElement("div");
          if (Ir.className = "inline-deleted-margin-view-zone", yn(Ir, Xi.fontInfo), this._options.renderIndicators.read(b)) for (let Ki = 0; Ki < Ss.heightInLines; Ki++) {
            const le = document.createElement("div");
            le.className = `delete-sign ${Ee.asClassName(HV)}`, le.setAttribute("style", `position:absolute;top:${Ki * we}px;width:${Xi.lineDecorationsWidth}px;height:${we}px;right:0;`), Ir.appendChild(le);
          }
          let jd;
          _.add(new yne((() => Dh(jd)), Ir, this._editors.modified, nt.diff, this._diffEditorWidget, Ss.viewLineCounts, this._editors.original.getModel(), this._contextMenuService, this._clipboardService));
          for (let Ki = 0; Ki < Ss.viewLineCounts.length; Ki++) {
            const le = Ss.viewLineCounts[Ki];
            le > 1 && H.push({ afterLineNumber: nt.originalRange.startLineNumber + Ki, domNode: f(), heightInPx: (le - 1) * we, showInHiddenAreas: !0, suppressMouseDown: !0 });
          }
          $.push({ afterLineNumber: nt.modifiedRange.startLineNumber - 1, domNode: an, heightInPx: Ss.heightInLines * we, minWidthInPx: Ss.minWidthInPx, marginDomNode: Ir, setZoneId(Ki) {
            jd = Ki;
          }, showInHiddenAreas: !0, suppressMouseDown: !0 });
        }
        const De = document.createElement("div");
        De.className = "gutter-delete", H.push({ afterLineNumber: nt.originalRange.endLineNumberExclusive - 1, domNode: f(), heightInPx: nt.modifiedHeightInPx, marginDomNode: De, showInHiddenAreas: !0, suppressMouseDown: !0 });
      } else {
        const De = nt.modifiedHeightInPx - nt.originalHeightInPx;
        if (De > 0) {
          if (Re?.lineRangeMapping.original.delta(-1).deltaLength(2).contains(nt.originalRange.endLineNumberExclusive - 1)) continue;
          H.push({ afterLineNumber: nt.originalRange.endLineNumberExclusive - 1, domNode: f(), heightInPx: De, showInHiddenAreas: !0, suppressMouseDown: !0 });
        } else {
          let an = function() {
            const Er = document.createElement("div");
            return Er.className = "arrow-revert-change " + Ee.asClassName(ne.arrowRight), C.add(K(Er, "mousedown", ((Ws) => Ws.stopPropagation()))), C.add(K(Er, "click", ((Ws) => {
              Ws.stopPropagation(), s.revert(nt.diff);
            }))), Q("div", {}, Er);
          };
          if (Re?.lineRangeMapping.modified.delta(-1).deltaLength(2).contains(nt.modifiedRange.endLineNumberExclusive - 1)) continue;
          let La;
          nt.diff && nt.diff.modified.isEmpty && this._options.shouldRenderOldRevertArrows.read(b) && (La = an()), $.push({ afterLineNumber: nt.modifiedRange.endLineNumberExclusive - 1, domNode: f(), heightInPx: -De, marginDomNode: La, showInHiddenAreas: !0, suppressMouseDown: !0 });
        }
      }
      for (const nt of (T = p.read(b)) !== null && T !== void 0 ? T : []) {
        if (!Re?.lineRangeMapping.original.intersect(nt.originalRange) || !Re?.lineRangeMapping.modified.intersect(nt.modifiedRange)) continue;
        const De = nt.modifiedHeightInPx - nt.originalHeightInPx;
        De > 0 ? H.push({ afterLineNumber: nt.originalRange.endLineNumberExclusive - 1, domNode: f(), heightInPx: De, showInHiddenAreas: !0, suppressMouseDown: !0 }) : $.push({ afterLineNumber: nt.modifiedRange.endLineNumberExclusive - 1, domNode: f(), heightInPx: -De, showInHiddenAreas: !0, suppressMouseDown: !0 });
      }
      return { orig: H, mod: $ };
    }));
    let v = !1;
    this._register(this._editors.original.onDidScrollChange(((b) => {
      b.scrollLeftChanged && !v && (v = !0, this._editors.modified.setScrollLeft(b.scrollLeft), v = !1);
    }))), this._register(this._editors.modified.onDidScrollChange(((b) => {
      b.scrollLeftChanged && !v && (v = !0, this._editors.original.setScrollLeft(b.scrollLeft), v = !1);
    }))), this._originalScrollTop = Rt(this._editors.original.onDidScrollChange, (() => this._editors.original.getScrollTop())), this._modifiedScrollTop = Rt(this._editors.modified.onDidScrollChange, (() => this._editors.modified.getScrollTop())), this._register(Ge(((b) => {
      const C = this._originalScrollTop.read(b) - (this._originalScrollOffsetAnimated.get() - this._modifiedScrollOffsetAnimated.read(b)) - (this._originalTopPadding.get() - this._modifiedTopPadding.read(b));
      C !== this._editors.modified.getScrollTop() && this._editors.modified.setScrollTop(C, 1);
    }))), this._register(Ge(((b) => {
      const C = this._modifiedScrollTop.read(b) - (this._modifiedScrollOffsetAnimated.get() - this._originalScrollOffsetAnimated.read(b)) - (this._modifiedTopPadding.get() - this._originalTopPadding.read(b));
      C !== this._editors.original.getScrollTop() && this._editors.original.setScrollTop(C, 1);
    }))), this._register(Ge(((b) => {
      var C;
      const w = (C = this._diffModel.read(b)) === null || C === void 0 ? void 0 : C.movedTextToCompare.read(b);
      let y = 0;
      if (w) {
        const L = this._editors.original.getTopForLineNumber(w.lineRangeMapping.original.startLineNumber, !0) - this._originalTopPadding.get();
        y = this._editors.modified.getTopForLineNumber(w.lineRangeMapping.modified.startLineNumber, !0) - this._modifiedTopPadding.get() - L;
      }
      y > 0 ? (this._modifiedTopPadding.set(0, void 0), this._originalTopPadding.set(y, void 0)) : y < 0 ? (this._modifiedTopPadding.set(-y, void 0), this._originalTopPadding.set(0, void 0)) : setTimeout((() => {
        this._modifiedTopPadding.set(0, void 0), this._originalTopPadding.set(0, void 0);
      }), 400), this._editors.modified.hasTextFocus() ? this._originalScrollOffset.set(this._modifiedScrollOffset.get() - y, void 0, !0) : this._modifiedScrollOffset.set(this._originalScrollOffset.get() + y, void 0, !0);
    })));
  }
};
function PF(n, e, t, i, s, o) {
  const r = new Pd(OF(n, i)), a = new Pd(OF(e, s)), l = n.getOption(67), d = e.getOption(67), h = [];
  let c = 0, u = 0;
  function g(p, f) {
    for (; ; ) {
      let _ = r.peek(), v = a.peek();
      if (_ && _.lineNumber >= p && (_ = void 0), v && v.lineNumber >= f && (v = void 0), !_ && !v) break;
      const b = _ ? _.lineNumber - c : Number.MAX_VALUE, C = v ? v.lineNumber - u : Number.MAX_VALUE;
      b < C ? (r.dequeue(), v = { lineNumber: _.lineNumber - c + u, heightInPx: 0 }) : b > C ? (a.dequeue(), _ = { lineNumber: v.lineNumber - u + c, heightInPx: 0 }) : (r.dequeue(), a.dequeue()), h.push({ originalRange: je.ofLength(_.lineNumber, 1), modifiedRange: je.ofLength(v.lineNumber, 1), originalHeightInPx: l + _.heightInPx, modifiedHeightInPx: d + v.heightInPx, diff: void 0 });
    }
  }
  for (const p of t) {
    let C = function(w, y) {
      var L, k, N, A;
      if (w < b || y < v) return;
      if (_) _ = !1;
      else if (w === b || y === v) return;
      const B = new je(b, w), T = new je(v, y);
      if (B.isEmpty && T.isEmpty) return;
      const O = (k = (L = r.takeWhile((($) => $.lineNumber < w))) === null || L === void 0 ? void 0 : L.reduce((($, pe) => $ + pe.heightInPx), 0)) !== null && k !== void 0 ? k : 0, H = (A = (N = a.takeWhile((($) => $.lineNumber < y))) === null || N === void 0 ? void 0 : N.reduce((($, pe) => $ + pe.heightInPx), 0)) !== null && A !== void 0 ? A : 0;
      h.push({ originalRange: B, modifiedRange: T, originalHeightInPx: B.length * l + O, modifiedHeightInPx: T.length * d + H, diff: p.lineRangeMapping }), b = w, v = y;
    };
    const f = p.lineRangeMapping;
    g(f.original.startLineNumber, f.modified.startLineNumber);
    let _ = !0, v = f.modified.startLineNumber, b = f.original.startLineNumber;
    if (o) for (const w of f.innerChanges || []) {
      w.originalRange.startColumn > 1 && w.modifiedRange.startColumn > 1 && C(w.originalRange.startLineNumber, w.modifiedRange.startLineNumber);
      const y = n.getModel(), L = w.originalRange.endLineNumber <= y.getLineCount() ? y.getLineMaxColumn(w.originalRange.endLineNumber) : Number.MAX_SAFE_INTEGER;
      w.originalRange.endColumn < L && C(w.originalRange.endLineNumber, w.modifiedRange.endLineNumber);
    }
    C(f.original.endLineNumberExclusive, f.modified.endLineNumberExclusive), c = f.original.endLineNumberExclusive, u = f.modified.endLineNumberExclusive;
  }
  return g(Number.MAX_VALUE, Number.MAX_VALUE), h;
}
function OF(n, e) {
  const t = [], i = [], s = n.getOption(146).wrappingColumn !== -1, o = n._getViewModel().coordinatesConverter, r = n.getOption(67);
  if (s) for (let a = 1; a <= n.getModel().getLineCount(); a++) {
    const l = o.getModelLineViewLineCount(a);
    l > 1 && i.push({ lineNumber: a, heightInPx: r * (l - 1) });
  }
  for (const a of n.getWhitespaces()) {
    if (e.has(a.id)) continue;
    const l = a.afterLineNumber === 0 ? 0 : o.convertViewPositionToModelPosition(new W(a.afterLineNumber, 1)).lineNumber;
    t.push({ lineNumber: l, heightInPx: a.height });
  }
  return (function(a, l, d, h) {
    if (a.length === 0) return l;
    if (l.length === 0) return a;
    const c = [];
    let u = 0, g = 0;
    for (; u < a.length && g < l.length; ) {
      const p = a[u], f = l[g], _ = d(p), v = d(f);
      _ < v ? (c.push(p), u++) : _ > v ? (c.push(f), g++) : (c.push(h(p, f)), u++, g++);
    }
    for (; u < a.length; ) c.push(a[u]), u++;
    for (; g < l.length; ) c.push(l[g]), g++;
    return c;
  })(t, i, ((a) => a.lineNumber), ((a, l) => ({ lineNumber: a.lineNumber, heightInPx: a.heightInPx + l.heightInPx })));
}
z2 = kne([AF(8, Kd), AF(9, io)], z2);
var U2, Dne = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, xne = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let b0 = U2 = class extends V {
  static setBreadcrumbsSourceFactory(n) {
    this._breadcrumbsSourceFactory.set(n, void 0);
  }
  get isUpdatingHiddenAreas() {
    return this._isUpdatingHiddenAreas;
  }
  constructor(n, e, t, i) {
    super(), this._editors = n, this._diffModel = e, this._options = t, this._instantiationService = i, this._modifiedOutlineSource = Fl(this, ((a) => {
      const l = this._editors.modifiedModel.read(a), d = U2._breadcrumbsSourceFactory.read(a);
      return l && d ? d(l, this._instantiationService) : void 0;
    })), this._isUpdatingHiddenAreas = !1, this._register(this._editors.original.onDidChangeCursorPosition(((a) => {
      if (a.reason === 1) return;
      const l = this._diffModel.get();
      Tt(((d) => {
        for (const h of this._editors.original.getSelections() || []) l?.ensureOriginalLineIsVisible(h.getStartPosition().lineNumber, 0, d), l?.ensureOriginalLineIsVisible(h.getEndPosition().lineNumber, 0, d);
      }));
    }))), this._register(this._editors.modified.onDidChangeCursorPosition(((a) => {
      if (a.reason === 1) return;
      const l = this._diffModel.get();
      Tt(((d) => {
        for (const h of this._editors.modified.getSelections() || []) l?.ensureModifiedLineIsVisible(h.getStartPosition().lineNumber, 0, d), l?.ensureModifiedLineIsVisible(h.getEndPosition().lineNumber, 0, d);
      }));
    })));
    const s = this._diffModel.map(((a, l) => {
      var d, h;
      const c = (d = a?.unchangedRegions.read(l)) !== null && d !== void 0 ? d : [];
      return c.length === 1 && c[0].modifiedLineNumber === 1 && c[0].lineCount === ((h = this._editors.modifiedModel.read(l)) === null || h === void 0 ? void 0 : h.getLineCount()) ? [] : c;
    }));
    this.viewZones = vf(this, ((a, l) => {
      const d = this._modifiedOutlineSource.read(a);
      if (!d) return { origViewZones: [], modViewZones: [] };
      const h = [], c = [], u = this._options.renderSideBySide.read(a), g = s.read(a);
      for (const p of g) if (!p.shouldHideControls(a)) {
        {
          const f = Fe(this, ((v) => p.getHiddenOriginalRange(v).startLineNumber - 1)), _ = new tS(f, 24);
          h.push(_), l.add(new FF(this._editors.original, _, p, p.originalUnchangedRange, !u, d, ((v) => this._diffModel.get().ensureModifiedLineIsVisible(v, 2, void 0)), this._options));
        }
        {
          const f = Fe(this, ((v) => p.getHiddenModifiedRange(v).startLineNumber - 1)), _ = new tS(f, 24);
          c.push(_), l.add(new FF(this._editors.modified, _, p, p.modifiedUnchangedRange, !1, d, ((v) => this._diffModel.get().ensureModifiedLineIsVisible(v, 2, void 0)), this._options));
        }
      }
      return { origViewZones: h, modViewZones: c };
    }));
    const o = { description: "unchanged lines", className: "diff-unchanged-lines", isWholeLine: !0 }, r = { description: "Fold Unchanged", glyphMarginHoverMessage: new Vn(void 0, { isTrusted: !0, supportThemeIcons: !0 }).appendMarkdown(m(0, "Fold Unchanged Region")), glyphMarginClassName: "fold-unchanged " + Ee.asClassName(ne.fold), zIndex: 10001 };
    this._register(eS(this._editors.original, Fe(this, ((a) => {
      const l = s.read(a), d = l.map(((h) => ({ range: h.originalUnchangedRange.toInclusiveRange(), options: o })));
      for (const h of l) h.shouldHideControls(a) && d.push({ range: D.fromPositions(new W(h.originalLineNumber, 1)), options: r });
      return d;
    })))), this._register(eS(this._editors.modified, Fe(this, ((a) => {
      const l = s.read(a), d = l.map(((h) => ({ range: h.modifiedUnchangedRange.toInclusiveRange(), options: o })));
      for (const h of l) h.shouldHideControls(a) && d.push({ range: je.ofLength(h.modifiedLineNumber, 1).toInclusiveRange(), options: r });
      return d;
    })))), this._register(Ge(((a) => {
      const l = s.read(a);
      this._isUpdatingHiddenAreas = !0;
      try {
        this._editors.original.setHiddenAreas(l.map(((d) => d.getHiddenOriginalRange(a).toInclusiveRange())).filter(hl)), this._editors.modified.setHiddenAreas(l.map(((d) => d.getHiddenModifiedRange(a).toInclusiveRange())).filter(hl));
      } finally {
        this._isUpdatingHiddenAreas = !1;
      }
    }))), this._register(this._editors.modified.onMouseUp(((a) => {
      var l;
      if (!a.event.rightButton && a.target.position && (!((l = a.target.element) === null || l === void 0) && l.className.includes("fold-unchanged"))) {
        const d = a.target.position.lineNumber, h = this._diffModel.get();
        if (!h) return;
        const c = h.unchangedRegions.get().find(((u) => u.modifiedUnchangedRange.includes(d)));
        if (!c) return;
        c.collapseAll(void 0), a.event.stopPropagation(), a.event.preventDefault();
      }
    }))), this._register(this._editors.original.onMouseUp(((a) => {
      var l;
      if (!a.event.rightButton && a.target.position && (!((l = a.target.element) === null || l === void 0) && l.className.includes("fold-unchanged"))) {
        const d = a.target.position.lineNumber, h = this._diffModel.get();
        if (!h) return;
        const c = h.unchangedRegions.get().find(((u) => u.originalUnchangedRange.includes(d)));
        if (!c) return;
        c.collapseAll(void 0), a.event.stopPropagation(), a.event.preventDefault();
      }
    })));
  }
};
b0._breadcrumbsSourceFactory = lt("breadcrumbsSourceFactory", void 0), b0 = U2 = Dne([xne(3, Se)], b0);
class FF extends VV {
  constructor(e, t, i, s, o, r, a, l) {
    const d = yt("div.diff-hidden-lines-widget");
    super(e, t, d.root), this._editor = e, this._unchangedRegion = i, this._unchangedRegionRange = s, this._hide = o, this._modifiedOutlineSource = r, this._revealModifiedHiddenLine = a, this._options = l, this._nodes = yt("div.diff-hidden-lines", [yt("div.top@top", { title: m(0, "Click or drag to show more above") }), yt("div.center@content", { style: { display: "flex" } }, [yt("div@first", { style: { display: "flex", justifyContent: "center", alignItems: "center", flexShrink: "0" } }, [Q("a", { title: m(0, "Show Unchanged Region"), role: "button", onclick: () => {
      this._unchangedRegion.showAll(void 0);
    } }, ...tc("$(unfold)"))]), yt("div@others", { style: { display: "flex", justifyContent: "center", alignItems: "center" } })]), yt("div.bottom@bottom", { title: m(0, "Click or drag to show more below"), role: "button" })]), d.root.appendChild(this._nodes.root);
    const h = Rt(this._editor.onDidLayoutChange, (() => this._editor.getLayoutInfo()));
    this._hide ? wn(this._nodes.first) : this._register(Ed(this._nodes.first, { width: h.map(((u) => u.contentLeft)) })), this._register(Ge(((u) => {
      const g = this._unchangedRegion.visibleLineCountTop.read(u) + this._unchangedRegion.visibleLineCountBottom.read(u) === this._unchangedRegion.lineCount;
      this._nodes.bottom.classList.toggle("canMoveTop", !g), this._nodes.bottom.classList.toggle("canMoveBottom", this._unchangedRegion.visibleLineCountBottom.read(u) > 0), this._nodes.top.classList.toggle("canMoveTop", this._unchangedRegion.visibleLineCountTop.read(u) > 0), this._nodes.top.classList.toggle("canMoveBottom", !g);
      const p = this._unchangedRegion.isDragged.read(u), f = this._editor.getDomNode();
      f && (f.classList.toggle("draggingUnchangedRegion", !!p), p === "top" ? (f.classList.toggle("canMoveTop", this._unchangedRegion.visibleLineCountTop.read(u) > 0), f.classList.toggle("canMoveBottom", !g)) : p === "bottom" ? (f.classList.toggle("canMoveTop", !g), f.classList.toggle("canMoveBottom", this._unchangedRegion.visibleLineCountBottom.read(u) > 0)) : (f.classList.toggle("canMoveTop", !1), f.classList.toggle("canMoveBottom", !1)));
    })));
    const c = this._editor;
    this._register(K(this._nodes.top, "mousedown", ((u) => {
      if (u.button !== 0) return;
      this._nodes.top.classList.toggle("dragging", !0), this._nodes.root.classList.toggle("dragging", !0), u.preventDefault();
      const g = u.clientY;
      let p = !1;
      const f = this._unchangedRegion.visibleLineCountTop.get();
      this._unchangedRegion.isDragged.set("top", void 0);
      const _ = ke(this._nodes.top), v = K(_, "mousemove", ((C) => {
        const w = C.clientY - g;
        p = p || Math.abs(w) > 2;
        const y = Math.round(w / c.getOption(67)), L = Math.max(0, Math.min(f + y, this._unchangedRegion.getMaxVisibleLineCountTop()));
        this._unchangedRegion.visibleLineCountTop.set(L, void 0);
      })), b = K(_, "mouseup", ((C) => {
        p || this._unchangedRegion.showMoreAbove(this._options.hideUnchangedRegionsRevealLineCount.get(), void 0), this._nodes.top.classList.toggle("dragging", !1), this._nodes.root.classList.toggle("dragging", !1), this._unchangedRegion.isDragged.set(void 0, void 0), v.dispose(), b.dispose();
      }));
    }))), this._register(K(this._nodes.bottom, "mousedown", ((u) => {
      if (u.button !== 0) return;
      this._nodes.bottom.classList.toggle("dragging", !0), this._nodes.root.classList.toggle("dragging", !0), u.preventDefault();
      const g = u.clientY;
      let p = !1;
      const f = this._unchangedRegion.visibleLineCountBottom.get();
      this._unchangedRegion.isDragged.set("bottom", void 0);
      const _ = ke(this._nodes.bottom), v = K(_, "mousemove", ((C) => {
        const w = C.clientY - g;
        p = p || Math.abs(w) > 2;
        const y = Math.round(w / c.getOption(67)), L = Math.max(0, Math.min(f - y, this._unchangedRegion.getMaxVisibleLineCountBottom())), k = this._unchangedRegionRange.endLineNumberExclusive > c.getModel().getLineCount() ? c.getContentHeight() : c.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
        this._unchangedRegion.visibleLineCountBottom.set(L, void 0);
        const N = this._unchangedRegionRange.endLineNumberExclusive > c.getModel().getLineCount() ? c.getContentHeight() : c.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
        c.setScrollTop(c.getScrollTop() + (N - k));
      })), b = K(_, "mouseup", ((C) => {
        if (this._unchangedRegion.isDragged.set(void 0, void 0), !p) {
          const w = c.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
          this._unchangedRegion.showMoreBelow(this._options.hideUnchangedRegionsRevealLineCount.get(), void 0);
          const y = c.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
          c.setScrollTop(c.getScrollTop() + (y - w));
        }
        this._nodes.bottom.classList.toggle("dragging", !1), this._nodes.root.classList.toggle("dragging", !1), v.dispose(), b.dispose();
      }));
    }))), this._register(Ge(((u) => {
      const g = [];
      if (!this._hide) {
        const p = m(0, "{0} hidden lines", i.getHiddenModifiedRange(u).length), f = Q("span", { title: m(0, "Double click to unfold") }, p);
        f.addEventListener("dblclick", ((b) => {
          b.button === 0 && (b.preventDefault(), this._unchangedRegion.showAll(void 0));
        })), g.push(f);
        const _ = this._unchangedRegion.getHiddenModifiedRange(u), v = this._modifiedOutlineSource.getBreadcrumbItems(_, u);
        if (v.length > 0) {
          g.push(Q("span", void 0, "  |  "));
          for (let b = 0; b < v.length; b++) {
            const C = v[b], w = yt("div.breadcrumb-item", { style: { display: "flex", alignItems: "center" } }, [Lv(Rw.toIcon(C.kind)), " ", C.name, ...b === v.length - 1 ? [] : [Lv(ne.chevronRight)]]).root;
            g.push(w), w.onclick = () => {
              this._revealModifiedHiddenLine(C.startLineNumber);
            };
          }
        }
      }
      wn(this._nodes.others, ...g);
    })));
  }
}
var cr, Nne = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ene = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Pu = cr = class extends V {
  constructor(n, e, t, i, s, o, r) {
    super(), this._editors = n, this._rootElement = e, this._diffModel = t, this._rootWidth = i, this._rootHeight = s, this._modifiedEditorLayoutInfo = o, this._themeService = r, this.width = cr.ENTIRE_DIFF_OVERVIEW_WIDTH;
    const a = Rt(this._themeService.onDidColorThemeChange, (() => this._themeService.getColorTheme())), l = Fe(((c) => {
      const u = a.read(c);
      return { insertColor: u.getColor(L$) || (u.getColor(y$) || ZE).transparent(2), removeColor: u.getColor(k$) || (u.getColor(S$) || YE).transparent(2) };
    })), d = wt(document.createElement("div"));
    d.setClassName("diffViewport"), d.setPosition("absolute");
    const h = yt("div.diffOverview", { style: { position: "absolute", top: "0px", width: cr.ENTIRE_DIFF_OVERVIEW_WIDTH + "px" } }).root;
    this._register(T_(h, d.domNode)), this._register(bi(h, ie.POINTER_DOWN, ((c) => {
      this._editors.modified.delegateVerticalScrollbarPointerDown(c);
    }))), this._register(K(h, ie.MOUSE_WHEEL, ((c) => {
      this._editors.modified.delegateScrollFromMouseWheelEvent(c);
    }), { passive: !1 })), this._register(T_(this._rootElement, h)), this._register(nr(((c, u) => {
      const g = this._diffModel.read(c), p = this._editors.original.createOverviewRuler("original diffOverviewRuler");
      p && (u.add(p), u.add(T_(h, p.getDomNode())));
      const f = this._editors.modified.createOverviewRuler("modified diffOverviewRuler");
      if (f && (u.add(f), u.add(T_(h, f.getDomNode()))), !p || !f) return;
      const _ = Hn("viewZoneChanged", this._editors.original.onDidChangeViewZones), v = Hn("viewZoneChanged", this._editors.modified.onDidChangeViewZones), b = Hn("hiddenRangesChanged", this._editors.original.onDidChangeHiddenAreas), C = Hn("hiddenRangesChanged", this._editors.modified.onDidChangeHiddenAreas);
      u.add(Ge(((w) => {
        var y;
        _.read(w), v.read(w), b.read(w), C.read(w);
        const L = l.read(w), k = (y = g?.diff.read(w)) === null || y === void 0 ? void 0 : y.mappings;
        function N(T, O, H) {
          const $ = H._getViewModel();
          return $ ? T.filter(((pe) => pe.length > 0)).map(((pe) => {
            const me = $.coordinatesConverter.convertModelPositionToViewPosition(new W(pe.startLineNumber, 1)), ue = $.coordinatesConverter.convertModelPositionToViewPosition(new W(pe.endLineNumberExclusive, 1)), ee = ue.lineNumber - me.lineNumber;
            return new qB(me.lineNumber, ue.lineNumber, ee, O.toString());
          })) : [];
        }
        const A = N((k || []).map(((T) => T.lineRangeMapping.original)), L.removeColor, this._editors.original), B = N((k || []).map(((T) => T.lineRangeMapping.modified)), L.insertColor, this._editors.modified);
        p?.setZones(A), f?.setZones(B);
      }))), u.add(Ge(((w) => {
        const y = this._rootHeight.read(w), L = this._rootWidth.read(w), k = this._modifiedEditorLayoutInfo.read(w);
        if (k) {
          const N = cr.ENTIRE_DIFF_OVERVIEW_WIDTH - 2 * cr.ONE_OVERVIEW_WIDTH;
          p.setLayout({ top: 0, height: y, right: N + cr.ONE_OVERVIEW_WIDTH, width: cr.ONE_OVERVIEW_WIDTH }), f.setLayout({ top: 0, height: y, right: 0, width: cr.ONE_OVERVIEW_WIDTH });
          const A = this._editors.modifiedScrollTop.read(w), B = this._editors.modifiedScrollHeight.read(w), T = this._editors.modified.getOption(103), O = new Km(T.verticalHasArrows ? T.arrowSize : 0, T.verticalScrollbarSize, 0, k.height, B, A);
          d.setTop(O.getSliderPosition()), d.setHeight(O.getSliderSize());
        } else d.setTop(0), d.setHeight(0);
        h.style.height = y + "px", h.style.left = L - cr.ENTIRE_DIFF_OVERVIEW_WIDTH + "px", d.setWidth(cr.ENTIRE_DIFF_OVERVIEW_WIDTH);
      })));
    })));
  }
};
Pu.ONE_OVERVIEW_WIDTH = 15, Pu.ENTIRE_DIFF_OVERVIEW_WIDTH = 2 * cr.ONE_OVERVIEW_WIDTH, Pu = cr = Nne([Ene(6, Yi)], Pu);
const hx = [];
class Ine extends V {
  constructor(e, t, i, s) {
    super(), this._editors = e, this._diffModel = t, this._options = i, this._widget = s, this._selectedDiffs = Fe(this, ((o) => {
      const r = this._diffModel.read(o), a = r?.diff.read(o);
      if (!a) return hx;
      const l = this._editors.modifiedSelections.read(o);
      if (l.every(((c) => c.isEmpty()))) return hx;
      const d = new Uo(l.map(((c) => je.fromRangeInclusive(c)))), h = a.mappings.filter(((c) => c.lineRangeMapping.innerChanges && d.intersects(c.lineRangeMapping.modified))).map(((c) => ({ mapping: c, rangeMappings: c.lineRangeMapping.innerChanges.filter(((u) => l.some(((g) => D.areIntersecting(u.modifiedRange, g))))) })));
      return h.length === 0 || h.every(((c) => c.rangeMappings.length === 0)) ? hx : h;
    })), this._register(nr(((o, r) => {
      if (!this._options.shouldRenderOldRevertArrows.read(o)) return;
      const a = this._diffModel.read(o), l = a?.diff.read(o);
      if (!a || !l || a.movedTextToCompare.read(o)) return;
      const d = [], h = this._selectedDiffs.read(o), c = new Set(h.map(((u) => u.mapping)));
      if (h.length > 0) {
        const u = this._editors.modifiedSelections.read(o), g = r.add(new Kv(u[u.length - 1].positionLineNumber, this._widget, h.flatMap(((p) => p.rangeMappings)), !0));
        this._editors.modified.addGlyphMarginWidget(g), d.push(g);
      }
      for (const u of l.mappings) if (!c.has(u) && !u.lineRangeMapping.modified.isEmpty && u.lineRangeMapping.innerChanges) {
        const g = r.add(new Kv(u.lineRangeMapping.modified.startLineNumber, this._widget, u.lineRangeMapping, !1));
        this._editors.modified.addGlyphMarginWidget(g), d.push(g);
      }
      r.add(ye((() => {
        for (const u of d) this._editors.modified.removeGlyphMarginWidget(u);
      })));
    })));
  }
}
class Kv extends V {
  getId() {
    return this._id;
  }
  constructor(e, t, i, s) {
    super(), this._lineNumber = e, this._widget = t, this._diffs = i, this._revertSelection = s, this._id = "revertButton" + Kv.counter++, this._domNode = yt("div.revertButton", { title: this._revertSelection ? m(0, "Revert Selected Changes") : m(0, "Revert Change") }, [Lv(ne.arrowRight)]).root, this._register(K(this._domNode, ie.MOUSE_DOWN, ((o) => {
      o.button !== 2 && (o.stopPropagation(), o.preventDefault());
    }))), this._register(K(this._domNode, ie.MOUSE_UP, ((o) => {
      o.stopPropagation(), o.preventDefault();
    }))), this._register(K(this._domNode, ie.CLICK, ((o) => {
      this._diffs instanceof us ? this._widget.revert(this._diffs) : this._widget.revertRangeMappings(this._diffs), o.stopPropagation(), o.preventDefault();
    })));
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return { lane: _l.Right, range: { startColumn: 1, startLineNumber: this._lineNumber, endColumn: 1, endLineNumber: this._lineNumber }, zIndex: 10001 };
  }
}
Kv.counter = 0;
var Mne = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, BF = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let K2 = class extends V {
  get onDidContentSizeChange() {
    return this._onDidContentSizeChange.event;
  }
  constructor(n, e, t, i, s, o, r) {
    super(), this.originalEditorElement = n, this.modifiedEditorElement = e, this._options = t, this._argCodeEditorWidgetOptions = i, this._createInnerEditor = s, this._instantiationService = o, this._keybindingService = r, this.original = this._register(this._createLeftHandSideEditor(this._options.editorOptions.get(), this._argCodeEditorWidgetOptions.originalEditor || {})), this.modified = this._register(this._createRightHandSideEditor(this._options.editorOptions.get(), this._argCodeEditorWidgetOptions.modifiedEditor || {})), this._onDidContentSizeChange = this._register(new F()), this.modifiedScrollTop = Rt(this.modified.onDidScrollChange, (() => this.modified.getScrollTop())), this.modifiedScrollHeight = Rt(this.modified.onDidScrollChange, (() => this.modified.getScrollHeight())), this.modifiedModel = Rt(this.modified.onDidChangeModel, (() => this.modified.getModel())), this.modifiedSelections = Rt(this.modified.onDidChangeCursorSelection, (() => {
      var a;
      return (a = this.modified.getSelections()) !== null && a !== void 0 ? a : [];
    })), this.modifiedCursor = mm({ owner: this, equalityComparer: W.equals }, ((a) => {
      var l, d;
      return (d = (l = this.modifiedSelections.read(a)[0]) === null || l === void 0 ? void 0 : l.getPosition()) !== null && d !== void 0 ? d : new W(1, 1);
    })), this.originalCursor = Rt(this.original.onDidChangeCursorPosition, (() => {
      var a;
      return (a = this.original.getPosition()) !== null && a !== void 0 ? a : new W(1, 1);
    })), this._argCodeEditorWidgetOptions = null, this._register(A1({ createEmptyChangeSummary: () => ({}), handleChange: (a, l) => (a.didChange(t.editorOptions) && Object.assign(l, a.change.changedOptions), !0) }, ((a, l) => {
      t.editorOptions.read(a), this._options.renderSideBySide.read(a), this.modified.updateOptions(this._adjustOptionsForRightHandSide(a, l)), this.original.updateOptions(this._adjustOptionsForLeftHandSide(a, l));
    })));
  }
  _createLeftHandSideEditor(n, e) {
    const t = this._adjustOptionsForLeftHandSide(void 0, n), i = this._constructInnerEditor(this._instantiationService, this.originalEditorElement, t, e);
    return i.setContextValue("isInDiffLeftEditor", !0), i;
  }
  _createRightHandSideEditor(n, e) {
    const t = this._adjustOptionsForRightHandSide(void 0, n), i = this._constructInnerEditor(this._instantiationService, this.modifiedEditorElement, t, e);
    return i.setContextValue("isInDiffRightEditor", !0), i;
  }
  _constructInnerEditor(n, e, t, i) {
    const s = this._createInnerEditor(n, e, t, i);
    return this._register(s.onDidContentSizeChange(((o) => {
      const r = this.original.getContentWidth() + this.modified.getContentWidth() + Pu.ENTIRE_DIFF_OVERVIEW_WIDTH, a = Math.max(this.modified.getContentHeight(), this.original.getContentHeight());
      this._onDidContentSizeChange.fire({ contentHeight: a, contentWidth: r, contentHeightChanged: o.contentHeightChanged, contentWidthChanged: o.contentWidthChanged });
    }))), s;
  }
  _adjustOptionsForLeftHandSide(n, e) {
    const t = this._adjustOptionsForSubEditor(e);
    return this._options.renderSideBySide.get() ? (t.unicodeHighlight = this._options.editorOptions.get().unicodeHighlight || {}, t.wordWrapOverride1 = this._options.diffWordWrap.get()) : (t.wordWrapOverride1 = "off", t.wordWrapOverride2 = "off", t.stickyScroll = { enabled: !1 }, t.unicodeHighlight = { nonBasicASCII: !1, ambiguousCharacters: !1, invisibleCharacters: !1 }), t.glyphMargin = this._options.renderSideBySide.get(), e.originalAriaLabel && (t.ariaLabel = e.originalAriaLabel), t.ariaLabel = this._updateAriaLabel(t.ariaLabel), t.readOnly = !this._options.originalEditable.get(), t.dropIntoEditor = { enabled: !t.readOnly }, t.extraEditorClassName = "original-in-monaco-diff-editor", t;
  }
  _adjustOptionsForRightHandSide(n, e) {
    const t = this._adjustOptionsForSubEditor(e);
    return e.modifiedAriaLabel && (t.ariaLabel = e.modifiedAriaLabel), t.ariaLabel = this._updateAriaLabel(t.ariaLabel), t.wordWrapOverride1 = this._options.diffWordWrap.get(), t.revealHorizontalRightPadding = ta.revealHorizontalRightPadding.defaultValue + Pu.ENTIRE_DIFF_OVERVIEW_WIDTH, t.scrollbar.verticalHasArrows = !1, t.extraEditorClassName = "modified-in-monaco-diff-editor", t;
  }
  _adjustOptionsForSubEditor(n) {
    const e = { ...n, dimension: { height: 0, width: 0 } };
    return e.inDiffEditor = !0, e.automaticLayout = !1, e.scrollbar = { ...e.scrollbar || {} }, e.folding = !1, e.codeLens = this._options.diffCodeLens.get(), e.fixedOverflowWidgets = !0, e.minimap = { ...e.minimap || {} }, e.minimap.enabled = !1, this._options.hideUnchangedRegions.get() ? e.stickyScroll = { enabled: !1 } : e.stickyScroll = this._options.editorOptions.get().stickyScroll, e;
  }
  _updateAriaLabel(n) {
    var e;
    n || (n = "");
    const t = m(0, " use {0} to open the accessibility help.", (e = this._keybindingService.lookupKeybinding("editor.action.accessibilityHelp")) === null || e === void 0 ? void 0 : e.getAriaLabel());
    return this._options.accessibilityVerbose.get() ? n + t : n ? n.replaceAll(t, "") : "";
  }
};
K2 = Mne([BF(5, Se), BF(6, Dt)], K2);
class zL extends V {
  constructor() {
    super(...arguments), this._id = ++zL.idCounter, this._onDidDispose = this._register(new F()), this.onDidDispose = this._onDidDispose.event;
  }
  getId() {
    return this.getEditorType() + ":v2:" + this._id;
  }
  getVisibleColumnFromPosition(e) {
    return this._targetEditor.getVisibleColumnFromPosition(e);
  }
  getPosition() {
    return this._targetEditor.getPosition();
  }
  setPosition(e, t = "api") {
    this._targetEditor.setPosition(e, t);
  }
  revealLine(e, t = 0) {
    this._targetEditor.revealLine(e, t);
  }
  revealLineInCenter(e, t = 0) {
    this._targetEditor.revealLineInCenter(e, t);
  }
  revealLineInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealLineInCenterIfOutsideViewport(e, t);
  }
  revealLineNearTop(e, t = 0) {
    this._targetEditor.revealLineNearTop(e, t);
  }
  revealPosition(e, t = 0) {
    this._targetEditor.revealPosition(e, t);
  }
  revealPositionInCenter(e, t = 0) {
    this._targetEditor.revealPositionInCenter(e, t);
  }
  revealPositionInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealPositionInCenterIfOutsideViewport(e, t);
  }
  revealPositionNearTop(e, t = 0) {
    this._targetEditor.revealPositionNearTop(e, t);
  }
  getSelection() {
    return this._targetEditor.getSelection();
  }
  getSelections() {
    return this._targetEditor.getSelections();
  }
  setSelection(e, t = "api") {
    this._targetEditor.setSelection(e, t);
  }
  setSelections(e, t = "api") {
    this._targetEditor.setSelections(e, t);
  }
  revealLines(e, t, i = 0) {
    this._targetEditor.revealLines(e, t, i);
  }
  revealLinesInCenter(e, t, i = 0) {
    this._targetEditor.revealLinesInCenter(e, t, i);
  }
  revealLinesInCenterIfOutsideViewport(e, t, i = 0) {
    this._targetEditor.revealLinesInCenterIfOutsideViewport(e, t, i);
  }
  revealLinesNearTop(e, t, i = 0) {
    this._targetEditor.revealLinesNearTop(e, t, i);
  }
  revealRange(e, t = 0, i = !1, s = !0) {
    this._targetEditor.revealRange(e, t, i, s);
  }
  revealRangeInCenter(e, t = 0) {
    this._targetEditor.revealRangeInCenter(e, t);
  }
  revealRangeInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealRangeInCenterIfOutsideViewport(e, t);
  }
  revealRangeNearTop(e, t = 0) {
    this._targetEditor.revealRangeNearTop(e, t);
  }
  revealRangeNearTopIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealRangeNearTopIfOutsideViewport(e, t);
  }
  revealRangeAtTop(e, t = 0) {
    this._targetEditor.revealRangeAtTop(e, t);
  }
  getSupportedActions() {
    return this._targetEditor.getSupportedActions();
  }
  focus() {
    this._targetEditor.focus();
  }
  trigger(e, t, i) {
    this._targetEditor.trigger(e, t, i);
  }
  createDecorationsCollection(e) {
    return this._targetEditor.createDecorationsCollection(e);
  }
  changeDecorations(e) {
    return this._targetEditor.changeDecorations(e);
  }
}
zL.idCounter = 0;
var Tne = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Rne = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let j2 = class {
  get editorOptions() {
    return this._options;
  }
  constructor(n, e) {
    this._accessibilityService = e, this._diffEditorWidth = lt(this, 0), this._screenReaderMode = Rt(this._accessibilityService.onDidChangeScreenReaderOptimized, (() => this._accessibilityService.isScreenReaderOptimized())), this.couldShowInlineViewBecauseOfSize = Fe(this, ((i) => this._options.read(i).renderSideBySide && this._diffEditorWidth.read(i) <= this._options.read(i).renderSideBySideInlineBreakpoint)), this.renderOverviewRuler = Fe(this, ((i) => this._options.read(i).renderOverviewRuler)), this.renderSideBySide = Fe(this, ((i) => this._options.read(i).renderSideBySide && !(this._options.read(i).useInlineViewWhenSpaceIsLimited && this.couldShowInlineViewBecauseOfSize.read(i) && !this._screenReaderMode.read(i)))), this.readOnly = Fe(this, ((i) => this._options.read(i).readOnly)), this.shouldRenderOldRevertArrows = Fe(this, ((i) => !!this._options.read(i).renderMarginRevertIcon && !!this.renderSideBySide.read(i) && !this.readOnly.read(i) && !this.shouldRenderGutterMenu.read(i))), this.shouldRenderGutterMenu = Fe(this, ((i) => this._options.read(i).renderGutterMenu)), this.renderIndicators = Fe(this, ((i) => this._options.read(i).renderIndicators)), this.enableSplitViewResizing = Fe(this, ((i) => this._options.read(i).enableSplitViewResizing)), this.splitViewDefaultRatio = Fe(this, ((i) => this._options.read(i).splitViewDefaultRatio)), this.ignoreTrimWhitespace = Fe(this, ((i) => this._options.read(i).ignoreTrimWhitespace)), this.maxComputationTimeMs = Fe(this, ((i) => this._options.read(i).maxComputationTime)), this.showMoves = Fe(this, ((i) => this._options.read(i).experimental.showMoves && this.renderSideBySide.read(i))), this.isInEmbeddedEditor = Fe(this, ((i) => this._options.read(i).isInEmbeddedEditor)), this.diffWordWrap = Fe(this, ((i) => this._options.read(i).diffWordWrap)), this.originalEditable = Fe(this, ((i) => this._options.read(i).originalEditable)), this.diffCodeLens = Fe(this, ((i) => this._options.read(i).diffCodeLens)), this.accessibilityVerbose = Fe(this, ((i) => this._options.read(i).accessibilityVerbose)), this.diffAlgorithm = Fe(this, ((i) => this._options.read(i).diffAlgorithm)), this.showEmptyDecorations = Fe(this, ((i) => this._options.read(i).experimental.showEmptyDecorations)), this.onlyShowAccessibleDiffViewer = Fe(this, ((i) => this._options.read(i).onlyShowAccessibleDiffViewer)), this.hideUnchangedRegions = Fe(this, ((i) => this._options.read(i).hideUnchangedRegions.enabled)), this.hideUnchangedRegionsRevealLineCount = Fe(this, ((i) => this._options.read(i).hideUnchangedRegions.revealLineCount)), this.hideUnchangedRegionsContextLineCount = Fe(this, ((i) => this._options.read(i).hideUnchangedRegions.contextLineCount)), this.hideUnchangedRegionsMinimumLineCount = Fe(this, ((i) => this._options.read(i).hideUnchangedRegions.minimumLineCount));
    const t = { ...n, ...WF(n, An) };
    this._options = lt(this, t);
  }
  updateOptions(n) {
    const e = WF(n, this._options.get()), t = { ...this._options.get(), ...n, ...e };
    this._options.set(t, void 0, { changedOptions: n });
  }
  setWidth(n) {
    this._diffEditorWidth.set(n, void 0);
  }
};
function WF(n, e) {
  var t, i, s, o, r, a, l, d;
  return { enableSplitViewResizing: ve(n.enableSplitViewResizing, e.enableSplitViewResizing), splitViewDefaultRatio: eK(n.splitViewDefaultRatio, 0.5, 0.1, 0.9), renderSideBySide: ve(n.renderSideBySide, e.renderSideBySide), renderMarginRevertIcon: ve(n.renderMarginRevertIcon, e.renderMarginRevertIcon), maxComputationTime: iu(n.maxComputationTime, e.maxComputationTime, 0, 1073741824), maxFileSize: iu(n.maxFileSize, e.maxFileSize, 0, 1073741824), ignoreTrimWhitespace: ve(n.ignoreTrimWhitespace, e.ignoreTrimWhitespace), renderIndicators: ve(n.renderIndicators, e.renderIndicators), originalEditable: ve(n.originalEditable, e.originalEditable), diffCodeLens: ve(n.diffCodeLens, e.diffCodeLens), renderOverviewRuler: ve(n.renderOverviewRuler, e.renderOverviewRuler), diffWordWrap: _i(n.diffWordWrap, e.diffWordWrap, ["off", "on", "inherit"]), diffAlgorithm: _i(n.diffAlgorithm, e.diffAlgorithm, ["legacy", "advanced"], { smart: "legacy", experimental: "advanced" }), accessibilityVerbose: ve(n.accessibilityVerbose, e.accessibilityVerbose), experimental: { showMoves: ve((t = n.experimental) === null || t === void 0 ? void 0 : t.showMoves, e.experimental.showMoves), showEmptyDecorations: ve((i = n.experimental) === null || i === void 0 ? void 0 : i.showEmptyDecorations, e.experimental.showEmptyDecorations) }, hideUnchangedRegions: { enabled: ve((o = (s = n.hideUnchangedRegions) === null || s === void 0 ? void 0 : s.enabled) !== null && o !== void 0 ? o : (r = n.experimental) === null || r === void 0 ? void 0 : r.collapseUnchangedRegions, e.hideUnchangedRegions.enabled), contextLineCount: iu((a = n.hideUnchangedRegions) === null || a === void 0 ? void 0 : a.contextLineCount, e.hideUnchangedRegions.contextLineCount, 0, 1073741824), minimumLineCount: iu((l = n.hideUnchangedRegions) === null || l === void 0 ? void 0 : l.minimumLineCount, e.hideUnchangedRegions.minimumLineCount, 0, 1073741824), revealLineCount: iu((d = n.hideUnchangedRegions) === null || d === void 0 ? void 0 : d.revealLineCount, e.hideUnchangedRegions.revealLineCount, 0, 1073741824) }, isInEmbeddedEditor: ve(n.isInEmbeddedEditor, e.isInEmbeddedEditor), onlyShowAccessibleDiffViewer: ve(n.onlyShowAccessibleDiffViewer, e.onlyShowAccessibleDiffViewer), renderSideBySideInlineBreakpoint: iu(n.renderSideBySideInlineBreakpoint, e.renderSideBySideInlineBreakpoint, 0, 1073741824), useInlineViewWhenSpaceIsLimited: ve(n.useInlineViewWhenSpaceIsLimited, e.useInlineViewWhenSpaceIsLimited), renderGutterMenu: ve(n.renderGutterMenu, e.renderGutterMenu) };
}
j2 = Tne([Rne(1, or)], j2);
class Ane extends V {
  constructor(e, t, i) {
    super(), this._editor = e, this._domNode = t, this.itemProvider = i, this.scrollTop = Rt(this._editor.onDidScrollChange, ((r) => this._editor.getScrollTop())), this.isScrollTopZero = this.scrollTop.map(((r) => r === 0)), this.modelAttached = Rt(this._editor.onDidChangeModel, ((r) => this._editor.hasModel())), this.editorOnDidChangeViewZones = Hn("onDidChangeViewZones", this._editor.onDidChangeViewZones), this.editorOnDidContentSizeChange = Hn("onDidContentSizeChange", this._editor.onDidContentSizeChange), this.domNodeSizeChanged = DL("domNodeSizeChanged"), this.views = /* @__PURE__ */ new Map(), this._domNode.className = "gutter monaco-editor";
    const s = this._domNode.appendChild(yt("div.scroll-decoration", { role: "presentation", ariaHidden: "true", style: { width: "100%" } }).root), o = new ResizeObserver((() => {
      Tt(((r) => {
        this.domNodeSizeChanged.trigger(r);
      }));
    }));
    o.observe(this._domNode), this._register(ye((() => o.disconnect()))), this._register(Ge(((r) => {
      s.className = this.isScrollTopZero.read(r) ? "" : "scroll-decoration";
    }))), this._register(Ge(((r) => this.render(r))));
  }
  dispose() {
    super.dispose(), wn(this._domNode);
  }
  render(e) {
    if (!this.modelAttached.read(e)) return;
    this.domNodeSizeChanged.read(e), this.editorOnDidChangeViewZones.read(e), this.editorOnDidContentSizeChange.read(e);
    const t = this.scrollTop.read(e), i = this._editor.getVisibleRanges(), s = new Set(this.views.keys()), o = qe.ofStartAndLength(0, this._domNode.clientHeight);
    if (!o.isEmpty) for (const r of i) {
      const a = new je(r.startLineNumber, r.endLineNumber + 1), l = this.itemProvider.getIntersectingGutterItems(a, e);
      Tt(((d) => {
        for (const h of l) {
          if (!h.range.intersect(a)) continue;
          s.delete(h.id);
          let c = this.views.get(h.id);
          if (c) c.item.set(h, d);
          else {
            const p = document.createElement("div");
            this._domNode.appendChild(p);
            const f = lt("item", h), _ = this.itemProvider.createView(f, p);
            c = new Pne(f, _, p), this.views.set(h.id, c);
          }
          const u = h.range.startLineNumber <= this._editor.getModel().getLineCount() ? this._editor.getTopForLineNumber(h.range.startLineNumber, !0) - t : this._editor.getBottomForLineNumber(h.range.startLineNumber - 1, !1) - t, g = (h.range.isEmpty ? u : this._editor.getBottomForLineNumber(h.range.endLineNumberExclusive - 1, !0) - t) - u;
          c.domNode.style.top = `${u}px`, c.domNode.style.height = `${g}px`, c.gutterItemView.layout(qe.ofStartAndLength(u, g), o);
        }
      }));
    }
    for (const r of s) {
      const a = this.views.get(r);
      a.gutterItemView.dispose(), this._domNode.removeChild(a.domNode), this.views.delete(r);
    }
  }
}
class Pne {
  constructor(e, t, i) {
    this.item = e, this.gutterItemView = t, this.domNode = i;
  }
}
class jV extends lg {
  constructor(e) {
    super(), this._getContext = e;
  }
  runAction(e, t) {
    const i = this._getContext();
    return super.runAction(e, i);
  }
}
class One {
  constructor(e) {
    this.text = e, this.lineStartOffsetByLineIdx = [], this.lineStartOffsetByLineIdx.push(0);
    for (let t = 0; t < e.length; t++) e.charAt(t) === `
` && this.lineStartOffsetByLineIdx.push(t + 1);
  }
  getOffset(e) {
    return this.lineStartOffsetByLineIdx[e.lineNumber - 1] + e.column - 1;
  }
  getOffsetRange(e) {
    return new qe(this.getOffset(e.getStartPosition()), this.getOffset(e.getEndPosition()));
  }
  get textLength() {
    const e = this.lineStartOffsetByLineIdx.length - 1;
    return new kr(e, this.text.length - this.lineStartOffsetByLineIdx[e]);
  }
}
class eP {
  constructor(e) {
    this.edits = e, dg((() => bR(e, ((t, i) => t.range.getEndPosition().isBeforeOrEqual(i.range.getStartPosition())))));
  }
  apply(e) {
    let t = "", i = new W(1, 1);
    for (const o of this.edits) {
      const r = o.range, a = r.getStartPosition(), l = r.getEndPosition(), d = VF(i, a);
      d.isEmpty() || (t += e.getValueOfRange(d)), t += o.text, i = l;
    }
    const s = VF(i, e.endPositionExclusive);
    return s.isEmpty() || (t += e.getValueOfRange(s)), t;
  }
  applyToString(e) {
    const t = new Fne(e);
    return this.apply(t);
  }
  getNewRanges() {
    const e = [];
    let t = 0, i = 0, s = 0;
    for (const o of this.edits) {
      const r = kr.ofText(o.text), a = W.lift({ lineNumber: o.range.startLineNumber + i, column: o.range.startColumn + (o.range.startLineNumber === t ? s : 0) }), l = r.createRange(a);
      e.push(l), i = l.endLineNumber - o.range.endLineNumber, s = l.endColumn - o.range.endColumn, t = o.range.endLineNumber;
    }
    return e;
  }
}
class Bd {
  constructor(e, t) {
    this.range = e, this.text = t;
  }
}
function VF(n, e) {
  if (!n.isBeforeOrEqual(e)) throw new Kt("start must be before end");
  return new D(n.lineNumber, n.column, e.lineNumber, e.column);
}
class qV {
  get endPositionExclusive() {
    return this.length.addToPosition(new W(1, 1));
  }
}
class Fne extends qV {
  constructor(e) {
    super(), this.value = e, this._t = new One(this.value);
  }
  getValueOfRange(e) {
    return this._t.getOffsetRange(e).substring(this.value);
  }
  get length() {
    return this._t.textLength;
  }
}
class Bne extends qV {
  constructor(e) {
    super(), this._textModel = e;
  }
  getValueOfRange(e) {
    return this._textModel.getValueInRange(e);
  }
  get length() {
    const e = this._textModel.getLineCount(), t = this._textModel.getLineLength(e);
    return new kr(e - 1, t);
  }
}
class Wne extends V {
  constructor(e, t, i = { orientation: 0 }) {
    var s;
    super(), this.submenuActionViewItems = [], this.hasSecondaryActions = !1, this._onDidChangeDropdownVisibility = this._register(new aK()), this.onDidChangeDropdownVisibility = this._onDidChangeDropdownVisibility.event, this.disposables = this._register(new G()), i.hoverDelegate = (s = i.hoverDelegate) !== null && s !== void 0 ? s : this._register(Zm()), this.options = i, this.lookupKeybindings = typeof this.options.getKeyBinding == "function", this.toggleMenuAction = this._register(new jv((() => {
      var o;
      return (o = this.toggleMenuActionViewItem) === null || o === void 0 ? void 0 : o.show();
    }), i.toggleMenuTitle)), this.element = document.createElement("div"), this.element.className = "monaco-toolbar", e.appendChild(this.element), this.actionBar = this._register(new sr(this.element, { orientation: i.orientation, ariaLabel: i.ariaLabel, actionRunner: i.actionRunner, allowContextMenu: i.allowContextMenu, highlightToggledItems: i.highlightToggledItems, hoverDelegate: i.hoverDelegate, actionViewItemProvider: (o, r) => {
      var a;
      if (o.id === jv.ID) return this.toggleMenuActionViewItem = new Ay(o, o.menuActions, t, { actionViewItemProvider: this.options.actionViewItemProvider, actionRunner: this.actionRunner, keybindingProvider: this.options.getKeyBinding, classNames: Ee.asClassNameArray((a = i.moreIcon) !== null && a !== void 0 ? a : ne.toolBarMore), anchorAlignmentProvider: this.options.anchorAlignmentProvider, menuAsChild: !!this.options.renderDropdownAsChildElement, skipTelemetry: this.options.skipTelemetry, isMenu: !0, hoverDelegate: this.options.hoverDelegate }), this.toggleMenuActionViewItem.setActionContext(this.actionBar.context), this.disposables.add(this._onDidChangeDropdownVisibility.add(this.toggleMenuActionViewItem.onDidChangeVisibility)), this.toggleMenuActionViewItem;
      if (i.actionViewItemProvider) {
        const l = i.actionViewItemProvider(o, r);
        if (l) return l;
      }
      if (o instanceof Om) {
        const l = new Ay(o, o.actions, t, { actionViewItemProvider: this.options.actionViewItemProvider, actionRunner: this.actionRunner, keybindingProvider: this.options.getKeyBinding, classNames: o.class, anchorAlignmentProvider: this.options.anchorAlignmentProvider, menuAsChild: !!this.options.renderDropdownAsChildElement, skipTelemetry: this.options.skipTelemetry, hoverDelegate: this.options.hoverDelegate });
        return l.setActionContext(this.actionBar.context), this.submenuActionViewItems.push(l), this.disposables.add(this._onDidChangeDropdownVisibility.add(l.onDidChangeVisibility)), l;
      }
    } }));
  }
  set actionRunner(e) {
    this.actionBar.actionRunner = e;
  }
  get actionRunner() {
    return this.actionBar.actionRunner;
  }
  getElement() {
    return this.element;
  }
  getItemAction(e) {
    return this.actionBar.getAction(e);
  }
  setActions(e, t) {
    this.clear();
    const i = e ? e.slice(0) : [];
    this.hasSecondaryActions = !!(t && t.length > 0), this.hasSecondaryActions && t && (this.toggleMenuAction.menuActions = t.slice(0), i.push(this.toggleMenuAction)), i.forEach(((s) => {
      this.actionBar.push(s, { icon: !0, label: !1, keybinding: this.getKeybindingLabel(s) });
    }));
  }
  getKeybindingLabel(e) {
    var t, i, s;
    const o = this.lookupKeybindings ? (i = (t = this.options).getKeyBinding) === null || i === void 0 ? void 0 : i.call(t, e) : void 0;
    return (s = o?.getLabel()) !== null && s !== void 0 ? s : void 0;
  }
  clear() {
    this.submenuActionViewItems = [], this.disposables.clear(), this.actionBar.clear();
  }
  dispose() {
    this.clear(), this.disposables.dispose(), super.dispose();
  }
}
class jv extends Qs {
  constructor(e, t) {
    t = t || m(0, "More Actions..."), super(jv.ID, t, void 0, !0), this._menuActions = [], this.toggleDropdownMenu = e;
  }
  async run() {
    this.toggleDropdownMenu();
  }
  get menuActions() {
    return this._menuActions;
  }
  set menuActions(e) {
    this._menuActions = e;
  }
}
jv.ID = "toolbar.toggle.more";
var $V = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ja = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let qv = class extends Wne {
  constructor(n, e, t, i, s, o, r) {
    super(n, s, { getKeyBinding: (l) => {
      var d;
      return (d = o.lookupKeybinding(l.id)) !== null && d !== void 0 ? d : void 0;
    }, ...e, allowContextMenu: !0, skipTelemetry: typeof e?.telemetrySource == "string" }), this._options = e, this._menuService = t, this._contextKeyService = i, this._contextMenuService = s, this._sessionDisposables = this._store.add(new G());
    const a = e?.telemetrySource;
    a && this._store.add(this.actionBar.onDidRun(((l) => r.publicLog2("workbenchActionExecuted", { id: l.action.id, from: a }))));
  }
  setActions(n, e = [], t) {
    var i, s, o;
    this._sessionDisposables.clear();
    const r = n.slice(), a = e.slice(), l = [];
    let d = 0;
    const h = [];
    let c = !1;
    if (((i = this._options) === null || i === void 0 ? void 0 : i.hiddenItemStrategy) !== -1) for (let u = 0; u < r.length; u++) {
      const g = r[u];
      (g instanceof Eo || g instanceof ev) && g.hideActions && (l.push(g.hideActions.toggle), g.hideActions.toggle.checked && d++, g.hideActions.isHidden && (c = !0, r[u] = void 0, ((s = this._options) === null || s === void 0 ? void 0 : s.hiddenItemStrategy) !== 0 && (h[u] = g)));
    }
    if (((o = this._options) === null || o === void 0 ? void 0 : o.overflowBehavior) !== void 0) {
      const u = (function(f, _) {
        const v = /* @__PURE__ */ new Set();
        for (const b of _) f.has(b) && v.add(b);
        return v;
      })(new Set(this._options.overflowBehavior.exempted), at.map(r, ((f) => f?.id))), g = this._options.overflowBehavior.maxItems - u.size;
      let p = 0;
      for (let f = 0; f < r.length; f++) {
        const _ = r[f];
        _ && (p++, u.has(_.id) || p >= g && (r[f] = void 0, h[f] = _));
      }
    }
    GP(r), GP(h), super.setActions(r, Ui.join(h, a)), l.length > 0 && this._sessionDisposables.add(K(this.getElement(), "contextmenu", ((u) => {
      var g, p, f, _, v;
      const b = new _r(ke(this.getElement()), u), C = this.getItemAction(b.target);
      if (!C) return;
      b.preventDefault(), b.stopPropagation();
      let w, y = !1;
      if (d === 1 && ((g = this._options) === null || g === void 0 ? void 0 : g.hiddenItemStrategy) === 0) {
        y = !0;
        for (let k = 0; k < l.length; k++) if (l[k].checked) {
          l[k] = Yp({ id: C.id, label: C.label, checked: !0, enabled: !1, run() {
          } });
          break;
        }
      }
      if (!y && (C instanceof Eo || C instanceof ev)) {
        if (!C.hideActions) return;
        w = C.hideActions.hide;
      } else w = Yp({ id: "label", label: m(0, "Hide"), enabled: !1, run() {
      } });
      const L = Ui.join([w], l);
      !((p = this._options) === null || p === void 0) && p.resetMenu && !t && (t = [this._options.resetMenu]), c && t && (L.push(new Ui()), L.push(Yp({ id: "resetThisMenu", label: m(0, "Reset Menu"), run: () => this._menuService.resetHiddenStates(t) }))), this._contextMenuService.showContextMenu({ getAnchor: () => b, getActions: () => L, menuId: (f = this._options) === null || f === void 0 ? void 0 : f.contextMenu, menuActionOptions: { renderShortTitle: !0, ...(_ = this._options) === null || _ === void 0 ? void 0 : _.menuOptions }, skipTelemetry: typeof ((v = this._options) === null || v === void 0 ? void 0 : v.telemetrySource) == "string", contextKeyService: this._contextKeyService });
    })));
  }
};
qv = $V([Ja(2, Mo), Ja(3, Te), Ja(4, io), Ja(5, Dt), Ja(6, es)], qv);
let nS = class extends qv {
  constructor(n, e, t, i, s, o, r, a) {
    super(n, { resetMenu: e, ...t }, i, s, o, r, a), this._onDidChangeMenuItems = this._store.add(new F()), this.onDidChangeMenuItems = this._onDidChangeMenuItems.event;
    const l = this._store.add(i.createMenu(e, s, { emitEventsForSubmenuChanges: !0 })), d = () => {
      var h, c, u;
      const g = [], p = [];
      EL(l, t?.menuOptions, { primary: g, secondary: p }, (h = t?.toolbarOptions) === null || h === void 0 ? void 0 : h.primaryGroup, (c = t?.toolbarOptions) === null || c === void 0 ? void 0 : c.shouldInlineSubmenu, (u = t?.toolbarOptions) === null || u === void 0 ? void 0 : u.useSeparatorsInPrimaryActions), n.classList.toggle("has-no-actions", g.length === 0 && p.length === 0), super.setActions(g, p);
    };
    this._store.add(l.onDidChange((() => {
      d(), this._onDidChangeMenuItems.fire(this);
    }))), d();
  }
  setActions() {
    throw new Kt("This toolbar is populated from a menu.");
  }
};
nS = $V([Ja(3, Mo), Ja(4, Te), Ja(5, io), Ja(6, Dt), Ja(7, es)], nS);
var GV = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, sw = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const cx = [];
let q2 = class extends V {
  constructor(n, e, t, i, s, o) {
    var r, a;
    super(), this._diffModel = e, this._editors = t, this._instantiationService = i, this._contextKeyService = s, this._menuService = o, this._menu = this._register(this._menuService.createMenu(x.DiffEditorHunkToolbar, this._contextKeyService)), this._actions = Rt(this._menu.onDidChange, (() => this._menu.getActions())), this._hasActions = this._actions.map(((l) => l.length > 0)), this.width = Fe(this, ((l) => this._hasActions.read(l) ? 35 : 0)), this.elements = yt("div.gutter@gutter", { style: { position: "absolute", height: "100%", width: "35px" } }, []), this._currentDiff = Fe(this, ((l) => {
      var d;
      const h = this._diffModel.read(l);
      if (!h) return;
      const c = (d = h.diff.read(l)) === null || d === void 0 ? void 0 : d.mappings, u = this._editors.modifiedCursor.read(l);
      return u ? c?.find(((g) => g.lineRangeMapping.modified.contains(u.lineNumber))) : void 0;
    })), this._selectedDiffs = Fe(this, ((l) => {
      const d = this._diffModel.read(l), h = d?.diff.read(l);
      if (!h) return cx;
      const c = this._editors.modifiedSelections.read(l);
      if (c.every(((p) => p.isEmpty()))) return cx;
      const u = new Uo(c.map(((p) => je.fromRangeInclusive(p)))), g = h.mappings.filter(((p) => p.lineRangeMapping.innerChanges && u.intersects(p.lineRangeMapping.modified))).map(((p) => ({ mapping: p, rangeMappings: p.lineRangeMapping.innerChanges.filter(((f) => c.some(((_) => D.areIntersecting(f.modifiedRange, _))))) })));
      return g.length === 0 || g.every(((p) => p.rangeMappings.length === 0)) ? cx : g;
    })), this._register((r = n, a = this.elements.root, r.prepend(a), ye((() => {
      r.removeChild(a);
    })))), this._register(K(this.elements.root, "click", (() => {
      this._editors.modified.focus();
    }))), this._register(Ed(this.elements.root, { display: this._hasActions.map(((l) => l ? "block" : "none")) })), this._register(new Ane(this._editors.modified, this.elements.root, { getIntersectingGutterItems: (l, d) => {
      const h = this._diffModel.read(d);
      if (!h) return [];
      const c = h.diff.read(d);
      if (!c) return [];
      const u = this._selectedDiffs.read(d);
      if (u.length > 0) {
        const p = xo.fromRangeMappings(u.flatMap(((f) => f.rangeMappings)));
        return [new HF(p, !0, x.DiffEditorSelectionToolbar, void 0, h.model.original.uri, h.model.modified.uri)];
      }
      const g = this._currentDiff.read(d);
      return c.mappings.map(((p) => new HF(p.lineRangeMapping.withInnerChangesFromLineRanges(), p.lineRangeMapping === g?.lineRangeMapping, x.DiffEditorHunkToolbar, void 0, h.model.original.uri, h.model.modified.uri)));
    }, createView: (l, d) => this._instantiationService.createInstance($2, l, d, this) })), this._register(K(this.elements.gutter, ie.MOUSE_WHEEL, ((l) => {
      this._editors.modified.getOption(103).handleMouseWheel && this._editors.modified.delegateScrollFromMouseWheelEvent(l);
    }), { passive: !1 }));
  }
  computeStagedValue(n) {
    var e;
    const t = (e = n.innerChanges) !== null && e !== void 0 ? e : [];
    return new eP(t.map(((i) => new Bd(i.originalRange, this._editors.modifiedModel.get().getValueInRange(i.modifiedRange))))).apply(new Bne(this._editors.original.getModel()));
  }
  layout(n) {
    this.elements.gutter.style.left = n + "px";
  }
};
q2 = GV([sw(3, Se), sw(4, Te), sw(5, Mo)], q2);
class HF {
  constructor(e, t, i, s, o, r) {
    this.mapping = e, this.showAlways = t, this.menuId = i, this.rangeOverride = s, this.originalUri = o, this.modifiedUri = r;
  }
  get id() {
    return this.mapping.modified.toString();
  }
  get range() {
    var e;
    return (e = this.rangeOverride) !== null && e !== void 0 ? e : this.mapping.modified;
  }
}
let $2 = class extends V {
  constructor(n, e, t, i) {
    super(), this._item = n, this._elements = yt("div.gutterItem", { style: { height: "20px", width: "34px" } }, [yt("div.background@background", {}, []), yt("div.buttons@buttons", {}, [])]), this._showAlways = this._item.map(this, ((o) => o.showAlways)), this._menuId = this._item.map(this, ((o) => o.menuId)), this._isSmall = lt(this, !1), this._lastItemRange = void 0, this._lastViewRange = void 0;
    const s = this._register(i.createInstance(Sv, "element", !0, { position: { hoverPosition: 1 } }));
    this._register(T_(e, this._elements.root)), this._register(Ge(((o) => {
      const r = this._showAlways.read(o);
      this._elements.root.classList.toggle("noTransition", !0), this._elements.root.classList.toggle("showAlways", r), setTimeout((() => {
        this._elements.root.classList.toggle("noTransition", !1);
      }), 0);
    }))), this._register(nr(((o, r) => {
      this._elements.buttons.replaceChildren();
      const a = r.add(i.createInstance(nS, this._elements.buttons, this._menuId.read(o), { orientation: 1, hoverDelegate: s, toolbarOptions: { primaryGroup: (l) => l.startsWith("primary") }, overflowBehavior: { maxItems: this._isSmall.read(o) ? 1 : 3 }, hiddenItemStrategy: 0, actionRunner: new jV((() => {
        const l = this._item.get(), d = l.mapping;
        return { mapping: d, originalWithModifiedChanges: t.computeStagedValue(d), originalUri: l.originalUri, modifiedUri: l.modifiedUri };
      })), menuOptions: { shouldForwardArgs: !0 } }));
      r.add(a.onDidChangeMenuItems((() => {
        this._lastItemRange && this.layout(this._lastItemRange, this._lastViewRange);
      })));
    })));
  }
  layout(n, e) {
    this._lastItemRange = n, this._lastViewRange = e;
    let t = this._elements.buttons.clientHeight;
    this._isSmall.set(this._item.get().mapping.original.startLineNumber === 1 && n.length < 30, void 0), t = this._elements.buttons.clientHeight, this._elements.root.style.top = n.start + "px", this._elements.root.style.height = n.length + "px";
    const i = n.length / 2 - t / 2, s = t;
    let o = n.start + i;
    const r = qe.tryCreate(s, e.endExclusive - s - t), a = qe.tryCreate(n.start + s, n.endExclusive - t - s);
    a && r && a.start < a.endExclusive && (o = r.clip(o), o = a.clip(o)), this._elements.buttons.style.top = o - n.start + "px";
  }
};
$2 = GV([sw(3, Se)], $2);
var Vne = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Gf = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let wd = class extends zL {
  get onDidContentSizeChange() {
    return this._editors.onDidContentSizeChange;
  }
  constructor(n, e, t, i, s, o, r, a) {
    var l;
    super(), this._domElement = n, this._parentContextKeyService = i, this._parentInstantiationService = s, this._accessibilitySignalService = r, this._editorProgressService = a, this.elements = yt("div.monaco-diff-editor.side-by-side", { style: { position: "relative", height: "100%" } }, [yt("div.noModificationsOverlay@overlay", { style: { position: "absolute", height: "100%", visibility: "hidden" } }, [Q("span", {}, "No Changes")]), yt("div.editor.original@original", { style: { position: "absolute", height: "100%" } }), yt("div.editor.modified@modified", { style: { position: "absolute", height: "100%" } }), yt("div.accessibleDiffViewer@accessibleDiffViewer", { style: { position: "absolute", height: "100%" } })]), this._diffModel = lt(this, void 0), this._shouldDisposeDiffModel = !1, this.onDidChangeModel = se.fromObservableLight(this._diffModel), this._contextKeyService = this._register(this._parentContextKeyService.createScoped(this._domElement)), this._instantiationService = this._parentInstantiationService.createChild(new N1([Te, this._contextKeyService])), this._boundarySashes = lt(this, void 0), this._accessibleDiffViewerShouldBeVisible = lt(this, !1), this._accessibleDiffViewerVisible = Fe(this, ((C) => !!this._options.onlyShowAccessibleDiffViewer.read(C) || this._accessibleDiffViewerShouldBeVisible.read(C))), this._movedBlocksLinesPart = lt(this, void 0), this._layoutInfo = Fe(this, ((C) => {
      var w, y, L, k, N;
      const A = this._rootSizeObserver.width.read(C), B = this._rootSizeObserver.height.read(C), T = this._sash.read(C), O = this._gutter.read(C), H = (w = O?.width.read(C)) !== null && w !== void 0 ? w : 0, $ = (L = (y = this._overviewRulerPart.read(C)) === null || y === void 0 ? void 0 : y.width) !== null && L !== void 0 ? L : 0;
      let pe, me, ue, ee, te;
      if (T) {
        const be = T.sashLeft.read(C);
        pe = 0, me = be - H - ((N = (k = this._movedBlocksLinesPart.read(C)) === null || k === void 0 ? void 0 : k.width.read(C)) !== null && N !== void 0 ? N : 0), te = be - H, ue = be, ee = A - ue - $;
      } else te = 0, pe = H, me = Math.max(5, this._editors.original.getLayoutInfo().decorationsLeft), ue = H + me, ee = A - ue - $;
      return this.elements.original.style.left = pe + "px", this.elements.original.style.width = me + "px", this._editors.original.layout({ width: me, height: B }, !0), O?.layout(te), this.elements.modified.style.left = ue + "px", this.elements.modified.style.width = ee + "px", this._editors.modified.layout({ width: ee, height: B }, !0), { modifiedEditor: this._editors.modified.getLayoutInfo(), originalEditor: this._editors.original.getLayoutInfo() };
    })), this._diffValue = this._diffModel.map(((C, w) => C?.diff.read(w))), this.onDidUpdateDiff = se.fromObservableLight(this._diffValue), o.willCreateDiffEditor(), this._contextKeyService.createKey("isInDiffEditor", !0), this._domElement.appendChild(this.elements.root), this._register(ye((() => this._domElement.removeChild(this.elements.root)))), this._rootSizeObserver = this._register(new WV(this.elements.root, e.dimension)), this._rootSizeObserver.setAutomaticLayout((l = e.automaticLayout) !== null && l !== void 0 && l), this._options = this._instantiationService.createInstance(j2, e), this._register(Ge(((C) => {
      this._options.setWidth(this._rootSizeObserver.width.read(C));
    }))), this._contextKeyService.createKey(E.isEmbeddedDiffEditor.key, !1), this._register(Ml(E.isEmbeddedDiffEditor, this._contextKeyService, ((C) => this._options.isInEmbeddedEditor.read(C)))), this._register(Ml(E.comparingMovedCode, this._contextKeyService, ((C) => {
      var w;
      return !!(!((w = this._diffModel.read(C)) === null || w === void 0) && w.movedTextToCompare.read(C));
    }))), this._register(Ml(E.diffEditorRenderSideBySideInlineBreakpointReached, this._contextKeyService, ((C) => this._options.couldShowInlineViewBecauseOfSize.read(C)))), this._register(Ml(E.diffEditorInlineMode, this._contextKeyService, ((C) => !this._options.renderSideBySide.read(C)))), this._register(Ml(E.hasChanges, this._contextKeyService, ((C) => {
      var w, y, L;
      return ((L = (y = (w = this._diffModel.read(C)) === null || w === void 0 ? void 0 : w.diff.read(C)) === null || y === void 0 ? void 0 : y.mappings.length) !== null && L !== void 0 ? L : 0) > 0;
    }))), this._editors = this._register(this._instantiationService.createInstance(K2, this.elements.original, this.elements.modified, this._options, t, ((C, w, y, L) => this._createInnerEditor(C, w, y, L)))), this._register(Ml(E.diffEditorOriginalWritable, this._contextKeyService, ((C) => this._options.originalEditable.read(C)))), this._register(Ml(E.diffEditorModifiedWritable, this._contextKeyService, ((C) => !this._options.readOnly.read(C)))), this._register(Ml(E.diffEditorOriginalUri, this._contextKeyService, ((C) => {
      var w, y;
      return (y = (w = this._diffModel.read(C)) === null || w === void 0 ? void 0 : w.model.original.uri.toString()) !== null && y !== void 0 ? y : "";
    }))), this._register(Ml(E.diffEditorModifiedUri, this._contextKeyService, ((C) => {
      var w, y;
      return (y = (w = this._diffModel.read(C)) === null || w === void 0 ? void 0 : w.model.modified.uri.toString()) !== null && y !== void 0 ? y : "";
    }))), this._overviewRulerPart = Fl(this, ((C) => this._options.renderOverviewRuler.read(C) ? this._instantiationService.createInstance(gr(Pu, C), this._editors, this.elements.root, this._diffModel, this._rootSizeObserver.width, this._rootSizeObserver.height, this._layoutInfo.map(((w) => w.modifiedEditor))) : void 0)).recomputeInitiallyAndOnChange(this._store), this._sash = Fl(this, ((C) => {
      const w = this._options.renderSideBySide.read(C);
      return this.elements.root.classList.toggle("side-by-side", w), w ? new bne(this._options, this.elements.root, { height: this._rootSizeObserver.height, width: this._rootSizeObserver.width.map(((y, L) => {
        var k, N;
        return y - ((N = (k = this._overviewRulerPart.read(L)) === null || k === void 0 ? void 0 : k.width) !== null && N !== void 0 ? N : 0);
      })) }, this._boundarySashes) : void 0;
    })).recomputeInitiallyAndOnChange(this._store);
    const d = Fl(this, ((C) => this._instantiationService.createInstance(gr(b0, C), this._editors, this._diffModel, this._options))).recomputeInitiallyAndOnChange(this._store);
    Fl(this, ((C) => this._instantiationService.createInstance(gr(vne, C), this._editors, this._diffModel, this._options, this))).recomputeInitiallyAndOnChange(this._store);
    const h = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
    let u = !1;
    const g = Fl(this, ((C) => this._instantiationService.createInstance(gr(z2, C), ke(this._domElement), this._editors, this._diffModel, this._options, this, (() => u || d.get().isUpdatingHiddenAreas), h, c))).recomputeInitiallyAndOnChange(this._store), p = Fe(this, ((C) => {
      const w = g.read(C).viewZones.read(C).orig, y = d.read(C).viewZones.read(C).origViewZones;
      return w.concat(y);
    })), f = Fe(this, ((C) => {
      const w = g.read(C).viewZones.read(C).mod, y = d.read(C).viewZones.read(C).modViewZones;
      return w.concat(y);
    }));
    let _;
    this._register(iS(this._editors.original, p, ((C) => {
      u = C;
    }), h)), this._register(iS(this._editors.modified, f, ((C) => {
      u = C, u ? _ = wa.capture(this._editors.modified) : (_?.restore(this._editors.modified), _ = void 0);
    }), c)), this._accessibleDiffViewer = Fl(this, ((C) => this._instantiationService.createInstance(gr(Vh, C), this.elements.accessibleDiffViewer, this._accessibleDiffViewerVisible, ((w, y) => this._accessibleDiffViewerShouldBeVisible.set(w, y)), this._options.onlyShowAccessibleDiffViewer.map(((w) => !w)), this._rootSizeObserver.width, this._rootSizeObserver.height, this._diffModel.map(((w, y) => {
      var L;
      return (L = w?.diff.read(y)) === null || L === void 0 ? void 0 : L.mappings.map(((k) => k.lineRangeMapping));
    })), new une(this._editors)))).recomputeInitiallyAndOnChange(this._store);
    const v = this._accessibleDiffViewerVisible.map(((C) => C ? "hidden" : "visible"));
    this._register(Ed(this.elements.modified, { visibility: v })), this._register(Ed(this.elements.original, { visibility: v })), this._createDiffEditorContributions(), o.addDiffEditor(this), this._gutter = Fl(this, ((C) => this._options.shouldRenderGutterMenu.read(C) ? this._instantiationService.createInstance(gr(q2, C), this.elements.root, this._diffModel, this._editors) : void 0)), this._register(P1(this._layoutInfo)), Fl(this, ((C) => new (gr(oc, C))(this.elements.root, this._diffModel, this._layoutInfo.map(((w) => w.originalEditor)), this._layoutInfo.map(((w) => w.modifiedEditor)), this._editors))).recomputeInitiallyAndOnChange(this._store, ((C) => {
      this._movedBlocksLinesPart.set(C, void 0);
    })), this._register(Ed(this.elements.overlay, { width: this._layoutInfo.map(((C, w) => C.originalEditor.width + (this._options.renderSideBySide.read(w) ? 0 : C.modifiedEditor.width))), visibility: Fe(((C) => {
      var w, y;
      return this._options.hideUnchangedRegions.read(C) && ((y = (w = this._diffModel.read(C)) === null || w === void 0 ? void 0 : w.diff.read(C)) === null || y === void 0 ? void 0 : y.mappings.length) === 0 ? "visible" : "hidden";
    })) })), this._register(se.runAndSubscribe(this._editors.modified.onDidChangeCursorPosition, ((C) => this._handleCursorPositionChange(C, !0)))), this._register(se.runAndSubscribe(this._editors.original.onDidChangeCursorPosition, ((C) => this._handleCursorPositionChange(C, !1))));
    const b = this._diffModel.map(this, ((C, w) => {
      if (C) return C.diff.read(w) === void 0 && !C.isDiffUpToDate.read(w);
    }));
    this._register(nr(((C, w) => {
      if (b.read(C) === !0) {
        const y = this._editorProgressService.show(!0, 1e3);
        w.add(ye((() => y.done())));
      }
    }))), this._register(ye((() => {
      var C;
      this._shouldDisposeDiffModel && ((C = this._diffModel.get()) === null || C === void 0 || C.dispose());
    }))), this._register(nr(((C, w) => {
      w.add(new (gr(Ine, C))(this._editors, this._diffModel, this._options, this));
    })));
  }
  _createInnerEditor(n, e, t, i) {
    return n.createInstance(um, e, t, i);
  }
  _createDiffEditorContributions() {
    const n = Xp.getDiffEditorContributions();
    for (const e of n) try {
      this._register(this._instantiationService.createInstance(e.ctor, this));
    } catch (t) {
      We(t);
    }
  }
  get _targetEditor() {
    return this._editors.modified;
  }
  getEditorType() {
    return b1.IDiffEditor;
  }
  layout(n) {
    this._rootSizeObserver.observe(n);
  }
  hasTextFocus() {
    return this._editors.original.hasTextFocus() || this._editors.modified.hasTextFocus();
  }
  saveViewState() {
    var n;
    return { original: this._editors.original.saveViewState(), modified: this._editors.modified.saveViewState(), modelState: (n = this._diffModel.get()) === null || n === void 0 ? void 0 : n.serializeState() };
  }
  restoreViewState(n) {
    var e;
    if (n && n.original && n.modified) {
      const t = n;
      this._editors.original.restoreViewState(t.original), this._editors.modified.restoreViewState(t.modified), t.modelState && ((e = this._diffModel.get()) === null || e === void 0 || e.restoreSerializedState(t.modelState));
    }
  }
  handleInitialized() {
    this._editors.original.handleInitialized(), this._editors.modified.handleInitialized();
  }
  createViewModel(n) {
    return this._instantiationService.createInstance(H2, n, this._options);
  }
  getModel() {
    var n, e;
    return (e = (n = this._diffModel.get()) === null || n === void 0 ? void 0 : n.model) !== null && e !== void 0 ? e : null;
  }
  setModel(n, e) {
    !n && this._diffModel.get() && this._accessibleDiffViewer.get().close();
    const t = n ? "model" in n ? { model: n, shouldDispose: !1 } : { model: this.createViewModel(n), shouldDispose: !0 } : void 0;
    this._diffModel.get() !== t?.model && Mv(e, ((i) => {
      var s;
      Rt.batchEventsGlobally(i, (() => {
        this._editors.original.setModel(t ? t.model.model.original : null), this._editors.modified.setModel(t ? t.model.model.modified : null);
      }));
      const o = this._diffModel.get(), r = this._shouldDisposeDiffModel;
      this._shouldDisposeDiffModel = (s = t?.shouldDispose) !== null && s !== void 0 && s, this._diffModel.set(t?.model, i), r && o?.dispose();
    }));
  }
  updateOptions(n) {
    this._options.updateOptions(n);
  }
  getContainerDomNode() {
    return this._domElement;
  }
  getOriginalEditor() {
    return this._editors.original;
  }
  getModifiedEditor() {
    return this._editors.modified;
  }
  getLineChanges() {
    var n;
    const e = (n = this._diffModel.get()) === null || n === void 0 ? void 0 : n.diff.get();
    return e ? e.mappings.map(((t) => {
      const i = t.lineRangeMapping;
      let s, o, r, a, l = i.innerChanges;
      return i.original.isEmpty ? (s = i.original.startLineNumber - 1, o = 0, l = void 0) : (s = i.original.startLineNumber, o = i.original.endLineNumberExclusive - 1), i.modified.isEmpty ? (r = i.modified.startLineNumber - 1, a = 0, l = void 0) : (r = i.modified.startLineNumber, a = i.modified.endLineNumberExclusive - 1), { originalStartLineNumber: s, originalEndLineNumber: o, modifiedStartLineNumber: r, modifiedEndLineNumber: a, charChanges: l?.map(((d) => ({ originalStartLineNumber: d.originalRange.startLineNumber, originalStartColumn: d.originalRange.startColumn, originalEndLineNumber: d.originalRange.endLineNumber, originalEndColumn: d.originalRange.endColumn, modifiedStartLineNumber: d.modifiedRange.startLineNumber, modifiedStartColumn: d.modifiedRange.startColumn, modifiedEndLineNumber: d.modifiedRange.endLineNumber, modifiedEndColumn: d.modifiedRange.endColumn }))) };
    })) : null;
  }
  revert(n) {
    const e = this._diffModel.get();
    e && e.isDiffUpToDate.get() && this._editors.modified.executeEdits("diffEditor", [{ range: n.modified.toExclusiveRange(), text: e.model.original.getValueInRange(n.original.toExclusiveRange()) }]);
  }
  revertRangeMappings(n) {
    const e = this._diffModel.get();
    if (!e || !e.isDiffUpToDate.get()) return;
    const t = n.map(((i) => ({ range: i.modifiedRange, text: e.model.original.getValueInRange(i.originalRange) })));
    this._editors.modified.executeEdits("diffEditor", t);
  }
  _goTo(n) {
    this._editors.modified.setPosition(new W(n.lineRangeMapping.modified.startLineNumber, 1)), this._editors.modified.revealRangeInCenter(n.lineRangeMapping.modified.toExclusiveRange());
  }
  goToDiff(n) {
    var e, t, i, s;
    const o = (t = (e = this._diffModel.get()) === null || e === void 0 ? void 0 : e.diff.get()) === null || t === void 0 ? void 0 : t.mappings;
    if (!o || o.length === 0) return;
    const r = this._editors.modified.getPosition().lineNumber;
    let a;
    a = n === "next" ? (i = o.find(((l) => l.lineRangeMapping.modified.startLineNumber > r))) !== null && i !== void 0 ? i : o[0] : (s = iv(o, ((l) => l.lineRangeMapping.modified.startLineNumber < r))) !== null && s !== void 0 ? s : o[o.length - 1], this._goTo(a), a.lineRangeMapping.modified.isEmpty ? this._accessibilitySignalService.playSignal(He.diffLineDeleted, { source: "diffEditor.goToDiff" }) : a.lineRangeMapping.original.isEmpty ? this._accessibilitySignalService.playSignal(He.diffLineInserted, { source: "diffEditor.goToDiff" }) : a && this._accessibilitySignalService.playSignal(He.diffLineModified, { source: "diffEditor.goToDiff" });
  }
  revealFirstDiff() {
    const n = this._diffModel.get();
    n && this.waitForDiff().then((() => {
      var e;
      const t = (e = n.diff.get()) === null || e === void 0 ? void 0 : e.mappings;
      t && t.length !== 0 && this._goTo(t[0]);
    }));
  }
  accessibleDiffViewerNext() {
    this._accessibleDiffViewer.get().next();
  }
  accessibleDiffViewerPrev() {
    this._accessibleDiffViewer.get().prev();
  }
  async waitForDiff() {
    const n = this._diffModel.get();
    n && await n.waitForDiff();
  }
  mapToOtherSide() {
    var n, e;
    const t = this._editors.modified.hasWidgetFocus(), i = t ? this._editors.modified : this._editors.original, s = t ? this._editors.original : this._editors.modified;
    let o;
    const r = i.getSelection();
    if (r) {
      const a = (e = (n = this._diffModel.get()) === null || n === void 0 ? void 0 : n.diff.get()) === null || e === void 0 ? void 0 : e.mappings.map(((l) => t ? l.lineRangeMapping.flip() : l.lineRangeMapping));
      if (a) {
        const l = kF(r.getStartPosition(), a), d = kF(r.getEndPosition(), a);
        o = D.plusRange(l, d);
      }
    }
    return { destination: s, destinationSelection: o };
  }
  switchSide() {
    const { destination: n, destinationSelection: e } = this.mapToOtherSide();
    n.focus(), e && n.setSelection(e);
  }
  exitCompareMove() {
    const n = this._diffModel.get();
    n && n.movedTextToCompare.set(void 0, void 0);
  }
  collapseAllUnchangedRegions() {
    var n;
    const e = (n = this._diffModel.get()) === null || n === void 0 ? void 0 : n.unchangedRegions.get();
    e && Tt(((t) => {
      for (const i of e) i.collapseAll(t);
    }));
  }
  showAllUnchangedRegions() {
    var n;
    const e = (n = this._diffModel.get()) === null || n === void 0 ? void 0 : n.unchangedRegions.get();
    e && Tt(((t) => {
      for (const i of e) i.showAll(t);
    }));
  }
  _handleCursorPositionChange(n, e) {
    var t, i;
    if (n?.reason === 3) {
      const s = (i = (t = this._diffModel.get()) === null || t === void 0 ? void 0 : t.diff.get()) === null || i === void 0 ? void 0 : i.mappings.find(((o) => e ? o.lineRangeMapping.modified.contains(n.position.lineNumber) : o.lineRangeMapping.original.contains(n.position.lineNumber)));
      s?.lineRangeMapping.modified.isEmpty ? this._accessibilitySignalService.playSignal(He.diffLineDeleted, { source: "diffEditor.cursorPositionChanged" }) : s?.lineRangeMapping.original.isEmpty ? this._accessibilitySignalService.playSignal(He.diffLineInserted, { source: "diffEditor.cursorPositionChanged" }) : s && this._accessibilitySignalService.playSignal(He.diffLineModified, { source: "diffEditor.cursorPositionChanged" });
    }
  }
};
wd = Vne([Gf(3, Te), Gf(4, Se), Gf(5, mt), Gf(6, Oc), Gf(7, Nc)], wd);
var tP = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Jt = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Hne = 0, zF = !1;
function zne(n) {
  if (!n) {
    if (zF) return;
    zF = !0;
  }
  (function(e) {
    _u = document.createElement("div"), _u.className = "monaco-aria-container";
    const t = () => {
      const s = document.createElement("div");
      return s.className = "monaco-alert", s.setAttribute("role", "alert"), s.setAttribute("aria-atomic", "true"), _u.appendChild(s), s;
    };
    RC = t(), qE = t();
    const i = () => {
      const s = document.createElement("div");
      return s.className = "monaco-status", s.setAttribute("aria-live", "polite"), s.setAttribute("aria-atomic", "true"), _u.appendChild(s), s;
    };
    AC = i(), $E = i(), e.appendChild(_u);
  })(n || It.document.body);
}
let sS = class extends um {
  constructor(n, e, t, i, s, o, r, a, l, d, h, c) {
    const u = { ...e };
    u.ariaLabel = u.ariaLabel || Ty.editorViewAccessibleLabel, u.ariaLabel = u.ariaLabel + ";" + Ty.accessibilityHelpMessage, super(n, u, {}, t, i, s, o, a, l, d, h, c), this._standaloneKeybindingService = r instanceof of ? r : null, zne(u.ariaContainerElement), wL = (g, p) => t.createInstance(Sv, g, p, {});
  }
  addCommand(n, e, t) {
    if (!this._standaloneKeybindingService) return console.warn("Cannot add command because the editor is configured with an unrecognized KeybindingService"), null;
    const i = "DYNAMIC_" + ++Hne, s = q.deserialize(t);
    return this._standaloneKeybindingService.addDynamicKeybinding(i, n, e, s), i;
  }
  createContextKey(n, e) {
    return this._contextKeyService.createKey(n, e);
  }
  addAction(n) {
    if (typeof n.id != "string" || typeof n.label != "string" || typeof n.run != "function") throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
    if (!this._standaloneKeybindingService) return console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService"), V.None;
    const e = n.id, t = n.label, i = q.and(q.equals("editorId", this.getId()), q.deserialize(n.precondition)), s = n.keybindings, o = q.and(i, q.deserialize(n.keybindingContext)), r = n.contextMenuGroupId || null, a = n.contextMenuOrder || 0, l = (u, ...g) => Promise.resolve(n.run(this, ...g)), d = new G(), h = this.getId() + ":" + e;
    if (d.add(dt.registerCommand(h, l)), r) {
      const u = { command: { id: h, title: t }, when: i, group: r, order: a };
      d.add(tn.appendMenuItem(x.EditorContext, u));
    }
    if (Array.isArray(s)) for (const u of s) d.add(this._standaloneKeybindingService.addDynamicKeybinding(h, u, l, o));
    const c = new GB(h, t, t, void 0, i, ((...u) => Promise.resolve(n.run(this, ...u))), this._contextKeyService);
    return this._actions.set(e, c), d.add(ye((() => {
      this._actions.delete(e);
    }))), d;
  }
  _triggerCommand(n, e) {
    if (this._codeEditorService instanceof zC) try {
      this._codeEditorService.setActiveCodeEditor(this), super._triggerCommand(n, e);
    } finally {
      this._codeEditorService.setActiveCodeEditor(null);
    }
    else super._triggerCommand(n, e);
  }
};
sS = tP([Jt(2, Se), Jt(3, mt), Jt(4, ai), Jt(5, Te), Jt(6, Dt), Jt(7, Yi), Jt(8, Ri), Jt(9, or), Jt(10, zt), Jt(11, fe)], sS);
let G2 = class extends sS {
  constructor(n, e, t, i, s, o, r, a, l, d, h, c, u, g, p) {
    const f = { ...e };
    Jy(d, f, !1);
    const _ = a.registerEditorContainer(n);
    typeof f.theme == "string" && a.setTheme(f.theme), f.autoDetectHighContrast !== void 0 && a.setAutoDetectHighContrast(!!f.autoDetectHighContrast);
    const v = f.model;
    let b;
    if (delete f.model, super(n, f, t, i, s, o, r, a, l, h, g, p), this._configurationService = d, this._standaloneThemeService = a, this._register(_), v === void 0) {
      const C = u.getLanguageIdByMimeType(f.language) || f.language || ko;
      b = ZV(c, u, f.value || "", C, void 0), this._ownsModel = !0;
    } else b = v, this._ownsModel = !1;
    if (this._attachModel(b), b) {
      const C = { oldModelUrl: null, newModelUrl: b.uri };
      this._onDidChangeModel.fire(C);
    }
  }
  dispose() {
    super.dispose();
  }
  updateOptions(n) {
    Jy(this._configurationService, n, !1), typeof n.theme == "string" && this._standaloneThemeService.setTheme(n.theme), n.autoDetectHighContrast !== void 0 && this._standaloneThemeService.setAutoDetectHighContrast(!!n.autoDetectHighContrast), super.updateOptions(n);
  }
  _postDetachModelCleanup(n) {
    super._postDetachModelCleanup(n), n && this._ownsModel && (n.dispose(), this._ownsModel = !1);
  }
};
G2 = tP([Jt(2, Se), Jt(3, mt), Jt(4, ai), Jt(5, Te), Jt(6, Dt), Jt(7, Ro), Jt(8, Ri), Jt(9, Ye), Jt(10, or), Jt(11, ni), Jt(12, Xt), Jt(13, zt), Jt(14, fe)], G2);
let Z2 = class extends wd {
  constructor(n, e, t, i, s, o, r, a, l, d, h, c) {
    const u = { ...e };
    Jy(a, u, !0);
    const g = o.registerEditorContainer(n);
    typeof u.theme == "string" && o.setTheme(u.theme), u.autoDetectHighContrast !== void 0 && o.setAutoDetectHighContrast(!!u.autoDetectHighContrast), super(n, u, {}, i, t, s, c, d), this._configurationService = a, this._standaloneThemeService = o, this._register(g);
  }
  dispose() {
    super.dispose();
  }
  updateOptions(n) {
    Jy(this._configurationService, n, !0), typeof n.theme == "string" && this._standaloneThemeService.setTheme(n.theme), n.autoDetectHighContrast !== void 0 && this._standaloneThemeService.setAutoDetectHighContrast(!!n.autoDetectHighContrast), super.updateOptions(n);
  }
  _createInnerEditor(n, e, t) {
    return n.createInstance(sS, e, t);
  }
  getOriginalEditor() {
    return super.getOriginalEditor();
  }
  getModifiedEditor() {
    return super.getModifiedEditor();
  }
  addCommand(n, e, t) {
    return this.getModifiedEditor().addCommand(n, e, t);
  }
  createContextKey(n, e) {
    return this.getModifiedEditor().createContextKey(n, e);
  }
  addAction(n) {
    return this.getModifiedEditor().addAction(n);
  }
};
function ZV(n, e, t, i, s) {
  if (t = t || "", !i) {
    const o = t.indexOf(`
`);
    let r = t;
    return o !== -1 && (r = t.substring(0, o)), UF(n, t, e.createByFilepathOrFirstLine(s || null, r), s);
  }
  return UF(n, t, e.createById(i), s);
}
function UF(n, e, t, i) {
  return n.createModel(e, t, i);
}
Z2 = tP([Jt(2, Se), Jt(3, Te), Jt(4, mt), Jt(5, Ro), Jt(6, Ri), Jt(7, Ye), Jt(8, io), Jt(9, Nc), Jt(10, Kd), Jt(11, Oc)], Z2);
var Une = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Kne = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class jne {
  constructor(e, t) {
    this.viewModel = e, this.deltaScrollVertical = t;
  }
  getId() {
    return this.viewModel;
  }
}
let oS = class extends V {
  constructor(n, e, t, i) {
    super(), this._container = n, this._overflowWidgetsDomNode = e, this._workbenchUIElementFactory = t, this._instantiationService = i, this._viewModel = lt(this, void 0), this._collapsed = Fe(this, ((o) => {
      var r;
      return (r = this._viewModel.read(o)) === null || r === void 0 ? void 0 : r.collapsed.read(o);
    })), this._editorContentHeight = lt(this, 500), this.contentHeight = Fe(this, ((o) => (this._collapsed.read(o) ? 0 : this._editorContentHeight.read(o)) + this._outerEditorHeight)), this._modifiedContentWidth = lt(this, 0), this._modifiedWidth = lt(this, 0), this._originalContentWidth = lt(this, 0), this._originalWidth = lt(this, 0), this.maxScroll = Fe(this, ((o) => {
      const r = this._modifiedContentWidth.read(o) - this._modifiedWidth.read(o), a = this._originalContentWidth.read(o) - this._originalWidth.read(o);
      return r > a ? { maxScroll: r, width: this._modifiedWidth.read(o) } : { maxScroll: a, width: this._originalWidth.read(o) };
    })), this._elements = yt("div.multiDiffEntry", [yt("div.header@header", [yt("div.header-content", [yt("div.collapse-button@collapseButton"), yt("div.file-path", [yt("div.title.modified.show-file-icons@primaryPath", []), yt("div.status.deleted@status", ["R"]), yt("div.title.original.show-file-icons@secondaryPath", [])]), yt("div.actions@actions")])]), yt("div.editorParent", [yt("div.editorContainer@editor")])]), this.editor = this._register(this._instantiationService.createInstance(wd, this._elements.editor, { overflowWidgetsDomNode: this._overflowWidgetsDomNode }, {})), this.isModifedFocused = KF(this.editor.getModifiedEditor()), this.isOriginalFocused = KF(this.editor.getOriginalEditor()), this.isFocused = Fe(this, ((o) => this.isModifedFocused.read(o) || this.isOriginalFocused.read(o))), this._resourceLabel = this._workbenchUIElementFactory.createResourceLabel ? this._register(this._workbenchUIElementFactory.createResourceLabel(this._elements.primaryPath)) : void 0, this._resourceLabel2 = this._workbenchUIElementFactory.createResourceLabel ? this._register(this._workbenchUIElementFactory.createResourceLabel(this._elements.secondaryPath)) : void 0, this._dataStore = new G(), this._headerHeight = 40, this._lastScrollTop = -1, this._isSettingScrollTop = !1;
    const s = new Xy(this._elements.collapseButton, {});
    this._register(Ge(((o) => {
      s.element.className = "", s.icon = this._collapsed.read(o) ? ne.chevronRight : ne.chevronDown;
    }))), this._register(s.onDidClick((() => {
      var o;
      (o = this._viewModel.get()) === null || o === void 0 || o.collapsed.set(!this._collapsed.get(), void 0);
    }))), this._register(Ge(((o) => {
      this._elements.editor.style.display = this._collapsed.read(o) ? "none" : "block";
    }))), this._register(this.editor.getModifiedEditor().onDidLayoutChange(((o) => {
      const r = this.editor.getModifiedEditor().getLayoutInfo().contentWidth;
      this._modifiedWidth.set(r, void 0);
    }))), this._register(this.editor.getOriginalEditor().onDidLayoutChange(((o) => {
      const r = this.editor.getOriginalEditor().getLayoutInfo().contentWidth;
      this._originalWidth.set(r, void 0);
    }))), this._register(this.editor.onDidContentSizeChange(((o) => {
      qC(((r) => {
        this._editorContentHeight.set(o.contentHeight, r), this._modifiedContentWidth.set(this.editor.getModifiedEditor().getContentWidth(), r), this._originalContentWidth.set(this.editor.getOriginalEditor().getContentWidth(), r);
      }));
    }))), this._register(this.editor.getOriginalEditor().onDidScrollChange(((o) => {
      if (this._isSettingScrollTop || !o.scrollTopChanged || !this._data) return;
      const r = o.scrollTop - this._lastScrollTop;
      this._data.deltaScrollVertical(r);
    }))), this._register(Ge(((o) => {
      const r = this.isFocused.read(o);
      this._elements.root.classList.toggle("focused", r);
    }))), this._container.appendChild(this._elements.root), this._outerEditorHeight = this._headerHeight, this._register(this._instantiationService.createInstance(nS, this._elements.actions, x.MultiDiffEditorFileToolbar, { actionRunner: this._register(new jV((() => {
      var o;
      return (o = this._viewModel.get()) === null || o === void 0 ? void 0 : o.modifiedUri;
    }))), menuOptions: { shouldForwardArgs: !0 }, toolbarOptions: { primaryGroup: (o) => o.startsWith("navigation") }, actionViewItemProvider: (o, r) => JW(i, o, r) }));
  }
  setScrollLeft(n) {
    this._modifiedContentWidth.get() - this._modifiedWidth.get() > this._originalContentWidth.get() - this._originalWidth.get() ? this.editor.getModifiedEditor().setScrollLeft(n) : this.editor.getOriginalEditor().setScrollLeft(n);
  }
  setData(n) {
    function e(i) {
      return { ...i, scrollBeyondLastLine: !1, hideUnchangedRegions: { enabled: !0 }, scrollbar: { vertical: "hidden", horizontal: "hidden", handleMouseWheel: !1, useShadows: !1 }, renderOverviewRuler: !1, fixedOverflowWidgets: !0, overviewRulerBorder: !1 };
    }
    this._data = n;
    const t = n.viewModel.entry.value;
    t.onOptionsDidChange && this._dataStore.add(t.onOptionsDidChange((() => {
      var i;
      this.editor.updateOptions(e((i = t.options) !== null && i !== void 0 ? i : {}));
    }))), qC(((i) => {
      var s, o, r, a;
      (s = this._resourceLabel) === null || s === void 0 || s.setUri((o = n.viewModel.modifiedUri) !== null && o !== void 0 ? o : n.viewModel.originalUri, { strikethrough: n.viewModel.modifiedUri === void 0 });
      let l = !1, d = !1, h = !1, c = "";
      n.viewModel.modifiedUri && n.viewModel.originalUri && n.viewModel.modifiedUri.path !== n.viewModel.originalUri.path ? (c = "R", l = !0) : n.viewModel.modifiedUri ? n.viewModel.originalUri || (c = "A", h = !0) : (c = "D", d = !0), this._elements.status.classList.toggle("renamed", l), this._elements.status.classList.toggle("deleted", d), this._elements.status.classList.toggle("added", h), this._elements.status.innerText = c, (r = this._resourceLabel2) === null || r === void 0 || r.setUri(l ? n.viewModel.originalUri : void 0, { strikethrough: !0 }), this._dataStore.clear(), this._viewModel.set(n.viewModel, i), this.editor.setModel(n.viewModel.diffEditorViewModel, i), this.editor.updateOptions(e((a = t.options) !== null && a !== void 0 ? a : {}));
    }));
  }
  render(n, e, t, i) {
    this._elements.root.style.visibility = "visible", this._elements.root.style.top = `${n.start}px`, this._elements.root.style.height = `${n.length}px`, this._elements.root.style.width = `${e}px`, this._elements.root.style.position = "absolute";
    const s = n.length - this._headerHeight, o = Math.max(0, Math.min(i.start - n.start, s));
    this._elements.header.style.transform = `translateY(${o}px)`, qC(((r) => {
      this.editor.layout({ width: e - 16 - 2, height: n.length - this._outerEditorHeight });
    }));
    try {
      this._isSettingScrollTop = !0, this._lastScrollTop = t, this.editor.getOriginalEditor().setScrollTop(t);
    } finally {
      this._isSettingScrollTop = !1;
    }
    this._elements.header.classList.toggle("shadow", o > 0 || t > 0), this._elements.header.classList.toggle("collapsed", o === s);
  }
  hide() {
    this._elements.root.style.top = "-100000px", this._elements.root.style.visibility = "hidden";
  }
};
function KF(n) {
  return Rt(((e) => {
    const t = new G();
    return t.add(n.onDidFocusEditorWidget((() => e(!0)))), t.add(n.onDidBlurEditorWidget((() => e(!1)))), t;
  }), (() => n.hasTextFocus()));
}
oS = Une([Kne(3, Se)], oS);
class qne {
  constructor(e) {
    this._create = e, this._unused = /* @__PURE__ */ new Set(), this._used = /* @__PURE__ */ new Set(), this._itemData = /* @__PURE__ */ new Map();
  }
  getUnusedObj(e) {
    var t;
    let i;
    if (this._unused.size === 0) i = this._create(e), this._itemData.set(i, e);
    else {
      const s = [...this._unused.values()];
      i = (t = s.find(((o) => this._itemData.get(o).getId() === e.getId()))) !== null && t !== void 0 ? t : s[0], this._unused.delete(i), this._itemData.set(i, e), i.setData(e);
    }
    return this._used.add(i), { object: i, dispose: () => {
      this._used.delete(i), this._unused.size > 5 ? i.dispose() : this._unused.add(i);
    } };
  }
  dispose() {
    for (const e of this._used) e.dispose();
    for (const e of this._unused) e.dispose();
    this._used.clear(), this._unused.clear();
  }
}
var $ne = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, jF = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Y2 = class extends V {
  constructor(n, e, t, i, s, o) {
    super(), this._element = n, this._dimension = e, this._viewModel = t, this._workbenchUIElementFactory = i, this._parentContextKeyService = s, this._parentInstantiationService = o, this._elements = yt("div.monaco-component.multiDiffEditor", [yt("div@content", { style: { overflow: "hidden" } }), yt("div.monaco-editor@overflowWidgetsDomNode", {})]), this._sizeObserver = this._register(new WV(this._element, void 0)), this._objectPool = this._register(new qne(((a) => {
      const l = this._instantiationService.createInstance(oS, this._elements.content, this._elements.overflowWidgetsDomNode, this._workbenchUIElementFactory);
      return l.setData(a), l;
    }))), this._scrollable = this._register(new _f({ forceIntegerValues: !1, scheduleAtNextAnimationFrame: (a) => Ys(ke(this._element), a), smoothScrollDuration: 100 })), this._scrollableElement = this._register(new aL(this._elements.root, { vertical: 1, horizontal: 1, useShadows: !1 }, this._scrollable)), this.scrollTop = Rt(this._scrollableElement.onScroll, (() => this._scrollableElement.getScrollPosition().scrollTop)), this.scrollLeft = Rt(this._scrollableElement.onScroll, (() => this._scrollableElement.getScrollPosition().scrollLeft)), this._viewItems = vf(this, ((a, l) => {
      const d = this._viewModel.read(a);
      return d ? d.items.read(a).map(((h) => {
        var c;
        const u = l.add(new Gne(h, this._objectPool, this.scrollLeft, ((p) => {
          this._scrollableElement.setScrollPosition({ scrollTop: this._scrollableElement.getScrollPosition().scrollTop + p });
        }))), g = (c = this._lastDocStates) === null || c === void 0 ? void 0 : c[u.getKey()];
        return g && Tt(((p) => {
          u.setViewState(g, p);
        })), u;
      })) : [];
    })), this._spaceBetweenPx = 0, this._totalHeight = this._viewItems.map(this, ((a, l) => a.reduce(((d, h) => d + h.contentHeight.read(l) + this._spaceBetweenPx), 0))), this.activeDiffItem = Fe(this, ((a) => this._viewItems.read(a).find(((l) => {
      var d;
      return (d = l.template.read(a)) === null || d === void 0 ? void 0 : d.isFocused.read(a);
    })))), this.lastActiveDiffItem = (function(a) {
      let l;
      return Fe(((d) => (l = a(d, l), l)));
    })(((a, l) => {
      var d;
      return (d = this.activeDiffItem.read(a)) !== null && d !== void 0 ? d : l;
    })), this._contextKeyService = this._register(this._parentContextKeyService.createScoped(this._element)), this._instantiationService = this._parentInstantiationService.createChild(new N1([Te, this._contextKeyService])), this._lastDocStates = {}, this._contextKeyService.createKey(E.inMultiDiffEditor.key, !0), this._register(nr(((a, l) => {
      const d = this._viewModel.read(a);
      if (d && d.contextKeys) for (const [h, c] of Object.entries(d.contextKeys)) {
        const u = this._contextKeyService.createKey(h, void 0);
        u.set(c), l.add(ye((() => u.reset())));
      }
    })));
    const r = this._parentContextKeyService.createKey(E.multiDiffEditorAllCollapsed.key, !1);
    this._register(Ge(((a) => {
      const l = this._viewModel.read(a);
      if (l) {
        const d = l.items.read(a).every(((h) => h.collapsed.read(a)));
        r.set(d);
      }
    }))), this._register(Ge(((a) => {
      const l = this.lastActiveDiffItem.read(a);
      Tt(((d) => {
        var h;
        (h = this._viewModel.read(a)) === null || h === void 0 || h.activeDiffItem.set(l?.viewModel, d);
      }));
    }))), this._register(Ge(((a) => {
      const l = this._dimension.read(a);
      this._sizeObserver.observe(l);
    }))), this._elements.content.style.position = "relative", this._register(Ge(((a) => {
      const l = this._sizeObserver.height.read(a);
      this._elements.root.style.height = `${l}px`;
      const d = this._totalHeight.read(a);
      this._elements.content.style.height = `${d}px`;
      const h = this._sizeObserver.width.read(a);
      let c = h;
      const u = kR(this._viewItems.read(a), ((g) => g.maxScroll.read(a).maxScroll));
      u && (c = h + u.maxScroll.read(a).maxScroll), this._scrollableElement.setScrollDimensions({ width: h, height: l, scrollHeight: d, scrollWidth: c });
    }))), n.replaceChildren(this._scrollableElement.getDomNode()), this._register(ye((() => {
      n.replaceChildren();
    }))), this._register(this._register(Ge(((a) => {
      qC(((l) => {
        this.render(a);
      }));
    }))));
  }
  render(n) {
    const e = this.scrollTop.read(n);
    let t = 0, i = 0, s = 0;
    const o = this._sizeObserver.height.read(n), r = qe.ofStartAndLength(e, o), a = this._sizeObserver.width.read(n);
    for (const l of this._viewItems.read(n)) {
      const d = l.contentHeight.read(n), h = Math.min(d, o), c = qe.ofStartAndLength(i, h), u = qe.ofStartAndLength(s, d);
      if (u.isBefore(r)) t -= d - h, l.hide();
      else if (u.isAfter(r)) l.hide();
      else {
        const g = Math.max(0, Math.min(r.start - u.start, d - h));
        t -= g;
        const p = qe.ofStartAndLength(e + t, o);
        l.render(c, g, a, p);
      }
      i += h + this._spaceBetweenPx, s += d + this._spaceBetweenPx;
    }
    this._elements.content.style.transform = `translateY(${-(e + t)}px)`;
  }
};
Y2 = $ne([jF(4, Te), jF(5, Se)], Y2);
class Gne extends V {
  constructor(e, t, i, s) {
    super(), this.viewModel = e, this._objectPool = t, this._scrollLeft = i, this._deltaScrollVertical = s, this._templateRef = this._register(Tv(this, void 0)), this.contentHeight = Fe(this, ((o) => {
      var r, a, l;
      return (l = (a = (r = this._templateRef.read(o)) === null || r === void 0 ? void 0 : r.object.contentHeight) === null || a === void 0 ? void 0 : a.read(o)) !== null && l !== void 0 ? l : this.viewModel.lastTemplateData.read(o).contentHeight;
    })), this.maxScroll = Fe(this, ((o) => {
      var r, a;
      return (a = (r = this._templateRef.read(o)) === null || r === void 0 ? void 0 : r.object.maxScroll.read(o)) !== null && a !== void 0 ? a : { maxScroll: 0, scrollWidth: 0 };
    })), this.template = Fe(this, ((o) => {
      var r;
      return (r = this._templateRef.read(o)) === null || r === void 0 ? void 0 : r.object;
    })), this._isHidden = lt(this, !1), this._register(Ge(((o) => {
      var r;
      const a = this._scrollLeft.read(o);
      (r = this._templateRef.read(o)) === null || r === void 0 || r.object.setScrollLeft(a);
    }))), this._register(Ge(((o) => {
      const r = this._templateRef.read(o);
      r && this._isHidden.read(o) && (r.object.isFocused.read(o) || this._clear());
    })));
  }
  dispose() {
    this._clear(), super.dispose();
  }
  toString() {
    var e;
    return `VirtualViewItem(${(e = this.viewModel.entry.value.modified) === null || e === void 0 ? void 0 : e.uri.toString()})`;
  }
  getKey() {
    return this.viewModel.getKey();
  }
  setViewState(e, t) {
    var i;
    this.viewModel.collapsed.set(e.collapsed, t), this._updateTemplateData(t);
    const s = this.viewModel.lastTemplateData.get(), o = (i = e.selections) === null || i === void 0 ? void 0 : i.map(_e.liftSelection);
    this.viewModel.lastTemplateData.set({ ...s, selections: o }, t);
    const r = this._templateRef.get();
    r && o && r.object.editor.setSelections(o);
  }
  _updateTemplateData(e) {
    var t;
    const i = this._templateRef.get();
    i && this.viewModel.lastTemplateData.set({ contentHeight: i.object.contentHeight.get(), selections: (t = i.object.editor.getSelections()) !== null && t !== void 0 ? t : void 0 }, e);
  }
  _clear() {
    const e = this._templateRef.get();
    e && Tt(((t) => {
      this._updateTemplateData(t), e.object.hide(), this._templateRef.set(void 0, t);
    }));
  }
  hide() {
    this._isHidden.set(!0, void 0);
  }
  render(e, t, i, s) {
    this._isHidden.set(!1, void 0);
    let o = this._templateRef.get();
    if (!o) {
      o = this._objectPool.getUnusedObj(new jne(this.viewModel, this._deltaScrollVertical)), this._templateRef.set(o, void 0);
      const r = this.viewModel.lastTemplateData.get().selections;
      r && o.object.editor.setSelections(r);
    }
    o.object.render(e, i, t, s);
  }
}
I("multiDiffEditor.headerBackground", { dark: "#262626", light: "tab.inactiveBackground", hcDark: "tab.inactiveBackground", hcLight: "tab.inactiveBackground" }, m(0, "The background color of the diff editor's header")), I("multiDiffEditor.background", { dark: "editorBackground", light: "editorBackground", hcDark: "editorBackground", hcLight: "editorBackground" }, m(0, "The background color of the multi file diff editor")), I("multiDiffEditor.border", { dark: "sideBarSectionHeader.border", light: "#cccccc", hcDark: "sideBarSectionHeader.border", hcLight: "#cccccc" }, m(0, "The border color of the multi file diff editor"));
var Zne = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Yne = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let X2 = class extends V {
  constructor(n, e, t) {
    super(), this._element = n, this._workbenchUIElementFactory = e, this._instantiationService = t, this._dimension = lt(this, void 0), this._viewModel = lt(this, void 0), this._widgetImpl = vf(this, ((i, s) => (gr(oS, i), s.add(this._instantiationService.createInstance(gr(Y2, i), this._element, this._dimension, this._viewModel, this._workbenchUIElementFactory))))), this._register(P1(this._widgetImpl));
  }
};
function Xne(n, e, t) {
  return Me.initialize(t || {}).createInstance(G2, n, e);
}
function Qne(n) {
  return Me.get(mt).onCodeEditorAdd(((e) => {
    n(e);
  }));
}
function Jne(n) {
  return Me.get(mt).onDiffEditorAdd(((e) => {
    n(e);
  }));
}
function ese() {
  return Me.get(mt).listCodeEditors();
}
function tse() {
  return Me.get(mt).listDiffEditors();
}
function ise(n, e, t) {
  return Me.initialize(t || {}).createInstance(Z2, n, e);
}
function nse(n, e) {
  const t = Me.initialize(e || {});
  return new X2(n, {}, t);
}
function sse(n) {
  if (typeof n.id != "string" || typeof n.run != "function") throw new Error("Invalid command descriptor, `id` and `run` are required properties!");
  return dt.registerCommand(n.id, n.run);
}
function ose(n) {
  if (typeof n.id != "string" || typeof n.label != "string" || typeof n.run != "function") throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
  const e = q.deserialize(n.precondition), t = new G();
  if (t.add(dt.registerCommand(n.id, ((i, ...s) => Zi.runEditorCommand(i, s, e, ((o, r, a) => Promise.resolve(n.run(r, ...a))))))), n.contextMenuGroupId) {
    const i = { command: { id: n.id, title: n.label }, when: e, group: n.contextMenuGroupId, order: n.contextMenuOrder || 0 };
    t.add(tn.appendMenuItem(x.EditorContext, i));
  }
  if (Array.isArray(n.keybindings)) {
    const i = Me.get(Dt);
    if (i instanceof of) {
      const s = q.and(e, q.deserialize(n.keybindingContext));
      t.add(i.addDynamicKeybindings(n.keybindings.map(((o) => ({ keybinding: o, command: n.id, when: s })))));
    } else console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService");
  }
  return t;
}
function rse(n) {
  return YV([n]);
}
function YV(n) {
  const e = Me.get(Dt);
  return e instanceof of ? e.addDynamicKeybindings(n.map(((t) => ({ keybinding: t.keybinding, command: t.command, commandArgs: t.commandArgs, when: q.deserialize(t.when) })))) : (console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService"), V.None);
}
function ase(n, e, t) {
  const i = Me.get(Xt), s = i.getLanguageIdByMimeType(e) || e;
  return ZV(Me.get(ni), i, n, s, t);
}
function lse(n, e) {
  const t = Me.get(Xt), i = t.getLanguageIdByMimeType(e) || e || ko;
  n.setLanguage(t.createById(i));
}
function dse(n, e, t) {
  n && Me.get(kl).changeOne(e, n.uri, t);
}
function hse(n) {
  Me.get(kl).changeAll(n, []);
}
function cse(n) {
  return Me.get(kl).read(n);
}
function use(n) {
  return Me.get(kl).onMarkerChanged(n);
}
function gse(n) {
  return Me.get(ni).getModel(n);
}
function pse() {
  return Me.get(ni).getModels();
}
function mse(n) {
  return Me.get(ni).onModelAdded(n);
}
function fse(n) {
  return Me.get(ni).onModelRemoved(n);
}
function _se(n) {
  return Me.get(ni).onModelLanguageChanged(((e) => {
    n({ model: e.model, oldLanguage: e.oldLanguageId });
  }));
}
function vse(n) {
  return (function(e, t, i) {
    return new Kq(e, t, i);
  })(Me.get(ni), Me.get(zt), n);
}
function bse(n, e) {
  const t = Me.get(Xt), i = Me.get(Ro);
  return TR.colorizeElement(i, t, n, e).then((() => {
    i.registerEditorContainer(n);
  }));
}
function Cse(n, e, t) {
  const i = Me.get(Xt);
  return Me.get(Ro).registerEditorContainer(It.document.body), TR.colorize(i, n, e, t);
}
function wse(n, e, t = 4) {
  return Me.get(Ro).registerEditorContainer(It.document.body), TR.colorizeModelLine(n, e, t);
}
function yse(n, e) {
  ci.getOrCreate(e);
  const t = (function(r) {
    return ci.get(r) || { getInitialState: () => Vm, tokenize: (l, d, h) => ER(r, h) };
  })(e), i = Sl(n), s = [];
  let o = t.getInitialState();
  for (let r = 0, a = i.length; r < a; r++) {
    const l = i[r], d = t.tokenize(l, !0, o);
    s[r] = d.tokens, o = d.endState;
  }
  return s;
}
function Sse(n, e) {
  Me.get(Ro).defineTheme(n, e);
}
function Lse(n) {
  Me.get(Ro).setTheme(n);
}
function kse() {
  TE.clearAllFontInfos();
}
function Dse(n, e) {
  return dt.registerCommand({ id: n, handler: e });
}
function xse(n) {
  return Me.get(Fs).registerOpener({ open: async (e) => (typeof e == "string" && (e = Ie.parse(e)), n.open(e)) });
}
function Nse(n) {
  return Me.get(mt).registerCodeEditorOpenHandler((async (e, t, i) => {
    var s;
    if (!t) return null;
    const o = (s = e.options) === null || s === void 0 ? void 0 : s.selection;
    let r;
    return o && typeof o.endLineNumber == "number" && typeof o.endColumn == "number" ? r = o : o && (r = { lineNumber: o.startLineNumber, column: o.startColumn }), await n.openCodeEditor(t, e.resource, r) ? t : null;
  }));
}
function jb(n, e) {
  return typeof n == "boolean" ? n : e;
}
function qF(n, e) {
  return typeof n == "string" ? n : e;
}
function $F(n, e = !1) {
  e && (n = n.map((function(i) {
    return i.toLowerCase();
  })));
  const t = (function(i) {
    const s = {};
    for (const o of i) s[o] = !0;
    return s;
  })(n);
  return e ? function(i) {
    return t[i.toLowerCase()] !== void 0 && t.hasOwnProperty(i.toLowerCase());
  } : function(i) {
    return t[i] !== void 0 && t.hasOwnProperty(i);
  };
}
function Q2(n, e, t) {
  e = e.replace(/@@/g, "");
  let i, s = 0;
  do
    i = !1, e = e.replace(/@(\w+)/g, (function(r, a) {
      i = !0;
      let l = "";
      if (typeof n[a] == "string") l = n[a];
      else {
        if (!(n[a] && n[a] instanceof RegExp)) throw n[a] === void 0 ? Gt(n, "language definition does not contain attribute '" + a + "', used at: " + e) : Gt(n, "attribute reference '" + a + "' must be a string, used at: " + e);
        l = n[a].source;
      }
      return fu(l) ? "" : "(?:" + l + ")";
    })), s++;
  while (i && s < 5);
  e = e.replace(/\x01/g, "@");
  const o = (n.ignoreCase ? "i" : "") + (n.unicode ? "u" : "");
  if (t && e.match(/\$[sS](\d\d?)/g)) {
    let r = null, a = null;
    return (l) => (a && r === l || (r = l, a = new RegExp((function(d, h, c) {
      let u = null;
      return h.replace(/\$[sS](\d\d?)/g, (function(g, p) {
        return u === null && (u = c.split("."), u.unshift(c)), !fu(p) && p < u.length ? xd(d, u[p]) : "";
      }));
    })(n, e, l), o)), a);
  }
  return new RegExp(e, o);
}
function Ese(n, e, t, i) {
  let s = -1, o = t, r = t.match(/^\$(([sS]?)(\d\d?)|#)(.*)$/);
  r && (r[3] && (s = parseInt(r[3]), r[2] && (s += 100)), o = r[4]);
  let a, l = "~", d = o;
  if (o && o.length !== 0 ? /^\w*$/.test(d) ? l = "==" : (r = o.match(/^(@|!@|~|!~|==|!=)(.*)$/), r && (l = r[1], d = r[2])) : (l = "!=", d = ""), l !== "~" && l !== "!~" || !/^(\w|\|)*$/.test(d)) if (l === "@" || l === "!@") {
    const h = n[d];
    if (!h) throw Gt(n, "the @ match target '" + d + "' is not defined, in rule: " + e);
    if (!(function(u, g) {
      if (!g || !Array.isArray(g)) return !1;
      for (const p of g) if (!u(p)) return !1;
      return !0;
    })((function(u) {
      return typeof u == "string";
    }), h)) throw Gt(n, "the @ match target '" + d + "' must be an array of strings, in rule: " + e);
    const c = $F(h, n.ignoreCase);
    a = function(u) {
      return l === "@" ? c(u) : !c(u);
    };
  } else if (l === "~" || l === "!~") if (d.indexOf("$") < 0) {
    const h = Q2(n, "^" + d + "$", !1);
    a = function(c) {
      return l === "~" ? h.test(c) : !h.test(c);
    };
  } else a = function(h, c, u, g) {
    return Q2(n, "^" + _h(n, d, c, u, g) + "$", !1).test(h);
  };
  else if (d.indexOf("$") < 0) {
    const h = xd(n, d);
    a = function(c) {
      return l === "==" ? c === h : c !== h;
    };
  } else {
    const h = xd(n, d);
    a = function(c, u, g, p, f) {
      const _ = _h(n, h, u, g, p);
      return l === "==" ? c === _ : c !== _;
    };
  }
  else {
    const h = $F(d.split("|"), n.ignoreCase);
    a = function(c) {
      return l === "~" ? h(c) : !h(c);
    };
  }
  return s === -1 ? { name: t, value: i, test: function(h, c, u, g) {
    return a(h, h, c, u, g);
  } } : { name: t, value: i, test: function(h, c, u, g) {
    const p = (function(f, _, v, b) {
      if (b < 0) return f;
      if (b < _.length) return _[b];
      if (b >= 100) {
        b -= 100;
        const C = v.split(".");
        if (C.unshift(v), b < C.length) return C[b];
      }
      return null;
    })(h, c, u, s);
    return a(p || "", h, c, u, g);
  } };
}
function J2(n, e, t) {
  if (t) {
    if (typeof t == "string") return t;
    if (t.token || t.token === "") {
      if (typeof t.token != "string") throw Gt(n, "a 'token' attribute must be of type string, in rule: " + e);
      {
        const i = { token: t.token };
        if (t.token.indexOf("$") >= 0 && (i.tokenSubst = !0), typeof t.bracket == "string") if (t.bracket === "@open") i.bracket = 1;
        else {
          if (t.bracket !== "@close") throw Gt(n, "a 'bracket' attribute must be either '@open' or '@close', in rule: " + e);
          i.bracket = -1;
        }
        if (t.next) {
          if (typeof t.next != "string") throw Gt(n, "the next state must be a string value in rule: " + e);
          {
            let s = t.next;
            if (!/^(@pop|@push|@popall)$/.test(s) && (s[0] === "@" && (s = s.substr(1)), s.indexOf("$") < 0 && !(function(o, r) {
              let a = r;
              for (; a && a.length > 0; ) {
                if (o.stateNames[a]) return !0;
                const l = a.lastIndexOf(".");
                a = l < 0 ? null : a.substr(0, l);
              }
              return !1;
            })(n, _h(n, s, "", [], "")))) throw Gt(n, "the next state '" + t.next + "' is not defined in rule: " + e);
            i.next = s;
          }
        }
        return typeof t.goBack == "number" && (i.goBack = t.goBack), typeof t.switchTo == "string" && (i.switchTo = t.switchTo), typeof t.log == "string" && (i.log = t.log), typeof t.nextEmbedded == "string" && (i.nextEmbedded = t.nextEmbedded, n.usesEmbedded = !0), i;
      }
    }
    if (Array.isArray(t)) {
      const i = [];
      for (let s = 0, o = t.length; s < o; s++) i[s] = J2(n, e, t[s]);
      return { group: i };
    }
    if (t.cases) {
      const i = [];
      for (const o in t.cases) if (t.cases.hasOwnProperty(o)) {
        const r = J2(n, e, t.cases[o]);
        o === "@default" || o === "@" || o === "" ? i.push({ test: void 0, value: r, name: o }) : o === "@eos" ? i.push({ test: function(a, l, d, h) {
          return h;
        }, value: r, name: o }) : i.push(Ese(n, e, o, r));
      }
      const s = n.defaultToken;
      return { test: function(o, r, a, l) {
        for (const d of i)
          if (!d.test || d.test(o, r, a, l)) return d.value;
        return s;
      } };
    }
    throw Gt(n, "an action must be a string, an object with a 'token' or 'cases' attribute, or an array of actions; in rule: " + e);
  }
  return { token: "" };
}
X2 = Zne([Yne(2, Se)], X2);
class Ise {
  constructor(e) {
    this.regex = new RegExp(""), this.action = { token: "" }, this.matchOnlyAtLineStart = !1, this.name = "", this.name = e;
  }
  setRegex(e, t) {
    let i;
    if (typeof t == "string") i = t;
    else {
      if (!(t instanceof RegExp)) throw Gt(e, "rules must start with a match string or regular expression: " + this.name);
      i = t.source;
    }
    this.matchOnlyAtLineStart = i.length > 0 && i[0] === "^", this.name = this.name + ": " + i, this.regex = Q2(e, "^(?:" + (this.matchOnlyAtLineStart ? i.substr(1) : i) + ")", !0);
  }
  setAction(e, t) {
    this.action = J2(e, this.name, t);
  }
  resolveRegex(e) {
    return this.regex instanceof RegExp ? this.regex : this.regex(e);
  }
}
function XV(n, e) {
  if (!e || typeof e != "object") throw new Error("Monarch: expecting a language definition object");
  const t = {};
  t.languageId = n, t.includeLF = jb(e.includeLF, !1), t.noThrow = !1, t.maxStack = 100, t.start = typeof e.start == "string" ? e.start : null, t.ignoreCase = jb(e.ignoreCase, !1), t.unicode = jb(e.unicode, !1), t.tokenPostfix = qF(e.tokenPostfix, "." + t.languageId), t.defaultToken = qF(e.defaultToken, "source"), t.usesEmbedded = !1;
  const i = e;
  function s(r, a, l) {
    for (const d of l) {
      let h = d.include;
      if (h) {
        if (typeof h != "string") throw Gt(t, "an 'include' attribute must be a string at: " + r);
        if (h[0] === "@" && (h = h.substr(1)), !e.tokenizer[h]) throw Gt(t, "include target '" + h + "' is not defined at: " + r);
        s(r + "." + h, a, e.tokenizer[h]);
      } else {
        const c = new Ise(r);
        if (Array.isArray(d) && d.length >= 1 && d.length <= 3) if (c.setRegex(i, d[0]), d.length >= 3) if (typeof d[1] == "string") c.setAction(i, { token: d[1], next: d[2] });
        else {
          if (typeof d[1] != "object") throw Gt(t, "a next state as the last element of a rule can only be given if the action is either an object or a string, at: " + r);
          {
            const u = d[1];
            u.next = d[2], c.setAction(i, u);
          }
        }
        else c.setAction(i, d[1]);
        else {
          if (!d.regex) throw Gt(t, "a rule must either be an array, or an object with a 'regex' or 'include' field at: " + r);
          d.name && typeof d.name == "string" && (c.name = d.name), d.matchOnlyAtStart && (c.matchOnlyAtLineStart = jb(d.matchOnlyAtLineStart, !1)), c.setRegex(i, d.regex), c.setAction(i, d.action);
        }
        a.push(c);
      }
    }
  }
  if (i.languageId = n, i.includeLF = t.includeLF, i.ignoreCase = t.ignoreCase, i.unicode = t.unicode, i.noThrow = t.noThrow, i.usesEmbedded = t.usesEmbedded, i.stateNames = e.tokenizer, i.defaultToken = t.defaultToken, !e.tokenizer || typeof e.tokenizer != "object") throw Gt(t, "a language definition must define the 'tokenizer' attribute as an object");
  t.tokenizer = [];
  for (const r in e.tokenizer) if (e.tokenizer.hasOwnProperty(r)) {
    t.start || (t.start = r);
    const a = e.tokenizer[r];
    t.tokenizer[r] = new Array(), s("tokenizer." + r, t.tokenizer[r], a);
  }
  if (t.usesEmbedded = i.usesEmbedded, e.brackets) {
    if (!Array.isArray(e.brackets)) throw Gt(t, "the 'brackets' attribute must be defined as an array");
  } else e.brackets = [{ open: "{", close: "}", token: "delimiter.curly" }, { open: "[", close: "]", token: "delimiter.square" }, { open: "(", close: ")", token: "delimiter.parenthesis" }, { open: "<", close: ">", token: "delimiter.angle" }];
  const o = [];
  for (const r of e.brackets) {
    let a = r;
    if (a && Array.isArray(a) && a.length === 3 && (a = { token: a[2], open: a[0], close: a[1] }), a.open === a.close) throw Gt(t, "open and close brackets in a 'brackets' attribute must be different: " + a.open + `
 hint: use the 'bracket' attribute if matching on equal brackets is required.`);
    if (typeof a.open != "string" || typeof a.token != "string" || typeof a.close != "string") throw Gt(t, "every element in the 'brackets' array must be a '{open,close,token}' object or array");
    o.push({ token: a.token + t.tokenPostfix, open: xd(t, a.open), close: xd(t, a.close) });
  }
  return t.brackets = o, t.noThrow = !0, t;
}
function Mse(n) {
  Bm.registerLanguage(n);
}
function Tse() {
  let n = [];
  return n = n.concat(Bm.getLanguages()), n;
}
function Rse(n) {
  return Me.get(Xt).languageIdCodec.encodeLanguageId(n);
}
function Ase(n, e) {
  return Me.withServices((() => {
    const t = Me.get(Xt).onDidRequestRichLanguageFeatures(((i) => {
      i === n && (t.dispose(), e());
    }));
    return t;
  }));
}
function Pse(n, e) {
  return Me.withServices((() => {
    const t = Me.get(Xt).onDidRequestBasicLanguageFeatures(((i) => {
      i === n && (t.dispose(), e());
    }));
    return t;
  }));
}
function Ose(n, e) {
  if (!Me.get(Xt).isRegisteredLanguageId(n)) throw new Error(`Cannot set configuration for unknown language ${n}`);
  return Me.get(zt).register(n, e, 100);
}
class Fse {
  constructor(e, t) {
    this._languageId = e, this._actual = t;
  }
  dispose() {
  }
  getInitialState() {
    return this._actual.getInitialState();
  }
  tokenize(e, t, i) {
    if (typeof this._actual.tokenize == "function") return $v.adaptTokenize(this._languageId, this._actual, e, i);
    throw new Error("Not supported!");
  }
  tokenizeEncoded(e, t, i) {
    const s = this._actual.tokenizeEncoded(e, i);
    return new PS(s.tokens, s.endState);
  }
}
class $v {
  constructor(e, t, i, s) {
    this._languageId = e, this._actual = t, this._languageService = i, this._standaloneThemeService = s;
  }
  dispose() {
  }
  getInitialState() {
    return this._actual.getInitialState();
  }
  static _toClassicTokens(e, t) {
    const i = [];
    let s = 0;
    for (let o = 0, r = e.length; o < r; o++) {
      const a = e[o];
      let l = a.startIndex;
      o === 0 ? l = 0 : l < s && (l = s), i[o] = new q0(l, a.scopes, t), s = l;
    }
    return i;
  }
  static adaptTokenize(e, t, i, s) {
    const o = t.tokenize(i, s), r = $v._toClassicTokens(o.tokens, e);
    let a;
    return a = o.endState.equals(s) ? s : o.endState, new iR(r, a);
  }
  tokenize(e, t, i) {
    return $v.adaptTokenize(this._languageId, this._actual, e, i);
  }
  _toBinaryTokens(e, t) {
    const i = e.encodeLanguageId(this._languageId), s = this._standaloneThemeService.getColorTheme().tokenTheme, o = [];
    let r = 0, a = 0;
    for (let d = 0, h = t.length; d < h; d++) {
      const c = t[d], u = 1024 | s.match(i, c.scopes);
      if (r > 0 && o[r - 1] === u) continue;
      let g = c.startIndex;
      d === 0 ? g = 0 : g < a && (g = a), o[r++] = g, o[r++] = u, a = g;
    }
    const l = new Uint32Array(r);
    for (let d = 0; d < r; d++) l[d] = o[d];
    return l;
  }
  tokenizeEncoded(e, t, i) {
    const s = this._actual.tokenize(e, i), o = this._toBinaryTokens(this._languageService.languageIdCodec, s.tokens);
    let r;
    return r = s.endState.equals(i) ? i : s.endState, new PS(o, r);
  }
}
function QV(n) {
  return n && typeof n.then == "function";
}
function Bse(n) {
  const e = Me.get(Ro);
  if (n) {
    const t = [null];
    for (let i = 1, s = n.length; i < s; i++) t[i] = z.fromHex(n[i]);
    e.setColorMapOverride(t);
  } else e.setColorMapOverride(null);
}
function JV(n, e) {
  return (function(t) {
    return "tokenizeEncoded" in t;
  })(e) ? new Fse(n, e) : new $v(n, e, Me.get(Xt), Me.get(Ro));
}
function iP(n, e) {
  const t = new yK((async () => {
    const i = await Promise.resolve(e.create());
    return i ? typeof i.getInitialState == "function" ? JV(n, i) : new dv(Me.get(Xt), Me.get(Ro), n, XV(n, i), Me.get(Ye)) : null;
  }));
  return ci.registerFactory(n, t);
}
function Wse(n, e) {
  if (!Me.get(Xt).isRegisteredLanguageId(n)) throw new Error(`Cannot set tokens provider for unknown language ${n}`);
  return QV(e) ? iP(n, { create: () => e }) : ci.register(n, JV(n, e));
}
function Vse(n, e) {
  return QV(e) ? iP(n, { create: () => e }) : ci.register(n, ((t) => new dv(Me.get(Xt), Me.get(Ro), n, XV(n, t), Me.get(Ye)))(e));
}
function Hse(n, e) {
  return Me.get(fe).referenceProvider.register(n, e);
}
function zse(n, e) {
  return Me.get(fe).renameProvider.register(n, e);
}
function Use(n, e) {
  return Me.get(fe).newSymbolNamesProvider.register(n, e);
}
function Kse(n, e) {
  return Me.get(fe).signatureHelpProvider.register(n, e);
}
function jse(n, e) {
  return Me.get(fe).hoverProvider.register(n, { provideHover: (t, i, s) => {
    const o = t.getWordAtPosition(i);
    return Promise.resolve(e.provideHover(t, i, s)).then(((r) => {
      if (r) return !r.range && o && (r.range = new D(i.lineNumber, o.startColumn, i.lineNumber, o.endColumn)), r.range || (r.range = new D(i.lineNumber, i.column, i.lineNumber, i.column)), r;
    }));
  } });
}
function qse(n, e) {
  return Me.get(fe).documentSymbolProvider.register(n, e);
}
function $se(n, e) {
  return Me.get(fe).documentHighlightProvider.register(n, e);
}
function Gse(n, e) {
  return Me.get(fe).linkedEditingRangeProvider.register(n, e);
}
function Zse(n, e) {
  return Me.get(fe).definitionProvider.register(n, e);
}
function Yse(n, e) {
  return Me.get(fe).implementationProvider.register(n, e);
}
function Xse(n, e) {
  return Me.get(fe).typeDefinitionProvider.register(n, e);
}
function Qse(n, e) {
  return Me.get(fe).codeLensProvider.register(n, e);
}
function Jse(n, e, t) {
  return Me.get(fe).codeActionProvider.register(n, { providedCodeActionKinds: t?.providedCodeActionKinds, documentation: t?.documentation, provideCodeActions: (i, s, o, r) => {
    const a = Me.get(kl).read({ resource: i.uri }).filter(((l) => D.areIntersectingOrTouching(l, s)));
    return e.provideCodeActions(i, s, { markers: a, only: o.only, trigger: o.trigger }, r);
  }, resolveCodeAction: e.resolveCodeAction });
}
function eoe(n, e) {
  return Me.get(fe).documentFormattingEditProvider.register(n, e);
}
function toe(n, e) {
  return Me.get(fe).documentRangeFormattingEditProvider.register(n, e);
}
function ioe(n, e) {
  return Me.get(fe).onTypeFormattingEditProvider.register(n, e);
}
function noe(n, e) {
  return Me.get(fe).linkProvider.register(n, e);
}
function soe(n, e) {
  return Me.get(fe).completionProvider.register(n, e);
}
function ooe(n, e) {
  return Me.get(fe).colorProvider.register(n, e);
}
function roe(n, e) {
  return Me.get(fe).foldingRangeProvider.register(n, e);
}
function aoe(n, e) {
  return Me.get(fe).declarationProvider.register(n, e);
}
function loe(n, e) {
  return Me.get(fe).selectionRangeProvider.register(n, e);
}
function doe(n, e) {
  return Me.get(fe).documentSemanticTokensProvider.register(n, e);
}
function hoe(n, e) {
  return Me.get(fe).documentRangeSemanticTokensProvider.register(n, e);
}
function coe(n, e) {
  return Me.get(fe).inlineCompletionsProvider.register(n, e);
}
function uoe(n, e) {
  return Me.get(fe).inlineEditProvider.register(n, e);
}
function goe(n, e) {
  return Me.get(fe).inlayHintsProvider.register(n, e);
}
const nP = tt("IEditorCancelService"), eH = new ae("cancellableOperation", !1, m(0, "Whether the editor runs a cancellable operation, e.g. like 'Peek References'"));
rt(nP, class {
  constructor() {
    this._tokens = /* @__PURE__ */ new WeakMap();
  }
  add(n, e) {
    let t, i = this._tokens.get(n);
    return i || (i = n.invokeWithinContext(((s) => ({ key: eH.bindTo(s.get(Te)), tokens: new fs() }))), this._tokens.set(n, i)), i.key.set(!0), t = i.tokens.push(e), () => {
      t && (t(), i.key.set(!i.tokens.isEmpty()), t = void 0);
    };
  }
  cancel(n) {
    const e = this._tokens.get(n);
    if (!e) return;
    const t = e.tokens.pop();
    t && (t.cancel(), e.key.set(!e.tokens.isEmpty()));
  }
}, 1);
class poe extends Ci {
  constructor(e, t) {
    super(t), this.editor = e, this._unregister = e.invokeWithinContext(((i) => i.get(nP).add(e, this)));
  }
  dispose() {
    this._unregister(), super.dispose();
  }
}
re(new class extends Zi {
  constructor() {
    super({ id: "editor.cancelOperation", kbOpts: { weight: 100, primary: 9 }, precondition: eH });
  }
  runEditorCommand(n, e) {
    n.get(nP).cancel(e);
  }
}());
let tH = class eM {
  constructor(e, t) {
    if (this.flags = t, 1 & this.flags) {
      const i = e.getModel();
      this.modelVersionId = i ? sg("{0}#{1}", i.uri.toString(), i.getVersionId()) : null;
    } else this.modelVersionId = null;
    4 & this.flags ? this.position = e.getPosition() : this.position = null, 2 & this.flags ? this.selection = e.getSelection() : this.selection = null, 8 & this.flags ? (this.scrollLeft = e.getScrollLeft(), this.scrollTop = e.getScrollTop()) : (this.scrollLeft = -1, this.scrollTop = -1);
  }
  _equals(e) {
    if (!(e instanceof eM)) return !1;
    const t = e;
    return this.modelVersionId === t.modelVersionId && this.scrollLeft === t.scrollLeft && this.scrollTop === t.scrollTop && !(!this.position && t.position || this.position && !t.position || this.position && t.position && !this.position.equals(t.position)) && !(!this.selection && t.selection || this.selection && !t.selection || this.selection && t.selection && !this.selection.equalsRange(t.selection));
  }
  validate(e) {
    return this._equals(new eM(e, this.flags));
  }
};
class Ic extends poe {
  constructor(e, t, i, s) {
    super(e, s), this._listener = new G(), 4 & t && this._listener.add(e.onDidChangeCursorPosition(((o) => {
      i && D.containsPosition(i, o.position) || this.cancel();
    }))), 2 & t && this._listener.add(e.onDidChangeCursorSelection(((o) => {
      i && D.containsRange(i, o.selection) || this.cancel();
    }))), 8 & t && this._listener.add(e.onDidScrollChange(((o) => this.cancel()))), 1 & t && (this._listener.add(e.onDidChangeModel(((o) => this.cancel()))), this._listener.add(e.onDidChangeModelContent(((o) => this.cancel()))));
  }
  dispose() {
    this._listener.dispose(), super.dispose();
  }
}
class sP extends Ci {
  constructor(e, t) {
    super(t), this._listener = e.onDidChangeContent((() => this.cancel()));
  }
  dispose() {
    this._listener.dispose(), super.dispose();
  }
}
function yl(n) {
  return !(!n || typeof n.getEditorType != "function") && n.getEditorType() === b1.ICodeEditor;
}
function oP(n) {
  return !(!n || typeof n.getEditorType != "function") && n.getEditorType() === b1.IDiffEditor;
}
function iH(n) {
  return yl(n) ? n : oP(n) ? n.getModifiedEditor() : (function(e) {
    return !!e && typeof e == "object" && typeof e.onDidChangeActiveEditor == "function";
  })(n) && yl(n.activeCodeEditor) ? n.activeCodeEditor : null;
}
class rf {
  static _handleEolEdits(e, t) {
    let i;
    const s = [];
    for (const o of t) typeof o.eol == "number" && (i = o.eol), o.range && typeof o.text == "string" && s.push(o);
    return typeof i == "number" && e.hasModel() && e.getModel().pushEOL(i), s;
  }
  static _isFullModelReplaceEdit(e, t) {
    if (!e.hasModel()) return !1;
    const i = e.getModel(), s = i.validateRange(t.range);
    return i.getFullModelRange().equalsRange(s);
  }
  static execute(e, t, i) {
    i && e.pushUndoStop();
    const s = wa.capture(e), o = rf._handleEolEdits(e, t);
    o.length === 1 && rf._isFullModelReplaceEdit(e, o[0]) ? e.executeEdits("formatEditsCommand", o.map(((r) => ii.replace(D.lift(r.range), r.text)))) : e.executeEdits("formatEditsCommand", o.map(((r) => ii.replaceMove(D.lift(r.range), r.text)))), i && e.pushUndoStop(), s.restoreRelativeVerticalPositionOfCursor(e);
  }
}
class GF {
  constructor(e) {
    this.value = e, this._lower = e.toLowerCase();
  }
  static toKey(e) {
    return typeof e == "string" ? e.toLowerCase() : e._lower;
  }
}
class moe {
  constructor(e) {
    if (this._set = /* @__PURE__ */ new Set(), e) for (const t of e) this.add(t);
  }
  add(e) {
    this._set.add(GF.toKey(e));
  }
  has(e) {
    return this._set.has(GF.toKey(e));
  }
}
function nH(n, e, t) {
  const i = [], s = new moe(), o = n.ordered(t);
  for (const a of o) i.push(a), a.extensionId && s.add(a.extensionId);
  const r = e.ordered(t);
  for (const a of r) {
    if (a.extensionId) {
      if (s.has(a.extensionId)) continue;
      s.add(a.extensionId);
    }
    i.push({ displayName: a.displayName, extensionId: a.extensionId, provideDocumentFormattingEdits: (l, d, h) => a.provideDocumentRangeFormattingEdits(l, l.getFullModelRange(), d, h) });
  }
  return i;
}
class vg {
  static setFormatterSelector(e) {
    return { dispose: vg._selectors.unshift(e) };
  }
  static async select(e, t, i, s) {
    if (e.length === 0) return;
    const o = at.first(vg._selectors);
    return o ? await o(e, t, i, s) : void 0;
  }
}
async function sH(n, e, t, i, s, o, r) {
  const a = n.get(Se), { documentRangeFormattingEditProvider: l } = n.get(fe), d = yl(e) ? e.getModel() : e, h = l.ordered(d), c = await vg.select(h, d, i, 2);
  c && (s.report(c), await a.invokeFunction(foe, c, e, t, o, r));
}
async function foe(n, e, t, i, s, o) {
  var r, a;
  const l = n.get(Qo), d = n.get(ts), h = n.get(Oc);
  let c, u;
  yl(t) ? (c = t.getModel(), u = new Ic(t, 5, void 0, s)) : (c = t, u = new sP(t, s));
  const g = [];
  let p = 0;
  for (const C of UT(i).sort(D.compareRangesUsingStarts)) p > 0 && D.areIntersectingOrTouching(g[p - 1], C) ? g[p - 1] = D.fromPositions(g[p - 1].getStartPosition(), C.getEndPosition()) : p = g.push(C);
  const f = async (C) => {
    var w, y;
    d.trace("[format][provideDocumentRangeFormattingEdits] (request)", (w = e.extensionId) === null || w === void 0 ? void 0 : w.value, C);
    const L = await e.provideDocumentRangeFormattingEdits(c, C, c.getFormattingOptions(), u.token) || [];
    return d.trace("[format][provideDocumentRangeFormattingEdits] (response)", (y = e.extensionId) === null || y === void 0 ? void 0 : y.value, L), L;
  }, _ = (C, w) => {
    if (!C.length || !w.length) return !1;
    const y = C.reduce(((L, k) => D.plusRange(L, k.range)), C[0].range);
    if (!w.some(((L) => D.intersectRanges(y, L.range)))) return !1;
    for (const L of C) for (const k of w) if (D.intersectRanges(L.range, k.range)) return !0;
    return !1;
  }, v = [], b = [];
  try {
    if (typeof e.provideDocumentRangesFormattingEdits == "function") {
      d.trace("[format][provideDocumentRangeFormattingEdits] (request)", (r = e.extensionId) === null || r === void 0 ? void 0 : r.value, g);
      const C = await e.provideDocumentRangesFormattingEdits(c, g, c.getFormattingOptions(), u.token) || [];
      d.trace("[format][provideDocumentRangeFormattingEdits] (response)", (a = e.extensionId) === null || a === void 0 ? void 0 : a.value, C), b.push(C);
    } else {
      for (const C of g) {
        if (u.token.isCancellationRequested) return !0;
        b.push(await f(C));
      }
      for (let C = 0; C < g.length; ++C) for (let w = C + 1; w < g.length; ++w) {
        if (u.token.isCancellationRequested) return !0;
        if (_(b[C], b[w])) {
          const y = D.plusRange(g[C], g[w]), L = await f(y);
          g.splice(w, 1), g.splice(C, 1), g.push(y), b.splice(w, 1), b.splice(C, 1), b.push(L), C = 0, w = 0;
        }
      }
    }
    for (const C of b) {
      if (u.token.isCancellationRequested) return !0;
      const w = await l.computeMoreMinimalEdits(c.uri, C);
      w && v.push(...w);
    }
  } finally {
    u.dispose();
  }
  if (v.length === 0) return !1;
  if (yl(t)) rf.execute(t, v, !0), t.revealPositionInCenterIfOutsideViewport(t.getPosition(), 1);
  else {
    const [{ range: C }] = v, w = new _e(C.startLineNumber, C.startColumn, C.endLineNumber, C.endColumn);
    c.pushEditOperations([w], v.map(((y) => ({ text: y.text, range: D.lift(y.range), forceMoveMarkers: !0 }))), ((y) => {
      for (const { range: L } of y) if (D.areIntersectingOrTouching(L, w)) return [new _e(L.startLineNumber, L.startColumn, L.endLineNumber, L.endColumn)];
      return null;
    }));
  }
  return h.playSignal(He.format, { userGesture: o }), !0;
}
async function _oe(n, e, t, i, s, o) {
  const r = n.get(Se), a = n.get(fe), l = yl(e) ? e.getModel() : e, d = nH(a.documentFormattingEditProvider, a.documentRangeFormattingEditProvider, l), h = await vg.select(d, l, t, 1);
  h && (i.report(h), await r.invokeFunction(voe, h, e, t, s, o));
}
async function voe(n, e, t, i, s, o) {
  const r = n.get(Qo), a = n.get(Oc);
  let l, d, h;
  yl(t) ? (l = t.getModel(), d = new Ic(t, 5, void 0, s)) : (l = t, d = new sP(t, s));
  try {
    const c = await e.provideDocumentFormattingEdits(l, l.getFormattingOptions(), d.token);
    if (h = await r.computeMoreMinimalEdits(l.uri, c), d.token.isCancellationRequested) return !0;
  } finally {
    d.dispose();
  }
  if (!h || h.length === 0) return !1;
  if (yl(t)) rf.execute(t, h, i !== 2), i !== 2 && t.revealPositionInCenterIfOutsideViewport(t.getPosition(), 1);
  else {
    const [{ range: c }] = h, u = new _e(c.startLineNumber, c.startColumn, c.endLineNumber, c.endColumn);
    l.pushEditOperations([u], h.map(((g) => ({ text: g.text, range: D.lift(g.range), forceMoveMarkers: !0 }))), ((g) => {
      for (const { range: p } of g) if (D.areIntersectingOrTouching(p, u)) return [new _e(p.startLineNumber, p.startColumn, p.endLineNumber, p.endColumn)];
      return null;
    }));
  }
  return a.playSignal(He.format, { userGesture: o }), !0;
}
function oH(n, e, t, i, s, o, r) {
  const a = e.onTypeFormattingEditProvider.ordered(t);
  return a.length === 0 || a[0].autoFormatTriggerCharacters.indexOf(s) < 0 ? Promise.resolve(void 0) : Promise.resolve(a[0].provideOnTypeFormattingEdits(t, i, s, o, r)).catch(Ni).then(((l) => n.computeMoreMinimalEdits(t.uri, l)));
}
vg._selectors = new fs(), dt.registerCommand("_executeFormatRangeProvider", (async function(n, ...e) {
  const [t, i, s] = e;
  vt(Ie.isUri(t)), vt(D.isIRange(i));
  const o = n.get(Ps), r = n.get(Qo), a = n.get(fe), l = await o.createModelReference(t);
  try {
    return (async function(d, h, c, u, g, p) {
      const f = h.documentRangeFormattingEditProvider.ordered(c);
      for (const _ of f) {
        const v = await Promise.resolve(_.provideDocumentRangeFormattingEdits(c, u, g, p)).catch(Ni);
        if (zn(v)) return await d.computeMoreMinimalEdits(c.uri, v);
      }
    })(r, a, l.object.textEditorModel, D.lift(i), s, et.None);
  } finally {
    l.dispose();
  }
})), dt.registerCommand("_executeFormatDocumentProvider", (async function(n, ...e) {
  const [t, i] = e;
  vt(Ie.isUri(t));
  const s = n.get(Ps), o = n.get(Qo), r = n.get(fe), a = await s.createModelReference(t);
  try {
    return (async function(l, d, h, c, u) {
      const g = nH(d.documentFormattingEditProvider, d.documentRangeFormattingEditProvider, h);
      for (const p of g) {
        const f = await Promise.resolve(p.provideDocumentFormattingEdits(h, c, u)).catch(Ni);
        if (zn(f)) return await l.computeMoreMinimalEdits(h.uri, f);
      }
    })(o, r, a.object.textEditorModel, i, et.None);
  } finally {
    a.dispose();
  }
})), dt.registerCommand("_executeFormatOnTypeProvider", (async function(n, ...e) {
  const [t, i, s, o] = e;
  vt(Ie.isUri(t)), vt(W.isIPosition(i)), vt(typeof s == "string");
  const r = n.get(Ps), a = n.get(Qo), l = n.get(fe), d = await r.createModelReference(t);
  try {
    return oH(a, l, d.object.textEditorModel, W.lift(i), s, o, et.None);
  } finally {
    d.dispose();
  }
})), ta.wrappingIndent.defaultValue = 0, ta.glyphMargin.defaultValue = !1, ta.autoIndent.defaultValue = 3, ta.overviewRulerLanes.defaultValue = 2, vg.setFormatterSelector(((n, e, t) => Promise.resolve(n[0])));
const ys = Z7();
ys.editor = { create: Xne, getEditors: ese, getDiffEditors: tse, onDidCreateEditor: Qne, onDidCreateDiffEditor: Jne, createDiffEditor: ise, addCommand: sse, addEditorAction: ose, addKeybindingRule: rse, addKeybindingRules: YV, createModel: ase, setModelLanguage: lse, setModelMarkers: dse, getModelMarkers: cse, removeAllMarkers: hse, onDidChangeMarkers: use, getModels: pse, getModel: gse, onDidCreateModel: mse, onWillDisposeModel: fse, onDidChangeModelLanguage: _se, createWebWorker: vse, colorizeElement: bse, colorize: Cse, colorizeModelLine: wse, tokenize: yse, defineTheme: Sse, setTheme: Lse, remeasureFonts: kse, registerCommand: Dse, registerLinkOpener: xse, registerEditorOpener: Nse, AccessibilitySupport: TN, ContentWidgetPositionPreference: BN, CursorChangeReason: WN, DefaultEndOfLine: VN, EditorAutoIndentStrategy: zN, EditorOption: UN, EndOfLinePreference: KN, EndOfLineSequence: jN, MinimapPosition: tE, MinimapSectionHeaderStyle: iE, MouseTargetType: nE, OverlayWidgetPositionPreference: oE, OverviewRulerLane: rE, GlyphMarginLane: qN, RenderLineNumbersType: dE, RenderMinimap: hE, ScrollbarVisibility: uE, ScrollType: cE, TextEditorCursorBlinkingStyle: vE, TextEditorCursorStyle: bE, TrackedRangeStickiness: CE, WrappingIndent: wE, InjectedTextCursorStops: GN, PositionAffinity: lE, ShowLightbulbIconMode: pE, ConfigurationChangedEvent: N7, BareFontInfo: zu, FontInfo: ME, TextModelResolvedOptions: MC, FindMatch: tv, ApplyUpdateResult: q_, EditorZoom: Vo, createMultiFileDiffEditor: nse, EditorType: b1, EditorOptions: ta }, ys.languages = { register: Mse, getLanguages: Tse, onLanguage: Ase, onLanguageEncountered: Pse, getEncodedLanguageId: Rse, setLanguageConfiguration: Ose, setColorMap: Bse, registerTokensProviderFactory: iP, setTokensProvider: Wse, setMonarchTokensProvider: Vse, registerReferenceProvider: Hse, registerRenameProvider: zse, registerNewSymbolNameProvider: Use, registerCompletionItemProvider: soe, registerSignatureHelpProvider: Kse, registerHoverProvider: jse, registerDocumentSymbolProvider: qse, registerDocumentHighlightProvider: $se, registerLinkedEditingRangeProvider: Gse, registerDefinitionProvider: Zse, registerImplementationProvider: Yse, registerTypeDefinitionProvider: Xse, registerCodeLensProvider: Qse, registerCodeActionProvider: Jse, registerDocumentFormattingEditProvider: eoe, registerDocumentRangeFormattingEditProvider: toe, registerOnTypeFormattingEditProvider: ioe, registerLinkProvider: noe, registerColorProvider: ooe, registerFoldingRangeProvider: roe, registerDeclarationProvider: aoe, registerSelectionRangeProvider: loe, registerDocumentSemanticTokensProvider: doe, registerDocumentRangeSemanticTokensProvider: hoe, registerInlineCompletionsProvider: coe, registerInlineEditProvider: uoe, registerInlayHintsProvider: goe, DocumentHighlightKind: HN, CompletionItemKind: PN, CompletionItemTag: ON, CompletionItemInsertTextRule: AN, SymbolKind: fE, SymbolTag: _E, IndentAction: $N, CompletionTriggerKind: FN, SignatureHelpTriggerKind: mE, InlayHintKind: ZN, InlineCompletionTriggerKind: YN, InlineEditTriggerKind: XN, CodeActionTriggerType: RN, NewSymbolNameTag: sE, PartialAcceptTriggerKind: aE, FoldingRangeKind: ls, SelectedSuggestionInfo: G7 };
const rH = ys.CancellationTokenSource, rP = ys.Emitter, aH = ys.KeyCode, lH = ys.KeyMod, dH = ys.Position, hH = ys.Range, cH = ys.Selection, uH = ys.SelectionDirection, gH = ys.MarkerSeverity, pH = ys.MarkerTag, mH = ys.Uri, fH = ys.Token, _H = ys.editor, C0 = ys.languages, ZF = globalThis.MonacoEnvironment;
(ZF?.globalAPI || typeof define == "function" && define.amd) && (globalThis.monaco = ys), globalThis.require !== void 0 && typeof globalThis.require.config == "function" && globalThis.require.config({ ignoreDuplicateModules: ["vscode-languageserver-types", "vscode-languageserver-types/main", "vscode-languageserver-textdocument", "vscode-languageserver-textdocument/main", "vscode-nls", "vscode-nls/vscode-nls", "jsonc-parser", "jsonc-parser/main", "vscode-uri", "vscode-uri/index", "vs/basic-languages/typescript/typescript"] });
const UL = Object.freeze(Object.defineProperty({ __proto__: null, CancellationTokenSource: rH, Emitter: rP, KeyCode: aH, KeyMod: lH, MarkerSeverity: gH, MarkerTag: pH, Position: dH, Range: hH, Selection: cH, SelectionDirection: uH, Token: fH, Uri: mH, editor: _H, languages: C0 }, Symbol.toStringTag, { value: "Module" }));
var boe = Object.defineProperty, Coe = Object.getOwnPropertyDescriptor, woe = Object.getOwnPropertyNames, yoe = Object.prototype.hasOwnProperty, R_ = {};
((n, e, t, i) => {
  if (e && typeof e == "object" || typeof e == "function") for (let s of woe(e)) yoe.call(n, s) || s === t || boe(n, s, { get: () => e[s], enumerable: !(i = Coe(e, s)) || i.enumerable });
})(R_, UL, "default");
var vH = {}, ux = {}, Soe = class bH {
  static getOrCreate(e) {
    return ux[e] || (ux[e] = new bH(e)), ux[e];
  }
  constructor(e) {
    this._languageId = e, this._loadingTriggered = !1, this._lazyLoadPromise = new Promise(((t, i) => {
      this._lazyLoadPromiseResolve = t, this._lazyLoadPromiseReject = i;
    }));
  }
  load() {
    return this._loadingTriggered || (this._loadingTriggered = !0, vH[this._languageId].loader().then(((e) => this._lazyLoadPromiseResolve(e)), ((e) => this._lazyLoadPromiseReject(e)))), this._lazyLoadPromise;
  }
};
function Le(n) {
  const e = n.id;
  vH[e] = n, R_.languages.register(n);
  const t = Soe.getOrCreate(e);
  R_.languages.registerTokensProviderFactory(e, { create: async () => (await t.load()).language }), R_.languages.onLanguageEncountered(e, (async () => {
    const i = await t.load();
    R_.languages.setLanguageConfiguration(e, i.conf);
  }));
}
Le({ id: "abap", extensions: [".abap"], aliases: ["abap", "ABAP"], loader: () => import("./abap-Tr56a1Zm.js") }), Le({ id: "apex", extensions: [".cls"], aliases: ["Apex", "apex"], mimetypes: ["text/x-apex-source", "text/x-apex"], loader: () => import("./apex-DBt-xJmL.js") }), Le({ id: "azcli", extensions: [".azcli"], aliases: ["Azure CLI", "azcli"], loader: () => import("./azcli-Btn7m3fD.js") }), Le({ id: "bat", extensions: [".bat", ".cmd"], aliases: ["Batch", "bat"], loader: () => import("./bat-ByTATCOl.js") }), Le({ id: "bicep", extensions: [".bicep"], aliases: ["Bicep"], loader: () => import("./bicep-BhEnY-uZ.js") }), Le({ id: "cameligo", extensions: [".mligo"], aliases: ["Cameligo"], loader: () => import("./cameligo-3LdHYQL-.js") }), Le({ id: "clojure", extensions: [".clj", ".cljs", ".cljc", ".edn"], aliases: ["clojure", "Clojure"], loader: () => import("./clojure-DjbhrUaB.js") }), Le({ id: "coffeescript", extensions: [".coffee"], aliases: ["CoffeeScript", "coffeescript", "coffee"], mimetypes: ["text/x-coffeescript", "text/coffeescript"], loader: () => import("./coffee-7FzaZYLM.js") }), Le({ id: "c", extensions: [".c", ".h"], aliases: ["C", "c"], loader: () => import("./cpp-Dv-XAjCK.js") }), Le({ id: "cpp", extensions: [".cpp", ".cc", ".cxx", ".hpp", ".hh", ".hxx"], aliases: ["C++", "Cpp", "cpp"], loader: () => import("./cpp-Dv-XAjCK.js") }), Le({ id: "csharp", extensions: [".cs", ".csx", ".cake"], aliases: ["C#", "csharp"], loader: () => import("./csharp-BZz0OSMf.js") }), Le({ id: "csp", extensions: [], aliases: ["CSP", "csp"], loader: () => import("./csp-ZfKUTqW0.js") }), Le({ id: "css", extensions: [".css"], aliases: ["CSS", "css"], mimetypes: ["text/css"], loader: () => import("./css-Bnm3Iei0.js") }), Le({ id: "cypher", extensions: [".cypher", ".cyp"], aliases: ["Cypher", "OpenCypher"], loader: () => import("./cypher-BFvd4W4v.js") }), Le({ id: "dart", extensions: [".dart"], aliases: ["Dart", "dart"], mimetypes: ["text/x-dart-source", "text/x-dart"], loader: () => import("./dart-DkaMDnmt.js") }), Le({ id: "dockerfile", extensions: [".dockerfile"], filenames: ["Dockerfile"], aliases: ["Dockerfile"], loader: () => import("./dockerfile-DFtjHw12.js") }), Le({ id: "ecl", extensions: [".ecl"], aliases: ["ECL", "Ecl", "ecl"], loader: () => import("./ecl-BtT9Hws7.js") }), Le({ id: "elixir", extensions: [".ex", ".exs"], aliases: ["Elixir", "elixir", "ex"], loader: () => import("./elixir-CZV6vub2.js") }), Le({ id: "flow9", extensions: [".flow"], aliases: ["Flow9", "Flow", "flow9", "flow"], loader: () => import("./flow9-elQvKHRe.js") }), Le({ id: "fsharp", extensions: [".fs", ".fsi", ".ml", ".mli", ".fsx", ".fsscript"], aliases: ["F#", "FSharp", "fsharp"], loader: () => import("./fsharp-CQsoCURP.js") }), Le({ id: "freemarker2", extensions: [".ftl", ".ftlh", ".ftlx"], aliases: ["FreeMarker2", "Apache FreeMarker2"], loader: () => import("./freemarker2-CoC8KEBU.js").then(((n) => n.TagAutoInterpolationDollar)) }), Le({ id: "freemarker2.tag-angle.interpolation-dollar", aliases: ["FreeMarker2 (Angle/Dollar)", "Apache FreeMarker2 (Angle/Dollar)"], loader: () => import("./freemarker2-CoC8KEBU.js").then(((n) => n.TagAngleInterpolationDollar)) }), Le({ id: "freemarker2.tag-bracket.interpolation-dollar", aliases: ["FreeMarker2 (Bracket/Dollar)", "Apache FreeMarker2 (Bracket/Dollar)"], loader: () => import("./freemarker2-CoC8KEBU.js").then(((n) => n.TagBracketInterpolationDollar)) }), Le({ id: "freemarker2.tag-angle.interpolation-bracket", aliases: ["FreeMarker2 (Angle/Bracket)", "Apache FreeMarker2 (Angle/Bracket)"], loader: () => import("./freemarker2-CoC8KEBU.js").then(((n) => n.TagAngleInterpolationBracket)) }), Le({ id: "freemarker2.tag-bracket.interpolation-bracket", aliases: ["FreeMarker2 (Bracket/Bracket)", "Apache FreeMarker2 (Bracket/Bracket)"], loader: () => import("./freemarker2-CoC8KEBU.js").then(((n) => n.TagBracketInterpolationBracket)) }), Le({ id: "freemarker2.tag-auto.interpolation-dollar", aliases: ["FreeMarker2 (Auto/Dollar)", "Apache FreeMarker2 (Auto/Dollar)"], loader: () => import("./freemarker2-CoC8KEBU.js").then(((n) => n.TagAutoInterpolationDollar)) }), Le({ id: "freemarker2.tag-auto.interpolation-bracket", aliases: ["FreeMarker2 (Auto/Bracket)", "Apache FreeMarker2 (Auto/Bracket)"], loader: () => import("./freemarker2-CoC8KEBU.js").then(((n) => n.TagAutoInterpolationBracket)) }), Le({ id: "go", extensions: [".go"], aliases: ["Go"], loader: () => import("./go-B6ANsLBK.js") }), Le({ id: "graphql", extensions: [".graphql", ".gql"], aliases: ["GraphQL", "graphql", "gql"], mimetypes: ["application/graphql"], loader: () => import("./graphql-CRNCUg8Q.js") }), Le({ id: "handlebars", extensions: [".handlebars", ".hbs"], aliases: ["Handlebars", "handlebars", "hbs"], mimetypes: ["text/x-handlebars-template"], loader: () => import("./handlebars-C87D8GL3.js") }), Le({ id: "hcl", extensions: [".tf", ".tfvars", ".hcl"], aliases: ["Terraform", "tf", "HCL", "hcl"], loader: () => import("./hcl-Dmsg-7yr.js") }), Le({ id: "html", extensions: [".html", ".htm", ".shtml", ".xhtml", ".mdoc", ".jsp", ".asp", ".aspx", ".jshtm"], aliases: ["HTML", "htm", "html", "xhtml"], mimetypes: ["text/html", "text/x-jshtm", "text/template", "text/ng-template"], loader: () => import("./html-DdJGrIQN.js") }), Le({ id: "ini", extensions: [".ini", ".properties", ".gitconfig"], filenames: ["config", ".gitattributes", ".gitconfig", ".editorconfig"], aliases: ["Ini", "ini"], loader: () => import("./ini-BJUuYG3X.js") }), Le({ id: "java", extensions: [".java", ".jav"], aliases: ["Java", "java"], mimetypes: ["text/x-java-source", "text/x-java"], loader: () => import("./java-Dyma2_Zy.js") }), Le({ id: "javascript", extensions: [".js", ".es6", ".jsx", ".mjs", ".cjs"], firstLine: "^#!.*\\bnode", filenames: ["jakefile"], aliases: ["JavaScript", "javascript", "js"], mimetypes: ["text/javascript"], loader: () => import("./javascript-DeKzf4PS.js") }), Le({ id: "julia", extensions: [".jl"], aliases: ["julia", "Julia"], loader: () => import("./julia-Bf8d5Nbk.js") }), Le({ id: "kotlin", extensions: [".kt", ".kts"], aliases: ["Kotlin", "kotlin"], mimetypes: ["text/x-kotlin-source", "text/x-kotlin"], loader: () => import("./kotlin-DX5ll4GS.js") }), Le({ id: "less", extensions: [".less"], aliases: ["Less", "less"], mimetypes: ["text/x-less", "text/less"], loader: () => import("./less-Cla7PKqn.js") }), Le({ id: "lexon", extensions: [".lex"], aliases: ["Lexon"], loader: () => import("./lexon-pCFSm_JI.js") }), Le({ id: "lua", extensions: [".lua"], aliases: ["Lua", "lua"], loader: () => import("./lua-DmFtFri_.js") }), Le({ id: "liquid", extensions: [".liquid", ".html.liquid"], aliases: ["Liquid", "liquid"], mimetypes: ["application/liquid"], loader: () => import("./liquid-DZY1hlLU.js") }), Le({ id: "m3", extensions: [".m3", ".i3", ".mg", ".ig"], aliases: ["Modula-3", "Modula3", "modula3", "m3"], loader: () => import("./m3-CcliCMX8.js") }), Le({ id: "markdown", extensions: [".md", ".markdown", ".mdown", ".mkdn", ".mkd", ".mdwn", ".mdtxt", ".mdtext"], aliases: ["Markdown", "markdown"], loader: () => import("./markdown-BE16CdWC.js") }), Le({ id: "mdx", extensions: [".mdx"], aliases: ["MDX", "mdx"], loader: () => import("./mdx-BuElf7Bd.js") }), Le({ id: "mips", extensions: [".s"], aliases: ["MIPS", "MIPS-V"], mimetypes: ["text/x-mips", "text/mips", "text/plaintext"], loader: () => import("./mips-CZ5rJTWg.js") }), Le({ id: "msdax", extensions: [".dax", ".msdax"], aliases: ["DAX", "MSDAX"], loader: () => import("./msdax-Bvmv6_-6.js") }), Le({ id: "mysql", extensions: [], aliases: ["MySQL", "mysql"], loader: () => import("./mysql-CCUiKRFH.js") }), Le({ id: "objective-c", extensions: [".m"], aliases: ["Objective-C"], loader: () => import("./objective-c-DpBn7jMI.js") }), Le({ id: "pascal", extensions: [".pas", ".p", ".pp"], aliases: ["Pascal", "pas"], mimetypes: ["text/x-pascal-source", "text/x-pascal"], loader: () => import("./pascal-DheuMH6q.js") }), Le({ id: "pascaligo", extensions: [".ligo"], aliases: ["Pascaligo", "ligo"], loader: () => import("./pascaligo-EZ4nPFs_.js") }), Le({ id: "perl", extensions: [".pl", ".pm"], aliases: ["Perl", "pl"], loader: () => import("./perl-DsA-aB-_.js") }), Le({ id: "pgsql", extensions: [], aliases: ["PostgreSQL", "postgres", "pg", "postgre"], loader: () => import("./pgsql-DuAX-GK2.js") }), Le({ id: "php", extensions: [".php", ".php4", ".php5", ".phtml", ".ctp"], aliases: ["PHP", "php"], mimetypes: ["application/x-php"], loader: () => import("./php-BCR7iqV8.js") }), Le({ id: "pla", extensions: [".pla"], loader: () => import("./pla-B2fYjXXB.js") }), Le({ id: "postiats", extensions: [".dats", ".sats", ".hats"], aliases: ["ATS", "ATS/Postiats"], loader: () => import("./postiats-I3fntyTX.js") }), Le({ id: "powerquery", extensions: [".pq", ".pqm"], aliases: ["PQ", "M", "Power Query", "Power Query M"], loader: () => import("./powerquery-DXoCgcvh.js") }), Le({ id: "powershell", extensions: [".ps1", ".psm1", ".psd1"], aliases: ["PowerShell", "powershell", "ps", "ps1"], loader: () => import("./powershell-BOW6ItqY.js") }), Le({ id: "proto", extensions: [".proto"], aliases: ["protobuf", "Protocol Buffers"], loader: () => import("./protobuf-DUYs5q6s.js") }), Le({ id: "pug", extensions: [".jade", ".pug"], aliases: ["Pug", "Jade", "jade"], loader: () => import("./pug-DrAJxA5u.js") }), Le({ id: "python", extensions: [".py", ".rpy", ".pyw", ".cpy", ".gyp", ".gypi"], aliases: ["Python", "py"], firstLine: "^#!/.*\\bpython[0-9.-]*\\b", loader: () => import("./python-DELG-R7O.js") }), Le({ id: "qsharp", extensions: [".qs"], aliases: ["Q#", "qsharp"], loader: () => import("./qsharp-D1xHloYg.js") }), Le({ id: "r", extensions: [".r", ".rhistory", ".rmd", ".rprofile", ".rt"], aliases: ["R", "r"], loader: () => import("./r-CMHxhNVv.js") }), Le({ id: "razor", extensions: [".cshtml"], aliases: ["Razor", "razor"], mimetypes: ["text/x-cshtml"], loader: () => import("./razor-CEHTkWKU.js") }), Le({ id: "redis", extensions: [".redis"], aliases: ["redis"], loader: () => import("./redis-BcdKgvB8.js") }), Le({ id: "redshift", extensions: [], aliases: ["Redshift", "redshift"], loader: () => import("./redshift-CpWQF0fU.js") }), Le({ id: "restructuredtext", extensions: [".rst"], aliases: ["reStructuredText", "restructuredtext"], loader: () => import("./restructuredtext-CMNZjQgw.js") }), Le({ id: "ruby", extensions: [".rb", ".rbx", ".rjs", ".gemspec", ".pp"], filenames: ["rakefile", "Gemfile"], aliases: ["Ruby", "rb"], loader: () => import("./ruby-B_DAwuyk.js") }), Le({ id: "rust", extensions: [".rs", ".rlib"], aliases: ["Rust", "rust"], loader: () => import("./rust-BSPxeqCM.js") }), Le({ id: "sb", extensions: [".sb"], aliases: ["Small Basic", "sb"], loader: () => import("./sb-0xs4WOZO.js") }), Le({ id: "scala", extensions: [".scala", ".sc", ".sbt"], aliases: ["Scala", "scala", "SBT", "Sbt", "sbt", "Dotty", "dotty"], mimetypes: ["text/x-scala-source", "text/x-scala", "text/x-sbt", "text/x-dotty"], loader: () => import("./scala-CDUtQgZP.js") }), Le({ id: "scheme", extensions: [".scm", ".ss", ".sch", ".rkt"], aliases: ["scheme", "Scheme"], loader: () => import("./scheme-DTT6HxEC.js") }), Le({ id: "scss", extensions: [".scss"], aliases: ["Sass", "sass", "scss"], mimetypes: ["text/x-scss", "text/scss"], loader: () => import("./scss-bnVM9Ces.js") }), Le({ id: "shell", extensions: [".sh", ".bash"], aliases: ["Shell", "sh"], loader: () => import("./shell-CK2WEEgP.js") }), Le({ id: "sol", extensions: [".sol"], aliases: ["sol", "solidity", "Solidity"], loader: () => import("./solidity-qIY78QOQ.js") }), Le({ id: "aes", extensions: [".aes"], aliases: ["aes", "sophia", "Sophia"], loader: () => import("./sophia-dUW-Rpx-.js") }), Le({ id: "sparql", extensions: [".rq"], aliases: ["sparql", "SPARQL"], loader: () => import("./sparql-BeGvre3N.js") }), Le({ id: "sql", extensions: [".sql"], aliases: ["SQL"], loader: () => import("./sql-CK5iI7_1.js") }), Le({ id: "st", extensions: [".st", ".iecst", ".iecplc", ".lc3lib", ".TcPOU", ".TcDUT", ".TcGVL", ".TcIO"], aliases: ["StructuredText", "scl", "stl"], loader: () => import("./st-CwX2pLFB.js") }), Le({ id: "swift", aliases: ["Swift", "swift"], extensions: [".swift"], mimetypes: ["text/swift"], loader: () => import("./swift-C-YOpDhl.js") }), Le({ id: "systemverilog", extensions: [".sv", ".svh"], aliases: ["SV", "sv", "SystemVerilog", "systemverilog"], loader: () => import("./systemverilog-TF1oBkzk.js") }), Le({ id: "verilog", extensions: [".v", ".vh"], aliases: ["V", "v", "Verilog", "verilog"], loader: () => import("./systemverilog-TF1oBkzk.js") }), Le({ id: "tcl", extensions: [".tcl"], aliases: ["tcl", "Tcl", "tcltk", "TclTk", "tcl/tk", "Tcl/Tk"], loader: () => import("./tcl-Cm0weSIy.js") }), Le({ id: "twig", extensions: [".twig"], aliases: ["Twig", "twig"], mimetypes: ["text/x-twig"], loader: () => import("./twig-DsWCP9to.js") }), Le({ id: "typescript", extensions: [".ts", ".tsx", ".cts", ".mts"], aliases: ["TypeScript", "ts", "typescript"], mimetypes: ["text/typescript"], loader: () => import("./typescript-BudTDa0C.js") }), Le({ id: "vb", extensions: [".vb"], aliases: ["Visual Basic", "vb"], loader: () => import("./vb-Dhcs4wOP.js") }), Le({ id: "wgsl", extensions: [".wgsl"], aliases: ["WebGPU Shading Language", "WGSL", "wgsl"], loader: () => import("./wgsl-vmUf8Zkn.js") }), Le({ id: "xml", extensions: [".xml", ".xsd", ".dtd", ".ascx", ".csproj", ".config", ".props", ".targets", ".wxi", ".wxl", ".wxs", ".xaml", ".svg", ".svgz", ".opf", ".xslt", ".xsl"], firstLine: "(\\<\\?xml.*)|(\\<svg)|(\\<\\!doctype\\s+svg)", aliases: ["XML", "xml"], mimetypes: ["text/xml", "application/xml", "application/xaml+xml", "application/xml-dtd"], loader: () => import("./xml-AZ5ybf4G.js") }), Le({ id: "yaml", extensions: [".yaml", ".yml"], aliases: ["YAML", "yaml", "YML", "yml"], mimetypes: ["application/x-yaml", "text/x-yaml"], loader: () => import("./yaml-Bgsn5hDp.js") });
var Loe = Object.defineProperty, koe = Object.getOwnPropertyDescriptor, Doe = Object.getOwnPropertyNames, xoe = Object.prototype.hasOwnProperty, zp = {};
((n, e, t) => {
  ((i, s, o, r) => {
    if (s && typeof s == "object" || typeof s == "function") for (let a of Doe(s)) xoe.call(i, a) || a === o || Loe(i, a, { get: () => s[a], enumerable: !(r = koe(s, a)) || r.enumerable });
  })(n, e, "default");
})(zp, UL);
var aP = class {
  constructor(n, e, t) {
    this._onDidChange = new zp.Emitter(), this._languageId = n, this.setOptions(e), this.setModeConfiguration(t);
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get languageId() {
    return this._languageId;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  get diagnosticsOptions() {
    return this.options;
  }
  get options() {
    return this._options;
  }
  setOptions(n) {
    this._options = n || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
  setDiagnosticsOptions(n) {
    this.setOptions(n);
  }
  setModeConfiguration(n) {
    this._modeConfiguration = n || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
}, lP = { validate: !0, lint: { compatibleVendorPrefixes: "ignore", vendorPrefix: "warning", duplicateProperties: "warning", emptyRules: "warning", importStatement: "ignore", boxModel: "ignore", universalSelector: "ignore", zeroUnits: "ignore", fontFaceProperties: "warning", hexColorLength: "error", argumentsInColorFunction: "error", unknownProperties: "warning", ieHack: "ignore", unknownVendorSpecificProperties: "ignore", propertyIgnoredDueToDisplay: "warning", important: "ignore", float: "ignore", idSelector: "ignore" }, data: { useDefaultDataProvider: !0 }, format: { newlineBetweenSelectors: !0, newlineBetweenRules: !0, spaceAroundSelectorSeparator: !1, braceStyle: "collapse", maxPreserveNewLines: void 0, preserveNewLines: !0 } }, dP = { completionItems: !0, hovers: !0, documentSymbols: !0, definitions: !0, references: !0, documentHighlights: !0, rename: !0, colors: !0, foldingRanges: !0, diagnostics: !0, selectionRanges: !0, documentFormattingEdits: !0, documentRangeFormattingEdits: !0 }, YF = new aP("css", lP, dP), XF = new aP("scss", lP, dP), QF = new aP("less", lP, dP);
function gx() {
  return import("./cssMode-BZIBJ_PG.js");
}
zp.languages.css = { cssDefaults: YF, lessDefaults: QF, scssDefaults: XF }, zp.languages.onLanguage("less", (() => {
  gx().then(((n) => n.setupMode(QF)));
})), zp.languages.onLanguage("scss", (() => {
  gx().then(((n) => n.setupMode(XF)));
})), zp.languages.onLanguage("css", (() => {
  gx().then(((n) => n.setupMode(YF)));
}));
var Noe = Object.defineProperty, Eoe = Object.getOwnPropertyDescriptor, Ioe = Object.getOwnPropertyNames, Moe = Object.prototype.hasOwnProperty, KL = {};
((n, e, t) => {
  ((i, s, o, r) => {
    if (s && typeof s == "object" || typeof s == "function") for (let a of Ioe(s)) Moe.call(i, a) || a === o || Noe(i, a, { get: () => s[a], enumerable: !(r = Eoe(s, a)) || r.enumerable });
  })(n, e, "default");
})(KL, UL);
var Toe = class {
  constructor(n, e, t) {
    this._onDidChange = new KL.Emitter(), this._languageId = n, this.setOptions(e), this.setModeConfiguration(t);
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get languageId() {
    return this._languageId;
  }
  get options() {
    return this._options;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  setOptions(n) {
    this._options = n || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
  setModeConfiguration(n) {
    this._modeConfiguration = n || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
}, jL = { format: { tabSize: 4, insertSpaces: !1, wrapLineLength: 120, unformatted: 'default": "a, abbr, acronym, b, bdo, big, br, button, cite, code, dfn, em, i, img, input, kbd, label, map, object, q, samp, select, small, span, strong, sub, sup, textarea, tt, var', contentUnformatted: "pre", indentInnerHtml: !1, preserveNewLines: !0, maxPreserveNewLines: void 0, indentHandlebars: !1, endWithNewline: !1, extraLiners: "head, body, /html", wrapAttributes: "auto" }, suggest: {}, data: { useDefaultDataProvider: !0 } };
function qL(n) {
  return { completionItems: !0, hovers: !0, documentSymbols: !0, links: !0, documentHighlights: !0, rename: !0, colors: !0, foldingRanges: !0, selectionRanges: !0, diagnostics: n === w0, documentFormattingEdits: n === w0, documentRangeFormattingEdits: n === w0 };
}
var w0 = "html", JF = "handlebars", e6 = "razor", CH = $L(w0, jL, qL(w0)), Roe = CH.defaults, wH = $L(JF, jL, qL(JF)), Aoe = wH.defaults, yH = $L(e6, jL, qL(e6)), Poe = yH.defaults;
function $L(n, e = jL, t = qL(n)) {
  const i = new Toe(n, e, t);
  let s;
  const o = KL.languages.onLanguage(n, (async () => {
    s = (await import("./htmlMode-C9DT-arR.js")).setupMode(i);
  }));
  return { defaults: i, dispose() {
    o.dispose(), s?.dispose(), s = void 0;
  } };
}
KL.languages.html = { htmlDefaults: Roe, razorDefaults: Poe, handlebarDefaults: Aoe, htmlLanguageService: CH, handlebarLanguageService: wH, razorLanguageService: yH, registerHTMLLanguageService: $L };
var t6 = new class {
  constructor(n, e, t) {
    this._onDidChange = new rP(), this._languageId = n, this.setDiagnosticsOptions(e), this.setModeConfiguration(t);
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get languageId() {
    return this._languageId;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  get diagnosticsOptions() {
    return this._diagnosticsOptions;
  }
  setDiagnosticsOptions(n) {
    this._diagnosticsOptions = n || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
  setModeConfiguration(n) {
    this._modeConfiguration = n || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
}("json", { validate: !0, allowComments: !0, schemas: [], enableSchemaRequest: !1, schemaRequest: "warning", schemaValidation: "warning", comments: "error", trailingCommas: "error" }, { documentFormattingEdits: !0, documentRangeFormattingEdits: !0, completionItems: !0, hovers: !0, documentSymbols: !0, tokens: !0, colors: !0, foldingRanges: !0, diagnostics: !0, selectionRanges: !0 });
function i6() {
  return import("./jsonMode-DsoFGIpA.js");
}
C0.json = { jsonDefaults: t6, getWorker: () => i6().then(((n) => n.getWorker())) }, C0.register({ id: "json", extensions: [".json", ".bowerrc", ".jshintrc", ".jscsrc", ".eslintrc", ".babelrc", ".har"], aliases: ["JSON", "json"], mimetypes: ["application/json"] }), C0.onLanguage("json", (() => {
  i6().then(((n) => n.setupMode(t6)));
}));
var Ooe = Object.defineProperty, Foe = Object.getOwnPropertyDescriptor, Boe = Object.getOwnPropertyNames, Woe = Object.prototype.hasOwnProperty, Cm = {};
((n, e, t) => {
  ((i, s, o, r) => {
    if (s && typeof s == "object" || typeof s == "function") for (let a of Boe(s)) Woe.call(i, a) || a === o || Ooe(i, a, { get: () => s[a], enumerable: !(r = Foe(s, a)) || r.enumerable });
  })(n, e, "default");
})(Cm, UL);
var SH = ((n) => (n[n.None = 0] = "None", n[n.CommonJS = 1] = "CommonJS", n[n.AMD = 2] = "AMD", n[n.UMD = 3] = "UMD", n[n.System = 4] = "System", n[n.ES2015 = 5] = "ES2015", n[n.ESNext = 99] = "ESNext", n))(SH || {}), LH = ((n) => (n[n.None = 0] = "None", n[n.Preserve = 1] = "Preserve", n[n.React = 2] = "React", n[n.ReactNative = 3] = "ReactNative", n[n.ReactJSX = 4] = "ReactJSX", n[n.ReactJSXDev = 5] = "ReactJSXDev", n))(LH || {}), kH = ((n) => (n[n.CarriageReturnLineFeed = 0] = "CarriageReturnLineFeed", n[n.LineFeed = 1] = "LineFeed", n))(kH || {}), DH = ((n) => (n[n.ES3 = 0] = "ES3", n[n.ES5 = 1] = "ES5", n[n.ES2015 = 2] = "ES2015", n[n.ES2016 = 3] = "ES2016", n[n.ES2017 = 4] = "ES2017", n[n.ES2018 = 5] = "ES2018", n[n.ES2019 = 6] = "ES2019", n[n.ES2020 = 7] = "ES2020", n[n.ESNext = 99] = "ESNext", n[n.JSON = 100] = "JSON", n[n.Latest = 99] = "Latest", n))(DH || {}), xH = ((n) => (n[n.Classic = 1] = "Classic", n[n.NodeJs = 2] = "NodeJs", n))(xH || {}), NH = class {
  constructor(n, e, t, i, s) {
    this._onDidChange = new Cm.Emitter(), this._onDidExtraLibsChange = new Cm.Emitter(), this._extraLibs = /* @__PURE__ */ Object.create(null), this._removedExtraLibs = /* @__PURE__ */ Object.create(null), this._eagerModelSync = !1, this.setCompilerOptions(n), this.setDiagnosticsOptions(e), this.setWorkerOptions(t), this.setInlayHintsOptions(i), this.setModeConfiguration(s), this._onDidExtraLibsChangeTimeout = -1;
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get onDidExtraLibsChange() {
    return this._onDidExtraLibsChange.event;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  get workerOptions() {
    return this._workerOptions;
  }
  get inlayHintsOptions() {
    return this._inlayHintsOptions;
  }
  getExtraLibs() {
    return this._extraLibs;
  }
  addExtraLib(n, e) {
    let t;
    if (t = e === void 0 ? `ts:extralib-${Math.random().toString(36).substring(2, 15)}` : e, this._extraLibs[t] && this._extraLibs[t].content === n) return { dispose: () => {
    } };
    let i = 1;
    return this._removedExtraLibs[t] && (i = this._removedExtraLibs[t] + 1), this._extraLibs[t] && (i = this._extraLibs[t].version + 1), this._extraLibs[t] = { content: n, version: i }, this._fireOnDidExtraLibsChangeSoon(), { dispose: () => {
      let s = this._extraLibs[t];
      s && s.version === i && (delete this._extraLibs[t], this._removedExtraLibs[t] = i, this._fireOnDidExtraLibsChangeSoon());
    } };
  }
  setExtraLibs(n) {
    for (const e in this._extraLibs) this._removedExtraLibs[e] = this._extraLibs[e].version;
    if (this._extraLibs = /* @__PURE__ */ Object.create(null), n && n.length > 0) for (const e of n) {
      const t = e.filePath || `ts:extralib-${Math.random().toString(36).substring(2, 15)}`, i = e.content;
      let s = 1;
      this._removedExtraLibs[t] && (s = this._removedExtraLibs[t] + 1), this._extraLibs[t] = { content: i, version: s };
    }
    this._fireOnDidExtraLibsChangeSoon();
  }
  _fireOnDidExtraLibsChangeSoon() {
    this._onDidExtraLibsChangeTimeout === -1 && (this._onDidExtraLibsChangeTimeout = window.setTimeout((() => {
      this._onDidExtraLibsChangeTimeout = -1, this._onDidExtraLibsChange.fire(void 0);
    }), 0));
  }
  getCompilerOptions() {
    return this._compilerOptions;
  }
  setCompilerOptions(n) {
    this._compilerOptions = n || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  getDiagnosticsOptions() {
    return this._diagnosticsOptions;
  }
  setDiagnosticsOptions(n) {
    this._diagnosticsOptions = n || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  setWorkerOptions(n) {
    this._workerOptions = n || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  setInlayHintsOptions(n) {
    this._inlayHintsOptions = n || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  setMaximumWorkerIdleTime(n) {
  }
  setEagerModelSync(n) {
    this._eagerModelSync = n;
  }
  getEagerModelSync() {
    return this._eagerModelSync;
  }
  setModeConfiguration(n) {
    this._modeConfiguration = n || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
}, EH = { completionItems: !0, hovers: !0, documentSymbols: !0, definitions: !0, references: !0, documentHighlights: !0, rename: !0, diagnostics: !0, documentRangeFormattingEdits: !0, signatureHelp: !0, onTypeFormattingEdits: !0, codeActions: !0, inlayHints: !0 }, n6 = new NH({ allowNonTsExtensions: !0, target: 99 }, { noSemanticValidation: !1, noSyntaxValidation: !1, onlyVisible: !1 }, {}, {}, EH), s6 = new NH({ allowNonTsExtensions: !0, allowJs: !0, target: 99 }, { noSemanticValidation: !0, noSyntaxValidation: !1, onlyVisible: !1 }, {}, {}, EH);
function qb() {
  return import("./tsMode-BKgdVKnV.js");
}
Cm.languages.typescript = { ModuleKind: SH, JsxEmit: LH, NewLineKind: kH, ScriptTarget: DH, ModuleResolutionKind: xH, typescriptVersion: "5.0.2", typescriptDefaults: n6, javascriptDefaults: s6, getTypeScriptWorker: () => qb().then(((n) => n.getTypeScriptWorker())), getJavaScriptWorker: () => qb().then(((n) => n.getJavaScriptWorker())) }, Cm.languages.onLanguage("typescript", (() => qb().then(((n) => n.setupTypeScript(n6))))), Cm.languages.onLanguage("javascript", (() => qb().then(((n) => n.setupJavaScript(s6)))));
class o6 extends cs {
  constructor() {
    super({ id: "diffEditor.toggleShowMovedCodeBlocks", title: ct(0, "Toggle Show Moved Code Blocks"), precondition: q.has("isInDiffEditor") });
  }
  run(e, ...t) {
    const i = e.get(Ye), s = !i.getValue("diffEditor.experimental.showMoves");
    i.updateValue("diffEditor.experimental.showMoves", s);
  }
}
class r6 extends cs {
  constructor() {
    super({ id: "diffEditor.toggleUseInlineViewWhenSpaceIsLimited", title: ct(0, "Toggle Use Inline View When Space Is Limited"), precondition: q.has("isInDiffEditor") });
  }
  run(e, ...t) {
    const i = e.get(Ye), s = !i.getValue("diffEditor.useInlineViewWhenSpaceIsLimited");
    i.updateValue("diffEditor.useInlineViewWhenSpaceIsLimited", s);
  }
}
const A_ = ct(0, "Diff Editor");
class tM extends cs {
  constructor() {
    super({ id: "diffEditor.revert", title: ct(0, "Revert"), f1: !1, category: A_ });
  }
  run(e, t) {
    var i;
    const s = (function(o, r, a) {
      return o.get(mt).listDiffEditors().find(((d) => {
        var h, c;
        const u = d.getModifiedEditor(), g = d.getOriginalEditor();
        return u && ((h = u.getModel()) === null || h === void 0 ? void 0 : h.uri.toString()) === a.toString() && g && ((c = g.getModel()) === null || c === void 0 ? void 0 : c.uri.toString()) === r.toString();
      })) || null;
    })(e, t.originalUri, t.modifiedUri);
    s instanceof wd && s.revertRangeMappings((i = t.mapping.innerChanges) !== null && i !== void 0 ? i : []);
  }
}
const IH = ct(0, "Accessible Diff Viewer");
class wm extends cs {
  constructor() {
    super({ id: wm.id, title: ct(0, "Go to Next Difference"), category: IH, precondition: q.has("isInDiffEditor"), keybinding: { primary: 65, weight: 100 }, f1: !0 });
  }
  run(e) {
    const t = Up(e);
    t?.accessibleDiffViewerNext();
  }
}
wm.id = "editor.action.accessibleDiffViewer.next";
class Gv extends cs {
  constructor() {
    super({ id: Gv.id, title: ct(0, "Go to Previous Difference"), category: IH, precondition: q.has("isInDiffEditor"), keybinding: { primary: 1089, weight: 100 }, f1: !0 });
  }
  run(e) {
    const t = Up(e);
    t?.accessibleDiffViewerPrev();
  }
}
function Up(n) {
  const e = n.get(mt).listDiffEditors(), t = Mn();
  if (t) {
    for (const i of e)
      if (Voe(i.getContainerDomNode(), t)) return i;
  }
  return null;
}
function Voe(n, e) {
  let t = e;
  for (; t; ) {
    if (t === n) return !0;
    t = t.parentElement;
  }
  return !1;
}
Gv.id = "editor.action.accessibleDiffViewer.prev", Ft(class extends cs {
  constructor() {
    super({ id: "diffEditor.toggleCollapseUnchangedRegions", title: ct(0, "Toggle Collapse Unchanged Regions"), icon: ne.map, toggled: q.has("config.diffEditor.hideUnchangedRegions.enabled"), precondition: q.has("isInDiffEditor"), menu: { when: q.has("isInDiffEditor"), id: x.EditorTitle, order: 22, group: "navigation" } });
  }
  run(n, ...e) {
    const t = n.get(Ye), i = !t.getValue("diffEditor.hideUnchangedRegions.enabled");
    t.updateValue("diffEditor.hideUnchangedRegions.enabled", i);
  }
}), Ft(o6), Ft(r6), tn.appendMenuItem(x.EditorTitle, { command: { id: new r6().desc.id, title: m(0, "Use Inline View When Space Is Limited"), toggled: q.has("config.diffEditor.useInlineViewWhenSpaceIsLimited"), precondition: q.has("isInDiffEditor") }, order: 11, group: "1_diff", when: q.and(E.diffEditorRenderSideBySideInlineBreakpointReached, q.has("isInDiffEditor")) }), tn.appendMenuItem(x.EditorTitle, { command: { id: new o6().desc.id, title: m(0, "Show Moved Code Blocks"), icon: ne.move, toggled: uf.create("config.diffEditor.experimental.showMoves", !0), precondition: q.has("isInDiffEditor") }, order: 10, group: "1_diff", when: q.has("isInDiffEditor") }), Ft(tM);
for (const n of [{ icon: ne.arrowRight, key: E.diffEditorInlineMode.toNegated() }, { icon: ne.discard, key: E.diffEditorInlineMode }]) tn.appendMenuItem(x.DiffEditorHunkToolbar, { command: { id: new tM().desc.id, title: m(0, "Revert Block"), icon: n.icon }, when: q.and(E.diffEditorModifiedWritable, n.key), order: 5, group: "primary" }), tn.appendMenuItem(x.DiffEditorSelectionToolbar, { command: { id: new tM().desc.id, title: m(0, "Revert Selection"), icon: n.icon }, when: q.and(E.diffEditorModifiedWritable, n.key), order: 5, group: "primary" });
Ft(class extends Qr {
  constructor() {
    super({ id: "diffEditor.switchSide", title: ct(0, "Switch Side"), icon: ne.arrowSwap, precondition: q.has("isInDiffEditor"), f1: !0, category: A_ });
  }
  runEditorCommand(n, e, t) {
    const i = Up(n);
    if (i instanceof wd) {
      if (t && t.dryRun) return { destinationSelection: i.mapToOtherSide().destinationSelection };
      i.switchSide();
    }
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "diffEditor.exitCompareMove", title: ct(0, "Exit Compare Move"), icon: ne.close, precondition: E.comparingMovedCode, f1: !1, category: A_, keybinding: { weight: 1e4, primary: 9 } });
  }
  runEditorCommand(n, e, ...t) {
    const i = Up(n);
    i instanceof wd && i.exitCompareMove();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "diffEditor.collapseAllUnchangedRegions", title: ct(0, "Collapse All Unchanged Regions"), icon: ne.fold, precondition: q.has("isInDiffEditor"), f1: !0, category: A_ });
  }
  runEditorCommand(n, e, ...t) {
    const i = Up(n);
    i instanceof wd && i.collapseAllUnchangedRegions();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "diffEditor.showAllUnchangedRegions", title: ct(0, "Show All Unchanged Regions"), icon: ne.unfold, precondition: q.has("isInDiffEditor"), f1: !0, category: A_ });
  }
  runEditorCommand(n, e, ...t) {
    const i = Up(n);
    i instanceof wd && i.showAllUnchangedRegions();
  }
}), tn.appendMenuItem(x.EditorTitle, { command: { id: wm.id, title: m(0, "Open Accessible Diff Viewer"), precondition: q.has("isInDiffEditor") }, order: 10, group: "2_diff", when: q.and(E.accessibleDiffViewerVisible.negate(), q.has("isInDiffEditor")) }), dt.registerCommandAlias("editor.action.diffReview.next", wm.id), Ft(wm), dt.registerCommandAlias("editor.action.diffReview.prev", Gv.id), Ft(Gv);
var iM, Hoe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, zoe = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const ow = new ae("selectionAnchorSet", !1);
let $l = iM = class {
  static get(n) {
    return n.getContribution(iM.ID);
  }
  constructor(n, e) {
    this.editor = n, this.selectionAnchorSetContextKey = ow.bindTo(e), this.modelChangeListener = n.onDidChangeModel((() => this.selectionAnchorSetContextKey.reset()));
  }
  setSelectionAnchor() {
    if (this.editor.hasModel()) {
      const n = this.editor.getPosition();
      this.editor.changeDecorations(((e) => {
        this.decorationId && e.removeDecoration(this.decorationId), this.decorationId = e.addDecoration(_e.fromPositions(n, n), { description: "selection-anchor", stickiness: 1, hoverMessage: new Vn().appendText(m(0, "Selection Anchor")), className: "selection-anchor" });
      })), this.selectionAnchorSetContextKey.set(!!this.decorationId), Io(m(0, "Anchor set at {0}:{1}", n.lineNumber, n.column));
    }
  }
  goToSelectionAnchor() {
    if (this.editor.hasModel() && this.decorationId) {
      const n = this.editor.getModel().getDecorationRange(this.decorationId);
      n && this.editor.setPosition(n.getStartPosition());
    }
  }
  selectFromAnchorToCursor() {
    if (this.editor.hasModel() && this.decorationId) {
      const n = this.editor.getModel().getDecorationRange(this.decorationId);
      if (n) {
        const e = this.editor.getPosition();
        this.editor.setSelection(_e.fromPositions(n.getStartPosition(), e)), this.cancelSelectionAnchor();
      }
    }
  }
  cancelSelectionAnchor() {
    if (this.decorationId) {
      const n = this.decorationId;
      this.editor.changeDecorations(((e) => {
        e.removeDecoration(n), this.decorationId = void 0;
      })), this.selectionAnchorSetContextKey.set(!1);
    }
  }
  dispose() {
    this.cancelSelectionAnchor(), this.modelChangeListener.dispose();
  }
};
$l.ID = "editor.contrib.selectionAnchorController", $l = iM = Hoe([zoe(1, Te)], $l);
ft($l.ID, $l, 4), X(class extends he {
  constructor() {
    super({ id: "editor.action.setSelectionAnchor", label: m(0, "Set Selection Anchor"), alias: "Set Selection Anchor", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2080), weight: 100 } });
  }
  async run(n, e) {
    var t;
    (t = $l.get(e)) === null || t === void 0 || t.setSelectionAnchor();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.goToSelectionAnchor", label: m(0, "Go to Selection Anchor"), alias: "Go to Selection Anchor", precondition: ow });
  }
  async run(n, e) {
    var t;
    (t = $l.get(e)) === null || t === void 0 || t.goToSelectionAnchor();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.selectFromAnchorToCursor", label: m(0, "Select from Anchor to Cursor"), alias: "Select from Anchor to Cursor", precondition: ow, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2089), weight: 100 } });
  }
  async run(n, e) {
    var t;
    (t = $l.get(e)) === null || t === void 0 || t.selectFromAnchorToCursor();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.cancelSelectionAnchor", label: m(0, "Cancel Selection Anchor"), alias: "Cancel Selection Anchor", precondition: ow, kbOpts: { kbExpr: E.editorTextFocus, primary: 9, weight: 100 } });
  }
  async run(n, e) {
    var t;
    (t = $l.get(e)) === null || t === void 0 || t.cancelSelectionAnchor();
  }
});
const Uoe = I("editorOverviewRuler.bracketMatchForeground", { dark: "#A0A0A0", light: "#A0A0A0", hcDark: "#A0A0A0", hcLight: "#A0A0A0" }, m(0, "Overview ruler marker color for matching brackets."));
class Koe {
  constructor(e, t, i) {
    this.position = e, this.brackets = t, this.options = i;
  }
}
class pr extends V {
  static get(e) {
    return e.getContribution(pr.ID);
  }
  constructor(e) {
    super(), this._editor = e, this._lastBracketsData = [], this._lastVersionId = 0, this._decorations = this._editor.createDecorationsCollection(), this._updateBracketsSoon = this._register(new Et((() => this._updateBrackets()), 50)), this._matchBrackets = this._editor.getOption(72), this._updateBracketsSoon.schedule(), this._register(e.onDidChangeCursorPosition(((t) => {
      this._matchBrackets !== "never" && this._updateBracketsSoon.schedule();
    }))), this._register(e.onDidChangeModelContent(((t) => {
      this._updateBracketsSoon.schedule();
    }))), this._register(e.onDidChangeModel(((t) => {
      this._lastBracketsData = [], this._updateBracketsSoon.schedule();
    }))), this._register(e.onDidChangeModelLanguageConfiguration(((t) => {
      this._lastBracketsData = [], this._updateBracketsSoon.schedule();
    }))), this._register(e.onDidChangeConfiguration(((t) => {
      t.hasChanged(72) && (this._matchBrackets = this._editor.getOption(72), this._decorations.clear(), this._lastBracketsData = [], this._lastVersionId = 0, this._updateBracketsSoon.schedule());
    }))), this._register(e.onDidBlurEditorWidget((() => {
      this._updateBracketsSoon.schedule();
    }))), this._register(e.onDidFocusEditorWidget((() => {
      this._updateBracketsSoon.schedule();
    })));
  }
  jumpToBracket() {
    if (!this._editor.hasModel()) return;
    const e = this._editor.getModel(), t = this._editor.getSelections().map(((i) => {
      const s = i.getStartPosition(), o = e.bracketPairs.matchBracket(s);
      let r = null;
      if (o) o[0].containsPosition(s) && !o[1].containsPosition(s) ? r = o[1].getStartPosition() : o[1].containsPosition(s) && (r = o[0].getStartPosition());
      else {
        const a = e.bracketPairs.findEnclosingBrackets(s);
        if (a) r = a[1].getStartPosition();
        else {
          const l = e.bracketPairs.findNextBracket(s);
          l && l.range && (r = l.range.getStartPosition());
        }
      }
      return r ? new _e(r.lineNumber, r.column, r.lineNumber, r.column) : new _e(s.lineNumber, s.column, s.lineNumber, s.column);
    }));
    this._editor.setSelections(t), this._editor.revealRange(t[0]);
  }
  selectToBracket(e) {
    if (!this._editor.hasModel()) return;
    const t = this._editor.getModel(), i = [];
    this._editor.getSelections().forEach(((s) => {
      const o = s.getStartPosition();
      let r = t.bracketPairs.matchBracket(o);
      if (!r && (r = t.bracketPairs.findEnclosingBrackets(o), !r)) {
        const d = t.bracketPairs.findNextBracket(o);
        d && d.range && (r = t.bracketPairs.matchBracket(d.range.getStartPosition()));
      }
      let a = null, l = null;
      if (r) {
        r.sort(D.compareRangesUsingStarts);
        const [d, h] = r;
        if (a = e ? d.getStartPosition() : d.getEndPosition(), l = e ? h.getEndPosition() : h.getStartPosition(), h.containsPosition(o)) {
          const c = a;
          a = l, l = c;
        }
      }
      a && l && i.push(new _e(a.lineNumber, a.column, l.lineNumber, l.column));
    })), i.length > 0 && (this._editor.setSelections(i), this._editor.revealRange(i[0]));
  }
  removeBrackets(e) {
    if (!this._editor.hasModel()) return;
    const t = this._editor.getModel();
    this._editor.getSelections().forEach(((i) => {
      const s = i.getPosition();
      let o = t.bracketPairs.matchBracket(s);
      o || (o = t.bracketPairs.findEnclosingBrackets(s)), o && (this._editor.pushUndoStop(), this._editor.executeEdits(e, [{ range: o[0], text: "" }, { range: o[1], text: "" }]), this._editor.pushUndoStop());
    }));
  }
  _updateBrackets() {
    if (this._matchBrackets === "never") return;
    this._recomputeBrackets();
    const e = [];
    let t = 0;
    for (const i of this._lastBracketsData) {
      const s = i.brackets;
      s && (e[t++] = { range: s[0], options: i.options }, e[t++] = { range: s[1], options: i.options });
    }
    this._decorations.set(e);
  }
  _recomputeBrackets() {
    if (!this._editor.hasModel() || !this._editor.hasWidgetFocus()) return this._lastBracketsData = [], void (this._lastVersionId = 0);
    const e = this._editor.getSelections();
    if (e.length > 100) return this._lastBracketsData = [], void (this._lastVersionId = 0);
    const t = this._editor.getModel(), i = t.getVersionId();
    let s = [];
    this._lastVersionId === i && (s = this._lastBracketsData);
    const o = [];
    let r = 0;
    for (let c = 0, u = e.length; c < u; c++) {
      const g = e[c];
      g.isEmpty() && (o[r++] = g.getStartPosition());
    }
    o.length > 1 && o.sort(W.compare);
    const a = [];
    let l = 0, d = 0;
    const h = s.length;
    for (let c = 0, u = o.length; c < u; c++) {
      const g = o[c];
      for (; d < h && s[d].position.isBefore(g); ) d++;
      if (d < h && s[d].position.equals(g)) a[l++] = s[d];
      else {
        let p = t.bracketPairs.matchBracket(g, 20), f = pr._DECORATION_OPTIONS_WITH_OVERVIEW_RULER;
        p || this._matchBrackets !== "always" || (p = t.bracketPairs.findEnclosingBrackets(g, 20), f = pr._DECORATION_OPTIONS_WITHOUT_OVERVIEW_RULER), a[l++] = new Koe(g, p, f);
      }
    }
    this._lastBracketsData = a, this._lastVersionId = i;
  }
}
pr.ID = "editor.contrib.bracketMatchingController", pr._DECORATION_OPTIONS_WITH_OVERVIEW_RULER = Ve.register({ description: "bracket-match-overview", stickiness: 1, className: "bracket-match", overviewRuler: { color: ui(Uoe), position: Do.Center } }), pr._DECORATION_OPTIONS_WITHOUT_OVERVIEW_RULER = Ve.register({ description: "bracket-match-no-overview", stickiness: 1, className: "bracket-match" }), ft(pr.ID, pr, 1), X(class extends he {
  constructor() {
    super({ id: "editor.action.selectToBracket", label: m(0, "Select to Bracket"), alias: "Select to Bracket", precondition: void 0, metadata: { description: ct(0, "Select the text inside and including the brackets or curly braces"), args: [{ name: "args", schema: { type: "object", properties: { selectBrackets: { type: "boolean", default: !0 } } } }] } });
  }
  run(n, e, t) {
    var i;
    let s = !0;
    t && t.selectBrackets === !1 && (s = !1), (i = pr.get(e)) === null || i === void 0 || i.selectToBracket(s);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.jumpToBracket", label: m(0, "Go to Bracket"), alias: "Go to Bracket", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 3165, weight: 100 } });
  }
  run(n, e) {
    var t;
    (t = pr.get(e)) === null || t === void 0 || t.jumpToBracket();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.removeBrackets", label: m(0, "Remove Brackets"), alias: "Remove Brackets", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 2561, weight: 100 } });
  }
  run(n, e) {
    var t;
    (t = pr.get(e)) === null || t === void 0 || t.removeBrackets(this.id);
  }
}), tn.appendMenuItem(x.MenubarGoMenu, { group: "5_infile_nav", command: { id: "editor.action.jumpToBracket", title: m(0, "Go to &&Bracket") }, order: 2 });
class joe {
  constructor(e, t) {
    this._selection = e, this._isMovingLeft = t;
  }
  getEditOperations(e, t) {
    if (this._selection.startLineNumber !== this._selection.endLineNumber || this._selection.isEmpty()) return;
    const i = this._selection.startLineNumber, s = this._selection.startColumn, o = this._selection.endColumn;
    if ((!this._isMovingLeft || s !== 1) && (this._isMovingLeft || o !== e.getLineMaxColumn(i))) if (this._isMovingLeft) {
      const r = new D(i, s - 1, i, s), a = e.getValueInRange(r);
      t.addEditOperation(r, null), t.addEditOperation(new D(i, o, i, o), a);
    } else {
      const r = new D(i, o, i, o + 1), a = e.getValueInRange(r);
      t.addEditOperation(r, null), t.addEditOperation(new D(i, s, i, s), a);
    }
  }
  computeCursorState(e, t) {
    return this._isMovingLeft ? new _e(this._selection.startLineNumber, this._selection.startColumn - 1, this._selection.endLineNumber, this._selection.endColumn - 1) : new _e(this._selection.startLineNumber, this._selection.startColumn + 1, this._selection.endLineNumber, this._selection.endColumn + 1);
  }
}
class a6 extends he {
  constructor(e, t) {
    super(t), this.left = e;
  }
  run(e, t) {
    if (!t.hasModel()) return;
    const i = [], s = t.getSelections();
    for (const o of s) i.push(new joe(o, this.left));
    t.pushUndoStop(), t.executeCommands(this.id, i), t.pushUndoStop();
  }
}
X(class extends a6 {
  constructor() {
    super(!0, { id: "editor.action.moveCarretLeftAction", label: m(0, "Move Selected Text Left"), alias: "Move Selected Text Left", precondition: E.writable });
  }
}), X(class extends a6 {
  constructor() {
    super(!1, { id: "editor.action.moveCarretRightAction", label: m(0, "Move Selected Text Right"), alias: "Move Selected Text Right", precondition: E.writable });
  }
});
X(class extends he {
  constructor() {
    super({ id: "editor.action.transposeLetters", label: m(0, "Transpose Letters"), alias: "Transpose Letters", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 306 }, weight: 100 } });
  }
  run(n, e) {
    if (!e.hasModel()) return;
    const t = e.getModel(), i = [], s = e.getSelections();
    for (const o of s) {
      if (!o.isEmpty()) continue;
      const r = o.startLineNumber, a = o.startColumn, l = t.getLineMaxColumn(r);
      if (r === 1 && (a === 1 || a === 2 && l === 2)) continue;
      const d = a === l ? o.getPosition() : St.rightPosition(t, o.getPosition().lineNumber, o.getPosition().column), h = St.leftPosition(t, d), c = St.leftPosition(t, h), u = t.getValueInRange(D.fromPositions(c, h)), g = t.getValueInRange(D.fromPositions(h, d)), p = D.fromPositions(c, d);
      i.push(new Dn(p, g + u));
    }
    i.length > 0 && (e.pushUndoStop(), e.executeCommands(this.id, i), e.pushUndoStop());
  }
});
const GL = (function() {
  if (typeof crypto == "object" && typeof crypto.randomUUID == "function") return crypto.randomUUID.bind(crypto);
  let n;
  n = typeof crypto == "object" && typeof crypto.getRandomValues == "function" ? crypto.getRandomValues.bind(crypto) : function(i) {
    for (let s = 0; s < i.length; s++) i[s] = Math.floor(256 * Math.random());
    return i;
  };
  const e = new Uint8Array(16), t = [];
  for (let i = 0; i < 256; i++) t.push(i.toString(16).padStart(2, "0"));
  return function() {
    n(e), e[6] = 15 & e[6] | 64, e[8] = 63 & e[8] | 128;
    let i = 0, s = "";
    return s += t[e[i++]], s += t[e[i++]], s += t[e[i++]], s += t[e[i++]], s += "-", s += t[e[i++]], s += t[e[i++]], s += "-", s += t[e[i++]], s += t[e[i++]], s += "-", s += t[e[i++]], s += t[e[i++]], s += "-", s += t[e[i++]], s += t[e[i++]], s += t[e[i++]], s += t[e[i++]], s += t[e[i++]], s += t[e[i++]], s;
  };
})();
function hP(n) {
  return { asString: async () => n, asFile: () => {
  }, value: typeof n == "string" ? n : void 0 };
}
class MH {
  constructor() {
    this._entries = /* @__PURE__ */ new Map();
  }
  get size() {
    let e = 0;
    for (const t of this._entries) e++;
    return e;
  }
  has(e) {
    return this._entries.has(this.toKey(e));
  }
  matches(e) {
    const t = [...this._entries.keys()];
    return at.some(this, (([i, s]) => s.asFile())) && t.push("files"), RH(rS(e), t);
  }
  get(e) {
    var t;
    return (t = this._entries.get(this.toKey(e))) === null || t === void 0 ? void 0 : t[0];
  }
  append(e, t) {
    const i = this._entries.get(e);
    i ? i.push(t) : this._entries.set(this.toKey(e), [t]);
  }
  replace(e, t) {
    this._entries.set(this.toKey(e), [t]);
  }
  delete(e) {
    this._entries.delete(this.toKey(e));
  }
  *[Symbol.iterator]() {
    for (const [e, t] of this._entries) for (const i of t) yield [e, i];
  }
  toKey(e) {
    return rS(e);
  }
}
function rS(n) {
  return n.toLowerCase();
}
function TH(n, e) {
  return RH(rS(n), e.map(rS));
}
function RH(n, e) {
  if (n === "*/*") return e.length > 0;
  if (e.includes(n)) return !0;
  const t = n.match(/^([a-z]+)\/([a-z]+|\*)$/i);
  if (!t) return !1;
  const [i, s, o] = t;
  return o === "*" && e.some(((r) => r.startsWith(s + "/")));
}
const ZL = Object.freeze({ create: (n) => Ad(n.map(((e) => e.toString()))).join(`\r
`), split: (n) => n.split(`\r
`), parse: (n) => ZL.split(n).filter(((e) => !e.startsWith("#"))) });
class Nt {
  constructor(e) {
    this.value = e;
  }
  equals(e) {
    return this.value === e.value;
  }
  contains(e) {
    return this.equals(e) || this.value === "" || e.value.startsWith(this.value + Nt.sep);
  }
  intersects(e) {
    return this.contains(e) || e.contains(this);
  }
  append(...e) {
    return new Nt((this.value ? [this.value, ...e] : e).join(Nt.sep));
  }
}
Nt.sep = ".", Nt.None = new Nt("@@none@@"), Nt.Empty = new Nt("");
const qoe = "CodeEditors", $oe = "CodeFiles";
li.add("workbench.contributions.dragAndDrop", new class {
}());
class Zv {
  constructor() {
  }
  static getInstance() {
    return Zv.INSTANCE;
  }
  hasData(e) {
    return e && e === this.proto;
  }
  getData(e) {
    if (this.hasData(e)) return this.data;
  }
}
function AH(n) {
  const e = new MH();
  for (const t of n.items) {
    const i = t.type;
    if (t.kind === "string") {
      const s = new Promise(((o) => t.getAsString(o)));
      e.append(i, hP(s));
    } else if (t.kind === "file") {
      const s = t.getAsFile();
      s && e.append(i, Goe(s));
    }
  }
  return e;
}
function Goe(n) {
  const e = n.path ? Ie.parse(n.path) : void 0;
  return (function(t, i, s) {
    const o = { id: GL(), name: t, uri: i, data: s };
    return { asString: async () => "", asFile: () => o, value: void 0 };
  })(n.name, e, (async () => new Uint8Array(await n.arrayBuffer())));
}
Zv.INSTANCE = new Zv();
const Zoe = Object.freeze([qoe, $oe, Iv.RESOURCES, Iv.INTERNAL_URI_LIST]);
function PH(n, e = !1) {
  const t = AH(n), i = t.get(Iv.INTERNAL_URI_LIST);
  if (i) t.replace(vi.uriList, i);
  else if (e || !t.has(vi.uriList)) {
    const s = [];
    for (const o of n.items) {
      const r = o.getAsFile();
      if (r) {
        const a = r.path;
        try {
          a ? s.push(Ie.file(a).toString()) : s.push(Ie.parse(r.name, !0).toString());
        } catch {
        }
      }
    }
    s.length && t.replace(vi.uriList, hP(ZL.create(s)));
  }
  for (const s of Zoe) t.delete(s);
  return t;
}
var cP = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Yv = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class uP {
  async provideDocumentPasteEdits(e, t, i, s, o) {
    const r = await this.getEdit(i, o);
    if (r) return { dispose() {
    }, edits: [{ insertText: r.insertText, title: r.title, kind: r.kind, handledMimeType: r.handledMimeType, yieldTo: r.yieldTo }] };
  }
  async provideDocumentOnDropEdits(e, t, i, s) {
    const o = await this.getEdit(i, s);
    return o ? [{ insertText: o.insertText, title: o.title, kind: o.kind, handledMimeType: o.handledMimeType, yieldTo: o.yieldTo }] : void 0;
  }
}
class Wd extends uP {
  constructor() {
    super(...arguments), this.kind = Wd.kind, this.dropMimeTypes = [vi.text], this.pasteMimeTypes = [vi.text];
  }
  async getEdit(e, t) {
    const i = e.get(vi.text);
    if (!i || e.has(vi.uriList)) return;
    const s = await i.asString();
    return { handledMimeType: vi.text, title: m(0, "Insert Plain Text"), insertText: s, kind: this.kind };
  }
}
Wd.id = "text", Wd.kind = new Nt("text.plain");
class OH extends uP {
  constructor() {
    super(...arguments), this.kind = new Nt("uri.absolute"), this.dropMimeTypes = [vi.uriList], this.pasteMimeTypes = [vi.uriList];
  }
  async getEdit(e, t) {
    const i = await FH(e);
    if (!i.length || t.isCancellationRequested) return;
    let s = 0;
    const o = i.map((({ uri: a, originalText: l }) => a.scheme === Ue.file ? a.fsPath : (s++, l))).join(" ");
    let r;
    return r = s > 0 ? i.length > 1 ? m(0, "Insert Uris") : m(0, "Insert Uri") : i.length > 1 ? m(0, "Insert Paths") : m(0, "Insert Path"), { handledMimeType: vi.uriList, insertText: o, title: r, kind: this.kind };
  }
}
let aS = class extends uP {
  constructor(n) {
    super(), this._workspaceContextService = n, this.kind = new Nt("uri.relative"), this.dropMimeTypes = [vi.uriList], this.pasteMimeTypes = [vi.uriList];
  }
  async getEdit(n, e) {
    const t = await FH(n);
    if (!t.length || e.isCancellationRequested) return;
    const i = ha(t.map((({ uri: s }) => {
      const o = this._workspaceContextService.getWorkspaceFolder(s);
      return o ? LX(o.uri, s) : void 0;
    })));
    return i.length ? { handledMimeType: vi.uriList, insertText: i.join(" "), title: t.length > 1 ? m(0, "Insert Relative Paths") : m(0, "Insert Relative Path"), kind: this.kind } : void 0;
  }
};
aS = cP([Yv(0, gg)], aS);
class Yoe {
  constructor() {
    this.kind = new Nt("html"), this.pasteMimeTypes = ["text/html"], this._yieldTo = [{ mimeType: vi.text }];
  }
  async provideDocumentPasteEdits(e, t, i, s, o) {
    var r;
    if (s.triggerKind !== G0.PasteAs && !(!((r = s.only) === null || r === void 0) && r.contains(this.kind))) return;
    const a = i.get("text/html"), l = await a?.asString();
    return l && !o.isCancellationRequested ? { dispose() {
    }, edits: [{ insertText: l, yieldTo: this._yieldTo, title: m(0, "Insert HTML"), kind: this.kind }] } : void 0;
  }
}
async function FH(n) {
  const e = n.get(vi.uriList);
  if (!e) return [];
  const t = await e.asString(), i = [];
  for (const s of ZL.parse(t)) try {
    i.push({ uri: Ie.parse(s), originalText: s });
  } catch {
  }
  return i;
}
let nM = class extends V {
  constructor(n, e) {
    super(), this._register(n.documentOnDropEditProvider.register("*", new Wd())), this._register(n.documentOnDropEditProvider.register("*", new OH())), this._register(n.documentOnDropEditProvider.register("*", new aS(e)));
  }
};
nM = cP([Yv(0, fe), Yv(1, gg)], nM);
let sM = class extends V {
  constructor(n, e) {
    super(), this._register(n.documentPasteEditProvider.register("*", new Wd())), this._register(n.documentPasteEditProvider.register("*", new OH())), this._register(n.documentPasteEditProvider.register("*", new aS(e))), this._register(n.documentPasteEditProvider.register("*", new Yoe()));
  }
};
sM = cP([Yv(0, fe), Yv(1, gg)], sM);
class ur {
  constructor() {
    this.value = "", this.pos = 0;
  }
  static isDigitCharacter(e) {
    return e >= 48 && e <= 57;
  }
  static isVariableCharacter(e) {
    return e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90;
  }
  text(e) {
    this.value = e, this.pos = 0;
  }
  tokenText(e) {
    return this.value.substr(e.pos, e.len);
  }
  next() {
    if (this.pos >= this.value.length) return { type: 14, pos: this.pos, len: 0 };
    const e = this.pos;
    let t, i = 0, s = this.value.charCodeAt(e);
    if (t = ur._table[s], typeof t == "number") return this.pos += 1, { type: t, pos: e, len: 1 };
    if (ur.isDigitCharacter(s)) {
      t = 8;
      do
        i += 1, s = this.value.charCodeAt(e + i);
      while (ur.isDigitCharacter(s));
      return this.pos += i, { type: t, pos: e, len: i };
    }
    if (ur.isVariableCharacter(s)) {
      t = 9;
      do
        s = this.value.charCodeAt(e + ++i);
      while (ur.isVariableCharacter(s) || ur.isDigitCharacter(s));
      return this.pos += i, { type: t, pos: e, len: i };
    }
    t = 10;
    do
      i += 1, s = this.value.charCodeAt(e + i);
    while (!isNaN(s) && ur._table[s] === void 0 && !ur.isDigitCharacter(s) && !ur.isVariableCharacter(s));
    return this.pos += i, { type: t, pos: e, len: i };
  }
}
ur._table = { 36: 0, 58: 1, 44: 2, 123: 3, 125: 4, 92: 5, 47: 6, 124: 7, 43: 11, 45: 12, 63: 13 };
class wf {
  constructor() {
    this._children = [];
  }
  appendChild(e) {
    return e instanceof hs && this._children[this._children.length - 1] instanceof hs ? this._children[this._children.length - 1].value += e.value : (e.parent = this, this._children.push(e)), this;
  }
  replace(e, t) {
    const { parent: i } = e, s = i.children.indexOf(e), o = i.children.slice(0);
    o.splice(s, 1, ...t), i._children = o, (function r(a, l) {
      for (const d of a) d.parent = l, r(d.children, d);
    })(t, i);
  }
  get children() {
    return this._children;
  }
  get rightMostDescendant() {
    return this._children.length > 0 ? this._children[this._children.length - 1].rightMostDescendant : this;
  }
  get snippet() {
    let e = this;
    for (; ; ) {
      if (!e) return;
      if (e instanceof V1) return e;
      e = e.parent;
    }
  }
  toString() {
    return this.children.reduce(((e, t) => e + t.toString()), "");
  }
  len() {
    return 0;
  }
}
class hs extends wf {
  constructor(e) {
    super(), this.value = e;
  }
  toString() {
    return this.value;
  }
  len() {
    return this.value.length;
  }
  clone() {
    return new hs(this.value);
  }
}
class BH extends wf {
}
class Wo extends BH {
  static compareByIndex(e, t) {
    return e.index === t.index ? 0 : e.isFinalTabstop ? 1 : t.isFinalTabstop || e.index < t.index ? -1 : e.index > t.index ? 1 : 0;
  }
  constructor(e) {
    super(), this.index = e;
  }
  get isFinalTabstop() {
    return this.index === 0;
  }
  get choice() {
    return this._children.length === 1 && this._children[0] instanceof yf ? this._children[0] : void 0;
  }
  clone() {
    const e = new Wo(this.index);
    return this.transform && (e.transform = this.transform.clone()), e._children = this.children.map(((t) => t.clone())), e;
  }
}
class yf extends wf {
  constructor() {
    super(...arguments), this.options = [];
  }
  appendChild(e) {
    return e instanceof hs && (e.parent = this, this.options.push(e)), this;
  }
  toString() {
    return this.options[0].value;
  }
  len() {
    return this.options[0].len();
  }
  clone() {
    const e = new yf();
    return this.options.forEach(e.appendChild, e), e;
  }
}
class gP extends wf {
  constructor() {
    super(...arguments), this.regexp = new RegExp("");
  }
  resolve(e) {
    const t = this;
    let i = !1, s = e.replace(this.regexp, (function() {
      return i = !0, t._replace(Array.prototype.slice.call(arguments, 0, -2));
    }));
    return !i && this._children.some(((o) => o instanceof jr && !!o.elseValue)) && (s = this._replace([])), s;
  }
  _replace(e) {
    let t = "";
    for (const i of this._children) if (i instanceof jr) {
      let s = e[i.index] || "";
      s = i.resolve(s), t += s;
    } else t += i.toString();
    return t;
  }
  toString() {
    return "";
  }
  clone() {
    const e = new gP();
    return e.regexp = new RegExp(this.regexp.source, (this.regexp.ignoreCase ? "i" : "") + (this.regexp.global ? "g" : "")), e._children = this.children.map(((t) => t.clone())), e;
  }
}
class jr extends wf {
  constructor(e, t, i, s) {
    super(), this.index = e, this.shorthandName = t, this.ifValue = i, this.elseValue = s;
  }
  resolve(e) {
    return this.shorthandName === "upcase" ? e ? e.toLocaleUpperCase() : "" : this.shorthandName === "downcase" ? e ? e.toLocaleLowerCase() : "" : this.shorthandName === "capitalize" ? e ? e[0].toLocaleUpperCase() + e.substr(1) : "" : this.shorthandName === "pascalcase" ? e ? this._toPascalCase(e) : "" : this.shorthandName === "camelcase" ? e ? this._toCamelCase(e) : "" : e && typeof this.ifValue == "string" ? this.ifValue : e || typeof this.elseValue != "string" ? e || "" : this.elseValue;
  }
  _toPascalCase(e) {
    const t = e.match(/[a-z0-9]+/gi);
    return t ? t.map(((i) => i.charAt(0).toUpperCase() + i.substr(1))).join("") : e;
  }
  _toCamelCase(e) {
    const t = e.match(/[a-z0-9]+/gi);
    return t ? t.map(((i, s) => s === 0 ? i.charAt(0).toLowerCase() + i.substr(1) : i.charAt(0).toUpperCase() + i.substr(1))).join("") : e;
  }
  clone() {
    return new jr(this.index, this.shorthandName, this.ifValue, this.elseValue);
  }
}
class Xv extends BH {
  constructor(e) {
    super(), this.name = e;
  }
  resolve(e) {
    let t = e.resolve(this);
    return this.transform && (t = this.transform.resolve(t || "")), t !== void 0 && (this._children = [new hs(t)], !0);
  }
  clone() {
    const e = new Xv(this.name);
    return this.transform && (e.transform = this.transform.clone()), e._children = this.children.map(((t) => t.clone())), e;
  }
}
function l6(n, e) {
  const t = [...n];
  for (; t.length > 0; ) {
    const i = t.shift();
    if (!e(i)) break;
    t.unshift(...i.children);
  }
}
class V1 extends wf {
  get placeholderInfo() {
    if (!this._placeholders) {
      const e = [];
      let t;
      this.walk((function(i) {
        return i instanceof Wo && (e.push(i), t = !t || t.index < i.index ? i : t), !0;
      })), this._placeholders = { all: e, last: t };
    }
    return this._placeholders;
  }
  get placeholders() {
    const { all: e } = this.placeholderInfo;
    return e;
  }
  offset(e) {
    let t = 0, i = !1;
    return this.walk(((s) => s === e ? (i = !0, !1) : (t += s.len(), !0))), i ? t : -1;
  }
  fullLen(e) {
    let t = 0;
    return l6([e], ((i) => (t += i.len(), !0))), t;
  }
  enclosingPlaceholders(e) {
    const t = [];
    let { parent: i } = e;
    for (; i; ) i instanceof Wo && t.push(i), i = i.parent;
    return t;
  }
  resolveVariables(e) {
    return this.walk(((t) => (t instanceof Xv && t.resolve(e) && (this._placeholders = void 0), !0))), this;
  }
  appendChild(e) {
    return this._placeholders = void 0, super.appendChild(e);
  }
  replace(e, t) {
    return this._placeholders = void 0, super.replace(e, t);
  }
  clone() {
    const e = new V1();
    return this._children = this.children.map(((t) => t.clone())), e;
  }
  walk(e) {
    l6(this.children, e);
  }
}
class bg {
  constructor() {
    this._scanner = new ur(), this._token = { type: 14, pos: 0, len: 0 };
  }
  static escape(e) {
    return e.replace(/\$|}|\\/g, "\\$&");
  }
  static guessNeedsClipboard(e) {
    return /\${?CLIPBOARD/.test(e);
  }
  parse(e, t, i) {
    const s = new V1();
    return this.parseFragment(e, s), this.ensureFinalTabstop(s, i != null && i, t != null && t), s;
  }
  parseFragment(e, t) {
    const i = t.children.length;
    for (this._scanner.text(e), this._token = this._scanner.next(); this._parse(t); ) ;
    const s = /* @__PURE__ */ new Map(), o = [];
    t.walk(((l) => (l instanceof Wo && (l.isFinalTabstop ? s.set(0, void 0) : !s.has(l.index) && l.children.length > 0 ? s.set(l.index, l.children) : o.push(l)), !0)));
    const r = (l, d) => {
      const h = s.get(l.index);
      if (!h) return;
      const c = new Wo(l.index);
      c.transform = l.transform;
      for (const u of h) {
        const g = u.clone();
        c.appendChild(g), g instanceof Wo && s.has(g.index) && !d.has(g.index) && (d.add(g.index), r(g, d), d.delete(g.index));
      }
      t.replace(l, [c]);
    }, a = /* @__PURE__ */ new Set();
    for (const l of o) r(l, a);
    return t.children.slice(i);
  }
  ensureFinalTabstop(e, t, i) {
    (t || i && e.placeholders.length > 0) && (e.placeholders.find(((s) => s.index === 0)) || e.appendChild(new Wo(0)));
  }
  _accept(e, t) {
    if (e === void 0 || this._token.type === e) {
      const i = !t || this._scanner.tokenText(this._token);
      return this._token = this._scanner.next(), i;
    }
    return !1;
  }
  _backTo(e) {
    return this._scanner.pos = e.pos + e.len, this._token = e, !1;
  }
  _until(e) {
    const t = this._token;
    for (; this._token.type !== e; ) {
      if (this._token.type === 14) return !1;
      if (this._token.type === 5) {
        const s = this._scanner.next();
        if (s.type !== 0 && s.type !== 4 && s.type !== 5) return !1;
      }
      this._token = this._scanner.next();
    }
    const i = this._scanner.value.substring(t.pos, this._token.pos).replace(/\\(\$|}|\\)/g, "$1");
    return this._token = this._scanner.next(), i;
  }
  _parse(e) {
    return this._parseEscaped(e) || this._parseTabstopOrVariableName(e) || this._parseComplexPlaceholder(e) || this._parseComplexVariable(e) || this._parseAnything(e);
  }
  _parseEscaped(e) {
    let t;
    return !!(t = this._accept(5, !0)) && (t = this._accept(0, !0) || this._accept(4, !0) || this._accept(5, !0) || t, e.appendChild(new hs(t)), !0);
  }
  _parseTabstopOrVariableName(e) {
    let t;
    const i = this._token;
    return this._accept(0) && (t = this._accept(9, !0) || this._accept(8, !0)) ? (e.appendChild(/^\d+$/.test(t) ? new Wo(Number(t)) : new Xv(t)), !0) : this._backTo(i);
  }
  _parseComplexPlaceholder(e) {
    let t;
    const i = this._token;
    if (!(this._accept(0) && this._accept(3) && (t = this._accept(8, !0)))) return this._backTo(i);
    const s = new Wo(Number(t));
    if (this._accept(1)) for (; ; ) {
      if (this._accept(4)) return e.appendChild(s), !0;
      if (!this._parse(s)) return e.appendChild(new hs("${" + t + ":")), s.children.forEach(e.appendChild, e), !0;
    }
    else {
      if (!(s.index > 0 && this._accept(7))) return this._accept(6) ? this._parseTransform(s) ? (e.appendChild(s), !0) : (this._backTo(i), !1) : this._accept(4) ? (e.appendChild(s), !0) : this._backTo(i);
      {
        const o = new yf();
        for (; ; ) {
          if (this._parseChoiceElement(o)) {
            if (this._accept(2)) continue;
            if (this._accept(7) && (s.appendChild(o), this._accept(4))) return e.appendChild(s), !0;
          }
          return this._backTo(i), !1;
        }
      }
    }
  }
  _parseChoiceElement(e) {
    const t = this._token, i = [];
    for (; this._token.type !== 2 && this._token.type !== 7; ) {
      let s;
      if (s = (s = this._accept(5, !0)) ? this._accept(2, !0) || this._accept(7, !0) || this._accept(5, !0) || s : this._accept(void 0, !0), !s) return this._backTo(t), !1;
      i.push(s);
    }
    return i.length === 0 ? (this._backTo(t), !1) : (e.appendChild(new hs(i.join(""))), !0);
  }
  _parseComplexVariable(e) {
    let t;
    const i = this._token;
    if (!(this._accept(0) && this._accept(3) && (t = this._accept(9, !0)))) return this._backTo(i);
    const s = new Xv(t);
    if (!this._accept(1)) return this._accept(6) ? this._parseTransform(s) ? (e.appendChild(s), !0) : (this._backTo(i), !1) : this._accept(4) ? (e.appendChild(s), !0) : this._backTo(i);
    for (; ; ) {
      if (this._accept(4)) return e.appendChild(s), !0;
      if (!this._parse(s)) return e.appendChild(new hs("${" + t + ":")), s.children.forEach(e.appendChild, e), !0;
    }
  }
  _parseTransform(e) {
    const t = new gP();
    let i = "", s = "";
    for (; !this._accept(6); ) {
      let o;
      if (o = this._accept(5, !0)) o = this._accept(6, !0) || o, i += o;
      else {
        if (this._token.type === 14) return !1;
        i += this._accept(void 0, !0);
      }
    }
    for (; !this._accept(6); ) {
      let o;
      if (o = this._accept(5, !0)) o = this._accept(5, !0) || this._accept(6, !0) || o, t.appendChild(new hs(o));
      else if (!this._parseFormatString(t) && !this._parseAnything(t)) return !1;
    }
    for (; !this._accept(4); ) {
      if (this._token.type === 14) return !1;
      s += this._accept(void 0, !0);
    }
    try {
      t.regexp = new RegExp(i, s);
    } catch {
      return !1;
    }
    return e.transform = t, !0;
  }
  _parseFormatString(e) {
    const t = this._token;
    if (!this._accept(0)) return !1;
    let i = !1;
    this._accept(3) && (i = !0);
    const s = this._accept(8, !0);
    if (!s) return this._backTo(t), !1;
    if (!i) return e.appendChild(new jr(Number(s))), !0;
    if (this._accept(4)) return e.appendChild(new jr(Number(s))), !0;
    if (!this._accept(1)) return this._backTo(t), !1;
    if (this._accept(6)) {
      const o = this._accept(9, !0);
      return o && this._accept(4) ? (e.appendChild(new jr(Number(s), o)), !0) : (this._backTo(t), !1);
    }
    if (this._accept(11)) {
      const o = this._until(4);
      if (o) return e.appendChild(new jr(Number(s), void 0, o, void 0)), !0;
    } else if (this._accept(12)) {
      const o = this._until(4);
      if (o) return e.appendChild(new jr(Number(s), void 0, void 0, o)), !0;
    } else if (this._accept(13)) {
      const o = this._until(1);
      if (o) {
        const r = this._until(4);
        if (r) return e.appendChild(new jr(Number(s), void 0, o, r)), !0;
      }
    } else {
      const o = this._until(4);
      if (o) return e.appendChild(new jr(Number(s), void 0, void 0, o)), !0;
    }
    return this._backTo(t), !1;
  }
  _parseAnything(e) {
    return this._token.type !== 14 && (e.appendChild(new hs(this._scanner.tokenText(this._token))), this._accept(void 0), !0);
  }
}
function WH(n, e, t) {
  var i, s, o, r;
  return (typeof t.insertText == "string" ? t.insertText === "" : t.insertText.snippet === "") ? { edits: (s = (i = t.additionalEdit) === null || i === void 0 ? void 0 : i.edits) !== null && s !== void 0 ? s : [] } : { edits: [...e.map(((a) => new ic(n, { range: a, text: typeof t.insertText == "string" ? bg.escape(t.insertText) + "$0" : t.insertText.snippet, insertAsSnippet: !0 }))), ...(r = (o = t.additionalEdit) === null || o === void 0 ? void 0 : o.edits) !== null && r !== void 0 ? r : []] };
}
function VH(n) {
  var e;
  function t(r, a) {
    return "mimeType" in r ? r.mimeType === a.handledMimeType : !!a.kind && r.kind.contains(a.kind);
  }
  const i = /* @__PURE__ */ new Map();
  for (const r of n) for (const a of (e = r.yieldTo) !== null && e !== void 0 ? e : []) for (const l of n) if (l !== r && t(a, l)) {
    let d = i.get(r);
    d || (d = [], i.set(r, d)), d.push(l);
  }
  if (!i.size) return Array.from(n);
  const s = /* @__PURE__ */ new Set(), o = [];
  return (function r(a) {
    if (!a.length) return [];
    const l = a[0];
    if (o.includes(l)) return console.warn("Yield to cycle detected", l), a;
    if (s.has(l)) return r(a.slice(1));
    let d = [];
    const h = i.get(l);
    return h && (o.push(l), d = r(h), o.pop()), s.add(l), [...d, l, ...r(a.slice(1))];
  })(Array.from(n));
}
var Xoe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Qoe = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const Joe = Ve.register({ description: "inline-progress-widget", stickiness: 1, showIfCollapsed: !0, after: { content: " ", inlineClassName: "inline-editor-progress-decoration", inlineClassNameAffectsLetterSpacing: !0 } });
class YL extends V {
  constructor(e, t, i, s, o) {
    super(), this.typeId = e, this.editor = t, this.range = i, this.delegate = o, this.allowEditorOverflow = !1, this.suppressMouseDown = !0, this.create(s), this.editor.addContentWidget(this), this.editor.layoutContentWidget(this);
  }
  create(e) {
    this.domNode = Q(".inline-progress-widget"), this.domNode.role = "button", this.domNode.title = e;
    const t = Q("span.icon");
    this.domNode.append(t), t.classList.add(...Ee.asClassNameArray(ne.loading), "codicon-modifier-spin");
    const i = () => {
      const s = this.editor.getOption(67);
      this.domNode.style.height = `${s}px`, this.domNode.style.width = `${Math.ceil(0.8 * s)}px`;
    };
    i(), this._register(this.editor.onDidChangeConfiguration(((s) => {
      (s.hasChanged(52) || s.hasChanged(67)) && i();
    }))), this._register(K(this.domNode, ie.CLICK, ((s) => {
      this.delegate.cancel();
    })));
  }
  getId() {
    return YL.baseId + "." + this.typeId;
  }
  getDomNode() {
    return this.domNode;
  }
  getPosition() {
    return { position: { lineNumber: this.range.startLineNumber, column: this.range.startColumn }, preference: [0] };
  }
  dispose() {
    super.dispose(), this.editor.removeContentWidget(this);
  }
}
YL.baseId = "editor.widget.inlineProgressWidget";
let lS = class extends V {
  constructor(n, e, t) {
    super(), this.id = n, this._editor = e, this._instantiationService = t, this._showDelay = 500, this._showPromise = this._register(new rn()), this._currentWidget = new rn(), this._operationIdPool = 0, this._currentDecorations = e.createDecorationsCollection();
  }
  async showWhile(n, e, t) {
    const i = this._operationIdPool++;
    this._currentOperation = i, this.clear(), this._showPromise.value = bc((() => {
      const s = D.fromPositions(n);
      this._currentDecorations.set([{ range: s, options: Joe }]).length > 0 && (this._currentWidget.value = this._instantiationService.createInstance(YL, this.id, this._editor, s, e, t));
    }), this._showDelay);
    try {
      return await t;
    } finally {
      this._currentOperation === i && (this.clear(), this._currentOperation = void 0);
    }
  }
  clear() {
    this._showPromise.clear(), this._currentDecorations.clear(), this._currentWidget.clear();
  }
};
lS = Xoe([Qoe(2, Se)], lS);
var rw, ere = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, d6 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let bs = rw = class {
  static get(n) {
    return n.getContribution(rw.ID);
  }
  constructor(n, e, t) {
    this._openerService = t, this._messageWidget = new rn(), this._messageListeners = new G(), this._mouseOverMessage = !1, this._editor = n, this._visible = rw.MESSAGE_VISIBLE.bindTo(e);
  }
  dispose() {
    var n;
    (n = this._message) === null || n === void 0 || n.dispose(), this._messageListeners.dispose(), this._messageWidget.dispose(), this._visible.reset();
  }
  showMessage(n, e) {
    let t;
    Io(da(n) ? n.value : n), this._visible.set(!0), this._messageWidget.clear(), this._messageListeners.clear(), this._message = da(n) ? vL(n, { actionHandler: { callback: (i) => {
      this.closeMessage(), LA(this._openerService, i, da(n) ? n.isTrusted : void 0);
    }, disposables: this._messageListeners } }) : void 0, this._messageWidget.value = new h6(this._editor, e, typeof n == "string" ? n : this._message.element), this._messageListeners.add(se.debounce(this._editor.onDidBlurEditorText, ((i, s) => s), 0)((() => {
      this._mouseOverMessage || this._messageWidget.value && gn(Mn(), this._messageWidget.value.getDomNode()) || this.closeMessage();
    }))), this._messageListeners.add(this._editor.onDidChangeCursorPosition((() => this.closeMessage()))), this._messageListeners.add(this._editor.onDidDispose((() => this.closeMessage()))), this._messageListeners.add(this._editor.onDidChangeModel((() => this.closeMessage()))), this._messageListeners.add(K(this._messageWidget.value.getDomNode(), ie.MOUSE_ENTER, (() => this._mouseOverMessage = !0), !0)), this._messageListeners.add(K(this._messageWidget.value.getDomNode(), ie.MOUSE_LEAVE, (() => this._mouseOverMessage = !1), !0)), this._messageListeners.add(this._editor.onMouseMove(((i) => {
      i.target.position && (t ? t.containsPosition(i.target.position) || this.closeMessage() : t = new D(e.lineNumber - 3, 1, i.target.position.lineNumber + 3, 1));
    })));
  }
  closeMessage() {
    this._visible.reset(), this._messageListeners.clear(), this._messageWidget.value && this._messageListeners.add(h6.fadeOut(this._messageWidget.value));
  }
};
bs.ID = "editor.contrib.messageController", bs.MESSAGE_VISIBLE = new ae("messageVisible", !1, m(0, "Whether the editor is currently showing an inline message")), bs = rw = ere([d6(1, Te), d6(2, Fs)], bs);
re(new (Zi.bindToContribution(bs.get))({ id: "leaveEditorMessage", precondition: bs.MESSAGE_VISIBLE, handler: (n) => n.closeMessage(), kbOpts: { weight: 130, primary: 9 } }));
let h6 = class {
  static fadeOut(n) {
    const e = () => {
      n.dispose(), clearTimeout(t), n.getDomNode().removeEventListener("animationend", e);
    }, t = setTimeout(e, 110);
    return n.getDomNode().addEventListener("animationend", e), n.getDomNode().classList.add("fadeOut"), { dispose: e };
  }
  constructor(n, { lineNumber: e, column: t }, i) {
    this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this._editor = n, this._editor.revealLinesInCenterIfOutsideViewport(e, e, 0), this._position = { lineNumber: e, column: t }, this._domNode = document.createElement("div"), this._domNode.classList.add("monaco-editor-overlaymessage"), this._domNode.style.marginLeft = "-6px";
    const s = document.createElement("div");
    s.classList.add("anchor", "top"), this._domNode.appendChild(s);
    const o = document.createElement("div");
    typeof i == "string" ? (o.classList.add("message"), o.textContent = i) : (i.classList.add("message"), o.appendChild(i)), this._domNode.appendChild(o);
    const r = document.createElement("div");
    r.classList.add("anchor", "below"), this._domNode.appendChild(r), this._editor.addContentWidget(this), this._domNode.classList.add("fadeIn");
  }
  dispose() {
    this._editor.removeContentWidget(this);
  }
  getId() {
    return "messageoverlay";
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return { position: this._position, preference: [1, 2], positionAffinity: 1 };
  }
  afterRender(n) {
    this._domNode.classList.toggle("below", n === 2);
  }
};
ft(bs.ID, bs, 4);
var oM, HH = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, y0 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let aw = oM = class extends V {
  constructor(n, e, t, i, s, o, r, a, l, d) {
    super(), this.typeId = n, this.editor = e, this.showCommand = i, this.range = s, this.edits = o, this.onSelectNewEdit = r, this._contextMenuService = a, this._keybindingService = d, this.allowEditorOverflow = !0, this.suppressMouseDown = !0, this.create(), this.visibleContext = t.bindTo(l), this.visibleContext.set(!0), this._register(ye((() => this.visibleContext.reset()))), this.editor.addContentWidget(this), this.editor.layoutContentWidget(this), this._register(ye((() => this.editor.removeContentWidget(this)))), this._register(this.editor.onDidChangeCursorPosition(((h) => {
      s.containsPosition(h.position) || this.dispose();
    }))), this._register(se.runAndSubscribe(d.onDidUpdateKeybindings, (() => {
      this._updateButtonTitle();
    })));
  }
  _updateButtonTitle() {
    var n;
    const e = (n = this._keybindingService.lookupKeybinding(this.showCommand.id)) === null || n === void 0 ? void 0 : n.getLabel();
    this.button.element.title = this.showCommand.label + (e ? ` (${e})` : "");
  }
  create() {
    this.domNode = Q(".post-edit-widget"), this.button = this._register(new Xy(this.domNode, { supportIcons: !0 })), this.button.label = "$(insert)", this._register(K(this.domNode, ie.CLICK, (() => this.showSelector())));
  }
  getId() {
    return oM.baseId + "." + this.typeId;
  }
  getDomNode() {
    return this.domNode;
  }
  getPosition() {
    return { position: this.range.getEndPosition(), preference: [2] };
  }
  showSelector() {
    this._contextMenuService.showContextMenu({ getAnchor: () => {
      const n = Ti(this.button.element);
      return { x: n.left + n.width, y: n.top + n.height };
    }, getActions: () => this.edits.allEdits.map(((n, e) => Yp({ id: "", label: n.title, checked: e === this.edits.activeEditIndex, run: () => {
      if (e !== this.edits.activeEditIndex) return this.onSelectNewEdit(e);
    } }))) });
  }
};
aw.baseId = "editor.widget.postEditWidget", aw = oM = HH([y0(7, io), y0(8, Te), y0(9, Dt)], aw);
let dS = class extends V {
  constructor(n, e, t, i, s, o) {
    super(), this._id = n, this._editor = e, this._visibleContext = t, this._showCommand = i, this._instantiationService = s, this._bulkEditService = o, this._currentWidget = this._register(new rn()), this._register(se.any(e.onDidChangeModel, e.onDidChangeModelContent)((() => this.clear())));
  }
  async applyEditAndShowIfNeeded(n, e, t, i, s) {
    const o = this._editor.getModel();
    if (!o || !n.length) return;
    const r = e.allEdits.at(e.activeEditIndex);
    if (!r) return;
    const a = await i(r, s), l = WH(o.uri, n, a), d = n[0], h = o.deltaDecorations([], [{ range: d, options: { description: "paste-line-suffix", stickiness: 0 } }]);
    let c, u;
    try {
      c = await this._bulkEditService.apply(l, { editor: this._editor, token: s }), u = o.getDecorationRange(h[0]);
    } finally {
      o.deltaDecorations(h, []);
    }
    t && c.isApplied && e.allEdits.length > 1 && this.show(u ?? d, e, (async (g) => {
      const p = this._editor.getModel();
      p && (await p.undo(), this.applyEditAndShowIfNeeded(n, { activeEditIndex: g, allEdits: e.allEdits }, t, i, s));
    }));
  }
  show(n, e, t) {
    this.clear(), this._editor.hasModel() && (this._currentWidget.value = this._instantiationService.createInstance(aw, this._id, this._editor, this._visibleContext, this._showCommand, n, e, t));
  }
  clear() {
    this._currentWidget.clear();
  }
  tryShowSelector() {
    var n;
    (n = this._currentWidget.value) === null || n === void 0 || n.showSelector();
  }
};
dS = HH([y0(4, Se), y0(5, M1)], dS);
var lu, tre = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Qg = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const zH = "editor.changePasteType", rM = new ae("pasteWidgetVisible", !1, m(0, "Whether the paste widget is showing")), px = "application/vnd.code.copyMetadata";
let za = lu = class extends V {
  static get(n) {
    return n.getContribution(lu.ID);
  }
  constructor(n, e, t, i, s, o, r) {
    super(), this._bulkEditService = t, this._clipboardService = i, this._languageFeaturesService = s, this._quickInputService = o, this._progressService = r, this._editor = n;
    const a = n.getContainerDomNode();
    this._register(K(a, "copy", ((l) => this.handleCopy(l)))), this._register(K(a, "cut", ((l) => this.handleCopy(l)))), this._register(K(a, "paste", ((l) => this.handlePaste(l)), !0)), this._pasteProgressManager = this._register(new lS("pasteIntoEditor", n, e)), this._postPasteWidgetManager = this._register(e.createInstance(dS, "pasteIntoEditor", n, rM, { id: zH, label: m(0, "Show paste options...") }));
  }
  changePasteType() {
    this._postPasteWidgetManager.tryShowSelector();
  }
  pasteAs(n) {
    this._editor.focus();
    try {
      this._pasteAsActionContext = { preferred: n }, cf().execCommand("paste");
    } finally {
      this._pasteAsActionContext = void 0;
    }
  }
  clearWidgets() {
    this._postPasteWidgetManager.clear();
  }
  isPasteAsEnabled() {
    return this._editor.getOption(85).enabled && !this._editor.getOption(91);
  }
  async finishedPaste() {
    await this._currentPasteOperation;
  }
  handleCopy(n) {
    var e, t;
    if (!this._editor.hasTextFocus() || (gc && this._clipboardService.writeResources([]), !n.clipboardData || !this.isPasteAsEnabled())) return;
    const i = this._editor.getModel(), s = this._editor.getSelections();
    if (!i || !s?.length) return;
    const o = this._editor.getOption(37);
    let r = s;
    const a = s.length === 1 && s[0].isEmpty();
    if (a) {
      if (!o) return;
      r = [new D(r[0].startLineNumber, 1, r[0].startLineNumber, 1 + i.getLineLength(r[0].startLineNumber))];
    }
    const l = (e = this._editor._getViewModel()) === null || e === void 0 ? void 0 : e.getPlainTextToCopy(s, o, Tn), d = { multicursorText: Array.isArray(l) ? l : null, pasteOnNewLine: a, mode: null }, h = this._languageFeaturesService.documentPasteEditProvider.ordered(i).filter(((f) => !!f.prepareDocumentPaste));
    if (!h.length) return void this.setCopyMetadata(n.clipboardData, { defaultPastePayload: d });
    const c = AH(n.clipboardData), u = h.flatMap(((f) => {
      var _;
      return (_ = f.copyMimeTypes) !== null && _ !== void 0 ? _ : [];
    })), g = GL();
    this.setCopyMetadata(n.clipboardData, { id: g, providerCopyMimeTypes: u, defaultPastePayload: d });
    const p = on((async (f) => {
      const _ = ha(await Promise.all(h.map((async (v) => {
        try {
          return await v.prepareDocumentPaste(i, r, c, f);
        } catch (b) {
          return void console.error(b);
        }
      }))));
      _.reverse();
      for (const v of _) for (const [b, C] of v) c.replace(b, C);
      return c;
    }));
    (t = lu._currentCopyOperation) === null || t === void 0 || t.dataTransferPromise.cancel(), lu._currentCopyOperation = { handle: g, dataTransferPromise: p };
  }
  async handlePaste(n) {
    var e, t, i, s;
    if (!n.clipboardData || !this._editor.hasTextFocus()) return;
    (e = bs.get(this._editor)) === null || e === void 0 || e.closeMessage(), (t = this._currentPasteOperation) === null || t === void 0 || t.cancel(), this._currentPasteOperation = void 0;
    const o = this._editor.getModel(), r = this._editor.getSelections();
    if (!r?.length || !o || !this.isPasteAsEnabled() && !this._pasteAsActionContext) return;
    const a = this.fetchCopyMetadata(n), l = PH(n.clipboardData);
    l.delete(px);
    const d = [...n.clipboardData.types, ...(i = a?.providerCopyMimeTypes) !== null && i !== void 0 ? i : [], vi.uriList], h = this._languageFeaturesService.documentPasteEditProvider.ordered(o).filter(((c) => {
      var u, g;
      const p = (u = this._pasteAsActionContext) === null || u === void 0 ? void 0 : u.preferred;
      return !(p && c.providedPasteEditKinds && !this.providerMatchesPreference(c, p)) && ((g = c.pasteMimeTypes) === null || g === void 0 ? void 0 : g.some(((f) => TH(f, d))));
    }));
    h.length ? (n.preventDefault(), n.stopImmediatePropagation(), this._pasteAsActionContext ? this.showPasteAsPick(this._pasteAsActionContext.preferred, h, r, l, a) : this.doPasteInline(h, r, l, a, n)) : !((s = this._pasteAsActionContext) === null || s === void 0) && s.preferred && this.showPasteAsNoEditMessage(r, this._pasteAsActionContext.preferred);
  }
  showPasteAsNoEditMessage(n, e) {
    var t;
    (t = bs.get(this._editor)) === null || t === void 0 || t.showMessage(m(0, "No paste edits for '{0}' found", e instanceof Nt ? e.value : e.providerId), n[0].getStartPosition());
  }
  doPasteInline(n, e, t, i, s) {
    const o = on((async (r) => {
      const a = this._editor;
      if (!a.hasModel()) return;
      const l = a.getModel(), d = new Ic(a, 3, void 0, r);
      try {
        if (await this.mergeInDataFromCopy(t, i, d.token), d.token.isCancellationRequested) return;
        const h = n.filter(((g) => this.isSupportedPasteProvider(g, t)));
        if (!h.length || h.length === 1 && h[0] instanceof Wd) return this.applyDefaultPasteHandler(t, i, d.token, s);
        const c = { triggerKind: G0.Automatic }, u = await this.getPasteEdits(h, t, l, e, c, d.token);
        if (d.token.isCancellationRequested) return;
        if (u.length === 1 && u[0].provider instanceof Wd) return this.applyDefaultPasteHandler(t, i, d.token, s);
        if (u.length) {
          const g = a.getOption(85).showPasteSelector === "afterPaste";
          return this._postPasteWidgetManager.applyEditAndShowIfNeeded(e, { activeEditIndex: 0, allEdits: u }, g, (async (p, f) => {
            var _, v;
            const b = await ((v = (_ = p.provider).resolveDocumentPasteEdit) === null || v === void 0 ? void 0 : v.call(_, p, f));
            return b && (p.additionalEdit = b.additionalEdit), p;
          }), d.token);
        }
        await this.applyDefaultPasteHandler(t, i, d.token, s);
      } finally {
        d.dispose(), this._currentPasteOperation === o && (this._currentPasteOperation = void 0);
      }
    }));
    this._pasteProgressManager.showWhile(e[0].getEndPosition(), m(0, "Running paste handlers. Click to cancel"), o), this._currentPasteOperation = o;
  }
  showPasteAsPick(n, e, t, i, s) {
    const o = on((async (r) => {
      const a = this._editor;
      if (!a.hasModel()) return;
      const l = a.getModel(), d = new Ic(a, 3, void 0, r);
      try {
        if (await this.mergeInDataFromCopy(i, s, d.token), d.token.isCancellationRequested) return;
        let h = e.filter(((f) => this.isSupportedPasteProvider(f, i, n)));
        n && (h = h.filter(((f) => this.providerMatchesPreference(f, n))));
        const c = { triggerKind: G0.PasteAs, only: n && n instanceof Nt ? n : void 0 };
        let u, g = await this.getPasteEdits(h, i, l, t, c, d.token);
        if (d.token.isCancellationRequested) return;
        if (n && (g = g.filter(((f) => n instanceof Nt ? n.contains(f.kind) : n.providerId === f.provider.id))), !g.length) return void (c.only && this.showPasteAsNoEditMessage(t, c.only));
        if (n) u = g.at(0);
        else {
          const f = await this._quickInputService.pick(g.map(((_) => {
            var v;
            return { label: _.title, description: (v = _.kind) === null || v === void 0 ? void 0 : v.value, edit: _ };
          })), { placeHolder: m(0, "Select Paste Action") });
          u = f?.edit;
        }
        if (!u) return;
        const p = WH(l.uri, t, u);
        await this._bulkEditService.apply(p, { editor: this._editor });
      } finally {
        d.dispose(), this._currentPasteOperation === o && (this._currentPasteOperation = void 0);
      }
    }));
    this._progressService.withProgress({ location: 10, title: m(0, "Running paste handlers") }, (() => o));
  }
  setCopyMetadata(n, e) {
    n.setData(px, JSON.stringify(e));
  }
  fetchCopyMetadata(n) {
    var e;
    if (!n.clipboardData) return;
    const t = n.clipboardData.getData(px);
    if (t) try {
      return JSON.parse(t);
    } catch {
      return;
    }
    const [i, s] = eI.getTextData(n.clipboardData);
    return s ? { defaultPastePayload: { mode: s.mode, multicursorText: (e = s.multicursorText) !== null && e !== void 0 ? e : null, pasteOnNewLine: !!s.isFromEmptySelection } } : void 0;
  }
  async mergeInDataFromCopy(n, e, t) {
    var i;
    if (e?.id && ((i = lu._currentCopyOperation) === null || i === void 0 ? void 0 : i.handle) === e.id) {
      const s = await lu._currentCopyOperation.dataTransferPromise;
      if (t.isCancellationRequested) return;
      for (const [o, r] of s) n.replace(o, r);
    }
    if (!n.has(vi.uriList)) {
      const s = await this._clipboardService.readResources();
      if (t.isCancellationRequested) return;
      s.length && n.append(vi.uriList, hP(ZL.create(s)));
    }
  }
  async getPasteEdits(n, e, t, i, s, o) {
    const r = await f1(Promise.all(n.map((async (a) => {
      var l, d;
      try {
        const h = await ((l = a.provideDocumentPasteEdits) === null || l === void 0 ? void 0 : l.call(a, t, i, e, s, o));
        return (d = h?.edits) === null || d === void 0 ? void 0 : d.map(((c) => ({ ...c, provider: a })));
      } catch (h) {
        console.error(h);
      }
    }))), o);
    return VH(ha(r ?? []).flat().filter(((a) => !s.only || s.only.contains(a.kind))));
  }
  async applyDefaultPasteHandler(n, e, t, i) {
    var s, o, r, a;
    const l = (s = n.get(vi.text)) !== null && s !== void 0 ? s : n.get("text"), d = (o = await l?.asString()) !== null && o !== void 0 ? o : "";
    if (t.isCancellationRequested) return;
    const h = { clipboardEvent: i, text: d, pasteOnNewLine: (r = e?.defaultPastePayload.pasteOnNewLine) !== null && r !== void 0 && r, multicursorText: (a = e?.defaultPastePayload.multicursorText) !== null && a !== void 0 ? a : null, mode: null };
    this._editor.trigger("keyboard", "paste", h);
  }
  isSupportedPasteProvider(n, e, t) {
    var i;
    return !!(!((i = n.pasteMimeTypes) === null || i === void 0) && i.some(((s) => e.matches(s)))) && (!t || this.providerMatchesPreference(n, t));
  }
  providerMatchesPreference(n, e) {
    return e instanceof Nt ? !n.providedPasteEditKinds || n.providedPasteEditKinds.some(((t) => e.contains(t))) : n.id === e.providerId;
  }
};
za.ID = "editor.contrib.copyPasteActionController", za = lu = tre([Qg(1, Se), Qg(2, M1), Qg(3, Kd), Qg(4, fe), Qg(5, Sa), Qg(6, FW)], za);
const Cg = "9_cutcopypaste", ire = ml || document.queryCommandSupported("cut"), UH = ml || document.queryCommandSupported("copy"), nre = navigator.clipboard !== void 0 && !tr || document.queryCommandSupported("paste");
function pP(n) {
  return n.register(), n;
}
const sre = ire ? pP(new gf({ id: "editor.action.clipboardCutAction", precondition: void 0, kbOpts: ml ? { primary: 2102, win: { primary: 2102, secondary: [1044] }, weight: 100 } : void 0, menuOpts: [{ menuId: x.MenubarEditMenu, group: "2_ccp", title: m(0, "Cu&&t"), order: 1 }, { menuId: x.EditorContext, group: Cg, title: m(0, "Cut"), when: E.writable, order: 1 }, { menuId: x.CommandPalette, group: "", title: m(0, "Cut"), order: 1 }, { menuId: x.SimpleEditorContext, group: Cg, title: m(0, "Cut"), when: E.writable, order: 1 }] })) : void 0, ore = UH ? pP(new gf({ id: "editor.action.clipboardCopyAction", precondition: void 0, kbOpts: ml ? { primary: 2081, win: { primary: 2081, secondary: [2067] }, weight: 100 } : void 0, menuOpts: [{ menuId: x.MenubarEditMenu, group: "2_ccp", title: m(0, "&&Copy"), order: 2 }, { menuId: x.EditorContext, group: Cg, title: m(0, "Copy"), order: 2 }, { menuId: x.CommandPalette, group: "", title: m(0, "Copy"), order: 1 }, { menuId: x.SimpleEditorContext, group: Cg, title: m(0, "Copy"), order: 2 }] })) : void 0;
tn.appendMenuItem(x.MenubarEditMenu, { submenu: x.MenubarCopy, title: ct(0, "Copy As"), group: "2_ccp", order: 3 }), tn.appendMenuItem(x.EditorContext, { submenu: x.EditorContextCopy, title: ct(0, "Copy As"), group: Cg, order: 3 }), tn.appendMenuItem(x.EditorContext, { submenu: x.EditorContextShare, title: ct(0, "Share"), group: "11_share", order: -1, when: q.and(q.notEquals("resourceScheme", "output"), E.editorTextFocus) }), tn.appendMenuItem(x.EditorTitleContext, { submenu: x.EditorTitleContextShare, title: ct(0, "Share"), group: "11_share", order: -1 }), tn.appendMenuItem(x.ExplorerContext, { submenu: x.ExplorerContextShare, title: ct(0, "Share"), group: "11_share", order: -1 });
const mx = nre ? pP(new gf({ id: "editor.action.clipboardPasteAction", precondition: void 0, kbOpts: ml ? { primary: 2100, win: { primary: 2100, secondary: [1043] }, linux: { primary: 2100, secondary: [1043] }, weight: 100 } : void 0, menuOpts: [{ menuId: x.MenubarEditMenu, group: "2_ccp", title: m(0, "&&Paste"), order: 4 }, { menuId: x.EditorContext, group: Cg, title: m(0, "Paste"), when: E.writable, order: 4 }, { menuId: x.CommandPalette, group: "", title: m(0, "Paste"), order: 1 }, { menuId: x.SimpleEditorContext, group: Cg, title: m(0, "Paste"), when: E.writable, order: 4 }] })) : void 0;
class rre extends he {
  constructor() {
    super({ id: "editor.action.clipboardCopyWithSyntaxHighlightingAction", label: m(0, "Copy With Syntax Highlighting"), alias: "Copy With Syntax Highlighting", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 0, weight: 100 } });
  }
  run(e, t) {
    t.hasModel() && (!t.getOption(37) && t.getSelection().isEmpty() || (QE.forceCopyWithSyntaxHighlighting = !0, t.focus(), t.getContainerDomNode().ownerDocument.execCommand("copy"), QE.forceCopyWithSyntaxHighlighting = !1));
  }
}
function c6(n, e) {
  n && (n.addImplementation(1e4, "code-editor", ((t, i) => {
    const s = t.get(mt).getFocusedCodeEditor();
    if (s && s.hasTextFocus()) {
      const o = s.getOption(37), r = s.getSelection();
      return r && r.isEmpty() && !o || s.getContainerDomNode().ownerDocument.execCommand(e), !0;
    }
    return !1;
  })), n.addImplementation(0, "generic-dom", ((t, i) => (cf().execCommand(e), !0))));
}
c6(sre, "cut"), c6(ore, "copy"), mx && (mx.addImplementation(1e4, "code-editor", ((n, e) => {
  var t, i;
  const s = n.get(mt), o = n.get(Kd), r = s.getFocusedCodeEditor();
  return r && r.hasTextFocus() ? r.getContainerDomNode().ownerDocument.execCommand("paste") ? (i = (t = za.get(r)) === null || t === void 0 ? void 0 : t.finishedPaste()) !== null && i !== void 0 ? i : Promise.resolve() : !gc || (async () => {
    const a = await o.readText();
    if (a !== "") {
      const l = mv.INSTANCE.get(a);
      let d = !1, h = null, c = null;
      l && (d = r.getOption(37) && !!l.isFromEmptySelection, h = l.multicursorText !== void 0 ? l.multicursorText : null, c = l.mode), r.trigger("keyboard", "paste", { text: a, pasteOnNewLine: d, multicursorText: h, mode: c });
    }
  })() : !1;
})), mx.addImplementation(0, "generic-dom", ((n, e) => (cf().execCommand("paste"), !0)))), UH && X(rre);
const ti = new class {
  constructor() {
    this.QuickFix = new Nt("quickfix"), this.Refactor = new Nt("refactor"), this.RefactorExtract = this.Refactor.append("extract"), this.RefactorInline = this.Refactor.append("inline"), this.RefactorMove = this.Refactor.append("move"), this.RefactorRewrite = this.Refactor.append("rewrite"), this.Notebook = new Nt("notebook"), this.Source = new Nt("source"), this.SourceOrganizeImports = this.Source.append("organizeImports"), this.SourceFixAll = this.Source.append("fixAll"), this.SurroundWith = this.Refactor.append("surround");
  }
}();
var qs;
function u6(n, e, t) {
  return !!e.contains(n) && (!t || !e.contains(t));
}
(function(n) {
  n.Refactor = "refactor", n.RefactorPreview = "refactor preview", n.Lightbulb = "lightbulb", n.Default = "other (default)", n.SourceAction = "source action", n.QuickFix = "quick fix action", n.FixAll = "fix all", n.OrganizeImports = "organize imports", n.AutoFix = "auto fix", n.QuickFixHover = "quick fix hover window", n.OnSave = "save participants", n.ProblemsView = "problems view";
})(qs || (qs = {}));
class el {
  static fromUser(e, t) {
    return e && typeof e == "object" ? new el(el.getKindFromUser(e, t.kind), el.getApplyFromUser(e, t.apply), el.getPreferredUser(e)) : new el(t.kind, t.apply, !1);
  }
  static getApplyFromUser(e, t) {
    switch (typeof e.apply == "string" ? e.apply.toLowerCase() : "") {
      case "first":
        return "first";
      case "never":
        return "never";
      case "ifsingle":
        return "ifSingle";
      default:
        return t;
    }
  }
  static getKindFromUser(e, t) {
    return typeof e.kind == "string" ? new Nt(e.kind) : t;
  }
  static getPreferredUser(e) {
    return typeof e.preferred == "boolean" && e.preferred;
  }
  constructor(e, t, i) {
    this.kind = e, this.apply = t, this.preferred = i;
  }
}
class are {
  constructor(e, t, i) {
    this.action = e, this.provider = t, this.highlightRange = i;
  }
  async resolve(e) {
    var t;
    if (!((t = this.provider) === null || t === void 0) && t.resolveCodeAction && !this.action.edit) {
      let i;
      try {
        i = await this.provider.resolveCodeAction(this.action, e);
      } catch (s) {
        Ni(s);
      }
      i && (this.action.edit = i.edit);
    }
    return this;
  }
}
const KH = "editor.action.codeAction", mP = "editor.action.quickFix", jH = "editor.action.autoFix", qH = "editor.action.refactor", $H = "editor.action.sourceAction", fP = "editor.action.organizeImports", _P = "editor.action.fixAll";
class S0 extends V {
  static codeActionsPreferredComparator(e, t) {
    return e.isPreferred && !t.isPreferred ? -1 : !e.isPreferred && t.isPreferred ? 1 : 0;
  }
  static codeActionsComparator({ action: e }, { action: t }) {
    return e.isAI && !t.isAI ? 1 : !e.isAI && t.isAI ? -1 : zn(e.diagnostics) ? zn(t.diagnostics) ? S0.codeActionsPreferredComparator(e, t) : -1 : zn(t.diagnostics) ? 1 : S0.codeActionsPreferredComparator(e, t);
  }
  constructor(e, t, i) {
    super(), this.documentation = t, this._register(i), this.allActions = [...e].sort(S0.codeActionsComparator), this.validActions = this.allActions.filter((({ action: s }) => !s.disabled));
  }
  get hasAutoFix() {
    return this.validActions.some((({ action: e }) => !!e.kind && ti.QuickFix.contains(new Nt(e.kind)) && !!e.isPreferred));
  }
  get hasAIFix() {
    return this.validActions.some((({ action: e }) => !!e.isAI));
  }
  get allAIFixes() {
    return this.validActions.every((({ action: e }) => !!e.isAI));
  }
}
const g6 = { actions: [], documentation: void 0 };
async function L0(n, e, t, i, s, o) {
  var r;
  const a = i.filter || {}, l = { ...a, excludes: [...a.excludes || [], ti.Notebook] }, d = { only: (r = a.include) === null || r === void 0 ? void 0 : r.value, trigger: i.type }, h = new sP(e, o), c = i.type === 2, u = (function(_, v, b) {
    return _.all(v).filter(((C) => !C.providedCodeActionKinds || C.providedCodeActionKinds.some(((w) => (function(y, L) {
      return !(y.include && !y.include.intersects(L) || y.excludes && y.excludes.some(((k) => u6(L, k, y.include))) || !y.includeSourceActions && ti.Source.contains(L));
    })(b, new Nt(w))))));
  })(n, e, c ? l : a), g = new G(), p = u.map((async (_) => {
    try {
      s.report(_);
      const v = await _.provideCodeActions(e, t, d, h.token);
      if (v && g.add(v), h.token.isCancellationRequested) return g6;
      const b = (v?.actions || []).filter(((w) => w && (function(y, L) {
        const k = L.kind ? new Nt(L.kind) : void 0;
        return !(!(!y.include || k && y.include.contains(k)) || y.excludes && k && y.excludes.some(((N) => u6(k, N, y.include))) || !y.includeSourceActions && k && ti.Source.contains(k) || y.onlyIncludePreferredActions && !L.isPreferred);
      })(a, w))), C = (function(w, y, L) {
        if (!w.documentation) return;
        const k = w.documentation.map(((N) => ({ kind: new Nt(N.kind), command: N.command })));
        if (L) {
          let N;
          for (const A of k) A.kind.contains(L) && (N ? N.kind.contains(A.kind) && (N = A) : N = A);
          if (N) return N?.command;
        }
        for (const N of y) if (N.kind) {
          for (const A of k) if (A.kind.contains(new Nt(N.kind))) return A.command;
        }
      })(_, b, a.include);
      return { actions: b.map(((w) => new are(w, _))), documentation: C };
    } catch (v) {
      if (ya(v)) throw v;
      return Ni(v), g6;
    }
  })), f = n.onDidChange((() => {
    ri(n.all(e), u) || h.cancel();
  }));
  try {
    const _ = await Promise.all(p), v = _.map(((C) => C.actions)).flat(), b = [...ha(_.map(((C) => C.documentation))), ...lre(n, e, i, v)];
    return new S0(v, b, g);
  } finally {
    f.dispose(), h.dispose();
  }
}
function* lre(n, e, t, i) {
  var s, o, r;
  if (e && i.length) for (const a of n.all(e)) a._getAdditionalMenuItems && (yield* (s = a._getAdditionalMenuItems) === null || s === void 0 ? void 0 : s.call(a, { trigger: t.type, only: (r = (o = t.filter) === null || o === void 0 ? void 0 : o.include) === null || r === void 0 ? void 0 : r.value }, i.map(((l) => l.action))));
}
var ym;
async function dre(n, e, t, i, s = et.None) {
  var o;
  const r = n.get(M1), a = n.get(ai), l = n.get(es), d = n.get(Ri);
  if (l.publicLog2("codeAction.applyCodeAction", { codeActionTitle: e.action.title, codeActionKind: e.action.kind, codeActionIsPreferred: !!e.action.isPreferred, reason: t }), await e.resolve(s), !s.isCancellationRequested) {
    if (!((o = e.action.edit) === null || o === void 0) && o.edits.length && !(await r.apply(e.action.edit, { editor: i?.editor, label: e.action.title, quotableLabel: e.action.title, code: "undoredo.codeAction", respectAutoSaveConfig: t !== ym.OnSave, showPreview: i?.preview })).isApplied)
      return;
    if (e.action.command) try {
      await a.executeCommand(e.action.command.id, ...e.action.command.arguments || []);
    } catch (h) {
      const c = (function(u) {
        return typeof u == "string" ? u : u instanceof Error && typeof u.message == "string" ? u.message : void 0;
      })(h);
      d.error(typeof c == "string" ? c : m(0, "An unknown error occurred while applying the code action"));
    }
  }
}
(function(n) {
  n.OnSave = "onSave", n.FromProblemsView = "fromProblemsView", n.FromCodeActions = "fromCodeActions", n.FromAILightbulb = "fromAILightbulb";
})(ym || (ym = {})), dt.registerCommand("_executeCodeActionProvider", (async function(n, e, t, i, s) {
  if (!(e instanceof Ie)) throw Yo();
  const { codeActionProvider: o } = n.get(fe), r = n.get(ni).getModel(e);
  if (!r) throw Yo();
  const a = _e.isISelection(t) ? _e.liftSelection(t) : D.isIRange(t) ? r.validateRange(t) : void 0;
  if (!a) throw Yo();
  const l = typeof i == "string" ? new Nt(i) : void 0, d = await L0(o, r, a, { type: 1, triggerAction: qs.Default, filter: { includeSourceActions: !0, include: l } }, Nd.None, et.None), h = [], c = Math.min(d.validActions.length, typeof s == "number" ? s : 0);
  for (let u = 0; u < c; u++) h.push(d.validActions[u].resolve(et.None));
  try {
    return await Promise.all(h), d.validActions.map(((u) => u.action));
  } finally {
    setTimeout((() => d.dispose()), 100);
  }
}));
var aM, hre = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, cre = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let lw = aM = class {
  constructor(n) {
    this.keybindingService = n;
  }
  getResolver() {
    const n = new ua((() => this.keybindingService.getKeybindings().filter(((e) => aM.codeActionCommands.indexOf(e.command) >= 0)).filter(((e) => e.resolvedKeybinding)).map(((e) => {
      let t = e.commandArgs;
      return e.command === fP ? t = { kind: ti.SourceOrganizeImports.value } : e.command === _P && (t = { kind: ti.SourceFixAll.value }), { resolvedKeybinding: e.resolvedKeybinding, ...el.fromUser(t, { kind: Nt.None, apply: "never" }) };
    }))));
    return (e) => {
      if (e.kind) {
        const t = this.bestKeybindingForCodeAction(e, n.value);
        return t?.resolvedKeybinding;
      }
    };
  }
  bestKeybindingForCodeAction(n, e) {
    if (!n.kind) return;
    const t = new Nt(n.kind);
    return e.filter(((i) => i.kind.contains(t))).filter(((i) => !i.preferred || n.isPreferred)).reduceRight(((i, s) => i ? i.kind.contains(s.kind) ? s : i : s), void 0);
  }
};
lw.codeActionCommands = [qH, KH, $H, fP, _P], lw = aM = hre([cre(0, Dt)], lw), I("symbolIcon.arrayForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for array symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.booleanForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for boolean symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.classForeground", { dark: "#EE9D28", light: "#D67E00", hcDark: "#EE9D28", hcLight: "#D67E00" }, m(0, "The foreground color for class symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.colorForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for color symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.constantForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for constant symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.constructorForeground", { dark: "#B180D7", light: "#652D90", hcDark: "#B180D7", hcLight: "#652D90" }, m(0, "The foreground color for constructor symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.enumeratorForeground", { dark: "#EE9D28", light: "#D67E00", hcDark: "#EE9D28", hcLight: "#D67E00" }, m(0, "The foreground color for enumerator symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.enumeratorMemberForeground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, m(0, "The foreground color for enumerator member symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.eventForeground", { dark: "#EE9D28", light: "#D67E00", hcDark: "#EE9D28", hcLight: "#D67E00" }, m(0, "The foreground color for event symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.fieldForeground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, m(0, "The foreground color for field symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.fileForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for file symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.folderForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for folder symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.functionForeground", { dark: "#B180D7", light: "#652D90", hcDark: "#B180D7", hcLight: "#652D90" }, m(0, "The foreground color for function symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.interfaceForeground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, m(0, "The foreground color for interface symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.keyForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for key symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.keywordForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for keyword symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.methodForeground", { dark: "#B180D7", light: "#652D90", hcDark: "#B180D7", hcLight: "#652D90" }, m(0, "The foreground color for method symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.moduleForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for module symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.namespaceForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for namespace symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.nullForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for null symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.numberForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for number symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.objectForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for object symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.operatorForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for operator symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.packageForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for package symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.propertyForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for property symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.referenceForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for reference symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.snippetForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for snippet symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.stringForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for string symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.structForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for struct symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.textForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for text symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.typeParameterForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for type parameter symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.unitForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for unit symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.variableForeground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, m(0, "The foreground color for variable symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const GH = Object.freeze({ kind: Nt.Empty, title: m(0, "More Actions...") }), ure = Object.freeze([{ kind: ti.QuickFix, title: m(0, "Quick Fix") }, { kind: ti.RefactorExtract, title: m(0, "Extract"), icon: ne.wrench }, { kind: ti.RefactorInline, title: m(0, "Inline"), icon: ne.wrench }, { kind: ti.RefactorRewrite, title: m(0, "Rewrite"), icon: ne.wrench }, { kind: ti.RefactorMove, title: m(0, "Move"), icon: ne.wrench }, { kind: ti.SurroundWith, title: m(0, "Surround With"), icon: ne.surroundWith }, { kind: ti.Source, title: m(0, "Source Action"), icon: ne.symbolFile }, GH]);
var lM, Kp, gre = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, p6 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
(function(n) {
  n.Hidden = { type: 0 }, n.Showing = class {
    constructor(e, t, i, s) {
      this.actions = e, this.trigger = t, this.editorPosition = i, this.widgetPosition = s, this.type = 1;
    }
  };
})(Kp || (Kp = {}));
let Ou = lM = class extends V {
  constructor(n, e, t) {
    super(), this._editor = n, this._keybindingService = e, this._onClick = this._register(new F()), this.onClick = this._onClick.event, this._state = Kp.Hidden, this._iconClasses = [], this._domNode = Q("div.lightBulbWidget"), this._register(Bt.ignoreTarget(this._domNode)), this._editor.addContentWidget(this), this._register(this._editor.onDidChangeModelContent(((i) => {
      const s = this._editor.getModel();
      (this.state.type !== 1 || !s || this.state.editorPosition.lineNumber >= s.getLineCount()) && this.hide();
    }))), this._register(rj(this._domNode, ((i) => {
      if (this.state.type !== 1) return;
      this._editor.focus(), i.preventDefault();
      const { top: s, height: o } = Ti(this._domNode), r = this._editor.getOption(67);
      let a = Math.floor(r / 3);
      this.state.widgetPosition.position !== null && this.state.widgetPosition.position.lineNumber < this.state.editorPosition.lineNumber && (a += r), this._onClick.fire({ x: i.posx, y: s + o + a, actions: this.state.actions, trigger: this.state.trigger });
    }))), this._register(K(this._domNode, "mouseenter", ((i) => {
      1 & ~i.buttons || this.hide();
    }))), this._register(se.runAndSubscribe(this._keybindingService.onDidUpdateKeybindings, (() => {
      var i, s, o, r;
      this._preferredKbLabel = (s = (i = this._keybindingService.lookupKeybinding(jH)) === null || i === void 0 ? void 0 : i.getLabel()) !== null && s !== void 0 ? s : void 0, this._quickFixKbLabel = (r = (o = this._keybindingService.lookupKeybinding(mP)) === null || o === void 0 ? void 0 : o.getLabel()) !== null && r !== void 0 ? r : void 0, this._updateLightBulbTitleAndIcon();
    })));
  }
  dispose() {
    super.dispose(), this._editor.removeContentWidget(this);
  }
  getId() {
    return "LightBulbWidget";
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return this._state.type === 1 ? this._state.widgetPosition : null;
  }
  update(n, e, t) {
    if (n.validActions.length <= 0) return this.hide();
    if (!this._editor.getOptions().get(65).enabled) return this.hide();
    const i = this._editor.getModel();
    if (!i) return this.hide();
    const { lineNumber: s, column: o } = i.validatePosition(t), r = i.getOptions().tabSize, a = this._editor.getOptions().get(50), l = hL(i.getLineContent(s), r), d = (u) => u > 2 && this._editor.getTopForLineNumber(u) === this._editor.getTopForLineNumber(u - 1);
    let h = s, c = 1;
    if (!(a.spaceWidth * l > 22)) {
      if (s > 1 && !d(s - 1)) h -= 1;
      else if (s < i.getLineCount() && !d(s + 1)) h += 1;
      else if (o * a.spaceWidth < 22) return this.hide();
      c = /^\S\s*$/.test(i.getLineContent(h)) ? 2 : 1;
    }
    this.state = new Kp.Showing(n, e, t, { position: { lineNumber: h, column: c }, preference: lM._posPref }), this._editor.layoutContentWidget(this);
  }
  hide() {
    this.state !== Kp.Hidden && (this.state = Kp.Hidden, this._editor.layoutContentWidget(this));
  }
  get state() {
    return this._state;
  }
  set state(n) {
    this._state = n, this._updateLightBulbTitleAndIcon();
  }
  _updateLightBulbTitleAndIcon() {
    if (this._domNode.classList.remove(...this._iconClasses), this._iconClasses = [], this.state.type !== 1) return;
    let n, e = !1;
    this.state.actions.allAIFixes ? (n = ne.sparkleFilled, this.state.actions.validActions.length === 1 && (e = !0)) : n = this.state.actions.hasAutoFix ? this.state.actions.hasAIFix ? ne.lightbulbSparkleAutofix : ne.lightbulbAutofix : this.state.actions.hasAIFix ? ne.lightbulbSparkle : ne.lightBulb, this._updateLightbulbTitle(this.state.actions.hasAutoFix, e), this._iconClasses = Ee.asClassNameArray(n), this._domNode.classList.add(...this._iconClasses);
  }
  _updateLightbulbTitle(n, e) {
    this.state.type === 1 && (e ? this.title = m(0, "Run: {0}", this.state.actions.validActions[0].action.title) : n && this._preferredKbLabel ? this.title = m(0, "Show Code Actions. Preferred Quick Fix Available ({0})", this._preferredKbLabel) : !n && this._quickFixKbLabel ? this.title = m(0, "Show Code Actions ({0})", this._quickFixKbLabel) : n || (this.title = m(0, "Show Code Actions")));
  }
  set title(n) {
    this._domNode.title = n;
  }
};
Ou.ID = "editor.contrib.lightbulbWidget", Ou._posPref = [0], Ou = lM = gre([p6(1, Dt), p6(2, ai)], Ou);
var ZH = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, dM = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const YH = "acceptSelectedCodeAction", XH = "previewSelectedCodeAction";
class pre {
  get templateId() {
    return "header";
  }
  renderTemplate(e) {
    e.classList.add("group-header");
    const t = document.createElement("span");
    return e.append(t), { container: e, text: t };
  }
  renderElement(e, t, i) {
    var s, o;
    i.text.textContent = (o = (s = e.group) === null || s === void 0 ? void 0 : s.title) !== null && o !== void 0 ? o : "";
  }
  disposeTemplate(e) {
  }
}
let hM = class {
  get templateId() {
    return "action";
  }
  constructor(n, e) {
    this._supportsPreview = n, this._keybindingService = e;
  }
  renderTemplate(n) {
    n.classList.add(this.templateId);
    const e = document.createElement("div");
    e.className = "icon", n.append(e);
    const t = document.createElement("span");
    return t.className = "title", n.append(t), { container: n, icon: e, text: t, keybinding: new Cf(n, Gs) };
  }
  renderElement(n, e, t) {
    var i, s, o;
    if (!((i = n.group) === null || i === void 0) && i.icon ? (t.icon.className = Ee.asClassName(n.group.icon), n.group.icon.color && (t.icon.style.color = de(n.group.icon.color.id))) : (t.icon.className = Ee.asClassName(ne.lightBulb), t.icon.style.color = "var(--vscode-editorLightBulb-foreground)"), !n.item || !n.label) return;
    t.text.textContent = QH(n.label), t.keybinding.set(n.keybinding), (function(l, ...d) {
      l ? bo(...d) : Ts(...d);
    })(!!n.keybinding, t.keybinding.element);
    const r = (s = this._keybindingService.lookupKeybinding(YH)) === null || s === void 0 ? void 0 : s.getLabel(), a = (o = this._keybindingService.lookupKeybinding(XH)) === null || o === void 0 ? void 0 : o.getLabel();
    t.container.classList.toggle("option-disabled", n.disabled), n.disabled ? t.container.title = n.label : r && a ? this._supportsPreview && n.canPreview ? t.container.title = m(0, "{0} to Apply, {1} to Preview", r, a) : t.container.title = m(0, "{0} to Apply", r) : t.container.title = "";
  }
  disposeTemplate(n) {
    n.keybinding.dispose();
  }
};
hM = ZH([dM(1, Dt)], hM);
class mre extends UIEvent {
  constructor() {
    super("acceptSelectedAction");
  }
}
class m6 extends UIEvent {
  constructor() {
    super("previewSelectedAction");
  }
}
function fre(n) {
  if (n.kind === "action") return n.label;
}
let cM = class extends V {
  constructor(n, e, t, i, s, o) {
    super(), this._delegate = i, this._contextViewService = s, this._keybindingService = o, this._actionLineHeight = 24, this._headerLineHeight = 26, this.cts = this._register(new Ci()), this.domNode = document.createElement("div"), this.domNode.classList.add("actionList");
    const r = { getHeight: (a) => a.kind === "header" ? this._headerLineHeight : this._actionLineHeight, getTemplateId: (a) => a.kind };
    this._list = this._register(new uo(n, this.domNode, r, [new hM(e, this._keybindingService), new pre()], { keyboardSupport: !1, typeNavigationEnabled: !0, keyboardNavigationLabelProvider: { getKeyboardNavigationLabel: fre }, accessibilityProvider: { getAriaLabel: (a) => {
      if (a.kind === "action") {
        let l = a.label ? QH(a?.label) : "";
        return a.disabled && (l = m(0, "{0}, Disabled Reason: {1}", l, a.disabled)), l;
      }
      return null;
    }, getWidgetAriaLabel: () => m(0, "Action Widget"), getRole: (a) => a.kind === "action" ? "option" : "separator", getWidgetRole: () => "listbox" } })), this._list.style(Ig), this._register(this._list.onMouseClick(((a) => this.onListClick(a)))), this._register(this._list.onMouseOver(((a) => this.onListHover(a)))), this._register(this._list.onDidChangeFocus((() => this.onFocus()))), this._register(this._list.onDidChangeSelection(((a) => this.onListSelection(a)))), this._allMenuItems = t, this._list.splice(0, this._list.length, this._allMenuItems), this._list.length && this.focusNext();
  }
  focusCondition(n) {
    return !n.disabled && n.kind === "action";
  }
  hide(n) {
    this._delegate.onHide(n), this.cts.cancel(), this._contextViewService.hideContextView();
  }
  layout(n) {
    const e = this._allMenuItems.filter(((o) => o.kind === "header")).length, t = this._allMenuItems.length * this._actionLineHeight + e * this._headerLineHeight - e * this._actionLineHeight;
    this._list.layout(t);
    let i = n;
    if (this._allMenuItems.length >= 50) i = 380;
    else {
      const o = this._allMenuItems.map(((r, a) => {
        const l = this.domNode.ownerDocument.getElementById(this._list.getElementID(a));
        if (l) {
          l.style.width = "auto";
          const d = l.getBoundingClientRect().width;
          return l.style.width = "", d;
        }
        return 0;
      }));
      i = Math.max(...o, n);
    }
    const s = Math.min(t, 0.7 * this.domNode.ownerDocument.body.clientHeight);
    return this._list.layout(s, i), this.domNode.style.height = `${s}px`, this._list.domFocus(), i;
  }
  focusPrevious() {
    this._list.focusPrevious(1, !0, void 0, this.focusCondition);
  }
  focusNext() {
    this._list.focusNext(1, !0, void 0, this.focusCondition);
  }
  acceptSelected(n) {
    const e = this._list.getFocus();
    if (e.length === 0) return;
    const t = e[0], i = this._list.element(t);
    if (!this.focusCondition(i)) return;
    const s = n ? new m6() : new mre();
    this._list.setSelection([t], s);
  }
  onListSelection(n) {
    if (!n.elements.length) return;
    const e = n.elements[0];
    e.item && this.focusCondition(e) ? this._delegate.onSelect(e.item, n.browserEvent instanceof m6) : this._list.setSelection([]);
  }
  onFocus() {
    var n, e;
    const t = this._list.getFocus();
    if (t.length === 0) return;
    const i = t[0], s = this._list.element(i);
    (e = (n = this._delegate).onFocus) === null || e === void 0 || e.call(n, s.item);
  }
  async onListHover(n) {
    const e = n.element;
    if (e && e.item && this.focusCondition(e)) {
      if (this._delegate.onHover && !e.disabled && e.kind === "action") {
        const t = await this._delegate.onHover(e.item, this.cts.token);
        e.canPreview = t ? t.canPreview : void 0;
      }
      n.index && this._list.splice(n.index, 1, [e]);
    }
    this._list.setFocus(typeof n.index == "number" ? [n.index] : []);
  }
  onListClick(n) {
    n.element && this.focusCondition(n.element) && this._list.setFocus([]);
  }
};
function QH(n) {
  return n.replace(/\r\n|\r|\n/g, " ");
}
cM = ZH([dM(4, zd), dM(5, Dt)], cM);
var _re = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, fx = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
I("actionBar.toggledBackground", { dark: Eu, light: Eu, hcDark: Eu, hcLight: Eu }, m(0, "Background color for toggled action items in action bar."));
const Su = { Visible: new ae("codeActionMenuVisible", !1, m(0, "Whether the action widget list is visible")) }, Lu = tt("actionWidgetService");
let Fu = class extends V {
  get isVisible() {
    return Su.Visible.getValue(this._contextKeyService) || !1;
  }
  constructor(n, e, t) {
    super(), this._contextViewService = n, this._contextKeyService = e, this._instantiationService = t, this._list = this._register(new rn());
  }
  show(n, e, t, i, s, o, r) {
    const a = Su.Visible.bindTo(this._contextKeyService), l = this._instantiationService.createInstance(cM, n, e, t, i);
    this._contextViewService.showContextView({ getAnchor: () => s, render: (d) => (a.set(!0), this._renderWidget(d, l, r ?? [])), onHide: (d) => {
      a.reset(), this._onWidgetClosed(d);
    } }, o, !1);
  }
  acceptSelected(n) {
    var e;
    (e = this._list.value) === null || e === void 0 || e.acceptSelected(n);
  }
  focusPrevious() {
    var n, e;
    (e = (n = this._list) === null || n === void 0 ? void 0 : n.value) === null || e === void 0 || e.focusPrevious();
  }
  focusNext() {
    var n, e;
    (e = (n = this._list) === null || n === void 0 ? void 0 : n.value) === null || e === void 0 || e.focusNext();
  }
  hide() {
    var n;
    (n = this._list.value) === null || n === void 0 || n.hide(), this._list.clear();
  }
  _renderWidget(n, e, t) {
    var i;
    const s = document.createElement("div");
    if (s.classList.add("action-widget"), n.appendChild(s), this._list.value = e, !this._list.value) throw new Error("List has no value");
    s.appendChild(this._list.value.domNode);
    const o = new G(), r = document.createElement("div"), a = n.appendChild(r);
    a.classList.add("context-view-block"), o.add(K(a, ie.MOUSE_DOWN, ((g) => g.stopPropagation())));
    const l = document.createElement("div"), d = n.appendChild(l);
    d.classList.add("context-view-pointerBlock"), o.add(K(d, ie.POINTER_MOVE, (() => d.remove()))), o.add(K(d, ie.MOUSE_DOWN, (() => d.remove())));
    let h = 0;
    if (t.length) {
      const g = this._createActionBar(".action-widget-action-bar", t);
      g && (s.appendChild(g.getContainer().parentElement), o.add(g), h = g.getContainer().offsetWidth);
    }
    const c = (i = this._list.value) === null || i === void 0 ? void 0 : i.layout(h);
    s.style.width = `${c}px`;
    const u = o.add(pa(n));
    return o.add(u.onDidBlur((() => this.hide()))), o;
  }
  _createActionBar(n, e) {
    if (!e.length) return;
    const t = Q(n), i = new sr(t);
    return i.push(e, { icon: !1, label: !0 }), i;
  }
  _onWidgetClosed(n) {
    var e;
    (e = this._list.value) === null || e === void 0 || e.hide(n);
  }
};
Fu = _re([fx(0, zd), fx(1, Te), fx(2, Se)], Fu), rt(Lu, Fu, 1);
const Zf = 1100;
Ft(class extends cs {
  constructor() {
    super({ id: "hideCodeActionWidget", title: ct(0, "Hide action widget"), precondition: Su.Visible, keybinding: { weight: Zf, primary: 9, secondary: [1033] } });
  }
  run(n) {
    n.get(Lu).hide();
  }
}), Ft(class extends cs {
  constructor() {
    super({ id: "selectPrevCodeAction", title: ct(0, "Select previous action"), precondition: Su.Visible, keybinding: { weight: Zf, primary: 16, secondary: [2064], mac: { primary: 16, secondary: [2064, 302] } } });
  }
  run(n) {
    const e = n.get(Lu);
    e instanceof Fu && e.focusPrevious();
  }
}), Ft(class extends cs {
  constructor() {
    super({ id: "selectNextCodeAction", title: ct(0, "Select next action"), precondition: Su.Visible, keybinding: { weight: Zf, primary: 18, secondary: [2066], mac: { primary: 18, secondary: [2066, 300] } } });
  }
  run(n) {
    const e = n.get(Lu);
    e instanceof Fu && e.focusNext();
  }
}), Ft(class extends cs {
  constructor() {
    super({ id: YH, title: ct(0, "Accept selected action"), precondition: Su.Visible, keybinding: { weight: Zf, primary: 3, secondary: [2137] } });
  }
  run(n) {
    const e = n.get(Lu);
    e instanceof Fu && e.acceptSelected();
  }
}), Ft(class extends cs {
  constructor() {
    super({ id: XH, title: ct(0, "Preview selected action"), precondition: Su.Visible, keybinding: { weight: Zf, primary: 2051 } });
  }
  run(n) {
    const e = n.get(Lu);
    e instanceof Fu && e.acceptSelected(!0);
  }
});
const JH = new ae("supportedCodeAction", ""), f6 = "_typescript.applyFixAllCodeAction";
class vre extends V {
  constructor(e, t, i, s = 250) {
    super(), this._editor = e, this._markerService = t, this._signalChange = i, this._delay = s, this._autoTriggerTimer = this._register(new Dr()), this._register(this._markerService.onMarkerChanged(((o) => this._onMarkerChanges(o)))), this._register(this._editor.onDidChangeCursorPosition((() => this._tryAutoTrigger())));
  }
  trigger(e) {
    const t = this._getRangeOfSelectionUnlessWhitespaceEnclosed(e);
    this._signalChange(t ? { trigger: e, selection: t } : void 0);
  }
  _onMarkerChanges(e) {
    const t = this._editor.getModel();
    t && e.some(((i) => XR(i, t.uri))) && this._tryAutoTrigger();
  }
  _tryAutoTrigger() {
    this._autoTriggerTimer.cancelAndSet((() => {
      this.trigger({ type: 2, triggerAction: qs.Default });
    }), this._delay);
  }
  _getRangeOfSelectionUnlessWhitespaceEnclosed(e) {
    if (!this._editor.hasModel()) return;
    const t = this._editor.getSelection();
    if (e.type === 1) return t;
    const i = this._editor.getOption(65).enabled;
    if (i !== mr.Off) {
      if (i === mr.On) return t;
      if (i === mr.OnCode) {
        if (!t.isEmpty()) return t;
        const s = this._editor.getModel(), { lineNumber: o, column: r } = t.getPosition(), a = s.getLineContent(o);
        if (a.length === 0) return;
        if (r === 1) {
          if (/\s/.test(a[0])) return;
        } else if (r === s.getLineMaxColumn(o)) {
          if (/\s/.test(a[a.length - 1])) return;
        } else if (/\s/.test(a[r - 2]) && /\s/.test(a[r - 1])) return;
      }
      return t;
    }
  }
}
var ku;
(function(n) {
  n.Empty = { type: 0 }, n.Triggered = class {
    constructor(e, t, i) {
      this.trigger = e, this.position = t, this._cancellablePromise = i, this.type = 1, this.actions = i.catch(((s) => {
        if (ya(s)) return ez;
        throw s;
      }));
    }
    cancel() {
      this._cancellablePromise.cancel();
    }
  };
})(ku || (ku = {}));
const ez = Object.freeze({ allActions: [], validActions: [], dispose: () => {
}, documentation: [], hasAutoFix: !1, hasAIFix: !1, allAIFixes: !1 });
class bre extends V {
  constructor(e, t, i, s, o, r) {
    super(), this._editor = e, this._registry = t, this._markerService = i, this._progressService = o, this._configurationService = r, this._codeActionOracle = this._register(new rn()), this._state = ku.Empty, this._onDidChangeState = this._register(new F()), this.onDidChangeState = this._onDidChangeState.event, this._disposed = !1, this._supportedCodeActions = JH.bindTo(s), this._register(this._editor.onDidChangeModel((() => this._update()))), this._register(this._editor.onDidChangeModelLanguage((() => this._update()))), this._register(this._registry.onDidChange((() => this._update()))), this._register(this._editor.onDidChangeConfiguration(((a) => {
      a.hasChanged(65) && this._update();
    }))), this._update();
  }
  dispose() {
    this._disposed || (this._disposed = !0, super.dispose(), this.setState(ku.Empty, !0));
  }
  _settingEnabledNearbyQuickfixes() {
    var e;
    const t = (e = this._editor) === null || e === void 0 ? void 0 : e.getModel();
    return !!this._configurationService && this._configurationService.getValue("editor.codeActionWidget.includeNearbyQuickFixes", { resource: t?.uri });
  }
  _update() {
    if (this._disposed) return;
    this._codeActionOracle.value = void 0, this.setState(ku.Empty);
    const e = this._editor.getModel();
    if (e && this._registry.has(e) && !this._editor.getOption(91)) {
      const t = this._registry.all(e).flatMap(((i) => {
        var s;
        return (s = i.providedCodeActionKinds) !== null && s !== void 0 ? s : [];
      }));
      this._supportedCodeActions.set(t.join(" ")), this._codeActionOracle.value = new vre(this._editor, this._markerService, ((i) => {
        var s;
        if (!i) return void this.setState(ku.Empty);
        const o = i.selection.getStartPosition(), r = on((async (d) => {
          var h, c, u, g, p, f, _, v, b, C;
          if (this._settingEnabledNearbyQuickfixes() && i.trigger.type === 1 && (i.trigger.triggerAction === qs.QuickFix || !((c = (h = i.trigger.filter) === null || h === void 0 ? void 0 : h.include) === null || c === void 0) && c.contains(ti.QuickFix))) {
            const w = await L0(this._registry, e, i.selection, i.trigger, Nd.None, d), y = [...w.allActions];
            if (d.isCancellationRequested) return ez;
            const L = (u = w.validActions) === null || u === void 0 ? void 0 : u.some(((N) => !!N.action.kind && ti.QuickFix.contains(new Nt(N.action.kind)))), k = this._markerService.read({ resource: e.uri });
            if (L) {
              for (const N of w.validActions) !((p = (g = N.action.command) === null || g === void 0 ? void 0 : g.arguments) === null || p === void 0) && p.some(((A) => typeof A == "string" && A.includes(f6))) && (N.action.diagnostics = [...k.filter(((A) => A.relatedInformation))]);
              return { validActions: w.validActions, allActions: y, documentation: w.documentation, hasAutoFix: w.hasAutoFix, hasAIFix: w.hasAIFix, allAIFixes: w.allAIFixes, dispose: () => {
                w.dispose();
              } };
            }
            if (!L && k.length > 0) {
              const N = i.selection.getPosition();
              let A = N, B = Number.MAX_VALUE;
              const T = [...w.validActions];
              for (const H of k) {
                const $ = H.endColumn, pe = H.endLineNumber, me = H.startLineNumber;
                if (pe === N.lineNumber || me === N.lineNumber) {
                  A = new W(pe, $);
                  const ue = { type: i.trigger.type, triggerAction: i.trigger.triggerAction, filter: { include: !((f = i.trigger.filter) === null || f === void 0) && f.include ? (_ = i.trigger.filter) === null || _ === void 0 ? void 0 : _.include : ti.QuickFix }, autoApply: i.trigger.autoApply, context: { notAvailableMessage: ((v = i.trigger.context) === null || v === void 0 ? void 0 : v.notAvailableMessage) || "", position: A } }, ee = new _e(A.lineNumber, A.column, A.lineNumber, A.column), te = await L0(this._registry, e, ee, ue, Nd.None, d);
                  if (te.validActions.length !== 0) {
                    for (const be of te.validActions) !((C = (b = be.action.command) === null || b === void 0 ? void 0 : b.arguments) === null || C === void 0) && C.some(((we) => typeof we == "string" && we.includes(f6))) && (be.action.diagnostics = [...k.filter(((we) => we.relatedInformation))]);
                    w.allActions.length === 0 && y.push(...te.allActions), Math.abs(N.column - $) < B ? T.unshift(...te.validActions) : T.push(...te.validActions);
                  }
                  B = Math.abs(N.column - $);
                }
              }
              const O = T.filter(((H, $, pe) => pe.findIndex(((me) => me.action.title === H.action.title)) === $));
              return O.sort(((H, $) => H.action.isPreferred && !$.action.isPreferred ? -1 : !H.action.isPreferred && $.action.isPreferred || H.action.isAI && !$.action.isAI ? 1 : !H.action.isAI && $.action.isAI ? -1 : 0)), { validActions: O, allActions: y, documentation: w.documentation, hasAutoFix: w.hasAutoFix, hasAIFix: w.hasAIFix, allAIFixes: w.allAIFixes, dispose: () => {
                w.dispose();
              } };
            }
          }
          return L0(this._registry, e, i.selection, i.trigger, Nd.None, d);
        }));
        i.trigger.type === 1 && ((s = this._progressService) === null || s === void 0 || s.showWhile(r, 250));
        const a = new ku.Triggered(i.trigger, o, r);
        let l = !1;
        this._state.type === 1 && (l = this._state.trigger.type === 1 && a.type === 1 && a.trigger.type === 2 && this._state.position !== a.position), l || this.setState(a);
      }), void 0), this._codeActionOracle.value.trigger({ type: 2, triggerAction: qs.Default });
    } else this._supportedCodeActions.reset();
  }
  trigger(e) {
    var t;
    (t = this._codeActionOracle.value) === null || t === void 0 || t.trigger(e);
  }
  setState(e, t) {
    e !== this._state && (this._state.type === 1 && this._state.cancel(), this._state = e, t || this._disposed || this._onDidChangeState.fire(e));
  }
}
var mp, Cre = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Tl = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let zh = mp = class extends V {
  static get(n) {
    return n.getContribution(mp.ID);
  }
  constructor(n, e, t, i, s, o, r, a, l, d) {
    super(), this._commandService = r, this._configurationService = a, this._actionWidgetService = l, this._instantiationService = d, this._activeCodeActions = this._register(new rn()), this._showDisabled = !1, this._disposed = !1, this._editor = n, this._model = this._register(new bre(this._editor, s.codeActionProvider, e, t, o, a)), this._register(this._model.onDidChangeState(((h) => this.update(h)))), this._lightBulbWidget = new ua((() => {
      const h = this._editor.getContribution(Ou.ID);
      return h && this._register(h.onClick(((c) => this.showCodeActionsFromLightbulb(c.actions, c)))), h;
    })), this._resolver = i.createInstance(lw), this._register(this._editor.onDidLayoutChange((() => this._actionWidgetService.hide())));
  }
  dispose() {
    this._disposed = !0, super.dispose();
  }
  async showCodeActionsFromLightbulb(n, e) {
    if (n.allAIFixes && n.validActions.length === 1) {
      const t = n.validActions[0], i = t.action.command;
      return i && i.id === "inlineChat.start" && i.arguments && i.arguments.length >= 1 && (i.arguments[0] = { ...i.arguments[0], autoSend: !1 }), void await this._applyCodeAction(t, !1, !1, ym.FromAILightbulb);
    }
    await this.showCodeActionList(n, e, { includeDisabledActions: !1, fromLightbulb: !0 });
  }
  showCodeActions(n, e, t) {
    return this.showCodeActionList(e, t, { includeDisabledActions: !1, fromLightbulb: !1 });
  }
  manualTriggerAtCurrentPosition(n, e, t, i) {
    var s;
    if (!this._editor.hasModel()) return;
    (s = bs.get(this._editor)) === null || s === void 0 || s.closeMessage();
    const o = this._editor.getPosition();
    this._trigger({ type: 1, triggerAction: e, filter: t, autoApply: i, context: { notAvailableMessage: n, position: o } });
  }
  _trigger(n) {
    return this._model.trigger(n);
  }
  async _applyCodeAction(n, e, t, i) {
    try {
      await this._instantiationService.invokeFunction(dre, n, i, { preview: t, editor: this._editor });
    } finally {
      e && this._trigger({ type: 2, triggerAction: qs.QuickFix, filter: {} });
    }
  }
  async update(n) {
    var e, t, i, s, o, r, a;
    if (n.type !== 1) return void ((e = this._lightBulbWidget.rawValue) === null || e === void 0 || e.hide());
    let l;
    try {
      l = await n.actions;
    } catch (d) {
      return void We(d);
    }
    if (!this._disposed) if ((t = this._lightBulbWidget.value) === null || t === void 0 || t.update(l, n.trigger, n.position), n.trigger.type === 1) {
      if (!((i = n.trigger.filter) === null || i === void 0) && i.include) {
        const h = this.tryGetValidActionToApply(n.trigger, l);
        if (h) {
          try {
            (s = this._lightBulbWidget.value) === null || s === void 0 || s.hide(), await this._applyCodeAction(h, !1, !1, ym.FromCodeActions);
          } finally {
            l.dispose();
          }
          return;
        }
        if (n.trigger.context) {
          const c = this.getInvalidActionThatWouldHaveBeenApplied(n.trigger, l);
          if (c && c.action.disabled) return (o = bs.get(this._editor)) === null || o === void 0 || o.showMessage(c.action.disabled, n.trigger.context.position), void l.dispose();
        }
      }
      const d = !!(!((r = n.trigger.filter) === null || r === void 0) && r.include);
      if (n.trigger.context && (!l.allActions.length || !d && !l.validActions.length)) return (a = bs.get(this._editor)) === null || a === void 0 || a.showMessage(n.trigger.context.notAvailableMessage, n.trigger.context.position), this._activeCodeActions.value = l, void l.dispose();
      this._activeCodeActions.value = l, this.showCodeActionList(l, this.toCoords(n.position), { includeDisabledActions: d, fromLightbulb: !1 });
    } else this._actionWidgetService.isVisible ? l.dispose() : this._activeCodeActions.value = l;
  }
  getInvalidActionThatWouldHaveBeenApplied(n, e) {
    if (e.allActions.length) return n.autoApply === "first" && e.validActions.length === 0 || n.autoApply === "ifSingle" && e.allActions.length === 1 ? e.allActions.find((({ action: t }) => t.disabled)) : void 0;
  }
  tryGetValidActionToApply(n, e) {
    if (e.validActions.length) return n.autoApply === "first" && e.validActions.length > 0 || n.autoApply === "ifSingle" && e.validActions.length === 1 ? e.validActions[0] : void 0;
  }
  async showCodeActionList(n, e, t) {
    const i = this._editor.createDecorationsCollection(), s = this._editor.getDomNode();
    if (!s) return;
    const o = t.includeDisabledActions && (this._showDisabled || n.validActions.length === 0) ? n.allActions : n.validActions;
    if (!o.length) return;
    const r = W.isIPosition(e) ? this.toCoords(e) : e, a = { onSelect: async (l, d) => {
      this._applyCodeAction(l, !0, !!d, ym.FromCodeActions), this._actionWidgetService.hide(), i.clear();
    }, onHide: () => {
      var l;
      (l = this._editor) === null || l === void 0 || l.focus(), i.clear();
    }, onHover: async (l, d) => {
      var h;
      if (d.isCancellationRequested) return;
      let c = !1;
      const u = l.action.kind;
      if (u) {
        const g = new Nt(u);
        c = [ti.RefactorExtract, ti.RefactorInline, ti.RefactorRewrite].some(((p) => p.contains(g)));
      }
      return { canPreview: c || !!(!((h = l.action.edit) === null || h === void 0) && h.edits.length) };
    }, onFocus: (l) => {
      var d, h;
      if (l && l.action) {
        const c = l.action.ranges, u = l.action.diagnostics;
        if (i.clear(), c && c.length > 0) {
          const g = u && u?.length > 1 ? u.map(((p) => ({ range: p, options: mp.DECORATION }))) : c.map(((p) => ({ range: p, options: mp.DECORATION })));
          i.set(g);
        } else if (u && u.length > 0) {
          const g = u.map(((f) => ({ range: f, options: mp.DECORATION })));
          i.set(g);
          const p = u[0];
          p.startLineNumber && p.startColumn && vl(m(0, "Context: {0} at line {1} and column {2}.", (h = (d = this._editor.getModel()) === null || d === void 0 ? void 0 : d.getWordAtPosition({ lineNumber: p.startLineNumber, column: p.startColumn })) === null || h === void 0 ? void 0 : h.word, p.startLineNumber, p.startColumn));
        }
      } else i.clear();
    } };
    this._actionWidgetService.show("codeActionWidget", !0, (function(l, d, h) {
      if (!d) return l.map(((g) => {
        var p;
        return { kind: "action", item: g, group: GH, disabled: !!g.action.disabled, label: g.action.disabled || g.action.title, canPreview: !!(!((p = g.action.edit) === null || p === void 0) && p.edits.length) };
      }));
      const c = ure.map(((g) => ({ group: g, actions: [] })));
      for (const g of l) {
        const p = g.action.kind ? new Nt(g.action.kind) : Nt.None;
        for (const f of c) if (f.group.kind.contains(p)) {
          f.actions.push(g);
          break;
        }
      }
      const u = [];
      for (const g of c) if (g.actions.length) {
        u.push({ kind: "header", group: g.group });
        for (const p of g.actions) {
          const f = g.group;
          u.push({ kind: "action", item: p, group: p.action.isAI ? { title: f.title, kind: f.kind, icon: ne.sparkle } : f, label: p.action.title, disabled: !!p.action.disabled, keybinding: h(p.action) });
        }
      }
      return u;
    })(o, this._shouldShowHeaders(), this._resolver.getResolver()), a, r, s, this._getActionBarActions(n, e, t));
  }
  toCoords(n) {
    if (!this._editor.hasModel()) return { x: 0, y: 0 };
    this._editor.revealPosition(n, 1), this._editor.render();
    const e = this._editor.getScrolledVisiblePosition(n), t = Ti(this._editor.getDomNode());
    return { x: t.left + e.left, y: t.top + e.top + e.height };
  }
  _shouldShowHeaders() {
    var n;
    const e = (n = this._editor) === null || n === void 0 ? void 0 : n.getModel();
    return this._configurationService.getValue("editor.codeActionWidget.showHeaders", { resource: e?.uri });
  }
  _getActionBarActions(n, e, t) {
    if (t.fromLightbulb) return [];
    const i = n.documentation.map(((s) => {
      var o;
      return { id: s.id, label: s.title, tooltip: (o = s.tooltip) !== null && o !== void 0 ? o : "", class: void 0, enabled: !0, run: () => {
        var r;
        return this._commandService.executeCommand(s.id, ...(r = s.arguments) !== null && r !== void 0 ? r : []);
      } };
    }));
    return t.includeDisabledActions && n.validActions.length > 0 && n.allActions.length !== n.validActions.length && i.push(this._showDisabled ? { id: "hideMoreActions", label: m(0, "Hide Disabled"), enabled: !0, tooltip: "", class: void 0, run: () => (this._showDisabled = !1, this.showCodeActionList(n, e, t)) } : { id: "showMoreActions", label: m(0, "Show Disabled"), enabled: !0, tooltip: "", class: void 0, run: () => (this._showDisabled = !0, this.showCodeActionList(n, e, t)) }), i;
  }
};
function Yf(n) {
  return q.regex(JH.keys()[0], new RegExp("(\\s|^)" + No(n.value) + "\\b"));
}
zh.ID = "editor.contrib.codeActionController", zh.DECORATION = Ve.register({ description: "quickfix-highlight", className: "quickfix-edit-highlight" }), zh = mp = Cre([Tl(1, kl), Tl(2, Te), Tl(3, Se), Tl(4, fe), Tl(5, Nc), Tl(6, ai), Tl(7, Ye), Tl(8, Lu), Tl(9, Se)], zh), rr(((n, e) => {
  ((i, s) => {
    s && e.addRule(`.monaco-editor ${i} { background-color: ${s}; }`);
  })(".quickfix-edit-highlight", n.getColor(hd));
  const t = n.getColor(Th);
  t && e.addRule(`.monaco-editor .quickfix-edit-highlight { border: 1px ${aa(n.type) ? "dotted" : "solid"} ${t}; box-sizing: border-box; }`);
}));
const _x = { type: "object", defaultSnippets: [{ body: { kind: "" } }], properties: { kind: { type: "string", description: m(0, "Kind of the code action to run.") }, apply: { type: "string", description: m(0, "Controls when the returned actions are applied."), default: "ifSingle", enum: ["first", "ifSingle", "never"], enumDescriptions: [m(0, "Always apply the first returned code action."), m(0, "Apply the first returned code action if it is the only one."), m(0, "Do not apply the returned code actions.")] }, preferred: { type: "boolean", default: !1, description: m(0, "Controls if only preferred code actions should be returned.") } } };
function Yc(n, e, t, i, s = qs.Default) {
  if (n.hasModel()) {
    const o = zh.get(n);
    o?.manualTriggerAtCurrentPosition(e, s, t, i);
  }
}
ft(zh.ID, zh, 3), ft(Ou.ID, Ou, 4), X(class extends he {
  constructor() {
    super({ id: mP, label: m(0, "Quick Fix..."), alias: "Quick Fix...", precondition: q.and(E.writable, E.hasCodeActionsProvider), kbOpts: { kbExpr: E.textInputFocus, primary: 2137, weight: 100 } });
  }
  run(n, e) {
    return Yc(e, m(0, "No code actions available"), void 0, void 0, qs.QuickFix);
  }
}), X(class extends he {
  constructor() {
    super({ id: qH, label: m(0, "Refactor..."), alias: "Refactor...", precondition: q.and(E.writable, E.hasCodeActionsProvider), kbOpts: { kbExpr: E.textInputFocus, primary: 3120, mac: { primary: 1328 }, weight: 100 }, contextMenuOpts: { group: "1_modification", order: 2, when: q.and(E.writable, Yf(ti.Refactor)) }, metadata: { description: "Refactor...", args: [{ name: "args", schema: _x }] } });
  }
  run(n, e, t) {
    const i = el.fromUser(t, { kind: ti.Refactor, apply: "never" });
    return Yc(e, typeof t?.kind == "string" ? i.preferred ? m(0, "No preferred refactorings for '{0}' available", t.kind) : m(0, "No refactorings for '{0}' available", t.kind) : i.preferred ? m(0, "No preferred refactorings available") : m(0, "No refactorings available"), { include: ti.Refactor.contains(i.kind) ? i.kind : Nt.None, onlyIncludePreferredActions: i.preferred }, i.apply, qs.Refactor);
  }
}), X(class extends he {
  constructor() {
    super({ id: $H, label: m(0, "Source Action..."), alias: "Source Action...", precondition: q.and(E.writable, E.hasCodeActionsProvider), contextMenuOpts: { group: "1_modification", order: 2.1, when: q.and(E.writable, Yf(ti.Source)) }, metadata: { description: "Source Action...", args: [{ name: "args", schema: _x }] } });
  }
  run(n, e, t) {
    const i = el.fromUser(t, { kind: ti.Source, apply: "never" });
    return Yc(e, typeof t?.kind == "string" ? i.preferred ? m(0, "No preferred source actions for '{0}' available", t.kind) : m(0, "No source actions for '{0}' available", t.kind) : i.preferred ? m(0, "No preferred source actions available") : m(0, "No source actions available"), { include: ti.Source.contains(i.kind) ? i.kind : Nt.None, includeSourceActions: !0, onlyIncludePreferredActions: i.preferred }, i.apply, qs.SourceAction);
  }
}), X(class extends he {
  constructor() {
    super({ id: fP, label: m(0, "Organize Imports"), alias: "Organize Imports", precondition: q.and(E.writable, Yf(ti.SourceOrganizeImports)), kbOpts: { kbExpr: E.textInputFocus, primary: 1581, weight: 100 } });
  }
  run(n, e) {
    return Yc(e, m(0, "No organize imports action available"), { include: ti.SourceOrganizeImports, includeSourceActions: !0 }, "ifSingle", qs.OrganizeImports);
  }
}), X(class extends he {
  constructor() {
    super({ id: jH, label: m(0, "Auto Fix..."), alias: "Auto Fix...", precondition: q.and(E.writable, Yf(ti.QuickFix)), kbOpts: { kbExpr: E.textInputFocus, primary: 1625, mac: { primary: 2649 }, weight: 100 } });
  }
  run(n, e) {
    return Yc(e, m(0, "No auto fixes available"), { include: ti.QuickFix, onlyIncludePreferredActions: !0 }, "ifSingle", qs.AutoFix);
  }
}), X(class extends he {
  constructor() {
    super({ id: _P, label: m(0, "Fix All"), alias: "Fix All", precondition: q.and(E.writable, Yf(ti.SourceFixAll)) });
  }
  run(n, e) {
    return Yc(e, m(0, "No fix all action available"), { include: ti.SourceFixAll, includeSourceActions: !0 }, "ifSingle", qs.FixAll);
  }
}), re(new class extends Zi {
  constructor() {
    super({ id: KH, precondition: q.and(E.writable, E.hasCodeActionsProvider), metadata: { description: "Trigger a code action", args: [{ name: "args", schema: _x }] } });
  }
  runEditorCommand(n, e, t) {
    const i = el.fromUser(t, { kind: Nt.Empty, apply: "ifSingle" });
    return Yc(e, typeof t?.kind == "string" ? i.preferred ? m(0, "No preferred code actions for '{0}' available", t.kind) : m(0, "No code actions for '{0}' available", t.kind) : i.preferred ? m(0, "No preferred code actions available") : m(0, "No code actions available"), { include: i.kind, includeSourceActions: !0, onlyIncludePreferredActions: i.preferred }, i.apply);
  }
}()), li.as(ma).registerConfiguration({ ...xy, properties: { "editor.codeActionWidget.showHeaders": { type: "boolean", scope: 5, description: m(0, "Enable/disable showing group headers in the Code Action menu."), default: !0 } } }), li.as(ma).registerConfiguration({ ...xy, properties: { "editor.codeActionWidget.includeNearbyQuickFixes": { type: "boolean", scope: 5, description: m(0, "Enable/disable showing nearest Quick Fix within a line when not currently on a diagnostic."), default: !0 } } });
class uM {
  constructor() {
    this.lenses = [], this._disposables = new G();
  }
  dispose() {
    this._disposables.dispose();
  }
  get isDisposed() {
    return this._disposables.isDisposed;
  }
  add(e, t) {
    this._disposables.add(e);
    for (const i of e.lenses) this.lenses.push({ symbol: i, provider: t });
  }
}
async function tz(n, e, t) {
  const i = n.ordered(e), s = /* @__PURE__ */ new Map(), o = new uM(), r = i.map((async (a, l) => {
    s.set(a, l);
    try {
      const d = await Promise.resolve(a.provideCodeLenses(e, t));
      d && o.add(d, a);
    } catch (d) {
      Ni(d);
    }
  }));
  return await Promise.all(r), o.lenses = o.lenses.sort(((a, l) => a.symbol.range.startLineNumber < l.symbol.range.startLineNumber ? -1 : a.symbol.range.startLineNumber > l.symbol.range.startLineNumber ? 1 : s.get(a.provider) < s.get(l.provider) ? -1 : s.get(a.provider) > s.get(l.provider) ? 1 : a.symbol.range.startColumn < l.symbol.range.startColumn ? -1 : a.symbol.range.startColumn > l.symbol.range.startColumn ? 1 : 0)), o;
}
dt.registerCommand("_executeCodeLensProvider", (function(n, ...e) {
  let [t, i] = e;
  vt(Ie.isUri(t)), vt(typeof i == "number" || !i);
  const { codeLensProvider: s } = n.get(fe), o = n.get(ni).getModel(t);
  if (!o) throw Yo();
  const r = [], a = new G();
  return tz(s, o, et.None).then(((l) => {
    a.add(l);
    const d = [];
    for (const h of l.lenses) i == null || h.symbol.command ? r.push(h.symbol) : i-- > 0 && h.provider.resolveCodeLens && d.push(Promise.resolve(h.provider.resolveCodeLens(o, h.symbol, et.None)).then(((c) => r.push(c || h.symbol))));
    return Promise.all(d);
  })).then((() => r)).finally((() => {
    setTimeout((() => a.dispose()), 100);
  }));
}));
var wre = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, yre = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const iz = tt("ICodeLensCache");
class _6 {
  constructor(e, t) {
    this.lineCount = e, this.data = t;
  }
}
let vx = class {
  constructor(n) {
    this._fakeProvider = new class {
      provideCodeLenses() {
        throw new Error("not supported");
      }
    }(), this._cache = new Ll(20, 0.75), c_(It, (() => n.remove("codelens/cache", 1)));
    const e = "codelens/cache2", t = n.get(e, 1, "{}");
    this._deserialize(t), se.once(n.onWillSaveState)(((i) => {
      i.reason === Pv.SHUTDOWN && n.store(e, this._serialize(), 1, 1);
    }));
  }
  put(n, e) {
    const t = e.lenses.map(((o) => {
      var r;
      return { range: o.symbol.range, command: o.symbol.command && { id: "", title: (r = o.symbol.command) === null || r === void 0 ? void 0 : r.title } };
    })), i = new uM();
    i.add({ lenses: t, dispose: () => {
    } }, this._fakeProvider);
    const s = new _6(n.getLineCount(), i);
    this._cache.set(n.uri.toString(), s);
  }
  get(n) {
    const e = this._cache.get(n.uri.toString());
    return e && e.lineCount === n.getLineCount() ? e.data : void 0;
  }
  delete(n) {
    this._cache.delete(n.uri.toString());
  }
  _serialize() {
    const n = /* @__PURE__ */ Object.create(null);
    for (const [e, t] of this._cache) {
      const i = /* @__PURE__ */ new Set();
      for (const s of t.data.lenses) i.add(s.symbol.range.startLineNumber);
      n[e] = { lineCount: t.lineCount, lines: [...i.values()] };
    }
    return JSON.stringify(n);
  }
  _deserialize(n) {
    try {
      const e = JSON.parse(n);
      for (const t in e) {
        const i = e[t], s = [];
        for (const r of i.lines) s.push({ range: new D(r, 1, r, 11) });
        const o = new uM();
        o.add({ lenses: s, dispose() {
        } }, this._fakeProvider), this._cache.set(t, new _6(i.lineCount, o));
      }
    } catch {
    }
  }
};
vx = wre([yre(0, Nr)], vx), rt(iz, vx, 1);
class Sre {
  constructor(e, t, i) {
    this.afterColumn = 1073741824, this.afterLineNumber = e, this.heightInPx = t, this._onHeight = i, this.suppressMouseDown = !0, this.domNode = document.createElement("div");
  }
  onComputedHeight(e) {
    this._lastHeight === void 0 ? this._lastHeight = e : this._lastHeight !== e && (this._lastHeight = e, this._onHeight());
  }
  isVisible() {
    return this._lastHeight !== 0 && this.domNode.hasAttribute("monaco-visible-view-zone");
  }
}
class Qv {
  constructor(e, t) {
    this.allowEditorOverflow = !1, this.suppressMouseDown = !0, this._commands = /* @__PURE__ */ new Map(), this._isEmpty = !0, this._editor = e, this._id = "codelens.widget-" + Qv._idPool++, this.updatePosition(t), this._domNode = document.createElement("span"), this._domNode.className = "codelens-decoration";
  }
  withCommands(e, t) {
    this._commands.clear();
    const i = [];
    let s = !1;
    for (let o = 0; o < e.length; o++) {
      const r = e[o];
      if (r && (s = !0, r.command)) {
        const a = tc(r.command.title.trim());
        if (r.command.id) {
          const l = "c" + Qv._idPool++;
          i.push(Q("a", { id: l, title: r.command.tooltip, role: "button" }, ...a)), this._commands.set(l, r.command);
        } else i.push(Q("span", { title: r.command.tooltip }, ...a));
        o + 1 < e.length && i.push(Q("span", void 0, " | "));
      }
    }
    s ? (wn(this._domNode, ...i), this._isEmpty && t && this._domNode.classList.add("fadein"), this._isEmpty = !1) : wn(this._domNode, Q("span", void 0, "no commands"));
  }
  getCommand(e) {
    return e.parentElement === this._domNode ? this._commands.get(e.id) : void 0;
  }
  getId() {
    return this._id;
  }
  getDomNode() {
    return this._domNode;
  }
  updatePosition(e) {
    const t = this._editor.getModel().getLineFirstNonWhitespaceColumn(e);
    this._widgetPosition = { position: { lineNumber: e, column: t }, preference: [1] };
  }
  getPosition() {
    return this._widgetPosition || null;
  }
}
Qv._idPool = 0;
class bx {
  constructor() {
    this._removeDecorations = [], this._addDecorations = [], this._addDecorationsCallbacks = [];
  }
  addDecoration(e, t) {
    this._addDecorations.push(e), this._addDecorationsCallbacks.push(t);
  }
  removeDecoration(e) {
    this._removeDecorations.push(e);
  }
  commit(e) {
    const t = e.deltaDecorations(this._removeDecorations, this._addDecorations);
    for (let i = 0, s = t.length; i < s; i++) this._addDecorationsCallbacks[i](t[i]);
  }
}
const v6 = Ve.register({ collapseOnReplaceEdit: !0, description: "codelens" });
class b6 {
  constructor(e, t, i, s, o, r) {
    let a;
    this._isDisposed = !1, this._editor = t, this._data = e, this._decorationIds = [];
    const l = [];
    this._data.forEach(((d, h) => {
      d.symbol.command && l.push(d.symbol), i.addDecoration({ range: d.symbol.range, options: v6 }, ((c) => this._decorationIds[h] = c)), a = a ? D.plusRange(a, d.symbol.range) : D.lift(d.symbol.range);
    })), this._viewZone = new Sre(a.startLineNumber - 1, o, r), this._viewZoneId = s.addZone(this._viewZone), l.length > 0 && (this._createContentWidgetIfNecessary(), this._contentWidget.withCommands(l, !1));
  }
  _createContentWidgetIfNecessary() {
    this._contentWidget ? this._editor.layoutContentWidget(this._contentWidget) : (this._contentWidget = new Qv(this._editor, this._viewZone.afterLineNumber + 1), this._editor.addContentWidget(this._contentWidget));
  }
  dispose(e, t) {
    this._decorationIds.forEach(e.removeDecoration, e), this._decorationIds = [], t?.removeZone(this._viewZoneId), this._contentWidget && (this._editor.removeContentWidget(this._contentWidget), this._contentWidget = void 0), this._isDisposed = !0;
  }
  isDisposed() {
    return this._isDisposed;
  }
  isValid() {
    return this._decorationIds.some(((e, t) => {
      const i = this._editor.getModel().getDecorationRange(e), s = this._data[t].symbol;
      return !(!i || D.isEmpty(s.range) !== i.isEmpty());
    }));
  }
  updateCodeLensSymbols(e, t) {
    this._decorationIds.forEach(t.removeDecoration, t), this._decorationIds = [], this._data = e, this._data.forEach(((i, s) => {
      t.addDecoration({ range: i.symbol.range, options: v6 }, ((o) => this._decorationIds[s] = o));
    }));
  }
  updateHeight(e, t) {
    this._viewZone.heightInPx = e, t.layoutZone(this._viewZoneId), this._contentWidget && this._editor.layoutContentWidget(this._contentWidget);
  }
  computeIfNecessary(e) {
    if (!this._viewZone.isVisible()) return null;
    for (let t = 0; t < this._decorationIds.length; t++) {
      const i = e.getDecorationRange(this._decorationIds[t]);
      i && (this._data[t].symbol.range = i);
    }
    return this._data;
  }
  updateCommands(e) {
    this._createContentWidgetIfNecessary(), this._contentWidget.withCommands(e, !0);
    for (let t = 0; t < this._data.length; t++) {
      const i = e[t];
      if (i) {
        const { symbol: s } = this._data[t];
        s.command = i.command || s.command;
      }
    }
  }
  getCommand(e) {
    var t;
    return (t = this._contentWidget) === null || t === void 0 ? void 0 : t.getCommand(e);
  }
  getLineNumber() {
    const e = this._editor.getModel().getDecorationRange(this._decorationIds[0]);
    return e ? e.startLineNumber : -1;
  }
  update(e) {
    if (this.isValid()) {
      const t = this._editor.getModel().getDecorationRange(this._decorationIds[0]);
      t && (this._viewZone.afterLineNumber = t.startLineNumber - 1, e.layoutZone(this._viewZoneId), this._contentWidget && (this._contentWidget.updatePosition(t.startLineNumber), this._editor.layoutContentWidget(this._contentWidget)));
    }
  }
}
var Lre = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Xf = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Jg = class {
  constructor(n, e, t, i, s, o) {
    this._editor = n, this._languageFeaturesService = e, this._commandService = i, this._notificationService = s, this._codeLensCache = o, this._disposables = new G(), this._localToDispose = new G(), this._lenses = [], this._oldCodeLensModels = new G(), this._provideCodeLensDebounce = t.for(e.codeLensProvider, "CodeLensProvide", { min: 250 }), this._resolveCodeLensesDebounce = t.for(e.codeLensProvider, "CodeLensResolve", { min: 250, salt: "resolve" }), this._resolveCodeLensesScheduler = new Et((() => this._resolveCodeLensesInViewport()), this._resolveCodeLensesDebounce.default()), this._disposables.add(this._editor.onDidChangeModel((() => this._onModelChange()))), this._disposables.add(this._editor.onDidChangeModelLanguage((() => this._onModelChange()))), this._disposables.add(this._editor.onDidChangeConfiguration(((r) => {
      (r.hasChanged(50) || r.hasChanged(19) || r.hasChanged(18)) && this._updateLensStyle(), r.hasChanged(17) && this._onModelChange();
    }))), this._disposables.add(e.codeLensProvider.onDidChange(this._onModelChange, this)), this._onModelChange(), this._updateLensStyle();
  }
  dispose() {
    var n;
    this._localDispose(), this._disposables.dispose(), this._oldCodeLensModels.dispose(), (n = this._currentCodeLensModel) === null || n === void 0 || n.dispose();
  }
  _getLayoutInfo() {
    const n = Math.max(1.3, this._editor.getOption(67) / this._editor.getOption(52));
    let e = this._editor.getOption(19);
    return (!e || e < 5) && (e = 0.9 * this._editor.getOption(52) | 0), { fontSize: e, codeLensHeight: e * n | 0 };
  }
  _updateLensStyle() {
    const { codeLensHeight: n, fontSize: e } = this._getLayoutInfo(), t = this._editor.getOption(18), i = this._editor.getOption(50), { style: s } = this._editor.getContainerDomNode();
    s.setProperty("--vscode-editorCodeLens-lineHeight", `${n}px`), s.setProperty("--vscode-editorCodeLens-fontSize", `${e}px`), s.setProperty("--vscode-editorCodeLens-fontFeatureSettings", i.fontFeatureSettings), t && (s.setProperty("--vscode-editorCodeLens-fontFamily", t), s.setProperty("--vscode-editorCodeLens-fontFamilyDefault", Is.fontFamily)), this._editor.changeViewZones(((o) => {
      for (const r of this._lenses) r.updateHeight(n, o);
    }));
  }
  _localDispose() {
    var n, e, t;
    (n = this._getCodeLensModelPromise) === null || n === void 0 || n.cancel(), this._getCodeLensModelPromise = void 0, (e = this._resolveCodeLensesPromise) === null || e === void 0 || e.cancel(), this._resolveCodeLensesPromise = void 0, this._localToDispose.clear(), this._oldCodeLensModels.clear(), (t = this._currentCodeLensModel) === null || t === void 0 || t.dispose();
  }
  _onModelChange() {
    this._localDispose();
    const n = this._editor.getModel();
    if (!n || !this._editor.getOption(17) || n.isTooLargeForTokenization()) return;
    const e = this._codeLensCache.get(n);
    if (e && this._renderCodeLensSymbols(e), !this._languageFeaturesService.codeLensProvider.has(n)) return void (e && bc((() => {
      const i = this._codeLensCache.get(n);
      e === i && (this._codeLensCache.delete(n), this._onModelChange());
    }), 3e4, this._localToDispose));
    for (const i of this._languageFeaturesService.codeLensProvider.all(n)) if (typeof i.onDidChange == "function") {
      const s = i.onDidChange((() => t.schedule()));
      this._localToDispose.add(s);
    }
    const t = new Et((() => {
      var i;
      const s = Date.now();
      (i = this._getCodeLensModelPromise) === null || i === void 0 || i.cancel(), this._getCodeLensModelPromise = on(((o) => tz(this._languageFeaturesService.codeLensProvider, n, o))), this._getCodeLensModelPromise.then(((o) => {
        this._currentCodeLensModel && this._oldCodeLensModels.add(this._currentCodeLensModel), this._currentCodeLensModel = o, this._codeLensCache.put(n, o);
        const r = this._provideCodeLensDebounce.update(n, Date.now() - s);
        t.delay = r, this._renderCodeLensSymbols(o), this._resolveCodeLensesInViewportSoon();
      }), We);
    }), this._provideCodeLensDebounce.get(n));
    this._localToDispose.add(t), this._localToDispose.add(ye((() => this._resolveCodeLensesScheduler.cancel()))), this._localToDispose.add(this._editor.onDidChangeModelContent((() => {
      var i;
      this._editor.changeDecorations(((s) => {
        this._editor.changeViewZones(((o) => {
          const r = [];
          let a = -1;
          this._lenses.forEach(((d) => {
            d.isValid() && a !== d.getLineNumber() ? (d.update(o), a = d.getLineNumber()) : r.push(d);
          }));
          const l = new bx();
          r.forEach(((d) => {
            d.dispose(l, o), this._lenses.splice(this._lenses.indexOf(d), 1);
          })), l.commit(s);
        }));
      })), t.schedule(), this._resolveCodeLensesScheduler.cancel(), (i = this._resolveCodeLensesPromise) === null || i === void 0 || i.cancel(), this._resolveCodeLensesPromise = void 0;
    }))), this._localToDispose.add(this._editor.onDidFocusEditorWidget((() => {
      t.schedule();
    }))), this._localToDispose.add(this._editor.onDidBlurEditorText((() => {
      t.cancel();
    }))), this._localToDispose.add(this._editor.onDidScrollChange(((i) => {
      i.scrollTopChanged && this._lenses.length > 0 && this._resolveCodeLensesInViewportSoon();
    }))), this._localToDispose.add(this._editor.onDidLayoutChange((() => {
      this._resolveCodeLensesInViewportSoon();
    }))), this._localToDispose.add(ye((() => {
      if (this._editor.getModel()) {
        const i = wa.capture(this._editor);
        this._editor.changeDecorations(((s) => {
          this._editor.changeViewZones(((o) => {
            this._disposeAllLenses(s, o);
          }));
        })), i.restore(this._editor);
      } else this._disposeAllLenses(void 0, void 0);
    }))), this._localToDispose.add(this._editor.onMouseDown(((i) => {
      if (i.target.type !== 9) return;
      let s = i.target.element;
      if (s?.tagName === "SPAN" && (s = s.parentElement), s?.tagName === "A") for (const o of this._lenses) {
        const r = o.getCommand(s);
        if (r) {
          this._commandService.executeCommand(r.id, ...r.arguments || []).catch(((a) => this._notificationService.error(a)));
          break;
        }
      }
    }))), t.schedule();
  }
  _disposeAllLenses(n, e) {
    const t = new bx();
    for (const i of this._lenses) i.dispose(t, e);
    n && t.commit(n), this._lenses.length = 0;
  }
  _renderCodeLensSymbols(n) {
    if (!this._editor.hasModel()) return;
    const e = this._editor.getModel().getLineCount(), t = [];
    let i;
    for (const r of n.lenses) {
      const a = r.symbol.range.startLineNumber;
      a < 1 || a > e || (i && i[i.length - 1].symbol.range.startLineNumber === a ? i.push(r) : (i = [r], t.push(i)));
    }
    if (!t.length && !this._lenses.length) return;
    const s = wa.capture(this._editor), o = this._getLayoutInfo();
    this._editor.changeDecorations(((r) => {
      this._editor.changeViewZones(((a) => {
        const l = new bx();
        let d = 0, h = 0;
        for (; h < t.length && d < this._lenses.length; ) {
          const c = t[h][0].symbol.range.startLineNumber, u = this._lenses[d].getLineNumber();
          u < c ? (this._lenses[d].dispose(l, a), this._lenses.splice(d, 1)) : u === c ? (this._lenses[d].updateCodeLensSymbols(t[h], l), h++, d++) : (this._lenses.splice(d, 0, new b6(t[h], this._editor, l, a, o.codeLensHeight, (() => this._resolveCodeLensesInViewportSoon()))), d++, h++);
        }
        for (; d < this._lenses.length; ) this._lenses[d].dispose(l, a), this._lenses.splice(d, 1);
        for (; h < t.length; ) this._lenses.push(new b6(t[h], this._editor, l, a, o.codeLensHeight, (() => this._resolveCodeLensesInViewportSoon()))), h++;
        l.commit(r);
      }));
    })), s.restore(this._editor);
  }
  _resolveCodeLensesInViewportSoon() {
    this._editor.getModel() && this._resolveCodeLensesScheduler.schedule();
  }
  _resolveCodeLensesInViewport() {
    var n;
    (n = this._resolveCodeLensesPromise) === null || n === void 0 || n.cancel(), this._resolveCodeLensesPromise = void 0;
    const e = this._editor.getModel();
    if (!e) return;
    const t = [], i = [];
    if (this._lenses.forEach(((r) => {
      const a = r.computeIfNecessary(e);
      a && (t.push(a), i.push(r));
    })), t.length === 0) return;
    const s = Date.now(), o = on(((r) => {
      const a = t.map(((l, d) => {
        const h = new Array(l.length), c = l.map(((u, g) => u.symbol.command || typeof u.provider.resolveCodeLens != "function" ? (h[g] = u.symbol, Promise.resolve(void 0)) : Promise.resolve(u.provider.resolveCodeLens(e, u.symbol, r)).then(((p) => {
          h[g] = p;
        }), Ni)));
        return Promise.all(c).then((() => {
          r.isCancellationRequested || i[d].isDisposed() || i[d].updateCommands(h);
        }));
      }));
      return Promise.all(a);
    }));
    this._resolveCodeLensesPromise = o, this._resolveCodeLensesPromise.then((() => {
      const r = this._resolveCodeLensesDebounce.update(e, Date.now() - s);
      this._resolveCodeLensesScheduler.delay = r, this._currentCodeLensModel && this._codeLensCache.put(e, this._currentCodeLensModel), this._oldCodeLensModels.clear(), o === this._resolveCodeLensesPromise && (this._resolveCodeLensesPromise = void 0);
    }), ((r) => {
      We(r), o === this._resolveCodeLensesPromise && (this._resolveCodeLensesPromise = void 0);
    }));
  }
  async getModel() {
    var n;
    return await this._getCodeLensModelPromise, await this._resolveCodeLensesPromise, !((n = this._currentCodeLensModel) === null || n === void 0) && n.isDisposed ? void 0 : this._currentCodeLensModel;
  }
};
Jg.ID = "css.editor.codeLens", Jg = Lre([Xf(1, fe), Xf(2, ar), Xf(3, ai), Xf(4, Ri), Xf(5, iz)], Jg), ft(Jg.ID, Jg, 1), X(class extends he {
  constructor() {
    super({ id: "codelens.showLensesInCurrentLine", precondition: E.hasCodeLensProvider, label: m(0, "Show CodeLens Commands For Current Line"), alias: "Show CodeLens Commands For Current Line" });
  }
  async run(n, e) {
    if (!e.hasModel()) return;
    const t = n.get(Sa), i = n.get(ai), s = n.get(Ri), o = e.getSelection().positionLineNumber, r = e.getContribution(Jg.ID);
    if (!r) return;
    const a = await r.getModel();
    if (!a) return;
    const l = [];
    for (const c of a.lenses) c.symbol.command && c.symbol.range.startLineNumber === o && l.push({ label: c.symbol.command.title, command: c.symbol.command });
    if (l.length === 0) return;
    const d = await t.pick(l, { canPickMany: !1, placeHolder: m(0, "Select a command") });
    if (!d) return;
    let h = d.command;
    if (a.isDisposed) {
      const c = await r.getModel(), u = c?.lenses.find(((g) => {
        var p;
        return g.symbol.range.startLineNumber === o && ((p = g.symbol.command) === null || p === void 0 ? void 0 : p.title) === h.title;
      }));
      if (!u || !u.symbol.command) return;
      h = u.symbol.command;
    }
    try {
      await i.executeCommand(h.id, ...h.arguments || []);
    } catch (c) {
      s.error(c);
    }
  }
});
var kre = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Cx = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class vP {
  constructor(e, t) {
    this._editorWorkerClient = new NR(e, !1, "editorWorkerService", t);
  }
  async provideDocumentColors(e, t) {
    return this._editorWorkerClient.computeDefaultDocumentColors(e.uri);
  }
  provideColorPresentations(e, t, i) {
    const s = t.range, o = t.color, r = o.alpha, a = new z(new ht(Math.round(255 * o.red), Math.round(255 * o.green), Math.round(255 * o.blue), r)), l = r ? z.Format.CSS.formatRGB(a) : z.Format.CSS.formatRGBA(a), d = r ? z.Format.CSS.formatHSL(a) : z.Format.CSS.formatHSLA(a), h = r ? z.Format.CSS.formatHex(a) : z.Format.CSS.formatHexA(a), c = [];
    return c.push({ label: l, textEdit: { range: s, text: l } }), c.push({ label: d, textEdit: { range: s, text: d } }), c.push({ label: h, textEdit: { range: s, text: h } }), c;
  }
}
let wx = class extends V {
  constructor(n, e, t) {
    super(), this._register(t.colorProvider.register("*", new vP(n, e)));
  }
};
async function nz(n, e, t, i = !0) {
  return gM(new Dre(), n, e, t, i);
}
function sz(n, e, t, i) {
  return Promise.resolve(t.provideColorPresentations(n, e, i));
}
wx = kre([Cx(0, ni), Cx(1, zt), Cx(2, fe)], wx), W1(wx);
class Dre {
  constructor() {
  }
  async compute(e, t, i, s) {
    const o = await e.provideDocumentColors(t, i);
    if (Array.isArray(o)) for (const r of o) s.push({ colorInfo: r, provider: e });
    return Array.isArray(o);
  }
}
class xre {
  constructor() {
  }
  async compute(e, t, i, s) {
    const o = await e.provideDocumentColors(t, i);
    if (Array.isArray(o)) for (const r of o) s.push({ range: r.range, color: [r.color.red, r.color.green, r.color.blue, r.color.alpha] });
    return Array.isArray(o);
  }
}
class Nre {
  constructor(e) {
    this.colorInfo = e;
  }
  async compute(e, t, i, s) {
    const o = await e.provideColorPresentations(t, this.colorInfo, et.None);
    return Array.isArray(o) && s.push(...o), Array.isArray(o);
  }
}
async function gM(n, e, t, i, s) {
  let o, r = !1;
  const a = [], l = e.ordered(t);
  for (let d = l.length - 1; d >= 0; d--) {
    const h = l[d];
    if (h instanceof vP) o = h;
    else try {
      await n.compute(h, t, i, a) && (r = !0);
    } catch (c) {
      Ni(c);
    }
  }
  return r ? a : o && s ? (await n.compute(o, t, i, a), a) : [];
}
function C6(n, e) {
  const { colorProvider: t } = n.get(fe), i = n.get(ni).getModel(e);
  if (!i) throw Yo();
  return { model: i, colorProviderRegistry: t, isDefaultColorDecoratorsEnabled: n.get(Ye).getValue("editor.defaultColorDecorators", { resource: e }) };
}
dt.registerCommand("_executeDocumentColorProvider", (function(n, ...e) {
  const [t] = e;
  if (!(t instanceof Ie)) throw Yo();
  const { model: i, colorProviderRegistry: s, isDefaultColorDecoratorsEnabled: o } = C6(n, t);
  return gM(new xre(), s, i, et.None, o);
})), dt.registerCommand("_executeColorPresentationProvider", (function(n, ...e) {
  const [t, i] = e, { uri: s, range: o } = i;
  if (!(s instanceof Ie && Array.isArray(t) && t.length === 4 && D.isIRange(o))) throw Yo();
  const { model: r, colorProviderRegistry: a, isDefaultColorDecoratorsEnabled: l } = C6(n, s), [d, h, c, u] = t;
  return gM(new Nre({ range: o, color: { red: d, green: h, blue: c, alpha: u } }), a, r, et.None, l);
}));
var pM, Ere = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, yx = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const oz = /* @__PURE__ */ Object.create({});
let Uh = pM = class extends V {
  constructor(n, e, t, i) {
    super(), this._editor = n, this._configurationService = e, this._languageFeaturesService = t, this._localToDispose = this._register(new G()), this._decorationsIds = [], this._colorDatas = /* @__PURE__ */ new Map(), this._colorDecoratorIds = this._editor.createDecorationsCollection(), this._ruleFactory = new w1(this._editor), this._decoratorLimitReporter = new Ire(), this._colorDecorationClassRefs = this._register(new G()), this._debounceInformation = i.for(t.colorProvider, "Document Colors", { min: pM.RECOMPUTE_TIME }), this._register(n.onDidChangeModel((() => {
      this._isColorDecoratorsEnabled = this.isEnabled(), this.updateColors();
    }))), this._register(n.onDidChangeModelLanguage((() => this.updateColors()))), this._register(t.colorProvider.onDidChange((() => this.updateColors()))), this._register(n.onDidChangeConfiguration(((s) => {
      const o = this._isColorDecoratorsEnabled;
      this._isColorDecoratorsEnabled = this.isEnabled(), this._isDefaultColorDecoratorsEnabled = this._editor.getOption(147);
      const r = o !== this._isColorDecoratorsEnabled || s.hasChanged(21), a = s.hasChanged(147);
      (r || a) && (this._isColorDecoratorsEnabled ? this.updateColors() : this.removeAllDecorations());
    }))), this._timeoutTimer = null, this._computePromise = null, this._isColorDecoratorsEnabled = this.isEnabled(), this._isDefaultColorDecoratorsEnabled = this._editor.getOption(147), this.updateColors();
  }
  isEnabled() {
    const n = this._editor.getModel();
    if (!n) return !1;
    const e = n.getLanguageId(), t = this._configurationService.getValue(e);
    if (t && typeof t == "object") {
      const i = t.colorDecorators;
      if (i && i.enable !== void 0 && !i.enable) return i.enable;
    }
    return this._editor.getOption(20);
  }
  static get(n) {
    return n.getContribution(this.ID);
  }
  dispose() {
    this.stop(), this.removeAllDecorations(), super.dispose();
  }
  updateColors() {
    if (this.stop(), !this._isColorDecoratorsEnabled) return;
    const n = this._editor.getModel();
    n && this._languageFeaturesService.colorProvider.has(n) && (this._localToDispose.add(this._editor.onDidChangeModelContent((() => {
      this._timeoutTimer || (this._timeoutTimer = new Dr(), this._timeoutTimer.cancelAndSet((() => {
        this._timeoutTimer = null, this.beginCompute();
      }), this._debounceInformation.get(n)));
    }))), this.beginCompute());
  }
  async beginCompute() {
    this._computePromise = on((async (n) => {
      const e = this._editor.getModel();
      if (!e) return [];
      const t = new Rn(!1), i = await nz(this._languageFeaturesService.colorProvider, e, n, this._isDefaultColorDecoratorsEnabled);
      return this._debounceInformation.update(e, t.elapsed()), i;
    }));
    try {
      const n = await this._computePromise;
      this.updateDecorations(n), this.updateColorDecorators(n), this._computePromise = null;
    } catch (n) {
      We(n);
    }
  }
  stop() {
    this._timeoutTimer && (this._timeoutTimer.cancel(), this._timeoutTimer = null), this._computePromise && (this._computePromise.cancel(), this._computePromise = null), this._localToDispose.clear();
  }
  updateDecorations(n) {
    const e = n.map(((t) => ({ range: { startLineNumber: t.colorInfo.range.startLineNumber, startColumn: t.colorInfo.range.startColumn, endLineNumber: t.colorInfo.range.endLineNumber, endColumn: t.colorInfo.range.endColumn }, options: Ve.EMPTY })));
    this._editor.changeDecorations(((t) => {
      this._decorationsIds = t.deltaDecorations(this._decorationsIds, e), this._colorDatas = /* @__PURE__ */ new Map(), this._decorationsIds.forEach(((i, s) => this._colorDatas.set(i, n[s])));
    }));
  }
  updateColorDecorators(n) {
    this._colorDecorationClassRefs.clear();
    const e = [], t = this._editor.getOption(21);
    for (let s = 0; s < n.length && e.length < t; s++) {
      const { red: o, green: r, blue: a, alpha: l } = n[s].colorInfo.color, d = new ht(Math.round(255 * o), Math.round(255 * r), Math.round(255 * a), l), h = `rgba(${d.r}, ${d.g}, ${d.b}, ${d.a})`, c = this._colorDecorationClassRefs.add(this._ruleFactory.createClassNameRef({ backgroundColor: h }));
      e.push({ range: { startLineNumber: n[s].colorInfo.range.startLineNumber, startColumn: n[s].colorInfo.range.startColumn, endLineNumber: n[s].colorInfo.range.endLineNumber, endColumn: n[s].colorInfo.range.endColumn }, options: { description: "colorDetector", before: { content: " ", inlineClassName: `${c.className} colorpicker-color-decoration`, inlineClassNameAffectsLetterSpacing: !0, attachedData: oz } } });
    }
    const i = t < n.length && t;
    this._decoratorLimitReporter.update(n.length, i), this._colorDecoratorIds.set(e);
  }
  removeAllDecorations() {
    this._editor.removeDecorations(this._decorationsIds), this._decorationsIds = [], this._colorDecoratorIds.clear(), this._colorDecorationClassRefs.clear();
  }
  getColorData(n) {
    const e = this._editor.getModel();
    if (!e) return null;
    const t = e.getDecorationsInRange(D.fromPositions(n, n)).filter(((i) => this._colorDatas.has(i.id)));
    return t.length === 0 ? null : this._colorDatas.get(t[0].id);
  }
  isColorDecoration(n) {
    return this._colorDecoratorIds.has(n);
  }
};
Uh.ID = "editor.contrib.colorDetector", Uh.RECOMPUTE_TIME = 1e3, Uh = pM = Ere([yx(1, Ye), yx(2, fe), yx(3, ar)], Uh);
class Ire {
  constructor() {
    this._onDidChange = new F(), this._computed = 0, this._limited = !1;
  }
  update(e, t) {
    e === this._computed && t === this._limited || (this._computed = e, this._limited = t, this._onDidChange.fire());
  }
}
ft(Uh.ID, Uh, 1);
class Mre {
  get color() {
    return this._color;
  }
  set color(e) {
    this._color.equals(e) || (this._color = e, this._onDidChangeColor.fire(e));
  }
  get presentation() {
    return this.colorPresentations[this.presentationIndex];
  }
  get colorPresentations() {
    return this._colorPresentations;
  }
  set colorPresentations(e) {
    this._colorPresentations = e, this.presentationIndex > e.length - 1 && (this.presentationIndex = 0), this._onDidChangePresentation.fire(this.presentation);
  }
  constructor(e, t, i) {
    this.presentationIndex = i, this._onColorFlushed = new F(), this.onColorFlushed = this._onColorFlushed.event, this._onDidChangeColor = new F(), this.onDidChangeColor = this._onDidChangeColor.event, this._onDidChangePresentation = new F(), this.onDidChangePresentation = this._onDidChangePresentation.event, this.originalColor = e, this._color = e, this._colorPresentations = t;
  }
  selectNextColorPresentation() {
    this.presentationIndex = (this.presentationIndex + 1) % this.colorPresentations.length, this.flushColor(), this._onDidChangePresentation.fire(this.presentation);
  }
  guessColorPresentation(e, t) {
    let i = -1;
    for (let s = 0; s < this.colorPresentations.length; s++) if (t.toLowerCase() === this.colorPresentations[s].label) {
      i = s;
      break;
    }
    if (i === -1) {
      const s = t.split("(")[0].toLowerCase();
      for (let o = 0; o < this.colorPresentations.length; o++) if (this.colorPresentations[o].label.toLowerCase().startsWith(s)) {
        i = o;
        break;
      }
    }
    i !== -1 && i !== this.presentationIndex && (this.presentationIndex = i, this._onDidChangePresentation.fire(this.presentation));
  }
  flushColor() {
    this._onColorFlushed.fire(this._color);
  }
}
const vo = Q;
class Tre extends V {
  constructor(e, t, i, s = !1) {
    super(), this.model = t, this.showingStandaloneColorPicker = s, this._closeButton = null, this._domNode = vo(".colorpicker-header"), Z(e, this._domNode), this._pickedColorNode = Z(this._domNode, vo(".picked-color")), Z(this._pickedColorNode, vo("span.codicon.codicon-color-mode")), this._pickedColorPresentation = Z(this._pickedColorNode, document.createElement("span")), this._pickedColorPresentation.classList.add("picked-color-presentation");
    const o = m(0, "Click to toggle color options (rgb/hsl/hex)");
    this._pickedColorNode.setAttribute("title", o), this._originalColorNode = Z(this._domNode, vo(".original-color")), this._originalColorNode.style.backgroundColor = z.Format.CSS.format(this.model.originalColor) || "", this.backgroundColor = i.getColorTheme().getColor(sy) || z.white, this._register(i.onDidColorThemeChange(((r) => {
      this.backgroundColor = r.getColor(sy) || z.white;
    }))), this._register(K(this._pickedColorNode, ie.CLICK, (() => this.model.selectNextColorPresentation()))), this._register(K(this._originalColorNode, ie.CLICK, (() => {
      this.model.color = this.model.originalColor, this.model.flushColor();
    }))), this._register(t.onDidChangeColor(this.onDidChangeColor, this)), this._register(t.onDidChangePresentation(this.onDidChangePresentation, this)), this._pickedColorNode.style.backgroundColor = z.Format.CSS.format(t.color) || "", this._pickedColorNode.classList.toggle("light", t.color.rgba.a < 0.5 ? this.backgroundColor.isLighter() : t.color.isLighter()), this.onDidChangeColor(this.model.color), this.showingStandaloneColorPicker && (this._domNode.classList.add("standalone-colorpicker"), this._closeButton = this._register(new Rre(this._domNode)));
  }
  get closeButton() {
    return this._closeButton;
  }
  get pickedColorNode() {
    return this._pickedColorNode;
  }
  get originalColorNode() {
    return this._originalColorNode;
  }
  onDidChangeColor(e) {
    this._pickedColorNode.style.backgroundColor = z.Format.CSS.format(e) || "", this._pickedColorNode.classList.toggle("light", e.rgba.a < 0.5 ? this.backgroundColor.isLighter() : e.isLighter()), this.onDidChangePresentation();
  }
  onDidChangePresentation() {
    this._pickedColorPresentation.textContent = this.model.presentation ? this.model.presentation.label : "";
  }
}
class Rre extends V {
  constructor(e) {
    super(), this._onClicked = this._register(new F()), this.onClicked = this._onClicked.event, this._button = document.createElement("div"), this._button.classList.add("close-button"), Z(e, this._button);
    const t = document.createElement("div");
    t.classList.add("close-button-inner-div"), Z(this._button, t), Z(t, vo(".button" + Ee.asCSSSelector(Ei("color-picker-close", ne.close, m(0, "Icon to close the color picker"))))).classList.add("close-icon"), this._register(K(this._button, ie.CLICK, (() => {
      this._onClicked.fire();
    })));
  }
}
class Are extends V {
  constructor(e, t, i, s = !1) {
    super(), this.model = t, this.pixelRatio = i, this._insertButton = null, this._domNode = vo(".colorpicker-body"), Z(e, this._domNode), this._saturationBox = new Pre(this._domNode, this.model, this.pixelRatio), this._register(this._saturationBox), this._register(this._saturationBox.onDidChange(this.onDidSaturationValueChange, this)), this._register(this._saturationBox.onColorFlushed(this.flushColor, this)), this._opacityStrip = new Ore(this._domNode, this.model, s), this._register(this._opacityStrip), this._register(this._opacityStrip.onDidChange(this.onDidOpacityChange, this)), this._register(this._opacityStrip.onColorFlushed(this.flushColor, this)), this._hueStrip = new Fre(this._domNode, this.model, s), this._register(this._hueStrip), this._register(this._hueStrip.onDidChange(this.onDidHueChange, this)), this._register(this._hueStrip.onColorFlushed(this.flushColor, this)), s && (this._insertButton = this._register(new Bre(this._domNode)), this._domNode.classList.add("standalone-colorpicker"));
  }
  flushColor() {
    this.model.flushColor();
  }
  onDidSaturationValueChange({ s: e, v: t }) {
    const i = this.model.color.hsva;
    this.model.color = new z(new il(i.h, e, t, i.a));
  }
  onDidOpacityChange(e) {
    const t = this.model.color.hsva;
    this.model.color = new z(new il(t.h, t.s, t.v, e));
  }
  onDidHueChange(e) {
    const t = this.model.color.hsva, i = 360 * (1 - e);
    this.model.color = new z(new il(i === 360 ? 0 : i, t.s, t.v, t.a));
  }
  get domNode() {
    return this._domNode;
  }
  get saturationBox() {
    return this._saturationBox;
  }
  get enterButton() {
    return this._insertButton;
  }
  layout() {
    this._saturationBox.layout(), this._opacityStrip.layout(), this._hueStrip.layout();
  }
}
class Pre extends V {
  constructor(e, t, i) {
    super(), this.model = t, this.pixelRatio = i, this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._onColorFlushed = new F(), this.onColorFlushed = this._onColorFlushed.event, this._domNode = vo(".saturation-wrap"), Z(e, this._domNode), this._canvas = document.createElement("canvas"), this._canvas.className = "saturation-box", Z(this._domNode, this._canvas), this.selection = vo(".saturation-selection"), Z(this._domNode, this.selection), this.layout(), this._register(K(this._domNode, ie.POINTER_DOWN, ((s) => this.onPointerDown(s)))), this._register(this.model.onDidChangeColor(this.onDidChangeColor, this)), this.monitor = null;
  }
  get domNode() {
    return this._domNode;
  }
  onPointerDown(e) {
    if (!(e.target && e.target instanceof Element)) return;
    this.monitor = this._register(new ff());
    const t = Ti(this._domNode);
    e.target !== this.selection && this.onDidChangePosition(e.offsetX, e.offsetY), this.monitor.startMonitoring(e.target, e.pointerId, e.buttons, ((s) => this.onDidChangePosition(s.pageX - t.left, s.pageY - t.top)), (() => null));
    const i = K(e.target.ownerDocument, ie.POINTER_UP, (() => {
      this._onColorFlushed.fire(), i.dispose(), this.monitor && (this.monitor.stopMonitoring(!0), this.monitor = null);
    }), !0);
  }
  onDidChangePosition(e, t) {
    const i = Math.max(0, Math.min(1, e / this.width)), s = Math.max(0, Math.min(1, 1 - t / this.height));
    this.paintSelection(i, s), this._onDidChange.fire({ s: i, v: s });
  }
  layout() {
    this.width = this._domNode.offsetWidth, this.height = this._domNode.offsetHeight, this._canvas.width = this.width * this.pixelRatio, this._canvas.height = this.height * this.pixelRatio, this.paint();
    const e = this.model.color.hsva;
    this.paintSelection(e.s, e.v);
  }
  paint() {
    const e = this.model.color.hsva, t = new z(new il(e.h, 1, 1, 1)), i = this._canvas.getContext("2d"), s = i.createLinearGradient(0, 0, this._canvas.width, 0);
    s.addColorStop(0, "rgba(255, 255, 255, 1)"), s.addColorStop(0.5, "rgba(255, 255, 255, 0.5)"), s.addColorStop(1, "rgba(255, 255, 255, 0)");
    const o = i.createLinearGradient(0, 0, 0, this._canvas.height);
    o.addColorStop(0, "rgba(0, 0, 0, 0)"), o.addColorStop(1, "rgba(0, 0, 0, 1)"), i.rect(0, 0, this._canvas.width, this._canvas.height), i.fillStyle = z.Format.CSS.format(t), i.fill(), i.fillStyle = s, i.fill(), i.fillStyle = o, i.fill();
  }
  paintSelection(e, t) {
    this.selection.style.left = e * this.width + "px", this.selection.style.top = this.height - t * this.height + "px";
  }
  onDidChangeColor(e) {
    if (this.monitor && this.monitor.isMonitoring()) return;
    this.paint();
    const t = e.hsva;
    this.paintSelection(t.s, t.v);
  }
}
class rz extends V {
  constructor(e, t, i = !1) {
    super(), this.model = t, this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._onColorFlushed = new F(), this.onColorFlushed = this._onColorFlushed.event, i ? (this.domNode = Z(e, vo(".standalone-strip")), this.overlay = Z(this.domNode, vo(".standalone-overlay"))) : (this.domNode = Z(e, vo(".strip")), this.overlay = Z(this.domNode, vo(".overlay"))), this.slider = Z(this.domNode, vo(".slider")), this.slider.style.top = "0px", this._register(K(this.domNode, ie.POINTER_DOWN, ((s) => this.onPointerDown(s)))), this._register(t.onDidChangeColor(this.onDidChangeColor, this)), this.layout();
  }
  layout() {
    this.height = this.domNode.offsetHeight - this.slider.offsetHeight;
    const e = this.getValue(this.model.color);
    this.updateSliderPosition(e);
  }
  onDidChangeColor(e) {
    const t = this.getValue(e);
    this.updateSliderPosition(t);
  }
  onPointerDown(e) {
    if (!(e.target && e.target instanceof Element)) return;
    const t = this._register(new ff()), i = Ti(this.domNode);
    this.domNode.classList.add("grabbing"), e.target !== this.slider && this.onDidChangeTop(e.offsetY), t.startMonitoring(e.target, e.pointerId, e.buttons, ((o) => this.onDidChangeTop(o.pageY - i.top)), (() => null));
    const s = K(e.target.ownerDocument, ie.POINTER_UP, (() => {
      this._onColorFlushed.fire(), s.dispose(), t.stopMonitoring(!0), this.domNode.classList.remove("grabbing");
    }), !0);
  }
  onDidChangeTop(e) {
    const t = Math.max(0, Math.min(1, 1 - e / this.height));
    this.updateSliderPosition(t), this._onDidChange.fire(t);
  }
  updateSliderPosition(e) {
    this.slider.style.top = (1 - e) * this.height + "px";
  }
}
class Ore extends rz {
  constructor(e, t, i = !1) {
    super(e, t, i), this.domNode.classList.add("opacity-strip"), this.onDidChangeColor(this.model.color);
  }
  onDidChangeColor(e) {
    super.onDidChangeColor(e);
    const { r: t, g: i, b: s } = e.rgba, o = new z(new ht(t, i, s, 1)), r = new z(new ht(t, i, s, 0));
    this.overlay.style.background = `linear-gradient(to bottom, ${o} 0%, ${r} 100%)`;
  }
  getValue(e) {
    return e.hsva.a;
  }
}
class Fre extends rz {
  constructor(e, t, i = !1) {
    super(e, t, i), this.domNode.classList.add("hue-strip");
  }
  getValue(e) {
    return 1 - e.hsva.h / 360;
  }
}
class Bre extends V {
  constructor(e) {
    super(), this._onClicked = this._register(new F()), this.onClicked = this._onClicked.event, this._button = Z(e, document.createElement("button")), this._button.classList.add("insert-button"), this._button.textContent = "Insert", this._register(K(this._button, ie.CLICK, (() => {
      this._onClicked.fire();
    })));
  }
  get button() {
    return this._button;
  }
}
class Wre extends To {
  constructor(e, t, i, s, o = !1) {
    super(), this.model = t, this.pixelRatio = i, this._register(Q0.getInstance(ke(e)).onDidChange((() => this.layout())));
    const r = vo(".colorpicker-widget");
    e.appendChild(r), this.header = this._register(new Tre(r, this.model, s, o)), this.body = this._register(new Are(r, this.model, this.pixelRatio, o));
  }
  layout() {
    this.body.layout();
  }
}
var az = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, lz = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class Vre {
  constructor(e, t, i, s) {
    this.owner = e, this.range = t, this.model = i, this.provider = s, this.forceShowAtRange = !0;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
let hS = class {
  constructor(n, e) {
    this._editor = n, this._themeService = e, this.hoverOrdinal = 2;
  }
  computeSync(n, e) {
    return [];
  }
  computeAsync(n, e, t) {
    return Pi.fromPromise(this._computeAsync(n, e, t));
  }
  async _computeAsync(n, e, t) {
    if (!this._editor.hasModel()) return [];
    const i = Uh.get(this._editor);
    if (!i) return [];
    for (const s of e) {
      if (!i.isColorDecoration(s)) continue;
      const o = i.getColorData(s.range.getStartPosition());
      if (o)
        return [await dz(this, this._editor.getModel(), o.colorInfo, o.provider)];
    }
    return [];
  }
  renderHoverParts(n, e) {
    return hz(this, this._editor, this._themeService, e, n);
  }
};
hS = az([lz(1, Yi)], hS);
class Hre {
  constructor(e, t, i, s) {
    this.owner = e, this.range = t, this.model = i, this.provider = s;
  }
}
let Jv = class {
  constructor(n, e) {
    this._editor = n, this._themeService = e, this._color = null;
  }
  async createColorHover(n, e, t) {
    if (!this._editor.hasModel() || !Uh.get(this._editor)) return null;
    const i = await nz(t, this._editor.getModel(), et.None);
    let s = null, o = null;
    for (const d of i) {
      const h = d.colorInfo;
      D.containsRange(h.range, n.range) && (s = h, o = d.provider);
    }
    const r = s ?? n, a = o ?? e, l = !!s;
    return { colorHover: await dz(this, this._editor.getModel(), r, a), foundInEditor: l };
  }
  async updateEditorModel(n) {
    if (!this._editor.hasModel()) return;
    const e = n.model;
    let t = new D(n.range.startLineNumber, n.range.startColumn, n.range.endLineNumber, n.range.endColumn);
    this._color && (await dw(this._editor.getModel(), e, this._color, t, n), t = cz(this._editor, t, e));
  }
  renderHoverParts(n, e) {
    return hz(this, this._editor, this._themeService, e, n);
  }
  set color(n) {
    this._color = n;
  }
  get color() {
    return this._color;
  }
};
async function dz(n, e, t, i) {
  const s = e.getValueInRange(t.range), { red: o, green: r, blue: a, alpha: l } = t.color, d = new ht(Math.round(255 * o), Math.round(255 * r), Math.round(255 * a), l), h = new z(d), c = await sz(e, t, i, et.None), u = new Mre(h, [], 0);
  return u.colorPresentations = c || [], u.guessColorPresentation(h, s), n instanceof hS ? new Vre(n, D.lift(t.range), u, i) : new Hre(n, D.lift(t.range), u, i);
}
function hz(n, e, t, i, s) {
  if (i.length === 0 || !e.hasModel()) return V.None;
  if (s.setMinimumDimensions) {
    const u = e.getOption(67) + 8;
    s.setMinimumDimensions(new bt(302, u));
  }
  const o = new G(), r = i[0], a = e.getModel(), l = r.model, d = o.add(new Wre(s.fragment, l, e.getOption(143), t, n instanceof Jv));
  s.setColorPicker(d);
  let h = !1, c = new D(r.range.startLineNumber, r.range.startColumn, r.range.endLineNumber, r.range.endColumn);
  if (n instanceof Jv) {
    const u = i[0].model.color;
    n.color = u, dw(a, l, u, c, r), o.add(l.onColorFlushed(((g) => {
      n.color = g;
    })));
  } else o.add(l.onColorFlushed((async (u) => {
    await dw(a, l, u, c, r), h = !0, c = cz(e, c, l);
  })));
  return o.add(l.onDidChangeColor(((u) => {
    dw(a, l, u, c, r);
  }))), o.add(e.onDidChangeModelContent(((u) => {
    h ? h = !1 : (s.hide(), e.focus());
  }))), o;
}
function cz(n, e, t) {
  var i, s;
  const o = [], r = (i = t.presentation.textEdit) !== null && i !== void 0 ? i : { range: e, text: t.presentation.label, forceMoveMarkers: !1 };
  o.push(r), t.presentation.additionalTextEdits && o.push(...t.presentation.additionalTextEdits);
  const a = D.lift(r.range), l = n.getModel()._setTrackedRange(null, a, 3);
  return n.executeEdits("colorpicker", o), n.pushUndoStop(), (s = n.getModel()._getTrackedRange(l)) !== null && s !== void 0 ? s : a;
}
async function dw(n, e, t, i, s) {
  const o = await sz(n, { range: i, color: { red: t.rgba.r / 255, green: t.rgba.g / 255, blue: t.rgba.b / 255, alpha: t.rgba.a } }, s.provider, et.None);
  e.colorPresentations = o || [];
}
function mM(n, e) {
  return !!n[e];
}
Jv = az([lz(1, Yi)], Jv);
class Sx {
  constructor(e, t) {
    this.target = e.target, this.isLeftClick = e.event.leftButton, this.isMiddleClick = e.event.middleButton, this.isRightClick = e.event.rightButton, this.hasTriggerModifier = mM(e.event, t.triggerModifier), this.hasSideBySideModifier = mM(e.event, t.triggerSideBySideModifier), this.isNoneOrSingleMouseDown = e.event.detail <= 1;
  }
}
class w6 {
  constructor(e, t) {
    this.keyCodeIsTriggerKey = e.keyCode === t.triggerKey, this.keyCodeIsSideBySideKey = e.keyCode === t.triggerSideBySideKey, this.hasTriggerModifier = mM(e, t.triggerModifier);
  }
}
class $b {
  constructor(e, t, i, s) {
    this.triggerKey = e, this.triggerModifier = t, this.triggerSideBySideKey = i, this.triggerSideBySideModifier = s;
  }
  equals(e) {
    return this.triggerKey === e.triggerKey && this.triggerModifier === e.triggerModifier && this.triggerSideBySideKey === e.triggerSideBySideKey && this.triggerSideBySideModifier === e.triggerSideBySideModifier;
  }
}
function y6(n) {
  return n === "altKey" ? Je ? new $b(57, "metaKey", 6, "altKey") : new $b(5, "ctrlKey", 6, "altKey") : Je ? new $b(6, "altKey", 57, "metaKey") : new $b(6, "altKey", 5, "ctrlKey");
}
class XL extends V {
  constructor(e, t) {
    var i;
    super(), this._onMouseMoveOrRelevantKeyDown = this._register(new F()), this.onMouseMoveOrRelevantKeyDown = this._onMouseMoveOrRelevantKeyDown.event, this._onExecute = this._register(new F()), this.onExecute = this._onExecute.event, this._onCancel = this._register(new F()), this.onCancel = this._onCancel.event, this._editor = e, this._extractLineNumberFromMouseEvent = (i = t?.extractLineNumberFromMouseEvent) !== null && i !== void 0 ? i : (s) => s.target.position ? s.target.position.lineNumber : 0, this._opts = y6(this._editor.getOption(78)), this._lastMouseMoveEvent = null, this._hasTriggerKeyOnMouseDown = !1, this._lineNumberOnMouseDown = 0, this._register(this._editor.onDidChangeConfiguration(((s) => {
      if (s.hasChanged(78)) {
        const o = y6(this._editor.getOption(78));
        if (this._opts.equals(o)) return;
        this._opts = o, this._lastMouseMoveEvent = null, this._hasTriggerKeyOnMouseDown = !1, this._lineNumberOnMouseDown = 0, this._onCancel.fire();
      }
    }))), this._register(this._editor.onMouseMove(((s) => this._onEditorMouseMove(new Sx(s, this._opts))))), this._register(this._editor.onMouseDown(((s) => this._onEditorMouseDown(new Sx(s, this._opts))))), this._register(this._editor.onMouseUp(((s) => this._onEditorMouseUp(new Sx(s, this._opts))))), this._register(this._editor.onKeyDown(((s) => this._onEditorKeyDown(new w6(s, this._opts))))), this._register(this._editor.onKeyUp(((s) => this._onEditorKeyUp(new w6(s, this._opts))))), this._register(this._editor.onMouseDrag((() => this._resetHandler()))), this._register(this._editor.onDidChangeCursorSelection(((s) => this._onDidChangeCursorSelection(s)))), this._register(this._editor.onDidChangeModel(((s) => this._resetHandler()))), this._register(this._editor.onDidChangeModelContent((() => this._resetHandler()))), this._register(this._editor.onDidScrollChange(((s) => {
      (s.scrollTopChanged || s.scrollLeftChanged) && this._resetHandler();
    })));
  }
  _onDidChangeCursorSelection(e) {
    e.selection && e.selection.startColumn !== e.selection.endColumn && this._resetHandler();
  }
  _onEditorMouseMove(e) {
    this._lastMouseMoveEvent = e, this._onMouseMoveOrRelevantKeyDown.fire([e, null]);
  }
  _onEditorMouseDown(e) {
    this._hasTriggerKeyOnMouseDown = e.hasTriggerModifier, this._lineNumberOnMouseDown = this._extractLineNumberFromMouseEvent(e);
  }
  _onEditorMouseUp(e) {
    const t = this._extractLineNumberFromMouseEvent(e);
    this._hasTriggerKeyOnMouseDown && this._lineNumberOnMouseDown && this._lineNumberOnMouseDown === t && this._onExecute.fire(e);
  }
  _onEditorKeyDown(e) {
    this._lastMouseMoveEvent && (e.keyCodeIsTriggerKey || e.keyCodeIsSideBySideKey && e.hasTriggerModifier) ? this._onMouseMoveOrRelevantKeyDown.fire([this._lastMouseMoveEvent, e]) : e.hasTriggerModifier && this._onCancel.fire();
  }
  _onEditorKeyUp(e) {
    e.keyCodeIsTriggerKey && this._onCancel.fire();
  }
  _resetHandler() {
    this._lastMouseMoveEvent = null, this._hasTriggerKeyOnMouseDown = !1, this._onCancel.fire();
  }
}
var zre = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Rl = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Mc = class extends um {
  constructor(n, e, t, i, s, o, r, a, l, d, h, c, u) {
    super(n, { ...i.getRawOptions(), overflowWidgetsDomNode: i.getOverflowWidgetsDomNode() }, t, s, o, r, a, l, d, h, c, u), this._parentEditor = i, this._overwriteOptions = e, super.updateOptions(this._overwriteOptions), this._register(i.onDidChangeConfiguration(((g) => this._onParentConfigurationChanged(g))));
  }
  getParentEditor() {
    return this._parentEditor;
  }
  _onParentConfigurationChanged(n) {
    super.updateOptions(this._parentEditor.getRawOptions()), super.updateOptions(this._overwriteOptions);
  }
  updateOptions(n) {
    RS(this._overwriteOptions, n, !0), super.updateOptions(this._overwriteOptions);
  }
};
Mc = zre([Rl(4, Se), Rl(5, mt), Rl(6, ai), Rl(7, Te), Rl(8, Yi), Rl(9, Ri), Rl(10, or), Rl(11, zt), Rl(12, fe)], Mc);
const S6 = new z(new ht(0, 122, 204)), Ure = { showArrow: !0, showFrame: !0, className: "", frameColor: S6, arrowColor: S6, keepEditorSelection: !1 };
class Kre {
  constructor(e, t, i, s, o, r, a, l) {
    this.id = "", this.domNode = e, this.afterLineNumber = t, this.afterColumn = i, this.heightInLines = s, this.showInHiddenAreas = a, this.ordinal = l, this._onDomNodeTop = o, this._onComputedHeight = r;
  }
  onDomNodeTop(e) {
    this._onDomNodeTop(e);
  }
  onComputedHeight(e) {
    this._onComputedHeight(e);
  }
}
class jre {
  constructor(e, t) {
    this._id = e, this._domNode = t;
  }
  getId() {
    return this._id;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return null;
  }
}
class QL {
  constructor(e) {
    this._editor = e, this._ruleName = QL._IdGenerator.nextId(), this._decorations = this._editor.createDecorationsCollection(), this._color = null, this._height = -1;
  }
  dispose() {
    this.hide(), IE(this._ruleName);
  }
  set color(e) {
    this._color !== e && (this._color = e, this._updateStyle());
  }
  set height(e) {
    this._height !== e && (this._height = e, this._updateStyle());
  }
  _updateStyle() {
    IE(this._ruleName), jw(`.monaco-editor ${this._ruleName}`, `border-style: solid; border-color: transparent; border-bottom-color: ${this._color}; border-width: ${this._height}px; bottom: -${this._height}px !important; margin-left: -${this._height}px; `);
  }
  show(e) {
    e.column === 1 && (e = { lineNumber: e.lineNumber, column: 2 }), this._decorations.set([{ range: D.fromPositions(e), options: { description: "zone-widget-arrow", className: this._ruleName, stickiness: 1 } }]);
  }
  hide() {
    this._decorations.clear();
  }
}
QL._IdGenerator = new yA(".arrow-decoration-");
class qre {
  constructor(e, t = {}) {
    this._arrow = null, this._overlayWidget = null, this._resizeSash = null, this._viewZone = null, this._disposables = new G(), this.container = null, this._isShowing = !1, this.editor = e, this._positionMarkerId = this.editor.createDecorationsCollection(), this.options = Ul(t), RS(this.options, Ure, !1), this.domNode = document.createElement("div"), this.options.isAccessible || (this.domNode.setAttribute("aria-hidden", "true"), this.domNode.setAttribute("role", "presentation")), this._disposables.add(this.editor.onDidLayoutChange(((i) => {
      const s = this._getWidth(i);
      this.domNode.style.width = s + "px", this.domNode.style.left = this._getLeft(i) + "px", this._onWidth(s);
    })));
  }
  dispose() {
    this._overlayWidget && (this.editor.removeOverlayWidget(this._overlayWidget), this._overlayWidget = null), this._viewZone && this.editor.changeViewZones(((e) => {
      this._viewZone && e.removeZone(this._viewZone.id), this._viewZone = null;
    })), this._positionMarkerId.clear(), this._disposables.dispose();
  }
  create() {
    this.domNode.classList.add("zone-widget"), this.options.className && this.domNode.classList.add(this.options.className), this.container = document.createElement("div"), this.container.classList.add("zone-widget-container"), this.domNode.appendChild(this.container), this.options.showArrow && (this._arrow = new QL(this.editor), this._disposables.add(this._arrow)), this._fillContainer(this.container), this._initSash(), this._applyStyles();
  }
  style(e) {
    e.frameColor && (this.options.frameColor = e.frameColor), e.arrowColor && (this.options.arrowColor = e.arrowColor), this._applyStyles();
  }
  _applyStyles() {
    if (this.container && this.options.frameColor) {
      const e = this.options.frameColor.toString();
      this.container.style.borderTopColor = e, this.container.style.borderBottomColor = e;
    }
    if (this._arrow && this.options.arrowColor) {
      const e = this.options.arrowColor.toString();
      this._arrow.color = e;
    }
  }
  _getWidth(e) {
    return e.width - e.minimap.minimapWidth - e.verticalScrollbarWidth;
  }
  _getLeft(e) {
    return e.minimap.minimapWidth > 0 && e.minimap.minimapLeft === 0 ? e.minimap.minimapWidth : 0;
  }
  _onViewZoneTop(e) {
    this.domNode.style.top = e + "px";
  }
  _onViewZoneHeight(e) {
    var t;
    if (this.domNode.style.height = `${e}px`, this.container) {
      const i = e - this._decoratingElementsHeight();
      this.container.style.height = `${i}px`;
      const s = this.editor.getLayoutInfo();
      this._doLayout(i, this._getWidth(s));
    }
    (t = this._resizeSash) === null || t === void 0 || t.layout();
  }
  get position() {
    const e = this._positionMarkerId.getRange(0);
    if (e) return e.getStartPosition();
  }
  show(e, t) {
    const i = D.isIRange(e) ? D.lift(e) : D.fromPositions(e);
    this._isShowing = !0, this._showImpl(i, t), this._isShowing = !1, this._positionMarkerId.set([{ range: i, options: Ve.EMPTY }]);
  }
  hide() {
    var e;
    this._viewZone && (this.editor.changeViewZones(((t) => {
      this._viewZone && t.removeZone(this._viewZone.id);
    })), this._viewZone = null), this._overlayWidget && (this.editor.removeOverlayWidget(this._overlayWidget), this._overlayWidget = null), (e = this._arrow) === null || e === void 0 || e.hide(), this._positionMarkerId.clear();
  }
  _decoratingElementsHeight() {
    const e = this.editor.getOption(67);
    let t = 0;
    return this.options.showArrow && (t += 2 * Math.round(e / 3)), this.options.showFrame && (t += 2 * Math.round(e / 9)), t;
  }
  _showImpl(e, t) {
    const i = e.getStartPosition(), s = this.editor.getLayoutInfo(), o = this._getWidth(s);
    this.domNode.style.width = `${o}px`, this.domNode.style.left = this._getLeft(s) + "px";
    const r = document.createElement("div");
    r.style.overflow = "hidden";
    const a = this.editor.getOption(67);
    if (!this.options.allowUnlimitedHeight) {
      const u = Math.max(12, this.editor.getLayoutInfo().height / a * 0.8);
      t = Math.min(t, u);
    }
    let l = 0, d = 0;
    if (this._arrow && this.options.showArrow && (l = Math.round(a / 3), this._arrow.height = l, this._arrow.show(i)), this.options.showFrame && (d = Math.round(a / 9)), this.editor.changeViewZones(((u) => {
      this._viewZone && u.removeZone(this._viewZone.id), this._overlayWidget && (this.editor.removeOverlayWidget(this._overlayWidget), this._overlayWidget = null), this.domNode.style.top = "-1000px", this._viewZone = new Kre(r, i.lineNumber, i.column, t, ((g) => this._onViewZoneTop(g)), ((g) => this._onViewZoneHeight(g)), this.options.showInHiddenAreas, this.options.ordinal), this._viewZone.id = u.addZone(this._viewZone), this._overlayWidget = new jre("vs.editor.contrib.zoneWidget" + this._viewZone.id, this.domNode), this.editor.addOverlayWidget(this._overlayWidget);
    })), this.container && this.options.showFrame) {
      const u = this.options.frameWidth ? this.options.frameWidth : d;
      this.container.style.borderTopWidth = u + "px", this.container.style.borderBottomWidth = u + "px";
    }
    const h = t * a - this._decoratingElementsHeight();
    this.container && (this.container.style.top = l + "px", this.container.style.height = h + "px", this.container.style.overflow = "hidden"), this._doLayout(h, o), this.options.keepEditorSelection || this.editor.setSelection(e);
    const c = this.editor.getModel();
    if (c) {
      const u = c.validateRange(new D(e.startLineNumber, 1, e.endLineNumber + 1, 1));
      this.revealRange(u, u.startLineNumber === c.getLineCount());
    }
  }
  revealRange(e, t) {
    t ? this.editor.revealLineNearTop(e.endLineNumber, 0) : this.editor.revealRange(e, 0);
  }
  setCssClass(e, t) {
    this.container && (t && this.container.classList.remove(t), this.container.classList.add(e));
  }
  _onWidth(e) {
  }
  _doLayout(e, t) {
  }
  _relayout(e) {
    this._viewZone && this._viewZone.heightInLines !== e && this.editor.changeViewZones(((t) => {
      this._viewZone && (this._viewZone.heightInLines = e, t.layoutZone(this._viewZone.id));
    }));
  }
  _initSash() {
    if (this._resizeSash) return;
    let e;
    this._resizeSash = this._disposables.add(new Bn(this.domNode, this, { orientation: 1 })), this.options.isResizeable || (this._resizeSash.state = 0), this._disposables.add(this._resizeSash.onDidStart(((t) => {
      this._viewZone && (e = { startY: t.startY, heightInLines: this._viewZone.heightInLines });
    }))), this._disposables.add(this._resizeSash.onDidEnd((() => {
      e = void 0;
    }))), this._disposables.add(this._resizeSash.onDidChange(((t) => {
      if (e) {
        const i = (t.currentY - e.startY) / this.editor.getOption(67), s = i < 0 ? Math.ceil(i) : Math.floor(i), o = e.heightInLines + s;
        o > 5 && o < 35 && this._relayout(o);
      }
    })));
  }
  getHorizontalSashLeft() {
    return 0;
  }
  getHorizontalSashTop() {
    return (this.domNode.style.height === null ? 0 : parseInt(this.domNode.style.height)) - this._decoratingElementsHeight() / 2;
  }
  getHorizontalSashWidth() {
    const e = this.editor.getLayoutInfo();
    return e.width - e.minimap.minimapWidth;
  }
}
var uz = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, gz = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const pz = tt("IPeekViewService");
var As;
rt(pz, class {
  constructor() {
    this._widgets = /* @__PURE__ */ new Map();
  }
  addExclusiveWidget(n, e) {
    const t = this._widgets.get(n);
    t && (t.listener.dispose(), t.widget.dispose()), this._widgets.set(n, { widget: e, listener: e.onDidClose((() => {
      const i = this._widgets.get(n);
      i && i.widget === e && (i.listener.dispose(), this._widgets.delete(n));
    })) });
  }
}, 1), (function(n) {
  n.inPeekEditor = new ae("inReferenceSearchEditor", !0, m(0, "Whether the current code editor is embedded inside peek")), n.notInPeekEditor = n.inPeekEditor.toNegated();
})(As || (As = {}));
let Qf = class {
  constructor(n, e) {
    n instanceof Mc && As.inPeekEditor.bindTo(e);
  }
  dispose() {
  }
};
Qf.ID = "editor.contrib.referenceController", Qf = uz([gz(1, Te)], Qf), ft(Qf.ID, Qf, 0);
const $re = { headerBackgroundColor: z.white, primaryHeadingColor: z.fromHex("#333333"), secondaryHeadingColor: z.fromHex("#6c6c6cb3") };
let cS = class extends qre {
  constructor(n, e, t) {
    super(n, e), this.instantiationService = t, this._onDidClose = new F(), this.onDidClose = this._onDidClose.event, RS(this.options, $re, !1);
  }
  dispose() {
    this.disposed || (this.disposed = !0, super.dispose(), this._onDidClose.fire(this));
  }
  style(n) {
    const e = this.options;
    n.headerBackgroundColor && (e.headerBackgroundColor = n.headerBackgroundColor), n.primaryHeadingColor && (e.primaryHeadingColor = n.primaryHeadingColor), n.secondaryHeadingColor && (e.secondaryHeadingColor = n.secondaryHeadingColor), super.style(n);
  }
  _applyStyles() {
    super._applyStyles();
    const n = this.options;
    this._headElement && n.headerBackgroundColor && (this._headElement.style.backgroundColor = n.headerBackgroundColor.toString()), this._primaryHeading && n.primaryHeadingColor && (this._primaryHeading.style.color = n.primaryHeadingColor.toString()), this._secondaryHeading && n.secondaryHeadingColor && (this._secondaryHeading.style.color = n.secondaryHeadingColor.toString()), this._bodyElement && n.frameColor && (this._bodyElement.style.borderColor = n.frameColor.toString());
  }
  _fillContainer(n) {
    this.setCssClass("peekview-widget"), this._headElement = Q(".head"), this._bodyElement = Q(".body"), this._fillHead(this._headElement), this._fillBody(this._bodyElement), n.appendChild(this._headElement), n.appendChild(this._bodyElement);
  }
  _fillHead(n, e) {
    this._titleElement = Q(".peekview-title"), this.options.supportOnTitleClick && (this._titleElement.classList.add("clickable"), bi(this._titleElement, "click", ((s) => this._onTitleClick(s)))), Z(this._headElement, this._titleElement), this._fillTitleIcon(this._titleElement), this._primaryHeading = Q("span.filename"), this._secondaryHeading = Q("span.dirname"), this._metaHeading = Q("span.meta"), Z(this._titleElement, this._primaryHeading, this._secondaryHeading, this._metaHeading);
    const t = Q(".peekview-actions");
    Z(this._headElement, t);
    const i = this._getActionBarOptions();
    this._actionbarWidget = new sr(t, i), this._disposables.add(this._actionbarWidget), e || this._actionbarWidget.push(new Qs("peekview.close", m(0, "Close"), Ee.asClassName(ne.close), !0, (() => (this.dispose(), Promise.resolve()))), { label: !1, icon: !0 });
  }
  _fillTitleIcon(n) {
  }
  _getActionBarOptions() {
    return { actionViewItemProvider: JW.bind(void 0, this.instantiationService), orientation: 0 };
  }
  _onTitleClick(n) {
  }
  setTitle(n, e) {
    this._primaryHeading && this._secondaryHeading && (this._primaryHeading.innerText = n, this._primaryHeading.setAttribute("title", n), e ? this._secondaryHeading.innerText = e : Un(this._secondaryHeading));
  }
  setMetaTitle(n) {
    this._metaHeading && (n ? (this._metaHeading.innerText = n, bo(this._metaHeading)) : Ts(this._metaHeading));
  }
  _doLayout(n, e) {
    if (!this._isShowing && n < 0) return void this.dispose();
    const t = Math.ceil(1.2 * this.editor.getOption(67)), i = Math.round(n - (t + 2));
    this._doLayoutHead(t, e), this._doLayoutBody(i, e);
  }
  _doLayoutHead(n, e) {
    this._headElement && (this._headElement.style.height = `${n}px`, this._headElement.style.lineHeight = this._headElement.style.height);
  }
  _doLayoutBody(n, e) {
    this._bodyElement && (this._bodyElement.style.height = `${n}px`);
  }
};
cS = uz([gz(2, Se)], cS);
const Gre = I("peekViewTitle.background", { dark: "#252526", light: "#F3F3F3", hcDark: z.black, hcLight: z.white }, m(0, "Background color of the peek view title area.")), mz = I("peekViewTitleLabel.foreground", { dark: z.white, light: z.black, hcDark: z.white, hcLight: Go }, m(0, "Color of the peek view title.")), fz = I("peekViewTitleDescription.foreground", { dark: "#ccccccb3", light: "#616161", hcDark: "#FFFFFF99", hcLight: "#292929" }, m(0, "Color of the peek view title info.")), Zre = I("peekView.border", { dark: Rs, light: Rs, hcDark: ot, hcLight: ot }, m(0, "Color of the peek view borders and arrow.")), Yre = I("peekViewResult.background", { dark: "#252526", light: "#F3F3F3", hcDark: z.black, hcLight: z.white }, m(0, "Background color of the peek view result list."));
I("peekViewResult.lineForeground", { dark: "#bbbbbb", light: "#646465", hcDark: z.white, hcLight: Go }, m(0, "Foreground color for line nodes in the peek view result list.")), I("peekViewResult.fileForeground", { dark: z.white, light: "#1E1E1E", hcDark: z.white, hcLight: Go }, m(0, "Foreground color for file nodes in the peek view result list.")), I("peekViewResult.selectionBackground", { dark: "#3399ff33", light: "#3399ff33", hcDark: null, hcLight: null }, m(0, "Background color of the selected entry in the peek view result list.")), I("peekViewResult.selectionForeground", { dark: z.white, light: "#6C6C6C", hcDark: z.white, hcLight: Go }, m(0, "Foreground color of the selected entry in the peek view result list."));
const Yd = I("peekViewEditor.background", { dark: "#001F33", light: "#F2F8FC", hcDark: z.black, hcLight: z.white }, m(0, "Background color of the peek view editor."));
I("peekViewEditorGutter.background", { dark: Yd, light: Yd, hcDark: Yd, hcLight: Yd }, m(0, "Background color of the gutter in the peek view editor.")), I("peekViewEditorStickyScroll.background", { dark: Yd, light: Yd, hcDark: Yd, hcLight: Yd }, m(0, "Background color of sticky scroll in the peek view editor.")), I("peekViewResult.matchHighlightBackground", { dark: "#ea5c004d", light: "#ea5c004d", hcDark: null, hcLight: null }, m(0, "Match highlight color in the peek view result list.")), I("peekViewEditor.matchHighlightBackground", { dark: "#ff8f0099", light: "#f5d802de", hcDark: null, hcLight: null }, m(0, "Match highlight color in the peek view editor.")), I("peekViewEditor.matchHighlightBorder", { dark: null, light: null, hcDark: Zt, hcLight: Zt }, m(0, "Match highlight border in the peek view editor."));
class rc {
  constructor(e, t, i, s) {
    this.isProviderFirst = e, this.parent = t, this.link = i, this._rangeCallback = s, this.id = TI.nextId();
  }
  get uri() {
    return this.link.uri;
  }
  get range() {
    var e, t;
    return (t = (e = this._range) !== null && e !== void 0 ? e : this.link.targetSelectionRange) !== null && t !== void 0 ? t : this.link.range;
  }
  set range(e) {
    this._range = e, this._rangeCallback(this);
  }
  get ariaMessage() {
    var e;
    const t = (e = this.parent.getPreview(this)) === null || e === void 0 ? void 0 : e.preview(this.range);
    return t ? m(0, "{0} in {1} on line {2} at column {3}", t.value, ir(this.uri), this.range.startLineNumber, this.range.startColumn) : m(0, "in {0} on line {1} at column {2}", ir(this.uri), this.range.startLineNumber, this.range.startColumn);
  }
}
class Xre {
  constructor(e) {
    this._modelReference = e;
  }
  dispose() {
    this._modelReference.dispose();
  }
  preview(e, t = 8) {
    const i = this._modelReference.object.textEditorModel;
    if (!i) return;
    const { startLineNumber: s, startColumn: o, endLineNumber: r, endColumn: a } = e, l = i.getWordUntilPosition({ lineNumber: s, column: o - t }), d = new D(s, l.startColumn, s, o), h = new D(r, a, r, 1073741824), c = i.getValueInRange(d).replace(/^\s+/, ""), u = i.getValueInRange(e);
    return { value: c + u + i.getValueInRange(h).replace(/\s+$/, ""), highlight: { start: c.length, end: c.length + u.length } };
  }
}
class e1 {
  constructor(e, t) {
    this.parent = e, this.uri = t, this.children = [], this._previews = new Di();
  }
  dispose() {
    Ht(this._previews.values()), this._previews.clear();
  }
  getPreview(e) {
    return this._previews.get(e.uri);
  }
  get ariaMessage() {
    const e = this.children.length;
    return e === 1 ? m(0, "1 symbol in {0}, full path {1}", ir(this.uri), this.uri.fsPath) : m(0, "{0} symbols in {1}, full path {2}", e, ir(this.uri), this.uri.fsPath);
  }
  async resolve(e) {
    if (this._previews.size !== 0) return this;
    for (const t of this.children) if (!this._previews.has(t.uri)) try {
      const i = await e.createModelReference(t.uri);
      this._previews.set(t.uri, new Xre(i));
    } catch (i) {
      We(i);
    }
    return this;
  }
}
class Js {
  constructor(e, t) {
    this.groups = [], this.references = [], this._onDidChangeReferenceRange = new F(), this.onDidChangeReferenceRange = this._onDidChangeReferenceRange.event, this._links = e, this._title = t;
    const [i] = e;
    let s;
    e.sort(Js._compareReferences);
    for (const o of e) if (s && Yt.isEqual(s.uri, o.uri, !0) || (s = new e1(this, o.uri), this.groups.push(s)), s.children.length === 0 || Js._compareReferences(o, s.children[s.children.length - 1]) !== 0) {
      const r = new rc(i === o, s, o, ((a) => this._onDidChangeReferenceRange.fire(a)));
      this.references.push(r), s.children.push(r);
    }
  }
  dispose() {
    Ht(this.groups), this._onDidChangeReferenceRange.dispose(), this.groups.length = 0;
  }
  clone() {
    return new Js(this._links, this._title);
  }
  get title() {
    return this._title;
  }
  get isEmpty() {
    return this.groups.length === 0;
  }
  get ariaMessage() {
    return this.isEmpty ? m(0, "No results found") : this.references.length === 1 ? m(0, "Found 1 symbol in {0}", this.references[0].uri.fsPath) : this.groups.length === 1 ? m(0, "Found {0} symbols in {1}", this.references.length, this.groups[0].uri.fsPath) : m(0, "Found {0} symbols in {1} files", this.references.length, this.groups.length);
  }
  nextOrPreviousReference(e, t) {
    const { parent: i } = e;
    let s = i.children.indexOf(e);
    const o = i.children.length, r = i.parent.groups.length;
    return r === 1 || t && s + 1 < o || !t && s > 0 ? (s = t ? (s + 1) % o : (s + o - 1) % o, i.children[s]) : (s = i.parent.groups.indexOf(i), t ? (s = (s + 1) % r, i.parent.groups[s].children[0]) : (s = (s + r - 1) % r, i.parent.groups[s].children[i.parent.groups[s].children.length - 1]));
  }
  nearestReference(e, t) {
    const i = this.references.map(((s, o) => ({ idx: o, prefixLen: mc(s.uri.toString(), e.toString()), offsetDist: 100 * Math.abs(s.range.startLineNumber - t.lineNumber) + Math.abs(s.range.startColumn - t.column) }))).sort(((s, o) => s.prefixLen > o.prefixLen ? -1 : s.prefixLen < o.prefixLen ? 1 : s.offsetDist < o.offsetDist ? -1 : s.offsetDist > o.offsetDist ? 1 : 0))[0];
    if (i) return this.references[i.idx];
  }
  referenceAt(e, t) {
    for (const i of this.references) if (i.uri.toString() === e.toString() && D.containsPosition(i.range, t)) return i;
  }
  firstReference() {
    for (const e of this.references) if (e.isProviderFirst) return e;
    return this.references[0];
  }
  static _compareReferences(e, t) {
    return Yt.compare(e.uri, t.uri) || D.compareRangesUsingStarts(e.range, t.range);
  }
}
var fM, JL = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, ek = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let _M = class {
  constructor(n) {
    this._resolverService = n;
  }
  hasChildren(n) {
    return n instanceof Js || n instanceof e1;
  }
  getChildren(n) {
    if (n instanceof Js) return n.groups;
    if (n instanceof e1) return n.resolve(this._resolverService).then(((e) => e.children));
    throw new Error("bad tree");
  }
};
_M = JL([ek(0, Ps)], _M);
class Qre {
  getHeight() {
    return 23;
  }
  getTemplateId(e) {
    return e instanceof e1 ? k0.id : H1.id;
  }
}
let vM = class {
  constructor(n) {
    this._keybindingService = n;
  }
  getKeyboardNavigationLabel(n) {
    var e;
    if (n instanceof rc) {
      const t = (e = n.parent.getPreview(n)) === null || e === void 0 ? void 0 : e.preview(n.range);
      if (t) return t.value;
    }
    return ir(n.uri);
  }
};
vM = JL([ek(0, Dt)], vM);
class Jre {
  getId(e) {
    return e instanceof rc ? e.id : e.uri;
  }
}
let bM = class extends V {
  constructor(n, e) {
    super(), this._labelService = e;
    const t = document.createElement("div");
    t.classList.add("reference-file"), this.file = this._register(new Yy(t, { supportHighlights: !0 })), this.badge = new v2(Z(t, Q(".count")), {}, XW), n.appendChild(t);
  }
  set(n, e) {
    const t = uL(n.uri);
    this.file.setLabel(this._labelService.getUriBasenameLabel(n.uri), this._labelService.getUriLabel(t, { relative: !0 }), { title: this._labelService.getUriLabel(n.uri), matches: e });
    const i = n.children.length;
    this.badge.setCount(i), i > 1 ? this.badge.setTitleFormat(m(0, "{0} references", i)) : this.badge.setTitleFormat(m(0, "{0} reference", i));
  }
};
bM = JL([ek(1, $m)], bM);
let k0 = fM = class {
  constructor(n) {
    this._instantiationService = n, this.templateId = fM.id;
  }
  renderTemplate(n) {
    return this._instantiationService.createInstance(bM, n);
  }
  renderElement(n, e, t) {
    t.set(n.element, I1(n.filterData));
  }
  disposeTemplate(n) {
    n.dispose();
  }
};
k0.id = "FileReferencesRenderer", k0 = fM = JL([ek(0, Se)], k0);
class eae extends V {
  constructor(e) {
    super(), this.label = this._register(new sc(e));
  }
  set(e, t) {
    var i;
    const s = (i = e.parent.getPreview(e)) === null || i === void 0 ? void 0 : i.preview(e.range);
    if (s && s.value) {
      const { value: o, highlight: r } = s;
      t && !la.isDefault(t) ? (this.label.element.classList.toggle("referenceMatch", !1), this.label.set(o, I1(t))) : (this.label.element.classList.toggle("referenceMatch", !0), this.label.set(o, [r]));
    } else this.label.set(`${ir(e.uri)}:${e.range.startLineNumber + 1}:${e.range.startColumn + 1}`);
  }
}
class H1 {
  constructor() {
    this.templateId = H1.id;
  }
  renderTemplate(e) {
    return new eae(e);
  }
  renderElement(e, t, i) {
    i.set(e.element, e.filterData);
  }
  disposeTemplate(e) {
    e.dispose();
  }
}
H1.id = "OneReferenceRenderer";
class tae {
  getWidgetAriaLabel() {
    return m(0, "References");
  }
  getAriaLabel(e) {
    return e.ariaMessage;
  }
}
var iae = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Al = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class tk {
  constructor(e, t) {
    this._editor = e, this._model = t, this._decorations = /* @__PURE__ */ new Map(), this._decorationIgnoreSet = /* @__PURE__ */ new Set(), this._callOnDispose = new G(), this._callOnModelChange = new G(), this._callOnDispose.add(this._editor.onDidChangeModel((() => this._onModelChanged()))), this._onModelChanged();
  }
  dispose() {
    this._callOnModelChange.dispose(), this._callOnDispose.dispose(), this.removeDecorations();
  }
  _onModelChanged() {
    this._callOnModelChange.clear();
    const e = this._editor.getModel();
    if (e) {
      for (const t of this._model.references) if (t.uri.toString() === e.uri.toString()) return void this._addDecorations(t.parent);
    }
  }
  _addDecorations(e) {
    if (!this._editor.hasModel()) return;
    this._callOnModelChange.add(this._editor.getModel().onDidChangeDecorations((() => this._onDecorationChanged())));
    const t = [], i = [];
    for (let s = 0, o = e.children.length; s < o; s++) {
      const r = e.children[s];
      this._decorationIgnoreSet.has(r.id) || r.uri.toString() === this._editor.getModel().uri.toString() && (t.push({ range: r.range, options: tk.DecorationOptions }), i.push(s));
    }
    this._editor.changeDecorations(((s) => {
      const o = s.deltaDecorations([], t);
      for (let r = 0; r < o.length; r++) this._decorations.set(o[r], e.children[i[r]]);
    }));
  }
  _onDecorationChanged() {
    const e = [], t = this._editor.getModel();
    if (t) {
      for (const [i, s] of this._decorations) {
        const o = t.getDecorationRange(i);
        if (!o) continue;
        let r = !1;
        D.equalsRange(o, s.range) || ((D.spansMultipleLines(o) || s.range.endColumn - s.range.startColumn !== o.endColumn - o.startColumn) && (r = !0), r ? (this._decorationIgnoreSet.add(s.id), e.push(i)) : s.range = o);
      }
      for (let i = 0, s = e.length; i < s; i++) this._decorations.delete(e[i]);
      this._editor.removeDecorations(e);
    }
  }
  removeDecorations() {
    this._editor.removeDecorations([...this._decorations.keys()]), this._decorations.clear();
  }
}
tk.DecorationOptions = Ve.register({ description: "reference-decoration", stickiness: 1, className: "reference-decoration" });
class nae {
  constructor() {
    this.ratio = 0.7, this.heightInLines = 18;
  }
  static fromJSON(e) {
    let t, i;
    try {
      const s = JSON.parse(e);
      t = s.ratio, i = s.heightInLines;
    } catch {
    }
    return { ratio: t || 0.7, heightInLines: i || 18 };
  }
}
class sae extends p2 {
}
let CM = class extends cS {
  constructor(n, e, t, i, s, o, r, a, l, d, h, c) {
    super(n, { showFrame: !1, showArrow: !0, isResizeable: !0, isAccessible: !0, supportOnTitleClick: !0 }, o), this._defaultTreeKeyboardSupport = e, this.layoutData = t, this._textModelResolverService = s, this._instantiationService = o, this._peekViewService = r, this._uriLabel = a, this._undoRedoService = l, this._keybindingService = d, this._languageService = h, this._languageConfigurationService = c, this._disposeOnNewModel = new G(), this._callOnDispose = new G(), this._onDidSelectReference = new F(), this.onDidSelectReference = this._onDidSelectReference.event, this._dim = new bt(0, 0), this._applyTheme(i.getColorTheme()), this._callOnDispose.add(i.onDidColorThemeChange(this._applyTheme.bind(this))), this._peekViewService.addExclusiveWidget(n, this), this.create();
  }
  dispose() {
    this.setModel(void 0), this._callOnDispose.dispose(), this._disposeOnNewModel.dispose(), Ht(this._preview), Ht(this._previewNotAvailableMessage), Ht(this._tree), Ht(this._previewModelReference), this._splitView.dispose(), super.dispose();
  }
  _applyTheme(n) {
    const e = n.getColor(Zre) || z.transparent;
    this.style({ arrowColor: e, frameColor: e, headerBackgroundColor: n.getColor(Gre) || z.transparent, primaryHeadingColor: n.getColor(mz), secondaryHeadingColor: n.getColor(fz) });
  }
  show(n) {
    super.show(n, this.layoutData.heightInLines || 18);
  }
  focusOnReferenceTree() {
    this._tree.domFocus();
  }
  focusOnPreviewEditor() {
    this._preview.focus();
  }
  isPreviewEditorFocused() {
    return this._preview.hasTextFocus();
  }
  _onTitleClick(n) {
    this._preview && this._preview.getModel() && this._onDidSelectReference.fire({ element: this._getFocusedReference(), kind: n.ctrlKey || n.metaKey || n.altKey ? "side" : "open", source: "title" });
  }
  _fillBody(n) {
    this.setCssClass("reference-zone-widget"), this._messageContainer = Z(n, Q("div.messages")), Ts(this._messageContainer), this._splitView = new nV(n, { orientation: 1 }), this._previewContainer = Z(n, Q("div.preview.inline")), this._preview = this._instantiationService.createInstance(Mc, this._previewContainer, { scrollBeyondLastLine: !1, scrollbar: { verticalScrollbarSize: 14, horizontal: "auto", useShadows: !0, verticalHasArrows: !1, horizontalHasArrows: !1, alwaysConsumeMouseWheel: !0 }, overviewRulerLanes: 2, fixedOverflowWidgets: !0, minimap: { enabled: !1 } }, {}, this.editor), Ts(this._previewContainer), this._previewNotAvailableMessage = new Pa(m(0, "no preview available"), ko, Pa.DEFAULT_CREATION_OPTIONS, null, this._undoRedoService, this._languageService, this._languageConfigurationService), this._treeContainer = Z(n, Q("div.ref-tree.inline"));
    const e = { keyboardSupport: this._defaultTreeKeyboardSupport, accessibilityProvider: new tae(), keyboardNavigationLabelProvider: this._instantiationService.createInstance(vM), identityProvider: new Jre(), openOnSingleClick: !0, selectionNavigation: !0, overrideStyles: { listBackground: Yre } };
    this._defaultTreeKeyboardSupport && this._callOnDispose.add(bi(this._treeContainer, "keydown", ((i) => {
      i.equals(9) && (this._keybindingService.dispatchEvent(i, i.target), i.stopPropagation());
    }), !0)), this._tree = this._instantiationService.createInstance(sae, "ReferencesWidget", this._treeContainer, new Qre(), [this._instantiationService.createInstance(k0), this._instantiationService.createInstance(H1)], this._instantiationService.createInstance(_M), e), this._splitView.addView({ onDidChange: se.None, element: this._previewContainer, minimumSize: 200, maximumSize: Number.MAX_VALUE, layout: (i) => {
      this._preview.layout({ height: this._dim.height, width: i });
    } }, Ky.Distribute), this._splitView.addView({ onDidChange: se.None, element: this._treeContainer, minimumSize: 100, maximumSize: Number.MAX_VALUE, layout: (i) => {
      this._treeContainer.style.height = `${this._dim.height}px`, this._treeContainer.style.width = `${i}px`, this._tree.layout(this._dim.height, i);
    } }, Ky.Distribute), this._disposables.add(this._splitView.onDidSashChange((() => {
      this._dim.width && (this.layoutData.ratio = this._splitView.getViewSize(0) / this._dim.width);
    }), void 0));
    const t = (i, s) => {
      i instanceof rc && (s === "show" && this._revealReference(i, !1), this._onDidSelectReference.fire({ element: i, kind: s, source: "tree" }));
    };
    this._tree.onDidOpen(((i) => {
      i.sideBySide ? t(i.element, "side") : i.editorOptions.pinned ? t(i.element, "goto") : t(i.element, "show");
    })), Ts(this._treeContainer);
  }
  _onWidth(n) {
    this._dim && this._doLayoutBody(this._dim.height, n);
  }
  _doLayoutBody(n, e) {
    super._doLayoutBody(n, e), this._dim = new bt(e, n), this.layoutData.heightInLines = this._viewZone ? this._viewZone.heightInLines : this.layoutData.heightInLines, this._splitView.layout(e), this._splitView.resizeView(0, e * this.layoutData.ratio);
  }
  setSelection(n) {
    return this._revealReference(n, !0).then((() => {
      this._model && (this._tree.setSelection([n]), this._tree.setFocus([n]));
    }));
  }
  setModel(n) {
    return this._disposeOnNewModel.clear(), this._model = n, this._model ? this._onNewModel() : Promise.resolve();
  }
  _onNewModel() {
    return this._model ? this._model.isEmpty ? (this.setTitle(""), this._messageContainer.innerText = m(0, "No results"), bo(this._messageContainer), Promise.resolve(void 0)) : (Ts(this._messageContainer), this._decorationsManager = new tk(this._preview, this._model), this._disposeOnNewModel.add(this._decorationsManager), this._disposeOnNewModel.add(this._model.onDidChangeReferenceRange(((n) => this._tree.rerender(n)))), this._disposeOnNewModel.add(this._preview.onMouseDown(((n) => {
      const { event: e, target: t } = n;
      if (e.detail !== 2) return;
      const i = this._getFocusedReference();
      i && this._onDidSelectReference.fire({ element: { uri: i.uri, range: t.range }, kind: e.ctrlKey || e.metaKey || e.altKey ? "side" : "open", source: "editor" });
    }))), this.container.classList.add("results-loaded"), bo(this._treeContainer), bo(this._previewContainer), this._splitView.layout(this._dim.width), this.focusOnReferenceTree(), this._tree.setInput(this._model.groups.length === 1 ? this._model.groups[0] : this._model)) : Promise.resolve(void 0);
  }
  _getFocusedReference() {
    const [n] = this._tree.getFocus();
    return n instanceof rc ? n : n instanceof e1 && n.children.length > 0 ? n.children[0] : void 0;
  }
  async revealReference(n) {
    await this._revealReference(n, !1), this._onDidSelectReference.fire({ element: n, kind: "goto", source: "tree" });
  }
  async _revealReference(n, e) {
    if (this._revealedReference === n) return;
    this._revealedReference = n, n.uri.scheme !== Ue.inMemory ? this.setTitle(CX(n.uri), this._uriLabel.getUriLabel(uL(n.uri))) : this.setTitle(m(0, "References"));
    const t = this._textModelResolverService.createModelReference(n.uri);
    this._tree.getInput() === n.parent || (e && this._tree.reveal(n.parent), await this._tree.expand(n.parent)), this._tree.reveal(n);
    const i = await t;
    if (!this._model) return void i.dispose();
    Ht(this._previewModelReference);
    const s = i.object;
    if (s) {
      const o = this._preview.getModel() === s.textEditorModel ? 0 : 1, r = D.lift(n.range).collapseToStart();
      this._previewModelReference = i, this._preview.setModel(s.textEditorModel), this._preview.setSelection(r), this._preview.revealRangeInCenter(r, o);
    } else this._preview.setModel(this._previewNotAvailableMessage), i.dispose();
  }
};
CM = iae([Al(3, Yi), Al(4, Ps), Al(5, Se), Al(6, pz), Al(7, $m), Al(8, gL), Al(9, Dt), Al(10, Xt), Al(11, zt)], CM);
var hw, oae = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, ep = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const du = new ae("referenceSearchVisible", !1, m(0, "Whether reference peek is visible, like 'Peek References' or 'Peek Definition'"));
let ac = hw = class {
  static get(n) {
    return n.getContribution(hw.ID);
  }
  constructor(n, e, t, i, s, o, r, a) {
    this._defaultTreeKeyboardSupport = n, this._editor = e, this._editorService = i, this._notificationService = s, this._instantiationService = o, this._storageService = r, this._configurationService = a, this._disposables = new G(), this._requestIdPool = 0, this._ignoreModelChangeEvent = !1, this._referenceSearchVisible = du.bindTo(t);
  }
  dispose() {
    var n, e;
    this._referenceSearchVisible.reset(), this._disposables.dispose(), (n = this._widget) === null || n === void 0 || n.dispose(), (e = this._model) === null || e === void 0 || e.dispose(), this._widget = void 0, this._model = void 0;
  }
  toggleWidget(n, e, t) {
    let i;
    if (this._widget && (i = this._widget.position), this.closeWidget(), i && n.containsPosition(i)) return;
    this._peekMode = t, this._referenceSearchVisible.set(!0), this._disposables.add(this._editor.onDidChangeModelLanguage((() => {
      this.closeWidget();
    }))), this._disposables.add(this._editor.onDidChangeModel((() => {
      this._ignoreModelChangeEvent || this.closeWidget();
    })));
    const s = "peekViewLayout", o = nae.fromJSON(this._storageService.get(s, 0, "{}"));
    this._widget = this._instantiationService.createInstance(CM, this._editor, this._defaultTreeKeyboardSupport, o), this._widget.setTitle(m(0, "Loading...")), this._widget.show(n), this._disposables.add(this._widget.onDidClose((() => {
      e.cancel(), this._widget && (this._storageService.store(s, JSON.stringify(this._widget.layoutData), 0, 1), this._widget = void 0), this.closeWidget();
    }))), this._disposables.add(this._widget.onDidSelectReference(((a) => {
      const { element: l, kind: d } = a;
      if (l) switch (d) {
        case "open":
          a.source === "editor" && this._configurationService.getValue("editor.stablePeek") || this.openReference(l, !1, !1);
          break;
        case "side":
          this.openReference(l, !0, !1);
          break;
        case "goto":
          t ? this._gotoReference(l, !0) : this.openReference(l, !1, !0);
      }
    })));
    const r = ++this._requestIdPool;
    e.then(((a) => {
      var l;
      if (r === this._requestIdPool && this._widget) return (l = this._model) === null || l === void 0 || l.dispose(), this._model = a, this._widget.setModel(this._model).then((() => {
        if (this._widget && this._model && this._editor.hasModel()) {
          this._model.isEmpty ? this._widget.setMetaTitle("") : this._widget.setMetaTitle(m(0, "{0} ({1})", this._model.title, this._model.references.length));
          const d = this._editor.getModel().uri, h = new W(n.startLineNumber, n.startColumn), c = this._model.nearestReference(d, h);
          if (c) return this._widget.setSelection(c).then((() => {
            this._widget && this._editor.getOption(87) === "editor" && this._widget.focusOnPreviewEditor();
          }));
        }
      }));
      a.dispose();
    }), ((a) => {
      this._notificationService.error(a);
    }));
  }
  changeFocusBetweenPreviewAndReferences() {
    this._widget && (this._widget.isPreviewEditorFocused() ? this._widget.focusOnReferenceTree() : this._widget.focusOnPreviewEditor());
  }
  async goToNextOrPreviousReference(n) {
    if (!this._editor.hasModel() || !this._model || !this._widget) return;
    const e = this._widget.position;
    if (!e) return;
    const t = this._model.nearestReference(this._editor.getModel().uri, e);
    if (!t) return;
    const i = this._model.nextOrPreviousReference(t, n), s = this._editor.hasTextFocus(), o = this._widget.isPreviewEditorFocused();
    await this._widget.setSelection(i), await this._gotoReference(i, !1), s ? this._editor.focus() : this._widget && o && this._widget.focusOnPreviewEditor();
  }
  async revealReference(n) {
    this._editor.hasModel() && this._model && this._widget && await this._widget.revealReference(n);
  }
  closeWidget(n = !0) {
    var e, t;
    (e = this._widget) === null || e === void 0 || e.dispose(), (t = this._model) === null || t === void 0 || t.dispose(), this._referenceSearchVisible.reset(), this._disposables.clear(), this._widget = void 0, this._model = void 0, n && this._editor.focus(), this._requestIdPool += 1;
  }
  _gotoReference(n, e) {
    var t;
    (t = this._widget) === null || t === void 0 || t.hide(), this._ignoreModelChangeEvent = !0;
    const i = D.lift(n.range).collapseToStart();
    return this._editorService.openCodeEditor({ resource: n.uri, options: { selection: i, selectionSource: "code.jump", pinned: e } }, this._editor).then(((s) => {
      var o;
      if (this._ignoreModelChangeEvent = !1, s && this._widget) if (this._editor === s) this._widget.show(i), this._widget.focusOnReferenceTree();
      else {
        const r = hw.get(s), a = this._model.clone();
        this.closeWidget(), s.focus(), r?.toggleWidget(i, on(((l) => Promise.resolve(a))), (o = this._peekMode) !== null && o !== void 0 && o);
      }
      else this.closeWidget();
    }), ((s) => {
      this._ignoreModelChangeEvent = !1, We(s);
    }));
  }
  openReference(n, e, t) {
    e || this.closeWidget();
    const { uri: i, range: s } = n;
    this._editorService.openCodeEditor({ resource: i, options: { selection: s, selectionSource: "code.jump", pinned: t } }, this._editor, e);
  }
};
function Xc(n, e) {
  const t = (function(s) {
    const o = s.get(mt).getFocusedCodeEditor();
    return o instanceof Mc ? o.getParentEditor() : o;
  })(n);
  if (!t) return;
  const i = ac.get(t);
  i && e(i);
}
ac.ID = "editor.contrib.referencesController", ac = hw = oae([ep(2, Te), ep(3, mt), ep(4, Ri), ep(5, Se), ep(6, Nr), ep(7, Ye)], ac), Es.registerCommandAndKeybindingRule({ id: "togglePeekWidgetFocus", weight: 100, primary: Vi(2089, 60), when: q.or(du, As.inPeekEditor), handler(n) {
  Xc(n, ((e) => {
    e.changeFocusBetweenPreviewAndReferences();
  }));
} }), Es.registerCommandAndKeybindingRule({ id: "goToNextReference", weight: 90, primary: 62, secondary: [70], when: q.or(du, As.inPeekEditor), handler(n) {
  Xc(n, ((e) => {
    e.goToNextOrPreviousReference(!0);
  }));
} }), Es.registerCommandAndKeybindingRule({ id: "goToPreviousReference", weight: 90, primary: 1086, secondary: [1094], when: q.or(du, As.inPeekEditor), handler(n) {
  Xc(n, ((e) => {
    e.goToNextOrPreviousReference(!1);
  }));
} }), dt.registerCommandAlias("goToNextReferenceFromEmbeddedEditor", "goToNextReference"), dt.registerCommandAlias("goToPreviousReferenceFromEmbeddedEditor", "goToPreviousReference"), dt.registerCommandAlias("closeReferenceSearchEditor", "closeReferenceSearch"), dt.registerCommand("closeReferenceSearch", ((n) => Xc(n, ((e) => e.closeWidget())))), Es.registerKeybindingRule({ id: "closeReferenceSearch", weight: -1, primary: 9, secondary: [1033], when: q.and(As.inPeekEditor, q.not("config.editor.stablePeek")) }), Es.registerKeybindingRule({ id: "closeReferenceSearch", weight: 250, primary: 9, secondary: [1033], when: q.and(du, q.not("config.editor.stablePeek"), q.or(E.editorTextFocus, hie.negate())) }), Es.registerCommandAndKeybindingRule({ id: "revealReference", weight: 200, primary: 3, mac: { primary: 3, secondary: [2066] }, when: q.and(du, eF, c2.negate(), u2.negate()), handler(n) {
  var e;
  const t = (e = n.get(Jo).lastFocusedList) === null || e === void 0 ? void 0 : e.getFocus();
  Array.isArray(t) && t[0] instanceof rc && Xc(n, ((i) => i.revealReference(t[0])));
} }), Es.registerCommandAndKeybindingRule({ id: "openReferenceToSide", weight: 100, primary: 2051, mac: { primary: 259 }, when: q.and(du, eF, c2.negate(), u2.negate()), handler(n) {
  var e;
  const t = (e = n.get(Jo).lastFocusedList) === null || e === void 0 ? void 0 : e.getFocus();
  Array.isArray(t) && t[0] instanceof rc && Xc(n, ((i) => i.openReference(t[0], !0, !0)));
} }), dt.registerCommand("openReference", ((n) => {
  var e;
  const t = (e = n.get(Jo).lastFocusedList) === null || e === void 0 ? void 0 : e.getFocus();
  Array.isArray(t) && t[0] instanceof rc && Xc(n, ((i) => i.openReference(t[0], !1, !0)));
}));
var _z = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, P_ = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const wM = new ae("hasSymbols", !1, m(0, "Whether there are symbol locations that can be navigated via keyboard-only.")), cw = tt("ISymbolNavigationService");
let Lx = class {
  constructor(n, e, t, i) {
    this._editorService = e, this._notificationService = t, this._keybindingService = i, this._currentModel = void 0, this._currentIdx = -1, this._ignoreEditorChange = !1, this._ctxHasSymbols = wM.bindTo(n);
  }
  reset() {
    var n, e;
    this._ctxHasSymbols.reset(), (n = this._currentState) === null || n === void 0 || n.dispose(), (e = this._currentMessage) === null || e === void 0 || e.dispose(), this._currentModel = void 0, this._currentIdx = -1;
  }
  put(n) {
    const e = n.parent.parent;
    if (e.references.length <= 1) return void this.reset();
    this._currentModel = e, this._currentIdx = e.references.indexOf(n), this._ctxHasSymbols.set(!0), this._showMessage();
    const t = new yM(this._editorService), i = t.onDidChange(((s) => {
      if (this._ignoreEditorChange) return;
      const o = this._editorService.getActiveCodeEditor();
      if (!o) return;
      const r = o.getModel(), a = o.getPosition();
      if (!r || !a) return;
      let l = !1, d = !1;
      for (const h of e.references) if (XR(h.uri, r.uri)) l = !0, d = d || D.containsPosition(h.range, a);
      else if (l) break;
      l && d || this.reset();
    }));
    this._currentState = yr(t, i);
  }
  revealNext(n) {
    if (!this._currentModel) return Promise.resolve();
    this._currentIdx += 1, this._currentIdx %= this._currentModel.references.length;
    const e = this._currentModel.references[this._currentIdx];
    return this._showMessage(), this._ignoreEditorChange = !0, this._editorService.openCodeEditor({ resource: e.uri, options: { selection: D.collapseToStart(e.range), selectionRevealType: 3 } }, n).finally((() => {
      this._ignoreEditorChange = !1;
    }));
  }
  _showMessage() {
    var n;
    (n = this._currentMessage) === null || n === void 0 || n.dispose();
    const e = this._keybindingService.lookupKeybinding("editor.gotoNextSymbolFromResult"), t = e ? m(0, "Symbol {0} of {1}, {2} for next", this._currentIdx + 1, this._currentModel.references.length, e.getLabel()) : m(0, "Symbol {0} of {1}", this._currentIdx + 1, this._currentModel.references.length);
    this._currentMessage = this._notificationService.status(t);
  }
};
Lx = _z([P_(0, Te), P_(1, mt), P_(2, Ri), P_(3, Dt)], Lx), rt(cw, Lx, 1), re(new class extends Zi {
  constructor() {
    super({ id: "editor.gotoNextSymbolFromResult", precondition: wM, kbOpts: { weight: 100, primary: 70 } });
  }
  runEditorCommand(n, e) {
    return n.get(cw).revealNext(e);
  }
}()), Es.registerCommandAndKeybindingRule({ id: "editor.gotoNextSymbolFromResult.cancel", weight: 100, when: wM, primary: 9, handler(n) {
  n.get(cw).reset();
} });
let yM = class {
  constructor(n) {
    this._listener = /* @__PURE__ */ new Map(), this._disposables = new G(), this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._disposables.add(n.onCodeEditorRemove(this._onDidRemoveEditor, this)), this._disposables.add(n.onCodeEditorAdd(this._onDidAddEditor, this)), n.listCodeEditors().forEach(this._onDidAddEditor, this);
  }
  dispose() {
    this._disposables.dispose(), this._onDidChange.dispose(), Ht(this._listener.values());
  }
  _onDidAddEditor(n) {
    this._listener.set(n, yr(n.onDidChangeCursorPosition(((e) => this._onDidChange.fire({ editor: n }))), n.onDidChangeModelContent(((e) => this._onDidChange.fire({ editor: n })))));
  }
  _onDidRemoveEditor(n) {
    var e;
    (e = this._listener.get(n)) === null || e === void 0 || e.dispose(), this._listener.delete(n);
  }
};
async function z1(n, e, t, i) {
  const s = t.ordered(n).map(((o) => Promise.resolve(i(o, n, e)).then(void 0, ((r) => {
    Ni(r);
  }))));
  return ha((await Promise.all(s)).flat());
}
function ik(n, e, t, i) {
  return z1(e, t, n, ((s, o, r) => s.provideDefinition(o, r, i)));
}
function vz(n, e, t, i) {
  return z1(e, t, n, ((s, o, r) => s.provideDeclaration(o, r, i)));
}
function bz(n, e, t, i) {
  return z1(e, t, n, ((s, o, r) => s.provideImplementation(o, r, i)));
}
function Cz(n, e, t, i) {
  return z1(e, t, n, ((s, o, r) => s.provideTypeDefinition(o, r, i)));
}
function uS(n, e, t, i, s) {
  return z1(e, t, n, (async (o, r, a) => {
    const l = await o.provideReferences(r, a, { includeDeclaration: !0 }, s);
    if (!i || !l || l.length !== 2) return l;
    const d = await o.provideReferences(r, a, { includeDeclaration: !1 }, s);
    return d && d.length === 1 ? d : l;
  }));
}
async function Jf(n) {
  const e = await n(), t = new Js(e, ""), i = t.references.map(((s) => s.link));
  return t.dispose(), i;
}
var Gb, Zb, Yb, kx, Dx, xx, Nx, Ex;
yM = _z([P_(0, mt)], yM), ja("_executeDefinitionProvider", ((n, e, t) => {
  const i = ik(n.get(fe).definitionProvider, e, t, et.None);
  return Jf((() => i));
})), ja("_executeTypeDefinitionProvider", ((n, e, t) => {
  const i = Cz(n.get(fe).typeDefinitionProvider, e, t, et.None);
  return Jf((() => i));
})), ja("_executeDeclarationProvider", ((n, e, t) => {
  const i = vz(n.get(fe).declarationProvider, e, t, et.None);
  return Jf((() => i));
})), ja("_executeReferenceProvider", ((n, e, t) => {
  const i = uS(n.get(fe).referenceProvider, e, t, !1, et.None);
  return Jf((() => i));
})), ja("_executeImplementationProvider", ((n, e, t) => {
  const i = bz(n.get(fe).implementationProvider, e, t, et.None);
  return Jf((() => i));
})), tn.appendMenuItem(x.EditorContext, { submenu: x.EditorContextPeek, title: m(0, "Peek"), group: "navigation", order: 100 });
class af {
  static is(e) {
    return !(!e || typeof e != "object") && (e instanceof af || !(!W.isIPosition(e.position) || !e.model));
  }
  constructor(e, t) {
    this.model = e, this.position = t;
  }
}
class Xn extends Qr {
  static all() {
    return Xn._allSymbolNavigationCommands.values();
  }
  static _patchConfig(e) {
    const t = { ...e, f1: !0 };
    if (t.menu) for (const i of at.wrap(t.menu)) i.id !== x.EditorContext && i.id !== x.EditorContextPeek || (i.when = q.and(e.precondition, i.when));
    return t;
  }
  constructor(e, t) {
    super(Xn._patchConfig(t)), this.configuration = e, Xn._allSymbolNavigationCommands.set(t.id, this);
  }
  runEditorCommand(e, t, i, s) {
    if (!t.hasModel()) return Promise.resolve(void 0);
    const o = e.get(Ri), r = e.get(mt), a = e.get(Nc), l = e.get(cw), d = e.get(fe), h = e.get(Se), c = t.getModel(), u = t.getPosition(), g = af.is(i) ? i : new af(c, u), p = new Ic(t, 5), f = f1(this._getLocationModel(d, g.model, g.position, p.token), p.token).then((async (_) => {
      var v;
      if (!_ || p.token.isCancellationRequested) return;
      let b;
      if (Io(_.ariaMessage), _.referenceAt(c.uri, u)) {
        const w = this._getAlternativeCommand(t);
        !Xn._activeAlternativeCommands.has(w) && Xn._allSymbolNavigationCommands.has(w) && (b = Xn._allSymbolNavigationCommands.get(w));
      }
      const C = _.references.length;
      if (C === 0) {
        if (!this.configuration.muteMessage) {
          const w = c.getWordAtPosition(u);
          (v = bs.get(t)) === null || v === void 0 || v.showMessage(this._getNoResultFoundMessage(w), u);
        }
      } else {
        if (C !== 1 || !b) return this._onResult(r, l, t, _, s);
        Xn._activeAlternativeCommands.add(this.desc.id), h.invokeFunction(((w) => b.runEditorCommand(w, t, i, s).finally((() => {
          Xn._activeAlternativeCommands.delete(this.desc.id);
        }))));
      }
    }), ((_) => {
      o.error(_);
    })).finally((() => {
      p.dispose();
    }));
    return a.showWhile(f, 250), f;
  }
  async _onResult(e, t, i, s, o) {
    const r = this._getGoToPreference(i);
    if (i instanceof Mc || !(this.configuration.openInPeek || r === "peek" && s.references.length > 1)) {
      const a = s.firstReference(), l = s.references.length > 1 && r === "gotoAndPeek", d = await this._openReference(i, e, a, this.configuration.openToSide, !l);
      l && d ? this._openInPeek(d, s, o) : s.dispose(), r === "goto" && t.put(a);
    } else this._openInPeek(i, s, o);
  }
  async _openReference(e, t, i, s, o) {
    let r;
    var a;
    if ((a = i) && Ie.isUri(a.uri) && D.isIRange(a.range) && (D.isIRange(a.originSelectionRange) || D.isIRange(a.targetSelectionRange)) && (r = i.targetSelectionRange), r || (r = i.range), !r) return;
    const l = await t.openCodeEditor({ resource: i.uri, options: { selection: D.collapseToStart(r), selectionRevealType: 3, selectionSource: "code.jump" } }, e, s);
    if (l) {
      if (o) {
        const d = l.getModel(), h = l.createDecorationsCollection([{ range: r, options: { description: "symbol-navigate-action-highlight", className: "symbolHighlight" } }]);
        setTimeout((() => {
          l.getModel() === d && h.clear();
        }), 350);
      }
      return l;
    }
  }
  _openInPeek(e, t, i) {
    const s = ac.get(e);
    s && e.hasModel() ? s.toggleWidget(i ?? e.getSelection(), on(((o) => Promise.resolve(t))), this.configuration.openInPeek) : t.dispose();
  }
}
Xn._allSymbolNavigationCommands = /* @__PURE__ */ new Map(), Xn._activeAlternativeCommands = /* @__PURE__ */ new Set();
class D0 extends Xn {
  async _getLocationModel(e, t, i, s) {
    return new Js(await ik(e.definitionProvider, t, i, s), m(0, "Definitions"));
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? m(0, "No definition found for '{0}'", e.word) : m(0, "No definition found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(58).alternativeDefinitionCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(58).multipleDefinitions;
  }
}
Ft(((Gb = class extends D0 {
  constructor() {
    super({ openToSide: !1, openInPeek: !1, muteMessage: !1 }, { id: Gb.id, title: { ...ct(0, "Go to Definition"), mnemonicTitle: m(0, "Go to &&Definition") }, precondition: E.hasDefinitionProvider, keybinding: [{ when: E.editorTextFocus, primary: 70, weight: 100 }, { when: q.and(E.editorTextFocus, J3), primary: 2118, weight: 100 }], menu: [{ id: x.EditorContext, group: "navigation", order: 1.1 }, { id: x.MenubarGoMenu, precondition: null, group: "4_symbol_nav", order: 2 }] }), dt.registerCommandAlias("editor.action.goToDeclaration", Gb.id);
  }
}).id = "editor.action.revealDefinition", Gb)), Ft(((Zb = class extends D0 {
  constructor() {
    super({ openToSide: !0, openInPeek: !1, muteMessage: !1 }, { id: Zb.id, title: ct(0, "Open Definition to the Side"), precondition: q.and(E.hasDefinitionProvider, E.isInEmbeddedEditor.toNegated()), keybinding: [{ when: E.editorTextFocus, primary: Vi(2089, 70), weight: 100 }, { when: q.and(E.editorTextFocus, J3), primary: Vi(2089, 2118), weight: 100 }] }), dt.registerCommandAlias("editor.action.openDeclarationToTheSide", Zb.id);
  }
}).id = "editor.action.revealDefinitionAside", Zb)), Ft(((Yb = class extends D0 {
  constructor() {
    super({ openToSide: !1, openInPeek: !0, muteMessage: !1 }, { id: Yb.id, title: ct(0, "Peek Definition"), precondition: q.and(E.hasDefinitionProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), keybinding: { when: E.editorTextFocus, primary: 582, linux: { primary: 3140 }, weight: 100 }, menu: { id: x.EditorContextPeek, group: "peek", order: 2 } }), dt.registerCommandAlias("editor.action.previewDeclaration", Yb.id);
  }
}).id = "editor.action.peekDefinition", Yb));
class L6 extends Xn {
  async _getLocationModel(e, t, i, s) {
    return new Js(await vz(e.declarationProvider, t, i, s), m(0, "Declarations"));
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? m(0, "No declaration found for '{0}'", e.word) : m(0, "No declaration found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(58).alternativeDeclarationCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(58).multipleDeclarations;
  }
}
Ft(((kx = class extends L6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !1, muteMessage: !1 }, { id: kx.id, title: { ...ct(0, "Go to Declaration"), mnemonicTitle: m(0, "Go to &&Declaration") }, precondition: q.and(E.hasDeclarationProvider, E.isInEmbeddedEditor.toNegated()), menu: [{ id: x.EditorContext, group: "navigation", order: 1.3 }, { id: x.MenubarGoMenu, precondition: null, group: "4_symbol_nav", order: 3 }] });
  }
  _getNoResultFoundMessage(n) {
    return n && n.word ? m(0, "No declaration found for '{0}'", n.word) : m(0, "No declaration found");
  }
}).id = "editor.action.revealDeclaration", kx)), Ft(class extends L6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !0, muteMessage: !1 }, { id: "editor.action.peekDeclaration", title: ct(0, "Peek Declaration"), precondition: q.and(E.hasDeclarationProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), menu: { id: x.EditorContextPeek, group: "peek", order: 3 } });
  }
});
class k6 extends Xn {
  async _getLocationModel(e, t, i, s) {
    return new Js(await Cz(e.typeDefinitionProvider, t, i, s), m(0, "Type Definitions"));
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? m(0, "No type definition found for '{0}'", e.word) : m(0, "No type definition found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(58).alternativeTypeDefinitionCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(58).multipleTypeDefinitions;
  }
}
Ft(((Dx = class extends k6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !1, muteMessage: !1 }, { id: Dx.ID, title: { ...ct(0, "Go to Type Definition"), mnemonicTitle: m(0, "Go to &&Type Definition") }, precondition: E.hasTypeDefinitionProvider, keybinding: { when: E.editorTextFocus, primary: 0, weight: 100 }, menu: [{ id: x.EditorContext, group: "navigation", order: 1.4 }, { id: x.MenubarGoMenu, precondition: null, group: "4_symbol_nav", order: 3 }] });
  }
}).ID = "editor.action.goToTypeDefinition", Dx)), Ft(((xx = class extends k6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !0, muteMessage: !1 }, { id: xx.ID, title: ct(0, "Peek Type Definition"), precondition: q.and(E.hasTypeDefinitionProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), menu: { id: x.EditorContextPeek, group: "peek", order: 4 } });
  }
}).ID = "editor.action.peekTypeDefinition", xx));
class D6 extends Xn {
  async _getLocationModel(e, t, i, s) {
    return new Js(await bz(e.implementationProvider, t, i, s), m(0, "Implementations"));
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? m(0, "No implementation found for '{0}'", e.word) : m(0, "No implementation found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(58).alternativeImplementationCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(58).multipleImplementations;
  }
}
Ft(((Nx = class extends D6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !1, muteMessage: !1 }, { id: Nx.ID, title: { ...ct(0, "Go to Implementations"), mnemonicTitle: m(0, "Go to &&Implementations") }, precondition: E.hasImplementationProvider, keybinding: { when: E.editorTextFocus, primary: 2118, weight: 100 }, menu: [{ id: x.EditorContext, group: "navigation", order: 1.45 }, { id: x.MenubarGoMenu, precondition: null, group: "4_symbol_nav", order: 4 }] });
  }
}).ID = "editor.action.goToImplementation", Nx)), Ft(((Ex = class extends D6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !0, muteMessage: !1 }, { id: Ex.ID, title: ct(0, "Peek Implementations"), precondition: q.and(E.hasImplementationProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), keybinding: { when: E.editorTextFocus, primary: 3142, weight: 100 }, menu: { id: x.EditorContextPeek, group: "peek", order: 5 } });
  }
}).ID = "editor.action.peekImplementation", Ex));
class x6 extends Xn {
  _getNoResultFoundMessage(e) {
    return e ? m(0, "No references found for '{0}'", e.word) : m(0, "No references found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(58).alternativeReferenceCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(58).multipleReferences;
  }
}
Ft(class extends x6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !1, muteMessage: !1 }, { id: "editor.action.goToReferences", title: { ...ct(0, "Go to References"), mnemonicTitle: m(0, "Go to &&References") }, precondition: q.and(E.hasReferenceProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), keybinding: { when: E.editorTextFocus, primary: 1094, weight: 100 }, menu: [{ id: x.EditorContext, group: "navigation", order: 1.45 }, { id: x.MenubarGoMenu, precondition: null, group: "4_symbol_nav", order: 5 }] });
  }
  async _getLocationModel(n, e, t, i) {
    return new Js(await uS(n.referenceProvider, e, t, !0, i), m(0, "References"));
  }
}), Ft(class extends x6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !0, muteMessage: !1 }, { id: "editor.action.referenceSearch.trigger", title: ct(0, "Peek References"), precondition: q.and(E.hasReferenceProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), menu: { id: x.EditorContextPeek, group: "peek", order: 6 } });
  }
  async _getLocationModel(n, e, t, i) {
    return new Js(await uS(n.referenceProvider, e, t, !1, i), m(0, "References"));
  }
});
class rae extends Xn {
  constructor(e, t, i) {
    super(e, { id: "editor.action.goToLocation", title: ct(0, "Go to Any Symbol"), precondition: q.and(As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()) }), this._references = t, this._gotoMultipleBehaviour = i;
  }
  async _getLocationModel(e, t, i, s) {
    return new Js(this._references, m(0, "Locations"));
  }
  _getNoResultFoundMessage(e) {
    return e && m(0, "No results for '{0}'", e.word) || "";
  }
  _getGoToPreference(e) {
    var t;
    return (t = this._gotoMultipleBehaviour) !== null && t !== void 0 ? t : e.getOption(58).multipleReferences;
  }
  _getAlternativeCommand() {
    return "";
  }
}
dt.registerCommand({ id: "editor.action.goToLocations", metadata: { description: "Go to locations from a position in a file", args: [{ name: "uri", description: "The text document in which to start", constraint: Ie }, { name: "position", description: "The position at which to start", constraint: W.isIPosition }, { name: "locations", description: "An array of locations.", constraint: Array }, { name: "multiple", description: "Define what to do when having multiple results, either `peek`, `gotoAndPeek`, or `goto`" }, { name: "noResultsMessage", description: "Human readable message that shows when locations is empty." }] }, handler: async (n, e, t, i, s, o, r) => {
  vt(Ie.isUri(e)), vt(W.isIPosition(t)), vt(Array.isArray(i)), vt(s === void 0 || typeof s == "string"), vt(r === void 0 || typeof r == "boolean");
  const a = n.get(mt), l = await a.openCodeEditor({ resource: e }, a.getFocusedCodeEditor());
  if (yl(l)) return l.setPosition(t), l.revealPositionInCenterIfOutsideViewport(t, 0), l.invokeWithinContext(((d) => {
    const h = new class extends rae {
      _getNoResultFoundMessage(c) {
        return o || super._getNoResultFoundMessage(c);
      }
    }({ muteMessage: !o, openInPeek: !!r, openToSide: !1 }, i, s);
    d.get(Se).invokeFunction(h.run.bind(h), l);
  }));
} }), dt.registerCommand({ id: "editor.action.peekLocations", metadata: { description: "Peek locations from a position in a file", args: [{ name: "uri", description: "The text document in which to start", constraint: Ie }, { name: "position", description: "The position at which to start", constraint: W.isIPosition }, { name: "locations", description: "An array of locations.", constraint: Array }, { name: "multiple", description: "Define what to do when having multiple results, either `peek`, `gotoAndPeek`, or `goto`" }] }, handler: async (n, e, t, i, s) => {
  n.get(ai).executeCommand("editor.action.goToLocations", e, t, i, s, void 0, !0);
} }), dt.registerCommand({ id: "editor.action.findReferences", handler: (n, e, t) => {
  vt(Ie.isUri(e)), vt(W.isIPosition(t));
  const i = n.get(fe), s = n.get(mt);
  return s.openCodeEditor({ resource: e }, s.getFocusedCodeEditor()).then(((o) => {
    if (!yl(o) || !o.hasModel()) return;
    const r = ac.get(o);
    if (!r) return;
    const a = on(((d) => uS(i.referenceProvider, o.getModel(), W.lift(t), !1, d).then(((h) => new Js(h, m(0, "References")))))), l = new D(t.lineNumber, t.column, t.lineNumber, t.column);
    return Promise.resolve(r.toggleWidget(l, a, !1));
  }));
} }), dt.registerCommandAlias("editor.action.showReferences", "editor.action.peekLocations");
var O_, aae = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ix = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let hu = O_ = class {
  constructor(n, e, t, i) {
    this.textModelResolverService = e, this.languageService = t, this.languageFeaturesService = i, this.toUnhook = new G(), this.toUnhookForKeyboard = new G(), this.currentWordAtPosition = null, this.previousPromise = null, this.editor = n, this.linkDecorations = this.editor.createDecorationsCollection();
    const s = new XL(n);
    this.toUnhook.add(s), this.toUnhook.add(s.onMouseMoveOrRelevantKeyDown((([o, r]) => {
      this.startFindDefinitionFromMouse(o, r ?? void 0);
    }))), this.toUnhook.add(s.onExecute(((o) => {
      this.isEnabled(o) && this.gotoDefinition(o.target.position, o.hasSideBySideModifier).catch(((r) => {
        We(r);
      })).finally((() => {
        this.removeLinkDecorations();
      }));
    }))), this.toUnhook.add(s.onCancel((() => {
      this.removeLinkDecorations(), this.currentWordAtPosition = null;
    })));
  }
  static get(n) {
    return n.getContribution(O_.ID);
  }
  async startFindDefinitionFromCursor(n) {
    await this.startFindDefinition(n), this.toUnhookForKeyboard.add(this.editor.onDidChangeCursorPosition((() => {
      this.currentWordAtPosition = null, this.removeLinkDecorations(), this.toUnhookForKeyboard.clear();
    }))), this.toUnhookForKeyboard.add(this.editor.onKeyDown(((e) => {
      e && (this.currentWordAtPosition = null, this.removeLinkDecorations(), this.toUnhookForKeyboard.clear());
    })));
  }
  startFindDefinitionFromMouse(n, e) {
    if (n.target.type === 9 && this.linkDecorations.length > 0) return;
    if (!this.editor.hasModel() || !this.isEnabled(n, e)) return this.currentWordAtPosition = null, void this.removeLinkDecorations();
    const t = n.target.position;
    this.startFindDefinition(t);
  }
  async startFindDefinition(n) {
    var e;
    this.toUnhookForKeyboard.clear();
    const t = n ? (e = this.editor.getModel()) === null || e === void 0 ? void 0 : e.getWordAtPosition(n) : null;
    if (!t) return this.currentWordAtPosition = null, void this.removeLinkDecorations();
    if (this.currentWordAtPosition && this.currentWordAtPosition.startColumn === t.startColumn && this.currentWordAtPosition.endColumn === t.endColumn && this.currentWordAtPosition.word === t.word) return;
    this.currentWordAtPosition = t;
    const i = new tH(this.editor, 15);
    let s;
    this.previousPromise && (this.previousPromise.cancel(), this.previousPromise = null), this.previousPromise = on(((r) => this.findDefinition(n, r)));
    try {
      s = await this.previousPromise;
    } catch (r) {
      return void We(r);
    }
    if (!s || !s.length || !i.validate(this.editor)) return void this.removeLinkDecorations();
    const o = s[0].originSelectionRange ? D.lift(s[0].originSelectionRange) : new D(n.lineNumber, t.startColumn, n.lineNumber, t.endColumn);
    if (s.length > 1) {
      let r = o;
      for (const { originSelectionRange: a } of s) a && (r = D.plusRange(r, a));
      this.addDecoration(r, new Vn().appendText(m(0, "Click to show {0} definitions.", s.length)));
    } else {
      const r = s[0];
      if (!r.uri) return;
      this.textModelResolverService.createModelReference(r.uri).then(((a) => {
        if (!a.object || !a.object.textEditorModel) return void a.dispose();
        const { object: { textEditorModel: l } } = a, { startLineNumber: d } = r.range;
        if (d < 1 || d > l.getLineCount()) return void a.dispose();
        const h = this.getPreviewValue(l, d, r), c = this.languageService.guessLanguageIdByFilepathOrFirstLine(l.uri);
        this.addDecoration(o, h ? new Vn().appendCodeblock(c || "", h) : void 0), a.dispose();
      }));
    }
  }
  getPreviewValue(n, e, t) {
    let i = t.range;
    return i.endLineNumber - i.startLineNumber >= O_.MAX_SOURCE_PREVIEW_LINES && (i = this.getPreviewRangeBasedOnIndentation(n, e)), this.stripIndentationFromPreviewRange(n, e, i);
  }
  stripIndentationFromPreviewRange(n, e, t) {
    let i = n.getLineFirstNonWhitespaceColumn(e);
    for (let s = e + 1; s < t.endLineNumber; s++) {
      const o = n.getLineFirstNonWhitespaceColumn(s);
      i = Math.min(i, o);
    }
    return n.getValueInRange(t).replace(new RegExp(`^\\s{${i - 1}}`, "gm"), "").trim();
  }
  getPreviewRangeBasedOnIndentation(n, e) {
    const t = n.getLineFirstNonWhitespaceColumn(e), i = Math.min(n.getLineCount(), e + O_.MAX_SOURCE_PREVIEW_LINES);
    let s = e + 1;
    for (; s < i && t !== n.getLineFirstNonWhitespaceColumn(s); s++)
      ;
    return new D(e, 1, s + 1, 1);
  }
  addDecoration(n, e) {
    const t = { range: n, options: { description: "goto-definition-link", inlineClassName: "goto-definition-link", hoverMessage: e } };
    this.linkDecorations.set([t]);
  }
  removeLinkDecorations() {
    this.linkDecorations.clear();
  }
  isEnabled(n, e) {
    var t;
    return this.editor.hasModel() && n.isLeftClick && n.isNoneOrSingleMouseDown && n.target.type === 6 && !(((t = n.target.detail.injectedText) === null || t === void 0 ? void 0 : t.options) instanceof xc) && (n.hasTriggerModifier || !!e && e.keyCodeIsTriggerKey) && this.languageFeaturesService.definitionProvider.has(this.editor.getModel());
  }
  findDefinition(n, e) {
    const t = this.editor.getModel();
    return t ? ik(this.languageFeaturesService.definitionProvider, t, n, e) : Promise.resolve(null);
  }
  gotoDefinition(n, e) {
    return this.editor.setPosition(n), this.editor.invokeWithinContext(((t) => {
      const i = !e && this.editor.getOption(88) && !this.isInPeekEditor(t);
      return new D0({ openToSide: e, openInPeek: i, muteMessage: !0 }, { title: { value: "", original: "" }, id: "", precondition: void 0 }).run(t);
    }));
  }
  isInPeekEditor(n) {
    const e = n.get(Te);
    return As.inPeekEditor.getValue(e);
  }
  dispose() {
    this.toUnhook.dispose(), this.toUnhookForKeyboard.dispose();
  }
};
hu.ID = "editor.contrib.gotodefinitionatposition", hu.MAX_SOURCE_PREVIEW_LINES = 8, hu = O_ = aae([Ix(1, Ps), Ix(2, Xt), Ix(3, fe)], hu), ft(hu.ID, hu, 2);
let lae = class {
  constructor(n, e, t) {
    this.value = n, this.isComplete = e, this.hasLoadingMessage = t;
  }
};
class wz extends V {
  constructor(e, t) {
    super(), this._editor = e, this._computer = t, this._onResult = this._register(new F()), this.onResult = this._onResult.event, this._firstWaitScheduler = this._register(new Et((() => this._triggerAsyncComputation()), 0)), this._secondWaitScheduler = this._register(new Et((() => this._triggerSyncComputation()), 0)), this._loadingMessageScheduler = this._register(new Et((() => this._triggerLoadingMessage()), 0)), this._state = 0, this._asyncIterable = null, this._asyncIterableDone = !1, this._result = [];
  }
  dispose() {
    this._asyncIterable && (this._asyncIterable.cancel(), this._asyncIterable = null), super.dispose();
  }
  get _hoverTime() {
    return this._editor.getOption(60).delay;
  }
  get _firstWaitTime() {
    return this._hoverTime / 2;
  }
  get _secondWaitTime() {
    return this._hoverTime - this._firstWaitTime;
  }
  get _loadingMessageTime() {
    return 3 * this._hoverTime;
  }
  _setState(e, t = !0) {
    this._state = e, t && this._fireResult();
  }
  _triggerAsyncComputation() {
    this._setState(2), this._secondWaitScheduler.schedule(this._secondWaitTime), this._computer.computeAsync ? (this._asyncIterableDone = !1, this._asyncIterable = (function(e) {
      const t = new Ci(), i = e(t.token);
      return new FK(t, (async (s) => {
        const o = t.token.onCancellationRequested((() => {
          o.dispose(), t.dispose(), s.reject(new Vd());
        }));
        try {
          for await (const r of i) {
            if (t.token.isCancellationRequested) return;
            s.emitOne(r);
          }
          o.dispose(), t.dispose();
        } catch (r) {
          o.dispose(), t.dispose(), s.reject(r);
        }
      }));
    })(((e) => this._computer.computeAsync(e))), (async () => {
      try {
        for await (const e of this._asyncIterable) e && (this._result.push(e), this._fireResult());
        this._asyncIterableDone = !0, this._state !== 3 && this._state !== 4 || this._setState(0);
      } catch (e) {
        We(e);
      }
    })()) : this._asyncIterableDone = !0;
  }
  _triggerSyncComputation() {
    this._computer.computeSync && (this._result = this._result.concat(this._computer.computeSync())), this._setState(this._asyncIterableDone ? 0 : 3);
  }
  _triggerLoadingMessage() {
    this._state === 3 && this._setState(4);
  }
  _fireResult() {
    if (this._state === 1 || this._state === 2) return;
    const e = this._state === 0, t = this._state === 4;
    this._onResult.fire(new lae(this._result.slice(0), e, t));
  }
  start(e) {
    if (e === 0) this._state === 0 && (this._setState(1), this._firstWaitScheduler.schedule(this._firstWaitTime), this._loadingMessageScheduler.schedule(this._loadingMessageTime));
    else switch (this._state) {
      case 0:
        this._triggerAsyncComputation(), this._secondWaitScheduler.cancel(), this._triggerSyncComputation();
        break;
      case 2:
        this._secondWaitScheduler.cancel(), this._triggerSyncComputation();
    }
  }
  cancel() {
    this._firstWaitScheduler.cancel(), this._secondWaitScheduler.cancel(), this._loadingMessageScheduler.cancel(), this._asyncIterable && (this._asyncIterable.cancel(), this._asyncIterable = null), this._result = [], this._setState(0, !1);
  }
}
class Mx {
  constructor(e, t, i, s) {
    this.priority = e, this.range = t, this.initialMousePosX = i, this.initialMousePosY = s, this.type = 1;
  }
  equals(e) {
    return e.type === 1 && this.range.equalsRange(e.range);
  }
  canAdoptVisibleHover(e, t) {
    return e.type === 1 && t.lineNumber === this.range.startLineNumber;
  }
}
class Zu {
  constructor(e, t, i, s, o, r) {
    this.priority = e, this.owner = t, this.range = i, this.initialMousePosX = s, this.initialMousePosY = o, this.supportsMarkerHover = r, this.type = 2;
  }
  equals(e) {
    return e.type === 2 && this.owner === e.owner;
  }
  canAdoptVisibleHover(e, t) {
    return e.type === 2 && this.owner === e.owner;
  }
}
const Tc = new class {
  constructor() {
    this._participants = [];
  }
  register(n) {
    this._participants.push(n);
  }
  getAll() {
    return this._participants;
  }
}();
class bP {
  constructor() {
    let e;
    this._onDidWillResize = new F(), this.onDidWillResize = this._onDidWillResize.event, this._onDidResize = new F(), this.onDidResize = this._onDidResize.event, this._sashListener = new G(), this._size = new bt(0, 0), this._minSize = new bt(0, 0), this._maxSize = new bt(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER), this.domNode = document.createElement("div"), this._eastSash = new Bn(this.domNode, { getVerticalSashLeft: () => this._size.width }, { orientation: 0 }), this._westSash = new Bn(this.domNode, { getVerticalSashLeft: () => 0 }, { orientation: 0 }), this._northSash = new Bn(this.domNode, { getHorizontalSashTop: () => 0 }, { orientation: 1, orthogonalEdge: zy.North }), this._southSash = new Bn(this.domNode, { getHorizontalSashTop: () => this._size.height }, { orientation: 1, orthogonalEdge: zy.South }), this._northSash.orthogonalStartSash = this._westSash, this._northSash.orthogonalEndSash = this._eastSash, this._southSash.orthogonalStartSash = this._westSash, this._southSash.orthogonalEndSash = this._eastSash;
    let t = 0, i = 0;
    this._sashListener.add(se.any(this._northSash.onDidStart, this._eastSash.onDidStart, this._southSash.onDidStart, this._westSash.onDidStart)((() => {
      e === void 0 && (this._onDidWillResize.fire(), e = this._size, t = 0, i = 0);
    }))), this._sashListener.add(se.any(this._northSash.onDidEnd, this._eastSash.onDidEnd, this._southSash.onDidEnd, this._westSash.onDidEnd)((() => {
      e !== void 0 && (e = void 0, t = 0, i = 0, this._onDidResize.fire({ dimension: this._size, done: !0 }));
    }))), this._sashListener.add(this._eastSash.onDidChange(((s) => {
      e && (i = s.currentX - s.startX, this.layout(e.height + t, e.width + i), this._onDidResize.fire({ dimension: this._size, done: !1, east: !0 }));
    }))), this._sashListener.add(this._westSash.onDidChange(((s) => {
      e && (i = -(s.currentX - s.startX), this.layout(e.height + t, e.width + i), this._onDidResize.fire({ dimension: this._size, done: !1, west: !0 }));
    }))), this._sashListener.add(this._northSash.onDidChange(((s) => {
      e && (t = -(s.currentY - s.startY), this.layout(e.height + t, e.width + i), this._onDidResize.fire({ dimension: this._size, done: !1, north: !0 }));
    }))), this._sashListener.add(this._southSash.onDidChange(((s) => {
      e && (t = s.currentY - s.startY, this.layout(e.height + t, e.width + i), this._onDidResize.fire({ dimension: this._size, done: !1, south: !0 }));
    }))), this._sashListener.add(se.any(this._eastSash.onDidReset, this._westSash.onDidReset)(((s) => {
      this._preferredSize && (this.layout(this._size.height, this._preferredSize.width), this._onDidResize.fire({ dimension: this._size, done: !0 }));
    }))), this._sashListener.add(se.any(this._northSash.onDidReset, this._southSash.onDidReset)(((s) => {
      this._preferredSize && (this.layout(this._preferredSize.height, this._size.width), this._onDidResize.fire({ dimension: this._size, done: !0 }));
    })));
  }
  dispose() {
    this._northSash.dispose(), this._southSash.dispose(), this._eastSash.dispose(), this._westSash.dispose(), this._sashListener.dispose(), this._onDidResize.dispose(), this._onDidWillResize.dispose(), this.domNode.remove();
  }
  enableSashes(e, t, i, s) {
    this._northSash.state = e ? 3 : 0, this._eastSash.state = t ? 3 : 0, this._southSash.state = i ? 3 : 0, this._westSash.state = s ? 3 : 0;
  }
  layout(e = this.size.height, t = this.size.width) {
    const { height: i, width: s } = this._minSize, { height: o, width: r } = this._maxSize;
    e = Math.max(i, Math.min(o, e)), t = Math.max(s, Math.min(r, t));
    const a = new bt(t, e);
    bt.equals(a, this._size) || (this.domNode.style.height = e + "px", this.domNode.style.width = t + "px", this._size = a, this._northSash.layout(), this._eastSash.layout(), this._southSash.layout(), this._westSash.layout());
  }
  clearSashHoverState() {
    this._eastSash.clearSashHoverState(), this._westSash.clearSashHoverState(), this._northSash.clearSashHoverState(), this._southSash.clearSashHoverState();
  }
  get size() {
    return this._size;
  }
  set maxSize(e) {
    this._maxSize = e;
  }
  get maxSize() {
    return this._maxSize;
  }
  set minSize(e) {
    this._minSize = e;
  }
  get minSize() {
    return this._minSize;
  }
  set preferredSize(e) {
    this._preferredSize = e;
  }
  get preferredSize() {
    return this._preferredSize;
  }
}
class dae extends V {
  constructor(e, t = new bt(10, 10)) {
    super(), this._editor = e, this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this._resizableNode = this._register(new bP()), this._contentPosition = null, this._isResizing = !1, this._resizableNode.domNode.style.position = "absolute", this._resizableNode.minSize = bt.lift(t), this._resizableNode.layout(t.height, t.width), this._resizableNode.enableSashes(!0, !0, !0, !0), this._register(this._resizableNode.onDidResize(((i) => {
      this._resize(new bt(i.dimension.width, i.dimension.height)), i.done && (this._isResizing = !1);
    }))), this._register(this._resizableNode.onDidWillResize((() => {
      this._isResizing = !0;
    })));
  }
  get isResizing() {
    return this._isResizing;
  }
  getDomNode() {
    return this._resizableNode.domNode;
  }
  getPosition() {
    return this._contentPosition;
  }
  get position() {
    var e;
    return !((e = this._contentPosition) === null || e === void 0) && e.position ? W.lift(this._contentPosition.position) : void 0;
  }
  _availableVerticalSpaceAbove(e) {
    const t = this._editor.getDomNode(), i = this._editor.getScrolledVisiblePosition(e);
    if (!(!t || !i))
      return Ti(t).top + i.top - 30;
  }
  _availableVerticalSpaceBelow(e) {
    const t = this._editor.getDomNode(), i = this._editor.getScrolledVisiblePosition(e);
    if (!t || !i) return;
    const s = Ti(t), o = Cc(t.ownerDocument.body), r = s.top + i.top + i.height;
    return o.height - r - 24;
  }
  _findPositionPreference(e, t) {
    var i, s;
    const o = Math.min((i = this._availableVerticalSpaceBelow(t)) !== null && i !== void 0 ? i : 1 / 0, e), r = Math.min((s = this._availableVerticalSpaceAbove(t)) !== null && s !== void 0 ? s : 1 / 0, e), a = Math.min(Math.max(r, o), e), l = Math.min(e, a);
    let d;
    return d = this._editor.getOption(60).above ? l <= r ? 1 : 2 : l <= o ? 2 : 1, d === 1 ? this._resizableNode.enableSashes(!0, !0, !1, !1) : this._resizableNode.enableSashes(!1, !0, !0, !1), d;
  }
  _resize(e) {
    this._resizableNode.layout(e.height, e.width);
  }
}
var uw, Ta, CP = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Bu = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const N6 = Q;
let gw = uw = class extends V {
  constructor(n, e, t) {
    super(), this._editor = n, this._instantiationService = e, this._keybindingService = t, this._currentResult = null, this._widget = this._register(this._instantiationService.createInstance(Kh, this._editor)), this._participants = [];
    for (const i of Tc.getAll()) this._participants.push(this._instantiationService.createInstance(i, this._editor));
    this._participants.sort(((i, s) => i.hoverOrdinal - s.hoverOrdinal)), this._computer = new pS(this._editor, this._participants), this._hoverOperation = this._register(new wz(this._editor, this._computer)), this._register(this._hoverOperation.onResult(((i) => {
      if (!this._computer.anchor) return;
      const s = i.hasLoadingMessage ? this._addLoadingMessage(i.value) : i.value;
      this._withResult(new yz(this._computer.anchor, s, i.isComplete));
    }))), this._register(bi(this._widget.getDomNode(), "keydown", ((i) => {
      i.equals(9) && this.hide();
    }))), this._register(ci.onDidChange((() => {
      this._widget.position && this._currentResult && this._setCurrentResult(this._currentResult);
    })));
  }
  _startShowingOrUpdateHover(n, e, t, i, s) {
    return !this._widget.position || !this._currentResult ? !!n && (this._startHoverOperationIfNecessary(n, e, t, i, !1), !0) : this._editor.getOption(60).sticky && s && this._widget.isMouseGettingCloser(s.event.posx, s.event.posy) ? (n && this._startHoverOperationIfNecessary(n, e, t, i, !0), !0) : n ? !(!n || !this._currentResult.anchor.equals(n)) || (n.canAdoptVisibleHover(this._currentResult.anchor, this._widget.position) ? (this._setCurrentResult(this._currentResult.filter(n)), this._startHoverOperationIfNecessary(n, e, t, i, !1), !0) : (this._setCurrentResult(null), this._startHoverOperationIfNecessary(n, e, t, i, !1), !0)) : (this._setCurrentResult(null), !1);
  }
  _startHoverOperationIfNecessary(n, e, t, i, s) {
    this._computer.anchor && this._computer.anchor.equals(n) || (this._hoverOperation.cancel(), this._computer.anchor = n, this._computer.shouldFocus = i, this._computer.source = t, this._computer.insistOnKeepingHoverVisible = s, this._hoverOperation.start(e));
  }
  _setCurrentResult(n) {
    this._currentResult !== n && (n && n.messages.length === 0 && (n = null), this._currentResult = n, this._currentResult ? this._renderMessages(this._currentResult.anchor, this._currentResult.messages) : this._widget.hide());
  }
  _addLoadingMessage(n) {
    if (this._computer.anchor) {
      for (const e of this._participants) if (e.createLoadingMessage) {
        const t = e.createLoadingMessage(this._computer.anchor);
        if (t) return n.slice(0).concat([t]);
      }
    }
    return n;
  }
  _withResult(n) {
    this._widget.position && this._currentResult && this._currentResult.isComplete && (!n.isComplete || this._computer.insistOnKeepingHoverVisible && n.messages.length === 0) || this._setCurrentResult(n);
  }
  _renderMessages(n, e) {
    const { showAtPosition: t, showAtSecondaryPosition: i, highlightRange: s } = uw.computeHoverRanges(this._editor, n.range, e), o = new G(), r = o.add(new gS(this._keybindingService)), a = document.createDocumentFragment();
    let l = null;
    const d = { fragment: a, statusBar: r, setColorPicker: (c) => l = c, onContentsChanged: () => this._widget.onContentsChanged(), setMinimumDimensions: (c) => this._widget.setMinimumDimensions(c), hide: () => this.hide() };
    for (const c of this._participants) {
      const u = e.filter(((g) => g.owner === c));
      u.length > 0 && o.add(c.renderHoverParts(d, u));
    }
    const h = e.some(((c) => c.isBeforeContent));
    if (r.hasContent && a.appendChild(r.hoverElement), a.hasChildNodes()) {
      if (s) {
        const c = this._editor.createDecorationsCollection();
        c.set([{ range: s, options: uw._DECORATION_OPTIONS }]), o.add(ye((() => {
          c.clear();
        })));
      }
      this._widget.showAt(a, new cae(n.initialMousePosX, n.initialMousePosY, l, t, i, this._editor.getOption(60).above, this._computer.shouldFocus, this._computer.source, h, o));
    } else o.dispose();
  }
  static computeHoverRanges(n, e, t) {
    let i = 1;
    if (n.hasModel()) {
      const l = n._getViewModel(), d = l.coordinatesConverter, h = d.convertModelRangeToViewRange(e), c = new W(h.startLineNumber, l.getLineMinColumn(h.startLineNumber));
      i = d.convertViewPositionToModelPosition(c).column;
    }
    const s = e.startLineNumber;
    let o = e.startColumn, r = t[0].range, a = null;
    for (const l of t) r = D.plusRange(r, l.range), l.range.startLineNumber === s && l.range.endLineNumber === s && (o = Math.max(Math.min(o, l.range.startColumn), i)), l.forceShowAtRange && (a = l.range);
    return { showAtPosition: a ? a.getStartPosition() : new W(s, e.startColumn), showAtSecondaryPosition: a ? a.getStartPosition() : new W(s, o), highlightRange: r };
  }
  showsOrWillShow(n) {
    if (this._widget.isResizing) return !0;
    const e = [];
    for (const i of this._participants) if (i.suggestHoverAnchor) {
      const s = i.suggestHoverAnchor(n);
      s && e.push(s);
    }
    const t = n.target;
    if (t.type === 6 && e.push(new Mx(0, t.range, n.event.posx, n.event.posy)), t.type === 7) {
      const i = this._editor.getOption(50).typicalHalfwidthCharacterWidth / 2;
      !t.detail.isAfterLines && typeof t.detail.horizontalDistanceToText == "number" && t.detail.horizontalDistanceToText < i && e.push(new Mx(0, t.range, n.event.posx, n.event.posy));
    }
    return e.length === 0 ? this._startShowingOrUpdateHover(null, 0, 0, !1, n) : (e.sort(((i, s) => s.priority - i.priority)), this._startShowingOrUpdateHover(e[0], 0, 0, !1, n));
  }
  startShowingAtRange(n, e, t, i) {
    this._startShowingOrUpdateHover(new Mx(0, n, void 0, void 0), e, t, i, null);
  }
  containsNode(n) {
    return !!n && this._widget.getDomNode().contains(n);
  }
  focus() {
    this._widget.focus();
  }
  scrollUp() {
    this._widget.scrollUp();
  }
  scrollDown() {
    this._widget.scrollDown();
  }
  scrollLeft() {
    this._widget.scrollLeft();
  }
  scrollRight() {
    this._widget.scrollRight();
  }
  pageUp() {
    this._widget.pageUp();
  }
  pageDown() {
    this._widget.pageDown();
  }
  goToTop() {
    this._widget.goToTop();
  }
  goToBottom() {
    this._widget.goToBottom();
  }
  hide() {
    this._computer.anchor = null, this._hoverOperation.cancel(), this._setCurrentResult(null);
  }
  get isColorPickerVisible() {
    return this._widget.isColorPickerVisible;
  }
  get isVisibleFromKeyboard() {
    return this._widget.isVisibleFromKeyboard;
  }
  get isVisible() {
    return this._widget.isVisible;
  }
  get isFocused() {
    return this._widget.isFocused;
  }
  get isResizing() {
    return this._widget.isResizing;
  }
  get widget() {
    return this._widget;
  }
};
gw._DECORATION_OPTIONS = Ve.register({ description: "content-hover-highlight", className: "hoverHighlight" }), gw = uw = CP([Bu(1, Se), Bu(2, Dt)], gw);
class yz {
  constructor(e, t, i) {
    this.anchor = e, this.messages = t, this.isComplete = i;
  }
  filter(e) {
    const t = this.messages.filter(((i) => i.isValidForHoverAnchor(e)));
    return t.length === this.messages.length ? this : new hae(this, this.anchor, t, this.isComplete);
  }
}
class hae extends yz {
  constructor(e, t, i, s) {
    super(t, i, s), this.original = e;
  }
  filter(e) {
    return this.original.filter(e);
  }
}
class cae {
  constructor(e, t, i, s, o, r, a, l, d, h) {
    this.initialMousePosX = e, this.initialMousePosY = t, this.colorPicker = i, this.showAtPosition = s, this.showAtSecondaryPosition = o, this.preferAbove = r, this.stoleFocus = a, this.source = l, this.isBeforeContent = d, this.disposables = h, this.closestMouseDistance = void 0;
  }
}
let Kh = Ta = class extends dae {
  get isColorPickerVisible() {
    var n;
    return !!(!((n = this._visibleData) === null || n === void 0) && n.colorPicker);
  }
  get isVisibleFromKeyboard() {
    var n;
    return ((n = this._visibleData) === null || n === void 0 ? void 0 : n.source) === 1;
  }
  get isVisible() {
    var n;
    return (n = this._hoverVisibleKey.get()) !== null && n !== void 0 && n;
  }
  get isFocused() {
    var n;
    return (n = this._hoverFocusedKey.get()) !== null && n !== void 0 && n;
  }
  constructor(n, e, t, i, s) {
    const o = n.getOption(67) + 8, r = new bt(150, o);
    super(n, r), this._configurationService = t, this._accessibilityService = i, this._keybindingService = s, this._hover = this._register(new pA()), this._minimumSize = r, this._hoverVisibleKey = E.hoverVisible.bindTo(e), this._hoverFocusedKey = E.hoverFocused.bindTo(e), Z(this._resizableNode.domNode, this._hover.containerDomNode), this._resizableNode.domNode.style.zIndex = "50", this._register(this._editor.onDidLayoutChange((() => {
      this.isVisible && this._updateMaxDimensions();
    }))), this._register(this._editor.onDidChangeConfiguration(((l) => {
      l.hasChanged(50) && this._updateFont();
    })));
    const a = this._register(pa(this._resizableNode.domNode));
    this._register(a.onDidFocus((() => {
      this._hoverFocusedKey.set(!0);
    }))), this._register(a.onDidBlur((() => {
      this._hoverFocusedKey.set(!1);
    }))), this._setHoverData(void 0), this._editor.addContentWidget(this);
  }
  dispose() {
    var n;
    super.dispose(), (n = this._visibleData) === null || n === void 0 || n.disposables.dispose(), this._editor.removeContentWidget(this);
  }
  getId() {
    return Ta.ID;
  }
  static _applyDimensions(n, e, t) {
    const i = typeof e == "number" ? `${e}px` : e, s = typeof t == "number" ? `${t}px` : t;
    n.style.width = i, n.style.height = s;
  }
  _setContentsDomNodeDimensions(n, e) {
    const t = this._hover.contentsDomNode;
    return Ta._applyDimensions(t, n, e);
  }
  _setContainerDomNodeDimensions(n, e) {
    const t = this._hover.containerDomNode;
    return Ta._applyDimensions(t, n, e);
  }
  _setHoverWidgetDimensions(n, e) {
    this._setContentsDomNodeDimensions(n, e), this._setContainerDomNodeDimensions(n, e), this._layoutContentWidget();
  }
  static _applyMaxDimensions(n, e, t) {
    const i = typeof e == "number" ? `${e}px` : e, s = typeof t == "number" ? `${t}px` : t;
    n.style.maxWidth = i, n.style.maxHeight = s;
  }
  _setHoverWidgetMaxDimensions(n, e) {
    Ta._applyMaxDimensions(this._hover.contentsDomNode, n, e), Ta._applyMaxDimensions(this._hover.containerDomNode, n, e), this._hover.containerDomNode.style.setProperty("--vscode-hover-maxWidth", typeof n == "number" ? `${n}px` : n), this._layoutContentWidget();
  }
  _hasHorizontalScrollbar() {
    const n = this._hover.scrollbar.getScrollDimensions();
    return n.scrollWidth > n.width;
  }
  _adjustContentsBottomPadding() {
    const n = this._hover.contentsDomNode, e = `${this._hover.scrollbar.options.horizontalScrollbarSize}px`;
    n.style.paddingBottom !== e && (n.style.paddingBottom = e);
  }
  _setAdjustedHoverWidgetDimensions(n) {
    this._setHoverWidgetMaxDimensions("none", "none");
    const e = n.width, t = n.height;
    this._setHoverWidgetDimensions(e, t), this._hasHorizontalScrollbar() && (this._adjustContentsBottomPadding(), this._setContentsDomNodeDimensions(e, t - 10));
  }
  _updateResizableNodeMaxDimensions() {
    var n, e;
    const t = (n = this._findMaximumRenderingWidth()) !== null && n !== void 0 ? n : 1 / 0, i = (e = this._findMaximumRenderingHeight()) !== null && e !== void 0 ? e : 1 / 0;
    this._resizableNode.maxSize = new bt(t, i), this._setHoverWidgetMaxDimensions(t, i);
  }
  _resize(n) {
    var e, t;
    Ta._lastDimensions = new bt(n.width, n.height), this._setAdjustedHoverWidgetDimensions(n), this._resizableNode.layout(n.height, n.width), this._updateResizableNodeMaxDimensions(), this._hover.scrollbar.scanDomNode(), this._editor.layoutContentWidget(this), (t = (e = this._visibleData) === null || e === void 0 ? void 0 : e.colorPicker) === null || t === void 0 || t.layout();
  }
  _findAvailableSpaceVertically() {
    var n;
    const e = (n = this._visibleData) === null || n === void 0 ? void 0 : n.showAtPosition;
    if (e) return this._positionPreference === 1 ? this._availableVerticalSpaceAbove(e) : this._availableVerticalSpaceBelow(e);
  }
  _findMaximumRenderingHeight() {
    const n = this._findAvailableSpaceVertically();
    if (!n) return;
    let e = 6;
    return Array.from(this._hover.contentsDomNode.children).forEach(((t) => {
      e += t.clientHeight;
    })), this._hasHorizontalScrollbar() && (e += 10), Math.min(n, e);
  }
  _isHoverTextOverflowing() {
    this._hover.containerDomNode.style.setProperty("--vscode-hover-whiteSpace", "nowrap"), this._hover.containerDomNode.style.setProperty("--vscode-hover-sourceWhiteSpace", "nowrap");
    const n = Array.from(this._hover.contentsDomNode.children).some(((e) => e.scrollWidth > e.clientWidth));
    return this._hover.containerDomNode.style.removeProperty("--vscode-hover-whiteSpace"), this._hover.containerDomNode.style.removeProperty("--vscode-hover-sourceWhiteSpace"), n;
  }
  _findMaximumRenderingWidth() {
    if (!this._editor || !this._editor.hasModel()) return;
    const n = this._isHoverTextOverflowing(), e = this._contentWidth === void 0 ? 0 : this._contentWidth - 2;
    return n || this._hover.containerDomNode.clientWidth < e ? Cc(this._hover.containerDomNode.ownerDocument.body).width - 14 : this._hover.containerDomNode.clientWidth + 2;
  }
  isMouseGettingCloser(n, e) {
    if (!this._visibleData) return !1;
    if (this._visibleData.initialMousePosX === void 0 || this._visibleData.initialMousePosY === void 0) return this._visibleData.initialMousePosX = n, this._visibleData.initialMousePosY = e, !1;
    const t = Ti(this.getDomNode());
    this._visibleData.closestMouseDistance === void 0 && (this._visibleData.closestMouseDistance = E6(this._visibleData.initialMousePosX, this._visibleData.initialMousePosY, t.left, t.top, t.width, t.height));
    const i = E6(n, e, t.left, t.top, t.width, t.height);
    return !(i > this._visibleData.closestMouseDistance + 4) && (this._visibleData.closestMouseDistance = Math.min(this._visibleData.closestMouseDistance, i), !0);
  }
  _setHoverData(n) {
    var e;
    (e = this._visibleData) === null || e === void 0 || e.disposables.dispose(), this._visibleData = n, this._hoverVisibleKey.set(!!n), this._hover.containerDomNode.classList.toggle("hidden", !n);
  }
  _updateFont() {
    const { fontSize: n, lineHeight: e } = this._editor.getOption(50), t = this._hover.contentsDomNode;
    t.style.fontSize = `${n}px`, t.style.lineHeight = "" + e / n, Array.prototype.slice.call(this._hover.contentsDomNode.getElementsByClassName("code")).forEach(((i) => this._editor.applyFontInfo(i)));
  }
  _updateContent(n) {
    const e = this._hover.contentsDomNode;
    e.style.paddingBottom = "", e.textContent = "", e.appendChild(n);
  }
  _layoutContentWidget() {
    this._editor.layoutContentWidget(this), this._hover.onContentsChanged();
  }
  _updateMaxDimensions() {
    const n = Math.max(this._editor.getLayoutInfo().height / 4, 250, Ta._lastDimensions.height), e = Math.max(0.66 * this._editor.getLayoutInfo().width, 500, Ta._lastDimensions.width);
    this._setHoverWidgetMaxDimensions(e, n);
  }
  _render(n, e) {
    this._setHoverData(e), this._updateFont(), this._updateContent(n), this._updateMaxDimensions(), this.onContentsChanged(), this._editor.render();
  }
  getPosition() {
    var n;
    return this._visibleData ? { position: this._visibleData.showAtPosition, secondaryPosition: this._visibleData.showAtSecondaryPosition, positionAffinity: this._visibleData.isBeforeContent ? 3 : void 0, preference: [(n = this._positionPreference) !== null && n !== void 0 ? n : 1] } : null;
  }
  showAt(n, e) {
    var t, i, s, o;
    if (!this._editor || !this._editor.hasModel()) return;
    this._render(n, e);
    const r = rd(this._hover.containerDomNode), a = e.showAtPosition;
    this._positionPreference = (t = this._findPositionPreference(r, a)) !== null && t !== void 0 ? t : 1, this.onContentsChanged(), e.stoleFocus && this._hover.containerDomNode.focus(), (i = e.colorPicker) === null || i === void 0 || i.layout();
    const l = this._hover.containerDomNode.ownerDocument.activeElement === this._hover.containerDomNode && kW(this._configurationService.getValue("accessibility.verbosity.hover") === !0 && this._accessibilityService.isScreenReaderOptimized(), (o = (s = this._keybindingService.lookupKeybinding("editor.action.accessibleView")) === null || s === void 0 ? void 0 : s.getAriaLabel()) !== null && o !== void 0 ? o : "");
    l && (this._hover.contentsDomNode.ariaLabel = this._hover.contentsDomNode.textContent + ", " + l);
  }
  hide() {
    if (!this._visibleData) return;
    const n = this._visibleData.stoleFocus || this._hoverFocusedKey.get();
    this._setHoverData(void 0), this._resizableNode.maxSize = new bt(1 / 0, 1 / 0), this._resizableNode.clearSashHoverState(), this._hoverFocusedKey.set(!1), this._editor.layoutContentWidget(this), n && this._editor.focus();
  }
  _removeConstraintsRenderNormally() {
    const n = this._editor.getLayoutInfo();
    this._resizableNode.layout(n.height, n.width), this._setHoverWidgetDimensions("auto", "auto");
  }
  _adjustHoverHeightForScrollbar(n) {
    var e;
    const t = this._hover.containerDomNode, i = this._hover.contentsDomNode, s = (e = this._findMaximumRenderingHeight()) !== null && e !== void 0 ? e : 1 / 0;
    this._setContainerDomNodeDimensions(os(t), Math.min(s, n)), this._setContentsDomNodeDimensions(os(i), Math.min(s, n - 10));
  }
  setMinimumDimensions(n) {
    this._minimumSize = new bt(Math.max(this._minimumSize.width, n.width), Math.max(this._minimumSize.height, n.height)), this._updateMinimumWidth();
  }
  _updateMinimumWidth() {
    const n = this._contentWidth === void 0 ? this._minimumSize.width : Math.min(this._contentWidth, this._minimumSize.width);
    this._resizableNode.minSize = new bt(n, this._minimumSize.height);
  }
  onContentsChanged() {
    var n;
    this._removeConstraintsRenderNormally();
    const e = this._hover.containerDomNode;
    let t = rd(e), i = os(e);
    if (this._resizableNode.layout(t, i), this._setHoverWidgetDimensions(i, t), t = rd(e), i = os(e), this._contentWidth = i, this._updateMinimumWidth(), this._resizableNode.layout(t, i), this._hasHorizontalScrollbar() && (this._adjustContentsBottomPadding(), this._adjustHoverHeightForScrollbar(t)), (n = this._visibleData) === null || n === void 0 ? void 0 : n.showAtPosition) {
      const s = rd(this._hover.containerDomNode);
      this._positionPreference = this._findPositionPreference(s, this._visibleData.showAtPosition);
    }
    this._layoutContentWidget();
  }
  focus() {
    this._hover.containerDomNode.focus();
  }
  scrollUp() {
    const n = this._hover.scrollbar.getScrollPosition().scrollTop, e = this._editor.getOption(50);
    this._hover.scrollbar.setScrollPosition({ scrollTop: n - e.lineHeight });
  }
  scrollDown() {
    const n = this._hover.scrollbar.getScrollPosition().scrollTop, e = this._editor.getOption(50);
    this._hover.scrollbar.setScrollPosition({ scrollTop: n + e.lineHeight });
  }
  scrollLeft() {
    const n = this._hover.scrollbar.getScrollPosition().scrollLeft;
    this._hover.scrollbar.setScrollPosition({ scrollLeft: n - 30 });
  }
  scrollRight() {
    const n = this._hover.scrollbar.getScrollPosition().scrollLeft;
    this._hover.scrollbar.setScrollPosition({ scrollLeft: n + 30 });
  }
  pageUp() {
    const n = this._hover.scrollbar.getScrollPosition().scrollTop, e = this._hover.scrollbar.getScrollDimensions().height;
    this._hover.scrollbar.setScrollPosition({ scrollTop: n - e });
  }
  pageDown() {
    const n = this._hover.scrollbar.getScrollPosition().scrollTop, e = this._hover.scrollbar.getScrollDimensions().height;
    this._hover.scrollbar.setScrollPosition({ scrollTop: n + e });
  }
  goToTop() {
    this._hover.scrollbar.setScrollPosition({ scrollTop: 0 });
  }
  goToBottom() {
    this._hover.scrollbar.setScrollPosition({ scrollTop: this._hover.scrollbar.getScrollDimensions().scrollHeight });
  }
};
Kh.ID = "editor.contrib.resizableContentHoverWidget", Kh._lastDimensions = new bt(0, 0), Kh = Ta = CP([Bu(1, Te), Bu(2, Ye), Bu(3, or), Bu(4, Dt)], Kh);
let gS = class extends V {
  get hasContent() {
    return this._hasContent;
  }
  constructor(n) {
    super(), this._keybindingService = n, this._hasContent = !1, this.hoverElement = N6("div.hover-row.status-bar"), this.actionsElement = Z(this.hoverElement, N6("div.actions"));
  }
  addAction(n) {
    const e = this._keybindingService.lookupKeybinding(n.commandId), t = e ? e.getLabel() : null;
    return this._hasContent = !0, this._register(fL.render(this.actionsElement, n, t));
  }
  append(n) {
    const e = Z(this.actionsElement, n);
    return this._hasContent = !0, e;
  }
};
gS = CP([Bu(0, Dt)], gS);
class pS {
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    this._anchor = e;
  }
  get shouldFocus() {
    return this._shouldFocus;
  }
  set shouldFocus(e) {
    this._shouldFocus = e;
  }
  get source() {
    return this._source;
  }
  set source(e) {
    this._source = e;
  }
  get insistOnKeepingHoverVisible() {
    return this._insistOnKeepingHoverVisible;
  }
  set insistOnKeepingHoverVisible(e) {
    this._insistOnKeepingHoverVisible = e;
  }
  constructor(e, t) {
    this._editor = e, this._participants = t, this._anchor = null, this._shouldFocus = !1, this._source = 0, this._insistOnKeepingHoverVisible = !1;
  }
  static _getLineDecorations(e, t) {
    if (t.type !== 1 && !t.supportsMarkerHover) return [];
    const i = e.getModel(), s = t.range.startLineNumber;
    if (s > i.getLineCount()) return [];
    const o = i.getLineMaxColumn(s);
    return e.getLineDecorations(s).filter(((r) => {
      if (r.options.isWholeLine) return !0;
      const a = r.range.startLineNumber === s ? r.range.startColumn : 1, l = r.range.endLineNumber === s ? r.range.endColumn : o;
      if (r.options.showIfCollapsed) {
        if (a > t.range.startColumn + 1 || t.range.endColumn - 1 > l) return !1;
      } else if (a > t.range.startColumn || t.range.endColumn > l) return !1;
      return !0;
    }));
  }
  computeAsync(e) {
    const t = this._anchor;
    if (!this._editor.hasModel() || !t) return Pi.EMPTY;
    const i = pS._getLineDecorations(this._editor, t);
    return Pi.merge(this._participants.map(((s) => s.computeAsync ? s.computeAsync(t, i, e) : Pi.EMPTY)));
  }
  computeSync() {
    if (!this._editor.hasModel() || !this._anchor) return [];
    const e = pS._getLineDecorations(this._editor, this._anchor);
    let t = [];
    for (const i of this._participants) t = t.concat(i.computeSync(this._anchor, e));
    return ha(t);
  }
}
function E6(n, e, t, i, s, o) {
  const r = t + s / 2, a = i + o / 2, l = Math.max(Math.abs(n - r) - s / 2, 0), d = Math.max(Math.abs(e - a) - o / 2, 0);
  return Math.sqrt(l * l + d * d);
}
const I6 = Q;
class Sm extends V {
  constructor(e, t, i) {
    super(), this._renderDisposeables = this._register(new G()), this._editor = e, this._isVisible = !1, this._messages = [], this._hover = this._register(new pA()), this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible), this._markdownRenderer = this._register(new pl({ editor: this._editor }, t, i)), this._computer = new uae(this._editor), this._hoverOperation = this._register(new wz(this._editor, this._computer)), this._register(this._hoverOperation.onResult(((s) => {
      this._withResult(s.value);
    }))), this._register(this._editor.onDidChangeModelDecorations((() => this._onModelDecorationsChanged()))), this._register(this._editor.onDidChangeConfiguration(((s) => {
      s.hasChanged(50) && this._updateFont();
    }))), this._editor.addOverlayWidget(this);
  }
  dispose() {
    this._editor.removeOverlayWidget(this), super.dispose();
  }
  getId() {
    return Sm.ID;
  }
  getDomNode() {
    return this._hover.containerDomNode;
  }
  getPosition() {
    return null;
  }
  _updateFont() {
    Array.prototype.slice.call(this._hover.contentsDomNode.getElementsByClassName("code")).forEach(((e) => this._editor.applyFontInfo(e)));
  }
  _onModelDecorationsChanged() {
    this._isVisible && (this._hoverOperation.cancel(), this._hoverOperation.start(0));
  }
  startShowingAt(e, t) {
    this._computer.lineNumber === e && this._computer.lane === t || (this._hoverOperation.cancel(), this.hide(), this._computer.lineNumber = e, this._computer.lane = t, this._hoverOperation.start(0));
  }
  hide() {
    this._computer.lineNumber = -1, this._hoverOperation.cancel(), this._isVisible && (this._isVisible = !1, this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible));
  }
  _withResult(e) {
    this._messages = e, this._messages.length > 0 ? this._renderMessages(this._computer.lineNumber, this._messages) : this.hide();
  }
  _renderMessages(e, t) {
    this._renderDisposeables.clear();
    const i = document.createDocumentFragment();
    for (const s of t) {
      const o = I6("div.hover-row.markdown-hover"), r = Z(o, I6("div.hover-contents")), a = this._renderDisposeables.add(this._markdownRenderer.render(s.value));
      r.appendChild(a.element), i.appendChild(o);
    }
    this._updateContents(i), this._showAt(e);
  }
  _updateContents(e) {
    this._hover.contentsDomNode.textContent = "", this._hover.contentsDomNode.appendChild(e), this._updateFont();
  }
  _showAt(e) {
    this._isVisible || (this._isVisible = !0, this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible));
    const t = this._editor.getLayoutInfo(), i = this._editor.getTopForLineNumber(e), s = this._editor.getScrollTop(), o = this._editor.getOption(67), r = i - s - (this._hover.containerDomNode.clientHeight - o) / 2, a = t.glyphMarginLeft + t.glyphMarginWidth + (this._computer.lane === "lineNo" ? t.lineNumbersWidth : 0);
    this._hover.containerDomNode.style.left = `${a}px`, this._hover.containerDomNode.style.top = `${Math.max(Math.round(r), 0)}px`;
  }
}
Sm.ID = "editor.contrib.modesGlyphHoverWidget";
class uae {
  get lineNumber() {
    return this._lineNumber;
  }
  set lineNumber(e) {
    this._lineNumber = e;
  }
  get lane() {
    return this._laneOrLine;
  }
  set lane(e) {
    this._laneOrLine = e;
  }
  constructor(e) {
    this._editor = e, this._lineNumber = -1, this._laneOrLine = _l.Center;
  }
  computeSync() {
    var e, t;
    const i = (a) => ({ value: a }), s = this._editor.getLineDecorations(this._lineNumber), o = [], r = this._laneOrLine === "lineNo";
    if (!s) return o;
    for (const a of s) {
      const l = (t = (e = a.options.glyphMargin) === null || e === void 0 ? void 0 : e.position) !== null && t !== void 0 ? t : _l.Center;
      if (!r && l !== this._laneOrLine) continue;
      const d = r ? a.options.lineNumberHoverMessage : a.options.glyphMarginHoverMessage;
      d && !jm(d) && o.push(...UT(d).map(i));
    }
    return o;
  }
}
class gae {
  constructor(e, t, i) {
    this.provider = e, this.hover = t, this.ordinal = i;
  }
}
function wP(n, e, t, i) {
  const s = n.ordered(e).map(((o, r) => (async function(a, l, d, h, c) {
    try {
      const u = await Promise.resolve(a.provideHover(d, h, c));
      if (u && (function(g) {
        const p = g.range !== void 0, f = g.contents !== void 0 && g.contents && g.contents.length > 0;
        return p && f;
      })(u)) return new gae(a, u, l);
    } catch (u) {
      Ni(u);
    }
  })(o, r, e, t, i)));
  return Pi.fromPromises(s).coalesce();
}
ja("_executeHoverProvider", ((n, e, t) => (function(i, s, o, r) {
  return wP(i, s, o, r).map(((a) => a.hover)).toPromise();
})(n.get(fe).hoverProvider, e, t, et.None)));
var pae = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Xb = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const M6 = Q;
class Jr {
  constructor(e, t, i, s, o) {
    this.owner = e, this.range = t, this.contents = i, this.isBeforeContent = s, this.ordinal = o;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
let mS = class {
  constructor(n, e, t, i, s) {
    this._editor = n, this._languageService = e, this._openerService = t, this._configurationService = i, this._languageFeaturesService = s, this.hoverOrdinal = 3;
  }
  createLoadingMessage(n) {
    return new Jr(this, n.range, [new Vn().appendText(m(0, "Loading..."))], !1, 2e3);
  }
  computeSync(n, e) {
    if (!this._editor.hasModel() || n.type !== 1) return [];
    const t = this._editor.getModel(), i = n.range.startLineNumber, s = t.getLineMaxColumn(i), o = [];
    let r = 1e3;
    const a = t.getLineLength(i), l = t.getLanguageIdAtPosition(n.range.startLineNumber, n.range.startColumn), d = this._editor.getOption(117), h = this._configurationService.getValue("editor.maxTokenizationLineLength", { overrideIdentifier: l });
    let c = !1;
    d >= 0 && a > d && n.range.startColumn >= d && (c = !0, o.push(new Jr(this, n.range, [{ value: m(0, "Rendering paused for long line for performance reasons. This can be configured via `editor.stopRenderingLineAfter`.") }], !1, r++))), !c && typeof h == "number" && a >= h && o.push(new Jr(this, n.range, [{ value: m(0, "Tokenization is skipped for long lines for performance reasons. This can be configured via `editor.maxTokenizationLineLength`.") }], !1, r++));
    let u = !1;
    for (const g of e) {
      const p = g.range.startLineNumber === i ? g.range.startColumn : 1, f = g.range.endLineNumber === i ? g.range.endColumn : s, _ = g.options.hoverMessage;
      if (!_ || jm(_)) continue;
      g.options.beforeContentClassName && (u = !0);
      const v = new D(n.range.startLineNumber, p, n.range.startLineNumber, f);
      o.push(new Jr(this, v, UT(_), u, r++));
    }
    return o;
  }
  computeAsync(n, e, t) {
    if (!this._editor.hasModel() || n.type !== 1) return Pi.EMPTY;
    const i = this._editor.getModel();
    if (!this._languageFeaturesService.hoverProvider.has(i)) return Pi.EMPTY;
    const s = new W(n.range.startLineNumber, n.range.startColumn);
    return wP(this._languageFeaturesService.hoverProvider, i, s, t).filter(((o) => !jm(o.hover.contents))).map(((o) => {
      const r = o.hover.range ? D.lift(o.hover.range) : n.range;
      return new Jr(this, r, o.hover.contents, !1, o.ordinal);
    }));
  }
  renderHoverParts(n, e) {
    return Sz(n, e, this._editor, this._languageService, this._openerService);
  }
};
function Sz(n, e, t, i, s) {
  e.sort(((r, a) => r.ordinal - a.ordinal));
  const o = new G();
  for (const r of e) for (const a of r.contents) {
    if (jm(a)) continue;
    const l = M6("div.hover-row.markdown-hover"), d = Z(l, M6("div.hover-contents")), h = o.add(new pl({ editor: t }, i, s));
    o.add(h.onDidRenderAsync((() => {
      d.className = "hover-contents code-hover-contents", n.onContentsChanged();
    })));
    const c = o.add(h.render(a));
    d.appendChild(c.element), n.fragment.appendChild(l);
  }
  return o;
}
mS = pae([Xb(1, Xt), Xb(2, Fs), Xb(3, Ye), Xb(4, fe)], mS);
var Lz = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, fS = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class T6 {
  constructor(e, t, i) {
    this.marker = e, this.index = t, this.total = i;
  }
}
let SM = class {
  constructor(n, e, t) {
    this._markerService = e, this._configService = t, this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._dispoables = new G(), this._markers = [], this._nextIdx = -1, Ie.isUri(n) ? this._resourceFilter = (r) => r.toString() === n.toString() : n && (this._resourceFilter = n);
    const i = this._configService.getValue("problems.sortOrder"), s = (r, a) => {
      let l = Y0(r.resource.toString(), a.resource.toString());
      return l === 0 && (l = i === "position" ? D.compareRangesUsingStarts(r, a) || pi.compare(r.severity, a.severity) : pi.compare(r.severity, a.severity) || D.compareRangesUsingStarts(r, a)), l;
    }, o = () => {
      this._markers = this._markerService.read({ resource: Ie.isUri(n) ? n : void 0, severities: pi.Error | pi.Warning | pi.Info }), typeof n == "function" && (this._markers = this._markers.filter(((r) => this._resourceFilter(r.resource)))), this._markers.sort(s);
    };
    o(), this._dispoables.add(e.onMarkerChanged(((r) => {
      this._resourceFilter && !r.some(((a) => this._resourceFilter(a))) || (o(), this._nextIdx = -1, this._onDidChange.fire());
    })));
  }
  dispose() {
    this._dispoables.dispose(), this._onDidChange.dispose();
  }
  matches(n) {
    return !this._resourceFilter && !n || !(!this._resourceFilter || !n) && this._resourceFilter(n);
  }
  get selected() {
    const n = this._markers[this._nextIdx];
    return n && new T6(n, this._nextIdx + 1, this._markers.length);
  }
  _initIdx(n, e, t) {
    let i = !1, s = this._markers.findIndex(((o) => o.resource.toString() === n.uri.toString()));
    s < 0 && (s = H0(this._markers, { resource: n.uri }, ((o, r) => Y0(o.resource.toString(), r.resource.toString()))), s < 0 && (s = ~s));
    for (let o = s; o < this._markers.length; o++) {
      let r = D.lift(this._markers[o]);
      if (r.isEmpty()) {
        const a = n.getWordAtPosition(r.getStartPosition());
        a && (r = new D(r.startLineNumber, a.startColumn, r.startLineNumber, a.endColumn));
      }
      if (e && (r.containsPosition(e) || e.isBeforeOrEqual(r.getStartPosition()))) {
        this._nextIdx = o, i = !0;
        break;
      }
      if (this._markers[o].resource.toString() !== n.uri.toString()) break;
    }
    i || (this._nextIdx = t ? 0 : this._markers.length - 1), this._nextIdx < 0 && (this._nextIdx = this._markers.length - 1);
  }
  resetIndex() {
    this._nextIdx = -1;
  }
  move(n, e, t) {
    if (this._markers.length === 0) return !1;
    const i = this._nextIdx;
    return this._nextIdx === -1 ? this._initIdx(e, t, n) : n ? this._nextIdx = (this._nextIdx + 1) % this._markers.length : n || (this._nextIdx = (this._nextIdx - 1 + this._markers.length) % this._markers.length), i !== this._nextIdx;
  }
  find(n, e) {
    let t = this._markers.findIndex(((i) => i.resource.toString() === n.toString()));
    if (!(t < 0)) {
      for (; t < this._markers.length; t++) if (D.containsPosition(this._markers[t], e)) return new T6(this._markers[t], t + 1, this._markers.length);
    }
  }
};
SM = Lz([fS(1, kl), fS(2, Ye)], SM);
const kz = tt("IMarkerNavigationService");
let Tx = class {
  constructor(n, e) {
    this._markerService = n, this._configService = e, this._provider = new fs();
  }
  getMarkerList(n) {
    for (const e of this._provider) {
      const t = e.getMarkerList(n);
      if (t) return t;
    }
    return new SM(n, this._markerService, this._configService);
  }
};
var LM;
Tx = Lz([fS(0, kl), fS(1, Ye)], Tx), rt(kz, Tx, 1), (function(n) {
  n.className = function(e) {
    switch (e) {
      case ki.Ignore:
        return "severity-ignore " + Ee.asClassName(ne.info);
      case ki.Info:
        return Ee.asClassName(ne.info);
      case ki.Warning:
        return Ee.asClassName(ne.warning);
      case ki.Error:
        return Ee.asClassName(ne.error);
      default:
        return "";
    }
  };
})(LM || (LM = {}));
var kM, mae = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, tp = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class fae {
  constructor(e, t, i, s, o) {
    this._openerService = s, this._labelService = o, this._lines = 0, this._longestLineLength = 0, this._relatedDiagnostics = /* @__PURE__ */ new WeakMap(), this._disposables = new G(), this._editor = t;
    const r = document.createElement("div");
    r.className = "descriptioncontainer", this._messageBlock = document.createElement("div"), this._messageBlock.classList.add("message"), this._messageBlock.setAttribute("aria-live", "assertive"), this._messageBlock.setAttribute("role", "alert"), r.appendChild(this._messageBlock), this._relatedBlock = document.createElement("div"), r.appendChild(this._relatedBlock), this._disposables.add(bi(this._relatedBlock, "click", ((a) => {
      a.preventDefault();
      const l = this._relatedDiagnostics.get(a.target);
      l && i(l);
    }))), this._scrollable = new SB(r, { horizontal: 1, vertical: 1, useShadows: !1, horizontalScrollbarSize: 6, verticalScrollbarSize: 6 }), e.appendChild(this._scrollable.getDomNode()), this._disposables.add(this._scrollable.onScroll(((a) => {
      r.style.left = `-${a.scrollLeft}px`, r.style.top = `-${a.scrollTop}px`;
    }))), this._disposables.add(this._scrollable);
  }
  dispose() {
    Ht(this._disposables);
  }
  update(e) {
    const { source: t, message: i, relatedInformation: s, code: o } = e;
    let r = (t?.length || 0) + 2;
    o && (r += typeof o == "string" ? o.length : o.value.length);
    const a = Sl(i);
    this._lines = a.length, this._longestLineLength = 0;
    for (const u of a) this._longestLineLength = Math.max(u.length + r, this._longestLineLength);
    Un(this._messageBlock), this._messageBlock.setAttribute("aria-label", this.getAriaLabel(e)), this._editor.applyFontInfo(this._messageBlock);
    let l = this._messageBlock;
    for (const u of a) l = document.createElement("div"), l.innerText = u, u === "" && (l.style.height = this._messageBlock.style.lineHeight), this._messageBlock.appendChild(l);
    if (t || o) {
      const u = document.createElement("span");
      if (u.classList.add("details"), l.appendChild(u), t) {
        const g = document.createElement("span");
        g.innerText = t, g.classList.add("source"), u.appendChild(g);
      }
      if (o) if (typeof o == "string") {
        const g = document.createElement("span");
        g.innerText = `(${o})`, g.classList.add("code"), u.appendChild(g);
      } else
        this._codeLink = Q("a.code-link"), this._codeLink.setAttribute("href", `${o.target.toString()}`), this._codeLink.onclick = (g) => {
          this._openerService.open(o.target, { allowCommands: !0 }), g.preventDefault(), g.stopPropagation();
        }, Z(this._codeLink, Q("span")).innerText = o.value, u.appendChild(this._codeLink);
    }
    if (Un(this._relatedBlock), this._editor.applyFontInfo(this._relatedBlock), zn(s)) {
      const u = this._relatedBlock.appendChild(document.createElement("div"));
      u.style.paddingTop = `${Math.floor(0.66 * this._editor.getOption(67))}px`, this._lines += 1;
      for (const g of s) {
        const p = document.createElement("div"), f = document.createElement("a");
        f.classList.add("filename"), f.innerText = `${this._labelService.getUriBasenameLabel(g.resource)}(${g.startLineNumber}, ${g.startColumn}): `, f.title = this._labelService.getUriLabel(g.resource), this._relatedDiagnostics.set(f, g);
        const _ = document.createElement("span");
        _.innerText = g.message, p.appendChild(f), p.appendChild(_), this._lines += 1, u.appendChild(p);
      }
    }
    const d = this._editor.getOption(50), h = Math.ceil(d.typicalFullwidthCharacterWidth * this._longestLineLength * 0.75), c = d.lineHeight * this._lines;
    this._scrollable.setScrollDimensions({ scrollWidth: h, scrollHeight: c });
  }
  layout(e, t) {
    this._scrollable.getDomNode().style.height = `${e}px`, this._scrollable.getDomNode().style.width = `${t}px`, this._scrollable.setScrollDimensions({ width: t, height: e });
  }
  getHeightInLines() {
    return Math.min(17, this._lines);
  }
  getAriaLabel(e) {
    let t = "";
    switch (e.severity) {
      case pi.Error:
        t = m(0, "Error");
        break;
      case pi.Warning:
        t = m(0, "Warning");
        break;
      case pi.Info:
        t = m(0, "Info");
        break;
      case pi.Hint:
        t = m(0, "Hint");
    }
    let i = m(0, "{0} at {1}. ", t, e.startLineNumber + ":" + e.startColumn);
    const s = this._editor.getModel();
    return s && e.startLineNumber <= s.getLineCount() && e.startLineNumber >= 1 && (i = `${s.getLineContent(e.startLineNumber)}, ${i}`), i;
  }
}
let Lm = kM = class extends cS {
  constructor(n, e, t, i, s, o, r) {
    super(n, { showArrow: !0, showFrame: !0, isAccessible: !0, frameWidth: 1 }, s), this._themeService = e, this._openerService = t, this._menuService = i, this._contextKeyService = o, this._labelService = r, this._callOnDispose = new G(), this._onDidSelectRelatedInformation = new F(), this.onDidSelectRelatedInformation = this._onDidSelectRelatedInformation.event, this._severity = pi.Warning, this._backgroundColor = z.white, this._applyTheme(e.getColorTheme()), this._callOnDispose.add(e.onDidColorThemeChange(this._applyTheme.bind(this))), this.create();
  }
  _applyTheme(n) {
    this._backgroundColor = n.getColor(Cae);
    let e = DM, t = _ae;
    this._severity === pi.Warning ? (e = pw, t = vae) : this._severity === pi.Info && (e = xM, t = bae);
    const i = n.getColor(e), s = n.getColor(t);
    this.style({ arrowColor: i, frameColor: i, headerBackgroundColor: s, primaryHeadingColor: n.getColor(mz), secondaryHeadingColor: n.getColor(fz) });
  }
  _applyStyles() {
    this._parentContainer && (this._parentContainer.style.backgroundColor = this._backgroundColor ? this._backgroundColor.toString() : ""), super._applyStyles();
  }
  dispose() {
    this._callOnDispose.dispose(), super.dispose();
  }
  _fillHead(n) {
    super._fillHead(n), this._disposables.add(this._actionbarWidget.actionRunner.onWillRun(((i) => this.editor.focus())));
    const e = [], t = this._menuService.createMenu(kM.TitleMenu, this._contextKeyService);
    EL(t, void 0, e), this._actionbarWidget.push(e, { label: !1, icon: !0, index: 0 }), t.dispose();
  }
  _fillTitleIcon(n) {
    this._icon = Z(n, Q(""));
  }
  _fillBody(n) {
    this._parentContainer = n, n.classList.add("marker-widget"), this._parentContainer.tabIndex = 0, this._parentContainer.setAttribute("role", "tooltip"), this._container = document.createElement("div"), n.appendChild(this._container), this._message = new fae(this._container, this.editor, ((e) => this._onDidSelectRelatedInformation.fire(e)), this._openerService, this._labelService), this._disposables.add(this._message);
  }
  show() {
    throw new Error("call showAtMarker");
  }
  showAtMarker(n, e, t) {
    this._container.classList.remove("stale"), this._message.update(n), this._severity = n.severity, this._applyTheme(this._themeService.getColorTheme());
    const i = D.lift(n), s = this.editor.getPosition(), o = s && i.containsPosition(s) ? s : i.getStartPosition();
    super.show(o, this.computeRequiredHeight());
    const r = this.editor.getModel();
    if (r) {
      const a = m(0, t > 1 ? "{0} of {1} problems" : "{0} of {1} problem", e, t);
      this.setTitle(ir(r.uri), a);
    }
    this._icon.className = `codicon ${LM.className(pi.toSeverity(this._severity))}`, this.editor.revealPositionNearTop(o, 0), this.editor.focus();
  }
  updateMarker(n) {
    this._container.classList.remove("stale"), this._message.update(n);
  }
  showStale() {
    this._container.classList.add("stale"), this._relayout();
  }
  _doLayoutBody(n, e) {
    super._doLayoutBody(n, e), this._heightInPixel = n, this._message.layout(n, e), this._container.style.height = `${n}px`;
  }
  _onWidth(n) {
    this._message.layout(this._heightInPixel, n);
  }
  _relayout() {
    super._relayout(this.computeRequiredHeight());
  }
  computeRequiredHeight() {
    return 3 + this._message.getHeightInLines();
  }
};
Lm.TitleMenu = new x("gotoErrorTitleMenu"), Lm = kM = mae([tp(1, Yi), tp(2, Fs), tp(3, Mo), tp(4, Se), tp(5, Te), tp(6, $m)], Lm);
const R6 = hv(sl, g$), A6 = hv(Qn, cv), P6 = hv(Rs, uv), DM = I("editorMarkerNavigationError.background", { dark: R6, light: R6, hcDark: ot, hcLight: ot }, m(0, "Editor marker navigation widget error color.")), _ae = I("editorMarkerNavigationError.headerBackground", { dark: Ce(DM, 0.1), light: Ce(DM, 0.1), hcDark: null, hcLight: null }, m(0, "Editor marker navigation widget error heading background.")), pw = I("editorMarkerNavigationWarning.background", { dark: A6, light: A6, hcDark: ot, hcLight: ot }, m(0, "Editor marker navigation widget warning color.")), vae = I("editorMarkerNavigationWarning.headerBackground", { dark: Ce(pw, 0.1), light: Ce(pw, 0.1), hcDark: "#0C141F", hcLight: Ce(pw, 0.2) }, m(0, "Editor marker navigation widget warning heading background.")), xM = I("editorMarkerNavigationInfo.background", { dark: P6, light: P6, hcDark: ot, hcLight: ot }, m(0, "Editor marker navigation widget info color.")), bae = I("editorMarkerNavigationInfo.headerBackground", { dark: Ce(xM, 0.1), light: Ce(xM, 0.1), hcDark: null, hcLight: null }, m(0, "Editor marker navigation widget info heading background.")), Cae = I("editorMarkerNavigation.background", { dark: sn, light: sn, hcDark: sn, hcLight: sn }, m(0, "Editor marker navigation widget background."));
var F_, wae = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Qb = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let lc = F_ = class {
  static get(n) {
    return n.getContribution(F_.ID);
  }
  constructor(n, e, t, i, s) {
    this._markerNavigationService = e, this._contextKeyService = t, this._editorService = i, this._instantiationService = s, this._sessionDispoables = new G(), this._editor = n, this._widgetVisible = Dz.bindTo(this._contextKeyService);
  }
  dispose() {
    this._cleanUp(), this._sessionDispoables.dispose();
  }
  _cleanUp() {
    this._widgetVisible.reset(), this._sessionDispoables.clear(), this._widget = void 0, this._model = void 0;
  }
  _getOrCreateModel(n) {
    if (this._model && this._model.matches(n)) return this._model;
    let e = !1;
    return this._model && (e = !0, this._cleanUp()), this._model = this._markerNavigationService.getMarkerList(n), e && this._model.move(!0, this._editor.getModel(), this._editor.getPosition()), this._widget = this._instantiationService.createInstance(Lm, this._editor), this._widget.onDidClose((() => this.close()), this, this._sessionDispoables), this._widgetVisible.set(!0), this._sessionDispoables.add(this._model), this._sessionDispoables.add(this._widget), this._sessionDispoables.add(this._editor.onDidChangeCursorPosition(((t) => {
      var i, s, o;
      !((i = this._model) === null || i === void 0) && i.selected && D.containsPosition((s = this._model) === null || s === void 0 ? void 0 : s.selected.marker, t.position) || (o = this._model) === null || o === void 0 || o.resetIndex();
    }))), this._sessionDispoables.add(this._model.onDidChange((() => {
      if (!this._widget || !this._widget.position || !this._model) return;
      const t = this._model.find(this._editor.getModel().uri, this._widget.position);
      t ? this._widget.updateMarker(t.marker) : this._widget.showStale();
    }))), this._sessionDispoables.add(this._widget.onDidSelectRelatedInformation(((t) => {
      this._editorService.openCodeEditor({ resource: t.resource, options: { pinned: !0, revealIfOpened: !0, selection: D.lift(t).collapseToStart() } }, this._editor), this.close(!1);
    }))), this._sessionDispoables.add(this._editor.onDidChangeModel((() => this._cleanUp()))), this._model;
  }
  close(n = !0) {
    this._cleanUp(), n && this._editor.focus();
  }
  showAtMarker(n) {
    if (this._editor.hasModel()) {
      const e = this._getOrCreateModel(this._editor.getModel().uri);
      e.resetIndex(), e.move(!0, this._editor.getModel(), new W(n.startLineNumber, n.startColumn)), e.selected && this._widget.showAtMarker(e.selected.marker, e.selected.index, e.selected.total);
    }
  }
  async nagivate(n, e) {
    var t, i;
    if (this._editor.hasModel()) {
      const s = this._getOrCreateModel(e ? void 0 : this._editor.getModel().uri);
      if (s.move(n, this._editor.getModel(), this._editor.getPosition()), !s.selected) return;
      if (s.selected.marker.resource.toString() !== this._editor.getModel().uri.toString()) {
        this._cleanUp();
        const o = await this._editorService.openCodeEditor({ resource: s.selected.marker.resource, options: { pinned: !1, revealIfOpened: !0, selectionRevealType: 2, selection: s.selected.marker } }, this._editor);
        o && ((t = F_.get(o)) === null || t === void 0 || t.close(), (i = F_.get(o)) === null || i === void 0 || i.nagivate(n, e));
      } else this._widget.showAtMarker(s.selected.marker, s.selected.index, s.selected.total);
    }
  }
};
lc.ID = "editor.contrib.markerController", lc = F_ = wae([Qb(1, kz), Qb(2, Te), Qb(3, mt), Qb(4, Se)], lc);
class _S extends he {
  constructor(e, t, i) {
    super(i), this._next = e, this._multiFile = t;
  }
  async run(e, t) {
    var i;
    t.hasModel() && ((i = lc.get(t)) === null || i === void 0 || i.nagivate(this._next, this._multiFile));
  }
}
class dc extends _S {
  constructor() {
    super(!0, !1, { id: dc.ID, label: dc.LABEL, alias: "Go to Next Problem (Error, Warning, Info)", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 578, weight: 100 }, menuOpts: { menuId: Lm.TitleMenu, title: dc.LABEL, icon: Ei("marker-navigation-next", ne.arrowDown, m(0, "Icon for goto next marker.")), group: "navigation", order: 1 } });
  }
}
dc.ID = "editor.action.marker.next", dc.LABEL = m(0, "Go to Next Problem (Error, Warning, Info)");
class Yu extends _S {
  constructor() {
    super(!1, !1, { id: Yu.ID, label: Yu.LABEL, alias: "Go to Previous Problem (Error, Warning, Info)", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 1602, weight: 100 }, menuOpts: { menuId: Lm.TitleMenu, title: Yu.LABEL, icon: Ei("marker-navigation-previous", ne.arrowUp, m(0, "Icon for goto previous marker.")), group: "navigation", order: 2 } });
  }
}
Yu.ID = "editor.action.marker.prev", Yu.LABEL = m(0, "Go to Previous Problem (Error, Warning, Info)");
ft(lc.ID, lc, 4), X(dc), X(Yu), X(class extends _S {
  constructor() {
    super(!0, !0, { id: "editor.action.marker.nextInFiles", label: m(0, "Go to Next Problem in Files (Error, Warning, Info)"), alias: "Go to Next Problem in Files (Error, Warning, Info)", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 66, weight: 100 }, menuOpts: { menuId: x.MenubarGoMenu, title: m(0, "Next &&Problem"), group: "6_problem_nav", order: 1 } });
  }
}), X(class extends _S {
  constructor() {
    super(!1, !0, { id: "editor.action.marker.prevInFiles", label: m(0, "Go to Previous Problem in Files (Error, Warning, Info)"), alias: "Go to Previous Problem in Files (Error, Warning, Info)", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 1090, weight: 100 }, menuOpts: { menuId: x.MenubarGoMenu, title: m(0, "Previous &&Problem"), group: "6_problem_nav", order: 2 } });
  }
});
const Dz = new ae("markersNavigationVisible", !1);
re(new (Zi.bindToContribution(lc.get))({ id: "closeMarkersNavigation", precondition: Dz, handler: (n) => n.close(), kbOpts: { weight: 150, kbExpr: E.focus, primary: 9, secondary: [1033] } }));
var yae = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Rx = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const lr = Q;
class Sae {
  constructor(e, t, i) {
    this.owner = e, this.range = t, this.marker = i;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
const O6 = { type: 1, filter: { include: ti.QuickFix }, triggerAction: qs.QuickFixHover };
let NM = class {
  constructor(n, e, t, i) {
    this._editor = n, this._markerDecorationsService = e, this._openerService = t, this._languageFeaturesService = i, this.hoverOrdinal = 1, this.recentMarkerCodeActionsInfo = void 0;
  }
  computeSync(n, e) {
    if (!this._editor.hasModel() || n.type !== 1 && !n.supportsMarkerHover) return [];
    const t = this._editor.getModel(), i = n.range.startLineNumber, s = t.getLineMaxColumn(i), o = [];
    for (const r of e) {
      const a = r.range.startLineNumber === i ? r.range.startColumn : 1, l = r.range.endLineNumber === i ? r.range.endColumn : s, d = this._markerDecorationsService.getMarker(t.uri, r);
      if (!d) continue;
      const h = new D(n.range.startLineNumber, a, n.range.startLineNumber, l);
      o.push(new Sae(this, h, d));
    }
    return o;
  }
  renderHoverParts(n, e) {
    if (!e.length) return V.None;
    const t = new G();
    e.forEach(((s) => n.fragment.appendChild(this.renderMarkerHover(s, t))));
    const i = e.length === 1 ? e[0] : e.sort(((s, o) => pi.compare(s.marker.severity, o.marker.severity)))[0];
    return this.renderMarkerStatusbar(n, i, t), t;
  }
  renderMarkerHover(n, e) {
    const t = lr("div.hover-row"), i = Z(t, lr("div.marker.hover-contents")), { source: s, message: o, code: r, relatedInformation: a } = n.marker;
    this._editor.applyFontInfo(i);
    const l = Z(i, lr("span"));
    if (l.style.whiteSpace = "pre-wrap", l.innerText = o, s || r) if (r && typeof r != "string") {
      const d = lr("span");
      s && (Z(d, lr("span")).innerText = s);
      const h = Z(d, lr("a.code-link"));
      h.setAttribute("href", r.target.toString()), e.add(K(h, "click", ((u) => {
        this._openerService.open(r.target, { allowCommands: !0 }), u.preventDefault(), u.stopPropagation();
      }))), Z(h, lr("span")).innerText = r.value;
      const c = Z(i, d);
      c.style.opacity = "0.6", c.style.paddingLeft = "6px";
    } else {
      const d = Z(i, lr("span"));
      d.style.opacity = "0.6", d.style.paddingLeft = "6px", d.innerText = s && r ? `${s}(${r})` : s || `(${r})`;
    }
    if (zn(a)) for (const { message: d, resource: h, startLineNumber: c, startColumn: u } of a) {
      const g = Z(i, lr("div"));
      g.style.marginTop = "8px";
      const p = Z(g, lr("a"));
      p.innerText = `${ir(h)}(${c}, ${u}): `, p.style.cursor = "pointer", e.add(K(p, "click", ((_) => {
        _.stopPropagation(), _.preventDefault(), this._openerService && this._openerService.open(h, { fromUserGesture: !0, editorOptions: { selection: { startLineNumber: c, startColumn: u } } }).catch(We);
      })));
      const f = Z(g, lr("span"));
      f.innerText = d, this._editor.applyFontInfo(f);
    }
    return t;
  }
  renderMarkerStatusbar(n, e, t) {
    if (e.marker.severity === pi.Error || e.marker.severity === pi.Warning || e.marker.severity === pi.Info) {
      const i = lc.get(this._editor);
      i && n.statusBar.addAction({ label: m(0, "View Problem"), commandId: dc.ID, run: () => {
        n.hide(), i.showAtMarker(e.marker), this._editor.focus();
      } });
    }
    if (!this._editor.getOption(91)) {
      const i = n.statusBar.append(lr("div"));
      this.recentMarkerCodeActionsInfo && (Vy.makeKey(this.recentMarkerCodeActionsInfo.marker) === Vy.makeKey(e.marker) ? this.recentMarkerCodeActionsInfo.hasCodeActions || (i.textContent = m(0, "No quick fixes available")) : this.recentMarkerCodeActionsInfo = void 0);
      const s = this.recentMarkerCodeActionsInfo && !this.recentMarkerCodeActionsInfo.hasCodeActions ? V.None : bc((() => i.textContent = m(0, "Checking for quick fixes...")), 200, t);
      i.textContent || (i.textContent = " ");
      const o = this.getCodeActions(e.marker);
      t.add(ye((() => o.cancel()))), o.then(((r) => {
        if (s.dispose(), this.recentMarkerCodeActionsInfo = { marker: e.marker, hasCodeActions: r.validActions.length > 0 }, !this.recentMarkerCodeActionsInfo.hasCodeActions) return r.dispose(), void (i.textContent = m(0, "No quick fixes available"));
        i.style.display = "none";
        let a = !1;
        t.add(ye((() => {
          a || r.dispose();
        }))), n.statusBar.addAction({ label: m(0, "Quick Fix..."), commandId: mP, run: (l) => {
          a = !0;
          const d = zh.get(this._editor), h = Ti(l);
          n.hide(), d?.showCodeActions(O6, r, { x: h.left, y: h.top, width: h.width, height: h.height });
        } });
      }), We);
    }
  }
  getCodeActions(n) {
    return on(((e) => L0(this._languageFeaturesService.codeActionProvider, this._editor.getModel(), new D(n.startLineNumber, n.startColumn, n.endLineNumber, n.endColumn), O6, Nd.None, e)));
  }
};
NM = yae([Rx(1, RR), Rx(2, Fs), Rx(3, fe)], NM);
const xz = "editor.action.inlineSuggest.commit", Nz = "editor.action.inlineSuggest.showPrevious", Ez = "editor.action.inlineSuggest.showNext";
var mw, yP = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, ea = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let EM = class extends V {
  constructor(n, e, t) {
    super(), this.editor = n, this.model = e, this.instantiationService = t, this.alwaysShowToolbar = Rt(this.editor.onDidChangeConfiguration, (() => this.editor.getOption(62).showToolbar === "always")), this.sessionPosition = void 0, this.position = Fe(this, ((i) => {
      var s, o, r;
      const a = (s = this.model.read(i)) === null || s === void 0 ? void 0 : s.primaryGhostText.read(i);
      if (!this.alwaysShowToolbar.read(i) || !a || a.parts.length === 0) return this.sessionPosition = void 0, null;
      const l = a.parts[0].column;
      this.sessionPosition && this.sessionPosition.lineNumber !== a.lineNumber && (this.sessionPosition = void 0);
      const d = new W(a.lineNumber, Math.min(l, (r = (o = this.sessionPosition) === null || o === void 0 ? void 0 : o.column) !== null && r !== void 0 ? r : Number.MAX_SAFE_INTEGER));
      return this.sessionPosition = d, d;
    })), this._register(nr(((i, s) => {
      const o = this.model.read(i);
      if (!o || !this.alwaysShowToolbar.read(i)) return;
      const r = s.add(this.instantiationService.createInstance(jh, this.editor, !0, this.position, o.selectedInlineCompletionIndex, o.inlineCompletionsCount, o.selectedInlineCompletion.map(((a) => {
        var l;
        return (l = a?.inlineCompletion.source.inlineCompletions.commands) !== null && l !== void 0 ? l : [];
      }))));
      n.addContentWidget(r), s.add(ye((() => n.removeContentWidget(r)))), s.add(Ge(((a) => {
        this.position.read(a) && o.lastTriggerKind.read(a) !== Ld.Explicit && o.triggerExplicitly();
      })));
    })));
  }
};
EM = yP([ea(2, Se)], EM);
const Lae = Ei("inline-suggestion-hints-next", ne.chevronRight, m(0, "Icon for show next parameter hint.")), kae = Ei("inline-suggestion-hints-previous", ne.chevronLeft, m(0, "Icon for show previous parameter hint."));
let jh = mw = class extends V {
  static get dropDownVisible() {
    return this._dropDownVisible;
  }
  createCommandAction(n, e, t) {
    const i = new Qs(n, e, t, !0, (() => this._commandService.executeCommand(n))), s = this.keybindingService.lookupKeybinding(n, this._contextKeyService);
    let o = e;
    return s && (o = m(0, "{0} ({1})", e, s.getLabel())), i.tooltip = o, i;
  }
  constructor(n, e, t, i, s, o, r, a, l, d, h) {
    super(), this.editor = n, this.withBorder = e, this._position = t, this._currentSuggestionIdx = i, this._suggestionCount = s, this._extraCommands = o, this._commandService = r, this.keybindingService = l, this._contextKeyService = d, this._menuService = h, this.id = "InlineSuggestionHintsContentWidget" + mw.id++, this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this.nodes = yt("div.inlineSuggestionsHints", { className: this.withBorder ? ".withBorder" : "" }, [yt("div@toolBar")]), this.previousAction = this.createCommandAction(Nz, m(0, "Previous"), Ee.asClassName(kae)), this.availableSuggestionCountAction = new Qs("inlineSuggestionHints.availableSuggestionCount", "", void 0, !1), this.nextAction = this.createCommandAction(Ez, m(0, "Next"), Ee.asClassName(Lae)), this.inlineCompletionsActionsMenus = this._register(this._menuService.createMenu(x.InlineCompletionsActions, this._contextKeyService)), this.clearAvailableSuggestionCountLabelDebounced = this._register(new Et((() => {
      this.availableSuggestionCountAction.label = "";
    }), 100)), this.disableButtonsDebounced = this._register(new Et((() => {
      this.previousAction.enabled = this.nextAction.enabled = !1;
    }), 100)), this.lastCommands = [], this.toolBar = this._register(a.createInstance(IM, this.nodes.toolBar, x.InlineSuggestionToolbar, { menuOptions: { renderShortTitle: !0 }, toolbarOptions: { primaryGroup: (c) => c.startsWith("primary") }, actionViewItemProvider: (c, u) => {
      if (c instanceof Eo) return a.createInstance(xae, c, void 0);
      if (c === this.availableSuggestionCountAction) {
        const g = new Dae(void 0, c, { label: !0, icon: !1 });
        return g.setClass("availableSuggestionCount"), g;
      }
    }, telemetrySource: "InlineSuggestionToolbar" })), this.toolBar.setPrependedPrimaryActions([this.previousAction, this.availableSuggestionCountAction, this.nextAction]), this._register(this.toolBar.onDidChangeDropdownVisibility(((c) => {
      mw._dropDownVisible = c;
    }))), this._register(Ge(((c) => {
      this._position.read(c), this.editor.layoutContentWidget(this);
    }))), this._register(Ge(((c) => {
      const u = this._suggestionCount.read(c), g = this._currentSuggestionIdx.read(c);
      u !== void 0 ? (this.clearAvailableSuggestionCountLabelDebounced.cancel(), this.availableSuggestionCountAction.label = `${g + 1}/${u}`) : this.clearAvailableSuggestionCountLabelDebounced.schedule(), u !== void 0 && u > 1 ? (this.disableButtonsDebounced.cancel(), this.previousAction.enabled = this.nextAction.enabled = !0) : this.disableButtonsDebounced.schedule();
    }))), this._register(Ge(((c) => {
      const u = this._extraCommands.read(c);
      if (ri(this.lastCommands, u)) return;
      this.lastCommands = u;
      const g = u.map(((p) => ({ class: void 0, id: p.id, enabled: !0, tooltip: p.tooltip || "", label: p.title, run: (f) => this._commandService.executeCommand(p.id) })));
      for (const [p, f] of this.inlineCompletionsActionsMenus.getActions()) for (const _ of f) _ instanceof Eo && g.push(_);
      g.length > 0 && g.unshift(new Ui()), this.toolBar.setAdditionalSecondaryActions(g);
    })));
  }
  getId() {
    return this.id;
  }
  getDomNode() {
    return this.nodes.root;
  }
  getPosition() {
    return { position: this._position.get(), preference: [1, 2], positionAffinity: 3 };
  }
};
jh._dropDownVisible = !1, jh.id = 0, jh = mw = yP([ea(6, ai), ea(7, Se), ea(8, Dt), ea(9, Te), ea(10, Mo)], jh);
class Dae extends Qm {
  constructor() {
    super(...arguments), this._className = void 0;
  }
  setClass(e) {
    this._className = e;
  }
  render(e) {
    super.render(e), this._className && e.classList.add(this._className);
  }
  updateTooltip() {
  }
}
let xae = class extends Ec {
  updateLabel() {
    const n = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
    if (!n) return super.updateLabel();
    if (this.label) {
      const e = yt("div.keybinding").root;
      this._register(new Cf(e, Gs, { disableTitle: !0, ...LV })).set(n), this.label.textContent = this._action.label, this.label.appendChild(e), this.label.classList.add("inlineSuggestionStatusBarItemLabel");
    }
  }
  updateTooltip() {
  }
}, IM = class extends qv {
  constructor(n, e, t, i, s, o, r, a) {
    super(n, { resetMenu: e, ...t }, i, s, o, r, a), this.menuId = e, this.options2 = t, this.menuService = i, this.contextKeyService = s, this.menu = this._store.add(this.menuService.createMenu(this.menuId, this.contextKeyService, { emitEventsForSubmenuChanges: !0 })), this.additionalActions = [], this.prependedPrimaryActions = [], this._store.add(this.menu.onDidChange((() => this.updateToolbar()))), this.updateToolbar();
  }
  updateToolbar() {
    var n, e, t, i, s, o, r;
    const a = [], l = [];
    EL(this.menu, (n = this.options2) === null || n === void 0 ? void 0 : n.menuOptions, { primary: a, secondary: l }, (t = (e = this.options2) === null || e === void 0 ? void 0 : e.toolbarOptions) === null || t === void 0 ? void 0 : t.primaryGroup, (s = (i = this.options2) === null || i === void 0 ? void 0 : i.toolbarOptions) === null || s === void 0 ? void 0 : s.shouldInlineSubmenu, (r = (o = this.options2) === null || o === void 0 ? void 0 : o.toolbarOptions) === null || r === void 0 ? void 0 : r.useSeparatorsInPrimaryActions), l.push(...this.additionalActions), a.unshift(...this.prependedPrimaryActions), this.setActions(a, l);
  }
  setPrependedPrimaryActions(n) {
    ri(this.prependedPrimaryActions, n, ((e, t) => e === t)) || (this.prependedPrimaryActions = n, this.updateToolbar());
  }
  setAdditionalSecondaryActions(n) {
    ri(this.additionalActions, n, ((e, t) => e === t)) || (this.additionalActions = n, this.updateToolbar());
  }
};
IM = yP([ea(3, Mo), ea(4, Te), ea(5, io), ea(6, Dt), ea(7, es)], IM);
var MM, Nae = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Jb = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let xs = MM = class extends V {
  constructor(n, e, t, i, s) {
    super(), this._editor = n, this._instantiationService = e, this._openerService = t, this._languageService = i, this._keybindingService = s, this._listenersStore = new G(), this._hoverState = { mouseDown: !1, contentHoverFocused: !1, activatedByDecoratorClick: !1 }, this._reactToEditorMouseMoveRunner = this._register(new Et((() => this._reactToEditorMouseMove(this._mouseMoveEvent)), 0)), this._hookListeners(), this._register(this._editor.onDidChangeConfiguration(((o) => {
      o.hasChanged(60) && (this._unhookListeners(), this._hookListeners());
    })));
  }
  static get(n) {
    return n.getContribution(MM.ID);
  }
  _hookListeners() {
    const n = this._editor.getOption(60);
    this._hoverSettings = { enabled: n.enabled, sticky: n.sticky, hidingDelay: n.delay }, n.enabled ? (this._listenersStore.add(this._editor.onMouseDown(((e) => this._onEditorMouseDown(e)))), this._listenersStore.add(this._editor.onMouseUp((() => this._onEditorMouseUp()))), this._listenersStore.add(this._editor.onMouseMove(((e) => this._onEditorMouseMove(e)))), this._listenersStore.add(this._editor.onKeyDown(((e) => this._onKeyDown(e))))) : (this._listenersStore.add(this._editor.onMouseMove(((e) => this._onEditorMouseMove(e)))), this._listenersStore.add(this._editor.onKeyDown(((e) => this._onKeyDown(e))))), this._listenersStore.add(this._editor.onMouseLeave(((e) => this._onEditorMouseLeave(e)))), this._listenersStore.add(this._editor.onDidChangeModel((() => {
      this._cancelScheduler(), this._hideWidgets();
    }))), this._listenersStore.add(this._editor.onDidChangeModelContent((() => this._cancelScheduler()))), this._listenersStore.add(this._editor.onDidScrollChange(((e) => this._onEditorScrollChanged(e))));
  }
  _unhookListeners() {
    this._listenersStore.clear();
  }
  _cancelScheduler() {
    this._mouseMoveEvent = void 0, this._reactToEditorMouseMoveRunner.cancel();
  }
  _onEditorScrollChanged(n) {
    (n.scrollTopChanged || n.scrollLeftChanged) && this._hideWidgets();
  }
  _onEditorMouseDown(n) {
    var e;
    this._hoverState.mouseDown = !0;
    const t = n.target;
    t.type !== 9 || t.detail !== Kh.ID ? t.type === 12 && t.detail === Sm.ID || (t.type !== 12 && (this._hoverState.contentHoverFocused = !1), !((e = this._contentWidget) === null || e === void 0) && e.widget.isResizing || this._hideWidgets()) : this._hoverState.contentHoverFocused = !0;
  }
  _onEditorMouseUp() {
    this._hoverState.mouseDown = !1;
  }
  _onEditorMouseLeave(n) {
    var e, t;
    this._cancelScheduler();
    const i = n.event.browserEvent.relatedTarget;
    !((e = this._contentWidget) === null || e === void 0) && e.widget.isResizing || !((t = this._contentWidget) === null || t === void 0) && t.containsNode(i) || this._hideWidgets();
  }
  _isMouseOverWidget(n) {
    var e, t, i, s, o;
    const r = n.target, a = this._hoverSettings.sticky;
    return !(!a || r.type !== 9 || r.detail !== Kh.ID) || !(!a || !(!((e = this._contentWidget) === null || e === void 0) && e.containsNode((t = n.event.browserEvent.view) === null || t === void 0 ? void 0 : t.document.activeElement)) || !((s = (i = n.event.browserEvent.view) === null || i === void 0 ? void 0 : i.getSelection()) === null || s === void 0) && s.isCollapsed) || !(a || r.type !== 9 || r.detail !== Kh.ID || !(!((o = this._contentWidget) === null || o === void 0) && o.isColorPickerVisible)) || !(!a || r.type !== 12 || r.detail !== Sm.ID);
  }
  _onEditorMouseMove(n) {
    var e, t, i, s;
    if (this._mouseMoveEvent = n, ((e = this._contentWidget) === null || e === void 0 ? void 0 : e.isFocused) || ((t = this._contentWidget) === null || t === void 0 ? void 0 : t.isResizing) || this._hoverState.mouseDown && this._hoverState.contentHoverFocused) return;
    const o = this._hoverSettings.sticky;
    if (o && (!((i = this._contentWidget) === null || i === void 0) && i.isVisibleFromKeyboard)) return;
    if (this._isMouseOverWidget(n)) return void this._reactToEditorMouseMoveRunner.cancel();
    const r = this._hoverSettings.hidingDelay;
    !((s = this._contentWidget) === null || s === void 0) && s.isVisible && o && r > 0 ? this._reactToEditorMouseMoveRunner.isScheduled() || this._reactToEditorMouseMoveRunner.schedule(r) : this._reactToEditorMouseMove(n);
  }
  _reactToEditorMouseMove(n) {
    var e, t, i, s;
    if (!n) return;
    const o = n.target, r = (e = o.element) === null || e === void 0 ? void 0 : e.classList.contains("colorpicker-color-decoration"), a = this._editor.getOption(148), l = this._hoverSettings.enabled, d = this._hoverState.activatedByDecoratorClick;
    if (r && (a === "click" && !d || a === "hover" && !l || a === "clickAndHover" && !l && !d) || !r && !l && !d) return void this._hideWidgets();
    this._getOrCreateContentWidget().showsOrWillShow(n) ? (t = this._glyphWidget) === null || t === void 0 || t.hide() : o.type === 2 && o.position && o.detail.glyphMarginLane ? ((i = this._contentWidget) === null || i === void 0 || i.hide(), this._getOrCreateGlyphWidget().startShowingAt(o.position.lineNumber, o.detail.glyphMarginLane)) : o.type === 3 && o.position ? ((s = this._contentWidget) === null || s === void 0 || s.hide(), this._getOrCreateGlyphWidget().startShowingAt(o.position.lineNumber, "lineNo")) : this._hideWidgets();
  }
  _onKeyDown(n) {
    var e;
    if (!this._editor.hasModel()) return;
    const t = this._keybindingService.softDispatch(n, this._editor.getDomNode()), i = t.kind === 1 || t.kind === 2 && t.commandId === "editor.action.showHover" && ((e = this._contentWidget) === null || e === void 0 ? void 0 : e.isVisible);
    n.keyCode === 5 || n.keyCode === 6 || n.keyCode === 57 || n.keyCode === 4 || i || this._hideWidgets();
  }
  _hideWidgets() {
    var n, e, t;
    this._hoverState.mouseDown && this._hoverState.contentHoverFocused && (!((n = this._contentWidget) === null || n === void 0) && n.isColorPickerVisible) || jh.dropDownVisible || (this._hoverState.activatedByDecoratorClick = !1, this._hoverState.contentHoverFocused = !1, (e = this._glyphWidget) === null || e === void 0 || e.hide(), (t = this._contentWidget) === null || t === void 0 || t.hide());
  }
  _getOrCreateContentWidget() {
    return this._contentWidget || (this._contentWidget = this._instantiationService.createInstance(gw, this._editor)), this._contentWidget;
  }
  _getOrCreateGlyphWidget() {
    return this._glyphWidget || (this._glyphWidget = new Sm(this._editor, this._languageService, this._openerService)), this._glyphWidget;
  }
  showContentHover(n, e, t, i, s = !1) {
    this._hoverState.activatedByDecoratorClick = s, this._getOrCreateContentWidget().startShowingAtRange(n, e, t, i);
  }
  focus() {
    var n;
    (n = this._contentWidget) === null || n === void 0 || n.focus();
  }
  scrollUp() {
    var n;
    (n = this._contentWidget) === null || n === void 0 || n.scrollUp();
  }
  scrollDown() {
    var n;
    (n = this._contentWidget) === null || n === void 0 || n.scrollDown();
  }
  scrollLeft() {
    var n;
    (n = this._contentWidget) === null || n === void 0 || n.scrollLeft();
  }
  scrollRight() {
    var n;
    (n = this._contentWidget) === null || n === void 0 || n.scrollRight();
  }
  pageUp() {
    var n;
    (n = this._contentWidget) === null || n === void 0 || n.pageUp();
  }
  pageDown() {
    var n;
    (n = this._contentWidget) === null || n === void 0 || n.pageDown();
  }
  goToTop() {
    var n;
    (n = this._contentWidget) === null || n === void 0 || n.goToTop();
  }
  goToBottom() {
    var n;
    (n = this._contentWidget) === null || n === void 0 || n.goToBottom();
  }
  get isColorPickerVisible() {
    var n;
    return (n = this._contentWidget) === null || n === void 0 ? void 0 : n.isColorPickerVisible;
  }
  get isHoverVisible() {
    var n;
    return (n = this._contentWidget) === null || n === void 0 ? void 0 : n.isVisible;
  }
  dispose() {
    var n, e;
    super.dispose(), this._unhookListeners(), this._listenersStore.dispose(), (n = this._glyphWidget) === null || n === void 0 || n.dispose(), (e = this._contentWidget) === null || e === void 0 || e.dispose();
  }
};
var Wr;
xs.ID = "editor.contrib.hover", xs = MM = Nae([Jb(1, Se), Jb(2, Fs), Jb(3, Xt), Jb(4, Dt)], xs), (function(n) {
  n.NoAutoFocus = "noAutoFocus", n.FocusIfVisible = "focusIfVisible", n.AutoFocusImmediately = "autoFocusImmediately";
})(Wr || (Wr = {}));
ft(xs.ID, xs, 2), X(class extends he {
  constructor() {
    super({ id: "editor.action.showHover", label: m(0, "Show or Focus Hover"), metadata: { description: "Show or Focus Hover", args: [{ name: "args", schema: { type: "object", properties: { focus: { description: "Controls if and when the hover should take focus upon being triggered by this action.", enum: [Wr.NoAutoFocus, Wr.FocusIfVisible, Wr.AutoFocusImmediately], enumDescriptions: [m(0, "The hover will not automatically take focus."), m(0, "The hover will take focus only if it is already visible."), m(0, "The hover will automatically take focus when it appears.")], default: Wr.FocusIfVisible } } } }] }, alias: "Show or Focus Hover", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2087), weight: 100 } });
  }
  run(n, e, t) {
    if (!e.hasModel()) return;
    const i = xs.get(e);
    if (!i) return;
    const s = t?.focus;
    let o = Wr.FocusIfVisible;
    Object.values(Wr).includes(s) ? o = s : typeof s == "boolean" && s && (o = Wr.AutoFocusImmediately);
    const r = (l) => {
      const d = e.getPosition(), h = new D(d.lineNumber, d.column, d.lineNumber, d.column);
      i.showContentHover(h, 1, 1, l);
    }, a = e.getOption(2) === 2;
    i.isHoverVisible ? o !== Wr.NoAutoFocus ? i.focus() : r(a) : r(a || o === Wr.AutoFocusImmediately);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.showDefinitionPreviewHover", label: m(0, "Show Definition Preview Hover"), alias: "Show Definition Preview Hover", precondition: void 0 });
  }
  run(n, e) {
    const t = xs.get(e);
    if (!t) return;
    const i = e.getPosition();
    if (!i) return;
    const s = new D(i.lineNumber, i.column, i.lineNumber, i.column), o = hu.get(e);
    o && o.startFindDefinitionFromCursor(i).then((() => {
      t.showContentHover(s, 1, 1, !0);
    }));
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.scrollUpHover", label: m(0, "Scroll Up Hover"), alias: "Scroll Up Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 16, weight: 100 } });
  }
  run(n, e) {
    const t = xs.get(e);
    t && t.scrollUp();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.scrollDownHover", label: m(0, "Scroll Down Hover"), alias: "Scroll Down Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 18, weight: 100 } });
  }
  run(n, e) {
    const t = xs.get(e);
    t && t.scrollDown();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.scrollLeftHover", label: m(0, "Scroll Left Hover"), alias: "Scroll Left Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 15, weight: 100 } });
  }
  run(n, e) {
    const t = xs.get(e);
    t && t.scrollLeft();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.scrollRightHover", label: m(0, "Scroll Right Hover"), alias: "Scroll Right Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 17, weight: 100 } });
  }
  run(n, e) {
    const t = xs.get(e);
    t && t.scrollRight();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.pageUpHover", label: m(0, "Page Up Hover"), alias: "Page Up Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 11, secondary: [528], weight: 100 } });
  }
  run(n, e) {
    const t = xs.get(e);
    t && t.pageUp();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.pageDownHover", label: m(0, "Page Down Hover"), alias: "Page Down Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 12, secondary: [530], weight: 100 } });
  }
  run(n, e) {
    const t = xs.get(e);
    t && t.pageDown();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.goToTopHover", label: m(0, "Go To Top Hover"), alias: "Go To Bottom Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 14, secondary: [2064], weight: 100 } });
  }
  run(n, e) {
    const t = xs.get(e);
    t && t.goToTop();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.goToBottomHover", label: m(0, "Go To Bottom Hover"), alias: "Go To Bottom Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 13, secondary: [2066], weight: 100 } });
  }
  run(n, e) {
    const t = xs.get(e);
    t && t.goToBottom();
  }
}), Tc.register(mS), Tc.register(NM), rr(((n, e) => {
  const t = n.getColor(hB);
  t && (e.addRule(`.monaco-editor .monaco-hover .hover-row:not(:first-child):not(:empty) { border-top: 1px solid ${t.transparent(0.5)}; }`), e.addRule(`.monaco-editor .monaco-hover hr { border-top: 1px solid ${t.transparent(0.5)}; }`), e.addRule(`.monaco-editor .monaco-hover hr { border-bottom: 0px solid ${t.transparent(0.5)}; }`));
}));
class Ax extends V {
  constructor(e) {
    super(), this._editor = e, this._register(e.onMouseDown(((t) => this.onMouseDown(t))));
  }
  dispose() {
    super.dispose();
  }
  onMouseDown(e) {
    const t = this._editor.getOption(148);
    if (t !== "click" && t !== "clickAndHover") return;
    const i = e.target;
    if (i.type !== 6 || !i.detail.injectedText || i.detail.injectedText.options.attachedData !== oz || !i.range) return;
    const s = this._editor.getContribution(xs.ID);
    if (s && !s.isColorPickerVisible) {
      const o = new D(i.range.startLineNumber, i.range.startColumn + 1, i.range.endLineNumber, i.range.endColumn + 1);
      s.showContentHover(o, 1, 0, !1, !0);
    }
  }
}
Ax.ID = "editor.contrib.colorContribution", ft(Ax.ID, Ax, 2), Tc.register(hS);
var TM, RM, Iz = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Zr = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let yh = TM = class extends V {
  constructor(n, e, t, i, s, o, r) {
    super(), this._editor = n, this._modelService = t, this._keybindingService = i, this._instantiationService = s, this._languageFeatureService = o, this._languageConfigurationService = r, this._standaloneColorPickerWidget = null, this._standaloneColorPickerVisible = E.standaloneColorPickerVisible.bindTo(e), this._standaloneColorPickerFocused = E.standaloneColorPickerFocused.bindTo(e);
  }
  showOrFocus() {
    var n;
    this._editor.hasModel() && (this._standaloneColorPickerVisible.get() ? this._standaloneColorPickerFocused.get() || (n = this._standaloneColorPickerWidget) === null || n === void 0 || n.focus() : this._standaloneColorPickerWidget = new fw(this._editor, this._standaloneColorPickerVisible, this._standaloneColorPickerFocused, this._instantiationService, this._modelService, this._keybindingService, this._languageFeatureService, this._languageConfigurationService));
  }
  hide() {
    var n;
    this._standaloneColorPickerFocused.set(!1), this._standaloneColorPickerVisible.set(!1), (n = this._standaloneColorPickerWidget) === null || n === void 0 || n.hide(), this._editor.focus();
  }
  insertColor() {
    var n;
    (n = this._standaloneColorPickerWidget) === null || n === void 0 || n.updateEditor(), this.hide();
  }
  static get(n) {
    return n.getContribution(TM.ID);
  }
};
yh.ID = "editor.contrib.standaloneColorPickerController", yh = TM = Iz([Zr(1, Te), Zr(2, ni), Zr(3, Dt), Zr(4, Se), Zr(5, fe), Zr(6, zt)], yh), ft(yh.ID, yh, 1);
let fw = RM = class extends V {
  constructor(n, e, t, i, s, o, r, a) {
    var l;
    super(), this._editor = n, this._standaloneColorPickerVisible = e, this._standaloneColorPickerFocused = t, this._modelService = s, this._keybindingService = o, this._languageFeaturesService = r, this._languageConfigurationService = a, this.allowEditorOverflow = !0, this._position = void 0, this._body = document.createElement("div"), this._colorHover = null, this._selectionSetInEditor = !1, this._onResult = this._register(new F()), this.onResult = this._onResult.event, this._standaloneColorPickerVisible.set(!0), this._standaloneColorPickerParticipant = i.createInstance(Jv, this._editor), this._position = (l = this._editor._getViewModel()) === null || l === void 0 ? void 0 : l.getPrimaryCursorState().modelState.position;
    const d = this._editor.getSelection(), h = d ? { startLineNumber: d.startLineNumber, startColumn: d.startColumn, endLineNumber: d.endLineNumber, endColumn: d.endColumn } : { startLineNumber: 0, endLineNumber: 0, endColumn: 0, startColumn: 0 }, c = this._register(pa(this._body));
    this._register(c.onDidBlur(((u) => {
      this.hide();
    }))), this._register(c.onDidFocus(((u) => {
      this.focus();
    }))), this._register(this._editor.onDidChangeCursorPosition((() => {
      this._selectionSetInEditor ? this._selectionSetInEditor = !1 : this.hide();
    }))), this._register(this._editor.onMouseMove(((u) => {
      var g;
      const p = (g = u.target.element) === null || g === void 0 ? void 0 : g.classList;
      p && p.contains("colorpicker-color-decoration") && this.hide();
    }))), this._register(this.onResult(((u) => {
      this._render(u.value, u.foundInEditor);
    }))), this._start(h), this._body.style.zIndex = "50", this._editor.addContentWidget(this);
  }
  updateEditor() {
    this._colorHover && this._standaloneColorPickerParticipant.updateEditorModel(this._colorHover);
  }
  getId() {
    return RM.ID;
  }
  getDomNode() {
    return this._body;
  }
  getPosition() {
    if (!this._position) return null;
    const n = this._editor.getOption(60).above;
    return { position: this._position, secondaryPosition: this._position, preference: n ? [1, 2] : [2, 1], positionAffinity: 2 };
  }
  hide() {
    this.dispose(), this._standaloneColorPickerVisible.set(!1), this._standaloneColorPickerFocused.set(!1), this._editor.removeContentWidget(this), this._editor.focus();
  }
  focus() {
    this._standaloneColorPickerFocused.set(!0), this._body.focus();
  }
  async _start(n) {
    const e = await this._computeAsync(n);
    e && this._onResult.fire(new Eae(e.result, e.foundInEditor));
  }
  async _computeAsync(n) {
    if (!this._editor.hasModel()) return null;
    const e = { range: n, color: { red: 0, green: 0, blue: 0, alpha: 1 } }, t = await this._standaloneColorPickerParticipant.createColorHover(e, new vP(this._modelService, this._languageConfigurationService), this._languageFeaturesService.colorProvider);
    return t ? { result: t.colorHover, foundInEditor: t.foundInEditor } : null;
  }
  _render(n, e) {
    const t = document.createDocumentFragment();
    let i;
    const s = { fragment: t, statusBar: this._register(new gS(this._keybindingService)), setColorPicker: (c) => i = c, onContentsChanged: () => {
    }, hide: () => this.hide() };
    if (this._colorHover = n, this._register(this._standaloneColorPickerParticipant.renderHoverParts(s, [n])), i === void 0) return;
    this._body.classList.add("standalone-colorpicker-body"), this._body.style.maxHeight = Math.max(this._editor.getLayoutInfo().height / 4, 250) + "px", this._body.style.maxWidth = Math.max(0.66 * this._editor.getLayoutInfo().width, 500) + "px", this._body.tabIndex = 0, this._body.appendChild(t), i.layout();
    const o = i.body, r = o.saturationBox.domNode.clientWidth, a = o.domNode.clientWidth - r - 22 - 8, l = i.body.enterButton;
    l?.onClicked((() => {
      this.updateEditor(), this.hide();
    }));
    const d = i.header;
    d.pickedColorNode.style.width = r + 8 + "px", d.originalColorNode.style.width = a + "px";
    const h = i.header.closeButton;
    h?.onClicked((() => {
      this.hide();
    })), e && (l && (l.button.textContent = "Replace"), this._selectionSetInEditor = !0, this._editor.setSelection(n.range)), this._editor.layoutContentWidget(this);
  }
};
fw.ID = "editor.contrib.standaloneColorPickerWidget", fw = RM = Iz([Zr(3, Se), Zr(4, ni), Zr(5, Dt), Zr(6, fe), Zr(7, zt)], fw);
class Eae {
  constructor(e, t) {
    this.value = e, this.foundInEditor = t;
  }
}
X(class extends he {
  constructor() {
    super({ id: "editor.action.hideColorPicker", label: m(0, "Hide the Color Picker"), alias: "Hide the Color Picker", precondition: E.standaloneColorPickerVisible.isEqualTo(!0), kbOpts: { primary: 9, weight: 100 } });
  }
  run(n, e) {
    var t;
    (t = yh.get(e)) === null || t === void 0 || t.hide();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertColorWithStandaloneColorPicker", label: m(0, "Insert Color with Standalone Color Picker"), alias: "Insert Color with Standalone Color Picker", precondition: E.standaloneColorPickerFocused.isEqualTo(!0), kbOpts: { primary: 3, weight: 100 } });
  }
  run(n, e) {
    var t;
    (t = yh.get(e)) === null || t === void 0 || t.insertColor();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.showOrFocusStandaloneColorPicker", title: { ...ct(0, "Show or Focus Standalone Color Picker"), mnemonicTitle: m(0, "&&Show or Focus Standalone Color Picker") }, precondition: void 0, menu: [{ id: x.CommandPalette }] });
  }
  runEditorCommand(n, e) {
    var t;
    (t = yh.get(e)) === null || t === void 0 || t.showOrFocus();
  }
});
class qh {
  constructor(e, t, i) {
    this.languageConfigurationService = i, this._selection = e, this._insertSpace = t, this._usedEndToken = null;
  }
  static _haystackHasNeedleAtOffset(e, t, i) {
    if (i < 0) return !1;
    const s = t.length;
    if (i + s > e.length) return !1;
    for (let o = 0; o < s; o++) {
      const r = e.charCodeAt(i + o), a = t.charCodeAt(o);
      if (r !== a && !(r >= 65 && r <= 90 && r + 32 === a || a >= 65 && a <= 90 && a + 32 === r)) return !1;
    }
    return !0;
  }
  _createOperationsForBlockComment(e, t, i, s, o, r) {
    const a = e.startLineNumber, l = e.startColumn, d = e.endLineNumber, h = e.endColumn, c = o.getLineContent(a), u = o.getLineContent(d);
    let g, p = c.lastIndexOf(t, l - 1 + t.length), f = u.indexOf(i, h - 1 - i.length);
    if (p !== -1 && f !== -1) if (a === d)
      c.substring(p + t.length, f).indexOf(i) >= 0 && (p = -1, f = -1);
    else {
      const _ = c.substring(p + t.length), v = u.substring(0, f);
      (_.indexOf(i) >= 0 || v.indexOf(i) >= 0) && (p = -1, f = -1);
    }
    p !== -1 && f !== -1 ? (s && p + t.length < c.length && c.charCodeAt(p + t.length) === 32 && (t += " "), s && f > 0 && u.charCodeAt(f - 1) === 32 && (i = " " + i, f -= 1), g = qh._createRemoveBlockCommentOperations(new D(a, p + t.length + 1, d, f + 1), t, i)) : (g = qh._createAddBlockCommentOperations(e, t, i, this._insertSpace), this._usedEndToken = g.length === 1 ? i : null);
    for (const _ of g) r.addTrackedEditOperation(_.range, _.text);
  }
  static _createRemoveBlockCommentOperations(e, t, i) {
    const s = [];
    return D.isEmpty(e) ? s.push(ii.delete(new D(e.startLineNumber, e.startColumn - t.length, e.endLineNumber, e.endColumn + i.length))) : (s.push(ii.delete(new D(e.startLineNumber, e.startColumn - t.length, e.startLineNumber, e.startColumn))), s.push(ii.delete(new D(e.endLineNumber, e.endColumn, e.endLineNumber, e.endColumn + i.length)))), s;
  }
  static _createAddBlockCommentOperations(e, t, i, s) {
    const o = [];
    return D.isEmpty(e) ? o.push(ii.replace(new D(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn), t + "  " + i)) : (o.push(ii.insert(new W(e.startLineNumber, e.startColumn), t + (s ? " " : ""))), o.push(ii.insert(new W(e.endLineNumber, e.endColumn), (s ? " " : "") + i))), o;
  }
  getEditOperations(e, t) {
    const i = this._selection.startLineNumber, s = this._selection.startColumn;
    e.tokenization.tokenizeIfCheap(i);
    const o = e.getLanguageIdAtPosition(i, s), r = this.languageConfigurationService.getLanguageConfiguration(o).comments;
    r && r.blockCommentStartToken && r.blockCommentEndToken && this._createOperationsForBlockComment(this._selection, r.blockCommentStartToken, r.blockCommentEndToken, this._insertSpace, e, t);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations();
    if (i.length === 2) {
      const s = i[0], o = i[1];
      return new _e(s.range.endLineNumber, s.range.endColumn, o.range.startLineNumber, o.range.startColumn);
    }
    {
      const s = i[0].range, o = this._usedEndToken ? -this._usedEndToken.length - 1 : 0;
      return new _e(s.endLineNumber, s.endColumn + o, s.endLineNumber, s.endColumn + o);
    }
  }
}
class zl {
  constructor(e, t, i, s, o, r, a) {
    this.languageConfigurationService = e, this._selection = t, this._indentSize = i, this._type = s, this._insertSpace = o, this._selectionId = null, this._deltaColumn = 0, this._moveEndPositionDown = !1, this._ignoreEmptyLines = r, this._ignoreFirstLine = a || !1;
  }
  static _gatherPreflightCommentStrings(e, t, i, s) {
    e.tokenization.tokenizeIfCheap(t);
    const o = e.getLanguageIdAtPosition(t, 1), r = s.getLanguageConfiguration(o).comments, a = r ? r.lineCommentToken : null;
    if (!a) return null;
    const l = [];
    for (let d = 0, h = i - t + 1; d < h; d++) l[d] = { ignore: !1, commentStr: a, commentStrOffset: 0, commentStrLength: a.length };
    return l;
  }
  static _analyzeLines(e, t, i, s, o, r, a, l) {
    let d, h = !0;
    d = e === 0 || e !== 1;
    for (let c = 0, u = s.length; c < u; c++) {
      const g = s[c], p = o + c;
      if (p === o && a) {
        g.ignore = !0;
        continue;
      }
      const f = i.getLineContent(p), _ = Jn(f);
      if (_ !== -1) {
        if (h = !1, g.ignore = !1, g.commentStrOffset = _, d && !qh._haystackHasNeedleAtOffset(f, g.commentStr, _) && (e === 0 ? d = !1 : e === 1 || (g.ignore = !0)), d && t) {
          const v = _ + g.commentStrLength;
          v < f.length && f.charCodeAt(v) === 32 && (g.commentStrLength += 1);
        }
      } else g.ignore = r, g.commentStrOffset = f.length;
    }
    if (e === 0 && h) {
      d = !1;
      for (let c = 0, u = s.length; c < u; c++) s[c].ignore = !1;
    }
    return { supported: !0, shouldRemoveComments: d, lines: s };
  }
  static _gatherPreflightData(e, t, i, s, o, r, a, l) {
    const d = zl._gatherPreflightCommentStrings(i, s, o, l);
    return d === null ? { supported: !1 } : zl._analyzeLines(e, t, i, d, s, r, a, l);
  }
  _executeLineComments(e, t, i, s) {
    let o;
    i.shouldRemoveComments ? o = zl._createRemoveLineCommentsOperations(i.lines, s.startLineNumber) : (zl._normalizeInsertionPoint(e, i.lines, s.startLineNumber, this._indentSize), o = this._createAddLineCommentsOperations(i.lines, s.startLineNumber));
    const r = new W(s.positionLineNumber, s.positionColumn);
    for (let a = 0, l = o.length; a < l; a++) t.addEditOperation(o[a].range, o[a].text), D.isEmpty(o[a].range) && D.getStartPosition(o[a].range).equals(r) && e.getLineContent(r.lineNumber).length + 1 === r.column && (this._deltaColumn = (o[a].text || "").length);
    this._selectionId = t.trackSelection(s);
  }
  _attemptRemoveBlockComment(e, t, i, s) {
    let o = t.startLineNumber, r = t.endLineNumber;
    const a = s.length + Math.max(e.getLineFirstNonWhitespaceColumn(t.startLineNumber), t.startColumn);
    let l = e.getLineContent(o).lastIndexOf(i, a - 1), d = e.getLineContent(r).indexOf(s, t.endColumn - 1 - i.length);
    return l !== -1 && d === -1 && (d = e.getLineContent(o).indexOf(s, l + i.length), r = o), l === -1 && d !== -1 && (l = e.getLineContent(r).lastIndexOf(i, d), o = r), !t.isEmpty() || l !== -1 && d !== -1 || (l = e.getLineContent(o).indexOf(i), l !== -1 && (d = e.getLineContent(o).indexOf(s, l + i.length))), l !== -1 && e.getLineContent(o).charCodeAt(l + i.length) === 32 && (i += " "), d !== -1 && e.getLineContent(r).charCodeAt(d - 1) === 32 && (s = " " + s, d -= 1), l !== -1 && d !== -1 ? qh._createRemoveBlockCommentOperations(new D(o, l + i.length + 1, r, d + 1), i, s) : null;
  }
  _executeBlockComment(e, t, i) {
    e.tokenization.tokenizeIfCheap(i.startLineNumber);
    const s = e.getLanguageIdAtPosition(i.startLineNumber, 1), o = this.languageConfigurationService.getLanguageConfiguration(s).comments;
    if (!o || !o.blockCommentStartToken || !o.blockCommentEndToken) return;
    const r = o.blockCommentStartToken, a = o.blockCommentEndToken;
    let l = this._attemptRemoveBlockComment(e, i, r, a);
    if (!l) {
      if (i.isEmpty()) {
        const d = e.getLineContent(i.startLineNumber);
        let h = Jn(d);
        h === -1 && (h = d.length), l = qh._createAddBlockCommentOperations(new D(i.startLineNumber, h + 1, i.startLineNumber, d.length + 1), r, a, this._insertSpace);
      } else l = qh._createAddBlockCommentOperations(new D(i.startLineNumber, e.getLineFirstNonWhitespaceColumn(i.startLineNumber), i.endLineNumber, e.getLineMaxColumn(i.endLineNumber)), r, a, this._insertSpace);
      l.length === 1 && (this._deltaColumn = r.length + 1);
    }
    this._selectionId = t.trackSelection(i);
    for (const d of l) t.addEditOperation(d.range, d.text);
  }
  getEditOperations(e, t) {
    let i = this._selection;
    if (this._moveEndPositionDown = !1, i.startLineNumber === i.endLineNumber && this._ignoreFirstLine) return t.addEditOperation(new D(i.startLineNumber, e.getLineMaxColumn(i.startLineNumber), i.startLineNumber + 1, 1), i.startLineNumber === e.getLineCount() ? "" : `
`), void (this._selectionId = t.trackSelection(i));
    i.startLineNumber < i.endLineNumber && i.endColumn === 1 && (this._moveEndPositionDown = !0, i = i.setEndPosition(i.endLineNumber - 1, e.getLineMaxColumn(i.endLineNumber - 1)));
    const s = zl._gatherPreflightData(this._type, this._insertSpace, e, i.startLineNumber, i.endLineNumber, this._ignoreEmptyLines, this._ignoreFirstLine, this.languageConfigurationService);
    return s.supported ? this._executeLineComments(e, t, s, i) : this._executeBlockComment(e, t, i);
  }
  computeCursorState(e, t) {
    let i = t.getTrackedSelection(this._selectionId);
    return this._moveEndPositionDown && (i = i.setEndPosition(i.endLineNumber + 1, 1)), new _e(i.selectionStartLineNumber, i.selectionStartColumn + this._deltaColumn, i.positionLineNumber, i.positionColumn + this._deltaColumn);
  }
  static _createRemoveLineCommentsOperations(e, t) {
    const i = [];
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e[s];
      r.ignore || i.push(ii.delete(new D(t + s, r.commentStrOffset + 1, t + s, r.commentStrOffset + r.commentStrLength + 1)));
    }
    return i;
  }
  _createAddLineCommentsOperations(e, t) {
    const i = [], s = this._insertSpace ? " " : "";
    for (let o = 0, r = e.length; o < r; o++) {
      const a = e[o];
      a.ignore || i.push(ii.insert(new W(t + o, a.commentStrOffset + 1), a.commentStr + s));
    }
    return i;
  }
  static nextVisibleColumn(e, t, i, s) {
    return i ? e + (t - e % t) : e + s;
  }
  static _normalizeInsertionPoint(e, t, i, s) {
    let o, r, a = 1073741824;
    for (let l = 0, d = t.length; l < d; l++) {
      if (t[l].ignore) continue;
      const h = e.getLineContent(i + l);
      let c = 0;
      for (let u = 0, g = t[l].commentStrOffset; c < a && u < g; u++) c = zl.nextVisibleColumn(c, s, h.charCodeAt(u) === 9, 1);
      c < a && (a = c);
    }
    a = Math.floor(a / s) * s;
    for (let l = 0, d = t.length; l < d; l++) {
      if (t[l].ignore) continue;
      const h = e.getLineContent(i + l);
      let c = 0;
      for (o = 0, r = t[l].commentStrOffset; c < a && o < r; o++) c = zl.nextVisibleColumn(c, s, h.charCodeAt(o) === 9, 1);
      t[l].commentStrOffset = c > a ? o - 1 : o;
    }
  }
}
class Px extends he {
  constructor(e, t) {
    super(t), this._type = e;
  }
  run(e, t) {
    const i = e.get(zt);
    if (!t.hasModel()) return;
    const s = [], o = t.getModel().getOptions(), r = t.getOption(23), a = t.getSelections().map(((d, h) => ({ selection: d, index: h, ignoreFirstLine: !1 })));
    a.sort(((d, h) => D.compareRangesUsingStarts(d.selection, h.selection)));
    let l = a[0];
    for (let d = 1; d < a.length; d++) {
      const h = a[d];
      l.selection.endLineNumber === h.selection.startLineNumber && (l.index < h.index ? h.ignoreFirstLine = !0 : (l.ignoreFirstLine = !0, l = h));
    }
    for (const d of a) s.push(new zl(i, d.selection, o.indentSize, this._type, r.insertSpace, r.ignoreEmptyLines, d.ignoreFirstLine));
    t.pushUndoStop(), t.executeCommands(this.id, s), t.pushUndoStop();
  }
}
X(class extends Px {
  constructor() {
    super(0, { id: "editor.action.commentLine", label: m(0, "Toggle Line Comment"), alias: "Toggle Line Comment", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 2138, weight: 100 }, menuOpts: { menuId: x.MenubarEditMenu, group: "5_insert", title: m(0, "&&Toggle Line Comment"), order: 1 } });
  }
}), X(class extends Px {
  constructor() {
    super(1, { id: "editor.action.addCommentLine", label: m(0, "Add Line Comment"), alias: "Add Line Comment", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2081), weight: 100 } });
  }
}), X(class extends Px {
  constructor() {
    super(2, { id: "editor.action.removeCommentLine", label: m(0, "Remove Line Comment"), alias: "Remove Line Comment", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2099), weight: 100 } });
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.blockComment", label: m(0, "Toggle Block Comment"), alias: "Toggle Block Comment", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 1567, linux: { primary: 3103 }, weight: 100 }, menuOpts: { menuId: x.MenubarEditMenu, group: "5_insert", title: m(0, "Toggle &&Block Comment"), order: 2 } });
  }
  run(n, e) {
    const t = n.get(zt);
    if (!e.hasModel()) return;
    const i = e.getOption(23), s = [], o = e.getSelections();
    for (const r of o) s.push(new qh(r, i.insertSpace, t));
    e.pushUndoStop(), e.executeCommands(this.id, s), e.pushUndoStop();
  }
});
var AM, Iae = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Qc = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let km = AM = class {
  static get(n) {
    return n.getContribution(AM.ID);
  }
  constructor(n, e, t, i, s, o, r, a) {
    this._contextMenuService = e, this._contextViewService = t, this._contextKeyService = i, this._keybindingService = s, this._menuService = o, this._configurationService = r, this._workspaceContextService = a, this._toDispose = new G(), this._contextMenuIsBeingShownCount = 0, this._editor = n, this._toDispose.add(this._editor.onContextMenu(((l) => this._onContextMenu(l)))), this._toDispose.add(this._editor.onMouseWheel(((l) => {
      if (this._contextMenuIsBeingShownCount > 0) {
        const d = this._contextViewService.getContextViewElement(), h = l.srcElement;
        h.shadowRoot && ag(d) === h.shadowRoot || this._contextViewService.hideContextView();
      }
    }))), this._toDispose.add(this._editor.onKeyDown(((l) => {
      this._editor.getOption(24) && l.keyCode === 58 && (l.preventDefault(), l.stopPropagation(), this.showContextMenu());
    })));
  }
  _onContextMenu(n) {
    if (!this._editor.hasModel()) return;
    if (!this._editor.getOption(24)) return this._editor.focus(), void (n.target.position && !this._editor.getSelection().containsPosition(n.target.position) && this._editor.setPosition(n.target.position));
    if (n.target.type === 12 || n.target.type === 6 && n.target.detail.injectedText) return;
    if (n.event.preventDefault(), n.event.stopPropagation(), n.target.type === 11) return this._showScrollbarContextMenu(n.event);
    if (n.target.type !== 6 && n.target.type !== 7 && n.target.type !== 1) return;
    if (this._editor.focus(), n.target.position) {
      let t = !1;
      for (const i of this._editor.getSelections()) if (i.containsPosition(n.target.position)) {
        t = !0;
        break;
      }
      t || this._editor.setPosition(n.target.position);
    }
    let e = null;
    n.target.type !== 1 && (e = n.event), this.showContextMenu(e);
  }
  showContextMenu(n) {
    if (!this._editor.getOption(24) || !this._editor.hasModel()) return;
    const e = this._getMenuActions(this._editor.getModel(), this._editor.isSimpleWidget ? x.SimpleEditorContext : x.EditorContext);
    e.length > 0 && this._doShowContextMenu(e, n);
  }
  _getMenuActions(n, e) {
    const t = [], i = this._menuService.createMenu(e, this._contextKeyService), s = i.getActions({ arg: n.uri });
    i.dispose();
    for (const o of s) {
      const [, r] = o;
      let a = 0;
      for (const l of r) if (l instanceof ev) {
        const d = this._getMenuActions(n, l.item.submenu);
        d.length > 0 && (t.push(new Om(l.id, l.label, d)), a++);
      } else t.push(l), a++;
      a && t.push(new Ui());
    }
    return t.length && t.pop(), t;
  }
  _doShowContextMenu(n, e = null) {
    if (!this._editor.hasModel()) return;
    const t = this._editor.getOption(60);
    this._editor.updateOptions({ hover: { enabled: !1 } });
    let i = e;
    if (!i) {
      this._editor.revealPosition(this._editor.getPosition(), 1), this._editor.render();
      const o = this._editor.getScrolledVisiblePosition(this._editor.getPosition()), r = Ti(this._editor.getDomNode()), a = r.left + o.left, l = r.top + o.top + o.height;
      i = { x: a, y: l };
    }
    const s = this._editor.getOption(127) && !ca;
    this._contextMenuIsBeingShownCount++, this._contextMenuService.showContextMenu({ domForShadowRoot: s ? this._editor.getDomNode() : void 0, getAnchor: () => i, getActions: () => n, getActionViewItem: (o) => {
      const r = this._keybindingFor(o);
      if (r) return new Qm(o, o, { label: !0, keybinding: r.getLabel(), isMenu: !0 });
      const a = o;
      return typeof a.getActionViewItem == "function" ? a.getActionViewItem() : new Qm(o, o, { icon: !0, label: !0, isMenu: !0 });
    }, getKeyBinding: (o) => this._keybindingFor(o), onHide: (o) => {
      this._contextMenuIsBeingShownCount--, this._editor.updateOptions({ hover: t });
    } });
  }
  _showScrollbarContextMenu(n) {
    if (!this._editor.hasModel() || this._workspaceContextService.getWorkspace().id === BW) return;
    const e = this._editor.getOption(73);
    let t = 0;
    const i = (a) => ({ id: "menu-action-" + ++t, label: a.label, tooltip: "", class: void 0, enabled: a.enabled === void 0 || a.enabled, checked: a.checked, run: a.run }), s = (a, l, d, h, c) => {
      if (!l) return i({ label: a, enabled: l, run: () => {
      } });
      const u = (p) => () => {
        this._configurationService.updateValue(d, p);
      }, g = [];
      for (const p of c) g.push(i({ label: p.label, checked: h === p.value, run: u(p.value) }));
      return ((p, f) => new Om("menu-action-" + ++t, p, f, void 0))(a, g);
    }, o = [];
    o.push(i({ label: m(0, "Minimap"), checked: e.enabled, run: () => {
      this._configurationService.updateValue("editor.minimap.enabled", !e.enabled);
    } })), o.push(new Ui()), o.push(i({ label: m(0, "Render Characters"), enabled: e.enabled, checked: e.renderCharacters, run: () => {
      this._configurationService.updateValue("editor.minimap.renderCharacters", !e.renderCharacters);
    } })), o.push(s(m(0, "Vertical size"), e.enabled, "editor.minimap.size", e.size, [{ label: m(0, "Proportional"), value: "proportional" }, { label: m(0, "Fill"), value: "fill" }, { label: m(0, "Fit"), value: "fit" }])), o.push(s(m(0, "Slider"), e.enabled, "editor.minimap.showSlider", e.showSlider, [{ label: m(0, "Mouse Over"), value: "mouseover" }, { label: m(0, "Always"), value: "always" }]));
    const r = this._editor.getOption(127) && !ca;
    this._contextMenuIsBeingShownCount++, this._contextMenuService.showContextMenu({ domForShadowRoot: r ? this._editor.getDomNode() : void 0, getAnchor: () => n, getActions: () => o, onHide: (a) => {
      this._contextMenuIsBeingShownCount--, this._editor.focus();
    } });
  }
  _keybindingFor(n) {
    return this._keybindingService.lookupKeybinding(n.id);
  }
  dispose() {
    this._contextMenuIsBeingShownCount > 0 && this._contextViewService.hideContextView(), this._toDispose.dispose();
  }
};
km.ID = "editor.contrib.contextmenu", km = AM = Iae([Qc(1, io), Qc(2, zd), Qc(3, Te), Qc(4, Dt), Qc(5, Mo), Qc(6, Ye), Qc(7, gg)], km);
ft(km.ID, km, 2), X(class extends he {
  constructor() {
    super({ id: "editor.action.showContextMenu", label: m(0, "Show Editor Context Menu"), alias: "Show Editor Context Menu", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 1092, weight: 100 } });
  }
  run(n, e) {
    var t;
    (t = km.get(e)) === null || t === void 0 || t.showContextMenu();
  }
});
class Ox {
  constructor(e) {
    this.selections = e;
  }
  equals(e) {
    const t = this.selections.length;
    if (t !== e.selections.length) return !1;
    for (let i = 0; i < t; i++) if (!this.selections[i].equalsSelection(e.selections[i])) return !1;
    return !0;
  }
}
class Fx {
  constructor(e, t, i) {
    this.cursorState = e, this.scrollTop = t, this.scrollLeft = i;
  }
}
class Wu extends V {
  static get(e) {
    return e.getContribution(Wu.ID);
  }
  constructor(e) {
    super(), this._editor = e, this._isCursorUndoRedo = !1, this._undoStack = [], this._redoStack = [], this._register(e.onDidChangeModel(((t) => {
      this._undoStack = [], this._redoStack = [];
    }))), this._register(e.onDidChangeModelContent(((t) => {
      this._undoStack = [], this._redoStack = [];
    }))), this._register(e.onDidChangeCursorSelection(((t) => {
      if (this._isCursorUndoRedo || !t.oldSelections || t.oldModelVersionId !== t.modelVersionId) return;
      const i = new Ox(t.oldSelections);
      this._undoStack.length > 0 && this._undoStack[this._undoStack.length - 1].cursorState.equals(i) || (this._undoStack.push(new Fx(i, e.getScrollTop(), e.getScrollLeft())), this._redoStack = [], this._undoStack.length > 50 && this._undoStack.shift());
    })));
  }
  cursorUndo() {
    this._editor.hasModel() && this._undoStack.length !== 0 && (this._redoStack.push(new Fx(new Ox(this._editor.getSelections()), this._editor.getScrollTop(), this._editor.getScrollLeft())), this._applyState(this._undoStack.pop()));
  }
  cursorRedo() {
    this._editor.hasModel() && this._redoStack.length !== 0 && (this._undoStack.push(new Fx(new Ox(this._editor.getSelections()), this._editor.getScrollTop(), this._editor.getScrollLeft())), this._applyState(this._redoStack.pop()));
  }
  _applyState(e) {
    this._isCursorUndoRedo = !0, this._editor.setSelections(e.cursorState.selections), this._editor.setScrollPosition({ scrollTop: e.scrollTop, scrollLeft: e.scrollLeft }), this._isCursorUndoRedo = !1;
  }
}
Wu.ID = "editor.contrib.cursorUndoRedoController";
ft(Wu.ID, Wu, 0), X(class extends he {
  constructor() {
    super({ id: "cursorUndo", label: m(0, "Cursor Undo"), alias: "Cursor Undo", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 2099, weight: 100 } });
  }
  run(n, e, t) {
    var i;
    (i = Wu.get(e)) === null || i === void 0 || i.cursorUndo();
  }
}), X(class extends he {
  constructor() {
    super({ id: "cursorRedo", label: m(0, "Cursor Redo"), alias: "Cursor Redo", precondition: void 0 });
  }
  run(n, e, t) {
    var i;
    (i = Wu.get(e)) === null || i === void 0 || i.cursorRedo();
  }
});
class Mae {
  constructor(e, t, i) {
    this.selection = e, this.targetPosition = t, this.copy = i, this.targetSelection = null;
  }
  getEditOperations(e, t) {
    const i = e.getValueInRange(this.selection);
    this.copy || t.addEditOperation(this.selection, null), t.addEditOperation(new D(this.targetPosition.lineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.targetPosition.column), i), !this.selection.containsPosition(this.targetPosition) || this.copy && (this.selection.getEndPosition().equals(this.targetPosition) || this.selection.getStartPosition().equals(this.targetPosition)) ? this.copy ? this.targetSelection = new _e(this.targetPosition.lineNumber, this.targetPosition.column, this.selection.endLineNumber - this.selection.startLineNumber + this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn) : this.targetPosition.lineNumber > this.selection.endLineNumber ? this.targetSelection = new _e(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn) : this.targetPosition.lineNumber < this.selection.endLineNumber ? this.targetSelection = new _e(this.targetPosition.lineNumber, this.targetPosition.column, this.targetPosition.lineNumber + this.selection.endLineNumber - this.selection.startLineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn) : this.selection.endColumn <= this.targetPosition.column ? this.targetSelection = new _e(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, (this.selection.startLineNumber, this.selection.endLineNumber, this.targetPosition.column - this.selection.endColumn + this.selection.startColumn), this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column : this.selection.endColumn) : this.targetSelection = new _e(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.targetPosition.column + this.selection.endColumn - this.selection.startColumn) : this.targetSelection = this.selection;
  }
  computeCursorState(e, t) {
    return this.targetSelection;
  }
}
function ip(n) {
  return Je ? n.altKey : n.ctrlKey;
}
class id extends V {
  constructor(e) {
    super(), this._editor = e, this._dndDecorationIds = this._editor.createDecorationsCollection(), this._register(this._editor.onMouseDown(((t) => this._onEditorMouseDown(t)))), this._register(this._editor.onMouseUp(((t) => this._onEditorMouseUp(t)))), this._register(this._editor.onMouseDrag(((t) => this._onEditorMouseDrag(t)))), this._register(this._editor.onMouseDrop(((t) => this._onEditorMouseDrop(t)))), this._register(this._editor.onMouseDropCanceled((() => this._onEditorMouseDropCanceled()))), this._register(this._editor.onKeyDown(((t) => this.onEditorKeyDown(t)))), this._register(this._editor.onKeyUp(((t) => this.onEditorKeyUp(t)))), this._register(this._editor.onDidBlurEditorWidget((() => this.onEditorBlur()))), this._register(this._editor.onDidBlurEditorText((() => this.onEditorBlur()))), this._mouseDown = !1, this._modifierPressed = !1, this._dragSelection = null;
  }
  onEditorBlur() {
    this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1, this._modifierPressed = !1;
  }
  onEditorKeyDown(e) {
    this._editor.getOption(35) && !this._editor.getOption(22) && (ip(e) && (this._modifierPressed = !0), this._mouseDown && ip(e) && this._editor.updateOptions({ mouseStyle: "copy" }));
  }
  onEditorKeyUp(e) {
    this._editor.getOption(35) && !this._editor.getOption(22) && (ip(e) && (this._modifierPressed = !1), this._mouseDown && e.keyCode === id.TRIGGER_KEY_VALUE && this._editor.updateOptions({ mouseStyle: "default" }));
  }
  _onEditorMouseDown(e) {
    this._mouseDown = !0;
  }
  _onEditorMouseUp(e) {
    this._mouseDown = !1, this._editor.updateOptions({ mouseStyle: "text" });
  }
  _onEditorMouseDrag(e) {
    const t = e.target;
    if (this._dragSelection === null) {
      const i = (this._editor.getSelections() || []).filter(((s) => t.position && s.containsPosition(t.position)));
      if (i.length !== 1) return;
      this._dragSelection = i[0];
    }
    ip(e.event) ? this._editor.updateOptions({ mouseStyle: "copy" }) : this._editor.updateOptions({ mouseStyle: "default" }), t.position && (this._dragSelection.containsPosition(t.position) ? this._removeDecoration() : this.showAt(t.position));
  }
  _onEditorMouseDropCanceled() {
    this._editor.updateOptions({ mouseStyle: "text" }), this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1;
  }
  _onEditorMouseDrop(e) {
    if (e.target && (this._hitContent(e.target) || this._hitMargin(e.target)) && e.target.position) {
      const t = new W(e.target.position.lineNumber, e.target.position.column);
      if (this._dragSelection === null) {
        let i = null;
        if (e.event.shiftKey) {
          const s = this._editor.getSelection();
          if (s) {
            const { selectionStartLineNumber: o, selectionStartColumn: r } = s;
            i = [new _e(o, r, t.lineNumber, t.column)];
          }
        } else i = (this._editor.getSelections() || []).map(((s) => s.containsPosition(t) ? new _e(t.lineNumber, t.column, t.lineNumber, t.column) : s));
        this._editor.setSelections(i || [], "mouse", 3);
      } else (!this._dragSelection.containsPosition(t) || (ip(e.event) || this._modifierPressed) && (this._dragSelection.getEndPosition().equals(t) || this._dragSelection.getStartPosition().equals(t))) && (this._editor.pushUndoStop(), this._editor.executeCommand(id.ID, new Mae(this._dragSelection, t, ip(e.event) || this._modifierPressed)), this._editor.pushUndoStop());
    }
    this._editor.updateOptions({ mouseStyle: "text" }), this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1;
  }
  showAt(e) {
    this._dndDecorationIds.set([{ range: new D(e.lineNumber, e.column, e.lineNumber, e.column), options: id._DECORATION_OPTIONS }]), this._editor.revealPosition(e, 1);
  }
  _removeDecoration() {
    this._dndDecorationIds.clear();
  }
  _hitContent(e) {
    return e.type === 6 || e.type === 7;
  }
  _hitMargin(e) {
    return e.type === 2 || e.type === 3 || e.type === 4;
  }
  dispose() {
    this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1, this._modifierPressed = !1, super.dispose();
  }
}
var eC;
id.ID = "editor.contrib.dragAndDrop", id.TRIGGER_KEY_VALUE = Je ? 6 : 5, id._DECORATION_OPTIONS = Ve.register({ description: "dnd-target", className: "dnd-target" }), ft(id.ID, id, 2), ft(za.ID, za, 0), W1(sM), re(new class extends Zi {
  constructor() {
    super({ id: zH, precondition: rM, kbOpts: { weight: 100, primary: 2137 } });
  }
  runEditorCommand(n, e) {
    var t;
    return (t = za.get(e)) === null || t === void 0 ? void 0 : t.changePasteType();
  }
}()), re(new class extends Zi {
  constructor() {
    super({ id: "editor.hidePasteWidget", precondition: rM, kbOpts: { weight: 100, primary: 9 } });
  }
  runEditorCommand(n, e) {
    var t;
    (t = za.get(e)) === null || t === void 0 || t.clearWidgets();
  }
}()), X((eC = class extends he {
  constructor() {
    super({ id: "editor.action.pasteAs", label: m(0, "Paste As..."), alias: "Paste As...", precondition: E.writable, metadata: { description: "Paste as", args: [{ name: "args", schema: eC.argsSchema }] } });
  }
  run(n, e, t) {
    var i;
    let s = typeof t?.kind == "string" ? t.kind : void 0;
    return !s && t && (s = typeof t.id == "string" ? t.id : void 0), (i = za.get(e)) === null || i === void 0 ? void 0 : i.pasteAs(s ? new Nt(s) : void 0);
  }
}, eC.argsSchema = { type: "object", properties: { kind: { type: "string", description: m(0, "The kind of the paste edit to try applying. If not provided or there are multiple edits for this kind, the editor will show a picker.") } } }, eC)), X(class extends he {
  constructor() {
    super({ id: "editor.action.pasteAsText", label: m(0, "Paste as Text"), alias: "Paste as Text", precondition: E.writable });
  }
  run(n, e) {
    var t;
    return (t = za.get(e)) === null || t === void 0 ? void 0 : t.pasteAs({ providerId: Wd.id });
  }
});
class F6 {
  constructor(e) {
    this.identifier = e;
  }
}
const Mz = tt("treeViewsDndService");
rt(Mz, class {
  constructor() {
    this._dragOperations = /* @__PURE__ */ new Map();
  }
  removeDragOperationTransfer(n) {
    if (n && this._dragOperations.has(n)) {
      const e = this._dragOperations.get(n);
      return this._dragOperations.delete(n), e;
    }
  }
}, 1);
var PM, Tae = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, tC = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const Tz = "editor.experimental.dropIntoEditor.defaultProvider", Rz = "editor.changeDropType", OM = new ae("dropWidgetVisible", !1, m(0, "Whether the drop widget is showing"));
let Jc = PM = class extends V {
  static get(n) {
    return n.getContribution(PM.ID);
  }
  constructor(n, e, t, i, s) {
    super(), this._configService = t, this._languageFeaturesService = i, this._treeViewsDragAndDropService = s, this.treeItemsTransfer = Zv.getInstance(), this._dropProgressManager = this._register(e.createInstance(lS, "dropIntoEditor", n)), this._postDropWidgetManager = this._register(e.createInstance(dS, "dropIntoEditor", n, OM, { id: Rz, label: m(0, "Show drop options...") })), this._register(n.onDropIntoEditor(((o) => this.onDropIntoEditor(n, o.position, o.event))));
  }
  clearWidgets() {
    this._postDropWidgetManager.clear();
  }
  changeDropType() {
    this._postDropWidgetManager.tryShowSelector();
  }
  async onDropIntoEditor(n, e, t) {
    var i;
    if (!t.dataTransfer || !n.hasModel()) return;
    (i = this._currentOperation) === null || i === void 0 || i.cancel(), n.focus(), n.setPosition(e);
    const s = on((async (o) => {
      const r = new Ic(n, 1, void 0, o);
      try {
        const a = await this.extractDataTransferData(t);
        if (a.size === 0 || r.token.isCancellationRequested) return;
        const l = n.getModel();
        if (!l) return;
        const d = this._languageFeaturesService.documentOnDropEditProvider.ordered(l).filter(((c) => !c.dropMimeTypes || c.dropMimeTypes.some(((u) => a.matches(u))))), h = await this.getDropEdits(d, l, e, a, r);
        if (r.token.isCancellationRequested) return;
        if (h.length) {
          const c = this.getInitialActiveEditIndex(l, h), u = n.getOption(36).showDropSelector === "afterDrop";
          await this._postDropWidgetManager.applyEditAndShowIfNeeded([D.fromPositions(e)], { activeEditIndex: c, allEdits: h }, u, (async (g) => g), o);
        }
      } finally {
        r.dispose(), this._currentOperation === s && (this._currentOperation = void 0);
      }
    }));
    this._dropProgressManager.showWhile(e, m(0, "Running drop handlers. Click to cancel"), s), this._currentOperation = s;
  }
  async getDropEdits(n, e, t, i, s) {
    const o = await f1(Promise.all(n.map((async (r) => {
      try {
        const a = await r.provideDocumentOnDropEdits(e, t, i, s.token);
        return a?.map(((l) => ({ ...l, providerId: r.id })));
      } catch (a) {
        console.error(a);
      }
    }))), s.token);
    return VH(ha(o ?? []).flat());
  }
  getInitialActiveEditIndex(n, e) {
    const t = this._configService.getValue(Tz, { resource: n.uri });
    for (const [i, s] of Object.entries(t)) {
      const o = new Nt(s), r = e.findIndex(((a) => o.value === a.providerId && a.handledMimeType && TH(i, [a.handledMimeType])));
      if (r >= 0) return r;
    }
    return 0;
  }
  async extractDataTransferData(n) {
    if (!n.dataTransfer) return new MH();
    const e = PH(n.dataTransfer);
    if (this.treeItemsTransfer.hasData(F6.prototype)) {
      const t = this.treeItemsTransfer.getData(F6.prototype);
      if (Array.isArray(t)) for (const i of t) {
        const s = await this._treeViewsDragAndDropService.removeDragOperationTransfer(i.identifier);
        if (s) for (const [o, r] of s) e.replace(o, r);
      }
    }
    return e;
  }
};
Jc.ID = "editor.contrib.dropIntoEditorController", Jc = PM = Tae([tC(1, Se), tC(2, Ye), tC(3, fe), tC(4, Mz)], Jc), ft(Jc.ID, Jc, 2), W1(nM), re(new class extends Zi {
  constructor() {
    super({ id: Rz, precondition: OM, kbOpts: { weight: 100, primary: 2137 } });
  }
  runEditorCommand(n, e, t) {
    var i;
    (i = Jc.get(e)) === null || i === void 0 || i.changeDropType();
  }
}()), re(new class extends Zi {
  constructor() {
    super({ id: "editor.hideDropWidget", precondition: OM, kbOpts: { weight: 100, primary: 9 } });
  }
  runEditorCommand(n, e, t) {
    var i;
    (i = Jc.get(e)) === null || i === void 0 || i.clearWidgets();
  }
}()), li.as(ma).registerConfiguration({ ...xy, properties: { [Tz]: { type: "object", scope: 5, description: m(0, "Configures the default drop provider to use for content of a given mime type."), default: {}, additionalProperties: { type: "string" } } } });
class Zn {
  constructor(e) {
    this._editor = e, this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null, this._startPosition = this._editor.getPosition();
  }
  dispose() {
    this._editor.removeDecorations(this._allDecorations()), this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null;
  }
  reset() {
    this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null;
  }
  getCount() {
    return this._decorations.length;
  }
  getFindScope() {
    return this._findScopeDecorationIds[0] ? this._editor.getModel().getDecorationRange(this._findScopeDecorationIds[0]) : null;
  }
  getFindScopes() {
    if (this._findScopeDecorationIds.length) {
      const e = this._findScopeDecorationIds.map(((t) => this._editor.getModel().getDecorationRange(t))).filter(((t) => !!t));
      if (e.length) return e;
    }
    return null;
  }
  getStartPosition() {
    return this._startPosition;
  }
  setStartPosition(e) {
    this._startPosition = e, this.setCurrentFindMatch(null);
  }
  _getDecorationIndex(e) {
    const t = this._decorations.indexOf(e);
    return t >= 0 ? t + 1 : 1;
  }
  getDecorationRangeAt(e) {
    const t = e < this._decorations.length ? this._decorations[e] : null;
    return t ? this._editor.getModel().getDecorationRange(t) : null;
  }
  getCurrentMatchesPosition(e) {
    const t = this._editor.getModel().getDecorationsInRange(e);
    for (const i of t) {
      const s = i.options;
      if (s === Zn._FIND_MATCH_DECORATION || s === Zn._CURRENT_FIND_MATCH_DECORATION) return this._getDecorationIndex(i.id);
    }
    return 0;
  }
  setCurrentFindMatch(e) {
    let t = null, i = 0;
    if (e) for (let s = 0, o = this._decorations.length; s < o; s++) {
      const r = this._editor.getModel().getDecorationRange(this._decorations[s]);
      if (e.equalsRange(r)) {
        t = this._decorations[s], i = s + 1;
        break;
      }
    }
    return this._highlightedDecorationId === null && t === null || this._editor.changeDecorations(((s) => {
      if (this._highlightedDecorationId !== null && (s.changeDecorationOptions(this._highlightedDecorationId, Zn._FIND_MATCH_DECORATION), this._highlightedDecorationId = null), t !== null && (this._highlightedDecorationId = t, s.changeDecorationOptions(this._highlightedDecorationId, Zn._CURRENT_FIND_MATCH_DECORATION)), this._rangeHighlightDecorationId !== null && (s.removeDecoration(this._rangeHighlightDecorationId), this._rangeHighlightDecorationId = null), t !== null) {
        let o = this._editor.getModel().getDecorationRange(t);
        if (o.startLineNumber !== o.endLineNumber && o.endColumn === 1) {
          const r = o.endLineNumber - 1, a = this._editor.getModel().getLineMaxColumn(r);
          o = new D(o.startLineNumber, o.startColumn, r, a);
        }
        this._rangeHighlightDecorationId = s.addDecoration(o, Zn._RANGE_HIGHLIGHT_DECORATION);
      }
    })), i;
  }
  set(e, t) {
    this._editor.changeDecorations(((i) => {
      let s = Zn._FIND_MATCH_DECORATION;
      const o = [];
      if (e.length > 1e3) {
        s = Zn._FIND_MATCH_NO_OVERVIEW_DECORATION;
        const a = this._editor.getModel().getLineCount(), l = this._editor.getLayoutInfo().height / a, d = Math.max(2, Math.ceil(3 / l));
        let h = e[0].range.startLineNumber, c = e[0].range.endLineNumber;
        for (let u = 1, g = e.length; u < g; u++) {
          const p = e[u].range;
          c + d >= p.startLineNumber ? p.endLineNumber > c && (c = p.endLineNumber) : (o.push({ range: new D(h, 1, c, 1), options: Zn._FIND_MATCH_ONLY_OVERVIEW_DECORATION }), h = p.startLineNumber, c = p.endLineNumber);
        }
        o.push({ range: new D(h, 1, c, 1), options: Zn._FIND_MATCH_ONLY_OVERVIEW_DECORATION });
      }
      const r = new Array(e.length);
      for (let a = 0, l = e.length; a < l; a++) r[a] = { range: e[a].range, options: s };
      this._decorations = i.deltaDecorations(this._decorations, r), this._overviewRulerApproximateDecorations = i.deltaDecorations(this._overviewRulerApproximateDecorations, o), this._rangeHighlightDecorationId && (i.removeDecoration(this._rangeHighlightDecorationId), this._rangeHighlightDecorationId = null), this._findScopeDecorationIds.length && (this._findScopeDecorationIds.forEach(((a) => i.removeDecoration(a))), this._findScopeDecorationIds = []), t?.length && (this._findScopeDecorationIds = t.map(((a) => i.addDecoration(a, Zn._FIND_SCOPE_DECORATION))));
    }));
  }
  matchBeforePosition(e) {
    if (this._decorations.length === 0) return null;
    for (let t = this._decorations.length - 1; t >= 0; t--) {
      const i = this._decorations[t], s = this._editor.getModel().getDecorationRange(i);
      if (s && !(s.endLineNumber > e.lineNumber) && (s.endLineNumber < e.lineNumber || !(s.endColumn > e.column)))
        return s;
    }
    return this._editor.getModel().getDecorationRange(this._decorations[this._decorations.length - 1]);
  }
  matchAfterPosition(e) {
    if (this._decorations.length === 0) return null;
    for (let t = 0, i = this._decorations.length; t < i; t++) {
      const s = this._decorations[t], o = this._editor.getModel().getDecorationRange(s);
      if (o && !(o.startLineNumber < e.lineNumber) && (o.startLineNumber > e.lineNumber || !(o.startColumn < e.column)))
        return o;
    }
    return this._editor.getModel().getDecorationRange(this._decorations[0]);
  }
  _allDecorations() {
    let e = [];
    return e = e.concat(this._decorations), e = e.concat(this._overviewRulerApproximateDecorations), this._findScopeDecorationIds.length && e.push(...this._findScopeDecorationIds), this._rangeHighlightDecorationId && e.push(this._rangeHighlightDecorationId), e;
  }
}
Zn._CURRENT_FIND_MATCH_DECORATION = Ve.register({ description: "current-find-match", stickiness: 1, zIndex: 13, className: "currentFindMatch", showIfCollapsed: !0, overviewRuler: { color: ui(cD), position: Do.Center }, minimap: { color: ui(Mp), position: 1 } }), Zn._FIND_MATCH_DECORATION = Ve.register({ description: "find-match", stickiness: 1, zIndex: 10, className: "findMatch", showIfCollapsed: !0, overviewRuler: { color: ui(cD), position: Do.Center }, minimap: { color: ui(Mp), position: 1 } }), Zn._FIND_MATCH_NO_OVERVIEW_DECORATION = Ve.register({ description: "find-match-no-overview", stickiness: 1, className: "findMatch", showIfCollapsed: !0 }), Zn._FIND_MATCH_ONLY_OVERVIEW_DECORATION = Ve.register({ description: "find-match-only-overview", stickiness: 1, overviewRuler: { color: ui(cD), position: Do.Center } }), Zn._RANGE_HIGHLIGHT_DECORATION = Ve.register({ description: "find-range-highlight", stickiness: 1, className: "rangeHighlight", isWholeLine: !0 }), Zn._FIND_SCOPE_DECORATION = Ve.register({ description: "find-scope", className: "findScope", isWholeLine: !0 });
class Rae {
  constructor(e, t, i) {
    this._editorSelection = e, this._ranges = t, this._replaceStrings = i, this._trackedEditorSelectionId = null;
  }
  getEditOperations(e, t) {
    if (this._ranges.length > 0) {
      const i = [];
      for (let r = 0; r < this._ranges.length; r++) i.push({ range: this._ranges[r], text: this._replaceStrings[r] });
      i.sort(((r, a) => D.compareRangesUsingStarts(r.range, a.range)));
      const s = [];
      let o = i[0];
      for (let r = 1; r < i.length; r++) o.range.endLineNumber === i[r].range.startLineNumber && o.range.endColumn === i[r].range.startColumn ? (o.range = o.range.plusRange(i[r].range), o.text = o.text + i[r].text) : (s.push(o), o = i[r]);
      s.push(o);
      for (const r of s) t.addEditOperation(r.range, r.text);
    }
    this._trackedEditorSelectionId = t.trackSelection(this._editorSelection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._trackedEditorSelectionId);
  }
}
function Az(n, e) {
  if (n && n[0] !== "") {
    const t = B6(n, e, "-"), i = B6(n, e, "_");
    return t && !i ? W6(n, e, "-") : !t && i ? W6(n, e, "_") : n[0].toUpperCase() === n[0] ? e.toUpperCase() : n[0].toLowerCase() === n[0] ? e.toLowerCase() : (function(s, o = !1) {
      return !!s && (o && (s = s.replace(/\\./g, "")), s.toLowerCase() !== s);
    })(n[0][0]) && e.length > 0 ? e[0].toUpperCase() + e.substr(1) : n[0][0].toUpperCase() !== n[0][0] && e.length > 0 ? e[0].toLowerCase() + e.substr(1) : e;
  }
  return e;
}
function B6(n, e, t) {
  return n[0].indexOf(t) !== -1 && e.indexOf(t) !== -1 && n[0].split(t).length === e.split(t).length;
}
function W6(n, e, t) {
  const i = e.split(t), s = n[0].split(t);
  let o = "";
  return i.forEach(((r, a) => {
    o += Az([s[a]], r) + t;
  })), o.slice(0, -1);
}
class V6 {
  constructor(e) {
    this.staticValue = e, this.kind = 0;
  }
}
class Aae {
  constructor(e) {
    this.pieces = e, this.kind = 1;
  }
}
class lf {
  static fromStaticValue(e) {
    return new lf([Xu.staticValue(e)]);
  }
  get hasReplacementPatterns() {
    return this._state.kind === 1;
  }
  constructor(e) {
    e && e.length !== 0 ? e.length === 1 && e[0].staticValue !== null ? this._state = new V6(e[0].staticValue) : this._state = new Aae(e) : this._state = new V6("");
  }
  buildReplaceString(e, t) {
    if (this._state.kind === 0) return t ? Az(e, this._state.staticValue) : this._state.staticValue;
    let i = "";
    for (let s = 0, o = this._state.pieces.length; s < o; s++) {
      const r = this._state.pieces[s];
      if (r.staticValue !== null) {
        i += r.staticValue;
        continue;
      }
      let a = lf._substitute(r.matchIndex, e);
      if (r.caseOps !== null && r.caseOps.length > 0) {
        const l = [], d = r.caseOps.length;
        let h = 0;
        for (let c = 0, u = a.length; c < u; c++) {
          if (h >= d) {
            l.push(a.slice(c));
            break;
          }
          switch (r.caseOps[h]) {
            case "U":
              l.push(a[c].toUpperCase());
              break;
            case "u":
              l.push(a[c].toUpperCase()), h++;
              break;
            case "L":
              l.push(a[c].toLowerCase());
              break;
            case "l":
              l.push(a[c].toLowerCase()), h++;
              break;
            default:
              l.push(a[c]);
          }
        }
        a = l.join("");
      }
      i += a;
    }
    return i;
  }
  static _substitute(e, t) {
    if (t === null) return "";
    if (e === 0) return t[0];
    let i = "";
    for (; e > 0; ) {
      if (e < t.length)
        return (t[e] || "") + i;
      i = String(e % 10) + i, e = Math.floor(e / 10);
    }
    return "$" + i;
  }
}
class Xu {
  static staticValue(e) {
    return new Xu(e, -1, null);
  }
  static caseOps(e, t) {
    return new Xu(null, e, t);
  }
  constructor(e, t, i) {
    this.staticValue = e, this.matchIndex = t, i && i.length !== 0 ? this.caseOps = i.slice(0) : this.caseOps = null;
  }
}
class Pae {
  constructor(e) {
    this._source = e, this._lastCharIndex = 0, this._result = [], this._resultLen = 0, this._currentStaticPiece = "";
  }
  emitUnchanged(e) {
    this._emitStatic(this._source.substring(this._lastCharIndex, e)), this._lastCharIndex = e;
  }
  emitStatic(e, t) {
    this._emitStatic(e), this._lastCharIndex = t;
  }
  _emitStatic(e) {
    e.length !== 0 && (this._currentStaticPiece += e);
  }
  emitMatchIndex(e, t, i) {
    this._currentStaticPiece.length !== 0 && (this._result[this._resultLen++] = Xu.staticValue(this._currentStaticPiece), this._currentStaticPiece = ""), this._result[this._resultLen++] = Xu.caseOps(e, i), this._lastCharIndex = t;
  }
  finalize() {
    return this.emitUnchanged(this._source.length), this._currentStaticPiece.length !== 0 && (this._result[this._resultLen++] = Xu.staticValue(this._currentStaticPiece), this._currentStaticPiece = ""), new lf(this._result);
  }
}
const Gl = new ae("findWidgetVisible", !1);
Gl.toNegated();
const vS = new ae("findInputFocussed", !1), FM = new ae("replaceInputFocussed", !1), iC = { primary: 545, mac: { primary: 2593 } }, nC = { primary: 565, mac: { primary: 2613 } }, sC = { primary: 560, mac: { primary: 2608 } }, oC = { primary: 554, mac: { primary: 2602 } }, rC = { primary: 558, mac: { primary: 2606 } }, Oae = "actions.find", Fae = "actions.findWithSelection", Bae = "editor.actions.findWithArgs", BM = "editor.action.nextMatchFindAction", WM = "editor.action.previousMatchFindAction", Wae = "editor.action.goToMatchFindAction", Vae = "editor.action.nextSelectionMatchFindAction", Hae = "editor.action.previousSelectionMatchFindAction", zae = "editor.action.startFindReplaceAction", Pz = "closeFindWidget", SP = "toggleFindCaseSensitive", LP = "toggleFindWholeWord", kP = "toggleFindRegex", Oz = "toggleFindInSelection", Fz = "togglePreserveCase", VM = "editor.action.replaceOne", HM = "editor.action.replaceAll", Uae = "editor.action.selectAllMatches", $h = 19999;
class x0 {
  constructor(e, t) {
    this._toDispose = new G(), this._editor = e, this._state = t, this._isDisposed = !1, this._startSearchingTimer = new Dr(), this._decorations = new Zn(e), this._toDispose.add(this._decorations), this._updateDecorationsScheduler = new Et((() => this.research(!1)), 100), this._toDispose.add(this._updateDecorationsScheduler), this._toDispose.add(this._editor.onDidChangeCursorPosition(((i) => {
      i.reason !== 3 && i.reason !== 5 && i.reason !== 6 || this._decorations.setStartPosition(this._editor.getPosition());
    }))), this._ignoreModelContentChanged = !1, this._toDispose.add(this._editor.onDidChangeModelContent(((i) => {
      this._ignoreModelContentChanged || (i.isFlush && this._decorations.reset(), this._decorations.setStartPosition(this._editor.getPosition()), this._updateDecorationsScheduler.schedule());
    }))), this._toDispose.add(this._state.onFindReplaceStateChange(((i) => this._onStateChanged(i)))), this.research(!1, this._state.searchScope);
  }
  dispose() {
    this._isDisposed = !0, Ht(this._startSearchingTimer), this._toDispose.dispose();
  }
  _onStateChanged(e) {
    !this._isDisposed && this._editor.hasModel() && (e.searchString || e.isReplaceRevealed || e.isRegex || e.wholeWord || e.matchCase || e.searchScope) && (this._editor.getModel().isTooLargeForSyncing() ? (this._startSearchingTimer.cancel(), this._startSearchingTimer.setIfNotSet((() => {
      e.searchScope ? this.research(e.moveCursor, this._state.searchScope) : this.research(e.moveCursor);
    }), 240)) : e.searchScope ? this.research(e.moveCursor, this._state.searchScope) : this.research(e.moveCursor));
  }
  static _getSearchRange(e, t) {
    return t || e.getFullModelRange();
  }
  research(e, t) {
    let i = null;
    t !== void 0 ? t !== null && (i = Array.isArray(t) ? t : [t]) : i = this._decorations.getFindScopes(), i !== null && (i = i.map(((a) => {
      if (a.startLineNumber !== a.endLineNumber) {
        let l = a.endLineNumber;
        return a.endColumn === 1 && (l -= 1), new D(a.startLineNumber, 1, l, this._editor.getModel().getLineMaxColumn(l));
      }
      return a;
    })));
    const s = this._findMatches(i, !1, $h);
    this._decorations.set(s, i);
    const o = this._editor.getSelection();
    let r = this._decorations.getCurrentMatchesPosition(o);
    if (r === 0 && s.length > 0) {
      const a = sv(s.map(((l) => l.range)), ((l) => D.compareRangesUsingStarts(l, o) >= 0));
      r = a > 0 ? a - 1 + 1 : r;
    }
    this._state.changeMatchInfo(r, this._decorations.getCount(), void 0), e && this._editor.getOption(41).cursorMoveOnType && this._moveToNextMatch(this._decorations.getStartPosition());
  }
  _hasMatches() {
    return this._state.matchesCount > 0;
  }
  _cannotFind() {
    if (!this._hasMatches()) {
      const e = this._decorations.getFindScope();
      return e && this._editor.revealRangeInCenterIfOutsideViewport(e, 0), !0;
    }
    return !1;
  }
  _setCurrentFindMatch(e) {
    const t = this._decorations.setCurrentFindMatch(e);
    this._state.changeMatchInfo(t, this._decorations.getCount(), e), this._editor.setSelection(e), this._editor.revealRangeInCenterIfOutsideViewport(e, 0);
  }
  _prevSearchPosition(e) {
    const t = this._state.isRegex && (this._state.searchString.indexOf("^") >= 0 || this._state.searchString.indexOf("$") >= 0);
    let { lineNumber: i, column: s } = e;
    const o = this._editor.getModel();
    return t || s === 1 ? (i === 1 ? i = o.getLineCount() : i--, s = o.getLineMaxColumn(i)) : s--, new W(i, s);
  }
  _moveToPrevMatch(e, t = !1) {
    if (!this._state.canNavigateBack()) {
      const h = this._decorations.matchAfterPosition(e);
      return void (h && this._setCurrentFindMatch(h));
    }
    if (this._decorations.getCount() < $h) {
      let h = this._decorations.matchBeforePosition(e);
      return h && h.isEmpty() && h.getStartPosition().equals(e) && (e = this._prevSearchPosition(e), h = this._decorations.matchBeforePosition(e)), void (h && this._setCurrentFindMatch(h));
    }
    if (this._cannotFind()) return;
    const i = this._decorations.getFindScope(), s = x0._getSearchRange(this._editor.getModel(), i);
    s.getEndPosition().isBefore(e) && (e = s.getEndPosition()), e.isBefore(s.getStartPosition()) && (e = s.getEndPosition());
    const { lineNumber: o, column: r } = e, a = this._editor.getModel();
    let l = new W(o, r), d = a.findPreviousMatch(this._state.searchString, l, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null, !1);
    return d && d.range.isEmpty() && d.range.getStartPosition().equals(l) && (l = this._prevSearchPosition(l), d = a.findPreviousMatch(this._state.searchString, l, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null, !1)), d ? t || s.containsRange(d.range) ? void this._setCurrentFindMatch(d.range) : this._moveToPrevMatch(d.range.getStartPosition(), !0) : void 0;
  }
  moveToPrevMatch() {
    this._moveToPrevMatch(this._editor.getSelection().getStartPosition());
  }
  _nextSearchPosition(e) {
    const t = this._state.isRegex && (this._state.searchString.indexOf("^") >= 0 || this._state.searchString.indexOf("$") >= 0);
    let { lineNumber: i, column: s } = e;
    const o = this._editor.getModel();
    return t || s === o.getLineMaxColumn(i) ? (i === o.getLineCount() ? i = 1 : i++, s = 1) : s++, new W(i, s);
  }
  _moveToNextMatch(e) {
    if (!this._state.canNavigateForward()) {
      const i = this._decorations.matchBeforePosition(e);
      return void (i && this._setCurrentFindMatch(i));
    }
    if (this._decorations.getCount() < $h) {
      let i = this._decorations.matchAfterPosition(e);
      return i && i.isEmpty() && i.getStartPosition().equals(e) && (e = this._nextSearchPosition(e), i = this._decorations.matchAfterPosition(e)), void (i && this._setCurrentFindMatch(i));
    }
    const t = this._getNextMatch(e, !1, !0);
    t && this._setCurrentFindMatch(t.range);
  }
  _getNextMatch(e, t, i, s = !1) {
    if (this._cannotFind()) return null;
    const o = this._decorations.getFindScope(), r = x0._getSearchRange(this._editor.getModel(), o);
    r.getEndPosition().isBefore(e) && (e = r.getStartPosition()), e.isBefore(r.getStartPosition()) && (e = r.getStartPosition());
    const { lineNumber: a, column: l } = e, d = this._editor.getModel();
    let h = new W(a, l), c = d.findNextMatch(this._state.searchString, h, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null, t);
    return i && c && c.range.isEmpty() && c.range.getStartPosition().equals(h) && (h = this._nextSearchPosition(h), c = d.findNextMatch(this._state.searchString, h, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null, t)), c ? s || r.containsRange(c.range) ? c : this._getNextMatch(c.range.getEndPosition(), t, i, !0) : null;
  }
  moveToNextMatch() {
    this._moveToNextMatch(this._editor.getSelection().getEndPosition());
  }
  _moveToMatch(e) {
    const t = this._decorations.getDecorationRangeAt(e);
    t && this._setCurrentFindMatch(t);
  }
  moveToMatch(e) {
    this._moveToMatch(e);
  }
  _getReplacePattern() {
    return this._state.isRegex ? (function(e) {
      if (!e || e.length === 0) return new lf(null);
      const t = [], i = new Pae(e);
      for (let s = 0, o = e.length; s < o; s++) {
        const r = e.charCodeAt(s);
        if (r !== 92) {
          if (r === 36) {
            if (s++, s >= o) break;
            const a = e.charCodeAt(s);
            if (a === 36) {
              i.emitUnchanged(s - 1), i.emitStatic("$", s + 1);
              continue;
            }
            if (a === 48 || a === 38) {
              i.emitUnchanged(s - 1), i.emitMatchIndex(0, s + 1, t), t.length = 0;
              continue;
            }
            if (49 <= a && a <= 57) {
              let l = a - 48;
              if (s + 1 < o) {
                const d = e.charCodeAt(s + 1);
                if (48 <= d && d <= 57) {
                  s++, l = 10 * l + (d - 48), i.emitUnchanged(s - 2), i.emitMatchIndex(l, s + 1, t), t.length = 0;
                  continue;
                }
              }
              i.emitUnchanged(s - 1), i.emitMatchIndex(l, s + 1, t), t.length = 0;
              continue;
            }
          }
        } else {
          if (s++, s >= o) break;
          const a = e.charCodeAt(s);
          switch (a) {
            case 92:
              i.emitUnchanged(s - 1), i.emitStatic("\\", s + 1);
              break;
            case 110:
              i.emitUnchanged(s - 1), i.emitStatic(`
`, s + 1);
              break;
            case 116:
              i.emitUnchanged(s - 1), i.emitStatic("	", s + 1);
              break;
            case 117:
            case 85:
            case 108:
            case 76:
              i.emitUnchanged(s - 1), i.emitStatic("", s + 1), t.push(String.fromCharCode(a));
          }
        }
      }
      return i.finalize();
    })(this._state.replaceString) : lf.fromStaticValue(this._state.replaceString);
  }
  replace() {
    if (!this._hasMatches()) return;
    const e = this._getReplacePattern(), t = this._editor.getSelection(), i = this._getNextMatch(t.getStartPosition(), !0, !1);
    if (i) if (t.equalsRange(i.range)) {
      const s = e.buildReplaceString(i.matches, this._state.preserveCase), o = new Dn(t, s);
      this._executeEditorCommand("replace", o), this._decorations.setStartPosition(new W(t.startLineNumber, t.startColumn + s.length)), this.research(!0);
    } else this._decorations.setStartPosition(this._editor.getPosition()), this._setCurrentFindMatch(i.range);
  }
  _findMatches(e, t, i) {
    const s = (e || [null]).map(((o) => x0._getSearchRange(this._editor.getModel(), o)));
    return this._editor.getModel().findMatches(this._state.searchString, s, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null, t, i);
  }
  replaceAll() {
    if (!this._hasMatches()) return;
    const e = this._decorations.getFindScopes();
    e === null && this._state.matchesCount >= $h ? this._largeReplaceAll() : this._regularReplaceAll(e), this.research(!1);
  }
  _largeReplaceAll() {
    const e = new su(this._state.searchString, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null).parseSearchRequest();
    if (!e) return;
    let t = e.regex;
    if (!t.multiline) {
      let h = "mu";
      t.ignoreCase && (h += "i"), t.global && (h += "g"), t = new RegExp(t.source, h);
    }
    const i = this._editor.getModel(), s = i.getValue(1), o = i.getFullModelRange(), r = this._getReplacePattern();
    let a;
    const l = this._state.preserveCase;
    a = r.hasReplacementPatterns || l ? s.replace(t, (function() {
      return r.buildReplaceString(arguments, l);
    })) : s.replace(t, r.buildReplaceString(null, l));
    const d = new KR(o, a, this._editor.getSelection());
    this._executeEditorCommand("replaceAll", d);
  }
  _regularReplaceAll(e) {
    const t = this._getReplacePattern(), i = this._findMatches(e, t.hasReplacementPatterns || this._state.preserveCase, 1073741824), s = [];
    for (let r = 0, a = i.length; r < a; r++) s[r] = t.buildReplaceString(i[r].matches, this._state.preserveCase);
    const o = new Rae(this._editor.getSelection(), i.map(((r) => r.range)), s);
    this._executeEditorCommand("replaceAll", o);
  }
  selectAllMatches() {
    if (!this._hasMatches()) return;
    const e = this._decorations.getFindScopes();
    let t = this._findMatches(e, !1, 1073741824).map(((s) => new _e(s.range.startLineNumber, s.range.startColumn, s.range.endLineNumber, s.range.endColumn)));
    const i = this._editor.getSelection();
    for (let s = 0, o = t.length; s < o; s++)
      if (t[s].equalsRange(i)) {
        t = [i].concat(t.slice(0, s)).concat(t.slice(s + 1));
        break;
      }
    this._editor.setSelections(t);
  }
  _executeEditorCommand(e, t) {
    try {
      this._ignoreModelContentChanged = !0, this._editor.pushUndoStop(), this._editor.executeCommand(e, t), this._editor.pushUndoStop();
    } finally {
      this._ignoreModelContentChanged = !1;
    }
  }
}
class nk extends To {
  constructor(e, t, i) {
    super(), this._hideSoon = this._register(new Et((() => this._hide()), 2e3)), this._isVisible = !1, this._editor = e, this._state = t, this._keybindingService = i, this._domNode = document.createElement("div"), this._domNode.className = "findOptionsWidget", this._domNode.style.display = "none", this._domNode.style.top = "10px", this._domNode.style.zIndex = "12", this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true");
    const s = { inputActiveOptionBorder: de(OR), inputActiveOptionForeground: de(FR), inputActiveOptionBackground: de(Eu) }, o = this._register(Zm());
    this.caseSensitive = this._register(new sV({ appendTitle: this._keybindingLabelFor(SP), isChecked: this._state.matchCase, hoverDelegate: o, ...s })), this._domNode.appendChild(this.caseSensitive.domNode), this._register(this.caseSensitive.onChange((() => {
      this._state.change({ matchCase: this.caseSensitive.checked }, !1);
    }))), this.wholeWords = this._register(new oV({ appendTitle: this._keybindingLabelFor(LP), isChecked: this._state.wholeWord, hoverDelegate: o, ...s })), this._domNode.appendChild(this.wholeWords.domNode), this._register(this.wholeWords.onChange((() => {
      this._state.change({ wholeWord: this.wholeWords.checked }, !1);
    }))), this.regex = this._register(new rV({ appendTitle: this._keybindingLabelFor(kP), isChecked: this._state.isRegex, hoverDelegate: o, ...s })), this._domNode.appendChild(this.regex.domNode), this._register(this.regex.onChange((() => {
      this._state.change({ isRegex: this.regex.checked }, !1);
    }))), this._editor.addOverlayWidget(this), this._register(this._state.onFindReplaceStateChange(((r) => {
      let a = !1;
      r.isRegex && (this.regex.checked = this._state.isRegex, a = !0), r.wholeWord && (this.wholeWords.checked = this._state.wholeWord, a = !0), r.matchCase && (this.caseSensitive.checked = this._state.matchCase, a = !0), !this._state.isRevealed && a && this._revealTemporarily();
    }))), this._register(K(this._domNode, ie.MOUSE_LEAVE, ((r) => this._onMouseLeave()))), this._register(K(this._domNode, "mouseover", ((r) => this._onMouseOver())));
  }
  _keybindingLabelFor(e) {
    const t = this._keybindingService.lookupKeybinding(e);
    return t ? ` (${t.getLabel()})` : "";
  }
  dispose() {
    this._editor.removeOverlayWidget(this), super.dispose();
  }
  getId() {
    return nk.ID;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return { preference: 0 };
  }
  highlightFindOptions() {
    this._revealTemporarily();
  }
  _revealTemporarily() {
    this._show(), this._hideSoon.schedule();
  }
  _onMouseLeave() {
    this._hideSoon.schedule();
  }
  _onMouseOver() {
    this._hideSoon.cancel();
  }
  _show() {
    this._isVisible || (this._isVisible = !0, this._domNode.style.display = "block");
  }
  _hide() {
    this._isVisible && (this._isVisible = !1, this._domNode.style.display = "none");
  }
}
function aC(n, e) {
  return n === 1 || n !== 2 && e;
}
nk.ID = "editor.contrib.findOptionsWidget";
class Kae extends V {
  get searchString() {
    return this._searchString;
  }
  get replaceString() {
    return this._replaceString;
  }
  get isRevealed() {
    return this._isRevealed;
  }
  get isReplaceRevealed() {
    return this._isReplaceRevealed;
  }
  get isRegex() {
    return aC(this._isRegexOverride, this._isRegex);
  }
  get wholeWord() {
    return aC(this._wholeWordOverride, this._wholeWord);
  }
  get matchCase() {
    return aC(this._matchCaseOverride, this._matchCase);
  }
  get preserveCase() {
    return aC(this._preserveCaseOverride, this._preserveCase);
  }
  get actualIsRegex() {
    return this._isRegex;
  }
  get actualWholeWord() {
    return this._wholeWord;
  }
  get actualMatchCase() {
    return this._matchCase;
  }
  get actualPreserveCase() {
    return this._preserveCase;
  }
  get searchScope() {
    return this._searchScope;
  }
  get matchesPosition() {
    return this._matchesPosition;
  }
  get matchesCount() {
    return this._matchesCount;
  }
  get currentMatch() {
    return this._currentMatch;
  }
  constructor() {
    super(), this._onFindReplaceStateChange = this._register(new F()), this.onFindReplaceStateChange = this._onFindReplaceStateChange.event, this._searchString = "", this._replaceString = "", this._isRevealed = !1, this._isReplaceRevealed = !1, this._isRegex = !1, this._isRegexOverride = 0, this._wholeWord = !1, this._wholeWordOverride = 0, this._matchCase = !1, this._matchCaseOverride = 0, this._preserveCase = !1, this._preserveCaseOverride = 0, this._searchScope = null, this._matchesPosition = 0, this._matchesCount = 0, this._currentMatch = null, this._loop = !0, this._isSearching = !1, this._filters = null;
  }
  changeMatchInfo(e, t, i) {
    const s = { moveCursor: !1, updateHistory: !1, searchString: !1, replaceString: !1, isRevealed: !1, isReplaceRevealed: !1, isRegex: !1, wholeWord: !1, matchCase: !1, preserveCase: !1, searchScope: !1, matchesPosition: !1, matchesCount: !1, currentMatch: !1, loop: !1, isSearching: !1, filters: !1 };
    let o = !1;
    t === 0 && (e = 0), e > t && (e = t), this._matchesPosition !== e && (this._matchesPosition = e, s.matchesPosition = !0, o = !0), this._matchesCount !== t && (this._matchesCount = t, s.matchesCount = !0, o = !0), i !== void 0 && (D.equalsRange(this._currentMatch, i) || (this._currentMatch = i, s.currentMatch = !0, o = !0)), o && this._onFindReplaceStateChange.fire(s);
  }
  change(e, t, i = !0) {
    var s;
    const o = { moveCursor: t, updateHistory: i, searchString: !1, replaceString: !1, isRevealed: !1, isReplaceRevealed: !1, isRegex: !1, wholeWord: !1, matchCase: !1, preserveCase: !1, searchScope: !1, matchesPosition: !1, matchesCount: !1, currentMatch: !1, loop: !1, isSearching: !1, filters: !1 };
    let r = !1;
    const a = this.isRegex, l = this.wholeWord, d = this.matchCase, h = this.preserveCase;
    e.searchString !== void 0 && this._searchString !== e.searchString && (this._searchString = e.searchString, o.searchString = !0, r = !0), e.replaceString !== void 0 && this._replaceString !== e.replaceString && (this._replaceString = e.replaceString, o.replaceString = !0, r = !0), e.isRevealed !== void 0 && this._isRevealed !== e.isRevealed && (this._isRevealed = e.isRevealed, o.isRevealed = !0, r = !0), e.isReplaceRevealed !== void 0 && this._isReplaceRevealed !== e.isReplaceRevealed && (this._isReplaceRevealed = e.isReplaceRevealed, o.isReplaceRevealed = !0, r = !0), e.isRegex !== void 0 && (this._isRegex = e.isRegex), e.wholeWord !== void 0 && (this._wholeWord = e.wholeWord), e.matchCase !== void 0 && (this._matchCase = e.matchCase), e.preserveCase !== void 0 && (this._preserveCase = e.preserveCase), e.searchScope !== void 0 && (!((s = e.searchScope) === null || s === void 0) && s.every(((c) => {
      var u;
      return (u = this._searchScope) === null || u === void 0 ? void 0 : u.some(((g) => !D.equalsRange(g, c)));
    })) || (this._searchScope = e.searchScope, o.searchScope = !0, r = !0)), e.loop !== void 0 && this._loop !== e.loop && (this._loop = e.loop, o.loop = !0, r = !0), e.isSearching !== void 0 && this._isSearching !== e.isSearching && (this._isSearching = e.isSearching, o.isSearching = !0, r = !0), e.filters !== void 0 && (this._filters ? this._filters.update(e.filters) : this._filters = e.filters, o.filters = !0, r = !0), this._isRegexOverride = e.isRegexOverride !== void 0 ? e.isRegexOverride : 0, this._wholeWordOverride = e.wholeWordOverride !== void 0 ? e.wholeWordOverride : 0, this._matchCaseOverride = e.matchCaseOverride !== void 0 ? e.matchCaseOverride : 0, this._preserveCaseOverride = e.preserveCaseOverride !== void 0 ? e.preserveCaseOverride : 0, a !== this.isRegex && (r = !0, o.isRegex = !0), l !== this.wholeWord && (r = !0, o.wholeWord = !0), d !== this.matchCase && (r = !0, o.matchCase = !0), h !== this.preserveCase && (r = !0, o.preserveCase = !0), r && this._onFindReplaceStateChange.fire(o);
  }
  canNavigateBack() {
    return this.canNavigateInLoop() || this.matchesPosition !== 1;
  }
  canNavigateForward() {
    return this.canNavigateInLoop() || this.matchesPosition < this.matchesCount;
  }
  canNavigateInLoop() {
    return this._loop || this.matchesCount >= $h;
  }
}
const jae = m(0, "input"), qae = m(0, "Preserve Case");
class $ae extends bf {
  constructor(e) {
    var t;
    super({ icon: ne.preserveCase, title: qae + e.appendTitle, isChecked: e.isChecked, hoverDelegate: (t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("element"), inputActiveOptionBorder: e.inputActiveOptionBorder, inputActiveOptionForeground: e.inputActiveOptionForeground, inputActiveOptionBackground: e.inputActiveOptionBackground });
  }
}
class Gae extends To {
  constructor(e, t, i, s) {
    super(), this._showOptionButtons = i, this.fixFocusOnOptionClickEnabled = !0, this.cachedOptionsWidth = 0, this._onDidOptionChange = this._register(new F()), this.onDidOptionChange = this._onDidOptionChange.event, this._onKeyDown = this._register(new F()), this.onKeyDown = this._onKeyDown.event, this._onMouseDown = this._register(new F()), this._onInput = this._register(new F()), this._onKeyUp = this._register(new F()), this._onPreserveCaseKeyDown = this._register(new F()), this.onPreserveCaseKeyDown = this._onPreserveCaseKeyDown.event, this.contextViewProvider = t, this.placeholder = s.placeholder || "", this.validation = s.validation, this.label = s.label || jae;
    const o = s.appendPreserveCaseLabel || "", r = s.history || [], a = !!s.flexibleHeight, l = !!s.flexibleWidth, d = s.flexibleMaxHeight;
    this.domNode = document.createElement("div"), this.domNode.classList.add("monaco-findInput"), this.inputBox = this._register(new aV(this.domNode, this.contextViewProvider, { ariaLabel: this.label || "", placeholder: this.placeholder || "", validationOptions: { validation: this.validation }, history: r, showHistoryHint: s.showHistoryHint, flexibleHeight: a, flexibleWidth: l, flexibleMaxHeight: d, inputBoxStyles: s.inputBoxStyles })), this.preserveCase = this._register(new $ae({ appendTitle: o, isChecked: !1, ...s.toggleStyles })), this._register(this.preserveCase.onChange(((u) => {
      this._onDidOptionChange.fire(u), !u && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
    }))), this._register(this.preserveCase.onKeyDown(((u) => {
      this._onPreserveCaseKeyDown.fire(u);
    }))), this._showOptionButtons ? this.cachedOptionsWidth = this.preserveCase.width() : this.cachedOptionsWidth = 0;
    const h = [this.preserveCase.domNode];
    this.onkeydown(this.domNode, ((u) => {
      if (u.equals(15) || u.equals(17) || u.equals(9)) {
        const g = h.indexOf(this.domNode.ownerDocument.activeElement);
        if (g >= 0) {
          let p = -1;
          u.equals(17) ? p = (g + 1) % h.length : u.equals(15) && (p = g === 0 ? h.length - 1 : g - 1), u.equals(9) ? (h[g].blur(), this.inputBox.focus()) : p >= 0 && h[p].focus(), Ze(u, !0);
        }
      }
    }));
    const c = document.createElement("div");
    c.className = "controls", c.style.display = this._showOptionButtons ? "block" : "none", c.appendChild(this.preserveCase.domNode), this.domNode.appendChild(c), e?.appendChild(this.domNode), this.onkeydown(this.inputBox.inputElement, ((u) => this._onKeyDown.fire(u))), this.onkeyup(this.inputBox.inputElement, ((u) => this._onKeyUp.fire(u))), this.oninput(this.inputBox.inputElement, ((u) => this._onInput.fire())), this.onmousedown(this.inputBox.inputElement, ((u) => this._onMouseDown.fire(u)));
  }
  enable() {
    this.domNode.classList.remove("disabled"), this.inputBox.enable(), this.preserveCase.enable();
  }
  disable() {
    this.domNode.classList.add("disabled"), this.inputBox.disable(), this.preserveCase.disable();
  }
  setEnabled(e) {
    e ? this.enable() : this.disable();
  }
  select() {
    this.inputBox.select();
  }
  focus() {
    this.inputBox.focus();
  }
  getPreserveCase() {
    return this.preserveCase.checked;
  }
  setPreserveCase(e) {
    this.preserveCase.checked = e;
  }
  focusOnPreserve() {
    this.preserveCase.focus();
  }
  validate() {
    var e;
    (e = this.inputBox) === null || e === void 0 || e.validate();
  }
  set width(e) {
    this.inputBox.paddingRight = this.cachedOptionsWidth, this.domNode.style.width = e + "px";
  }
  dispose() {
    super.dispose();
  }
}
var Bz = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Wz = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const zM = new ae("suggestWidgetVisible", !1, m(0, "Whether suggestion are visible")), UM = "historyNavigationWidgetFocus", Vz = "historyNavigationForwardsEnabled", Hz = "historyNavigationBackwardsEnabled";
let Vu;
const lC = [];
function zz(n, e) {
  if (lC.includes(e)) throw new Error("Cannot register the same widget multiple times");
  lC.push(e);
  const t = new G(), i = new ae(UM, !1).bindTo(n), s = new ae(Vz, !0).bindTo(n), o = new ae(Hz, !0).bindTo(n), r = () => {
    i.set(!0), Vu = e;
  }, a = () => {
    i.set(!1), Vu === e && (Vu = void 0);
  };
  return HS(e.element) && r(), t.add(e.onDidFocus((() => r()))), t.add(e.onDidBlur((() => a()))), t.add(ye((() => {
    lC.splice(lC.indexOf(e), 1), a();
  }))), { historyNavigationForwardsEnablement: s, historyNavigationBackwardsEnablement: o, dispose() {
    t.dispose();
  } };
}
let KM = class extends lV {
  constructor(n, e, t, i) {
    super(n, e, t);
    const s = this._register(i.createScoped(this.inputBox.element));
    this._register(zz(s, this.inputBox));
  }
};
KM = Bz([Wz(3, Te)], KM);
let jM = class extends Gae {
  constructor(n, e, t, i, s = !1) {
    super(n, e, s, t);
    const o = this._register(i.createScoped(this.inputBox.element));
    this._register(zz(o, this.inputBox));
  }
};
function H6(n) {
  var e, t;
  return ((e = n.lookupKeybinding("history.showPrevious")) === null || e === void 0 ? void 0 : e.getElectronAccelerator()) === "Up" && ((t = n.lookupKeybinding("history.showNext")) === null || t === void 0 ? void 0 : t.getElectronAccelerator()) === "Down";
}
jM = Bz([Wz(3, Te)], jM), Es.registerCommandAndKeybindingRule({ id: "history.showPrevious", weight: 200, when: q.and(q.has(UM), q.equals(Hz, !0), q.not("isComposing"), zM.isEqualTo(!1)), primary: 16, secondary: [528], handler: (n) => {
  Vu?.showPreviousValue();
} }), Es.registerCommandAndKeybindingRule({ id: "history.showNext", weight: 200, when: q.and(q.has(UM), q.equals(Vz, !0), q.not("isComposing"), zM.isEqualTo(!1)), primary: 18, secondary: [530], handler: (n) => {
  Vu?.showNextValue();
} });
const Zae = Ei("find-selection", ne.selection, m(0, "Icon for 'Find in Selection' in the editor find widget.")), z6 = Ei("find-collapsed", ne.chevronRight, m(0, "Icon to indicate that the editor find widget is collapsed.")), U6 = Ei("find-expanded", ne.chevronDown, m(0, "Icon to indicate that the editor find widget is expanded.")), Yae = Ei("find-replace", ne.replace, m(0, "Icon for 'Replace' in the editor find widget.")), Xae = Ei("find-replace-all", ne.replaceAll, m(0, "Icon for 'Replace All' in the editor find widget.")), Qae = Ei("find-previous-match", ne.arrowUp, m(0, "Icon for 'Find Previous' in the editor find widget.")), Jae = Ei("find-next-match", ne.arrowDown, m(0, "Icon for 'Find Next' in the editor find widget.")), ele = m(0, "Find / Replace"), tle = m(0, "Find"), ile = m(0, "Find"), nle = m(0, "Previous Match"), sle = m(0, "Next Match"), ole = m(0, "Find in Selection"), rle = m(0, "Close"), ale = m(0, "Replace"), lle = m(0, "Replace"), dle = m(0, "Replace"), hle = m(0, "Replace All"), cle = m(0, "Toggle Replace"), ule = m(0, "Only the first {0} results are highlighted, but all find operations work on the entire text.", $h), gle = m(0, "{0} of {1}"), K6 = m(0, "No results"), np = 419;
let e_ = 69;
const j6 = "ctrlEnterReplaceAll.windows.donotask", q6 = Je ? 256 : 2048;
class Bx {
  constructor(e) {
    this.afterLineNumber = e, this.heightInPx = 33, this.suppressMouseDown = !1, this.domNode = document.createElement("div"), this.domNode.className = "dock-find-viewzone";
  }
}
function $6(n, e, t) {
  const i = !!e.match(/\n/);
  t && i && t.selectionStart > 0 && n.stopPropagation();
}
function G6(n, e, t) {
  const i = !!e.match(/\n/);
  t && i && t.selectionEnd < t.value.length && n.stopPropagation();
}
class sk extends To {
  constructor(e, t, i, s, o, r, a, l, d) {
    super(), this._cachedHeight = null, this._revealTimeouts = [], this._codeEditor = e, this._controller = t, this._state = i, this._contextViewProvider = s, this._keybindingService = o, this._contextKeyService = r, this._storageService = l, this._notificationService = d, this._ctrlEnterReplaceAllWarningPrompted = !!l.getBoolean(j6, 0), this._isVisible = !1, this._isReplaceVisible = !1, this._ignoreChangeEvent = !1, this._updateHistoryDelayer = new Sr(500), this._register(ye((() => this._updateHistoryDelayer.cancel()))), this._register(this._state.onFindReplaceStateChange(((h) => this._onStateChanged(h)))), this._buildDomNode(), this._updateButtons(), this._tryUpdateWidgetWidth(), this._findInput.inputBox.layout(), this._register(this._codeEditor.onDidChangeConfiguration(((h) => {
      if (h.hasChanged(91) && (this._codeEditor.getOption(91) && this._state.change({ isReplaceRevealed: !1 }, !1), this._updateButtons()), h.hasChanged(145) && this._tryUpdateWidgetWidth(), h.hasChanged(2) && this.updateAccessibilitySupport(), h.hasChanged(41)) {
        const c = this._codeEditor.getOption(41).loop;
        this._state.change({ loop: c }, !1);
        const u = this._codeEditor.getOption(41).addExtraSpaceOnTop;
        u && !this._viewZone && (this._viewZone = new Bx(0), this._showViewZone()), !u && this._viewZone && this._removeViewZone();
      }
    }))), this.updateAccessibilitySupport(), this._register(this._codeEditor.onDidChangeCursorSelection((() => {
      this._isVisible && this._updateToggleSelectionFindButton();
    }))), this._register(this._codeEditor.onDidFocusEditorWidget((async () => {
      if (this._isVisible) {
        const h = await this._controller.getGlobalBufferTerm();
        h && h !== this._state.searchString && (this._state.change({ searchString: h }, !1), this._findInput.select());
      }
    }))), this._findInputFocused = vS.bindTo(r), this._findFocusTracker = this._register(pa(this._findInput.inputBox.inputElement)), this._register(this._findFocusTracker.onDidFocus((() => {
      this._findInputFocused.set(!0), this._updateSearchScope();
    }))), this._register(this._findFocusTracker.onDidBlur((() => {
      this._findInputFocused.set(!1);
    }))), this._replaceInputFocused = FM.bindTo(r), this._replaceFocusTracker = this._register(pa(this._replaceInput.inputBox.inputElement)), this._register(this._replaceFocusTracker.onDidFocus((() => {
      this._replaceInputFocused.set(!0), this._updateSearchScope();
    }))), this._register(this._replaceFocusTracker.onDidBlur((() => {
      this._replaceInputFocused.set(!1);
    }))), this._codeEditor.addOverlayWidget(this), this._codeEditor.getOption(41).addExtraSpaceOnTop && (this._viewZone = new Bx(0)), this._register(this._codeEditor.onDidChangeModel((() => {
      this._isVisible && (this._viewZoneId = void 0);
    }))), this._register(this._codeEditor.onDidScrollChange(((h) => {
      h.scrollTopChanged ? this._layoutViewZone() : setTimeout((() => {
        this._layoutViewZone();
      }), 0);
    })));
  }
  getId() {
    return sk.ID;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return this._isVisible ? { preference: 0 } : null;
  }
  _onStateChanged(e) {
    if (e.searchString) {
      try {
        this._ignoreChangeEvent = !0, this._findInput.setValue(this._state.searchString);
      } finally {
        this._ignoreChangeEvent = !1;
      }
      this._updateButtons();
    }
    if (e.replaceString && (this._replaceInput.inputBox.value = this._state.replaceString), e.isRevealed && (this._state.isRevealed ? this._reveal() : this._hide(!0)), e.isReplaceRevealed && (this._state.isReplaceRevealed ? this._codeEditor.getOption(91) || this._isReplaceVisible || (this._isReplaceVisible = !0, this._replaceInput.width = os(this._findInput.domNode), this._updateButtons(), this._replaceInput.inputBox.layout()) : this._isReplaceVisible && (this._isReplaceVisible = !1, this._updateButtons())), (e.isRevealed || e.isReplaceRevealed) && (this._state.isRevealed || this._state.isReplaceRevealed) && this._tryUpdateHeight() && this._showViewZone(), e.isRegex && this._findInput.setRegex(this._state.isRegex), e.wholeWord && this._findInput.setWholeWords(this._state.wholeWord), e.matchCase && this._findInput.setCaseSensitive(this._state.matchCase), e.preserveCase && this._replaceInput.setPreserveCase(this._state.preserveCase), e.searchScope && (this._state.searchScope ? this._toggleSelectionFind.checked = !0 : this._toggleSelectionFind.checked = !1, this._updateToggleSelectionFindButton()), e.searchString || e.matchesCount || e.matchesPosition) {
      const t = this._state.searchString.length > 0 && this._state.matchesCount === 0;
      this._domNode.classList.toggle("no-results", t), this._updateMatchesCount(), this._updateButtons();
    }
    (e.searchString || e.currentMatch) && this._layoutViewZone(), e.updateHistory && this._delayedUpdateHistory(), e.loop && this._updateButtons();
  }
  _delayedUpdateHistory() {
    this._updateHistoryDelayer.trigger(this._updateHistory.bind(this)).then(void 0, We);
  }
  _updateHistory() {
    this._state.searchString && this._findInput.inputBox.addToHistory(), this._state.replaceString && this._replaceInput.inputBox.addToHistory();
  }
  _updateMatchesCount() {
    let e;
    if (this._matchesCount.style.minWidth = e_ + "px", this._state.matchesCount >= $h ? this._matchesCount.title = ule : this._matchesCount.title = "", this._matchesCount.firstChild && this._matchesCount.removeChild(this._matchesCount.firstChild), this._state.matchesCount > 0) {
      let t = String(this._state.matchesCount);
      this._state.matchesCount >= $h && (t += "+");
      let i = String(this._state.matchesPosition);
      i === "0" && (i = "?"), e = sg(gle, i, t);
    } else e = K6;
    this._matchesCount.appendChild(document.createTextNode(e)), Io(this._getAriaLabel(e, this._state.currentMatch, this._state.searchString)), e_ = Math.max(e_, this._matchesCount.clientWidth);
  }
  _getAriaLabel(e, t, i) {
    if (e === K6) return i === "" ? m(0, "{0} found", e) : m(0, "{0} found for '{1}'", e, i);
    if (t) {
      const s = m(0, "{0} found for '{1}', at {2}", e, i, t.startLineNumber + ":" + t.startColumn), o = this._codeEditor.getModel();
      return o && t.startLineNumber <= o.getLineCount() && t.startLineNumber >= 1 ? `${o.getLineContent(t.startLineNumber)}, ${s}` : s;
    }
    return m(0, "{0} found for '{1}'", e, i);
  }
  _updateToggleSelectionFindButton() {
    const e = this._codeEditor.getSelection(), t = !!e && (e.startLineNumber !== e.endLineNumber || e.startColumn !== e.endColumn), i = this._toggleSelectionFind.checked;
    this._isVisible && (i || t) ? this._toggleSelectionFind.enable() : this._toggleSelectionFind.disable();
  }
  _updateButtons() {
    this._findInput.setEnabled(this._isVisible), this._replaceInput.setEnabled(this._isVisible && this._isReplaceVisible), this._updateToggleSelectionFindButton(), this._closeBtn.setEnabled(this._isVisible);
    const e = this._state.searchString.length > 0, t = !!this._state.matchesCount;
    this._prevBtn.setEnabled(this._isVisible && e && t && this._state.canNavigateBack()), this._nextBtn.setEnabled(this._isVisible && e && t && this._state.canNavigateForward()), this._replaceBtn.setEnabled(this._isVisible && this._isReplaceVisible && e), this._replaceAllBtn.setEnabled(this._isVisible && this._isReplaceVisible && e), this._domNode.classList.toggle("replaceToggled", this._isReplaceVisible), this._toggleReplaceBtn.setExpanded(this._isReplaceVisible);
    const i = !this._codeEditor.getOption(91);
    this._toggleReplaceBtn.setEnabled(this._isVisible && i);
  }
  _reveal() {
    if (this._revealTimeouts.forEach(((e) => {
      clearTimeout(e);
    })), this._revealTimeouts = [], !this._isVisible) {
      this._isVisible = !0;
      const e = this._codeEditor.getSelection();
      switch (this._codeEditor.getOption(41).autoFindInSelection) {
        case "always":
          this._toggleSelectionFind.checked = !0;
          break;
        case "never":
          this._toggleSelectionFind.checked = !1;
          break;
        case "multiline": {
          const i = !!e && e.startLineNumber !== e.endLineNumber;
          this._toggleSelectionFind.checked = i;
          break;
        }
      }
      this._tryUpdateWidgetWidth(), this._updateButtons(), this._revealTimeouts.push(setTimeout((() => {
        this._domNode.classList.add("visible"), this._domNode.setAttribute("aria-hidden", "false");
      }), 0)), this._revealTimeouts.push(setTimeout((() => {
        this._findInput.validate();
      }), 200)), this._codeEditor.layoutOverlayWidget(this);
      let t = !0;
      if (this._codeEditor.getOption(41).seedSearchStringFromSelection && e) {
        const i = this._codeEditor.getDomNode();
        if (i) {
          const s = Ti(i), o = this._codeEditor.getScrolledVisiblePosition(e.getStartPosition()), r = s.left + (o ? o.left : 0), a = o ? o.top : 0;
          if (this._viewZone && a < this._viewZone.heightInPx) {
            e.endLineNumber > e.startLineNumber && (t = !1);
            const l = _8(this._domNode).left;
            r > l && (t = !1);
            const d = this._codeEditor.getScrolledVisiblePosition(e.getEndPosition());
            s.left + (d ? d.left : 0) > l && (t = !1);
          }
        }
      }
      this._showViewZone(t);
    }
  }
  _hide(e) {
    this._revealTimeouts.forEach(((t) => {
      clearTimeout(t);
    })), this._revealTimeouts = [], this._isVisible && (this._isVisible = !1, this._updateButtons(), this._domNode.classList.remove("visible"), this._domNode.setAttribute("aria-hidden", "true"), this._findInput.clearMessage(), e && this._codeEditor.focus(), this._codeEditor.layoutOverlayWidget(this), this._removeViewZone());
  }
  _layoutViewZone(e) {
    if (!this._codeEditor.getOption(41).addExtraSpaceOnTop) return void this._removeViewZone();
    if (!this._isVisible) return;
    const t = this._viewZone;
    this._viewZoneId === void 0 && t && this._codeEditor.changeViewZones(((i) => {
      t.heightInPx = this._getHeight(), this._viewZoneId = i.addZone(t), this._codeEditor.setScrollTop(e || this._codeEditor.getScrollTop() + t.heightInPx);
    }));
  }
  _showViewZone(e = !0) {
    if (!this._isVisible || !this._codeEditor.getOption(41).addExtraSpaceOnTop) return;
    this._viewZone === void 0 && (this._viewZone = new Bx(0));
    const t = this._viewZone;
    this._codeEditor.changeViewZones(((i) => {
      if (this._viewZoneId !== void 0) {
        const s = this._getHeight();
        if (s === t.heightInPx) return;
        const o = s - t.heightInPx;
        return t.heightInPx = s, i.layoutZone(this._viewZoneId), void (e && this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() + o));
      }
      {
        let s = this._getHeight();
        if (s -= this._codeEditor.getOption(84).top, s <= 0) return;
        t.heightInPx = s, this._viewZoneId = i.addZone(t), e && this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() + s);
      }
    }));
  }
  _removeViewZone() {
    this._codeEditor.changeViewZones(((e) => {
      this._viewZoneId !== void 0 && (e.removeZone(this._viewZoneId), this._viewZoneId = void 0, this._viewZone && (this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() - this._viewZone.heightInPx), this._viewZone = void 0));
    }));
  }
  _tryUpdateWidgetWidth() {
    if (!this._isVisible || !this._domNode.isConnected) return;
    const e = this._codeEditor.getLayoutInfo();
    if (e.contentWidth <= 0) return void this._domNode.classList.add("hiddenEditor");
    this._domNode.classList.contains("hiddenEditor") && this._domNode.classList.remove("hiddenEditor");
    const t = e.width, i = e.minimap.minimapWidth;
    let s = !1, o = !1, r = !1;
    if (this._resized && os(this._domNode) > np)
      return this._domNode.style.maxWidth = t - 28 - i - 15 + "px", void (this._replaceInput.width = os(this._findInput.domNode));
    if (447 + i >= t && (o = !0), 447 + i - e_ >= t && (r = !0), 447 + i - e_ >= t + 50 && (s = !0), this._domNode.classList.toggle("collapsed-find-widget", s), this._domNode.classList.toggle("narrow-find-widget", r), this._domNode.classList.toggle("reduced-find-widget", o), r || s || (this._domNode.style.maxWidth = t - 28 - i - 15 + "px"), this._findInput.layout({ collapsedFindWidget: s, narrowFindWidget: r, reducedFindWidget: o }), this._resized) {
      const a = this._findInput.inputBox.element.clientWidth;
      a > 0 && (this._replaceInput.width = a);
    } else this._isReplaceVisible && (this._replaceInput.width = os(this._findInput.domNode));
  }
  _getHeight() {
    let e = 0;
    return e += 4, e += this._findInput.inputBox.height + 2, this._isReplaceVisible && (e += 4, e += this._replaceInput.inputBox.height + 2), e += 4, e;
  }
  _tryUpdateHeight() {
    const e = this._getHeight();
    return (this._cachedHeight === null || this._cachedHeight !== e) && (this._cachedHeight = e, this._domNode.style.height = `${e}px`, !0);
  }
  focusFindInput() {
    this._findInput.select(), this._findInput.focus();
  }
  focusReplaceInput() {
    this._replaceInput.select(), this._replaceInput.focus();
  }
  highlightFindOptions() {
    this._findInput.highlightFindOptions();
  }
  _updateSearchScope() {
    if (this._codeEditor.hasModel() && this._toggleSelectionFind.checked) {
      const e = this._codeEditor.getSelections();
      e.map(((t) => {
        t.endColumn === 1 && t.endLineNumber > t.startLineNumber && (t = t.setEndPosition(t.endLineNumber - 1, this._codeEditor.getModel().getLineMaxColumn(t.endLineNumber - 1)));
        const i = this._state.currentMatch;
        return t.startLineNumber === t.endLineNumber || D.equalsRange(t, i) ? null : t;
      })).filter(((t) => !!t)), e.length && this._state.change({ searchScope: e }, !0);
    }
  }
  _onFindInputMouseDown(e) {
    e.middleButton && e.stopPropagation();
  }
  _onFindInputKeyDown(e) {
    return e.equals(3 | q6) ? (this._keybindingService.dispatchEvent(e, e.target) || this._findInput.inputBox.insertAtCursor(`
`), void e.preventDefault()) : e.equals(2) ? (this._isReplaceVisible ? this._replaceInput.focus() : this._findInput.focusOnCaseSensitive(), void e.preventDefault()) : e.equals(2066) ? (this._codeEditor.focus(), void e.preventDefault()) : e.equals(16) ? $6(e, this._findInput.getValue(), this._findInput.domNode.querySelector("textarea")) : e.equals(18) ? G6(e, this._findInput.getValue(), this._findInput.domNode.querySelector("textarea")) : void 0;
  }
  _onReplaceInputKeyDown(e) {
    return e.equals(3 | q6) ? (this._keybindingService.dispatchEvent(e, e.target) || (Tn && ml && !this._ctrlEnterReplaceAllWarningPrompted && (this._notificationService.info(m(0, "Ctrl+Enter now inserts line break instead of replacing all. You can modify the keybinding for editor.action.replaceAll to override this behavior.")), this._ctrlEnterReplaceAllWarningPrompted = !0, this._storageService.store(j6, !0, 0, 0)), this._replaceInput.inputBox.insertAtCursor(`
`)), void e.preventDefault()) : e.equals(2) ? (this._findInput.focusOnCaseSensitive(), void e.preventDefault()) : e.equals(1026) ? (this._findInput.focus(), void e.preventDefault()) : e.equals(2066) ? (this._codeEditor.focus(), void e.preventDefault()) : e.equals(16) ? $6(e, this._replaceInput.inputBox.value, this._replaceInput.inputBox.element.querySelector("textarea")) : e.equals(18) ? G6(e, this._replaceInput.inputBox.value, this._replaceInput.inputBox.element.querySelector("textarea")) : void 0;
  }
  getVerticalSashLeft(e) {
    return 0;
  }
  _keybindingLabelFor(e) {
    const t = this._keybindingService.lookupKeybinding(e);
    return t ? ` (${t.getLabel()})` : "";
  }
  _buildDomNode() {
    this._findInput = this._register(new KM(null, this._contextViewProvider, { width: 221, label: tle, placeholder: ile, appendCaseSensitiveLabel: this._keybindingLabelFor(SP), appendWholeWordsLabel: this._keybindingLabelFor(LP), appendRegexLabel: this._keybindingLabelFor(kP), validation: (h) => {
      if (h.length === 0 || !this._findInput.getRegex()) return null;
      try {
        return new RegExp(h, "gu"), null;
      } catch (c) {
        return { content: c.message };
      }
    }, flexibleHeight: !0, flexibleWidth: !0, flexibleMaxHeight: 118, showCommonFindToggles: !0, showHistoryHint: () => H6(this._keybindingService), inputBoxStyles: Oy, toggleStyles: Py }, this._contextKeyService)), this._findInput.setRegex(!!this._state.isRegex), this._findInput.setCaseSensitive(!!this._state.matchCase), this._findInput.setWholeWords(!!this._state.wholeWord), this._register(this._findInput.onKeyDown(((h) => this._onFindInputKeyDown(h)))), this._register(this._findInput.inputBox.onDidChange((() => {
      this._ignoreChangeEvent || this._state.change({ searchString: this._findInput.getValue() }, !0);
    }))), this._register(this._findInput.onDidOptionChange((() => {
      this._state.change({ isRegex: this._findInput.getRegex(), wholeWord: this._findInput.getWholeWords(), matchCase: this._findInput.getCaseSensitive() }, !0);
    }))), this._register(this._findInput.onCaseSensitiveKeyDown(((h) => {
      h.equals(1026) && this._isReplaceVisible && (this._replaceInput.focus(), h.preventDefault());
    }))), this._register(this._findInput.onRegexKeyDown(((h) => {
      h.equals(2) && this._isReplaceVisible && (this._replaceInput.focusOnPreserve(), h.preventDefault());
    }))), this._register(this._findInput.inputBox.onDidHeightChange(((h) => {
      this._tryUpdateHeight() && this._showViewZone();
    }))), Cs && this._register(this._findInput.onMouseDown(((h) => this._onFindInputMouseDown(h)))), this._matchesCount = document.createElement("div"), this._matchesCount.className = "matchesCount", this._updateMatchesCount();
    const i = this._register(Zm());
    this._prevBtn = this._register(new sp({ label: nle + this._keybindingLabelFor(WM), icon: Qae, hoverDelegate: i, onTrigger: () => {
      Dh(this._codeEditor.getAction(WM)).run().then(void 0, We);
    } })), this._nextBtn = this._register(new sp({ label: sle + this._keybindingLabelFor(BM), icon: Jae, hoverDelegate: i, onTrigger: () => {
      Dh(this._codeEditor.getAction(BM)).run().then(void 0, We);
    } }));
    const s = document.createElement("div");
    s.className = "find-part", s.appendChild(this._findInput.domNode);
    const o = document.createElement("div");
    o.className = "find-actions", s.appendChild(o), o.appendChild(this._matchesCount), o.appendChild(this._prevBtn.domNode), o.appendChild(this._nextBtn.domNode), this._toggleSelectionFind = this._register(new bf({ icon: Zae, title: ole + this._keybindingLabelFor(Oz), isChecked: !1, hoverDelegate: i, inputActiveOptionBackground: de(Eu), inputActiveOptionBorder: de(OR), inputActiveOptionForeground: de(FR) })), this._register(this._toggleSelectionFind.onChange((() => {
      if (this._toggleSelectionFind.checked) {
        if (this._codeEditor.hasModel()) {
          let h = this._codeEditor.getSelections();
          h = h.map(((c) => (c.endColumn === 1 && c.endLineNumber > c.startLineNumber && (c = c.setEndPosition(c.endLineNumber - 1, this._codeEditor.getModel().getLineMaxColumn(c.endLineNumber - 1))), c.isEmpty() ? null : c))).filter(((c) => !!c)), h.length && this._state.change({ searchScope: h }, !0);
        }
      } else this._state.change({ searchScope: null }, !0);
    }))), o.appendChild(this._toggleSelectionFind.domNode), this._closeBtn = this._register(new sp({ label: rle + this._keybindingLabelFor(Pz), icon: TV, hoverDelegate: i, onTrigger: () => {
      this._state.change({ isRevealed: !1, searchScope: null }, !1);
    }, onKeyDown: (h) => {
      h.equals(2) && this._isReplaceVisible && (this._replaceBtn.isEnabled() ? this._replaceBtn.focus() : this._codeEditor.focus(), h.preventDefault());
    } })), this._replaceInput = this._register(new jM(null, void 0, { label: ale, placeholder: lle, appendPreserveCaseLabel: this._keybindingLabelFor(Fz), history: [], flexibleHeight: !0, flexibleWidth: !0, flexibleMaxHeight: 118, showHistoryHint: () => H6(this._keybindingService), inputBoxStyles: Oy, toggleStyles: Py }, this._contextKeyService, !0)), this._replaceInput.setPreserveCase(!!this._state.preserveCase), this._register(this._replaceInput.onKeyDown(((h) => this._onReplaceInputKeyDown(h)))), this._register(this._replaceInput.inputBox.onDidChange((() => {
      this._state.change({ replaceString: this._replaceInput.inputBox.value }, !1);
    }))), this._register(this._replaceInput.inputBox.onDidHeightChange(((h) => {
      this._isReplaceVisible && this._tryUpdateHeight() && this._showViewZone();
    }))), this._register(this._replaceInput.onDidOptionChange((() => {
      this._state.change({ preserveCase: this._replaceInput.getPreserveCase() }, !0);
    }))), this._register(this._replaceInput.onPreserveCaseKeyDown(((h) => {
      h.equals(2) && (this._prevBtn.isEnabled() ? this._prevBtn.focus() : this._nextBtn.isEnabled() ? this._nextBtn.focus() : this._toggleSelectionFind.enabled ? this._toggleSelectionFind.focus() : this._closeBtn.isEnabled() && this._closeBtn.focus(), h.preventDefault());
    })));
    const r = this._register(Zm());
    this._replaceBtn = this._register(new sp({ label: dle + this._keybindingLabelFor(VM), icon: Yae, hoverDelegate: r, onTrigger: () => {
      this._controller.replace();
    }, onKeyDown: (h) => {
      h.equals(1026) && (this._closeBtn.focus(), h.preventDefault());
    } })), this._replaceAllBtn = this._register(new sp({ label: hle + this._keybindingLabelFor(HM), icon: Xae, hoverDelegate: r, onTrigger: () => {
      this._controller.replaceAll();
    } }));
    const a = document.createElement("div");
    a.className = "replace-part", a.appendChild(this._replaceInput.domNode);
    const l = document.createElement("div");
    l.className = "replace-actions", a.appendChild(l), l.appendChild(this._replaceBtn.domNode), l.appendChild(this._replaceAllBtn.domNode), this._toggleReplaceBtn = this._register(new sp({ label: cle, className: "codicon toggle left", onTrigger: () => {
      this._state.change({ isReplaceRevealed: !this._isReplaceVisible }, !1), this._isReplaceVisible && (this._replaceInput.width = os(this._findInput.domNode), this._replaceInput.inputBox.layout()), this._showViewZone();
    } })), this._toggleReplaceBtn.setExpanded(this._isReplaceVisible), this._domNode = document.createElement("div"), this._domNode.className = "editor-widget find-widget", this._domNode.setAttribute("aria-hidden", "true"), this._domNode.ariaLabel = ele, this._domNode.role = "dialog", this._domNode.style.width = "419px", this._domNode.appendChild(this._toggleReplaceBtn.domNode), this._domNode.appendChild(s), this._domNode.appendChild(this._closeBtn.domNode), this._domNode.appendChild(a), this._resizeSash = this._register(new Bn(this._domNode, this, { orientation: 0, size: 2 })), this._resized = !1;
    let d = np;
    this._register(this._resizeSash.onDidStart((() => {
      d = os(this._domNode);
    }))), this._register(this._resizeSash.onDidChange(((h) => {
      this._resized = !0;
      const c = d + h.startX - h.currentX;
      c < np || c > (parseFloat(VS(this._domNode).maxWidth) || 0) || (this._domNode.style.width = `${c}px`, this._isReplaceVisible && (this._replaceInput.width = os(this._findInput.domNode)), this._findInput.inputBox.layout(), this._tryUpdateHeight());
    }))), this._register(this._resizeSash.onDidReset((() => {
      const h = os(this._domNode);
      if (h < np) return;
      let c = np;
      if (!this._resized || h === np) {
        const u = this._codeEditor.getLayoutInfo();
        c = u.width - 28 - u.minimap.minimapWidth - 15, this._resized = !0;
      }
      this._domNode.style.width = `${c}px`, this._isReplaceVisible && (this._replaceInput.width = os(this._findInput.domNode)), this._findInput.inputBox.layout();
    })));
  }
  updateAccessibilitySupport() {
    const e = this._codeEditor.getOption(2);
    this._findInput.setFocusInputOnOptionClick(e !== 2);
  }
}
sk.ID = "editor.contrib.findWidget";
class sp extends To {
  constructor(e) {
    var t;
    super(), this._opts = e;
    let i = "button";
    this._opts.className && (i = i + " " + this._opts.className), this._opts.icon && (i = i + " " + Ee.asClassName(this._opts.icon)), this._domNode = document.createElement("div"), this._domNode.tabIndex = 0, this._domNode.className = i, this._domNode.setAttribute("role", "button"), this._domNode.setAttribute("aria-label", this._opts.label), this._register(xr((t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("element"), this._domNode, this._opts.label)), this.onclick(this._domNode, ((s) => {
      this._opts.onTrigger(), s.preventDefault();
    })), this.onkeydown(this._domNode, ((s) => {
      var o, r;
      if (s.equals(10) || s.equals(3)) return this._opts.onTrigger(), void s.preventDefault();
      (r = (o = this._opts).onKeyDown) === null || r === void 0 || r.call(o, s);
    }));
  }
  get domNode() {
    return this._domNode;
  }
  isEnabled() {
    return this._domNode.tabIndex >= 0;
  }
  focus() {
    this._domNode.focus();
  }
  setEnabled(e) {
    this._domNode.classList.toggle("disabled", !e), this._domNode.setAttribute("aria-disabled", String(!e)), this._domNode.tabIndex = e ? 0 : -1;
  }
  setExpanded(e) {
    this._domNode.setAttribute("aria-expanded", String(!!e)), e ? (this._domNode.classList.remove(...Ee.asClassNameArray(z6)), this._domNode.classList.add(...Ee.asClassNameArray(U6))) : (this._domNode.classList.remove(...Ee.asClassNameArray(U6)), this._domNode.classList.add(...Ee.asClassNameArray(z6)));
  }
}
rr(((n, e) => {
  const t = n.getColor(Th);
  t && e.addRule(`.monaco-editor .findMatch { border: 1px ${aa(n.type) ? "dotted" : "solid"} ${t}; box-sizing: border-box; }`);
  const i = n.getColor(_$);
  i && e.addRule(`.monaco-editor .findScope { border: 1px ${aa(n.type) ? "dashed" : "solid"} ${i}; }`);
  const s = n.getColor(ot);
  s && e.addRule(`.monaco-editor .find-widget { border: 1px solid ${s}; }`);
}));
var qM, Uz = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, qr = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
function $M(n, e = "single", t = !1) {
  if (!n.hasModel()) return null;
  const i = n.getSelection();
  if (e === "single" && i.startLineNumber === i.endLineNumber || e === "multiple") {
    if (i.isEmpty()) {
      const s = n.getConfiguredWordAtPosition(i.getStartPosition());
      if (s && t === !1) return s.word;
    } else if (n.getModel().getValueLengthInRange(i) < 524288) return n.getModel().getValueInRange(i);
  }
  return null;
}
let gs = qM = class extends V {
  get editor() {
    return this._editor;
  }
  static get(n) {
    return n.getContribution(qM.ID);
  }
  constructor(n, e, t, i, s) {
    super(), this._editor = n, this._findWidgetVisible = Gl.bindTo(e), this._contextKeyService = e, this._storageService = t, this._clipboardService = i, this._notificationService = s, this._updateHistoryDelayer = new Sr(500), this._state = this._register(new Kae()), this.loadQueryState(), this._register(this._state.onFindReplaceStateChange(((o) => this._onStateChanged(o)))), this._model = null, this._register(this._editor.onDidChangeModel((() => {
      const o = this._editor.getModel() && this._state.isRevealed;
      this.disposeModel(), this._state.change({ searchScope: null, matchCase: this._storageService.getBoolean("editor.matchCase", 1, !1), wholeWord: this._storageService.getBoolean("editor.wholeWord", 1, !1), isRegex: this._storageService.getBoolean("editor.isRegex", 1, !1), preserveCase: this._storageService.getBoolean("editor.preserveCase", 1, !1) }, !1), o && this._start({ forceRevealReplace: !1, seedSearchStringFromSelection: "none", seedSearchStringFromNonEmptySelection: !1, seedSearchStringFromGlobalClipboard: !1, shouldFocus: 0, shouldAnimate: !1, updateSearchScope: !1, loop: this._editor.getOption(41).loop });
    })));
  }
  dispose() {
    this.disposeModel(), super.dispose();
  }
  disposeModel() {
    this._model && (this._model.dispose(), this._model = null);
  }
  _onStateChanged(n) {
    this.saveQueryState(n), n.isRevealed && (this._state.isRevealed ? this._findWidgetVisible.set(!0) : (this._findWidgetVisible.reset(), this.disposeModel())), n.searchString && this.setGlobalBufferTerm(this._state.searchString);
  }
  saveQueryState(n) {
    n.isRegex && this._storageService.store("editor.isRegex", this._state.actualIsRegex, 1, 1), n.wholeWord && this._storageService.store("editor.wholeWord", this._state.actualWholeWord, 1, 1), n.matchCase && this._storageService.store("editor.matchCase", this._state.actualMatchCase, 1, 1), n.preserveCase && this._storageService.store("editor.preserveCase", this._state.actualPreserveCase, 1, 1);
  }
  loadQueryState() {
    this._state.change({ matchCase: this._storageService.getBoolean("editor.matchCase", 1, this._state.matchCase), wholeWord: this._storageService.getBoolean("editor.wholeWord", 1, this._state.wholeWord), isRegex: this._storageService.getBoolean("editor.isRegex", 1, this._state.isRegex), preserveCase: this._storageService.getBoolean("editor.preserveCase", 1, this._state.preserveCase) }, !1);
  }
  isFindInputFocused() {
    return !!vS.getValue(this._contextKeyService);
  }
  getState() {
    return this._state;
  }
  closeFindWidget() {
    this._state.change({ isRevealed: !1, searchScope: null }, !1), this._editor.focus();
  }
  toggleCaseSensitive() {
    this._state.change({ matchCase: !this._state.matchCase }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleWholeWords() {
    this._state.change({ wholeWord: !this._state.wholeWord }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleRegex() {
    this._state.change({ isRegex: !this._state.isRegex }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  togglePreserveCase() {
    this._state.change({ preserveCase: !this._state.preserveCase }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleSearchScope() {
    if (this._state.searchScope) this._state.change({ searchScope: null }, !0);
    else if (this._editor.hasModel()) {
      let n = this._editor.getSelections();
      n = n.map(((e) => (e.endColumn === 1 && e.endLineNumber > e.startLineNumber && (e = e.setEndPosition(e.endLineNumber - 1, this._editor.getModel().getLineMaxColumn(e.endLineNumber - 1))), e.isEmpty() ? null : e))).filter(((e) => !!e)), n.length && this._state.change({ searchScope: n }, !0);
    }
  }
  setSearchString(n) {
    this._state.isRegex && (n = No(n)), this._state.change({ searchString: n }, !1);
  }
  highlightFindOptions(n = !1) {
  }
  async _start(n, e) {
    if (this.disposeModel(), !this._editor.hasModel()) return;
    const t = { ...e, isRevealed: !0 };
    if (n.seedSearchStringFromSelection === "single") {
      const i = $M(this._editor, n.seedSearchStringFromSelection, n.seedSearchStringFromNonEmptySelection);
      i && (this._state.isRegex ? t.searchString = No(i) : t.searchString = i);
    } else if (n.seedSearchStringFromSelection === "multiple" && !n.updateSearchScope) {
      const i = $M(this._editor, n.seedSearchStringFromSelection);
      i && (t.searchString = i);
    }
    if (!t.searchString && n.seedSearchStringFromGlobalClipboard) {
      const i = await this.getGlobalBufferTerm();
      if (!this._editor.hasModel()) return;
      i && (t.searchString = i);
    }
    if (n.forceRevealReplace || t.isReplaceRevealed ? t.isReplaceRevealed = !0 : this._findWidgetVisible.get() || (t.isReplaceRevealed = !1), n.updateSearchScope) {
      const i = this._editor.getSelections();
      i.some(((s) => !s.isEmpty())) && (t.searchScope = i);
    }
    t.loop = n.loop, this._state.change(t, !1), this._model || (this._model = new x0(this._editor, this._state));
  }
  start(n, e) {
    return this._start(n, e);
  }
  moveToNextMatch() {
    return !!this._model && (this._model.moveToNextMatch(), !0);
  }
  moveToPrevMatch() {
    return !!this._model && (this._model.moveToPrevMatch(), !0);
  }
  goToMatch(n) {
    return !!this._model && (this._model.moveToMatch(n), !0);
  }
  replace() {
    return !!this._model && (this._model.replace(), !0);
  }
  replaceAll() {
    var n;
    return !!this._model && (!((n = this._editor.getModel()) === null || n === void 0) && n.isTooLargeForHeapOperation() ? (this._notificationService.warn(m(0, "The file is too large to perform a replace all operation.")), !1) : (this._model.replaceAll(), !0));
  }
  selectAllMatches() {
    return !!this._model && (this._model.selectAllMatches(), this._editor.focus(), !0);
  }
  async getGlobalBufferTerm() {
    return this._editor.getOption(41).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing() ? this._clipboardService.readFindText() : "";
  }
  setGlobalBufferTerm(n) {
    this._editor.getOption(41).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing() && this._clipboardService.writeFindText(n);
  }
};
gs.ID = "editor.contrib.findController", gs = qM = Uz([qr(1, Te), qr(2, Nr), qr(3, Kd), qr(4, Ri)], gs);
let GM = class extends gs {
  constructor(n, e, t, i, s, o, r, a) {
    super(n, t, r, a, o), this._contextViewService = e, this._keybindingService = i, this._themeService = s, this._widget = null, this._findOptionsWidget = null;
  }
  async _start(n, e) {
    this._widget || this._createFindWidget();
    const t = this._editor.getSelection();
    let i = !1;
    switch (this._editor.getOption(41).autoFindInSelection) {
      case "always":
        i = !0;
        break;
      case "never":
        i = !1;
        break;
      case "multiline":
        i = !!t && t.startLineNumber !== t.endLineNumber;
        break;
    }
    n.updateSearchScope = n.updateSearchScope || i, await super._start(n, e), this._widget && (n.shouldFocus === 2 ? this._widget.focusReplaceInput() : n.shouldFocus === 1 && this._widget.focusFindInput());
  }
  highlightFindOptions(n = !1) {
    this._widget || this._createFindWidget(), this._state.isRevealed && !n ? this._widget.highlightFindOptions() : this._findOptionsWidget.highlightFindOptions();
  }
  _createFindWidget() {
    this._widget = this._register(new sk(this._editor, this, this._state, this._contextViewService, this._keybindingService, this._contextKeyService, this._themeService, this._storageService, this._notificationService)), this._findOptionsWidget = this._register(new nk(this._editor, this._state, this._keybindingService));
  }
};
GM = Uz([qr(1, zd), qr(2, Te), qr(3, Dt), qr(4, Yi), qr(5, Ri), qr(6, Nr), qr(7, Kd)], GM);
A8(new R8({ id: Oae, label: m(0, "Find"), alias: "Find", precondition: q.or(E.focus, q.has("editorIsOpen")), kbOpts: { kbExpr: null, primary: 2084, weight: 100 }, menuOpts: { menuId: x.MenubarEditMenu, group: "3_find", title: m(0, "&&Find"), order: 1 } })).addImplementation(0, ((n, e, t) => {
  const i = gs.get(e);
  return !!i && i.start({ forceRevealReplace: !1, seedSearchStringFromSelection: e.getOption(41).seedSearchStringFromSelection !== "never" ? "single" : "none", seedSearchStringFromNonEmptySelection: e.getOption(41).seedSearchStringFromSelection === "selection", seedSearchStringFromGlobalClipboard: e.getOption(41).globalFindClipboard, shouldFocus: 1, shouldAnimate: !0, updateSearchScope: !1, loop: e.getOption(41).loop });
}));
const ple = { description: "Open a new In-Editor Find Widget.", args: [{ name: "Open a new In-Editor Find Widget args", schema: { properties: { searchString: { type: "string" }, replaceString: { type: "string" }, isRegex: { type: "boolean" }, matchWholeWord: { type: "boolean" }, isCaseSensitive: { type: "boolean" }, preserveCase: { type: "boolean" }, findInSelection: { type: "boolean" } } } }] };
class Z6 extends he {
  async run(e, t) {
    const i = gs.get(t);
    i && !this._run(i) && (await i.start({ forceRevealReplace: !1, seedSearchStringFromSelection: i.getState().searchString.length === 0 && t.getOption(41).seedSearchStringFromSelection !== "never" ? "single" : "none", seedSearchStringFromNonEmptySelection: t.getOption(41).seedSearchStringFromSelection === "selection", seedSearchStringFromGlobalClipboard: !0, shouldFocus: 0, shouldAnimate: !0, updateSearchScope: !1, loop: t.getOption(41).loop }), this._run(i));
  }
}
class Y6 extends he {
  async run(e, t) {
    const i = gs.get(t);
    if (!i) return;
    const s = $M(t, "single", !1);
    s && i.setSearchString(s), this._run(i) || (await i.start({ forceRevealReplace: !1, seedSearchStringFromSelection: "none", seedSearchStringFromNonEmptySelection: !1, seedSearchStringFromGlobalClipboard: !1, shouldFocus: 0, shouldAnimate: !0, updateSearchScope: !1, loop: t.getOption(41).loop }), this._run(i));
  }
}
A8(new R8({ id: zae, label: m(0, "Replace"), alias: "Replace", precondition: q.or(E.focus, q.has("editorIsOpen")), kbOpts: { kbExpr: null, primary: 2086, mac: { primary: 2596 }, weight: 100 }, menuOpts: { menuId: x.MenubarEditMenu, group: "3_find", title: m(0, "&&Replace"), order: 2 } })).addImplementation(0, ((n, e, t) => {
  if (!e.hasModel() || e.getOption(91)) return !1;
  const i = gs.get(e);
  if (!i) return !1;
  const s = e.getSelection(), o = i.isFindInputFocused(), r = !s.isEmpty() && s.startLineNumber === s.endLineNumber && e.getOption(41).seedSearchStringFromSelection !== "never" && !o, a = o || r ? 2 : 1;
  return i.start({ forceRevealReplace: !0, seedSearchStringFromSelection: r ? "single" : "none", seedSearchStringFromNonEmptySelection: e.getOption(41).seedSearchStringFromSelection === "selection", seedSearchStringFromGlobalClipboard: e.getOption(41).seedSearchStringFromSelection !== "never", shouldFocus: a, shouldAnimate: !0, updateSearchScope: !1, loop: e.getOption(41).loop });
})), ft(gs.ID, GM, 0), X(class extends he {
  constructor() {
    super({ id: Bae, label: m(0, "Find With Arguments"), alias: "Find With Arguments", precondition: void 0, kbOpts: { kbExpr: null, primary: 0, weight: 100 }, metadata: ple });
  }
  async run(n, e, t) {
    const i = gs.get(e);
    if (i) {
      const s = t ? { searchString: t.searchString, replaceString: t.replaceString, isReplaceRevealed: t.replaceString !== void 0, isRegex: t.isRegex, wholeWord: t.matchWholeWord, matchCase: t.isCaseSensitive, preserveCase: t.preserveCase } : {};
      await i.start({ forceRevealReplace: !1, seedSearchStringFromSelection: i.getState().searchString.length === 0 && e.getOption(41).seedSearchStringFromSelection !== "never" ? "single" : "none", seedSearchStringFromNonEmptySelection: e.getOption(41).seedSearchStringFromSelection === "selection", seedSearchStringFromGlobalClipboard: !0, shouldFocus: 1, shouldAnimate: !0, updateSearchScope: t?.findInSelection || !1, loop: e.getOption(41).loop }, s), i.setGlobalBufferTerm(i.getState().searchString);
    }
  }
}), X(class extends he {
  constructor() {
    super({ id: Fae, label: m(0, "Find With Selection"), alias: "Find With Selection", precondition: void 0, kbOpts: { kbExpr: null, primary: 0, mac: { primary: 2083 }, weight: 100 } });
  }
  async run(n, e) {
    const t = gs.get(e);
    t && (await t.start({ forceRevealReplace: !1, seedSearchStringFromSelection: "multiple", seedSearchStringFromNonEmptySelection: !1, seedSearchStringFromGlobalClipboard: !1, shouldFocus: 0, shouldAnimate: !0, updateSearchScope: !1, loop: e.getOption(41).loop }), t.setGlobalBufferTerm(t.getState().searchString));
  }
}), X(class extends Z6 {
  constructor() {
    super({ id: BM, label: m(0, "Find Next"), alias: "Find Next", precondition: void 0, kbOpts: [{ kbExpr: E.focus, primary: 61, mac: { primary: 2085, secondary: [61] }, weight: 100 }, { kbExpr: q.and(E.focus, vS), primary: 3, weight: 100 }] });
  }
  _run(n) {
    return !!n.moveToNextMatch() && (n.editor.pushUndoStop(), !0);
  }
}), X(class extends Z6 {
  constructor() {
    super({ id: WM, label: m(0, "Find Previous"), alias: "Find Previous", precondition: void 0, kbOpts: [{ kbExpr: E.focus, primary: 1085, mac: { primary: 3109, secondary: [1085] }, weight: 100 }, { kbExpr: q.and(E.focus, vS), primary: 1027, weight: 100 }] });
  }
  _run(n) {
    return n.moveToPrevMatch();
  }
}), X(class extends he {
  constructor() {
    super({ id: Wae, label: m(0, "Go to Match..."), alias: "Go to Match...", precondition: Gl }), this._highlightDecorations = [];
  }
  run(n, e, t) {
    const i = gs.get(e);
    if (!i) return;
    const s = i.getState().matchesCount;
    if (s < 1)
      return void n.get(Ri).notify({ severity: pL.Warning, message: m(0, "No matches. Try searching for something else.") });
    const o = n.get(Sa).createInputBox();
    o.placeholder = m(0, "Type a number to go to a specific match (between 1 and {0})", s);
    const r = (l) => {
      const d = parseInt(l);
      if (isNaN(d)) return;
      const h = i.getState().matchesCount;
      return d > 0 && d <= h ? d - 1 : d < 0 && d >= -h ? h + d : void 0;
    }, a = (l) => {
      const d = r(l);
      if (typeof d == "number") {
        o.validationMessage = void 0, i.goToMatch(d);
        const h = i.getState().currentMatch;
        h && this.addDecorations(e, h);
      } else o.validationMessage = m(0, "Please type a number between 1 and {0}", i.getState().matchesCount), this.clearDecorations(e);
    };
    o.onDidChangeValue(((l) => {
      a(l);
    })), o.onDidAccept((() => {
      const l = r(o.value);
      typeof l == "number" ? (i.goToMatch(l), o.hide()) : o.validationMessage = m(0, "Please type a number between 1 and {0}", i.getState().matchesCount);
    })), o.onDidHide((() => {
      this.clearDecorations(e), o.dispose();
    })), o.show();
  }
  clearDecorations(n) {
    n.changeDecorations(((e) => {
      this._highlightDecorations = e.deltaDecorations(this._highlightDecorations, []);
    }));
  }
  addDecorations(n, e) {
    n.changeDecorations(((t) => {
      this._highlightDecorations = t.deltaDecorations(this._highlightDecorations, [{ range: e, options: { description: "find-match-quick-access-range-highlight", className: "rangeHighlight", isWholeLine: !0 } }, { range: e, options: { description: "find-match-quick-access-range-highlight-overview", overviewRuler: { color: ui(EB), position: Do.Full } } }]);
    }));
  }
}), X(class extends Y6 {
  constructor() {
    super({ id: Vae, label: m(0, "Find Next Selection"), alias: "Find Next Selection", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 2109, weight: 100 } });
  }
  _run(n) {
    return n.moveToNextMatch();
  }
}), X(class extends Y6 {
  constructor() {
    super({ id: Hae, label: m(0, "Find Previous Selection"), alias: "Find Previous Selection", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 3133, weight: 100 } });
  }
  _run(n) {
    return n.moveToPrevMatch();
  }
});
const Ar = Zi.bindToContribution(gs.get);
re(new Ar({ id: Pz, precondition: Gl, handler: (n) => n.closeFindWidget(), kbOpts: { weight: 105, kbExpr: q.and(E.focus, q.not("isComposing")), primary: 9, secondary: [1033] } })), re(new Ar({ id: SP, precondition: void 0, handler: (n) => n.toggleCaseSensitive(), kbOpts: { weight: 105, kbExpr: E.focus, primary: iC.primary, mac: iC.mac, win: iC.win, linux: iC.linux } })), re(new Ar({ id: LP, precondition: void 0, handler: (n) => n.toggleWholeWords(), kbOpts: { weight: 105, kbExpr: E.focus, primary: nC.primary, mac: nC.mac, win: nC.win, linux: nC.linux } })), re(new Ar({ id: kP, precondition: void 0, handler: (n) => n.toggleRegex(), kbOpts: { weight: 105, kbExpr: E.focus, primary: sC.primary, mac: sC.mac, win: sC.win, linux: sC.linux } })), re(new Ar({ id: Oz, precondition: void 0, handler: (n) => n.toggleSearchScope(), kbOpts: { weight: 105, kbExpr: E.focus, primary: oC.primary, mac: oC.mac, win: oC.win, linux: oC.linux } })), re(new Ar({ id: Fz, precondition: void 0, handler: (n) => n.togglePreserveCase(), kbOpts: { weight: 105, kbExpr: E.focus, primary: rC.primary, mac: rC.mac, win: rC.win, linux: rC.linux } })), re(new Ar({ id: VM, precondition: Gl, handler: (n) => n.replace(), kbOpts: { weight: 105, kbExpr: E.focus, primary: 3094 } })), re(new Ar({ id: VM, precondition: Gl, handler: (n) => n.replace(), kbOpts: { weight: 105, kbExpr: q.and(E.focus, FM), primary: 3 } })), re(new Ar({ id: HM, precondition: Gl, handler: (n) => n.replaceAll(), kbOpts: { weight: 105, kbExpr: E.focus, primary: 2563 } })), re(new Ar({ id: HM, precondition: Gl, handler: (n) => n.replaceAll(), kbOpts: { weight: 105, kbExpr: q.and(E.focus, FM), primary: void 0, mac: { primary: 2051 } } })), re(new Ar({ id: Uae, precondition: Gl, handler: (n) => n.selectAllMatches(), kbOpts: { weight: 105, kbExpr: E.focus, primary: 515 } }));
const mle = { 0: " ", 1: "u", 2: "r" }, $r = 16777215, X6 = 4278190080;
class Wx {
  constructor(e) {
    const t = Math.ceil(e / 32);
    this._states = new Uint32Array(t);
  }
  get(e) {
    const t = e / 32 | 0, i = e % 32;
    return !!(this._states[t] & 1 << i);
  }
  set(e, t) {
    const i = e / 32 | 0, s = e % 32, o = this._states[i];
    this._states[i] = t ? o | 1 << s : o & ~(1 << s);
  }
}
class go {
  constructor(e, t, i) {
    if (e.length !== t.length || e.length > 65535) throw new Error("invalid startIndexes or endIndexes size");
    this._startIndexes = e, this._endIndexes = t, this._collapseStates = new Wx(e.length), this._userDefinedStates = new Wx(e.length), this._recoveredStates = new Wx(e.length), this._types = i, this._parentsComputed = !1;
  }
  ensureParentIndices() {
    if (!this._parentsComputed) {
      this._parentsComputed = !0;
      const e = [], t = (i, s) => {
        const o = e[e.length - 1];
        return this.getStartLineNumber(o) <= i && this.getEndLineNumber(o) >= s;
      };
      for (let i = 0, s = this._startIndexes.length; i < s; i++) {
        const o = this._startIndexes[i], r = this._endIndexes[i];
        if (o > $r || r > $r) throw new Error("startLineNumber or endLineNumber must not exceed " + $r);
        for (; e.length > 0 && !t(o, r); ) e.pop();
        const a = e.length > 0 ? e[e.length - 1] : -1;
        e.push(i), this._startIndexes[i] = o + ((255 & a) << 24), this._endIndexes[i] = r + ((65280 & a) << 16);
      }
    }
  }
  get length() {
    return this._startIndexes.length;
  }
  getStartLineNumber(e) {
    return this._startIndexes[e] & $r;
  }
  getEndLineNumber(e) {
    return this._endIndexes[e] & $r;
  }
  getType(e) {
    return this._types ? this._types[e] : void 0;
  }
  hasTypes() {
    return !!this._types;
  }
  isCollapsed(e) {
    return this._collapseStates.get(e);
  }
  setCollapsed(e, t) {
    this._collapseStates.set(e, t);
  }
  isUserDefined(e) {
    return this._userDefinedStates.get(e);
  }
  setUserDefined(e, t) {
    return this._userDefinedStates.set(e, t);
  }
  isRecovered(e) {
    return this._recoveredStates.get(e);
  }
  setRecovered(e, t) {
    return this._recoveredStates.set(e, t);
  }
  getSource(e) {
    return this.isUserDefined(e) ? 1 : this.isRecovered(e) ? 2 : 0;
  }
  setSource(e, t) {
    t === 1 ? (this.setUserDefined(e, !0), this.setRecovered(e, !1)) : t === 2 ? (this.setUserDefined(e, !1), this.setRecovered(e, !0)) : (this.setUserDefined(e, !1), this.setRecovered(e, !1));
  }
  setCollapsedAllOfType(e, t) {
    let i = !1;
    if (this._types) for (let s = 0; s < this._types.length; s++) this._types[s] === e && (this.setCollapsed(s, t), i = !0);
    return i;
  }
  toRegion(e) {
    return new fle(this, e);
  }
  getParentIndex(e) {
    this.ensureParentIndices();
    const t = ((this._startIndexes[e] & X6) >>> 24) + ((this._endIndexes[e] & X6) >>> 16);
    return t === 65535 ? -1 : t;
  }
  contains(e, t) {
    return this.getStartLineNumber(e) <= t && this.getEndLineNumber(e) >= t;
  }
  findIndex(e) {
    let t = 0, i = this._startIndexes.length;
    if (i === 0) return -1;
    for (; t < i; ) {
      const s = Math.floor((t + i) / 2);
      e < this.getStartLineNumber(s) ? i = s : t = s + 1;
    }
    return t - 1;
  }
  findRange(e) {
    let t = this.findIndex(e);
    if (t >= 0) {
      if (this.getEndLineNumber(t) >= e) return t;
      for (t = this.getParentIndex(t); t !== -1; ) {
        if (this.contains(t, e)) return t;
        t = this.getParentIndex(t);
      }
    }
    return -1;
  }
  toString() {
    const e = [];
    for (let t = 0; t < this.length; t++) e[t] = `[${mle[this.getSource(t)]}${this.isCollapsed(t) ? "+" : "-"}] ${this.getStartLineNumber(t)}/${this.getEndLineNumber(t)}`;
    return e.join(", ");
  }
  toFoldRange(e) {
    return { startLineNumber: this._startIndexes[e] & $r, endLineNumber: this._endIndexes[e] & $r, type: this._types ? this._types[e] : void 0, isCollapsed: this.isCollapsed(e), source: this.getSource(e) };
  }
  static fromFoldRanges(e) {
    const t = e.length, i = new Uint32Array(t), s = new Uint32Array(t);
    let o = [], r = !1;
    for (let l = 0; l < t; l++) {
      const d = e[l];
      i[l] = d.startLineNumber, s[l] = d.endLineNumber, o.push(d.type), d.type && (r = !0);
    }
    r || (o = void 0);
    const a = new go(i, s, o);
    for (let l = 0; l < t; l++) e[l].isCollapsed && a.setCollapsed(l, !0), a.setSource(l, e[l].source);
    return a;
  }
  static sanitizeAndMerge(e, t, i) {
    i = i ?? Number.MAX_VALUE;
    const s = (f, _) => Array.isArray(f) ? (v) => v < _ ? f[v] : void 0 : (v) => v < _ ? f.toFoldRange(v) : void 0, o = s(e, e.length), r = s(t, t.length);
    let a = 0, l = 0, d = o(0), h = r(0);
    const c = [];
    let u, g = 0;
    const p = [];
    for (; d || h; ) {
      let f;
      if (h && (!d || d.startLineNumber >= h.startLineNumber)) d && d.startLineNumber === h.startLineNumber ? (h.source === 1 ? f = h : (f = d, f.isCollapsed = h.isCollapsed && d.endLineNumber === h.endLineNumber, f.source = 0), d = o(++a)) : (f = h, h.isCollapsed && h.source === 0 && (f.source = 2)), h = r(++l);
      else {
        let _ = l, v = h;
        for (; ; ) {
          if (!v || v.startLineNumber > d.endLineNumber) {
            f = d;
            break;
          }
          if (v.source === 1 && v.endLineNumber > d.endLineNumber) break;
          v = r(++_);
        }
        d = o(++a);
      }
      if (f) {
        for (; u && u.endLineNumber < f.startLineNumber; ) u = c.pop();
        f.endLineNumber > f.startLineNumber && f.startLineNumber > g && f.endLineNumber <= i && (!u || u.endLineNumber >= f.endLineNumber) && (p.push(f), g = f.startLineNumber, u && c.push(u), u = f);
      }
    }
    return p;
  }
}
class fle {
  constructor(e, t) {
    this.ranges = e, this.index = t;
  }
  get startLineNumber() {
    return this.ranges.getStartLineNumber(this.index);
  }
  get endLineNumber() {
    return this.ranges.getEndLineNumber(this.index);
  }
  get regionIndex() {
    return this.index;
  }
  get parentIndex() {
    return this.ranges.getParentIndex(this.index);
  }
  get isCollapsed() {
    return this.ranges.isCollapsed(this.index);
  }
  containedBy(e) {
    return e.startLineNumber <= this.startLineNumber && e.endLineNumber >= this.endLineNumber;
  }
  containsLine(e) {
    return this.startLineNumber <= e && e <= this.endLineNumber;
  }
}
class _le {
  get regions() {
    return this._regions;
  }
  get textModel() {
    return this._textModel;
  }
  constructor(e, t) {
    this._updateEventEmitter = new F(), this.onDidChange = this._updateEventEmitter.event, this._textModel = e, this._decorationProvider = t, this._regions = new go(new Uint32Array(0), new Uint32Array(0)), this._editorDecorationIds = [];
  }
  toggleCollapseState(e) {
    if (!e.length) return;
    e = e.sort(((i, s) => i.regionIndex - s.regionIndex));
    const t = {};
    this._decorationProvider.changeDecorations(((i) => {
      let s = 0, o = -1, r = -1;
      const a = (l) => {
        for (; s < l; ) {
          const d = this._regions.getEndLineNumber(s), h = this._regions.isCollapsed(s);
          if (d <= o) {
            const c = this.regions.getSource(s) !== 0;
            i.changeDecorationOptions(this._editorDecorationIds[s], this._decorationProvider.getDecorationOption(h, d <= r, c));
          }
          h && d > r && (r = d), s++;
        }
      };
      for (const l of e) {
        const d = l.regionIndex, h = this._editorDecorationIds[d];
        if (h && !t[h]) {
          t[h] = !0, a(d);
          const c = !this._regions.isCollapsed(d);
          this._regions.setCollapsed(d, c), o = Math.max(o, this._regions.getEndLineNumber(d));
        }
      }
      a(this._regions.length);
    })), this._updateEventEmitter.fire({ model: this, collapseStateChanged: e });
  }
  removeManualRanges(e) {
    const t = new Array(), i = (s) => {
      for (const o of e) if (!(o.startLineNumber > s.endLineNumber || s.startLineNumber > o.endLineNumber)) return !0;
      return !1;
    };
    for (let s = 0; s < this._regions.length; s++) {
      const o = this._regions.toFoldRange(s);
      o.source !== 0 && i(o) || t.push(o);
    }
    this.updatePost(go.fromFoldRanges(t));
  }
  update(e, t = []) {
    const i = this._currentFoldedOrManualRanges(t), s = go.sanitizeAndMerge(e, i, this._textModel.getLineCount());
    this.updatePost(go.fromFoldRanges(s));
  }
  updatePost(e) {
    const t = [];
    let i = -1;
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e.getStartLineNumber(s), a = e.getEndLineNumber(s), l = e.isCollapsed(s), d = e.getSource(s) !== 0, h = { startLineNumber: r, startColumn: this._textModel.getLineMaxColumn(r), endLineNumber: a, endColumn: this._textModel.getLineMaxColumn(a) + 1 };
      t.push({ range: h, options: this._decorationProvider.getDecorationOption(l, a <= i, d) }), l && a > i && (i = a);
    }
    this._decorationProvider.changeDecorations(((s) => this._editorDecorationIds = s.deltaDecorations(this._editorDecorationIds, t))), this._regions = e, this._updateEventEmitter.fire({ model: this });
  }
  _currentFoldedOrManualRanges(e = []) {
    const t = (s, o) => {
      for (const r of e) if (s < r && r <= o) return !0;
      return !1;
    }, i = [];
    for (let s = 0, o = this._regions.length; s < o; s++) {
      let r = this.regions.isCollapsed(s);
      const a = this.regions.getSource(s);
      if (r || a !== 0) {
        const l = this._regions.toFoldRange(s), d = this._textModel.getDecorationRange(this._editorDecorationIds[s]);
        d && (r && t(d.startLineNumber, d.endLineNumber) && (r = !1), i.push({ startLineNumber: d.startLineNumber, endLineNumber: d.endLineNumber, type: l.type, isCollapsed: r, source: a }));
      }
    }
    return i;
  }
  getMemento() {
    const e = this._currentFoldedOrManualRanges(), t = [], i = this._textModel.getLineCount();
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e[s];
      if (r.startLineNumber >= r.endLineNumber || r.startLineNumber < 1 || r.endLineNumber > i) continue;
      const a = this._getLinesChecksum(r.startLineNumber + 1, r.endLineNumber);
      t.push({ startLineNumber: r.startLineNumber, endLineNumber: r.endLineNumber, isCollapsed: r.isCollapsed, source: r.source, checksum: a });
    }
    return t.length > 0 ? t : void 0;
  }
  applyMemento(e) {
    var t, i;
    if (!Array.isArray(e)) return;
    const s = [], o = this._textModel.getLineCount();
    for (const a of e) {
      if (a.startLineNumber >= a.endLineNumber || a.startLineNumber < 1 || a.endLineNumber > o) continue;
      const l = this._getLinesChecksum(a.startLineNumber + 1, a.endLineNumber);
      a.checksum && l !== a.checksum || s.push({ startLineNumber: a.startLineNumber, endLineNumber: a.endLineNumber, type: void 0, isCollapsed: (t = a.isCollapsed) === null || t === void 0 || t, source: (i = a.source) !== null && i !== void 0 ? i : 0 });
    }
    const r = go.sanitizeAndMerge(this._regions, s, o);
    this.updatePost(go.fromFoldRanges(r));
  }
  _getLinesChecksum(e, t) {
    return FS(this._textModel.getLineContent(e) + this._textModel.getLineContent(t)) % 1e6;
  }
  dispose() {
    this._decorationProvider.removeDecorations(this._editorDecorationIds);
  }
  getAllRegionsAtLine(e, t) {
    const i = [];
    if (this._regions) {
      let s = this._regions.findRange(e), o = 1;
      for (; s >= 0; ) {
        const r = this._regions.toRegion(s);
        t && !t(r, o) || i.push(r), o++, s = r.parentIndex;
      }
    }
    return i;
  }
  getRegionAtLine(e) {
    if (this._regions) {
      const t = this._regions.findRange(e);
      if (t >= 0) return this._regions.toRegion(t);
    }
    return null;
  }
  getRegionsInside(e, t) {
    const i = [], s = e ? e.regionIndex + 1 : 0, o = e ? e.endLineNumber : Number.MAX_VALUE;
    if (t && t.length === 2) {
      const r = [];
      for (let a = s, l = this._regions.length; a < l; a++) {
        const d = this._regions.toRegion(a);
        if (!(this._regions.getStartLineNumber(a) < o)) break;
        for (; r.length > 0 && !d.containedBy(r[r.length - 1]); ) r.pop();
        r.push(d), t(d, r.length) && i.push(d);
      }
    } else for (let r = s, a = this._regions.length; r < a; r++) {
      const l = this._regions.toRegion(r);
      if (!(this._regions.getStartLineNumber(r) < o)) break;
      t && !t(l) || i.push(l);
    }
    return i;
  }
}
function Kz(n, e, t) {
  const i = [];
  for (const s of t) {
    const o = n.getRegionAtLine(s);
    if (o) {
      const r = !o.isCollapsed;
      if (i.push(o), e > 1) {
        const a = n.getRegionsInside(o, ((l, d) => l.isCollapsed !== r && d < e));
        i.push(...a);
      }
    }
  }
  n.toggleCollapseState(i);
}
function op(n, e, t = Number.MAX_VALUE, i) {
  const s = [];
  if (i && i.length > 0) for (const o of i) {
    const r = n.getRegionAtLine(o);
    if (r && (r.isCollapsed !== e && s.push(r), t > 1)) {
      const a = n.getRegionsInside(r, ((l, d) => l.isCollapsed !== e && d < t));
      s.push(...a);
    }
  }
  else {
    const o = n.getRegionsInside(null, ((r, a) => r.isCollapsed !== e && a < t));
    s.push(...o);
  }
  n.toggleCollapseState(s);
}
function Q6(n, e, t, i) {
  const s = [];
  for (const o of i) {
    const r = n.getAllRegionsAtLine(o, ((a, l) => a.isCollapsed !== e && l <= t));
    s.push(...r);
  }
  n.toggleCollapseState(s);
}
function J6(n, e, t) {
  const i = [];
  for (const o of t) {
    const r = n.getAllRegionsAtLine(o, void 0);
    r.length > 0 && i.push(r[0]);
  }
  const s = n.getRegionsInside(null, ((o) => i.every(((r) => !r.containedBy(o) && !o.containedBy(r))) && o.isCollapsed !== e));
  n.toggleCollapseState(s);
}
function Vx(n, e, t) {
  const i = n.textModel, s = n.regions, o = [];
  for (let r = s.length - 1; r >= 0; r--) if (t !== s.isCollapsed(r)) {
    const a = s.getStartLineNumber(r);
    e.test(i.getLineContent(a)) && o.push(s.toRegion(r));
  }
  n.toggleCollapseState(o);
}
function Hx(n, e, t) {
  const i = n.regions, s = [];
  for (let o = i.length - 1; o >= 0; o--) t !== i.isCollapsed(o) && e === i.getType(o) && s.push(i.toRegion(o));
  n.toggleCollapseState(s);
}
class vle {
  get onDidChange() {
    return this._updateEventEmitter.event;
  }
  get hiddenRanges() {
    return this._hiddenRanges;
  }
  constructor(e) {
    this._updateEventEmitter = new F(), this._hasLineChanges = !1, this._foldingModel = e, this._foldingModelListener = e.onDidChange(((t) => this.updateHiddenRanges())), this._hiddenRanges = [], e.regions.length && this.updateHiddenRanges();
  }
  notifyChangeModelContent(e) {
    this._hiddenRanges.length && !this._hasLineChanges && (this._hasLineChanges = e.changes.some(((t) => t.range.endLineNumber !== t.range.startLineNumber || kc(t.text)[0] !== 0)));
  }
  updateHiddenRanges() {
    let e = !1;
    const t = [];
    let i = 0, s = 0, o = Number.MAX_VALUE, r = -1;
    const a = this._foldingModel.regions;
    for (; i < a.length; i++) {
      if (!a.isCollapsed(i)) continue;
      const l = a.getStartLineNumber(i) + 1, d = a.getEndLineNumber(i);
      o <= l && d <= r || (!e && s < this._hiddenRanges.length && this._hiddenRanges[s].startLineNumber === l && this._hiddenRanges[s].endLineNumber === d ? (t.push(this._hiddenRanges[s]), s++) : (e = !0, t.push(new D(l, 1, d, 1))), o = l, r = d);
    }
    (this._hasLineChanges || e || s < this._hiddenRanges.length) && this.applyHiddenRanges(t);
  }
  applyHiddenRanges(e) {
    this._hiddenRanges = e, this._hasLineChanges = !1, this._updateEventEmitter.fire(e);
  }
  hasRanges() {
    return this._hiddenRanges.length > 0;
  }
  isHidden(e) {
    return e9(this._hiddenRanges, e) !== null;
  }
  adjustSelections(e) {
    let t = !1;
    const i = this._foldingModel.textModel;
    let s = null;
    const o = (r) => (s && (function(a, l) {
      return a >= l.startLineNumber && a <= l.endLineNumber;
    })(r, s) || (s = e9(this._hiddenRanges, r)), s ? s.startLineNumber - 1 : null);
    for (let r = 0, a = e.length; r < a; r++) {
      let l = e[r];
      const d = o(l.startLineNumber);
      d && (l = l.setStartPosition(d, i.getLineMaxColumn(d)), t = !0);
      const h = o(l.endLineNumber);
      h && (l = l.setEndPosition(h, i.getLineMaxColumn(h)), t = !0), e[r] = l;
    }
    return t;
  }
  dispose() {
    this.hiddenRanges.length > 0 && (this._hiddenRanges = [], this._updateEventEmitter.fire(this._hiddenRanges)), this._foldingModelListener && (this._foldingModelListener.dispose(), this._foldingModelListener = null);
  }
}
function e9(n, e) {
  const t = sv(n, ((i) => e < i.startLineNumber)) - 1;
  return t >= 0 && n[t].endLineNumber >= e ? n[t] : null;
}
class DP {
  constructor(e, t, i) {
    this.editorModel = e, this.languageConfigurationService = t, this.foldingRangesLimit = i, this.id = "indent";
  }
  dispose() {
  }
  compute(e) {
    const t = this.languageConfigurationService.getLanguageConfiguration(this.editorModel.getLanguageId()).foldingRules, i = t && !!t.offSide, s = t && t.markers;
    return Promise.resolve((function(o, r, a, l = Cle) {
      const d = o.getOptions().tabSize, h = new ble(l);
      let c;
      a && (c = new RegExp(`(${a.start.source})|(?:${a.end.source})`));
      const u = [], g = o.getLineCount() + 1;
      u.push({ indent: -1, endAbove: g, line: g });
      for (let p = o.getLineCount(); p > 0; p--) {
        const f = o.getLineContent(p), _ = hL(f, d);
        let v, b = u[u.length - 1];
        if (_ !== -1) {
          if (c && (v = f.match(c))) {
            if (!v[1]) {
              u.push({ indent: -2, endAbove: p, line: p });
              continue;
            }
            {
              let C = u.length - 1;
              for (; C > 0 && u[C].indent !== -2; ) C--;
              if (C > 0) {
                u.length = C + 1, b = u[C], h.insertFirst(p, b.line, _), b.line = p, b.indent = _, b.endAbove = p;
                continue;
              }
            }
          }
          if (b.indent > _) {
            do
              u.pop(), b = u[u.length - 1];
            while (b.indent > _);
            const C = b.endAbove - 1;
            C - p >= 1 && h.insertFirst(p, C, _);
          }
          b.indent === _ ? b.endAbove = p : u.push({ indent: _, endAbove: p, line: p });
        } else r && (b.endAbove = p);
      }
      return h.toIndentRanges(o);
    })(this.editorModel, i, s, this.foldingRangesLimit));
  }
}
let ble = class {
  constructor(n) {
    this._startIndexes = [], this._endIndexes = [], this._indentOccurrences = [], this._length = 0, this._foldingRangesLimit = n;
  }
  insertFirst(n, e, t) {
    if (n > $r || e > $r) return;
    const i = this._length;
    this._startIndexes[i] = n, this._endIndexes[i] = e, this._length++, t < 1e3 && (this._indentOccurrences[t] = (this._indentOccurrences[t] || 0) + 1);
  }
  toIndentRanges(n) {
    const e = this._foldingRangesLimit.limit;
    if (this._length <= e) {
      this._foldingRangesLimit.update(this._length, !1);
      const t = new Uint32Array(this._length), i = new Uint32Array(this._length);
      for (let s = this._length - 1, o = 0; s >= 0; s--, o++) t[o] = this._startIndexes[s], i[o] = this._endIndexes[s];
      return new go(t, i);
    }
    {
      this._foldingRangesLimit.update(this._length, e);
      let t = 0, i = this._indentOccurrences.length;
      for (let a = 0; a < this._indentOccurrences.length; a++) {
        const l = this._indentOccurrences[a];
        if (l) {
          if (l + t > e) {
            i = a;
            break;
          }
          t += l;
        }
      }
      const s = n.getOptions().tabSize, o = new Uint32Array(e), r = new Uint32Array(e);
      for (let a = this._length - 1, l = 0; a >= 0; a--) {
        const d = this._startIndexes[a], h = hL(n.getLineContent(d), s);
        (h < i || h === i && t++ < e) && (o[l] = d, r[l] = this._endIndexes[a], l++);
      }
      return new go(o, r);
    }
  }
};
const Cle = { limit: 5e3, update: () => {
} }, wle = I("editor.foldBackground", { light: Ce(Mh, 0.3), dark: Ce(Mh, 0.3), hcDark: null, hcLight: null }, m(0, "Background color behind folded ranges. The color must not be opaque so as not to hide underlying decorations."), !0);
I("editorGutter.foldingControlForeground", { dark: nl, light: nl, hcDark: nl, hcLight: nl }, m(0, "Color of the folding control in the editor gutter."));
const bS = Ei("folding-expanded", ne.chevronDown, m(0, "Icon for expanded ranges in the editor glyph margin.")), CS = Ei("folding-collapsed", ne.chevronRight, m(0, "Icon for collapsed ranges in the editor glyph margin.")), t9 = Ei("folding-manual-collapsed", CS, m(0, "Icon for manually collapsed ranges in the editor glyph margin.")), i9 = Ei("folding-manual-expanded", bS, m(0, "Icon for manually expanded ranges in the editor glyph margin.")), zx = { color: ui(wle), position: 1 }, rp = m(0, "Click to expand the range."), dC = m(0, "Click to collapse the range.");
class Ai {
  constructor(e) {
    this.editor = e, this.showFoldingControls = "mouseover", this.showFoldingHighlights = !0;
  }
  getDecorationOption(e, t, i) {
    return t ? Ai.HIDDEN_RANGE_DECORATION : this.showFoldingControls === "never" ? e ? this.showFoldingHighlights ? Ai.NO_CONTROLS_COLLAPSED_HIGHLIGHTED_RANGE_DECORATION : Ai.NO_CONTROLS_COLLAPSED_RANGE_DECORATION : Ai.NO_CONTROLS_EXPANDED_RANGE_DECORATION : e ? i ? this.showFoldingHighlights ? Ai.MANUALLY_COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION : Ai.MANUALLY_COLLAPSED_VISUAL_DECORATION : this.showFoldingHighlights ? Ai.COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION : Ai.COLLAPSED_VISUAL_DECORATION : this.showFoldingControls === "mouseover" ? i ? Ai.MANUALLY_EXPANDED_AUTO_HIDE_VISUAL_DECORATION : Ai.EXPANDED_AUTO_HIDE_VISUAL_DECORATION : i ? Ai.MANUALLY_EXPANDED_VISUAL_DECORATION : Ai.EXPANDED_VISUAL_DECORATION;
  }
  changeDecorations(e) {
    return this.editor.changeDecorations(e);
  }
  removeDecorations(e) {
    this.editor.removeDecorations(e);
  }
}
Ai.COLLAPSED_VISUAL_DECORATION = Ve.register({ description: "folding-collapsed-visual-decoration", stickiness: 0, afterContentClassName: "inline-folded", isWholeLine: !0, linesDecorationsTooltip: rp, firstLineDecorationClassName: Ee.asClassName(CS) }), Ai.COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION = Ve.register({ description: "folding-collapsed-highlighted-visual-decoration", stickiness: 0, afterContentClassName: "inline-folded", className: "folded-background", minimap: zx, isWholeLine: !0, linesDecorationsTooltip: rp, firstLineDecorationClassName: Ee.asClassName(CS) }), Ai.MANUALLY_COLLAPSED_VISUAL_DECORATION = Ve.register({ description: "folding-manually-collapsed-visual-decoration", stickiness: 0, afterContentClassName: "inline-folded", isWholeLine: !0, linesDecorationsTooltip: rp, firstLineDecorationClassName: Ee.asClassName(t9) }), Ai.MANUALLY_COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION = Ve.register({ description: "folding-manually-collapsed-highlighted-visual-decoration", stickiness: 0, afterContentClassName: "inline-folded", className: "folded-background", minimap: zx, isWholeLine: !0, linesDecorationsTooltip: rp, firstLineDecorationClassName: Ee.asClassName(t9) }), Ai.NO_CONTROLS_COLLAPSED_RANGE_DECORATION = Ve.register({ description: "folding-no-controls-range-decoration", stickiness: 0, afterContentClassName: "inline-folded", isWholeLine: !0, linesDecorationsTooltip: rp }), Ai.NO_CONTROLS_COLLAPSED_HIGHLIGHTED_RANGE_DECORATION = Ve.register({ description: "folding-no-controls-range-decoration", stickiness: 0, afterContentClassName: "inline-folded", className: "folded-background", minimap: zx, isWholeLine: !0, linesDecorationsTooltip: rp }), Ai.EXPANDED_VISUAL_DECORATION = Ve.register({ description: "folding-expanded-visual-decoration", stickiness: 1, isWholeLine: !0, firstLineDecorationClassName: "alwaysShowFoldIcons " + Ee.asClassName(bS), linesDecorationsTooltip: dC }), Ai.EXPANDED_AUTO_HIDE_VISUAL_DECORATION = Ve.register({ description: "folding-expanded-auto-hide-visual-decoration", stickiness: 1, isWholeLine: !0, firstLineDecorationClassName: Ee.asClassName(bS), linesDecorationsTooltip: dC }), Ai.MANUALLY_EXPANDED_VISUAL_DECORATION = Ve.register({ description: "folding-manually-expanded-visual-decoration", stickiness: 0, isWholeLine: !0, firstLineDecorationClassName: "alwaysShowFoldIcons " + Ee.asClassName(i9), linesDecorationsTooltip: dC }), Ai.MANUALLY_EXPANDED_AUTO_HIDE_VISUAL_DECORATION = Ve.register({ description: "folding-manually-expanded-auto-hide-visual-decoration", stickiness: 0, isWholeLine: !0, firstLineDecorationClassName: Ee.asClassName(i9), linesDecorationsTooltip: dC }), Ai.NO_CONTROLS_EXPANDED_RANGE_DECORATION = Ve.register({ description: "folding-no-controls-range-decoration", stickiness: 0, isWholeLine: !0 }), Ai.HIDDEN_RANGE_DECORATION = Ve.register({ description: "folding-hidden-range-decoration", stickiness: 1 });
const yle = {};
class xP {
  constructor(e, t, i, s, o) {
    this.editorModel = e, this.providers = t, this.handleFoldingRangesChange = i, this.foldingRangesLimit = s, this.fallbackRangeProvider = o, this.id = "syntax", this.disposables = new G(), o && this.disposables.add(o);
    for (const r of t) typeof r.onDidChange == "function" && this.disposables.add(r.onDidChange(i));
  }
  compute(e) {
    return (function(t, i, s) {
      let o = null;
      const r = t.map(((a, l) => Promise.resolve(a.provideFoldingRanges(i, yle, s)).then(((d) => {
        if (!s.isCancellationRequested && Array.isArray(d)) {
          Array.isArray(o) || (o = []);
          const h = i.getLineCount();
          for (const c of d) c.start > 0 && c.end > c.start && c.end <= h && o.push({ start: c.start, end: c.end, rank: l, kind: c.kind });
        }
      }), Ni)));
      return Promise.all(r).then(((a) => o));
    })(this.providers, this.editorModel, e).then(((t) => {
      var i, s;
      return t ? (function(o, r) {
        const a = o.sort(((c, u) => {
          let g = c.start - u.start;
          return g === 0 && (g = c.rank - u.rank), g;
        })), l = new Sle(r);
        let d;
        const h = [];
        for (const c of a) if (d) {
          if (c.start > d.start) if (c.end <= d.end) h.push(d), d = c, l.add(c.start, c.end, c.kind && c.kind.value, h.length);
          else {
            if (c.start > d.end) {
              do
                d = h.pop();
              while (d && c.start > d.end);
              d && h.push(d), d = c;
            }
            l.add(c.start, c.end, c.kind && c.kind.value, h.length);
          }
        } else d = c, l.add(c.start, c.end, c.kind && c.kind.value, h.length);
        return l.toIndentRanges();
      })(t, this.foldingRangesLimit) : (s = (i = this.fallbackRangeProvider) === null || i === void 0 ? void 0 : i.compute(e)) !== null && s !== void 0 ? s : null;
    }));
  }
  dispose() {
    this.disposables.dispose();
  }
}
class Sle {
  constructor(e) {
    this._startIndexes = [], this._endIndexes = [], this._nestingLevels = [], this._nestingLevelCounts = [], this._types = [], this._length = 0, this._foldingRangesLimit = e;
  }
  add(e, t, i, s) {
    if (e > $r || t > $r) return;
    const o = this._length;
    this._startIndexes[o] = e, this._endIndexes[o] = t, this._nestingLevels[o] = s, this._types[o] = i, this._length++, s < 30 && (this._nestingLevelCounts[s] = (this._nestingLevelCounts[s] || 0) + 1);
  }
  toIndentRanges() {
    const e = this._foldingRangesLimit.limit;
    if (this._length <= e) {
      this._foldingRangesLimit.update(this._length, !1);
      const t = new Uint32Array(this._length), i = new Uint32Array(this._length);
      for (let s = 0; s < this._length; s++) t[s] = this._startIndexes[s], i[s] = this._endIndexes[s];
      return new go(t, i, this._types);
    }
    {
      this._foldingRangesLimit.update(this._length, e);
      let t = 0, i = this._nestingLevelCounts.length;
      for (let a = 0; a < this._nestingLevelCounts.length; a++) {
        const l = this._nestingLevelCounts[a];
        if (l) {
          if (l + t > e) {
            i = a;
            break;
          }
          t += l;
        }
      }
      const s = new Uint32Array(e), o = new Uint32Array(e), r = [];
      for (let a = 0, l = 0; a < this._length; a++) {
        const d = this._nestingLevels[a];
        (d < i || d === i && t++ < e) && (s[l] = this._startIndexes[a], o[l] = this._endIndexes[a], r[l] = this._types[a], l++);
      }
      return new go(s, o, r);
    }
  }
}
var fp, Lle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, t_ = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const Pn = new ae("foldingEnabled", !1);
let Id = fp = class extends V {
  static get(n) {
    return n.getContribution(fp.ID);
  }
  static getFoldingRangeProviders(n, e) {
    var t, i;
    const s = n.foldingRangeProvider.ordered(e);
    return (i = (t = fp._foldingRangeSelector) === null || t === void 0 ? void 0 : t.call(fp, s, e)) !== null && i !== void 0 ? i : s;
  }
  constructor(n, e, t, i, s, o) {
    super(), this.contextKeyService = e, this.languageConfigurationService = t, this.languageFeaturesService = o, this.localToDispose = this._register(new G()), this.editor = n, this._foldingLimitReporter = new jz(n);
    const r = this.editor.getOptions();
    this._isEnabled = r.get(43), this._useFoldingProviders = r.get(44) !== "indentation", this._unfoldOnClickAfterEndOfLine = r.get(48), this._restoringViewState = !1, this._currentModelHasFoldedImports = !1, this._foldingImportsByDefault = r.get(46), this.updateDebounceInfo = s.for(o.foldingRangeProvider, "Folding", { min: 200 }), this.foldingModel = null, this.hiddenRangeModel = null, this.rangeProvider = null, this.foldingRegionPromise = null, this.foldingModelPromise = null, this.updateScheduler = null, this.cursorChangedScheduler = null, this.mouseDownInfo = null, this.foldingDecorationProvider = new Ai(n), this.foldingDecorationProvider.showFoldingControls = r.get(110), this.foldingDecorationProvider.showFoldingHighlights = r.get(45), this.foldingEnabled = Pn.bindTo(this.contextKeyService), this.foldingEnabled.set(this._isEnabled), this._register(this.editor.onDidChangeModel((() => this.onModelChanged()))), this._register(this.editor.onDidChangeConfiguration(((a) => {
      if (a.hasChanged(43) && (this._isEnabled = this.editor.getOptions().get(43), this.foldingEnabled.set(this._isEnabled), this.onModelChanged()), a.hasChanged(47) && this.onModelChanged(), a.hasChanged(110) || a.hasChanged(45)) {
        const l = this.editor.getOptions();
        this.foldingDecorationProvider.showFoldingControls = l.get(110), this.foldingDecorationProvider.showFoldingHighlights = l.get(45), this.triggerFoldingModelChanged();
      }
      a.hasChanged(44) && (this._useFoldingProviders = this.editor.getOptions().get(44) !== "indentation", this.onFoldingStrategyChanged()), a.hasChanged(48) && (this._unfoldOnClickAfterEndOfLine = this.editor.getOptions().get(48)), a.hasChanged(46) && (this._foldingImportsByDefault = this.editor.getOptions().get(46));
    }))), this.onModelChanged();
  }
  saveViewState() {
    const n = this.editor.getModel();
    if (!n || !this._isEnabled || n.isTooLargeForTokenization()) return {};
    if (this.foldingModel) {
      const e = this.foldingModel.getMemento(), t = this.rangeProvider ? this.rangeProvider.id : void 0;
      return { collapsedRegions: e, lineCount: n.getLineCount(), provider: t, foldedImports: this._currentModelHasFoldedImports };
    }
  }
  restoreViewState(n) {
    const e = this.editor.getModel();
    if (e && this._isEnabled && !e.isTooLargeForTokenization() && this.hiddenRangeModel && n && (this._currentModelHasFoldedImports = !!n.foldedImports, n.collapsedRegions && n.collapsedRegions.length > 0 && this.foldingModel)) {
      this._restoringViewState = !0;
      try {
        this.foldingModel.applyMemento(n.collapsedRegions);
      } finally {
        this._restoringViewState = !1;
      }
    }
  }
  onModelChanged() {
    this.localToDispose.clear();
    const n = this.editor.getModel();
    this._isEnabled && n && !n.isTooLargeForTokenization() && (this._currentModelHasFoldedImports = !1, this.foldingModel = new _le(n, this.foldingDecorationProvider), this.localToDispose.add(this.foldingModel), this.hiddenRangeModel = new vle(this.foldingModel), this.localToDispose.add(this.hiddenRangeModel), this.localToDispose.add(this.hiddenRangeModel.onDidChange(((e) => this.onHiddenRangesChanges(e)))), this.updateScheduler = new Sr(this.updateDebounceInfo.get(n)), this.cursorChangedScheduler = new Et((() => this.revealCursor()), 200), this.localToDispose.add(this.cursorChangedScheduler), this.localToDispose.add(this.languageFeaturesService.foldingRangeProvider.onDidChange((() => this.onFoldingStrategyChanged()))), this.localToDispose.add(this.editor.onDidChangeModelLanguageConfiguration((() => this.onFoldingStrategyChanged()))), this.localToDispose.add(this.editor.onDidChangeModelContent(((e) => this.onDidChangeModelContent(e)))), this.localToDispose.add(this.editor.onDidChangeCursorPosition((() => this.onCursorPositionChanged()))), this.localToDispose.add(this.editor.onMouseDown(((e) => this.onEditorMouseDown(e)))), this.localToDispose.add(this.editor.onMouseUp(((e) => this.onEditorMouseUp(e)))), this.localToDispose.add({ dispose: () => {
      var e, t;
      this.foldingRegionPromise && (this.foldingRegionPromise.cancel(), this.foldingRegionPromise = null), (e = this.updateScheduler) === null || e === void 0 || e.cancel(), this.updateScheduler = null, this.foldingModel = null, this.foldingModelPromise = null, this.hiddenRangeModel = null, this.cursorChangedScheduler = null, (t = this.rangeProvider) === null || t === void 0 || t.dispose(), this.rangeProvider = null;
    } }), this.triggerFoldingModelChanged());
  }
  onFoldingStrategyChanged() {
    var n;
    (n = this.rangeProvider) === null || n === void 0 || n.dispose(), this.rangeProvider = null, this.triggerFoldingModelChanged();
  }
  getRangeProvider(n) {
    if (this.rangeProvider) return this.rangeProvider;
    const e = new DP(n, this.languageConfigurationService, this._foldingLimitReporter);
    if (this.rangeProvider = e, this._useFoldingProviders && this.foldingModel) {
      const t = fp.getFoldingRangeProviders(this.languageFeaturesService, n);
      t.length > 0 && (this.rangeProvider = new xP(n, t, (() => this.triggerFoldingModelChanged()), this._foldingLimitReporter, e));
    }
    return this.rangeProvider;
  }
  getFoldingModel() {
    return this.foldingModelPromise;
  }
  onDidChangeModelContent(n) {
    var e;
    (e = this.hiddenRangeModel) === null || e === void 0 || e.notifyChangeModelContent(n), this.triggerFoldingModelChanged();
  }
  triggerFoldingModelChanged() {
    this.updateScheduler && (this.foldingRegionPromise && (this.foldingRegionPromise.cancel(), this.foldingRegionPromise = null), this.foldingModelPromise = this.updateScheduler.trigger((() => {
      const n = this.foldingModel;
      if (!n) return null;
      const e = new Rn(), t = this.getRangeProvider(n.textModel), i = this.foldingRegionPromise = on(((s) => t.compute(s)));
      return i.then(((s) => {
        if (s && i === this.foldingRegionPromise) {
          let o;
          if (this._foldingImportsByDefault && !this._currentModelHasFoldedImports) {
            const d = s.setCollapsedAllOfType(ls.Imports.value, !0);
            d && (o = wa.capture(this.editor), this._currentModelHasFoldedImports = d);
          }
          const r = this.editor.getSelections(), a = r ? r.map(((d) => d.startLineNumber)) : [];
          n.update(s, a), o?.restore(this.editor);
          const l = this.updateDebounceInfo.update(n.textModel, e.elapsed());
          this.updateScheduler && (this.updateScheduler.defaultDelay = l);
        }
        return n;
      }));
    })).then(void 0, ((n) => (We(n), null))));
  }
  onHiddenRangesChanges(n) {
    if (this.hiddenRangeModel && n.length && !this._restoringViewState) {
      const e = this.editor.getSelections();
      e && this.hiddenRangeModel.adjustSelections(e) && this.editor.setSelections(e);
    }
    this.editor.setHiddenAreas(n, this);
  }
  onCursorPositionChanged() {
    this.hiddenRangeModel && this.hiddenRangeModel.hasRanges() && this.cursorChangedScheduler.schedule();
  }
  revealCursor() {
    const n = this.getFoldingModel();
    n && n.then(((e) => {
      if (e) {
        const t = this.editor.getSelections();
        if (t && t.length > 0) {
          const i = [];
          for (const s of t) {
            const o = s.selectionStartLineNumber;
            this.hiddenRangeModel && this.hiddenRangeModel.isHidden(o) && i.push(...e.getAllRegionsAtLine(o, ((r) => r.isCollapsed && o > r.startLineNumber)));
          }
          i.length && (e.toggleCollapseState(i), this.reveal(t[0].getPosition()));
        }
      }
    })).then(void 0, We);
  }
  onEditorMouseDown(n) {
    if (this.mouseDownInfo = null, !this.hiddenRangeModel || !n.target || !n.target.range || !n.event.leftButton && !n.event.middleButton) return;
    const e = n.target.range;
    let t = !1;
    switch (n.target.type) {
      case 4: {
        const i = n.target.detail, s = n.target.element.offsetLeft;
        if (i.offsetX - s < 4) return;
        t = !0;
        break;
      }
      case 7:
        if (this._unfoldOnClickAfterEndOfLine && this.hiddenRangeModel.hasRanges() && !n.target.detail.isAfterLines)
          break;
        return;
      case 6:
        if (this.hiddenRangeModel.hasRanges()) {
          const i = this.editor.getModel();
          if (i && e.startColumn === i.getLineMaxColumn(e.startLineNumber)) break;
        }
        return;
      default:
        return;
    }
    this.mouseDownInfo = { lineNumber: e.startLineNumber, iconClicked: t };
  }
  onEditorMouseUp(n) {
    const e = this.foldingModel;
    if (!e || !this.mouseDownInfo || !n.target) return;
    const t = this.mouseDownInfo.lineNumber, i = this.mouseDownInfo.iconClicked, s = n.target.range;
    if (!s || s.startLineNumber !== t) return;
    if (i) {
      if (n.target.type !== 4) return;
    } else {
      const r = this.editor.getModel();
      if (!r || s.startColumn !== r.getLineMaxColumn(t)) return;
    }
    const o = e.getRegionAtLine(t);
    if (o && o.startLineNumber === t) {
      const r = o.isCollapsed;
      if (i || r) {
        let a = [];
        if (n.event.altKey) {
          const l = (h) => !h.containedBy(o) && !o.containedBy(h), d = e.getRegionsInside(null, l);
          for (const h of d) h.isCollapsed && a.push(h);
          a.length === 0 && (a = d);
        } else {
          const l = n.event.middleButton || n.event.shiftKey;
          if (l) for (const d of e.getRegionsInside(o)) d.isCollapsed === r && a.push(d);
          !r && l && a.length !== 0 || a.push(o);
        }
        e.toggleCollapseState(a), this.reveal({ lineNumber: t, column: 1 });
      }
    }
  }
  reveal(n) {
    this.editor.revealPositionInCenterIfOutsideViewport(n, 0);
  }
};
Id.ID = "editor.contrib.folding", Id = fp = Lle([t_(1, Te), t_(2, zt), t_(3, Ri), t_(4, ar), t_(5, fe)], Id);
class jz {
  constructor(e) {
    this.editor = e, this._onDidChange = new F(), this._computed = 0, this._limited = !1;
  }
  get limit() {
    return this.editor.getOptions().get(47);
  }
  update(e, t) {
    e === this._computed && t === this._limited || (this._computed = e, this._limited = t, this._onDidChange.fire());
  }
}
class jn extends he {
  runEditorCommand(e, t, i) {
    const s = e.get(zt), o = Id.get(t);
    if (!o) return;
    const r = o.getFoldingModel();
    return r ? (this.reportTelemetry(e, t), r.then(((a) => {
      if (a) {
        this.invoke(o, a, t, i, s);
        const l = t.getSelection();
        l && o.reveal(l.getStartPosition());
      }
    }))) : void 0;
  }
  getSelectedLines(e) {
    const t = e.getSelections();
    return t ? t.map(((i) => i.startLineNumber)) : [];
  }
  getLineNumbers(e, t) {
    return e && e.selectionLines ? e.selectionLines.map(((i) => i + 1)) : this.getSelectedLines(t);
  }
  run(e, t) {
  }
}
function n9(n) {
  if (!$s(n)) {
    if (!ms(n)) return !1;
    const e = n;
    if (!$s(e.levels) && !uc(e.levels) || !$s(e.direction) && !ps(e.direction) || !($s(e.selectionLines) || Array.isArray(e.selectionLines) && e.selectionLines.every(uc))) return !1;
  }
  return !0;
}
class Qu extends jn {
  getFoldingLevel() {
    return parseInt(this.id.substr(Qu.ID_PREFIX.length));
  }
  invoke(e, t, i) {
    (function(s, o, r, a) {
      const l = s.getRegionsInside(null, ((d, h) => h === o && d.isCollapsed !== r && !a.some(((c) => d.containsLine(c)))));
      s.toggleCollapseState(l);
    })(t, this.getFoldingLevel(), !0, this.getSelectedLines(i));
  }
}
Qu.ID_PREFIX = "editor.foldLevel", Qu.ID = (n) => Qu.ID_PREFIX + n;
ft(Id.ID, Id, 0), X(class extends jn {
  constructor() {
    super({ id: "editor.unfold", label: m(0, "Unfold"), alias: "Unfold", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: 3166, mac: { primary: 2654 }, weight: 100 }, metadata: { description: "Unfold the content in the editor", args: [{ name: "Unfold editor argument", description: `Property-value pairs that can be passed through this argument:
						* 'levels': Number of levels to unfold. If not set, defaults to 1.
						* 'direction': If 'up', unfold given number of levels up otherwise unfolds down.
						* 'selectionLines': Array of the start lines (0-based) of the editor selections to apply the unfold action to. If not set, the active selection(s) will be used.
						`, constraint: n9, schema: { type: "object", properties: { levels: { type: "number", default: 1 }, direction: { type: "string", enum: ["up", "down"], default: "down" }, selectionLines: { type: "array", items: { type: "number" } } } } }] } });
  }
  invoke(n, e, t, i) {
    const s = i && i.levels || 1, o = this.getLineNumbers(i, t);
    i && i.direction === "up" ? Q6(e, !1, s, o) : op(e, !1, s, o);
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.unfoldRecursively", label: m(0, "Unfold Recursively"), alias: "Unfold Recursively", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2142), weight: 100 } });
  }
  invoke(n, e, t, i) {
    op(e, !1, Number.MAX_VALUE, this.getSelectedLines(t));
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.fold", label: m(0, "Fold"), alias: "Fold", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: 3164, mac: { primary: 2652 }, weight: 100 }, metadata: { description: "Fold the content in the editor", args: [{ name: "Fold editor argument", description: `Property-value pairs that can be passed through this argument:
							* 'levels': Number of levels to fold.
							* 'direction': If 'up', folds given number of levels up otherwise folds down.
							* 'selectionLines': Array of the start lines (0-based) of the editor selections to apply the fold action to. If not set, the active selection(s) will be used.
							If no levels or direction is set, folds the region at the locations or if already collapsed, the first uncollapsed parent instead.
						`, constraint: n9, schema: { type: "object", properties: { levels: { type: "number" }, direction: { type: "string", enum: ["up", "down"] }, selectionLines: { type: "array", items: { type: "number" } } } } }] } });
  }
  invoke(n, e, t, i) {
    const s = this.getLineNumbers(i, t), o = i && i.levels, r = i && i.direction;
    typeof o != "number" && typeof r != "string" ? (function(a, l, d) {
      const h = [];
      for (const c of d) {
        const u = a.getAllRegionsAtLine(c, ((g) => g.isCollapsed !== l));
        u.length > 0 && h.push(u[0]);
      }
      a.toggleCollapseState(h);
    })(e, !0, s) : r === "up" ? Q6(e, !0, o || 1, s) : op(e, !0, o || 1, s);
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.foldRecursively", label: m(0, "Fold Recursively"), alias: "Fold Recursively", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2140), weight: 100 } });
  }
  invoke(n, e, t) {
    const i = this.getSelectedLines(t);
    op(e, !0, Number.MAX_VALUE, i);
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.foldAll", label: m(0, "Fold All"), alias: "Fold All", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2069), weight: 100 } });
  }
  invoke(n, e, t) {
    op(e, !0);
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.unfoldAll", label: m(0, "Unfold All"), alias: "Unfold All", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2088), weight: 100 } });
  }
  invoke(n, e, t) {
    op(e, !1);
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.foldAllBlockComments", label: m(0, "Fold All Block Comments"), alias: "Fold All Block Comments", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2138), weight: 100 } });
  }
  invoke(n, e, t, i, s) {
    if (e.regions.hasTypes()) Hx(e, ls.Comment.value, !0);
    else {
      const o = t.getModel();
      if (!o) return;
      const r = s.getLanguageConfiguration(o.getLanguageId()).comments;
      r && r.blockCommentStartToken && Vx(e, new RegExp("^\\s*" + No(r.blockCommentStartToken)), !0);
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.foldAllMarkerRegions", label: m(0, "Fold All Regions"), alias: "Fold All Regions", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2077), weight: 100 } });
  }
  invoke(n, e, t, i, s) {
    if (e.regions.hasTypes()) Hx(e, ls.Region.value, !0);
    else {
      const o = t.getModel();
      if (!o) return;
      const r = s.getLanguageConfiguration(o.getLanguageId()).foldingRules;
      r && r.markers && r.markers.start && Vx(e, new RegExp(r.markers.start), !0);
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.unfoldAllMarkerRegions", label: m(0, "Unfold All Regions"), alias: "Unfold All Regions", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2078), weight: 100 } });
  }
  invoke(n, e, t, i, s) {
    if (e.regions.hasTypes()) Hx(e, ls.Region.value, !1);
    else {
      const o = t.getModel();
      if (!o) return;
      const r = s.getLanguageConfiguration(o.getLanguageId()).foldingRules;
      r && r.markers && r.markers.start && Vx(e, new RegExp(r.markers.start), !1);
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.foldAllExcept", label: m(0, "Fold All Except Selected"), alias: "Fold All Except Selected", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2136), weight: 100 } });
  }
  invoke(n, e, t) {
    J6(e, !0, this.getSelectedLines(t));
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.unfoldAllExcept", label: m(0, "Unfold All Except Selected"), alias: "Unfold All Except Selected", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2134), weight: 100 } });
  }
  invoke(n, e, t) {
    J6(e, !1, this.getSelectedLines(t));
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.toggleFold", label: m(0, "Toggle Fold"), alias: "Toggle Fold", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2090), weight: 100 } });
  }
  invoke(n, e, t) {
    Kz(e, 1, this.getSelectedLines(t));
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.gotoParentFold", label: m(0, "Go to Parent Fold"), alias: "Go to Parent Fold", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, weight: 100 } });
  }
  invoke(n, e, t) {
    const i = this.getSelectedLines(t);
    if (i.length > 0) {
      const s = (function(o, r) {
        let a = null;
        const l = r.getRegionAtLine(o);
        if (l !== null && (a = l.startLineNumber, o === a)) {
          const d = l.parentIndex;
          a = d !== -1 ? r.regions.getStartLineNumber(d) : null;
        }
        return a;
      })(i[0], e);
      s !== null && t.setSelection({ startLineNumber: s, startColumn: 1, endLineNumber: s, endColumn: 1 });
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.gotoPreviousFold", label: m(0, "Go to Previous Folding Range"), alias: "Go to Previous Folding Range", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, weight: 100 } });
  }
  invoke(n, e, t) {
    const i = this.getSelectedLines(t);
    if (i.length > 0) {
      const s = (function(o, r) {
        let a = r.getRegionAtLine(o);
        if (a !== null && a.startLineNumber === o) {
          if (o !== a.startLineNumber) return a.startLineNumber;
          {
            const l = a.parentIndex;
            let d = 0;
            for (l !== -1 && (d = r.regions.getStartLineNumber(a.parentIndex)); a !== null; ) {
              if (!(a.regionIndex > 0) || (a = r.regions.toRegion(a.regionIndex - 1), a.startLineNumber <= d)) return null;
              if (a.parentIndex === l) return a.startLineNumber;
            }
          }
        } else if (r.regions.length > 0) for (a = r.regions.toRegion(r.regions.length - 1); a !== null; ) {
          if (a.startLineNumber < o) return a.startLineNumber;
          a = a.regionIndex > 0 ? r.regions.toRegion(a.regionIndex - 1) : null;
        }
        return null;
      })(i[0], e);
      s !== null && t.setSelection({ startLineNumber: s, startColumn: 1, endLineNumber: s, endColumn: 1 });
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.gotoNextFold", label: m(0, "Go to Next Folding Range"), alias: "Go to Next Folding Range", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, weight: 100 } });
  }
  invoke(n, e, t) {
    const i = this.getSelectedLines(t);
    if (i.length > 0) {
      const s = (function(o, r) {
        let a = r.getRegionAtLine(o);
        if (a !== null && a.startLineNumber === o) {
          const l = a.parentIndex;
          let d = 0;
          if (l !== -1) d = r.regions.getEndLineNumber(a.parentIndex);
          else {
            if (r.regions.length === 0) return null;
            d = r.regions.getEndLineNumber(r.regions.length - 1);
          }
          for (; a !== null; ) {
            if (!(a.regionIndex < r.regions.length) || (a = r.regions.toRegion(a.regionIndex + 1), a.startLineNumber >= d)) return null;
            if (a.parentIndex === l) return a.startLineNumber;
          }
        } else if (r.regions.length > 0) for (a = r.regions.toRegion(0); a !== null; ) {
          if (a.startLineNumber > o) return a.startLineNumber;
          a = a.regionIndex < r.regions.length ? r.regions.toRegion(a.regionIndex + 1) : null;
        }
        return null;
      })(i[0], e);
      s !== null && t.setSelection({ startLineNumber: s, startColumn: 1, endLineNumber: s, endColumn: 1 });
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.createFoldingRangeFromSelection", label: m(0, "Create Folding Range from Selection"), alias: "Create Folding Range from Selection", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2135), weight: 100 } });
  }
  invoke(n, e, t) {
    var i;
    const s = [], o = t.getSelections();
    if (o) {
      for (const r of o) {
        let a = r.endLineNumber;
        r.endColumn === 1 && --a, a > r.startLineNumber && (s.push({ startLineNumber: r.startLineNumber, endLineNumber: a, type: void 0, isCollapsed: !0, source: 1 }), t.setSelection({ startLineNumber: r.startLineNumber, startColumn: 1, endLineNumber: r.startLineNumber, endColumn: 1 }));
      }
      if (s.length > 0) {
        s.sort(((a, l) => a.startLineNumber - l.startLineNumber));
        const r = go.sanitizeAndMerge(e.regions, s, (i = t.getModel()) === null || i === void 0 ? void 0 : i.getLineCount());
        e.updatePost(go.fromFoldRanges(r));
      }
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.removeManualFoldingRanges", label: m(0, "Remove Manual Folding Ranges"), alias: "Remove Manual Folding Ranges", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2137), weight: 100 } });
  }
  invoke(n, e, t) {
    const i = t.getSelections();
    if (i) {
      const s = [];
      for (const o of i) {
        const { startLineNumber: r, endLineNumber: a } = o;
        s.push(a >= r ? { startLineNumber: r, endLineNumber: a } : { endLineNumber: a, startLineNumber: r });
      }
      e.removeManualRanges(s), n.triggerFoldingModelChanged();
    }
  }
});
for (let n = 1; n <= 7; n++) s9 = new Qu({ id: Qu.ID(n), label: m(0, "Fold Level {0}", n), alias: `Fold Level ${n}`, precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2048 | 21 + n), weight: 100 } }), Ho.INSTANCE.registerEditorAction(s9);
var s9;
dt.registerCommand("_executeFoldingRangeProvider", (async function(n, ...e) {
  const [t] = e;
  if (!(t instanceof Ie)) throw Yo();
  const i = n.get(fe), s = n.get(ni).getModel(t);
  if (!s) throw Yo();
  const o = n.get(Ye);
  if (!o.getValue("editor.folding", { resource: t })) return [];
  const r = n.get(zt), a = o.getValue("editor.foldingStrategy", { resource: t }), l = { get limit() {
    return o.getValue("editor.foldingMaximumRegions", { resource: t });
  }, update: (g, p) => {
  } }, d = new DP(s, r, l);
  let h = d;
  if (a !== "indentation") {
    const g = Id.getFoldingRangeProviders(i, s);
    g.length && (h = new xP(s, g, (() => {
    }), l, d));
  }
  const c = await h.compute(et.None), u = [];
  try {
    if (c) for (let g = 0; g < c.length; g++) {
      const p = c.getType(g);
      u.push({ start: c.getStartLineNumber(g), end: c.getEndLineNumber(g), kind: p ? ls.fromValue(p) : void 0 });
    }
    return u;
  } finally {
    h.dispose();
  }
}));
X(class extends he {
  constructor() {
    super({ id: "editor.action.fontZoomIn", label: m(0, "Increase Editor Font Size"), alias: "Increase Editor Font Size", precondition: void 0 });
  }
  run(n, e) {
    Vo.setZoomLevel(Vo.getZoomLevel() + 1);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.fontZoomOut", label: m(0, "Decrease Editor Font Size"), alias: "Decrease Editor Font Size", precondition: void 0 });
  }
  run(n, e) {
    Vo.setZoomLevel(Vo.getZoomLevel() - 1);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.fontZoomReset", label: m(0, "Reset Editor Font Size"), alias: "Reset Editor Font Size", precondition: void 0 });
  }
  run(n, e) {
    Vo.setZoomLevel(0);
  }
});
var qz = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, N0 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let E0 = class {
  constructor(n, e, t, i) {
    this._editor = n, this._languageFeaturesService = e, this._workerService = t, this._accessibilitySignalService = i, this._disposables = new G(), this._sessionDisposables = new G(), this._disposables.add(e.onTypeFormattingEditProvider.onDidChange(this._update, this)), this._disposables.add(n.onDidChangeModel((() => this._update()))), this._disposables.add(n.onDidChangeModelLanguage((() => this._update()))), this._disposables.add(n.onDidChangeConfiguration(((s) => {
      s.hasChanged(56) && this._update();
    }))), this._update();
  }
  dispose() {
    this._disposables.dispose(), this._sessionDisposables.dispose();
  }
  _update() {
    if (this._sessionDisposables.clear(), !this._editor.getOption(56) || !this._editor.hasModel()) return;
    const n = this._editor.getModel(), [e] = this._languageFeaturesService.onTypeFormattingEditProvider.ordered(n);
    if (!e || !e.autoFormatTriggerCharacters) return;
    const t = new Xw();
    for (const i of e.autoFormatTriggerCharacters) t.add(i.charCodeAt(0));
    this._sessionDisposables.add(this._editor.onDidType(((i) => {
      const s = i.charCodeAt(i.length - 1);
      t.has(s) && this._trigger(String.fromCharCode(s));
    })));
  }
  _trigger(n) {
    if (!this._editor.hasModel() || this._editor.getSelections().length > 1 || !this._editor.getSelection().isEmpty()) return;
    const e = this._editor.getModel(), t = this._editor.getPosition(), i = new Ci(), s = this._editor.onDidChangeModelContent(((o) => {
      if (o.isFlush) return i.cancel(), void s.dispose();
      for (let r = 0, a = o.changes.length; r < a; r++)
        if (o.changes[r].range.endLineNumber <= t.lineNumber) return i.cancel(), void s.dispose();
    }));
    oH(this._workerService, this._languageFeaturesService, e, t, n, e.getFormattingOptions(), i.token).then(((o) => {
      i.token.isCancellationRequested || zn(o) && (this._accessibilitySignalService.playSignal(He.format, { userGesture: !1 }), rf.execute(this._editor, o, !0));
    })).finally((() => {
      s.dispose();
    }));
  }
};
E0.ID = "editor.contrib.autoFormat", E0 = qz([N0(1, fe), N0(2, Qo), N0(3, Oc)], E0);
let I0 = class {
  constructor(n, e, t) {
    this.editor = n, this._languageFeaturesService = e, this._instantiationService = t, this._callOnDispose = new G(), this._callOnModel = new G(), this._callOnDispose.add(n.onDidChangeConfiguration((() => this._update()))), this._callOnDispose.add(n.onDidChangeModel((() => this._update()))), this._callOnDispose.add(n.onDidChangeModelLanguage((() => this._update()))), this._callOnDispose.add(e.documentRangeFormattingEditProvider.onDidChange(this._update, this));
  }
  dispose() {
    this._callOnDispose.dispose(), this._callOnModel.dispose();
  }
  _update() {
    this._callOnModel.clear(), this.editor.getOption(55) && this.editor.hasModel() && this._languageFeaturesService.documentRangeFormattingEditProvider.has(this.editor.getModel()) && this._callOnModel.add(this.editor.onDidPaste((({ range: n }) => this._trigger(n))));
  }
  _trigger(n) {
    this.editor.hasModel() && (this.editor.getSelections().length > 1 || this._instantiationService.invokeFunction(sH, this.editor, n, 2, Nd.None, et.None, !1).catch(We));
  }
};
I0.ID = "editor.contrib.formatOnPaste", I0 = qz([N0(1, fe), N0(2, Se)], I0);
ft(E0.ID, E0, 2), ft(I0.ID, I0, 2), X(class extends he {
  constructor() {
    super({ id: "editor.action.formatDocument", label: m(0, "Format Document"), alias: "Format Document", precondition: q.and(E.notInCompositeEditor, E.writable, E.hasDocumentFormattingProvider), kbOpts: { kbExpr: E.editorTextFocus, primary: 1572, linux: { primary: 3111 }, weight: 100 }, contextMenuOpts: { group: "1_modification", order: 1.3 } });
  }
  async run(n, e) {
    if (e.hasModel()) {
      const t = n.get(Se);
      await n.get(Nc).showWhile(t.invokeFunction(_oe, e, 1, Nd.None, et.None, !0), 250);
    }
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.formatSelection", label: m(0, "Format Selection"), alias: "Format Selection", precondition: q.and(E.writable, E.hasDocumentSelectionFormattingProvider), kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2084), weight: 100 }, contextMenuOpts: { when: E.hasNonEmptySelection, group: "1_modification", order: 1.31 } });
  }
  async run(n, e) {
    if (!e.hasModel()) return;
    const t = n.get(Se), i = e.getModel(), s = e.getSelections().map(((r) => r.isEmpty() ? new D(r.startLineNumber, 1, r.startLineNumber, i.getLineMaxColumn(r.startLineNumber)) : r));
    await n.get(Nc).showWhile(t.invokeFunction(sH, e, s, 1, Nd.None, et.None, !0), 250);
  }
}), dt.registerCommand("editor.action.format", (async (n) => {
  const e = n.get(mt).getFocusedCodeEditor();
  if (!e || !e.hasModel()) return;
  const t = n.get(ai);
  e.getSelection().isEmpty() ? await t.executeCommand("editor.action.formatDocument") : await t.executeCommand("editor.action.formatSelection");
}));
var kle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ux = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class jp {
  remove() {
    var e;
    (e = this.parent) === null || e === void 0 || e.children.delete(this.id);
  }
  static findId(e, t) {
    let i;
    typeof e == "string" ? i = `${t.id}/${e}` : (i = `${t.id}/${e.name}`, t.children.get(i) !== void 0 && (i = `${t.id}/${e.name}_${e.range.startLineNumber}_${e.range.startColumn}`));
    let s = i;
    for (let o = 0; t.children.get(s) !== void 0; o++) s = `${i}_${o}`;
    return s;
  }
  static empty(e) {
    return e.children.size === 0;
  }
}
class ZM extends jp {
  constructor(e, t, i) {
    super(), this.id = e, this.parent = t, this.symbol = i, this.children = /* @__PURE__ */ new Map();
  }
}
class $z extends jp {
  constructor(e, t, i, s) {
    super(), this.id = e, this.parent = t, this.label = i, this.order = s, this.children = /* @__PURE__ */ new Map();
  }
}
class Zl extends jp {
  static create(e, t, i) {
    const s = new Ci(i), o = new Zl(t.uri), r = e.ordered(t), a = r.map(((d, h) => {
      var c;
      const u = jp.findId(`provider_${h}`, o), g = new $z(u, o, (c = d.displayName) !== null && c !== void 0 ? c : "Unknown Outline Provider", h);
      return Promise.resolve(d.provideDocumentSymbols(t, s.token)).then(((p) => {
        for (const f of p || []) Zl._makeOutlineElement(f, g);
        return g;
      }), ((p) => (Ni(p), g))).then(((p) => {
        jp.empty(p) ? p.remove() : o._groups.set(u, p);
      }));
    })), l = e.onDidChange((() => {
      ri(e.ordered(t), r) || s.cancel();
    }));
    return Promise.all(a).then((() => s.token.isCancellationRequested && !i.isCancellationRequested ? Zl.create(e, t, i) : o._compact())).finally((() => {
      s.dispose(), l.dispose(), s.dispose();
    }));
  }
  static _makeOutlineElement(e, t) {
    const i = jp.findId(e, t), s = new ZM(i, t, e);
    if (e.children) for (const o of e.children) Zl._makeOutlineElement(o, s);
    t.children.set(s.id, s);
  }
  constructor(e) {
    super(), this.uri = e, this.id = "root", this.parent = void 0, this._groups = /* @__PURE__ */ new Map(), this.children = /* @__PURE__ */ new Map(), this.id = "root", this.parent = void 0;
  }
  _compact() {
    let e = 0;
    for (const [t, i] of this._groups) i.children.size === 0 ? this._groups.delete(t) : e += 1;
    if (e !== 1) this.children = this._groups;
    else {
      const t = at.first(this._groups.values());
      for (const [, i] of t.children) i.parent = this, this.children.set(i.id, i);
    }
    return this;
  }
  getTopLevelSymbols() {
    const e = [];
    for (const t of this.children.values()) t instanceof ZM ? e.push(t.symbol) : e.push(...at.map(t.children.values(), ((i) => i.symbol)));
    return e.sort(((t, i) => D.compareRangesUsingStarts(t.range, i.range)));
  }
  asListOfDocumentSymbols() {
    const e = this.getTopLevelSymbols(), t = [];
    return Zl._flattenDocumentSymbols(t, e, ""), t.sort(((i, s) => W.compare(D.getStartPosition(i.range), D.getStartPosition(s.range)) || W.compare(D.getEndPosition(s.range), D.getEndPosition(i.range))));
  }
  static _flattenDocumentSymbols(e, t, i) {
    for (const s of t) e.push({ kind: s.kind, tags: s.tags, name: s.name, detail: s.detail, containerName: s.containerName || i, range: s.range, selectionRange: s.selectionRange, children: void 0 }), s.children && Zl._flattenDocumentSymbols(e, s.children, s.name);
  }
}
const t1 = tt("IOutlineModelService");
let Kx = class {
  constructor(n, e, t) {
    this._languageFeaturesService = n, this._disposables = new G(), this._cache = new Ll(10, 0.7), this._debounceInformation = e.for(n.documentSymbolProvider, "DocumentSymbols", { min: 350 }), this._disposables.add(t.onModelRemoved(((i) => {
      this._cache.delete(i.id);
    })));
  }
  dispose() {
    this._disposables.dispose();
  }
  async getOrCreate(n, e) {
    const t = this._languageFeaturesService.documentSymbolProvider, i = t.ordered(n);
    let s = this._cache.get(n.id);
    if (!s || s.versionId !== n.getVersionId() || !ri(s.provider, i)) {
      const r = new Ci();
      s = { versionId: n.getVersionId(), provider: i, promiseCnt: 0, source: r, promise: Zl.create(t, n, r.token), model: void 0 }, this._cache.set(n.id, s);
      const a = Date.now();
      s.promise.then(((l) => {
        s.model = l, this._debounceInformation.update(n, Date.now() - a);
      })).catch(((l) => {
        this._cache.delete(n.id);
      }));
    }
    if (s.model) return s.model;
    s.promiseCnt += 1;
    const o = e.onCancellationRequested((() => {
      --s.promiseCnt == 0 && (s.source.cancel(), this._cache.delete(n.id));
    }));
    try {
      return await s.promise;
    } finally {
      o.dispose();
    }
  }
};
Kx = kle([Ux(0, fe), Ux(1, ar), Ux(2, ni)], Kx), rt(t1, Kx, 1), dt.registerCommand("_executeDocumentSymbolProvider", (async function(n, ...e) {
  const [t] = e;
  vt(Ie.isUri(t));
  const i = n.get(t1), s = n.get(Ps), o = await s.createModelReference(t);
  try {
    return (await i.getOrCreate(o.object.textEditorModel, et.None)).getTopLevelSymbols();
  } finally {
    o.dispose();
  }
}));
class un extends V {
  constructor(e, t) {
    super(), this.contextKeyService = e, this.model = t, this.inlineCompletionVisible = un.inlineSuggestionVisible.bindTo(this.contextKeyService), this.inlineCompletionSuggestsIndentation = un.inlineSuggestionHasIndentation.bindTo(this.contextKeyService), this.inlineCompletionSuggestsIndentationLessThanTabSize = un.inlineSuggestionHasIndentationLessThanTabSize.bindTo(this.contextKeyService), this.suppressSuggestions = un.suppressSuggestions.bindTo(this.contextKeyService), this._register(Ge(((i) => {
      const s = this.model.read(i), o = s?.state.read(i), r = !!o?.inlineCompletion && o?.primaryGhostText !== void 0 && !o?.primaryGhostText.isEmpty();
      this.inlineCompletionVisible.set(r), o?.primaryGhostText && o?.inlineCompletion && this.suppressSuggestions.set(o.inlineCompletion.inlineCompletion.source.inlineCompletions.suppressSuggestions);
    }))), this._register(Ge(((i) => {
      const s = this.model.read(i);
      let o = !1, r = !0;
      const a = s?.primaryGhostText.read(i);
      if (s?.selectedSuggestItem && a && a.parts.length > 0) {
        const { column: l, lines: d } = a.parts[0], h = d[0];
        if (l <= s.textModel.getLineIndentColumn(a.lineNumber)) {
          let c = Jn(h);
          c === -1 && (c = h.length - 1), o = c > 0;
          const u = s.textModel.getOptions().tabSize;
          r = Gi.visibleColumnFromColumn(h, c + 1, u) < u;
        }
      }
      this.inlineCompletionSuggestsIndentation.set(o), this.inlineCompletionSuggestsIndentationLessThanTabSize.set(r);
    })));
  }
}
un.inlineSuggestionVisible = new ae("inlineSuggestionVisible", !1, m(0, "Whether an inline suggestion is visible")), un.inlineSuggestionHasIndentation = new ae("inlineSuggestionHasIndentation", !1, m(0, "Whether the inline suggestion starts with whitespace")), un.inlineSuggestionHasIndentationLessThanTabSize = new ae("inlineSuggestionHasIndentationLessThanTabSize", !0, m(0, "Whether the inline suggestion starts with whitespace that is less than what would be inserted by tab")), un.suppressSuggestions = new ae("inlineSuggestionSuppressSuggestions", void 0, m(0, "Whether suggestions should be suppressed for the current suggestion"));
class i1 {
  constructor(e, t) {
    this.lineNumber = e, this.parts = t;
  }
  equals(e) {
    return this.lineNumber === e.lineNumber && this.parts.length === e.parts.length && this.parts.every(((t, i) => t.equals(e.parts[i])));
  }
  renderForScreenReader(e) {
    if (this.parts.length === 0) return "";
    const t = this.parts[this.parts.length - 1], i = e.substr(0, t.column - 1);
    return new eP([...this.parts.map(((s) => new Bd(D.fromPositions(new W(1, s.column)), s.lines.join(`
`))))]).applyToString(i).substring(this.parts[0].column - 1);
  }
  isEmpty() {
    return this.parts.every(((e) => e.lines.length === 0));
  }
  get lineCount() {
    return 1 + this.parts.reduce(((e, t) => e + t.lines.length - 1), 0);
  }
}
class wS {
  constructor(e, t, i) {
    this.column = e, this.text = t, this.preview = i, this.lines = Sl(this.text);
  }
  equals(e) {
    return this.column === e.column && this.lines.length === e.lines.length && this.lines.every(((t, i) => t === e.lines[i]));
  }
}
class YM {
  constructor(e, t, i, s = 0) {
    this.lineNumber = e, this.columnRange = t, this.text = i, this.additionalReservedLineCount = s, this.parts = [new wS(this.columnRange.endColumnExclusive, this.text, !1)], this.newLines = Sl(this.text);
  }
  renderForScreenReader(e) {
    return this.newLines.join(`
`);
  }
  get lineCount() {
    return this.newLines.length;
  }
  isEmpty() {
    return this.parts.every(((e) => e.lines.length === 0));
  }
  equals(e) {
    return this.lineNumber === e.lineNumber && this.columnRange.equals(e.columnRange) && this.newLines.length === e.newLines.length && this.newLines.every(((t, i) => t === e.newLines[i])) && this.additionalReservedLineCount === e.additionalReservedLineCount;
  }
}
function o9(n, e) {
  return ri(n, e, Gz);
}
function Gz(n, e) {
  return n === e || !(!n || !e) && (n instanceof i1 && e instanceof i1 || n instanceof YM && e instanceof YM) && n.equals(e);
}
const Dle = [];
class Zz {
  constructor(e, t) {
    if (this.startColumn = e, this.endColumnExclusive = t, e > t) throw new Kt(`startColumn ${e} cannot be after endColumnExclusive ${t}`);
  }
  toRange(e) {
    return new D(e, this.startColumn, e, this.endColumnExclusive);
  }
  equals(e) {
    return this.startColumn === e.startColumn && this.endColumnExclusive === e.endColumnExclusive;
  }
}
function Yz(n, e) {
  const t = new G(), i = n.createDecorationsCollection();
  return t.add(LL({ debugName: () => `Apply decorations from ${e.debugName}` }, ((s) => {
    const o = e.read(s);
    i.set(o);
  }))), t.add({ dispose: () => {
    i.clear();
  } }), t;
}
function r9(n, e) {
  return new W(n.lineNumber - e.lineNumber + 1, n.lineNumber - e.lineNumber == 0 ? n.column - e.column + 1 : n.column);
}
var xle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Nle = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const a9 = "ghost-text";
let XM = class extends V {
  constructor(n, e, t) {
    super(), this.editor = n, this.model = e, this.languageService = t, this.isDisposed = lt(this, !1), this.currentTextModel = Rt(this.editor.onDidChangeModel, (() => this.editor.getModel())), this.uiState = Fe(this, ((i) => {
      if (this.isDisposed.read(i)) return;
      const s = this.currentTextModel.read(i);
      if (s !== this.model.targetTextModel.read(i)) return;
      const o = this.model.ghostText.read(i);
      if (!o) return;
      const r = o instanceof YM ? o.columnRange : void 0, a = [], l = [];
      function d(p, f) {
        if (l.length > 0) {
          const _ = l[l.length - 1];
          f && _.decorations.push(new _s(_.content.length + 1, _.content.length + 1 + p[0].length, f, 0)), _.content += p[0], p = p.slice(1);
        }
        for (const _ of p) l.push({ content: _, decorations: f ? [new _s(1, _.length + 1, f, 0)] : [] });
      }
      const h = s.getLineContent(o.lineNumber);
      let c, u = 0;
      for (const p of o.parts) {
        let f = p.lines;
        c === void 0 ? (a.push({ column: p.column, text: f[0], preview: p.preview }), f = f.slice(1)) : d([h.substring(u, p.column - 1)], void 0), f.length > 0 && (d(f, a9), c === void 0 && p.column <= h.length && (c = p.column)), u = p.column - 1;
      }
      c !== void 0 && d([h.substring(u)], void 0);
      const g = c !== void 0 ? new Zz(c, h.length + 1) : void 0;
      return { replacedRange: r, inlineTexts: a, additionalLines: l, hiddenRange: g, lineNumber: o.lineNumber, additionalReservedLineCount: this.model.minReservedLineCount.read(i), targetTextModel: s };
    })), this.decorations = Fe(this, ((i) => {
      const s = this.uiState.read(i);
      if (!s) return [];
      const o = [];
      s.replacedRange && o.push({ range: s.replacedRange.toRange(s.lineNumber), options: { inlineClassName: "inline-completion-text-to-replace", description: "GhostTextReplacement" } }), s.hiddenRange && o.push({ range: s.hiddenRange.toRange(s.lineNumber), options: { inlineClassName: "ghost-text-hidden", description: "ghost-text-hidden" } });
      for (const r of s.inlineTexts) o.push({ range: D.fromPositions(new W(s.lineNumber, r.column)), options: { description: a9, after: { content: r.text, inlineClassName: r.preview ? "ghost-text-decoration-preview" : "ghost-text-decoration", cursorStops: vr.Left }, showIfCollapsed: !0 } });
      return o;
    })), this.additionalLinesWidget = this._register(new Xz(this.editor, this.languageService.languageIdCodec, Fe(((i) => {
      const s = this.uiState.read(i);
      return s ? { lineNumber: s.lineNumber, additionalLines: s.additionalLines, minReservedLineCount: s.additionalReservedLineCount, targetTextModel: s.targetTextModel } : void 0;
    })))), this._register(ye((() => {
      this.isDisposed.set(!0, void 0);
    }))), this._register(Yz(this.editor, this.decorations));
  }
  ownsViewZone(n) {
    return this.additionalLinesWidget.viewZoneId === n;
  }
};
XM = xle([Nle(2, Xt)], XM);
class Xz extends V {
  get viewZoneId() {
    return this._viewZoneId;
  }
  constructor(e, t, i) {
    super(), this.editor = e, this.languageIdCodec = t, this.lines = i, this._viewZoneId = void 0, this.editorOptionsChanged = Hn("editorOptionChanged", se.filter(this.editor.onDidChangeConfiguration, ((s) => s.hasChanged(33) || s.hasChanged(117) || s.hasChanged(99) || s.hasChanged(94) || s.hasChanged(51) || s.hasChanged(50) || s.hasChanged(67)))), this._register(Ge(((s) => {
      const o = this.lines.read(s);
      this.editorOptionsChanged.read(s), o ? this.updateLines(o.lineNumber, o.additionalLines, o.minReservedLineCount) : this.clear();
    })));
  }
  dispose() {
    super.dispose(), this.clear();
  }
  clear() {
    this.editor.changeViewZones(((e) => {
      this._viewZoneId && (e.removeZone(this._viewZoneId), this._viewZoneId = void 0);
    }));
  }
  updateLines(e, t, i) {
    const s = this.editor.getModel();
    if (!s) return;
    const { tabSize: o } = s.getOptions();
    this.editor.changeViewZones(((r) => {
      this._viewZoneId && (r.removeZone(this._viewZoneId), this._viewZoneId = void 0);
      const a = Math.max(t.length, i);
      if (a > 0) {
        const l = document.createElement("div");
        (function(d, h, c, u, g) {
          const p = u.get(33), f = u.get(117), _ = "none", v = u.get(94), b = u.get(51), C = u.get(50), w = u.get(67), y = new pf(1e4);
          y.appendString('<div class="suggest-preview-text">');
          for (let N = 0, A = c.length; N < A; N++) {
            const B = c[N], T = B.content;
            y.appendString('<div class="view-line'), y.appendString('" style="top:'), y.appendString(String(N * w)), y.appendString('px;width:1000000px;">');
            const O = p1(T), H = Pm(T), $ = nn.createEmpty(T, g);
            C1(new Sc(C.isMonospace && !p, C.canUseHalfwidthRightwardsArrow, T, !1, O, H, 0, $, B.decorations, h, 0, C.spaceWidth, C.middotWidth, C.wsmiddotWidth, f, _, v, b !== fo.OFF, null), y), y.appendString("</div>");
          }
          y.appendString("</div>"), yn(d, C);
          const L = y.build(), k = l9 ? l9.createHTML(L) : L;
          d.innerHTML = k;
        })(l, o, t, this.editor.getOptions(), this.languageIdCodec), this._viewZoneId = r.addZone({ afterLineNumber: e, heightInLines: a, domNode: l, afterColumnAffinity: 1 });
      }
    }));
  }
}
const l9 = Hd("editorGhostText", { createHTML: (n) => n });
class Ele {
  constructor(e) {
    this.lines = e, this.tokenization = { getLineTokens: (t) => this.lines[t - 1] };
  }
  getLineCount() {
    return this.lines.length;
  }
  getLineLength(e) {
    return this.lines[e - 1].getLineContent().length;
  }
}
async function Ile(n, e, t, i, s = et.None, o) {
  const r = (function(v, b) {
    const C = b.getWordAtPosition(v), w = b.getLineMaxColumn(v.lineNumber);
    return C ? new D(v.lineNumber, C.startColumn, v.lineNumber, w) : D.fromPositions(v, v.with(void 0, w));
  })(e, t), a = n.all(t), l = new wR();
  for (const v of a) v.groupId && l.add(v.groupId, v);
  function d(v) {
    if (!v.yieldsToGroupIds) return [];
    const b = [];
    for (const C of v.yieldsToGroupIds || []) {
      const w = l.get(C);
      for (const y of w) b.push(y);
    }
    return b;
  }
  const h = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Set();
  function u(v, b) {
    if (b = [...b, v], c.has(v)) return b;
    c.add(v);
    try {
      const C = d(v);
      for (const w of C) {
        const y = u(w, b);
        if (y) return y;
      }
    } finally {
      c.delete(v);
    }
  }
  function g(v) {
    const b = h.get(v);
    if (b) return b;
    const C = u(v, []);
    C && Ni(new Error(`Inline completions: cyclic yield-to dependency detected. Path: ${C.map(((y) => y.toString ? y.toString() : "" + y)).join(" -> ")}`));
    const w = new _1();
    return h.set(v, w.p), (async () => {
      if (!C) {
        const y = d(v);
        for (const L of y) {
          const k = await g(L);
          if (k && k.items.length > 0) return;
        }
      }
      try {
        return await v.provideInlineCompletions(t, e, i, s);
      } catch (y) {
        return void Ni(y);
      }
    })().then(((y) => w.complete(y)), ((y) => w.error(y))), w.p;
  }
  const p = await Promise.all(a.map((async (v) => ({ provider: v, completions: await g(v) })))), f = /* @__PURE__ */ new Map(), _ = [];
  for (const v of p) {
    const b = v.completions;
    if (!b) continue;
    const C = new Tle(b, v.provider);
    _.push(C);
    for (const w of b.items) {
      const y = yS.from(w, C, r, t, o);
      f.set(y.hash(), y);
    }
  }
  return new Mle(Array.from(f.values()), new Set(f.keys()), _);
}
class Mle {
  constructor(e, t, i) {
    this.completions = e, this.hashs = t, this.providerResults = i;
  }
  has(e) {
    return this.hashs.has(e.hash());
  }
  dispose() {
    for (const e of this.providerResults) e.removeRef();
  }
}
class Tle {
  constructor(e, t) {
    this.inlineCompletions = e, this.provider = t, this.refCount = 1;
  }
  addRef() {
    this.refCount++;
  }
  removeRef() {
    this.refCount--, this.refCount === 0 && this.provider.freeInlineCompletions(this.inlineCompletions);
  }
}
class yS {
  static from(e, t, i, s, o) {
    let r, a, l = e.range ? D.lift(e.range) : i;
    if (typeof e.insertText == "string") {
      if (r = e.insertText, o && e.completeBracketPairs) {
        r = d9(r, l.getStartPosition(), s, o);
        const d = r.length - e.insertText.length;
        d !== 0 && (l = new D(l.startLineNumber, l.startColumn, l.endLineNumber, l.endColumn + d));
      }
      a = void 0;
    } else if ("snippet" in e.insertText) {
      const d = e.insertText.snippet.length;
      if (o && e.completeBracketPairs) {
        e.insertText.snippet = d9(e.insertText.snippet, l.getStartPosition(), s, o);
        const c = e.insertText.snippet.length - d;
        c !== 0 && (l = new D(l.startLineNumber, l.startColumn, l.endLineNumber, l.endColumn + c));
      }
      const h = new bg().parse(e.insertText.snippet);
      h.children.length === 1 && h.children[0] instanceof hs ? (r = h.children[0].value, a = void 0) : (r = h.toString(), a = { snippet: e.insertText.snippet, range: l });
    } else XS(e.insertText);
    return new yS(r, e.command, l, r, a, e.additionalTextEdits || Dle, e, t);
  }
  constructor(e, t, i, s, o, r, a, l) {
    this.filterText = e, this.command = t, this.range = i, this.insertText = s, this.snippetInfo = o, this.additionalTextEdits = r, this.sourceInlineCompletion = a, this.source = l, s = (e = e.replace(/\r\n|\r/g, `
`)).replace(/\r\n|\r/g, `
`);
  }
  withRange(e) {
    return new yS(this.filterText, this.command, e, this.insertText, this.snippetInfo, this.additionalTextEdits, this.sourceInlineCompletion, this.source);
  }
  hash() {
    return JSON.stringify({ insertText: this.insertText, range: this.range.toString() });
  }
}
function d9(n, e, t, i) {
  const s = t.getLineContent(e.lineNumber).substring(0, e.column - 1) + n, o = t.tokenization.tokenizeLineWithEdit(e, s.length - (e.column - 1), n), r = o?.sliceAndInflate(e.column - 1, s.length, 0);
  return r ? (function(l, d) {
    const h = new YB(), c = new QB(h, ((f) => d.getLanguageConfiguration(f))), u = lI(new XB(new Ele([l]), c), [], void 0, !0);
    let g = "";
    const p = l.getLineContent();
    return (function f(_, v) {
      if (_.kind === 2) if (f(_.openingBracket, v), v = gi(v, _.openingBracket.length), _.child && (f(_.child, v), v = gi(v, _.child.length)), _.closingBracket) f(_.closingBracket, v), v = gi(v, _.closingBracket.length);
      else {
        const b = c.getSingleLanguageBracketTokens(_.openingBracket.languageId).findClosingTokenText(_.openingBracket.bracketIds);
        g += b;
      }
      else if (_.kind !== 3) {
        if (_.kind === 0 || _.kind === 1) g += p.substring(v, gi(v, _.length));
        else if (_.kind === 4) for (const b of _.children) f(b, v), v = gi(v, b.length);
      }
    })(u, vs), g;
  })(r, i) : n;
}
function Ju(n, e, t) {
  const i = t ? n.range.intersectRanges(t) : n.range;
  if (!i) return n;
  const s = e.getValueInRange(i, 1), o = mc(s, n.text), r = kr.ofText(s.substring(0, o)).addToPosition(n.range.getStartPosition()), a = n.text.substring(o), l = D.fromPositions(r, n.range.getEndPosition());
  return new Bd(l, a);
}
function Qz(n, e) {
  return n.text.startsWith(e.text) && (t = n.range, (i = e.range).getStartPosition().equals(t.getStartPosition()) && i.getEndPosition().isBeforeOrEqual(t.getEndPosition()));
  var t, i;
}
function h9(n, e, t, i, s = 0) {
  let o = Ju(n, e);
  if (o.range.endLineNumber !== o.range.startLineNumber) return;
  const r = e.getLineContent(o.range.startLineNumber), a = Wt(r).length;
  if (o.range.startColumn - 1 <= a) {
    const g = Wt(o.text).length, p = r.substring(o.range.startColumn - 1, a), [f, _] = [o.range.getStartPosition(), o.range.getEndPosition()], v = f.column + p.length <= _.column ? f.delta(0, p.length) : _, b = D.fromPositions(v, _), C = o.text.startsWith(p) ? o.text.substring(p.length) : o.text.substring(g);
    o = new Bd(b, C);
  }
  const l = e.getValueInRange(o.range), d = (function(g, p) {
    if (eu?.originalValue === g && eu?.newValue === p) return eu?.changes;
    {
      let f = u9(g, p, !0);
      if (f) {
        const _ = c9(f);
        if (_ > 0) {
          const v = u9(g, p, !1);
          v && c9(v) < _ && (f = v);
        }
      }
      return eu = { originalValue: g, newValue: p, changes: f }, f;
    }
  })(l, o.text);
  if (!d) return;
  const h = o.range.startLineNumber, c = new Array();
  if (t === "prefix") {
    const g = d.filter(((p) => p.originalLength === 0));
    if (g.length > 1 || g.length === 1 && g[0].originalStart !== l.length) return;
  }
  const u = o.text.length - s;
  for (const g of d) {
    const p = o.range.startColumn + g.originalStart + g.originalLength;
    if (t === "subwordSmart" && i && i.lineNumber === o.range.startLineNumber && p < i.column || g.originalLength > 0) return;
    if (g.modifiedLength === 0) continue;
    const f = g.modifiedStart + g.modifiedLength, _ = Math.max(g.modifiedStart, Math.min(f, u)), v = o.text.substring(g.modifiedStart, _), b = o.text.substring(_, Math.max(g.modifiedStart, f));
    v.length > 0 && c.push(new wS(p, v, !1)), b.length > 0 && c.push(new wS(p, b, !0));
  }
  return new i1(h, c);
}
let eu;
function c9(n) {
  let e = 0;
  for (const t of n) e += t.originalLength;
  return e;
}
function u9(n, e, t) {
  if (n.length > 5e3 || e.length > 5e3) return;
  function i(d) {
    let h = 0;
    for (let c = 0, u = d.length; c < u; c++) {
      const g = d.charCodeAt(c);
      g > h && (h = g);
    }
    return h;
  }
  const s = Math.max(i(n), i(e));
  function o(d) {
    if (d < 0) throw new Error("unexpected");
    return s + d + 1;
  }
  function r(d) {
    let h = 0, c = 0;
    const u = new Int32Array(d.length);
    for (let g = 0, p = d.length; g < p; g++) if (t && d[g] === "(") {
      const f = 100 * c + h;
      u[g] = o(2 * f), h++;
    } else if (t && d[g] === ")") {
      h = Math.max(h - 1, 0);
      const f = 100 * c + h;
      u[g] = o(2 * f + 1), h === 0 && c++;
    } else u[g] = d.charCodeAt(g);
    return u;
  }
  const a = r(n), l = r(e);
  return new qa({ getElements: () => a }, { getElements: () => l }).ComputeDiff(!1).changes;
}
var Rle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, g9 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let QM = class extends V {
  constructor(n, e, t, i, s) {
    super(), this.textModel = n, this.versionId = e, this._debounceValue = t, this.languageFeaturesService = i, this.languageConfigurationService = s, this._updateOperation = this._register(new rn()), this.inlineCompletions = Tv("inlineCompletions", void 0), this.suggestWidgetInlineCompletions = Tv("suggestWidgetInlineCompletions", void 0), this._register(this.textModel.onDidChangeContent((() => {
      this._updateOperation.clear();
    })));
  }
  fetch(n, e, t) {
    var i, s;
    const o = new Ale(n, e, this.textModel.getVersionId()), r = e.selectedSuggestionInfo ? this.suggestWidgetInlineCompletions : this.inlineCompletions;
    if (!((i = this._updateOperation.value) === null || i === void 0) && i.request.satisfies(o)) return this._updateOperation.value.promise;
    if (!((s = r.get()) === null || s === void 0) && s.request.satisfies(o)) return Promise.resolve(!0);
    const a = !!this._updateOperation.value;
    this._updateOperation.clear();
    const l = new Ci(), d = (async () => {
      var c, u;
      if ((a || e.triggerKind === Ld.Automatic) && await (c = this._debounceValue.get(this.textModel), u = l.token, new Promise(((v) => {
        let b;
        const C = setTimeout((() => {
          b && b.dispose(), v();
        }), c);
        u && (b = u.onCancellationRequested((() => {
          clearTimeout(C), b && b.dispose(), v();
        })));
      }))), l.token.isCancellationRequested || this.textModel.getVersionId() !== o.versionId) return !1;
      const g = /* @__PURE__ */ new Date(), p = await Ile(this.languageFeaturesService.inlineCompletionsProvider, n, this.textModel, e, l.token, this.languageConfigurationService);
      if (l.token.isCancellationRequested || this.textModel.getVersionId() !== o.versionId) return !1;
      const f = /* @__PURE__ */ new Date();
      this._debounceValue.update(this.textModel, f.getTime() - g.getTime());
      const _ = new Ole(p, o, this.textModel, this.versionId);
      if (t) {
        const v = t.toInlineCompletion(void 0);
        t.canBeReused(this.textModel, n) && !p.has(v) && _.prepend(t.inlineCompletion, v.range, !0);
      }
      return this._updateOperation.clear(), Tt(((v) => {
        r.set(_, v);
      })), !0;
    })(), h = new Ple(o, l, d);
    return this._updateOperation.value = h, d;
  }
  clear(n) {
    this._updateOperation.clear(), this.inlineCompletions.set(void 0, n), this.suggestWidgetInlineCompletions.set(void 0, n);
  }
  clearSuggestWidgetInlineCompletions(n) {
    var e;
    !((e = this._updateOperation.value) === null || e === void 0) && e.request.context.selectedSuggestionInfo && this._updateOperation.clear(), this.suggestWidgetInlineCompletions.set(void 0, n);
  }
  cancelUpdate() {
    this._updateOperation.clear();
  }
};
QM = Rle([g9(3, fe), g9(4, zt)], QM);
class Ale {
  constructor(e, t, i) {
    this.position = e, this.context = t, this.versionId = i;
  }
  satisfies(e) {
    return this.position.equals(e.position) && (function(t, i, s) {
      return !t || !i ? t === i : s(t, i);
    })(this.context.selectedSuggestionInfo, e.context.selectedSuggestionInfo, ((t, i) => t.equals(i))) && (e.context.triggerKind === Ld.Automatic || this.context.triggerKind === Ld.Explicit) && this.versionId === e.versionId;
  }
}
class Ple {
  constructor(e, t, i) {
    this.request = e, this.cancellationTokenSource = t, this.promise = i;
  }
  dispose() {
    this.cancellationTokenSource.cancel();
  }
}
class Ole {
  get inlineCompletions() {
    return this._inlineCompletions;
  }
  constructor(e, t, i, s) {
    this.inlineCompletionProviderResult = e, this.request = t, this.textModel = i, this.versionId = s, this._refCount = 1, this._prependedInlineCompletionItems = [], this._rangeVersionIdValue = 0, this._rangeVersionId = Fe(this, ((r) => {
      this.versionId.read(r);
      let a = !1;
      for (const l of this._inlineCompletions) a = a || l._updateRange(this.textModel);
      return a && this._rangeVersionIdValue++, this._rangeVersionIdValue;
    }));
    const o = i.deltaDecorations([], e.completions.map(((r) => ({ range: r.range, options: { description: "inline-completion-tracking-range" } }))));
    this._inlineCompletions = e.completions.map(((r, a) => new p9(r, o[a], this._rangeVersionId)));
  }
  clone() {
    return this._refCount++, this;
  }
  dispose() {
    if (this._refCount--, this._refCount === 0) {
      setTimeout((() => {
        this.textModel.isDisposed() || this.textModel.deltaDecorations(this._inlineCompletions.map(((e) => e.decorationId)), []);
      }), 0), this.inlineCompletionProviderResult.dispose();
      for (const e of this._prependedInlineCompletionItems) e.source.removeRef();
    }
  }
  prepend(e, t, i) {
    i && e.source.addRef();
    const s = this.textModel.deltaDecorations([], [{ range: t, options: { description: "inline-completion-tracking-range" } }])[0];
    this._inlineCompletions.unshift(new p9(e, s, this._rangeVersionId, t)), this._prependedInlineCompletionItems.push(e);
  }
}
class p9 {
  get forwardStable() {
    var e;
    return (e = this.inlineCompletion.source.inlineCompletions.enableForwardStability) !== null && e !== void 0 && e;
  }
  constructor(e, t, i, s) {
    this.inlineCompletion = e, this.decorationId = t, this.rangeVersion = i, this.semanticId = JSON.stringify([this.inlineCompletion.filterText, this.inlineCompletion.insertText, this.inlineCompletion.range.getStartPosition().toString()]), this._isValid = !0, this._updatedRange = s ?? e.range;
  }
  toInlineCompletion(e) {
    return this.inlineCompletion.withRange(this._getUpdatedRange(e));
  }
  toSingleTextEdit(e) {
    return new Bd(this._getUpdatedRange(e), this.inlineCompletion.insertText);
  }
  isVisible(e, t, i) {
    const s = Ju(this._toFilterTextReplacement(i), e);
    if (!this._isValid || !this.inlineCompletion.range.getStartPosition().equals(this._getUpdatedRange(i).getStartPosition()) || t.lineNumber !== s.range.startLineNumber) return !1;
    const o = e.getValueInRange(s.range, 1), r = s.text, a = Math.max(0, t.column - s.range.startColumn);
    let l = r.substring(0, a), d = r.substring(a), h = o.substring(0, a), c = o.substring(a);
    const u = e.getLineIndentColumn(s.range.startLineNumber);
    return s.range.startColumn <= u && (h = h.trimStart(), h.length === 0 && (c = c.trimStart()), l = l.trimStart(), l.length === 0 && (d = d.trimStart())), l.startsWith(h) && !!EW(c, d);
  }
  canBeReused(e, t) {
    return this._isValid && this._getUpdatedRange(void 0).containsPosition(t) && this.isVisible(e, t, void 0) && !this._isSmallerThanOriginal(void 0);
  }
  _toFilterTextReplacement(e) {
    return new Bd(this._getUpdatedRange(e), this.inlineCompletion.filterText);
  }
  _isSmallerThanOriginal(e) {
    return m9(this._getUpdatedRange(e)).isBefore(m9(this.inlineCompletion.range));
  }
  _getUpdatedRange(e) {
    return this.rangeVersion.read(e), this._updatedRange;
  }
  _updateRange(e) {
    const t = e.getDecorationRange(this.decorationId);
    return t ? !this._updatedRange.equalsRange(t) && (this._updatedRange = t, !0) : (this._isValid = !1, !0);
  }
}
function m9(n) {
  return n.startLineNumber === n.endLineNumber ? new W(1, 1 + n.endColumn - n.startColumn) : new W(1 + n.endLineNumber - n.startLineNumber, n.endColumn);
}
const $e = { Visible: zM, HasFocusedSuggestion: new ae("suggestWidgetHasFocusedSuggestion", !1, m(0, "Whether any suggestion is focused")), DetailsVisible: new ae("suggestWidgetDetailsVisible", !1, m(0, "Whether suggestion details are visible")), MultipleSuggestions: new ae("suggestWidgetMultipleSuggestions", !1, m(0, "Whether there are multiple suggestions to pick from")), MakesTextEdit: new ae("suggestionMakesTextEdit", !0, m(0, "Whether inserting the current suggestion yields in a change or has everything already been typed")), AcceptSuggestionsOnEnter: new ae("acceptSuggestionOnEnter", !0, m(0, "Whether suggestions are inserted when pressing Enter")), HasInsertAndReplaceRange: new ae("suggestionHasInsertAndReplaceRange", !1, m(0, "Whether the current suggestion has insert and replace behaviour")), InsertMode: new ae("suggestionInsertMode", void 0, { type: "string", description: m(0, "Whether the default behaviour is to insert or replace") }), CanResolve: new ae("suggestionCanResolve", !1, m(0, "Whether the current suggestion supports to resolve further details")) }, dh = new x("suggestWidgetStatusBar");
class Fle {
  constructor(e, t, i, s) {
    var o;
    this.position = e, this.completion = t, this.container = i, this.provider = s, this.isInvalid = !1, this.score = la.Default, this.distance = 0, this.textLabel = typeof t.label == "string" ? t.label : (o = t.label) === null || o === void 0 ? void 0 : o.label, this.labelLow = this.textLabel.toLowerCase(), this.isInvalid = !this.textLabel, this.sortTextLow = t.sortText && t.sortText.toLowerCase(), this.filterTextLow = t.filterText && t.filterText.toLowerCase(), this.extensionId = t.extensionId, D.isIRange(t.range) ? (this.editStart = new W(t.range.startLineNumber, t.range.startColumn), this.editInsertEnd = new W(t.range.endLineNumber, t.range.endColumn), this.editReplaceEnd = new W(t.range.endLineNumber, t.range.endColumn), this.isInvalid = this.isInvalid || D.spansMultipleLines(t.range) || t.range.startLineNumber !== e.lineNumber) : (this.editStart = new W(t.range.insert.startLineNumber, t.range.insert.startColumn), this.editInsertEnd = new W(t.range.insert.endLineNumber, t.range.insert.endColumn), this.editReplaceEnd = new W(t.range.replace.endLineNumber, t.range.replace.endColumn), this.isInvalid = this.isInvalid || D.spansMultipleLines(t.range.insert) || D.spansMultipleLines(t.range.replace) || t.range.insert.startLineNumber !== e.lineNumber || t.range.replace.startLineNumber !== e.lineNumber || t.range.insert.startColumn !== t.range.replace.startColumn), typeof s.resolveCompletionItem != "function" && (this._resolveCache = Promise.resolve(), this._resolveDuration = 0);
  }
  get isResolved() {
    return this._resolveDuration !== void 0;
  }
  get resolveDuration() {
    return this._resolveDuration !== void 0 ? this._resolveDuration : -1;
  }
  async resolve(e) {
    if (!this._resolveCache) {
      const t = e.onCancellationRequested((() => {
        this._resolveCache = void 0, this._resolveDuration = void 0;
      })), i = new Rn(!0);
      this._resolveCache = Promise.resolve(this.provider.resolveCompletionItem(this.completion, e)).then(((s) => {
        Object.assign(this.completion, s), this._resolveDuration = i.elapsed();
      }), ((s) => {
        ya(s) && (this._resolveCache = void 0, this._resolveDuration = void 0);
      })).finally((() => {
        t.dispose();
      }));
    }
    return this._resolveCache;
  }
}
class n1 {
  constructor(e = 2, t = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Map(), o = !0) {
    this.snippetSortOrder = e, this.kindFilter = t, this.providerFilter = i, this.providerItemsToReuse = s, this.showDeprecated = o;
  }
}
n1.default = new n1();
class Ble {
  constructor(e, t, i, s) {
    this.items = e, this.needsClipboard = t, this.durations = i, this.disposable = s;
  }
}
async function NP(n, e, t, i = n1.default, s = { triggerKind: 0 }, o = et.None) {
  const r = new Rn();
  t = t.clone();
  const a = e.getWordAtPosition(t), l = a ? new D(t.lineNumber, a.startColumn, t.lineNumber, a.endColumn) : D.fromPositions(t), d = { replace: l, insert: l.setEndPosition(t.lineNumber, t.column) }, h = [], c = new G(), u = [];
  let g = !1;
  const p = (v, b, C) => {
    var w, y, L;
    let k = !1;
    if (!b) return k;
    for (const N of b.suggestions) if (!i.kindFilter.has(N.kind)) {
      if (!i.showDeprecated && (!((w = N?.tags) === null || w === void 0) && w.includes(1))) continue;
      N.range || (N.range = d), N.sortText || (N.sortText = typeof N.label == "string" ? N.label : N.label.label), !g && N.insertTextRules && 4 & N.insertTextRules && (g = bg.guessNeedsClipboard(N.insertText)), h.push(new Fle(t, N, b, v)), k = !0;
    }
    return YT(b) && c.add(b), u.push({ providerName: (y = v._debugDisplayName) !== null && y !== void 0 ? y : "unknown_provider", elapsedProvider: (L = b.duration) !== null && L !== void 0 ? L : -1, elapsedOverall: C.elapsed() }), k;
  }, f = (async () => {
  })();
  for (const v of n.orderedGroups(e)) {
    let b = !1;
    if (await Promise.all(v.map((async (C) => {
      if (i.providerItemsToReuse.has(C)) {
        const w = i.providerItemsToReuse.get(C);
        return w.forEach(((y) => h.push(y))), void (b = b || w.length > 0);
      }
      if (!(i.providerFilter.size > 0) || i.providerFilter.has(C)) try {
        const w = new Rn(), y = await C.provideCompletionItems(e, t, s, o);
        b = p(C, y, w) || b;
      } catch (w) {
        Ni(w);
      }
    }))), b || o.isCancellationRequested) break;
  }
  return await f, o.isCancellationRequested ? (c.dispose(), Promise.reject(new Vd())) : new Ble(h.sort((_ = i.snippetSortOrder, _w.get(_))), g, { entries: u, elapsed: r.elapsed() }, c);
  var _;
}
function jx(n, e) {
  if (n.sortTextLow && e.sortTextLow) {
    if (n.sortTextLow < e.sortTextLow) return -1;
    if (n.sortTextLow > e.sortTextLow) return 1;
  }
  return n.textLabel < e.textLabel ? -1 : n.textLabel > e.textLabel ? 1 : n.completion.kind - e.completion.kind;
}
const _w = /* @__PURE__ */ new Map();
_w.set(0, (function(n, e) {
  if (n.completion.kind !== e.completion.kind) {
    if (n.completion.kind === 27) return -1;
    if (e.completion.kind === 27) return 1;
  }
  return jx(n, e);
})), _w.set(2, (function(n, e) {
  if (n.completion.kind !== e.completion.kind) {
    if (n.completion.kind === 27) return 1;
    if (e.completion.kind === 27) return -1;
  }
  return jx(n, e);
})), _w.set(1, jx), dt.registerCommand("_executeCompletionItemProvider", (async (n, ...e) => {
  const [t, i, s, o] = e;
  vt(Ie.isUri(t)), vt(W.isIPosition(i)), vt(typeof s == "string" || !s), vt(typeof o == "number" || !o);
  const { completionProvider: r } = n.get(fe), a = await n.get(Ps).createModelReference(t);
  try {
    const l = { incomplete: !1, suggestions: [] }, d = [], h = a.object.textEditorModel.validatePosition(i), c = await NP(r, a.object.textEditorModel, h, void 0, { triggerCharacter: s ?? void 0, triggerKind: s ? 1 : 0 });
    for (const u of c.items) d.length < (o ?? 0) && d.push(u.resolve(et.None)), l.incomplete = l.incomplete || u.container.incomplete, l.suggestions.push(u.completion);
    try {
      return await Promise.all(d), l;
    } finally {
      setTimeout((() => c.disposable.dispose()), 100);
    }
  } finally {
    a.dispose();
  }
}));
class qp {
  static isAllOff(e) {
    return e.other === "off" && e.comments === "off" && e.strings === "off";
  }
  static isAllOn(e) {
    return e.other === "on" && e.comments === "on" && e.strings === "on";
  }
  static valueFor(e, t) {
    switch (t) {
      case 1:
        return e.comments;
      case 2:
        return e.strings;
      default:
        return e.other;
    }
  }
}
function f9(n, e = Tn) {
  return (function(t, i = Tn) {
    return !!i && iW(t.charCodeAt(0)) && t.charCodeAt(1) === 58;
  })(n, e) ? n.charAt(0).toUpperCase() + n.slice(1) : n;
}
var Wle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Vle = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class _9 {
  constructor(e) {
    this._delegates = e;
  }
  resolve(e) {
    for (const t of this._delegates) {
      const i = t.resolve(e);
      if (i !== void 0) return i;
    }
  }
}
class v9 {
  constructor(e, t, i, s) {
    this._model = e, this._selection = t, this._selectionIdx = i, this._overtypingCapturer = s;
  }
  resolve(e) {
    const { name: t } = e;
    if (t === "SELECTION" || t === "TM_SELECTED_TEXT") {
      let i = this._model.getValueInRange(this._selection) || void 0, s = this._selection.startLineNumber !== this._selection.endLineNumber;
      if (!i && this._overtypingCapturer) {
        const o = this._overtypingCapturer.getLastOvertypedInfo(this._selectionIdx);
        o && (i = o.value, s = o.multiline);
      }
      if (i && s && e.snippet) {
        const o = Wt(this._model.getLineContent(this._selection.startLineNumber), 0, this._selection.startColumn - 1);
        let r = o;
        e.snippet.walk(((l) => l !== e && (l instanceof hs && (r = Wt(Sl(l.value).pop())), !0)));
        const a = mc(r, o);
        i = i.replace(/(\r\n|\r|\n)(.*)/g, ((l, d, h) => `${d}${r.substr(a)}${h}`));
      }
      return i;
    }
    if (t === "TM_CURRENT_LINE") return this._model.getLineContent(this._selection.positionLineNumber);
    if (t === "TM_CURRENT_WORD") {
      const i = this._model.getWordAtPosition({ lineNumber: this._selection.positionLineNumber, column: this._selection.positionColumn });
      return i && i.word || void 0;
    }
    return t === "TM_LINE_INDEX" ? String(this._selection.positionLineNumber - 1) : t === "TM_LINE_NUMBER" ? String(this._selection.positionLineNumber) : t === "CURSOR_INDEX" ? String(this._selectionIdx) : t === "CURSOR_NUMBER" ? String(this._selectionIdx + 1) : void 0;
  }
}
class b9 {
  constructor(e, t) {
    this._labelService = e, this._model = t;
  }
  resolve(e) {
    const { name: t } = e;
    if (t === "TM_FILENAME") return xh(this._model.uri.fsPath);
    if (t === "TM_FILENAME_BASE") {
      const i = xh(this._model.uri.fsPath), s = i.lastIndexOf(".");
      return s <= 0 ? i : i.slice(0, s);
    }
    return t === "TM_DIRECTORY" ? U7(this._model.uri.fsPath) === "." ? "" : this._labelService.getUriLabel(uL(this._model.uri)) : t === "TM_FILEPATH" ? this._labelService.getUriLabel(this._model.uri) : t === "RELATIVE_FILEPATH" ? this._labelService.getUriLabel(this._model.uri, { relative: !0, noPrefix: !0 }) : void 0;
  }
}
class C9 {
  constructor(e, t, i, s) {
    this._readClipboardText = e, this._selectionIdx = t, this._selectionCount = i, this._spread = s;
  }
  resolve(e) {
    if (e.name !== "CLIPBOARD") return;
    const t = this._readClipboardText();
    if (t) {
      if (this._spread) {
        const i = t.split(/\r\n|\n|\r/).filter(((s) => !Y7(s)));
        if (i.length === this._selectionCount) return i[this._selectionIdx];
      }
      return t;
    }
  }
}
let SS = class {
  constructor(n, e, t) {
    this._model = n, this._selection = e, this._languageConfigurationService = t;
  }
  resolve(n) {
    const { name: e } = n, t = this._model.getLanguageIdAtPosition(this._selection.selectionStartLineNumber, this._selection.selectionStartColumn), i = this._languageConfigurationService.getLanguageConfiguration(t).comments;
    if (i) return e === "LINE_COMMENT" ? i.lineCommentToken || void 0 : e === "BLOCK_COMMENT_START" ? i.blockCommentStartToken || void 0 : e === "BLOCK_COMMENT_END" && i.blockCommentEndToken || void 0;
  }
};
SS = Wle([Vle(2, zt)], SS);
class na {
  constructor() {
    this._date = /* @__PURE__ */ new Date();
  }
  resolve(e) {
    const { name: t } = e;
    if (t === "CURRENT_YEAR") return String(this._date.getFullYear());
    if (t === "CURRENT_YEAR_SHORT") return String(this._date.getFullYear()).slice(-2);
    if (t === "CURRENT_MONTH") return String(this._date.getMonth().valueOf() + 1).padStart(2, "0");
    if (t === "CURRENT_DATE") return String(this._date.getDate().valueOf()).padStart(2, "0");
    if (t === "CURRENT_HOUR") return String(this._date.getHours().valueOf()).padStart(2, "0");
    if (t === "CURRENT_MINUTE") return String(this._date.getMinutes().valueOf()).padStart(2, "0");
    if (t === "CURRENT_SECOND") return String(this._date.getSeconds().valueOf()).padStart(2, "0");
    if (t === "CURRENT_DAY_NAME") return na.dayNames[this._date.getDay()];
    if (t === "CURRENT_DAY_NAME_SHORT") return na.dayNamesShort[this._date.getDay()];
    if (t === "CURRENT_MONTH_NAME") return na.monthNames[this._date.getMonth()];
    if (t === "CURRENT_MONTH_NAME_SHORT") return na.monthNamesShort[this._date.getMonth()];
    if (t === "CURRENT_SECONDS_UNIX") return String(Math.floor(this._date.getTime() / 1e3));
    if (t === "CURRENT_TIMEZONE_OFFSET") {
      const i = this._date.getTimezoneOffset(), s = i > 0 ? "-" : "+", o = Math.trunc(Math.abs(i / 60)), r = o < 10 ? "0" + o : o, a = Math.abs(i) - 60 * o;
      return s + r + ":" + (a < 10 ? "0" + a : a);
    }
  }
}
na.dayNames = [m(0, "Sunday"), m(0, "Monday"), m(0, "Tuesday"), m(0, "Wednesday"), m(0, "Thursday"), m(0, "Friday"), m(0, "Saturday")], na.dayNamesShort = [m(0, "Sun"), m(0, "Mon"), m(0, "Tue"), m(0, "Wed"), m(0, "Thu"), m(0, "Fri"), m(0, "Sat")], na.monthNames = [m(0, "January"), m(0, "February"), m(0, "March"), m(0, "April"), m(0, "May"), m(0, "June"), m(0, "July"), m(0, "August"), m(0, "September"), m(0, "October"), m(0, "November"), m(0, "December")], na.monthNamesShort = [m(0, "Jan"), m(0, "Feb"), m(0, "Mar"), m(0, "Apr"), m(0, "May"), m(0, "Jun"), m(0, "Jul"), m(0, "Aug"), m(0, "Sep"), m(0, "Oct"), m(0, "Nov"), m(0, "Dec")];
class w9 {
  constructor(e) {
    this._workspaceService = e;
  }
  resolve(e) {
    if (!this._workspaceService) return;
    const t = (function(i, s) {
      if (typeof i == "string" || i === void 0) return typeof i == "string" ? { id: xh(i) } : See;
      const o = i;
      return o.configuration ? { id: o.id, configPath: o.configuration } : o.folders.length === 1 ? { id: o.id, uri: o.folders[0].uri } : { id: o.id };
    })(this._workspaceService.getWorkspace());
    return yee(t) ? void 0 : e.name === "WORKSPACE_NAME" ? this._resolveWorkspaceName(t) : e.name === "WORKSPACE_FOLDER" ? this._resoveWorkspacePath(t) : void 0;
  }
  _resolveWorkspaceName(e) {
    if (VI(e)) return xh(e.uri.path);
    let t = xh(e.configPath.path);
    return t.endsWith(kee) && (t = t.substr(0, t.length - 14 - 1)), t;
  }
  _resoveWorkspacePath(e) {
    if (VI(e)) return f9(e.uri.fsPath);
    const t = xh(e.configPath.path);
    let i = e.configPath.fsPath;
    return i.endsWith(t) && (i = i.substr(0, i.length - t.length - 1)), i ? f9(i) : "/";
  }
}
class y9 {
  resolve(e) {
    const { name: t } = e;
    return t === "RANDOM" ? Math.random().toString().slice(-6) : t === "RANDOM_HEX" ? Math.random().toString(16).slice(-6) : t === "UUID" ? GL() : void 0;
  }
}
var Fr, Hle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, zle = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class Bo {
  constructor(e, t, i) {
    this._editor = e, this._snippet = t, this._snippetLineLeadingWhitespace = i, this._offset = -1, this._nestingLevel = 1, this._placeholderGroups = $P(t.placeholders, Wo.compareByIndex), this._placeholderGroupsIdx = -1;
  }
  initialize(e) {
    this._offset = e.newPosition;
  }
  dispose() {
    this._placeholderDecorations && this._editor.removeDecorations([...this._placeholderDecorations.values()]), this._placeholderGroups.length = 0;
  }
  _initDecorations() {
    if (this._offset === -1) throw new Error("Snippet not initialized!");
    if (this._placeholderDecorations) return;
    this._placeholderDecorations = /* @__PURE__ */ new Map();
    const e = this._editor.getModel();
    this._editor.changeDecorations(((t) => {
      for (const i of this._snippet.placeholders) {
        const s = this._snippet.offset(i), o = this._snippet.fullLen(i), r = D.fromPositions(e.getPositionAt(this._offset + s), e.getPositionAt(this._offset + s + o)), a = i.isFinalTabstop ? Bo._decor.inactiveFinal : Bo._decor.inactive, l = t.addDecoration(r, a);
        this._placeholderDecorations.set(i, l);
      }
    }));
  }
  move(e) {
    if (!this._editor.hasModel()) return [];
    if (this._initDecorations(), this._placeholderGroupsIdx >= 0) {
      const s = [];
      for (const o of this._placeholderGroups[this._placeholderGroupsIdx]) if (o.transform) {
        const r = this._placeholderDecorations.get(o), a = this._editor.getModel().getDecorationRange(r), l = this._editor.getModel().getValueInRange(a), d = o.transform.resolve(l).split(/\r\n|\r|\n/);
        for (let h = 1; h < d.length; h++) d[h] = this._editor.getModel().normalizeIndentation(this._snippetLineLeadingWhitespace + d[h]);
        s.push(ii.replace(a, d.join(this._editor.getModel().getEOL())));
      }
      s.length > 0 && this._editor.executeEdits("snippet.placeholderTransform", s);
    }
    let t = !1;
    e === !0 && this._placeholderGroupsIdx < this._placeholderGroups.length - 1 ? (this._placeholderGroupsIdx += 1, t = !0) : e === !1 && this._placeholderGroupsIdx > 0 && (this._placeholderGroupsIdx -= 1, t = !0);
    const i = this._editor.getModel().changeDecorations(((s) => {
      const o = /* @__PURE__ */ new Set(), r = [];
      for (const a of this._placeholderGroups[this._placeholderGroupsIdx]) {
        const l = this._placeholderDecorations.get(a), d = this._editor.getModel().getDecorationRange(l);
        r.push(new _e(d.startLineNumber, d.startColumn, d.endLineNumber, d.endColumn)), t = t && this._hasPlaceholderBeenCollapsed(a), s.changeDecorationOptions(l, a.isFinalTabstop ? Bo._decor.activeFinal : Bo._decor.active), o.add(a);
        for (const h of this._snippet.enclosingPlaceholders(a)) {
          const c = this._placeholderDecorations.get(h);
          s.changeDecorationOptions(c, h.isFinalTabstop ? Bo._decor.activeFinal : Bo._decor.active), o.add(h);
        }
      }
      for (const [a, l] of this._placeholderDecorations) o.has(a) || s.changeDecorationOptions(l, a.isFinalTabstop ? Bo._decor.inactiveFinal : Bo._decor.inactive);
      return r;
    }));
    return t ? this.move(e) : i ?? [];
  }
  _hasPlaceholderBeenCollapsed(e) {
    let t = e;
    for (; t; ) {
      if (t instanceof Wo) {
        const i = this._placeholderDecorations.get(t);
        if (this._editor.getModel().getDecorationRange(i).isEmpty() && t.toString().length > 0) return !0;
      }
      t = t.parent;
    }
    return !1;
  }
  get isAtFirstPlaceholder() {
    return this._placeholderGroupsIdx <= 0 || this._placeholderGroups.length === 0;
  }
  get isAtLastPlaceholder() {
    return this._placeholderGroupsIdx === this._placeholderGroups.length - 1;
  }
  get hasPlaceholder() {
    return this._snippet.placeholders.length > 0;
  }
  get isTrivialSnippet() {
    if (this._snippet.placeholders.length === 0) return !0;
    if (this._snippet.placeholders.length === 1) {
      const [e] = this._snippet.placeholders;
      if (e.isFinalTabstop && this._snippet.rightMostDescendant === e) return !0;
    }
    return !1;
  }
  computePossibleSelections() {
    const e = /* @__PURE__ */ new Map();
    for (const t of this._placeholderGroups) {
      let i;
      for (const s of t) {
        if (s.isFinalTabstop) break;
        i || (i = [], e.set(s.index, i));
        const o = this._placeholderDecorations.get(s), r = this._editor.getModel().getDecorationRange(o);
        if (!r) {
          e.delete(s.index);
          break;
        }
        i.push(r);
      }
    }
    return e;
  }
  get activeChoice() {
    if (!this._placeholderDecorations) return;
    const e = this._placeholderGroups[this._placeholderGroupsIdx][0];
    if (!e?.choice) return;
    const t = this._placeholderDecorations.get(e);
    if (!t) return;
    const i = this._editor.getModel().getDecorationRange(t);
    return i ? { range: i, choice: e.choice } : void 0;
  }
  get hasChoice() {
    let e = !1;
    return this._snippet.walk(((t) => (e = t instanceof yf, !e))), e;
  }
  merge(e) {
    const t = this._editor.getModel();
    this._nestingLevel *= 10, this._editor.changeDecorations(((i) => {
      for (const s of this._placeholderGroups[this._placeholderGroupsIdx]) {
        const o = e.shift();
        console.assert(o._offset !== -1), console.assert(!o._placeholderDecorations);
        const r = o._snippet.placeholderInfo.last.index;
        for (const l of o._snippet.placeholderInfo.all) l.isFinalTabstop ? l.index = s.index + (r + 1) / this._nestingLevel : l.index = s.index + l.index / this._nestingLevel;
        this._snippet.replace(s, o._snippet.children);
        const a = this._placeholderDecorations.get(s);
        i.removeDecoration(a), this._placeholderDecorations.delete(s);
        for (const l of o._snippet.placeholders) {
          const d = o._snippet.offset(l), h = o._snippet.fullLen(l), c = D.fromPositions(t.getPositionAt(o._offset + d), t.getPositionAt(o._offset + d + h)), u = i.addDecoration(c, Bo._decor.inactive);
          this._placeholderDecorations.set(l, u);
        }
      }
      this._placeholderGroups = $P(this._snippet.placeholders, Wo.compareByIndex);
    }));
  }
}
Bo._decor = { active: Ve.register({ description: "snippet-placeholder-1", stickiness: 0, className: "snippet-placeholder" }), inactive: Ve.register({ description: "snippet-placeholder-2", stickiness: 1, className: "snippet-placeholder" }), activeFinal: Ve.register({ description: "snippet-placeholder-3", stickiness: 1, className: "finish-snippet-placeholder" }), inactiveFinal: Ve.register({ description: "snippet-placeholder-4", stickiness: 1, className: "finish-snippet-placeholder" }) };
const S9 = { overwriteBefore: 0, overwriteAfter: 0, adjustWhitespace: !0, clipboardText: void 0, overtypingCapturer: void 0 };
let LS = Fr = class {
  static adjustWhitespace(n, e, t, i, s) {
    const o = Wt(n.getLineContent(e.lineNumber), 0, e.column - 1);
    let r;
    return i.walk(((a) => {
      if (!(a instanceof hs) || a.parent instanceof yf || s && !s.has(a)) return !0;
      const l = a.value.split(/\r\n|\r|\n/);
      if (t) {
        const h = i.offset(a);
        if (h === 0) l[0] = n.normalizeIndentation(l[0]);
        else {
          r = r ?? i.toString();
          const c = r.charCodeAt(h - 1);
          c !== 10 && c !== 13 || (l[0] = n.normalizeIndentation(o + l[0]));
        }
        for (let c = 1; c < l.length; c++) l[c] = n.normalizeIndentation(o + l[c]);
      }
      const d = l.join(n.getEOL());
      return d !== a.value && (a.parent.replace(a, [new hs(d)]), r = void 0), !0;
    })), o;
  }
  static adjustSelection(n, e, t, i) {
    if (t !== 0 || i !== 0) {
      const { positionLineNumber: s, positionColumn: o } = e, r = o - t, a = o + i, l = n.validateRange({ startLineNumber: s, startColumn: r, endLineNumber: s, endColumn: a });
      e = _e.createWithDirection(l.startLineNumber, l.startColumn, l.endLineNumber, l.endColumn, e.getDirection());
    }
    return e;
  }
  static createEditsAndSnippetsFromSelections(n, e, t, i, s, o, r, a, l) {
    const d = [], h = [];
    if (!n.hasModel()) return { edits: d, snippets: h };
    const c = n.getModel(), u = n.invokeWithinContext(((C) => C.get(gg))), g = n.invokeWithinContext(((C) => new b9(C.get($m), c))), p = () => r, f = c.getValueInRange(Fr.adjustSelection(c, n.getSelection(), t, 0)), _ = c.getValueInRange(Fr.adjustSelection(c, n.getSelection(), 0, i)), v = c.getLineFirstNonWhitespaceColumn(n.getSelection().positionLineNumber), b = n.getSelections().map(((C, w) => ({ selection: C, idx: w }))).sort(((C, w) => D.compareRangesUsingStarts(C.selection, w.selection)));
    for (const { selection: C, idx: w } of b) {
      let y = Fr.adjustSelection(c, C, t, 0), L = Fr.adjustSelection(c, C, 0, i);
      f !== c.getValueInRange(y) && (y = C), _ !== c.getValueInRange(L) && (L = C);
      const k = C.setStartPosition(y.startLineNumber, y.startColumn).setEndPosition(L.endLineNumber, L.endColumn), N = new bg().parse(e, !0, s), A = k.getStartPosition(), B = Fr.adjustWhitespace(c, A, o || w > 0 && v !== c.getLineFirstNonWhitespaceColumn(C.positionLineNumber), N);
      N.resolveVariables(new _9([g, new C9(p, w, b.length, n.getOption(79) === "spread"), new v9(c, C, w, a), new SS(c, C, l), new na(), new w9(u), new y9()])), d[w] = ii.replace(k, N.toString()), d[w].identifier = { major: w, minor: 0 }, d[w]._isTracked = !0, h[w] = new Bo(n, N, B);
    }
    return { edits: d, snippets: h };
  }
  static createEditsAndSnippetsFromEdits(n, e, t, i, s, o, r) {
    if (!n.hasModel() || e.length === 0) return { edits: [], snippets: [] };
    const a = [], l = n.getModel(), d = new bg(), h = new V1(), c = new _9([n.invokeWithinContext(((g) => new b9(g.get($m), l))), new C9((() => s), 0, n.getSelections().length, n.getOption(79) === "spread"), new v9(l, n.getSelection(), 0, o), new SS(l, n.getSelection(), r), new na(), new w9(n.invokeWithinContext(((g) => g.get(gg)))), new y9()]);
    e = e.sort(((g, p) => D.compareRangesUsingStarts(g.range, p.range)));
    let u = 0;
    for (let g = 0; g < e.length; g++) {
      const { range: p, template: f } = e[g];
      if (g > 0) {
        const w = e[g - 1].range, y = D.fromPositions(w.getEndPosition(), p.getStartPosition()), L = new hs(l.getValueInRange(y));
        h.appendChild(L), u += L.value.length;
      }
      const _ = d.parseFragment(f, h);
      Fr.adjustWhitespace(l, p.getStartPosition(), !0, h, new Set(_)), h.resolveVariables(c);
      const v = h.toString(), b = v.slice(u);
      u = v.length;
      const C = ii.replace(p, b);
      C.identifier = { major: g, minor: 0 }, C._isTracked = !0, a.push(C);
    }
    return d.ensureFinalTabstop(h, t, !0), { edits: a, snippets: [new Bo(n, h, "")] };
  }
  constructor(n, e, t = S9, i) {
    this._editor = n, this._template = e, this._options = t, this._languageConfigurationService = i, this._templateMerges = [], this._snippets = [];
  }
  dispose() {
    Ht(this._snippets);
  }
  _logInfo() {
    return `template="${this._template}", merged_templates="${this._templateMerges.join(" -> ")}"`;
  }
  insert() {
    if (!this._editor.hasModel()) return;
    const { edits: n, snippets: e } = typeof this._template == "string" ? Fr.createEditsAndSnippetsFromSelections(this._editor, this._template, this._options.overwriteBefore, this._options.overwriteAfter, !1, this._options.adjustWhitespace, this._options.clipboardText, this._options.overtypingCapturer, this._languageConfigurationService) : Fr.createEditsAndSnippetsFromEdits(this._editor, this._template, !1, this._options.adjustWhitespace, this._options.clipboardText, this._options.overtypingCapturer, this._languageConfigurationService);
    this._snippets = e, this._editor.executeEdits("snippet", n, ((t) => {
      const i = t.filter(((s) => !!s.identifier));
      for (let s = 0; s < e.length; s++) e[s].initialize(i[s].textChange);
      return this._snippets[0].hasPlaceholder ? this._move(!0) : i.map(((s) => _e.fromPositions(s.range.getEndPosition())));
    })), this._editor.revealRange(this._editor.getSelections()[0]);
  }
  merge(n, e = S9) {
    if (!this._editor.hasModel()) return;
    this._templateMerges.push([this._snippets[0]._nestingLevel, this._snippets[0]._placeholderGroupsIdx, n]);
    const { edits: t, snippets: i } = Fr.createEditsAndSnippetsFromSelections(this._editor, n, e.overwriteBefore, e.overwriteAfter, !0, e.adjustWhitespace, e.clipboardText, e.overtypingCapturer, this._languageConfigurationService);
    this._editor.executeEdits("snippet", t, ((s) => {
      const o = s.filter(((a) => !!a.identifier));
      for (let a = 0; a < i.length; a++) i[a].initialize(o[a].textChange);
      const r = i[0].isTrivialSnippet;
      if (!r) {
        for (const a of this._snippets) a.merge(i);
        console.assert(i.length === 0);
      }
      return this._snippets[0].hasPlaceholder && !r ? this._move(void 0) : o.map(((a) => _e.fromPositions(a.range.getEndPosition())));
    }));
  }
  next() {
    const n = this._move(!0);
    this._editor.setSelections(n), this._editor.revealPositionInCenterIfOutsideViewport(n[0].getPosition());
  }
  prev() {
    const n = this._move(!1);
    this._editor.setSelections(n), this._editor.revealPositionInCenterIfOutsideViewport(n[0].getPosition());
  }
  _move(n) {
    const e = [];
    for (const t of this._snippets) {
      const i = t.move(n);
      e.push(...i);
    }
    return e;
  }
  get isAtFirstPlaceholder() {
    return this._snippets[0].isAtFirstPlaceholder;
  }
  get isAtLastPlaceholder() {
    return this._snippets[0].isAtLastPlaceholder;
  }
  get hasPlaceholder() {
    return this._snippets[0].hasPlaceholder;
  }
  get hasChoice() {
    return this._snippets[0].hasChoice;
  }
  get activeChoice() {
    return this._snippets[0].activeChoice;
  }
  isSelectionWithinPlaceholders() {
    if (!this.hasPlaceholder) return !1;
    const n = this._editor.getSelections();
    if (n.length < this._snippets.length) return !1;
    const e = /* @__PURE__ */ new Map();
    for (const t of this._snippets) {
      const i = t.computePossibleSelections();
      if (e.size === 0) for (const [s, o] of i) {
        o.sort(D.compareRangesUsingStarts);
        for (const r of n) if (o[0].containsRange(r)) {
          e.set(s, []);
          break;
        }
      }
      if (e.size === 0) return !1;
      e.forEach(((s, o) => {
        s.push(...i.get(o));
      }));
    }
    n.sort(D.compareRangesUsingStarts);
    for (const [t, i] of e) if (i.length === n.length) {
      i.sort(D.compareRangesUsingStarts);
      for (let s = 0; s < i.length; s++) i[s].containsRange(n[s]) || e.delete(t);
    } else e.delete(t);
    return e.size > 0;
  }
};
LS = Fr = Hle([zle(3, zt)], LS);
var _p, Ule = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, hC = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const L9 = { overwriteBefore: 0, overwriteAfter: 0, undoStopBefore: !0, undoStopAfter: !0, adjustWhitespace: !0, clipboardText: void 0, overtypingCapturer: void 0 };
let _n = _p = class {
  static get(n) {
    return n.getContribution(_p.ID);
  }
  constructor(n, e, t, i, s) {
    this._editor = n, this._logService = e, this._languageFeaturesService = t, this._languageConfigurationService = s, this._snippetListener = new G(), this._modelVersionId = -1, this._inSnippet = _p.InSnippetMode.bindTo(i), this._hasNextTabstop = _p.HasNextTabstop.bindTo(i), this._hasPrevTabstop = _p.HasPrevTabstop.bindTo(i);
  }
  dispose() {
    var n;
    this._inSnippet.reset(), this._hasPrevTabstop.reset(), this._hasNextTabstop.reset(), (n = this._session) === null || n === void 0 || n.dispose(), this._snippetListener.dispose();
  }
  insert(n, e) {
    try {
      this._doInsert(n, e === void 0 ? L9 : { ...L9, ...e });
    } catch (t) {
      this.cancel(), this._logService.error(t), this._logService.error("snippet_error"), this._logService.error("insert_template=", n), this._logService.error("existing_template=", this._session ? this._session._logInfo() : "<no_session>");
    }
  }
  _doInsert(n, e) {
    var t;
    if (this._editor.hasModel()) {
      if (this._snippetListener.clear(), e.undoStopBefore && this._editor.getModel().pushStackElement(), this._session && typeof n != "string" && this.cancel(), this._session ? (vt(typeof n == "string"), this._session.merge(n, e)) : (this._modelVersionId = this._editor.getModel().getAlternativeVersionId(), this._session = new LS(this._editor, n, e, this._languageConfigurationService), this._session.insert()), e.undoStopAfter && this._editor.getModel().pushStackElement(), (t = this._session) === null || t === void 0 ? void 0 : t.hasChoice) {
        const i = { _debugDisplayName: "snippetChoiceCompletions", provideCompletionItems: (d, h) => {
          if (!this._session || d !== this._editor.getModel() || !W.equals(this._editor.getPosition(), h)) return;
          const { activeChoice: c } = this._session;
          if (!c || c.choice.options.length === 0) return;
          const u = d.getValueInRange(c.range), g = !!c.choice.options.find(((f) => f.value === u)), p = [];
          for (let f = 0; f < c.choice.options.length; f++) {
            const _ = c.choice.options[f];
            p.push({ kind: 13, label: _.value, insertText: _.value, sortText: "a".repeat(f + 1), range: c.range, filterText: g ? `${u}_${_.value}` : void 0, command: { id: "jumpToNextSnippetPlaceholder", title: m(0, "Go to next placeholder...") } });
          }
          return { suggestions: p };
        } }, s = this._editor.getModel();
        let o, r = !1;
        const a = () => {
          o?.dispose(), r = !1;
        }, l = () => {
          r || (o = this._languageFeaturesService.completionProvider.register({ language: s.getLanguageId(), pattern: s.uri.fsPath, scheme: s.uri.scheme, exclusive: !0 }, i), this._snippetListener.add(o), r = !0);
        };
        this._choiceCompletions = { provider: i, enable: l, disable: a };
      }
      this._updateState(), this._snippetListener.add(this._editor.onDidChangeModelContent(((i) => i.isFlush && this.cancel()))), this._snippetListener.add(this._editor.onDidChangeModel((() => this.cancel()))), this._snippetListener.add(this._editor.onDidChangeCursorSelection((() => this._updateState())));
    }
  }
  _updateState() {
    if (this._session && this._editor.hasModel()) {
      if (this._modelVersionId === this._editor.getModel().getAlternativeVersionId()) return this.cancel();
      if (!this._session.hasPlaceholder) return this.cancel();
      if (this._session.isAtLastPlaceholder || !this._session.isSelectionWithinPlaceholders()) return this._editor.getModel().pushStackElement(), this.cancel();
      this._inSnippet.set(!0), this._hasPrevTabstop.set(!this._session.isAtFirstPlaceholder), this._hasNextTabstop.set(!this._session.isAtLastPlaceholder), this._handleChoice();
    }
  }
  _handleChoice() {
    var n;
    if (!this._session || !this._editor.hasModel()) return void (this._currentChoice = void 0);
    const { activeChoice: e } = this._session;
    if (!e || !this._choiceCompletions) return (n = this._choiceCompletions) === null || n === void 0 || n.disable(), void (this._currentChoice = void 0);
    this._currentChoice !== e.choice && (this._currentChoice = e.choice, this._choiceCompletions.enable(), queueMicrotask((() => {
      (function(t, i) {
        var s;
        (s = t.getContribution("editor.contrib.suggestController")) === null || s === void 0 || s.triggerSuggest((/* @__PURE__ */ new Set()).add(i), void 0, !0);
      })(this._editor, this._choiceCompletions.provider);
    })));
  }
  finish() {
    for (; this._inSnippet.get(); ) this.next();
  }
  cancel(n = !1) {
    var e;
    this._inSnippet.reset(), this._hasPrevTabstop.reset(), this._hasNextTabstop.reset(), this._snippetListener.clear(), this._currentChoice = void 0, (e = this._session) === null || e === void 0 || e.dispose(), this._session = void 0, this._modelVersionId = -1, n && this._editor.setSelections([this._editor.getSelection()]);
  }
  prev() {
    var n;
    (n = this._session) === null || n === void 0 || n.prev(), this._updateState();
  }
  next() {
    var n;
    (n = this._session) === null || n === void 0 || n.next(), this._updateState();
  }
  isInSnippet() {
    return !!this._inSnippet.get();
  }
};
_n.ID = "snippetController2", _n.InSnippetMode = new ae("inSnippetMode", !1, m(0, "Whether the editor in current in snippet mode")), _n.HasNextTabstop = new ae("hasNextTabstop", !1, m(0, "Whether there is a next tab stop when in snippet mode")), _n.HasPrevTabstop = new ae("hasPrevTabstop", !1, m(0, "Whether there is a previous tab stop when in snippet mode")), _n = _p = Ule([hC(1, ts), hC(2, fe), hC(3, Te), hC(4, zt)], _n), ft(_n.ID, _n, 4);
const cC = Zi.bindToContribution(_n.get);
re(new cC({ id: "jumpToNextSnippetPlaceholder", precondition: q.and(_n.InSnippetMode, _n.HasNextTabstop), handler: (n) => n.next(), kbOpts: { weight: 130, kbExpr: E.editorTextFocus, primary: 2 } })), re(new cC({ id: "jumpToPrevSnippetPlaceholder", precondition: q.and(_n.InSnippetMode, _n.HasPrevTabstop), handler: (n) => n.prev(), kbOpts: { weight: 130, kbExpr: E.editorTextFocus, primary: 1026 } })), re(new cC({ id: "leaveSnippet", precondition: _n.InSnippetMode, handler: (n) => n.cancel(!0), kbOpts: { weight: 130, kbExpr: E.editorTextFocus, primary: 9, secondary: [1033] } })), re(new cC({ id: "acceptSnippet", precondition: _n.InSnippetMode, handler: (n) => n.finish() }));
var lo, Kle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, qx = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
(function(n) {
  n[n.Undo = 0] = "Undo", n[n.Redo = 1] = "Redo", n[n.AcceptWord = 2] = "AcceptWord", n[n.Other = 3] = "Other";
})(lo || (lo = {}));
let JM = class extends V {
  get isAcceptingPartially() {
    return this._isAcceptingPartially;
  }
  constructor(n, e, t, i, s, o, r, a, l, d, h, c) {
    let u;
    super(), this.textModel = n, this.selectedSuggestItem = e, this.textModelVersionId = t, this._positions = i, this._debounceValue = s, this._suggestPreviewEnabled = o, this._suggestPreviewMode = r, this._inlineSuggestMode = a, this._enabled = l, this._instantiationService = d, this._commandService = h, this._languageConfigurationService = c, this._source = this._register(this._instantiationService.createInstance(QM, this.textModel, this.textModelVersionId, this._debounceValue)), this._isActive = lt(this, !1), this._forceUpdateSignal = DL("forceUpdate"), this._selectedInlineCompletionId = lt(this, void 0), this._primaryPosition = Fe(this, ((g) => {
      var p;
      return (p = this._positions.read(g)[0]) !== null && p !== void 0 ? p : new W(1, 1);
    })), this._isAcceptingPartially = !1, this._preserveCurrentCompletionReasons = /* @__PURE__ */ new Set([lo.Redo, lo.Undo, lo.AcceptWord]), this._fetchInlineCompletions = (function(g, p) {
      var f;
      return new Xm(new va(g.owner, g.debugName, void 0), p, g.createEmptyChangeSummary, g.handleChange, void 0, (f = g.equalityComparer) !== null && f !== void 0 ? f : Ym);
    })({ owner: this, createEmptyChangeSummary: () => ({ preserveCurrentCompletion: !1, inlineCompletionTriggerKind: Ld.Automatic }), handleChange: (g, p) => (g.didChange(this.textModelVersionId) && this._preserveCurrentCompletionReasons.has(g.change) ? p.preserveCurrentCompletion = !0 : g.didChange(this._forceUpdateSignal) && (p.inlineCompletionTriggerKind = g.change), !0) }, ((g, p) => {
      if (this._forceUpdateSignal.read(g), !(this._enabled.read(g) && this.selectedSuggestItem.read(g) || this._isActive.read(g))) return void this._source.cancelUpdate();
      this.textModelVersionId.read(g);
      const f = this.selectedInlineCompletion.get(), _ = p.preserveCurrentCompletion || f?.forwardStable ? f : void 0, v = this._source.suggestWidgetInlineCompletions.get(), b = this.selectedSuggestItem.read(g);
      if (v && !b) {
        const y = this._source.inlineCompletions.get();
        Tt(((L) => {
          (!y || v.request.versionId > y.request.versionId) && this._source.inlineCompletions.set(v.clone(), L), this._source.clearSuggestWidgetInlineCompletions(L);
        }));
      }
      const C = this._primaryPosition.read(g), w = { triggerKind: p.inlineCompletionTriggerKind, selectedSuggestionInfo: b?.toSelectedSuggestionInfo() };
      return this._source.fetch(C, w, _);
    })), this._filteredInlineCompletionItems = Fe(this, ((g) => {
      const p = this._source.inlineCompletions.read(g);
      if (!p) return [];
      const f = this._primaryPosition.read(g);
      return p.inlineCompletions.filter(((v) => v.isVisible(this.textModel, f, g)));
    })), this.selectedInlineCompletionIndex = Fe(this, ((g) => {
      const p = this._selectedInlineCompletionId.read(g), f = this._filteredInlineCompletionItems.read(g), _ = this._selectedInlineCompletionId === void 0 ? -1 : f.findIndex(((v) => v.semanticId === p));
      return _ === -1 ? (this._selectedInlineCompletionId.set(void 0, void 0), 0) : _;
    })), this.selectedInlineCompletion = Fe(this, ((g) => this._filteredInlineCompletionItems.read(g)[this.selectedInlineCompletionIndex.read(g)])), this.lastTriggerKind = this._source.inlineCompletions.map(this, ((g) => g?.request.context.triggerKind)), this.inlineCompletionsCount = Fe(this, ((g) => this.lastTriggerKind.read(g) === Ld.Explicit ? this._filteredInlineCompletionItems.read(g).length : void 0)), this.state = mm({ owner: this, equalityComparer: (g, p) => g && p ? o9(g.ghostTexts, p.ghostTexts) && g.inlineCompletion === p.inlineCompletion && g.suggestItem === p.suggestItem : g === p }, ((g) => {
      var p, f;
      const _ = this.textModel, v = this.selectedSuggestItem.read(g);
      if (v) {
        const b = Ju(v.toSingleTextEdit(), _), C = this._computeAugmentation(b, g);
        if (!this._suggestPreviewEnabled.read(g) && !C) return;
        const w = (p = C?.edit) !== null && p !== void 0 ? p : b, y = C ? C.edit.text.length - b.text.length : 0, L = this._suggestPreviewMode.read(g), k = this._positions.read(g), N = [w, ...$x(this.textModel, k, w)], A = N.map(((B, T) => h9(B, _, L, k[T], y))).filter(hl);
        return { edits: N, primaryGhostText: (f = A[0]) !== null && f !== void 0 ? f : new i1(w.range.endLineNumber, []), ghostTexts: A, inlineCompletion: C?.completion, suggestItem: v };
      }
      {
        if (!this._isActive.read(g)) return;
        const b = this.selectedInlineCompletion.read(g);
        if (!b) return;
        const C = b.toSingleTextEdit(g), w = this._inlineSuggestMode.read(g), y = this._positions.read(g), L = [C, ...$x(this.textModel, y, C)], k = L.map(((N, A) => h9(N, _, w, y[A], 0))).filter(hl);
        return k[0] ? { edits: L, primaryGhostText: k[0], ghostTexts: k, inlineCompletion: b, suggestItem: void 0 } : void 0;
      }
    })), this.ghostTexts = mm({ owner: this, equalityComparer: o9 }, ((g) => {
      const p = this.state.read(g);
      if (p) return p.ghostTexts;
    })), this.primaryGhostText = mm({ owner: this, equalityComparer: Gz }, ((g) => {
      const p = this.state.read(g);
      if (p) return p?.primaryGhostText;
    })), this._register(P1(this._fetchInlineCompletions)), this._register(Ge(((g) => {
      var p, f;
      const _ = this.state.read(g), v = _?.inlineCompletion;
      if (v?.semanticId !== u?.semanticId && (u = v, v)) {
        const b = v.inlineCompletion, C = b.source;
        (f = (p = C.provider).handleItemDidShow) === null || f === void 0 || f.call(p, C.inlineCompletions, b.sourceInlineCompletion, b.insertText);
      }
    })));
  }
  async trigger(n) {
    this._isActive.set(!0, n), await this._fetchInlineCompletions.get();
  }
  async triggerExplicitly(n) {
    Mv(n, ((e) => {
      this._isActive.set(!0, e), this._forceUpdateSignal.trigger(e, Ld.Explicit);
    })), await this._fetchInlineCompletions.get();
  }
  stop(n) {
    Mv(n, ((e) => {
      this._isActive.set(!1, e), this._source.clear(e);
    }));
  }
  _computeAugmentation(n, e) {
    const t = this.textModel, i = this._source.suggestWidgetInlineCompletions.read(e);
    return (function(s, o) {
      for (const r of s) {
        const a = o(r);
        if (a !== void 0) return a;
      }
    })(i ? i.inlineCompletions : [this.selectedInlineCompletion.read(e)].filter(hl), ((s) => {
      let o = s.toSingleTextEdit(e);
      return o = Ju(o, t, D.fromPositions(o.range.getStartPosition(), n.range.getEndPosition())), Qz(o, n) ? { completion: s, edit: o } : void 0;
    }));
  }
  async _deltaSelectedInlineCompletionIndex(n) {
    await this.triggerExplicitly();
    const e = this._filteredInlineCompletionItems.get() || [];
    if (e.length > 0) {
      const t = (this.selectedInlineCompletionIndex.get() + n + e.length) % e.length;
      this._selectedInlineCompletionId.set(e[t].semanticId, void 0);
    } else this._selectedInlineCompletionId.set(void 0, void 0);
  }
  async next() {
    await this._deltaSelectedInlineCompletionIndex(1);
  }
  async previous() {
    await this._deltaSelectedInlineCompletionIndex(-1);
  }
  async accept(n) {
    var e;
    if (n.getModel() !== this.textModel) throw new Kt();
    const t = this.state.get();
    if (!t || t.primaryGhostText.isEmpty() || !t.inlineCompletion) return;
    const i = t.inlineCompletion.toInlineCompletion(void 0);
    if (n.pushUndoStop(), i.snippetInfo) n.executeEdits("inlineSuggestion.accept", [ii.replaceMove(i.range, ""), ...i.additionalTextEdits]), n.setPosition(i.snippetInfo.range.getStartPosition(), "inlineCompletionAccept"), (e = _n.get(n)) === null || e === void 0 || e.insert(i.snippetInfo.snippet, { undoStopBefore: !1 });
    else {
      const s = t.edits, o = k9(s).map(((r) => _e.fromPositions(r)));
      n.executeEdits("inlineSuggestion.accept", [...s.map(((r) => ii.replaceMove(r.range, r.text))), ...i.additionalTextEdits]), n.setSelections(o, "inlineCompletionAccept");
    }
    i.command && i.source.addRef(), Tt(((s) => {
      this._source.clear(s), this._isActive.set(!1, s);
    })), i.command && (await this._commandService.executeCommand(i.command.id, ...i.command.arguments || []).then(void 0, Ni), i.source.removeRef());
  }
  async acceptNextWord(n) {
    await this._acceptNext(n, ((e, t) => {
      const i = this.textModel.getLanguageIdAtPosition(e.lineNumber, e.column), s = this._languageConfigurationService.getLanguageConfiguration(i), o = new RegExp(s.wordDefinition.source, s.wordDefinition.flags.replace("g", "")), r = t.match(o);
      let a = 0;
      a = r && r.index !== void 0 ? r.index === 0 ? r[0].length : r.index : t.length;
      const l = /\s+/g.exec(t);
      return l && l.index !== void 0 && l.index + l[0].length < a && (a = l.index + l[0].length), a;
    }), 0);
  }
  async acceptNextLine(n) {
    await this._acceptNext(n, ((e, t) => {
      const i = t.match(/\n/);
      return i && i.index !== void 0 ? i.index + 1 : t.length;
    }), 1);
  }
  async _acceptNext(n, e, t) {
    if (n.getModel() !== this.textModel) throw new Kt();
    const i = this.state.get();
    if (!i || i.primaryGhostText.isEmpty() || !i.inlineCompletion) return;
    const s = i.primaryGhostText, o = i.inlineCompletion.toInlineCompletion(void 0);
    if (o.snippetInfo || o.filterText !== o.insertText) return void await this.accept(n);
    const r = s.parts[0], a = new W(s.lineNumber, r.column), l = r.text, d = e(a, l);
    if (d === l.length && s.parts.length === 1) return void this.accept(n);
    const h = l.substring(0, d), c = this._positions.get(), u = c[0];
    o.source.addRef();
    try {
      this._isAcceptingPartially = !0;
      try {
        n.pushUndoStop();
        const g = D.fromPositions(u, a), p = n.getModel().getValueInRange(g) + h, f = new Bd(g, p), _ = [f, ...$x(this.textModel, c, f)], v = k9(_).map(((b) => _e.fromPositions(b)));
        n.executeEdits("inlineSuggestion.accept", _.map(((b) => ii.replaceMove(b.range, b.text)))), n.setSelections(v, "inlineCompletionPartialAccept");
      } finally {
        this._isAcceptingPartially = !1;
      }
      if (o.source.provider.handlePartialAccept) {
        const g = D.fromPositions(o.range.getStartPosition(), kr.ofText(h).addToPosition(a)), p = n.getModel().getValueInRange(g, 1);
        o.source.provider.handlePartialAccept(o.source.inlineCompletions, o.sourceInlineCompletion, p.length, { kind: t });
      }
    } finally {
      o.source.removeRef();
    }
  }
  handleSuggestAccepted(n) {
    var e, t;
    const i = Ju(n.toSingleTextEdit(), this.textModel), s = this._computeAugmentation(i, void 0);
    if (!s) return;
    const o = s.completion.inlineCompletion;
    (t = (e = o.source.provider).handlePartialAccept) === null || t === void 0 || t.call(e, o.source.inlineCompletions, o.sourceInlineCompletion, i.text.length, { kind: 2 });
  }
};
function $x(n, e, t) {
  if (e.length === 1) return [];
  const i = e[0], s = e.slice(1), o = t.range.getStartPosition(), r = t.range.getEndPosition(), a = n.getValueInRange(D.fromPositions(i, r)), l = r9(i, o);
  if (l.lineNumber < 1) return We(new Kt(`positionWithinTextEdit line number should be bigger than 0.
			Invalid subtraction between ${i.toString()} and ${o.toString()}`)), [];
  const d = (function(h, c) {
    let u = "";
    const g = (function(p) {
      var f;
      const _ = [], v = p.split(/(\r\n|\r|\n)/);
      for (let b = 0; b < Math.ceil(v.length / 2); b++) _.push(v[2 * b] + ((f = v[2 * b + 1]) !== null && f !== void 0 ? f : ""));
      return _;
    })(h);
    for (let p = c.lineNumber - 1; p < g.length; p++) u += g[p].substring(p === c.lineNumber - 1 ? c.column - 1 : 0);
    return u;
  })(t.text, l);
  return s.map(((h) => {
    const c = (u = r9(h, o), g = r, new W(u.lineNumber + g.lineNumber - 1, g.lineNumber === 1 ? u.column + g.column - 1 : g.column));
    var u, g;
    const p = n.getValueInRange(D.fromPositions(h, c)), f = mc(a, p), _ = D.fromPositions(h, h.delta(0, f));
    return new Bd(_, d);
  }));
}
function k9(n) {
  const e = kw.createSortPermutation(n, ((i, s) => D.compareRangesUsingStarts(i.range, s.range))), t = new eP(e.apply(n)).getNewRanges();
  return e.inverse().apply(t).map(((i) => i.getEndPosition()));
}
JM = Kle([qx(9, Se), qx(10, ai), qx(11, zt)], JM);
var B_, jle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, D9 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class eT {
  constructor(e) {
    this.name = e;
  }
  select(e, t, i) {
    if (i.length === 0) return 0;
    const s = i[0].score[0];
    for (let o = 0; o < i.length; o++) {
      const { score: r, completion: a } = i[o];
      if (r[0] !== s) break;
      if (a.preselect) return o;
    }
    return 0;
  }
}
class Jz extends eT {
  constructor() {
    super("first");
  }
  memorize(e, t, i) {
  }
  toJSON() {
  }
  fromJSON() {
  }
}
let W_ = B_ = class {
  constructor(n, e) {
    this._storageService = n, this._configService = e, this._disposables = new G(), this._persistSoon = new Et((() => this._saveState()), 500), this._disposables.add(n.onWillSaveState(((t) => {
      t.reason === Pv.SHUTDOWN && this._saveState();
    })));
  }
  dispose() {
    this._disposables.dispose(), this._persistSoon.dispose();
  }
  memorize(n, e, t) {
    this._withStrategy(n, e).memorize(n, e, t), this._persistSoon.schedule();
  }
  select(n, e, t) {
    return this._withStrategy(n, e).select(n, e, t);
  }
  _withStrategy(n, e) {
    var t;
    const i = this._configService.getValue("editor.suggestSelection", { overrideIdentifier: n.getLanguageIdAtPosition(e.lineNumber, e.column), resource: n.uri });
    if (((t = this._strategy) === null || t === void 0 ? void 0 : t.name) !== i) {
      this._saveState();
      const s = B_._strategyCtors.get(i) || Jz;
      this._strategy = new s();
      try {
        const o = this._configService.getValue("editor.suggest.shareSuggestSelections") ? 0 : 1, r = this._storageService.get(`${B_._storagePrefix}/${i}`, o);
        r && this._strategy.fromJSON(JSON.parse(r));
      } catch {
      }
    }
    return this._strategy;
  }
  _saveState() {
    if (this._strategy) {
      const n = this._configService.getValue("editor.suggest.shareSuggestSelections") ? 0 : 1, e = JSON.stringify(this._strategy);
      this._storageService.store(`${B_._storagePrefix}/${this._strategy.name}`, e, n, 1);
    }
  }
};
W_._strategyCtors = /* @__PURE__ */ new Map([["recentlyUsedByPrefix", class extends eT {
  constructor() {
    super("recentlyUsedByPrefix"), this._trie = pm.forStrings(), this._seq = 0;
  }
  memorize(n, e, t) {
    const { word: i } = n.getWordUntilPosition(e), s = `${n.getLanguageId()}/${i}`;
    this._trie.set(s, { type: t.completion.kind, insertText: t.completion.insertText, touch: this._seq++ });
  }
  select(n, e, t) {
    const { word: i } = n.getWordUntilPosition(e);
    if (!i) return super.select(n, e, t);
    const s = `${n.getLanguageId()}/${i}`;
    let o = this._trie.get(s);
    if (o || (o = this._trie.findSubstr(s)), o) for (let r = 0; r < t.length; r++) {
      const { kind: a, insertText: l } = t[r].completion;
      if (a === o.type && l === o.insertText) return r;
    }
    return super.select(n, e, t);
  }
  toJSON() {
    const n = [];
    return this._trie.forEach(((e, t) => n.push([t, e]))), n.sort(((e, t) => -(e[1].touch - t[1].touch))).forEach(((e, t) => e[1].touch = t)), n.slice(0, 200);
  }
  fromJSON(n) {
    if (this._trie.clear(), n.length > 0) {
      this._seq = n[0][1].touch + 1;
      for (const [e, t] of n) t.type = typeof t.type == "number" ? t.type : $0.fromString(t.type), this._trie.set(e, t);
    }
  }
}], ["recentlyUsed", class extends eT {
  constructor() {
    super("recentlyUsed"), this._cache = new Ll(300, 0.66), this._seq = 0;
  }
  memorize(n, e, t) {
    const i = `${n.getLanguageId()}/${t.textLabel}`;
    this._cache.set(i, { touch: this._seq++, type: t.completion.kind, insertText: t.completion.insertText });
  }
  select(n, e, t) {
    if (t.length === 0) return 0;
    const i = n.getLineContent(e.lineNumber).substr(e.column - 10, e.column - 1);
    if (/\s$/.test(i)) return super.select(n, e, t);
    const s = t[0].score[0];
    let o = -1, r = -1, a = -1;
    for (let l = 0; l < t.length && t[l].score[0] === s; l++) {
      const d = `${n.getLanguageId()}/${t[l].textLabel}`, h = this._cache.peek(d);
      if (h && h.touch > a && h.type === t[l].completion.kind && h.insertText === t[l].completion.insertText && (a = h.touch, r = l), t[l].completion.preselect && o === -1) return l;
    }
    return r !== -1 ? r : o !== -1 ? o : 0;
  }
  toJSON() {
    return this._cache.toJSON();
  }
  fromJSON(n) {
    this._cache.clear();
    for (const [e, t] of n) t.touch = 0, t.type = typeof t.type == "number" ? t.type : $0.fromString(t.type), this._cache.set(e, t);
    this._seq = this._cache.size;
  }
}], ["first", Jz]]), W_._storagePrefix = "suggest/memories", W_ = B_ = jle([D9(0, Nr), D9(1, Ye)], W_);
const ok = tt("ISuggestMemories");
rt(ok, W_, 1);
var tT, qle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, $le = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let M0 = tT = class {
  constructor(n, e) {
    this._editor = n, this._enabled = !1, this._ckAtEnd = tT.AtEnd.bindTo(e), this._configListener = this._editor.onDidChangeConfiguration(((t) => t.hasChanged(123) && this._update())), this._update();
  }
  dispose() {
    var n;
    this._configListener.dispose(), (n = this._selectionListener) === null || n === void 0 || n.dispose(), this._ckAtEnd.reset();
  }
  _update() {
    const n = this._editor.getOption(123) === "on";
    if (this._enabled !== n) if (this._enabled = n, this._enabled) {
      const e = () => {
        if (!this._editor.hasModel()) return void this._ckAtEnd.set(!1);
        const t = this._editor.getModel(), i = this._editor.getSelection(), s = t.getWordAtPosition(i.getStartPosition());
        s ? this._ckAtEnd.set(s.endColumn === i.getStartPosition().column) : this._ckAtEnd.set(!1);
      };
      this._selectionListener = this._editor.onDidChangeCursorSelection(e), e();
    } else this._selectionListener && (this._ckAtEnd.reset(), this._selectionListener.dispose(), this._selectionListener = void 0);
  }
};
M0.AtEnd = new ae("atEndOfWord", !1), M0 = tT = qle([$le(1, Te)], M0);
var V_, Gle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Zle = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let eg = V_ = class {
  constructor(n, e) {
    this._editor = n, this._index = 0, this._ckOtherSuggestions = V_.OtherSuggestions.bindTo(e);
  }
  dispose() {
    this.reset();
  }
  reset() {
    var n;
    this._ckOtherSuggestions.reset(), (n = this._listener) === null || n === void 0 || n.dispose(), this._model = void 0, this._acceptNext = void 0, this._ignore = !1;
  }
  set({ model: n, index: e }, t) {
    if (n.items.length === 0) return void this.reset();
    V_._moveIndex(!0, n, e) !== e ? (this._acceptNext = t, this._model = n, this._index = e, this._listener = this._editor.onDidChangeCursorPosition((() => {
      this._ignore || this.reset();
    })), this._ckOtherSuggestions.set(!0)) : this.reset();
  }
  static _moveIndex(n, e, t) {
    let i = t;
    for (let s = e.items.length; s > 0 && (i = (i + e.items.length + (n ? 1 : -1)) % e.items.length, i !== t) && e.items[i].completion.additionalTextEdits; s--) ;
    return i;
  }
  next() {
    this._move(!0);
  }
  prev() {
    this._move(!1);
  }
  _move(n) {
    if (this._model) try {
      this._ignore = !0, this._index = V_._moveIndex(n, this._model, this._index), this._acceptNext({ index: this._index, item: this._model.items[this._index], model: this._model });
    } finally {
      this._ignore = !1;
    }
  }
};
eg.OtherSuggestions = new ae("hasOtherSuggestions", !1), eg = V_ = Gle([Zle(1, Te)], eg);
class Yle {
  constructor(e, t, i, s) {
    this._disposables = new G(), this._disposables.add(i.onDidSuggest(((o) => {
      o.completionModel.items.length === 0 && this.reset();
    }))), this._disposables.add(i.onDidCancel(((o) => {
      this.reset();
    }))), this._disposables.add(t.onDidShow((() => this._onItem(t.getFocusedItem())))), this._disposables.add(t.onDidFocus(this._onItem, this)), this._disposables.add(t.onDidHide(this.reset, this)), this._disposables.add(e.onWillType(((o) => {
      if (this._active && !t.isFrozen() && i.state !== 0) {
        const r = o.charCodeAt(o.length - 1);
        this._active.acceptCharacters.has(r) && e.getOption(0) && s(this._active.item);
      }
    })));
  }
  _onItem(e) {
    if (!e || !zn(e.item.completion.commitCharacters)) return void this.reset();
    if (this._active && this._active.item.item === e.item) return;
    const t = new Xw();
    for (const i of e.item.completion.commitCharacters) i.length > 0 && t.add(i.charCodeAt(0));
    this._active = { acceptCharacters: t, item: e };
  }
  reset() {
    this._active = void 0;
  }
  dispose() {
    this._disposables.dispose();
  }
}
class ho {
  async provideSelectionRanges(e, t) {
    const i = [];
    for (const s of t) {
      const o = [];
      i.push(o);
      const r = /* @__PURE__ */ new Map();
      await new Promise(((a) => ho._bracketsRightYield(a, 0, e, s, r))), await new Promise(((a) => ho._bracketsLeftYield(a, 0, e, s, r, o)));
    }
    return i;
  }
  static _bracketsRightYield(e, t, i, s, o) {
    const r = /* @__PURE__ */ new Map(), a = Date.now();
    for (; ; ) {
      if (t >= ho._maxRounds) {
        e();
        break;
      }
      if (!s) {
        e();
        break;
      }
      const l = i.bracketPairs.findNextBracket(s);
      if (!l) {
        e();
        break;
      }
      if (Date.now() - a > ho._maxDuration) {
        setTimeout((() => ho._bracketsRightYield(e, t + 1, i, s, o)));
        break;
      }
      if (l.bracketInfo.isOpeningBracket) {
        const d = l.bracketInfo.bracketText, h = r.has(d) ? r.get(d) : 0;
        r.set(d, h + 1);
      } else {
        const d = l.bracketInfo.getOpeningBrackets()[0].bracketText;
        let h = r.has(d) ? r.get(d) : 0;
        if (h -= 1, r.set(d, Math.max(0, h)), h < 0) {
          let c = o.get(d);
          c || (c = new fs(), o.set(d, c)), c.push(l.range);
        }
      }
      s = l.range.getEndPosition();
    }
  }
  static _bracketsLeftYield(e, t, i, s, o, r) {
    const a = /* @__PURE__ */ new Map(), l = Date.now();
    for (; ; ) {
      if (t >= ho._maxRounds && o.size === 0) {
        e();
        break;
      }
      if (!s) {
        e();
        break;
      }
      const d = i.bracketPairs.findPrevBracket(s);
      if (!d) {
        e();
        break;
      }
      if (Date.now() - l > ho._maxDuration) {
        setTimeout((() => ho._bracketsLeftYield(e, t + 1, i, s, o, r)));
        break;
      }
      if (d.bracketInfo.isOpeningBracket) {
        const h = d.bracketInfo.bracketText;
        let c = a.has(h) ? a.get(h) : 0;
        if (c -= 1, a.set(h, Math.max(0, c)), c < 0) {
          const u = o.get(h);
          if (u) {
            const g = u.shift();
            u.size === 0 && o.delete(h);
            const p = D.fromPositions(d.range.getEndPosition(), g.getStartPosition()), f = D.fromPositions(d.range.getStartPosition(), g.getEndPosition());
            r.push({ range: p }), r.push({ range: f }), ho._addBracketLeading(i, f, r);
          }
        }
      } else {
        const h = d.bracketInfo.getOpeningBrackets()[0].bracketText, c = a.has(h) ? a.get(h) : 0;
        a.set(h, c + 1);
      }
      s = d.range.getStartPosition();
    }
  }
  static _addBracketLeading(e, t, i) {
    if (t.startLineNumber === t.endLineNumber) return;
    const s = t.startLineNumber, o = e.getLineFirstNonWhitespaceColumn(s);
    o !== 0 && o !== t.startColumn && (i.push({ range: D.fromPositions(new W(s, o), t.getEndPosition()) }), i.push({ range: D.fromPositions(new W(s, 1), t.getEndPosition()) }));
    const r = s - 1;
    if (r > 0) {
      const a = e.getLineFirstNonWhitespaceColumn(r);
      a === t.startColumn && a !== e.getLineLastNonWhitespaceColumn(r) && (i.push({ range: D.fromPositions(new W(r, a), t.getEndPosition()) }), i.push({ range: D.fromPositions(new W(r, 1), t.getEndPosition()) }));
    }
  }
}
ho._maxDuration = 30, ho._maxRounds = 2;
class Yr {
  static async create(e, t) {
    if (!t.getOption(118).localityBonus || !t.hasModel()) return Yr.None;
    const i = t.getModel(), s = t.getPosition();
    if (!e.canComputeWordRanges(i.uri)) return Yr.None;
    const [o] = await new ho().provideSelectionRanges(i, [s]);
    if (o.length === 0) return Yr.None;
    const r = await e.computeWordRanges(i.uri, o[0].range);
    if (!r) return Yr.None;
    const a = i.getWordUntilPosition(s);
    return delete r[a.word], new class extends Yr {
      distance(l, d) {
        if (!s.equals(t.getPosition())) return 0;
        if (d.kind === 17) return 2 << 20;
        const h = typeof d.label == "string" ? d.label : d.label.label, c = r[h];
        if (p7(c)) return 2 << 20;
        const u = H0(c, D.fromPositions(l), D.compareRangesUsingStarts), g = u >= 0 ? c[u] : c[Math.max(0, ~u - 1)];
        let p = o.length;
        for (const f of o) {
          if (!D.containsRange(f.range, g)) break;
          p -= 1;
        }
        return p;
      }
    }();
  }
}
Yr.None = new class extends Yr {
  distance() {
    return 0;
  }
}();
let x9 = class {
  constructor(n, e) {
    this.leadingLineContent = n, this.characterCountDelta = e;
  }
};
class Sh {
  constructor(e, t, i, s, o, r, a = _L.default, l = void 0) {
    this.clipboardText = l, this._snippetCompareFn = Sh._compareCompletionItems, this._items = e, this._column = t, this._wordDistance = s, this._options = o, this._refilterKind = 1, this._lineContext = i, this._fuzzyScoreOptions = a, r === "top" ? this._snippetCompareFn = Sh._compareCompletionItemsSnippetsUp : r === "bottom" && (this._snippetCompareFn = Sh._compareCompletionItemsSnippetsDown);
  }
  get lineContext() {
    return this._lineContext;
  }
  set lineContext(e) {
    this._lineContext.leadingLineContent === e.leadingLineContent && this._lineContext.characterCountDelta === e.characterCountDelta || (this._refilterKind = this._lineContext.characterCountDelta < e.characterCountDelta && this._filteredItems ? 2 : 1, this._lineContext = e);
  }
  get items() {
    return this._ensureCachedState(), this._filteredItems;
  }
  getItemsByProvider() {
    return this._ensureCachedState(), this._itemsByProvider;
  }
  getIncompleteProvider() {
    this._ensureCachedState();
    const e = /* @__PURE__ */ new Set();
    for (const [t, i] of this.getItemsByProvider()) i.length > 0 && i[0].container.incomplete && e.add(t);
    return e;
  }
  get stats() {
    return this._ensureCachedState(), this._stats;
  }
  _ensureCachedState() {
    this._refilterKind !== 0 && this._createCachedState();
  }
  _createCachedState() {
    this._itemsByProvider = /* @__PURE__ */ new Map();
    const e = [], { leadingLineContent: t, characterCountDelta: i } = this._lineContext;
    let s = "", o = "";
    const r = this._refilterKind === 1 ? this._items : this._filteredItems, a = [], l = !this._options.filterGraceful || r.length > 2e3 ? ug : MJ;
    for (let d = 0; d < r.length; d++) {
      const h = r[d];
      if (h.isInvalid) continue;
      const c = this._itemsByProvider.get(h.provider);
      c ? c.push(h) : this._itemsByProvider.set(h.provider, [h]);
      const u = h.position.column - h.editStart.column, g = u + i - (h.position.column - this._column);
      if (s.length !== g && (s = g === 0 ? "" : t.slice(-g), o = s.toLowerCase()), h.word = s, g === 0) h.score = la.Default;
      else {
        let p = 0;
        for (; p < u; ) {
          const f = s.charCodeAt(p);
          if (f !== 32 && f !== 9) break;
          p += 1;
        }
        if (p >= g) h.score = la.Default;
        else if (typeof h.completion.filterText == "string") {
          const f = l(s, o, p, h.completion.filterText, h.filterTextLow, 0, this._fuzzyScoreOptions);
          if (!f) continue;
          yE(h.completion.filterText, h.textLabel) === 0 ? h.score = f : (h.score = EJ(s, o, p, h.textLabel, h.labelLow, 0), h.score[0] = f[0]);
        } else {
          const f = l(s, o, p, h.textLabel, h.labelLow, 0, this._fuzzyScoreOptions);
          if (!f) continue;
          h.score = f;
        }
      }
      h.idx = d, h.distance = this._wordDistance.distance(h.position, h.completion), a.push(h), e.push(h.textLabel.length);
    }
    this._filteredItems = a.sort(this._snippetCompareFn), this._refilterKind = 0, this._stats = { pLabelLen: e.length ? CN(e.length - 0.85, e, ((d, h) => d - h)) : 0 };
  }
  static _compareCompletionItems(e, t) {
    return e.score[0] > t.score[0] ? -1 : e.score[0] < t.score[0] ? 1 : e.distance < t.distance ? -1 : e.distance > t.distance ? 1 : e.idx < t.idx ? -1 : e.idx > t.idx ? 1 : 0;
  }
  static _compareCompletionItemsSnippetsDown(e, t) {
    if (e.completion.kind !== t.completion.kind) {
      if (e.completion.kind === 27) return 1;
      if (t.completion.kind === 27) return -1;
    }
    return Sh._compareCompletionItems(e, t);
  }
  static _compareCompletionItemsSnippetsUp(e, t) {
    if (e.completion.kind !== t.completion.kind) {
      if (e.completion.kind === 27) return -1;
      if (t.completion.kind === 27) return 1;
    }
    return Sh._compareCompletionItems(e, t);
  }
}
var iT, Xle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Xd = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class tu {
  static shouldAutoTrigger(e) {
    if (!e.hasModel()) return !1;
    const t = e.getModel(), i = e.getPosition();
    t.tokenization.tokenizeIfCheap(i.lineNumber);
    const s = t.getWordAtPosition(i);
    return !!s && (s.endColumn === i.column || s.startColumn + 1 === i.column) && !!isNaN(Number(s.word));
  }
  constructor(e, t, i) {
    this.leadingLineContent = e.getLineContent(t.lineNumber).substr(0, t.column - 1), this.leadingWord = e.getWordUntilPosition(t), this.lineNumber = t.lineNumber, this.column = t.column, this.triggerOptions = i;
  }
}
let kS = iT = class {
  constructor(n, e, t, i, s, o, r, a, l) {
    this._editor = n, this._editorWorkerService = e, this._clipboardService = t, this._telemetryService = i, this._logService = s, this._contextKeyService = o, this._configurationService = r, this._languageFeaturesService = a, this._envService = l, this._toDispose = new G(), this._triggerCharacterListener = new G(), this._triggerQuickSuggest = new Dr(), this._triggerState = void 0, this._completionDisposables = new G(), this._onDidCancel = new F(), this._onDidTrigger = new F(), this._onDidSuggest = new F(), this.onDidCancel = this._onDidCancel.event, this.onDidTrigger = this._onDidTrigger.event, this.onDidSuggest = this._onDidSuggest.event, this._telemetryGate = 0, this._currentSelection = this._editor.getSelection() || new _e(1, 1, 1, 1), this._toDispose.add(this._editor.onDidChangeModel((() => {
      this._updateTriggerCharacters(), this.cancel();
    }))), this._toDispose.add(this._editor.onDidChangeModelLanguage((() => {
      this._updateTriggerCharacters(), this.cancel();
    }))), this._toDispose.add(this._editor.onDidChangeConfiguration((() => {
      this._updateTriggerCharacters();
    }))), this._toDispose.add(this._languageFeaturesService.completionProvider.onDidChange((() => {
      this._updateTriggerCharacters(), this._updateActiveSuggestSession();
    })));
    let d = !1;
    this._toDispose.add(this._editor.onDidCompositionStart((() => {
      d = !0;
    }))), this._toDispose.add(this._editor.onDidCompositionEnd((() => {
      d = !1, this._onCompositionEnd();
    }))), this._toDispose.add(this._editor.onDidChangeCursorSelection(((h) => {
      d || this._onCursorChange(h);
    }))), this._toDispose.add(this._editor.onDidChangeModelContent((() => {
      d || this._triggerState === void 0 || this._refilterCompletionItems();
    }))), this._updateTriggerCharacters();
  }
  dispose() {
    Ht(this._triggerCharacterListener), Ht([this._onDidCancel, this._onDidSuggest, this._onDidTrigger, this._triggerQuickSuggest]), this._toDispose.dispose(), this._completionDisposables.dispose(), this.cancel();
  }
  _updateTriggerCharacters() {
    if (this._triggerCharacterListener.clear(), this._editor.getOption(91) || !this._editor.hasModel() || !this._editor.getOption(121)) return;
    const n = /* @__PURE__ */ new Map();
    for (const t of this._languageFeaturesService.completionProvider.all(this._editor.getModel())) for (const i of t.triggerCharacters || []) {
      let s = n.get(i);
      s || (s = /* @__PURE__ */ new Set(), s.add(void 0), n.set(i, s)), s.add(t);
    }
    const e = (t) => {
      var i;
      if (!(function(r, a, l) {
        if (!a.getContextKeyValue("inlineSuggestionVisible")) return !0;
        const d = a.getContextKeyValue(un.suppressSuggestions.key);
        return d !== void 0 ? !d : !r.getOption(62).suppressSuggestions;
      })(this._editor, this._contextKeyService, this._configurationService) || tu.shouldAutoTrigger(this._editor)) return;
      if (!t) {
        const r = this._editor.getPosition();
        t = this._editor.getModel().getLineContent(r.lineNumber).substr(0, r.column - 1);
      }
      let s = "";
      og(t.charCodeAt(t.length - 1)) ? en(t.charCodeAt(t.length - 2)) && (s = t.substr(t.length - 2)) : s = t.charAt(t.length - 1);
      const o = n.get(s);
      if (o) {
        const r = /* @__PURE__ */ new Map();
        if (this._completionModel) for (const [a, l] of this._completionModel.getItemsByProvider()) o.has(a) || r.set(a, l);
        this.trigger({ auto: !0, triggerKind: 1, triggerCharacter: s, retrigger: !!this._completionModel, clipboardText: (i = this._completionModel) === null || i === void 0 ? void 0 : i.clipboardText, completionOptions: { providerFilter: o, providerItemsToReuse: r } });
      }
    };
    this._triggerCharacterListener.add(this._editor.onDidType(e)), this._triggerCharacterListener.add(this._editor.onDidCompositionEnd((() => e())));
  }
  get state() {
    return this._triggerState ? this._triggerState.auto ? 2 : 1 : 0;
  }
  cancel(n = !1) {
    var e;
    this._triggerState !== void 0 && (this._triggerQuickSuggest.cancel(), (e = this._requestToken) === null || e === void 0 || e.cancel(), this._requestToken = void 0, this._triggerState = void 0, this._completionModel = void 0, this._context = void 0, this._onDidCancel.fire({ retrigger: n }));
  }
  clear() {
    this._completionDisposables.clear();
  }
  _updateActiveSuggestSession() {
    this._triggerState !== void 0 && (this._editor.hasModel() && this._languageFeaturesService.completionProvider.has(this._editor.getModel()) ? this.trigger({ auto: this._triggerState.auto, retrigger: !0 }) : this.cancel());
  }
  _onCursorChange(n) {
    if (!this._editor.hasModel()) return;
    const e = this._currentSelection;
    this._currentSelection = this._editor.getSelection(), !n.selection.isEmpty() || n.reason !== 0 && n.reason !== 3 || n.source !== "keyboard" && n.source !== "deleteLeft" ? this.cancel() : this._triggerState === void 0 && n.reason === 0 ? (e.containsRange(this._currentSelection) || e.getEndPosition().isBeforeOrEqual(this._currentSelection.getPosition())) && this._doTriggerQuickSuggest() : this._triggerState !== void 0 && n.reason === 3 && this._refilterCompletionItems();
  }
  _onCompositionEnd() {
    this._triggerState === void 0 ? this._doTriggerQuickSuggest() : this._refilterCompletionItems();
  }
  _doTriggerQuickSuggest() {
    var n;
    qp.isAllOff(this._editor.getOption(89)) || this._editor.getOption(118).snippetsPreventQuickSuggestions && (!((n = _n.get(this._editor)) === null || n === void 0) && n.isInSnippet()) || (this.cancel(), this._triggerQuickSuggest.cancelAndSet((() => {
      if (this._triggerState !== void 0 || !tu.shouldAutoTrigger(this._editor) || !this._editor.hasModel() || !this._editor.hasWidgetFocus()) return;
      const e = this._editor.getModel(), t = this._editor.getPosition(), i = this._editor.getOption(89);
      if (!qp.isAllOff(i)) {
        if (!qp.isAllOn(i)) {
          e.tokenization.tokenizeIfCheap(t.lineNumber);
          const s = e.tokenization.getLineTokens(t.lineNumber), o = s.getStandardTokenType(s.findTokenIndexAtOffset(Math.max(t.column - 1 - 1, 0)));
          if (qp.valueFor(i, o) !== "on") return;
        }
        (function(s, o, r) {
          if (!o.getContextKeyValue(un.inlineSuggestionVisible.key)) return !0;
          const a = o.getContextKeyValue(un.suppressSuggestions.key);
          return a !== void 0 ? !a : !s.getOption(62).suppressSuggestions;
        })(this._editor, this._contextKeyService, this._configurationService) && this._languageFeaturesService.completionProvider.has(e) && this.trigger({ auto: !0 });
      }
    }), this._editor.getOption(90)));
  }
  _refilterCompletionItems() {
    vt(this._editor.hasModel()), vt(this._triggerState !== void 0);
    const n = this._editor.getModel(), e = this._editor.getPosition(), t = new tu(n, e, { ...this._triggerState, refilter: !0 });
    this._onNewContext(t);
  }
  trigger(n) {
    var e, t, i, s, o, r;
    if (!this._editor.hasModel()) return;
    const a = this._editor.getModel(), l = new tu(a, this._editor.getPosition(), n);
    this.cancel(n.retrigger), this._triggerState = n, this._onDidTrigger.fire({ auto: n.auto, shy: (e = n.shy) !== null && e !== void 0 && e, position: this._editor.getPosition() }), this._context = l;
    let d = { triggerKind: (t = n.triggerKind) !== null && t !== void 0 ? t : 0 };
    n.triggerCharacter && (d = { triggerKind: 1, triggerCharacter: n.triggerCharacter }), this._requestToken = new Ci();
    let h = 1;
    switch (this._editor.getOption(112)) {
      case "top":
        h = 0;
        break;
      case "bottom":
        h = 2;
    }
    const { itemKind: c, showDeprecated: u } = iT.createSuggestFilter(this._editor), g = new n1(h, (s = (i = n.completionOptions) === null || i === void 0 ? void 0 : i.kindFilter) !== null && s !== void 0 ? s : c, (o = n.completionOptions) === null || o === void 0 ? void 0 : o.providerFilter, (r = n.completionOptions) === null || r === void 0 ? void 0 : r.providerItemsToReuse, u), p = Yr.create(this._editorWorkerService, this._editor), f = NP(this._languageFeaturesService.completionProvider, a, this._editor.getPosition(), g, d, this._requestToken.token);
    Promise.all([f, p]).then((async ([_, v]) => {
      var b;
      if ((b = this._requestToken) === null || b === void 0 || b.dispose(), !this._editor.hasModel()) return;
      let C = n?.clipboardText;
      if (!C && _.needsClipboard && (C = await this._clipboardService.readText()), this._triggerState === void 0) return;
      const w = this._editor.getModel(), y = new tu(w, this._editor.getPosition(), n), L = { ..._L.default, firstMatchCanBeWeak: !this._editor.getOption(118).matchOnWordStartOnly };
      if (this._completionModel = new Sh(_.items, this._context.column, { leadingLineContent: y.leadingLineContent, characterCountDelta: y.column - this._context.column }, v, this._editor.getOption(118), this._editor.getOption(112), L, C), this._completionDisposables.add(_.disposable), this._onNewContext(y), this._reportDurationsTelemetry(_.durations), !this._envService.isBuilt || this._envService.isExtensionDevelopment) for (const k of _.items) k.isInvalid && this._logService.warn(`[suggest] did IGNORE invalid completion item from ${k.provider._debugDisplayName}`, k.completion);
    })).catch(We);
  }
  _reportDurationsTelemetry(n) {
    this._telemetryGate++ % 230 == 0 && setTimeout((() => {
      this._telemetryService.publicLog2("suggest.durations.json", { data: JSON.stringify(n) }), this._logService.debug("suggest.durations.json", n);
    }));
  }
  static createSuggestFilter(n) {
    const e = /* @__PURE__ */ new Set();
    n.getOption(112) === "none" && e.add(27);
    const t = n.getOption(118);
    return t.showMethods || e.add(0), t.showFunctions || e.add(1), t.showConstructors || e.add(2), t.showFields || e.add(3), t.showVariables || e.add(4), t.showClasses || e.add(5), t.showStructs || e.add(6), t.showInterfaces || e.add(7), t.showModules || e.add(8), t.showProperties || e.add(9), t.showEvents || e.add(10), t.showOperators || e.add(11), t.showUnits || e.add(12), t.showValues || e.add(13), t.showConstants || e.add(14), t.showEnums || e.add(15), t.showEnumMembers || e.add(16), t.showKeywords || e.add(17), t.showWords || e.add(18), t.showColors || e.add(19), t.showFiles || e.add(20), t.showReferences || e.add(21), t.showColors || e.add(22), t.showFolders || e.add(23), t.showTypeParameters || e.add(24), t.showSnippets || e.add(27), t.showUsers || e.add(25), t.showIssues || e.add(26), { itemKind: e, showDeprecated: t.showDeprecated };
  }
  _onNewContext(n) {
    if (this._context) if (n.lineNumber === this._context.lineNumber) if (Wt(n.leadingLineContent) === Wt(this._context.leadingLineContent)) {
      if (n.column < this._context.column) n.leadingWord.word ? this.trigger({ auto: this._context.triggerOptions.auto, retrigger: !0 }) : this.cancel();
      else if (this._completionModel) if (n.leadingWord.word.length !== 0 && n.leadingWord.startColumn > this._context.leadingWord.startColumn) {
        if (tu.shouldAutoTrigger(this._editor) && this._context) {
          const e = this._completionModel.getItemsByProvider();
          this.trigger({ auto: this._context.triggerOptions.auto, retrigger: !0, clipboardText: this._completionModel.clipboardText, completionOptions: { providerItemsToReuse: e } });
        }
      } else if (n.column > this._context.column && this._completionModel.getIncompleteProvider().size > 0 && n.leadingWord.word.length !== 0) {
        const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set();
        for (const [i, s] of this._completionModel.getItemsByProvider()) s.length > 0 && s[0].container.incomplete ? t.add(i) : e.set(i, s);
        this.trigger({ auto: this._context.triggerOptions.auto, triggerKind: 2, retrigger: !0, clipboardText: this._completionModel.clipboardText, completionOptions: { providerFilter: t, providerItemsToReuse: e } });
      } else {
        const e = this._completionModel.lineContext;
        let t = !1;
        if (this._completionModel.lineContext = { leadingLineContent: n.leadingLineContent, characterCountDelta: n.column - this._context.column }, this._completionModel.items.length === 0) {
          const i = tu.shouldAutoTrigger(this._editor);
          if (!this._context) return void this.cancel();
          if (i && this._context.leadingWord.endColumn < n.leadingWord.startColumn) return void this.trigger({ auto: this._context.triggerOptions.auto, retrigger: !0 });
          if (this._context.triggerOptions.auto) return void this.cancel();
          if (this._completionModel.lineContext = e, t = this._completionModel.items.length > 0, t && n.leadingWord.word.length === 0) return void this.cancel();
        }
        this._onDidSuggest.fire({ completionModel: this._completionModel, triggerOptions: n.triggerOptions, isFrozen: t });
      }
    } else this.cancel();
    else this.cancel();
  }
};
kS = iT = Xle([Xd(1, Qo), Xd(2, Kd), Xd(3, es), Xd(4, ts), Xd(5, Te), Xd(6, Ye), Xd(7, fe), Xd(8, cA)], kS);
class rk {
  constructor(e, t) {
    this._disposables = new G(), this._lastOvertyped = [], this._locked = !1, this._disposables.add(e.onWillType((() => {
      if (this._locked || !e.hasModel()) return;
      const i = e.getSelections(), s = i.length;
      let o = !1;
      for (let a = 0; a < s; a++) if (!i[a].isEmpty()) {
        o = !0;
        break;
      }
      if (!o) return void (this._lastOvertyped.length !== 0 && (this._lastOvertyped.length = 0));
      this._lastOvertyped = [];
      const r = e.getModel();
      for (let a = 0; a < s; a++) {
        const l = i[a];
        if (r.getValueLengthInRange(l) > rk._maxSelectionLength) return;
        this._lastOvertyped[a] = { value: r.getValueInRange(l), multiline: l.startLineNumber !== l.endLineNumber };
      }
    }))), this._disposables.add(t.onDidTrigger(((i) => {
      this._locked = !0;
    }))), this._disposables.add(t.onDidCancel(((i) => {
      this._locked = !1;
    })));
  }
  getLastOvertypedInfo(e) {
    if (e >= 0 && e < this._lastOvertyped.length) return this._lastOvertyped[e];
  }
  dispose() {
    this._disposables.dispose();
  }
}
rk._maxSelectionLength = 51200;
var Qle = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Gx = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Jle = class eU extends Ec {
  updateLabel() {
    const e = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
    if (!e) return super.updateLabel();
    this.label && (this.label.textContent = m(0, "{0} ({1})", this._action.label, eU.symbolPrintEnter(e)));
  }
  static symbolPrintEnter(e) {
    var t;
    return (t = e.getLabel()) === null || t === void 0 ? void 0 : t.replace(/\benter\b/gi, "⏎");
  }
}, nT = class {
  constructor(n, e, t, i, s) {
    this._menuId = e, this._menuService = i, this._contextKeyService = s, this._menuDisposables = new G(), this.element = Z(n, Q(".suggest-status-bar"));
    const o = (r) => r instanceof Eo ? t.createInstance(Jle, r, void 0) : void 0;
    this._leftActions = new sr(this.element, { actionViewItemProvider: o }), this._rightActions = new sr(this.element, { actionViewItemProvider: o }), this._leftActions.domNode.classList.add("left"), this._rightActions.domNode.classList.add("right");
  }
  dispose() {
    this._menuDisposables.dispose(), this._leftActions.dispose(), this._rightActions.dispose(), this.element.remove();
  }
  show() {
    const n = this._menuService.createMenu(this._menuId, this._contextKeyService), e = () => {
      const t = [], i = [];
      for (const [s, o] of n.getActions()) s === "left" ? t.push(...o) : i.push(...o);
      this._leftActions.clear(), this._leftActions.push(t), this._rightActions.clear(), this._rightActions.push(i);
    };
    this._menuDisposables.add(n.onDidChange((() => e()))), this._menuDisposables.add(n);
  }
  hide() {
    this._menuDisposables.clear();
  }
};
nT = Qle([Gx(2, Se), Gx(3, Mo), Gx(4, Te)], nT);
var ede = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, tde = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
function EP(n) {
  return !!n && !!(n.completion.documentation || n.completion.detail && n.completion.detail !== n.completion.label);
}
let sT = class {
  constructor(n, e) {
    this._editor = n, this._onDidClose = new F(), this.onDidClose = this._onDidClose.event, this._onDidChangeContents = new F(), this.onDidChangeContents = this._onDidChangeContents.event, this._disposables = new G(), this._renderDisposeable = new G(), this._borderWidth = 1, this._size = new bt(330, 0), this.domNode = Q(".suggest-details"), this.domNode.classList.add("no-docs"), this._markdownRenderer = e.createInstance(pl, { editor: n }), this._body = Q(".body"), this._scrollbar = new S1(this._body, { alwaysConsumeMouseWheel: !0 }), Z(this.domNode, this._scrollbar.getDomNode()), this._disposables.add(this._scrollbar), this._header = Z(this._body, Q(".header")), this._close = Z(this._header, Q("span" + Ee.asCSSSelector(ne.close))), this._close.title = m(0, "Close"), this._type = Z(this._header, Q("p.type")), this._docs = Z(this._body, Q("p.docs")), this._configureFont(), this._disposables.add(this._editor.onDidChangeConfiguration(((t) => {
      t.hasChanged(50) && this._configureFont();
    })));
  }
  dispose() {
    this._disposables.dispose(), this._renderDisposeable.dispose();
  }
  _configureFont() {
    const n = this._editor.getOptions(), e = n.get(50), t = e.getMassagedFontFamily(), i = n.get(119) || e.fontSize, s = n.get(120) || e.lineHeight, o = e.fontWeight, r = `${i}px`, a = `${s}px`;
    this.domNode.style.fontSize = r, this.domNode.style.lineHeight = "" + s / i, this.domNode.style.fontWeight = o, this.domNode.style.fontFeatureSettings = e.fontFeatureSettings, this._type.style.fontFamily = t, this._close.style.height = a, this._close.style.width = a;
  }
  getLayoutInfo() {
    const n = this._editor.getOption(120) || this._editor.getOption(50).lineHeight, e = this._borderWidth;
    return { lineHeight: n, borderWidth: e, borderHeight: 2 * e, verticalPadding: 22, horizontalPadding: 14 };
  }
  renderLoading() {
    this._type.textContent = m(0, "Loading..."), this._docs.textContent = "", this.domNode.classList.remove("no-docs", "no-type"), this.layout(this.size.width, 2 * this.getLayoutInfo().lineHeight), this._onDidChangeContents.fire(this);
  }
  renderItem(n, e) {
    var t, i;
    this._renderDisposeable.clear();
    let { detail: s, documentation: o } = n.completion;
    if (e) {
      let r = "";
      r += `score: ${n.score[0]}
`, r += `prefix: ${(t = n.word) !== null && t !== void 0 ? t : "(no prefix)"}
`, r += `word: ${n.completion.filterText ? n.completion.filterText + " (filterText)" : n.textLabel}
`, r += `distance: ${n.distance} (localityBonus-setting)
`, r += `index: ${n.idx}, based on ${n.completion.sortText && `sortText: "${n.completion.sortText}"` || "label"}
`, r += `commit_chars: ${(i = n.completion.commitCharacters) === null || i === void 0 ? void 0 : i.join("")}
`, o = new Vn().appendCodeblock("empty", r), s = `Provider: ${n.provider._debugDisplayName}`;
    }
    if (e || EP(n)) {
      if (this.domNode.classList.remove("no-docs", "no-type"), s) {
        const r = s.length > 1e5 ? `${s.substr(0, 1e5)}…` : s;
        this._type.textContent = r, this._type.title = r, bo(this._type), this._type.classList.toggle("auto-wrap", !/\r?\n^\s+/gim.test(r));
      } else Un(this._type), this._type.title = "", Ts(this._type), this.domNode.classList.add("no-type");
      if (Un(this._docs), typeof o == "string") this._docs.classList.remove("markdown-docs"), this._docs.textContent = o;
      else if (o) {
        this._docs.classList.add("markdown-docs"), Un(this._docs);
        const r = this._markdownRenderer.render(o);
        this._docs.appendChild(r.element), this._renderDisposeable.add(r), this._renderDisposeable.add(this._markdownRenderer.onDidRenderAsync((() => {
          this.layout(this._size.width, this._type.clientHeight + this._docs.clientHeight), this._onDidChangeContents.fire(this);
        })));
      }
      this.domNode.style.userSelect = "text", this.domNode.tabIndex = -1, this._close.onmousedown = (r) => {
        r.preventDefault(), r.stopPropagation();
      }, this._close.onclick = (r) => {
        r.preventDefault(), r.stopPropagation(), this._onDidClose.fire();
      }, this._body.scrollTop = 0, this.layout(this._size.width, this._type.clientHeight + this._docs.clientHeight), this._onDidChangeContents.fire(this);
    } else this.clearContents();
  }
  clearContents() {
    this.domNode.classList.add("no-docs"), this._type.textContent = "", this._docs.textContent = "";
  }
  get isEmpty() {
    return this.domNode.classList.contains("no-docs");
  }
  get size() {
    return this._size;
  }
  layout(n, e) {
    const t = new bt(n, e);
    bt.equals(t, this._size) || (this._size = t, (function(i, s, o) {
      typeof s == "number" && (i.style.width = `${s}px`), typeof o == "number" && (i.style.height = `${o}px`);
    })(this.domNode, n, e)), this._scrollbar.scanDomNode();
  }
  scrollDown(n = 8) {
    this._body.scrollTop += n;
  }
  scrollUp(n = 8) {
    this._body.scrollTop -= n;
  }
  scrollTop() {
    this._body.scrollTop = 0;
  }
  scrollBottom() {
    this._body.scrollTop = this._body.scrollHeight;
  }
  pageDown() {
    this.scrollDown(80);
  }
  pageUp() {
    this.scrollUp(80);
  }
  set borderWidth(n) {
    this._borderWidth = n;
  }
  get borderWidth() {
    return this._borderWidth;
  }
};
sT = ede([tde(1, Se)], sT);
class ide {
  constructor(e, t) {
    let i, s;
    this.widget = e, this._editor = t, this.allowEditorOverflow = !0, this._disposables = new G(), this._added = !1, this._preferAlignAtTop = !0, this._resizable = new bP(), this._resizable.domNode.classList.add("suggest-details-container"), this._resizable.domNode.appendChild(e.domNode), this._resizable.enableSashes(!1, !0, !0, !1);
    let o = 0, r = 0;
    this._disposables.add(this._resizable.onDidWillResize((() => {
      i = this._topLeft, s = this._resizable.size;
    }))), this._disposables.add(this._resizable.onDidResize(((a) => {
      if (i && s) {
        this.widget.layout(a.dimension.width, a.dimension.height);
        let l = !1;
        a.west && (r = s.width - a.dimension.width, l = !0), a.north && (o = s.height - a.dimension.height, l = !0), l && this._applyTopLeft({ top: i.top + o, left: i.left + r });
      }
      a.done && (i = void 0, s = void 0, o = 0, r = 0, this._userSize = a.dimension);
    }))), this._disposables.add(this.widget.onDidChangeContents((() => {
      var a;
      this._anchorBox && this._placeAtAnchor(this._anchorBox, (a = this._userSize) !== null && a !== void 0 ? a : this.widget.size, this._preferAlignAtTop);
    })));
  }
  dispose() {
    this._resizable.dispose(), this._disposables.dispose(), this.hide();
  }
  getId() {
    return "suggest.details";
  }
  getDomNode() {
    return this._resizable.domNode;
  }
  getPosition() {
    return this._topLeft ? { preference: this._topLeft } : null;
  }
  show() {
    this._added || (this._editor.addOverlayWidget(this), this._added = !0);
  }
  hide(e = !1) {
    this._resizable.clearSashHoverState(), this._added && (this._editor.removeOverlayWidget(this), this._added = !1, this._anchorBox = void 0, this._topLeft = void 0), e && (this._userSize = void 0, this.widget.clearContents());
  }
  placeAtAnchor(e, t) {
    var i;
    const s = e.getBoundingClientRect();
    this._anchorBox = s, this._preferAlignAtTop = t, this._placeAtAnchor(this._anchorBox, (i = this._userSize) !== null && i !== void 0 ? i : this.widget.size, t);
  }
  _placeAtAnchor(e, t, i) {
    var s;
    const o = Cc(this.getDomNode().ownerDocument.body), r = this.widget.getLayoutInfo(), a = new bt(220, 2 * r.lineHeight), l = e.top, d = (function() {
      const L = o.width - (e.left + e.width + r.borderWidth + r.horizontalPadding), k = -r.borderWidth + e.left + e.width, N = new bt(L, o.height - e.top - r.borderHeight - r.verticalPadding), A = N.with(void 0, e.top + e.height - r.borderHeight - r.verticalPadding);
      return { top: l, left: k, fit: L - t.width, maxSizeTop: N, maxSizeBottom: A, minSize: a.with(Math.min(L, a.width)) };
    })(), h = (function() {
      const L = e.left - r.borderWidth - r.horizontalPadding, k = Math.max(r.horizontalPadding, e.left - t.width - r.borderWidth), N = new bt(L, o.height - e.top - r.borderHeight - r.verticalPadding), A = N.with(void 0, e.top + e.height - r.borderHeight - r.verticalPadding);
      return { top: l, left: k, fit: L - t.width, maxSizeTop: N, maxSizeBottom: A, minSize: a.with(Math.min(L, a.width)) };
    })(), c = (function() {
      const L = e.left, k = -r.borderWidth + e.top + e.height, N = new bt(e.width - r.borderHeight, o.height - e.top - e.height - r.verticalPadding);
      return { top: k, left: L, fit: N.height - t.height, maxSizeBottom: N, maxSizeTop: N, minSize: a.with(N.width) };
    })(), u = [d, h, c], g = (s = u.find(((L) => L.fit >= 0))) !== null && s !== void 0 ? s : u.sort(((L, k) => k.fit - L.fit))[0], p = e.top + e.height - r.borderHeight;
    let f, _ = t.height;
    const v = Math.max(g.maxSizeTop.height, g.maxSizeBottom.height);
    let b;
    _ > v && (_ = v), i ? _ <= g.maxSizeTop.height ? (f = !0, b = g.maxSizeTop) : (f = !1, b = g.maxSizeBottom) : _ <= g.maxSizeBottom.height ? (f = !1, b = g.maxSizeBottom) : (f = !0, b = g.maxSizeTop);
    let { top: C, left: w } = g;
    !f && _ > e.height && (C = p - _);
    const y = this._editor.getDomNode();
    if (y) {
      const L = y.getBoundingClientRect();
      C -= L.top, w -= L.left;
    }
    this._applyTopLeft({ left: w, top: C }), this._resizable.enableSashes(!f, g === d, f, g !== d), this._resizable.minSize = g.minSize, this._resizable.maxSize = b, this._resizable.layout(_, Math.min(b.width, t.width)), this.widget.layout(this._resizable.size.width, this._resizable.size.height);
  }
  _applyTopLeft(e) {
    this._topLeft = e, this._editor.layoutOverlayWidget(this);
  }
}
var ll;
(function(n) {
  n[n.FILE = 0] = "FILE", n[n.FOLDER = 1] = "FOLDER", n[n.ROOT_FOLDER = 2] = "ROOT_FOLDER";
})(ll || (ll = {}));
const nde = /(?:\/|^)(?:([^\/]+)\/)?([^\/]+)$/;
function uC(n, e, t, i, s) {
  const o = i === ll.ROOT_FOLDER ? ["rootfolder-icon"] : i === ll.FOLDER ? ["folder-icon"] : ["file-icon"];
  if (t) {
    let r;
    if (t.scheme === Ue.data)
      r = Fh.parseMetaData(t).get(Fh.META_DATA_LABEL);
    else {
      const a = t.path.match(nde);
      a ? (r = gC(a[2].toLowerCase()), a[1] && o.push(`${gC(a[1].toLowerCase())}-name-dir-icon`)) : r = gC(t.authority.toLowerCase());
    }
    if (i === ll.ROOT_FOLDER) o.push(`${r}-root-name-folder-icon`);
    else if (i === ll.FOLDER) o.push(`${r}-name-folder-icon`);
    else {
      if (r) {
        if (o.push(`${r}-name-file-icon`), o.push("name-file-icon"), r.length <= 255) {
          const l = r.split(".");
          for (let d = 1; d < l.length; d++) o.push(`${l.slice(d).join(".")}-ext-file-icon`);
        }
        o.push("ext-file-icon");
      }
      const a = (function(l, d, h) {
        if (!h) return null;
        let c = null;
        if (h.scheme === Ue.data) {
          const u = Fh.parseMetaData(h).get(Fh.META_DATA_MIME);
          u && (c = d.getLanguageIdByMimeType(u));
        } else {
          const u = l.getModel(h);
          u && (c = u.getLanguageId());
        }
        return c && c !== ko ? c : d.guessLanguageIdByFilepathOrFirstLine(h);
      })(n, e, t);
      a && o.push(`${gC(a)}-lang-file-icon`);
    }
  }
  return o;
}
function gC(n) {
  return n.replace(/[\11\12\14\15\40]/g, "/");
}
var Qd, sde = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Zx = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
function tU(n) {
  return `suggest-aria-id:${n}`;
}
const ode = Ei("suggest-more-info", ne.chevronRight, m(0, "Icon for more information in the suggest widget.")), rde = new (Qd = class {
  extract(n, e) {
    if (n.textLabel.match(Qd._regexStrict)) return e[0] = n.textLabel, !0;
    if (n.completion.detail && n.completion.detail.match(Qd._regexStrict)) return e[0] = n.completion.detail, !0;
    if (n.completion.documentation) {
      const t = typeof n.completion.documentation == "string" ? n.completion.documentation : n.completion.documentation.value, i = Qd._regexRelaxed.exec(t);
      if (i && (i.index === 0 || i.index + i[0].length === t.length)) return e[0] = i[0], !0;
    }
    return !1;
  }
}, Qd._regexRelaxed = /(#([\da-fA-F]{3}){1,2}|(rgb|hsl)a\(\s*(\d{1,3}%?\s*,\s*){3}(1|0?\.\d+)\)|(rgb|hsl)\(\s*\d{1,3}%?(\s*,\s*\d{1,3}%?){2}\s*\))/, Qd._regexStrict = new RegExp(`^${Qd._regexRelaxed.source}$`, "i"), Qd)();
let oT = class {
  constructor(n, e, t, i) {
    this._editor = n, this._modelService = e, this._languageService = t, this._themeService = i, this._onDidToggleDetails = new F(), this.onDidToggleDetails = this._onDidToggleDetails.event, this.templateId = "suggestion";
  }
  dispose() {
    this._onDidToggleDetails.dispose();
  }
  renderTemplate(n) {
    const e = new G(), t = n;
    t.classList.add("show-file-icons");
    const i = Z(n, Q(".icon")), s = Z(i, Q("span.colorspan")), o = Z(n, Q(".contents")), r = Z(o, Q(".main")), a = Z(r, Q(".icon-label.codicon")), l = Z(r, Q("span.left")), d = Z(r, Q("span.right")), h = new Yy(l, { supportHighlights: !0, supportIcons: !0 });
    e.add(h);
    const c = Z(l, Q("span.signature-label")), u = Z(l, Q("span.qualifier-label")), g = Z(d, Q("span.details-label")), p = Z(d, Q("span.readMore" + Ee.asCSSSelector(ode)));
    return p.title = m(0, "Read More"), { root: t, left: l, right: d, icon: i, colorspan: s, iconLabel: h, iconContainer: a, parametersLabel: c, qualifierLabel: u, detailsLabel: g, readMore: p, disposables: e, configureFont: () => {
      const f = this._editor.getOptions(), _ = f.get(50), v = _.getMassagedFontFamily(), b = _.fontFeatureSettings, C = f.get(119) || _.fontSize, w = f.get(120) || _.lineHeight, y = _.fontWeight, L = `${C}px`, k = `${w}px`, N = `${_.letterSpacing}px`;
      t.style.fontSize = L, t.style.fontWeight = y, t.style.letterSpacing = N, r.style.fontFamily = v, r.style.fontFeatureSettings = b, r.style.lineHeight = k, i.style.height = k, i.style.width = k, p.style.height = k, p.style.width = k;
    } };
  }
  renderElement(n, e, t) {
    t.configureFont();
    const { completion: i } = n;
    t.root.id = tU(e), t.colorspan.style.backgroundColor = "";
    const s = { labelEscapeNewLines: !0, matches: I1(n.score) }, o = [];
    if (i.kind === 19 && rde.extract(n, o)) t.icon.className = "icon customcolor", t.iconContainer.className = "icon hide", t.colorspan.style.backgroundColor = o[0];
    else if (i.kind === 20 && this._themeService.getFileIconTheme().hasFileIcons) {
      t.icon.className = "icon hide", t.iconContainer.className = "icon hide";
      const r = uC(this._modelService, this._languageService, Ie.from({ scheme: "fake", path: n.textLabel }), ll.FILE), a = uC(this._modelService, this._languageService, Ie.from({ scheme: "fake", path: i.detail }), ll.FILE);
      s.extraClasses = r.length > a.length ? r : a;
    } else i.kind === 23 && this._themeService.getFileIconTheme().hasFolderIcons ? (t.icon.className = "icon hide", t.iconContainer.className = "icon hide", s.extraClasses = [uC(this._modelService, this._languageService, Ie.from({ scheme: "fake", path: n.textLabel }), ll.FOLDER), uC(this._modelService, this._languageService, Ie.from({ scheme: "fake", path: i.detail }), ll.FOLDER)].flat()) : (t.icon.className = "icon hide", t.iconContainer.className = "", t.iconContainer.classList.add("suggest-icon", ...Ee.asClassNameArray($0.toIcon(i.kind))));
    i.tags && i.tags.indexOf(1) >= 0 && (s.extraClasses = (s.extraClasses || []).concat(["deprecated"]), s.matches = []), t.iconLabel.setLabel(n.textLabel, void 0, s), typeof i.label == "string" ? (t.parametersLabel.textContent = "", t.detailsLabel.textContent = Yx(i.detail || ""), t.root.classList.add("string-label")) : (t.parametersLabel.textContent = Yx(i.label.detail || ""), t.detailsLabel.textContent = Yx(i.label.description || ""), t.root.classList.remove("string-label")), this._editor.getOption(118).showInlineDetails ? bo(t.detailsLabel) : Ts(t.detailsLabel), EP(n) ? (t.right.classList.add("can-expand-details"), bo(t.readMore), t.readMore.onmousedown = (r) => {
      r.stopPropagation(), r.preventDefault();
    }, t.readMore.onclick = (r) => {
      r.stopPropagation(), r.preventDefault(), this._onDidToggleDetails.fire();
    }) : (t.right.classList.remove("can-expand-details"), Ts(t.readMore), t.readMore.onmousedown = null, t.readMore.onclick = null);
  }
  disposeTemplate(n) {
    n.disposables.dispose();
  }
};
function Yx(n) {
  return n.replace(/\r\n|\r|\n/g, "");
}
oT = sde([Zx(1, ni), Zx(2, Xt), Zx(3, Yi)], oT);
var vp, ade = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, pC = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
I("editorSuggestWidget.background", { dark: xi, light: xi, hcDark: xi, hcLight: xi }, m(0, "Background color of the suggest widget.")), I("editorSuggestWidget.border", { dark: dd, light: dd, hcDark: dd, hcLight: dd }, m(0, "Border color of the suggest widget."));
const mC = I("editorSuggestWidget.foreground", { dark: Go, light: Go, hcDark: Go, hcLight: Go }, m(0, "Foreground color of the suggest widget."));
I("editorSuggestWidget.selectedForeground", { dark: Rh, light: Rh, hcDark: Rh, hcLight: Rh }, m(0, "Foreground color of the selected entry in the suggest widget.")), I("editorSuggestWidget.selectedIconForeground", { dark: Rp, light: Rp, hcDark: Rp, hcLight: Rp }, m(0, "Icon foreground color of the selected entry in the suggest widget."));
const lde = I("editorSuggestWidget.selectedBackground", { dark: Ah, light: Ah, hcDark: Ah, hcLight: Ah }, m(0, "Background color of the selected entry in the suggest widget."));
I("editorSuggestWidget.highlightForeground", { dark: Cr, light: Cr, hcDark: Cr, hcLight: Cr }, m(0, "Color of the match highlights in the suggest widget.")), I("editorSuggestWidget.focusHighlightForeground", { dark: lb, light: lb, hcDark: lb, hcLight: lb }, m(0, "Color of the match highlights in the suggest widget when an item is focused.")), I("editorSuggestWidgetStatus.foreground", { dark: Ce(mC, 0.5), light: Ce(mC, 0.5), hcDark: Ce(mC, 0.5), hcLight: Ce(mC, 0.5) }, m(0, "Foreground color of the suggest widget status."));
class dde {
  constructor(e, t) {
    this._service = e, this._key = `suggestWidget.size/${t.getEditorType()}/${t instanceof Mc}`;
  }
  restore() {
    var e;
    const t = (e = this._service.get(this._key, 0)) !== null && e !== void 0 ? e : "";
    try {
      const i = JSON.parse(t);
      if (bt.is(i)) return bt.lift(i);
    } catch {
    }
  }
  store(e) {
    this._service.store(this._key, JSON.stringify(e), 0, 1);
  }
  reset() {
    this._service.remove(this._key, 0);
  }
}
let H_ = vp = class {
  constructor(n, e, t, i, s) {
    this.editor = n, this._storageService = e, this._state = 0, this._isAuto = !1, this._pendingLayout = new rn(), this._pendingShowDetails = new rn(), this._ignoreFocusEvents = !1, this._forceRenderingAbove = !1, this._explainMode = !1, this._showTimeout = new Dr(), this._disposables = new G(), this._onDidSelect = new ng(), this._onDidFocus = new ng(), this._onDidHide = new F(), this._onDidShow = new F(), this.onDidSelect = this._onDidSelect.event, this.onDidFocus = this._onDidFocus.event, this.onDidHide = this._onDidHide.event, this.onDidShow = this._onDidShow.event, this._onDetailsKeydown = new F(), this.onDetailsKeyDown = this._onDetailsKeydown.event, this.element = new bP(), this.element.domNode.classList.add("editor-widget", "suggest-widget"), this._contentWidget = new hde(this, n), this._persistedSize = new dde(e, n);
    class o {
      constructor(u, g, p = !1, f = !1) {
        this.persistedSize = u, this.currentSize = g, this.persistHeight = p, this.persistWidth = f;
      }
    }
    let r;
    this._disposables.add(this.element.onDidWillResize((() => {
      this._contentWidget.lockPreference(), r = new o(this._persistedSize.restore(), this.element.size);
    }))), this._disposables.add(this.element.onDidResize(((c) => {
      var u, g, p, f;
      if (this._resize(c.dimension.width, c.dimension.height), r && (r.persistHeight = r.persistHeight || !!c.north || !!c.south, r.persistWidth = r.persistWidth || !!c.east || !!c.west), c.done) {
        if (r) {
          const { itemHeight: _, defaultSize: v } = this.getLayoutInfo(), b = Math.round(_ / 2);
          let { width: C, height: w } = this.element.size;
          (!r.persistHeight || Math.abs(r.currentSize.height - w) <= b) && (w = (g = (u = r.persistedSize) === null || u === void 0 ? void 0 : u.height) !== null && g !== void 0 ? g : v.height), (!r.persistWidth || Math.abs(r.currentSize.width - C) <= b) && (C = (f = (p = r.persistedSize) === null || p === void 0 ? void 0 : p.width) !== null && f !== void 0 ? f : v.width), this._persistedSize.store(new bt(C, w));
        }
        this._contentWidget.unlockPreference(), r = void 0;
      }
    }))), this._messageElement = Z(this.element.domNode, Q(".message")), this._listElement = Z(this.element.domNode, Q(".tree"));
    const a = this._disposables.add(s.createInstance(sT, this.editor));
    a.onDidClose(this.toggleDetails, this, this._disposables), this._details = new ide(a, this.editor);
    const l = () => this.element.domNode.classList.toggle("no-icons", !this.editor.getOption(118).showIcons);
    l();
    const d = s.createInstance(oT, this.editor);
    this._disposables.add(d), this._disposables.add(d.onDidToggleDetails((() => this.toggleDetails()))), this._list = new uo("SuggestWidget", this._listElement, { getHeight: (c) => this.getLayoutInfo().itemHeight, getTemplateId: (c) => "suggestion" }, [d], { alwaysConsumeMouseWheel: !0, useShadows: !1, mouseSupport: !1, multipleSelectionSupport: !1, accessibilityProvider: { getRole: () => "option", getWidgetAriaLabel: () => m(0, "Suggest"), getWidgetRole: () => "listbox", getAriaLabel: (c) => {
      let u = c.textLabel;
      if (typeof c.completion.label != "string") {
        const { detail: f, description: _ } = c.completion.label;
        f && _ ? u = m(0, "{0} {1}, {2}", u, f, _) : f ? u = m(0, "{0} {1}", u, f) : _ && (u = m(0, "{0}, {1}", u, _));
      }
      if (!c.isResolved || !this._isDetailsVisible()) return u;
      const { documentation: g, detail: p } = c.completion;
      return m(0, "{0}, docs: {1}", u, sg("{0}{1}", p || "", g ? typeof g == "string" ? g : g.value : ""));
    } } }), this._list.style(Mg({ listInactiveFocusBackground: lde, listInactiveFocusOutline: Zt })), this._status = s.createInstance(nT, this.element.domNode, dh);
    const h = () => this.element.domNode.classList.toggle("with-status-bar", this.editor.getOption(118).showStatusBar);
    h(), this._disposables.add(i.onDidColorThemeChange(((c) => this._onThemeChange(c)))), this._onThemeChange(i.getColorTheme()), this._disposables.add(this._list.onMouseDown(((c) => this._onListMouseDownOrTap(c)))), this._disposables.add(this._list.onTap(((c) => this._onListMouseDownOrTap(c)))), this._disposables.add(this._list.onDidChangeSelection(((c) => this._onListSelection(c)))), this._disposables.add(this._list.onDidChangeFocus(((c) => this._onListFocus(c)))), this._disposables.add(this.editor.onDidChangeCursorSelection((() => this._onCursorSelectionChanged()))), this._disposables.add(this.editor.onDidChangeConfiguration(((c) => {
      c.hasChanged(118) && (h(), l()), this._completionModel && (c.hasChanged(50) || c.hasChanged(119) || c.hasChanged(120)) && this._list.splice(0, this._list.length, this._completionModel.items);
    }))), this._ctxSuggestWidgetVisible = $e.Visible.bindTo(t), this._ctxSuggestWidgetDetailsVisible = $e.DetailsVisible.bindTo(t), this._ctxSuggestWidgetMultipleSuggestions = $e.MultipleSuggestions.bindTo(t), this._ctxSuggestWidgetHasFocusedSuggestion = $e.HasFocusedSuggestion.bindTo(t), this._disposables.add(bi(this._details.widget.domNode, "keydown", ((c) => {
      this._onDetailsKeydown.fire(c);
    }))), this._disposables.add(this.editor.onMouseDown(((c) => this._onEditorMouseDown(c))));
  }
  dispose() {
    var n;
    this._details.widget.dispose(), this._details.dispose(), this._list.dispose(), this._status.dispose(), this._disposables.dispose(), (n = this._loadingTimeout) === null || n === void 0 || n.dispose(), this._pendingLayout.dispose(), this._pendingShowDetails.dispose(), this._showTimeout.dispose(), this._contentWidget.dispose(), this.element.dispose();
  }
  _onEditorMouseDown(n) {
    this._details.widget.domNode.contains(n.target.element) ? this._details.widget.domNode.focus() : this.element.domNode.contains(n.target.element) && this.editor.focus();
  }
  _onCursorSelectionChanged() {
    this._state !== 0 && this._contentWidget.layout();
  }
  _onListMouseDownOrTap(n) {
    n.element !== void 0 && n.index !== void 0 && (n.browserEvent.preventDefault(), n.browserEvent.stopPropagation(), this._select(n.element, n.index));
  }
  _onListSelection(n) {
    n.elements.length && this._select(n.elements[0], n.indexes[0]);
  }
  _select(n, e) {
    const t = this._completionModel;
    t && (this._onDidSelect.fire({ item: n, index: e, model: t }), this.editor.focus());
  }
  _onThemeChange(n) {
    this._details.widget.borderWidth = aa(n.type) ? 2 : 1;
  }
  _onListFocus(n) {
    var e;
    if (this._ignoreFocusEvents) return;
    if (!n.elements.length) return this._currentSuggestionDetails && (this._currentSuggestionDetails.cancel(), this._currentSuggestionDetails = void 0, this._focusedItem = void 0), this.editor.setAriaOptions({ activeDescendant: void 0 }), void this._ctxSuggestWidgetHasFocusedSuggestion.set(!1);
    if (!this._completionModel) return;
    this._ctxSuggestWidgetHasFocusedSuggestion.set(!0);
    const t = n.elements[0], i = n.indexes[0];
    t !== this._focusedItem && ((e = this._currentSuggestionDetails) === null || e === void 0 || e.cancel(), this._currentSuggestionDetails = void 0, this._focusedItem = t, this._list.reveal(i), this._currentSuggestionDetails = on((async (s) => {
      const o = bc((() => {
        this._isDetailsVisible() && this.showDetails(!0);
      }), 250), r = s.onCancellationRequested((() => o.dispose()));
      try {
        return await t.resolve(s);
      } finally {
        o.dispose(), r.dispose();
      }
    })), this._currentSuggestionDetails.then((() => {
      i >= this._list.length || t !== this._list.element(i) || (this._ignoreFocusEvents = !0, this._list.splice(i, 1, [t]), this._list.setFocus([i]), this._ignoreFocusEvents = !1, this._isDetailsVisible() ? this.showDetails(!1) : this.element.domNode.classList.remove("docs-side"), this.editor.setAriaOptions({ activeDescendant: tU(i) }));
    })).catch(We)), this._onDidFocus.fire({ item: t, index: i, model: this._completionModel });
  }
  _setState(n) {
    if (this._state !== n) switch (this._state = n, this.element.domNode.classList.toggle("frozen", n === 4), this.element.domNode.classList.remove("message"), n) {
      case 0:
        Ts(this._messageElement, this._listElement, this._status.element), this._details.hide(!0), this._status.hide(), this._contentWidget.hide(), this._ctxSuggestWidgetVisible.reset(), this._ctxSuggestWidgetMultipleSuggestions.reset(), this._ctxSuggestWidgetHasFocusedSuggestion.reset(), this._showTimeout.cancel(), this.element.domNode.classList.remove("visible"), this._list.splice(0, this._list.length), this._focusedItem = void 0, this._cappedHeight = void 0, this._explainMode = !1;
        break;
      case 1:
        this.element.domNode.classList.add("message"), this._messageElement.textContent = vp.LOADING_MESSAGE, Ts(this._listElement, this._status.element), bo(this._messageElement), this._details.hide(), this._show(), this._focusedItem = void 0, vl(vp.LOADING_MESSAGE);
        break;
      case 2:
        this.element.domNode.classList.add("message"), this._messageElement.textContent = vp.NO_SUGGESTIONS_MESSAGE, Ts(this._listElement, this._status.element), bo(this._messageElement), this._details.hide(), this._show(), this._focusedItem = void 0, vl(vp.NO_SUGGESTIONS_MESSAGE);
        break;
      case 3:
      case 4:
        Ts(this._messageElement), bo(this._listElement, this._status.element), this._show();
        break;
      case 5:
        Ts(this._messageElement), bo(this._listElement, this._status.element), this._details.show(), this._show();
    }
  }
  _show() {
    this._status.show(), this._contentWidget.show(), this._layout(this._persistedSize.restore()), this._ctxSuggestWidgetVisible.set(!0), this._showTimeout.cancelAndSet((() => {
      this.element.domNode.classList.add("visible"), this._onDidShow.fire(this);
    }), 100);
  }
  showTriggered(n, e) {
    this._state === 0 && (this._contentWidget.setPosition(this.editor.getPosition()), this._isAuto = !!n, this._isAuto || (this._loadingTimeout = bc((() => this._setState(1)), e)));
  }
  showSuggestions(n, e, t, i, s) {
    var o, r;
    if (this._contentWidget.setPosition(this.editor.getPosition()), (o = this._loadingTimeout) === null || o === void 0 || o.dispose(), (r = this._currentSuggestionDetails) === null || r === void 0 || r.cancel(), this._currentSuggestionDetails = void 0, this._completionModel !== n && (this._completionModel = n), t && this._state !== 2 && this._state !== 0) return void this._setState(4);
    const a = this._completionModel.items.length, l = a === 0;
    if (this._ctxSuggestWidgetMultipleSuggestions.set(a > 1), l) return this._setState(i ? 0 : 2), void (this._completionModel = void 0);
    this._focusedItem = void 0, this._onDidFocus.pause(), this._onDidSelect.pause();
    try {
      this._list.splice(0, this._list.length, this._completionModel.items), this._setState(t ? 4 : 3), this._list.reveal(e, 0), this._list.setFocus(s ? [] : [e]);
    } finally {
      this._onDidFocus.resume(), this._onDidSelect.resume();
    }
    this._pendingLayout.value = Uw(ke(this.element.domNode), (() => {
      this._pendingLayout.clear(), this._layout(this.element.size), this._details.widget.domNode.classList.remove("focused");
    }));
  }
  focusSelected() {
    this._list.length > 0 && this._list.setFocus([0]);
  }
  selectNextPage() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.pageDown(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusNextPage(), !0;
    }
  }
  selectNext() {
    switch (this._state) {
      case 0:
        return !1;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusNext(1, !0), !0;
    }
  }
  selectLast() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.scrollBottom(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusLast(), !0;
    }
  }
  selectPreviousPage() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.pageUp(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusPreviousPage(), !0;
    }
  }
  selectPrevious() {
    switch (this._state) {
      case 0:
        return !1;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusPrevious(1, !0), !1;
    }
  }
  selectFirst() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.scrollTop(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusFirst(), !0;
    }
  }
  getFocusedItem() {
    if (this._state !== 0 && this._state !== 2 && this._state !== 1 && this._completionModel && this._list.getFocus().length > 0) return { item: this._list.getFocusedElements()[0], index: this._list.getFocus()[0], model: this._completionModel };
  }
  toggleDetailsFocus() {
    this._state === 5 ? (this._setState(3), this._details.widget.domNode.classList.remove("focused")) : this._state === 3 && this._isDetailsVisible() && (this._setState(5), this._details.widget.domNode.classList.add("focused"));
  }
  toggleDetails() {
    this._isDetailsVisible() ? (this._pendingShowDetails.clear(), this._ctxSuggestWidgetDetailsVisible.set(!1), this._setDetailsVisible(!1), this._details.hide(), this.element.domNode.classList.remove("shows-details")) : !EP(this._list.getFocusedElements()[0]) && !this._explainMode || this._state !== 3 && this._state !== 5 && this._state !== 4 || (this._ctxSuggestWidgetDetailsVisible.set(!0), this._setDetailsVisible(!0), this.showDetails(!1));
  }
  showDetails(n) {
    this._pendingShowDetails.value = Uw(ke(this.element.domNode), (() => {
      this._pendingShowDetails.clear(), this._details.show(), n ? this._details.widget.renderLoading() : this._details.widget.renderItem(this._list.getFocusedElements()[0], this._explainMode), this._details.widget.isEmpty ? this._details.hide() : (this._positionDetails(), this.element.domNode.classList.add("shows-details")), this.editor.focus();
    }));
  }
  toggleExplainMode() {
    this._list.getFocusedElements()[0] && (this._explainMode = !this._explainMode, this._isDetailsVisible() ? this.showDetails(!1) : this.toggleDetails());
  }
  resetPersistedSize() {
    this._persistedSize.reset();
  }
  hideWidget() {
    var n;
    this._pendingLayout.clear(), this._pendingShowDetails.clear(), (n = this._loadingTimeout) === null || n === void 0 || n.dispose(), this._setState(0), this._onDidHide.fire(this), this.element.clearSashHoverState();
    const e = this._persistedSize.restore(), t = Math.ceil(4.3 * this.getLayoutInfo().itemHeight);
    e && e.height < t && this._persistedSize.store(e.with(void 0, t));
  }
  isFrozen() {
    return this._state === 4;
  }
  _afterRender(n) {
    n !== null ? this._state !== 2 && this._state !== 1 && (this._isDetailsVisible() && !this._details.widget.isEmpty && this._details.show(), this._positionDetails()) : this._isDetailsVisible() && this._details.hide();
  }
  _layout(n) {
    var e, t, i;
    if (!this.editor.hasModel() || !this.editor.getDomNode()) return;
    const s = Cc(this.element.domNode.ownerDocument.body), o = this.getLayoutInfo();
    n || (n = o.defaultSize);
    let r = n.height, a = n.width;
    if (this._status.element.style.height = `${o.itemHeight}px`, this._state === 2 || this._state === 1) r = o.itemHeight + o.borderHeight, a = o.defaultSize.width / 2, this.element.enableSashes(!1, !1, !1, !1), this.element.minSize = this.element.maxSize = new bt(a, r), this._contentWidget.setPreference(2);
    else {
      const l = s.width - o.borderHeight - 2 * o.horizontalPadding;
      a > l && (a = l);
      const d = this._completionModel ? this._completionModel.stats.pLabelLen * o.typicalHalfwidthCharacterWidth : a, h = o.statusBarHeight + this._list.contentHeight + o.borderHeight, c = o.itemHeight + o.statusBarHeight, u = Ti(this.editor.getDomNode()), g = this.editor.getScrolledVisiblePosition(this.editor.getPosition()), p = u.top + g.top + g.height, f = Math.min(s.height - p - o.verticalPadding, h), _ = u.top + g.top - o.verticalPadding, v = Math.min(_, h);
      let b = Math.min(Math.max(v, f) + o.borderHeight, h);
      r === ((e = this._cappedHeight) === null || e === void 0 ? void 0 : e.capped) && (r = this._cappedHeight.wanted), r < c && (r = c), r > b && (r = b), r > f || this._forceRenderingAbove && _ > 150 ? (this._contentWidget.setPreference(1), this.element.enableSashes(!0, !0, !1, !1), b = v) : (this._contentWidget.setPreference(2), this.element.enableSashes(!1, !0, !0, !1), b = f), this.element.preferredSize = new bt(d, o.defaultSize.height), this.element.maxSize = new bt(l, b), this.element.minSize = new bt(220, c), this._cappedHeight = r === h ? { wanted: (i = (t = this._cappedHeight) === null || t === void 0 ? void 0 : t.wanted) !== null && i !== void 0 ? i : n.height, capped: r } : void 0;
    }
    this._resize(a, r);
  }
  _resize(n, e) {
    const { width: t, height: i } = this.element.maxSize;
    n = Math.min(t, n), e = Math.min(i, e);
    const { statusBarHeight: s } = this.getLayoutInfo();
    this._list.layout(e - s, n), this._listElement.style.height = e - s + "px", this.element.layout(e, n), this._contentWidget.layout(), this._positionDetails();
  }
  _positionDetails() {
    var n;
    this._isDetailsVisible() && this._details.placeAtAnchor(this.element.domNode, ((n = this._contentWidget.getPosition()) === null || n === void 0 ? void 0 : n.preference[0]) === 2);
  }
  getLayoutInfo() {
    const n = this.editor.getOption(50), e = as(this.editor.getOption(120) || n.lineHeight, 8, 1e3), t = this.editor.getOption(118).showStatusBar && this._state !== 2 && this._state !== 1 ? e : 0, i = this._details.widget.borderWidth, s = 2 * i;
    return { itemHeight: e, statusBarHeight: t, borderWidth: i, borderHeight: s, typicalHalfwidthCharacterWidth: n.typicalHalfwidthCharacterWidth, verticalPadding: 22, horizontalPadding: 14, defaultSize: new bt(430, t + 12 * e + s) };
  }
  _isDetailsVisible() {
    return this._storageService.getBoolean("expandSuggestionDocs", 0, !1);
  }
  _setDetailsVisible(n) {
    this._storageService.store("expandSuggestionDocs", n, 0, 0);
  }
  forceRenderingAbove() {
    this._forceRenderingAbove || (this._forceRenderingAbove = !0, this._layout(this._persistedSize.restore()));
  }
  stopForceRenderingAbove() {
    this._forceRenderingAbove = !1;
  }
};
H_.LOADING_MESSAGE = m(0, "Loading..."), H_.NO_SUGGESTIONS_MESSAGE = m(0, "No suggestions."), H_ = vp = ade([pC(1, Nr), pC(2, Te), pC(3, Yi), pC(4, Se)], H_);
class hde {
  constructor(e, t) {
    this._widget = e, this._editor = t, this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this._preferenceLocked = !1, this._added = !1, this._hidden = !1;
  }
  dispose() {
    this._added && (this._added = !1, this._editor.removeContentWidget(this));
  }
  getId() {
    return "editor.widget.suggestWidget";
  }
  getDomNode() {
    return this._widget.element.domNode;
  }
  show() {
    this._hidden = !1, this._added || (this._added = !0, this._editor.addContentWidget(this));
  }
  hide() {
    this._hidden || (this._hidden = !0, this.layout());
  }
  layout() {
    this._editor.layoutContentWidget(this);
  }
  getPosition() {
    return !this._hidden && this._position && this._preference ? { position: this._position, preference: [this._preference] } : null;
  }
  beforeRender() {
    const { height: e, width: t } = this._widget.element.size, { borderWidth: i, horizontalPadding: s } = this._widget.getLayoutInfo();
    return new bt(t + 2 * i + s, e + 2 * i);
  }
  afterRender(e) {
    this._widget._afterRender(e);
  }
  setPreference(e) {
    this._preferenceLocked || (this._preference = e);
  }
  lockPreference() {
    this._preferenceLocked = !0;
  }
  unlockPreference() {
    this._preferenceLocked = !1;
  }
  setPosition(e) {
    this._position = e;
  }
}
var rT, cde = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, ap = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class ude {
  constructor(e, t) {
    if (this._model = e, this._position = t, this._decorationOptions = Ve.register({ description: "suggest-line-suffix", stickiness: 1 }), e.getLineMaxColumn(t.lineNumber) !== t.column) {
      const i = e.getOffsetAt(t), s = e.getPositionAt(i + 1);
      e.changeDecorations(((o) => {
        this._marker && o.removeDecoration(this._marker), this._marker = o.addDecoration(D.fromPositions(t, s), this._decorationOptions);
      }));
    }
  }
  dispose() {
    this._marker && !this._model.isDisposed() && this._model.changeDecorations(((e) => {
      e.removeDecoration(this._marker), this._marker = void 0;
    }));
  }
  delta(e) {
    if (this._model.isDisposed() || this._position.lineNumber !== e.lineNumber) return 0;
    if (this._marker) {
      const t = this._model.getDecorationRange(this._marker);
      return this._model.getOffsetAt(t.getStartPosition()) - this._model.getOffsetAt(e);
    }
    return this._model.getLineMaxColumn(e.lineNumber) - e.column;
  }
}
let wr = rT = class {
  static get(n) {
    return n.getContribution(rT.ID);
  }
  constructor(n, e, t, i, s, o, r) {
    this._memoryService = e, this._commandService = t, this._contextKeyService = i, this._instantiationService = s, this._logService = o, this._telemetryService = r, this._lineSuffix = new rn(), this._toDispose = new G(), this._selectors = new gde(((h) => h.priority)), this._onWillInsertSuggestItem = new F(), this.onWillInsertSuggestItem = this._onWillInsertSuggestItem.event, this.editor = n, this.model = s.createInstance(kS, this.editor), this._selectors.register({ priority: 0, select: (h, c, u) => this._memoryService.select(h, c, u) });
    const a = $e.InsertMode.bindTo(i);
    a.set(n.getOption(118).insertMode), this._toDispose.add(this.model.onDidTrigger((() => a.set(n.getOption(118).insertMode)))), this.widget = this._toDispose.add(new Kk(ke(n.getDomNode()), (() => {
      const h = this._instantiationService.createInstance(H_, this.editor);
      this._toDispose.add(h), this._toDispose.add(h.onDidSelect(((f) => this._insertSuggestion(f, 0)), this));
      const c = new Yle(this.editor, h, this.model, ((f) => this._insertSuggestion(f, 2)));
      this._toDispose.add(c);
      const u = $e.MakesTextEdit.bindTo(this._contextKeyService), g = $e.HasInsertAndReplaceRange.bindTo(this._contextKeyService), p = $e.CanResolve.bindTo(this._contextKeyService);
      return this._toDispose.add(ye((() => {
        u.reset(), g.reset(), p.reset();
      }))), this._toDispose.add(h.onDidFocus((({ item: f }) => {
        const _ = this.editor.getPosition(), v = f.editStart.column, b = _.column;
        let C = !0;
        this.editor.getOption(1) !== "smart" || this.model.state !== 2 || f.completion.additionalTextEdits || 4 & f.completion.insertTextRules || b - v !== f.completion.insertText.length || (C = this.editor.getModel().getValueInRange({ startLineNumber: _.lineNumber, startColumn: v, endLineNumber: _.lineNumber, endColumn: b }) !== f.completion.insertText), u.set(C), g.set(!W.equals(f.editInsertEnd, f.editReplaceEnd)), p.set(!!f.provider.resolveCompletionItem || !!f.completion.documentation || f.completion.detail !== f.completion.label);
      }))), this._toDispose.add(h.onDetailsKeyDown(((f) => {
        f.toKeyCodeChord().equals(new Od(!0, !1, !1, !1, 33)) || Je && f.toKeyCodeChord().equals(new Od(!1, !1, !1, !0, 33)) ? f.stopPropagation() : f.toKeyCodeChord().isModifierKey() || this.editor.focus();
      }))), h;
    }))), this._overtypingCapturer = this._toDispose.add(new Kk(ke(n.getDomNode()), (() => this._toDispose.add(new rk(this.editor, this.model))))), this._alternatives = this._toDispose.add(new Kk(ke(n.getDomNode()), (() => this._toDispose.add(new eg(this.editor, this._contextKeyService))))), this._toDispose.add(s.createInstance(M0, n)), this._toDispose.add(this.model.onDidTrigger(((h) => {
      this.widget.value.showTriggered(h.auto, h.shy ? 250 : 50), this._lineSuffix.value = new ude(this.editor.getModel(), h.position);
    }))), this._toDispose.add(this.model.onDidSuggest(((h) => {
      if (h.triggerOptions.shy) return;
      let c = -1;
      for (const g of this._selectors.itemsOrderedByPriorityDesc) if (c = g.select(this.editor.getModel(), this.editor.getPosition(), h.completionModel.items), c !== -1) break;
      if (c === -1 && (c = 0), this.model.state === 0) return;
      let u = !1;
      if (h.triggerOptions.auto) {
        const g = this.editor.getOption(118);
        g.selectionMode === "never" || g.selectionMode === "always" ? u = g.selectionMode === "never" : g.selectionMode === "whenTriggerCharacter" ? u = h.triggerOptions.triggerKind !== 1 : g.selectionMode === "whenQuickSuggestion" && (u = h.triggerOptions.triggerKind === 1 && !h.triggerOptions.refilter);
      }
      this.widget.value.showSuggestions(h.completionModel, c, h.isFrozen, h.triggerOptions.auto, u);
    }))), this._toDispose.add(this.model.onDidCancel(((h) => {
      h.retrigger || this.widget.value.hideWidget();
    }))), this._toDispose.add(this.editor.onDidBlurEditorWidget((() => {
      this.model.cancel(), this.model.clear();
    })));
    const l = $e.AcceptSuggestionsOnEnter.bindTo(i), d = () => {
      const h = this.editor.getOption(1);
      l.set(h === "on" || h === "smart");
    };
    this._toDispose.add(this.editor.onDidChangeConfiguration((() => d()))), d();
  }
  dispose() {
    this._alternatives.dispose(), this._toDispose.dispose(), this.widget.dispose(), this.model.dispose(), this._lineSuffix.dispose(), this._onWillInsertSuggestItem.dispose();
  }
  _insertSuggestion(n, e) {
    if (!n || !n.item) return this._alternatives.value.reset(), this.model.cancel(), void this.model.clear();
    if (!this.editor.hasModel()) return;
    const t = _n.get(this.editor);
    if (!t) return;
    this._onWillInsertSuggestItem.fire({ item: n.item });
    const i = this.editor.getModel(), s = i.getAlternativeVersionId(), { item: o } = n, r = [], a = new Ci();
    1 & e || this.editor.pushUndoStop();
    const l = this.getOverwriteInfo(o, !!(8 & e));
    this._memoryService.memorize(i, this.editor.getPosition(), o);
    const d = o.isResolved;
    let h = -1, c = -1;
    if (Array.isArray(o.completion.additionalTextEdits)) {
      this.model.cancel();
      const g = wa.capture(this.editor);
      this.editor.executeEdits("suggestController.additionalTextEdits.sync", o.completion.additionalTextEdits.map(((p) => {
        let f = D.lift(p.range);
        if (f.startLineNumber === o.position.lineNumber && f.startColumn > o.position.column) {
          const _ = this.editor.getPosition().column - o.position.column, v = _, b = D.spansMultipleLines(f) ? 0 : _;
          f = new D(f.startLineNumber, f.startColumn + v, f.endLineNumber, f.endColumn + b);
        }
        return ii.replaceMove(f, p.text);
      }))), g.restoreRelativeVerticalPositionOfCursor(this.editor);
    } else if (!d) {
      const g = new Rn();
      let p;
      const f = i.onDidChangeContent(((C) => {
        if (C.isFlush) return a.cancel(), void f.dispose();
        for (const w of C.changes) {
          const y = D.getEndPosition(w.range);
          p && !W.isBefore(y, p) || (p = y);
        }
      })), _ = e;
      e |= 2;
      let v = !1;
      const b = this.editor.onWillType((() => {
        b.dispose(), v = !0, 2 & _ || this.editor.pushUndoStop();
      }));
      r.push(o.resolve(a.token).then((() => {
        if (!o.completion.additionalTextEdits || a.token.isCancellationRequested) return;
        if (p && o.completion.additionalTextEdits.some(((w) => W.isBefore(p, D.getStartPosition(w.range))))) return !1;
        v && this.editor.pushUndoStop();
        const C = wa.capture(this.editor);
        return this.editor.executeEdits("suggestController.additionalTextEdits.async", o.completion.additionalTextEdits.map(((w) => ii.replaceMove(D.lift(w.range), w.text)))), C.restoreRelativeVerticalPositionOfCursor(this.editor), !v && 2 & _ || this.editor.pushUndoStop(), !0;
      })).then(((C) => {
        this._logService.trace("[suggest] async resolving of edits DONE (ms, applied?)", g.elapsed(), C), c = C === !0 ? 1 : C === !1 ? 0 : -2;
      })).finally((() => {
        f.dispose(), b.dispose();
      })));
    }
    let { insertText: u } = o.completion;
    if (4 & o.completion.insertTextRules || (u = bg.escape(u)), this.model.cancel(), t.insert(u, { overwriteBefore: l.overwriteBefore, overwriteAfter: l.overwriteAfter, undoStopBefore: !1, undoStopAfter: !1, adjustWhitespace: !(1 & o.completion.insertTextRules), clipboardText: n.model.clipboardText, overtypingCapturer: this._overtypingCapturer.value }), 2 & e || this.editor.pushUndoStop(), o.completion.command) if (o.completion.command.id === s1.id) this.model.trigger({ auto: !0, retrigger: !0 });
    else {
      const g = new Rn();
      r.push(this._commandService.executeCommand(o.completion.command.id, ...o.completion.command.arguments ? [...o.completion.command.arguments] : []).catch(((p) => {
        o.completion.extensionId ? Ni(p) : We(p);
      })).finally((() => {
        h = g.elapsed();
      })));
    }
    4 & e && this._alternatives.value.set(n, ((g) => {
      for (a.cancel(); i.canUndo(); ) {
        s !== i.getAlternativeVersionId() && i.undo(), this._insertSuggestion(g, 3 | (8 & e ? 8 : 0));
        break;
      }
    })), this._alertCompletionItem(o), Promise.all(r).finally((() => {
      this._reportSuggestionAcceptedTelemetry(o, i, d, h, c), this.model.clear(), a.dispose();
    }));
  }
  _reportSuggestionAcceptedTelemetry(n, e, t, i, s) {
    var o, r, a;
    Math.floor(100 * Math.random()) !== 0 && this._telemetryService.publicLog2("suggest.acceptedSuggestion", { extensionId: (r = (o = n.extensionId) === null || o === void 0 ? void 0 : o.value) !== null && r !== void 0 ? r : "unknown", providerId: (a = n.provider._debugDisplayName) !== null && a !== void 0 ? a : "unknown", kind: n.completion.kind, basenameHash: FS(ir(e.uri)).toString(16), languageId: e.getLanguageId(), fileExtension: wX(e.uri), resolveInfo: n.provider.resolveCompletionItem ? t ? 1 : 0 : -1, resolveDuration: n.resolveDuration, commandDuration: i, additionalEditsAsync: s });
  }
  getOverwriteInfo(n, e) {
    vt(this.editor.hasModel());
    let t = this.editor.getOption(118).insertMode === "replace";
    e && (t = !t);
    const i = n.position.column - n.editStart.column, s = (t ? n.editReplaceEnd.column : n.editInsertEnd.column) - n.position.column;
    return { overwriteBefore: i + (this.editor.getPosition().column - n.position.column), overwriteAfter: s + (this._lineSuffix.value ? this._lineSuffix.value.delta(this.editor.getPosition()) : 0) };
  }
  _alertCompletionItem(n) {
    zn(n.completion.additionalTextEdits) && Io(m(0, "Accepting '{0}' made {1} additional edits", n.textLabel, n.completion.additionalTextEdits.length));
  }
  triggerSuggest(n, e, t) {
    this.editor.hasModel() && (this.model.trigger({ auto: e != null && e, completionOptions: { providerFilter: n, kindFilter: t ? /* @__PURE__ */ new Set() : void 0 } }), this.editor.revealPosition(this.editor.getPosition(), 0), this.editor.focus());
  }
  triggerSuggestAndAcceptBest(n) {
    if (!this.editor.hasModel()) return;
    const e = this.editor.getPosition(), t = () => {
      e.equals(this.editor.getPosition()) && this._commandService.executeCommand(n.fallback);
    }, i = (s) => {
      if (4 & s.completion.insertTextRules || s.completion.additionalTextEdits) return !0;
      const o = this.editor.getPosition(), r = s.editStart.column, a = o.column;
      return a - r !== s.completion.insertText.length ? !0 : this.editor.getModel().getValueInRange({ startLineNumber: o.lineNumber, startColumn: r, endLineNumber: o.lineNumber, endColumn: a }) !== s.completion.insertText;
    };
    se.once(this.model.onDidTrigger)(((s) => {
      const o = [];
      se.any(this.model.onDidTrigger, this.model.onDidCancel)((() => {
        Ht(o), t();
      }), void 0, o), this.model.onDidSuggest((({ completionModel: r }) => {
        if (Ht(o), r.items.length === 0) return void t();
        const a = this._memoryService.select(this.editor.getModel(), this.editor.getPosition(), r.items), l = r.items[a];
        i(l) ? (this.editor.pushUndoStop(), this._insertSuggestion({ index: a, item: l, model: r }, 7)) : t();
      }), void 0, o);
    })), this.model.trigger({ auto: !1, shy: !0 }), this.editor.revealPosition(e, 0), this.editor.focus();
  }
  acceptSelectedSuggestion(n, e) {
    const t = this.widget.value.getFocusedItem();
    let i = 0;
    n && (i |= 4), e && (i |= 8), this._insertSuggestion(t, i);
  }
  acceptNextSuggestion() {
    this._alternatives.value.next();
  }
  acceptPrevSuggestion() {
    this._alternatives.value.prev();
  }
  cancelSuggestWidget() {
    this.model.cancel(), this.model.clear(), this.widget.value.hideWidget();
  }
  focusSuggestion() {
    this.widget.value.focusSelected();
  }
  selectNextSuggestion() {
    this.widget.value.selectNext();
  }
  selectNextPageSuggestion() {
    this.widget.value.selectNextPage();
  }
  selectLastSuggestion() {
    this.widget.value.selectLast();
  }
  selectPrevSuggestion() {
    this.widget.value.selectPrevious();
  }
  selectPrevPageSuggestion() {
    this.widget.value.selectPreviousPage();
  }
  selectFirstSuggestion() {
    this.widget.value.selectFirst();
  }
  toggleSuggestionDetails() {
    this.widget.value.toggleDetails();
  }
  toggleExplainMode() {
    this.widget.value.toggleExplainMode();
  }
  toggleSuggestionFocus() {
    this.widget.value.toggleDetailsFocus();
  }
  resetWidgetSize() {
    this.widget.value.resetPersistedSize();
  }
  forceRenderingAbove() {
    this.widget.value.forceRenderingAbove();
  }
  stopForceRenderingAbove() {
    this.widget.isInitialized && this.widget.value.stopForceRenderingAbove();
  }
  registerSelector(n) {
    return this._selectors.register(n);
  }
};
wr.ID = "editor.contrib.suggestController", wr = rT = cde([ap(1, ok), ap(2, ai), ap(3, Te), ap(4, Se), ap(5, ts), ap(6, es)], wr);
class gde {
  constructor(e) {
    this.prioritySelector = e, this._items = new Array();
  }
  register(e) {
    if (this._items.indexOf(e) !== -1) throw new Error("Value is already registered");
    return this._items.push(e), this._items.sort(((t, i) => this.prioritySelector(i) - this.prioritySelector(t))), { dispose: () => {
      const t = this._items.indexOf(e);
      t >= 0 && this._items.splice(t, 1);
    } };
  }
  get itemsOrderedByPriorityDesc() {
    return this._items;
  }
}
class s1 extends he {
  constructor() {
    super({ id: s1.id, label: m(0, "Trigger Suggest"), alias: "Trigger Suggest", precondition: q.and(E.writable, E.hasCompletionItemProvider, $e.Visible.toNegated()), kbOpts: { kbExpr: E.textInputFocus, primary: 2058, secondary: [2087], mac: { primary: 266, secondary: [521, 2087] }, weight: 100 } });
  }
  run(e, t, i) {
    const s = wr.get(t);
    if (!s) return;
    let o;
    i && typeof i == "object" && i.auto === !0 && (o = !0), s.triggerSuggest(void 0, o, void 0);
  }
}
s1.id = "editor.action.triggerSuggest", ft(wr.ID, wr, 2), X(s1);
const no = 190, ns = Zi.bindToContribution(wr.get);
re(new ns({ id: "acceptSelectedSuggestion", precondition: q.and($e.Visible, $e.HasFocusedSuggestion), handler(n) {
  n.acceptSelectedSuggestion(!0, !1);
}, kbOpts: [{ primary: 2, kbExpr: q.and($e.Visible, E.textInputFocus), weight: no }, { primary: 3, kbExpr: q.and($e.Visible, E.textInputFocus, $e.AcceptSuggestionsOnEnter, $e.MakesTextEdit), weight: no }], menuOpts: [{ menuId: dh, title: m(0, "Insert"), group: "left", order: 1, when: $e.HasInsertAndReplaceRange.toNegated() }, { menuId: dh, title: m(0, "Insert"), group: "left", order: 1, when: q.and($e.HasInsertAndReplaceRange, $e.InsertMode.isEqualTo("insert")) }, { menuId: dh, title: m(0, "Replace"), group: "left", order: 1, when: q.and($e.HasInsertAndReplaceRange, $e.InsertMode.isEqualTo("replace")) }] })), re(new ns({ id: "acceptAlternativeSelectedSuggestion", precondition: q.and($e.Visible, E.textInputFocus, $e.HasFocusedSuggestion), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 1027, secondary: [1026] }, handler(n) {
  n.acceptSelectedSuggestion(!1, !0);
}, menuOpts: [{ menuId: dh, group: "left", order: 2, when: q.and($e.HasInsertAndReplaceRange, $e.InsertMode.isEqualTo("insert")), title: m(0, "Replace") }, { menuId: dh, group: "left", order: 2, when: q.and($e.HasInsertAndReplaceRange, $e.InsertMode.isEqualTo("replace")), title: m(0, "Insert") }] })), dt.registerCommandAlias("acceptSelectedSuggestionOnEnter", "acceptSelectedSuggestion"), re(new ns({ id: "hideSuggestWidget", precondition: $e.Visible, handler: (n) => n.cancelSuggestWidget(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 9, secondary: [1033] } })), re(new ns({ id: "selectNextSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (n) => n.selectNextSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 18, secondary: [2066], mac: { primary: 18, secondary: [2066, 300] } } })), re(new ns({ id: "selectNextPageSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (n) => n.selectNextPageSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 12, secondary: [2060] } })), re(new ns({ id: "selectLastSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (n) => n.selectLastSuggestion() })), re(new ns({ id: "selectPrevSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (n) => n.selectPrevSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 16, secondary: [2064], mac: { primary: 16, secondary: [2064, 302] } } })), re(new ns({ id: "selectPrevPageSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (n) => n.selectPrevPageSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 11, secondary: [2059] } })), re(new ns({ id: "selectFirstSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (n) => n.selectFirstSuggestion() })), re(new ns({ id: "focusSuggestion", precondition: q.and($e.Visible, $e.HasFocusedSuggestion.negate()), handler: (n) => n.focusSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 2058, secondary: [2087], mac: { primary: 266, secondary: [2087] } } })), re(new ns({ id: "focusAndAcceptSuggestion", precondition: q.and($e.Visible, $e.HasFocusedSuggestion.negate()), handler: (n) => {
  n.focusSuggestion(), n.acceptSelectedSuggestion(!0, !1);
} })), re(new ns({ id: "toggleSuggestionDetails", precondition: q.and($e.Visible, $e.HasFocusedSuggestion), handler: (n) => n.toggleSuggestionDetails(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 2058, secondary: [2087], mac: { primary: 266, secondary: [2087] } }, menuOpts: [{ menuId: dh, group: "right", order: 1, when: q.and($e.DetailsVisible, $e.CanResolve), title: m(0, "show less") }, { menuId: dh, group: "right", order: 1, when: q.and($e.DetailsVisible.toNegated(), $e.CanResolve), title: m(0, "show more") }] })), re(new ns({ id: "toggleExplainMode", precondition: $e.Visible, handler: (n) => n.toggleExplainMode(), kbOpts: { weight: 100, primary: 2138 } })), re(new ns({ id: "toggleSuggestionFocus", precondition: $e.Visible, handler: (n) => n.toggleSuggestionFocus(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 2570, mac: { primary: 778 } } })), re(new ns({ id: "insertBestCompletion", precondition: q.and(E.textInputFocus, q.equals("config.editor.tabCompletion", "on"), M0.AtEnd, $e.Visible.toNegated(), eg.OtherSuggestions.toNegated(), _n.InSnippetMode.toNegated()), handler: (n, e) => {
  n.triggerSuggestAndAcceptBest(ms(e) ? { fallback: "tab", ...e } : { fallback: "tab" });
}, kbOpts: { weight: no, primary: 2 } })), re(new ns({ id: "insertNextSuggestion", precondition: q.and(E.textInputFocus, q.equals("config.editor.tabCompletion", "on"), eg.OtherSuggestions, $e.Visible.toNegated(), _n.InSnippetMode.toNegated()), handler: (n) => n.acceptNextSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 2 } })), re(new ns({ id: "insertPrevSuggestion", precondition: q.and(E.textInputFocus, q.equals("config.editor.tabCompletion", "on"), eg.OtherSuggestions, $e.Visible.toNegated(), _n.InSnippetMode.toNegated()), handler: (n) => n.acceptPrevSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 1026 } })), X(class extends he {
  constructor() {
    super({ id: "editor.action.resetSuggestSize", label: m(0, "Reset Suggest Widget Size"), alias: "Reset Suggest Widget Size", precondition: void 0 });
  }
  run(n, e) {
    var t;
    (t = wr.get(e)) === null || t === void 0 || t.resetWidgetSize();
  }
});
class pde extends V {
  get selectedItem() {
    return this._selectedItem;
  }
  constructor(e, t, i, s) {
    super(), this.editor = e, this.suggestControllerPreselector = t, this.checkModelVersion = i, this.onWillAccept = s, this.isSuggestWidgetVisible = !1, this.isShiftKeyPressed = !1, this._isActive = !1, this._currentSuggestItemInfo = void 0, this._selectedItem = lt(this, void 0), this._register(e.onKeyDown(((r) => {
      r.shiftKey && !this.isShiftKeyPressed && (this.isShiftKeyPressed = !0, this.update(this._isActive));
    }))), this._register(e.onKeyUp(((r) => {
      r.shiftKey && this.isShiftKeyPressed && (this.isShiftKeyPressed = !1, this.update(this._isActive));
    })));
    const o = wr.get(this.editor);
    if (o) {
      this._register(o.registerSelector({ priority: 100, select: (l, d, h) => {
        Tt(((_) => this.checkModelVersion(_)));
        const c = this.editor.getModel();
        if (!c) return -1;
        const u = this.suggestControllerPreselector(), g = u ? Ju(u, c) : void 0;
        if (!g) return -1;
        const p = W.lift(d), f = kR(h.map(((_, v) => {
          const b = Ju(T0.fromSuggestion(o, c, p, _, this.isShiftKeyPressed).toSingleTextEdit(), c);
          return { index: v, valid: Qz(g, b), prefixLength: b.text.length, suggestItem: _ };
        })).filter(((_) => _ && _.valid && _.prefixLength > 0)), jo(((_) => _.prefixLength), od));
        return f ? f.index : -1;
      } }));
      let r = !1;
      const a = () => {
        r || (r = !0, this._register(o.widget.value.onDidShow((() => {
          this.isSuggestWidgetVisible = !0, this.update(!0);
        }))), this._register(o.widget.value.onDidHide((() => {
          this.isSuggestWidgetVisible = !1, this.update(!1);
        }))), this._register(o.widget.value.onDidFocus((() => {
          this.isSuggestWidgetVisible = !0, this.update(!0);
        }))));
      };
      this._register(se.once(o.model.onDidTrigger)(((l) => {
        a();
      }))), this._register(o.onWillInsertSuggestItem(((l) => {
        const d = this.editor.getPosition(), h = this.editor.getModel();
        if (!d || !h) return;
        const c = T0.fromSuggestion(o, h, d, l.item, this.isShiftKeyPressed);
        this.onWillAccept(c);
      })));
    }
    this.update(this._isActive);
  }
  update(e) {
    const t = this.getSuggestItemInfo();
    this._isActive === e && (function(i, s) {
      return i === s ? !0 : !i || !s ? !1 : i.equals(s);
    })(this._currentSuggestItemInfo, t) || (this._isActive = e, this._currentSuggestItemInfo = t, Tt(((i) => {
      this.checkModelVersion(i), this._selectedItem.set(this._isActive ? this._currentSuggestItemInfo : void 0, i);
    })));
  }
  getSuggestItemInfo() {
    const e = wr.get(this.editor);
    if (!e || !this.isSuggestWidgetVisible) return;
    const t = e.widget.value.getFocusedItem(), i = this.editor.getPosition(), s = this.editor.getModel();
    return t && i && s ? T0.fromSuggestion(e, s, i, t.item, this.isShiftKeyPressed) : void 0;
  }
  stopForceRenderingAbove() {
    const e = wr.get(this.editor);
    e?.stopForceRenderingAbove();
  }
  forceRenderingAbove() {
    const e = wr.get(this.editor);
    e?.forceRenderingAbove();
  }
}
class T0 {
  static fromSuggestion(e, t, i, s, o) {
    let { insertText: r } = s.completion, a = !1;
    if (4 & s.completion.insertTextRules) {
      const d = new bg().parse(r);
      d.children.length < 100 && LS.adjustWhitespace(t, i, !0, d), r = d.toString(), a = !0;
    }
    const l = e.getOverwriteInfo(s, o);
    return new T0(D.fromPositions(i.delta(0, -l.overwriteBefore), i.delta(0, Math.max(l.overwriteAfter, 0))), r, s.completion.kind, a);
  }
  constructor(e, t, i, s) {
    this.range = e, this.insertText = t, this.completionItemKind = i, this.isSnippetText = s;
  }
  equals(e) {
    return this.range.equalsRange(e.range) && this.insertText === e.insertText && this.completionItemKind === e.completionItemKind && this.isSnippetText === e.isSnippetText;
  }
  toSelectedSuggestionInfo() {
    return new G7(this.range, this.insertText, this.completionItemKind, this.isSnippetText);
  }
  toSingleTextEdit() {
    return new Bd(this.range, this.insertText);
  }
}
var aT, mde = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Jd = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let po = aT = class extends V {
  static get(n) {
    return n.getContribution(aT.ID);
  }
  constructor(n, e, t, i, s, o, r, a, l) {
    super(), this.editor = n, this._instantiationService = e, this._contextKeyService = t, this._configurationService = i, this._commandService = s, this._debounceService = o, this._languageFeaturesService = r, this._accessibilitySignalService = a, this._keybindingService = l, this.model = this._register(Tv("inlineCompletionModel", void 0)), this._textModelVersionId = lt(this, -1), this._positions = lt(this, [new W(1, 1)]), this._suggestWidgetAdaptor = this._register(new pde(this.editor, (() => {
      var u, g;
      return (g = (u = this.model.get()) === null || u === void 0 ? void 0 : u.selectedInlineCompletion.get()) === null || g === void 0 ? void 0 : g.toSingleTextEdit(void 0);
    }), ((u) => this.updateObservables(u, lo.Other)), ((u) => {
      Tt(((g) => {
        var p;
        this.updateObservables(g, lo.Other), (p = this.model.get()) === null || p === void 0 || p.handleSuggestAccepted(u);
      }));
    }))), this._enabled = Rt(this.editor.onDidChangeConfiguration, (() => this.editor.getOption(62).enabled)), this._fontFamily = Rt(this.editor.onDidChangeConfiguration, (() => this.editor.getOption(62).fontFamily)), this._ghostTexts = Fe(this, ((u) => {
      var g;
      const p = this.model.read(u);
      return (g = p?.ghostTexts.read(u)) !== null && g !== void 0 ? g : [];
    })), this._stablizedGhostTexts = (function(u, g) {
      const p = lt("result", []), f = [];
      return g.add(Ge(((_) => {
        const v = u.read(_);
        Tt(((b) => {
          if (v.length !== f.length) {
            f.length = v.length;
            for (let C = 0; C < f.length; C++) f[C] || (f[C] = lt("item", v[C]));
            p.set([...f], b);
          }
          f.forEach(((C, w) => C.set(v[w], b)));
        }));
      }))), p;
    })(this._ghostTexts, this._store), this._ghostTextWidgets = (function(u, g, p, f) {
      let _ = new B3(p, f);
      return mm({ debugReferenceFn: p, owner: u, onLastObserverRemoved: () => {
        _.dispose(), _ = new B3(p);
      } }, ((v) => (_.setItems(g.read(v)), _.getItems())));
    })(this, this._stablizedGhostTexts, ((u, g) => g.add(this._instantiationService.createInstance(XM, this.editor, { ghostText: u, minReservedLineCount: ia(0), targetTextModel: this.model.map(((p) => p?.textModel)) })))).recomputeInitiallyAndOnChange(this._store), this._debounceValue = this._debounceService.for(this._languageFeaturesService.inlineCompletionsProvider, "InlineCompletionsDebounce", { min: 50, max: 50 }), this._playAccessibilitySignal = DL(this), this._isReadonly = Rt(this.editor.onDidChangeConfiguration, (() => this.editor.getOption(91))), this._textModel = Rt(this.editor.onDidChangeModel, (() => this.editor.getModel())), this._textModelIfWritable = Fe(((u) => this._isReadonly.read(u) ? void 0 : this._textModel.read(u))), this._register(new un(this._contextKeyService, this.model)), this._register(Ge(((u) => {
      const g = this._textModelIfWritable.read(u);
      Tt(((p) => {
        if (this.model.set(void 0, p), this.updateObservables(p, lo.Other), g) {
          const f = e.createInstance(JM, g, this._suggestWidgetAdaptor.selectedItem, this._textModelVersionId, this._positions, this._debounceValue, Rt(n.onDidChangeConfiguration, (() => n.getOption(118).preview)), Rt(n.onDidChangeConfiguration, (() => n.getOption(118).previewMode)), Rt(n.onDidChangeConfiguration, (() => n.getOption(62).mode)), this._enabled);
          this.model.set(f, p);
        }
      }));
    })));
    const d = this._register(w8());
    this._register(Ge(((u) => {
      const g = this._fontFamily.read(u);
      d.setStyle(g === "" || g === "default" ? "" : `
.monaco-editor .ghost-text-decoration,
.monaco-editor .ghost-text-decoration-preview,
.monaco-editor .ghost-text {
	font-family: ${g};
}`);
    })));
    const h = (u) => {
      var g;
      return u.isUndoing ? lo.Undo : u.isRedoing ? lo.Redo : !((g = this.model.get()) === null || g === void 0) && g.isAcceptingPartially ? lo.AcceptWord : lo.Other;
    };
    let c;
    this._register(n.onDidChangeModelContent(((u) => Tt(((g) => this.updateObservables(g, h(u))))))), this._register(n.onDidChangeCursorPosition(((u) => Tt(((g) => {
      var p;
      this.updateObservables(g, lo.Other), u.reason !== 3 && u.source !== "api" || (p = this.model.get()) === null || p === void 0 || p.stop(g);
    }))))), this._register(n.onDidType((() => Tt(((u) => {
      var g;
      this.updateObservables(u, lo.Other), this._enabled.get() && ((g = this.model.get()) === null || g === void 0 || g.trigger(u));
    }))))), this._register(this._commandService.onDidExecuteCommand(((u) => {
      (/* @__PURE__ */ new Set([om.Tab.id, om.DeleteLeft.id, om.DeleteRight.id, xz, "acceptSelectedSuggestion"])).has(u.commandId) && n.hasTextFocus() && this._enabled.get() && Tt(((g) => {
        var p;
        (p = this.model.get()) === null || p === void 0 || p.trigger(g);
      }));
    }))), this._register(this.editor.onDidBlurEditorWidget((() => {
      this._contextKeyService.getContextKeyValue("accessibleViewIsShown") || this._configurationService.getValue("editor.inlineSuggest.keepOnBlur") || n.getOption(62).keepOnBlur || jh.dropDownVisible || Tt(((u) => {
        var g;
        (g = this.model.get()) === null || g === void 0 || g.stop(u);
      }));
    }))), this._register(Ge(((u) => {
      var g;
      const p = (g = this.model.read(u)) === null || g === void 0 ? void 0 : g.state.read(u);
      p?.suggestItem ? p.primaryGhostText.lineCount >= 2 && this._suggestWidgetAdaptor.forceRenderingAbove() : this._suggestWidgetAdaptor.stopForceRenderingAbove();
    }))), this._register(ye((() => {
      this._suggestWidgetAdaptor.stopForceRenderingAbove();
    }))), this._register(A1({ handleChange: (u, g) => (u.didChange(this._playAccessibilitySignal) && (c = void 0), !0) }, (async (u) => {
      this._playAccessibilitySignal.read(u);
      const g = this.model.read(u), p = g?.state.read(u);
      if (g && p && p.inlineCompletion) {
        if (p.inlineCompletion.semanticId !== c) {
          c = p.inlineCompletion.semanticId;
          const f = g.textModel.getLineContent(p.primaryGhostText.lineNumber);
          this._accessibilitySignalService.playSignal(He.inlineSuggestion).then((() => {
            this.editor.getOption(8) && this.provideScreenReaderUpdate(p.primaryGhostText.renderForScreenReader(f));
          }));
        }
      } else c = void 0;
    }))), this._register(new EM(this.editor, this.model, this._instantiationService)), this._register(this._configurationService.onDidChangeConfiguration(((u) => {
      u.affectsConfiguration("accessibility.verbosity.inlineCompletions") && this.editor.updateOptions({ inlineCompletionsAccessibilityVerbose: this._configurationService.getValue("accessibility.verbosity.inlineCompletions") });
    }))), this.editor.updateOptions({ inlineCompletionsAccessibilityVerbose: this._configurationService.getValue("accessibility.verbosity.inlineCompletions") });
  }
  playAccessibilitySignal(n) {
    this._playAccessibilitySignal.trigger(n);
  }
  provideScreenReaderUpdate(n) {
    const e = this._contextKeyService.getContextKeyValue("accessibleViewIsShown"), t = this._keybindingService.lookupKeybinding("editor.action.accessibleView");
    let i;
    !e && t && this.editor.getOption(149) && (i = m(0, "Inspect this in the accessible view ({0})", t.getAriaLabel())), Io(i ? n + ", " + i : n);
  }
  updateObservables(n, e) {
    var t, i, s;
    const o = this.editor.getModel();
    this._textModelVersionId.set((t = o?.getVersionId()) !== null && t !== void 0 ? t : -1, n, e), this._positions.set((s = (i = this.editor.getSelections()) === null || i === void 0 ? void 0 : i.map(((r) => r.getPosition()))) !== null && s !== void 0 ? s : [new W(1, 1)], n);
  }
  shouldShowHoverAt(n) {
    var e;
    const t = (e = this.model.get()) === null || e === void 0 ? void 0 : e.primaryGhostText.get();
    return !!t && t.parts.some(((i) => n.containsPosition(new W(t.lineNumber, i.column))));
  }
  shouldShowHoverAtViewZone(n) {
    var e, t;
    return (t = (e = this._ghostTextWidgets.get()[0]) === null || e === void 0 ? void 0 : e.ownsViewZone(n)) !== null && t !== void 0 && t;
  }
};
po.ID = "editor.contrib.inlineCompletionsController", po = aT = mde([Jd(1, Se), Jd(2, Te), Jd(3, Ye), Jd(4, ai), Jd(5, ar), Jd(6, fe), Jd(7, Oc), Jd(8, Dt)], po);
class ak extends he {
  constructor() {
    super({ id: ak.ID, label: m(0, "Show Next Inline Suggestion"), alias: "Show Next Inline Suggestion", precondition: q.and(E.writable, un.inlineSuggestionVisible), kbOpts: { weight: 100, primary: 606 } });
  }
  async run(e, t) {
    var i;
    const s = po.get(t);
    (i = s?.model.get()) === null || i === void 0 || i.next();
  }
}
ak.ID = Ez;
class lk extends he {
  constructor() {
    super({ id: lk.ID, label: m(0, "Show Previous Inline Suggestion"), alias: "Show Previous Inline Suggestion", precondition: q.and(E.writable, un.inlineSuggestionVisible), kbOpts: { weight: 100, primary: 604 } });
  }
  async run(e, t) {
    var i;
    const s = po.get(t);
    (i = s?.model.get()) === null || i === void 0 || i.previous();
  }
}
lk.ID = Nz;
class dk extends he {
  constructor() {
    super({ id: dk.ID, label: m(0, "Hide Inline Suggestion"), alias: "Hide Inline Suggestion", precondition: un.inlineSuggestionVisible, kbOpts: { weight: 100, primary: 9 } });
  }
  async run(e, t) {
    const i = po.get(t);
    Tt(((s) => {
      var o;
      (o = i?.model.get()) === null || o === void 0 || o.stop(s);
    }));
  }
}
dk.ID = "editor.action.inlineSuggest.hide";
class hk extends cs {
  constructor() {
    super({ id: hk.ID, title: m(0, "Always Show Toolbar"), f1: !1, precondition: void 0, menu: [{ id: x.InlineSuggestionToolbar, group: "secondary", order: 10 }], toggled: q.equals("config.editor.inlineSuggest.showToolbar", "always") });
  }
  async run(e, t) {
    const i = e.get(Ye), s = i.getValue("editor.inlineSuggest.showToolbar") === "always" ? "onHover" : "always";
    i.updateValue("editor.inlineSuggest.showToolbar", s);
  }
}
hk.ID = "editor.action.inlineSuggest.toggleAlwaysShowToolbar";
var fde = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, i_ = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class _de {
  constructor(e, t, i) {
    this.owner = e, this.range = t, this.controller = i;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
let Xx = class {
  constructor(n, e, t, i, s, o) {
    this._editor = n, this._languageService = e, this._openerService = t, this.accessibilityService = i, this._instantiationService = s, this._telemetryService = o, this.hoverOrdinal = 4;
  }
  suggestHoverAnchor(n) {
    const e = po.get(this._editor);
    if (!e) return null;
    const t = n.target;
    if (t.type === 8) {
      const i = t.detail;
      if (e.shouldShowHoverAtViewZone(i.viewZoneId)) return new Zu(1e3, this, D.fromPositions(this._editor.getModel().validatePosition(i.positionBefore || i.position)), n.event.posx, n.event.posy, !1);
    }
    return t.type === 7 && e.shouldShowHoverAt(t.range) ? new Zu(1e3, this, t.range, n.event.posx, n.event.posy, !1) : t.type === 6 && t.detail.mightBeForeignElement && e.shouldShowHoverAt(t.range) ? new Zu(1e3, this, t.range, n.event.posx, n.event.posy, !1) : null;
  }
  computeSync(n, e) {
    if (this._editor.getOption(62).showToolbar !== "onHover") return [];
    const t = po.get(this._editor);
    return t && t.shouldShowHoverAt(n.range) ? [new _de(this, n.range, t)] : [];
  }
  renderHoverParts(n, e) {
    const t = new G(), i = e[0];
    this._telemetryService.publicLog2("inlineCompletionHover.shown"), this.accessibilityService.isScreenReaderOptimized() && !this._editor.getOption(8) && this.renderScreenReaderText(n, i, t);
    const s = i.controller.model.get(), o = this._instantiationService.createInstance(jh, this._editor, !1, ia(null), s.selectedInlineCompletionIndex, s.inlineCompletionsCount, s.selectedInlineCompletion.map(((r) => {
      var a;
      return (a = r?.inlineCompletion.source.inlineCompletions.commands) !== null && a !== void 0 ? a : [];
    })));
    return n.fragment.appendChild(o.getDomNode()), s.triggerExplicitly(), t.add(o), t;
  }
  renderScreenReaderText(n, e, t) {
    const i = Q, s = i("div.hover-row.markdown-hover"), o = Z(s, i("div.hover-contents", { "aria-live": "assertive" })), r = t.add(new pl({ editor: this._editor }, this._languageService, this._openerService));
    t.add(Ge(((a) => {
      var l;
      const d = (l = e.controller.model.read(a)) === null || l === void 0 ? void 0 : l.primaryGhostText.read(a);
      if (d) {
        const h = this._editor.getModel().getLineContent(d.lineNumber);
        ((c) => {
          t.add(r.onDidRenderAsync((() => {
            o.className = "hover-contents code-hover-contents", n.onContentsChanged();
          })));
          const u = m(0, "Suggestion:"), g = t.add(r.render(new Vn().appendText(u).appendCodeblock("text", c)));
          o.replaceChildren(g.element);
        })(d.renderForScreenReader(h));
      } else wn(o);
    }))), n.fragment.appendChild(s);
  }
};
function Ks(n, e) {
  let t = 0;
  for (let i = 0; i < n.length; i++) n.charAt(i) === "	" ? t += e : t++;
  return t;
}
function R0(n, e, t) {
  n = n < 0 ? 0 : n;
  let i = "";
  if (!t) {
    const s = Math.floor(n / e);
    n %= e;
    for (let o = 0; o < s; o++) i += "	";
  }
  for (let s = 0; s < n; s++) i += " ";
  return i;
}
function N9(n, e, t, i, s) {
  if (n.getLineCount() === 1 && n.getLineMaxColumn(1) === 1) return [];
  const o = e.getLanguageConfiguration(n.getLanguageId()).indentationRules;
  if (!o) return [];
  for (i = Math.min(i, n.getLineCount()); t <= i && o.unIndentedLinePattern; ) {
    const _ = n.getLineContent(t);
    if (!o.unIndentedLinePattern.test(_)) break;
    t++;
  }
  if (t > i - 1) return [];
  const { tabSize: r, indentSize: a, insertSpaces: l } = n.getOptions(), d = (_, v) => (v = v || 1, Ko.shiftIndent(_, _.length + v, r, a, l)), h = (_, v) => (v = v || 1, Ko.unshiftIndent(_, _.length + v, r, a, l)), c = [];
  let u;
  const g = n.getLineContent(t);
  let p = g;
  u = Wt(g);
  let f = u;
  o.increaseIndentPattern && o.increaseIndentPattern.test(p) ? (f = d(f), u = d(u)) : o.indentNextLinePattern && o.indentNextLinePattern.test(p) && (f = d(f));
  for (let _ = ++t; _ <= i; _++) {
    const v = n.getLineContent(_), b = Wt(v), C = f + v.substring(b.length);
    o.decreaseIndentPattern && o.decreaseIndentPattern.test(C) && (f = h(f), u = h(u)), b !== f && c.push(ii.replaceMove(new _e(_, 1, _, b.length + 1), UR(f, a, l))), o.unIndentedLinePattern && o.unIndentedLinePattern.test(v) || (o.increaseIndentPattern && o.increaseIndentPattern.test(C) ? (u = d(u), f = u) : f = o.indentNextLinePattern && o.indentNextLinePattern.test(C) ? d(f) : u);
  }
  return c;
}
Xx = fde([i_(1, Xt), i_(2, Fs), i_(3, or), i_(4, Se), i_(5, es)], Xx), ft(po.ID, po, 3), X(class extends he {
  constructor() {
    super({ id: "editor.action.inlineSuggest.trigger", label: m(0, "Trigger Inline Suggestion"), alias: "Trigger Inline Suggestion", precondition: E.writable });
  }
  async run(n, e) {
    const t = po.get(e);
    await (async function(i, s) {
      const o = new SL(i, s);
      try {
        await i(o);
      } finally {
        o.finish();
      }
    })((async (i) => {
      var s;
      await ((s = t?.model.get()) === null || s === void 0 ? void 0 : s.triggerExplicitly(i)), t?.playAccessibilitySignal(i);
    }));
  }
}), X(ak), X(lk), X(class extends he {
  constructor() {
    super({ id: "editor.action.inlineSuggest.acceptNextWord", label: m(0, "Accept Next Word Of Inline Suggestion"), alias: "Accept Next Word Of Inline Suggestion", precondition: q.and(E.writable, un.inlineSuggestionVisible), kbOpts: { weight: 101, primary: 2065, kbExpr: q.and(E.writable, un.inlineSuggestionVisible) }, menuOpts: [{ menuId: x.InlineSuggestionToolbar, title: m(0, "Accept Word"), group: "primary", order: 2 }] });
  }
  async run(n, e) {
    var t;
    const i = po.get(e);
    await ((t = i?.model.get()) === null || t === void 0 ? void 0 : t.acceptNextWord(i.editor));
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.inlineSuggest.acceptNextLine", label: m(0, "Accept Next Line Of Inline Suggestion"), alias: "Accept Next Line Of Inline Suggestion", precondition: q.and(E.writable, un.inlineSuggestionVisible), kbOpts: { weight: 101 }, menuOpts: [{ menuId: x.InlineSuggestionToolbar, title: m(0, "Accept Line"), group: "secondary", order: 2 }] });
  }
  async run(n, e) {
    var t;
    const i = po.get(e);
    await ((t = i?.model.get()) === null || t === void 0 ? void 0 : t.acceptNextLine(i.editor));
  }
}), X(class extends he {
  constructor() {
    super({ id: xz, label: m(0, "Accept Inline Suggestion"), alias: "Accept Inline Suggestion", precondition: un.inlineSuggestionVisible, menuOpts: [{ menuId: x.InlineSuggestionToolbar, title: m(0, "Accept"), group: "primary", order: 1 }], kbOpts: { primary: 2, weight: 200, kbExpr: q.and(un.inlineSuggestionVisible, E.tabMovesFocus.toNegated(), un.inlineSuggestionHasIndentationLessThanTabSize, $e.Visible.toNegated(), E.hoverFocused.toNegated()) } });
  }
  async run(n, e) {
    var t;
    const i = po.get(e);
    i && ((t = i.model.get()) === null || t === void 0 || t.accept(i.editor), i.editor.focus());
  }
}), X(dk), Ft(hk), Tc.register(Xx);
var vde = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, bde = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class ck extends he {
  constructor() {
    super({ id: ck.ID, label: m(0, "Convert Indentation to Spaces"), alias: "Convert Indentation to Spaces", precondition: E.writable });
  }
  run(e, t) {
    const i = t.getModel();
    if (!i) return;
    const s = i.getOptions(), o = t.getSelection();
    if (!o) return;
    const r = new wde(o, s.tabSize);
    t.pushUndoStop(), t.executeCommands(this.id, [r]), t.pushUndoStop(), i.updateOptions({ insertSpaces: !0 });
  }
}
ck.ID = "editor.action.indentationToSpaces";
class uk extends he {
  constructor() {
    super({ id: uk.ID, label: m(0, "Convert Indentation to Tabs"), alias: "Convert Indentation to Tabs", precondition: E.writable });
  }
  run(e, t) {
    const i = t.getModel();
    if (!i) return;
    const s = i.getOptions(), o = t.getSelection();
    if (!o) return;
    const r = new yde(o, s.tabSize);
    t.pushUndoStop(), t.executeCommands(this.id, [r]), t.pushUndoStop(), i.updateOptions({ insertSpaces: !1 });
  }
}
uk.ID = "editor.action.indentationToTabs";
class IP extends he {
  constructor(e, t, i) {
    super(i), this.insertSpaces = e, this.displaySizeOnly = t;
  }
  run(e, t) {
    const i = e.get(Sa), s = e.get(ni), o = t.getModel();
    if (!o) return;
    const r = s.getCreationOptions(o.getLanguageId(), o.uri, o.isForSimpleWidget), a = o.getOptions(), l = [1, 2, 3, 4, 5, 6, 7, 8].map(((h) => ({ id: h.toString(), label: h.toString(), description: h === r.tabSize && h === a.tabSize ? m(0, "Configured Tab Size") : h === r.tabSize ? m(0, "Default Tab Size") : h === a.tabSize ? m(0, "Current Tab Size") : void 0 }))), d = Math.min(o.getOptions().tabSize - 1, 7);
    setTimeout((() => {
      i.pick(l, { placeHolder: m(0, "Select Tab Size for Current File"), activeItem: l[d] }).then(((h) => {
        if (h && o && !o.isDisposed()) {
          const c = parseInt(h.label, 10);
          this.displaySizeOnly ? o.updateOptions({ tabSize: c }) : o.updateOptions({ tabSize: c, indentSize: c, insertSpaces: this.insertSpaces });
        }
      }));
    }), 50);
  }
}
class gk extends IP {
  constructor() {
    super(!1, !1, { id: gk.ID, label: m(0, "Indent Using Tabs"), alias: "Indent Using Tabs", precondition: void 0 });
  }
}
gk.ID = "editor.action.indentUsingTabs";
class pk extends IP {
  constructor() {
    super(!0, !1, { id: pk.ID, label: m(0, "Indent Using Spaces"), alias: "Indent Using Spaces", precondition: void 0 });
  }
}
pk.ID = "editor.action.indentUsingSpaces";
class mk extends IP {
  constructor() {
    super(!0, !0, { id: mk.ID, label: m(0, "Change Tab Display Size"), alias: "Change Tab Display Size", precondition: void 0 });
  }
}
mk.ID = "editor.action.changeTabDisplaySize";
class fk extends he {
  constructor() {
    super({ id: fk.ID, label: m(0, "Detect Indentation from Content"), alias: "Detect Indentation from Content", precondition: void 0 });
  }
  run(e, t) {
    const i = e.get(ni), s = t.getModel();
    if (!s) return;
    const o = i.getCreationOptions(s.getLanguageId(), s.uri, s.isForSimpleWidget);
    s.detectIndentation(o.insertSpaces, o.tabSize);
  }
}
fk.ID = "editor.action.detectIndentation";
class Cde {
  constructor(e, t) {
    this._initialSelection = t, this._edits = [], this._selectionId = null;
    for (const i of e) i.range && typeof i.text == "string" && this._edits.push(i);
  }
  getEditOperations(e, t) {
    for (const s of this._edits) t.addEditOperation(D.lift(s.range), s.text);
    let i = !1;
    Array.isArray(this._edits) && this._edits.length === 1 && this._initialSelection.isEmpty() && (this._edits[0].range.startColumn === this._initialSelection.endColumn && this._edits[0].range.startLineNumber === this._initialSelection.endLineNumber ? (i = !0, this._selectionId = t.trackSelection(this._initialSelection, !0)) : this._edits[0].range.endColumn === this._initialSelection.startColumn && this._edits[0].range.endLineNumber === this._initialSelection.startLineNumber && (i = !0, this._selectionId = t.trackSelection(this._initialSelection, !1))), i || (this._selectionId = t.trackSelection(this._initialSelection));
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._selectionId);
  }
}
let A0 = class {
  constructor(n, e) {
    this.editor = n, this._languageConfigurationService = e, this.callOnDispose = new G(), this.callOnModel = new G(), this.callOnDispose.add(n.onDidChangeConfiguration((() => this.update()))), this.callOnDispose.add(n.onDidChangeModel((() => this.update()))), this.callOnDispose.add(n.onDidChangeModelLanguage((() => this.update())));
  }
  update() {
    this.callOnModel.clear(), this.editor.getOption(12) < 4 || this.editor.getOption(55) || this.editor.hasModel() && this.callOnModel.add(this.editor.onDidPaste((({ range: n }) => {
      this.trigger(n);
    })));
  }
  trigger(n) {
    const e = this.editor.getSelections();
    if (e === null || e.length > 1) return;
    const t = this.editor.getModel();
    if (!t || !t.tokenization.isCheapToTokenize(n.getStartPosition().lineNumber)) return;
    const i = this.editor.getOption(12), { tabSize: s, indentSize: o, insertSpaces: r } = t.getOptions(), a = [], l = { shiftIndent: (u) => Ko.shiftIndent(u, u.length + 1, s, o, r), unshiftIndent: (u) => Ko.unshiftIndent(u, u.length + 1, s, o, r) };
    let d = n.startLineNumber;
    for (; d <= n.endLineNumber && this.shouldIgnoreLine(t, d); ) d++;
    if (d > n.endLineNumber) return;
    let h = t.getLineContent(d);
    if (!/\S/.test(h.substring(0, n.startColumn - 1))) {
      const u = t0(i, t, t.getLanguageId(), d, l, this._languageConfigurationService);
      if (u !== null) {
        const g = Wt(h), p = Ks(u, s);
        if (p !== Ks(g, s)) {
          const f = R0(p, s, r);
          a.push({ range: new D(d, 1, d, g.length + 1), text: f }), h = f + h.substr(g.length);
        } else {
          const f = FB(t, d, this._languageConfigurationService);
          if (f === 0 || f === 8) return;
        }
      }
    }
    const c = d;
    for (; d < n.endLineNumber && !/\S/.test(t.getLineContent(d + 1)); ) d++;
    if (d !== n.endLineNumber) {
      const u = t0(i, { tokenization: { getLineTokens: (g) => t.tokenization.getLineTokens(g), getLanguageId: () => t.getLanguageId(), getLanguageIdAtPosition: (g, p) => t.getLanguageIdAtPosition(g, p) }, getLineContent: (g) => g === c ? h : t.getLineContent(g) }, t.getLanguageId(), d + 1, l, this._languageConfigurationService);
      if (u !== null) {
        const g = Ks(u, s), p = Ks(Wt(t.getLineContent(d + 1)), s);
        if (g !== p) {
          const f = g - p;
          for (let _ = d + 1; _ <= n.endLineNumber; _++) {
            const v = Wt(t.getLineContent(_)), b = R0(Ks(v, s) + f, s, r);
            b !== v && a.push({ range: new D(_, 1, _, v.length + 1), text: b });
          }
        }
      }
    }
    if (a.length > 0) {
      this.editor.pushUndoStop();
      const u = new Cde(a, this.editor.getSelection());
      this.editor.executeCommand("autoIndentOnPaste", u), this.editor.pushUndoStop();
    }
  }
  shouldIgnoreLine(n, e) {
    n.tokenization.forceTokenization(e);
    const t = n.getLineFirstNonWhitespaceColumn(e);
    if (t === 0) return !0;
    const i = n.tokenization.getLineTokens(e);
    if (i.getCount() > 0) {
      const s = i.findTokenIndexAtOffset(t);
      if (s >= 0 && i.getStandardTokenType(s) === 1) return !0;
    }
    return !1;
  }
  dispose() {
    this.callOnDispose.dispose(), this.callOnModel.dispose();
  }
};
function iU(n, e, t, i) {
  if (n.getLineCount() === 1 && n.getLineMaxColumn(1) === 1) return;
  let s = "";
  for (let r = 0; r < t; r++) s += " ";
  const o = new RegExp(s, "gi");
  for (let r = 1, a = n.getLineCount(); r <= a; r++) {
    let l = n.getLineFirstNonWhitespaceColumn(r);
    if (l === 0 && (l = n.getLineMaxColumn(r)), l === 1) continue;
    const d = new D(r, 1, r, l), h = n.getValueInRange(d), c = i ? h.replace(/\t/gi, s) : h.replace(o, "	");
    e.addEditOperation(d, c);
  }
}
A0.ID = "editor.contrib.autoIndentOnPaste", A0 = vde([bde(1, zt)], A0);
class wde {
  constructor(e, t) {
    this.selection = e, this.tabSize = t, this.selectionId = null;
  }
  getEditOperations(e, t) {
    this.selectionId = t.trackSelection(this.selection), iU(e, t, this.tabSize, !0);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this.selectionId);
  }
}
class yde {
  constructor(e, t) {
    this.selection = e, this.tabSize = t, this.selectionId = null;
  }
  getEditOperations(e, t) {
    this.selectionId = t.trackSelection(this.selection), iU(e, t, this.tabSize, !1);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this.selectionId);
  }
}
ft(A0.ID, A0, 2), X(ck), X(uk), X(gk), X(pk), X(mk), X(fk), X(class extends he {
  constructor() {
    super({ id: "editor.action.reindentlines", label: m(0, "Reindent Lines"), alias: "Reindent Lines", precondition: E.writable });
  }
  run(n, e) {
    const t = n.get(zt), i = e.getModel();
    if (!i) return;
    const s = N9(i, t, 1, i.getLineCount());
    s.length > 0 && (e.pushUndoStop(), e.executeEdits(this.id, s), e.pushUndoStop());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.reindentselectedlines", label: m(0, "Reindent Selected Lines"), alias: "Reindent Selected Lines", precondition: E.writable });
  }
  run(n, e) {
    const t = n.get(zt), i = e.getModel();
    if (!i) return;
    const s = e.getSelections();
    if (s === null) return;
    const o = [];
    for (const r of s) {
      let a = r.startLineNumber, l = r.endLineNumber;
      if (a !== l && r.endColumn === 1 && l--, a === 1) {
        if (a === l) continue;
      } else a--;
      const d = N9(i, t, a, l);
      o.push(...d);
    }
    o.length > 0 && (e.pushUndoStop(), e.executeEdits(this.id, o), e.pushUndoStop());
  }
});
class nU {
  constructor(e, t) {
    this.range = e, this.direction = t;
  }
}
class MP {
  constructor(e, t, i) {
    this.hint = e, this.anchor = t, this.provider = i, this._isResolved = !1;
  }
  with(e) {
    const t = new MP(this.hint, e.anchor, this.provider);
    return t._isResolved = this._isResolved, t._currentResolve = this._currentResolve, t;
  }
  async resolve(e) {
    if (typeof this.provider.resolveInlayHint == "function") {
      if (this._currentResolve)
        return await this._currentResolve, e.isCancellationRequested ? void 0 : this.resolve(e);
      this._isResolved || (this._currentResolve = this._doResolve(e).finally((() => this._currentResolve = void 0))), await this._currentResolve;
    }
  }
  async _doResolve(e) {
    var t, i, s;
    try {
      const o = await Promise.resolve(this.provider.resolveInlayHint(this.hint, e));
      this.hint.tooltip = (t = o?.tooltip) !== null && t !== void 0 ? t : this.hint.tooltip, this.hint.label = (i = o?.label) !== null && i !== void 0 ? i : this.hint.label, this.hint.textEdits = (s = o?.textEdits) !== null && s !== void 0 ? s : this.hint.textEdits, this._isResolved = !0;
    } catch (o) {
      Ni(o), this._isResolved = !1;
    }
  }
}
class tg {
  static async create(e, t, i, s) {
    const o = [], r = e.ordered(t).reverse().map(((a) => i.map((async (l) => {
      try {
        const d = await a.provideInlayHints(t, l, s);
        (d?.hints.length || a.onDidChangeInlayHints) && o.push([d ?? tg._emptyInlayHintList, a]);
      } catch (d) {
        Ni(d);
      }
    }))));
    if (await Promise.all(r.flat()), s.isCancellationRequested || t.isDisposed()) throw new Vd();
    return new tg(i, o, t);
  }
  constructor(e, t, i) {
    this._disposables = new G(), this.ranges = e, this.provider = /* @__PURE__ */ new Set();
    const s = [];
    for (const [o, r] of t) {
      this._disposables.add(o), this.provider.add(r);
      for (const a of o.hints) {
        const l = i.validatePosition(a.position);
        let d = "before";
        const h = tg._getRangeAtPosition(i, l);
        let c;
        h.getStartPosition().isBefore(l) ? (c = D.fromPositions(h.getStartPosition(), l), d = "after") : (c = D.fromPositions(l, h.getEndPosition()), d = "before"), s.push(new MP(a, new nU(c, d), r));
      }
    }
    this.items = s.sort(((o, r) => W.compare(o.hint.position, r.hint.position)));
  }
  dispose() {
    this._disposables.dispose();
  }
  static _getRangeAtPosition(e, t) {
    const i = t.lineNumber, s = e.getWordAtPosition(t);
    if (s) return new D(i, s.startColumn, i, s.endColumn);
    e.tokenization.tokenizeIfCheap(i);
    const o = e.tokenization.getLineTokens(i), r = t.column - 1, a = o.findTokenIndexAtOffset(r);
    let l = o.getStartOffset(a), d = o.getEndOffset(a);
    return d - l == 1 && (l === r && a > 1 ? (l = o.getStartOffset(a - 1), d = o.getEndOffset(a - 1)) : d === r && a < o.getCount() - 1 && (l = o.getStartOffset(a + 1), d = o.getEndOffset(a + 1))), new D(i, l + 1, i, d + 1);
  }
}
async function Sde(n, e, t, i) {
  var s;
  const o = n.get(Ps), r = n.get(io), a = n.get(ai), l = n.get(Se), d = n.get(Ri);
  if (await i.item.resolve(et.None), !i.part.location) return;
  const h = i.part.location, c = [], u = new Set(tn.getMenuItems(x.EditorContext).map(((p) => kp(p) ? p.command.id : GL())));
  for (const p of Xn.all()) u.has(p.desc.id) && c.push(new Qs(p.desc.id, Eo.label(p.desc, { renderShortTitle: !0 }), void 0, !0, (async () => {
    const f = await o.createModelReference(h.uri);
    try {
      const _ = new af(f.object.textEditorModel, D.getStartPosition(h.range)), v = i.item.anchor.range;
      await l.invokeFunction(p.runEditorCommand.bind(p), e, _, v);
    } finally {
      f.dispose();
    }
  })));
  if (i.part.command) {
    const { command: p } = i.part;
    c.push(new Ui()), c.push(new Qs(p.id, p.title, void 0, !0, (async () => {
      var f;
      try {
        await a.executeCommand(p.id, ...(f = p.arguments) !== null && f !== void 0 ? f : []);
      } catch (_) {
        d.notify({ severity: pL.Error, source: i.item.provider.displayName, message: _ });
      }
    })));
  }
  const g = e.getOption(127);
  r.showContextMenu({ domForShadowRoot: g && (s = e.getDomNode()) !== null && s !== void 0 ? s : void 0, getAnchor: () => {
    const p = Ti(t);
    return { x: p.left, y: p.top + p.height + 8 };
  }, getActions: () => c, onHide: () => {
    e.focus();
  }, autoSelectFirstItem: !0 });
}
async function sU(n, e, t, i) {
  const s = n.get(Ps), o = await s.createModelReference(i.uri);
  await t.invokeWithinContext((async (r) => {
    const a = e.hasSideBySideModifier, l = r.get(Te), d = As.inPeekEditor.getValue(l), h = !a && t.getOption(88) && !d;
    return new D0({ openToSide: a, openInPeek: h, muteMessage: !0 }, { title: { value: "", original: "" }, id: "", precondition: void 0 }).run(r, new af(o.object.textEditorModel, D.getStartPosition(i.range)), D.lift(i.range));
  })), o.dispose();
}
tg._emptyInlayHintList = Object.freeze({ dispose() {
}, hints: [] });
var bp, Lde = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, lp = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class DS {
  constructor() {
    this._entries = new Ll(50);
  }
  get(e) {
    const t = DS._key(e);
    return this._entries.get(t);
  }
  set(e, t) {
    const i = DS._key(e);
    this._entries.set(i, t);
  }
  static _key(e) {
    return `${e.uri.toString()}/${e.getVersionId()}`;
  }
}
const oU = tt("IInlayHintsCache");
rt(oU, DS, 1);
class lT {
  constructor(e, t) {
    this.item = e, this.index = t;
  }
  get part() {
    const e = this.item.hint.label;
    return typeof e == "string" ? { label: e } : e[this.index];
  }
}
class kde {
  constructor(e, t) {
    this.part = e, this.hasTriggerModifier = t;
  }
}
let Lh = bp = class {
  static get(n) {
    var e;
    return (e = n.getContribution(bp.ID)) !== null && e !== void 0 ? e : void 0;
  }
  constructor(n, e, t, i, s, o, r) {
    this._editor = n, this._languageFeaturesService = e, this._inlayHintsCache = i, this._commandService = s, this._notificationService = o, this._instaService = r, this._disposables = new G(), this._sessionDisposables = new G(), this._decorationsMetadata = /* @__PURE__ */ new Map(), this._ruleFactory = new w1(this._editor), this._activeRenderMode = 0, this._debounceInfo = t.for(e.inlayHintsProvider, "InlayHint", { min: 25 }), this._disposables.add(e.inlayHintsProvider.onDidChange((() => this._update()))), this._disposables.add(n.onDidChangeModel((() => this._update()))), this._disposables.add(n.onDidChangeModelLanguage((() => this._update()))), this._disposables.add(n.onDidChangeConfiguration(((a) => {
      a.hasChanged(141) && this._update();
    }))), this._update();
  }
  dispose() {
    this._sessionDisposables.dispose(), this._removeAllDecorations(), this._disposables.dispose();
  }
  _update() {
    this._sessionDisposables.clear(), this._removeAllDecorations();
    const n = this._editor.getOption(141);
    if (n.enabled === "off") return;
    const e = this._editor.getModel();
    if (!e || !this._languageFeaturesService.inlayHintsProvider.has(e)) return;
    if (n.enabled === "on") this._activeRenderMode = 0;
    else {
      let r, a;
      n.enabled === "onUnlessPressed" ? (r = 0, a = 1) : (r = 1, a = 0), this._activeRenderMode = r, this._sessionDisposables.add(ad.getInstance().event(((l) => {
        if (!this._editor.hasModel()) return;
        const d = l.altKey && l.ctrlKey && !l.shiftKey && !l.metaKey ? a : r;
        if (d !== this._activeRenderMode) {
          this._activeRenderMode = d;
          const h = this._editor.getModel(), c = this._copyInlayHintsWithCurrentAnchor(h);
          this._updateHintsDecorators([h.getFullModelRange()], c), o.schedule(0);
        }
      })));
    }
    const t = this._inlayHintsCache.get(e);
    let i;
    t && this._updateHintsDecorators([e.getFullModelRange()], t), this._sessionDisposables.add(ye((() => {
      e.isDisposed() || this._cacheHintsForFastRestore(e);
    })));
    const s = /* @__PURE__ */ new Set(), o = new Et((async () => {
      const r = Date.now();
      i?.dispose(!0), i = new Ci();
      const a = e.onWillDispose((() => i?.cancel()));
      try {
        const l = i.token, d = await tg.create(this._languageFeaturesService.inlayHintsProvider, e, this._getHintsRanges(), l);
        if (o.delay = this._debounceInfo.update(e, Date.now() - r), l.isCancellationRequested) return void d.dispose();
        for (const h of d.provider) typeof h.onDidChangeInlayHints != "function" || s.has(h) || (s.add(h), this._sessionDisposables.add(h.onDidChangeInlayHints((() => {
          o.isScheduled() || o.schedule();
        }))));
        this._sessionDisposables.add(d), this._updateHintsDecorators(d.ranges, d.items), this._cacheHintsForFastRestore(e);
      } catch (l) {
        We(l);
      } finally {
        i.dispose(), a.dispose();
      }
    }), this._debounceInfo.get(e));
    this._sessionDisposables.add(o), this._sessionDisposables.add(ye((() => i?.dispose(!0)))), o.schedule(0), this._sessionDisposables.add(this._editor.onDidScrollChange(((r) => {
      !r.scrollTopChanged && o.isScheduled() || o.schedule();
    }))), this._sessionDisposables.add(this._editor.onDidChangeModelContent(((r) => {
      i?.cancel();
      const a = Math.max(o.delay, 1250);
      o.schedule(a);
    }))), this._sessionDisposables.add(this._installDblClickGesture((() => o.schedule(0)))), this._sessionDisposables.add(this._installLinkGesture()), this._sessionDisposables.add(this._installContextMenu());
  }
  _installLinkGesture() {
    const n = new G(), e = n.add(new XL(this._editor)), t = new G();
    return n.add(t), n.add(e.onMouseMoveOrRelevantKeyDown(((i) => {
      const [s] = i, o = this._getInlayHintLabelPart(s), r = this._editor.getModel();
      if (!o || !r) return void t.clear();
      const a = new Ci();
      t.add(ye((() => a.dispose(!0)))), o.item.resolve(a.token), this._activeInlayHintPart = o.part.command || o.part.location ? new kde(o, s.hasTriggerModifier) : void 0;
      const l = r.validatePosition(o.item.hint.position).lineNumber, d = new D(l, 1, l, r.getLineMaxColumn(l)), h = this._getInlineHintsForRange(d);
      this._updateHintsDecorators([d], h), t.add(ye((() => {
        this._activeInlayHintPart = void 0, this._updateHintsDecorators([d], h);
      })));
    }))), n.add(e.onCancel((() => t.clear()))), n.add(e.onExecute((async (i) => {
      const s = this._getInlayHintLabelPart(i);
      if (s) {
        const o = s.part;
        o.location ? this._instaService.invokeFunction(sU, i, this._editor, o.location) : MN.is(o.command) && await this._invokeCommand(o.command, s.item);
      }
    }))), n;
  }
  _getInlineHintsForRange(n) {
    const e = /* @__PURE__ */ new Set();
    for (const t of this._decorationsMetadata.values()) n.containsRange(t.item.anchor.range) && e.add(t.item);
    return Array.from(e);
  }
  _installDblClickGesture(n) {
    return this._editor.onMouseUp((async (e) => {
      if (e.event.detail !== 2) return;
      const t = this._getInlayHintLabelPart(e);
      if (t && (e.event.preventDefault(), await t.item.resolve(et.None), zn(t.item.hint.textEdits))) {
        const i = t.item.hint.textEdits.map(((s) => ii.replace(D.lift(s.range), s.text)));
        this._editor.executeEdits("inlayHint.default", i), n();
      }
    }));
  }
  _installContextMenu() {
    return this._editor.onContextMenu((async (n) => {
      if (!(n.event.target instanceof HTMLElement)) return;
      const e = this._getInlayHintLabelPart(n);
      e && await this._instaService.invokeFunction(Sde, this._editor, n.event.target, e);
    }));
  }
  _getInlayHintLabelPart(n) {
    var e;
    if (n.target.type !== 6) return;
    const t = (e = n.target.detail.injectedText) === null || e === void 0 ? void 0 : e.options;
    return t instanceof xc && t?.attachedData instanceof lT ? t.attachedData : void 0;
  }
  async _invokeCommand(n, e) {
    var t;
    try {
      await this._commandService.executeCommand(n.id, ...(t = n.arguments) !== null && t !== void 0 ? t : []);
    } catch (i) {
      this._notificationService.notify({ severity: pL.Error, source: e.provider.displayName, message: i });
    }
  }
  _cacheHintsForFastRestore(n) {
    const e = this._copyInlayHintsWithCurrentAnchor(n);
    this._inlayHintsCache.set(n, e);
  }
  _copyInlayHintsWithCurrentAnchor(n) {
    const e = /* @__PURE__ */ new Map();
    for (const [t, i] of this._decorationsMetadata) {
      if (e.has(i.item)) continue;
      const s = n.getDecorationRange(t);
      if (s) {
        const o = new nU(s, i.item.anchor.direction), r = i.item.with({ anchor: o });
        e.set(i.item, r);
      }
    }
    return Array.from(e.values());
  }
  _getHintsRanges() {
    const n = this._editor.getModel(), e = this._editor.getVisibleRangesPlusViewportAboveBelow(), t = [];
    for (const i of e.sort(D.compareRangesUsingStarts)) {
      const s = n.validateRange(new D(i.startLineNumber - 30, i.startColumn, i.endLineNumber + 30, i.endColumn));
      t.length !== 0 && D.areIntersectingOrTouching(t[t.length - 1], s) ? t[t.length - 1] = D.plusRange(t[t.length - 1], s) : t.push(s);
    }
    return t;
  }
  _updateHintsDecorators(n, e) {
    var t, i;
    const s = [], o = (f, _, v, b, C) => {
      const w = { content: v, inlineClassNameAffectsLetterSpacing: !0, inlineClassName: _.className, cursorStops: b, attachedData: C };
      s.push({ item: f, classNameRef: _, decoration: { range: f.anchor.range, options: { description: "InlayHint", showIfCollapsed: f.anchor.range.isEmpty(), collapseOnReplaceEdit: !f.anchor.range.isEmpty(), stickiness: 0, [f.anchor.direction]: this._activeRenderMode === 0 ? w : void 0 } } });
    }, r = (f, _) => {
      const v = this._ruleFactory.createClassNameRef({ width: (a / 3 | 0) + "px", display: "inline-block" });
      o(f, v, " ", _ ? vr.Right : vr.None);
    }, { fontSize: a, fontFamily: l, padding: d, isUniform: h } = this._getLayoutInfo(), c = "--code-editorInlayHintsFontFamily";
    this._editor.getContainerDomNode().style.setProperty(c, l);
    let u = { line: 0, totalLen: 0 };
    for (const f of e) {
      if (u.line !== f.anchor.range.startLineNumber && (u = { line: f.anchor.range.startLineNumber, totalLen: 0 }), u.totalLen > bp._MAX_LABEL_LEN) continue;
      f.hint.paddingLeft && r(f, !1);
      const _ = typeof f.hint.label == "string" ? [{ label: f.hint.label }] : f.hint.label;
      for (let v = 0; v < _.length; v++) {
        const b = _[v], C = v === 0, w = v === _.length - 1, y = { fontSize: `${a}px`, fontFamily: `var(${c}), ${Is.fontFamily}`, verticalAlign: h ? "baseline" : "middle", unicodeBidi: "isolate" };
        zn(f.hint.textEdits) && (y.cursor = "default"), this._fillInColors(y, f.hint), (b.command || b.location) && ((t = this._activeInlayHintPart) === null || t === void 0 ? void 0 : t.part.item) === f && this._activeInlayHintPart.part.index === v && (y.textDecoration = "underline", this._activeInlayHintPart.hasTriggerModifier && (y.color = ui(m$), y.cursor = "pointer")), d && (C && w ? (y.padding = `1px ${0 | Math.max(1, a / 4)}px`, y.borderRadius = (a / 4 | 0) + "px") : C ? (y.padding = `1px 0 1px ${0 | Math.max(1, a / 4)}px`, y.borderRadius = `${a / 4 | 0}px 0 0 ${a / 4 | 0}px`) : w ? (y.padding = `1px ${0 | Math.max(1, a / 4)}px 1px 0`, y.borderRadius = `0 ${a / 4 | 0}px ${a / 4 | 0}px 0`) : y.padding = "1px 0 1px 0");
        let L = b.label;
        u.totalLen += L.length;
        let k = !1;
        const N = u.totalLen - bp._MAX_LABEL_LEN;
        if (N > 0 && (L = L.slice(0, -N) + "…", k = !0), o(f, this._ruleFactory.createClassNameRef(y), Dde(L), w && !f.hint.paddingRight ? vr.Right : vr.None, new lT(f, v)), k) break;
      }
      if (f.hint.paddingRight && r(f, !0), s.length > bp._MAX_DECORATORS) break;
    }
    const g = [];
    for (const [f, _] of this._decorationsMetadata) {
      const v = (i = this._editor.getModel()) === null || i === void 0 ? void 0 : i.getDecorationRange(f);
      v && n.some(((b) => b.containsRange(v))) && (g.push(f), _.classNameRef.dispose(), this._decorationsMetadata.delete(f));
    }
    const p = wa.capture(this._editor);
    this._editor.changeDecorations(((f) => {
      const _ = f.deltaDecorations(g, s.map(((v) => v.decoration)));
      for (let v = 0; v < _.length; v++) {
        const b = s[v];
        this._decorationsMetadata.set(_[v], b);
      }
    })), p.restore(this._editor);
  }
  _fillInColors(n, e) {
    e.kind === Aw.Parameter ? (n.backgroundColor = ui(w$), n.color = ui(C$)) : e.kind === Aw.Type ? (n.backgroundColor = ui(b$), n.color = ui(v$)) : (n.backgroundColor = ui(ud), n.color = ui(cd));
  }
  _getLayoutInfo() {
    const n = this._editor.getOption(141), e = n.padding, t = this._editor.getOption(52), i = this._editor.getOption(49);
    let s = n.fontSize;
    (!s || s < 5 || s > t) && (s = t);
    const o = n.fontFamily || i;
    return { fontSize: s, fontFamily: o, padding: e, isUniform: !e && o === i && s === t };
  }
  _removeAllDecorations() {
    this._editor.removeDecorations(Array.from(this._decorationsMetadata.keys()));
    for (const n of this._decorationsMetadata.values()) n.classNameRef.dispose();
    this._decorationsMetadata.clear();
  }
};
function Dde(n) {
  return n.replace(/[ \t]/g, " ");
}
Lh.ID = "editor.contrib.InlayHints", Lh._MAX_DECORATORS = 1500, Lh._MAX_LABEL_LEN = 43, Lh = bp = Lde([lp(1, fe), lp(2, ar), lp(3, oU), lp(4, ai), lp(5, Ri), lp(6, Se)], Lh), dt.registerCommand("_executeInlayHintProvider", (async (n, ...e) => {
  const [t, i] = e;
  vt(Ie.isUri(t)), vt(D.isIRange(i));
  const { inlayHintsProvider: s } = n.get(fe), o = await n.get(Ps).createModelReference(t);
  try {
    const r = await tg.create(s, o.object.textEditorModel, [D.lift(i)], et.None), a = r.items.map(((l) => l.hint));
    return setTimeout((() => r.dispose()), 0), a;
  } finally {
    o.dispose();
  }
}));
var xde = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, n_ = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class E9 extends Zu {
  constructor(e, t, i, s) {
    super(10, t, e.item.anchor.range, i, s, !0), this.part = e;
  }
}
let Qx = class extends mS {
  constructor(n, e, t, i, s, o) {
    super(n, e, t, i, o), this._resolverService = s, this.hoverOrdinal = 6;
  }
  suggestHoverAnchor(n) {
    var e;
    if (!Lh.get(this._editor) || n.target.type !== 6) return null;
    const t = (e = n.target.detail.injectedText) === null || e === void 0 ? void 0 : e.options;
    return t instanceof xc && t.attachedData instanceof lT ? new E9(t.attachedData, this, n.event.posx, n.event.posy) : null;
  }
  computeSync() {
    return [];
  }
  computeAsync(n, e, t) {
    return n instanceof E9 ? new Pi((async (i) => {
      const { part: s } = n;
      if (await s.item.resolve(t), t.isCancellationRequested) return;
      let o, r;
      if (typeof s.item.hint.tooltip == "string" ? o = new Vn().appendText(s.item.hint.tooltip) : s.item.hint.tooltip && (o = s.item.hint.tooltip), o && i.emitOne(new Jr(this, n.range, [o], !1, 0)), zn(s.item.hint.textEdits) && i.emitOne(new Jr(this, n.range, [new Vn().appendText(m(0, "Double-click to insert"))], !1, 10001)), typeof s.part.tooltip == "string" ? r = new Vn().appendText(s.part.tooltip) : s.part.tooltip && (r = s.part.tooltip), r && i.emitOne(new Jr(this, n.range, [r], !1, 1)), s.part.location || s.part.command) {
        let d;
        const h = m(0, this._editor.getOption(78) === "altKey" ? Je ? "cmd + click" : "ctrl + click" : Je ? "option + click" : "alt + click");
        s.part.location && s.part.command ? d = new Vn().appendText(m(0, "Go to Definition ({0}), right click for more", h)) : s.part.location ? d = new Vn().appendText(m(0, "Go to Definition ({0})", h)) : s.part.command && (d = new Vn(`[${m(0, "Execute Command")}](${a = s.part.command, Ie.from({ scheme: Ue.command, path: a.id, query: a.arguments && encodeURIComponent(JSON.stringify(a.arguments)) }).toString()} "${s.part.command.title}") (${h})`, { isTrusted: !0 })), d && i.emitOne(new Jr(this, n.range, [d], !1, 1e4));
      }
      var a;
      const l = await this._resolveInlayHintLabelPartHover(s, t);
      for await (const d of l) i.emitOne(d);
    })) : Pi.EMPTY;
  }
  async _resolveInlayHintLabelPartHover(n, e) {
    if (!n.part.location) return Pi.EMPTY;
    const { uri: t, range: i } = n.part.location, s = await this._resolverService.createModelReference(t);
    try {
      const o = s.object.textEditorModel;
      return this._languageFeaturesService.hoverProvider.has(o) ? wP(this._languageFeaturesService.hoverProvider, o, new W(i.startLineNumber, i.startColumn), e).filter(((r) => !jm(r.hover.contents))).map(((r) => new Jr(this, n.item.anchor.range, r.hover.contents, !1, 2 + r.ordinal))) : Pi.EMPTY;
    } finally {
      s.dispose();
    }
  }
};
Qx = xde([n_(1, Xt), n_(2, Fs), n_(3, Ye), n_(4, Ps), n_(5, fe)], Qx), ft(Lh.ID, Lh, 1), Tc.register(Qx);
class Nde {
  constructor(e, t, i) {
    this._editRange = e, this._originalSelection = t, this._text = i;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._editRange, this._text);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return this._originalSelection.isEmpty() ? new _e(i.endLineNumber, Math.min(this._originalSelection.positionColumn, i.endColumn), i.endLineNumber, Math.min(this._originalSelection.positionColumn, i.endColumn)) : new _e(i.endLineNumber, i.endColumn - this._text.length, i.endLineNumber, i.endColumn);
  }
}
var vw, Ede = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ide = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Gh = vw = class {
  static get(n) {
    return n.getContribution(vw.ID);
  }
  constructor(n, e) {
    this.editor = n, this.editorWorkerService = e, this.decorations = this.editor.createDecorationsCollection();
  }
  dispose() {
  }
  run(n, e) {
    var t;
    (t = this.currentRequest) === null || t === void 0 || t.cancel();
    const i = this.editor.getSelection(), s = this.editor.getModel();
    if (!s || !i) return;
    let o = i;
    if (o.startLineNumber !== o.endLineNumber) return;
    const r = new tH(this.editor, 5), a = s.uri;
    return this.editorWorkerService.canNavigateValueSet(a) ? (this.currentRequest = on(((l) => this.editorWorkerService.navigateValueSet(a, o, e))), this.currentRequest.then(((l) => {
      var d;
      if (!l || !l.range || !l.value || !r.validate(this.editor)) return;
      const h = D.lift(l.range);
      let c = l.range;
      const u = l.value.length - (o.endColumn - o.startColumn);
      c = { startLineNumber: c.startLineNumber, startColumn: c.startColumn, endLineNumber: c.endLineNumber, endColumn: c.startColumn + l.value.length }, u > 1 && (o = new _e(o.startLineNumber, o.startColumn, o.endLineNumber, o.endColumn + u - 1));
      const g = new Nde(h, o, l.value);
      this.editor.pushUndoStop(), this.editor.executeCommand(n, g), this.editor.pushUndoStop(), this.decorations.set([{ range: c, options: vw.DECORATION }]), (d = this.decorationRemover) === null || d === void 0 || d.cancel(), this.decorationRemover = vc(350), this.decorationRemover.then((() => this.decorations.clear())).catch(We);
    })).catch(We)) : Promise.resolve(void 0);
  }
};
Gh.ID = "editor.contrib.inPlaceReplaceController", Gh.DECORATION = Ve.register({ description: "in-place-replace", className: "valueSetReplacement" }), Gh = vw = Ede([Ide(1, Qo)], Gh);
ft(Gh.ID, Gh, 4), X(class extends he {
  constructor() {
    super({ id: "editor.action.inPlaceReplace.up", label: m(0, "Replace with Previous Value"), alias: "Replace with Previous Value", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 3159, weight: 100 } });
  }
  run(n, e) {
    const t = Gh.get(e);
    return t ? t.run(this.id, !1) : Promise.resolve(void 0);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.inPlaceReplace.down", label: m(0, "Replace with Next Value"), alias: "Replace with Next Value", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 3161, weight: 100 } });
  }
  run(n, e) {
    const t = Gh.get(e);
    return t ? t.run(this.id, !0) : Promise.resolve(void 0);
  }
});
X(class extends he {
  constructor() {
    super({ id: "expandLineSelection", label: m(0, "Expand Line Selection"), alias: "Expand Line Selection", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2090 } });
  }
  run(n, e, t) {
    if (t = t || {}, !e.hasModel()) return;
    const i = e._getViewModel();
    i.model.pushStackElement(), i.setCursorStates(t.source, 3, mn.expandLineSelection(i, i.getCursorStates())), i.revealAllCursors(t.source, !0);
  }
});
class Mde {
  constructor(e, t, i) {
    this._selection = e, this._cursors = t, this._selectionId = null, this._trimInRegexesAndStrings = i;
  }
  getEditOperations(e, t) {
    const i = (function(s, o, r) {
      o.sort(((c, u) => c.lineNumber === u.lineNumber ? c.column - u.column : c.lineNumber - u.lineNumber));
      for (let c = o.length - 2; c >= 0; c--) o[c].lineNumber === o[c + 1].lineNumber && o.splice(c, 1);
      const a = [];
      let l = 0, d = 0;
      const h = o.length;
      for (let c = 1, u = s.getLineCount(); c <= u; c++) {
        const g = s.getLineContent(c), p = g.length + 1;
        let f = 0;
        if (d < h && o[d].lineNumber === c && (f = o[d].column, d++, f === p) || g.length === 0) continue;
        const _ = oa(g);
        let v = 0;
        if (_ === -1) v = 1;
        else {
          if (_ === g.length - 1) continue;
          v = _ + 2;
        }
        if (!r) {
          if (!s.tokenization.hasAccurateTokensForLine(c)) continue;
          const b = s.tokenization.getLineTokens(c), C = b.getStandardTokenType(b.findTokenIndexAtOffset(v));
          if (C === 2 || C === 3) continue;
        }
        v = Math.max(f, v), a[l++] = ii.delete(new D(c, v, c, p));
      }
      return a;
    })(e, this._cursors, this._trimInRegexesAndStrings);
    for (let s = 0, o = i.length; s < o; s++) {
      const r = i[s];
      t.addEditOperation(r.range, r.text);
    }
    this._selectionId = t.trackSelection(this._selection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._selectionId);
  }
}
class rU {
  constructor(e, t, i) {
    this._selection = e, this._isCopyingDown = t, this._noop = i || !1, this._selectionDirection = 0, this._selectionId = null, this._startLineNumberDelta = 0, this._endLineNumberDelta = 0;
  }
  getEditOperations(e, t) {
    let i = this._selection;
    this._startLineNumberDelta = 0, this._endLineNumberDelta = 0, i.startLineNumber < i.endLineNumber && i.endColumn === 1 && (this._endLineNumberDelta = 1, i = i.setEndPosition(i.endLineNumber - 1, e.getLineMaxColumn(i.endLineNumber - 1)));
    const s = [];
    for (let r = i.startLineNumber; r <= i.endLineNumber; r++) s.push(e.getLineContent(r));
    const o = s.join(`
`);
    o === "" && this._isCopyingDown && (this._startLineNumberDelta++, this._endLineNumberDelta++), this._noop ? t.addEditOperation(new D(i.endLineNumber, e.getLineMaxColumn(i.endLineNumber), i.endLineNumber + 1, 1), i.endLineNumber === e.getLineCount() ? "" : `
`) : this._isCopyingDown ? t.addEditOperation(new D(i.startLineNumber, 1, i.startLineNumber, 1), o + `
`) : t.addEditOperation(new D(i.endLineNumber, e.getLineMaxColumn(i.endLineNumber), i.endLineNumber, e.getLineMaxColumn(i.endLineNumber)), `
` + o), this._selectionId = t.trackSelection(i), this._selectionDirection = this._selection.getDirection();
  }
  computeCursorState(e, t) {
    let i = t.getTrackedSelection(this._selectionId);
    if (this._startLineNumberDelta !== 0 || this._endLineNumberDelta !== 0) {
      let s = i.startLineNumber, o = i.startColumn, r = i.endLineNumber, a = i.endColumn;
      this._startLineNumberDelta !== 0 && (s += this._startLineNumberDelta, o = 1), this._endLineNumberDelta !== 0 && (r += this._endLineNumberDelta, a = 1), i = _e.createWithDirection(s, o, r, a, this._selectionDirection);
    }
    return i;
  }
}
var Tde = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Rde = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let dT = class {
  constructor(n, e, t, i) {
    this._languageConfigurationService = i, this._selection = n, this._isMovingDown = e, this._autoIndent = t, this._selectionId = null, this._moveEndLineSelectionShrink = !1;
  }
  getEditOperations(n, e) {
    const t = n.getLineCount();
    if (this._isMovingDown && this._selection.endLineNumber === t) return void (this._selectionId = e.trackSelection(this._selection));
    if (!this._isMovingDown && this._selection.startLineNumber === 1) return void (this._selectionId = e.trackSelection(this._selection));
    this._moveEndPositionDown = !1;
    let i = this._selection;
    i.startLineNumber < i.endLineNumber && i.endColumn === 1 && (this._moveEndPositionDown = !0, i = i.setEndPosition(i.endLineNumber - 1, n.getLineMaxColumn(i.endLineNumber - 1)));
    const { tabSize: s, indentSize: o, insertSpaces: r } = n.getOptions(), a = this.buildIndentConverter(s, o, r), l = { tokenization: { getLineTokens: (d) => n.tokenization.getLineTokens(d), getLanguageId: () => n.getLanguageId(), getLanguageIdAtPosition: (d, h) => n.getLanguageIdAtPosition(d, h) }, getLineContent: null };
    if (i.startLineNumber === i.endLineNumber && n.getLineMaxColumn(i.startLineNumber) === 1) {
      const d = i.startLineNumber, h = this._isMovingDown ? d + 1 : d - 1;
      n.getLineMaxColumn(h) === 1 ? e.addEditOperation(new D(1, 1, 1, 1), null) : (e.addEditOperation(new D(d, 1, d, 1), n.getLineContent(h)), e.addEditOperation(new D(h, 1, h, n.getLineMaxColumn(h)), null)), i = new _e(h, 1, h, 1);
    } else {
      let d, h;
      if (this._isMovingDown) {
        d = i.endLineNumber + 1, h = n.getLineContent(d), e.addEditOperation(new D(d - 1, n.getLineMaxColumn(d - 1), d, n.getLineMaxColumn(d)), null);
        let c = h;
        if (this.shouldAutoIndent(n, i)) {
          const u = this.matchEnterRule(n, a, s, d, i.startLineNumber - 1);
          if (u !== null)
            c = R0(u + Ks(Wt(n.getLineContent(d)), s), s, r) + this.trimStart(h);
          else {
            l.getLineContent = (f) => f === i.startLineNumber ? n.getLineContent(d) : n.getLineContent(f);
            const p = t0(this._autoIndent, l, n.getLanguageIdAtPosition(d, 1), i.startLineNumber, a, this._languageConfigurationService);
            if (p !== null) {
              const f = Wt(n.getLineContent(d)), _ = Ks(p, s);
              _ !== Ks(f, s) && (c = R0(_, s, r) + this.trimStart(h));
            }
          }
          e.addEditOperation(new D(i.startLineNumber, 1, i.startLineNumber, 1), c + `
`);
          const g = this.matchEnterRuleMovingDown(n, a, s, i.startLineNumber, d, c);
          if (g !== null) g !== 0 && this.getIndentEditsOfMovingBlock(n, e, i, s, r, g);
          else {
            l.getLineContent = (f) => f === i.startLineNumber ? c : f >= i.startLineNumber + 1 && f <= i.endLineNumber + 1 ? n.getLineContent(f - 1) : n.getLineContent(f);
            const p = t0(this._autoIndent, l, n.getLanguageIdAtPosition(d, 1), i.startLineNumber + 1, a, this._languageConfigurationService);
            if (p !== null) {
              const f = Wt(n.getLineContent(i.startLineNumber)), _ = Ks(p, s), v = Ks(f, s);
              if (_ !== v) {
                const b = _ - v;
                this.getIndentEditsOfMovingBlock(n, e, i, s, r, b);
              }
            }
          }
        } else e.addEditOperation(new D(i.startLineNumber, 1, i.startLineNumber, 1), c + `
`);
      } else if (d = i.startLineNumber - 1, h = n.getLineContent(d), e.addEditOperation(new D(d, 1, d + 1, 1), null), e.addEditOperation(new D(i.endLineNumber, n.getLineMaxColumn(i.endLineNumber), i.endLineNumber, n.getLineMaxColumn(i.endLineNumber)), `
` + h), this.shouldAutoIndent(n, i)) {
        l.getLineContent = (u) => u === d ? n.getLineContent(i.startLineNumber) : n.getLineContent(u);
        const c = this.matchEnterRule(n, a, s, i.startLineNumber, i.startLineNumber - 2);
        if (c !== null) c !== 0 && this.getIndentEditsOfMovingBlock(n, e, i, s, r, c);
        else {
          const u = t0(this._autoIndent, l, n.getLanguageIdAtPosition(i.startLineNumber, 1), d, a, this._languageConfigurationService);
          if (u !== null) {
            const g = Wt(n.getLineContent(i.startLineNumber)), p = Ks(u, s), f = Ks(g, s);
            if (p !== f) {
              const _ = p - f;
              this.getIndentEditsOfMovingBlock(n, e, i, s, r, _);
            }
          }
        }
      }
    }
    this._selectionId = e.trackSelection(i);
  }
  buildIndentConverter(n, e, t) {
    return { shiftIndent: (i) => Ko.shiftIndent(i, i.length + 1, n, e, t), unshiftIndent: (i) => Ko.unshiftIndent(i, i.length + 1, n, e, t) };
  }
  parseEnterResult(n, e, t, i, s) {
    if (s) {
      let o = s.indentation;
      s.indentAction === Oi.None || s.indentAction === Oi.Indent ? o = s.indentation + s.appendText : s.indentAction === Oi.IndentOutdent ? o = s.indentation : s.indentAction === Oi.Outdent && (o = e.unshiftIndent(s.indentation) + s.appendText);
      const r = n.getLineContent(i);
      if (this.trimStart(r).indexOf(this.trimStart(o)) >= 0) {
        const a = Wt(n.getLineContent(i));
        let l = Wt(o);
        const d = FB(n, i, this._languageConfigurationService);
        return d !== null && 2 & d && (l = e.unshiftIndent(l)), Ks(l, t) - Ks(a, t);
      }
    }
    return null;
  }
  matchEnterRuleMovingDown(n, e, t, i, s, o) {
    if (oa(o) >= 0) {
      const r = n.getLineMaxColumn(s), a = sm(this._autoIndent, n, new D(s, r, s, r), this._languageConfigurationService);
      return this.parseEnterResult(n, e, t, i, a);
    }
    {
      let r = i - 1;
      for (; r >= 1 && !(oa(n.getLineContent(r)) >= 0); )
        r--;
      if (r < 1 || i > n.getLineCount()) return null;
      const a = n.getLineMaxColumn(r), l = sm(this._autoIndent, n, new D(r, a, r, a), this._languageConfigurationService);
      return this.parseEnterResult(n, e, t, i, l);
    }
  }
  matchEnterRule(n, e, t, i, s, o) {
    let r = s;
    for (; r >= 1; ) {
      let d;
      if (d = r === s && o !== void 0 ? o : n.getLineContent(r), oa(d) >= 0) break;
      r--;
    }
    if (r < 1 || i > n.getLineCount()) return null;
    const a = n.getLineMaxColumn(r), l = sm(this._autoIndent, n, new D(r, a, r, a), this._languageConfigurationService);
    return this.parseEnterResult(n, e, t, i, l);
  }
  trimStart(n) {
    return n.replace(/^\s+/, "");
  }
  shouldAutoIndent(n, e) {
    if (this._autoIndent < 4 || !n.tokenization.isCheapToTokenize(e.startLineNumber)) return !1;
    const t = n.getLanguageIdAtPosition(e.startLineNumber, 1);
    return t === n.getLanguageIdAtPosition(e.endLineNumber, 1) && this._languageConfigurationService.getLanguageConfiguration(t).indentRulesSupport !== null;
  }
  getIndentEditsOfMovingBlock(n, e, t, i, s, o) {
    for (let r = t.startLineNumber; r <= t.endLineNumber; r++) {
      const a = Wt(n.getLineContent(r)), l = R0(Ks(a, i) + o, i, s);
      l !== a && (e.addEditOperation(new D(r, 1, r, a.length + 1), l), r === t.endLineNumber && t.endColumn <= a.length + 1 && l === "" && (this._moveEndLineSelectionShrink = !0));
    }
  }
  computeCursorState(n, e) {
    let t = e.getTrackedSelection(this._selectionId);
    return this._moveEndPositionDown && (t = t.setEndPosition(t.endLineNumber + 1, 1)), this._moveEndLineSelectionShrink && t.startLineNumber < t.endLineNumber && (t = t.setEndPosition(t.endLineNumber, 2)), t;
  }
};
dT = Tde([Rde(3, zt)], dT);
class hc {
  static getCollator() {
    return hc._COLLATOR || (hc._COLLATOR = new Intl.Collator()), hc._COLLATOR;
  }
  constructor(e, t) {
    this.selection = e, this.descending = t, this.selectionId = null;
  }
  getEditOperations(e, t) {
    const i = (function(s, o, r) {
      const a = I9(s, o, r);
      return a ? ii.replace(new D(a.startLineNumber, 1, a.endLineNumber, s.getLineMaxColumn(a.endLineNumber)), a.after.join(`
`)) : null;
    })(e, this.selection, this.descending);
    i && t.addEditOperation(i.range, i.text), this.selectionId = t.trackSelection(this.selection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this.selectionId);
  }
  static canRun(e, t, i) {
    if (e === null) return !1;
    const s = I9(e, t, i);
    if (!s) return !1;
    for (let o = 0, r = s.before.length; o < r; o++) if (s.before[o] !== s.after[o]) return !0;
    return !1;
  }
}
function I9(n, e, t) {
  const i = e.startLineNumber;
  let s = e.endLineNumber;
  if (e.endColumn === 1 && s--, i >= s) return null;
  const o = [];
  for (let a = i; a <= s; a++) o.push(n.getLineContent(a));
  let r = o.slice(0);
  return r.sort(hc.getCollator().compare), t === !0 && (r = r.reverse()), { startLineNumber: i, endLineNumber: s, before: o, after: r };
}
hc._COLLATOR = null;
class M9 extends he {
  constructor(e, t) {
    super(t), this.down = e;
  }
  run(e, t) {
    if (!t.hasModel()) return;
    const i = t.getSelections().map(((r, a) => ({ selection: r, index: a, ignore: !1 })));
    i.sort(((r, a) => D.compareRangesUsingStarts(r.selection, a.selection)));
    let s = i[0];
    for (let r = 1; r < i.length; r++) {
      const a = i[r];
      s.selection.endLineNumber === a.selection.startLineNumber && (s.index < a.index ? a.ignore = !0 : (s.ignore = !0, s = a));
    }
    const o = [];
    for (const r of i) o.push(new rU(r.selection, this.down, r.ignore));
    t.pushUndoStop(), t.executeCommands(this.id, o), t.pushUndoStop();
  }
}
class T9 extends he {
  constructor(e, t) {
    super(t), this.down = e;
  }
  run(e, t) {
    const i = e.get(zt), s = [], o = t.getSelections() || [], r = t.getOption(12);
    for (const a of o) s.push(new dT(a, this.down, r, i));
    t.pushUndoStop(), t.executeCommands(this.id, s), t.pushUndoStop();
  }
}
class R9 extends he {
  constructor(e, t) {
    super(t), this.descending = e;
  }
  run(e, t) {
    if (!t.hasModel()) return;
    const i = t.getModel();
    let s = t.getSelections();
    s.length === 1 && s[0].isEmpty() && (s = [new _e(1, 1, i.getLineCount(), i.getLineMaxColumn(i.getLineCount()))]);
    for (const r of s) if (!hc.canRun(t.getModel(), r, this.descending)) return;
    const o = [];
    for (let r = 0, a = s.length; r < a; r++) o[r] = new hc(s[r], this.descending);
    t.pushUndoStop(), t.executeCommands(this.id, o), t.pushUndoStop();
  }
}
class _k extends he {
  constructor() {
    super({ id: _k.ID, label: m(0, "Trim Trailing Whitespace"), alias: "Trim Trailing Whitespace", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2102), weight: 100 } });
  }
  run(e, t, i) {
    let s = [];
    i.reason === "auto-save" && (s = (t.getSelections() || []).map(((h) => new W(h.positionLineNumber, h.positionColumn))));
    const o = t.getSelection();
    if (o === null) return;
    const r = e.get(Ye), a = t.getModel(), l = r.getValue("files.trimTrailingWhitespaceInRegexAndStrings", { overrideIdentifier: a?.getLanguageId(), resource: a?.uri }), d = new Mde(o, s, l);
    t.pushUndoStop(), t.executeCommands(this.id, [d]), t.pushUndoStop();
  }
}
_k.ID = "editor.action.trimTrailingWhitespace";
class A9 extends he {
  run(e, t) {
    if (!t.hasModel()) return;
    const i = t.getSelection(), s = this._getRangesToDelete(t), o = [];
    for (let l = 0, d = s.length - 1; l < d; l++) {
      const h = s[l], c = s[l + 1];
      D.intersectRanges(h, c) === null ? o.push(h) : s[l + 1] = D.plusRange(h, c);
    }
    o.push(s[s.length - 1]);
    const r = this._getEndCursorState(i, o), a = o.map(((l) => ii.replace(l, "")));
    t.pushUndoStop(), t.executeEdits(this.id, a, r), t.pushUndoStop();
  }
}
class wg extends he {
  run(e, t) {
    const i = t.getSelections();
    if (i === null) return;
    const s = t.getModel();
    if (s === null) return;
    const o = t.getOption(131), r = [];
    for (const a of i) if (a.isEmpty()) {
      const l = a.getStartPosition(), d = t.getConfiguredWordAtPosition(l);
      if (!d) continue;
      const h = new D(l.lineNumber, d.startColumn, l.lineNumber, d.endColumn), c = s.getValueInRange(h);
      r.push(ii.replace(h, this._modifyText(c, o)));
    } else {
      const l = s.getValueInRange(a);
      r.push(ii.replace(a, this._modifyText(l, o)));
    }
    t.pushUndoStop(), t.executeEdits(this.id, r), t.pushUndoStop();
  }
}
class Md {
  constructor(e, t) {
    this._pattern = e, this._flags = t, this._actual = null, this._evaluated = !1;
  }
  get() {
    if (!this._evaluated) {
      this._evaluated = !0;
      try {
        this._actual = new RegExp(this._pattern, this._flags);
      } catch {
      }
    }
    return this._actual;
  }
  isSupported() {
    return this.get() !== null;
  }
}
class o1 extends wg {
  constructor() {
    super({ id: "editor.action.transformToTitlecase", label: m(0, "Transform to Title Case"), alias: "Transform to Title Case", precondition: E.writable });
  }
  _modifyText(e, t) {
    const i = o1.titleBoundary.get();
    return i ? e.toLocaleLowerCase().replace(i, ((s) => s.toLocaleUpperCase())) : e;
  }
}
o1.titleBoundary = new Md("(^|[^\\p{L}\\p{N}']|((^|\\P{L})'))\\p{L}", "gmu");
class cc extends wg {
  constructor() {
    super({ id: "editor.action.transformToSnakecase", label: m(0, "Transform to Snake Case"), alias: "Transform to Snake Case", precondition: E.writable });
  }
  _modifyText(e, t) {
    const i = cc.caseBoundary.get(), s = cc.singleLetters.get();
    return i && s ? e.replace(i, "$1_$2").replace(s, "$1_$2$3").toLocaleLowerCase() : e;
  }
}
cc.caseBoundary = new Md("(\\p{Ll})(\\p{Lu})", "gmu"), cc.singleLetters = new Md("(\\p{Lu}|\\p{N})(\\p{Lu})(\\p{Ll})", "gmu");
class r1 extends wg {
  constructor() {
    super({ id: "editor.action.transformToCamelcase", label: m(0, "Transform to Camel Case"), alias: "Transform to Camel Case", precondition: E.writable });
  }
  _modifyText(e, t) {
    const i = r1.wordBoundary.get();
    if (!i) return e;
    const s = e.split(i);
    return s.shift() + s.map(((o) => o.substring(0, 1).toLocaleUpperCase() + o.substring(1))).join("");
  }
}
r1.wordBoundary = new Md("[_\\s-]", "gm");
class yg extends wg {
  constructor() {
    super({ id: "editor.action.transformToPascalcase", label: m(0, "Transform to Pascal Case"), alias: "Transform to Pascal Case", precondition: E.writable });
  }
  _modifyText(e, t) {
    const i = yg.wordBoundary.get(), s = yg.wordBoundaryToMaintain.get();
    return !i || !s ? e : e.split(s).map(((o) => o.split(i))).flat().map(((o) => o.substring(0, 1).toLocaleUpperCase() + o.substring(1))).join("");
  }
}
yg.wordBoundary = new Md("[_\\s-]", "gm"), yg.wordBoundaryToMaintain = new Md("(?<=\\.)", "gm");
class nd extends wg {
  static isSupported() {
    return [this.caseBoundary, this.singleLetters, this.underscoreBoundary].every(((e) => e.isSupported()));
  }
  constructor() {
    super({ id: "editor.action.transformToKebabcase", label: m(0, "Transform to Kebab Case"), alias: "Transform to Kebab Case", precondition: E.writable });
  }
  _modifyText(e, t) {
    const i = nd.caseBoundary.get(), s = nd.singleLetters.get(), o = nd.underscoreBoundary.get();
    return i && s && o ? e.replace(o, "$1-$3").replace(i, "$1-$2").replace(s, "$1-$2").toLocaleLowerCase() : e;
  }
}
nd.caseBoundary = new Md("(\\p{Ll})(\\p{Lu})", "gmu"), nd.singleLetters = new Md("(\\p{Lu}|\\p{N})(\\p{Lu}\\p{Ll})", "gmu"), nd.underscoreBoundary = new Md("(\\S)(_)(\\S)", "gm"), X(class extends M9 {
  constructor() {
    super(!1, { id: "editor.action.copyLinesUpAction", label: m(0, "Copy Line Up"), alias: "Copy Line Up", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 1552, linux: { primary: 3600 }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "2_line", title: m(0, "&&Copy Line Up"), order: 1 } });
  }
}), X(class extends M9 {
  constructor() {
    super(!0, { id: "editor.action.copyLinesDownAction", label: m(0, "Copy Line Down"), alias: "Copy Line Down", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 1554, linux: { primary: 3602 }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "2_line", title: m(0, "Co&&py Line Down"), order: 2 } });
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.duplicateSelection", label: m(0, "Duplicate Selection"), alias: "Duplicate Selection", precondition: E.writable, menuOpts: { menuId: x.MenubarSelectionMenu, group: "2_line", title: m(0, "&&Duplicate Selection"), order: 5 } });
  }
  run(n, e, t) {
    if (!e.hasModel()) return;
    const i = [], s = e.getSelections(), o = e.getModel();
    for (const r of s) if (r.isEmpty()) i.push(new rU(r, !0));
    else {
      const a = new _e(r.endLineNumber, r.endColumn, r.endLineNumber, r.endColumn);
      i.push(new JZ(a, o.getValueInRange(r)));
    }
    e.pushUndoStop(), e.executeCommands(this.id, i), e.pushUndoStop();
  }
}), X(class extends T9 {
  constructor() {
    super(!1, { id: "editor.action.moveLinesUpAction", label: m(0, "Move Line Up"), alias: "Move Line Up", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 528, linux: { primary: 528 }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "2_line", title: m(0, "Mo&&ve Line Up"), order: 3 } });
  }
}), X(class extends T9 {
  constructor() {
    super(!0, { id: "editor.action.moveLinesDownAction", label: m(0, "Move Line Down"), alias: "Move Line Down", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 530, linux: { primary: 530 }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "2_line", title: m(0, "Move &&Line Down"), order: 4 } });
  }
}), X(class extends R9 {
  constructor() {
    super(!1, { id: "editor.action.sortLinesAscending", label: m(0, "Sort Lines Ascending"), alias: "Sort Lines Ascending", precondition: E.writable });
  }
}), X(class extends R9 {
  constructor() {
    super(!0, { id: "editor.action.sortLinesDescending", label: m(0, "Sort Lines Descending"), alias: "Sort Lines Descending", precondition: E.writable });
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.removeDuplicateLines", label: m(0, "Delete Duplicate Lines"), alias: "Delete Duplicate Lines", precondition: E.writable });
  }
  run(n, e) {
    if (!e.hasModel()) return;
    const t = e.getModel();
    if (t.getLineCount() === 1 && t.getLineMaxColumn(1) === 1) return;
    const i = [], s = [];
    let o = 0, r = !0, a = e.getSelections();
    a.length === 1 && a[0].isEmpty() && (a = [new _e(1, 1, t.getLineCount(), t.getLineMaxColumn(t.getLineCount()))], r = !1);
    for (const l of a) {
      const d = /* @__PURE__ */ new Set(), h = [];
      for (let p = l.startLineNumber; p <= l.endLineNumber; p++) {
        const f = t.getLineContent(p);
        d.has(f) || (h.push(f), d.add(f));
      }
      const c = new _e(l.startLineNumber, 1, l.endLineNumber, t.getLineMaxColumn(l.endLineNumber)), u = l.startLineNumber - o, g = new _e(u, 1, u + h.length - 1, h[h.length - 1].length);
      i.push(ii.replace(c, h.join(`
`))), s.push(g), o += l.endLineNumber - l.startLineNumber + 1 - h.length;
    }
    e.pushUndoStop(), e.executeEdits(this.id, i, r ? s : void 0), e.pushUndoStop();
  }
}), X(_k), X(class extends he {
  constructor() {
    super({ id: "editor.action.deleteLines", label: m(0, "Delete Line"), alias: "Delete Line", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 3113, weight: 100 } });
  }
  run(n, e) {
    if (!e.hasModel()) return;
    const t = this._getLinesToRemove(e), i = e.getModel();
    if (i.getLineCount() === 1 && i.getLineMaxColumn(1) === 1) return;
    let s = 0;
    const o = [], r = [];
    for (let a = 0, l = t.length; a < l; a++) {
      const d = t[a];
      let h = d.startLineNumber, c = d.endLineNumber, u = 1, g = i.getLineMaxColumn(c);
      c < i.getLineCount() ? (c += 1, g = 1) : h > 1 && (h -= 1, u = i.getLineMaxColumn(h)), o.push(ii.replace(new _e(h, u, c, g), "")), r.push(new _e(h - s, d.positionColumn, h - s, d.positionColumn)), s += d.endLineNumber - d.startLineNumber + 1;
    }
    e.pushUndoStop(), e.executeEdits(this.id, o, r), e.pushUndoStop();
  }
  _getLinesToRemove(n) {
    const e = n.getSelections().map(((s) => {
      let o = s.endLineNumber;
      return s.startLineNumber < s.endLineNumber && s.endColumn === 1 && (o -= 1), { startLineNumber: s.startLineNumber, selectionStartColumn: s.selectionStartColumn, endLineNumber: o, positionColumn: s.positionColumn };
    }));
    e.sort(((s, o) => s.startLineNumber === o.startLineNumber ? s.endLineNumber - o.endLineNumber : s.startLineNumber - o.startLineNumber));
    const t = [];
    let i = e[0];
    for (let s = 1; s < e.length; s++) i.endLineNumber + 1 >= e[s].startLineNumber ? i.endLineNumber = e[s].endLineNumber : (t.push(i), i = e[s]);
    return t.push(i), t;
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.indentLines", label: m(0, "Indent Line"), alias: "Indent Line", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 2142, weight: 100 } });
  }
  run(n, e) {
    const t = e._getViewModel();
    t && (e.pushUndoStop(), e.executeCommands(this.id, oi.indent(t.cursorConfig, e.getModel(), e.getSelections())), e.pushUndoStop());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.outdentLines", label: m(0, "Outdent Line"), alias: "Outdent Line", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 2140, weight: 100 } });
  }
  run(n, e) {
    om.Outdent.runEditorCommand(n, e, null);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertLineBefore", label: m(0, "Insert Line Above"), alias: "Insert Line Above", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 3075, weight: 100 } });
  }
  run(n, e) {
    const t = e._getViewModel();
    t && (e.pushUndoStop(), e.executeCommands(this.id, oi.lineInsertBefore(t.cursorConfig, e.getModel(), e.getSelections())));
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertLineAfter", label: m(0, "Insert Line Below"), alias: "Insert Line Below", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 2051, weight: 100 } });
  }
  run(n, e) {
    const t = e._getViewModel();
    t && (e.pushUndoStop(), e.executeCommands(this.id, oi.lineInsertAfter(t.cursorConfig, e.getModel(), e.getSelections())));
  }
}), X(class extends A9 {
  constructor() {
    super({ id: "deleteAllLeft", label: m(0, "Delete All Left"), alias: "Delete All Left", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 2049 }, weight: 100 } });
  }
  _getEndCursorState(n, e) {
    let t = null;
    const i = [];
    let s = 0;
    return e.forEach(((o) => {
      let r;
      if (o.endColumn === 1 && s > 0) {
        const a = o.startLineNumber - s;
        r = new _e(a, o.startColumn, a, o.startColumn);
      } else r = new _e(o.startLineNumber, o.startColumn, o.startLineNumber, o.startColumn);
      s += o.endLineNumber - o.startLineNumber, o.intersectRanges(n) ? t = r : i.push(r);
    })), t && i.unshift(t), i;
  }
  _getRangesToDelete(n) {
    const e = n.getSelections();
    if (e === null) return [];
    let t = e;
    const i = n.getModel();
    return i === null ? [] : (t.sort(D.compareRangesUsingStarts), t = t.map(((s) => {
      if (s.isEmpty()) {
        if (s.startColumn === 1) {
          const o = Math.max(1, s.startLineNumber - 1), r = s.startLineNumber === 1 ? 1 : i.getLineLength(o) + 1;
          return new D(o, r, s.startLineNumber, 1);
        }
        return new D(s.startLineNumber, 1, s.startLineNumber, s.startColumn);
      }
      return new D(s.startLineNumber, 1, s.endLineNumber, s.endColumn);
    })), t);
  }
}), X(class extends A9 {
  constructor() {
    super({ id: "deleteAllRight", label: m(0, "Delete All Right"), alias: "Delete All Right", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 297, secondary: [2068] }, weight: 100 } });
  }
  _getEndCursorState(n, e) {
    let t = null;
    const i = [];
    for (let s = 0, o = e.length, r = 0; s < o; s++) {
      const a = e[s], l = new _e(a.startLineNumber - r, a.startColumn, a.startLineNumber - r, a.startColumn);
      a.intersectRanges(n) ? t = l : i.push(l);
    }
    return t && i.unshift(t), i;
  }
  _getRangesToDelete(n) {
    const e = n.getModel();
    if (e === null) return [];
    const t = n.getSelections();
    if (t === null) return [];
    const i = t.map(((s) => {
      if (s.isEmpty()) {
        const o = e.getLineMaxColumn(s.startLineNumber);
        return s.startColumn === o ? new D(s.startLineNumber, s.startColumn, s.startLineNumber + 1, 1) : new D(s.startLineNumber, s.startColumn, s.startLineNumber, o);
      }
      return s;
    }));
    return i.sort(D.compareRangesUsingStarts), i;
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.joinLines", label: m(0, "Join Lines"), alias: "Join Lines", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 0, mac: { primary: 296 }, weight: 100 } });
  }
  run(n, e) {
    const t = e.getSelections();
    if (t === null) return;
    let i = e.getSelection();
    if (i === null) return;
    t.sort(D.compareRangesUsingStarts);
    const s = [], o = t.reduce(((c, u) => c.isEmpty() ? c.endLineNumber === u.startLineNumber ? (i.equalsSelection(c) && (i = u), u) : u.startLineNumber > c.endLineNumber + 1 ? (s.push(c), u) : new _e(c.startLineNumber, c.startColumn, u.endLineNumber, u.endColumn) : u.startLineNumber > c.endLineNumber ? (s.push(c), u) : new _e(c.startLineNumber, c.startColumn, u.endLineNumber, u.endColumn)));
    s.push(o);
    const r = e.getModel();
    if (r === null) return;
    const a = [], l = [];
    let d = i, h = 0;
    for (let c = 0, u = s.length; c < u; c++) {
      const g = s[c], p = g.startLineNumber, f = 1;
      let _, v, b = 0;
      const C = r.getLineLength(g.endLineNumber) - g.endColumn;
      if (g.isEmpty() || g.startLineNumber === g.endLineNumber) {
        const L = g.getStartPosition();
        L.lineNumber < r.getLineCount() ? (_ = p + 1, v = r.getLineMaxColumn(_)) : (_ = L.lineNumber, v = r.getLineMaxColumn(L.lineNumber));
      } else _ = g.endLineNumber, v = r.getLineMaxColumn(_);
      let w = r.getLineContent(p);
      for (let L = p + 1; L <= _; L++) {
        const k = r.getLineContent(L), N = r.getLineFirstNonWhitespaceColumn(L);
        if (N >= 1) {
          let A = !0;
          w === "" && (A = !1), !A || w.charAt(w.length - 1) !== " " && w.charAt(w.length - 1) !== "	" || (A = !1, w = w.replace(/[\s\uFEFF\xA0]+$/g, " "));
          const B = k.substr(N - 1);
          w += (A ? " " : "") + B, b = A ? B.length + 1 : B.length;
        } else b = 0;
      }
      const y = new D(p, f, _, v);
      if (!y.isEmpty()) {
        let L;
        g.isEmpty() ? (a.push(ii.replace(y, w)), L = new _e(y.startLineNumber - h, w.length - b + 1, p - h, w.length - b + 1)) : g.startLineNumber === g.endLineNumber ? (a.push(ii.replace(y, w)), L = new _e(g.startLineNumber - h, g.startColumn, g.endLineNumber - h, g.endColumn)) : (a.push(ii.replace(y, w)), L = new _e(g.startLineNumber - h, g.startColumn, g.startLineNumber - h, w.length - C)), D.intersectRanges(y, i) !== null ? d = L : l.push(L);
      }
      h += y.endLineNumber - y.startLineNumber;
    }
    l.unshift(d), e.pushUndoStop(), e.executeEdits(this.id, a, l), e.pushUndoStop();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.transpose", label: m(0, "Transpose Characters around the Cursor"), alias: "Transpose Characters around the Cursor", precondition: E.writable });
  }
  run(n, e) {
    const t = e.getSelections();
    if (t === null) return;
    const i = e.getModel();
    if (i === null) return;
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o];
      if (!a.isEmpty()) continue;
      const l = a.getStartPosition(), d = i.getLineMaxColumn(l.lineNumber);
      if (l.column >= d) {
        if (l.lineNumber === i.getLineCount()) continue;
        const h = new D(l.lineNumber, Math.max(1, l.column - 1), l.lineNumber + 1, 1), c = i.getValueInRange(h).split("").reverse().join("");
        s.push(new Dn(new _e(l.lineNumber, Math.max(1, l.column - 1), l.lineNumber + 1, 1), c));
      } else {
        const h = new D(l.lineNumber, Math.max(1, l.column - 1), l.lineNumber, l.column + 1), c = i.getValueInRange(h).split("").reverse().join("");
        s.push(new KR(h, c, new _e(l.lineNumber, l.column + 1, l.lineNumber, l.column + 1)));
      }
    }
    e.pushUndoStop(), e.executeCommands(this.id, s), e.pushUndoStop();
  }
}), X(class extends wg {
  constructor() {
    super({ id: "editor.action.transformToUppercase", label: m(0, "Transform to Uppercase"), alias: "Transform to Uppercase", precondition: E.writable });
  }
  _modifyText(n, e) {
    return n.toLocaleUpperCase();
  }
}), X(class extends wg {
  constructor() {
    super({ id: "editor.action.transformToLowercase", label: m(0, "Transform to Lowercase"), alias: "Transform to Lowercase", precondition: E.writable });
  }
  _modifyText(n, e) {
    return n.toLocaleLowerCase();
  }
}), cc.caseBoundary.isSupported() && cc.singleLetters.isSupported() && X(cc), r1.wordBoundary.isSupported() && X(r1), yg.wordBoundary.isSupported() && X(yg), o1.titleBoundary.isSupported() && X(o1), nd.isSupported() && X(nd);
var bw, Ade = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, fC = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const aU = new ae("LinkedEditingInputVisible", !1);
let Zh = bw = class extends V {
  static get(n) {
    return n.getContribution(bw.ID);
  }
  constructor(n, e, t, i, s) {
    super(), this.languageConfigurationService = i, this._syncRangesToken = 0, this._localToDispose = this._register(new G()), this._editor = n, this._providers = t.linkedEditingRangeProvider, this._enabled = !1, this._visibleContextKey = aU.bindTo(e), this._debounceInformation = s.for(this._providers, "Linked Editing", { max: 200 }), this._currentDecorations = this._editor.createDecorationsCollection(), this._languageWordPattern = null, this._currentWordPattern = null, this._ignoreChangeEvent = !1, this._localToDispose = this._register(new G()), this._rangeUpdateTriggerPromise = null, this._rangeSyncTriggerPromise = null, this._currentRequestCts = null, this._currentRequestPosition = null, this._currentRequestModelVersion = null, this._register(this._editor.onDidChangeModel((() => this.reinitialize(!0)))), this._register(this._editor.onDidChangeConfiguration(((o) => {
      (o.hasChanged(70) || o.hasChanged(93)) && this.reinitialize(!1);
    }))), this._register(this._providers.onDidChange((() => this.reinitialize(!1)))), this._register(this._editor.onDidChangeModelLanguage((() => this.reinitialize(!0)))), this.reinitialize(!0);
  }
  reinitialize(n) {
    const e = this._editor.getModel(), t = e !== null && (this._editor.getOption(70) || this._editor.getOption(93)) && this._providers.has(e);
    if (t === this._enabled && !n || (this._enabled = t, this.clearRanges(), this._localToDispose.clear(), !t || e === null)) return;
    this._localToDispose.add(se.runAndSubscribe(e.onDidChangeLanguageConfiguration, (() => {
      this._languageWordPattern = this.languageConfigurationService.getLanguageConfiguration(e.getLanguageId()).getWordDefinition();
    })));
    const i = new Sr(this._debounceInformation.get(e)), s = () => {
      var a;
      this._rangeUpdateTriggerPromise = i.trigger((() => this.updateRanges()), (a = this._debounceDuration) !== null && a !== void 0 ? a : this._debounceInformation.get(e));
    }, o = new Sr(0), r = (a) => {
      this._rangeSyncTriggerPromise = o.trigger((() => this._syncRanges(a)));
    };
    this._localToDispose.add(this._editor.onDidChangeCursorPosition((() => {
      s();
    }))), this._localToDispose.add(this._editor.onDidChangeModelContent(((a) => {
      if (!this._ignoreChangeEvent && this._currentDecorations.length > 0) {
        const l = this._currentDecorations.getRange(0);
        if (l && a.changes.every(((d) => l.intersectRanges(d.range)))) return void r(this._syncRangesToken);
      }
      s();
    }))), this._localToDispose.add({ dispose: () => {
      i.dispose(), o.dispose();
    } }), this.updateRanges();
  }
  _syncRanges(n) {
    if (!this._editor.hasModel() || n !== this._syncRangesToken || this._currentDecorations.length === 0) return;
    const e = this._editor.getModel(), t = this._currentDecorations.getRange(0);
    if (!t || t.startLineNumber !== t.endLineNumber) return this.clearRanges();
    const i = e.getValueInRange(t);
    if (this._currentWordPattern) {
      const o = i.match(this._currentWordPattern);
      if ((o ? o[0].length : 0) !== i.length) return this.clearRanges();
    }
    const s = [];
    for (let o = 1, r = this._currentDecorations.length; o < r; o++) {
      const a = this._currentDecorations.getRange(o);
      if (a) if (a.startLineNumber !== a.endLineNumber) s.push({ range: a, text: i });
      else {
        let l = e.getValueInRange(a), d = i, h = a.startColumn, c = a.endColumn;
        const u = mc(l, d);
        h += u, l = l.substr(u), d = d.substr(u);
        const g = Fw(l, d);
        c -= g, l = l.substr(0, l.length - g), d = d.substr(0, d.length - g), h === c && d.length === 0 || s.push({ range: new D(a.startLineNumber, h, a.endLineNumber, c), text: d });
      }
    }
    if (s.length !== 0) try {
      this._editor.popUndoStop(), this._ignoreChangeEvent = !0;
      const o = this._editor._getViewModel().getPrevEditOperationType();
      this._editor.executeEdits("linkedEditing", s), this._editor._getViewModel().setPrevEditOperationType(o);
    } finally {
      this._ignoreChangeEvent = !1;
    }
  }
  dispose() {
    this.clearRanges(), super.dispose();
  }
  clearRanges() {
    this._visibleContextKey.set(!1), this._currentDecorations.clear(), this._currentRequestCts && (this._currentRequestCts.cancel(), this._currentRequestCts = null, this._currentRequestPosition = null);
  }
  async updateRanges(n = !1) {
    if (!this._editor.hasModel()) return void this.clearRanges();
    const e = this._editor.getPosition();
    if (!this._enabled && !n || this._editor.getSelections().length > 1) return void this.clearRanges();
    const t = this._editor.getModel(), i = t.getVersionId();
    if (this._currentRequestPosition && this._currentRequestModelVersion === i) {
      if (e.equals(this._currentRequestPosition)) return;
      if (this._currentDecorations.length > 0) {
        const o = this._currentDecorations.getRange(0);
        if (o && o.containsPosition(e)) return;
      }
    }
    this.clearRanges(), this._currentRequestPosition = e, this._currentRequestModelVersion = i;
    const s = this._currentRequestCts = new Ci();
    try {
      const o = new Rn(!1), r = await lU(this._providers, t, e, s.token);
      if (this._debounceInformation.update(t, o.elapsed()), s !== this._currentRequestCts || (this._currentRequestCts = null, i !== t.getVersionId())) return;
      let a = [];
      r?.ranges && (a = r.ranges), this._currentWordPattern = r?.wordPattern || this._languageWordPattern;
      let l = !1;
      for (let h = 0, c = a.length; h < c; h++) if (D.containsPosition(a[h], e)) {
        if (l = !0, h !== 0) {
          const u = a[h];
          a.splice(h, 1), a.unshift(u);
        }
        break;
      }
      if (!l) return void this.clearRanges();
      const d = a.map(((h) => ({ range: h, options: bw.DECORATION })));
      this._visibleContextKey.set(!0), this._currentDecorations.set(d), this._syncRangesToken++;
    } catch (o) {
      ya(o) || We(o), this._currentRequestCts !== s && this._currentRequestCts || this.clearRanges();
    }
  }
};
Zh.ID = "editor.contrib.linkedEditing", Zh.DECORATION = Ve.register({ description: "linked-editing", stickiness: 0, className: "linked-editing-decoration" }), Zh = bw = Ade([fC(1, Te), fC(2, fe), fC(3, zt), fC(4, ar)], Zh);
function lU(n, e, t, i) {
  return hR(n.ordered(e).map(((s) => async () => {
    try {
      return await s.provideLinkedEditingRanges(e, t, i);
    } catch (o) {
      return void Ni(o);
    }
  })), ((s) => !!s && zn(s?.ranges)));
}
re(new (Zi.bindToContribution(Zh.get))({ id: "cancelLinkedEditingInput", precondition: aU, handler: (n) => n.clearRanges(), kbOpts: { kbExpr: E.editorTextFocus, weight: 199, primary: 9, secondary: [1033] } })), I("editor.linkedEditingBackground", { dark: z.fromHex("#f00").transparent(0.3), light: z.fromHex("#f00").transparent(0.3), hcDark: z.fromHex("#f00").transparent(0.3), hcLight: z.white }, m(0, "Background color when the editor auto renames on type.")), ja("_executeLinkedEditingProvider", ((n, e, t) => {
  const { linkedEditingRangeProvider: i } = n.get(fe);
  return lU(i, e, t, et.None);
})), ft(Zh.ID, Zh, 1), X(class extends he {
  constructor() {
    super({ id: "editor.action.linkedEditing", label: m(0, "Start Linked Editing"), alias: "Start Linked Editing", precondition: q.and(E.writable, E.hasRenameProvider), kbOpts: { kbExpr: E.editorTextFocus, primary: 3132, weight: 100 } });
  }
  runCommand(n, e) {
    const t = n.get(mt), [i, s] = Array.isArray(e) && e || [void 0, void 0];
    return Ie.isUri(i) && W.isIPosition(s) ? t.openCodeEditor({ resource: i }, t.getActiveCodeEditor()).then(((o) => {
      o && (o.setPosition(s), o.invokeWithinContext(((r) => (this.reportTelemetry(r, o), this.run(r, o)))));
    }), We) : super.runCommand(n, e);
  }
  run(n, e) {
    const t = Zh.get(e);
    return t ? Promise.resolve(t.updateRanges(!0)) : Promise.resolve();
  }
});
let Pde = class {
  constructor(n, e) {
    this._link = n, this._provider = e;
  }
  toJSON() {
    return { range: this.range, url: this.url, tooltip: this.tooltip };
  }
  get range() {
    return this._link.range;
  }
  get url() {
    return this._link.url;
  }
  get tooltip() {
    return this._link.tooltip;
  }
  async resolve(n) {
    return this._link.url ? this._link.url : typeof this._provider.resolveLink == "function" ? Promise.resolve(this._provider.resolveLink(this._link, n)).then(((e) => (this._link = e || this._link, this._link.url ? this.resolve(n) : Promise.reject(new Error("missing"))))) : Promise.reject(new Error("missing"));
  }
};
class xS {
  constructor(e) {
    this._disposables = new G();
    let t = [];
    for (const [i, s] of e) {
      const o = i.links.map(((r) => new Pde(r, s)));
      t = xS._union(t, o), YT(i) && this._disposables.add(i);
    }
    this.links = t;
  }
  dispose() {
    this._disposables.dispose(), this.links.length = 0;
  }
  static _union(e, t) {
    const i = [];
    let s, o, r, a;
    for (s = 0, r = 0, o = e.length, a = t.length; s < o && r < a; ) {
      const l = e[s], d = t[r];
      if (D.areIntersectingOrTouching(l.range, d.range)) {
        s++;
        continue;
      }
      D.compareRangesUsingStarts(l.range, d.range) < 0 ? (i.push(l), s++) : (i.push(d), r++);
    }
    for (; s < o; s++) i.push(e[s]);
    for (; r < a; r++) i.push(t[r]);
    return i;
  }
}
function dU(n, e, t) {
  const i = [], s = n.ordered(e).reverse().map(((o, r) => Promise.resolve(o.provideLinks(e, t)).then(((a) => {
    a && (i[r] = [a, o]);
  }), Ni)));
  return Promise.all(s).then((() => {
    const o = new xS(ha(i));
    return t.isCancellationRequested ? (o.dispose(), new xS([])) : o;
  }));
}
dt.registerCommand("_executeLinkProvider", (async (n, ...e) => {
  let [t, i] = e;
  vt(t instanceof Ie), typeof i != "number" && (i = 0);
  const { linkProvider: s } = n.get(fe), o = n.get(ni).getModel(t);
  if (!o) return [];
  const r = await dU(s, o, et.None);
  if (!r) return [];
  for (let l = 0; l < Math.min(i, r.links.length); l++) await r.links[l].resolve(et.None);
  const a = r.links.slice(0);
  return r.dispose(), a;
}));
var hT, Ode = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, _C = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Dm = hT = class extends V {
  static get(n) {
    return n.getContribution(hT.ID);
  }
  constructor(n, e, t, i, s) {
    super(), this.editor = n, this.openerService = e, this.notificationService = t, this.languageFeaturesService = i, this.providers = this.languageFeaturesService.linkProvider, this.debounceInformation = s.for(this.providers, "Links", { min: 1e3, max: 4e3 }), this.computeLinks = this._register(new Et((() => this.computeLinksNow()), 1e3)), this.computePromise = null, this.activeLinksList = null, this.currentOccurrences = {}, this.activeLinkDecorationId = null;
    const o = this._register(new XL(n));
    this._register(o.onMouseMoveOrRelevantKeyDown((([r, a]) => {
      this._onEditorMouseMove(r, a);
    }))), this._register(o.onExecute(((r) => {
      this.onEditorMouseUp(r);
    }))), this._register(o.onCancel(((r) => {
      this.cleanUpActiveLinkDecoration();
    }))), this._register(n.onDidChangeConfiguration(((r) => {
      r.hasChanged(71) && (this.updateDecorations([]), this.stop(), this.computeLinks.schedule(0));
    }))), this._register(n.onDidChangeModelContent(((r) => {
      this.editor.hasModel() && this.computeLinks.schedule(this.debounceInformation.get(this.editor.getModel()));
    }))), this._register(n.onDidChangeModel(((r) => {
      this.currentOccurrences = {}, this.activeLinkDecorationId = null, this.stop(), this.computeLinks.schedule(0);
    }))), this._register(n.onDidChangeModelLanguage(((r) => {
      this.stop(), this.computeLinks.schedule(0);
    }))), this._register(this.providers.onDidChange(((r) => {
      this.stop(), this.computeLinks.schedule(0);
    }))), this.computeLinks.schedule(0);
  }
  async computeLinksNow() {
    if (!this.editor.hasModel() || !this.editor.getOption(71)) return;
    const n = this.editor.getModel();
    if (!n.isTooLargeForSyncing() && this.providers.has(n)) {
      this.activeLinksList && (this.activeLinksList.dispose(), this.activeLinksList = null), this.computePromise = on(((e) => dU(this.providers, n, e)));
      try {
        const e = new Rn(!1);
        if (this.activeLinksList = await this.computePromise, this.debounceInformation.update(n, e.elapsed()), n.isDisposed()) return;
        this.updateDecorations(this.activeLinksList.links);
      } catch (e) {
        We(e);
      } finally {
        this.computePromise = null;
      }
    }
  }
  updateDecorations(n) {
    const e = this.editor.getOption(78) === "altKey", t = [], i = Object.keys(this.currentOccurrences);
    for (const o of i) {
      const r = this.currentOccurrences[o];
      t.push(r.decorationId);
    }
    const s = [];
    if (n) for (const o of n) s.push(xm.decoration(o, e));
    this.editor.changeDecorations(((o) => {
      const r = o.deltaDecorations(t, s);
      this.currentOccurrences = {}, this.activeLinkDecorationId = null;
      for (let a = 0, l = r.length; a < l; a++) {
        const d = new xm(n[a], r[a]);
        this.currentOccurrences[d.decorationId] = d;
      }
    }));
  }
  _onEditorMouseMove(n, e) {
    const t = this.editor.getOption(78) === "altKey";
    if (this.isEnabled(n, e)) {
      this.cleanUpActiveLinkDecoration();
      const i = this.getLinkOccurrence(n.target.position);
      i && this.editor.changeDecorations(((s) => {
        i.activate(s, t), this.activeLinkDecorationId = i.decorationId;
      }));
    } else this.cleanUpActiveLinkDecoration();
  }
  cleanUpActiveLinkDecoration() {
    const n = this.editor.getOption(78) === "altKey";
    if (this.activeLinkDecorationId) {
      const e = this.currentOccurrences[this.activeLinkDecorationId];
      e && this.editor.changeDecorations(((t) => {
        e.deactivate(t, n);
      })), this.activeLinkDecorationId = null;
    }
  }
  onEditorMouseUp(n) {
    if (!this.isEnabled(n)) return;
    const e = this.getLinkOccurrence(n.target.position);
    e && this.openLinkOccurrence(e, n.hasSideBySideModifier, !0);
  }
  openLinkOccurrence(n, e, t = !1) {
    if (!this.openerService) return;
    const { link: i } = n;
    i.resolve(et.None).then(((s) => {
      if (typeof s == "string" && this.editor.hasModel()) {
        const o = this.editor.getModel().uri;
        if (o.scheme === Ue.file && s.startsWith(`${Ue.file}:`)) {
          const r = Ie.parse(s);
          if (r.scheme === Ue.file) {
            const a = Ma(r);
            let l = null;
            a.startsWith("/./") || a.startsWith("\\.\\") ? l = `.${a.substr(1)}` : (a.startsWith("//./") || a.startsWith("\\\\.\\")) && (l = `.${a.substr(2)}`), l && (s = yX(o, l));
          }
        }
      }
      return this.openerService.open(s, { openToSide: e, fromUserGesture: t, allowContributedOpeners: !0, allowCommands: !0, fromWorkspace: !0 });
    }), ((s) => {
      const o = s instanceof Error ? s.message : s;
      o === "invalid" ? this.notificationService.warn(m(0, "Failed to open this link because it is not well-formed: {0}", i.url.toString())) : o === "missing" ? this.notificationService.warn(m(0, "Failed to open this link because its target is missing.")) : We(s);
    }));
  }
  getLinkOccurrence(n) {
    if (!this.editor.hasModel() || !n) return null;
    const e = this.editor.getModel().getDecorationsInRange({ startLineNumber: n.lineNumber, startColumn: n.column, endLineNumber: n.lineNumber, endColumn: n.column }, 0, !0);
    for (const t of e) {
      const i = this.currentOccurrences[t.id];
      if (i) return i;
    }
    return null;
  }
  isEnabled(n, e) {
    return !!(n.target.type === 6 && (n.hasTriggerModifier || e && e.keyCodeIsTriggerKey));
  }
  stop() {
    var n;
    this.computeLinks.cancel(), this.activeLinksList && ((n = this.activeLinksList) === null || n === void 0 || n.dispose(), this.activeLinksList = null), this.computePromise && (this.computePromise.cancel(), this.computePromise = null);
  }
  dispose() {
    super.dispose(), this.stop();
  }
};
Dm.ID = "editor.linkDetector", Dm = hT = Ode([_C(1, Fs), _C(2, Ri), _C(3, fe), _C(4, ar)], Dm);
const Fde = Ve.register({ description: "detected-link", stickiness: 1, collapseOnReplaceEdit: !0, inlineClassName: "detected-link" }), Bde = Ve.register({ description: "detected-link-active", stickiness: 1, collapseOnReplaceEdit: !0, inlineClassName: "detected-link-active" });
class xm {
  static decoration(e, t) {
    return { range: e.range, options: xm._getOptions(e, t, !1) };
  }
  static _getOptions(e, t, i) {
    const s = { ...i ? Bde : Fde };
    return s.hoverMessage = (function(o, r) {
      const a = o.url && /^command:/i.test(o.url.toString()), l = o.tooltip ? o.tooltip : m(0, a ? "Execute command" : "Follow link"), d = m(0, r ? Je ? "cmd + click" : "ctrl + click" : Je ? "option + click" : "alt + click");
      if (o.url) {
        let h = "";
        if (/^command:/i.test(o.url.toString())) {
          const c = o.url.toString().match(/^command:([^?#]+)/);
          c && (h = m(0, "Execute command {0}", c[1]));
        }
        return new Vn("", !0).appendLink(o.url.toString(!0).replace(/ /g, "%20"), l, h).appendMarkdown(` (${d})`);
      }
      return new Vn().appendText(`${l} (${d})`);
    })(e, t), s;
  }
  constructor(e, t) {
    this.link = e, this.decorationId = t;
  }
  activate(e, t) {
    e.changeDecorationOptions(this.decorationId, xm._getOptions(this.link, t, !0));
  }
  deactivate(e, t) {
    e.changeDecorationOptions(this.decorationId, xm._getOptions(this.link, t, !1));
  }
}
ft(Dm.ID, Dm, 1), X(class extends he {
  constructor() {
    super({ id: "editor.action.openLink", label: m(0, "Open Link"), alias: "Open Link", precondition: void 0 });
  }
  run(n, e) {
    const t = Dm.get(e);
    if (!t || !e.hasModel()) return;
    const i = e.getSelections();
    for (const s of i) {
      const o = t.getLinkOccurrence(s.getEndPosition());
      o && t.openLinkOccurrence(o, !1);
    }
  }
});
class Jx extends V {
  constructor(e) {
    super(), this._editor = e, this._register(this._editor.onMouseDown(((t) => {
      const i = this._editor.getOption(117);
      i >= 0 && t.target.type === 6 && t.target.position.column >= i && this._editor.updateOptions({ stopRenderingLineAfter: -1 });
    })));
  }
}
Jx.ID = "editor.contrib.longLinesHelper", ft(Jx.ID, Jx, 2);
const vC = I("editor.wordHighlightBackground", { dark: "#575757B8", light: "#57575740", hcDark: null, hcLight: null }, m(0, "Background color of a symbol during read-access, like reading a variable. The color must not be opaque so as not to hide underlying decorations."), !0);
I("editor.wordHighlightStrongBackground", { dark: "#004972B8", light: "#0e639c40", hcDark: null, hcLight: null }, m(0, "Background color of a symbol during write-access, like writing to a variable. The color must not be opaque so as not to hide underlying decorations."), !0), I("editor.wordHighlightTextBackground", { light: vC, dark: vC, hcDark: vC, hcLight: vC }, m(0, "Background color of a textual occurrence for a symbol. The color must not be opaque so as not to hide underlying decorations."), !0);
const bC = I("editor.wordHighlightBorder", { light: null, dark: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color of a symbol during read-access, like reading a variable."));
I("editor.wordHighlightStrongBorder", { light: null, dark: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color of a symbol during write-access, like writing to a variable.")), I("editor.wordHighlightTextBorder", { light: bC, dark: bC, hcDark: bC, hcLight: bC }, m(0, "Border color of a textual occurrence for a symbol."));
const Wde = I("editorOverviewRuler.wordHighlightForeground", { dark: "#A0A0A0CC", light: "#A0A0A0CC", hcDark: "#A0A0A0CC", hcLight: "#A0A0A0CC" }, m(0, "Overview ruler marker color for symbol highlights. The color must not be opaque so as not to hide underlying decorations."), !0), Vde = I("editorOverviewRuler.wordHighlightStrongForeground", { dark: "#C0A0C0CC", light: "#C0A0C0CC", hcDark: "#C0A0C0CC", hcLight: "#C0A0C0CC" }, m(0, "Overview ruler marker color for write-access symbol highlights. The color must not be opaque so as not to hide underlying decorations."), !0), Hde = I("editorOverviewRuler.wordHighlightTextForeground", { dark: v_, light: v_, hcDark: v_, hcLight: v_ }, m(0, "Overview ruler marker color of a textual occurrence for a symbol. The color must not be opaque so as not to hide underlying decorations."), !0), zde = Ve.register({ description: "word-highlight-strong", stickiness: 1, className: "wordHighlightStrong", overviewRuler: { color: ui(Vde), position: Do.Center }, minimap: { color: ui(sL), position: 1 } }), Ude = Ve.register({ description: "word-highlight-text", stickiness: 1, className: "wordHighlightText", overviewRuler: { color: ui(Hde), position: Do.Center }, minimap: { color: ui(sL), position: 1 } }), Kde = Ve.register({ description: "selection-highlight-overview", stickiness: 1, className: "selectionHighlight", overviewRuler: { color: ui(v_), position: Do.Center }, minimap: { color: ui(sL), position: 1 } }), jde = Ve.register({ description: "selection-highlight", stickiness: 1, className: "selectionHighlight" }), qde = Ve.register({ description: "word-highlight", stickiness: 1, className: "wordHighlight", overviewRuler: { color: ui(Wde), position: Do.Center }, minimap: { color: ui(sL), position: 1 } });
function $de(n) {
  return n ? jde : Kde;
}
rr(((n, e) => {
  const t = n.getColor(PR);
  t && e.addRule(`.monaco-editor .selectionHighlight { background-color: ${t.transparent(0.5)}; }`);
}));
var cT, Gde = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Zde = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
function hh(n, e) {
  const t = e.filter(((i) => !n.find(((s) => s.equals(i)))));
  if (t.length >= 1) {
    const i = t.map(((s) => `line ${s.viewState.position.lineNumber} column ${s.viewState.position.column}`)).join(", ");
    vl(t.length === 1 ? m(0, "Cursor added: {0}", i) : m(0, "Cursors added: {0}", i));
  }
}
class CC {
  constructor(e, t, i) {
    this.selections = e, this.revealRange = t, this.revealScrollType = i;
  }
}
class a1 {
  static create(e, t) {
    if (!e.hasModel()) return null;
    const i = t.getState();
    if (!e.hasTextFocus() && i.isRevealed && i.searchString.length > 0) return new a1(e, t, !1, i.searchString, i.wholeWord, i.matchCase, null);
    let s, o, r = !1;
    const a = e.getSelections();
    a.length === 1 && a[0].isEmpty() ? (r = !0, s = !0, o = !0) : (s = i.wholeWord, o = i.matchCase);
    const l = e.getSelection();
    let d, h = null;
    if (l.isEmpty()) {
      const c = e.getConfiguredWordAtPosition(l.getStartPosition());
      if (!c) return null;
      d = c.word, h = new _e(l.startLineNumber, c.startColumn, l.startLineNumber, c.endColumn);
    } else d = e.getModel().getValueInRange(l).replace(/\r\n/g, `
`);
    return new a1(e, t, r, d, s, o, h);
  }
  constructor(e, t, i, s, o, r, a) {
    this._editor = e, this.findController = t, this.isDisconnectedFromFindController = i, this.searchText = s, this.wholeWord = o, this.matchCase = r, this.currentMatch = a;
  }
  addSelectionToNextFindMatch() {
    if (!this._editor.hasModel()) return null;
    const e = this._getNextMatch();
    if (!e) return null;
    const t = this._editor.getSelections();
    return new CC(t.concat(e), e, 0);
  }
  moveSelectionToNextFindMatch() {
    if (!this._editor.hasModel()) return null;
    const e = this._getNextMatch();
    if (!e) return null;
    const t = this._editor.getSelections();
    return new CC(t.slice(0, t.length - 1).concat(e), e, 0);
  }
  _getNextMatch() {
    if (!this._editor.hasModel()) return null;
    if (this.currentMatch) {
      const s = this.currentMatch;
      return this.currentMatch = null, s;
    }
    this.findController.highlightFindOptions();
    const e = this._editor.getSelections(), t = e[e.length - 1], i = this._editor.getModel().findNextMatch(this.searchText, t.getEndPosition(), !1, this.matchCase, this.wholeWord ? this._editor.getOption(131) : null, !1);
    return i ? new _e(i.range.startLineNumber, i.range.startColumn, i.range.endLineNumber, i.range.endColumn) : null;
  }
  addSelectionToPreviousFindMatch() {
    if (!this._editor.hasModel()) return null;
    const e = this._getPreviousMatch();
    if (!e) return null;
    const t = this._editor.getSelections();
    return new CC(t.concat(e), e, 0);
  }
  moveSelectionToPreviousFindMatch() {
    if (!this._editor.hasModel()) return null;
    const e = this._getPreviousMatch();
    if (!e) return null;
    const t = this._editor.getSelections();
    return new CC(t.slice(0, t.length - 1).concat(e), e, 0);
  }
  _getPreviousMatch() {
    if (!this._editor.hasModel()) return null;
    if (this.currentMatch) {
      const s = this.currentMatch;
      return this.currentMatch = null, s;
    }
    this.findController.highlightFindOptions();
    const e = this._editor.getSelections(), t = e[e.length - 1], i = this._editor.getModel().findPreviousMatch(this.searchText, t.getStartPosition(), !1, this.matchCase, this.wholeWord ? this._editor.getOption(131) : null, !1);
    return i ? new _e(i.range.startLineNumber, i.range.startColumn, i.range.endLineNumber, i.range.endColumn) : null;
  }
  selectAll(e) {
    if (!this._editor.hasModel()) return [];
    this.findController.highlightFindOptions();
    const t = this._editor.getModel();
    return e ? t.findMatches(this.searchText, e, !1, this.matchCase, this.wholeWord ? this._editor.getOption(131) : null, !1, 1073741824) : t.findMatches(this.searchText, !0, !1, this.matchCase, this.wholeWord ? this._editor.getOption(131) : null, !1, 1073741824);
  }
}
class Sg extends V {
  static get(e) {
    return e.getContribution(Sg.ID);
  }
  constructor(e) {
    super(), this._sessionDispose = this._register(new G()), this._editor = e, this._ignoreSelectionChange = !1, this._session = null;
  }
  dispose() {
    this._endSession(), super.dispose();
  }
  _beginSessionIfNeeded(e) {
    if (!this._session) {
      const t = a1.create(this._editor, e);
      if (!t) return;
      this._session = t;
      const i = { searchString: this._session.searchText };
      this._session.isDisconnectedFromFindController && (i.wholeWordOverride = 1, i.matchCaseOverride = 1, i.isRegexOverride = 2), e.getState().change(i, !1), this._sessionDispose.add(this._editor.onDidChangeCursorSelection(((s) => {
        this._ignoreSelectionChange || this._endSession();
      }))), this._sessionDispose.add(this._editor.onDidBlurEditorText((() => {
        this._endSession();
      }))), this._sessionDispose.add(e.getState().onFindReplaceStateChange(((s) => {
        (s.matchCase || s.wholeWord) && this._endSession();
      })));
    }
  }
  _endSession() {
    if (this._sessionDispose.clear(), this._session && this._session.isDisconnectedFromFindController) {
      const e = { wholeWordOverride: 0, matchCaseOverride: 0, isRegexOverride: 0 };
      this._session.findController.getState().change(e, !1);
    }
    this._session = null;
  }
  _setSelections(e) {
    this._ignoreSelectionChange = !0, this._editor.setSelections(e), this._ignoreSelectionChange = !1;
  }
  _expandEmptyToWord(e, t) {
    if (!t.isEmpty()) return t;
    const i = this._editor.getConfiguredWordAtPosition(t.getStartPosition());
    return i ? new _e(t.startLineNumber, i.startColumn, t.startLineNumber, i.endColumn) : t;
  }
  _applySessionResult(e) {
    e && (this._setSelections(e.selections), e.revealRange && this._editor.revealRangeInCenterIfOutsideViewport(e.revealRange, e.revealScrollType));
  }
  getSession(e) {
    return this._session;
  }
  addSelectionToNextFindMatch(e) {
    if (this._editor.hasModel()) {
      if (!this._session) {
        const t = this._editor.getSelections();
        if (t.length > 1) {
          const i = e.getState().matchCase;
          if (!hU(this._editor.getModel(), t, i)) {
            const s = this._editor.getModel(), o = [];
            for (let r = 0, a = t.length; r < a; r++) o[r] = this._expandEmptyToWord(s, t[r]);
            return void this._editor.setSelections(o);
          }
        }
      }
      this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.addSelectionToNextFindMatch());
    }
  }
  addSelectionToPreviousFindMatch(e) {
    this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.addSelectionToPreviousFindMatch());
  }
  moveSelectionToNextFindMatch(e) {
    this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.moveSelectionToNextFindMatch());
  }
  moveSelectionToPreviousFindMatch(e) {
    this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.moveSelectionToPreviousFindMatch());
  }
  selectAll(e) {
    if (!this._editor.hasModel()) return;
    let t = null;
    const i = e.getState();
    if (i.isRevealed && i.searchString.length > 0 && i.isRegex) {
      const s = this._editor.getModel();
      t = i.searchScope ? s.findMatches(i.searchString, i.searchScope, i.isRegex, i.matchCase, i.wholeWord ? this._editor.getOption(131) : null, !1, 1073741824) : s.findMatches(i.searchString, !0, i.isRegex, i.matchCase, i.wholeWord ? this._editor.getOption(131) : null, !1, 1073741824);
    } else {
      if (this._beginSessionIfNeeded(e), !this._session) return;
      t = this._session.selectAll(i.searchScope);
    }
    if (t.length > 0) {
      const s = this._editor.getSelection();
      for (let o = 0, r = t.length; o < r; o++) {
        const a = t[o];
        if (a.range.intersectRanges(s)) {
          t[o] = t[0], t[0] = a;
          break;
        }
      }
      this._setSelections(t.map(((o) => new _e(o.range.startLineNumber, o.range.startColumn, o.range.endLineNumber, o.range.endColumn))));
    }
  }
}
Sg.ID = "editor.contrib.multiCursorController";
class dp extends he {
  run(e, t) {
    const i = Sg.get(t);
    if (!i) return;
    const s = t._getViewModel();
    if (s) {
      const o = s.getCursorStates(), r = gs.get(t);
      if (r) this._run(i, r);
      else {
        const a = e.get(Se).createInstance(gs, t);
        this._run(i, a), a.dispose();
      }
      hh(o, s.getCursorStates());
    }
  }
}
class Yde {
  constructor(e, t, i, s, o) {
    this._model = e, this._searchText = t, this._matchCase = i, this._wordSeparators = s, this._modelVersionId = this._model.getVersionId(), this._cachedFindMatches = null, o && this._model === o._model && this._searchText === o._searchText && this._matchCase === o._matchCase && this._wordSeparators === o._wordSeparators && this._modelVersionId === o._modelVersionId && (this._cachedFindMatches = o._cachedFindMatches);
  }
  findMatches() {
    return this._cachedFindMatches === null && (this._cachedFindMatches = this._model.findMatches(this._searchText, !0, !1, this._matchCase, this._wordSeparators, !1).map(((e) => e.range)), this._cachedFindMatches.sort(D.compareRangesUsingStarts)), this._cachedFindMatches;
  }
}
let P0 = cT = class extends V {
  constructor(n, e) {
    super(), this._languageFeaturesService = e, this.editor = n, this._isEnabled = n.getOption(108), this._decorations = n.createDecorationsCollection(), this.updateSoon = this._register(new Et((() => this._update()), 300)), this.state = null, this._register(n.onDidChangeConfiguration(((i) => {
      this._isEnabled = n.getOption(108);
    }))), this._register(n.onDidChangeCursorSelection(((i) => {
      this._isEnabled && (i.selection.isEmpty() ? i.reason === 3 ? (this.state && this._setState(null), this.updateSoon.schedule()) : this._setState(null) : this._update());
    }))), this._register(n.onDidChangeModel(((i) => {
      this._setState(null);
    }))), this._register(n.onDidChangeModelContent(((i) => {
      this._isEnabled && this.updateSoon.schedule();
    })));
    const t = gs.get(n);
    t && this._register(t.getState().onFindReplaceStateChange(((i) => {
      this._update();
    }))), this.updateSoon.schedule();
  }
  _update() {
    this._setState(cT._createState(this.state, this._isEnabled, this.editor));
  }
  static _createState(n, e, t) {
    if (!e || !t.hasModel()) return null;
    const i = t.getSelection();
    if (i.startLineNumber !== i.endLineNumber) return null;
    const s = Sg.get(t);
    if (!s) return null;
    const o = gs.get(t);
    if (!o) return null;
    let r = s.getSession(o);
    if (!r) {
      const d = t.getSelections();
      if (d.length > 1) {
        const h = o.getState().matchCase;
        if (!hU(t.getModel(), d, h)) return null;
      }
      r = a1.create(t, o);
    }
    if (!r || r.currentMatch || /^[ \t]+$/.test(r.searchText) || r.searchText.length > 200) return null;
    const a = o.getState(), l = a.matchCase;
    if (a.isRevealed) {
      let d = a.searchString;
      l || (d = d.toLowerCase());
      let h = r.searchText;
      if (l || (h = h.toLowerCase()), d === h && r.matchCase === a.matchCase && r.wholeWord === a.wholeWord && !a.isRegex) return null;
    }
    return new Yde(t.getModel(), r.searchText, r.matchCase, r.wholeWord ? t.getOption(131) : null, n);
  }
  _setState(n) {
    if (this.state = n, !this.state) return void this._decorations.clear();
    if (!this.editor.hasModel()) return;
    const e = this.editor.getModel();
    if (e.isTooLargeForTokenization()) return;
    const t = this.state.findMatches(), i = this.editor.getSelections();
    i.sort(D.compareRangesUsingStarts);
    const s = [];
    for (let l = 0, d = 0, h = t.length, c = i.length; l < h; ) {
      const u = t[l];
      if (d >= c) s.push(u), l++;
      else {
        const g = D.compareRangesUsingStarts(u, i[d]);
        g < 0 ? (!i[d].isEmpty() && D.areIntersecting(u, i[d]) || s.push(u), l++) : (g > 0 || l++, d++);
      }
    }
    const o = this.editor.getOption(81) !== "off", r = this._languageFeaturesService.documentHighlightProvider.has(e) && o, a = s.map(((l) => ({ range: l, options: $de(r) })));
    this._decorations.set(a);
  }
  dispose() {
    this._setState(null), super.dispose();
  }
};
function hU(n, e, t) {
  const i = P9(n, e[0], !t);
  for (let s = 1, o = e.length; s < o; s++) {
    const r = e[s];
    if (r.isEmpty() || i !== P9(n, r, !t)) return !1;
  }
  return !0;
}
function P9(n, e, t) {
  const i = n.getValueInRange(e);
  return t ? i.toLowerCase() : i;
}
P0.ID = "editor.contrib.selectionHighlighter", P0 = cT = Gde([Zde(1, fe)], P0);
ft(Sg.ID, Sg, 4), ft(P0.ID, P0, 1), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertCursorAbove", label: m(0, "Add Cursor Above"), alias: "Add Cursor Above", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 2576, linux: { primary: 1552, secondary: [3088] }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "&&Add Cursor Above"), order: 2 } });
  }
  run(n, e, t) {
    if (!e.hasModel()) return;
    let i = !0;
    t && t.logicalLine === !1 && (i = !1);
    const s = e._getViewModel();
    if (s.cursorConfig.readOnly) return;
    s.model.pushStackElement();
    const o = s.getCursorStates();
    s.setCursorStates(t.source, 3, mn.addCursorUp(s, o, i)), s.revealTopMostCursor(t.source), hh(o, s.getCursorStates());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertCursorBelow", label: m(0, "Add Cursor Below"), alias: "Add Cursor Below", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 2578, linux: { primary: 1554, secondary: [3090] }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "A&&dd Cursor Below"), order: 3 } });
  }
  run(n, e, t) {
    if (!e.hasModel()) return;
    let i = !0;
    t && t.logicalLine === !1 && (i = !1);
    const s = e._getViewModel();
    if (s.cursorConfig.readOnly) return;
    s.model.pushStackElement();
    const o = s.getCursorStates();
    s.setCursorStates(t.source, 3, mn.addCursorDown(s, o, i)), s.revealBottomMostCursor(t.source), hh(o, s.getCursorStates());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertCursorAtEndOfEachLineSelected", label: m(0, "Add Cursors to Line Ends"), alias: "Add Cursors to Line Ends", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 1575, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "Add C&&ursors to Line Ends"), order: 4 } });
  }
  getCursorsForSelection(n, e, t) {
    if (!n.isEmpty()) {
      for (let i = n.startLineNumber; i < n.endLineNumber; i++) {
        const s = e.getLineMaxColumn(i);
        t.push(new _e(i, s, i, s));
      }
      n.endColumn > 1 && t.push(new _e(n.endLineNumber, n.endColumn, n.endLineNumber, n.endColumn));
    }
  }
  run(n, e) {
    if (!e.hasModel()) return;
    const t = e.getModel(), i = e.getSelections(), s = e._getViewModel(), o = s.getCursorStates(), r = [];
    i.forEach(((a) => this.getCursorsForSelection(a, t, r))), r.length > 0 && e.setSelections(r), hh(o, s.getCursorStates());
  }
}), X(class extends dp {
  constructor() {
    super({ id: "editor.action.addSelectionToNextFindMatch", label: m(0, "Add Selection To Next Find Match"), alias: "Add Selection To Next Find Match", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 2082, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "Add &&Next Occurrence"), order: 5 } });
  }
  _run(n, e) {
    n.addSelectionToNextFindMatch(e);
  }
}), X(class extends dp {
  constructor() {
    super({ id: "editor.action.addSelectionToPreviousFindMatch", label: m(0, "Add Selection To Previous Find Match"), alias: "Add Selection To Previous Find Match", precondition: void 0, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "Add P&&revious Occurrence"), order: 6 } });
  }
  _run(n, e) {
    n.addSelectionToPreviousFindMatch(e);
  }
}), X(class extends dp {
  constructor() {
    super({ id: "editor.action.moveSelectionToNextFindMatch", label: m(0, "Move Last Selection To Next Find Match"), alias: "Move Last Selection To Next Find Match", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: Vi(2089, 2082), weight: 100 } });
  }
  _run(n, e) {
    n.moveSelectionToNextFindMatch(e);
  }
}), X(class extends dp {
  constructor() {
    super({ id: "editor.action.moveSelectionToPreviousFindMatch", label: m(0, "Move Last Selection To Previous Find Match"), alias: "Move Last Selection To Previous Find Match", precondition: void 0 });
  }
  _run(n, e) {
    n.moveSelectionToPreviousFindMatch(e);
  }
}), X(class extends dp {
  constructor() {
    super({ id: "editor.action.selectHighlights", label: m(0, "Select All Occurrences of Find Match"), alias: "Select All Occurrences of Find Match", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 3114, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "Select All &&Occurrences"), order: 7 } });
  }
  _run(n, e) {
    n.selectAll(e);
  }
}), X(class extends dp {
  constructor() {
    super({ id: "editor.action.changeAll", label: m(0, "Change All Occurrences"), alias: "Change All Occurrences", precondition: q.and(E.writable, E.editorTextFocus), kbOpts: { kbExpr: E.editorTextFocus, primary: 2108, weight: 100 }, contextMenuOpts: { group: "1_modification", order: 1.2 } });
  }
  _run(n, e) {
    n.selectAll(e);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.addCursorsToBottom", label: m(0, "Add Cursors To Bottom"), alias: "Add Cursors To Bottom", precondition: void 0 });
  }
  run(n, e) {
    if (!e.hasModel()) return;
    const t = e.getSelections(), i = e.getModel().getLineCount(), s = [];
    for (let a = t[0].startLineNumber; a <= i; a++) s.push(new _e(a, t[0].startColumn, a, t[0].endColumn));
    const o = e._getViewModel(), r = o.getCursorStates();
    s.length > 0 && e.setSelections(s), hh(r, o.getCursorStates());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.addCursorsToTop", label: m(0, "Add Cursors To Top"), alias: "Add Cursors To Top", precondition: void 0 });
  }
  run(n, e) {
    if (!e.hasModel()) return;
    const t = e.getSelections(), i = [];
    for (let r = t[0].startLineNumber; r >= 1; r--) i.push(new _e(r, t[0].startColumn, r, t[0].endColumn));
    const s = e._getViewModel(), o = s.getCursorStates();
    i.length > 0 && e.setSelections(i), hh(o, s.getCursorStates());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.focusNextCursor", label: m(0, "Focus Next Cursor"), metadata: { description: m(0, "Focuses the next cursor"), args: [] }, alias: "Focus Next Cursor", precondition: void 0 });
  }
  run(n, e, t) {
    if (!e.hasModel()) return;
    const i = e._getViewModel();
    if (i.cursorConfig.readOnly) return;
    i.model.pushStackElement();
    const s = Array.from(i.getCursorStates()), o = s.shift();
    o && (s.push(o), i.setCursorStates(t.source, 3, s), i.revealPrimaryCursor(t.source, !0), hh(s, i.getCursorStates()));
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.focusPreviousCursor", label: m(0, "Focus Previous Cursor"), metadata: { description: m(0, "Focuses the previous cursor"), args: [] }, alias: "Focus Previous Cursor", precondition: void 0 });
  }
  run(n, e, t) {
    if (!e.hasModel()) return;
    const i = e._getViewModel();
    if (i.cursorConfig.readOnly) return;
    i.model.pushStackElement();
    const s = Array.from(i.getCursorStates()), o = s.pop();
    o && (s.unshift(o), i.setCursorStates(t.source, 3, s), i.revealPrimaryCursor(t.source, !0), hh(s, i.getCursorStates()));
  }
});
var Xde = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Qde = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const eN = "inline-edit";
let uT = class extends V {
  constructor(n, e, t) {
    super(), this.editor = n, this.model = e, this.languageService = t, this.isDisposed = lt(this, !1), this.currentTextModel = Rt(this.editor.onDidChangeModel, (() => this.editor.getModel())), this.uiState = Fe(this, ((i) => {
      var s;
      if (this.isDisposed.read(i)) return;
      const o = this.currentTextModel.read(i);
      if (o !== this.model.targetTextModel.read(i)) return;
      const r = this.model.ghostText.read(i);
      if (!r) return;
      let a = (s = this.model.range) === null || s === void 0 ? void 0 : s.read(i);
      a && a.startLineNumber === a.endLineNumber && a.startColumn === a.endColumn && (a = void 0);
      const l = (!a || a.startLineNumber === a.endLineNumber) && r.parts.length === 1 && r.parts[0].lines.length === 1, d = r.parts.length === 1 && r.parts[0].lines.every(((b) => b.length === 0)), h = [], c = [];
      function u(b, C) {
        if (c.length > 0) {
          const w = c[c.length - 1];
          C && w.decorations.push(new _s(w.content.length + 1, w.content.length + 1 + b[0].length, C, 0)), w.content += b[0], b = b.slice(1);
        }
        for (const w of b) c.push({ content: w, decorations: C ? [new _s(1, w.length + 1, C, 0)] : [] });
      }
      const g = o.getLineContent(r.lineNumber);
      let p, f = 0;
      if (!d) {
        for (const b of r.parts) {
          let C = b.lines;
          a && !l && (u(C, eN), C = []), p === void 0 ? (h.push({ column: b.column, text: C[0], preview: b.preview }), C = C.slice(1)) : u([g.substring(f, b.column - 1)], void 0), C.length > 0 && (u(C, eN), p === void 0 && b.column <= g.length && (p = b.column)), f = b.column - 1;
        }
        p !== void 0 && u([g.substring(f)], void 0);
      }
      const _ = p !== void 0 ? new Zz(p, g.length + 1) : void 0, v = l || !a ? r.lineNumber : a.endLineNumber - 1;
      return { inlineTexts: h, additionalLines: c, hiddenRange: _, lineNumber: v, additionalReservedLineCount: this.model.minReservedLineCount.read(i), targetTextModel: o, range: a, isSingleLine: l, isPureRemove: d, backgroundColoring: this.model.backgroundColoring.read(i) };
    })), this.decorations = Fe(this, ((i) => {
      const s = this.uiState.read(i);
      if (!s) return [];
      const o = [];
      if (s.hiddenRange && o.push({ range: s.hiddenRange.toRange(s.lineNumber), options: { inlineClassName: "inline-edit-hidden", description: "inline-edit-hidden" } }), s.range) {
        const r = [];
        if (s.isSingleLine) r.push(s.range);
        else if (s.isPureRemove) {
          const l = s.range.endLineNumber - s.range.startLineNumber;
          for (let d = 0; d < l; d++) {
            const h = s.range.startLineNumber + d, c = s.targetTextModel.getLineFirstNonWhitespaceColumn(h), u = s.targetTextModel.getLineLastNonWhitespaceColumn(h), g = new D(h, c, h, u);
            r.push(g);
          }
        } else {
          const l = s.range.endLineNumber - s.range.startLineNumber;
          for (let d = 0; d < l; d++) {
            const h = s.range.startLineNumber + d, c = s.targetTextModel.getLineFirstNonWhitespaceColumn(h), u = s.targetTextModel.getLineLastNonWhitespaceColumn(h), g = new D(h, c, h, u);
            r.push(g);
          }
        }
        const a = s.backgroundColoring ? "inline-edit-remove backgroundColoring" : "inline-edit-remove";
        for (const l of r) o.push({ range: l, options: { inlineClassName: a, description: "inline-edit-remove" } });
      }
      for (const r of s.inlineTexts) o.push({ range: D.fromPositions(new W(s.lineNumber, r.column)), options: { description: eN, after: { content: r.text, inlineClassName: r.preview ? "inline-edit-decoration-preview" : "inline-edit-decoration", cursorStops: vr.Left }, showIfCollapsed: !0 } });
      return o;
    })), this.additionalLinesWidget = this._register(new Xz(this.editor, this.languageService.languageIdCodec, Fe(((i) => {
      const s = this.uiState.read(i);
      return s && !s.isPureRemove ? { lineNumber: s.lineNumber, additionalLines: s.additionalLines, minReservedLineCount: s.additionalReservedLineCount, targetTextModel: s.targetTextModel } : void 0;
    })))), this._register(ye((() => {
      this.isDisposed.set(!0, void 0);
    }))), this._register(Yz(this.editor, this.decorations));
  }
  ownsViewZone(n) {
    return this.additionalLinesWidget.viewZoneId === n;
  }
};
uT = Xde([Qde(2, Xt)], uT);
var Cw, TP = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, sd = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let gT = class extends V {
  constructor(n, e, t) {
    super(), this.editor = n, this.model = e, this.instantiationService = t, this.alwaysShowToolbar = Rt(this.editor.onDidChangeConfiguration, (() => this.editor.getOption(63).showToolbar === "always")), this.sessionPosition = void 0, this.position = Fe(this, ((i) => {
      var s, o, r;
      const a = (s = this.model.read(i)) === null || s === void 0 ? void 0 : s.widget.model.ghostText.read(i);
      if (!this.alwaysShowToolbar.read(i) || !a || a.parts.length === 0) return this.sessionPosition = void 0, null;
      const l = a.parts[0].column;
      this.sessionPosition && this.sessionPosition.lineNumber !== a.lineNumber && (this.sessionPosition = void 0);
      const d = new W(a.lineNumber, Math.min(l, (r = (o = this.sessionPosition) === null || o === void 0 ? void 0 : o.column) !== null && r !== void 0 ? r : Number.MAX_SAFE_INTEGER));
      return this.sessionPosition = d, d;
    })), this._register(nr(((i, s) => {
      if (!this.model.read(i) || !this.alwaysShowToolbar.read(i)) return;
      const o = s.add(this.instantiationService.createInstance($p, this.editor, !0, this.position));
      n.addContentWidget(o), s.add(ye((() => n.removeContentWidget(o))));
    })));
  }
};
gT = TP([sd(2, Se)], gT);
let $p = Cw = class extends V {
  constructor(n, e, t, i, s, o) {
    super(), this.editor = n, this.withBorder = e, this._position = t, this._contextKeyService = s, this._menuService = o, this.id = "InlineEditHintsContentWidget" + Cw.id++, this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this.nodes = yt("div.inlineEditHints", { className: this.withBorder ? ".withBorder" : "" }, [yt("div@toolBar")]), this.inlineCompletionsActionsMenus = this._register(this._menuService.createMenu(x.InlineEditActions, this._contextKeyService)), this.toolBar = this._register(i.createInstance(pT, this.nodes.toolBar, this.editor, x.InlineEditToolbar, { menuOptions: { renderShortTitle: !0 }, toolbarOptions: { primaryGroup: (r) => r.startsWith("primary") }, actionViewItemProvider: (r, a) => {
      if (r instanceof Eo) return i.createInstance(Jde, r, void 0);
    }, telemetrySource: "InlineEditToolbar" })), this._register(this.toolBar.onDidChangeDropdownVisibility(((r) => {
      Cw._dropDownVisible = r;
    }))), this._register(Ge(((r) => {
      this._position.read(r), this.editor.layoutContentWidget(this);
    }))), this._register(Ge(((r) => {
      const a = [];
      for (const [l, d] of this.inlineCompletionsActionsMenus.getActions()) for (const h of d) h instanceof Eo && a.push(h);
      a.length > 0 && a.unshift(new Ui()), this.toolBar.setAdditionalSecondaryActions(a);
    })));
  }
  getId() {
    return this.id;
  }
  getDomNode() {
    return this.nodes.root;
  }
  getPosition() {
    return { position: this._position.get(), preference: [1, 2], positionAffinity: 3 };
  }
};
$p._dropDownVisible = !1, $p.id = 0, $p = Cw = TP([sd(3, Se), sd(4, Te), sd(5, Mo)], $p);
class Jde extends Ec {
  updateLabel() {
    const e = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
    if (!e) return super.updateLabel();
    if (this.label) {
      const t = yt("div.keybinding").root;
      this._register(new Cf(t, Gs, { disableTitle: !0, ...LV })).set(e), this.label.textContent = this._action.label, this.label.appendChild(t), this.label.classList.add("inlineEditStatusBarItemLabel");
    }
  }
  updateTooltip() {
  }
}
let pT = class extends qv {
  constructor(n, e, t, i, s, o, r, a, l) {
    super(n, { resetMenu: t, ...i }, s, o, r, a, l), this.editor = e, this.menuId = t, this.options2 = i, this.menuService = s, this.contextKeyService = o, this.menu = this._store.add(this.menuService.createMenu(this.menuId, this.contextKeyService, { emitEventsForSubmenuChanges: !0 })), this.additionalActions = [], this.prependedPrimaryActions = [], this._store.add(this.menu.onDidChange((() => this.updateToolbar()))), this._store.add(this.editor.onDidChangeCursorPosition((() => this.updateToolbar()))), this.updateToolbar();
  }
  updateToolbar() {
    var n, e, t, i, s, o, r;
    const a = [], l = [];
    EL(this.menu, (n = this.options2) === null || n === void 0 ? void 0 : n.menuOptions, { primary: a, secondary: l }, (t = (e = this.options2) === null || e === void 0 ? void 0 : e.toolbarOptions) === null || t === void 0 ? void 0 : t.primaryGroup, (s = (i = this.options2) === null || i === void 0 ? void 0 : i.toolbarOptions) === null || s === void 0 ? void 0 : s.shouldInlineSubmenu, (r = (o = this.options2) === null || o === void 0 ? void 0 : o.toolbarOptions) === null || r === void 0 ? void 0 : r.useSeparatorsInPrimaryActions), l.push(...this.additionalActions), a.unshift(...this.prependedPrimaryActions), this.setActions(a, l);
  }
  setAdditionalSecondaryActions(n) {
    ri(this.additionalActions, n, ((e, t) => e === t)) || (this.additionalActions = n, this.updateToolbar());
  }
};
pT = TP([sd(4, Mo), sd(5, Te), sd(6, io), sd(7, Dt), sd(8, es)], pT);
var Hu, ehe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, s_ = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class the {
  constructor(e, t) {
    this.widget = e, this.edit = t;
  }
  dispose() {
    this.widget.dispose();
  }
}
let $i = Hu = class extends V {
  static get(n) {
    return n.getContribution(Hu.ID);
  }
  constructor(n, e, t, i, s, o) {
    super(), this.editor = n, this.instantiationService = e, this.contextKeyService = t, this.languageFeaturesService = i, this._commandService = s, this._configurationService = o, this._isVisibleContext = Hu.inlineEditVisibleContext.bindTo(this.contextKeyService), this._isCursorAtInlineEditContext = Hu.cursorAtInlineEditContext.bindTo(this.contextKeyService), this._currentEdit = this._register(Tv(this, void 0)), this._isAccepting = lt(this, !1), this._enabled = Rt(this.editor.onDidChangeConfiguration, (() => this.editor.getOption(63).enabled)), this._fontFamily = Rt(this.editor.onDidChangeConfiguration, (() => this.editor.getOption(63).fontFamily)), this._backgroundColoring = Rt(this.editor.onDidChangeConfiguration, (() => this.editor.getOption(63).backgroundColoring));
    const r = Hn("InlineEditController.modelContentChangedSignal", n.onDidChangeModelContent);
    this._register(Ge(((c) => {
      this._enabled.read(c) && (r.read(c), this._isAccepting.read(c) || this.getInlineEdit(n, !0));
    })));
    const a = Rt(n.onDidChangeCursorPosition, (() => n.getPosition()));
    this._register(Ge(((c) => {
      if (!this._enabled.read(c)) return;
      const u = a.read(c);
      u && this.checkCursorPosition(u);
    }))), this._register(Ge(((c) => {
      const u = this._currentEdit.read(c);
      if (this._isCursorAtInlineEditContext.set(!1), !u) return void this._isVisibleContext.set(!1);
      this._isVisibleContext.set(!0);
      const g = n.getPosition();
      g && this.checkCursorPosition(g);
    })));
    const l = Hn("InlineEditController.editorBlurSignal", n.onDidBlurEditorWidget);
    this._register(Ge((async (c) => {
      var u;
      this._enabled.read(c) && (l.read(c), this._configurationService.getValue("editor.experimentalInlineEdit.keepOnBlur") || n.getOption(63).keepOnBlur || ((u = this._currentRequestCts) === null || u === void 0 || u.dispose(!0), this._currentRequestCts = void 0, await this.clear(!1)));
    })));
    const d = Hn("InlineEditController.editorFocusSignal", n.onDidFocusEditorText);
    this._register(Ge(((c) => {
      this._enabled.read(c) && (d.read(c), this.getInlineEdit(n, !0));
    })));
    const h = this._register(w8());
    this._register(Ge(((c) => {
      const u = this._fontFamily.read(c);
      h.setStyle(u === "" || u === "default" ? "" : `
.monaco-editor .inline-edit-decoration,
.monaco-editor .inline-edit-decoration-preview,
.monaco-editor .inline-edit {
	font-family: ${u};
}`);
    }))), this._register(new gT(this.editor, this._currentEdit, this.instantiationService));
  }
  checkCursorPosition(n) {
    var e;
    if (!this._currentEdit) return void this._isCursorAtInlineEditContext.set(!1);
    const t = (e = this._currentEdit.get()) === null || e === void 0 ? void 0 : e.edit;
    t ? this._isCursorAtInlineEditContext.set(D.containsPosition(t.range, n)) : this._isCursorAtInlineEditContext.set(!1);
  }
  validateInlineEdit(n, e) {
    var t, i;
    if (e.text.includes(`
`) && e.range.startLineNumber !== e.range.endLineNumber && e.range.startColumn !== e.range.endColumn) {
      if (e.range.startColumn !== 1) return !1;
      const s = e.range.endLineNumber;
      if (e.range.endColumn !== ((i = (t = n.getModel()) === null || t === void 0 ? void 0 : t.getLineLength(s)) !== null && i !== void 0 ? i : 0) + 1) return !1;
    }
    return !0;
  }
  async fetchInlineEdit(n, e) {
    this._currentRequestCts && this._currentRequestCts.dispose(!0);
    const t = n.getModel();
    if (!t) return;
    const i = t.getVersionId(), s = this.languageFeaturesService.inlineEditProvider.all(t);
    if (s.length === 0) return;
    const o = s[0];
    this._currentRequestCts = new Ci();
    const r = this._currentRequestCts.token, a = e ? Pw.Automatic : Pw.Invoke;
    var l, d;
    if (e && await (l = 50, d = r, new Promise(((c) => {
      let u;
      const g = setTimeout((() => {
        u && u.dispose(), c();
      }), l);
      d && (u = d.onCancellationRequested((() => {
        clearTimeout(g), u && u.dispose(), c();
      })));
    }))), r.isCancellationRequested || t.isDisposed() || t.getVersionId() !== i) return;
    const h = await o.provideInlineEdit(t, { triggerKind: a }, r);
    return h && !r.isCancellationRequested && !t.isDisposed() && t.getVersionId() === i && this.validateInlineEdit(n, h) ? h : void 0;
  }
  async getInlineEdit(n, e) {
    var t;
    this._isCursorAtInlineEditContext.set(!1), await this.clear();
    const i = await this.fetchInlineEdit(n, e);
    if (!i) return;
    const s = i.range.endLineNumber, o = i.range.endColumn, r = new i1(s, [new wS(o, i.text, !1)]), a = this.instantiationService.createInstance(uT, this.editor, { ghostText: ia(r), minReservedLineCount: ia(0), targetTextModel: ia((t = this.editor.getModel()) !== null && t !== void 0 ? t : void 0), range: ia(i.range), backgroundColoring: this._backgroundColoring });
    this._currentEdit.set(new the(a, i), void 0);
  }
  async trigger() {
    await this.getInlineEdit(this.editor, !1);
  }
  async jumpBack() {
    this._jumpBackPosition && (this.editor.setPosition(this._jumpBackPosition), this.editor.revealPositionInCenterIfOutsideViewport(this._jumpBackPosition));
  }
  async accept() {
    var n;
    this._isAccepting.set(!0, void 0);
    const e = (n = this._currentEdit.get()) === null || n === void 0 ? void 0 : n.edit;
    if (!e) return;
    let t = e.text;
    e.text.startsWith(`
`) && (t = e.text.substring(1)), this.editor.pushUndoStop(), this.editor.executeEdits("acceptCurrent", [ii.replace(D.lift(e.range), t)]), e.accepted && await this._commandService.executeCommand(e.accepted.id, ...e.accepted.arguments || []).then(void 0, Ni), this.freeEdit(e), Tt(((i) => {
      this._currentEdit.set(void 0, i), this._isAccepting.set(!1, i);
    }));
  }
  jumpToCurrent() {
    var n, e;
    this._jumpBackPosition = (n = this.editor.getSelection()) === null || n === void 0 ? void 0 : n.getStartPosition();
    const t = (e = this._currentEdit.get()) === null || e === void 0 ? void 0 : e.edit;
    if (!t) return;
    const i = W.lift({ lineNumber: t.range.startLineNumber, column: t.range.startColumn });
    this.editor.setPosition(i), this.editor.revealPositionInCenterIfOutsideViewport(i);
  }
  async clear(n = !0) {
    var e;
    const t = (e = this._currentEdit.get()) === null || e === void 0 ? void 0 : e.edit;
    t && t?.rejected && n && await this._commandService.executeCommand(t.rejected.id, ...t.rejected.arguments || []).then(void 0, Ni), t && this.freeEdit(t), this._currentEdit.set(void 0, void 0);
  }
  freeEdit(n) {
    const e = this.editor.getModel();
    if (!e) return;
    const t = this.languageFeaturesService.inlineEditProvider.all(e);
    t.length !== 0 && t[0].freeInlineEdit(n);
  }
  shouldShowHoverAt(n) {
    const e = this._currentEdit.get();
    if (!e) return !1;
    const t = e.edit, i = e.widget.model;
    if (D.containsPosition(t.range, n.getStartPosition()) || D.containsPosition(t.range, n.getEndPosition())) return !0;
    const s = i.ghostText.get();
    return !!s && s.parts.some(((o) => n.containsPosition(new W(s.lineNumber, o.column))));
  }
  shouldShowHoverAtViewZone(n) {
    var e, t;
    return (t = (e = this._currentEdit.get()) === null || e === void 0 ? void 0 : e.widget.ownsViewZone(n)) !== null && t !== void 0 && t;
  }
};
$i.ID = "editor.contrib.inlineEditController", $i.inlineEditVisibleKey = "inlineEditVisible", $i.inlineEditVisibleContext = new ae(Hu.inlineEditVisibleKey, !1), $i.cursorAtInlineEditKey = "cursorAtInlineEdit", $i.cursorAtInlineEditContext = new ae(Hu.cursorAtInlineEditKey, !1), $i = Hu = ehe([s_(1, Se), s_(2, Te), s_(3, fe), s_(4, ai), s_(5, Ye)], $i);
var ihe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, O9 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class nhe {
  constructor(e, t, i) {
    this.owner = e, this.range = t, this.controller = i;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
let tN = class {
  constructor(n, e, t) {
    this._editor = n, this._instantiationService = e, this._telemetryService = t, this.hoverOrdinal = 5;
  }
  suggestHoverAnchor(n) {
    const e = $i.get(this._editor);
    if (!e) return null;
    const t = n.target;
    if (t.type === 8) {
      const i = t.detail;
      if (e.shouldShowHoverAtViewZone(i.viewZoneId)) {
        const s = t.range;
        return new Zu(1e3, this, s, n.event.posx, n.event.posy, !1);
      }
    }
    return t.type === 7 && e.shouldShowHoverAt(t.range) ? new Zu(1e3, this, t.range, n.event.posx, n.event.posy, !1) : t.type === 6 && t.detail.mightBeForeignElement && e.shouldShowHoverAt(t.range) ? new Zu(1e3, this, t.range, n.event.posx, n.event.posy, !1) : null;
  }
  computeSync(n, e) {
    if (this._editor.getOption(63).showToolbar !== "onHover") return [];
    const t = $i.get(this._editor);
    return t && t.shouldShowHoverAt(n.range) ? [new nhe(this, n.range, t)] : [];
  }
  renderHoverParts(n, e) {
    const t = new G();
    this._telemetryService.publicLog2("inlineEditHover.shown");
    const i = this._instantiationService.createInstance($p, this._editor, !1, ia(null));
    return n.fragment.appendChild(i.getDomNode()), t.add(i), t;
  }
};
tN = ihe([O9(1, Se), O9(2, es)], tN), X(class extends he {
  constructor() {
    super({ id: "editor.action.inlineEdit.accept", label: "Accept Inline Edit", alias: "Accept Inline Edit", precondition: q.and(E.writable, $i.inlineEditVisibleContext), kbOpts: [{ weight: 101, primary: 2, kbExpr: q.and(E.writable, $i.inlineEditVisibleContext, $i.cursorAtInlineEditContext) }], menuOpts: [{ menuId: x.InlineEditToolbar, title: "Accept", group: "primary", order: 1 }] });
  }
  async run(n, e) {
    const t = $i.get(e);
    await t?.accept();
  }
}), X(class extends he {
  constructor() {
    const n = q.and(E.writable, $i.inlineEditVisibleContext);
    super({ id: "editor.action.inlineEdit.reject", label: "Reject Inline Edit", alias: "Reject Inline Edit", precondition: n, kbOpts: { weight: 100, primary: 9, kbExpr: n }, menuOpts: [{ menuId: x.InlineEditToolbar, title: "Reject", group: "secondary", order: 2 }] });
  }
  async run(n, e) {
    const t = $i.get(e);
    await t?.clear();
  }
}), X(class extends he {
  constructor() {
    const n = q.and(E.writable, $i.inlineEditVisibleContext, q.not($i.cursorAtInlineEditKey));
    super({ id: "editor.action.inlineEdit.jumpTo", label: "Jump to Inline Edit", alias: "Jump to Inline Edit", precondition: n, kbOpts: { weight: 101, primary: 2646, kbExpr: n }, menuOpts: [{ menuId: x.InlineEditToolbar, title: "Jump To Edit", group: "primary", order: 3, when: n }] });
  }
  async run(n, e) {
    const t = $i.get(e);
    t?.jumpToCurrent();
  }
}), X(class extends he {
  constructor() {
    const n = q.and(E.writable, $i.cursorAtInlineEditContext);
    super({ id: "editor.action.inlineEdit.jumpBack", label: "Jump Back from Inline Edit", alias: "Jump Back from Inline Edit", precondition: n, kbOpts: { weight: 110, primary: 2646, kbExpr: n }, menuOpts: [{ menuId: x.InlineEditToolbar, title: "Jump Back", group: "primary", order: 3, when: n }] });
  }
  async run(n, e) {
    const t = $i.get(e);
    t?.jumpBack();
  }
}), X(class extends he {
  constructor() {
    const n = q.and(E.writable, q.not($i.inlineEditVisibleKey));
    super({ id: "editor.action.inlineEdit.trigger", label: "Trigger Inline Edit", alias: "Trigger Inline Edit", precondition: n, kbOpts: { weight: 101, primary: 2646, kbExpr: n } });
  }
  async run(n, e) {
    const t = $i.get(e);
    t?.trigger();
  }
}), ft($i.ID, $i, 3), Tc.register(tN);
const Du = { Visible: new ae("parameterHintsVisible", !1), MultipleSignatures: new ae("parameterHintsMultipleSignatures", !1) };
async function cU(n, e, t, i, s) {
  const o = n.ordered(e);
  for (const r of o) try {
    const a = await r.provideSignatureHelp(e, t, s, i);
    if (a) return a;
  } catch (a) {
    Ni(a);
  }
}
var mh;
dt.registerCommand("_executeSignatureHelpProvider", (async (n, ...e) => {
  const [t, i, s] = e;
  vt(Ie.isUri(t)), vt(W.isIPosition(i)), vt(typeof s == "string" || !s);
  const o = n.get(fe), r = await n.get(Ps).createModelReference(t);
  try {
    const a = await cU(o.signatureHelpProvider, r.object.textEditorModel, W.lift(i), { triggerKind: cl.Invoke, isRetrigger: !1, triggerCharacter: s }, et.None);
    return a ? (setTimeout((() => a.dispose()), 0), a.value) : void 0;
  } finally {
    r.dispose();
  }
})), (function(n) {
  n.Default = { type: 0 }, n.Pending = class {
    constructor(e, t) {
      this.request = e, this.previouslyActiveHints = t, this.type = 2;
    }
  }, n.Active = class {
    constructor(e) {
      this.hints = e, this.type = 1;
    }
  };
})(mh || (mh = {}));
class vk extends V {
  constructor(e, t, i = vk.DEFAULT_DELAY) {
    super(), this._onChangedHints = this._register(new F()), this.onChangedHints = this._onChangedHints.event, this.triggerOnType = !1, this._state = mh.Default, this._pendingTriggers = [], this._lastSignatureHelpResult = this._register(new rn()), this.triggerChars = new Xw(), this.retriggerChars = new Xw(), this.triggerId = 0, this.editor = e, this.providers = t, this.throttledDelayer = new Sr(i), this._register(this.editor.onDidBlurEditorWidget((() => this.cancel()))), this._register(this.editor.onDidChangeConfiguration((() => this.onEditorConfigurationChange()))), this._register(this.editor.onDidChangeModel(((s) => this.onModelChanged()))), this._register(this.editor.onDidChangeModelLanguage(((s) => this.onModelChanged()))), this._register(this.editor.onDidChangeCursorSelection(((s) => this.onCursorChange(s)))), this._register(this.editor.onDidChangeModelContent(((s) => this.onModelContentChange()))), this._register(this.providers.onDidChange(this.onModelChanged, this)), this._register(this.editor.onDidType(((s) => this.onDidType(s)))), this.onEditorConfigurationChange(), this.onModelChanged();
  }
  get state() {
    return this._state;
  }
  set state(e) {
    this._state.type === 2 && this._state.request.cancel(), this._state = e;
  }
  cancel(e = !1) {
    this.state = mh.Default, this.throttledDelayer.cancel(), e || this._onChangedHints.fire(void 0);
  }
  trigger(e, t) {
    const i = this.editor.getModel();
    if (!i || !this.providers.has(i)) return;
    const s = ++this.triggerId;
    this._pendingTriggers.push(e), this.throttledDelayer.trigger((() => this.doTrigger(s)), t).catch(We);
  }
  next() {
    if (this.state.type !== 1) return;
    const e = this.state.hints.signatures.length, t = this.state.hints.activeSignature, i = t % e == e - 1, s = this.editor.getOption(86).cycle;
    !(e < 2 || i) || s ? this.updateActiveSignature(i && s ? 0 : t + 1) : this.cancel();
  }
  previous() {
    if (this.state.type !== 1) return;
    const e = this.state.hints.signatures.length, t = this.state.hints.activeSignature, i = t === 0, s = this.editor.getOption(86).cycle;
    !(e < 2 || i) || s ? this.updateActiveSignature(i && s ? e - 1 : t - 1) : this.cancel();
  }
  updateActiveSignature(e) {
    this.state.type === 1 && (this.state = new mh.Active({ ...this.state.hints, activeSignature: e }), this._onChangedHints.fire(this.state.hints));
  }
  async doTrigger(e) {
    const t = this.state.type === 1 || this.state.type === 2, i = this.getLastActiveHints();
    if (this.cancel(!0), this._pendingTriggers.length === 0) return !1;
    const s = this._pendingTriggers.reduce(she);
    this._pendingTriggers = [];
    const o = { triggerKind: s.triggerKind, triggerCharacter: s.triggerCharacter, isRetrigger: t, activeSignatureHelp: i };
    if (!this.editor.hasModel()) return !1;
    const r = this.editor.getModel(), a = this.editor.getPosition();
    this.state = new mh.Pending(on(((l) => cU(this.providers, r, a, o, l))), i);
    try {
      const l = await this.state.request;
      return e !== this.triggerId ? (l?.dispose(), !1) : l && l.value.signatures && l.value.signatures.length !== 0 ? (this.state = new mh.Active(l.value), this._lastSignatureHelpResult.value = l, this._onChangedHints.fire(this.state.hints), !0) : (l?.dispose(), this._lastSignatureHelpResult.clear(), this.cancel(), !1);
    } catch (l) {
      return e === this.triggerId && (this.state = mh.Default), We(l), !1;
    }
  }
  getLastActiveHints() {
    switch (this.state.type) {
      case 1:
        return this.state.hints;
      case 2:
        return this.state.previouslyActiveHints;
      default:
        return;
    }
  }
  get isTriggered() {
    return this.state.type === 1 || this.state.type === 2 || this.throttledDelayer.isTriggered();
  }
  onModelChanged() {
    this.cancel(), this.triggerChars.clear(), this.retriggerChars.clear();
    const e = this.editor.getModel();
    if (e) for (const t of this.providers.ordered(e)) {
      for (const i of t.signatureHelpTriggerCharacters || []) if (i.length) {
        const s = i.charCodeAt(0);
        this.triggerChars.add(s), this.retriggerChars.add(s);
      }
      for (const i of t.signatureHelpRetriggerCharacters || []) i.length && this.retriggerChars.add(i.charCodeAt(0));
    }
  }
  onDidType(e) {
    if (!this.triggerOnType) return;
    const t = e.length - 1, i = e.charCodeAt(t);
    (this.triggerChars.has(i) || this.isTriggered && this.retriggerChars.has(i)) && this.trigger({ triggerKind: cl.TriggerCharacter, triggerCharacter: e.charAt(t) });
  }
  onCursorChange(e) {
    e.source === "mouse" ? this.cancel() : this.isTriggered && this.trigger({ triggerKind: cl.ContentChange });
  }
  onModelContentChange() {
    this.isTriggered && this.trigger({ triggerKind: cl.ContentChange });
  }
  onEditorConfigurationChange() {
    this.triggerOnType = this.editor.getOption(86).enabled, this.triggerOnType || this.cancel();
  }
  dispose() {
    this.cancel(!0), super.dispose();
  }
}
function she(n, e) {
  switch (e.triggerKind) {
    case cl.Invoke:
      return e;
    case cl.ContentChange:
      return n;
    case cl.TriggerCharacter:
    default:
      return e;
  }
}
vk.DEFAULT_DELAY = 120;
var mT, ohe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, iN = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const so = Q, rhe = Ei("parameter-hints-next", ne.chevronDown, m(0, "Icon for show next parameter hint.")), ahe = Ei("parameter-hints-previous", ne.chevronUp, m(0, "Icon for show previous parameter hint."));
let ww = mT = class extends V {
  constructor(n, e, t, i, s) {
    super(), this.editor = n, this.model = e, this.renderDisposeables = this._register(new G()), this.visible = !1, this.announcedLabel = null, this.allowEditorOverflow = !0, this.markdownRenderer = this._register(new pl({ editor: n }, s, i)), this.keyVisible = Du.Visible.bindTo(t), this.keyMultipleSignatures = Du.MultipleSignatures.bindTo(t);
  }
  createParameterHintDOMNodes() {
    const n = so(".editor-widget.parameter-hints-widget"), e = Z(n, so(".phwrapper"));
    e.tabIndex = -1;
    const t = Z(e, so(".controls")), i = Z(t, so(".button" + Ee.asCSSSelector(ahe))), s = Z(t, so(".overloads")), o = Z(t, so(".button" + Ee.asCSSSelector(rhe)));
    this._register(K(i, "click", ((c) => {
      Ze(c), this.previous();
    }))), this._register(K(o, "click", ((c) => {
      Ze(c), this.next();
    })));
    const r = so(".body"), a = new S1(r, { alwaysConsumeMouseWheel: !0 });
    this._register(a), e.appendChild(a.getDomNode());
    const l = Z(r, so(".signature")), d = Z(r, so(".docs"));
    n.style.userSelect = "text", this.domNodes = { element: n, signature: l, overloads: s, docs: d, scrollbar: a }, this.editor.addContentWidget(this), this.hide(), this._register(this.editor.onDidChangeCursorSelection(((c) => {
      this.visible && this.editor.layoutContentWidget(this);
    })));
    const h = () => {
      if (!this.domNodes) return;
      const c = this.editor.getOption(50);
      this.domNodes.element.style.fontSize = `${c.fontSize}px`, this.domNodes.element.style.lineHeight = "" + c.lineHeight / c.fontSize;
    };
    h(), this._register(se.chain(this.editor.onDidChangeConfiguration.bind(this.editor), ((c) => c.filter(((u) => u.hasChanged(50)))))(h)), this._register(this.editor.onDidLayoutChange(((c) => this.updateMaxHeight()))), this.updateMaxHeight();
  }
  show() {
    this.visible || (this.domNodes || this.createParameterHintDOMNodes(), this.keyVisible.set(!0), this.visible = !0, setTimeout((() => {
      var n;
      (n = this.domNodes) === null || n === void 0 || n.element.classList.add("visible");
    }), 100), this.editor.layoutContentWidget(this));
  }
  hide() {
    var n;
    this.renderDisposeables.clear(), this.visible && (this.keyVisible.reset(), this.visible = !1, this.announcedLabel = null, (n = this.domNodes) === null || n === void 0 || n.element.classList.remove("visible"), this.editor.layoutContentWidget(this));
  }
  getPosition() {
    return this.visible ? { position: this.editor.getPosition(), preference: [1, 2] } : null;
  }
  render(n) {
    var e;
    if (this.renderDisposeables.clear(), !this.domNodes) return;
    const t = n.signatures.length > 1;
    this.domNodes.element.classList.toggle("multiple", t), this.keyMultipleSignatures.set(t), this.domNodes.signature.innerText = "", this.domNodes.docs.innerText = "";
    const i = n.signatures[n.activeSignature];
    if (!i) return;
    const s = Z(this.domNodes.signature, so(".code")), o = this.editor.getOption(50);
    s.style.fontSize = `${o.fontSize}px`, s.style.fontFamily = o.fontFamily;
    const r = i.parameters.length > 0, a = (e = i.activeParameter) !== null && e !== void 0 ? e : n.activeParameter;
    r ? this.renderParameters(s, i, a) : Z(s, so("span")).textContent = i.label;
    const l = i.parameters[a];
    if (l?.documentation) {
      const h = so("span.documentation");
      if (typeof l.documentation == "string") h.textContent = l.documentation;
      else {
        const c = this.renderMarkdownDocs(l.documentation);
        h.appendChild(c.element);
      }
      Z(this.domNodes.docs, so("p", {}, h));
    }
    if (i.documentation !== void 0) if (typeof i.documentation == "string") Z(this.domNodes.docs, so("p", {}, i.documentation));
    else {
      const h = this.renderMarkdownDocs(i.documentation);
      Z(this.domNodes.docs, h.element);
    }
    const d = this.hasDocs(i, l);
    if (this.domNodes.signature.classList.toggle("has-docs", d), this.domNodes.docs.classList.toggle("empty", !d), this.domNodes.overloads.textContent = String(n.activeSignature + 1).padStart(n.signatures.length.toString().length, "0") + "/" + n.signatures.length, l) {
      let h = "";
      const c = i.parameters[a];
      h = Array.isArray(c.label) ? i.label.substring(c.label[0], c.label[1]) : c.label, c.documentation && (h += typeof c.documentation == "string" ? `, ${c.documentation}` : `, ${c.documentation.value}`), i.documentation && (h += typeof i.documentation == "string" ? `, ${i.documentation}` : `, ${i.documentation.value}`), this.announcedLabel !== h && (Io(m(0, "{0}, hint", h)), this.announcedLabel = h);
    }
    this.editor.layoutContentWidget(this), this.domNodes.scrollbar.scanDomNode();
  }
  renderMarkdownDocs(n) {
    const e = this.renderDisposeables.add(this.markdownRenderer.render(n, { asyncRenderCallback: () => {
      var t;
      (t = this.domNodes) === null || t === void 0 || t.scrollbar.scanDomNode();
    } }));
    return e.element.classList.add("markdown-docs"), e;
  }
  hasDocs(n, e) {
    return !!(e && typeof e.documentation == "string" && Dh(e.documentation).length > 0) || !!(e && typeof e.documentation == "object" && Dh(e.documentation).value.length > 0) || !!(n.documentation && typeof n.documentation == "string" && Dh(n.documentation).length > 0) || !!(n.documentation && typeof n.documentation == "object" && Dh(n.documentation.value).length > 0);
  }
  renderParameters(n, e, t) {
    const [i, s] = this.getParameterLabelOffsets(e, t), o = document.createElement("span");
    o.textContent = e.label.substring(0, i);
    const r = document.createElement("span");
    r.textContent = e.label.substring(i, s), r.className = "parameter active";
    const a = document.createElement("span");
    a.textContent = e.label.substring(s), Z(n, o, r, a);
  }
  getParameterLabelOffsets(n, e) {
    const t = n.parameters[e];
    if (t) {
      if (Array.isArray(t.label)) return t.label;
      if (t.label.length) {
        const i = new RegExp(`(\\W|^)${No(t.label)}(?=\\W|$)`, "g");
        i.test(n.label);
        const s = i.lastIndex - t.label.length;
        return s >= 0 ? [s, i.lastIndex] : [0, 0];
      }
      return [0, 0];
    }
    return [0, 0];
  }
  next() {
    this.editor.focus(), this.model.next();
  }
  previous() {
    this.editor.focus(), this.model.previous();
  }
  getDomNode() {
    return this.domNodes || this.createParameterHintDOMNodes(), this.domNodes.element;
  }
  getId() {
    return mT.ID;
  }
  updateMaxHeight() {
    if (!this.domNodes) return;
    const n = `${Math.max(this.editor.getLayoutInfo().height / 4, 250)}px`;
    this.domNodes.element.style.maxHeight = n;
    const e = this.domNodes.element.getElementsByClassName("phwrapper");
    e.length && (e[0].style.maxHeight = n);
  }
};
ww.ID = "editor.widget.parameterHintsWidget", ww = mT = ohe([iN(2, Te), iN(3, Fs), iN(4, Xt)], ww), I("editorHoverWidget.highlightForeground", { dark: Cr, light: Cr, hcDark: Cr, hcLight: Cr }, m(0, "Foreground color of the active item in the parameter hint."));
var fT, lhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, F9 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let ig = fT = class extends V {
  static get(n) {
    return n.getContribution(fT.ID);
  }
  constructor(n, e, t) {
    super(), this.editor = n, this.model = this._register(new vk(n, t.signatureHelpProvider)), this._register(this.model.onChangedHints(((i) => {
      var s;
      i ? (this.widget.value.show(), this.widget.value.render(i)) : (s = this.widget.rawValue) === null || s === void 0 || s.hide();
    }))), this.widget = new ua((() => this._register(e.createInstance(ww, this.editor, this.model))));
  }
  cancel() {
    this.model.cancel();
  }
  previous() {
    var n;
    (n = this.widget.rawValue) === null || n === void 0 || n.previous();
  }
  next() {
    var n;
    (n = this.widget.rawValue) === null || n === void 0 || n.next();
  }
  trigger(n) {
    this.model.trigger(n, 0);
  }
};
ig.ID = "editor.controller.parameterHints", ig = fT = lhe([F9(1, Se), F9(2, fe)], ig);
ft(ig.ID, ig, 2), X(class extends he {
  constructor() {
    super({ id: "editor.action.triggerParameterHints", label: m(0, "Trigger Parameter Hints"), alias: "Trigger Parameter Hints", precondition: E.hasSignatureHelpProvider, kbOpts: { kbExpr: E.editorTextFocus, primary: 3082, weight: 100 } });
  }
  run(n, e) {
    const t = ig.get(e);
    t?.trigger({ triggerKind: cl.Invoke });
  }
});
const nN = Zi.bindToContribution(ig.get);
re(new nN({ id: "closeParameterHints", precondition: Du.Visible, handler: (n) => n.cancel(), kbOpts: { weight: 175, kbExpr: E.focus, primary: 9, secondary: [1033] } })), re(new nN({ id: "showPrevParameterHint", precondition: q.and(Du.Visible, Du.MultipleSignatures), handler: (n) => n.previous(), kbOpts: { weight: 175, kbExpr: E.focus, primary: 16, secondary: [528], mac: { primary: 16, secondary: [528, 302] } } })), re(new nN({ id: "showNextParameterHint", precondition: q.and(Du.Visible, Du.MultipleSignatures), handler: (n) => n.next(), kbOpts: { weight: 175, kbExpr: E.focus, primary: 18, secondary: [530], mac: { primary: 18, secondary: [530, 300] } } }));
var dhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, wC = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const Cp = new ae("renameInputVisible", !1, m(0, "Whether the rename input widget is visible"));
new ae("renameInputFocused", !1, m(0, "Whether the rename input widget is focused"));
let _T = class {
  constructor(n, e, t, i, s, o) {
    this._editor = n, this._acceptKeybindings = e, this._themeService = t, this._keybindingService = i, this._logService = o, this.allowEditorOverflow = !0, this._disposables = new G(), this._visibleContextKey = Cp.bindTo(s), this._isEditingRenameCandidate = !1, this._beforeFirstInputFieldEditSW = new Rn(), this._input = new hhe(), this._disposables.add(this._input), this._editor.addContentWidget(this), this._disposables.add(this._editor.onDidChangeConfiguration(((r) => {
      r.hasChanged(50) && this._updateFont();
    }))), this._disposables.add(t.onDidColorThemeChange(this._updateStyles, this));
  }
  dispose() {
    this._disposables.dispose(), this._editor.removeContentWidget(this);
  }
  getId() {
    return "__renameInputWidget";
  }
  getDomNode() {
    return this._domNode || (this._domNode = document.createElement("div"), this._domNode.className = "monaco-editor rename-box", this._domNode.appendChild(this._input.domNode), this._renameCandidateListView = this._disposables.add(new RP(this._domNode, { fontInfo: this._editor.getOption(50), onFocusChange: (n) => {
      this._input.domNode.value = n, this._isEditingRenameCandidate = !1;
    }, onSelectionChange: () => {
      this._isEditingRenameCandidate = !1, this.acceptInput(!1);
    } })), this._disposables.add(this._input.onDidChange((() => {
      var n, e, t, i;
      ((n = this._renameCandidateListView) === null || n === void 0 ? void 0 : n.focusedCandidate) !== void 0 && (this._isEditingRenameCandidate = !0), (e = this._timeBeforeFirstInputFieldEdit) !== null && e !== void 0 || (this._timeBeforeFirstInputFieldEdit = this._beforeFirstInputFieldEditSW.elapsed()), ((t = this._renameCandidateProvidersCts) === null || t === void 0 ? void 0 : t.token.isCancellationRequested) === !1 && this._renameCandidateProvidersCts.cancel(), (i = this._renameCandidateListView) === null || i === void 0 || i.clearFocus();
    }))), this._label = document.createElement("div"), this._label.className = "rename-label", this._domNode.appendChild(this._label), this._updateFont(), this._updateStyles(this._themeService.getColorTheme())), this._domNode;
  }
  _updateStyles(n) {
    var e, t, i, s;
    if (!this._domNode) return;
    const o = n.getColor(gd), r = n.getColor(cB);
    this._domNode.style.backgroundColor = String((e = n.getColor(xi)) !== null && e !== void 0 ? e : ""), this._domNode.style.boxShadow = o ? ` 0 0 8px 2px ${o}` : "", this._domNode.style.border = r ? `1px solid ${r}` : "", this._domNode.style.color = String((t = n.getColor(gB)) !== null && t !== void 0 ? t : ""), this._input.domNode.style.backgroundColor = String((i = n.getColor(uB)) !== null && i !== void 0 ? i : "");
    const a = n.getColor(pB);
    this._input.domNode.style.borderWidth = a ? "1px" : "0px", this._input.domNode.style.borderStyle = a ? "solid" : "none", this._input.domNode.style.borderColor = (s = a?.toString()) !== null && s !== void 0 ? s : "none";
  }
  _updateFont() {
    if (this._domNode === void 0) return;
    vt(this._label !== void 0, "RenameWidget#_updateFont: _label must not be undefined given _domNode is defined"), this._editor.applyFontInfo(this._input.domNode);
    const n = this._editor.getOption(50);
    this._label.style.fontSize = `${this._computeLabelFontSize(n.fontSize)}px`;
  }
  _computeLabelFontSize(n) {
    return 0.8 * n;
  }
  getPosition() {
    if (!this._visible || !this._editor.hasModel() || !this._editor.getDomNode()) return null;
    const n = Cc(this.getDomNode().ownerDocument.body), e = Ti(this._editor.getDomNode()), t = this._getTopForPosition();
    this._nPxAvailableAbove = t + e.top, this._nPxAvailableBelow = n.height - this._nPxAvailableAbove;
    const i = this._editor.getOption(67), { totalHeight: s } = Lg.getLayoutInfo({ lineHeight: i }), o = this._nPxAvailableBelow > 6 * s ? [2, 1] : [1, 2];
    return { position: this._position, preference: o };
  }
  beforeRender() {
    var n, e;
    const [t, i] = this._acceptKeybindings;
    return this._label.innerText = m(0, "{0} to Rename, {1} to Preview", (n = this._keybindingService.lookupKeybinding(t)) === null || n === void 0 ? void 0 : n.getLabel(), (e = this._keybindingService.lookupKeybinding(i)) === null || e === void 0 ? void 0 : e.getLabel()), this._domNode.style.minWidth = "200px", null;
  }
  afterRender(n) {
    if (this._trace("invoking afterRender, position: ", n ? "not null" : "null"), n === null) return void this.cancelInput(!0, "afterRender (because position is null)");
    if (!this._editor.hasModel() || !this._editor.getDomNode()) return;
    vt(this._renameCandidateListView), vt(this._nPxAvailableAbove !== void 0), vt(this._nPxAvailableBelow !== void 0);
    const e = rd(this._input.domNode), t = rd(this._label);
    let i;
    i = n === 2 ? this._nPxAvailableBelow : this._nPxAvailableAbove, this._renameCandidateListView.layout({ height: i - t - e, width: os(this._input.domNode) });
  }
  acceptInput(n) {
    var e;
    this._trace("invoking acceptInput"), (e = this._currentAcceptInput) === null || e === void 0 || e.call(this, n);
  }
  cancelInput(n, e) {
    var t;
    this._trace(`invoking cancelInput, caller: ${e}, _currentCancelInput: ${this._currentAcceptInput ? "not undefined" : "undefined"}`), (t = this._currentCancelInput) === null || t === void 0 || t.call(this, n);
  }
  focusNextRenameSuggestion() {
    var n;
    !((n = this._renameCandidateListView) === null || n === void 0) && n.focusNext() || (this._input.domNode.value = this._currentName);
  }
  focusPreviousRenameSuggestion() {
    var n;
    !((n = this._renameCandidateListView) === null || n === void 0) && n.focusPrevious() || (this._input.domNode.value = this._currentName);
  }
  getInput(n, e, t, i, s) {
    const { start: o, end: r } = this._getSelection(n, e);
    this._renameCandidateProvidersCts = new Ci();
    const a = i(this._renameCandidateProvidersCts.token);
    this._updateRenameCandidates(a, e, s.token), this._isEditingRenameCandidate = !1, this._domNode.classList.toggle("preview", t), this._position = new W(n.startLineNumber, n.startColumn), this._currentName = e, this._input.domNode.value = e, this._input.domNode.setAttribute("selectionStart", o.toString()), this._input.domNode.setAttribute("selectionEnd", r.toString()), this._input.domNode.size = Math.max(1.1 * (n.endColumn - n.startColumn), 20), this._beforeFirstInputFieldEditSW.reset();
    const l = new G();
    l.add(ye((() => s.dispose(!0)))), l.add(ye((() => {
      this._renameCandidateProvidersCts !== void 0 && (this._renameCandidateProvidersCts.dispose(!0), this._renameCandidateProvidersCts = void 0);
    })));
    const d = new _1();
    return d.p.finally((() => {
      l.dispose(), this._hide();
    })), this._currentCancelInput = (h) => {
      var c;
      return this._trace("invoking _currentCancelInput"), this._currentAcceptInput = void 0, this._currentCancelInput = void 0, (c = this._renameCandidateListView) === null || c === void 0 || c.clearCandidates(), d.complete(h), !0;
    }, this._currentAcceptInput = (h) => {
      this._trace("invoking _currentAcceptInput"), vt(this._renameCandidateListView !== void 0);
      const c = this._renameCandidateListView.nCandidates;
      let u, g;
      const p = this._renameCandidateListView.focusedCandidate;
      p !== void 0 ? (this._trace("using new name from renameSuggestion"), u = p, g = { k: "renameSuggestion" }) : (this._trace("using new name from inputField"), u = this._input.domNode.value, g = this._isEditingRenameCandidate ? { k: "userEditedRenameSuggestion" } : { k: "inputField" }), u !== e && u.trim().length !== 0 ? (this._currentAcceptInput = void 0, this._currentCancelInput = void 0, this._renameCandidateListView.clearCandidates(), d.complete({ newName: u, wantsPreview: t && h, stats: { source: g, nRenameSuggestions: c, timeBeforeFirstInputFieldEdit: this._timeBeforeFirstInputFieldEdit } })) : this.cancelInput(!0, "_currentAcceptInput (because newName === value || newName.trim().length === 0)");
    }, l.add(s.token.onCancellationRequested((() => this.cancelInput(!0, "cts.token.onCancellationRequested")))), l.add(this._editor.onDidBlurEditorWidget((() => {
      var h;
      return this.cancelInput(!(!((h = this._domNode) === null || h === void 0) && h.ownerDocument.hasFocus()), "editor.onDidBlurEditorWidget");
    }))), this._show(), d.p;
  }
  _getSelection(n, e) {
    vt(this._editor.hasModel());
    const t = this._editor.getSelection();
    let i = 0, s = e.length;
    return D.isEmpty(t) || D.spansMultipleLines(t) || !D.containsRange(n, t) || (i = Math.max(0, t.startColumn - n.startColumn), s = Math.min(n.endColumn, t.endColumn) - n.startColumn), { start: i, end: s };
  }
  _show() {
    this._trace("invoking _show"), this._editor.revealLineInCenterIfOutsideViewport(this._position.lineNumber, 0), this._visible = !0, this._visibleContextKey.set(!0), this._editor.layoutContentWidget(this), setTimeout((() => {
      this._input.domNode.focus(), this._input.domNode.setSelectionRange(parseInt(this._input.domNode.getAttribute("selectionStart")), parseInt(this._input.domNode.getAttribute("selectionEnd")));
    }), 100);
  }
  async _updateRenameCandidates(n, e, t) {
    const i = (...l) => this._trace("_updateRenameCandidates", ...l);
    i("start");
    const s = await f1(Promise.allSettled(n), t);
    if (s === void 0) return void i("returning early - received updateRenameCandidates results - undefined");
    const o = s.flatMap(((l) => l.status === "fulfilled" && hl(l.value) ? l.value : []));
    i(`received updateRenameCandidates results - total (unfiltered) ${o.length} candidates.`);
    const r = Ad(o, ((l) => l.newSymbolName));
    i(`distinct candidates - ${r.length} candidates.`);
    const a = r.filter((({ newSymbolName: l }) => l.trim().length > 0 && l !== this._input.domNode.value && l !== e));
    i(`valid distinct candidates - ${o.length} candidates.`), a.length < 1 ? i("returning early - no valid distinct candidates") : (i("setting candidates"), this._renameCandidateListView.setCandidates(a), i("asking editor to re-layout"), this._editor.layoutContentWidget(this));
  }
  _hide() {
    this._trace("invoked _hide"), this._visible = !1, this._visibleContextKey.reset(), this._editor.layoutContentWidget(this);
  }
  _getTopForPosition() {
    const n = this._editor.getVisibleRanges();
    let e;
    return n.length > 0 ? e = n[0].startLineNumber : (this._logService.warn("RenameWidget#_getTopForPosition: this should not happen - visibleRanges is empty"), e = Math.max(1, this._position.lineNumber - 5)), this._editor.getTopForLineNumber(this._position.lineNumber) - this._editor.getTopForLineNumber(e);
  }
  _trace(...n) {
    this._logService.trace("RenameWidget", ...n);
  }
};
_T = dhe([wC(2, Yi), wC(3, Dt), wC(4, Te), wC(5, ts)], _T);
class RP {
  constructor(e, t) {
    this._disposables = new G(), this._availableHeight = 0, this._minimumWidth = 0, this._lineHeight = t.fontInfo.lineHeight, this._typicalHalfwidthCharacterWidth = t.fontInfo.typicalHalfwidthCharacterWidth, this._listContainer = document.createElement("div"), e.appendChild(this._listContainer), this._listWidget = RP._createListWidget(this._listContainer, this._candidateViewHeight, t.fontInfo), this._listWidget.onDidChangeFocus(((i) => {
      i.elements.length === 1 && t.onFocusChange(i.elements[0].newSymbolName);
    }), this._disposables), this._listWidget.onDidChangeSelection(((i) => {
      i.elements.length === 1 && t.onSelectionChange();
    }), this._disposables), this._disposables.add(this._listWidget.onDidBlur(((i) => {
      this._listWidget.setFocus([]);
    }))), this._listWidget.style(Mg({ listInactiveFocusForeground: Rh, listInactiveFocusBackground: Ah }));
  }
  dispose() {
    this._listWidget.dispose(), this._disposables.dispose();
  }
  layout({ height: e, width: t }) {
    this._availableHeight = e, this._minimumWidth = t;
  }
  setCandidates(e) {
    this._listWidget.splice(0, 0, e);
    const t = this._pickListHeight(e.length), i = this._pickListWidth(e);
    this._listWidget.layout(t, i), this._listContainer.style.height = `${t}px`, this._listContainer.style.width = `${i}px`, vl(m(0, "Received {0} rename suggestions", e.length));
  }
  clearCandidates() {
    this._listContainer.style.height = "0px", this._listContainer.style.width = "0px", this._listWidget.splice(0, this._listWidget.length, []);
  }
  get nCandidates() {
    return this._listWidget.length;
  }
  get focusedCandidate() {
    if (this._listWidget.length === 0) return;
    const e = this._listWidget.getSelectedElements()[0];
    if (e !== void 0) return e.newSymbolName;
    const t = this._listWidget.getFocusedElements()[0];
    return t !== void 0 ? t.newSymbolName : void 0;
  }
  focusNext() {
    if (this._listWidget.length === 0) return !1;
    const e = this._listWidget.getFocus();
    return e.length === 0 ? (this._listWidget.focusFirst(), !0) : e[0] === this._listWidget.length - 1 ? (this._listWidget.setFocus([]), !1) : (this._listWidget.focusNext(), !0);
  }
  focusPrevious() {
    if (this._listWidget.length === 0) return !1;
    const e = this._listWidget.getFocus();
    return e.length === 0 ? (this._listWidget.focusLast(), !0) : e[0] === 0 ? (this._listWidget.setFocus([]), !1) : (this._listWidget.focusPrevious(), !0);
  }
  clearFocus() {
    this._listWidget.setFocus([]);
  }
  get _candidateViewHeight() {
    const { totalHeight: e } = Lg.getLayoutInfo({ lineHeight: this._lineHeight });
    return e;
  }
  _pickListHeight(e) {
    const t = this._candidateViewHeight * e;
    return Math.min(t, this._availableHeight, 7 * this._candidateViewHeight);
  }
  _pickListWidth(e) {
    const t = Math.ceil(Math.max(...e.map(((i) => i.newSymbolName.length))) * this._typicalHalfwidthCharacterWidth);
    return Math.max(this._minimumWidth, 25 + t + 10);
  }
  static _createListWidget(e, t, i) {
    const s = new class {
      getTemplateId(r) {
        return "candidate";
      }
      getHeight(r) {
        return t;
      }
    }(), o = new class {
      constructor() {
        this.templateId = "candidate";
      }
      renderTemplate(r) {
        return new Lg(r, i);
      }
      renderElement(r, a, l) {
        l.populate(r);
      }
      disposeTemplate(r) {
        r.dispose();
      }
    }();
    return new uo("NewSymbolNameCandidates", e, s, [o], { keyboardSupport: !1, mouseSupport: !0, multipleSelectionSupport: !1 });
  }
}
class hhe {
  constructor() {
    this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._disposables = new G();
  }
  get domNode() {
    return this._domNode || (this._domNode = document.createElement("input"), this._domNode.className = "rename-input", this._domNode.type = "text", this._domNode.setAttribute("aria-label", m(0, "Rename input. Type new name and press Enter to commit.")), this._disposables.add(K(this._domNode, "input", (() => this._onDidChange.fire())))), this._domNode;
  }
  dispose() {
    this._onDidChange.dispose(), this._disposables.dispose();
  }
}
class Lg {
  constructor(e, t) {
    this._domNode = document.createElement("div"), this._domNode.style.display = "flex", this._domNode.style.columnGap = "5px", this._domNode.style.alignItems = "center", this._domNode.style.height = `${t.lineHeight}px`, this._domNode.style.padding = `${Lg._PADDING}px`;
    const i = document.createElement("div");
    i.style.display = "flex", i.style.alignItems = "center", i.style.width = i.style.height = 0.8 * t.lineHeight + "px", this._domNode.appendChild(i), this._icon = Lv(ne.sparkle), this._icon.style.display = "none", i.appendChild(this._icon), this._label = document.createElement("div"), yn(this._label, t), this._domNode.appendChild(this._label), e.appendChild(this._domNode);
  }
  populate(e) {
    this._updateIcon(e), this._updateLabel(e);
  }
  _updateIcon(e) {
    var t;
    const i = !!(!((t = e.tags) === null || t === void 0) && t.includes(IN.AIGenerated));
    this._icon.style.display = i ? "inherit" : "none";
  }
  _updateLabel(e) {
    this._label.innerText = e.newSymbolName;
  }
  static getLayoutInfo({ lineHeight: e }) {
    return { totalHeight: e + 2 * Lg._PADDING };
  }
  dispose() {
  }
}
Lg._PADDING = 2;
var vT, che = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, eh = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class bT {
  constructor(e, t, i) {
    this.model = e, this.position = t, this._providerRenameIdx = 0, this._providers = i.ordered(e);
  }
  hasProvider() {
    return this._providers.length > 0;
  }
  async resolveRenameLocation(e) {
    const t = [];
    for (this._providerRenameIdx = 0; this._providerRenameIdx < this._providers.length; this._providerRenameIdx++) {
      const s = this._providers[this._providerRenameIdx];
      if (!s.resolveRenameLocation) break;
      const o = await s.resolveRenameLocation(this.model, this.position, e);
      if (o) {
        if (!o.rejectReason) return o;
        t.push(o.rejectReason);
      }
    }
    this._providerRenameIdx = 0;
    const i = this.model.getWordAtPosition(this.position);
    return i ? { range: new D(this.position.lineNumber, i.startColumn, this.position.lineNumber, i.endColumn), text: i.word, rejectReason: t.length > 0 ? t.join(`
`) : void 0 } : { range: D.fromPositions(this.position), text: "", rejectReason: t.length > 0 ? t.join(`
`) : void 0 };
  }
  async provideRenameEdits(e, t) {
    return this._provideRenameEdits(e, this._providerRenameIdx, [], t);
  }
  async _provideRenameEdits(e, t, i, s) {
    const o = this._providers[t];
    if (!o) return { edits: [], rejectReason: i.join(`
`) };
    const r = await o.provideRenameEdits(this.model, this.position, e, s);
    return r ? r.rejectReason ? this._provideRenameEdits(e, t + 1, i.concat(r.rejectReason), s) : r : this._provideRenameEdits(e, t + 1, i.concat(m(0, "No result.")), s);
  }
}
let Td = vT = class {
  static get(n) {
    return n.getContribution(vT.ID);
  }
  constructor(n, e, t, i, s, o, r, a, l) {
    this.editor = n, this._instaService = e, this._notificationService = t, this._bulkEditService = i, this._progressService = s, this._logService = o, this._configService = r, this._languageFeaturesService = a, this._telemetryService = l, this._disposableStore = new G(), this._cts = new Ci(), this._renameWidget = this._disposableStore.add(this._instaService.createInstance(_T, this.editor, ["acceptRenameInput", "acceptRenameInputWithPreview"]));
  }
  dispose() {
    this._disposableStore.dispose(), this._cts.dispose(!0);
  }
  async run() {
    var n, e;
    const t = this._logService.trace.bind(this._logService, "[rename]");
    if (this._cts.dispose(!0), this._cts = new Ci(), !this.editor.hasModel()) return void t("editor has no model");
    const i = this.editor.getPosition(), s = new bT(this.editor.getModel(), i, this._languageFeaturesService.renameProvider);
    if (!s.hasProvider()) return void t("skeleton has no provider");
    const o = new Ic(this.editor, 5, void 0, this._cts.token);
    let r;
    try {
      t("resolving rename location");
      const g = s.resolveRenameLocation(o.token);
      this._progressService.showWhile(g, 250), r = await g, t("resolved rename location");
    } catch (g) {
      return void (g instanceof Vd ? t("resolve rename location cancelled", JSON.stringify(g, null, "	")) : (t("resolve rename location failed", g instanceof Error ? g : JSON.stringify(g, null, "	")), (typeof g == "string" || da(g)) && ((n = bs.get(this.editor)) === null || n === void 0 || n.showMessage(g || m(0, "An unknown error occurred while resolving rename location"), i))));
    } finally {
      o.dispose();
    }
    if (!r) return void t("returning early - no loc");
    if (r.rejectReason) return t(`returning early - rejected with reason: ${r.rejectReason}`, r.rejectReason), void ((e = bs.get(this.editor)) === null || e === void 0 || e.showMessage(r.rejectReason, i));
    if (o.token.isCancellationRequested) return void t("returning early - cts1 cancelled");
    const a = new Ic(this.editor, 5, r.range, this._cts.token), l = this.editor.getModel(), d = this._languageFeaturesService.newSymbolNamesProvider.all(l);
    t("creating rename input field and awaiting its result");
    const h = this._bulkEditService.hasPreviewHandler() && this._configService.getValue(this.editor.getModel().uri, "editor.rename.enablePreview"), c = await this._renameWidget.getInput(r.range, r.text, h, ((g) => d.map(((p) => p.provideNewSymbolNames(l, r.range, g)))), a);
    if (t("received response from rename input field"), d.length > 0 && this._reportTelemetry(d.length, l.getLanguageId(), c), typeof c == "boolean") return t(`returning early - rename input field response - ${c}`), c && this.editor.focus(), void a.dispose();
    this.editor.focus(), t("requesting rename edits");
    const u = f1(s.provideRenameEdits(c.newName, a.token), a.token).then((async (g) => {
      if (g) if (this.editor.hasModel()) {
        if (g.rejectReason) return t(`returning early - rejected with reason: ${g.rejectReason}`), void this._notificationService.info(g.rejectReason);
        this.editor.setSelection(D.fromPositions(this.editor.getSelection().getPosition())), t("applying edits"), this._bulkEditService.apply(g, { editor: this.editor, showPreview: c.wantsPreview, label: m(0, "Renaming '{0}' to '{1}'", r?.text, c.newName), code: "undoredo.rename", quotableLabel: m(0, "Renaming {0} to {1}", r?.text, c.newName), respectAutoSaveConfig: !0 }).then(((p) => {
          t("edits applied"), p.ariaSummary && Io(m(0, "Successfully renamed '{0}' to '{1}'. Summary: {2}", r.text, c.newName, p.ariaSummary));
        })).catch(((p) => {
          t(`error when applying edits ${JSON.stringify(p, null, "	")}`), this._notificationService.error(m(0, "Rename failed to apply edits")), this._logService.error(p);
        }));
      } else t("returning early - no model after rename edits are provided");
      else t("returning early - no rename edits result");
    }), ((g) => {
      t("error when providing rename edits", JSON.stringify(g, null, "	")), this._notificationService.error(m(0, "Rename failed to compute edits")), this._logService.error(g);
    })).finally((() => {
      a.dispose();
    }));
    return t("returning rename operation"), this._progressService.showWhile(u, 250), u;
  }
  acceptRenameInput(n) {
    this._renameWidget.acceptInput(n);
  }
  cancelRenameInput() {
    this._renameWidget.cancelInput(!0, "cancelRenameInput command");
  }
  focusNextRenameSuggestion() {
    this._renameWidget.focusNextRenameSuggestion();
  }
  focusPreviousRenameSuggestion() {
    this._renameWidget.focusPreviousRenameSuggestion();
  }
  _reportTelemetry(n, e, t) {
    const i = typeof t == "boolean" ? { kind: "cancelled", languageId: e, nRenameSuggestionProviders: n } : { kind: "accepted", languageId: e, nRenameSuggestionProviders: n, source: t.stats.source.k, nRenameSuggestions: t.stats.nRenameSuggestions, timeBeforeFirstInputFieldEdit: t.stats.timeBeforeFirstInputFieldEdit, wantsPreview: t.wantsPreview };
    this._telemetryService.publicLog2("renameInvokedEvent", i);
  }
};
Td.ID = "editor.contrib.renameController", Td = vT = che([eh(1, Se), eh(2, Ri), eh(3, M1), eh(4, Nc), eh(5, ts), eh(6, xR), eh(7, fe), eh(8, es)], Td);
ft(Td.ID, Td, 4), X(class extends he {
  constructor() {
    super({ id: "editor.action.rename", label: m(0, "Rename Symbol"), alias: "Rename Symbol", precondition: q.and(E.writable, E.hasRenameProvider), kbOpts: { kbExpr: E.editorTextFocus, primary: 60, weight: 100 }, contextMenuOpts: { group: "1_modification", order: 1.1 } });
  }
  runCommand(n, e) {
    const t = n.get(mt), [i, s] = Array.isArray(e) && e || [void 0, void 0];
    return Ie.isUri(i) && W.isIPosition(s) ? t.openCodeEditor({ resource: i }, t.getActiveCodeEditor()).then(((o) => {
      o && (o.setPosition(s), o.invokeWithinContext(((r) => (this.reportTelemetry(r, o), this.run(r, o)))));
    }), We) : super.runCommand(n, e);
  }
  run(n, e) {
    const t = n.get(ts), i = Td.get(e);
    return i ? (t.trace("[RenameAction] got controller, running..."), i.run()) : (t.trace("[RenameAction] returning early - controller missing"), Promise.resolve());
  }
});
const sN = Zi.bindToContribution(Td.get);
re(new sN({ id: "acceptRenameInput", precondition: Cp, handler: (n) => n.acceptRenameInput(!1), kbOpts: { weight: 199, kbExpr: q.and(E.focus, q.not("isComposing")), primary: 3 } })), re(new sN({ id: "acceptRenameInputWithPreview", precondition: q.and(Cp, q.has("config.editor.rename.enablePreview")), handler: (n) => n.acceptRenameInput(!0), kbOpts: { weight: 199, kbExpr: q.and(E.focus, q.not("isComposing")), primary: 2051 } })), re(new sN({ id: "cancelRenameInput", precondition: Cp, handler: (n) => n.cancelRenameInput(), kbOpts: { weight: 199, kbExpr: E.focus, primary: 9, secondary: [1033] } })), Ft(class extends cs {
  constructor() {
    super({ id: "focusNextRenameSuggestion", title: { ...ct(0, "Focus Next Rename Suggestion") }, precondition: Cp, keybinding: [{ primary: 2, secondary: [18], weight: 199 }] });
  }
  run(n) {
    const e = n.get(mt).getFocusedCodeEditor();
    if (!e) return;
    const t = Td.get(e);
    t && t.focusNextRenameSuggestion();
  }
}), Ft(class extends cs {
  constructor() {
    super({ id: "focusPreviousRenameSuggestion", title: { ...ct(0, "Focus Previous Rename Suggestion") }, precondition: Cp, keybinding: [{ primary: 1026, secondary: [16], weight: 199 }] });
  }
  run(n) {
    const e = n.get(mt).getFocusedCodeEditor();
    if (!e) return;
    const t = Td.get(e);
    t && t.focusPreviousRenameSuggestion();
  }
}), ja("_executeDocumentRenameProvider", (function(n, e, t, ...i) {
  const [s] = i;
  vt(typeof s == "string");
  const { renameProvider: o } = n.get(fe);
  return (async function(r, a, l, d) {
    const h = new bT(a, l, r), c = await h.resolveRenameLocation(et.None);
    return c?.rejectReason ? { edits: [], rejectReason: c.rejectReason } : h.provideRenameEdits(d, et.None);
  })(o, e, t, s);
})), ja("_executePrepareRename", (async function(n, e, t) {
  const { renameProvider: i } = n.get(fe), s = new bT(e, t, i), o = await s.resolveRenameLocation(et.None);
  if (o?.rejectReason) throw new Error(o.rejectReason);
  return o;
})), li.as(ma).registerConfiguration({ id: "editor", properties: { "editor.rename.enablePreview": { scope: 5, description: m(0, "Enable/disable the ability to preview changes before renaming"), default: !0, type: "boolean" } } });
var uhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, B9 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let o_ = class extends V {
  constructor(n, e, t) {
    super(), this.editor = n, this.languageConfigurationService = e, this.editorWorkerService = t, this.decorations = this.editor.createDecorationsCollection(), this.options = this.createOptions(n.getOption(73)), this.computePromise = null, this.currentOccurrences = {}, this._register(n.onDidChangeModel(((i) => {
      this.currentOccurrences = {}, this.options = this.createOptions(n.getOption(73)), this.stop(), this.computeSectionHeaders.schedule(0);
    }))), this._register(n.onDidChangeModelLanguage(((i) => {
      this.currentOccurrences = {}, this.options = this.createOptions(n.getOption(73)), this.stop(), this.computeSectionHeaders.schedule(0);
    }))), this._register(e.onDidChange(((i) => {
      var s;
      const o = (s = this.editor.getModel()) === null || s === void 0 ? void 0 : s.getLanguageId();
      o && i.affects(o) && (this.currentOccurrences = {}, this.options = this.createOptions(n.getOption(73)), this.stop(), this.computeSectionHeaders.schedule(0));
    }))), this._register(n.onDidChangeConfiguration(((i) => {
      this.options && !i.hasChanged(73) || (this.options = this.createOptions(n.getOption(73)), this.updateDecorations([]), this.stop(), this.computeSectionHeaders.schedule(0));
    }))), this._register(this.editor.onDidChangeModelContent(((i) => {
      this.computeSectionHeaders.schedule();
    }))), this.computeSectionHeaders = this._register(new Et((() => {
      this.findSectionHeaders();
    }), 250)), this.computeSectionHeaders.schedule(0);
  }
  createOptions(n) {
    if (!n || !this.editor.hasModel()) return;
    const e = this.editor.getModel().getLanguageId();
    if (!e) return;
    const t = this.languageConfigurationService.getLanguageConfiguration(e).comments, i = this.languageConfigurationService.getLanguageConfiguration(e).foldingRules;
    return t || i?.markers ? { foldingRules: i, findMarkSectionHeaders: n.showMarkSectionHeaders, findRegionSectionHeaders: n.showRegionSectionHeaders } : void 0;
  }
  findSectionHeaders() {
    var n, e;
    if (!this.editor.hasModel() || !(!((n = this.options) === null || n === void 0) && n.findMarkSectionHeaders) && !(!((e = this.options) === null || e === void 0) && e.findRegionSectionHeaders)) return;
    const t = this.editor.getModel();
    if (t.isDisposed() || t.isTooLargeForSyncing()) return;
    const i = t.getVersionId();
    this.editorWorkerService.findSectionHeaders(t.uri, this.options).then(((s) => {
      t.isDisposed() || t.getVersionId() !== i || this.updateDecorations(s);
    }));
  }
  updateDecorations(n) {
    const e = this.editor.getModel();
    e && (n = n.filter(((s) => {
      if (!s.shouldBeInComments) return !0;
      const o = e.validateRange(s.range), r = e.tokenization.getLineTokens(o.startLineNumber), a = r.findTokenIndexAtOffset(o.startColumn - 1), l = r.getStandardTokenType(a);
      return r.getLanguageId(a) === e.getLanguageId() && l === 1;
    })));
    const t = Object.values(this.currentOccurrences).map(((s) => s.decorationId)), i = n.map(((s) => (function(o) {
      return { range: o.range, options: Ve.createDynamic({ description: "section-header", stickiness: 3, collapseOnReplaceEdit: !0, minimap: { color: void 0, position: 1, sectionHeaderStyle: o.hasSeparatorLine ? 2 : 1, sectionHeaderText: o.text } }) };
    })(s)));
    this.editor.changeDecorations(((s) => {
      const o = s.deltaDecorations(t, i);
      this.currentOccurrences = {};
      for (let r = 0, a = o.length; r < a; r++) {
        const l = { sectionHeader: n[r], decorationId: o[r] };
        this.currentOccurrences[l.decorationId] = l;
      }
    }));
  }
  stop() {
    this.computeSectionHeaders.cancel(), this.computePromise && (this.computePromise.cancel(), this.computePromise = null);
  }
  dispose() {
    super.dispose(), this.stop(), this.decorations.clear();
  }
};
function W9(n) {
  const e = new Uint32Array((function(i) {
    let s = 0;
    if (s += 2, i.type === "full") s += 1 + i.data.length;
    else {
      s += 1, s += 3 * i.deltas.length;
      for (const o of i.deltas) o.data && (s += o.data.length);
    }
    return s;
  })(n));
  let t = 0;
  if (e[t++] = n.id, n.type === "full") e[t++] = 1, e[t++] = n.data.length, e.set(n.data, t), t += n.data.length;
  else {
    e[t++] = 2, e[t++] = n.deltas.length;
    for (const i of n.deltas) e[t++] = i.start, e[t++] = i.deleteCount, i.data ? (e[t++] = i.data.length, e.set(i.data, t), t += i.data.length) : e[t++] = 0;
  }
  return (function(i) {
    const s = new Uint8Array(i.buffer, i.byteOffset, 4 * i.length);
    return L7() || (function(o) {
      for (let r = 0, a = o.length; r < a; r += 4) {
        const l = o[r + 0], d = o[r + 1], h = o[r + 2], c = o[r + 3];
        o[r + 0] = c, o[r + 1] = h, o[r + 2] = d, o[r + 3] = l;
      }
    })(s), eL.wrap(s);
  })(e);
}
function bk(n) {
  return n && !!n.data;
}
function uU(n) {
  return n && Array.isArray(n.edits);
}
o_.ID = "editor.sectionHeaderDetector", o_ = uhe([B9(1, zt), B9(2, Qo)], o_), ft(o_.ID, o_, 1);
class ghe {
  constructor(e, t, i) {
    this.provider = e, this.tokens = t, this.error = i;
  }
}
function gU(n, e) {
  return n.has(e);
}
async function pU(n, e, t, i, s) {
  const o = (function(a, l) {
    const d = a.orderedGroups(l);
    return d.length > 0 ? d[0] : [];
  })(n, e), r = await Promise.all(o.map((async (a) => {
    let l, d = null;
    try {
      l = await a.provideDocumentSemanticTokens(e, a === t ? i : null, s);
    } catch (h) {
      d = h, l = null;
    }
    return l && (bk(l) || uU(l)) || (l = null), new ghe(a, l, d);
  })));
  for (const a of r) {
    if (a.error) throw a.error;
    if (a.tokens) return a;
  }
  return r.length > 0 ? r[0] : null;
}
class phe {
  constructor(e, t) {
    this.provider = e, this.tokens = t;
  }
}
function mU(n, e) {
  const t = n.orderedGroups(e);
  return t.length > 0 ? t[0] : [];
}
async function CT(n, e, t, i) {
  const s = mU(n, e), o = await Promise.all(s.map((async (r) => {
    let a;
    try {
      a = await r.provideDocumentRangeSemanticTokens(e, t, i);
    } catch (l) {
      Ni(l), a = null;
    }
    return a && bk(a) || (a = null), new phe(r, a);
  })));
  for (const r of o) if (r.tokens) return r;
  return o.length > 0 ? o[0] : null;
}
dt.registerCommand("_provideDocumentSemanticTokensLegend", (async (n, ...e) => {
  const [t] = e;
  vt(t instanceof Ie);
  const i = n.get(ni).getModel(t);
  if (!i) return;
  const { documentSemanticTokensProvider: s } = n.get(fe), o = (function(r, a) {
    const l = r.orderedGroups(a);
    return l.length > 0 ? l[0] : null;
  })(s, i);
  return o ? o[0].getLegend() : n.get(ai).executeCommand("_provideDocumentRangeSemanticTokensLegend", t);
})), dt.registerCommand("_provideDocumentSemanticTokens", (async (n, ...e) => {
  const [t] = e;
  vt(t instanceof Ie);
  const i = n.get(ni).getModel(t);
  if (!i) return;
  const { documentSemanticTokensProvider: s } = n.get(fe);
  if (!gU(s, i)) return n.get(ai).executeCommand("_provideDocumentRangeSemanticTokens", t, i.getFullModelRange());
  const o = await pU(s, i, null, null, et.None);
  if (!o) return;
  const { provider: r, tokens: a } = o;
  if (!a || !bk(a)) return;
  const l = W9({ id: 0, type: "full", data: a.data });
  return a.resultId && r.releaseDocumentSemanticTokens(a.resultId), l;
})), dt.registerCommand("_provideDocumentRangeSemanticTokensLegend", (async (n, ...e) => {
  const [t, i] = e;
  vt(t instanceof Ie);
  const s = n.get(ni).getModel(t);
  if (!s) return;
  const { documentRangeSemanticTokensProvider: o } = n.get(fe), r = mU(o, s);
  if (r.length === 0) return;
  if (r.length === 1) return r[0].getLegend();
  if (!i || !D.isIRange(i)) return console.warn("provideDocumentRangeSemanticTokensLegend might be out-of-sync with provideDocumentRangeSemanticTokens unless a range argument is passed in"), r[0].getLegend();
  const a = await CT(o, s, D.lift(i), et.None);
  return a ? a.provider.getLegend() : void 0;
})), dt.registerCommand("_provideDocumentRangeSemanticTokens", (async (n, ...e) => {
  const [t, i] = e;
  vt(t instanceof Ie), vt(D.isIRange(i));
  const s = n.get(ni).getModel(t);
  if (!s) return;
  const { documentRangeSemanticTokensProvider: o } = n.get(fe), r = await CT(o, s, D.lift(i), et.None);
  return r && r.tokens ? W9({ id: 0, type: "full", data: r.tokens.data }) : void 0;
}));
const AP = "editor.semanticHighlighting";
function yw(n, e, t) {
  var i;
  const s = (i = t.getValue(AP, { overrideIdentifier: n.getLanguageId(), resource: n.uri })) === null || i === void 0 ? void 0 : i.enabled;
  return typeof s == "boolean" ? s : e.getColorTheme().semanticHighlighting;
}
var ch, fU = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ua = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let wT = class extends V {
  constructor(n, e, t, i, s, o) {
    super(), this._watchers = /* @__PURE__ */ Object.create(null);
    const r = (d) => {
      this._watchers[d.uri.toString()] = new z_(d, n, t, s, o);
    }, a = (d, h) => {
      h.dispose(), delete this._watchers[d.uri.toString()];
    }, l = () => {
      for (const d of e.getModels()) {
        const h = this._watchers[d.uri.toString()];
        yw(d, t, i) ? h || r(d) : h && a(d, h);
      }
    };
    e.getModels().forEach(((d) => {
      yw(d, t, i) && r(d);
    })), this._register(e.onModelAdded(((d) => {
      yw(d, t, i) && r(d);
    }))), this._register(e.onModelRemoved(((d) => {
      const h = this._watchers[d.uri.toString()];
      h && a(d, h);
    }))), this._register(i.onDidChangeConfiguration(((d) => {
      d.affectsConfiguration(AP) && l();
    }))), this._register(t.onDidColorThemeChange(l));
  }
  dispose() {
    for (const n of Object.values(this._watchers)) n.dispose();
    super.dispose();
  }
};
wT = fU([Ua(0, mL), Ua(1, ni), Ua(2, Yi), Ua(3, Ye), Ua(4, ar), Ua(5, fe)], wT);
let z_ = ch = class extends V {
  constructor(n, e, t, i, s) {
    super(), this._semanticTokensStylingService = e, this._isDisposed = !1, this._model = n, this._provider = s.documentSemanticTokensProvider, this._debounceInformation = i.for(this._provider, "DocumentSemanticTokens", { min: ch.REQUEST_MIN_DELAY, max: ch.REQUEST_MAX_DELAY }), this._fetchDocumentSemanticTokens = this._register(new Et((() => this._fetchDocumentSemanticTokensNow()), ch.REQUEST_MIN_DELAY)), this._currentDocumentResponse = null, this._currentDocumentRequestCancellationTokenSource = null, this._documentProvidersChangeListeners = [], this._providersChangedDuringRequest = !1, this._register(this._model.onDidChangeContent((() => {
      this._fetchDocumentSemanticTokens.isScheduled() || this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    }))), this._register(this._model.onDidChangeAttached((() => {
      this._fetchDocumentSemanticTokens.isScheduled() || this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    }))), this._register(this._model.onDidChangeLanguage((() => {
      this._currentDocumentResponse && (this._currentDocumentResponse.dispose(), this._currentDocumentResponse = null), this._currentDocumentRequestCancellationTokenSource && (this._currentDocumentRequestCancellationTokenSource.cancel(), this._currentDocumentRequestCancellationTokenSource = null), this._setDocumentSemanticTokens(null, null, null, []), this._fetchDocumentSemanticTokens.schedule(0);
    })));
    const o = () => {
      Ht(this._documentProvidersChangeListeners), this._documentProvidersChangeListeners = [];
      for (const r of this._provider.all(n)) typeof r.onDidChange == "function" && this._documentProvidersChangeListeners.push(r.onDidChange((() => {
        this._currentDocumentRequestCancellationTokenSource ? this._providersChangedDuringRequest = !0 : this._fetchDocumentSemanticTokens.schedule(0);
      })));
    };
    o(), this._register(this._provider.onDidChange((() => {
      o(), this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    }))), this._register(t.onDidColorThemeChange(((r) => {
      this._setDocumentSemanticTokens(null, null, null, []), this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    }))), this._fetchDocumentSemanticTokens.schedule(0);
  }
  dispose() {
    this._currentDocumentResponse && (this._currentDocumentResponse.dispose(), this._currentDocumentResponse = null), this._currentDocumentRequestCancellationTokenSource && (this._currentDocumentRequestCancellationTokenSource.cancel(), this._currentDocumentRequestCancellationTokenSource = null), Ht(this._documentProvidersChangeListeners), this._documentProvidersChangeListeners = [], this._setDocumentSemanticTokens(null, null, null, []), this._isDisposed = !0, super.dispose();
  }
  _fetchDocumentSemanticTokensNow() {
    if (this._currentDocumentRequestCancellationTokenSource) return;
    if (!gU(this._provider, this._model)) return void (this._currentDocumentResponse && this._model.tokenization.setSemanticTokens(null, !1));
    if (!this._model.isAttachedToEditor()) return;
    const n = new Ci(), e = this._currentDocumentResponse ? this._currentDocumentResponse.provider : null, t = this._currentDocumentResponse && this._currentDocumentResponse.resultId || null, i = pU(this._provider, this._model, e, t, n.token);
    this._currentDocumentRequestCancellationTokenSource = n, this._providersChangedDuringRequest = !1;
    const s = [], o = this._model.onDidChangeContent(((a) => {
      s.push(a);
    })), r = new Rn(!1);
    i.then(((a) => {
      if (this._debounceInformation.update(this._model, r.elapsed()), this._currentDocumentRequestCancellationTokenSource = null, o.dispose(), a) {
        const { provider: l, tokens: d } = a, h = this._semanticTokensStylingService.getStyling(l);
        this._setDocumentSemanticTokens(l, d || null, h, s);
      } else this._setDocumentSemanticTokens(null, null, null, s);
    }), ((a) => {
      a && (ya(a) || typeof a.message == "string" && a.message.indexOf("busy") !== -1) || We(a), this._currentDocumentRequestCancellationTokenSource = null, o.dispose(), (s.length > 0 || this._providersChangedDuringRequest) && (this._fetchDocumentSemanticTokens.isScheduled() || this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model)));
    }));
  }
  static _copy(n, e, t, i, s) {
    s = Math.min(s, t.length - i, n.length - e);
    for (let o = 0; o < s; o++) t[i + o] = n[e + o];
  }
  _setDocumentSemanticTokens(n, e, t, i) {
    const s = this._currentDocumentResponse, o = () => {
      (i.length > 0 || this._providersChangedDuringRequest) && !this._fetchDocumentSemanticTokens.isScheduled() && this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    };
    if (this._currentDocumentResponse && (this._currentDocumentResponse.dispose(), this._currentDocumentResponse = null), this._isDisposed) n && e && n.releaseDocumentSemanticTokens(e.resultId);
    else if (n && t) {
      if (!e) return this._model.tokenization.setSemanticTokens(null, !0), void o();
      if (uU(e)) {
        if (!s) return void this._model.tokenization.setSemanticTokens(null, !0);
        if (e.edits.length === 0) e = { resultId: e.resultId, data: s.data };
        else {
          let r = 0;
          for (const c of e.edits) r += (c.data ? c.data.length : 0) - c.deleteCount;
          const a = s.data, l = new Uint32Array(a.length + r);
          let d = a.length, h = l.length;
          for (let c = e.edits.length - 1; c >= 0; c--) {
            const u = e.edits[c];
            if (u.start > a.length) return t.warnInvalidEditStart(s.resultId, e.resultId, c, u.start, a.length), void this._model.tokenization.setSemanticTokens(null, !0);
            const g = d - (u.start + u.deleteCount);
            g > 0 && (ch._copy(a, d - g, l, h - g, g), h -= g), u.data && (ch._copy(u.data, 0, l, h - u.data.length, u.data.length), h -= u.data.length), d = u.start;
          }
          d > 0 && ch._copy(a, 0, l, 0, d), e = { resultId: e.resultId, data: l };
        }
      }
      if (bk(e)) {
        this._currentDocumentResponse = new mhe(n, e.resultId, e.data);
        const r = CW(e, t, this._model.getLanguageId());
        if (i.length > 0) for (const a of i) for (const l of r) for (const d of a.changes) l.applyEdit(d.range, d.text);
        this._model.tokenization.setSemanticTokens(r, !0);
      } else this._model.tokenization.setSemanticTokens(null, !0);
      o();
    } else this._model.tokenization.setSemanticTokens(null, !1);
  }
};
z_.REQUEST_MIN_DELAY = 300, z_.REQUEST_MAX_DELAY = 2e3, z_ = ch = fU([Ua(1, mL), Ua(2, Yi), Ua(3, ar), Ua(4, fe)], z_);
class mhe {
  constructor(e, t, i) {
    this.provider = e, this.resultId = t, this.data = i;
  }
  dispose() {
    this.provider.releaseDocumentSemanticTokens(this.resultId);
  }
}
W1(wT);
var fhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, r_ = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let a_ = class extends V {
  constructor(n, e, t, i, s, o) {
    super(), this._semanticTokensStylingService = e, this._themeService = t, this._configurationService = i, this._editor = n, this._provider = o.documentRangeSemanticTokensProvider, this._debounceInformation = s.for(this._provider, "DocumentRangeSemanticTokens", { min: 100, max: 500 }), this._tokenizeViewport = this._register(new Et((() => this._tokenizeViewportNow()), 100)), this._outstandingRequests = [];
    const r = () => {
      this._editor.hasModel() && this._tokenizeViewport.schedule(this._debounceInformation.get(this._editor.getModel()));
    };
    this._register(this._editor.onDidScrollChange((() => {
      r();
    }))), this._register(this._editor.onDidChangeModel((() => {
      this._cancelAll(), r();
    }))), this._register(this._editor.onDidChangeModelContent(((a) => {
      this._cancelAll(), r();
    }))), this._register(this._provider.onDidChange((() => {
      this._cancelAll(), r();
    }))), this._register(this._configurationService.onDidChangeConfiguration(((a) => {
      a.affectsConfiguration(AP) && (this._cancelAll(), r());
    }))), this._register(this._themeService.onDidColorThemeChange((() => {
      this._cancelAll(), r();
    }))), r();
  }
  _cancelAll() {
    for (const n of this._outstandingRequests) n.cancel();
    this._outstandingRequests = [];
  }
  _removeOutstandingRequest(n) {
    for (let e = 0, t = this._outstandingRequests.length; e < t; e++) if (this._outstandingRequests[e] === n) return void this._outstandingRequests.splice(e, 1);
  }
  _tokenizeViewportNow() {
    if (!this._editor.hasModel()) return;
    const n = this._editor.getModel();
    if (n.tokenization.hasCompleteSemanticTokens()) return;
    if (!yw(n, this._themeService, this._configurationService) || !(function(t, i) {
      return t.has(i);
    })(this._provider, n)) return void (n.tokenization.hasSomeSemanticTokens() && n.tokenization.setSemanticTokens(null, !1));
    const e = this._editor.getVisibleRangesPlusViewportAboveBelow();
    this._outstandingRequests = this._outstandingRequests.concat(e.map(((t) => this._requestRange(n, t))));
  }
  _requestRange(n, e) {
    const t = n.getVersionId(), i = on(((o) => Promise.resolve(CT(this._provider, n, e, o)))), s = new Rn(!1);
    return i.then(((o) => {
      if (this._debounceInformation.update(n, s.elapsed()), !o || !o.tokens || n.isDisposed() || n.getVersionId() !== t) return;
      const { provider: r, tokens: a } = o, l = this._semanticTokensStylingService.getStyling(r);
      n.tokenization.setPartialSemanticTokens(e, CW(a, l, n.getLanguageId()));
    })).then((() => this._removeOutstandingRequest(i)), (() => this._removeOutstandingRequest(i))), i;
  }
};
a_.ID = "editor.contrib.viewportSemanticTokens", a_ = fhe([r_(1, mL), r_(2, Yi), r_(3, Ye), r_(4, ar), r_(5, fe)], a_), ft(a_.ID, a_, 1);
class _he {
  constructor(e = !0) {
    this.selectSubwords = e;
  }
  provideSelectionRanges(e, t) {
    const i = [];
    for (const s of t) {
      const o = [];
      i.push(o), this.selectSubwords && this._addInWordRanges(o, e, s), this._addWordRanges(o, e, s), this._addWhitespaceLine(o, e, s), o.push({ range: e.getFullModelRange() });
    }
    return i;
  }
  _addInWordRanges(e, t, i) {
    const s = t.getWordAtPosition(i);
    if (!s) return;
    const { word: o, startColumn: r } = s, a = i.column - r;
    let l = a, d = a, h = 0;
    for (; l >= 0; l--) {
      const c = o.charCodeAt(l);
      if (l !== a && (c === 95 || c === 45) || Nh(c) && Ba(h)) break;
      h = c;
    }
    for (l += 1; d < o.length; d++) {
      const c = o.charCodeAt(d);
      if (Ba(c) && Nh(h) || c === 95 || c === 45) break;
      h = c;
    }
    l < d && e.push({ range: new D(i.lineNumber, r + l, i.lineNumber, r + d) });
  }
  _addWordRanges(e, t, i) {
    const s = t.getWordAtPosition(i);
    s && e.push({ range: new D(i.lineNumber, s.startColumn, i.lineNumber, s.endColumn) });
  }
  _addWhitespaceLine(e, t, i) {
    t.getLineLength(i.lineNumber) > 0 && t.getLineFirstNonWhitespaceColumn(i.lineNumber) === 0 && t.getLineLastNonWhitespaceColumn(i.lineNumber) === 0 && e.push({ range: new D(i.lineNumber, 1, i.lineNumber, t.getLineMaxColumn(i.lineNumber)) });
  }
}
var yT, vhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, bhe = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class PP {
  constructor(e, t) {
    this.index = e, this.ranges = t;
  }
  mov(e) {
    const t = this.index + (e ? 1 : -1);
    if (t < 0 || t >= this.ranges.length) return this;
    const i = new PP(t, this.ranges);
    return i.ranges[t].equalsRange(this.ranges[this.index]) ? i.mov(e) : i;
  }
}
let Nm = yT = class {
  static get(n) {
    return n.getContribution(yT.ID);
  }
  constructor(n, e) {
    this._editor = n, this._languageFeaturesService = e, this._ignoreSelection = !1;
  }
  dispose() {
    var n;
    (n = this._selectionListener) === null || n === void 0 || n.dispose();
  }
  async run(n) {
    if (!this._editor.hasModel()) return;
    const e = this._editor.getSelections(), t = this._editor.getModel();
    if (this._state || await _U(this._languageFeaturesService.selectionRangeProvider, t, e.map(((s) => s.getPosition())), this._editor.getOption(113), et.None).then(((s) => {
      var o;
      if (zn(s) && s.length === e.length && this._editor.hasModel() && ri(this._editor.getSelections(), e, ((r, a) => r.equalsSelection(a)))) {
        for (let r = 0; r < s.length; r++) s[r] = s[r].filter(((a) => a.containsPosition(e[r].getStartPosition()) && a.containsPosition(e[r].getEndPosition()))), s[r].unshift(e[r]);
        this._state = s.map(((r) => new PP(0, r))), (o = this._selectionListener) === null || o === void 0 || o.dispose(), this._selectionListener = this._editor.onDidChangeCursorPosition((() => {
          var r;
          this._ignoreSelection || ((r = this._selectionListener) === null || r === void 0 || r.dispose(), this._state = void 0);
        }));
      }
    })), !this._state) return;
    this._state = this._state.map(((s) => s.mov(n)));
    const i = this._state.map(((s) => _e.fromPositions(s.ranges[s.index].getStartPosition(), s.ranges[s.index].getEndPosition())));
    this._ignoreSelection = !0;
    try {
      this._editor.setSelections(i);
    } finally {
      this._ignoreSelection = !1;
    }
  }
};
Nm.ID = "editor.contrib.smartSelectController", Nm = yT = vhe([bhe(1, fe)], Nm);
class V9 extends he {
  constructor(e, t) {
    super(t), this._forward = e;
  }
  async run(e, t) {
    const i = Nm.get(t);
    i && await i.run(this._forward);
  }
}
dt.registerCommandAlias("editor.action.smartSelect.grow", "editor.action.smartSelect.expand");
async function _U(n, e, t, i, s) {
  const o = n.all(e).concat(new _he(i.selectSubwords));
  o.length === 1 && o.unshift(new ho());
  const r = [], a = [];
  for (const l of o) r.push(Promise.resolve(l.provideSelectionRanges(e, t, s)).then(((d) => {
    if (zn(d) && d.length === t.length) for (let h = 0; h < t.length; h++) {
      a[h] || (a[h] = []);
      for (const c of d[h]) D.isIRange(c.range) && D.containsPosition(c.range, t[h]) && a[h].push(D.lift(c.range));
    }
  }), Ni));
  return await Promise.all(r), a.map(((l) => {
    if (l.length === 0) return [];
    l.sort(((u, g) => W.isBefore(u.getStartPosition(), g.getStartPosition()) ? 1 : W.isBefore(g.getStartPosition(), u.getStartPosition()) || W.isBefore(u.getEndPosition(), g.getEndPosition()) ? -1 : W.isBefore(g.getEndPosition(), u.getEndPosition()) ? 1 : 0));
    const d = [];
    let h;
    for (const u of l) (!h || D.containsRange(u, h) && !D.equalsRange(u, h)) && (d.push(u), h = u);
    if (!i.selectLeadingAndTrailingWhitespace) return d;
    const c = [d[0]];
    for (let u = 1; u < d.length; u++) {
      const g = d[u - 1], p = d[u];
      if (p.startLineNumber !== g.startLineNumber || p.endLineNumber !== g.endLineNumber) {
        const f = new D(g.startLineNumber, e.getLineFirstNonWhitespaceColumn(g.startLineNumber), g.endLineNumber, e.getLineLastNonWhitespaceColumn(g.endLineNumber));
        f.containsRange(g) && !f.equalsRange(g) && p.containsRange(f) && !p.equalsRange(f) && c.push(f);
        const _ = new D(g.startLineNumber, 1, g.endLineNumber, e.getLineMaxColumn(g.endLineNumber));
        _.containsRange(g) && !_.equalsRange(f) && p.containsRange(_) && !p.equalsRange(_) && c.push(_);
      }
      c.push(p);
    }
    return c;
  }));
}
ft(Nm.ID, Nm, 4), X(class extends V9 {
  constructor() {
    super(!0, { id: "editor.action.smartSelect.expand", label: m(0, "Expand Selection"), alias: "Expand Selection", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 1553, mac: { primary: 3345, secondary: [1297] }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "1_basic", title: m(0, "&&Expand Selection"), order: 2 } });
  }
}), X(class extends V9 {
  constructor() {
    super(!1, { id: "editor.action.smartSelect.shrink", label: m(0, "Shrink Selection"), alias: "Shrink Selection", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 1551, mac: { primary: 3343, secondary: [1295] }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "1_basic", title: m(0, "&&Shrink Selection"), order: 3 } });
  }
}), dt.registerCommand("_executeSelectionRangeProvider", (async function(n, ...e) {
  const [t, i] = e;
  vt(Ie.isUri(t));
  const s = n.get(fe).selectionRangeProvider, o = await n.get(Ps).createModelReference(t);
  try {
    return _U(s, o.object.textEditorModel, i, { selectLeadingAndTrailingWhitespace: !0, selectSubwords: !0 }, et.None);
  } finally {
    o.dispose();
  }
}));
const Che = Object.freeze({ View: ct(0, "View"), Help: ct(0, "Help"), Test: ct(0, "Test"), File: ct(0, "File"), Preferences: ct(0, "Preferences"), Developer: ct(0, "Developer") });
class H9 {
  constructor(e, t, i, s = null) {
    this.startLineNumbers = e, this.endLineNumbers = t, this.lastLineRelativePosition = i, this.showEndForLine = s;
  }
  equals(e) {
    return !!e && this.lastLineRelativePosition === e.lastLineRelativePosition && this.showEndForLine === e.showEndForLine && ri(this.startLineNumbers, e.startLineNumbers) && ri(this.endLineNumbers, e.endLineNumbers);
  }
}
const z9 = Hd("stickyScrollViewLayer", { createHTML: (n) => n }), oN = "data-sticky-line-index", U9 = "data-sticky-is-line", K9 = "data-sticky-is-folding-icon";
class whe extends V {
  constructor(e) {
    super(), this._editor = e, this._foldingIconStore = new G(), this._rootDomNode = document.createElement("div"), this._lineNumbersDomNode = document.createElement("div"), this._linesDomNodeScrollable = document.createElement("div"), this._linesDomNode = document.createElement("div"), this._lineHeight = this._editor.getOption(67), this._renderedStickyLines = [], this._lineNumbers = [], this._lastLineRelativePosition = 0, this._minContentWidthInPx = 0, this._isOnGlyphMargin = !1, this._lineNumbersDomNode.className = "sticky-widget-line-numbers", this._lineNumbersDomNode.setAttribute("role", "none"), this._linesDomNode.className = "sticky-widget-lines", this._linesDomNode.setAttribute("role", "list"), this._linesDomNodeScrollable.className = "sticky-widget-lines-scrollable", this._linesDomNodeScrollable.appendChild(this._linesDomNode), this._rootDomNode.className = "sticky-widget", this._rootDomNode.classList.toggle("peek", e instanceof Mc), this._rootDomNode.appendChild(this._lineNumbersDomNode), this._rootDomNode.appendChild(this._linesDomNodeScrollable);
    const t = () => {
      this._linesDomNode.style.left = this._editor.getOption(115).scrollWithEditor ? `-${this._editor.getScrollLeft()}px` : "0px";
    };
    this._register(this._editor.onDidChangeConfiguration(((i) => {
      i.hasChanged(115) && t(), i.hasChanged(67) && (this._lineHeight = this._editor.getOption(67));
    }))), this._register(this._editor.onDidScrollChange(((i) => {
      i.scrollLeftChanged && t(), i.scrollWidthChanged && this._updateWidgetWidth();
    }))), this._register(this._editor.onDidChangeModel((() => {
      t(), this._updateWidgetWidth();
    }))), this._register(this._foldingIconStore), t(), this._register(this._editor.onDidLayoutChange(((i) => {
      this._updateWidgetWidth();
    }))), this._updateWidgetWidth();
  }
  get lineNumbers() {
    return this._lineNumbers;
  }
  get lineNumberCount() {
    return this._lineNumbers.length;
  }
  getRenderedStickyLine(e) {
    return this._renderedStickyLines.find(((t) => t.lineNumber === e));
  }
  getCurrentLines() {
    return this._lineNumbers;
  }
  setState(e, t, i) {
    if (i === void 0 && (!this._previousState && !e || this._previousState && this._previousState.equals(e))) return;
    const s = this._isWidgetHeightZero(e), o = s ? void 0 : e, r = s ? 0 : this._findLineToRebuildWidgetFrom(e, i);
    this._renderRootNode(o, t, r), this._previousState = e;
  }
  _isWidgetHeightZero(e) {
    if (!e) return !0;
    const t = e.startLineNumbers.length * this._lineHeight + e.lastLineRelativePosition;
    if (t > 0) {
      this._lastLineRelativePosition = e.lastLineRelativePosition;
      const i = [...e.startLineNumbers];
      e.showEndForLine !== null && (i[e.showEndForLine] = e.endLineNumbers[e.showEndForLine]), this._lineNumbers = i;
    } else this._lastLineRelativePosition = 0, this._lineNumbers = [];
    return t === 0;
  }
  _findLineToRebuildWidgetFrom(e, t) {
    if (!e || !this._previousState) return 0;
    if (t !== void 0) return t;
    const i = this._previousState, s = e.startLineNumbers.findIndex(((o) => !i.startLineNumbers.includes(o)));
    return s === -1 ? 0 : s;
  }
  _updateWidgetWidth() {
    const e = this._editor.getLayoutInfo(), t = e.contentLeft;
    this._lineNumbersDomNode.style.width = `${t}px`, this._linesDomNodeScrollable.style.setProperty("--vscode-editorStickyScroll-scrollableWidth", this._editor.getScrollWidth() - e.verticalScrollbarWidth + "px"), this._rootDomNode.style.width = e.width - e.verticalScrollbarWidth + "px";
  }
  _clearStickyLinesFromLine(e) {
    this._foldingIconStore.clear();
    for (let t = e; t < this._renderedStickyLines.length; t++) {
      const i = this._renderedStickyLines[t];
      i.lineNumberDomNode.remove(), i.lineDomNode.remove();
    }
    this._renderedStickyLines = this._renderedStickyLines.slice(0, e), this._rootDomNode.style.display = "none";
  }
  _useFoldingOpacityTransition(e) {
    this._lineNumbersDomNode.style.setProperty("--vscode-editorStickyScroll-foldingOpacityTransition", `opacity ${e ? 0.5 : 0}s`);
  }
  _setFoldingIconsVisibility(e) {
    for (const t of this._renderedStickyLines) {
      const i = t.foldingIcon;
      i && i.setVisible(!!e || i.isCollapsed);
    }
  }
  async _renderRootNode(e, t, i) {
    if (this._clearStickyLinesFromLine(i), !e) return;
    for (const a of this._renderedStickyLines) this._updateTopAndZIndexOfStickyLine(a);
    const s = this._editor.getLayoutInfo(), o = this._lineNumbers.slice(i);
    for (const [a, l] of o.entries()) {
      const d = this._renderChildNode(a + i, l, t, s);
      d && (this._linesDomNode.appendChild(d.lineDomNode), this._lineNumbersDomNode.appendChild(d.lineNumberDomNode), this._renderedStickyLines.push(d));
    }
    t && (this._setFoldingHoverListeners(), this._useFoldingOpacityTransition(!this._isOnGlyphMargin));
    const r = this._lineNumbers.length * this._lineHeight + this._lastLineRelativePosition;
    this._rootDomNode.style.display = "block", this._lineNumbersDomNode.style.height = `${r}px`, this._linesDomNodeScrollable.style.height = `${r}px`, this._rootDomNode.style.height = `${r}px`, this._rootDomNode.style.marginLeft = "0px", this._minContentWidthInPx = Math.max(...this._renderedStickyLines.map(((a) => a.scrollWidth))) + s.verticalScrollbarWidth, this._editor.layoutOverlayWidget(this);
  }
  _setFoldingHoverListeners() {
    this._editor.getOption(110) === "mouseover" && (this._foldingIconStore.add(K(this._lineNumbersDomNode, ie.MOUSE_ENTER, (() => {
      this._isOnGlyphMargin = !0, this._setFoldingIconsVisibility(!0);
    }))), this._foldingIconStore.add(K(this._lineNumbersDomNode, ie.MOUSE_LEAVE, (() => {
      this._isOnGlyphMargin = !1, this._useFoldingOpacityTransition(!0), this._setFoldingIconsVisibility(!1);
    }))));
  }
  _renderChildNode(e, t, i, s) {
    const o = this._editor._getViewModel();
    if (!o) return;
    const r = o.coordinatesConverter.convertModelPositionToViewPosition(new W(t, 1)).lineNumber, a = o.getViewLineRenderingData(r), l = this._editor.getOption(68);
    let d;
    try {
      d = _s.filter(a.inlineDecorations, r, a.minColumn, a.maxColumn);
    } catch {
      d = [];
    }
    const h = new Sc(!0, !0, a.content, a.continuesWithWrappedLine, a.isBasicASCII, a.containsRTL, 0, a.tokens, d, a.tabSize, a.startVisibleColumn, 1, 1, 1, 500, "none", !0, !0, null), c = new pf(2e3), u = C1(h, c);
    let g;
    g = z9 ? z9.createHTML(c.build()) : c.build();
    const p = document.createElement("span");
    p.setAttribute(oN, String(e)), p.setAttribute(U9, ""), p.setAttribute("role", "listitem"), p.tabIndex = 0, p.className = "sticky-line-content", p.classList.add(`stickyLine${t}`), p.style.lineHeight = `${this._lineHeight}px`, p.innerHTML = g;
    const f = document.createElement("span");
    f.setAttribute(oN, String(e)), f.setAttribute("data-sticky-is-line-number", ""), f.className = "sticky-line-number", f.style.lineHeight = `${this._lineHeight}px`;
    const _ = s.contentLeft;
    f.style.width = `${_}px`;
    const v = document.createElement("span");
    l.renderType === 1 || l.renderType === 3 && t % 10 == 0 ? v.innerText = t.toString() : l.renderType === 2 && (v.innerText = Math.abs(t - this._editor.getPosition().lineNumber).toString()), v.className = "sticky-line-number-inner", v.style.lineHeight = `${this._lineHeight}px`, v.style.width = `${s.lineNumbersWidth}px`, v.style.paddingLeft = `${s.lineNumbersLeft}px`, f.appendChild(v);
    const b = this._renderFoldingIconForLine(i, t);
    b && f.appendChild(b.domNode), this._editor.applyFontInfo(p), this._editor.applyFontInfo(v), f.style.lineHeight = `${this._lineHeight}px`, p.style.lineHeight = `${this._lineHeight}px`, f.style.height = `${this._lineHeight}px`, p.style.height = `${this._lineHeight}px`;
    const C = new yhe(e, t, p, f, b, u.characterMapping, p.scrollWidth);
    return this._updateTopAndZIndexOfStickyLine(C);
  }
  _updateTopAndZIndexOfStickyLine(e) {
    var t;
    const i = e.index, s = e.lineDomNode, o = e.lineNumberDomNode, r = i === this._lineNumbers.length - 1;
    s.style.zIndex = r ? "0" : "1", o.style.zIndex = r ? "0" : "1";
    const a = `${i * this._lineHeight + this._lastLineRelativePosition + (!((t = e.foldingIcon) === null || t === void 0) && t.isCollapsed ? 1 : 0)}px`, l = i * this._lineHeight + "px";
    return s.style.top = r ? a : l, o.style.top = r ? a : l, e;
  }
  _renderFoldingIconForLine(e, t) {
    const i = this._editor.getOption(110);
    if (!e || i === "never") return;
    const s = e.regions, o = s.findRange(t), r = s.getStartLineNumber(o);
    if (t !== r) return;
    const a = s.isCollapsed(o), l = new She(a, r, s.getEndLineNumber(o), this._lineHeight);
    return l.setVisible(!!this._isOnGlyphMargin || a || i === "always"), l.domNode.setAttribute(K9, ""), l;
  }
  getId() {
    return "editor.contrib.stickyScrollWidget";
  }
  getDomNode() {
    return this._rootDomNode;
  }
  getPosition() {
    return { preference: null };
  }
  getMinContentWidthInPx() {
    return this._minContentWidthInPx;
  }
  focusLineWithIndex(e) {
    0 <= e && e < this._renderedStickyLines.length && this._renderedStickyLines[e].lineDomNode.focus();
  }
  getEditorPositionFromNode(e) {
    if (!e || e.children.length > 0) return null;
    const t = this._getRenderedStickyLineFromChildDomNode(e);
    if (!t) return null;
    const i = VR(t.characterMapping, e, 0);
    return new W(t.lineNumber, i);
  }
  getLineNumberFromChildDomNode(e) {
    var t, i;
    return (i = (t = this._getRenderedStickyLineFromChildDomNode(e)) === null || t === void 0 ? void 0 : t.lineNumber) !== null && i !== void 0 ? i : null;
  }
  _getRenderedStickyLineFromChildDomNode(e) {
    const t = this.getLineIndexFromChildDomNode(e);
    return t === null || t < 0 || t >= this._renderedStickyLines.length ? null : this._renderedStickyLines[t];
  }
  getLineIndexFromChildDomNode(e) {
    const t = this._getAttributeValue(e, oN);
    return t ? parseInt(t, 10) : null;
  }
  isInStickyLine(e) {
    return this._getAttributeValue(e, U9) !== void 0;
  }
  isInFoldingIconDomNode(e) {
    return this._getAttributeValue(e, K9) !== void 0;
  }
  _getAttributeValue(e, t) {
    for (; e && e !== this._rootDomNode; ) {
      const i = e.getAttribute(t);
      if (i !== null) return i;
      e = e.parentElement;
    }
  }
}
class yhe {
  constructor(e, t, i, s, o, r, a) {
    this.index = e, this.lineNumber = t, this.lineDomNode = i, this.lineNumberDomNode = s, this.foldingIcon = o, this.characterMapping = r, this.scrollWidth = a;
  }
}
class She {
  constructor(e, t, i, s) {
    this.isCollapsed = e, this.foldingStartLine = t, this.foldingEndLine = i, this.dimension = s, this.domNode = document.createElement("div"), this.domNode.style.width = `${s}px`, this.domNode.style.height = `${s}px`, this.domNode.className = Ee.asClassName(e ? CS : bS);
  }
  setVisible(e) {
    this.domNode.style.cursor = e ? "pointer" : "default", this.domNode.style.opacity = e ? "1" : "0";
  }
}
class O0 {
  constructor(e, t) {
    this.startLineNumber = e, this.endLineNumber = t;
  }
}
class NS {
  constructor(e, t, i) {
    this.range = e, this.children = t, this.parent = i;
  }
}
class vU {
  constructor(e, t, i, s) {
    this.uri = e, this.version = t, this.element = i, this.outlineProviderId = s;
  }
}
var F0, Yh, Ck = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, l1 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
(function(n) {
  n.OUTLINE_MODEL = "outlineModel", n.FOLDING_PROVIDER_MODEL = "foldingProviderModel", n.INDENTATION_MODEL = "indentationModel";
})(F0 || (F0 = {})), (function(n) {
  n[n.VALID = 0] = "VALID", n[n.INVALID = 1] = "INVALID", n[n.CANCELED = 2] = "CANCELED";
})(Yh || (Yh = {}));
let ST = class extends V {
  constructor(n, e, t, i) {
    switch (super(), this._editor = n, this._languageConfigurationService = t, this._languageFeaturesService = i, this._modelProviders = [], this._modelPromise = null, this._updateScheduler = this._register(new Sr(300)), this._updateOperation = this._register(new G()), this._editor.getOption(115).defaultModel) {
      case F0.OUTLINE_MODEL:
        this._modelProviders.push(new LT(this._editor, i));
      case F0.FOLDING_PROVIDER_MODEL:
        this._modelProviders.push(new DT(this._editor, e, i));
      case F0.INDENTATION_MODEL:
        this._modelProviders.push(new kT(this._editor, t));
    }
  }
  dispose() {
    this._modelProviders.forEach(((n) => n.dispose())), this._updateOperation.clear(), this._cancelModelPromise(), super.dispose();
  }
  _cancelModelPromise() {
    this._modelPromise && (this._modelPromise.cancel(), this._modelPromise = null);
  }
  async update(n) {
    return this._updateOperation.clear(), this._updateOperation.add({ dispose: () => {
      this._cancelModelPromise(), this._updateScheduler.cancel();
    } }), this._cancelModelPromise(), await this._updateScheduler.trigger((async () => {
      for (const e of this._modelProviders) {
        const { statusPromise: t, modelPromise: i } = e.computeStickyModel(n);
        this._modelPromise = i;
        const s = await t;
        if (this._modelPromise !== i) return null;
        switch (s) {
          case Yh.CANCELED:
            return this._updateOperation.clear(), null;
          case Yh.VALID:
            return e.stickyModel;
        }
      }
      return null;
    })).catch(((e) => (We(e), null)));
  }
};
ST = Ck([l1(2, Se), l1(3, fe)], ST);
class bU extends V {
  constructor(e) {
    super(), this._editor = e, this._stickyModel = null;
  }
  get stickyModel() {
    return this._stickyModel;
  }
  _invalid() {
    return this._stickyModel = null, Yh.INVALID;
  }
  computeStickyModel(e) {
    if (e.isCancellationRequested || !this.isProviderValid()) return { statusPromise: this._invalid(), modelPromise: null };
    const t = on(((i) => this.createModelFromProvider(i)));
    return { statusPromise: t.then(((i) => this.isModelValid(i) ? e.isCancellationRequested ? Yh.CANCELED : (this._stickyModel = this.createStickyModel(e, i), Yh.VALID) : this._invalid())).then(void 0, ((i) => (We(i), Yh.CANCELED))), modelPromise: t };
  }
  isModelValid(e) {
    return !0;
  }
  isProviderValid() {
    return !0;
  }
}
let LT = class extends bU {
  constructor(n, e) {
    super(n), this._languageFeaturesService = e;
  }
  createModelFromProvider(n) {
    return Zl.create(this._languageFeaturesService.documentSymbolProvider, this._editor.getModel(), n);
  }
  createStickyModel(n, e) {
    var t;
    const { stickyOutlineElement: i, providerID: s } = this._stickyModelFromOutlineModel(e, (t = this._stickyModel) === null || t === void 0 ? void 0 : t.outlineProviderId), o = this._editor.getModel();
    return new vU(o.uri, o.getVersionId(), i, s);
  }
  isModelValid(n) {
    return n && n.children.size > 0;
  }
  _stickyModelFromOutlineModel(n, e) {
    let t;
    if (at.first(n.children.values()) instanceof $z) {
      const o = at.find(n.children.values(), ((r) => r.id === e));
      if (o) t = o.children;
      else {
        let r, a = "", l = -1;
        for (const [d, h] of n.children.entries()) {
          const c = this._findSumOfRangesOfGroup(h);
          c > l && (r = h, l = c, a = h.id);
        }
        e = a, t = r.children;
      }
    } else t = n.children;
    const i = [], s = Array.from(t.values()).sort(((o, r) => {
      const a = new O0(o.symbol.range.startLineNumber, o.symbol.range.endLineNumber), l = new O0(r.symbol.range.startLineNumber, r.symbol.range.endLineNumber);
      return this._comparator(a, l);
    }));
    for (const o of s) i.push(this._stickyModelFromOutlineElement(o, o.symbol.selectionRange.startLineNumber));
    return { stickyOutlineElement: new NS(void 0, i, void 0), providerID: e };
  }
  _stickyModelFromOutlineElement(n, e) {
    const t = [];
    for (const s of n.children.values()) if (s.symbol.selectionRange.startLineNumber !== s.symbol.range.endLineNumber) if (s.symbol.selectionRange.startLineNumber !== e) t.push(this._stickyModelFromOutlineElement(s, s.symbol.selectionRange.startLineNumber));
    else for (const o of s.children.values()) t.push(this._stickyModelFromOutlineElement(o, s.symbol.selectionRange.startLineNumber));
    t.sort(((s, o) => this._comparator(s.range, o.range)));
    const i = new O0(n.symbol.selectionRange.startLineNumber, n.symbol.range.endLineNumber);
    return new NS(i, t, void 0);
  }
  _comparator(n, e) {
    return n.startLineNumber !== e.startLineNumber ? n.startLineNumber - e.startLineNumber : e.endLineNumber - n.endLineNumber;
  }
  _findSumOfRangesOfGroup(n) {
    let e = 0;
    for (const t of n.children.values()) e += this._findSumOfRangesOfGroup(t);
    return n instanceof ZM ? e + n.symbol.range.endLineNumber - n.symbol.selectionRange.startLineNumber : e;
  }
};
LT = Ck([l1(1, fe)], LT);
class CU extends bU {
  constructor(e) {
    super(e), this._foldingLimitReporter = new jz(e);
  }
  createStickyModel(e, t) {
    const i = this._fromFoldingRegions(t), s = this._editor.getModel();
    return new vU(s.uri, s.getVersionId(), i, void 0);
  }
  isModelValid(e) {
    return e !== null;
  }
  _fromFoldingRegions(e) {
    const t = e.length, i = [], s = new NS(void 0, [], void 0);
    for (let o = 0; o < t; o++) {
      const r = e.getParentIndex(o);
      let a;
      a = r !== -1 ? i[r] : s;
      const l = new NS(new O0(e.getStartLineNumber(o), e.getEndLineNumber(o) + 1), [], a);
      a.children.push(l), i.push(l);
    }
    return s;
  }
}
let kT = class extends CU {
  constructor(n, e) {
    super(n), this._languageConfigurationService = e, this.provider = this._register(new DP(n.getModel(), this._languageConfigurationService, this._foldingLimitReporter));
  }
  async createModelFromProvider(n) {
    return this.provider.compute(n);
  }
};
kT = Ck([l1(1, zt)], kT);
let DT = class extends CU {
  constructor(n, e, t) {
    super(n), this._languageFeaturesService = t;
    const i = Id.getFoldingRangeProviders(this._languageFeaturesService, n.getModel());
    i.length > 0 && (this.provider = this._register(new xP(n.getModel(), i, e, this._foldingLimitReporter, void 0)));
  }
  isProviderValid() {
    return this.provider !== void 0;
  }
  async createModelFromProvider(n) {
    var e, t;
    return (t = (e = this.provider) === null || e === void 0 ? void 0 : e.compute(n)) !== null && t !== void 0 ? t : null;
  }
};
DT = Ck([l1(2, fe)], DT);
var Lhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, j9 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class khe {
  constructor(e, t, i) {
    this.startLineNumber = e, this.endLineNumber = t, this.nestingDepth = i;
  }
}
let xT = class extends V {
  constructor(n, e, t) {
    super(), this._languageFeaturesService = e, this._languageConfigurationService = t, this._onDidChangeStickyScroll = this._register(new F()), this.onDidChangeStickyScroll = this._onDidChangeStickyScroll.event, this._model = null, this._cts = null, this._stickyModelProvider = null, this._editor = n, this._sessionStore = this._register(new G()), this._updateSoon = this._register(new Et((() => this.update()), 50)), this._register(this._editor.onDidChangeConfiguration(((i) => {
      i.hasChanged(115) && this.readConfiguration();
    }))), this.readConfiguration();
  }
  readConfiguration() {
    this._sessionStore.clear(), this._editor.getOption(115).enabled && (this._sessionStore.add(this._editor.onDidChangeModel((() => {
      this._model = null, this.updateStickyModelProvider(), this._onDidChangeStickyScroll.fire(), this.update();
    }))), this._sessionStore.add(this._editor.onDidChangeHiddenAreas((() => this.update()))), this._sessionStore.add(this._editor.onDidChangeModelContent((() => this._updateSoon.schedule()))), this._sessionStore.add(this._languageFeaturesService.documentSymbolProvider.onDidChange((() => this.update()))), this._sessionStore.add(ye((() => {
      var n;
      (n = this._stickyModelProvider) === null || n === void 0 || n.dispose(), this._stickyModelProvider = null;
    }))), this.updateStickyModelProvider(), this.update());
  }
  getVersionId() {
    var n;
    return (n = this._model) === null || n === void 0 ? void 0 : n.version;
  }
  updateStickyModelProvider() {
    var n;
    (n = this._stickyModelProvider) === null || n === void 0 || n.dispose(), this._stickyModelProvider = null;
    const e = this._editor;
    e.hasModel() && (this._stickyModelProvider = new ST(e, (() => this._updateSoon.schedule()), this._languageConfigurationService, this._languageFeaturesService));
  }
  async update() {
    var n;
    (n = this._cts) === null || n === void 0 || n.dispose(!0), this._cts = new Ci(), await this.updateStickyModel(this._cts.token), this._onDidChangeStickyScroll.fire();
  }
  async updateStickyModel(n) {
    if (!this._editor.hasModel() || !this._stickyModelProvider || this._editor.getModel().isTooLargeForTokenization()) return void (this._model = null);
    const e = await this._stickyModelProvider.update(n);
    n.isCancellationRequested || (this._model = e);
  }
  updateIndex(n) {
    return n === -1 ? n = 0 : n < 0 && (n = -n - 2), n;
  }
  getCandidateStickyLinesIntersectingFromStickyModel(n, e, t, i, s) {
    if (e.children.length === 0) return;
    let o = s;
    const r = [];
    for (let d = 0; d < e.children.length; d++) {
      const h = e.children[d];
      h.range && r.push(h.range.startLineNumber);
    }
    const a = this.updateIndex(H0(r, n.startLineNumber, ((d, h) => d - h))), l = this.updateIndex(H0(r, n.startLineNumber + i, ((d, h) => d - h)));
    for (let d = a; d <= l; d++) {
      const h = e.children[d];
      if (!h) return;
      if (h.range) {
        const c = h.range.startLineNumber, u = h.range.endLineNumber;
        n.startLineNumber <= u + 1 && c - 1 <= n.endLineNumber && c !== o && (o = c, t.push(new khe(c, u - 1, i + 1)), this.getCandidateStickyLinesIntersectingFromStickyModel(n, h, t, i + 1, c));
      } else this.getCandidateStickyLinesIntersectingFromStickyModel(n, h, t, i, s);
    }
  }
  getCandidateStickyLinesIntersecting(n) {
    var e, t;
    if (!(!((e = this._model) === null || e === void 0) && e.element)) return [];
    let i = [];
    this.getCandidateStickyLinesIntersectingFromStickyModel(n, this._model.element, i, 0, -1);
    const s = (t = this._editor._getViewModel()) === null || t === void 0 ? void 0 : t.getHiddenAreas();
    if (s) for (const o of s) i = i.filter(((r) => !(r.startLineNumber >= o.startLineNumber && r.endLineNumber <= o.endLineNumber + 1)));
    return i;
  }
};
xT = Lhe([j9(1, fe), j9(2, zt)], xT);
var NT, Dhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, hp = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Fa = NT = class extends V {
  constructor(n, e, t, i, s, o, r) {
    super(), this._editor = n, this._contextMenuService = e, this._languageFeaturesService = t, this._instaService = i, this._contextKeyService = r, this._sessionStore = new G(), this._foldingModel = null, this._maxStickyLines = Number.MAX_SAFE_INTEGER, this._candidateDefinitionsLength = -1, this._focusedStickyElementIndex = -1, this._enabled = !1, this._focused = !1, this._positionRevealed = !1, this._onMouseDown = !1, this._endLineNumbers = [], this._showEndForLine = null, this._stickyScrollWidget = new whe(this._editor), this._stickyLineCandidateProvider = new xT(this._editor, t, s), this._register(this._stickyScrollWidget), this._register(this._stickyLineCandidateProvider), this._widgetState = new H9([], [], 0), this._onDidResize(), this._readConfiguration();
    const a = this._stickyScrollWidget.getDomNode();
    this._register(this._editor.onDidChangeConfiguration(((d) => {
      (d.hasChanged(115) || d.hasChanged(73) || d.hasChanged(67) || d.hasChanged(110)) && this._readConfiguration();
    }))), this._register(K(a, ie.CONTEXT_MENU, (async (d) => {
      this._onContextMenu(ke(a), d);
    }))), this._stickyScrollFocusedContextKey = E.stickyScrollFocused.bindTo(this._contextKeyService), this._stickyScrollVisibleContextKey = E.stickyScrollVisible.bindTo(this._contextKeyService);
    const l = this._register(pa(a));
    this._register(l.onDidBlur(((d) => {
      this._positionRevealed === !1 && a.clientHeight === 0 ? (this._focusedStickyElementIndex = -1, this.focus()) : this._disposeFocusStickyScrollStore();
    }))), this._register(l.onDidFocus(((d) => {
      this.focus();
    }))), this._registerMouseListeners(), this._register(K(a, ie.MOUSE_DOWN, ((d) => {
      this._onMouseDown = !0;
    })));
  }
  static get(n) {
    return n.getContribution(NT.ID);
  }
  _disposeFocusStickyScrollStore() {
    var n;
    this._stickyScrollFocusedContextKey.set(!1), (n = this._focusDisposableStore) === null || n === void 0 || n.dispose(), this._focused = !1, this._positionRevealed = !1, this._onMouseDown = !1;
  }
  focus() {
    if (this._onMouseDown) return this._onMouseDown = !1, void this._editor.focus();
    this._stickyScrollFocusedContextKey.get() !== !0 && (this._focused = !0, this._focusDisposableStore = new G(), this._stickyScrollFocusedContextKey.set(!0), this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumbers.length - 1, this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex));
  }
  focusNext() {
    this._focusedStickyElementIndex < this._stickyScrollWidget.lineNumberCount - 1 && this._focusNav(!0);
  }
  focusPrevious() {
    this._focusedStickyElementIndex > 0 && this._focusNav(!1);
  }
  selectEditor() {
    this._editor.focus();
  }
  _focusNav(n) {
    this._focusedStickyElementIndex = n ? this._focusedStickyElementIndex + 1 : this._focusedStickyElementIndex - 1, this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex);
  }
  goToFocused() {
    const n = this._stickyScrollWidget.lineNumbers;
    this._disposeFocusStickyScrollStore(), this._revealPosition({ lineNumber: n[this._focusedStickyElementIndex], column: 1 });
  }
  _revealPosition(n) {
    this._reveaInEditor(n, (() => this._editor.revealPosition(n)));
  }
  _revealLineInCenterIfOutsideViewport(n) {
    this._reveaInEditor(n, (() => this._editor.revealLineInCenterIfOutsideViewport(n.lineNumber, 0)));
  }
  _reveaInEditor(n, e) {
    this._focused && this._disposeFocusStickyScrollStore(), this._positionRevealed = !0, e(), this._editor.setSelection(D.fromPositions(n)), this._editor.focus();
  }
  _registerMouseListeners() {
    const n = this._register(new G()), e = this._register(new XL(this._editor, { extractLineNumberFromMouseEvent: (s) => {
      const o = this._stickyScrollWidget.getEditorPositionFromNode(s.target.element);
      return o ? o.lineNumber : 0;
    } })), t = (s) => {
      if (!this._editor.hasModel() || s.target.type !== 12 || s.target.detail !== this._stickyScrollWidget.getId()) return null;
      const o = s.target.element;
      if (!o || o.innerText !== o.innerHTML) return null;
      const r = this._stickyScrollWidget.getEditorPositionFromNode(o);
      return r ? { range: new D(r.lineNumber, r.column, r.lineNumber, r.column + o.innerText.length), textElement: o } : null;
    }, i = this._stickyScrollWidget.getDomNode();
    this._register(bi(i, ie.CLICK, ((s) => {
      if (s.ctrlKey || s.altKey || s.metaKey || !s.leftButton) return;
      if (s.shiftKey) {
        const r = this._stickyScrollWidget.getLineIndexFromChildDomNode(s.target);
        if (r === null) return;
        const a = new W(this._endLineNumbers[r], 1);
        return void this._revealLineInCenterIfOutsideViewport(a);
      }
      if (this._stickyScrollWidget.isInFoldingIconDomNode(s.target)) {
        const r = this._stickyScrollWidget.getLineNumberFromChildDomNode(s.target);
        return void this._toggleFoldingRegionForLine(r);
      }
      if (!this._stickyScrollWidget.isInStickyLine(s.target)) return;
      let o = this._stickyScrollWidget.getEditorPositionFromNode(s.target);
      if (!o) {
        const r = this._stickyScrollWidget.getLineNumberFromChildDomNode(s.target);
        if (r === null) return;
        o = new W(r, 1);
      }
      this._revealPosition(o);
    }))), this._register(bi(i, ie.MOUSE_MOVE, ((s) => {
      if (s.shiftKey) {
        const o = this._stickyScrollWidget.getLineIndexFromChildDomNode(s.target);
        return o === null || this._showEndForLine !== null && this._showEndForLine === o ? void 0 : (this._showEndForLine = o, void this._renderStickyScroll());
      }
      this._showEndForLine !== null && (this._showEndForLine = null, this._renderStickyScroll());
    }))), this._register(K(i, ie.MOUSE_LEAVE, ((s) => {
      this._showEndForLine !== null && (this._showEndForLine = null, this._renderStickyScroll());
    }))), this._register(e.onMouseMoveOrRelevantKeyDown((([s, o]) => {
      const r = t(s);
      if (!r || !s.hasTriggerModifier || !this._editor.hasModel()) return void n.clear();
      const { range: a, textElement: l } = r;
      if (a.equalsRange(this._stickyRangeProjectedOnEditor)) {
        if (l.style.textDecoration === "underline") return;
      } else this._stickyRangeProjectedOnEditor = a, n.clear();
      const d = new Ci();
      let h;
      n.add(ye((() => d.dispose(!0)))), ik(this._languageFeaturesService.definitionProvider, this._editor.getModel(), new W(a.startLineNumber, a.startColumn + 1), d.token).then(((c) => {
        if (!d.token.isCancellationRequested) if (c.length !== 0) {
          this._candidateDefinitionsLength = c.length;
          const u = l;
          h !== u ? (n.clear(), h = u, h.style.textDecoration = "underline", n.add(ye((() => {
            h.style.textDecoration = "none";
          })))) : h || (h = u, h.style.textDecoration = "underline", n.add(ye((() => {
            h.style.textDecoration = "none";
          }))));
        } else n.clear();
      }));
    }))), this._register(e.onCancel((() => {
      n.clear();
    }))), this._register(e.onExecute((async (s) => {
      if (s.target.type !== 12 || s.target.detail !== this._stickyScrollWidget.getId()) return;
      const o = this._stickyScrollWidget.getEditorPositionFromNode(s.target.element);
      o && this._editor.hasModel() && this._stickyRangeProjectedOnEditor && (this._candidateDefinitionsLength > 1 && (this._focused && this._disposeFocusStickyScrollStore(), this._revealPosition({ lineNumber: o.lineNumber, column: 1 })), this._instaService.invokeFunction(sU, s, this._editor, { uri: this._editor.getModel().uri, range: this._stickyRangeProjectedOnEditor }));
    })));
  }
  _onContextMenu(n, e) {
    const t = new _r(n, e);
    this._contextMenuService.showContextMenu({ menuId: x.StickyScrollContext, getAnchor: () => t });
  }
  _toggleFoldingRegionForLine(n) {
    if (!this._foldingModel || n === null) return;
    const e = this._stickyScrollWidget.getRenderedStickyLine(n), t = e?.foldingIcon;
    if (!t) return;
    Kz(this._foldingModel, Number.MAX_VALUE, [n]), t.isCollapsed = !t.isCollapsed;
    const i = (t.isCollapsed ? this._editor.getTopForLineNumber(t.foldingEndLine) : this._editor.getTopForLineNumber(t.foldingStartLine)) - this._editor.getOption(67) * e.index + 1;
    this._editor.setScrollTop(i), this._renderStickyScroll(n);
  }
  _readConfiguration() {
    const n = this._editor.getOption(115);
    if (n.enabled === !1) return this._editor.removeOverlayWidget(this._stickyScrollWidget), this._sessionStore.clear(), void (this._enabled = !1);
    n.enabled && !this._enabled && (this._editor.addOverlayWidget(this._stickyScrollWidget), this._sessionStore.add(this._editor.onDidScrollChange(((e) => {
      e.scrollTopChanged && (this._showEndForLine = null, this._renderStickyScroll());
    }))), this._sessionStore.add(this._editor.onDidLayoutChange((() => this._onDidResize()))), this._sessionStore.add(this._editor.onDidChangeModelTokens(((e) => this._onTokensChange(e)))), this._sessionStore.add(this._stickyLineCandidateProvider.onDidChangeStickyScroll((() => {
      this._showEndForLine = null, this._renderStickyScroll();
    }))), this._enabled = !0), this._editor.getOption(68).renderType === 2 && this._sessionStore.add(this._editor.onDidChangeCursorPosition((() => {
      this._showEndForLine = null, this._renderStickyScroll(0);
    })));
  }
  _needsUpdate(n) {
    const e = this._stickyScrollWidget.getCurrentLines();
    for (const t of e) for (const i of n.ranges) if (t >= i.fromLineNumber && t <= i.toLineNumber) return !0;
    return !1;
  }
  _onTokensChange(n) {
    this._needsUpdate(n) && this._renderStickyScroll(0);
  }
  _onDidResize() {
    const n = this._editor.getLayoutInfo().height / this._editor.getOption(67);
    this._maxStickyLines = Math.round(0.25 * n);
  }
  async _renderStickyScroll(n) {
    var e, t;
    const i = this._editor.getModel();
    if (!i || i.isTooLargeForTokenization()) return this._foldingModel = null, void this._stickyScrollWidget.setState(void 0, null);
    const s = this._stickyLineCandidateProvider.getVersionId();
    if (s === void 0 || s === i.getVersionId()) if (this._foldingModel = (t = await ((e = Id.get(this._editor)) === null || e === void 0 ? void 0 : e.getFoldingModel())) !== null && t !== void 0 ? t : null, this._widgetState = this.findScrollWidgetState(), this._stickyScrollVisibleContextKey.set(this._widgetState.startLineNumbers.length !== 0), this._focused) if (this._focusedStickyElementIndex === -1) this._stickyScrollWidget.setState(this._widgetState, this._foldingModel, n), this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumberCount - 1, this._focusedStickyElementIndex !== -1 && this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex);
    else {
      const o = this._stickyScrollWidget.lineNumbers[this._focusedStickyElementIndex];
      this._stickyScrollWidget.setState(this._widgetState, this._foldingModel, n), this._stickyScrollWidget.lineNumberCount === 0 ? this._focusedStickyElementIndex = -1 : (this._stickyScrollWidget.lineNumbers.includes(o) || (this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumberCount - 1), this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex));
    }
    else this._stickyScrollWidget.setState(this._widgetState, this._foldingModel, n);
  }
  findScrollWidgetState() {
    const n = this._editor.getOption(67), e = Math.min(this._maxStickyLines, this._editor.getOption(115).maxLineCount), t = this._editor.getScrollTop();
    let i = 0;
    const s = [], o = [], r = this._editor.getVisibleRanges();
    if (r.length !== 0) {
      const a = new O0(r[0].startLineNumber, r[r.length - 1].endLineNumber), l = this._stickyLineCandidateProvider.getCandidateStickyLinesIntersecting(a);
      for (const d of l) {
        const h = d.startLineNumber, c = d.endLineNumber, u = d.nestingDepth;
        if (c - h > 0) {
          const g = (u - 1) * n, p = u * n, f = this._editor.getBottomForLineNumber(h) - t, _ = this._editor.getTopForLineNumber(c) - t, v = this._editor.getBottomForLineNumber(c) - t;
          if (g > _ && g <= v) {
            s.push(h), o.push(c + 1), i = v - p;
            break;
          }
          if (p > f && p <= v && (s.push(h), o.push(c + 1)), s.length === e) break;
        }
      }
    }
    return this._endLineNumbers = o, new H9(s, o, i, this._showEndForLine);
  }
  dispose() {
    super.dispose(), this._sessionStore.dispose();
  }
};
Fa.ID = "store.contrib.stickyScrollController", Fa = NT = Dhe([hp(1, io), hp(2, fe), hp(3, Se), hp(4, zt), hp(5, ar), hp(6, Te)], Fa);
const yC = 100;
ft(Fa.ID, Fa, 1), Ft(class extends cs {
  constructor() {
    super({ id: "editor.action.toggleStickyScroll", title: { ...ct(0, "Toggle Editor Sticky Scroll"), mnemonicTitle: m(0, "&&Toggle Editor Sticky Scroll") }, category: Che.View, toggled: { condition: q.equals("config.editor.stickyScroll.enabled", !0), title: m(0, "Sticky Scroll"), mnemonicTitle: m(0, "&&Sticky Scroll") }, menu: [{ id: x.CommandPalette }, { id: x.MenubarAppearanceMenu, group: "4_editor", order: 3 }, { id: x.StickyScrollContext }] });
  }
  async run(n) {
    const e = n.get(Ye), t = !e.getValue("editor.stickyScroll.enabled");
    return e.updateValue("editor.stickyScroll.enabled", t);
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.focusStickyScroll", title: { ...ct(0, "Focus Sticky Scroll"), mnemonicTitle: m(0, "&&Focus Sticky Scroll") }, precondition: q.and(q.has("config.editor.stickyScroll.enabled"), E.stickyScrollVisible), menu: [{ id: x.CommandPalette }] });
  }
  runEditorCommand(n, e) {
    var t;
    (t = Fa.get(e)) === null || t === void 0 || t.focus();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.selectPreviousStickyScrollLine", title: ct(0, "Select previous sticky scroll line"), precondition: E.stickyScrollFocused.isEqualTo(!0), keybinding: { weight: yC, primary: 16 } });
  }
  runEditorCommand(n, e) {
    var t;
    (t = Fa.get(e)) === null || t === void 0 || t.focusPrevious();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.selectNextStickyScrollLine", title: ct(0, "Select next sticky scroll line"), precondition: E.stickyScrollFocused.isEqualTo(!0), keybinding: { weight: yC, primary: 18 } });
  }
  runEditorCommand(n, e) {
    var t;
    (t = Fa.get(e)) === null || t === void 0 || t.focusNext();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.goToFocusedStickyScrollLine", title: ct(0, "Go to focused sticky scroll line"), precondition: E.stickyScrollFocused.isEqualTo(!0), keybinding: { weight: yC, primary: 3 } });
  }
  runEditorCommand(n, e) {
    var t;
    (t = Fa.get(e)) === null || t === void 0 || t.goToFocused();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.selectEditor", title: ct(0, "Select Editor"), precondition: E.stickyScrollFocused.isEqualTo(!0), keybinding: { weight: yC, primary: 9 } });
  }
  runEditorCommand(n, e) {
    var t;
    (t = Fa.get(e)) === null || t === void 0 || t.selectEditor();
  }
});
var wU = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, U_ = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
class xhe {
  constructor(e, t, i, s, o, r) {
    this.range = e, this.insertText = t, this.filterText = i, this.additionalTextEdits = s, this.command = o, this.completion = r;
  }
}
let ET = class extends iK {
  constructor(n, e, t, i, s, o) {
    super(s.disposable), this.model = n, this.line = e, this.word = t, this.completionModel = i, this._suggestMemoryService = o;
  }
  canBeReused(n, e, t) {
    return this.model === n && this.line === e && this.word.word.length > 0 && this.word.startColumn === t.startColumn && this.word.endColumn < t.endColumn && this.completionModel.getIncompleteProvider().size === 0;
  }
  get items() {
    var n;
    const e = [], { items: t } = this.completionModel, i = this._suggestMemoryService.select(this.model, { lineNumber: this.line, column: this.word.endColumn + this.completionModel.lineContext.characterCountDelta }, t), s = at.slice(t, i), o = at.slice(t, 0, i);
    let r = 5;
    for (const a of at.concat(s, o)) {
      if (a.score === la.Default) continue;
      const l = new D(a.editStart.lineNumber, a.editStart.column, a.editInsertEnd.lineNumber, a.editInsertEnd.column + this.completionModel.lineContext.characterCountDelta), d = a.completion.insertTextRules && 4 & a.completion.insertTextRules ? { snippet: a.completion.insertText } : a.completion.insertText;
      e.push(new xhe(l, d, (n = a.filterTextLow) !== null && n !== void 0 ? n : a.labelLow, a.completion.additionalTextEdits, a.completion.command, a)), r-- >= 0 && a.resolve(et.None);
    }
    return e;
  }
};
ET = wU([U_(5, ok)], ET);
let rN = class extends V {
  constructor(n, e, t, i) {
    super(), this._languageFeatureService = n, this._clipboardService = e, this._suggestMemoryService = t, this._editorService = i, this._store.add(n.inlineCompletionsProvider.register("*", this));
  }
  async provideInlineCompletions(n, e, t, i) {
    var s;
    if (t.selectedSuggestionInfo) return;
    let o;
    for (const g of this._editorService.listCodeEditors()) if (g.getModel() === n) {
      o = g;
      break;
    }
    if (!o) return;
    const r = o.getOption(89);
    if (qp.isAllOff(r)) return;
    n.tokenization.tokenizeIfCheap(e.lineNumber);
    const a = n.tokenization.getLineTokens(e.lineNumber), l = a.getStandardTokenType(a.findTokenIndexAtOffset(Math.max(e.column - 1 - 1, 0)));
    if (qp.valueFor(r, l) !== "inline") return;
    let d, h, c = n.getWordAtPosition(e);
    if (c?.word || (d = this._getTriggerCharacterInfo(n, e)), !c?.word && !d || (c || (c = n.getWordUntilPosition(e)), c.endColumn !== e.column)) return;
    const u = n.getValueInRange(new D(e.lineNumber, 1, e.lineNumber, e.column));
    if (!d && (!((s = this._lastResult) === null || s === void 0) && s.canBeReused(n, e.lineNumber, c))) {
      const g = new x9(u, e.column - this._lastResult.word.endColumn);
      this._lastResult.completionModel.lineContext = g, this._lastResult.acquire(), h = this._lastResult;
    } else {
      const g = await NP(this._languageFeatureService.completionProvider, n, e, new n1(void 0, kS.createSuggestFilter(o).itemKind, d?.providers), d && { triggerKind: 1, triggerCharacter: d.ch }, i);
      let p;
      g.needsClipboard && (p = await this._clipboardService.readText());
      const f = new Sh(g.items, e.column, new x9(u, 0), Yr.None, o.getOption(118), o.getOption(112), { boostFullMatch: !1, firstMatchCanBeWeak: !1 }, p);
      h = new ET(n, e.lineNumber, c, f, g, this._suggestMemoryService);
    }
    return this._lastResult = h, h;
  }
  handleItemDidShow(n, e) {
    e.completion.resolve(et.None);
  }
  freeInlineCompletions(n) {
    n.release();
  }
  _getTriggerCharacterInfo(n, e) {
    var t;
    const i = n.getValueInRange(D.fromPositions({ lineNumber: e.lineNumber, column: e.column - 1 }, e)), s = /* @__PURE__ */ new Set();
    for (const o of this._languageFeatureService.completionProvider.all(n)) !((t = o.triggerCharacters) === null || t === void 0) && t.includes(i) && s.add(o);
    if (s.size !== 0) return { providers: s, ch: i };
  }
};
rN = wU([U_(0, fe), U_(1, Kd), U_(2, ok), U_(3, mt)], rN), W1(rN);
X(class extends he {
  constructor() {
    super({ id: "editor.action.forceRetokenize", label: m(0, "Developer: Force Retokenize"), alias: "Developer: Force Retokenize", precondition: void 0 });
  }
  run(n, e) {
    if (!e.hasModel()) return;
    const t = e.getModel();
    t.tokenization.resetTokenization();
    const i = new Rn();
    t.tokenization.forceTokenization(t.getLineCount()), i.stop(), console.log(`tokenization took ${i.elapsed()}`);
  }
});
class ES extends cs {
  constructor() {
    super({ id: ES.ID, title: ct(0, "Toggle Tab Key Moves Focus"), precondition: void 0, keybinding: { primary: 2091, mac: { primary: 1323 }, weight: 100 }, f1: !0 });
  }
  run() {
    const e = !Hm.getTabFocusMode();
    Hm.setTabFocusMode(e), Io(m(0, e ? "Pressing Tab will now move focus to the next focusable element" : "Pressing Tab will now insert the tab character"));
  }
}
ES.ID = "editor.action.toggleTabFocusMode", Ft(ES);
var Nhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ehe = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let IT = class extends V {
  get enabled() {
    return this._enabled;
  }
  set enabled(n) {
    n ? (this.el.setAttribute("aria-disabled", "false"), this.el.tabIndex = 0, this.el.style.pointerEvents = "auto", this.el.style.opacity = "1", this.el.style.cursor = "pointer", this._enabled = !1) : (this.el.setAttribute("aria-disabled", "true"), this.el.tabIndex = -1, this.el.style.pointerEvents = "none", this.el.style.opacity = "0.4", this.el.style.cursor = "default", this._enabled = !0), this._enabled = n;
  }
  constructor(n, e, t = {}, i) {
    var s, o;
    super(), this._link = e, this._enabled = !0, this.el = Z(n, Q("a.monaco-link", { tabIndex: (s = e.tabIndex) !== null && s !== void 0 ? s : 0, href: e.href }, e.label)), this.hoverDelegate = (o = t.hoverDelegate) !== null && o !== void 0 ? o : Bs("mouse"), this.setTooltip(e.title), this.el.setAttribute("role", "button");
    const r = this._register(new st(this.el, "click")), a = this._register(new st(this.el, "keypress")), l = se.chain(a.event, ((c) => c.map(((u) => new jt(u))).filter(((u) => u.keyCode === 3)))), d = this._register(new st(this.el, Vt.Tap)).event;
    this._register(Bt.addTarget(this.el));
    const h = se.any(r.event, l, d);
    this._register(h(((c) => {
      this.enabled && (Ze(c, !0), t?.opener ? t.opener(this._link.href) : i.open(this._link.href, { allowCommands: !0 }));
    }))), this.enabled = !0;
  }
  setTooltip(n) {
    this.hoverDelegate.showNativeHover ? this.el.title = n ?? "" : !this.hover && n ? this.hover = this._register(xr(this.hoverDelegate, this.el, n)) : this.hover && this.hover.update(n);
  }
};
IT = Nhe([Ehe(3, Fs)], IT);
var yU = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, SU = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let MT = class extends V {
  constructor(n, e) {
    super(), this._editor = n, this.instantiationService = e, this.banner = this._register(this.instantiationService.createInstance(TT));
  }
  hide() {
    this._editor.setBanner(null, 0), this.banner.clear();
  }
  show(n) {
    this.banner.show({ ...n, onClose: () => {
      var e;
      this.hide(), (e = n.onClose) === null || e === void 0 || e.call(n);
    } }), this._editor.setBanner(this.banner.element, 26);
  }
};
MT = yU([SU(1, Se)], MT);
let TT = class extends V {
  constructor(n) {
    super(), this.instantiationService = n, this.markdownRenderer = this.instantiationService.createInstance(pl, {}), this.element = Q("div.editor-banner"), this.element.tabIndex = 0;
  }
  getAriaLabel(n) {
    return n.ariaLabel ? n.ariaLabel : typeof n.message == "string" ? n.message : void 0;
  }
  getBannerMessage(n) {
    if (typeof n == "string") {
      const e = Q("span");
      return e.innerText = n, e;
    }
    return this.markdownRenderer.render(n).element;
  }
  clear() {
    Un(this.element);
  }
  show(n) {
    Un(this.element);
    const e = this.getAriaLabel(n);
    e && this.element.setAttribute("aria-label", e);
    const t = Z(this.element, Q("div.icon-container"));
    t.setAttribute("aria-hidden", "true"), n.icon && t.appendChild(Q(`div${Ee.asCSSSelector(n.icon)}`));
    const i = Z(this.element, Q("div.message-container"));
    if (i.setAttribute("aria-hidden", "true"), i.appendChild(this.getBannerMessage(n.message)), this.messageActionsContainer = Z(this.element, Q("div.message-actions-container")), n.actions) for (const o of n.actions) this._register(this.instantiationService.createInstance(IT, this.messageActionsContainer, { ...o, tabIndex: -1 }, {}));
    const s = Z(this.element, Q("div.action-container"));
    this.actionBar = this._register(new sr(s)), this.actionBar.push(this._register(new Qs("banner.close", "Close Banner", Ee.asClassName(TV), !0, (() => {
      typeof n.onClose == "function" && n.onClose();
    }))), { icon: !0, label: !1 }), this.actionBar.setFocusable(!1);
  }
};
TT = yU([SU(0, Se)], TT);
var OP = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Em = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const Ihe = Ei("extensions-warning-message", ne.warning, m(0, "Icon shown with a warning message in the extensions editor."));
let Im = class extends V {
  constructor(n, e, t, i) {
    super(), this._editor = n, this._editorWorkerService = e, this._workspaceTrustService = t, this._highlighter = null, this._bannerClosed = !1, this._updateState = (s) => {
      if (s && s.hasMore) {
        if (this._bannerClosed) return;
        const o = Math.max(s.ambiguousCharacterCount, s.nonBasicAsciiCharacterCount, s.invisibleCharacterCount);
        let r;
        if (s.nonBasicAsciiCharacterCount >= o) r = { message: m(0, "This document contains many non-basic ASCII unicode characters"), command: new Lf() };
        else if (s.ambiguousCharacterCount >= o) r = { message: m(0, "This document contains many ambiguous unicode characters"), command: new Bc() };
        else {
          if (!(s.invisibleCharacterCount >= o)) throw new Error("Unreachable");
          r = { message: m(0, "This document contains many invisible unicode characters"), command: new Sf() };
        }
        this._bannerController.show({ id: "unicodeHighlightBanner", message: r.message, icon: Ihe, actions: [{ label: r.command.shortLabel, href: `command:${r.command.id}` }], onClose: () => {
          this._bannerClosed = !0;
        } });
      } else this._bannerController.hide();
    }, this._bannerController = this._register(i.createInstance(MT, n)), this._register(this._editor.onDidChangeModel((() => {
      this._bannerClosed = !1, this._updateHighlighter();
    }))), this._options = n.getOption(125), this._register(t.onDidChangeTrust(((s) => {
      this._updateHighlighter();
    }))), this._register(n.onDidChangeConfiguration(((s) => {
      s.hasChanged(125) && (this._options = n.getOption(125), this._updateHighlighter());
    }))), this._updateHighlighter();
  }
  dispose() {
    this._highlighter && (this._highlighter.dispose(), this._highlighter = null), super.dispose();
  }
  _updateHighlighter() {
    if (this._updateState(null), this._highlighter && (this._highlighter.dispose(), this._highlighter = null), !this._editor.hasModel()) return;
    const n = (function(t, i) {
      return { nonBasicASCII: i.nonBasicASCII === ro ? !t : i.nonBasicASCII, ambiguousCharacters: i.ambiguousCharacters, invisibleCharacters: i.invisibleCharacters, includeComments: i.includeComments === ro ? !t : i.includeComments, includeStrings: i.includeStrings === ro ? !t : i.includeStrings, allowedCharacters: i.allowedCharacters, allowedLocales: i.allowedLocales };
    })(this._workspaceTrustService.isWorkspaceTrusted(), this._options);
    if ([n.nonBasicASCII, n.ambiguousCharacters, n.invisibleCharacters].every(((t) => t === !1))) return;
    const e = { nonBasicASCII: n.nonBasicASCII, ambiguousCharacters: n.ambiguousCharacters, invisibleCharacters: n.invisibleCharacters, includeComments: n.includeComments, includeStrings: n.includeStrings, allowedCodePoints: Object.keys(n.allowedCharacters).map(((t) => t.codePointAt(0))), allowedLocales: Object.keys(n.allowedLocales).map(((t) => t === "_os" ? new Intl.NumberFormat().resolvedOptions().locale : t === "_vscode" ? $U : t)) };
    this._editorWorkerService.canComputeUnicodeHighlights(this._editor.getModel().uri) ? this._highlighter = new RT(this._editor, e, this._updateState, this._editorWorkerService) : this._highlighter = new Mhe(this._editor, e, this._updateState);
  }
  getDecorationInfo(n) {
    return this._highlighter ? this._highlighter.getDecorationInfo(n) : null;
  }
};
Im.ID = "editor.contrib.unicodeHighlighter", Im = OP([Em(1, Qo), Em(2, WW), Em(3, Se)], Im);
let RT = class extends V {
  constructor(n, e, t, i) {
    super(), this._editor = n, this._options = e, this._updateState = t, this._editorWorkerService = i, this._model = this._editor.getModel(), this._decorations = this._editor.createDecorationsCollection(), this._updateSoon = this._register(new Et((() => this._update()), 250)), this._register(this._editor.onDidChangeModelContent((() => {
      this._updateSoon.schedule();
    }))), this._updateSoon.schedule();
  }
  dispose() {
    this._decorations.clear(), super.dispose();
  }
  _update() {
    if (this._model.isDisposed()) return;
    if (!this._model.mightContainNonBasicASCII()) return void this._decorations.clear();
    const n = this._model.getVersionId();
    this._editorWorkerService.computedUnicodeHighlights(this._model.uri, this._options).then(((e) => {
      if (this._model.isDisposed() || this._model.getVersionId() !== n) return;
      this._updateState(e);
      const t = [];
      if (!e.hasMore) for (const i of e.ranges) t.push({ range: i, options: IS.instance.getDecorationFromOptions(this._options) });
      this._decorations.set(t);
    }));
  }
  getDecorationInfo(n) {
    if (!this._decorations.has(n)) return null;
    const e = this._editor.getModel();
    return aA(e, n) ? { reason: kU(e.getValueInRange(n.range), this._options), inComment: lA(e, n), inString: dA(e, n) } : null;
  }
};
RT = OP([Em(3, Qo)], RT);
class Mhe extends V {
  constructor(e, t, i) {
    super(), this._editor = e, this._options = t, this._updateState = i, this._model = this._editor.getModel(), this._decorations = this._editor.createDecorationsCollection(), this._updateSoon = this._register(new Et((() => this._update()), 250)), this._register(this._editor.onDidLayoutChange((() => {
      this._updateSoon.schedule();
    }))), this._register(this._editor.onDidScrollChange((() => {
      this._updateSoon.schedule();
    }))), this._register(this._editor.onDidChangeHiddenAreas((() => {
      this._updateSoon.schedule();
    }))), this._register(this._editor.onDidChangeModelContent((() => {
      this._updateSoon.schedule();
    }))), this._updateSoon.schedule();
  }
  dispose() {
    this._decorations.clear(), super.dispose();
  }
  _update() {
    if (this._model.isDisposed()) return;
    if (!this._model.mightContainNonBasicASCII()) return void this._decorations.clear();
    const e = this._editor.getVisibleRanges(), t = [], i = { ranges: [], ambiguousCharacterCount: 0, invisibleCharacterCount: 0, nonBasicAsciiCharacterCount: 0, hasMore: !1 };
    for (const s of e) {
      const o = SR.computeUnicodeHighlights(this._model, this._options, s);
      for (const r of o.ranges) i.ranges.push(r);
      i.ambiguousCharacterCount += i.ambiguousCharacterCount, i.invisibleCharacterCount += i.invisibleCharacterCount, i.nonBasicAsciiCharacterCount += i.nonBasicAsciiCharacterCount, i.hasMore = i.hasMore || o.hasMore;
    }
    if (!i.hasMore) for (const s of i.ranges) t.push({ range: s, options: IS.instance.getDecorationFromOptions(this._options) });
    this._updateState(i), this._decorations.set(t);
  }
  getDecorationInfo(e) {
    if (!this._decorations.has(e)) return null;
    const t = this._editor.getModel(), i = t.getValueInRange(e.range);
    return aA(t, e) ? { reason: kU(i, this._options), inComment: lA(t, e), inString: dA(t, e) } : null;
  }
}
const LU = m(0, "Configure Unicode Highlight Options");
let AT = class {
  constructor(n, e, t) {
    this._editor = n, this._languageService = e, this._openerService = t, this.hoverOrdinal = 5;
  }
  computeSync(n, e) {
    if (!this._editor.hasModel() || n.type !== 1) return [];
    const t = this._editor.getModel(), i = this._editor.getContribution(Im.ID);
    if (!i) return [];
    const s = [], o = /* @__PURE__ */ new Set();
    let r = 300;
    for (const a of e) {
      const l = i.getDecorationInfo(a);
      if (!l) continue;
      const d = t.getValueInRange(a.range).codePointAt(0), h = aN(d);
      let c;
      switch (l.reason.kind) {
        case 0:
          c = p1(l.reason.confusableWith) ? m(0, "The character {0} could be confused with the ASCII character {1}, which is more common in source code.", h, aN(l.reason.confusableWith.codePointAt(0))) : m(0, "The character {0} could be confused with the character {1}, which is more common in source code.", h, aN(l.reason.confusableWith.codePointAt(0)));
          break;
        case 1:
          c = m(0, "The character {0} is invisible.", h);
          break;
        case 2:
          c = m(0, "The character {0} is not a basic ASCII character.", h);
      }
      if (o.has(c)) continue;
      o.add(c);
      const u = { codePoint: d, reason: l.reason, inComment: l.inComment, inString: l.inString }, g = m(0, "Adjust settings"), p = `command:${d1.ID}?${encodeURIComponent(JSON.stringify(u))}`, f = new Vn("", !0).appendMarkdown(c).appendText(" ").appendLink(p, g, LU);
      s.push(new Jr(this, a.range, [f], !1, r++));
    }
    return s;
  }
  renderHoverParts(n, e) {
    return Sz(n, e, this._editor, this._languageService, this._openerService);
  }
};
function PT(n) {
  return `U+${n.toString(16).padStart(4, "0")}`;
}
function aN(n) {
  let e = `\`${PT(n)}\``;
  return ul.isInvisibleCharacter(n) || (e += ` "${(function(t) {
    return t === 96 ? "`` ` ``" : "`" + String.fromCodePoint(t) + "`";
  })(n)}"`), e;
}
function kU(n, e) {
  return SR.computeUnicodeHighlightReason(n, e);
}
AT = OP([Em(1, Xt), Em(2, Fs)], AT);
class IS {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  getDecorationFromOptions(e) {
    return this.getDecoration(!e.includeComments, !e.includeStrings);
  }
  getDecoration(e, t) {
    const i = `${e}${t}`;
    let s = this.map.get(i);
    return s || (s = Ve.createDynamic({ description: "unicode-highlight", stickiness: 1, className: "unicode-highlight", showIfCollapsed: !0, overviewRuler: null, minimap: null, hideInCommentTokens: e, hideInStringTokens: t }), this.map.set(i, s)), s;
  }
}
IS.instance = new IS();
class The extends he {
  constructor() {
    super({ id: Bc.ID, label: m(0, "Disable highlighting of characters in comments"), alias: "Disable highlighting of characters in comments", precondition: void 0 }), this.shortLabel = m(0, "Disable Highlight In Comments");
  }
  async run(e, t, i) {
    const s = e?.get(Ye);
    s && this.runAction(s);
  }
  async runAction(e) {
    await e.updateValue(R7, !1, 2);
  }
}
class Rhe extends he {
  constructor() {
    super({ id: Bc.ID, label: m(0, "Disable highlighting of characters in strings"), alias: "Disable highlighting of characters in strings", precondition: void 0 }), this.shortLabel = m(0, "Disable Highlight In Strings");
  }
  async run(e, t, i) {
    const s = e?.get(Ye);
    s && this.runAction(s);
  }
  async runAction(e) {
    await e.updateValue(A7, !1, 2);
  }
}
class Bc extends he {
  constructor() {
    super({ id: Bc.ID, label: m(0, "Disable highlighting of ambiguous characters"), alias: "Disable highlighting of ambiguous characters", precondition: void 0 }), this.shortLabel = m(0, "Disable Ambiguous Highlight");
  }
  async run(e, t, i) {
    const s = e?.get(Ye);
    s && this.runAction(s);
  }
  async runAction(e) {
    await e.updateValue(T7, !1, 2);
  }
}
Bc.ID = "editor.action.unicodeHighlight.disableHighlightingOfAmbiguousCharacters";
class Sf extends he {
  constructor() {
    super({ id: Sf.ID, label: m(0, "Disable highlighting of invisible characters"), alias: "Disable highlighting of invisible characters", precondition: void 0 }), this.shortLabel = m(0, "Disable Invisible Highlight");
  }
  async run(e, t, i) {
    const s = e?.get(Ye);
    s && this.runAction(s);
  }
  async runAction(e) {
    await e.updateValue(I7, !1, 2);
  }
}
Sf.ID = "editor.action.unicodeHighlight.disableHighlightingOfInvisibleCharacters";
class Lf extends he {
  constructor() {
    super({ id: Lf.ID, label: m(0, "Disable highlighting of non basic ASCII characters"), alias: "Disable highlighting of non basic ASCII characters", precondition: void 0 }), this.shortLabel = m(0, "Disable Non ASCII Highlight");
  }
  async run(e, t, i) {
    const s = e?.get(Ye);
    s && this.runAction(s);
  }
  async runAction(e) {
    await e.updateValue(M7, !1, 2);
  }
}
Lf.ID = "editor.action.unicodeHighlight.disableHighlightingOfNonBasicAsciiCharacters";
class d1 extends he {
  constructor() {
    super({ id: d1.ID, label: m(0, "Show Exclude Options"), alias: "Show Exclude Options", precondition: void 0 });
  }
  async run(e, t, i) {
    const { codePoint: s, reason: o, inString: r, inComment: a } = i, l = String.fromCodePoint(s), d = e.get(Sa), h = e.get(Ye), c = [];
    if (o.kind === 0) for (const g of o.notAmbiguousInLocales) c.push({ label: m(0, 'Allow unicode characters that are more common in the language "{0}".', g), run: async () => {
      Ahe(h, [g]);
    } });
    if (c.push({ label: (function(g) {
      return ul.isInvisibleCharacter(g) ? m(0, "Exclude {0} (invisible character) from being highlighted", PT(g)) : m(0, "Exclude {0} from being highlighted", `${PT(g)} "${l}"`);
    })(s), run: () => (async function(g, p) {
      const f = g.getValue(LN);
      let _;
      _ = typeof f == "object" && f ? f : {};
      for (const v of p) _[String.fromCodePoint(v)] = !0;
      await g.updateValue(LN, _, 2);
    })(h, [s]) }), a) {
      const g = new The();
      c.push({ label: g.label, run: async () => g.runAction(h) });
    } else if (r) {
      const g = new Rhe();
      c.push({ label: g.label, run: async () => g.runAction(h) });
    }
    if (o.kind === 0) {
      const g = new Bc();
      c.push({ label: g.label, run: async () => g.runAction(h) });
    } else if (o.kind === 1) {
      const g = new Sf();
      c.push({ label: g.label, run: async () => g.runAction(h) });
    } else if (o.kind === 2) {
      const g = new Lf();
      c.push({ label: g.label, run: async () => g.runAction(h) });
    } else (function(g) {
      throw new Error(`Unexpected value: ${g}`);
    })(o);
    const u = await d.pick(c, { title: LU });
    u && await u.run();
  }
}
async function Ahe(n, e) {
  var t;
  const i = (t = n.inspect(kN).user) === null || t === void 0 ? void 0 : t.value;
  let s;
  s = typeof i == "object" && i ? Object.assign({}, i) : {};
  for (const o of e) s[o] = !0;
  await n.updateValue(kN, s, 2);
}
d1.ID = "editor.action.unicodeHighlight.showExcludeOptions", X(Bc), X(Sf), X(Lf), X(d1), ft(Im.ID, Im, 1), Tc.register(AT);
var Phe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, q9 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const $9 = "ignoreUnusualLineTerminators";
let l_ = class extends V {
  constructor(n, e, t) {
    super(), this._editor = n, this._dialogService = e, this._codeEditorService = t, this._isPresentingDialog = !1, this._config = this._editor.getOption(126), this._register(this._editor.onDidChangeConfiguration(((i) => {
      i.hasChanged(126) && (this._config = this._editor.getOption(126), this._checkForUnusualLineTerminators());
    }))), this._register(this._editor.onDidChangeModel((() => {
      this._checkForUnusualLineTerminators();
    }))), this._register(this._editor.onDidChangeModelContent(((i) => {
      i.isUndoing || this._checkForUnusualLineTerminators();
    }))), this._checkForUnusualLineTerminators();
  }
  async _checkForUnusualLineTerminators() {
    if (this._config === "off" || !this._editor.hasModel()) return;
    const n = this._editor.getModel();
    if (!n.mightContainUnusualLineTerminators() || (function(i, s) {
      return i.getModelProperty(s.uri, $9);
    })(this._codeEditorService, n) === !0 || this._editor.getOption(91)) return;
    if (this._config === "auto") return void n.removeUnusualLineTerminators(this._editor.getSelections());
    if (this._isPresentingDialog) return;
    let t;
    try {
      this._isPresentingDialog = !0, t = await this._dialogService.confirm({ title: m(0, "Unusual Line Terminators"), message: m(0, "Detected unusual line terminators"), detail: m(0, "The file '{0}' contains one or more unusual line terminator characters, like Line Separator (LS) or Paragraph Separator (PS).\n\nIt is recommended to remove them from the file. This can be configured via `editor.unusualLineTerminators`.", ir(n.uri)), primaryButton: m(0, "&&Remove Unusual Line Terminators"), cancelButton: m(0, "Ignore") });
    } finally {
      this._isPresentingDialog = !1;
    }
    t.confirmed ? n.removeUnusualLineTerminators(this._editor.getSelections()) : (function(i, s, o) {
      i.setModelProperty(s.uri, $9, o);
    })(this._codeEditorService, n, !0);
  }
};
l_.ID = "editor.contrib.unusualLineTerminatorsDetector", l_ = Phe([q9(1, E1), q9(2, mt)], l_), ft(l_.ID, l_, 1);
var qi, OT, DU = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Sw = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
const Lw = new ae("hasWordHighlights", !1);
function xU(n, e, t, i) {
  return hR(n.ordered(e).map(((s) => () => Promise.resolve(s.provideDocumentHighlights(e, t, i)).then(void 0, Ni))), zn).then(((s) => {
    if (s) {
      const o = new Di();
      return o.set(e.uri, s), o;
    }
    return new Di();
  }));
}
class FP {
  constructor(e, t, i) {
    this._model = e, this._selection = t, this._wordSeparators = i, this._wordRange = this._getCurrentWordRange(e, t), this._result = null;
  }
  get result() {
    return this._result || (this._result = on(((e) => this._compute(this._model, this._selection, this._wordSeparators, e)))), this._result;
  }
  _getCurrentWordRange(e, t) {
    const i = e.getWordAtPosition(t.getPosition());
    return i ? new D(t.startLineNumber, i.startColumn, t.startLineNumber, i.endColumn) : null;
  }
  isValid(e, t, i) {
    const s = t.startLineNumber, o = t.startColumn, r = t.endColumn, a = this._getCurrentWordRange(e, t);
    let l = !!(this._wordRange && this._wordRange.equalsRange(a));
    for (let d = 0, h = i.length; !l && d < h; d++) {
      const c = i.getRange(d);
      c && c.startLineNumber === s && c.startColumn <= o && c.endColumn >= r && (l = !0);
    }
    return l;
  }
  cancel() {
    this.result.cancel();
  }
}
class Ohe extends FP {
  constructor(e, t, i, s) {
    super(e, t, i), this._providers = s;
  }
  _compute(e, t, i, s) {
    return xU(this._providers, e, t.getPosition(), s).then(((o) => o || new Di()));
  }
}
class Fhe extends FP {
  constructor(e, t, i, s, o) {
    super(e, t, i), this._providers = s, this._otherModels = o;
  }
  _compute(e, t, i, s) {
    return (function(o, r, a, l, d, h) {
      return hR(o.ordered(r).map(((c) => () => {
        const u = h.filter(((g) => $8(g))).filter(((g) => uA(c.selector, g.uri, g.getLanguageId(), !0, void 0, void 0) > 0));
        return Promise.resolve(c.provideMultiDocumentHighlights(r, a, u, d)).then(void 0, Ni);
      })), ((c) => c instanceof Di && c.size > 0));
    })(this._providers, e, t.getPosition(), 0, s, this._otherModels).then(((o) => o || new Di()));
  }
}
class G9 extends FP {
  constructor(e, t, i, s, o) {
    super(e, t, s), this._otherModels = o, this._selectionIsEmpty = t.isEmpty(), this._word = i;
  }
  _compute(e, t, i, s) {
    return vc(250, s).then((() => {
      const o = new Di();
      let r;
      if (r = this._word ? this._word : e.getWordAtPosition(t.getPosition()), !r) return new Di();
      const a = [e, ...this._otherModels];
      for (const l of a) {
        if (l.isDisposed()) continue;
        const d = l.findMatches(r.word, !0, !1, !0, i, !1).map(((h) => ({ range: h.range, kind: Z0.Text })));
        d && o.set(l.uri, d);
      }
      return o;
    }));
  }
  isValid(e, t, i) {
    const s = t.isEmpty();
    return this._selectionIsEmpty === s && super.isValid(e, t, i);
  }
}
ja("_executeDocumentHighlights", (async (n, e, t) => {
  const i = n.get(fe), s = await xU(i.documentHighlightProvider, e, t, et.None);
  return s?.get(e.uri);
}));
let K_ = qi = class {
  constructor(n, e, t, i, s) {
    this.toUnhook = new G(), this.workerRequestTokenId = 0, this.workerRequestCompleted = !1, this.workerRequestValue = new Di(), this.lastCursorPositionChangeTime = 0, this.renderDecorationsTimer = -1, this.editor = n, this.providers = e, this.multiDocumentProviders = t, this.codeEditorService = s, this._hasWordHighlights = Lw.bindTo(i), this._ignorePositionChangeEvent = !1, this.occurrencesHighlight = this.editor.getOption(81), this.model = this.editor.getModel(), this.toUnhook.add(n.onDidChangeCursorPosition(((o) => {
      this._ignorePositionChangeEvent || this.occurrencesHighlight !== "off" && this._onPositionChanged(o);
    }))), this.toUnhook.add(n.onDidFocusEditorText(((o) => {
      this.occurrencesHighlight !== "off" && (this.workerRequest || this._run());
    }))), this.toUnhook.add(n.onDidChangeModelContent(((o) => {
      this._stopAll();
    }))), this.toUnhook.add(n.onDidChangeModel(((o) => {
      !o.newModelUrl && o.oldModelUrl ? this._stopSingular() : qi.query && this._run();
    }))), this.toUnhook.add(n.onDidChangeConfiguration(((o) => {
      const r = this.editor.getOption(81);
      this.occurrencesHighlight !== r && (this.occurrencesHighlight = r, this._stopAll());
    }))), this.decorations = this.editor.createDecorationsCollection(), this.workerRequestTokenId = 0, this.workerRequest = null, this.workerRequestCompleted = !1, this.lastCursorPositionChangeTime = 0, this.renderDecorationsTimer = -1, qi.query && this._run();
  }
  hasDecorations() {
    return this.decorations.length > 0;
  }
  restore() {
    this.occurrencesHighlight !== "off" && this._run();
  }
  _getSortedHighlights() {
    return this.decorations.getRanges().sort(D.compareRangesUsingStarts);
  }
  moveNext() {
    const n = this._getSortedHighlights(), e = n.findIndex(((s) => s.containsPosition(this.editor.getPosition()))), t = (e + 1) % n.length, i = n[t];
    try {
      this._ignorePositionChangeEvent = !0, this.editor.setPosition(i.getStartPosition()), this.editor.revealRangeInCenterIfOutsideViewport(i);
      const s = this._getWord();
      s && Io(`${this.editor.getModel().getLineContent(i.startLineNumber)}, ${t + 1} of ${n.length} for '${s.word}'`);
    } finally {
      this._ignorePositionChangeEvent = !1;
    }
  }
  moveBack() {
    const n = this._getSortedHighlights(), e = n.findIndex(((s) => s.containsPosition(this.editor.getPosition()))), t = (e - 1 + n.length) % n.length, i = n[t];
    try {
      this._ignorePositionChangeEvent = !0, this.editor.setPosition(i.getStartPosition()), this.editor.revealRangeInCenterIfOutsideViewport(i);
      const s = this._getWord();
      s && Io(`${this.editor.getModel().getLineContent(i.startLineNumber)}, ${t + 1} of ${n.length} for '${s.word}'`);
    } finally {
      this._ignorePositionChangeEvent = !1;
    }
  }
  _removeSingleDecorations() {
    if (!this.editor.hasModel()) return;
    const n = qi.storedDecorations.get(this.editor.getModel().uri);
    n && (this.editor.removeDecorations(n), qi.storedDecorations.delete(this.editor.getModel().uri), this.decorations.length > 0 && (this.decorations.clear(), this._hasWordHighlights.set(!1)));
  }
  _removeAllDecorations() {
    const n = this.codeEditorService.listCodeEditors(), e = [];
    for (const t of n) {
      if (!t.hasModel()) continue;
      const i = qi.storedDecorations.get(t.getModel().uri);
      if (!i) continue;
      t.removeDecorations(i), e.push(t.getModel().uri);
      const s = Rd.get(t);
      s?.wordHighlighter && s.wordHighlighter.decorations.length > 0 && (s.wordHighlighter.decorations.clear(), s.wordHighlighter.workerRequest = null, s.wordHighlighter._hasWordHighlights.set(!1));
    }
    for (const t of e) qi.storedDecorations.delete(t);
  }
  _stopSingular() {
    var n, e, t, i;
    this._removeSingleDecorations(), this.editor.hasTextFocus() && (((n = this.editor.getModel()) === null || n === void 0 ? void 0 : n.uri.scheme) !== Ue.vscodeNotebookCell && ((t = (e = qi.query) === null || e === void 0 ? void 0 : e.modelInfo) === null || t === void 0 ? void 0 : t.model.uri.scheme) !== Ue.vscodeNotebookCell ? (qi.query = null, this._run()) : !((i = qi.query) === null || i === void 0) && i.modelInfo && (qi.query.modelInfo = null)), this.renderDecorationsTimer !== -1 && (clearTimeout(this.renderDecorationsTimer), this.renderDecorationsTimer = -1), this.workerRequest !== null && (this.workerRequest.cancel(), this.workerRequest = null), this.workerRequestCompleted || (this.workerRequestTokenId++, this.workerRequestCompleted = !0);
  }
  _stopAll() {
    this._removeAllDecorations(), this.renderDecorationsTimer !== -1 && (clearTimeout(this.renderDecorationsTimer), this.renderDecorationsTimer = -1), this.workerRequest !== null && (this.workerRequest.cancel(), this.workerRequest = null), this.workerRequestCompleted || (this.workerRequestTokenId++, this.workerRequestCompleted = !0);
  }
  _onPositionChanged(n) {
    var e;
    this.occurrencesHighlight !== "off" && (n.reason === 3 || ((e = this.editor.getModel()) === null || e === void 0 ? void 0 : e.uri.scheme) === Ue.vscodeNotebookCell) ? this._run() : this._stopAll();
  }
  _getWord() {
    const n = this.editor.getSelection(), e = n.startLineNumber, t = n.startColumn;
    return this.model.isDisposed() ? null : this.model.getWordAtPosition({ lineNumber: e, column: t });
  }
  getOtherModelsToHighlight(n) {
    if (!n) return [];
    if (n.uri.scheme === Ue.vscodeNotebookCell) {
      const i = [], s = this.codeEditorService.listCodeEditors();
      for (const o of s) {
        const r = o.getModel();
        r && r !== n && r.uri.scheme === Ue.vscodeNotebookCell && i.push(r);
      }
      return i;
    }
    const e = [], t = this.codeEditorService.listCodeEditors();
    for (const i of t) {
      if (!oP(i)) continue;
      const s = i.getModel();
      s && n === s.modified && e.push(s.modified);
    }
    if (e.length) return e;
    if (this.occurrencesHighlight === "singleFile") return [];
    for (const i of t) {
      const s = i.getModel();
      s && s !== n && e.push(s);
    }
    return e;
  }
  _run() {
    var n;
    let e;
    if (this.editor.hasTextFocus()) {
      const t = this.editor.getSelection();
      if (!t || t.startLineNumber !== t.endLineNumber) return qi.query = null, void this._stopAll();
      const i = t.startColumn, s = t.endColumn, o = this._getWord();
      if (!o || o.startColumn > i || o.endColumn < s) return qi.query = null, void this._stopAll();
      e = this.workerRequest && this.workerRequest.isValid(this.model, t, this.decorations), qi.query = { modelInfo: { model: this.model, selection: t }, word: o };
    } else if (!qi.query) return;
    if (this.lastCursorPositionChangeTime = (/* @__PURE__ */ new Date()).getTime(), e) this.workerRequestCompleted && this.renderDecorationsTimer !== -1 && (clearTimeout(this.renderDecorationsTimer), this.renderDecorationsTimer = -1, this._beginRenderDecorations());
    else {
      this._stopAll();
      const t = ++this.workerRequestTokenId;
      this.workerRequestCompleted = !1;
      const i = this.getOtherModelsToHighlight(this.editor.getModel());
      if (!qi.query.modelInfo || qi.query.modelInfo.model.isDisposed()) return;
      this.workerRequest = this.computeWithModel(qi.query.modelInfo.model, qi.query.modelInfo.selection, qi.query.word, i), (n = this.workerRequest) === null || n === void 0 || n.result.then(((s) => {
        t === this.workerRequestTokenId && (this.workerRequestCompleted = !0, this.workerRequestValue = s || [], this._beginRenderDecorations());
      }), We);
    }
  }
  computeWithModel(n, e, t, i) {
    return i.length ? (function(s, o, r, a, l, d) {
      return s.has(o) ? new Fhe(o, r, l, s, d) : new G9(o, r, a, l, d);
    })(this.multiDocumentProviders, n, e, t, this.editor.getOption(131), i) : (function(s, o, r, a, l) {
      return s.has(o) ? new Ohe(o, r, l, s) : new G9(o, r, a, l, []);
    })(this.providers, n, e, t, this.editor.getOption(131));
  }
  _beginRenderDecorations() {
    const n = (/* @__PURE__ */ new Date()).getTime(), e = this.lastCursorPositionChangeTime + 250;
    n >= e ? (this.renderDecorationsTimer = -1, this.renderDecorations()) : this.renderDecorationsTimer = setTimeout((() => {
      this.renderDecorations();
    }), e - n);
  }
  renderDecorations() {
    var n, e, t;
    this.renderDecorationsTimer = -1;
    const i = this.codeEditorService.listCodeEditors();
    for (const o of i) {
      const r = Rd.get(o);
      if (!r) continue;
      const a = [], l = (n = o.getModel()) === null || n === void 0 ? void 0 : n.uri;
      if (l && this.workerRequestValue.has(l)) {
        const d = qi.storedDecorations.get(l), h = this.workerRequestValue.get(l);
        if (h) for (const u of h) u.range && a.push({ range: u.range, options: (s = u.kind, s === Z0.Write ? zde : s === Z0.Text ? Ude : qde) });
        let c = [];
        o.changeDecorations(((u) => {
          c = u.deltaDecorations(d ?? [], a);
        })), qi.storedDecorations = qi.storedDecorations.set(l, c), a.length > 0 && ((e = r.wordHighlighter) === null || e === void 0 || e.decorations.set(a), (t = r.wordHighlighter) === null || t === void 0 || t._hasWordHighlights.set(!0));
      }
    }
    var s;
  }
  dispose() {
    this._stopSingular(), this.toUnhook.dispose();
  }
};
K_.storedDecorations = new Di(), K_.query = null, K_ = qi = DU([Sw(4, mt)], K_);
let Rd = OT = class extends V {
  static get(n) {
    return n.getContribution(OT.ID);
  }
  constructor(n, e, t, i) {
    super(), this._wordHighlighter = null;
    const s = () => {
      n.hasModel() && !n.getModel().isTooLargeForTokenization() && (this._wordHighlighter = new K_(n, t.documentHighlightProvider, t.multiDocumentHighlightProvider, e, i));
    };
    this._register(n.onDidChangeModel(((o) => {
      this._wordHighlighter && (this._wordHighlighter.dispose(), this._wordHighlighter = null), s();
    }))), s();
  }
  get wordHighlighter() {
    return this._wordHighlighter;
  }
  saveViewState() {
    return !(!this._wordHighlighter || !this._wordHighlighter.hasDecorations());
  }
  moveNext() {
    var n;
    (n = this._wordHighlighter) === null || n === void 0 || n.moveNext();
  }
  moveBack() {
    var n;
    (n = this._wordHighlighter) === null || n === void 0 || n.moveBack();
  }
  restoreViewState(n) {
    this._wordHighlighter && n && this._wordHighlighter.restore();
  }
  dispose() {
    this._wordHighlighter && (this._wordHighlighter.dispose(), this._wordHighlighter = null), super.dispose();
  }
};
Rd.ID = "editor.contrib.wordHighlighter", Rd = OT = DU([Sw(1, Te), Sw(2, fe), Sw(3, mt)], Rd);
class Z9 extends he {
  constructor(e, t) {
    super(t), this._isNext = e;
  }
  run(e, t) {
    const i = Rd.get(t);
    i && (this._isNext ? i.moveNext() : i.moveBack());
  }
}
ft(Rd.ID, Rd, 0), X(class extends Z9 {
  constructor() {
    super(!0, { id: "editor.action.wordHighlight.next", label: m(0, "Go to Next Symbol Highlight"), alias: "Go to Next Symbol Highlight", precondition: Lw, kbOpts: { kbExpr: E.editorTextFocus, primary: 65, weight: 100 } });
  }
}), X(class extends Z9 {
  constructor() {
    super(!1, { id: "editor.action.wordHighlight.prev", label: m(0, "Go to Previous Symbol Highlight"), alias: "Go to Previous Symbol Highlight", precondition: Lw, kbOpts: { kbExpr: E.editorTextFocus, primary: 1089, weight: 100 } });
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.wordHighlight.trigger", label: m(0, "Trigger Symbol Highlight"), alias: "Trigger Symbol Highlight", precondition: Lw.toNegated(), kbOpts: { kbExpr: E.editorTextFocus, primary: 0, weight: 100 } });
  }
  run(n, e, t) {
    const i = Rd.get(e);
    i && i.restoreViewState(!0);
  }
});
class wk extends Zi {
  constructor(e) {
    super(e), this._inSelectionMode = e.inSelectionMode, this._wordNavigationType = e.wordNavigationType;
  }
  runEditorCommand(e, t, i) {
    if (!t.hasModel()) return;
    const s = zo(t.getOption(131), t.getOption(130)), o = t.getModel(), r = t.getSelections().map(((a) => {
      const l = new W(a.positionLineNumber, a.positionColumn), d = this._move(s, o, l, this._wordNavigationType);
      return this._moveTo(a, d, this._inSelectionMode);
    }));
    if (o.pushStackElement(), t._getViewModel().setCursorStates("moveWordCommand", 3, r.map(((a) => pt.fromModelSelection(a)))), r.length === 1) {
      const a = new W(r[0].positionLineNumber, r[0].positionColumn);
      t.revealPosition(a, 0);
    }
  }
  _moveTo(e, t, i) {
    return i ? new _e(e.selectionStartLineNumber, e.selectionStartColumn, t.lineNumber, t.column) : new _e(t.lineNumber, t.column, t.lineNumber, t.column);
  }
}
class th extends wk {
  _move(e, t, i, s) {
    return Ct.moveWordLeft(e, t, i, s);
  }
}
class ih extends wk {
  _move(e, t, i, s) {
    return Ct.moveWordRight(e, t, i, s);
  }
}
class MS extends Zi {
  constructor(e) {
    super(e), this._whitespaceHeuristics = e.whitespaceHeuristics, this._wordNavigationType = e.wordNavigationType;
  }
  runEditorCommand(e, t, i) {
    const s = e.get(zt);
    if (!t.hasModel()) return;
    const o = zo(t.getOption(131), t.getOption(130)), r = t.getModel(), a = t.getSelections(), l = t.getOption(6), d = t.getOption(11), h = s.getLanguageConfiguration(r.getLanguageId()).getAutoClosingPairs(), c = t._getViewModel(), u = a.map(((g) => {
      const p = this._delete({ wordSeparators: o, model: r, selection: g, whitespaceHeuristics: this._whitespaceHeuristics, autoClosingDelete: t.getOption(9), autoClosingBrackets: l, autoClosingQuotes: d, autoClosingPairs: h, autoClosedCharacters: c.getCursorAutoClosedCharacters() }, this._wordNavigationType);
      return new Dn(p, "");
    }));
    t.pushUndoStop(), t.executeCommands(this.id, u), t.pushUndoStop();
  }
}
class lN extends MS {
  _delete(e, t) {
    return Ct.deleteWordLeft(e, t) || new D(1, 1, 1, 1);
  }
}
class dN extends MS {
  _delete(e, t) {
    const i = Ct.deleteWordRight(e, t);
    if (i) return i;
    const s = e.model.getLineCount(), o = e.model.getLineMaxColumn(s);
    return new D(s, o, s, o);
  }
}
re(new class extends th {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 0, id: "cursorWordStartLeft", precondition: void 0 });
  }
}()), re(new class extends th {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 2, id: "cursorWordEndLeft", precondition: void 0 });
  }
}()), re(new class extends th {
  constructor() {
    var n;
    super({ inSelectionMode: !1, wordNavigationType: 1, id: "cursorWordLeft", precondition: void 0, kbOpts: { kbExpr: q.and(E.textInputFocus, (n = q.and(g_, Hb)) === null || n === void 0 ? void 0 : n.negate()), primary: 2063, mac: { primary: 527 }, weight: 100 } });
  }
}()), re(new class extends th {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 0, id: "cursorWordStartLeftSelect", precondition: void 0 });
  }
}()), re(new class extends th {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 2, id: "cursorWordEndLeftSelect", precondition: void 0 });
  }
}()), re(new class extends th {
  constructor() {
    var n;
    super({ inSelectionMode: !0, wordNavigationType: 1, id: "cursorWordLeftSelect", precondition: void 0, kbOpts: { kbExpr: q.and(E.textInputFocus, (n = q.and(g_, Hb)) === null || n === void 0 ? void 0 : n.negate()), primary: 3087, mac: { primary: 1551 }, weight: 100 } });
  }
}()), re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 0, id: "cursorWordStartRight", precondition: void 0 });
  }
}()), re(new class extends ih {
  constructor() {
    var n;
    super({ inSelectionMode: !1, wordNavigationType: 2, id: "cursorWordEndRight", precondition: void 0, kbOpts: { kbExpr: q.and(E.textInputFocus, (n = q.and(g_, Hb)) === null || n === void 0 ? void 0 : n.negate()), primary: 2065, mac: { primary: 529 }, weight: 100 } });
  }
}()), re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 2, id: "cursorWordRight", precondition: void 0 });
  }
}()), re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 0, id: "cursorWordStartRightSelect", precondition: void 0 });
  }
}()), re(new class extends ih {
  constructor() {
    var n;
    super({ inSelectionMode: !0, wordNavigationType: 2, id: "cursorWordEndRightSelect", precondition: void 0, kbOpts: { kbExpr: q.and(E.textInputFocus, (n = q.and(g_, Hb)) === null || n === void 0 ? void 0 : n.negate()), primary: 3089, mac: { primary: 1553 }, weight: 100 } });
  }
}()), re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 2, id: "cursorWordRightSelect", precondition: void 0 });
  }
}()), re(new class extends th {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 3, id: "cursorWordAccessibilityLeft", precondition: void 0 });
  }
  _move(n, e, t, i) {
    return super._move(zo(ta.wordSeparators.defaultValue, n.intlSegmenterLocales), e, t, i);
  }
}()), re(new class extends th {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 3, id: "cursorWordAccessibilityLeftSelect", precondition: void 0 });
  }
  _move(n, e, t, i) {
    return super._move(zo(ta.wordSeparators.defaultValue, n.intlSegmenterLocales), e, t, i);
  }
}()), re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 3, id: "cursorWordAccessibilityRight", precondition: void 0 });
  }
  _move(n, e, t, i) {
    return super._move(zo(ta.wordSeparators.defaultValue, n.intlSegmenterLocales), e, t, i);
  }
}()), re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 3, id: "cursorWordAccessibilityRightSelect", precondition: void 0 });
  }
  _move(n, e, t, i) {
    return super._move(zo(ta.wordSeparators.defaultValue, n.intlSegmenterLocales), e, t, i);
  }
}()), re(new class extends lN {
  constructor() {
    super({ whitespaceHeuristics: !1, wordNavigationType: 0, id: "deleteWordStartLeft", precondition: E.writable });
  }
}()), re(new class extends lN {
  constructor() {
    super({ whitespaceHeuristics: !1, wordNavigationType: 2, id: "deleteWordEndLeft", precondition: E.writable });
  }
}()), re(new class extends lN {
  constructor() {
    super({ whitespaceHeuristics: !0, wordNavigationType: 0, id: "deleteWordLeft", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 2049, mac: { primary: 513 }, weight: 100 } });
  }
}()), re(new class extends dN {
  constructor() {
    super({ whitespaceHeuristics: !1, wordNavigationType: 0, id: "deleteWordStartRight", precondition: E.writable });
  }
}()), re(new class extends dN {
  constructor() {
    super({ whitespaceHeuristics: !1, wordNavigationType: 2, id: "deleteWordEndRight", precondition: E.writable });
  }
}()), re(new class extends dN {
  constructor() {
    super({ whitespaceHeuristics: !0, wordNavigationType: 2, id: "deleteWordRight", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 2068, mac: { primary: 532 }, weight: 100 } });
  }
}()), X(class extends he {
  constructor() {
    super({ id: "deleteInsideWord", precondition: E.writable, label: m(0, "Delete Word"), alias: "Delete Word" });
  }
  run(n, e, t) {
    if (!e.hasModel()) return;
    const i = zo(e.getOption(131), e.getOption(130)), s = e.getModel(), o = e.getSelections().map(((r) => {
      const a = Ct.deleteInsideWord(i, s, r);
      return new Dn(a, "");
    }));
    e.pushUndoStop(), e.executeCommands(this.id, o), e.pushUndoStop();
  }
});
class Y9 extends wk {
  _move(e, t, i, s) {
    return dy.moveWordPartLeft(e, t, i);
  }
}
dt.registerCommandAlias("cursorWordPartStartLeft", "cursorWordPartLeft");
dt.registerCommandAlias("cursorWordPartStartLeftSelect", "cursorWordPartLeftSelect");
class X9 extends wk {
  _move(e, t, i, s) {
    return dy.moveWordPartRight(e, t, i);
  }
}
re(new class extends MS {
  constructor() {
    super({ whitespaceHeuristics: !0, wordNavigationType: 0, id: "deleteWordPartLeft", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 769 }, weight: 100 } });
  }
  _delete(n, e) {
    return dy.deleteWordPartLeft(n) || new D(1, 1, 1, 1);
  }
}()), re(new class extends MS {
  constructor() {
    super({ whitespaceHeuristics: !0, wordNavigationType: 2, id: "deleteWordPartRight", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 788 }, weight: 100 } });
  }
  _delete(n, e) {
    const t = dy.deleteWordPartRight(n);
    if (t) return t;
    const i = n.model.getLineCount(), s = n.model.getLineMaxColumn(i);
    return new D(i, s, i, s);
  }
}()), re(new class extends Y9 {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 0, id: "cursorWordPartLeft", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 783 }, weight: 100 } });
  }
}()), re(new class extends Y9 {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 0, id: "cursorWordPartLeftSelect", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 1807 }, weight: 100 } });
  }
}()), re(new class extends X9 {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 2, id: "cursorWordPartRight", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 785 }, weight: 100 } });
  }
}()), re(new class extends X9 {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 2, id: "cursorWordPartRightSelect", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 1809 }, weight: 100 } });
  }
}());
class hN extends V {
  constructor(e) {
    super(), this.editor = e, this._register(this.editor.onDidAttemptReadOnlyEdit((() => this._onDidAttemptReadOnlyEdit())));
  }
  _onDidAttemptReadOnlyEdit() {
    const e = bs.get(this.editor);
    if (e && this.editor.hasModel()) {
      let t = this.editor.getOptions().get(92);
      t || (t = this.editor.isSimpleWidget ? new Vn(m(0, "Cannot edit in read-only input")) : new Vn(m(0, "Cannot edit in read-only editor"))), e.showMessage(t, this.editor.getPosition());
    }
  }
}
hN.ID = "editor.contrib.readOnlyMessageController", ft(hN.ID, hN, 2);
var Bhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Q9 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let cN = class extends V {
  constructor(n, e, t) {
    super(), this._textModel = n, this._languageFeaturesService = e, this._outlineModelService = t, this._currentModel = lt(this, void 0);
    const i = Hn("documentSymbolProvider.onDidChange", this._languageFeaturesService.documentSymbolProvider.onDidChange), s = Hn("_textModel.onDidChangeContent", se.debounce(((o) => this._textModel.onDidChangeContent(o)), (() => {
    }), 100));
    this._register(nr((async (o, r) => {
      i.read(o), s.read(o);
      const a = r.add(new nne()), l = await this._outlineModelService.getOrCreate(this._textModel, a.token);
      r.isDisposed || this._currentModel.set(l, void 0);
    })));
  }
  getBreadcrumbItems(n, e) {
    const t = this._currentModel.read(e);
    if (!t) return [];
    const i = t.asListOfDocumentSymbols().filter(((s) => n.contains(s.range.startLineNumber) && !n.contains(s.range.endLineNumber)));
    return i.sort(m7(jo(((s) => s.range.endLineNumber - s.range.startLineNumber), od))), i.map(((s) => ({ name: s.name, kind: s.kind, startLineNumber: s.range.startLineNumber })));
  }
};
cN = Bhe([Q9(1, fe), Q9(2, t1)], cN), b0.setBreadcrumbsSourceFactory(((n, e) => e.createInstance(cN, n)));
class FT extends V {
  constructor(e) {
    super(), this.editor = e, this.widget = null, ca && (this._register(e.onDidChangeConfiguration((() => this.update()))), this.update());
  }
  update() {
    const e = !this.editor.getOption(91);
    !this.widget && e ? this.widget = new yk(this.editor) : this.widget && !e && (this.widget.dispose(), this.widget = null);
  }
  dispose() {
    super.dispose(), this.widget && (this.widget.dispose(), this.widget = null);
  }
}
FT.ID = "editor.contrib.iPadShowKeyboard";
class yk extends V {
  constructor(e) {
    super(), this.editor = e, this._domNode = document.createElement("textarea"), this._domNode.className = "iPadShowKeyboard", this._register(K(this._domNode, "touchstart", ((t) => {
      this.editor.focus();
    }))), this._register(K(this._domNode, "focus", ((t) => {
      this.editor.focus();
    }))), this.editor.addOverlayWidget(this);
  }
  dispose() {
    this.editor.removeOverlayWidget(this), super.dispose();
  }
  getId() {
    return yk.ID;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return { preference: 1 };
  }
}
yk.ID = "editor.contrib.ShowKeyboardWidget", ft(FT.ID, FT, 3);
var BT, Whe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, J9 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let Mm = BT = class extends V {
  static get(n) {
    return n.getContribution(BT.ID);
  }
  constructor(n, e, t) {
    super(), this._editor = n, this._languageService = t, this._widget = null, this._register(this._editor.onDidChangeModel(((i) => this.stop()))), this._register(this._editor.onDidChangeModelLanguage(((i) => this.stop()))), this._register(ci.onDidChange(((i) => this.stop()))), this._register(this._editor.onKeyUp(((i) => i.keyCode === 9 && this.stop())));
  }
  dispose() {
    this.stop(), super.dispose();
  }
  launch() {
    this._widget || this._editor.hasModel() && (this._widget = new Sk(this._editor, this._languageService));
  }
  stop() {
    this._widget && (this._widget.dispose(), this._widget = null);
  }
};
Mm.ID = "editor.contrib.inspectTokens", Mm = BT = Whe([J9(1, Ro), J9(2, Xt)], Mm);
class Sk extends V {
  constructor(e, t) {
    super(), this.allowEditorOverflow = !0, this._editor = e, this._languageService = t, this._model = this._editor.getModel(), this._domNode = document.createElement("div"), this._domNode.className = "tokens-inspect-widget", this._tokenizationSupport = (function(i, s) {
      const o = ci.get(s);
      if (o) return o;
      const r = i.encodeLanguageId(s);
      return { getInitialState: () => Vm, tokenize: (a, l, d) => ER(s, d), tokenizeEncoded: (a, l, d) => iL(r, d) };
    })(this._languageService.languageIdCodec, this._model.getLanguageId()), this._compute(this._editor.getPosition()), this._register(this._editor.onDidChangeCursorPosition(((i) => this._compute(this._editor.getPosition())))), this._editor.addContentWidget(this);
  }
  dispose() {
    this._editor.removeContentWidget(this), super.dispose();
  }
  getId() {
    return Sk._ID;
  }
  _compute(e) {
    const t = this._getTokensAtLine(e.lineNumber);
    let i = 0;
    for (let l = t.tokens1.length - 1; l >= 0; l--) {
      const d = t.tokens1[l];
      if (e.column - 1 >= d.offset) {
        i = l;
        break;
      }
    }
    let s = 0;
    for (let l = t.tokens2.length >>> 1; l >= 0; l--) if (e.column - 1 >= t.tokens2[l << 1]) {
      s = l;
      break;
    }
    const o = this._model.getLineContent(e.lineNumber);
    let r = "";
    if (i < t.tokens1.length) {
      const l = t.tokens1[i].offset, d = i + 1 < t.tokens1.length ? t.tokens1[i + 1].offset : o.length;
      r = o.substring(l, d);
    }
    wn(this._domNode, Q("h2.tm-token", void 0, (function(l) {
      let d = "";
      for (let h = 0, c = l.length; h < c; h++) {
        const u = l.charCodeAt(h);
        switch (u) {
          case 9:
            d += "→";
            break;
          case 32:
            d += "·";
            break;
          default:
            d += String.fromCharCode(u);
        }
      }
      return d;
    })(r), Q("span.tm-token-length", void 0, `${r.length} ${r.length === 1 ? "char" : "chars"}`))), Z(this._domNode, Q("hr.tokens-inspect-separator", { style: "clear:both" }));
    const a = 1 + (s << 1) < t.tokens2.length ? this._decodeMetadata(t.tokens2[1 + (s << 1)]) : null;
    Z(this._domNode, Q("table.tm-metadata-table", void 0, Q("tbody", void 0, Q("tr", void 0, Q("td.tm-metadata-key", void 0, "language"), Q("td.tm-metadata-value", void 0, `${a ? a.languageId : "-?-"}`)), Q("tr", void 0, Q("td.tm-metadata-key", void 0, "token type"), Q("td.tm-metadata-value", void 0, `${a ? this._tokenTypeToString(a.tokenType) : "-?-"}`)), Q("tr", void 0, Q("td.tm-metadata-key", void 0, "font style"), Q("td.tm-metadata-value", void 0, `${a ? this._fontStyleToString(a.fontStyle) : "-?-"}`)), Q("tr", void 0, Q("td.tm-metadata-key", void 0, "foreground"), Q("td.tm-metadata-value", void 0, `${a ? z.Format.CSS.formatHex(a.foreground) : "-?-"}`)), Q("tr", void 0, Q("td.tm-metadata-key", void 0, "background"), Q("td.tm-metadata-value", void 0, `${a ? z.Format.CSS.formatHex(a.background) : "-?-"}`))))), Z(this._domNode, Q("hr.tokens-inspect-separator")), i < t.tokens1.length && Z(this._domNode, Q("span.tm-token-type", void 0, t.tokens1[i].type)), this._editor.layoutContentWidget(this);
  }
  _decodeMetadata(e) {
    const t = ci.getColorMap(), i = In.getLanguageId(e), s = In.getTokenType(e), o = In.getFontStyle(e), r = In.getForeground(e), a = In.getBackground(e);
    return { languageId: this._languageService.languageIdCodec.decodeLanguageId(i), tokenType: s, fontStyle: o, foreground: t[r], background: t[a] };
  }
  _tokenTypeToString(e) {
    switch (e) {
      case 0:
        return "Other";
      case 1:
        return "Comment";
      case 2:
        return "String";
      case 3:
        return "RegEx";
      default:
        return "??";
    }
  }
  _fontStyleToString(e) {
    let t = "";
    return 1 & e && (t += "italic "), 2 & e && (t += "bold "), 4 & e && (t += "underline "), 8 & e && (t += "strikethrough "), t.length === 0 && (t = "---"), t;
  }
  _getTokensAtLine(e) {
    const t = this._getStateBeforeLine(e), i = this._tokenizationSupport.tokenize(this._model.getLineContent(e), !0, t), s = this._tokenizationSupport.tokenizeEncoded(this._model.getLineContent(e), !0, t);
    return { startState: t, tokens1: i.tokens, tokens2: s.tokens, endState: i.endState };
  }
  _getStateBeforeLine(e) {
    let t = this._tokenizationSupport.getInitialState();
    for (let i = 1; i < e; i++)
      t = this._tokenizationSupport.tokenize(this._model.getLineContent(i), !0, t).endState;
    return t;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return { position: this._editor.getPosition(), preference: [2, 1] };
  }
}
Sk._ID = "editor.contrib.inspectTokensWidget", ft(Mm.ID, Mm, 4), X(class extends he {
  constructor() {
    super({ id: "editor.action.inspectTokens", label: HI.inspectTokensAction, alias: "Developer: Inspect Tokens", precondition: void 0 });
  }
  run(n, e) {
    const t = Mm.get(e);
    t?.launch();
  }
});
var j_, Vhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, e7 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let SC = j_ = class {
  constructor(n, e) {
    this.quickInputService = n, this.keybindingService = e, this.registry = li.as(Tg);
  }
  provide(n) {
    const e = new G();
    return e.add(n.onDidAccept((() => {
      const [t] = n.selectedItems;
      t && this.quickInputService.quickAccess.show(t.prefix, { preserveValue: !0 });
    }))), e.add(n.onDidChangeValue(((t) => {
      const i = this.registry.getQuickAccessProvider(t.substr(j_.PREFIX.length));
      i && i.prefix && i.prefix !== j_.PREFIX && this.quickInputService.quickAccess.show(i.prefix, { preserveValue: !0 });
    }))), n.items = this.getQuickAccessProviders().filter(((t) => t.prefix !== j_.PREFIX)), e;
  }
  getQuickAccessProviders() {
    return this.registry.getQuickAccessProviders().sort(((n, e) => n.prefix.localeCompare(e.prefix))).flatMap(((n) => this.createPicks(n)));
  }
  createPicks(n) {
    return n.helpEntries.map(((e) => {
      const t = e.prefix || n.prefix, i = t || "…";
      return { prefix: t, label: i, keybinding: e.commandId ? this.keybindingService.lookupKeybinding(e.commandId) : void 0, ariaLabel: m(0, "{0}, {1}", i, e.description), description: e.description };
    }));
  }
};
SC.PREFIX = "?", SC = j_ = Vhe([e7(0, Sa), e7(1, Dt)], SC), li.as(Tg).registerQuickAccessProvider({ ctor: SC, prefix: "", helpEntries: [{ description: zI.helpQuickAccessActionLabel }] });
class NU {
  constructor(e) {
    this.options = e, this.rangeHighlightDecorationId = void 0;
  }
  provide(e, t) {
    var i;
    const s = new G();
    e.canAcceptInBackground = !!(!((i = this.options) === null || i === void 0) && i.canAcceptInBackground), e.matchOnLabel = e.matchOnDescription = e.matchOnDetail = e.sortByLabel = !1;
    const o = s.add(new rn());
    return o.value = this.doProvide(e, t), s.add(this.onDidActiveTextEditorControlChange((() => {
      o.value = void 0, o.value = this.doProvide(e, t);
    }))), s;
  }
  doProvide(e, t) {
    var i;
    const s = new G(), o = this.activeTextEditorControl;
    if (o && this.canProvideWithTextEditor(o)) {
      const r = { editor: o }, a = iH(o);
      if (a) {
        let l = (i = o.saveViewState()) !== null && i !== void 0 ? i : void 0;
        s.add(a.onDidChangeCursorPosition((() => {
          var d;
          l = (d = o.saveViewState()) !== null && d !== void 0 ? d : void 0;
        }))), r.restoreViewState = () => {
          l && o === this.activeTextEditorControl && o.restoreViewState(l);
        }, s.add(pc(t.onCancellationRequested)((() => {
          var d;
          return (d = r.restoreViewState) === null || d === void 0 ? void 0 : d.call(r);
        })));
      }
      s.add(ye((() => this.clearDecorations(o)))), s.add(this.provideWithTextEditor(r, e, t));
    } else s.add(this.provideWithoutTextEditor(e, t));
    return s;
  }
  canProvideWithTextEditor(e) {
    return !0;
  }
  gotoLocation({ editor: e }, t) {
    e.setSelection(t.range, "code.jump"), e.revealRangeInCenter(t.range, 0), t.preserveFocus || e.focus();
    const i = e.getModel();
    i && "getLineContent" in i && vl(`${i.getLineContent(t.range.startLineNumber)}`);
  }
  getModel(e) {
    var t;
    return oP(e) ? (t = e.getModel()) === null || t === void 0 ? void 0 : t.modified : e.getModel();
  }
  addDecorations(e, t) {
    e.changeDecorations(((i) => {
      const s = [];
      this.rangeHighlightDecorationId && (s.push(this.rangeHighlightDecorationId.overviewRulerDecorationId), s.push(this.rangeHighlightDecorationId.rangeHighlightId), this.rangeHighlightDecorationId = void 0);
      const o = [{ range: t, options: { description: "quick-access-range-highlight", className: "rangeHighlight", isWholeLine: !0 } }, { range: t, options: { description: "quick-access-range-highlight-overview", overviewRuler: { color: ui(EB), position: Do.Full } } }], [r, a] = i.deltaDecorations(s, o);
      this.rangeHighlightDecorationId = { rangeHighlightId: r, overviewRulerDecorationId: a };
    }));
  }
  clearDecorations(e) {
    const t = this.rangeHighlightDecorationId;
    t && (e.changeDecorations(((i) => {
      i.deltaDecorations([t.overviewRulerDecorationId, t.rangeHighlightId], []);
    })), this.rangeHighlightDecorationId = void 0);
  }
}
class Lk extends NU {
  constructor() {
    super({ canAcceptInBackground: !0 });
  }
  provideWithoutTextEditor(e) {
    const t = m(0, "Open a text editor first to go to a line.");
    return e.items = [{ label: t }], e.ariaLabel = t, V.None;
  }
  provideWithTextEditor(e, t, i) {
    const s = e.editor, o = new G();
    o.add(t.onDidAccept(((l) => {
      const [d] = t.selectedItems;
      if (d) {
        if (!this.isValidLineNumber(s, d.lineNumber)) return;
        this.gotoLocation(e, { range: this.toRange(d.lineNumber, d.column), keyMods: t.keyMods, preserveFocus: l.inBackground }), l.inBackground || t.hide();
      }
    })));
    const r = () => {
      const l = this.parsePosition(s, t.value.trim().substr(Lk.PREFIX.length)), d = this.getPickLabel(s, l.lineNumber, l.column);
      if (t.items = [{ lineNumber: l.lineNumber, column: l.column, label: d }], t.ariaLabel = d, !this.isValidLineNumber(s, l.lineNumber)) return void this.clearDecorations(s);
      const h = this.toRange(l.lineNumber, l.column);
      s.revealRangeInCenter(h, 0), this.addDecorations(s, h);
    };
    r(), o.add(t.onDidChangeValue((() => r())));
    const a = iH(s);
    return a && a.getOptions().get(68).renderType === 2 && (a.updateOptions({ lineNumbers: "on" }), o.add(ye((() => a.updateOptions({ lineNumbers: "relative" }))))), o;
  }
  toRange(e = 1, t = 1) {
    return { startLineNumber: e, startColumn: t, endLineNumber: e, endColumn: t };
  }
  parsePosition(e, t) {
    const i = t.split(/,|:|#/).map(((o) => parseInt(o, 10))).filter(((o) => !isNaN(o))), s = this.lineCount(e) + 1;
    return { lineNumber: i[0] > 0 ? i[0] : s + i[0], column: i[1] };
  }
  getPickLabel(e, t, i) {
    if (this.isValidLineNumber(e, t)) return this.isValidColumn(e, t, i) ? m(0, "Go to line {0} and character {1}.", t, i) : m(0, "Go to line {0}.", t);
    const s = e.getPosition() || { lineNumber: 1, column: 1 }, o = this.lineCount(e);
    return o > 1 ? m(0, "Current Line: {0}, Character: {1}. Type a line number between 1 and {2} to navigate to.", s.lineNumber, s.column, o) : m(0, "Current Line: {0}, Character: {1}. Type a line number to navigate to.", s.lineNumber, s.column);
  }
  isValidLineNumber(e, t) {
    return !(!t || typeof t != "number") && t > 0 && t <= this.lineCount(e);
  }
  isValidColumn(e, t, i) {
    if (!i || typeof i != "number") return !1;
    const s = this.getModel(e);
    if (!s) return !1;
    const o = { lineNumber: t, column: i };
    return s.validatePosition(o).equals(o);
  }
  lineCount(e) {
    var t, i;
    return (i = (t = this.getModel(e)) === null || t === void 0 ? void 0 : t.getLineCount()) !== null && i !== void 0 ? i : 0;
  }
}
Lk.PREFIX = ":";
var Hhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, zhe = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let h1 = class extends Lk {
  constructor(n) {
    super(), this.editorService = n, this.onDidActiveTextEditorControlChange = se.None;
  }
  get activeTextEditorControl() {
    var n;
    return (n = this.editorService.getFocusedCodeEditor()) !== null && n !== void 0 ? n : void 0;
  }
};
h1 = Hhe([zhe(0, mt)], h1);
let uN = class EU extends he {
  constructor() {
    super({ id: EU.ID, label: Iy.gotoLineActionLabel, alias: "Go to Line/Column...", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 2085, mac: { primary: 293 }, weight: 100 } });
  }
  run(e) {
    e.get(Sa).quickAccess.show(h1.PREFIX);
  }
};
uN.ID = "editor.action.gotoLine", X(uN), li.as(Tg).registerQuickAccessProvider({ ctor: h1, prefix: h1.PREFIX, helpEntries: [{ description: Iy.gotoLineActionLabel, commandId: uN.ID }] });
const IU = [void 0, []];
function gN(n, e, t = 0, i = 0) {
  const s = e;
  return s.values && s.values.length > 1 ? (function(o, r, a, l) {
    let d = 0;
    const h = [];
    for (const c of r) {
      const [u, g] = t7(o, c, a, l);
      if (typeof u != "number") return IU;
      d += u, h.push(...g);
    }
    return [d, Uhe(h)];
  })(n, s.values, t, i) : t7(n, e, t, i);
}
function t7(n, e, t, i) {
  const s = ug(e.original, e.originalLowercase, t, n, n.toLowerCase(), i, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
  return s ? [s[0], I1(s)] : IU;
}
function Uhe(n) {
  const e = n.sort(((s, o) => s.start - o.start)), t = [];
  let i;
  for (const s of e) i && Khe(i, s) ? (i.start = Math.min(i.start, s.start), i.end = Math.max(i.end, s.end)) : (i = s, t.push(s));
  return t;
}
function Khe(n, e) {
  return !(n.end < e.start) && !(e.end < n.start);
}
function i7(n) {
  return n.startsWith('"') && n.endsWith('"');
}
const MU = " ";
function WT(n) {
  typeof n != "string" && (n = "");
  const e = n.toLowerCase(), { pathNormalized: t, normalized: i, normalizedLowercase: s } = n7(n), o = t.indexOf(sa) >= 0, r = i7(n);
  let a;
  const l = n.split(MU);
  if (l.length > 1) for (const d of l) {
    const h = i7(d), { pathNormalized: c, normalized: u, normalizedLowercase: g } = n7(d);
    u && (a || (a = []), a.push({ original: d, originalLowercase: d.toLowerCase(), pathNormalized: c, normalized: u, normalizedLowercase: g, expectContiguousMatch: h }));
  }
  return { original: n, originalLowercase: e, pathNormalized: t, normalized: i, normalizedLowercase: s, values: a, containsPathSeparator: o, expectContiguousMatch: r };
}
function n7(n) {
  let e;
  e = Tn ? n.replace(/\//g, sa) : n.replace(/\\/g, sa);
  const t = (i = e, i.replace(/\*/g, "")).replace(/\s|"/g, "");
  var i;
  return { pathNormalized: e, normalized: t, normalizedLowercase: t.toLowerCase() };
}
function s7(n) {
  return Array.isArray(n) ? WT(n.map(((e) => e.original)).join(MU)) : WT(n.original);
}
var Tm, jhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, o7 = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let tl = Tm = class extends NU {
  constructor(n, e, t = /* @__PURE__ */ Object.create(null)) {
    super(t), this._languageFeaturesService = n, this._outlineModelService = e, this.options = t, this.options.canAcceptInBackground = !0;
  }
  provideWithoutTextEditor(n) {
    return this.provideLabelPick(n, m(0, "To go to a symbol, first open a text editor with symbol information.")), V.None;
  }
  provideWithTextEditor(n, e, t) {
    const i = n.editor, s = this.getModel(i);
    return s ? this._languageFeaturesService.documentSymbolProvider.has(s) ? this.doProvideWithEditorSymbols(n, s, e, t) : this.doProvideWithoutEditorSymbols(n, s, e, t) : V.None;
  }
  doProvideWithoutEditorSymbols(n, e, t, i) {
    const s = new G();
    return this.provideLabelPick(t, m(0, "The active text editor does not provide symbol information.")), (async () => await this.waitForLanguageSymbolRegistry(e, s) && !i.isCancellationRequested && s.add(this.doProvideWithEditorSymbols(n, e, t, i)))(), s;
  }
  provideLabelPick(n, e) {
    n.items = [{ label: e, index: 0, kind: 14 }], n.ariaLabel = e;
  }
  async waitForLanguageSymbolRegistry(n, e) {
    if (this._languageFeaturesService.documentSymbolProvider.has(n)) return !0;
    const t = new _1(), i = e.add(this._languageFeaturesService.documentSymbolProvider.onDidChange((() => {
      this._languageFeaturesService.documentSymbolProvider.has(n) && (i.dispose(), t.complete(!0));
    })));
    return e.add(ye((() => t.complete(!1)))), t.p;
  }
  doProvideWithEditorSymbols(n, e, t, i) {
    var s;
    const o = n.editor, r = new G();
    r.add(t.onDidAccept(((h) => {
      const [c] = t.selectedItems;
      c && c.range && (this.gotoLocation(n, { range: c.range.selection, keyMods: t.keyMods, preserveFocus: h.inBackground }), h.inBackground || t.hide());
    }))), r.add(t.onDidTriggerItemButton((({ item: h }) => {
      h && h.range && (this.gotoLocation(n, { range: h.range.selection, keyMods: t.keyMods, forceSideBySide: !0 }), t.hide());
    })));
    const a = this.getDocumentSymbols(e, i);
    let l;
    const d = async (h) => {
      l?.dispose(!0), t.busy = !1, l = new Ci(i), t.busy = !0;
      try {
        const c = WT(t.value.substr(Tm.PREFIX.length).trim()), u = await this.doGetSymbolPicks(a, c, void 0, l.token);
        if (i.isCancellationRequested) return;
        if (u.length > 0) {
          if (t.items = u, h && c.original.length === 0) {
            const g = iv(u, ((p) => !!(p.type !== "separator" && p.range && D.containsPosition(p.range.decoration, h))));
            g && (t.activeItems = [g]);
          }
        } else c.original.length > 0 ? this.provideLabelPick(t, m(0, "No matching editor symbols")) : this.provideLabelPick(t, m(0, "No editor symbols"));
      } finally {
        i.isCancellationRequested || (t.busy = !1);
      }
    };
    return r.add(t.onDidChangeValue((() => d(void 0)))), d((s = o.getSelection()) === null || s === void 0 ? void 0 : s.getPosition()), r.add(t.onDidChangeActive((() => {
      const [h] = t.activeItems;
      h && h.range && (o.revealRangeInCenter(h.range.selection, 0), this.addDecorations(o, h.range.decoration));
    }))), r;
  }
  async doGetSymbolPicks(n, e, t, i) {
    var s, o;
    const r = await n;
    if (i.isCancellationRequested) return [];
    const a = e.original.indexOf(Tm.SCOPE_PREFIX) === 0, l = a ? 1 : 0;
    let d, h, c;
    e.values && e.values.length > 1 ? (d = s7(e.values[0]), h = s7(e.values.slice(1))) : d = e;
    const u = (o = (s = this.options) === null || s === void 0 ? void 0 : s.openSideBySideDirection) === null || o === void 0 ? void 0 : o.call(s);
    u && (c = [{ iconClass: u === "right" ? Ee.asClassName(ne.splitHorizontal) : Ee.asClassName(ne.splitVertical), tooltip: m(0, u === "right" ? "Open to the Side" : "Open to the Bottom") }]);
    const g = [];
    for (let b = 0; b < r.length; b++) {
      const C = r[b], w = LK(C.name), y = `$(${Rw.toIcon(C.kind).id}) ${w}`, L = y.length - w.length;
      let k, N, A, B, T = C.containerName;
      if (t?.extraContainerLabel && (T = T ? `${t.extraContainerLabel} • ${T}` : t.extraContainerLabel), e.original.length > l) {
        let H = !1;
        if (d !== e && ([k, N] = gN(y, { ...e, values: void 0 }, l, L), typeof k == "number" && (H = !0)), typeof k != "number" && ([k, N] = gN(y, d, l, L), typeof k != "number")) continue;
        if (!H && h) {
          if (T && h.original.length > 0 && ([A, B] = gN(T, h)), typeof A != "number") continue;
          typeof k == "number" && (k += A);
        }
      }
      const O = C.tags && C.tags.indexOf(1) >= 0;
      g.push({ index: b, kind: C.kind, score: k, label: y, ariaLabel: (p = C.name, f = C.kind, m(0, "{0} ({1})", p, wK[f])), description: T, highlights: O ? void 0 : { label: N, description: B }, range: { selection: D.collapseToStart(C.selectionRange), decoration: C.range }, strikethrough: O, buttons: c });
    }
    var p, f;
    const _ = g.sort(((b, C) => a ? this.compareByKindAndScore(b, C) : this.compareByScore(b, C)));
    let v = [];
    if (a) {
      let y = function() {
        C && typeof b == "number" && w > 0 && (C.label = sg(mN[b] || pN, w));
      }, b, C, w = 0;
      for (const L of _) b !== L.kind ? (y(), b = L.kind, w = 1, C = { type: "separator" }, v.push(C)) : w++, v.push(L);
      y();
    } else _.length > 0 && (v = [{ label: m(0, "symbols ({0})", g.length), type: "separator" }, ..._]);
    return v;
  }
  compareByScore(n, e) {
    if (typeof n.score != "number" && typeof e.score == "number") return 1;
    if (typeof n.score == "number" && typeof e.score != "number") return -1;
    if (typeof n.score == "number" && typeof e.score == "number") {
      if (n.score > e.score) return -1;
      if (n.score < e.score) return 1;
    }
    return n.index < e.index ? -1 : n.index > e.index ? 1 : 0;
  }
  compareByKindAndScore(n, e) {
    const t = mN[n.kind] || pN, i = mN[e.kind] || pN, s = t.localeCompare(i);
    return s === 0 ? this.compareByScore(n, e) : s;
  }
  async getDocumentSymbols(n, e) {
    const t = await this._outlineModelService.getOrCreate(n, e);
    return e.isCancellationRequested ? [] : t.asListOfDocumentSymbols();
  }
};
tl.PREFIX = "@", tl.SCOPE_PREFIX = ":", tl.PREFIX_BY_CATEGORY = `${Tm.PREFIX}${Tm.SCOPE_PREFIX}`, tl = Tm = jhe([o7(0, fe), o7(1, t1)], tl);
const pN = m(0, "properties ({0})"), mN = { 5: m(0, "methods ({0})"), 11: m(0, "functions ({0})"), 8: m(0, "constructors ({0})"), 12: m(0, "variables ({0})"), 4: m(0, "classes ({0})"), 22: m(0, "structs ({0})"), 23: m(0, "events ({0})"), 24: m(0, "operators ({0})"), 10: m(0, "interfaces ({0})"), 2: m(0, "namespaces ({0})"), 3: m(0, "packages ({0})"), 25: m(0, "type parameters ({0})"), 1: m(0, "modules ({0})"), 6: m(0, "properties ({0})"), 9: m(0, "enumerations ({0})"), 21: m(0, "enumeration members ({0})"), 14: m(0, "strings ({0})"), 0: m(0, "files ({0})"), 17: m(0, "arrays ({0})"), 15: m(0, "numbers ({0})"), 16: m(0, "booleans ({0})"), 18: m(0, "objects ({0})"), 19: m(0, "keys ({0})"), 7: m(0, "fields ({0})"), 13: m(0, "constants ({0})") };
var qhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, fN = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let VT = class extends tl {
  constructor(n, e, t) {
    super(e, t), this.editorService = n, this.onDidActiveTextEditorControlChange = se.None;
  }
  get activeTextEditorControl() {
    var n;
    return (n = this.editorService.getFocusedCodeEditor()) !== null && n !== void 0 ? n : void 0;
  }
};
VT = qhe([fN(0, mt), fN(1, fe), fN(2, t1)], VT);
class B0 extends he {
  constructor() {
    super({ id: B0.ID, label: xv.quickOutlineActionLabel, alias: "Go to Symbol...", precondition: E.hasDocumentSymbolProvider, kbOpts: { kbExpr: E.focus, primary: 3117, weight: 100 }, contextMenuOpts: { group: "navigation", order: 3 } });
  }
  run(e) {
    e.get(Sa).quickAccess.show(tl.PREFIX, { itemActivation: Kr.NONE });
  }
}
function _N(n, e) {
  return e && (n.stack || n.stacktrace) ? m(0, "{0}: {1}", a7(n), r7(n.stack) || r7(n.stacktrace)) : a7(n);
}
function r7(n) {
  return Array.isArray(n) ? n.join(`
`) : n;
}
function a7(n) {
  return n.code === "ERR_UNC_HOST_NOT_ALLOWED" ? `${n.message}. Please update the 'security.allowedUNCHosts' setting if you want to allow this host.` : typeof n.code == "string" && typeof n.errno == "number" && typeof n.syscall == "string" ? m(0, "A system error occurred ({0})", n.message) : n.message || m(0, "An unknown error occurred. Please consult the log for more details.");
}
function TU(n = null, e = !1) {
  if (!n) return m(0, "An unknown error occurred. Please consult the log for more details.");
  if (Array.isArray(n)) {
    const t = ha(n), i = TU(t[0], e);
    return t.length > 1 ? m(0, "{0} ({1} errors in total)", i, t.length) : i;
  }
  if (ps(n)) return n;
  if (n.detail) {
    const t = n.detail;
    if (t.error) return _N(t.error, e);
    if (t.exception) return _N(t.exception, e);
  }
  return n.stack ? _N(n, e) : n.message ? n.message : m(0, "An unknown error occurred. Please consult the log for more details.");
}
B0.ID = "editor.action.quickOutline", X(B0), li.as(Tg).registerQuickAccessProvider({ ctor: VT, prefix: tl.PREFIX, helpEntries: [{ description: xv.quickOutlineActionLabel, prefix: tl.PREFIX, commandId: B0.ID }, { description: xv.quickOutlineByCategoryActionLabel, prefix: tl.PREFIX_BY_CATEGORY }] });
class W0 {
  constructor() {
    this.chunkCount = 0, this.chunkOccurrences = /* @__PURE__ */ new Map(), this.documents = /* @__PURE__ */ new Map();
  }
  calculateScores(e, t) {
    const i = this.computeEmbedding(e), s = /* @__PURE__ */ new Map(), o = [];
    for (const [r, a] of this.documents) {
      if (t.isCancellationRequested) return [];
      for (const l of a.chunks) {
        const d = this.computeSimilarityScore(l, i, s);
        d > 0 && o.push({ key: r, score: d });
      }
    }
    return o;
  }
  static termFrequencies(e) {
    return (function(t) {
      var i;
      const s = /* @__PURE__ */ new Map();
      for (const o of t) s.set(o, ((i = s.get(o)) !== null && i !== void 0 ? i : 0) + 1);
      return s;
    })(W0.splitTerms(e));
  }
  static *splitTerms(e) {
    const t = (i) => i.toLowerCase();
    for (const [i] of e.matchAll(new RegExp("\\b\\p{Letter}[\\p{Letter}\\d]{2,}\\b", "gu"))) {
      yield t(i);
      const s = i.replace(/([a-z])([A-Z])/g, "$1 $2").split(/\s+/g);
      if (s.length > 1) for (const o of s) o.length > 2 && new RegExp("\\p{Letter}{3,}", "gu").test(o) && (yield t(o));
    }
  }
  updateDocuments(e) {
    var t;
    for (const { key: i } of e) this.deleteDocument(i);
    for (const i of e) {
      const s = [];
      for (const o of i.textChunks) {
        const r = W0.termFrequencies(o);
        for (const a of r.keys()) this.chunkOccurrences.set(a, ((t = this.chunkOccurrences.get(a)) !== null && t !== void 0 ? t : 0) + 1);
        s.push({ text: o, tf: r });
      }
      this.chunkCount += s.length, this.documents.set(i.key, { chunks: s });
    }
    return this;
  }
  deleteDocument(e) {
    const t = this.documents.get(e);
    if (t) {
      this.documents.delete(e), this.chunkCount -= t.chunks.length;
      for (const i of t.chunks) for (const s of i.tf.keys()) {
        const o = this.chunkOccurrences.get(s);
        if (typeof o == "number") {
          const r = o - 1;
          r <= 0 ? this.chunkOccurrences.delete(s) : this.chunkOccurrences.set(s, r);
        }
      }
    }
  }
  computeSimilarityScore(e, t, i) {
    let s = 0;
    for (const [o, r] of Object.entries(t)) {
      const a = e.tf.get(o);
      if (!a) continue;
      let l = i.get(o);
      typeof l != "number" && (l = this.computeIdf(o), i.set(o, l)), s += a * l * r;
    }
    return s;
  }
  computeEmbedding(e) {
    const t = W0.termFrequencies(e);
    return this.computeTfidf(t);
  }
  computeIdf(e) {
    var t;
    const i = (t = this.chunkOccurrences.get(e)) !== null && t !== void 0 ? t : 0;
    return i > 0 ? Math.log((this.chunkCount + 1) / i) : 0;
  }
  computeTfidf(e) {
    const t = /* @__PURE__ */ Object.create(null);
    for (const [i, s] of e) {
      const o = this.computeIdf(i);
      o > 0 && (t[i] = s * o);
    }
    return t;
  }
}
var Gp;
function vN(n) {
  const e = n;
  return Array.isArray(e.items);
}
function l7(n) {
  const e = n;
  return !!e.picks && e.additionalPicks instanceof Promise;
}
(function(n) {
  n[n.NO_ACTION = 0] = "NO_ACTION", n[n.CLOSE_PICKER = 1] = "CLOSE_PICKER", n[n.REFRESH_PICKER = 2] = "REFRESH_PICKER", n[n.REMOVE_ITEM = 3] = "REMOVE_ITEM";
})(Gp || (Gp = {}));
class $he extends V {
  constructor(e, t) {
    super(), this.prefix = e, this.options = t;
  }
  provide(e, t, i) {
    var s;
    const o = new G();
    let r;
    e.canAcceptInBackground = !!(!((s = this.options) === null || s === void 0) && s.canAcceptInBackground), e.matchOnLabel = e.matchOnDescription = e.matchOnDetail = e.sortByLabel = !1;
    const a = o.add(new rn()), l = async () => {
      var h;
      const c = a.value = new G();
      r?.dispose(!0), e.busy = !1, r = new Ci(t);
      const u = r.token;
      let g = e.value.substring(this.prefix.length);
      !((h = this.options) === null || h === void 0) && h.shouldSkipTrimPickFilter || (g = g.trim());
      const p = this._getPicks(g, c, u, i), f = (v, b) => {
        var C;
        let w, y;
        if (vN(v) ? (w = v.items, y = v.active) : w = v, w.length === 0) {
          if (b) return !1;
          (g.length > 0 || e.hideInput) && (!((C = this.options) === null || C === void 0) && C.noResultsPick) && (w = U0(this.options.noResultsPick) ? [this.options.noResultsPick(g)] : [this.options.noResultsPick]);
        }
        return e.items = w, y && (e.activeItems = [y]), !0;
      }, _ = async (v) => {
        let b = !1, C = !1;
        await Promise.all([(async () => {
          typeof v.mergeDelay == "number" && (await vc(v.mergeDelay), u.isCancellationRequested) || C || (b = f(v.picks, !0));
        })(), (async () => {
          e.busy = !0;
          try {
            const w = await v.additionalPicks;
            if (u.isCancellationRequested) return;
            let y, L, k, N;
            if (vN(v.picks) ? (y = v.picks.items, L = v.picks.active) : y = v.picks, vN(w) ? (k = w.items, N = w.active) : k = w, k.length > 0 || !b) {
              let A;
              if (!L && !N) {
                const B = e.activeItems[0];
                B && y.indexOf(B) !== -1 && (A = B);
              }
              f({ items: [...y, ...k], active: L || N || A });
            }
          } finally {
            u.isCancellationRequested || (e.busy = !1), C = !0;
          }
        })()]);
      };
      if (p !== null) if (l7(p)) await _(p);
      else if (p instanceof Promise) {
        e.busy = !0;
        try {
          const v = await p;
          if (u.isCancellationRequested) return;
          l7(v) ? await _(v) : f(v);
        } finally {
          u.isCancellationRequested || (e.busy = !1);
        }
      } else f(p);
    };
    o.add(e.onDidChangeValue((() => l()))), l(), o.add(e.onDidAccept(((h) => {
      const [c] = e.selectedItems;
      typeof c?.accept == "function" && (h.inBackground || e.hide(), c.accept(e.keyMods, h));
    })));
    const d = async (h, c) => {
      var u, g;
      if (typeof c.trigger != "function") return;
      const p = (g = (u = c.buttons) === null || u === void 0 ? void 0 : u.indexOf(h)) !== null && g !== void 0 ? g : -1;
      if (p >= 0) {
        const f = c.trigger(p, e.keyMods), _ = typeof f == "number" ? f : await f;
        if (t.isCancellationRequested) return;
        switch (_) {
          case Gp.NO_ACTION:
            break;
          case Gp.CLOSE_PICKER:
            e.hide();
            break;
          case Gp.REFRESH_PICKER:
            l();
            break;
          case Gp.REMOVE_ITEM: {
            const v = e.items.indexOf(c);
            if (v !== -1) {
              const b = e.items.slice(), C = b.splice(v, 1), w = e.activeItems.filter(((L) => L !== C[0])), y = e.keepScrollPosition;
              e.keepScrollPosition = !0, e.items = b, w && (e.activeItems = w), e.keepScrollPosition = y;
            }
            break;
          }
        }
      }
    };
    return o.add(e.onDidTriggerItemButton((({ button: h, item: c }) => d(h, c)))), o.add(e.onDidTriggerSeparatorButton((({ button: h, separator: c }) => d(h, c)))), o;
  }
}
var cu, Bi, RU = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, kh = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let uu = cu = class extends $he {
  constructor(n, e, t, i, s, o) {
    super(cu.PREFIX, n), this.instantiationService = e, this.keybindingService = t, this.commandService = i, this.telemetryService = s, this.dialogService = o, this.commandsHistory = this._register(this.instantiationService.createInstance(uh)), this.options = n;
  }
  async _getPicks(n, e, t, i) {
    var s, o, r, a;
    const l = await this.getCommandPicks(t);
    if (t.isCancellationRequested) return [];
    const d = pc((() => {
      const _ = new W0();
      return _.updateDocuments(l.map(((v) => ({ key: v.commandId, textChunks: [this.getTfIdfChunk(v)] })))), (function(v) {
        var b, C;
        const w = v.slice(0);
        w.sort(((L, k) => k.score - L.score));
        const y = (C = (b = w[0]) === null || b === void 0 ? void 0 : b.score) !== null && C !== void 0 ? C : 0;
        if (y > 0) for (const L of w) L.score /= y;
        return w;
      })(_.calculateScores(n, t)).filter(((v) => v.score > cu.TFIDF_THRESHOLD)).slice(0, cu.TFIDF_MAX_RESULTS);
    })), h = [];
    for (const _ of l) {
      const v = (s = cu.WORD_FILTER(n, _.label)) !== null && s !== void 0 ? s : void 0, b = _.commandAlias && (o = cu.WORD_FILTER(n, _.commandAlias)) !== null && o !== void 0 ? o : void 0;
      if (v || b) _.highlights = { label: v, detail: this.options.showAlias ? b : void 0 }, h.push(_);
      else if (n === _.commandId) h.push(_);
      else if (n.length >= 3) {
        const C = d();
        if (t.isCancellationRequested) return [];
        const w = C.find(((y) => y.key === _.commandId));
        w && (_.tfIdfScore = w.score, h.push(_));
      }
    }
    const c = /* @__PURE__ */ new Map();
    for (const _ of h) {
      const v = c.get(_.label);
      v ? (_.description = _.commandId, v.description = v.commandId) : c.set(_.label, _);
    }
    h.sort(((_, v) => {
      if (_.tfIdfScore && v.tfIdfScore) return _.tfIdfScore === v.tfIdfScore ? _.label.localeCompare(v.label) : v.tfIdfScore - _.tfIdfScore;
      if (_.tfIdfScore) return 1;
      if (v.tfIdfScore) return -1;
      const b = this.commandsHistory.peek(_.commandId), C = this.commandsHistory.peek(v.commandId);
      if (b && C) return b > C ? -1 : 1;
      if (b) return -1;
      if (C) return 1;
      if (this.options.suggestedCommandIds) {
        const w = this.options.suggestedCommandIds.has(_.commandId), y = this.options.suggestedCommandIds.has(v.commandId);
        if (w && y) return 0;
        if (w) return -1;
        if (y) return 1;
      }
      return _.label.localeCompare(v.label);
    }));
    const u = [];
    let g = !1, p = !0, f = !!this.options.suggestedCommandIds;
    for (let _ = 0; _ < h.length; _++) {
      const v = h[_];
      _ === 0 && this.commandsHistory.peek(v.commandId) && (u.push({ type: "separator", label: m(0, "recently used") }), g = !0), p && v.tfIdfScore !== void 0 && (u.push({ type: "separator", label: m(0, "similar commands") }), p = !1), f && v.tfIdfScore === void 0 && !this.commandsHistory.peek(v.commandId) && (!((r = this.options.suggestedCommandIds) === null || r === void 0) && r.has(v.commandId)) && (u.push({ type: "separator", label: m(0, "commonly used") }), g = !0, f = !1), !g || v.tfIdfScore !== void 0 || this.commandsHistory.peek(v.commandId) || !((a = this.options.suggestedCommandIds) === null || a === void 0) && a.has(v.commandId) || (u.push({ type: "separator", label: m(0, "other commands") }), g = !1), u.push(this.toCommandPick(v, i));
    }
    return this.hasAdditionalCommandPicks(n, t) ? { picks: u, additionalPicks: (async () => {
      var _;
      const v = await this.getAdditionalCommandPicks(l, h, n, t);
      if (t.isCancellationRequested) return [];
      const b = v.map(((C) => this.toCommandPick(C, i)));
      return p && ((_ = b[0]) === null || _ === void 0 ? void 0 : _.type) !== "separator" && b.unshift({ type: "separator", label: m(0, "similar commands") }), b;
    })() } : u;
  }
  toCommandPick(n, e) {
    if (n.type === "separator") return n;
    const t = this.keybindingService.lookupKeybinding(n.commandId), i = t ? m(0, "{0}, {1}", n.label, t.getAriaLabel()) : n.label;
    return { ...n, ariaLabel: i, detail: this.options.showAlias && n.commandAlias !== n.label ? n.commandAlias : void 0, keybinding: t, accept: async () => {
      var s, o;
      this.commandsHistory.push(n.commandId), this.telemetryService.publicLog2("workbenchActionExecuted", { id: n.commandId, from: (s = e?.from) !== null && s !== void 0 ? s : "quick open" });
      try {
        !((o = n.args) === null || o === void 0) && o.length ? await this.commandService.executeCommand(n.commandId, ...n.args) : await this.commandService.executeCommand(n.commandId);
      } catch (r) {
        ya(r) || this.dialogService.error(m(0, "Command '{0}' resulted in an error", n.label), TU(r));
      }
    } };
  }
  getTfIdfChunk({ label: n, commandAlias: e, commandDescription: t }) {
    let i = n;
    return e && e !== n && (i += ` - ${e}`), t && t.value !== n && (i += ` - ${t.value === t.original ? t.value : `${t.value} (${t.original})`}`), i;
  }
};
uu.PREFIX = ">", uu.TFIDF_THRESHOLD = 0.5, uu.TFIDF_MAX_RESULTS = 5, uu.WORD_FILTER = fA(kv, (function(n, e, t = !1) {
  if (!e || e.length === 0) return null;
  let i = null, s = 0;
  for (n = n.toLowerCase(), e = e.toLowerCase(); s < e.length && (i = MI(n, e, 0, s, t), i === null); ) s = PW(e, s + 1);
  return i;
}), NW), uu = cu = RU([kh(1, Se), kh(2, Dt), kh(3, ai), kh(4, es), kh(5, E1)], uu);
let uh = Bi = class extends V {
  constructor(n, e, t) {
    super(), this.storageService = n, this.configurationService = e, this.logService = t, this.configuredCommandsHistoryLength = 0, this.updateConfiguration(), this.load(), this.registerListeners();
  }
  registerListeners() {
    this._register(this.configurationService.onDidChangeConfiguration(((n) => this.updateConfiguration(n)))), this._register(this.storageService.onWillSaveState(((n) => {
      n.reason === Pv.SHUTDOWN && this.saveState();
    })));
  }
  updateConfiguration(n) {
    n && !n.affectsConfiguration("workbench.commandPalette.history") || (this.configuredCommandsHistoryLength = Bi.getConfiguredCommandHistoryLength(this.configurationService), Bi.cache && Bi.cache.limit !== this.configuredCommandsHistoryLength && (Bi.cache.limit = this.configuredCommandsHistoryLength, Bi.hasChanges = !0));
  }
  load() {
    const n = this.storageService.get(Bi.PREF_KEY_CACHE, 0);
    let e;
    if (n) try {
      e = JSON.parse(n);
    } catch (i) {
      this.logService.error(`[CommandsHistory] invalid data: ${i}`);
    }
    const t = Bi.cache = new Ll(this.configuredCommandsHistoryLength, 1);
    if (e) {
      let i;
      i = e.usesLRU ? e.entries : e.entries.sort(((s, o) => s.value - o.value)), i.forEach(((s) => t.set(s.key, s.value)));
    }
    Bi.counter = this.storageService.getNumber(Bi.PREF_KEY_COUNTER, 0, Bi.counter);
  }
  push(n) {
    Bi.cache && (Bi.cache.set(n, Bi.counter++), Bi.hasChanges = !0);
  }
  peek(n) {
    var e;
    return (e = Bi.cache) === null || e === void 0 ? void 0 : e.peek(n);
  }
  saveState() {
    if (!Bi.cache || !Bi.hasChanges) return;
    const n = { usesLRU: !0, entries: [] };
    Bi.cache.forEach(((e, t) => n.entries.push({ key: t, value: e }))), this.storageService.store(Bi.PREF_KEY_CACHE, JSON.stringify(n), 0, 0), this.storageService.store(Bi.PREF_KEY_COUNTER, Bi.counter, 0, 0), Bi.hasChanges = !1;
  }
  static getConfiguredCommandHistoryLength(n) {
    var e, t;
    const i = (t = (e = n.getValue().workbench) === null || e === void 0 ? void 0 : e.commandPalette) === null || t === void 0 ? void 0 : t.history;
    return typeof i == "number" ? i : Bi.DEFAULT_COMMANDS_HISTORY_LENGTH;
  }
};
uh.DEFAULT_COMMANDS_HISTORY_LENGTH = 50, uh.PREF_KEY_CACHE = "commandPalette.mru.cache", uh.PREF_KEY_COUNTER = "commandPalette.mru.counter", uh.counter = 1, uh.hasChanges = !1, uh = Bi = RU([kh(0, Nr), kh(1, Ye), kh(2, ts)], uh);
class Ghe extends uu {
  constructor(e, t, i, s, o, r) {
    super(e, t, i, s, o, r);
  }
  getCodeEditorCommandPicks() {
    const e = this.activeTextEditorControl;
    if (!e) return [];
    const t = [];
    for (const i of e.getSupportedActions()) t.push({ commandId: i.id, commandAlias: i.alias, label: wA(i.label) || i.id });
    return t;
  }
}
var Zhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, cp = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let c1 = class extends Ghe {
  get activeTextEditorControl() {
    var n;
    return (n = this.codeEditorService.getFocusedCodeEditor()) !== null && n !== void 0 ? n : void 0;
  }
  constructor(n, e, t, i, s, o) {
    super({ showAlias: !1 }, n, t, i, s, o), this.codeEditorService = e;
  }
  async getCommandPicks() {
    return this.getCodeEditorCommandPicks();
  }
  hasAdditionalCommandPicks() {
    return !1;
  }
  async getAdditionalCommandPicks() {
    return [];
  }
};
c1 = Zhe([cp(0, Se), cp(1, mt), cp(2, Dt), cp(3, ai), cp(4, es), cp(5, E1)], c1);
class V0 extends he {
  constructor() {
    super({ id: V0.ID, label: My.quickCommandActionLabel, alias: "Command Palette", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 59, weight: 100 }, contextMenuOpts: { group: "z_commands", order: 1 } });
  }
  run(e) {
    e.get(Sa).quickAccess.show(c1.PREFIX);
  }
}
V0.ID = "editor.action.quickCommand", X(V0), li.as(Tg).registerQuickAccessProvider({ ctor: c1, prefix: c1.PREFIX, helpEntries: [{ description: My.quickCommandHelp, commandId: V0.ID }] });
var Yhe = function(n, e, t, i) {
  var s, o = arguments.length, r = o < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(n, e, t, i);
  else for (var a = n.length - 1; a >= 0; a--) (s = n[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, up = function(n, e) {
  return function(t, i) {
    e(t, i, n);
  };
};
let bN = class extends ac {
  constructor(n, e, t, i, s, o, r) {
    super(!0, n, e, t, i, s, o, r);
  }
};
bN = Yhe([up(1, Te), up(2, mt), up(3, Ri), up(4, Se), up(5, Nr), up(6, Ye)], bN), ft(ac.ID, bN, 4);
X(class extends he {
  constructor() {
    super({ id: "editor.action.toggleHighContrast", label: UI.toggleHighContrast, alias: "Toggle High Contrast Theme", precondition: void 0 }), this._originalThemeName = null;
  }
  run(n, e) {
    const t = n.get(Ro), i = t.getColorTheme();
    aa(i.type) ? (t.setTheme(this._originalThemeName || (zm(i.type) ? bm : td)), this._originalThemeName = null) : (t.setTheme(zm(i.type) ? $u : Gu), this._originalThemeName = i.themeName);
  }
});
const Dce = Object.freeze(Object.defineProperty({ __proto__: null, CancellationTokenSource: rH, Emitter: rP, KeyCode: aH, KeyMod: lH, MarkerSeverity: gH, MarkerTag: pH, Position: dH, Range: hH, Selection: cH, SelectionDirection: uH, Token: fH, Uri: mH, editor: _H, languages: C0 }, Symbol.toStringTag, { value: "Module" }));
function Xhe(n) {
  return new Worker("/assets/editor.worker-bC97SofN.js", { name: n?.name });
}
function Qhe(n) {
  return new Worker("/assets/json.worker-Bcdi5VFc.js", { name: n?.name });
}
function Jhe(n) {
  return new Worker("/assets/css.worker-DJu1U97v.js", { name: n?.name });
}
function ece(n) {
  return new Worker("/assets/html.worker-CtIwIR74.js", { name: n?.name });
}
function tce(n) {
  return new Worker("/assets/ts.worker-DZwTjWhb.js", { name: n?.name });
}
function ice(n) {
  return new Worker("/assets/yaml.worker-Bep3HbPQ.js", { name: n?.name });
}
function d7(n, e, t) {
  const i = /* @__PURE__ */ new Map(), s = (c) => {
    const u = c.getLanguageId();
    return Array.isArray(e) ? e.includes(u) : e === u;
  }, o = async (c) => {
    const u = c.getVersionId(), g = await t.provideMarkerData(c);
    u === c.getVersionId() && !c.isDisposed() && s(c) && n.editor.setModelMarkers(c, t.owner, g ?? []);
  }, r = (c) => {
    if (!s(c)) return;
    let u;
    i.set(c, c.onDidChangeContent((() => {
      clearTimeout(u), u = setTimeout((() => {
        o(c);
      }), 500);
    }))), o(c);
  }, a = (c) => {
    n.editor.setModelMarkers(c, t.owner, []);
    const u = i.get(c);
    u && (u.dispose(), i.delete(c));
  }, l = n.editor.onDidCreateModel(r), d = n.editor.onWillDisposeModel(((c) => {
    a(c), t.doReset?.(c);
  })), h = n.editor.onDidChangeModelLanguage(((c) => {
    a(c.model), r(c.model), t.doReset?.(c.model);
  }));
  for (const c of n.editor.getModels()) r(c);
  return { dispose() {
    for (const c of i.keys()) a(c);
    l.dispose(), d.dispose(), h.dispose();
  }, async revalidate() {
    await Promise.all(n.editor.getModels().map(o));
  } };
}
var AU;
(() => {
  var n = { 470: (s) => {
    function o(l) {
      if (typeof l != "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(l));
    }
    function r(l, d) {
      for (var h, c = "", u = 0, g = -1, p = 0, f = 0; f <= l.length; ++f) {
        if (f < l.length) h = l.charCodeAt(f);
        else {
          if (h === 47) break;
          h = 47;
        }
        if (h === 47) {
          if (!(g === f - 1 || p === 1)) if (g !== f - 1 && p === 2) {
            if (c.length < 2 || u !== 2 || c.charCodeAt(c.length - 1) !== 46 || c.charCodeAt(c.length - 2) !== 46) {
              if (c.length > 2) {
                var _ = c.lastIndexOf("/");
                if (_ !== c.length - 1) {
                  _ === -1 ? (c = "", u = 0) : u = (c = c.slice(0, _)).length - 1 - c.lastIndexOf("/"), g = f, p = 0;
                  continue;
                }
              } else if (c.length === 2 || c.length === 1) {
                c = "", u = 0, g = f, p = 0;
                continue;
              }
            }
            d && (c.length > 0 ? c += "/.." : c = "..", u = 2);
          } else c.length > 0 ? c += "/" + l.slice(g + 1, f) : c = l.slice(g + 1, f), u = f - g - 1;
          g = f, p = 0;
        } else h === 46 && p !== -1 ? ++p : p = -1;
      }
      return c;
    }
    var a = { resolve: function() {
      for (var l, d = "", h = !1, c = arguments.length - 1; c >= -1 && !h; c--) {
        var u;
        c >= 0 ? u = arguments[c] : (l === void 0 && (l = process.cwd()), u = l), o(u), u.length !== 0 && (d = u + "/" + d, h = u.charCodeAt(0) === 47);
      }
      return d = r(d, !h), h ? d.length > 0 ? "/" + d : "/" : d.length > 0 ? d : ".";
    }, normalize: function(l) {
      if (o(l), l.length === 0) return ".";
      var d = l.charCodeAt(0) === 47, h = l.charCodeAt(l.length - 1) === 47;
      return (l = r(l, !d)).length !== 0 || d || (l = "."), l.length > 0 && h && (l += "/"), d ? "/" + l : l;
    }, isAbsolute: function(l) {
      return o(l), l.length > 0 && l.charCodeAt(0) === 47;
    }, join: function() {
      if (arguments.length === 0) return ".";
      for (var l, d = 0; d < arguments.length; ++d) {
        var h = arguments[d];
        o(h), h.length > 0 && (l === void 0 ? l = h : l += "/" + h);
      }
      return l === void 0 ? "." : a.normalize(l);
    }, relative: function(l, d) {
      if (o(l), o(d), l === d || (l = a.resolve(l)) === (d = a.resolve(d))) return "";
      for (var h = 1; h < l.length && l.charCodeAt(h) === 47; ++h) ;
      for (var c = l.length, u = c - h, g = 1; g < d.length && d.charCodeAt(g) === 47; ++g) ;
      for (var p = d.length - g, f = u < p ? u : p, _ = -1, v = 0; v <= f; ++v) {
        if (v === f) {
          if (p > f) {
            if (d.charCodeAt(g + v) === 47) return d.slice(g + v + 1);
            if (v === 0) return d.slice(g + v);
          } else u > f && (l.charCodeAt(h + v) === 47 ? _ = v : v === 0 && (_ = 0));
          break;
        }
        var b = l.charCodeAt(h + v);
        if (b !== d.charCodeAt(g + v)) break;
        b === 47 && (_ = v);
      }
      var C = "";
      for (v = h + _ + 1; v <= c; ++v) v !== c && l.charCodeAt(v) !== 47 || (C.length === 0 ? C += ".." : C += "/..");
      return C.length > 0 ? C + d.slice(g + _) : (g += _, d.charCodeAt(g) === 47 && ++g, d.slice(g));
    }, _makeLong: function(l) {
      return l;
    }, dirname: function(l) {
      if (o(l), l.length === 0) return ".";
      for (var d = l.charCodeAt(0), h = d === 47, c = -1, u = !0, g = l.length - 1; g >= 1; --g) if ((d = l.charCodeAt(g)) === 47) {
        if (!u) {
          c = g;
          break;
        }
      } else u = !1;
      return c === -1 ? h ? "/" : "." : h && c === 1 ? "//" : l.slice(0, c);
    }, basename: function(l, d) {
      if (d !== void 0 && typeof d != "string") throw new TypeError('"ext" argument must be a string');
      o(l);
      var h, c = 0, u = -1, g = !0;
      if (d !== void 0 && d.length > 0 && d.length <= l.length) {
        if (d.length === l.length && d === l) return "";
        var p = d.length - 1, f = -1;
        for (h = l.length - 1; h >= 0; --h) {
          var _ = l.charCodeAt(h);
          if (_ === 47) {
            if (!g) {
              c = h + 1;
              break;
            }
          } else f === -1 && (g = !1, f = h + 1), p >= 0 && (_ === d.charCodeAt(p) ? --p == -1 && (u = h) : (p = -1, u = f));
        }
        return c === u ? u = f : u === -1 && (u = l.length), l.slice(c, u);
      }
      for (h = l.length - 1; h >= 0; --h) if (l.charCodeAt(h) === 47) {
        if (!g) {
          c = h + 1;
          break;
        }
      } else u === -1 && (g = !1, u = h + 1);
      return u === -1 ? "" : l.slice(c, u);
    }, extname: function(l) {
      o(l);
      for (var d = -1, h = 0, c = -1, u = !0, g = 0, p = l.length - 1; p >= 0; --p) {
        var f = l.charCodeAt(p);
        if (f !== 47) c === -1 && (u = !1, c = p + 1), f === 46 ? d === -1 ? d = p : g !== 1 && (g = 1) : d !== -1 && (g = -1);
        else if (!u) {
          h = p + 1;
          break;
        }
      }
      return d === -1 || c === -1 || g === 0 || g === 1 && d === c - 1 && d === h + 1 ? "" : l.slice(d, c);
    }, format: function(l) {
      if (l === null || typeof l != "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof l);
      return (function(d, h) {
        var c = h.dir || h.root, u = h.base || (h.name || "") + (h.ext || "");
        return c ? c === h.root ? c + u : c + "/" + u : u;
      })(0, l);
    }, parse: function(l) {
      o(l);
      var d = { root: "", dir: "", base: "", ext: "", name: "" };
      if (l.length === 0) return d;
      var h, c = l.charCodeAt(0), u = c === 47;
      u ? (d.root = "/", h = 1) : h = 0;
      for (var g = -1, p = 0, f = -1, _ = !0, v = l.length - 1, b = 0; v >= h; --v) if ((c = l.charCodeAt(v)) !== 47) f === -1 && (_ = !1, f = v + 1), c === 46 ? g === -1 ? g = v : b !== 1 && (b = 1) : g !== -1 && (b = -1);
      else if (!_) {
        p = v + 1;
        break;
      }
      return g === -1 || f === -1 || b === 0 || b === 1 && g === f - 1 && g === p + 1 ? f !== -1 && (d.base = d.name = p === 0 && u ? l.slice(1, f) : l.slice(p, f)) : (p === 0 && u ? (d.name = l.slice(1, g), d.base = l.slice(1, f)) : (d.name = l.slice(p, g), d.base = l.slice(p, f)), d.ext = l.slice(g, f)), p > 0 ? d.dir = l.slice(0, p - 1) : u && (d.dir = "/"), d;
    }, sep: "/", delimiter: ":", win32: null, posix: null };
    a.posix = a, s.exports = a;
  } }, e = {};
  function t(s) {
    var o = e[s];
    if (o !== void 0) return o.exports;
    var r = e[s] = { exports: {} };
    return n[s](r, r.exports, t), r.exports;
  }
  t.d = (s, o) => {
    for (var r in o) t.o(o, r) && !t.o(s, r) && Object.defineProperty(s, r, { enumerable: !0, get: o[r] });
  }, t.o = (s, o) => Object.prototype.hasOwnProperty.call(s, o), t.r = (s) => {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
  };
  var i = {};
  (() => {
    let s;
    t.r(i), t.d(i, { URI: () => u, Utils: () => B }), typeof process == "object" ? s = process.platform === "win32" : typeof navigator == "object" && (s = navigator.userAgent.indexOf("Windows") >= 0);
    const o = /^\w[\w\d+.-]*$/, r = /^\//, a = /^\/\//;
    function l(T, O) {
      if (!T.scheme && O) throw new Error(`[UriError]: Scheme is missing: {scheme: "", authority: "${T.authority}", path: "${T.path}", query: "${T.query}", fragment: "${T.fragment}"}`);
      if (T.scheme && !o.test(T.scheme)) throw new Error("[UriError]: Scheme contains illegal characters.");
      if (T.path) {
        if (T.authority) {
          if (!r.test(T.path)) throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
        } else if (a.test(T.path)) throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
      }
    }
    const d = "", h = "/", c = /^(([^:/?#]+?):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
    class u {
      static isUri(O) {
        return O instanceof u || !!O && typeof O.authority == "string" && typeof O.fragment == "string" && typeof O.path == "string" && typeof O.query == "string" && typeof O.scheme == "string" && typeof O.fsPath == "string" && typeof O.with == "function" && typeof O.toString == "function";
      }
      scheme;
      authority;
      path;
      query;
      fragment;
      constructor(O, H, $, pe, me, ue = !1) {
        typeof O == "object" ? (this.scheme = O.scheme || d, this.authority = O.authority || d, this.path = O.path || d, this.query = O.query || d, this.fragment = O.fragment || d) : (this.scheme = /* @__PURE__ */ (function(ee, te) {
          return ee || te ? ee : "file";
        })(O, ue), this.authority = H || d, this.path = (function(ee, te) {
          switch (ee) {
            case "https":
            case "http":
            case "file":
              te ? te[0] !== h && (te = h + te) : te = h;
          }
          return te;
        })(this.scheme, $ || d), this.query = pe || d, this.fragment = me || d, l(this, ue));
      }
      get fsPath() {
        return b(this);
      }
      with(O) {
        if (!O) return this;
        let { scheme: H, authority: $, path: pe, query: me, fragment: ue } = O;
        return H === void 0 ? H = this.scheme : H === null && (H = d), $ === void 0 ? $ = this.authority : $ === null && ($ = d), pe === void 0 ? pe = this.path : pe === null && (pe = d), me === void 0 ? me = this.query : me === null && (me = d), ue === void 0 ? ue = this.fragment : ue === null && (ue = d), H === this.scheme && $ === this.authority && pe === this.path && me === this.query && ue === this.fragment ? this : new p(H, $, pe, me, ue);
      }
      static parse(O, H = !1) {
        const $ = c.exec(O);
        return $ ? new p($[2] || d, L($[4] || d), L($[5] || d), L($[7] || d), L($[9] || d), H) : new p(d, d, d, d, d);
      }
      static file(O) {
        let H = d;
        if (s && (O = O.replace(/\\/g, h)), O[0] === h && O[1] === h) {
          const $ = O.indexOf(h, 2);
          $ === -1 ? (H = O.substring(2), O = h) : (H = O.substring(2, $), O = O.substring($) || h);
        }
        return new p("file", H, O, d, d);
      }
      static from(O) {
        const H = new p(O.scheme, O.authority, O.path, O.query, O.fragment);
        return l(H, !0), H;
      }
      toString(O = !1) {
        return C(this, O);
      }
      toJSON() {
        return this;
      }
      static revive(O) {
        if (O) {
          if (O instanceof u) return O;
          {
            const H = new p(O);
            return H._formatted = O.external, H._fsPath = O._sep === g ? O.fsPath : null, H;
          }
        }
        return O;
      }
    }
    const g = s ? 1 : void 0;
    class p extends u {
      _formatted = null;
      _fsPath = null;
      get fsPath() {
        return this._fsPath || (this._fsPath = b(this)), this._fsPath;
      }
      toString(O = !1) {
        return O ? C(this, !0) : (this._formatted || (this._formatted = C(this, !1)), this._formatted);
      }
      toJSON() {
        const O = { $mid: 1 };
        return this._fsPath && (O.fsPath = this._fsPath, O._sep = g), this._formatted && (O.external = this._formatted), this.path && (O.path = this.path), this.scheme && (O.scheme = this.scheme), this.authority && (O.authority = this.authority), this.query && (O.query = this.query), this.fragment && (O.fragment = this.fragment), O;
      }
    }
    const f = { 58: "%3A", 47: "%2F", 63: "%3F", 35: "%23", 91: "%5B", 93: "%5D", 64: "%40", 33: "%21", 36: "%24", 38: "%26", 39: "%27", 40: "%28", 41: "%29", 42: "%2A", 43: "%2B", 44: "%2C", 59: "%3B", 61: "%3D", 32: "%20" };
    function _(T, O, H) {
      let $, pe = -1;
      for (let me = 0; me < T.length; me++) {
        const ue = T.charCodeAt(me);
        if (ue >= 97 && ue <= 122 || ue >= 65 && ue <= 90 || ue >= 48 && ue <= 57 || ue === 45 || ue === 46 || ue === 95 || ue === 126 || O && ue === 47 || H && ue === 91 || H && ue === 93 || H && ue === 58) pe !== -1 && ($ += encodeURIComponent(T.substring(pe, me)), pe = -1), $ !== void 0 && ($ += T.charAt(me));
        else {
          $ === void 0 && ($ = T.substr(0, me));
          const ee = f[ue];
          ee !== void 0 ? (pe !== -1 && ($ += encodeURIComponent(T.substring(pe, me)), pe = -1), $ += ee) : pe === -1 && (pe = me);
        }
      }
      return pe !== -1 && ($ += encodeURIComponent(T.substring(pe))), $ !== void 0 ? $ : T;
    }
    function v(T) {
      let O;
      for (let H = 0; H < T.length; H++) {
        const $ = T.charCodeAt(H);
        $ === 35 || $ === 63 ? (O === void 0 && (O = T.substr(0, H)), O += f[$]) : O !== void 0 && (O += T[H]);
      }
      return O !== void 0 ? O : T;
    }
    function b(T, O) {
      let H;
      return H = T.authority && T.path.length > 1 && T.scheme === "file" ? `//${T.authority}${T.path}` : T.path.charCodeAt(0) === 47 && (T.path.charCodeAt(1) >= 65 && T.path.charCodeAt(1) <= 90 || T.path.charCodeAt(1) >= 97 && T.path.charCodeAt(1) <= 122) && T.path.charCodeAt(2) === 58 ? T.path[1].toLowerCase() + T.path.substr(2) : T.path, s && (H = H.replace(/\//g, "\\")), H;
    }
    function C(T, O) {
      const H = O ? v : _;
      let $ = "", { scheme: pe, authority: me, path: ue, query: ee, fragment: te } = T;
      if (pe && ($ += pe, $ += ":"), (me || pe === "file") && ($ += h, $ += h), me) {
        let be = me.indexOf("@");
        if (be !== -1) {
          const we = me.substr(0, be);
          me = me.substr(be + 1), be = we.lastIndexOf(":"), be === -1 ? $ += H(we, !1, !1) : ($ += H(we.substr(0, be), !1, !1), $ += ":", $ += H(we.substr(be + 1), !1, !0)), $ += "@";
        }
        me = me.toLowerCase(), be = me.lastIndexOf(":"), be === -1 ? $ += H(me, !1, !0) : ($ += H(me.substr(0, be), !1, !0), $ += me.substr(be));
      }
      if (ue) {
        if (ue.length >= 3 && ue.charCodeAt(0) === 47 && ue.charCodeAt(2) === 58) {
          const be = ue.charCodeAt(1);
          be >= 65 && be <= 90 && (ue = `/${String.fromCharCode(be + 32)}:${ue.substr(3)}`);
        } else if (ue.length >= 2 && ue.charCodeAt(1) === 58) {
          const be = ue.charCodeAt(0);
          be >= 65 && be <= 90 && (ue = `${String.fromCharCode(be + 32)}:${ue.substr(2)}`);
        }
        $ += H(ue, !0, !1);
      }
      return ee && ($ += "?", $ += H(ee, !1, !1)), te && ($ += "#", $ += O ? te : _(te, !1, !1)), $;
    }
    function w(T) {
      try {
        return decodeURIComponent(T);
      } catch {
        return T.length > 3 ? T.substr(0, 3) + w(T.substr(3)) : T;
      }
    }
    const y = /(%[0-9A-Za-z][0-9A-Za-z])+/g;
    function L(T) {
      return T.match(y) ? T.replace(y, ((O) => w(O))) : T;
    }
    var k = t(470);
    const N = k.posix || k, A = "/";
    var B;
    (function(T) {
      T.joinPath = function(O, ...H) {
        return O.with({ path: N.join(O.path, ...H) });
      }, T.resolvePath = function(O, ...H) {
        let $ = O.path, pe = !1;
        $[0] !== A && ($ = A + $, pe = !0);
        let me = N.resolve($, ...H);
        return pe && me[0] === A && !O.authority && (me = me.substring(1)), O.with({ path: me });
      }, T.dirname = function(O) {
        if (O.path.length === 0 || O.path === A) return O;
        let H = N.dirname(O.path);
        return H.length === 1 && H.charCodeAt(0) === 46 && (H = ""), O.with({ path: H });
      }, T.basename = function(O) {
        return N.basename(O.path);
      }, T.extname = function(O) {
        return N.extname(O.path);
      };
    })(B || (B = {}));
  })(), AU = i;
})();
const { URI: yd, Utils: xce } = AU;
function nce(n) {
  return n;
}
function sce(n) {
  return n;
}
function BP(n) {
  return { start: { line: n.startLineNumber - 1, character: n.startColumn - 1 }, end: { line: n.endLineNumber - 1, character: n.endColumn - 1 } };
}
function Xs(n) {
  return { startLineNumber: n.start.line + 1, startColumn: n.start.character + 1, endLineNumber: n.end.line + 1, endColumn: n.end.character + 1 };
}
function oce(n) {
  return { location: { range: BP(n), uri: String(n.resource) }, message: n.message };
}
function rce(n) {
  return { ...Xs(n.location.range), message: n.message, resource: yd.parse(n.location.uri) };
}
function ace(n) {
  const e = { message: n.message, range: BP(n), severity: (t = n.severity, t === 8 ? 1 : t === 4 ? 2 : t === 2 ? 3 : 4) };
  var t;
  return typeof n.code == "string" ? e.code = n.code : n.code != null && (e.code = n.code.value, e.codeDescription = { href: String(n.code.target) }), n.relatedInformation && (e.relatedInformation = n.relatedInformation.map(oce)), n.tags && (e.tags = n.tags.map(nce)), n.source != null && (e.source = n.source), e;
}
function PU(n, e) {
  const t = { ...Xs(n.range), message: n.message, severity: n.severity ? (i = n.severity, i === 1 ? 8 : i === 2 ? 4 : i === 3 ? 2 : 1) : 8 };
  var i;
  return n.code != null && (t.code = n.codeDescription == null ? String(n.code) : { value: String(n.code), target: yd.parse(n.codeDescription.href) }), n.relatedInformation && (t.relatedInformation = n.relatedInformation.map(rce)), n.tags && (t.tags = n.tags.map(sce)), n.source != null && (t.source = n.source), t;
}
function OU(n) {
  return { range: Xs(n.range), text: n.newText };
}
function lce(n) {
  const e = n.kind === "create" ? { newResource: yd.parse(n.uri) } : n.kind === "delete" ? { oldResource: yd.parse(n.uri) } : { oldResource: yd.parse(n.oldUri), newResource: yd.parse(n.newUri) };
  return n.options && (e.options = (function(t) {
    const i = {};
    return t.ignoreIfExists != null && (i.ignoreIfExists = t.ignoreIfExists), t.ignoreIfNotExists != null && (i.ignoreIfNotExists = t.ignoreIfNotExists), t.overwrite != null && (i.overwrite = t.overwrite), t.recursive != null && (i.recursive = t.recursive), i;
  })(n.options)), e;
}
function h7(n, e, t) {
  return { resource: yd.parse(e), versionId: t, textEdit: OU(n) };
}
function dce(n, e) {
  const t = { title: n.title, isPreferred: n.isPreferred };
  return n.diagnostics && (t.diagnostics = n.diagnostics.map(((i) => PU(i)))), n.disabled && (t.disabled = n.disabled.reason), n.edit && (t.edit = (function(i) {
    var s;
    const o = [];
    if (i.changes) for (const [r, a] of Object.entries(i.changes)) for (const l of a) o.push(h7(l, r));
    if (i.documentChanges) for (const r of i.documentChanges) if ("textDocument" in r) for (const a of r.edits) o.push(h7(a, r.textDocument.uri, (s = r.textDocument.version) !== null && s !== void 0 ? s : void 0));
    else o.push(lce(r));
    return { edits: o };
  })(n.edit)), n.isPreferred != null && (t.isPreferred = n.isPreferred), n.kind && (t.kind = n.kind), t;
}
function hce(n) {
  return n;
}
function FU(n) {
  return { value: n.value };
}
function cce(n) {
  return { range: Xs(n.range), text: n.newText };
}
function uce(n, e) {
  var t, i, s, o, r;
  const a = (t = e.itemDefaults) !== null && t !== void 0 ? t : {}, l = (i = n.textEdit) !== null && i !== void 0 ? i : a.editRange, d = (s = n.commitCharacters) !== null && s !== void 0 ? s : a.commitCharacters, h = (o = n.insertTextFormat) !== null && o !== void 0 ? o : a.insertTextFormat, c = (r = n.insertTextMode) !== null && r !== void 0 ? r : a.insertTextMode;
  let u, g = n.insertText;
  var p;
  l ? (u = "range" in (p = l) ? Xs(p.range) : "insert" in p && "replace" in p ? { insert: Xs(p.insert), replace: Xs(p.replace) } : Xs(p), "newText" in l && (g = l.newText)) : u = { ...e.range };
  const f = { insertText: g ?? n.label, kind: n.kind == null ? 18 : (_ = n.kind, _ === 1 ? 18 : _ === 2 ? 0 : _ === 3 ? 1 : _ === 4 ? 2 : _ === 5 ? 3 : _ === 6 ? 4 : _ === 7 ? 5 : _ === 8 ? 7 : _ === 9 ? 8 : _ === 10 ? 9 : _ === 11 ? 12 : _ === 12 ? 13 : _ === 13 ? 15 : _ === 14 ? 17 : _ === 15 ? 27 : _ === 16 ? 19 : _ === 17 ? 20 : _ === 18 ? 21 : _ === 19 ? 23 : _ === 20 ? 16 : _ === 21 ? 14 : _ === 22 ? 6 : _ === 23 ? 10 : _ === 24 ? 11 : 24), label: n.label, range: u };
  var _;
  return n.additionalTextEdits && (f.additionalTextEdits = n.additionalTextEdits.map(cce)), n.command && (f.command = (function(v) {
    const b = { title: v.title, id: v.command };
    return v.arguments && (b.arguments = v.arguments), b;
  })(n.command)), d && (f.commitCharacters = d), n.detail != null && (f.detail = n.detail), typeof n.documentation == "string" ? f.documentation = n.documentation : n.documentation && (f.documentation = FU(n.documentation)), n.filterText != null && (f.filterText = n.filterText), h === 2 ? f.insertTextRules = 4 : c === 2 && (f.insertTextRules = 1), n.preselect != null && (f.preselect = n.preselect), n.sortText != null && (f.sortText = n.sortText), n.tags && (f.tags = n.tags.map(hce)), f;
}
function gce(n) {
  return n;
}
function BU(n) {
  var e, t, i;
  const s = { detail: (e = n.detail) !== null && e !== void 0 ? e : "", kind: (o = n.kind, o === 1 ? 0 : o === 2 ? 1 : o === 3 ? 2 : o === 4 ? 3 : o === 5 ? 4 : o === 6 ? 5 : o === 7 ? 6 : o === 8 ? 7 : o === 9 ? 8 : o === 10 ? 9 : o === 11 ? 10 : o === 12 ? 11 : o === 13 ? 12 : o === 14 ? 13 : o === 15 ? 14 : o === 16 ? 15 : o === 17 ? 16 : o === 18 ? 17 : o === 19 ? 18 : o === 20 ? 19 : o === 21 ? 20 : o === 22 ? 21 : o === 23 ? 22 : o === 24 ? 23 : o === 25 ? 24 : 25), name: n.name, range: Xs(n.range), selectionRange: Xs(n.selectionRange), tags: (i = (t = n.tags) === null || t === void 0 ? void 0 : t.map(gce)) !== null && i !== void 0 ? i : [] };
  var o;
  return n.children && (s.children = n.children.map(BU)), s;
}
function pce(n) {
  const e = { start: n.startLine + 1, end: n.endLine + 1 };
  return n.kind != null && (e.kind = { value: n.kind }), e;
}
function c7(n) {
  return typeof n == "string" ? { value: n } : { value: `\`\`\`${n.language}
${n.value}
\`\`\`` };
}
function WP(n) {
  return { character: n.column - 1, line: n.lineNumber - 1 };
}
function mce(n) {
  const e = { range: Xs(n.range) };
  return n.tooltip != null && (e.tooltip = n.tooltip), n.target != null && (e.url = yd.parse(n.target)), e;
}
function fce(n) {
  const e = { range: Xs(n.targetRange), targetSelectionRange: Xs(n.targetSelectionRange), uri: yd.parse(n.targetUri) };
  return n.originSelectionRange && (e.originSelectionRange = Xs(n.originSelectionRange)), e;
}
function u7(n) {
  return { owner: "yaml", async provideMarkerData(e) {
    const t = await n(e.uri), i = await t.doValidation(String(e.uri));
    return i?.map(((s) => PU(s)));
  }, async doReset(e) {
    await (await n(e.uri)).resetSchema(String(e.uri));
  } };
}
function _ce(n) {
  return { triggerCharacters: [" ", ":"], async provideCompletionItems(e, t) {
    const i = e.uri, s = e.getWordUntilPosition(t), o = await n(i), r = await o.doComplete(String(i), WP(t));
    if (r) return a = r, l = { range: { startLineNumber: t.lineNumber, startColumn: s.startColumn, endLineNumber: t.lineNumber, endColumn: s.endColumn } }, { incomplete: !!a.isIncomplete, suggestions: a.items.map(((d) => uce(d, { range: l.range, itemDefaults: a.itemDefaults }))) };
    var a, l;
  } };
}
function vce(n) {
  return { async provideDefinition(e, t) {
    const i = e.uri, s = await n(i), o = await s.doDefinition(String(i), WP(t));
    return o?.map(fce);
  } };
}
function bce(n) {
  return { async provideHover(e, t) {
    const i = e.uri, s = await n(i), o = await s.doHover(String(i), WP(t));
    if (o) return (function(r) {
      const a = { contents: (l = r.contents, typeof l == "string" || "language" in l ? [c7(l)] : Array.isArray(l) ? l.map(c7) : [FU(l)]) };
      var l;
      return r.range && (a.range = Xs(r.range)), a;
    })(o);
  } };
}
function Cce(n) {
  return { displayName: "yaml", async provideDocumentSymbols(e) {
    const t = e.uri, i = await n(t), s = await i.findDocumentSymbols(String(t));
    return s?.map(BU);
  } };
}
function wce(n) {
  return { displayName: "yaml", async provideDocumentFormattingEdits(e) {
    const t = e.uri, i = await n(t), s = await i.format(String(t));
    return s?.map(OU);
  } };
}
function yce(n) {
  return { async provideLinks(e) {
    const t = e.uri, i = await n(t), s = await i.findLinks(String(t));
    if (s) return { links: s.map(mce) };
  } };
}
function Sce(n) {
  return { async provideCodeActions(e, t, i) {
    const s = e.uri, o = await n(s), r = await o.getCodeAction(String(s), BP(t), (function(a) {
      const l = { diagnostics: a.markers.map(ace), triggerKind: a.trigger };
      return a.only != null && (l.only = [a.only]), l;
    })(i));
    if (r) return { actions: r.map(((a) => dce(a))), dispose() {
    } };
  } };
}
function Lce(n) {
  return { async provideFoldingRanges(e) {
    const t = e.uri, i = await n(t), s = await i.getFoldingRanges(String(t));
    return s?.map(pce);
  } };
}
function Nce(n, e) {
  const t = { completion: !0, customTags: [], enableSchemaRequest: !1, format: !0, isKubernetes: !1, hover: !0, schemas: [], validate: !0, yamlVersion: "1.2", ...e };
  n.languages.register({ id: "yaml", extensions: [".yaml", ".yml"], aliases: ["YAML", "yaml", "YML", "yml"], mimetypes: ["application/x-yaml"] });
  const i = (function(r, a) {
    let l, { createData: d, interval: h = 3e4, label: c, moduleId: u, stopWhenIdleFor: g = 12e4 } = a, p = 0, f = !1;
    const _ = () => {
      l && (l.dispose(), l = void 0);
    }, v = setInterval((() => {
      l && Date.now() - p > g && _();
    }), h);
    return { dispose() {
      f = !0, clearInterval(v), _();
    }, getWorker(...b) {
      if (f) throw new Error("Worker manager has been disposed");
      return p = Date.now(), l || (l = r.editor.createWebWorker({ createData: d, label: c, moduleId: u })), l.withSyncedResources(b);
    }, updateCreateData(b) {
      d = b, _();
    } };
  })(n, { label: "yaml", moduleId: "monaco-yaml/yaml.worker", createData: t });
  let s = d7(n, "yaml", u7(i.getWorker));
  const o = [i, n.languages.registerCompletionItemProvider("yaml", _ce(i.getWorker)), n.languages.registerHoverProvider("yaml", bce(i.getWorker)), n.languages.registerDefinitionProvider("yaml", vce(i.getWorker)), n.languages.registerDocumentSymbolProvider("yaml", Cce(i.getWorker)), n.languages.registerDocumentFormattingEditProvider("yaml", wce(i.getWorker)), n.languages.registerLinkProvider("yaml", yce(i.getWorker)), n.languages.registerCodeActionProvider("yaml", Sce(i.getWorker)), n.languages.registerFoldingRangeProvider("yaml", Lce(i.getWorker)), n.languages.setLanguageConfiguration("yaml", { comments: { lineComment: "#" }, brackets: [["{", "}"], ["[", "]"], ["(", ")"]], autoClosingPairs: [{ open: "{", close: "}" }, { open: "[", close: "]" }, { open: "(", close: ")" }, { open: '"', close: '"' }, { open: "'", close: "'" }], surroundingPairs: [{ open: "{", close: "}" }, { open: "[", close: "]" }, { open: "(", close: ")" }, { open: '"', close: '"' }, { open: "'", close: "'" }], onEnterRules: [{ beforeText: /:\s*$/, action: { indentAction: n.languages.IndentAction.Indent } }] })];
  return { dispose() {
    for (const r of o) r.dispose();
    s.dispose();
  }, update(r) {
    i.updateCreateData(Object.assign(t, r)), s.dispose(), s = d7(n, "yaml", u7(i.getWorker));
  } };
}
self.MonacoEnvironment = { getWorker: (n, e) => e === "json" ? new Qhe() : e === "css" || e === "scss" || e === "less" ? new Jhe() : e === "html" || e === "handlebars" || e === "razor" ? new ece() : e === "typescript" || e === "javascript" ? new tce() : e === "yaml" ? new ice() : new Xhe() };
export {
  Dce as a,
  Nce as c,
  UL as m,
  n6 as t
};
